
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8fd7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8fd7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gX8Np", function(module, exports) {
// prettier-ignore
module.exports = {
    '5E': '2E',
    '5IV': '5IVE',
    '2F': 'F2 Mobile',
    '3Q': '3Q',
    'J7': '7 Mobile',
    '2Q': '3GNET',
    '4G': '4Good',
    '27': '3GO',
    '04': '4ife',
    '36': '360',
    '88': '8848',
    '10M': '10moons',
    '41': 'A1',
    'AK1': 'A&K',
    '00': 'Accent',
    'ACC': 'Accesstyle',
    'ACD': 'ACD',
    'AE': 'Ace',
    'AC': 'Acer',
    'ACL': 'Aceline',
    'ACP': 'Acepad',
    '3K': 'Acteck',
    'ACT': 'actiMirror',
    'A9': 'Advan',
    'AD': 'Advance',
    'ADV': 'Advantage Air',
    '76': 'Adronix',
    'ADR': 'Adreamer',
    'AF': 'AfriOne',
    'FY': 'AFFIX',
    'A3': 'AGM',
    'AEE': 'AEEZO',
    'J0': 'AG Mobile',
    'AJI': 'Ajib',
    'AZ': 'Ainol',
    'AIR': 'Airis',
    'AI': 'Airness',
    'ARP': 'Airpha',
    'AT': 'Airties',
    '7U': 'Airtel',
    'AIT': 'AirTouch',
    'U0': 'AIRON',
    '0A': 'AIS',
    'AW': 'Aiwa',
    '85': 'Aiuto',
    'U7': 'AIDATA',
    'AL1': 'AileTV',
    'AL2': 'AI+',
    'AK': 'Akai',
    'Q3': 'AKIRA',
    '1A': 'Alba',
    'AL': 'Alcatel',
    'AL0': 'Alienware',
    '20': 'Alcor',
    'XY': 'Alps',
    'XYA': 'XY Auto',
    'AAU': 'AAUW',
    '7L': 'ALDI NORD',
    '6L': "ALDI S\xdcD",
    '3L': 'Alfawise',
    '4A': 'Aligator',
    'ALS': 'All Star',
    'AA': 'AllCall',
    '3A': 'AllDocube',
    'ALL': 'allente',
    'A2': 'Allview',
    'ALI': 'ALLINmobile',
    'A7': 'Allwinner',
    'ALP': 'alpsmart',
    'A1': 'Altech UEC',
    '66': 'Altice',
    'ALM': 'Altimo',
    'A5': 'altron',
    'ALB': 'Altibox',
    'ALT': 'Altus',
    'KN': 'Amazon',
    'AMZ': 'Amazon Basics',
    'AMA': 'AMA',
    'AG': 'AMGOO',
    '9A': 'Amigoo',
    'AO': 'Amoi',
    '3J': 'Amino',
    '54': 'AMCV',
    '60': 'Andowl',
    'ANX': 'ANXONIT',
    'ANL': 'ANCEL',
    'ANC': 'ANBERNIC',
    'AND': 'andersson',
    '6J': 'Angelcare',
    'ANG': 'AngelTech',
    '7A': 'Anry',
    'A0': 'ANS',
    '74': 'Anker',
    '3N': 'Aoson',
    'O8': 'AOC',
    'J2': 'AOYODKG',
    '55': 'AOpen',
    'RW': 'Aoro',
    '9Y': 'Aocos',
    'AOW': 'Aocwei',
    'AP': 'Apple',
    'APS': 'ApoloSign',
    'ARC': "Ar\xe7elik",
    'AR': 'Archos',
    'AB': 'Arian Space',
    'ARI': 'Arival',
    'A6': 'Ark',
    '5A': 'ArmPhone',
    'AN': 'Arnova',
    'AS': 'ARRIS',
    'AQ': 'Aspera',
    'HJ': 'Aquarius',
    '40': 'Artel',
    '21': 'Artizlee',
    '59': 'ArtLine',
    '8A': 'Asano',
    '90': 'Asanzo',
    '1U': 'Astro (UA)',
    'AST': 'astro (MY)',
    'A4': 'Ask',
    'A8': 'Assistant',
    'ASS': 'ASSE',
    'AU': 'Asus',
    '6A': 'AT&T',
    'ATH': 'Athesi',
    'ATE': 'Atlantic Electrics',
    '5Q': 'Atmaca Elektronik',
    'YH': 'ATMAN',
    'ATM': 'ATMPC',
    '2A': 'Atom',
    'AT1': 'Atozee',
    'ATO': 'ATOL',
    'Z2': 'Atvio',
    'ATI': 'Attila',
    'ATU': 'Atouch',
    'AX': 'Audiovox',
    'AJ': 'AURIS',
    'YZ': 'Autan',
    'AUP': 'AUPO',
    'ZA': 'Avenzo',
    'AH': 'AVH',
    'AV': 'Avvio',
    'AVA': 'Avaya',
    'AXE': 'AXEN',
    'AY': 'Axxion',
    'AXX': 'AXXA',
    'AYA': 'AYA',
    'YR': 'AYYA',
    'XA': 'Axioo',
    'AM': 'Azumi Mobile',
    'AZE': 'Azeyou',
    'AZU': 'Azupik',
    'AZO': 'AZOM',
    'WW': 'Awow',
    'AWO': 'AWOX',
    'XU': 'AUX',
    'BAC': 'Backcell',
    'BFF': 'BAFF',
    'BNC': 'BNCF',
    'BO': 'BangOlufsen',
    'BN': 'Barnes & Noble',
    'BAR': 'BARTEC',
    'BAS': 'BASE',
    'BAU': 'BAUHN',
    'BB': 'BBK',
    '0B': 'BB Mobile',
    'B6': 'BDF',
    'QD': 'BDQ',
    '8Z': 'BDsharing',
    'BEF': 'Beafon',
    'BE': 'Becker',
    'B5': 'Beeline',
    'B0': 'Beelink',
    'BL': 'Beetel',
    'BEK': 'Beko',
    '2X': 'Benco',
    'BQ': 'BenQ',
    'BQL': 'Bqeel',
    'BS': 'BenQ-Siemens',
    '4Y': 'Benzo',
    'XJ': 'Benesse',
    'BEN': 'BenWee',
    'YB': 'Beista',
    'BY': 'BS Mobile',
    'BZ': 'Bezkam',
    'BEL': 'Bell',
    '9B': 'Bellphone',
    '63': 'Beyond',
    'BG': 'BGH',
    '6B': 'Bigben',
    'B8': 'BIHEE',
    '1B': 'Billion',
    'BA': 'BilimLand',
    'BIL': 'Billow',
    'BH': 'BioRugged',
    'BI': 'Bird',
    'BT': 'Bitel',
    'B7': 'Bitmore',
    'ZB': 'Bittium',
    'BIE': 'Biegedy',
    'BK': 'Bkav',
    '5B': 'Black Bear',
    'BLK': 'Black Box',
    'BF': 'Black Fox',
    'BPC': 'Blackpcs',
    'BLP': 'Blackphone',
    'BLT': 'Blackton',
    'B2': 'Blackview',
    '2Y': 'b2m',
    'BP': 'Blaupunkt',
    'BU': 'Blu',
    'BUS': 'BluSlate',
    'BUZ': 'BuzzTV',
    'B3': 'Bluboo',
    '2B': 'Bluedot',
    'BD': 'Bluegood',
    'LB': 'Bluewave',
    'J8': 'Bluebird',
    'BSS': 'BlueSky',
    '7B': 'Blloc',
    'UB': 'Bleck',
    'Q2': 'Blow',
    'BLI': 'BLISS',
    'BM': 'Bmobile',
    'Y5': 'BMAX',
    'BMX': 'BMXC',
    'B9': 'Bobarry',
    'B4': 'bogo',
    'BOL': 'Bolva',
    'BW': 'Boway',
    'BOO': 'Boost',
    'BOK': 'Bookeen',
    'BOT': 'Botech',
    'BX': 'bq',
    '8B': 'Brandt',
    'BRA': 'BrandCode',
    'BV': 'Bravis',
    'BRV': 'BRAVE',
    'BRG': 'Brigmton',
    'BR': 'Brondi',
    'XF': 'BROR',
    'BJ': 'BrightSign',
    'B1': 'Bush',
    '4Q': 'Bundy',
    'Y8': 'Bubblegum',
    'BMW': 'BMW',
    'BYJ': 'BYJU\'S',
    'BYY': 'BYYBUO',
    'BYD': 'BYD',
    'C9': 'CAGI',
    'CAD': 'CADENA',
    'CAL': 'CALME',
    'CAI': 'Caixun',
    'CT': 'Capitel',
    'GRD': 'G-Guard',
    'GVL': 'G-Vill',
    'G3': 'CG Mobile',
    '37': 'CGV',
    'CP': 'Captiva',
    'CPD': 'CPDEVICE',
    'CF': 'Carrefour',
    'CA1': 'Carbon Mobile',
    'CS': 'Casio',
    'R4': 'Casper',
    'CA': 'Cat',
    'BC': 'Camfone',
    'CJ': 'Cavion',
    'CNM': 'Canaima',
    'CAN': 'Canal+',
    '4D': 'Canal Digital',
    'CNG': 'Canguro',
    'CNT': 'CCIT',
    'CEC': 'Cecotec',
    'CEP': 'CEPTER',
    'CEI': 'Ceibal',
    '02': 'Cell-C',
    'CEL': 'Cellacom',
    '34': 'CellAllure',
    '7C': 'Celcus',
    'CE': 'Celkon',
    'CG': 'Cellution',
    '62': 'Centric',
    'CEN': 'CENTEK',
    'C2': 'Changhong',
    'CHA': 'Chainway',
    'CHG': 'ChiliGreen',
    'CH': 'Cherry Mobile',
    'C3': 'China Mobile',
    'U9': 'China Telecom',
    'CI': 'Chico Mobile',
    'CHC': 'CHCNAV',
    'CIA': 'C Idea',
    'CIP': 'CipherLab',
    'CIT': 'Citycall',
    '1C': 'Chuwi',
    'L8': 'Clarmin',
    '25': 'Claresta',
    'CLA': 'CLAYTON',
    'CLT': 'Clovertek',
    '1J': 'Cloud',
    'CD': 'Cloudfone',
    '6C': 'Cloudpad',
    'C0': 'Clout',
    'CN': 'CnM',
    'CY': 'Coby Kyros',
    'XC': 'Cobalt',
    'C6': 'Comio',
    'COM': 'CommScope',
    'CL': 'Compal',
    'CQ': 'Compaq',
    'C7': 'ComTrade Tesla',
    '7Z': 'COMPUMAX',
    'C8': 'Concord',
    'CC': 'ConCorde',
    'C5': 'Condor',
    'C5M': 'C5 Mobile',
    'COE': 'Cogeco',
    '4C': 'Conquest',
    'COG': 'CONSUNG',
    '3C': 'Contixo',
    '8C': 'Connex',
    '53': 'Connectce',
    'CON': 'Conceptum',
    'CED': 'Continental Edison',
    '9C': 'Colors',
    'COL': 'COLORROOM',
    'CAA': 'coocaa',
    'CO': 'Coolpad',
    'COO': 'Coopers',
    'CDE': 'COOD-E',
    '4R': 'CORN',
    '1O': 'Cosmote',
    'CW': 'Cowon',
    '75': 'Covia',
    'QG': 'COYOTE',
    'CKK': 'CKK Mobile',
    'YW': 'ClearPHONE',
    '33': 'Clementoni',
    'CR': 'CreNova',
    'CX': 'Crescent',
    'CRE': 'Crestron',
    'CK': 'Cricket',
    'CM': 'Crius Mea',
    'CMF': 'CMF',
    '0C': 'Crony',
    'C1': 'Crosscall',
    '4W': 'Crown',
    'CTR': 'Ctroniq',
    'CU': 'Cube',
    'CB': 'CUBOT',
    'CUI': 'Cuiud',
    'CUL': 'Cultraview',
    'CV': 'CVTE',
    'CWO': 'Cwowdefu',
    'CX0': 'CX',
    'C4': 'Cyrus',
    'D5': 'Daewoo',
    'DA': 'Danew',
    'DAN': 'Dany',
    'DA1': 'DangcapHD',
    'DAR': 'Daria',
    'DT': 'Datang',
    'D7': 'Datawind',
    '7D': 'Datamini',
    '6D': 'Datalogic',
    'D1': 'Datsun',
    'DZ': 'Dazen',
    'DAS': 'DASS',
    'DAW': 'Dawlance',
    'DB': 'Dbtel',
    'DBP': 'DbPhone',
    'DCO': 'Dcode',
    'DL': 'Dell',
    'DL0': 'DL',
    'DE': 'Denver',
    'DS': 'Desay',
    'DSD': 'DSDevices',
    'DSI': 'DSIC',
    'DW': 'DeWalt',
    'DX': 'DEXP',
    'DEY': 'DEYI',
    'DEN': 'Denali',
    'DEA': 'DEALDIG',
    'DNK': 'Denka',
    '8D': 'DF',
    'DGT': 'DGTEC',
    'DG': 'Dialog',
    'DIA': 'DIALN',
    'DI': 'Dicam',
    'D4': 'Digi',
    'D3': 'Digicel',
    'DDG': 'Digidragon',
    'DH': 'Digihome',
    'DD': 'Digiland',
    'DIJ': 'DIJITSU',
    'DIG': 'Digit4G',
    'DIC': 'DIGICOM',
    'Q0': 'DIGIFORS',
    'DIK': 'DIKOM',
    'DQ': 'DISH',
    'DIS': 'Disney',
    '9D': 'Ditecma',
    'D2': 'Digma',
    '1D': 'Diva',
    'DIV': 'DiverMax',
    'D6': 'Divisat',
    'DIO': 'DIORA',
    'DIF': 'Diofox',
    'X6': 'DIXON',
    'DIM': 'DIMO',
    '5D': 'DING DING',
    'DIN': 'Dinax',
    'DNA': 'Dinalink',
    'DM': 'DMM',
    'DMO': 'DMOAO',
    'DN': 'DNS',
    'DC': 'DoCoMo',
    'DF': 'Doffler',
    'D9': 'Dolamee',
    'DO': 'Doogee',
    'D0': 'Doopro',
    'DV': 'Doov',
    'DOM': 'Dom.ru',
    'DP': 'Dopod',
    'DPA': 'DPA',
    'JQ': 'Doppio',
    'DR': 'Doro',
    'DOR': 'Dora',
    'ZD': 'DORLAND',
    'DRO': 'Droidlogic',
    'D8': 'Droxio',
    'DJ': 'Dragon Touch',
    'DRA': 'DRAGON',
    'DY': 'Dreamgate',
    'DRE': 'DreamTab',
    'DR1': 'DreamStar',
    'DTA': 'Dtac',
    'DU': 'Dune HD',
    'DUO': 'DuoTV',
    'UD': 'DUNNS Mobile',
    'DUU': 'Duubee',
    'DUR': 'Durabook',
    'DUD': 'DUDU AUTO',
    'DYO': 'Dyon',
    'DYM': 'Dykemann',
    'DTE': 'D-Tech',
    'DLI': 'D-Link',
    'ENO': 'eNOVA',
    'IN2': 'iNOVA',
    'IN3': 'inovo',
    'INH': 'Inhon',
    'IND': 'Indurama',
    'EB': 'E-Boda',
    'EJ': 'Engel',
    'ENA': 'ENACOM',
    'END': 'ENDURO',
    'ENI': 'ENIE',
    '2E': 'E-Ceros',
    'E8': 'E-tel',
    'ETH': 'E-TACHI',
    'EAS': 'EAS Electric',
    'EP': 'Easypix',
    'EQ': 'Eagle',
    'EGS': 'EagleSoar',
    'EA': 'EBEST',
    'YC': 'EBEN',
    'E4': 'Echo Mobiles',
    'EQ1': 'Equator',
    'ES': 'ECS',
    '35': 'ECON',
    'ECC': 'ECOO',
    'ZZ': 'ecom',
    'ECS': 'EcoStar',
    'EDE': 'Edenwood',
    'EDX': 'Edanix',
    'E6': 'EE',
    'GW': 'EGL',
    'EGO': 'EGOTEK',
    'EFT': 'EFT',
    'EK': 'EKO',
    'EY': 'Einstein',
    'EM': 'Eks Mobility',
    'UE': 'Ematic',
    'EMR': 'Emporia',
    '4K': 'EKT',
    'EKI': 'EKINOX',
    '7E': 'ELARI',
    '03': 'Electroneum',
    'Z8': 'ELECTRONIA',
    'ELG': 'ELE-GATE',
    'EL1': 'Elecson',
    'ELK': 'Elektroland',
    'L0': 'Element',
    'EG': 'Elenberg',
    'EL': 'Elephone',
    'JE': 'Elekta',
    'ELE': 'Elevate',
    'ELS': 'Elista',
    'ELT': 'elit',
    '4E': 'Eltex',
    'ELM': 'Elong Mobile',
    'ED': 'Energizer',
    'E1': 'Energy Sistem',
    '3E': 'Enot',
    'ENT': 'Entity',
    'ENV': 'Envizen',
    '8E': 'Epik One',
    'EPK': 'Epic',
    'XP': 'Epson',
    'EPH': 'Ephone',
    'EPL': 'Eplutus',
    'E7': 'Ergo',
    'EC': 'Ericsson',
    '05': 'Erisson',
    'ER': 'Ericy',
    'EE': 'Essential',
    'E2': 'Essentielb',
    '6E': 'eSTAR',
    'ETO': 'ETOE',
    'EN': 'Eton',
    'ET': 'eTouch',
    '1E': 'Etuline',
    'EHL': 'Ehlel',
    'EU': 'Eurostar',
    '4J': 'Eurocase',
    'EUR': 'EUROLUX',
    'EUD': 'Eudora',
    'E9': 'Evercoss',
    'EV': 'Evertek',
    'EVE': 'Everest',
    'EV1': 'Everex',
    'EVR': 'Everis',
    'EVF': 'Everfine',
    'E3': 'Evolio',
    'EO': 'Evolveo',
    '0Q': 'Evoo',
    '5U': 'EVPAD',
    'EVV': 'evvoli',
    'E0': 'EvroMedia',
    'XE': 'ExMobile',
    '4Z': 'Exmart',
    'EH': 'EXO',
    'EX': 'Explay',
    'EXP': 'Express LUCK',
    'E5': 'Extrem',
    'EXL': 'ExtraLink',
    'EF': 'EXCEED',
    'QE': 'EWIS',
    'EI': 'Ezio',
    'EZ': 'Ezze',
    'UF': 'EYU',
    'EYE': 'Eyemoo',
    'UE1': 'UE',
    '5F': 'F150',
    'FPS': 'F+',
    'F6': 'Facebook',
    'FAC': 'Facetel',
    'FA1': 'Facime',
    'FA': 'Fairphone',
    'FM': 'Famoco',
    'FAM': 'Famous',
    '17': 'FarEasTone',
    '9R': 'FaRao Pro',
    'FAR': 'Farassoo',
    'FB': 'Fantec',
    'FAN': 'Fanvace',
    'FE': 'Fengxiang',
    'FEN': 'Fenoti',
    'F7': 'Fero',
    '67': 'FEONAL',
    'FI': 'FiGO',
    'J9': 'FiGi',
    'FIG': 'Figgers',
    'F9': 'FiiO',
    'F1': 'FinePower',
    'FX': 'Finlux',
    'F3': 'FireFly Mobile',
    'F8': 'FISE',
    'FIS': 'Fision',
    'FIT': 'FITCO',
    'FLM': 'Filimo',
    'FIL': 'FILIX',
    'FIN': 'FINIX',
    'FL': 'Fly',
    'QC': 'FLYCAT',
    'FLY': 'FLYCOAY',
    'FLU': 'Fluo',
    'FN': 'FNB',
    'FOB': 'Fobem',
    'FD': 'Fondi',
    '0F': 'Fourel',
    '44': 'Four Mobile',
    'F0': 'Fonos',
    'F0N': 'FONTEL',
    'F2': 'FORME',
    'FRM': 'Formovie',
    'F5': 'Formuler',
    'FR': 'Forstar',
    'RF': 'Fortis',
    'FRT': 'FortuneShip',
    'FO': 'Foxconn',
    'FOD': 'FoxxD',
    'FJ': 'FOODO',
    'FOS': 'FOSSiBOT',
    'FRE': 'free',
    'FT': 'Freetel',
    'FTH': 'FRESH',
    'FEY': 'FreeYond',
    'FRU': 'Frunsi',
    'F4': 'F&U',
    '1F': 'FMT',
    'FPT': 'FPT',
    'FG': 'Fuego',
    'FUJ': 'FUJICOM',
    'FU': 'Fujitsu',
    '4F': 'Funai',
    '5J': 'Fusion5',
    'FF': 'Future Mobile Technology',
    'FFF': 'FFF SmartLife',
    'FW': 'FNF',
    'FXT': 'Fxtec',
    'GT': 'G-TiDE',
    'G9': 'G-Touch',
    'GFO': 'Gfone',
    'GTM': 'GTMEDIA',
    'GTX': 'GTX',
    'GDL': 'GDL',
    '0G': 'GFive',
    'GM': 'Garmin-Asus',
    'GA': 'Gateway',
    '99': 'Galaxy Innovations',
    'GA1': 'Galactic',
    'GAT': 'Galatec',
    'GAM': 'Gamma',
    'GAZ': 'Gazer',
    'GAL': 'Gazal',
    'GEA': 'Geanee',
    'GEN': 'Geant',
    'GD': 'Gemini',
    'GN': 'General Mobile',
    'GD1': 'Genius Devices',
    '2G': 'Genesis',
    'GEP': 'Geo Phone',
    'G2': 'GEOFOX',
    'GE': 'Geotel',
    'Q4': 'Geotex',
    'GEO': 'GEOZON',
    'GNO': 'Getnord',
    'GER': 'Gear Mobile',
    'GH': 'Ghia',
    '2C': 'Ghong',
    'GJ': 'Ghost',
    'GG': 'Gigabyte',
    'GS': 'Gigaset',
    'GZ': 'Ginzzu',
    '1G': 'Gini',
    'GI': 'Gionee',
    'GIR': 'GIRASOLE',
    'G4': 'Globex',
    'GL2': 'GlobalSec',
    'GLB': 'Globmall',
    'GME': 'GlocalMe',
    '38': 'GLONYX',
    'U6': 'Glofiish',
    'GLO': 'Glory Star',
    'GNE': 'GN Electronics',
    'G7': 'GoGEN',
    'GC': 'GOCLEVER',
    '5G': 'Gocomma',
    'GB': 'Gol Mobile',
    'GL': 'Goly',
    'GOL': 'GoldMaster',
    'GOS': 'GoldStar',
    'GOB': 'GOLDBERG',
    'GX': 'GLX',
    'G5': 'Gome',
    'G1': 'GoMobile',
    'GO': 'Google',
    'G0': 'Goophone',
    '6G': 'Gooweel',
    'GOO': 'GOODTEL',
    'GO1': 'GOtv',
    'GPL': 'G-PLUS',
    '8G': 'Gplus',
    'GR': 'Gradiente',
    'GRE': 'Graetz',
    'GP': 'Grape',
    'G6': 'Gree',
    'GRA': 'Great Asia',
    '3G': 'Greentel',
    'GRO': 'Green Orange',
    'GRL': 'Green Lion',
    'GR1': 'GroBerwert',
    'GF': 'Gretel',
    '82': 'Gresso',
    'GRB': "Gr\xfcnberg",
    'GU': 'Grundig',
    'GV': 'Gtel',
    'CUO': 'Guophone',
    'CUD': 'CUD',
    'GVC': 'GVC Pro',
    'H13': 'H133',
    '9Z': 'H96',
    'HF': 'Hafury',
    '9F': 'HAOVM',
    'HAQ': 'HAOQIN',
    'HA': 'Haier',
    'HEC': 'HEC',
    'XH': 'Haipai',
    'XHU': 'Haixu',
    'HAN': 'Handheld',
    'HE': 'HannSpree',
    'HNS': 'Hanseatic',
    'HA2': 'Hanson',
    'HK': 'Hardkernel',
    'HAR': 'Harper',
    'HA1': 'Hartens',
    'HS': 'Hasee',
    '8H': 'Hamlet',
    'HAM': 'Hammer',
    'HAT': 'Hathway',
    'HAV': 'HAVIT',
    'HEM': 'Hemilton',
    'H6': 'Helio',
    'HQ': 'HERO',
    'ZH': 'Hezire',
    'HEX': 'HexaByte',
    'HEW': 'HeadWolf',
    'HEI': 'Heimat',
    'HL': 'Hi-Level',
    '3H': 'Hi',
    'HIB': 'Hiberg',
    'HBY': 'HiBy',
    'HIH': 'HiHi',
    'HIK': 'HiKing',
    'H2': 'Highscreen',
    'Q1': 'High Q',
    'HI1': 'HIGH1ONE',
    'HIG': 'HiGrace',
    '1H': 'Hipstreet',
    'HIR': 'Hiremco',
    'HI': 'Hisense',
    'HIP': 'HIPER',
    'HC': 'Hitachi',
    'H8': 'Hitech',
    'W3': 'HiMax',
    '8X': 'Hi Nova',
    'HLL': 'HLLO',
    'HKC': 'HKC',
    'HMD': 'HMD',
    '8W': 'HKPro',
    'HOF': 'HOFER',
    'HOC': 'hoco',
    'H1': 'Hoffmann',
    'HOM': 'Homatics',
    'H0': 'Hometech',
    'HLB': 'HOLLEBERG',
    'HM': 'Homtom',
    'HM1': 'HOMII',
    'HOP': 'Hopeland',
    'HZ': 'Hoozo',
    'HOR': 'Horion',
    'H7': 'Horizon',
    '4H': 'Horizont',
    'HO': 'Hosin',
    'H3': 'Hotel',
    'HV': 'Hotwav',
    'U8': 'Hot Pepper',
    'HOT': 'HOTACK',
    'JH': 'HOTREALS',
    'HW': 'How',
    'WH': 'Honeywell',
    'HNR': 'Honor',
    'HON': 'HongTop',
    'HOG': 'HONKUAHG',
    'HP': 'HP',
    'HDC': 'HDC',
    'HT': 'HTC',
    'QZ': 'Huagan',
    'HD': 'Huadoo',
    'HG': 'Huavi',
    'HU': 'Huawei',
    'HX': 'Humax',
    'HUM': 'Humanware',
    'HME': 'HUMElab',
    'HR': 'Hurricane',
    'H5': 'Huskee',
    'HUG': 'Hugerock',
    'HY': 'Hyrican',
    'HN': 'Hyundai',
    '7H': 'Hyve',
    'HYT': 'Hytera',
    'HYK': 'Hykker',
    'HYA': 'Hyatta',
    'IKL': 'I KALL',
    '3I': 'i-Cherry',
    'IJ': 'i-Joy',
    'IM': 'i-mate',
    'IO': 'i-mobile',
    'INN': 'I-INN',
    'IPL': 'I-Plus',
    'OF': 'iOutdoor',
    'IB': 'iBall',
    'IY': 'iBerry',
    '7I': 'iBrit',
    'IBO': 'ibowin',
    'I2': 'IconBIT',
    'ING': 'Icone Gold',
    'IC': 'iDroid',
    'IDI': 'iDino',
    '6Z': 'iData',
    'IDC': 'IDC',
    'IG': 'iGet',
    'IHL': 'iHome Life',
    'IH': 'iHunt',
    'IA': 'Ikea',
    'IYO': 'iYou',
    '8I': 'IKU Mobile',
    '2K': 'IKI Mobile',
    'IK': 'iKoMo',
    '58': 'iKon',
    '588': 'iKonia',
    'I7': 'iLA',
    '2I': 'iLife',
    '1I': 'iMars',
    'IMI': 'iMI',
    'U4': 'iMan',
    'ILE': 'iLepo',
    'IL': 'IMO Mobile',
    'IMA': 'Imaq',
    'IM1': 'Imose',
    'I3': 'Impression',
    'FC': 'INCAR',
    '2H': 'Inch',
    '6I': 'Inco',
    'INK': 'Inka',
    'IW': 'iNew',
    'IF': 'Infinix',
    'INF': 'Infiniton',
    'IPR': 'InfinityPro',
    'I0': 'InFocus',
    'IN1': 'InFone',
    'II': 'Inkti',
    'MIR': 'Infomir',
    '81': 'InfoKit',
    'I5': 'InnJoo',
    '26': 'Innos',
    'IN': 'Innostream',
    'I4': 'Inoi',
    'INO': 'iNo Mobile',
    'IQ': 'INQ',
    'QN': 'iQ&T',
    'IS': 'Insignia',
    'YI': 'INSYS',
    'IT': 'Intek',
    'INT': 'Intel',
    'IX': 'Intex',
    'IV': 'Inverto',
    '32': 'Invens',
    '4I': 'Invin',
    'IFT': 'iFIT',
    'INA': 'iNavi',
    'I1': 'iOcean',
    'IMU': 'iMuz',
    'IP': 'iPro',
    'X9': 'iPEGTOP',
    '8Q': 'IQM',
    'Q8': 'IRA',
    'I6': 'Irbis',
    '5I': 'Iris',
    'IRE': 'iReplace',
    'IR': 'iRola',
    'IU': 'iRulu',
    'IRO': 'iRobot',
    '9I': 'iSWAG',
    '9J': 'iSafe Mobile',
    'IST': 'iStar',
    '86': 'IT',
    'IZ': 'iTel',
    '0I': 'iTruck',
    'I8': 'iVA',
    'IE': 'iView',
    '0J': 'iVooMi',
    'UI': 'ivvi',
    'QW': 'iWaylink',
    'I9': 'iZotron',
    'IXT': 'iXTech',
    'IOT': 'IOTWE',
    'JA': 'JAY-Tech',
    'JAM': 'Jambo',
    'KJ': 'Jiake',
    'JD': 'Jedi',
    'JEE': 'Jeep',
    'J6': 'Jeka',
    'JF': 'JFone',
    'JI': 'Jiayu',
    'JG': 'Jinga',
    'JIN': 'Jin Tu',
    'JX': 'Jio',
    'VJ': 'Jivi',
    'JK': 'JKL',
    'JR1': 'JREN',
    'JO': 'Jolla',
    'JP': 'Joy',
    'JOY': 'JoySurf',
    'UJ': 'Juniper Systems',
    'J5': 'Just5',
    'JUS': 'JUSYEA',
    '7J': 'Jumper',
    'JPA': 'JPay',
    'JV': 'JVC',
    'JXD': 'JXD',
    'JS': 'Jesy',
    'KT': 'K-Touch',
    'KLT': 'K-Lite',
    'K4': 'Kaan',
    'K7': 'Kaiomy',
    'KL': 'Kalley',
    'K6': 'Kanji',
    'KA': 'Karbonn',
    'K5': 'KATV1',
    'KAP': 'Kapsys',
    'K0': 'Kata',
    'KZ': 'Kazam',
    '9K': 'Kazuna',
    'KD': 'KDDI',
    'KHA': 'Khadas',
    'KS': 'Kempler & Strauss',
    'K3': 'Keneksi',
    'KHI': 'KENSHI',
    'KNW': 'KENWOOD',
    'KX': 'Kenxinda',
    'KEN': 'Kenbo',
    'KND': 'Kendo',
    'KZG': 'KZG',
    'K1': 'Kiano',
    'KID': 'kidiby',
    '5W': 'Kingbox',
    'KI': 'Kingsun',
    'KIS': 'Kinstone',
    'KF': 'KINGZONE',
    'KIN': 'Kingstar',
    '46': 'Kiowa',
    'KV': 'Kivi',
    '64': 'Kvant',
    'KVA': 'KVADRA',
    '0K': 'Klipad',
    'KNM': 'KN Mobile',
    'KC': 'Kocaso',
    'KK': 'Kodak',
    'KG': 'Kogan',
    'KGT': 'KGTEL',
    'KM': 'Komu',
    'KMC': 'KMC',
    'KO': 'Konka',
    'KW': 'Konrow',
    'KB': 'Koobee',
    '7K': 'Koolnee',
    'K9': 'Kooper',
    'KP': 'KOPO',
    'KR': 'Koridy',
    'XK': 'Koslam',
    'K2': 'KRONO',
    'KRX': 'Korax',
    'KE': "Kr\xfcger&Matz",
    '5K': 'KREZ',
    'WK': 'KRIP',
    'KRA': 'Kraft',
    'KH': 'KT-Tech',
    'KTC': 'KTC',
    'Z6': 'KUBO',
    'KUG': 'KuGou',
    'K8': 'Kuliao',
    '8K': 'Kult',
    'KU': 'Kumai',
    '6K': 'Kurio',
    'KYD': 'Kydos',
    'KY': 'Kyocera',
    'KQ': 'Kyowon',
    '1K': 'Kzen',
    'LQ': 'LAIQ',
    'L6': 'Land Rover',
    'L2': 'Landvo',
    'LA': 'Lanix',
    'LA1': 'Lanin',
    'LK': 'Lark',
    'Z3': 'Laurus',
    'LEC': 'Lectrus',
    'LAS': 'Laser',
    'LV': 'Lava',
    'LVI': 'Lville',
    'LC': 'LCT',
    'L5': 'Leagoo',
    'U3': 'Leben',
    'LEB': 'LeBest',
    'LD': 'Ledstar',
    'LEE': 'Leelbox',
    'L1': 'LeEco',
    '4B': 'Leff',
    'LEG': 'Legend',
    'L4': 'Lemhoov',
    'W9': 'LEMFO',
    'LEM': 'Lemco',
    'LN': 'Lenco',
    'LE': 'Lenovo',
    'LT': 'Leotec',
    'LP': 'Le Pan',
    'ZJ': 'Leke',
    'L7': 'Lephone',
    'LZ': 'Lesia',
    'L3': 'Lexand',
    'LX': 'Lexibook',
    'LG': 'LG',
    '39': 'Liberton',
    '5L': 'Linsar',
    'LIN': 'Linsay',
    'LF': 'Lifemaxx',
    'LI': 'Lingwin',
    'LIB': 'Lingbo',
    'LIM': 'Lime',
    'LJ': 'L-Max',
    'LW': 'Linnex',
    'JJ': 'Listo',
    'LNM': 'LNMBBS',
    'LO': 'Loewe',
    'LNG': 'LongTV',
    'YL': 'Loview',
    'LOV': 'Lovme',
    'LGN': 'LOGAN',
    '1L': 'Logic',
    'LH': 'Logic Instrument',
    'LM': 'Logicom',
    'LOG': 'Logik',
    'LGT': 'Logitech',
    'GY': 'LOKMAT',
    'LPX': 'LPX-G',
    '0L': 'Lumigon',
    'LU': 'Lumus',
    'LUM': 'Lumitel',
    'L9': 'Luna',
    'LNN': 'LUNNEN',
    'LUO': 'LUO',
    'LR': 'Luxor',
    'LY': 'LYF',
    'LL': 'Leader Phone',
    'LTL': 'LYOTECH LABS',
    'QL': 'LT Mobile',
    'LW1': 'LW',
    'MQ': 'M.T.T.',
    'MN': 'M4tel',
    'XM': 'Macoox',
    '92': 'MAC AUDIO',
    'MJ': 'Majestic',
    'FQ': 'Mafe',
    'MAG': 'MAG',
    'MA2': 'MAGCH',
    '6Y': 'Magicsee',
    'MA4': 'Magenta',
    '23': 'Magnus',
    'NH': 'Manhattan',
    'MAN': 'Mango',
    '5M': 'Mann',
    'MA': 'Manta Multimedia',
    'Z0': 'Mantra',
    'J4': 'Mara',
    'MAR': 'Marshal',
    '8Y': 'Massgo',
    'MA1': 'Mascom',
    '2M': 'Masstel',
    '3X': 'Mastertech',
    'MAS': 'Master-G',
    '50': 'Matrix',
    'MAT': 'Matco Tools',
    '7M': 'Maxcom',
    '7M1': 'Maxfone',
    'ZM': 'Maximus',
    '6X': 'Maxtron',
    '0D': 'MAXVI',
    'MAX': 'Maxwell',
    'XZ': 'MAXX',
    'MW': 'Maxwest',
    'M0': 'Maze',
    'YM': 'Maze Speed',
    '87': 'Malata',
    'MAU': 'Maunfeld',
    'MCL': 'McLaut',
    '28': 'MBOX',
    'FK': 'MBI',
    'MBK': 'MBK',
    '3D': 'MDC Store',
    '1Y': 'MDTV',
    '09': 'meanIT',
    'M3': 'Mecer',
    'M3M': 'M3 Mobile',
    '0M': 'Mecool',
    'MEC': 'MECHEN',
    'MEM': 'MeMobile',
    'MC': 'Mediacom',
    'MD': 'Medion',
    'M2': 'MEEG',
    'MEG': 'MEGA VISION',
    'MCA': 'Megacable',
    'MP': 'MegaFon',
    'MGX': 'MEGAMAX',
    'X0': 'mPhone',
    '3M': 'Meitu',
    'M1': 'Meizu',
    '0E': 'Melrose',
    'MU': 'Memup',
    'ME': 'Metz',
    'MEO': 'MEO',
    'MX': 'MEU',
    'MES': 'MESWAO',
    'MI': 'MicroMax',
    'MIP': 'mipo',
    'MS': 'Microsoft',
    '6Q': 'Microtech',
    'MIG': 'Mightier',
    '1X': 'Minix',
    'OM': 'Mintt',
    'MIN': 'Mint',
    'MO': 'Mio',
    'MOD': 'Moondrop',
    'MOR': 'MORTAL',
    'X7': 'Mione',
    'M7': 'Miray',
    'MIT': 'Mitchell & Brown',
    '8M': 'Mito',
    'MT': 'Mitsubishi',
    '0Y': 'Mitsui',
    'M5': 'MIXC',
    '2D': 'MIVO',
    '1Z': 'MiXzo',
    'MIW': 'MIWANG',
    'ML': 'MLLED',
    'LS': 'MLS',
    'MLA': 'MLAB',
    '5H': 'MMI',
    '4M': 'Mobicel',
    'M6': 'Mobiistar',
    'MOK': 'Mobile Kingdom',
    'MH': 'Mobiola',
    'MB': 'Mobistel',
    'ID': 'MobiIoT',
    '6W': 'MobiWire',
    '9M': 'Mobo',
    'MOB': 'Mobell',
    'MVO': 'Mobvoi',
    'M4': 'Modecom',
    'MEP': 'Mode Mobile',
    'MF': 'Mofut',
    'MR': 'Motorola',
    'MTS': 'Motorola Solutions',
    'MIV': 'Motiv',
    'MV': 'Movic',
    'MOV': 'Movitel',
    'MO1': 'MOVISUN',
    'MOS': 'Mosimosi',
    'MOX': 'Moxee',
    'MM': 'Mpman',
    'MZ': 'MSI',
    '3R': 'MStar',
    'M9': 'MTC',
    'N4': 'MTN',
    '72': 'M-Tech',
    '9H': 'M-Horse',
    'MKP': 'M-KOPA',
    'MLB': 'multibox',
    '1R': 'Multilaser',
    'MPS': 'MultiPOS',
    'MLT': 'MULTYNET',
    '1M': 'MYFON',
    'MY1': 'myPhone (PL)',
    'MY': 'MyPhone (PH)',
    '51': 'Myros',
    'M8': 'Myria',
    '6M': 'Mystery',
    '3T': 'MyTab',
    'MG': 'MyWigo',
    'J3': 'Mymaga',
    'MYM': 'MyMobile',
    '07': 'MyGica',
    'MYG': 'MygPad',
    'MWA': 'MwalimuPlus',
    'NEO': 'neoCore',
    'NER': 'Neoregent',
    '08': 'Nabi',
    'N7': 'National',
    'NC': 'Navcity',
    '6N': 'Navitech',
    '7V': 'Navitel',
    'N3': 'Navon',
    '7R': 'NavRoad',
    'NAB': 'NABO',
    'NAS': 'NASCO',
    'NP': 'Naomi Phone',
    'NAN': 'Nanho',
    'NE': 'NEC',
    'NDP': 'Nedaphone',
    '8N': 'Necnot',
    'NF': 'Neffos',
    '9X': 'Neo',
    'NEK': 'NEKO',
    '1N': 'Neomi',
    '7Q': 'Neon IQ',
    '8F': 'Neolix',
    'NES': 'Nesons',
    'NET': 'NetBox',
    'NWT': 'NETWIT',
    'NA': 'Netgear',
    'NEM': 'Netmak',
    'NU': 'NeuImage',
    'NEU': 'NeuTab',
    'NEV': 'NEVIR',
    'NW': 'Newgen',
    'N9': 'Newland',
    '0N': 'Newman',
    'NS': 'NewsMy',
    'ND': 'Newsday',
    'HB': 'New Balance',
    'BRI': 'New Bridge',
    'NEW': 'Newal',
    'XB': 'NEXBOX',
    'NX': 'Nexian',
    '7X': 'Nexa',
    '7XR': 'Nexar',
    'N8': 'NEXON',
    'N2': 'Nextbit',
    'NT': 'NextBook',
    'NTT': 'NTT West',
    '4N': 'NextTab',
    'NEX': 'NEXT',
    'NST': 'Next & NextStar',
    'NJO': 'nJoy',
    'NG': 'NGM',
    'NZ': 'NG Optics',
    'NZP': 'NGpon',
    'NN': 'Nikon',
    'NIL': 'NILAIT',
    'NI': 'Nintendo',
    'NIN': 'NINETEC',
    'NI1': 'NINETOLOGY',
    'N5': 'NOA',
    'N1': 'Noain',
    'N6': 'Nobby',
    'NOC': 'Novacom',
    'NOS': 'NoviSea',
    'NO2': 'NOVIS',
    'NOV': 'Novey',
    'NO1': 'NOVO',
    '57': 'Nubia',
    'JN': 'NOBUX',
    'NB': 'Noblex',
    'OG': 'NOGA',
    'NK': 'Nokia',
    'NM': 'Nomi',
    '2N': 'Nomu',
    '6H': 'Noontec',
    'NR': 'Nordmende',
    'NRD': 'Nordfrost',
    'NOR': 'NORMANDE',
    '7N': 'NorthTech',
    'NOT': 'Nothing',
    '5N': 'Nos',
    'NO': 'Nous',
    'NQ': 'Novex',
    'NOD': 'noDROPOUT',
    'NJ': 'NuAns',
    'NL': 'NUU Mobile',
    'N0': 'Nuvo',
    'NUV': 'NuVision',
    'NV': 'Nvidia',
    'NY': 'NYX Mobile',
    'NON': 'N-one',
    'O3': 'O+',
    'OT': 'O2',
    'O7': 'Oale',
    'OC': 'OASYS',
    'OB': 'Obi',
    'OBR': 'Ober',
    'OQ': 'Meta',
    'O1': 'Odys',
    'ODP': 'Odotpad',
    'O9': 'ok.',
    'OKA': 'Okapi',
    'OA': 'Okapia',
    'OKI': 'Oking',
    'OLA': 'Olax',
    'OLK': 'Olkya',
    'OLY': 'Olympia',
    'OCE': 'OCEANIC',
    'OLT': 'OLTO',
    'OJ': 'Ookee',
    'OD': 'Onda',
    'ON': 'OnePlus',
    'ONC': 'OneClick',
    'ONL': 'OneLern',
    'OAN': 'Oangcc',
    'OX': 'Onix',
    'OIN': 'Onida',
    '3O': 'ONYX BOOX',
    'O4': 'ONN',
    '9Q': 'Onkyo',
    'ONV': 'ONVO',
    'OOR': 'Ooredoo',
    '2O': 'OpelMobile',
    'OH': 'Openbox',
    '7Y': 'Obabox',
    'OP': 'OPPO',
    'OO': 'Opsson',
    'OPT': 'Optoma',
    'OPH': 'Ophone',
    'OR': 'Orange',
    'ORP': 'Orange Pi',
    'ORA': 'Orava',
    'O5': 'Orbic',
    'Y6': 'Orbita',
    'ORB': 'Orbsmart',
    'OS': 'Ordissimo',
    '8O': 'Orion',
    'OTT': 'OTTO',
    'OK': 'Ouki',
    '0O': 'OINOM',
    'OIL': 'Oilsky',
    'QK': 'OKWU',
    'QQ': 'OMIX',
    '56': 'OKSI',
    'OE': 'Oukitel',
    'OU': 'OUYA',
    'JB': 'OUJIA',
    'OV': 'Overmax',
    '30': 'Ovvi',
    'O2': 'Owwo',
    'OSC': 'OSCAL',
    'OXT': 'OX TAB',
    'OY': 'Oysters',
    'QF': 'OYSIN',
    'O6': 'Oyyu',
    'OZ': 'OzoneHD',
    'OLL': 'Ollee',
    '7P': 'P-UP',
    'PRA': 'Pacific Research Alliance',
    'PAG': 'PAGRAER',
    'PAD': 'Padpro',
    'YP': 'Paladin',
    'PM': 'Palm',
    'PN': 'Panacom',
    'PA': 'Panasonic',
    'PNV': 'Panavox',
    'PT': 'Pantech',
    'PAN': 'Pano',
    'PND': 'Panodic',
    'PA1': 'Panoramic',
    'PLT': 'Platoon',
    'PLD': 'PLDT',
    '94': 'Packard Bell',
    'H9': 'Parrot Mobile',
    'PAR': 'Partner Mobile',
    'PAP': 'PAPYRE',
    'PB': 'PCBOX',
    'PCS': 'PC Smart',
    'PC': 'PCD',
    'PD': 'PCD Argentina',
    'PE': 'PEAQ',
    'PEN': 'Penta',
    'PG': 'Pentagram',
    'PQ': 'Pendoo',
    '93': 'Perfeo',
    '8J': 'Pelitt',
    '1P': 'Phicomm',
    '4P': 'Philco',
    'PH': 'Philips',
    '5P': 'Phonemax',
    'PO': 'phoneOne',
    'PI': 'Pioneer',
    'PIC': 'Pioneer Computers',
    'PJ': 'PiPO',
    '8P': 'Pixelphone',
    '9O': 'Pixela',
    'PX': 'Pixus',
    'PIX': 'PIXPRO',
    'QP': 'Pico',
    'PIR': 'PIRANHA',
    'PIN': 'PINE64',
    '9P': 'Planet Computers',
    'PLA': 'Play Now',
    'PY': 'Ployer',
    'P4': 'Plum',
    'PLU': 'PlusStyle',
    '22': 'Pluzz',
    'P8': 'PocketBook',
    '0P': 'POCO',
    'FH': 'Point Mobile',
    'PV': 'Point of View',
    'PVB': 'PVBox',
    'PL': 'Polaroid',
    'Q6': 'Polar',
    '97': 'PolarLine',
    'PP': 'PolyPad',
    'P5': 'Polytron',
    'P2': 'Pomp',
    'P0': 'Poppox',
    '0X': 'POPTEL',
    'PS': 'Positivo',
    '3P': 'Positivo BGH',
    '3F': 'Porsche',
    'PRT': 'Portfolio',
    'PPD': 'PPDS',
    'P3': 'PPTV',
    'FP': 'Premio',
    'PR1': 'Premier',
    'PR': 'Prestigio',
    'P9': 'Primepad',
    'PRM': 'PRIME',
    '6P': 'Primux',
    '2P': 'Prixton',
    'PRI': 'Pritom',
    'PRP': 'PRISM+',
    'PF': 'PROFiLO',
    'P6': 'Proline',
    '5O': 'Prology',
    'P1': 'ProScan',
    'PRO': 'PROSONIC',
    'P7': 'Protruly',
    'R0': 'ProVision',
    '7O': 'Polestar',
    'PU': 'PULID',
    'UP': 'Purism',
    'PUN': 'Punos',
    'QFX': 'QFX',
    'Q7': 'Q-Box',
    'QH': 'Q-Touch',
    'QB': 'Q.Bell',
    'QI': 'Qilive',
    'QIN': 'QIN',
    'QIW': 'Qiuwoky',
    'QM': 'QMobile',
    'QT': 'Qtek',
    'Q9': 'QTECH',
    'QA': 'Quantum',
    'QUE': 'Quest',
    'QUA': 'Quatro',
    'QU': 'Quechua',
    'QUI': 'Quipus',
    'QO': 'Qumo',
    'UQ': 'Qubo',
    'QUP': 'Qupi',
    'YQ': 'QLink',
    'QY': 'Qnet Mobile',
    'WJ': 'Qware',
    'QWT': 'QWATT',
    'R2': 'R-TV',
    'R3D': 'R3Di',
    'RA': 'Ramos',
    '0R': 'Raspberry',
    'R9': 'Ravoz',
    'RZ': 'Razer',
    'RAZ': 'RAZZ',
    '95': 'Rakuten',
    'RAY': 'Raylandz',
    'RC': 'RCA Tablets',
    'RCT': 'RCT',
    '2R': 'Reach',
    'RLX': 'Realix',
    'REL': 'RelNAT',
    'RE4': 'Relndoo',
    'RB': 'Readboy',
    'RE': 'Realme',
    'RE1': 'Redbean',
    'R8': 'RED',
    'RDX': 'RED-X',
    'REW': 'Redway',
    '6F': 'Redfox',
    'RE2': 'RedLine',
    'RD': 'Reeder',
    'Z9': 'REGAL',
    'RH': 'Remdun',
    'RP': 'Revo',
    'REV': 'Revomovil',
    '8R': 'Retroid Pocket',
    'REN': 'Renova',
    'RE3': 'RENSO',
    'REP': 'rephone',
    'RHI': 'Rhino',
    'RIC': 'Ricoh',
    'RI': 'Rikomagic',
    'RM': 'RIM',
    'RN': 'Rinno',
    'RNB': 'Ringing Bells',
    'RX': 'Ritmix',
    'R7': 'Ritzviva',
    'RV': 'Riviera',
    '6R': 'Rivo',
    'RIZ': 'Rizzen',
    'RR': 'Roadrover',
    'QR': 'ROADMAX',
    'ROH': 'ROCH',
    'ROC': 'Roam Cat',
    'ROT': 'Rocket',
    'R1': 'Rokit',
    'ROI': 'ROiK',
    'RK': 'Roku',
    'R3': 'Rombica',
    'RUA': 'Romsat',
    'R5': 'Ross&Moor',
    'RO': 'Rover',
    'R6': 'RoverPad',
    'RQ': 'RoyQueen',
    'RJ': 'Royole',
    'RT': 'RT Project',
    'RTK': 'RTK',
    'RG': 'RugGear',
    'RUG': 'Ruggex',
    'RUT': 'RuggeTech',
    'RU': 'Runbo',
    'RUN': 'RunGee',
    'RUP': 'Rupa',
    'RL': 'Ruio',
    'RY': 'Ryte',
    'X5': 'Saba',
    '8L': 'S-TELL',
    '8L1': 'S-Color',
    '4O': 'S2Tel',
    '89': 'Seatel',
    'SEW': 'Sewoo',
    'SE1': 'SEEWO',
    'SEN': 'SENNA',
    'SER': 'SERVO',
    'Y7': 'Saiet',
    'SLF': 'SAILF',
    'X1': 'Safaricom',
    'SG': 'Sagem',
    'SAG': 'Sagemcom',
    '4L': 'Salora',
    'SA': 'Samsung',
    'SAT': 'Samtech',
    'SAM': 'Samtron',
    'SAB': 'Sambox',
    'SNA': 'SNAMI',
    'S0': 'Sanei',
    '12': 'Sansui',
    'SAK': 'Sankey',
    'SQ': 'Santin',
    'SY': 'Sanyo',
    'SAN': 'SANY',
    'S9': 'Savio',
    'Y4': 'TCL SCBC',
    'SCH': 'SCHAUB LORENZ',
    'CZ': 'Schneider',
    'SHO': 'SCHONTECH',
    'SCO': 'Scosmos',
    'SC1': 'Scoole',
    'ZG': 'Schok',
    'G8': 'SEG',
    'SEX': 'SEHMAX',
    'SD': 'Sega',
    '0U': 'Selecline',
    '9G': 'Selenga',
    'SV': 'Selevision',
    'SL': 'Selfix',
    '0S': 'SEMP TCL',
    'S1': 'Sencor',
    'SNM': 'Sencrom',
    'SN': 'Sendo',
    '01': 'Senkatel',
    'S6': 'Senseit',
    'EW': 'Senwa',
    '24': 'Seeken',
    'SEB': 'SEBBE',
    '61': 'Seuic',
    'SX': 'SFR',
    'SGI': 'SGIN',
    'SH': 'Sharp',
    'JU': 'Shanling',
    '7S': 'Shift Phones',
    '78': 'Shivaki',
    'RS': 'Shtrikh-M',
    '3S': 'Shuttle',
    '13': 'Sico',
    'SI': 'Siemens',
    '1S': 'Sigma',
    '70': 'Silelis',
    'SJ': 'Silent Circle',
    'SIL': 'Silva Schneider',
    '10': 'Simbans',
    '98': 'Simply',
    'SIM': 'simfer',
    '52': 'Singtech',
    'SIN': 'SINGER',
    '31': 'Siragon',
    'SIS': 'Siswoo',
    '83': 'Sirin Labs',
    '5Z': 'SK Broadband',
    'GK': 'SKG',
    'SW': 'Sky',
    'SK': 'Skyworth',
    'SKY': 'Skyline',
    'SK1': 'SkyStream',
    'SKT': 'Skytech',
    'SKK': 'SKK Mobile',
    '14': 'Smadl',
    '19': 'Smailo',
    'SR': 'Smart Electronic',
    'SMA': 'Smart Kassel',
    'STE': 'Smart Tech',
    '49': 'Smart',
    '47': 'SmartBook',
    '3B': 'Smartab',
    '80': 'SMARTEC',
    'SM1': 'Smartex',
    'SC': 'Smartfren',
    'S7': 'Smartisan',
    'SMU': 'SMUX',
    'SMT': 'SMT Telecom',
    'JR': 'Sylvania',
    'SYH': 'SYH',
    '3Y': 'Smarty',
    'HH': 'Smooth Mobile',
    '1Q': 'Smotreshka',
    'SF': 'Softbank',
    '9L': 'SOLE',
    'JL': 'SOLO',
    'SOS': 'SOSH',
    'SOD': 'Soda',
    'SOL': 'Solas',
    '16': 'Solone',
    'OI': 'Sonim',
    'SVE': 'Sveon',
    'SO': 'Sony',
    'SE': 'Sony Ericsson',
    'X2': 'Soundmax',
    'SUL': 'SoulLink',
    '8S': 'Soyes',
    '77': 'SONOS',
    '68': 'Soho Style',
    'SOB': 'SobieTech',
    'SOW': 'SOWLY',
    'PK': 'Spark',
    'SPX': 'Sparx',
    'FS': 'SPC',
    '6S': 'Spectrum',
    '43': 'Spectralink',
    'SP': 'Spice',
    'SPD': 'Spider',
    '84': 'Sprint',
    'SPU': 'SPURT',
    'QS': 'SQOOL',
    'S4': 'Star',
    'OL': 'Starlight',
    'STA': 'Star-Light',
    '18': 'Starmobile',
    '2S': 'Starway',
    '45': 'Starwind',
    'SB': 'STF Mobile',
    'S8': 'STK',
    'GQ': 'STG Telecom',
    'S2': 'Stonex',
    'ST': 'Storex',
    'STR': 'Stream',
    '71': 'StrawBerry',
    '96': 'STRONG',
    '69': 'Stylo',
    'STI': 'Stilevs',
    '9S': 'Sugar',
    'SUR': 'Surge',
    'SUF': 'Surfans',
    '06': 'Subor',
    'SUT': 'SULPICE TV',
    'SZ': 'Sumvision',
    '0H': 'Sunstech',
    'S3': 'SunVan',
    '5S': 'Sunvell',
    '5Y': 'Sunny',
    'W8': 'SUNWIND',
    'SBX': 'SuperBOX',
    'SBM': 'Supermax',
    'SBR': 'Sber',
    'SGE': 'Super General',
    'SU': 'SuperSonic',
    '79': 'SuperTab',
    'STV': 'SuperTV',
    'S5': 'Supra',
    'SUP': 'Supraim',
    'ZS': 'Suzuki',
    '2J': 'Sunmi',
    'SUN': 'Sunmax',
    '0W': 'Swipe',
    'SWI': 'Switel',
    'SS': 'SWISSMOBILITY',
    '1W': 'Swisstone',
    'SWO': 'SWOFY',
    'SSK': 'SSKY',
    'SYC': 'Syco',
    'SM': 'Symphony',
    '4S': 'Syrox',
    'SYS': 'System76',
    'TM': 'T-Mobile',
    'T96': 'T96',
    'TAD': 'TADAAM',
    'TK': 'Takara',
    '73': 'Tambo',
    '9N': 'Tanix',
    'U5': 'Taiga System',
    'TAL': 'Talius',
    '7G': 'TAG Tech',
    'TLB': 'TALBERG',
    'TAU': 'TAUBE',
    'T5': 'TB Touch',
    'TC': 'TCL',
    'T0': 'TD Systems',
    'YY': 'TD Tech',
    'H4': 'Technicolor',
    'TEA': 'TeachTouch',
    'Z5': 'Technika',
    'TE1': 'TechSmart',
    'TX': 'TechniSat',
    'TT': 'TechnoTrend',
    'TTS': 'TECHNOSAT',
    'TM1': 'Temigereev',
    'TP': 'TechPad',
    'TPS': 'TPS',
    '9E': 'Techwood',
    '7F': 'Technopc',
    'TCH': 'Techstorm',
    'T7': 'Teclast',
    'TB': 'Tecno Mobile',
    'TEC': 'TecToy',
    '91': 'TEENO',
    'TLK': 'Telkom',
    '2L': 'Tele2',
    'TL': 'Telefunken',
    'TG': 'Telego',
    'T2': 'Telenor',
    'TE': 'Telit',
    '65': 'Telia',
    'TLY': 'Telly',
    'TEL': 'Telma',
    'PW': 'Telpo',
    'TLS': 'TeloSystems',
    'TER': 'Teracube',
    'TD': 'Tesco',
    'TA': 'Tesla',
    '9T': 'Tetratab',
    'TET': 'TETC',
    'TZ': 'teXet',
    '29': 'Teknosa',
    'JZ': 'TJC',
    'TJD': 'TJD',
    'JC': 'TENPLUS',
    'T4': 'ThL',
    'TN': 'Thomson',
    'O0': 'Thuraya',
    'TI': 'TIANYU',
    'JY': 'Tigers',
    '8T': 'Time2',
    'TQ': 'Timovi',
    'TIM': 'TIMvision',
    '2T': 'Tinai',
    'TF': 'Tinmo',
    'TH': 'TiPhone',
    'YV': 'TiVo',
    'TIV': 'Tivax',
    'TIB': 'Tibuta',
    'Y3': 'TOKYO',
    'TOX': 'TOX',
    'T1': 'Tolino',
    '0T': 'Tone',
    'TY': 'Tooky',
    'TYD': 'TYD',
    'TOO': 'TOOGO',
    'TPT': 'Top-Tech',
    'T9': 'Top House',
    'DK': 'Topelotek',
    '42': 'Topway',
    'TO': 'Toplux',
    'TOD': 'TOPDON',
    'TOP': 'TopDevice',
    'TO2': 'TOPSHOWS',
    '7T': 'Torex',
    'TOR': 'Torque',
    'TRN': 'TORNADO',
    '6O': 'TOSCIDO',
    'TO1': 'Topsion',
    'TS': 'Toshiba',
    'T8': 'Touchmate',
    'TOU': 'Touch Plus',
    '5R': 'Transpeed',
    'T6': 'TrekStor',
    'TRP': 'Trecfone',
    'T3': 'Trevi',
    'TRI': 'TriaPlay',
    'TJ': 'Trifone',
    'Q5': 'Trident',
    'TRB': 'Trimble',
    '4T': 'Tronsmart',
    '11': 'True',
    'JT': 'True Slim',
    'J1': 'Trio',
    'TRC': 'Tricolor',
    'THT': 'Tsinghua Tongfang',
    '5C': 'TTEC',
    'TTF': 'TTfone',
    'TTK': 'TTK-TV',
    'TU': 'Tunisie Telecom',
    '1T': 'Turbo',
    'TR': 'Turbo-X',
    '5X': 'TurboPad',
    '5T': 'TurboKids',
    'UR': 'Turkcell',
    '4U': 'TuCEL',
    'TUV': 'Tuvio',
    'TUC': 'TUCSON',
    '2U': "T\xfcrk Telekom",
    'TUR': "T\xfcrksat",
    'TV': 'TVC',
    'TVP': 'TV+',
    'TW': 'TWM',
    'Z1': 'TWZ',
    '6T': 'Twoe',
    'TWN': 'TwinMOS',
    '15': 'Tymes',
    'UC': 'U.S. Cellular',
    'UD1': 'UD',
    'UGI': 'UGINE',
    'UG': 'Ugoos',
    'U1': 'Uhans',
    'UH': 'Uhappy',
    'UL': 'Ulefone',
    'UA': 'Umax',
    'UM': 'UMIDIGI',
    'UM2': 'Umiio',
    'UNT': 'Unitech',
    'UZ': 'Unihertz',
    '3Z': 'UZ Mobile',
    'UX': 'Unimax',
    'UNQ': 'Uniqcell',
    'US': 'Uniscope',
    'UNI': 'Unistrong',
    'U2': 'UNIWA',
    'UND': 'Uniden',
    'UNE': 'UNITED',
    'UGR': 'United Group',
    'UO': 'Unnecto',
    'UNN': 'Unnion Technologies',
    'UNP': 'UnoPhone',
    'UU': 'Unonu',
    'UN': 'Unowhy',
    'UY': 'UNNO',
    'UOO': 'UOOGOU',
    'UNB': 'Unblock Tech',
    'UK': 'UTOK',
    '3U': 'IUNI',
    'UT': 'UTStarcom',
    '6U': 'UTime',
    '9U': 'Urovo',
    'UW': 'U-Magic',
    '5V': 'VAIO',
    'WV': 'VAVA',
    'VA': 'Vastking',
    'VAS': 'VASOUN',
    'VP': 'Vargo',
    'VC': 'Vankyo',
    'VAL': 'VALEM',
    'VA2': 'VALE',
    'VAT': 'VALTECH',
    'VAN': 'VANGUARD',
    'VAW': 'VANWIN',
    'VB': 'VC',
    'VEI': 'Veidoo',
    'VN': 'Venso',
    'VNP': 'VNPT Technology',
    'VEN': 'Venstar',
    'UV': 'Venturer',
    'VQ': 'Vega',
    'WC': 'VEON',
    '4V': 'Verico',
    'V4': 'Verizon',
    'VR': 'Vernee',
    'VX': 'Vertex',
    'VE': 'Vertu',
    'VET': 'VETAS',
    'VL': 'Verykool',
    'QV': 'Verssed',
    'VER': 'Versus',
    'V8': 'Vesta',
    'VEK': 'Vekta',
    'VT': 'Vestel',
    '48': 'Vexia',
    'V6': 'VGO TEL',
    'QJ': 'VDVD',
    'VIC': 'Victurio',
    'VD': 'Videocon',
    'VW': 'Videoweb',
    'VS': 'ViewSonic',
    'VIE': 'Viendo',
    'VIK': 'VIKUSHA',
    'V7': 'Vinga',
    'V7T': 'V7',
    'V3': 'Vinsoc',
    'XD': 'Vinabox',
    'FV': 'Vios',
    '0V': 'Vipro',
    'ZV': 'Virzo',
    'VIP': 'Viper',
    'VI': 'Vitelcom',
    'VIB': 'ViBox',
    '8V': 'Viumee',
    'V5': 'Vivax',
    'VIV': 'VIVIMAGE',
    'VI2': 'VIVIBright',
    'VV': 'Vivo',
    '6V': 'VIWA',
    'VII': 'VIIPOO',
    'VID': 'VIDA',
    'VZ': 'Vizio',
    'VIZ': 'Vizmo',
    'VIT': 'Vityaz',
    'VTM': 'Vitumi',
    '9V': 'Vision Touch',
    'VIS': 'Vision Technology',
    'VST': 'Visitech',
    'VIL': 'Visual Land',
    'VI1': 'VILLAON',
    'VIM': 'VIMOQ',
    'VK': 'VK Mobile',
    'JM': 'v-mobile',
    'VHO': 'V-HOPE',
    'VHM': 'V-HOME',
    'VGE': 'V-Gen',
    'V0': 'VKworld',
    'VM': 'Vodacom',
    'VOC': 'VOCAL',
    'VF': 'Vodafone',
    '7W': 'VOGA',
    'V2': 'Vonino',
    '1V': 'Vontar',
    'VG': 'Vorago',
    '2V': 'Vorke',
    '8U': 'Vorcom',
    'JW': 'Vortex',
    'VRX': 'VORTEX (RO)',
    'VOR': 'Vormor',
    'V1': 'Voto',
    'Z7': 'VOX',
    'VOI': 'VOIX',
    'VO': 'Voxtel',
    'VY': 'Voyo',
    'VOL': "V\xf6lfen",
    'VO1': 'Volt',
    'VOP': 'Volla',
    'V02': 'VOLIA',
    'VH': 'Vsmart',
    'V9': 'Vsun',
    'VU': 'Vulcan',
    '3V': 'VVETIME',
    'ZC': 'VUCATIMES',
    'VO2': 'VOLKANO',
    'VUE': 'Vue Micro',
    'WAK': 'Walker',
    'WA': 'Walton',
    'WAF': 'WAF',
    'WAO': 'W&O',
    'WLT': 'Waltham',
    'WAL': 'Waltter',
    'WAI': 'Wainyok',
    'WAT': 'waipu.tv',
    'WHI': 'White Mobile',
    'WHO': 'Whoop',
    'WBL': 'We. by Loewe.',
    'WCP': 'WeChip',
    'WM': 'Weimei',
    'WM1': 'Weiimi',
    'WE': 'WellcoM',
    'W6': 'WELLINGTON',
    'WD': 'Western Digital',
    'WST': 'Weston',
    'WT': 'Westpoint',
    'WAN': 'Wanmukang',
    'WA1': 'WANSA',
    'WY': 'Wexler',
    '3W': 'WE',
    'WEC': 'Wecool',
    'WEE': 'Weelikeit',
    'WP': 'Wieppo',
    'W2': 'Wigor',
    'WI': 'Wiko',
    'WF': 'Wileyfox',
    'WLR': 'WildRed',
    'WS': 'Winds',
    'WN': 'Wink',
    '9W': 'Winmax',
    'W5': 'Winnovo',
    'WU': 'Wintouch',
    'WIS': 'Winstar',
    'W0': 'Wiseasy',
    '2W': 'Wizz',
    'W4': 'WIWA',
    'WIZ': 'WizarPos',
    'WL': 'Wolder',
    'WG': 'Wolfgang',
    'WQ': 'Wolki',
    'WON': 'WONDER',
    'WO': 'Wonu',
    'W1': 'Woo',
    'WR': 'Wortmann',
    'WX': 'Woxter',
    'WOZ': 'WOZIFAN',
    'XQ': 'X-AGE',
    'XEL': 'XElectron',
    'X3': 'X-BO',
    'XBI': 'XB',
    'XMO': 'X-Mobile',
    'XT': 'X-TIGI',
    'XV': 'X-View',
    'X4': 'X.Vision',
    'X88': 'X88',
    'X96': 'X96',
    '96Q': 'X96Q',
    'A95': 'A95X',
    'XG': 'Xgody',
    'XGE': 'XGEM',
    'QX': 'XGIMI',
    'XL': 'Xiaolajiao',
    'XI': 'Xiaomi',
    'XW': 'Xiaodu',
    'XN': 'Xion',
    'XO': 'Xolo',
    'XR': 'Xoro',
    'XPP': 'XPPen',
    'XRL': 'XREAL',
    'XS': 'Xshitou',
    'XSM': 'Xsmart',
    '4X': 'Xtouch',
    'X8': 'Xtratech',
    'XCR': 'Xcruiser',
    'XCO': 'XCOM',
    'XCL': 'Xcell',
    'XWA': 'Xwave',
    'YD': 'Yandex',
    'YA': 'Yarvik',
    'Y2': 'Yes',
    'YES': 'Yestel',
    'YE': 'Yezz',
    'YG': 'YEPEN',
    'YEL': 'YELLYOUTH',
    'YK': 'Yoka TV',
    'YO': 'Yota',
    'YOU': 'Youin',
    'YO1': 'Youwei',
    'YOO': 'Yooz',
    'YT': 'Ytone',
    'Y9': 'YOTOPT',
    'Y1': 'Yu',
    'YF': 'YU Fly',
    'Y0': 'YUHO',
    'YN': 'Yuno',
    'YUN': 'YUNDOO',
    'YUS': 'YunSong',
    'YUM': 'YUMKEM',
    'YIK': 'YIKEMI',
    'YU': 'Yuandao',
    'YS': 'Yusun',
    'YJ': 'YASIN',
    'YX': 'Yxtel',
    '0Z': 'Zatec',
    '2Z': 'Zaith',
    'ZAM': 'Zamolxe',
    'ZAL': 'ZALA',
    'ZZB': 'ZZB',
    'ZEA': 'Zealot',
    'PZ': 'Zebra',
    'ZE1': 'Zeblaze',
    'ZE': 'Zeemi',
    'WZ': 'Zeeker',
    'ZN': 'Zen',
    'ZK': 'Zenek',
    'ZL': 'Zentality',
    'ZF': 'Zfiner',
    'ZI': 'Zidoo',
    'FZ': 'ZIFRO',
    'ZIF': 'ZIFFLER',
    'ZIO': 'ZIOVO',
    'ZX': 'Ziox',
    'ZIK': 'ZIK',
    'ZKI': 'Z-Kai',
    'ZIG': 'Zigo',
    'ZIN': 'Zinox',
    'ZO': 'Zonda',
    'ZW': 'Zonko',
    'ZP': 'Zopo',
    'ZOO': 'ZoomSmart',
    'ZO1': 'Zoom',
    'ZT': 'ZTE',
    'ZU': 'Zuum',
    'ZY': 'Zync',
    'ZR': 'Zyrex',
    'ZQ': 'ZYQ',
    'Z4': 'ZH&K',
    'OW': "\xf6wn",
    'WBF': 'Webfleet',
    'WSS': 'WS',
    // legacy brands, might be removed in future versions
    'WB': 'Web TV',
    'XX': 'Unknown'
};

});

parcelRegister("doq08", function(module, exports) {
module.exports = {
    "360": {
        "regex": "(?:180[1379]-A01|1713-A01|1707-A01|1509-A00|1603-A03|1607-A01|1503-A01|1505-A0[12]|1605-A01)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "1807-A01(?:[);/ ]|$)",
                "model": "N7"
            },
            {
                "regex": "1803-A01(?:[);/ ]|$)",
                "model": "N7 Lite"
            },
            {
                "regex": "1809-A01(?:[);/ ]|$)",
                "model": "N7 Pro"
            },
            {
                "regex": "1713-A01(?:[);/ ]|$)",
                "model": "N6 Lite"
            },
            {
                "regex": "1707-A01(?:[);/ ]|$)",
                "model": "N6"
            },
            {
                "regex": "1801-A01(?:[);/ ]|$)",
                "model": "N6 Pro"
            },
            {
                "regex": "1509-A00(?:[);/ ]|$)",
                "model": "Q5 Plus"
            },
            {
                "regex": "1503-A01(?:[);/ ]|$)",
                "model": "N4"
            },
            {
                "regex": "1605-A01(?:[);/ ]|$)",
                "model": "N5"
            },
            {
                "regex": "1603-A03(?:[);/ ]|$)",
                "model": "N4A"
            },
            {
                "regex": "1607-A01(?:[);/ ]|$)",
                "model": "N5S"
            },
            {
                "regex": "1505-A0[12](?:[);/ ]|$)",
                "model": "N4S"
            }
        ]
    },
    "8848": {
        "regex": "8848 (M[3-6])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Ace": {
        "regex": "(?:BUZZ [1-57]|BUZZ 4(?:Pro|S|Lite)|CLEVER [13]|URBAN [123](?: Pro)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BUZZ ([45]) Ultra",
                "model": "Buzz $1 Ultra"
            },
            {
                "regex": "BUZZ ([457]) Note",
                "model": "Buzz $1 Note"
            },
            {
                "regex": "BUZZ ([45]) Prime",
                "model": "Buzz $1 Prime"
            },
            {
                "regex": "BUZZ 5 Pro Plus",
                "model": "Buzz 5 Pro+"
            },
            {
                "regex": "BUZZ ([45]) ?Pro",
                "model": "Buzz $1 Pro"
            },
            {
                "regex": "BUZZ ([1245]) ?Lite",
                "model": "Buzz $1 Lite"
            },
            {
                "regex": "BUZZ ([123]) Plus",
                "model": "Buzz $1 Plus"
            },
            {
                "regex": "BUZZ 4S",
                "model": "Buzz 4S"
            },
            {
                "regex": "BUZZ ([1-5])",
                "model": "Buzz $1"
            },
            {
                "regex": "CLEVER ([13])",
                "model": "Clever $1"
            },
            {
                "regex": "URBAN 1 Pro",
                "model": "Urban 1 Pro"
            },
            {
                "regex": "URBAN ([123])",
                "model": "Urban $1"
            }
        ]
    },
    "Tunisie Telecom": {
        "regex": "StarTrail TT(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "StarTrail by TT"
    },
    "SFR": {
        "regex": "StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem|StarTab|(?:Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:AURA (?:PLUS|ULTRA)|AURA))(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "StarXtrem II(?:[);/ ]|$)",
                "model": "StarXtrem 2"
            },
            {
                "regex": "StarXtrem ?([3-6])(?:[);/ ]|$)",
                "model": "StarXtrem $1"
            },
            {
                "regex": "StarXtrem(?:[);/ ]|$)",
                "model": "StarXtrem"
            },
            {
                "regex": "StarTrail III(?:[);/ ]|$)",
                "model": "StarTrail 3"
            },
            {
                "regex": "StarTrail II(?:[);/ ]|$)",
                "model": "StarTrail 2"
            },
            {
                "regex": "StarTrail[ _]?([1-9])[ _]([34])G(?:[);/ ]|$)",
                "model": "StarTrail $1 $2G"
            },
            {
                "regex": "StarTrail[ _]?([1-9])(?:[);/ ]|$)",
                "model": "StarTrail $1"
            },
            {
                "regex": "StarTrail(?:[);/ ]|$)",
                "model": "StarTrail"
            },
            {
                "regex": "AURA PLUS(?:[);/ ]|$)",
                "model": "Aura Plus"
            },
            {
                "regex": "aura ULTRA(?:[);/ ]|$)",
                "model": "Aura Ultra"
            },
            {
                "regex": "AURA(?:[);/ ]|$)",
                "model": "Aura"
            },
            {
                "regex": "StarShine II(?:[);/ ]|$)",
                "model": "StarShine 2"
            },
            {
                "regex": "StarShine III(?:[);/ ]|$)",
                "model": "StarShine 3"
            },
            {
                "regex": "StarShine(?:[);/ ]|$)",
                "model": "StarShine"
            },
            {
                "regex": "STARADDICT 6(?:[);/ ]|$)",
                "model": "StarAddict 6"
            },
            {
                "regex": "STARADDICT 4(?:[);/ ]|$)",
                "model": "StarAddict 4"
            },
            {
                "regex": "STARADDICT III(?:[);/ ]|$)",
                "model": "StarAddict 3"
            },
            {
                "regex": "STARADDICT II Plus(?:[);/ ]|$)",
                "model": "StarAddict 2 Plus"
            },
            {
                "regex": "STARADDICT II(?:[);/ ]|$)",
                "model": "StarAddict 2"
            },
            {
                "regex": "STARADDICT(?:[);/ ]|$)",
                "model": "StarAddict"
            },
            {
                "regex": "StarText II(?:[);/ ]|$)",
                "model": "StarText 2"
            },
            {
                "regex": "StarText(?:[);/ ]|$)",
                "model": "StarText"
            },
            {
                "regex": "StarNaute II(?:[);/ ]|$)",
                "model": "StarNaute 2"
            },
            {
                "regex": "STARNAUTE ?([1-4])(?:[);/ ]|$)",
                "model": "StarNaute $1"
            },
            {
                "regex": "StarNaute(?:[);/ ]|$)",
                "model": "StarNaute"
            },
            {
                "regex": "StarTab",
                "model": "StarTab",
                "device": "tablet"
            },
            {
                "regex": "((?:StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem)[^;/]*) Build",
                "model": "$1"
            }
        ]
    },
    "Adronix": {
        "regex": "Adronix[ _]?(?:MT[0-9]+|X1001|Mini ?Tab ?7 ?3G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Adronix ?Mini ?Tab ?7 ?3G",
                "model": "Mini Tab 7 3G"
            },
            {
                "regex": "Adronix[ _]?(MT[0-9]+|X1001)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Cherry Mobile": {
        "regex": "Cherry|Superion[_ ](?:S2|Radar Deluxe|S1 DTV|S1 Plus DTV|Tab Pro)|Flare([ _])?(Selfie|2\\.[01]|2X|4|A[123]|J[1235678]|P[13]|S[4-8]|X2|Y[3567]|S[ _]Play|HD|LITE|XL|X_V[23]|Y3s|Tab|INFINITY)(?:[ _](?:Pro|Plus|Max|LTE))?|Fusion Aura 3s|Radar Deluxe 2|Desire R[678]|Desire_R[67]_Lite|Fusion Bolt|Omega[_ ](?:Icon 2|Icon Lite 2|lite[_ ][243][Cs]?|HD[ _][345]|HD_Duo|X)|Spin Max 2|Selfie_Two|Flare X Lite|Flare_5|Android 1.*Aqua S9|Aqua S10|MAIA PAD PLUS|COSMOS THREE| Revel 3G|Touch XL 2|DSR_(?:R8|R7P?)|CUBIX CUBE 3",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Flare2X|Aqua S(?:9|10)(?: (?:Max|Lite|Pro))?)",
                "model": "$1"
            },
            {
                "regex": "Flare[_ ]HD[_ ]([345])",
                "model": "Flare HD $1"
            },
            {
                "regex": "Flare_HD_MAX",
                "model": "Flare HD Max"
            },
            {
                "regex": "FLARE LITE",
                "model": "Flare Lite"
            },
            {
                "regex": "Flare[ _]S[ _]Play",
                "model": "Flare S Play"
            },
            {
                "regex": "Flare (2\\.[01])",
                "model": "Flare $1"
            },
            {
                "regex": "Flare[_ ]J([2356])S",
                "model": "Flare J$1s"
            },
            {
                "regex": "Flare_([A-Z]\\d+)_Prime",
                "model": "Flare $1 Prime"
            },
            {
                "regex": "Flare_([A-Z]\\d+)_Deluxe",
                "model": "Flare $1 Deluxe"
            },
            {
                "regex": "Flare[_ ]([A-Z]\\d+)[_ ]Power",
                "model": "Flare $1 Power"
            },
            {
                "regex": "Flare[_ ]([A-Z]\\d+)[_ ]Pro",
                "model": "Flare $1 Pro"
            },
            {
                "regex": "Flare[_ ]([A-Z]\\d+)[_ ]Lite",
                "model": "Flare $1 Lite"
            },
            {
                "regex": "Flare[_ ]([A-Z]\\d+)[_ ]Plus",
                "model": "Flare $1 Plus"
            },
            {
                "regex": "Flare XL Plus",
                "model": "Flare XL Plus"
            },
            {
                "regex": "Flare ?J3 ?Plus",
                "model": "Flare J3 Plus"
            },
            {
                "regex": "Flare X Lite",
                "model": "Flare X Lite"
            },
            {
                "regex": "Cherry[_ ]X740",
                "model": "Flare A5"
            },
            {
                "regex": "Flare[ _]X[_ ]V([23])",
                "model": "Flare X V$1"
            },
            {
                "regex": "Flare[ _]XL[_ ]?2",
                "model": "Flare XL 2"
            },
            {
                "regex": "Flare[ _]([A-Z]\\d+)[ _]mini",
                "model": "Flare $1 Mini"
            },
            {
                "regex": "Flare_J2_2018",
                "model": "Flare J2 (2018)"
            },
            {
                "regex": "Flare S4 Max LTE",
                "model": "Flare S4 Max LTE"
            },
            {
                "regex": "Flare[_ ]([A-Z]\\d+)[_ ]Max",
                "model": "Flare $1 Max"
            },
            {
                "regex": "FlareS5LiteDTV",
                "model": "Flare S5 Lite DTV"
            },
            {
                "regex": "Flare[_ ]J2[_ ]DTV",
                "model": "Flare S2 DTV"
            },
            {
                "regex": "Flare[_ ]INFINITY",
                "model": "Flare Infinity"
            },
            {
                "regex": "Flare[_ ]Lite[_ ]3S",
                "model": "Flare Lite S3"
            },
            {
                "regex": "Flare(?:[ _])?(Selfie|A1_Roam|A[123]|J8 LTE|J1s|J[1235678]|P[13]|S[4-8]|X2|Y3s|Y7_LTE|Y[3567]|[45])",
                "model": "Flare $1"
            },
            {
                "regex": "Touch XL 2",
                "model": "Touch XL 2"
            },
            {
                "regex": "OMEGA[ _]HD[ _]([345])",
                "model": "Omega HD $1"
            },
            {
                "regex": "Omega_HD_Duo",
                "model": "Omega HD Duo"
            },
            {
                "regex": "Omega Icon Lite 2",
                "model": "Omega Icon Lite 2"
            },
            {
                "regex": "Omega Icon 2",
                "model": "Omega Icon 2"
            },
            {
                "regex": "Omega[_ ]Lite[_ ](3[Cs]|[24])",
                "model": "Omega Lite $1"
            },
            {
                "regex": "Omega[_ ]X",
                "model": "Omega X"
            },
            {
                "regex": "Spin Max 2",
                "model": "Spin Max 2"
            },
            {
                "regex": "Selfie_Two",
                "model": "Selfie Two"
            },
            {
                "regex": "Desire[ _]R(\\d)[ _]Lite",
                "model": "Desire R$1 Lite"
            },
            {
                "regex": "Desire R6 plus",
                "model": "Desire R6 Plus"
            },
            {
                "regex": "Desire R6",
                "model": "Desire R6"
            },
            {
                "regex": "DSR_R([78])P",
                "model": "Desire R$1 Plus"
            },
            {
                "regex": "DSR_R([78])",
                "model": "Desire R$1"
            },
            {
                "regex": "Desire Eye",
                "model": "Desire Eye"
            },
            {
                "regex": "COSMOS THREE",
                "model": "Cosmos 3"
            },
            {
                "regex": "CUBIX CUBE 3",
                "model": "Cubix Cube 3"
            },
            {
                "regex": "Revel 3G",
                "model": "Revel 3G"
            },
            {
                "regex": "Radar Deluxe 2",
                "model": "Superion Radar Deluxe 2",
                "device": "tablet"
            },
            {
                "regex": "Superion_S2_Plus",
                "model": "Superion S2 Plus",
                "device": "tablet"
            },
            {
                "regex": "Superion S1 Plus DTV",
                "model": "Superion S1 Plus DTV",
                "device": "tablet"
            },
            {
                "regex": "Superion Tab Pro",
                "model": "Superion Tab Pro",
                "device": "tablet"
            },
            {
                "regex": "Flare Tab Pro V(\\d)",
                "device": "tablet",
                "model": "Flare Tab Pro V$1"
            },
            {
                "regex": "Fusion Aura 3s",
                "device": "tablet",
                "model": "Fusion Aura 3S"
            },
            {
                "regex": "MAIA PAD PLUS",
                "device": "tablet",
                "model": "Maia Pad Plus"
            },
            {
                "regex": "(Fusion Bolt|Flare Tab Pro|Flare Tab|Superion[_ ](?:S2|Radar Deluxe|S1 DTV))",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Cherry(?:[ _]?Mobile)?[ _]?([^/;]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "HTC": {
        "regex": "HTC|Sprint (?:APA|ATP)|ADR(?!910L)[a-z0-9]+|NexusHD2|Amaze[ _]4G(?:[);/ ]|$)|(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))|(Amaze[ _]4G|(?<!BLU LIFE |ZOPO )One ?[XELSV\\+]+)(?:[);/ ]|$)|SPV E6[05]0|(One M8|One Mini 2|X525a|PG86100|PC36100|XV6975|PJ83100|2PYB2|2PS64|2PZC5|0PJA10|0PJA2|HTV33|0PM92|0PCV1|601HT|0PAJ5|HTL2[23]|HTV3[12]|2PQ93|X2-HT|EXODUS 1|ISW13HT|710C|U Ultra|2Q8L10000|2Q55100|2QC9200|2PZC100|2PZF1|2PZM3|2Q6E1|U12 life|U Play)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:HTC[_ ](?:U-2u|U Play|2PZM3)|2PZM3|U Play)(?:[);/ ]|$)",
                "model": "U Play"
            },
            {
                "regex": "(?:HTC[_ ]U-1[wu]|2PZF1|U Ultra)(?:[);/ ]|$)",
                "model": "U Ultra"
            },
            {
                "regex": "(?:U11 plus|(?:HTC_)?2Q4D[12]00)(?:[);/ ]|$)",
                "model": "U11 Plus"
            },
            {
                "regex": "(?:HTC )?(?:U12\\+|2Q55[13]00)(?:[);/ ]|$)",
                "model": "U12 Plus"
            },
            {
                "regex": "U(1[12]) life(?:[);/ ]|$)",
                "model": "U$1 Life"
            },
            {
                "regex": "2Q6E1(?:[);/ ]|$)",
                "model": "U12 Life"
            },
            {
                "regex": "(?:U11 Eyes|2Q4R100)(?:[);/ ]|$)",
                "model": "U11 Eyes"
            },
            {
                "regex": "XV6975(?:[);/ ]|$)",
                "model": "Imagio"
            },
            {
                "regex": "PG86100(?:[);/ ]|$)",
                "model": "Evo 3G"
            },
            {
                "regex": "PC36100(?:[);/ ]|$)",
                "model": "Evo 4G"
            },
            {
                "regex": "HTC[_ ]D628u",
                "model": "Desire 628 Dual SIM"
            },
            {
                "regex": "(?:HTC[_ ])?(?:HTV33|601HT|2PZC100|2PZC5|U-3[uw])(?:[);/ ]|$)",
                "model": "U11"
            },
            {
                "regex": "(?:HTC_)?(?:801e|802[wdt]|PN071)",
                "model": "One"
            },
            {
                "regex": "PJ83100(?:[);/ ]|$)",
                "model": "One X"
            },
            {
                "regex": "HTC[_ ]PO582(?:[);/ ]|$)",
                "model": "One Mini"
            },
            {
                "regex": "(?:HTC_?)?(?:One[ _]?Mini[ _]?2|M8MINx)(?:[);/ ]|$)",
                "model": "One Mini 2"
            },
            {
                "regex": "X2-HT(?:[);/ ]|$)",
                "model": "One X2"
            },
            {
                "regex": "HTC 2PXH3(?:[);/ ]|$)",
                "model": "One X10"
            },
            {
                "regex": "ISW13HT(?:[);/ ]|$)",
                "model": "J"
            },
            {
                "regex": "HTL22(?:[);/ ]|$)",
                "model": "J One"
            },
            {
                "regex": "(?:HTC U23 pro|2QC9200)(?:[);/ ]|$)",
                "model": "U23 Pro"
            },
            {
                "regex": "(?:HTL23|HTV31)(?:[);/ ]|$)",
                "model": "J Butterfly"
            },
            {
                "regex": "HTCButterflys901s(?:[);/ ]|$)",
                "model": "Butterfly S"
            },
            {
                "regex": "One M9_Prime Camera Edition",
                "model": "One M9 Prime Camera Edition"
            },
            {
                "regex": "(?:HTC[_ ])?(?:M9pw|One M9 ?PLUS)(?:[);/ ]|$)",
                "model": "One M9 Plus"
            },
            {
                "regex": "(?:HTC[_ ]M9u|0PJA2|0PJA10|HTC One M9|HTC6535LVW)(?:[);/ ]|$)",
                "model": "One M9"
            },
            {
                "regex": "One[ _](X9|[EM]8) dual sim(?:[);/ ]|$)",
                "model": "One $1 Dual SIM"
            },
            {
                "regex": "Desire[ _]([\\d\\w]+) dual sim(?:[);/ ]|$)",
                "model": "Desire $1 Dual SIM"
            },
            {
                "regex": "HTC(?: One m7|6500LVW|PN071)(?:[);/ ]|$)",
                "model": "One M7"
            },
            {
                "regex": "(?:One M8|HTC6525LVW|HTC[_ ]M8[xd]|HTC[_ ]0P6B|HTCOneM8)(?:[);/ ]|$)",
                "model": "One M8"
            },
            {
                "regex": "HTC ?One ?M8 ?Eye(?:[);/ ]|$)",
                "model": "One M8 Eye"
            },
            {
                "regex": "(?:HTC_)?(?:0PAJ5|M8Sx)(?:[);/ ]|$)",
                "model": "One E8"
            },
            {
                "regex": "HTC[_ ]E9x(?:[);/ ]|$)",
                "model": "One E9"
            },
            {
                "regex": "HTC[_ ]?(?:One[_ ])?E9(?:pw|PLUS dual sim)(?:[);/ ]|$)",
                "model": "One E9 Plus"
            },
            {
                "regex": "HTC_S9u(?:[);/ ]|$)",
                "model": "One S9"
            },
            {
                "regex": "HTC6515LVW(?:[);/ ]|$)",
                "model": "One Remix"
            },
            {
                "regex": "X525a(?:[);/ ]|$)",
                "model": "One X+"
            },
            {
                "regex": "(?:2PQ9(?:3|10)|HTC[_ ]A9u)(?:[);/ ]|$)",
                "model": "One A9"
            },
            {
                "regex": "ADR6300",
                "model": "Droid Incredible"
            },
            {
                "regex": "HTC6435LVW",
                "model": "Droid DNA"
            },
            {
                "regex": "ADR6400L",
                "model": "ThunderBolt"
            },
            {
                "regex": "ADR6410LRA",
                "model": "Droid Incredible 3"
            },
            {
                "regex": "SPV E600",
                "model": "Excalibur"
            },
            {
                "regex": "SPV E650",
                "model": "Vox"
            },
            {
                "regex": "2PYB2",
                "model": "Bolt"
            },
            {
                "regex": "2PS64|HTC6545LVW|HTC[_ ]M10h",
                "model": "10"
            },
            {
                "regex": "(710C)(?:[);/ ]|$)",
                "model": "Desire $1"
            },
            {
                "regex": "0PM92(?:[);/ ]|$)",
                "model": "Desire 626S"
            },
            {
                "regex": "(?:HTC_)?0PCV[12](?:[);/ ]|$)",
                "model": "Desire 510"
            },
            {
                "regex": "HTC ?D160LVW(?:PP)?(?:[);/ ]|$)",
                "model": "Desire 530"
            },
            {
                "regex": "HTC[_ ]D310n(?:[);/ ]|$)",
                "model": "Desire 310"
            },
            {
                "regex": "HTC[_ ]v01(?:[);/ ]|$)",
                "model": "Desire 320"
            },
            {
                "regex": "608t(?:[);/ ]|$)",
                "model": "Desire 608t"
            },
            {
                "regex": "HTC_(?:0P9O2|D610x)(?:[);/ ]|$)",
                "model": "Desire 610"
            },
            {
                "regex": "HTC[_ ]?(0P4E[12])(?:[);/ ]|$)",
                "model": "Desire 601"
            },
            {
                "regex": "HTC_?D620h(?:[);/ ]|$)",
                "model": "Desire 620"
            },
            {
                "regex": "HTC[_ ]?(?:D626ph|D200LVWPP)(?:[);/ ]|$)",
                "model": "Desire 626"
            },
            {
                "regex": "HTC_?(?:0P9C2|D816[xd]?)(?:[);/ ]|$)",
                "model": "Desire 816"
            },
            {
                "regex": "HTC_?D526h(?:[);/ ]|$)",
                "model": "Desire 526"
            },
            {
                "regex": "2Q8L10000(?:[);/ ]|$)",
                "model": "Desire 19s"
            },
            {
                "regex": "Desire620G(?:[);/ ]|$)",
                "model": "Desire 620G Dual SIM"
            },
            {
                "regex": "EXODUS 1(?:[);/ ]|$)",
                "model": "Exodus 1"
            },
            {
                "regex": "HTC 2Q7A100(?:[);/ ]|$)",
                "model": "U19e"
            },
            {
                "regex": "HTC Desire 10 compact(?:[);/ ]|$)",
                "model": "Desire 10 Compact"
            },
            {
                "regex": "HTC_D10i(?:[);/ ]|$)",
                "model": "Desire 10 Pro"
            },
            {
                "regex": "HTC[ _](?:10[ _]evo|M10f)(?:[);/ ]|$)",
                "model": "10 Evo"
            },
            {
                "regex": "HTC Desire (\\d+) pro 5G(?:[);/ ]|$)",
                "model": "Desire $1 Pro 5G"
            },
            {
                "regex": "HTC Desire (\\d+) pro(?:[);/ ]|$)",
                "model": "Desire $1 Pro"
            },
            {
                "regex": "Desire 10 lifestyle(?:[);/ ]|$)",
                "model": "Desire 10 Life Style"
            },
            {
                "regex": "NexusHD2",
                "model": "HD2"
            },
            {
                "regex": "(?:HTC[_ ])?TATTOO[_ ]A3288",
                "model": "Tattoo A3288"
            },
            {
                "regex": "HTC[ _-]P715a",
                "device": "tablet",
                "model": "P715a"
            },
            {
                "regex": "HTC[ _-]Flyer Build",
                "device": "tablet",
                "model": "Flyer"
            },
            {
                "regex": "HTC[ _-](A10[13]) Plus",
                "device": "tablet",
                "model": "$1 Plus"
            },
            {
                "regex": "HTC[ _-](A10[0123])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "HTC[ _-]Flyer[ _-]([\\w]{1,5})",
                "device": "tablet",
                "model": "Flyer $1"
            },
            {
                "regex": "HTC(?:[ _-])?(?:One[ _-]max|6600LVW|0P3P7)(?:[);/ ]|$)",
                "device": "phablet",
                "model": "One Max"
            },
            {
                "regex": "USCCHTC(\\d+)",
                "model": "$1"
            },
            {
                "regex": "Sprint (ATP.*) Build",
                "device": "tablet",
                "model": "$1 (Sprint)"
            },
            {
                "regex": "Sprint (APA.*) Build",
                "model": "$1 (Sprint)"
            },
            {
                "regex": "Wildfire (E3) lite",
                "model": "Wildfire $1 Lite"
            },
            {
                "regex": "Wildfire (E) star",
                "model": "Wildfire $1 Star"
            },
            {
                "regex": "Wildfire (E2?) plus",
                "model": "Wildfire $1 Plus"
            },
            {
                "regex": "HTC[ _]([^/;]+) [0-9]+(?:\\.[0-9]+)+ Build",
                "model": "$1"
            },
            {
                "regex": "HTC[ _]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "HTC[ _]([a-z0-9]+[ _-]?(?:[a-z0-9_+\\-])*)",
                "model": "$1"
            },
            {
                "regex": "(?:HTC-)?HTC(?:[-/ ])?([a-z0-9\\-_]+)",
                "model": "$1"
            },
            {
                "regex": "HTC;(?: )?([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|[);])",
                "model": "$1 $2"
            },
            {
                "regex": "(Amaze[ _]4G|One ?[XELSV\\+]*) Build",
                "model": "$1"
            },
            {
                "regex": "(ADR[^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(ADR[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "HTV32(?:[);/ ]|$)",
                "model": "10"
            }
        ]
    },
    "Microsoft": {
        "regex": "KIN\\.(One|Two)|RM-(?:1010|1031|106[57]|107[23467]|1089|109[02]|1096|1099|1109|111[348]|1127|1141|115[24]|994)|Microsoft; Lumia|Lumia (?:1530|1320|950|850|650|640|550|535|435)|Corporation/Surface|Surface Duo|Surface 3",
        "device": "smartphone",
        "models": [
            {
                "regex": "KIN\\.(One|Two)",
                "device": "feature phone",
                "model": "Kin $1"
            },
            {
                "regex": "RM-1099|Lumia 430",
                "model": "Lumia 430"
            },
            {
                "regex": "RM-1114|Lumia 435",
                "model": "Lumia 435"
            },
            {
                "regex": "RM-1031|Lumia 532",
                "model": "Lumia 532"
            },
            {
                "regex": "Lumia 535 Dual SIM",
                "model": "Lumia 535 Dual SIM"
            },
            {
                "regex": "RM-109[02]|RM-1089|Lumia 535",
                "model": "Lumia 535"
            },
            {
                "regex": "RM-1141|Lumia 540",
                "model": "Lumia 540"
            },
            {
                "regex": "RM-1127|Lumia 550",
                "model": "Lumia 550"
            },
            {
                "regex": "RM-1010",
                "model": "Lumia 638"
            },
            {
                "regex": "Lumia 640 XL LTE",
                "model": "Lumia 640 XL LTE",
                "device": "phablet"
            },
            {
                "regex": "RM-106[57]|RM-1096|Lumia 640 XL",
                "model": "Lumia 640 XL",
                "device": "phablet"
            },
            {
                "regex": "Lumia 640 LTE Dual SIM",
                "model": "Lumia 640 LTE Dual SIM"
            },
            {
                "regex": "Lumia 640 LTE",
                "model": "Lumia 640 LTE"
            },
            {
                "regex": "Lumia 640 Dual SIM",
                "model": "Lumia 640 Dual SIM"
            },
            {
                "regex": "RM-1109|RM-1113|RM-107[23467]|Lumia 640",
                "model": "Lumia 640"
            },
            {
                "regex": "RM-1154|Lumia 650",
                "model": "Lumia 650"
            },
            {
                "regex": "RM-1152",
                "model": "Lumia 650 SS"
            },
            {
                "regex": "Lumia 850",
                "model": "Lumia 850"
            },
            {
                "regex": "Lumia 950 XL Dual SIM",
                "model": "Lumia 950 XL Dual SIM",
                "device": "phablet"
            },
            {
                "regex": "Lumia 950 XL",
                "model": "Lumia 950 XL",
                "device": "phablet"
            },
            {
                "regex": "Lumia 950 Dual SIM",
                "model": "Lumia 950 Dual SIM"
            },
            {
                "regex": "Lumia 950|RM-1118",
                "model": "Lumia 950"
            },
            {
                "regex": "RM-994|Lumia 1320",
                "model": "Lumia 1320"
            },
            {
                "regex": "Lumia 1530",
                "model": "Lumia 1530"
            },
            {
                "regex": "Surface Book 3",
                "device": "desktop",
                "model": "Surface Book 3"
            },
            {
                "regex": "Surface Pro( [34])?",
                "device": "desktop",
                "model": "Surface Pro$1"
            },
            {
                "regex": "Surface Duo 2",
                "device": "tablet",
                "model": "Surface Duo 2"
            },
            {
                "regex": "Surface Duo",
                "device": "tablet",
                "model": "Surface Duo"
            },
            {
                "regex": "Surface 3",
                "device": "tablet",
                "model": "Surface 3"
            },
            {
                "regex": "Microsoft; Lumia ([^;/)]+)(?:[;/)]|$)",
                "model": "Lumia $1"
            }
        ]
    },
    "Nokia": {
        "regex": "Nokia(?!Browser|Webview|; GT-I8750)|Lumia|Maemo RX|portalmmm/2\\.0 N7|portalmmm/2\\.0 NK|nok[0-9]+|Symbian.*\\s([a-z0-9]+)$|RX-51 N900|TA-[0-9]{4}|N(?:1374|1530|15[01256])DL|ARM; 909",
        "device": "smartphone",
        "models": [
            {
                "regex": "TA-10(07|23|29|35)",
                "model": "2"
            },
            {
                "regex": "TA-10(20|28|32|38)",
                "model": "3"
            },
            {
                "regex": "TA-10(24|27|44|53)",
                "model": "5"
            },
            {
                "regex": "TA-10(00|03|21|25|33|39|54)",
                "model": "6"
            },
            {
                "regex": "TA-1041",
                "model": "7"
            },
            {
                "regex": "TA-10(04|12|52)",
                "model": "8"
            },
            {
                "regex": "Nokia 8 Sirocco",
                "model": "8 Sirocco"
            },
            {
                "regex": "Nokia 7 plus",
                "model": "7 plus"
            },
            {
                "regex": "Nokia 6\\.1 Plus",
                "model": "6.1 Plus"
            },
            {
                "regex": "Nokia 5\\.1 Plus",
                "model": "5.1 Plus"
            },
            {
                "regex": "Nokia 3\\.1 Plus",
                "model": "3.1 Plus"
            },
            {
                "regex": "Nokia 1 Plus",
                "model": "1 Plus"
            },
            {
                "regex": "Nokia 2 V(?:[);/ ]|$)",
                "model": "2 V Tella"
            },
            {
                "regex": "Nokia 8 V 5G UW",
                "model": "8V 5G UW"
            },
            {
                "regex": "Nokia[_ ]Xplus",
                "model": "X+"
            },
            {
                "regex": "N152DL",
                "model": "C100"
            },
            {
                "regex": "N156DL",
                "model": "C110"
            },
            {
                "regex": "N151DL",
                "model": "C200"
            },
            {
                "regex": "N150DL",
                "model": "G100"
            },
            {
                "regex": "N1374DL",
                "model": "G300 5G"
            },
            {
                "regex": "N155DL",
                "model": "G300"
            },
            {
                "regex": "N1530DL",
                "model": "G400 5G"
            },
            {
                "regex": "Nokia ?X2DS",
                "model": "X2 Dual"
            },
            {
                "regex": "RX-51 N900",
                "model": "N900"
            },
            {
                "regex": "(?: )?(Nokia500|nokiaasha500(?:dualsim)?)(?: Build|[_);/])",
                "model": "Asha 500"
            },
            {
                "regex": "Nokia5130c(?:-2)?",
                "model": "5130 XpressMusic"
            },
            {
                "regex": "Nokia5230",
                "model": "Nuron"
            },
            {
                "regex": "Nokia5233",
                "model": "5233"
            },
            {
                "regex": "Nokia5800d-1",
                "model": "5800 XpressMusic"
            },
            {
                "regex": "Nokia6210Navigator",
                "model": "Navigator"
            },
            {
                "regex": "Nokia8800e?",
                "model": "Sapphire Arte"
            },
            {
                "regex": "NOKIA-RH-17",
                "model": "2280"
            },
            {
                "regex": "NOKIA-RH-27",
                "model": "6225"
            },
            {
                "regex": "NOKIA-RH-34",
                "model": "6585"
            },
            {
                "regex": "NOKIA-RH-48",
                "model": "3105"
            },
            {
                "regex": "NOKIA-RM-11",
                "model": "3205"
            },
            {
                "regex": "Nokia808 ?PureView",
                "model": "808 PureView"
            },
            {
                "regex": "Nokia ?([0-9]{4})c(?:-)?",
                "model": "$1 Classic"
            },
            {
                "regex": "Nokia ?([0-9]{4})s(?:-)?",
                "model": "$1 Slide"
            },
            {
                "regex": "Nokia[ _]?([0-9]{4})[ _]?Flip",
                "model": "$1 Flip"
            },
            {
                "regex": "Nokia[ _]?([0-9]{4})[ _]?V[ _]?Flip",
                "model": "$1 V Flip"
            },
            {
                "regex": "Nokia ?([0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "(?: )?Nokia([235][0-9]{2})(?: Build|[_);/])",
                "model": "Asha $1"
            },
            {
                "regex": "Nokia([CEX]-?[0-9]{1,2}i?)-[0-9]{1,2}u?(?: Build|[_);/])",
                "model": "$1"
            },
            {
                "regex": "Nokia;? 520T",
                "model": "Lumia 520T"
            },
            {
                "regex": "RM-91[45]",
                "model": "Lumia 520"
            },
            {
                "regex": "RM-997|Nokia 526",
                "model": "Lumia 526"
            },
            {
                "regex": "RM-846",
                "model": "Lumia 620"
            },
            {
                "regex": "RM-97[68]",
                "model": "Lumia 630"
            },
            {
                "regex": "RM-97[45]",
                "model": "Lumia 635"
            },
            {
                "regex": "RM-1027",
                "model": "Lumia 636"
            },
            {
                "regex": "NOKIA;? 710",
                "model": "Lumia 710"
            },
            {
                "regex": "Nokia;? 720T",
                "model": "Lumia 720T"
            },
            {
                "regex": "RM-885",
                "model": "Lumia 720"
            },
            {
                "regex": "Lumia 730",
                "model": "Lumia 730"
            },
            {
                "regex": "RM-103[89]",
                "model": "Lumia 735"
            },
            {
                "regex": "Nokia;? 800C",
                "model": "Lumia 800C"
            },
            {
                "regex": "Nokia;? 800",
                "model": "Lumia 800"
            },
            {
                "regex": "Nokia 820",
                "model": "Lumia 820"
            },
            {
                "regex": "RM-984",
                "model": "Lumia 830"
            },
            {
                "regex": "Nokia;? 900",
                "model": "Lumia 900"
            },
            {
                "regex": "(RM-82[12]|Nokia;? 920)(?: Build|[_);/])",
                "model": "Lumia 920"
            },
            {
                "regex": "(RM-89[23]|RM-910|Nokia;? 925)(?: Build|[a_);/])",
                "model": "Lumia 925"
            },
            {
                "regex": "Lumia 929",
                "model": "Lumia Icon"
            },
            {
                "regex": "RM-1045",
                "model": "Lumia 930"
            },
            {
                "regex": "(ARM; 909|NOKIA;? 909|NOKIA; id300)(?: Build|[_);/])",
                "model": "Lumia 1020"
            },
            {
                "regex": "NOKIA;? 1520\\.1",
                "model": "Lumia 1520.1"
            },
            {
                "regex": "Nokia T([12]0|21)",
                "device": "tablet",
                "model": "T$1"
            },
            {
                "regex": "Streaming (Stick 800|Box 8000)(?:[);/ ]|$)",
                "device": "tv",
                "model": "Streaming $1"
            },
            {
                "regex": "Nokia ([A-Za-z0-9\\. ]+)(?: Build|\\))",
                "model": "$1"
            },
            {
                "regex": "Nokia(N[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Nokia-([a-z0-9]+)",
                "model": "N$1"
            },
            {
                "regex": "NOKIA; (?!Qt;)([a-z0-9\\- ]+)",
                "model": "$1"
            },
            {
                "regex": "NOKIA[ _]?([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "NOKIA/([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "(Lumia [a-z0-9-]+ XL)",
                "device": "phablet",
                "model": "$1"
            },
            {
                "regex": "(Lumia [a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "Maemo RX-51 ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Maemo RX-34",
                "model": "N800"
            },
            {
                "regex": "NokiaInternal|Nokia-WAP-Toolkit|Nokia-MIT-Browser|Nokia Mobile|Nokia Browser|Nokia/Series",
                "model": ""
            },
            {
                "regex": "portalmmm/2\\.0 (N7[37]|NK[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "nok([0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Symbian.*\\s([a-z0-9]+)$",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "CnM": {
        "regex": "CnM ",
        "device": "tablet",
        "models": [
            {
                "regex": "CnM[ -](?:Touchpad|TP)[ -]([0-9.]+)",
                "model": "Touchpad $1"
            }
        ]
    },
    "RIM": {
        "regex": "BB10;|BlackBerry|rim[0-9]+|PlayBook|STV100-[1234]|STH100-[12]|BBA100-[12]|BBB100-[1234567]|BBD100-[126]|BB[EF]100-[123456789]|BB[CGH]100-1",
        "device": "smartphone",
        "models": [
            {
                "regex": "BBA100-[12]",
                "model": "BlackBerry DTEK60"
            },
            {
                "regex": "BBB100-[1234567]",
                "model": "KEYone"
            },
            {
                "regex": "BBC100-1",
                "model": "Aurora"
            },
            {
                "regex": "BBD100-[126]|BlackBerry Motion",
                "model": "Motion"
            },
            {
                "regex": "BBE100-[123456789]",
                "model": "KEY2 LE"
            },
            {
                "regex": "BBF100-[1234567]|BlackBerry Key2",
                "model": "KEY2"
            },
            {
                "regex": "BBF100-8",
                "model": "KEY2 Silver"
            },
            {
                "regex": "BBF100-9",
                "model": "KEY2 Black"
            },
            {
                "regex": "BBG100-1",
                "model": "Evolve"
            },
            {
                "regex": "BBH100-1|Evolve X",
                "model": "Evolve X"
            },
            {
                "regex": "(?:BlackBerry )?(9000|9790)",
                "model": "Bold $1"
            },
            {
                "regex": "STV100-[1234]",
                "model": "BlackBerry Priv"
            },
            {
                "regex": "STH100-[12]",
                "model": "BlackBerry DTEK50"
            },
            {
                "regex": "BB10; ([a-z0-9\\- ]+)\\)",
                "model": "BlackBerry $1"
            },
            {
                "regex": "PlayBook.+RIM Tablet OS",
                "model": "BlackBerry Playbook",
                "device": "tablet"
            },
            {
                "regex": "BlackBerry(?: )?([a-z0-9]+)",
                "model": "BlackBerry $1"
            },
            {
                "regex": "rim([0-9]+)",
                "model": "BlackBerry $1"
            },
            {
                "regex": "9300",
                "model": "Curve 3G 9300"
            },
            {
                "regex": "(8520|8530|9220|9320|9360)",
                "model": "Curve $1"
            },
            {
                "regex": "9630",
                "model": "Tour 9630"
            },
            {
                "regex": "9720",
                "model": "9720"
            },
            {
                "regex": "(9800|9860)",
                "model": "Torch $1"
            },
            {
                "regex": "BlackBerry",
                "model": "BlackBerry"
            }
        ]
    },
    "Ghia": {
        "regex": "GHIA|QS702|SVEGLIO[ _][QH]1|VECTOR10\\.1|GTKIDS7[BVR]?|(?:A7_WF|GTA7(?:WF|PLUS)|VENUS7|TREO_TAB8G?|VECTOR_SLIM|GTAB718|GTABPND|GTABKIDS|GTVR10S|AXIS7_SLIM|AXIS7_LED|4104116N|GK133M3)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SVEGLIO[ _]([QH]1)",
                "model": "Sveglio $1",
                "device": "smartphone"
            },
            {
                "regex": "QS702",
                "model": "QS702",
                "device": "smartphone"
            },
            {
                "regex": "GHIA_ZEUS_3G",
                "model": "Zeus 3G",
                "device": "smartphone"
            },
            {
                "regex": "GHIA[ _](L1)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "VECTOR_SLIM",
                "model": "Vector Slim"
            },
            {
                "regex": "GHIA_AXIS7P",
                "model": "Axis 7P"
            },
            {
                "regex": "AXIS7_SLIM",
                "model": "Axis 7 Slim"
            },
            {
                "regex": "AXIS7_LED",
                "model": "Axis 7 LED"
            },
            {
                "regex": "GHIA_AXIS7_3G",
                "model": "Axis 7 3G"
            },
            {
                "regex": "GHIA_AXIS7",
                "model": "Axis 7"
            },
            {
                "regex": "A7_WF",
                "model": "A7 WiFi"
            },
            {
                "regex": "VECTOR10\\.1",
                "model": "Vector 10.1\""
            },
            {
                "regex": "GTA7WF",
                "model": "A7 ROJA"
            },
            {
                "regex": "GTA7PLUS",
                "model": "A7 Plus"
            },
            {
                "regex": "TREO_TAB8G",
                "model": "TREO TAB8G"
            },
            {
                "regex": "GTKIDS7[ABVR]?|GTABKIDS",
                "model": "GT KIDS 7"
            },
            {
                "regex": "GTVR10S",
                "model": "Vector 10.1\" Slim"
            },
            {
                "regex": "GTABPND",
                "model": "Kids Panda"
            },
            {
                "regex": "VENUS7",
                "model": "VENUS 7"
            },
            {
                "regex": "4104116N",
                "model": "Any Diez.1"
            },
            {
                "regex": "GHIA[ _]?(47458|VECTOR_3G)",
                "model": "$1"
            },
            {
                "regex": "(GTAB718|GK133M3)",
                "model": "$1"
            }
        ]
    },
    "Palm": {
        "regex": "(?:Pre|Pixi)/(\\d+)\\.(\\d+)|Palm|Treo|Xiino|PVG100(?:E_RU|E)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "((?:Pre|Pixi))/(\\d+\\.\\d+)",
                "model": "$1 $2"
            },
            {
                "regex": "Palm(?:[ -])?((?!OS|Source|scape)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Treo([a-z0-9]+)",
                "model": "Treo $1"
            },
            {
                "regex": "Tungsten",
                "model": "Tungsten"
            },
            {
                "regex": "PVG100",
                "model": "Pepito"
            },
            {
                "regex": "Xiino|Palmscape",
                "model": ""
            }
        ]
    },
    "Compaq": {
        "regex": "(?:CT101|CT1085_32GB)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(CT1085)_32GB",
                "model": "$1"
            },
            {
                "regex": "(CT101)",
                "model": "$1"
            }
        ]
    },
    "HP": {
        "regex": "Hewlett-Packard|HP Engage|HP/HP|HP Chromebook|HP EliteBook|TouchPad/\\d+\\.\\d+|hp-tablet|HP ?iPAQ|webOS.*P160U|HP (?:Pro )?Slate|Slate 21|Slate 10|HP [78]|HP 10 Plus|Compaq [7|8]|HP; [^;/)]+|cm_tenderloin",
        "device": "smartphone",
        "models": [
            {
                "regex": "HP Slate 6 Voice Tab",
                "model": "Slate 6 VoiceTab",
                "device": "phablet"
            },
            {
                "regex": "HP 10 Plus",
                "model": "10 Plus",
                "device": "tablet"
            },
            {
                "regex": "HP ([78][^)/;]*)(?: Build|\\))",
                "model": "Slate $1",
                "device": "tablet"
            },
            {
                "regex": "Slate 21 Pro",
                "model": "Slate 21 Pro",
                "device": "tablet"
            },
            {
                "regex": "Slate 21",
                "model": "Slate 21",
                "device": "tablet"
            },
            {
                "regex": "Slate 10 HD",
                "model": "Slate 10 HD",
                "device": "tablet"
            },
            {
                "regex": "cm_tenderloin",
                "model": "Touch 9.7\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "Compaq 8200 Elite SFF PC",
                "device": "desktop",
                "model": "Compaq 8200 Elite SFF PC"
            },
            {
                "regex": "Compaq ([78][^/;]*) Build",
                "model": "Compaq $1",
                "device": "tablet"
            },
            {
                "regex": "HP Pro Slate 8",
                "model": "Pro Slate 8",
                "device": "tablet"
            },
            {
                "regex": "HP Slate ?(.+) Build",
                "model": "Slate $1",
                "device": "tablet"
            },
            {
                "regex": "HP Slate ?([0-9]+)",
                "model": "Slate $1",
                "device": "tablet"
            },
            {
                "regex": "TouchPad/(\\d+\\.\\d+)|hp-tablet",
                "model": "TouchPad",
                "device": "tablet"
            },
            {
                "regex": "HP; ([^;/)]+)",
                "model": "$1"
            },
            {
                "regex": "HP ?iPAQ ?([a-z0-9]+)",
                "model": "iPAQ $1"
            },
            {
                "regex": "webOS.*(P160U)",
                "model": "Veer"
            },
            {
                "regex": "HP ProBook (6560b)",
                "device": "desktop",
                "model": "ProBook $1"
            },
            {
                "regex": "Engage One Pro AIO",
                "device": "desktop",
                "model": "Engage One Pro AIO"
            },
            {
                "regex": "Chromebook (11 G5|x360 11 G1 EE|13 G1|x2)",
                "device": "desktop",
                "model": "Chromebook $1"
            },
            {
                "regex": "HP EliteBook (820 G2|8470p)",
                "device": "desktop",
                "model": "EliteBook $1"
            },
            {
                "regex": "Z240 Tower Workstation",
                "device": "desktop",
                "model": "Z240 Tower Workstation"
            }
        ]
    },
    "TiPhone": {
        "regex": "TiPhone ?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "TiVo": {
        "regex": "TIVO[ ,-]",
        "device": "tv",
        "models": [
            {
                "regex": "STREAM 4K",
                "model": "Stream 4K"
            },
            {
                "regex": "TCD8F6000",
                "model": "TCD8F6000"
            },
            {
                "regex": "(?:TiVo|VirginMedia), (?:OnDemand_)?([a-z0-9]+), (?:wired|wireless)",
                "model": "$1"
            },
            {
                "regex": "TiVo-([a-z0-9]+)-([a-z0-9]+)",
                "model": "$2"
            }
        ]
    },
    "Apple": {
        "regex": "(?:iTunes-)?Apple[ _]?TV|Apple/|(?:Apple-|iTunes-)?(?<!like )(?:iPad|iPhone)(?!\\: Build/)|iPh(?:[0-9]|1[0-7]),[0-9]|CFNetwork|HomePod|AirPlay|AirPodcasts/|Watch ?OS|Watch1,[12]|MDCR_i?Mac|ICRU_iP(?:ad|hone)|Mac OS X[,;]|OSX/|macOS,|for Apple Watch",
        "models": [
            {
                "regex": "(?:HomePod|AirPodcasts/)",
                "device": "smart speaker",
                "model": "HomePod"
            },
            {
                "regex": "AirPlay",
                "device": "smart speaker",
                "model": ""
            },
            {
                "regex": "Watch1,1",
                "device": "wearable",
                "model": "Watch 38mm"
            },
            {
                "regex": "Watch1,2",
                "device": "wearable",
                "model": "Watch 42mm"
            },
            {
                "regex": "Watch2,6",
                "device": "wearable",
                "model": "Watch Series 1 38mm"
            },
            {
                "regex": "Watch2,7",
                "device": "wearable",
                "model": "Watch Series 1 42mm"
            },
            {
                "regex": "Watch2,3",
                "device": "wearable",
                "model": "Watch Series 2 38mm"
            },
            {
                "regex": "Watch2,4",
                "device": "wearable",
                "model": "Watch Series 2 42mm"
            },
            {
                "regex": "Watch3,[13]",
                "device": "wearable",
                "model": "Watch Series 3 38mm"
            },
            {
                "regex": "Watch3,[24]",
                "device": "wearable",
                "model": "Watch Series 3 42mm"
            },
            {
                "regex": "Watch5,(?:9|11)",
                "device": "wearable",
                "model": "Watch SE 40mm"
            },
            {
                "regex": "Watch5,1[02]",
                "device": "wearable",
                "model": "Watch SE 44mm"
            },
            {
                "regex": "Watch6,1[02]",
                "device": "wearable",
                "model": "Watch SE (Gen 2) 40mm"
            },
            {
                "regex": "Watch6,1[13]",
                "device": "wearable",
                "model": "Watch SE (Gen 2) 44mm"
            },
            {
                "regex": "Watch6,1[46]",
                "device": "wearable",
                "model": "Watch Series 8 41mm"
            },
            {
                "regex": "Watch6,1[57]",
                "device": "wearable",
                "model": "Watch Series 8 45mm"
            },
            {
                "regex": "Watch6,18",
                "device": "wearable",
                "model": "Watch Ultra"
            },
            {
                "regex": "Watch7,5",
                "device": "wearable",
                "model": "Watch Ultra 2"
            },
            {
                "regex": "Watch([456]),[13]",
                "device": "wearable",
                "model": "Watch Series $1 40mm"
            },
            {
                "regex": "Watch([456]),[24]",
                "device": "wearable",
                "model": "Watch Series $1 44mm"
            },
            {
                "regex": "Watch6,[68]",
                "device": "wearable",
                "model": "Watch Series 7 41mm"
            },
            {
                "regex": "Watch6,[79]",
                "device": "wearable",
                "model": "Watch Series 7 45mm"
            },
            {
                "regex": "Watch7,8",
                "device": "wearable",
                "model": "Watch Series 10 42mm"
            },
            {
                "regex": "Watch7,9",
                "device": "wearable",
                "model": "Watch Series 10 46mm"
            },
            {
                "regex": "Watch7,10",
                "device": "wearable",
                "model": "Watch Series 10 42mm"
            },
            {
                "regex": "Watch7,11",
                "device": "wearable",
                "model": "Watch Series 10 46mm"
            },
            {
                "regex": "Watch7,1",
                "device": "wearable",
                "model": "Watch Series 9 41mm"
            },
            {
                "regex": "Watch7,3",
                "device": "wearable",
                "model": "Watch Series 9 41mm"
            },
            {
                "regex": "Watch7,2",
                "device": "wearable",
                "model": "Watch Series 9 45mm"
            },
            {
                "regex": "Watch7,4",
                "device": "wearable",
                "model": "Watch Series 9 45mm"
            },
            {
                "regex": "(:?Apple Watch|watchOS)",
                "device": "wearable",
                "model": "Watch"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacPro1(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Pro (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacPro2(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Pro (2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacPro3(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Pro (2008)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacPro4(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Pro (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacPro5(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Pro (2010-2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)8",
                "device": "desktop",
                "model": "Mac Pro (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac5(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac5(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 17\" (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac6(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 24\" (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac7(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac (2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac8(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac (2008)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac9(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac10(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac11(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 27\" (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac11(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 21.5\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac11(?:%2C|,)3",
                "device": "desktop",
                "model": "iMac 27\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac12(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 21.5\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac12(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 27\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac13(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 21.5\" (2012-2013)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac13(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 27\" (2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac14(?:%2C|,)[13]",
                "device": "desktop",
                "model": "iMac 21.5\" (2013)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac14(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 27\" (2013)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac14(?:%2C|,)4",
                "device": "desktop",
                "model": "iMac 21.5\" (2014)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac17(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 27\" (2015)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac18(?:%2C|,)[12]",
                "device": "desktop",
                "model": "iMac 21.5\" (2017)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac18(?:%2C|,)3",
                "device": "desktop",
                "model": "iMac 27\" (2017)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac19(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac 27\" (2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac19(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac 21.5\" (2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac20(?:%2C|,)[12]",
                "device": "desktop",
                "model": "iMac 27\" (2020)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMac21(?:%2C|,)[12]",
                "device": "desktop",
                "model": "iMac 24\" (2021)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac15(?:%2C|,)[45]",
                "device": "desktop",
                "model": "iMac 24\" (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iMacPro1(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac Pro 27\" (2017)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook1(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook2(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2006-2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook3(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook[45](?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2008)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook5(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook 13\" (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook6(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook7(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 13\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook8(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 12\" (2015)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBook9(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook 12\" (2016)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir1(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2008)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir2(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir3(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir3(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir4(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir4(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir5(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir5(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir6(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2013-2014)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir6(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2013-2014)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir7(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 11\" (2015)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir7(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2015-2017)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir8(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2018)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir8(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir9(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2020)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookAir10(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Air 13\" (2020)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Air 13\" (2022)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)15",
                "device": "desktop",
                "model": "MacBook Air 15\" (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac15(?:%2C|,)12",
                "device": "desktop",
                "model": "MacBook Air 13\" (2024)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro1(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro1(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro2(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro2(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro[34](?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro (2008)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro5(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2008)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro5(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro5(?:%2C|,)[34]",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro5(?:%2C|,)5",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro6(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro6(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro7(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro8(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro8(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro8(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 17\" (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro9(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro9(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro10(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2012-2013)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro10(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2012-2013)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro11(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2013-2014)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro11(?:%2C|,)[23]",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2013-2014)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro11(?:%2C|,)[45]",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2015)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro12(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2015)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro13(?:%2C|,)[12]",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2016)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro13(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2016)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro14(?:%2C|,)[12]",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2017)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro14(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2017)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro15(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2018-2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro15(?:%2C|,)2",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2018-2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro15(?:%2C|,)3",
                "device": "desktop",
                "model": "MacBook Pro 15\" (2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro15(?:%2C|,)4",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro16(?:%2C|,)[14]",
                "device": "desktop",
                "model": "MacBook Pro 16\" (2019)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro16(?:%2C|,)[23]",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2020)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro17(?:%2C|,)1",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2020)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)7",
                "device": "desktop",
                "model": "MacBook Pro 13\" (2022)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro18(?:%2C|,)[12]",
                "device": "desktop",
                "model": "MacBook Pro 16\" (2021)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)(?:6|10)",
                "device": "desktop",
                "model": "MacBook Pro 16\" (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac15(?:%2C|,)(?:[79]|11)",
                "device": "desktop",
                "model": "MacBook Pro 16\" (2023-2024)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?MacBookPro18(?:%2C|,)[34]",
                "device": "desktop",
                "model": "MacBook Pro 14\" (2021)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)[59]",
                "device": "desktop",
                "model": "MacBook Pro 14\" (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac15(?:%2C|,)(?:[368]|10)",
                "device": "desktop",
                "model": "MacBook Pro 14\" (2023-2024)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini1(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2006)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini2(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2007)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini3(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2009)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini4(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2010)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini5(?:%2C|,)[123]",
                "device": "desktop",
                "model": "Mac Mini (2011)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini6(?:%2C|,)[12]",
                "device": "desktop",
                "model": "Mac Mini (2012)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini7(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2014)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini8(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2018)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Macmini9(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini (2020)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)(?:3|12)",
                "device": "desktop",
                "model": "Mac mini (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerMac7(?:%2C|,)2",
                "device": "desktop",
                "model": "Power Macintosh G5 (2003)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerMac7(?:%2C|,)3",
                "device": "desktop",
                "model": "Power Macintosh G5 (2004-2005)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerMac8(?:%2C|,)2",
                "device": "desktop",
                "model": "iMac G5 (2005)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerMac10(?:%2C|,)1",
                "device": "desktop",
                "model": "Mac Mini G4 (2005)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerMac12(?:%2C|,)1",
                "device": "desktop",
                "model": "iMac G5 (2005)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerBook5(?:%2C|,)6",
                "device": "desktop",
                "model": "PowerBook G4 (2005)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?PowerBook6(?:%2C|,)7",
                "device": "desktop",
                "model": "iBook G4 (2005)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac13(?:%2C|,)[12]",
                "device": "desktop",
                "model": "Mac Studio (2022)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?Mac14(?:%2C|,)1[34]",
                "device": "desktop",
                "model": "Mac Studio (2023)"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?1[C,_]1",
                "model": "iPhone",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?1[C,_]2",
                "model": "iPhone 3G",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?2[C,_]1| 3GS\\)$",
                "model": "iPhone 3GS",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?3[C,_][123]",
                "model": "iPhone 4",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?4[C,_]1|1C2%254enohPi| 4S\\)$",
                "model": "iPhone 4S",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?5[C,_][12]| 5\\)$",
                "model": "iPhone 5",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?5[C,_][34]",
                "model": "iPhone 5C",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?6[C,_][12]|(?:iPhone[ _]?5S| 5S)(?:[);/ ]|$)",
                "model": "iPhone 5S",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?7[C,_]1|1C2%257enohPi|(?:iPhone[ _]?6Plus| 6PLUS)(?:[);/ ]|$)",
                "model": "iPhone 6 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?7[C,_]2|(?:iPhone[ _]?6| 6)(?:[);/ ]|$)",
                "model": "iPhone 6",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?8[C,_]1|(?:iPhone[ /]?6s| 6S)(?:[);/ ]|$)",
                "model": "iPhone 6s",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?8[C,_]2| 6SPLUS\\)$",
                "model": "iPhone 6s Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?8[C,_]4|(?:iPhoneSE| SE)(?:[);/ ]|$)",
                "model": "iPhone SE",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?9[C,_][24]|(?:iPhone[ _]?7Plus| 7PLUS)(?:[);/ ]|$)",
                "model": "iPhone 7 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?9[C,_][13]|(?:iPhone[ _]?7 ?| 7)(?:[);/ ]|$)",
                "model": "iPhone 7",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?10[C,_][25]|(?:iPhone[ _]?8Plus| 8PLUS)(?:[);/ ]|$)",
                "model": "iPhone 8 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?10[C,_][14]|(?:iPhone[ _]?8| 8)(?:[);/ ]|$)",
                "model": "iPhone 8",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?11[C,_][46]|(?:iPhone[ _]?XS[ _]?Max| XSMAX)(?:[);/ ]|$)",
                "model": "iPhone XS Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?11[C,_]2|(?:iPhone[ _]?XS| XS)(?:[);/ ]|$)",
                "model": "iPhone XS",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?11[C,_]8|(?:iPhone[ _]?XR| XR)(?:[);/ ]|$)",
                "model": "iPhone XR",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?10[C,_][36]|(?:iPhone[ _]?X| X)(?:[);/ ]|$)",
                "model": "iPhone X",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?12[C,_]5|(?:iPhone[ _]?11[ _]?Pro[ _]?Max| 11PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 11 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?12[C,_]3|(?:iPhone[ _]?11[ _]?Pro| 11PRO)(?:[);/ ]|$)",
                "model": "iPhone 11 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?12[C,_]1|(?:iPhone[ _]?11| 11)(?:[);/ ]|$)",
                "model": "iPhone 11",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?12[C,_]8|(?:iPhone SE 2|iPhoneSE2ndGen| SE2)(?:[);/ ]|$)",
                "model": "iPhone SE (2020)",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?13[C,_]1|(?:iPhone12mini| 12MINI)(?:[);/ ]|$)",
                "model": "iPhone 12 Mini",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?13[C,_]4|(?:iPhone[ _]?12[ _]?Pro[ _]?Max| 12PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 12 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?13[C,_]3|(?:iPhone[ _]?12[ _]?Pro| 12PRO)(?:[);/ ]|$)",
                "model": "iPhone 12 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?13[C,_]2|(?:iPhone[ _]?12| 12)(?:[);/ ]|$)",
                "model": "iPhone 12",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]3|(?:iPhone[ _]?13[ _]?Pro[ _]?Max| 13PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 13 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]2|(?:iPhone[ _]?13[ _]?Pro| 13PRO)(?:[);/ ]|$)",
                "model": "iPhone 13 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]4|(?:iPhone[ _]?13[ _]?mini| 13MINI)(?:[);/ ]|$)",
                "model": "iPhone 13 Mini",
                "device": "smartphone"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]5|(?:iPhone[ _]?13| 13)(?:[);/ ]|$)",
                "model": "iPhone 13",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]6|(?:iPhoneSE3ndGen| SE3)(?:[);/ ]|$)",
                "model": "iPhone SE (2022)",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?15[C,_]3|(?:iPhone[ _]?14[ _]?Pro[ _]?Max| 14PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 14 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?15[C,_]2|(?:iPhone[ _]?14[ _]?Pro| 14PRO)(?:[);/ ]|$)",
                "model": "iPhone 14 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]8|(?:iPhone[ _]?14[ _]?Plus| 14PLUS)(?:[);/ ]|$)",
                "model": "iPhone 14 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?14[C,_]7|(?:iPhone[ _]?14| 14)(?:[);/ ]|$)",
                "model": "iPhone 14",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?16[C,_]2|(?:iPhone[ _]?15[ _]?Pro[ _]?Max| 15PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 15 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?16[C,_]1|(?:iPhone[ _]?15[ _]?Pro| 15PRO)(?:[);/ ]|$)",
                "model": "iPhone 15 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?15[C,_]5|(?:iPhone[ _]?15[ _]?Plus| 15PLUS)(?:[);/ ]|$)",
                "model": "iPhone 15 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?15[C,_]4|(?:iPhone[ _]?15| 15)(?:[);/ ]|$)",
                "model": "iPhone 15",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?17[C,_]2|(?:iPhone[ _]?16[ _]?Pro[ _]?Max| 16PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 16 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?17[C,_]1|(?:iPhone[ _]?16[ _]?Pro| 16PRO)(?:[);/ ]|$)",
                "model": "iPhone 16 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?17[C,_]4|(?:iPhone[ _]?16[ _]?Plus| 16PLUS)(?:[);/ ]|$)",
                "model": "iPhone 16 Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?17[C,_]5|(?:iPhone[ _]?16e| 16e)(?:[);/ ]|$)",
                "model": "iPhone 16e",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?17[C,_]3|(?:iPhone[ _]?16| 16)(?:[);/ ]|$)",
                "model": "iPhone 16",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?18[C,_]2|(?:iPhone[ _]?17[ _]?Pro[ _]?Max| 17PROMAX)(?:[);/ ]|$)",
                "model": "iPhone 17 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?18[C,_]1|(?:iPhone[ _]?17[ _]?Pro| 17PRO)(?:[);/ ]|$)",
                "model": "iPhone 17 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?18[C,_]3|(?:iPhone[ _]?17| 17)(?:[);/ ]|$)",
                "model": "iPhone 17",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPh(?:one)?18[C,_]4|(?:iPhone[ _]?17[ _]?Air| 17AIR)(?:[);/ ]|$)",
                "model": "iPhone Air",
                "device": "phablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad1[C,_]1",
                "model": "iPad",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad2[C,_][1-4]",
                "model": "iPad 2",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad2[C,_][567]",
                "model": "iPad Mini",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad3[C,_][123]",
                "model": "iPad 3",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad3[C,_][456]",
                "model": "iPad 4",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad4[C,_][123]",
                "model": "iPad Air",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad4[C,_][456]",
                "model": "iPad Mini 2",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad4[C,_][789]",
                "model": "iPad Mini 3",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad5[C,_][12]",
                "model": "iPad Mini 4",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad5[C,_][34]|(?:iPad Air 2 \\(WiFi\\))(?:[);/ ]|$)",
                "model": "iPad Air 2",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad6[C,_][34]",
                "model": "iPad Pro 9.7",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad6[C,_][78]",
                "model": "iPad Pro 12.9",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad6[C,_](?:11|12)",
                "model": "iPad 5 9.7",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad7[C,_][12](?:[\\]);/ ]|$)",
                "model": "iPad Pro 2 12.9",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad7[C,_][34](?:[\\]);/ ]|$)",
                "model": "iPad Pro 10.5",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad7[C,_][56]|(?:iPad 6 \\(WiFi\\))(?:[);/ ]|$)",
                "model": "iPad 6 9.7",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad7[C,_](?:11|12)(?:[\\]);/ ]|$)",
                "model": "iPad 7 10.2",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad8[C,_](?:9|10)",
                "model": "iPad Pro 2 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad8[C,_]1[12]",
                "model": "iPad Pro 4 12.9\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad8[C,_][12]",
                "model": "iPad Pro 3 11.0 WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad8[C,_][34]|(?:iPad Pro 11-inch 3rd-gen \\(Cellular\\))(?:[);/ ]|$)",
                "model": "iPad Pro 3 11.0",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad8[C,_][5-8]",
                "model": "iPad Pro 3 12.9",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad11[C,_][12]",
                "model": "iPad Mini 5",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad11[C,_][34]",
                "model": "iPad Air 3",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad11[C,_][67]",
                "model": "iPad 8 10.2\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad12[C,_]1|(?:iPad 9th Gen \\(WiFi\\))(?:[);/ ]|$)",
                "model": "iPad 9 10.2\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad12[C,_]2|(?:iPad 9th Gen \\(Cellular\\))(?:[);/ ]|$)",
                "model": "iPad 9 10.2\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]4",
                "model": "iPad Pro 3 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_][5-7]",
                "model": "iPad Pro 3 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]8",
                "model": "iPad Pro 5 12.9\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_](?:9|10|11)",
                "model": "iPad Pro 5 12.9\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]16",
                "model": "iPad Air 5 WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]17",
                "model": "iPad Air 5",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]18",
                "model": "iPad 10 10.9\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]19",
                "model": "iPad 10 10.9\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]1|(?:iPad Air 4th Gen \\(WiFi\\))(?:[);/ ]|$)",
                "model": "iPad Air 4 WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad13[C,_]2",
                "model": "iPad Air 4",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]10",
                "model": "iPad Air 7 13\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]11",
                "model": "iPad Air 7 13\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]1|(?:iPad mini 6th Gen \\(WiFi\\))(?:[);/ ]|$)",
                "model": "iPad Mini 6 WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]2",
                "model": "iPad Mini 6",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]3",
                "model": "iPad Pro 4 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]4|(?:iPad Pro \\(11-inch\\) \\(4th generation\\))(?:[);/ ]|$)",
                "model": "iPad Pro 4 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]5",
                "model": "iPad Pro 6 12.9\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]6",
                "model": "iPad Pro 6 12.9\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]8",
                "model": "iPad Air 6 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad14[C,_]9",
                "model": "iPad Air 6 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad15[C,_]3",
                "model": "iPad Air 7 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad15[C,_]4",
                "model": "iPad Air 7 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad15[C,_]5",
                "model": "iPad Air 7 13\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad15[C,_]6",
                "model": "iPad Air 7 13\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad15[C,_]7",
                "model": "iPad 11 10.9\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad15[C,_]8",
                "model": "iPad 11 10.9\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad16[C,_]1",
                "model": "iPad Mini 7 WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad16[C,_]2",
                "model": "iPad Mini 7",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad16[C,_]3|(?:iPad Pro 11 inch 5th Gen \\(WiFi\\))(?:[);/ ]|$)",
                "model": "iPad Pro 5 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad16[C,_]4",
                "model": "iPad Pro 5 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad16[C,_]5",
                "model": "iPad Pro 7 13\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad16[C,_]6",
                "model": "iPad Pro 7 13\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad17[C,_]1",
                "model": "iPad Pro 6 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad17[C,_]2",
                "model": "iPad Pro 6 11\"",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad17[C,_]3",
                "model": "iPad Pro 2 13\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad17[C,_]4",
                "model": "iPad Pro 2 13\"",
                "device": "tablet"
            },
            {
                "regex": "Apple-?TV2[C,_]1",
                "model": "Apple TV 2",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV3[C,_][12]",
                "model": "Apple TV 3",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV5[C,_]3|Apple TV 4",
                "model": "Apple TV 4",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV6[C,_]2",
                "model": "Apple TV 4K",
                "device": "tv"
            },
            {
                "regex": "Apple-?TV11[C,_]1",
                "model": "Apple TV 4K (2021)",
                "device": "tv"
            },
            {
                "regex": "(?:iTunes-)?Apple[ _]?TV",
                "model": "Apple TV",
                "device": "tv"
            },
            {
                "regex": "iTunes-iPad/[0-9]+(?:\\.[0-9]+)* \\(([^;]+);",
                "model": "iPad $1",
                "device": "tablet"
            },
            {
                "regex": "(?:MDCR_|ICRU_|Apple-)?iPad",
                "model": "iPad",
                "device": "tablet"
            },
            {
                "regex": "iTunes-iPhone/[0-9]+(?:\\.[0-9]+)* \\(([^;]+);",
                "model": "iPhone $1",
                "device": "smartphone"
            },
            {
                "regex": "(?:Apple-)?iPhone ?(3GS?|4S?|5[CS]?|6(:? Plus)?)?",
                "model": "iPhone $1",
                "device": "smartphone"
            }
        ]
    },
    "MicroMax": {
        "regex": "(?:MicroMax[ \\-\\_]?[a-z0-9]+|Q327)|4560MMX|P70221|(?:YU(?:5012|5040|5530)|AQ5001(?: Canvas Power)?|Android 4(?:[\\d.]*);(?: [\\w-]+;)? A240|Android 8(?:[\\d.]*);(?: [\\w-]+;)? B5Pro|Bharat 5|N8216|N8301|IN_2[bc]|IN_Note1|ione note|E7446|E7533|E6523)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AQ5001 Canvas Power",
                "model": "Canvas Power"
            },
            {
                "regex": "AQ5001",
                "model": "Canvas Juice 2"
            },
            {
                "regex": "A240(?:[);/ ]|$)",
                "model": "Canvas Doodle 2"
            },
            {
                "regex": "A107(?:[);/ ]|$)",
                "model": "Canvas Fire 4"
            },
            {
                "regex": "Q465(?:[);/ ]|$)",
                "model": "Canvas Juice 4"
            },
            {
                "regex": "E451(?:[);/ ]|$)",
                "model": "Canvas Pulse"
            },
            {
                "regex": "4560MMX(?:[);/ ]|$)",
                "model": "4560MMX"
            },
            {
                "regex": "IN_2b(?:[);/ ]|$)",
                "model": "IN 2B"
            },
            {
                "regex": "IN_2c(?:[);/ ]|$)",
                "model": "IN 2C"
            },
            {
                "regex": "E6523(?:[);/ ]|$)",
                "model": "IN 1B"
            },
            {
                "regex": "AQ4502(?:[);/ ]|$)",
                "model": "Canvas A1"
            },
            {
                "regex": "E453(?:[);/ ]|$)",
                "model": "Canvas Evok Note"
            },
            {
                "regex": "E481(?:[);/ ]|$)",
                "model": "Canvas 5"
            },
            {
                "regex": "Q462(?:[);/ ]|$)",
                "model": "Canvas 5 Lite"
            },
            {
                "regex": "P70221(?:[);/ ]|$)",
                "model": "Canvas Tab",
                "device": "tablet"
            },
            {
                "regex": "Q(3[25]7|30[13]|326|354|338|3[03]01)(?:[);/ ]|$)",
                "model": "Bolt Q$1"
            },
            {
                "regex": "Q417",
                "model": "Canvas Mega"
            },
            {
                "regex": "Q350R",
                "model": "Canvas Magnus 2 Plus"
            },
            {
                "regex": "Q480",
                "model": "Canvas Space 2"
            },
            {
                "regex": "Q380",
                "model": "Canvas Spark"
            },
            {
                "regex": "Q351",
                "model": "Canvas Spark 2 Pro"
            },
            {
                "regex": "Q350",
                "model": "Canvas Spark 2 Plus"
            },
            {
                "regex": "Q349",
                "model": "Canvas Selfie 4"
            },
            {
                "regex": "Q402\\+",
                "model": "Bolt Pace"
            },
            {
                "regex": "Q409",
                "model": "Spark 4G (2017)"
            },
            {
                "regex": "Q415",
                "model": "Canvas Pace"
            },
            {
                "regex": "Q340",
                "model": "Selfie 2"
            },
            {
                "regex": "YU5040(?:[);/ ]|$)",
                "model": "YU Yureka YU5040"
            },
            {
                "regex": "YU5012(?:[);/ ]|$)",
                "model": "Yunique 2 Plus"
            },
            {
                "regex": "YU5530(?:[);/ ]|$)",
                "model": "YU Yureka S YU5530"
            },
            {
                "regex": "Q424",
                "model": "Bolt Selfie"
            },
            {
                "regex": "Q4101",
                "model": "Bolt Warrior 1 Plus"
            },
            {
                "regex": "Q352",
                "model": "Bolt Supreme 4"
            },
            {
                "regex": "(?:Micromax_)?(Q333|S302|Q324)",
                "model": "Bolt $1"
            },
            {
                "regex": "Q306",
                "model": "Bolt Prime 3G"
            },
            {
                "regex": "Q402 ?Plus",
                "model": "Bharat 2 Plus"
            },
            {
                "regex": "Q426",
                "model": "Canvas Mega 2"
            },
            {
                "regex": "N8216",
                "model": "Infinity N11"
            },
            {
                "regex": "N8301",
                "model": "Infinity N12"
            },
            {
                "regex": "Micromax[_ ]HS3(?:[);/ ]|$)",
                "model": "Canvas Infinity Pro"
            },
            {
                "regex": "Micromax[_ ]HS2(?:[);/ ]|$)",
                "model": "Canvas Infinity"
            },
            {
                "regex": "Micromax[_ ]HS1(?:[);/ ]|$)",
                "model": "Canvas Infinity Lite"
            },
            {
                "regex": "Q440Plus(?:[);/ ]|$)",
                "model": "Q440 Plus"
            },
            {
                "regex": "Micromax[_ ]Q353P(?:[);/ ]|$)",
                "model": "Q353 Plus"
            },
            {
                "regex": "Q452(?:[);/ ]|$)",
                "model": "Spark 4G Prime"
            },
            {
                "regex": "Q4601(?:[);/ ]|$)",
                "model": "Selfie 2 Note"
            },
            {
                "regex": "Q421(?:[);/ ]|$)",
                "model": "Canvas Magnus HD"
            },
            {
                "regex": "E313(?:[);/ ]|$)",
                "model": "Canvas Xpress 2"
            },
            {
                "regex": "Q413(?:[);/ ]|$)",
                "model": "Canvas Xpress"
            },
            {
                "regex": "Q4251(?:[);/ ]|$)",
                "model": "Vdeo 4"
            },
            {
                "regex": "Micromax C1A(?:[);/ ]|$)",
                "model": "Canvas 1 (2018)"
            },
            {
                "regex": "C2APLS(?:[);/ ]|$)",
                "model": "Canvas 2 Plus"
            },
            {
                "regex": "Bharat[ _](\\d)[ _]Pro(?:[);/ ]|$)",
                "model": "Bharat $1 Pro"
            },
            {
                "regex": "Bharat[ _](\\d)[ _]Plus(?:[);/ ]|$)",
                "model": "Bharat $1 Plus"
            },
            {
                "regex": "Bharat (\\d)(?:[);/ ]|$)",
                "model": "Bharat $1"
            },
            {
                "regex": "ione note(?:[);/ ]|$)",
                "model": "iOne Note"
            },
            {
                "regex": "IN_Note1(?:[);/ ]|$)",
                "model": "IN Note 1"
            },
            {
                "regex": "E7446(?:[);/ ]|$)",
                "model": "IN Note 2"
            },
            {
                "regex": "E7533(?:[);/ ]|$)",
                "model": "IN 1b"
            },
            {
                "regex": "B5Pro(?:[);/ ]|$)",
                "model": "B5 Pro"
            },
            {
                "regex": "MicroMax(?:[ _-])?(P681|P802)(?:[);/ ]|$)",
                "model": "Canvas Tab $1",
                "device": "tablet"
            },
            {
                "regex": "MicroMax(?:[ _-])?(X291|X246|X252|X458|X312)",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "MicroMax(?:[ _-])?(P[a-z0-9]+)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "MicroMax(?:[ _-])?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "3Q": {
        "regex": "AC0731B|AC1024C|AC7803C|BC9710AM|EL72B|LC0720C|LC0723B|LC0725B|LC0804B|LC0808B|LC0809B|LC0810C|LC0816C|LC0901D|LC1016C|MT0724B|MT0729[BD]|MT0811B|OC1020A|RC07(?:09B|10B|18C|19H|2[16]B|22C|27H|34H|43H)|RC0817C|RC1018C|RC1019G|RC1025F|RC1301C|RC780[24]F|RC9711B|RC9712C|RC9716B|RC9717B|RC9724C|RC9726C|RC9727F|RC9730C|RC9731C|TS0807B|TS1013B|VM0711A|VM1017A|RC0813C|QS9719D|QS9718C|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT7801C|TS9708B|AC0732C|MT0739D|MT0812E|(?:3Q_)?ER71B",
        "device": "tablet",
        "models": [
            {
                "regex": "MT0724B|LC0901D|LC0816C|LC0810C|LC0809B|LC0808B|LC0804B|LC0725B|LC0723B",
                "model": "Qoo! P-Pad"
            },
            {
                "regex": "VM1017A|TS1013B|TS0807B|RC9731C|RC9730C|RC9727F|RC9726C|RC9724C|RC9717B|RC9716B|RC9712C|RC9711B|RC1301C|RC1025F|RC1019G|RC1018C|RC0817C|RC0813C|RC0743H|RC0734H|RC0726B|RC0722C|RC0721B|RC0719H|RC0718C|RC0710B|RC0709B|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT0811B|MT0739D|MT0729[BD]|LC1016C|LC0720C|BC9710AM|AC1024C|AC0731B",
                "model": "Qoo! Q-Pad"
            },
            {
                "regex": "MT7801C|QS9718C|QS9719D|VM0711A|OC1020A",
                "model": "Qoo! Surf"
            },
            {
                "regex": "TS9708B",
                "model": "Surf TS1009B"
            },
            {
                "regex": "AC7803C|AC0732C|RC0727H",
                "model": "Qoo! Lite"
            },
            {
                "regex": "MT0812E|RC7802F",
                "model": "Qoo! Meta"
            },
            {
                "regex": "EL72B|(?:3Q_)?ER71B",
                "model": "Qoo! Q-Book"
            },
            {
                "regex": "(RC7804F)",
                "model": "Qoo! Glaze"
            }
        ]
    },
    "4Good": {
        "regex": "4Good[ _]|S450m [43]G|S555m 4G|S501m 3G|T700i_3G|People (?:G503|G410|GT300)|Light (?:A10[34]|B100|AT300)|Light_AT200",
        "device": "smartphone",
        "models": [
            {
                "regex": "(T700i|T100m|T70[34]m)[_ ]?3G",
                "model": "$1 3G",
                "device": "tablet"
            },
            {
                "regex": "Light[_ ](AT[23]00)",
                "model": "Light $1",
                "device": "tablet"
            },
            {
                "regex": "People (GT300|AT100)",
                "model": "People $1",
                "device": "tablet"
            },
            {
                "regex": "S555m[_ ]4G",
                "model": "People"
            },
            {
                "regex": "(S(?:450m|501m)[_ ][43]G|Light (?:A10[34]|B100)|People (?:G503|G410))",
                "model": "$1"
            },
            {
                "regex": "KIDS S45",
                "model": "Kids S45"
            },
            {
                "regex": "4Good[ _]([^);/]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Acteck": {
        "regex": "BLECK|AT723C(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "AT723C",
                "model": "Aikun AT723C"
            },
            {
                "regex": "BLECK",
                "model": "Bleck"
            }
        ]
    },
    "Alba": {
        "regex": "Alba ?(?:7Q|10Q|57|4|10 TABLET|(?:[78]|10)(?:Nou|Pie))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alba 57",
                "model": "5.7"
            },
            {
                "regex": "Alba (4)",
                "model": "$1"
            },
            {
                "regex": "10 TABLET",
                "device": "tablet",
                "model": "10 Tablet"
            },
            {
                "regex": "Alba((?:[78]|10)(?:Nou|Pie)|7Q|10Q)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "All Star": {
        "regex": "(ASSTV[A-Z0-9]+)",
        "device": "tv",
        "model": "$1"
    },
    "AllCall": {
        "regex": "AllCall_|Heat[34]|SHINE 12T?|(?:Rio_X|S5500|HERO_20_PRO|HERO 20)(?:[);/ ]|$)|Hot ?[125][^;/]+ Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "SHINE 12T",
                "model": "Shine 12T"
            },
            {
                "regex": "SHINE 12 PRO",
                "model": "Shine 12 Pro"
            },
            {
                "regex": "SHINE 12",
                "model": "Shine 12"
            },
            {
                "regex": "HERO_20_PRO",
                "model": "Hero 20 Pro"
            },
            {
                "regex": "HERO 20",
                "model": "Hero 20"
            },
            {
                "regex": "AllCall_(Alpha|Atom|Bro|Madrid)",
                "model": "$1"
            },
            {
                "regex": "AllCall_S1_X",
                "model": "S1 X"
            },
            {
                "regex": "AllCall_S1",
                "model": "S1"
            },
            {
                "regex": "AllCall_RIO_S",
                "model": "Rio S"
            },
            {
                "regex": "AllCall_RIO_PRO",
                "model": "Rio Pro"
            },
            {
                "regex": "AllCall_RIO",
                "model": "Rio"
            },
            {
                "regex": "Heat([34])",
                "model": "Heat $1"
            },
            {
                "regex": "Rio_X(?:[);/ ]|$)",
                "model": "Rio X"
            },
            {
                "regex": "(S5500)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Hot ?([125][^;/]+) Build",
                "model": "Hot $1"
            }
        ]
    },
    "Bravis": {
        "regex": "Bravis[ _]|A501 Bright|A552 JOY Max|A504 Trace|A505 JOY Plus|A503 Joy|NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961|NP 104 3G|B501|N1-570 Space|Atlas A551|A511 Harmony|A512 Harmony Pro|A510_Jeans_4G|A509_Jeans|N1_550_Cruiser|N1_551 Gloss",
        "device": "smartphone",
        "models": [
            {
                "regex": "A501 BRIGHT",
                "model": "A501 Bright"
            },
            {
                "regex": "Bravis[_ ]X500",
                "model": "Trace Pro"
            },
            {
                "regex": "Bravis[_ ]A506",
                "model": "Crystal"
            },
            {
                "regex": "Bravis[_ ]A553",
                "model": "Discovery"
            },
            {
                "regex": "BRAVIS[ _]TAU",
                "model": "Tau"
            },
            {
                "regex": "BRAVIS[ _]DELTA",
                "model": "Delta"
            },
            {
                "regex": "BRAVIS[ _]TREND",
                "model": "Trend"
            },
            {
                "regex": "B501",
                "model": "Easy"
            },
            {
                "regex": "N1-570",
                "model": "Space"
            },
            {
                "regex": "BRAVIS[ ]A554",
                "model": "A554 Grand"
            },
            {
                "regex": "BRAVIS[ ]S500",
                "model": "S500 Diamond"
            },
            {
                "regex": "A505 JOY Plus",
                "model": "A505 Joy Plus"
            },
            {
                "regex": "A552 JOY Max",
                "model": "A552 Joy Max"
            },
            {
                "regex": "Atlas A551",
                "model": "A551 Atlas"
            },
            {
                "regex": "A503 Joy",
                "model": "A503 Joy"
            },
            {
                "regex": "A504 Trace",
                "model": "A504 Trace"
            },
            {
                "regex": "A512 Harmony Pro",
                "model": "A512 Harmony Pro"
            },
            {
                "regex": "A511 Harmony",
                "model": "A511 Harmony"
            },
            {
                "regex": "A510_Jeans_4G",
                "model": "A510 Jeans 4G"
            },
            {
                "regex": "A509_Jeans",
                "model": "A509 Jeans"
            },
            {
                "regex": "BRAVIS NEO",
                "model": "A401 Neo"
            },
            {
                "regex": "N1_550_Cruiser",
                "model": "N1-550 Cruiser"
            },
            {
                "regex": "N1_551 Gloss",
                "model": "N1-551 Gloss"
            },
            {
                "regex": "BRAVIS OMEGA",
                "model": "Omega"
            },
            {
                "regex": "BRAVIS BIZ",
                "model": "Biz"
            },
            {
                "regex": "BRAVIS POWER",
                "model": "Power"
            },
            {
                "regex": "BRAVIS[ _]SPARK",
                "model": "Spark"
            },
            {
                "regex": "BRAVIS[ _]SLIM[ _]3G",
                "model": "Slim 3G",
                "device": "tablet"
            },
            {
                "regex": "NP 104 3G",
                "model": "NP104 3G",
                "device": "tablet"
            },
            {
                "regex": "BRAVIS NP 103",
                "model": "NP103",
                "device": "tablet"
            },
            {
                "regex": "BRAVIS NP 747 SD",
                "model": "NP747 SD",
                "device": "tablet"
            },
            {
                "regex": "BRAVIS NP 844",
                "model": "NP844",
                "device": "tablet"
            },
            {
                "regex": "Bravis[_ ]([^;\\)]+) Build",
                "model": "$1"
            },
            {
                "regex": "(NB(?:106M|10[1-8]|75[134]|7[145]|8[57]1|76)|NP101|NB961)",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Brigmton": {
        "regex": "BTPC-",
        "device": "smartphone",
        "models": [
            {
                "regex": "BTPC-1022QC3G-TV",
                "model": "BTPC-1022QC3G-TV",
                "device": "tablet"
            }
        ]
    },
    "Acer": {
        "regex": "acer|ACTAB|TravelMate|(?<!Satellite |ZTE BLADE |ImSmart |ERGO |X-Style Tab )(?<!Optima 7 )a(?:101|110|2[10]0(?! Pro)|211|50[10]|51[10]|70[10])(?:[);/ ]|$)|Android.*V3[67]0(?:[);/ ]|$)|Android.*Z1[23456]0 Build|Android.*Z5\\d{2} Build|Android.*T0[234678] Build|Android 5(?:[\\d.]*);(?: [\\w-]+;)? S59|android [45]([\\d.]*);(?: [\\w-]+;)? S55(?! Nova)(?:[);/ ]|$)|(?:A1-(713(HD)?|7[23]4|830|841|840(?:FHD)?|81[01])|A3-A[1-5][01]|B1-(7[1235-9][01](HD)?|7[23]3|7A0|8[1235]0|A71|860A)|TPA60W|B3-(A[125]0|A3[02]|A40FHD)|E39)(?:[);/ ]|$)|S5[12]0 Build|(DA[0-9]+HQ?L|Aspire (?:V5-121|XC-704G|V5-573G|4349)|Chromebook 14 \\(CB3-431\\)|Predator G9-793|GT-810|B1-870|B3-A20B|M10-12(?:_EEA)?|B3-A4[02]|android 4([\\d.]*);(?: [\\w-]+;)? Z500|B3-A50FHD|ET-108-11A|AC?TAB(?:721E?|1422E|821|1021(?:E|_A)|1022)|A3-A20FHD|A10-21(?:_EEA|_CUS1)?|E380|Swift SF113-31|A410_4G|EUT[13]10A?-11A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DA220HQL(?:[);/ ]|$)",
                "model": "DA220HQL",
                "device": "smart display"
            },
            {
                "regex": "DA241HL(?:[);/ ]|$)",
                "model": "DA241HL",
                "device": "smart display"
            },
            {
                "regex": "(DA[0-9]+HQ?L)(?:[);/ ]|$)",
                "model": "$1",
                "device": "smart display"
            },
            {
                "regex": "A410_4G",
                "model": "A410 4G",
                "device": "tablet"
            },
            {
                "regex": "M10-12(?:_EEA)?",
                "model": "BattleZone LTE",
                "device": "tablet"
            },
            {
                "regex": "A1-81[01]",
                "model": "Iconia A",
                "device": "tablet"
            },
            {
                "regex": "ATAB(102[12]|721|1422)E",
                "model": "ATAB$1E",
                "device": "tablet"
            },
            {
                "regex": "ACTAB1021(?:_A)?",
                "model": "ACTAB1021",
                "device": "tablet"
            },
            {
                "regex": "ACTAB(821|1022)",
                "model": "ACTAB$1",
                "device": "tablet"
            },
            {
                "regex": "ET-108-11A",
                "model": "Enduro T1",
                "device": "tablet"
            },
            {
                "regex": "TPA60W",
                "model": "TPA60W",
                "device": "tablet"
            },
            {
                "regex": "A1-84(1|0(?:FHD)?)",
                "model": "Iconia Tab 8",
                "device": "tablet"
            },
            {
                "regex": "A1-713(HD)?",
                "model": "Iconia Tab 7",
                "device": "tablet"
            },
            {
                "regex": "A1-830",
                "model": "Iconia A1",
                "device": "tablet"
            },
            {
                "regex": "A1-7[23]4",
                "model": "Iconia Talk S",
                "device": "tablet"
            },
            {
                "regex": "A3-A20FHD",
                "device": "tablet",
                "model": "Iconia A3 FHD"
            },
            {
                "regex": "A10-21(?:_EEA|_CUS1)?",
                "device": "tablet",
                "model": "Iconia A10 M1"
            },
            {
                "regex": "A3-A[12][01]",
                "model": "Iconia A3",
                "device": "tablet"
            },
            {
                "regex": "A3-A[345]0",
                "model": "Iconia Tab 10",
                "device": "tablet"
            },
            {
                "regex": "B1-7(?:[5-9]0|30HD|A0)",
                "model": "Iconia One 7",
                "device": "tablet"
            },
            {
                "regex": "B1-7[123][01]|B1-A71",
                "model": "Iconia B1",
                "device": "tablet"
            },
            {
                "regex": "B1-7[23]3",
                "model": "Iconia Talk 7",
                "device": "tablet"
            },
            {
                "regex": "B1-8[123567]0",
                "model": "Iconia One 8",
                "device": "tablet"
            },
            {
                "regex": "B3-A([125]0|3[02]|[45]0FHD|4[02])",
                "model": "Iconia One 10",
                "device": "tablet"
            },
            {
                "regex": "A101",
                "model": "Vangogh",
                "device": "tablet"
            },
            {
                "regex": "A200",
                "model": "Picasso E",
                "device": "tablet"
            },
            {
                "regex": "A50[01]",
                "model": "Picasso",
                "device": "tablet"
            },
            {
                "regex": "Acer One 7 4G",
                "model": "One 7 4G",
                "device": "tablet"
            },
            {
                "regex": "Acer One 7",
                "model": "One 7",
                "device": "tablet"
            },
            {
                "regex": "GT-810",
                "model": "Predator 8",
                "device": "tablet"
            },
            {
                "regex": "(ACTAB721)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Acer_one_8_T2",
                "model": "One 8 T2",
                "device": "tablet"
            },
            {
                "regex": "One 8 T4-82L",
                "model": "One 8 T4-82L",
                "device": "tablet"
            },
            {
                "regex": "EUT([13])10A?-11A",
                "model": "ENDURO Urban T$1",
                "device": "tablet"
            },
            {
                "regex": "E39(?:[);/ ]|$)",
                "model": "Liquid E700"
            },
            {
                "regex": "E310(?:[);/ ]|$)",
                "model": "Liquid Mini"
            },
            {
                "regex": "E320(?:-orange)?(?:[);/ ]|$)",
                "model": "Liquid Express"
            },
            {
                "regex": "Android.*V360(?:[);/ ]|$)",
                "model": "Liquid E1 Duo"
            },
            {
                "regex": "Android.*V370(?:[);/ ]|$)",
                "model": "Liquid E2 Duo"
            },
            {
                "regex": "E380(?:[);/ ]|$)",
                "model": "Liquid E3"
            },
            {
                "regex": "S510(?:[);/ ]|$)",
                "model": "Liquid S1"
            },
            {
                "regex": "S520(?:[);/ ]|$)",
                "model": "Liquid S2"
            },
            {
                "regex": "(?:Acer_)?P400(?:[);/ ]|$)",
                "model": "neoTouch P400"
            },
            {
                "regex": "(?:Acer_)?P300(?:[);/ ]|$)",
                "model": "neoTouch P300"
            },
            {
                "regex": "(?:Acer_)?S200(?:[);/ ]|$)",
                "model": "neoTouch S200"
            },
            {
                "regex": "(?:Acer_)?E100(?:[);/ ]|$)",
                "model": "beTouch E100"
            },
            {
                "regex": "Android.*Z1([234])0(?:[);/ ]|$)",
                "model": "Liquid Z$1"
            },
            {
                "regex": "Android.*Z110(?:[);/ ]|$)",
                "model": "Liquid Z110"
            },
            {
                "regex": "Android.*Z150(?:[);/ ]|$)",
                "model": "Liquid Z5 Duo"
            },
            {
                "regex": "Android.*Z160(?:[);/ ]|$)",
                "model": "Liquid Z4 Duo"
            },
            {
                "regex": "Android.*Z(5\\d{2})(?:[);/ ]|$)",
                "model": "Liquid Z$1"
            },
            {
                "regex": "Android.*S57(?:[);/ ]|$)",
                "model": "Liquid Jade Z"
            },
            {
                "regex": "Android.*T02(?:[);/ ]|$)",
                "model": "Liquid Z530"
            },
            {
                "regex": "Android.*T03(?:[);/ ]|$)",
                "model": "Liquid Z630"
            },
            {
                "regex": "Android.*T04(?:[);/ ]|$)",
                "model": "Liquid Z630S"
            },
            {
                "regex": "Android.*T06(?:[);/ ]|$)",
                "model": "Liquid Zest"
            },
            {
                "regex": "Android.*T07(?:[);/ ]|$)",
                "model": "Liquid Zest 4G"
            },
            {
                "regex": "Android.*T08(?:[);/ ]|$)",
                "model": "Liquid Zest Plus"
            },
            {
                "regex": "TM01(?:[);/ ]|$)",
                "model": "Liquid M330"
            },
            {
                "regex": "M220(?:[);/ ]|$)",
                "model": "Liquid M220"
            },
            {
                "regex": "AcerTD600",
                "model": "TD600"
            },
            {
                "regex": "S55(?:[);/ ]|$)",
                "model": "Liquid Jade"
            },
            {
                "regex": "S59(?:[);/ ]|$)",
                "model": "Liquid X2"
            },
            {
                "regex": "(?:Acer )?(Chromebook R1[13])",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "TravelMate Spin (B118-G2-R)",
                "model": "TravelMate Spin $1",
                "device": "desktop"
            },
            {
                "regex": "TravelMate (P653-M|5760G|8371|B118-M)",
                "model": "TravelMate $1",
                "device": "desktop"
            },
            {
                "regex": "(?:Acer )?(Chromebook 1[45])",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "Aspire (V5-121|XC-704G|V5-573G|A515-51G|4349|E5-511)",
                "model": "Aspire $1",
                "device": "desktop"
            },
            {
                "regex": "(Predator G9-793|Swift SF113-31)",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "a(101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)",
                "model": "Iconia Tab A$1",
                "device": "tablet"
            },
            {
                "regex": "Acer; ?([^;()/]+)",
                "model": "$1"
            },
            {
                "regex": "Acer(?! ?inc)[ _-]?([^;)/]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "acer[_-]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Advan": {
        "regex": "(?:ADVAN (?:M4|S40|T5C|1011)|i7U|S45E|S50H|I7D|i55[KD]|i4U|S7D|S4Z|i5[KE]|S5E[ _]NXT|S5J\\+|S4\\+|E1C_3G|ADVANNASAPro)(?:[);/ ]|$)| (?:E1C Pro|5505|5202|50(?:[46]1|5[89]|62)|600[234]|6[25]01|Android [56](?:[\\d.]*);(?: [\\w-]+;)? (?:i5C|i7A)|i5G|E1C 3G)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "ADVAN M4",
                "model": "M4"
            },
            {
                "regex": "ADVAN S40",
                "model": "S40"
            },
            {
                "regex": "i7U",
                "model": "I Lite i7U"
            },
            {
                "regex": "S5E[ _]NXT",
                "model": "S5E NXT"
            },
            {
                "regex": "i(55[KD]|5[KE])",
                "model": "I$1"
            },
            {
                "regex": "i4U",
                "model": "I4U"
            },
            {
                "regex": "5505(?:[);/ ]|$)",
                "model": "NASA Plus"
            },
            {
                "regex": "ADVANNASAPro(?:[);/ ]|$)",
                "model": "NASA Pro"
            },
            {
                "regex": "5202(?:[);/ ]|$)",
                "model": "NASA"
            },
            {
                "regex": "6201(?: Build|[;)])",
                "model": "G5"
            },
            {
                "regex": "6501(?: Build|[;)])",
                "model": "G5 Elite"
            },
            {
                "regex": "i5G(?: Build|[;)])",
                "model": "S50 4G"
            },
            {
                "regex": "6004(?: Build|[;)])",
                "model": "G2 Pro"
            },
            {
                "regex": "6002(?: Build|[;)])",
                "model": "G3 Pro"
            },
            {
                "regex": "(S45E|50[46]1|505[89]|5062|S50H|I7D|S7D|S4Z|S5J\\+|S4\\+|i5C)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "E1C[_ ]3G",
                "device": "tablet",
                "model": "E1C 3G"
            },
            {
                "regex": "E1C Pro",
                "device": "tablet",
                "model": "E1C Pro"
            },
            {
                "regex": "(T5C|i7A)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "ADVAN 1011(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Sketsa 2"
            }
        ]
    },
    "Advance": {
        "regex": "Hollogram|(?:HL(?:4[79]36|6246|5576|5585|[56]575|5[67]67|6[05]77|6256|7257|9000)|IntroTr3544|Pr(?:61(?:4[56]|50)|60[27]0|5[69]50|5860)|Tr3845|TR7989|SP[345]701)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IntroTr3544|Tr3845",
                "model": "Intro",
                "device": "tablet"
            },
            {
                "regex": "TR7989",
                "model": "TR7989",
                "device": "tablet"
            },
            {
                "regex": "SP([345]701)",
                "model": "SmartPad SP$1",
                "device": "tablet"
            },
            {
                "regex": "Pr(61(?:4[56]|50)|60[27]0|5[69]50|5860)",
                "model": "Prime PR$1",
                "device": "tablet"
            },
            {
                "regex": "HL(4[79]36|6246|[56]575|5576|5585|5[67]67|6[05]77|6256|7257|9000)",
                "model": "Hollogram HL$1"
            },
            {
                "regex": "Hollogram ([^;/)]+)(?: Build|[;)])",
                "model": "Hollogram $1"
            }
        ]
    },
    "AGM": {
        "regex": "AGM[ _]([^/;)]+)(?: Build|[;)])|AG[_ ]Go[_-]Tab|(?:Flair(?! \\w\\d)|(?<!STX )Ultra 2|Freedom Access)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AG[_ ]Go[_-]Tab[_ ]Access(_2)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Go Tab Access$1"
            },
            {
                "regex": "(Flair|Ultra 2|Freedom Access)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "AGM A9(?:[);/ ]|$)",
                "model": "A9"
            },
            {
                "regex": "AGM_H_MAX",
                "model": "H Max"
            },
            {
                "regex": "AGM_H3(?:[);/ ]|$)",
                "model": "H3"
            },
            {
                "regex": "AGM_H5_PRO(?:[);/ ]|$)",
                "model": "H5 Pro"
            },
            {
                "regex": "AGM[_ ]PAD[_ ](P2W|P[12]|T[13])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Pad $1"
            },
            {
                "regex": "AGM[ _]([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Airis": {
        "regex": "AIRIS|PhonePAD 83G",
        "device": "smartphone",
        "models": [
            {
                "regex": "TM50QZ(?:[);/ ]|$)",
                "model": "TM50QZ"
            },
            {
                "regex": "PhonePAD 83G",
                "device": "tablet",
                "model": "PhonePAD 83G"
            }
        ]
    },
    "Airness": {
        "regex": "AIRNESS-([\\w]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Airpha": {
        "regex": "(?:Halo3_Pro|Halo4 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Halo([34])[ _]Pro",
                "model": "Halo$1 Pro"
            }
        ]
    },
    "Aiwa": {
        "regex": "AIWAAndroidTV|(?:AW790|M300(?! 4G)|AWM(?:53[39]|50[19]|561|999)|AW500|Android 7(?:[\\d.]*);(?: [\\w-]+;)? Z9 PLUS|JA2-SMP0601|AWTX6|WS-508G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AW790(?:[);/ ]|$)",
                "model": "AW790"
            },
            {
                "regex": "Z9 PLUS",
                "model": "Z9 Plus"
            },
            {
                "regex": "AW500(?:[);/ ]|$)",
                "model": "AW500"
            },
            {
                "regex": "AWM(53[39]|50[19]|561|999)(?:[);/ ]|$)",
                "model": "AWM$1"
            },
            {
                "regex": "(JA2-SMP0601)",
                "model": "$1"
            },
            {
                "regex": "M300(?:[);/ ]|$)",
                "model": "M300",
                "device": "phablet"
            },
            {
                "regex": "(AWTX6|WS-508G)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "AIWAAndroidTV",
                "model": "AndroidTV Box"
            }
        ]
    },
    "Akai": {
        "regex": "Akai[ _\\-,]|LGE; (?:ALT|AK)[a-z0-9]+;|Eco[ _]E2|Glory[ _](?:G[1235]|L[123]|O[125])|(?:TAB-[79]8[03]0Q?|X[56] METAL|AKTB-703MZ|FZ70[13]|X5_PRO|X3[_ ]PRO[_ ]SLIM|iLike U5 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TAB-([79]8[03]0Q?)",
                "device": "tablet",
                "model": "TAB $1"
            },
            {
                "regex": "AKTB-703MZ",
                "device": "tablet",
                "model": "AKTB-703MZ"
            },
            {
                "regex": "(FZ70[13])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "X([56]) METAL",
                "model": "iLike X$1 Metal"
            },
            {
                "regex": "X3[_ ]PRO[_ ]SLIM",
                "model": "iLike X3 Pro Slim"
            },
            {
                "regex": "X5_PRO",
                "model": "iLike X5 Pro"
            },
            {
                "regex": "iLike U5 Pro",
                "model": "iLike U5 Pro"
            },
            {
                "regex": "Glory[ _](G[1235]|L[123]|O[125])",
                "model": "Glory $1"
            },
            {
                "regex": "Eco[ _]E2",
                "model": "Eco E2"
            },
            {
                "regex": "AKAI\\-v\\.tv\\.([0-9]{4})",
                "device": "tv",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Akai[ _-]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "AKAI,(AK3219NF)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "LGE; ((?:ALT|AK)[a-z0-9]+);",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Si2157LG32",
                "device": "tv",
                "model": ""
            }
        ]
    },
    "Arian Space": {
        "regex": "Arian Space",
        "device": "tablet",
        "models": [
            {
                "regex": "100 ST1004PG",
                "model": "100"
            },
            {
                "regex": "80 SS8003PG",
                "model": "80"
            },
            {
                "regex": "71 ST7002PG",
                "model": "71"
            },
            {
                "regex": "70 ST7001RW",
                "model": "70"
            }
        ]
    },
    "Alcatel": {
        "regex": "Alcatel|Alc(?!or )[a-z0-9]+|One[ _]?Touch|idol[3X]|TIMXL|(?:(?:3088X|4003[AJ]|4009[ADEFIKMSX]|4013[DEJKMX]|4014[ADEKMX]|4015[ADNTX]|4016[ADX]|4017[ADEFSX]|4018[ADEFMX]|4024[DEX]|4027[ADNX]|4028[AEJS]|4032[ADEX]|4034[ADEFGLTX]|4035[ADXY]|4044[COV]|4045[ADELX]|4047[ADFGNX]|4049[DEGMX]|4052[CORWZ]|4056[WZ]|4060[SW]|4063[FT]|4065F|4087U|4114E|5001[ADJTU]|5002[ABDEFHJLMRSUWX]|5003[ADGUX]|5006[ADG]|5007[AGUOS]|5008[ADTUY]|5009[AD]|5010[DEGSUX]|5011A|5012[DFG]|5015[ADEX]|5016[AJX]|5017[ABDEOX]|5019D|5022[DEX]|5023[EF]|5024[ADFIJ]|5025[DEG]|5026[ADJ]|5027B|5028[ADY]|5029[ADEFY]|5030[ADEFJMU]|5031[ADGJ]|5032[OW]|5033(?:[DFTXY]R|[EFM]P|[ADEFGJMOQSTXY])|5034D|5036D|5038[ADEX]|5039[DY]|5041[CD]|5042[ADEFGTWX]|5044[ADGIKOPSTY]|5045[ADFGIJTXY]|5046[ADGIJSTUY]|5047[DIUY]|5048[AIUY]|5049[EGSWZ]|5050[ASXY]|5051[ADEJMTWX]|5052[ADY]|5053[ADKY]|5054[ADNSTWX]|5056[ADEGIJMNTUWX]|5057M|5058[AIJY]|5059[ADIJSTXYZ]|5060[ADJ]|5061[AKU]|5065[ADNWX]|5070D|5080[ADFQUX]|5085[ABCDGHIJNOQY]|5086[ADY]|5090[AIY]|5095[IKY]|5098[OS]|5099[ADIUY]|5116J|5131E|5145A|6002[ADJ]|6016[ADEX]|6025[ADH]|6027A|6036[AXY]|6037[BKY]|6039[AHJKSY]|6042D|6043[AD]|6044D|6045[BFIKOXY]|6050[AFY]|6055[ABDHIKPUYZ]|6056[ADH]|6058[ADX]|6060[SXC]|6062W|6065A|6070K|7040[ADEFKRT]|7041[DX]|7042A|7043[AEKY]|7044[AX]|7045Y|7048[ASWX]|7053D|7055A|7070X|7071[ADX]|8030Y|8050[DEGX]|8063|8088[MQX]|8094[MTX]|9001[DIX]|9002X|9003[AX]|9005X|9006W|9007[ATX]|9008[ADIJNTUX]|9009[AFG]|9010X|9013[ATX]|9015B|9020A|9022X|9024[OW]|9025Q|9026X|9027[FQTWX]|9029[ZW]|9032[TWXZ]|9203A|9309X|A(?:40[56]DL|46[46]BG|57[04]BL|576CC|621BL|50[13]DL|57[17]VL)|I213|I216[AX]|(?<!\\.)80(?:[89]2|84|91|6[78]|5[124567]))(?:_(?:EEA|RU|TR))?|P3[36]0X|AM-H200|A463BG)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "3088X",
                "model": "3088",
                "device": "feature phone"
            },
            {
                "regex": "4052[CR]",
                "model": "SmartFlip",
                "device": "feature phone"
            },
            {
                "regex": "4052[OWZ]",
                "model": "Go Flip 3",
                "device": "feature phone"
            },
            {
                "regex": "4056[WZ]",
                "model": "Go Flip 4",
                "device": "feature phone"
            },
            {
                "regex": "(?:Alcatel)?4044V",
                "model": "Go Flip V",
                "device": "feature phone"
            },
            {
                "regex": "A405DL",
                "model": "MyFlip",
                "device": "feature phone"
            },
            {
                "regex": "A406DL",
                "model": "MyFlip 2",
                "device": "feature phone"
            },
            {
                "regex": "(?:Alcatel)?4044C",
                "model": "Quick Flip",
                "device": "feature phone"
            },
            {
                "regex": "(?:Alcatel)?4044O",
                "model": "Cingular Flip II",
                "device": "feature phone"
            },
            {
                "regex": "4087U",
                "model": "1SE Light"
            },
            {
                "regex": "5022[EDX]|5070D",
                "model": "One Touch Pop Star"
            },
            {
                "regex": "6044D",
                "model": "One Touch Pop Up"
            },
            {
                "regex": "4015[ATX]|4016A",
                "model": "One Touch Pop C1"
            },
            {
                "regex": "4015[DN]|4016[DX]",
                "model": "One Touch Pop C1 Dual SIM"
            },
            {
                "regex": "4032[AX]",
                "model": "One Touch Pop C2"
            },
            {
                "regex": "4032[DE]",
                "model": "One Touch Pop C2 Dual SIM"
            },
            {
                "regex": "5036D",
                "model": "One Touch Pop C5 Dual SIM"
            },
            {
                "regex": "7040[AFK]|7041X|7042A",
                "model": "One Touch Pop C7"
            },
            {
                "regex": "7040[DE]|7041D",
                "model": "One Touch Pop C7 Dual SIM"
            },
            {
                "regex": "4018[ADEFMX]",
                "model": "One Touch Pop D1"
            },
            {
                "regex": "4035[ADXY]",
                "model": "One Touch Pop D3"
            },
            {
                "regex": "5038[ADEX]",
                "model": "One Touch Pop D5"
            },
            {
                "regex": "4045[AXL]",
                "model": "One Touch Pop 2 4\""
            },
            {
                "regex": "4045[DE]",
                "model": "One Touch Pop 2 4\" Dual SIM"
            },
            {
                "regex": "5042[AFGWX]",
                "model": "One Touch Pop 2 4.5\""
            },
            {
                "regex": "5042[DE]",
                "model": "One Touch Pop 2 4.5\" Dual SIM"
            },
            {
                "regex": "7043[AY]|7044[AX]",
                "model": "One Touch Pop 2 5\""
            },
            {
                "regex": "7043[EK]",
                "model": "One Touch Pop 2 5\" Dual SIM"
            },
            {
                "regex": "50[16]5X",
                "model": "One Touch Pop 3"
            },
            {
                "regex": "5015[AE]|5016[AJ]|5065[ADWX]|5116J",
                "model": "One Touch Pop 3 5\""
            },
            {
                "regex": "5025[DEG]|5054[ADSTX]",
                "model": "One Touch Pop 3 5.5\""
            },
            {
                "regex": "5015D",
                "model": "One Touch Pop 3 Dual SIM"
            },
            {
                "regex": "5051[AEJMTWX]",
                "model": "One Touch Pop 4"
            },
            {
                "regex": "5051D",
                "model": "One Touch Pop 4 Dual SIM"
            },
            {
                "regex": "5095[IKY]",
                "model": "One Touch Pop 4S"
            },
            {
                "regex": "5056[ADEGJMTUX]",
                "model": "One Touch Pop 4+"
            },
            {
                "regex": "7070X",
                "model": "One Touch Pop 4 6\""
            },
            {
                "regex": "5057M",
                "model": "One Touch Pop Mirage"
            },
            {
                "regex": "5050[ASXY]",
                "model": "One Touch Pop S3"
            },
            {
                "regex": "7045Y",
                "model": "One Touch Pop S7"
            },
            {
                "regex": "6037[BKY]",
                "model": "One Touch Idol 2"
            },
            {
                "regex": "5042T",
                "model": "One Touch Astro"
            },
            {
                "regex": "IdolX 6040",
                "model": "One Touch Idol X"
            },
            {
                "regex": "5027B",
                "model": "One Touch Dawn"
            },
            {
                "regex": "7071[ADX]",
                "model": "A7 XL"
            },
            {
                "regex": "5002[ABDEHJLMSUWX]",
                "model": "1B (2020)"
            },
            {
                "regex": "5031[ADGJ]|5131E",
                "model": "1B (2022)"
            },
            {
                "regex": "(?:Alcatel_)?5008R",
                "model": "Onyx"
            },
            {
                "regex": "(?:Alcatel_)?5002R",
                "model": "Volta"
            },
            {
                "regex": "4034T",
                "model": "1E"
            },
            {
                "regex": "5002F",
                "model": "1A (2020)"
            },
            {
                "regex": "4063F",
                "model": "1L Plus"
            },
            {
                "regex": "4065F",
                "model": "1L Pro"
            },
            {
                "regex": "5034D|6056[ADH]",
                "model": "3L"
            },
            {
                "regex": "A576CC",
                "model": "Kora A576CC"
            },
            {
                "regex": "7040[RT]",
                "model": "One Touch Fierce 2"
            },
            {
                "regex": "5056[NW]",
                "model": "One Touch Fierce 4"
            },
            {
                "regex": "5054N",
                "model": "One Touch Fierce XL"
            },
            {
                "regex": "6042D",
                "model": "One Touch Flash"
            },
            {
                "regex": "6016[AX]",
                "model": "One Touch Idol 2 mini"
            },
            {
                "regex": "6016[DE]",
                "model": "One Touch Idol 2 mini Dual SIM"
            },
            {
                "regex": "6036[AXY]",
                "model": "One Touch Idol 2 mini S"
            },
            {
                "regex": "6050[AFY]",
                "model": "One Touch Idol 2S"
            },
            {
                "regex": "6039[AHJKYS]|idol3",
                "model": "One Touch Idol 3"
            },
            {
                "regex": "6045[BFIKOYX]|AM-H200",
                "model": "One Touch Idol 3 5.5\""
            },
            {
                "regex": "6055[ABDHIKPUYZ]",
                "model": "One Touch Idol 4"
            },
            {
                "regex": "6070K",
                "model": "One Touch Idol 4S"
            },
            {
                "regex": "6058[ADX]",
                "model": "One Touch Idol 5"
            },
            {
                "regex": "6060[SX]",
                "model": "One Touch Idol 5S"
            },
            {
                "regex": "(?:Alcatel_)?6060C",
                "model": "One Touch Idol 5"
            },
            {
                "regex": "6043[AD]",
                "model": "One Touch Idol X+"
            },
            {
                "regex": "8030Y",
                "model": "One Touch Hero 2"
            },
            {
                "regex": "7055A",
                "model": "One Touch Hero 2C"
            },
            {
                "regex": "7053D",
                "model": "One Touch X1"
            },
            {
                "regex": "5065N",
                "model": "TRU"
            },
            {
                "regex": "A574BL",
                "model": "Raven"
            },
            {
                "regex": "A577VL",
                "model": "Zip"
            },
            {
                "regex": "A466BG",
                "model": "Pixi Unite"
            },
            {
                "regex": "5056I",
                "model": "One Touch Optus X Smart"
            },
            {
                "regex": "A570BL",
                "model": "One Touch Pixi Avion LTE"
            },
            {
                "regex": "A571VL",
                "model": "One Touch Pixi Avion 4G LTE"
            },
            {
                "regex": "4024[DEX]",
                "model": "One Touch Pixi First"
            },
            {
                "regex": "A464BG",
                "model": "One Touch Pixi Glitz"
            },
            {
                "regex": "A621BL",
                "model": "One Touch Pixi Glory"
            },
            {
                "regex": "4014D",
                "model": "One Touch Pixi 2"
            },
            {
                "regex": "4009[AFIKMSX]|A463BG",
                "model": "One Touch Pixi 3 3.5\""
            },
            {
                "regex": "4009[DE]",
                "model": "One Touch Pixi 3 3.5\" Dual SIM"
            },
            {
                "regex": "4003[AJ]|4013[DEJKMX]|4014[AEKMX]|4114E",
                "model": "One Touch Pixi 3 4\""
            },
            {
                "regex": "4027[ADNX]|4028[AEJS]|5019D",
                "model": "One Touch Pixi 3 4.5\""
            },
            {
                "regex": "5017[ABDEOX]",
                "model": "One Touch Pixi 3 4.5\" 4G"
            },
            {
                "regex": "9002X",
                "model": "One Touch Pixi 3 7\"",
                "device": "phablet"
            },
            {
                "regex": "9007A",
                "model": "One Touch Pixi 3 7\"",
                "device": "tablet"
            },
            {
                "regex": "9007[TX]",
                "model": "One Touch Pixi 3 7\" 4G",
                "device": "tablet"
            },
            {
                "regex": "(?:9009G|9013[AT])",
                "model": "1T",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)808[24](?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "1T 10",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)8092(?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "1T 10 Smart",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)8091(?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "1T 10 WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)8052(?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "TEKE Mini",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)8051(?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "Smart Tab 7\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "(?!<\\.)805[4567](?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "One Touch Pixi 3 7\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "9009A",
                "model": "1T 7",
                "device": "tablet"
            },
            {
                "regex": "9009F",
                "model": "1T 7\" 3G",
                "device": "tablet"
            },
            {
                "regex": "9309X",
                "model": "1T 7\" (2021)",
                "device": "tablet"
            },
            {
                "regex": "(?:(?!<\\.)806[78]|9013X)(?:_(?:EEA|RU))?(?:[);/ ]|$)",
                "model": "1T 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "9022X",
                "model": "One Touch Pixi 3 8\"",
                "device": "phablet"
            },
            {
                "regex": "9010X",
                "model": "One Touch Pixi 3 10\"",
                "device": "tablet"
            },
            {
                "regex": "4017[ADEFSX]",
                "model": "One Touch Pixi 4 3.5\""
            },
            {
                "regex": "4034[ADEFGXL]",
                "model": "One Touch Pixi 4 4\""
            },
            {
                "regex": "4060[SW]",
                "model": "One Touch Pixi 4 4.5\""
            },
            {
                "regex": "5023[EF]",
                "model": "One Touch Pixi 4 Plus Power"
            },
            {
                "regex": "5010[DEGSUX]",
                "model": "One Touch Pixi 4 5\" 3G"
            },
            {
                "regex": "5041D",
                "model": "One Touch Pixi 4 5.0\""
            },
            {
                "regex": "5012[DFG]",
                "model": "One Touch Pixi 4 5.5\" 3G"
            },
            {
                "regex": "5045[ADFGIJTXY]|5145A",
                "model": "One Touch Pixi 4 5\" 4G"
            },
            {
                "regex": "5098O",
                "model": "One Touch Pixi Theatre"
            },
            {
                "regex": "A501DL",
                "model": "A1"
            },
            {
                "regex": "A503DL",
                "model": "A1X"
            },
            {
                "regex": "(?:Alcatel_)?5004R",
                "model": "Axel"
            },
            {
                "regex": "5046[ADIJTUY]",
                "model": "A3"
            },
            {
                "regex": "5011A|5049[EG]",
                "model": "A3 Plus"
            },
            {
                "regex": "9008[ADIJNTUX]",
                "model": "A3 XL"
            },
            {
                "regex": "9203A",
                "model": "A3 7\" 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:9027[QFTWX]|9032[TX])",
                "model": "3T 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "9026X",
                "model": "A3 10\"",
                "device": "tablet"
            },
            {
                "regex": "5085[BQ]",
                "model": "A5"
            },
            {
                "regex": "5085[ADHIJY]",
                "model": "A5 LED"
            },
            {
                "regex": "5085N",
                "model": "A5 Max LED"
            },
            {
                "regex": "5090[AIY]",
                "model": "A7"
            },
            {
                "regex": "5046[GS]",
                "model": "A30"
            },
            {
                "regex": "5049S",
                "model": "A30 Plus"
            },
            {
                "regex": "5049Z",
                "model": "A30 Fierce"
            },
            {
                "regex": "5085[GO]",
                "model": "A50"
            },
            {
                "regex": "5048[AYUI]",
                "model": "3X (2019)"
            },
            {
                "regex": "5049W",
                "model": "Revvl"
            },
            {
                "regex": "9006W",
                "model": "One Touch Pixi 2 7\" 4G",
                "device": "tablet"
            },
            {
                "regex": "8050[GX]",
                "model": "One Touch Pixi 4 6\" 3G"
            },
            {
                "regex": "8050[ED]",
                "model": "One Touch Pixi 4 6\" 3G Dual SIM"
            },
            {
                "regex": "5098S|9001[DIX]",
                "model": "One Touch Pixi 4 6\" 4G"
            },
            {
                "regex": "9003[AX]",
                "model": "One Touch Pixi 4 7\" 3G",
                "device": "tablet"
            },
            {
                "regex": "9015B",
                "model": "One Touch Pixi 4 7\" 4G",
                "device": "tablet"
            },
            {
                "regex": "8063",
                "model": "One Touch Pixi 4 7\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "9024[OW]",
                "model": "One Touch Pixi 5",
                "device": "tablet"
            },
            {
                "regex": "I216[AX]",
                "model": "One Touch Pixi 7",
                "device": "tablet"
            },
            {
                "regex": "I213",
                "model": "One Touch Pixi 7",
                "device": "tablet"
            },
            {
                "regex": "9005X",
                "model": "One Touch Pixi 8",
                "device": "tablet"
            },
            {
                "regex": "9025Q",
                "model": "One Touch Pop 4 7\" 4G",
                "device": "tablet"
            },
            {
                "regex": "P320X",
                "model": "One Touch POP 8",
                "device": "tablet"
            },
            {
                "regex": "P310X",
                "model": "One Touch POP 7",
                "device": "tablet"
            },
            {
                "regex": "P330X",
                "model": "One Touch POP 7S",
                "device": "tablet"
            },
            {
                "regex": "9020A",
                "model": "One Touch Trek HD",
                "device": "tablet"
            },
            {
                "regex": "7048[ASWX]",
                "model": "One Touch Go Play"
            },
            {
                "regex": "(?:Alcatel-)?OT-802",
                "model": "Wave"
            },
            {
                "regex": "ALCATEL_ONE_TOUCH_768T",
                "model": "Island"
            },
            {
                "regex": "(?:TRIBE_)?3075A",
                "model": "One Touch Tribe"
            },
            {
                "regex": "ALCATEL_one_touch_585",
                "model": "One Touch 585"
            },
            {
                "regex": "ALCATEL_ONE_TOUCH_838",
                "model": "One Touch 838"
            },
            {
                "regex": "ALCATEL_one_touch_813d",
                "model": "One Touch 813D"
            },
            {
                "regex": "ALCATEL_one_touch_813",
                "model": "One Touch 813"
            },
            {
                "regex": "OT871A",
                "model": "One Touch 871A"
            },
            {
                "regex": "P360X",
                "model": "One Touch Pop 10"
            },
            {
                "regex": "(?:Alcatel[ _])?One[ _]?Touch[ _]((?:T[0-9]+|TAB[^/;]+|EVO[78](?:HD)?)) Build",
                "device": "tablet",
                "model": "One Touch $1"
            },
            {
                "regex": "(?:Alcatel[ _])?One[ _]?Touch([^/;]*) Build",
                "model": "One Touch$1"
            },
            {
                "regex": "(?:Alcatel[ _])?One[ _]?Touch([^/;\\)]*)\\)",
                "model": "One Touch$1"
            },
            {
                "regex": "5080[ADFQUX]",
                "model": "Shine Lite"
            },
            {
                "regex": "TIMXL",
                "model": "TIM XL"
            },
            {
                "regex": "5085C",
                "model": "PulseMix"
            },
            {
                "regex": "4049[DEGMX]",
                "model": "U3"
            },
            {
                "regex": "5044[ADIKOPTY]",
                "model": "U5"
            },
            {
                "regex": "4047[DFXN]",
                "model": "U5 3G"
            },
            {
                "regex": "5047[DIUY]",
                "model": "U5 HD"
            },
            {
                "regex": "4047G",
                "model": "U5 Lite"
            },
            {
                "regex": "4047A",
                "model": "U5 Plus"
            },
            {
                "regex": "4044[CV]",
                "model": "Quick Flip"
            },
            {
                "regex": "4044O",
                "model": "Cingular Flip 2"
            },
            {
                "regex": "(?:Alcatel)?4044[MNT]",
                "model": "Go Flip"
            },
            {
                "regex": "5044[GS]",
                "model": "U50"
            },
            {
                "regex": "5033[DFTXY]R(?:[);/ ]|$)",
                "model": "1 (2021)"
            },
            {
                "regex": "5033MP(?:[);/ ]|$)",
                "model": "1 Ultra"
            },
            {
                "regex": "5033(?:[ADJEFGMOTXYQS]|[EF]P)(?:_(?:EEA|RU|TR))?(?:[);/ ]|$)",
                "model": "1"
            },
            {
                "regex": "5009[AD]",
                "model": "1C"
            },
            {
                "regex": "5003[ADGUX]",
                "model": "1C (2019)"
            },
            {
                "regex": "5008[ADUYT]",
                "model": "1X (2019)"
            },
            {
                "regex": "5007[AGUS]",
                "model": "1V (2020)"
            },
            {
                "regex": "6002[AD]",
                "model": "1V (2021)"
            },
            {
                "regex": "6002J",
                "model": "1V (2022)"
            },
            {
                "regex": "5006[ADG]",
                "model": "3C (2019)"
            },
            {
                "regex": "5024[ADFIJ]|5028Y|6025[ADH]",
                "model": "1S"
            },
            {
                "regex": "(?:5028[AD]|5007O)",
                "model": "1S (2020)"
            },
            {
                "regex": "5030E",
                "model": "1SP (2020)"
            },
            {
                "regex": "5030[ADFJMU]",
                "model": "1SE (2020)"
            },
            {
                "regex": "5001[ADJTU]",
                "model": "1V"
            },
            {
                "regex": "5059[ADJXYZIT]",
                "model": "1X"
            },
            {
                "regex": "5059S",
                "model": "Avalon V"
            },
            {
                "regex": "5060[ADJ]",
                "model": "5V",
                "device": "phablet"
            },
            {
                "regex": "5052[ADY]|5053[ADKY]",
                "model": "3"
            },
            {
                "regex": "5029E",
                "model": "3 (2020)"
            },
            {
                "regex": "5029[ADFY]",
                "model": "3L (2020)"
            },
            {
                "regex": "5032[OW]|5099[ADYUI]",
                "model": "3V"
            },
            {
                "regex": "5026[ADJ]",
                "model": "3C"
            },
            {
                "regex": "6027A",
                "model": "3H Plus"
            },
            {
                "regex": "5039[DY]",
                "model": "3L",
                "device": "phablet"
            },
            {
                "regex": "5058[AIJY]",
                "model": "3X"
            },
            {
                "regex": "5061[AKU]",
                "model": "3X (2020)"
            },
            {
                "regex": "5086[ADY]",
                "model": "5"
            },
            {
                "regex": "6065A",
                "model": "5H Plus"
            },
            {
                "regex": "6062W",
                "model": "7"
            },
            {
                "regex": "8088[XQM]",
                "model": "3T 10\"",
                "device": "tablet"
            },
            {
                "regex": "8094[MTX]",
                "model": "3T 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "9029[ZW]",
                "model": "Joy Tab",
                "device": "tablet"
            },
            {
                "regex": "9032[WZ]",
                "model": "Joy Tab 2",
                "device": "tablet"
            },
            {
                "regex": "Alcatel UP",
                "model": ""
            },
            {
                "regex": "(?:ALCATEL_)?A383G",
                "model": "Big Easy Plus"
            },
            {
                "regex": "5041C",
                "model": "TETRA"
            },
            {
                "regex": "ALCATEL([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "ALCATEL[ -]?([^/;\\)]+)",
                "model": "$1"
            },
            {
                "regex": "ALCATEL_([^/;\\)]+)",
                "model": "$1"
            },
            {
                "regex": "Alc([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Allview": {
        "regex": "Allview|A4You|H1003_LTE_PRO|A5_(?:Easy(?:_TM)?|Ready(?:_TM)?|Quad|Quad_Plus_TM)|A[5-9]_Lite|A5Smiley|A6_Duo|A10_Lite_(?:2019|2GB)|A10_(?:Plus|Max)|AX2_Frenzy|AX4Nano|AX5NanoQ|AX50(?:[23]|1Q)|C6_Duo|E[23]_Living|E[23]_(?:Jump|Sign)|E4_Lite|M9_Connect|P(?:43_Easy|[5689]_Energy|6_Energy_Lite|[68]_Energy_Mini(?:_TM)?|(41|[4568])_eMagic(?:_TM)?|[589](?:_)?Life(?:_TM)?|[567]_Lite(?:_TM)?|6_plus|[45678]_Pro|7_Seon|10_Life|10_Max|10_Style|7_Xtreme|6_Qmax|4_Quad)|V(?:[1345]_Viper|1_Viper_I|2_Viper_(?:[EISX]|X_plus|Xe))|X4_Soul_Vision|X(?:[1-46]_Soul_Xtreme|[1-5]_Soul|3_Soul_Lite|[2-6]_Soul_Mini(?:_TM)?|4_Soul_Mini_S(?:_TM)?|[2-58]_Soul_Style(?:_TM)?|2_Soul_Style_Plus|2_Twin)|A30_Plus|Viva_(?:H801|100[13]G|(?:H100[124]|H701|H802)_LTE|C701|i701G|803G)|VivaH(?:10|[78])|X7_Soul_Style|X[12]0_Soul|X[78]_Soul_Pro|V10_Viper|Viva_(?:Home|i7G)|H1004_LTE",
        "device": "smartphone",
        "models": [
            {
                "regex": "A4You",
                "model": "A4 You"
            },
            {
                "regex": "AX2_Frenzy",
                "model": "AX2 Frenzy",
                "device": "tablet"
            },
            {
                "regex": "AX5NanoQ",
                "model": "AX5 Nano Q",
                "device": "tablet"
            },
            {
                "regex": "C6_Duo",
                "model": "C6 Duo"
            },
            {
                "regex": "E([23])_Living",
                "model": "E$1 Living"
            },
            {
                "regex": "E([23])_Jump",
                "model": "E$1 Jump"
            },
            {
                "regex": "E3_Sign",
                "model": "E3 Sign"
            },
            {
                "regex": "E4_Lite",
                "model": "E4 Lite"
            },
            {
                "regex": "M9_Connect",
                "model": "M9 Connect"
            },
            {
                "regex": "P43_Easy",
                "model": "P43 Easy"
            },
            {
                "regex": "P(41|[4568])_eMagic(?:_TM)?",
                "model": "P$1 eMagic"
            },
            {
                "regex": "P([567])_Lite(?:_TM)?",
                "model": "P$1 Lite"
            },
            {
                "regex": "P6_plus",
                "model": "P6 Plus"
            },
            {
                "regex": "P6_Qmax",
                "model": "P6 Qmax"
            },
            {
                "regex": "P([45678])_Pro",
                "model": "P$1 Pro"
            },
            {
                "regex": "P4_Quad",
                "model": "P4 Quad"
            },
            {
                "regex": "P9_Energy_Lite_2017",
                "model": "P9 Energy Lite (2017)"
            },
            {
                "regex": "P9_Energy_S",
                "model": "P9 Energy S"
            },
            {
                "regex": "P([69])_Energy_Lite",
                "model": "P$1 Energy Lite"
            },
            {
                "regex": "P8_Energy_PRO",
                "model": "P8 Energy Pro"
            },
            {
                "regex": "P([689])_Energy_mini(?:_TM)?",
                "model": "P$1 Energy Mini"
            },
            {
                "regex": "P([5689])_Energy",
                "model": "P$1 Energy"
            },
            {
                "regex": "P7_Seon",
                "model": "P7 Seon"
            },
            {
                "regex": "P7_Xtreme",
                "model": "P7 Xtreme"
            },
            {
                "regex": "P([589])(?:_)?Life(?:_TM)?",
                "model": "P$1 Life"
            },
            {
                "regex": "P10_Life",
                "model": "P10 Life"
            },
            {
                "regex": "P10_Max",
                "model": "P10 Max"
            },
            {
                "regex": "P10_Style",
                "model": "P10 Style"
            },
            {
                "regex": "V([12])_Viper_I4G(?:_TM)?",
                "model": "V$1 Viper I 4G"
            },
            {
                "regex": "V1_Viper_I",
                "model": "V1 Viper I"
            },
            {
                "regex": "V4_Viper_PRO",
                "model": "V4 Viper Pro"
            },
            {
                "regex": "V2_Viper_X_plus",
                "model": "V2 Viper X Plus"
            },
            {
                "regex": "V2_Viper_(E|I|S|X(?:e)?)",
                "model": "V2 Viper $1"
            },
            {
                "regex": "X4_Soul_Vision",
                "model": "X4 Soul Vision"
            },
            {
                "regex": "X7_Soul_Style",
                "model": "X7 Soul Style"
            },
            {
                "regex": "X8_Soul_Pro",
                "model": "X8 Soul Pro"
            },
            {
                "regex": "X([1246])_Soul_Xtreme",
                "model": "X$1 Soul Xtreme"
            },
            {
                "regex": "X4_Soul_Infinity_(L|N|S|Z)",
                "model": "X4 Soul Infinity $1"
            },
            {
                "regex": "X4[_ ]Soul[_ ]Infinity[_ ]Plus",
                "model": "X4 Soul Infinity Plus"
            },
            {
                "regex": "X([34])_Soul_Lite",
                "model": "X$1 Soul Lite"
            },
            {
                "regex": "X4_Soul_Mini_S(?:_TM)?",
                "model": "X4 Soul Mini S"
            },
            {
                "regex": "X([23456])_Soul_Mini(?:_TM)?",
                "model": "X$1 Soul Mini"
            },
            {
                "regex": "X3_Soul_PLUS",
                "model": "X3 Soul Plus"
            },
            {
                "regex": "X([357])_Soul_Pro",
                "model": "X$1 Soul Pro"
            },
            {
                "regex": "X2_Soul_Style_Plus",
                "model": "X2 Soul Style Plus"
            },
            {
                "regex": "X([23458])_Soul_Style(?:_TM)?",
                "model": "X$1 Soul Style"
            },
            {
                "regex": "X(\\d+)_Soul",
                "model": "X$1 Soul"
            },
            {
                "regex": "V(\\d+)_Viper",
                "model": "V$1 Viper"
            },
            {
                "regex": "X2_Twin",
                "model": "X2 Twin"
            },
            {
                "regex": "A5_Easy(?:_TM)?",
                "model": "A5 Easy"
            },
            {
                "regex": "A([56789])_Lite",
                "model": "A$1 Lite"
            },
            {
                "regex": "A5_Ready(?:_TM)?",
                "model": "A5 Ready"
            },
            {
                "regex": "A5Smiley",
                "model": "A5 Smiley"
            },
            {
                "regex": "A5_Quad_Plus_TM",
                "model": "A5 Quad Plus"
            },
            {
                "regex": "A5_Quad",
                "model": "A5 Quad"
            },
            {
                "regex": "A6_Duo",
                "model": "A6 Duo"
            },
            {
                "regex": "A10_Lite_2019",
                "model": "A10 Lite (2019)"
            },
            {
                "regex": "A10_Lite_2GB",
                "model": "A10 Lite"
            },
            {
                "regex": "A(10|30)_Plus",
                "model": "A$1 Plus"
            },
            {
                "regex": "A10_Max",
                "model": "A10 Max"
            },
            {
                "regex": "Impera S",
                "model": "Impera S"
            },
            {
                "regex": "ALLVIEW P4i",
                "model": "AllDro P4"
            },
            {
                "regex": "Allview_P2",
                "model": "AllDro"
            },
            {
                "regex": "Viva_(i7G)",
                "device": "tablet",
                "model": "Viva $1"
            },
            {
                "regex": "Viva_Home",
                "device": "tv",
                "model": "Viva Home"
            },
            {
                "regex": "AllviewCityPlus",
                "device": "tablet",
                "model": "City Plus"
            },
            {
                "regex": "AllviewCity",
                "device": "tablet",
                "model": "City"
            },
            {
                "regex": "AllviewAX2Frenzy",
                "device": "tablet",
                "model": "AX2 Frenzy"
            },
            {
                "regex": "Allview2SpeedDuo",
                "device": "tablet",
                "model": "Alldro 2 Speed Duo"
            },
            {
                "regex": "Allview3SpeedQuad",
                "device": "tablet",
                "model": "Alldro 3 Speed Quad"
            },
            {
                "regex": "H1003_LTE_PRO([13])",
                "device": "tablet",
                "model": "Viva H1003 LTE Pro $1"
            },
            {
                "regex": "H1003_LTE_PRO",
                "device": "tablet",
                "model": "Viva H1003 LTE Pro"
            },
            {
                "regex": "Viva_1003G_Lite",
                "device": "tablet",
                "model": "Viva 1003G Lite"
            },
            {
                "regex": "H1004_LTE",
                "device": "tablet",
                "model": "Viva H1004 LTE"
            },
            {
                "regex": "Viva[_ ]?H([78]|10)[_ ]?LTE",
                "device": "tablet",
                "model": "Viva H$1 LTE"
            },
            {
                "regex": "Viva_?((?:H80[12]|H100[12]|H701)_LTE|C701|i701G|803G|H10|H7|H801|100[13]G)",
                "device": "tablet",
                "model": "Viva $1"
            },
            {
                "regex": "ALLVIEW ?SPEEDI",
                "device": "tablet",
                "model": "Speed I"
            },
            {
                "regex": "ALLVIEW ?SPEED",
                "device": "tablet",
                "model": "Speed"
            },
            {
                "regex": "ALLVIEWSPEED",
                "device": "tablet",
                "model": "Speed"
            },
            {
                "regex": "AX4Nano[_ ]plus",
                "device": "tablet",
                "model": "AX4 Nano Plus"
            },
            {
                "regex": "AX4Nano",
                "device": "tablet",
                "model": "AX4 Nano"
            },
            {
                "regex": "ALLVIEW_TX1_Quasar",
                "device": "tablet",
                "model": "TX1 Quasar"
            },
            {
                "regex": "AX(50[23]|501Q)",
                "device": "tablet",
                "model": "AX$1"
            },
            {
                "regex": "Allview[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Allview[ _-]([^;/]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Allwinner": {
        "regex": "(?:QUAD-CORE (?:T3 p1|A64 p3|A33 y3|T3 K2001M|T3 k2001o|T3 k2001-nwd)|ZY-07B|UltraOcta-T8|OCTA-CORE T8|OCTOPUS-CORE T8|QUAD-CORE T3 p3|QuadCore-R16)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "QUAD-CORE A64 p3",
                "model": "A64 QUAD-CORE p3"
            },
            {
                "regex": "QUAD-CORE A33 y3",
                "model": "A33 QUAD-CORE y3"
            },
            {
                "regex": "ZY-07B",
                "model": "ZY-07B"
            },
            {
                "regex": "UltraOcta-T8",
                "device": "car browser",
                "model": "Ultra Octa T8"
            },
            {
                "regex": "QUAD-CORE T3 K2001o",
                "device": "car browser",
                "model": "QUAD-CORE T3 K2001O"
            },
            {
                "regex": "QUAD-CORE T3 K(2001M?)",
                "device": "car browser",
                "model": "QUAD-CORE T3 K$1"
            },
            {
                "regex": "QUAD-CORE T3 p([13])",
                "device": "car browser",
                "model": "QUAD-CORE T3 P$1"
            },
            {
                "regex": "OCTA-CORE T8",
                "device": "car browser",
                "model": "OCTA-CORE T8"
            },
            {
                "regex": "OCTOPUS-CORE T8",
                "device": "car browser",
                "model": "OCTOPUS-CORE T8"
            },
            {
                "regex": "QuadCore-R16",
                "device": "car browser",
                "model": "QUAD-CORE R16"
            }
        ]
    },
    "alpsmart": {
        "regex": "(AS51[2456])(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "altron": {
        "regex": "(AL-555|GI-626|OB[_-](?:421|588|728|62[78]))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AL-555",
                "model": "AL-555"
            },
            {
                "regex": "OB[_-](421|588|728|62[78])",
                "model": "OB-$1"
            },
            {
                "regex": "GI-626",
                "device": "phablet",
                "model": "GI-626"
            }
        ]
    },
    "AMGOO": {
        "regex": "AM(350|355|40[257]|41[025]|450|50[689]|52[037]|51[58]|53[05])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AM350",
                "model": "Jack Pro"
            },
            {
                "regex": "AM(355|407)",
                "model": "Tigo"
            },
            {
                "regex": "AM402",
                "model": "Pronto"
            },
            {
                "regex": "AM410",
                "model": "Unico"
            },
            {
                "regex": "AM450",
                "model": "Swift"
            },
            {
                "regex": "AM508",
                "model": "Fuego"
            },
            {
                "regex": "AM509",
                "model": "Uno"
            },
            {
                "regex": "AM515",
                "model": "D1"
            },
            {
                "regex": "AM518",
                "model": "C1"
            },
            {
                "regex": "AM520",
                "model": "Pro"
            },
            {
                "regex": "AM523",
                "model": "Plus"
            },
            {
                "regex": "AM527",
                "model": "Geo"
            },
            {
                "regex": "AM530",
                "model": "A1"
            },
            {
                "regex": "AM535",
                "model": "P1"
            },
            {
                "regex": "AM([0-9]{3})",
                "model": "AM$1"
            }
        ]
    },
    "Amoi": {
        "regex": "Amoi|(?:A862W|Clever[ -]?(?:Gem S52|Gleam S45|Pad P7|Wave S50|Touch S46|JOY S40|Lite S41))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Clever Pad P7",
                "model": "Clever Pad P7"
            },
            {
                "regex": "A862W",
                "model": "A862W"
            },
            {
                "regex": "CLEVER JOY S40",
                "model": "Clever Joy S40"
            },
            {
                "regex": "Clever[ -]?(Gleam S45|Gem S52|Wave S50|Touch S46|Lite S41)",
                "model": "Clever $1"
            },
            {
                "regex": "Amoi[-_ /](CA6)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "Amoi[-_ /]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Amoisonic-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Ainol": {
        "regex": "Numy|novo[0-9]|Novo 10 Hero|AX10PRO|NUMY3GAX9|NOVO10 Spark|Aurora-II|Rainbow(?:II)? 3G",
        "device": "tablet",
        "models": [
            {
                "regex": "Numy 3G AX1",
                "model": "Novo 7 Numy AX1 3G"
            },
            {
                "regex": "Numy[_ ]?3G[_ ]?Sword",
                "model": "Numy 3G Sword"
            },
            {
                "regex": "NOVO10 Spark",
                "model": "Novo 10 Spark"
            },
            {
                "regex": "AX10PRO",
                "model": "Numy AX10 Pro"
            },
            {
                "regex": "Numy_3G_AX3",
                "model": "Numy AX3 Sword"
            },
            {
                "regex": "Numy3GTalos",
                "model": "Numy 3G Talos"
            },
            {
                "regex": "Numy_3G_BW1",
                "model": "Numy 3G Talos 2"
            },
            {
                "regex": "NUMY3GAX9(?:[);/ ]|$)",
                "model": "Numy 3G AX9"
            },
            {
                "regex": "Numy3G_AX10(?:[);/ ]|$)",
                "model": "Numy 3G AX10"
            },
            {
                "regex": "(Novo 10 Hero QuadCore)",
                "model": "$1"
            },
            {
                "regex": "RainbowII 3G",
                "model": "Numy Rainbow-II"
            },
            {
                "regex": "Rainbow 3G",
                "model": "Numy Rainbow"
            },
            {
                "regex": "Aurora-II",
                "model": "Novo 7 Aurora II"
            },
            {
                "regex": "Novo7Fire",
                "model": "Novo 7 Fire"
            },
            {
                "regex": "Novo7 ?Flame(?:[);/ ]|$)",
                "model": "Novo 7 Flame"
            },
            {
                "regex": "novo ?7[_ ]ELF(?:[);/ ]|$)",
                "model": "Novo 7 Elf"
            },
            {
                "regex": "NOVO7(?:[);/ ]|$)",
                "model": "Novo 7"
            },
            {
                "regex": "Numy[ _]([^;/)]+)(?: Build|[;)])",
                "model": "Numy $1"
            },
            {
                "regex": "Novo([0-9]+)[_ -]([^;/)]+)(?: Build|[;)])",
                "model": "Novo $1 $2"
            }
        ]
    },
    "Archos": {
        "regex": "(?:YL-)?Archos|(?:A50TI|AC101BHE|AC50BHE|AC45NE|X67 5G|AC45BHE|AC101PL3GV2|9\\.4 FFF|Tikeasy 10d)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Archos (Oxygen (?:63|57|68XL))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Archos 55 diamond Selfie",
                "model": "55 Diamond Selfie"
            },
            {
                "regex": "A50TI(?:[);/ ]|$)",
                "model": "50 Titanium 4G"
            },
            {
                "regex": "40C TIv2",
                "model": "40c Titanium v2"
            },
            {
                "regex": "45B Titanium",
                "model": "45b Titanium"
            },
            {
                "regex": "AC45BHE",
                "model": "45b Helium"
            },
            {
                "regex": "AC45NE(?:[);/ ]|$)",
                "model": "45 Neon"
            },
            {
                "regex": "X67 5G(?:[);/ ]|$)",
                "model": "X67 5G"
            },
            {
                "regex": "Archos ?5(?:[);/ ]|$)",
                "device": "tablet",
                "model": "5"
            },
            {
                "regex": "AC101BHE(?:[);/ ]|$)",
                "device": "tablet",
                "model": "101B Helium 4G"
            },
            {
                "regex": "T96 WIFI",
                "device": "tablet",
                "model": "T96 WiFi"
            },
            {
                "regex": "AC50BHE(?:[);/ ]|$)",
                "model": "50B Helium 4G"
            },
            {
                "regex": "Archos 80 Oxygen(?:[);/ ]|$)",
                "device": "tablet",
                "model": "80 Oxygen"
            },
            {
                "regex": "Archos 101 Oxygen(?:[);/ ]|$)",
                "device": "tablet",
                "model": "101 Oxygen 4G"
            },
            {
                "regex": "Archos Access 70 3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "70 Access 3G"
            },
            {
                "regex": "Archos Access 101 3G V2",
                "device": "tablet",
                "model": "101 Access 3G V2"
            },
            {
                "regex": "AC101PL3GV2",
                "device": "tablet",
                "model": "101 Platinum 3G V2"
            },
            {
                "regex": "Archos Oxygen 101S ARDOIZ(?:[);/ ]|$)",
                "device": "tablet",
                "model": "101s Oxygen Ardoiz"
            },
            {
                "regex": "Archos Oxygen 101S(?:[);/ ]|$)",
                "device": "tablet",
                "model": "101s Oxygen"
            },
            {
                "regex": "Archos T ?(101X?) 4G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T$1 4G"
            },
            {
                "regex": "Archos Core (101) 3G Ultra",
                "device": "tablet",
                "model": "Core $1 3G Ultra"
            },
            {
                "regex": "Archos Core 3g v4",
                "device": "tablet",
                "model": "Core 101 3G V4"
            },
            {
                "regex": "Archos Core (70|101) 3G",
                "device": "tablet",
                "model": "Core $1 3G"
            },
            {
                "regex": "Archos Hello 7(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Hello 7"
            },
            {
                "regex": "9\\.4 FFF(?:[);/ ]|$)",
                "device": "tablet",
                "model": "9.4\" FFF"
            },
            {
                "regex": "Archos Sense 101 X(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Sense 101 X"
            },
            {
                "regex": "Tikeasy 10d(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tikeasy 10d"
            },
            {
                "regex": "T101 HD 4G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T101 HD 4G"
            },
            {
                "regex": "T101 FHD WiFi(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T101 FHD WiFi"
            },
            {
                "regex": "(?:YL-)?Archos ([^/;]*(?:PAD)[^/;]*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Archos ((?:[789]|10)[0-9]?[a-z]* ?(?:G9|Access|Magnus|G10|Helium|Titanium|Copper|Cobalt|Platini?um|Xenon|Carbon|Neon|XS|IT)[^/);]*)(?: Build|[;)])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Archos ([^/);]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Axxion": {
        "regex": "Axxion ATAB-[0-9]+(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Axxion ATAB-([0-9]+)(?:[);/ ]|$)",
                "model": "ATAB-$1"
            }
        ]
    },
    "MEO": {
        "regex": "MEO TV Box 4K(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box 4K"
    },
    "Ooredoo": {
        "regex": "Sagemcom DIW387_UHD_OOR(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box"
    },
    "MEU": {
        "regex": "MEU ([a-z0-9]+) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Arnova": {
        "regex": "arnova|ARCHM901|AN7CG2|AN7IG3|AN7G2(DTE|I)?|AN7[BCDFH]?G3|A80KSC|AN8G2|AN8[BC]?G3|AN9G2I?|AN9G3|A101[BC](?!M)|AN10G2|AN10BG2(DT|I)?|AN10BG3(DT)?|AN10[CD]G3",
        "device": "tablet",
        "models": [
            {
                "regex": "ARCHM901",
                "model": "M901"
            },
            {
                "regex": "AN7CG2",
                "model": "7c G2"
            },
            {
                "regex": "AN7G2I|AN7G2|AN7G2DTE",
                "model": "7 G2"
            },
            {
                "regex": "AN7G3",
                "model": "7 G3"
            },
            {
                "regex": "AN7IG3",
                "model": "7i G3"
            },
            {
                "regex": "AN7BG3",
                "model": "7b G3"
            },
            {
                "regex": "AN7CG3",
                "model": "7c G3"
            },
            {
                "regex": "AN7DG3-CP",
                "model": "Childpad"
            },
            {
                "regex": "AN7DG3",
                "model": "7d G3"
            },
            {
                "regex": "AN7FG3",
                "model": "7f G3"
            },
            {
                "regex": "AN7HG3",
                "model": "7h G3"
            },
            {
                "regex": "A80KSC",
                "model": "8"
            },
            {
                "regex": "AN8G2",
                "model": "8 G2"
            },
            {
                "regex": "AN8G3",
                "model": "8 G3"
            },
            {
                "regex": "AN8BG3",
                "model": "8b G3"
            },
            {
                "regex": "AN8CG3",
                "model": "8c G3"
            },
            {
                "regex": "AN9G2I",
                "model": "9i G2"
            },
            {
                "regex": "AN9G2",
                "model": "9 G2"
            },
            {
                "regex": "AN9G3",
                "model": "9 G3"
            },
            {
                "regex": "A101B2|A101C|AN10G2",
                "model": "10 G2"
            },
            {
                "regex": "A101B",
                "model": "10"
            },
            {
                "regex": "AN10BG2|AN10BG2DT|AN10BG2I",
                "model": "10b G2"
            },
            {
                "regex": "AN10BG3|AN10BG3DT|AN10BG3-LZ",
                "model": "10b G3"
            },
            {
                "regex": "AN10CG3",
                "model": "10c G3"
            },
            {
                "regex": "AN10DG3",
                "model": "10d G3"
            },
            {
                "regex": "ARNOVA 90G3",
                "model": "90 G3"
            },
            {
                "regex": "ARNOVA 90 G4",
                "model": "90 G4"
            },
            {
                "regex": "ARNOVA 97G4",
                "model": "97 G4"
            },
            {
                "regex": "ARNOVA 101 G4",
                "model": "101 G4"
            },
            {
                "regex": "Arnova ([^/;]*) Build",
                "model": "$1"
            }
        ]
    },
    "ARRIS": {
        "regex": "ARRIS",
        "device": "tv",
        "models": [
            {
                "regex": "Arris_liberty,([a-z0-9-]+),(?:wired|wireless)",
                "model": "$1"
            },
            {
                "regex": "ARRIS[,;] ([^),;/]+)",
                "model": "$1"
            }
        ]
    },
    "Ask": {
        "regex": "ASK[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ASK[ _]791SP[ _]3G",
                "model": "791SP 3G",
                "device": "tablet"
            },
            {
                "regex": "ASK[_ ]([^/;]*) Build",
                "model": "$1"
            }
        ]
    },
    "ANS": {
        "regex": "ANS/|(?: UL40|ACK2326)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "UL40",
                "model": "UL40"
            },
            {
                "regex": "ANS/L51",
                "model": "L51"
            },
            {
                "regex": "ACK2326",
                "model": "Artia"
            }
        ]
    },
    "AOC": {
        "regex": "AOC[;,]|(?:Q10107L-ME)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(Q10107L-ME)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Assistant": {
        "regex": "(AS[-_](?:50[123]|543[1-6]|44[12]1|541[12]|54[23]1|6431|[46]01L)|AP-(?:109|115G|721N|753G|7[25]7G|10[68]|107G|110N|941|719))[;/)_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "AS[-_]401L(?:[);/ ]|$)",
                "model": "Asper"
            },
            {
                "regex": "AS-5432(?:[);/ ]|$)",
                "model": "Agio"
            },
            {
                "regex": "AS[-_](?:5434|501)(?:[);/ ]|$)",
                "model": "Club"
            },
            {
                "regex": "AS_601L(?:[);/ ]|$)",
                "model": "AS-601L"
            },
            {
                "regex": "AS-5433 Secret(?:[);/ ]|$)",
                "model": "Secret"
            },
            {
                "regex": "AS-5433(?:[);/ ]|$)",
                "model": "Max Secret"
            },
            {
                "regex": "AS-5421(?:[);/ ]|$)",
                "model": "Surf"
            },
            {
                "regex": "AS-44[12]1(?:[);/ ]|$)",
                "model": "Unami"
            },
            {
                "regex": "AS-5431(?:[);/ ]|$)",
                "model": "Prima"
            },
            {
                "regex": "AS-502(?:[);/ ]|$)",
                "model": "Shot"
            },
            {
                "regex": "AS-503(?:[);/ ]|$)",
                "model": "Target"
            },
            {
                "regex": "AS-5435(?:[);/ ]|$)",
                "model": "Shine"
            },
            {
                "regex": "AS-5436[ _]",
                "model": "Grid"
            },
            {
                "regex": "AS-6431(?:[);/ ]|$)",
                "model": "Rider"
            },
            {
                "regex": "AS-5411[_ ]",
                "model": "Max Ritm"
            },
            {
                "regex": "AS-5412 Max(?:[);/ ]|$)",
                "model": "AS-5412 Max"
            },
            {
                "regex": "AP-721N(?:[);/ ]|$)",
                "model": "AP-721N Force",
                "device": "tablet"
            },
            {
                "regex": "AP-941(?:[);/ ]|$)",
                "model": "AP-941",
                "device": "tablet"
            },
            {
                "regex": "AP-108(?:[);/ ]|$)",
                "model": "Cetus",
                "device": "tablet"
            },
            {
                "regex": "AP-106(?:[);/ ]|$)",
                "model": "AP-106 Force",
                "device": "tablet"
            },
            {
                "regex": "(AP-(?:109|115G|7[25]7G|753G|107G|110N|719))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(AS-(?:\\d+))(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ark": {
        "regex": "(ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))|Impulse[ _]P[12]|(?:EDGE A5HD|Elf_S8|ICON (R40\\+|R45)|Wizard_[12]|UKOZI U[56]|L925)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))",
                "model": "Benefit $1"
            },
            {
                "regex": "Impulse[ _]P1\\+",
                "model": "Impulse P1 Plus"
            },
            {
                "regex": "Impulse[ _](P[12])",
                "model": "Impulse $1"
            },
            {
                "regex": "EDGE (A5HD)",
                "model": "Edge $1"
            },
            {
                "regex": "ICON (R40\\+|R45)",
                "model": "Icon $1"
            },
            {
                "regex": "Wizard_([12])",
                "model": "Wizard $1"
            },
            {
                "regex": "Elf_S8(?:[);/ ]|$)",
                "model": "Elf S8"
            },
            {
                "regex": "UKOZI U([56])(?:[);/ ]|$)",
                "model": "Ukozi U$1"
            },
            {
                "regex": "L925(?:[);/ ]|$)",
                "model": "Hercls L925"
            }
        ]
    },
    "Garmin-Asus": {
        "regex": "Garmin-Asus|Garminfone",
        "device": "smartphone",
        "models": [
            {
                "regex": "Garminfone[ \\-_]([^;/]*)Build",
                "model": "Garminfone $1"
            },
            {
                "regex": "Garmin-Asus[ \\-_]([^;/]+)Build",
                "model": "$1"
            },
            {
                "regex": "Garmin-Asus[ \\-_]([^;/]+)[\\)/]",
                "model": "$1"
            }
        ]
    },
    "Asus": {
        "regex": "Asus(?! Update)|Transformer|ZenFone Max|MeMOPad 10|TF300T|Slider SL101|PadFone|ME302(?:C|KL)|ME301T|ME371MG|ME17(?:1|2V|3X)|(?:K0[01][0-9a-z]|(?:P(?:00[128ACIL]|01[MTVWYZ]|01MA|01T_1|02[13478])(?: Build|\\))|X015D|X018D|X003|X00[7ABT]D|Z00D|Z00[MTY]D|Z01[7FGHKMR]D)|K01[579N]|AST21|K50IJ)(?:[);/ ]|$)|G55[023]KL|ZB(631|602|633|55[135]|50[01])KL|ZC(55[134]|520|600)KL|ZA550KL|ZE(5[02]0|620|55[2345])KL|ZD55[23]KL|ZS6(?:61|7[02136])KS|ZS(6[0236]0|55[10])KL|ZS590KS|ZB(500KG|601KL)|MeMo Pad FHD 10 LTE|Z00[SV]D|P01Y_S|Zenfone 5Z?|AOSP on Duma|Tinker Board(?: S)?|TX201LA|I005DA|I003D|Z00UDH",
        "device": "smartphone",
        "models": [
            {
                "regex": "XPad 10 ?LTE(?:[);/ ]|$)",
                "model": "XPad 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "ME171(?:[);/ ]|$)",
                "model": "Eee Pad MeMO 171",
                "device": "tablet"
            },
            {
                "regex": "ASUS Z906(?:[);/ ]|$)",
                "model": "Z906 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "ME172V",
                "model": "MeMO Pad",
                "device": "tablet"
            },
            {
                "regex": "ME302C(?:[);/ ]|$)",
                "model": "MeMO Pad FHD 10",
                "device": "tablet"
            },
            {
                "regex": "(?:ME302KL|MeMOPad 10FHD LTE|MeMo Pad FHD 10 LTE|AOSP on Duma)(?:[);/ ]|$)",
                "model": "MeMO Pad FHD 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "ME301T(?:[);/ ]|$)",
                "model": "MeMO Pad Smart 10",
                "device": "tablet"
            },
            {
                "regex": "Z101 Prime(?:[);/ ]|$)",
                "model": "Z101 Prime",
                "device": "tablet"
            },
            {
                "regex": "Z101(?:[);/ ]|$)",
                "model": "Z101",
                "device": "tablet"
            },
            {
                "regex": "(?:X Pad 10 LTE|ASUSXPad10)(?:[);/ ]|$)",
                "model": "X Pad 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:K01[3A7]|K007|K00R)(?:[);/ ]|$)|MeMO Pad 7",
                "model": "MeMO Pad 7",
                "device": "tablet"
            },
            {
                "regex": "K01E(?:[);/ ]|$)",
                "model": "MeMO Pad 10 ME103K",
                "device": "tablet"
            },
            {
                "regex": "K00U|ME173X(?:[);/ ]|$)",
                "model": "MeMO Pad HD 7",
                "device": "tablet"
            },
            {
                "regex": "(?:K01[15]|K00L|AST21)(?:[);/ ]|$)",
                "model": "MeMO Pad 8",
                "device": "tablet"
            },
            {
                "regex": "K014(?:[);/ ]|$)",
                "model": "MeMO Pad 8.9",
                "device": "tablet"
            },
            {
                "regex": "K00S(?:[);/ ]|$)",
                "model": "MeMO Pad HD 7 Dual SIM",
                "device": "tablet"
            },
            {
                "regex": "K00F(?:[);/ ]|$)",
                "model": "MeMO Pad 10",
                "device": "tablet"
            },
            {
                "regex": "K00C(?:[);/ ]|$)",
                "model": "Transformer Pad TF701T",
                "device": "tablet"
            },
            {
                "regex": "K010(?:[);/ ]|$)",
                "model": "Transformer Pad TF103C",
                "device": "tablet"
            },
            {
                "regex": "K018(?:[);/ ]|$)",
                "model": "Transformer Pad TF103CG",
                "device": "tablet"
            },
            {
                "regex": "TF300T(?:[);/ ]|$)",
                "model": "Transformer Pad TF300T",
                "device": "tablet"
            },
            {
                "regex": "K01B(?:[);/ ]|$)",
                "model": "Transformer Pad TF303K",
                "device": "tablet"
            },
            {
                "regex": "TX201LA(?:[);/ ]|$)",
                "model": "Transformer Book Trio",
                "device": "tablet"
            },
            {
                "regex": "Slider SL101",
                "model": "Eee Pad Slider SL101",
                "device": "tablet"
            },
            {
                "regex": "P01[YZ](?:_S)?",
                "model": "ZenPad C 7.0",
                "device": "tablet"
            },
            {
                "regex": "P008 Build",
                "model": "ZenPad Z8",
                "device": "tablet"
            },
            {
                "regex": "P001",
                "model": "ZenPad Z10",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P00J",
                "model": "ZenPad Z8s",
                "device": "tablet"
            },
            {
                "regex": "P01[VW]|P002",
                "model": "ZenPad 7.0",
                "device": "tablet"
            },
            {
                "regex": "(?:P024|P00A)(?:[);/ ]|$)",
                "model": "ZenPad 8.0",
                "device": "tablet"
            },
            {
                "regex": "P01MA?(?:[);/ ]|$)",
                "model": "ZenPad S 8.0",
                "device": "tablet"
            },
            {
                "regex": "ASUS_(w706)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "P027",
                "model": "ZenPad 3S 10",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P00I",
                "model": "ZenPad 3S 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P008",
                "model": "ZenPad 3 8.0",
                "device": "tablet"
            },
            {
                "regex": "(?:ASUS_)?P00C|P02[138]|P00L|P01T_1",
                "model": "ZenPad 10",
                "device": "tablet"
            },
            {
                "regex": "ASUS Tablet P1801-T",
                "model": "Transformer AiO P1801 18.4\"",
                "device": "tablet"
            },
            {
                "regex": "ASUS TAB A8",
                "model": "TAB A8",
                "device": "tablet"
            },
            {
                "regex": "ME371MG(?:[);/ ]|$)",
                "model": "Fonepad",
                "device": "phablet"
            },
            {
                "regex": "K00G(?:[);/ ]|$)",
                "model": "Fonepad Note 6",
                "device": "phablet"
            },
            {
                "regex": "(?:K01[2N9]|K00E)(?:[);/ ]|$)",
                "model": "Fonepad 7",
                "device": "phablet"
            },
            {
                "regex": "K00Z(?:[);/ ]|$)",
                "model": "Fonepad 7 Dual SIM",
                "device": "phablet"
            },
            {
                "regex": "K016(?:[);/ ]|$)",
                "model": "Fonepad 8",
                "device": "phablet"
            },
            {
                "regex": "(?:ASUS_)?A001D|ZB634KL",
                "model": "ZenFone Max Shot"
            },
            {
                "regex": "(?:ASUS_)?T00N",
                "model": "PadFone S"
            },
            {
                "regex": "(?:ASUS_)?T00[CE]",
                "model": "PadFone Mini"
            },
            {
                "regex": "(?:ASUS[-_])?T00T",
                "model": "PadFone X Mini"
            },
            {
                "regex": "PadFone T008",
                "model": "PadFone E"
            },
            {
                "regex": "PadFone T004",
                "model": "PadFone Infinity"
            },
            {
                "regex": "(?:ASUS_)?A002(A)?",
                "model": "ZenFone AR"
            },
            {
                "regex": "(?:ASUS_)?AI2401_H",
                "model": "ZenFone 11 Ultra"
            },
            {
                "regex": "(?:ASUS_?)?AI2501H",
                "model": "ZenFone 12 Ultra"
            },
            {
                "regex": "(?:ASUS_)?(?:I006D|ZS590KS)",
                "model": "ZenFone 8"
            },
            {
                "regex": "(?:ASUS_)?(?:I004D|ZS672KS)",
                "model": "ZenFone 8 Flip"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2202)",
                "model": "ZenFone 9"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2302)",
                "model": "ZenFone 10"
            },
            {
                "regex": "(?:ASUS_)?A006",
                "model": "ZenFone V"
            },
            {
                "regex": "(?:ASUS_)?A009",
                "model": "ZenFone V Live"
            },
            {
                "regex": "(?:ASUS_)?Z007",
                "model": "ZenFone C"
            },
            {
                "regex": "(?:ASUS_)?(X00P[SD]|ZB555KL)",
                "model": "ZenFone Max M1"
            },
            {
                "regex": "(?:ASUS_)?(?:ZB60[12]KL)|ZenFone Max Pro M1",
                "model": "ZenFone Max Pro M1"
            },
            {
                "regex": "(?:ASUS[_-])?(X01([AB]D)|ZB633KL)(?:[);/ ]|$)",
                "model": "ZenFone Max M2"
            },
            {
                "regex": "(?:ASUS_)?(?:Z00[AD]|Z008D|Z008|Z00AD[AB]?|ZE551ML)",
                "model": "ZenFone 2"
            },
            {
                "regex": "(?:ASUS_)?(?:ZenFone 2E)",
                "model": "ZenFone 2E"
            },
            {
                "regex": "(?:ASUS_)?(?:A007|Z00YD|ZA550KL|ZB553KL|ZB501KL)(?:[);/ ]|$)",
                "model": "ZenFone Live"
            },
            {
                "regex": "(?:ASUS_)?(?:X00RD|G552KL)",
                "model": "ZenFone Live L1"
            },
            {
                "regex": "G553KL",
                "model": "ZenFone Lite L1"
            },
            {
                "regex": "(?:ASUS_)?(?:Z00[ERLMTW]D|Z011D|ZE500KL)",
                "model": "ZenFone 2 Laser"
            },
            {
                "regex": "(?:ASUS_)?(?:T00[IQ1]|Z01KD)",
                "model": "ZenFone 4"
            },
            {
                "regex": "(?:ASUS_)?T00P",
                "model": "ZenFone 5 LTE"
            },
            {
                "regex": "(?:ASUS_)?(?:T00K|X017DA|X017D|ZC600KL)",
                "model": "ZenFone 5 Lite"
            },
            {
                "regex": "(?:ASUS_)?(?:Z01RD|ZS620KL)|Zenfone 5Z",
                "model": "ZenFone 5Z"
            },
            {
                "regex": "(?:ASUS_)?(?:T00[JF]|X00QD|X00QSA|ZE620KL)|Zenfone 5",
                "model": "ZenFone 5"
            },
            {
                "regex": "(?:ASUS_)?(?:T00G|Z002|ZS630KL|I01WD[X]?)",
                "model": "ZenFone 6"
            },
            {
                "regex": "(?:ASUS_)?ZS671KS",
                "model": "ZenFone 7 Pro"
            },
            {
                "regex": "(?:ASUS_)?(?:ZS670KS|I002D|AI2205_C)(?:[);/ ]|$)",
                "model": "ZenFone 7"
            },
            {
                "regex": "(?:ASUS_)?Z010D",
                "model": "ZenFone Max"
            },
            {
                "regex": "(?:ASUS_)?X018D",
                "model": "ZenFone Max Plus M1"
            },
            {
                "regex": "(?:ASUS_)?X00TD?",
                "model": "ZenFone Max Pro M1"
            },
            {
                "regex": "(?:ASUS_)?(?:X01BDA|ZB631KL|Zenfone Max Pro M2)",
                "model": "ZenFone Max Pro M2"
            },
            {
                "regex": "(?:ASUS_)?X014D",
                "model": "ZenFone Go Plus"
            },
            {
                "regex": "(?:ASUS_)?(L001|X00[7AB]D|X009[DB][DA]|X009D|Z00[SV]D|ZB500K[LG]|ZB551KL)",
                "model": "ZenFone Go"
            },
            {
                "regex": "(?:ASUS_)?(?:G550KL|X013DB)",
                "model": "ZenFone Go TV"
            },
            {
                "regex": "(?:ASUS_)?X013D",
                "model": "ZenFone Go Life"
            },
            {
                "regex": "(?:ASUS_)?Z00[SV]D",
                "model": "ZenFone Go"
            },
            {
                "regex": "(?:ASUS_)?(X00[23])",
                "model": "ZenFone Pegasus"
            },
            {
                "regex": "(?:ASUS_)?X005",
                "model": "ZenFone Pegasus 5000"
            },
            {
                "regex": "(?:ASUS_)?X550",
                "model": "ZenFone Pegasus 2 Plus"
            },
            {
                "regex": "(?:ASUS_)?(X00GD)",
                "model": "ZenFone Pegasus 3S Max"
            },
            {
                "regex": "(?:ASUS_)?(?:X00D[DS]|X008D)|ZC553KL",
                "model": "ZenFone 3 Max"
            },
            {
                "regex": "(?:ASUS_)?(X008)",
                "model": "ZenFone 3 Pegasus"
            },
            {
                "regex": "(?:ASUS_)?(ZE553KL|Z01HDA?)",
                "model": "ZenFone 3 Zoom"
            },
            {
                "regex": "(?:ASUS_)?ZS550KL",
                "model": "ZenFone 3 Deluxe"
            },
            {
                "regex": "(?:ASUS_)?Z00UD",
                "model": "ZenFone Selfie"
            },
            {
                "regex": "(?:ASUS_)?(Z016[DS]|Z01FD)",
                "model": "ZenFone 3 Deluxe"
            },
            {
                "regex": "(?:ASUS_)?Z(?:017DA|E520KL|E552KL|017D|012(?:DC?|S))",
                "model": "ZenFone 3"
            },
            {
                "regex": "(?:ASUS_)?Z01B[DS]|ZC551KL",
                "model": "ZenFone 3 Laser"
            },
            {
                "regex": "(?:ASUS_)?A001",
                "model": "ZenFone 3 Ultra"
            },
            {
                "regex": "(?:ASUS_)?(?:ZD552KL|Z01MDA?)(?:[);/ ]|$)",
                "model": "ZenFone 4 Selfie Pro"
            },
            {
                "regex": "(?:ASUS_)?(?:X00LDA|ZD553KL)",
                "model": "ZenFone 4 Selfie"
            },
            {
                "regex": "(?:ASUS_)?(?:X00LD|Z01KS|Z01KDA|ZE554KL)",
                "model": "ZenFone 4"
            },
            {
                "regex": "(?:ASUS_)?X00(?:[HIK]D|IS)|ZC554KL|ZC520KL",
                "model": "ZenFone 4 Max"
            },
            {
                "regex": "(?:ASUS_)?X015D",
                "model": "ZenFone 4 Max Plus"
            },
            {
                "regex": "(?:ASUS_)?(:?Z01G[DS]|ZS551KL)",
                "model": "ZenFone 4 Pro"
            },
            {
                "regex": "(?:ASUS_)?Z00XS",
                "model": "ZenFone Zoom"
            },
            {
                "regex": "(?:ASUS_)?(?:Z01QD|ZS600KL)",
                "model": "ROG Phone"
            },
            {
                "regex": "(?:ASUS_)?(?:I001D[ABCE]?|ZS660KL)",
                "model": "ROG Phone 2"
            },
            {
                "regex": "(?:ASUS_)?(?:I003DD?|ZS661KS)",
                "model": "ROG Phone 3"
            },
            {
                "regex": "(?:ASUS_)?(?:I005D[AC]?|ZS67[36]KS|ROG Phone 5)",
                "model": "ROG Phone 5"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2201)",
                "model": "ROG Phone 6"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2203)",
                "model": "ROG Phone 6D"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2205)",
                "model": "ROG Phone 7"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2401_[DE])",
                "model": "ROG Phone 8 Pro"
            },
            {
                "regex": "(?:ASUS_)?(?:AI2401)",
                "model": "ROG Phone 8"
            },
            {
                "regex": "(?:ASUS_?)?(?:AI2501[BE])",
                "model": "ROG Phone 9"
            },
            {
                "regex": "(?:ASUS_?)?(?:AI2501)",
                "model": "ROG Phone 9 Pro"
            },
            {
                "regex": "(?:ASUS_)?(?:I007D)",
                "model": "Smartphone for Snapdragon Insiders"
            },
            {
                "regex": "ZN220IC",
                "device": "desktop",
                "model": "Zen AiO ZN220IC"
            },
            {
                "regex": "(K50IJ)(?:[);/ ]|$)",
                "device": "desktop",
                "model": "$1"
            },
            {
                "regex": "Tinker Board( S)?",
                "device": "peripheral",
                "model": "Tinker Board$1"
            },
            {
                "regex": "asus_google_cube",
                "device": "tv",
                "model": "Cube"
            },
            {
                "regex": "(?:ASUS_)?ZenWatch( 2)?",
                "device": "wearable",
                "model": "ZenWatch$1"
            },
            {
                "regex": "Asus(?:-|;)?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(PadFone(?: [^;/]+)?) Build",
                "model": "$1"
            },
            {
                "regex": "(PadFone(?: [a-z0-9]+)?)",
                "model": "$1"
            },
            {
                "regex": "(?:Asus|Transformer) ((?:Pad |Prime )?TF[0-9a-z]+)",
                "device": "tablet",
                "model": "Transformer $1"
            },
            {
                "regex": "Chromebook Flip (C10[01]PA|C302)",
                "device": "desktop",
                "model": "Chromebook Flip $1"
            }
        ]
    },
    "Audiovox": {
        "regex": "Audiovox|(?<!M5 lite )CDM|UTS(?:TARCOM)?\\-|audio(?!book)[a-z0-9-]+",
        "device": "smartphone",
        "models": [
            {
                "regex": "Audiovox[_\\-]([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "CDM(?:-)?([a-z0-9]+)",
                "model": "CDM-$1"
            },
            {
                "regex": "UTS(?:TARCOM)?-([a-z0-9-]+)",
                "model": "CDM-$1"
            },
            {
                "regex": "audio([a-z0-9-]+)",
                "model": "CDM-$1"
            }
        ]
    },
    "AVH": {
        "regex": "Excer[ _]",
        "device": "tablet",
        "models": [
            {
                "regex": "Excer[ _]G5\\.([236])",
                "model": "Excer G5.$1"
            },
            {
                "regex": "Excer[ _]G5",
                "model": "Excer G5"
            },
            {
                "regex": "Excer[ _]10[ _]PRO",
                "model": "Excer 10 Pro"
            },
            {
                "regex": "Excer[ _]8",
                "model": "Excer 8"
            }
        ]
    },
    "Avvio": {
        "regex": "Avvio[ _]?([a-z0-9-]+)|(?:CHIVAS_55|Colombia_2018|Mint_M353)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CHIVAS_55",
                "model": "Chivas 55"
            },
            {
                "regex": "Mint_M353",
                "model": "Mint M353"
            },
            {
                "regex": "Colombia_2018",
                "model": "Colombia (2018)"
            },
            {
                "regex": "Avvio[ _]PAD",
                "model": "PAD",
                "device": "tablet"
            },
            {
                "regex": "Avvio[ _]?([a-z0-9-]+)",
                "model": "$1"
            }
        ]
    },
    "AXEN": {
        "regex": "LGE; (AX[a-z0-9-]+);",
        "device": "tv",
        "model": "$1"
    },
    "Azumi Mobile": {
        "regex": "Azumi[_ -]|(?:SPEED55|A50_Style_Plus|LT50\\+|KIREI A5Q PLUS|NOBU[ _]A55[ _]PRO|IRO A55 QL?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Azumi[_ -]AKANE",
                "model": "Akane"
            },
            {
                "regex": "Azumi[_ -]A4\\+",
                "model": "A4 Plus"
            },
            {
                "regex": "Azumi[_ -]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Azumi[_ -]([a-z0-9_]+)",
                "model": "$1"
            },
            {
                "regex": "SPEED55",
                "model": "Speed 5.5\""
            },
            {
                "regex": "A50_Style_Plus",
                "model": "A50 Style Plus"
            },
            {
                "regex": "IRO A55 Q",
                "model": "IRO A55 Q"
            },
            {
                "regex": "LT50\\+",
                "model": "LT50 Plus"
            },
            {
                "regex": "KIREI A5Q PLUS",
                "model": "Kirei A5Q Plus"
            },
            {
                "regex": "NOBU[ _]A55[ _]PRO",
                "model": "Nobu A55 Pro"
            }
        ]
    },
    "Barnes & Noble": {
        "regex": "Nook|BN[TR]V[0-9]+",
        "device": "tablet",
        "models": [
            {
                "regex": "Nook([a-z0-9]+)",
                "model": "Nook $1"
            },
            {
                "regex": "Nook[ _]([^/;]+)[ _]Build",
                "model": "Nook $1"
            },
            {
                "regex": "(BN[TR]V[0-9]+)",
                "model": "Nook $1"
            }
        ]
    },
    "BGH": {
        "regex": "(?!Positivo )BGH ([^/;)]+)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Y([17]00|2[01]0|1010)",
                "device": "tablet",
                "model": "Y$1"
            },
            {
                "regex": "BGH (\\+Simple|Mini|M840)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Y710 KIDS",
                "device": "tablet",
                "model": "Y710 Kids"
            },
            {
                "regex": "JOY X2",
                "model": "Joy X2"
            },
            {
                "regex": "BGH ([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Bitel": {
        "regex": "Bitel[ _-]([^/;]+) Build|(?:B(?:840[5-9]|841[0456]|850[2346]|860[146]|9401|950[1-5])|S8402L?|S8501L?|BPRO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(B(?:840[5789]|841[0456]|850[2346]|860[146]|9401|950[12345])|S8402L?|S8501L?)",
                "model": "$1"
            },
            {
                "regex": "BPRO(?:[);/ ]|$)",
                "model": "B Pro"
            },
            {
                "regex": "Bitel[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "GDL": {
        "regex": "GDL[_ ](Xtreme 4)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Blu": {
        "regex": "BLU[ _]|(?:blu|(?<!DROIDZ )Dash)[ _]([^/;)]+)(?: Build|[;)])|(?:Studio[ _](G3|J8M|X10L|X12|5\\.0K|5\\.5|View(?: XL)?|Mega(?: LTE)?|C 8\\+8|[CGM][ _]HD|G2 HD|G4|[CGX]|SELFIE|Selfie LTE|Touch|M[45] Plus|J[1258]|X[89] HD|X10\\+?|XL(?: 2)?)|Advance (4\\.0 ?[LM]|5\\.[02](?: HD)?|A[467]|L[45]|A5 Plus|A5 LTE)|M6 2021|ENERGY (DIAMOND|XL)|ENERGY[_ ]DIAMOND[_ ]MINI|Energy X 2|LIFE XL|B110DL|Dash (?:X[2L]|L3)|PURE (?:X[LR]|MINI|View)|Life One X[23]|G50 (?:Mega|Plus)|G51 Plus|G90(?: PRO)?|G91 Pro|GRAND (?:M3|Max|5\\.5 HD|XL LTE|Mini|Energy)|R1 (?:HD|PLUS)|R2 (?:LTE|Plus)|Tank Xtreme [45]\\.0|Tank Xtreme(?: Pro)?|Touchbook M7 Pro|DASH X PLUS|C[456] 2019|BOLD (?:M7|N[123]|K[15]0)|B1[34]0DL|Vivo (?:5 Mini|One Plus|5R|XL[234]| Plus|8L|XI[+]?|GO)|(?<!Neffos )C[56]L(?: 2020)?|C6 2020|G9 PRO|D701|VIEW 1|B13[15]DL|R2 3G|Grand (?:M2X?|XL|M2 LTE)|D600|D5[01]0|B1550VL|DIAMOND M|M8L Plus|STUDIO ENERGY|M8L 2022|LIFE X8|M10L (?:Pro|PLUS)|G71 PLUS|G52L|G61S|G91S|Studio Mini 2023|B(?:160|300)V|Android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:G[57]0|G[679]1)|Android 11(?:[\\d.]*);(?: [\\w-]+;)? J9L|Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:G53)|F92 E 5G|(?<!Neffos |CAMELEON )C5 (?:Max|Plus|LTE))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F92 E 5G",
                "model": "F92 E 5G"
            },
            {
                "regex": "Advance A5 Plus",
                "model": "Advance A5 Plus LTE"
            },
            {
                "regex": "Advance A5 LTE",
                "model": "Advance A5 LTE"
            },
            {
                "regex": "Advance (4\\.0 ?[LM]|4\\.0|5\\.[02](?: HD)?|A[46]|L[54])",
                "model": "Advance $1"
            },
            {
                "regex": "M6 2021(?:[);/ ]|$)",
                "model": "M6 (2021)"
            },
            {
                "regex": "STUDIO X Mini",
                "model": "Studio X Mini"
            },
            {
                "regex": "Studio X10 2022",
                "model": "Studio X10 (2022)"
            },
            {
                "regex": "Studio Mini 2023",
                "model": "Studio Mini (2023)"
            },
            {
                "regex": "STUDIO G PLUS",
                "model": "Studio G Plus"
            },
            {
                "regex": "STUDIO G Max",
                "model": "Studio G Max"
            },
            {
                "regex": "(?:BLU[_ ])?Studio[ _](G3|J8M|5\\.0 C|5\\.5|C 5\\+5 LTE|View(?: XL)?|Mega(?: LTE)?|C 8\\+8|G HD LTE|[CG][ _]HD|C|G|Touch|M HD|G2 HD|M[45] Plus|J[1258]|X[89] HD|X5|X10\\+?|XL(?: 2)?|X|G4)(?:[);/ ]|$)",
                "model": "Studio $1"
            },
            {
                "regex": "(?:BLU[_ ])?Studio[ _]5\\.0 ?K(?:[);/ ]|$)",
                "model": "Studio 5.0 K"
            },
            {
                "regex": "STUDIO SELFIE LTE",
                "model": "Studio Selfie LTE"
            },
            {
                "regex": "STUDIO ONE",
                "model": "Studio One"
            },
            {
                "regex": "STUDIO ENERGY",
                "model": "Studio Energy"
            },
            {
                "regex": "STUDIO[_ ](X10L|X12|G2)(?:[);/ ]|$)",
                "model": "Studio $1"
            },
            {
                "regex": "STUDIO SELFIE ([23]|LTE)",
                "model": "Studio Selfie $1"
            },
            {
                "regex": "STUDIO SELFIE",
                "model": "Studio Selfie"
            },
            {
                "regex": "(?:BLU[_ ])?NEO_ENERGY_MINI",
                "model": "Neo Energy Mini"
            },
            {
                "regex": "ENERGY[_ ]DIAMOND[_ ]MINI",
                "model": "Energy Diamond Mini"
            },
            {
                "regex": "ENERGY DIAMOND",
                "model": "Energy Diamond"
            },
            {
                "regex": "DIAMOND M",
                "model": "Diamond M"
            },
            {
                "regex": "Grand Energy",
                "model": "Grand Energy"
            },
            {
                "regex": "ENERGY XL",
                "model": "Energy XL"
            },
            {
                "regex": "Energy X 2",
                "model": "Energy X 2"
            },
            {
                "regex": "ENERGY X PLUS 2",
                "model": "Energy X Plus 2"
            },
            {
                "regex": "ENERGY X PLUS",
                "model": "Energy X Plus"
            },
            {
                "regex": "B300V",
                "model": "Flex"
            },
            {
                "regex": "LIFE XL",
                "model": "Life XL"
            },
            {
                "regex": "DASH[ _]X[ _]PLUS[ _]LTE",
                "model": "Dash X Plus LTE"
            },
            {
                "regex": "DASH X PLUS",
                "model": "Dash X Plus"
            },
            {
                "regex": "DASH 4\\.5",
                "model": "Dash 4.5"
            },
            {
                "regex": "Dash XL",
                "model": "Dash XL"
            },
            {
                "regex": "PURE (X[LR]|View)",
                "model": "Pure $1"
            },
            {
                "regex": "PURE MINI",
                "model": "Pure Mini"
            },
            {
                "regex": "BOLD (M7|N[123]|K[15]0)",
                "model": "Bold $1"
            },
            {
                "regex": "Life One X2 Mini",
                "model": "Life One X2 Mini"
            },
            {
                "regex": "LIFE ONE (X[23]?)",
                "model": "Life One $1"
            },
            {
                "regex": "LIFE ONE",
                "model": "Life One"
            },
            {
                "regex": "LIFE X LTE",
                "model": "Life X LTE"
            },
            {
                "regex": "LIFE X8",
                "model": "Life X8"
            },
            {
                "regex": "LIFE MARK",
                "model": "Life Mark"
            },
            {
                "regex": "NEO X PLUS",
                "model": "Neo X Plus"
            },
            {
                "regex": "NEO (XL|X|5\\.5)",
                "model": "Neo $1"
            },
            {
                "regex": "G50 Mega",
                "model": "G50 Mega"
            },
            {
                "regex": "G(5[01]|71) Plus",
                "model": "G$1 Plus"
            },
            {
                "regex": "G(9[01]?) PRO",
                "model": "G$1 Pro"
            },
            {
                "regex": "(G[579]0|G[679]1|D701|R2 3G|G52L|G91S|G61S)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(J9L|G53)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GRAND 5\\.5 HD",
                "model": "Grand 5.5 HD"
            },
            {
                "regex": "Grand X LTE",
                "model": "Grand X LTE"
            },
            {
                "regex": "Grand XL LTE",
                "model": "Grand XL LTE"
            },
            {
                "regex": "Grand M2 LTE",
                "model": "Grand M2 LTE"
            },
            {
                "regex": "Grand (M2X?|XL)",
                "model": "Grand $1"
            },
            {
                "regex": "Grand Max",
                "model": "Grand Max"
            },
            {
                "regex": "Grand Mini",
                "model": "Grand Mini"
            },
            {
                "regex": "Grand M3",
                "model": "Grand M3"
            },
            {
                "regex": "B110DL",
                "model": "View Mega"
            },
            {
                "regex": "B1550VL",
                "model": "View Speed 5G"
            },
            {
                "regex": "B13[01]DL",
                "model": "View 2"
            },
            {
                "regex": "B135DL",
                "model": "View 4"
            },
            {
                "regex": "B160V",
                "model": "View 5"
            },
            {
                "regex": "B140DL",
                "model": "View 3"
            },
            {
                "regex": "VIEW 1",
                "model": "View 1"
            },
            {
                "regex": "R1 HD",
                "model": "R1 HD"
            },
            {
                "regex": "R2 LTE",
                "model": "R2 LTE"
            },
            {
                "regex": "R([12]) PLUS",
                "model": "R$1 Plus"
            },
            {
                "regex": "C([456]) 20(19|20)",
                "model": "C$1 (20$2)"
            },
            {
                "regex": "(?:BLU[_ ])?TankMega_3G",
                "model": "Tank Mega"
            },
            {
                "regex": "Tank Xtreme ([45])\\.0",
                "model": "Tank Xtreme $1.0\""
            },
            {
                "regex": "Tank Xtreme Pro",
                "model": "Tank Xtreme Pro"
            },
            {
                "regex": "Tank Xtreme",
                "model": "Tank Xtreme"
            },
            {
                "regex": "VIVO AIR LTE",
                "model": "Vivo Air LTE"
            },
            {
                "regex": "Touchbook G7",
                "model": "Touchbook G7"
            },
            {
                "regex": "C5 (Max|Plus|LTE)(?:[);/ ]|$)",
                "model": "C5 $1"
            },
            {
                "regex": "C6L Max",
                "model": "C6L Max"
            },
            {
                "regex": "C([56])L 20(20|21)",
                "model": "C$1L (20$2)"
            },
            {
                "regex": "C5L Plus",
                "model": "C5L Plus"
            },
            {
                "regex": "C5L Max",
                "model": "C5L Max"
            },
            {
                "regex": "C([56])L",
                "model": "C$1L"
            },
            {
                "regex": "(?:BLU[_ ])?VIVO[ _]SELFIE",
                "model": "Vivo Selfie"
            },
            {
                "regex": "(?:BLU[_ ])?Vivo 5 Mini",
                "model": "Vivo 5 Mini"
            },
            {
                "regex": "Vivo One Plus 2019",
                "model": "Vivo One Plus (2019)"
            },
            {
                "regex": "(?:BLU[_ ])?Vivo (One|XL3|XI)(?: Plus|[+])",
                "model": "Vivo $1 Plus"
            },
            {
                "regex": "(?:BLU[_ ])?Vivo (5R|XI|XL[234]|8L)",
                "model": "Vivo $1"
            },
            {
                "regex": "(?:BLU[_ ])?VIVO GO",
                "model": "Vivo Go"
            },
            {
                "regex": "(?:BLU[_ ])?ZOEY_SMART",
                "model": "Zoey Smart"
            },
            {
                "regex": "(?:BLU[_ ])?(D600|D5[01]0)",
                "model": "$1"
            },
            {
                "regex": "Touchbook M7 Pro",
                "model": "Touchbook M7 Pro",
                "device": "tablet"
            },
            {
                "regex": "M(8|10)L Plus",
                "model": "M$1L Plus",
                "device": "tablet"
            },
            {
                "regex": "M(10)L Pro",
                "model": "M$1L Pro",
                "device": "tablet"
            },
            {
                "regex": "M8L (2022)",
                "model": "M8L ($1)",
                "device": "tablet"
            },
            {
                "regex": "STUDIO 7\\.0 II",
                "model": "Studio 7.0\" II",
                "device": "tablet"
            },
            {
                "regex": "Advance A7",
                "model": "Advance A7",
                "device": "tablet"
            },
            {
                "regex": "DASH (L[45] LTE|5\\.0|L[45]X|L3|X2|[LMX])(?:[);/ ]|$)",
                "model": "Dash $1"
            },
            {
                "regex": "DASH[ _]([^)/;]+)(?: Build|\\))",
                "model": "Dash $1"
            },
            {
                "regex": "blu[ _]([^/;]+)( Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Bluegood": {
        "regex": "BLUEGOOD",
        "device": "smartphone",
        "models": [
            {
                "regex": "V6",
                "model": "V6"
            }
        ]
    },
    "Blackview": {
        "regex": "Blackview|(BL8[08]00|BV([24-9]000|8[128]00|[468]900|(5[1589]|9[135689])00|6[12368]00|7[13]00)(?:[ _](?:PRO))?|(?<!Titan )P10000(?:[ _](?:PRO))?|omega[ _]pro|Alife[ _][PS]1|N6000|Heatwave|DM550|BV9700Pro|BL9000 Pro|(?<!Lenovo[_ ])A[68]0(?:Pro)?\\))|(?:SOLID 4 G2|A[86]0Plus|A80S|BL(?:6000|8800)Pro|R6 Lite|P2Lite|A8 MAX|A30-RU|A20Pro|Android 10(?:[\\d.]*);(?: [\\w-]+;)? Tab[89]|Android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:A80)|Android 11(?:[\\d.]*);(?: [\\w-]+;)? (?:A95|A100|BL5000|Tab 12)|Android 1[12](?:[\\d.]*);(?: [\\w-]+;)? (?:A[79]0|A70 Pro|A55 Pro|Tab 1[01356]|Tab 6)|Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:A200 Pro|Tab [86]0|Tab 18|BL9000)|BV500|BV4800|BV[579]200|SOLID_4G1|BV5300(?: Pro| Plus)?|Tab A5 Kids|Tab [56]0 Kids|Active (?:8|1[02]) Pro|Active 8|SHARK [89]|Tab 8E|Tab (?:[579]0|[789]|1[01]) WiFi|COLOR [68]|Tab (?:1[236]|60) Pro|MEGA [128]|WAVE 6C|WAVE 8C?|HERO 10|A52 Pro| E7s|Tab 90|XPLORE [12])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A([2678]0|5[25]) ?Pro(?:[);/ ]|$)",
                "model": "A$1 Pro"
            },
            {
                "regex": "A([6798]0|9[56]|55|100)(?: Build|[;)])",
                "model": "A$1"
            },
            {
                "regex": "A8 MAX(?:[);/ ]|$)",
                "model": "A8 Max"
            },
            {
                "regex": "A80S(?:[);/ ]|$)",
                "model": "A80S"
            },
            {
                "regex": "A30-RU",
                "model": "A30"
            },
            {
                "regex": "(A[86]0|BV[59]500)Plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(P2|R6) ?Lite",
                "model": "$1 Lite"
            },
            {
                "regex": "BV9000Pro-F",
                "model": "BV9000 Pro"
            },
            {
                "regex": "(BL[69]000|BL8800|BV(?:[0-9]+)|A200) ?Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "N6000 SE",
                "model": "N6000 SE"
            },
            {
                "regex": "(BL[579]000|BV6000S|BL8[08]00|N6000)",
                "model": "$1"
            },
            {
                "regex": "(?:Blackview[ _])?E7s(?:[);/ ]|$)",
                "model": "E7s"
            },
            {
                "regex": "Blackview (A[78])",
                "model": "$1"
            },
            {
                "regex": "COLOR ([68])",
                "model": "Color $1"
            },
            {
                "regex": "XPLORE ([12])",
                "model": "Xplore $1"
            },
            {
                "regex": "SHARK ([89])",
                "model": "Shark $1"
            },
            {
                "regex": "WAVE ([68])C",
                "model": "Wave $1C"
            },
            {
                "regex": "WAVE 8",
                "model": "Wave 8"
            },
            {
                "regex": "HERO 10",
                "model": "Hero 10"
            },
            {
                "regex": "SOLID_4G1",
                "model": "Solid-4 G1"
            },
            {
                "regex": "SOLID 4 G2",
                "model": "Solid-4 G2"
            },
            {
                "regex": "(BV6[13]00)(?:[);/ ]|$)",
                "model": "$1",
                "device": "phablet"
            },
            {
                "regex": "(BV\\d+[\\w]?|P10000)[ _]?Plus(?:[-_](?:RU|F))?(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(BV\\d+[\\w]?|P10000)[ _]?PRO(?:[-_](?:RU|F))?(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "(BV\\d+[\\w]?|P10000)(?:[-_](?:RU|F))?(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Active (8|1[02]) Pro",
                "device": "tablet",
                "model": "Active $1 Pro"
            },
            {
                "regex": "Active 8",
                "device": "tablet",
                "model": "Active 8"
            },
            {
                "regex": "MEGA ([128])",
                "device": "tablet",
                "model": "Mega $1"
            },
            {
                "regex": "Tab (1[0-6]|60) Pro(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab $1 Pro"
            },
            {
                "regex": "Tab ?([56]0? Kids|8E|A[56] Kids)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab $1"
            },
            {
                "regex": "Tab ([579]0|[789]|1[01]) WiFi(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab $1 WiFi"
            },
            {
                "regex": "Tab 11 SE(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 11 SE"
            },
            {
                "regex": "Tab ?([689]|1[0123568]|[689]0)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab $1"
            },
            {
                "regex": "omega[ _]pro",
                "model": "Omega Pro"
            },
            {
                "regex": "(Alife[ _][PS]1|DM550|Heatwave)",
                "model": "$1"
            }
        ]
    },
    "Bluboo": {
        "regex": "Bluboo|Maya Build|(?:(?<!IQM )Picasso(?: 4G)?|Xfire2?|D6 Lite|D1_Pro|D6 Pro|S8_plus_a| S8a|Android 8(?:[\\d.]*);(?: [\\w-]+;)? D6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Maya Build",
                "model": "Maya"
            },
            {
                "regex": "Xfire2",
                "model": "Xfire 2"
            },
            {
                "regex": "Picasso(?: 4G)?",
                "model": "Picasso 4G"
            },
            {
                "regex": "Xfire",
                "model": "Xfire"
            },
            {
                "regex": "D6 Lite",
                "model": "D6 Lite"
            },
            {
                "regex": "S8_plus_a",
                "model": "S8 Plus"
            },
            {
                "regex": "S8a",
                "model": "S8a"
            },
            {
                "regex": "D([16])[_ ]Pro",
                "model": "D$1 Pro"
            },
            {
                "regex": "(?:Bluboo[_ ])?S8[_ ]plus",
                "model": "S8 Plus"
            },
            {
                "regex": "D6(?: Build|[;)])",
                "model": "D6"
            },
            {
                "regex": "Bluboo[ _-]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Bluboo[ _-]?([^;/)]+)",
                "model": "$1"
            }
        ]
    },
    "Black Fox": {
        "regex": "BMM[ _-]?(?:44[123]D|431B|441[AWB]|44[12]S|431[SD]|53[23]D|54[12]S|541[ABW]|54[123]D|543S|531[ABD]|532 S|531S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BMM443D",
                "model": "B7 Fox+"
            },
            {
                "regex": "BMM441[AS]",
                "model": "B8 Fox"
            },
            {
                "regex": "BMM442S|BMM441B",
                "model": "B8 Fox+"
            },
            {
                "regex": "BMM441W",
                "model": "B8M"
            },
            {
                "regex": "BMM442D",
                "model": "B7"
            },
            {
                "regex": "BMM531D",
                "model": "B6"
            },
            {
                "regex": "BMM531A",
                "model": "B5"
            },
            {
                "regex": "BMM541A",
                "model": "B5+"
            },
            {
                "regex": "BMM543[DS]",
                "model": "B4"
            },
            {
                "regex": "BMM441D",
                "model": "B4 Mini"
            },
            {
                "regex": "BMM541B",
                "model": "B4 Mini NFC"
            },
            {
                "regex": "BMM531B",
                "model": "B4 Mini (2019)"
            },
            {
                "regex": "BMM542D",
                "model": "B3+"
            },
            {
                "regex": "BMM541D",
                "model": "B3"
            },
            {
                "regex": "BMM541W",
                "model": "B7R Fox"
            },
            {
                "regex": "BMM 532 S",
                "model": "BMM 532S"
            },
            {
                "regex": "BMM[ _-]?(53[23]D|431[DS]|54[12]S|531S|431B)(?:[);/ ]|$)",
                "model": "BMM $1"
            }
        ]
    },
    "bogo": {
        "regex": "BO-(FRSP4|LFSPBS5|LFSP4|LFSPSL4|LFSPBS5|LFSPSL6QCI)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BO-LFSP4",
                "model": "LifeStyle 4DC"
            },
            {
                "regex": "BO-LFSPSL4",
                "model": "LifeStyle 4SL"
            },
            {
                "regex": "BO-LFSPBS5",
                "model": "LifeStyle 5BS"
            },
            {
                "regex": "BO-LFSPSL6QCI",
                "model": "LifeStyle 6QC"
            },
            {
                "regex": "BO-(FRSP4)",
                "model": "$1"
            }
        ]
    },
    "Boway": {
        "regex": "(?:sprd-)?(BOWAY)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BOWAY[ _-]([^/;]+)[ _]Build",
                "model": "$1"
            },
            {
                "regex": "([^/;]+) Build/BOWAY",
                "model": "$1"
            },
            {
                "regex": ".*BOWAY[ _-]([^/;]+)/",
                "model": "$1"
            }
        ]
    },
    "HMD": {
        "regex": "(?:HMD (?:Pulse (?:Pro|Plus)|Pulse|Vibe|Fusion|Skyline|CREST|XR21|ARC)|N159V)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pulse Plus",
                "model": "Pulse+"
            },
            {
                "regex": "Pulse Pro",
                "model": "Pulse Pro"
            },
            {
                "regex": "Pulse",
                "model": "Pulse"
            },
            {
                "regex": "Fusion",
                "model": "Fusion"
            },
            {
                "regex": "Skyline",
                "model": "Skyline"
            },
            {
                "regex": "Vibe 5G",
                "model": "Vibe 5G"
            },
            {
                "regex": "N159V|Vibe",
                "model": "Vibe"
            },
            {
                "regex": "CREST",
                "model": "Crest"
            },
            {
                "regex": "XR21",
                "model": "XR21"
            },
            {
                "regex": "HMD ARC",
                "model": "Arc"
            }
        ]
    },
    "Brondi": {
        "regex": "Brondi[ _]|(?:CENTURION|GLADIATOR| GLORY|(?<!Land Rover )LUXURY|SENSUELLE|(?<!ODYSSEY[_ ])VICTORY|AMICO[_ ]SMARTPHONE[_ ](?:4G|X[SL]|S\\+)|MIDNIGHT_SKY|501 SZ|850_4G)(?:[ _-]?[2-6])?(?:[);/ ]|$)|Surfing Tab",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Brondi[ _])?(620 SZ|730_4G_HD|501 SZ|850_4G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CENTURION(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "CENTURION $1"
            },
            {
                "regex": "GLADIATOR(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "GLADIATOR $1"
            },
            {
                "regex": "GLORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "GLORY $1"
            },
            {
                "regex": "LUXURY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "LUXURY $1"
            },
            {
                "regex": "MIDNIGHT_SKY(?:[);/ ]|$)",
                "model": "Midnight Sky"
            },
            {
                "regex": "SENSUELLE(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "SENSUELLE $1"
            },
            {
                "regex": "VICTORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                "model": "VICTORY $1"
            },
            {
                "regex": "AMICO_SMARTPHONE_4G",
                "model": "Amico Smartphone 4G"
            },
            {
                "regex": "AMICO SMARTPHONE (X[LS]|S\\+)",
                "model": "Amico Smartphone $1"
            },
            {
                "regex": "Surfing Tab ([^;/]+) Build",
                "model": "SURFING TAB $1",
                "device": "tablet"
            },
            {
                "regex": "Surfing Tab ([^;/)]+)[;/)]",
                "model": "SURFING TAB $1",
                "device": "tablet"
            }
        ]
    },
    "VGO TEL": {
        "regex": "VGOTEL|(?:Flex 2|Venture V(?:[278]|12)|VentureV10|Ocean[_ ][689]|Ocean9L|NEW (?:1[01256]|2[02456]|[57])|V TAB 2|i_Smart)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Venture ?V([278]|1[02])(?:[);/ ]|$)",
                "model": "Venture V$1"
            },
            {
                "regex": "Ocean[_ ]?([689]|9L)(?:[);/ ]|$)",
                "model": "Ocean $1"
            },
            {
                "regex": "NEW (\\d+)",
                "model": "New $1"
            },
            {
                "regex": "Flex 2",
                "model": "Flex 2"
            },
            {
                "regex": "i_Smart",
                "model": "i Smart"
            },
            {
                "regex": "V TAB 2",
                "device": "tablet",
                "model": "V Tab 2"
            }
        ]
    },
    "Vivo": {
        "regex": "((?:VIV-|BBG-)?(?<!FBCR/|NOA |Gtel )vivo(?!(?:Browser)| 4G_r))|iQOO Neo \\d|(?:V1730(D[AT]|GA)|V18(?:01A0|13B[AT])|1819|V1937|I(?:192[78]|201[28]|2218)|V(?:2026|2031|2036|2043)_21|V1916[AT]|V1936TL|V1936AL|V(?:1732|1809|181[3468]|182[149]|183[1268]|1901|191[13469]|192[1-48]|193[0246]|194[15]|195[05]|196[235]|198[16]|1990|201[12]|202[03-5]|203[146]|204[6789]|205[45679]|2066B|206[1568]|207[23]|208[05]|2099|2106|211[18]|212[135]|213[346]|214[1358]|2162)A|V1824BA|V(?:1731|1818|2020)CA|V(?:1818|1938)CT|V(?:1730|2031)EA|V(?:1732|1809|181[3468]|182[19]|183[1268]|1901|1913|1938)T|I201[19]|I212[67]|X50 Pro\\+|I220[123678]|I24(?:0[134579]|10)|I22(?:1[234679]|2[013])|I230[1-6]|I20(?:09|17|22)|I25(?:0[25])|V1962BA|V1930|PA2170|PA23[57]3|V20(?:0[1256]|0[2159]A|[34]4|29_PK|4[57]A?|23EA|2[2-9]|3[0-35-9]|4[0-3568]|5[02-5789]|6[015689]|69B?A|70)|V21(?:0[12459]|1[01]|2[04-79]|3[012459]A?|7[12]A|4[0-79]|40A|6[0289]|64[KP]A|6[234568]A|7[08]A|1[4-8]A?|0[28]A?|5[4678]A|5[0-478]|8[03568]A|80GA|66(?:BA)?|56FA|9[069]A|99GA)|V22(?:8[2345]A|7[01289]A|5[0123]|30EA|4[0246789]|41HA|5[46]A?|3[016789]|34(?:_PK)?|3[01289]A|4[2345]A|[34]1A|2[12589]|2[079]A|[36]6A|0[37]A|0[1-9]|1[789]A|1[24789])|V23(?:4[34]A|4[1-8]|12BA|24HA|61GA|66[GH]A|3[0-46789]|3[4789]A|39FA|0[1-479]A|0[23789]|52GA|5[01256]|5[23479]A|53DA|57EA|6[124]A|2[0-57]|2[3479]A|1[0124-9]|1[23478]A)|V24(?:0[1346-9]|1[02-9]|2[02-8]|3[0-9]|35A|4[01368]|4[45]A|45EA|0[358]A|05DA|54D?A|2[569]A|1[0579]A|30A|5[135]|5[2368]A|6[345]A)|V25(?:0[236-9]|0[2567]A|1[0138]|2[0179]|3[014])|S7t 5G| (?:Y30g|Y20T|Y31s 5G|Y33s|Y50t|Y55s 5G)|iQOO (?:U[13]x?|Z1x 5G|Z5x|[578]|Z[153])|V17 SD665|NEX 3s? 5G|Z5x 712|iPA2375|iPA24(?:5[13]|75)|PA2473|Y51A|Y51 PK|1907_19|V2111-EG|Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:Y85A?|Y83A|Y71A?)|X21i A|X21A|Y52s|Y71t|Y76s)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PA2170",
                "device": "tablet",
                "model": "Pad"
            },
            {
                "regex": "PA2373",
                "device": "tablet",
                "model": "Pad 2"
            },
            {
                "regex": "PA2473",
                "device": "tablet",
                "model": "Pad 3 Pro"
            },
            {
                "regex": "PA2353",
                "device": "tablet",
                "model": "Pad Air"
            },
            {
                "regex": "iPA2375",
                "device": "tablet",
                "model": "iQOO Pad"
            },
            {
                "regex": "iPA2451",
                "device": "tablet",
                "model": "iQOO Pad Air"
            },
            {
                "regex": "iPA2475",
                "device": "tablet",
                "model": "iQOO Pad2 Pro"
            },
            {
                "regex": "iPA2453",
                "device": "tablet",
                "model": "iQOO Pad2"
            },
            {
                "regex": "V2170A(?:[);/ ]|$)",
                "device": "phablet",
                "model": "X Note"
            },
            {
                "regex": "V2256A",
                "device": "phablet",
                "model": "X Flip"
            },
            {
                "regex": "V2178A",
                "device": "phablet",
                "model": "X Fold"
            },
            {
                "regex": "V2266A",
                "device": "phablet",
                "model": "X Fold 2"
            },
            {
                "regex": "V2303A|V2337A",
                "device": "phablet",
                "model": "X Fold 3"
            },
            {
                "regex": "V2330",
                "device": "phablet",
                "model": "X Fold 3 Pro"
            },
            {
                "regex": "V2229A",
                "device": "phablet",
                "model": "X Fold+"
            },
            {
                "regex": "(Y20T|Y30g|X21i A|X21A)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "V2318A",
                "model": "G2"
            },
            {
                "regex": "V2506A",
                "model": "Y500"
            },
            {
                "regex": "V2516A",
                "model": "Y500 Pro"
            },
            {
                "regex": "V2506",
                "model": "Y400 5G"
            },
            {
                "regex": "V2455",
                "model": "Y400"
            },
            {
                "regex": "V2439",
                "model": "Y400 Pro 5G"
            },
            {
                "regex": "V2324A|V2309(?:[);/ ]|$)",
                "model": "X100 Pro"
            },
            {
                "regex": "V2366[GH]A",
                "model": "X100 Ultra"
            },
            {
                "regex": "V2309A|V2308",
                "model": "X100"
            },
            {
                "regex": "V2502A",
                "model": "X300 Pro"
            },
            {
                "regex": "V2454D?A",
                "model": "X200 Ultra"
            },
            {
                "regex": "V2503",
                "model": "X200 FE"
            },
            {
                "regex": "V2405D?A|V2413",
                "model": "X200 Pro"
            },
            {
                "regex": "V2419A",
                "model": "X200 Pro Mini"
            },
            {
                "regex": "V2415A?",
                "model": "X200"
            },
            {
                "regex": "V2458A",
                "model": "X200s"
            },
            {
                "regex": "V2324HA",
                "model": "X100s Pro"
            },
            {
                "regex": "V2359A",
                "model": "X100s"
            },
            {
                "regex": "(?:V2307|V2343A|V2401)(?:[);/ ]|$)",
                "model": "Y200 5G"
            },
            {
                "regex": "V2361GA",
                "model": "Y200 GT"
            },
            {
                "regex": "V2354A",
                "model": "Y200i"
            },
            {
                "regex": "V2336(?:[);/ ]|$)",
                "model": "Y200e 5G"
            },
            {
                "regex": "V2353DA",
                "model": "Y200t 5G"
            },
            {
                "regex": "V1824[B]?A(?:[);/ ]|$)",
                "model": "iQOO"
            },
            {
                "regex": "V1955A(?:[);/ ]|$)",
                "model": "iQOO 3"
            },
            {
                "regex": "(?:V2171A|I2017)(?:[);/ ]|$)",
                "model": "iQOO 9"
            },
            {
                "regex": "I2019(?:[);/ ]|$)",
                "model": "iQOO 9 SE"
            },
            {
                "regex": "(?:V2172A|I2022)(?:[);/ ]|$)",
                "model": "iQOO 9 Pro"
            },
            {
                "regex": "I2201(?:[);/ ]|$)",
                "model": "iQOO 9T"
            },
            {
                "regex": "V2218A",
                "model": "iQOO 10 Pro"
            },
            {
                "regex": "V2217A",
                "model": "iQOO 10"
            },
            {
                "regex": "(?:V2243A|I2212)(?:[);/ ]|$)",
                "model": "iQOO 11"
            },
            {
                "regex": "V2304A",
                "model": "iQOO 11S"
            },
            {
                "regex": "V2254A",
                "model": "iQOO 11 Pro"
            },
            {
                "regex": "I2220|V2307A",
                "model": "iQOO 12"
            },
            {
                "regex": "V2329A",
                "model": "iQOO 12 Pro"
            },
            {
                "regex": "V2408A|I2401",
                "model": "iQOO 13"
            },
            {
                "regex": "V2505A",
                "model": "iQOO 15"
            },
            {
                "regex": "I192[78](?:[);/ ]|$)",
                "model": "iQOO 3 5G"
            },
            {
                "regex": "V2165A(?:[);/ ]|$)",
                "model": "iQOO U5"
            },
            {
                "regex": "V2180GA",
                "model": "iQOO U5x"
            },
            {
                "regex": "iQOO 7 Legend",
                "model": "iQOO 7 Legend"
            },
            {
                "regex": "iQOO 7 India",
                "model": "iQOO 7 India"
            },
            {
                "regex": "(?:V2049A|I2009|iQOO 7)(?:[);/ ]|$)",
                "model": "iQOO 7"
            },
            {
                "regex": "V2425A|I2405",
                "model": "iQOO Neo 10"
            },
            {
                "regex": "I2221",
                "model": "iQOO Neo 10R"
            },
            {
                "regex": "V2425",
                "model": "Y200"
            },
            {
                "regex": "V2426A",
                "model": "iQOO Neo 10 Pro"
            },
            {
                "regex": "V2463A",
                "model": "iQOO Neo 10 Pro+"
            },
            {
                "regex": "V2196A",
                "model": "iQOO Neo 6"
            },
            {
                "regex": "(?:V2231A|I2214)(?:[);/ ]|$)",
                "model": "iQOO Neo 7"
            },
            {
                "regex": "V2232A",
                "model": "iQOO Neo 7 Racing Edition"
            },
            {
                "regex": "I2217",
                "model": "iQOO Neo 7 Pro"
            },
            {
                "regex": "V2238A",
                "model": "iQOO Neo 7 SE"
            },
            {
                "regex": "V2302A",
                "model": "iQOO Neo 8 Pro"
            },
            {
                "regex": "I2304|V2339A",
                "model": "iQOO Neo 9 Pro"
            },
            {
                "regex": "V2338A",
                "model": "iQOO Neo 9"
            },
            {
                "regex": "V2339FA",
                "model": "iQOO Neo 9S Pro"
            },
            {
                "regex": "V2403A",
                "model": "iQOO Neo 9S Pro+"
            },
            {
                "regex": "V2157A",
                "model": "iQOO Neo 5 SE"
            },
            {
                "regex": "V2154A|iQOO Neo 5S",
                "model": "iQOO Neo 5S"
            },
            {
                "regex": "I2012(?:[);/ ]|$)",
                "model": "iQOO 7 5G"
            },
            {
                "regex": "V1922A(?:[);/ ]|$)",
                "model": "iQOO Pro"
            },
            {
                "regex": "V1916[AT]",
                "model": "iQOO Pro 5G"
            },
            {
                "regex": "V1914A(?:[);/ ]|$)",
                "model": "iQOO Neo"
            },
            {
                "regex": "(?:V1981A|iQOO Neo 3)(?:[);/ ]|$)",
                "model": "iQOO Neo 3"
            },
            {
                "regex": "V1936(?:TL|A[L]?)(?:[);/ ]|$)",
                "model": "iQOO Neo 855"
            },
            {
                "regex": "V2301A",
                "model": "iQOO Neo 8"
            },
            {
                "regex": "(?:V2118A|iQOO Neo 5 Lite)(?:[);/ ]|$)",
                "model": "iQOO Neo 5 Lite"
            },
            {
                "regex": "(?:V2055A|iQOO Neo 5)(?:[);/ ]|$)",
                "model": "iQOO Neo 5"
            },
            {
                "regex": "V2199A(?:[);/ ]|$)",
                "model": "iQOO Neo 6 SE"
            },
            {
                "regex": "(?:V1986A|iQOO Z1)(?:[);/ ]|$)",
                "model": "iQOO Z1"
            },
            {
                "regex": "V2012A(?:[);/ ]|$)",
                "model": "iQOO Z1x"
            },
            {
                "regex": "iQOO Z1x 5G(?:[);/ ]|$)",
                "model": "iQOO Z1x 5G"
            },
            {
                "regex": "V2445A",
                "model": "iQOO Z10x"
            },
            {
                "regex": "I2404",
                "model": "iQOO Z10x 5G"
            },
            {
                "regex": "I2505|I2410",
                "model": "iQOO Z10R 5G"
            },
            {
                "regex": "I2407",
                "model": "iQOO Z10 5G"
            },
            {
                "regex": "V2452A",
                "model": "iQOO Z10 Turbo"
            },
            {
                "regex": "V2507A",
                "model": "iQOO Z10 Turbo+"
            },
            {
                "regex": "I2502",
                "model": "iQOO Z10 Lite"
            },
            {
                "regex": "I2409",
                "model": "iQOO Z10 Lite 5G"
            },
            {
                "regex": "V2453A",
                "model": "iQOO Z10 Turbo Pro"
            },
            {
                "regex": "(?:V2073A|I2011|iQOO Z3 5G)(?:[);/ ]|$)",
                "model": "iQOO Z3"
            },
            {
                "regex": "Z5x 712",
                "model": "Z5x 712"
            },
            {
                "regex": "V1919A|iQOO Z5x",
                "model": "iQOO Z5x"
            },
            {
                "regex": "V2131A",
                "model": "iQOO Z5x 5G"
            },
            {
                "regex": "I2018(?:[);/ ]|$)",
                "model": "iQOO Z5 5G"
            },
            {
                "regex": "V2148A|iQOO Z5",
                "model": "iQOO Z5"
            },
            {
                "regex": "(?:I220[236]|I2127|V2220A)(?:[);/ ]|$)",
                "model": "iQOO Z6"
            },
            {
                "regex": "V2164KA",
                "model": "iQOO Z6x"
            },
            {
                "regex": "I2126(?:[);/ ]|$)",
                "model": "iQOO Z6 Pro"
            },
            {
                "regex": "I2208(?:[);/ ]|$)",
                "model": "iQOO Z6 Lite"
            },
            {
                "regex": "V2270A",
                "model": "iQOO Z7"
            },
            {
                "regex": "V2230EA",
                "model": "iQOO Z7i"
            },
            {
                "regex": "I22(?:13|07)(?:[);/ ]|$)",
                "model": "iQOO Z7 5G"
            },
            {
                "regex": "I2301(?:[);/ ]|$)",
                "model": "iQOO Z7 Pro 5G"
            },
            {
                "regex": "V2272A",
                "model": "iQOO Z7x"
            },
            {
                "regex": "I2216(?:[);/ ]|$)",
                "model": "iQOO Z7x 5G"
            },
            {
                "regex": "I2223(?:[);/ ]|$)",
                "model": "iQOO Z7s 5G"
            },
            {
                "regex": "V2314A",
                "model": "iQOO Z8"
            },
            {
                "regex": "V2312A",
                "model": "iQOO Z8x"
            },
            {
                "regex": "V2361A",
                "model": "iQOO Z9"
            },
            {
                "regex": "I2302|I2218",
                "model": "iQOO Z9 5G"
            },
            {
                "regex": "V2352GA",
                "model": "iQOO Z9 Turbo Endurance"
            },
            {
                "regex": "V2352A",
                "model": "iQOO Z9 Turbo"
            },
            {
                "regex": "V2417A",
                "model": "iQOO Z9 Turbo+"
            },
            {
                "regex": "I2219|V2353A",
                "model": "iQOO Z9x 5G"
            },
            {
                "regex": "I2403",
                "model": "iQOO Z9s 5G"
            },
            {
                "regex": "I2305",
                "model": "iQOO Z9s Pro 5G"
            },
            {
                "regex": "I2306",
                "model": "iQOO Z9 Lite 5G"
            },
            {
                "regex": "(?:V2023A|iQOO U1)(?:[);/ ]|$)",
                "model": "iQOO U1"
            },
            {
                "regex": "(?:V2065A|iQOO U1x)(?:[);/ ]|$)",
                "model": "iQOO U1x"
            },
            {
                "regex": "(?:V2061A|iQOO U3)(?:[);/ ]|$)",
                "model": "iQOO U3"
            },
            {
                "regex": "V2143A",
                "model": "iQOO U3x"
            },
            {
                "regex": "(?:V2106A|iQOO U3x 5G)(?:[);/ ]|$)",
                "model": "iQOO U3x 5G"
            },
            {
                "regex": "(?:V2025A|iQOO 5 Pro)(?:[);/ ]|$)",
                "model": "iQOO 5 Pro"
            },
            {
                "regex": "(?:V2024A|iQOO 5)(?:[);/ ]|$)",
                "model": "iQOO 5"
            },
            {
                "regex": "(?:V2141A|iQOO 8 Pro)(?:[);/ ]|$)",
                "model": "iQOO 8 Pro"
            },
            {
                "regex": "(?:V2136A|iQOO 8)(?:[);/ ]|$)",
                "model": "iQOO 8"
            },
            {
                "regex": "V2339(?:[);/ ]|$)",
                "model": "V30e"
            },
            {
                "regex": "V2337(?:[);/ ]|$)",
                "model": "V40 SE 5G"
            },
            {
                "regex": "(?:V2025)(?:[);/ ]|$)",
                "model": "V20"
            },
            {
                "regex": "(?:V2066|V2108)(?:[);/ ]|$)",
                "model": "V21"
            },
            {
                "regex": "(?:V2050)(?:[);/ ]|$)",
                "model": "V21 5G"
            },
            {
                "regex": "V2061(?:[);/ ]|$)",
                "model": "V21e"
            },
            {
                "regex": "V2055(?:[);/ ]|$)",
                "model": "V21e 5G"
            },
            {
                "regex": "V2040(?:[);/ ]|$)",
                "model": "V20 (2021)"
            },
            {
                "regex": "Vivo 1921(?:[);/ ]|$)",
                "model": "U20"
            },
            {
                "regex": "Vivo 1916(?:[);/ ]|$)",
                "model": "U10"
            },
            {
                "regex": "vivo 1805(?:[);/ ]|$)",
                "model": "Nex"
            },
            {
                "regex": "(?:vivo 1912|V1923A)(?:[);/ ]|$)",
                "model": "Nex 3"
            },
            {
                "regex": "(?:V1924A|NEX 3 5G)(?:[);/ ]|$)",
                "model": "Nex 3 5G"
            },
            {
                "regex": "V1950A(?:[);/ ]|$)",
                "model": "Nex 3S"
            },
            {
                "regex": "vivo NEX S(?:[);/ ]|$)",
                "model": "Nex S"
            },
            {
                "regex": "NEX 3s 5G(?:[);/ ]|$)",
                "model": "Nex 3S 5G"
            },
            {
                "regex": "vivo NEX A(?:[);/ ]|$)",
                "model": "Nex A"
            },
            {
                "regex": "vivo NEX(?:[);/ ]|$)",
                "model": "Nex"
            },
            {
                "regex": "(?:V1821[AT]|vivo 1813)(?:[);/ ]|$)",
                "model": "Nex Dual Display"
            },
            {
                "regex": "Vivo ONE(?:[);/ ]|$)",
                "model": "One"
            },
            {
                "regex": "V2334A",
                "model": "S18e"
            },
            {
                "regex": "V2312BA",
                "model": "Y100i 5G"
            },
            {
                "regex": "V2115A|V2141|V2157|V2150",
                "model": "T1 5G"
            },
            {
                "regex": "V2151",
                "model": "T1 Pro 5G"
            },
            {
                "regex": "V2153",
                "model": "T1 4G"
            },
            {
                "regex": "V2143",
                "model": "T1x"
            },
            {
                "regex": "V2188A",
                "model": "T2x"
            },
            {
                "regex": "V2253|V2312",
                "model": "T2x 5G"
            },
            {
                "regex": "V2320|V2199GA",
                "model": "T2"
            },
            {
                "regex": "V2222",
                "model": "T2 5G"
            },
            {
                "regex": "V2321",
                "model": "T2 Pro 5G"
            },
            {
                "regex": "V2240",
                "model": "T2 5G"
            },
            {
                "regex": "V2426",
                "model": "T3 Ultra"
            },
            {
                "regex": "V2404",
                "model": "T3 Pro 5G"
            },
            {
                "regex": "V2334",
                "model": "T3 5G"
            },
            {
                "regex": "V23[45]6(?:[);/ ]|$)",
                "model": "T3 Lite 5G"
            },
            {
                "regex": "V2338(?:[);/ ]|$)",
                "model": "T3x 5G"
            },
            {
                "regex": "V2437",
                "model": "T4x 5G"
            },
            {
                "regex": "V2518",
                "model": "T4R 5G"
            },
            {
                "regex": "V2510",
                "model": "T4 Pro"
            },
            {
                "regex": "V2502",
                "model": "T4 5G"
            },
            {
                "regex": "V2509",
                "model": "T4 Lite 5G"
            },
            {
                "regex": "V1962BA",
                "model": "G1 5G"
            },
            {
                "regex": "V2203A(?:[);/ ]|$)",
                "model": "S15"
            },
            {
                "regex": "V2344A",
                "model": "S18 Pro"
            },
            {
                "regex": "V2362A",
                "model": "S19 Pro"
            },
            {
                "regex": "V2323A",
                "model": "S18"
            },
            {
                "regex": "V2364A",
                "model": "S19"
            },
            {
                "regex": "V1831[AT]",
                "model": "S1"
            },
            {
                "regex": "V1832[AT](?:[);/ ]|$)",
                "model": "S1 Pro"
            },
            {
                "regex": "V2121A",
                "model": "S10"
            },
            {
                "regex": "V2429A",
                "model": "S20"
            },
            {
                "regex": "V2430A",
                "model": "S20 Pro"
            },
            {
                "regex": "V2464A",
                "model": "S30"
            },
            {
                "regex": "V2465A",
                "model": "S30 Pro Mini"
            },
            {
                "regex": "V243[08]",
                "model": "Y04"
            },
            {
                "regex": "V2531",
                "model": "Y04s"
            },
            {
                "regex": "V2130A",
                "model": "S10e 5G"
            },
            {
                "regex": "V211[56]",
                "model": "V23e"
            },
            {
                "regex": "V2126",
                "model": "V23e 5G"
            },
            {
                "regex": "V2130",
                "model": "V23 5G"
            },
            {
                "regex": "V2132A",
                "model": "X70t"
            },
            {
                "regex": "V2132",
                "model": "V23 Pro 5G"
            },
            {
                "regex": "V2202",
                "model": "V25 SE"
            },
            {
                "regex": "V220[19]|V2242(?:[);/ ]|$)",
                "model": "V25e"
            },
            {
                "regex": "V2230A",
                "model": "Y35 5G"
            },
            {
                "regex": "V2357EA",
                "model": "Y37m"
            },
            {
                "regex": "V2436|V2443",
                "model": "Y39 5G"
            },
            {
                "regex": "V2230",
                "model": "V27 Pro"
            },
            {
                "regex": "V2237",
                "model": "V27e"
            },
            {
                "regex": "V22(?:31|46)",
                "model": "V27"
            },
            {
                "regex": "V2250",
                "model": "V29"
            },
            {
                "regex": "V2251",
                "model": "V29 Pro"
            },
            {
                "regex": "V2303",
                "model": "V29e"
            },
            {
                "regex": "V2317A",
                "model": "Y12 (2023)"
            },
            {
                "regex": "V2317",
                "model": "V29e 5G"
            },
            {
                "regex": "V2315",
                "model": "Y28 5G"
            },
            {
                "regex": "V2351",
                "model": "Y28s 5G"
            },
            {
                "regex": "V2407",
                "model": "Y28e 5G"
            },
            {
                "regex": "V2352|V2433",
                "model": "Y28"
            },
            {
                "regex": "V243[45](?:[);/ ]|$)",
                "model": "Y29"
            },
            {
                "regex": "V2420",
                "model": "Y29 5G"
            },
            {
                "regex": "V2527",
                "model": "Y29t 5G"
            },
            {
                "regex": "V2446",
                "model": "Y29s 5G"
            },
            {
                "regex": "V2244(?:[);/ ]|$)",
                "model": "V29 Lite 5G"
            },
            {
                "regex": "V2318(?:[);/ ]|$)",
                "model": "V30"
            },
            {
                "regex": "V2342",
                "model": "V30 Lite"
            },
            {
                "regex": "V2327A",
                "model": "Y36t"
            },
            {
                "regex": "V2343(?:[);/ ]|$)",
                "model": "Y38 5G"
            },
            {
                "regex": "V2314(?:[);/ ]|$)",
                "model": "V30 Lite 5G"
            },
            {
                "regex": "V2327(?:[);/ ]|$)",
                "model": "Y100"
            },
            {
                "regex": "(?:V2341|V2424|V2417)(?:[);/ ]|$)",
                "model": "V40 Lite"
            },
            {
                "regex": "V2348",
                "model": "V40"
            },
            {
                "regex": "V2347",
                "model": "V40 Pro"
            },
            {
                "regex": "(?:V2418|V2403)(?:[);/ ]|$)",
                "model": "V40e"
            },
            {
                "regex": "V24(?:51|27|48)",
                "model": "V50"
            },
            {
                "regex": "V2428",
                "model": "V50e"
            },
            {
                "regex": "V2441|V2453",
                "model": "V50 Lite"
            },
            {
                "regex": "V24[45]0",
                "model": "V50 Lite 5G"
            },
            {
                "regex": "V2319",
                "model": "V30 Pro"
            },
            {
                "regex": "V2513",
                "model": "V60e"
            },
            {
                "regex": "V2511",
                "model": "V60"
            },
            {
                "regex": "V2530",
                "model": "V60 Lite"
            },
            {
                "regex": "V2529",
                "model": "V60 Lite 5G"
            },
            {
                "regex": "V1932[AT](?:[);/ ]|$)",
                "model": "S5"
            },
            {
                "regex": "V2207A",
                "model": "S15 Pro"
            },
            {
                "regex": "V1962A(?:[);/ ]|$)",
                "model": "S6 5G"
            },
            {
                "regex": "V2162A?",
                "model": "S12 5G"
            },
            {
                "regex": "V2190A",
                "model": "S15e"
            },
            {
                "regex": "V2244A",
                "model": "S16"
            },
            {
                "regex": "V2245A",
                "model": "S16 Pro"
            },
            {
                "regex": "V2239A",
                "model": "S16e"
            },
            {
                "regex": "V2020C?A(?:[);/ ]|$)",
                "model": "S7"
            },
            {
                "regex": "V2283A",
                "model": "S17"
            },
            {
                "regex": "V2282A",
                "model": "S17t"
            },
            {
                "regex": "V2285A",
                "model": "S17e"
            },
            {
                "regex": "V2284A",
                "model": "S17 Pro"
            },
            {
                "regex": "V2031EA(?:[);/ ]|$)",
                "model": "S7e"
            },
            {
                "regex": "V2080A(?:[);/ ]|$)",
                "model": "S7t"
            },
            {
                "regex": "S7t 5G(?:[);/ ]|$)",
                "model": "S7t 5G"
            },
            {
                "regex": "V2072A(?:[);/ ]|$)",
                "model": "S9 (2021)"
            },
            {
                "regex": "V2048A(?:[);/ ]|$)",
                "model": "S9e"
            },
            {
                "regex": "V1941A(?:[);/ ]|$)",
                "model": "U3"
            },
            {
                "regex": "V1928A(?:[);/ ]|$)",
                "model": "U3X"
            },
            {
                "regex": "vivo 1804(?:[);/ ]|$)",
                "model": "V11 Pro"
            },
            {
                "regex": "vivo 1806(?:[);/ ]|$)",
                "model": "V11i"
            },
            {
                "regex": "1819(?:[);/ ]|$)",
                "model": "V15"
            },
            {
                "regex": "vivo 1818(?:[);/ ]|$)",
                "model": "V15 Pro"
            },
            {
                "regex": "vivo 19(?:10|09)(?:[);/ ]|$)",
                "model": "V17 Pro"
            },
            {
                "regex": "(?:vivo 1907(?:_19)?|1907_19)(?:[);/ ]|$)",
                "model": "V17 Neo"
            },
            {
                "regex": "(?:vivo 1919|V17 SD665)(?:[);/ ]|$)",
                "model": "V17"
            },
            {
                "regex": "vivo 1920(?:_20)?(?:[);/ ]|$)",
                "model": "S1 Pro"
            },
            {
                "regex": "vivo 1933(?:[);/ ]|$)",
                "model": "V19"
            },
            {
                "regex": "V2022(?:[);/ ]|$)",
                "model": "V20 SE"
            },
            {
                "regex": "vivo 2018(?:[);/ ]|$)",
                "model": "V20 Pro"
            },
            {
                "regex": "(?:VIV-|BBG-)?vivo[ _]1601(?:[);/ ]|$)",
                "model": "V5"
            },
            {
                "regex": "vivo 1609(?:[);/ ]|$)",
                "model": "V5 Lite"
            },
            {
                "regex": "vivo 1611(?:[);/ ]|$)",
                "model": "V5 Plus"
            },
            {
                "regex": "vivo (1713|1612)(?:[);/ ]|$)",
                "model": "V5s"
            },
            {
                "regex": "vivo 1718(?:[);/ ]|$)",
                "model": "V7"
            },
            {
                "regex": "V2166BA(?:[);/ ]|$)",
                "model": "V77e"
            },
            {
                "regex": "vivo (?:1716|1850)(?:[);/ ]|$)",
                "model": "V7 Plus"
            },
            {
                "regex": "vivo 1723(?:[);/ ]|$)",
                "model": "V9"
            },
            {
                "regex": "(?:vivo 1727|V9Youth)(?:[);/ ]|$)",
                "model": "V9 Youth"
            },
            {
                "regex": "vivo (?:1851|V9Pro)(?:[);/ ]|$)",
                "model": "V9 Pro"
            },
            {
                "regex": "vivo V3Max(?: [AL])?(?:[);/ ]|$)",
                "model": "V3 Max"
            },
            {
                "regex": "vivo X9s Plus(?:[);/ ]|$)",
                "model": "X9s Plus"
            },
            {
                "regex": "vivo X9s(?: [AL])?(?:[);/ ]|$)",
                "model": "X9s"
            },
            {
                "regex": "V2241A|V2218(?:[);/ ]|$)",
                "model": "X90"
            },
            {
                "regex": "V2219(?:[);/ ]|$)",
                "model": "X90 Pro"
            },
            {
                "regex": "V2241HA",
                "model": "X90s"
            },
            {
                "regex": "vivo X5Pro(?:[);/ ]|$)",
                "model": "X5 Pro"
            },
            {
                "regex": "vivo X20Plus UD(?:[);/ ]|$)",
                "model": "X20 Plus UD"
            },
            {
                "regex": "vivo 1721(?:[);/ ]|$)",
                "model": "X20"
            },
            {
                "regex": "(?:X20Plus(?: a)?|vivo 1720)(?:[);/ ]|$)",
                "model": "X20 Plus"
            },
            {
                "regex": "vivo X21i(?: A)?(?:[);/ ]|$)",
                "model": "X21i"
            },
            {
                "regex": "vivo X21UD(?: A)?(?:[);/ ]|$)",
                "model": "X21 UD"
            },
            {
                "regex": "vivo (?:1725|X21)(?:[);/ ]|$)",
                "model": "X21"
            },
            {
                "regex": "V1814[AT](?:[);/ ]|$)",
                "model": "X21S"
            },
            {
                "regex": "V1809[AT](?:[);/ ]|$)",
                "model": "X23"
            },
            {
                "regex": "V1816[AT](?:[);/ ]|$)",
                "model": "X23"
            },
            {
                "regex": "V18(38|29)[AT](?:[);/ ]|$)",
                "model": "X27"
            },
            {
                "regex": "V1836[AT](?:[);/ ]|$)",
                "model": "X27 Pro"
            },
            {
                "regex": "V1938CT(?:[);/ ]|$)",
                "model": "X30"
            },
            {
                "regex": "V1938T(?:[);/ ]|$)",
                "model": "X30 Pro"
            },
            {
                "regex": "(?:V2001A|vivo 2004)(?:[);/ ]|$)",
                "model": "X50"
            },
            {
                "regex": "V1930(?:[);/ ]|$)",
                "model": "X50e"
            },
            {
                "regex": "vivo 2005(?:[);/ ]|$)",
                "model": "X50 5G"
            },
            {
                "regex": "(?:vivo 1937|V1937)(?:[);/ ]|$)",
                "model": "X50 Lite"
            },
            {
                "regex": "(?:V2005A|vivo 2006)(?:[);/ ]|$)",
                "model": "X50 Pro"
            },
            {
                "regex": "(?:V2011A|X50 Pro\\+)(?:[);/ ]|$)",
                "model": "X50 Pro Plus"
            },
            {
                "regex": "(?:V20(?:46|59)A|V2045)(?:[);/ ]|$)",
                "model": "X60"
            },
            {
                "regex": "V2085A(?:[);/ ]|$)",
                "model": "X60t"
            },
            {
                "regex": "(?:V2047A|V2046)(?:[);/ ]|$)",
                "model": "X60 Pro"
            },
            {
                "regex": "(?:V2056A|V2047)(?:[);/ ]|$)",
                "model": "X60 Pro Plus"
            },
            {
                "regex": "(?:V2134A|V2105)(?:[);/ ]|$)",
                "model": "X70 Pro"
            },
            {
                "regex": "(?:V2145A|V2114)(?:[);/ ]|$)",
                "model": "X70 Pro+"
            },
            {
                "regex": "V2133A(?:[);/ ]|$)",
                "model": "X70"
            },
            {
                "regex": "V2104(?:[);/ ]|$)",
                "model": "X70 5G"
            },
            {
                "regex": "(?:V2144|V2183A)(?:[);/ ]|$)",
                "model": "X80"
            },
            {
                "regex": "V2242A",
                "model": "X90 Pro"
            },
            {
                "regex": "V2227A",
                "model": "X90 Pro+"
            },
            {
                "regex": "V218[56]A|V2145",
                "model": "X80 Pro"
            },
            {
                "regex": "V2208(?:[);/ ]|$)",
                "model": "X80 Lite 5G"
            },
            {
                "regex": "X([0-9])Plus(?: A)?(?:[);/ ]|$)",
                "model": "X$1 Plus"
            },
            {
                "regex": "vivo Xplay6(?:[);/ ]|$)",
                "model": "X Play 6"
            },
            {
                "regex": "vivo (?:1929|2015)(?:_21)?(?:[);/ ]|$)",
                "model": "Y1s"
            },
            {
                "regex": "vivo 1902(?:[);/ ]|$)",
                "model": "Y17"
            },
            {
                "regex": "V2310|V2331",
                "model": "Y17s"
            },
            {
                "regex": "(?:V2333|V2345)(?:[);/ ]|$)",
                "model": "Y18"
            },
            {
                "regex": "V2410(?:[);/ ]|$)",
                "model": "Y18s"
            },
            {
                "regex": "V2350",
                "model": "Y18e"
            },
            {
                "regex": "V2414",
                "model": "Y18i"
            },
            {
                "regex": "V2408",
                "model": "Y18t"
            },
            {
                "regex": "V22[01]4(?:[);/ ]|$)",
                "model": "Y16"
            },
            {
                "regex": "(?:vivo 1906(?:_20)?|V2236A)(?:[);/ ]|$)",
                "model": "Y11"
            },
            {
                "regex": "V2140A",
                "model": "Y10"
            },
            {
                "regex": "V2168A",
                "model": "Y10 T1"
            },
            {
                "regex": "V2313A",
                "model": "Y100 5G"
            },
            {
                "regex": "V2239|V2412",
                "model": "Y100"
            },
            {
                "regex": "V2168",
                "model": "T1"
            },
            {
                "regex": "V2118",
                "model": "Y01"
            },
            {
                "regex": "V2166(?:[);/ ]|$)",
                "model": "Y01A"
            },
            {
                "regex": "(?:V2203|V222[19])(?:[);/ ]|$)",
                "model": "Y02s"
            },
            {
                "regex": "(?:V225[24]|V2325)(?:[);/ ]|$)",
                "model": "Y02t"
            },
            {
                "regex": "(?:V2217|V2236|V2234_PK)(?:[);/ ]|$)",
                "model": "Y02"
            },
            {
                "regex": "(?:V2234)(?:[);/ ]|$)",
                "model": "Y02A"
            },
            {
                "regex": "V2332|V2406",
                "model": "Y03"
            },
            {
                "regex": "V2409|V2344",
                "model": "Y03t"
            },
            {
                "regex": "vivo 19(?:04|40)(?:[);/ ]|$)",
                "model": "Y12"
            },
            {
                "regex": "V2163A",
                "model": "Y12 Pro"
            },
            {
                "regex": "V2102(?:[);/ ]|$)",
                "model": "Y12a"
            },
            {
                "regex": "vivo 2007(?:[);/ ]|$)",
                "model": "Y12i"
            },
            {
                "regex": "vivo 1901(?:_19)?(?:[);/ ]|$)",
                "model": "Y15"
            },
            {
                "regex": "V2134",
                "model": "Y15a"
            },
            {
                "regex": "(?:V212[05]|V2139)(?:[);/ ]|$)",
                "model": "Y15s"
            },
            {
                "regex": "V2147|V2212",
                "model": "Y15c"
            },
            {
                "regex": "vivo 1915(?:[);/ ]|$)",
                "model": "Y19"
            },
            {
                "regex": "V2432",
                "model": "Y19 5G"
            },
            {
                "regex": "(?:V2419|V2423)(?:[);/ ]|$)",
                "model": "Y19s"
            },
            {
                "regex": "V250[78]",
                "model": "Y19s Pro"
            },
            {
                "regex": "V2431",
                "model": "Y19e"
            },
            {
                "regex": "V2027(?:_PK)?(?:[);/ ]|$)",
                "model": "Y20i"
            },
            {
                "regex": "V2029(?:_PK)?(?:[);/ ]|$)",
                "model": "Y20"
            },
            {
                "regex": "(?:V2207|V2238)(?:[);/ ]|$)",
                "model": "Y22"
            },
            {
                "regex": "V2249",
                "model": "Y27"
            },
            {
                "regex": "V2322",
                "model": "Y27s"
            },
            {
                "regex": "V2302",
                "model": "Y27 5G"
            },
            {
                "regex": "V2206(?:[);/ ]|$)",
                "model": "Y22s"
            },
            {
                "regex": "vivo 1613(?:[);/ ]|$)",
                "model": "Y25"
            },
            {
                "regex": "(?:V2043_21|V2048)(?:[);/ ]|$)",
                "model": "Y20 (2021)"
            },
            {
                "regex": "(?:V205[24]|V2070|V2101|V2034)(?:[);/ ]|$)",
                "model": "Y20A"
            },
            {
                "regex": "V2037(?:[);/ ]|$)",
                "model": "Y20G"
            },
            {
                "regex": "V2129(?:[);/ ]|$)",
                "model": "Y20T"
            },
            {
                "regex": "V2065(?:[);/ ]|$)",
                "model": "Y20G (2021)"
            },
            {
                "regex": "V2028(?:[);/ ]|$)",
                "model": "Y11s"
            },
            {
                "regex": "V2038(?:[);/ ]|$)",
                "model": "Y20s"
            },
            {
                "regex": "V2043(?:[);/ ]|$)",
                "model": "Y20 (2021)"
            },
            {
                "regex": "V2279A",
                "model": "Y100i"
            },
            {
                "regex": "V2278A",
                "model": "Y78"
            },
            {
                "regex": "V2271A",
                "model": "Y78+"
            },
            {
                "regex": "V(?:2041|2060)(?:[);/ ]|$)",
                "model": "Y72 5G"
            },
            {
                "regex": "V2009A",
                "model": "Y74s 5G"
            },
            {
                "regex": "V2102A",
                "model": "Y72T 5G"
            },
            {
                "regex": "V2117",
                "model": "Y75"
            },
            {
                "regex": "V2219A",
                "model": "Y77"
            },
            {
                "regex": "V2169",
                "model": "Y77 5G"
            },
            {
                "regex": "V2032(?:[);/ ]|$)",
                "model": "Y20i"
            },
            {
                "regex": "V2110",
                "model": "Y21s"
            },
            {
                "regex": "V2520",
                "model": "Y21d"
            },
            {
                "regex": "V2152(?:[);/ ]|$)",
                "model": "Y21G"
            },
            {
                "regex": "V2111(?:[);/ ]|$)",
                "model": "Y21"
            },
            {
                "regex": "V2149|V2111-EG",
                "model": "Y21a"
            },
            {
                "regex": "V2140(?:[);/ ]|$)",
                "model": "Y21e"
            },
            {
                "regex": "V213[15](?:[);/ ]|$)",
                "model": "Y21t"
            },
            {
                "regex": "V2023(?:[);/ ]|$)",
                "model": "V20 SE"
            },
            {
                "regex": "V1901[AT](?:[);/ ]|$)",
                "model": "Y3"
            },
            {
                "regex": "V2044",
                "model": "Y3s"
            },
            {
                "regex": "V1930A",
                "model": "Y3 Standard"
            },
            {
                "regex": "V2445EA",
                "model": "Y300+"
            },
            {
                "regex": "V2435A",
                "model": "Y300"
            },
            {
                "regex": "V2416",
                "model": "Y300 5G"
            },
            {
                "regex": "V2410A",
                "model": "Y300 Pro 5G"
            },
            {
                "regex": "V2456A",
                "model": "Y300 Pro+"
            },
            {
                "regex": "V2444A",
                "model": "Y300i"
            },
            {
                "regex": "V2422",
                "model": "Y300 Plus 5G"
            },
            {
                "regex": "(?:vivo 193[89]|V203[46]A)(?:[);/ ]|$)",
                "model": "Y30"
            },
            {
                "regex": "V2160(?:[);/ ]|$)",
                "model": "Y30 5G"
            },
            {
                "regex": "V2099A(?:[);/ ]|$)",
                "model": "Y30 (2021)"
            },
            {
                "regex": "V2066[B]?A(?:[);/ ]|$)",
                "model": "Y30g"
            },
            {
                "regex": "V2036(?:_21)?(?:[);/ ]|$)",
                "model": "Y31"
            },
            {
                "regex": "V2534",
                "model": "Y31 Pro 5G"
            },
            {
                "regex": "V2068A?(?:[);/ ]|$)",
                "model": "Y31s"
            },
            {
                "regex": "V2521",
                "model": "Y31 5G"
            },
            {
                "regex": "V2534",
                "model": "Y31 Pro 5G"
            },
            {
                "regex": "V2158A",
                "model": "Y32"
            },
            {
                "regex": "V2228(?:[);/ ]|$)",
                "model": "V25"
            },
            {
                "regex": "V2158",
                "model": "V25 Pro"
            },
            {
                "regex": "V2180A",
                "model": "Y32t"
            },
            {
                "regex": "V2057(?:[);/ ]|$)",
                "model": "Y33"
            },
            {
                "regex": "(?:V2109|Y33s)(?:[);/ ]|$)",
                "model": "Y33s"
            },
            {
                "regex": "V2146(?:[);/ ]|$)",
                "model": "Y33t"
            },
            {
                "regex": "V2166A(?:[);/ ]|$)",
                "model": "Y33s (2022)"
            },
            {
                "regex": "V2205(?:[);/ ]|$)",
                "model": "Y35"
            },
            {
                "regex": "(?:V2247|V2324)(?:[);/ ]|$)",
                "model": "Y36"
            },
            {
                "regex": "V2248(?:[);/ ]|$)",
                "model": "Y36 5G"
            },
            {
                "regex": "V2357A(?:[);/ ]|$)",
                "model": "Y37 5G"
            },
            {
                "regex": "V1934A(?:[);/ ]|$)",
                "model": "Y5s"
            },
            {
                "regex": "(?:V1965A|vivo 1935)(?:[);/ ]|$)",
                "model": "Y50"
            },
            {
                "regex": "(?:V2023EA|Y50t)(?:[);/ ]|$)",
                "model": "Y50t"
            },
            {
                "regex": "V(?:2024|203[05])(?:[);/ ]|$)",
                "model": "Y51"
            },
            {
                "regex": "Y51 PK(?:[);/ ]|$)",
                "model": "Y51 PK"
            },
            {
                "regex": "vivo 1707(?:[);/ ]|$)",
                "model": "Y51 (2015)"
            },
            {
                "regex": "V2031(?:_21)?(?:[);/ ]|$)",
                "model": "Y51s"
            },
            {
                "regex": "Y51A(?:[);/ ]|$)",
                "model": "Y51A"
            },
            {
                "regex": "(?:V2054A|Y31s 5G)(?:[);/ ]|$)",
                "model": "Y31s"
            },
            {
                "regex": "(?:V2057A|Y52s)(?:[);/ ]|$)",
                "model": "Y52s"
            },
            {
                "regex": "V2053(?:[);/ ]|$)",
                "model": "Y52"
            },
            {
                "regex": "vivo 1606(?:[);/ ]|$)",
                "model": "Y53i"
            },
            {
                "regex": "vivo 1606a(?:[);/ ]|$)",
                "model": "Y53"
            },
            {
                "regex": "(?:V2058|V2111A|V2123A)(?:[);/ ]|$)",
                "model": "Y53s"
            },
            {
                "regex": "V2069A",
                "model": "Y53s T1"
            },
            {
                "regex": "vivo 1603(?:[);/ ]|$)",
                "model": "Y55l"
            },
            {
                "regex": "vivo 1610(?:[);/ ]|$)",
                "model": "Y55s"
            },
            {
                "regex": "V2164A|Y55s 5G",
                "model": "Y55s (2021)"
            },
            {
                "regex": "V2164PA",
                "model": "Y73t 5G"
            },
            {
                "regex": "V2127",
                "model": "Y55 5G"
            },
            {
                "regex": "V2154",
                "model": "Y55"
            },
            {
                "regex": "V2045A",
                "model": "Y54s"
            },
            {
                "regex": "V2311|V2225",
                "model": "Y56 5G"
            },
            {
                "regex": "V2355",
                "model": "Y58 5G"
            },
            {
                "regex": "vivo 1719(?:[);/ ]|$)",
                "model": "Y65"
            },
            {
                "regex": "vivo (?:1714|Y69A?)(?:[);/ ]|$)",
                "model": "Y69"
            },
            {
                "regex": "V2002A(?:[);/ ]|$)",
                "model": "Y70s"
            },
            {
                "regex": "V2006(?:[);/ ]|$)",
                "model": "Y60s"
            },
            {
                "regex": "vivo (?:1724|Y71A?)(?:[);/ ]|$)",
                "model": "Y71"
            },
            {
                "regex": "Y71t(?:[);/ ]|$)",
                "model": "Y71t"
            },
            {
                "regex": "vivo 1801i?(?:[);/ ]|$)",
                "model": "Y71i"
            },
            {
                "regex": "V1731CA(?:[);/ ]|$)",
                "model": "Y73"
            },
            {
                "regex": "V2059(?:[);/ ]|$)",
                "model": "Y73 (2021)"
            },
            {
                "regex": "V2031A(?:[);/ ]|$)",
                "model": "Y73s"
            },
            {
                "regex": "V2124(?:[);/ ]|$)",
                "model": "Y76 5G"
            },
            {
                "regex": "V2156F?A|Y76s(?:[);/ ]|$)",
                "model": "Y76s"
            },
            {
                "regex": "V1913[AT](?:[);/ ]|$)",
                "model": "Y7s"
            },
            {
                "regex": "vivo 180([38]|8i)(?:[);/ ]|$)",
                "model": "Y81"
            },
            {
                "regex": "vivo 1812(?:_19)?(?:[);/ ]|$)",
                "model": "Y81i"
            },
            {
                "regex": "V1732[AT](?:[);/ ]|$)",
                "model": "Y81s"
            },
            {
                "regex": "vivo (?:Y83A?|1802)(?:[);/ ]|$)",
                "model": "Y83"
            },
            {
                "regex": "vivo 1726(?:[);/ ]|$)",
                "model": "Y83 Pro"
            },
            {
                "regex": "V1730EA(?:[);/ ]|$)",
                "model": "Y89"
            },
            {
                "regex": "vivo (?:1823|1908)(?:_19)?(?:[);/ ]|$)",
                "model": "Y90"
            },
            {
                "regex": "vivo 181[17](?:[);/ ]|$)",
                "model": "Y91"
            },
            {
                "regex": "vivo 1820(?:_19)?(?:[);/ ]|$)",
                "model": "Y91i"
            },
            {
                "regex": "V1945A(?:[);/ ]|$)",
                "model": "Y9s"
            },
            {
                "regex": "(?:V2026|V2033|V2042)(?:[);/ ]|$)",
                "model": "Y12s"
            },
            {
                "regex": "(?:V20[63]9|V2026_21)(?:[);/ ]|$)",
                "model": "Y12s (2021)"
            },
            {
                "regex": "vivo 18(16|20)(?:[);/ ]|$)",
                "model": "Y91i"
            },
            {
                "regex": "(V1818[AT]|vivo 181[45])(?:[);/ ]|$)",
                "model": "Y93"
            },
            {
                "regex": "V1818C[AT](?:[);/ ]|$)",
                "model": "Y93s"
            },
            {
                "regex": "vivo 1807(?:[);/ ]|$)",
                "model": "Y95"
            },
            {
                "regex": "V1813[AT](?:[);/ ]|$)",
                "model": "Y97"
            },
            {
                "regex": "V1801A0(?:[);/ ]|$)",
                "model": "Z1"
            },
            {
                "regex": "vivo (?:1918|1951|Z1Pro)(?:[);/ ]|$)",
                "model": "Z1 Pro"
            },
            {
                "regex": "V1730D[AT](?:[);/ ]|$)",
                "model": "Z1i"
            },
            {
                "regex": "vivo 1917(?:[);/ ]|$)",
                "model": "Z1x"
            },
            {
                "regex": "V1813B[AT](?:[);/ ]|$)",
                "model": "Z3"
            },
            {
                "regex": "(?:vivo Z3x|V1730GA)(?:[);/ ]|$)",
                "model": "Z3x"
            },
            {
                "regex": "V1921A(?:[);/ ]|$)",
                "model": "Z5"
            },
            {
                "regex": "V1911A(?:[);/ ]|$)",
                "model": "Z5x"
            },
            {
                "regex": "V1990A(?:[);/ ]|$)",
                "model": "Z5x (2020)"
            },
            {
                "regex": "V1963A(?:[);/ ]|$)",
                "model": "Z6"
            },
            {
                "regex": "V2142(?:[);/ ]|$)",
                "model": "Y75 5G"
            },
            {
                "regex": "(?:vivo Y75s|V2069BA)(?:[);/ ]|$)",
                "model": "Y75s"
            },
            {
                "regex": "vivo X710L?(?:[);/ ]|$)",
                "model": "X Shot"
            },
            {
                "regex": "X6SPlus(?: [AD])?(?:[);/ ]|$)",
                "model": "X6S Plus"
            },
            {
                "regex": "vivo X6S(?: A)?(?:[);/ ]|$)",
                "model": "X6S"
            },
            {
                "regex": "vivo X([5679]|20)[ALD]?(?:[);/ ]|$)",
                "model": "X$1"
            },
            {
                "regex": "vivo X5Pro(?: L)?(?:[);/ ]|$)",
                "model": "X5 Pro"
            },
            {
                "regex": "vivo Y66i(?: A)?(?:[);/ ]|$)",
                "model": "Y66i"
            },
            {
                "regex": "vivo Y(\\d{2})[AL]?(?:[);/ ]|$)",
                "model": "Y$1"
            },
            {
                "regex": "vivo Xplay(\\d)S(?:[);/ ]|$)",
                "model": "X Play $1S"
            },
            {
                "regex": "vivo Xplay(\\d)[AL]?(?:[);/ ]|$)",
                "model": "X Play $1"
            },
            {
                "regex": "(?:VIV-|BBG-)?vivo[ _]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:VIV-|BBG-)?vivo[ _]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": " (Y85A?|Y83A|Y71A?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Vinsoc": {
        "regex": "(XA Pro) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Bird": {
        "regex": "BIRD[-. _]([^;/]+)|(E5018)(?:[);/ ]|$)",
        "device": "feature phone",
        "models": [
            {
                "regex": "(E5018)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "BIRD[\\-. _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "BIRD[\\-. _]([^;/]+)",
                "model": "$1"
            }
        ]
    },
    "Becker": {
        "regex": "Becker-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Beeline": {
        "regex": "Beeline|(?:A239s|SWG2001A-A|RASSE-001)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Beeline[_ ]Pro[_ ]([2436])",
                "model": "Pro $1"
            },
            {
                "regex": "Tab (Fast(?: 2)?|Pro)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "Tab ([0-9])",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "Tab",
                "model": "Tab",
                "device": "tablet"
            },
            {
                "regex": "E([67]00)",
                "model": "E$1"
            },
            {
                "regex": "(?:Beeline[_ ])?Smart[ _]?([0-9])",
                "model": "Smart $1"
            },
            {
                "regex": "Smart Dual",
                "model": "Smart Dual"
            },
            {
                "regex": "(?:Beeline[_ ])?Fast[_ ]2(?:[);/ ]|$)",
                "model": "Fast 2"
            },
            {
                "regex": "Fast(?:[);/ ]|$)",
                "model": "Fast"
            },
            {
                "regex": "A239s(?:[);/ ]|$)",
                "model": "Smart 8 A239s"
            },
            {
                "regex": "(RASSE-001)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "(SWG2001A-A)(?:[);/ ]|$)",
                "device": "tv",
                "model": "Beebox $1"
            }
        ]
    },
    "Beetel": {
        "regex": "Beetel ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "BenQ-Siemens": {
        "regex": "BENQ-SIEMENS - ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "BenQ": {
        "regex": "BENQ(?:[ -])?([a-z0-9]+)|(?:F52_09|F5_15|T47_09|QS02)(?:[);/ ]|$)",
        "device": "feature phone",
        "models": [
            {
                "regex": "(F(?:52|5)|T47)_(?:15|09)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "BENQ(?:[ -])?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "QS02",
                "device": "tv",
                "model": "QS02"
            }
        ]
    },
    "Blaupunkt": {
        "regex": "Blaupunkt|(?:Soundphone S2|Atlantis[_ ](?:1001A|1010A|A10[._]G40[23])|SLplus02|Discovery[_ ](?:A10_302|10[28]C|111C|1000C|1001A?)|Endeavour[_ ](?:785|101[GLM]|1000|1001|101[03]|1100)|Polaris[_ ]80[38](?:_BE)?|BP_(?:6010|6110)|B-STREAM|SL05|SM 02 2019|SF04 4G|A-STREAM|55UW5000T)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Discovery[_ ](1000|111|10[28])C",
                "model": "Discovery $1C"
            },
            {
                "regex": "Discovery[_ ]A10_302",
                "model": "Discovery A10.302"
            },
            {
                "regex": "Discovery[_ ]1001A",
                "model": "Discovery 1001A"
            },
            {
                "regex": "Discovery[_ ]1001",
                "model": "Discovery 1001"
            },
            {
                "regex": "Soundphone S2",
                "model": "Soundphone S2"
            },
            {
                "regex": "Endeavour[_ ](101[GLM]|785|100[01]|101[03]|1100)",
                "model": "Endeavour $1"
            },
            {
                "regex": "Polaris[_ ](808[_ ]BE|80[38])",
                "model": "Polaris $1"
            },
            {
                "regex": "Atlantis_A10_G403",
                "model": "Atlantis A10.G403"
            },
            {
                "regex": "Atlantis[_ ](1001A|1010A|A10\\.G40[23])",
                "model": "Atlantis $1"
            },
            {
                "regex": "SLplus02",
                "model": "SL Plus 02"
            },
            {
                "regex": "BP_(6010|6110)",
                "model": "BP $1"
            },
            {
                "regex": "Blaupunkt[_ ](SL[_ ]0[124]|SM[_ ]0[12]|TX60)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(SF02|SL05|SF04 4G)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "SM 02 2019",
                "device": "smartphone",
                "model": "SM 02 (2019)"
            },
            {
                "regex": "(4K Android TV|A-STREAM)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "B-STREAM",
                "device": "tv",
                "model": "Box Stream"
            },
            {
                "regex": "55UW5000T",
                "device": "tv",
                "model": "55UW5000T"
            }
        ]
    },
    "Bmobile": {
        "regex": "Bmobile[_ ]|B60Pro(?:_MV03)?|BL40_MV12|BL50P_TG0[567]|BL51_MV05|BL53_TG06|BL5[24]_?Pro|(?:B50Pro|BL5[02]|BL60_TG(?:05|17)|BL60M_MV05|BL60 Pro|BL6[12]|BL63_TG07|FUN 4 2018|AX686A|AX-?(?:[1-9][0-9]{2,3}[eEO+]?|7OO))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AX-?([1-9][0-9]{2,3}[eAEO+]?)",
                "model": "AX$1"
            },
            {
                "regex": "AX7OO",
                "model": "AX700"
            },
            {
                "regex": "FUN 4 2018",
                "model": "Fun 4 (2018)"
            },
            {
                "regex": "B60Pro(?:_MV03)?",
                "model": "B60 Pro"
            },
            {
                "regex": "BL40_MV12(?:[);/ ]|$)",
                "model": "BL40"
            },
            {
                "regex": "BL60_TG(?:05|17)",
                "model": "BL60"
            },
            {
                "regex": "BL([56]0|52)[_ ]?Pro(?:[);/ ]|$)",
                "model": "BL$1 Pro"
            },
            {
                "regex": "BL63_TG07(?:[);/ ]|$)",
                "model": "BL63"
            },
            {
                "regex": "BL60M_MV05",
                "model": "BL60M"
            },
            {
                "regex": "B50Pro",
                "model": "B50 Pro"
            },
            {
                "regex": "BL50P_TG0[567](?:[);/ ]|$)",
                "model": "BL50 Pro"
            },
            {
                "regex": "BL(5[02])(?:[);/ ]|$)",
                "model": "BL$1"
            },
            {
                "regex": "BL51_MV05(?:[);/ ]|$)",
                "model": "BL51"
            },
            {
                "regex": "BL53_TG06(?:[);/ ]|$)",
                "model": "BL53"
            },
            {
                "regex": "BL54_?Pro",
                "model": "BL54 Pro"
            },
            {
                "regex": "BL6([12])(?:[);/ ]|$)",
                "model": "BL6$1"
            },
            {
                "regex": "Bmobile[_ ]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Bmobile[_ ]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "bq": {
        "regex": "Aquaris|bq [^/;]+ Build|BQS[-_][0-9]{4}|(?:BQ(?:ru)?[_ -][0-9]{3,4})|BQ_\\d{2}FSF?|BQ5059|BQ1008G|BQru_BQru-|Edison 3|Smart_TV_BQ|Fnac 10 3G",
        "device": "smartphone",
        "models": [
            {
                "regex": "BQ(?:ru)?-(?:5209L|5044)(?:[);/ ]|$)",
                "model": "Strike LTE"
            },
            {
                "regex": "BQ(?:ru)?-(?:6035L)(?:[);/ ]|$)",
                "model": "Strike Power Max"
            },
            {
                "regex": "BQ(?:ru)?-(?:5535L)(?:[);/ ]|$)",
                "model": "Strike Power Plus"
            },
            {
                "regex": "BQ(S|ru)?-6353L",
                "model": "Joy"
            },
            {
                "regex": "BQ(S|ru)?-(?:5070|6040L)(?:[);/ ]|$)",
                "model": "Magic"
            },
            {
                "regex": "BQ(S|ru)?-(?:6424L)(?:[);/ ]|$)",
                "model": "Magic O"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5730L)(?:[);/ ]|$)",
                "model": "Magic C"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5731L)(?:[);/ ]|$)",
                "model": "Magic S"
            },
            {
                "regex": "BQ(?:S|ru)?-57[46]5L(?:[);/ ]|$)",
                "model": "Clever"
            },
            {
                "regex": "BQ(?:S|ru)?-5533G(?:[);/ ]|$)",
                "model": "Fresh"
            },
            {
                "regex": "BQ(?:S|ru)?-5031G(?:[);/ ]|$)",
                "model": "Fun"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5732L)(?:[);/ ]|$)",
                "model": "Aurora SE"
            },
            {
                "regex": "BQ(?:S|ru)?-6430L(?:[);/ ]|$)",
                "model": "Aurora"
            },
            {
                "regex": "BQ(?:S|ru)?-6630L(?:[);/ ]|$)",
                "model": "Magic L"
            },
            {
                "regex": "BQ-9011[G]?(?:[);/ ]|$)",
                "model": "Vision",
                "device": "tablet"
            },
            {
                "regex": "BQ-8068L(?:[);/ ]|$)",
                "model": "Hornet Plus Pro"
            },
            {
                "regex": "BQ-8067L",
                "model": "Hornet Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-8052G",
                "model": "BQ-8052G",
                "device": "tablet"
            },
            {
                "regex": "BQ-8041L",
                "model": "Art",
                "device": "tablet"
            },
            {
                "regex": "BQ-7084G",
                "model": "Simple",
                "device": "tablet"
            },
            {
                "regex": "BQ-7061G",
                "model": "Andros",
                "device": "tablet"
            },
            {
                "regex": "BQ(ru)?-(7082)",
                "model": "Armor",
                "device": "tablet"
            },
            {
                "regex": "BQ-7051G",
                "model": "Elba",
                "device": "tablet"
            },
            {
                "regex": "BQ-7036L",
                "model": "Hornet",
                "device": "tablet"
            },
            {
                "regex": "BQ-7022(G)?",
                "model": "Canion",
                "device": "tablet"
            },
            {
                "regex": "Fnac 10 3G",
                "model": "Fnac 10\" 3G",
                "device": "tablet"
            },
            {
                "regex": "BQ-7021G",
                "model": "Hit",
                "device": "tablet"
            },
            {
                "regex": "BQ-7010G",
                "model": "Max",
                "device": "tablet"
            },
            {
                "regex": "BQ-7006G",
                "model": "Union",
                "device": "tablet"
            },
            {
                "regex": "BQ-7003",
                "model": "Jamaica",
                "device": "tablet"
            },
            {
                "regex": "BQ-6200L|BQ-6000L",
                "model": "Aurora"
            },
            {
                "regex": "BQ(?:ru|s)?-6631G",
                "model": "Surf"
            },
            {
                "regex": "BQ-6645L",
                "model": "6645L Element"
            },
            {
                "regex": "BQ-6061L",
                "model": "6061L Slim"
            },
            {
                "regex": "BQ-6022G",
                "model": "Aura"
            },
            {
                "regex": "BQ(ru)?[ -]6015L",
                "model": "Universe"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5525|6030G|6010G)",
                "model": "Practic"
            },
            {
                "regex": "BQ-6001L|BQ-6050",
                "model": "Jumbo"
            },
            {
                "regex": "BQ-5707G(?:[);/ ]|$)",
                "model": "Next Music"
            },
            {
                "regex": "BQ-5702(?:[);/ ]|$)",
                "model": "Spring"
            },
            {
                "regex": "BQ-5700L(?:[);/ ]|$)",
                "model": "Space X"
            },
            {
                "regex": "BQ-(?:5591|551[89]G)(?:[);/ ]|$)",
                "model": "Jeans"
            },
            {
                "regex": "BQ-5522",
                "model": "Next"
            },
            {
                "regex": "BQ-5520L(?:[);/ ]|$)",
                "model": "Silk"
            },
            {
                "regex": "BQ-5519L(?:[);/ ]|$)",
                "model": "Fast Plus"
            },
            {
                "regex": "BQ-5540L(?:[);/ ]|$)",
                "model": "Fast Pro"
            },
            {
                "regex": "BQ-5517L(?:[);/ ]|$)",
                "model": "Twin Pro"
            },
            {
                "regex": "BQ-5516L(?:[);/ ]|$)",
                "model": "Twin"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5515|6868L)(?:[);/ ]|$)",
                "model": "Wide"
            },
            {
                "regex": "BQ-5515L(?:[);/ ]|$)",
                "model": "Fast"
            },
            {
                "regex": "BQ-(?:5512L|5528L)(?:[);/ ]|$)",
                "model": "Strike Forward"
            },
            {
                "regex": "BQ-5511L(?:[);/ ]|$)",
                "model": "Bliss"
            },
            {
                "regex": "BQS[_ ]5505(?:[);/ ]|$)",
                "model": "Amsterdam"
            },
            {
                "regex": "BQ(?:ru)?-5510(?:[);/ ]|$)",
                "model": "Strike Power Max 4G"
            },
            {
                "regex": "BQ(?:ru)?-(?:5521|5594)(?:[);/ ]|$)",
                "model": "Strike Power Max"
            },
            {
                "regex": "BQ-5508L(?:[);/ ]|$)",
                "model": "Next LTE"
            },
            {
                "regex": "BQ-5507L(?:[);/ ]|$)",
                "model": "Iron Max"
            },
            {
                "regex": "BQ(?:ru)?-5504(?:[);/ ]|$)",
                "model": "Strike Selfie Max"
            },
            {
                "regex": "BQ(?:ru)?-5503(?:[);/ ]|$)",
                "model": "Nice 2"
            },
            {
                "regex": "BQ(?:ru)?-6045L(?:[);/ ]|$)",
                "model": "Nice"
            },
            {
                "regex": "BQ(?:ru)?-4030G(?:[);/ ]|$)",
                "model": "Nice Mini"
            },
            {
                "regex": "BQS-5502(?:[);/ ]|$)",
                "model": "Hammer"
            },
            {
                "regex": "BQS-5501(?:[);/ ]|$)",
                "model": "Kawasaki"
            },
            {
                "regex": "BQS-5500(?:[);/ ]|$)",
                "model": "Vancouver"
            },
            {
                "regex": "BQ-5500L(?:[);/ ]|$)",
                "model": "Advance"
            },
            {
                "regex": "BQ-5302G(?:[);/ ]|$)",
                "model": "Velvet 2"
            },
            {
                "regex": "BQ-5301(?:[);/ ]|$)",
                "model": "Strike View"
            },
            {
                "regex": "BQ-5300G(?:[);/ ]|$)",
                "model": "Velvet View"
            },
            {
                "regex": "BQ(ru|S)?-(?:5211|5020)(?:[);/ ]|$)",
                "model": "Strike"
            },
            {
                "regex": "BQ-5206L(?:[);/ ]|$)",
                "model": "Balance"
            },
            {
                "regex": "BQ(?:ru|S)?-(?:5204|5050)(?:[);/ ]|$)",
                "model": "Strike Selfie"
            },
            {
                "regex": "BQ(?:ru)?-5203(?:[);/ ]|$)",
                "model": "Vision"
            },
            {
                "regex": "BQ(?:ru)?-5202(?:[);/ ]|$)",
                "model": "Space Lite"
            },
            {
                "regex": "BQ(?:ru)?-5201(?:[);/ ]|$)",
                "model": "Space"
            },
            {
                "regex": "BQ-5082(?:[);/ ]|$)",
                "model": "Sense 2"
            },
            {
                "regex": "BQ-5045L(?:[);/ ]|$)",
                "model": "Wallet"
            },
            {
                "regex": "BQ-5047L(?:[);/ ]|$)",
                "model": "Like"
            },
            {
                "regex": "BQ-5071(?:[);/ ]|$)",
                "model": "Belief"
            },
            {
                "regex": "BQ[S]?-(?:5065|5340)(?:[);/ ]|$)",
                "model": "Choice"
            },
            {
                "regex": "BQ(?:S|ru)?-5046L(?:[);/ ]|$)",
                "model": "Choice LTE"
            },
            {
                "regex": "BQ(?:ru)?-?(?:5059|5514G)(?:[);/ ]|$)",
                "model": "Strike Power"
            },
            {
                "regex": "(?:BQru_)?BQ(?:ru)?-5058(?:[);/ ]|$)",
                "model": "Strike Power Easy"
            },
            {
                "regex": "BQ(?:ru)?-5057(?:[);/ ]|$)",
                "model": "Strike 2"
            },
            {
                "regex": "BQ[S]?-(?:5056|5030)(?:[);/ ]|$)",
                "model": "Fresh"
            },
            {
                "regex": "BQ-6042l(?:[);/ ]|$)",
                "model": "Magic E"
            },
            {
                "regex": "BQS-5055(?:[);/ ]|$)",
                "model": "Turbo Plus"
            },
            {
                "regex": "BQ(?:ru)?-5054(?:[);/ ]|$)",
                "model": "Crystal"
            },
            {
                "regex": "BQ-5052(?:[);/ ]|$)",
                "model": "Sense"
            },
            {
                "regex": "BQ-5060L",
                "model": "Basic"
            },
            {
                "regex": "BQ-6861L",
                "model": "Core"
            },
            {
                "regex": "BQ-6761",
                "model": "Unit"
            },
            {
                "regex": "BQ-6051G(?:[);/ ]|$)",
                "model": "Soul"
            },
            {
                "regex": "BQ[S]?-5045(?:[);/ ]|$)",
                "model": "Fast"
            },
            {
                "regex": "BQ(?:ru)?-(?:5037|5514L)(?:[);/ ]|$)",
                "model": "Strike Power 4G"
            },
            {
                "regex": "BQ(?:ru)?-5035(?:[);/ ]|$)",
                "model": "Velvet"
            },
            {
                "regex": "BQ(?:ru)?-5033(?:[);/ ]|$)",
                "model": "Shark"
            },
            {
                "regex": "BQ-5541L(?:[);/ ]|$)",
                "model": "Shark Rush"
            },
            {
                "regex": "BQ-5032(?:[);/ ]|$)",
                "model": "Element"
            },
            {
                "regex": "BQS-5025(?:[);/ ]|$)",
                "model": "High Way"
            },
            {
                "regex": "BQ(?:ru)?-5022(?:[);/ ]|$)",
                "model": "Bond"
            },
            {
                "regex": "BQ-5015L(?:[);/ ]|$)",
                "model": "First"
            },
            {
                "regex": "BQ-5016G(?:[);/ ]|$)",
                "model": "Choice"
            },
            {
                "regex": "BQ-5012L(?:[);/ ]|$)",
                "model": "Rich"
            },
            {
                "regex": "BQ-5521L(?:[);/ ]|$)",
                "model": "Rich Max"
            },
            {
                "regex": "BQS-5011(?:[);/ ]|$)",
                "model": "Monte Carlo"
            },
            {
                "regex": "BQ-5010G(?:[);/ ]|$)",
                "model": "Spot"
            },
            {
                "regex": "BQ-5000G(?:[);/ ]|$)",
                "model": "Velvet Easy"
            },
            {
                "regex": "BQS-5010(?:[);/ ]|$)",
                "model": "Prague"
            },
            {
                "regex": "BQ-5009L(?:[);/ ]|$)",
                "model": "Trend"
            },
            {
                "regex": "BQ-5560L",
                "model": "Trend (2021)"
            },
            {
                "regex": "BQ-5565L",
                "model": "Fest"
            },
            {
                "regex": "BQS-500[59](?:[);/ ]|$)",
                "model": "Sydney"
            },
            {
                "regex": "BQ-5008L(?:[);/ ]|$)",
                "model": "Brave"
            },
            {
                "regex": "BQ-5007L(?:[);/ ]|$)",
                "model": "Iron"
            },
            {
                "regex": "BQS-5006(?:[);/ ]|$)",
                "model": "Los Angeles"
            },
            {
                "regex": "BQ-(?:5005L|5530L)(?:[);/ ]|$)",
                "model": "Intense"
            },
            {
                "regex": "BQS-5004(?:[);/ ]|$)",
                "model": "Paris"
            },
            {
                "regex": "BQ-5003L(?:[);/ ]|$)",
                "model": "Shark Pro"
            },
            {
                "regex": "BQ-5002G(?:[);/ ]|$)",
                "model": "Fun"
            },
            {
                "regex": "BQS-5002(?:[);/ ]|$)",
                "model": "Colombo"
            },
            {
                "regex": "BQS-5003(?:[);/ ]|$)",
                "model": "Colombo II"
            },
            {
                "regex": "BQ-5001L(?:[);/ ]|$)",
                "model": "Contact"
            },
            {
                "regex": "BQS-5001(?:[);/ ]|$)",
                "model": "Milan"
            },
            {
                "regex": "BQ(?:ru|S)?-5000(?:[);/ ]|$)",
                "model": "Tokyo"
            },
            {
                "regex": "BQS-4800(?:[);/ ]|$)",
                "model": "Blade"
            },
            {
                "regex": "BQS-4707(?:[);/ ]|$)",
                "model": "Montreal"
            },
            {
                "regex": "BQS-4702(?:[);/ ]|$)",
                "model": "\u041Esaka"
            },
            {
                "regex": "BQS-4701(?:[);/ ]|$)",
                "model": "Venice"
            },
            {
                "regex": "BQ-(?:4585|5011G)(?:[);/ ]|$)",
                "model": "Fox View"
            },
            {
                "regex": "BQ(?:ru)?-4583(?:[);/ ]|$)",
                "model": "Fox Power"
            },
            {
                "regex": "BQS-4570(?:[);/ ]|$)",
                "model": "Drive"
            },
            {
                "regex": "BQS-4560(?:[);/ ]|$)",
                "model": "Golf"
            },
            {
                "regex": "BQS-4555(?:[);/ ]|$)",
                "model": "Turbo"
            },
            {
                "regex": "BQS-4550(?:[);/ ]|$)",
                "model": "Richmond"
            },
            {
                "regex": "BQ(?:ru)?-(?:4526|5004G)(?:[);/ ]|$)",
                "model": "Fox"
            },
            {
                "regex": "BQS-4525(?:[);/ ]|$)",
                "model": "Vienna"
            },
            {
                "regex": "BQS-4516(?:[);/ ]|$)",
                "model": "Singapore"
            },
            {
                "regex": "BQS-4515(?:[);/ ]|$)",
                "model": "Moscow"
            },
            {
                "regex": "BQS-4510(?:[);/ ]|$)",
                "model": "Florence"
            },
            {
                "regex": "BQS-4505(?:[);/ ]|$)",
                "model": "Santiago"
            },
            {
                "regex": "BQS-4503(?:[);/ ]|$)",
                "model": "Dubai"
            },
            {
                "regex": "BQS-4502(?:[);/ ]|$)",
                "model": "Kingston"
            },
            {
                "regex": "BQS-4501 Bristol",
                "model": "Bristol"
            },
            {
                "regex": "BQ-4501G(?:[);/ ]|$)",
                "model": "Fox Easy"
            },
            {
                "regex": "BQ(?:ru)?-4500(?:[);/ ]|$)",
                "model": "Fox LTE"
            },
            {
                "regex": "BQ-4077(?:[);/ ]|$)",
                "model": "Shark Mini"
            },
            {
                "regex": "BQ(?:ru)?-4072(?:[);/ ]|$)",
                "model": "Strike Mini"
            },
            {
                "regex": "BQ(?:ru)?[- ]402[68](?:[);/ ]|$)",
                "model": "Up!"
            },
            {
                "regex": "BQS-4010(?:[);/ ]|$)",
                "model": "Aspen"
            },
            {
                "regex": "BQS-4009(?:[);/ ]|$)",
                "model": "Orleans"
            },
            {
                "regex": "BQS-4008(?:[);/ ]|$)",
                "model": "Shanghai"
            },
            {
                "regex": "BQS-4007(?:[);/ ]|$)",
                "model": "Valencia"
            },
            {
                "regex": "BQS-4005(?:[);/ ]|$)",
                "model": "Seoul"
            },
            {
                "regex": "BQS-4004(?:[);/ ]|$)",
                "model": "Dusseldorf"
            },
            {
                "regex": "BQS-4003(?:[);/ ]|$)",
                "model": "Verona"
            },
            {
                "regex": "BQ-4001G(?:[);/ ]|$)",
                "model": "Cool"
            },
            {
                "regex": "BQS-4001(?:[);/ ]|$)",
                "model": "Oxford"
            },
            {
                "regex": "BQS-3510(?:[);/ ]|$)",
                "model": "Aspen Mini"
            },
            {
                "regex": "BQS-3503(?:[);/ ]|$)",
                "model": "Bombay"
            },
            {
                "regex": "BQ-1085L(?:[);/ ]|$)",
                "model": "Hornet Max Pro",
                "device": "tablet"
            },
            {
                "regex": "BQ-1036L",
                "model": "Exion Advant",
                "device": "tablet"
            },
            {
                "regex": "BQ-1084L(?:[);/ ]|$)",
                "model": "Hornet Max",
                "device": "tablet"
            },
            {
                "regex": "BQ-1083G(?:[);/ ]|$)",
                "model": "Armor Pro Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-1082G(?:[);/ ]|$)",
                "model": "Armor Pro",
                "device": "tablet"
            },
            {
                "regex": "BQ-1077L(?:[);/ ]|$)",
                "model": "Armor Pro LTE",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1057L(?:[);/ ]|$)",
                "model": "Passion",
                "device": "tablet"
            },
            {
                "regex": "BQ-1051G(?:[);/ ]|$)",
                "model": "Corsika",
                "device": "tablet"
            },
            {
                "regex": "BQ-1050G(?:[);/ ]|$)",
                "model": "Hawaii",
                "device": "tablet"
            },
            {
                "regex": "BQ[-]?1008G(?:[);/ ]|$)",
                "model": "Grace",
                "device": "tablet"
            },
            {
                "regex": "Aquaris (M10 FHD|M10 4G|M8)",
                "model": "Aquaris $1",
                "device": "tablet"
            },
            {
                "regex": "Aquaris_([AM])4\\.5",
                "model": "Aquaris $14.5"
            },
            {
                "regex": "BQ(?:ru)?[_ -](?:5590|5740G)(?:[);/ ]|$)",
                "model": "Spring"
            },
            {
                "regex": "BQ[S]?-(?:6016L|5520)(?:[);/ ]|$)",
                "model": "Mercury"
            },
            {
                "regex": "BQ(?:S|ru)?-(?:5701L|5060)(?:[);/ ]|$)",
                "model": "Slim"
            },
            {
                "regex": "(BQ-7850|BQ-700[12]G|BQ-8002G|BQ-905[12]G|BQ-9702G|BQ-7056G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "BQ-8006G(?:[);/ ]|$)",
                "model": "Java",
                "device": "tablet"
            },
            {
                "regex": "BQ-9055L",
                "model": "Exion Pro Mini",
                "device": "tablet"
            },
            {
                "regex": "BQ-8088L",
                "model": "Exion Surf",
                "device": "tablet"
            },
            {
                "regex": "BQ-7062G(?:[);/ ]|$)",
                "model": "Fiji",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1081G(?:[);/ ]|$)",
                "model": "Grace 3G",
                "device": "tablet"
            },
            {
                "regex": "BQ-7802G(?:[);/ ]|$)",
                "model": "Luzon",
                "device": "tablet"
            },
            {
                "regex": "BQ-7008G(?:[);/ ]|$)",
                "model": "Clarion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7064G(?:[);/ ]|$)",
                "model": "Fusion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7050G(?:[);/ ]|$)",
                "model": "Malta",
                "device": "tablet"
            },
            {
                "regex": "BQ-7000G(?:[);/ ]|$)",
                "model": "Charm",
                "device": "tablet"
            },
            {
                "regex": "BQ-7040G(?:[);/ ]|$)",
                "model": "Charm Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-7038G(?:[);/ ]|$)",
                "model": "Light Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ-7005G(?:[);/ ]|$)",
                "model": "Maui",
                "device": "tablet"
            },
            {
                "regex": "BQ-7098G(?:[);/ ]|$)",
                "model": "Armor Power",
                "device": "tablet"
            },
            {
                "regex": "BQ-1007(?:[);/ ]|$)",
                "model": "Necker",
                "device": "tablet"
            },
            {
                "regex": "BQ-1045[G]?(?:[);/ ]|$)",
                "model": "Orion",
                "device": "tablet"
            },
            {
                "regex": "BQ-(?:1054L|1020L)(?:[);/ ]|$)",
                "model": "Nexion",
                "device": "tablet"
            },
            {
                "regex": "BQ-7083G(?:[);/ ]|$)",
                "model": "Light",
                "device": "tablet"
            },
            {
                "regex": "BQ-8077L(?:[);/ ]|$)",
                "model": "Exion Plus",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-7083(?:[);/ ]|$)",
                "model": "7083",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1056L(?:[);/ ]|$)",
                "model": "1056L",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1022l(?:[);/ ]|$)",
                "model": "Armor Pro LTE+",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1024L(?:[);/ ]|$)",
                "model": "Exion Pro",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-7055L(?:[);/ ]|$)",
                "model": "Exion One",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-1025L(?:[);/ ]|$)",
                "model": "Exion Max",
                "device": "tablet"
            },
            {
                "regex": "BQ(?:ru)?-7081(?:[);/ ]|$)",
                "model": "Charm",
                "device": "tablet"
            },
            {
                "regex": "Edison 3(?:[);/ ]|$)",
                "model": "Edison 3",
                "device": "tablet"
            },
            {
                "regex": "(?:bq )?Aquaris ([^/);]*)(?: Build|[);])",
                "model": "Aquaris $1"
            },
            {
                "regex": "(?:bq )?Aquaris",
                "model": "Aquaris"
            },
            {
                "regex": "BQ_32FSFO1B",
                "device": "tv",
                "model": "32FSF01B"
            },
            {
                "regex": "BQ_(\\d{2}FS\\d{2}B)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Smart_TV_BQ",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "bq ([^/;]+) Build",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Bush": {
        "regex": "Bush[ ;,_-]|Bush10Nou",
        "device": "smartphone",
        "models": [
            {
                "regex": "Bush10Nou",
                "device": "tablet",
                "model": "10Nou"
            },
            {
                "regex": "Spira B1 (8|10\\.1)",
                "device": "tablet",
                "model": "Spira B1 $1\""
            },
            {
                "regex": "BUSH ([^;/)]+)Tablet(?: Build|[);])",
                "model": "$1Tablet",
                "device": "tablet"
            },
            {
                "regex": "BUSH Spira B2 5 Smartphone",
                "model": "Spira B2 5\""
            },
            {
                "regex": "BUSH ([^;/)]+) Smartphone",
                "model": "$1"
            },
            {
                "regex": "BUSH ([^;/)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "BUSH\\-v\\.tv\\.([0-9]{4})",
                "device": "tv",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "BUSH, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": "",
                "device": "tv"
            }
        ]
    },
    "CAGI": {
        "regex": "CAGI-",
        "device": "smartphone",
        "models": [
            {
                "regex": "CAGI-OMEGA",
                "model": "Omega"
            },
            {
                "regex": "CAGI-([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Capitel": {
        "regex": "Capitel-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Captiva": {
        "regex": "Captiva[ _-]([^;/)]+)(?: Build|\\))",
        "device": "tablet",
        "model": "Pad $1"
    },
    "Casio": {
        "regex": "(C811|C7[57]1)(?: 4G)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "C751(?:[);/ ]|$)",
                "model": "G'zOne Ravine"
            },
            {
                "regex": "C771(?:[);/ ]|$)",
                "model": "G'zOne Commando"
            },
            {
                "regex": "C811 4G(?:[);/ ]|$)",
                "model": "G'zOne Commando 4G LTE"
            }
        ]
    },
    "VOCAL": {
        "regex": "VOCAL[ _](V[01]|V11|V2 Lite|V0Core)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Casper": {
        "regex": "CASPER[_ ]|VIA[- _](X30(?: Plus)?|[AXS]40|X45|[XF]20|F30|T7D|A[34]|E[43]|E30|F[123]|G[345]|M4|M3[05]|[LM]40|[LS]8|S7|P[23]|V8C|A[13]_Plus(?:_64)?|A1(?:_1)?|S[13]0|S48|S|T17_M|T1[07]|T7|[ST]7-3G|T8B|T8D-3G|S1[78]|S48_0|[LS]30_0|L[35]0|F30 Plus|M30 Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:CASPER[_ ])?VIA[_ ](A1|[FMX]30)[_ ]Plus(?:_64)?",
                "model": "VIA $1 Plus"
            },
            {
                "regex": "(?:CASPER[_ ])?VIA[_ ]([AXM]40|[XF]20|X45|F30|X30|G1_Plus|F30 Plus|A3_Plus|G[135]|E[14]|E30|[AE]2|M[123]|V[35689]|V10|G3|V6X|A[34]|E3|F[123]|G4|M4|M3[05]|P[23]|S|V8C|A1(?:_1)?)(?:[);/ ]|$)",
                "model": "VIA $1"
            },
            {
                "regex": "CASPER_VIA_E1c",
                "model": "VIA E1C"
            },
            {
                "regex": "CASPER_L10_4\\.5G",
                "model": "L10 4.5G",
                "device": "tablet"
            },
            {
                "regex": "CASPER_(S[23]8)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "VIA[- _]([ST]7|T8D)-3G",
                "model": "VIA $1 3G",
                "device": "tablet"
            },
            {
                "regex": "VIA[- _](T7D|S[134]0|S48|[LS]8|[LS]30|S7|T17_M|T1[07]|T7|T8B|S1[78]|L[45]0)(?:_0)?(?:[);/ ]|$)",
                "model": "VIA $1",
                "device": "tablet"
            }
        ]
    },
    "Cat": {
        "regex": "BULLITTGROUPLIMITED|B30_Dorado|Cat ?(tablet|stargate|nova|S52|B35)|(?:B15Q|CAT-B100|S22 FLIP|S62 Pro|S48c|Android 9(?:[\\d.]*);(?: [\\w-]+;)? S52|Android 10(?:[\\d.]*);(?: [\\w-]+;)? S42)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "B15Q",
                "model": "B15Q",
                "device": "smartphone"
            },
            {
                "regex": "CAT B35",
                "model": "B35",
                "device": "smartphone"
            },
            {
                "regex": "S61(?:[);/ ]|$)",
                "model": "S61",
                "device": "smartphone"
            },
            {
                "regex": "S62 Pro",
                "model": "S62 Pro",
                "device": "smartphone"
            },
            {
                "regex": "S22 FLIP",
                "model": "S22 Flip",
                "device": "smartphone"
            },
            {
                "regex": "(S48c|S[45]2)(?:[);/ ]|$)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "Cat ?(?:tablet)? ?((?:Galactica|Nova|StarGate|PHOENIX)[^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "Cat ?tablet",
                "model": "Nova"
            },
            {
                "regex": "CAT-(B100)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "(B30)_Dorado",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Carrefour": {
        "regex": "CT(?:10[0123]0|7[12]0|820|735_16GB|1056_32GB|1005)(?:W|FR)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CT820",
                "model": "Touch Tablet Neo2"
            },
            {
                "regex": "CT(10[0123]0(?:W|FR)?)",
                "model": "CT$1"
            },
            {
                "regex": "CT(7[12]0(?:W|FR)?|735|1005|1056)",
                "model": "CT$1"
            }
        ]
    },
    "Celcus": {
        "regex": "CELCUS, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Celkon": {
        "regex": "Celkon|Android 7.+ UNIQ(?: Build|[);])|(?:Millennia Hero|2GBStar|2GBXpress|CliQ2|Campus Prime)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Celkon[ _*](C[78]20)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Celkon[_ ]4G_TAB-8",
                "model": "4G Tab 8",
                "device": "tablet"
            },
            {
                "regex": "Millennia Hero",
                "model": "Millennia Hero"
            },
            {
                "regex": "2GBStar",
                "model": "2GB Star"
            },
            {
                "regex": "2GBXpress",
                "model": "2GB Xpress"
            },
            {
                "regex": "CliQ2(?:[);/ ]|$)",
                "model": "CliQ 2"
            },
            {
                "regex": "Q4GPlus(?:[);/ ]|$)",
                "model": "Q4G Plus"
            },
            {
                "regex": "Android 7.+ UniQ(?: Build|[);])",
                "model": "UniQ"
            },
            {
                "regex": "(Campus Prime)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Celkon[ _*](CT[^;/]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Celkon[ _*]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Celkon[\\. _*]([^;/\\)]+)[\\)/]",
                "model": "$1"
            }
        ]
    },
    "Cellution": {
        "regex": "Cosmas|CT_Cosmas_V|PADUA",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:CT_)?Cosmas_(TF|[VF])",
                "model": "Cosmas $1"
            },
            {
                "regex": "Cosmas",
                "model": "Cosmas"
            },
            {
                "regex": "PADUA",
                "model": "Padua"
            }
        ]
    },
    "Changhong": {
        "regex": "Changhong|HON H01|GHONGV12",
        "device": "smartphone",
        "models": [
            {
                "regex": "Changhong[ ]?(X1-K|X6|R8|Z9S?|Z1S|S18|R9|S07)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "HON H01",
                "model": "HONPhone H01"
            },
            {
                "regex": "GHONGV12",
                "model": "V12"
            },
            {
                "regex": "ChangHong Andr[o0]id TV",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "changhong,([a-z0-9_ -]+),(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "(?:Opera TV.+)Changhong-([^);/]+)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "China Mobile": {
        "regex": "(?:M812C|1501_M02|9930i|A1303|A309W|M651CY|M653|CMCC[ -]M(?:670|860)|M762G|SP210|SP[23]00)(?: Build|[);]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M651CY",
                "model": "A3"
            },
            {
                "regex": "CMCC-M860",
                "model": "N5 Pro"
            },
            {
                "regex": "M653",
                "model": "A3s"
            },
            {
                "regex": "M762G",
                "model": "N5"
            },
            {
                "regex": "(M812C|1501_M02|9930i|A1303|A309W|M670|SP210|SP[23]00)",
                "model": "$1"
            }
        ]
    },
    "CHCNAV": {
        "regex": "CHCNAV|(?:HCE[67]00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(HCE[67]00)",
                "device": "peripheral",
                "model": "$1"
            }
        ]
    },
    "Comio": {
        "regex": "Comio|(?:CT701G PLUS|CT701W|GT100)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GT100",
                "model": "GT100",
                "device": "tablet"
            },
            {
                "regex": "CT701W",
                "model": "CT701W",
                "device": "tablet"
            },
            {
                "regex": "CT701G PLUS",
                "model": "CT701G Plus",
                "device": "tablet"
            },
            {
                "regex": "Comio[ _-]?([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "CommScope": {
        "regex": "VIP7802(?:[);/ ]|$)",
        "device": "tv",
        "model": "VIP7802"
    },
    "Compal": {
        "regex": "Compal-[a-z0-9]+",
        "device": "feature phone",
        "model": "$1"
    },
    "Artel": {
        "regex": "Artel[_ ]|\\w+_ARTEL_\\w+|(?: GAP|GAP YOQ| ALO|U1 MINI|Android 8(?:[\\d.]*);(?: [\\w-]+;)? U[124](?!/)|U3_4G| R3G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "R3G(?:[);/ ]|$)",
                "device": "tv",
                "model": "R3 GTV"
            },
            {
                "regex": "GAP|GAP YOQ(?:[);/ ]|$)",
                "model": "Gap Yo Q"
            },
            {
                "regex": "U1 MINI(?:[);/ ]|$)",
                "model": "U1 Mini"
            },
            {
                "regex": "U3_4G(?:[);/ ]|$)",
                "model": "U3 4G"
            },
            {
                "regex": "U([124])(?:[);/ ]|$)",
                "model": "U$1"
            },
            {
                "regex": "ALO(?:[);/ ]|$)",
                "model": "Allo"
            },
            {
                "regex": "Artel[_ ](Quadro(?: Pro)?|Tesla|Air|Tomchi|Premium|U3_4G|Z5|Sentinel (?:X 8G|X D5|X)|T10|T21)",
                "model": "$1"
            },
            {
                "regex": "Artel[_ ]Komi3",
                "model": "Komi 3"
            },
            {
                "regex": "Artel[_ ]Q21_PRO",
                "model": "Q21 Pro"
            },
            {
                "regex": "Artel[_ ]Q21",
                "model": "Q21"
            },
            {
                "regex": "Artel[_ ](Star|Nova|Connect|Choice|Style)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(?:\\w+_)?ARTEL_([FVM]5|X[45])_\\w+",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "ComTrade Tesla": {
        "regex": "Tesla(?!(?:Browser|Group/LUMUS))|Impulse 7\\.85 3G|Impulse 10\\.1 OCTA|Smartphone_6\\.1|SP(?:6\\.2|6\\.2_Lite)|TTL(?:713G|8)|Explr 9",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Explr 9)",
                "model": "$1"
            },
            {
                "regex": "TeslaEvo5\\.0",
                "model": "Evo 5.0"
            },
            {
                "regex": "(Gravity 9\\.7 SHD)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(Impulse 7\\.85 3G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Impulse 10\\.1 OCTA",
                "model": "Impulse 10.1\" OCTA",
                "device": "tablet"
            },
            {
                "regex": "Tesla_SP([^/;)]+)L(?: Build|[;)])",
                "model": "Smartphone $1 Lite"
            },
            {
                "regex": "Smartphone_6\\.1",
                "model": "Smartphone 6.1"
            },
            {
                "regex": "(?:Tesla_)?SP(\\d+)[_.](\\d+)_Lite(?: Build|[;)])",
                "model": "Smartphone $1.$2 Lite"
            },
            {
                "regex": "Tesla_SP(\\d+)[_.](\\d+)(?: Build|[;)])",
                "model": "Smartphone $1.$2"
            },
            {
                "regex": "Tesla_SP([^/;]+) Build",
                "model": "Smartphone $1"
            },
            {
                "regex": "SP([^/;]+) Build",
                "model": "Smartphone $1"
            },
            {
                "regex": "Smartphone ([36])",
                "model": "Smartphone $1"
            },
            {
                "regex": "Tesla_Tablet_785",
                "model": "7.85\"",
                "device": "tablet"
            },
            {
                "regex": "TTH7",
                "model": "H7",
                "device": "tablet"
            },
            {
                "regex": "TTL7 Build",
                "model": "L7",
                "device": "tablet"
            },
            {
                "regex": "Tesla_Tablet_L7_3G",
                "model": "L7 3G",
                "device": "tablet"
            },
            {
                "regex": "(L7\\.1)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "TTL713G",
                "model": "L7.1 3G",
                "device": "tablet"
            },
            {
                "regex": "(L7 Quad) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(L7 Quad Lite)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "TTL8 Build",
                "model": "L8",
                "device": "tablet"
            },
            {
                "regex": "(L8\\.1)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "TESLA_TABLET_M7",
                "model": "M7",
                "device": "tablet"
            },
            {
                "regex": "Tesla_Tablet_M8",
                "model": "M8",
                "device": "tablet"
            },
            {
                "regex": "TESLA XT550",
                "model": "MediaBox XT550",
                "device": "tv"
            },
            {
                "regex": "TESLA,([a-z0-9_ -]+),(?:wired|wireless)",
                "model": "",
                "device": "tv"
            }
        ]
    },
    "ConCorde": {
        "regex": "ConCorde ([^/;]+) Build|Concorde_Raptor_Z55(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Concorde_(Raptor_Z55)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ConCorde Tab ?([^/;]+) Build",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "ConCorde ReadMan ?([^/;]+) Build",
                "model": "ReadMan $1",
                "device": "tablet"
            },
            {
                "regex": "ConCorde ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Condor": {
        "regex": "Condor|Allure (?:A8 Pro|A55 Slim|M[123]|X)|Griffe T[235-9]|TFX71[12]G|TFX71[34]L|TMK715L|TRA-901G|TGW[-]?(710G|709|102L|801[GL])|(?:PGN\\-?[456][012][0-9]|PHS\\-601|PHQ519|PAM412|PHQ52[056]|TB105L|TB717G|PKT\\-301|Plume (?:H1|L[1-68]|P8|P6 PRO LTE)|Infinity E5|Infinity a4|Infinity_i[45]|PKT411|SP413|PAM524|GT60 PRO|GT60|NOVA60(?: i)?)(?:[);/ ]|$)|CTAB[^/;]+ Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "CTAB([^/;]+) Build",
                "device": "tablet",
                "model": "CTAB $1"
            },
            {
                "regex": "(TGW)-?(710G|709|801[GL]|102L)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1 $2"
            },
            {
                "regex": "(TFX71[12]G|TFX71[34]L|TB105L|TB717G|TMK715L)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(TRA)-(901G)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1 $2"
            },
            {
                "regex": "(?:Condor_)(FP216L)(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "NOVA60 i",
                "model": "Nova 60i"
            },
            {
                "regex": "NOVA60",
                "model": "Nova 60"
            },
            {
                "regex": "PHS-601",
                "model": "C8"
            },
            {
                "regex": "GT60 PRO",
                "model": "GT60 Pro"
            },
            {
                "regex": "PGN-?403",
                "model": "C4+ Noir"
            },
            {
                "regex": "PGN-?404",
                "model": "C7 Mini"
            },
            {
                "regex": "PGN-?409",
                "model": "Plume P4"
            },
            {
                "regex": "PKT-?301",
                "model": "C2"
            },
            {
                "regex": "PGN-?504",
                "model": "C5"
            },
            {
                "regex": "PGN-?505",
                "model": "C8S"
            },
            {
                "regex": "PGN-?506",
                "model": "C7"
            },
            {
                "regex": "(Allure \\w+) Plus",
                "model": "$1 Plus"
            },
            {
                "regex": "(Allure \\w+) Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "(Allure \\w+) Lite",
                "model": "$1 Lite"
            },
            {
                "regex": "(Allure (?:M[123]|X)|GT60)",
                "model": "$1"
            },
            {
                "regex": "PGN\\-?507",
                "model": "Allure A9"
            },
            {
                "regex": "PGN-?508",
                "model": "C6+"
            },
            {
                "regex": "PGN\\-?509",
                "model": "C6 Pro"
            },
            {
                "regex": "PGN-?511",
                "model": "Allure A9 Plus"
            },
            {
                "regex": "PAM-?412",
                "model": "G2S"
            },
            {
                "regex": "PGN-?513",
                "model": "Griffe G4"
            },
            {
                "regex": "SP413",
                "model": "Griffe T1"
            },
            {
                "regex": "PKT411",
                "model": "Griffe G2"
            },
            {
                "regex": "PHQ519",
                "model": "Griffe G4S"
            },
            {
                "regex": "PHQ520",
                "model": "Griffe G5"
            },
            {
                "regex": "PAM524",
                "model": "Griffe G5 Plus"
            },
            {
                "regex": "PHQ525",
                "model": "Griffe G6"
            },
            {
                "regex": "PHQ526",
                "model": "Griffe G6 Pro"
            },
            {
                "regex": "PGN-?514",
                "model": "Plume P7"
            },
            {
                "regex": "PGN-?515",
                "model": "Plume P4 Pro"
            },
            {
                "regex": "PGN-?516",
                "model": "Plume P5"
            },
            {
                "regex": "PGN-?51[78]",
                "model": "Plume P6"
            },
            {
                "regex": "Infinity a4",
                "model": "Infinity A4"
            },
            {
                "regex": "Infinity e5 pro",
                "model": "Infinity E5 Pro"
            },
            {
                "regex": "Infinity E5",
                "model": "Infinity E5"
            },
            {
                "regex": "Infinity_i([45])",
                "model": "Infinity I$1"
            },
            {
                "regex": "PGN-?521",
                "model": "Griffe G4 Plus"
            },
            {
                "regex": "Griffe T3 ?pro",
                "model": "Griffe T3 Pro"
            },
            {
                "regex": "Griffe T([0-9]) Plus",
                "model": "Griffe T$1 Plus"
            },
            {
                "regex": "Griffe T([0-9])",
                "model": "Griffe T$1"
            },
            {
                "regex": "PGN-?522",
                "model": "P6 Plus"
            },
            {
                "regex": "PGN-?523",
                "model": "P7 Plus"
            },
            {
                "regex": "PGN-?527",
                "model": "Plume P4 Plus"
            },
            {
                "regex": "PGN-?528|PLUME P6 PRO LTE",
                "model": "Plume P6 Pro LTE"
            },
            {
                "regex": "PGN-?605",
                "model": "Plume P8"
            },
            {
                "regex": "PGN-?606",
                "model": "Allure A55"
            },
            {
                "regex": "PGN-?607",
                "model": "Allure A100"
            },
            {
                "regex": "PGN-?608|Allure A55 Slim",
                "model": "Allure A55 Slim"
            },
            {
                "regex": "PGN-?609",
                "model": "Allure A100 Lite"
            },
            {
                "regex": "PGN-?610",
                "model": "Plume P8 Lite"
            },
            {
                "regex": "PGN-?611",
                "model": "Allure A8"
            },
            {
                "regex": "PGN-?612",
                "model": "Allure A8 Plus"
            },
            {
                "regex": "PGN-?613",
                "model": "Allure A55 Plus"
            },
            {
                "regex": "Plume H1",
                "model": "Plume H1"
            },
            {
                "regex": "Plume L([24568]) Pro",
                "model": "Plume L$1 Pro"
            },
            {
                "regex": "Plume L([13]) Plus",
                "model": "Plume L$1 Plus"
            },
            {
                "regex": "Plume L3 Smart",
                "model": "Plume L3 Smart"
            },
            {
                "regex": "Plume L([1-5])",
                "model": "Plume L$1"
            },
            {
                "regex": "Plume P8 Pro",
                "model": "Plume P8 Pro"
            },
            {
                "regex": "PGN-?([0-9]{3})",
                "model": "PGN-$1"
            }
        ]
    },
    "Coolpad": {
        "regex": "(?:YL-)?Coolpad|(?:Cool_9S|1824-S0|8190Q|1831-A0|8676-[AM]01|1872-A0|REVVLPLUS C3701A|VCR-[AI]0|C105-(?:8|E0)|C106-[789]|C107-9| C106|MTS-T0|ORL-C0|DLS-E0|182[56]-I01|1825-E0| 1825|8298-(?:M02|A01)|5560S|CP3320AS2|CP3321AT|CP350[34]L|cp3636a|CP3648AT?|CP3667AT|CP3669AS|cp3705A[S]?|CP3706AS|CP23NV3|CP8298_I00|CP8676_I0[23]|C103|CP03|C1-U02|SAC-A0| 203[29]|CP0[57]|CP12[psQ]?)(?:[);/ ]|$)|(8295|5860S) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "CP23NV3",
                "model": "Y60 5G"
            },
            {
                "regex": "VCR-[AI]0",
                "model": "Cool Play 6"
            },
            {
                "regex": "1831-A0(?:[);/ ]|$)",
                "model": "Cool Play C7"
            },
            {
                "regex": "1872-A0(?:[);/ ]|$)",
                "model": "Cool Play 7"
            },
            {
                "regex": "2032(?:[);/ ]|$)",
                "model": "N7 Plus"
            },
            {
                "regex": "REVVLPLUS C3701A",
                "model": "REVVL Plus",
                "device": "phablet"
            },
            {
                "regex": "CP3667AT",
                "model": "Tasker",
                "device": "tablet"
            },
            {
                "regex": "8190Q(?:[);/ ]|$)",
                "model": "8190Q"
            },
            {
                "regex": "DLS-E0(?:[);/ ]|$)",
                "model": "N5"
            },
            {
                "regex": "1825-E0",
                "model": "N5 Lite"
            },
            {
                "regex": "1824-S0(?:[);/ ]|$)",
                "model": "N5C"
            },
            {
                "regex": "CP3321AT(?:[);/ ]|$)",
                "model": "Bellaza"
            },
            {
                "regex": "cp3636a(?:[);/ ]|$)",
                "model": "Canvas"
            },
            {
                "regex": "CP3705A[S]?(?:[);/ ]|$)",
                "model": "Legacy"
            },
            {
                "regex": "CP3648AT?(?:[);/ ]|$)",
                "model": "Legacy S"
            },
            {
                "regex": "CP3320AS2?(?:[);/ ]|$)",
                "model": "Legacy S SR"
            },
            {
                "regex": "CP3706AS(?:[);/ ]|$)",
                "model": "Legacy Brisa"
            },
            {
                "regex": "CP3669AS(?:[);/ ]|$)",
                "model": "Suva"
            },
            {
                "regex": "MTS-T0(?:[);/ ]|$)",
                "model": "N2M"
            },
            {
                "regex": "(?:C106-[789]|R116|C10[36]|C1-U02)(?:[);/ ]|$)",
                "model": "Cool 1"
            },
            {
                "regex": "2039(?:[);/ ]|$)",
                "model": "Cool S"
            },
            {
                "regex": "C107-9(?:[);/ ]|$)",
                "model": "1C"
            },
            {
                "regex": "C105-(?:E0|8)(?:[);/ ]|$)",
                "model": "Cool S1"
            },
            {
                "regex": "1826-I01(?:[);/ ]|$)",
                "model": "Cool 5"
            },
            {
                "regex": "1825-I01(?:[);/ ]|$)",
                "model": "Cool 3 Plus"
            },
            {
                "regex": "1825(?:[);/ ]|$)",
                "model": "Cool 3"
            },
            {
                "regex": "ORL-C0(?:[);/ ]|$)",
                "model": "Cool 9"
            },
            {
                "regex": "Cool_9S(?:[);/ ]|$)",
                "model": "Cool 9S"
            },
            {
                "regex": "CP03(?:[);/ ]|$)",
                "model": "Cool 20"
            },
            {
                "regex": "CP05(?:[);/ ]|$)",
                "model": "Cool 20 Pro"
            },
            {
                "regex": "CP07(?:[);/ ]|$)",
                "model": "Cool 20S 5G"
            },
            {
                "regex": "CP12Q(?:[);/ ]|$)",
                "model": "Cool 30i"
            },
            {
                "regex": "(CP12)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CP12P(?:[);/ ]|$)",
                "model": "CP12P"
            },
            {
                "regex": "CP12s(?:[);/ ]|$)",
                "model": "CP12s"
            },
            {
                "regex": "SAC-A0(?:[);/ ]|$)",
                "model": "26"
            },
            {
                "regex": "5560S(?:[);/ ]|$)",
                "model": "Arise"
            },
            {
                "regex": "(5860S|8295) Build",
                "model": "$1"
            },
            {
                "regex": "Coolpad[_ ]2041",
                "model": "10A"
            },
            {
                "regex": "E501",
                "model": "Modena"
            },
            {
                "regex": "E502",
                "model": "Modena 2"
            },
            {
                "regex": "CP8676_I02(?:[);/ ]|$)",
                "model": "Note 3"
            },
            {
                "regex": "COR-I0(?:[);/ ]|$)",
                "model": "Note 6"
            },
            {
                "regex": "CP8676_I03(?:[);/ ]|$)",
                "model": "Note 3 Plus"
            },
            {
                "regex": "CP8298_I00(?:[);/ ]|$)",
                "model": "Note 3 Lite"
            },
            {
                "regex": "(CP350[34]L)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(8676-[AM]01|8298-(?:M02|A01))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Coolpad[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:YL-)?Coolpad[ _-]?([a-z0-9-]+)",
                "model": "$1"
            }
        ]
    },
    "Clarmin": {
        "regex": "Clarmin|(?:B8Lite|B8Plus|Android 7(?:[\\d.]*);(?: [\\w-]+;)? B5Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "B8Lite",
                "model": "B8 Lite"
            },
            {
                "regex": "B8Plus",
                "model": "B8 Plus"
            },
            {
                "regex": "B5Pro",
                "model": "B5 Pro"
            },
            {
                "regex": "Clarmin[_ ](B[65]|C1)",
                "model": "$1"
            }
        ]
    },
    "CORN": {
        "regex": "CORN[_ ]|(?:C55 Pro|C60 Ultra|Fenix8_3G|Note1|Tronik_(?:[123]|12S)|Star7 3G|Coco10_Ultra_4G|Play25_Pro_4G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(C55 Pro|C60 Ultra|Star7 3G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Play25_Pro_4G",
                "model": "Play 25 Pro 4G"
            },
            {
                "regex": "Coco10_Ultra_4G",
                "model": "Coco 10 Ultra 4G"
            },
            {
                "regex": "Fenix8_3G(?:[);/ ]|$)",
                "model": "Fenix 8 3G"
            },
            {
                "regex": "CORN Note1(?:[);/ ]|$)",
                "model": "Note 1"
            },
            {
                "regex": "CORN R([124])0(?:[);/ ]|$)",
                "model": "R$10"
            },
            {
                "regex": "Tronik_([123]|12S)(?:[);/ ]|$)",
                "model": "Tronik $1"
            },
            {
                "regex": "CORN[_ ]C(4)(?:[);/ ]|$)",
                "model": "C$1"
            },
            {
                "regex": "CORN[_ ]X(4|55|5)(?:[);/ ]|$)",
                "model": "X$1"
            }
        ]
    },
    "Cosmote": {
        "regex": "Cosmote",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cosmote_My_mini_Tab",
                "device": "tablet",
                "model": "My Mini Tab"
            },
            {
                "regex": "Cosmote?[_ ]([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Cricket": {
        "regex": "Cricket-([a-z0-9]+)|CKT_|(?:U(?:102|304|325|380|572|6080|655|668|680|705|1030)AC|V350C|EC1002|EC21100[1-4]|SL100EA|SL101AE|WTCKT01|SL112C|SL219C|SN304AE|SN509C)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:CKT_)?U102AC",
                "device": "feature phone",
                "model": "Debut Flip"
            },
            {
                "regex": "(?:CKT_)?U1030AC",
                "device": "feature phone",
                "model": "Debut Flex"
            },
            {
                "regex": "SL101AE",
                "model": "Debut Smart"
            },
            {
                "regex": "U572AC",
                "model": "Debut S3"
            },
            {
                "regex": "U6080AC",
                "model": "Magic 5G"
            },
            {
                "regex": "U655AC",
                "model": "Magic 2 5G"
            },
            {
                "regex": "U380AC",
                "model": "Debut S2"
            },
            {
                "regex": "U680AC",
                "model": "Outlast"
            },
            {
                "regex": "SN509C",
                "model": "Outlast 5G"
            },
            {
                "regex": "EC211001",
                "model": "Dream 5G"
            },
            {
                "regex": "U304AC",
                "model": "Icon"
            },
            {
                "regex": "U325AC",
                "model": "Icon 2"
            },
            {
                "regex": "EC211002",
                "model": "Icon 3"
            },
            {
                "regex": "WTCKT01",
                "model": "Icon 4"
            },
            {
                "regex": "SL112C",
                "model": "Icon 5"
            },
            {
                "regex": "SL219C",
                "model": "Icon 6"
            },
            {
                "regex": "V350C",
                "model": "Influence"
            },
            {
                "regex": "EC211004",
                "model": "Innovate 5G"
            },
            {
                "regex": "SN304AE",
                "model": "Innovate E 5G"
            },
            {
                "regex": "U705AC",
                "model": "Ovation"
            },
            {
                "regex": "EC1002",
                "model": "Ovation 2"
            },
            {
                "regex": "U668AC",
                "model": "Ovation 3"
            },
            {
                "regex": "EC211003",
                "model": "Splendor"
            },
            {
                "regex": "SL100EA",
                "model": "Vision Plus"
            },
            {
                "regex": "Cricket-([a-z0-9]+)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Crius Mea": {
        "regex": "(Q7A\\+?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Crosscall": {
        "regex": "Crosscall|ODYSSEY_Plus|Action-X[35]|Core-(?:M[45]|T[45]|X[345]|Z5)|Stellar-X5|Trekker-[MSX][1-4]|Odyssey S1",
        "device": "smartphone",
        "models": [
            {
                "regex": "Action-X3 Pro(?:[);/ ]|$)",
                "model": "Action-X3 Pro"
            },
            {
                "regex": "Action-X([35])(?:[);/ ]|$)",
                "model": "Action-X$1"
            },
            {
                "regex": "Crosscall_Core-S4_4G(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "Core-S4"
            },
            {
                "regex": "Core-(M4) GO(?:[);/ ]|$)",
                "model": "Core-$1 Go"
            },
            {
                "regex": "Core-(M[45]|X[345]|Z5)(?:[);/ ]|$)",
                "model": "Core-$1"
            },
            {
                "regex": "Crosscall ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "ODYSSEY_Plus",
                "model": "ODYSSEY+"
            },
            {
                "regex": "Odyssey S1",
                "model": "ODYSSEY S1"
            },
            {
                "regex": "Trekker-([MSX][1-4]) Core",
                "model": "Trekker-$1 Core"
            },
            {
                "regex": "Trekker-([MSX][1-4](?: Core)?)",
                "model": "Trekker-$1"
            },
            {
                "regex": "Stellar-(X5)(?:[);/ ]|$)",
                "model": "Stellar-$1"
            },
            {
                "regex": "Core-T([45])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Core-T$1"
            }
        ]
    },
    "Walker": {
        "regex": "WALKER[;,]",
        "device": "tv",
        "model": ""
    },
    "Crown": {
        "regex": "CROWN, ([a-z0-9_ -]+), (?:wired|wireless)|BlossomB902(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CROWN, ([a-z0-9_ -]+), (?:wired|wireless)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "BlossomB902",
                "model": "Blossom B902"
            }
        ]
    },
    "AllDocube": {
        "regex": "(?:T1001XS?|T1006S?|T1001|T811|iPlay[_ ][2345]0|U1006H?|U1005E|U63PLUS|iPlay8|iPlay_?[89]T|iPlay[134]0|iPlay_40H|iPlay50_mini_Pro|iPlay50 (?:Pro|Mini)|iPlay_?[25]0[SP]|iPlay50(?:Pro|_Lite)?|iPlay60(?:[_ ]mini)?[_ ](?:Pro|Turbo)|kPad|X_Game|T806MHE?|Power M3|Smile_X|iPlay_60_Lite|iPlay_60|T1201)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Smile_X(?:[);/ ]|$)",
                "model": "Smile X"
            },
            {
                "regex": "T811(?:[);/ ]|$)",
                "model": "Kidz Pad Pro"
            },
            {
                "regex": "T1001XS(?:[);/ ]|$)",
                "model": "M5XS"
            },
            {
                "regex": "kPad(?:[);/ ]|$)",
                "model": "kPad"
            },
            {
                "regex": "T1006S(?:[);/ ]|$)",
                "model": "M5S"
            },
            {
                "regex": "T1006(?:[);/ ]|$)",
                "model": "M5"
            },
            {
                "regex": "T1001X(?:[);/ ]|$)",
                "model": "M5X"
            },
            {
                "regex": "T1001(?:[);/ ]|$)",
                "model": "Power M3"
            },
            {
                "regex": "U63PLUS(?:[);/ ]|$)",
                "model": "U63 Plus"
            },
            {
                "regex": "U1006H?(?:[);/ ]|$)",
                "model": "iPlay 10 Pro 10.1\""
            },
            {
                "regex": "U1005E(?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "T806MHE?",
                "model": "iPlay 8 Pro"
            },
            {
                "regex": "T1201",
                "model": "iPlay 60 Pro"
            },
            {
                "regex": "iPlay60 mini Turbo",
                "model": "iPlay 60 Mini Turbo"
            },
            {
                "regex": "iPlay_?([56]0)_Lite",
                "model": "iPlay $1 Lite"
            },
            {
                "regex": "iPlay[_ ]?([56]0)[_ ]mini[_ ]Pro",
                "model": "iPlay $1 Mini Pro"
            },
            {
                "regex": "iPlay ?([56]0)[ _]?Pro",
                "model": "iPlay $1 Pro"
            },
            {
                "regex": "iPlay50 Mini",
                "model": "iPlay 50 Mini"
            },
            {
                "regex": "iPlay[_ ]?([1-6]0|[89]T?|40H|[25]0[sP])(?:[);/ ]|$)",
                "model": "iPlay $1"
            },
            {
                "regex": "X_Game(?:[);/ ]|$)",
                "model": "X Game"
            },
            {
                "regex": "Power M3(?:[);/ ]|$)",
                "model": "Power M3"
            }
        ]
    },
    "allente": {
        "regex": "Allente 1(?:[);/ ]|$)",
        "device": "tv",
        "model": "Allente 1"
    },
    "Xsmart": {
        "regex": "(?:Xsmart (?:Nova 7|Mate 10)|CORE_X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CORE_X",
                "model": "Core X"
            },
            {
                "regex": "Xsmart (Nova 7|Mate 10)",
                "model": "$1"
            }
        ]
    },
    "MyTab": {
        "regex": "(?:MyTAB[ _-](?:8 MINI Dual Core|U55GT)|U103GT1)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MyTAB[ _-]8 MINI Dual Core(?:[);/ ]|$)",
                "model": "8 Mini Dual Core"
            },
            {
                "regex": "MyTAB-U55GT(?:[);/ ]|$)",
                "model": "U55GT"
            },
            {
                "regex": "U103GT1(?:[);/ ]|$)",
                "model": "Volta"
            }
        ]
    },
    "Cube": {
        "regex": "(<!myPhone ?)Cube|(U[0-9]+GT|K8GT)|(?:T8-PLUSM?S?|T8PLUSML|I1-TF[BD]?|I1-TC|i15-T[CG]?|I1_3GD|i1002S|Iwork10 Flagship|iwork10 Pro|T10 PLUS|CUBE-T970|U55GT_C8)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "U27GT-C8X?",
                "model": "Talk 8X"
            },
            {
                "regex": "U25GT-C4YT|U25GT-W4",
                "model": "U25GT"
            },
            {
                "regex": "U30GT ?2(?:[);/ ]|$)",
                "model": "U30GT2"
            },
            {
                "regex": "U27GT",
                "model": "Talk 8"
            },
            {
                "regex": "U55GT_C8",
                "model": "Talk 79"
            },
            {
                "regex": "U51GT-SL|U51GT-C8",
                "model": "Talk 7X"
            },
            {
                "regex": "U31GT",
                "model": "Talk 10"
            },
            {
                "regex": "(?:T8-PLUSM?S?|T8PLUSML)(?:[);/ ]|$)",
                "model": "T8 Ultimate"
            },
            {
                "regex": "U55GT",
                "model": "Talk 79"
            },
            {
                "regex": "T10 PLUS",
                "model": "T10 Plus"
            },
            {
                "regex": "U65GT",
                "model": "Talk 9X"
            },
            {
                "regex": "I1-TF[BD]?(?:[);/ ]|$)",
                "model": "iWork 8 Air"
            },
            {
                "regex": "I1_3GD(?:[);/ ]|$)",
                "model": "iWork 8 3G"
            },
            {
                "regex": "I1-TC(?:[);/ ]|$)",
                "model": "iWork 8 Ultimate"
            },
            {
                "regex": "i15-TG(?:[);/ ]|$)",
                "model": "iWork 10 Ultimate"
            },
            {
                "regex": "i15-T(?:[);/ ]|$)",
                "model": "iWork 10"
            },
            {
                "regex": "(?:i1002S|iwork10 Pro)(?:[);/ ]|$)",
                "model": "iWork 10 Pro"
            },
            {
                "regex": "Iwork10 Flagship|i15-TC(?:[);/ ]|$)",
                "model": "iWork 10 Flagship"
            },
            {
                "regex": "CUBE-T970(?:[);/ ]|$)",
                "model": "T970 4G"
            },
            {
                "regex": "(U[0-9]+GT[^;/]*) Build",
                "model": "$1"
            },
            {
                "regex": "(U[0-9]+GT(?:[0-9]|[\\-_][a-z]+)?)",
                "model": "$1"
            },
            {
                "regex": "(K8GT)",
                "model": "$1"
            }
        ]
    },
    "Meta": {
        "regex": "(?:Pacific|(?<!like )Quest).+OculusBrowser|(?:Standalone HMD|PortalGo|Quest 3S?)(?:[);/ ]|$)",
        "device": "wearable",
        "models": [
            {
                "regex": "Pacific",
                "model": "Go"
            },
            {
                "regex": "PortalGo",
                "model": "Portal Go",
                "device": "smart display"
            },
            {
                "regex": "Quest 3S",
                "model": "Quest 3S"
            },
            {
                "regex": "Quest 3",
                "model": "Quest 3"
            },
            {
                "regex": "(?:Quest 2|Standalone HMD)",
                "model": "Quest 2"
            },
            {
                "regex": "Quest Pro",
                "model": "Quest Pro"
            },
            {
                "regex": "Quest",
                "model": "Quest"
            }
        ]
    },
    "CUBOT": {
        "regex": "CUBOT|(?<!QUMO |like )QUEST(?!(?:[0-9]|\\s[0-9]))(?: LITE)?|(?:(?<!(?:Redmi|Tegra) )NOTE 7|(?<!Galaxy )NOTE 20(?: PRO)?|RAINBOW 2|KING_KONG_3|ZORRO 001|KINGKONG[_ ](?:MINI2?|POWER|STAR|[5-9]|5 Pro|AX|X|ACE [23]|ES|11)|TAB KINGKONG|KING KONG CS| X30P|R15_PRO|S550 Pro|Android [6-7](?:[\\d.]*);(?: [\\w-]+;)? CHEETAH| [RX]19|X19 S|(?<!MI )MAX [35]|Android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:J5|MAX 2|X20 PRO)|Android [89](?:[\\d.]*);(?: [\\w-]+;)? R15(?! Dream Mirror| Neo)|Android 12(?:[\\d.]*);(?: [\\w-]+;)? (?:P60|NOTE 30)|Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:NOTE [345]0|NOTE 2[134]|P80)|Android 11(?:[\\d.]*);(?: [\\w-]+;)? (?:Pocket|NOTE 9|P50|J10)|POCKET 3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TAB KINGKONG 2",
                "device": "tablet",
                "model": "Tab King Kong 2"
            },
            {
                "regex": "TAB KINGKONG",
                "device": "tablet",
                "model": "Tab King Kong"
            },
            {
                "regex": "POCKET (3)",
                "model": "Pocket $1"
            },
            {
                "regex": "Pocket",
                "model": "Pocket"
            },
            {
                "regex": "CHEETAH( 2)?",
                "model": "Cheetah$1"
            },
            {
                "regex": "RAINBOW 2",
                "model": "Rainbow 2"
            },
            {
                "regex": "RAINBOW",
                "model": "Rainbow"
            },
            {
                "regex": "DINOSAUR",
                "model": "Dinosaur"
            },
            {
                "regex": "KINGKONG X PRO",
                "model": "King Kong X Pro"
            },
            {
                "regex": "KINGKONG POWER ([235])",
                "model": "King Kong Power $1"
            },
            {
                "regex": "KINGKONG[ _]POWER",
                "model": "King Kong Power"
            },
            {
                "regex": "KINGKONG[ _]AX",
                "model": "King Kong AX"
            },
            {
                "regex": "KINGKONG ACE ([23])",
                "model": "King Kong Ace $1"
            },
            {
                "regex": "KINGKONG[ _]STAR[ _]2",
                "model": "King Kong Star 2"
            },
            {
                "regex": "KINGKONG[ _]STAR",
                "model": "King Kong Star"
            },
            {
                "regex": "KINGKONG MINI2 Pro",
                "model": "King Kong Mini 2 Pro"
            },
            {
                "regex": "KINGKONG MINI ?([23])",
                "model": "King Kong Mini $1"
            },
            {
                "regex": "KINGKONG_MINI",
                "model": "King Kong Mini"
            },
            {
                "regex": "KINGKONG 5 Pro",
                "model": "King Kong 5 Pro"
            },
            {
                "regex": "KING[_ ]?KONG[_ ](11|[35-9]|X|ES)",
                "model": "King Kong $1"
            },
            {
                "regex": "KING KONG CS",
                "model": "King Kong CS"
            },
            {
                "regex": "KING KONG",
                "model": "King Kong"
            },
            {
                "regex": "QUEST LITE",
                "model": "Quest Lite"
            },
            {
                "regex": "QUEST",
                "model": "Quest"
            },
            {
                "regex": "X20 PRO",
                "model": "X20 Pro"
            },
            {
                "regex": "ZORRO 001",
                "model": "Zorro 001"
            },
            {
                "regex": "CUBOT[ _]Echo",
                "model": "Echo"
            },
            {
                "regex": "CUBOT[ _]MANITO",
                "model": "Manito"
            },
            {
                "regex": "CUBOT[ _]MAGIC",
                "model": "Magic"
            },
            {
                "regex": "MAX ([235])",
                "model": "Max $1"
            },
            {
                "regex": "CUBOT[ _]MAX",
                "model": "Max"
            },
            {
                "regex": "NOTE Plus",
                "model": "Note Plus"
            },
            {
                "regex": "NOTE 20 PRO",
                "model": "Note 20 Pro"
            },
            {
                "regex": "(R15|S550|J3)[_ ]PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "NOTE ([2-5]0|2[134]|[79])",
                "model": "Note $1"
            },
            {
                "regex": "CUBOT[_ ]NOTE[_ ]S",
                "model": "Note S"
            },
            {
                "regex": "CUBOT_NOVA",
                "model": "Nova"
            },
            {
                "regex": "CUBOT_POWER",
                "model": "Power"
            },
            {
                "regex": "CUBOT_X18_Plus",
                "model": "X18 Plus"
            },
            {
                "regex": "CUBOT[_ ]Hafury V1",
                "model": "Hafury V1"
            },
            {
                "regex": "CUBOT[ _](A5|C6W|H3|J3|P7|P20|[RXJ]9|R11|X18|X[35]0)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(X19 S|[RX]19|R15|J5|P[568]0|J10|X30P)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CUBOT ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "([^;/]+) Build/CUBOT",
                "model": "$1"
            }
        ]
    },
    "Clout": {
        "regex": "Hind[ _]5\\.1|X417[ _]Amaze|X418[ _]Zest|X421[ _]Nova|X422[ ]Exotic|X425[ _]Shavit|X428[ _]Astute",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hind[ _]5\\.1",
                "model": "Hind 5.1"
            },
            {
                "regex": "X417[ _]Amaze",
                "model": "X417 Amaze"
            },
            {
                "regex": "X418[ _]Zest",
                "model": "X418 Zest"
            },
            {
                "regex": "X421[ _]Nova",
                "model": "X421 Nova"
            },
            {
                "regex": "X422[ _]Exotic",
                "model": "X422 Exotic"
            },
            {
                "regex": "X425[ _]Shavit",
                "model": "X425 Shavit"
            },
            {
                "regex": "X428[ _]Astute",
                "model": "X428 Astute"
            }
        ]
    },
    "Concord": {
        "regex": "Concord[ _-]|(?:Flyfix 6|C-721|Plus-7_C777|Plus_M19_C779|Plus-9_C778|Dream_Edition_C-754)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Concord[ _-](M[12]0)",
                "model": "$1"
            },
            {
                "regex": "Flyfix 6",
                "model": "Flyfix 6"
            },
            {
                "regex": "C-721",
                "model": "Flyfix Q",
                "device": "tablet"
            },
            {
                "regex": "Plus[-_]([79]|M19)_(C77[789])(?:[);/ ]|$)",
                "model": "Plus-$1 $2",
                "device": "tablet"
            },
            {
                "regex": "Dream_Edition_C-754",
                "model": "Dream Edition C-754",
                "device": "tablet"
            },
            {
                "regex": "Concord_RANGE_HS",
                "model": "Range HS",
                "device": "tablet"
            }
        ]
    },
    "Crescent": {
        "regex": "WING 5|WING9|Venus[ _][14]",
        "device": "smartphone",
        "models": [
            {
                "regex": "WING 5",
                "model": "Wing 5"
            },
            {
                "regex": "WING9",
                "model": "Wing 9"
            },
            {
                "regex": "Venus[ _]([14])",
                "model": "Venus $1"
            }
        ]
    },
    "Crestron": {
        "regex": "Crestron",
        "device": "smart display",
        "model": ""
    },
    "Cwowdefu": {
        "regex": "(?:C70W|F35W_EEA|C82W_EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(C70W|F35W|C82W)(?:_EEA)?(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "CX": {
        "regex": "CX9006(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CX9006",
                "model": "CX9006",
                "device": "tablet"
            }
        ]
    },
    "Cyrus": {
        "regex": "Cyrus[ _-]|CyrusApel|CM17XA|CS(?:22|45)XA(?:_EEA)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CM17XA(?:_EEA)?(?:[);/ ]|$)",
                "model": "CM17XA"
            },
            {
                "regex": "CS(22|45)XA(?:_EEA)?",
                "model": "CS$1 XA"
            },
            {
                "regex": "Cyrus[ _-]?([^;/)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Cyrus[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Datang": {
        "regex": "DATANG",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:DATANG[ _-])+([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:DATANG[ _-])+([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Datsun": {
        "regex": "DATSUN",
        "device": "smartphone",
        "models": [
            {
                "regex": "DATSUN_D5500",
                "model": "D5500"
            },
            {
                "regex": "Datsun_D5001",
                "model": "D5001"
            }
        ]
    },
    "Danew": {
        "regex": "Dslide|Konnect_?(?:402|50[246]|556|60[1278])|GEODROID_A5|Dbook[_ ]110",
        "device": "smartphone",
        "models": [
            {
                "regex": "Konnect[_ ]?(402|50[246]|556|60[1278])",
                "model": "Konnect $1"
            },
            {
                "regex": "GEODROID_A5",
                "device": "tablet",
                "model": "Geodroid A5"
            },
            {
                "regex": "Dbook[_ ](110)",
                "model": "DBook $1",
                "device": "tablet"
            },
            {
                "regex": "Dslide[ _]?([^;/)]+)(?: Build|[);])",
                "device": "tablet",
                "model": "DSlide $1"
            }
        ]
    },
    "Dazen": {
        "regex": "dazen",
        "device": "smartphone",
        "models": [
            {
                "regex": "6A",
                "model": "6A"
            }
        ]
    },
    "Denver": {
        "regex": "(?:TAQ_10[4G]|TA[CDQ]-[0-9]+)|P(?:.+)TAQ-(?:[0-9]+)|SDQ[_-](?:550[24]4L|52001G|50002G|57004L)",
        "device": "tablet",
        "models": [
            {
                "regex": "TAQ_(10[4G])",
                "model": "TAQ-$1"
            },
            {
                "regex": "P(?:.+)TAQ-(10213GMK2|10172MK3|10242MK2|70242MK2|[0-9]+)(?:[);/ ]|$)",
                "model": "TAQ-$1"
            },
            {
                "regex": "(TA[CDQ]-[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SDQ[_-](550[24]4L|52001G|50002G|57004L)",
                "device": "smartphone",
                "model": "SDQ-$1"
            }
        ]
    },
    "Dell": {
        "regex": "Dell[^a-z]|Venue|XCD35|Latitude E?\\d{4}|Inspiron N?\\d{4}|Inspiron 13|Vostro (?:3546|14-3468)",
        "device": "smartphone",
        "models": [
            {
                "regex": "XCD35",
                "model": "XCD35"
            },
            {
                "regex": "Venue ((?:10|[78]) [0-9]{4}|[78] HSPA\\+)",
                "model": "Venue $1",
                "device": "tablet"
            },
            {
                "regex": "(?:Dell )?Venue(?: Build|[);])",
                "model": "Venue"
            },
            {
                "regex": "Dell; Venue Pro",
                "model": "Venue Pro"
            },
            {
                "regex": "(OptiPlex (?:3050|7010))",
                "device": "desktop",
                "model": "$1"
            },
            {
                "regex": "Vostro (3546|14-3468)",
                "device": "desktop",
                "model": "Vostro $1"
            },
            {
                "regex": "Chromebook (\\d{2} \\(\\d{4}\\))",
                "device": "desktop",
                "model": "Chromebook $1"
            },
            {
                "regex": "Venue7 (3740)",
                "model": "Venue 7 $1",
                "device": "tablet"
            },
            {
                "regex": "(?:Dell )?(Streak|Venue) ?([^/;]*) Build",
                "model": "$1 $2",
                "device": "tablet"
            },
            {
                "regex": "(?:Dell Inc\\./)?(XPS 13 9360|Latitude (?:7480|7390|E4310)|Inspiron N?\\d{4}|Inspiron 13-\\d{4})(?:[);/ ]|$)",
                "device": "desktop",
                "model": "$1"
            },
            {
                "regex": "Dell; ((?:Streak|Venue)[^;/\\)]*)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Dell; ([^;/\\)]+)",
                "model": "$1"
            },
            {
                "regex": "Dell[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Desay": {
        "regex": "Desay",
        "device": "smartphone",
        "models": [
            {
                "regex": "Desay[ _-]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Desay[ _-]?([^;/)]+)",
                "model": "$1"
            }
        ]
    },
    "DEXP": {
        "regex": "DEXP|(?:Ursus|Ixion)[ _]([^;/)]+)|H135[ _]Build|Larus_TV1|Ixion(?:ML4\\.7|ES250)|M150Storm|(?:SENIOR|F4[38]D8000K|VA(?:[12]10|170)|ML450|MS[56]50|BL(?:[123]50|160|155)|BS(?:155|160|[1256]50)|(?<!ILIUM )S(?:3[78]0|2[89]0|670)|AL(?:[12]40|[23]50)|AS(?:155|[123]60)| (?:B260|B245|H[12]10|H270|L470|N280i|P310|P380i?|R1[18]0|Q110|E1[78]0|E[12]10|B(?:450|340|35[05])|M170|M445|M[12]10|T155|H32F8000CG?|U43F8000Q|A(?:1[456]0|340|[34]55)|GS15[035]|GL[23]55|G25[035]|G355|G550|G15[05]|ES750|XL150|Z[1-4]55|H[13]70|H[34]10|P[45]10|L2[17]0)|Z250|A440|(?<!MITO )A350(?! TV)|N[13]80i|(?<!Blade )L1[178]0|L3[17]0i|(?<!VOX )G450|G660|Q[123]10|Q[12]80|N[234]10|N[35]70|EX111|S[245]70|S[127]70i|S169|S110|S180i?|S770|A555(?! Universe)|(?:U75H8000K|U50H8000E|U65H8000K|F43H8000QG|U50G8000QG|U55H8050E|U43G9000CG|U43F8100QG|U55G8000QG|U50G9000CG|H32H800(?:1C|0[KQ])|H32G8000(?:CG|KW|Q)|H32F8000QG?(?:-[abc])?|H32F8[01]00Q|H39F8000Q|F43H8000K|U43H8000E|F(?:32|43)H8050C|U43F8000EG|F43F8000[CQ]G?|F32[FG]8000C|F43G8000C|H24H8000C|H24F8000Q|F43F8000Q-G)(?:-[AbcfedH])?|Android 8(?:[\\d.]*);(?: [\\w-]+;)? A240|android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:B[23]1|B38|B1[87]|K28|K[34]1)|android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:K18|K21|B11)|Android 11(?:[\\d.]*);(?: [\\w-]+;)? (?:D[12]1|T21|K[345]1|K[342]8|K61|C3[78]|B28|B27|H28)|43UCY[123](?:-[GB])?|32FCY[12]|U43H8050EG|H32H8051C-G|H32H8050CG|65UCY(?:1-[GB]|3)|55UCY1-[BG]|50UCY[12]-G|75UCY1-G|40FCY1|43FCY[12]|24HEY1|55UCY1|U5[05]E9100Q|H24F8000C|H3218000K|U5[05]F8000QG?|U50H8050EG|H32I8000K|U65G8000Q|U43G8100QG|U50F8000EG?|F40H8000E|Android 11(?:[\\d.]*);(?: [\\w-]+;)? P11)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:DEXP_)?(ML450|MS[56]50|ES750|XL150|ES1050)(?:[);/ ]|$)",
                "model": "Ixion $1"
            },
            {
                "regex": "IxionES250(?:[);/ ]|$)",
                "model": "Ixion ES250 Rage"
            },
            {
                "regex": "IxionML4\\.7(?:[);/ ]|$)",
                "model": "Ixion ML 4.7\""
            },
            {
                "regex": "Ixion ES2 5",
                "model": "Ixion ES2 5\""
            },
            {
                "regex": "Ixion[_ ]([^;/]+)(?: Build|\\))",
                "model": "Ixion $1"
            },
            {
                "regex": "M150Storm(?:[);/ ]|$)",
                "model": "Ixion M150 Storm"
            },
            {
                "regex": "M445(?:[);/ ]|$)",
                "model": "Ixion M445 Onyx 2"
            },
            {
                "regex": "AL250(?:[);/ ]|$)",
                "model": "4.5\" AL250"
            },
            {
                "regex": "AL350(?:[);/ ]|$)",
                "model": "5.0\" AL350"
            },
            {
                "regex": "AS155(?:[);/ ]|$)",
                "model": "5.45\" AS155"
            },
            {
                "regex": "AS260(?:[);/ ]|$)",
                "model": "5.85\" AS260",
                "device": "phablet"
            },
            {
                "regex": "AS360(?:[);/ ]|$)",
                "model": "6.22\" AS360",
                "device": "phablet"
            },
            {
                "regex": "Ursus 9EV mini 3G",
                "model": "Ursus 9EV Mini 3G",
                "device": "tablet"
            },
            {
                "regex": "Ursus[ _]([^;/)]+)(?: Build|[);])",
                "model": "Ursus $1",
                "device": "tablet"
            },
            {
                "regex": "(K[23456]1|K[234]8|[KB]18|B[23]1|B[12]7|B[23]8|[BD]11|D21|T21|C3[78]|P11)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(VA[21]10|VA170|E210|R1[18]0|Q110|M[12]10|N280i|P380i?|P[345]10|S2[89]0|S3[78]0|S[456]70|H[12]10|H[123]70|H[34]10|L1[178]0|L2[17]0|N[13]80i|N[234]10|E1[178]0|Q[123]10|Q[12]80|EX111|N[35]70|L3[17]0i|L470|S[127]70i|S270|S110|S169|S770|S180i?|M170)(?:[);/ ]|$)",
                "model": "Ursus $1",
                "device": "tablet"
            },
            {
                "regex": "(H28)(?:[);/ ]|$)",
                "model": "Ursus $1",
                "device": "tablet"
            },
            {
                "regex": "(G450)[ _](2021)",
                "model": "$1 ($2)"
            },
            {
                "regex": "(B260|B245|A440|A[345]55|B450|B340|B35[05]|BL155|BL160|A160|A[23]40|A350|T155|Z[1-4]55|G25[035]|G355|Z250|G450|G550|G660)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SENIOR(?:[);/ ]|$)",
                "model": "Senior"
            },
            {
                "regex": "Larus_TV1",
                "device": "feature phone",
                "model": "Larus_TV1"
            },
            {
                "regex": "DEXP[_ ]Freya",
                "device": "console",
                "model": "Freya"
            },
            {
                "regex": "([HFU]\\d{2}[A-Z]\\d{4}[A-Z]{1,2}|AL-2020|43UCY[12]-[GB]|43UCY[13]|43FCY[12]|40FCY1|24HEY1|32FCY[12]|F32H8050C|H32F8000Q|H32[1I]8000K|H32H8051C-G|F43F8000Q-G|50UCY[12]-G|75UCY1-G|55UCY1-[BG]|65UCY(?:1-[GB]|3)|55UCY1)(?:-[AbcfedH])?(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "H135[ _]Build",
                "model": "Atlas",
                "device": "desktop"
            },
            {
                "regex": "(BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|A1[45]0|GS15[035]|AS160|GL[23]55|G15[05])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "DEXP[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "DEXP[ _]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "DbPhone": {
        "regex": "DB8PLUS",
        "device": "smartphone",
        "model": "DB8 Plus"
    },
    "Dbtel": {
        "regex": "DBTEL(?:[\\-/])?([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "DGTEC": {
        "regex": "(?:DG101HSTB|DG101TBIPS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(DG101HSTB|DG101TBIPS)(?:[);/ ]|$)",
                "model": "DG101TBIPS",
                "device": "tablet"
            }
        ]
    },
    "Dialog": {
        "regex": "Dialog ?([^;/]+)(?: Build|[;)])|(?:M50E-1A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(M50E-1A)",
                "model": "$1"
            },
            {
                "regex": "Dialog ?([^;/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Dicam": {
        "regex": "DICAM-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Digi": {
        "regex": "(?<!FBCR/)Digi[ _]([^);/]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Digicel": {
        "regex": "DIGICEL|(?:DL3(?:PlusPro)?|DL501)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DL3PlusPro",
                "model": "DL3 Plus Pro"
            },
            {
                "regex": "DL3(?:[);/ ]|$)",
                "model": "DL3"
            },
            {
                "regex": "DL(755|501)",
                "model": "DL$1"
            },
            {
                "regex": "DL810",
                "model": "DL810"
            },
            {
                "regex": "DIGICELDL1plus",
                "model": "DL1 Plus"
            },
            {
                "regex": "DIGICEL[ _]([^/);]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Digidragon": {
        "regex": "(?:DS502|DS6018|DS6261)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(DS502|DS6018|DS6261)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Digihome": {
        "regex": "DIGIHOME, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Digiland": {
        "regex": "(?:DL721-RB|DL(?:1016|1023|1025GH|1036|900[23]|[78]006|1008M|718M|703QR|702Q|5[05]03QL|1022QR|1010Q)|Compumax Blue)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(DL5[05]03QL)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "DL1008M",
                "model": "DL1008M"
            },
            {
                "regex": "DL(1010Q|1016|1025GH|1022QR|1023|1036|900[23]|[78]006|721-RB|718M|70[23]QR?)",
                "model": "DL$1"
            },
            {
                "regex": "(Compumax Blue)",
                "model": "$1"
            }
        ]
    },
    "Digit4G": {
        "regex": "Digit_|Digit4G|Digit(?:4G|play1|next_Ultra)|DIGIT (?:INFINITY|Glory1)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Digitplay1(?:[);/ ]|$)",
                "model": "Play1"
            },
            {
                "regex": "Digitnext_Ultra(?:[);/ ]|$)",
                "model": "Next Ultra"
            },
            {
                "regex": "Glory1(?:[);/ ]|$)",
                "model": "Glory1"
            },
            {
                "regex": "INFINITY MAX(?:[);/ ]|$)",
                "model": "Infinity Max"
            },
            {
                "regex": "INFINITY(?:[);/ ]|$)",
                "model": "Infinity"
            },
            {
                "regex": "Energy Max(?:[);/ ]|$)",
                "model": "Energy Max"
            },
            {
                "regex": "Digit_Digit4G[_-](Bold|Defender|Elite|Music|Power|Shine|Star)_4G(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Digit_Digit4GLite_4G(?:[);/ ]|$)",
                "model": "Lite"
            },
            {
                "regex": "Digit_Digit4GPowerMAX_4G(?:[);/ ]|$)",
                "model": "Power Max"
            },
            {
                "regex": "Digit4G[ _]E([234])[ _]pro(?:[);/ ]|$)",
                "model": "E$1 Pro"
            },
            {
                "regex": "Digit4G[ -](Energy|Pro)",
                "model": "$1"
            }
        ]
    },
    "COMPUMAX": {
        "regex": "BlueS10(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "BlueS10",
                "model": "Blue S10"
            }
        ]
    },
    "Digma": {
        "regex": "Digma[_ ]([^;/)]+)(?: Build|[;)])|iD[sr]Q\\d+|DiMagic|HIT HT707[10]MG|CITI (?:7 E401 4G|8 E400 4G|ATL 4G|Kids|Octa [178]0|1902 3G|10 E402|Z530 3G|13 X703 4G)|(CITI[_ ](?:[A-Z0-9]+)[_ ][34]G)[ _][TC][ST](?:[0-9]{4}[PM][LG])|HIT 4G|HT7074ML|IDX5|(iDx10|iDx7)|MVM900H(?:WZ|C)|MVM908HCZ|(iDxD8 3G|iDxD10 3G|iDrQ10 3G|iDxD[45]|iDxQ5|iD[nx]D7(?:[_ ]3G)?)|PS604M|PT452E|Linx.+ [34]G L[TS][0-9]{4}[PM][GL]|Linx PS474S|PS1043MG|HT7071MG|HT5035PG|HT4039PG|NS6902QL|NS9797MG|TS7854M|TS1012E 3G|TT1004PG|TT702[045]MG|TT1002MG|TT7026MW|WS825[123]PL|VRL42|((?:Optima(?![_ ]T-II)(?: Kids 7)?|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.ST]+|Prime)(?:[ _][43]G)?)|(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)|DM-LED(?:5[05]UBB3[13]|32SBB33|43UBB3[13]|32SR21|4[03]SBB33|(?:32|40)SBB3[125]|43SR2[23]|42SR24|24SR20|55UR31|43SBB31|24SBB31|65UBB33)|RS1248PL|RS1253PL|RS1249PL|RS1267PL|WS125[01]PL|WS1262RW|HS1002PL|TS1292PL|HS100[134]PL|TS8289PL|Kids_8280C_WS8252PL|HS101[012]PL|DA6B8P01|TA3E0P01|TA2D0P01|TA1C8M01|TA2D0P02|TA3E[02]M01|TA2D0M01|TA3E1M01|TA3D1M01|TA3E1P02|TA2D1M01|TA2D1P01|TA3D(?:1P01|0P0[12]|0M01)|TA3E1P01|TA3E0P02|TA2D5P01|DA1C0P01|MS100[1-3]PL|TAXX5P0X",
        "device": "smartphone",
        "models": [
            {
                "regex": "HIT(?: 3G)? HT707[10]MG",
                "model": "HIT 3G",
                "device": "tablet"
            },
            {
                "regex": "DA6B8P01",
                "model": "Q8 DA6B8P01",
                "device": "tablet"
            },
            {
                "regex": "K10 (DA1C0P01)",
                "model": "K10 $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3E0M01|TA2D0M01|TA3D0M01)",
                "model": "Pro Infinity $1",
                "device": "tablet"
            },
            {
                "regex": "(TAXX5P0X|TA2D5P02)",
                "model": "Pro Wave $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3E1P02)",
                "model": "Pro Eclipse $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3E2M01)",
                "model": "Pro Empire $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3D0P01|TA3E0P01|TA2D0P01)",
                "model": "Pro Pulse $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3[DE]1M01|TA2D1M01)",
                "model": "Pro Edge $1",
                "device": "tablet"
            },
            {
                "regex": "(TA1C8M01)",
                "model": "Pro Spark $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3D0P02|TA3E0P02)",
                "model": "Pro Zoom $1",
                "device": "tablet"
            },
            {
                "regex": "(TA2D5P01)",
                "model": "Pro Quantum $1",
                "device": "tablet"
            },
            {
                "regex": "(TA3E1P01|TA3D1P01|TA2D1P01)",
                "model": "Pro Zenith $1",
                "device": "tablet"
            },
            {
                "regex": "(TA2D0P02)",
                "model": "Pro Spectrum $1",
                "device": "tablet"
            },
            {
                "regex": "iDx5",
                "model": "iDx5"
            },
            {
                "regex": "HT5035PG",
                "model": "HIT Q500 3G"
            },
            {
                "regex": "HT4039PG",
                "model": "HIT Q401 3G"
            },
            {
                "regex": "VS5037PL",
                "model": "VOX Fire 4G"
            },
            {
                "regex": "(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)",
                "model": "$1"
            },
            {
                "regex": "PS604M",
                "model": "Linx 6.0"
            },
            {
                "regex": "LT4049PG",
                "model": "Linx Atom 3G"
            },
            {
                "regex": "LT5048MG",
                "model": "Linx Joy 3G"
            },
            {
                "regex": "LT5052ML",
                "model": "Linx Base 4G"
            },
            {
                "regex": "LT4047MG",
                "model": "Linx Alfa 3G"
            },
            {
                "regex": "LS4050MG",
                "model": "Linx X1 3G"
            },
            {
                "regex": "LS4051MG",
                "model": "Linx X1 Pro 3G"
            },
            {
                "regex": "LT4054MG",
                "model": "Linx Argo 3G"
            },
            {
                "regex": "LS5041PL",
                "model": "Linx Trix 4G"
            },
            {
                "regex": "LS5040PL",
                "model": "Linx Rage 4G"
            },
            {
                "regex": "LS5053ML",
                "model": "Linx Pay 4G"
            },
            {
                "regex": "Linx ([A-Z][0-9]{3}) 3G (?:LT4028PG|LS4019PG|LT4001PG|LT5001PG|LT4038PG|LT5037MG|LT4030PG)",
                "model": "Linx $1 3G"
            },
            {
                "regex": "(Linx PS474S)",
                "model": "$1"
            },
            {
                "regex": "PT452E",
                "model": "Linx 4.5"
            },
            {
                "regex": "CITI ATL 4G CS5029ML",
                "model": "CITI ATL 4G"
            },
            {
                "regex": "(CITI Z530 3G)",
                "model": "$1"
            },
            {
                "regex": "(CITI [A-Z0-9]+ [34]G) C[ST](?:606[32]ML|4024PG|5009PL|5021ML|502[56]PL)",
                "model": "$1"
            },
            {
                "regex": "MS100[123]PL",
                "model": "Pro Prime 18 11\" 3G",
                "device": "tablet"
            },
            {
                "regex": "HIT 18 HS101[012]PL",
                "model": "Pro Hit 18 10.51\"",
                "device": "tablet"
            },
            {
                "regex": "HS1007PL",
                "model": "Pro Hit 106 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "HS1009PL",
                "model": "Pro Hit 104 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "Pro STAR 14|AS8001PL",
                "model": "Pro Star 14",
                "device": "tablet"
            },
            {
                "regex": "TS7854M",
                "model": "Plane 8.1\" 3G",
                "device": "tablet"
            },
            {
                "regex": "RS1249PL",
                "model": "Pro 1800F 4G",
                "device": "tablet"
            },
            {
                "regex": "HS1002PL",
                "model": "Pro Hit 16 10.4\"",
                "device": "tablet"
            },
            {
                "regex": "HS1008PL",
                "model": "Pro Hit 104 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "HS100[13]PL",
                "model": "Hit 16 10.4\"",
                "device": "tablet"
            },
            {
                "regex": "HS1004PL",
                "model": "Pro Hit 108E 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "HS1006PL",
                "model": "Pro Hit 14 10.4\"",
                "device": "tablet"
            },
            {
                "regex": "HS1005PL",
                "model": "Pro Hit 104 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "PS1043MG",
                "model": "Plane 10.3\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TS1012E 3G",
                "model": "Plane 10.1\" 3G",
                "device": "tablet"
            },
            {
                "regex": "MVM900H(?:WZ|C)",
                "model": "iDx8",
                "device": "tablet"
            },
            {
                "regex": "MVM908HCZ",
                "model": "iDx9",
                "device": "tablet"
            },
            {
                "regex": "(iD(?:xD10|rQ10|xD7)[_ ]3G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(iDx10|iDx7)",
                "model": "$1"
            },
            {
                "regex": "(iDxD[45]|iDxQ5)",
                "model": "$1"
            },
            {
                "regex": "HIT 4G HT7074ML",
                "model": "HIT 4G",
                "device": "tablet"
            },
            {
                "regex": "PRO (1[46]00E 4G)",
                "model": "Pro $1",
                "device": "tablet"
            },
            {
                "regex": "DIGMA[_ ]IDSD",
                "model": "IDsD 10 3G",
                "device": "tablet"
            },
            {
                "regex": "CITI[_ ](1902 3G|Kids(?:[_ ](?:8[01]|10))?|8527_4G|8269C 3G|Octa [178]0|10 E402 4G|8 E400 4G|7 E401 4G|13 X703 4G|131[23]C 4G|8443E 4G|1314C 4G|1421D 4G)",
                "model": "CITI $1",
                "device": "tablet"
            },
            {
                "regex": "WS1262RW",
                "model": "Kids 1210B",
                "device": "tablet"
            },
            {
                "regex": "WS8253PL",
                "model": "Kids 8260C",
                "device": "tablet"
            },
            {
                "regex": "(?:Kids_8280C_)?WS8252PL",
                "model": "Kids 8280C",
                "device": "tablet"
            },
            {
                "regex": "(CITI[ _](?:[A-Z0-9]+)[ _][34]G)[ _][TC][ST](?:106[24]ML|111[46]ML|1115MG|1117PG|1207MG|1210MG|3001ML|500[67]PG|7052PG|706[567]MG|7097MG|720[48]MG|820[69]MG|11[459]4MG|1195MG|1196ML|3001ML|8152ML|1050PL|709[68]PL|7113PL|7193MG|7216MG|8205PG|7203MG|8143MG|7153MG|7141MG|7140ML|8268PL)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "iDxD8 3G",
                "model": "D-Plane2 8",
                "device": "tablet"
            },
            {
                "regex": "(iDnD7)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "NS6902QL",
                "model": "Platina 7.2 4G",
                "device": "tablet"
            },
            {
                "regex": "NS9797MG",
                "model": "Platina 7.2 3G",
                "device": "tablet"
            },
            {
                "regex": "TT1004PG",
                "model": "Optima 10.4\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT1002MG",
                "model": "Optima D 10.4\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7025MG",
                "model": "Optima 7.5\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7026MW",
                "model": "Optima 7.6\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7020MG",
                "model": "Optima 7.3\" 3G",
                "device": "tablet"
            },
            {
                "regex": "TT7024MG",
                "model": "Optima 7.4\" 3G",
                "device": "tablet"
            },
            {
                "regex": "Optima ([0-9]+ [AXZE][0-9]+[SC]?) ([43])G",
                "model": "Optima $1 $2G",
                "device": "tablet"
            },
            {
                "regex": "TS8289PL",
                "model": "Optima 8305C 4G",
                "device": "tablet"
            },
            {
                "regex": "Optima ([0-9]+ A500S) 3G",
                "model": "Optima $1 3G",
                "device": "tablet"
            },
            {
                "regex": "iD([sr])Q(\\d+)[_ ]3G",
                "model": "iD$1Q$2 3G",
                "device": "tablet"
            },
            {
                "regex": "iD([sr])Q(\\d+)",
                "model": "iD$1Q$2",
                "device": "tablet"
            },
            {
                "regex": "TS7203RW",
                "model": "Optima Kids 7",
                "device": "tablet"
            },
            {
                "regex": "TT7000MG",
                "model": "Optima Prime 3G",
                "device": "tablet"
            },
            {
                "regex": "8402D 4G",
                "model": "8402D 4G",
                "device": "tablet"
            },
            {
                "regex": "1402D 4G WS1250PL",
                "model": "1402D 4G",
                "device": "tablet"
            },
            {
                "regex": "WS1251PL",
                "model": "Kids 1247C",
                "device": "tablet"
            },
            {
                "regex": "RS1267PL",
                "model": "Pro 1480E 4G",
                "device": "tablet"
            },
            {
                "regex": "((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.BSTNMEVCD]+|Prime(?:[ _][345])?)(?:[ _][43]G)?)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Digma[_ ]([^;/]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "DiMagic Cube ([^;/)]+)(?: Build|[;)])",
                "model": "DiMagic Cube $1",
                "device": "peripheral"
            },
            {
                "regex": "VRL42(?:[);/ ]|$)",
                "device": "wearable",
                "model": "VR L42"
            },
            {
                "regex": "DM-LED(\\d+(?:[SU]R|[SU]BB)\\d+)(?:[);/ ]|$)",
                "device": "tv",
                "model": "DM-LED$1"
            }
        ]
    },
    "DoCoMo": {
        "regex": "DoCoMo|\\;FOMA|KGT/1\\.0",
        "device": "feature phone",
        "models": [
            {
                "regex": "DoCoMo/.+MST.+(SH2101V)",
                "model": "$1"
            },
            {
                "regex": "DoCoMo/[12]\\.0[/ ]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "([a-z0-9]+)(?:_W)?\\;FOMA",
                "model": "$1"
            },
            {
                "regex": "KGT/1\\.0 ([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Bqeel": {
        "regex": "Y8 MAX S905X3",
        "device": "tv",
        "model": "Y8 Max"
    },
    "Doogee": {
        "regex": "DOOGEE[/ _-]|Valencia2_Y100(?:_?(?:pro|plus))?|Y100_Plus|X5max(?:[_ ]PRO)?|Shoot_[12]|x5_doogee|(KISSME|BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)|(?:BL12000|BL5500[_ ]Lite| Y6C|X9 Mini|LEO_DG280|Y9Plus|Y8 Plus|Hitman_DG850|S(?:4[01]|[568]8|9[05678]|59|61|8[69])Pro|X9[567]Pro|S[478]0Lite|S88Plus|BL[579]000|N[24]0Pro| S118|(?<!Lenovo )S90C|Ibiza_F2|S55_Lite|T5_Lite|S60 ?Lite|Iron-bone DG750|X10S|X[569]0L|MIX2|Y6 Max|Y6_Piano(?:_black)?|S100Pro|X[679]pro|V20Pro|V40 Pro|S96GT|android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:S59|S35|X95i?|X93|N30)|android 12(?:[\\d.]*);(?: [\\w-]+;)? (?:S98|S61|S89|V Max|S100|V30T?|S51)|V Max Plus|Y7Plus|S35T|V31GT|Smini|T[23]0Ultra|T10E|[TV]20S|V30Pro|android 14(?:[\\d.]*);(?: [\\w-]+;)? (?:N55|Fire 6)|android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:R[12]0)|android 15(?:[\\d.]*);(?: [\\w-]+;)? (?:Fire 3(?: Pro| Ultra)?)|Android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:N100|N20|Y8|S95)|S41T|N50S|D60 Pro|DK10|Turbo_mini_F1|Y100X|T30Pro|T10S|T10Plus|T10Pro|T20Mini|S41 Max|V Max S|S41 Plus|N55 Pro|N55 Plus|S punk|S cyber|Blade20(?: (?:Turbo|Pro|Max|Play))?|Blade GT|Blade10(?: Ultra|Pro)?|V Max (?:Pro|Play)|T30 Max|(?<!Titanium[_ ])S200|S200 X|Note 5[89]|Note58 Pro|Note59 Pro\\+|S119|U10 Kid)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "T([13]0)Pro(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T$1 Pro"
            },
            {
                "regex": "T30 Max",
                "device": "tablet",
                "model": "T30 Max"
            },
            {
                "regex": "R([12]0)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "R$1"
            },
            {
                "regex": "T([12]0)S(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T$1S"
            },
            {
                "regex": "T10E(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T10E"
            },
            {
                "regex": "T10Plus(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T10 Plus"
            },
            {
                "regex": "T20Mini Kid(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T20 Mini Kid"
            },
            {
                "regex": "T([23]0)Ultra(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T$1 Ultra"
            },
            {
                "regex": "T20Mini ?Pro",
                "device": "tablet",
                "model": "T20 Mini Pro"
            },
            {
                "regex": "T20Mini",
                "device": "tablet",
                "model": "T20 Mini"
            },
            {
                "regex": "U10 Kid",
                "device": "tablet",
                "model": "U10 Kid"
            },
            {
                "regex": "Blade GT Ultra",
                "model": "Blade GT Ultra"
            },
            {
                "regex": "Blade GT Pro",
                "model": "Blade GT Pro"
            },
            {
                "regex": "Blade GT Play",
                "model": "Blade GT Play"
            },
            {
                "regex": "Blade GT",
                "model": "Blade GT"
            },
            {
                "regex": "Blade10 Power",
                "model": "Blade 10 Power"
            },
            {
                "regex": "Blade10 Energy",
                "model": "Blade 10 Energy"
            },
            {
                "regex": "Blade([12]0) Ultra",
                "model": "Blade $1 Ultra"
            },
            {
                "regex": "Blade([12]0) Max",
                "model": "Blade $1 Max"
            },
            {
                "regex": "Blade10 Pro",
                "model": "Blade 10 Pro"
            },
            {
                "regex": "Blade20 Turbo",
                "model": "Blade 20 Turbo"
            },
            {
                "regex": "Blade20 Pro",
                "model": "Blade 20 Pro"
            },
            {
                "regex": "Blade20 Play",
                "model": "Blade 20 Play"
            },
            {
                "regex": "Blade([12]0)",
                "model": "Blade $1"
            },
            {
                "regex": "Fire 3 Pro",
                "model": "Fire 3 Pro"
            },
            {
                "regex": "Fire 3 Ultra",
                "model": "Fire 3 Ultra"
            },
            {
                "regex": "Fire 6 Power",
                "model": "Fire 6 Power"
            },
            {
                "regex": "Fire 6 Max",
                "model": "Fire 6 Max"
            },
            {
                "regex": "Fire ([36])",
                "model": "Fire $1"
            },
            {
                "regex": "V Max Plus",
                "model": "V Max Plus"
            },
            {
                "regex": "V Max Play",
                "model": "V Max Play"
            },
            {
                "regex": "V Max Pro",
                "model": "V Max Pro"
            },
            {
                "regex": "V Max S",
                "model": "V Max S"
            },
            {
                "regex": "V Max",
                "model": "V Max"
            },
            {
                "regex": "S Punk Pro",
                "model": "S Punk Pro"
            },
            {
                "regex": "S punk",
                "model": "S Punk"
            },
            {
                "regex": "S cyber Pro",
                "model": "S Cyber Pro"
            },
            {
                "regex": "S cyber",
                "model": "S Cyber"
            },
            {
                "regex": "V40 Pro",
                "model": "V40 Pro"
            },
            {
                "regex": "(?:Valencia2_)?Y100_Plus(?:[);/ ]|$)",
                "model": "Valencia2 Y100 Plus"
            },
            {
                "regex": "Valencia2[_ ]Y100pro",
                "model": "Valencia2 Y100 Pro"
            },
            {
                "regex": "Valencia2_Y100(?:[);/ ]|$)",
                "model": "Valencia2 Y100"
            },
            {
                "regex": "LEO_(DG280)",
                "model": "Leo $1"
            },
            {
                "regex": "Iron-bone (DG750)",
                "model": "Iron Bone $1"
            },
            {
                "regex": "(X95i?|BL[579]000|S90C|X10S|X[569]0L|X93|V30T?|V31GT|V20S|DK10|S200 X|S119)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "X(9[567])Pro",
                "model": "X$1 Pro"
            },
            {
                "regex": "V30Pro(?:[);/ ]|$)",
                "model": "V30 Pro"
            },
            {
                "regex": "N([24]0|55) ?Pro",
                "model": "N$1 Pro"
            },
            {
                "regex": "N55 Plus",
                "model": "N55 Plus"
            },
            {
                "regex": "Note59 Pro\\+",
                "model": "Note 59 Pro+"
            },
            {
                "regex": "Note58 Pro",
                "model": "Note 58 Pro"
            },
            {
                "regex": "Note (5[89])",
                "model": "Note $1"
            },
            {
                "regex": "N(50)S(?:[);/ ]|$)",
                "model": "N$1S"
            },
            {
                "regex": "BL12000 PRO",
                "model": "BL12000 Pro"
            },
            {
                "regex": "D60 Pro",
                "model": "D60 Pro"
            },
            {
                "regex": "BL5500[_ ]Lite",
                "model": "BL5500 Lite"
            },
            {
                "regex": "BL12000",
                "model": "BL12000"
            },
            {
                "regex": "V20Pro",
                "model": "V20 Pro"
            },
            {
                "regex": "S41 Max",
                "model": "S41 Max"
            },
            {
                "regex": "S([568]8|9[05678]|59|61|4[01]|8[69]|[12]00|118) ?Pro",
                "model": "S$1 Pro"
            },
            {
                "regex": "S(88|41|200) ?Plus",
                "model": "S$1 Plus"
            },
            {
                "regex": "S([4-8]0|55)[_ ]?Lite",
                "model": "S$1 Lite"
            },
            {
                "regex": "S96GT",
                "model": "S96 GT"
            },
            {
                "regex": "KISSME-DG580",
                "model": "Kissme DG580"
            },
            {
                "regex": "Hitman_DG850",
                "model": "Hitman DG580"
            },
            {
                "regex": "X9 Mini",
                "model": "X9 Mini"
            },
            {
                "regex": "Smini",
                "model": "S Mini"
            },
            {
                "regex": "x5_doogee",
                "model": "X5"
            },
            {
                "regex": "T5_Lite",
                "model": "T5 Lite"
            },
            {
                "regex": "Doogee X5MP|x5MaxPro",
                "model": "X5 Max Pro"
            },
            {
                "regex": "X5max_S",
                "model": "X5 Max S"
            },
            {
                "regex": "Shoot_([12])",
                "model": "Shoot $1"
            },
            {
                "regex": "Ibiza_F2",
                "model": "Ibiza F2"
            },
            {
                "regex": "Y6_Piano_black",
                "model": "Y6 Piano Black"
            },
            {
                "regex": "Y6_Piano",
                "model": "Y6 Piano"
            },
            {
                "regex": "Y6 Max 3D",
                "model": "Y6 Max 3D"
            },
            {
                "regex": "Y6 Max",
                "model": "Y6 Max"
            },
            {
                "regex": "Y7Plus",
                "model": "Y7 Plus"
            },
            {
                "regex": "(?:Doogee[_ ])?X([679])[_ ]?pro",
                "model": "X$1 Pro"
            },
            {
                "regex": "T6pro",
                "model": "T6 Pro"
            },
            {
                "regex": "DG550",
                "model": "DG550 Dagger"
            },
            {
                "regex": "Y100X",
                "model": "Nova Y100X"
            },
            {
                "regex": "Turbo_mini_F1",
                "model": "Turbo Mini F1"
            },
            {
                "regex": "Y([89]) ?Plus(?:[);/ ]|$)",
                "model": "Y$1 Plus"
            },
            {
                "regex": "(S5[19]|S35T?|S9[58]|S89|Y8|Y6C|S61|N[23]0|[NS]100|S118|S41T|N55|S200)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(X5max(?:[_ ]PRO)?)",
                "model": "$1"
            },
            {
                "regex": "(?:DOOGEE[ _-])?(BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|Valencia2_Y100pro|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "DOOGEE[ _-]([^);/]+) Build",
                "model": "$1"
            },
            {
                "regex": "DOOGEE[ _-]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MIX2(?:[);/ ]|$)",
                "model": "Mix 2"
            }
        ]
    },
    "Doov": {
        "regex": "(?:Doov-)?Doov[ _]| (?:20200308|20190808)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "20200308(?:[);/ ]|$)",
                "model": "X11 Pro Max"
            },
            {
                "regex": "20190808(?:[);/ ]|$)",
                "model": "X11 Pro"
            },
            {
                "regex": "(?:Doov-)?Doov[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:Doov-)?Doov[ _]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Dopod": {
        "regex": "Dopod(?: )?([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Doppio": {
        "regex": "Doppio[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Doppio DP355(?:[);/ ]|$)",
                "model": "DP355"
            },
            {
                "regex": "Doppio_TEXTER_3G(?:[);/ ]|$)",
                "model": "Texter"
            },
            {
                "regex": "Doppio ([0-9a-z]+)",
                "model": "$1"
            }
        ]
    },
    "Doro": {
        "regex": "Doro|DSB-02[23]0",
        "device": "smartphone",
        "models": [
            {
                "regex": "DSB-0230(?:[);/ ]|$)",
                "model": "8050"
            },
            {
                "regex": "Doro[_ ]8020x(?:[);/ ]|$)",
                "model": "8020X"
            },
            {
                "regex": "DSB-0220(?:[);/ ]|$)",
                "model": "8080"
            },
            {
                "regex": "Doro[ _-]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Doro[ _-]([0-9a-z]+)",
                "model": "$1"
            }
        ]
    },
    "Dune HD": {
        "regex": "DuneHD|SOLO 4K(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SOLO 4K(?:[);/ ]|$)",
                "model": "Solo 4k"
            },
            {
                "regex": "DuneHD/\\d\\.\\d \\([a-z]+__([a-z0-9_-]+);",
                "model": "$1"
            },
            {
                "regex": "DuneHD/\\d\\.\\d \\(([a-z0-9_-]+);",
                "model": "$1"
            }
        ]
    },
    "DNS": {
        "regex": "(?:DNS|AirTab)[ _-]([^;/)]+)|(?:S4505M|S4004M|SD01M)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:DNS[-_]DNS[-_])?S3504",
                "model": "S3504 Meteor 3.5\""
            },
            {
                "regex": "(?:DNS[_ ])?(S4505M|S4004M|SD01M|S4502|S4003|S4003)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "S-4003(?:[);/ ]|$)",
                "model": "S4003"
            },
            {
                "regex": "AirTab[ _-]([^;/]+)(?: Build|[);])",
                "model": "AirTab $1",
                "device": "tablet"
            },
            {
                "regex": "DNS[ _-]([^;/]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "E-Boda": {
        "regex": "E-Boda|Eclipse_(?:G400M|G500)|Revo R77 GPS",
        "device": "smartphone",
        "models": [
            {
                "regex": "E-Boda ((?:Revo|Izzycomm(?: Z80)?|Essential|Intelligence|Supreme)[^/);]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Revo R77 GPS",
                "device": "tablet",
                "model": "Revo R77 GPS"
            },
            {
                "regex": "Eclipse_(G400M|G500)",
                "model": "Eclipse $1"
            },
            {
                "regex": "E-Boda ([^/);]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Easypix": {
        "regex": "EasyPad|(?<!INOI )EasyPhone",
        "device": "smartphone",
        "models": [
            {
                "regex": "(EasyPhone[^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "EasyPad ([^/;)]+)(?: Build|[;)])",
                "model": "EasyPad $1",
                "device": "tablet"
            }
        ]
    },
    "EBEST": {
        "regex": "EBEST",
        "device": "smartphone",
        "models": [
            {
                "regex": "EBEST[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "EBEST[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Horizont": {
        "regex": "(?:Horizont[_ ])?(32LE7011D|24LE7011D|43LE7022D|32LE705[12]D|65LE7053D|43LE7052D|50LE7053D|55LE7053D)",
        "device": "tv",
        "model": "$1"
    },
    "Echo Mobiles": {
        "regex": "ECHO[ _](HOLI|HORIZON|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION|PUSH|PRISM|STUDIO)|(?:HORIZON_M|Stellar [34]G|FEELING|MOON(?![ _]HD[ _]Quad)|LOOK)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ECHO_HORIZON_LITE",
                "model": "HORIZON Lite"
            },
            {
                "regex": "(HORIZON_M|FEELING|MOON|LOOK)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "STELLAR ([34])G",
                "model": "STELLAR $1G"
            },
            {
                "regex": "ECHO_SMART_4G",
                "model": "SMART 4G"
            },
            {
                "regex": "ECHO[ _](HOLI|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION|PUSH|PRISM|STUDIO)",
                "model": "$1"
            }
        ]
    },
    "ECS": {
        "regex": "(?:TA10CA3|TM105A?|TR10[CR]S1|TF10EA2|TR10CS2)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TA10CA3(?:[);/ ]|$)",
                "model": "TA10CA3"
            },
            {
                "regex": "(TR10[CR]S1|TF10EA2|TR10CS2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "TM105A(?:[);/ ]|$)",
                "model": "TM105A"
            },
            {
                "regex": "TM105(?:[);/ ]|$)",
                "model": "TM105"
            }
        ]
    },
    "Edenwood": {
        "regex": "EDENWOOD[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "SmartTV;",
                "model": "Smart TV"
            }
        ]
    },
    "EE": {
        "regex": "(?:Harrier(?: Tab)?|Hawk|Rook)[_ ]from[_ ]EE",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Harrier Tab)[_ ]from[_ ]EE",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Rook[_ ]from[_ ]EE",
                "model": "Rock"
            },
            {
                "regex": "(Harrier|Hawk)[_ ]from[_ ]EE",
                "model": "$1"
            }
        ]
    },
    "EGL": {
        "regex": "EGL11QF6",
        "device": "smartphone",
        "models": [
            {
                "regex": "EGL11QF6",
                "device": "tablet",
                "model": "11QF6"
            }
        ]
    },
    "EKT": {
        "regex": "EK-(?:5040|5336|5540|5937|6020|8680|MII|T7020)",
        "device": "tablet",
        "models": [
            {
                "regex": "EK-(MII|T7020)",
                "model": "EK-$1"
            },
            {
                "regex": "EK-(5040|5336|5540|5937|6020|8680)",
                "device": "smartphone",
                "model": "EK-$1"
            }
        ]
    },
    "Eks Mobility": {
        "regex": "(?:S5[UL]S|X4UPlus|S45U)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(S5[UL]S|S45U)",
                "model": "$1"
            },
            {
                "regex": "X4UPlus",
                "model": "X4U Plus"
            }
        ]
    },
    "Elephone": {
        "regex": "Elephone|Vowney(?: Lite)?|P6000(?!_Plus)( ?Pro| ?Plus|\\+| ?02| 5.0 01)?|(?<!Chrome/)Soldier|C1_Max|(?:Trunk 1|P8_3D|P8_Max|P8_Mini|A6_mini|P9000(?:_Lite)?|Android 9(?:[\\d.]*);(?: [\\w-]+;)? PX|PX_Pro| U3H|U_Pro|Android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:E10_Pro|E10))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Elephone[_ ])?Trunk(?: 1)?(?:[);/ ]|$)",
                "model": "Trunk"
            },
            {
                "regex": "Vowney Lite(?:[);/ ]|$)",
                "model": "Vowney Lite"
            },
            {
                "regex": "Vowney(?:[);/ ]|$)",
                "model": "Vowney"
            },
            {
                "regex": "P6000(\\+| ?Plus)(?:[);/ ]|$)",
                "model": "P6000 Plus"
            },
            {
                "regex": "P6000 02(?:[);/ ]|$)",
                "model": "P6000 02"
            },
            {
                "regex": "P6000 5\\.0 01(?:[);/ ]|$)",
                "model": "P6000 01"
            },
            {
                "regex": "P6000 ?Pro(?:[);/ ]|$)",
                "model": "P6000 Pro"
            },
            {
                "regex": "P(\\d+)[_ ]Lite(?:[);/ ]|$)",
                "model": "P$1 Lite"
            },
            {
                "regex": "Soldier(?:[);/ ]|$)",
                "model": "Soldier"
            },
            {
                "regex": "A6_mini(?:[);/ ]|$)",
                "model": "A6 Mini"
            },
            {
                "regex": "P8_Mini(?:[);/ ]|$)",
                "model": "P8 Mini"
            },
            {
                "regex": "(U|PX|E10)_Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "U3H(?:[);/ ]|$)",
                "model": "U3H"
            },
            {
                "regex": "C1_Max(?:[);/ ]|$)",
                "model": "C1 Max"
            },
            {
                "regex": "PX(?: Build|[;)])",
                "model": "PX"
            },
            {
                "regex": "(P8_3D|P8_Max)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Elephone[ _])?(P[7689]000|S2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Elephone[ _-]([^/;]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Element": {
        "regex": "(?:smarttv_)?AFTRS",
        "model": "Element 4K (2017)",
        "device": "tv"
    },
    "Elenberg": {
        "regex": "(?:TAB(?:101|728)[ _]3G|TAB7(?:[03]8|16|40|3[30])|STB0819)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(STB0819)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "(TAB(?:101|728)[ _]3G|TAB7(?:[03]8|16|40|3[30]))",
                "model": "$1"
            }
        ]
    },
    "Ericy": {
        "regex": "Ericy-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Essential": {
        "regex": "PH-1(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PH-1",
                "model": "PH-1"
            }
        ]
    },
    "E-tel": {
        "regex": "E-tel[-_ ](?:i2[45]0|i300|i7c|N[67]|Q4|O9)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E-tel[-_ ]i(7c|\\d+)",
                "model": "i$1"
            },
            {
                "regex": "E-tel[-_ ]N([67])",
                "model": "N$1"
            },
            {
                "regex": "E-tel[-_ ]O9",
                "model": "Curiosity O9"
            },
            {
                "regex": "E-tel[-_ ]Q4",
                "device": "tablet",
                "model": "Q4"
            }
        ]
    },
    "Evercoss": {
        "regex": "EVERCOSS[ _]|(U6 PRIME|A75A\\*|AT8B|U50A_PLUS|M50 (?:MAX|STAR)|A75 MAX|M55[ABC]|M50A|R40K|R70A|7.*; (?:R70|R5C)|S55[AB]|U70[CB])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A75A\\*(?:[);/ ]|$)",
                "model": "A75A Star"
            },
            {
                "regex": "(A75|M50A) MAX*(?:[);/ ]|$)",
                "model": "$1 Max"
            },
            {
                "regex": "U50A_PLUS(?:[);/ ]|$)",
                "model": "U50A Plus"
            },
            {
                "regex": "M50 STAR(?:[);/ ]|$)",
                "model": "M50 Star"
            },
            {
                "regex": "M50 MAX(?:[);/ ]|$)",
                "model": "M50 Max"
            },
            {
                "regex": "U6 PRIME",
                "model": "U6 Prime"
            },
            {
                "regex": "(M50A|R40K|R70|R5C|S55[AB]|M55[ABC])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(AT8B|R70A|U70[CB])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "EVERCOSS[ _](A7[BRLZ]|A65|A74A|A5Z)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Eurostar": {
        "regex": "(ET7002C-H12|ET8183GQ-HM15|ET7184GQ-B15|ET7183GQ-H16|Onyx-[13]S|T40SG?LED-A1[45])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Onyx-([13]S)",
                "model": "Onyx $1"
            },
            {
                "regex": "ET7002C-H12",
                "model": "ePad 4S",
                "device": "tablet"
            },
            {
                "regex": "(ET8183GQ-HM15|ET7184GQ-B15|ET7183GQ-H16)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(T40SG?LED-A1[45])",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "ETOE": {
        "regex": "SDMC D1221(?:[);/ ]|$)",
        "device": "tv",
        "model": "D1221"
    },
    "Eton": {
        "regex": "Eton",
        "device": "smartphone",
        "models": [
            {
                "regex": "Eton[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "Eton[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Essentielb": {
        "regex": "ESSENTIEL B[;,]|(?:Wooze[_ ]?(?:I55?|I45|X?L)|HEYOU(?:[135]|20PLUS|[1-7]0))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HEYOU20PLUS(?:[);/ ]|$)",
                "model": "HEYou 20 Plus"
            },
            {
                "regex": "HEYOU([135]|[1-7]0)(?:[);/ ]|$)",
                "model": "HEYou $1"
            },
            {
                "regex": "Wooze[_ ]?((?:I55?|I45|X?L))(?:[);/ ]|$)",
                "model": "Wooze $1"
            },
            {
                "regex": "ESSENTIEL B,([a-z0-9_ -]+),(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Facebook": {
        "regex": "PortalTV",
        "device": "tv",
        "model": "Portal TV"
    },
    "Gateway": {
        "regex": "GWAT(?:8-1|10-1)",
        "device": "tablet",
        "models": [
            {
                "regex": "GWAT(8|10)-1",
                "model": "Tablet $1\""
            }
        ]
    },
    "Ricoh": {
        "regex": "ricoh_",
        "device": "peripheral",
        "models": [
            {
                "regex": "ricoh_mfpapnl",
                "model": "MFP"
            }
        ]
    },
    "Rikomagic": {
        "regex": "(?:RKM[_ ])?MK(902II|902|80[28][^/;]*)(?: Build|[;)])",
        "device": "tv",
        "model": "MK$1"
    },
    "Rinno": {
        "regex": "Rinno (R(?:400|505))",
        "device": "smartphone",
        "model": "$1"
    },
    "Riviera": {
        "regex": "RIVIERA[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "RIVIERA[ _](F23|U963)",
                "model": "$1"
            }
        ]
    },
    "Senseit": {
        "regex": "SENSEIT[ _]?([^;/)]+)( Build|\\))",
        "device": "smartphone",
        "model": "$1"
    },
    "SUNWIND": {
        "regex": "SUNWIND[_ ]|SUN[-_]LED\\d+|(?:SKY 9 [EA]\\d+ 3G|Sky (?:126[24]C|1123B|7143B|8244B|8421D|1430D) [43]G|SKY Kids 70 SS7238PG)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SKY ([79]) ([EA]\\d+) 3G",
                "model": "Sky $1 $2 3G"
            },
            {
                "regex": "SKY Kids 70",
                "model": "Sky Kids 70"
            },
            {
                "regex": "Sky (\\d{4}[BCD]) ([34])G",
                "model": "Sky $1 $2G"
            },
            {
                "regex": "SUN[-_]LED(\\d+\\w{1,2}\\d+)",
                "device": "tv",
                "model": "SUN-LED$1"
            }
        ]
    },
    "ZoomSmart": {
        "regex": "(LT600T)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Smartab": {
        "regex": "(ST1009|ST7160|ST1009X)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Sony": {
        "regex": "Sony(?: ?Ericsson)?|SGP|Xperia|(?:[4-9]0[12])SO|C1[569]0[45]|C2[01]0[45]|C230[45]|C530[236]|C550[23]|C6[56]0[236]|C6616|C68(?:0[26]|[34]3)|C69(?:0[236]|16|43)|D(?:200[45]|21(?:0[45]|14)|22(?:0[236]|12|43)|230[2356]|240[36]|2502|2533|510[236]|530[36]|5316|5322|5503|58[03]3|65(?:0[23]|43|63)|66[03458]3|66[14]6|6708)|E(?:20[0345]3|2006|210[45]|2115|2124|230[36]|2312|23[356]3|530[36]|53[3456]3|5506|55[356]3|56[46305][36]|58[02]3|6508|65[35]3|66[0358]3|68[358]3)|F(?:311[12356]|331[13]|321[12356]|5[13]21|5122|813[12]|833[12])|G(?:2299|312[135]|311[26]|322[136]|3212|331[123]|3412|3416|342[136]|823[12]|834[123]|8[14]4[12]|8188)|H(?:3113|3123|3133|3213|3223|3311|3321|3413|4113|4133|4213|4233|4311|4331|4413|4433|4493|8116|8166|82[1679]6|83[12]4|8416|9436|9493)|I(?:3[12]23|3213|[34]113|[34]312|4193|42[19]3|4332)|J(?:3173|3273|81[17]0|82[17]0|91[15]0|92[16]0)|(?:WT|LT|SO|ST|SK|MK)[0-9]+[a-z]+[0-9]*(?: Build|\\))|X?L39H|XM50[ht]|XQ-[A-Z]{2}[0-9]{2}|W960|portalmmm/2\\.0 K|S3[69]h|SOG(?:0[1-9]|1[013])|SOL2[2-6]|SOT[23]1|SOV3[1-9]|SOV4[0-3]|X10[ia]v?|E1[05][ai]v?|MT[0-9]{2}[a-z]? Build|SO-0(?:[12]C|[2-5]D|[1-4]E|[1-5]F|[1-5]G|[1-4]H|[1-4]J|[1-5]K|1M|[1-3]L)|R800[aix]|LiveWithWalkman|BRAVIA|SGP771|E3 Dual|A[012]01SO|A204SO|A[123]02SO|SO-[45]1[AB]|SO-5[1234][ABCDE]|A[12]03SO|A002SO|NW-(A[13]00|ZX500|Z1000)Series|NSZ-GS7|SmartWatch 3|SVP-DTV15",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Sony(?:Ericsson)?)?E10[ai]v?",
                "model": "Xperia X10 mini",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U20",
                "model": "Xperia X10 mini pro",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E15[ai]v?",
                "model": "Xperia X8",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(LT15[ai]?v?|SO-01C)",
                "model": "Xperia arc",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT18[ai]v?",
                "model": "Xperia arc S",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MT11",
                "model": "Xperia neo V",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MT15",
                "model": "Xperia neo",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MT27",
                "model": "Xperia Sola",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?MK16[ai]",
                "model": "Xperia pro",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST15[ai]",
                "model": "Xperia mini",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST17[ai]",
                "model": "Xperia active",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-02L",
                "model": "Xperia Ace",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST18[ai]",
                "model": "Xperia ray",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SK17[ai]?",
                "model": "Xperia mini pro",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?X10[ai]v?",
                "model": "Xperia X10",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)M1",
                "model": "Aspen",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?R800",
                "model": "Xperia PLAY",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "Xperia Acro S",
                "model": "Xperia Acro S",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?WT19|LiveWithWalkman",
                "model": "Live with Walkman",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?CK13i",
                "model": "txt",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?CK15[ai]",
                "model": "txt pro",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F100i",
                "model": "Jalou",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J105",
                "model": "Naite",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J108",
                "model": "Cedar",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J10",
                "model": "Elm",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J20",
                "model": "Hazel",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U10",
                "model": "Aino",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U100",
                "model": "Yari",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U1",
                "model": "Satio",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U5",
                "model": "Vivaz",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?U8",
                "model": "Vivaz pro",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W20",
                "model": "Zylo",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W100",
                "model": "Spiro",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W150",
                "model": "Yendo",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?W960",
                "model": "W960",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?WT13",
                "model": "Mix Walkman",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "SO-01E(?:[);/ ]|$)",
                "model": "Xperia AX"
            },
            {
                "regex": "XQ-BE[4-7]2",
                "model": "Xperia Pro I"
            },
            {
                "regex": "XQ-AQ[56]2",
                "model": "Xperia Pro"
            },
            {
                "regex": "SO-04F",
                "model": "Xperia A2"
            },
            {
                "regex": "SO-02D",
                "model": "Xperia NX"
            },
            {
                "regex": "G2299",
                "model": "Xperia R1 Plus"
            },
            {
                "regex": "SO-04G",
                "model": "Xperia A4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?I(?:4113|31[12]3)",
                "model": "Xperia 10"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J3173(?:[);/ ]|$)",
                "model": "Xperia Ace"
            },
            {
                "regex": "SO-41B(?:[);/ ]|$)",
                "model": "Xperia Ace II"
            },
            {
                "regex": "(?:A203SO|SO-53C|SOG08)(?:[);/ ]|$)",
                "model": "Xperia Ace III"
            },
            {
                "regex": "(?:A001SO|XQ-AU42|XQ-AU51|XQ-A[TU]52|SO-41A|SOV43)(?:[);/ ]|$)",
                "model": "Xperia 10 II"
            },
            {
                "regex": "(?:A10[12]SO|SO-52B|SOG04|XQ-BT52)(?:[);/ ]|$)",
                "model": "Xperia 10 III"
            },
            {
                "regex": "(?:SO-52D|XQ-DC72|XQ-DC54|A302SO|SOG11)(?:[);/ ]|$)",
                "model": "Xperia 10 V"
            },
            {
                "regex": "(?:XQ-ES[45]4|XQ-ES72|SOG14|SO-52E|A402SO)(?:[);/ ]|$)",
                "model": "Xperia 10 VI"
            },
            {
                "regex": "XQ-BT44(?:[);/ ]|$)",
                "model": "Xperia 10 III Lite"
            },
            {
                "regex": "(?:XQ-CC72|XQ-CC[45]4|SOG07|SO-52C|A202SO)(?:[);/ ]|$)",
                "model": "Xperia 10 IV"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?I(?:42[19]3|32[12]3)",
                "model": "Xperia 10 Plus"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?I4193",
                "model": "Xperia 10 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:J(?:9110|81[17]0)|SOV40|SO-03L|802SO)",
                "model": "Xperia 1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:J9150)",
                "model": "Xperia 1 Professional Edition"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOG01|SO-51A|XQ-AT42|XQ-AT51|SO51Aa|XQ-AT72)(?:[);/ ]|$)",
                "model": "Xperia 1 II"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SO-51B|SOG03|XQ-BC[4567]2)(?:[);/ ]|$)",
                "model": "Xperia 1 III"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOG06|XQ-CT[67]2|SO-51C|A201SO|XQ-CT[45]4)(?:[);/ ]|$)",
                "model": "Xperia 1 IV"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOG10|SO-51D|XQ-DQ(?:[67]2|[45]4))(?:[);/ ]|$)",
                "model": "Xperia 1 V"
            },
            {
                "regex": "(?:XQ-EC72|XQ-EC54|XQ-EC44|SOG13|SO-51E|A401SO|SOG13)(?:[);/ ]|$)",
                "model": "Xperia 1 VI"
            },
            {
                "regex": "XQ-FS(?:72|44)",
                "model": "Xperia 1 VII"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT22i|Xperia P",
                "model": "Xperia P"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT25i|Xperia V",
                "model": "Xperia V"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J92[16]0",
                "model": "Xperia 5 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:J82[17]0|SO-01M|SOV41|901SO)",
                "model": "Xperia 5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOG02|A002SO|XQ-AS[4567]2|SO-52A)",
                "model": "Xperia 5 II"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:XQ-DE72|XQ-DE[45]4)",
                "model": "Xperia 5 V"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SO-53B|A103SO|SOG05|XQ-BQ[4567]2)",
                "model": "Xperia 5 III"
            },
            {
                "regex": "(?:SOG09|XQ-CQ72|SO-54C|XQ-CQ[45]4|XQ-CQ62|A204SO)",
                "model": "Xperia 5 IV"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:SOV42|902SO)",
                "model": "Xperia 8"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?J3273",
                "model": "Xperia 8 Lite"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT26ii",
                "model": "Xperia SL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT26i|Xperia S(?:[);/ ]|$)",
                "model": "Xperia S"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-02C",
                "model": "Xperia arco"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-03D",
                "model": "Xperia arco HD"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT26w",
                "model": "Xperia arco S"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT28[aih]",
                "model": "Xperia ion"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT29i|Xperia TX(?:[);/ ]|$)",
                "model": "Xperia TX"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT30a",
                "model": "Xperia T LTE"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?LT30p",
                "model": "Xperia T"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST21[ia]2",
                "model": "Xperia tipo dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST21[ia]",
                "model": "Xperia tipo"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST23[ia]",
                "model": "Xperia miro"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST25[ia]",
                "model": "Xperia U"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SOL22",
                "model": "Xperia UL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SOL21",
                "model": "Xperia VL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST26[ia]",
                "model": "Xperia J"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?ST27[ia]",
                "model": "Xperia go"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C150[45]",
                "model": "Xperia E"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C160[45]",
                "model": "Xperia E Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E210[45]|E2115|E2124)",
                "model": "Xperia E4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E20[05]3|E2006",
                "model": "Xperia E4G"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C190[45]",
                "model": "Xperia M"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C200[45]",
                "model": "Xperia M Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C210[45]|S36h",
                "model": "Xperia L"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C230[45]|S39h",
                "model": "Xperia C"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C530[236]|Xperia SP(?:[);/ ]|$)",
                "model": "Xperia SP"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C550[23]",
                "model": "Xperia ZR"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?C650[236]|Xperia ZL(?:[);/ ]|$)",
                "model": "Xperia ZL"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SOL25(?:[);/ ]|$)",
                "model": "Xperia ZL2"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:C66(?:0[236]|16)|SO-02E)",
                "model": "Xperia Z"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:C68(?:0[26]|[34]3)|XL39H|SOL24)|Xperia Z Ultra(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Xperia Z Ultra"
            },
            {
                "regex": "Xperia Z(?:[);/ ]|$)",
                "model": "Xperia Z"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D200[45]",
                "model": "Xperia E1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D21(?:0[45]|14)",
                "model": "Xperia E1 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D22(?:0[236]|43)",
                "model": "Xperia E3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2212|E3 Dual",
                "model": "Xperia E3 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E20[34]3",
                "model": "Xperia E4g Dual"
            },
            {
                "regex": "H33[12]1",
                "model": "Xperia L2"
            },
            {
                "regex": "H43[13]1",
                "model": "Xperia L2 Dual"
            },
            {
                "regex": "I3312",
                "model": "Xperia L3"
            },
            {
                "regex": "I43[13]2",
                "model": "Xperia L3 Dual"
            },
            {
                "regex": "XQ-AD5[12]",
                "model": "Xperia L4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2302",
                "model": "Xperia M2 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D230[356]",
                "model": "Xperia M2"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D240[36]",
                "model": "Xperia M2 Aqua"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E230[36]|E23[35]3)",
                "model": "Xperia M4 Aqua"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E2312|E2363)",
                "model": "Xperia M4 Aqua Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E56[05][36]",
                "model": "Xperia M5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E56[436]3",
                "model": "Xperia M5 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2502",
                "model": "Xperia C3 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D2533",
                "model": "Xperia C3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E53[05]3|E5306",
                "model": "Xperia C4"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E53[0346]3",
                "model": "Xperia C4 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E5506|E5553",
                "model": "Xperia C5 Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E55[36]3",
                "model": "Xperia C5 Ultra Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D510[236]",
                "model": "Xperia T3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D530[36]|D5316|XM50[ht])",
                "model": "Xperia T2 Ultra",
                "device": "phablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D5322",
                "model": "Xperia T2 Ultra Dual",
                "device": "phablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?D5503|Xperia Z1 Compact",
                "model": "Xperia Z1 Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:C69(?:0[236]|16|43)|SOL23|L39H|SO-0[12]F)|Xperia Z1(?:[);/ ]|$)",
                "model": "Xperia Z1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D58[03]3|SO-02G)|Xperia Z3 Compact(?:[);/ ]|$)",
                "model": "Xperia Z3 Compact"
            },
            {
                "regex": "Xperia Z2 Tablet Wifi",
                "model": "Xperia Z2 Tablet WiFi",
                "device": "tablet"
            },
            {
                "regex": "SGP561|SOT21(?:[);/ ]|$)",
                "model": "Xperia Z2 Tablet",
                "device": "tablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D65(?:0[23]|43)|SO-03F)|Xperia Z2(?:[);/ ]|$)",
                "model": "Xperia Z2"
            },
            {
                "regex": "D6563",
                "model": "Xperia Z2a"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D66[045]3|D66[14]6|SO-01G|SOL26|401SO)|Xperia Z3(?:[);/ ]|$)",
                "model": "Xperia Z3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D6633|D6683)",
                "model": "Xperia Z3 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E65[35]3)",
                "model": "Xperia Z3+"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:D6708)",
                "model": "Xperia Z3v"
            },
            {
                "regex": "SOV31|402SO|SO-03G",
                "model": "Xperia Z4"
            },
            {
                "regex": "E6508",
                "model": "Xperia Z4v"
            },
            {
                "regex": "SGP771|SOT31|SO-05G",
                "model": "Xperia Z4",
                "device": "tablet"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E58[02]3|SO-02H)",
                "model": "Xperia Z5 Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E66[05]3|SOV32|501SO|SO-01H)",
                "model": "Xperia Z5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E66[38]3",
                "model": "Xperia Z5 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:E68[58]3|SO-03H)",
                "model": "Xperia Z5 Premium"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?E6833",
                "model": "Xperia Z5 Premium Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F311[135]",
                "model": "Xperia XA"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F311[26]",
                "model": "Xperia XA Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F321[135]",
                "model": "Xperia XA Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F321[26]",
                "model": "Xperia XA Ultra Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F833[12]|SOV34|601SO|SO-01J",
                "model": "Xperia XZ"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:701SO|SOV36|G834[123]|SO-01K)",
                "model": "Xperia XZ1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G8441|SO-02K",
                "model": "Xperia XZ1 Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F331[13]",
                "model": "Xperia E5"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G312[135]|G311[26]",
                "model": "Xperia XA1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G341[26]|G342[13]",
                "model": "Xperia XA1 Plus"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G3426",
                "model": "Xperia XA1 Plus Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G322[136]|G3212",
                "model": "Xperia XA1 Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?H31[123]3",
                "model": "Xperia XA2"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?H41[13]3",
                "model": "Xperia XA2 Dual"
            },
            {
                "regex": "H44[19]3|H3413",
                "model": "Xperia XA2 Plus"
            },
            {
                "regex": "H4433",
                "model": "H4433"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?H(?:3213|3223|4213|4233)",
                "model": "Xperia XA2 Ultra"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G823[12]|SOV35|602SO|SO-03J",
                "model": "Xperia XZs"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:G814[12]|G8188|SO-04[JK])",
                "model": "Xperia XZ Premium"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:H83[12]4|H82[17]6|SOV37|SO-03K|H8296|702SO)",
                "model": "Xperia XZ2"
            },
            {
                "regex": "H8266",
                "model": "Xperia XZ2 Dual"
            },
            {
                "regex": "SO-05K",
                "model": "Xperia XZ2 Compact"
            },
            {
                "regex": "(?:H81[16]6|SOV38)(?:[);/ ]|$)",
                "model": "Xperia XZ2 Premium Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:H(8416|9436|9493)|SO-01L|SOV39|801SO)",
                "model": "Xperia XZ3"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G331[13]",
                "model": "Xperia L1"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?G3312",
                "model": "Xperia L1 Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-04E",
                "model": "Xperia A"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-04D",
                "model": "Xperia GX"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?SO-05D",
                "model": "Xperia SX"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F5121",
                "model": "Xperia X"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F5122",
                "model": "Xperia X Dual"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F5321|SO-02J",
                "model": "Xperia X Compact"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?(?:F8131|502SO|SOV33|SO-04H)",
                "model": "Xperia X Performance"
            },
            {
                "regex": "(?:Sony(?:Ericsson)?)?F8132",
                "model": "Xperia X Performance Dual"
            },
            {
                "regex": "(?:Sony)?(?:SGP(?:311|312|321)|(Sony)?SO-03E|Tablet Z LTE)(?:[);/ ]|$)",
                "model": "Xperia Tablet Z",
                "device": "tablet"
            },
            {
                "regex": "SGP712(?:[);/ ]|$)",
                "model": "Xperia Tablet Z4",
                "device": "tablet"
            },
            {
                "regex": "SGP(?:511|512|521)(?:[);/ ]|$)|SO-05F",
                "model": "Xperia Tablet Z2",
                "device": "tablet"
            },
            {
                "regex": "SGP(?:6[124]1|612)(?:[);/ ]|$)",
                "model": "Xperia Tablet Z3 Compact",
                "device": "tablet"
            },
            {
                "regex": "SGPT(?:12|121|122|123|13|131|132|133)(?:[);/ ]|$)",
                "model": "Xperia Tablet S",
                "device": "tablet"
            },
            {
                "regex": "SmartWatch 3",
                "model": "SmartWatch 3",
                "device": "wearable"
            },
            {
                "regex": "(?:BRAVIA )(2K GB ATV3|[48]K UR[123]|4K GB ATV3|4K GB|4K VH21|4K VH2|4K 2015|2015|VH1|VU[12]|VU31)(?:[);/ ]|$)",
                "model": "Bravia $1",
                "device": "tv"
            },
            {
                "regex": "SVP-DTV15(?:[);/ ]|$)",
                "model": "Bravia 4K (2015)",
                "device": "tv"
            },
            {
                "regex": "(NSZ-GS7)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "Sony-BRAVIA-VH1(?:[);/ ]|$)",
                "model": "Bravia VH1",
                "device": "tv"
            },
            {
                "regex": "NW-(A[13]00|Z1000|ZX500)Series",
                "model": "Walkman $1",
                "device": "portable media player"
            },
            {
                "regex": "BDP7G",
                "model": "BDP7G",
                "device": "tv"
            },
            {
                "regex": "BDP8G_AX",
                "model": "BDP8G AX",
                "device": "tv"
            },
            {
                "regex": "BDV7G_NV",
                "model": "BDV7G NV",
                "device": "tv"
            },
            {
                "regex": "BDP9G_AXD",
                "model": "BDP9G AXD",
                "device": "tv"
            },
            {
                "regex": "BDPlayer; ([0-9a-z\\-_]+);",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "BDP(201[3-7])",
                "model": "Blu-ray Player ($1)",
                "device": "tv"
            },
            {
                "regex": "SonyBDP|SonyDBV|BDPlayer",
                "model": "Blu-ray Player",
                "device": "tv"
            },
            {
                "regex": "(?:Sony-)?(KDL?-?[0-9a-z]+)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "Opera TV Store.*(?:Sony-)([0-9a-z\\-_]+)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "((?:WT|SO|ST|SK|MK)[0-9]+[a-z]*[0-9]*)(?: Build|\\))",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "(MT[0-9]{2}[a-z]?)(?:[);/ ]|$)",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "portalmmm/2\\.0 K([a-z0-9]+)",
                "model": "K$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "SonyEricsson ?IS11S",
                "model": "arco IS11S",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "Sony ?Ericsson?([^/;]*) Build",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "SonyEricsson([CGJKPTWZ][0-9]+[a-z]+)/",
                "model": "$1",
                "brand": "Sony Ericsson",
                "device": "feature phone"
            },
            {
                "regex": "Sony ?Ericsson ?([a-z0-9-]+)",
                "model": "$1",
                "brand": "Sony Ericsson"
            },
            {
                "regex": "Sony Corporation/([^/;]*)\\)",
                "model": "$1",
                "device": "desktop"
            },
            {
                "regex": "Sony (Tablet[^/;]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(SGP[^/;]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Xperia ([^/;]*Tablet[^/;]*) Build",
                "model": "Xperia $1",
                "device": "tablet"
            },
            {
                "regex": "Xperia ([^;/]+) \\(AOSP\\) Build",
                "model": "Xperia $1"
            },
            {
                "regex": "Xperia ([^;/]+) Build",
                "model": "Xperia $1"
            },
            {
                "regex": "(XQ-[A-Z]{2}[0-9]{2})",
                "model": "$1"
            },
            {
                "regex": "Sony[ -]?([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "Sony[ -]?([a-z0-9-]+)",
                "model": "$1"
            }
        ]
    },
    "Ergo": {
        "regex": "ERGO|(V550[_ ]Vision|B502 Basic|B504[_ ]Unit|A502[_ ]Aurum|A503[ _]Optima|Prime B400|A551 Sky 4G|A553 Power|A555 Universe|Force F500|GoTab GBT9|GoTab Gti8|F501_Magic|V551[ _]Aura|V540_Level|V570_BIG_BEN|B506[_ ]INTRO|A503-Optima|B505_Unit_4G|LE32CT5515AK)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F501_Magic",
                "model": "F501 Magic"
            },
            {
                "regex": "B502 Basic",
                "model": "B502 Basic"
            },
            {
                "regex": "A503-Optima",
                "model": "A503 Optima"
            },
            {
                "regex": "B506[_ ]INTRO",
                "model": "B506 Intro"
            },
            {
                "regex": "V550[_ ]Vision",
                "model": "V550 Vision"
            },
            {
                "regex": "B504[_ ]Unit",
                "model": "B504 Unit"
            },
            {
                "regex": "B505_Unit_4G",
                "model": "B505 Unit 4G"
            },
            {
                "regex": "V551[ _]Aura",
                "model": "V551 Aura"
            },
            {
                "regex": "V540_Level",
                "model": "V540 Level"
            },
            {
                "regex": "V570_BIG_BEN",
                "model": "V570 Big Ben"
            },
            {
                "regex": "Ergo F502",
                "model": "F502 Platinum"
            },
            {
                "regex": "(ERGO_)?A500[ _]Best",
                "model": "A500 Best"
            },
            {
                "regex": "(ERGO_)?A550[ _]Maxx",
                "model": "A550 Maxx"
            },
            {
                "regex": "Prime B400",
                "model": "Prime B400"
            },
            {
                "regex": "A502[_ ]Aurum",
                "model": "A502 Aurum"
            },
            {
                "regex": "A503[ _]Optima",
                "model": "A503 Optima"
            },
            {
                "regex": "A551 Sky 4G",
                "model": "A551 Sky 4G"
            },
            {
                "regex": "A553 Power",
                "model": "A553 Power"
            },
            {
                "regex": "A555 Universe",
                "model": "A555 Universe"
            },
            {
                "regex": "ERGO[_ ]A556",
                "model": "A556"
            },
            {
                "regex": "ERGO[_ ]F500",
                "model": "F500"
            },
            {
                "regex": "ERGO[_ ]F501",
                "model": "F501"
            },
            {
                "regex": "B500 First",
                "model": "B500 First"
            },
            {
                "regex": "Force F500",
                "model": "Force F500"
            },
            {
                "regex": "GoTab GBT9",
                "model": "GoTab GBT9",
                "device": "tablet"
            },
            {
                "regex": "GoTab Gti8",
                "model": "GoTab GTi8",
                "device": "tablet"
            },
            {
                "regex": "ERGO[_ ]Tab[ _]Crystal[ _]Lite",
                "model": "Tab Crystal Lite",
                "device": "tablet"
            },
            {
                "regex": "ERGO[_ ]Tab[ _]Hero[ _]II",
                "model": "Tab Hero II",
                "device": "tablet"
            },
            {
                "regex": "ERGO[_ ](B700)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "ERGO SmartBox SX",
                "model": "SmartBox SX",
                "device": "tv"
            },
            {
                "regex": "(LE32CT5515AK)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "ERGOGS",
                "model": "GHS55",
                "device": "tv"
            }
        ]
    },
    "Ericsson": {
        "regex": "(?:Ericsson(?:/ )?[a-z0-9]+)|(?:R380 2\\.0 WAP1\\.1)",
        "device": "feature phone",
        "models": [
            {
                "regex": "Ericsson(?:/ )?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "R380 2\\.0 WAP1\\.1",
                "model": "R380"
            }
        ]
    },
    "Energizer": {
        "regex": "Energizer_|Energizer[ _](?:Energy|Ultimate|Power Max|Hard ?case)|PowerMax|HARDCASEH5[05]0S|ENERGY[_ ]?(?:[45]00|400S|S[56]00|E12|E5[02]0S?)(?:[_ ](?:LTE|EU))?",
        "device": "smartphone",
        "models": [
            {
                "regex": "Power ?Max ?(P[0-9]+S?)",
                "model": "Power Max $1"
            },
            {
                "regex": "ENERGY[_ ]([45]00|E520)[_ ]LTE",
                "model": "Energy $1 LTE"
            },
            {
                "regex": "ENERGY[_ ]400S",
                "model": "Energy 400S"
            },
            {
                "regex": "ENERGY400",
                "model": "Energy 400"
            },
            {
                "regex": "ENERGY[_ ]S([56]00|550)",
                "model": "Energy S$1"
            },
            {
                "regex": "ENERGY[_ ]?(E500S|E500|E12)",
                "model": "Energy $1"
            },
            {
                "regex": "HARD ?CASE ?(H5[057]0S|G5)",
                "model": "Hard Case $1"
            },
            {
                "regex": "Ultimate 65G",
                "model": "Ultimate 65G"
            },
            {
                "regex": "Energizer_(E24[12]S|E280S|E282SC|H280A|E241)(?:_(?:4G|512))?(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "eTouch": {
        "regex": "eTouch ?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Etuline": {
        "regex": "(ETL-S(?:3520|4521|5042|5084|6022)|ETL-T(?:752G|850|882G|9[78]0))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(ETL-S(?:[^/); ]+))",
                "model": "$1"
            },
            {
                "regex": "(ETL-T(?:[^/); ]+))",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Storex": {
        "regex": "eZee[^a-z]*Tab ?([^;/]*) Build|STOREX LinkBox",
        "device": "tablet",
        "models": [
            {
                "regex": "eZee[^a-z]*Tab ?([^;/]*) Build",
                "model": "eZee'Tab$1"
            },
            {
                "regex": "STOREX LinkBox",
                "model": "LinkBox",
                "device": "tv"
            }
        ]
    },
    "Everest": {
        "regex": "(?:DC-(?:1032|121[56]|110[24]|1028|1545|70[59]|71[48]|85[56]|8015|971[45])|(?:EVERPAD )?DC-709|DC-9712-8)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "DC-(1032|1028|121[56]|110[24]|1545|70[59]|71[48]|8015|85[56]|971[45]|9712)",
                "model": "EverPad DC-$1"
            }
        ]
    },
    "Evertek": {
        "regex": "(Ever(?:Allure|Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Solo|Smart|Star)[^/);]*)(?: Build|[;)])|(?:E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E1014HG|E7224HG|E7914HG|V5_Nano|M10\\+Max|M10 Nano|V4 Nano| V4\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG|E7224HG|E1014HG)",
                "device": "tablet",
                "model": "Everpad $1"
            },
            {
                "regex": "(M10|V[45])[_ ]Nano",
                "model": "$1 Nano"
            },
            {
                "regex": "M10\\+Max",
                "model": "M10 Max"
            },
            {
                "regex": "EverMiracle Plus",
                "model": "EverMiracle Plus"
            },
            {
                "regex": "V4\\+",
                "model": "V4 Plus"
            },
            {
                "regex": "EverTrendy\\+4G",
                "model": "EverTrendy 4G"
            },
            {
                "regex": "Ever(Shine|Allure|Glory) ?II",
                "model": "Ever$1 II"
            },
            {
                "regex": "(Ever(?:Allure|Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Solo|Smart|Star)[^/);]*)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Evolio": {
        "regex": "Evolio|M4MAGIC",
        "device": "smartphone",
        "models": [
            {
                "regex": "M4MAGIC",
                "model": "M4 Magic"
            },
            {
                "regex": "Evolio_M5Pro",
                "model": "M5 Pro"
            },
            {
                "regex": "Evolio[ _](M6|S4 Cobalt|S5|X10|Yuppi)",
                "model": "$1"
            }
        ]
    },
    "Evolveo": {
        "regex": "EVOLVEO|StrongPhone",
        "device": "smartphone",
        "models": [
            {
                "regex": "EVOLVEO MultiMedia Box M4",
                "device": "tv",
                "model": "MultiMedia Box M4"
            },
            {
                "regex": "EVOLVEO Android Box (H[48])",
                "device": "tv",
                "model": "Android Box $1"
            },
            {
                "regex": "Smart TV ([^;/]*) Build",
                "device": "tv",
                "model": "Smart TV $1"
            },
            {
                "regex": "Android Stick Q4",
                "device": "tv",
                "model": "Stick Q4"
            },
            {
                "regex": "StrongPhone D2 Mini",
                "model": "StrongPhone D2 Mini"
            },
            {
                "regex": "EVOLVEO StrongPhone G(\\d)",
                "model": "StrongPhone G$1"
            },
            {
                "regex": "(?:EVOLVEO[ _])?StrongPhone[ _]?Q([679])(_LTE)?",
                "model": "StrongPhone Q$1$2"
            },
            {
                "regex": "EVOLVEO[ _]([^;/]*) Build",
                "model": "$1"
            }
        ]
    },
    "Evoo": {
        "regex": "(EVM4G3|EVM4G6|EVMFV2)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Leotec": {
        "regex": "(LESPH501[14]|LESPH5003B|SUPERNOVA[ _](?:Qi16|i216|Qi32|i3G96[X]?|iS3G)|PULSAR QI3G|LETAB916|Titanium T355)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LESPH5011",
                "model": "Argon e250"
            },
            {
                "regex": "LESPH5003B",
                "model": "Argon A250B"
            },
            {
                "regex": "LESPH5014",
                "model": "Krypton K150"
            },
            {
                "regex": "Titanium T355",
                "model": "Titanium T355"
            },
            {
                "regex": "SUPERNOVA[ _](i216|Qi16|Qi32|i3G96[X]?|iS3G)",
                "device": "tablet",
                "model": "Supernova $1"
            },
            {
                "regex": "PULSAR (QI3G)",
                "device": "tablet",
                "model": "Pulsar $1"
            },
            {
                "regex": "LETAB916",
                "device": "tablet",
                "model": "L-Pad Star S"
            }
        ]
    },
    "EVPAD": {
        "regex": "(?:EVBOX-PLUS\\+|EVPAD-[35]S|EVPAD-PRO-MAX)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "EVBOX-PLUS\\+",
                "model": "EVBox Plus"
            },
            {
                "regex": "EVPAD-([35]S)",
                "model": "$1"
            },
            {
                "regex": "EVPAD-PRO-MAX",
                "model": "EVBox Pro Max"
            }
        ]
    },
    "evvoli": {
        "regex": "EVVOLI[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "EVVOLI,([a-z0-9_ -]+),(?:wired|wireless)",
                "model": "$1"
            }
        ]
    },
    "EvroMedia": {
        "regex": "EVROMEDIA|Playpad[ _]|PLAY_PAD_PRO_XL|3G NOTE XL",
        "device": "tablet",
        "models": [
            {
                "regex": "Playpad 3G GOO",
                "model": "Play Pad 3G Goo"
            },
            {
                "regex": "Play Pad 3G 2Goo",
                "model": "Play Pad 3G 2Goo"
            },
            {
                "regex": "Play Pad PRO",
                "model": "Play Pad Pro"
            },
            {
                "regex": "PLAY_PAD_PRO_XL",
                "model": "Play Pad Pro XL"
            },
            {
                "regex": "PlayPad 3GTab XL",
                "model": "Play Pad 3G Tab XL"
            },
            {
                "regex": "3G NOTE XL",
                "model": "Play Pad 3G Note XL"
            }
        ]
    },
    "EKO": {
        "regex": "EKO|Star (?:\\d\\.\\d) (?:G65|G5[05]|G40)|(?:K55USW)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(K55USW)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "EKO Android TV 2K",
                "model": "2K Android TV",
                "device": "tv"
            },
            {
                "regex": "Star (\\d\\.\\d) (G65|G5[05]|G40)",
                "model": "Star $1 $2"
            },
            {
                "regex": "EKO[ _-]?([^;/)]+) Build",
                "model": "$1"
            },
            {
                "regex": "EKO[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Extrem": {
        "regex": "Rock[ _]X[89]+|ROCK_X11",
        "device": "smartphone",
        "models": [
            {
                "regex": "Rock[ _]X([89])\\+",
                "model": "Rock X$1+"
            },
            {
                "regex": "ROCK_X11",
                "model": "Rock X11"
            }
        ]
    },
    "Jumper": {
        "regex": "EZpad ([^;/)]+)(?: Build|[;)])",
        "device": "tablet",
        "model": "EZpad $1"
    },
    "JPay": {
        "regex": "(JP5s?) Inmate Media Device(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Ezze": {
        "regex": "EZZE-|EZ(?!Browser)[a-z0-9]+",
        "device": "feature phone",
        "models": [
            {
                "regex": "EZZE-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "EZ([a-z0-9]+)",
                "model": "EZ$1"
            }
        ]
    },
    "Ezio": {
        "regex": "EZIO-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Forstar": {
        "regex": "Amosta ?3G5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Amosta ?3G5",
                "model": "Amosta 3G5"
            }
        ]
    },
    "InFocus": {
        "regex": "(?:IF(900[1237]|902[19]|903[15]|236a|195a)|M370i?|InFocus M808i?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IF9001",
                "model": "Turbo 5"
            },
            {
                "regex": "(M370i?)",
                "model": "$1"
            },
            {
                "regex": "IF9007",
                "model": "A3"
            },
            {
                "regex": "IF9021",
                "model": "Turbo 5 Plus"
            },
            {
                "regex": "IF9035",
                "model": "A2"
            },
            {
                "regex": "IF9002",
                "model": "M5s"
            },
            {
                "regex": "IF9003",
                "model": "M6s"
            },
            {
                "regex": "IF9031",
                "model": "Vision 3"
            },
            {
                "regex": "IF9029",
                "model": "Vision 3 Pro"
            },
            {
                "regex": "IF(236|195)a",
                "model": "Big Tab IF$1a",
                "device": "tablet"
            },
            {
                "regex": "InFocus M([0-9]+[a-z]?)",
                "model": "M$1"
            }
        ]
    },
    "Foxconn": {
        "regex": "InFocus M[0-9]+[a-z]?",
        "device": "smartphone",
        "models": [
            {
                "regex": "InFocus M([0-9]+[a-z]?)",
                "model": "InFocus M$1"
            }
        ]
    },
    "Fobem": {
        "regex": "Fobem ",
        "device": "tv",
        "models": [
            {
                "regex": "4K SMART TV(?:[);/ ]|$)",
                "model": "4K Smart TV"
            }
        ]
    },
    "Fondi": {
        "regex": "Fondi[- _]([^;/)]+)|(T702|Q008B|Q010B|Q718B|Q902|T602B|T707G|T708B|T725B|T725B1|T907B)(?:\\)| Build)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(T702|T602B)",
                "model": "$1"
            },
            {
                "regex": "(Q008B|Q010B|Q718B|Q902|T707G|T708B|T725B|T725B1|T907B)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Fondi[- _]([^;/)]+)",
                "model": "$1"
            }
        ]
    },
    "Fairphone": {
        "regex": "(?:Fairphone )?(FP(?:1U?|[2345]))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Famoco": {
        "regex": "(FX[123]00)",
        "device": "smartphone",
        "model": "$1"
    },
    "FiGO": {
        "regex": "ATRIUM II F55L2|TRIO F40LT|CENTRIC S50G|EPIC F50G|Gravity X55L|Orion M50L|ULTRA M50G|UltraJ8|M405B|VIRTUE3|F55L Build|Orbit_ll|F40G2",
        "device": "smartphone",
        "models": [
            {
                "regex": "ATRIUM II F55L2",
                "model": "Atrium II"
            },
            {
                "regex": "(F55L)",
                "model": "$1"
            },
            {
                "regex": "TRIO F40LT",
                "model": "Trio F40LT"
            },
            {
                "regex": "EPIC F50G",
                "model": "Epic F50G"
            },
            {
                "regex": "(Gravity X55L|Orion M50L)",
                "model": "$1"
            },
            {
                "regex": "ULTRA M50G",
                "model": "Prime"
            },
            {
                "regex": "M405B_8GB",
                "model": "Virtue II 8GB"
            },
            {
                "regex": "M405B",
                "model": "Virtue II"
            },
            {
                "regex": "VIRTUE3",
                "model": "Virtue III"
            },
            {
                "regex": "CENTRIC S50G",
                "model": "Centric S50G"
            },
            {
                "regex": "UltraJ8",
                "model": "Ultra J8"
            },
            {
                "regex": "Orbit_ll",
                "model": "Orbit II"
            },
            {
                "regex": "F40G2",
                "model": "Ultra Plus F40G2"
            }
        ]
    },
    "FNB": {
        "regex": "ConeXis (A[12]|X[12])|SP5045V",
        "device": "smartphone",
        "models": [
            {
                "regex": "SP5045V",
                "model": "SP5045V"
            },
            {
                "regex": "ConeXis A1",
                "model": "ConeXis A1"
            },
            {
                "regex": "ConeXis A2",
                "model": "ConeXis A2"
            },
            {
                "regex": "ConeXis X1",
                "model": "ConeXis X1"
            },
            {
                "regex": "ConeXis X2",
                "model": "ConeXis X2"
            }
        ]
    },
    "Fuego": {
        "regex": "FUEGO, ([a-z0-9_ -]+), (?:wired|wireless)|FUEGO 2K SMART TV",
        "device": "tv",
        "models": [
            {
                "regex": "2K SMART TV",
                "model": "2K Smart TV"
            }
        ]
    },
    "SEG": {
        "regex": "SEG, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Fujitsu": {
        "regex": "(?:F-01[FHJKLM]|F-02[EFGHLK]|F-03[DEFGKHL]|F-04[EGFHKJ]|F-05[DEFJG]|F-06[EF]|F-07[DE]|F-0[18]D|F-09[DE]|F-[45]1A|F-41B|F-[45]2A|F-1[012]D|F-12C|F-5[12]B|F-51E|M532|FARTM933KZ|901FJ|arrows(?:RX|M03|M0[45](?:-PREMIUM)?)|801FJ|FJL2[12]|RM02|FCG01|A101FC|BZ02|LIFEBOOK AH532)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F-51A(?:[);/ ]|$)",
                "model": "Arrows 5G F-51A"
            },
            {
                "regex": "F-01F(?:[);/ ]|$)",
                "model": "Arrows NX F-01F"
            },
            {
                "regex": "(F-01[LM]|F-06F|F-03K|F-42A)(?:[);/ ]|$)",
                "model": "Easy Phone $1"
            },
            {
                "regex": "F-03L(?:[);/ ]|$)",
                "model": "Arrows Phone F-03L"
            },
            {
                "regex": "F-01J(?:[);/ ]|$)",
                "model": "Arrows NX F-01J"
            },
            {
                "regex": "F-01K(?:[);/ ]|$)",
                "model": "Arrows NX F-01K"
            },
            {
                "regex": "F-01H(?:[);/ ]|$)",
                "model": "Arrows Fit F-01H"
            },
            {
                "regex": "F-02E(?:[);/ ]|$)",
                "model": "Arrows X F-02E"
            },
            {
                "regex": "F-02G(?:[);/ ]|$)",
                "model": "Arrows NX F-02G"
            },
            {
                "regex": "FJL21(?:[);/ ]|$)",
                "model": "Arrows EF FJL21"
            },
            {
                "regex": "FJL22(?:[);/ ]|$)",
                "model": "Arrows Z FJL22"
            },
            {
                "regex": "F-02H(?:[);/ ]|$)",
                "model": "Arrows NX F-02H"
            },
            {
                "regex": "F-52A(?:[);/ ]|$)",
                "model": "Arrows NX9 F-52A"
            },
            {
                "regex": "F-03D(?:[);/ ]|$)",
                "model": "Arrows Kiss F-03D"
            },
            {
                "regex": "F-03E(?:[);/ ]|$)",
                "model": "Arrows Kiss F-03E"
            },
            {
                "regex": "F-03F(?:[);/ ]|$)",
                "model": "Disney Mobile F-03F"
            },
            {
                "regex": "F-03H(?:[);/ ]|$)",
                "model": "Arrows SV F-03H"
            },
            {
                "regex": "901FJ(?:[);/ ]|$)",
                "model": "Arrows J 901FJ"
            },
            {
                "regex": "F-04E(?:[);/ ]|$)",
                "model": "Arrows V F-04E"
            },
            {
                "regex": "F-04G(?:[);/ ]|$)",
                "model": "Arrows NX F-04G"
            },
            {
                "regex": "F-05D(?:[);/ ]|$)",
                "model": "Arrows X LTE F-05D"
            },
            {
                "regex": "F-05F(?:[);/ ]|$)",
                "model": "Arrows NX F-05F"
            },
            {
                "regex": "F-05J(?:[);/ ]|$)",
                "model": "Arrows Be F-05J"
            },
            {
                "regex": "F-05G(?:[);/ ]|$)",
                "model": "Arrows K-tai"
            },
            {
                "regex": "F-04K(?:[);/ ]|$)",
                "model": "Arrows Be F-04K"
            },
            {
                "regex": "F-02L(?:[);/ ]|$)",
                "model": "Arrows Be 3 F-02L"
            },
            {
                "regex": "F-41A(?:[);/ ]|$)",
                "model": "Arrows Be 4 F-41A"
            },
            {
                "regex": "F-41B(?:[);/ ]|$)",
                "model": "Arrows Be 4 Plus F-41B"
            },
            {
                "regex": "F-06E(?:[);/ ]|$)",
                "model": "Arrows NX F-06E"
            },
            {
                "regex": "F-07D(?:[);/ ]|$)",
                "model": "Arrows \u03BC F-07D"
            },
            {
                "regex": "(?:F-51B|FCG01|A101FC)(?:[);/ ]|$)",
                "model": "Arrows We"
            },
            {
                "regex": "(F-51E)(?:[);/ ]|$)",
                "model": "Arrows We Plus $1"
            },
            {
                "regex": "801FJ(?:[);/ ]|$)",
                "model": "Arrows U 801FJ"
            },
            {
                "regex": "F-07E(?:[);/ ]|$)",
                "model": "Disney Mobile F-07E"
            },
            {
                "regex": "F-08D(?:[);/ ]|$)",
                "model": "Disney Mobile F-08D"
            },
            {
                "regex": "F-09D(?:[);/ ]|$)",
                "model": "ANTEPRIMA F-09D"
            },
            {
                "regex": "F-09E(?:[);/ ]|$)",
                "model": "Raku-Raku Smartphone Premium F-09E"
            },
            {
                "regex": "F-(52B|12D)(?:[);/ ]|$)",
                "model": "Raku-Raku Smartphone F-$1"
            },
            {
                "regex": "F-10D(?:[);/ ]|$)",
                "model": "Arrows X F-10D"
            },
            {
                "regex": "F-11D(?:[);/ ]|$)",
                "model": "Arrows Me F-11D"
            },
            {
                "regex": "F-12C(?:[);/ ]|$)",
                "model": "F-12C"
            },
            {
                "regex": "(F-04[JF])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "arrowsM03(?:[);/ ]|$)",
                "model": "Arrows M03"
            },
            {
                "regex": "RM02(?:[);/ ]|$)",
                "model": "Arrows RM02"
            },
            {
                "regex": "BZ02(?:[);/ ]|$)",
                "model": "Arrows BZ02"
            },
            {
                "regex": "arrowsRX(?:[);/ ]|$)",
                "model": "Arrows RX"
            },
            {
                "regex": "arrowsM04-PREMIUM(?:[);/ ]|$)",
                "model": "Arrows M04 Premium"
            },
            {
                "regex": "arrowsM(0[45])(?:[);/ ]|$)",
                "model": "Arrows M$1"
            },
            {
                "regex": "(F-0[32]F|F-03G|F-04H|F-05E|F-02K|F-01D)(?:[);/ ]|$)",
                "model": "Arrows Tab $1",
                "device": "tablet"
            },
            {
                "regex": "FARTM933KZ",
                "model": "Arrows Tab M504/HA4",
                "device": "tablet"
            },
            {
                "regex": "M532(?:[);/ ]|$)",
                "model": "Stylistic",
                "device": "tablet"
            },
            {
                "regex": "LIFEBOOK AH532",
                "model": "LifeBook AH532",
                "device": "desktop"
            }
        ]
    },
    "G-TiDE": {
        "regex": "G-TiDE|(?: EX10|EXTREME X9)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Shining7",
                "model": "Shining 7"
            },
            {
                "regex": "G-TiDE[_ ](A1|S[34]|E520|Vans [89]c?|V7s)",
                "model": "$1"
            },
            {
                "regex": "G-TiDE V6",
                "model": "V6"
            },
            {
                "regex": "EXTREME X9",
                "model": "Extreme X9"
            },
            {
                "regex": "EX10",
                "model": "EX10"
            },
            {
                "regex": "E(57|60|66|72|77)",
                "model": "$1"
            },
            {
                "regex": "G-TiDE[_ ](H1)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Gemini": {
        "regex": "(GEM[0-9]+[a-z]*)",
        "device": "tablet",
        "model": "$1"
    },
    "Geotel": {
        "regex": "GEOTEL[ _]?",
        "device": "smartphone",
        "models": [
            {
                "regex": "G1",
                "model": "G1"
            },
            {
                "regex": "GEOTEL[ _]?Note",
                "model": "Note"
            },
            {
                "regex": "GEOTEL[ _]AMIGO",
                "model": "Amigo"
            }
        ]
    },
    "Gigabyte": {
        "regex": "(?<!Singer \\dK |WALTON |Dawlance )GSmart[ _][a-z0-9 ]+(?: Build|\\))|Gigabyte-[a-z0-9]+|Simba SX1|Roma R2|Boston 4G|GSmart_Classic_Lite|(?<!Eagle )Classic[_ ](?:Joy|Pro)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Roma R2",
                "model": "GSmart Roma R2"
            },
            {
                "regex": "(GSmart[ _][a-z0-9 ]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Gigabyte-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(Classic[ _](?:Joy|Pro)|GSmart_Classic_Lite|Boston 4G)",
                "model": "$1"
            },
            {
                "regex": "Simba SX1",
                "model": "GSmart Simba SX1"
            }
        ]
    },
    "Gigaset": {
        "regex": "Gigaset|(?: GX290|GS80|GS1[0189]0|GS1[89]5|GS2[89]0|GS5[357]-6|GS[23]70(?:_Plus)?|E940-(?:2766|279[567]|2878|2849)-\\d{2})(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gigaset QV(1030|830)",
                "model": "Gigaset QV$1",
                "device": "tablet"
            },
            {
                "regex": "G(S[23]70)[_ ]Plus(?:[);/ ]|$)",
                "model": "G$1 Plus"
            },
            {
                "regex": "GS([23]70|1[0189]0|1[89]5|2[89]0|80)(?:[);/ ]|$)",
                "model": "GS$1"
            },
            {
                "regex": "(GX290)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GS57-6",
                "model": "ME Pro"
            },
            {
                "regex": "GS55-6",
                "model": "ME"
            },
            {
                "regex": "E940-2797-00",
                "model": "GX4"
            },
            {
                "regex": "E940-2797-01",
                "model": "GX4 Pro"
            },
            {
                "regex": "E940-2766-00",
                "model": "GS3"
            },
            {
                "regex": "E940-2795-00",
                "model": "GS4"
            },
            {
                "regex": "E940-2849-00",
                "model": "GX6"
            },
            {
                "regex": "E940-2849-01",
                "model": "GX6 Pro"
            },
            {
                "regex": "E940-2796-00",
                "model": "GS5"
            },
            {
                "regex": "E940-2878-03",
                "model": "GS5 Lite"
            },
            {
                "regex": "GS53-6",
                "model": "ME Pure"
            },
            {
                "regex": "Gigaset ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Gigaset ([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ginzzu": {
        "regex": "GINZZU[_ ]|((?:RS(?:7[14]|81|9[67])D)|S5002|(?<!Wave Pro )S5021|S5230|S50[45]0|S51[24]0|RS(6[12]|9[45])D|S40[23]0|RS850[12]|RS9602|GT-W170)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GINZZU[_ ]?(S40[17]0|S4710|ST60[14]0|ST6120)",
                "model": "$1"
            },
            {
                "regex": "(?:GINZZU[_ ]?)?(GT-(?:W170|1050|7105|70[1-4]0|7115|7210|[WX]831|X[78]70|7810|8[01]10|X853|X890))",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(RS6[12]D) ULTIMATE",
                "model": "$1 Ultimate"
            },
            {
                "regex": "(?:GINZZU[ _])?((?:RS(?:7[14]|81|9[14-7]|7)D)|S50[45]0|S5002|S5021|S5230|S51[24]0|S40[23]0|RS850[12]|RS9602|RS94D|R8 Dual)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Gionee": {
        "regex": "(?:GIO-)?GIONEE(?!_?Star)[ _-]?[a-z0-9]+|(?:Dream_D1|V188S?|GN(?!2200)[0-9]{3,4}[a-z]?)(?:[);/ ]|$)|F103(?: Pro)?(?: Build|\\))|P5 mini Build|(M7 Power|F106L|F100[AL]|F103S|F103 Pro|M6 mirror|20190620G|20190619G|20190418Q|GNP21M02|GNS2161B|GAU0820|Android 6(?:[\\d.]*);(?: [\\w-]+;)? (?:P8 Max|P7 Max)|Android 5(?:[\\d.]*);(?: [\\w-]+;)? M5 (?:mini|Plus)|Android 11(?:[\\d.]*);(?: [\\w-]+;)? P61|WBL7519|WBL7361|20190419Q|M5 lite CDMA|GLY1620|M2mini)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GNP21M02",
                "model": "M12 Pad Pro",
                "device": "tablet"
            },
            {
                "regex": "GN810(?:[);/ ]|$)",
                "model": "GN810",
                "device": "phablet"
            },
            {
                "regex": "GN8003L",
                "model": "M6L"
            },
            {
                "regex": "WBL7519",
                "model": "S6s"
            },
            {
                "regex": "WBL7361",
                "model": "M6 Lite"
            },
            {
                "regex": "GIONEE[_ ]MAX Pro",
                "model": "Max Pro"
            },
            {
                "regex": "20190619G",
                "model": "K3 Pro"
            },
            {
                "regex": "20190418Q",
                "model": "K6"
            },
            {
                "regex": "GN8003",
                "model": "M6"
            },
            {
                "regex": "GAU0820",
                "model": "K8 Pro"
            },
            {
                "regex": "GNS2161B",
                "model": "M18"
            },
            {
                "regex": "GN([0-9]{3,4}[a-z]?)(?:[);/ ]|$)",
                "model": "GN$1"
            },
            {
                "regex": "(F106L|F100[AL]|V188S|V188|F103S|F8 Neo)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M7 Power(?:[);/ ]|$)",
                "model": "M7 Power"
            },
            {
                "regex": "M5 Plus",
                "model": "M5 Plus"
            },
            {
                "regex": "M([25]) ?mini",
                "model": "M$1 Mini"
            },
            {
                "regex": "20190620G(?:[);/ ]|$)",
                "model": "M11"
            },
            {
                "regex": "P5 mini",
                "model": "P5 mini"
            },
            {
                "regex": "M5 lite CDMA",
                "model": "M5 Lite CDMA"
            },
            {
                "regex": "P7 Max",
                "model": "P7 Max"
            },
            {
                "regex": "P8 Max",
                "model": "P8 Max"
            },
            {
                "regex": "(S11|F205|S10) Lite(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "M6 mirror(?:[);/ ]|$)",
                "model": "M6 Mirror"
            },
            {
                "regex": "GLY1620",
                "model": "M50 Pro"
            },
            {
                "regex": "F9 Plus(?:[);/ ]|$)",
                "model": "F9 Plus"
            },
            {
                "regex": "20190419Q(?:[);/ ]|$)",
                "model": "F12 Pro"
            },
            {
                "regex": "F103( Pro)?( BUILD|\\))",
                "model": "F103$1"
            },
            {
                "regex": "(P61)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:(?:GIO-)?GIONEE[ _-])?Dream_D1(?:[);/ ]|$)",
                "model": "Dream D1"
            },
            {
                "regex": "(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+).*Android",
                "model": "$1"
            },
            {
                "regex": "Android.*(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+)[ _]Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "Android.*(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+)",
                "model": "$1"
            },
            {
                "regex": "(?:GIO-)?GIONEE[ _-]?([a-z0-9]+)",
                "model": "$1",
                "device": "feature phone"
            }
        ]
    },
    "Grape": {
        "regex": "(?:Grape[ _])?GTM[-_]5([^;)/]+)(?: Build|[;)])",
        "device": "smartphone",
        "model": "GTM-5$1"
    },
    "Vizio": {
        "regex": "Vizio|(?:VAP430|VTAB1008|XR6[PM]10)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "VAP430",
                "model": "VAP430"
            },
            {
                "regex": "ISV-B11",
                "model": "ISV-B11"
            },
            {
                "regex": "D50u-D1",
                "model": "D50u-D1"
            },
            {
                "regex": "VIZIO ([a-z0-9_-]+) ViziOS/",
                "model": "$1"
            },
            {
                "regex": "Model/([a-z0-9_-]+)\\)",
                "model": "$1"
            },
            {
                "regex": "Vizio, ([a-z0-9_-]+), (?:wired|wireless)",
                "model": "$1"
            },
            {
                "regex": "(VTAB1008|XR6[PM]10)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Timovi": {
        "regex": "Tmovi[ _]|(?:Infinit[ _](?:Lite[_ ]2|X[_ ]CAM)|Infinit (?:MX(?: Pro)?|2)|Vision_PRO|VISION ULTRA|Epix|Yeah_Go|Insignia Delta 2|Insignia_(?:Delta3|Lab))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tmovi[ _]Prime",
                "model": "Prime"
            },
            {
                "regex": "TMOVI_YEAH_BEAT",
                "model": "Yeah Beat"
            },
            {
                "regex": "YeahLIVE",
                "model": "Yeah LIVE"
            },
            {
                "regex": "Infinit[_ ]X[_ ]CAM",
                "model": "Infinit X Cam"
            },
            {
                "regex": "Infinit MX Pro",
                "model": "Infinit MX Pro"
            },
            {
                "regex": "Infinit MX",
                "model": "Infinit MX"
            },
            {
                "regex": "Infinit 2",
                "model": "Infinit 2"
            },
            {
                "regex": "Infinit[_ ]Lite([_ ]2)?",
                "model": "Infinit Lite$1"
            },
            {
                "regex": "Vision_PRO",
                "model": "Vision Pro"
            },
            {
                "regex": "VISION ULTRA",
                "model": "Vision Ultra"
            },
            {
                "regex": "Epix",
                "model": "Epix"
            },
            {
                "regex": "Yeah_Go",
                "model": "Yeah Go"
            },
            {
                "regex": "Insignia_(Lab)",
                "device": "tablet",
                "model": "Insignia $1"
            },
            {
                "regex": "Insignia[ _]Delta[ _]?([32])",
                "device": "tablet",
                "model": "Insignia Delta $1"
            }
        ]
    },
    "TIMvision": {
        "regex": "(?:TIMVISIONBOX|TIM_BOX)(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box"
    },
    "GOCLEVER": {
        "regex": "GOCLEVER|QUANTUM_(?:[235]_)?[0-9]{3}|QUANTUM [0-9]{1}|QUANTUM 700N|Quantum2 500|QUANTUM_(1010N|1010M|900|II_500_N)|ARIES|INSIGNIA|ORION_|ELIPSO|LIBRA[ _]97|TERRA_7o[WL]|(?:TQ700|ORION7oL)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "QUANTUM_(1010N|1010M|900)",
                "model": "QUANTUM $1",
                "device": "tablet"
            },
            {
                "regex": "INSIGNIA_(785_PRO|1010M|800M)",
                "model": "INSIGNIA $1",
                "device": "tablet"
            },
            {
                "regex": "(ORION|ARIES|ELIPSO)[_ ](71|101|102)",
                "model": "$1 $2",
                "device": "tablet"
            },
            {
                "regex": "TQ700N",
                "model": "QUANTUM 700N",
                "device": "tablet"
            },
            {
                "regex": "ORION7oL",
                "model": "ORION 70L",
                "device": "tablet"
            },
            {
                "regex": "TQ700(?:[);/ ]|$)",
                "model": "QUANTUM 700",
                "device": "tablet"
            },
            {
                "regex": "QUANTUM_1010_Lite",
                "model": "Quantum 1010 Lite",
                "device": "tablet"
            },
            {
                "regex": "QUANTUM_2_(1010|700|960)_Mobile",
                "model": "Quantum 2 $1 Mobile",
                "device": "tablet"
            },
            {
                "regex": "QUANTUM_([235])_(5[05]0)_RUGGED",
                "model": "Quantum $1 $2 Rugged"
            },
            {
                "regex": "QUANTUM_(\\d+)_RUGGED_PRO",
                "model": "Quantum $1 Rugged Pro"
            },
            {
                "regex": "QUANTUM[_ ]([235])_([45]00)[_ ]LITE",
                "model": "Quantum $1 $2 Lite"
            },
            {
                "regex": "QUANTUM_II_500_N",
                "model": "Quantum 2 500 N"
            },
            {
                "regex": "QUANTUM[_ ]([45]00)[_ ]LITE",
                "model": "Quantum $1 Lite"
            },
            {
                "regex": "QUANTUM[ _]?([235])[ _]([^;/]+)(?: Build|[);])",
                "model": "Quantum $1 $2"
            },
            {
                "regex": "((?:QUANTUM|ARIES|INSIGNIA|ORION|ELIPSO)[ _-]?[^;/]+)(?: Build|\\))",
                "model": "$1"
            },
            {
                "regex": "NETBOOK R103",
                "device": "desktop",
                "model": "Netbook R103"
            },
            {
                "regex": "TERRA_(7o[WL])",
                "model": "Terra $1",
                "device": "tablet"
            },
            {
                "regex": "GOCLEVER[ _-]TAB[ _-]?([^;/]+) Build",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "GOCLEVER[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "TAB ([^;/)]+) Build/GOCLEVER",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "([^;/)]+) Build/GOCLEVER",
                "model": "$1"
            },
            {
                "regex": "GOCLEVER[ _-]?TAB[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "GOCLEVER[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "LIBRA[ _]97",
                "model": "Libra 97",
                "device": "tablet"
            }
        ]
    },
    "GOtv": {
        "regex": "(SEI600GO|GO700FR)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "GoMobile": {
        "regex": "GO Onyx|GO[0-9]{3,4}",
        "device": "smartphone",
        "models": [
            {
                "regex": "GO Onyx Plus",
                "model": "GO Onyx Plus"
            },
            {
                "regex": "GO Onyx mini",
                "model": "Go Onyx Mini"
            },
            {
                "regex": "GO Onyx HD",
                "model": "Go Onyx HD"
            },
            {
                "regex": "GO Onyx",
                "model": "Go Onyx"
            },
            {
                "regex": "GO([0-9]{3,4})",
                "model": "Go$1"
            }
        ]
    },
    "Explay": {
        "regex": "Explay|[\\w]+-EXPLAY-FIN|ActiveD[ _]|Atlant |Informer[ _][0-9]+|CinemaTV 3G|Surfer[ _][0-9.]|Surfer7773G|sQuad[ _][0-9.]|Onliner[1-4]|RioPlay|Leader|Pulsar|Infinityll|Joy_TV|Imperium[78]|Winner[78]|Indigo|Lagoon|Tornado(?! 348| Slim|,)(?:3G)?|Onyx(?!_[A-Z]{1,2})(?:[);/ ]|$)|android 4([\\d.]*);(?: [\\w-]+;)? Discovery.+(?<! Mobile )Safari/|Party|Scream 3G|A350 TV",
        "device": "tablet",
        "models": [
            {
                "regex": "ActiveD[ _]7\\.4[ _]3G",
                "model": "ActiveD 7.4 3G"
            },
            {
                "regex": "Scream 3G",
                "model": "Scream 3G"
            },
            {
                "regex": "Tornado 8",
                "model": "Tornado 8"
            },
            {
                "regex": "Imperium([78])(?:[);/ ]|$)",
                "model": "Imperium $1 3G"
            },
            {
                "regex": "ActiveD[ _]8\\.2[ _]3G",
                "model": "ActiveD 8.2 3G"
            },
            {
                "regex": "CinemaTV[ _]3G",
                "model": "CinemaTV 3G"
            },
            {
                "regex": "Infinityll",
                "model": "Infinity II"
            },
            {
                "regex": "Informer[ _]([0-9]+(?:[ _]3G)?)",
                "model": "Informer $1"
            },
            {
                "regex": "Surfer[ _]([0-9.]+(?:[ _]3G)?)",
                "model": "Surfer $1"
            },
            {
                "regex": "Surfer([0-9.]+)[ _]?3G",
                "model": "Surfer $1 3G"
            },
            {
                "regex": "sQuad[ _]([0-9.]+(?:[ _]3G)?)",
                "model": "sQuad $1"
            },
            {
                "regex": "Onliner([1-4])",
                "model": "Onliner $1"
            },
            {
                "regex": "Winner([78])",
                "model": "Winner $1"
            },
            {
                "regex": "Discovery(?:[);/ ]|$)",
                "model": "Discovery"
            },
            {
                "regex": "Atlant(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Atlant"
            },
            {
                "regex": "Indigo(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Indigo"
            },
            {
                "regex": "Pulsar(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Pulsar"
            },
            {
                "regex": "Tornado(?:3G)?(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Tornado 3G"
            },
            {
                "regex": "Onyx(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Onyx"
            },
            {
                "regex": "Fresh(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Fresh"
            },
            {
                "regex": "Joy_TV(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "JoyTV"
            },
            {
                "regex": "[\\w]+-EXPLAY-FIN",
                "device": "feature phone",
                "model": "Fin"
            },
            {
                "regex": "Lagoon(?:[);/ ]|$)",
                "model": "Lagoon"
            },
            {
                "regex": "A350 TV(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "A350TV"
            },
            {
                "regex": "Party(?:[);/ ]|$)",
                "model": "Party"
            },
            {
                "regex": "Explay[ _-]([^;/]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "RioPlay(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Rio Play"
            },
            {
                "regex": "Leader",
                "model": "Leader"
            }
        ]
    },
    "General Mobile": {
        "regex": "General_Mobile_|GM 5 Plus|GM8 go|GM[ _][568][ _]d|GM [86]|General Mobile 4G|GM6_Tur|GM 9 (?:Pro|Plus)|(?: GM 5|e-tab 20|Android 1[012](?:\\.[\\d.]+)?;(?: [\\w-]+;)? (?:G[35]01|G[35]10|G702|(?<!Huawei )G700)|Discovery(?![_ ]XT) (?:Air|Elite(?: Plus)?)|GM Discovery II|GM Discovery tab 8|Discovery II Mini| GM6|G300|G008|android 4([\\d.]*);(?: [\\w-]+;)? Discovery|e-?tab5|G51[24]|G31[246]|G901|(?<!Symphony) G100|G518|G318)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GM 5 Plus",
                "model": "GM 5 Plus"
            },
            {
                "regex": "G518",
                "model": "GM Era 30"
            },
            {
                "regex": "G318",
                "model": "GM Era 50"
            },
            {
                "regex": "G300",
                "model": "GM 10"
            },
            {
                "regex": "G310",
                "model": "GM 21"
            },
            {
                "regex": "G510",
                "model": "GM 21 Plus"
            },
            {
                "regex": "G312",
                "model": "GM 22"
            },
            {
                "regex": "G316",
                "model": "GM 23"
            },
            {
                "regex": "G314",
                "model": "GM 23 SE"
            },
            {
                "regex": "G512",
                "model": "GM 22 Plus"
            },
            {
                "regex": "G702",
                "model": "GM 22 Pro"
            },
            {
                "regex": "G700",
                "model": "GM 21 Pro"
            },
            {
                "regex": "G301",
                "model": "GM 20"
            },
            {
                "regex": "G501",
                "model": "GM 20 Pro"
            },
            {
                "regex": "G514",
                "model": "GM 24 Pro"
            },
            {
                "regex": "GM[ _](\\d+)[ _]d",
                "model": "GM $1D"
            },
            {
                "regex": "GM6_Tur|GM ?6",
                "model": "GM 6"
            },
            {
                "regex": "GM ([58])",
                "model": "GM $1"
            },
            {
                "regex": "GM8 go",
                "model": "GM 8 Go"
            },
            {
                "regex": "G008",
                "model": "GM 9 Go"
            },
            {
                "regex": "GM 9 Pro",
                "model": "GM 9 Pro"
            },
            {
                "regex": "G901",
                "model": "GM Phoenix 5G"
            },
            {
                "regex": "GM 9 Plus",
                "model": "GM 9 Plus"
            },
            {
                "regex": "G100",
                "model": "GM 6 DS"
            },
            {
                "regex": "Discovery (Air|Elite(?: Plus)?)",
                "model": "Discovery $1"
            },
            {
                "regex": "Discovery II Mini",
                "model": "Discovery II Mini"
            },
            {
                "regex": "GM Discovery II",
                "model": "GM Discovery II"
            },
            {
                "regex": "GM Discovery tab 8",
                "device": "tablet",
                "model": "Discovery Tab 8"
            },
            {
                "regex": "Discovery(?:[);/ ]|$)",
                "model": "Discovery"
            },
            {
                "regex": "General[ _]Mobile[ _]4G[ _]Dual",
                "model": "4G Dual"
            },
            {
                "regex": "General Mobile 4G",
                "model": "4G"
            },
            {
                "regex": "e-?tab ?(\\d+)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "E-Tab $1"
            }
        ]
    },
    "Gol Mobile": {
        "regex": "(?:F10_PRIME|F3Prime|F9_PLUS|TEAM_7_3G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F10_PRIME",
                "model": "F10 Prime"
            },
            {
                "regex": "F3Prime",
                "model": "F3 Prime"
            },
            {
                "regex": "F9_PLUS",
                "model": "F9 Plus"
            },
            {
                "regex": "TEAM_7_3G",
                "device": "tablet",
                "model": "Team 7.0 3G"
            }
        ]
    },
    "Goly": {
        "regex": "Goly[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Goly[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Goly[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Google": {
        "regex": "Nexus(?! 6P)|GoogleTV|Google Fiber|Google Pixel|Glass(?<!Browser)|CrKey[^a-z0-9]|(?:Pixel|sailfish|taimen|blueline|Chromecast(?: HD)?)(?:;? Build|[)])|Pixel (?:XL|9 Pro(?: XL)?|C|[2-9]|[2-4] XL|10|Fold|Tablet)|Google 2XL|PIXEL4X|G011A|AOSP on (?:bramble|HammerHead|Manta|sunfish)|Pipit|ADT-2|GE2AE|G0DZQ|GZPFO|G1MNW|G82U8|G9BQD|G6QU3|GO3Z5|G025[IJENH]|G020[ABCGHEMPI]|G9FPL|GWKK3|GWVK6|GR83Y|GKV4X|GUR25|GP4BC|G4S1M|GKWS6|GHL1X|G1F8F|G01[13]C|G013A|GC3VE|GB7N6|GD1YQ|GTT9Q|GVU6C|GA02099|GA01180-US|G5NZ6|GQML3|G8VOU|GGH2X|GEC77|GC15S|G8HHN|GFE4J|G576D|G2YBB|G1B60|GA04851-US|GPJ41",
        "device": "smartphone",
        "models": [
            {
                "regex": "Glass 1",
                "device": "wearable",
                "model": "Glass 1"
            },
            {
                "regex": "Galaxy Nexus",
                "model": "Galaxy Nexus"
            },
            {
                "regex": "AOSP on HammerHead",
                "model": "Nexus 5"
            },
            {
                "regex": "(Nexus (?:2|S|4|5X?|One))",
                "model": "$1"
            },
            {
                "regex": "(Nexus (?:6P?))",
                "device": "phablet",
                "model": "$1"
            },
            {
                "regex": "(Nexus (?:7|9|10))",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "AOSP on Manta",
                "device": "tablet",
                "model": "Nexus 10"
            },
            {
                "regex": "Pixel Slate",
                "device": "tablet",
                "model": "Pixel Slate"
            },
            {
                "regex": "(GFHD[12]00)",
                "device": "tv",
                "model": "Fiber $1"
            },
            {
                "regex": "CrKey/[0-9.]+ DeviceType/SmartSpeaker",
                "model": "Chromecast",
                "device": "smart speaker"
            },
            {
                "regex": "CrKey[^a-z0-9]",
                "model": "Chromecast",
                "device": "tv"
            },
            {
                "regex": "Chromecast HD",
                "model": "Chromecast HD (2022)",
                "device": "tv"
            },
            {
                "regex": "Chromecast",
                "model": "Chromecast (2020)",
                "device": "tv"
            },
            {
                "regex": "GoogleTV",
                "device": "tv",
                "model": "GoogleTV"
            },
            {
                "regex": "(?:Pixel|sailfish)(?: Build|[)])",
                "model": "Pixel"
            },
            {
                "regex": "Pixel XL",
                "model": "Pixel XL"
            },
            {
                "regex": "blueline|G013A",
                "model": "Pixel 3"
            },
            {
                "regex": "G020[AEHF]",
                "model": "Pixel 3a"
            },
            {
                "regex": "Pixel 9 Pro XL|GGX8B|GQ57S|GZC4K",
                "model": "Pixel 9 Pro XL"
            },
            {
                "regex": "Pixel 3 XL|G013C",
                "model": "Pixel 3 XL"
            },
            {
                "regex": "Pixel 2 XL|taimen",
                "model": "Pixel 2 XL"
            },
            {
                "regex": "Pixel 3a XL|G020[BCG]",
                "model": "Pixel 3a XL"
            },
            {
                "regex": "Pixel 4 XL|GA01180-US|G020P",
                "model": "Pixel 4 XL"
            },
            {
                "regex": "G020[MI]",
                "model": "Pixel 4"
            },
            {
                "regex": "PIXEL4X",
                "model": "Pixel 4 X"
            },
            {
                "regex": "AOSP on sunfish|G025[JNH]|GA02099",
                "model": "Pixel 4a"
            },
            {
                "regex": "Pixel 4a \\(?5G\\)?|AOSP on bramble|G025[IE]|G6QU3",
                "model": "Pixel 4a (5G)"
            },
            {
                "regex": "pixel ([3-9])a",
                "model": "Pixel $1a"
            },
            {
                "regex": "G1F8F|G4S1M",
                "model": "Pixel 5a 5G"
            },
            {
                "regex": "G011A",
                "model": "Pixel 2"
            },
            {
                "regex": "GE2AE|GP4BC|GFE4J",
                "model": "Pixel 7 Pro"
            },
            {
                "regex": "GO3Z5|GQML3|GVU6C",
                "model": "Pixel 7"
            },
            {
                "regex": "GTT9Q|GD1YQ|G5NZ6",
                "model": "Pixel 5"
            },
            {
                "regex": "G1MNW|GC3VE|GE9DP",
                "model": "Pixel 8 Pro"
            },
            {
                "regex": "G9BQD|GPJ41|GKWS6|GZPFO|GA04851-US",
                "model": "Pixel 8"
            },
            {
                "regex": "GKV4X|G8HHN|G576D|G6GPR|G576D",
                "model": "Pixel 8a"
            },
            {
                "regex": "GPJ41",
                "model": "Pixel 8"
            },
            {
                "regex": "G0DZQ|G82U8|GWKK3|GHL1X",
                "model": "Pixel 7a"
            },
            {
                "regex": "G8VOU",
                "model": "Pixel 6 Pro"
            },
            {
                "regex": "GB7N6",
                "model": "Pixel 6"
            },
            {
                "regex": "Google 2XL|G011C",
                "model": "Pixel 2 XL"
            },
            {
                "regex": "Pixel 10 Pro XL",
                "model": "Pixel 10 Pro XL"
            },
            {
                "regex": "GUR25|G2YBB|G1B60",
                "model": "Pixel 9"
            },
            {
                "regex": "GWVK6|GR83Y|GEC77",
                "model": "Pixel 9 Pro"
            },
            {
                "regex": "Pixel 9 Pro Fold|GGH2X|GC15S",
                "device": "phablet",
                "model": "Pixel 9 Pro Fold"
            },
            {
                "regex": "Pixel 10 Pro Fold",
                "device": "phablet",
                "model": "Pixel 10 Pro Fold"
            },
            {
                "regex": "Pixel ([6789]|10) Pro",
                "model": "Pixel $1 Pro"
            },
            {
                "regex": "pixel ([2-9]|10)",
                "model": "Pixel $1"
            },
            {
                "regex": "Pipit",
                "device": "phablet",
                "model": "Pipit"
            },
            {
                "regex": "G9FPL|Pixel Fold",
                "device": "phablet",
                "model": "Pixel Fold"
            },
            {
                "regex": "Pixel C",
                "device": "tablet",
                "model": "Pixel C"
            },
            {
                "regex": "Pixel Tablet 2",
                "device": "tablet",
                "model": "Pixel Tablet 2"
            },
            {
                "regex": "Pixel Tablet",
                "device": "tablet",
                "model": "Pixel Tablet"
            },
            {
                "regex": "Pixelbook Go",
                "device": "desktop",
                "model": "Pixelbook Go"
            },
            {
                "regex": "Pixelbook",
                "device": "tablet",
                "model": "Pixelbook"
            },
            {
                "regex": "ADT-2",
                "device": "tv",
                "model": "ADT-2"
            },
            {
                "regex": "Nexus Player",
                "device": "tv",
                "model": "Nexus Player"
            }
        ]
    },
    "Gradiente": {
        "regex": "GRADIENTE",
        "device": "feature phone",
        "models": [
            {
                "regex": "GRADIENTE-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "GRADIENTE ([a-z0-9-]+)",
                "model": "$1"
            }
        ]
    },
    "Graetz": {
        "regex": "GRAETZ[;,]",
        "device": "tv",
        "model": ""
    },
    "Gr\xfcnberg": {
        "regex": "(GR(?:32200|43200))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Grundig": {
        "regex": "GR?-TB[0-9]+[a-z]*|(?<!Arcelik )GRUNDIG|portalmmm/2\\.0 G|AFTEU(?:011|014|FF014)",
        "device": "tv",
        "models": [
            {
                "regex": "(GR?-TB[0-9]+[a-z]*)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "GRUNDIG (?:Android TV|Google TV UHD\\+)",
                "model": "Smart TV"
            },
            {
                "regex": "GRUNDIG ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2\\.0 G([a-z0-9]+)",
                "model": "G$1"
            },
            {
                "regex": "AFTEU014",
                "model": "Vision 7 4K (2019)"
            },
            {
                "regex": "AFTEUFF014",
                "model": "OLED 4K (2019)"
            },
            {
                "regex": "AFTEU011",
                "model": "Vision 6 HD (2019)"
            }
        ]
    },
    "Gtel": {
        "regex": "Gtel[ _]|A727_Infinity_Pro(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A727_Infinity_Pro",
                "model": "A727 Infinity Pro"
            },
            {
                "regex": "Infinity 8s(?:[);/ ]|$)",
                "model": "Infinity 8s"
            },
            {
                "regex": "Infinity 9(?:[);/ ]|$)",
                "model": "Infinity 9"
            },
            {
                "regex": "Gtel[ _-]X(\\d) ?plus(?:[);/ ]|$)",
                "model": "X$1 Plus"
            },
            {
                "regex": "Gtel[ _-]X(\\d) ?mini(?:[);/ ]|$)",
                "model": "X$1 Mini"
            },
            {
                "regex": "Gtel[ _-]([^;/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "H133": {
        "regex": "Betacrux(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Betacrux(?:[);/ ]|$)",
                "model": "Betacrux"
            }
        ]
    },
    "H96": {
        "regex": "H96[ _]?(?:Max|mini H8|plus|PRO\\+)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:H96[_ ]?)?Max[ _]RK(\\d{4})(?:[);/ ]|$)",
                "model": "Max RK$1"
            },
            {
                "regex": "Max X2(?:[);/ ]|$)",
                "model": "Max X2"
            },
            {
                "regex": "H96[_ ]Max[ _]V11(?:[);/ ]|$)",
                "model": "Max V11"
            },
            {
                "regex": "Max(?:[);/ ]|$)",
                "model": "Max"
            },
            {
                "regex": "mini H8(?:[);/ ]|$)",
                "model": "Mini H8"
            },
            {
                "regex": "H96plus(?:[);/ ]|$)",
                "model": "Plus"
            },
            {
                "regex": "PRO\\+(?:[);/ ]|$)",
                "model": "Pro+"
            }
        ]
    },
    "Hafury": {
        "regex": "HAFURY|(?:GT20|MEET)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GT20(?:[);/ ]|$)",
                "model": "GT20"
            },
            {
                "regex": "(MIX|UMAX|MEET)",
                "model": "$1"
            }
        ]
    },
    "HEC": {
        "regex": "50SSD-SMART TV-R1",
        "device": "tv",
        "model": "R1 50S 4K"
    },
    "Haier": {
        "regex": "Haier|(?:M53-52401|I6_Infinity|Titan[ _]T[135]|(?:HW-)?W(?:71[67]|757|86[07]|970)|S5 Silk|(?:HM-)?(N505|N700|G(?:152|303|353|552|70[01])?-FL|HM-(?:I559|N50[15]|I560|G553|N70[01])-FL|HR-V101|G(?:303)?-W|I(?:557)?-FL)|(?:PAD[ _](?:D71|G781|d85))|A2_Lite_NFC|A4_Lite|HL810G|Andromax C46B2H|OLED TV S9|MINTAKA|android 8([\\d.]*);(?: [\\w-]+;)? E13)(?:[);/ ]|$)|Android [67](?:[\\d.]*);(?: [\\w-]+;)? P2(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "A2_Lite_NFC",
                "model": "Alpha A2 Lite NFC"
            },
            {
                "regex": "A4_Lite",
                "model": "Alpha A4 Lite"
            },
            {
                "regex": "HM-N505-FL",
                "model": "I8"
            },
            {
                "regex": "S5 Silk",
                "model": "S5 Silk"
            },
            {
                "regex": "E13(?:[);/ ]|$)",
                "model": "Elegance E13"
            },
            {
                "regex": "HM-N700-FL",
                "model": "L7"
            },
            {
                "regex": "HM-N701-FL",
                "model": "L8"
            },
            {
                "regex": "HM-N501-FL",
                "model": "L56"
            },
            {
                "regex": "HM-I559-FL",
                "model": "L55s"
            },
            {
                "regex": "HM-I560-FL",
                "model": "G7s"
            },
            {
                "regex": "HM-G553-FL",
                "model": "G51"
            },
            {
                "regex": "P2(?: Build|[;)])",
                "model": "P2"
            },
            {
                "regex": "Andromax C46B2H",
                "model": "Andromax EC"
            },
            {
                "regex": "(?:HM-)?(G(?:152|353|552|70[01])|G(?:303)|I(?:557))",
                "model": "$1"
            },
            {
                "regex": "(Titan[_ ]T[135]|I6_Infinity)",
                "model": "$1"
            },
            {
                "regex": "(?:HW-)?W(71[67]|757|86[07]|970)(?:[);/ ]|$)",
                "model": "W$1"
            },
            {
                "regex": "MINTAKA(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Mintaka"
            },
            {
                "regex": "PAD[ -_](D71|G781|d85)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(HL810G|HR-V101|M53-52401)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Haier MatrixTV AEL(?:[);/ ]|$)",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "haierATVnippori",
                "device": "tv",
                "model": "2K Android TV"
            },
            {
                "regex": "haierATV",
                "device": "tv",
                "model": "Android TV"
            },
            {
                "regex": "OLED TV S9",
                "device": "tv",
                "model": "OLED TV S9"
            },
            {
                "regex": "haier Android TV DVB2K",
                "device": "tv",
                "model": "Android TV DVB2K"
            },
            {
                "regex": "Android TV FF Pro",
                "device": "tv",
                "model": "Android TV FF Pro"
            },
            {
                "regex": "Haier[ _-](H[WT]-[^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Haier[ _-](H[WT]-[a-z0-9_-]+)",
                "model": "$1"
            },
            {
                "regex": "Haier[ _-](sy[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Haier[ _-]([a-z0-9-]+)",
                "model": "$1",
                "device": "feature phone"
            }
        ]
    },
    "HannSpree": {
        "regex": "(HSG[0-9]{4})|SN97T41W|SN1AT71W\\(B\\)|SN70T51A|SN70T31?|T7-QC",
        "device": "tablet",
        "models": [
            {
                "regex": "(HSG[0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "SN1AT71W\\(B\\)",
                "model": "SN1AT71W(B)"
            },
            {
                "regex": "SN70T31",
                "model": "SN70T31"
            },
            {
                "regex": "SN70T3",
                "model": "SN70T3"
            },
            {
                "regex": "SN70T51A",
                "model": "SN70T51A"
            },
            {
                "regex": "SN97T41W",
                "model": "SN97T41W"
            },
            {
                "regex": "T7-QC",
                "model": "SNAT71BUE"
            }
        ]
    },
    "Hasee": {
        "regex": "Hasee",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hasee ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Hasee ([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Toshiba": {
        "regex": "Toshiba|TSBNetTV/|portalmmm/[12]\\.0 TS|(?:T-01C|T-0[12]D|IS04|IS11T|AT1S0|AT300SE|AFT6E0FA|AFTBOXE1|AFTDCT31|AFTHA00[2-4]|AT(?:7-C|10-A|10[PL]E-A|100|200|270|300|330|374|400|470|500a?|503|570|703|830)|AFTKMST12|AFTBAMR311|SATELLITE (?:C655|L50-C|Pro L300|A100))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "T-01C",
                "model": "Regza T-01C"
            },
            {
                "regex": "T-01D",
                "model": "Regza T-01D"
            },
            {
                "regex": "T-02D",
                "model": "Regza T-02D"
            },
            {
                "regex": "IS04",
                "model": "Regza IS04"
            },
            {
                "regex": "IS11T",
                "model": "Regza IS11T"
            },
            {
                "regex": "AT7-C",
                "model": "Excite",
                "device": "tablet"
            },
            {
                "regex": "AT1S0",
                "model": "Regza AT1S0",
                "device": "tablet"
            },
            {
                "regex": "AT300SE",
                "model": "Regza AT300SE",
                "device": "tablet"
            },
            {
                "regex": "AT500a",
                "model": "Regza AT500a",
                "device": "tablet"
            },
            {
                "regex": "AT(100|200|270|300|330|374|400|470|500|503|570|703|830)",
                "model": "Regza AT$1",
                "device": "tablet"
            },
            {
                "regex": "AT10([PL])E-A",
                "model": "Excite AT10$1-A",
                "device": "tablet"
            },
            {
                "regex": "AT10-A",
                "model": "Excite AT10-A",
                "device": "tablet"
            },
            {
                "regex": "SATELLITE L50-C",
                "device": "desktop",
                "model": "Satellite L50C"
            },
            {
                "regex": "SATELLITE (C655|Pro L300|A100)",
                "device": "desktop",
                "model": "Satellite $1"
            },
            {
                "regex": "AFT6E0FA(?:[);/ ]|$)",
                "device": "tv",
                "model": "32WF2F53DB"
            },
            {
                "regex": "AFTBOXE1(?:[);/ ]|$)",
                "device": "tv",
                "model": "65UF3D63DA"
            },
            {
                "regex": "AFTKMST12",
                "device": "tv",
                "model": "43LF711U20"
            },
            {
                "regex": "AFTDCT31",
                "device": "tv",
                "model": "4K UHD (2020)"
            },
            {
                "regex": "AFTBAMR311",
                "device": "tv",
                "model": "43LF421U19"
            },
            {
                "regex": "AFTHA002(?:[);/ ]|$)",
                "device": "tv",
                "model": "V35 Series (2021)"
            },
            {
                "regex": "AFTHA003(?:[);/ ]|$)",
                "device": "tv",
                "model": "Fire TV 4K (2021)"
            },
            {
                "regex": "AFTHA004(?:[);/ ]|$)",
                "device": "tv",
                "model": "Fire TV 4K (2022)"
            },
            {
                "regex": "TOSHIBA;SmartTV;([a-z0-9_ -]+);",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "TOSHIBA, ([a-z0-9_ -]+), (?:wired|wireless)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "TSBNetTV/",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "Toshiba[ /_\\-]?([a-z0-9_ -]+) Build",
                "model": "$1"
            },
            {
                "regex": "Toshiba[ /_\\-]?([a-z0-9_-]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/[12]\\.0 (TS[a-z0-9 ]+)",
                "model": "$1"
            }
        ]
    },
    "AWOX": {
        "regex": "(?:AWOX|B213[29]00SW)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "AWOX;SmartTV;([a-z0-9_ -]+);",
                "model": "$1"
            },
            {
                "regex": "(B213[29]00SW)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "UD": {
        "regex": "TV3[45]8_?(?:DVB|ISDB)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "TV348_DVB(?:[);/ ]|$)",
                "model": "TV348 DVB"
            },
            {
                "regex": "TV348_ISDB(?:[);/ ]|$)",
                "model": "TV348 ISDB"
            },
            {
                "regex": "TV358DVB(?:[);/ ]|$)",
                "model": "TV358 DVB"
            }
        ]
    },
    "UGINE": {
        "regex": "UGINE(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "UGINE;SmartTV;([a-z0-9_ -]+)V[ST];",
                "model": "$1"
            }
        ]
    },
    "Sunny": {
        "regex": "LGE; SNY?[0-9]{2}[0-9a-z]+(?:-[0-9]+)?;|(?:SS4G9 Mira|SS4G7 Sole|SS4G1 Luna|SS4G8 Nora|SS4G6 Lola|SN7014S?|SN7016|SN10016|SN01DNGL300|SUNNY ?(?:SS01|S52D|SN55UAL253-?)|SUNNY;SmartTV)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(SS4G9 Mira|SS4G7 Sole|SS4G1 Luna|SS4G8 Nora|SS4G6 Lola)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SUNNY (SS01|S52D)",
                "model": "$1"
            },
            {
                "regex": "(SN7014S?|SN7016|SN10016)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "SUNNY;SmartTV",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "SN01DNGL300(?:[);/ ]|$)",
                "device": "tv",
                "model": "Prime TV Stick"
            },
            {
                "regex": "(?:SUNNY[_ ]?)?(SN55UAL253)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "LGE; (SNY?[0-9]{2}[0-9a-z]+)(?:-[0-9]+)?;",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Qilive": {
        "regex": "Qilive [0-9][^;/]*|QILIVE|Q(7S5[5]?IN4G|T19101|T22101B|T23109BP|T21101|7T10INP|T19101HV|8T10IN|8S55IN4G2|8S[56]IN4G|9T9IN|9T(?:7|10)IN4G|9S55IN4G|10S5[37]IN4G|10S[56]IN4G|10S[56]IN4GR|9S5IN4G|6T7IN|T2108BP)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Q7S5IN4G",
                "model": "Q7 5.0\" 4G"
            },
            {
                "regex": "Q7S55IN4G",
                "model": "Q7 5.5\" 4G"
            },
            {
                "regex": "Q8S55IN4G2",
                "model": "Q8 5.5\" 4G"
            },
            {
                "regex": "Q8S6IN4G",
                "model": "Q8 6.0\" 4G"
            },
            {
                "regex": "Q8S5IN4GP",
                "model": "Q8 5.1\" 4G"
            },
            {
                "regex": "Q9S5IN4G",
                "model": "Q9 5.0\" 4G"
            },
            {
                "regex": "Q9S55IN4G",
                "model": "Q9 5.5\" 4G"
            },
            {
                "regex": "Q10S53IN4G",
                "model": "Q10 5.3\" 4G"
            },
            {
                "regex": "Q10S57IN4G",
                "model": "Q10 5.7\" 4G"
            },
            {
                "regex": "Q10S5IN4G[R]?",
                "model": "Q10 5.0\" 4G"
            },
            {
                "regex": "Q10S6IN4G",
                "model": "Q10 6.0\" 4G"
            },
            {
                "regex": "Q6T7IN",
                "model": "Q6",
                "device": "tablet"
            },
            {
                "regex": "Q7T10INP",
                "model": "Q7 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "Q8T10IN",
                "model": "Q8 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "Q9T7IN4G",
                "model": "Q9 7.0\" 4G",
                "device": "tablet"
            },
            {
                "regex": "Q9T9IN",
                "model": "Q9 9.0\"",
                "device": "tablet"
            },
            {
                "regex": "Q9T10IN4G",
                "model": "Q9 10.1\" 4G",
                "device": "tablet"
            },
            {
                "regex": "(QT19101HV|QT19101|QT23109BP|QT22101B)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "QT21101",
                "model": "Q1-21",
                "device": "tablet"
            },
            {
                "regex": "QT2108BP",
                "model": "Q4-21",
                "device": "tablet"
            },
            {
                "regex": "Qilive (1\\d+[^;/)]*)(?: Build|[;)])",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Qilive ([0-5][^;/)]*)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Qilive ([0-5]*)/",
                "model": "$1"
            },
            {
                "regex": "97R-2",
                "model": "97R2",
                "device": "tablet"
            },
            {
                "regex": "Qilive ([6-9][^;/)]*)(?: Build|[;)])",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "QILIVE[; ]Smart ?TV",
                "model": "Smart TV",
                "device": "tv"
            }
        ]
    },
    "JVC": {
        "regex": "JVC[;, ]|JVC-CVTE|AV-10NT310|(?:smarttv_)?(?:AFTSO001|AFTJULI1|AFTWMST22|LT-98N7125)",
        "device": "tv",
        "models": [
            {
                "regex": "JVC[;,](32D1290)",
                "model": "$1"
            },
            {
                "regex": "(?:smarttv_)?AFTSO001",
                "model": "Fire TV 4K (2019)"
            },
            {
                "regex": "(?:smarttv_)?AFTJULI1",
                "model": "Fire TV 4K (2021)"
            },
            {
                "regex": "(?:smarttv_)?AFTWMST22",
                "model": "Fire TV 2K (2020)"
            },
            {
                "regex": "(LT-98N7125)",
                "model": "$1"
            },
            {
                "regex": "JVC, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": "",
                "device": "tv"
            },
            {
                "regex": "JVC-CVTE;SmartTV|JVC Android TV",
                "model": "Smart TV",
                "device": "tv"
            },
            {
                "regex": "(AV-10NT310)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Loewe": {
        "regex": "LOEWE[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "48A81FEVS",
                "model": "48A81FEVS"
            }
        ]
    },
    "LongTV": {
        "regex": "LongTV",
        "device": "tv",
        "models": [
            {
                "regex": "LongTV LOUiE(?:[);/ ]|$)",
                "model": "LOUiE"
            }
        ]
    },
    "Majestic": {
        "regex": "MAJESTIC[;, _-]|CRONO ?[0-9]+|(?:TAB (?:647|411) 3G|TAB_(?:81[12]|912|918_PRO)_4G|TAB_911_3G|TAB-714|TAB_814|TAB (711 4G|747 3G|[56]11 3G)|URANO27|URANO 47|URANO 77LTE|PLUTO__?26N?|JACK| JOE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "JACK(?:[);/ ]|$)",
                "model": "Jack"
            },
            {
                "regex": "JOE(?:[);/ ]|$)",
                "model": "Joe"
            },
            {
                "regex": "URANO 77LTE(?:[);/ ]|$)",
                "model": "Urano 77 LTE"
            },
            {
                "regex": "URANO ?([24]7)(?:[);/ ]|$)",
                "model": "Urano $1"
            },
            {
                "regex": "PLUTO__?(26N?)(?:[);/ ]|$)",
                "model": "Pluto $1"
            },
            {
                "regex": "TAB[ _](\\d{3})[ _]PRO_([34])G",
                "model": "Tab $1 Pro $2G",
                "device": "tablet"
            },
            {
                "regex": "TAB[ _](\\d{3})[ _]([34])G",
                "model": "Tab $1 $2G",
                "device": "tablet"
            },
            {
                "regex": "TAB-714",
                "model": "Tab 714 WiFi",
                "device": "tablet"
            },
            {
                "regex": "TAB_814",
                "model": "Tab 814",
                "device": "tablet"
            },
            {
                "regex": "MAJESTIC[ _]Tab([^;/]+)Build",
                "model": "Tab$1",
                "device": "tablet"
            },
            {
                "regex": "MAJESTIC[ _]Tab([^);/]+)(?:[);/ ]|$)",
                "model": "Tab$1",
                "device": "tablet"
            },
            {
                "regex": "MAJESTIC[ _]([^;/]+)Build",
                "model": "$1"
            },
            {
                "regex": "MAJESTIC[ _]([^);/]+)(?:(?:[);/ ]|$)|$)",
                "model": "$1"
            },
            {
                "regex": "CRONO ?([0-9]+) Build",
                "model": "Crono $1"
            },
            {
                "regex": "CRONO ?([0-9]+)(?:[);/ ]|$)",
                "model": "Crono $1"
            }
        ]
    },
    "Maxwell": {
        "regex": "MAXWELL[;,]",
        "device": "tv",
        "model": ""
    },
    "Schneider": {
        "regex": "SCHNEIDER[;,]",
        "device": "tv",
        "model": ""
    },
    "Sencor": {
        "regex": "Sencor|(?:ELEMENT[ _]?(?:(?:7|8|9\\.7|10[ _]1)(?:[ _]?V[23])?|P[0-9]+|10\\.1 Q001)|10_1Q205|ELEMENT-P5501)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:SENCOR[ _])?Element (10\\.1) (Q001)",
                "model": "Element $1\" $2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V3",
                "model": "Element 7 V3"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2[ _]BASIC",
                "model": "Element 7 V2 Basic"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2",
                "model": "Element 7 V2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V3",
                "model": "Element 8 V3"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V2",
                "model": "Element 8 V2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT8",
                "model": "Element 8"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V3",
                "model": "Element 9.7 V3"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V2",
                "model": "Element 9.7 V2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _]9\\.7",
                "model": "Element 9.7"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT10[ _]1",
                "model": "Element 10.1"
            },
            {
                "regex": "(?:SENCOR[ _])?(7Q105)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:SENCOR[ _])?(10)_(1Q205|1Q102)(?:[);/ ]|$)",
                "model": "$1.$2"
            },
            {
                "regex": "(?:SENCOR[ _])?ELEMENT[ _-]?P([0-9]+)",
                "model": "Element P$1",
                "device": "smartphone"
            },
            {
                "regex": "Sencor[ _]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "TAUBE": {
        "regex": "TAUBE[;,]",
        "device": "tv",
        "model": ""
    },
    "Hi-Level": {
        "regex": "HLV-T([a-z0-9]+)",
        "device": "tablet",
        "model": "HLV-T$1"
    },
    "HKC": {
        "regex": "HKC ",
        "device": "tv",
        "models": [
            {
                "regex": "4K AI Smart TV(?:[);/ ]|$)",
                "model": "4K AI Smart TV"
            }
        ]
    },
    "HKPro": {
        "regex": "HKPRO,([a-z0-9_ -]+),(?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Hoffmann": {
        "regex": "(HOFFMANN|Neo[_ ]A[1379]00|X-Go|X-Play|X-Pro|X_Ultra|X-Max)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Neo[_ ](A[1379]00)",
                "model": "Neo $1"
            },
            {
                "regex": "HOFFMANN[ _]X[-_ ](Prime|Twist|Max)",
                "model": "X $1"
            },
            {
                "regex": "X[-_](Play|Go|Pro|Ultra|Max)",
                "model": "X $1"
            }
        ]
    },
    "Homatics": {
        "regex": "(Box Q|Box R 4K Plus|Box R (?:Lite )?4K| KP1|Dongle G 4K)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Huagan": {
        "regex": "Huagan[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Huagan[ _]([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Stream": {
        "regex": "LGE; WSTR[0-9a-z]+;|(B3 (?:Maxi|Simply)|B3Pro|Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:B1s|HT28|HT16))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(B3 (?:Maxi|Simply)|B1s|HT28|HT16)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "B3Pro(?:[);/ ]|$)",
                "model": "B3 Pro"
            },
            {
                "regex": "LGE; (WSTR[0-9a-z]+);",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "Homtom": {
        "regex": "Homtom|(?:HT[0-9]{1,2}(?: ?Pro)?|HT3_Pro|P30 Pro|android 8([\\d.]*);(?: [\\w-]+;)? S17)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "P30 Pro",
                "model": "P30 Pro"
            },
            {
                "regex": "S17",
                "model": "S17"
            },
            {
                "regex": "(?:Homtom[_ ])?HT ?([0-9]{1,2})[ _]?Pro(?:[);/ ]|$)",
                "model": "HT$1 Pro"
            },
            {
                "regex": "(?:Homtom[_ ])?HT ?([0-9]{1,2}?)(?:[);/ ]|$)",
                "model": "HT$1"
            },
            {
                "regex": "Homtom ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Hopeland": {
        "regex": "HY(?:416|820)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "HY(416|820)(?:[);/ ]|$)",
                "model": "HY$1"
            }
        ]
    },
    "Hosin": {
        "regex": "HOSIN[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "HOSIN[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "HOSIN[ _-]([^;/]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Hoozo": {
        "regex": "(?:HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)|F13_EEA|MZ104|HZ0010J?|HZ1012|YK_P30(?:_EEA)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001|MZ104)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(HZ0010J?|HZ1012)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "F13_EEA(?:[);/ ]|$)",
                "model": "F13"
            },
            {
                "regex": "(YK_P30)(?:_EEA)?(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Mightier": {
        "regex": "(MT003-21)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Minix": {
        "regex": "(?:NEO[- ](?:X8-H|X8|U9-H|X[57]-mini|X8H?-PLUS|X88-?I|X7-216A|X5-116A|X[68]|U1|Z64|U22-XJ)|MNBP-300G)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "NEO-X8-H",
                "model": "NEO X8H"
            },
            {
                "regex": "NEO U22-XJ",
                "model": "NEO U22"
            },
            {
                "regex": "NEO-X([57])-mini",
                "model": "NEO X$1 Mini"
            },
            {
                "regex": "NEO-(X8H?)-PLUS",
                "model": "NEO $1 Plus"
            },
            {
                "regex": "NEO-X88-?I",
                "model": "NEO X88i"
            },
            {
                "regex": "NEO-X7-216A",
                "model": "NEO X7"
            },
            {
                "regex": "NEO-X5-116A",
                "model": "NEO X5"
            },
            {
                "regex": "NEO-X([68])",
                "model": "NEO X$1"
            },
            {
                "regex": "NEO-U1",
                "model": "NEO U1"
            },
            {
                "regex": "NEO-Z64",
                "model": "NEO Z64"
            },
            {
                "regex": "NEO-U9-H",
                "model": "NEO U9H"
            },
            {
                "regex": "(MNBP-300G)",
                "model": "$1"
            }
        ]
    },
    "Huavi": {
        "regex": "KHATAR H-(?:10 mini|20 PRO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "KHATAR H-10 mini(?:[);/ ]|$)",
                "model": "KHATAR H-10 Mini"
            },
            {
                "regex": "KHATAR H-20 PRO(?:[);/ ]|$)",
                "model": "KHATAR H-20 Pro"
            }
        ]
    },
    "Turkcell": {
        "regex": "TURKCELL[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Turbo T50(?:[);/ ]|$)",
                "model": "Turbo T50"
            },
            {
                "regex": "T([124-8])0(?:[);/ ]|$)",
                "model": "T$10"
            },
            {
                "regex": "Maxi Plus 5(?:[);/ ]|$)",
                "model": "T21 Maxi Plus 5"
            },
            {
                "regex": "MaxiPRO5(?:[);/ ]|$)",
                "model": "T21 Maxi Pro 5"
            },
            {
                "regex": "Turkcell_T_Tablet(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T Tablet"
            }
        ]
    },
    "China Telecom": {
        "regex": "Build/Tianyi|(?:TYH211U|TYH201H|TYH6(?:1[12]|22|3[12]|41)M|TYH651M-02)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TYH622M",
                "model": "Maimang 11 5G"
            },
            {
                "regex": "TYH611M",
                "model": "Maimang 10 SE 5G"
            },
            {
                "regex": "TYH612M",
                "model": "Maimang 10 5G"
            },
            {
                "regex": "TYH632M",
                "model": "Maimang A20 5G"
            },
            {
                "regex": "TYH631M",
                "model": "Maimang 20 5G"
            },
            {
                "regex": "TYH641M",
                "model": "Maimang 30 5G"
            },
            {
                "regex": "TYH211U",
                "model": "Tianyi One (2021)"
            },
            {
                "regex": "TYH201H",
                "model": "Tianyi One"
            },
            {
                "regex": "TYH651M-02",
                "model": "Maimang 40 5G"
            }
        ]
    },
    "U-Magic": {
        "regex": "(?:Liantong)?(?:VP00[1235])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Liantong)?VP001",
                "model": "Enjoy 20 Plus 5G"
            },
            {
                "regex": "(?:Liantong)?VP002",
                "model": "Enjoy 20 5G"
            },
            {
                "regex": "(?:Liantong)?VP003",
                "model": "Enjoy 30e 5G"
            },
            {
                "regex": "(?:Liantong)?VP005",
                "model": "Enjoy 50 Plus"
            }
        ]
    },
    "Hi Nova": {
        "regex": "(?:Hebe|Hera|Hinova)-BD00|(?:ALH-BD00|MGZ-BD00|FIO-BD00|MIZ-BD00|MNT-BD00|SUP-BD00|MRK-BD00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "FIO-BD00",
                "model": "9 SE"
            },
            {
                "regex": "MNT-BD00",
                "model": "9z 5G"
            },
            {
                "regex": "Hebe-BD00",
                "model": "9 Pro"
            },
            {
                "regex": "Hera-BD00",
                "model": "9"
            },
            {
                "regex": "ALH-BD00",
                "model": "10"
            },
            {
                "regex": "MGZ-BD00",
                "model": "10 Pro"
            },
            {
                "regex": "MRK-BD00",
                "model": "10 SE 5G"
            },
            {
                "regex": "Hinova-BD00|MIZ-BD00",
                "model": "11"
            },
            {
                "regex": "SUP-BD00",
                "model": "12 SE"
            }
        ]
    },
    "TD Tech": {
        "regex": "Build/TDTech|(?:NAT-TN70|TDT-MA01|AVA-PA00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NAT-TN70",
                "model": "N8 Pro"
            },
            {
                "regex": "AVA-PA00",
                "model": "P50"
            },
            {
                "regex": "TDT-MA01",
                "model": "M40"
            }
        ]
    },
    "Honor": {
        "regex": "(?:HONOR[ _]?|HW-)?(?:FCP-(?:N49|AN10)|AGM3-(?:W|AL)09HN|LGN-LX[1-3]|HEY3-(?:W00|N09)|HEY2-N09|HEY2?-W09|ELN2-[WL]29|ELN-(?:L0[39]|W09)|AGR-(?:W|AL)09HN|NDL-[LW]09|AGM-W09HN|KOB2-(?:AL00|W09)HN|BRT-(?:AN09|W09)|KRJ2-(?:AN00|W09)|ROD-W[01]9|ROD2-(?:W09|W69)|ROL-W[06]0|GDI-W09|NIC-(?:LX[1-3]|AN00)|WOD-LX[1-3]|AGI-AN00|BRP-(?:NX[13]|NX1M|AN[08]0)|BRC-(?:AN00|NX1)|LYN-AN00|ALP-AN00|ALI-(?:NX[13]|AN00)|LLY-AN00|CRT-(?:NX[13]|LX[123]|AN00)|GFY-(?:LX2|LX2P)|VNA-(?:LX[23])|ANY-(?:LX[123]|NX1)|DNP-(?:NX9|AN00)|DNY-NX9|RMO-(?:NX[13]|AN00)|ADT-AN00|DIO-AN00|CLK-AN00|HJC-(?:LX9|AN90)|KOZ-(?:AL00|AL00CM|AL40)|CHL-A[NL]00|CMA-(?:AN[04]0|LX[123])|NEW-AN90|NZA-AL00?|ALT-(?:AN00|LX[123]|NX[13])|CLK-(?:[LN]X[123])|RKY-(?:LX[123]|AN[01]0)|NNH-AN00|VNE-(?:AN[04]0|LX[123]|N41)|JDY-(?:AN00|LX[123])|DVD-AN[08]0|PTP-(?:AN[01267]0|N[245]9)|BVL-(?:AN[02]0|N[45]9|AN16)|MGI-AN00|PGT-(?:N[01]9|AN[012]0)|LGE-(?:AN[012]0|NX9|N49B)|GBD-NX9|ELZ-AN[012]0|FLC-AN00|FRI-(?:AN[10]0|NX9)|VER-(?:AN[01]0|N49|N49DP)|AMP-AN[01]0|AMM-AN00|HPB-AN00|GIA-AN[08]0|ANN-AN00|ANB-AN00|AGT-AN00|ANP-AN00|SDY-AN00|FNE-(?:NX9|AN00)|MAA-AN00|MAA-AN10|REP-AN00|MAG-AN00|REA-(?:NX9|AN00)|RTG-NX9|AMG-AN00|VCA-AN00|TNA-AN00|LSA-AN00|RNA-[AT]N00|NTN-(?:LX[13]|L22|AN20)|NTH-(?:NX9|AN00)|WDY-(?:LX[123]|AN00)|ELP-(?:AN00|NX9)|ELI-(?:AN00|NX9)|LLY-NX1|ABR-(?:NX1|LX[123]|AN00)|LLY-LX[123]|RBN-NX[13]|DNN-AN00|MTN-(?:NX1|AN[08]0)|JLH-AN00|MBH-AN10|BKQ-AN10|CLE-AN00|ELA-LX[23]|TFY-(?:LX[123]|AN40)|LRA-AN00|NLA-LX2P)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MBH-AN10",
                "device": "phablet",
                "model": "Magic V5"
            },
            {
                "regex": "ELA-LX[23]",
                "model": "Play 10"
            },
            {
                "regex": "BKQ-AN10",
                "model": "Magic 8 Pro"
            },
            {
                "regex": "ALT-LX[123]",
                "model": "X7c"
            },
            {
                "regex": "LGN-LX[1-3]",
                "model": "X7d"
            },
            {
                "regex": "ALT-NX1",
                "model": "X7c 5G"
            },
            {
                "regex": "DVD-AN[08]0",
                "model": "Power"
            },
            {
                "regex": "FCP-(?:AN10|N49)",
                "device": "phablet",
                "model": "Magic V3"
            },
            {
                "regex": "MTN-AN[08]0",
                "model": "X70"
            },
            {
                "regex": "ABR-AN00",
                "model": "X70i"
            },
            {
                "regex": "ABR-LX[123]",
                "model": "X8c"
            },
            {
                "regex": "LLY-NX1",
                "model": "200 Lite"
            },
            {
                "regex": "ELI-(?:AN00|NX9)",
                "model": "200"
            },
            {
                "regex": "ELP-(?:AN00|NX9)",
                "model": "200 Pro"
            },
            {
                "regex": "AMG-AN00",
                "model": "GT"
            },
            {
                "regex": "AMM-AN00",
                "model": "300"
            },
            {
                "regex": "AMP-AN00",
                "model": "300 Pro"
            },
            {
                "regex": "AMP-AN10",
                "model": "300 Ultra"
            },
            {
                "regex": "VER-N49DP",
                "model": "Magic V2 RSR"
            },
            {
                "regex": "CLE-AN00",
                "model": "Magic V Flip 2"
            },
            {
                "regex": "FLC-AN00",
                "model": "Magic Vs3"
            },
            {
                "regex": "ALI-NX1",
                "model": "X9b"
            },
            {
                "regex": "ALI-NX3",
                "model": "Magic 6 Lite 5G"
            },
            {
                "regex": "BVL-AN16|BVL-N49",
                "model": "Magic 6 Pro"
            },
            {
                "regex": "BVL-(?:AN20|N59)",
                "model": "Magic 6 RSR"
            },
            {
                "regex": "BVL-AN00",
                "model": "Magic 6"
            },
            {
                "regex": "PTP-(?:AN[06]0|N29)",
                "model": "Magic 7"
            },
            {
                "regex": "PTP-(?:AN20|N59)",
                "model": "Magic 7 RSR"
            },
            {
                "regex": "PTP-(?:N49|AN[17]0)",
                "model": "Magic 7 Pro"
            },
            {
                "regex": "BRP-(?:NX3|NX1M)",
                "model": "Magic 7 Lite"
            },
            {
                "regex": "JDY-AN00",
                "model": "Play 50 5G"
            },
            {
                "regex": "ALT-AN00",
                "model": "Play 60 Plus"
            },
            {
                "regex": "NIC-AN00",
                "model": "Play 60"
            },
            {
                "regex": "KOZ-AL00CM",
                "model": "Play 20a"
            },
            {
                "regex": "CLK-AN00",
                "model": "Play 8T"
            },
            {
                "regex": "DNN-AN00|DNY-NX9",
                "model": "400"
            },
            {
                "regex": "DNP-NX9|DNP-AN00",
                "model": "400 Pro"
            },
            {
                "regex": "ABR-NX1",
                "model": "400 Lite"
            },
            {
                "regex": "MEY-AN00",
                "model": "500"
            },
            {
                "regex": "BRP-NX1(?!M)",
                "model": "X9c"
            },
            {
                "regex": "MTN-NX1",
                "model": "X9d"
            },
            {
                "regex": "BRC-NX1",
                "model": "X9c Smart"
            },
            {
                "regex": "NLA-LX2P",
                "model": "X5c Plus"
            },
            {
                "regex": "GFY-LX2P",
                "model": "X5b Plus"
            },
            {
                "regex": "GFY-LX2",
                "model": "X5b"
            },
            {
                "regex": "LLY-AN00",
                "model": "X50i+ 5G"
            },
            {
                "regex": "LYN-AN00",
                "model": "X60i 5G"
            },
            {
                "regex": "BRC-AN00",
                "model": "X60"
            },
            {
                "regex": "BRP-AN[08]0",
                "model": "X60 Pro"
            },
            {
                "regex": "AGI-AN00",
                "model": "X60 GT"
            },
            {
                "regex": "WOD-LX[1-3]",
                "model": "X5 Plus"
            },
            {
                "regex": "NIC-LX[1-3]",
                "model": "X6c"
            },
            {
                "regex": "RKY-AN00",
                "model": "Play 40 Plus"
            },
            {
                "regex": "RKY-AN10",
                "model": "Play 7T 5G"
            },
            {
                "regex": "WDY-AN00",
                "model": "Play 40"
            },
            {
                "regex": "RKY-LX[123]",
                "model": "X7a"
            },
            {
                "regex": "CLK-LX[123]",
                "model": "X7b"
            },
            {
                "regex": "VNE-AN40",
                "model": "Play 6C"
            },
            {
                "regex": "CRT-LX[123]",
                "model": "X8a"
            },
            {
                "regex": "RBN-NX3",
                "model": "X8a 5G"
            },
            {
                "regex": "LLY-LX[123]",
                "model": "X8b"
            },
            {
                "regex": "WDY-LX[123]",
                "model": "X6a"
            },
            {
                "regex": "JDY-LX[123]",
                "model": "X6b"
            },
            {
                "regex": "ALT-NX3",
                "model": "X6b 5G"
            },
            {
                "regex": "VCA-AN00",
                "model": "V Purse"
            },
            {
                "regex": "CRT-NX[13]",
                "model": "90 Lite"
            },
            {
                "regex": "CLK-NX[13]",
                "model": "90 Smart"
            },
            {
                "regex": "REA-(?:NX9|AN00)|RTG-NX9",
                "model": "90"
            },
            {
                "regex": "MAG-AN00",
                "model": "90 GT"
            },
            {
                "regex": "REP-AN00",
                "model": "90 Pro"
            },
            {
                "regex": "MAA-AN10",
                "model": "100 Pro"
            },
            {
                "regex": "MAA-AN00",
                "model": "100"
            },
            {
                "regex": "VER-(?:AN10|N49)",
                "model": "Magic V2"
            },
            {
                "regex": "LRA-AN00",
                "model": "Magic V Flip 5G"
            },
            {
                "regex": "FRI-AN10",
                "model": "Magic Vs Ultimate"
            },
            {
                "regex": "VER-AN00",
                "model": "Magic Vs2"
            },
            {
                "regex": "RMO-NX3",
                "model": "Magic 5 Lite"
            },
            {
                "regex": "MGI-AN00|PGT-(?:N09|AN00)",
                "model": "Magic 5"
            },
            {
                "regex": "PGT-(?:AN10|N19)",
                "model": "Magic 5 Pro"
            },
            {
                "regex": "PGT-AN20",
                "model": "Magic 5 Ultimate"
            },
            {
                "regex": "CLK-NX2",
                "model": "X7b 5G"
            },
            {
                "regex": "RMO-NX1",
                "model": "X9a"
            },
            {
                "regex": "CRT-AN00",
                "model": "X50i"
            },
            {
                "regex": "ALI-AN00",
                "model": "X50"
            },
            {
                "regex": "ALP-AN00",
                "model": "X50 Pro 5G"
            },
            {
                "regex": "TFY-AN40",
                "model": "Play 6T Pro"
            },
            {
                "regex": "DIO-AN00",
                "model": "X40i"
            },
            {
                "regex": "ADT-AN00",
                "model": "X40 GT"
            },
            {
                "regex": "RMO-AN00",
                "model": "X40"
            },
            {
                "regex": "CMA-AN00",
                "model": "Play 30 Plus"
            },
            {
                "regex": "VNE-AN00",
                "model": "Play 30"
            },
            {
                "regex": "CMA-LX[123]",
                "model": "X7"
            },
            {
                "regex": "TFY-LX[123]",
                "model": "X8"
            },
            {
                "regex": "VNE-N41",
                "model": "X8 5G"
            },
            {
                "regex": "FNE-AN00",
                "model": "70"
            },
            {
                "regex": "FNE-NX9",
                "model": "70 5G"
            },
            {
                "regex": "SDY-AN00",
                "model": "70 Pro"
            },
            {
                "regex": "RBN-NX1",
                "model": "70 Lite"
            },
            {
                "regex": "ANP-AN00",
                "model": "80 Pro"
            },
            {
                "regex": "AGT-AN00",
                "model": "80 GT"
            },
            {
                "regex": "ANB-AN00",
                "model": "80 Pro Flat"
            },
            {
                "regex": "ANN-AN00",
                "model": "80 5G"
            },
            {
                "regex": "GIA-AN80",
                "model": "80 SE"
            },
            {
                "regex": "HPB-AN00",
                "model": "70 Pro+"
            },
            {
                "regex": "FRI-NX9",
                "model": "Magic Vs"
            },
            {
                "regex": "FRI-AN00",
                "model": "Magic Vs 5G"
            },
            {
                "regex": "LGE-(?:AN10|NX9|N49B)|GBD-NX9",
                "model": "Magic 4 Pro"
            },
            {
                "regex": "LGE-AN00",
                "model": "Magic 4"
            },
            {
                "regex": "LGE-AN20",
                "model": "Magic 4 Pro+"
            },
            {
                "regex": "ANY-LX1",
                "model": "Magic 4 Lite"
            },
            {
                "regex": "CMA-AN40",
                "model": "Play 6T"
            },
            {
                "regex": "ANY-(?:NX1)",
                "model": "X9 5G"
            },
            {
                "regex": "ANY-LX[23]",
                "model": "X9"
            },
            {
                "regex": "VNA-LX[23]",
                "model": "X5"
            },
            {
                "regex": "NNH-AN00",
                "model": "50"
            },
            {
                "regex": "NTN-AN20",
                "model": "X20"
            },
            {
                "regex": "VNE-LX[123]",
                "model": "X6"
            },
            {
                "regex": "NTH-(?:NX9|AN00)",
                "model": "50 5G"
            },
            {
                "regex": "JLH-AN00",
                "model": "50 SE"
            },
            {
                "regex": "NTN-(?:LX[13]|L22)(?:[);/ ]|$)",
                "model": "50 Lite"
            },
            {
                "regex": "RNA-[AT]N00",
                "model": "50 Pro 5G"
            },
            {
                "regex": "LSA-AN00",
                "model": "60"
            },
            {
                "regex": "GIA-AN00",
                "model": "60 SE 5G"
            },
            {
                "regex": "TNA-AN00",
                "model": "60 Pro"
            },
            {
                "regex": "ELZ-AN00",
                "model": "Magic 3"
            },
            {
                "regex": "ELZ-AN10",
                "model": "Magic 3 Pro"
            },
            {
                "regex": "ELZ-AN20",
                "model": "Magic 3 Pro+"
            },
            {
                "regex": "NEW-AN90",
                "model": "Play 5 Vitality"
            },
            {
                "regex": "CHL-AL00",
                "model": "Play 5T Pro"
            },
            {
                "regex": "CHL-AN00",
                "model": "X20 SE"
            },
            {
                "regex": "HJC-AN90",
                "model": "Play 5"
            },
            {
                "regex": "KOZ-AL00",
                "model": "Play 20"
            },
            {
                "regex": "HJC-LX9",
                "model": "Play 20 Pro"
            },
            {
                "regex": "(?:NZA-AL00?|KOZ-AL40)(?:[);/ ]|$)",
                "model": "Play 5T"
            },
            {
                "regex": "GDI-W09",
                "model": "MagicPad 13 WiFi",
                "device": "tablet"
            },
            {
                "regex": "ROD2-W09",
                "model": "MagicPad 2 WiFi",
                "device": "tablet"
            },
            {
                "regex": "ROD-W09",
                "model": "Pad V8 Pro 12.1\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "ROD-W19",
                "model": "Pad 9 Pro Soft Light Edition 12.1\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "ROL-W00",
                "model": "Pad V9 11.5\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "ROL-W60",
                "model": "Pad GT 11.5\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "ROD2-W69",
                "model": "Pad GT Pro 12.3\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "KRJ2-W09",
                "model": "Pad V7 10.4\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "KRJ2-AN00",
                "model": "Pad V7 10.4\" 5G",
                "device": "tablet"
            },
            {
                "regex": "BRT-W09",
                "model": "Pad V7 Pro 11\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "BRT-AN09",
                "model": "Pad V7 Pro 11\" 5G",
                "device": "tablet"
            },
            {
                "regex": "KOB2-W09HN",
                "device": "tablet",
                "model": "Pad X7 8\" WiFi"
            },
            {
                "regex": "KOB2-AL00HN",
                "device": "tablet",
                "model": "Pad X7 8\" LTE"
            },
            {
                "regex": "AGR-W09HN",
                "device": "tablet",
                "model": "Pad X6"
            },
            {
                "regex": "AGM-W09HN",
                "device": "tablet",
                "model": "Pad X8 Lite WiFi"
            },
            {
                "regex": "NDL-W09",
                "device": "tablet",
                "model": "Pad X8a WiFi"
            },
            {
                "regex": "NDL-L09",
                "device": "tablet",
                "model": "Pad X8a LTE"
            },
            {
                "regex": "AGR-AL09HN",
                "device": "tablet",
                "model": "Pad X6 9.7\""
            },
            {
                "regex": "ELN-W09",
                "device": "tablet",
                "model": "Pad X9 11.5\" WiFi"
            },
            {
                "regex": "ELN-L0[39]",
                "device": "tablet",
                "model": "Pad X9 11.5\" LTE"
            },
            {
                "regex": "ELN2-L29",
                "device": "tablet",
                "model": "Pad X9a 11.5\" LTE"
            },
            {
                "regex": "ELN2-W29",
                "device": "tablet",
                "model": "Pad X9a 11.5\" WiFi"
            },
            {
                "regex": "HEY3-W00",
                "device": "tablet",
                "model": "Pad 10 12.1\" WiFi"
            },
            {
                "regex": "HEY3-N09",
                "device": "tablet",
                "model": "Pad 10 12.1\""
            },
            {
                "regex": "HEY-W09",
                "device": "tablet",
                "model": "Pad 8 12.0\" WiFi"
            },
            {
                "regex": "HEY2-W09",
                "device": "tablet",
                "model": "Pad 9 12.1\" WiFi"
            },
            {
                "regex": "HEY2-N09",
                "device": "tablet",
                "model": "Pad 9 12.1\" 5G"
            },
            {
                "regex": "AGM3-W09HN",
                "device": "tablet",
                "model": "Pad 7 10.1\" WiFi"
            },
            {
                "regex": "AGM3-AL09HN",
                "device": "tablet",
                "model": "Pad 7 10.1\""
            }
        ]
    },
    "Huawei": {
        "regex": "Honor|Ideos (?:Build/|[;])|HONOR_H30-L01M|(?:HW-)?HUAWEI[_ ]?(?!Browser)|EC6108V|dtab01|MediaPad (?:7|10)|(?:Build/HUAWEI|(?:HW-)?HUAWEI)?(?:d-01[HKJ]|d-02[HK]|JSN-(?:L2[1-3]|L42|[TA]L00[a]?)|YOK-AN10|ASK-AL(?:00x|20)|DNN-LX9|KANT-(?:3[67]0|370S|3[56]0S|350[BC]|3[56]9)|BLM-00|COL-(?:AL[01]0|TL[01]0|L29|L10)|JAT-(?:L29|LX[13]|L41|[AT]L00)|ARC-AL00|GLL-AL01|LEO-(?:BX9|DLXXE?)|TFY-(?:AN00)|BZD-(?:W00|AL00)|MXW-[AT]N00|BZT3-(?:AL00|W09)|BZI-(?:W[02]0|AL[02]0)|BZT-(?:AL[01]0|W09)|AGRK-[WL]09|T1-82(?:3L|1W)|MediaPad T1|T1-701u|T1-(?:A21[LW]|A2[23]L)|FDR-(A01[LW]|A03L)|60[56]HW|JDN-(?:L01|AL00|W09)|BGO-(?:DL09|L03)|PLE-70[13]L|BG2-(?:U0[13]|W09)|KOB-[LW]09|PE-(?:[CU]L00|TL[12]0|TL00M)|BZK-[LW]00|AGS-(?:L0[39]|W09)|OXP-AN00|AGR-[LW]09|KOB2-(?:[LW]09|L03)|Kobe3-L09|AGS2-(?:[LW]09|W09HN|W19|L03|AL00|AL00HN)|BAH-(?:L09|AL00)|BAH-W09|Bach-W09|ANY-AN00|BLN-(?:L2[124]|AL[1-4]0|TL[01]0)|CPN-(?:[LW]09|AL00)|701HW|BTV-(?:DL09|W09)|SCM-W09|VRD-(?:(AL|W)09|AL10|W10)|SHT-(?:AL|W)09|JDN2-(:?[WL]09|AL[50]0)|JDN2-(?:AL[05]0|W09)HN|BAH2-(?:AL[01]0|L09|W[01]9)|GEM-70[1-3]L|SCM-AL09|CMR-(?:AL[01]9|W09|W19)|WEB-W0[09]|PCE-W(?:29|[34]0)|PCT-(?:L29|[TA]L10)|WGR-AN19|WGRR?-W[10]9|MRX-(?:AN19|W[0-3]9|AL[01]9)|MRO-W09|MRR-W[23]9|M2-801W|M2-A01L|M2-80[123]L|LND-(?:AL[34]0|L29|TL[34]0)|BZT4-W19|BZW-AL[01]0|BZC-(?:W00|AL00)|BZA-[LW]00|MON-(?:W19|AL19B?)|HMW-W09|TGR-(?:W0[09]|W10)|BTKR-W09|BTK-(?:W09|AL09)|DBY2-(?:L09|L09CK|W0[09])|AGS5-(?:L09|AL00|W0[09])|AGS3K-(?:L09|W0[90]|W20)|AGS3-(A?L09|AL00|W00[DE]|AL09HN|W09HN|W0?9)|SCMR-(?:AL09|W09)|XYAO-W00|GOT-(?:W[02]9|AL[01]9)|DBR-W1[09]|BKY-W09|AGS6-[LW]09|DB[YR]-W09|BAH3-(?:AN10|AL00|[LW]09|W59)|BAH4-(?:L09|AL10|W29|W[03]9)|HWT31|BVE-W10|GRL-(?:AL10|LX9)|Nexus 6P|G6-L11|Ultym5|CM990|NMO-L31|302HW|LTK-LX3|JKM-(?:[TA]L00[ab]?|LX[123]|L03)|FLA-(LX[123]|AL20|TL10|L23)|AQM-(?:LX1|[AT]L[01]0)|Peppa-(?:L2[23]B|L0[23]B)|LDN-(?:LX[23]|TL10|L01|AL00|L21)|DUB-(?:LX[123]|TL00|AL20|AL00a?)|CAM-L(?:03|2[13]|32)|CAM-(?:[ATU]L00|TL00H)(?:_TD)?|Y635-(?:L21|L0[123])|Y625-U03|M[ER]D-LX2|Y6 Pro 2019|TIT-(?:AL00|L01|U02)|ATU-L(?:31|42)|Y6Prime|MRD-L(?:X1[NF]?|X3)|Y6 2019|ATU-L(?:11|2[12]|X3)|SCC-U21|(?:HW-)?SCL-(?:AL00|CL00|TL00H?|L21|U31|L0[1-4]|L32)(?:_TD)?|CUN-(?:L(?:[02][1-3]|33)|U29|[AT]L00)|DRA-(?:LX[2359]|[AT]L00|L0[13]|L2[13])|CAG-(?:L[02]3|L[02]2)|AMN-LX[1239]|MYA-(?:TL10|L(?:0[23]|2[123]|41|1[13])|AL10|U29)|LUA-(?:U22|L2[12]|U03)|CRO-(?:L[02][23]|U00)|ARS-(?:[AT]L00|L22)|U(?:8230|8661|8667)|ATH-(?:[CAU]L00|TL00H?|UL0[16])|MLA-(?:TL[01]0|AL10|L1[12])|VIE-(?:AL10|L[02]9)|SLA-L(?:02|03|22|23)|VNS-(?:L(?:[23]1|[26]2|5[23]|23)|[AT]L00)|EVA-(?:AL[10]0|L[012]9|[TCD]L00)|PRA-(?:LA1|LX[1-3]|AL00X?|TL10)|hi6210sft|ALE-(?:[TUC]L00|L02|L2[13])|503HW|GRA-(?:L09|[TU]L00|UL10)|ELS-(?:[AT]N00|NX9|N04|AN10|N[23]9)|NEY-NX9|ART-(?:L29N|L2[89]|[AT]L00[xm]?)|JNY-(?:LX[12]|L[02]1|[AT]L10)|VOG-(?:L(?:04|09|29)|[AT]L00|AL10)|HW-02L|Marie-L21BX|MAR-(?:LX(?:1[BMH]|2B|[13]Am?|2J?|3BM)|[AT]L00|L21B|L21ME[AB])|NIC-LX1A|HWV33|ELE-(?:[AT]L00|L0[49]|L29)|CLT-(?:AL0[01]|TL0[01]|L0J|L(?:04|[02]9))l?|HW-01K|ANE-(?:LX[123]|LX2J|L2[23]|TL00)|HWV32|EML-(?:[TA]L00|L[02]9)|VKY-(?:[AT]L00|L09|L29)|WAS-(?:L(?:X1|X1A|X2|X2J|X3|03T)|TL10|AL00)|VTR-(?:L[02]9|AL00|TL00)|P Smart S|STK-(?:LX[13]|[AT]L00|L2[12])|PPA-LX[123]|POT-(?:LX(?:[123]|1[AT]|2J|1AF)|AL00|L01)|FIG-L(?:A1|X[123]|[13]1)|HRY-(?:AL00T[a]?|LX1T|[AT]L00A?|LX2|LX1MEB)|STG-(?:LX[12]|AL00)|CTR-(?:LX[123]|AL[02]0|L[89]1)|CHW-LX3|GFY-(?:LX1|AL00)|HLK-(?:AL10|L4[12]|AL00a?)|EVE-LX[39]|WKG-(?:LX9|[AT]N00)|Wukong-L29A|nova Y60|Enjoy 20 5G|CHA-AL80|BNE-(?:LX[13]|AL00)|NCO-(?:AL00|LX[13])|GLA-(?:LX[13]|AL00)|JLN-(?:AL00|LX[13])|JuliaQN-(?:L[02]1B|L23A)|RTE-AL00|NAM-(?:AL00|LX9)|ANG-(?:LX[12]|AN00)|Angela-(?:L2[12]B|L02B)|nova 8|BRQ-A[LN]00|CHL-AL60|JSC-(?:AL50|AN00)|nova 8 SE|NEN-L(?:X[13]|22)|nova 8i|nova 7i|TLR-AL00|BLK-(?:AL[08]0|LX9)|ADA-(?:AL00|AL[01]0U)|BON-AL00|FIN-AL60a?|FOA-(?:LX9|AL00)|GOA-(?:LX9|AL80|AL80U)|CDY-(?:[AT]N[02]0|NX9[AB]|AN9[05]|TN90)|CDL-AN50|CND-AN00|nova 7 SE 5G|JER-(?:[AT]N10|[AT]N20)|nova 7 Pro 5G|JEF-(?:[AT]N00|[AT]N20|NX9)|nova 7 5G|WLZ-(?:[AT]N00|AL10)|nova 6|nova 6SE|nova 6 5G|SPN-[AT]L00|nova 5T Pro|YAL-(?:L[26]1|[AT]L[05]0|L41|AL10)|Yale-(?:L71A|L61D)|GLK-(?:[AT]L00|LX1U|LX[23])|SEA-(?:AL10|[AT]L00)|VCE-(L22|[AT]L00)|INE-(?:AL00|LX[12]r|LX[12]|TL00)|IVY-LX2|PAR-(?:[AT]L00|LX[19]|LX1M|TL20)|HWI-[AT]L00|BAC-(?:[AT]L00|L2[12]|L[02]3|L01)|704HW|nova Lite3Plus|608HW|CAZ-(?:AL[01]0|TL[12]0)|CAN-L[01][1-3]|BND-(?:AL[01]0|TL10|L[23][14])|CRR-(?:L09|UL[20]0|CL00)|NEO-(?:AL00|L29)|LON-(?:AL00(?:-PD)?|L29)|BLL-L2[123]|MHA-(?:L[02]9|[AT]L00)|M300-L09|NXT-(?:AL10|L[02]9)|BRA-AL00|ALN-AL[018]0|CET-(?:AL[06]0|LX9)|DCO-(?:AL00|LX9)|OCE-(?:A[NL]50|AN[01]0)|Mate 40 RS|NOP-AN00|ALA-AN70|NOH-(?:NX9|AN0[01]|AN[58]0|AL[01]0)|LIO-(?:[TA]L00|L[02]9|AN00[mP]?|N29|TN00|AL10)|Mate30 RS|TAS-(?:[AT]L00|L[02]9|AN00)|AMZ-L29|EVR-(?:[TA]L00|L29|N29|AN00)|LYA-(?:AL[01]0|AL00P|L[02]9|L0C|TL00)|PAN-L29|SNE-(?:AL00|LX[0-3]|L01)|HMA-(?:[AT]L00|L[02]9)|BLA-(?:A09|L[02]9|L29S|[TA]L00)|RNE-(?:AL00|L(?:0[123]|2[123]))|ALP-(?:[TA]L00|L[02]9|L09S|L29S)|TET-(?:A[NL]00|AN[15]0)|ICL-(?:AL[12]0|LX9)|ALT-AL10|ALT-(?:AL00|L29)|PAL-(?:AL00|LX9)|TAH-(?:N29|AN00)m?|Mate Xs|TYH601M|TNNH?-AN00|POT-(?:AL10|[TA]L00a)|RIO-(?:[ATU]L00|L0[123])|IDEOS[_ ]X5|U8[85]00|U8510|ANA-(?:AL00|N29|L[0X]4|NX9|[AT]N00)|G750-T01|Hol-U19|H30-(?:C00|L01M?|L02|U10|T00|T10)(?:_TD)?|U9508|U8860|LEM-AL00|BAL-(?:AL[068]0|L49)|ABR-(?:AL[0689]0|LX9)|JAD-(?:AL[0568]0|LX9)|LNA-(?:AL00|LX9)|MNA-(?:AL00|LX9)|KII-L2[12]|G621-TL00M?|CHC-U(?:0[13]|23)|G735-L(?:03|12|23)|U8665|MLD-AL[01]0|Enjoy 20e Helio P35|FRL-(?:L2[123]|[AT]N00a?)|Enjoy 20 Plus 5G|PPA-AL20|Enjoy 20 SE|Enjoy Z 5G|DVC-(?:[AT]N20|AN00)|Enjoy 20 Pro 5G|MRD-[TA]L00|ATU-[AT]L10|FLA-AL[01]0|LDN-(?:AL[12]0|TL[02]0)|TRT-(?:AL00[A]?|L21A|L53|LX[123]|TL10A?)|FIG-(?:[AT]L[10]0)|SLA-(?:AL00|TL10)|DIG-(?:TL10|AL00|L0[13]|L2[123])(?:HN)?|NCE-(AL[10]0|TL10)|TAG-(?:L0[13]|L32|L13|L2[123]|[ACT]L00)|FGD-AL00|MAO-(?:AL00|LX9N?)|MGA-(?:AL[04]0|LX9N|LX[39])|EVE-AL00|MED-(?:[AT]L00|AL20|LX9N?)|PLA-AL10|CLS-AL[03]0|PLR-(?:AL[03]0|L29)|PLU-AL10|LMU-LX9|HED-LX9|HBN-(?:AL[018]0|LX9)|HBP-(?:AL00|LX9)|ADY-(?:AL[01]0|LX9)|PIC-LX9|MT2L03|Y550-L03|Y530|HW-H30-C00|H30-T[01]0|HN3-U01|LYO-(?:L0[12]|L21)|G7-TL00|H1711|Y(?:221|3[23]0|541)-U\\d{2}|MIS-LX9|NEM-(?:AL10|L51|UL10|TL00|L2[12]|TL00H)|RVL-AL09|G7-L01|G527-U081|G620S-L03|C8817D|G630-U251|Maimang 9|Enjoy 10e|BKL-(?:AL[023]0|L09S|L0[49]|TL10)|STF-(?:AL[10]0|L09S?|TL10)|KSA-(?:LX[239]|AL[10]0)|MOA-(?:AL[02]0|TL00|LX9N)|BMH-(?:AN[12]0|TN10)|KKG-AN[07]0|EBG-(?:AN10|N19|[AT]N00)|LRA-(?:LX1|[AT]L00)|COR-(?:AL[01]0|L29|TL10)|ARE-(?:AL[10]0|L22(?:HN)?|TL00)|KOB2K-L09|HWV31|IDEOS S7(?: Slim)?|AUM-(?:L29|L33|L41)|PLK-(?:AL10|CL00|TL00|TL01H?|UL00|L01)|CHE2?-[UT]L00[HM]?|CHE1-CL[12]0|CHE2-L(?:1[12]|23)|Che1-L04|CHE-TL00H?|MOGOLIA|VNA-L29|Holly-U19|CHM-(?:[CUT]L00[HM]?|U01)|HDN-[LW]09|KRJ-(?:W09|AN00)|HDL-(?:W|AL)09|KIW-(?:AL10|TL00H|[TC]L00|L2[1-4]|UL00)(?:_TD)?|DLI-(?:AL10|L[24]2|TL20)|JMM-(?:L22|[AT]L[01]0)|BKK-(?:AL[10]0|L2[12]|LX2|TL00)|VEN-L22|DUK-(?:L09|TL30|AL20)|VAT-L19|FRD-(?:AL[01]0|L0[249]|L1[49]|DL00)|DUA-(?:L22|LX[39]|[TA]L00)|TEL-(?:AN(?:00a?|10)|TN00)|OXF-AN[01]0|EDI-AL10|KNT-(?:AL[12]0|[TU]L10)|TNY-[AT]L00|NTS-AL00|AKA-(?:L29|AL10)|LLD-(?:AL[0123]0|L[23]1|TL10)|KJR-W09|(?:HW-)?H60-(?:J1|L0[1-4]|L1[12])(?:_TD)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ADY-(?:AL[01]0|LX9)",
                "model": "Pura 70"
            },
            {
                "regex": "HBP-(?:AL00|LX9)",
                "model": "Pura 70 Ultra"
            },
            {
                "regex": "HBN-(?:AL00|LX9)",
                "model": "Pura 70 Pro"
            },
            {
                "regex": "HBN-(?:AL[18]0)",
                "model": "Pura 70 Pro+"
            },
            {
                "regex": "LMU-LX9",
                "model": "Pura 80 Ultra"
            },
            {
                "regex": "HED-LX9",
                "model": "Pura 80"
            },
            {
                "regex": "PLU-AL10",
                "model": "Mate 70 RS Ultimate 5G"
            },
            {
                "regex": "PLR-(?:AL[03]0|L29)",
                "model": "Mate 70 Pro"
            },
            {
                "regex": "CLS-AL[03]0",
                "model": "Mate 70 5G"
            },
            {
                "regex": "PLA-AL10",
                "model": "Mate 70 Pro+ 5G"
            },
            {
                "regex": "GFY-AL00",
                "model": "Enjoy 70S"
            },
            {
                "regex": "POT-[TA]L00a(?:[);/ ]|$)",
                "model": "9S"
            },
            {
                "regex": "U9500(?:[);/ ]|$)",
                "model": "Ascend D1"
            },
            {
                "regex": "Z100-UL00(?:[);/ ]|$)",
                "model": "Ascend D3"
            },
            {
                "regex": "Y530(?:[);/ ]|$)",
                "model": "Ascend Y530"
            },
            {
                "regex": "Y320-(?:U10|T00|U05)(?:[);/ ]|$)",
                "model": "Ascend Y320"
            },
            {
                "regex": "Y330-U05(?:[);/ ]|$)",
                "model": "Ascend Y330"
            },
            {
                "regex": "Y541-U02(?:[);/ ]|$)",
                "model": "Ascend Y5C"
            },
            {
                "regex": "U8818(?:[);/ ]|$)",
                "model": "Ascend G300"
            },
            {
                "regex": "G527-U081(?:[);/ ]|$)",
                "model": "Ascend G527"
            },
            {
                "regex": "(G620S-L0[13]|C8817D)(?:[);/ ]|$)",
                "model": "Ascend G620S"
            },
            {
                "regex": "G630-U251(?:[);/ ]|$)",
                "model": "Ascend G630"
            },
            {
                "regex": "G7-(?:L01|TL00)(?:[);/ ]|$)",
                "model": "Ascend G7"
            },
            {
                "regex": "P7-L(?:10|07)(?:[);/ ]|$)",
                "model": "Ascend P7"
            },
            {
                "regex": "P6 ?S-U06",
                "model": "Ascend P6"
            },
            {
                "regex": "G730-C00(?:[);/ ]|$)",
                "model": "Ascend G730"
            },
            {
                "regex": "U9200(?:[);/ ]|$)",
                "model": "Ascend P1"
            },
            {
                "regex": "H1711(?:[);/ ]|$)",
                "model": "Ascend XT2"
            },
            {
                "regex": "Y221-U(?:[12]2|[0345]3)(?:[);/ ]|$)",
                "model": "Ascend Y221"
            },
            {
                "regex": "Y550-L03(?:[);/ ]|$)",
                "model": "Ascend Y550"
            },
            {
                "regex": "Y560-L01(?:[);/ ]|$)",
                "model": "Ascend Y560"
            },
            {
                "regex": "Huawei g700(?:-(?:U[012]0|T0[01]))?",
                "model": "Ascend G700"
            },
            {
                "regex": "ART-[AT]L00[xm]?(?:[);/ ]|$)",
                "model": "Enjoy 10"
            },
            {
                "regex": "STK-[AT]L00(?:[);/ ]|$)",
                "model": "Enjoy 10 Plus"
            },
            {
                "regex": "MED-(?:[AT]L00|AL20)(?:[);/ ]|$)|Enjoy 10e",
                "model": "Enjoy 10E"
            },
            {
                "regex": "AQM-[AT]L00(?:[);/ ]|$)",
                "model": "Enjoy 10S"
            },
            {
                "regex": "TAG-[ACT]L00(?:[);/ ]|$)",
                "model": "Enjoy 5S"
            },
            {
                "regex": "MGA-AL00",
                "model": "Enjoy 50"
            },
            {
                "regex": "EVE-AL00",
                "model": "Enjoy 50z"
            },
            {
                "regex": "MGA-AL40",
                "model": "Enjoy 60"
            },
            {
                "regex": "MAO-AL00",
                "model": "Enjoy 60 Pro 4G"
            },
            {
                "regex": "CTR-AL00",
                "model": "Enjoy 50 Pro"
            },
            {
                "regex": "STG-AL00",
                "model": "Enjoy 60X"
            },
            {
                "regex": "CTR-AL20",
                "model": "Enjoy 70 Pro"
            },
            {
                "regex": "FGD-AL00",
                "model": "Enjoy 70"
            },
            {
                "regex": "TAG-(?:L0[13]|L32|L13|L2[123])(?:[);/ ]|$)",
                "model": "GR3"
            },
            {
                "regex": "NCE-(AL[10]0|TL10)(?:[);/ ]|$)",
                "model": "Enjoy 6"
            },
            {
                "regex": "DIG-(?:TL10|AL00)(?:[);/ ]|$)",
                "model": "Enjoy 6S"
            },
            {
                "regex": "SLA-(?:AL00|TL10)(?:[);/ ]|$)",
                "model": "Enjoy 7"
            },
            {
                "regex": "FIG-(?:[AT]L[10]0)(?:[);/ ]|$)",
                "model": "Enjoy 7S"
            },
            {
                "regex": "(?:TRT-AL00[A]?|TRT-TL10A)(?:[);/ ]|$)",
                "model": "Enjoy 7 Plus"
            },
            {
                "regex": "LDN-(?:AL[12]0|TL[02]0)(?:[);/ ]|$)",
                "model": "Enjoy 8"
            },
            {
                "regex": "FLA-AL[01]0(?:[);/ ]|$)",
                "model": "Enjoy 8 Plus"
            },
            {
                "regex": "ATU-[AT]L10(?:[);/ ]|$)",
                "model": "Enjoy 8e"
            },
            {
                "regex": "MRD-[TA]L00(?:[);/ ]|$)",
                "model": "Enjoy 9e"
            },
            {
                "regex": "DVC-[AT]N20|Enjoy 20 Pro 5G",
                "model": "Enjoy 20 Pro 5G"
            },
            {
                "regex": "(?:DVC-AN00|Enjoy Z 5G)(?:[);/ ]|$)",
                "model": "Enjoy Z 5G"
            },
            {
                "regex": "(?:PPA-AL20|Enjoy 20 SE)(?:[);/ ]|$)",
                "model": "Enjoy 20 SE"
            },
            {
                "regex": "FRL-[AT]N00|Enjoy 20 Plus 5G",
                "model": "Enjoy 20 Plus 5G"
            },
            {
                "regex": "MLD-AL[01]0|Enjoy 20e Helio P35",
                "model": "Enjoy 20e"
            },
            {
                "regex": "U8665(?:[);/ ]|$)",
                "model": "Fusion 2"
            },
            {
                "regex": "MED-LX9N?(?:[);/ ]|$)",
                "model": "Y6p"
            },
            {
                "regex": "G735-L(?:03|12|23)(?:[);/ ]|$)",
                "model": "G Play"
            },
            {
                "regex": "CHC-U(?:0[13]|23)(?:[);/ ]|$)",
                "model": "G Play Mini"
            },
            {
                "regex": "(?:Honor_|HW-)?G621-TL00M?(?:[);/ ]|$)",
                "model": "G621"
            },
            {
                "regex": "DIG-L2[12](?:[);/ ]|$)",
                "model": "GR3 (2017)"
            },
            {
                "regex": "KII-L2[12]",
                "model": "GR5"
            },
            {
                "regex": "BLL-L2[12]",
                "model": "GR5 (2017)"
            },
            {
                "regex": "RIO-L03",
                "model": "GX8"
            },
            {
                "regex": "RIO-L0[12]",
                "model": "G8"
            },
            {
                "regex": "RIO-[UT]L00",
                "model": "G7 Plus"
            },
            {
                "regex": "MNA-(?:AL00|LX9)",
                "model": "P60 Pro"
            },
            {
                "regex": "LNA-(?:AL00|LX9)",
                "model": "P60"
            },
            {
                "regex": "JAD-(?:AL[0568]0|LX9)(?:[);/ ]|$)",
                "model": "P50 Pro"
            },
            {
                "regex": "ABR-(?:AL[08]0|LX9)",
                "model": "P50"
            },
            {
                "regex": "ABR-AL[69]0",
                "model": "P50E"
            },
            {
                "regex": "BAL-(?:AL[08]0|L49)",
                "model": "P50 Pocket"
            },
            {
                "regex": "BAL-AL60",
                "model": "Pocket S"
            },
            {
                "regex": "LEM-AL00",
                "model": "Pocket 2"
            },
            {
                "regex": "U8860(?:[);/ ]|$)",
                "model": "Honor"
            },
            {
                "regex": "U9508(?:[);/ ]|$)",
                "model": "Honor 2"
            },
            {
                "regex": "(?:Honor_|HW-)?H30-(?:C00|L01M?|L02|U10|T00|T10)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 3C"
            },
            {
                "regex": "Hol-U19(?:[);/ ]|$)",
                "model": "Honor 3C Lite"
            },
            {
                "regex": "G750-T01(?:[);/ ]|$)",
                "model": "Honor 3X"
            },
            {
                "regex": "HN3-U01",
                "model": "Honor 3"
            },
            {
                "regex": "YOK-AN10",
                "model": "Honor V40"
            },
            {
                "regex": "ALA-AN70",
                "model": "Honor V40 Lite"
            },
            {
                "regex": "KKG-AN70",
                "model": "Honor X30 Max"
            },
            {
                "regex": "ANY-AN00",
                "model": "Honor X30"
            },
            {
                "regex": "TFY-AN00",
                "model": "Honor X30i"
            },
            {
                "regex": "AGS3-AL09HN",
                "device": "tablet",
                "model": "Honor Pad 6 10.1\""
            },
            {
                "regex": "AGS3-W09HN",
                "device": "tablet",
                "model": "Honor Pad 6 10.1\" WiFi"
            },
            {
                "regex": "KRJ-AN00|Honor V6 5G",
                "model": "Honor Pad V6 10.4\" 5G",
                "device": "tablet"
            },
            {
                "regex": "KJR-W09|KRJ-W09|Honor V6 Wi-Fi",
                "model": "Honor Pad V6 10.4\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "EBG-[AT]N00",
                "model": "Honor 30 Pro"
            },
            {
                "regex": "(?:EBG-AN10|EBG-N19|Honor 30 Pro\\+)(?:[);/ ]|$)",
                "model": "Honor 30 Pro Plus"
            },
            {
                "regex": "(?:CDY-(?:AN9[05]|NX9A|TN90)|Honor 30S)(?:[);/ ]|$)",
                "model": "Honor 30S"
            },
            {
                "regex": "LRA-LX1(?:[);/ ]|$)",
                "model": "Honor 30I"
            },
            {
                "regex": "(?:MXW-[AT]N00|Honor 30 Lite)(?:[);/ ]|$)",
                "model": "Honor 30 Lite"
            },
            {
                "regex": "(?:BMH-(?:AN[12]0|TN10)|Honor 30)(?:[);/ ]|$)",
                "model": "Honor 30"
            },
            {
                "regex": "TNNH-AN00",
                "model": "Honor Play 4"
            },
            {
                "regex": "(?:OXP-AN00|Honor Play 4T Pro)(?:[);/ ]|$)",
                "model": "Honor Play 4 Pro"
            },
            {
                "regex": "(?:AKA-AL10|Honor Play 4T)(?:[);/ ]|$)",
                "model": "Honor Play 4T"
            },
            {
                "regex": "(?:JAT-L41|Honor 8A Pro)(?:[);/ ]|$)",
                "model": "Honor 8A Pro"
            },
            {
                "regex": "(?:MOA-LX9N|Honor 9A)(?:[);/ ]|$)",
                "model": "Honor 9A"
            },
            {
                "regex": "(?:AKA-L29|Honor 9C)(?:[);/ ]|$)",
                "model": "Honor 9C"
            },
            {
                "regex": "Honor 9x Lite",
                "model": "Honor 9X Lite"
            },
            {
                "regex": "OXF-AN00",
                "model": "Honor View 30"
            },
            {
                "regex": "OXF-AN10",
                "model": "Honor View 30 Pro"
            },
            {
                "regex": "(?:KKG-AN00|Honor X10 Max)(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Honor X10 Max"
            },
            {
                "regex": "(?:DNN-LX9|Honor X10 Lite)",
                "model": "Honor X10 Lite"
            },
            {
                "regex": "(?:TEL-(?:AN(?:00a?|10)|TN00)|Honor X10 5G)(?:[);/ ]|$)",
                "model": "Honor X10 5G"
            },
            {
                "regex": "X10 Pro",
                "model": "Honor X10 Pro"
            },
            {
                "regex": "MOA-(?:AL[02]0|TL00)",
                "model": "Honor Play 9A"
            },
            {
                "regex": "HRY-(?:[AT]L00[A]?|LX[12]|L21|LX1MEB)(?:[);/ ]|$)",
                "model": "Honor 10 Lite"
            },
            {
                "regex": "(?:HRY-LX1T|Honor 10i)(?:[);/ ]|$)",
                "model": "Honor 10I"
            },
            {
                "regex": "(?:LRA-[AT]L00|Honor 20 Lite)(?:[);/ ]|$)",
                "model": "Honor 20 Lite"
            },
            {
                "regex": "(HRY-AL00T[a]?|Honor 20i)(?:[);/ ]|$)",
                "model": "Honor 20I"
            },
            {
                "regex": "(?:YAL-(?:L41|AL10)|Honor 20 Pro)(?:[);/ ]|$)",
                "model": "Honor 20 Pro"
            },
            {
                "regex": "(?:MAR-LX1H|YAL-[AT]L50)(?:[);/ ]|$)",
                "model": "Honor 20S"
            },
            {
                "regex": "(?:YAL-(?:L21|[AT]L00)|Honor 20)(?:[);/ ]|$)",
                "model": "Honor 20"
            },
            {
                "regex": "(?:KSA-AL10|Honor Play 3e)(?:[);/ ]|$)",
                "model": "Honor Play 3E"
            },
            {
                "regex": "(?:ASK-AL(?:00x|20)|Honor Play 3)(?:[);/ ]|$)",
                "model": "Honor Play 3"
            },
            {
                "regex": "CHM-[CUT]L00[HM]?(?:[);/ ]|$)",
                "model": "Honor Play 4C"
            },
            {
                "regex": "(?:JAT-L(29|X[13])|Honor 8A)(?:[);/ ]|$)",
                "model": "Honor 8A"
            },
            {
                "regex": "(?:KSA-(LX[239]|AL00)|Honor 8S)(?:[);/ ]|$)",
                "model": "Honor 8S"
            },
            {
                "regex": "(?:DUA-LX9|Honor 9S)(?:[);/ ]|$)",
                "model": "Honor 9S"
            },
            {
                "regex": "(?:HLK-(?:AL10|L4[12])|Honor 9x Pro)(?:[);/ ]|$)",
                "model": "Honor 9X Pro"
            },
            {
                "regex": "(?:HLK-AL00a?|Honor 9x)(?:[);/ ]|$)",
                "model": "Honor 9X"
            },
            {
                "regex": "DUA-[TA]L00",
                "model": "Honor Play 7"
            },
            {
                "regex": "JAT-[AT]L00|Honor Play 8A",
                "model": "Honor Play 8A"
            },
            {
                "regex": "Honor Play 8",
                "model": "Honor Play 8"
            },
            {
                "regex": "COL-(?:[AT]L[01]0|L29|L10)(?:[);/ ]|$)",
                "model": "Honor 10"
            },
            {
                "regex": "BKK-(?:AL[01]0|L2[12]|LX2|TL00)",
                "model": "Honor 8C"
            },
            {
                "regex": "JSN-(?:L2[123]|L42|[TA]L00[a]?)",
                "model": "Honor 8X"
            },
            {
                "regex": "ARE-(?:AL[10]0|L22(?:HN)?|TL00)",
                "model": "Honor 8X Max"
            },
            {
                "regex": "TNY-[AT]L00",
                "model": "Honor Magic 2"
            },
            {
                "regex": "Honor Magic 2 3D",
                "model": "Honor Magic 2 3D"
            },
            {
                "regex": "PCT-(?:[TA]L10)",
                "model": "Honor V20"
            },
            {
                "regex": "(?:VNA|PCT)-L29",
                "model": "Honor View 20"
            },
            {
                "regex": "(?:Honor_|HW-)?CUN-[AT]L00(?:[);/ ]|$)",
                "model": "Honor 5 Play"
            },
            {
                "regex": "MYA-TL10",
                "model": "Honor 6 Play"
            },
            {
                "regex": "AUM-(?:AL[20]0|L33[A]?|TL20)(?:[);/ ]|$)",
                "model": "Honor 7A"
            },
            {
                "regex": "AUM-L29(?:[);/ ]|$)",
                "model": "Honor 7A Pro"
            },
            {
                "regex": "(?:Honor_|HW-)?(?:LND-(?:AL[34]0|L29|TL[34]0)|AUM-L41)(?:[);/ ]|$)",
                "model": "Honor 7C"
            },
            {
                "regex": "(?:Honor_|HW-)?DUA-(?:L22|LX3)(?:[);/ ]|$)",
                "model": "Honor 7S"
            },
            {
                "regex": "PRA-(?:AL00X|AL00|TL10)",
                "model": "Honor 8 Lite"
            },
            {
                "regex": "RVL-AL09",
                "model": "Honor Note 10"
            },
            {
                "regex": "COR-(?:AL[01]0|L29|TL10)",
                "model": "Honor Play"
            },
            {
                "regex": "STF-(?:AL[10]0|L09S?|TL10)",
                "model": "Honor 9"
            },
            {
                "regex": "LLD-(?:AL[01]0|L[23]1|TL10)",
                "model": "Honor 9 Lite"
            },
            {
                "regex": "LLD-AL[23]0",
                "model": "Honor 9i"
            },
            {
                "regex": "BKL-(?:L04|L09S)",
                "model": "Honor View 10"
            },
            {
                "regex": "BKL-(?:AL[023]0|L09|TL10)",
                "model": "Honor V10"
            },
            {
                "regex": "(?:HONOR[ _]?)?BND-(?:AL[01]0|TL10|L2[14]|L31)",
                "model": "Honor 7X"
            },
            {
                "regex": "(?:HONOR[ _]?)?DLI-(?:AL10|L[24]2|TL20)(?:[);/ ]|$)",
                "model": "Honor 6A"
            },
            {
                "regex": "DIG-L21HN",
                "model": "Honor 6C"
            },
            {
                "regex": "JMM-L22(?:[);/ ]|$)",
                "model": "Honor 6C Pro"
            },
            {
                "regex": "DUK-(?:L09|TL30)",
                "model": "Honor 8 Pro"
            },
            {
                "regex": "EDI-AL10",
                "model": "Honor Note 8"
            },
            {
                "regex": "CAM-UL00",
                "model": "Honor Holly 3"
            },
            {
                "regex": "NTS-AL00",
                "model": "Honor Magic"
            },
            {
                "regex": "DUK-AL20",
                "model": "Honor V9"
            },
            {
                "regex": "JMM-[AT]L[01]0",
                "model": "Honor V9 Play"
            },
            {
                "regex": "Honor 4c Pro(?:[);/ ]|$)",
                "model": "Honor 4C Pro"
            },
            {
                "regex": "AQM-[AT]L10(?:[);/ ]|$)",
                "model": "Honor Play 4T Pro"
            },
            {
                "regex": "(?:Honor_|HW-)?CAM-(?:AL00|TL00H|TL00)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 5A"
            },
            {
                "regex": "(?:Honor_|HW-)?NEM-(?:AL10|L51|UL10|TL00)(?:[);/ ]|$)",
                "model": "Honor 5C"
            },
            {
                "regex": "(?:Honor_|HW-)?NEM-(?:L22|TL00H)(?:[);/ ]|$)",
                "model": "Honor 5C Dual SIM"
            },
            {
                "regex": "(?:HONOR[ _]?)?BLN-(?:L2[124]|AL[1-4]0|TL[01]0(?:[);/ ]|$))",
                "model": "Honor 6X"
            },
            {
                "regex": "(?:Honor_|HW-)?NEM-L21(?:[);/ ]|$)",
                "model": "Honor 7 Lite"
            },
            {
                "regex": "(?:FRD-(?:AL[01]0|L0[249]|L1[49]|DL00)|VAT-L19)(?:[);/ ]|$)",
                "model": "Honor 8"
            },
            {
                "regex": "VEN-L22",
                "model": "Honor 8 Smart"
            },
            {
                "regex": "KNT-(?:AL[12]0|[TU]L10)",
                "model": "Honor V8"
            },
            {
                "regex": "(?:Honor_|HW-)?SCL-(?:AL00|CL00|TL00H?)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 4A"
            },
            {
                "regex": "(?:Honor_|HW-)?CHM-U01(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 4C"
            },
            {
                "regex": "(?:Honor_|HW-)?KIW-(?:AL10|TL00H|[TC]L00|L2[1-4]|UL00)(?:_TD)?(?:[);/ ]|$)",
                "model": "Honor 5X"
            },
            {
                "regex": "(?:Honor[_]?|HW-)?PLK-(?:AL10|CL00|TL00|TL01H?|UL00|L01)(?:[);/ ]|$)",
                "model": "Honor 7"
            },
            {
                "regex": "ATH-(?:[CAU]L00|TL00H?)(?:[);/ ]|$)",
                "model": "Honor 7i"
            },
            {
                "regex": "Holly-U19",
                "model": "Honor Holly"
            },
            {
                "regex": "(?:CHE2?-[UT]L00[HM]?|CHE1-CL[12]0|CHE2-L(?:1[12]|23)|Che1-L04|CHE-TL00)(?:[);/ ]|$)",
                "model": "Honor 4X"
            },
            {
                "regex": "((?:Honor_|HW-)?H60-L(?:01|02|03|04|11|12)(?:_TD)?|HW-H60-J1|MOGOLIA)(?:[);/ ]|$)",
                "model": "Honor 6"
            },
            {
                "regex": "PE-(?:[CU]L00|TL[12]0|TL00M)(?:[);/ ]|$)",
                "model": "Honor 6 Plus"
            },
            {
                "regex": "(AGS2-AL00|JDN2-(?:AL00|W09))HN",
                "device": "tablet",
                "model": "Honor Tab 5"
            },
            {
                "regex": "HDN-[LW]09",
                "model": "Honor Water Play 10.1",
                "device": "tablet"
            },
            {
                "regex": "HDL-(?:W09|AL09)",
                "model": "Honor Water Play 8.0",
                "device": "tablet"
            },
            {
                "regex": "JDN-(?:AL00|W09)",
                "model": "Honor Pad 2",
                "device": "tablet"
            },
            {
                "regex": "VKY-TL00",
                "model": "P10 Plus"
            },
            {
                "regex": "VOG-AL00",
                "model": "P30 Pro"
            },
            {
                "regex": "ANA-(?:[AT]N00)",
                "model": "P40 5G"
            },
            {
                "regex": "ANA-(?:AL00|N29|L04)",
                "model": "P40"
            },
            {
                "regex": "ANA-NX9",
                "model": "P40 Dual"
            },
            {
                "regex": "U8500(?:[);/ ]|$)",
                "model": "Ideos X2"
            },
            {
                "regex": "U8510(?:[);/ ]|$)",
                "model": "Ideos X3"
            },
            {
                "regex": "U8800(?:[);/ ]|$)",
                "model": "Ideos X5"
            },
            {
                "regex": "IDEOS[_ ]X5[_ ]PRO(?:[);/ ]|$)",
                "model": "Ideos X5 Pro"
            },
            {
                "regex": "MLA-AL10(?:[);/ ]|$)",
                "model": "Maimang 5"
            },
            {
                "regex": "RIO-AL00",
                "model": "Maimang 4"
            },
            {
                "regex": "POT-AL10(?:[);/ ]|$)",
                "model": "Maimang 8"
            },
            {
                "regex": "TNN-AN00(?:[);/ ]|$)",
                "model": "Maimang 9"
            },
            {
                "regex": "TYH601M",
                "model": "Maimang 9 5G"
            },
            {
                "regex": "Maimang (\\d)(?:[);/ ]|$)",
                "model": "Maimang $1"
            },
            {
                "regex": "(?:TAH-(?:N29|AN00)m|Mate Xs)(?:[);/ ]|$)",
                "model": "Mate XS"
            },
            {
                "regex": "PAL-(?:AL00|LX9)",
                "model": "Mate XS 2"
            },
            {
                "regex": "TAH-AN00",
                "model": "Mate X"
            },
            {
                "regex": "ALT-(?:AL00|L29)",
                "model": "Mate X3"
            },
            {
                "regex": "ALT-AL10",
                "model": "Mate X5"
            },
            {
                "regex": "ICL-(?:AL[12]0|LX9)",
                "model": "Mate X6"
            },
            {
                "regex": "TET-(?:A[NL]00|AN10)",
                "model": "Mate X2"
            },
            {
                "regex": "TET-AN50",
                "model": "Mate X2 5G"
            },
            {
                "regex": "ALP-(?:[TA]L00|L[02]9|L09S|L29S)(?:[);/ ]|$)",
                "model": "Mate 10"
            },
            {
                "regex": "RNE-(?:AL00|L(?:0[13]|2[13]))(?:[);/ ]|$)",
                "model": "Mate 10 Lite"
            },
            {
                "regex": "BLA-(?:A09|L[02]9|L29S|[TA]L00)(?:[);/ ]|$)",
                "model": "Mate 10 Pro"
            },
            {
                "regex": "HMA-(?:[AT]L00|L[02]9)(?:[);/ ]|$)",
                "model": "Mate 20"
            },
            {
                "regex": "SNE-(?:AL00|LX[0-3]|L01)(?:[);/ ]|$)",
                "model": "Mate 20 Lite"
            },
            {
                "regex": "(?:LYA-(?:AL[01]0|L[02]9|L0C|TL00)|PAN-L29)(?:[);/ ]|$)",
                "model": "Mate 20 Pro"
            },
            {
                "regex": "LYA-AL00P(?:[);/ ]|$)",
                "model": "Mate 20 RS"
            },
            {
                "regex": "EVR-(?:[TA]L00|L29|N29|AN00)(?:[);/ ]|$)",
                "model": "Mate 20 X"
            },
            {
                "regex": "(?:TAS-([AT]L00|L[02]9)|AMZ-L29)(?:[);/ ]|$)",
                "model": "Mate 30"
            },
            {
                "regex": "TAS-AN00",
                "model": "Mate 30 5G"
            },
            {
                "regex": "(?:LIO-AN00P|Mate30 RS)(?:[);/ ]|$)",
                "model": "Mate 30 RS Porsche Design"
            },
            {
                "regex": "SPN-AL00(?:[);/ ]|$)",
                "model": "Mate 30 Lite"
            },
            {
                "regex": "LIO-(?:[TA]L00|L[02]9|AN00)(?:[);/ ]|$)",
                "model": "Mate 30 Pro"
            },
            {
                "regex": "LIO-(?:N29|TN00|AL10)(?:[);/ ]|$)",
                "model": "Mate 30 Pro 5G"
            },
            {
                "regex": "LIO-AN00m(?:[);/ ]|$)",
                "model": "Mate 30E Pro 5G"
            },
            {
                "regex": "NOH-(?:NX9|AN0[01]|AN50|AL[01]0)(?:[);/ ]|$)",
                "model": "Mate 40 Pro"
            },
            {
                "regex": "NOH-AN80",
                "model": "Mate 40E Pro 5G"
            },
            {
                "regex": "NOP-AN00(?:[);/ ]|$)",
                "model": "Mate 40 Pro+"
            },
            {
                "regex": "Mate 40 RS(?:[);/ ]|$)",
                "model": "Mate 40 RS"
            },
            {
                "regex": "OCE-AN10(?:[);/ ]|$)",
                "model": "Mate 40"
            },
            {
                "regex": "OCE-(?:A[NL]50|AN00)(?:[);/ ]|$)",
                "model": "Mate 40E"
            },
            {
                "regex": "DCO-(?:AL00|LX9)",
                "model": "Mate 50 Pro"
            },
            {
                "regex": "CET-(?:AL00|LX9)",
                "model": "Mate 50"
            },
            {
                "regex": "CET-AL60",
                "model": "Mate 50E"
            },
            {
                "regex": "ALN-AL[08]0",
                "model": "Mate 60 Pro"
            },
            {
                "regex": "ALN-AL10",
                "model": "Mate 60 Pro+"
            },
            {
                "regex": "BRA-AL00",
                "model": "Mate 60"
            },
            {
                "regex": "NXT-(?:AL10|L[02]9)(?:[);/ ]|$)",
                "model": "Mate 8"
            },
            {
                "regex": "(?:MHA-(?:L[02]9|[AT]L00)|M300-L09)(?:[);/ ]|$)",
                "model": "Mate 9"
            },
            {
                "regex": "BLL-L23(?:[);/ ]|$)",
                "model": "Mate 9 Lite"
            },
            {
                "regex": "LON-(?:AL00(?:-PD)?|L29)(?:[);/ ]|$)",
                "model": "Mate 9 Pro"
            },
            {
                "regex": "NEO-AL00(?:[);/ ]|$)",
                "model": "Mate RS"
            },
            {
                "regex": "NEO-L29(?:[);/ ]|$)",
                "model": "Mate RS Porsche Design"
            },
            {
                "regex": "CRR-(?:L09|UL[20]0|CL00)(?:[);/ ]|$)",
                "model": "Mate S"
            },
            {
                "regex": "BND-L34(?:[);/ ]|$)",
                "model": "Mate SE"
            },
            {
                "regex": "(CAZ-(?:AL[01]0|TL[12]0)|CAN-L[01][1-3])(?:[);/ ]|$)",
                "model": "Nova"
            },
            {
                "regex": "(?:608HW|PRA-LX[23])(?:[);/ ]|$)",
                "model": "Nova Lite"
            },
            {
                "regex": "MLA-L1[12](?:[);/ ]|$)",
                "model": "Nova Plus"
            },
            {
                "regex": "nova Lite3Plus(?:[);/ ]|$)",
                "model": "Nova Lite 3+"
            },
            {
                "regex": "(?:PIC-(?:[AT]L00|LX9)|HWV31)(?:[);/ ]|$)",
                "model": "Nova 2"
            },
            {
                "regex": "704HW(?:[);/ ]|$)",
                "model": "Nova 2 Lite"
            },
            {
                "regex": "BAC-(?:L0[13]|TL00)(?:[);/ ]|$)",
                "model": "Nova 2 Plus"
            },
            {
                "regex": "BAC-(?:AL00|L2[12])(?:[);/ ]|$)",
                "model": "Nova 2 Plus Dual SIM"
            },
            {
                "regex": "RNE-L[02]2(?:[);/ ]|$)",
                "model": "Nova 2I"
            },
            {
                "regex": "HWI-[AT]L00(?:[);/ ]|$)",
                "model": "Nova 2S"
            },
            {
                "regex": "PAR-(?:[AT]L00|LX[19]|LX1M|TL20)(?:[);/ ]|$)",
                "model": "Nova 3"
            },
            {
                "regex": "ANE-AL00(?:[);/ ]|$)",
                "model": "Nova 3e"
            },
            {
                "regex": "INE-(?:AL00|LX[12]r|LX[12]|TL00)|IVY-LX2",
                "model": "Nova 3i"
            },
            {
                "regex": "VCE-(L22|[AT]L00)(?:[);/ ]|$)",
                "model": "Nova 4"
            },
            {
                "regex": "MAR-AL00(?:[);/ ]|$)",
                "model": "Nova 4e"
            },
            {
                "regex": "SEA-[AT]L00(?:[);/ ]|$)",
                "model": "Nova 5"
            },
            {
                "regex": "SEA-AL10(?:[);/ ]|$)",
                "model": "Nova 5 Pro"
            },
            {
                "regex": "GLK-(?:[AT]L00|LX1U|LX[23])(?:[);/ ]|$)",
                "model": "Nova 5i"
            },
            {
                "regex": "YAL-L61|Yale-(?:L71A|L61D)",
                "model": "Nova 5T"
            },
            {
                "regex": "nova 5T Pro",
                "model": "Nova 5T Pro"
            },
            {
                "regex": "SPN-TL00(?:[);/ ]|$)",
                "model": "Nova 5i Pro"
            },
            {
                "regex": "(?:WLZ-[AT]N00|nova 6 5G)(?:[);/ ]|$)",
                "model": "Nova 6 5G"
            },
            {
                "regex": "(?:JNY-[AT]L10|nova 6SE)(?:[);/ ]|$)",
                "model": "Nova 6 SE"
            },
            {
                "regex": "(?:WLZ-AL10|nova 6)(?:[);/ ]|$)",
                "model": "Nova 6"
            },
            {
                "regex": "(?:JEF-(?:[AT]N00|[AT]N20|NX9)|nova 7 5G)(?:[);/ ]|$)",
                "model": "Nova 7 5G"
            },
            {
                "regex": "(?:JER-(?:[AT]N10|[AT]N20)|nova 7 Pro 5G)(?:[);/ ]|$)",
                "model": "Nova 7 Pro 5G"
            },
            {
                "regex": "(?:CDY-(?:[AT]N00|NX9B|[AT]N20)|CDL-AN50|CND-AN00|nova 7 SE 5G)(?:[);/ ]|$)",
                "model": "Nova 7 SE 5G"
            },
            {
                "regex": "MAO-LX9",
                "model": "Nova 11i"
            },
            {
                "regex": "GOA-AL80U",
                "model": "Nova 11 Ultra"
            },
            {
                "regex": "GOA-(?:LX9|AL80)",
                "model": "Nova 11 Pro"
            },
            {
                "regex": "FOA-(?:LX9|AL00)",
                "model": "Nova 11"
            },
            {
                "regex": "FIN-AL60a?",
                "model": "Nova 12 Lite"
            },
            {
                "regex": "BON-AL00",
                "model": "Nova 11 SE"
            },
            {
                "regex": "ADA-AL00U",
                "model": "Nova 12 Ultra"
            },
            {
                "regex": "ADA-AL10U",
                "model": "Nova 12"
            },
            {
                "regex": "CTR-L81",
                "model": "Nova 12i"
            },
            {
                "regex": "CTR-L91",
                "model": "Nova 13i"
            },
            {
                "regex": "MIS-LX9",
                "model": "Nova 13 Pro"
            },
            {
                "regex": "ADA-AL00",
                "model": "Nova 12 Pro"
            },
            {
                "regex": "BLK-AL00",
                "model": "Nova 12"
            },
            {
                "regex": "BLK-(?:AL80|LX9)",
                "model": "Nova 13"
            },
            {
                "regex": "TLR-AL00",
                "model": "Nova 14"
            },
            {
                "regex": "(?:JNY-LX2|nova 7i)(?:[);/ ]|$)",
                "model": "Nova 7i"
            },
            {
                "regex": "(?:NEN-L(?:X[13]|22)|nova 8i)(?:[);/ ]|$)",
                "model": "Nova 8i"
            },
            {
                "regex": "ANG-AN00(?:[);/ ]|$)",
                "model": "Nova 8 5G"
            },
            {
                "regex": "JSC-AN00",
                "model": "Nova 8 SE 5G"
            },
            {
                "regex": "JSC-AL50|nova 8 SE",
                "model": "Nova 8 SE 4G"
            },
            {
                "regex": "CHL-AL60",
                "model": "Nova 8 SE Vitality"
            },
            {
                "regex": "BRQ-AL00(?:[);/ ]|$)",
                "model": "Nova 8 Pro 4G"
            },
            {
                "regex": "BRQ-AN00(?:[);/ ]|$)",
                "model": "Nova 8 Pro 5G"
            },
            {
                "regex": "(?:ANG-LX[12]|Angela-(?:L2[12]B|L02B)|nova 8)(?:[);/ ]|$)",
                "model": "Nova 8"
            },
            {
                "regex": "NAM-(?:AL00|LX9)(?:[);/ ]|$)",
                "model": "Nova 9"
            },
            {
                "regex": "RTE-AL00(?:[);/ ]|$)",
                "model": "Nova 9 Pro"
            },
            {
                "regex": "JLN-(?:AL00|LX[13])|JuliaQN-(?:L[02]1B|L23A)",
                "model": "Nova 9 SE"
            },
            {
                "regex": "GLA-(?:LX[13]|AL00)",
                "model": "Nova 10 Pro"
            },
            {
                "regex": "NCO-(?:AL00|LX[13])",
                "model": "Nova 10 4G"
            },
            {
                "regex": "BNE-(?:LX[13]|AL00)",
                "model": "Nova 10 SE"
            },
            {
                "regex": "CHA-AL80",
                "model": "Nova 10z"
            },
            {
                "regex": "MAO-LX9N",
                "model": "Nova 11i"
            },
            {
                "regex": "DIG-L01(?:[);/ ]|$)",
                "model": "Nova Smart"
            },
            {
                "regex": "WAS-AL00(?:[);/ ]|$)",
                "model": "Nova Youth"
            },
            {
                "regex": "WKG-[AT]N00|Enjoy 20 5G",
                "model": "Enjoy 20 5G"
            },
            {
                "regex": "(?:WKG-LX9|Wukong-L29A|nova Y60)(?:[);/ ]|$)",
                "model": "Nova Y60"
            },
            {
                "regex": "EVE-LX[39]",
                "model": "Nova Y61"
            },
            {
                "regex": "MGA-LX[39]",
                "model": "Nova Y70"
            },
            {
                "regex": "GFY-LX1",
                "model": "Nova Y72S"
            },
            {
                "regex": "CTR-LX[123]|CHW-LX3",
                "model": "Nova Y90"
            },
            {
                "regex": "STG-LX[12]",
                "model": "Nova Y91"
            },
            {
                "regex": "FIG-L(?:A1|X[123]|[13]1)(?:[);/ ]|$)",
                "model": "P smart"
            },
            {
                "regex": "POT-(?:LX(?:[123]|1T|2J|1AF)|AL00|L01)(?:[);/ ]|$)",
                "model": "P smart (2019)"
            },
            {
                "regex": "POT-LX1A(?:[);/ ]|$)",
                "model": "P smart (2020)"
            },
            {
                "regex": "PPA-LX[12]",
                "model": "P smart (2021)"
            },
            {
                "regex": "STK-LX1(?:[);/ ]|$)",
                "model": "P smart Z"
            },
            {
                "regex": "P Smart S(?:[);/ ]|$)",
                "model": "P smart S"
            },
            {
                "regex": "VTR-(?:L[02]9|AL00|TL00)(?:[);/ ]|$)",
                "model": "P10"
            },
            {
                "regex": "WAS-(?:L(?:X1|X1A|X2|X2J|X3|03T)|TL10)(?:[);/ ]|$)",
                "model": "P10 Lite"
            },
            {
                "regex": "VKY-(?:AL00|L09|L29)(?:[);/ ]|$)",
                "model": "P10 Plus"
            },
            {
                "regex": "BAC-L[02]3(?:[);/ ]|$)",
                "model": "P10 Selfie"
            },
            {
                "regex": "EML-(?:[TA]L00|L[02]9)(?:[);/ ]|$)",
                "model": "P20"
            },
            {
                "regex": "(?:ANE-(?:LX[123]|LX2J|L2[23]|TL00)|HWV32)(?:[);/ ]|$)",
                "model": "P20 Lite"
            },
            {
                "regex": "(?:CLT-(?:AL0[01]|TL0[01]|L0J|L(?:04|[02]9))l?|HW-01K)(?:[);/ ]|$)",
                "model": "P20 Pro"
            },
            {
                "regex": "(?:ELE-L(?:04|09|29)|ELE-[AT]L00)(?:[);/ ]|$)",
                "model": "P30"
            },
            {
                "regex": "(?:MAR-(?:LX(?:1[BM]|2B|[13]Am?|2J?|3BM)|TL00|L21B|L21ME[AB])|NIC-LX1A|HWV33)(?:[);/ ]|$)",
                "model": "P30 Lite"
            },
            {
                "regex": "Marie-L21BX",
                "model": "P30 Lite NE"
            },
            {
                "regex": "(?:VOG-(?:L(?:04|09|29)|TL00|AL10)|HW-02L)(?:[);/ ]|$)",
                "model": "P30 Pro"
            },
            {
                "regex": "ANA-LX4(?:[);/ ]|$)",
                "model": "P40"
            },
            {
                "regex": "JNY-(?:LX1|L[02]1)(?:[);/ ]|$)",
                "model": "P40 Lite"
            },
            {
                "regex": "ART-L29(?:[);/ ]|$)",
                "model": "P40 Lite E"
            },
            {
                "regex": "ART-L29N(?:[);/ ]|$)",
                "model": "P40 Lite E NFC"
            },
            {
                "regex": "(?:ELS-(?:[AT]N00|NX9|N04)|NEY-NX9)(?:[);/ ]|$)",
                "model": "P40 Pro"
            },
            {
                "regex": "ELS-(?:AN10|N[23]9)(?:[);/ ]|$)",
                "model": "P40 Pro Plus"
            },
            {
                "regex": "GRA-(?:L09|[TU]L00)(?:[);/ ]|$)",
                "model": "P8"
            },
            {
                "regex": "HUAWEI P8max(?:[);/ ]|$)",
                "model": "P8 Max"
            },
            {
                "regex": "GRA-UL10(?:[);/ ]|$)",
                "model": "P8 Premium"
            },
            {
                "regex": "(?:ALE-L(?:02|2[13])|ALE-[TUC]L00|503HW)(?:[);/ ]|$)",
                "model": "P8 Lite (2015)"
            },
            {
                "regex": "(?:PRA-L(?:A1|X[12])|hi6210sft)(?:[);/ ]|$)",
                "model": "P8 Lite (2017)"
            },
            {
                "regex": "EVA-(?:AL[10]0|L[012]9|[TCD]L00)(?:[);/ ]|$)",
                "model": "P9"
            },
            {
                "regex": "VNS-L(?:[23]1|[26]2|53|23)(?:[);/ ]|$)",
                "model": "P9 Lite"
            },
            {
                "regex": "VNS-L52(?:[);/ ]|$)",
                "model": "P9 Lite Premium"
            },
            {
                "regex": "SLA-L(?:02|03|22|23)(?:[);/ ]|$)",
                "model": "P9 Lite Mini"
            },
            {
                "regex": "DIG-L(?:03|23)(?:[);/ ]|$)",
                "model": "P9 Lite Smart"
            },
            {
                "regex": "VIE-(?:AL10|L[02]9)(?:[);/ ]|$)",
                "model": "P9 Plus"
            },
            {
                "regex": "MLA-TL[01]0(?:[);/ ]|$)",
                "model": "G9 Plus"
            },
            {
                "regex": "VNS-[AT]L00(?:[);/ ]|$)",
                "model": "G9 Lite"
            },
            {
                "regex": "ATH-UL0[16](?:[);/ ]|$)",
                "model": "ShotX"
            },
            {
                "regex": "U(8230|8661|8667)(?:[);/ ]|$)",
                "model": "U$1"
            },
            {
                "regex": "ARS-([AT]L00|L22)(?:[);/ ]|$)",
                "model": "Y Max"
            },
            {
                "regex": "CRO-(?:L[02]2|U00)(?:[);/ ]|$)",
                "model": "Y3 (2017)"
            },
            {
                "regex": "CAG-L[02]2(?:[);/ ]|$)",
                "model": "Y3 (2018)"
            },
            {
                "regex": "LUA-(U22|L2[12]|U03)(?:[);/ ]|$)",
                "model": "Y3II"
            },
            {
                "regex": "MYA-(?:L(?:0[23]|2[23])|U29)(?:[);/ ]|$)",
                "model": "Y5 (2017)"
            },
            {
                "regex": "DRA-L(?:0[13]|2[13]|X3)(?:[);/ ]|$)",
                "model": "Y5 (2018)"
            },
            {
                "regex": "AMN-LX[1239](?:[);/ ]|$)",
                "model": "Y5 (2019)"
            },
            {
                "regex": "DRA-LX5(?:[);/ ]|$)",
                "model": "Y5 Lite"
            },
            {
                "regex": "DRA-LX9(?:[);/ ]|$)",
                "model": "Y5p"
            },
            {
                "regex": "CRO-L[02]3(?:[);/ ]|$)",
                "model": "Y5 Lite (2017)"
            },
            {
                "regex": "CAG-L[02]3(?:[);/ ]|$)",
                "model": "Y5 Lite (2018)"
            },
            {
                "regex": "DRA-(?:LX2|[AT]L00)(?:[);/ ]|$)",
                "model": "Y5 Prime (2018)"
            },
            {
                "regex": "MYA-L13(?:[);/ ]|$)",
                "model": "Y5 Pro (2017)"
            },
            {
                "regex": "CUN-(?:L(?:0[123]|2[123]|33)|U29)(?:[);/ ]|$)",
                "model": "Y5II"
            },
            {
                "regex": "(?:SCC-U21|(?:HW-)?SCL-(?:U31|L21|L0[1-4]|L32))(?:[);/ ]|$)",
                "model": "Y6"
            },
            {
                "regex": "(?:Honor_|HW-)?LYO-L[02]1(?:[);/ ]|$)",
                "model": "Y6 II Compact"
            },
            {
                "regex": "(?:Honor_|HW-)?LYO-L02(?:[);/ ]|$)",
                "model": "Y6 Elite"
            },
            {
                "regex": "MYA-L11(?:[);/ ]|$)",
                "model": "Y6 (2016)"
            },
            {
                "regex": "MYA-(L41|AL10)(?:[);/ ]|$)",
                "model": "Y6 (2017)"
            },
            {
                "regex": "ATU-L(?:11|21|22|X3)(?:[);/ ]|$)",
                "model": "Y6 (2018)"
            },
            {
                "regex": "(?:MRD-L(?:X1[NF]?|X3)|Y6 2019)(?:[);/ ]|$)",
                "model": "Y6 (2019)"
            },
            {
                "regex": "(?:ATU-L(?:31|42)|Y6Prime)(?:[);/ ]|$)",
                "model": "Y6 Prime (2018)"
            },
            {
                "regex": "TIT-(?:AL00|L01|U02)(?:[);/ ]|$)",
                "model": "Y6 Pro"
            },
            {
                "regex": "(?:M[ER]D-LX2|Y6 Pro 2019)(?:[);/ ]|$)",
                "model": "Y6 Pro (2019)"
            },
            {
                "regex": "Y625-U03(?:[);/ ]|$)",
                "model": "Y625"
            },
            {
                "regex": "Y635-L0[123](?:[);/ ]|$)",
                "model": "Y635"
            },
            {
                "regex": "Y635-L21(?:[);/ ]|$)",
                "model": "Y635 Dual SIM"
            },
            {
                "regex": "CAM-L(?:03|2[13]|32)(?:[);/ ]|$)",
                "model": "Y6II"
            },
            {
                "regex": "TRT-LX[123](?:[);/ ]|$)",
                "model": "Y7 (2017)"
            },
            {
                "regex": "LDN-L(?:01|X3)(?:[);/ ]|$)",
                "model": "Y7 (2018)"
            },
            {
                "regex": "(?:HUAWEI[ _]?)?DUB-(?:LX[13]|TL00)(?:[);/ ]|$)",
                "model": "Y7 (2019)"
            },
            {
                "regex": "(?:LDN-(?:AL00|L21)|TRT-TL10)(?:[);/ ]|$)",
                "model": "Y7 Prime"
            },
            {
                "regex": "(?:LDN-(?:LX2|TL10)|TRT-(?:L21A|L53))(?:[);/ ]|$)",
                "model": "Y7 Prime (2018)"
            },
            {
                "regex": "DUB-(?:LX2|AL00)(?:[);/ ]|$)",
                "model": "Y7 Pro (2019)"
            },
            {
                "regex": "DUB-AL00a(?:[);/ ]|$)",
                "model": "Enjoy 9"
            },
            {
                "regex": "DUB-AL20(?:[);/ ]|$)",
                "model": "Y7 Pro (2019)"
            },
            {
                "regex": "(?:PPA-LX3|Peppa-(?:L2[23]B|L0[23]B))(?:[);/ ]|$)",
                "model": "Y7a"
            },
            {
                "regex": "ART-L28(?:[);/ ]|$)",
                "model": "Y7p"
            },
            {
                "regex": "AQM-LX1(?:[);/ ]|$)",
                "model": "Y8p"
            },
            {
                "regex": "FLA-(LX[123]|AL20|TL10|L23)(?:[);/ ]|$)",
                "model": "Y9 (2018)"
            },
            {
                "regex": "JKM-(?:[TA]L00[ab]?|LX[123]|L03)(?:[);/ ]|$)",
                "model": "Y9 (2019)"
            },
            {
                "regex": "STK-(L2[12]|LX3)|LTK-LX3",
                "model": "Y9 Prime (2019)"
            },
            {
                "regex": "FRL-L2[123](?:[);/ ]|$)",
                "model": "Y9a"
            },
            {
                "regex": "302HW(?:[);/ ]|$)",
                "model": "Stream S"
            },
            {
                "regex": "NMO-L31(?:[);/ ]|$)",
                "model": "GT3"
            },
            {
                "regex": "CM990(?:[);/ ]|$)",
                "model": "Evolucion 3"
            },
            {
                "regex": "Ultym5(?:[);/ ]|$)",
                "model": "Ultym 5"
            },
            {
                "regex": "G6-L11(?:[);/ ]|$)",
                "model": "Ascend G6"
            },
            {
                "regex": "Nexus 6P(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Nexus 6P"
            },
            {
                "regex": "GRL-(?:AL10|LX9)",
                "device": "phablet",
                "model": "Mate XT Ultimate Design"
            },
            {
                "regex": "KOB2K-L09",
                "device": "tablet",
                "model": "MatePad T8 8\" LTE"
            },
            {
                "regex": "BVE-W10",
                "model": "Qinyun C5z 10.4\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "HWT31(?:[);/ ]|$)",
                "model": "Qua Tab 02 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "BAH4-(?:L09|AL10)",
                "model": "MatePad 10.4\" (2022)",
                "device": "tablet"
            },
            {
                "regex": "BAH4-W(?:29|[03]9)",
                "model": "MatePad 10.4\" (2022) WiFi",
                "device": "tablet"
            },
            {
                "regex": "BAH3-(?:AL00|[LW]09)(?:[);/ ]|$)",
                "model": "MatePad 10.4\"",
                "device": "tablet"
            },
            {
                "regex": "BAH3-W59",
                "model": "MatePad 10.4\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "BAH3-AN10",
                "model": "MatePad 10.4\" 5G",
                "device": "tablet"
            },
            {
                "regex": "DB[YR]-W09",
                "device": "tablet",
                "model": "MatePad 11 WiFi"
            },
            {
                "regex": "AGS6-W09",
                "device": "tablet",
                "model": "MatePad SE 11 WiFi"
            },
            {
                "regex": "AGS6-L09",
                "device": "tablet",
                "model": "MatePad SE 11"
            },
            {
                "regex": "BKY-W09",
                "device": "tablet",
                "model": "MatePad 12 X WiFi"
            },
            {
                "regex": "DBR-W1[09]",
                "model": "MatePad 11 (2023) WiFi",
                "device": "tablet"
            },
            {
                "regex": "GOT-AL[01]9(?:[);/ ]|$)",
                "model": "MatePad Pro 11",
                "device": "tablet"
            },
            {
                "regex": "GOT-W[02]9(?:[);/ ]|$)",
                "model": "MatePad Pro 11 WiFi",
                "device": "tablet"
            },
            {
                "regex": "XYAO-W00",
                "model": "MatePad Pro 11 (2024) WiFi",
                "device": "tablet"
            },
            {
                "regex": "SCMR-W09(?:[);/ ]|$)",
                "model": "MatePad 10.8\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "SCMR-AL09(?:[);/ ]|$)",
                "model": "MatePad 10.8\"",
                "device": "tablet"
            },
            {
                "regex": "AGS3-(A?L09|AL00)(?:[);/ ]|$)",
                "model": "MatePad T10s",
                "device": "tablet"
            },
            {
                "regex": "AGS3-W0?9(?:[);/ ]|$)",
                "model": "MatePad T10s WiFi",
                "device": "tablet"
            },
            {
                "regex": "AGS5-(?:L09|AL00)(?:[);/ ]|$)",
                "model": "MatePad 10.4\" SE",
                "device": "tablet"
            },
            {
                "regex": "DBY2-W0[09]",
                "model": "MatePad 11.5\" Air WiFi",
                "device": "tablet"
            },
            {
                "regex": "DBY2-L09",
                "model": "MatePad 11.5\" Air",
                "device": "tablet"
            },
            {
                "regex": "BTK-AL09",
                "model": "MatePad 11.5\" LTE",
                "device": "tablet"
            },
            {
                "regex": "BTK-W09",
                "model": "MatePad 11.5\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "BTKR-W09",
                "model": "MatePad 11.5\" (2024) WiFi",
                "device": "tablet"
            },
            {
                "regex": "TGR-(?:W0[09]|W10)",
                "model": "MatePad 11.5\" S WiFi",
                "device": "tablet"
            },
            {
                "regex": "AGS5-W0[09](?:[);/ ]|$)",
                "model": "MatePad 10.4\" SE WiFi",
                "device": "tablet"
            },
            {
                "regex": "HMW-W09(?:[);/ ]|$)",
                "model": "MatePad Paper 10.3\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "MON-(W|AL)19(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MatePad C5 8"
            },
            {
                "regex": "BZA-W00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C3 9.6\" WiFi"
            },
            {
                "regex": "BZA-L00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C3 9.6\""
            },
            {
                "regex": "BZC-AL00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C3 9.7\" (2020)"
            },
            {
                "regex": "BZC-W00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C3 9.7\" (2020) WiFi"
            },
            {
                "regex": "BZW-AL[01]0(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C5 8\" LTE"
            },
            {
                "regex": "BZT4-W19(?:[);/ ]|$)",
                "device": "tablet",
                "model": "C5 10.4\" WiFi"
            },
            {
                "regex": "M2-80[123]L(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M2 8.0\""
            },
            {
                "regex": "M2-A01L(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M2 10.1\""
            },
            {
                "regex": "M2-801W(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M2 8.0\" WiFi"
            },
            {
                "regex": "MRX-AL[01]9(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MatePad Pro 10.8\""
            },
            {
                "regex": "MRX-W[0-3]9(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MatePad Pro 10.8\" WiFi"
            },
            {
                "regex": "MRR-W[23]9",
                "device": "tablet",
                "model": "MatePad Pro 10.8\" (2021) WiFi"
            },
            {
                "regex": "MRO-W09",
                "device": "tablet",
                "model": "MatePad Pro 12.2\" (2024) WiFi"
            },
            {
                "regex": "MRX-AN19(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MatePad Pro 10.8\" 5G"
            },
            {
                "regex": "WGRR?-W[10]9",
                "device": "tablet",
                "model": "MatePad Pro 12.6\" WiFi"
            },
            {
                "regex": "WGR-AN19",
                "device": "tablet",
                "model": "MatePad Pro 12.6\""
            },
            {
                "regex": "PCE-W(?:29|[34]0)",
                "device": "tablet",
                "model": "MatePad Pro 13.2\" WiFi"
            },
            {
                "regex": "WEB-W0[09]",
                "device": "tablet",
                "model": "MatePad Pro 13.2\" (2025) WiFi"
            },
            {
                "regex": "CMR-(?:AL[01]9|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 10.8"
            },
            {
                "regex": "CMR-W19(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 Pro 10.8"
            },
            {
                "regex": "SCM-AL09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M6 10.8\""
            },
            {
                "regex": "GEM-70[1-3]L(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad X2"
            },
            {
                "regex": "(?:JDN2-(:?[WL]09|AL[50]0|AL50HN)|BAH2-(?:AL[01]0|L09|W[01]9))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 Lite"
            },
            {
                "regex": "SHT-(?:AL|W)09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M5 8.4"
            },
            {
                "regex": "VRD-(?:(AL|W)09|AL10|W10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M6 8.4"
            },
            {
                "regex": "SCM-W09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M6 10.8\" WiFi"
            },
            {
                "regex": "BTV-W09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M3 8"
            },
            {
                "regex": "(?:BAH-W09|Bach-W09|CPN-(?:L|W)09|CPN-AL00|701HW)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M3 Lite"
            },
            {
                "regex": "BAH-(?:L09|AL00)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad M3 Lite 10"
            },
            {
                "regex": "BTV-DL09",
                "device": "tablet",
                "model": "MediaPad M3"
            },
            {
                "regex": "AGS2-(?:[LW]09|W09HN|W19|L03)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T5 10"
            },
            {
                "regex": "(?:KOB2-(?:[LW]09|L03)|Kobe3-L09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T 8.0\""
            },
            {
                "regex": "AGR-[LW]09(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T 10"
            },
            {
                "regex": "AGS-(?:L0[39]|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T3 10"
            },
            {
                "regex": "(?:KOB-(?:L|W)09|BZK-[LW]00)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T3 8"
            },
            {
                "regex": "BG2-(?:U0[13]|W09)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T3 7"
            },
            {
                "regex": "BGO-L03(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 7.0"
            },
            {
                "regex": "(?:BGO-DL09|PLE-70[13]L)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 7.0 Pro"
            },
            {
                "regex": "JDN-L01(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 8.0 Pro"
            },
            {
                "regex": "(?:FDR-(A01[LW]|A03L)|60[56]HW)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T2 10.0\" Pro"
            },
            {
                "regex": "(?:T1-(?:A21[LW]|A2[23]L)|MediaPad T1 10 4G)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T1 10"
            },
            {
                "regex": "T1-701u(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T1 7"
            },
            {
                "regex": "(?:T1-82(?:3L|1W)|MediaPad T1 8\\.0)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MediaPad T1 8"
            },
            {
                "regex": "AGS3K-W20",
                "device": "tablet",
                "model": "MediaPad SE 10.1\" WiFi"
            },
            {
                "regex": "AGS3K-W0[90]",
                "device": "tablet",
                "model": "MediaPad T10s 10.1\" WiFi"
            },
            {
                "regex": "AGS3K-L09",
                "device": "tablet",
                "model": "MediaPad T10s 10.1\" LTE"
            },
            {
                "regex": "AGRK-W09",
                "device": "tablet",
                "model": "MediaPad T10 9.7\" WiFi"
            },
            {
                "regex": "AGRK-L09",
                "device": "tablet",
                "model": "MediaPad T10 9.7\" LTE"
            },
            {
                "regex": "AGS2-AL00(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Enjoy Tablet 10.1"
            },
            {
                "regex": "AGS3-W00[DE](?:[);/ ]|$)",
                "device": "tablet",
                "model": "Enjoy Tablet 2 10.1\" WiFi"
            },
            {
                "regex": "BZT-(?:AL[01]0)",
                "device": "tablet",
                "model": "MediaPad C5 10.1"
            },
            {
                "regex": "BZT-W09",
                "device": "tablet",
                "model": "MediaPad C5 10.1\" WiFi"
            },
            {
                "regex": "MON-AL19B",
                "device": "tablet",
                "model": "MediaPad C5 8\""
            },
            {
                "regex": "BZI-AL[02]0",
                "model": "MatePad C5e 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "BZI-W[02]0",
                "model": "MatePad C5e 10.1\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "BZT3-W09",
                "model": "C5 10.4\" WiFi",
                "device": "tablet"
            },
            {
                "regex": "BZT3-AL00",
                "model": "C5 10.4\"",
                "device": "tablet"
            },
            {
                "regex": "BZD-W00",
                "device": "tablet",
                "model": "MediaPad C3 8.0\" WiFi"
            },
            {
                "regex": "BZD-AL00",
                "device": "tablet",
                "model": "MediaPad C3 8.0\""
            },
            {
                "regex": "(?:d-01J|d-02[HK])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "D Tab Compact"
            },
            {
                "regex": "(?:dtab)?(d-01[KH]|01)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "dtab $1"
            },
            {
                "regex": "LEO-BX9(?:[);/ ]|$)",
                "device": "wearable",
                "model": "Smart Watch 2"
            },
            {
                "regex": "LEO-DLXXE?",
                "device": "wearable",
                "model": "Smart Watch 2 Sport"
            },
            {
                "regex": "GLL-AL01",
                "device": "wearable",
                "model": "Watch 3 Pro Elite"
            },
            {
                "regex": "ARC-AL00",
                "device": "wearable",
                "model": "Watch 4"
            },
            {
                "regex": "BLM-00(?:[);/ ]|$)",
                "device": "smart display",
                "model": "BLM-00 SmartScreen"
            },
            {
                "regex": "EC6108V(8|9)",
                "device": "tv",
                "model": "EC6108V$1"
            },
            {
                "regex": "KANT-369",
                "device": "tv",
                "model": "Vision S 65\""
            },
            {
                "regex": "KANT-359",
                "device": "tv",
                "model": "Vision S 55\""
            },
            {
                "regex": "KANT-350[BC]",
                "device": "tv",
                "model": "Smart Screen S 55\""
            },
            {
                "regex": "KANT-350S",
                "device": "tv",
                "model": "Smart Screen S Pro 55\""
            },
            {
                "regex": "KANT-360S",
                "device": "tv",
                "model": "Smart Screen S Pro 65\""
            },
            {
                "regex": "KANT-360",
                "device": "tv",
                "model": "Smart Screen S 65\""
            },
            {
                "regex": "KANT-370S",
                "device": "tv",
                "model": "Smart Screen S Pro 75\""
            },
            {
                "regex": "KANT-370",
                "device": "tv",
                "model": "Smart Screen S 75\""
            },
            {
                "regex": "(MediaPad[^/;]*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Ideos([^;/]*) Build",
                "model": "Ideos$1"
            },
            {
                "regex": "(?:HUAWEI )?MT([0-9]+)",
                "device": "phablet",
                "model": "Ascend Mate $1"
            },
            {
                "regex": "Huawei[ _-]?([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "(?:HW-)?Huawei(?!Browser)(?:/1\\.0/0?(?:Huawei))?[_\\- /]?([a-z0-9\\-_]+)",
                "model": "$1"
            },
            {
                "regex": "Huawei; ([a-z0-9 \\-]+)",
                "model": "$1"
            }
        ]
    },
    "Hyundai": {
        "regex": "Hyundai|(?:Ultra (?:Active|Air|Charm|Dream|Energy|Latitude|Link|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)|Ultra_Vision_Plus|(?:Android 9(?:[\\d.]*);(?: [\\w-]+;)? [EL]553)|E435 Plus|E503F|E601F|L503F Plus|L604|L622|L601F|E(?:475|504|603)|G(?:24027|2552[34])K|W25042L|HP554O|Seoul (ECO|S8|MIX|5 Plus|9)|HT0701L16|HT0703K16|HT0704K08|HT100(?:4LI?16|2W32|3X16|2W16)|Koral_8W2|HT0701W16|Eternity[_ ](?:G25|H6[578])|HYMI 5S Plus|7GB1|7WD1|10LA1|10LB1|10WB[12]|E465GO|H-LED(?:55[BG]U7003|50FU7001|50[BG]U7003|50EU1311|55EU1311|65[BG]U7003|65EU1311|75BU7005|24BS5000|40GS5003|40FS500[13]|42FS500[13]|43FS500[13]|43EU1312|32FS500[135]|32GS5003|(?:32|40)BS5003|43[BG]U7003)(?:-[PC])?|H-DMP10[03]|HT070[34]W08|Koral 7W4|LGE; [0-9]{2}HYN[a-z0-9]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ultra[_ ]Vision[_ ]Plus",
                "model": "Ultra Vision Plus"
            },
            {
                "regex": "Ultra (Active|Air|Charm|Dream|Energy Lite|Energy Plus|Energy|Latitude|Link|Live II|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)",
                "model": "Ultra $1"
            },
            {
                "regex": "Seoul S8",
                "model": "Seoul S8"
            },
            {
                "regex": "Seoul MIX",
                "model": "Seoul Mix"
            },
            {
                "regex": "Seoul ECO",
                "model": "Seoul Eco"
            },
            {
                "regex": "Seoul 5 Plus",
                "model": "Seoul 5 Plus"
            },
            {
                "regex": "Seoul (\\d+)",
                "model": "Seoul $1"
            },
            {
                "regex": "G25523K",
                "model": "Eternity G23"
            },
            {
                "regex": "Eternity[_ ](G25|H6[578])",
                "model": "Eternity $1"
            },
            {
                "regex": "G25524K",
                "model": "Eternity G24"
            },
            {
                "regex": "G24027K",
                "model": "Eternity G27"
            },
            {
                "regex": "W25042L",
                "model": "Eternity W42"
            },
            {
                "regex": "HP554O",
                "model": "HP554O"
            },
            {
                "regex": "L503F Plus",
                "model": "L503F Plus"
            },
            {
                "regex": "HYMI 5S Plus",
                "model": "Hymi 5S Plus"
            },
            {
                "regex": "E465GO",
                "model": "E465 Go"
            },
            {
                "regex": "ULTRA ROCK",
                "model": "Ultra Rock"
            },
            {
                "regex": "E(475|504|503F|553|603|601F)(?:[);/ ]|$)",
                "model": "E$1"
            },
            {
                "regex": "L(553|601F|604|622)(?:[);/ ]|$)",
                "model": "L$1"
            },
            {
                "regex": "(?:Hyundai[_ ])?(Eternity[_ ](?:G57L?|G[56]0W?)|H7|Aero Plus|E435 Plus)",
                "model": "$1"
            },
            {
                "regex": "(H-LED\\w+)(?:-[PC])(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "(H-LED\\w+|H-DMP10[03]|2K TV)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "LGE; ([0-9]{2}HYN[a-z0-9]+)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "HT0704W08|Koral 7W4",
                "model": "Koral 7W4",
                "device": "tablet"
            },
            {
                "regex": "HT0701L16",
                "model": "Koral 7XL",
                "device": "tablet"
            },
            {
                "regex": "HT0701W16",
                "model": "Koral 7W4X",
                "device": "tablet"
            },
            {
                "regex": "HT0703W08",
                "model": "Koral 7W3",
                "device": "tablet"
            },
            {
                "regex": "10LB1",
                "model": "Koral 10LB1",
                "device": "tablet"
            },
            {
                "regex": "HT1004LI16",
                "model": "Koral 10XL",
                "device": "tablet"
            },
            {
                "regex": "Koral_8W2",
                "model": "Koral 8W2",
                "device": "tablet"
            },
            {
                "regex": "HT1004L16",
                "model": "Koral 10XL",
                "device": "tablet"
            },
            {
                "regex": "HT1003X16",
                "model": "Koral 10X",
                "device": "tablet"
            },
            {
                "regex": "HT1002W16",
                "model": "Koral 10W",
                "device": "tablet"
            },
            {
                "regex": "HT0703K16",
                "model": "Koral 7M3X",
                "device": "tablet"
            },
            {
                "regex": "HT0704K08",
                "model": "Koral 7M4",
                "device": "tablet"
            },
            {
                "regex": "10WB1",
                "model": "Koral 10WB1",
                "device": "tablet"
            },
            {
                "regex": "10WB2",
                "model": "HyTab Plus 10WB2",
                "device": "tablet"
            },
            {
                "regex": "10LA1",
                "model": "HyTab Pro 10LA1",
                "device": "tablet"
            },
            {
                "regex": "HT1002W32",
                "model": "Koral 10X3 WiFi",
                "device": "tablet"
            },
            {
                "regex": "7GB1(?:[);/ ]|$)",
                "model": "HyTab 7GB1",
                "device": "tablet"
            },
            {
                "regex": "7WD1(?:[);/ ]|$)",
                "model": "HyTab Lite 7WD1",
                "device": "tablet"
            },
            {
                "regex": "Hyundai ([^;/]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Hyundai[ _-]?([a-z0-9_-]+)",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "i-Joy": {
        "regex": "i-Joy|i-Call|(?:Neon[79]|Sygnus|Deox|Elektra (?:M|L|XL|XXL))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Elektra M(?:[);/ ]|$)",
                "model": "Elektra M"
            },
            {
                "regex": "Elektra L(?:[);/ ]|$)",
                "model": "Elektra L"
            },
            {
                "regex": "Elektra XL(?:[);/ ]|$)",
                "model": "Elektra XL"
            },
            {
                "regex": "Elektra XXL(?:[);/ ]|$)",
                "model": "Elektra XXL",
                "device": "phablet"
            },
            {
                "regex": "Neon([79])(?:[);/ ]|$)",
                "model": "Neon $1",
                "device": "tablet"
            },
            {
                "regex": "Sygnus(?:[);/ ]|$)",
                "model": "Sygnus",
                "device": "tablet"
            },
            {
                "regex": "Deox(?:[);/ ]|$)",
                "model": "Deox",
                "device": "tablet"
            },
            {
                "regex": "i-Call ([^;/]+) Build",
                "model": "i-Call $1"
            },
            {
                "regex": "i-Joy ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "iBall": {
        "regex": "iBall[ _]([^;/)]+)[ _]Build|iBall[_ ]Slide|(?:Snap[_ ]4G2|3G 1026-Q18|6351-Q400i|iT-KSA0003|iT-KSA0012|iT-KSA0066|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Brisk 4G2|Slide[_ ](?:Dazzle[_ ]3500|Skye_03)|Blaze_V4|Wondro 10|Q27 4G|Andi (?:Wink|5G Blink) 4G|Co-Mate|Nova_4G|Brace-X1|DD-1GB|Elan 4G2|Spirit_X2|Cuddle A4)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Andi Wink 4G",
                "device": "smartphone",
                "model": "Andi Wink 4G"
            },
            {
                "regex": "Andi 5G Blink 4G",
                "device": "smartphone",
                "model": "Andi 5G Blink 4G"
            },
            {
                "regex": "(Snap[_ ]4G2|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Blaze_V4|Wondro 10|Q27 4G|Brisk 4G2|Co-Mate|Nova_4G|Elan 4G2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "6351-Q400i(?:[);/ ]|$)",
                "model": "Slide"
            },
            {
                "regex": "DD-1GB(?:[);/ ]|$)",
                "model": "Slide DD-1GB"
            },
            {
                "regex": "Cuddle A4",
                "model": "Slide Cuddle A4"
            },
            {
                "regex": "Slide[_ ]Dazzle[_ ]3500(?:[);/ ]|$)",
                "model": "Slide Dazzle 3500"
            },
            {
                "regex": "1026-Q18(?:[);/ ]|$)",
                "model": "Slide 3G"
            },
            {
                "regex": "Spirit_X2",
                "model": "Spirit X2"
            },
            {
                "regex": "Slide_Skye_03",
                "model": "Slide Skye 03"
            },
            {
                "regex": "Brace-X1(?:[);/ ]|$)",
                "model": "Brace X1"
            },
            {
                "regex": "iT-KSA0003(?:[);/ ]|$)",
                "model": "iTAB BizniZ"
            },
            {
                "regex": "iT-KSA0066(?:[);/ ]|$)",
                "model": "iTAB BizniZ Mini"
            },
            {
                "regex": "iT-KSA0012(?:[);/ ]|$)",
                "model": "iTAB Moviez Pro"
            },
            {
                "regex": "iBall[ _]([^;/)]+)(?:[ _]Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "iRola": {
        "regex": "iRola ([^/;]+) Build|(DX758|DX752|DX752|DX758[ _]?Pro) Build",
        "device": "tablet",
        "models": [
            {
                "regex": "DX758[ _]?Pro",
                "model": "DX758 Pro"
            },
            {
                "regex": "(DX758|DX752)",
                "model": "$1"
            },
            {
                "regex": "iRola ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "iRulu": {
        "regex": "iRULU[ _-](X11|V[34]|U2|AL101)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "iRULU[ _-](X11|V[34]|AL101)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "iRULU[ _](U2)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Irbis": {
        "regex": "IRBIS|TZ(1(?:0[04]|42|5[01]|84|65|7[01345-89]|8[356]|9[12578])|200|49|55|72|22|7(?:0[127]|1[1-46789]|2[021567]|3[025-8]|4[257]|5[23457]|6[12]|72|7[137]|8[1]|9[147])|8(?:[34]1|32|5[3-8]|6[2-5]|7[12478]|8[1-5]|9[0127])|96[0-9])|TZ199|TZ85|TZ13|TZ(?:one|art|HIT|81L)|(SP(?:0[56]|2[01]|4[1-36]|40[12]|45[345]|49[34]|50|51[0147]|531|54[12]|55[0124]|571)|\\d{2}[FYHU]1YDX000F?BS2|65U001BS2)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(TZ(?:[0-9]+)|TZ(?:one|art|HIT|81L))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(SP[0-9]+)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(\\d{2}[FYHU]1YDX000F?BS2|65U001BS2)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "iBerry": {
        "regex": "AUXUS ([^/;]+) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "AUXUS (Core[^/;]+) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "AUXUS ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "iHome Life": {
        "regex": "HLQ MAX(?:[);/ ]|$)",
        "device": "tv",
        "model": "HLQ MAX"
    },
    "iHunt": {
        "regex": "iHunt|One_ Love_|TIT?AN[_ ]P\\d+|Like_(3|4U|3_Pro)|X300 Elite|S10_Tank_2019|S10 Tank PRO 2020|S60 Discovery Plus|S60_Discovery_2019|AlienXLite2020|Alien X (?:Lite|Pro)|Alien_X|(?:Titan ?P6000|S[23]0 Ultra ApeX 2021|S21 Ultra 4G 2021|P11000 Pro|Strong Tablet P15000 Pro|Like 11 Panda Pro|Like_Hi10_2021|Like Hi5|S21 Plus 2021|Like_[78]|Cyber DOG 4G|S10 Tank 2020|(?:S100|S90_)Apex|Tablet PC 10 PRO)(?:_EEA)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Strong Tablet (P15000|X) Pro",
                "device": "tablet",
                "model": "Strong Tablet $1 Pro"
            },
            {
                "regex": "Tablet PC 10 PRO",
                "device": "tablet",
                "model": "Tablet PC 10 Pro"
            },
            {
                "regex": "Cyber DOG 4G",
                "model": "Cyber Dog 4G"
            },
            {
                "regex": "Like_Hi10_2021",
                "model": "Like Hi10 (2021)"
            },
            {
                "regex": "S10[_ ]Tank[_ ]20(19|20)",
                "model": "S10 Tank (20$1)"
            },
            {
                "regex": "S10 Tank PRO 2020",
                "model": "S10 Tank Pro (2020)"
            },
            {
                "regex": "One_ Love_",
                "model": "One Love"
            },
            {
                "regex": "Tian[ _]P3000",
                "model": "Tian P3000"
            },
            {
                "regex": "TITAN_P11000_PRO|P11000 Pro",
                "model": "Titan P11000 Pro"
            },
            {
                "regex": "TITAN P15000 PRO 5G",
                "model": "Titan P15000 Pro 5G"
            },
            {
                "regex": "TITAN P([48]000) Pro 2021",
                "model": "Titan P$1 Pro (2021)"
            },
            {
                "regex": "Titan P8000 Ultra Carbon",
                "model": "Titan P8000 Ultra Carbon"
            },
            {
                "regex": "Titan_P6000_PRO",
                "model": "Titan P6000 Pro"
            },
            {
                "regex": "Titan ?P6000",
                "model": "Titan P6000"
            },
            {
                "regex": "Like_3_Pro",
                "model": "Like 3 Pro"
            },
            {
                "regex": "Like 12 PRO",
                "model": "Like 12 Pro"
            },
            {
                "regex": "Like Hi5",
                "model": "Like Hi5"
            },
            {
                "regex": "Like_([378])",
                "model": "Like $1"
            },
            {
                "regex": "Like_4U",
                "model": "Like 4U"
            },
            {
                "regex": "iHunt_Like",
                "model": "Like"
            },
            {
                "regex": "X300 Elite",
                "model": "X300 Elite"
            },
            {
                "regex": "S60_Discovery_2019",
                "model": "S60 Discovery (2019)"
            },
            {
                "regex": "S60 Discovery Plus",
                "model": "S60 Discovery Plus"
            },
            {
                "regex": "S60 Discovery Pro 2022",
                "model": "S60 Discovery Pro (2022)"
            },
            {
                "regex": "AlienXLite2020",
                "model": "Alien X Lite (2020)"
            },
            {
                "regex": "Alien X Lite PRO",
                "model": "Alien X Lite Pro"
            },
            {
                "regex": "Alien X Lite",
                "model": "Alien X Lite"
            },
            {
                "regex": "Alien X Pro 2021",
                "model": "Alien X Pro (2021)"
            },
            {
                "regex": "Alien_X_ApeX_2020",
                "model": "Alien X ApeX (2020)"
            },
            {
                "regex": "Alien_X_ApeX",
                "model": "Alien X ApeX"
            },
            {
                "regex": "S(90|100)_?Apex",
                "model": "S$1 ApeX"
            },
            {
                "regex": "Alien_X",
                "model": "Alien X"
            },
            {
                "regex": "S21 Plus 2021",
                "model": "S21 Plus (2021)"
            },
            {
                "regex": "S([23]0) Ultra ApeX 2021",
                "model": "S$1 Ultra ApeX (2021)"
            },
            {
                "regex": "S21 Ultra 4G 2021",
                "model": "S21 Ultra 4G (2021)"
            },
            {
                "regex": "S(2[234]) ULTRA",
                "model": "S$1 Ultra"
            },
            {
                "regex": "(?:iHunt_)?S(2[234])[ _]PLUS",
                "model": "S$1 Plus"
            },
            {
                "regex": "Like 11 Panda Pro 2022",
                "model": "Like 11 Panda Pro (2022)"
            },
            {
                "regex": "iHunt ([^;)/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "IconBIT": {
        "regex": "IconBIT|NT-(3506M|1501C|0704S|0909T|1009T|10[01]1T|1017T|3601P/3602P|3603P|3702S|3805C|3905T|3701S|0701S|0805C|0902S|370[23]M)|XDS[789]4K|Omnicast UHD|Movie Smart 4K|Movie IPTV Quad|TOUCAN (?:Smart 3D Quad|(?:NANO|Stick) 4K)|NetTAB_Space_3G|XLR3089",
        "device": "tablet",
        "models": [
            {
                "regex": "NT-3506M",
                "device": "smartphone",
                "model": "NetTAB Mercury Quad FHD"
            },
            {
                "regex": "NT-0704S",
                "model": "NetTAB Sky LE"
            },
            {
                "regex": "NT-0909T",
                "model": "NetTAB Thor IZ"
            },
            {
                "regex": "NT-1009T",
                "model": "NetTAB Thor quad II"
            },
            {
                "regex": "NT-10[01]1T",
                "model": "NetTAB Thor LE"
            },
            {
                "regex": "NT-1017T",
                "model": "NetTAB Thor 3G quad"
            },
            {
                "regex": "NT-3601P/3602P",
                "model": "NetTAB Pocket 3G"
            },
            {
                "regex": "NT-3603P",
                "model": "NetTAB Pocket 3G Slim"
            },
            {
                "regex": "NT-3702S",
                "model": "NetTAB Sky HD 3G"
            },
            {
                "regex": "NT-3805C",
                "model": "NetTAB Skat 3G quad"
            },
            {
                "regex": "NT-3701S",
                "model": "NetTAB Sky 3G duo"
            },
            {
                "regex": "NT-3905T",
                "model": "NetTAB Thor ZX 3G"
            },
            {
                "regex": "NT-0701S",
                "model": "NetTAB Sky net"
            },
            {
                "regex": "NT-0805C",
                "model": "NetTAB Skat MX"
            },
            {
                "regex": "NT-0902S",
                "model": "NetTAB Space quad RX"
            },
            {
                "regex": "NetTAB_Space_3G",
                "model": "NetTAB Space 3G"
            },
            {
                "regex": "NT-3702M",
                "model": "NetTAB Matrix 3G duo"
            },
            {
                "regex": "NT-3703M",
                "model": "NetTAB Matrix 3GT"
            },
            {
                "regex": "MATRIX ULTRA",
                "model": "NetTAB Matrix Ultra"
            },
            {
                "regex": "NT-1501C",
                "model": "Callisto 100",
                "device": "wearable"
            },
            {
                "regex": "XLR3089",
                "model": "Movie 2100",
                "device": "tv"
            },
            {
                "regex": "TOUCAN NANO 4K",
                "model": "Toucan Nano 4K",
                "device": "tv"
            },
            {
                "regex": "TOUCAN Smart 3D Quad",
                "model": "Toucan Smart 3D Quad",
                "device": "tv"
            },
            {
                "regex": "TOUCAN Stick 4K",
                "model": "Toucan Stick 4K",
                "device": "tv"
            },
            {
                "regex": "(?:iconBIT )?(Movie (?:Smart 4K|UNO|Play|IPTV Quad|Ultra HD 4K)|XDS[789]4K|XLR3090|Omnicast UHD|Stick|XDS1[01]00?|Movie [XZ])",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "LYF": {
        "regex": "(LYF[ _])?LS-[456][0-9]{3}|LYF/[^/]+/",
        "device": "smartphone",
        "models": [
            {
                "regex": "LS-4004",
                "model": "Flame 2"
            },
            {
                "regex": "LS-5501",
                "model": "Earth 1"
            },
            {
                "regex": "LS-5021",
                "model": "Earth 2"
            },
            {
                "regex": "LS-5505",
                "model": "Water F1"
            },
            {
                "regex": "LS-4503",
                "model": "Flame LS-4503"
            },
            {
                "regex": "LS-4001",
                "model": "Flame 3"
            },
            {
                "regex": "LS-4003",
                "model": "Flame 4"
            },
            {
                "regex": "LS-4002",
                "model": "Flame 5"
            },
            {
                "regex": "LS-4005",
                "model": "Flame 6"
            },
            {
                "regex": "(LYF[ _])?LS-4006",
                "model": "Flame 7"
            },
            {
                "regex": "LS-4008",
                "model": "Flame 7S"
            },
            {
                "regex": "LS-450[58]",
                "model": "Flame 8"
            },
            {
                "regex": "LS-5002",
                "model": "Water 1"
            },
            {
                "regex": "LS-5005",
                "model": "Water 4"
            },
            {
                "regex": "LS-5006",
                "model": "Water 6"
            },
            {
                "regex": "LS-5008",
                "model": "Water 2"
            },
            {
                "regex": "LS-5009",
                "model": "Wind 6"
            },
            {
                "regex": "LS-5013",
                "model": "Wind 5"
            },
            {
                "regex": "LS-5014",
                "model": "Wind 4"
            },
            {
                "regex": "LS-5010",
                "model": "Wind 1"
            },
            {
                "regex": "LS-5015",
                "model": "Water 8"
            },
            {
                "regex": "LS-5016",
                "model": "Wind 7"
            },
            {
                "regex": "LS-5504",
                "model": "Water 7"
            },
            {
                "regex": "LS-5507",
                "model": "Water 7S"
            },
            {
                "regex": "LS-5017",
                "model": "Water 11"
            },
            {
                "regex": "LS-5018",
                "model": "Wind 4S"
            },
            {
                "regex": "LS-5020",
                "model": "Water 10"
            },
            {
                "regex": "LS-5201",
                "model": "Water F1S"
            },
            {
                "regex": "LS-5502",
                "model": "Wind 3"
            },
            {
                "regex": "LS-5503",
                "model": "Water 3"
            },
            {
                "regex": "LS-5506",
                "model": "Water 9"
            },
            {
                "regex": "LS-6001",
                "model": "Wind 2"
            },
            {
                "regex": "LYF/([^/]+)/",
                "model": "$1"
            }
        ]
    },
    "Lumus": {
        "regex": "(?:NEO(SR620|SC600)|INNOSR545|Lumus[_ ]Ion|AEONSR570)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NEO(SR620|SC600)(?:[);/ ]|$)",
                "model": "Neo $1"
            },
            {
                "regex": "INNO(SR545)(?:[);/ ]|$)",
                "model": "INNO $1"
            },
            {
                "regex": "Lumus[_ ]Ion(?:[);/ ]|$)",
                "model": "Ion"
            },
            {
                "regex": "AEON(SR570)(?:[);/ ]|$)",
                "model": "AEON $1"
            }
        ]
    },
    "LW": {
        "regex": "(LW788)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "M4tel": {
        "regex": "(?:M4[ -]SS[0-9]{4}(?:-R)?|M4_B[23]|M4_R2|R2_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SS1050",
                "model": "Joy"
            },
            {
                "regex": "SS1060",
                "model": "Live"
            },
            {
                "regex": "SS1070",
                "model": "Sense"
            },
            {
                "regex": "SS1080",
                "model": "Max One"
            },
            {
                "regex": "SS1090",
                "model": "Max Ultra"
            },
            {
                "regex": "SS4020",
                "model": "Play"
            },
            {
                "regex": "SS4040",
                "model": "In Touch"
            },
            {
                "regex": "SS4045",
                "model": "Style"
            },
            {
                "regex": "SS4345",
                "model": "Soul Mini"
            },
            {
                "regex": "SS4350",
                "model": "Soul"
            },
            {
                "regex": "SS4445",
                "model": "Style Access"
            },
            {
                "regex": "SS4450",
                "model": "Share"
            },
            {
                "regex": "SS4451",
                "model": "Believe"
            },
            {
                "regex": "SS4452",
                "model": "Dream"
            },
            {
                "regex": "SS4453-R",
                "model": "R1 Feel"
            },
            {
                "regex": "R2_Plus",
                "model": "R2 Plus"
            },
            {
                "regex": "SS4453",
                "model": "Inspiration"
            },
            {
                "regex": "SS4455",
                "model": "Excite"
            },
            {
                "regex": "SS4456",
                "model": "Evolution"
            },
            {
                "regex": "SS4457-R",
                "model": "Ever"
            },
            {
                "regex": "SS4457",
                "model": "Elegance"
            },
            {
                "regex": "SS4458-R|M4-SS4458-R",
                "model": "Feel Plus"
            },
            {
                "regex": "SS4458",
                "model": "Attitude"
            },
            {
                "regex": "M4_B([23])",
                "model": "B$1"
            },
            {
                "regex": "M4_R(2)",
                "model": "R$1"
            }
        ]
    },
    "IMO Mobile": {
        "regex": "IMO[ _]\\w",
        "device": "smartphone",
        "models": [
            {
                "regex": "IMO[ _]Q([23]) Plus(?:[);/ ]|$)",
                "model": "Q$1 Plus"
            },
            {
                "regex": "IMO[ _]Q([4]) Pro(?:[);/ ]|$)",
                "model": "Q$1 Pro"
            },
            {
                "regex": "IMO[ _]Q2(?:[);/ ]|$)",
                "model": "Q2"
            },
            {
                "regex": "IMO[ _]S2(?:[);/ ]|$)",
                "model": "S2"
            },
            {
                "regex": "IMO[ _]FEEL A2(?:[);/ ]|$)",
                "model": "Feel A2"
            },
            {
                "regex": "IMO[ _]S50(?:[);/ ]|$)",
                "model": "S50 Light"
            },
            {
                "regex": "IMO[ _]S80(?:[);/ ]|$)",
                "model": "S80 Hero"
            },
            {
                "regex": "IMO[ _]S89(?:[);/ ]|$)",
                "model": "S89 Miracle"
            },
            {
                "regex": "IMO[ _]S88(?:[);/ ]|$)",
                "model": "S88 Discovery"
            },
            {
                "regex": "IMO[ _]S99(?:[);/ ]|$)",
                "model": "S99 Ocean"
            },
            {
                "regex": "IMO[ _]S98(?:[);/ ]|$)",
                "model": "S98 Champion"
            },
            {
                "regex": "IMO[ _]S87(?:[);/ ]|$)",
                "model": "S87 Raptor"
            },
            {
                "regex": "IMO[ _]S67(?:[);/ ]|$)",
                "model": "S67 Blast"
            },
            {
                "regex": "IMO[ _]S78(?:[);/ ]|$)",
                "model": "S78 Glory"
            },
            {
                "regex": "IMO[ _]Q8(?:[);/ ]|$)",
                "model": "Q8 Clarity"
            },
            {
                "regex": "IMO[ _]Discovery II(?:[);/ ]|$)",
                "model": "Discovery II"
            },
            {
                "regex": "IMO[ _]Q(?:[);/ ]|$)",
                "model": "Q"
            },
            {
                "regex": "IMO[ _]Q(5)(?:[);/ ]|$)",
                "model": "Q$1"
            },
            {
                "regex": "IMO[ _](Y5|Z[67])(?:[);/ ]|$)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "IMO TAB X9(?:[);/ ]|$)",
                "model": "Tab X9",
                "device": "tablet"
            }
        ]
    },
    "iLA": {
        "regex": "(?:iLA[-_ ](?:Silk|X2?|R1)|R1 Lite)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(R1) Lite(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "iLA[-_ ](Silk|X2?|R1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "iNew": {
        "regex": "iNew|(?:V7A|V3 Plus|V3-?E|V3C|FIRE_Tab_6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "V3C(?:[);/ ]|$)",
                "model": "V3C"
            },
            {
                "regex": "V3-?E(?:[);/ ]|$)",
                "model": "V3-E"
            },
            {
                "regex": "V3 Plus(?:[);/ ]|$)",
                "model": "V3 Plus"
            },
            {
                "regex": "V7A(?:[);/ ]|$)",
                "model": "V7A"
            },
            {
                "regex": "FIRE_Tab_6(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Fire Tab 6"
            },
            {
                "regex": "iNew[ -_]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "iPro": {
        "regex": "(?:IPRO_K2_3G|Kylin[ _]5\\.[05]S?|KYLIN(?:40|50i)|Jade[78]s|Amber[678]S?|Amber[58]S[ _]Pro|Benny10|Phonenix50S|Ruby5S|Zafiro|I9355A|Opal 4S|Perla|S[45]01A|S200M|WAVE 4\\.0 II|WAVE 5\\.0|MEGA7|SAMBA65S|S501APlus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IPRO_K2_3G",
                "model": "K2 3G"
            },
            {
                "regex": "S501APlus",
                "model": "S501A Plus"
            },
            {
                "regex": "Kylin_5\\.0S",
                "model": "Kylin 5.0S"
            },
            {
                "regex": "Kylin (5\\.[05])",
                "model": "Kylin $1"
            },
            {
                "regex": "Kylin50i",
                "model": "Kylin 50i"
            },
            {
                "regex": "KYLIN40",
                "model": "Kylin 40"
            },
            {
                "regex": "Opal 4S",
                "model": "Opal 4S"
            },
            {
                "regex": "Jade([78])s",
                "model": "Jade $1s"
            },
            {
                "regex": "Amber5S_Pro",
                "model": "Amber 5S Pro"
            },
            {
                "regex": "Amber6",
                "model": "Amber 6"
            },
            {
                "regex": "Amber7S",
                "model": "Amber 7S"
            },
            {
                "regex": "Amber8s Pro",
                "model": "Amber 8S Pro"
            },
            {
                "regex": "Amber8S",
                "model": "Amber 8S"
            },
            {
                "regex": "Amber8",
                "model": "Amber 8"
            },
            {
                "regex": "Benny10",
                "model": "Benny 10"
            },
            {
                "regex": "Phonenix50S",
                "model": "Phonenix 50S"
            },
            {
                "regex": "Ruby5S",
                "model": "Ruby 5S"
            },
            {
                "regex": "SAMBA65S",
                "model": "Samba 65S"
            },
            {
                "regex": "Zafiro",
                "model": "Zafiro"
            },
            {
                "regex": "WAVE 4\\.0 II",
                "model": "Wave 4.0 II"
            },
            {
                "regex": "WAVE 5\\.0",
                "model": "Wave 5.0"
            },
            {
                "regex": "(I9355A|S[45]01A|S200M|Perla)",
                "model": "$1"
            },
            {
                "regex": "MEGA7",
                "device": "tablet",
                "model": "Mega 7"
            }
        ]
    },
    "Infinix": {
        "regex": "Infinix",
        "device": "smartphone",
        "models": [
            {
                "regex": "Infinix[ _-]X6739",
                "model": "GT 10 Pro"
            },
            {
                "regex": "Infinix[ _-]X6871",
                "model": "GT 20 Pro"
            },
            {
                "regex": "Infinix[ _-]X6873",
                "model": "GT 30 Pro"
            },
            {
                "regex": "Infinix[ _-]X260",
                "model": "Buzz"
            },
            {
                "regex": "Infinix[ _-]X502",
                "model": "Alpha Marvel"
            },
            {
                "regex": "Infinix[ _-]X570",
                "model": "Alpha"
            },
            {
                "regex": "Infinix[ _-]X350",
                "model": "Surf Smart"
            },
            {
                "regex": "Infinix[ _-]X351",
                "model": "Surf Smart 3G"
            },
            {
                "regex": "Infinix[ _-]X352",
                "model": "Surf Smart 2"
            },
            {
                "regex": "Infinix[ _-]X403",
                "model": "Surf Spice"
            },
            {
                "regex": "Infinix[ _-]X503",
                "model": "Surf Bravo"
            },
            {
                "regex": "Infinix[ _-]X511",
                "model": "Surf Noir"
            },
            {
                "regex": "Infinix[ _-]X400",
                "model": "Race"
            },
            {
                "regex": "Infinix[ _-]X401",
                "model": "Race Lite"
            },
            {
                "regex": "Infinix[ _-]X450",
                "model": "Race Bolt"
            },
            {
                "regex": "Infinix[ _-]X451",
                "model": "Race Bolt Q"
            },
            {
                "regex": "Infinix[ _-]X454",
                "model": "Race Bolt 2"
            },
            {
                "regex": "Infinix[ _-]X500",
                "model": "Race Eagle"
            },
            {
                "regex": "Infinix[ _-]X501",
                "model": "Race Jet"
            },
            {
                "regex": "Infinix[ _-]X506",
                "model": "Zero"
            },
            {
                "regex": "Infinix[ _-]X6962",
                "model": "Zero Flip"
            },
            {
                "regex": "Infinix[ _-]X6731B",
                "model": "Zero 30"
            },
            {
                "regex": "Infinix[ _-]X6731",
                "model": "Zero 30 5G"
            },
            {
                "regex": "Infinix[ _-]X509",
                "model": "Zero 2"
            },
            {
                "regex": "Infinix[ _-]X6821",
                "model": "Zero 20"
            },
            {
                "regex": "Infinix[ _-](?:X552|Zero 3)",
                "model": "Zero 3"
            },
            {
                "regex": "Infinix[ _-](?:X6861|ZERO 40 5G)",
                "model": "Zero 40 5G"
            },
            {
                "regex": "Infinix[ _-](?:X6860|ZERO 40)",
                "model": "Zero 40"
            },
            {
                "regex": "Infinix[ _-](?:X(?:574|602)|Zero 4 Plus)",
                "model": "Zero 4 Plus"
            },
            {
                "regex": "Infinix[ _-](?:X555|Zero 4)",
                "model": "Zero 4"
            },
            {
                "regex": "Infinix[ _-]X603",
                "model": "Zero 5"
            },
            {
                "regex": "Infinix[ _-]X603B",
                "model": "Zero 5 Pro"
            },
            {
                "regex": "Infinix[ _-]X620B",
                "model": "Zero 6"
            },
            {
                "regex": "Infinix[ _-]X620",
                "model": "Zero 6 Pro"
            },
            {
                "regex": "Infinix[ _-]X687B",
                "device": "phablet",
                "model": "Zero 8i"
            },
            {
                "regex": "Infinix X6870",
                "device": "phablet",
                "model": "Note 50S 5G"
            },
            {
                "regex": "Infinix[ _-]X687",
                "device": "phablet",
                "model": "Zero 8"
            },
            {
                "regex": "Infinix[ _-]X6815B",
                "device": "phablet",
                "model": "Zero 5G"
            },
            {
                "regex": "Infinix[ _-]X6811B",
                "device": "phablet",
                "model": "Zero X"
            },
            {
                "regex": "Infinix[ _-]X6815",
                "device": "phablet",
                "model": "Zero 5G"
            },
            {
                "regex": "Infinix[ _-]X6811",
                "device": "phablet",
                "model": "Zero X Pro"
            },
            {
                "regex": "Infinix[ _-]X6810",
                "device": "phablet",
                "model": "Zero X Neo"
            },
            {
                "regex": "Infinix[ _-]X6820",
                "device": "phablet",
                "model": "Zero Ultra"
            },
            {
                "regex": "Infinix[ _-]X507",
                "model": "Hot"
            },
            {
                "regex": "Infinix[ _-]X510",
                "model": "Hot 2"
            },
            {
                "regex": "Infinix[ _-](?:X55[34]|HOT 3 LTE)",
                "model": "Hot 3"
            },
            {
                "regex": "Infinix[ _-]X669",
                "model": "Hot 30i"
            },
            {
                "regex": "Infinix[ _-](?:X6831|X6833B)",
                "model": "Hot 30"
            },
            {
                "regex": "Infinix[ _-]X6835B?",
                "model": "Hot 30 Play"
            },
            {
                "regex": "Infinix[ _-]X6832",
                "model": "Hot 30 5G"
            },
            {
                "regex": "Infinix[ _-]X6528",
                "model": "Hot 40i"
            },
            {
                "regex": "Infinix[ _-]X6836",
                "model": "Hot 40"
            },
            {
                "regex": "Infinix[ _-]X6837",
                "model": "Hot 40 Pro"
            },
            {
                "regex": "Infinix[ _-]X622",
                "model": "Hot S3X"
            },
            {
                "regex": "Infinix[ _-]X521",
                "model": "Hot S"
            },
            {
                "regex": "Infinix[ _-]X522",
                "model": "Hot S2"
            },
            {
                "regex": "Infinix[ _-]X557",
                "model": "Hot 4"
            },
            {
                "regex": "Infinix[ _-]X556",
                "model": "Hot 4 Pro"
            },
            {
                "regex": "Infinix[ _-]X559[cF]",
                "model": "Hot 5"
            },
            {
                "regex": "Infinix[ _-]X6882",
                "model": "Hot 50"
            },
            {
                "regex": "Infinix[ _-]X6531",
                "model": "Hot 50i"
            },
            {
                "regex": "Infinix[ _-]X6720B?",
                "model": "Hot 50 5G"
            },
            {
                "regex": "Infinix[ _-]X6881",
                "model": "Hot 50 Pro"
            },
            {
                "regex": "Infinix[ _-]X6880",
                "model": "Hot 50 Pro+"
            },
            {
                "regex": "Infinix[ _-]X559",
                "model": "Hot 5 Lite"
            },
            {
                "regex": "Infinix[ _-]X606[BC]?",
                "model": "Hot 6"
            },
            {
                "regex": "Infinix[ _-]X6885",
                "model": "Hot 60 Pro"
            },
            {
                "regex": "Infinix[ _-]X6886",
                "model": "Hot 60 Pro+"
            },
            {
                "regex": "Infinix[ _-]X6726B",
                "model": "Hot 60 5G"
            },
            {
                "regex": "Infinix[ _-]X6728",
                "model": "Hot 60i"
            },
            {
                "regex": "Infinix[ _-]X6730B?",
                "model": "Hot 60i 5G"
            },
            {
                "regex": "Infinix[ _-]X623",
                "model": "Hot 6X"
            },
            {
                "regex": "Infinix[ _-]X608",
                "model": "Hot 6 Pro"
            },
            {
                "regex": "Infinix[ _-]X624",
                "model": "Hot 7"
            },
            {
                "regex": "Infinix[ _-]X625",
                "model": "Hot 7 Pro"
            },
            {
                "regex": "Infinix[ _-]X650",
                "model": "Hot 8"
            },
            {
                "regex": "Infinix[ _-]X655F",
                "model": "Hot 9 Pro"
            },
            {
                "regex": "Infinix[ _-]X655",
                "model": "Hot 9"
            },
            {
                "regex": "Infinix[ _-]X680[BCEF]",
                "model": "Hot 9 Play"
            },
            {
                "regex": "Infinix[ _-]X680D",
                "model": "Smart 4 Plus"
            },
            {
                "regex": "Infinix[ _-]X680",
                "model": "Smart 4"
            },
            {
                "regex": "Infinix[ _-]X688",
                "model": "Hot 10 Play"
            },
            {
                "regex": "Infinix[ _-]X682[BC]",
                "model": "Hot 10"
            },
            {
                "regex": "Infinix[ _-]X689C",
                "model": "Hot 10T"
            },
            {
                "regex": "Infinix[ _-]X689F",
                "model": "Hot 11"
            },
            {
                "regex": "Infinix X689D",
                "model": "Hot 10s NFC"
            },
            {
                "regex": "Infinix X689",
                "model": "Hot 10s"
            },
            {
                "regex": "Infinix[ _-](?:X659|PR652|X658)",
                "model": "Hot 10i"
            },
            {
                "regex": "Infinix[ _-]X573B?",
                "model": "Hot S3"
            },
            {
                "regex": "Infinix[ _-]X6812",
                "model": "Hot 11S"
            },
            {
                "regex": "Infinix[ _-]X675",
                "model": "Hot 11 (2020)"
            },
            {
                "regex": "Infinix[ _-]X662",
                "model": "Hot 11"
            },
            {
                "regex": "Infinix[ _-]X6816D",
                "model": "Hot 12 Play NFC"
            },
            {
                "regex": "Infinix[ _-]X6816C?",
                "model": "Hot 12 Play"
            },
            {
                "regex": "Infinix[ _-]X668C?",
                "model": "Hot 12 Pro"
            },
            {
                "regex": "Infinix[ _-]X665[EC]",
                "model": "Hot 20i"
            },
            {
                "regex": "Infinix[ _-]X6826",
                "model": "Hot 20"
            },
            {
                "regex": "Infinix[ _-]X666",
                "model": "Hot 20 5G"
            },
            {
                "regex": "Infinix[ _-]X6825",
                "model": "Hot 20 Play"
            },
            {
                "regex": "Infinix[ _-]X6827",
                "model": "Hot 20S"
            },
            {
                "regex": "Infinix[ _-]X665",
                "model": "Hot 12i"
            },
            {
                "regex": "Infinix[ _-]X6817",
                "model": "Hot 12"
            },
            {
                "regex": "Infinix[ _-]X612",
                "model": "Smart HD (2021)"
            },
            {
                "regex": "Infinix[ _-]X5010",
                "model": "Smart"
            },
            {
                "regex": "Infinix[ _-]X5515[FI]?",
                "model": "Smart 2"
            },
            {
                "regex": "Infinix[ _-]X609",
                "model": "Smart 2 HD"
            },
            {
                "regex": "Infinix[ _-]X5516",
                "model": "Smart 3"
            },
            {
                "regex": "Infinix[ _-]X627",
                "model": "Smart 3 Plus"
            },
            {
                "regex": "Infinix[ _-]X5514D",
                "model": "Smart 2 Pro"
            },
            {
                "regex": "Infinix[ _-]X6532C",
                "model": "Smart 9 HD"
            },
            {
                "regex": "Infinix[ _-]X6532",
                "model": "Smart 9"
            },
            {
                "regex": "Infinix[ _-]X653",
                "model": "Smart 4"
            },
            {
                "regex": "Infinix[ _-]X657",
                "model": "Smart 5"
            },
            {
                "regex": "Infinix[ _-](?:X6823C?|X6511G)",
                "model": "Smart 6 Plus"
            },
            {
                "regex": "Infinix[ _-]X6511",
                "model": "Smart 6"
            },
            {
                "regex": "Infinix[ _-]X6512",
                "model": "Smart 6 HD"
            },
            {
                "regex": "Infinix[ _-]X6517",
                "model": "Smart 7 Plus"
            },
            {
                "regex": "Infinix[ _-]X6515",
                "model": "Smart 7"
            },
            {
                "regex": "Infinix[ _-]X6516",
                "model": "Smart 7 HD"
            },
            {
                "regex": "Infinix[ _-](?:X6525B|SMART 8 Pro)",
                "model": "Smart 8 Pro"
            },
            {
                "regex": "Infinix[ _-]X6526",
                "model": "Smart 8 Plus"
            },
            {
                "regex": "Infinix[ _-](?:X6525|SMART 8)",
                "model": "Smart 8"
            },
            {
                "regex": "Infinix[ _-]X652B",
                "model": "S5 Lite"
            },
            {
                "regex": "Infinix[ _-]X626",
                "model": "S4"
            },
            {
                "regex": "Infinix[ _-]X652C",
                "model": "S5 Lite"
            },
            {
                "regex": "Infinix[ _-]X652",
                "model": "S5"
            },
            {
                "regex": "Infinix[ _-]X660",
                "model": "S5 Pro"
            },
            {
                "regex": "Infinix[ _-]X6725[BC]",
                "model": "Smart 10 Plus"
            },
            {
                "regex": "Infinix[ _-]X6838",
                "model": "Note 40X 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X551",
                "model": "Hot Note",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X600",
                "model": "Note 2",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X601",
                "model": "Note 3",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X572",
                "model": "Note 4",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X571",
                "model": "Note 4 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X604",
                "model": "Note 5",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X605",
                "model": "Note 5 Stylus",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X610",
                "model": "Note 6",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X690",
                "model": "Note 7",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X656",
                "model": "Note 7 Lite",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X692",
                "model": "Note 8",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X683",
                "model": "Note 8i",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X695",
                "model": "Note 10 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X693",
                "model": "Note 10",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X663C",
                "model": "Note 12",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X677",
                "model": "Note 12i (2022)",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6819",
                "model": "Note 12i",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X676B",
                "model": "Note 12 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X671B",
                "model": "Note 12 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X672",
                "model": "Note 12 VIP",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X663D",
                "model": "Note 12 NFC",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X663",
                "model": "Note 11",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X697",
                "model": "Note 11 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X698",
                "model": "Note 11S",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X670",
                "model": "Note 12",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X671(?:[);/ ]|$)",
                "model": "Note 12 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X676C",
                "model": "Note 12 (2023)",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6716B",
                "model": "Note 30",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6716",
                "model": "Note 30i",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6710",
                "model": "Note 30 VIP",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X678B",
                "model": "Note 30 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6711",
                "model": "Note 30 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6855",
                "model": "Note 50 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6856",
                "model": "Note 50 Pro+ 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6857B?",
                "model": "Note 50X 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6858",
                "model": "Note 50",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6850B",
                "model": "Note 40S",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6850",
                "model": "Note 40 Pro",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6851B",
                "model": "Note 40 Pro+ 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6851",
                "model": "Note 40 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X6852",
                "model": "Note 40 5G",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X685",
                "model": "Note 40",
                "device": "phablet"
            },
            {
                "regex": "Infinix[ _-]X1101B?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "XPad"
            },
            {
                "regex": "Infinix HOT ([a-z]?[1-6])( (?:Lite|Plus|Pro))?",
                "model": "Hot $1$2"
            },
            {
                "regex": "Infinix[ _-](X[78]00)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Infinix[ _-](X\\d+)",
                "model": "$1"
            },
            {
                "regex": "Infinix[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Infinix[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "InnJoo": {
        "regex": "InnJoo|(?:Halo Plus|Halo2 LTE|Halo X|Halo 5 3G|Halo[ _]4(?:[ _]mini[ _]LTE)?|VISION LTE|Halo2 3G|Fire 4 ?(?:Pro|Plus)?|Fire_Plus_LTE|Fire3 mini|Fire2 (?:Air|Pro|Plus) LTE|Fire2 LTE|Superb(?:_PLus)?|VOOM TAB 2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VOOM TAB 2",
                "device": "tablet",
                "model": "Voom Tab 2"
            },
            {
                "regex": "InnJoo[ _]X3(?:[);/ ]|$)",
                "model": "X3"
            },
            {
                "regex": "Halo[ _]X[ _]LTE(?:[);/ ]|$)",
                "model": "Halo X LTE"
            },
            {
                "regex": "InnJoo[ _]X(?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "Halo Plus(?:[);/ ]|$)",
                "model": "Halo Plus"
            },
            {
                "regex": "Halo[ _]4[ _]mini[ _]LTE(?:[);/ ]|$)",
                "model": "Halo 4 Mini LTE"
            },
            {
                "regex": "Halo 4(?:[);/ ]|$)",
                "model": "Halo 4"
            },
            {
                "regex": "Halo ?2 LTE(?:[);/ ]|$)",
                "model": "Halo 2 LTE"
            },
            {
                "regex": "Halo ?([25]) 3G(?:[);/ ]|$)",
                "model": "Halo $1 3G"
            },
            {
                "regex": "InnJoo[ _]Pro2(?:[);/ ]|$)",
                "model": "Pro 2"
            },
            {
                "regex": "Innjoo ONE 3G(?:[);/ ]|$)",
                "model": "One 3G"
            },
            {
                "regex": "Innjoo[ _]2[ _]LTE(?:[);/ ]|$)",
                "model": "2 LTE"
            },
            {
                "regex": "InnJoo[ _]([2-4])",
                "model": "$1"
            },
            {
                "regex": "Fire2 Plus LTE",
                "model": "Fire 2 Plus LTE"
            },
            {
                "regex": "Fire_Plus_LTE",
                "model": "Fire Plus LTE"
            },
            {
                "regex": "Fire2 Air LTE",
                "model": "Fire 2 Air LTE"
            },
            {
                "regex": "Fire2 Pro LTE",
                "model": "Fire 2 Pro LTE"
            },
            {
                "regex": "Fire2 LTE",
                "model": "Fire 2 LTE"
            },
            {
                "regex": "Fire3 mini",
                "model": "Fire 3 Mini"
            },
            {
                "regex": "Fire 4 Pro",
                "model": "Fire 4 Pro"
            },
            {
                "regex": "Fire 4 Plus",
                "model": "Fire 4 Plus"
            },
            {
                "regex": "Fire 4",
                "model": "Fire 4"
            },
            {
                "regex": "Superb_PLus",
                "model": "SuperB Plus"
            },
            {
                "regex": "Superb",
                "model": "SuperB"
            },
            {
                "regex": "VISION LTE",
                "model": "Vision LTE"
            }
        ]
    },
    "Inkti": {
        "regex": "intki[ _]([^/;]*)[ _]Build",
        "device": "smartphone",
        "model": "$1"
    },
    "Innos": {
        "regex": "Innos_?(D6000)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Innostream": {
        "regex": "INNO(?!va[123]0)([a-z0-9]+)",
        "device": "feature phone",
        "model": "INNO$1"
    },
    "Insignia": {
        "regex": "NS-(P11A8100|P10A8100|P10A6100|P16AT08|P16AT10|P16AT785HD|P08A7100|P10A7100)(?:[);/ ]|$)|AFTEAMR311|AFTJMST12",
        "device": "tablet",
        "models": [
            {
                "regex": "NS-P11A8100",
                "model": "11.6\""
            },
            {
                "regex": "NS-(P10A6100|P16AT10)",
                "model": "Flex 10.1\""
            },
            {
                "regex": "NS-P16AT08",
                "model": "Flex 8\""
            },
            {
                "regex": "NS-P08A7100",
                "model": "8\""
            },
            {
                "regex": "NS-(P10A8100|P10A7100)",
                "model": "10.1\""
            },
            {
                "regex": "NS-P16AT785HD",
                "model": "Flex Elite 7.85\""
            },
            {
                "regex": "AFTEAMR311",
                "model": "HD (2018)",
                "device": "tv"
            },
            {
                "regex": "AFTJMST12",
                "model": "4K (2018)",
                "device": "tv"
            }
        ]
    },
    "INSYS": {
        "regex": "INSYS|(?:HK9-4010|IH9-L614|AC7_DJ17|HN2-M16Q)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HK9-4010",
                "model": "HK9-4010"
            },
            {
                "regex": "AC7_DJ17",
                "model": "AC7-DJ17"
            },
            {
                "regex": "IH9-L614",
                "model": "MX IH9-L614"
            },
            {
                "regex": "(GU4-K147|HN2-M16Q|VI4-103)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "INQ": {
        "regex": "INQ[/ ]",
        "device": "feature phone",
        "models": [
            {
                "regex": "INQ/([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "INQ ([^;/]+) Build",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "AFFIX": {
        "regex": "elite Aquarius(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "elite Aquarius",
                "model": "Elite Aquarius"
            }
        ]
    },
    "Aquarius": {
        "regex": "Aquarius|(?:NS220R?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Aquarius Pro, Std, Elt Series",
                "device": "desktop",
                "model": "Pro Std Elite Series"
            },
            {
                "regex": "(NS220R?)",
                "model": "CMP $1"
            },
            {
                "regex": "Aquarius[_ ]CMP[_ ]([^/;)]+)(?: Build|[);])",
                "model": "CMP $1"
            },
            {
                "regex": "Aquarius[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Vsun": {
        "regex": "(?:VSUN (?:ILLUSION|RACE|V9|TOUCH)|Aqua Tough|MERCURY Tough|MARS TOUCH|MARS NOTE|MARS NOCAM|SATURN SELFIE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ILLUSION(?:[);/ ]|$)",
                "model": "Illusion"
            },
            {
                "regex": "MARS TOUCH(?:[);/ ]|$)",
                "model": "Mars Touch"
            },
            {
                "regex": "MERCURY Tough",
                "model": "Mercury Touch"
            },
            {
                "regex": "MARS NOTE",
                "model": "Mars Note"
            },
            {
                "regex": "MARS NOCAM",
                "model": "Mars Nocam"
            },
            {
                "regex": "Aqua Tough",
                "model": "Aqua Tough"
            },
            {
                "regex": "SATURN SELFIE(?:[);/ ]|$)",
                "model": "Saturn Selfie"
            },
            {
                "regex": "RACE(?:[);/ ]|$)",
                "model": "Race"
            },
            {
                "regex": "VSUN TOUCH(?:[);/ ]|$)",
                "model": "Touch"
            },
            {
                "regex": "(V9)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Turbo": {
        "regex": "(?:Turbo[_ ]?(?:X5[_ ]?(?:Max|Black|Space|Hero)|X8|X6[ _]Z|X[ _]Ray)|Monsterpad7)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TurboX5Space(?:[);/ ]|$)",
                "model": "X5 Space"
            },
            {
                "regex": "TurboX5Hero(?:[);/ ]|$)",
                "model": "X5 Hero"
            },
            {
                "regex": "TurboX[ _]Ray(?:[);/ ]|$)",
                "model": "X Ray"
            },
            {
                "regex": "Turbo[ _]?X5[ _]?Black(?:[);/ ]|$)",
                "model": "X5 Black"
            },
            {
                "regex": "Turbo[ _]X5[ _]Max(?:[);/ ]|$)",
                "model": "X5 Max"
            },
            {
                "regex": "Turbo[ _]X6[ _]Z(?:[);/ ]|$)",
                "model": "X6 Z"
            },
            {
                "regex": "Turbo[ _]X8(?:[);/ ]|$)",
                "model": "X8"
            },
            {
                "regex": "Monsterpad7(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MonsterPad 7\""
            }
        ]
    },
    "Turbo-X": {
        "regex": "Turbo[-_]X|(?:TURBOX_I4G|Hive V 3G|Calltab10\\.1|Calltab2GB10|Calltab7inch|Turbox_S3|Fire_II_WiFi|Breeze IV|Aqua_II|RainbowIII3G|RubikII7|Rubik 10\\.1 II|Rubik_10_III|QUAD-CORE A33 inet)(?:[);/ ]|$)|(?<!Rombica TV |DVK82 )Mercury(?!/| HD Quad core)|(?:android 8([\\d.]*);(?: [\\w-]+;)? Dream)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Dream",
                "model": "Dream"
            },
            {
                "regex": "Turbox_S3",
                "model": "S3"
            },
            {
                "regex": "Turbo-X_A2(?:[);/ ]|$)",
                "model": "A2"
            },
            {
                "regex": "Turbo-X_e3(?:[);/ ]|$)",
                "model": "E3"
            },
            {
                "regex": "Mercury(?!/)",
                "model": "Mercury"
            },
            {
                "regex": "Turbo-X_epsilon",
                "model": "Epsilon"
            },
            {
                "regex": "Turbo-X lamda",
                "model": "Lamda"
            },
            {
                "regex": "Turbo-X_pi_4G|Turbo_X_Pi 1 4G",
                "model": "Pi 4G"
            },
            {
                "regex": "TURBOX_I4G",
                "model": "I 4G"
            },
            {
                "regex": "Turbo-X Ice(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Ice"
            },
            {
                "regex": "Turbo-X Coral II",
                "device": "tablet",
                "model": "Coral II"
            },
            {
                "regex": "Aqua_II(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Aqua II"
            },
            {
                "regex": "Hive V 3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Hive V 3G"
            },
            {
                "regex": "Hive VI",
                "device": "tablet",
                "model": "Hive VI"
            },
            {
                "regex": "Fire_II_WiFi(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Fire II WiFi"
            },
            {
                "regex": "Breeze IV(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Breeze IV"
            },
            {
                "regex": "RubikII7(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Rubik II 7\""
            },
            {
                "regex": "Rubik 10\\.1 II(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Rubik II 10.1\""
            },
            {
                "regex": "Rubik_10_III(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Rubik III 10.1\""
            },
            {
                "regex": "RainbowIII3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Rainbow III 3G"
            },
            {
                "regex": "Calltab10\\.1",
                "device": "tablet",
                "model": "CallTab II 10.1\""
            },
            {
                "regex": "Calltab2GB10",
                "device": "tablet",
                "model": "CallTab 10.1\""
            },
            {
                "regex": "Calltab7inch",
                "device": "tablet",
                "model": "CallTab 7\""
            },
            {
                "regex": "QUAD-CORE A33 inet",
                "device": "tablet",
                "model": "Twister"
            },
            {
                "regex": "TURBO-X, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": "",
                "device": "tv"
            },
            {
                "regex": "Turbo-X Tablet([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Turbo-X ([^;)/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Intex": {
        "regex": "Intex|(Aqua|Cloud[ _][XY][0-9]{1}|Cloud (?:Fame|Glory) 4G)|(?:CLOUD TREAD|IM0318ND|IV0318ND)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IM0318ND",
                "model": "Aqua Lions 3"
            },
            {
                "regex": "AQUA[ _]LIONS[ _]T1[ _]LITE(?:[);/ ]|$)",
                "model": "Aqua Lions T1 Lite"
            },
            {
                "regex": "AQUA[ _]LIONS[ _]([NT]1|[23]|E3)(?:[);/ ]|$)",
                "model": "Aqua Lions $1"
            },
            {
                "regex": "AQUA (A4) PLUS(?:[);/ ]|$)",
                "model": "Aqua $1 Plus"
            },
            {
                "regex": "AQUA[ _](A4|S[13])(?:[);/ ]|$)",
                "model": "Aqua $1"
            },
            {
                "regex": "Intex[ _]IM0118ND",
                "model": "Aqua Lions T1 Plus"
            },
            {
                "regex": "AQUA CRYSTAL\\+(?:[);/ ]|$)",
                "model": "Aqua Crystal Plus"
            },
            {
                "regex": "AQUA FulVU e5(?:[);/ ]|$)",
                "model": "Aqua Fulvu E5"
            },
            {
                "regex": "AQUA JEWEL 2(?:[);/ ]|$)",
                "model": "Aqua Jewel 2"
            },
            {
                "regex": "Aqua[_ ]Life[_ ]?III(?:[);/ ]|$)",
                "model": "Aqua Life III"
            },
            {
                "regex": "(?:INTEX[_ ])?AQUA[_ ]4\\.0[_ ]4G",
                "model": "Aqua 4.0 4G"
            },
            {
                "regex": "(?:INTEX[_ ])?AQUA[_ ]4G[_ ]MINI",
                "model": "Aqua Mini 4G"
            },
            {
                "regex": "(?:INTEX[_ ])?AQUA[_ ]LIONS[_ ]4G",
                "model": "Aqua Lions 4G"
            },
            {
                "regex": "(?:INTEX[_ ])?AQUA[_ ]PRIME[_ ]4G",
                "model": "Aqua Prime 4G"
            },
            {
                "regex": "(?:INTEX[_ ])?AQUA[_ ]ZENITH",
                "model": "Aqua Zenith"
            },
            {
                "regex": "(?:INTEX[_ ])?AQUA[_ ]POWER[_ ]IV",
                "model": "Aqua Power IV"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]YOUNG[_ ]4G",
                "model": "Aqua Young 4G"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]TREND[_ ]LITE",
                "model": "Aqua Trend Lite"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]AMAZE\\+",
                "model": "Aqua Amaze Plus"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]Supreme\\+",
                "model": "Aqua Supreme Plus"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]STYLE (\\d)",
                "model": "Aqua Style $1"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]Strong 5\\.1\\+",
                "model": "Aqua Strong 5.1 Plus"
            },
            {
                "regex": "(?:INTEX[ _])?AQUA[_ ]CRYSTAL",
                "model": "Aqua Crystal"
            },
            {
                "regex": "(?:INTEX[ _])?ELYT[_ ]DUAL[_ ]PLUS",
                "model": "Elyt Dual Plus"
            },
            {
                "regex": "(?:INTEX[ _])?ELYT[_ ]DUAL",
                "model": "Elyt Dual"
            },
            {
                "regex": "(?:INTEX[ _])?ELYT[_ ](E\\d+)",
                "model": "Elyt $1"
            },
            {
                "regex": "IV0318ND",
                "model": "Indie 11"
            },
            {
                "regex": "Intex[ _]IV0118ND",
                "model": "Lions 6"
            },
            {
                "regex": "Intex[ _]IP0418ND",
                "model": "Infie 77"
            },
            {
                "regex": "Intex[ _]([^/;]*)[ _]Build",
                "model": "$1"
            },
            {
                "regex": "CLOUD TREAD(?:[);/ ]|$)",
                "model": "Cloud Tread"
            },
            {
                "regex": "(Cloud (?:Fame|Glory) 4G)",
                "model": "$1"
            },
            {
                "regex": "(Aqua|Cloud)[ _\\.]([^/;\\)]+)(?:[ _]Build|(?<!Build)/|\\))",
                "model": "$1 $2"
            },
            {
                "regex": "Intex[ _]([a-z0-9_+\\-]+)",
                "model": "$1"
            }
        ]
    },
    "i-mate": {
        "regex": "i-mate ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "i-mobile": {
        "regex": "i-mobile[ _]?[a-z0-9]+|i-Style|IQ ?(9\\.1|5\\.5|5\\.6A?)",
        "device": "feature phone",
        "models": [
            {
                "regex": "i-mobile (i-note[^/;]*) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "i-Style ?([^;/)]+)(?: Build|[;)])",
                "model": "i-Style $1",
                "device": "smartphone"
            },
            {
                "regex": "(?:i-mobile_)?IQ[ _]XPRO2",
                "device": "smartphone",
                "model": "IQ X Pro 2"
            },
            {
                "regex": "(?:i-mobile_)?IQ[ _]BIG2",
                "device": "smartphone",
                "model": "IQ Big 2"
            },
            {
                "regex": "IQ ?(9\\.1|5\\.5|5\\.6A?|II)",
                "model": "IQ $1",
                "device": "smartphone"
            },
            {
                "regex": "IQ Z PRO",
                "model": "IQ Z Pro",
                "device": "smartphone"
            },
            {
                "regex": "IQ Z BRIGHT",
                "model": "IQ Z Bright",
                "device": "smartphone"
            },
            {
                "regex": "i-mobile (IQ[^/;]*) Build",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "i-mobile(?: )?([a-z0-9\\- ]+) Build",
                "model": "$1"
            },
            {
                "regex": "i-mobile(?: )?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "iKoMo": {
        "regex": "iKoMo ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "iOcean": {
        "regex": "iOCEAN|M6752|W180|X7[ _]?S|X8 mini",
        "device": "smartphone",
        "models": [
            {
                "regex": "X7S-T",
                "model": "X7S-T"
            },
            {
                "regex": "X8 mini pro",
                "model": "X8 Mini Pro"
            },
            {
                "regex": "X8 mini",
                "model": "X8 Mini"
            },
            {
                "regex": "X7[ _]?S",
                "model": "X7S Elite"
            },
            {
                "regex": "(M6752|W180) Build",
                "model": "$1"
            },
            {
                "regex": "iOCEAN[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "iOCEAN[ _-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "iView": {
        "regex": "(?:(?:733|730|766|930)TPC|769TPC(?:II)?|744TPC plus)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "744TPC plus",
                "model": "744TPC Plus"
            },
            {
                "regex": "((?:733|730|766|930)TPC|769TPC(?:II)?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Impression": {
        "regex": "(?:Impression[ _-]?([^/;]+)|A502|I10\\-LE|ImPad[ _]?(.*)|ImSmart[ _]?(.*))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(A502)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "ImSmart[ _]?([^/;)]+)(?: Build|\\))",
                "model": "ImSmart $1",
                "device": "smartphone"
            },
            {
                "regex": "ImPad[ _]?([^/;)]+)(?: Build|\\))",
                "model": "ImPad $1"
            },
            {
                "regex": "(I10\\-LE)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "Impression[ _-]?([^/;)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "iLife": {
        "regex": "WTAB[ _]?\\d{3}|(ITELL[_ ](?:K3300|K3500N?|K4700)|K3102 WIFI|FIVO (?:PLUS|Lite)|Zed Book G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "K3102 WIFI",
                "model": "K3102 WiFi"
            },
            {
                "regex": "WTAB[ _]?(\\d{3}(?:[^;/)]*))(?: Build|[;)])",
                "model": "WTAB $1"
            },
            {
                "regex": "(ITELL[_ ](?:K3300|K3500N?|K4700))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Zed Book G",
                "model": "Zed Book G"
            },
            {
                "regex": "FIVO PLUS(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Fivo Plus"
            },
            {
                "regex": "FIVO Lite(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Fivo Lite"
            }
        ]
    },
    "iTel": {
        "regex": "itel|iNote|GP10X2019(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "W6502",
                "device": "phablet",
                "model": "S16"
            },
            {
                "regex": "L6503",
                "device": "phablet",
                "model": "S16 Pro"
            },
            {
                "regex": "C671L",
                "model": "City 100"
            },
            {
                "regex": "A671LC",
                "model": "A80"
            },
            {
                "regex": "A6610L",
                "model": "A90"
            },
            {
                "regex": "W5505",
                "model": "A36"
            },
            {
                "regex": "A507LV",
                "model": "V52 LTE"
            },
            {
                "regex": "A632W",
                "model": "A04"
            },
            {
                "regex": "A663L",
                "model": "A05s"
            },
            {
                "regex": "S667LN",
                "model": "S24"
            },
            {
                "regex": "S665LN?",
                "model": "S23"
            },
            {
                "regex": "S681LN",
                "model": "S23+"
            },
            {
                "regex": "A662LM",
                "model": "A60s"
            },
            {
                "regex": "A662L",
                "model": "A60"
            },
            {
                "regex": "A667L",
                "model": "A50"
            },
            {
                "regex": "A665L",
                "model": "A70"
            },
            {
                "regex": "W5504",
                "model": "P33"
            },
            {
                "regex": "W5503",
                "model": "Alpha"
            },
            {
                "regex": "W5002",
                "model": "A35"
            },
            {
                "regex": "A571W",
                "model": "A37"
            },
            {
                "regex": "A631L",
                "model": "A49 Play"
            },
            {
                "regex": "A507LM",
                "model": "AC50"
            },
            {
                "regex": "W6002E?",
                "model": "S15"
            },
            {
                "regex": "S663L[NC]",
                "model": "Vision 5"
            },
            {
                "regex": "S662LCN?",
                "model": "Vision 5 Plus"
            },
            {
                "regex": "S663L",
                "model": "S18"
            },
            {
                "regex": "S661W",
                "model": "S17"
            },
            {
                "regex": "A551L",
                "model": "S17 Pro"
            },
            {
                "regex": "W5005P?",
                "model": "P15"
            },
            {
                "regex": "P552W",
                "model": "P17 Pro"
            },
            {
                "regex": "P551W",
                "model": "P17"
            },
            {
                "regex": "A666L",
                "model": "P55"
            },
            {
                "regex": "P663L",
                "model": "P55+"
            },
            {
                "regex": "P665L",
                "model": "P55T"
            },
            {
                "regex": "P661N",
                "model": "P55 5G"
            },
            {
                "regex": "P671L",
                "model": "P65"
            },
            {
                "regex": "P666L",
                "model": "P65C"
            },
            {
                "regex": "W5003",
                "model": "S32 Mini"
            },
            {
                "regex": "L5502",
                "model": "A44 Air"
            },
            {
                "regex": "L5505",
                "model": "A47"
            },
            {
                "regex": "W5006X",
                "model": "A17"
            },
            {
                "regex": "A510W",
                "model": "A16 Plus"
            },
            {
                "regex": "L6006",
                "model": "A48"
            },
            {
                "regex": "A571L",
                "model": "A26"
            },
            {
                "regex": "S666LN",
                "model": "RS4"
            },
            {
                "regex": "P651W",
                "model": "P37"
            },
            {
                "regex": "A509WM?",
                "model": "A33 Plus"
            },
            {
                "regex": "P681L",
                "model": "P37 Pro"
            },
            {
                "regex": "W6501",
                "model": "P36"
            },
            {
                "regex": "P661W",
                "model": "P38"
            },
            {
                "regex": "L5007",
                "model": "A24"
            },
            {
                "regex": "A511LP",
                "model": "A24 Pro"
            },
            {
                "regex": "A512W",
                "model": "A18"
            },
            {
                "regex": "A513W",
                "model": "A18s"
            },
            {
                "regex": "L6003P",
                "model": "A55 LTE"
            },
            {
                "regex": "L6002P",
                "model": "S15 Pro"
            },
            {
                "regex": "[LW]6503",
                "model": "S16 Pro"
            },
            {
                "regex": "A511LQ",
                "model": "A23S"
            },
            {
                "regex": "L5006[CS]",
                "model": "A23 Pro"
            },
            {
                "regex": "L5002P",
                "model": "A25 Pro"
            },
            {
                "regex": "L5002",
                "model": "A25"
            },
            {
                "regex": "A507LS",
                "model": "A24"
            },
            {
                "regex": "L5503",
                "model": "A46"
            },
            {
                "regex": "A661L",
                "model": "A49"
            },
            {
                "regex": "W6004P",
                "model": "A56 Pro"
            },
            {
                "regex": "A661WP",
                "model": "A58 Pro"
            },
            {
                "regex": "A661W",
                "model": "A58"
            },
            {
                "regex": "A631W",
                "model": "A58 Lite"
            },
            {
                "regex": "L6004L",
                "model": "AC60"
            },
            {
                "regex": "W4001S",
                "model": "V41"
            },
            {
                "regex": "W4001",
                "model": "AC13"
            },
            {
                "regex": "W4002",
                "model": "A14 Plus"
            },
            {
                "regex": "W4003",
                "model": "A14 Max"
            },
            {
                "regex": "[LW]6004",
                "model": "A56 LTE"
            },
            {
                "regex": "W6001",
                "model": "P33 Plus"
            },
            {
                "regex": "W5001P",
                "model": "A33"
            },
            {
                "regex": "W6003",
                "model": "A55"
            },
            {
                "regex": "A611W",
                "model": "A57"
            },
            {
                "regex": "itel[ _]A15R",
                "model": "A15"
            },
            {
                "regex": "P662LN?",
                "model": "P40"
            },
            {
                "regex": "P683L",
                "model": "P40+"
            },
            {
                "regex": "L6005",
                "model": "Vision 1"
            },
            {
                "regex": "P682LPN?",
                "model": "Vision 3 Plus"
            },
            {
                "regex": "P682L",
                "model": "P38 Pro"
            },
            {
                "regex": "P651L",
                "model": "Vision 2S"
            },
            {
                "regex": "L6501",
                "model": "Vision 1 Plus"
            },
            {
                "regex": "L6502",
                "model": "Vision 1 Pro"
            },
            {
                "regex": "S661L",
                "model": "Vision 3"
            },
            {
                "regex": "GP10X2019",
                "model": "GP10X2019"
            },
            {
                "regex": "iNote ([^/;]*)Build",
                "model": "iNote $1"
            },
            {
                "regex": "iNote_([a-z0-9\\-_]+)",
                "model": "iNote $1"
            },
            {
                "regex": "itel-it(1410|1512|1520)(?:[);/ ]|$)",
                "model": "it$1"
            },
            {
                "regex": "itel-it1553(?:[);/ ]|$)",
                "model": "Power Pro"
            },
            {
                "regex": "S11Plus(?:[);/ ]|$)",
                "model": "S11 Plus"
            },
            {
                "regex": "itel[- ](A14S?|A16 Plus|A44 Power|A23S|A52 Lite)",
                "model": "$1"
            },
            {
                "regex": "itel it1701",
                "device": "tablet",
                "model": "iNote Prime"
            },
            {
                "regex": "itel P10001L",
                "device": "tablet",
                "model": "Pad 1"
            },
            {
                "regex": "itel W7001",
                "device": "tablet",
                "model": "KidPad 1"
            },
            {
                "regex": "itel W7002",
                "device": "tablet",
                "model": "PrimeTab 1"
            },
            {
                "regex": "P10003L",
                "device": "tablet",
                "model": "Vista Tab 30"
            },
            {
                "regex": "itel it170([23])",
                "device": "tablet",
                "model": "iNote Prime $1"
            },
            {
                "regex": "itel A(\\d{1,2}) ?Plus",
                "model": "A$1 Plus"
            },
            {
                "regex": "iTel ([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "iTel[_ ]([a-z0-9\\-_]*)",
                "model": "$1"
            }
        ]
    },
    "iZotron": {
        "regex": "(Mi7_HERO_(?:BETA|TAB))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Mi7[_ ]HERO[_ ]BETA(?:[);/ ]|$)",
                "model": "MI7 Hero Beta"
            },
            {
                "regex": "Mi7[_ ]HERO[_ ]TAB(?:[);/ ]|$)",
                "model": "MI7 Hero Tab"
            }
        ]
    },
    "JAY-Tech": {
        "regex": "(?<!VIVAX )(?<!VIVAX TABLET )TPC-(?!71213G)[A-Z0-9]+|TPCY-TX[TE][^);/ ]+",
        "device": "tablet",
        "models": [
            {
                "regex": "TPC-PA10\\.1M",
                "model": "Tablet PC PA10.1M"
            },
            {
                "regex": "TPC-(XE10D-H)",
                "model": "Tablet PC $1"
            },
            {
                "regex": "TPC-G1011LTE",
                "model": "Tablet PC G 10.11\" LTE"
            },
            {
                "regex": "TPC-([A-Z0-9]+)",
                "model": "Tablet PC $1"
            },
            {
                "regex": "(TPCY-TX[TE][^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Jiayu": {
        "regex": "JIAYU[ _-]|(?:JY-G4[\\\\_]G5|(?:JY-[a-z0-9]+)|JY_G4C)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:JIAYU G4_G5|JY-G4[\\\\_]G5)(?:[);/ ]|$)",
                "model": "G4/G5"
            },
            {
                "regex": "JIAYU[ _-](G4[S]?|G2F|G3[S]?|S[23])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "JY[-_]([a-z0-9]+|G4C)(?:[);/ ]|$)",
                "model": "JY-$1"
            }
        ]
    },
    "Jolla": {
        "regex": "Jolla",
        "device": "smartphone",
        "model": ""
    },
    "Juniper Systems": {
        "regex": "Junipers/",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cedar#CT8",
                "device": "tablet",
                "model": "CT8"
            }
        ]
    },
    "Just5": {
        "regex": "JUST5(-)?SPACER(s)?|COSMO[_ ](L707|L808)|BLASTER|FREEDOM[ _](C10[05]|M303|X1)|Freedom(?!TurboXL)",
        "device": "smartphone",
        "models": [
            {
                "regex": "COSMO[_ ](L707|L808)",
                "model": "Cosmo $1"
            },
            {
                "regex": "FREEDOM[ _](C10[05]|M303|X1)",
                "model": "Freedom $1"
            },
            {
                "regex": "Freedom",
                "model": "Freedom"
            },
            {
                "regex": "JUST5(-)?SPACER2s",
                "model": "Spacer 2S"
            },
            {
                "regex": "JUST5(-)?SPACER2",
                "model": "Spacer 2"
            },
            {
                "regex": "JUST5SPACER",
                "model": "Spacer"
            },
            {
                "regex": "BLASTER 2",
                "model": "Blaster 2"
            },
            {
                "regex": "BLASTER",
                "model": "Blaster"
            }
        ]
    },
    "SuperTV": {
        "regex": "Android 7(?:[\\d.]*); (?:BLACK|WHITE) X(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "BLACK X",
                "model": "Black X"
            },
            {
                "regex": "WHITE X",
                "model": "White X"
            }
        ]
    },
    "Kalley": {
        "regex": "KALLEY|(?:ELEMENT (?:4 Plus|5|MAX|PLAY|Q)|ELEMENT_PRO_2|K-BOOK(?:8MG|73G)|SILVER_MAX(?:_Pro_2)?|Silver Max (?:Lite|Pro)|Black[ _][13CEGXZ](?:_PRO)?|Black_G_2|BLACK_PRO|ATV R[12]|GOLD_PRO|KBOOK7M)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Black_G_2",
                "model": "Black G 2"
            },
            {
                "regex": "Black[ _](C)_PRO",
                "model": "Black $1 Pro"
            },
            {
                "regex": "Black[ _]([13ECGXZ])",
                "model": "Black $1"
            },
            {
                "regex": "BLACK_PRO",
                "model": "Black Pro"
            },
            {
                "regex": "Element 4 Plus",
                "model": "Element 4 Plus"
            },
            {
                "regex": "Element 5(?:[);/ ]|$)",
                "model": "Element 5"
            },
            {
                "regex": "ELEMENT MAX",
                "model": "Element Max"
            },
            {
                "regex": "Silver[_ ]Max[_ ]Pro[_ ]2",
                "model": "Silver Max Pro 2"
            },
            {
                "regex": "Silver Max (Lite|Pro)",
                "model": "Silver Max $1"
            },
            {
                "regex": "SILVER_MAX",
                "model": "Silver Max"
            },
            {
                "regex": "ELEMENT PLAY",
                "model": "Element Play"
            },
            {
                "regex": "ELEMENT Q",
                "model": "Element Q"
            },
            {
                "regex": "ELEMENT_PRO_2",
                "model": "Element Pro 2"
            },
            {
                "regex": "GOLD_PRO",
                "model": "Gold Pro"
            },
            {
                "regex": "K-?BOOK(8MG|73G|7M)",
                "device": "tablet",
                "model": "K-BOOK$1"
            },
            {
                "regex": "ATV (R[12])",
                "device": "tv",
                "model": "Android TV $1"
            },
            {
                "regex": "KALLEY,(43D1800|55D1240)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Kaan": {
        "regex": "KAAN[ _](N[12]|A1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Kazam": {
        "regex": "Kazam|(?:Trooper_X[0-9][0-9]|Tornado 348|TROOPER 4\\.0)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tornado 348",
                "model": "Tornado 348"
            },
            {
                "regex": "Thunder 450W",
                "model": "Thunder 450W"
            },
            {
                "regex": "TROOPER 4\\.0",
                "model": "Trooper X4.0"
            },
            {
                "regex": "Trooper_X([0-9])([0-9])(?:[);/ ]|$)",
                "model": "Trooper X$1.$2"
            },
            {
                "regex": "Kazam[; _]([^;/)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "Kazuna": {
        "regex": "KAZ-N20",
        "device": "smartphone",
        "models": [
            {
                "regex": "KAZ-N20",
                "model": "eTalk MYFLIX"
            }
        ]
    },
    "Keneksi": {
        "regex": "KENEKSI|(?:Hemera|Teta Dual|Helios)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Hemera|Teta Dual|Helios)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "KENEKSI[ _-]liberty",
                "model": "Liberty"
            },
            {
                "regex": "KENEKSI[ _-]FLASH",
                "model": "Flash"
            },
            {
                "regex": "KENEKSI[ _-]SUN",
                "model": "Sun"
            },
            {
                "regex": "KENEKSI[ _-]ZETA",
                "model": "Zeta"
            },
            {
                "regex": "KENEKSI[ _-]SIGMA",
                "model": "Sigma"
            },
            {
                "regex": "KENEKSI[ _-](Moon|Libra_Dual|Glass|Amber|Chance|Amulet|Choice|Crystal|Dream|Delta[_ ]Dual|Norma 2|Norma|Sky|Fire 2|Fire|Flame|Flora|Rock|Solo|Soul|Step|Smart|Star|Storm|Wind)",
                "model": "$1"
            }
        ]
    },
    "Kempler & Strauss": {
        "regex": "Alumini_?3_?Plus|Alumini ?[23]|KEMPLER_(?:P[13]|TV|[X9]|8_PLUS)|ZKEMPLER[ _](?:PLUS|PRO)|P1[ _]Amateur",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alumini ?2",
                "model": "Alumini 2"
            },
            {
                "regex": "Alumini_?3_?Plus",
                "model": "Alumini 3 Plus"
            },
            {
                "regex": "Alumini3",
                "model": "Alumini 3"
            },
            {
                "regex": "KEMPLER_P([13])",
                "model": "P$1"
            },
            {
                "regex": "P1[ _]Amateur",
                "model": "P1 Amateur"
            },
            {
                "regex": "KEMPLER_TV",
                "model": "TV"
            },
            {
                "regex": "KEMPLER_X",
                "model": "X"
            },
            {
                "regex": "KEMPLER_8_PLUS",
                "model": "8 Plus"
            },
            {
                "regex": "KEMPLER_9",
                "model": "9"
            },
            {
                "regex": "ZKEMPLER PLUS",
                "model": "ZKempler Plus",
                "device": "tablet"
            },
            {
                "regex": "ZKEMPLER_PRO",
                "model": "ZKempler Pro",
                "device": "tablet"
            }
        ]
    },
    "Kiano": {
        "regex": "Kiano|Elegance_[45]_[015](?:_PRO)?|ELEGANCE 5\\.0 Lite|Elegance_4\\.5|Elegance 6|CORE 10\\.1 DUAL 3G|Intelect ?(7|8|10)|Slim ?Tab ?\\d+(?:[_ ]3GR?)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Slim ?Tab ?(\\d+)(?:[_ ]3GR?)?",
                "model": "Slim Tab $1",
                "device": "tablet"
            },
            {
                "regex": "CORE 10\\.1 DUAL 3G",
                "model": "CORE 10.1 DUAL 3G",
                "device": "tablet"
            },
            {
                "regex": "Elegance_(5)_([51])_Pro",
                "model": "Elegance $1.$2\" Pro"
            },
            {
                "regex": "ELEGANCE 5\\.0 Lite",
                "model": "Elegance 5.0\" Lite"
            },
            {
                "regex": "Elegance 6",
                "model": "Elegance 6 5.85\""
            },
            {
                "regex": "Elegance_([45])[_.]([015])",
                "model": "Elegance $1.$2\""
            },
            {
                "regex": "(Kiano)?(Intelect|Elegance) ?(7|8|10)?",
                "model": "$2 $3",
                "device": "tablet"
            },
            {
                "regex": "Kiano[ _]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "kidiby": {
        "regex": "KIDIBY",
        "device": "tablet",
        "model": ""
    },
    "Kingbox": {
        "regex": "Kingbox",
        "device": "tv",
        "model": ""
    },
    "Kingstar": {
        "regex": "Kingstar",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kingstar[-_ ]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Kingsun": {
        "regex": "Kingsun[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kingsun[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Kingsun[ -]((?!Build)[a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Kocaso": {
        "regex": "Kocaso|(?:DX765 Pro|M(?:6200|729|7[357][026][hw]?|76[01236][bw]?|83[016]|8[567]0|1050s|106[012368]w?|1070|X736(?:-kit)?|X780))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "DX765 Pro(?:[);/ ]|$)",
                "model": "DX765 Pro"
            },
            {
                "regex": "M6200(?:[);/ ]|$)",
                "model": "M6200"
            },
            {
                "regex": "M729(?:[);/ ]|$)",
                "model": "M729"
            },
            {
                "regex": "M(7[357][026])[hw]?(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M(76[01236])[bw]?(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "MX780(?:[);/ ]|$)",
                "model": "MX780"
            },
            {
                "regex": "M(83[016])(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M(8[567]0)(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M851(?:[);/ ]|$)",
                "model": "M851"
            },
            {
                "regex": "M1050S(?:[);/ ]|$)",
                "model": "M1050s"
            },
            {
                "regex": "M(106[012368])W?(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "M1070(?:[);/ ]|$)",
                "model": "M1070"
            },
            {
                "regex": "MX736(?:-kit)?(?:[);/ ]|$)",
                "model": "MX736"
            },
            {
                "regex": "Kocaso[ _-]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Kocaso[ _-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Kogan": {
        "regex": "Kogan|(?:Agora (?:8 Plus|XI|Go|Lite|4G Pro))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kogan ?(SmarterTV(?: 2K)?|TV|TVAP)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Agora ([68]) ?Plus",
                "model": "Agora $1 Plus"
            },
            {
                "regex": "Agora XI",
                "model": "Agora 11"
            },
            {
                "regex": "Agora Go",
                "model": "Agora Go"
            },
            {
                "regex": "Agora 4G Pro",
                "model": "Agora 4G Pro"
            },
            {
                "regex": "Agora Lite",
                "model": "Agora Lite"
            },
            {
                "regex": "Kogan[ _-]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Kogan[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Komu": {
        "regex": "Komu[_ -]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Komu[_ -]([^;/).]+)(?: Build|[;).])",
                "model": "$1"
            },
            {
                "regex": "Komu[_ -]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Koobee": {
        "regex": "Koobee|(?:F2_Plus|SL004T|Android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:K60))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SL004T",
                "model": "K100"
            },
            {
                "regex": "F2[_ ]Plus",
                "model": "F2 Plus"
            },
            {
                "regex": "(K60)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Koobee[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Koobee[ _-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Kumai": {
        "regex": "(?:KM-)?Kumai",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:KM-)?Kumai[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:KM-)?Kumai[ _-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "KT-Tech": {
        "regex": "(KM-[a-z0-9]+|EV-[a-z0-9]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "KDDI": {
        "regex": "kddi-([a-z0-9]+)|(?:INFOBAR A01|HTX21|HTL21)(?:[);/ ]|$)",
        "device": "feature phone",
        "models": [
            {
                "regex": "kddi-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "INFOBAR (A01)",
                "device": "smartphone",
                "model": "iida InfoBar $1"
            },
            {
                "regex": "HTX21(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "InfoBar A02"
            },
            {
                "regex": "HTL21(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "J Butterfly"
            }
        ]
    },
    "PIXPRO": {
        "regex": "PIXPRO[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "L1 Pro",
                "model": "L1 Pro"
            }
        ]
    },
    "Kodak": {
        "regex": "KODAK|(?:IM5|KD50|Ektra|Smartway[_ ](?:[FT]1|[LT]2)|D55L|D61L|D6[05]LX|PATH_7XPRO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IM5",
                "model": "IM5"
            },
            {
                "regex": "(KD50|D55L|D6[05]LX|D61L)",
                "model": "Seren $1"
            },
            {
                "regex": "Ektra(?:[);/ ]|$)",
                "model": "Ektra"
            },
            {
                "regex": "(?:KODAK[_ ])?SMARTWAY[_ ]L1 PRO",
                "model": "Smartway L1 Pro"
            },
            {
                "regex": "(?:KODAK[_ ])?SMARTWAY[_ ]([FLMTX]1|[LMTX]2|T3)",
                "model": "Smartway $1"
            },
            {
                "regex": "Tablet (7|10)",
                "device": "tablet",
                "model": "Tablet $1"
            },
            {
                "regex": "PATH_7XPRO",
                "device": "tv",
                "model": "7XPRO"
            }
        ]
    },
    "KOPO": {
        "regex": "J?KOPO[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "J?KOPO[ _-]?([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "J?KOPO[ _-]?([^/;)]+)",
                "model": "$1"
            }
        ]
    },
    "Koridy": {
        "regex": "KORIDY[ _-]([^/;]+) Build",
        "device": "smartphone",
        "model": "$1"
    },
    "KRONO": {
        "regex": "(?:NET1100|NET (?:HIT|ALPHA)|NET_(?:LITE|TITAN|VOLT|MAX|MATRIX|[KR]7|HIT)|android 8([\\d.]*);(?: [\\w-]+;)? NETWORK)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NET1100",
                "model": "NET 1100"
            },
            {
                "regex": "NET[_ ](LITE|TITAN|VOLT|HIT|ALPHA)",
                "model": "NET $1"
            },
            {
                "regex": "NET_MATRIX",
                "device": "tablet",
                "model": "Net Matrix"
            },
            {
                "regex": "NET_MAX",
                "device": "tablet",
                "model": "Net Max"
            },
            {
                "regex": "NET_([KR]7)",
                "device": "tablet",
                "model": "Net $1"
            },
            {
                "regex": "NETWORK",
                "device": "tablet",
                "model": "Network"
            }
        ]
    },
    "K-Touch": {
        "regex": "K-?Touch[ _][a-z0-9]+|(?:Pace 2 Lite|KT202011(?:99|88)|LDXA-2[01]22|LDOX-2130|LDOX-212[13])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "KT20201199",
                "model": "P60 Pro"
            },
            {
                "regex": "KT20201188",
                "model": "T12 Pro Max"
            },
            {
                "regex": "LDOX-2130",
                "model": "i13 Pro Max"
            },
            {
                "regex": "LDOX-2123",
                "model": "X13 Pro"
            },
            {
                "regex": "LDOX-2121",
                "model": "MT40"
            },
            {
                "regex": "LDXA-2022",
                "model": "X27S Pro"
            },
            {
                "regex": "LDXA-2122",
                "model": "X27S"
            },
            {
                "regex": "Pace 2 Lite",
                "model": "Pace 2 Lite"
            },
            {
                "regex": "K-?Touch[ _]([^/;]*)[ _]Build",
                "model": "$1"
            },
            {
                "regex": "K-?Touch[ _]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Diva": {
        "regex": "(QC-(?:703GN|704GA|803GN|1013G|7BHD)|QC7704GM|T10K_Plus)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Kyocera": {
        "regex": "Kyocera|KWC-|QC-[0-9]{4}|(?:QC6035|NP501KC|302KC|503KC|602KC|705KC|901KC|C51[27]0|C5155|C5215|C67[35]0|C6522N?|C6530N|C6740N?|C6743|E6[89]10|KYL2[13]|KYV3[1-9]|KYT3[123]|KYF3[1235789]|KYF4[012]|KYX31|KYG0[13]|KYY2[1-4]|S2151|KC-S701|S[468]-KC|S9-KC|S10-KC|KYV40U?|KYY31|KYV4[1-8]|KYV4[47]|KC-S301AE|KC-S302|X3-KC|E6560[CT]|E6782[L]?|E6790(?:TM)?|SZJ-JS20[12]|KCP01K|[47]04KC|A[0-3]01KC|A205KC|WX10K|URBANO PROGRESSO|E7110|E7200|E6921|KY-(?:42C|51B)|C6930|A101BM)(?:[-_][uj]2?)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "C5120(?:[);/ ]|$)",
                "model": "Milano"
            },
            {
                "regex": "(A101BM)(?:[);/ ]|$)",
                "model": "Balmuda $1"
            },
            {
                "regex": "S([4689]|10)-KC(?:[);/ ]|$)",
                "model": "One S$1"
            },
            {
                "regex": "C5155(?:[);/ ]|$)",
                "model": "Rise"
            },
            {
                "regex": "602KC(?:[);/ ]|$)",
                "model": "Digno G"
            },
            {
                "regex": "503KC(?:[);/ ]|$)",
                "model": "Digno E"
            },
            {
                "regex": "404KC(?:[);/ ]|$)",
                "model": "Digno C"
            },
            {
                "regex": "704KC(?:[);/ ]|$)",
                "model": "Digno J"
            },
            {
                "regex": "302KC(?:[);/ ]|$)",
                "model": "Digno T"
            },
            {
                "regex": "KC-S302(?:[);/ ]|$)",
                "model": "Digno XS2"
            },
            {
                "regex": "NP501KC(?:[);/ ]|$)",
                "model": "Digno"
            },
            {
                "regex": "WX10K(?:[);/ ]|$)",
                "model": "Digno Dual 2"
            },
            {
                "regex": "KYV36(?:[);/ ]|$)",
                "model": "Digno Rafre"
            },
            {
                "regex": "901KC(?:[);/ ]|$)",
                "model": "Digno BX"
            },
            {
                "regex": "A101KC(?:[);/ ]|$)",
                "model": "Digno BX 2"
            },
            {
                "regex": "KY-42C(?:[);/ ]|$)",
                "model": "Digno Keitai R"
            },
            {
                "regex": "KYV39(?:[);/ ]|$)",
                "model": "Miraie F"
            },
            {
                "regex": "KYX31(?:[);/ ]|$)",
                "model": "Infobar XV"
            },
            {
                "regex": "C5170(?:[);/ ]|$)",
                "model": "Hydro"
            },
            {
                "regex": "C5215(?:[);/ ]|$)",
                "model": "Hydro EDGE"
            },
            {
                "regex": "C6522N?",
                "model": "Hydro XTRM"
            },
            {
                "regex": "C6730",
                "model": "Hydro ICON"
            },
            {
                "regex": "C6750",
                "model": "Hydro ELITE"
            },
            {
                "regex": "C6530N",
                "model": "Hydro LIFE"
            },
            {
                "regex": "C6740(N)?",
                "model": "Hydro WAVE"
            },
            {
                "regex": "C6743",
                "model": "Hydro Reach"
            },
            {
                "regex": "E6560[CT]",
                "model": "DuraForce"
            },
            {
                "regex": "(?:KYOCERA-)?E68[12]0",
                "model": "DuraForce Pro"
            },
            {
                "regex": "(?:KYOCERA-)?(?:E69[12]0|E6921)",
                "model": "DuraForce Pro 2"
            },
            {
                "regex": "(?:KYOCERA-)?(?:E7200)",
                "model": "DuraForce Pro 3"
            },
            {
                "regex": "E7110",
                "model": "DuraForce Ultra 5G"
            },
            {
                "regex": "C6930",
                "model": "DuraForce 5G"
            },
            {
                "regex": "KC-S701",
                "model": "Torque"
            },
            {
                "regex": "KYG01",
                "model": "Torque 5G"
            },
            {
                "regex": "KYL21(?:[);/ ]|$)",
                "model": "Digno S"
            },
            {
                "regex": "KYL23(?:[);/ ]|$)",
                "model": "Miraie"
            },
            {
                "regex": "KYY24(?:[);/ ]|$)",
                "model": "Torque G01"
            },
            {
                "regex": "KYG03(?:[);/ ]|$)",
                "model": "Torque G06"
            },
            {
                "regex": "(KYF32|KYF41)(?:[);/ ]|$)",
                "model": "Easy Mobile Phone $1"
            },
            {
                "regex": "KYF35(?:[);/ ]|$)",
                "model": "Marvera"
            },
            {
                "regex": "KYF40(?:[);/ ]|$)",
                "model": "Mamorino 5"
            },
            {
                "regex": "KYF3[179](?:[);/ ]|$)",
                "model": "Gratina 4G"
            },
            {
                "regex": "(KYV48|KYF42)(?:[);/ ]|$)",
                "model": "Gratina $1"
            },
            {
                "regex": "KYF33(?:[);/ ]|$)",
                "model": "Torque X01"
            },
            {
                "regex": "(KYF38)(?:[);/ ]|$)",
                "model": "Keitai $1"
            },
            {
                "regex": "KYV35(?:[);/ ]|$)",
                "model": "Torque G02"
            },
            {
                "regex": "KYV41(?:[);/ ]|$)",
                "model": "Torque G03"
            },
            {
                "regex": "KYV46(?:[);/ ]|$)",
                "model": "Torque G04"
            },
            {
                "regex": "KYV32?(?:[);/ ]|$)",
                "model": "Basio"
            },
            {
                "regex": "KYV47(?:-[uj])?(?:[);/ ]|$)",
                "model": "Basio 4"
            },
            {
                "regex": "KYV43(?:_j)?(?:[);/ ]|$)",
                "model": "Basio 3"
            },
            {
                "regex": "705KC(?:[);/ ]|$)",
                "model": "Kantan Sumaho"
            },
            {
                "regex": "KYV37(?:[);/ ]|$)",
                "model": "Qua Phone"
            },
            {
                "regex": "KYV42(?:_u)?(?:[);/ ]|$)",
                "model": "Qua Phone QX"
            },
            {
                "regex": "KYV44(?:_u2?)?(?:[);/ ]|$)",
                "model": "Qua Phone QZ"
            },
            {
                "regex": "KYT33(?:[);/ ]|$)",
                "model": "Qua Tab QZ10",
                "device": "tablet"
            },
            {
                "regex": "KYT32(?:[);/ ]|$)",
                "model": "Qua Tab QZ8",
                "device": "tablet"
            },
            {
                "regex": "KYT31(?:[);/ ]|$)",
                "model": "Qua Tab 01",
                "device": "tablet"
            },
            {
                "regex": "KYV40U?(?:[);/ ]|$)",
                "model": "Rafre"
            },
            {
                "regex": "KYV33(?:[);/ ]|$)",
                "model": "Infobar A03"
            },
            {
                "regex": "KYY21(?:[);/ ]|$)",
                "model": "Urbano L01"
            },
            {
                "regex": "KYY22(?:[);/ ]|$)",
                "model": "Urbano L02"
            },
            {
                "regex": "KYY23(?:[);/ ]|$)",
                "model": "Urbano L03"
            },
            {
                "regex": "KYV31(?:[);/ ]|$)",
                "model": "Urbano V01"
            },
            {
                "regex": "KYV34(?:[);/ ]|$)",
                "model": "Urbano V02"
            },
            {
                "regex": "KYV(?:45|38)(?:[);/ ]|$)",
                "model": "Urbano V03"
            },
            {
                "regex": "A301KC(?:[);/ ]|$)",
                "model": "DuraForce EX"
            },
            {
                "regex": "(?:Kyocera-)?E6790(?:TM)?",
                "model": "DuraForce XD"
            },
            {
                "regex": "X3-KC(?:[);/ ]|$)",
                "model": "One X3"
            },
            {
                "regex": "E6782(?:[);/ ]|$)",
                "model": "Brigadier"
            },
            {
                "regex": "E6782L(?:[);/ ]|$)",
                "model": "DuraScout"
            },
            {
                "regex": "KCP01K(?:[);/ ]|$)",
                "model": "Luce"
            },
            {
                "regex": "(KC-S301AE|KY-51B)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(SZJ-JS20[12])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "A001KC(?:[);/ ]|$)",
                "model": "Katan Sumaho 2"
            },
            {
                "regex": "A201KC(?:[);/ ]|$)",
                "model": "Katan Sumaho 2+"
            },
            {
                "regex": "A205KC(?:[);/ ]|$)",
                "model": "Katan Sumaho 3"
            },
            {
                "regex": "URBANO PROGRESSO(?:[);/ ]|$)",
                "model": "Urbano Progresso"
            },
            {
                "regex": "KYY31(?:[);/ ]|$)",
                "model": "GzOne Type-XX"
            },
            {
                "regex": "S2151",
                "model": "Coast",
                "device": "feature phone"
            },
            {
                "regex": "Kyocera-KZ-([a-z0-9]+)",
                "model": "KZ $1"
            },
            {
                "regex": "Kyocera(?:[\\-/])?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(KWC|QC)-?([a-z0-9]+)",
                "model": "$1-$2"
            }
        ]
    },
    "Mymaga": {
        "regex": "(MOVE_S201)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Kr\xfcger&Matz": {
        "regex": "Kruger[ _&]Matz|KrugerMatz[ _]|K&M|EAGLE_(?:807|961|107[46]|1068)|FLOW ?5PLUS|FLOW 1[01]|FLOW 4 PLUS|Flow 9|FLOW_5|FLOW7|FLOW6(?:S|Lite)?|DRIVE9|DRIVE 8|DRIVE[_ ]6S?|Drive 10|MOVE8mini|MOVE9| MOVE 10|MOVE_|LIVE_6plus|LIVE 5 PLUS|Live [89]|LIVE4_KM043[89]|LIVE 7S?|LIVE 12|Flow 7S|Eagle 806|KM(?:106[679]|107[23]|1065G|0701(?:_1)?|0702|080[45](?:_1)?|1070)|Live 10S",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOVE8mini",
                "model": "MOVE 8 Mini"
            },
            {
                "regex": "MOVE_6_mini",
                "model": "MOVE 6 Mini"
            },
            {
                "regex": "MOVE[_ ]([78]|6S?|10)",
                "model": "MOVE $1"
            },
            {
                "regex": "DRIVE 4 mini LTE",
                "model": "DRIVE 4 mini LTE"
            },
            {
                "regex": "DRIVE[ _]?([45689][S]?|10)(?:[);/ ]|$)",
                "model": "DRIVE $1"
            },
            {
                "regex": "FLOW ?([54]) ?PLUS(?:[);/ ]|$)",
                "model": "FLOW $1 Plus"
            },
            {
                "regex": "FLOW6Lite(?:[);/ ]|$)",
                "model": "FLOW 6 Lite"
            },
            {
                "regex": "FLOW[ _]?([4-7][S]?|9|1[01])(?:[);/ ]|$)",
                "model": "FLOW $1"
            },
            {
                "regex": "LIVE4_(KM043[89])(?:[);/ ]|$)",
                "model": "LIVE 4 $1"
            },
            {
                "regex": "KrugerMatz_LIVE4(?:[);/ ]|$)",
                "model": "LIVE 4"
            },
            {
                "regex": "_LIVE5_(KM0450)(?:[);/ ]|$)",
                "model": "LIVE 5 $1"
            },
            {
                "regex": "LIVE 5 PLUS(?:[);/ ]|$)",
                "model": "LIVE 5 Plus"
            },
            {
                "regex": "LIVE_6plus(?:[);/ ]|$)",
                "model": "LIVE 6 Plus"
            },
            {
                "regex": "LIVE ([79]|10)S(?:[);/ ]|$)",
                "model": "LIVE $1S"
            },
            {
                "regex": "Live ([789]|12)(?:[);/ ]|$)",
                "model": "LIVE $1"
            },
            {
                "regex": "MOVE9(?:[);/ ]|$)",
                "model": "MOVE 9"
            },
            {
                "regex": "KM(106[679]|1072)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.1\""
            },
            {
                "regex": "KM(1073)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.4\""
            },
            {
                "regex": "Eagle 806(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE 806 8.0\""
            },
            {
                "regex": "Eagle_807(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE 807 8.4\""
            },
            {
                "regex": "Eagle_(107[46])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.4\""
            },
            {
                "regex": "EAGLE_(961|1068)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1"
            },
            {
                "regex": "KM(1070)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.5\""
            },
            {
                "regex": "KM(1065G)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 10.1\""
            },
            {
                "regex": "KM0(701)(?:_1)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 7.1\""
            },
            {
                "regex": "KM0(80[45])(?:_1)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 8.0\""
            },
            {
                "regex": "KM0(702)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "EAGLE $1 7.0\""
            },
            {
                "regex": "K&M,([a-z0-9_ -]+),(?:wired|wireless)",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "LAIQ": {
        "regex": "LAIQ|(?:Monaco)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:LAIQ_)?(Glam|New York|Dubai|Monaco)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "AIS": {
        "regex": "iris708|Kingcomm C500",
        "device": "smartphone",
        "models": [
            {
                "regex": "iris708",
                "model": "LAVA PRO 4.5"
            },
            {
                "regex": "Kingcomm C500",
                "model": "Super Smart Plus X3"
            }
        ]
    },
    "Beko": {
        "regex": "Beko(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "Benco": {
        "regex": "Benco[_ ]|(?:AE9(?:[03]10|1[25]0|2[2346]0|950)|AH9110|AEOP520|AEOP513)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AE9950",
                "model": "V60"
            },
            {
                "regex": "AE9150",
                "model": "V62"
            },
            {
                "regex": "AE9220",
                "model": "V70"
            },
            {
                "regex": "AE9010",
                "model": "V80"
            },
            {
                "regex": "AE9120",
                "model": "V90"
            },
            {
                "regex": "AE9310",
                "model": "V91"
            },
            {
                "regex": "AEOP520",
                "model": "V91 Plus"
            },
            {
                "regex": "AH9110",
                "model": "Y11"
            },
            {
                "regex": "AE9240",
                "model": "S1"
            },
            {
                "regex": "AEOP513",
                "model": "S1 Plus"
            },
            {
                "regex": "AE9260",
                "model": "S1 Pro"
            },
            {
                "regex": "AE9230",
                "model": "Y32"
            }
        ]
    },
    "Laser": {
        "regex": "(?:MID_1089IPSA100)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MID_1089IPSA100(?:[);/ ]|$)",
                "model": "MID-1089IPSA100"
            }
        ]
    },
    "Lava": {
        "regex": "Lava[ _]|LAVA(?:A1|X10)|(?:DISCOVER136|KKT QUADRA)|iris(?! Plus 2021|_Pad_G)[ _]?([^/;)]+)(?<!Plus 2021)(?: Build|[;)])|A(?:67|76) Build|X1 Selfie Build|X41 Plus Build|X1_atom_L|(?:Flair (?:[ZS]1|P8)|PixelV1|Pixel V2\\+?|Z60s|Z61_2GB|A97 IPS|A97 2GB PLUS|L[EH]9920(?:[_ ]P)?|L[NEH]9910|LH9810|Ivory(?:S1|S4G)?|A76Plus|Grand2c|AH9910| A3_mini|T71_w|V23GB|R1_Lite|Atom 2X|AF9030|Z50_Pro| Z(?:[56]1|92)|Android 6(?:[\\d.]*);(?: [\\w-]+;)? (:?X28|P7plus)|AF9020|Alfa L|T81N(?:_UP)?|LN982[01]|Fuel F1 Mini|LE000Z93P|LZX415)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LZX409(?:[);/ ]|$)",
                "model": "Blaze 2"
            },
            {
                "regex": "LXX506(?:[);/ ]|$)",
                "model": "Blaze Pro 5G"
            },
            {
                "regex": "LZX404(?:[);/ ]|$)",
                "model": "Blaze Pro"
            },
            {
                "regex": "LZX411(?:[);/ ]|$)",
                "model": "Blaze"
            },
            {
                "regex": "LZX407(?:[);/ ]|$)",
                "model": "Blaze NXT"
            },
            {
                "regex": "LXX503(?:[);/ ]|$)",
                "model": "Blaze 5G"
            },
            {
                "regex": "LXX505",
                "model": "Blaze Curve"
            },
            {
                "regex": "Flair ([ZS]1|P8)(?:[);/ ]|$)",
                "model": "Flair $1"
            },
            {
                "regex": "AF9030(?:[);/ ]|$)",
                "model": "Benco Y30"
            },
            {
                "regex": "AF9020(?:[);/ ]|$)",
                "model": "Benco Y50"
            },
            {
                "regex": "AH9910(?:[);/ ]|$)",
                "model": "Benco Y40"
            },
            {
                "regex": "LXX501(?:[);/ ]|$)",
                "model": "Agni 5G"
            },
            {
                "regex": "LXX504(?:[);/ ]|$)",
                "model": "Agni 2 5G"
            },
            {
                "regex": "Z61P(?:[);/ ]|$)",
                "model": "Z61 Pro"
            },
            {
                "regex": "A97 IPS(?:[);/ ]|$)",
                "model": "A97 IPS"
            },
            {
                "regex": "LF6810(?:[);/ ]|$)",
                "model": "R5s Play"
            },
            {
                "regex": "A97 2GB PLUS(?:[);/ ]|$)",
                "model": "A97 2GB Plus"
            },
            {
                "regex": "A76Plus(?:[);/ ]|$)",
                "model": "A76 Plus"
            },
            {
                "regex": "A3_mini(?:[);/ ]|$)",
                "model": "A3 Mini"
            },
            {
                "regex": "Pixel V2\\+(?:[);/ ]|$)",
                "model": "Pixel V2 Plus"
            },
            {
                "regex": "Pixel ?V([12])(?:[);/ ]|$)",
                "model": "Pixel V$1"
            },
            {
                "regex": "X1_atom_L(?:[);/ ]|$)",
                "model": "X1 Atom L"
            },
            {
                "regex": "X1 Selfie(?:[);/ ]|$)",
                "model": "Iris X1 Selfie"
            },
            {
                "regex": "X41 Plus(?:[);/ ]|$)",
                "model": "X41 Plus"
            },
            {
                "regex": "(?:LAVA[_ ]?)?A([13]|67|76)(?:[);/ ]|$)",
                "model": "A$1"
            },
            {
                "regex": "LAVA_R(1s?)",
                "model": "R$1"
            },
            {
                "regex": "LAVA Z3 UP",
                "model": "Z3"
            },
            {
                "regex": "LEX402",
                "model": "Z33"
            },
            {
                "regex": "Z(\\d{2})(?:_2GB)?(?:[);/ ]|$)",
                "model": "Z$1"
            },
            {
                "regex": "Z50_Pro(?:[);/ ]|$)",
                "model": "Z50 Pro"
            },
            {
                "regex": "LMX06(?:[);/ ]|$)",
                "model": "Z6"
            },
            {
                "regex": "LMG01(?:[);/ ]|$)",
                "model": "Z2"
            },
            {
                "regex": "LZG402 OM",
                "model": "Z21"
            },
            {
                "regex": "LZG403[ _]225(?:[);/ ]|$)",
                "model": "X2"
            },
            {
                "regex": "LE000Z93P(?:[);/ ]|$)",
                "model": "Z2"
            },
            {
                "regex": "LZG403[ _]25(?:[);/ ]|$)",
                "model": "Z3 Pro"
            },
            {
                "regex": "LZG403(?:[);/ ]|$)",
                "model": "Z3"
            },
            {
                "regex": "LZG401(?:[);/ ]|$)",
                "model": "Z6"
            },
            {
                "regex": "Z60s(?:[);/ ]|$)",
                "model": "Z60s"
            },
            {
                "regex": "V23GB(?:[);/ ]|$)",
                "model": "V2"
            },
            {
                "regex": "LE9920[ _]P(?:[);/ ]|$)",
                "model": "V7"
            },
            {
                "regex": "LE9940(?:[);/ ]|$)",
                "model": "V7 Prime"
            },
            {
                "regex": "LE9940_W",
                "model": "V7s Prime"
            },
            {
                "regex": "LE9920(?:[);/ ]|$)",
                "model": "Z53"
            },
            {
                "regex": "LH9910(?:[);/ ]|$)",
                "model": "Z52"
            },
            {
                "regex": "LF9810(?:_2GB)?(?:[);/ ]|$)",
                "model": "Z62"
            },
            {
                "regex": "LF9820(?:[);/ ]|$)",
                "model": "Z71"
            },
            {
                "regex": "LE9830(?:[);/ ]|$)",
                "model": "Z93"
            },
            {
                "regex": "LN9810(?:[);/ ]|$)",
                "model": "Iris 66"
            },
            {
                "regex": "LH9810(?:[);/ ]|$)",
                "model": "Iris 52"
            },
            {
                "regex": "LH993[01](?:[);/ ]|$)",
                "model": "Iris 54"
            },
            {
                "regex": "LE9930(?:[);/ ]|$)",
                "model": "Iris 59"
            },
            {
                "regex": "LH9950(?:[);/ ]|$)",
                "model": "Iris 46"
            },
            {
                "regex": "LN9821(?:[);/ ]|$)",
                "model": "Iris 45C"
            },
            {
                "regex": "LN9820(?:[);/ ]|$)",
                "model": "Iris 45"
            },
            {
                "regex": "Atom 2X(?:[);/ ]|$)",
                "model": "Iris Atom 2X"
            },
            {
                "regex": "Alfa L(?:[);/ ]|$)",
                "model": "Iris Alfa L"
            },
            {
                "regex": "LN9910(?:[);/ ]|$)",
                "model": "Z41"
            },
            {
                "regex": "LE9910(?:[);/ ]|$)",
                "model": "V8"
            },
            {
                "regex": "LH9920(?:[);/ ]|$)",
                "model": "V+6"
            },
            {
                "regex": "Grand2c",
                "model": "Grand 2C"
            },
            {
                "regex": "R1_Lite",
                "model": "R1 Lite"
            },
            {
                "regex": "LE9820",
                "model": "R5"
            },
            {
                "regex": "LE9810",
                "model": "R3 Note"
            },
            {
                "regex": "P7plus",
                "model": "P7 Plus"
            },
            {
                "regex": "LZX415",
                "model": "Yuva 3"
            },
            {
                "regex": "LZX414",
                "model": "Yuva 3 Pro"
            },
            {
                "regex": "LZX408",
                "model": "Yuva 2 Pro"
            },
            {
                "regex": "LIX402",
                "model": "Yuva Pro"
            },
            {
                "regex": "LZG409",
                "model": "Yuva Star"
            },
            {
                "regex": "LXX508",
                "model": "Storm 5G"
            },
            {
                "regex": "(X\\d+)[ _]Plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(X28)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "iris88[_ ]go",
                "model": "Iris 88 Go"
            },
            {
                "regex": "Fuel F1 Mini",
                "model": "Iris Fuel F1 Mini"
            },
            {
                "regex": "DISCOVER136",
                "device": "feature phone",
                "model": "Discover 136"
            },
            {
                "regex": "KKT QUADRA",
                "device": "feature phone",
                "model": "KKT Quadra"
            },
            {
                "regex": "KKT40[ ]?Power[P\\+]",
                "device": "feature phone",
                "model": "KKT40 Power Plus"
            },
            {
                "regex": "Ivory(S1|S4G)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Ivory $1"
            },
            {
                "regex": "T81N_UP(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T81N Up"
            },
            {
                "regex": "T81N(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T81N"
            },
            {
                "regex": "T71_w(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T71"
            },
            {
                "regex": "iris[ _]?([^/;)]+)[_ ]lite(?: Build|[);])",
                "model": "Iris $1 Lite"
            },
            {
                "regex": "iris[ _]?([^/;)]+)(?: Build|[);])",
                "model": "Iris $1"
            },
            {
                "regex": "Lava[ _]?([^/;)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "LAVA[ _]([^/;)]+)/MIDP",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "SKG": {
        "regex": "(Modern[ _](?:S10?|S[3679]))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "iVA": {
        "regex": "(LAMCY (?:L3[05]0|C100|L400)|IVA S6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LAMCY (L3[05]0|C100|L400)(?:[);/ ]|$)",
                "model": "Lamcy $1"
            },
            {
                "regex": "IVA S6(?:[);/ ]|$)",
                "model": "S6"
            }
        ]
    },
    "Landvo": {
        "regex": "XM[123]00|(?<!Blade |Haipainoble )S6 Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "S6 Build",
                "model": "S6"
            },
            {
                "regex": "XM([123])00([^/;)]*)(?: Build|[;)])",
                "model": "XM$100$2"
            }
        ]
    },
    "Land Rover": {
        "regex": "Land[ ]?Rover[d]?[ _-](?:X1[0-9]|Explore|LUXURY|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)|Polar3|Vphone[- ]X3|ST11-A5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Land[ ]?Rover[d]?[ _-](X1[0-9]|Explore(?: R)?|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Vphone[- ]X3",
                "model": "Vphone X3"
            },
            {
                "regex": "LUXURY",
                "model": "Luxury"
            },
            {
                "regex": "Polar3",
                "model": "Ioutdoor Polar 3"
            },
            {
                "regex": "(ST11-A5)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "iOutdoor": {
        "regex": "iOutdoor (X)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Lanin": {
        "regex": "lanin (T4)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Lanix": {
        "regex": "LANIX-([a-z0-9]+)|Ilium[ _]|LANIX_PAD|IliumPad|X120C|(?:Alpha 950(?:XL)?|Alpha [1359]V|Alpha 1R|X540)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ILIUM_PAD_RX10v5",
                "device": "tablet",
                "model": "Ilium Pad RX10 V5"
            },
            {
                "regex": "LANIX_PAD_E7",
                "device": "tablet",
                "model": "Ilium Pad E7"
            },
            {
                "regex": "ILIUM[ _]?PAD[ _]?([^;/]+)(?: Build|[;)])",
                "model": "Ilium Pad $1",
                "device": "tablet"
            },
            {
                "regex": "X120C",
                "model": "Ilium X120C"
            },
            {
                "regex": "Ilium[ _](Alpha [15]s|Alpha [379]|Alpha 1T|L(?:200|6[12]0|9[0125]0|1[0124]00|1050|1120)|LT5[012]0|M[579]s|M7T|M[13579]|S(?:106|520|6[27]0)|X(?:1[12]0|2[0126]0|400|5[12]0|500B|710))(?:[);/ ]|$)",
                "model": "Ilium $1"
            },
            {
                "regex": "ILIUM[ _]([^;/)]+)(?: Build|[;)])",
                "model": "Ilium $1"
            },
            {
                "regex": "Alpha (9500|950(?:XL)?)",
                "model": "Ilium Alpha $1"
            },
            {
                "regex": "Alpha ([1359])V",
                "model": "Alpha $1V"
            },
            {
                "regex": "Alpha (1)R",
                "model": "Alpha $1R"
            },
            {
                "regex": "(X540)",
                "model": "$1"
            },
            {
                "regex": "LANIX-([a-z0-9]+)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Lark": {
        "regex": "(Lark|Cumulus|Evolution|FreeMe|Ultimate (?:X4|7i))[ _-]|Build/Lark|Bjorn[_ ]SP-500|FreeBird 5WiFi|Impress_Noda",
        "device": "tablet",
        "models": [
            {
                "regex": "Cumulus[ _](5\\.5|[56])[ _]HD",
                "model": "Cumulus $1 HD",
                "device": "smartphone"
            },
            {
                "regex": "FreeMe X2 ([79]) (?:ver|v)?\\.([23])",
                "model": "FreeMe X2 $1 Version $2"
            },
            {
                "regex": "FreeMe X4 7 3G HD",
                "model": "FreeMe X4 7HD 3G"
            },
            {
                "regex": "FreeMe[ _]X2[ _]([7-9])",
                "model": "FreeMe X2 $1"
            },
            {
                "regex": "FreeMe X4[ _]7[_ ]?HD",
                "model": "FreeMe X4 7HD"
            },
            {
                "regex": "FreeMe X4[ _]9",
                "model": "FreeMe X4 9"
            },
            {
                "regex": "FreeMe X4 7",
                "model": "FreeMe X4 7"
            },
            {
                "regex": "FreeBird 5WiFi",
                "model": "FreeBird 5 WiFi"
            },
            {
                "regex": "(?:Lark[ _-])?Evolution[ _](X2 7 3G-GPS|X4[_ ]10\\.1|10|X4[_ ]7[ _]IPS)",
                "model": "Evolution $1"
            },
            {
                "regex": "Ul(?:ti|it)mate (X4 10\\.1 3G IPS|X4 8s 3G|7i)",
                "model": "Ultimate $1"
            },
            {
                "regex": "PHABLET 7",
                "model": "Phablet 7"
            },
            {
                "regex": "Phablet 6\\.0",
                "model": "Phablet 6.0",
                "device": "smartphone"
            },
            {
                "regex": "Bjorn[_ ]SP-500",
                "model": "Bjorn SP-500",
                "device": "smartphone"
            },
            {
                "regex": "Cirrus[ _](4\\.5|[45])",
                "model": "Cirrus $1",
                "device": "smartphone"
            },
            {
                "regex": "Lark[ _](Stratus[_ ]5)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "Impress_Noda",
                "model": "Impress Noda",
                "device": "smartphone"
            }
        ]
    },
    "LCT": {
        "regex": "LCT_([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Le Pan": {
        "regex": "Le ?Pan|TC970 ([^;/]+)Build",
        "device": "tablet",
        "models": [
            {
                "regex": "TC802A",
                "model": "Le Pan Mini"
            },
            {
                "regex": "TC970 ([^;/]+)Build",
                "model": "TC970 $1"
            },
            {
                "regex": "Le ?Pan ?(II|S)(?:[);/ ]|$)",
                "model": "Le Pan $1"
            },
            {
                "regex": "Le ?Pan ?([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Leagoo": {
        "regex": "(?:MY)?LEAGOO[ _-]?|(?:XRover(?: C)?|Shark (5000|1|6300)|M5 EDGE|KIICAA (POWER|MIX)|Leapad[ _](?:X|7s|7Pro)|Alfa [125]|Elite [15Y]|Venture 1|Z10-E|M9 Pro|Power 5|Power[ _]2(?: Pro)?|Android 9(?:[\\d.]*);(?: [\\w-]+;)? M1[23]|Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:Z9A|T8s)|Lead 3| T5c)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:LEAGOO[- _])?M([89])[_-]?Pro(?:[);/ ]|$)",
                "model": "M$1 Pro"
            },
            {
                "regex": "LEAGOO[- _](Z[156]|Z5c|M[58]|T1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M5 EDGE",
                "model": "M5 Edge"
            },
            {
                "regex": "(?:LEAGOO[_ ])?Lead ?([357])",
                "model": "Lead $1"
            },
            {
                "regex": "KIICAA POWER",
                "model": "KICCAA Power"
            },
            {
                "regex": "KIICAA MIX",
                "model": "KICCAA Mix"
            },
            {
                "regex": "Elite ([15Y])(?:[);/ ]|$)",
                "model": "Elite $1"
            },
            {
                "regex": "Shark (1|5000|6300)(?:[);/ ]|$)",
                "model": "Shark $1"
            },
            {
                "regex": "Power 2 Pro(?:[);/ ]|$)",
                "model": "Power 2 Pro"
            },
            {
                "regex": "(?:leagoo-)?Power[ _]([25])(?:[);/ ]|$)",
                "model": "Power $1"
            },
            {
                "regex": "Venture 1(?:[);/ ]|$)",
                "model": "Venture 1"
            },
            {
                "regex": "Alfa ([125])(?:[);/ ]|$)",
                "model": "Alfa $1"
            },
            {
                "regex": "XRover( C)?(?:[);/ ]|$)",
                "model": "XRover$1"
            },
            {
                "regex": "(?:LEAGOO[- _])?(Z10-E|M6|M1[23]|T5c|T8s|Z9A)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:My)?Leagoo[- _](E4)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Leapad 7Pro",
                "device": "tablet",
                "model": "LeaPad 7 Pro"
            },
            {
                "regex": "LEAGOO_LEAPAD7_8",
                "device": "tablet",
                "model": "LeaPad 7"
            },
            {
                "regex": "(?:LEAGOO_)?Leapad[ _](7s|10|X|7I)",
                "model": "LeaPad $1",
                "device": "tablet"
            }
        ]
    },
    "Ledstar": {
        "regex": "(?:Ledstar[_ ])?(?:Trendy 5\\.0|Novus_Premium_6\\.0)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Trendy 5\\.0",
                "model": "Trendy 5.0"
            },
            {
                "regex": "Ledstar_Novus_Premium_6\\.0(?:[);/ ]|$)",
                "model": "Novus Premium 6.0\""
            }
        ]
    },
    "Leelbox": {
        "regex": "Leelbox(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Leelbox(?:[);/ ]|$)",
                "model": ""
            }
        ]
    },
    "LeEco": {
        "regex": "Letv|LeEco|Le ?X[0-9][^;/]+|Le Max|Le [12]|Le2[_ ]x527|X900 Build|(?:X[89]00\\+|X52[67]|lineage_c106)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X800\\+",
                "model": "Le 1 Pro"
            },
            {
                "regex": "X900\\+",
                "model": "Max X900+"
            },
            {
                "regex": "X50[10]",
                "model": "Le 1S"
            },
            {
                "regex": "LE ?(X62[26]|X522)",
                "model": "Le 3S $1"
            },
            {
                "regex": "(X910)",
                "model": "$1"
            },
            {
                "regex": "X900 Build",
                "model": "Le X900"
            },
            {
                "regex": "LEX72[057](?:[);/ ]|$)",
                "model": "Le Pro 3"
            },
            {
                "regex": "LEX65[0137](?:[);/ ]|$)",
                "model": "Le Pro 3 AI"
            },
            {
                "regex": "LE(X620)(?:[);/ ]|$)",
                "model": "Le 2 $1"
            },
            {
                "regex": "(?:Le ?X526|Le2[_ ]x527|Le 2|X52[67])(?:[);/ ]|$)",
                "model": "Le 2"
            },
            {
                "regex": "lineage_c106",
                "model": "Cool 1"
            },
            {
                "regex": "LEX82[019]|Le Max 2",
                "model": "Le Max 2"
            },
            {
                "regex": "Le ?X([^;/]+) Build",
                "model": "Le X$1"
            },
            {
                "regex": "Le ?X([^) ;/]+)",
                "model": "Le X$1"
            },
            {
                "regex": "Le ?([12][^;/]+) Build",
                "model": "Le $1"
            },
            {
                "regex": "Le Max([^;/]*) Build",
                "model": "Le Max$1"
            },
            {
                "regex": "Le Max([^ ;/]*)",
                "model": "Le Max$1"
            },
            {
                "regex": "LeEco ([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Lephone": {
        "regex": "lephone[ _]|lephoneP1|S104G(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "lephone[ _](K7|K10)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "S104G",
                "model": "S104G"
            },
            {
                "regex": "lephone_W7_plus|lephone W7+",
                "model": "W7 Plus"
            },
            {
                "regex": "lephone(?:[ _])?([^/);]*)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Lemco": {
        "regex": "Lemco (FBX-3566W?)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Lenco": {
        "regex": "Lenco (?:[^/);]*)(?: Build|[);])|(?:TDV900)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "LENCO Diverso-700",
                "device": "portable media player",
                "model": "Diverso 700"
            },
            {
                "regex": "TDV900",
                "model": "TDV900"
            },
            {
                "regex": "Lenco ([^/);]*)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Aligator": {
        "regex": "ALIGATOR[_ ]|(?:RX[67]00|S5710|RX460)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RX850",
                "model": "RX850 eXtremo"
            },
            {
                "regex": "(?:ALIGATOR[ _])?(S4080|S[56]550|S50(?:6[56]|[678]0)|S55[24]0|S5710|RX510|S6[0156]00|RX710|RX[678]00|RX460)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Lenovo": {
        "regex": "(?:LNV-)?Lenovo|IdeaTab|IdeaPad|Thinkpad|Yoga Tablet|Tab2A[0-9]-[0-9]{2}[a-z]?|ZUK[ -_]|TB-X306|(?:TB2-X30L|TB3-710[IF]|TB128FU|YT3-X50[MFL]|K50a40|TB-(?:Q706Z|X103F|8504F|X304F|X704V|X704A)|A5500-H|A2107A-H|A3500-HV|A2109A|S6000|Z2 Plus|Vibe[ _](?:P1|S6i Plus|S[23567]i|C|[ZX]2|K5(?: Plus)?|V7)|P2A42|L38011|L18011|[5-8]01LV|[67]02LV|Z2131|K350t|K31-t3|Tab A1020|TAB 2 A8-50LC|S90-A|A101LV|P70-A|VR-1541F|d-42A|lineage_A6020|EveryPad2|A2010l36|F0CU0028RK|TB310XU|TB301[FX]U|TB132FU|TB32(?:8[FX]U|0FC)|TB138FC|PB-6505Y|TB-X505[FLX]|TB-8704V|TB351FU|TB3[05]0[FX]U|TB-X606[XFM]|L38043|TB3-X70L|TB-X605[LF]C?|A7600-HV?|YT-X703F|TB330XU|TB373FU|TB3[17]0FU|TB331FC|TB321FU|A397i|TB330FU|NL5H00X|L79031|XT2091-[78]|L71061|L70081|L78031|20JJS0CU1M|A6020l3[67]|A6020a46|TB360ZU|TB311[XF]U|TB37[15]FC|L58091|L39051|L19041|L19111|L780[157]1|Lecoo P116G|XT2129-3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Lenovo ?G780",
                "model": "G780",
                "device": "desktop"
            },
            {
                "regex": "Lecoo P116G",
                "model": "Lecoo 5G Cloud Tablet",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?A3500-FL",
                "model": "IdeaTab A7-40",
                "device": "tablet"
            },
            {
                "regex": "Tab A1020",
                "model": "IdeaTab A1020",
                "device": "tablet"
            },
            {
                "regex": "TB373FU",
                "model": "IdeaTab Pro 12.7\" (2025)",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo ?)?A3500-(?:H|HV|F)",
                "model": "IdeaTab A7-50",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo[ _])?A5500-[HF]",
                "model": "IdeaTab A8-50",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?A7600|A7600-H",
                "model": "IdeaTab A10-70",
                "device": "tablet"
            },
            {
                "regex": "A2107A-H",
                "model": "A2107",
                "device": "tablet"
            },
            {
                "regex": "A2109A",
                "model": "IdeaTab A2109A",
                "device": "tablet"
            },
            {
                "regex": "TB2-X30[FL]",
                "model": "Tab 2 A10-30",
                "device": "tablet"
            },
            {
                "regex": "TB-X6C6[XF]",
                "model": "Tab K10",
                "device": "tablet"
            },
            {
                "regex": "TB311[XF]U",
                "model": "Tab K10 (Gen 2)",
                "device": "tablet"
            },
            {
                "regex": "YT3-X50[FLM]",
                "model": "Yoga Tab 3",
                "device": "tablet"
            },
            {
                "regex": "YT-J706[XF]",
                "model": "Yoga Tab 11",
                "device": "tablet"
            },
            {
                "regex": "YT-K606F",
                "model": "Yoga Pad Pro",
                "device": "tablet"
            },
            {
                "regex": "TB3-730X",
                "model": "TAB3 7",
                "device": "tablet"
            },
            {
                "regex": "TB3-710[IF]",
                "model": "TAB3 7 Essential",
                "device": "tablet"
            },
            {
                "regex": "TB-7703X",
                "model": "TAB3 7 Plus",
                "device": "tablet"
            },
            {
                "regex": "TB3-X70L",
                "model": "TAB3 10 Plus",
                "device": "tablet"
            },
            {
                "regex": "TB3-X70F",
                "model": "TAB3 10 Business",
                "device": "tablet"
            },
            {
                "regex": "TB-8703[XF]",
                "model": "TAB3 8 Plus",
                "device": "tablet"
            },
            {
                "regex": "TB-8X04F",
                "model": "TAB4 8 REL",
                "device": "tablet"
            },
            {
                "regex": "TAB 2 A8-50LC",
                "model": "TAB2 A8-50LC",
                "device": "tablet"
            },
            {
                "regex": "501LV(?:[);/ ]|$)",
                "model": "TAB2 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "TAB 2 A10-70L(?:[);/ ]|$)",
                "model": "TAB 2 A10",
                "device": "tablet"
            },
            {
                "regex": "(?:TB3-850[FM]|601LV)(?:[);/ ]|$)",
                "model": "TAB3 8",
                "device": "tablet"
            },
            {
                "regex": "602LV(?:[);/ ]|$)",
                "model": "TAB3 8 Dual",
                "device": "tablet"
            },
            {
                "regex": "TB-X304[FL]",
                "model": "TAB4 10",
                "device": "tablet"
            },
            {
                "regex": "TB-8504[XL]",
                "model": "TAB4 8",
                "device": "tablet"
            },
            {
                "regex": "TB-8704X",
                "model": "TAB4 8 Plus",
                "device": "tablet"
            },
            {
                "regex": "(?:TB-X704[FVL]|70[12]LV)(?:[);/ ]|$)",
                "model": "TAB4 10 Plus",
                "device": "tablet"
            },
            {
                "regex": "801LV(?:[);/ ]|$)",
                "model": "TAB5 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X103F(?:[);/ ]|$)",
                "model": "TAB10 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X704A(?:[);/ ]|$)",
                "model": "Moto Tab",
                "device": "tablet"
            },
            {
                "regex": "TB-X605F(?:[);/ ]|$)",
                "model": "Tab M10",
                "device": "tablet"
            },
            {
                "regex": "TB330[FX]U(?:[);/ ]|$)",
                "model": "Tab M11",
                "device": "tablet"
            },
            {
                "regex": "TB310[FX]U(?:[);/ ]|$)",
                "model": "Tab M9",
                "device": "tablet"
            },
            {
                "regex": "TB-X705[FL](?:[);/ ]|$)",
                "model": "Tab P10",
                "device": "tablet"
            },
            {
                "regex": "TB-J606[LF](?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab P11"
            },
            {
                "regex": "TB-Q706[FZ](?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab P12 Pro"
            },
            {
                "regex": "TB370FU",
                "device": "tablet",
                "model": "Tab P12"
            },
            {
                "regex": "TB351FU",
                "device": "tablet",
                "model": "Tab Plus"
            },
            {
                "regex": "TB-J606[FN]",
                "device": "tablet",
                "model": "Tab K11"
            },
            {
                "regex": "TB-J607F(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab QT K11 Pro WiFi"
            },
            {
                "regex": "TB-J6C6F(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab QT K11 WiFi"
            },
            {
                "regex": "TB-J616[XF](?:[);/ ]|$)",
                "model": "Tab P11 Plus",
                "device": "tablet"
            },
            {
                "regex": "TB-J706[LF](?:[);/ ]|$)",
                "model": "Tab P11 Pro",
                "device": "tablet"
            },
            {
                "regex": "TB132FU(?:[);/ ]|$)",
                "model": "Tab P11 Pro (Gen 2)",
                "device": "tablet"
            },
            {
                "regex": "TB350[FX]U(?:[);/ ]|$)",
                "model": "Tab P11 (Gen 2)",
                "device": "tablet"
            },
            {
                "regex": "TB-J607Z(?:[);/ ]|$)",
                "model": "Tab K11 Pro 5G",
                "device": "tablet"
            },
            {
                "regex": "TB-7104[IF](?:[);/ ]|$)",
                "model": "Tab E7",
                "device": "tablet"
            },
            {
                "regex": "TB-8304F1(?:[);/ ]|$)",
                "model": "Tab E8",
                "device": "tablet"
            },
            {
                "regex": "TB-7304",
                "model": "Tab 7 Essential",
                "device": "tablet"
            },
            {
                "regex": "TB-7504X(?:[);/ ]|$)",
                "model": "Tab 7",
                "device": "tablet"
            },
            {
                "regex": "PB-6505",
                "model": "Tab V7",
                "device": "tablet"
            },
            {
                "regex": "A101LV",
                "model": "Tab 6",
                "device": "tablet"
            },
            {
                "regex": "TB-X606[FXV]A?(?:[);/ ]|$)",
                "model": "Tab M10 FHD Plus",
                "device": "tablet"
            },
            {
                "regex": "TB-X605[FL]C",
                "model": "Tab M10 FHD Rel",
                "device": "tablet"
            },
            {
                "regex": "TB-X605",
                "model": "Tab M10 FHD",
                "device": "tablet"
            },
            {
                "regex": "TB-X306",
                "model": "Tab M10 HD",
                "device": "tablet"
            },
            {
                "regex": "TB-?360ZU",
                "model": "Tab M10 5G",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo )?TB12[58][FX]U",
                "model": "Tab M10 Plus (Gen 3)",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo )?TB328[FX]U",
                "model": "Tab M10 (Gen 3)",
                "device": "tablet"
            },
            {
                "regex": "(?:Lenovo )?TB-X505",
                "model": "Tab M10",
                "device": "tablet"
            },
            {
                "regex": "TB-7305[IXF](?:[);/ ]|$)",
                "model": "Tab M7",
                "device": "tablet"
            },
            {
                "regex": "TB-7306[XF](?:[);/ ]|$)",
                "model": "Tab M7 (Gen 3)",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?B8000(-[FH])?",
                "model": "Yoga Tablet 10",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?B8080(-[FH])?",
                "model": "Yoga Tablet 10 HD",
                "device": "tablet"
            },
            {
                "regex": "YOGA Tablet 2 Pro-1380[FL]",
                "model": "Yoga Tablet 2 Pro 13.3\"",
                "device": "tablet"
            },
            {
                "regex": "YOGA Tablet 2-1050[FL]",
                "model": "Yoga Tablet 2 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "YOGA Tablet 2-830(?:[FL]|LC)",
                "model": "Yoga Tablet 2 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?B6000(-[FH])?",
                "model": "Yoga Tablet 8",
                "device": "tablet"
            },
            {
                "regex": "YT3-X90(L|F|X)",
                "model": "Yoga 3 Pro",
                "device": "tablet"
            },
            {
                "regex": "YT3-850[FL]",
                "model": "Yoga Tab 3 8",
                "device": "tablet"
            },
            {
                "regex": "YT3-850M",
                "model": "Yoga Tab 3 10",
                "device": "tablet"
            },
            {
                "regex": "YT-X703[FL]",
                "model": "Yoga Tab 3 Plus",
                "device": "tablet"
            },
            {
                "regex": "YT-X705[FL]",
                "model": "Yoga Smart Tab",
                "device": "tablet"
            },
            {
                "regex": "YB1-X90[FL]",
                "model": "Yoga Book",
                "device": "tablet"
            },
            {
                "regex": "TB-J716F",
                "model": "XiaoXin Pad Pro 11.5\" (2021)",
                "device": "tablet"
            },
            {
                "regex": "TB138FC",
                "model": "Xiaoxin Pad Pro 11\" (2022)",
                "device": "tablet"
            },
            {
                "regex": "TB331FC",
                "model": "Xiaoxin Pad 11\" (2024)",
                "device": "tablet"
            },
            {
                "regex": "EveryPad2",
                "model": "Yamada Every Pad 2",
                "device": "tablet"
            },
            {
                "regex": "TB37[15]FC",
                "model": "Xiaoxin Pad Pro 12.7\"",
                "device": "tablet"
            },
            {
                "regex": "S6000(?:[);/ ]|$)",
                "model": "IdeaTab S6000",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ([ASB][0-9]{4})[A-Z]?\\-[EHF]",
                "model": "IdeaTab $1",
                "device": "tablet"
            },
            {
                "regex": "ThinkPadTablet_(A[0-9]{3})_",
                "model": "ThinkPad Tablet $1",
                "device": "tablet"
            },
            {
                "regex": "ThinkPad ?Tablet([^;/]*) Build",
                "model": "ThinkPad Tablet$1",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ?A3300-(?:GV|H)",
                "model": "TAB 2 A7-30",
                "device": "tablet"
            },
            {
                "regex": "TAB 2 A7-30[HGD]C",
                "model": "TAB 2 A7",
                "device": "tablet"
            },
            {
                "regex": "TB-8504F",
                "model": "TAB 4 8",
                "device": "tablet"
            },
            {
                "regex": "TB-8704[FV]",
                "model": "Tab 4 8\" Plus",
                "device": "tablet"
            },
            {
                "regex": "TB-X304X",
                "model": "Tab 4 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "TB-X304F",
                "model": "TAB4 10",
                "device": "tablet"
            },
            {
                "regex": "TB-X505[FX]",
                "model": "M10",
                "device": "tablet"
            },
            {
                "regex": "TB-X104[FXL]",
                "model": "E10",
                "device": "tablet"
            },
            {
                "regex": "Tab2A([0-9]-[0-9]{2}[a-z]?)",
                "model": "TAB 2 A$1",
                "device": "tablet"
            },
            {
                "regex": "IdeaTab[ \\-_]?([a-z0-9]+)",
                "model": "IdeaTab $1",
                "device": "tablet"
            },
            {
                "regex": "YB-Q501F",
                "model": "Yoga A12",
                "device": "tablet"
            },
            {
                "regex": "YT-X705X",
                "model": "Yoga Smart Tab",
                "device": "tablet"
            },
            {
                "regex": "Yoga Tablet([^;/]+) Build",
                "model": "Yoga Tablet$1",
                "device": "tablet"
            },
            {
                "regex": "TB-8505[FX]S",
                "model": "Smart Tab M8",
                "device": "tablet"
            },
            {
                "regex": "TB-8505[FX]",
                "model": "Tab M8",
                "device": "tablet"
            },
            {
                "regex": "TB-8506[FX]",
                "model": "Tab M8 (Gen 3)",
                "device": "tablet"
            },
            {
                "regex": "TB300[FX]U",
                "model": "Tab M8 (Gen 4)",
                "device": "tablet"
            },
            {
                "regex": "TB301[FX]U",
                "model": "Tab M8 (Gen 4) (2024)",
                "device": "tablet"
            },
            {
                "regex": "TB-8705[FX]",
                "model": "Tab M8 FHD",
                "device": "tablet"
            },
            {
                "regex": "(?:TB-9707F|TB320FC|TB321FU)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Legion Y700"
            },
            {
                "regex": "Lenovo (TB[0-9]?\\-[a-z0-9-]+) Build",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "L71061",
                "model": "Legion Y90"
            },
            {
                "regex": "L71091",
                "model": "Legion Y70"
            },
            {
                "regex": "Lenovo S([69]0)-?[aU]",
                "model": "S$1"
            },
            {
                "regex": "Lenovo K30-W(?:[);/ ]|$)",
                "model": "K3"
            },
            {
                "regex": "L18011(?:[);/ ]|$)",
                "model": "A5"
            },
            {
                "regex": "L18081(?:[);/ ]|$)",
                "model": "A5s"
            },
            {
                "regex": "L19111(?:[);/ ]|$)",
                "model": "A7"
            },
            {
                "regex": "L10041(?:[);/ ]|$)",
                "model": "A8"
            },
            {
                "regex": "L78121(?:[);/ ]|$)",
                "model": "Z6"
            },
            {
                "regex": "Z2 Plus",
                "model": "Z2 Plus"
            },
            {
                "regex": "Z2151",
                "model": "ZUK Edge"
            },
            {
                "regex": "Z213[12]",
                "model": "ZUK Z2"
            },
            {
                "regex": "Z2121",
                "model": "ZUK Z2 Pro"
            },
            {
                "regex": "ZUK[ -_]([^/;]*)(?: Build|\\))",
                "model": "ZUK $1"
            },
            {
                "regex": "K10a40(?:[);/ ]|$)",
                "model": "C2"
            },
            {
                "regex": "(?:k50a40|K50-t5)(?:[);/ ]|$)",
                "model": "K3 Note"
            },
            {
                "regex": "K(1[30]) Note(?:[);/ ]|$)",
                "model": "K$1 Note"
            },
            {
                "regex": "A7010(?:a48)?(?:[);/ ]|$)",
                "model": "K4 Note"
            },
            {
                "regex": "K350t(?:[);/ ]|$)",
                "model": "K5"
            },
            {
                "regex": "L38011(?:[);/ ]|$)",
                "model": "K5 Play"
            },
            {
                "regex": "(?:L38041|K5 Pro)(?:[);/ ]|$)",
                "model": "K5 Pro"
            },
            {
                "regex": "L39051(?:[);/ ]|$)",
                "model": "K10 Plus"
            },
            {
                "regex": "(?:A7020a4[08]|L38012|K52e78)(?:[);/ ]|$)",
                "model": "K5 Note"
            },
            {
                "regex": "L19041(?:[);/ ]|$)",
                "model": "A6 Note"
            },
            {
                "regex": "K31-t3(?:[);/ ]|$)",
                "model": "K31"
            },
            {
                "regex": "A6010Pro(?:[);/ ]|$)",
                "model": "A6010 Pro"
            },
            {
                "regex": "(?:A6020a46|Vibe K5 Plus|lineage_A6020)(?:[);/ ]|$)",
                "model": "Vibe K5 Plus"
            },
            {
                "regex": "(?:Lenovo-)?(?:A6020(?:a40|l3[67])|Vibe K5)(?:[);/ ]|$)",
                "model": "Vibe K5"
            },
            {
                "regex": "VIBE Z2(?:[);/ ]|$)",
                "model": "Vibe Z2"
            },
            {
                "regex": "(?:VIBE C|A2020a40)(?:[);/ ]|$)",
                "model": "Vibe C"
            },
            {
                "regex": "(?:VIBE X2|X2-(?:X+CU|TO|AP))(?:[);/ ]|$)",
                "model": "Vibe X2"
            },
            {
                "regex": "(?:X3(?:a40|c[57]0)|K51c78)(?:[);/ ]|$)",
                "model": "Vibe X3"
            },
            {
                "regex": "Lenovo X3 Lite(?:[);/ ]|$)",
                "model": "Vibe X3 Lite"
            },
            {
                "regex": "VIBE V7(?:[);/ ]|$)",
                "model": "Vibe V7"
            },
            {
                "regex": "VIBE S6i Plus(?:[);/ ]|$)",
                "model": "Vibe S6i Plus"
            },
            {
                "regex": "VIBE[ _]S([23567])i(?:[);/ ]|$)",
                "model": "Vibe S$1i"
            },
            {
                "regex": "L79031(?:[);/ ]|$)",
                "model": "Legion Pro"
            },
            {
                "regex": "L70081(?:[);/ ]|$)",
                "model": "Legion 2 Pro"
            },
            {
                "regex": "k33a48(?:[);/ ]|$)",
                "model": "K6"
            },
            {
                "regex": "L38043(?:[);/ ]|$)",
                "model": "K9"
            },
            {
                "regex": "L3808[23](?:[);/ ]|$)",
                "model": "K11"
            },
            {
                "regex": "P2A42(?:[);/ ]|$)",
                "model": "P2"
            },
            {
                "regex": "L38031(?:[);/ ]|$)",
                "model": "K5S"
            },
            {
                "regex": "k53a48(?:[);/ ]|$)",
                "model": "K6 Note"
            },
            {
                "regex": "K33a42(?:[);/ ]|$)",
                "model": "K6 Power"
            },
            {
                "regex": "P1ma40(?:[);/ ]|$)",
                "model": "Vibe P1m"
            },
            {
                "regex": "Vibe P1 Turbo(?:[);/ ]|$)",
                "model": "Vibe P1 Turbo"
            },
            {
                "regex": "(?:P1(?:a42|c72)|Vibe P1)(?:[);/ ]|$)",
                "model": "Vibe P1"
            },
            {
                "regex": "A2016a40(?:[);/ ]|$)",
                "model": "Vibe B"
            },
            {
                "regex": "A1010a20(?:[);/ ]|$)",
                "model": "A Plus"
            },
            {
                "regex": "(?:Z90a40|Z90-7)(?:[);/ ]|$)",
                "model": "Vibe Shot"
            },
            {
                "regex": "S1a40(?:[);/ ]|$)",
                "model": "Vibe S1"
            },
            {
                "regex": "S1La40(?:[);/ ]|$)",
                "model": "Vibe S1 Lite"
            },
            {
                "regex": "L78071(?:[);/ ]|$)",
                "model": "Z5s"
            },
            {
                "regex": "L78011(?:[);/ ]|$)",
                "model": "Z5"
            },
            {
                "regex": "L78031(?:[);/ ]|$)",
                "model": "Z5 Pro"
            },
            {
                "regex": "(?:Z6 Pro 5G|L79041)(?:[);/ ]|$)",
                "model": "Z6 Pro 5G"
            },
            {
                "regex": "(?:Z6 Pro|L78051)(?:[);/ ]|$)",
                "model": "Z6 Pro"
            },
            {
                "regex": "L78032(?:[);/ ]|$)",
                "model": "Z5 Pro GT"
            },
            {
                "regex": "L38111(?:[);/ ]|$)",
                "model": "Z6 Youth"
            },
            {
                "regex": "L58041(?:[);/ ]|$)",
                "model": "S5 Pro"
            },
            {
                "regex": "L58091(?:[);/ ]|$)",
                "model": "S5 Pro GT"
            },
            {
                "regex": "L18021(?:[);/ ]|$)",
                "model": "A3"
            },
            {
                "regex": "PB2-6(?:70M|50[YM])(?:[);/ ]|$)",
                "model": "Phab 2"
            },
            {
                "regex": "PB1-750M(?:[);/ ]|$)",
                "model": "Phab"
            },
            {
                "regex": "PB1-770M(?:[);/ ]|$)",
                "model": "Phab Plus"
            },
            {
                "regex": "(S90-A|P70-A|A397i)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "IdeaPad ?([^;/]*) Build",
                "model": "IdeaPad $1",
                "device": "tablet"
            },
            {
                "regex": "d-42A(?:[);/ ]|$)",
                "model": "dtab Compact 42A",
                "device": "tablet"
            },
            {
                "regex": "XT2081-4",
                "model": "K12"
            },
            {
                "regex": "A2010l36",
                "model": "A2010"
            },
            {
                "regex": "Lenovo K12 Pro|XT2091-[78]",
                "model": "K12 Pro"
            },
            {
                "regex": "Lenovo X2(?:-[ER]U)?",
                "model": "X2"
            },
            {
                "regex": "XT2129-3",
                "model": "K13 Pro"
            },
            {
                "regex": "VR-1541F",
                "device": "wearable",
                "model": "Mirage Solo"
            },
            {
                "regex": "NL5H00X",
                "device": "peripheral",
                "model": "Xiaoxin 100"
            },
            {
                "regex": "Projector701",
                "device": "peripheral",
                "model": "Projector 701"
            },
            {
                "regex": "LENOVO/81W8(?:[);/ ]|$)",
                "device": "desktop",
                "model": "IdeaPad S145-15IIL"
            },
            {
                "regex": "LENOVO/81MV(?:[);/ ]|$)",
                "device": "desktop",
                "model": "IdeaPad S145-15IWL"
            },
            {
                "regex": "LENOVO/81SS(?:[);/ ]|$)",
                "device": "desktop",
                "model": "Flex 14API 81SS"
            },
            {
                "regex": "F0CU0028RK(?:[);/ ]|$)",
                "device": "desktop",
                "model": "IdeaCentre 520S-23IKU"
            },
            {
                "regex": "20JJS0CU1M(?:[);/ ]|$)",
                "device": "desktop",
                "model": "ThinkPad Yoga 370"
            },
            {
                "regex": "Lenovo TAB ?([^/);]*)(?: Build|[;)])",
                "model": "TAB $1",
                "device": "tablet"
            },
            {
                "regex": "Lenovo ([^/);]*)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "(?:LNV-|Lenovo-)?Lenovo[ \\-_]?([a-z0-9_+\\-]+)",
                "model": "$1"
            }
        ]
    },
    "Lexand": {
        "regex": "Lexand[ _]|(?:S[BC]7 PRO HD|SB5 HD|S5A[1-4]|S4A[1-5]|S6A1|A811|(?<!Tab )A802|LPH7_Smarty)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A(811|802)",
                "device": "tablet",
                "model": "A$1"
            },
            {
                "regex": "S4A1",
                "model": "Vega"
            },
            {
                "regex": "S4A2",
                "model": "Irida"
            },
            {
                "regex": "S4A3",
                "model": "Pallada"
            },
            {
                "regex": "S4A5",
                "model": "Oxygen"
            },
            {
                "regex": "S4A4 NEON",
                "model": "S4A4 Neon"
            },
            {
                "regex": "S5A1",
                "model": "Callisto"
            },
            {
                "regex": "S5A2",
                "model": "Overon"
            },
            {
                "regex": "S5A3",
                "model": "Capella"
            },
            {
                "regex": "S5A4",
                "model": "Argon"
            },
            {
                "regex": "S6A1",
                "model": "Antares"
            },
            {
                "regex": "(S[CB]7) PRO HD",
                "device": "tablet",
                "model": "$1 PRO HD"
            },
            {
                "regex": "(SB5) HD",
                "device": "tablet",
                "model": "$1 HD"
            },
            {
                "regex": "LPH7_Smarty",
                "model": "LPH7 Smarty"
            },
            {
                "regex": "Lexand[ _]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Lexibook": {
        "regex": "(MFC[0-9]{3}[a-z]{2,})",
        "device": "tablet",
        "models": [
            {
                "regex": "MFC191FR",
                "model": "Tablet Ultra 3 XL"
            },
            {
                "regex": "MFC045FR",
                "model": "TabTab"
            },
            {
                "regex": "MFC163FR",
                "model": "Tablet Master 3"
            },
            {
                "regex": "MFC142FR",
                "model": "Tablet Kids"
            },
            {
                "regex": "MFC250FR",
                "model": "Tablet Junior"
            },
            {
                "regex": "MFC270FR",
                "model": "Tablet Junior Power Touch"
            },
            {
                "regex": "MFC280FR",
                "model": "Tablet Junior 2"
            },
            {
                "regex": "MFC156FR",
                "model": "Tablet One"
            },
            {
                "regex": "MFC155FR",
                "model": "Tablet Master"
            },
            {
                "regex": "MFC157FR",
                "model": "Tablet Master 2"
            },
            {
                "regex": "MFC17[05]FR",
                "model": "Tablet Ultra"
            },
            {
                "regex": "MFC375FR",
                "model": "Tablet Ultra 2"
            },
            {
                "regex": "MFC162FR",
                "model": "Power Tablet"
            },
            {
                "regex": "MFC180FR",
                "model": "Tablet Advanced"
            },
            {
                "regex": "MFC181FR",
                "model": "Tablet Advanced 2"
            },
            {
                "regex": "MFC500FR",
                "model": "Tablet XL"
            },
            {
                "regex": "MFC190BBFR",
                "model": "Barbie Tablet"
            },
            {
                "regex": "MFC195DCFR",
                "model": "Tablet Disney Cars HD"
            },
            {
                "regex": "MFC195FUFR",
                "model": "Furby Tablet"
            },
            {
                "regex": "MFC195DPFR",
                "model": "Tablet Disney Princesse HD"
            },
            {
                "regex": "MFC140FR",
                "model": "LapTab"
            },
            {
                "regex": "MFC141FR",
                "model": "LapTab 2"
            },
            {
                "regex": "(MFC[0-9]{3}[a-z]{2,})",
                "model": "$1"
            }
        ]
    },
    "Vargo": {
        "regex": "Vargo[; _]|(?:V210101|Android 8(?:[\\d.]*);(?: [\\w-]+;)? VX4)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(V210101|VX4)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "LG": {
        "regex": "(?<!TECNO Mobile |TECNO )LG(?!(?:N-LX[1-3]| Browser/8| NetCast\\.TV| WebOS|E[;,]))|NetCast(?!\\.TV)|WebAppManager|portalmmm/2\\.0 (?:KE|KG|KP|L3)|(?:(?!VX20|VX19)VX[0-9]+|L-0[12]D|L-07C|P713|(LM-[A-Z][0-9]{3}[A-Z]{0,3}(?:\\(FGN?\\)|\\(G\\)|\\.FN|\\.F(?:GN?)?)?)|LM-(X625N1|G820QM[0127])|G Watch|lucye)(?:[);/ ]|$)|RS98[78]|RS500|VS(?:50[01]|835|876|880|98[05-8]|99[056]|(410|415|425|500|880)PP)|VS820|VS870 4G|Nexsus 5|10A30Q|LM-?(?:K920|K200[EB]?)|LML(41[34]D|211B|713D|212V)L|VK810 4G|VK815|X5-LG|L-05[DE]|L-03K|L-01[LJK]|L-52A|L-[45]1A|901LG|A001LG|80[12]LG|402LG|LGT32|L-02K|L-01F|LM-V40|DM-01K|DM-02H|LMX130IM|LMG820UM1|VS810PP|VS425|VM670|VS930 4G|US215|LGE[;,] (?!50ST3204|43SFSW4M)(?:[0-9]{2}[ELSTUP][ABCFGHJ-NP-TWX][a-z0-9]{4,7}(?:\\-[a-z]{2})?|[0-9]{2}NANO[a-z0-9]+|OLED[0-9]{2}[a-z0-9-]+)|(?:27ART10AKPL|28MT49S-PSS|HF60LS-EU)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DM-(01K|02H)",
                "model": "Disney Mobile DM-$1"
            },
            {
                "regex": "LG-?(?:D32[0159]|AS323|LS620)",
                "model": "L70"
            },
            {
                "regex": "LG-?(D315|L31L|F370)",
                "model": "F70"
            },
            {
                "regex": "LG-D4(?:[01]5|[01]0)",
                "model": "L90"
            },
            {
                "regex": "LG-D37[35]",
                "model": "L80"
            },
            {
                "regex": "LG-D340F8",
                "model": "L70 Tri"
            },
            {
                "regex": "LG-D12[05]",
                "model": "L30"
            },
            {
                "regex": "LG-D160",
                "model": "L40"
            },
            {
                "regex": "LG-?(?:X132|X130g)",
                "model": "L45"
            },
            {
                "regex": "LG-?(?:D157f|D150)",
                "model": "L35"
            },
            {
                "regex": "LG-D10[057]",
                "model": "L20"
            },
            {
                "regex": "LG-X14[057]",
                "model": "L60"
            },
            {
                "regex": "LG-X13[57]",
                "model": "L60i"
            },
            {
                "regex": "LG-D28[05]",
                "model": "L65"
            },
            {
                "regex": "LM-X210APM",
                "model": "Phoenix 4"
            },
            {
                "regex": "LG-P505R",
                "model": "Phoenix"
            },
            {
                "regex": "LM-X210VPP",
                "model": "Zone 4"
            },
            {
                "regex": "LM-X220PM",
                "model": "Tribute Empire"
            },
            {
                "regex": "LG-SP200",
                "model": "Tribute Dynasty"
            },
            {
                "regex": "LG-?LS675",
                "model": "Tribute 5"
            },
            {
                "regex": "LG-?LS665",
                "model": "Tribute 2"
            },
            {
                "regex": "LG-F570",
                "model": "Band Play"
            },
            {
                "regex": "VS930 4G",
                "model": "Spectrum II 4G"
            },
            {
                "regex": "VS980|L-01F|LG-(?:F320[LKS]|D80[012356]|LS980)",
                "model": "G2"
            },
            {
                "regex": "LG-D6(?:1[08]|2[05])",
                "model": "G2 Mini"
            },
            {
                "regex": "LG-(?:D85[012568]|AS990|F400[LKS])|LG-?LS990|(?:LG-)?(?:VS985|LGUS990|LGL24|LGD85[05]|LGV31)(?:[);/ ]|$)",
                "model": "G3"
            },
            {
                "regex": "LG-?LS885",
                "model": "G3 Vigor"
            },
            {
                "regex": "LG-F410S",
                "model": "G3 A"
            },
            {
                "regex": "LG-D722(?!J)",
                "model": "G3S"
            },
            {
                "regex": "LG-(?:D72[23568]|F470[LKS]|D722J)",
                "model": "G3 Beat"
            },
            {
                "regex": "LG-D693n?|LG-D690n",
                "model": "G3 Stylus"
            },
            {
                "regex": "LG-F460",
                "model": "G3 Cat. 6"
            },
            {
                "regex": "LG-D724",
                "model": "G3s"
            },
            {
                "regex": "LG-?H81[012589]|LG-?[LU]S991|LGV32|LG-F500[LSK]|VS986",
                "model": "G4"
            },
            {
                "regex": "LG-H525n?",
                "model": "G4c"
            },
            {
                "regex": "LG-H22[012]",
                "model": "Joy"
            },
            {
                "regex": "LG-(?:H540|H542|H630)",
                "model": "G4 Stylus"
            },
            {
                "regex": "LG-H73[46]",
                "model": "G4s"
            },
            {
                "regex": "LG-H735",
                "model": "G4 Beat"
            },
            {
                "regex": "LG-H731",
                "model": "G4 Vigor"
            },
            {
                "regex": "LG-H8(?:20|3[01]|5[08]|6[08])|VS987|(?:LG-)?RS988|LG-F700[SKL]|LG-?(?:[LU]S992|AS992)",
                "model": "G5"
            },
            {
                "regex": "LG-H84[05]",
                "model": "G5 SE"
            },
            {
                "regex": "VS988|LG-H87(?:[01](?:DS|[SI]|AR)?|[23])|LG-?US997|LGM-G600[SKL]|LG-[AL]S993|lucye",
                "model": "G6"
            },
            {
                "regex": "LM-Q850",
                "model": "G7 Fit"
            },
            {
                "regex": "LM-Q910",
                "model": "G7 One"
            },
            {
                "regex": "LG-?(?:L23|D95[015689]|LS995|D950G|F340[LKS])(?:[);/ ]|$)",
                "model": "G Flex"
            },
            {
                "regex": "LG-?(?:H95[059]|F510[KLS]|LS996|AS995)",
                "model": "G Flex 2"
            },
            {
                "regex": "LG-D68[0-6]",
                "model": "G Pro Lite"
            },
            {
                "regex": "LM-G820([NV]|QM[0127]|UMB)?",
                "model": "G8"
            },
            {
                "regex": "LG-F430L",
                "model": "Gx2"
            },
            {
                "regex": "LG-F310LR?",
                "model": "Gx"
            },
            {
                "regex": "LM-G850",
                "model": "G8X ThinQ"
            },
            {
                "regex": "LM-G810",
                "model": "G8S ThinQ"
            },
            {
                "regex": "901LG(?:[);/ ]|$)",
                "model": "G8X ThinQ"
            },
            {
                "regex": "LG-H410(?:[);/ ]|$)",
                "model": "Wine Smart H410"
            },
            {
                "regex": "LG-?(?:D486|F480[LKS])(?:[);/ ]|$)",
                "model": "Wine Smart"
            },
            {
                "regex": "LG-?T480[KS]",
                "model": "Wine Smart 3G"
            },
            {
                "regex": "LG-F610[KS]",
                "model": "Wine Smart Jazz"
            },
            {
                "regex": "VS501|LM-X120",
                "model": "K20"
            },
            {
                "regex": "LGMS395|LG-D393",
                "model": "F60"
            },
            {
                "regex": "LG-(?:F520[LKS]|H788)",
                "model": "AKA"
            },
            {
                "regex": "LGL41C",
                "model": "Ultimate 2"
            },
            {
                "regex": "LGLS660",
                "model": "Tribute"
            },
            {
                "regex": "(?:LG-)?H50[02]",
                "model": "Magna"
            },
            {
                "regex": "LGL63BL",
                "model": "Fiesta"
            },
            {
                "regex": "LGL16(?:3BL|4VL)",
                "model": "Fiesta 2"
            },
            {
                "regex": "LG-(?:X15[05]|X165g)",
                "model": "Bello 2"
            },
            {
                "regex": "LG-D33[157]",
                "model": "L Bello"
            },
            {
                "regex": "LG-D29[05]",
                "model": "L Fino"
            },
            {
                "regex": "(?:LG-)?H343",
                "model": "Risio"
            },
            {
                "regex": "(?:LG-)?H650",
                "model": "Zero"
            },
            {
                "regex": "(?:LG-)?M154",
                "model": "Risio 2"
            },
            {
                "regex": "LGM-K120[LSK]",
                "model": "X300"
            },
            {
                "regex": "LG-K120(?:[);/ ]|$)",
                "model": "Spree"
            },
            {
                "regex": "LGM-X401S",
                "model": "X400"
            },
            {
                "regex": "LGM-X320[SKL]?(?:[);/ ]|$)",
                "model": "X500"
            },
            {
                "regex": "LGM-X100S",
                "model": "Smart Folder X100S"
            },
            {
                "regex": "LG-F620[KLS]",
                "model": "Class"
            },
            {
                "regex": "LG-?L18VC",
                "model": "Classic"
            },
            {
                "regex": "(?:LG-)?P500H",
                "model": "Optimus One"
            },
            {
                "regex": "(?:LG-?)?VS450PP",
                "model": "Optimus Exceed 2"
            },
            {
                "regex": "LG-(?:E97[567]|F180[KLS]|E987|LS970)|LGL01E",
                "model": "Optimus G"
            },
            {
                "regex": "LG-F220K",
                "model": "Optimus GK"
            },
            {
                "regex": "LG-?L39C",
                "model": "Optimus Dynamic II"
            },
            {
                "regex": "LG-(?:F240[KLS]|E98[69]|E98[015])",
                "model": "Optimus G Pro"
            },
            {
                "regex": "LG-E435f?",
                "model": "Optimus L3 II"
            },
            {
                "regex": "LG-E4(?:70f|40|65f)",
                "model": "Optimus L4 II"
            },
            {
                "regex": "LG-E4(?:67f|45)",
                "model": "Optimus L4 II Dual"
            },
            {
                "regex": "LG-?(?:D180f|D175f|D170|D165)",
                "model": "Optimus L40"
            },
            {
                "regex": "LG-E4[56]0",
                "model": "Optimus L5 II"
            },
            {
                "regex": "LG-E61[02]",
                "model": "Optimus L5"
            },
            {
                "regex": "LG-(?:E4[17]5f|E410)",
                "model": "Optimus L1 II"
            },
            {
                "regex": "LG-(?:D605)",
                "model": "Optimus L9 II"
            },
            {
                "regex": "LG-P875",
                "model": "Optimus F5"
            },
            {
                "regex": "LG-?(?:P655H|MS659)",
                "model": "Optimus F3"
            },
            {
                "regex": "LGMS500|LG-D505",
                "model": "Optimus F6"
            },
            {
                "regex": "LG-US780",
                "model": "Optimus F7"
            },
            {
                "regex": "(L-05[DE])(?:[);/ ]|$)",
                "model": "Optimus it $1"
            },
            {
                "regex": "LG-L160L|LG-F160",
                "model": "Optimus LTE 2"
            },
            {
                "regex": "LG-F260S",
                "model": "Optimus LTE 3"
            },
            {
                "regex": "LG-F120",
                "model": "Optimus LTE Tag"
            },
            {
                "regex": "LG-P705",
                "model": "Optimus L7"
            },
            {
                "regex": "(?:LG-)?(?:P713|P71[0245]|P713TR)(?:[);/ ]|$)",
                "model": "Optimus L7 II"
            },
            {
                "regex": "LG-P716(?:[);/ ]|$)",
                "model": "Optimus L7 II Dual"
            },
            {
                "regex": "LG-?MS323",
                "model": "Optimus L70"
            },
            {
                "regex": "L-01D(?:[);/ ]|$)",
                "model": "Optimus LTE L-01D"
            },
            {
                "regex": "L-02D(?:[);/ ]|$)",
                "model": "PRADA phone L-02D"
            },
            {
                "regex": "L-07C",
                "model": "Optimus Bright L-07C"
            },
            {
                "regex": "(?:LG-?)?(?:F800[SKL]?|H990|H910(?:PR)?|US996|V34|LS997)(?:[);/ ]|$)",
                "model": "V20"
            },
            {
                "regex": "LM-Q710(?:\\(FGN\\)|[\\.]?FGN)",
                "model": "Q Stylus Plus"
            },
            {
                "regex": "LG-?(?:D22[17]|D213)",
                "model": "L50 Sporty"
            },
            {
                "regex": "LG-LS840",
                "model": "Viper 4G LTE"
            },
            {
                "regex": "801LG",
                "model": "Q Stylus"
            },
            {
                "regex": "LG-M400",
                "model": "Stylus 3"
            },
            {
                "regex": "LG-?(?:K520|F720[KLS])",
                "model": "Stylus 2"
            },
            {
                "regex": "LG-(?:K53[05])",
                "model": "Stylus 2 Plus"
            },
            {
                "regex": "LM-Q[67]10\\.FG(?:[);/ ]|$)",
                "model": "Q7"
            },
            {
                "regex": "LM-(Q72[57][KLS]|Q610[\\(.]FGN)(?:[);/ ]|$)",
                "model": "Q7+"
            },
            {
                "regex": "LM-Q815[KSL](?:[);/ ]|$)",
                "model": "Q8+"
            },
            {
                "regex": "LGM-X800[KL]|LG-H970",
                "model": "Q8"
            },
            {
                "regex": "LM-Q925[LKS](?:[);/ ]|$)",
                "model": "Q9"
            },
            {
                "regex": "LM-(?:Q730N|Q620)(?:[);/ ]|$)",
                "model": "Q70"
            },
            {
                "regex": "LM-Q520N(?:[);/ ]|$)",
                "model": "Q52"
            },
            {
                "regex": "LGV33(?:[);/ ]|$)",
                "model": "Qua Phone PX"
            },
            {
                "regex": "LG-MS870",
                "model": "Sprint 4G"
            },
            {
                "regex": "L-03K(?:[);/ ]|$)",
                "model": "Style"
            },
            {
                "regex": "L-01L(?:[);/ ]|$)",
                "model": "Style 2"
            },
            {
                "regex": "LGLS775|LGL8(?:2V|1A)L",
                "model": "Stylo 2"
            },
            {
                "regex": "VS835(?:[);/ ]|$)",
                "model": "Stylo 2 V"
            },
            {
                "regex": "LG-?(?:MS550|K55[07])",
                "model": "Stylo 2 Plus"
            },
            {
                "regex": "L-41A(?:[);/ ]|$)",
                "model": "Style 3"
            },
            {
                "regex": "LG-?(?:MS63[14]|H63[145]|F560K|LS770)(?:[);/ ]|$)",
                "model": "G Stylo"
            },
            {
                "regex": "LG-?(?:LS777|L84VL|M430|L83BL)(?:[);/ ]|$)",
                "model": "Stylo 3"
            },
            {
                "regex": "LG-?([TM]P450|M470F?)(?:[);/ ]|$)",
                "model": "Stylo 3 Plus"
            },
            {
                "regex": "LM-Q710|LML713DL|LG-Q710[AP]L",
                "model": "Stylo 4"
            },
            {
                "regex": "(?:LM-Q720|LGL722DL)(?:[);/ ]|$)",
                "model": "Stylo 5"
            },
            {
                "regex": "LM-Q730(?:[);/ ]|$)",
                "model": "Stylo 6"
            },
            {
                "regex": "LM-G710(N|VM)?|LG-G710",
                "model": "G7 ThinQ"
            },
            {
                "regex": "LMG820UM1",
                "model": "G8 ThinQ"
            },
            {
                "regex": "LG-M153",
                "model": "Fortune"
            },
            {
                "regex": "LM-X210CM",
                "model": "Fortune 2"
            },
            {
                "regex": "LG-H44[35]",
                "model": "Escape 2"
            },
            {
                "regex": "LM-X410\\.FG?(?:[);/ ]|$)",
                "model": "Premier Pro"
            },
            {
                "regex": "LGL455DL(?:[);/ ]|$)",
                "model": "Premier Pro Plus"
            },
            {
                "regex": "LML41[34]DL(?:[);/ ]|$)",
                "model": "Premier Pro LTE"
            },
            {
                "regex": "LG-?L6(?:2V|1A)L(?:[);/ ]|$)",
                "model": "Premier"
            },
            {
                "regex": "LG-?L5(?:2V|1A)L(?:[);/ ]|$)",
                "model": "Treasure"
            },
            {
                "regex": "LM-X525",
                "model": "Q60"
            },
            {
                "regex": "LM-K315IM",
                "model": "W31"
            },
            {
                "regex": "LG-?L355DL",
                "model": "K31"
            },
            {
                "regex": "LGL423DL",
                "model": "Solo LTE"
            },
            {
                "regex": "LG-F820L",
                "model": "U"
            },
            {
                "regex": "LM-X210[KLS]",
                "model": "X2"
            },
            {
                "regex": "LG-(?:K580|F690[LS])",
                "model": "X Cam"
            },
            {
                "regex": "LG-?K600",
                "model": "X Mach"
            },
            {
                "regex": "LG-(?:SP320|M32[27]|US601)",
                "model": "X Charge"
            },
            {
                "regex": "LG-?(?:LS676|L56VL|L53BL|K200)",
                "model": "X Style"
            },
            {
                "regex": "LG-F740L",
                "model": "X Skin"
            },
            {
                "regex": "LG-?(?:K500|F650|S02)",
                "model": "X Screen"
            },
            {
                "regex": "LG-(?:M710|H700|US701)",
                "model": "X Venture"
            },
            {
                "regex": "LM-X510WM",
                "model": "X Power 3"
            },
            {
                "regex": "LM-X(?:41[05]K|410S)",
                "model": "X4"
            },
            {
                "regex": "LM-X(415[LS]|410L)",
                "model": "X4+"
            },
            {
                "regex": "LM-X410(?:\\.FN|\\(FG\\))",
                "model": "K11"
            },
            {
                "regex": "LM-X(?:320|410[UP]M)|LGL322DL",
                "model": "K30"
            },
            {
                "regex": "LMX130IM",
                "model": "W10"
            },
            {
                "regex": "LM-K310IM",
                "model": "W11"
            },
            {
                "regex": "LM-X600IM",
                "model": "W30 Pro"
            },
            {
                "regex": "LM-X440ZMW",
                "model": "W30"
            },
            {
                "regex": "LM-K610IM",
                "model": "W41"
            },
            {
                "regex": "LG-H522",
                "model": "Prime Plus 4G"
            },
            {
                "regex": "LGL58VL",
                "model": "Rabel 2"
            },
            {
                "regex": "LG-X190",
                "model": "Ray"
            },
            {
                "regex": "LG-?LS740",
                "model": "Volt"
            },
            {
                "regex": "LG-?LS751",
                "model": "Volt II"
            },
            {
                "regex": "LM-X410",
                "model": "LM-X410"
            },
            {
                "regex": "LGM-K121",
                "model": "X400"
            },
            {
                "regex": "LGM-X401L",
                "model": "X401"
            },
            {
                "regex": "LM-X420N",
                "model": "X4 (2019)"
            },
            {
                "regex": "(?:VS425|LG-?(?:K120GT|K121|M151|X230))(?:[);/ ]|$)",
                "model": "K4"
            },
            {
                "regex": "LG-K130(?:[);/ ]|$)",
                "model": "K4 LTE"
            },
            {
                "regex": "(?:LG-?)?(?:M160|L57BL)(?:[);/ ]|$)",
                "model": "K4 (2017)"
            },
            {
                "regex": "LM-X420",
                "model": "K40"
            },
            {
                "regex": "LM-X430(?:[);/ ]|$)",
                "model": "K40S"
            },
            {
                "regex": "LM-K410",
                "model": "K41S"
            },
            {
                "regex": "LG-X220",
                "model": "K5"
            },
            {
                "regex": "LM-X540",
                "model": "K50S"
            },
            {
                "regex": "(?:802LG|LM-X520)(?:[);/ ]|$)",
                "model": "K50"
            },
            {
                "regex": "402LG",
                "model": "Spray"
            },
            {
                "regex": "L-02K",
                "model": "JoJo"
            },
            {
                "regex": "(?:LM-X510[KLS]|X5-LG)",
                "model": "X5"
            },
            {
                "regex": "LM-X625N1",
                "model": "X6"
            },
            {
                "regex": "LM-X625N",
                "model": "X6 (2019)"
            },
            {
                "regex": "LGMS210|LG-M210",
                "model": "Aristo"
            },
            {
                "regex": "LM-X210[G]?",
                "model": "Aristo 2"
            },
            {
                "regex": "LM-X220(?:[);/ ]|$)",
                "model": "Aristo 3"
            },
            {
                "regex": "LM-X220N(?:[);/ ]|$)",
                "model": "X2 (2019)"
            },
            {
                "regex": "LM-V40(?:5|9N|5EBW)?(?:[);/ ]|$)",
                "model": "V40 ThinQ"
            },
            {
                "regex": "LM-(?:V500N?|V450)(?:[);/ ]|$)",
                "model": "V50 ThinQ"
            },
            {
                "regex": "LM-V510N",
                "model": "V50S ThinQ"
            },
            {
                "regex": "LM-Q920N",
                "model": "Q92"
            },
            {
                "regex": "LM-Q927L",
                "model": "Q9 One"
            },
            {
                "regex": "(?:LG-)?(?:RS987|H90[01]|H96[0218]|VS990|F600[LKS]|K428)",
                "model": "V10"
            },
            {
                "regex": "LG-(?:X240|M200)",
                "model": "K8 (2017)"
            },
            {
                "regex": "LM-X220QMA",
                "model": "K8s"
            },
            {
                "regex": "(?:LG-)?RS500",
                "model": "K8 4G"
            },
            {
                "regex": "(?:LG-)?VS500",
                "model": "K8 V"
            },
            {
                "regex": "LM-X212\\(G\\)|(?:LG)?US215",
                "model": "K8 (2018)"
            },
            {
                "regex": "(?:LG-)?(?:VS995|F800K|US999|LS997|H91[058]|H990(?:DS|[NT])?)",
                "model": "V20"
            },
            {
                "regex": "(?:VS996|LG-(?:H933|H93[012]|H930RE|H932PR|[LU]S998|AS998)|LGM-V300[KLS])(?:[);/ ]|$)",
                "model": "V30"
            },
            {
                "regex": "L-01J(?:[);/ ]|$)",
                "model": "V20 Pro"
            },
            {
                "regex": "(?:L-01K|LGV35|LG-H930DS)(?:[);/ ]|$)",
                "model": "V30 Plus"
            },
            {
                "regex": "L-51A(?:[);/ ]|$)",
                "model": "V60"
            },
            {
                "regex": "(?:L-52A|LM-G900(?:[NV]|TM)?)(?:[);/ ]|$)",
                "model": "Velvet 5G"
            },
            {
                "regex": "LM-V700N(?:[);/ ]|$)",
                "model": "Velvet 2 Pro"
            },
            {
                "regex": "LM-G910",
                "model": "Velvet 4G"
            },
            {
                "regex": "(?:A001LG|LM-V600V?)(?:[);/ ]|$)",
                "model": "V60 ThinQ 5G"
            },
            {
                "regex": "(?:LG-)?VS410PP",
                "model": "Optimus Zone"
            },
            {
                "regex": "LM-V350[N]?",
                "model": "V35"
            },
            {
                "regex": "(?:LG-)?VS415PP",
                "model": "Optimus Zone 2"
            },
            {
                "regex": "(?:LG-)?VS425PP",
                "model": "Optimus Zone 3"
            },
            {
                "regex": "(?:LG-?)?(?:K100|LS450)",
                "model": "K3"
            },
            {
                "regex": "LG-AS110|LGUS110",
                "model": "K3 (2017)"
            },
            {
                "regex": "(?:LG-?)?(?:K|MS)33[02]|LG-X210",
                "model": "K7"
            },
            {
                "regex": "(?:LG-?)?(?:K|MS)350",
                "model": "K8"
            },
            {
                "regex": "VS500PP",
                "model": "K8 V"
            },
            {
                "regex": "(?:LG-?)?(?:K420(?:N)?|K425|F670[KLS]?|K430(?:DS|DSF|DSY)?|K410|MS428)",
                "model": "K10"
            },
            {
                "regex": "(?:LG-)?(?:M250N?|M257PR)",
                "model": "K10 (2017)"
            },
            {
                "regex": "(?:LG-)?M255",
                "model": "K20"
            },
            {
                "regex": "(?:LG-?)?[MT]P260",
                "model": "K20 Plus"
            },
            {
                "regex": "LM-?K200[EB]",
                "model": "K22 Plus"
            },
            {
                "regex": "LM-K200(?:[);/ ]|$)",
                "model": "K22"
            },
            {
                "regex": "LM-?K920",
                "model": "K92"
            },
            {
                "regex": "LM-K300(?:[);/ ]|$)",
                "model": "K31"
            },
            {
                "regex": "LM-K330(?:[);/ ]|$)",
                "model": "K33"
            },
            {
                "regex": "LM-K420(?:[);/ ]|$)",
                "model": "K42"
            },
            {
                "regex": "(?:LM-K500|LGL555DL)(?:[);/ ]|$)",
                "model": "K51"
            },
            {
                "regex": "LM-K510(?:[);/ ]|$)",
                "model": "K51S"
            },
            {
                "regex": "LM-K520(?:[);/ ]|$)",
                "model": "K52"
            },
            {
                "regex": "LM-K525(?:[);/ ]|$)",
                "model": "K56"
            },
            {
                "regex": "LM-K526(?:[);/ ]|$)",
                "model": "K56 Plus"
            },
            {
                "regex": "LM-Q510N(?:[);/ ]|$)",
                "model": "Q51"
            },
            {
                "regex": "LM-Q310N(?:[);/ ]|$)",
                "model": "Q31"
            },
            {
                "regex": "LM-Q630N?(?:[);/ ]|$)",
                "model": "Q61"
            },
            {
                "regex": "(?:LG-)?M700(?:N|A|DSK|AN)?|LGM-X600[SLK]|LG-M703|LG-US700",
                "model": "Q6"
            },
            {
                "regex": "LM-X440",
                "model": "W30"
            },
            {
                "regex": "LGV36(?:[);/ ]|$)",
                "model": "it"
            },
            {
                "regex": "LG-M257(?:[);/ ]|$)",
                "model": "Harmony"
            },
            {
                "regex": "LM-K400(?:[);/ ]|$)",
                "model": "Harmony 4"
            },
            {
                "regex": "(?:LG-?)?(?:K220|LS755|F750K|US610)",
                "model": "X Power"
            },
            {
                "regex": "(?:LG-?)?M320",
                "model": "X Power 2"
            },
            {
                "regex": "(?:LG-)?K371",
                "model": "Phoenix 2"
            },
            {
                "regex": "(?:LG-)?M150",
                "model": "Phoenix 3"
            },
            {
                "regex": "(?:LG-)?F100[SL]",
                "model": "Optimus Vu"
            },
            {
                "regex": "(?:LG-)?F200(?:[KLS]|LS)",
                "model": "Optimus Vu II"
            },
            {
                "regex": "(?:LG-)?VM670",
                "model": "Optimus V"
            },
            {
                "regex": "(?:LG-)?P880",
                "model": "Optimus 4X HD"
            },
            {
                "regex": "(?:LG-)?(H340n?|H32[04])",
                "model": "Leon"
            },
            {
                "regex": "(?:LG-)?H34[25]|LGMS345",
                "model": "Leon 4G LTE"
            },
            {
                "regex": "(?:LG-)?H4(?:40|2[02])",
                "model": "Spirit"
            },
            {
                "regex": "(?:LG)?C660",
                "model": "Optimus Pro"
            },
            {
                "regex": "LGL158VL",
                "model": "Rebel 3"
            },
            {
                "regex": "LML21(?:1B|2V)L",
                "model": "Rebel 4"
            },
            {
                "regex": "LG-?L4(?:4V|3A)L",
                "model": "Rebel"
            },
            {
                "regex": "VS876",
                "model": "Lucid 3"
            },
            {
                "regex": "VS880(PP)?|LG-(?:D690|D631)",
                "model": "G Vista"
            },
            {
                "regex": "LG-H740",
                "model": "G Vista 2"
            },
            {
                "regex": "VS820",
                "model": "Lancet"
            },
            {
                "regex": "VS870 4G",
                "model": "Lucid 2"
            },
            {
                "regex": "VS810PP",
                "model": "Transpyre"
            },
            {
                "regex": "LG-F580L",
                "model": "Gentle"
            },
            {
                "regex": "LG-?(?:D838|F350[LKS])",
                "model": "G Pro 2"
            },
            {
                "regex": "LG-F300[LKS]",
                "model": "Vu 3"
            },
            {
                "regex": "LG-FL40L",
                "model": "070 Touch"
            },
            {
                "regex": "LG-F440L",
                "model": "Ice Cream Smart"
            },
            {
                "regex": "LG-D38[05]",
                "model": "L80 Dual"
            },
            {
                "regex": "LG-D370",
                "model": "L80 Single"
            },
            {
                "regex": "LG-?(?:L16C|L15G)",
                "model": "Y25"
            },
            {
                "regex": "LM-F100N?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "WING"
            },
            {
                "regex": "10A30Q",
                "model": "Ultra Tab",
                "device": "tablet"
            },
            {
                "regex": "LM-T60[05]",
                "model": "G Pad 5 10.1\" FHD",
                "device": "tablet"
            },
            {
                "regex": "LG-?(?:(?:UK|V)410|V411|V400Y7)",
                "model": "G Pad 7.0\" LTE",
                "device": "tablet"
            },
            {
                "regex": "LG-V533",
                "model": "G Pad IV 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-?(?:LK430|V400)",
                "model": "G Pad F 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "LGLK430",
                "model": "G Pad F 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-V49[56]",
                "model": "G Pad F 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-LK460",
                "model": "G Pad F2 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-V4[89]0",
                "model": "G Pad 8.0",
                "device": "tablet"
            },
            {
                "regex": "LGT01|LG-P490L",
                "model": "G Pad 8.0\" LTE",
                "device": "tablet"
            },
            {
                "regex": "LG-V50(?:0|7L)",
                "model": "G Pad 8.3",
                "device": "tablet"
            },
            {
                "regex": "LG-V700",
                "model": "G Pad 10.1",
                "device": "tablet"
            },
            {
                "regex": "LG-V497",
                "model": "G Pad II 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-V935|LGUK932",
                "model": "G Pad II 10.1",
                "device": "tablet"
            },
            {
                "regex": "LG-V940",
                "model": "G Pad II 10.1 FHD",
                "device": "tablet"
            },
            {
                "regex": "LGT02|LG-?V522",
                "model": "G Pad III 8.0",
                "device": "tablet"
            },
            {
                "regex": "LG-V525(?:S[13])?(?:[);/ ]|$)",
                "model": "G Pad III 8.0\" FHD",
                "device": "tablet"
            },
            {
                "regex": "LG-?[VP]755",
                "model": "G Pad III 10.1\" FHD LTE",
                "device": "tablet"
            },
            {
                "regex": "LG-P530L",
                "model": "G Pad IV 8.0\" FHD LTE",
                "device": "tablet"
            },
            {
                "regex": "VK810",
                "model": "G Pad 8.3 LTE",
                "device": "tablet"
            },
            {
                "regex": "VK815",
                "model": "G Pad X 8.3",
                "device": "tablet"
            },
            {
                "regex": "LG-V52[01]",
                "model": "G Pad X 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "LG-V930",
                "model": "G Pad X 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "LG-V530",
                "model": "G Pad X2 8.0\" Plus",
                "device": "tablet"
            },
            {
                "regex": "LG-?UK750",
                "model": "G Pad X2 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "LGT32",
                "model": "Qua Tad PZ",
                "device": "tablet"
            },
            {
                "regex": "LGT31",
                "model": "Qua Tad PX",
                "device": "tablet"
            },
            {
                "regex": "HF60LS-EU",
                "device": "peripheral",
                "model": "HF60LS-EU"
            },
            {
                "regex": "27ART10AKPL",
                "device": "peripheral",
                "model": "StandbyME"
            },
            {
                "regex": "KEY0000010F",
                "device": "tv",
                "model": "KEY0000010F"
            },
            {
                "regex": "\\(LGE?, WEBOS[123], (?:wired|wireless)",
                "device": "tv",
                "model": "WebOS TV"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+\\( ?;LGE? ?;(\\d{2}\\w+) ?;",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "LGE;? (?:HOTEL\\-TV; )?([0-9]{2}[a-z0-9]{4,9}(?:\\-[a-z]{2,3})?)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "\\(LGE?,? ([a-z0-9_ -]+)(?:\\.[a-z]+)?,? (?:wired|wireless)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "Media/([a-z]{2,3}[0-9]{3,4})",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "47LA790W-ZA",
                "model": "47LA790W-ZA",
                "device": "tv"
            },
            {
                "regex": "webOS\\.TV",
                "device": "tv",
                "model": "WebOS TV"
            },
            {
                "regex": "LGE_DLNA_SDK|NetCast",
                "device": "tv",
                "model": "NetCast"
            },
            {
                "regex": "LG Watch Urbane",
                "device": "wearable",
                "model": "Watch Urbane"
            },
            {
                "regex": "G Watch( R)?",
                "device": "wearable",
                "model": "G Watch$1"
            },
            {
                "regex": "(LM-[A-Z]{1}[0-9]{3}([A-Z]{1,3})?)",
                "model": "$1"
            },
            {
                "regex": "LGE(?: |-LG| LG-AX|-)([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "FBDV/LG-([a-z0-9]+);FBSV",
                "model": "$1"
            },
            {
                "regex": "LGE;([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "LG[ _-](V90.*|Optimus[ _-]Pad.*) Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "LGM-([^/;]*)( Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "LG(?:/|-LG| |-)?([^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "LG(?:/|-LG| |-)?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "LG; ([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2\\.0 ((?:KE|KG|KP|L3)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(VX[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Web0S; Linux/SmartTV",
                "device": "tv",
                "model": ""
            }
        ]
    },
    "Lifemaxx": {
        "regex": "LIFEMAXX, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Lingbo": {
        "regex": "(?:Venus Pad1[456]|L24 Ultra|L16 Max|G15 Pro Max|G24_mini|G15_mini)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Venus Pad(1[456])",
                "device": "tablet",
                "model": "Venus Pad $1"
            },
            {
                "regex": "L16 Max",
                "device": "tablet",
                "model": "L16 Max"
            },
            {
                "regex": "L24 Ultra",
                "model": "L24 Ultra"
            },
            {
                "regex": "G15 Pro Max",
                "model": "G15 Pro Max"
            },
            {
                "regex": "G(15|24)_mini",
                "model": "G$1 Mini"
            }
        ]
    },
    "Lingwin": {
        "regex": "Lingwin[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Lingwin[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Lingwin[ _-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Logic Instrument": {
        "regex": "Logic Instrument|Fieldbook K101",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fieldbook F1(?:[);/ ]|$)",
                "model": "Fieldbook F1"
            },
            {
                "regex": "Fieldbook F1B",
                "model": "Fieldbook F1B"
            },
            {
                "regex": "Fieldbook K101",
                "device": "tablet",
                "model": "Fieldbook K101"
            },
            {
                "regex": "Fieldbook KS80",
                "device": "tablet",
                "model": "Fieldbook KS80"
            }
        ]
    },
    "Logicom": {
        "regex": "LOGICOM[_ ]|La_tab_link|(TAB950|TAB1062|E731|E812|E912|E1031|POWER BOT|La[ _]?Tab[ _]?(?:7[24]|10[57]|11[345]|12[4789]|292|Stand(?:RB)?)|(?:[BCM]|ID|VR)[ _]?BOT[ _]?(?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?|KT712A_4\\.4|L-?IXIR[0-9]*|L_IXIR_TAB_1047HD|L-ITE|L-EGANTONE(?:-R)?|Le Fizz|L-?EMENT.+|Le[ _]?(?:Up|Connect|Omega|Hop|Hello|Lift|Pulse|Prime|Swipe|Wave|Hola|Moov[2]?|Must(?: 2)?|Starter L|Fit FR|Spark|Prime|Smooth(?: FR)?)|Tab_Stand_Pro|LeFit|logikids4|Le Link|TAB76|Five Pro|Solar(?: Pro)?|LUNAR|Lunar Pro|Elio|Yuno)(?:[);/ ]|$|_)",
        "device": "tablet",
        "models": [
            {
                "regex": "Tab_Stand_Pro",
                "model": "La Tab Stand Pro"
            },
            {
                "regex": "La[ _]?Tab[ _]?(7[24]|10[57]|11[345]|127 HD|12[89]|105_P|292|Stand)(?:[);/ ]|$)",
                "model": "La Tab $1"
            },
            {
                "regex": "LaTabStandRB(?:[);/ ]|$)",
                "model": "La Tab Stand"
            },
            {
                "regex": "TAB76(?:[);/ ]|$)",
                "model": "La Tab 79"
            },
            {
                "regex": "La[_ ]Tab[_ ]124[_ ]HD[_ ]Plus(?:[);/ ]|$)",
                "model": "La Tab 124 HD Plus"
            },
            {
                "regex": "(?:LOGICOM_)?LA_TAB_LINK_(7[14])",
                "model": "La Tab Link $1"
            },
            {
                "regex": "logikids4",
                "model": "Logikids 4"
            },
            {
                "regex": "KT712A_4\\.4|L-IXIR TAB 701 3G",
                "model": "L-ixir Tab 701 3G"
            },
            {
                "regex": "L_IXIR_TAB_1047HD",
                "model": "L-ixir Tab 1047 HD"
            },
            {
                "regex": "LIXIR1041",
                "model": "L-ixir Tab 1041"
            },
            {
                "regex": "L-?IXIR[ _]TAB[ _]([^);/]+)( Build|[);])",
                "model": "L-ixir Tab $1"
            },
            {
                "regex": "L-ITE[ _](400M|452|50[46] HD|506R HD|552 HD)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "L-ite $1"
            },
            {
                "regex": "L-ITE[ _]([^;/]+) Build",
                "model": "L-ite Tab $1"
            },
            {
                "regex": "L-?EMENT[ _]?(350|451|40[103]|55[013]|50[15]|500L?)(?:[);/ ]|$)",
                "model": "L-ement $1",
                "device": "smartphone"
            },
            {
                "regex": "L-?EMENT[ _](?:TAB)[ )]?([^);/]+)(?: Build|[);])",
                "model": "L-ement Tab $1"
            },
            {
                "regex": "L-?EMENT[ _]?(74[01])(?:[);/ ]|$)",
                "model": "L-ement Tab $1"
            },
            {
                "regex": "(TAB950|TAB1062|E731|E812|E912|E1031)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "POWER BOT",
                "model": "POWER BOT"
            },
            {
                "regex": "M bot (5[14])",
                "device": "smartphone",
                "model": "M BOT $1"
            },
            {
                "regex": "VR bot (552) Plus",
                "device": "smartphone",
                "model": "VR BOT $1 Plus"
            },
            {
                "regex": "VR bot (552)",
                "device": "smartphone",
                "model": "VR BOT $1"
            },
            {
                "regex": "((?:[BCM]|ID|VR))[ _]?BOT[ _]?TAB[ _]([0-9]+(?:PLUS|\\+)?)",
                "model": "$1 BOT Tab $2"
            },
            {
                "regex": "((?:[BCM]|ID|VR))[ _]?BOT[ _]?((?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?)",
                "model": "$1 BOT $2"
            },
            {
                "regex": "Elio",
                "model": "Elio",
                "device": "smartphone"
            },
            {
                "regex": "Yuno",
                "model": "Yuno",
                "device": "smartphone"
            },
            {
                "regex": "Five Pro 32",
                "model": "Five Pro 32",
                "device": "smartphone"
            },
            {
                "regex": "Five Pro",
                "model": "Five Pro",
                "device": "smartphone"
            },
            {
                "regex": "Solar Pro",
                "model": "Solar Pro",
                "device": "smartphone"
            },
            {
                "regex": "SOLAR",
                "model": "Solar",
                "device": "smartphone"
            },
            {
                "regex": "Lunar Pro",
                "model": "Lunar Pro",
                "device": "smartphone"
            },
            {
                "regex": "LUNAR",
                "model": "Lunar",
                "device": "smartphone"
            },
            {
                "regex": "Le Lift",
                "model": "Le Lift",
                "device": "smartphone"
            },
            {
                "regex": "Le Link",
                "model": "Le Link",
                "device": "smartphone"
            },
            {
                "regex": "Le Wave",
                "model": "Le Wave",
                "device": "smartphone"
            },
            {
                "regex": "Le Swipe",
                "model": "Le Swipe",
                "device": "smartphone"
            },
            {
                "regex": "Le Omega",
                "model": "Le Omega",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Connect",
                "model": "Le Connect",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Pulse",
                "model": "Le Pulse",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Prime",
                "model": "Le Prime",
                "device": "smartphone"
            },
            {
                "regex": "Le Hola FR(?:[);/ ]|$)",
                "model": "Le Hola FR",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Hola(?:[);/ ]|$)",
                "model": "Le Hola",
                "device": "smartphone"
            },
            {
                "regex": "LeMoov2(?:[);/ ]|$)",
                "model": "Le Moov 2",
                "device": "smartphone"
            },
            {
                "regex": "LeMoov(?:[);/ ]|$)",
                "model": "Le Moov",
                "device": "smartphone"
            },
            {
                "regex": "Le Fit FR(?:[);/ ]|$)",
                "model": "Le Fit FR",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]?Fit",
                "model": "Le Fit",
                "device": "smartphone"
            },
            {
                "regex": "Le Fizz",
                "model": "Le Fizz",
                "device": "smartphone"
            },
            {
                "regex": "Le Hop(?:[);/ ]|$)",
                "model": "Le Hop",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Hello(?:[);/ ]|$)",
                "model": "Le Hello",
                "device": "smartphone"
            },
            {
                "regex": "Le Smooth FR(?:[);/ ]|$)",
                "model": "Le Smooth FR",
                "device": "smartphone"
            },
            {
                "regex": "Le Smooth(?:[);/ ]|$)",
                "model": "Le Smooth",
                "device": "smartphone"
            },
            {
                "regex": "Le Must 2(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Le Must 2"
            },
            {
                "regex": "Le Must(?:[);/ ]|$)",
                "model": "Le Must",
                "device": "smartphone"
            },
            {
                "regex": "Le Starter L(?:[);/ ]|$)",
                "model": "Le Starter L",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Spark(?:[);/ ]|$)",
                "model": "Le Spark",
                "device": "smartphone"
            },
            {
                "regex": "Le[ _]Prime(?:[);/ ]|$)",
                "model": "Le Prime",
                "device": "smartphone"
            },
            {
                "regex": "L-EGANTONE-R",
                "model": "L-Egant One R",
                "device": "smartphone"
            },
            {
                "regex": "L-EGANTONE",
                "model": "L-Egant One",
                "device": "smartphone"
            },
            {
                "regex": "Le Up(?:[);/ ]|$)",
                "model": "Le Up",
                "device": "smartphone"
            }
        ]
    },
    "Konka": {
        "regex": "KONKA[_ ]([a-z0-9]+)|(?: R[EU]1|KC516(?: Pro)?|KUD50WT702AN|UDE55NR314ANTS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "KC516 Pro",
                "model": "Phoenix Pro"
            },
            {
                "regex": "KC516",
                "model": "Phoenix"
            },
            {
                "regex": "E5660S",
                "model": "Viva 5660s"
            },
            {
                "regex": "W830",
                "model": "Tango 830"
            },
            {
                "regex": "W(9[67]0)",
                "model": "Expose $1"
            },
            {
                "regex": "W990",
                "model": "Tuxedo 990"
            },
            {
                "regex": "( R[EU]1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "2K Android TV",
                "device": "tv",
                "model": "2K Smart TV"
            },
            {
                "regex": "(KUD50WT702AN|UDE55NR314ANTS)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "KONKA[_ ]([a-z0-9]+)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Konrow": {
        "regex": "KONROW[_ ]|(?:LINK55|KTAB_1003|BIGCOOL|SOFT5P?|COOLFIVE|COOL-K|Just5|Link5|EASY ?(?:5|62|K55)|EASY_5_EEA|EASY55|CITY55?|CITY4|Cool55|SKY_?55_EEA|Android 11(?:[\\d.]*);(?: [\\w-]+;)? SWEET5|SWEET 55)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BIGCOOL(?:[);/ ]|$)",
                "model": "BigCool"
            },
            {
                "regex": "LINK55(?:[);/ ]|$)",
                "model": "LINK55"
            },
            {
                "regex": "COOL-K(?:[);/ ]|$)",
                "model": "Cool-K"
            },
            {
                "regex": "Cool55(?:[);/ ]|$)",
                "model": "Cool 55"
            },
            {
                "regex": "SOFT5(?:[);/ ]|$)",
                "model": "Soft 5"
            },
            {
                "regex": "SOFT5P(?:[);/ ]|$)",
                "model": "Soft 5P"
            },
            {
                "regex": "COOLFIVE(?:[);/ ]|$)",
                "model": "Cool Five"
            },
            {
                "regex": "Just5(?:[);/ ]|$)",
                "model": "Just 5"
            },
            {
                "regex": "Link5(?:[);/ ]|$)",
                "model": "Link 5"
            },
            {
                "regex": "EASY ?(55?|62|K55)(?:[);/ ]|$)",
                "model": "Easy $1"
            },
            {
                "regex": "EASY_5_EEA(?:[);/ ]|$)",
                "model": "Easy 5"
            },
            {
                "regex": "CITY(55?|4)(?:[);/ ]|$)",
                "model": "City $1"
            },
            {
                "regex": "SKY_?55_EEA(?:[);/ ]|$)",
                "model": "Sky 55"
            },
            {
                "regex": "SWEET ?(55?)(?:[);/ ]|$)",
                "model": "Sweet $1"
            },
            {
                "regex": "KONROW[_ ](701X)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "KTAB_1003(?:[);/ ]|$)",
                "device": "tablet",
                "model": "K-Tab 1003"
            }
        ]
    },
    "K-Lite": {
        "regex": "(?:KLT_K301|NAVTECH_TOUCHY_F2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "KLT_K301",
                "model": "K301"
            },
            {
                "regex": "NAVTECH_TOUCHY_F2",
                "model": "Navtech Touchy F2"
            }
        ]
    },
    "Karbonn": {
        "regex": "(?:Browser-)?Karbonn|K9 Kavach 4G|K9[_ ](?:Viraat|Smart)[_ ]Plus|K9 Music 4G|K9 Smart|K9 VIRAAT 4G|Aura_Power|Aura (?:Sleek Plus|Sleek 4G|Power 4G Plus|Note Play|Note 2|Storm|Champ)|Titanium[ _](?:3D-Plex|Octane Plus|Vista 4G|Jumbo|S360|S1[059]|S35|S20[13]|S22|S[15]|S200 HD|Frames S7|MOGHUL|S9)|MACHFIVE|MACHONE|Sparkle V|Alfa A114 Quad|Quattro[ _]L(?:45|5[025])[ _](?:HD|IPS|VR)|A41 Power|A(?:[19]|4[05])[ _]Indian|S2052GB|MACH SIX VR|K-Lite F3|Titanium Vista",
        "device": "smartphone",
        "models": [
            {
                "regex": "K9 Kavach 4G",
                "model": "K9 Kavach 4G"
            },
            {
                "regex": "K9 Music 4G",
                "model": "K9 Music 4G"
            },
            {
                "regex": "K9 Smart Eco Plus",
                "model": "K9 Smart Eco Plus"
            },
            {
                "regex": "K9 Smart Eco",
                "model": "K9 Smart Eco"
            },
            {
                "regex": "K9 Smart 4G",
                "model": "K9 Smart 4G"
            },
            {
                "regex": "K9 Smart Selfie",
                "model": "K9 Smart Selfie"
            },
            {
                "regex": "K9 Smart Grand",
                "model": "K9 Smart Grand"
            },
            {
                "regex": "K9 Smart Yuva",
                "model": "K9 Smart Yuva"
            },
            {
                "regex": "K9[_ ]Smart[_ ]Plus",
                "model": "K9 Smart Plus"
            },
            {
                "regex": "K9 Smart(?: 1GB)?",
                "model": "K9 Smart"
            },
            {
                "regex": "A40 Indian Plus",
                "model": "A40 Indian Plus"
            },
            {
                "regex": "A([19]|4[05])[ _]Indian",
                "model": "A$1 Indian"
            },
            {
                "regex": "K9[_ ]Viraat[_ ]Plus",
                "model": "K9 Viraat Plus"
            },
            {
                "regex": "Aura Sleek Plus",
                "model": "Aura Sleek Plus"
            },
            {
                "regex": "Aura Power 4G Plus",
                "model": "Aura Power 4G Plus"
            },
            {
                "regex": "Aura Note Play",
                "model": "Aura Note Play"
            },
            {
                "regex": "Aura Note 2",
                "model": "Aura Note 2"
            },
            {
                "regex": "Aura Storm",
                "model": "Aura Storm"
            },
            {
                "regex": "Aura Champ",
                "model": "Aura Champ"
            },
            {
                "regex": "Aura Sleek 4G",
                "model": "Aura Sleek 4G"
            },
            {
                "regex": "Aura_Power",
                "model": "Aura Power"
            },
            {
                "regex": "Alfa A114 Quad",
                "model": "Alfa A114 Quad"
            },
            {
                "regex": "(?:karbonn)?K9 Viraat 4G",
                "model": "K9 Viraat 4G"
            },
            {
                "regex": "MACHFIVE",
                "model": "Mach Five"
            },
            {
                "regex": "MACHONEPLUS",
                "model": "Titanium Mach One Plus"
            },
            {
                "regex": "MACHONE",
                "model": "Titanium Mach One"
            },
            {
                "regex": "MACH SIX VR",
                "model": "Titanium Mach Six VR"
            },
            {
                "regex": "Titanium[ _]S([29])[ _]?Plus",
                "model": "Titanium S$1 Plus"
            },
            {
                "regex": "Titanium[_ ]S(99|360|1[059]|109|35|200 HD|20[13]|22|[15])(?:[);/ ]|$)",
                "model": "Titanium S$1"
            },
            {
                "regex": "Titanium Vista(?: 4G)?",
                "model": "Titanium Vista 4G"
            },
            {
                "regex": "Titanium Jumbo 2",
                "model": "Titanium Jumbo 2"
            },
            {
                "regex": "Titanium Jumbo",
                "model": "Titanium Jumbo"
            },
            {
                "regex": "Titanium[ _]MOGHUL",
                "model": "Titanium Moghul"
            },
            {
                "regex": "Titanium Frames S7",
                "model": "Titanium Frames S7"
            },
            {
                "regex": "Titanium Octane Plus",
                "model": "Titanium Octane Plus"
            },
            {
                "regex": "Titanium[ _]3D-Plex",
                "model": "Titanium 3D Plex"
            },
            {
                "regex": "S2052GB",
                "model": "Titanium S250 2GB"
            },
            {
                "regex": "K-lite F3",
                "model": "K-Lite F3"
            },
            {
                "regex": "Sparkle V",
                "model": "Sparkle V"
            },
            {
                "regex": "A41 Power",
                "model": "A41 Power"
            },
            {
                "regex": "Quattro[ _]L(5[05])[ _]HD",
                "model": "Quattro L$1 HD"
            },
            {
                "regex": "Quattro[ _]L(45)[ _]IPS",
                "model": "Quattro L$1 IPS"
            },
            {
                "regex": "Quattro[ _]L(52)[ _]VR",
                "model": "Quattro L$1 VR"
            },
            {
                "regex": "Karbonn ([a-z0-9]+) WAP-Browser",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "WAP Browser-Karbonn ([a-z0-9]+)/",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "Karbonn_([^;/)]+)",
                "model": "$1"
            },
            {
                "regex": "Karbonn ([^;/)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Karbonn ([^;/]+)/",
                "model": "$1"
            }
        ]
    },
    "Sagem": {
        "regex": "SAGEM(?!com)|portalmmm/2\\.0 (?:SG|my)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SAGEM-(my[a-z0-9-]+)",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "SAGEM ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAGEM-([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2\\.0 ((?:SG|my)[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Coby Kyros": {
        "regex": "(MID(?:1024|112[56]|1045|1048|106[05]|4331|701[26]|7015A?|70[32]2|703[56]|704[278]|7052|7065|7120|8024|80[47]2|8048|8065|8125|812[78]|9724|974[02])|CTB761)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Mpman": {
        "regex": "(?:MPQC|MPDC)[0-9]+|PH(?:150|340|350|360|451|500|520|544|604)|(?:MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP100i OCTA|MP(?:843|717|718|1010|7007|7008|843|888|959|969|QCG(1[01]|77)(?: 3G)?)|MGP7)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "((?:MPQC|MPDC)[0-9]+[^/;)]*)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "MP100i OCTA(?:[);/ ]|$)",
                "model": "MP100i OCTA"
            },
            {
                "regex": "MPQCG10(?: 3G)?(?:[);/ ]|$)",
                "model": "MPQCG10 3G"
            },
            {
                "regex": "(MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP(?:843|717|718|1010|7007|7008|843|888|959|969|QCG(?:11|77))|MGP7)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(PH(?:150|340|350|360|451|500|520|544|604))",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Manta Multimedia": {
        "regex": "MANTA[;,]|MSP950(1[245]|2[01])|MSP96017|MSP94501|MSP95009|MSP96002|MSP450[79]|((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "MSP95012",
                "model": "Titano 1"
            },
            {
                "regex": "MSP95014",
                "model": "Titano 3"
            },
            {
                "regex": "MSP95015",
                "model": "Mezo 2"
            },
            {
                "regex": "MSP95020",
                "model": "Rocky 2"
            },
            {
                "regex": "MSP95021",
                "model": "Rocky 3 Pro"
            },
            {
                "regex": "MSP96017",
                "model": "Forto 2"
            },
            {
                "regex": "MSP96002",
                "model": "Forto 1"
            },
            {
                "regex": "MSP94501",
                "model": "Easy Selfie"
            },
            {
                "regex": "(MSP450[79]|MSP95009)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MANTA,([a-z0-9_ -]+),(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Masstel": {
        "regex": "Masstel|(?:Juno[ _]Q[567]|Tab10Ultra|Tab(?:[78]|10)Plus|Hapi10)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Masstel[_ ]Juno[_ ]Q5Plus",
                "model": "Juno Q5 Plus"
            },
            {
                "regex": "(?:Masstel_)?Hapi ?(1[05]|30)(?:[);/ ]|$)",
                "model": "Hapi $1"
            },
            {
                "regex": "Masstel[_ ]N660s",
                "model": "N660S"
            },
            {
                "regex": "Masstel[_ ]\\((M18)\\)",
                "model": "$1"
            },
            {
                "regex": "Masstel_Tab7LTE(?:[);/ ]|$)",
                "model": "Tab 7 LTE",
                "device": "tablet"
            },
            {
                "regex": "Tab10 WiFi(?:[);/ ]|$)",
                "model": "Tab 10 WiFi",
                "device": "tablet"
            },
            {
                "regex": "Masstel_Tab10_?4G(?:[);/ ]|$)",
                "model": "Tab 10 4G",
                "device": "tablet"
            },
            {
                "regex": "Tab10Ultra",
                "model": "Tab 10 Ultra",
                "device": "tablet"
            },
            {
                "regex": "Tab([78]|10)Plus",
                "model": "Tab $1 Plus",
                "device": "tablet"
            },
            {
                "regex": "(?:Masstel[ _])?Tab[ _]?([^/);]+)(?: Build|[);])",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "(?:Masstel[_ ]*)?(Juno[_ ]Q[3567]|Juno_S6|[MNXB]\\d+|LT52|N600S)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mastertech": {
        "regex": "MASTERTECH,([a-z0-9_ -]+),(?:wired|wireless)|QC77QPS(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "MASTERTECH,([a-z0-9_ -]+),(?:wired|wireless)",
                "model": "$1"
            },
            {
                "regex": "(QC77QPS)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Talius": {
        "regex": "(Nitro 551)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Maxwest": {
        "regex": "(?:Astro[_ ](?:Phablet_9|55?N[_ ]LTE|55[RT]|5 PRO|5[sTX]|[45]P|X4|5_GO_LTE|X55s?|4\\.5|4|63R|X5|8R)|Astro6|Virtue Z5|Nitro[_ ](?:4S?|55[ARCMN]|5[XRPNM]|[45] GO|4[sN] LTE|55[ _]LTE|N62|G55)|Gravity_(?:55?_GO|6P)|Gravity 5\\.5 LTE|Nitro_Phablet_9s|Nitro Phablet 7N|Nitro 8|MX-(?:A10R|A6[45]))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MX-(A10R|A6[45])",
                "model": "Astro $1"
            },
            {
                "regex": "Astro[_ ](55?)N[_ ]LTE",
                "model": "Astro $1N LTE"
            },
            {
                "regex": "Astro[_ ]X55[_ ]LTE",
                "model": "Astro X55 LTE"
            },
            {
                "regex": "Astro_5_GO_LTE",
                "model": "Astro 5 Go LTE"
            },
            {
                "regex": "Astro 5 PRO",
                "model": "Astro 5 Pro"
            },
            {
                "regex": "Astro[_ ](55[RT]|X55s?|5[sTX]|4|X[45]|[45]P|8R|63R)(?:[);/ ]|$)",
                "model": "Astro $1"
            },
            {
                "regex": "Astro[_ ](4\\.5)",
                "model": "Astro $1\""
            },
            {
                "regex": "Virtue Z5",
                "model": "Virtue Z5"
            },
            {
                "regex": "Astro[_ ]X4",
                "model": "Astro X4"
            },
            {
                "regex": "Nitro ([45]) GO",
                "model": "Nitro $1 GO"
            },
            {
                "regex": "Nitro 4s LTE",
                "model": "Nitro 4s LTE"
            },
            {
                "regex": "Nitro[ _]4s",
                "model": "Nitro 4s"
            },
            {
                "regex": "Nitro[_ ]((?:55|4N)[_ ]LTE|4|55[ARCNM]|5[XRPNM]|8|N62|G55)",
                "model": "Nitro $1"
            },
            {
                "regex": "Gravity_(55?)_GO",
                "model": "Gravity $1 GO"
            },
            {
                "regex": "Gravity_6P",
                "model": "Gravity 6P"
            },
            {
                "regex": "Gravity 5\\.5 LTE",
                "model": "Gravity 5.5 LTE"
            },
            {
                "regex": "Astro6",
                "device": "phablet",
                "model": "Astro 6"
            },
            {
                "regex": "Nitro[_ ]Phablet[_ ](9s|7N)",
                "device": "tablet",
                "model": "Nitro Phablet $1"
            },
            {
                "regex": "Astro_Phablet_9",
                "device": "tablet",
                "model": "Astro Phablet 9"
            }
        ]
    },
    "True Slim": {
        "regex": "(SSB-508[ED])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Maze Speed": {
        "regex": "(?:MP5184G|MS5424G|MS5514G|MS5539G|MS5614G|SSB-(?:500|508)|SSB408D|SSB504R|M1582C_MAX)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M1582C_MAX",
                "model": "M1582C Max"
            },
            {
                "regex": "(MP5184G|MS5424G|MS5514G|MS5539G|MS5614G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SSB-?(500|508|408D|504R)(?:[);/ ]|$)",
                "model": "SSB-$1"
            }
        ]
    },
    "Maze": {
        "regex": "(?:Alpha[_ ]X|Maze Alpha)(?:[);/ ]|$)|(?:Android [78](?:[\\d.]*);(?: [\\w-]+;)? Blade|Comet)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alpha[_ ]X(?:[);/ ]|$)",
                "model": "Alpha X"
            },
            {
                "regex": "Maze Alpha(?:[);/ ]|$)",
                "model": "Alpha"
            },
            {
                "regex": "(Blade|Comet)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mediacom": {
        "regex": "(?:SmartPad7503G|M-SP10MXA|M-PPAB500|SmartPad970s2(?:3G)?|M[_-][MPS]P[0-9a-z]+|M-IPRO[0-9a-z]+|10edge|1AZ2[TP]| (?:7[BCD]Y|8[ADE]Y|1[AB]EC|1CY|1AZ|1[DI]Y4G|1AZ2TW|1EY4G|1HY4G)(?:_eea)?|Azimut[ _]?[234](?: Lite|Pro)?|M-WPW801| 1EY)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SmartPad7503G(?:[);/ ]|$)",
                "model": "SmartPad 750 3G"
            },
            {
                "regex": "SmartPad970s23G(?:[);/ ]|$)",
                "model": "SmartPad 970 S2 3G"
            },
            {
                "regex": "SmartPad970s2(?:[);/ ]|$)",
                "model": "SmartPad 970 S2"
            },
            {
                "regex": "M-MP84[02]M(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" Mobile"
            },
            {
                "regex": "M-MP940M(?:[);/ ]|$)",
                "model": "SmartPad 9.7\" Mobile"
            },
            {
                "regex": "M-SP10MXA(?:[);/ ]|$)",
                "model": "SmartPad MX 10.1\""
            },
            {
                "regex": "M-SP8MXA(?:[);/ ]|$)",
                "model": "SmartPad MX 8.0\""
            },
            {
                "regex": "M-SP7HXAH(?:[);/ ]|$)",
                "model": "SmartPad HX 7.0\""
            },
            {
                "regex": "M-SP7MXAH?(?:[);/ ]|$)",
                "model": "SmartPad MX 7.0\""
            },
            {
                "regex": "M-SP8HXAH(?:[);/ ]|$)",
                "model": "SmartPad HX 8.0\" HD"
            },
            {
                "regex": "M-MP(?:710|720|725|726|740)GOx?(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" Go"
            },
            {
                "regex": "M-MP876S2(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S2"
            },
            {
                "regex": "M-MP8S2[AB]?3G(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S2 3G"
            },
            {
                "regex": "M-MP(101|102|860|875)S2[BW]?(?:[);/ ]|$)",
                "model": "SmartPad $1 S2"
            },
            {
                "regex": "M-MP85S23G(?:[);/ ]|$)",
                "model": "SmartPad 875 S2 3G"
            },
            {
                "regex": "M-SP1AGO3G",
                "model": "SmartPad 10 Go 3G"
            },
            {
                "regex": "M-SP7xGO3G",
                "model": "SmartPad 10.1\" iPro 3G"
            },
            {
                "regex": "1AEC",
                "model": "SmartPad 10 Eclipse"
            },
            {
                "regex": "1[DEHI]Y4G",
                "model": "SmartPad iyo 10 4G"
            },
            {
                "regex": "M-MP10[45][01]S2(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S2"
            },
            {
                "regex": "M-MP1S2[AB]3G(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S2 3G"
            },
            {
                "regex": "M-MP8[24]S4(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S4"
            },
            {
                "regex": "M-MP8S4[AB]3G(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" S4 3G"
            },
            {
                "regex": "M-MP9S4A3G(?:[);/ ]|$)",
                "model": "SmartPad 9.7\" S4 3G"
            },
            {
                "regex": "M-MP1[02]S4(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S4"
            },
            {
                "regex": "M-MP7S4A3G(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" S4 HD"
            },
            {
                "regex": "M-MP1040MC?(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HD S4 3G"
            },
            {
                "regex": "M-MP1S4[AB]3G(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" S4 3G"
            },
            {
                "regex": "M-SP10HXxH(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HX HD"
            },
            {
                "regex": "M-SP10MXHA(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" MX"
            },
            {
                "regex": "M-SP10MXHL(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" MX Lite"
            },
            {
                "regex": "M-MP8PA3G(?:[);/ ]|$)",
                "model": "SmartPad 8.0\" HD Pro 3G"
            },
            {
                "regex": "M-MP10PA(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HD Pro"
            },
            {
                "regex": "M-MP10PA3G(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" HD Pro 3G"
            },
            {
                "regex": "M-IPRO([18][01]0)[BW](?:[);/ ]|$)",
                "model": "SmartPad 8.0\" HD iPro$1 3G"
            },
            {
                "regex": "(?:1AZ2[TP]|Azimut2)(?:[);/ ]|$)",
                "model": "SmartPad 10.0\" Azimut 2"
            },
            {
                "regex": "Azimut 3 Lite(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" Azimut 3 Lite"
            },
            {
                "regex": "Azimut ?3 Pro(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" Azimut 3 Pro"
            },
            {
                "regex": "Azimut 3(?:[);/ ]|$)",
                "model": "SmartPad 10.1\" Azimut 3"
            },
            {
                "regex": "Azimut[ _]4(?:[);/ ]|$)",
                "model": "SmartPad 10.5\" Azimut 4"
            },
            {
                "regex": "8DY(?:[);/ ]|$)",
                "model": "SmartPad iyo 8\""
            },
            {
                "regex": "10edge(?:[);/ ]|$)",
                "model": "SmartPad 10 Edge"
            },
            {
                "regex": "1EY(?:[);/ ]|$)",
                "model": "SmartPad 1EY"
            },
            {
                "regex": "M-WPW801(?:[);/ ]|$)",
                "model": "WinPad W801"
            },
            {
                "regex": "(7[BCD]Y|8[AE]Y|1BEC|1CY|1AZ|1AZ2TW)(?:_eea)?(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:M-MP75S23G|M-MP72[01]M)(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" Mobile",
                "device": "phablet"
            },
            {
                "regex": "M-MP7S2[ABDK]3G(?:[);/ ]|$)",
                "model": "SmartPad 7.0\" S2 3G",
                "device": "phablet"
            },
            {
                "regex": "M-MP5303G(?:[);/ ]|$)",
                "model": "SmartPad Mini Mobile",
                "device": "phablet"
            },
            {
                "regex": "M-PPxB400(?:[);/ ]|$)",
                "model": "PhonePad Duo B400",
                "device": "phablet"
            },
            {
                "regex": "M-PPAG550(?:[);/ ]|$)",
                "model": "PhonePad Duo G550",
                "device": "phablet"
            },
            {
                "regex": "M-PPAB500(?:[);/ ]|$)",
                "model": "PhonePad Duo B500",
                "device": "phablet"
            },
            {
                "regex": "M-PP2G530(?:[);/ ]|$)",
                "model": "PhonePad Duo G530",
                "device": "phablet"
            },
            {
                "regex": "M-PPG700(?:[);/ ]|$)",
                "model": "PhonePad Duo G700",
                "device": "phablet"
            },
            {
                "regex": "M-PPxS531(?:[);/ ]|$)",
                "model": "PhonePad Duo S531",
                "device": "phablet"
            },
            {
                "regex": "M-PP2S550(?:[);/ ]|$)",
                "model": "PhonePad Duo S550",
                "device": "phablet"
            },
            {
                "regex": "M-PP2S650C?(?:[);/ ]|$)",
                "model": "PhonePad Duo S650",
                "device": "phablet"
            },
            {
                "regex": "M-PPxS551U(?:[);/ ]|$)",
                "model": "PhonePad Duo S551U",
                "device": "phablet"
            },
            {
                "regex": "M-PPAG4(?:[);/ ]|$)",
                "model": "PhonePad Duo G4",
                "device": "smartphone"
            },
            {
                "regex": "M-PP[ABC]G500(?:[);/ ]|$)",
                "model": "PhonePad Duo G500",
                "device": "smartphone"
            },
            {
                "regex": "M-PP2S500[BC]?(?:[);/ ]|$)",
                "model": "PhonePad Duo S500",
                "device": "smartphone"
            },
            {
                "regex": "M-PPx(S510|G551|G51[0125]|G415)(?:[);/ ]|$)",
                "model": "PhonePad Duo $1",
                "device": "smartphone"
            },
            {
                "regex": "M[_-]PP[Ax]X(470|510|555|520)U(?:[);/ ]|$)",
                "model": "PhonePad Duo X$1U",
                "device": "smartphone"
            },
            {
                "regex": "M-PPxG(400|501|[457][PM]?)(?:[);/ ]|$)",
                "model": "PhonePad Duo G$1",
                "device": "smartphone"
            },
            {
                "regex": "M-PPxS(532[LU]|470|501|5P?|7P?)(?:[);/ ]|$)",
                "model": "PhonePad Duo S$1",
                "device": "smartphone"
            },
            {
                "regex": "M-PPxG(4[15]0)(?:[);/ ]|$)",
                "model": "PhonePad Duo G$1",
                "device": "smartphone"
            },
            {
                "regex": "M-PPA(S520|R450|G552)(?:[);/ ]|$)",
                "model": "PhonePad Duo $1",
                "device": "smartphone"
            },
            {
                "regex": "M-PPx([XS]5\\d{2}[UL])(?:[);/ ]|$)",
                "model": "PhonePad Duo $1",
                "device": "phablet"
            },
            {
                "regex": "M-MP([0-9a-z]+)",
                "model": "SmartPad $1"
            }
        ]
    },
    "Medion": {
        "regex": "Medion|(?:MD_)?LIFETAB(?!Plus)|([SPX]10[0-9]{2}X|E10[45]1X|X5001|P851X|P850X|E691X|E10[56]0X|B5532)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:MD_)?LIFETAB[_ ]([a-z0-9]+)",
                "device": "tablet",
                "model": "Lifetab $1"
            },
            {
                "regex": "(E450[46]|E5004|S5004|X5001|E5020|P5015|P500[45]|X6001)(?:[);/ ]|$)",
                "model": "Life $1"
            },
            {
                "regex": "(B553[02])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(E10[45]1X)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "([SPX]10[0-9]{2}X|P851X|P850X|E691X|E10[56]0X)(?:[);/ ]|$)",
                "model": "Lifetab $1",
                "device": "tablet"
            },
            {
                "regex": "Medion(?: Smartphone)? ([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "MEDION, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": "",
                "device": "tv"
            }
        ]
    },
    "MEEG": {
        "regex": "MEEG[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "MEEG[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "MEEG[ _-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Fourel": {
        "regex": "(?:EASYSMARTM3|EasySmart M2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EASY ?SMART ?M([32])",
                "model": "Easy Smart M$1"
            }
        ]
    },
    "Meitu": {
        "regex": "(?:(?<!MI CC 9 )Meitu[2]?|MP1503|MP1512|MP160[235]|MP170[19]|MP171[138]|MP1801)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MP1503(?:[);/ ]|$)",
                "model": "M6"
            },
            {
                "regex": "(?:MP1512|Meizu M6s)(?:[);/ ]|$)",
                "model": "M6s"
            },
            {
                "regex": "MP1602(?:[);/ ]|$)",
                "model": "T8"
            },
            {
                "regex": "MP1605(?:[);/ ]|$)",
                "model": "V6"
            },
            {
                "regex": "MP1801(?:[);/ ]|$)",
                "model": "V7"
            },
            {
                "regex": "MP17(?:01|13)(?:[);/ ]|$)",
                "model": "T8s"
            },
            {
                "regex": "MP1718(?:[);/ ]|$)",
                "model": "T9"
            },
            {
                "regex": "MP1603(?:[);/ ]|$)",
                "model": "M8"
            },
            {
                "regex": "MP17(?:09|11)(?:[);/ ]|$)",
                "model": "M8s"
            },
            {
                "regex": "Meitu2(?:[);/ ]|$)",
                "model": "2"
            },
            {
                "regex": "Meitu (Kiss|[MV]4)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Memup": {
        "regex": "SlidePad ?([^;/]*) Build|SPNG?[0-9]{2,4}[a-z]{0,2}(?:[);/ ]|$)|SP704CE?|SP-NG708-3G",
        "device": "tablet",
        "models": [
            {
                "regex": "SlidePad ?([^;/]*) Build",
                "model": "SlidePad $1"
            },
            {
                "regex": "SPNG([0-9]{2,4}[a-z]{0,2})(?:[);/ ]|$)",
                "model": "SlidePad NG$1"
            },
            {
                "regex": "SP-NG(708)-3G(?:[);/ ]|$)",
                "model": "SlidePad NG$1 3G"
            },
            {
                "regex": "SP704(CE?)",
                "model": "SlidePad 704$1"
            }
        ]
    },
    "Mecer": {
        "regex": "(MF716\\+?|M785|800P3[12]C|101P51C|X1010|M7[67]QF6|M17QF[67][_-][43]G(?:plus)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "M785(?:[);/ ]|$)",
                "model": "Xpress Smartlife M785"
            },
            {
                "regex": "X1010(?:[);/ ]|$)",
                "model": "X1010"
            },
            {
                "regex": "M17QF6-3Gplus(?:[);/ ]|$)",
                "model": "M17QF6 3G Plus"
            },
            {
                "regex": "M17QF([67])_([34])G(?:[);/ ]|$)",
                "model": "M17QF$1 $2G"
            },
            {
                "regex": "800P31C",
                "model": "Xpress Smartlife 800P31C"
            },
            {
                "regex": "800P32C",
                "model": "Xpress Smartlife 800P32C"
            },
            {
                "regex": "101P51C",
                "model": "Xpress Smartlife 101P51C"
            },
            {
                "regex": "M7([76])QF6",
                "model": "Xpress Smartlife M7$1QF6"
            },
            {
                "regex": "MF716\\+",
                "model": "Xpress Smartlife M716 Plus"
            },
            {
                "regex": "MF716",
                "model": "Xpress Smartlife M716"
            }
        ]
    },
    "Mione": {
        "regex": "Mione[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hero (\\d+)",
                "model": "Hero $1"
            },
            {
                "regex": "Mione III",
                "model": "Hero 3"
            },
            {
                "regex": "Mione P2\\+",
                "model": "P2+"
            },
            {
                "regex": "Mione_PUBG_1",
                "model": "PUBG 1"
            },
            {
                "regex": "Mione XS max",
                "model": "XS Max"
            },
            {
                "regex": "Mione U1(?:[);/ ]|$)",
                "model": "U1"
            },
            {
                "regex": "Mione_Pro(?:[);/ ]|$)",
                "model": "Pro"
            },
            {
                "regex": "Mione Pro Plus(?:[);/ ]|$)",
                "model": "Pro+"
            },
            {
                "regex": "Mione[_ ]N10pro(?:[);/ ]|$)",
                "model": "N10 Pro"
            },
            {
                "regex": "Mione[_ ]Q1(?:[);/ ]|$)",
                "model": "Q1"
            },
            {
                "regex": "Mione[_ ]Q11(?:[);/ ]|$)",
                "model": "Q11"
            }
        ]
    },
    "Mio": {
        "regex": "MIO(?:/)?([a-z0-9]+)|(?:MOBIX M6|Mio TouchPad 7 Quad Core)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOBIX M6(?:[);/ ]|$)",
                "model": "Mobix M6"
            },
            {
                "regex": "MIO(?:/)?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Mio TouchPad 7 Quad Core",
                "device": "tablet",
                "model": "TouchPad 7 Quad Core"
            }
        ]
    },
    "Miray": {
        "regex": "MIRAY[;,]|MIDM[_-]|MPM[_-]|TPM4G_WT8",
        "device": "smartphone",
        "models": [
            {
                "regex": "TPM4G_WT8",
                "device": "tablet",
                "model": "TPM4G WT8"
            },
            {
                "regex": "MIDM[_-]([a-z0-9]+)",
                "model": "MIDM $1",
                "device": "tablet"
            },
            {
                "regex": "MPM[_-]([a-z0-9]+)",
                "model": "MPM $1"
            },
            {
                "regex": "MIRAY,([a-z0-9_ -]+),(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Mitsubishi": {
        "regex": "MITSU|portalmmm/[12]\\.0 M",
        "device": "feature phone",
        "models": [
            {
                "regex": "MITSU/[a-z0-9.]+ \\(([a-z0-9]+)\\)",
                "model": "$1"
            },
            {
                "regex": "MITSU[ -]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/[12]\\.0 (M[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "MIXC": {
        "regex": "(?<!VIA |Orbit )(M35|M20|G7106|G7108)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(M[0-9]{1,2})(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(G[0-9]{4})(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mobiola": {
        "regex": "(MS5[50]X6|MS55X5|MS55L1|MS50L1|MS43A3000|MS45A4000|MS50A4000|MS50A4500|MS50A5000|MS50A6000|MS50B11000|MB-2900 QUATTRO|POLYS[_ ]MS45L1|Wave5)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MS50X6",
                "model": "Atmos II"
            },
            {
                "regex": "POLYS[_ ]MS45L1",
                "model": "Polys MS45L1"
            },
            {
                "regex": "MS55X6",
                "model": "Atmos Pro II"
            },
            {
                "regex": "MS55X5",
                "model": "Atmos Pro"
            },
            {
                "regex": "MS55L1",
                "model": "GAIA"
            },
            {
                "regex": "MS50L1",
                "model": "Inti"
            },
            {
                "regex": "MB-2900 QUATTRO",
                "model": "MB-2900 Quattro"
            },
            {
                "regex": "MS43A3000",
                "model": "MS43A3000"
            },
            {
                "regex": "MS45A4000",
                "model": "eOn 45"
            },
            {
                "regex": "MS50A4000",
                "model": "eOn 50"
            },
            {
                "regex": "MS50A4500",
                "model": "eOn 50 Elegance"
            },
            {
                "regex": "MS50A5000",
                "model": "eOn 50 Quad 8"
            },
            {
                "regex": "MS50A6000",
                "model": "eOn 50 Quad 16"
            },
            {
                "regex": "MS50B11000",
                "model": "MS50B11000"
            },
            {
                "regex": "Wave5",
                "model": "Wave 5"
            }
        ]
    },
    "Matrix": {
        "regex": "(?:7116-A5|818 3G|MATRIX GRAVITY|Matrix7116)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MATRIX GRAVITY",
                "device": "smartphone",
                "model": "Gravity"
            },
            {
                "regex": "(7116-A5|818 3G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Matrix7116(?:[);/ ]|$)",
                "model": "7116 A5"
            }
        ]
    },
    "Mobicel": {
        "regex": "Mobicel[_ ](R[16]|METRO2)|(?<!\\()ASTRO(?: Build|[;)]|$)|(?:Android 6(?:[\\d.]*);(?: [\\w-]+;)? SHIFT)|(?:Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:BEAM|ZOOM|RUBY)|FAME(?:_DS)?|CLIK|R7_[12]|(?<!INTENSE )HYPE(?:_X)?|DANDY(?:_ZAM)?|(?<!SMADL |HIREMCO )Matrix|VENUS_G|TRENDY PLUS|FENDY_DS|TANGO_LITE|BLINK|BERRY|BERRY[_ ]?(?:[12]|PLUS)|R1PLUS_1|ZOOM-H|REBEL|LEGEND (?:MAX|PRO_1|Pro LTE)|HERO_DS|Switch[ _]GO|SWITCH1|switch plus|PULSE_1|TRENDY 2|TRENDY_LITE|FEVER_PLUS(?:_[HJ])?|RIO_(?:SS|ZAM|RW|BN)|Clik plus|(PURE|Fendy) PLUS|RX PRO|Neo[ _]LTE|Titan_1|ZOOM_1|R4 LTE|NEO_1|EPIC_[12]| GLO|EPIC PRO_[12]|IX PRO|OREO|Cosmo LTE|Neo_Plus|IX-1|Android 13(?:[\\d.]*);(?: [\\w-]+;)? IX|Android 1[12](?:[\\d.]*);(?: [\\w-]+;)? FORCE|VX20|VX19)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EPIC PRO_([12])",
                "model": "Epic Pro $1"
            },
            {
                "regex": "IX PRO",
                "model": "IX Pro"
            },
            {
                "regex": "RX PRO",
                "model": "RX Pro"
            },
            {
                "regex": "IX-1",
                "model": "IX-1"
            },
            {
                "regex": "IX(?: Build|[;)])",
                "model": "IX"
            },
            {
                "regex": "Matrix",
                "model": "Matrix"
            },
            {
                "regex": "LEGEND MAX",
                "model": "Legend Max"
            },
            {
                "regex": "LEGEND PRO_1",
                "model": "Legend Pro 1"
            },
            {
                "regex": "Legend Pro LTE",
                "model": "Legend Pro LTE"
            },
            {
                "regex": "BLINK",
                "model": "Blink"
            },
            {
                "regex": "FORCE",
                "model": "Force"
            },
            {
                "regex": "EPIC_([12])",
                "model": "Epic $1"
            },
            {
                "regex": "BERRY1",
                "model": "Berry 1"
            },
            {
                "regex": "BERRY PRO",
                "model": "Berry Pro"
            },
            {
                "regex": "BERRY 2",
                "model": "Berry 2"
            },
            {
                "regex": "TRENDY 2",
                "model": "Trendy 2"
            },
            {
                "regex": "BERRY[_ ]PLUS",
                "model": "Berry Plus"
            },
            {
                "regex": "BERRY",
                "model": "Berry"
            },
            {
                "regex": "TRENDY PLUS",
                "model": "Trendy Plus"
            },
            {
                "regex": "TRENDY_LITE",
                "model": "Trendy Lite"
            },
            {
                "regex": "R4 LTE",
                "model": "R4 LTE"
            },
            {
                "regex": "HYPE_X",
                "model": "Hype X"
            },
            {
                "regex": "HYPE",
                "model": "Hype"
            },
            {
                "regex": "DANDY_ZAM",
                "model": "Dandy Zam"
            },
            {
                "regex": "DANDY",
                "model": "Dandy"
            },
            {
                "regex": "METRO2",
                "model": "Metro 2"
            },
            {
                "regex": "ASTRO",
                "model": "Astro"
            },
            {
                "regex": "VENUS_G",
                "model": "Venus Go"
            },
            {
                "regex": "TANGO_LITE",
                "model": "Tango Lite"
            },
            {
                "regex": "FENDY_DS",
                "model": "Fendy DS"
            },
            {
                "regex": "REBEL",
                "model": "Rebel"
            },
            {
                "regex": "RUBY",
                "model": "Ruby"
            },
            {
                "regex": "R7_[12]",
                "model": "R7"
            },
            {
                "regex": "OREO",
                "model": "Oreo"
            },
            {
                "regex": "GLO(?:[);/ ]|$)",
                "model": "GLO"
            },
            {
                "regex": "Titan_1",
                "model": "Titan 1"
            },
            {
                "regex": "ZOOM_1",
                "model": "Zoom 1"
            },
            {
                "regex": "HERO_DS",
                "model": "Hero DS"
            },
            {
                "regex": "FAME_DS",
                "model": "Fame DS"
            },
            {
                "regex": "FAME",
                "model": "Fame"
            },
            {
                "regex": "BEAM",
                "model": "Beam"
            },
            {
                "regex": "SHIFT",
                "model": "Shift"
            },
            {
                "regex": "Cosmo LTE",
                "model": "Cosmo LTE"
            },
            {
                "regex": "Neo[ _]LTE",
                "model": "Neo LTE"
            },
            {
                "regex": "NEO_1",
                "model": "Neo"
            },
            {
                "regex": "Neo_Plus",
                "model": "Neo Plus"
            },
            {
                "regex": "RIO_(SS|ZAM|RW|BN)",
                "model": "Rio $1"
            },
            {
                "regex": "switch plus",
                "model": "Switch Plus"
            },
            {
                "regex": "Switch[ _]GO",
                "model": "Switch Go"
            },
            {
                "regex": "Switch1",
                "model": "Switch"
            },
            {
                "regex": "R1PLUS_1",
                "model": "R1 Plus"
            },
            {
                "regex": "Clik plus",
                "model": "Clik Plus"
            },
            {
                "regex": "CLIK",
                "model": "Clik"
            },
            {
                "regex": "VX(19|20) Pro",
                "model": "VX$1 Pro"
            },
            {
                "regex": "VX(19|20)",
                "model": "VX$1"
            },
            {
                "regex": "PULSE_1",
                "model": "Pulse 1"
            },
            {
                "regex": "PURE PLUS",
                "model": "Pure Plus"
            },
            {
                "regex": "Fendy plus",
                "model": "Fendy Plus"
            },
            {
                "regex": "Mobicel_(R[16])",
                "model": "$1"
            },
            {
                "regex": "ZOOM-H",
                "device": "tablet",
                "model": "Zoom H"
            },
            {
                "regex": "ZOOM",
                "device": "tablet",
                "model": "Zoom"
            },
            {
                "regex": "FEVER_PLUS_([HJ])",
                "device": "tablet",
                "model": "Fever Plus $1"
            },
            {
                "regex": "FEVER_PLUS",
                "device": "tablet",
                "model": "Fever Plus"
            }
        ]
    },
    "iStar": {
        "regex": "(I-T60)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Mobiistar": {
        "regex": "Mobiistar|Zumbo[ _]S|(?:PRIME X MAX|X1 (?:Notch|Dual)|E1 Selfie|XQ[_ ]Dual|C1 Lite)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X1 (Notch|Dual)(?:[);/ ]|$)",
                "model": "X1 $1"
            },
            {
                "regex": "E1 Selfie(?:[);/ ]|$)",
                "model": "E1 Selfie"
            },
            {
                "regex": "XQ[_ ]Dual(?:[);/ ]|$)",
                "model": "XQ Dual"
            },
            {
                "regex": "mobiistar_LAI_Zumbo(?:[);/ ]|$)",
                "model": "Zumbo"
            },
            {
                "regex": "Zumbo[_ ]S[_ ]2017[_ ]Lite(?:[);/ ]|$)",
                "model": "Lai Zumbo S Lite (2017)"
            },
            {
                "regex": "Zumbo[_ ]S[_ ]2017(?:[);/ ]|$)",
                "model": "Lai Zumbo S (2017)"
            },
            {
                "regex": "mobiistar ZUMBO S2( Dual)",
                "model": "Zumbo S2"
            },
            {
                "regex": "Mobiistar_LAI_Zumbo_J_2017(?:[);/ ]|$)",
                "model": "Lai Zumbo J (2017)"
            },
            {
                "regex": "Mobiistar_LAI_Zumbo_J(?:[);/ ]|$)",
                "model": "Lai Zumbo J"
            },
            {
                "regex": "Mobiistar[_ ]Zumbo[_ ]J2",
                "model": "Lai Zumbo J2"
            },
            {
                "regex": "Mobiistar[_ ]Zumbo[_ ]S2",
                "model": "Zumbo S2"
            },
            {
                "regex": "mobiistar ZUMBO Power",
                "model": "Zumbo Power"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]YUNA[ _]([1XCS])",
                "model": "Lai Yuna $1"
            },
            {
                "regex": "mobiistar LAI Yuki",
                "model": "Lai Yuki"
            },
            {
                "regex": "mobiistar[ _](?:LAI[ _])?ZORO[ _]([235])",
                "model": "Lai Zoro $1"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]Zena",
                "model": "Lai Zena"
            },
            {
                "regex": "mobiistar[ _]LAI[ _]Z([12])?",
                "model": "Lai Z$1"
            },
            {
                "regex": "mobiistar_ZORO_4G",
                "model": "Zoro 4G"
            },
            {
                "regex": "mobiistar touch LAI 512",
                "model": "Touch Lai 512"
            },
            {
                "regex": "mobiistar LAI 504([KC])",
                "model": "Lai 504$1"
            },
            {
                "regex": "mobiistar LAI Y",
                "model": "Lai Y"
            },
            {
                "regex": "mobiistar PRIME X 2017",
                "model": "Prime X"
            },
            {
                "regex": "C1 Lite",
                "model": "C1 Lite"
            },
            {
                "regex": "mobiistar[ _]PRIME[ _](X1|558|X[ _]Plus|X[ _]Grand) Build",
                "model": "Prime $1"
            },
            {
                "regex": "PRIME X MAX 2018",
                "model": "Prime X Max"
            },
            {
                "regex": "mobiistar[ _]KOOL([ _]Lite)?",
                "model": "Kool$1"
            },
            {
                "regex": "mobiistar KAT 452 Build",
                "model": "Kat 452"
            },
            {
                "regex": "mobiistar_LAI_YOLLO Build",
                "model": "Lai Yollo"
            },
            {
                "regex": "Mobiistar[ _]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Mobile Kingdom": {
        "regex": "GENESIS_126(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "G\xe9nesis 126"
    },
    "MSI": {
        "regex": "Primo ?(?:9[13]|81|76)|(?:Enjoy 7 Plus|GP70 2OD)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Primo ?(9[13]|76|81)",
                "model": "Primo $1"
            },
            {
                "regex": "Enjoy 7 Plus",
                "model": "Enjoy 7 Plus"
            },
            {
                "regex": "(GP70 2OD)",
                "device": "desktop",
                "model": "$1"
            }
        ]
    },
    "MLLED": {
        "regex": "MLLED[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "MLLED[ _]([^;/]+)Build",
                "model": "$1"
            },
            {
                "regex": "MLLED[ _]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mobistel": {
        "regex": "(Cynus[ _][^/;)]+)( Build|\\))",
        "device": "smartphone",
        "model": "$1"
    },
    "MobiIoT": {
        "regex": "(?:MobiGo2|MobiPrint 4\\+)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "MobiGo2(?:[);/ ]|$)",
                "model": "MobiGo 2"
            },
            {
                "regex": "MobiPrint 4\\+(?:[);/ ]|$)",
                "model": "MobiPrint 4 Plus"
            }
        ]
    },
    "Mecool": {
        "regex": "Mecool[ _-]|(?:ME-COOL S|KM9 ?PRO|BB2 PRO|K[I]{1,3} PRO|KI PLUS|KM9_TV_BOX|M8SPROW|M8S (?:PLUS|PRO) (?:DVB|[LW]|PLUS)|M8S (?:MAX|PRO)| KM[135679]| KD1)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "KM9 ?PRO(?:[);/ ]|$)",
                "model": "KM9 Pro"
            },
            {
                "regex": "KM9_TV_BOX(?:[);/ ]|$)",
                "model": "KM9 TV Box"
            },
            {
                "regex": "BB2 PRO(?:[);/ ]|$)",
                "model": "BB2 Pro"
            },
            {
                "regex": "(K[I]{1,3}) PRO(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "KI PLUS(?:[);/ ]|$)",
                "model": "KI Plus"
            },
            {
                "regex": "M8SPROW(?:[);/ ]|$)",
                "model": "M8S Pro W"
            },
            {
                "regex": "M8S PLUS DVB(?:[);/ ]|$)",
                "model": "M8S Plus DVB"
            },
            {
                "regex": "M8S PLUS ([LW])(?:[);/ ]|$)",
                "model": "M8S Plus $1"
            },
            {
                "regex": "M8S PRO ([LW])(?:[);/ ]|$)",
                "model": "M8S Pro $1"
            },
            {
                "regex": "M8S PRO PLUS(?:[);/ ]|$)",
                "model": "M8S Pro Plus"
            },
            {
                "regex": "M8S PRO(?:[);/ ]|$)",
                "model": "M8S Pro"
            },
            {
                "regex": "M8S MAX(?:[);/ ]|$)",
                "model": "M8S Max"
            },
            {
                "regex": "ME-COOL S(?:[);/ ]|$)",
                "model": "S"
            },
            {
                "regex": "K([MD]\\d+)(?:[);/ ]|$)",
                "model": "K$1"
            },
            {
                "regex": "Mecool[ _-]([^/);]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Modecom": {
        "regex": "Modecom|Free(?:Way )?Tab|xino z[\\d]+ x[\\d]+|(?:ECHO LOLLY)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "xino Z([\\d]+) X([\\d]+)",
                "model": "Xino Z$1 X$2",
                "device": "smartphone"
            },
            {
                "regex": "ECHO LOLLY",
                "model": "Echo Lolly"
            },
            {
                "regex": "FreeTab[ _-]?([^/;]+)? Build",
                "model": "FreeTab $1"
            },
            {
                "regex": "FreeTab[ _-]?((?!Build)[^);/ ]+)?",
                "model": "FreeTab $1"
            },
            {
                "regex": "FreeWay Tab[ _-]?([^/;]+) Build",
                "model": "FreeWay Tab $1"
            },
            {
                "regex": "FreeWay Tab[ _-]?((?!Build)[^);/ ]+)",
                "model": "FreeWay Tab $1"
            }
        ]
    },
    "Mode Mobile": {
        "regex": "MEP2Q421G(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MEP2Q421G",
                "model": "EarnPhone"
            }
        ]
    },
    "Mofut": {
        "regex": "Mofut",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mofut[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Mofut[ _-]?((?!Build)[^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "BrightSign": {
        "regex": "BrightSign",
        "device": "tv",
        "models": [
            {
                "regex": "(HD1023|XD233|XD230|XD1030|XD1132|XT114[34]|4K1142|LS424|LS445)",
                "model": "$1"
            }
        ]
    },
    "Verssed": {
        "regex": "MotionE11(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Motion E1.1"
    },
    "Torque": {
        "regex": "(?:EGO[ _](?:Max[ _]S|Surf[_ ][iS]|Phab 3G|Note 4G)|DROIDZ (?:Drive\\+|ATOM [SX]|Portal(?: X)?|Swivel|Smart|Trend|Force|Span|Play|Blast|Sport|Excel|Motion|Sky 3g|Rotate|Duo(?: Slim)?|Dash(?: X)?|Quad|Match TV|Beat TV|Avatar TV|Easy|Push i|Edge\\+))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DROIDZ (Duo(?: Slim)?|Dash(?: X)?|Push i|Edge\\+|Drive\\+|Portal(?: X)?)",
                "device": "tablet",
                "model": "DROIDZ $1"
            },
            {
                "regex": "DROIDZ Sky 3g",
                "model": "DROIDZ Sky 3G"
            },
            {
                "regex": "DROIDZ ATOM S",
                "model": "DROIDZ Atom S"
            },
            {
                "regex": "DROIDZ (Swivel|Trend|Force|Span|Smart|Atom X|Blast|Sport|Quad|Beat TV|Avatar TV|Match TV|Easy|Excel|Play|Rotate|Motion)",
                "model": "DROIDZ $1"
            },
            {
                "regex": "EGO[ _](Max[ _]S|Surf[_ ][iS])",
                "model": "EGO $1"
            },
            {
                "regex": "EGO Phab 3G",
                "device": "phablet",
                "model": "EGO Phab 3G"
            },
            {
                "regex": "EGO Note 4G",
                "model": "EGO Note 4G"
            }
        ]
    },
    "Motorola": {
        "regex": "MOT(?!TO)|(?<!AN)DROID(?!logic Hiremco) ?(?:Build|[a-z0-9]+)|portalmmm/2\\.0 (?:E378i|L6|L7|v3)|XOOM [^;/]*Build|XT19(?:24-7|4[23]-1|29-15|41-2|25-10|24-9|65-6|70-[25])|XT17(?:99-2|10-(?:08|10))|XT1021|XT21(?:71-[23]|13-2|15-1|75-2|41-1|25-4|27-2|29-[123]|43-1|53-1|58-6|39-1|31(?:-[134]|DL)|63-4|69-1|37-[12])|XT20(?:13-[124]|15-2|45-3|55-2|61-3|71-4|73-2|83-9|81-1|87-1|93DL|93-[37])|XT22(?:01-[126]|15-[124]|21-[12]|25-[12]|3[35]-2|31-1|51-1|55-1|43-2|4[15]-1|61-1|71-5)|XT-2201|XT180[3-5]|XT23(?:15-1|33-1|35-[23]|03-2|01-5|07-1|21-[23]|23-3|43-[1236]|63-2)|XT24(?:01-2|09-5|[23]7-4|51-4|53-2)|XT25(?:27-3|07-5|05-4)|(?<!FUNDROID |Xtreme )(?:XT|MZ|MB|ME)[0-9]{3,4}[a-z]?(?:\\(Defy\\)|-0[1-5])?(?:[;]? Build|\\))|lineage_osprey|ATRIX HD|PAMR00(?:0[28]|10)IN|PANB0001IN|PANB001[35]IN|PANV000[59]IN|PAGS0005IN",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOT-V360",
                "model": "V360",
                "device": "feature phone"
            },
            {
                "regex": "moto tab g70",
                "device": "tablet",
                "model": "Moto Tab G70"
            },
            {
                "regex": "XT2261-1",
                "model": "Moto Tab G62",
                "device": "tablet"
            },
            {
                "regex": "PAGS0005IN",
                "model": "Moto One Macro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT300",
                "model": "Spice"
            },
            {
                "regex": "ThinkPhone 25",
                "model": "ThinkPhone 25"
            },
            {
                "regex": "ThinkPhone",
                "model": "ThinkPhone"
            },
            {
                "regex": "MOTOROLA E6S",
                "model": "Moto E6S"
            },
            {
                "regex": "XT2451-4|razr 50 ultra",
                "model": "Moto Razr 50 Ultra"
            },
            {
                "regex": "XT2321-[23]",
                "model": "Moto Razr 40 Ultra"
            },
            {
                "regex": "XT2323-3",
                "model": "Moto Razr 40"
            },
            {
                "regex": "motorola razr 50(?: Build|[;)])|XT2453-2",
                "model": "Moto Razr 50"
            },
            {
                "regex": "motorola razr plus 2023",
                "model": "Moto Razr+ (2023)"
            },
            {
                "regex": "motorola razr 2023",
                "model": "Moto Razr (2023)"
            },
            {
                "regex": "XT2251-1",
                "model": "Moto Razr (2022)"
            },
            {
                "regex": "razr ultra 2025",
                "model": "Moto Razr Ultra (2025)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT30[35]",
                "model": "Motosmart ME"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT31[16]",
                "model": "Fire"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2125-4",
                "model": "Edge S"
            },
            {
                "regex": "(?:MOT-|Motorola[- ])?edge \\(?(202\\d)\\)?",
                "model": "Edge ($1)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2307-1",
                "model": "Edge 40 Neo"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2175-2",
                "model": "Edge S30"
            },
            {
                "regex": "motorola edge 30 ultra",
                "model": "Edge 30 Ultra"
            },
            {
                "regex": "XT2245-1|motorola edge 30 neo",
                "model": "Edge 30 Neo"
            },
            {
                "regex": "XT2201-1",
                "model": "Edge 30 Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2143-1",
                "model": "Edge 20"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2153-1",
                "model": "Edge S Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT32[01]",
                "model": "Defy Mini"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT3(?:89|90)",
                "model": "Motosmart"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT502",
                "model": "Quench"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT531",
                "model": "Fire XT"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT535",
                "model": "Defy"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2083-9",
                "model": "Defy (2021)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT55[567]C?",
                "model": "Defy XT"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT603",
                "model": "Admiral"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT610",
                "model": "Droid Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT615",
                "model": "Motoluxe"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT621",
                "model": "Primus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT626",
                "model": "IronRock"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT682",
                "model": "Atrix"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT685",
                "model": "Motoluxe Dual-SIM"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT687",
                "model": "Atrix TV"
            },
            {
                "regex": "(?:MOT-|Motorola-)?Atrix HD",
                "model": "Atrix HD"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT720",
                "model": "Milestone"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT800W",
                "model": "Glam"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT860",
                "model": "Milestone 3"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT881",
                "model": "Electrify 2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT882",
                "model": "Moto XT882"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT88[56]",
                "model": "Droid RAZR V"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT890",
                "model": "Droid RAZR i"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT894",
                "model": "Droid 4"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT897",
                "model": "Photon Q"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT901",
                "model": "Electrify M"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT90[567]",
                "model": "Droid RAZR M"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT910S?",
                "model": "Droid RAZR"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT91[4568]",
                "model": "Droid RAZR D1"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT9(?:19|20)",
                "model": "Droid RAZR D3"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT925",
                "model": "Droid RAZR HD"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT912",
                "model": "Droid RAZR Maxx"
            },
            {
                "regex": "XT2527-3",
                "model": "Moto G100 Pro"
            },
            {
                "regex": "moto g52j 5G",
                "model": "Moto G52j 5G"
            },
            {
                "regex": "XT2221-[12]",
                "model": "Moto G52"
            },
            {
                "regex": "moto g53y 5G",
                "model": "Moto G53y 5G"
            },
            {
                "regex": "XT2335-[23]",
                "model": "Moto G53"
            },
            {
                "regex": "XT2343-[1236]",
                "model": "Moto G54 5G"
            },
            {
                "regex": "XT2225-[12]",
                "model": "Moto G82 5G"
            },
            {
                "regex": "XT2427-4",
                "model": "Moto G85 5G"
            },
            {
                "regex": "PAMR00(0[28]|10)IN",
                "model": "Moto G10 Power"
            },
            {
                "regex": "XT2127-2",
                "model": "Moto G10"
            },
            {
                "regex": "moto g04s",
                "model": "Moto G04s"
            },
            {
                "regex": "Moto G8 Power",
                "model": "Moto G8 Power"
            },
            {
                "regex": "XT2055-[124]",
                "model": "Moto G8 Power Lite"
            },
            {
                "regex": "XT2015-2",
                "model": "Moto G8 Play"
            },
            {
                "regex": "XT2087-1",
                "model": "Moto G9 Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?(?:XT102[12]|XT830C|XT15[12]4|XT152[67])",
                "model": "Moto E"
            },
            {
                "regex": "Moto E \\(XT2052DL\\)",
                "model": "Moto E (2020)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1706",
                "model": "Moto E3 Power"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2158-6",
                "model": "Moto E30"
            },
            {
                "regex": "MotoE2\\(4G-LTE\\)",
                "model": "Moto E2 (4G-LTE)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1924-[79]",
                "model": "Moto E5 Plus"
            },
            {
                "regex": "moto e\\(?([0-9])\\)? plus",
                "model": "Moto E$1 Plus"
            },
            {
                "regex": "Moto E([0-9]) Play",
                "model": "Moto E$1 Play"
            },
            {
                "regex": "moto-e([0-9])-play",
                "model": "Moto E$1 Play"
            },
            {
                "regex": "moto e6 \\(XT2005DL\\)",
                "model": "Moto E6 (XT2005DL)"
            },
            {
                "regex": "moto e5 cruise(?:[);/ ]|$)",
                "model": "Moto E5 Cruise"
            },
            {
                "regex": "moto e5 supra(?:[);/ ]|$)",
                "model": "Moto E5 Supra"
            },
            {
                "regex": "Moto E5 go(?:[);/ ]|$)",
                "model": "Moto E5 Go"
            },
            {
                "regex": "Moto E\\(?(\\di?)\\)? Power(?:[);/ ]|$)",
                "model": "Moto E$1 Power"
            },
            {
                "regex": "Moto E\\(?((?:[567]|22)i?)\\)?(?:[);/ ]|$)",
                "model": "Moto E$1"
            },
            {
                "regex": "Moto E\\(?([567])s\\)?(?:[);/ ]|$)",
                "model": "Moto E$1s"
            },
            {
                "regex": "Moto E(\\d+)\\(?s\\)?",
                "model": "Moto E$1s"
            },
            {
                "regex": "Moto E(?: Build|[;)])",
                "model": "Moto E"
            },
            {
                "regex": "XT2081-1",
                "model": "Moto E7 Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1030",
                "model": "Droid Mini"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1565",
                "model": "Droid Maxx 2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1096",
                "model": "Moto X2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT175[046]",
                "model": "Moto C"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT172[135]",
                "model": "Moto C Plus"
            },
            {
                "regex": "Moto G4 Plus",
                "model": "Moto G4 Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1254",
                "model": "Droid Turbo"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT10(?:28|3[12349]|68|69)|lineage_osprey",
                "model": "Moto G"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT106[34]",
                "model": "Moto G2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?g\\(?(\\d+)\\)? 5G",
                "model": "Moto G$1 5G"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1609",
                "model": "Moto G4 Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT180[1-6]|Moto G ?5S Plus|Moto G \\(5S\\) Plus",
                "model": "Moto G5s Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1799-2|Moto G \\(5S\\)",
                "model": "Moto G5s"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT168[57]",
                "model": "Moto G5 Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT167[06]",
                "model": "Moto G5"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1925-10",
                "model": "Moto G6"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1965-6",
                "model": "Moto G7 Plus"
            },
            {
                "regex": "XT2129-[12]",
                "model": "Moto G30"
            },
            {
                "regex": "XT2235-2",
                "model": "Moto G32"
            },
            {
                "regex": "XT2363-2",
                "model": "Moto G34 5G"
            },
            {
                "regex": "XT2137-[12]",
                "model": "Moto G50"
            },
            {
                "regex": "XT2171-3",
                "model": "Moto G51"
            },
            {
                "regex": "XT2171-2",
                "model": "Moto G51 5G"
            },
            {
                "regex": "XT2169-1",
                "model": "Moto G71 5G"
            },
            {
                "regex": "XT2255-1",
                "model": "Moto G72"
            },
            {
                "regex": "XT2437-4",
                "model": "Moto G75 5G"
            },
            {
                "regex": "(?:MOT-|Motorola-)?(?:XT10(?:49|5[23568]|6[04]|9[23457])|XT1093)",
                "model": "Moto X"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT156[234]|Moto X Play(?:[);/ ]|$)",
                "model": "Moto X Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT157[02]",
                "model": "Moto X Style"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1575",
                "model": "Moto X Pure Edition"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT158[01]",
                "model": "Moto X Force"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2401-2",
                "model": "Moto X50 Ultra"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1080",
                "model": "Droid Ultra"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1585",
                "model": "Droid Turbo 2"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1650(?:-05)?",
                "model": "Moto Z"
            },
            {
                "regex": "moto z4(?:[);/ ]|$)",
                "model": "Moto Z4"
            },
            {
                "regex": "Moto Z3 Play(?:[);/ ]|$)",
                "model": "Moto Z3 Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1635(?:-0[1-3])?",
                "model": "Moto Z Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1710-(?:-0[28])?",
                "model": "Moto Z2 Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1789-05|Moto Z2 Force(?:[);/ ]|$)",
                "model": "Moto Z2 Force"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1929-15|moto z3(?:[);/ ]|$)",
                "model": "Moto Z3"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT166[23]",
                "model": "Moto M"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2241-1",
                "model": "Moto X30 Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2243-2",
                "model": "Moto S30 Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2409-5",
                "model": "Moto S50"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2201-[26]",
                "model": "Edge X30"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT-2201",
                "model": "Moto Edge X30 5G"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2507-5",
                "model": "Moto Edge 60 Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2505-4",
                "model": "Moto Edge 60"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT2301-5",
                "model": "Moto X40"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1943-1",
                "model": "P30"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1941-2",
                "model": "P30 Play"
            },
            {
                "regex": "(?:MOT-|Motorola-)?XT1942-1|P30 Note(?:[);/ ]|$)",
                "model": "P30 Note"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge plus 5G UW \\(2022\\)",
                "model": "Edge Plus 5G UW (2022)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge plus \\(?(202[23])\\)?",
                "model": "Edge Plus ($1)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge plus|XT2061-3",
                "model": "Edge Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge ([23]0) fusion",
                "model": "Edge $1 Fusion"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge 20 lite|XT2139-1",
                "model": "Edge 20 Lite"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge (\\d+) fusion",
                "model": "Edge $1 Fusion"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge (\\d+) ultra",
                "model": "Edge $1 Ultra"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge (\\d+) pro",
                "model": "Edge $1 Pro"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge (\\d+) neo",
                "model": "Edge $1 Neo"
            },
            {
                "regex": "(?:MOT-|Motorola-)?(?:edge 5G UW \\(2021\\)|XT2141-1)",
                "model": "Edge 5G UW (2021)"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge (\\d+)",
                "model": "Edge $1"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge \\(2021\\)",
                "model": "Edge (2021)"
            },
            {
                "regex": "XT2303-2",
                "model": "Edge 40"
            },
            {
                "regex": "(?:MOT-|Motorola-)?edge",
                "model": "Edge"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one vision plus",
                "model": "One Vision Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?(?:XT1970-[25]|one vision)",
                "model": "One Vision"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one power",
                "model": "One Power"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one hyper",
                "model": "One Hyper"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one zoom",
                "model": "One Zoom"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one fusion\\+",
                "model": "One Fusion Plus"
            },
            {
                "regex": "(?:MOT-|Motorola-)?one fusion|XT2073-2",
                "model": "One Fusion"
            },
            {
                "regex": "motorola one action|XT2013-[124]",
                "model": "One Action"
            },
            {
                "regex": "motorola one macro",
                "model": "One Macro"
            },
            {
                "regex": "motorola one 5G UW ace",
                "model": "One 5G UW Ace"
            },
            {
                "regex": "motorola one 5G UW",
                "model": "One 5G UW"
            },
            {
                "regex": "motorola one 5G ace|XT2113-2",
                "model": "One 5G Ace"
            },
            {
                "regex": "motorola one vision",
                "model": "One Vision"
            },
            {
                "regex": "moto g stylus \\(XT2115DL\\)",
                "model": "Moto G Stylus (XT2115DL)"
            },
            {
                "regex": "moto g stylus \\((202[12])\\)",
                "model": "Moto G Stylus ($1)"
            },
            {
                "regex": "moto g stylus 5G \\((2022)\\)",
                "model": "Moto G Stylus 5G ($1)"
            },
            {
                "regex": "XT2215-[124]",
                "model": "Moto G Stylus 5G (2022)"
            },
            {
                "regex": "XT2315-1",
                "model": "Moto G Stylus 5G (2023)"
            },
            {
                "regex": "XT2115-1",
                "model": "Moto G Stylus (2021)"
            },
            {
                "regex": "moto g stylus 5G|XT2131(?:-[134]|DL)",
                "model": "Moto G Stylus 5G"
            },
            {
                "regex": "moto g stylus",
                "model": "Moto G Stylus"
            },
            {
                "regex": "moto g play \\(2021\\)|XT2093DL|XT2093-[37]",
                "model": "Moto G Play (2021)"
            },
            {
                "regex": "XT2271-5|moto g play - 2023",
                "model": "Moto G Play (2023)"
            },
            {
                "regex": "moto g power \\(XT2041DL\\)",
                "model": "Moto G Power"
            },
            {
                "regex": "moto g power \\(2021\\)",
                "model": "Moto G Power (2021)"
            },
            {
                "regex": "moto g power \\(2022\\)",
                "model": "Moto G Power (2022)"
            },
            {
                "regex": "moto g power",
                "model": "Moto G Power"
            },
            {
                "regex": "moto g pro",
                "model": "Moto G Pro"
            },
            {
                "regex": "moto g pure|XT2163-4",
                "model": "Moto G Pure"
            },
            {
                "regex": "moto g fast|XT2045-3",
                "model": "Moto G Fast"
            },
            {
                "regex": "moto g 5G plus",
                "model": "Moto G 5G Plus"
            },
            {
                "regex": "moto g 5G \\(2022\\)",
                "model": "Moto G 5G (2022)"
            },
            {
                "regex": "moto g 5G",
                "model": "Moto G 5G"
            },
            {
                "regex": "moto g\\(?40\\)? fusion|PANV000[159]IN",
                "model": "Moto G40 Fusion"
            },
            {
                "regex": "XT2233-2",
                "model": "Moto G42"
            },
            {
                "regex": "PANB001[35]IN|PANB0001IN",
                "model": "Moto G60"
            },
            {
                "regex": "moto g\\(?60\\)?s",
                "model": "Moto G60s"
            },
            {
                "regex": "moto g(\\d+)\\((\\w)\\)",
                "model": "Moto G$1$2"
            },
            {
                "regex": "moto g24 power",
                "model": "Moto G24 Power"
            },
            {
                "regex": "XT2231-1",
                "model": "Moto G22"
            },
            {
                "regex": "XT2333-1",
                "model": "Moto G23"
            },
            {
                "regex": "moto g\\(([0-9]+)\\) \\(XT1925DL\\)",
                "model": "Moto G$1 (XT1925DL)"
            },
            {
                "regex": "moto g\\(([0-9]+)\\) forge",
                "model": "Moto G$1 Forge"
            },
            {
                "regex": "moto g\\(([0-9]+)\\) optimo \\(XT1952DL\\)",
                "model": "Moto G$1 Optimo (XT1952DL)"
            },
            {
                "regex": "moto g\\(([0-9]+)\\) optimo maxx\\(XT1955DL\\)",
                "model": "Moto G$1 Optimo Maxx (XT1955DL)"
            },
            {
                "regex": "moto g\\(([0-9])\\) power lite",
                "model": "Moto G$1 Power Lite"
            },
            {
                "regex": "moto g\\(?([0-9]|1[05])\\)? power",
                "model": "Moto G$1 Power"
            },
            {
                "regex": "moto g\\(([0-9])\\) supra",
                "model": "Moto G$1 Supra"
            },
            {
                "regex": "moto g\\(([0-9])\\) plus",
                "model": "Moto G$1 Plus"
            },
            {
                "regex": "moto g\\(([0-9]+)\\) play",
                "model": "Moto G$1 Play"
            },
            {
                "regex": "moto g\\(([0-9]+)\\)",
                "model": "Moto G$1"
            },
            {
                "regex": "moto g(\\d+)(?:[);/ ]|$)",
                "model": "Moto G$1"
            },
            {
                "regex": "moto g go",
                "model": "Moto G Go"
            },
            {
                "regex": "moto e\\(?([0-9]+)\\)?(?: Build|[;)])",
                "model": "Moto E$1"
            },
            {
                "regex": "moto x\\(?(4+)\\)?(?: Build|[;)])",
                "model": "Moto X$1"
            },
            {
                "regex": "moto(?:rola)? one 5G",
                "model": "One 5G"
            },
            {
                "regex": "Moto MAXX|XT1225",
                "model": "Moto Maxx"
            },
            {
                "regex": "Moto ([CGEXZ]) ?\\(([a-z0-9]+)\\)( Plus| Play)?",
                "model": "Moto $1$2$3"
            },
            {
                "regex": "Moto ?([CGEXZ])([0-9]+)( Plus| Play)?",
                "model": "Moto $1$2$3"
            },
            {
                "regex": "(?:Motorola-)?Moto[ _]?([CGEXZ])([ _](?:Plus|Play))?",
                "model": "Moto $1$2"
            },
            {
                "regex": "MotoroiX",
                "model": "MotoroiX"
            },
            {
                "regex": "Moto 360",
                "device": "wearable",
                "model": "Moto 360"
            },
            {
                "regex": "Moto(?:rola)?[- _]F100",
                "device": "wearable",
                "model": "Moto ACTV"
            },
            {
                "regex": "XT2071-4",
                "model": "RAZR 5G"
            },
            {
                "regex": "razr \\(?(202[02])\\)?",
                "model": "RAZR ($1)"
            },
            {
                "regex": "MOTORAZR[ _-]([a-z0-9]+)",
                "model": "RAZR $1"
            },
            {
                "regex": "MOTORIZR[ _-]([a-z0-9]+)",
                "model": "RIZR $1"
            },
            {
                "regex": "motorola razr (40) ultra",
                "model": "RAZR $1 Ultra"
            },
            {
                "regex": "motorola razr (40)",
                "model": "RAZR $1"
            },
            {
                "regex": "Motorola[ _-]([^/);]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Moto[ _-]([^/);]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "MOT(?!OROLA)[O]?[_-]?([a-z0-9.]+)",
                "model": "$1"
            },
            {
                "regex": "(?<!AN)DROID ?([a-z0-9 ]*) Build",
                "model": "DROID $1"
            },
            {
                "regex": "(?<!AN)DROID ?([a-z0-9]+)",
                "model": "DROID $1"
            },
            {
                "regex": "portalmmm/2\\.0 ((?:E378i|L6|L7|V3)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(XOOM [^;/]*)Build",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(MZ[0-9]{3})(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "((?:ME|MB|XT)[0-9]{3,4}(?:\\(Defy\\))?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Motorola Solutions": {
        "regex": "(LEX L11[ae])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Movic": {
        "regex": "MOVIC|F4502",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOVIC[ -]K(2)",
                "model": "K$1"
            },
            {
                "regex": "MOVIC[ -]W([2345])",
                "model": "W$1"
            },
            {
                "regex": "(F450[12])",
                "model": "$1"
            }
        ]
    },
    "Movitel": {
        "regex": "M(?:8421|9101[AB]|910[36]|841[4568]|8601)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M(\\d{4}[AB]?)(?:[);/ ]|$)",
                "model": "M$1"
            }
        ]
    },
    "MTN": {
        "regex": "MTN-(?!NX|AN)|(?:Kafit V900|Faith29|Ka ?Chocolate|M56[01]M3|M571M3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Faith29(?:[);/ ]|$)",
                "model": "Faith 29"
            },
            {
                "regex": "Ka ?Chocolate(?:[);/ ]|$)",
                "model": "Ka Chocolate"
            },
            {
                "regex": "Kafit V900",
                "model": "KaFit V900"
            },
            {
                "regex": "MTN-(L860|S620)",
                "model": "Sm@rt Mini $1"
            },
            {
                "regex": "M560M3",
                "model": "Smart S"
            },
            {
                "regex": "M561M3",
                "model": "Smart T"
            },
            {
                "regex": "M571M3",
                "model": "Smart Kamunye"
            },
            {
                "regex": "MTN-8978P",
                "device": "tablet",
                "model": "Steppa"
            },
            {
                "regex": "MTN-([a-z0-9_-]+)",
                "model": "MTN-$1"
            }
        ]
    },
    "Hammer": {
        "regex": "(?:Hammer[_ ](?:Construction_?(?:2_Thermal_5G|2_5G)?|Explorer[_ ](?:Plus|Pro)|FORCE|Blade_[34]|Blade2_PRO|Blade_5G|IRON_[234](?:[_ ]LTE)?|IRON|Explorer|ENERGY(?:_18x9|_2_2022|_[2X])?|Titan 2|Active2?(?:_LTE)?)|Iron[_ ](?:2|Va)|Blade V 5G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hammer[_ ]Construction_2_Thermal_5G",
                "model": "Construction 2 Thermal 5G"
            },
            {
                "regex": "Hammer[_ ]Construction_2_5G",
                "model": "Construction 2 5G"
            },
            {
                "regex": "Hammer[_ ]Construction",
                "model": "Construction"
            },
            {
                "regex": "Hammer[_ ]Explorer[_ ]Plus",
                "model": "Explorer Plus"
            },
            {
                "regex": "Hammer[_ ]Explorer[_ ]Pro",
                "model": "Explorer Pro"
            },
            {
                "regex": "HAMMER[ _]ENERGY_2_2022",
                "model": "Energy 2 (2022)"
            },
            {
                "regex": "HAMMER[ _]ENERGY[ _](18x9|3G|\\d+|X)",
                "model": "Energy $1"
            },
            {
                "regex": "HAMMER[ _]ENERGY",
                "model": "Energy"
            },
            {
                "regex": "Hammer Titan 2",
                "model": "Titan 2"
            },
            {
                "regex": "Hammer[_ ]FORCE",
                "model": "Force"
            },
            {
                "regex": "(?:Hammer[ _])?Iron[ _]([234]|Va?)",
                "model": "Iron $1"
            },
            {
                "regex": "Hammer[ _]Iron",
                "model": "Iron"
            },
            {
                "regex": "Hammer[ _]Explorer",
                "model": "Explorer"
            },
            {
                "regex": "Hammer Active(?:[);/ ]|$)",
                "model": "Active"
            },
            {
                "regex": "Hammer_Active2(?:[);/ ]|$)",
                "model": "Active 2"
            },
            {
                "regex": "Hammer_Active2_LTE(?:[);/ ]|$)",
                "model": "Active 2 LTE"
            },
            {
                "regex": "Blade V 5G",
                "model": "Blade V 5G"
            },
            {
                "regex": "Hammer_Blade_5G",
                "model": "Blade 5G"
            },
            {
                "regex": "Hammer_Blade2_PRO",
                "model": "Blade 2 Pro"
            },
            {
                "regex": "Hammer_Blade_([34])",
                "model": "Blade $1"
            }
        ]
    },
    "Rombica": {
        "regex": "Rombica[_ ]|(TV-Impact(?:-pro)?|SSQ-A0500|Smart Box v[0-9]+|Smart Box (?:[ABCDXYZ]1|[GDFQ]2|[AF]3|H4)|myPhone Jet|5[05]MT-UDG54G|65MT-UDG54G|55XT-UD2G64N)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "myPhone Jet",
                "device": "smartphone",
                "model": "myPhone Jet"
            },
            {
                "regex": "SSQ-A0500(?:[);/ ]|$)",
                "model": "Smart Stick 4K"
            },
            {
                "regex": "TV-Impact-pro",
                "model": "TV Impact Pro"
            },
            {
                "regex": "TV-Impact",
                "model": "TV Impact"
            },
            {
                "regex": "(?:Rombica[_ ])?Cinema4K_v01",
                "model": "Cinema 4K v01"
            },
            {
                "regex": "(\\d{2}MT-UDG54G|Infinity K8|Smart Box (?:Q1|v00[3-9]|Quad|Ultra HD v002|4K V001|[ABCDXYZ]1|[AGDFQL]2|[AFG]3|H4)|TV (?:Ultima|Fly)|Smart Stick Pro|TV Mercury|TV Emotion|TV Air|55XT-UD2G64N)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "MyPhone (PH)": {
        "regex": "MyPad[ _][^;/)]+( Build|[);])|MyPhone ?(?:A888|A919 Duo|Agua (?:Infinity|Rio ?(?:Fun|Lite)?)|MY27|Rio (?:2 ?(?:Fun|Lite)?|Pixie)|UNO)|my(?:A(?:10|[789])|T[356]) DTV|myWX1 Plus|myXI1(?:[ _](?:Plus|Pro))?|my(?:G1|XI3|NX1|X12|X[23589]|A1[0-35-8]|29S|807)|Brown [12]|A898 DUO",
        "device": "smartphone",
        "models": [
            {
                "regex": "myT([356]) DTV",
                "model": "myT$1 DTV",
                "device": "tablet"
            },
            {
                "regex": "myA([789]|10) DTV",
                "model": "myA$1 DTV"
            },
            {
                "regex": "A898 DUO",
                "model": "A898 Duo"
            },
            {
                "regex": "MyPhoneMY27",
                "model": "my27"
            },
            {
                "regex": "MY807",
                "model": "myX1"
            },
            {
                "regex": "myXI1 Plus(?:[);/ ]|$)",
                "model": "myXI1 Plus"
            },
            {
                "regex": "myXI1 Pro(?:[);/ ]|$)",
                "model": "myXI1 Pro"
            },
            {
                "regex": "myXI([13])(?:[);/ ]|$)",
                "model": "myXI$1"
            },
            {
                "regex": "my(A1[0-35-8]i?|G1|NX1|X[23589]|X12|29S)(?:[);/ ]|$)",
                "model": "my$1"
            },
            {
                "regex": "myWX1 Plus(?:[);/ ]|$)",
                "model": "myWX1 Plus"
            },
            {
                "regex": "Brown 1(?:[);/ ]|$)",
                "model": "Brown 1"
            },
            {
                "regex": "brown 2(?:[);/ ]|$)",
                "model": "Brown 2"
            },
            {
                "regex": "MyPhone[ _]([^;/)]+)( Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "MyPad[ _]([^;/(]+)(?: Build|[;)])",
                "model": "MyPad $1",
                "device": "tablet"
            }
        ]
    },
    "myPhone (PL)": {
        "regex": "(?:myPhone|myTab)_?[^;/)]+( Build|[);])|(?:FUN|Pocket|Prime)_18x9|Prime3Lite|Prime_4_Lite|Q-Smart_Plus|Q-Smart_III_Plus|Q_Smart_BE|(?:HAMMER_)?AXE[_ ]M[_ ]LTE|Hammer[_ ](?:Axe)|Cube_LTE|C-Smart_pix|SmartView_9\\.6_3G|SmartView_(?:[78]|9_6)_(?:LTE|[34]G)|Android 6(?:[\\d.]*);(?: [\\w-]+;)? Pocket|Pocket_2|LUNA_II",
        "device": "smartphone",
        "models": [
            {
                "regex": "C-Smart_pix",
                "model": "C-Smart Pix"
            },
            {
                "regex": "Cube_LTE|Cube 16GB",
                "model": "Cube LTE"
            },
            {
                "regex": "(?:myPhone_)?Fun[_ ]?(\\d)[_ ]?Lite",
                "model": "FUN $1 Lite"
            },
            {
                "regex": "(?:myPhone_)?Fun[_ ]?(\\d)[_ ]?LTE",
                "model": "FUN $1 LTE"
            },
            {
                "regex": "(?:myPhone_)?Fun_?([48]|18x9)",
                "model": "FUN $1"
            },
            {
                "regex": "Hammer AXE Pro",
                "model": "Hammer Axe Pro"
            },
            {
                "regex": "myPhone AXE 3G",
                "model": "Hammer Axe 3G"
            },
            {
                "regex": "(?:HAMMER_)?AXE[_ ]M[_ ]LTE",
                "model": "Hammer Axe M LTE"
            },
            {
                "regex": "INFINITY (LTE|3G)",
                "model": "Infinity $1"
            },
            {
                "regex": "LUNA_II",
                "model": "Luna II"
            },
            {
                "regex": "Pocket_2(?:[);/ ]|$)",
                "model": "Pocket 2"
            },
            {
                "regex": "Pocket(?:[);/ ]|$)",
                "model": "Pocket"
            },
            {
                "regex": "myPhone[_ ]Pocket[_ ]Pro",
                "model": "Pocket Pro"
            },
            {
                "regex": "Pocket_18x9",
                "model": "Pocket 18x9"
            },
            {
                "regex": "Prime3Lite(?:[);/ ]|$)",
                "model": "Prime 3 Lite"
            },
            {
                "regex": "Prime_4_Lite",
                "model": "Prime 4 Lite"
            },
            {
                "regex": "Prime_18x9(_LTE)?(?:[);/ ]|$)",
                "model": "Prime 18x9$1"
            },
            {
                "regex": "Q_Smart_BE(?:[);/ ]|$)",
                "model": "Q-Smart BE"
            },
            {
                "regex": "Q-Smart_Plus(?:[);/ ]|$)",
                "model": "Q-Smart Plus"
            },
            {
                "regex": "Q-Smart_III_Plus",
                "model": "Q-Smart III Plus"
            },
            {
                "regex": "myTab10II",
                "model": "myTab 10 II",
                "device": "tablet"
            },
            {
                "regex": "myTab_10III",
                "model": "myTab 10 III",
                "device": "tablet"
            },
            {
                "regex": "SmartView_7_3G",
                "model": "SmartView 7\" 3G",
                "device": "tablet"
            },
            {
                "regex": "SmartView_8_LTE",
                "model": "SmartView 8\" LTE",
                "device": "tablet"
            },
            {
                "regex": "SmartView_9[_.]6_3G",
                "model": "SmartView 9.6\" 3G",
                "device": "tablet"
            },
            {
                "regex": "myPhone[ _]([^;/)]+)( Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "myTab[ _]?([^;/]+)(?: Build|[;)])",
                "model": "myTab $1",
                "device": "tablet"
            }
        ]
    },
    "MyWigo": {
        "regex": "MyWigo ",
        "device": "smartphone",
        "models": [
            {
                "regex": "City3",
                "model": "City 3"
            },
            {
                "regex": "Excite GIII",
                "model": "Excite G3"
            },
            {
                "regex": "MyWigo[ _]([^;/)]+)( Build|\\))",
                "model": "$1"
            }
        ]
    },
    "Myros": {
        "regex": "(E70 Ultra)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Myria": {
        "regex": " (Myria[_ ][^/;]+|502M|Cozy|Easy tab 9|Grand|Compact_E2_Plus)(?: Build|[;)])|Myria_FIVE|Myria_Grand_4G|Myria_Wide_2|Myria_Wide_4G",
        "device": "smartphone",
        "models": [
            {
                "regex": "Myria_FIVE",
                "model": "Five"
            },
            {
                "regex": "(502M|Grand|Compact_E2_Plus)",
                "model": "$1"
            },
            {
                "regex": "Myria_Grand_4G",
                "model": "Grand 4G"
            },
            {
                "regex": "Myria_Wide_4G",
                "model": "Wide 4G"
            },
            {
                "regex": "Myria_Wide_2",
                "model": "Wide 2"
            },
            {
                "regex": "(Cozy|Easy tab 9)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Myria[_ ]([^/);]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "M.T.T.": {
        "regex": "M\\.T\\.T\\.|MTT IDEAL",
        "device": "smartphone",
        "models": [
            {
                "regex": "MTT IDEAL",
                "model": "Ideal"
            },
            {
                "regex": "M\\.T\\.T\\. ?Tablet([^;/)]+)?(?: Build|[;)])",
                "device": "tablet",
                "model": "Tablet$1"
            },
            {
                "regex": "M\\.T\\.T\\. ?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Navon": {
        "regex": "Navon[_ ]|(?:Vision_Tab_(?:7|10)|Pure Micro|Superme_Max|Raptor3G8GB|Predator (?:10|3G)|Platinum[_ ]?10[_ ]?3G(?:_V2|2019)?|Supreme[_ ](?:Fine(?:[_ ]Micro)?|Chief|Pure|Pro)(?:[_ ](?:Mini|Plus))?|T400 3G 2017|Spirit_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M505 LTE(?:[);/ ]|$)",
                "model": "Mizu M505 LTE"
            },
            {
                "regex": "(F552|D504)(?:[);/ ]|$)",
                "model": "Mizu $1"
            },
            {
                "regex": "Superme_Max(?:[);/ ]|$)",
                "model": "Supreme Max"
            },
            {
                "regex": "Supreme_Fine_Mini(?:[);/ ]|$)",
                "model": "Supreme Fine Mini"
            },
            {
                "regex": "Supreme_Fine_Micro(?:[);/ ]|$)",
                "model": "Supreme Fine Micro"
            },
            {
                "regex": "Supreme[_ ]Fine[_ ]Plus(?:[);/ ]|$)",
                "model": "Supreme Fine Plus"
            },
            {
                "regex": "Supreme_Fine(?:[);/ ]|$)",
                "model": "Supreme Fine"
            },
            {
                "regex": "Supreme[_ ]Chief(?:[);/ ]|$)",
                "model": "Supreme Chief"
            },
            {
                "regex": "Supreme[_ ]Pure[ _]Plus(?:[);/ ]|$)",
                "model": "Supreme Pure Plus"
            },
            {
                "regex": "Supreme Pure(?:[);/ ]|$)",
                "model": "Supreme Pure"
            },
            {
                "regex": "Supreme[_ ]Pro(?:[);/ ]|$)",
                "model": "Supreme Pro"
            },
            {
                "regex": "Pure Micro(?:[);/ ]|$)",
                "model": "Pure Micro"
            },
            {
                "regex": "Spirit_Plus(?:[);/ ]|$)",
                "model": "Spirit Plus"
            },
            {
                "regex": "T400 3G 2017",
                "model": "T400 3G (2017)"
            },
            {
                "regex": "Navon[_ ]Infinity(?:[);/ ]|$)",
                "model": "Infinity"
            },
            {
                "regex": "Navon[_ ](D405)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Navon[_ ])?Platinum[ _]10[ _]3G(_V2)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Platinum 10.1\" 3G$1"
            },
            {
                "regex": "(?:Navon[_ ])?Platinum103G2019(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Platinum 10.1\" 3G (2019)"
            },
            {
                "regex": "(?:Navon[_ ])?Orpheus[ _]3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Orpheus 3G"
            },
            {
                "regex": "(?:Navon_)?Predator[_ ](3G|10|7)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Predator $1"
            },
            {
                "regex": "Raptor3G8GB(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Raptor 3G 8GB"
            },
            {
                "regex": "Vision_Tab_(7|10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Vision Tab $1"
            }
        ]
    },
    "C5 Mobile": {
        "regex": "(?:noa X2 Plus|noa_G1|noaXPower|NOATAB)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "noa X2 Plus",
                "model": "Noa X2 Plus"
            },
            {
                "regex": "noa_G1",
                "model": "Noa G1"
            },
            {
                "regex": "noaXPower",
                "model": "Noa X Power"
            },
            {
                "regex": "NOATAB",
                "device": "tablet",
                "model": "Noa Tab"
            }
        ]
    },
    "NOA": {
        "regex": "(?:NOA-)?NOA[ _]|Hummer(?:_2019_R|LE)|NextSE|Vivo 4G_r|SPRINT4G|SparkSE",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOA[_ ]CORE[_ ]FORTE",
                "model": "Core Forte"
            },
            {
                "regex": "HummerLE",
                "model": "Hummer LE"
            },
            {
                "regex": "Hummer_2019_R",
                "model": "Hummer R (2019)"
            },
            {
                "regex": "NOA[_ ]Hummer[_ ]Lite",
                "model": "Hummer Lite"
            },
            {
                "regex": "NOA[_ ]HUMMER",
                "model": "Hummer"
            },
            {
                "regex": "NOA[_ ]MOVEse",
                "model": "Move SE"
            },
            {
                "regex": "NextSE",
                "model": "Next SE"
            },
            {
                "regex": "NOA[_ ]NEXT",
                "model": "Next"
            },
            {
                "regex": "NOA[_ ]VISION[_ ]H3SE",
                "model": "Vision H3SE"
            },
            {
                "regex": "NOA[_ ]VISION[_ ]H3",
                "model": "Vision H3"
            },
            {
                "regex": "NOA[_ ]LOOP",
                "model": "Loop"
            },
            {
                "regex": "(?:NOA-)?NOA[_ ]H4se",
                "model": "H4SE"
            },
            {
                "regex": "NOA[_ ]Mg12",
                "model": "MG12"
            },
            {
                "regex": "NOA[_ ]H44SE",
                "model": "H44SE"
            },
            {
                "regex": "NOA[_ ]H10LE",
                "model": "H10LE"
            },
            {
                "regex": "SPRINT4G",
                "model": "Sprint 4G"
            },
            {
                "regex": "SparkSE",
                "model": "Spark SE"
            },
            {
                "regex": "NOA[_ ](M108K|P497)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(?:NOA[_ ])?Vivo 4G_r",
                "model": "Vivo 4G"
            },
            {
                "regex": "NOA[_ ]([^;)/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Nobby": {
        "regex": "Nobby[ ](S500|X800(?: Pro)?|S300(?: Pro)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NoviSea": {
        "regex": "NoviSea[ _](A10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Novacom": {
        "regex": "SPYBOXS11",
        "device": "tv",
        "models": [
            {
                "regex": "SPYBOXS11_PLUS(?:[);/ ]|$)",
                "model": "Spy Box S11 Plus"
            },
            {
                "regex": "SPYBOXS11(?:[);/ ]|$)",
                "model": "Spy Box S11"
            }
        ]
    },
    "Novey": {
        "regex": "Novey|(?:Pro K10|(?:Force (?:F15|G20)|Alpha A1[06]))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Force (F15|G20)",
                "model": "Force $1"
            },
            {
                "regex": "Alpha A(1[06])",
                "model": "Alpha A$1"
            },
            {
                "regex": "Pro K10",
                "model": "Pro K10"
            },
            {
                "regex": "Novey (L2)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "NEC": {
        "regex": "NEC[ _-]|KGT/2\\.0|portalmmm/1\\.0 (?:DB|N)|(?:portalmmm|o2imode)/2\\.0[ ,]N|(?:PC-T[SE]\\d{3}[\\w]{2,3}|N-06C|N-02E|LAVIE T11 (?:11QHD1|112K1)|LAVIE Tab E (?:10|8)FHD[12]|7SD1|8HD1|LAVIE Tab (?:10FHD3|T12 12QHD1|9QHD1))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "N-06C(?:[);/ ]|$)",
                "model": "Medias Amadana"
            },
            {
                "regex": "N-02E(?:[);/ ]|$)",
                "model": "Medias U"
            },
            {
                "regex": "(?:NEC[ _-]|KGT/2\\.0 )([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/1\\.0 ((?:DB|N)[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(?:portalmmm|o2imode)/2\\.0[ ,](N[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "LAVIE Tab E ((?:10|8)FHD[12]|7SD1|8HD1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab E $1"
            },
            {
                "regex": "LAVIE Tab 10FHD3(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab T10 FHD (Gen 3)"
            },
            {
                "regex": "LAVIE Tab T12 12QHD1(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab T12 QHD"
            },
            {
                "regex": "LAVIE T11 (11QHD1|112K1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab T11 $1"
            },
            {
                "regex": "LAVIE T7 (7SD1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab T7 $1"
            },
            {
                "regex": "LAVIE T8 (8HD1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "LAVIE Tab T8 $1"
            },
            {
                "regex": "PC-TE(\\d+)",
                "device": "tablet",
                "model": "LAVIE Tab E TE$1"
            },
            {
                "regex": "PC-TS(\\d+)",
                "device": "tablet",
                "model": "LAVIE Tab S TS$1"
            },
            {
                "regex": "LAVIE Tab (9QHD1)",
                "device": "tablet",
                "model": "LAVIE Tab $1"
            }
        ]
    },
    "Neffos": {
        "regex": "Neffos|(TP601[ABCE])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:C57|TP601[ABCE])(?:[);/ ]|$)",
                "model": "C5L"
            },
            {
                "regex": "Neffos[_ ]Y50",
                "model": "Y50"
            },
            {
                "regex": "Neffos X20 Pro",
                "model": "X20 Pro"
            },
            {
                "regex": "Neffos X20",
                "model": "X20"
            },
            {
                "regex": "Neffos[_ ]((?:[YNCXA])[0-9][A-Z]?(?: Max| Lite| Plus)?)",
                "model": "$1"
            }
        ]
    },
    "Nextbit": {
        "regex": "Nextbit|(?:Robin)(?: Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Robin)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Newgen": {
        "regex": "NEWGEN\\-([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "NetBox": {
        "regex": "NETBOX",
        "device": "tv",
        "models": [
            {
                "regex": "NETBOX-Prime(?:[);/ ]|$)",
                "model": "Prime"
            },
            {
                "regex": "NETBOX-ShineS(?:[);/ ]|$)",
                "model": "Shine S"
            }
        ]
    },
    "Netgear": {
        "regex": "GTV100",
        "device": "tv",
        "models": [
            {
                "regex": "GTV100",
                "model": "NeoTV Prime"
            }
        ]
    },
    "Gear Mobile": {
        "regex": "(Feel_7013N)",
        "device": "tablet",
        "model": "$1"
    },
    "NeuImage": {
        "regex": "NIM-",
        "device": "smartphone",
        "models": [
            {
                "regex": "NIM-(450D|550O|[56]00Q)",
                "model": "$1"
            }
        ]
    },
    "NextBook": {
        "regex": "Next[0-9]|NX(?:785QC8G|M900MC|008HD8G|010HI8G|M908HC|M726|16A8116K|A8QC116|A8LTE116|16A10132S|16A11264|A116QC164|A101LTE116)|(?:BRT81)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(BRT81)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "NX008HD8G",
                "model": "Premium 8 HD"
            },
            {
                "regex": "NXA8QC116",
                "model": "Ares 8"
            },
            {
                "regex": "NXA8LTE116",
                "model": "Ares 8L"
            },
            {
                "regex": "NX16A8116K",
                "model": "Ares A8"
            },
            {
                "regex": "NX16A10132S",
                "model": "Ares A10"
            },
            {
                "regex": "NX16A11264",
                "model": "Ares A11"
            },
            {
                "regex": "NEXT1015BAP",
                "model": "Ares 10"
            },
            {
                "regex": "NXA101LTE116",
                "model": "Ares 10L"
            },
            {
                "regex": "NXA116QC164",
                "model": "Ares 11"
            },
            {
                "regex": "NXM908HC",
                "model": "Premium 9"
            },
            {
                "regex": "NX010HI8G",
                "model": "Premium 10 Hi"
            },
            {
                "regex": "NX785QC8G",
                "model": "8"
            },
            {
                "regex": "NXM900MC",
                "model": "8 HD"
            },
            {
                "regex": "NXM726",
                "model": "Premium 7"
            },
            {
                "regex": "Next([0-9]+[^;/]+) Build",
                "model": "Next $1"
            }
        ]
    },
    "NGM": {
        "regex": "NGM[_ ][a-z0-9]+|(Forward|Dynamic)[ _]?[^/;]+(?:Build|/)|Smart5Plus32GB|Android 5(?:[\\d.]*);(?: [\\w-]+;)? (?:P50[89]|P55[01])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Smart5Plus32GB",
                "model": "Smart 5 Plus"
            },
            {
                "regex": "P(50[89]|55[01])",
                "model": "You Color P$1"
            },
            {
                "regex": "Dynamic JumpL",
                "model": "Dynamic Jump L"
            },
            {
                "regex": "(Forward|Dynamic)[ _]?([^/;)]+)(?: Build|[;)])",
                "model": "$1 $2"
            },
            {
                "regex": "(Forward|Dynamic)[ _]?([^/;]+)/",
                "model": "$1 $2"
            },
            {
                "regex": "NGM ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "NGM_([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Nexian": {
        "regex": "S?Nexian",
        "device": "smartphone",
        "models": [
            {
                "regex": "S?Nexian[ ]?([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "S?Nexian-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Noain": {
        "regex": "NOAIN",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOAIN[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "NOAIN[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Noblex": {
        "regex": "Noblex|NBX-|(?:A[56]0UNS|T7A6INC|T7A6N)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Noblex|NBX)[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:Noblex|NBX)[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "(A[56]0)UNS",
                "model": "$1"
            },
            {
                "regex": "(T7A6INC|T7A6N)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "NOGA": {
        "regex": "(?:NOGAPC (?:LIVE|PRO|ULTRA)|NOGAPAD ?(?:7G|10\\.1GHD|10HD))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "NOGAPAD ?7G(?:[);/ ]|$)",
                "model": "NOGAPAD 7G"
            },
            {
                "regex": "NOGAPAD ?10\\.1GHD(?:[);/ ]|$)",
                "model": "NOGAPAD 10.1\" GHD"
            },
            {
                "regex": "NOGAPAD 10HD",
                "model": "NOGAPAD 10HD"
            },
            {
                "regex": "NOGAPC PRO(?:[);/ ]|$)",
                "device": "tv",
                "model": "PC Pro"
            },
            {
                "regex": "NOGAPC LIVE(?:[);/ ]|$)",
                "device": "tv",
                "model": "PC Live"
            },
            {
                "regex": "NOGAPC ULTRA(?:[);/ ]|$)",
                "device": "tv",
                "model": "PC Ultra"
            }
        ]
    },
    "Nomu": {
        "regex": "(?:Nomu[ _-](?:T18|S30mini|S10)|(?:V1600S|S10 PRO|S50_Pro)|LMCV1|Xeno V1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nomu[ _-]T18(?:[);/ ]|$)",
                "model": "T18"
            },
            {
                "regex": "Nomu[ _-]s10(?:[);/ ]|$)",
                "model": "S10"
            },
            {
                "regex": "Nomu[ _-]S30mini(?:[);/ ]|$)",
                "model": "S30 Mini"
            },
            {
                "regex": "LMCV1(?:[);/ ]|$)",
                "model": "S30"
            },
            {
                "regex": "S([15]0)[_ ]PRO(?:[);/ ]|$)",
                "model": "S$1 Pro"
            },
            {
                "regex": "(V1600S)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(Xeno V1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Noontec": {
        "regex": "Noontec ",
        "device": "tv",
        "model": ""
    },
    "Nordmende": {
        "regex": "NORDMENDE[ _;,]",
        "device": "tv",
        "models": [
            {
                "regex": "NORDMENDE[_ ](43NM6000F|55NM6000U)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Opsson": {
        "regex": "(?<!SANTIN )Opsson|IUSAI",
        "device": "smartphone",
        "models": [
            {
                "regex": "IUSAI[ _]([^/;]+) Build",
                "model": "Iusai $1"
            },
            {
                "regex": "IUSAI[ _]([^/;\\)]+)[/;\\)]",
                "model": "Iusai $1"
            },
            {
                "regex": "Opsson[ _]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:Opsson-)?Opsson[ -_]([^/;]+)/",
                "model": "$1"
            }
        ]
    },
    "Nomi": {
        "regex": "Nomi[ _-]|(C101010 Ultra2|i501[234]|i5032|i50[537]0|i5031|i55[13]0|i5532|C0(700(?:[02358]|2HD)|7850)|C1010[0-3]|i(?:50[0158]|450|40[01]|55[02])|i504 Dream|AB5116-01)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "i501[23](?:[);/ ]|$)",
                "model": "Evo M2"
            },
            {
                "regex": "Nomi[ _]i5010(?:[);/ ]|$)",
                "model": "Evo M"
            },
            {
                "regex": "Nomi[ _]i5001(?:[);/ ]|$)",
                "model": "Evo M3"
            },
            {
                "regex": "Nomi[ _]i5011(?:[);/ ]|$)",
                "model": "Evo M1"
            },
            {
                "regex": "Nomi[ _]i506(?:[);/ ]|$)",
                "model": "i506 Shine"
            },
            {
                "regex": "Nomi[ _]i5730(?:[);/ ]|$)",
                "model": "i5730 Infinity"
            },
            {
                "regex": "Nomi[ _]i6030(?:[);/ ]|$)",
                "model": "Note-X"
            },
            {
                "regex": "I5070(?:[);/ ]|$)",
                "model": "Iron-X"
            },
            {
                "regex": "i5071(?:[);/ ]|$)",
                "model": "Iron-X1"
            },
            {
                "regex": "Nomi[_ ]I4070(?:[);/ ]|$)",
                "model": "Iron-M"
            },
            {
                "regex": "i5014(?:[);/ ]|$)",
                "model": "Evo M4"
            },
            {
                "regex": "i5032(?:[);/ ]|$)",
                "model": "Evo X2"
            },
            {
                "regex": "i5030(?:[);/ ]|$)",
                "model": "Evo X"
            },
            {
                "regex": "i5031(?:[);/ ]|$)",
                "model": "Evo X1"
            },
            {
                "regex": "i5050(?:[);/ ]|$)",
                "model": "Evo Z"
            },
            {
                "regex": "(?:Nomi_)?i4510(?:[);/ ]|$)",
                "model": "Beat M"
            },
            {
                "regex": "(?:Nomi_)?i4500(?:[);/ ]|$)",
                "model": "Beat M1"
            },
            {
                "regex": "i5532(?:[);/ ]|$)",
                "model": "Space X2"
            },
            {
                "regex": "i5510(?:[);/ ]|$)",
                "model": "Space M"
            },
            {
                "regex": "i5530(?:[);/ ]|$)",
                "model": "Space X"
            },
            {
                "regex": "Nomi[_ ]i5511(?:[);/ ]|$)",
                "model": "Space M1"
            },
            {
                "regex": "(?:Nomi_)?i5710(?:[);/ ]|$)",
                "model": "Infinity X1"
            },
            {
                "regex": "i508(?:[);/ ]|$)",
                "model": "Energy"
            },
            {
                "regex": "(?:Nomi[ _])?i(50[015]|450|40[01]|55[02])(?:[);/ ]|$)",
                "model": "i$1"
            },
            {
                "regex": "Nomi[ _]i507(?:[);/ ]|$)",
                "model": "Spark"
            },
            {
                "regex": "Nomi[ _]i503(?:[);/ ]|$)",
                "model": "Jump"
            },
            {
                "regex": "(?:Nomi[ _]i504|i504 Dream)(?:[);/ ]|$)",
                "model": "Dream"
            },
            {
                "regex": "Nomi[ _](\\w+)[ _]PLUS(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(AB5116-01)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "C101010 Ultra2",
                "model": "Ultra 2",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C101040",
                "model": "Ultra 3 Pro",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C101030",
                "model": "Ultra 3 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C101012",
                "model": "Ultra 3 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C101014",
                "model": "Ultra 4 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C101034",
                "model": "Ultra 4 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C101044",
                "model": "Ultra 4 Pro LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C070010",
                "device": "tablet",
                "model": "Corsa"
            },
            {
                "regex": "(?:Nomi_)?C070020",
                "model": "Corsa Pro",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C070011",
                "model": "Corsa 2",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C070030",
                "model": "Corsa 3 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C070012",
                "model": "Corsa 3 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C070014L",
                "model": "Corsa 4 Light 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C0700[13]4",
                "model": "Corsa 4 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C070044",
                "model": "Corsa 4 Pro LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C080012",
                "model": "Libra 3 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C080010",
                "model": "Libra 2 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C080034",
                "model": "Libra 4 LTE",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C080014",
                "model": "Libra 4 3G",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C07008",
                "model": "Sigma",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi_)?C10105",
                "model": "Stella Plus",
                "device": "tablet"
            },
            {
                "regex": "(?:Nomi[ _])?(C0(?:700(?:[0235]|2HD)|7850|9600)|C1010[0-3])(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Nomi[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Nomi[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "NUU Mobile": {
        "regex": "NUU_|(?:(?:N(500[12]|550[12]|570[24]|6001)L|S(?:5501|5701|600[13]|6303|6501|6512)L|T080[12]L)|S6702X|A6L-[CG])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "T080[12]L",
                "device": "tablet",
                "model": "Tab 8"
            },
            {
                "regex": "NUU_A([13]L?)",
                "model": "A$1"
            },
            {
                "regex": "NUU_M([32])(?:[);/ ]|$)",
                "model": "M$1"
            },
            {
                "regex": "NUU_X5(?:[);/ ]|$)",
                "model": "X5"
            },
            {
                "regex": "S6003L",
                "model": "X6 Plus"
            },
            {
                "regex": "N5704L",
                "model": "G1"
            },
            {
                "regex": "S6512L",
                "model": "A15"
            },
            {
                "regex": "S6001L",
                "model": "G2"
            },
            {
                "regex": "S5501L",
                "model": "M19"
            },
            {
                "regex": "N5702L",
                "model": "G3"
            },
            {
                "regex": "S6501L",
                "model": "G5"
            },
            {
                "regex": "N5501L",
                "model": "A5L"
            },
            {
                "regex": "N5002L",
                "model": "A7L"
            },
            {
                "regex": "S6303L",
                "model": "A9L"
            },
            {
                "regex": "N5502L",
                "model": "A10L"
            },
            {
                "regex": "N6001L",
                "model": "A23"
            },
            {
                "regex": "S5701L",
                "model": "M4X Pro"
            },
            {
                "regex": "S6702X",
                "model": "B30 Pro"
            },
            {
                "regex": "(?:NUU_)?(N5001L|A6L-[CG]|Q500)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "NYX Mobile": {
        "regex": "NYX[ _]|(?:GLAM|ARGON|TQ14|GO-X|orbis)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NYX_A1",
                "model": "A1"
            },
            {
                "regex": "NYX[_ ]ALTER",
                "model": "Alter"
            },
            {
                "regex": "NYX_Blink",
                "model": "Blink"
            },
            {
                "regex": "NYX_EGO",
                "model": "Ego"
            },
            {
                "regex": "NYX_FENIX",
                "model": "Fenix"
            },
            {
                "regex": "NYX_FLY_II",
                "model": "Fly II"
            },
            {
                "regex": "NYX_FLY_MINI",
                "model": "Fly Mini"
            },
            {
                "regex": "NYX_FLY",
                "model": "Fly"
            },
            {
                "regex": "NYX_HIT",
                "model": "Hit"
            },
            {
                "regex": "NYX_JAK",
                "model": "Jak"
            },
            {
                "regex": "NYX_JOIN",
                "model": "Join"
            },
            {
                "regex": "NYX_NOBA_II",
                "model": "Noba II"
            },
            {
                "regex": "NYX_NOBA",
                "model": "Noba"
            },
            {
                "regex": "NYX_ORBIS",
                "model": "Orbis"
            },
            {
                "regex": "NYX[ _]REX",
                "model": "Rex"
            },
            {
                "regex": "NYX_SHADE",
                "model": "Shade"
            },
            {
                "regex": "NYX_SKY",
                "model": "Sky"
            },
            {
                "regex": "NYX_SPARK",
                "model": "Spark"
            },
            {
                "regex": "NYX_VOX",
                "model": "Vox"
            },
            {
                "regex": "NYX_ZEUZ_HD",
                "model": "Zeus HD"
            },
            {
                "regex": "GLAM",
                "model": "Glam"
            },
            {
                "regex": "ARGON",
                "model": "Argon"
            },
            {
                "regex": "(TQ14|GO-X)",
                "model": "$1"
            },
            {
                "regex": "orbis",
                "model": "Orbis"
            }
        ]
    },
    "Nous": {
        "regex": "(?:NS(?:[356]|500[2-68]|5511|5502)|NS 5511)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NS 5511(?:[);/ ]|$)",
                "model": "NS5511"
            },
            {
                "regex": "(NS[0-9]{1,4})(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Nvidia": {
        "regex": "NVIDIA|SHIELD|Tegra(Note-P1640| Note 7)|wx_na_wf|wx_un_do",
        "device": "tablet",
        "models": [
            {
                "regex": "TegraNote-P1640",
                "model": "Tegra Note P1640"
            },
            {
                "regex": "wx_na_wf|wx_un_do",
                "model": "SHIELD Tablet"
            },
            {
                "regex": "(SHIELD Tablet(?: K1)?|Tegra Note 7)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "SHIELD Andr[o0]id TV",
                "model": "SHIELD Android TV",
                "device": "tv"
            },
            {
                "regex": "NVIDIA_SHIELD_PRO_2019",
                "model": "SHIELD TV Pro",
                "device": "tv"
            },
            {
                "regex": "NVIDIA Shield",
                "model": "SHIELD TV",
                "device": "tv"
            },
            {
                "regex": "SHIELD",
                "model": "SHIELD Portable",
                "device": "console"
            }
        ]
    },
    "O+": {
        "regex": "O\\+[ _](Presto 700 LTE|FAB GO|360|8\\.(?:3[178]z|[15]2|37y|3[38]|9[12378]|1[75]|6)|Air|Grande|Crunch|Ultra|Xfinit|Upsized|Venti|EVO 4G|Sonic|360[ _]ALPHA[ _]PLUS[ _]2\\.0|360[ _]HD[ _]2\\.0|Stream HDTV)",
        "device": "smartphone",
        "models": [
            {
                "regex": "O\\+[ _](Presto 700 LTE|Grande|Crunch|Ultra 2\\.0|Xfinit|Ultra Lite|Ultra|Sonic|Upsized|Venti 4G|EVO 4G|8\\.(?:3[178]z|37y|3[38]|[15]2|9[12378]|1[75]|6))",
                "model": "$1"
            },
            {
                "regex": "O\\+_AIR",
                "model": "Air"
            },
            {
                "regex": "O\\+[ _]360[ _]HD[ _]2\\.0",
                "model": "360 HD 2.0"
            },
            {
                "regex": "O\\+[ _]360[ _]HD",
                "model": "360 HD"
            },
            {
                "regex": "O\\+[ _]360[ _]ALPHA[ _]PLUS[ _]2\\.0",
                "model": "360 Alpha Plus 2.0"
            },
            {
                "regex": "O\\+[ _]360 ALPHA Plus",
                "model": "360 Alpha Plus"
            },
            {
                "regex": "O\\+[ _]360 ALPHA",
                "model": "360 Alpha"
            },
            {
                "regex": "O\\+[ _]360",
                "model": "360"
            },
            {
                "regex": "O\\+ Stream HDTV",
                "device": "tablet",
                "model": "Stream HDTV"
            },
            {
                "regex": "O\\+ FAB GO",
                "device": "tablet",
                "model": "Fab Go"
            }
        ]
    },
    "O2": {
        "regex": "Xda|(?<!FBCR/)O2[ -]|COCOON",
        "device": "smartphone",
        "models": [
            {
                "regex": "O2 TV Box(?:[);/ ]|$)",
                "device": "tv",
                "model": "TV Box"
            },
            {
                "regex": "(Xda[ _][a-z0-9_]+)",
                "model": "$1"
            },
            {
                "regex": "(COCOON)",
                "model": "$1"
            },
            {
                "regex": "O2-(X[12]i|X4)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "O2 ([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "O2-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Funai": {
        "regex": "FUNAI[;,)-]|AFTMON00[12](?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "AFTMON00[12](?:[);/ ]|$)",
                "model": "Fire TV 4K (2022)"
            },
            {
                "regex": "Funai-Model18-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Fusion5": {
        "regex": "Fusion5|F104Bv2|F104EvII_PRO|F104EvII|F105D_128",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:Fusion5_)?(F104B)v2_PRO",
                "model": "$1v2 Pro"
            },
            {
                "regex": "(?:Fusion5_)?(F104B)v2",
                "model": "$1v2"
            },
            {
                "regex": "(?:Fusion5_)?F104EvII_PRO",
                "model": "F104EVII Pro"
            },
            {
                "regex": "(?:Fusion5_)?F104EvII(?:_EEA)?(?:[);/ ]|$)",
                "model": "F104EVII"
            },
            {
                "regex": "(?:Fusion5_)?(F704B|F105D|F104E)(?:_128|_EEA)?(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "ZH&K": {
        "regex": "(?:Odyssey[_ ](?:evo|DTV[67]|J[59]|J10|GLAZE\\+?|RANGE|ACE|AEON|VICTORY|SACRED|SAGA|SWIFT|O2|ULTRA|FLAME|POPO|PERRI|TYTAN|HIGH|SOAR|ERA)|ODYSSEY[ _]?NEXT|INTENSE (?:RISE|Hype|GAME))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ODYSSEY[ _]J10[ _]Mini",
                "model": "Odyssey J10 Mini"
            },
            {
                "regex": "ODYSSEY[ _](O2|J[95]|DTV[67]|J10)",
                "model": "Odyssey $1"
            },
            {
                "regex": "ODYSSEY[_ ]AEON",
                "model": "Odyssey Aeon"
            },
            {
                "regex": "ODYSSEY[_ ]ACE",
                "model": "Odyssey Ace"
            },
            {
                "regex": "ODYSSEY[_ ]ULTRA",
                "model": "Odyssey Ultra"
            },
            {
                "regex": "ODYSSEY[ _]?NEXT",
                "model": "Odyssey Next"
            },
            {
                "regex": "ODYSSEY[ _]PERRI",
                "model": "Odyssey Perri"
            },
            {
                "regex": "ODYSSEY[_ ]FLAME",
                "model": "Odyssey Flame"
            },
            {
                "regex": "ODYSSEY[_ ]evo",
                "model": "Odyssey Evo"
            },
            {
                "regex": "ODYSSEY[_ ]Victory",
                "model": "Odyssey Victory"
            },
            {
                "regex": "ODYSSEY[_ ]SWIFT",
                "model": "Odyssey Swift"
            },
            {
                "regex": "ODYSSEY[_ ]TYTAN",
                "model": "Odyssey Tytan"
            },
            {
                "regex": "ODYSSEY[_ ]SAGA",
                "model": "Odyssey Saga"
            },
            {
                "regex": "ODYSSEY[_ ]SACRED",
                "model": "Odyssey Sacred"
            },
            {
                "regex": "ODYSSEY[_ ]POPO",
                "model": "Odyssey Popo"
            },
            {
                "regex": "ODYSSEY[_ ]RANGE",
                "model": "Odyssey Range"
            },
            {
                "regex": "Odyssey[_ ]GLAZE\\+",
                "model": "Odyssey Glaze Plus"
            },
            {
                "regex": "Odyssey[_ ]GLAZE",
                "model": "Odyssey Glaze"
            },
            {
                "regex": "Odyssey[_ ]HIGH",
                "model": "Odyssey High"
            },
            {
                "regex": "Odyssey[_ ]SOAR",
                "model": "Odyssey Soar"
            },
            {
                "regex": "Odyssey[_ ]ERA",
                "model": "Odyssey Era"
            },
            {
                "regex": "INTENSE RISE",
                "model": "Intense Rise"
            },
            {
                "regex": "INTENSE Hype",
                "model": "Intense Hype"
            },
            {
                "regex": "INTENSE GAME",
                "model": "Intense Game"
            }
        ]
    },
    "Odys": {
        "regex": "ODYS[ _-]|IEOS[_ ]([^/;]+)|NOON(?:_PRO)? Build|SPACE10_(?:PLUS|PRO)_3G|THOR_?10|TAO_X10|RAPID_?(?:10|7)_?LTE|MAVEN_?10_|CONNECT[78]|ELEMENT10_PLUS_3G|XELIO[_0-9P]|PACE_10_LTE|(?:ADM816HC|ADM8000KP|NEO6_LTE|EOS10|AEON|FALCON_10_PLUS_3G|SPACE_ONE_?10(?:SE)?|FUSION|THANOS_10|MAVEN_X10_HD(?:_LTE)?|JUNIOR_8_PRO|JuniorT8Pro|(?:NOVA|PYRO)_X?7_PLUS_3G|UNO_X8|MAVEN_[GT]10(?:_pro)?|MAVEN_7_PLUS|SLADE_X55|XELIO_PRO_10_LTE|GOAL_10_PLUS_3G|NOTOSplus3G|PACE ?10|Titan_10_LTE|PEDI_PLUS_W|NoteTab_Pro|UNO_X10|NERON)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "XELIO[_ ]HD10[_ ]LTE",
                "model": "Xelio HD10 LTE"
            },
            {
                "regex": "XELIO[_ ](HD10|A10)",
                "model": "Xelio $1"
            },
            {
                "regex": "XELIOPHONETAB3",
                "model": "Xelio Phonetab 3"
            },
            {
                "regex": "THANOS_10",
                "model": "Thanos 10"
            },
            {
                "regex": "XELIO_NEXT_10_PLUS_3G",
                "model": "Xelio Next 10 Plus 3G"
            },
            {
                "regex": "XELIO_PHONE_TAB7_3G",
                "model": "Xelio Phonetab 7 3G"
            },
            {
                "regex": "XELIO10EXTREME",
                "model": "Xelio 10 Xtreme"
            },
            {
                "regex": "XELIO10_PLUS_3G",
                "model": "Xelio 10 Plus 3G"
            },
            {
                "regex": "XELIO10_HD_PLUS_3G",
                "model": "Xelio 10 HD Plus 3G"
            },
            {
                "regex": "XELIO_10_HD",
                "model": "Xelio 10 HD"
            },
            {
                "regex": "XELIO_PRO_10_LTE",
                "model": "Xelio Pro 10 LTE"
            },
            {
                "regex": "ELEMENT10_PLUS_3G",
                "model": "Element 10 Plus 3G"
            },
            {
                "regex": "CONNECT8PLUS",
                "model": "Connect 8 Plus"
            },
            {
                "regex": "CONNECT7PRO",
                "model": "Connect 7 Pro"
            },
            {
                "regex": "MAVEN_X10_HD_LTE",
                "model": "Maven X10 HD LTE"
            },
            {
                "regex": "Maven_T10_pro",
                "model": "Maven T10 Pro"
            },
            {
                "regex": "MAVEN_X10_HD",
                "model": "Maven X10 HD"
            },
            {
                "regex": "MAVEN_?10_PRO_PLUS_3G",
                "model": "Maven 10 Pro Plus 3G"
            },
            {
                "regex": "MAVEN_?10_?PLUS",
                "model": "Maven 10 Plus"
            },
            {
                "regex": "MAVEN_?10_?PRO",
                "model": "Maven 10 Pro"
            },
            {
                "regex": "MAVEN_?10_?HD",
                "model": "Maven 10 HD"
            },
            {
                "regex": "MAVEN_7_PLUS",
                "model": "Maven 7 Plus"
            },
            {
                "regex": "RAPID_?7_?LTE",
                "model": "Rapid 7 LTE"
            },
            {
                "regex": "RAPID_?10_?LTE",
                "model": "Rapid 10 LTE"
            },
            {
                "regex": "TAO_X10",
                "model": "Tao X10"
            },
            {
                "regex": "SPACE10_PLUS_3G",
                "model": "Space 10 Plus 3G"
            },
            {
                "regex": "SPACE_ONE_10SE",
                "model": "Space One 10 SE"
            },
            {
                "regex": "SPACE_ONE10",
                "model": "Space One 10"
            },
            {
                "regex": "SPACE10_PRO_3G",
                "model": "Space 10 Pro 3G"
            },
            {
                "regex": "THOR_?10 Build",
                "model": "Thor 10"
            },
            {
                "regex": "JuniorT8Pro",
                "model": "Junior T8 Pro"
            },
            {
                "regex": "JUNIOR_8_PRO",
                "model": "Junior 8 Pro"
            },
            {
                "regex": "ADM816HC",
                "model": "Neo X"
            },
            {
                "regex": "EOS10",
                "model": "EOS 10"
            },
            {
                "regex": "PACE_10_LTE_V2",
                "model": "Pace 10 LTE V2"
            },
            {
                "regex": "PACE ?10",
                "model": "Pace 10"
            },
            {
                "regex": "AEON",
                "model": "Aeon"
            },
            {
                "regex": "FALCON_10_PLUS_3G",
                "model": "Falcon 10 Plus 3G"
            },
            {
                "regex": "FUSION",
                "model": "Fusion 7"
            },
            {
                "regex": "UNO[_ ]X(8|10)",
                "model": "Uno X$1"
            },
            {
                "regex": "ADM8000KP",
                "model": "Titan"
            },
            {
                "regex": "Titan_10_LTE",
                "model": "Titan 10 LTE"
            },
            {
                "regex": "PYRO_7_PLUS_3G",
                "model": "Pyro 7 Plus 3G"
            },
            {
                "regex": "NOVA_X7_PLUS_3G",
                "model": "Nova X7 Plus 3G"
            },
            {
                "regex": "ODYS_NOVA_X7",
                "model": "Nova X7"
            },
            {
                "regex": "THOR_?10_PLUS_3G",
                "model": "Thor 10 Plus 3G"
            },
            {
                "regex": "NOTOSplus3G",
                "model": "Notos Plus 3G"
            },
            {
                "regex": "MAVEN_G10",
                "model": "Maven G10"
            },
            {
                "regex": "PEDI_PLUS_W",
                "model": "Pedi Plus W"
            },
            {
                "regex": "NoteTab_Pro",
                "model": "NoteTab Pro"
            },
            {
                "regex": "GOAL_10_PLUS_3G",
                "model": "Goal 10 Plus 3G"
            },
            {
                "regex": "IEOS[_ ]QUAD[_ ]W",
                "model": "Ieos Quad W"
            },
            {
                "regex": "IEOS[_ ]NEXT[_ ]10",
                "model": "Ieos Next 10"
            },
            {
                "regex": "IEOS[_ ]QUAD[_ ]PRO",
                "model": "Ieos Quad Pro"
            },
            {
                "regex": "NERON",
                "model": "Neron"
            },
            {
                "regex": "NEO6[_ ]LTE",
                "model": "Neo 6 LTE",
                "device": "smartphone"
            },
            {
                "regex": "SLADE_X55",
                "model": "Slade X55",
                "device": "smartphone"
            },
            {
                "regex": "IEOS[ _]([^/;]+) Build",
                "model": "Ieos $1"
            },
            {
                "regex": "(?:ODYS[ _-])?NOON Build",
                "model": "Noon"
            },
            {
                "regex": "(?:ODYS[ _-])?NOON_PRO",
                "model": "Noon Pro"
            },
            {
                "regex": "Odys[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "astro (MY)": {
        "regex": "Astro;([A-Z0-9]+);",
        "device": "tv",
        "model": "$1"
    },
    "Astro (UA)": {
        "regex": "Astro[- ](S451|S501)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Obi": {
        "regex": "Obi[ _-]|(?:(?:SJ1\\.5|SJ2\\.6|(?<!verykool )S(400|452\\+|45[13]|50[127]|503\\+?|520|55[01])|falcon)|SJ1-5|SJ[23]\\.2| SF1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SJ(\\d)[.-](\\d)",
                "model": "SJ$1.$2"
            },
            {
                "regex": "(?:Obi_)?S400",
                "model": "Skipper"
            },
            {
                "regex": "(?:Obi_)?S451|falcon",
                "model": "Flacon"
            },
            {
                "regex": "(?:Obi_)?S452\\+",
                "model": "Python"
            },
            {
                "regex": "(?:Obi_)?S453",
                "model": "Fox"
            },
            {
                "regex": "(?:Obi[_ ])?(SF1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Obi_)?S501",
                "model": "Wolverine"
            },
            {
                "regex": "(?:Obi_)?S502",
                "model": "Leopard"
            },
            {
                "regex": "(?:Obi_)?S503\\+",
                "model": "Boa Plus"
            },
            {
                "regex": "(?:Obi_)?S503",
                "model": "Boa"
            },
            {
                "regex": "(?:Obi_)?S507",
                "model": "Pelican"
            },
            {
                "regex": "(?:Obi_)?S520",
                "model": "Octopus"
            },
            {
                "regex": "(?:Obi_)?S550",
                "model": "Crane"
            },
            {
                "regex": "(?:Obi_)?S551",
                "model": "Hornbill"
            },
            {
                "regex": "(?:Obi_)?S454",
                "model": "Alligator"
            },
            {
                "regex": "Obi[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Obi[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Okapi": {
        "regex": "Okapi(?!a)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Okapi10(?:[);/ ]|$)",
                "model": "Okapi 10"
            },
            {
                "regex": "Okapi_Tab8_Pro",
                "model": "Tab 8 Pro"
            }
        ]
    },
    "Okapia": {
        "regex": "Okapia|Signature (?:L|Pro|Touch)|(?<!STYLO SM61 )(?:MAGIC\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Signature (L|Pro|Touch)",
                "model": "Signature $1"
            },
            {
                "regex": "Okapia X1(?:[);/ ]|$)",
                "model": "X1"
            },
            {
                "regex": "Okapia[_ ]Mirage(?:[);/ ]|$)",
                "model": "Mirage"
            },
            {
                "regex": "MAGIC\\+(?:[);/ ]|$)",
                "model": "Magic+"
            },
            {
                "regex": "Okapia[_ ]?Magic(?:[);/ ]|$)",
                "model": "Magic"
            }
        ]
    },
    "Olax": {
        "regex": "Olax |Ocean K(?:10|8)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ocean (K8) Pro",
                "device": "tablet",
                "model": "Ocean $1 Pro"
            },
            {
                "regex": "Ocean (K10|K8)(?:[);/ ]|$)",
                "model": "Ocean $1",
                "device": "tablet"
            },
            {
                "regex": "Olax Prime 12(?:[);/ ]|$)",
                "model": "Prime 12"
            }
        ]
    },
    "Olympia": {
        "regex": "(?<!Stream )TREK(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TREK(?:[);/ ]|$)",
                "model": "Trek"
            }
        ]
    },
    "Onda": {
        "regex": "Onda|(?:(?:V820w|V891[w]?|V919(?: 3G)? Air)[ _-]DualOS|(?:V919 4G Air|V989 Air|V972) Core[48]|T2101L2B1C| V10 4G|OBOOK20[_ ]PLUS|OBOOK (?:20 SE|20 DualOS|20 PLUS(?: DUALOS)?)|OBOOK10 SE|V10_4G|V919 Air CH DualOS| T9S|V116w-DualOS|V80[ _]SE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?: T9S)(?:[);/ ]|$)",
                "model": "T9 S"
            },
            {
                "regex": "ONDA[ _]MID",
                "model": "MID",
                "device": "tablet"
            },
            {
                "regex": "V820w[ _-]DualOS",
                "model": "V820W Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V891W[ _-]DualOS",
                "model": "V891W Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V891[ _-]DualOS",
                "model": "V891 Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 3G Air[ _-]DualOS",
                "model": "V919 3G Air Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V116w-DualOS",
                "model": "V116w 3G Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 Air[ _-]DualOS",
                "model": "V919 Air Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 Air CH DualOS",
                "model": "V919 Air CH Dual OS",
                "device": "tablet"
            },
            {
                "regex": "V919 4G Air Core8",
                "model": "V919 4G Air Core 8",
                "device": "tablet"
            },
            {
                "regex": "V972 Core4",
                "model": "V919 Core 4",
                "device": "tablet"
            },
            {
                "regex": "V989 Air Core8",
                "model": "V989 Air Core 8",
                "device": "tablet"
            },
            {
                "regex": "ONDA V989",
                "model": "V989 Core 8",
                "device": "tablet"
            },
            {
                "regex": "T2101L2B1C|OBOOK 20 PLUS DUALOS",
                "model": "oBook 20 Plus Dual OS",
                "device": "tablet"
            },
            {
                "regex": "OBOOK[_ ]?20[_ ]PLUS",
                "device": "tablet",
                "model": "oBook 20 Plus"
            },
            {
                "regex": "V10 4G(?:[);/ ]|$)",
                "model": "V10 10.1\" 4G",
                "device": "tablet"
            },
            {
                "regex": "V80[ _]SE(?:[);/ ]|$)",
                "model": "V80 SE",
                "device": "tablet"
            },
            {
                "regex": "OBOOK 20 DualOS(?:[);/ ]|$)",
                "model": "oBook 20 Dual OS",
                "device": "tablet"
            },
            {
                "regex": "OBOOK 20 SE(?:[);/ ]|$)",
                "model": "oBook 20 SE",
                "device": "tablet"
            },
            {
                "regex": "OBOOK10 SE(?:[);/ ]|$)",
                "model": "oBook 10 SE",
                "device": "tablet"
            },
            {
                "regex": "V10_4G(?:[);/ ]|$)",
                "model": "V10 4G",
                "device": "tablet"
            },
            {
                "regex": "([a-z0-9]+)[ _]Onda",
                "model": "$1"
            },
            {
                "regex": "Onda ([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "OnePlus": {
        "regex": "(?:du_)?ONEPLUS|(?:PGKM10|CPH251[35]|CPH2551|CPH2569|CPH249[31]|CPH244[79]|CPH240[19]|CPH24[12]3|CPH246[579]|CPH2487|CPH241[157]|CPH2419|CPH245[91]|CPH2399|CPH238[19]|CPH258[135]|CPH2573|A0001|A200[135]|AC200[13]|A300[03]|A3010|A5000|A600[03]|A601[03]|BE201[1235]|BE202[5689]|E100[135]|GM191[03517]|GM190[0135]|GM192[05]|HD191[0137]|HD190[01357]|HD1925|IN201[013579]|IN202[0135]|KB200[01357]|LE211[01357]|LE212[035]|GN2200|Nord N10 5G|LE210[01]|LE212[17]|DE211[78]|DN210[13]|EB210[13]|MT211[01]|IV2201|NE221[01357]|PG[PZ]110|PH[BKP]110|OPD(?:2203|2403|2304|2404)|PK[GRX]110|PJ[ADEFXZ]110|CPH26(?:0[59]|1[139]|21|4[579]|5[35]|6[13]|91)|OPWWE231|PLF110|PLC110)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "PJZ110|CPH265[35]|CPH2649",
                "model": "13"
            },
            {
                "regex": "CPH2691|CPH264[57]",
                "model": "13R"
            },
            {
                "regex": "PKX110",
                "model": "13T"
            },
            {
                "regex": "(?:CPH2585|CPH2611|CPH2609)(?:[);/ ]|$)",
                "model": "12R"
            },
            {
                "regex": "(?:PJD110|CPH258[13]|CPH2573)(?:[);/ ]|$)",
                "model": "12"
            },
            {
                "regex": "(?:CPH244[79]|PHB110|CPH2451)(?:[);/ ]|$)",
                "model": "11"
            },
            {
                "regex": "CPH2487",
                "model": "11R 5G"
            },
            {
                "regex": "CPH2551",
                "model": "Open"
            },
            {
                "regex": "CPH2551",
                "model": "Open"
            },
            {
                "regex": "PKG110",
                "model": "Ace 5"
            },
            {
                "regex": "PLF110",
                "model": "Ace 5 Race"
            },
            {
                "regex": "PLC110",
                "model": "Ace 5 Ultra"
            },
            {
                "regex": "PKR110",
                "model": "Ace 5 Pro"
            },
            {
                "regex": "PJX110",
                "model": "Ace 3 Pro 5G"
            },
            {
                "regex": "PJF110",
                "model": "Ace 3V"
            },
            {
                "regex": "PJE110",
                "model": "Ace 3"
            },
            {
                "regex": "PHK110(?:[);/ ]|$)",
                "model": "Ace 2"
            },
            {
                "regex": "PJA110(?:[);/ ]|$)",
                "model": "Ace 2 Pro"
            },
            {
                "regex": "PGKM10(?:[);/ ]|$)",
                "model": "Ace"
            },
            {
                "regex": "PHP110(?:[);/ ]|$)",
                "model": "Ace 2V"
            },
            {
                "regex": "PGP110(?:[);/ ]|$)",
                "model": "Ace Pro"
            },
            {
                "regex": "PGZ110(?:[);/ ]|$)",
                "model": "Ace Racing Edition"
            },
            {
                "regex": "AC200[13](?:[);/ ]|$)",
                "model": "Nord 5G"
            },
            {
                "regex": "(?:CPH2399|CPH2401)(?:[);/ ]|$)",
                "model": "Nord 2T"
            },
            {
                "regex": "EB210[13](?:[);/ ]|$)",
                "model": "Nord CE 5G"
            },
            {
                "regex": "CPH2613",
                "model": "Nord CE 4"
            },
            {
                "regex": "CPH266[13]",
                "model": "Nord 4"
            },
            {
                "regex": "CPH26(?:19|21)",
                "model": "Nord CE 4 Lite 5G"
            },
            {
                "regex": "CPH(?:2381|2409)(?:[);/ ]|$)",
                "model": "Nord CE 2 Lite"
            },
            {
                "regex": "CPH246[57](?:[);/ ]|$)",
                "model": "Nord CE 3 Lite"
            },
            {
                "regex": "CPH2569(?:[);/ ]|$)",
                "model": "Nord CE 3 5G"
            },
            {
                "regex": "CPH249[13]",
                "model": "Nord 3 5G"
            },
            {
                "regex": "BE2012(?:[);/ ]|$)",
                "model": "Clover"
            },
            {
                "regex": "BE201[135](?:[);/ ]|$)",
                "model": "Nord N100"
            },
            {
                "regex": "DE211[78](?:[);/ ]|$)",
                "model": "Nord N200 5G"
            },
            {
                "regex": "CPH2389",
                "model": "Nord N300 5G"
            },
            {
                "regex": "(?:GN2200|CPH2459)(?:[);/ ]|$)",
                "model": "Nord N20 5G"
            },
            {
                "regex": "(?:CPH251[35])(?:[);/ ]|$)",
                "model": "Nord N30 5G"
            },
            {
                "regex": "(?:CPH2605)(?:[);/ ]|$)",
                "model": "Nord N30 SE 5G"
            },
            {
                "regex": "CPH2469(?:[);/ ]|$)",
                "model": "Nord N20 SE"
            },
            {
                "regex": "BE2025(?:[);/ ]|$)",
                "model": "Nord N10"
            },
            {
                "regex": "(BE202[69]|Nord N10 5G)(?:[);/ ]|$)",
                "model": "Nord N10 5G"
            },
            {
                "regex": "BE2028(?:[);/ ]|$)",
                "model": "Nord N10 Lite"
            },
            {
                "regex": "DN210[13](?:[);/ ]|$)",
                "model": "Nord 2 5G"
            },
            {
                "regex": "IV2201(?:[);/ ]|$)",
                "model": "Nord CE 2"
            },
            {
                "regex": "IN202[0135](?:[);/ ]|$)",
                "model": "8 Pro"
            },
            {
                "regex": "KB2000(?:[);/ ]|$)",
                "model": "8T"
            },
            {
                "regex": "OnePlus 8 Lite(?:[);/ ]|$)",
                "model": "8 Lite"
            },
            {
                "regex": "(?:IN201[01357]|OnePlus 8)(?:[);/ ]|$)",
                "model": "8"
            },
            {
                "regex": "IN2019(?:[);/ ]|$)",
                "model": "8 5G UW"
            },
            {
                "regex": "LE211[01357](?:[);/ ]|$)",
                "model": "9"
            },
            {
                "regex": "MT211[01](?:[);/ ]|$)",
                "model": "9RT 5G"
            },
            {
                "regex": "LE210[01](?:[);/ ]|$)",
                "model": "9R"
            },
            {
                "regex": "CPH2423(?:[);/ ]|$)",
                "model": "10R"
            },
            {
                "regex": "CPH2411(?:[);/ ]|$)",
                "model": "10R 5G"
            },
            {
                "regex": "CPH241[3579](?:[);/ ]|$)",
                "model": "10T 5G"
            },
            {
                "regex": "LE212[01357](?:[);/ ]|$)",
                "model": "9 Pro"
            },
            {
                "regex": "NE2210(?:[);/ ]|$)",
                "model": "10 Pro Extreme Edition"
            },
            {
                "regex": "NE221[1357](?:[);/ ]|$)",
                "model": "10 Pro"
            },
            {
                "regex": "(?:GM191[01357]|OnePlus 7 Pro)(?:[);/ ]|$)",
                "model": "7 Pro"
            },
            {
                "regex": "GM190[0135](?:[);/ ]|$)",
                "model": "7"
            },
            {
                "regex": "HD190[01357](?:[);/ ]|$)",
                "model": "7T"
            },
            {
                "regex": "(?:HD191[0137]|OnePlus 7T Pro)(?:[);/ ]|$)",
                "model": "7T Pro"
            },
            {
                "regex": "(?:HD1925|GM192[05])(?:[);/ ]|$)",
                "model": "7T Pro 5G"
            },
            {
                "regex": "KB200[135](?:[);/ ]|$)",
                "model": "8T"
            },
            {
                "regex": "(?:KB2007|OnePlus ?8TMO)(?:[);/ ]|$)",
                "model": "8T+ 5G"
            },
            {
                "regex": "A0001(?:[);/ ]|$)",
                "model": "One"
            },
            {
                "regex": "A200[135]|OnePlus2",
                "model": "2"
            },
            {
                "regex": "E100[135](?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "A3010|OnePlus3T",
                "model": "3T"
            },
            {
                "regex": "A300[03]|OnePlus3",
                "model": "3"
            },
            {
                "regex": "A5010|OnePlus[ ]?5T",
                "model": "5T"
            },
            {
                "regex": "A5000|OnePlus5",
                "model": "5"
            },
            {
                "regex": "A600[03]|OnePlus6",
                "model": "6"
            },
            {
                "regex": "A601[03](?:[);/ ]|$)",
                "model": "6T"
            },
            {
                "regex": "OPWWE231",
                "device": "wearable",
                "model": "Watch 2"
            },
            {
                "regex": "OPD2203",
                "device": "tablet",
                "model": "Pad 11.61\" WiFi"
            },
            {
                "regex": "OPD2404",
                "device": "tablet",
                "model": "Pad Pro 12.1\""
            },
            {
                "regex": "OPD2403",
                "device": "tablet",
                "model": "Pad 2 12.1\" WiFi"
            },
            {
                "regex": "OPD2304",
                "device": "tablet",
                "model": "Pad Go 11.35\""
            },
            {
                "regex": "(?:du_)?ONEPLUS[ _]?([^;/,)(]+)(?: Build|[;,)])",
                "model": "$1"
            }
        ]
    },
    "Realme": {
        "regex": "Realme[ _]|(?:RMX(?:18(0[13579]|11|3[13]|2[1257]|[45]1|53|45)|19(03|4[1235]|19|9[23]|2[1579]|[01379]1|73)|20(?:[025-7]1|42|[0357]2|03|2[257]|63|7[56]|63L1|8[1356]|[2-5]0)|21(?:0[13]|1[27]|[12]1|4[24]|5[156]|6[13]|7[036]|8[0359]|9[345])|220[0125]|30(?:[3468]1|4[23]|9[23]|63|85)|31(?:15|2[125]|42|51|6[16]|71|9[1357])|32(?:0[13]|35|42|[346]1|6[0235689]|86)|33(?:[0157]0|[17]2|71|6[036]|[0186]1|57|88|9[12356])|34(?:30|78|[69]1|[67]2|7[145]|9[23])|35(?:0[1236]|1[12367]|21|[578]1|6[0123]|7[246])|36(?:1[0125789]|[39]0|36|2[347](?:_Natv_vf)?|8[67]|6[013])|37(?:0[0689]|6[125]|[14-7]0|[0457]1|8[01235])|38(?:[039]0|2[03]|34|4[01234]|5[0123]|6[789]|7[01]|88)|39(?:10|2[01]|3[0389]|4[013-6]|5[012]|8[87]|9[0325-9])|50(?:0[0234]|1[01]|20|3[0-3]|5[01456]|6[012]|7[0189]|8[05]|90)|51(?:0[16]|1[016])|53(?:03|13)|5250|6688)|(?:OPPO[ _]?)?CPH1861|RMP220[45]|RMP210[235-8]|4K Google TV Stick)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RMX3844",
                "model": "P1 Pro 5G"
            },
            {
                "regex": "RMX5004",
                "model": "P1 Speed 5G"
            },
            {
                "regex": "RMX3870",
                "model": "P1 5G"
            },
            {
                "regex": "RMX3987",
                "model": "P2 Pro 5G"
            },
            {
                "regex": "RMX503[01]",
                "model": "P3 Ultra 5G"
            },
            {
                "regex": "RMX5079",
                "model": "P3 5G"
            },
            {
                "regex": "RMX3944",
                "model": "P3x 5G"
            },
            {
                "regex": "RMX5032",
                "model": "P3 Pro 5G"
            },
            {
                "regex": "RMX5116",
                "model": "P4 Pro 5G"
            },
            {
                "regex": "RMX5110",
                "model": "P4 5G"
            },
            {
                "regex": "RMX3834",
                "model": "Note 50"
            },
            {
                "regex": "RMX370[68]",
                "model": "GT Neo 5"
            },
            {
                "regex": "RMX3852",
                "model": "GT Neo 6"
            },
            {
                "regex": "RMX38(?:51|00)",
                "model": "GT 6"
            },
            {
                "regex": "RMX3853",
                "model": "GT 6T"
            },
            {
                "regex": "RMX501[01]",
                "model": "GT 7 Pro"
            },
            {
                "regex": "RMX(?:6688|5061)",
                "model": "GT 7"
            },
            {
                "regex": "RMX5085",
                "model": "GT 7T"
            },
            {
                "regex": "RMX3850",
                "model": "GT Neo 6 SE"
            },
            {
                "regex": "RMX3700",
                "model": "GT Neo 5 SE"
            },
            {
                "regex": "RMX5060",
                "model": "Neo 7"
            },
            {
                "regex": "RMX5062",
                "model": "Neo 7 Turbo"
            },
            {
                "regex": "RMX5071",
                "model": "Neo 7x"
            },
            {
                "regex": "RMX5080",
                "model": "Neo 7 SE"
            },
            {
                "regex": "(?:OPPO[ _]?)?RMX3142(?:[);/ ]|$)",
                "model": "Q3 Pro Play"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1861(?:[);/ ]|$)",
                "model": "1"
            },
            {
                "regex": "RMX3663",
                "model": "10 Pro"
            },
            {
                "regex": "RMX180[59]",
                "model": "2"
            },
            {
                "regex": "RMX180[137]",
                "model": "2 Pro"
            },
            {
                "regex": "RMX(?:182[125])",
                "model": "3"
            },
            {
                "regex": "RMX1827",
                "model": "3i"
            },
            {
                "regex": "RMX185[13]",
                "model": "3 Pro"
            },
            {
                "regex": "RMX190[13]|Realme X(?:[);/ ]|$)",
                "model": "X"
            },
            {
                "regex": "RMX199[12]",
                "model": "X2"
            },
            {
                "regex": "RMX1993",
                "model": "X2 Dual"
            },
            {
                "regex": "RMX1931|Realme X2 Pro(?:[);/ ]|$)",
                "model": "X2 Pro"
            },
            {
                "regex": "RMX2117",
                "model": "Q2 5G"
            },
            {
                "regex": "RMX2173",
                "model": "Q2 Pro"
            },
            {
                "regex": "RMX2205",
                "model": "Q3 Pro 5G"
            },
            {
                "regex": "RMX3161",
                "model": "Q3 5G"
            },
            {
                "regex": "RMX3462",
                "model": "Q3t"
            },
            {
                "regex": "RMX3372",
                "model": "Q5 Pro"
            },
            {
                "regex": "RMX3478",
                "model": "Q5"
            },
            {
                "regex": "RMX3574",
                "model": "Q5i"
            },
            {
                "regex": "RMX2176(?:[);/ ]|$)",
                "model": "X7 5G"
            },
            {
                "regex": "RMX2121(?:[);/ ]|$)",
                "model": "X7 Pro 5G"
            },
            {
                "regex": "RMX1921|Realme XT(?:[);/ ]|$)",
                "model": "XT"
            },
            {
                "regex": "RMX19(1[19]|27)",
                "model": "5"
            },
            {
                "regex": "RMX197[13]",
                "model": "5 Pro"
            },
            {
                "regex": "RMX203[02]",
                "model": "5i"
            },
            {
                "regex": "RMX1929",
                "model": "5s"
            },
            {
                "regex": "RMX200[13]",
                "model": "6"
            },
            {
                "regex": "RMX204[02]",
                "model": "6i"
            },
            {
                "regex": "RMX2002",
                "model": "6S"
            },
            {
                "regex": "RMX206[13](?:L1)?(?:[);/ ]|$)",
                "model": "6 Pro"
            },
            {
                "regex": "RMX215[15]",
                "model": "7"
            },
            {
                "regex": "RMX2103",
                "model": "7I"
            },
            {
                "regex": "RMX2170",
                "model": "7 Pro"
            },
            {
                "regex": "RMX3115",
                "model": "X7 Pro Extreme Edition"
            },
            {
                "regex": "RMX3081",
                "model": "8 Pro"
            },
            {
                "regex": "RMX3085|Realme 8(?:[);/ ]|$)",
                "model": "8"
            },
            {
                "regex": "RMX3151|Realme 8i(?:[);/ ]|$)",
                "model": "8i"
            },
            {
                "regex": "RMX3381",
                "model": "8s"
            },
            {
                "regex": "RMX3241",
                "model": "8 5G"
            },
            {
                "regex": "RMX349[123]",
                "model": "9i"
            },
            {
                "regex": "RMX3612",
                "model": "9i 5G"
            },
            {
                "regex": "RMX3521",
                "model": "9"
            },
            {
                "regex": "RMX3388|RMX3474",
                "model": "9 5G"
            },
            {
                "regex": "RMX339[23]",
                "model": "9 Pro+ 5G"
            },
            {
                "regex": "RMX347[12]",
                "model": "9 Pro 5G"
            },
            {
                "regex": "RMX36(?:30|15)",
                "model": "10"
            },
            {
                "regex": "RMX3617",
                "model": "10s"
            },
            {
                "regex": "RMX366[01]",
                "model": "10 Pro 5G"
            },
            {
                "regex": "RMX368[67]",
                "model": "10 Pro+ 5G"
            },
            {
                "regex": "RMX3741",
                "model": "11 Pro+ 5G"
            },
            {
                "regex": "RMX3740",
                "model": "11 Pro+"
            },
            {
                "regex": "RMX3771",
                "model": "11 Pro 5G"
            },
            {
                "regex": "RMX3770",
                "model": "11 Pro"
            },
            {
                "regex": "RMX3785",
                "model": "11x 5G"
            },
            {
                "regex": "RMX3(?:636|751)",
                "model": "11"
            },
            {
                "regex": "RMX3780",
                "model": "11 5G"
            },
            {
                "regex": "RMX3842",
                "model": "12 Pro 5G"
            },
            {
                "regex": "RMX3843",
                "model": "12 Pro"
            },
            {
                "regex": "RMX3841",
                "model": "12 Pro+"
            },
            {
                "regex": "RMX3840",
                "model": "12 Pro+ 5G"
            },
            {
                "regex": "RMX3867",
                "model": "12+ 5G"
            },
            {
                "regex": "RMX399[29]",
                "model": "12 5G"
            },
            {
                "regex": "RMX3871",
                "model": "12"
            },
            {
                "regex": "RMX3998",
                "model": "12x 5G"
            },
            {
                "regex": "RMX3993",
                "model": "12x"
            },
            {
                "regex": "RMX5002",
                "model": "13 Pro"
            },
            {
                "regex": "RMX39(?:88|90)",
                "model": "13 Pro 5G"
            },
            {
                "regex": "RMX392[01]",
                "model": "13 Pro+ 5G"
            },
            {
                "regex": "RMX5000",
                "model": "13+ 5G"
            },
            {
                "regex": "RMX3951",
                "model": "13 5G"
            },
            {
                "regex": "RMX3952",
                "model": "13"
            },
            {
                "regex": "RMX394[03]",
                "model": "14x 5G"
            },
            {
                "regex": "RMX5070",
                "model": "14 5G"
            },
            {
                "regex": "RMX5078",
                "model": "14T 5G"
            },
            {
                "regex": "RMX505[14]",
                "model": "14 Pro+ 5G"
            },
            {
                "regex": "RMX5050",
                "model": "14 Pro+"
            },
            {
                "regex": "RMX5056",
                "model": "14 Pro 5G"
            },
            {
                "regex": "RMX5055",
                "model": "14 Pro"
            },
            {
                "regex": "RMX5106",
                "model": "15 5G"
            },
            {
                "regex": "RMX5101",
                "model": "15 Pro 5G"
            },
            {
                "regex": "RMX5111",
                "model": "15T"
            },
            {
                "regex": "RMX5250",
                "model": "15x 5G"
            },
            {
                "regex": "RMX1925",
                "model": "5S"
            },
            {
                "regex": "RMX1811",
                "model": "C1"
            },
            {
                "regex": "RMX194[1235]",
                "model": "C2"
            },
            {
                "regex": "(?:RMX202[1207]|Realme G70 Series)(?:[);/ ]|$)",
                "model": "C3"
            },
            {
                "regex": "RMX2185",
                "model": "C11"
            },
            {
                "regex": "RMX2189",
                "model": "C12"
            },
            {
                "regex": "RMX218[03]",
                "model": "C15"
            },
            {
                "regex": "RMX219[45]",
                "model": "C15 Qualcomm Edition"
            },
            {
                "regex": "RMX2101(?:[);/ ]|$)",
                "model": "C17"
            },
            {
                "regex": "RMX306[13]",
                "model": "C20"
            },
            {
                "regex": "RMX320[13]",
                "model": "C21"
            },
            {
                "regex": "RMX326[123]",
                "model": "C21Y"
            },
            {
                "regex": "RMX319[13]|realme C25 Series",
                "model": "C25"
            },
            {
                "regex": "RMX319[57]",
                "model": "C25s"
            },
            {
                "regex": "RMX326[589]",
                "model": "C25Y"
            },
            {
                "regex": "RMX350[123]",
                "model": "C31"
            },
            {
                "regex": "RMX(?:3581|3623)",
                "model": "C30"
            },
            {
                "regex": "RMX3690",
                "model": "C30s"
            },
            {
                "regex": "RMX362[47]",
                "model": "C33"
            },
            {
                "regex": "RMX351[123]",
                "model": "C35"
            },
            {
                "regex": "RMX3710",
                "model": "C55"
            },
            {
                "regex": "RMX3830",
                "model": "C51"
            },
            {
                "regex": "RMX3765",
                "model": "C51s"
            },
            {
                "regex": "RMX376[02]",
                "model": "C53"
            },
            {
                "regex": "RMX393[09]",
                "model": "C61"
            },
            {
                "regex": "RMX3950",
                "model": "C63 5G"
            },
            {
                "regex": "RMX3910",
                "model": "C65"
            },
            {
                "regex": "RMX3890",
                "model": "C67"
            },
            {
                "regex": "RMX3782",
                "model": "Narzo 60x"
            },
            {
                "regex": "RMX3997",
                "model": "C65 5G"
            },
            {
                "regex": "RMX3941",
                "model": "C75"
            },
            {
                "regex": "RMX5303",
                "model": "C71"
            },
            {
                "regex": "RMX3945",
                "model": "C73 5G"
            },
            {
                "regex": "RMX5020",
                "model": "C75x"
            },
            {
                "regex": "RMX3231",
                "model": "C11 (2021)"
            },
            {
                "regex": "RMX5090",
                "model": "GT 7 Pro"
            },
            {
                "regex": "RMX382[03]",
                "model": "GT 5"
            },
            {
                "regex": "RMX3888",
                "model": "GT 5 Pro"
            },
            {
                "regex": "RMX3709",
                "model": "GT 3"
            },
            {
                "regex": "RMX330[01]",
                "model": "GT 2 Pro"
            },
            {
                "regex": "RMX331[012]",
                "model": "GT 2"
            },
            {
                "regex": "RMX3551",
                "model": "GT 2 Explorer Master"
            },
            {
                "regex": "RMX3031",
                "model": "GT Neo"
            },
            {
                "regex": "RMX3370",
                "model": "GT Neo 2"
            },
            {
                "regex": "RMX356[012]",
                "model": "GT Neo 3"
            },
            {
                "regex": "RMX3563",
                "model": "GT Neo 3 150W"
            },
            {
                "regex": "RMX3371(?:[);/ ]|$)",
                "model": "GT Neo 3T"
            },
            {
                "regex": "RMX3357(?:[);/ ]|$)",
                "model": "GT Neo 2T"
            },
            {
                "regex": "RMX3701",
                "model": "GT Neo 5 SE"
            },
            {
                "regex": "RMX336[0136]",
                "model": "GT Master Edition"
            },
            {
                "regex": "RMX3350(?:[);/ ]|$)",
                "model": "GT Neo Flash"
            },
            {
                "regex": "RMX216[13](?:[);/ ]|$)",
                "model": "Narzo 20 Pro"
            },
            {
                "regex": "RMX2193",
                "model": "Narzo 20"
            },
            {
                "regex": "RMX2050",
                "model": "Narzo 20A"
            },
            {
                "regex": "RMX3171",
                "model": "Narzo 30A"
            },
            {
                "regex": "RMX2156",
                "model": "Narzo 30"
            },
            {
                "regex": "RMX3242",
                "model": "Narzo 30 5G"
            },
            {
                "regex": "RMX3430",
                "model": "Narzo 50A"
            },
            {
                "regex": "RMX3286",
                "model": "Narzo 50"
            },
            {
                "regex": "RMX3572",
                "model": "Narzo 50 5G"
            },
            {
                "regex": "RMX3395",
                "model": "Narzo 50 Pro"
            },
            {
                "regex": "RMX3396",
                "model": "Narzo 50 Pro 5G"
            },
            {
                "regex": "RMX351[67]",
                "model": "Narzo 50A Prime"
            },
            {
                "regex": "RMX3235",
                "model": "Narzo 50i"
            },
            {
                "regex": "RMX3506",
                "model": "Narzo 50i Prime"
            },
            {
                "regex": "RMX3750",
                "model": "Narzo 60 5G"
            },
            {
                "regex": "RMX3869",
                "model": "Narzo 70 5G"
            },
            {
                "regex": "RMX5003",
                "model": "Narzo 70 Turbo 5G"
            },
            {
                "regex": "RMX3868",
                "model": "Narzo 70 Pro 5G"
            },
            {
                "regex": "RMX5033",
                "model": "Narzo 80 Pro 5G"
            },
            {
                "regex": "RMX3761",
                "model": "Narzo N53"
            },
            {
                "regex": "RMX3933",
                "model": "Note 60"
            },
            {
                "regex": "RMX183[13](?:[);/ ]|$)",
                "model": "U1"
            },
            {
                "regex": "RMX(?:20(?:51|[2]5)|2144)(?:[);/ ]|$)",
                "model": "X50 5G"
            },
            {
                "regex": "RMX2052(?:[);/ ]|$)",
                "model": "X50t 5G"
            },
            {
                "regex": "RMX2071(?:[);/ ]|$)",
                "model": "X50 Pro"
            },
            {
                "regex": "RMX207[56](?:[);/ ]|$)",
                "model": "X50 Pro 5G"
            },
            {
                "regex": "RMX2072(?:[);/ ]|$)",
                "model": "X50 Pro Player"
            },
            {
                "regex": "RMX(2142|2081)(?:[);/ ]|$)",
                "model": "X3"
            },
            {
                "regex": "RMX208[56]",
                "model": "X3 Super Zoom"
            },
            {
                "regex": "RMX2083",
                "model": "X3"
            },
            {
                "regex": "Realme X7 Max 5G",
                "model": "X7 Max 5G"
            },
            {
                "regex": "RMX346[12]",
                "model": "Q3s"
            },
            {
                "regex": "RMX211[12]",
                "model": "V5 5G"
            },
            {
                "regex": "RMX220[01]",
                "model": "V3 5G"
            },
            {
                "regex": "RMX3618",
                "model": "V30"
            },
            {
                "regex": "RMX312[12]",
                "model": "V11 5G"
            },
            {
                "regex": "RMX3125",
                "model": "V11s 5G"
            },
            {
                "regex": "RMX304[123]",
                "model": "V13 5G"
            },
            {
                "regex": "RMX309[23]",
                "model": "V15 5G"
            },
            {
                "regex": "RMX361[01]",
                "model": "V20"
            },
            {
                "regex": "RMX3571",
                "model": "V23"
            },
            {
                "regex": "RMX3576",
                "model": "V23i"
            },
            {
                "regex": "RMX3475",
                "model": "V25"
            },
            {
                "regex": "RMX3619",
                "model": "V30"
            },
            {
                "regex": "RMX3783",
                "model": "V50s"
            },
            {
                "regex": "RMX3781",
                "model": "V50s"
            },
            {
                "regex": "RMX3995",
                "model": "V60"
            },
            {
                "regex": "RMX3996",
                "model": "V60s"
            },
            {
                "regex": "RMX3946",
                "model": "V70"
            },
            {
                "regex": "RMX2202",
                "model": "GT 5G"
            },
            {
                "regex": "RMX3938",
                "model": "Note 60x"
            },
            {
                "regex": "RMX5313",
                "model": "Note 70T"
            },
            {
                "regex": "Realme[ _]([1-9])[ _]Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "RMP210[23](?:[);/ ]|$)",
                "device": "tablet",
                "model": "Pad"
            },
            {
                "regex": "RMP220[45]",
                "device": "tablet",
                "model": "Pad 2"
            },
            {
                "regex": "RMP210[78]",
                "device": "tablet",
                "model": "Pad X"
            },
            {
                "regex": "RMP210[56](?:[);/ ]|$)",
                "device": "tablet",
                "model": "Pad Mini"
            },
            {
                "regex": "4K Google TV Stick",
                "device": "tv",
                "model": "4K Google TV Stick"
            }
        ]
    },
    "OPPO": {
        "regex": "(?:OB-)?OPPO[ _]?([a-z0-9]+)|N1T|R8001|R820[16]|A101OP|OPG0[1-4]|A00[12]OP|(?:X90[07][0679]|U70[57]T?|X909T?|R(?:10[01]1|2001|201[07]|6007|7005|7007|80[13579]|81[13579]|82[01379]|83[013]|800[067]|8015|810[679]|811[13]|820[057]|15 Neo)[KLSTW]?|N520[79]|N5117|A33[wf]|A33fw|A37fw?|PAAM00|A303OP|PAAT00|PAC[TM]00|R7kf|R7plus[fmt]?|A1601|CPH[0-9]{4}|CPH19(69|79|23|1[179])|PB(A[TM]00|CT10|BT30|CM[13]0|[FD]M00)|P(E[RFHG]M\\d{2}|E[GH]T\\d{2}|DAM10|ADM00|AF[TM]00|ADT00|AHM00|BBM[03]0|BBT00|BDT00|BFT00|[CB]E[MT]00|CA[MT]00|C[CDG]M00|CA[MT]10|[CD]PM00|CRM00|CDT00|CD[TM]10|CHM[013]0|CKM[08]0|CLM[15]0|DEM[13]0|DHM00|D[RK][TM]00|DPT00|DB[TM]00|DCM00|[CD]NM00|DVM00|DY[TM][12]0|DNT00|EA[TM]00|CRT01|EDM00)|PFDM00|PEG[MT]10|PEM[MT][02]0|PDCT00|PDET10|PDS[TM]00|PEC[MT]30|PE[QYPEXNLU]M00|PCHT[13]0|PCRT00|PFGM00|PF[VU]M10|A102OP|PFCM00|PFJM10|PGCM10|PECM20|PDAT10|A103OP|PCCT00|PFTM[12]0|PFFM20|OW19W[123]|OW20W1|PGJM10|PGAM10|PF[EF]M10|Reno ?(?:[4567]|Ace|1[012])|Find X[23]|Find N| R7sf| 1201|[56].*; (?:R7[gf])|OPD(?:210[12]A?|220[12]|230[123]|240[19])|PFZM10|PGIM10|A1603|A201OP|PESM10|PGBM10|PH[WQJMU]110|PH[AY]120|PGGM10|PG[WX]110|PGU110|PCCM40|PGT110|PGEM10|RX17Neo|R15 Dream Mirror|R9 Plustm A|PGFM10|A301OP|P(?:J[CGJSU]|H[FVSTNYZ])110|K9 Pro 5G| K9[xs]|CPH1821EX|PJ[HYBVRW]110|CHP(?:1723|2219|2365)|PKD130|RX17Pro|F7 Youth|A302OP|PJT110|PK[ABCDVJHPLKSTMZQUW]110|PL[ABEDJN]110|PKC130|PJU110_A1|PHJ110_A1|PKH120|PERM10_K10)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PCH[TM]10(?:[);/ ]|$)",
                "model": "A11"
            },
            {
                "regex": "PHQ110(?:[);/ ]|$)",
                "model": "A1 Pro"
            },
            {
                "regex": "PJU110_A1",
                "model": "A1x 5G"
            },
            {
                "regex": "PJU110|PJS110|PHJ110_A1",
                "model": "A2x 5G"
            },
            {
                "regex": "CPH2681|PKD130",
                "model": "A3x 5G"
            },
            {
                "regex": "CPH2641",
                "model": "A3x"
            },
            {
                "regex": "CPH2725",
                "model": "A5x"
            },
            {
                "regex": "PKW110",
                "model": "A5x 5G"
            },
            {
                "regex": "PJB110",
                "model": "A2 5G"
            },
            {
                "regex": "PKD110",
                "model": "A3 Energy"
            },
            {
                "regex": "PKA110|CPH2693",
                "model": "A3 5G"
            },
            {
                "regex": "PKL110",
                "model": "A3i 5G"
            },
            {
                "regex": "PJY110|CPH2665|CPH2639",
                "model": "A3 Pro 5G"
            },
            {
                "regex": "CPH2711",
                "model": "A5 Pro"
            },
            {
                "regex": "PKP110|CPH2695",
                "model": "A5 Pro 5G"
            },
            {
                "regex": "PLN110",
                "model": "A6 Pro 5G"
            },
            {
                "regex": "PCHT30(?:[);/ ]|$)",
                "model": "A11x"
            },
            {
                "regex": "(?:CPH2083|CPH2077)(?:[);/ ]|$)",
                "model": "A12"
            },
            {
                "regex": "(?:CPH2179)(?:[);/ ]|$)",
                "model": "A15s"
            },
            {
                "regex": "(?:CPH2271)(?:[);/ ]|$)",
                "model": "A16s"
            },
            {
                "regex": "CPH2421",
                "model": "A16e"
            },
            {
                "regex": "CPH2349|CPH2351",
                "model": "A16k"
            },
            {
                "regex": "CPH2477",
                "model": "A17"
            },
            {
                "regex": "CPH2471",
                "model": "A17k"
            },
            {
                "regex": "CPH2185",
                "model": "A15"
            },
            {
                "regex": "PCHM00",
                "model": "A11x"
            },
            {
                "regex": "CPH1923",
                "model": "A1k"
            },
            {
                "regex": "CPH2071",
                "model": "A11k"
            },
            {
                "regex": "CPH1925",
                "model": "A1s"
            },
            {
                "regex": "CPH22(?:69|75)(?:[);/ ]|$)",
                "model": "A16"
            },
            {
                "regex": "CPH2591",
                "model": "A18"
            },
            {
                "regex": "(?:OPPO[ _]?)?(CPH1837|CPH2669|PAD[TM]00)(?:[);/ ]|$)",
                "model": "A3"
            },
            {
                "regex": "(?:OPPO[ _]?)?A37f(w)(?:[);/ ]|$)",
                "model": "A37f$1"
            },
            {
                "regex": "A37f(?:[);/ ]|$)",
                "model": "A37f"
            },
            {
                "regex": "CPH2579(?:[);/ ]|$)",
                "model": "A38"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1605(?:[);/ ]|$)",
                "model": "A39"
            },
            {
                "regex": "PESM10(?:[);/ ]|$)",
                "model": "A36"
            },
            {
                "regex": "CPH20(?:81|73|31|15)(?:[);/ ]|$)",
                "model": "A31"
            },
            {
                "regex": "CPH2137(?:[);/ ]|$)",
                "model": "A33"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH18(?:0[35]|53)|PBBM30)(?:[);/ ]|$)",
                "model": "A3s"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1809|PBA[TM]00|PBBT30)(?:[);/ ]|$)",
                "model": "A5"
            },
            {
                "regex": "PKV110",
                "model": "A5 Energy"
            },
            {
                "regex": "PKQ110",
                "model": "A5 5G"
            },
            {
                "regex": "CPH19(?:3[13]|43)(?:[);/ ]|$)",
                "model": "A5 (2020)"
            },
            {
                "regex": "(?:PEC[MT]30|PECM20)(?:[);/ ]|$)",
                "model": "A53 5G"
            },
            {
                "regex": "PDVM00(?:[);/ ]|$)",
                "model": "A32"
            },
            {
                "regex": "PEFM00(?:[);/ ]|$)",
                "model": "A35"
            },
            {
                "regex": "(?:PDA[TM]10|CPH2069|CPH2061)(?:[);/ ]|$)",
                "model": "A52"
            },
            {
                "regex": "CPH(?:2127|213[19])(?:[);/ ]|$)",
                "model": "A53"
            },
            {
                "regex": "CPH2135(?:[);/ ]|$)",
                "model": "A53s"
            },
            {
                "regex": "CPH2321(?:[);/ ]|$)",
                "model": "A53s 5G"
            },
            {
                "regex": "(?:CPH2195|OPG02|CPH2303)(?:[);/ ]|$)",
                "model": "A54 5G"
            },
            {
                "regex": "(?:CPH2239|CPH2241)(?:[);/ ]|$)",
                "model": "A54"
            },
            {
                "regex": "CPH2273(?:[);/ ]|$)",
                "model": "A54s"
            },
            {
                "regex": "PEM[MT][02]0(?:[);/ ]|$)",
                "model": "A55 5G"
            },
            {
                "regex": "CPH2325",
                "model": "A55"
            },
            {
                "regex": "CPH2631|CPH3669",
                "model": "A60"
            },
            {
                "regex": "CPH2683",
                "model": "A60 5G"
            },
            {
                "regex": "(?:A102OP|CPH2309)(?:[);/ ]|$)",
                "model": "A55s 5G"
            },
            {
                "regex": "PFVM10",
                "model": "A56 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH170[15]|CPH2407)(?:[);/ ]|$)",
                "model": "A57"
            },
            {
                "regex": "PFTM20|CPH2387",
                "model": "A57 (2022)"
            },
            {
                "regex": "PHJ110",
                "model": "A1x 5G"
            },
            {
                "regex": "CPH2577",
                "model": "A58"
            },
            {
                "regex": "PFTM10",
                "model": "A97"
            },
            {
                "regex": "PHA120",
                "model": "A96"
            },
            {
                "regex": "CPH19(?:09|1[02])(?:[);/ ]|$)",
                "model": "A5S"
            },
            {
                "regex": "CPH2773",
                "model": "A5i"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH190[15]|PBF[TM]00)(?:[);/ ]|$)",
                "model": "A7"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1717(?:[);/ ]|$)",
                "model": "A71"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1801(?:[);/ ]|$)",
                "model": "A71 (2018)"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDY[TM]20|CPH2067)(?:[);/ ]|$)",
                "model": "A72"
            },
            {
                "regex": "CPH(?:2161|2099)(?:[);/ ]|$)",
                "model": "A73 5G"
            },
            {
                "regex": "(?:CHP|CPH)2219(?:[);/ ]|$)",
                "model": "A74"
            },
            {
                "regex": "CPH2263(?:[);/ ]|$)",
                "model": "A74 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDY[TM]10)(?:[);/ ]|$)",
                "model": "A72n 5G"
            },
            {
                "regex": "CPH2375",
                "model": "A76"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1715)(?:[);/ ]|$)",
                "model": "A77"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2339|CPH2385)",
                "model": "A77 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2495|CPH2483)",
                "model": "A78 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2565",
                "model": "A78"
            },
            {
                "regex": "(?:OPPO[ _]?)?A79kt",
                "model": "A79"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH255[37]|A303OP)",
                "model": "A79 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2473",
                "model": "A77s"
            },
            {
                "regex": "PCD[TM]00(?:[);/ ]|$)",
                "model": "A7n"
            },
            {
                "regex": "(PBBT00|PBBM00)(?:[);/ ]|$)",
                "model": "A7x"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDBM00)(?:[);/ ]|$)",
                "model": "A8"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1729(?:[);/ ]|$)",
                "model": "A83"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1827(?:[);/ ]|$)",
                "model": "A83 (2018)"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PCA[TM]10|CPH193[89])(?:[);/ ]|$)",
                "model": "A9"
            },
            {
                "regex": "(CPH1937|CPH1941|PCHM30)(?:[);/ ]|$)",
                "model": "A9 (2020)"
            },
            {
                "regex": "(?:PCPM00|CPH20[02]1)(?:[);/ ]|$)",
                "model": "A91"
            },
            {
                "regex": "CPH2059(?:[);/ ]|$)",
                "model": "A92"
            },
            {
                "regex": "PDK[TM]00(?:[);/ ]|$)",
                "model": "A92s"
            },
            {
                "regex": "(?:PEH[MT]00|CPH212[13])(?:[);/ ]|$)",
                "model": "A93"
            },
            {
                "regex": "(?:PFGM00)(?:[);/ ]|$)",
                "model": "A93s"
            },
            {
                "regex": "PFUM10",
                "model": "A96 5G"
            },
            {
                "regex": "CPH2529",
                "model": "A98 5G"
            },
            {
                "regex": "CPH2203(?:[);/ ]|$)",
                "model": "A94"
            },
            {
                "regex": "CPH2333(?:[);/ ]|$)",
                "model": "A96"
            },
            {
                "regex": "(?:CPH2197)(?:[);/ ]|$)",
                "model": "A74 5G"
            },
            {
                "regex": "PELM00",
                "model": "A95 5G"
            },
            {
                "regex": "CHP2365|CPH2365",
                "model": "A95 4G"
            },
            {
                "regex": "PCE[TM]00(?:[);/ ]|$)",
                "model": "A9x"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1851(?:[);/ ]|$)",
                "model": "AX5"
            },
            {
                "regex": "CPH1920(?:[);/ ]|$)",
                "model": "AX5s"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1903(?:[);/ ]|$)",
                "model": "AX7"
            },
            {
                "regex": "CPH2341",
                "model": "F21 Pro"
            },
            {
                "regex": "CPH2455|CPH2461",
                "model": "F21s Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?X9009(?:[);/ ]|$)",
                "model": "F1 Plus"
            },
            {
                "regex": "CPH2527",
                "model": "F23 5G"
            },
            {
                "regex": "CPH2603",
                "model": "Reno 11 F"
            },
            {
                "regex": "CPH2643",
                "model": "F27 Pro+ 5G"
            },
            {
                "regex": "CPH191[135](?:[);/ ]|$)",
                "model": "F11"
            },
            {
                "regex": "CPH19(?:69|87)(?:[);/ ]|$)",
                "model": "F11 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2095",
                "model": "F17"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2119)(?:[);/ ]|$)",
                "model": "F17 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?A1601(?:[);/ ]|$)",
                "model": "F1s"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1609(?:[);/ ]|$)",
                "model": "F3"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1613(?:[);/ ]|$)",
                "model": "F3 Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH172[37]|CHP1723)(?:[);/ ]|$)",
                "model": "F5"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1725(?:[);/ ]|$)",
                "model": "F5 Youth"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH18(?:[15]9|21|21EX)(?:[);/ ]|$)",
                "model": "F7"
            },
            {
                "regex": "F7 Youth",
                "model": "F7 Youth"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1825|CPH1881)(?:[);/ ]|$)",
                "model": "F9"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1823(?:[);/ ]|$)",
                "model": "F9 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2223(?:[);/ ]|$)",
                "model": "F19s"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2285|F19 Pro)(?:[);/ ]|$)",
                "model": "F19 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2213(?:[);/ ]|$)",
                "model": "F19 Pro Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?X909T?(?:[);/ ]|$)",
                "model": "Find 5"
            },
            {
                "regex": "(?:OPPO[ _]?)?R827T?(?:[);/ ]|$)",
                "model": "Find 5 Mini"
            },
            {
                "regex": "(?:OPPO[ _]?)?X907[067](?:[);/ ]|$)",
                "model": "Find 7"
            },
            {
                "regex": "(?:OPPO[ _]?)?X900[067](?:[);/ ]|$)",
                "model": "Find 7a"
            },
            {
                "regex": "(?:OPPO[ _]?)?PEUM00",
                "model": "Find N 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?Find N(?:[);/ ]|$)",
                "model": "Find N"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PGU110|CPH2439)(?:[);/ ]|$)",
                "model": "Find N2"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2437|PGT110)(?:[);/ ]|$)",
                "model": "Find N2 Flip"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2519|PHT110)(?:[);/ ]|$)",
                "model": "Find N3 Flip"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PHN110|CPH2499)",
                "model": "Find N3"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PKH1[12]0|CPH2671)",
                "model": "Find N5"
            },
            {
                "regex": "(?:OPPO[ _]?)?R815[TW]?(?:[);/ ]|$)",
                "model": "Find Clover"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8015(?:[);/ ]|$)",
                "model": "Find Guitar"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8111(?:[);/ ]|$)",
                "model": "Find Melody"
            },
            {
                "regex": "(?:OPPO[ _]?)?R821T?(?:[);/ ]|$)",
                "model": "Find Muse"
            },
            {
                "regex": "(?:OPPO[ _]?)?U707T?(?:[);/ ]|$)",
                "model": "Find Way S"
            },
            {
                "regex": "(?:OPPO[ _]?)?U705T(?:[);/ ]|$)",
                "model": "Ulike 2"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH187[15]|PAF[MT]00)(?:[);/ ]|$)",
                "model": "Find X"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PAHM00)(?:[);/ ]|$)",
                "model": "Find X Lamborghini"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDE[TM]10|CPH2023)(?:[);/ ]|$)",
                "model": "Find X2"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH2005|Find X2 Lite)(?:[);/ ]|$)",
                "model": "Find X2 Lite"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PDEM30|OPG01|CPH2025|Find X2 Pro)(?:[);/ ]|$)",
                "model": "Find X2 Pro"
            },
            {
                "regex": "PEDM00(?:[);/ ]|$)",
                "model": "Find X3"
            },
            {
                "regex": "Find X3 Neo(?:[);/ ]|$)",
                "model": "Find X3 Neo"
            },
            {
                "regex": "(?:PEEM00|CPH2173|OPG03|Find X3 Pro)(?:[);/ ]|$)",
                "model": "Find X3 Pro"
            },
            {
                "regex": "Find X3 Lite(?:[);/ ]|$)",
                "model": "Find X3 Lite"
            },
            {
                "regex": "CPH2307|PFFM10",
                "model": "Find X5"
            },
            {
                "regex": "CPH2305|PFEM10|PFFM20",
                "model": "Find X5 Pro"
            },
            {
                "regex": "PGEM10",
                "model": "Find X6 Pro"
            },
            {
                "regex": "PGFM10",
                "model": "Find X6"
            },
            {
                "regex": "PHZ110",
                "model": "Find X7"
            },
            {
                "regex": "PHY110",
                "model": "Find X7 Ultra"
            },
            {
                "regex": "PHY120",
                "model": "Find X7 Ultra SE"
            },
            {
                "regex": "PKC1[13]0|CPH2659",
                "model": "Find X8 Pro"
            },
            {
                "regex": "PK[JU]110",
                "model": "Find X8 Ultra"
            },
            {
                "regex": "CPH2651|PKB110",
                "model": "Find X8"
            },
            {
                "regex": "PKT110",
                "model": "Find X8s"
            },
            {
                "regex": "PLB110",
                "model": "Find X8s+"
            },
            {
                "regex": "(?:OPPO[ _]?)?R1011 Build",
                "model": "Joy Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PBC(?:M30|T10))(?:[);/ ]|$)",
                "model": "K1"
            },
            {
                "regex": "A1603(?:[);/ ]|$)",
                "model": "C1"
            },
            {
                "regex": "CPH1955(?:[);/ ]|$)",
                "model": "K3"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PCNM00)(?:[);/ ]|$)",
                "model": "K5"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PCLM50)(?:[);/ ]|$)",
                "model": "Reno 3 Youth"
            },
            {
                "regex": "(?:OPPO[ _]?)?(PERM00)(?:[);/ ]|$)",
                "model": "K7x"
            },
            {
                "regex": "(?:OPPO[ _]?)?PGCM10| K9x(?:[);/ ]|$)",
                "model": "K9x"
            },
            {
                "regex": "(?:OPPO[ _]?)?PGGM10",
                "model": "K10x"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH2373",
                "model": "K10"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:PGJM10|CPH2337|PERM10_K10)",
                "model": "K10 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PERM10| K9s(?:[);/ ]|$)",
                "model": "K9s"
            },
            {
                "regex": "(?:OPPO[ _]?)?PGIM10",
                "model": "K10 Pro 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PJC110",
                "model": "K11 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PLD110",
                "model": "K12s 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PHS110",
                "model": "A1 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PJG110",
                "model": "A2 Pro 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PHF110",
                "model": "K11x 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PJR110",
                "model": "K12 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?PKS110",
                "model": "K12 Plus"
            },
            {
                "regex": "CPH2667|PJT110",
                "model": "K12x 5G"
            },
            {
                "regex": "CPH2729",
                "model": "K13 5G"
            },
            {
                "regex": "PLE110",
                "model": "K13 Turbo Pro 5G"
            },
            {
                "regex": "(?:OPPO[ _]?)?N5117(?:[);/ ]|$)",
                "model": "N1 Mini"
            },
            {
                "regex": "(?:OPPO[ _]?)?N520[79](?:[);/ ]|$)",
                "model": "N3"
            },
            {
                "regex": "(?:OPPO[ _]?)?R831T?(?:[);/ ]|$)",
                "model": "Neo"
            },
            {
                "regex": "(?:OPPO[ _]?)?R831K(?:[);/ ]|$)",
                "model": "Neo 3"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:R831[SL]|1201)(?:[);/ ]|$)",
                "model": "Neo 5"
            },
            {
                "regex": "(?:OPPO[ _]?)?A33[wf](?:[);/ ]|$)",
                "model": "Neo 7"
            },
            {
                "regex": "(?:OPPO[ _]?)?A33fw(?:[);/ ]|$)",
                "model": "Neo 7s"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8113(?:[);/ ]|$)",
                "model": "Piano"
            },
            {
                "regex": "(?:OPPO[ _]?)?CPH1707(?:[);/ ]|$)",
                "model": "R11"
            },
            {
                "regex": "(?:OPPO[ _]?)?R11 Plusk?t?(?:[);/ ]|$)",
                "model": "R11 Plus"
            },
            {
                "regex": "R8001(?:[);/ ]|$)",
                "model": "R1K"
            },
            {
                "regex": "R820[16](?:[);/ ]|$)",
                "model": "R1x"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1721|R11s Plust?)(?:[);/ ]|$)",
                "model": "R11s Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1719|R11st?)(?:[);/ ]|$)",
                "model": "R11s"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1835|PAC[TM]00|PAAM00)(?:[);/ ]|$)",
                "model": "R15"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH183[13]|PAAT00)(?:[);/ ]|$)",
                "model": "R15 Pro"
            },
            {
                "regex": "PBCM10(?:[);/ ]|$)",
                "model": "R15x"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1879|PBE[MT]00)(?:[);/ ]|$)",
                "model": "R17"
            },
            {
                "regex": "RX17Neo",
                "model": "RX17 Neo"
            },
            {
                "regex": "R15 Dream Mirror",
                "model": "R15 Dream Mirror"
            },
            {
                "regex": "R15 Neo",
                "model": "R15 Neo"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1893)(?:[);/ ]|$)",
                "model": "R17 Neo"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1877|PBD[MT]00|RX17Pro)(?:[);/ ]|$)",
                "model": "R17 Pro"
            },
            {
                "regex": "(?:OPPO[ _]?)?R8006(?:[);/ ]|$)",
                "model": "R1L"
            },
            {
                "regex": "(?:OPPO[ _]?)?R800[07](?:[);/ ]|$)",
                "model": "R1S"
            },
            {
                "regex": "(?:OPPO[ _]?)?R810[679](?:[);/ ]|$)",
                "model": "R5"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7kf(?:[);/ ]|$)",
                "model": "R7 Lite"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7sPlus(?:[);/ ]|$)",
                "model": "R7s Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7sf(?:[);/ ]|$)",
                "model": "R7s"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7[gf](?:[);/ ]|$)",
                "model": "R7"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7Plus[mt]?(?:[);/ ]|$)",
                "model": "R7 Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?R7Plusf(?:[);/ ]|$)",
                "model": "R7 Plus F"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:X9079|R9 Plustm A)(?:[);/ ]|$)",
                "model": "R9 Plus"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1607|R9sk)(?:[);/ ]|$)",
                "model": "R9s"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1611|R9s Plus)(?:[);/ ]|$)",
                "model": "R9s Plus"
            },
            {
                "regex": "(?:CPH1917|PCA[MT]00)(?:[);/ ]|$)",
                "model": "Reno"
            },
            {
                "regex": "CPH1983(?:[);/ ]|$)",
                "model": "Reno A"
            },
            {
                "regex": "(?:CPH1919|PCCM00)(?:[);/ ]|$)",
                "model": "Reno 10X Zoom"
            },
            {
                "regex": "PCCT00",
                "model": "Reno 10X"
            },
            {
                "regex": "PHW110",
                "model": "Reno 10"
            },
            {
                "regex": "CPH2531",
                "model": "Reno 10 5G"
            },
            {
                "regex": "(?:CPH2525|PHV110|A302OP|Reno10 Pro)(?:[);/ ]|$)",
                "model": "Reno 10 Pro 5G"
            },
            {
                "regex": "CPH2521|PHU110",
                "model": "Reno 10 Pro+ 5G"
            },
            {
                "regex": "PJJ110|CPH2607|Reno 11 Pro",
                "model": "Reno 11 Pro"
            },
            {
                "regex": "Reno 11 F",
                "model": "Reno 11 F 5G"
            },
            {
                "regex": "CPH2599|PJH110",
                "model": "Reno 11"
            },
            {
                "regex": "PJ[VW]110",
                "model": "Reno 12"
            },
            {
                "regex": "CPH2625",
                "model": "Reno 12 5G"
            },
            {
                "regex": "CPH2637",
                "model": "Reno 12 F 5G"
            },
            {
                "regex": "CPH2687",
                "model": "Reno 12 F 4G"
            },
            {
                "regex": "CPH2629|Reno12 Pro",
                "model": "Reno 12 Pro 5G"
            },
            {
                "regex": "CPH2701",
                "model": "Reno 13 F"
            },
            {
                "regex": "PKM110",
                "model": "Reno 13"
            },
            {
                "regex": "CPH2699",
                "model": "Reno 13 F 5G"
            },
            {
                "regex": "CPH2689",
                "model": "Reno 13 5G"
            },
            {
                "regex": "CPH2697",
                "model": "Reno 13 Pro 5G"
            },
            {
                "regex": "PKK110",
                "model": "Reno 13 Pro"
            },
            {
                "regex": "PKZ110",
                "model": "Reno 14 Pro"
            },
            {
                "regex": "PLA110",
                "model": "Reno 14"
            },
            {
                "regex": "(?:PCKM00|CPH1907)(?:[);/ ]|$)",
                "model": "Reno 2"
            },
            {
                "regex": "CPH1989(?:[);/ ]|$)",
                "model": "Reno 2F"
            },
            {
                "regex": "(?:PCKM80|CPH1945|CPH1951)(?:[);/ ]|$)",
                "model": "Reno 2Z"
            },
            {
                "regex": "(?:CPH2043|PDCT00)(?:[);/ ]|$)",
                "model": "Reno 3"
            },
            {
                "regex": "(?:CPH2013|A002OP)(?:[);/ ]|$)",
                "model": "Reno 3A"
            },
            {
                "regex": "(?:PDCM00|A001OP|CPH2048)(?:[);/ ]|$)",
                "model": "Reno 3 5G"
            },
            {
                "regex": "(?:PCR[MT]00|CPH203[567]|CPH2009)",
                "model": "Reno 3 Pro"
            },
            {
                "regex": "PCRT01(?:[);/ ]|$)",
                "model": "Reno 3 Lite"
            },
            {
                "regex": "CPH2113(?:[);/ ]|$)",
                "model": "Reno 4 4G"
            },
            {
                "regex": "CPH2125(?:[);/ ]|$)",
                "model": "Reno 4 Lite"
            },
            {
                "regex": "(?:CPH2109|Reno 4 Pro)(?:[);/ ]|$)",
                "model": "Reno 4 Pro 4G"
            },
            {
                "regex": "(?:PDP[TM]00|CPH2091)(?:[);/ ]|$)",
                "model": "Reno 4 5G"
            },
            {
                "regex": "(?:PEA[TM]00|Reno4 SE 5G)(?:[);/ ]|$)",
                "model": "Reno 4 SE 5G "
            },
            {
                "regex": "(?:PDN[TM]00|CPH2089)(?:[);/ ]|$)",
                "model": "Reno 4 Pro 5G"
            },
            {
                "regex": "CPH2065|Reno4 Z 5G",
                "model": "Reno 4Z 5G"
            },
            {
                "regex": "CPH2209(?:[);/ ]|$)",
                "model": "Reno 4F"
            },
            {
                "regex": "(?:CPH2199|A10[13]OP)|Reno5 A 5G(?: Build|[;)])",
                "model": "Reno 5A"
            },
            {
                "regex": "CPH2205|Reno5 Lite(?: Build|[;)])",
                "model": "Reno 5 Lite"
            },
            {
                "regex": "(?:PEG[MT]00|CPH2145|Reno5 5G)(?:[);/ ]|$)",
                "model": "Reno 5 5G"
            },
            {
                "regex": "PEG[MT]10(?:[);/ ]|$)",
                "model": "Reno 5K"
            },
            {
                "regex": "Reno5 K 5G",
                "model": "Reno 5K 5G"
            },
            {
                "regex": "CPH2217(?:[);/ ]|$)",
                "model": "Reno 5F"
            },
            {
                "regex": "(?:CPH2211|Reno5 Z 5G)(?:[);/ ]|$)",
                "model": "Reno 5Z"
            },
            {
                "regex": "(?:PDS[TM]00|CPH220[17]|Reno5 Pro 5G)(?:[);/ ]|$)",
                "model": "Reno 5 Pro 5G"
            },
            {
                "regex": "PDR[TM]00(?:[);/ ]|$)",
                "model": "Reno 5 Pro Plus 5G"
            },
            {
                "regex": "(?:CPH1921|PCCM40)(?:[);/ ]|$)",
                "model": "Reno 5G"
            },
            {
                "regex": "CPH2159|(?:Reno5 4G|Reno 5)(?: Build|[;)])",
                "model": "Reno 5"
            },
            {
                "regex": "CPH2237|Reno6 Z 5G(?: Build|[;)])",
                "model": "Reno 6 Z 5G"
            },
            {
                "regex": "PEPM00(?:[);/ ]|$)",
                "model": "Reno 6 Pro"
            },
            {
                "regex": "CPH224[79]|Reno6 Pro 5G(?: Build|[;)])",
                "model": "Reno 6 Pro 5G"
            },
            {
                "regex": "PENM00(?:[);/ ]|$)",
                "model": "Reno 6 Pro Plus"
            },
            {
                "regex": "(?:CPH2235|PEQM00|CPH2251|Reno6 5G|Reno 6)(?:[);/ ]|$)",
                "model": "Reno 6"
            },
            {
                "regex": "PFJM10|CPH2371|CPH2363|Reno7(?: Build|[;)])",
                "model": "Reno 7"
            },
            {
                "regex": "CPH2343",
                "model": "Reno 7Z"
            },
            {
                "regex": "CPH2353|OPG04|A201OP",
                "model": "Reno 7A"
            },
            {
                "regex": "PFCM00|Reno7 SE(?: Build|[;)])",
                "model": "Reno 7 SE"
            },
            {
                "regex": "(?:PFDM00|CPH2293|Reno7 Pro)(?:[);/ ]|$)",
                "model": "Reno 7 Pro"
            },
            {
                "regex": "CPH2357|PGAM10",
                "model": "Reno 8 Pro 5G"
            },
            {
                "regex": "PFZM10",
                "model": "Reno 8 Pro+"
            },
            {
                "regex": "CPH2457",
                "model": "Reno 8 Z"
            },
            {
                "regex": "PGBM10|CPH2359",
                "model": "Reno 8 5G"
            },
            {
                "regex": "CPH2481|CPH2505",
                "model": "Reno 8T"
            },
            {
                "regex": "PHM110",
                "model": "Reno 9"
            },
            {
                "regex": "PGW110",
                "model": "Reno 9 Pro+"
            },
            {
                "regex": "PGX110",
                "model": "Reno 9 Pro"
            },
            {
                "regex": "CPH252[34]|A301OP",
                "model": "Reno 9 A"
            },
            {
                "regex": "(?:PEYM00|K9 Pro 5G)(?:[);/ ]|$)",
                "model": "K9 Pro 5G"
            },
            {
                "regex": "(?:PEXM00)(?:[);/ ]|$)",
                "model": "K9 5G"
            },
            {
                "regex": "Reno Ace 2 EVA",
                "model": "Reno Ace 2 EVA"
            },
            {
                "regex": "PCLM10(?:[);/ ]|$)",
                "model": "Reno Ace"
            },
            {
                "regex": "PDHM00(?:[);/ ]|$)",
                "model": "Reno Ace 2"
            },
            {
                "regex": "PCGM00(?:[);/ ]|$)",
                "model": "Reno K3"
            },
            {
                "regex": "(?:OPPO[ _]?)?(?:CPH1979|PCD[TM]10)(?:[);/ ]|$)",
                "model": "Reno Z"
            },
            {
                "regex": "A59st(?:[);/ ]|$)",
                "model": "A59s"
            },
            {
                "regex": "CPH2617",
                "model": "A59 5G"
            },
            {
                "regex": "OPPO ?(CNM632)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "OPD2102A?",
                "model": "Pad Air",
                "device": "tablet"
            },
            {
                "regex": "OPD2409",
                "model": "Pad 4 Pro",
                "device": "tablet"
            },
            {
                "regex": "OPD2401",
                "model": "Pad 3 Pro",
                "device": "tablet"
            },
            {
                "regex": "OPD2301",
                "model": "Pad Air 2",
                "device": "tablet"
            },
            {
                "regex": "OPD230[23]",
                "model": "Pad Neo",
                "device": "tablet"
            },
            {
                "regex": "OPD220[12]",
                "model": "Pad 2",
                "device": "tablet"
            },
            {
                "regex": "OPD2101",
                "model": "Pad WiFi",
                "device": "tablet"
            },
            {
                "regex": "OW19W[13]",
                "model": "Watch 46mm",
                "device": "wearable"
            },
            {
                "regex": "OW19W2",
                "model": "Watch 41mm",
                "device": "wearable"
            },
            {
                "regex": "OW20W1",
                "model": "Watch 2 46mm",
                "device": "wearable"
            },
            {
                "regex": "N1T?(?:[);/ ]|$)",
                "model": "N1T",
                "device": "phablet"
            },
            {
                "regex": "R([0-9]{3,4}[KSTW]?)(?:[);/ ]|$)",
                "model": "R$1"
            },
            {
                "regex": "(CPH[0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "(?:OB-)?OPPO[ _]?((?!Browser)[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Orange": {
        "regex": "SPV[ -]?([a-z0-9]+)|(?<!FBCR/)Orange[ _-](?!Tahiti-LS\\))([^/;]+)( Build|\\))(?<!Tahiti-LS\\))|SC/IHD92|Nura 2|FunTab ([^/;]+) Build|Orange[ _](?:Mahpee|Nevalink|Nevamini)|Dive 50|MouveTab7WIFI|(?:Sanza-)?M56[02]F3(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SC/IHD92",
                "device": "tv",
                "model": "Livebox Play"
            },
            {
                "regex": "Orange TV Box(?:[);/ ]|$)",
                "device": "tv",
                "model": "TV Box"
            },
            {
                "regex": "Orange_Nevalink(?:[);/ ]|$)",
                "model": "Neva Link"
            },
            {
                "regex": "Orange_Nevamini(?:[);/ ]|$)",
                "model": "Neva Mini"
            },
            {
                "regex": "Nola play",
                "model": "Nola Play"
            },
            {
                "regex": "Nola fun",
                "model": "Nola Fun"
            },
            {
                "regex": "Neva zen",
                "model": "Neva Zen"
            },
            {
                "regex": "Neva start",
                "model": "Neva Start"
            },
            {
                "regex": "Nura 2",
                "model": "Nura 2"
            },
            {
                "regex": "(?:Sanza-)?M56[02]F3",
                "model": "Sanza"
            },
            {
                "regex": "Sego",
                "model": "Sego",
                "device": "tablet"
            },
            {
                "regex": "FunTab ([^/;]+) Build",
                "model": "FunTab $1",
                "device": "tablet"
            },
            {
                "regex": "Orange Mouve 2",
                "device": "tablet",
                "model": "Mouve Tab II"
            },
            {
                "regex": "MouveTab7WIFI",
                "model": "Mouve Tab 7 WiFi",
                "device": "tablet"
            },
            {
                "regex": "orange_Tab_7_4G",
                "model": "Tab 7 4G",
                "device": "tablet"
            },
            {
                "regex": "Orange[ _-](Rise) ?(3[125]|5[12])(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "(?:Orange[ _-])?Dive ?(\\d+) Dual(?:[);/ ]|$)",
                "model": "Dive $1 Dual"
            },
            {
                "regex": "(?:Orange[ _-])?Dive ?(\\d+)(?:[);/ ]|$)",
                "model": "Dive $1"
            },
            {
                "regex": "Orange[ _-](Daytona|Dublin|Fova|Gova|Hi 4G|Hiro|Kivo|Monte Carlo|Neva 80|Neva play|Nura|Reyo|Rise[_ ](3[034]|40|5[345])|Rono|Roya|San Francisco|Tactile internet 2|Tado|Yomi|Yumo|Zali|Mahpee|Neva leaf|Sanza touch|Viking L508|Zilo)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SPV[ -]?([a-z0-9]+)",
                "model": "SPV $1"
            }
        ]
    },
    "Oukitel": {
        "regex": "OU[Kc]ITEL|(?:Android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:C19|C22)|Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:C11|U23)|Android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:K12)|Android 11(?:[\\d.]*);(?: [\\w-]+;)? (?:C25)|Android 12(?:[\\d.]*);(?: [\\w-]+;)? (?:C3[12])|Android 1[2-4](?:[\\d.]*);(?: [\\w-]+;)? (?:RT[89])|Android 1[23](?:[\\d.]*);(?: [\\w-]+;)? (?:K16|C51|C3[3568])|Android 7(?:[\\d.]*);(?: [\\w-]+;)? (?:U1[78]|U22)|(?:C1[569]|K10000|K[46]000)(?:[ _]Pro)|K4000Pro|C1[18]_Pro|C1[0237] Pro|C2[13] Pro|C12 Plus|[UK]15 Pro|K15_Plus|U16 Max|C11_F|U7 Max|U7 Plus|U11[_ ]Plus|U20_Plus|C21 Plus|OK6000 Plus|WP5000|WP[58] Pro|K[46]000[ _](?:Plus|Lite)|K9 Pro|Y4800|K10000|K7 Power|K[4-8]000| RT[12356]| OT[568]| C 38| OT11| WP(?:[125-79]|1[02356789]|2[0123678]|3[0235689]|5[02356]|300)|K[37]_Pro|WP32_Pro|WP100 TITAN|WP2[01]0 Pro|K13_Pro|U25_Pro|OKT[13]|UniverseTap|RT7 TITAN(?: 5G)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "WP(21|55) Ultra",
                "model": "WP$1 Ultra"
            },
            {
                "regex": "WP(28 [ES]|35 S|53 S)",
                "model": "WP$1"
            },
            {
                "regex": "WP100 TITAN",
                "model": "WP100 Titan"
            },
            {
                "regex": " C 38(?:[);/ ]|$)",
                "model": "C38"
            },
            {
                "regex": "(C1[0-9]|C2[13]|C31|K10000|K[46]000|WP\\d+|U[12]5|K[379]|K1[35])[ _]?Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "K7 Power(?:[);/ ]|$)",
                "model": "K7 Power"
            },
            {
                "regex": "(K10000|U16|U7)[ _]Max(?:[);/ ]|$)",
                "model": "$1 Max"
            },
            {
                "regex": "(U20|K[46]000|U7|U11|OK6000|K15|C12|C21|WP\\d+)[_ ]?Plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(K4000)[_ ]Lite(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "(K10000)[_ ]Mix(?:[);/ ]|$)",
                "model": "$1 Mix"
            },
            {
                "regex": "UniverseTap(?:[);/ ]|$)",
                "model": "U8 Universe Tap"
            },
            {
                "regex": "(?:Oukitel-)?(Y4800|K10000|K[4-8]000|WP5000|[CU]2|U1[078]|U2[23]|C1[19]|C[23]2|C3|C3[13568]|C51|WP15 S|C25)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:OUKITEL)? K([37]|1[26])(?:[);/ ]|$)",
                "model": "K$1"
            },
            {
                "regex": "RT7 TITAN 5G",
                "device": "tablet",
                "model": "RT7 Titan 5G"
            },
            {
                "regex": "OT6 Kids",
                "device": "tablet",
                "model": "OT6 Kids"
            },
            {
                "regex": "RT7 TITAN",
                "device": "tablet",
                "model": "RT7 Titan"
            },
            {
                "regex": "RT3 Pro",
                "device": "tablet",
                "model": "RT3 Pro"
            },
            {
                "regex": "(RT[1235689]|OKT[13]|OT5 S|OT[568]|OT11)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(?:OUKITEL)? (WP\\d+|C11_F)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "OUKITEL; ([^;]+);",
                "model": "$1"
            }
        ]
    },
    "OKWU": {
        "regex": "(?:OKWU SIGMA|PI[_ ]Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SIGMA",
                "model": "Sigma"
            },
            {
                "regex": "PI[_ ]Plus",
                "model": "PI Plus"
            }
        ]
    },
    "Orion": {
        "regex": "ORION, ([a-z0-9_ -]+), (?:wired|wireless)|CRANE-EVB",
        "device": "tv",
        "models": [
            {
                "regex": "ORION, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": ""
            },
            {
                "regex": "(CRANE-EVB)",
                "model": "CRANE-EVB",
                "device": "tablet"
            }
        ]
    },
    "Ouki": {
        "regex": "OUKI|OK[AU][0-9]+[a-z]* Build|OKP6 Pro",
        "device": "smartphone",
        "models": [
            {
                "regex": "OKP6 Pro",
                "model": "OKP6 Pro"
            },
            {
                "regex": "OUKI[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "([^;/)]+) Build/OUKI",
                "model": "$1"
            },
            {
                "regex": "OUKI[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            },
            {
                "regex": "(OK[AU][0-9]+[a-z]*) Build",
                "model": "$1"
            }
        ]
    },
    "Overmax": {
        "regex": "OV-[a-z]+(?:[^;(/]*)[();/ ]|Qualcore 10(?:10|27)|Livecore7032|Vertis 5021 Aim|Vertis 4004 You|OV1027[34]G",
        "device": "tablet",
        "models": [
            {
                "regex": "OV-V10",
                "model": "Vertis Yard",
                "device": "smartphone"
            },
            {
                "regex": "Vertis 5021 Aim",
                "model": "Vertis 5021 Aim",
                "device": "smartphone"
            },
            {
                "regex": "Vertis 4004 You",
                "model": "Vertis 4004 You",
                "device": "smartphone"
            },
            {
                "regex": "OV-Vertis[ _-]([^;/]+) Build",
                "model": "Vertis $1",
                "device": "smartphone"
            },
            {
                "regex": "Livecore7032",
                "model": "Livecore 7032"
            },
            {
                "regex": "Qualcore 1010",
                "model": "Qualcore 1010"
            },
            {
                "regex": "OV(\\d+)([34])G",
                "model": "Qualcore $1 $2G"
            },
            {
                "regex": "(?:OV-)?Qualcore[-_ ](\\d+)[-_ ]([34])G",
                "model": "Qualcore $1 $2G"
            },
            {
                "regex": "(OV-[a-z]+(?:[^/();]+))(?: Build|[();])",
                "model": "$1"
            }
        ]
    },
    "OX TAB": {
        "regex": "Ox-([^;/)]+)(?: Build|[;)])",
        "device": "tablet",
        "models": [
            {
                "regex": "Ox-p010-2(?:[);/ ]|$)",
                "model": "Ox-p010-2"
            }
        ]
    },
    "Oysters": {
        "regex": "Oysters|T84ERI[ _]3G|T72HM(s_)?3G|T102MS_3G|T102ER3G|T72ER3G|(T74HMi|T84Bi)[_ ]4G|T74MR4G|T74RD|T84Ni[_ ][34]G|Pacific(?:[ ]?800i|E)|T104B_[34]G|IndianV|T72HA_3G|T12V? 3G|T74D_3G|T74N_3G|T74SC_3G|T74Mai_3G|T74MRi3G|T104MBi_3G|T104SCi_3G|T104ER4G|Arctic450|Atlantic(?:4G|454|[EV])|AntarcticE|Life4G|T7V 3G|UBS1|Pacific(?:VS?|I?4G|454)",
        "device": "tablet",
        "models": [
            {
                "regex": "Pacific[ ]?800i",
                "device": "smartphone",
                "model": "Pacific 800i"
            },
            {
                "regex": "PacificE",
                "device": "smartphone",
                "model": "Pacific E"
            },
            {
                "regex": "IndianV",
                "device": "smartphone",
                "model": "Indian V"
            },
            {
                "regex": "(?:Oysters[_ ])?Pacific(VS?|I?4G|454)",
                "device": "smartphone",
                "model": "Pacific $1"
            },
            {
                "regex": "Atlantic(454|[EV]|4G)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Atlantic $1"
            },
            {
                "regex": "Arctic(450)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Arctic $1"
            },
            {
                "regex": "AntarcticE(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Antarctic E"
            },
            {
                "regex": "Life4G(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Life 4G"
            },
            {
                "regex": "UBS1(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Universal Phone 1"
            },
            {
                "regex": "Oysters ((?:Arctic|Indian|Atlantic|Pacific)[^/;]+) Build",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(T84ERI[ _]3G|T72HM(s_)?3G|(?:(T74HMi|T84Bi)[_ ]4G)|T84Ni[_ ][34]G)",
                "model": "$1"
            },
            {
                "regex": "(T74MR|T102MS|T104B|T74SC|T74[DN]|T72HA|T102ER|T72ER|T104SCi|T104MBi|T104ER|T7V|T12V?|T74MRi)[ _]?([34]G)",
                "model": "$1 $2"
            },
            {
                "regex": "T74Mai_3G",
                "model": "T74MAi 3G"
            },
            {
                "regex": "(T74RD)",
                "model": "$1"
            },
            {
                "regex": "Oysters ([^/;]+)( Build|\\))",
                "model": "$1"
            }
        ]
    },
    "\xf6wn": {
        "regex": "OWN[ _]|(?:S4035[ _][34]G|Smart8|SMART PLUS LTE|FUN VALUE (?:4G|Lite)|FUN_VALUE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "FUN ([67])",
                "model": "Fun $1"
            },
            {
                "regex": "FUN 5\\(4G\\)",
                "model": "Fun 5 4G"
            },
            {
                "regex": "(?:OWN[ _])?(S3000D|S3010|S3020D|S4010|S4025|S4035[ _][34]G)",
                "model": "$1"
            },
            {
                "regex": "One Plus",
                "model": "One Plus"
            },
            {
                "regex": "One",
                "model": "One"
            },
            {
                "regex": "Fun Value Lite",
                "model": "Fun Value Lite"
            },
            {
                "regex": "FUN[_ ]VALUE(?: 4G)?",
                "model": "Fun Value 4G"
            },
            {
                "regex": "Smart ?(8|9)(?:[);/ ]|$)",
                "model": "Smart $1"
            },
            {
                "regex": "SMART PLUS LTE(?:[);/ ]|$)",
                "model": "Smart Plus LTE"
            }
        ]
    },
    "Panacom": {
        "regex": "T-i708D",
        "device": "tablet",
        "model": "T-i708D"
    },
    "Panasonic": {
        "regex": "Panasonic|PANATV[0-9]+|Viera/|4KTV-0SU|(?:P902i|P-0[28]D|FZ-B2D|FZ-[NX]1|FZ-A2A|DMC-CM1|P-01[JK]|P-0[23]E|P55 Max)(?:[);/ ]|$)|Eluga[ _]|P55 Novo 4G",
        "device": "smartphone",
        "models": [
            {
                "regex": "P-01J(?:[);/ ]|$)",
                "model": "P-smart Keitai"
            },
            {
                "regex": "(P-01K)(?:[);/ ]|$)",
                "model": "Toughbook $1"
            },
            {
                "regex": "P-03E(?:[);/ ]|$)",
                "model": "Eluga P"
            },
            {
                "regex": "P-02E(?:[);/ ]|$)",
                "model": "Eluga X"
            },
            {
                "regex": "Eluga[ _]I7(?:_EE)?",
                "model": "Eluga I7"
            },
            {
                "regex": "(?:Panasonic_)?Eluga[ _-]([^;/]+) Build",
                "model": "Eluga $1"
            },
            {
                "regex": "(?:Panasonic_)?Eluga[ _-]([^);/]+)[;/)]",
                "model": "Eluga $1"
            },
            {
                "regex": "(DMC-CM1)",
                "model": "Lumix $1",
                "device": "camera"
            },
            {
                "regex": "P-02D(?:[);/ ]|$)",
                "model": "Lumix Phone P-02D"
            },
            {
                "regex": "(FZ-[XN]1)(?:[);/ ]|$)",
                "model": "Toughpad $1"
            },
            {
                "regex": "FZ-(B2D|A2A)(?:[);/ ]|$)",
                "model": "Toughpad FZ-$1",
                "device": "tablet"
            },
            {
                "regex": "P55 Novo(?: 4G)?",
                "model": "P55 Novo 4G"
            },
            {
                "regex": "P55 Max",
                "model": "P55 Max"
            },
            {
                "regex": "P(\\d*) NXT",
                "model": "P$1 NXT"
            },
            {
                "regex": "P902i(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "P902i"
            },
            {
                "regex": "Panasonic G00gle TV",
                "model": "Smart TV"
            },
            {
                "regex": "Panasonic\\..+\\.([0-9]{4})(?:[);/ ]|$)",
                "device": "tv",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Panasonic\\..+\\.([0-9]{4})\\.Mediatek",
                "device": "tv",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Panasonic MIL DLNA",
                "device": "tv",
                "model": "Viera Cast"
            },
            {
                "regex": "PANATV[0-9]+|Viera/",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "(43D1200|(?:32|43)D1270|32D1280|4KTV-0SU[WF]?)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "PANASONIC, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": "",
                "device": "tv"
            },
            {
                "regex": "PANASONIC,([a-z0-9_ -]+),(?:wired|wireless)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "Panasonic[ _-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2\\.0 (P[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "P-08D(?:[);/ ]|$)",
                "model": "Eluga Live 10.1\"",
                "device": "tablet"
            }
        ]
    },
    "PCBOX": {
        "regex": "Art-PCB-V116|Bee-PCB-V216|Clap-PCB-I316|PCB-T(?:10[34]|715|750)|Kova[ _-]PCB-\\w+|Kova_Plus_PCB_T735",
        "device": "smartphone",
        "models": [
            {
                "regex": "Art-PCB-V116",
                "model": "Art"
            },
            {
                "regex": "Bee-PCB-V216",
                "model": "Bee"
            },
            {
                "regex": "Clap-PCB-I316",
                "model": "Clap"
            },
            {
                "regex": "PCB-T103",
                "device": "tablet",
                "model": "Curi Lite"
            },
            {
                "regex": "PCB-T104",
                "device": "tablet",
                "model": "Flash"
            },
            {
                "regex": "PCB-T(715|750)",
                "device": "tablet",
                "model": "T$1"
            },
            {
                "regex": "Kova[ _-]PCB-T730",
                "device": "tablet",
                "model": "Kova T730"
            },
            {
                "regex": "Kova_Plus_PCB_T735",
                "device": "tablet",
                "model": "Kova Plus T735"
            }
        ]
    },
    "PCD": {
        "regex": "(?:PCD[ _])?(?:PL5507|PL571US|PH3501|PH400[12]|E400|PL620)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PL571US",
                "model": "Jaguar Pro II"
            },
            {
                "regex": "(?:PCD[ _])?(P[HL]\\d{4}|E400|PL620)",
                "model": "$1"
            }
        ]
    },
    "PCD Argentina": {
        "regex": "PCD[ ]?50[689]|(?:P63L)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PCD[ ]?(50[689])",
                "model": "$1"
            },
            {
                "regex": "(P63L)",
                "model": "$1"
            }
        ]
    },
    "ArmPhone": {
        "regex": "(TSD Octa A0520P|TSD Quadra A050[59]P)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Penta": {
        "regex": "Penta[ _]|(?:PS650)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "PS650",
                "model": "Smart PS650"
            },
            {
                "regex": "WS704DX",
                "model": "T-Pad WS704DX"
            }
        ]
    },
    "Pentagram": {
        "regex": "Pentagram|Quadra|Monster X5",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:PENTAGRAM[_ ])?EON[_ ]PRIX",
                "model": "Eon Prix"
            },
            {
                "regex": "Quadra 7(?: UltraSlim)?",
                "model": "Quadra 7 UltraSlim"
            },
            {
                "regex": "Monster X5?",
                "model": "Monster X5",
                "device": "smartphone"
            },
            {
                "regex": "Quadra ?([^);/]*) Build",
                "model": "Quadra $1"
            },
            {
                "regex": "Pentagram ?TAB ?([^);/]*) Build",
                "model": "Tab $1"
            },
            {
                "regex": "Pentagram ?([^);/]*) Build",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "TCL": {
        "regex": "TCL,|TCL[a-z0-9]+;|smarttv_AFTMM-TCL|AFTDEC012E|AFTMD002|AFTSHN02|AFTMD001|TCL[_ -][a-z0-9]+|(?:TCL[_ -][^;/]+ Build)|(?:TCLGalaG60(?:\\(9108A\\))?|T431P|4163D|4187[DMU]|4188[CLRSVO]|5004S|5033TP|5087Z|5101A|5102[BKLMOP]|5107G|5124J|5130[JMEI]|5133MP|5133A|5148A|5152D|5159[AJ]|5164[AD]|5199I|6102[ADH]|6125[ADFH]|6127[AI]|6156[ADH]|6159[AK]|6165[AHS]|7040N|8491X|9048S|9060[GX]|9080G|9081X|9295G|9296[GQ]|A(?:50[2789]|600)DL|T(?:60[123]|701)DL|T(?:506D|671[EFGHO]|676[HJK]|766[AHJSU]|767[GHW]|770[BH]|771K|773O|774[BH]|775[BH]|776[HO]|779W|780H|781SPP|781S|781|782H|790[SY]|799[BH]|810[HS])|Percee TV|9183W|9198S|9309X2|9317X1|8[14]96G|916[016]G| 9061| 8182| 8167| 8095|BeyondTV\\d?|UnionTV|T507[DU]|5131[AG]|T610[KE]|T611B|T612B|T614D|T702[DW]|9132[GS]|9137W|T430W|T431[DUQ]|T501[CL]|T768S|T803D|9199S|9494G|9460G|9466X|T60[79]DL|T433[DE]|T506[AGKTF]|T509[AK])(?:_(?:RU|EEA|TR))?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TCLGalaG60(?:\\(9108A\\))?(?:[);/ ]|$)",
                "model": "Gala G60"
            },
            {
                "regex": "5004S(?:[);/ ]|$)",
                "model": "Signa"
            },
            {
                "regex": "T430W(?:[);/ ]|$)",
                "model": "Ion X"
            },
            {
                "regex": "T501[CL](?:[);/ ]|$)",
                "model": "Ion"
            },
            {
                "regex": "T779W(?:[);/ ]|$)",
                "model": "Stylus 5G"
            },
            {
                "regex": "5[01]33[MT]P(?:[);/ ]|$)",
                "model": "201"
            },
            {
                "regex": "4187D(?:[);/ ]|$)",
                "model": "205"
            },
            {
                "regex": "(?:4163D|4188S)(?:[);/ ]|$)",
                "model": "304"
            },
            {
                "regex": "5131[AG]",
                "model": "303"
            },
            {
                "regex": "T431[DUQ](?:[);/ ]|$)",
                "model": "403"
            },
            {
                "regex": "6102[AD](?:[);/ ]|$)",
                "model": "305"
            },
            {
                "regex": "5164[AD](?:[);/ ]|$)",
                "model": "305i"
            },
            {
                "regex": "6102H(?:[);/ ]|$)",
                "model": "306"
            },
            {
                "regex": "T431P",
                "model": "403"
            },
            {
                "regex": "T506[AD]",
                "model": "405"
            },
            {
                "regex": "T506[GK]",
                "model": "406"
            },
            {
                "regex": "T506F",
                "model": "406i"
            },
            {
                "regex": "T506T",
                "model": " 406s"
            },
            {
                "regex": "T507[DU]",
                "model": "408"
            },
            {
                "regex": "T433[DE]",
                "model": "501"
            },
            {
                "regex": "T509K",
                "model": "505"
            },
            {
                "regex": "T509A",
                "model": "505 S"
            },
            {
                "regex": "T610[KE](?:[);/ ]|$)",
                "model": "40 SE"
            },
            {
                "regex": "T774[BH](?:[);/ ]|$)",
                "model": "20L"
            },
            {
                "regex": "T775B(?:[);/ ]|$)",
                "model": "20L Plus Premium Edition"
            },
            {
                "regex": "T775H(?:[);/ ]|$)",
                "model": "20L Plus"
            },
            {
                "regex": "6125[ADFH]",
                "model": "20E"
            },
            {
                "regex": "6127[AI]",
                "model": "30E"
            },
            {
                "regex": "6156[ADH]",
                "model": "20Y"
            },
            {
                "regex": "6159[AK]",
                "model": "20B"
            },
            {
                "regex": "5199I(?:[);/ ]|$)",
                "model": "C9"
            },
            {
                "regex": "A509DL(?:[);/ ]|$)",
                "model": "A3"
            },
            {
                "regex": "A600DL(?:[);/ ]|$)",
                "model": "A3X"
            },
            {
                "regex": "5102[LO](?:[);/ ]|$)",
                "model": "A30"
            },
            {
                "regex": "5152D(?:[);/ ]|$)",
                "model": "C5"
            },
            {
                "regex": "5133A(?:[);/ ]|$)",
                "model": "L5"
            },
            {
                "regex": "5102[BKMP](?:[);/ ]|$)",
                "model": "L7"
            },
            {
                "regex": "5159[AJ](?:[);/ ]|$)",
                "model": "L9"
            },
            {
                "regex": "5101A(?:[);/ ]|$)",
                "model": "L9 Plus"
            },
            {
                "regex": "5107G(?:[);/ ]|$)",
                "model": "L9S"
            },
            {
                "regex": "5124J(?:[);/ ]|$)",
                "model": "L10"
            },
            {
                "regex": "5130[JEI](?:[);/ ]|$)",
                "model": "L10+"
            },
            {
                "regex": "4187[MU](?:[);/ ]|$)",
                "model": "L10 Lite"
            },
            {
                "regex": "5148A(?:[);/ ]|$)",
                "model": "T9"
            },
            {
                "regex": "5130M(?:[);/ ]|$)",
                "model": "T Pro"
            },
            {
                "regex": "T780H(?:[);/ ]|$)",
                "model": "Plex"
            },
            {
                "regex": "T782H(?:[);/ ]|$)",
                "model": "10 Plus"
            },
            {
                "regex": "T790Y(?:[);/ ]|$)",
                "model": "10 5G"
            },
            {
                "regex": "(?:T790S|TCL 10 5G UW)(?:[);/ ]|$)",
                "model": "10 5G UW"
            },
            {
                "regex": "TCL[_ -]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "TCL[_ -]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(7040N)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "A502DL(?:[);/ ]|$)",
                "model": "LX"
            },
            {
                "regex": "A507DL(?:[);/ ]|$)",
                "model": "A2"
            },
            {
                "regex": "A508DL(?:[);/ ]|$)",
                "model": "A2X"
            },
            {
                "regex": "T601DL(?:[);/ ]|$)",
                "model": "X4 5G"
            },
            {
                "regex": "T609DL(?:[);/ ]|$)",
                "model": "40 XE 5G"
            },
            {
                "regex": "T702W(?:[);/ ]|$)",
                "model": "50 XL 5G"
            },
            {
                "regex": "T611B(?:[);/ ]|$)",
                "model": "50 SE"
            },
            {
                "regex": "T614D(?:[);/ ]|$)",
                "model": "50 XE 5G"
            },
            {
                "regex": "T770[HB](?:[);/ ]|$)",
                "model": "10L"
            },
            {
                "regex": "T766[AHJSU](?:_(?:EEA|TR|RU))?(?:[);/ ]|$)",
                "model": "10 SE"
            },
            {
                "regex": "T671[HFEO](?:_EEA)?(?:[);/ ]|$)",
                "model": "20 SE"
            },
            {
                "regex": "T768S(?:_EEA)?(?:[);/ ]|$)",
                "model": "20 A"
            },
            {
                "regex": "6165[AHS]",
                "model": "30 SE"
            },
            {
                "regex": "4188V",
                "model": "30 LE"
            },
            {
                "regex": "T676[KJ]",
                "model": "30+"
            },
            {
                "regex": "T676H",
                "model": "30"
            },
            {
                "regex": "(?:4188[CLRO]|T602DL)(?:[);/ ]|$)",
                "model": "30 Z"
            },
            {
                "regex": "(?:T781S|T781SPP)(?:[);/ ]|$)",
                "model": "30 V 5G"
            },
            {
                "regex": "T603DL",
                "model": "30 T"
            },
            {
                "regex": "T776[HO]",
                "model": "30 5G"
            },
            {
                "regex": "T767[GW](?:[);/ ]|$)",
                "model": "30 XE 5G"
            },
            {
                "regex": "(?:T671G|T701DL)(?:[);/ ]|$)",
                "model": "30 XL"
            },
            {
                "regex": "T767H(?:[);/ ]|$)",
                "model": "20R 5G"
            },
            {
                "regex": "T773O(?:[);/ ]|$)",
                "model": "20S"
            },
            {
                "regex": "5087Z(?:[);/ ]|$)",
                "model": "20 XE"
            },
            {
                "regex": "T781(?:[);/ ]|$)",
                "model": "20 5G"
            },
            {
                "regex": "T810[SH](?:[);/ ]|$)",
                "model": "20 Pro 5G"
            },
            {
                "regex": "T799[BH]",
                "model": "10 Pro"
            },
            {
                "regex": "T771K(?:[);/ ]|$)",
                "model": "40R 5G"
            },
            {
                "regex": "T607DL(?:[);/ ]|$)",
                "model": "ION V"
            },
            {
                "regex": "T612B(?:[);/ ]|$)",
                "device": "phablet",
                "model": "NxtPaper 40"
            },
            {
                "regex": "T803[DE](?:[);/ ]|$)",
                "device": "phablet",
                "model": "NxtPaper 50 Pro 5G"
            },
            {
                "regex": "T702D(?:[);/ ]|$)",
                "device": "phablet",
                "model": "NxtPaper 50 5G"
            },
            {
                "regex": "9494G",
                "device": "tablet",
                "model": "NxtPaper 12 Pro"
            },
            {
                "regex": "9199S",
                "device": "tablet",
                "model": "NxtPaper 10 5G"
            },
            {
                "regex": "9466X",
                "device": "tablet",
                "model": "NxtPaper 11"
            },
            {
                "regex": "9317X1",
                "device": "tablet",
                "model": "Smart Tab 7"
            },
            {
                "regex": "8095(?:[);/ ]|$)",
                "device": "tablet",
                "model": "TKEE Max"
            },
            {
                "regex": "9048S(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 8\" 4G"
            },
            {
                "regex": "9132G",
                "device": "tablet",
                "model": "Tab 8\""
            },
            {
                "regex": "9132S",
                "device": "tablet",
                "model": "Tab Lite"
            },
            {
                "regex": "9295G",
                "device": "tablet",
                "model": "10 TabMax 4G"
            },
            {
                "regex": "9296G",
                "device": "tablet",
                "model": "10 TabMax WiFi"
            },
            {
                "regex": "9296Q",
                "device": "tablet",
                "model": "10 TabMax"
            },
            {
                "regex": "9198S(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab Pro 5G"
            },
            {
                "regex": "9460G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 10"
            },
            {
                "regex": "9183W(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 10 5G"
            },
            {
                "regex": "(?:9061|9081X)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 10s"
            },
            {
                "regex": "8496G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 10 WiFi (Gen 2)"
            },
            {
                "regex": "8196G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 10 LTE (Gen 2)"
            },
            {
                "regex": "9309X2(?:_EEA)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 7 Lite"
            },
            {
                "regex": "(?:8167)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 7L WiFi"
            },
            {
                "regex": "(?:8182)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab 10L WiFi"
            },
            {
                "regex": "9060G|9161G",
                "device": "tablet",
                "model": "Tab 10 FHD 4G"
            },
            {
                "regex": "9060X|9160G",
                "device": "tablet",
                "model": "Tab 10 HD 4G"
            },
            {
                "regex": "9137W",
                "device": "tablet",
                "model": "Tab 8 LE"
            },
            {
                "regex": "9166G",
                "device": "tablet",
                "model": "Tab 11 LTE"
            },
            {
                "regex": "8491X",
                "device": "tablet",
                "model": "Tab 10L"
            },
            {
                "regex": "9080G",
                "device": "tablet",
                "model": "Tab 10s 4G"
            },
            {
                "regex": "(Percee TV|UnionTV)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "BeyondTV(\\d)?(?:[);/ ]|$)",
                "device": "tv",
                "model": "Beyond TV $1"
            },
            {
                "regex": "((?:43|55)S62FS|(?:43|50)P65US|U(?:43|60|65)P60|65P4USM|(?:40|49)S62|L32S6|55P610|50P8S|55S62|(?:43|50)P6US|55DP60)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "_TV_[A-Z0-9]+_Tbrowser_2k20",
                "model": "Smart TV (2020)"
            },
            {
                "regex": "smarttv_AFTMM-TCL-TS8011",
                "device": "tv",
                "model": "TS8011"
            },
            {
                "regex": "AFTMD002(?:[);/ ]|$)",
                "device": "tv",
                "model": "Fire TV 3-Series (2023)"
            },
            {
                "regex": "AFTSHN02(?:[);/ ]|$)",
                "device": "tv",
                "model": "FHD Fire TV (2023)"
            },
            {
                "regex": "AFTMD001(?:[);/ ]|$)",
                "device": "tv",
                "model": "4K Fire TV (2023)"
            },
            {
                "regex": "AFTDEC012E(?:[);/ ]|$)",
                "device": "tv",
                "model": "4K Fire TV (2024)"
            },
            {
                "regex": "TCL,([a-z0-9_ -]+),(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "phoneOne": {
        "regex": "phoneOne[ -]?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Primepad": {
        "regex": "PD\\-(3127NC|3127) Build",
        "device": "tablet",
        "models": [
            {
                "regex": "PD\\-3127NC Build",
                "model": "PD-3127NC"
            },
            {
                "regex": "PD\\-3127 Build",
                "model": "PD-3127"
            }
        ]
    },
    "Pioneer Computers": {
        "regex": "PIONEER COMPUTERS (DreamBook)",
        "device": "tablet",
        "model": "$1"
    },
    "Pioneer": {
        "regex": "Pioneer|.*; R1 Build|(?:dvr700pi|XDP-300R|F9212[AB]|SDA-835TAB|SDA-80?TAB)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": ".*; R1 Build",
                "model": "R1",
                "device": "tablet"
            },
            {
                "regex": "dvr700pi",
                "model": "DVR700PI 7.0\"",
                "device": "tablet"
            },
            {
                "regex": "(XDP-300R)",
                "device": "portable media player",
                "model": "$1"
            },
            {
                "regex": "(F9212[AB]|SDA-835TAB|SDA-80?TAB)",
                "device": "car browser",
                "model": "$1"
            },
            {
                "regex": "BDP-160",
                "device": "tv",
                "model": "BDP-160"
            },
            {
                "regex": "Pioneer, ?([a-z0-9_ -]+), ?(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Pioneer[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Pioneer[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "Pixus": {
        "regex": "Pixus|(hiPower|Touch_7_3G|Ride[_ ][34]G|Play[ _]Three[ _]v(?:[234]\\.0|3\\.1))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Ride[_ ]([34])G",
                "model": "Ride $1G"
            },
            {
                "regex": "Play[ _]Three[ _]v([234]\\.0|3.1)",
                "model": "Play Three v$1"
            },
            {
                "regex": "Play Two",
                "model": "Play Two"
            },
            {
                "regex": "Play Five",
                "model": "Play Five"
            },
            {
                "regex": "hiPower",
                "model": "hiPower"
            },
            {
                "regex": "Pixus[ _]Arena",
                "model": "Arena"
            },
            {
                "regex": "Pixus[ _]Deon",
                "model": "Deon"
            },
            {
                "regex": "Pixus[ _]Sprint",
                "model": "Sprint"
            },
            {
                "regex": "Pixus[ _]Drive",
                "model": "Drive"
            },
            {
                "regex": "Pixus[ _]Wing",
                "model": "Wing"
            },
            {
                "regex": "Pixus[ _]Line",
                "model": "Line"
            },
            {
                "regex": "Pixus[ _]Titan",
                "model": "Titan"
            },
            {
                "regex": "Pixus[ _]Folio",
                "model": "Folio"
            },
            {
                "regex": "(?:Pixus_)?Touch[ _]7[ _]3G",
                "model": "Touch 7 3G"
            },
            {
                "regex": "Pixus[ _]hiMax",
                "model": "HiMax 9.6\""
            },
            {
                "regex": "Pixus[ _]Blast",
                "model": "Blast 10.1\""
            },
            {
                "regex": "Pixus[ _]Joker",
                "model": "Joker 10.1\""
            },
            {
                "regex": "Pixus Blaze 10\\.1 3G",
                "model": "Blaze 10.1\" 3G"
            },
            {
                "regex": "Pixus[_ ]Hammer",
                "model": "Hammer"
            },
            {
                "regex": "Raze",
                "model": "Raze",
                "device": "smartphone"
            },
            {
                "regex": "Pixus_Jet",
                "model": "Jet",
                "device": "smartphone"
            },
            {
                "regex": "pixus hit 2",
                "model": "Hit 2",
                "device": "smartphone"
            }
        ]
    },
    "PULID": {
        "regex": "PULID[ _]|F1[01357]\\+? Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "F(1[01357]\\+?) Build",
                "model": "F$1"
            },
            {
                "regex": "PULID[ _]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "PULID[ _]([a-z0-9_]+)\\)",
                "model": "$1"
            }
        ]
    },
    "Purism": {
        "regex": "Librem 5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Librem 5",
                "model": "Librem 5"
            }
        ]
    },
    "Point Mobile": {
        "regex": "PM80",
        "device": "peripheral",
        "models": [
            {
                "regex": "PM80",
                "model": "PM80"
            }
        ]
    },
    "Point of View": {
        "regex": "POV_TV|POV_TAB|MOB-5045|TAB-P10232-3G",
        "device": "tablet",
        "models": [
            {
                "regex": "POV_TV-HDMI-KB-01",
                "model": "HDMI Smart TV Dongle",
                "device": "tv"
            },
            {
                "regex": "POV_TV-HDMI-200BT",
                "model": "Mini PC HDMI Dongle",
                "device": "tv"
            },
            {
                "regex": "MOB-5045",
                "model": "Mobii Phone 5045",
                "device": "smartphone"
            },
            {
                "regex": "POV_TAB-P506",
                "model": "ONYX 506 Navi"
            },
            {
                "regex": "POV_TAB[_-]NAVI7[_-]3G[_-]M",
                "model": "ONYX 507 Navi"
            },
            {
                "regex": "POV_TAB-P527S",
                "model": "ONYX 527S"
            },
            {
                "regex": "POV_TAB-P547",
                "model": "ONYX 547 Navi"
            },
            {
                "regex": "POV_TAB-PROTAB26",
                "model": "ProTab 26 XXL IPS"
            },
            {
                "regex": "POV_TAB-PROTAB25XXL8?",
                "model": "ProTab 25XXL"
            },
            {
                "regex": "POV_TAB-PL1015",
                "model": "Mobii 1015"
            },
            {
                "regex": "TAB-P10232-3G",
                "model": "Tab P10232 3G"
            },
            {
                "regex": "POV_TAB-PROTAB([a-z0-9]+)",
                "model": "ProTab $1"
            },
            {
                "regex": "POV_TAB-P?([a-z0-9]+)",
                "model": "Mobii $1"
            }
        ]
    },
    "Pomp": {
        "regex": "POMP[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "POMP[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "POMP[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "PPTV": {
        "regex": "(KING 7S?)",
        "device": "smartphone",
        "model": "$1"
    },
    "ProScan": {
        "regex": "PLT([^;/]+) Build|PLT(?:777[045]|9774|107[47]|9999)G(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "PLT([^;/]+) Build",
                "model": "PLT$1"
            },
            {
                "regex": "PLT(777[045]|9774|107[47]|9999)G",
                "model": "PLT$1G"
            }
        ]
    },
    "RCA Tablets": {
        "regex": "RCA-OEM[;,]|RC[AT]([^;/]+)(?: Build|[;)]|$)|RWOSU6547|RCA RLTP4028|RLTP5567|RLTP5573|RC7T3G21|DRP(?:29101|2091)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RCARENO5011619",
                "model": "Reno"
            },
            {
                "regex": "(?:RCA[ _])?(RLTP4028|RLTP5567|RLTP5573)",
                "model": "$1"
            },
            {
                "regex": "RCT6513W87",
                "device": "tablet",
                "model": "Galileo Pro 11.5\""
            },
            {
                "regex": "RCT6873W42M|RCT6876Q22N?|RCT6873W42BMF9E",
                "device": "tablet",
                "model": "Voyager 7.0\""
            },
            {
                "regex": "RCT6973W43(?:MD)?",
                "device": "tablet",
                "model": "Voyager III 7.0\""
            },
            {
                "regex": "RCT6773W22B",
                "device": "tablet",
                "model": "Voyager II 7.0\""
            },
            {
                "regex": "RCT6703W12|RCT6B06P23",
                "device": "tablet",
                "model": "Atlas 10.0\""
            },
            {
                "regex": "RCT6203W46L",
                "device": "tablet",
                "model": "Pro 10 Edition II"
            },
            {
                "regex": "RCT6A06P22",
                "device": "tablet",
                "model": "Endeavor 10.0\" HD"
            },
            {
                "regex": "RCT(?:6303W87(?:DK|M)|6K03W13)",
                "device": "tablet",
                "model": "Viking Pro 10.0\""
            },
            {
                "regex": "RCT6603W47M7",
                "device": "tablet",
                "model": "Viking II 10.0\""
            },
            {
                "regex": "RCT6613W23P",
                "device": "tablet",
                "model": "Delta Pro 11.6\""
            },
            {
                "regex": "(DRP29101|DRP2091)",
                "device": "portable media player",
                "model": "$1"
            },
            {
                "regex": "(RWOSU6547)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "RCT([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "RCT$1"
            },
            {
                "regex": "RC(?!A)([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "RC$1"
            }
        ]
    },
    "RCT": {
        "regex": "(MX101M[23])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Readboy": {
        "regex": "Readboy[ _-]",
        "device": "tablet",
        "models": [
            {
                "regex": "Readboy[ _-]C18Max",
                "model": "C18 Max"
            },
            {
                "regex": "Readboy[ _-]C(\\d+)Pro",
                "model": "C$1 Pro"
            },
            {
                "regex": "Readboy[ _-]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Roku": {
        "regex": "Roku(?:OS|4640X)?/(?:DVP|Pluto)?-?|QSP; Roku",
        "device": "tv",
        "models": [
            {
                "regex": "3930X",
                "model": "Express"
            },
            {
                "regex": "Roku4640X",
                "model": "Ultra"
            },
            {
                "regex": "",
                "model": "Digital Video Player"
            }
        ]
    },
    "Rokit": {
        "regex": "(?:IO (?:Pro|3D|Light)|Orb S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Orb S",
                "model": "Orb S"
            },
            {
                "regex": "IO Pro",
                "model": "IO Pro"
            },
            {
                "regex": "IO Light",
                "model": "IO Light"
            },
            {
                "regex": "IO 3D",
                "model": "IO 3D"
            }
        ]
    },
    "Rover": {
        "regex": "Rover ([0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "RoverPad": {
        "regex": "(?:Rover[ ]?Pad|RoverPhone|(?:Air|Art|Sky) 7\\.85 3G|Pro_Q(?:8|10)_LTE)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "RoverPhone(?:[);/ ]|$)",
                "model": "",
                "device": "smartphone"
            },
            {
                "regex": "Pro_Q(8|10)_LTE(?:[);/ ]|$)",
                "model": "Pro Q$1 LTE"
            },
            {
                "regex": "(?:Rover[ ]?Pad)?sky 7\\.85(?: 3G)?(?:[);/ ]|$)",
                "model": "Sky 7.85\" 3G"
            },
            {
                "regex": "(Air|Art) 7\\.85 3G",
                "model": "$1 7.85\" 3G"
            },
            {
                "regex": "RoverPad (10\\.4|Air S70|9\\.7 3G|Sky 9\\.7|3W A73|3W7|3WT70|3W9\\.4)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Roadrover": {
        "regex": "Roadrover ChangAn S",
        "device": "tablet",
        "model": "ChangAn S"
    },
    "RT Project": {
        "regex": "(?:Shock ?(?:5|5\\.5)|popper2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Shock ?(5\\.5|5)",
                "model": "Shock $1"
            },
            {
                "regex": "popper2",
                "model": "Popper 2"
            }
        ]
    },
    "Saba": {
        "regex": "Saba[_ ]|(?:32SB6000H|42SB6000F)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:Saba[_ ])?(\\d{2}SB\\d{4}[HF])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SMART TV(?:[);/ ]|$)",
                "model": "Smart TV"
            }
        ]
    },
    "S-TELL": {
        "regex": "S-TELL|(?:M630|M55[78]|P760|P750i|M555i|M580|M457|M655)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(P760|P750i)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:S-TELL[ _])?M([0-9]{3}|555i|M580|M655)(?:[);/ ]|$)",
                "model": "M$1"
            }
        ]
    },
    "Safaricom": {
        "regex": "Safaricom|NEON[_ ]RAY|(?:NEON_NOVA|NEON PLUS|NEON PLUS|NEON LITE|Neon Storm|SFCSTB2LITE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ET Kimem(?:[);/ ]|$)",
                "model": "ET Kimem"
            },
            {
                "regex": "Safaricom_Kimem_Kerefa_4G(?:[);/ ]|$)",
                "model": "Kimem Kerefa 4G"
            },
            {
                "regex": "NEON_RAY_PRO",
                "model": "Neon Ray Pro"
            },
            {
                "regex": "Neon Ray Ultra M",
                "model": "Neon Ray Ultra M"
            },
            {
                "regex": "Neon Ray Ultra",
                "model": "Neon Ray Ultra"
            },
            {
                "regex": "NEON_RAY",
                "model": "Neon Ray"
            },
            {
                "regex": "NEON RAY 2",
                "model": "Neon Ray 2"
            },
            {
                "regex": "NEON_NOVA",
                "model": "Neon Nova"
            },
            {
                "regex": "NEON PLUS",
                "model": "Neon Plus"
            },
            {
                "regex": "NEON LITE",
                "model": "Neon Lite"
            },
            {
                "regex": "Neon Storm",
                "model": "Neon Storm"
            },
            {
                "regex": "SFCSTB2LITE",
                "device": "tv",
                "model": "STB2 Lite"
            }
        ]
    },
    "Santin": {
        "regex": "SANTIN|(?:BiTBiZ_V58|ACTOMA ACE|DREAMPLUS03A|Candy U7 Pro|GAAMII|RS635H|HY-002 Plus|HongQi HQ1|G101-OG|HEXIN-H2-A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BiTBiZ_V58(?:[);/ ]|$)",
                "model": "BiTBiZ V58"
            },
            {
                "regex": "GAAMII G1(?:[);/ ]|$)",
                "model": "GAAMII G1"
            },
            {
                "regex": "GAAMII(?:[);/ ]|$)",
                "model": "GAAMII"
            },
            {
                "regex": "HEXIN-H2-A(?:[);/ ]|$)",
                "model": "Hexin H2-A"
            },
            {
                "regex": "Candy U7 Pro(?:[);/ ]|$)",
                "model": "Candy U7 Pro"
            },
            {
                "regex": "DREAMPLUS03A(?:[);/ ]|$)",
                "model": "Dream Plus 03A"
            },
            {
                "regex": "GreenOrange(?:[);/ ]|$)",
                "model": "Green Orange"
            },
            {
                "regex": "CLASSONE(?:[);/ ]|$)",
                "model": "Class One"
            },
            {
                "regex": "halove(?:[);/ ]|$)",
                "model": "Halove"
            },
            {
                "regex": "ACTOMA ACE(?:[);/ ]|$)",
                "model": "Actoma Ace"
            },
            {
                "regex": "monica(?:[);/ ]|$)",
                "model": "Monica"
            },
            {
                "regex": "HongQi HQ1(?:[);/ ]|$)",
                "model": "HongQi HQ1"
            },
            {
                "regex": "POWER(?:[);/ ]|$)",
                "model": "Power"
            },
            {
                "regex": "GALAZ(?:[);/ ]|$)",
                "model": "Galaz"
            },
            {
                "regex": "NEWDUN(?:[);/ ]|$)",
                "model": "Newdun"
            },
            {
                "regex": "HEXIN[_ -](H2-A|H3)(?:[);/ ]|$)",
                "model": "Hexin $1"
            },
            {
                "regex": "HY-002 Plus(?:[);/ ]|$)",
                "model": "HY-002 Plus"
            },
            {
                "regex": "G101-OG(?:[);/ ]|$)",
                "device": "tablet",
                "model": "G101-OG"
            },
            {
                "regex": "SANTIN[ _][#]?(Dante|Candy U7|Armor(?: 2)?|YSL-Y7|ANT\\.W|N[13]|JS|S6|V9(?:[ _]Pro)?|Life Shine|ovvi|D|11 XS Max|SHUGUO)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(RS635H)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Santin[ _#]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Siemens": {
        "regex": "SIEMENS|SIE-|portalmmm/2\\.0 SI|(?:S55(?! Nova)|SL45i)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:SIE-)?(S[56]5|S40|C45|ME45|SLIK)(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "SIEMENS[ -]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SIE(?:MENS )?[\\-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(?:SIE-)?(SL45i)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/2\\.0 (SI[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Soundmax": {
        "regex": "((?:SM-LED32M(?:1[0214]|0[479])S)|SM-QLED(?:50T2|50T21|55T21)SU|SM-LED(?:24M(?:0[69]|11)S|43M02S|40M04S|(?:5[05]|43)M0[1234]SU|32M1[35]S|65M0[12]SU))(?:_-Ver01)?(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Samsung": {
        "regex": "SAMSUNG(?! ?(?:Browser|Redmi|TicWatch))|FamilyHub|Maple (?!III)|Maple2012|SMART-TV.+Tizen.+SamsungBrowser|Gear Live|(?:SEC_)?SC-(?:001|01[EFGHKLM]|02[CGHJKLMF]|03[EFJKL]|04[EFJLG]|05[GL]|(?:4[12]|5[1-4])A|5[1-5][BC]|51E|5[15]D|56C|5[23]D)|N[57]100|N5110|N9100|S(?:CH|GH|PH|EC|AM|HV|HW|M)-|GT-|(?<!GOG|GOG )Galaxy|(?:portalmmm|o2imode)/2\\.0 [SZ]|sam[rua]|beyond[02]q?|crownq?lte|vollo Vi86(?:[);/ ]|$)|(?:lineage_|aokp_|rr_)?(?:serranoltexx|j5y17lte|Santos103G|fortuna3g|Verizon-SM)|(?:OTV-)?SMT-E5015|ISW11SC|40[34]SC|SC(?:G1[6789]|G2[0-7]|V3[1-9]|V4[0-9]|51Aa|-56B|T21|G0[1-9]|G1[0-5]|L2[234])(?:-[uj])?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GT-B9150",
                "device": "tv",
                "model": "Home Sync"
            },
            {
                "regex": "(?:OTV-)?SMT-E5015",
                "device": "tv",
                "model": "SMT-E5015"
            },
            {
                "regex": "Maple ",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "Samsung, ([a-z0-9_ -]+), (?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Maple2012",
                "device": "tv",
                "model": "Smart TV (2012)"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-)?N5100",
                "device": "tablet",
                "model": "Galaxy Note 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T677(?:[ATV]|N[KL])?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy View 18.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T670(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy View 18.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-)?N5110",
                "device": "tablet",
                "model": "Galaxy Note 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N5120",
                "device": "tablet",
                "model": "Galaxy Note 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT|SM)-N8000",
                "device": "tablet",
                "model": "Galaxy Note 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N8010",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N8020",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P1000M?|SCH-I800",
                "device": "tablet",
                "model": "Galaxy Tab"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P3100B?",
                "device": "tablet",
                "model": "Galaxy Tab 2 7\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P311[03]",
                "device": "tablet",
                "model": "Galaxy Tab 2 7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5100|SCH-I915",
                "device": "tablet",
                "model": "Galaxy Tab 2 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P511[03]",
                "device": "tablet",
                "model": "Galaxy Tab 2 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T217T",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\" 4G"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5200|Santos103G",
                "device": "tablet",
                "model": "Galaxy Tab 3 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5210",
                "device": "tablet",
                "model": "Galaxy Tab 3 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P5220",
                "device": "tablet",
                "model": "Galaxy Tab 3 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P6200",
                "device": "tablet",
                "model": "Galaxy Tab 7\" Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P6201",
                "device": "tablet",
                "model": "Galaxy Tab 7\" Plus N"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P6810",
                "device": "tablet",
                "model": "Galaxy Tab 7.7\""
            },
            {
                "regex": "SC-01E",
                "device": "tablet",
                "model": "Galaxy Tab 7.7\" Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P7100",
                "device": "tablet",
                "model": "Galaxy Tab 10.1v"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-P75[01]0",
                "device": "tablet",
                "model": "Galaxy Tab 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T321",
                "device": "tablet",
                "model": "Galaxy Tab Pro 8.4\" 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T905",
                "device": "tablet",
                "model": "Galaxy Tab Pro 12.2\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P600",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" 2014 Edition WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P60[12]",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" 2014 Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P605|P607T)",
                "device": "tablet",
                "model": "Galaxy Note 10.1\" 2014 Edition LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P900",
                "device": "tablet",
                "model": "Galaxy NotePRO 12.2\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P901",
                "device": "tablet",
                "model": "Galaxy NotePRO 12.2\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P905",
                "device": "tablet",
                "model": "Galaxy NotePRO 12.2\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P587|P588C)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" with S Pen (2016) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P583(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" with S Pen (2016) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P205(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" with S Pen (2019) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-P200(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" with S Pen (2019) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T307U(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A 8.4\" (2020) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T297",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" (2019) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T505[CN]?|T507)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A7 10.4\" (2020) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T500(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A7 10.4\" (2020) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T503(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A7 10.4\" (2022) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T22[57]",
                "device": "tablet",
                "model": "Galaxy Tab A7 Lite 8.7\" (2021) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T220(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab A7 Lite 8.7\" (2021) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X216",
                "device": "tablet",
                "model": "Galaxy Tab A9+ 11.0\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X218",
                "device": "tablet",
                "model": "Galaxy Tab A9+ 11.0\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X210",
                "device": "tablet",
                "model": "Galaxy Tab A9+ 11.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X215",
                "device": "tablet",
                "model": "Galaxy Tab A9+ 11.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X115",
                "device": "tablet",
                "model": "Galaxy Tab A9 8.7\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X110",
                "device": "tablet",
                "model": "Galaxy Tab A9 8.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T11[03]",
                "device": "tablet",
                "model": "Galaxy Tab 3 Lite 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X205",
                "device": "tablet",
                "model": "Galaxy Tab A8 10.5\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X200",
                "device": "tablet",
                "model": "Galaxy Tab A8 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T830[X]?|T837R4)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S4 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T837P(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S4 10.5\" with S Pen"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T835[CN]?|T837[VTA]?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S4 10.5\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T725[CN]?|T720X|T727(?:R4|[AUV])?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S5e 10.5\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T720(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S5e 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T865N?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T867(?:R4|[VU])?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P615[CN]?|P61[379])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 Lite 10.4\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P610X?|P620)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 Lite 10.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T860X?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T866N(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S6 10.5\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X700",
                "device": "tablet",
                "model": "Galaxy Tab S8 11.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X900",
                "device": "tablet",
                "model": "Galaxy Tab S8 Ultra 14.6\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X910(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S9 Ultra 14.6\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X916[CB]",
                "device": "tablet",
                "model": "Galaxy Tab S9 Ultra 14.6\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X810",
                "device": "tablet",
                "model": "Galaxy Tab S9+ 12.4\""
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-X818U|SM-X816[BN])",
                "device": "tablet",
                "model": "Galaxy Tab S9+ 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X716",
                "device": "tablet",
                "model": "Galaxy Tab S9 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X616",
                "device": "tablet",
                "model": "Galaxy Tab S9 FE+ 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X(?:518U|516)",
                "device": "tablet",
                "model": "Galaxy Tab S9 FE 10.9\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X610",
                "device": "tablet",
                "model": "Galaxy Tab S9 FE+ 12.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X710",
                "device": "tablet",
                "model": "Galaxy Tab S9 11\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T111",
                "device": "tablet",
                "model": "Galaxy Tab 3 Lite 7.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X920",
                "device": "tablet",
                "model": "Galaxy Tab S10 Ultra 14.6\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X926",
                "device": "tablet",
                "model": "Galaxy Tab S10 Ultra 14.6\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X620",
                "device": "tablet",
                "model": "Galaxy Tab S10 FE+ 13.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X626B",
                "device": "tablet",
                "model": "Galaxy Tab S10 FE+ 13.1\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X510",
                "device": "tablet",
                "model": "Galaxy Tab S9 FE 10.9\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X520",
                "device": "tablet",
                "model": "Galaxy Tab S10 FE 10.9\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X526",
                "device": "tablet",
                "model": "Galaxy Tab S10 FE 10.9\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X820",
                "device": "tablet",
                "model": "Galaxy Tab S10+ 12.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X826",
                "device": "tablet",
                "model": "Galaxy Tab S10+ 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T116(?:BU|NU|NY)?",
                "device": "tablet",
                "model": "Galaxy Tab 3 V"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T2105|T212)",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\" Kids"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T210R?",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T21(?:[15]|7[AS])",
                "device": "tablet",
                "model": "Galaxy Tab 3 7.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T230(?:NU)?",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T23[15]|403SC|SM-T321",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T239|T237[PV])",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T232(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 4 7.0\" WiFi + 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T310",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T312",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\" 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T311",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T315",
                "device": "tablet",
                "model": "Galaxy Tab 3 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T330",
                "device": "tablet",
                "model": "Galaxy Tab 4 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T33[215]|T337[AVT])",
                "device": "tablet",
                "model": "Galaxy Tab 4 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T520",
                "device": "tablet",
                "model": "Galaxy TabPRO 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T53[15]|T537[AV])",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T536(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\" Advanced"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T532(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T320",
                "device": "tablet",
                "model": "Galaxy TabPRO 8.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T325",
                "device": "tablet",
                "model": "Galaxy TabPRO 8.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T525",
                "device": "tablet",
                "model": "Galaxy TabPRO 10.1\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T530(?:NU)?|T533)",
                "device": "tablet",
                "model": "Galaxy Tab 4 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T700",
                "device": "tablet",
                "model": "Galaxy Tab S 8.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T705|T707[AV])",
                "device": "tablet",
                "model": "Galaxy Tab S 8.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T800",
                "device": "tablet",
                "model": "Galaxy Tab S 10.5\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-(?:T805|T807[PV]?)|SCT21)",
                "device": "tablet",
                "model": "Galaxy Tab S 10.5\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T813|T810)",
                "device": "tablet",
                "model": "Galaxy Tab S2 9.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T719[CY]?|T715(?:N0|[CY])?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S2 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T71[03]|T710X)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S2 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T815|T817[ATW]?|T818[ATVW]?|T819[Y]?)",
                "device": "tablet",
                "model": "Galaxy Tab S2 9.7\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T820",
                "device": "tablet",
                "model": "Galaxy Tab S3 9.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T82[57]",
                "device": "tablet",
                "model": "Galaxy Tab S3 9.7\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T975N?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7+ 12.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T970(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7+ 12.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T976[BN]|T978U)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7+ 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T870(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7 11.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T875N?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7 11.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T878U(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab S7 11.0\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T73[57]",
                "device": "tablet",
                "model": "Galaxy Tab S7 FE 12.4\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-T736|SM-T738[UTV])",
                "device": "tablet",
                "model": "Galaxy Tab S7 FE 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T733",
                "device": "tablet",
                "model": "Galaxy Tab S7 FE 12.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X906",
                "device": "tablet",
                "model": "Galaxy Tab S8 Ultra 14.6\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X80[68]",
                "device": "tablet",
                "model": "Galaxy Tab S8+ 12.4\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X800",
                "device": "tablet",
                "model": "Galaxy Tab S8+ 12.4\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X706",
                "device": "tablet",
                "model": "Galaxy Tab S8 11.0\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X730",
                "device": "tablet",
                "model": "Galaxy Tab S11 WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T900",
                "device": "tablet",
                "model": "Galaxy TabPRO 12.2\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T280",
                "device": "tablet",
                "model": "Galaxy Tab A 7.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T285",
                "device": "tablet",
                "model": "Galaxy Tab A 7.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T3[58]0",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P350|T3[58]5|T357[TW])",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T387(?:AA|R4|VK|[TPVW])",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" (2018) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T295",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" (2019) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T290",
                "device": "tablet",
                "model": "Galaxy Tab A 8.0\" (2019) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P355([MY])?|T550)",
                "device": "tablet",
                "model": "Galaxy Tab A 9.7\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P550|P555(M)?|T555)",
                "device": "tablet",
                "model": "Galaxy Tab A 9.7\" LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T58[05]|P58[05])",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" (2016) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T587[P]?",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" (2016) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T59[057]",
                "device": "tablet",
                "model": "Galaxy Tab A 10.5\" (2018) LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T51(?:7P|[057])",
                "device": "tablet",
                "model": "Galaxy Tab A 10.1\" (2019)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T37[57]|T378[KLSV])",
                "device": "tablet",
                "model": "Galaxy Tab E 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T56[02]",
                "device": "tablet",
                "model": "Galaxy Tab E 9.6\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T561",
                "device": "tablet",
                "model": "Galaxy Tab E 9.6\" 3G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T567V",
                "device": "tablet",
                "model": "Galaxy Tab E 9.6\" 4G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X306",
                "device": "tablet",
                "model": "Galaxy Tab Active 5 8.0\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-X300",
                "device": "tablet",
                "model": "Galaxy Tab Active5 8.0 (2024) WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T636",
                "device": "tablet",
                "model": "Galaxy Tab Active 4 Pro 10.1\" 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T365(?:F0|[MY])?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T360(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T395[CN]?|T397U)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 2 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T390(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 2 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T575N?|T577U?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 3 8.0\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T570(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active 3 8.0\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:T545|T547U?)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active Pro 10.1\""
            },
            {
                "regex": "(?:SAMSUNG-)?SM-T540(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Tab Active Pro 10.1\" WiFi"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:P902|P907A)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Galaxy Note Pro 12.2\""
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-T2519",
                "model": "Galaxy Tab Q",
                "device": "tablet"
            },
            {
                "regex": "SM-R820",
                "device": "wearable",
                "model": "Galaxy Watch Active 2 44mm"
            },
            {
                "regex": "SM-V7000",
                "device": "wearable",
                "model": "Galaxy Gear"
            },
            {
                "regex": "SM-R3500",
                "device": "wearable",
                "model": "Galaxy Gear Fit"
            },
            {
                "regex": "SM-R3800",
                "device": "wearable",
                "model": "Galaxy Gear 2"
            },
            {
                "regex": "SSM-R3810",
                "device": "wearable",
                "model": "Galaxy Gear 2 Neo"
            },
            {
                "regex": "SM-R825",
                "device": "wearable",
                "model": "Galaxy Watch Active 2 44mm LTE"
            },
            {
                "regex": "SM-R830",
                "device": "wearable",
                "model": "Galaxy Watch Active 2 40mm"
            },
            {
                "regex": "SM-R835",
                "device": "wearable",
                "model": "Galaxy Watch Active 2 40mm LTE"
            },
            {
                "regex": "SM-R800",
                "device": "wearable",
                "model": "Galaxy Watch 46mm"
            },
            {
                "regex": "SM-R875",
                "device": "wearable",
                "model": "Galaxy Watch 4 44mm"
            },
            {
                "regex": "SM-R8[76]0",
                "device": "wearable",
                "model": "Galaxy Watch 4 40mm"
            },
            {
                "regex": "SM-R90[05]",
                "device": "wearable",
                "model": "Galaxy Watch 5 40mm"
            },
            {
                "regex": "SM-R91[05]",
                "device": "wearable",
                "model": "Galaxy Watch 5 44mm"
            },
            {
                "regex": "SM-R925",
                "device": "wearable",
                "model": "Galaxy Watch 5 Pro 50mm"
            },
            {
                "regex": "SM-R920",
                "device": "wearable",
                "model": "Galaxy Watch 5 Pro 45mm"
            },
            {
                "regex": "SM-R960",
                "device": "wearable",
                "model": "Galaxy Watch 6 Classic 47mm"
            },
            {
                "regex": "SM-R950",
                "device": "wearable",
                "model": "Galaxy Watch 6 Classic 43mm"
            },
            {
                "regex": "SM-R805",
                "device": "wearable",
                "model": "Galaxy Watch 46mm LTE"
            },
            {
                "regex": "SM-R895",
                "device": "wearable",
                "model": "Galaxy Watch 4 46mm"
            },
            {
                "regex": "SM-R810",
                "device": "wearable",
                "model": "Galaxy Watch 42mm"
            },
            {
                "regex": "SM-R815",
                "device": "wearable",
                "model": "Galaxy Watch 42mm LTE"
            },
            {
                "regex": "SM-R885",
                "device": "wearable",
                "model": "Galaxy Watch 4 Classic 42mm"
            },
            {
                "regex": "SM-R500",
                "device": "wearable",
                "model": "Galaxy Watch Active"
            },
            {
                "regex": "SM-R600",
                "device": "wearable",
                "model": "Galaxy Gear Sport 43mm"
            },
            {
                "regex": "SM-R760",
                "device": "wearable",
                "model": "Galaxy Gear S3 Frontier 46mm"
            },
            {
                "regex": "SM-R720",
                "device": "wearable",
                "model": "Galaxy Gear S2 43mm"
            },
            {
                "regex": "SM-R730",
                "device": "wearable",
                "model": "Galaxy Gear S2 44mm"
            },
            {
                "regex": "SM-R750",
                "device": "wearable",
                "model": "Gear S 40mm"
            },
            {
                "regex": "SM-R732",
                "device": "wearable",
                "model": "Gear S2 42mm"
            },
            {
                "regex": "SM-R765",
                "device": "wearable",
                "model": "Galaxy Gear S3 Frontier 33mm"
            },
            {
                "regex": "SM-R770",
                "device": "wearable",
                "model": "Galaxy Gear S3 Classic 41mm"
            },
            {
                "regex": "SM-R845",
                "device": "wearable",
                "model": "Galaxy Watch 3 45mm LTE"
            },
            {
                "regex": "SM-R840",
                "device": "wearable",
                "model": "Galaxy Watch 3 45mm"
            },
            {
                "regex": "SM-R850",
                "device": "wearable",
                "model": "Galaxy Watch 3 41mm"
            },
            {
                "regex": "SM-R855",
                "device": "wearable",
                "model": "Galaxy Watch 3 41mm 4G"
            },
            {
                "regex": "Gear Live",
                "device": "wearable",
                "model": "Gear Live"
            },
            {
                "regex": "Family ?Hub",
                "device": "peripheral",
                "model": "Family Hub"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A245",
                "model": "Galaxy A24"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A256",
                "model": "Galaxy A25 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G850(?:8S|[AFKLMSWXY])",
                "model": "Galaxy Alpha"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B5330",
                "model": "Galaxy Chat"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A605K",
                "model": "Galaxy Jean"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A202K",
                "model": "Galaxy Jean 2"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B5510",
                "model": "Galaxy Y Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B5512",
                "model": "Galaxy Y Pro Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-B7510",
                "model": "Galaxy Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I5700",
                "model": "Galaxy Spica"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I5801",
                "model": "Galaxy Apollo"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I5800",
                "model": "Galaxy 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8000",
                "model": "Omnia II"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7530",
                "model": "Omnia M"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8350",
                "model": "Omnia W"
            },
            {
                "regex": "(?:SAMSUNG-)?OMNIA7",
                "model": "Omnia 7"
            },
            {
                "regex": "(?:SAMSUNG-)?SGH-i677",
                "model": "Focus Flash"
            },
            {
                "regex": "(?:SAMSUNG-)?SGH-i917",
                "model": "Focus"
            },
            {
                "regex": "(?:SAMSUNG-)?SGH-i937",
                "model": "Focus S"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I8150|SM-T255S)",
                "model": "Galaxy W"
            },
            {
                "regex": "SC-01H(?:[);/ ]|$)",
                "model": "Galaxy Active Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5830",
                "model": "Galaxy Ace"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G357(?:FZ|M)|G310HN)",
                "model": "Galaxy Ace Style"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8160",
                "model": "Galaxy Ace 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G313(?:HY|M[LUY]|[FM])",
                "model": "Galaxy Ace 4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G316M",
                "model": "Galaxy Ace 4 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G313[HU]",
                "model": "Galaxy Ace 4 Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G316U|G318(?:H|ML))(?:[);/ ]|$)",
                "model": "Galaxy Ace 4 Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G9100(?:[);/ ]|$)",
                "model": "Galaxy S II"
            },
            {
                "regex": "(?:SAMSUNG-)?SHV-E120",
                "model": "Galaxy S II HD LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8190",
                "model": "Galaxy S III mini"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8200",
                "model": "Galaxy S III mini Value Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I826[02]",
                "model": "Galaxy Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SHW-M570S",
                "model": "Galaxy Core Advance"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G386W",
                "model": "Galaxy Core LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3589W",
                "model": "Galaxy Core Lite LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8320",
                "model": "H1"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I85[23]0",
                "model": "Galaxy Beam"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3858",
                "model": "Galaxy Beam 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G600S",
                "model": "Galaxy Wide"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E426S",
                "model": "Galaxy Wide 5"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I855[028]",
                "model": "Galaxy Win"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G381[28]",
                "model": "Galaxy Win Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8580",
                "model": "Galaxy Core Advance"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I8730",
                "model": "Galaxy Express"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:E500(?:HQ|YZ|[0FHM])|S978L)",
                "model": "Galaxy E5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E700[09FHM]",
                "model": "Galaxy E7"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I90(?:00|08|18|88)",
                "model": "Galaxy S"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9001",
                "model": "Galaxy S Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9003",
                "model": "Galaxy SL"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9010",
                "model": "Galaxy S Giorgio Armani"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9070",
                "model": "Galaxy S Advance"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I910[08]",
                "model": "Galaxy S II"
            },
            {
                "regex": "(?:SAMSUNG-)?ISW11SC",
                "model": "Galaxy S II WiMAX"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9103",
                "model": "Galaxy R"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9105",
                "model": "Galaxy S II Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G730(?:W8|[AV])",
                "model": "Galaxy S3 mini"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I919[025]|SCH-I435)|(?:lineage_|aokp_)?serranoltexx",
                "model": "Galaxy S4 mini"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9515",
                "model": "Galaxy S4 Value Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I9295|SHV-E470S)",
                "model": "Galaxy S4 ACTIVE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I9300|SCH-(?:I535|I939|L710))|SC-03E",
                "model": "Galaxy S III"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I9305|SCH-R530)",
                "model": "Galaxy S III LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S975L|GT-I950[025]|SC-04E|SCH-(?:I545|I959|R970)|SGH-M919N?|Galaxy-S4|SHV-E300K)",
                "model": "Galaxy S4"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-I9506)",
                "model": "Galaxy S4 with LTE+"
            },
            {
                "regex": "(?:SAMSUNG-)?SHV-E330",
                "model": "Galaxy S4 LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5280",
                "model": "Galaxy STAR"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5301",
                "model": "Galaxy POCKET Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5310",
                "model": "Galaxy POCKET Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G110[BHM]",
                "model": "Galaxy POCKET 2"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5360",
                "model": "Galaxy Y Hello Kitty"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6310",
                "model": "Galaxy Young"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6312",
                "model": "Galaxy Young DUOS"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G130(?:BT|HN|[EHMU])",
                "model": "Galaxy Young 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G130BU",
                "model": "Galaxy Young 2 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6790",
                "model": "Galaxy FAME Lite with NFC"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6810",
                "model": "Galaxy FAME"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S6812",
                "model": "Galaxy FAME Duos"
            },
            {
                "regex": "SC-04J(?:[);/ ]|$)",
                "model": "Galaxy Feel"
            },
            {
                "regex": "SC-02L(?:[);/ ]|$)",
                "model": "Galaxy Feel 2"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7275",
                "model": "Galaxy ACE 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7500",
                "model": "Galaxy ACE Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-S7560|SCH-I699)",
                "model": "Galaxy Trend"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7390",
                "model": "Galaxy Trend Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7580",
                "model": "Galaxy Trend Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-I739",
                "model": "Galaxy Trend 2"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:GT-S7562|SCH-I919)",
                "model": "Galaxy S DUOS"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7582",
                "model": "Galaxy S DUOS 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G31[36]HU|G313HZ)",
                "model": "Galaxy S DUOS 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7710",
                "model": "Galaxy Xcover 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G388F",
                "model": "Galaxy Xcover 3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G389F",
                "model": "Galaxy Xcover 3 VE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G390[FWY]",
                "model": "Galaxy Xcover 4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G398FN",
                "model": "Galaxy Xcover 4s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G715(?:FN|U1|[AUW])",
                "model": "Galaxy Xcover Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G889(?:YB|[AFG])",
                "model": "Galaxy Xcover FieldPro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G525[FN]",
                "model": "Galaxy Xcover 5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G736",
                "model": "Galaxy Xcover 6 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G556",
                "model": "Galaxy Xcover 7"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S8500",
                "model": "Wave"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S8530",
                "model": "Wave II"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S8600",
                "model": "Wave 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5380",
                "model": "Wave Y"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7250",
                "model": "Wave M"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5250",
                "model": "Wave 525"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5330",
                "model": "Wave 533"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S5780",
                "model": "Wave 578"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-S7230",
                "model": "Wave 723"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:C101|C105([AL])?)",
                "model": "Galaxy S4 zoom"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:C111(M)?|C115)",
                "model": "Galaxy K zoom"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G318[HM]Z",
                "model": "Galaxy V Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G355(?:6D|[89HM])",
                "model": "Galaxy Core 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G350",
                "model": "Galaxy Core Plus"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G360[FH]?|S820L)",
                "model": "Galaxy Core Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G361[FH]?",
                "model": "Galaxy Core Prime Value Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G386F|G3518(?:_TD)?|G3586V)",
                "model": "Galaxy Core LTE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3568V",
                "model": "Galaxy Core Mini 4G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G5108Q?",
                "model": "Galaxy Core Max"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G3815",
                "model": "Galaxy EXPRESS II"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G80[01]",
                "model": "Galaxy S5 mini"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G9009D",
                "model": "Galaxy S5 Dual-SIM"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G900FD",
                "model": "Galaxy S5 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G900|G906[KLS]|S902L|S903VL|G490F)|Galaxy-S5|SCL23|SC-04F",
                "model": "Galaxy S5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G901F",
                "model": "Galaxy S5 LTE+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G870[AFW]|SC-02G",
                "model": "Galaxy S5 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G903[FMW]",
                "model": "Galaxy S5 Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G860P",
                "model": "Galaxy S5 K Sport"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G920(?:F[DQ]|W8|[089AFIKLPRSTVX])?|SM-S906L|SM-S907VL)|SC-05G",
                "model": "Galaxy S6"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G890A",
                "model": "Galaxy S5 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G925[0ADFJIKLPRSTVWX]|SCV31|404SC|SC-04G|SM-G828)",
                "model": "Galaxy S6 Edge"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G928(?:7C|N0|R4|W8|[07ACFGIKLPSTVX])",
                "model": "Galaxy S6 Edge+"
            },
            {
                "regex": "(?:SAMSUNG-|Verizon-)?SM-G930(?:AZ|FD|R[467]|T1|V[CL]|W8|[0AFKLPRSTUVX8])?(?:[);/ ]|$)",
                "model": "Galaxy S7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G935(?:R4|W8|[0AFKLPSTUVX])|SC-02H|SCV33|Galaxy s7 edge",
                "model": "Galaxy S7 Edge"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G891A",
                "model": "Galaxy S7 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G950[08FNUW]?|SCV36|SC-02J",
                "model": "Galaxy S8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G8750",
                "model": "Galaxy S8 Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G892[AU]",
                "model": "Galaxy S8 Active"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G955[0AFKLNPRTUVWX]?|SCV35|SC-03J",
                "model": "Galaxy S8+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G960[0FNUWX]?|SCV38|SC-02K",
                "model": "Galaxy S9"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G965[0FNUWX]|SCV39|SC-03K",
                "model": "Galaxy S9+"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-(?:G973|G977[BNPTU])|SCV41|SC-03L)",
                "model": "Galaxy S10"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S10 Lite|G770(?:U1|F))",
                "model": "Galaxy S10 Lite"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G975[08FUNWX]|SCV42|SC-04L)",
                "model": "Galaxy S10+"
            },
            {
                "regex": "SC-05L",
                "model": "Galaxy S10+ Olympic Games Edition"
            },
            {
                "regex": "(?:(?:SAMSUNG-)?SM-G970(?:U1|[08FUNWX])|beyond0q?)(?:[);/ ]|$)",
                "model": "Galaxy S10e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G980F",
                "model": "Galaxy S20"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G981(?:U1|[0BNUVW])|SCG01|SC-51A|SC51Aa",
                "model": "Galaxy S20 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G780",
                "model": "Galaxy S20 FE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G781(?:U1|[0BNUVW])",
                "model": "Galaxy S20 FE 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G988(?:U1|[0BNQUW])|SCG03",
                "model": "Galaxy S20 Ultra 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G985F|SCG02",
                "model": "Galaxy S20+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G986(?:U1|[0BNUW])|SC-52A",
                "model": "Galaxy S20+ 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G991V",
                "model": "Galaxy S21 5G UW"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G991(?:U1|R4|[0ABNWQU])|SCG09",
                "model": "Galaxy S21 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G990",
                "model": "Galaxy S21 FE 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SC-51B",
                "model": "Galaxy S21 5G Olympic Games Edition"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G998(?:U1|[0BNUWTP])|SC-52B)",
                "model": "Galaxy S21 Ultra 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G996(?:U1|[0BNWUP])|SCG10",
                "model": "Galaxy S21+ 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S901(?:U1|[0BENUW])|SC-51C|SCG13",
                "model": "Galaxy S22"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S908(?:U1|[0BENUW])|SCG14|SC-52C",
                "model": "Galaxy S22 Ultra"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S906(?:U1|[0BENUW])",
                "model": "Galaxy S22+"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S911|SCG19|SC-51D)",
                "model": "Galaxy S23"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S916",
                "model": "Galaxy S23+"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S918|SC-52D|SCG20)",
                "model": "Galaxy S23 Ultra"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S711|SCG24)",
                "model": "Galaxy S23 FE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S921|SCG25|SC-51E)",
                "model": "Galaxy S24"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S926)",
                "model": "Galaxy S24+"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S721|SCG30)",
                "model": "Galaxy S24 FE"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S928|SCG26)",
                "model": "Galaxy S24 Ultra"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S936)",
                "model": "Galaxy S25+"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S931)",
                "model": "Galaxy S25"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S937)",
                "model": "Galaxy S25 Edge"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S938)",
                "model": "Galaxy S25 Ultra"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F700(?:U1|[0FNUW])|SCV47",
                "model": "Galaxy Z Flip"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F707(?:U1|[0BNUW])|SCG04",
                "model": "Galaxy Z Flip 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-I200",
                "model": "Galaxy Stellar"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-I829",
                "model": "Galaxy Style Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SCH-R740|SGH-S730)",
                "model": "Galaxy Discover"
            },
            {
                "regex": "(?:SAMSUNG-)?SCH-S738",
                "model": "Galaxy Centura"
            },
            {
                "regex": "vollo Vi86(?:[);/ ]|$)",
                "model": "Vollo Vi86"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G386(?:T1|T)",
                "model": "Galaxy Avant"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A716S",
                "model": "Galaxy A Quantum"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A015(?:DL|[TU]1|[AFGMUV])|S111DL)",
                "model": "Galaxy A01"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A013[FGM]",
                "model": "Galaxy A01 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A025(?:[AFGM]|AZ)?|S124DL)",
                "model": "Galaxy A02s"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A037[F]?|SM-S13[45]DL)",
                "model": "Galaxy A03s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A035[F]?",
                "model": "Galaxy A03"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A047",
                "model": "Galaxy A04s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A042[FM]",
                "model": "Galaxy A04e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A045",
                "model": "Galaxy A04"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A032[F]?",
                "model": "Galaxy A03 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A022[GMF]?",
                "model": "Galaxy A02"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A055",
                "model": "Galaxy A05"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A057",
                "model": "Galaxy A05s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A066",
                "model": "Galaxy A06 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A260[FG]",
                "model": "Galaxy A2 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-S115(?:DL)?|SM-A115V)",
                "model": "Galaxy A11"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-[AS]146)",
                "model": "Galaxy A14 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A145)",
                "model": "Galaxy A14"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A156|SM-S156V)",
                "model": "Galaxy A15 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A155)",
                "model": "Galaxy A15"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A165)",
                "model": "Galaxy A16"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A166)",
                "model": "Galaxy A16 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A225[F]?",
                "model": "Galaxy A22"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A226L",
                "model": "Galaxy Buddy"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A226|SC-56B",
                "model": "Galaxy A22 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A300(?:FU|YZ|XU|XZ|[09FGHMXY])",
                "model": "Galaxy A3 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A310(?:N0|[FMXY])",
                "model": "Galaxy A3 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A320(?:FL|[FXY])",
                "model": "Galaxy A3 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A346",
                "model": "Galaxy A34 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A356",
                "model": "Galaxy A35 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A366",
                "model": "Galaxy A36 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A430F",
                "model": "Galaxy A4"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A500(?:YZ|[9LSWY])?|SM-A5OOH)(?:[);/ ]|$)",
                "model": "Galaxy A5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A500[0FGHKM]",
                "model": "Galaxy A5 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A500(?:FU|X)",
                "model": "Galaxy A5 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A510[08FKLMSXY]",
                "model": "Galaxy A5 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A520[FKLSWX]",
                "model": "Galaxy A5 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A525",
                "model": "Galaxy A52"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SC-53B|SM-A526)",
                "model": "Galaxy A52 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A528",
                "model": "Galaxy A52s 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A600(?:AZ|FN|GN|T1|[AFGNPTUX])|SM-A6(?:[);/ ]|$)",
                "model": "Galaxy A6"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A605(?:[FG]N|[08FGX])|SM-A6\\+",
                "model": "Galaxy A6+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G6200",
                "model": "Galaxy A6s (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A606[0Y]",
                "model": "Galaxy A60"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A700(?:YD|[09FHKLSX])",
                "model": "Galaxy A7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A710[08FKLMSXY]",
                "model": "Galaxy A7 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A720[FMSX]",
                "model": "Galaxy A7 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A750(?:GN|[CFGNX])",
                "model": "Galaxy A7 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A71(?:5[FW])?(?:[);/ ]|$)",
                "model": "Galaxy A71"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A725[FM](?:[);/ ]|$)",
                "model": "Galaxy A72"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A736",
                "model": "Galaxy A73 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A716(?:U1|[0BUVT])(?:[);/ ]|$)",
                "model": "Galaxy A71 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A(?:530F|800[0FISXY])|SCV32",
                "model": "Galaxy A8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G885[FSY]",
                "model": "Galaxy A8 Star"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A810(?:YZ|[FS])",
                "model": "Galaxy A8 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A8s|G887[0F])",
                "model": "Galaxy A8s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A530[MNWX]",
                "model": "Galaxy A8 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A730[FX]",
                "model": "Galaxy A8+ (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A900[0F]",
                "model": "Galaxy A9"
            },
            {
                "regex": "SM-A9\\[7\\]",
                "model": "Galaxy A9 7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A920[0FXN]",
                "model": "Galaxy A9 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G885[08]",
                "model": "Galaxy A9 Star"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A9 Pro|A910[0F]|G887N)",
                "model": "Galaxy A9 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A105[FGMN]",
                "model": "Galaxy A10"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A107[FM]",
                "model": "Galaxy A10s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S102DL|A102[NUW])",
                "model": "Galaxy A10e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A115(?:A[PZ]|U1|[AFMUW])",
                "model": "Galaxy A11"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A12(?:5[AFMNUWTPV]|7[FM])|S127DL)",
                "model": "Galaxy A12"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A136(?:U1|[BMWUS])|S136DL)",
                "model": "Galaxy A13 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A135|SM-A137F)",
                "model": "Galaxy A13"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A205(?:U1|YN|[FGSWU])|S205DL)|SC-02M|SCV46",
                "model": "Galaxy A20"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A215(?:DL|R4|U1|[UWTP])|SM-S215DL|SC-42A|SCV49|SM-A102J)(?:[);/ ]|$)",
                "model": "Galaxy A21"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A217",
                "model": "Galaxy A21s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A202[FG]",
                "model": "Galaxy A20e"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A207[0FM]",
                "model": "Galaxy A20s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A235",
                "model": "Galaxy A23"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A23[36]|SM-S236|SC-56C|SCG18",
                "model": "Galaxy A23 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A305(?:[FGY]N|GT|[FGN])|SCV43)",
                "model": "Galaxy A30"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A307(?:FN|GN|GT|[FG])",
                "model": "Galaxy A30s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A315[FGN](?:[);/ ]|$)",
                "model": "Galaxy A31"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A325",
                "model": "Galaxy A32"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-(?:A326(?:BR|U1|[BUWJ])|S326DL)|SCG08)",
                "model": "Galaxy A32 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A336",
                "model": "Galaxy A33 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A405(?:F[NM]|S)",
                "model": "Galaxy A40"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A305[018](?:[);/ ]|$)",
                "model": "Galaxy A40s"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A415F|SC-41A|SCV48)(?:[);/ ]|$)",
                "model": "Galaxy A41"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-[AS]426",
                "model": "Galaxy A42 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A505(?:F[GN]|U1|YN|[FGNUWX])|S506DL|505FN)",
                "model": "Galaxy A50"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A5070(?:[);/ ]|$)",
                "model": "Galaxy A50s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A507FN",
                "model": "Galaxy A50s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:A515[FUW]|S515DL)",
                "model": "Galaxy A51"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A516(?:U1|[0BNUVTF])|SC-54A|SCG07)",
                "model": "Galaxy A51 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A536V",
                "model": "Galaxy A53 5G UW"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A536|SC-53C|SCG15|SM-S536DL)",
                "model": "Galaxy A53 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A546S",
                "model": "Galaxy Quantum 4"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-[AS]546|SC-53D|SCG21)",
                "model": "Galaxy A54 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A556|SCG27)",
                "model": "Galaxy A55 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-A566)",
                "model": "Galaxy A56 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A705(?:GM|[MYF]N|[0FUWX])",
                "model": "Galaxy A70"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A707[0FW]",
                "model": "Galaxy A70s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A805[0FNX]",
                "model": "Galaxy A80"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A908[BN]",
                "model": "Galaxy A90"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A9080",
                "model": "Galaxy A90 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E025F",
                "model": "Galaxy F02s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E045F",
                "model": "Galaxy F04"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F127G(?:[);/ ]|$)",
                "model": "Galaxy F12"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E135F",
                "model": "Galaxy F13"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E146B",
                "model": "Galaxy F14 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E145F",
                "model": "Galaxy F14"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E156B",
                "model": "Galaxy F15 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E166P",
                "model": "Galaxy F16 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E225F(?:[);/ ]|$)",
                "model": "Galaxy F22"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E236",
                "model": "Galaxy F23 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E346",
                "model": "Galaxy F34 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F415F(?:[);/ ]|$)",
                "model": "Galaxy F41"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E426B(?:[);/ ]|$)",
                "model": "Galaxy F42 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E5260(?:[);/ ]|$)",
                "model": "Galaxy F52 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E546",
                "model": "Galaxy F54 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-E625",
                "model": "Galaxy F62"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9301I",
                "model": "Galaxy S III Neo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S120VL",
                "model": "Galaxy Luna"
            },
            {
                "regex": "(?:SAMSUNG-)?SGH-T399",
                "model": "Galaxy Light"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J100(?:FN|VPP|MU|[FGHMY])|S777C)",
                "model": "Galaxy J1"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J105[BFHYM]",
                "model": "Galaxy J1 Mini"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J106[BFHM]",
                "model": "Galaxy J1 mini Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J120(?:ZN|[AFGHMPTW])|J05H)",
                "model": "Galaxy J1 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J110[FGHLM]|J111[FM])",
                "model": "Galaxy J1 Ace"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J200[FGHMY]",
                "model": "Galaxy J2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J200BT",
                "model": "Galaxy J2 Duos"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J260AZ",
                "model": "Galaxy J2 Pure"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J260([AFGMY]|T1)|S260DL)",
                "model": "Galaxy J2 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J(?:210F|250[FGMNY])",
                "model": "Galaxy J2 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S367VL|S357BL)",
                "model": "Galaxy J3 Orbit"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J311(?:[09]|9S)",
                "model": "Galaxy J3 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S320VL(?:[);/ ]|$)",
                "model": "Galaxy J3 Sky"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S327VL(?:[);/ ]|$)",
                "model": "Galaxy J3 Luna Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327(?:T1|[ATW])(?:[);/ ]|$)",
                "model": "Galaxy J3 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327(?:[FP]|R4)",
                "model": "Galaxy J3 Emerge"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337R4(?:[);/ ]|$)",
                "model": "Galaxy J3 Aura"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337T(?:[);/ ]|$)",
                "model": "Galaxy J3 Star"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327VPP",
                "model": "Galaxy J3 Mission"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327V",
                "model": "Galaxy J3 Eclipse"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-S337TL",
                "model": "Galaxy J3 Luna Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J3109",
                "model": "Galaxy J3 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J300H|J320(?:[ZF]N|R4|W8|YZ|[AFGHMNPVY]))",
                "model": "Galaxy J3 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J330(?:FN|[08FGLN])|J327(?:R[76]|U))(?:[);/ ]|$)",
                "model": "Galaxy J3 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337(?:VPP|[AWPUV])(?:[);/ ]|$)",
                "model": "Galaxy J3 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G400[FG]|J400[FGM])",
                "model": "Galaxy J4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J500(?:FN|N0|[78FGHMY])(?:[);/ ]|$)",
                "model": "Galaxy J5 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J510(?:[FGMU]N|FQ|[8FGHKLSY])?|5108|G510H)(?:[);/ ]|$)",
                "model": "Galaxy J5 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J530[GY]",
                "model": "Galaxy J5 Pro (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J530|(?:lineage_)?j5y17lte",
                "model": "Galaxy J5 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G570[0FMY]",
                "model": "Galaxy J5 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J600[FGLN]",
                "model": "Galaxy J6"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J610[FG]",
                "model": "Galaxy J6+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J410[FG]",
                "model": "Galaxy J4 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J415(?:[FG]N|[FGN])",
                "model": "Galaxy J4+"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J710FN(?:[);/ ]|$)",
                "model": "Galaxy On8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J7[01]0(?:FN|MN|[8FHKM])",
                "model": "Galaxy J7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J700P",
                "model": "Galaxy J7 (2015)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J700(?:T1|T)|J710GN|J7109?)",
                "model": "Galaxy J7 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J730[K]|J727(?:R4|[AFSU]))(?:[);/ ]|$)",
                "model": "Galaxy J7 (2017)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J737(?:R4|T1|VPP|[APSTUV])(?:[);/ ]|$)",
                "model": "Galaxy J7 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C710F",
                "model": "Galaxy J7+ (C7)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G610[FMY]",
                "model": "Galaxy J7 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G611(?:FF|MT|M)",
                "model": "Galaxy J7 Prime 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G615F",
                "model": "Galaxy J7 Max"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S727VL|S737TL)",
                "model": "Galaxy J7 Sky Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:J7 Pro|J730(?:GM|[FG]))",
                "model": "Galaxy J7 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J701[FM]",
                "model": "Galaxy J7 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J720[FM]",
                "model": "Galaxy J7 Duo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:S767VL|S757BL)",
                "model": "Galaxy J7 Crown"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J727[PTV]",
                "model": "Galaxy J7 V"
            },
            {
                "regex": "SM-J7\\[7\\]",
                "model": "Galaxy J7 7"
            },
            {
                "regex": "SM-J8 Plus",
                "model": "Galaxy J8 Plus"
            },
            {
                "regex": "SM-J8 Pro",
                "model": "Galaxy J8 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J810|SM-J8(?:[);/ ]|$)",
                "model": "Galaxy J8"
            },
            {
                "regex": "SM-J9\\[7\\] Prime",
                "model": "Galaxy J9 7 Prime"
            },
            {
                "regex": "SM-J9\\[8\\] Pro",
                "model": "Galaxy J9 8 Pro"
            },
            {
                "regex": "SM-A326",
                "model": "Galaxy Jump 5G"
            },
            {
                "regex": "SM-M336K",
                "model": "Galaxy Jump 2"
            },
            {
                "regex": "SM-M446K",
                "model": "Galaxy Jump 3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M015[FG]",
                "model": "Galaxy M01"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M045F",
                "model": "Galaxy M04"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M055F",
                "model": "Galaxy M05"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M013F",
                "model": "Galaxy M01 Core"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M017F",
                "model": "Galaxy M01s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M025F",
                "model": "Galaxy M02s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M022[FGM]",
                "model": "Galaxy M02"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M105[FGMY]",
                "model": "Galaxy M10"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M107F",
                "model": "Galaxy M10s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M115[FM]",
                "model": "Galaxy M11"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M127[FGN]",
                "model": "Galaxy M12"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M135",
                "model": "Galaxy M13"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M136",
                "model": "Galaxy M13 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M146B",
                "model": "Galaxy M14 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M156B",
                "model": "Galaxy M15 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M166P",
                "model": "Galaxy M16 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:M205(?:[FGMN]|FN)|M20)(?:[);/ ]|$)",
                "model": "Galaxy M20"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M215F",
                "model": "Galaxy M21"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M215G",
                "model": "Galaxy M21 (2021)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M225",
                "model": "Galaxy M22"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M236L",
                "model": "Galaxy Buddy 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M236",
                "model": "Galaxy M23 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:M307(?:FN|[0F])|M30s)",
                "model": "Galaxy M30s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M305?",
                "model": "Galaxy M30"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M315F",
                "model": "Galaxy M31"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M325F",
                "model": "Galaxy M32"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M326",
                "model": "Galaxy M32 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M336",
                "model": "Galaxy M33 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M317F",
                "model": "Galaxy M31s"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M346",
                "model": "Galaxy M34 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M356",
                "model": "Galaxy M35 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M405",
                "model": "Galaxy M40"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M426",
                "model": "Galaxy M42 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M515F",
                "model": "Galaxy M51"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M526",
                "model": "Galaxy M52 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M536S",
                "model": "Galaxy Quantum 3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M536",
                "model": "Galaxy M53 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M546",
                "model": "Galaxy M54 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M625",
                "model": "Galaxy M62"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-M556",
                "model": "Galaxy M55 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W201([689])",
                "model": "Galaxy W201$1"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W2022",
                "model": "Galaxy W22"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W2020",
                "model": "Galaxy W20"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W2021",
                "model": "Galaxy W21"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-A826",
                "model": "Galaxy Quantum 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W2015",
                "model": "Galaxy Golden 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G910S",
                "model": "Galaxy Round"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G550(?:FY|T[12]?)|S550TL|G55[01]0|G5520)",
                "model": "Galaxy On5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G5528",
                "model": "Galaxy On5 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G600(?:FY|[0F])",
                "model": "Galaxy On7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G610[0KLS]",
                "model": "Galaxy On7 (2016)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G611[FKLS]",
                "model": "Galaxy On7 Prime"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C500[0X]",
                "model": "Galaxy C5"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C501[08]",
                "model": "Galaxy C5 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C5560",
                "model": "Galaxy C55 5G"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C700[0X]",
                "model": "Galaxy C7"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C701[08FX]",
                "model": "Galaxy C7 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C710[08]",
                "model": "Galaxy C8"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-C900[08FY]",
                "model": "Galaxy C9 Pro"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z130H",
                "model": "Galaxy Z1"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z200[FMY]",
                "model": "Galaxy Z2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z300H",
                "model": "Galaxy Z3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-Z400[FY]",
                "model": "Galaxy Z4"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:G150(?:N[0KLS])?|G155S)(?:[);/ ]|$)",
                "model": "Galaxy Folder"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-G16(?:0N|[05]0?|5N))(?:[);/ ]|$)",
                "model": "Galaxy Folder 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J321AZ(?:[);/ ]|$)",
                "model": "Galaxy Sol"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J326AZ(?:[);/ ]|$)",
                "model": "Galaxy Sol 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J336AZ(?:[);/ ]|$)",
                "model": "Galaxy Sol 3"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J727AZ(?:[);/ ]|$)",
                "model": "Galaxy Halo"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J327AZ",
                "model": "Galaxy Amp Prime 2"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-J337AZ",
                "model": "Galaxy Amp Prime 3 (2018)"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:F900[0FUW]|F907[BN])|SCV44",
                "model": "Galaxy Fold",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W9023",
                "model": "Galaxy W23 Fold",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W9025",
                "model": "Galaxy W25",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W9024",
                "model": "Galaxy W24 Fold",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W7023",
                "model": "Galaxy W23 Flip",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W7024",
                "model": "Galaxy W24 Flip",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F711|SCG12|SC-54B)",
                "model": "Galaxy Z Flip 3",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F721|SC-54C|SCG17)",
                "model": "Galaxy Z Flip 4",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F731|SCG23)",
                "model": "Galaxy Z Flip 5",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F741)",
                "model": "Galaxy Z Flip 6",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-F916(?:U1|[0BNQUW])|SCG05",
                "model": "Galaxy Z Fold 2 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F926|SC-55B|SCG11)",
                "model": "Galaxy Z Fold 3 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F936|SCG16|SC-55C)",
                "model": "Galaxy Z Fold 4",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F946|SCG22|SC-55D)",
                "model": "Galaxy Z Fold 5",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-F956|SCG28|SC-55E)",
                "model": "Galaxy Z Fold 6",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9060(?:[);/ ]|$)",
                "model": "Galaxy Grand Neo",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9063",
                "model": "Galaxy Grand Neo Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9(?:080|128)",
                "model": "Galaxy Grand",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9168",
                "model": "Galaxy Grand Neo+",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I9082",
                "model": "Galaxy Grand Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N7000",
                "model": "Galaxy Note",
                "device": "phablet"
            },
            {
                "regex": "(?:SC-01G|SCL24)(?:[);/ ]|$)",
                "model": "Galaxy Note Edge",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N935[FSLK](?:[);/ ]|$)",
                "model": "Galaxy Note Fan Edition",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:(?:GT-)?N7100|SCH-(?:I605|N719|R950)|SPH-L900|Galaxy Note 2)(?:[);/ ]|$)",
                "model": "Galaxy Note II",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-N7105",
                "model": "Galaxy Note II LTE",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G710(?:2T|5[HL]|[25689KLS])?(?:[);/ ]|$)",
                "model": "Galaxy Grand 2",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G720(?:AX|N0|[02])(?:[);/ ]|$)",
                "model": "Galaxy Grand Max"
            },
            {
                "regex": "(?:(?:SAMSUNG-)?SM-(?:G530(?:[689]W|[AF]Z|BT|MU|R[47]|[AFHMPTWY])|G531[FH]|S920L)|(?:rr_)?fortuna3g)(?:[);/ ]|$)",
                "model": "Galaxy Grand Prime",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G531(?:BT|[MY])(?:[);/ ]|$)",
                "model": "Galaxy Grand Prime VE Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G532F(?:[);/ ]|$)",
                "model": "Galaxy Grand Prime Plus",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G532MT(?:[);/ ]|$)",
                "model": "Galaxy J2 Prime (TV)",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G532[MG](?:[);/ ]|$)",
                "model": "Galaxy J2 Prime",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N7502(?:[);/ ]|$)",
                "model": "Galaxy Note 3 Neo Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N750[05LQ]?",
                "model": "Galaxy Note 3 Neo",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N9002(?:[);/ ]|$)",
                "model": "Galaxy Note 3 Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-9005(?:[);/ ]|$)",
                "model": "Galaxy Note 3 LTE",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-N900(?:W8|[05689][VQ]?|[AKLPSTV])?|SCL22|SC-01F|SC-02F)",
                "model": "Galaxy Note 3",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-(?:N910|910U)|N9100(?:[);/ ]|$)",
                "model": "Galaxy Note 4",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N916[KLS]",
                "model": "Galaxy Note 4 LTE",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N915",
                "model": "Galaxy Note 4 Edge",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N920(?:R[467]|W8|[0ACFGIKLPSTVX])",
                "model": "Galaxy Note 5",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-N9208",
                "model": "Galaxy Note 5 Duos",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G750(?:8Q|[9AFH])",
                "model": "Galaxy Mega 2",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I915[028]",
                "model": "Galaxy Mega 5.8",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-I920[05]",
                "model": "Galaxy Mega 6.3",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?(?:SM-N930(?:R[467]|W8|[0AFKLPSTUVX])|SCV34)",
                "model": "Galaxy Note 7",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-N950|SCV37|SC-01K",
                "model": "Galaxy Note 8",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N960|SCV40|SC-01L)|crownqlte",
                "model": "Galaxy Note 9",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N975(?:U1|XU|[0CFUWX])|SM-N976[0BVNQU]|SC-01M|SCV45)|Galaxy Note 10\\+",
                "model": "Galaxy Note 10+",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-(?:N970(?:U1|W8|[089DFJKLSUWX])|N971N)|Galaxy Note 10",
                "model": "Galaxy Note 10",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?SM-N770[FX]",
                "model": "Galaxy Note 10 Lite",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N981(?:B/DS|U1|[0BNUW]))",
                "model": "Galaxy Note 20 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N985(?:F/DS|F))|Galaxy Note 20 Ultra(?! 5G)",
                "model": "Galaxy Note 20 Ultra",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N980(?:F/DS|F)|Galaxy Note 20)",
                "model": "Galaxy Note 20",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG[- ])?(?:SM-N986(?:B/DS|U1|[0BCNUW])|SC-53A|SCG06)",
                "model": "Galaxy Note 20 Ultra 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-W750V",
                "model": "Ativ SE"
            },
            {
                "regex": "(?:SAMSUNG-)?SM-G310R5",
                "model": "GreatCall Touch 3"
            },
            {
                "regex": "(?:SAMSUNG-)?GT-E2152",
                "model": "E2152",
                "device": "feature phone"
            },
            {
                "regex": "Chromebook 3",
                "model": "Chromebook 3",
                "device": "desktop"
            },
            {
                "regex": "Chromebook Plus",
                "model": "Chromebook Plus",
                "device": "desktop"
            },
            {
                "regex": "(?:SAMSUNG-)?(GT-(P|N8|N5)[0-9]+[a-z]?)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "SC-02C",
                "model": "Galaxy S II"
            },
            {
                "regex": "(?:SAMSUNG-)?((?:SM-[TNP]|GT-P)[a-z0-9_-]+)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "((?:SCH|SGH|SPH|SHV|SHW|GT|SM)-[a-z0-9_-]+)",
                "model": "$1"
            },
            {
                "regex": "SMART-TV",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "Galaxy ([^/;)]+)(?: Build|[;)])",
                "model": "Galaxy $1"
            },
            {
                "regex": "Galaxy ([a-z0-9]+)",
                "model": "Galaxy $1"
            },
            {
                "regex": "SAMSUNG[\\-][ ]?([a-z0-9]+[\\-_][a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAMSUNG;[ ]?([a-z0-9]+[\\-_][a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAMSUNG[ _/\\-]?([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "SAMSUNG;(?! CPU OS)[ ]?([a-z0-9 ]+)",
                "model": "$1"
            },
            {
                "regex": "SEC_SC-([a-z0-9]+)",
                "model": "SC-$1"
            },
            {
                "regex": "SEC-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SAM-([a-z0-9]+)",
                "model": "SCH-$1"
            },
            {
                "regex": "(?:portalmmm|o2imode)/2\\.0 ([SZ][a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "sam([rua][0-9]+)",
                "model": "SCH-$1"
            }
        ]
    },
    "Sanei": {
        "regex": "(?:8312D|G(60[25]|70[3568]G?|785|803)|N83(?:-2cpu)?|N91) Build",
        "device": "smartphone",
        "models": [
            {
                "regex": "N83",
                "model": "N83"
            },
            {
                "regex": "N91",
                "model": "N91"
            },
            {
                "regex": "8312D",
                "model": "G101"
            },
            {
                "regex": "G(60[25]|70[3568]G?|785|803)",
                "model": "G$1"
            }
        ]
    },
    "Selfix": {
        "regex": "SELFIX",
        "device": "smartphone",
        "models": [
            {
                "regex": "SELFIX_SLASH6",
                "model": "Slash 6"
            },
            {
                "regex": "VOYAGER-V45",
                "model": "Voyager V45"
            },
            {
                "regex": "SELFIX_ES732_EXPERIUS",
                "model": "ES732 Experius"
            },
            {
                "regex": "SELFIX_Q5_URBAN",
                "model": "Q5 Urban"
            },
            {
                "regex": "SELFIX_Q3_REBEL",
                "model": "Q3 Rebel"
            },
            {
                "regex": "SELFIX_Q6_STALLION",
                "model": "Q6 Stallion"
            },
            {
                "regex": "SELFIX_V41_PRO_MARDIGRAS",
                "model": "V41 Pro Mardigras"
            }
        ]
    },
    "Senwa": {
        "regex": "Senwa|(?:S\\-?(?:471|7[12]5|6[01]5|915|905TL|1000|5018)|V705B|LS50F| LS50?|LS5518H|LS5718|LS5018FP?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S-?471(?:[);/ ]|$)",
                "model": "Jazz"
            },
            {
                "regex": "S-?605(?:[);/ ]|$)",
                "model": "City"
            },
            {
                "regex": "S-?905TL(?:[);/ ]|$)",
                "model": "Odin"
            },
            {
                "regex": "S-?1000(?:[);/ ]|$)",
                "model": "Odin"
            },
            {
                "regex": "S-?5018(?:[);/ ]|$)",
                "model": "Inizio"
            },
            {
                "regex": "LS5018FP(?:[);/ ]|$)",
                "model": "Inizio Plus"
            },
            {
                "regex": "LS5018F(?:[);/ ]|$)",
                "model": "Inizio LTE"
            },
            {
                "regex": "S-?(615|7[12]5|915)(?:[);/ ]|$)",
                "model": "S$1"
            },
            {
                "regex": "V705B(?:[);/ ]|$)",
                "model": "V705B"
            },
            {
                "regex": "LS50F(?:[);/ ]|$)",
                "model": "Evolution"
            },
            {
                "regex": "LS50(?:[);/ ]|$)",
                "model": "Pegasus"
            },
            {
                "regex": "LS5(?:[);/ ]|$)",
                "model": "Thor"
            },
            {
                "regex": "LS5518H(?:[);/ ]|$)",
                "model": "Sparkly"
            },
            {
                "regex": "LS5718(?:[);/ ]|$)",
                "model": "Diamond"
            },
            {
                "regex": "Senwa[ _-]*([^;/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Visual Land": {
        "regex": "(?:Prime10(?:SE|ES)|Elite(?:7QS|8QI|9QL|10QH(?:Pro)?))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Prime10(SE|ES)",
                "model": "Prestige Prime 10$1"
            },
            {
                "regex": "Elite10QHPro",
                "model": "Prestige Elite 10QH Pro"
            },
            {
                "regex": "Elite(7QS|8QI|9QL|10QH)",
                "model": "Prestige Elite $1"
            }
        ]
    },
    "UnoPhone": {
        "regex": "(?:Premier5Max|Premier5|Premier Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Premier5Max",
                "model": "Premier 5 Max"
            },
            {
                "regex": "Premier5",
                "model": "Premier 5"
            },
            {
                "regex": "Premier Pro",
                "model": "Premier Pro"
            }
        ]
    },
    "Sky": {
        "regex": "(?:SKY|Elite|Fuego)[_ ][3-7]\\.[05](?:[A-Z]{1,2})?|Elite[ _](?:Max|PHOTOPRO|5_0T|M45|[45]T|45T|GO|A63Max|M5Plus|T8Plus|T[46]|[ABCDHP]5|A6|5_5_Octa|Octa|[A-HJLNPTVR]55|[AB]65|[CG]63|T10)|Platinum[_ ](?:5\\.0M|5\\.5C|[56]\\.[05]\\+?|[ABCMP]4|[ACGKV]55|[ABDEFGHJKM]5|A7|A57|P9|X|UNO|VIEW2|O|4\\.0|4_0Plus)|PLATINUMVIEW|SKY[ _](?:55M|Pro_III|PAD10|PAD8)|SKYVISION|SKY B(?:lack|63)| SKY[ _]Prestige|Sky Vision2|PRO_SELFIE|Sky,",
        "device": "smartphone",
        "models": [
            {
                "regex": "Platinum[_ ](?:5\\.0M|M5)",
                "model": "Platinum 5.0M"
            },
            {
                "regex": "Platinum[_ ]5\\.5C",
                "model": "Platinum 5.5C"
            },
            {
                "regex": "Platinum[_ ]([56])\\.([05])\\+",
                "model": "Platinum $1.$2 Plus"
            },
            {
                "regex": "Platinum_4_0Plus",
                "model": "Platinum 4.0 Plus"
            },
            {
                "regex": "Platinum[ _]4\\.0",
                "model": "Platinum 4.0"
            },
            {
                "regex": "Platinum[_ ](P9) Pro(?:[);/ ]|$)",
                "model": "Platinum $1 Pro"
            },
            {
                "regex": "Platinum[_ ]B4P(?:[);/ ]|$)",
                "model": "Platinum B4"
            },
            {
                "regex": "Platinum[_ ]([ABCMP]4|[ACGK]55|[ABDEFGHJKM]5|A7|A57|P9|X|UNO|O|6\\.0)(?:[);/ ]|$)",
                "model": "Platinum $1"
            },
            {
                "regex": "Platinum[_ ]?VIEW(2)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Platinum View$1"
            },
            {
                "regex": "SKY[ _]PAD10Max",
                "device": "tablet",
                "model": "Pad 10 Max"
            },
            {
                "regex": "SKY[ _]PAD8Pro",
                "device": "tablet",
                "model": "Pad 8 Pro"
            },
            {
                "regex": "SKY[ _]PAD(10|8)",
                "device": "tablet",
                "model": "Pad $1"
            },
            {
                "regex": "SKYVISION",
                "device": "tablet",
                "model": "Vision"
            },
            {
                "regex": "Sky Vision2",
                "device": "tablet",
                "model": "Vision 2"
            },
            {
                "regex": "Elite_Octaplus(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Elite OctaPlus"
            },
            {
                "regex": "Elite[_ ]T8Plus(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Elite T8 Plus"
            },
            {
                "regex": "Elite_OctaXS(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Elite Octa XS"
            },
            {
                "regex": "Elite OctaX(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Elite Octa X"
            },
            {
                "regex": "Elite Octa(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Elite Octa"
            },
            {
                "regex": "Elite OctaMax(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Elite OctaMax"
            },
            {
                "regex": "Elite_5_5_Octa",
                "model": "Elite 5.5 Octa"
            },
            {
                "regex": "ELITE PHOTOPRO",
                "model": "Elite Photo Pro"
            },
            {
                "regex": "Elite M5Plus",
                "model": "Elite M5 Plus"
            },
            {
                "regex": "Elite ([ENP])55Max",
                "model": "Elite $155 Max"
            },
            {
                "regex": "Elite A63Max",
                "model": "Elite A63 Max"
            },
            {
                "regex": "SKY B63",
                "model": "Elite B63"
            },
            {
                "regex": "Elite[ _](Max|M45|Go|[45]T|T[46]|[ABCDHP]5|A6|[A-HJLNPTVR]55|[AB]65|[CG]63|45T)(?:[);/ ]|$)",
                "model": "Elite $1"
            },
            {
                "regex": "Elite (T10) Pro",
                "device": "tablet",
                "model": "Elite $1 Pro"
            },
            {
                "regex": "Elite (T10)",
                "device": "tablet",
                "model": "Elite $1"
            },
            {
                "regex": "Elite[_ ]([3-7])[\\._]([05](?:[A-Z]{1,2})?\\+?)",
                "model": "Elite $1.$2"
            },
            {
                "regex": "Fuego[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?\\+?)",
                "model": "Fuego $1"
            },
            {
                "regex": "SKY Black ?(2)?",
                "model": "Black $1"
            },
            {
                "regex": "SKY_Pro_III",
                "model": "Pro III"
            },
            {
                "regex": "PRO_SELFIE",
                "model": "Pro Selfie"
            },
            {
                "regex": "SKY 5\\.0Pro II",
                "model": "Pro II"
            },
            {
                "regex": "SKY 55M",
                "model": "55M"
            },
            {
                "regex": "Premier5",
                "model": "Premier 5"
            },
            {
                "regex": "SKY[ _]PrestigeX",
                "model": "Prestige X"
            },
            {
                "regex": "SKY[ _]Prestige",
                "model": "Prestige"
            },
            {
                "regex": "SKY[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?)",
                "model": "$1"
            },
            {
                "regex": "EM150",
                "model": "Q Mini",
                "device": "tv"
            },
            {
                "regex": "ES130",
                "model": "Q 1TB",
                "device": "tv"
            },
            {
                "regex": "ES140",
                "model": "Q 2TB",
                "device": "tv"
            },
            {
                "regex": "ES240",
                "model": "Q 2TB",
                "device": "tv"
            },
            {
                "regex": "ES340",
                "model": "Q 2TB V3",
                "device": "tv"
            },
            {
                "regex": "Sky, (XiOneUK|LlamaUK), (?:wired|wireless)",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "Skyworth": {
        "regex": "Sky_?worth|SWTV-|SKW690|(?:FlowBox-F1|SWTV|VGK02|SW-22AE NF)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "FlowBox-F1",
                "model": "FlowBox-F1"
            },
            {
                "regex": "VGK02",
                "model": "DGO Smart Stick"
            },
            {
                "regex": "SW-22AE NF",
                "model": "SWTV-22AE NF"
            },
            {
                "regex": "(SWTV-2[02]AE(?:-PRO|-FHD)?)",
                "model": "$1"
            },
            {
                "regex": "Sky_?worth ([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Smartfren": {
        "regex": "Smartfren|Androtab|Andromax|PD6D1J|AD682J|AD68[89]G|AD6B1H|AD9A1H|AD682H|AD683G",
        "device": "smartphone",
        "models": [
            {
                "regex": "S7 Build",
                "model": "Andromax Tab 7.0",
                "device": "tablet"
            },
            {
                "regex": "PD6D1J",
                "model": "Andromax V3s"
            },
            {
                "regex": "AD682J",
                "model": "Andromax T"
            },
            {
                "regex": "AD688G",
                "model": "Andromax C2"
            },
            {
                "regex": "AD689G",
                "model": "Andromax i3"
            },
            {
                "regex": "AD682H",
                "model": "Andromax i3s"
            },
            {
                "regex": "AD6B1H",
                "model": "Andromax G2 Hot"
            },
            {
                "regex": "AD9A1H",
                "model": "Andromax G2"
            },
            {
                "regex": "AD683G",
                "model": "Andromax I"
            },
            {
                "regex": "B26D2H",
                "model": "Andromax L"
            },
            {
                "regex": "New Andromax-i",
                "model": "New Andromax I"
            },
            {
                "regex": "Andromax[ _-]([^/;]+) Build",
                "model": "Andromax $1"
            },
            {
                "regex": "Andromax[ _-]([a-z0-9]+)",
                "model": "Andromax $1"
            },
            {
                "regex": "Smartfren[ _-]([^/;\\)]+)(?: Build|[/;\\)])",
                "model": "$1"
            },
            {
                "regex": "(Androtab[^/;]+) Build",
                "model": "$1",
                "device": "tablet"
            }
        ]
    },
    "Smartisan": {
        "regex": "Smartisan[_ ]|(SM(?:70[15]|[89]01|919)|OD10[35]|YQ60[1357]|DT2002C|DE106|DT190[12]A|O[CE]106|OS103|O[CS]105)[ /;\\)]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SM70[15]",
                "model": "T1"
            },
            {
                "regex": "SM801",
                "model": "T2"
            },
            {
                "regex": "SM901",
                "model": "M1"
            },
            {
                "regex": "SM919",
                "model": "M1L"
            },
            {
                "regex": "YQ60[1357]",
                "model": "U1"
            },
            {
                "regex": "OD10[35]",
                "model": "Pro"
            },
            {
                "regex": "OS105[ /;\\)]",
                "model": "Pro 2"
            },
            {
                "regex": "DE106[ /;\\)]",
                "model": "R1"
            },
            {
                "regex": "OE106[ /;\\)]",
                "model": "Nut Pro 2s"
            },
            {
                "regex": "OC10[56][ /;\\)]",
                "model": "Nut 3"
            },
            {
                "regex": "DT2002C[ /;\\)]",
                "model": "Nut 2"
            },
            {
                "regex": "DT190[12]A[ /;\\)]",
                "model": "Nut Pro 3"
            },
            {
                "regex": "OS103[ /;\\)]",
                "model": "JianGuo Pro 2"
            },
            {
                "regex": "Smartisan U3 Pro",
                "model": "U3 Pro"
            }
        ]
    },
    "STF Mobile": {
        "regex": "(?:AERIAL(?: PLUS)?|BLOCK_MINI|BLOCK GO|BLOCK 3|Fractal|Joy Pro|Origins Pro|SLAY II)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fractal",
                "model": "Fractal"
            },
            {
                "regex": "Origins Pro",
                "model": "Origins Pro"
            },
            {
                "regex": "AERIAL PLUS",
                "model": "Aerial Plus"
            },
            {
                "regex": "AERIAL",
                "model": "Aerial"
            },
            {
                "regex": "BLOCK_MINI",
                "model": "Block Mini"
            },
            {
                "regex": "BLOCK 3 mini",
                "model": "Block 3 Mini"
            },
            {
                "regex": "BLOCK 3",
                "model": "Block 3"
            },
            {
                "regex": "BLOCK GO",
                "model": "Block Go"
            },
            {
                "regex": "SLAY II",
                "model": "Slay II"
            },
            {
                "regex": "Joy Pro",
                "model": "Joy Pro"
            }
        ]
    },
    "STK": {
        "regex": "STK[_ ]|(?:Storm 2e Pluz|Life 7S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Life 8",
                "model": "Life 8"
            },
            {
                "regex": "Life 7S",
                "model": "Life 7S"
            },
            {
                "regex": "Storm 2e Pluz",
                "model": "Storm 2e Plus"
            },
            {
                "regex": "Sync 5z Plus",
                "model": "Sync 5z Plus"
            },
            {
                "regex": "STK[_ ]Transporter[_ ]1",
                "model": "Transporter 1"
            },
            {
                "regex": "STK[_ ]([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "STK[_ ]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Stonex": {
        "regex": "STX[ -]([^;/]+)|STONE EVO",
        "device": "smartphone",
        "models": [
            {
                "regex": "STX[ -]([^;/]+) Build",
                "model": "STX $1"
            },
            {
                "regex": "STX[ -]([a-z0-9_-]+)",
                "model": "STX $1"
            }
        ]
    },
    "SuperBOX": {
        "regex": "SuperBOX_S2PRO(?:[);/ ]|$)",
        "device": "tv",
        "model": "S2 Pro"
    },
    "Super General": {
        "regex": "SUPER GENERAL[;,]",
        "device": "tv",
        "model": ""
    },
    "SuperSonic": {
        "regex": "(SC-[0-9]+[a-z]+|SC-2110)",
        "device": "tablet",
        "model": "$1"
    },
    "Supra": {
        "regex": "SUPRA|NVTAB 7\\.0 3G|M74C 3G",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUPRA[ _]([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(NVTAB 7\\.0 3G|M74C 3G)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Sumvision": {
        "regex": "Cyclone (?:Voyager|X8)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Cyclone (?:Voyager 2|Voyager))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(Cyclone X8)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "SunVan": {
        "regex": "SUNVAN[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUNVAN[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "SUNVAN[ _-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "SWISSMOBILITY": {
        "regex": "(?:SCHR9G[RL]|PRA(?:U8|100|557|507)|ZUR(?:722M|70016W?|700[RW]|805A))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SCHR9G[RL]",
                "model": "SCHON R9"
            },
            {
                "regex": "PRA(U8|100|557|507)(?:[);/ ]|$)",
                "model": "PRA$1"
            },
            {
                "regex": "ZUR722M",
                "device": "phablet",
                "model": "Z72 go"
            },
            {
                "regex": "ZUR(70016W?|700[RW]|805A)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "ZUR$1"
            }
        ]
    },
    "Thomson": {
        "regex": "(?:Primo(7|8)|QM73[45]-8G|QM734-2|QM736-8G\\(HD\\)|(?<!\\.)8950|MID1002|5014G|TEO(?:13P|10[SM]|8M|7RK|X10[23]|104G)|Friendly_TH101|Delight TH201|TEOX10-MT8SL128LTE|HERO10RK|SPTEO10BK16|T43FSM5160|Origin_679(?:_Pro)?)(?:[);/ ]|$)|(?:Tlink|Every)[0-9]+|THOMSON[, ]",
        "device": "tablet",
        "models": [
            {
                "regex": "Primo(7|8)",
                "model": "Primo $1"
            },
            {
                "regex": "QM734-2",
                "model": "QM734-2"
            },
            {
                "regex": "QM734-8G",
                "model": "QM734-8G"
            },
            {
                "regex": "QM735-8G",
                "model": "QM735-8G"
            },
            {
                "regex": "QM736-8G\\(HD\\)",
                "model": "QM736-8G (HD)"
            },
            {
                "regex": "(?<!\\.)8950(?:[);/ ]|$)",
                "model": "3G 8950"
            },
            {
                "regex": "SPTEO10BK16",
                "model": "TEO10BK16"
            },
            {
                "regex": "TEOX10-MT8SL128LTE",
                "model": "TEOX10"
            },
            {
                "regex": "TEO(13P|10[SM]|7RK|104G|X10[23]|8M)(?:[);/ ]|$)",
                "model": "TEO$1"
            },
            {
                "regex": "HERO10RK",
                "model": "Hero 10RK"
            },
            {
                "regex": "(5014G|T510H)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "Tlink([0-9]+)",
                "device": "smartphone",
                "model": "Tlink$1"
            },
            {
                "regex": "Origin[_ ]679[_ ]Pro",
                "device": "smartphone",
                "model": "Origin 679 Pro"
            },
            {
                "regex": "Origin[_ ]679",
                "device": "smartphone",
                "model": "Origin 679"
            },
            {
                "regex": "Every([0-9]+)",
                "device": "smartphone",
                "model": "Every$1"
            },
            {
                "regex": "Delight TH201",
                "device": "smartphone",
                "model": "Delight TH201"
            },
            {
                "regex": "Friendly_TH101",
                "device": "smartphone",
                "model": "Friendly TH101"
            },
            {
                "regex": "THOMSON[ _]SEREA500",
                "device": "smartphone",
                "model": "Serea 500"
            },
            {
                "regex": "(T43FSM5160)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "THOMSON,([a-z0-9_ -]+)(?:\\*[0-9])?,(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Tanix": {
        "regex": "Tanix|(?:TX[53] MAX|TX[69]s|TX3 Mini|TX3MINI|TX5 Pro)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "TX([69])s",
                "model": "TX$1s"
            },
            {
                "regex": "Tanix (A3)",
                "model": "$1"
            },
            {
                "regex": "TX([35]) MAX",
                "model": "TX$1 Max"
            },
            {
                "regex": "TX5 Pro",
                "model": "TX5 Pro"
            },
            {
                "regex": "(?:Tanix_)?(?:TX3[ _]?Mini)",
                "model": "TX3 Mini"
            }
        ]
    },
    "Panavox": {
        "regex": "Panavox",
        "device": "tv",
        "models": [
            {
                "regex": "Panavox Android TV(?:[);/ ]|$)",
                "model": "Smart TV"
            }
        ]
    },
    "Pantech": {
        "regex": "Pantech|P[GN]-|PT-[a-z0-9]{3,}|(?<!Winmax )TX[T]?[0-9]+|IM-[a-z0-9]+(?:[);/ ]|$)|ADR910L",
        "device": "smartphone",
        "models": [
            {
                "regex": "ADR910L",
                "model": "Star Q"
            },
            {
                "regex": "IM-A860",
                "model": "Vega No 6"
            },
            {
                "regex": "IM-A850",
                "model": "Vega R3"
            },
            {
                "regex": "IM-A870K",
                "model": "Vega Iron"
            },
            {
                "regex": "Pantech[ -]?(P4100)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Pantech[ -]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Pantech_([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "(P[GTN]-[a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(TX[T]?[0-9]+) Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "(TX[T]?[0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(IM-[a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mosimosi": {
        "regex": "(?:momo3s)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "momo3s",
                "model": "momo3S"
            }
        ]
    },
    "Moxee": {
        "regex": "(?:MH-T6000|MT-T8B22|MT-T800)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MH-T6000",
                "model": "2160"
            },
            {
                "regex": "MT-T8(00|B22)",
                "device": "tablet",
                "model": "MT-T8$1"
            }
        ]
    },
    "Ployer": {
        "regex": "MOMO([0-9]|[ ]?mini[ ]?(?:S|3GS)?)",
        "device": "tablet",
        "models": [
            {
                "regex": "MOMOminiS",
                "model": "MOMO mini S"
            },
            {
                "regex": "momo mini 3GS",
                "model": "MOMO Mini 3GS"
            },
            {
                "regex": "MOMO([0-9][^);/]*)(?: Build|[;)])",
                "model": "MOMO $1"
            }
        ]
    },
    "Plum": {
        "regex": "PLUM[ _]|(?:Z51[89])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Z405",
                "model": "Gator 3"
            },
            {
                "regex": "Z407",
                "model": "Axe 4"
            },
            {
                "regex": "Z516",
                "model": "Compass"
            },
            {
                "regex": "Z518",
                "model": "Compass 2"
            },
            {
                "regex": "Z519",
                "model": "Gator 5"
            },
            {
                "regex": "Z811",
                "device": "tablet",
                "model": "Optimax 11"
            },
            {
                "regex": "Z709",
                "device": "tablet",
                "model": "Optimax 7"
            },
            {
                "regex": "Z712",
                "device": "tablet",
                "model": "Optimax 12"
            }
        ]
    },
    "Polaroid": {
        "regex": "Polaroid|POLPAROID|(?:PMID|MIDC)[0-9a-z]+(?:[);/ ]|$)|MID(?:1014|0714)|PRO[VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z])|(?:P(?:400[56]|4526|500[56]|502[56]|504[67]|552[56])A|P902/A900|PSPC(?:505|550|[MZL]20A0|K2[01]NA)|SIGMA 5|MIDI109PDE|MIDI156PDE|MIDB1048PHE|MIDS145PXE|MIDS747PX|MID4004JBL|MIDS185PR|PSPTD21NA|POMDTB00[56]|PSPCL30A0|PSN-H116|BDL0232PR|Mobility3G|BDL1064PR001|SMX4K)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "P4005A",
                "model": "Turbo C4"
            },
            {
                "regex": "P5005A",
                "model": "Turbo C5"
            },
            {
                "regex": "P4006A",
                "model": "Turbo D4"
            },
            {
                "regex": "PSPTD21NA",
                "model": "Turbo D2 Plus"
            },
            {
                "regex": "P4526A",
                "model": "Turbo E"
            },
            {
                "regex": "PSPC(505|550)",
                "model": "Cosmo $1"
            },
            {
                "regex": "PSPCL30A0",
                "model": "Cosmo C6"
            },
            {
                "regex": "P5006A",
                "model": "Cosmo K"
            },
            {
                "regex": "P5526A",
                "model": "Cosmo K Plus"
            },
            {
                "regex": "PSPCK20NA",
                "model": "Cosmo K2"
            },
            {
                "regex": "PSPCK21NA",
                "model": "Cosmo K2 Plus"
            },
            {
                "regex": "P5026A",
                "model": "Cosmo L"
            },
            {
                "regex": "PSPCL20A0",
                "model": "Cosmo L2"
            },
            {
                "regex": "PSPCM20A0",
                "model": "Cosmo M2"
            },
            {
                "regex": "P5046A",
                "model": "Cosmo P5s"
            },
            {
                "regex": "P5525A",
                "model": "Cosmo Q5s"
            },
            {
                "regex": "P5047A",
                "model": "Cosmo Z"
            },
            {
                "regex": "PSPCZ20A0",
                "model": "Cosmo Z2"
            },
            {
                "regex": "P5025A",
                "model": "L5s"
            },
            {
                "regex": "PRO4611(?:PR201)?",
                "model": "Pro4611"
            },
            {
                "regex": "PRO5023",
                "model": "Phantom 5"
            },
            {
                "regex": "PROV400",
                "model": "Agate"
            },
            {
                "regex": "PROV350",
                "model": "ProV350"
            },
            {
                "regex": "SIGMA 5(?:[);/ ]|$)",
                "model": "Sigma 5"
            },
            {
                "regex": "PRO([VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z]))",
                "model": "Pro$1"
            },
            {
                "regex": "PSPT350",
                "model": "Turbo 350 Gris"
            },
            {
                "regex": "PSN-H116",
                "model": "Snap"
            },
            {
                "regex": "SMX4K",
                "device": "tv",
                "model": "SmartBox S"
            },
            {
                "regex": "POLAROID, ([a-z0-9_ -]+), (?:wired|wireless)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "MIDS185PR|POLPAROID PURE",
                "model": "Pure 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "Mobility3G",
                "model": "Mobility 10.1\" 3G",
                "device": "tablet"
            },
            {
                "regex": "(MID(?:1014|0714|S145PXE|S747PX|4004JBL|B1048PHE|I109PDE|I156PDE)|POMDTB00[56]|BDL0232PR|BDL1064PR001)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "((?:PMID|MIDC)[0-9a-z]+)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(P902/A900)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Polaroid",
                "model": "",
                "device": "tablet"
            }
        ]
    },
    "PolyPad": {
        "regex": "POLY ?PAD",
        "device": "tablet",
        "models": [
            {
                "regex": "POLY ?PAD[_ .]([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "POLY ?PAD[_.]([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Polytron": {
        "regex": "POLYTRON|W8480|W7430|PW1100S|W7550|W7531|W8570|R2401|R255B",
        "device": "smartphone",
        "models": [
            {
                "regex": "R2508",
                "model": "Rocket"
            },
            {
                "regex": "POLYTRON[ _]R1500",
                "model": "Rocket Q-Five"
            },
            {
                "regex": "R2401",
                "model": "Rocket 2X"
            },
            {
                "regex": "POLYTRON[ _-]R2402",
                "model": "Rocket R2402"
            },
            {
                "regex": "POLYTRON[ _-]R2403",
                "model": "Rocket R1"
            },
            {
                "regex": "POLYTRON[ _-]R2406",
                "model": "Rocket R2"
            },
            {
                "regex": "POLYTRON[ _-]R2407",
                "model": "Rocket R3"
            },
            {
                "regex": "POLYTRON[ _-]R2452",
                "model": "Rocket S1"
            },
            {
                "regex": "POLYTRON[ _-]R2457",
                "model": "Rocket S2"
            },
            {
                "regex": "POLYTRON[ _-]R2501",
                "model": "Rocket T1"
            },
            {
                "regex": "POLYTRON[ _-]R2507",
                "model": "Rocket T3"
            },
            {
                "regex": "POLYTRON[ _-]R2509SE",
                "model": "Rocket T6 SE"
            },
            {
                "regex": "POLYTRON[ _-]R2509",
                "model": "Rocket T6"
            },
            {
                "regex": "POLYTRON[ _-]R250A",
                "model": "Rocket T7"
            },
            {
                "regex": "POLYTRON[ _-]R2506",
                "model": "Rocket T4"
            },
            {
                "regex": "POLYTRON[ _-](?:R3450|W1400)",
                "model": "Rocket Jetz"
            },
            {
                "regex": "POLYTRON[ _-]R3500",
                "model": "Rocket Jetz 5.0"
            },
            {
                "regex": "4G450",
                "model": "Zap 5"
            },
            {
                "regex": "W6500",
                "model": "Quadra Rocket"
            },
            {
                "regex": "W7452",
                "model": "Quadra S2"
            },
            {
                "regex": "W7550",
                "model": "Quadra V5"
            },
            {
                "regex": "W8570",
                "model": "Quadra V7"
            },
            {
                "regex": "POLYTRON[ _]L501",
                "model": "Rocket L501"
            },
            {
                "regex": "POLYTRON[ _]P520",
                "model": "Prime 7S"
            },
            {
                "regex": "POLYTRON[ _]P552",
                "model": "Prime 7 Pro"
            },
            {
                "regex": "4G500",
                "model": "Zap 6 Cleo"
            },
            {
                "regex": "W8480",
                "model": "Crystal 4 W8480"
            },
            {
                "regex": "W7531",
                "model": "Wizard V"
            },
            {
                "regex": "W7430",
                "model": "Quadra Mini W7430"
            },
            {
                "regex": "POLYTRON[ _]4G501",
                "model": "Zap 6 Posh"
            },
            {
                "regex": "POLYTRON[ _]4G502",
                "model": "Zap 6 Power"
            },
            {
                "regex": "POLYTRON[ _]4G503",
                "model": "Zap 6 Flaz"
            },
            {
                "regex": "POLYTRON[_ ]?[ _]4G550",
                "model": "Zap 6 Note"
            },
            {
                "regex": "POLYTRON[ _]4G551",
                "model": "Zap 6 Posh Note"
            },
            {
                "regex": "PW1100S",
                "model": "PW1100S"
            },
            {
                "regex": "Q2352",
                "model": "Q2352"
            },
            {
                "regex": "R255B",
                "model": "Prime T8"
            },
            {
                "regex": "POLYTRON[ _]T7800",
                "model": "Cosmica T7800",
                "device": "tablet"
            },
            {
                "regex": "POLYTRON[ _]T7700",
                "model": "Rocket Pad",
                "device": "tablet"
            }
        ]
    },
    "Positivo": {
        "regex": "(?:YPY_S450|Twist 4(?: Fit|Pro)?|Twist (?:4G|5 Max)|T1085|Positivo (?:Q20|Slim)|M10 4G PRO X|UP 32|YOLO|Android 4([\\d.]*);(?: [\\w-]+;)? X400)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YPY_S450",
                "model": "YPY S450"
            },
            {
                "regex": "X400(?:[);/ ]|$)",
                "model": "X400"
            },
            {
                "regex": "Positivo (Q20|Slim)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Twist 4 Mini",
                "model": "Twist 4 Mini"
            },
            {
                "regex": "Twist 5 Max",
                "model": "Twist 5 Max"
            },
            {
                "regex": "Twist 4 (Fit|Pro)",
                "model": "Twist 4 $1"
            },
            {
                "regex": "YOLO",
                "model": "Twist 4 Fit"
            },
            {
                "regex": "UP 32",
                "model": "Twist 4 Pro"
            },
            {
                "regex": "Twist 4G",
                "model": "Twist 4G"
            },
            {
                "regex": "Twist 4",
                "model": "Twist 4"
            },
            {
                "regex": "T1085",
                "device": "tablet",
                "model": "T1085"
            },
            {
                "regex": "M10 4G PRO X",
                "device": "tablet",
                "model": "M10 4G Pro X"
            }
        ]
    },
    "Prestigio": {
        "regex": "Prestigio 5500 DUO|(?:PMP|PAP|PMT|PSP|PGPS)[0-9]+[a-z0-9_]+(?:[);/ ]|$)|Muze C3|PTV50SS04X_CIS_BK|PTV50SS08X|PTV32SS08Z|PTV40SS04Y_CIS_ML|PTV32SS04Z_CIS_(?:ML|BK)|SILVER POS|PAB4411|GV7777",
        "device": "tablet",
        "models": [
            {
                "regex": "Prestigio 5500 DUO",
                "model": "MultiPhone 5500 Duo",
                "device": "smartphone"
            },
            {
                "regex": "P[AS]P(5517|5503|550[578])DUO(?:[);/ ]|$)",
                "model": "MultiPhone $1 Duo",
                "device": "smartphone"
            },
            {
                "regex": "PAP(7500)(?:[);/ ]|$)",
                "model": "MultiPhone $1",
                "device": "smartphone"
            },
            {
                "regex": "PSP5551DUO",
                "device": "smartphone",
                "model": "Grace S5"
            },
            {
                "regex": "PSP7590DUO",
                "device": "smartphone",
                "model": "Grace V7 LTE"
            },
            {
                "regex": "PSP7551DUO",
                "device": "smartphone",
                "model": "Grace S7 LTE"
            },
            {
                "regex": "PSP5470DUO",
                "device": "smartphone",
                "model": "Grace X5"
            },
            {
                "regex": "PSP5530DUO",
                "device": "smartphone",
                "model": "Grace Z5"
            },
            {
                "regex": "PSP3533DUO",
                "device": "smartphone",
                "model": "Grace Z3"
            },
            {
                "regex": "PSP5515DUO",
                "device": "smartphone",
                "model": "Grace P5"
            },
            {
                "regex": "PSP5552DUO",
                "device": "smartphone",
                "model": "Grace R5 LTE"
            },
            {
                "regex": "PSP5506DUO",
                "device": "smartphone",
                "model": "Grace Q5"
            },
            {
                "regex": "PSP5511DUO",
                "device": "smartphone",
                "model": "Grace M5 LTE"
            },
            {
                "regex": "PSP7501DUO",
                "device": "smartphone",
                "model": "Grace R7"
            },
            {
                "regex": "PSP7570DUO",
                "device": "smartphone",
                "model": "Grace P7 LTE"
            },
            {
                "regex": "PSP7572DUO",
                "device": "smartphone",
                "model": "Grace B7"
            },
            {
                "regex": "PSP3552DUO",
                "device": "smartphone",
                "model": "Muze H3"
            },
            {
                "regex": "PSP5523DUO",
                "device": "smartphone",
                "model": "Muze H5 LTE"
            },
            {
                "regex": "PSP3515DUO",
                "device": "smartphone",
                "model": "Muze M3 LTE"
            },
            {
                "regex": "PSP3495DUO",
                "device": "smartphone",
                "model": "Muze V3 LTE"
            },
            {
                "regex": "PSP3534DUO",
                "device": "smartphone",
                "model": "Muze K3 LTE"
            },
            {
                "regex": "PSP5513DUO",
                "device": "smartphone",
                "model": "Muze D5 LTE"
            },
            {
                "regex": "PSP5520DUO",
                "device": "smartphone",
                "model": "Muze B5"
            },
            {
                "regex": "PSP5518DUO",
                "device": "smartphone",
                "model": "Muze X5 LTE"
            },
            {
                "regex": "PSP5553DUO",
                "device": "smartphone",
                "model": "Muze F5 LTE"
            },
            {
                "regex": "PSP5502DUO",
                "device": "smartphone",
                "model": "Muze A5"
            },
            {
                "regex": "PSP5545DUO",
                "device": "smartphone",
                "model": "Muze E5 LTE"
            },
            {
                "regex": "PSP7512DUO",
                "device": "smartphone",
                "model": "Muze E7 LTE"
            },
            {
                "regex": "PSP3511DUO",
                "device": "smartphone",
                "model": "Muze G3 LTE"
            },
            {
                "regex": "PSP5522DUO",
                "device": "smartphone",
                "model": "Muze G5 LTE"
            },
            {
                "regex": "PSP7550DUO",
                "device": "smartphone",
                "model": "Muze G7 LTE"
            },
            {
                "regex": "PSP7510DUO",
                "device": "smartphone",
                "model": "Muze C7 LTE"
            },
            {
                "regex": "(?:Muze C3|PSP3504DUO)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Muze C3"
            },
            {
                "regex": "PSP3512DUO",
                "device": "smartphone",
                "model": "Muze B3"
            },
            {
                "regex": "PSP3532DUO",
                "device": "smartphone",
                "model": "Muze F3"
            },
            {
                "regex": "PSP3470DUO",
                "device": "smartphone",
                "model": "Muze J3"
            },
            {
                "regex": "PSP5524DUO",
                "device": "smartphone",
                "model": "Muze J5"
            },
            {
                "regex": "PSP7511DUO",
                "device": "smartphone",
                "model": "Muze B7"
            },
            {
                "regex": "PSP3514DUO",
                "device": "smartphone",
                "model": "Wize U3"
            },
            {
                "regex": "PSP3513DUO",
                "device": "smartphone",
                "model": "Wize V3"
            },
            {
                "regex": "PSP3416DUO",
                "device": "smartphone",
                "model": "Wize YA3"
            },
            {
                "regex": "PSP3406DUO",
                "device": "smartphone",
                "model": "Wize Y3"
            },
            {
                "regex": "PSP3423DUO",
                "device": "smartphone",
                "model": "Wize R3"
            },
            {
                "regex": "PSP3471DUO",
                "device": "smartphone",
                "model": "Wize Q3 LTE"
            },
            {
                "regex": "PSP3510DUO",
                "device": "smartphone",
                "model": "Wize G3"
            },
            {
                "regex": "PSP3537DUO",
                "device": "smartphone",
                "model": "Wize NV3"
            },
            {
                "regex": "PSP3528DUO",
                "device": "smartphone",
                "model": "Wize PX3"
            },
            {
                "regex": "PSP3527DUO",
                "device": "smartphone",
                "model": "Wize NK3"
            },
            {
                "regex": "PSP3468DUO",
                "device": "smartphone",
                "model": "Wize OK3"
            },
            {
                "regex": "SILVER POS",
                "model": "Silver POS"
            },
            {
                "regex": "PMT3277_3G",
                "model": "MultiPad Ranger 7.0\" 3G"
            },
            {
                "regex": "PMT4337_3G",
                "model": "Seed A7 3G"
            },
            {
                "regex": "PMT3997_W_D",
                "model": "SmartKids"
            },
            {
                "regex": "PMT3103_W",
                "model": "SmartKids Max"
            },
            {
                "regex": "PMT3104_Wi_D",
                "model": "SmartKids Up"
            },
            {
                "regex": "PMT4511_4G",
                "model": "SmartKids Pro"
            },
            {
                "regex": "PMT4208",
                "model": "Node A8 3G"
            },
            {
                "regex": "PMT4771",
                "model": "Root A10 3G"
            },
            {
                "regex": "PMP7070C3G",
                "model": "MultiPad 4 Diamond 7.0\" 3G"
            },
            {
                "regex": "PGPS7799CIS08GBPG(?:[);/ ]|$)",
                "model": "Geo Vision Tour 3"
            },
            {
                "regex": "GV7777(?:[);/ ]|$)",
                "model": "Geo Vision 7777"
            },
            {
                "regex": "PGPS7797(?:[);/ ]|$)",
                "model": "Geo Vision Tour 2"
            },
            {
                "regex": "PMT(3118|38[74]8|3[123]01|3[12]57|778[18]|4[789]91|5588|5718|5791|577[18]|4327|3768)[_ ]([34])G",
                "model": "Grace $1 $2G"
            },
            {
                "regex": "PMT3287_3G",
                "model": "MultiPad Ranger 8.0 3G"
            },
            {
                "regex": "PMT4238_4G",
                "model": "Q Pro"
            },
            {
                "regex": "PMT(1177|3208|3618|31[357]1|1157|1196|3[10]96|3[17]61|3407)[_ ]([34])GE?",
                "model": "MultiPad Wize $1 $2G"
            },
            {
                "regex": "PMT(1107|3[456]37|3[34]27|3317|4638|4311|413[17]|411[178]|3771)[_ ]([34])GE?",
                "model": "Wize $1 $2G"
            },
            {
                "regex": "PMT(3231|37[01]8|4231|4667|38[3678]1)[_ ]([34])GE?",
                "model": "Muze $1 $2G"
            },
            {
                "regex": "PSP7546DUO([ _][A-Z]{2})?",
                "model": "X Pro"
            },
            {
                "regex": "PSP7610DUO([ _][A-Z]{2})?",
                "model": "S Max"
            },
            {
                "regex": "PTV(\\w+)_CIS_(ML|BK)",
                "device": "tv",
                "model": "PTV$1CIS$2"
            },
            {
                "regex": "(PAB4411)",
                "device": "tv",
                "model": "MultiCenter $1"
            },
            {
                "regex": "(PTV32SS08Z|PTV50SS08X)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "(PM[PT][0-9]+[a-z0-9_]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "((?:PAP|PSP)[0-9]+[a-z0-9_]+(?: DUO)?)(?:[);/ ]|$)",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Sanyo": {
        "regex": "Sanyo|MobilePhone[ ;]",
        "device": "feature phone",
        "models": [
            {
                "regex": "SCP-?6750",
                "model": "Katana Eclipse X"
            },
            {
                "regex": "SCP-?6760",
                "model": "Incognito"
            },
            {
                "regex": "SCP-?6780",
                "model": "Innuendo"
            },
            {
                "regex": "SANYO[ /_-]([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "MobilePhone ([a-z0-9-]+)",
                "model": "$1"
            }
        ]
    },
    "Vankyo": {
        "regex": "Vankyo[_ ]|(?:QTAB1010X|S10_ROW|S[23]0_EEA|Z[14]_EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Vankyo[_ ]S(10|[78])",
                "model": "MatrixPad S$1"
            },
            {
                "regex": "(S[23]0|Z[14])_EEA",
                "model": "MatrixPad $1"
            },
            {
                "regex": "QTAB(1010X)",
                "model": "QTab $1"
            },
            {
                "regex": "S10_ROW",
                "model": "MatrixPad S10"
            }
        ]
    },
    "Quest": {
        "regex": "Android 1[012](?:[\\d.]*);(?: [\\w-]+;)? RAPTOR(?! LTD)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RAPTOR",
                "model": "Raptor"
            }
        ]
    },
    "QMobile": {
        "regex": "QMobile|QTab(?!10EW)|Q-?Smart|LINQ (?:L10|X100)|(?:Mark [25]|E2 Noir|Noir[ _](A[18]|X1S)|LUNA PRO|NICE S|JazzX JS(?:[27]|10)(?: PRO)?|LT[57]00[ _]PRO|LT950|Infinity (?:Cinema 2|triple|santos|Prime 2)|Q Infinity|Hot 5|Hot Pro 2|VITA S|i7i 2020|i10[ _]20(?:20|19)|V2 2018|Z12 PRO|Smart HD Pro|V[67]_Metal|Rocket (?:Lite|Pro)| GLi|i6i 2020|i6 Metal|Android 6(?:[\\d.]*);(?: [\\w-]+;)? (?:J5|S2 Pro|J7 PRO|M350 Pro)|Android 5(?:[\\d.]*);(?: [\\w-]+;)? Z9 Plus|i8i Dual|View Max Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "JazzX JS7 PRO",
                "model": "Jazz X JS7 Pro"
            },
            {
                "regex": "JazzX JS(2|10)",
                "model": "Jazz X JS$1"
            },
            {
                "regex": "Noir A1 lite",
                "model": "Noir A1 Lite"
            },
            {
                "regex": "Noir[ _](A[18]|X1S)(?:[);/ ]|$)",
                "model": "Noir $1"
            },
            {
                "regex": "Z9 Plus",
                "model": "Z9 Plus"
            },
            {
                "regex": "A600(?:[);/ ]|$)",
                "model": "Noir A600"
            },
            {
                "regex": "Z12 PRO",
                "model": "Noir Z12 Pro"
            },
            {
                "regex": "QMobile (Z9|J2)",
                "model": "Noir $1"
            },
            {
                "regex": "E2 Noir",
                "model": "E2 Noir"
            },
            {
                "regex": "Hot Pro 2",
                "model": "Hot Pro 2"
            },
            {
                "regex": "(J7|S2) Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "Hot 5",
                "model": "Hot 5"
            },
            {
                "regex": "LT([57]00)[ _]PRO",
                "model": "Noir LT$1 Pro"
            },
            {
                "regex": "View Max Pro",
                "model": "View Max Pro"
            },
            {
                "regex": "X700 PRO II",
                "model": "X700 Pro II"
            },
            {
                "regex": "X700 PRO Lite",
                "model": "X700 Pro Lite"
            },
            {
                "regex": "X700 PRO",
                "model": "X700 Pro"
            },
            {
                "regex": "M350 Pro",
                "model": "M350 Pro"
            },
            {
                "regex": "LUNA PRO",
                "model": "Luna Pro"
            },
            {
                "regex": "VITA S",
                "model": "Vita S"
            },
            {
                "regex": "NICE S",
                "model": "Nice S"
            },
            {
                "regex": "V([67])_Metal",
                "model": "V$1 Metal"
            },
            {
                "regex": "i(\\d+)i 20(20|1[89])",
                "model": "i$1i (20$2)"
            },
            {
                "regex": "i10[ _]20(20|19)",
                "model": "i10 (20$1)"
            },
            {
                "regex": "i6i 2020",
                "model": "i6i (2020)"
            },
            {
                "regex": "i8i PRO",
                "model": "i8i Pro"
            },
            {
                "regex": "i8i Dual",
                "model": "i8i Dual"
            },
            {
                "regex": "QMobile I8i",
                "model": "i8i"
            },
            {
                "regex": "i6 Metal ONE",
                "model": "i6 Metal One"
            },
            {
                "regex": "i6 Metal HD",
                "model": "i6 Metal HD"
            },
            {
                "regex": "i6 Metal (201[78])",
                "model": "i6 Metal ($1)"
            },
            {
                "regex": "Smart HD Pro",
                "model": "Smart HD Pro"
            },
            {
                "regex": "Rocket Pro",
                "model": "Rocket Pro"
            },
            {
                "regex": "Rocket Lite",
                "model": "Rocket Lite"
            },
            {
                "regex": "Mark ([25])",
                "model": "Mark $1"
            },
            {
                "regex": "QSmart (X[124]0)",
                "model": "$1"
            },
            {
                "regex": "Infinity Cinema 2",
                "model": "Infinity Cinema 2"
            },
            {
                "regex": "Infinity Prime 2",
                "model": "Infinity Prime 2"
            },
            {
                "regex": "Infinity triple",
                "model": "Infinity Triple"
            },
            {
                "regex": "Infinity santos",
                "model": "Infinity Santos"
            },
            {
                "regex": "Q Infinity PRO",
                "model": "Q Infinity Pro"
            },
            {
                "regex": "Q Infinity E Lite",
                "model": "Q Infinity E Lite"
            },
            {
                "regex": "Q Infinity ([FCB])",
                "model": "Q Infinity $1"
            },
            {
                "regex": "(LT950|J5)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "LINQ (L10|X100)",
                "model": "Linq $1"
            },
            {
                "regex": "GLi Lite(?:[);/ ]|$)",
                "model": "GLi Lite"
            },
            {
                "regex": "GLi(?:[);/ ]|$)",
                "model": "GLi"
            },
            {
                "regex": "V2 2018(?:[);/ ]|$)",
                "model": "V2 (2018)"
            },
            {
                "regex": "QMobile ENERGY (X[12])(?:[);/ ]|$)",
                "model": "Energy $1"
            },
            {
                "regex": "QTab[ _-]([^;/]+) Build",
                "model": "$1 Tab",
                "device": "tablet"
            },
            {
                "regex": "QTab[ _-]([^;/)]+)(?:[;/)]|$)",
                "model": "$1 Tab",
                "device": "tablet"
            },
            {
                "regex": "(?:QMobile|Q-?Smart)[ _-]([^;/)]+) Plus(?: Build|[;)])",
                "model": "$1 Plus"
            },
            {
                "regex": "(?:QMobile|Q-?Smart)[ _-]([^;/)]+) PRO(?: Build|[;)])",
                "model": "$1 Pro"
            },
            {
                "regex": "(?:QMobile|Q-?Smart)[ _-]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Q Infinity",
                "model": "Q Infinity"
            }
        ]
    },
    "COYOTE": {
        "regex": "COYOTE[ _]",
        "device": "tablet",
        "models": [
            {
                "regex": "1090 DVR Maximus Pro",
                "model": "1090 DVR Maximus Pro"
            }
        ]
    },
    "Matco Tools": {
        "regex": "(Maximus 3\\.0)",
        "device": "tablet",
        "model": "$1"
    },
    "Maximus": {
        "regex": "Maximus[ _]|(Noir X|G10 max|iX Ultra)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Maximus[ _])?(Noir X|D1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "G10 max(?:[);/ ]|$)",
                "model": "G10 Max"
            },
            {
                "regex": "iX Ultra",
                "model": "iX Ultra"
            },
            {
                "regex": "Maximus_(T2)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "TOOGO": {
        "regex": "TOOGO[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "TOOGO[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Quantum": {
        "regex": "Qrash|(?:Quantum (?:Fit|Five|Fly|UP|MUV (?:PRO|UP)|Go|Mini|M|V|You [2E])|GO 2|Q[23]0|LIO\\+|Q-TITANO(_007i|-H2)?|Q-Pulse70M|Q-Wave(?:101|71M))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LIO\\+(?:[);/ ]|$)",
                "model": "Lio Plus"
            },
            {
                "regex": "GO 2(?:[);/ ]|$)",
                "model": "Go 2"
            },
            {
                "regex": "Qrash(?:[);/ ]|$)",
                "model": "Qrash"
            },
            {
                "regex": "Quantum (Fit|Five|Go|Mini|[MV]|Fly|You [2E]|Q[23]0)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Quantum MUV PRO(?:[);/ ]|$)",
                "model": "MUV Pro"
            },
            {
                "regex": "Quantum MUV UP(?:[);/ ]|$)",
                "model": "MUV Up"
            },
            {
                "regex": "Quantum UP(?:[);/ ]|$)",
                "model": "Up"
            },
            {
                "regex": "Q-TITANO[ _-](BOS|X|M1|007i|H[12]|AK47)(?:[);/ ]|$)",
                "model": "Q-Titano $1"
            },
            {
                "regex": "Q-Pulse70M(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Q-Pulse 70M"
            },
            {
                "regex": "Q-Wave(101|71M)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Q-Wave $1"
            }
        ]
    },
    "Quechua": {
        "regex": "Quechua Phone 5",
        "device": "smartphone",
        "model": "Quechua Phone 5"
    },
    "Quipus": {
        "regex": "TINKU LTE(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TINKU LTE(?:[);/ ]|$)",
                "model": "Tinku"
            }
        ]
    },
    "R3Di": {
        "regex": "R3Di_FR150(?:[);/ ]|$)",
        "device": "feature phone",
        "model": "FR150"
    },
    "Ramos": {
        "regex": "Ramos ?([^/);]+)(?: Build|[);])|(?:MOS1(?:max)?|W22PRO 3G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Ramos[ _])?(R10|R9|M7)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(MOS1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MOS1max",
                "model": "MOS1 Max"
            },
            {
                "regex": "W22PRO 3G",
                "device": "tablet",
                "model": "W22 Pro 3G"
            },
            {
                "regex": "Ramos ?([^/;]+)(?: Build|[);])",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Volla": {
        "regex": "Volla Phone",
        "device": "smartphone",
        "models": [
            {
                "regex": "Volla Phone (22|X23)",
                "model": "Phone $1"
            }
        ]
    },
    "I-Plus": {
        "regex": "(?:Nu65|iPlus P3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "iPlus P3",
                "model": "P3"
            },
            {
                "regex": "(Nu65)",
                "model": "$1"
            }
        ]
    },
    "Razer": {
        "regex": "(?:(?<!T )Phone 2|Razer Edge 5G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Razer Edge 5G",
                "device": "console",
                "model": "Edge 5G"
            },
            {
                "regex": "Phone 2",
                "model": "Phone 2"
            }
        ]
    },
    "Sendo": {
        "regex": "Sendo([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Silent Circle": {
        "regex": "Blackphone 2",
        "device": "smartphone",
        "model": "Blackphone 2"
    },
    "Ophone": {
        "regex": "(?:(?:Sigma|Beeta)_4_0|Active 5\\.0)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Sigma_4_0",
                "model": "Sigma 4.0"
            },
            {
                "regex": "Beeta_4_0",
                "model": "Beeta 4.0"
            },
            {
                "regex": "Active 5\\.0",
                "model": "Active 5.0"
            }
        ]
    },
    "Sigma": {
        "regex": "Sigma(?!Designs)|(X[_-]Style[ _]?Tab[_ ]A(\\d+)|Tab_A1025_X-treme|X[-_ ]?treme[-_ ]?(?:PQ[0-9]{2}|PQ18_MAX)|X-Style_(?:S550[12]|S3502)|Tab A1015|Tab A802|Tab_A1010_Neo)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SIGMAMOBILE-S3500-3G(?:[);/ ]|$)",
                "model": "X-Style"
            },
            {
                "regex": "(?:Sigma[ _])?X[-_ ]?treme[-_ ]?PQ([0-9]{2})[_ ]Max(?:[);/ ]|$)",
                "model": "X-Treme PQ$1 Max"
            },
            {
                "regex": "(?:Sigma[ _])?X[-_ ]?treme[-_ ]?PQ([0-9]{2})(?:[);/ ]|$)",
                "model": "X-Treme PQ$1"
            },
            {
                "regex": "X[_-]Style[ _]?Tab[_ ]A(\\d+)(?:[);/ ]|$)",
                "model": "X-Style Tab A$1",
                "device": "tablet"
            },
            {
                "regex": "Tab_A1025_X-treme",
                "model": "X-Treme Tab A1025",
                "device": "tablet"
            },
            {
                "regex": "Tab (A1015|A802)(?:[);/ ]|$)",
                "model": "Tab $1",
                "device": "tablet"
            },
            {
                "regex": "Tab_A1010_Neo(?:[);/ ]|$)",
                "model": "Tab A1010 Neo",
                "device": "tablet"
            },
            {
                "regex": "(?:Sigma[ _])?X[-_ ]?Style[-_ ]S([0-9]+)(?:[);/ ]|$)",
                "model": "X-Style S$1"
            }
        ]
    },
    "Spice": {
        "regex": "(?<![\\d];)Spice(?!bird)|(?:Xlife[-_ ](?:\\d+Q?|Victor5|M5q\\+|M5 Pro|Proton5|Electro55HD))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Spice_)?Xlife[-_ ](\\d+Q?|M5\\+)(?:[);/ ]|$)",
                "model": "Xlife $1"
            },
            {
                "regex": "Xlife-M5q\\+",
                "model": "Xlife M5Q+"
            },
            {
                "regex": "Xlife-M5 Pro",
                "model": "Xlife M5 Pro"
            },
            {
                "regex": "Xlife-Victor5",
                "model": "Xlife Victor 5"
            },
            {
                "regex": "Xlife-Proton5 Pro",
                "model": "Xlife Proton 5 Pro"
            },
            {
                "regex": "Xlife-Electro55HD",
                "model": "Xlife Electro 55 HD"
            },
            {
                "regex": "Spice[-_ ]?Mi-?(7\\d{2})N(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Mi-$1N"
            },
            {
                "regex": "Spice[-_ ]?Mi-?(7\\d{2})(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Mi-$1"
            },
            {
                "regex": "Spice[-_ ]?Mi-?(\\d{3})N(?:[);/ ]|$)",
                "model": "Mi-$1N"
            },
            {
                "regex": "Spice[-_ ]?Mi-?(\\d{3})(?:[);/ ]|$)",
                "model": "Mi-$1"
            },
            {
                "regex": "Spice[-_ ]?([^/;]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Spice[-_ ]?([^/;]+)(?:/|$)",
                "model": "$1"
            }
        ]
    },
    "SGIN": {
        "regex": "SGIN_(?:E10M|X10)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SGIN_E10M",
                "model": "E10M"
            },
            {
                "regex": "SGIN_X10",
                "model": "X10"
            }
        ]
    },
    "F+": {
        "regex": "(?:(?:SH6[05]|SA50|SP65)_(?:2[13]|66)\\d{3}|H166|R570E|P670|LifeTabPlus|(?:SH6[05]|SA55) \\dGB/\\d{2}GB \\d{4}mAh [HG]MS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SA55 2GB",
                "model": "SA55"
            },
            {
                "regex": "SH(6[05]) 2GB",
                "model": "SH$1"
            },
            {
                "regex": "(H166|P670|R570E)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(SH6[05]|SA50|SP65)_(?:2[13]|66)\\d{3}",
                "model": "$1"
            },
            {
                "regex": "LifeTabPlus",
                "device": "tablet",
                "model": "Life Tab Plus"
            }
        ]
    },
    "Sharp": {
        "regex": "SHARP(?!_2|1)|SBM|SH-?[0-9]+[a-z]?(?:[);/ ]|$)|AQUOS|(?:SH-T01|SH-M26|SH-M0[14-9]|SH-M1[1-7](?:-y)?|S[357]-SH|SH-[MZ]([12]0|01|22)|SH-C0[3-6]|SH-[CL]02|SH-RM(?:1[1258]|02)|SH-R?M19s?|SH-R10A|[34]04SH|401SH|[45]02SH|306SH|[36]05SH|70[1246]SH|80[138]SH|90[1678]SH|50[3679]SH|SHL2[1235]|SHV4[0-8]|SHV3[1-9](?:[-_]u)?|FS80(?:1[08]|32|28|0[29])|TG-L900S|NP601SH|403SH|603SH|SHF3[1-4]|SHV4[035][-_]u|SW001SH|SHG0[1-9]|X4-SH|A002SH|DM-01[JH]|A[01]01SH|606SH|FS801[56]|d-41A|d-51C|NP80[567]SH|NP501SH|A00[34]SH|A102SH|IS05|SH-(?:S50|53A|51B|[HDA]01|01FDQ|S40P|M24)|LP-0[12]|FS8014|SBM00[35]SH|SBM103SH|A10[345]SH|lineage_ss2|LCD_xxSUFOC475A|A20[1248]SH|FS802[56]|ADS1|STTM21VAPP|NPA205SH|SHG10|SHT21|A30[12]SH|SH-M29)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "506SH(?:[);/ ]|$)",
                "model": "Aquos Xx3"
            },
            {
                "regex": "STTM21VAPP",
                "model": "Rouvo V"
            },
            {
                "regex": "603SH(?:[);/ ]|$)",
                "model": "Aquos Xx3 Mini"
            },
            {
                "regex": "50[23]SH(?:[);/ ]|$)",
                "model": "Aquos Xx2"
            },
            {
                "regex": "[34]04SH(?:[);/ ]|$)",
                "model": "Aquos Xx"
            },
            {
                "regex": "606SH(?:[);/ ]|$)",
                "model": "Aquos ea"
            },
            {
                "regex": "507SH(?:[);/ ]|$)",
                "model": "Android One"
            },
            {
                "regex": "S3-SH(?:[);/ ]|$)",
                "model": "Android One S3"
            },
            {
                "regex": "S5-SH(?:[);/ ]|$)",
                "model": "Android One S5"
            },
            {
                "regex": "S7-SH(?:[);/ ]|$)",
                "model": "Android One S7"
            },
            {
                "regex": "X4-SH(?:[);/ ]|$)",
                "model": "Android One X4"
            },
            {
                "regex": "(?:SHG06|A10[34]SH|SH-M20)(?:[);/ ]|$)",
                "model": "Aquos Wish"
            },
            {
                "regex": "(?:SH-51C|A204SH|SHG08)(?:[);/ ]|$)",
                "model": "Aquos Wish 2"
            },
            {
                "regex": "SH-M04(?:[);/ ]|$)",
                "model": "Aquos SH-M04"
            },
            {
                "regex": "SH-M05(?:[);/ ]|$)",
                "model": "Aquos Sense Lite"
            },
            {
                "regex": "SH-(?:M26|54D)(?:[);/ ]|$)",
                "model": "Aquos Sense 8"
            },
            {
                "regex": "SH-M29(?:[);/ ]|$)",
                "model": "Aquos Sense 9"
            },
            {
                "regex": "SH-M07(?:[);/ ]|$)",
                "model": "Aquos Sense Plus"
            },
            {
                "regex": "A003SH(?:[);/ ]|$)",
                "model": "Aquos Sense 4 Basic"
            },
            {
                "regex": "SH-41A(?:[);/ ]|$)",
                "model": "Aquos Sense 4"
            },
            {
                "regex": "SH-S40P(?:[);/ ]|$)",
                "model": "Aquos Sense 4 Plus"
            },
            {
                "regex": "(?:SH-54B|SHG05|SH-R?M19)(?:[);/ ]|$)",
                "model": "Aquos Sense 6"
            },
            {
                "regex": "(?:SHG07|SH-RM19s)(?:[);/ ]|$)",
                "model": "Aquos Sense 6s"
            },
            {
                "regex": "A208SH(?:[);/ ]|$)",
                "model": "Aquos Sense 7 Plus"
            },
            {
                "regex": "(?:SH-53C|SH-M24|SHG10)(?:[);/ ]|$)",
                "model": "Aquos Sense 7"
            },
            {
                "regex": "(?:SHG03|A004SH|SH-M17|SH-53A|A105SH|SH-S50)(?:[);/ ]|$)",
                "model": "Aquos Sense 5G"
            },
            {
                "regex": "SH-D01(?:[);/ ]|$)",
                "model": "Aquos D10"
            },
            {
                "regex": "SH-M12(?:-y)?(?:[);/ ]|$)",
                "model": "Aquos S3 Dual SIM"
            },
            {
                "regex": "SH-H01(?:[);/ ]|$)",
                "model": "Aquos Zeta"
            },
            {
                "regex": "(?:SH-[MZ]10|801SH)(?:[);/ ]|$)",
                "model": "Aquos Zero"
            },
            {
                "regex": "(?:SH-M13|906SH|SH-01M)(?:[);/ ]|$)",
                "model": "Aquos Zero 2"
            },
            {
                "regex": "(?:SHG04|A102SH|SH-RM18|Aquos zero6)(?:[);/ ]|$)",
                "model": "Aquos Zero 6"
            },
            {
                "regex": "(?:SHG02|A002SH)(?:[);/ ]|$)",
                "model": "Aquos Zero 5G Basic"
            },
            {
                "regex": "(?:SH-Z01|Aquos S2 4/64)(?:[);/ ]|$)",
                "model": "Aquos S2 (C10)"
            },
            {
                "regex": "(?:SH-02E|SH-01[GH]|SH-04H|SH-09D)(?:[);/ ]|$)",
                "model": "Aquos Phone Zeta"
            },
            {
                "regex": "SH-01FDQ(?:[);/ ]|$)",
                "model": "Dragon Quest"
            },
            {
                "regex": "SH-?06D(?:[);/ ]|$)",
                "model": "Aquos Phone SH-06D"
            },
            {
                "regex": "(SHL2[1235]|SH-M01|SH-01E)(?:[);/ ]|$)",
                "model": "Aquos Phone $1"
            },
            {
                "regex": "SBM(203SH|30[23]SH)(?:[);/ ]|$)",
                "model": "Aquos Phone XX $1"
            },
            {
                "regex": "SH-L02(?:[);/ ]|$)",
                "model": "Aquos L2"
            },
            {
                "regex": "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)",
                "model": "Aquos R"
            },
            {
                "regex": "(?:701SH|SHV41|SH-M06)(?:[);/ ]|$)",
                "model": "Aquos R Compact"
            },
            {
                "regex": "(?:SH-M09|SHV42|706SH|SH-03K)(?:[);/ ]|$)",
                "model": "Aquos R2"
            },
            {
                "regex": "803SH(?:[);/ ]|$)",
                "model": "Aquos R2 Compact"
            },
            {
                "regex": "(?:908SH|SHG01|SH-M14)(?:[);/ ]|$)",
                "model": "Aquos R5G"
            },
            {
                "regex": "SH-M16(?:[);/ ]|$)",
                "model": "Aquos S4 Plus"
            },
            {
                "regex": "SH-M15(?:[);/ ]|$)",
                "model": "Aquos S4 SIM"
            },
            {
                "regex": "SH-C02(?:[);/ ]|$)",
                "model": "Aquos V"
            },
            {
                "regex": "SH-C06(?:[);/ ]|$)",
                "model": "Aquos V7+"
            },
            {
                "regex": "SH-C03(?:[);/ ]|$)",
                "model": "Aquos V6"
            },
            {
                "regex": "SH-C05(?:[);/ ]|$)",
                "model": "Aquos V6 5G"
            },
            {
                "regex": "SH-C04(?:[);/ ]|$)",
                "model": "Aquos V6+"
            },
            {
                "regex": "(SHF3[1-4])(?:[);/ ]|$)",
                "model": "Aquos K $1"
            },
            {
                "regex": "704SH(?:[);/ ]|$)",
                "model": "Simple Smartphone 4"
            },
            {
                "regex": "A201SH(?:[);/ ]|$)",
                "model": "Simple Smartphone 6"
            },
            {
                "regex": "(?:SH-02J|SH-04G)(?:[);/ ]|$)",
                "model": "Aquos Ever"
            },
            {
                "regex": "SH-02H(?:[);/ ]|$)",
                "model": "Aquos Compact"
            },
            {
                "regex": "30[56]SH(?:[);/ ]|$)",
                "model": "Aquos Crystal"
            },
            {
                "regex": "402SH(?:[);/ ]|$)",
                "model": "Aquos Crystal X"
            },
            {
                "regex": "403SH(?:[);/ ]|$)",
                "model": "Aquos Crystal 2"
            },
            {
                "regex": "(?:509SH|SH-R10A)(?:[);/ ]|$)",
                "model": "Aquos 3"
            },
            {
                "regex": "NP601SH(?:[);/ ]|$)",
                "model": "Aquos 2"
            },
            {
                "regex": "(?:SHV40|SHV3[24])(?:_u)?(?:[);/ ]|$)",
                "model": "Aquos S"
            },
            {
                "regex": "702SH(?:[);/ ]|$)",
                "model": "Aquos S Basic"
            },
            {
                "regex": "Aquos P6(?:[);/ ]|$)",
                "model": "Aquos P6"
            },
            {
                "regex": "SHV3[183](?:[);/ ]|$)",
                "model": "Aquos S Mini"
            },
            {
                "regex": "(?:FS8010|SH-M08|SHV43(?:-u)?|SH-01[KL]|lineage_ss2|Aquos S2)(?:[);/ ]|$)",
                "model": "Aquos S2"
            },
            {
                "regex": "FS8016(?:[);/ ]|$)",
                "model": "Aquos S2 Plus"
            },
            {
                "regex": "(?:SHV46|SH-R?M11|901SH)(?:[);/ ]|$)",
                "model": "Aquos S3 Plus"
            },
            {
                "regex": "(?:SHV44|808SH|SH-04L|SH-03G)(?:[);/ ]|$)",
                "model": "Aquos R3"
            },
            {
                "regex": "(?:FS8032|FS8015|SH-02M|SHV45(?:-U)?)(?:[);/ ]|$)",
                "model": "Aquos S3"
            },
            {
                "regex": "FS8018(?:[);/ ]|$)",
                "model": "Aquos S3 Mini"
            },
            {
                "regex": "(?:SHV48|907SH)(?:[);/ ]|$)",
                "model": "Aquos S3 Basic"
            },
            {
                "regex": "SH-RM12(?:[);/ ]|$)",
                "model": "Aquos S3 Lite"
            },
            {
                "regex": "SH-RM15(?:[);/ ]|$)",
                "model": "Aquos S4 Lite"
            },
            {
                "regex": "SH-51A(?:[);/ ]|$)",
                "model": "Aquos R5G"
            },
            {
                "regex": "(?:SH-51B|A101SH|SH-M22)(?:[);/ ]|$)",
                "model": "Aquos R6"
            },
            {
                "regex": "(?:A202SH|SH-52C)(?:[);/ ]|$)",
                "model": "Aquos R7"
            },
            {
                "regex": "(?:SH-51D|A301SH)(?:[);/ ]|$)",
                "model": "Aquos R8 Pro"
            },
            {
                "regex": "A302SH(?:[);/ ]|$)",
                "model": "Aquos wish3"
            },
            {
                "regex": "(?:SH-52D)(?:[);/ ]|$)",
                "model": "Aquos R8"
            },
            {
                "regex": "SHV3[57](?:_u)?(?:[);/ ]|$)",
                "model": "Aquos U"
            },
            {
                "regex": "TG-L900S(?:[);/ ]|$)",
                "model": "Luna S"
            },
            {
                "regex": "SH-A01(?:[);/ ]|$)",
                "model": "B10"
            },
            {
                "regex": "FS8026(?:[);/ ]|$)",
                "model": "A2 Lite"
            },
            {
                "regex": "FS8025(?:[);/ ]|$)",
                "model": "A2"
            },
            {
                "regex": "(?:FS8002|SHV47)(?:[);/ ]|$)",
                "model": "Z2"
            },
            {
                "regex": "FS8009(?:[);/ ]|$)",
                "model": "Z3"
            },
            {
                "regex": "FS8014(?:[);/ ]|$)",
                "model": "R1"
            },
            {
                "regex": "FS8028(?:[);/ ]|$)",
                "model": "R1S"
            },
            {
                "regex": "SHV36(?:[);/ ]|$)",
                "model": "Basio 2"
            },
            {
                "regex": "SHG09(?:[);/ ]|$)",
                "model": "Basio Active"
            },
            {
                "regex": "SW001SH(?:[);/ ]|$)",
                "model": "Star Wars"
            },
            {
                "regex": "SH-RM02",
                "model": "Aquos SH-RM02"
            },
            {
                "regex": "401SH",
                "model": "Aquos 401SH"
            },
            {
                "regex": "(DM-01[JH])",
                "model": "Disney Mobile $1"
            },
            {
                "regex": "A001SH",
                "model": "Simple Sumaho 5"
            },
            {
                "regex": "NP80[56]SH",
                "model": "Aquos Keitai 3"
            },
            {
                "regex": "NPA205SH",
                "model": "Aquos Keitai 4"
            },
            {
                "regex": "NP807SH",
                "model": "Aquos Keitai 10"
            },
            {
                "regex": "NP501SH",
                "model": "Aquos Keitai"
            },
            {
                "regex": "LP-0([12])(?:[);/ ]|$)",
                "model": "Leica Leitz Phone $1"
            },
            {
                "regex": "SBM(00[35]SH)(?:[);/ ]|$)",
                "model": "Galapagos $1"
            },
            {
                "regex": "SBM(103SH)(?:[);/ ]|$)",
                "model": "Aquos Phone $1"
            },
            {
                "regex": "SH-02L(?:[);/ ]|$)",
                "model": "Aquos K-tai"
            },
            {
                "regex": "SBM200SH(?:[);/ ]|$)",
                "model": "Pantone 6"
            },
            {
                "regex": "SH-08E(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Sharp Aquos Pad"
            },
            {
                "regex": "SHT21(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Aquos Pad SHT21"
            },
            {
                "regex": "(d-41A|d-51C)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "dtab $1"
            },
            {
                "regex": "(SH-T01)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(LC-(?:[0-9]{2})[a-z0-9]+)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "LCD_xxSUFOC475A",
                "device": "tv",
                "model": "LCD-60SU475A"
            },
            {
                "regex": "SHARP-AQUOS|AQUOSBrowser",
                "device": "tv",
                "model": "Aquos Net Plus"
            },
            {
                "regex": "SHARP[ -]([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "AQUOS[ _-]TV([a-z0-9-]+)",
                "device": "tv",
                "model": "Aquos TV$1"
            },
            {
                "regex": "(?:SHARP|SBM)([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "(SH-?[0-9]+[a-z]?|IS05|ADS1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Simply": {
        "regex": "(NP602SI)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Softbank": {
        "regex": "Softbank|J-PHONE",
        "device": "smartphone",
        "models": [
            {
                "regex": "Softbank/[12]\\.0/([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "([a-z0-9]+);Softbank;",
                "model": "$1"
            },
            {
                "regex": "J-PHONE/[0-9]\\.[0-9]/([a-z0-9-]+)",
                "model": "$1"
            }
        ]
    },
    "Sonim": {
        "regex": "Sonim[ -]|XP(?:[67]7|[358]8|99)00(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Sonim-)?XP3400",
                "model": "XP3400",
                "device": "feature phone"
            },
            {
                "regex": "(?:Sonim-)?XP3800",
                "model": "XP3"
            },
            {
                "regex": "(?:Sonim-)?XP3900",
                "model": "XP3 Plus"
            },
            {
                "regex": "(?:Sonim-)?XP5800",
                "model": "XP5s"
            },
            {
                "regex": "(?:Sonim-)?XP5700",
                "model": "XP5"
            },
            {
                "regex": "(?:Sonim-)?XP6700",
                "model": "XP6"
            },
            {
                "regex": "(?:Sonim-)?XP7700",
                "model": "XP7"
            },
            {
                "regex": "(?:Sonim-)?XP8800",
                "model": "XP8"
            },
            {
                "regex": "(?:Sonim-)?XP9900",
                "model": "XP10"
            }
        ]
    },
    "Star": {
        "regex": "(?:N(?:9[5678]00|8800|9000|9977)|Star[ _]N9589)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "N9000",
                "model": "Note 3"
            },
            {
                "regex": "(?:Star_)?N(9[5678]00|8800|9977|9589)(?:[);/ ]|$)",
                "model": "N$1"
            }
        ]
    },
    "Starmobile": {
        "regex": "(?:Starmobile (?:Play (?:Neo|Spark|GO|Click|Max)|Astra)|DIAMOND D1|UP[_ ](?:Sense|Rave|Groove|Octa|Prime|Selfie|Snap|Xtreme|XL|Max|Vision|Neo)|PLAY (?:Club|Style|Click LTE|Dash)|ENGAGE7\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Starmobile PLAY GO(?:[);/ ]|$)",
                "model": "Play Go"
            },
            {
                "regex": "Starmobile ASTRA(?:[);/ ]|$)",
                "model": "Astra"
            },
            {
                "regex": "DIAMOND D1(?:[);/ ]|$)",
                "model": "Diamond D1"
            },
            {
                "regex": "(?:Starmobile )?Play (Neo|Spark|Click|Club|Style|Max|Dash)(?:[);/ ]|$)",
                "model": "Play $1"
            },
            {
                "regex": "UP[_ ](Sense|Rave|Groove|Octa|Prime|Selfie|Snap|Xtreme|XL|Max|Vision|Neo)(?:[);/ ]|$)",
                "model": "UP $1"
            },
            {
                "regex": "ENGAGE7\\+",
                "device": "tablet",
                "model": "Engage 7 Plus"
            }
        ]
    },
    "ok.": {
        "regex": "(?:AFTWI001|OK Google TV)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "AFTWI001",
                "model": "4K (2020)"
            },
            {
                "regex": "OK Google TV",
                "model": "Smart TV"
            }
        ]
    },
    "Anker": {
        "regex": "Anker|smarttv_AFTMM-Anker-AK-D3000111|(?:AFTMM|D21[45]0)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Anker|smarttv_AFTMM-Anker-AK-D3000111|AFTMM(?:[);/ ]|$)",
                "model": "Nebula Soundbar"
            },
            {
                "regex": "D2140(?:[);/ ]|$)",
                "model": "Nebula Cosmos"
            },
            {
                "regex": "D2150(?:[);/ ]|$)",
                "model": "Nebula Cosmos Max"
            }
        ]
    },
    "Altus": {
        "regex": "Altus(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "Onida": {
        "regex": "ONIDA[_ ](i4G1)|(?:AFTLE|AFTTIFF55)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ONIDA[_ ](i4G1)",
                "model": "$1"
            },
            {
                "regex": "AFTLE(?:[);/ ]|$)",
                "model": "Fire TV (2019)",
                "device": "tv"
            },
            {
                "regex": "AFTTIFF55(?:[);/ ]|$)",
                "model": "Fire TV (2020)",
                "device": "tv"
            }
        ]
    },
    "Amazon Basics": {
        "regex": "(?:AFTBU001|AFTPR001)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "AFTBU001(?:[);/ ]|$)",
                "model": "Fire TV (2020)"
            },
            {
                "regex": "AFTPR001(?:[);/ ]|$)",
                "model": "Fire TV 4K (2020)"
            }
        ]
    },
    "Amazon": {
        "regex": "(?:smarttv_)?(?:AFT[ABMNRST]|AFTSSS?|AFTANNA0|AFTGAZL|AFTMM|AFTK(?:A|M|RT)|AFTTI43|AFTTIFF43|AFTHA001|AFTKA(?:DE|UK)?00[12]|SD4930UR|AEO(?:AT|B[CP]|C[HNW]|H[PY]|KN|RH|TA)|KF(?:OT|ONWI|TT|JWI|JWA|[DFS]OWI|A[PRSU]WI|T[BH]WI|TRP?WI|SAW[IA]|GIWI|[KMR]AWI|MEWI|[MSTQ]UWI|SNWI|RAPWI))(?:[);/ _]|$)|Kindle|AlexaMediaPlayer|Amazon (?:Tate|Jem)|Silk/\\d+\\.\\d+|Echo/1|.+FIRETVSTICK|Amazon;Echo",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:smarttv_)?AFTA(?:[);/ _]|$)",
                "model": "Fire TV Cube (Gen 1)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTR(?:[);/ _]|$)",
                "model": "Fire TV Cube (Gen 2)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTGAZL(?:[);/ _]|$)",
                "model": "Fire TV Cube (Gen 3)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTN(?:[);/ _]|$)",
                "model": "Fire TV (Gen 3)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTTI43",
                "model": "Fire TV 4-Series (2021)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTKAUK001(?:[);/ _]|$)",
                "model": "Fire TV 4-Series (2023)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTKA(?:UK)?002(?:[);/ _]|$)",
                "model": "Fire TV 2-Series (2023)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTANNA0(?:[);/ _]|$)",
                "model": "Fire TV (2021-2022)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTALMO(?:[);/ _]|$)",
                "model": "Fire TV 2K (2022)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTHA001(?:[);/ _]|$)",
                "model": "Fire TV 4K (2021-2022)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTSHN01(?:[);/ _]|$)",
                "model": "Fire TV HD (2023)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTB(?:[);/ _]|$)",
                "model": "Fire TV (Gen 1)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTSSS(?:[);/ _]|$)",
                "model": "Fire TV Stick (Gen 3)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTSS(?:[);/ _]|$)",
                "model": "Fire TV Stick Lite (Gen 1)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTTIFF43(?:[);/ _]|$)",
                "model": "Fire TV Omni QLED (2022)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTKADE001(?:[);/ _]|$)",
                "model": "Fire TV Omni QLED (2023)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFT[MST](?:[);/ _]|$)",
                "model": "Fire TV Stick",
                "device": "tv"
            },
            {
                "regex": ".+FIRETVSTICK2018|(?:smarttv_)?AFTMM(?:[);/ _]|$)",
                "model": "Fire TV Stick 4K",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTKM(?:[);/ _]|$)",
                "model": "Fire TV Stick 4K (2023)",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTKA(?:[);/ _]|$)",
                "model": "Fire TV Stick 4K Max",
                "device": "tv"
            },
            {
                "regex": "(?:smarttv_)?AFTKRT(?:[);/ _]|$)",
                "model": "Fire TV Stick 4K Max (2023)",
                "device": "tv"
            },
            {
                "regex": "KFFOWI(?:[);/ ]|$)",
                "model": "Fire 7\""
            },
            {
                "regex": "KFMUWI(?:[);/ ]|$)",
                "model": "Fire 7\" (2019)"
            },
            {
                "regex": "KFTT(?:[);/ ]|$)",
                "model": "Kindle Fire HD"
            },
            {
                "regex": "KFJWI(?:[);/ ]|$)|Amazon Jem",
                "model": "Kindle Fire HD 8.9\" WiFi"
            },
            {
                "regex": "KFJWA(?:[);/ ]|$)",
                "model": "Kindle Fire HD 8.9\" 4G"
            },
            {
                "regex": "KFSOWI(?:[);/ ]|$)|Amazon Tate",
                "model": "Kindle Fire HD 7\" WiFi"
            },
            {
                "regex": "KFTHWI(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 7\" WiFi"
            },
            {
                "regex": "KFTHWA(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 7\" 4G"
            },
            {
                "regex": "KFAPWI(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 8.9\" WiFi"
            },
            {
                "regex": "KFAPWA(?:[);/ ]|$)",
                "model": "Kindle Fire HDX 8.9\" 4G"
            },
            {
                "regex": "KFSNWI(?:[);/ ]|$)",
                "model": "Fire Max 11"
            },
            {
                "regex": "KFARWI(?:[);/ ]|$)",
                "model": "Fire HD 6"
            },
            {
                "regex": "KFASWI(?:[);/ ]|$)",
                "model": "Fire HD 7"
            },
            {
                "regex": "KFQUWI(?:[);/ ]|$)",
                "model": "Fire 7 (2022)"
            },
            {
                "regex": "KFAUWI(?:[);/ ]|$)",
                "model": "Fire HD 7 (2017)"
            },
            {
                "regex": "KFMEWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2015)"
            },
            {
                "regex": "KFRAP?WI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2022)"
            },
            {
                "regex": "KFGIWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2016)"
            },
            {
                "regex": "KFDOWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2017)"
            },
            {
                "regex": "KFKAWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2018)"
            },
            {
                "regex": "KFONWI(?:[);/ ]|$)",
                "model": "Fire HD 8 (2020)"
            },
            {
                "regex": "KFSAWI(?:[);/ ]|$)",
                "model": "Fire HDX 8.9"
            },
            {
                "regex": "KFSAWA(?:[);/ ]|$)",
                "model": "Fire HDX 8.9 4G"
            },
            {
                "regex": "KFTBWI(?:[);/ ]|$)",
                "model": "Fire HD 10"
            },
            {
                "regex": "KFSUWI(?:[);/ ]|$)",
                "model": "Fire HD 10 (2017)"
            },
            {
                "regex": "KFMAWI(?:[);/ ]|$)",
                "model": "Fire HD 10 (2019)"
            },
            {
                "regex": "KFTRWI(?:[);/ ]|$)",
                "model": "Fire HD 10 (2021)"
            },
            {
                "regex": "KFTUWI(?:[);/ ]|$)",
                "model": "Fire HD 10 (2023)"
            },
            {
                "regex": "KFTRPWI(?:[);/ ]|$)",
                "model": "Fire HD 10 Plus (2021)"
            },
            {
                "regex": "SD4930UR",
                "model": "Fire Phone",
                "device": "smartphone"
            },
            {
                "regex": "KFOT|Kindle Fire|Silk-Accelerated",
                "model": "Kindle Fire"
            },
            {
                "regex": "Kindle",
                "model": "Kindle"
            },
            {
                "regex": "Amazon;Echo;",
                "model": "Echo",
                "device": "smart speaker"
            },
            {
                "regex": "Echo/1|AEO(?:AT|BC|CN|KN|TA)(?:[);/ ]|$)",
                "model": "Echo",
                "device": "smart speaker"
            },
            {
                "regex": "Amazon;Echo_Dot",
                "model": "Echo Dot",
                "device": "smart speaker"
            },
            {
                "regex": "Amazon;Echo_Show_(\\d+)",
                "model": "Echo Show $1"
            },
            {
                "regex": "AEOBP(?:[);/ ]|$)",
                "model": "Echo Show (Gen 2)",
                "device": "smart speaker"
            },
            {
                "regex": "AEOHP(?:[);/ ]|$)",
                "model": "Echo Show 5",
                "device": "smart speaker"
            },
            {
                "regex": "(?:AEOC[HW]|AEORH)(?:[);/ ]|$)",
                "model": "Echo Show 8",
                "device": "smart speaker"
            },
            {
                "regex": "AEOHY(?:[);/ ]|$)",
                "model": "Echo Show 15 (2021)",
                "device": "smart speaker"
            },
            {
                "regex": "AlexaMediaPlayer",
                "model": "Alexa",
                "device": "smart speaker"
            },
            {
                "regex": "Silk/\\d+\\.\\d+",
                "model": "",
                "device": "tv"
            }
        ]
    },
    "SONOS": {
        "regex": "(?:Sonos/.+\\((?:(?:BR|ZP).+)\\)|Sonos;|Sonos/.+\\(?:Arc|ANVIL|Play:\\d\\))",
        "device": "smart speaker",
        "models": [
            {
                "regex": "\\((ZPS(?:[13569]|1[1-9]|2[0-467]|3[013-9]|4[1345]|5[45])|ZP(?:90|120))\\)",
                "model": "$1"
            },
            {
                "regex": "Sonos;Beam;",
                "model": "Beam"
            },
            {
                "regex": "BR200",
                "model": "BOOST"
            },
            {
                "regex": "Sonos;Roam;",
                "model": "Roam"
            },
            {
                "regex": "Sonos;Bookshelf;",
                "model": "Bookshelf"
            },
            {
                "regex": "Sonos;Move;",
                "model": "Move"
            },
            {
                "regex": "Play:?(\\d)",
                "model": "Play:$1"
            },
            {
                "regex": "Sonos;One;",
                "model": "One"
            },
            {
                "regex": "Sonos;OneSL",
                "model": "OneSL"
            },
            {
                "regex": "\\(ANVIL\\)",
                "model": "Sub"
            }
        ]
    },
    "Syco": {
        "regex": "SYCO[ _]|RS-4(?:03|42)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RS-(\\d{3})",
                "model": "RS-$1"
            }
        ]
    },
    "Symphony": {
        "regex": "SYMPHONY[ \\_]([a-z0-9]+)|(?:(?:roar[ _](?:V20|A50|V78|E80|V150))|innova[123]0|roarV95|ZVIII?|V10[25]|V1[23]0|V128|V14[012]|V1[45]5|SYMTAB\\d+| (?:i9[79]|i7[245]|i8[05]|i6[568]|i30|i1[58]|i120|Z30 pro|Z60 plus|[ZR]30|V9[246789]|V75m)|INOVA|Android 7(?:[\\d.]*);(?: [\\w-]+;)? P11|Android 6.*; (?:V75|i2[015])|EASY_NAV_2|G10\\+|helio 30)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Symphony_PD1_4G_4G(?:[);/ ]|$)",
                "model": "PD1 4G"
            },
            {
                "regex": "ZVIII",
                "model": "ZVIII"
            },
            {
                "regex": "innova([123]0)",
                "model": "Innova $1"
            },
            {
                "regex": "ZVII",
                "model": "ZVII"
            },
            {
                "regex": "INOVA",
                "model": "iNova"
            },
            {
                "regex": "Symphony Atom ii",
                "model": "Atom II"
            },
            {
                "regex": "roar[ _]?(V20|A50|E80|V78|V95|V150)(?:[);/ ]|$)",
                "model": "Roar $1"
            },
            {
                "regex": "(Z30|P7) pro",
                "model": "$1 Pro"
            },
            {
                "regex": "(Z60) plus",
                "model": "$1 Plus"
            },
            {
                "regex": "G10\\+",
                "model": "G10 Plus"
            },
            {
                "regex": "helio 30",
                "model": "helio 30"
            },
            {
                "regex": "(V141|V1[23]0|V10[25]|V128|V14[012]|i9[79]|i7[245]|i8[05]|i6[568]|i30|i1[58]|i120|V1[45]5|[ZR]30|V9[246789]|V75m?|i2[015]|P11)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SYMPHONY[ \\_]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "SYMTAB(\\d+)",
                "device": "tablet",
                "model": "SymTab $1"
            },
            {
                "regex": "EASY_NAV_2",
                "device": "tablet",
                "model": "Easy Nav 2"
            }
        ]
    },
    "Helio": {
        "regex": "Helio (S60|S5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "HERO": {
        "regex": "SP-001(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SP-001(?:[);/ ]|$)",
                "model": "SP-001"
            }
        ]
    },
    "Syrox": {
        "regex": "(SYX-(?:T70[04]|T10[12]))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "System76": {
        "regex": "System76",
        "device": "desktop",
        "models": [
            {
                "regex": "System76 Galago Pro(?:[);/ ]|$)",
                "model": "Galago Pro"
            }
        ]
    },
    "Qtek": {
        "regex": "Qtek[ _]?([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Q-Box": {
        "regex": "QBOX(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "Q-Touch": {
        "regex": "Qtouch_|[ ](Q09|QS701|Q0[15]A|QS31)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Qtouch[_ ])?[ ]?(Q09|QS701|Q0[15]A|Q85|QS31)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "G-Touch": {
        "regex": "GTouch[_ ]|(?:Stella (?:XS?|Omega))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Stella (XS?|Omega)",
                "model": "Stella $1"
            },
            {
                "regex": "GTouch[_ ]STELLA",
                "model": "Stella"
            }
        ]
    },
    "T-Mobile": {
        "regex": "T-Mobile[ _][a-z0-9 ]+|(?:REVVLRY\\+?|REVVL V\\+ 5G|REVVL 2(?: PLUS)?|5062[ZW]|5007[ZW]|T790[WZ]|Telekom Puls|TMAF0[23]5G|TMRVL4G|TMRV5GTB|TMRV0[67]P?5G|T Phone|T Tablet)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TMRVL4G",
                "model": "REVVL V"
            },
            {
                "regex": "5062[ZW]",
                "model": "REVVL 4 Plus"
            },
            {
                "regex": "5007[ZW]",
                "model": "REVVL 4"
            },
            {
                "regex": "TMRV065G",
                "model": "REVVL 6x 5G"
            },
            {
                "regex": "TMRV06P5G",
                "model": "REVVL 6x Pro 5G"
            },
            {
                "regex": "T790[WZ]",
                "model": "REVVL 5G"
            },
            {
                "regex": "REVVL 2 PLUS",
                "model": "REVVL 2 Plus"
            },
            {
                "regex": "REVVL V\\+ 5G",
                "model": "REVVL V+ 5G"
            },
            {
                "regex": "REVVLRY",
                "model": "REVVL Plus"
            },
            {
                "regex": "REVVL 2(?:[);/ ]|$)",
                "model": "REVVL 2"
            },
            {
                "regex": "TMAF025G(?:[);/ ]|$)",
                "model": "REVVL 6 5G"
            },
            {
                "regex": "TMRV075G(?:[);/ ]|$)",
                "model": "REVVL 7 5G"
            },
            {
                "regex": "TMAF035G(?:[);/ ]|$)",
                "model": "REVVL 6 Pro 5G"
            },
            {
                "regex": "TMRV07P5G(?:[);/ ]|$)",
                "model": "REVVL 7 Pro 5G"
            },
            {
                "regex": "Telekom Puls(?:[);/ ]|$)",
                "model": "Telekom Puls"
            },
            {
                "regex": "T Phone 2 Pro",
                "model": "T Phone 2 Pro"
            },
            {
                "regex": "T Phone Pro \\((2023)\\)",
                "model": "T Phone Pro ($1)"
            },
            {
                "regex": "T Phone \\((2023)\\)",
                "model": "T Phone ($1)"
            },
            {
                "regex": "T Phone Pro(?:[);/ ]|$)",
                "model": "T Phone Pro"
            },
            {
                "regex": "T Phone (\\d*)(?:[);/ ]|$)",
                "model": "T Phone $1"
            },
            {
                "regex": "T Phone(?:[);/ ]|$)",
                "model": "T Phone"
            },
            {
                "regex": "TMRV5GTB",
                "device": "tablet",
                "model": "REVVL Tab 5G"
            },
            {
                "regex": "T Tablet(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T Tablet"
            },
            {
                "regex": "T-Mobile[ _]([a-z0-9_ ]+) Build",
                "model": "$1"
            },
            {
                "regex": "T-Mobile[ _]([a-z0-9_ ]+)",
                "model": "$1"
            }
        ]
    },
    "TB Touch": {
        "regex": "Ignis [89]",
        "device": "tablet",
        "models": [
            {
                "regex": "Ignis ([89])",
                "model": "Ignis $1"
            }
        ]
    },
    "Teclast": {
        "regex": "Teclast|P80_G3M2|TLA00[12]|TLA016|X98 Air III|M20_4G|X98 Air II\\(HG5N\\)|Tbook|X80 Power\\(B2N4\\)|P80H\\(D1C2\\)|T20\\(T2E1\\)|(?:[TM]40 Plus|T30|P80[XHT]|P20HD|P10[_ ]HD|M40|P10SE?|M30_Pro|M40SE|P8[05]|P25(?:_T)?|P85T|P[23]0S|P[34]0HD|T40S)_(?:ROW|EEA|RUS|W_EEA)|P20HD\\(N6H5\\)|T40 Plus\\(M7T3\\)|T40Pro|T40 PRO(?:\\(T1A1\\))?|T10\\(E3C[56]\\)|P10S\\(N4H5\\)|98\\(M1E[45789]\\)|98\\(M3E3\\)|X10 \\(M1D3\\)|M89 Pro|M40\\(N9H[123]\\)|P20HD\\(N6H7\\)|M40SE\\(M5T3\\)|M50S|M40(?:SE?|Pro|Air)_(?:ROW|EEA|RUS)|M50Plus|[MT]50Mini|P30Air|P10HD_Lite|(?:T60Ai|P50Ai|P50_[BT]|T50|M40_?Plus|M40 Pro|T50Pro_W|TLG01|P26T|P40S|P50|P25T|T70|T50Max|T50HD|T60Plus|T65Max)_(?:ROW|EEA)|M50[-_]ROW|M40Plus_EEA|P40HD_T_(?:EEA|ROW)|T40_Plus_RUS|T40 Air|P50_B|P50Case|(?: (?:T4[05]HD|P30T|P80X|M50HD)|98 \\(M1E3\\))|(?:Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:M50 Pro|T[56]0)|T50HD)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Tbook[_ -]([^;/]+)(?: Build|[;)]|$)",
                "model": "Tbook $1"
            },
            {
                "regex": "T10\\(E3C[56]\\)",
                "model": "T10"
            },
            {
                "regex": "T20\\(T2E1\\)",
                "model": "T20"
            },
            {
                "regex": "X10 \\(M1D3\\)",
                "model": "X10"
            },
            {
                "regex": "98 \\(M1E3\\)",
                "model": "98"
            },
            {
                "regex": "P10S(?:\\(N4H5\\)|_(?:ROW|EEA))(?:[);/ ]|$)",
                "model": "P10S"
            },
            {
                "regex": "P20HD_?(?:ROW|EEA|RUS)|P20HD\\(N6H[57]\\)",
                "model": "P20HD"
            },
            {
                "regex": "P40HD",
                "model": "P40HD"
            },
            {
                "regex": "P80T",
                "model": "P80T"
            },
            {
                "regex": "P50Case",
                "model": "P50 Case"
            },
            {
                "regex": "M50 ?Mini",
                "model": "M50 Mini"
            },
            {
                "regex": "T50Mini",
                "model": "T50 Mini"
            },
            {
                "regex": "P10[_ ]HD_(?:ROW|EEA)",
                "model": "Apex P10HD"
            },
            {
                "regex": "P10HD_Lite",
                "model": "Apex P10HD Lite"
            },
            {
                "regex": "P80[_ ](?:ROW|EEA)|P80_G3M2",
                "model": "P80"
            },
            {
                "regex": "P30S",
                "model": "P30S"
            },
            {
                "regex": "P(50|85)[_ ](?:ROW|EEA|RUS|[BT])",
                "model": "P$1"
            },
            {
                "regex": "P50Ai",
                "model": "P50Ai"
            },
            {
                "regex": "T60Ai",
                "model": "T60Ai"
            },
            {
                "regex": "M([43]0)[_ ]?Pro[_ ](?:ROW|EEA|RUS)",
                "model": "M$1 Pro"
            },
            {
                "regex": "M50 Pro",
                "model": "M50 Pro"
            },
            {
                "regex": "M20_4G",
                "model": "M20 4G"
            },
            {
                "regex": "M89 Pro",
                "model": "M89 Pro"
            },
            {
                "regex": "TLA002",
                "model": "M30 4G"
            },
            {
                "regex": "TLA016",
                "model": "M16"
            },
            {
                "regex": "M40Air",
                "model": "M40 Air"
            },
            {
                "regex": "M40\\(N9H[123]\\)",
                "model": "M40"
            },
            {
                "regex": "M40SE",
                "model": "M40 SE"
            },
            {
                "regex": "T(50|65)Max",
                "model": "T$1 Max"
            },
            {
                "regex": "T60Plus",
                "model": "T60 Plus"
            },
            {
                "regex": "M([45]0)[_ ]?Plus_?",
                "model": "M$1 Plus"
            },
            {
                "regex": "M40S[_ ](?:ROW|EEA|RUS)",
                "model": "M40S"
            },
            {
                "regex": "T40 ?PRO",
                "model": "T40 Pro"
            },
            {
                "regex": "T40 Air",
                "model": "T40 Air"
            },
            {
                "regex": "TLA001",
                "model": "T40"
            },
            {
                "regex": "T40[ _]Plus(?:_(?:ROW|EEA|RUS)|\\(M7T3\\))",
                "model": "T40 Plus"
            },
            {
                "regex": "T(4[05])HD",
                "model": "T$1HD"
            },
            {
                "regex": "M(50)HD",
                "model": "M$1HD"
            },
            {
                "regex": "T50Pro_W",
                "model": "T50 Pro"
            },
            {
                "regex": "P80H\\(D1C2\\)",
                "model": "P80h"
            },
            {
                "regex": "(P80[Xh]|P30HD|T30|M40|P25(?:_T)?|P10SE|T40S|P[24]0S|T[56]0|TLG01|P26T|P85T|P30T|T50HD|P25T|M50S?|T70)(?:[_ -](?:ROW|EEA))?(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "P80X",
                "model": "P80X"
            },
            {
                "regex": "P30Air",
                "model": "P30 Air"
            },
            {
                "regex": "98\\(M1E[45789]\\)|98\\(M3E3\\)",
                "model": "TPad 98 10.1\" 4G"
            },
            {
                "regex": "X80 Power\\(B2N4\\)(?:[);/ ]|$)",
                "model": "X98 Power"
            },
            {
                "regex": "X98 Air III(?:[);/ ]|$)",
                "model": "X98 Air III"
            },
            {
                "regex": "X98 Air II\\(HG5N\\)(?:[);/ ]|$)",
                "model": "X98 Air II"
            },
            {
                "regex": "Teclast[_ -]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "Tecno Mobile": {
        "regex": "Tecno|Camon|Phantom[56]|Phantom6-Plus|Phantom6S|DP7C ?Pro-SGA1|(?:DP7CPRO|DP8D)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Phantom6-Plus",
                "model": "Phantom 6 Plus"
            },
            {
                "regex": "Phantom6S",
                "model": "Phantom 6S"
            },
            {
                "regex": "Phantom([56])",
                "model": "Phantom $1"
            },
            {
                "regex": "TECNO[ _]AD8",
                "model": "Phantom X2"
            },
            {
                "regex": "TECNO[ _]AD9",
                "model": "Phantom X2 Pro"
            },
            {
                "regex": "TECNO[ _]AC8(?:[);/ ]|$)",
                "model": "Phantom X"
            },
            {
                "regex": "TECNO[ _]AD10(?:[);/ ]|$)",
                "model": "Phantom V Fold"
            },
            {
                "regex": "TECNO[ _]AE10(?:[);/ ]|$)",
                "model": "Phantom V Fold 2"
            },
            {
                "regex": "TECNO[ _]AD11(?:[);/ ]|$)",
                "model": "Phantom V Flip"
            },
            {
                "regex": "TECNO[ _]AE11(?:[);/ ]|$)",
                "model": "Phantom V2 Flip"
            },
            {
                "regex": "TECNO[ _]AB7(?:[);/ ]|$)",
                "model": "Phantom 9"
            },
            {
                "regex": "TECNO[ _]AX8(?:[);/ ]|$)",
                "model": "Phantom 8"
            },
            {
                "regex": "TECNO WX3LTE",
                "model": "WX3 LTE"
            },
            {
                "regex": "TECNO-W3",
                "model": "W3"
            },
            {
                "regex": "TECNO[ _]F4 Pro(?:[);/ ]|$)",
                "model": "F4 Pro"
            },
            {
                "regex": "TECNO[ _]IN5(?:[);/ ]|$)",
                "model": "Camon i"
            },
            {
                "regex": "TECNO[ _]IA5(?:[);/ ]|$)",
                "model": "Camon iTwin"
            },
            {
                "regex": "TECNO[ _]ID3k(?:[);/ ]|$)",
                "model": "Camon iAir 2+"
            },
            {
                "regex": "TECNO[ _]KB2(?:[);/ ]|$)",
                "model": "Camon iAce 2"
            },
            {
                "regex": "TECNO[ _]ID5b(?:[);/ ]|$)",
                "model": "Camon i2X"
            },
            {
                "regex": "TECNO[ _]ID5a(?:[);/ ]|$)",
                "model": "Camon i2"
            },
            {
                "regex": "TECNO[ _]ID6(?:[);/ ]|$)",
                "model": "Camon iClick 2"
            },
            {
                "regex": "TECNO[ _]IN2(?:[);/ ]|$)",
                "model": "Camon iSky"
            },
            {
                "regex": "TECNO[ _]IN1 Pro(?:[);/ ]|$)",
                "model": "Camon iSky 2"
            },
            {
                "regex": "TECNO[ _]KB3(?:[);/ ]|$)",
                "model": "Camon iSky 3"
            },
            {
                "regex": "Tecno[ _]7C(?:[);/ ]|$)",
                "model": "DroidPad 7C",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _]P701(?:[);/ ]|$)",
                "model": "DroidPad 7D",
                "device": "tablet"
            },
            {
                "regex": "(?:DP7C ?Pro-SGA1|TECNO[ _]DP7CPRO|DP7CPRO)(?:[);/ ]|$)",
                "model": "DroidPad 7C Pro",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _]P703(?:[);/ ]|$)",
                "model": "DroidPad 7F",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _]P704a(?:[);/ ]|$)",
                "model": "DroidPad 7G",
                "device": "tablet"
            },
            {
                "regex": "TECNO[ _]DP10A Pro(?:[);/ ]|$)",
                "model": "DroidPad 10A Pro",
                "device": "tablet"
            },
            {
                "regex": "TECNO[ _]P904(?:[);/ ]|$)",
                "model": "DroidPad 10D 4G",
                "device": "tablet"
            },
            {
                "regex": "DP8D(?:[);/ ]|$)",
                "model": "DroidPad 8D",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _]RC6(?:[);/ ]|$)",
                "model": "R7+"
            },
            {
                "regex": "Tecno[ _]CB7[j]?",
                "model": "Camon i4"
            },
            {
                "regex": "Tecno[- _]C9(?:[);/ ]|$)",
                "model": "Camon C9"
            },
            {
                "regex": "Tecno[ _]CF7[kS]?(?:[);/ ]|$)",
                "model": "Camon 11"
            },
            {
                "regex": "Tecno[ _]CF8(?:[);/ ]|$)",
                "model": "Camon 11 Pro"
            },
            {
                "regex": "Tecno[ _]CC7S?(?:[);/ ]|$)",
                "model": "Camon 12"
            },
            {
                "regex": "Tecno[ _]CC9(?:[);/ ]|$)",
                "model": "Camon 12 Pro"
            },
            {
                "regex": "Tecno[ _](?:CC6|KC3)(?:[);/ ]|$)",
                "model": "Camon 12 Air"
            },
            {
                "regex": "Tecno[ _-]CD7(?:[);/ ]|$)",
                "model": "Camon 15"
            },
            {
                "regex": "Tecno[ _-]CD6S?(?:[);/ ]|$)",
                "model": "Camon 15 Air"
            },
            {
                "regex": "Tecno[ _-]CD8j(?:[);/ ]|$)",
                "model": "Camon 15 Premier"
            },
            {
                "regex": "Tecno[ _-]CD8(?:[);/ ]|$)",
                "model": "Camon 15 Pro"
            },
            {
                "regex": "Tecno[ _-](?:CE9h|CE7)(?:[);/ ]|$)",
                "model": "Camon 16"
            },
            {
                "regex": "Tecno[ _-]CE9(?:[);/ ]|$)",
                "model": "Camon 16 Premier"
            },
            {
                "regex": "Tecno[ _-]CE8(?:[);/ ]|$)",
                "model": "Camon 16 Pro"
            },
            {
                "regex": "Tecno[ _-]CD6j(?:[);/ ]|$)",
                "model": "Camon 16 S"
            },
            {
                "regex": "Tecno[ _-]CE7j(?:[);/ ]|$)",
                "model": "Camon 16 SE"
            },
            {
                "regex": "Tecno[ _-]CG6j?(?:[);/ ]|$)",
                "model": "Camon 17"
            },
            {
                "regex": "Tecno[ _-]CG8h?(?:[);/ ]|$)",
                "model": "Camon 17 Pro"
            },
            {
                "regex": "Tecno[ _-]CG7n?(?:[);/ ]|$)",
                "model": "Camon 17P"
            },
            {
                "regex": "Tecno[ _-](?:Mobile )?CH9n?(?:[);/ ]|$)",
                "model": "Camon 18 Premier"
            },
            {
                "regex": "Tecno[ _-](?:Mobile )?CH6[nh]?(?:[);/ ]|$)",
                "model": "Camon 18"
            },
            {
                "regex": "Tecno[ _-]CH7n?(?:[);/ ]|$)",
                "model": "Camon 18P"
            },
            {
                "regex": "Tecno[ _-](?:Mobile )?CI6n?(?:[);/ ]|$)",
                "model": "Camon 19"
            },
            {
                "regex": "Tecno[ _-](?:Mobile )?CH6i(?:[);/ ]|$)",
                "model": "Camon 19 Neo"
            },
            {
                "regex": "Tecno[ _-](?:Mobile )?CI8n?(?:[);/ ]|$)",
                "model": "Camon 19 Pro"
            },
            {
                "regex": "Tecno[ _-]CI7n(?:[);/ ]|$)",
                "model": "Camon 19 Pro 5G"
            },
            {
                "regex": "(?:Tecno[ _-]CK7n?|Camon 20 Pro)(?:[);/ ]|$)",
                "model": "Camon 20 Pro"
            },
            {
                "regex": "Tecno[ _-]CK6n?(?:[);/ ]|$)",
                "model": "Camon 20"
            },
            {
                "regex": "Tecno[ _-]CK8n(?:[);/ ]|$)",
                "model": "Camon 20 Pro 5G"
            },
            {
                "regex": "Tecno[ _-]CK8nB(?:[);/ ]|$)",
                "model": "Camon 20s Pro 5G"
            },
            {
                "regex": "Tecno[ _-]CK9n(?:[);/ ]|$)",
                "model": "Camon 20 Premier 5G"
            },
            {
                "regex": "Tecno[ _-]CL6[ks]?(?:[);/ ]|$)",
                "model": "Camon 30"
            },
            {
                "regex": "Tecno[ _-]CL9(?:[);/ ]|$)",
                "model": "Camon 30 Premier 5G"
            },
            {
                "regex": "Tecno[ _-]CL7[ks]?(?:[);/ ]|$)",
                "model": "Camon 30 5G"
            },
            {
                "regex": "Tecno[ _-]CL8(?:[);/ ]|$)",
                "model": "Camon 30 Pro 5G"
            },
            {
                "regex": "Tecno[ _-]CLA6(?:[);/ ]|$)",
                "model": "Camon 30S Pro"
            },
            {
                "regex": "Tecno[ _-]CLA5(?:[);/ ]|$)",
                "model": "Camon 30S"
            },
            {
                "regex": "Tecno[ _-]CM5(?:[);/ ]|$)",
                "model": "Camon 40"
            },
            {
                "regex": "Tecno[ _-]CM6(?:[);/ ]|$)",
                "model": "Camon 40 Pro"
            },
            {
                "regex": "Tecno[ _-]CM8(?:[);/ ]|$)",
                "model": "Camon 40 Premier 5G"
            },
            {
                "regex": "Tecno[ _-]CA6S?(?:[);/ ]|$)",
                "model": "Camon CM"
            },
            {
                "regex": "Tecno[ _-]CA7(?:[);/ ]|$)",
                "model": "Camon X"
            },
            {
                "regex": "Tecno[ _-]CA8S?(?:[);/ ]|$)",
                "model": "Camon X Pro"
            },
            {
                "regex": "Tecno[ _-]Camon CX(?:[);/ ]|$)",
                "model": "Camon CX"
            },
            {
                "regex": "Tecno[ _-]CX Air(?:[);/ ]|$)",
                "model": "Camon CX Air"
            },
            {
                "regex": "TECNO[ _]F3(?:[);/ ]|$)",
                "model": "Pop 1"
            },
            {
                "regex": "TECNO[ _]B1(?:[);/ ]|$)",
                "model": "Pop 2"
            },
            {
                "regex": "TECNO[ _]SA2S(?:[);/ ]|$)",
                "model": "Pop 2 Mini"
            },
            {
                "regex": "TECNO[ _]B1[fg](?:[);/ ]|$)",
                "model": "Pop 2F"
            },
            {
                "regex": "TECNO[ _](?:RA8|KB2h)(?:[);/ ]|$)",
                "model": "Pop 2S"
            },
            {
                "regex": "TECNO[ _]KB2j(?:[);/ ]|$)",
                "model": "Pop 2S Pro"
            },
            {
                "regex": "TECNO[ _]BA2(?:[);/ ]|$)",
                "model": "Pop 2 Plus"
            },
            {
                "regex": "TECNO[ _]B1p(?:[);/ ]|$)",
                "model": "Pop 2 Power"
            },
            {
                "regex": "TECNO[ _]RB8S(?:[);/ ]|$)",
                "model": "Pop 2X Plus"
            },
            {
                "regex": "TECNO[ _]RB6S(?:[);/ ]|$)",
                "model": "Pop 2X Air"
            },
            {
                "regex": "TECNO[ _]RB7S(?:[);/ ]|$)",
                "model": "Pop 2X"
            },
            {
                "regex": "TECNO[ _]B1c(?:[);/ ]|$)",
                "model": "Pop 2F"
            },
            {
                "regex": "TECNO[ _]SC7S(?:[);/ ]|$)",
                "model": "Pop 2 Air"
            },
            {
                "regex": "TECNO[ _]BB2(?:[);/ ]|$)",
                "model": "Pop 3"
            },
            {
                "regex": "TECNO[ _]BB4(?:[);/ ]|$)",
                "model": "Pop 3 Plus"
            },
            {
                "regex": "TECNO[ _]BC2c?(?:[);/ ]|$)",
                "model": "Pop 4"
            },
            {
                "regex": "TECNO[ _]BC3?(?:[);/ ]|$)",
                "model": "Pop 4 Pro"
            },
            {
                "regex": "TECNO[ _]BC1(?:[);/ ]|$)",
                "model": "Pop 4 Air"
            },
            {
                "regex": "TECNO[ _]BC1s(?:[);/ ]|$)",
                "model": "Pop 4 LTE"
            },
            {
                "regex": "TECNO[ _]BD2[dp]?(?:[);/ ]|$)",
                "model": "Pop 5"
            },
            {
                "regex": "TECNO[ _]L6502S(?:[);/ ]|$)",
                "model": "Pop 5X"
            },
            {
                "regex": "TECNO[ _]BD1(?:[);/ ]|$)",
                "model": "Pop 5 Go"
            },
            {
                "regex": "TECNO[ _]W5006S(?:[);/ ]|$)",
                "model": "Pop 5C"
            },
            {
                "regex": "TECNO[ _]BD4[ai]?(?:[);/ ]|$)",
                "model": "Pop 5 LTE"
            },
            {
                "regex": "TECNO[ _]BD4[jh](?:[);/ ]|$)",
                "model": "Pop 5 Pro"
            },
            {
                "regex": "TECNO[ _]BD3(?:[);/ ]|$)",
                "model": "Pop 5P"
            },
            {
                "regex": "TECNO[ _]BE7(?:[);/ ]|$)",
                "model": "Pop 6"
            },
            {
                "regex": "TECNO[ _]BE6j?(?:[);/ ]|$)",
                "model": "Pop 6 Go"
            },
            {
                "regex": "TECNO[ _]BE8[i]?(?:[);/ ]|$)",
                "model": "Pop 6 Pro"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?BF6(?:[);/ ]|$)",
                "model": "Pop 7"
            },
            {
                "regex": "TECNO[ _]BF7h?(?:[);/ ]|$)",
                "model": "Pop 7 Pro"
            },
            {
                "regex": "TECNO[ _]BG6[ih](?:[);/ ]|$)",
                "model": "Pop 8"
            },
            {
                "regex": "TECNO[ _]KL4(?:[);/ ]|$)",
                "model": "Pop 9"
            },
            {
                "regex": "TECNO[ _]KL8h(?:[);/ ]|$)",
                "model": "Pop 9 5G"
            },
            {
                "regex": "Tecno[ _]SA1S Pro(?:[);/ ]|$)",
                "model": "SA1s Pro"
            },
            {
                "regex": "Tecno[ _]KG5[mh]?(?:[);/ ]|$)",
                "model": "Spark Go (2022)"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?BF7n(?:[);/ ]|$)",
                "model": "Spark Go (2023)"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?BG6[ms]?(?:[);/ ]|$)",
                "model": "Spark Go (2024)"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?KJ5n?(?:[);/ ]|$)",
                "model": "Spark 20"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?BG7n?(?:[);/ ]|$)",
                "model": "Spark 20C"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?KJ6(?:[);/ ]|$)",
                "model": "Spark 20 Pro"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?KJ8(?:[);/ ]|$)",
                "model": "Spark 20 Pro 5G"
            },
            {
                "regex": "Tecno[ _](?:Mobile )?KJ7s?(?:[);/ ]|$)",
                "model": "Spark 20 Pro+"
            },
            {
                "regex": "Tecno[ _]KA7O?(?:[);/ ]|$)",
                "model": "Spark 2"
            },
            {
                "regex": "Tecno[ _]LB6?(?:[);/ ]|$)",
                "model": "Spark 2 Youth"
            },
            {
                "regex": "Tecno[ _]KB7j?(?:[);/ ]|$)",
                "model": "Spark 3"
            },
            {
                "regex": "Tecno[ _]KB8?(?:[);/ ]|$)",
                "model": "Spark 3 Pro"
            },
            {
                "regex": "Tecno[ _](?:KC8S?|KC2j?)(?:[);/ ]|$)",
                "model": "Spark 4"
            },
            {
                "regex": "Tecno[ _](?:KC6S?|KC1j)(?:[);/ ]|$)",
                "model": "Spark 4 Air"
            },
            {
                "regex": "Tecno[ _]BB4k(?:[);/ ]|$)",
                "model": "Spark 4 Lite"
            },
            {
                "regex": "Tecno[ _]KD6a?(?:[);/ ]|$)",
                "model": "Spark 5 Air"
            },
            {
                "regex": "Tecno[ _]KD7[hS](?:[);/ ]|$)",
                "model": "Spark 5"
            },
            {
                "regex": "Tecno[ _]KD7(?:[);/ ]|$)",
                "model": "Spark 5 Pro"
            },
            {
                "regex": "TECNO[ _]KE7(?:[);/ ]|$)",
                "model": "Spark 6"
            },
            {
                "regex": "TECNO[ _]KE6j?(?:[);/ ]|$)",
                "model": "Spark 6 Air"
            },
            {
                "regex": "TECNO[ _]KE5[jk]?(?:[);/ ]|$)",
                "model": "Spark 6 Go"
            },
            {
                "regex": "TECNO[ _](?:KF6(?:ks|[nhmjki])?|PR651[EH]?)(?:[);/ ]|$)",
                "model": "Spark 7"
            },
            {
                "regex": "TECNO[ _]KF8(?:[);/ ]|$)",
                "model": "Spark 7 Pro"
            },
            {
                "regex": "TECNO[ _]KF7j(?:[);/ ]|$)",
                "model": "Spark 7P"
            },
            {
                "regex": "TECNO[ _]KF6p(?:[);/ ]|$)",
                "model": "Spark 7T"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?KG6k?(?:[);/ ]|$)",
                "model": "Spark 8"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?KG5[nkjq]?(?:[);/ ]|$)",
                "model": "Spark 8C"
            },
            {
                "regex": "TECNO[ _]KG7[nh]?(?:[);/ ]|$)",
                "model": "Spark 8P"
            },
            {
                "regex": "TECNO(?: Mobile)?[ _]KG6p(?:[);/ ]|$)",
                "model": "Spark 8T"
            },
            {
                "regex": "TECNO(?: Mobile)?[ _]KG8(?:[);/ ]|$)",
                "model": "Spark 8 Pro"
            },
            {
                "regex": "TECNO[ _]KH7[nh]?(?:[);/ ]|$)",
                "model": "Spark 9 Pro"
            },
            {
                "regex": "TECNO[ _]KG5p(?:[);/ ]|$)",
                "model": "Spark 9"
            },
            {
                "regex": "TECNO[ _]KH6(?:[);/ ]|$)",
                "model": "Spark 9T"
            },
            {
                "regex": "TECNO[ _](?:Mobile[ _])?KI5[km]",
                "model": "Spark 10C"
            },
            {
                "regex": "TECNO[ _](?:Mobile[ _])?KI5",
                "model": "Spark 10"
            },
            {
                "regex": "TECNO[ _]KI8",
                "model": "Spark 10 5G"
            },
            {
                "regex": "TECNO[ _](?:Mobile[ _])?KI7",
                "model": "Spark 10 Pro"
            },
            {
                "regex": "TECNO[ _]KC1h(?:[);/ ]|$)",
                "model": "Spark Go"
            },
            {
                "regex": "TECNO[ _]KE5S(?:[);/ ]|$)",
                "model": "Spark Go (2020)"
            },
            {
                "regex": "TECNO[ _]KG5m(?:[);/ ]|$)",
                "model": "Spark Go (2022)"
            },
            {
                "regex": "TECNO[ _]KL4h(?:[);/ ]|$)",
                "model": "Spark Go 1S"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?KL5n?(?:[);/ ]|$)",
                "model": "Spark 30C"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?KL6(?:[);/ ]|$)",
                "model": "Spark 30"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?KL7(?:[);/ ]|$)",
                "model": "Spark 30 Pro"
            },
            {
                "regex": "TECNO[ _]KC1(?:[);/ ]|$)",
                "model": "Spark Air"
            },
            {
                "regex": "TECNO[ _]K9(?:[);/ ]|$)",
                "model": "Spark Plus"
            },
            {
                "regex": "TECNO[ _]KA6(?:[);/ ]|$)",
                "model": "Spark Youth"
            },
            {
                "regex": "TECNO[ _]KA9(?:[);/ ]|$)",
                "model": "Spark CM"
            },
            {
                "regex": "Tecno[ _]DP8D(?:[);/ ]|$)",
                "model": "DroidPad 8D",
                "device": "tablet"
            },
            {
                "regex": "Tecno[ _](P702AS)(?:[);/ ]|$)",
                "model": "DroidPad $1",
                "device": "tablet"
            },
            {
                "regex": "TECNO[ _]LA7 Pro(?:[);/ ]|$)",
                "model": "Pouvoir 2 Pro"
            },
            {
                "regex": "TECNO[ _]LA7(?:[);/ ]|$)",
                "model": "Pouvoir 2"
            },
            {
                "regex": "TECNO[ _]LA6(?:[);/ ]|$)",
                "model": "Pouvoir 1"
            },
            {
                "regex": "TECNO[ _]LB7(?:[);/ ]|$)",
                "model": "Pouvoir 3"
            },
            {
                "regex": "TECNO[ _]LC6a?(?:[);/ ]|$)",
                "model": "Pouvoir 3 Air"
            },
            {
                "regex": "Tecno[ _]LB8a?",
                "model": "Pouvoir 3 Plus"
            },
            {
                "regex": "TECNO[ _]LC7S?(?:[);/ ]|$)",
                "model": "Pouvoir 4"
            },
            {
                "regex": "TECNO[ _]LC8(?:[);/ ]|$)",
                "model": "Pouvoir 4 Pro"
            },
            {
                "regex": "Tecno[ _-]J8(?:[);/ ]|$)",
                "model": "Boom J8"
            },
            {
                "regex": "Tecno[ _-]RA7(?:[);/ ]|$)",
                "model": "R7 4G"
            },
            {
                "regex": "Tecno[ _-]W3 Pro(?:[);/ ]|$)",
                "model": "W3 Pro"
            },
            {
                "regex": "Tecno[ _-]WX3P(?:[);/ ]|$)",
                "model": "WX3 Pro"
            },
            {
                "regex": "TECNO S9",
                "device": "phablet",
                "model": "S9"
            },
            {
                "regex": "TECNO[ _]LD7j?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova"
            },
            {
                "regex": "TECNO[ _]LE6h?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova Neo"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?LG6n(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova Neo 2"
            },
            {
                "regex": "TECNO[ _]LH6n(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova Neo 3"
            },
            {
                "regex": "TECNO[ _]LE6j(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova Neo 5G"
            },
            {
                "regex": "TECNO[ _]LE7n?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 2"
            },
            {
                "regex": "TECNO[ _]LF7n?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 3"
            },
            {
                "regex": "TECNO[ _]LE8(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 5G"
            },
            {
                "regex": "TECNO[ _]LG7n(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 4"
            },
            {
                "regex": "TECNO[ _]LG8n(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 4 Pro"
            },
            {
                "regex": "TECNO[ _]LH7n(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 5"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?LH8n(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 5 Pro 5G"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?LI9(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 6 Pro 5G"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?LI7(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 6"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?LI6(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 6 Neo"
            },
            {
                "regex": "TECNO[ _](?:Mobile )?KL8(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Pova 6 Neo 5G"
            },
            {
                "regex": "Tecno (F2) ?LTE",
                "model": "$1 LTE"
            },
            {
                "regex": "(?:TECNO[-_])?L8Plus",
                "model": "L8 Plus"
            },
            {
                "regex": "TECNO[ _-]?(T611)(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "$1"
            },
            {
                "regex": "TECNO[ _-]?(T1101)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "MegaPad 11"
            },
            {
                "regex": "Tecno[ _]([^;/]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "Tecno[ _-]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "TechSmart": {
        "regex": "TECHSMART[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "TECHSMART[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "TechPad": {
        "regex": "Tech[ _]?pad|XTAB[ _-]|(?:3G_16|Dual (?:C1081HD|C981HD)|S813G|NOTE[_ ]4CAM|M5(?:Go|Plus)|M6Plus|Android 8(?:[\\d.]*);(?: [\\w-]+;)? 816x?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "S813G",
                "model": "S813G"
            },
            {
                "regex": "TechPad10QC",
                "model": "10QC"
            },
            {
                "regex": "TechPad_10xx",
                "model": "10XX"
            },
            {
                "regex": "Tech ?Pad[_ ]?(10Y|9x|i700|10Z|7QC|10QC|832|703)",
                "model": "$1"
            },
            {
                "regex": "TechPad[_ ]3Gx",
                "model": "3Gx"
            },
            {
                "regex": "3G_16",
                "model": "3G-16"
            },
            {
                "regex": "Android 8(?:[\\d.]*);(?: [\\w-]+;)? (816x?)",
                "model": "$1"
            },
            {
                "regex": "Dual (C981HD|C1081HD)",
                "model": "XTAB $1"
            },
            {
                "regex": "XTAB[ _-]([^/;)]+)(?: Build|[;)])",
                "model": "XTAB $1"
            },
            {
                "regex": "M5(Go|Plus)",
                "device": "smartphone",
                "model": "M5 $1"
            },
            {
                "regex": "M6Plus",
                "device": "smartphone",
                "model": "M6 Plus"
            },
            {
                "regex": "NOTE[ _]4CAM",
                "device": "smartphone",
                "model": "Note 4 Cam"
            },
            {
                "regex": "Tech_Pad_Kaios_One_3G",
                "device": "feature phone",
                "model": "Kaios One 3G"
            },
            {
                "regex": "Tech ?pad[ _-]([^/;)]+)(?: Build|[;)])",
                "model": "$1",
                "device": "smartphone"
            }
        ]
    },
    "Techwood": {
        "regex": "Techwood",
        "device": "tv",
        "model": ""
    },
    "Teracube": {
        "regex": "Teracube",
        "device": "smartphone",
        "models": [
            {
                "regex": "Teracube (2e|One)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Tesco": {
        "regex": "Hudl (?:[^/;]+)(?: Build|[;)])|W032i-C3(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Hudl ([^/;]+)(?: Build|[;)])",
                "model": "Hudl $1"
            },
            {
                "regex": "W032i-C3(?:[);/ ]|$)",
                "model": "Op3n Dott"
            }
        ]
    },
    "teXet": {
        "regex": "Texet|(NaviPad [^/;]*) Build|TM-(?:1046|1058|1057|1067|3000|3200R|3500|400[34]|4071|450[34]|451[30]|4377|4082R|508[34]|550[358]|5010|5017|507[4-7]|5[23]77|6003|6906|702[13]|7055HD|709[69]|9747BT|9758|9751HD|9767|5513|520[410]|507[13]|558[134]|570[23]|7859|8044|9748[ _]3G|9720|7047HD[ _]3G|9757|9740|4982|4515|4083|500[3567]|5571|3204R|5016|8043|7047HD[ _]3G|8041HD|8066|705[23]|7041|8041HD|8051|8048|974[96]|973[78]W|974[170]|9743W|9750HD|7043XD|7049|7887|7037W|702[46])|TB-(771A|711A)|X Point|X-Force[\\(-]?TM-5009\\)?|X-Plus[\\(-]?TM-5577\\)?|TM_5011|X-pad (?:AIR 8|iX 7|NAVI 7\\.[35]|NAVI 10|SKY 8\\.1|STYLE 8|STYLE 10\\.1|HIT|LITE 7\\.[12]|QUAD (?:7\\.2|10|7)|SHINE 8\\.1)(?: 3G)?",
        "device": "tablet",
        "models": [
            {
                "regex": "TM-9749",
                "model": "X-pad Plus 7.1 3G"
            },
            {
                "regex": "TM-9746",
                "model": "X-pad Plus 7 3G"
            },
            {
                "regex": "TM-8051",
                "model": "X-pad Force 8i 3G"
            },
            {
                "regex": "TM-1058",
                "model": "X-Force 10 3G"
            },
            {
                "regex": "TM-8048",
                "model": "X-pad Force 8 3G"
            },
            {
                "regex": "(NaviPad [^/;]*) Build",
                "model": "$1"
            },
            {
                "regex": "TM-7055HD",
                "model": "NaviPad 3G"
            },
            {
                "regex": "TM-9758",
                "model": "X-pad Style 10.0\""
            },
            {
                "regex": "X-pad SHINE 8\\.1 3G",
                "model": "X-pad Shine 8.1\" 3G"
            },
            {
                "regex": "X-pad QUAD 10 3G",
                "model": "X-pad Quad 10.0\" 3G"
            },
            {
                "regex": "X-pad QUAD 7 3G",
                "model": "X-pad Quad 7.0\" 3G"
            },
            {
                "regex": "X-pad QUAD 7\\.2 3G",
                "model": "X-pad Quad 7.2\" 3G"
            },
            {
                "regex": "X-pad STYLE 8 3G",
                "model": "X-pad Style 8.0\" 3G"
            },
            {
                "regex": "X-pad HIT 3G",
                "model": "X-pad Hit 3G"
            },
            {
                "regex": "X-pad LITE (7\\.[12])",
                "model": "X-pad Lite $1\""
            },
            {
                "regex": "TM-9767",
                "model": "X-pad Style 10.0\" 3G"
            },
            {
                "regex": "X-pad STYLE 10\\.1 3G",
                "model": "X-pad Style 10.1\" 3G"
            },
            {
                "regex": "(X-pad (?:AIR 8|iX 7) 3G)",
                "model": "$1"
            },
            {
                "regex": "TM-7096|X-pad NAVI 7\\.3 3G",
                "model": "X-pad NAVI 7.3\" 3G"
            },
            {
                "regex": "TM-7099",
                "model": "X-pad NAVI 7.4\" 3G"
            },
            {
                "regex": "X-pad NAVI 7\\.5 3G",
                "model": "X-pad NAVI 7.5\" 3G"
            },
            {
                "regex": "X-pad SKY 8\\.1 3G",
                "model": "X-pad Sky 8.1\" 3G"
            },
            {
                "regex": "TM-1046|X-pad NAVI 10 3G",
                "model": "X-pad NAVI 10.0\" 3G"
            },
            {
                "regex": "TM-7859",
                "model": "X-pad NAVI 8.2\" 3G"
            },
            {
                "regex": "TM-7049",
                "model": "NaviPad TM-7049 3G"
            },
            {
                "regex": "TM-7887",
                "model": "NaviPad TM-7887 3G"
            },
            {
                "regex": "TM-8066",
                "model": "X-pad Rapid 8.2\" 4G"
            },
            {
                "regex": "(TM-(?:1057|1067|6906|8043|9748[_ ]3G|9740|9757(?:[_ ]3G)?|7047HD[ _]3G|9747BT|9751HD|702[13]|705[23]|7041|9720|7047HD[_ ]3G|8044|8041HD|973[78]W|9743W|974[710]|9750HD|7043XD|7037W|702[46])|TB-(?:771A|711A|8041HD))",
                "model": "$1"
            },
            {
                "regex": "TM-4503",
                "device": "smartphone",
                "model": "X-Quad"
            },
            {
                "regex": "(TM-(?:3000|3200R|400[34]|4083|4377|4504|451[30]|500[35]|5[23]77|5571|3204R|520[04]|5581|5505|5017|507[13-7]|5081|6003|5513))",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "TM-5006",
                "device": "smartphone",
                "model": "X-Line"
            },
            {
                "regex": "TM-5007",
                "device": "smartphone",
                "model": "X-Shine"
            },
            {
                "regex": "TM_5011",
                "device": "smartphone",
                "model": "X-Omega"
            },
            {
                "regex": "TM-508(3|4)",
                "device": "smartphone",
                "model": "Pay $1G"
            },
            {
                "regex": "TM-558(3|4)",
                "device": "smartphone",
                "model": "Pay 5.5\" $1G"
            },
            {
                "regex": "TM-5702",
                "device": "smartphone",
                "model": "Pay 5.7\" 3G"
            },
            {
                "regex": "TM-5703",
                "device": "smartphone",
                "model": "Pay 5.7\" Pro"
            },
            {
                "regex": "TM-5201",
                "device": "smartphone",
                "model": "Rock"
            },
            {
                "regex": "TM-4515",
                "device": "smartphone",
                "model": "X-Style"
            },
            {
                "regex": "TM-(5016|3500)",
                "device": "smartphone",
                "model": "X-Maxi 2"
            },
            {
                "regex": "TM-4071",
                "device": "smartphone",
                "model": "X-Smart"
            },
            {
                "regex": "TM-4982",
                "device": "smartphone",
                "model": "iX-Maxi"
            },
            {
                "regex": "TEXET[_ ]IX-MINI",
                "device": "smartphone",
                "model": "iX-Mini"
            },
            {
                "regex": "TM-5010",
                "device": "smartphone",
                "model": "X-Selfie"
            },
            {
                "regex": "TM-4082R",
                "device": "smartphone",
                "model": "X-Driver Quad"
            },
            {
                "regex": "TM-5503",
                "device": "smartphone",
                "model": "X-Mage"
            },
            {
                "regex": "TM-5508",
                "device": "smartphone",
                "model": "X-Cosmo"
            },
            {
                "regex": "X-Force[\\(-]?TM-5009\\)?",
                "device": "smartphone",
                "model": "X-Force"
            },
            {
                "regex": "X-Plus[\\(-]?TM-5577\\)?",
                "device": "smartphone",
                "model": "X-Plus"
            },
            {
                "regex": "teXet[_ ]X-medium[_ ]plus",
                "device": "smartphone",
                "model": "X-Medium Plus"
            },
            {
                "regex": "X Point",
                "device": "smartphone",
                "model": "X-Point"
            }
        ]
    },
    "Telefunken": {
        "regex": "TELEFUNKEN|Foxtrot|TEL-1013GIQA|TEL-1014GIQ|TEL-73GIQA|TEL-74GIQ|TF-SP(?:500[12]|4002)|(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))| TF5X| TF6|TF500|TF501_EC|(TF-LED(?:32S14T2S|43S9[57]T2SU|50S0[34]T2SU|50S25T2SU|55S11T2SU|58S06T2SU|65S75T2SU|32S39T2S|32S08T2S|32S5[289]T2S|32S60T2S|32S7[045]T2S|40S63T2S|40S19T2S|40S41T2S|43S94T2S|43S22T2SU)(?:-1)?)|LTE_LIMA|LTE Mike|Diamond_LTE|Outdoor (?:LTE|WT4|WT4-S)|TELP-1013KBC",
        "device": "tablet",
        "models": [
            {
                "regex": "TEL-1013GIQA",
                "model": "Giqa 10.1\" 3G"
            },
            {
                "regex": "TEL-(1014GIQ|74GIQ|73GIQA(?:11)?)",
                "model": "TEL-$1"
            },
            {
                "regex": "Foxtrot2",
                "model": "Foxtrot 2",
                "device": "smartphone"
            },
            {
                "regex": "LTE_LIMA",
                "model": "Lima LTE",
                "device": "smartphone"
            },
            {
                "regex": "Diamond_LTE",
                "model": "Diamond LTE",
                "device": "smartphone"
            },
            {
                "regex": "LTE Mike",
                "model": "Mike LTE",
                "device": "smartphone"
            },
            {
                "regex": "(?:TELEFUNKEN)?(TF-SP(?:500[12]|4002)|Outdoor (?:LTE|WT4-S|WT4)|Foxtrot|TF5X|TF6)",
                "model": "$1",
                "device": "smartphone"
            },
            {
                "regex": "(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G)|TF501_EC|TELP-1013KBC)",
                "model": "$1"
            },
            {
                "regex": "(TF-LED(?:\\d{2}S\\d{2}T2SU?)|TF500)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "TELEFUNKEN, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": "",
                "device": "tv"
            }
        ]
    },
    "Telego": {
        "regex": "TELEGO|Wise2_plus",
        "device": "smartphone",
        "models": [
            {
                "regex": "TELEGO-W503",
                "model": "W503"
            },
            {
                "regex": "Telego_JOY2",
                "model": "Joy 2"
            },
            {
                "regex": "Wise2_plus",
                "model": "Wise 2 Plus"
            },
            {
                "regex": "Telego[ _-]([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Telenor": {
        "regex": "(?<!FBCR/)Telenor|(?:Infinity[_ ](?:E[2-5]|K2?|A2))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Telenor[ _]([^;/]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "Infinity[ _](E[2-5]|K2?|A2)",
                "model": "Infinity $1"
            }
        ]
    },
    "Telit": {
        "regex": "Telit",
        "device": "feature phone",
        "models": [
            {
                "regex": "Telit_Mobile_Terminals-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "Telit[\\-_]?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Telly": {
        "regex": "TY55_1",
        "device": "tv",
        "models": [
            {
                "regex": "TY55_1",
                "model": "TY55-1"
            }
        ]
    },
    "Telma": {
        "regex": "Telma|(?:F1x4G|Feel_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Telma_F1_Max_4G",
                "model": "F1 Max 4G"
            },
            {
                "regex": "TELMA F1\\+4G",
                "model": "F1 Plus 4G"
            },
            {
                "regex": "F1x4G",
                "model": "F1x 4G"
            },
            {
                "regex": "Feel_Plus",
                "model": "Feel Plus"
            },
            {
                "regex": "TELMA[_ ]FEEL",
                "model": "Feel"
            },
            {
                "regex": "Telma[_ ](F2|Titan[_ ]4G|EGO)",
                "model": "$1"
            },
            {
                "regex": "Telma_Wi-Kif\\+3G_3G",
                "model": "Wi-Kif+ 3G"
            },
            {
                "regex": "Telma_Wi-Kif\\+4G_4G",
                "model": "Wi-Kif+ 4G"
            },
            {
                "regex": "Telma_Wikif_Max_4G",
                "model": "Wi-Kif Max"
            }
        ]
    },
    "Telpo": {
        "regex": "TPS3[29]0",
        "device": "peripheral",
        "models": [
            {
                "regex": "TPS(3[29]0)",
                "model": "TPS$1"
            }
        ]
    },
    "ThL": {
        "regex": "ThL[ _-]|(?:Knight 2|THL5000|T200)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Knight 2",
                "model": "Knight 2"
            },
            {
                "regex": "THL ?(5000)",
                "model": "$1"
            },
            {
                "regex": "(T200)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Box 1 Pro(?:[);/ ]|$)",
                "device": "tv",
                "model": "Box 1 Pro"
            },
            {
                "regex": "Box 1(?:[);/ ]|$)",
                "device": "tv",
                "model": "Box 1"
            },
            {
                "regex": "ThL[ _-]*([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            },
            {
                "regex": "ThL[ _-]*([^ ;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "TIANYU": {
        "regex": "TIANYU",
        "device": "feature phone",
        "models": [
            {
                "regex": "TIANYU ([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "TIANYU-KTOUCH/([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Tooky": {
        "regex": "TOOKY",
        "device": "smartphone",
        "models": [
            {
                "regex": "TOOKY (A19|W1|T8[368]|T1982)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "TOOKY A9PLUS(?:[);/ ]|$)",
                "model": "A9 Plus"
            }
        ]
    },
    "Tolino": {
        "regex": "Tolino Tab ([^/);]+)(?: Build|[);])",
        "device": "tablet",
        "model": "Tolino Tab $1"
    },
    "Top House": {
        "regex": "Coto[_ ]|X1013",
        "device": "smartphone",
        "models": [
            {
                "regex": "Coto W418",
                "model": "Coto W418"
            },
            {
                "regex": "COTO_T117",
                "model": "Coto T117",
                "device": "tablet"
            },
            {
                "regex": "X1013",
                "model": "X1013",
                "device": "tablet"
            },
            {
                "regex": "COTO_T40017",
                "model": "T40017"
            }
        ]
    },
    "Topelotek": {
        "regex": "KIDS(09|708)",
        "device": "tablet",
        "model": "KIDS$1 Kids Tablet"
    },
    "Toplux": {
        "regex": "Toplux ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Touchmate": {
        "regex": "TOUCHMATE|(TM-(?:MID870SB|MID1050WKD|MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|SM500N|SM410|MID1010|MID1065))",
        "device": "smartphone",
        "models": [
            {
                "regex": "(TM-(?:MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|MID10[14]0|MID1065))",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "TM-MID870SB",
                "device": "tablet",
                "model": "SuperMan 8\""
            },
            {
                "regex": "TM-MID1050WKD",
                "device": "tablet",
                "model": "Mega Matrix 10.1\" 3G"
            },
            {
                "regex": "(TM-(?:SM500N|SM410))",
                "model": "$1"
            },
            {
                "regex": "Touchmate ([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "PEAQ": {
        "regex": "PEAQ[ _]|PET \\d{3}|LGE; (?:PQ[a-z0-9-]+);",
        "device": "tablet",
        "models": [
            {
                "regex": "PET ([^/;)]+)(?: Build|[;)])",
                "model": "PET $1"
            },
            {
                "regex": "LGE; (PQ[a-z0-9-]+);",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "TrekStor": {
        "regex": "(?:TrekStor|Surftab) ([^/;]+)(?: Build|\\))|Surftab[^;\\)]*(?:[;\\)]|$)|ST10216-2A|ST13416-1|VT10416-[12]|TFQCOAL01232|TFMTKAW01232|Xintroni10\\.1",
        "device": "tablet",
        "models": [
            {
                "regex": "ST10216-2A|VT10416-[12]",
                "model": "SurfTab 10.1"
            },
            {
                "regex": "ST13416-1",
                "model": "SurfTab Theatre 13.4\""
            },
            {
                "regex": "Surftab theatre S11",
                "model": "SurfTab Theatre S11"
            },
            {
                "regex": "PrimeTab P10",
                "model": "PrimeTab P10"
            },
            {
                "regex": "TrekStor ([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Surftab ([^/;]+) Build",
                "model": "SurfTab $1"
            },
            {
                "regex": "Surftab[ _]([^;\\)]*)(?:[;\\)]|$)",
                "model": "SurfTab $1"
            },
            {
                "regex": "TFMTKAW01232",
                "model": "SurfTab L15"
            },
            {
                "regex": "(TFQCOAL01232)",
                "model": "$1"
            },
            {
                "regex": "Xintroni10\\.1",
                "model": "SurfTab Xintron I 10.1\""
            }
        ]
    },
    "Trevi": {
        "regex": "Trevi[ _]|TAB[ _]10[ _]3G[ _]V16|TAB[ _](7|8)[ _]3G[ _]V8|TAB9 3G|MINITAB 3GV|Phablet[ _](?:4|4\\.5|5|5\\,3|6)[ _]?[CSQ]|REVERSE[ _]5\\.5[ _]?Q",
        "device": "tablet",
        "models": [
            {
                "regex": "TAB[ _]?(7|8)[ _]3G[ _]V8",
                "model": "TAB $1 3G V8"
            },
            {
                "regex": "TAB[ _]?9[ _]3G[ _]V8",
                "model": "TAB 9 3G V8"
            },
            {
                "regex": "TAB[ _]?9[ _]3G",
                "model": "TAB 9 3G"
            },
            {
                "regex": "TAB[ _]10[ _]3G[ _]V16",
                "model": "TAB 10 3G V16"
            },
            {
                "regex": "MINITAB 3GV",
                "model": "MINITAB 3G V"
            },
            {
                "regex": "(?:Trevi_)?Phablet[ _]4[ _]?C",
                "model": "Phablet 4 C",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?Phablet[ _]4[ _]?S",
                "model": "Phablet 4 S",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?Phablet[ _]4\\.5[ _]?Q",
                "model": "Phablet 4.5Q",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?PHABLET[ _]5[ _]?S",
                "model": "Phablet 5 S",
                "device": "smartphone"
            },
            {
                "regex": "(?:Trevi_)?PHABLET[ _]5,3[ _]?Q",
                "model": "Phablet 5.3 Q",
                "device": "phablet"
            },
            {
                "regex": "(?:Trevi_)?REVERSE[ _]5\\.5[ _]?Q",
                "model": "Phablet 5.5 Q REVERSE",
                "device": "phablet"
            },
            {
                "regex": "(?:Trevi_)?PHABLET[ _]6[ _]?S",
                "model": "Phablet 6 S",
                "device": "phablet"
            },
            {
                "regex": "Trevi[_]([^;/]+) Build",
                "model": "$1"
            }
        ]
    },
    "TVC": {
        "regex": "(NuclearSX-SP5)",
        "device": "smartphone",
        "model": "Nuclear SX-SP5"
    },
    "U.S. Cellular": {
        "regex": "USCC-",
        "device": "smartphone",
        "models": [
            {
                "regex": "USCC-E6762",
                "model": "Kyocera DuraForce"
            },
            {
                "regex": "(USCC-[a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Uhappy": {
        "regex": "Uhappy|UP?580|UP350|UP[35679]20",
        "device": "smartphone",
        "models": [
            {
                "regex": "UP([35679]20)",
                "model": "UP$1"
            },
            {
                "regex": "UP350",
                "model": "UP350"
            },
            {
                "regex": "UP580",
                "model": "UP580"
            },
            {
                "regex": "U580",
                "model": "U580"
            },
            {
                "regex": "Uhappy[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Uhappy[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Unimax": {
        "regex": "U((?:67[013]|680)C|(?:452|504)TL|683CL|69[36]CL)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "UMX U$1"
    },
    "Unowhy": {
        "regex": "(?:QOOQ|QOOQ-V[1-5]0?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "QOOQ-V([1-5])0?",
                "model": "QOOQ V$1"
            },
            {
                "regex": "QOOQ",
                "model": "QOOQ"
            }
        ]
    },
    "UTStarcom": {
        "regex": "utstar[ _-]?([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Ulefone": {
        "regex": "Ulefone|Gemini Pro|Power[ _]Armor14|Power 3S|Power_[356]|Power_5S|S(?:10|9)_Pro|(?:Note [89]P|Note 1[23]P|Armor(?! P1[sw]| P1 Pro| H[12]s| I2w| V1s| I1 Slim| C1 Max)(?:[ _](?:[2367]|2S|X[236]|6[SE]|3WT|3W|X))?|U00[78][ _]Pro|Be[ _]X|Be[ _]Touch(?:[ _][23])?|Be[ _](?:One|Pure|Pro)(?:[ _]Lite)?|Note 14|Note (?:11P|7T)|(?<!MZ-MEIZU )Note 16 Pro|Tiger_lite|Note_7P|Note 10P|Paris_(?:Lite|X)|Paris|P6000_Plus|Vienna|RugKing|GQ3060TF3|Android 11(?:[\\d.]*);(?: [\\w-]+;)? Note 6P?|Tab A11 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S(10|9)_Pro",
                "model": "S$1 Pro"
            },
            {
                "regex": "Be[ _]Touch([ _][23])?",
                "model": "Be Touch$1"
            },
            {
                "regex": "Be[ _]Pure[ _]Lite",
                "model": "Be Pure Lite"
            },
            {
                "regex": "Be[ _]Pure",
                "model": "Be Pure"
            },
            {
                "regex": "Be[ _]One[ _]Lite",
                "model": "Be One Lite"
            },
            {
                "regex": "Be[ _]One",
                "model": "Be One"
            },
            {
                "regex": "Be[ _]X",
                "model": "Be X"
            },
            {
                "regex": "Be[ _]Pro",
                "model": "Be Pro"
            },
            {
                "regex": "U(00[78]) Pro",
                "model": "U$1 Pro"
            },
            {
                "regex": "P6000_Plus",
                "model": "P6000 Plus"
            },
            {
                "regex": "Paris_lite",
                "model": "Paris Lite"
            },
            {
                "regex": "Paris_X",
                "model": "Paris X"
            },
            {
                "regex": "RugKing",
                "model": "RugKing"
            },
            {
                "regex": "Paris",
                "model": "Paris"
            },
            {
                "regex": "Tiger_lite",
                "model": "Tiger Lite"
            },
            {
                "regex": "Power[ _]Armor[ _]?(\\d+)[ _]Pro",
                "model": "Power Armor $1 Pro"
            },
            {
                "regex": "Power Armor X11 Pro",
                "model": "Power Armor X11 Pro"
            },
            {
                "regex": "Power Armor (\\d+|19T|X11|18T|16S)(?:[);/ ]|$)",
                "model": "Power Armor $1"
            },
            {
                "regex": "Armor[ _]6S(?:[);/ ]|$)",
                "model": "Armor 6S"
            },
            {
                "regex": "GQ3060TF3(?:[);/ ]|$)",
                "model": "Armor 20WT"
            },
            {
                "regex": "Armor[ _]([679])E(?:[);/ ]|$)",
                "model": "Armor $1E"
            },
            {
                "regex": "Armor[ _]X(\\d+) Pro(?:[);/ ]|$)",
                "model": "Armor X$1 Pro"
            },
            {
                "regex": "Armor[ _]X(\\d+)(?:[);/ ]|$)",
                "model": "Armor X$1"
            },
            {
                "regex": "Armor[ _]([25])S(?:[);/ ]|$)",
                "model": "Armor $1S"
            },
            {
                "regex": "Armor[ _]X(?:[);/ ]|$)",
                "model": "Armor X"
            },
            {
                "regex": "Armor[ _]3W(?:[);/ ]|$)",
                "model": "Armor 3W"
            },
            {
                "regex": "Armor[ _]3WT(?:[);/ ]|$)",
                "model": "Armor 3WT"
            },
            {
                "regex": "Armor[ _](1\\d|11T) 5G(?:[);/ ]|$)",
                "model": "Armor $1 5G"
            },
            {
                "regex": "Armor[ _](8) Pro(?:[);/ ]|$)",
                "model": "Armor $1 Pro"
            },
            {
                "regex": "Armor[ _]([236789])(?:[);/ ]|$)",
                "model": "Armor $1"
            },
            {
                "regex": "Armor Pad([^;/)]*)(?: Build|[);])",
                "device": "tablet",
                "model": "Armor Pad$1"
            },
            {
                "regex": "Armor([^;/)]*)(?: Build|[);])",
                "model": "Armor$1"
            },
            {
                "regex": "Gemini Pro(?:[);/ ]|$)",
                "model": "Gemini Pro"
            },
            {
                "regex": "Vienna",
                "model": "Vienna"
            },
            {
                "regex": "Power[_ ]([356][SL]?)",
                "model": "Power $1"
            },
            {
                "regex": "Note[ _]([78]P|7T|6|14)(?:[);/ ]|$)",
                "model": "Note $1"
            },
            {
                "regex": "Note[ _](16) Pro(?:[);/ ]|$)",
                "model": "Note $1 Pro"
            },
            {
                "regex": "Note ([69]|1[123]|10)P(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Note $1P"
            },
            {
                "regex": "Tab A11 Pro",
                "device": "tablet",
                "model": "Tab A11 Pro"
            },
            {
                "regex": "Ulefone[_ ]Tab[_ ]([^;/)]+)(?: Build|[);])",
                "device": "tablet",
                "model": "Tab $1"
            },
            {
                "regex": "Ulefone[_ ](X|S1[ _]Pro|S[17])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Ulefone[ _-]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Ulefone[ _-]?([^;/)]+)(?:[;/)]|$)",
                "model": "$1"
            }
        ]
    },
    "UMIDIGI": {
        "regex": "UMI(?:DIGI)?[ _]|(?:A[5]_Pro|.+; A[79] Pro|S3_Pro|ROME[_ ]X|BISON|hammer_S|S2 LITE|London|Z2_PRO|C NOTE 2|A11 Pro Max|Power 3|Android 10(?:[\\d.]*);(?: [\\w-]+;)? (?:A3[SX]|A7S(?! 2020))|RP0[1234]|MT0[167]|MT1[016]|MP0[1-9]|MP1[3789]|MP2[0134-79]|MP34|Plus E|S2_PRO|RP05|(?<! HP Engage )One Pro|Diamond_X|TG3DBG1MA|Android [67](?:[\\d.]*);(?: [\\w-]+;)? Z Pro|Android 8(?:[\\d.]*);(?: [\\w-]+;)? A1_PRO|RP08|MP3[38]|PR4JBX20A|PG2309GBA|PA2310GBB)(?:[;/) ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MT01",
                "device": "tablet",
                "model": "A11 Tab"
            },
            {
                "regex": "MT07",
                "device": "tablet",
                "model": "A13 Tab"
            },
            {
                "regex": "MT06",
                "device": "tablet",
                "model": "G3 Tab"
            },
            {
                "regex": "TG3DBG1MA|MT10",
                "device": "tablet",
                "model": "G1 Tab"
            },
            {
                "regex": "MT11",
                "device": "tablet",
                "model": "G2 Tab"
            },
            {
                "regex": "MT16",
                "device": "tablet",
                "model": "G5 Tab"
            },
            {
                "regex": "(A[13579]|Z2|S3)[_ ]Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "PA2310GBB",
                "model": "A15T"
            },
            {
                "regex": "A11 Pro Max",
                "model": "A11 Pro Max"
            },
            {
                "regex": "MP17",
                "model": "C1 Max"
            },
            {
                "regex": "MP29",
                "model": "C1 Plus"
            },
            {
                "regex": "MP07",
                "model": "C1"
            },
            {
                "regex": "MP20",
                "model": "C2"
            },
            {
                "regex": "MP21",
                "model": "G2"
            },
            {
                "regex": "MP09",
                "model": "F3"
            },
            {
                "regex": "MP19",
                "model": "F3 Pro 5G"
            },
            {
                "regex": "MP13",
                "model": "F3 5G"
            },
            {
                "regex": "MP18",
                "model": "G1 Max"
            },
            {
                "regex": "MP01(?:[;/) ]|$)",
                "model": "A11S"
            },
            {
                "regex": "MP05(?:[;/) ]|$)",
                "model": "A13S"
            },
            {
                "regex": "MP33(?:[;/) ]|$)",
                "model": "A15"
            },
            {
                "regex": "MP34(?:[;/) ]|$)",
                "model": "A15C"
            },
            {
                "regex": "RP08(?:[;/) ]|$)",
                "model": "G5 Mecha"
            },
            {
                "regex": "MP27(?:[;/) ]|$)",
                "model": "G5"
            },
            {
                "regex": "PG2309GBA",
                "model": "G6 5G"
            },
            {
                "regex": "MP38(?:[;/) ]|$)",
                "model": "G5A"
            },
            {
                "regex": "MP24(?:[;/) ]|$)",
                "model": "G3"
            },
            {
                "regex": "MP26(?:[;/) ]|$)",
                "model": "G3 Max"
            },
            {
                "regex": "MP25(?:[;/) ]|$)",
                "model": "G3 Plus"
            },
            {
                "regex": "UMI TOUCH X",
                "model": "Touch X"
            },
            {
                "regex": "UMI TOUCH",
                "model": "Touch"
            },
            {
                "regex": "Plus E",
                "model": "Plus E"
            },
            {
                "regex": "One Pro",
                "model": "One Pro"
            },
            {
                "regex": "ROME[_ ]X",
                "model": "Rome X"
            },
            {
                "regex": "BISON GT",
                "model": "Bison GT"
            },
            {
                "regex": "PR4JBX20A",
                "model": "Bison X20"
            },
            {
                "regex": "RP05(?:[;/) ]|$)",
                "model": "Bison X10G"
            },
            {
                "regex": "Bison N1",
                "model": "Bison N1"
            },
            {
                "regex": "RP01(?:[;/) ]|$)",
                "model": "Bison X10"
            },
            {
                "regex": "RP02(?:[;/) ]|$)",
                "model": "Bison GT2 5G"
            },
            {
                "regex": "RP03(?:[;/) ]|$)",
                "model": "Bison GT2"
            },
            {
                "regex": "RP04(?:[;/) ]|$)",
                "model": "Bison 2"
            },
            {
                "regex": "BISON Pro",
                "model": "Bison Pro"
            },
            {
                "regex": "BISON",
                "model": "Bison"
            },
            {
                "regex": "hammer_S",
                "model": "Hammer S"
            },
            {
                "regex": "Diamond_X",
                "model": "Diamond X"
            },
            {
                "regex": "C NOTE 2",
                "model": "C Note 2"
            },
            {
                "regex": "UMI[_ ]SUPER",
                "model": "Super"
            },
            {
                "regex": "UMI[_ ]ZERO",
                "model": "Zero"
            },
            {
                "regex": "Z Pro",
                "model": "Z Pro"
            },
            {
                "regex": "S2 LITE",
                "model": "S2 Lite"
            },
            {
                "regex": "S2_PRO",
                "model": "S2 Pro"
            },
            {
                "regex": "Power 3",
                "model": "Power 3"
            },
            {
                "regex": "MP02(?:[;/) ]|$)",
                "model": "Power 5S"
            },
            {
                "regex": "MP08(?:[;/) ]|$)",
                "model": "G1"
            },
            {
                "regex": "MP03(?:[;/) ]|$)",
                "model": "A13 Pro 5G"
            },
            {
                "regex": "MP04(?:[;/) ]|$)",
                "model": "A13 Pro Max 5G"
            },
            {
                "regex": "MP06(?:[;/) ]|$)",
                "model": "Power 7 Max"
            },
            {
                "regex": "(A3[SX]|A7S)(?:[;/) ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:UMI_)?(London|Diamond(?:_X)?)",
                "model": "$1"
            },
            {
                "regex": "UMI(?:DIGI)?[ _]([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Uniqcell": {
        "regex": "UNIQCELL_|(?:[AQ]5\\.8|UNI (?:10X|GO))(?:[;/) ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "UNIQCELL_A4(?:[;/) ]|$)",
                "model": "A4"
            },
            {
                "regex": "(Space A5\\.8|Q5\\.8|UNI (?:10X|GO))(?:[;/) ]|$)",
                "model": "$1"
            }
        ]
    },
    "Uniscope": {
        "regex": "Uniscope",
        "device": "smartphone",
        "models": [
            {
                "regex": "Uniscope[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "Uniscope[ _-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Unistrong": {
        "regex": "(UT10)(?:[;/) ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "United Group": {
        "regex": "(?:SDOTT0202|SDSTB02)(?:[;/) ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SDOTT0202",
                "model": "EON Smart Box (2019-2020)"
            },
            {
                "regex": "SDSTB02",
                "model": "EON Smart Box (2023)"
            }
        ]
    },
    "Unnecto": {
        "regex": "Unnecto|(?:U513|U5151|U61[1356]|U7[12]0|U-830|U90[35])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "U513",
                "model": "Drone XT"
            },
            {
                "regex": "U5151",
                "model": "Bolt"
            },
            {
                "regex": "U611",
                "model": "Quattro X"
            },
            {
                "regex": "U613",
                "model": "Quattro S"
            },
            {
                "regex": "U615",
                "model": "Quattro M"
            },
            {
                "regex": "U616",
                "model": "U616"
            },
            {
                "regex": "U710",
                "model": "Quattro U710"
            },
            {
                "regex": "U720",
                "model": "Quattro Z"
            },
            {
                "regex": "U-830",
                "model": "Rush"
            },
            {
                "regex": "U903",
                "model": "Air"
            },
            {
                "regex": "U905",
                "model": "Air 5.5"
            }
        ]
    },
    "Unnion Technologies": {
        "regex": "UNSP7(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "UNSP7(?:[);/ ]|$)",
                "model": "SP7"
            }
        ]
    },
    "Unonu": {
        "regex": "Unonu[ _-]|(?:U4001|UT3G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(U4001|UT3G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Unonu[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Unonu[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "UTOK": {
        "regex": "UTOK (45[01]D)|(?:Dorel \\d|Dorel 3S|Hello 7Q)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "UTOK (45[01]D)",
                "model": "$1"
            },
            {
                "regex": "Dorel 3S",
                "model": "Dorel 3S"
            },
            {
                "regex": "Dorel (\\d)",
                "model": "Dorel $1"
            },
            {
                "regex": "Hello 7Q",
                "device": "tablet",
                "model": "Hello 7Q"
            }
        ]
    },
    "Vastking": {
        "regex": "(?:M910A|M783K|M783K-16G|M1072R-3G|KingPad[_ ](?:[KM]10|SA10|SA8|Z10)(?:Pro)?)(?:_EEA)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "KingPad[_ ]([KM]10|SA10|SA8|Z10)(Pro)?",
                "model": "KingPad $1 $2"
            },
            {
                "regex": "(M910A|M783K|M783K-16G|M1072R-3G)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "ViewSonic": {
        "regex": "ViewSonic|ViewPad|ViewPhone|(?:IFP(?:98|86|[67]5)50-3|VSD[0-9]+|vsi7q_1)(?:[);/ ]|$)",
        "device": "smart display",
        "models": [
            {
                "regex": "(?:ViewSonic-)?V500(?:[);/ ]|$)",
                "model": "V500",
                "device": "smartphone"
            },
            {
                "regex": "ViewSonic A8\\+(?:[);/ ]|$)",
                "model": "A8 Plus",
                "device": "smartphone"
            },
            {
                "regex": "(?:ViewSonic-)?ViewPhone ?([^;/]+)(?: Build|[;)])",
                "model": "ViewPhone $1",
                "device": "smartphone"
            },
            {
                "regex": "vsi7q_1",
                "model": "ViewPad i7Q",
                "device": "tablet"
            },
            {
                "regex": "(?:ViewSonic-)?ViewPad[ _]?([^;/)]+)(?: Build|[;)])",
                "model": "ViewPad $1",
                "device": "tablet"
            },
            {
                "regex": "(VSD[0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "IFP(98|86|[67]5)50-3",
                "model": "ViewBoard IFP$150-3 $1\" 4K"
            }
        ]
    },
    "Vitelcom": {
        "regex": "Vitelcom|portalmmm/[12]\\.0 TSM",
        "device": "feature phone",
        "models": [
            {
                "regex": "TSM-([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "TSM([a-z0-9-]+)",
                "model": "$1"
            },
            {
                "regex": "portalmmm/[12]\\.0 (TSM[a-z0-9 ]+)",
                "model": "$1"
            }
        ]
    },
    "Fengxiang": {
        "regex": "(vKB011B|vKB004L)",
        "device": "tablet",
        "model": "$1"
    },
    "Fenoti": {
        "regex": "FENOTI|(?:42FN6000F)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:FENOTI_)?(42FN6000F)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "VK Mobile": {
        "regex": "VK-VK([79]00)(?:[);/ ]|$)",
        "device": "feature phone",
        "model": "VK$1"
    },
    "Fortis": {
        "regex": "(Apollo 5 Neo)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "FortuneShip": {
        "regex": "ENIE E2(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Enie E2"
    },
    "Vernee": {
        "regex": "Vernee|(?:Mars Pro|Apollo[ _](?:Lite|X)|Thor (?:E|Plus)|X2_euro|M7_EEA|T3 Pro|V2 Pro|(?<!MAXTRON )Apollo(?! Premium))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Apollo[ _]Lite",
                "model": "Apollo Lite"
            },
            {
                "regex": "Apollo[ _]X",
                "model": "Apollo X"
            },
            {
                "regex": "Apollo",
                "model": "Apollo"
            },
            {
                "regex": "Mars Pro",
                "model": "Mars Pro"
            },
            {
                "regex": "Thor E",
                "model": "Thor E"
            },
            {
                "regex": "Thor Plus",
                "model": "Thor Plus"
            },
            {
                "regex": "Vernee_M5",
                "model": "M5"
            },
            {
                "regex": "M7_EEA",
                "model": "M7"
            },
            {
                "regex": "X2_euro",
                "model": "X2"
            },
            {
                "regex": "(V2|T3) Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "Vernee[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Vernee[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Vertu": {
        "regex": "Vertu[ ]?([a-z0-9]+)|(?:ASTER(?: [PT])?|CONSTELLATION X|VTL-(?:202[123]01|202402))(?:[);/ ]|$)",
        "device": "feature phone",
        "models": [
            {
                "regex": "ASTER( [PT])?(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Aster$1"
            },
            {
                "regex": "VTL-202402",
                "device": "smartphone",
                "model": "Quantum Flip"
            },
            {
                "regex": "VTL-202101",
                "device": "smartphone",
                "model": "iVertu 5G"
            },
            {
                "regex": "VTL-202201",
                "device": "smartphone",
                "model": "Metavertu 5G"
            },
            {
                "regex": "VTL-202301",
                "device": "smartphone",
                "model": "Metavertu 2 5G"
            },
            {
                "regex": "CONSTELLATION X(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Constellation X"
            },
            {
                "regex": "Vertu[ ]?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Veidoo": {
        "regex": "VEIDOO",
        "device": "tablet",
        "models": [
            {
                "regex": "VEIDOO_(T60)_PLUS(?:[);/ ]|$)",
                "model": "$1 Plus"
            }
        ]
    },
    "Venso": {
        "regex": "(?:CX-508|CX-551|Reiv 500|Creon F5|Isprit U50|Isprit-U50-LTE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Isprit U50|Isprit-U50-LTE",
                "model": "Isprit U50"
            },
            {
                "regex": "(CX-508|CX-551|Reiv 500|Creon F5)",
                "model": "$1"
            }
        ]
    },
    "Venturer": {
        "regex": "(?:VCT([a-z0-9_-]+)|CT9A03W23|CT9A06P23)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "VCT9B06Q22(?:[);/ ]|$)",
                "model": "Challenger Pro 10.1\""
            },
            {
                "regex": "(?:CT9A03W23|CT9A06P23)(?:[);/ ]|$)",
                "model": "Mariner 10 Pro"
            },
            {
                "regex": "VCT([a-z0-9_-]+)",
                "model": "VCT$1"
            }
        ]
    },
    "Verizon": {
        "regex": "QTA(SUN[12]|XIA1|QZ3|QZ3KID|IR7)|QMV7[AB]|WTVIS01",
        "device": "tablet",
        "models": [
            {
                "regex": "QTAXIA1|QTAIR7",
                "model": "Ellipsis 10"
            },
            {
                "regex": "QTASUN1",
                "model": "Ellipsis 8 HD"
            },
            {
                "regex": "QTASUN2",
                "model": "Ellipsis 8 HD 4G LTE"
            },
            {
                "regex": "QTAQZ3KID",
                "model": "Ellipsis Kids LTE"
            },
            {
                "regex": "QTAQZ3",
                "model": "Ellipsis 8"
            },
            {
                "regex": "QMV7[AB]",
                "model": "Ellipsis 7"
            },
            {
                "regex": "WTVIS01",
                "device": "smartphone",
                "model": "Visible Midnight"
            }
        ]
    },
    "Verykool": {
        "regex": "verykool",
        "device": "smartphone",
        "models": [
            {
                "regex": "verykool[ _]?SL5009",
                "model": "Jet"
            },
            {
                "regex": "verykool[ _]?S5001",
                "model": "Lotus"
            },
            {
                "regex": "verykool[ _]?S5004",
                "model": "Lotus Jr"
            },
            {
                "regex": "verykool[ _]?S5007",
                "model": "Lotus Plus"
            },
            {
                "regex": "verykool[ _]?s5015",
                "model": "Spark II"
            },
            {
                "regex": "verykool[ _]?SL5011",
                "model": "Spark LTE"
            },
            {
                "regex": "verykool[ _]?s5019",
                "model": "Wave"
            },
            {
                "regex": "verykool[ _]?S5005",
                "model": "Lotus II"
            },
            {
                "regex": "verykool[ _]?SL5560",
                "model": "Maverick Pro"
            },
            {
                "regex": "verykool[ _]?SL5200",
                "model": "Eclipse"
            },
            {
                "regex": "verykool[ _]?SL5050",
                "model": "Phantom"
            },
            {
                "regex": "verykool[ _]?S5030",
                "model": "Helix II"
            },
            {
                "regex": "verykool[ _]?s5527",
                "model": "Alpha Pro"
            },
            {
                "regex": "verykool[ _]?s5526",
                "model": "Alpha"
            },
            {
                "regex": "verykool[ _]?S5530",
                "model": "Maverick II"
            },
            {
                "regex": "verykool[ _]?S5525",
                "model": "Maverick III"
            },
            {
                "regex": "verykool[ _]?S5524",
                "model": "Maverick III Jr"
            },
            {
                "regex": "verykool[ _]?s5516",
                "model": "Maverick Jr"
            },
            {
                "regex": "verykool[ _]?SL5550",
                "model": "Maverick LTE"
            },
            {
                "regex": "verykool[ _]?s5035",
                "model": "Spear"
            },
            {
                "regex": "verykool[ _]?s5034",
                "model": "Spear Jr"
            },
            {
                "regex": "verykool[ _]?s5037",
                "model": "Apollo Quattro"
            },
            {
                "regex": "verykool[ _]?s5036",
                "model": "Apollo"
            },
            {
                "regex": "Sol Quatro Jr",
                "model": "Sol Quatro Jr"
            },
            {
                "regex": "verykool[ _]?s6005x",
                "model": "Cyprus Pro"
            },
            {
                "regex": "verykool[ _]?SL6010",
                "model": "Cyprus LTE"
            },
            {
                "regex": "verykool[ _]?S4006[QT]?",
                "model": "Leo 3G"
            },
            {
                "regex": "verykool[ _]?S4007",
                "model": "Leo IV"
            },
            {
                "regex": "verykool[ _]?S4008",
                "model": "Leo V"
            },
            {
                "regex": "verykool[ _]?s5017|Dorado s5017",
                "model": "Dorado"
            },
            {
                "regex": "verykool[ _]?s4510",
                "model": "Luna"
            },
            {
                "regex": "verykool[ _]?s5204",
                "model": "Orion"
            },
            {
                "regex": "verykool[ _]?s5205",
                "model": "Orion Pro"
            },
            {
                "regex": "verykool[ _]?s5528Jr",
                "model": "Cosmo Jr"
            },
            {
                "regex": "verykool[ _]?s5528",
                "model": "Cosmo"
            },
            {
                "regex": "verykool[ _]?s5702",
                "model": "Royale Quattro"
            },
            {
                "regex": "verykool[ _]?SL5029",
                "model": "Bolt Pro"
            },
            {
                "regex": "verykool[ _]?SL5565",
                "model": "Rocket"
            },
            {
                "regex": "verykool[ _]?TL8010",
                "device": "tablet",
                "model": "KolorPad LTE"
            },
            {
                "regex": "verykool[ _]?T7440",
                "device": "tablet",
                "model": "KolorPad II"
            },
            {
                "regex": "verykool[ _]?T7445",
                "device": "tablet",
                "model": "KolorPad IV"
            },
            {
                "regex": "verykool[ _]?([^/;)]+)(?:[ _]SL?[0-9]{4}[QT]?)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "verykool[ _]?([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Finlux": {
        "regex": "FINLUX",
        "device": "tv",
        "models": [
            {
                "regex": "FINLUX, ?([0-9]+[a-z0-9_ -]+), ?(?:wired|wireless)",
                "model": "$1"
            }
        ]
    },
    "Hitachi": {
        "regex": "HITACHI[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "HITACHI, ?([0-9]+[a-z0-9_ -]+), ?(?:wired|wireless)",
                "model": "$1"
            }
        ]
    },
    "Mitchell & Brown": {
        "regex": "MITCHELL_BROWN[;,]",
        "device": "tv",
        "model": ""
    },
    "Logik": {
        "regex": "DIXONS-LOGIK[;,]",
        "device": "tv",
        "model": ""
    },
    "Logitech": {
        "regex": "GR0006(?:[);/ ]|$)",
        "device": "console",
        "model": "G Cloud"
    },
    "Vios": {
        "regex": "(?:VMP0617|VI65PB1401NA|VTAB7)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VMP0617",
                "model": "VMP0617"
            },
            {
                "regex": "VI65PB1401NA",
                "model": "65PB1"
            },
            {
                "regex": "VTAB7",
                "device": "tablet",
                "model": "VTAB7"
            }
        ]
    },
    "Vestel": {
        "regex": "Vestel[ _,/\\-]|Venus[ _](GO|E[2-5]|V[1-9]|Z[1-9]0)|(?<!Winnovo )V_?TAB|VP74|VT97PRO|VSP145M|VSP250[GS]|VSP355[GS]|V3_5580_Dual|V TAB Z[12]",
        "device": "smartphone",
        "models": [
            {
                "regex": "VT97PRO",
                "model": "VTab 9.7 Pro",
                "device": "tablet"
            },
            {
                "regex": "VP74",
                "model": "VTab Lite II",
                "device": "tablet"
            },
            {
                "regex": "VTAB10",
                "model": "VTab 10",
                "device": "tablet"
            },
            {
                "regex": "V_TAB_7_ECO_III",
                "model": "VTab 7 Eco 3",
                "device": "tablet"
            },
            {
                "regex": "V_TAB_7_LITE_III",
                "model": "VTab 7 Lite 3",
                "device": "tablet"
            },
            {
                "regex": "V_TAB_([0-9]{4}[A-Z]?)",
                "model": "VTab $1",
                "device": "tablet"
            },
            {
                "regex": "V[_ ]TAB[_ ](Z[12])",
                "model": "VTab $1",
                "device": "tablet"
            },
            {
                "regex": "V3_5580_Dual",
                "model": "Venus V3 5580 Dual"
            },
            {
                "regex": "VSP145M",
                "model": "Venus 4.5"
            },
            {
                "regex": "VSP250G",
                "model": "Venus 5.0V"
            },
            {
                "regex": "VSP250S",
                "model": "Venus 5.0X"
            },
            {
                "regex": "VSP355G",
                "model": "Venus 5.5V"
            },
            {
                "regex": "VSP355S",
                "model": "Venus 5.5X"
            },
            {
                "regex": "Venus[ _]V([1-9])([ _][0-9]{4})?",
                "model": "Venus V$1$2"
            },
            {
                "regex": "Venus[ _]Z([1-9]0)",
                "model": "Venus Z$1"
            },
            {
                "regex": "Venus[ _]GO",
                "model": "Venus Go"
            },
            {
                "regex": "Venus E2 Plus Dual",
                "model": "Venus E2 Plus Dual"
            },
            {
                "regex": "Venus[ _]E2 Plus",
                "model": "Venus E2 Plus"
            },
            {
                "regex": "Venus[ _]E([345])",
                "model": "Venus E$1"
            },
            {
                "regex": "Vestel_5000_Dual",
                "model": "5000 Dual"
            },
            {
                "regex": "Vestel_5000_2gb",
                "model": "5000 2GB"
            },
            {
                "regex": "Vestel[ _]5530[ _]Dual",
                "model": "5530 Dual"
            },
            {
                "regex": "Vestel[ _](5000|5530)",
                "model": "$1"
            },
            {
                "regex": "VESTEL\\-v\\.tv\\.([0-9]{4})",
                "device": "tv",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "VESTEL, ([a-z0-9_ -]+), (?:wired|wireless)|\\+CE-HTML",
                "device": "tv",
                "model": ""
            }
        ]
    },
    "Videocon": {
        "regex": "Videocon[_ -]|(?:VT75C|V50DC|V406018|V512930|V50(?:2430|3630|4730|5024|5430|4630|5[98]20)|Z45_(?:Dazzle|Amaze)|Z45Q Star|Z50 Nova)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Videocon_V1585",
                "device": "feature phone",
                "model": "V1585"
            },
            {
                "regex": "Videocon[_ -]([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "VT75C(?:[);/ ]|$)",
                "model": "VT75C",
                "device": "tablet"
            },
            {
                "regex": "V502430(?:[);/ ]|$)",
                "model": "Kryton 3"
            },
            {
                "regex": "V50DC(?:[);/ ]|$)",
                "model": "Kryton"
            },
            {
                "regex": "V505024(?:[);/ ]|$)",
                "model": "Kryton 22 Plus"
            },
            {
                "regex": "V503630(?:[);/ ]|$)",
                "model": "Delite 11"
            },
            {
                "regex": "V504730(?:[);/ ]|$)",
                "model": "Delite 21"
            },
            {
                "regex": "V505920(?:[);/ ]|$)",
                "model": "Metal Pro 2"
            },
            {
                "regex": "V505820(?:[);/ ]|$)",
                "model": "Metal Pro 1"
            },
            {
                "regex": "V406018(?:[);/ ]|$)",
                "model": "Starr 100"
            },
            {
                "regex": "V512930(?:[);/ ]|$)",
                "model": "Ultra 50"
            },
            {
                "regex": "(V505430|V504630)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Z45_(Dazzle|Amaze)(?:[);/ ]|$)",
                "model": "Infinium Z45 $1"
            },
            {
                "regex": "Z45Q Star(?:[);/ ]|$)",
                "model": "Infinium Z45Q Star"
            },
            {
                "regex": "Z50 Nova(?:[);/ ]|$)",
                "model": "Infinium Z50 Nova"
            }
        ]
    },
    "Vodafone": {
        "regex": "(?<!FBCR/)Vodafone[ _-]|VodafoneSmartChat|Smart Ultra 6|Smart ?Tab ?(?:III? ?)?(?:4G|7|10)(?! e-Biz| M1)[;/ )-]|(?:GigaTV|VFD[ _][0-9]+|VFD[37]20|VF6[89]5|VF-(696|1397|795|895N|1497)|SmartV22)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VFD 100",
                "model": "Smart Mini"
            },
            {
                "regex": "Vodafone Pro 4G",
                "model": "Pro 4G"
            },
            {
                "regex": "VFD720",
                "model": "Smart N9"
            },
            {
                "regex": "VF685",
                "model": "Smart Kicka"
            },
            {
                "regex": "VF695",
                "model": "Smart First 6"
            },
            {
                "regex": "VFD 200",
                "model": "Smart First 7"
            },
            {
                "regex": "VFD 300",
                "model": "Smart Mini 7"
            },
            {
                "regex": "VFD 301",
                "model": "Smart Mini 7 Dual"
            },
            {
                "regex": "VFD 50[012]",
                "model": "Smart Turbo 7"
            },
            {
                "regex": "VFD 51[0123]",
                "model": "Smart E8"
            },
            {
                "regex": "VFD 52[789]",
                "model": "Smart E9"
            },
            {
                "regex": "VFD 822",
                "model": "Smart X9"
            },
            {
                "regex": "VFD 600",
                "model": "Smart Prime 7"
            },
            {
                "regex": "VFD320",
                "model": "Smart C9"
            },
            {
                "regex": "VFD 820",
                "model": "Smart X9"
            },
            {
                "regex": "VFD 610",
                "model": "Smart N8"
            },
            {
                "regex": "VFD 630",
                "model": "Smart N10"
            },
            {
                "regex": "VFD 620",
                "model": "Smart N9 Lite"
            },
            {
                "regex": "Smart ultra 6",
                "model": "Smart Ultra 6"
            },
            {
                "regex": "VFD 700",
                "model": "Smart Ultra 7"
            },
            {
                "regex": "VFD 710",
                "model": "Smart V8"
            },
            {
                "regex": "VFD 720",
                "model": "Smart N9"
            },
            {
                "regex": "VFD 730",
                "model": "Smart V10"
            },
            {
                "regex": "SmartV22",
                "model": "Smart V22"
            },
            {
                "regex": "VFD 900",
                "model": "Smart Platinum 7"
            },
            {
                "regex": "Vodafone[ _]875(?:[);/ ]|$)",
                "model": "Smart Mini"
            },
            {
                "regex": "Vodafone[ _]975N?(?:[);/ ]|$)",
                "model": "Smart 3"
            },
            {
                "regex": "Vodafone[ _]785(?:[);/ ]|$)",
                "model": "Smart 4 Mini"
            },
            {
                "regex": "VFD 525(?:[);/ ]|$)",
                "model": "Smart 4G"
            },
            {
                "regex": "Vodafone[ _]890N(?:[);/ ]|$)",
                "model": "Smart 4 Turbo"
            },
            {
                "regex": "Vodafone[ _]985N(?:[);/ ]|$)",
                "model": "Smart 4 Power"
            },
            {
                "regex": "VodafoneSmartChat",
                "model": "Smart Chat"
            },
            {
                "regex": "VF-696",
                "model": "Smart Grand 6"
            },
            {
                "regex": "VF-795",
                "model": "Smart Speed 6"
            },
            {
                "regex": "VF-895N",
                "model": "Smart Prime 6"
            },
            {
                "regex": "VF-1397",
                "model": "Tab Speed 6",
                "device": "tablet"
            },
            {
                "regex": "VF-1497",
                "model": "Tab Prime 6",
                "device": "tablet"
            },
            {
                "regex": "VFD 1100",
                "device": "tablet",
                "model": "Tab Mini 7"
            },
            {
                "regex": "VFD 1300",
                "device": "tablet",
                "model": "Smart Tab N8"
            },
            {
                "regex": "VFD 1400",
                "device": "tablet",
                "model": "Tab Prime 7"
            },
            {
                "regex": "Smart ?Tab ?3G",
                "device": "tablet",
                "model": "Smart Tab 3G"
            },
            {
                "regex": "Smart ?Tab ?4G",
                "device": "tablet",
                "model": "Smart Tab 4G"
            },
            {
                "regex": "Smart ?Tab ?4",
                "model": "Smart Tab 4",
                "device": "tablet"
            },
            {
                "regex": "SmartTab7[);/ -]",
                "model": "Smart Tab 7",
                "device": "tablet"
            },
            {
                "regex": "SmartTab10[);/ -]",
                "model": "Smart Tab 10",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?II ?7",
                "model": "Smart Tab II 7",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?II ?10",
                "model": "Smart Tab II 10",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?III ?7",
                "model": "Smart Tab III 7",
                "device": "tablet"
            },
            {
                "regex": "Smart ?Tab ?III ?10",
                "model": "Smart Tab III 10",
                "device": "tablet"
            },
            {
                "regex": "Vodafone TV(?:[);/ ]|$)",
                "model": "TV",
                "device": "tv"
            },
            {
                "regex": "GigaTV",
                "model": "Giga TV",
                "device": "tv"
            },
            {
                "regex": "VFD[ _]([0-9]+)(?:[);/ ]|$)",
                "model": "VFD $1"
            },
            {
                "regex": "Vodafone[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Vodafone[ _-]([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Surge": {
        "regex": "VOLT_(5XL)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Volt $1"
    },
    "Volt": {
        "regex": "VOLT[_ ](SV451[_ ]Vision)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vonino": {
        "regex": "Vonino|Epic (?:E8|P7)|Epic_(?:M8|P7)|Gyga[ _](?:X|S|QS|XS)|Jax[ _](?:QS|[SXQN]|Mini)|Magnet[ _](?:M[19]|G[135]0|W10)|Navo_QS|Navo[ _][SP]|Onyx_(QS|Z)|Orin_QS|Pluri[ _](?:[BCMQ]7|[CQM]8)|Sirius_QS|Spirit QS|(?<!Schok )Volt[ _][XS]|Xavy[_ ]([GT]7|L8)|Xylo[ _][XSPQT]|Zun[ _](?:N|X[OS]?)|JAX_N|Druid_L10|iMart_Pro|MusicPAD_[HM]1",
        "device": "smartphone",
        "models": [
            {
                "regex": "Zun[ _](N|X[OS]?)",
                "model": "Zun $1"
            },
            {
                "regex": "Xylo[ _]([PSXQT])",
                "model": "Xylo $1"
            },
            {
                "regex": "Volt[ _]S_A7",
                "model": "Volt S A7"
            },
            {
                "regex": "Volt[ _]S",
                "model": "Volt S"
            },
            {
                "regex": "Volt[ _]X",
                "model": "Volt X"
            },
            {
                "regex": "Gyga[ _]QS",
                "model": "Gyga QS"
            },
            {
                "regex": "Gyga[ _]XS",
                "model": "Gyga XS"
            },
            {
                "regex": "Gyga[ _](S|X)",
                "model": "Gyga $1"
            },
            {
                "regex": "Jax[ _]QS",
                "model": "Jax QS"
            },
            {
                "regex": "Jax[ _]S_A7",
                "model": "Jax S A7"
            },
            {
                "regex": "Jax[ _]([SQXN])",
                "model": "Jax $1"
            },
            {
                "regex": "Jax[ _]Mini",
                "model": "Jax Mini"
            },
            {
                "regex": "iMart_Pro",
                "device": "tablet",
                "model": "IMart Pro"
            },
            {
                "regex": "Epic[_ ]([EM]8|P7)",
                "model": "Epic $1",
                "device": "tablet"
            },
            {
                "regex": "Pluri_M([78])_2020",
                "model": "Pluri M$1 (2020)",
                "device": "tablet"
            },
            {
                "regex": "Pluri[ _]([BCMQ])7",
                "model": "Pluri $17",
                "device": "tablet"
            },
            {
                "regex": "Pluri[ _]([CQM])8",
                "model": "Pluri $18",
                "device": "tablet"
            },
            {
                "regex": "Druid[_ ](L10)",
                "model": "Druid $1",
                "device": "tablet"
            },
            {
                "regex": "Magnet[_ ]M10[_ ]2020",
                "device": "tablet",
                "model": "Magnet M10 (2020)"
            },
            {
                "regex": "Magnet[_ ](G50)[_ ]Pro",
                "device": "tablet",
                "model": "Magnet $1 Pro"
            },
            {
                "regex": "Magnet[ _](M[19]|G[135]0|W10)",
                "model": "Magnet $1",
                "device": "tablet"
            },
            {
                "regex": "Navo[_ ](Q?[SP])",
                "model": "Navo $1",
                "device": "tablet"
            },
            {
                "regex": "Onyx_(QS|Z)",
                "model": "Onyx $1",
                "device": "tablet"
            },
            {
                "regex": "Orin_QS",
                "model": "Orin QS",
                "device": "tablet"
            },
            {
                "regex": "Sirius_QS",
                "model": "Sirius QS",
                "device": "tablet"
            },
            {
                "regex": "Spirit QS",
                "model": "Spirit QS",
                "device": "tablet"
            },
            {
                "regex": "Xavy[_ ]([GT]7|L8)",
                "model": "Xavy $1",
                "device": "tablet"
            },
            {
                "regex": "MusicPAD_([HM]1)",
                "model": "MusicPAD $1",
                "device": "portable media player"
            }
        ]
    },
    "Vorago": {
        "regex": "VORAGO|(?:PAD-7-V5|PAD-7)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CELL-500",
                "model": "CELL-500"
            },
            {
                "regex": "(PAD-7-V5|PAD-7)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Voto": {
        "regex": "VOTO[ _-]|VT8[89]8(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VOTO[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "VOTO[ _-]?([^);/ ]+)",
                "model": "$1"
            },
            {
                "regex": "(VT8[89]8)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Voxtel": {
        "regex": "Voxtel_([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Vulcan": {
        "regex": "(?:VP5004A|VS5513|VS4011|VR6031)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(VP5004A|VR6031)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "VS5513(?:[);/ ]|$)",
                "model": "Tempo S13"
            },
            {
                "regex": "VS4011(?:[);/ ]|$)",
                "model": "Tempo S11"
            }
        ]
    },
    "Ober": {
        "regex": "OBER[_ ](Primo E8)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Walton": {
        "regex": "Walton|Walpad|RX7 Mini|Primo[ _](?:C[1234]?|D[1-689]|E[1-589]|F8s|EF[23]?|EM|F[1-79]i?|G[1-9]|GF[234]?|GH[23]?|GM|H[2-689M]|H10|H7s|N[F1]?|NX2?|R[1-689]|R[HM]2?|RX[23]?|S[1-8]|V1|X[1-4]|Z|[ZV]X)|Orbit M20|Orbit Y(?:2[10]|12|[57]0)|XANON X[29]0|NEXG N(?:7[0-4]|2[56]|[689])|LT750",
        "device": "smartphone",
        "models": [
            {
                "regex": "Walpad[ _]?([^;/)]+)(?: Build|[);])",
                "device": "tablet",
                "model": "Primo Walpad $1"
            },
            {
                "regex": "Primo S6 infinity",
                "model": "Primo S6 Infinity"
            },
            {
                "regex": "Primo S8 mini",
                "model": "Primo S8 Mini"
            },
            {
                "regex": "Primo H8 Pro(?:[);/ ]|$)",
                "model": "Primo H8 Pro"
            },
            {
                "regex": "Primo (RM2|ZX2|NX4|X2) ?mini(?:[);/ ]|$)",
                "model": "Primo $1 Mini"
            },
            {
                "regex": "Primo H8(?:[);/ ]|$)",
                "model": "Primo H8 Turbo"
            },
            {
                "regex": "RX7 Mini(?:[);/ ]|$)",
                "model": "RX7 Mini"
            },
            {
                "regex": "Orbit Y(\\d{2})",
                "model": "Orbit Y$1"
            },
            {
                "regex": "Orbit M(\\d{2})",
                "model": "Orbit M$1"
            },
            {
                "regex": "XANON X20",
                "model": "Xanon X20"
            },
            {
                "regex": "XANON X90",
                "model": "Xanon X90"
            },
            {
                "regex": "NEXG N71 Plus",
                "model": "Nexg N71 Plus"
            },
            {
                "regex": "NEXG N(7[0-4]|2[56]|[689])",
                "model": "Nexg N$1"
            },
            {
                "regex": "(LT750)",
                "model": "$1"
            },
            {
                "regex": "WALTON GSMART 2KTV",
                "device": "tv",
                "model": "2K Smart TV"
            },
            {
                "regex": "Primo[ _]([^;/)]+)[ _]Plus(?: Build|[;)])",
                "model": "Primo $1 Plus"
            },
            {
                "regex": "Primo[ _]([^;/)]+)(?: Build|[;)])",
                "model": "Primo $1"
            },
            {
                "regex": "Walton[ _]([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "WellcoM": {
        "regex": "WELLCOM[ _\\-/]([a-z0-9]+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Wexler": {
        "regex": "Wexler|(?:MOBI 7 LTE|ULTIMA 7 TWIST PLUS|ULTIMA 7|ULTIMA [78] TWIST|TAB10iQ3G|TAB[ _]10Q)(?:[);/ ]|$)|ZEN[ _](?:4\\.[57]|5)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:Wexler[ _.-])?ZEN[ _]4\\.5(?:[);/ ]|$)",
                "model": "ZEN 4.5",
                "device": "smartphone"
            },
            {
                "regex": "(?:Wexler[ _.-])?ZEN[ _]4\\.7(?:[);/ ]|$)",
                "model": "ZEN 4.7",
                "device": "smartphone"
            },
            {
                "regex": "(?:Wexler[ _.-])?ZEN[ _]5(?:[);/ ]|$)",
                "model": "ZEN 5",
                "device": "smartphone"
            },
            {
                "regex": "ZEN[ _]5\\+(?:[);/ ]|$)",
                "model": "ZEN 5 Plus",
                "device": "smartphone"
            },
            {
                "regex": "(?:Wexler[._-])?TAB[ _]?10Q(?:[);/ ]|$)",
                "model": "TAB 10Q"
            },
            {
                "regex": "TAB10iQ3G(?:[);/ ]|$)",
                "model": "TAB 10iQ 3G"
            },
            {
                "regex": "Wexler[ _.-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Wexler[ _.-]([^);/]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(ULTIMA 7 TWIST PLUS|ULTIMA [78] TWIST|ULTIMA 7 OCTA|ULTIMA 7|MOBI 7 LTE)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Inco": {
        "regex": "(?:Inco[ _](Aurora II|Colors|Sphere|Plain[_ ]2S?|Plain2 S|Flex(?: 2S)?|S4|Bloom(?: 2)?)|(Horizon_S|Horizon \\+|MATTER)|Bloom4|eco_s|Flex-3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Bloom ?4",
                "model": "Bloom 4"
            },
            {
                "regex": "(?:Inco[ _])?(Plain[_ ]2S?|Colors|Horizon_S|Horizon \\+|Aurora II|Flex(?: 2S)?|S4|Bloom(?: 2)?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Plain2 S",
                "model": "Plain 2S"
            },
            {
                "regex": "MATTER",
                "model": "Matter"
            },
            {
                "regex": "eco_s",
                "model": "Eco S"
            },
            {
                "regex": "Flex-(3)",
                "model": "Flex $1"
            },
            {
                "regex": "Inco Sphere( 3)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Sphere$1"
            }
        ]
    },
    "Inka": {
        "regex": "X96mini(?:[);/ ]|$)",
        "device": "tv",
        "model": "X96 mini"
    },
    "Wink": {
        "regex": "(?<!mismart )Wink[_ ]|SWITRON-i12A|WinkBox (?:[23]|Mini)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SWITRON-i12A",
                "device": "tv",
                "model": "Switron i12A"
            },
            {
                "regex": "WinkBox ([23])",
                "device": "tv",
                "model": "Box $1"
            },
            {
                "regex": "WinkBox Mini",
                "device": "tv",
                "model": "Box Mini"
            },
            {
                "regex": "Wink[_ ]((?:Glory|World|Share|City)(?:[_ ](?:SE|S))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Wink[ _](Primo|Highway)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Smart": {
        "regex": "(?:Coral 4|Slide Lite|Notrino|Smart PRIME II)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Smart PRIME II",
                "model": "Prime II"
            },
            {
                "regex": "(Coral 4|Slide Lite|Notrino|Smart PRIME II)",
                "model": "$1"
            }
        ]
    },
    "Wiko": {
        "regex": "(?:WIKO[_ -])|(?:WIKO-)?CINK_[a-z0-9_]+|(?:WIKO-)?HIGHWAY_[a-z0-9_]+|(?:WIKO-)?(?:Cink([^/;]*)|Highway([^/;]*)|Iggy|Stairway|Rainbow ?(Jam|Lite|Up)?|Darkside|Darkmoon|Darkfull|Darknight|Freddy|FEVER|Jerry[2]?|Sublim|Ozzy|JIMMY|Barry|Birdy|Bloom(?!4)|Getaway|Goa(?!nna|lPlus|-)|Kite|Robby|Lenny[2-9]?|(?<!iBall[_ ])Slide2?|Sunset[2-9]?|Sunny[2-9]?|Tommy[2-9]?|PULP(?: Fab)?|Wax|HARRY|Ridge(?! Plus)(?: Fab)?|U FEEL(?: Prime| Lite)?|U PULSE(?: LITE)?|View2 (?:Go|Plus)|View XL|View Prime)(?: Plus)?(?: 4G)?(?: Build|$)?|W_(?:C8[06]0|K[346]00|P130|P200|C200SN)|WC300|W-(?:V7[23]0|V745|V755|V8[035]0|P[36]11|K130|K211|K3[68]0|K420|K510S?|K521|K560|K610|K630)-(?:BYT|EEA|FRA|OPE|SU[IN]|SWI|TIM|TRU|TMV|TVM|DU|T[HV]|ID)|WIM Lite|W-V851|W-V6[08]0|W-V750BN|W-V770|W-K200|W-U300|(?:U307AS|CINK PEAX 2|HIGHWAY PURE|C210AE|v3913|U614AS|V3991AN|v12fnlite|K-KOOL|p6901|U616AT|VHEM|KENNY|View Go| WIM|SHR-AN00|JLG-AN00|Aix-AN00|BAL-AN20|MKY-AN20|GAR-AN[06]0)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SHR-AN00",
                "model": "Hi Enjoy 80 Pro 5G"
            },
            {
                "regex": "JLG-AN00",
                "model": "Hi Enjoy 80S 5G"
            },
            {
                "regex": "GAR-AN60",
                "model": "Hi Enjoy 60s 5G"
            },
            {
                "regex": "GAR-AN00",
                "model": "Hi Enjoy 60 5G"
            },
            {
                "regex": "BAL-AN20",
                "model": "Hi Enjoy 70 Pro 5G"
            },
            {
                "regex": "Aix-AN00",
                "model": "T20"
            },
            {
                "regex": "MKY-AN20",
                "model": "Hi Enjoy 70M 5G"
            },
            {
                "regex": "(?:WIKO-)?W-V770",
                "model": "T3"
            },
            {
                "regex": "(?:WIKO-)?VHEM",
                "model": "10"
            },
            {
                "regex": "(?:WIKO-)?U616AT",
                "model": "Voix"
            },
            {
                "regex": "(?:WIKO-)?W-V745",
                "model": "Power U10"
            },
            {
                "regex": "(?:WIKO-)?W-V750",
                "model": "Power U20"
            },
            {
                "regex": "(?:WIKO-)?W-V755-EEA",
                "model": "Power U30"
            },
            {
                "regex": "(?:WIKO-)?Cink Peax 2",
                "model": "Cink Peax 2"
            },
            {
                "regex": "(?:Wiko-)?Cink([^/;]*) Build",
                "model": "Cink$1"
            },
            {
                "regex": "(?:WIKO-)?CINK_([a-z0-9_]+)",
                "model": "Cink $1"
            },
            {
                "regex": "(?:WIKO-)?HIGHWAY PURE",
                "model": "Highway Pure"
            },
            {
                "regex": "(?:WIKO-)?HIGHWAY STAR",
                "model": "Highway Star"
            },
            {
                "regex": "(?:Wiko-)?Highway([^/;]*) Build",
                "model": "Highway$1"
            },
            {
                "regex": "(?:WIKO-)?HIGHWAY_([a-z0-9_]+)",
                "model": "Highway $1"
            },
            {
                "regex": "(?:WIKO-)?Iggy",
                "model": "Iggy"
            },
            {
                "regex": "(?:WIKO-)?FEVER",
                "model": "Fever"
            },
            {
                "regex": "(?:WIKO-)?Stairway",
                "model": "Stairway"
            },
            {
                "regex": "(?:WIKO-)?Ridge Fab 4G",
                "model": "Ridge Fab 4G"
            },
            {
                "regex": "(?:WIKO-)?Ridge 4G",
                "model": "Ridge 4G"
            },
            {
                "regex": "(?:WIKO-)?Ridge",
                "model": "Ridge"
            },
            {
                "regex": "RAINBOW LITE",
                "model": "Rainbow Lite"
            },
            {
                "regex": "(?:WIKO-)?Rainbow ([^/;]+) Build",
                "model": "Rainbow $1"
            },
            {
                "regex": "(?:WIKO-)?Rainbow",
                "model": "Rainbow"
            },
            {
                "regex": "(?:WIKO-)?Darkside",
                "model": "Darkside"
            },
            {
                "regex": "(?:WIKO-)?Darkmoon",
                "model": "Darkmoon"
            },
            {
                "regex": "(?:WIKO-)?Darkfull",
                "model": "Darkfull"
            },
            {
                "regex": "(?:WIKO-)?Darknight",
                "model": "Darknight"
            },
            {
                "regex": "(?:WIKO-)?Sublim",
                "model": "Sublim"
            },
            {
                "regex": "(?:WIKO-)?Ozzy",
                "model": "Ozzy"
            },
            {
                "regex": "(?:WIKO-)?Barry",
                "model": "Barry"
            },
            {
                "regex": "(?:WIKO-)?Birdy",
                "model": "Birdy"
            },
            {
                "regex": "(?:WIKO-)?Bloom2",
                "model": "Bloom 2"
            },
            {
                "regex": "(?:WIKO-)?Bloom",
                "model": "Bloom"
            },
            {
                "regex": "(?:WIKO-)?JIMMY",
                "model": "Jimmy"
            },
            {
                "regex": "JERRY MAX",
                "model": "Jerry Max"
            },
            {
                "regex": "W_K300",
                "model": "Jerry 3"
            },
            {
                "regex": "W-K420-TVM",
                "model": "Jerry 4"
            },
            {
                "regex": "(?:WIKO-)?Jerry2",
                "model": "Jerry 2"
            },
            {
                "regex": "(?:WIKO-)?Jerry",
                "model": "Jerry"
            },
            {
                "regex": "(?:WIKO-)?Getaway",
                "model": "Getaway"
            },
            {
                "regex": "(?:WIKO-)?KENNY",
                "model": "Kenny"
            },
            {
                "regex": "(?:WIKO-)?Goa(?!nna)",
                "model": "Goa"
            },
            {
                "regex": "(?:WIKO-)?Freddy",
                "model": "Freddy"
            },
            {
                "regex": "(?:WIKO-)?Kite",
                "model": "Kite"
            },
            {
                "regex": "W_K400",
                "model": "Lenny 5"
            },
            {
                "regex": "C210AE(?:[);/ ]|$)",
                "model": "Life"
            },
            {
                "regex": "U307AS(?:[);/ ]|$)",
                "model": "Life 2"
            },
            {
                "regex": "U316AT(?:[);/ ]|$)",
                "model": "Life 3"
            },
            {
                "regex": "v3913(?:[);/ ]|$)",
                "model": "Kenny"
            },
            {
                "regex": "(?:WIKO-)?Lenny[ -_]?3 Max",
                "model": "Lenny 3 Max"
            },
            {
                "regex": "(?:WIKO-)?Lenny[ -_]?4 Plus",
                "model": "Lenny 4 Plus"
            },
            {
                "regex": "(?:WIKO-)?Lenny[ -_]?([2-9])",
                "model": "Lenny $1"
            },
            {
                "regex": "(?:WIKO-)?Lenny",
                "model": "Lenny"
            },
            {
                "regex": "(?:WIKO-)?Slide2",
                "model": "Slide 2"
            },
            {
                "regex": "(?:WIKO-)?Slide",
                "model": "Slide"
            },
            {
                "regex": "(?:WIKO-)?Sunset2",
                "model": "Sunset 2"
            },
            {
                "regex": "(?:WIKO-)?Sunset",
                "model": "Sunset"
            },
            {
                "regex": "(?:WIKO-)?Sunny3 Mini",
                "model": "Sunny 3 Mini"
            },
            {
                "regex": "(?:WIKO-)?Sunny3",
                "model": "Sunny 3"
            },
            {
                "regex": "W-K200",
                "model": "Sunny 3 Plus"
            },
            {
                "regex": "(?:WIKO-)?Sunny2 Plus",
                "model": "Sunny 2 Plus"
            },
            {
                "regex": "(?:WIKO-)?Sunny2",
                "model": "Sunny 2"
            },
            {
                "regex": "W-K360-TV",
                "model": "Sunny 4 Plus"
            },
            {
                "regex": "W-K130-TMV",
                "model": "Sunny 4"
            },
            {
                "regex": "W-K380-TVM",
                "model": "Sunny 5"
            },
            {
                "regex": "W-K211-(?:TH|TVM)",
                "model": "Sunny 5 Lite"
            },
            {
                "regex": "(?:WIKO-)?Sunny",
                "model": "Sunny"
            },
            {
                "regex": "(?:W_K600|Tommy3|W_C200SN)",
                "model": "Tommy 3"
            },
            {
                "regex": "(?:WIKO-)?Tommy2 Plus",
                "model": "Tommy 2 Plus"
            },
            {
                "regex": "(?:WIKO-)?Tommy2",
                "model": "Tommy 2"
            },
            {
                "regex": "(?:WIKO-)?Tommy",
                "model": "Tommy"
            },
            {
                "regex": "(?:WIKO-)?Wax",
                "model": "Wax"
            },
            {
                "regex": "(?:WIKO-)?HARRY",
                "model": "Harry"
            },
            {
                "regex": "W-V600",
                "model": "Harry 2"
            },
            {
                "regex": "(?:WIKO-)?WIM Lite|p6901",
                "model": "WIM Lite"
            },
            {
                "regex": "(?:WIKO-)?WIM",
                "model": "WIM"
            },
            {
                "regex": "(?:WIKO-)?Pulp Fab 4G",
                "model": "Pulp Fab 4G"
            },
            {
                "regex": "(?:WIKO-)?Pulp Fab",
                "model": "Pulp Fab"
            },
            {
                "regex": "(?:WIKO-)?Pulp 4G",
                "model": "Pulp 4G"
            },
            {
                "regex": "(?:WIKO-)?Pulp",
                "model": "Pulp"
            },
            {
                "regex": "(?:WIKO-)?Robby(2)?",
                "model": "Robby$1"
            },
            {
                "regex": "(?:WIKO-)?U PULSE LITE",
                "model": "U Pulse Lite"
            },
            {
                "regex": "(?:WIKO-)?U PULSE",
                "model": "U Pulse"
            },
            {
                "regex": "(?:WIKO-)?U FEEL LITE",
                "model": "U Feel Lite"
            },
            {
                "regex": "(?:WIKO-)?U FEEL PRIME",
                "model": "U Feel Prime"
            },
            {
                "regex": "(?:WIKO-)?U FEEL",
                "model": "U Feel"
            },
            {
                "regex": "V3991AN",
                "model": "U Feel Fab"
            },
            {
                "regex": "(?:WIKO-)?View2 Go",
                "model": "View 2 Go"
            },
            {
                "regex": "(?:WIKO-)?View2 Plus",
                "model": "View 2 Plus"
            },
            {
                "regex": "(?:WIKO-)?View XL",
                "model": "View XL"
            },
            {
                "regex": "(?:WIKO-)?View Prime",
                "model": "View Prime"
            },
            {
                "regex": "WC300",
                "model": "View Lite"
            },
            {
                "regex": "v12fnlite",
                "model": "View"
            },
            {
                "regex": "W_C800",
                "model": "View 2"
            },
            {
                "regex": "W_C860",
                "model": "View 2 Pro"
            },
            {
                "regex": "W_P200",
                "model": "View Max"
            },
            {
                "regex": "W_P130|View Go",
                "model": "View Go"
            },
            {
                "regex": "W-V800-(TVM|TIM|EEA|OPE|DU)",
                "model": "View 3 Lite"
            },
            {
                "regex": "W-V851",
                "model": "View 5"
            },
            {
                "regex": "W-V850-EEA",
                "model": "View 5 Plus"
            },
            {
                "regex": "W-K130-(?:OPE|EEA|BYT)",
                "model": "Y50"
            },
            {
                "regex": "W-K420-EEA",
                "model": "Y50"
            },
            {
                "regex": "W-K211",
                "model": "Y51"
            },
            {
                "regex": "W-K521",
                "model": "Y52"
            },
            {
                "regex": "W-K510-(?:TVM|EEA|OPE|SUN|BYT|TH)|W-K510S-SWI",
                "model": "Y60"
            },
            {
                "regex": "W-K560-(?:EEA|TVM)",
                "model": "Y61"
            },
            {
                "regex": "W-K610-(?:SUI|FRA)",
                "model": "Y62 Plus"
            },
            {
                "regex": "W-K610",
                "model": "Y62"
            },
            {
                "regex": "W-V720-(?:EEA|OPE|SUN)",
                "model": "Y80"
            },
            {
                "regex": "W-V680",
                "model": "Y81"
            },
            {
                "regex": "W-K630",
                "model": "Y82"
            },
            {
                "regex": "W-P311-(?:EEA|OPE|TVM)",
                "model": "View 3"
            },
            {
                "regex": "W-P611-(?:EEA|OPE)",
                "model": "View 3 Pro"
            },
            {
                "regex": "W-V830-(?:EEA|OPE|ID)",
                "model": "View 4"
            },
            {
                "regex": "W-V730-(?:EEA|TVM|ID|OPE)",
                "model": "View 4 Lite"
            },
            {
                "regex": "W-V745-TVM",
                "model": "Power U10"
            },
            {
                "regex": "W-U300(?:[);/ ]|$)",
                "model": "Ride"
            },
            {
                "regex": "U520AS(?:[);/ ]|$)",
                "model": "Ride 2"
            },
            {
                "regex": "U614AS(?:[);/ ]|$)",
                "model": "Ride 3"
            },
            {
                "regex": "K-KOOL(?:[);/ ]|$)",
                "model": "K-Kool"
            },
            {
                "regex": "Wiko ([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Wieppo": {
        "regex": "Wieppo (S6 Lite|S[658]|E1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Weiimi": {
        "regex": "(?:20200808A1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "20200808A1",
                "model": "X16 Pro"
            }
        ]
    },
    "Weimei": {
        "regex": "weplus_3|WEIMEI_NEON2",
        "device": "smartphone",
        "models": [
            {
                "regex": "weplus_3",
                "model": "WePlus 3"
            },
            {
                "regex": "WEIMEI_NEON2",
                "model": "Neon 2"
            }
        ]
    },
    "Wileyfox": {
        "regex": "Wileyfox|(?:Swift 2|crackling)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Wileyfox Spark \\+",
                "model": "Spark +"
            },
            {
                "regex": "Wileyfox; Pro",
                "model": "Pro"
            },
            {
                "regex": "Wileyfox Spark X",
                "model": "Spark X"
            },
            {
                "regex": "Swift 2 (X|Plus)(?:[);/ ]|$)",
                "model": "Swift 2 $1"
            },
            {
                "regex": "Swift 2(?:[);/ ]|$)",
                "model": "Swift 2"
            },
            {
                "regex": "crackling",
                "model": "Swift"
            },
            {
                "regex": "Wileyfox (Spark|Swift)",
                "model": "$1"
            },
            {
                "regex": "Wileyfox ([^/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Wolder": {
        "regex": "miSmart|miTab|WIAM[ _]\\#?\\d+|WOLDER",
        "device": "smartphone",
        "models": [
            {
                "regex": "WIAM[_ ]\\#?65[_ ]lite",
                "model": "Wiam #65 Lite"
            },
            {
                "regex": "(?:WOLDER_)?WIAM[ _]\\#?(\\d+)",
                "model": "Wiam #$1"
            },
            {
                "regex": "WOLDER[_ ](\\d+)",
                "model": "Wiam #$1"
            },
            {
                "regex": "miSmart[ \\-_]?([^/]+) Build",
                "model": "miSmart $1"
            },
            {
                "regex": "miTab[_ ]PRO[_ ]10[_ ]plus",
                "device": "tablet",
                "model": "miTab PRO 10 PLUS"
            },
            {
                "regex": "miTab[ \\-_]?([^/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "miTab $1"
            }
        ]
    },
    "Wolfgang": {
        "regex": "AT[ _-]AS([0-9A-Z]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "AT-AS$1"
    },
    "Wolki": {
        "regex": "(?:W55SE|W626 LITE|WS054|WS067|WS5SE|WS626)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "WS054",
                "model": "W5.5 Lite"
            },
            {
                "regex": "W55SE",
                "model": "W5.5 SE"
            },
            {
                "regex": "WS626",
                "model": "W6.26"
            },
            {
                "regex": "W626 LITE",
                "model": "W6.26 Lite"
            },
            {
                "regex": "WS5SE",
                "model": "W5 SE"
            },
            {
                "regex": "WS067",
                "model": "W6 Pro"
            }
        ]
    },
    "Wonu": {
        "regex": "Wonu ([a-z0-9]+)",
        "device": "feature phone",
        "model": "$1"
    },
    "Woo": {
        "regex": "SP5026i-Scorpio|SP5040-Casiopea",
        "device": "smartphone",
        "models": [
            {
                "regex": "SP5026i-Scorpio",
                "model": "Scorpio"
            },
            {
                "regex": "SP5040-Casiopea",
                "model": "Casiopea II"
            }
        ]
    },
    "Woxter": {
        "regex": "Woxter[ _]|Nimbus 101Q",
        "device": "tablet",
        "models": [
            {
                "regex": "Nimbus ?(101Q|115|1100RX)(?:[);/ ]|$)",
                "model": "Nimbus $1"
            },
            {
                "regex": "WOXTER[ _]I-101(?:[);/ ]|$)",
                "model": "i-101"
            },
            {
                "regex": "Woxter[ _]([SQ]X) ?([0-9A-Z]+)(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "Woxter[_ ](?:Zielo[ _])?(Q27|Z800|Z420)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Zielo $1"
            },
            {
                "regex": "Woxter[ _]([^/;)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "X-View": {
        "regex": "X-View|(?:ZEN_U5\\+|AMBER_KIDS|Proton_(?:Amber_HD|Neon|JADE_2_PRO)|TitaniumGTColorsGO|FTB13)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZEN_U5\\+",
                "model": "ZEN U5+"
            },
            {
                "regex": "AMBER_KIDS",
                "device": "tablet",
                "model": "Amber Kids"
            },
            {
                "regex": "Proton_Amber_HD",
                "device": "tablet",
                "model": "Proton Amber HD"
            },
            {
                "regex": "Proton_Neon",
                "device": "tablet",
                "model": "Proton Neon"
            },
            {
                "regex": "PROTON_JADE_2_PRO",
                "device": "tablet",
                "model": "Proton Jade 2 Pro"
            },
            {
                "regex": "X-ViewTablet",
                "device": "tablet",
                "model": ""
            },
            {
                "regex": "TitaniumGTColorsGO",
                "device": "tablet",
                "model": "Titanium GT Colors GO"
            },
            {
                "regex": "(FTB13)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "POCO": {
        "regex": "(?:POCO[ _](?:X[2-7](?:_SN)?|F[267] PRO|M[2-7]|M5s|F[3567]|F4(?: GT)?|C40|C3|C[567]1|C[678]5)|M2010J19(?:C[GI]|GC)|M2007J20C[ITG]|M2012K11AG|M2006C3MI|M2004J19PI|M2102J20S[GI]|M2103K19P[IGY]|21091116AG|21061110AG|M2104K10I|211033MI|220111[67]P[GI]|camellian?|21121210G|2203(?:1116AI|33QPG)|22021211R[GI]|2204121(?:6U?G|9P[GI])|2207(?:1219C[GI]|33SP[IH]|117BPG)|22101320[GI]|22111317P[GI]|23013PC75G|2302EPCC4[HI]|23049PCD8[GI]|2305EPCC4G|22127PC95I|2310FPCA4[GI]|MZB0(?:GGWIN|E6DIN|7Z[0-4]IN)|23076PC4BI|2312(?:FRAFDI|BPC51[HX]|FPCA6G|2PCD1[GI]|8PC33I)|2311(?:3RKC6G|DRK48[GI])|2406(?:9PC21[GI]|6PC95I)|2404APC5FG|2405CPCFBG|2409(?:5PCAD[GI]|FPCC4[GI])|2410(?:FPCC5G|8PCE2I)|MZB9965IN|MZB874[13456]IN|M2004J11G|MZB0A0MIN|2412(?:DPC0A[GI](?:-art)?|2RKC7G)|24117RK2CG|25028PC03[GI]|25053PC47G|25078PC3EG|25062PC34[GE])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:POCO X2|MZB874[13456]IN)(?:[);/ ]|$)",
                "model": "X2"
            },
            {
                "regex": "23113RKC6G|POCO F6 Pro(?:[);/ ]|$)",
                "model": "F6 Pro"
            },
            {
                "regex": "24069PC21[GI]|POCO F6(?:[);/ ]|$)",
                "model": "F6"
            },
            {
                "regex": "2311DRK48[GI]|POCO X6 Pro 5G(?: Build|[;)])",
                "model": "X6 Pro 5G"
            },
            {
                "regex": "23122PCD1[GI]|POCO X6 5G(?: Build|[;)])",
                "model": "X6 5G"
            },
            {
                "regex": "2312FRAFDI|MZB0GGWIN",
                "model": "X6 Neo"
            },
            {
                "regex": "2412DPC0A[GI]|POCO X7 Pro",
                "model": "X7 Pro"
            },
            {
                "regex": "24095PCAD[GI]|POCO X7",
                "model": "X7"
            },
            {
                "regex": "(?:M2012K11AG|POCO F3)(?:[);/ ]|$)",
                "model": "F3"
            },
            {
                "regex": "23013PC75G|POCO F5 Pro",
                "model": "F5 Pro"
            },
            {
                "regex": "23049PCD8[GI]|POCO F5",
                "model": "F5"
            },
            {
                "regex": "M2004J19PI(?:[);/ ]|$)",
                "model": "M2"
            },
            {
                "regex": "(?:M2103K19P[IGY]|M3 Pro 5G|camellian?)(?:[);/ ]|$)",
                "model": "M3 Pro 5G"
            },
            {
                "regex": "POCO M([23]) Pro(?:[);/ ]|$)",
                "model": "M$1 Pro"
            },
            {
                "regex": "21091116AG|M4 Pro 5G",
                "model": "M4 Pro 5G"
            },
            {
                "regex": "22041219P[IG]|POCO M4 5G(?: Build|[;)])",
                "model": "M4 5G"
            },
            {
                "regex": "22071219C[IG]|POCO M5(?: Build|[;)])",
                "model": "M5"
            },
            {
                "regex": "2207117BPG|POCO M5s",
                "model": "M5s"
            },
            {
                "regex": "23128PC33I",
                "model": "M6 5G"
            },
            {
                "regex": "2404APC5FG|POCO M6(?: Build|[;)])",
                "model": "M6"
            },
            {
                "regex": "2409FPCC4[GI]|POCO M7 Pro 5G",
                "model": "M7 Pro 5G"
            },
            {
                "regex": "24108PCE2I",
                "model": "M7 5G"
            },
            {
                "regex": "25062PC34[GE]|POCO M7",
                "model": "M7"
            },
            {
                "regex": "23076PC4BI",
                "model": "M6 Pro 5G"
            },
            {
                "regex": "24066PC95I",
                "model": "M6 Plus 5G"
            },
            {
                "regex": "2312FPCA6G|POCO M6 Pro(?: Build|[;)])",
                "model": "M6 Pro"
            },
            {
                "regex": "2201117P[GI]|POCO M4 Pro",
                "model": "M4 Pro"
            },
            {
                "regex": "(?:M2010J19C[GI]|POCO M3)(?:[);/ ]|$)",
                "model": "M3"
            },
            {
                "regex": "M2010J19GC",
                "model": "M3 SE"
            },
            {
                "regex": "(?:M2007J20C[GT]|POCO X3 NFC)(?:[);/ ]|$)",
                "model": "X3 NFC"
            },
            {
                "regex": "(?:M2102J20S[GI]|POCO X3 Pro)(?:[);/ ]|$)",
                "model": "X3 Pro"
            },
            {
                "regex": "(?:21061110AG|POCO X3 GT)(?:[);/ ]|$)",
                "model": "X3 GT"
            },
            {
                "regex": "(?:M2007J20CI|MZB9965IN|POCO X3(?:_SN)?|MZB07Z[0-4]IN)(?:[);/ ]|$)",
                "model": "X3"
            },
            {
                "regex": "(?:22111317P[GI]|POCO X5 5G)(?:[);/ ]|$)",
                "model": "X5 5G"
            },
            {
                "regex": "(?:22041216UG|POCO X4 GT Pro)(?:[);/ ]|$)",
                "model": "X4 GT Pro"
            },
            {
                "regex": "(?:22041216G|POCO X4 GT)(?:[);/ ]|$)",
                "model": "X4 GT"
            },
            {
                "regex": "(?:22101320[GI]|POCO X5 Pro 5G)(?:[);/ ]|$)",
                "model": "X5 Pro 5G"
            },
            {
                "regex": "2201116P[GI]|POCO X4 Pro 5G",
                "model": "X4 Pro 5G"
            },
            {
                "regex": "(?:M2104K10I)(?:[);/ ]|$)",
                "model": "F3 GT"
            },
            {
                "regex": "(?:21121210G|POCO F4 GT)(?:[);/ ]|$)",
                "model": "F4 GT"
            },
            {
                "regex": "22021211R[GI]|POCO F4",
                "model": "F4"
            },
            {
                "regex": "24117RK2CG|POCO F7 Pro",
                "model": "F7 Pro"
            },
            {
                "regex": "24122RKC7G|Poco F7 Ultra",
                "model": "F7 Ultra"
            },
            {
                "regex": "25053PC47G|POCO F7",
                "model": "F7"
            },
            {
                "regex": "(?:M2006C3MI|POCO C3)(?:[);/ ]|$)",
                "model": "C3"
            },
            {
                "regex": "(?:211033MI|22031116AI|MZB0A0MIN)(?:[);/ ]|$)",
                "model": "C31"
            },
            {
                "regex": "(?:220333QPG|POCO C40)(?:[);/ ]|$)",
                "model": "C40"
            },
            {
                "regex": "2305EPCC4G|MZB0E6DIN|2302EPCC4[HI]|POCO C51(?: Build|[;)])",
                "model": "C51"
            },
            {
                "regex": "220733SP[IH]",
                "model": "C50"
            },
            {
                "regex": "22127PC95I",
                "model": "C55"
            },
            {
                "regex": "2312BPC51[HX]|POCO C61",
                "model": "C61"
            },
            {
                "regex": "2310FPCA4[GI]|POCO C65",
                "model": "C65"
            },
            {
                "regex": "2410FPCC5G|POCO C75",
                "model": "C75"
            },
            {
                "regex": "25028PC03[GI]|POCO C71",
                "model": "C71"
            },
            {
                "regex": "25078PC3EG|POCO C85",
                "model": "C85"
            },
            {
                "regex": "(?:POCO F2 PRO|M2004J11G)(?:[);/ ]|$)",
                "model": "F2 Pro"
            },
            {
                "regex": "X5 GT PRO(?:[);/ ]|$)",
                "model": "X5 GT Pro"
            },
            {
                "regex": "2405CPCFBG",
                "device": "tablet",
                "model": "Pad 12.1\""
            }
        ]
    },
    "Zopo": {
        "regex": "ZOPO|(?:ZOPO[_ ])?(HERO2|Flash X3|F2_Color5_5|F5_Color_M5|C2_Color_M4|ZP[0-9]{2,}[^/;]+)(?:\\)| Build)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:ZOPO_C2_MOD|ZP998)(?:[);/ ]|$)",
                "model": "C2 II"
            },
            {
                "regex": "ZOPO 9xxQuad(?:[);/ ]|$)",
                "model": "9XX Quad"
            },
            {
                "regex": "(?:ZOPO_)?ZP980[+](?:[);/ ]|$)",
                "model": "ZP980+"
            },
            {
                "regex": "(?:ZOPO_)?ZP980(?:[);/ ]|$)",
                "model": "Scorpio"
            },
            {
                "regex": "ZP952(?:[);/ ]|$)",
                "model": "Speed 7 Plus"
            },
            {
                "regex": "HERO2(?:[);/ ]|$)",
                "model": "Hero 2"
            },
            {
                "regex": "ZP951(?:[);/ ]|$)",
                "model": "Speed 7"
            },
            {
                "regex": "ZP955(?:[);/ ]|$)",
                "model": "Speed 8"
            },
            {
                "regex": "ZP950[+h]?(?:[);/ ]|$)",
                "model": "Leader Max"
            },
            {
                "regex": "ZP(?:900H?|910)(?:[);/ ]|$)",
                "model": "Leader"
            },
            {
                "regex": "ZP(?:800H|810)(?:[);/ ]|$)",
                "model": "Libero HD"
            },
            {
                "regex": "ZP500[+]?(?:[);/ ]|$)",
                "model": "Libero"
            },
            {
                "regex": "ZP330(?:[);/ ]|$)",
                "model": "Color C"
            },
            {
                "regex": "ZP370(?:[);/ ]|$)",
                "model": "Color S"
            },
            {
                "regex": "F2_Color5_5(?:[);/ ]|$)",
                "model": "Color F2"
            },
            {
                "regex": "F5_Color_M5(?:[);/ ]|$)",
                "model": "F5 Color M5"
            },
            {
                "regex": "C2_Color_M4(?:[);/ ]|$)",
                "model": "C2 Color M4"
            },
            {
                "regex": "ZP5(63|86)(?:[);/ ]|$)",
                "model": "Color X"
            },
            {
                "regex": "ZP567(?:[);/ ]|$)",
                "model": "Color C5i"
            },
            {
                "regex": "ZP300[S+]?(?:[);/ ]|$)",
                "model": "Field"
            },
            {
                "regex": "ZP200[+]?(?:[);/ ]|$)",
                "model": "Shining"
            },
            {
                "regex": "ZP100(?:[);/ ]|$)",
                "model": "Pilot"
            },
            {
                "regex": "ZP1790(?:[);/ ]|$)",
                "model": "Flash X2"
            },
            {
                "regex": "ZP781(?:[);/ ]|$)",
                "model": "Flash G5 Plus"
            },
            {
                "regex": "ZOPO[_ ]ONE[_ ]([YXTP])(?:[);/ ]|$)",
                "model": "One $1"
            },
            {
                "regex": "(?:ZOPO_)?(Flash X3|X1i|ZP[0-9]{2,}[^/;)]+)(?: Build|\\))",
                "model": "$1"
            }
        ]
    },
    "QIN": {
        "regex": "(?:Android 12(?:[\\d.]*);(?: [\\w-]+;)? F22 ?Pro|(?:Android 11(?:[\\d.]*);(?: [\\w-]+;)? (?:F22|F21 Pro))(?: Build|[;)]))",
        "device": "smartphone",
        "models": [
            {
                "regex": "F(\\d+) ?Pro(?:[);/ ]|$)",
                "model": "F$1 Pro"
            },
            {
                "regex": "F(22)(?:[);/ ]|$)",
                "model": "F$1"
            }
        ]
    },
    "Xiaomi": {
        "regex": "Xiaomi(?!/(?:Miui|Mint[ ])Browser)| ONC(?: Build|[;)])|MiTV-\\w|Mi9 ?(?:Lite|SE)|MiProj(?:A1|M05)|Mi9 Pro 5G|(?:Mi5X|MI [a-z0-9]+|Mi-4c|MI-One[ _]?[a-z0-9]+|MIX(?: 2S?)?|MIX 2S ART|pomelo|rubyplus|AFTBTX4)(?:[);/ ]|$)|HM (?:[^/;]+) (?:Build|MIUI)|(?:2014501|2014011|201481[12378]|201302[23]|2013061) Build|Redmi|POCOPHONE|(?:SHARK )?KTUS-[AH]0|(?:SHARK )?(KLE|KSR|MBU|PAR)-[AH]0|SK[RW]-[AH]0|PRS-[AH]0|POCO F1|DLT-[AH]0|MIBOX[234]([_ ]PRO)?|MiTV4[ACSX]?|AWM-A0|MI CC 9 Meitu Edition|MiBOX1S|M2006J10C|M2006C3(?:L[IGC]|LVG|MN?G|MT)|M2007J1(?:7[CGI]|SC)|M2002(?:J9[SEG]|F4LG)|HM2014819|WT88047|210611(?:8C|19(?:BI|[AD]G|AL))|M2001(?:J[12]G|J2I|C3K3I)|M2004J1(?:5SC|9AG)|M2004J(?:7[AB]|19)[CG]|M2012K11(?:[CGI]|A[CI])|M2011K2[CG]|M2011J18C|M2006C3[ML]II|M2003J(?:15SC|15SS|6B2G|6A1G|6[AB]1I)|M2007J3S[ICYGP]|M2007J22[CG]|M2103K19[CGYI]|M2101K(?:[79]AG|7AI|7B[GI]|6[GIRP]|7BNY|9[GCR])|M2010J19S[CGYIL]|M2102(?:K1AC|K1[CG]|J2SC)|HM NOTE 1(?:LTE|W)|MI[_ ]PLAY|Qin 1s\\+|Qin ?2(?: Pro)?|MI_(NOTE_Pro|5X|4i|(?:A2|8)_Lite)|A001XM|lancelot|XIG0[1-57]|2107119DC|M1810(?:F6LI|F6[GI])|M2101K(?:7BL|9AI)|A101XM|M2012K10C|M2104K10AC|M19(?:01F7[1S]|10F4S|08(?:F1XE|C3JGG)|08C3J[IH]|06F9S[IH]|02F1G|03C3GI)|21051182[CG]|21081111RG|2109119D[GI]|21091116(?:AI|[AU]?C|i|U[GI])|220111(?:7T[LGIY]|19TI|19UY|6S[IRC]|6TG|[67]SG|7SL)|21121(?:119S[CG]|23A[CG]|119VL|210C)|2204121(?:6[CI]|6UC|9[CGI]|9NY|1AC)|220333Q(?:AG|NY|L|BI)|2107113S[IGR]|22031(?:29G|116BG|21C)|PAR-H0|M2105K81A?C|2109119BC|2202(?:1119KR|1211RC|33L2[CGI])|22011(?:2[23][CG]|211C|16TI|17S[YI])|joyeuse|galahad|hydrogen|begonia|kenzo|willow|beryllium|rosemary|biloba| MD(?:G1|E5)|KLE-AO|Mi ?Pad ?\\d|220612(?:18C|[23]SC)|2207(?:12(?:2MC|12AG|19AI)|33S(?:F?G|[ILH])|43FI)|2208(?:7RA4DI|1212(?:U?G|[CR])|128(?:1AC|3[GC]))|Black Shark|MZB82(?:98|5[57])IN|MZB0A5[HE]IN|2210(?:1317C|1320C|1316(?:U[PG]|UCP?|[CIG])|1(?:29SG|32[CG]))|2211(?:13(?:3[CG]|17I)|1317G)|23013RK75C|2305(?:3RN02[AYLI]|4RA19C)|2209(?:5RA98C|116AG|129SC)|2212(?:0RN86[CGIH]|6RN91Y|ARNC4L|2RK93C|7RK46C)|2302(?:6RN54G|1RAA(?:EI|EG|2[YG])|7RAD4I|8R(?:N4D[GI]|A60L|NCA[GI]))|angelican|vnd_camellia|2304(?:9RAD8C|FPN6D[GC]|6RP50C|3RP34[CGI]|6PNC9C)|2303(?:0RAC7Y|CRA44A|ERA42L)|M1908C3(?:[KJI]G|KH|I[CH])|M1906G7G|M1901F7G|M1903(?:F10I|C3GG|C3E[IG])|M1904F3BG|Hongmi [45]A?|M1912G7B[CE]|2307(?:7RABDC|6RN4BI|6RA4BR|6RN8DY|8PND5G|8RKD5C|6RA4BC|3RPBF[GCL]|BRPDCC)|2310(?:6RN0DA|8RN04Y)|2312(?:CRNCCL|DRA50G|9RAA4G|9RA5FL|9RN51[HX]|CRAD3C|DRAAB[CGI]|7PN0C[CG]|DRA50[CI]|4RA7EO|4RN87[CIG])|2311(?:6PN5B[CG]|BPN23C|7RA68G|DRN14I|7RK66C|FRAFDC|DRK48C|3RKC6C)|2308(?:CPXD0C|8PND5R)|24018RPAC[CG]|2404(?:ARN45A|8RN6C[GI]|0RN64Y|4RN32L|9RN28L)|2405(?:3PY09[CI]|CRPFD[CGL]|CPX3D[CG])|2306EPN60G|23090(?:RA98[CGI])|23100RN82L|2406(?:9RA21C|ERN9C[IC]|APNFAG)|2403(?:1PN0DC|0PN60G)|QIN3ULTRA|FengMiProjA2|A401XM|MZB8458IN|M1805E10A|M1803D5XA|2407(?:6RP19[GI]|FPN8E[GR]|2PX77C|FRK8EC|4RPD2[GI]|5RP89G)|2410CRP4C[CGI]|2411(?:DRN47[CI]|6RACCG|6RNC1I|5RA8E[CGI]|7RK2CC|7RN76[OLEG])|A201XM|2409(?:0RA29[CGI]|BRN2C[ACILGY]|4RAD4[CIG]|1RPAD[CG])| Mi8|MDE40|A301XM|2410DPN6CC|2412(?:9PN74[CGI]|9RT7CC|7RK2CC|2RKC7C)|2501(?:0PN30[CGI]|9PNF3C)|2502(?:8RN03[ALIY]|FRA65G)|2504(?:2PN24C|0RP0A[EG])|2505(3RT47C|DRP06[EGI])|2506(?:7PYE3C|0RK16C|BPN68G|9PTEBG|2RN2D[AELY])|25078RA3E[AEYL]|2508(?:CRN2BE|0RABDC)|2509(?:8PN5AC|FPN0BC|9RP13G|BRP2DG)|25113PN0EC|25104RADAC",
        "device": "smartphone",
        "models": [
            {
                "regex": "SKR-[AH]0",
                "model": "Black Shark"
            },
            {
                "regex": "AWM-A0",
                "model": "Black Shark Helo"
            },
            {
                "regex": "SKW-[AH]0",
                "model": "Black Shark 2"
            },
            {
                "regex": "DLT-[AH]0",
                "model": "Black Shark 2 Pro"
            },
            {
                "regex": "(?:SHARK )?KLE-A[0O]",
                "model": "Black Shark 3"
            },
            {
                "regex": "(?:SHARK )?KSR-[AH]0",
                "model": "Black Shark 4 Pro"
            },
            {
                "regex": "(?:SHARK )?KLE-H0",
                "model": "Black Shark 3 5G"
            },
            {
                "regex": "(?:SHARK )?MBU-H0",
                "model": "Black Shark 3 Pro 5G"
            },
            {
                "regex": "(?:SHARK )?MBU-A0",
                "model": "Black Shark 3 Pro"
            },
            {
                "regex": "(?:SHARK )?PRS-[AH]0",
                "model": "Black Shark 4"
            },
            {
                "regex": "(?:SHARK )?PAR-[AH]0",
                "model": "Black Shark 5"
            },
            {
                "regex": "(?:SHARK )?KTUS-[AH]0",
                "model": "Black Shark 5 Pro"
            },
            {
                "regex": "Black Shark ([^/);]+)(?: Build|[;)])",
                "model": "Black Shark $1"
            },
            {
                "regex": "Xiaomi_2014501|2014501 Build",
                "model": "Hongmi 4G"
            },
            {
                "regex": "Xiaomi_2014011|2014011 Build",
                "model": "Hongmi 1S"
            },
            {
                "regex": "Xiaomi_201302[23]|201302[23] Build",
                "model": "Hongmi"
            },
            {
                "regex": "Xiaomi[_-]2014818|2014818 Build",
                "model": "Hongmi 2 3G"
            },
            {
                "regex": "Xiaomi_2014817|2014817 Build",
                "model": "Hongmi 2"
            },
            {
                "regex": "Xiaomi[_-]201481[123]|201481[123] Build",
                "model": "Hongmi 2 4G"
            },
            {
                "regex": "Hongmi ([45]A?)",
                "model": "Hongmi $1"
            },
            {
                "regex": "MI[_ ]PLAY(?:[);/ ]|$)",
                "model": "Mi Play"
            },
            {
                "regex": "Mi ?9 ?SE(?:[);/ ]|$)",
                "model": "Mi 9 SE"
            },
            {
                "regex": "(?:Mi ?9 Lite|M1904F3BG)(?:[);/ ]|$)",
                "model": "Mi 9 Lite"
            },
            {
                "regex": "(?:Xiaomi_)?M1902F1[GT]",
                "model": "Mi 9"
            },
            {
                "regex": "MI CC 9e|MI CC9e",
                "model": "Mi CC 9e"
            },
            {
                "regex": "MI CC9 Pro Premium Edition",
                "model": "Mi CC 9 Pro Premium Edition"
            },
            {
                "regex": "MI CC ?9 Pro",
                "model": "Mi CC 9 Pro"
            },
            {
                "regex": "MI CC 9(?: Meitu Edition)?(?:[);/ ]|$)",
                "model": "Mi CC 9"
            },
            {
                "regex": "(?:Xiaomi_)?(?:M2001J2E_TD-LTE|M2001J2[GI])(?:[);/ ]|$)",
                "model": "Mi 10"
            },
            {
                "regex": "(?:Xiaomi_)?(?:Mi 10 Pro|M2001J1[EG](?:_TD-LTE)?)(?:[);/ ]|$)",
                "model": "Mi 10 Pro"
            },
            {
                "regex": "M2011K2[CG](?:[);/ ]|$)",
                "model": "Mi 11"
            },
            {
                "regex": "21091116UI(?:[);/ ]|$)",
                "model": "11i HyperCharge 5G"
            },
            {
                "regex": "M2012K11AI(?:[);/ ]|$)",
                "model": "Mi 11X"
            },
            {
                "regex": "(?:M2012K11I|Mi 11X Pro)(?:[);/ ]|$)",
                "model": "Mi 11X Pro"
            },
            {
                "regex": "M2007J3S[GI](?:[);/ ]|$)",
                "model": "Mi 10T Pro 5G"
            },
            {
                "regex": "M2007J17G(?:[);/ ]|$)",
                "model": "Mi 10T Lite 5G"
            },
            {
                "regex": "M2007J3S[CYP](?:[);/ ]|$)",
                "model": "Mi 10T 5G"
            },
            {
                "regex": "M2007J1SC(?:[);/ ]|$)",
                "model": "Mi 10 Ultra 5G"
            },
            {
                "regex": "M2102J2SC(?:[);/ ]|$)",
                "model": "Mi 10S"
            },
            {
                "regex": "(?:M2002J9[EGS]|XIG01|Mi 10 Lite 5G)(?:[);/ ]|$)",
                "model": "Mi 10 Lite 5G"
            },
            {
                "regex": "M2007J17I(?:[);/ ]|$)",
                "model": "Mi 10i"
            },
            {
                "regex": "(?:M2012K11G|MZB0A5EIN)(?:[);/ ]|$)",
                "model": "Mi 11i"
            },
            {
                "regex": "(?:2107113S[IGR]|Xiaomi 11T Pro)(?:[);/ ]|$)",
                "model": "Mi 11T Pro"
            },
            {
                "regex": "(?:21081111RG|Xiaomi 11T)(?:[);/ ]|$)",
                "model": "Mi 11T"
            },
            {
                "regex": "(?:2109119DI|(?:Xiao)?mi 11 Lite (?:5G )?NE)(?:[);/ ]|$)",
                "model": "Mi 11 Lite 5G NE"
            },
            {
                "regex": "(?:M2101K9[GCR]|2109119DG|Mi 11 Lite 5G)(?:[);/ ]|$)",
                "model": "Mi 11 Lite 5G"
            },
            {
                "regex": "(?:M2101K9A[GI]|Mi 11 Lite)(?:[);/ ]|$)",
                "model": "Mi 11 Lite"
            },
            {
                "regex": "M2102K1[CG](?:[);/ ]|$)",
                "model": "Mi 11 Ultra"
            },
            {
                "regex": "(?:M2102K1AC|Mi 11 Pro)(?:[);/ ]|$)",
                "model": "Mi 11 Pro"
            },
            {
                "regex": "2201122[CG](?:[);/ ]|$)",
                "model": "12 Pro"
            },
            {
                "regex": "2201123[CG](?:[);/ ]|$)",
                "model": "12"
            },
            {
                "regex": "2209116AG(?:[);/ ]|$)",
                "model": "Redmi Note 12 Pro 4G"
            },
            {
                "regex": "22071212AG(?:[);/ ]|$)",
                "model": "12T"
            },
            {
                "regex": "(?:2207122MC|Xiaomi 12 Pro Dimensity)(?:[);/ ]|$)",
                "model": "12 Pro Dimensity"
            },
            {
                "regex": "(?:22081212(?:U?G|[CR])|Xiaomi 12T Pro|A201XM)(?:[);/ ]|$)",
                "model": "12T Pro"
            },
            {
                "regex": "(?:2206122SC|Xiaomi 12S Pro)(?:[);/ ]|$)",
                "model": "12S Pro"
            },
            {
                "regex": "(?:2206123SC)(?:[);/ ]|$)",
                "model": "12S"
            },
            {
                "regex": "(?:2203121C|Xiaomi 12S Ultra)(?:[);/ ]|$)",
                "model": "12S Ultra"
            },
            {
                "regex": "2203129G(?:[);/ ]|$)",
                "model": "12 Lite"
            },
            {
                "regex": "(?:2112123A[CG]|Xiaomi 12X)(?:[);/ ]|$)",
                "model": "12X"
            },
            {
                "regex": "2210132[CG](?:[);/ ]|$)",
                "model": "13 Pro"
            },
            {
                "regex": "(?:2210129SG|Xiaomi 13 Lite)(?:[);/ ]|$)",
                "model": "13 Lite"
            },
            {
                "regex": "2211133[CG](?:[);/ ]|$)|Xiaomi 13(?: Build|[;)])",
                "model": "13"
            },
            {
                "regex": "(?:2304FPN6D[CG]|Xiaomi 13 Ultra)(?:[);/ ]|$)",
                "model": "13 Ultra"
            },
            {
                "regex": "(?:23078PND5G|23088PND5R|Xiaomi 13T Pro|A301XM)(?:[);/ ]|$)",
                "model": "13T Pro"
            },
            {
                "regex": "(?:2306EPN60G|XIG04)(?:[);/ ]|$)",
                "model": "13T"
            },
            {
                "regex": "23127PN0C[CG](?:[);/ ]|$)",
                "model": "14"
            },
            {
                "regex": "(?:24031PN0DC|24030PN60G|Xiaomi 14 Ultra)(?:[);/ ]|$)",
                "model": "14 Ultra"
            },
            {
                "regex": "Xiaomi 14 Pro Ti",
                "model": "14 Pro Ti"
            },
            {
                "regex": "24053PY09I(?:[);/ ]|$)",
                "model": "14 Civi"
            },
            {
                "regex": "(?:23116PN5B[CG]|Xiaomi 14 Pro)(?:[);/ ]|$)",
                "model": "14 Pro"
            },
            {
                "regex": "(?:2311BPN23C)(?:[);/ ]|$)",
                "model": "Mix Flip"
            },
            {
                "regex": "(2407FPN8E[GR]|2406APNFAG|Xiaomi 14T Pro)(?:[);/ ]|$)",
                "model": "14T Pro"
            },
            {
                "regex": "XIG07(?:[);/ ]|$)",
                "model": "14T"
            },
            {
                "regex": "2410DPN6CC|Xiaomi15 Pro",
                "model": "15 Pro"
            },
            {
                "regex": "24129PN74[CGI]",
                "model": "15"
            },
            {
                "regex": "25042PN24C",
                "model": "15S Pro"
            },
            {
                "regex": "2506BPN68G",
                "model": "15T Pro"
            },
            {
                "regex": "25069PTEBG",
                "model": "15T"
            },
            {
                "regex": "2501(?:0PN30[CGI]|9PNF3C)",
                "model": "15 Ultra"
            },
            {
                "regex": "25098PN5AC",
                "model": "17 Pro"
            },
            {
                "regex": "25113PN0EC",
                "model": "17"
            },
            {
                "regex": "2509FPN0BC",
                "model": "17 Pro Max"
            },
            {
                "regex": "MI[ _]8[ _]?Lite(?:[);/ ]|$)",
                "model": "Mi 8 Lite"
            },
            {
                "regex": "MI 8 Explorer Edition(?:[);/ ]|$)",
                "model": "Mi 8 Explorer Edition"
            },
            {
                "regex": "MI ?8 ?([a-z]+)(?:[);/ ]|$)",
                "model": "Mi 8 $1"
            },
            {
                "regex": "Mi ?8(?:[);/ ]|$)",
                "model": "Mi 8"
            },
            {
                "regex": "Mi 9T Pro(?:[);/ ]|$)",
                "model": "Mi 9T Pro"
            },
            {
                "regex": "(?:Mi ?9 Pro 5G|M1908F1XE)(?:[);/ ]|$)",
                "model": "Mi 9 Pro 5G"
            },
            {
                "regex": "MI 9 Transparent Edition(?:[);/ ]|$)",
                "model": "Mi 9 Transparent Edition"
            },
            {
                "regex": "MI ([89]) Lite(?:[);/ ]|$)",
                "model": "Mi $1 Lite"
            },
            {
                "regex": "MI 5s Plus(?:[);/ ]|$)",
                "model": "Mi 5s Plus"
            },
            {
                "regex": "Xiaomi_MDT2|Mi5X(?:[);/ ]|$)",
                "model": "Mi 5X"
            },
            {
                "regex": "Xiaomi_2013061|2013061 Build",
                "model": "Mi 3"
            },
            {
                "regex": "Mi[- ]([43])c(?:[);/ ]|$)",
                "model": "Mi $1C"
            },
            {
                "regex": "MI 4W(?:[);/ ]|$)",
                "model": "Mi 4W"
            },
            {
                "regex": "Mi_4i(?:[);/ ]|$)",
                "model": "Mi 4i"
            },
            {
                "regex": "MI 4 ?LTE(?:[);/ ]|$)",
                "model": "Mi 4 LTE"
            },
            {
                "regex": "Mi Max3Pro",
                "model": "Mi Max 3 Pro"
            },
            {
                "regex": "MI MAX ([23])(?:[);/ ]|$)",
                "model": "Mi Max $1"
            },
            {
                "regex": "(?:MI MAX|hydrogen)(?:[);/ ]|$)",
                "model": "Mi Max"
            },
            {
                "regex": "MDE40(?:[);/ ]|$)",
                "model": "Mi Max 2"
            },
            {
                "regex": "Mi[ _]A2[ _]Lite(?:[);/ ]|$)",
                "model": "Mi A2 Lite"
            },
            {
                "regex": "M1906F9S[IH](?:[);/ ]|$)",
                "model": "Mi A3"
            },
            {
                "regex": "2106118C(?:[);/ ]|$)",
                "model": "Mi Mix 4"
            },
            {
                "regex": "MDE5(?:[);/ ]|$)",
                "model": "Mi Mix 2"
            },
            {
                "regex": "M1803D5XA(?:[);/ ]|$)",
                "model": "Mi Mix 2S"
            },
            {
                "regex": "Mi MIX 3 5G(?:[);/ ]|$)",
                "model": "Mi Mix 3 5G"
            },
            {
                "regex": "MIX ([23])(?:[);/ ]|$)",
                "model": "Mi Mix $1"
            },
            {
                "regex": "MIX 2S ART(?:[);/ ]|$)",
                "model": "Mi Mix 2S Art"
            },
            {
                "regex": "MIX 2S(?:[);/ ]|$)",
                "model": "Mi Mix 2S"
            },
            {
                "regex": "MIX(?! Fold 3)(?:[);/ ]|$)",
                "model": "Mi Mix"
            },
            {
                "regex": "2405CPX3D[CG]",
                "model": "Mix Flip"
            },
            {
                "regex": "24072PX77C(?:[);/ ]|$)",
                "model": "Mix Fold 4"
            },
            {
                "regex": "Mi Note 3(?:[);/ ]|$)",
                "model": "Mi Note 3"
            },
            {
                "regex": "POCOPHONE[ _]F1|POCO F1|beryllium|M1805E10A",
                "model": "Pocophone F1"
            },
            {
                "regex": "M1903C3G[IG]",
                "model": "Redmi Go"
            },
            {
                "regex": "24069RA21C|Redmi Turbo 3",
                "model": "Redmi Turbo 3"
            },
            {
                "regex": "24129RT7CC",
                "model": "Redmi Turbo 4"
            },
            {
                "regex": "25053RT47C",
                "model": "Redmi Turbo 4 Pro"
            },
            {
                "regex": "Redmi 5 Plus",
                "model": "Redmi 5 Plus"
            },
            {
                "regex": "MDG1(?:[);/ ]|$)",
                "model": "Redmi 5"
            },
            {
                "regex": "WT88047(?:[);/ ]|$)",
                "model": "Redmi 2"
            },
            {
                "regex": "HM2014819(?:[);/ ]|$)",
                "model": "Redmi 2 Pro"
            },
            {
                "regex": "HM 2A(?:[);/ ]|$)",
                "model": "Redmi 2A"
            },
            {
                "regex": "HM 1S[CW]?(?:[);/ ]|$)",
                "model": "Redmi 1S"
            },
            {
                "regex": "HM 1(?:[);/ ]|$)",
                "model": "Redmi 1"
            },
            {
                "regex": "(?:M2001C3K3I|MZB8298IN|M1908C3K[GH]|MZB8458IN)(?:[);/ ]|$)",
                "model": "Redmi 8A"
            },
            {
                "regex": "(?:MZB825[57]IN|M1908C3I[CG]|M1908C3IH)(?:[);/ ]|$)",
                "model": "Redmi 8"
            },
            {
                "regex": "Redmi 8A (Dual|Pro)(?:[);/ ]|$)",
                "model": "Redmi 8A $1"
            },
            {
                "regex": "(?:M2004J7AC|M2004J15SC|Redmi 10X (?:4G|LTE))(?:[);/ ]|$)",
                "model": "Redmi 10X"
            },
            {
                "regex": "220333Q(?:AG|NY|L)(?:[);/ ]|$)",
                "model": "Redmi 10C"
            },
            {
                "regex": "(?:2310(?:6RN0DA|8RN04Y|0RN82L)|2311DRN14I)(?:[);/ ]|$)",
                "model": "Redmi 13C"
            },
            {
                "regex": "2404(?:ARN45A|0RN64Y|9RN28L)",
                "model": "Redmi 13"
            },
            {
                "regex": "2406ERN9CI",
                "model": "Redmi 13 5G"
            },
            {
                "regex": "23124RN87[CIG]",
                "model": "Redmi 13C 5G"
            },
            {
                "regex": "2409BRN2C[ACILY]",
                "model": "Redmi 14C"
            },
            {
                "regex": "2411DRN47I",
                "model": "Redmi 14C 5G"
            },
            {
                "regex": "2411DRN47C",
                "model": "Redmi 14R 5G"
            },
            {
                "regex": "25078RA3E[AEYL]",
                "model": "Redmi 15C"
            },
            {
                "regex": "25062RN2D[AELY]",
                "model": "Redmi 15"
            },
            {
                "regex": "2508CRN2BE",
                "model": "Redmi 15C 5G"
            },
            {
                "regex": "(?:M2004J19[CG]|M2006C3MII|lancelot|galahad|M2004J19AG)(?:[);/ ]|$)",
                "model": "Redmi 9"
            },
            {
                "regex": "(?:M2004J19I|Redmi 9 Prime)(?:[);/ ]|$)",
                "model": "Redmi 9 Prime"
            },
            {
                "regex": "(?:M2010J19S[IL]|Redmi 9 Power)(?:[);/ ]|$)",
                "model": "Redmi 9 Power"
            },
            {
                "regex": "M2006C3L[GCI](?:[);/ ]|$)",
                "model": "Redmi 9A"
            },
            {
                "regex": "M2006C3LII(?:[);/ ]|$)",
                "model": "Redmi 9i"
            },
            {
                "regex": "MZB0A5HIN(?:[);/ ]|$)",
                "model": "Redmi 9i Sport"
            },
            {
                "regex": "M2006C3M[GT](?:[);/ ]|$)",
                "model": "Redmi 9C"
            },
            {
                "regex": "M2006C3LVG(?:[);/ ]|$)",
                "model": "Redmi 9AT"
            },
            {
                "regex": "(?:M2010J19S[GY]|pomelo|Redmi 9T, Note 9 4G, 9 Power)(?:[);/ ]|$)",
                "model": "Redmi 9T"
            },
            {
                "regex": "Redmi 9T NFC(?:_SN)?(?:[);/ ]|$)",
                "model": "Redmi 9T NFC"
            },
            {
                "regex": "(?:M2006C3MNG|Redmi 9C NFC|angelican)(?:[);/ ]|$)",
                "model": "Redmi 9C NFC"
            },
            {
                "regex": "(?:22041219(?:G|NY)|Redmi 10 5G)(?:[);/ ]|$)",
                "model": "Redmi 10 5G"
            },
            {
                "regex": "(?:21061119D[CG])(?:[);/ ]|$)",
                "model": "Redmi 10"
            },
            {
                "regex": "(?:220333QBI|Redmi 10 Power)(?:[);/ ]|$)",
                "model": "Redmi 10 Power"
            },
            {
                "regex": "220233L2[CGI](?:[);/ ]|$)",
                "model": "Redmi 10A"
            },
            {
                "regex": "(?:21061119A[GL]|21121119(?:SG|VL)|22011119UY|Redmi 10 2022)(?:[);/ ]|$)",
                "model": "Redmi 10 (2022)"
            },
            {
                "regex": "(?:22041219I|Redmi 10 Prime\\+ 5G)(?:[);/ ]|$)",
                "model": "Redmi 10 Prime+ 5G"
            },
            {
                "regex": "22011119TI(?:[);/ ]|$)",
                "model": "Redmi 10 Prime (2022)"
            },
            {
                "regex": "(?:21061119[BT]I|Redmi 10 Prime)(?:[);/ ]|$)",
                "model": "Redmi 10 Prime"
            },
            {
                "regex": "(?:M2004J7BC|Redmi 10X Pro)(?:[);/ ]|$)",
                "model": "Redmi 10X Pro"
            },
            {
                "regex": "22120RN86C",
                "model": "Redmi 11A"
            },
            {
                "regex": "22120RN86[GIH]|22126RN91Y|2212ARNC4L",
                "model": "Redmi 12C"
            },
            {
                "regex": "23053RN02[AYLI]",
                "model": "Redmi 12"
            },
            {
                "regex": "(?:23076(?:RN8DY|RA4BR|RN4BI)|23077RABDC|XIG03|Redmi 12 5G|A401XM)(?:[);/ ]|$)",
                "model": "Redmi 12 5G"
            },
            {
                "regex": "22071219AI(?:[);/ ]|$)",
                "model": "Redmi 11 Prime"
            },
            {
                "regex": "Redmi K20 Pro Premium Edition(?:[);/ ]|$)",
                "model": "Redmi K20 Pro Premium Edition"
            },
            {
                "regex": "Redmi K20Pro(?:[);/ ]|$)",
                "model": "Redmi K20 Pro"
            },
            {
                "regex": "M1903F10I",
                "model": "Redmi K20"
            },
            {
                "regex": "Redmi K30 Pro Zoom Edition(?:[);/ ]|$)",
                "model": "Redmi K30 Pro Zoom Edition"
            },
            {
                "regex": "Redmi K30 Pro Zoom(?:[);/ ]|$)",
                "model": "Redmi K30 Pro Zoom"
            },
            {
                "regex": "Redmi K30S Ultra(?:[);/ ]|$)",
                "model": "Redmi K30S Ultra"
            },
            {
                "regex": "Redmi K([23]0) Pro(?:[);/ ]|$)",
                "model": "Redmi K$1 Pro"
            },
            {
                "regex": "Redmi K30 5G(?:[);/ ]|$)",
                "model": "Redmi K30 5G"
            },
            {
                "regex": "M1912G7B[CE](?:[);/ ]|$)",
                "model": "Redmi K30 4G"
            },
            {
                "regex": "Redmi K30i 5G(?:[);/ ]|$)",
                "model": "Redmi K30i 5G"
            },
            {
                "regex": "M2012K11AC(?:[);/ ]|$)",
                "model": "Redmi K40"
            },
            {
                "regex": "22021211RC(?:[);/ ]|$)",
                "model": "Redmi K40S"
            },
            {
                "regex": "(?:M2012K10C|Redmi K40 Gaming)(?:[);/ ]|$)",
                "model": "Redmi K40 Gaming"
            },
            {
                "regex": "Redmi K40 Pro\\+(?:[);/ ]|$)",
                "model": "Redmi K40 Pro+"
            },
            {
                "regex": "(?:M2012K11C|Redmi K40 Pro)(?:[);/ ]|$)",
                "model": "Redmi K40 Pro"
            },
            {
                "regex": "(?:M2006J10C|Redmi K30 Ultra)(?:[);/ ]|$)",
                "model": "Redmi K30 Ultra"
            },
            {
                "regex": "22041211AC",
                "model": "Redmi K50"
            },
            {
                "regex": "Redmi K50 Mercedes-AMG F1 Team",
                "model": "Redmi K50 Mercedes-AMG F1 Team"
            },
            {
                "regex": "22041216I",
                "model": "Redmi K50i"
            },
            {
                "regex": "21121210C",
                "model": "Redmi K50G"
            },
            {
                "regex": "22011211C|Redmi K50 Pro",
                "model": "Redmi K50 Pro"
            },
            {
                "regex": "Redmi K50 Ultra",
                "model": "Redmi K50 Ultra"
            },
            {
                "regex": "22122RK93C",
                "model": "Redmi K60E"
            },
            {
                "regex": "22127RK46C|Redmi K60 Pro",
                "model": "Redmi K60 Pro"
            },
            {
                "regex": "23078RKD5C|Redmi K60 Ultra",
                "model": "Redmi K60 Ultra"
            },
            {
                "regex": "23117RK66C",
                "model": "Redmi K70 Pro"
            },
            {
                "regex": "2311DRK48C",
                "model": "Redmi K70E"
            },
            {
                "regex": "23113RKC6C",
                "model": "Redmi K70"
            },
            {
                "regex": "2407FRK8EC",
                "model": "Redmi K70 Ultra"
            },
            {
                "regex": "241[12]7RK2CC|24122RKC7C",
                "model": "Redmi K80 Pro"
            },
            {
                "regex": "25060RK16C",
                "model": "Redmi K80 Ultra"
            },
            {
                "regex": "Redmi Y1 Lite(?:[);/ ]|$)",
                "model": "Redmi Y1 Lite"
            },
            {
                "regex": "M1810F6[GI]",
                "model": "Redmi Y3"
            },
            {
                "regex": "Redmi 6 Pro Extreme",
                "model": "Redmi 6 Pro Extreme"
            },
            {
                "regex": "Xiaomi_M1805D1ST",
                "model": "Redmi 6 Pro"
            },
            {
                "regex": "ONC(?: Build|[;)])|M1810F6LI",
                "model": "Redmi 7"
            },
            {
                "regex": "M1903C3E[IG]",
                "model": "Redmi 7A"
            },
            {
                "regex": "Redmi (\\d+) Pro(?:[);/ ]|$)",
                "model": "Redmi $1 Pro"
            },
            {
                "regex": "Redmi 4 Prime(?:[);/ ]|$)",
                "model": "Redmi 4 Prime"
            },
            {
                "regex": "(?:220733SFG|Redmi A1\\+|220743FI)(?:[);/ ]|$)",
                "model": "Redmi A1+"
            },
            {
                "regex": "220733S[GHIL](?:[);/ ]|$)",
                "model": "Redmi A1"
            },
            {
                "regex": "2302(?:8RN4D[GI]|6RN54G)",
                "model": "Redmi A2"
            },
            {
                "regex": "23028RNCA[GI]",
                "model": "Redmi A2+"
            },
            {
                "regex": "23129RN51[XH]",
                "model": "Redmi 3"
            },
            {
                "regex": "2404(?:4RN32L|8RN6C[GI])",
                "model": "Redmi A3x"
            },
            {
                "regex": "2312CRNCCL",
                "model": "Redmi A3"
            },
            {
                "regex": "2409BRN2CG",
                "model": "Redmi A3 Pro"
            },
            {
                "regex": "24116RNC1I",
                "model": "Redmi A4 5G"
            },
            {
                "regex": "25028RN03[ALIY]",
                "model": "Redmi A5"
            },
            {
                "regex": "QIN3ULTRA",
                "model": "Qin 3 Ultra"
            },
            {
                "regex": "Qin ?2 Pro(?:[);/ ]|$)",
                "model": "Qin 2 Pro"
            },
            {
                "regex": "Qin 2(?:[);/ ]|$)",
                "model": "Qin 2"
            },
            {
                "regex": "2107119DC(?:[);/ ]|$)",
                "model": "CC11"
            },
            {
                "regex": "2109119BC(?:[);/ ]|$)",
                "model": "Civi"
            },
            {
                "regex": "2209129SC(?:[);/ ]|$)",
                "model": "Civi 2"
            },
            {
                "regex": "23046PNC9C",
                "model": "Civi 3"
            },
            {
                "regex": "24053PY09C",
                "model": "Civi 4 Pro"
            },
            {
                "regex": "25067PYE3C",
                "model": "Civi 5 Pro"
            },
            {
                "regex": "Civi 1S(?:[);/ ]|$)",
                "model": "Civi 1S"
            },
            {
                "regex": "(?:M2105K81AC|22081281AC|(?:Xiao)?mi Pad 5 Pro)(?:[);/ ]|$)",
                "model": "Mi Pad 5 Pro",
                "device": "tablet"
            },
            {
                "regex": "(?:21051182[CG]|(?:Xiao)?mi Pad 5)(?:[);/ ]|$)",
                "model": "Mi Pad 5",
                "device": "tablet"
            },
            {
                "regex": "M2105K81C(?:[);/ ]|$)",
                "model": "Mi Pad 5 Pro 5G",
                "device": "tablet"
            },
            {
                "regex": "(?:23046RP50C|Pad 6 Pro)(?:[);/ ]|$)",
                "model": "Pad 6 Pro",
                "device": "tablet"
            },
            {
                "regex": "24091RPAD[CG]",
                "model": "Pad 7 Pro",
                "device": "tablet"
            },
            {
                "regex": "2410CRP4C[CGI]",
                "model": "Pad 7",
                "device": "tablet"
            },
            {
                "regex": "23043RP34[CGI]|Xiaomi Pad 6(?: Build|[;)])",
                "model": "Pad 6",
                "device": "tablet"
            },
            {
                "regex": "2307BRPDCC(?:[);/ ]|$)",
                "model": "Pad 6 Max 14",
                "device": "tablet"
            },
            {
                "regex": "(?:24018RPAC[CG]|Xiaomi Pad 6S Pro 12\\.4)(?:[);/ ]|$)",
                "model": "Pad 6S Pro 12.4\"",
                "device": "tablet"
            },
            {
                "regex": "MI (?:PAD ?4 ?PLUS|Pad4\\+)(?:[);/ ]|$)",
                "model": "Mi Pad 4 Plus",
                "device": "tablet"
            },
            {
                "regex": "MI PAD4 Wi-?Fi(?:[);/ ]|$)",
                "model": "Mi Pad 4 WiFi",
                "device": "tablet"
            },
            {
                "regex": "MI PAD 4(?:[);/ ]|$)",
                "model": "Mi Pad 4",
                "device": "tablet"
            },
            {
                "regex": "MI ?PAD 3(?:[);/ ]|$)",
                "model": "Mi Pad 3",
                "device": "tablet"
            },
            {
                "regex": "MI PAD 2(?:[);/ ]|$)",
                "model": "Mi Pad 2",
                "device": "tablet"
            },
            {
                "regex": "MI PAD(?:[);/ ]|$)",
                "model": "Mi Pad",
                "device": "tablet"
            },
            {
                "regex": "22081283[GC](?:[);/ ]|$)",
                "model": "Redmi Pad",
                "device": "tablet"
            },
            {
                "regex": "2405CRPFD[CGL](?:[);/ ]|$)",
                "model": "Redmi Pad Pro",
                "device": "tablet"
            },
            {
                "regex": "2407(?:6RP19[GI]|5RP89G)|Redmi Pad SE 8\\.7",
                "model": "Redmi Pad SE 8.7\"",
                "device": "tablet"
            },
            {
                "regex": "(?:23073RPBF[GCL]|Redmi Pad SE)(?:[);/ ]|$)",
                "model": "Redmi Pad SE",
                "device": "tablet"
            },
            {
                "regex": "24074RPD2[CGI]",
                "model": "Redmi Pad Pro 5G",
                "device": "tablet"
            },
            {
                "regex": "2505DRP06[EG]",
                "model": "Redmi Pad 2 4G",
                "device": "tablet"
            },
            {
                "regex": "25040RP0A[EG]",
                "model": "Redmi Pad 2",
                "device": "tablet"
            },
            {
                "regex": "25099RP13G",
                "model": "Redmi Pad 2 Pro",
                "device": "tablet"
            },
            {
                "regex": "2509BRP2DG",
                "model": "Redmi Pad 2 Pro 5G",
                "device": "tablet"
            },
            {
                "regex": "MiProjA1",
                "model": "Mi Laser Projector 150\"",
                "device": "peripheral"
            },
            {
                "regex": "MiProjM05",
                "model": "Mi Smart Compact Projector",
                "device": "peripheral"
            },
            {
                "regex": "FengMiProjA2(?:[);/ ]|$)",
                "model": "FengMi Projector A2",
                "device": "tv"
            },
            {
                "regex": "MIBOX3[ _]Pro(?:[);/ ]|$)",
                "model": "Mi Box 3 Pro",
                "device": "tv"
            },
            {
                "regex": "MIBOX([234])(?:[);/ ]|$)",
                "model": "Mi Box $1",
                "device": "tv"
            },
            {
                "regex": "MiBOX1S(?:[);/ ]|$)",
                "model": "Mi Box 1S",
                "device": "tv"
            },
            {
                "regex": "MiTV-MSSP[123](?:[);/ ]|$)",
                "model": "MiTV 4S",
                "device": "tv"
            },
            {
                "regex": "MiTV-MTEQ0(?:[);/ ]|$)",
                "model": "MiTV Q1",
                "device": "tv"
            },
            {
                "regex": "MiTV-AESP0(?:[);/ ]|$)",
                "model": "MiTV Stick",
                "device": "tv"
            },
            {
                "regex": "MiTV-(?:ANSP0|AYFR0)(?:[);/ ]|$)",
                "model": "MiTV Stick 4K",
                "device": "tv"
            },
            {
                "regex": "MiTV-MOOQ0(?:[);/ ]|$)",
                "model": "MiTV P1",
                "device": "tv"
            },
            {
                "regex": "MiTV-MOSR1(?:[);/ ]|$)",
                "model": "MiTV R1",
                "device": "tv"
            },
            {
                "regex": "MiTV-MOOQ1(?:[);/ ]|$)",
                "model": "MiTV Q1",
                "device": "tv"
            },
            {
                "regex": "MiTV-MOOR4(?:[);/ ]|$)",
                "model": "MiTV A Pro",
                "device": "tv"
            },
            {
                "regex": "(?:MiTV-AXSO0|MiTV4(?:A|-ANSM0)|MiTV-MSSP0)(?:[);/ ]|$)",
                "model": "MiTV 4A",
                "device": "tv"
            },
            {
                "regex": "MiTV-AXSO[12](?:[);/ ]|$)",
                "model": "MiTV 4A Pro",
                "device": "tv"
            },
            {
                "regex": "MiTV(4[CSXI]|4)(?:[);/ ]|$)",
                "model": "MiTV $1",
                "device": "tv"
            },
            {
                "regex": "MiTV-AFKR0(?:[);/ ]|$)",
                "model": "TV Box S (2nd Gen)",
                "device": "tv"
            },
            {
                "regex": "AFTBTX4(?:[);/ ]|$)",
                "model": "Redmi Smart Fire TV 4K",
                "device": "tv"
            },
            {
                "regex": "MiTV-([A-Z]{4}[0-9]{1})(?:[);/ ]|$)",
                "model": "MiTV $1",
                "device": "tv"
            },
            {
                "regex": "M2011J18C(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Mi Mix Fold"
            },
            {
                "regex": "22061218C(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Mix Fold 2"
            },
            {
                "regex": "(?:2308CPXD0C|Mix Fold 3)(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Mix Fold 3"
            },
            {
                "regex": "HM NOTE 1W(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Redmi Note"
            },
            {
                "regex": "HM NOTE 1TD (?:Build|MIUI)",
                "device": "phablet",
                "model": "Hongmi Note 1TD"
            },
            {
                "regex": "HM NOTE 1(?:LTE|S)(?:W|GLOBAL|TD)? (?:Build|MIUI)|HM NOTE 1LTE",
                "device": "phablet",
                "model": "Redmi Note 4G"
            },
            {
                "regex": "Xiaomi[_ ]2015052",
                "model": "Redmi Note 2",
                "device": "phablet"
            },
            {
                "regex": "kenzo",
                "model": "Redmi Note 3",
                "device": "phablet"
            },
            {
                "regex": "Redmi Note 5A Prime",
                "model": "Redmi Note 5A Prime",
                "device": "phablet"
            },
            {
                "regex": "Redmi Note 5A Lite",
                "model": "Redmi Note 5A Lite",
                "device": "phablet"
            },
            {
                "regex": "(?:M2010J19SC|M2003J15SS|Redmi Note 9 4G)(?:[);/ ]|$)",
                "model": "Redmi Note 9",
                "device": "phablet"
            },
            {
                "regex": "M2003J6A1G(?:[);/ ]|$)",
                "model": "Redmi Note 9S",
                "device": "phablet"
            },
            {
                "regex": "M2003J15SC(?:[);/ ]|$)",
                "model": "Redmi Note 10X",
                "device": "phablet"
            },
            {
                "regex": "(?:M2101K7BL|rosemary)(?:[);/ ]|$)",
                "model": "Redmi Note 10S",
                "device": "phablet"
            },
            {
                "regex": "(?:M2007J22G|A001XM)(?:[);/ ]|$)",
                "model": "Redmi Note 9T 5G",
                "device": "phablet"
            },
            {
                "regex": "M2007J22C(?:[);/ ]|$)",
                "model": "Redmi Note 9 5G",
                "device": "phablet"
            },
            {
                "regex": "M2007J17C(?:[);/ ]|$)",
                "model": "Redmi Note 9 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:joyeuse|M2003J6(?:B2G|A1I))(?:[);/ ]|$)",
                "model": "Redmi Note 9 Pro",
                "device": "phablet"
            },
            {
                "regex": "Redmi Note 10 Lite|M2002F4LG(?:[);/ ]|$)",
                "model": "Redmi Note 10 Lite",
                "device": "phablet"
            },
            {
                "regex": "(?:Redmi Note ?9 Pro Max|M2003J6B1I)(?:[);/ ]|$)",
                "model": "Redmi Note 9 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "M2101K7A[GI]",
                "model": "Redmi Note 10",
                "device": "phablet"
            },
            {
                "regex": "M2103K19Y|22021119KR",
                "model": "Redmi Note 10T",
                "device": "phablet"
            },
            {
                "regex": "M2101K7B(?:[GI]|NY)(?:[);/ ]|$)",
                "model": "Redmi Note 10S",
                "device": "phablet"
            },
            {
                "regex": "(?:M2103K19[GC]|Redmi Note 10 5G|vnd_camellia)(?:[);/ ]|$)",
                "model": "Redmi Note 10 5G",
                "device": "phablet"
            },
            {
                "regex": "M2103K19I|A101XM|Redmi Note 10T 5G",
                "model": "Redmi Note 10T 5G",
                "device": "phablet"
            },
            {
                "regex": "XIG02(?:[);/ ]|$)",
                "model": "Redmi Note 10 JE",
                "device": "phablet"
            },
            {
                "regex": "(?:M2101K6[GIRP]|M2104K10AC|Redmi Note 10 Pro(?! Max))(?:[);/ ]|$)",
                "model": "Redmi Note 10 Pro",
                "device": "phablet"
            },
            {
                "regex": "rubyplus(?:[);/ ]|$)",
                "model": "Redmi Note 12 Discovery",
                "device": "phablet"
            },
            {
                "regex": "22101316[CIG]",
                "model": "Redmi Note 12 Pro",
                "device": "phablet"
            },
            {
                "regex": "23021RAA(?:EI|2G)",
                "model": "Redmi Note 12",
                "device": "phablet"
            },
            {
                "regex": "(?:22101320C|Redmi Note 12 Pro Speed)(?:[);/ ]|$)",
                "model": "Redmi Note 12 Pro Speed",
                "device": "phablet"
            },
            {
                "regex": "2303(?:0RAC7Y|CRA44A|ERA42L|Redmi Note 12S)(?:[);/ ]|$)",
                "model": "Redmi Note 12S",
                "device": "phablet"
            },
            {
                "regex": "(?:2302(?:1RAA2Y|1RAAEG|8RA60L|7RAD4I)|22101317C|22111317G)(?:[);/ ]|$)",
                "model": "Redmi Note 12",
                "device": "phablet"
            },
            {
                "regex": "(?:Redmi Note 12R Pro)(?:[);/ ]|$)",
                "model": "Redmi Note 12R Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:23076RA4BC|Redmi Note 12R)(?:[);/ ]|$)",
                "model": "Redmi Note 12R",
                "device": "phablet"
            },
            {
                "regex": "(?:23049RAD8C)(?:[);/ ]|$)",
                "model": "Redmi Note 12T",
                "device": "phablet"
            },
            {
                "regex": "(?:23054RA19C)(?:[);/ ]|$)",
                "model": "Redmi Note 12T Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:22101316UC)(?:[);/ ]|$)",
                "model": "Redmi Note 12 Pro DE",
                "device": "phablet"
            },
            {
                "regex": "(?:22101316UG|Redmi Note 12 Pro\\+ 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 12 Pro+ 5G",
                "device": "phablet"
            },
            {
                "regex": "22101316UP(?:[);/ ]|$)",
                "model": "Redmi Note 12 Discovery",
                "device": "phablet"
            },
            {
                "regex": "22101316UCP(?:[);/ ]|$)",
                "model": "Redmi Note 12 Pro+",
                "device": "phablet"
            },
            {
                "regex": "22111317I(?:[);/ ]|$)",
                "model": "Redmi Note 12",
                "device": "phablet"
            },
            {
                "regex": "(?:21091116C|2201116T[IG])(?:[);/ ]|$)",
                "model": "Redmi Note 11 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:2312(?:CRAD3C|DRA50C)|23117RA68G)(?:[);/ ]|$)",
                "model": "Redmi Note 13 Pro",
                "device": "phablet"
            },
            {
                "regex": "2406ERN9CC",
                "model": "Redmi Note 13R",
                "device": "phablet"
            },
            {
                "regex": "(?:2311FRAFDC)(?:[);/ ]|$)",
                "model": "Redmi Note 13R Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:2312DRA50[GI]|Redmi Note 13 Pro 5G|XIG05)(?:[);/ ]|$)",
                "model": "Redmi Note 13 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "2312(?:4RA7EO|9RAA4G|9RA5FL)(?:[);/ ]|$)",
                "model": "Redmi Note 13",
                "device": "phablet"
            },
            {
                "regex": "(?:23090RA98C)(?:[);/ ]|$)",
                "model": "Redmi Note 13 Pro+",
                "device": "phablet"
            },
            {
                "regex": "(?:24115RA8E[CGI])(?:[);/ ]|$)",
                "model": "Redmi Note 14 Pro+",
                "device": "phablet"
            },
            {
                "regex": "(?:24090RA29C|24116RACCG)(?:[);/ ]|$)",
                "model": "Redmi Note 14 Pro",
                "device": "phablet"
            },
            {
                "regex": "24090RA29[GI]",
                "model": "Redmi Note 14 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "2409(?:4RAD4[CIG])",
                "model": "Redmi Note 14 5G",
                "device": "phablet"
            },
            {
                "regex": "24117RN76[OLEG]",
                "model": "Redmi Note 14",
                "device": "phablet"
            },
            {
                "regex": "2502FRA65G",
                "model": "Redmi Note 14S",
                "device": "phablet"
            },
            {
                "regex": "25104RADAC",
                "model": "Redmi Note 15 Pro+",
                "device": "phablet"
            },
            {
                "regex": "25080RABDC",
                "model": "Redmi Note 15 Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:23090RA98[GI]|Redmi Note 13 Pro\\+ 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 13 Pro+ 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:2312DRAAB[CGI]|Redmi Note 13 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 13 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:2201116SC|Redmi Note 11E Pro)(?:[);/ ]|$)",
                "model": "Redmi Note 11E Pro",
                "device": "phablet"
            },
            {
                "regex": "(?:22041219C|Redmi Note 11E)(?:[);/ ]|$)",
                "model": "Redmi Note 11E",
                "device": "phablet"
            },
            {
                "regex": "(?:22041216C|Redmi Note 11T Pro)(?:[);/ ]|$)",
                "model": "Redmi Note 11T Pro",
                "device": "phablet"
            },
            {
                "regex": "22041216UC(?:[);/ ]|$)",
                "model": "Redmi Note 11T Pro+",
                "device": "phablet"
            },
            {
                "regex": "(?:2201116S[GR]|Redmi Note 11 Pro 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 11 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:2201116SI|Redmi Note 11 Pro\\+ 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 11 Pro+ 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:21091116U[CG]|Redmi Note 11 Pro\\+)(?:[);/ ]|$)",
                "model": "Redmi Note 11 Pro+",
                "device": "phablet"
            },
            {
                "regex": "21091116AC(?:[);/ ]|$)",
                "model": "Redmi Note 11 5G",
                "device": "phablet"
            },
            {
                "regex": "22095RA98C(?:[);/ ]|$)",
                "model": "Redmi Note 11R 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:21121119SC|2201117T[GILY]|Redmi Note 11 4G)(?:[);/ ]|$)",
                "model": "Redmi Note 11 4G",
                "device": "phablet"
            },
            {
                "regex": "(?:22087RA4DI|Redmi Note 11 SE)(?:[);/ ]|$)",
                "model": "Redmi Note 11 SE",
                "device": "phablet"
            },
            {
                "regex": "2201117S[GIYL]",
                "model": "Redmi Note 11S",
                "device": "phablet"
            },
            {
                "regex": "(?:22031116BG|Redmi Note 11S 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 11S 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:21091116(?:AI|I)|Redmi Note 11T 5G)(?:[);/ ]|$)",
                "model": "Redmi Note 11T 5G",
                "device": "phablet"
            },
            {
                "regex": "23013RK75C",
                "model": "Redmi Note 12 Pro 5G",
                "device": "phablet"
            },
            {
                "regex": "(?:M1908C3J[IH]|M1908C3JG)(?:[);/ ]|$)",
                "model": "Redmi Note 8",
                "device": "phablet"
            },
            {
                "regex": "(?:M1908C3JGG|Redmi Note 8 \\(2021\\)|biloba)(?:[);/ ]|$)",
                "model": "Redmi Note 8 (2021)",
                "device": "phablet"
            },
            {
                "regex": "(?:begonia|M1906G7G)(?:[);/ ]|$)",
                "model": "Redmi Note 8 Pro",
                "device": "phablet"
            },
            {
                "regex": "willow(?:[);/ ]|$)",
                "model": "Redmi Note 8T",
                "device": "phablet"
            },
            {
                "regex": "M1901F71(?:[);/ ]|$)",
                "model": "Redmi Note 7S",
                "device": "phablet"
            },
            {
                "regex": "M1901F7S(?:[);/ ]|$)",
                "model": "Redmi Note 7 Pro",
                "device": "phablet"
            },
            {
                "regex": "M1901F7G(?:[);/ ]|$)",
                "model": "Redmi Note 7",
                "device": "phablet"
            },
            {
                "regex": "Redmi Note (\\d+) Pro Max(?:[);/ ]|$)",
                "model": "Redmi Note $1 Pro Max",
                "device": "phablet"
            },
            {
                "regex": "Redmi Note (\\d+) Pro(?:[);/ ]|$)",
                "model": "Redmi Note $1 Pro",
                "device": "phablet"
            },
            {
                "regex": "Redmi[ _]Note[ _]([^;/) ]+)?",
                "model": "Redmi Note $1",
                "device": "phablet"
            },
            {
                "regex": "Redmi[ _]([^;/) ]+)?",
                "model": "Redmi $1"
            },
            {
                "regex": "MI_NOTE_Pro",
                "model": "Mi Note Pro",
                "device": "phablet"
            },
            {
                "regex": "Mi Note 10 Pro|M1910F4S(?:[);/ ]|$)",
                "model": "Mi Note 10 Pro",
                "device": "phablet"
            },
            {
                "regex": "Mi Note 10 Lite",
                "model": "Mi Note 10 Lite",
                "device": "phablet"
            },
            {
                "regex": "Mi Note 10|M1910F4G(?:[);/ ]|$)",
                "model": "Mi Note 10",
                "device": "phablet"
            },
            {
                "regex": "MI[ _]Note[ _]([^;/) ]+)?",
                "model": "Mi Note $1",
                "device": "phablet"
            },
            {
                "regex": "Qin 1s\\+",
                "model": "Qin 1s+"
            },
            {
                "regex": "MI[- ]One[ _]?Plus(?:[);/ ]|$)",
                "model": "Mi One Plus"
            },
            {
                "regex": "Mi[- ]One[ _]?([a-z0-9]+)?(?: Build|[);])",
                "model": "Mi One $1"
            },
            {
                "regex": "MI[ _]([^;/]*) Build",
                "model": "Mi $1"
            },
            {
                "regex": "MI[ _]([a-z0-9]+)(?:[);/ ]|$)",
                "model": "Mi $1"
            },
            {
                "regex": "HM Note ([^/;]+) (?:Build|MIUI)",
                "device": "phablet",
                "model": "Note"
            },
            {
                "regex": "HM ([^/;]+) (?:Build|MIUI)",
                "model": "HM $1"
            },
            {
                "regex": "Xiaomi[ _-]([^/;]+)(?: Build|$)",
                "model": "$1"
            }
        ]
    },
    "Xion": {
        "regex": "XI[_-]CE(?:655|U55|U[48])",
        "device": "smartphone",
        "models": [
            {
                "regex": "XI[_-]CE(655|U55|U[48])",
                "model": "CE$1"
            }
        ]
    },
    "Xolo": {
        "regex": "Xolo|(?:Q600|Q700s?|Q800|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5\\.[05]|Era5X|Era[ _]2[VX](?:[_ ]3GB)?|era[ _]X|era_HD|era[_ ]4[GK]|Era_4?X(?:_2GB)?|BLACK-1XM|A1000s_Lite|cube 5\\.0_2GB|Opus 3|era1X|era [2X]|era1Xpro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BLACK-?1XM?",
                "model": "Black 1X"
            },
            {
                "regex": "Era[ _]?1X ?Pro",
                "model": "Era 1X Pro"
            },
            {
                "regex": "Era[_ ]?([145])X(?:[);/ ]|$)",
                "model": "Era $1X"
            },
            {
                "regex": "Era_4X_2GB(?:[);/ ]|$)",
                "model": "Era 4X 2GB"
            },
            {
                "regex": "Era[ _]2V(?:[);/ ]|$)",
                "model": "Era 2V"
            },
            {
                "regex": "era[_ ](HD|4[GK]|2X?|X)",
                "model": "Era $1"
            },
            {
                "regex": "cube 5\\.0_2GB",
                "model": "Cube 5.0"
            },
            {
                "regex": "(Q600 Club|Q600|Q700s?|Q800|Q1000s Plus|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5\\.[05]|A1000s_Lite|Opus 3)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Xolo[ _]?([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Xolo[ _]?([a-z0-9_-]+)",
                "model": "$1"
            }
        ]
    },
    "Yarvik": {
        "regex": "Xenta[ -]Tab|Luna TAB|TAB09-410|TAB10-410|TAB07-485|TAB0[78]-200|TAB08-201-3G|TAB9-200|TAB09-211|TAB10-2[01]1|TAB13-201",
        "device": "tablet",
        "models": [
            {
                "regex": "Luna TAB07-920N",
                "model": "Luna 7"
            },
            {
                "regex": "Luna TAB07-10[01]",
                "model": "Luna 7c"
            },
            {
                "regex": "Luna TAB274",
                "model": "Luna 7c"
            },
            {
                "regex": "Luna TAB474",
                "model": "Luna 10"
            },
            {
                "regex": "Luna TAB10-150",
                "model": "Luna 10c"
            },
            {
                "regex": "TAB09-410",
                "model": "Noble 9.7"
            },
            {
                "regex": "TAB10-410",
                "model": "Noble 10.1"
            },
            {
                "regex": "TAB07-485",
                "model": "Noble Mini"
            },
            {
                "regex": "Xenta-TAB07-21[01]",
                "model": "Xenta 7c"
            },
            {
                "regex": "TAB07-200",
                "model": "Xenta 7ic"
            },
            {
                "regex": "TAB08-200",
                "model": "Xenta 8ic"
            },
            {
                "regex": "TAB08-201-3G",
                "model": "Xenta 8c"
            },
            {
                "regex": "TAB9-200",
                "model": "Xenta 9.7ic"
            },
            {
                "regex": "TAB09-211",
                "model": "Xenta 9.7ic+"
            },
            {
                "regex": "TAB10-2[01]1",
                "model": "Xenta 10ic"
            },
            {
                "regex": "TAB13-201",
                "model": "Xenta 13c"
            }
        ]
    },
    "Yes": {
        "regex": "M631Y|M685Y4|M651G_MY|YES (?:Altitude 4|MPY(?:48|54))",
        "device": "smartphone",
        "models": [
            {
                "regex": "M631Y",
                "model": "Altitude"
            },
            {
                "regex": "M651G_MY",
                "model": "Altitude 2"
            },
            {
                "regex": "M685Y4",
                "model": "Altitude 3"
            },
            {
                "regex": "YES (Altitude 4|MPY(?:48|54))",
                "model": "$1"
            }
        ]
    },
    "Yestel": {
        "regex": "yestel|(?:T5|T13|X2)_EEA(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "yestel P30(?:[);/ ]|$)",
                "model": "P30"
            },
            {
                "regex": "(X2|T5|T13)_EEA(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Yezz": {
        "regex": "Yezz|ANDY[ _]|(?: (?:4E4|5EQ)|A5EI|LIV[ _][13]S?|LIV1|LIV2[_ ]?LTE|ART ?[123](?:_?PRO|S)?|MAX_1_PLUS|MAX2 PLUS|EPIC T|GO ?[123])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:YEZZ[_-])?(4E4|5EQ|A4M|A5EI)",
                "model": "Andy $1"
            },
            {
                "regex": "Yezz-AC4EI",
                "model": "Andy 4EI"
            },
            {
                "regex": "ART1_PRO",
                "model": "Art 1 Pro"
            },
            {
                "regex": "ART1",
                "model": "Art 1"
            },
            {
                "regex": "ART2PRO",
                "model": "Art 2 Pro"
            },
            {
                "regex": "ART 3S",
                "model": "Art 3S"
            },
            {
                "regex": "EPIC T",
                "model": "Epic T"
            },
            {
                "regex": "GO ?([123])",
                "model": "GO $1"
            },
            {
                "regex": "LIV1",
                "model": "LIV1"
            },
            {
                "regex": "LIV 3S LTE",
                "model": "LIV 3S LTE"
            },
            {
                "regex": "LIV[ _]([13])S",
                "model": "LIV $1S"
            },
            {
                "regex": "LIV 3 LTE",
                "model": "LIV 3 LTE"
            },
            {
                "regex": "LIV2[_ ]?LTE",
                "model": "LIV2 LTE"
            },
            {
                "regex": "MAX_1_PLUS",
                "model": "Max 1 Plus"
            },
            {
                "regex": "MAX2 PLUS",
                "model": "Max 2 Plus"
            },
            {
                "regex": "Andy[ _]([A-Z]*[0-9]\\.[0-9][A-Z0-9]*)(?:[ _](LTE))?",
                "model": "Andy $1 $2"
            },
            {
                "regex": "Andy[ _]([A-Z]*[0-9])([0-9][A-Z0-9]*)(?:[ _](LTE))?",
                "model": "Andy $1.$2 $3"
            },
            {
                "regex": "Andy[ _]([A-Z]*[0-9][A-Z0-9]+)(?:[ _](LTE))?",
                "model": "Andy $1 $2"
            }
        ]
    },
    "YU Fly": {
        "regex": "YU Fly (\\w+)",
        "device": "smartphone",
        "model": "$1"
    },
    "Yu": {
        "regex": "(?:YU5[05]10[A]?|YU(?:4711|5200|5050|501[14]|5551)|AO5510|YU Yureka Black|YU 6000)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YU5010[A]?",
                "model": "Yuphoria"
            },
            {
                "regex": "YU5011",
                "model": "Yunique 2"
            },
            {
                "regex": "YU5050",
                "model": "Yutopia"
            },
            {
                "regex": "AO5510",
                "model": "Yureka"
            },
            {
                "regex": "YU5200",
                "model": "Yureka S"
            },
            {
                "regex": "YU5551",
                "model": "Yureka 2"
            },
            {
                "regex": "YU5510[A]?",
                "model": "Yureka Plus"
            },
            {
                "regex": "YU4711",
                "model": "Yunique"
            },
            {
                "regex": "YU5014",
                "model": "Ace"
            },
            {
                "regex": "YU 6000",
                "model": "Yureka Note"
            },
            {
                "regex": "YU (Yureka Black)",
                "model": "$1"
            }
        ]
    },
    "Yuandao": {
        "regex": "(?:N101[ _]DUAL(?:[ _]CORE)?(?:[ _]?2)?(?:[ _]V11)?|N70 DUAL CORE)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "N(101|70)[ _]DUAL(?:[ _]CORE)?(?:[ _]?2)?",
                "model": "N$1"
            }
        ]
    },
    "Yusun": {
        "regex": "Yusun|LA2-T",
        "device": "smartphone",
        "models": [
            {
                "regex": "LA2-T",
                "model": "LA2-T"
            },
            {
                "regex": "Yusun ([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Yusun ([a-z0-9_\\-\\+]+)",
                "model": "$1"
            }
        ]
    },
    "Ytone": {
        "regex": "YTONE[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "YTONE[ _-]?([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "YTONE[ _-]?([^);/ ]+)",
                "model": "$1"
            }
        ]
    },
    "Zonda": {
        "regex": "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)|ZA409",
        "device": "feature phone",
        "models": [
            {
                "regex": "ZA409",
                "device": "smartphone",
                "model": "Muzic"
            },
            {
                "regex": "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "ZYQ": {
        "regex": "ZYQ-Q88|(Q(?:2602|262[436]|638|2688|272[89]|3022|3623|TAB Tab4|328 m9|328|668)|J77|Q[._](?:Up|Boss P99|Dee R09|Good M9|Hi|Hot|Me|Mate R99|Next|TOP-X8|You))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Q638",
                "model": "I7"
            },
            {
                "regex": "Q2624",
                "model": "Cheer 3G"
            },
            {
                "regex": "Q2602",
                "model": "TV Next"
            },
            {
                "regex": "Q2728",
                "model": "Zone 3G"
            },
            {
                "regex": "Q2729",
                "model": "Q2729"
            },
            {
                "regex": "Q2688",
                "model": "Q2688"
            },
            {
                "regex": "Q2623",
                "model": "Win 3G"
            },
            {
                "regex": "Q2626",
                "model": "Care 3G"
            },
            {
                "regex": "Q3623",
                "model": "Braw 3G"
            },
            {
                "regex": "Q3022",
                "model": "Q3022"
            },
            {
                "regex": "Q328 m9",
                "model": "Q328 M9"
            },
            {
                "regex": "Q328",
                "model": "Speed 3G"
            },
            {
                "regex": "Q668",
                "model": "TV I4"
            },
            {
                "regex": "J77",
                "model": "Q.Dee"
            },
            {
                "regex": "Q\\.Up C5",
                "model": "Q.Up C5"
            },
            {
                "regex": "Q\\.Up",
                "model": "Q.Up"
            },
            {
                "regex": "Q\\.Boss P99",
                "model": "Q.Boss P99"
            },
            {
                "regex": "Q[._]Dee R09",
                "model": "Q.Dee R09"
            },
            {
                "regex": "Q\\.Good M9",
                "model": "Q.Good M9"
            },
            {
                "regex": "Q[._]Hi S1",
                "model": "Q.Hi S1"
            },
            {
                "regex": "Q[._]Hi",
                "model": "Q.Hi"
            },
            {
                "regex": "Q[._]Hot P7 3G",
                "model": "Q.Hot P7 3G"
            },
            {
                "regex": "Q[._]Hot",
                "model": "Q.Hot"
            },
            {
                "regex": "Q[._]Me Phone7 3G",
                "model": "Q.Me Phone 7 3G"
            },
            {
                "regex": "Q[._]Me Plus7",
                "model": "Q.Me Plus 7"
            },
            {
                "regex": "Q[._]Me",
                "model": "Q.Me"
            },
            {
                "regex": "Q[._]Mate R99",
                "model": "Q.Mate R99"
            },
            {
                "regex": "Q[._]Next B7",
                "model": "Q.Next B7"
            },
            {
                "regex": "Q[._]Next J2",
                "model": "Q.Next J2"
            },
            {
                "regex": "Q[._]TOP-X8",
                "model": "Q.Top X8"
            },
            {
                "regex": "Q[._]You",
                "model": "Q.You"
            },
            {
                "regex": "QTAB Tab4",
                "model": "QTab Tab4",
                "device": "tablet"
            },
            {
                "regex": "ZYQ-Q88",
                "model": "Q88",
                "device": "tablet"
            }
        ]
    },
    "Vivax": {
        "regex": "VIVAX|(?:Fly4|Fly5[_ ]Lite|Fun[_ ]S500|Point[_ ](?:X[12]|X50[123]|X450)|SMART FLY V500|PRO3|32LE77SM|40LE77SM|FUN S1|FUN_S20|TPC[-_ ](?:7121|80[56])3G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fly5[_ ]Lite(?:[);/ ]|$)",
                "model": "Fly 5 Lite"
            },
            {
                "regex": "Fly4(?:[);/ ]|$)",
                "model": "Fly 4"
            },
            {
                "regex": "SMART FLY V500(?:[);/ ]|$)",
                "model": "Smart Fly V500"
            },
            {
                "regex": "Point_X([12])(?:[);/ ]|$)",
                "model": "Point X$1"
            },
            {
                "regex": "Fun[_ ]S500(?:[);/ ]|$)",
                "model": "Fun S500"
            },
            {
                "regex": "FUN[ _]S(10?|20)(?:[);/ ]|$)",
                "model": "Fun S$1"
            },
            {
                "regex": "VIVAX[ _]Fly ?(\\d)(?:[);/ ]|$)",
                "model": "Fly $1"
            },
            {
                "regex": "VIVAX[ _]Fly[ _]V(1|550)(?:[);/ ]|$)",
                "model": "Fly V$1"
            },
            {
                "regex": "(?:VIVAX )?(Point[ _](?:X551|X50[123]|X450))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SMART Point X5010(?:[);/ ]|$)",
                "model": "Smart Point X5010"
            },
            {
                "regex": "VIVAX[_ ]PRO[_ ]?(3|M1)",
                "model": "Pro $1"
            },
            {
                "regex": "(?:VIVAX[ _])?TPC[-_ ](105|7121|806)_?([34])G",
                "model": "TPC-$1 $2G",
                "device": "tablet"
            },
            {
                "regex": "(?:TABLET )?TPC[-_ ](\\d+) ?([34])G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "TPC-$1 $2G"
            },
            {
                "regex": "(?:VIVAX-)?(40LE78T2S2SM|32LE77SM|40LE77SM)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "MLS": {
        "regex": "IQ(?:0705|L550|1017|1010w?|1012N?|1019N|1025|1060M|1380|1401|1436|1452a|1453|1470|1502a|1511|155[23]|1568|1570|1805N|180[68]|1810B_M|1832|1850|1890|5017|L626|9610|181011N|A27X_E|E[12]00|EL41|G550|GW516|L30|L5[01]|M801|M1001|N700|P50|R300|S300|S801|S1001|W503|W511T|W553N?|W60[38]|W626|M960|D10S|D700|9013_4N|F 200|T800)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IQ0705(?:[);/ ]|$)",
                "model": "iQTalk Twist"
            },
            {
                "regex": "IQL550(?:[);/ ]|$)",
                "model": "Notch Lite"
            },
            {
                "regex": "iQD10S(?:[);/ ]|$)",
                "model": "Notch Sense"
            },
            {
                "regex": "IQ1010W?(?:[);/ ]|$)",
                "model": "iQTab 10",
                "device": "tablet"
            },
            {
                "regex": "IQ1012N?(?:[);/ ]|$)",
                "model": "iQTab Brave 3G",
                "device": "tablet"
            },
            {
                "regex": "IQ1025(?:[);/ ]|$)",
                "model": "iQTab Action 4G",
                "device": "tablet"
            },
            {
                "regex": "iQ9013_4N(?:[);/ ]|$)",
                "model": "Life 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "IQ1019N(?:[);/ ]|$)",
                "model": "Alu Plus 4G 10.1\"",
                "device": "tablet"
            },
            {
                "regex": "iQ1805N(?:[);/ ]|$)",
                "model": "iQTab Ideal 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "iQ181011N(?:[);/ ]|$)",
                "model": "iQTab Care 8.0\"",
                "device": "tablet"
            },
            {
                "regex": "IQ1380(?:[);/ ]|$)",
                "model": "Brain 3G"
            },
            {
                "regex": "IQ1401(?:[);/ ]|$)",
                "model": "iQTalk Verse 4G"
            },
            {
                "regex": "IQ1436(?:[);/ ]|$)",
                "model": "Color mini 4G"
            },
            {
                "regex": "IQ1452a(?:[);/ ]|$)",
                "model": "TOP-S 4G"
            },
            {
                "regex": "IQ1453(?:[);/ ]|$)",
                "model": "Trend 4G"
            },
            {
                "regex": "IQ1470(?:[);/ ]|$)",
                "model": "iQTalk Onyx"
            },
            {
                "regex": "IQ1502a(?:[);/ ]|$)",
                "model": "iQTalk Flame"
            },
            {
                "regex": "IQ1511(?:[);/ ]|$)",
                "model": "iQTalk Spicy"
            },
            {
                "regex": "IQ1552(?:[);/ ]|$)",
                "model": "iQTalk Titan 4G"
            },
            {
                "regex": "IQ1553(?:[);/ ]|$)",
                "model": "Color 3 4G"
            },
            {
                "regex": "IQ1568(?:[);/ ]|$)",
                "model": "Range 4G"
            },
            {
                "regex": "IQ1570(?:[);/ ]|$)",
                "model": "iQTalk Color 5.5 4G"
            },
            {
                "regex": "IQ1806(?:[);/ ]|$)",
                "model": "iQTab Rose",
                "device": "tablet"
            },
            {
                "regex": "IQ1808(?:[);/ ]|$)",
                "model": "iQTab Master",
                "device": "tablet"
            },
            {
                "regex": "IQ1810B_M(?:[);/ ]|$)",
                "model": "iQTab Novel 3G",
                "device": "tablet"
            },
            {
                "regex": "IQ1832(?:[);/ ]|$)",
                "model": "Jet 3G",
                "device": "tablet"
            },
            {
                "regex": "iQ1017(?:[);/ ]|$)",
                "model": "Trophy 4G",
                "device": "tablet"
            },
            {
                "regex": "IQ1850(?:[);/ ]|$)",
                "model": "Diamond 5.2 4G"
            },
            {
                "regex": "IQ1890(?:[);/ ]|$)",
                "model": "iQTalk Aura"
            },
            {
                "regex": "IQ5017(?:[);/ ]|$)",
                "model": "Slice 4G"
            },
            {
                "regex": "IQ9610(?:[);/ ]|$)",
                "model": "Angel 3G",
                "device": "tablet"
            },
            {
                "regex": "iQM960(?:[);/ ]|$)",
                "model": "Angel 3G (2018)",
                "device": "tablet"
            },
            {
                "regex": "iQS801(?:[);/ ]|$)",
                "model": "Vital 4G",
                "device": "tablet"
            },
            {
                "regex": "IQG550(?:[);/ ]|$)",
                "model": "Style 4G"
            },
            {
                "regex": "IQGW516(?:[);/ ]|$)",
                "model": "F5"
            },
            {
                "regex": "IQE100(?:[);/ ]|$)",
                "model": "Energy 4G"
            },
            {
                "regex": "iQE200(?:[);/ ]|$)",
                "model": "MX 4G"
            },
            {
                "regex": "iQA27X_E(?:[);/ ]|$)",
                "model": "MX (2019)"
            },
            {
                "regex": "IQEL41(?:[);/ ]|$)",
                "model": "Fab 4G"
            },
            {
                "regex": "IQL30(?:[);/ ]|$)",
                "model": "Status 4G"
            },
            {
                "regex": "IQL50(?:[);/ ]|$)",
                "model": "More 4G"
            },
            {
                "regex": "IQL51(?:[);/ ]|$)",
                "model": "Wave 4G"
            },
            {
                "regex": "IQM801(?:[);/ ]|$)",
                "model": "Brace 2018 4G",
                "device": "tablet"
            },
            {
                "regex": "IQM1001(?:[);/ ]|$)",
                "model": "Level 4G",
                "device": "tablet"
            },
            {
                "regex": "IQN700(?:[);/ ]|$)",
                "model": "Inspire 4G"
            },
            {
                "regex": "IQP50(?:[);/ ]|$)",
                "model": "Ruby 4G"
            },
            {
                "regex": "IQS300(?:[);/ ]|$)",
                "model": "DX 4G"
            },
            {
                "regex": "IQS1001(?:[);/ ]|$)",
                "model": "Vista 4G",
                "device": "tablet"
            },
            {
                "regex": "iQ1060M(?:[);/ ]|$)",
                "model": "Space S 4G",
                "device": "tablet"
            },
            {
                "regex": "IQR300(?:[);/ ]|$)",
                "model": "R3 4G"
            },
            {
                "regex": "IQW608(?:[);/ ]|$)",
                "model": "Regal"
            },
            {
                "regex": "iQW603(?:[);/ ]|$)",
                "model": "Phab 6.0\"",
                "device": "phablet"
            },
            {
                "regex": "IQW626(?:[);/ ]|$)",
                "model": "D6 4G"
            },
            {
                "regex": "IQW511T(?:[);/ ]|$)",
                "model": "Liberal"
            },
            {
                "regex": "IQW553N?(?:[);/ ]|$)",
                "model": "Alu 5.5\""
            },
            {
                "regex": "iQL626?(?:[);/ ]|$)",
                "model": "Pop 4G"
            },
            {
                "regex": "IQW503(?:[);/ ]|$)",
                "model": "Flame 4G (2018)"
            },
            {
                "regex": "iQD700(?:[);/ ]|$)",
                "model": "Color Fingerprint 4G"
            },
            {
                "regex": "iQT800(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T8 Fingerprint 4G"
            },
            {
                "regex": "iQF ?200(?:[);/ ]|$)",
                "model": "iQF200"
            }
        ]
    },
    "MMI": {
        "regex": "MMI, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": "$1"
    },
    "FLYCAT": {
        "regex": "FLYCAT",
        "device": "smartphone",
        "models": [
            {
                "regex": "OPTIMUM (500[1-4]|5501)",
                "model": "Optimum $1"
            },
            {
                "regex": "UNICUM (1002|8S|8003)",
                "device": "tablet",
                "model": "Unicum $1"
            }
        ]
    },
    "Fly": {
        "regex": "(?<!GI |SMART )Fly(?!Flow|touch)|Power Plus 5000|Power Plus 3|Photo Pro|Slimline|Cirrus (?:6|13)|Life (?:Ace|Jet|Sky|Compact 4G|Geo|Zen|Play)|(?:lineage_)?FS50[1-9]|FS51[0-8]|FS52[0-9]|FS530|FS55[134]|FS40[1-9]|FS45[1-9]|4FS06|MERIDIAN-|(?:Phoenix 2|(?:IQ(?!10[134]0)[0-9]{3,}[i]?)[ _]?(?:Quad|Firebird|Quattro|Turbo|Magic)?|Tornado Slim|Android 8(?:[\\d.]*);(?: [\\w-]+;)? View Max)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Fly_)?IQ310(?:[);/ ]|$)",
                "model": "Panorama",
                "device": "tablet"
            },
            {
                "regex": "(?:Fly_)?IQ236(?:[);/ ]|$)",
                "model": "Victory"
            },
            {
                "regex": "(?:Fly_)?View Max(?:[);/ ]|$)",
                "model": "View Max"
            },
            {
                "regex": "Slimline(?:[);/ ]|$)",
                "model": "Slimline"
            },
            {
                "regex": "Power Plus 5000(?:[);/ ]|$)",
                "model": "Power Plus 5000"
            },
            {
                "regex": "Photo Pro(?:[);/ ]|$)",
                "model": "Photo Pro"
            },
            {
                "regex": "Life Ace(?:[);/ ]|$)",
                "model": "Life Ace"
            },
            {
                "regex": "Life Jet(?:[);/ ]|$)",
                "model": "Life Jet"
            },
            {
                "regex": "Life Sky(?:[);/ ]|$)",
                "model": "Life Sky"
            },
            {
                "regex": "Life Geo(?:[);/ ]|$)",
                "model": "Life Geo"
            },
            {
                "regex": "Life Zen(?:[);/ ]|$)",
                "model": "Life Zen"
            },
            {
                "regex": "Life Play(?:[);/ ]|$)",
                "model": "Life Play"
            },
            {
                "regex": "Life Buzz(?:[);/ ]|$)",
                "model": "Life Buzz"
            },
            {
                "regex": "Life Compact 4G(?:[);/ ]|$)",
                "model": "Life Compact 4G"
            },
            {
                "regex": "FS506",
                "model": "Cirrus 3"
            },
            {
                "regex": "FS403",
                "model": "Cumulus 1"
            },
            {
                "regex": "FS508|Cirrus 6",
                "model": "Cirrus 6"
            },
            {
                "regex": "FS511",
                "model": "Cirrus 7"
            },
            {
                "regex": "FS509",
                "model": "Nimbus 9"
            },
            {
                "regex": "FS406",
                "model": "Stratus 5"
            },
            {
                "regex": "FS404",
                "model": "Stratus 3"
            },
            {
                "regex": "(?:lineage_)?FS504",
                "model": "Cirrus 2"
            },
            {
                "regex": "FS407",
                "model": "Stratus 6"
            },
            {
                "regex": "FS401",
                "model": "Stratus 1"
            },
            {
                "regex": "FS402",
                "model": "Stratus 2"
            },
            {
                "regex": "FS501",
                "model": "Nimbus 3"
            },
            {
                "regex": "FS502",
                "model": "Cirrus 1"
            },
            {
                "regex": "FS507",
                "model": "Cirrus 4"
            },
            {
                "regex": "FS505",
                "model": "Nimbus 7"
            },
            {
                "regex": "FS551",
                "model": "Nimbus 4"
            },
            {
                "regex": "FS514",
                "model": "Cirrus 8"
            },
            {
                "regex": "FS553",
                "model": "Cirrus 9"
            },
            {
                "regex": "FS554",
                "model": "Power Plus FHD"
            },
            {
                "regex": "Power Plus 3",
                "model": "Power Plus 3"
            },
            {
                "regex": "FS517",
                "model": "Cirrus 11"
            },
            {
                "regex": "FS516",
                "model": "Cirrus 12"
            },
            {
                "regex": "FS518|Cirrus 13",
                "model": "Cirrus 13"
            },
            {
                "regex": "FS520",
                "model": "Selfie 1"
            },
            {
                "regex": "FS521",
                "model": "Power Plus 1"
            },
            {
                "regex": "FS522",
                "model": "Cirrus 14"
            },
            {
                "regex": "FS523",
                "model": "Cirrus 16"
            },
            {
                "regex": "FS524",
                "model": "Knockout"
            },
            {
                "regex": "FS526",
                "model": "Power Plus 2"
            },
            {
                "regex": "FS527",
                "model": "Nimbus 17"
            },
            {
                "regex": "FS528",
                "model": "Memory Plus"
            },
            {
                "regex": "FS529",
                "model": "Champ"
            },
            {
                "regex": "FS530",
                "model": "Power Plus XXL"
            },
            {
                "regex": "FS454",
                "model": "Nimbus 8"
            },
            {
                "regex": "FS452",
                "model": "Nimbus 2"
            },
            {
                "regex": "FS512",
                "model": "Nimbus 10"
            },
            {
                "regex": "FS510",
                "model": "Nimbus 12"
            },
            {
                "regex": "FS451",
                "model": "Nimbus 1"
            },
            {
                "regex": "FS405",
                "model": "Stratus 4"
            },
            {
                "regex": "FS408",
                "model": "Stratus 8"
            },
            {
                "regex": "FS409",
                "model": "Stratus 9"
            },
            {
                "regex": "FS455",
                "model": "Nimbus 11"
            },
            {
                "regex": "FS456",
                "model": "Nimbus 14"
            },
            {
                "regex": "FS457",
                "model": "Nimbus 15"
            },
            {
                "regex": "FS459",
                "model": "Nimbus 16"
            },
            {
                "regex": "FS458",
                "model": "Stratus 7"
            },
            {
                "regex": "(?:Fly_)?IQ237(?:[);/ ]|$)",
                "model": "Dynamic"
            },
            {
                "regex": "(?:Fly_)?IQ238(?:[);/ ]|$)",
                "model": "Jazz"
            },
            {
                "regex": "(?:Fly_)?IQ240(?:[);/ ]|$)",
                "model": "Whizz"
            },
            {
                "regex": "(?:Fly_)?IQ255(?:[);/ ]|$)",
                "model": "Pride"
            },
            {
                "regex": "(?:Fly_)?IQ270(?: Firebird)?(?:[);/ ]|$)",
                "model": "Firebird"
            },
            {
                "regex": "(?:Fly_)?IQ275(?:[);/ ]|$)",
                "model": "Marathon"
            },
            {
                "regex": "(?:Fly_)?IQ285(?: Turbo)?(?:[);/ ]|$)",
                "model": "Turbo"
            },
            {
                "regex": "(?:Fly_)?IQ430(?:[);/ ]|$)",
                "model": "Evoke"
            },
            {
                "regex": "(?:Fly_)?IQ431(?:[);/ ]|$)",
                "model": "Glory"
            },
            {
                "regex": "(?:Fly_)?IQ432(?:[);/ ]|$)",
                "model": "Era Nano 1"
            },
            {
                "regex": "(?:Fly_)?IQ436(?:[);/ ]|$)",
                "model": "Era Nano 3"
            },
            {
                "regex": "(?:Fly_)?IQ4490(?:[);/ ]|$)",
                "model": "Era Nano 4"
            },
            {
                "regex": "(?:Fly_)?IQ434(?:[);/ ]|$)",
                "model": "Era Nano 5"
            },
            {
                "regex": "(?:Fly_)?IQ4406(?:[);/ ]|$)",
                "model": "Era Nano 6"
            },
            {
                "regex": "(?:Fly_)?IQ436i(?:[);/ ]|$)",
                "model": "Era Nano 9"
            },
            {
                "regex": "(?:Fly_)?IQ4490i(?:[);/ ]|$)",
                "model": "Era Nano 10"
            },
            {
                "regex": "(?:Fly_)?IQ440(?:[);/ ]|$)",
                "model": "Energy"
            },
            {
                "regex": "(?:Fly_)?IQ4401(?:[);/ ]|$)",
                "model": "Era Energy 2"
            },
            {
                "regex": "(?:Fly_)?IQ441(?:[);/ ]|$)",
                "model": "Radiance"
            },
            {
                "regex": "(?:Fly_)?IQ442 Quad(?:[);/ ]|$)",
                "model": "Miracle 2"
            },
            {
                "regex": "(?:Fly_)?IQ442(?:[);/ ]|$)",
                "model": "Miracle"
            },
            {
                "regex": "(?:Fly_)?IQ443(?:[);/ ]|$)",
                "model": "Trend"
            },
            {
                "regex": "(?:Fly_)?IQ444(?: Quattro)?(?:[);/ ]|$)",
                "model": "Diamond 2"
            },
            {
                "regex": "(?:Fly_)?IQ445(?:[);/ ]|$)",
                "model": "Genius"
            },
            {
                "regex": "(?:Fly_)?IQ446(?: Magic)?(?:[);/ ]|$)",
                "model": "Magic"
            },
            {
                "regex": "(?:Fly_)?IQ447(?:[);/ ]|$)",
                "model": "Era Life 1"
            },
            {
                "regex": "(?:Fly_)?IQ456(?:[);/ ]|$)",
                "model": "Era Life 2"
            },
            {
                "regex": "(?:Fly_)?IQ4409 Quad(?:[);/ ]|$)",
                "model": "Era Life 4"
            },
            {
                "regex": "(?:Fly_)?IQ448(?:[);/ ]|$)",
                "model": "Chic"
            },
            {
                "regex": "(?:Fly_)?IQ449(?:[);/ ]|$)",
                "model": "Pronto"
            },
            {
                "regex": "(?:Fly_)?IQ450(?:[);/ ]|$)",
                "model": "Horizon"
            },
            {
                "regex": "(?:Fly_)?IQ450[ _]Quattro(?:[);/ ]|$)",
                "model": "Horizon 2"
            },
            {
                "regex": "(?:Fly_)?IQ451(?:[);/ ]|$)",
                "model": "Vista"
            },
            {
                "regex": "(?:Fly_)?IQ452 Quad(?:[);/ ]|$)",
                "model": "Ego Vision 1"
            },
            {
                "regex": "(?:Fly_)?IQ454(?:[);/ ]|$)",
                "model": "Evo Tech 1"
            },
            {
                "regex": "(?:Fly_)?IQ4403(?:[);/ ]|$)",
                "model": "Energy 3"
            },
            {
                "regex": "(?:Fly_)?IQ4404(?:[);/ ]|$)",
                "model": "Spark"
            },
            {
                "regex": "(?:Fly_)?IQ4410 Quad(?:[);/ ]|$)",
                "model": "Phoenix"
            },
            {
                "regex": "Phoenix 2(?:[);/ ]|$)",
                "model": "Phoenix 2"
            },
            {
                "regex": "(?:Fly_)?IQ4411(?:[);/ ]|$)",
                "model": "Energy 2"
            },
            {
                "regex": "(?:Fly_)?IQ4412 Quad(?:[);/ ]|$)",
                "model": "Coral"
            },
            {
                "regex": "(?:Fly_)?IQ4413[ _]Quad(?:[);/ ]|$)",
                "model": "Evo Chic 3"
            },
            {
                "regex": "(?:Fly_)?IQ4414 Quad(?:[);/ ]|$)",
                "model": "Evo Tech 3"
            },
            {
                "regex": "(?:Fly_)?IQ4415 Quad(?:[);/ ]|$)",
                "model": "Era Style 3"
            },
            {
                "regex": "(?:Fly_)?IQ4418(?:[);/ ]|$)",
                "model": "Era Style 4"
            },
            {
                "regex": "(?:Fly_)?IQ4504 Quad(?:[);/ ]|$)",
                "model": "Evo Energy 5"
            },
            {
                "regex": "Tornado Slim(?:[);/ ]|$)",
                "model": "Tornado Slim"
            },
            {
                "regex": "(?:Fly_)?IQ([0-9]+[i]? ?(?:Quad|Firebird|Quattro)?)(?:[);/ ]|$)",
                "model": "IQ$1"
            },
            {
                "regex": "Fly[ _-]?([a-z0-9_]+)/",
                "model": "$1",
                "device": "feature phone"
            },
            {
                "regex": "Flylife[ _-]?([^/;]+)(?: Build|[;)])",
                "model": "Flylife $1",
                "device": "tablet"
            },
            {
                "regex": "Fly[ _-]?([a-z0-9]+)",
                "model": "$1"
            },
            {
                "regex": "MERIDIAN-([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "FinePower": {
        "regex": "FinePower[_ ]?([AB][1-9]|[CD][1-9])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "FinePower[_ ]?([AB][1-9])(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "FinePower[_ ]?([CD][1-9])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Freetel": {
        "regex": "(?:FUN PLUS|Fun \\+|FTJ17[AC]00|FTJ152[ABCD]|FTU18A00|FT141B|FT142D(?:_LTEXM)?|FT142A?|FTJ161[ABE](?:-VN)?|FTJ1[56]2E|FTJ162[BD]|FT162D|FTE161[GE]|SAKURA_FTE1|FTE171A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fun \\+",
                "model": "Fun +"
            },
            {
                "regex": "FTJ152C",
                "model": "Samurai Miyabi"
            },
            {
                "regex": "FTJ17A00(?:[);/ ]|$)",
                "model": "Rei 2 Dual"
            },
            {
                "regex": "FTJ17C00(?:[);/ ]|$)",
                "model": "Priori 5"
            },
            {
                "regex": "FTU18A00(?:[);/ ]|$)",
                "model": "Cricket Wave"
            },
            {
                "regex": "FTJ161A",
                "model": "Musashi"
            },
            {
                "regex": "FTE171A",
                "model": "Ice 3"
            },
            {
                "regex": "FTE161E|FTJ161E",
                "model": "Ice 2"
            },
            {
                "regex": "FTE161G",
                "model": "Ice 2 Plus"
            },
            {
                "regex": "FTJ162E",
                "model": "Raijin"
            },
            {
                "regex": "FT141B",
                "model": "Nico"
            },
            {
                "regex": "FT142D(?:_LTEXM)?(?:[);/ ]|$)",
                "model": "XM"
            },
            {
                "regex": "FT142A?",
                "model": "Priori 2"
            },
            {
                "regex": "FTJ152A",
                "model": "Priori 3"
            },
            {
                "regex": "FTJ?162D",
                "model": "Priori 4"
            },
            {
                "regex": "FTJ152B",
                "model": "Priori 3S LTE"
            },
            {
                "regex": "FTJ152D",
                "model": "Samurai Kiwami"
            },
            {
                "regex": "FTJ162B",
                "model": "Samurai Kiwami 2"
            },
            {
                "regex": "FTJ161B",
                "model": "Samurai Rei"
            },
            {
                "regex": "FTJ152E",
                "model": "Katana 1"
            },
            {
                "regex": "SAKURA_FTE1",
                "model": "Sakura FTE1"
            },
            {
                "regex": "FUN PLUS",
                "model": "Fun Plus"
            }
        ]
    },
    "Western Digital": {
        "regex": "Westerndigital|WDSimpleBrowser",
        "device": "tv",
        "models": [
            {
                "regex": "Streamer2010",
                "model": "Streamer (2010)"
            }
        ]
    },
    "Zeemi": {
        "regex": "ZEEMI[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZEEMI[ _-]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "ZEEMI[ _-]([^/;)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Zenek": {
        "regex": "Z5007|Z551[679]|Z6001",
        "device": "smartphone",
        "models": [
            {
                "regex": "Z5517",
                "model": "Leopardo"
            },
            {
                "regex": "Z6001",
                "model": "Libelula"
            },
            {
                "regex": "Z5007",
                "model": "Oso"
            },
            {
                "regex": "Z5519",
                "model": "Ping\xfbino"
            },
            {
                "regex": "Z5516",
                "model": "Zebra"
            }
        ]
    },
    "Nubia": {
        "regex": "Nubia[ _]|(?:NX(?:302J|403A|404H|406E|40[X2]|503A|50[5678]J|51[0123]J|521J|523J_V1|529Jq?|5[345]1J|5[48]9J|569[HJ]|5[67]3J|575J|59[157]J|60[1689]J|61[12679]J|62[79]J|65[19]J|6[126]9J|66[67]J|679[JS]|70[129]J|71[123]J|72[1459]J|73[367]J|769J|779J|709S|907J|789J)|NP0[13]J|Z235[12]N|Z6255CA|Z2353|Z246[45]N)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NP0[13]J",
                "device": "tablet",
                "model": "Red Magic Gaming Pad"
            },
            {
                "regex": "Z6255CA",
                "model": "Blade A72"
            },
            {
                "regex": "NX724J",
                "model": "Flip 5G"
            },
            {
                "regex": "Z246[45]N",
                "model": "Neo 3 GT 5G"
            },
            {
                "regex": "8150N",
                "model": "Neo 5G"
            },
            {
                "regex": "Z2352N",
                "model": "Neo 2 5G"
            },
            {
                "regex": "Z2353",
                "model": "Music"
            },
            {
                "regex": "Z2460",
                "model": "Music 2"
            },
            {
                "regex": "Z2351N",
                "model": "Focus Pro 5G"
            },
            {
                "regex": "NX302J",
                "model": "Focus 5G"
            },
            {
                "regex": "NX711J",
                "model": "Z50"
            },
            {
                "regex": "NX712J",
                "model": "Z50 Ultra"
            },
            {
                "regex": "NX713J",
                "model": "Z50S Pro"
            },
            {
                "regex": "NX721J",
                "model": "Z60 Ultra"
            },
            {
                "regex": "NX667J",
                "model": "Z30 Pro"
            },
            {
                "regex": "NX701J",
                "model": "Z40 Pro"
            },
            {
                "regex": "NX702J",
                "model": "Z40s Pro"
            },
            {
                "regex": "NX733J",
                "model": "Z70 Ultra"
            },
            {
                "regex": "NX737J",
                "model": "Z70s Ultra"
            },
            {
                "regex": "NX736J",
                "model": "Z70 Ultra Starry Night"
            },
            {
                "regex": "NX709J",
                "model": "Red Magic 7 Pro"
            },
            {
                "regex": "NX729J",
                "model": "Red Magic 8 Pro"
            },
            {
                "regex": "NX769J",
                "model": "Red Magic 9 Pro"
            },
            {
                "regex": "NX789J",
                "model": "Red Magic 10 Pro"
            },
            {
                "regex": "NX779J",
                "model": "Red Magic 10 Air"
            },
            {
                "regex": "NX709S",
                "model": "Red Magic 7S Pro"
            },
            {
                "regex": "NX679[JS]",
                "model": "Red Magic 7"
            },
            {
                "regex": "NX669J",
                "model": "Red Magic 6"
            },
            {
                "regex": "NX666J",
                "model": "Red Magic 6R"
            },
            {
                "regex": "NX619J",
                "model": "Red Magic Mars"
            },
            {
                "regex": "NX629J",
                "model": "Red Magic 3"
            },
            {
                "regex": "NX40[X2]",
                "model": "Z5 Mini"
            },
            {
                "regex": "NX(403[AE]|406E|404H)",
                "model": "Z5S Mini"
            },
            {
                "regex": "NX503A",
                "model": "Z5S"
            },
            {
                "regex": "NX506J",
                "model": "Z7"
            },
            {
                "regex": "NX507J",
                "model": "Z7 Mini"
            },
            {
                "regex": "NX505J",
                "model": "Z7 Max"
            },
            {
                "regex": "NX508J",
                "model": "Z9"
            },
            {
                "regex": "(NX5[12]1J|Nubia Z9 mini)",
                "model": "Z9 Mini"
            },
            {
                "regex": "(NX510J|Nubia Z9 Max)",
                "model": "Z9 Max"
            },
            {
                "regex": "NX512J",
                "model": "Z9 Max Dual"
            },
            {
                "regex": "NX531J",
                "model": "Z11"
            },
            {
                "regex": "NX523J_V1",
                "model": "Z11 Max"
            },
            {
                "regex": "(?:NX549J|Nubia Z11 mini S)",
                "model": "Z11 Mini S"
            },
            {
                "regex": "(?:NX529Jq?|Nubia Z11 mini)",
                "model": "Z11 Mini"
            },
            {
                "regex": "NX606J",
                "model": "Z18"
            },
            {
                "regex": "NX616J",
                "model": "Z18S"
            },
            {
                "regex": "NX611J",
                "model": "Z18 Mini"
            },
            {
                "regex": "NX551J",
                "model": "M2"
            },
            {
                "regex": "NX563J",
                "model": "Z17"
            },
            {
                "regex": "NX569[HJ]",
                "model": "Z17 Mini"
            },
            {
                "regex": "NX589J",
                "model": "Z17 Mini S"
            },
            {
                "regex": "NX591J",
                "model": "Z17 Lite"
            },
            {
                "regex": "NX595J",
                "model": "Z17S"
            },
            {
                "regex": "NX612J",
                "model": "V18"
            },
            {
                "regex": "NX627J",
                "model": "Z20"
            },
            {
                "regex": "NX725J",
                "model": "Z60S Pro"
            },
            {
                "regex": "NX513J",
                "model": "My Prague"
            },
            {
                "regex": "NX601J",
                "model": "X6"
            },
            {
                "regex": "NX609J",
                "model": "Red Magic"
            },
            {
                "regex": "NX659J",
                "model": "Red Magic 5G"
            },
            {
                "regex": "NX651J",
                "model": "Play"
            },
            {
                "regex": "NX573J",
                "model": "M2 Lite"
            },
            {
                "regex": "NX907J",
                "model": "M2 Play"
            },
            {
                "regex": "NX541J",
                "model": "N1"
            },
            {
                "regex": "NX597J",
                "model": "N1 Lite"
            },
            {
                "regex": "NX575J",
                "model": "N2"
            },
            {
                "regex": "NX6(?:08|17)J",
                "model": "N3"
            },
            {
                "regex": "Nubia 8011",
                "model": "N80"
            },
            {
                "regex": "Nubia[_ ]([^;)/]+)( build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Rakuten": {
        "regex": "(?:ZR01|3917JR|P710|P780|C330)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZR01",
                "model": "Big"
            },
            {
                "regex": "3917JR",
                "model": "Big S"
            },
            {
                "regex": "P710",
                "model": "Hand"
            },
            {
                "regex": "C330",
                "model": "C330 Mini"
            },
            {
                "regex": "P780",
                "model": "Hand 5G"
            }
        ]
    },
    "ZTE": {
        "regex": "ZTE(?!; MegaFon)|AxonPhone|([a-z0-9]+)_USA_Cricket|(?:Blade[ _](?:A[57] 20(?:19|20)(?:RU)?|(?:V1000|L8)RU|E01|V0820|L110|L[2357]|L210(?:RU)?|L7A|L8|S6|V[6789]|V8Q|V8 SE|V9 VITA|X7|A(310?|320|460|465|475|510|520|530|602|51|30|3)|V580|V Ultra|Q Lux)|N9[15]8St|N818S|N951[0579]|N91[38]0|N9101|N913[267]|N952[01]|N9560|N9810|N799D|[UV]9180|[UV]9815|Z(?:5151V|610DL|6250CC|6400C|6410S|233V|331|5031O|559DL|6621O|667T|6750M|768G|792|81[25]|818L|82[08]|83[12359]|85[125]|851M|992|(557|71[67]|798|836|861|916)BL|986DL|(232|718|828)TL|(?:233|353|558|717|799|837|862|899|917|963)VL|955A|95[678]|965|97[018]|98[1237]|986U|999|936L)|V769M|Blade Apex2|G (LTE|Lux)|Vec|Z959|V865M|Z3001S|902ZT|KIS II Max|Kis 3|K3DX-V5G|Z930L|Optus X|Blade[ _](A[357] 2019(?:-T)?|A[35] 2020-T|A7S 2020-T|A6 MAX|A0622|X9)|Z3153V|Z836F|Ctyon-A9|602ZT|MO-01[JK]|Z963U|402ZT|P545|P609|P650 Pro|dandelion|901ZT|A00[13]ZT|Z-01K|UZTE (?:GRAND V7|V808)|ZTG01|K8[37]CA|K87CC|VERGATARIO ?5(?:PLUS)?|Axon mini|KIS C341|A[13]03ZT|Z335(?:1S|[23]CA)|Z5156CC|Z5157[VY]|B867RE|MEO Smart A[48]0|SmartA35|P65[10] 2021|Z6201V|Z6252CA|Z6251V?|A2020N3|A2322G|A202ZT|A302ZT|Z719DL|Z5158|Z235[069]|Z246[67]|Z245[038]|B2017G|5G UG Phone U2[35]|ATLAS[ _]W|A2121G|A2022|A202[23]P|A0622|A0616|2050RU|Z7540|A2022PG|A2019G|Z2472|Z2357N|A2025H)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "5G UG Phone U23|ZTE 7160N",
                "model": "5G UG Phone U23"
            },
            {
                "regex": "5G UG Phone U25",
                "model": "5G UG Phone U25"
            },
            {
                "regex": "P651 2021(?:[);/ ]|$)",
                "model": "Optus X (2021)"
            },
            {
                "regex": "P650 2021(?:[);/ ]|$)",
                "model": "Optus X Pro (2021)"
            },
            {
                "regex": "7530N(?:[);/ ]|$)",
                "model": "Voyage 10"
            },
            {
                "regex": "9040N(?:[);/ ]|$)",
                "model": "Voyage 20 Pro"
            },
            {
                "regex": "9042N(?:[);/ ]|$)",
                "model": "Voyage 40 Pro+"
            },
            {
                "regex": "7531N(?:[);/ ]|$)",
                "model": "Voyage 30S"
            },
            {
                "regex": "A2122H(?:[);/ ]|$)",
                "model": "S30 Pro 5G"
            },
            {
                "regex": "602ZT(?:[);/ ]|$)",
                "model": "Libero 2"
            },
            {
                "regex": "A001ZT(?:[);/ ]|$)",
                "model": "Libero 3"
            },
            {
                "regex": "A003ZT(?:[);/ ]|$)",
                "model": "Libero 5G"
            },
            {
                "regex": "A103ZT(?:[);/ ]|$)",
                "model": "Libero 5G II"
            },
            {
                "regex": "A202ZT(?:[);/ ]|$)",
                "model": "Libero 5G III"
            },
            {
                "regex": "A302ZT(?:[);/ ]|$)",
                "model": "Libero 5G IV"
            },
            {
                "regex": "901ZT(?:[);/ ]|$)",
                "model": "Libero S10"
            },
            {
                "regex": "A303ZT(?:[);/ ]|$)",
                "model": "Anshin Family"
            },
            {
                "regex": "ZTG01(?:[);/ ]|$)",
                "model": "A1"
            },
            {
                "regex": "7543N(?:[);/ ]|$)",
                "model": "Fresh 50"
            },
            {
                "regex": "ZTE T221(?:[);/ ]|$)",
                "model": "Blade AF3"
            },
            {
                "regex": "A0616(?:[);/ ]|$)",
                "model": "Blade A3"
            },
            {
                "regex": "Z3352CA(?:[);/ ]|$)",
                "model": "Blade A3 (2019)"
            },
            {
                "regex": "Z3353CA(?:[);/ ]|$)",
                "model": "Blade A3 Plus"
            },
            {
                "regex": "ZTE[_ ]Blade[_ ]A(3[13])[_ ]?(?:Plus|\\+)",
                "model": "Blade A$1 Plus"
            },
            {
                "regex": "(?:A7020(?:RU)?|Blade A7S 2020-T)(?:[);/ ]|$)",
                "model": "Blade A7s (2020)"
            },
            {
                "regex": "A7000(?:[);/ ]|$)",
                "model": "Blade A7 (2020)"
            },
            {
                "regex": "Z6252CA(?:[);/ ]|$)",
                "model": "Blade A7p (2020)"
            },
            {
                "regex": "A7030|A71 5G",
                "model": "Blade A71"
            },
            {
                "regex": "ZTE 7060",
                "model": "Blade A73"
            },
            {
                "regex": "Z2359",
                "model": "Blade A75"
            },
            {
                "regex": "N939Sc",
                "model": "Blade A711"
            },
            {
                "regex": "Z5157[VY]",
                "model": "Blade A3v"
            },
            {
                "regex": "7540N",
                "model": "Blade A72 5G"
            },
            {
                "regex": "A0722(?:[);/ ]|$)",
                "model": "Blade A7 Vita"
            },
            {
                "regex": "Z6201V(?:[);/ ]|$)",
                "model": "Blade A7"
            },
            {
                "regex": "Blade 10 Vita(?:[);/ ]|$)",
                "model": "Blade 10 Vita"
            },
            {
                "regex": "Z6251V(?:[);/ ]|$)",
                "model": "Blade 11 Prime"
            },
            {
                "regex": "(?:ZTE)? (?:2050|V1050)(?:RU)?",
                "model": "Blade 20 Smart"
            },
            {
                "regex": "ZTE Axon 7(?:[);/ ]|$)",
                "model": "Axon 7"
            },
            {
                "regex": "A2019G? Pro(?:[);/ ]|$)",
                "model": "Axon 9 Pro"
            },
            {
                "regex": "(?:902ZT|A2020N[23] Pro|A2020N3)(?:[);/ ]|$)",
                "model": "Axon 10 Pro 5G"
            },
            {
                "regex": "A2020 SP(?:[);/ ]|$)",
                "model": "Axon 10s Pro 5G"
            },
            {
                "regex": "(?:A2021[LGH]?|ZTE Axon 11 5G)(?:[);/ ]|$)",
                "model": "Axon 11 5G"
            },
            {
                "regex": "A2021E(?:[);/ ]|$)",
                "model": "Axon 11"
            },
            {
                "regex": "9000N(?:[);/ ]|$)",
                "model": "Axon 11 SE 5G"
            },
            {
                "regex": "A2322G",
                "model": "Axon 30 5G"
            },
            {
                "regex": "A2322|A2022L",
                "model": "Axon 30"
            },
            {
                "regex": "A2022H",
                "model": "Axon 31 Pro 5G"
            },
            {
                "regex": "A2022PG",
                "model": "Axon 30 Ultra"
            },
            {
                "regex": "A2022P",
                "model": "Axon 30 Pro 5G"
            },
            {
                "regex": "A2022",
                "model": "Axon 30 Pro"
            },
            {
                "regex": "A2023H",
                "model": "Axon A41 Ultra 5G"
            },
            {
                "regex": "A2023P",
                "model": "Axon 40 Ultra"
            },
            {
                "regex": "A2023G?",
                "model": "Axon 40 Pro"
            },
            {
                "regex": "ZTE[ _]?9047",
                "model": "Axon 40 SE"
            },
            {
                "regex": "A2016",
                "model": "Axon Elite"
            },
            {
                "regex": "Z2356",
                "model": "Axon 60"
            },
            {
                "regex": "A2025H",
                "model": "Axon 60 Ultra 5G"
            },
            {
                "regex": "Z2350",
                "model": "Axon 60 Lite"
            },
            {
                "regex": "A2024H",
                "model": "Axon 50 Ultra 5G"
            },
            {
                "regex": "N799D(?:[);/ ]|$)",
                "model": "Blade Eg"
            },
            {
                "regex": "Z818L(?:[);/ ]|$)",
                "model": "Allstar"
            },
            {
                "regex": "Z3001S(?:[);/ ]|$)",
                "model": "Quest Plus"
            },
            {
                "regex": "Z3351S(?:[);/ ]|$)",
                "model": "Quest 5"
            },
            {
                "regex": "Ctyon-A9(?:[);/ ]|$)",
                "model": "Ctyon A9"
            },
            {
                "regex": "K3DX-V5G(?:[);/ ]|$)",
                "model": "V5G"
            },
            {
                "regex": "(?:ZTE)?N918St(?:[);/ ]|$)",
                "model": "V5S"
            },
            {
                "regex": "N958St(?:[);/ ]|$)",
                "model": "V5 Max"
            },
            {
                "regex": "N9101(?:[);/ ]|$)",
                "model": "Imperial"
            },
            {
                "regex": "Z963U(?:[);/ ]|$)",
                "model": "Imperial Max"
            },
            {
                "regex": "N9120(?:[);/ ]|$)",
                "model": "Avid"
            },
            {
                "regex": "Z5156CC(?:[);/ ]|$)",
                "model": "Avid 579"
            },
            {
                "regex": "Z5158(?:[);/ ]|$)",
                "model": "Avid 589"
            },
            {
                "regex": "N9130(?:[);/ ]|$)",
                "model": "Speed"
            },
            {
                "regex": "N9132(?:[);/ ]|$)",
                "model": "Prestige"
            },
            {
                "regex": "N9136(?:[);/ ]|$)",
                "model": "Prestige 2"
            },
            {
                "regex": "N9137(?:[);/ ]|$)",
                "model": "Tempo X"
            },
            {
                "regex": "N9180(?:[);/ ]|$)",
                "model": "V5"
            },
            {
                "regex": "N9510(?:[);/ ]|$)",
                "model": "Warp 4G"
            },
            {
                "regex": "Z5151V(?:[);/ ]|$)",
                "model": "Visible R2"
            },
            {
                "regex": "N9517(?:[);/ ]|$)",
                "model": "Blade Force"
            },
            {
                "regex": "Z559DL(?:[);/ ]|$)",
                "model": "Blade T2"
            },
            {
                "regex": "402ZT(?:[);/ ]|$)",
                "model": "Blade Q+"
            },
            {
                "regex": "(?:ZTE[_ ])?Blade[ _]Q[ _]Lux(?:[);/ ]|$)",
                "model": "Blade Q Lux"
            },
            {
                "regex": "ZTE T320(?:[);/ ]|$)",
                "model": "Blade GF3"
            },
            {
                "regex": "N9515(?:[);/ ]|$)",
                "model": "Warp Sync"
            },
            {
                "regex": "N9519(?:[);/ ]|$)",
                "model": "Warp 7"
            },
            {
                "regex": "N9520(?:[);/ ]|$)",
                "model": "Boost Max"
            },
            {
                "regex": "N9521(?:[);/ ]|$)",
                "model": "Boost Max+"
            },
            {
                "regex": "N9560(?:[);/ ]|$)",
                "model": "Max XL"
            },
            {
                "regex": "N9810(?:[);/ ]|$)",
                "model": "Vital"
            },
            {
                "regex": "[UV]9180(?:[);/ ]|$)",
                "model": "V5 Red Bull"
            },
            {
                "regex": "[UV]9815(?:[);/ ]|$)",
                "model": "Grand Memo LTE"
            },
            {
                "regex": "V779M",
                "model": "Joey Jump 2"
            },
            {
                "regex": "V807",
                "model": "Blade C"
            },
            {
                "regex": "V809",
                "model": "Blade C2"
            },
            {
                "regex": "ZTE[_ ]Blade[_ ](C2|V7)[_ ]Plus",
                "model": "Blade $1 Plus"
            },
            {
                "regex": "(?:ZTE[_ ])?BA521",
                "model": "Blade 521"
            },
            {
                "regex": "Blade G Plus",
                "model": "Blade G Plus"
            },
            {
                "regex": "ZTE_Blade_III",
                "model": "Blade III"
            },
            {
                "regex": "(?:ZTE_)?V829",
                "model": "Blade G Pro"
            },
            {
                "regex": "V882",
                "model": "Lord"
            },
            {
                "regex": "V967S",
                "model": "Grand X2"
            },
            {
                "regex": "V970M?|V987",
                "model": "Grand X"
            },
            {
                "regex": "Z959(?:[);/ ]|$)",
                "model": "Grand X3"
            },
            {
                "regex": "(?:[RV]880H|V965)(?:[);/ ]|$)",
                "model": "V965"
            },
            {
                "regex": "V8000",
                "model": "Nova 4"
            },
            {
                "regex": "Z95[67]",
                "model": "Grand X4"
            },
            {
                "regex": "Z987",
                "model": "Grand X Max+"
            },
            {
                "regex": "(?:ZTE_)?Grand[ _]Era",
                "model": "Grand Era"
            },
            {
                "regex": "UZTE GRAND V7",
                "model": "Grand V7"
            },
            {
                "regex": "V788D",
                "model": "Kis Plus"
            },
            {
                "regex": "Z331(?:[);/ ]|$)",
                "model": "Z331"
            },
            {
                "regex": "N818S(?:[);/ ]|$)",
                "model": "N818S"
            },
            {
                "regex": "ZTE[_ ]V0840(?:[);/ ]|$)",
                "model": "Small Fresh 5"
            },
            {
                "regex": "Z5031O(?:[);/ ]|$)",
                "model": "Optus X Spirit 2"
            },
            {
                "regex": "P545(?:[);/ ]|$)",
                "model": "Optus X Power 2"
            },
            {
                "regex": "P609(?:[);/ ]|$)",
                "model": "Optus X Wave"
            },
            {
                "regex": "Optus X Start(?:[);/ ]|$)",
                "model": "Optus X Start"
            },
            {
                "regex": "BA520(?:[);/ ]|$)",
                "model": "Blade A520"
            },
            {
                "regex": "Blade A(5[12]) Lite(?:[);/ ]|$)",
                "model": "Blade A$1 Lite"
            },
            {
                "regex": "Blade L2 Plus(?:[);/ ]|$)",
                "model": "Blade L2 Plus"
            },
            {
                "regex": "(?:ZTE_)?Blade[ _]L2(?:[);/ ]|$)",
                "model": "Blade L2"
            },
            {
                "regex": "Blade L3 Plus(?:[);/ ]|$)",
                "model": "Blade L3 Plus"
            },
            {
                "regex": "Blade L3 Apex(?:[);/ ]|$)",
                "model": "Blade L3 Apex"
            },
            {
                "regex": "Blade L3(?:[);/ ]|$)",
                "model": "Blade L3"
            },
            {
                "regex": "ZTE[ _]T610(?:[);/ ]|$)",
                "model": "Blade L4"
            },
            {
                "regex": "ZTE[ _]Blade L4 Pro(?:[);/ ]|$)",
                "model": "Blade L4 Pro"
            },
            {
                "regex": "(?:Blade L5 Plus|BLADE L0510)(?:[);/ ]|$)",
                "model": "Blade L5 Plus"
            },
            {
                "regex": "Blade L6(?:[);/ ]|$)",
                "model": "Blade L6"
            },
            {
                "regex": "Blade L7A(?:[);/ ]|$)",
                "model": "Blade L7A"
            },
            {
                "regex": "Blade L(\\d+)(?:RU)?",
                "model": "Blade L$1"
            },
            {
                "regex": "Blade A([357]) (20(?:19|20))",
                "model": "Blade A$1 ($2)"
            },
            {
                "regex": "ZTE BV0720(?:[);/ ]|$)",
                "model": "Blade A2"
            },
            {
                "regex": "Blade A[35] 2020-T(?:[);/ ]|$)",
                "model": "Blade A$1 (2020)"
            },
            {
                "regex": "ZTE C880A(?:[);/ ]|$)",
                "model": "Blade A1"
            },
            {
                "regex": "Blade A([35]1?) Lite",
                "model": "Blade A$1 Lite"
            },
            {
                "regex": "Blade A(53) Pro",
                "model": "Blade A$1 Pro"
            },
            {
                "regex": "Blade (S6|A[35]1?) Plus",
                "model": "Blade $1 Plus"
            },
            {
                "regex": "(?:ZTE[ _])?BLADE[ _]A062[02](?:[);/ ]|$)",
                "model": "Blade A6"
            },
            {
                "regex": "BLADE (?:A6 MAX|A0605)(?:[);/ ]|$)",
                "model": "Blade A6 Max"
            },
            {
                "regex": "A0622(?:[);/ ]|$)",
                "model": "Blade A6 Lite"
            },
            {
                "regex": "Blade S6 Lite(?:[);/ ]|$)",
                "model": "Blade S6 Lite"
            },
            {
                "regex": "Blade S6(?:[);/ ]|$)",
                "model": "Blade S6"
            },
            {
                "regex": "BLADE A5 PRO(?:[);/ ]|$)",
                "model": "Blade A5 Pro"
            },
            {
                "regex": "T920(?:[);/ ]|$)",
                "model": "Blade S7"
            },
            {
                "regex": "ZTE[ _]T617(?:[);/ ]|$)",
                "model": "Blade D Lux"
            },
            {
                "regex": "(?:ZTE[ _])?Blade[ _]L(210|130)",
                "model": "Blade L$1"
            },
            {
                "regex": "(?:ZTE_)?Blade_A5_2019",
                "model": "Blade A5"
            },
            {
                "regex": "BLADE V Ultra(?:[);/ ]|$)",
                "model": "Blade V Ultra"
            },
            {
                "regex": "Blade V6 MAX(?:[);/ ]|$)",
                "model": "Blade V6 Max"
            },
            {
                "regex": "Blade V6 Plus(?:[);/ ]|$)",
                "model": "Blade V6 Plus"
            },
            {
                "regex": "Blade (?:V7 Lite|V0720)(?:[);/ ]|$)",
                "model": "Blade V7 Lite"
            },
            {
                "regex": "BLADE V0710(?:[);/ ]|$)",
                "model": "Blade V7"
            },
            {
                "regex": "Blade V([67])(?:[);/ ]|$)",
                "model": "Blade V$1"
            },
            {
                "regex": "9050N(?:[);/ ]|$)",
                "model": "Blade V50"
            },
            {
                "regex": "ZTE 8050(?:[);/ ]|$)",
                "model": "Blade V50 Design"
            },
            {
                "regex": "ZTE 8150N(?:[);/ ]|$)",
                "model": "Blade V50 Design 5G"
            },
            {
                "regex": "ZTE 8550(?:[);/ ]|$)",
                "model": "Blade V50 Vita"
            },
            {
                "regex": "Z2458",
                "model": "Blade V70 Design"
            },
            {
                "regex": "Z2467",
                "model": "Blade V70 Max"
            },
            {
                "regex": "BV0800(?:[);/ ]|$)",
                "model": "Blade V8"
            },
            {
                "regex": "(?:ZTE[ _])?Blade V1000|(?:ZTE_)?V1000",
                "model": "Blade V10"
            },
            {
                "regex": "Z6750M(?:[);/ ]|$)",
                "model": "Blade X1 5G"
            },
            {
                "regex": "Blade X([79])(?:[);/ ]|$)",
                "model": "Blade X$1"
            },
            {
                "regex": "ZTE T630(?:[);/ ]|$)",
                "model": "Blade X5"
            },
            {
                "regex": "ZTE T520(?:[);/ ]|$)",
                "model": "Blade L5"
            },
            {
                "regex": "Blade (?:V8Q|V0840)(?:[);/ ]|$)",
                "model": "Blade V8Q"
            },
            {
                "regex": "Blade V8 SE(?:[);/ ]|$)",
                "model": "Blade V8 SE"
            },
            {
                "regex": "BLADE (?:V0850|V8 Mini)(?:[);/ ]|$)",
                "model": "Blade V8 Mini"
            },
            {
                "regex": "BLADE V0920|ZTE-V9VITA",
                "model": "Blade V9 Vita"
            },
            {
                "regex": "ZTE 8030",
                "model": "Blade V30 Vita"
            },
            {
                "regex": "ZTE 8031",
                "model": "Blade V2022 4G"
            },
            {
                "regex": "ZTE 9030N",
                "model": "Blade S30"
            },
            {
                "regex": "ZTE 9030",
                "model": "Blade V30"
            },
            {
                "regex": "ZTE A7040",
                "model": "Blade V40 Smart"
            },
            {
                "regex": "ZTE A7050",
                "model": "Blade A72s"
            },
            {
                "regex": "ZTE 8045",
                "model": "Blade V40 Vita"
            },
            {
                "regex": "ZTE 8140N",
                "model": "Blade V41 Vita"
            },
            {
                "regex": "ZTE 9046",
                "model": "Blade V40 Pro"
            },
            {
                "regex": "ZTE 8046",
                "model": "Blade V40 Design"
            },
            {
                "regex": "ZTE 9045",
                "model": "Blade V40"
            },
            {
                "regex": "Blade V(9|10) Vita(?:[);/ ]|$)",
                "model": "Blade V$1 Vita"
            },
            {
                "regex": "Blade V([89]|10)(?:[);/ ]|$)",
                "model": "Blade V$1"
            },
            {
                "regex": "BLADE V0820(?:[);/ ]|$)",
                "model": "Blade V8 Lite"
            },
            {
                "regex": "(?:Blade[ _])?(Apex2|G (LTE|Lux)|Vec)(?:[);/ ]|$)",
                "model": "Blade $1"
            },
            {
                "regex": "Z768G(?:[);/ ]|$)",
                "model": "Midnight"
            },
            {
                "regex": "Z820",
                "model": "Obsidian"
            },
            {
                "regex": "Z986U",
                "model": "Blade Max 3"
            },
            {
                "regex": "Z6410S",
                "model": "Blade Max 2s"
            },
            {
                "regex": "Z610DL",
                "model": "Blade Max View"
            },
            {
                "regex": "Z971",
                "model": "Blade Spark"
            },
            {
                "regex": "Z978",
                "model": "Blade V8 Pro"
            },
            {
                "regex": "Z839",
                "model": "Blade Vantage"
            },
            {
                "regex": "Z3153V",
                "model": "Blade Vantage 2"
            },
            {
                "regex": "Z930L",
                "model": "Unico LTE"
            },
            {
                "regex": "Z965",
                "model": "Blade X"
            },
            {
                "regex": "Z6400C",
                "model": "Blade X2 Max"
            },
            {
                "regex": "Z981",
                "model": "Blade Z Max Pro"
            },
            {
                "regex": "Z982",
                "model": "Blade Z Max"
            },
            {
                "regex": "Z983",
                "model": "Blade X Max"
            },
            {
                "regex": "Z717[BV]L(?:[);/ ]|$)",
                "model": "Citrine LTE"
            },
            {
                "regex": "Z233VL(?:[);/ ]|$)",
                "model": "Cymbal-C LTE"
            },
            {
                "regex": "Z233V",
                "model": "Cymbal LTE"
            },
            {
                "regex": "Z232TL",
                "model": "Cymbal-G LTE"
            },
            {
                "regex": "Z353VL",
                "model": "Cymbal-T LTE"
            },
            {
                "regex": "Z718TL",
                "model": "Jasper LTE"
            },
            {
                "regex": "KIS II Max",
                "model": "Kis II Max"
            },
            {
                "regex": "Kis 3",
                "model": "Kis 3"
            },
            {
                "regex": "(?:Z798BL|Z799VL)(?:[);/ ]|$)",
                "model": "Majesty Pro LTE"
            },
            {
                "regex": "Z899VL",
                "model": "Majesty Pro Plus LTE"
            },
            {
                "regex": "Z828TL",
                "model": "Midnight Pro LTE"
            },
            {
                "regex": "(?:ZTE-)?Z792",
                "model": "Fanfare"
            },
            {
                "regex": "(?:ZTE-)?Z812",
                "model": "Maven"
            },
            {
                "regex": "(?:ZTE-)?Z719DL",
                "model": "ZMax One"
            },
            {
                "regex": "(?:ZTE-)?Z7540",
                "model": "ZMax 5G"
            },
            {
                "regex": "Z815",
                "model": "Fanfare 2"
            },
            {
                "regex": "Z831",
                "model": "Maven 2"
            },
            {
                "regex": "Z832",
                "model": "Sonata 3"
            },
            {
                "regex": "Z835",
                "model": "Maven 3"
            },
            {
                "regex": "Z851(?:[);/ ]|$)",
                "model": "Prelude Plus"
            },
            {
                "regex": "Z851M",
                "model": "Overture 3"
            },
            {
                "regex": "Z852",
                "model": "Fanfare 3"
            },
            {
                "regex": "Z828",
                "model": "Avid Plus"
            },
            {
                "regex": "Z855",
                "model": "Avid 4"
            },
            {
                "regex": "Z833",
                "model": "Avid TRIO"
            },
            {
                "regex": "(?:Z836BL|Z837VL|Z836F)(?:[);/ ]|$)",
                "model": "ZFive 2 LTE"
            },
            {
                "regex": "Z558VL",
                "model": "ZFive C LTE"
            },
            {
                "regex": "Z557BL",
                "model": "ZFive G LTE"
            },
            {
                "regex": "(?:Z861BL|Z862VL)(?:[);/ ]|$)",
                "model": "ZFive L LTE"
            },
            {
                "regex": "Z916BL",
                "model": "ZMax Grand LTE"
            },
            {
                "regex": "Z917VL",
                "model": "ZMax Champ LTE"
            },
            {
                "regex": "(?:Z958|Z955A)(?:[);/ ]|$)",
                "model": "ZMax 2"
            },
            {
                "regex": "dandelion(?:[);/ ]|$)",
                "model": "ZMax 3"
            },
            {
                "regex": "Z6250CC(?:[);/ ]|$)",
                "model": "ZMax 10"
            },
            {
                "regex": "Z963VL",
                "model": "Max Duo LTE"
            },
            {
                "regex": "Z970",
                "model": "ZMax Z970"
            },
            {
                "regex": "Z986DL",
                "model": "MAX Blue LTE"
            },
            {
                "regex": "(?:ZTE[-_])?Z992",
                "model": "Avail 2"
            },
            {
                "regex": "(?:Z999|Z-01K)(?:[);/ ]|$)",
                "model": "Axon M"
            },
            {
                "regex": "B201[56]|Axon mini",
                "model": "Axon Mini"
            },
            {
                "regex": "A2015",
                "model": "Axon Tianji"
            },
            {
                "regex": "A2017[GU]?",
                "model": "Axon 7"
            },
            {
                "regex": "C2017",
                "model": "Axon 7 Max"
            },
            {
                "regex": "A2018",
                "model": "Axon 7s"
            },
            {
                "regex": "B2017G",
                "model": "Axon 7 Mini"
            },
            {
                "regex": "(?:A2020(?:RU|[GU])? Pro|Axon 10 Pro)(?:[);/ ]|$)",
                "model": "Axon 10 Pro"
            },
            {
                "regex": "Z667T",
                "model": "Zinger"
            },
            {
                "regex": "Skate 2",
                "model": "Skate 2"
            },
            {
                "regex": "V?975|geek",
                "model": "Geek"
            },
            {
                "regex": "Z716BL",
                "model": "Citrine LTE"
            },
            {
                "regex": "X500",
                "model": "Score"
            },
            {
                "regex": "X501",
                "model": "Groove"
            },
            {
                "regex": "(?:ZTE-)?G-X991",
                "model": "Rio"
            },
            {
                "regex": "F-450",
                "model": "Adamant"
            },
            {
                "regex": "Z936L(?:[);/ ]|$)",
                "model": "Lever"
            },
            {
                "regex": "MO-01[JK](?:[);/ ]|$)",
                "model": "Mono"
            },
            {
                "regex": "V865M(?:[);/ ]|$)",
                "model": "V865M"
            },
            {
                "regex": "Z6621O(?:[);/ ]|$)",
                "model": "Optus X Vista"
            },
            {
                "regex": "P650 Pro(?:[);/ ]|$)",
                "model": "Optus X Pro LTE"
            },
            {
                "regex": "V769M(?:[);/ ]|$)",
                "model": "Leo Q2"
            },
            {
                "regex": "VERGATARIO 5(?:[);/ ]|$)",
                "model": "Vergatario 5"
            },
            {
                "regex": "VERGATARIO5PLUS(?:[);/ ]|$)",
                "model": "Vergatario 5 Plus"
            },
            {
                "regex": "ZTE V5 PRO(?:[);/ ]|$)",
                "model": "V5 Pro"
            },
            {
                "regex": "ZTE 8012N",
                "model": "Blade V2021 5G"
            },
            {
                "regex": "ZTE 9000",
                "model": "Blade V2020"
            },
            {
                "regex": "ZTE 8000",
                "model": "Blade V2020 Vita"
            },
            {
                "regex": "KIS C341",
                "model": "Kis C341"
            },
            {
                "regex": "MEO Smart A([48]0)",
                "model": "MEO Smart A$1"
            },
            {
                "regex": "Smart ?A(35)",
                "model": "MEO Smart A$1"
            },
            {
                "regex": "ATLAS[ _]W",
                "model": "Atlas W"
            },
            {
                "regex": "Z2357N",
                "model": "Blade A75 5G"
            },
            {
                "regex": "A2121[GLE]?(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Axon 20 5G"
            },
            {
                "regex": "ZTE 8010",
                "device": "phablet",
                "model": "Blade V2020 Smart"
            },
            {
                "regex": "B867RE(?:[);/ ]|$)",
                "device": "tv",
                "model": "ZXV10 B867RE"
            },
            {
                "regex": "K83CA(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Grand X View 3"
            },
            {
                "regex": "K87CA(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Grand X View 4"
            },
            {
                "regex": "K87CC(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Grand X View 3.8"
            },
            {
                "regex": "ZTE-K88(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Trek 2"
            },
            {
                "regex": "ZTE-K92(?:[);/ ]|$)",
                "device": "tablet",
                "model": "PrimeTime"
            },
            {
                "regex": "T1002(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Blade X10"
            },
            {
                "regex": "T1004(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Blade X10 II Pro+"
            },
            {
                "regex": "AxonPhone ([^;/]+) Build",
                "model": "AxonPhone $1"
            },
            {
                "regex": "([a-z0-9]+)_USA_Cricket",
                "model": "$1"
            },
            {
                "regex": "ZTE[- ](V98|V96A|V81|V70)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "Blade[_ ](A(\\d+)C?|L111|V580|E01)(?:[);/ ]|$)",
                "model": "Blade $1"
            },
            {
                "regex": "ZTE Blade A52",
                "model": "Blade A52"
            },
            {
                "regex": "Z2450",
                "model": "Blade A55"
            },
            {
                "regex": "ZTE Blade A53\\+",
                "model": "Blade A53+"
            },
            {
                "regex": "ZTE Blade A33s",
                "model": "Blade A33s"
            },
            {
                "regex": "Z2453",
                "model": "Blade A35"
            },
            {
                "regex": "Z2466",
                "model": "Blade A35s"
            },
            {
                "regex": "Z2472",
                "model": "Blade A36"
            },
            {
                "regex": "Blade[_ ]V0730(?:[);/ ]|$)",
                "model": "Blade V7"
            },
            {
                "regex": "Blade[_ ]V0800(?:[);/ ]|$)",
                "model": "Blade V8"
            },
            {
                "regex": "Blade[_ ]V1000(?:[);/ ]|$)",
                "model": "Blade V10"
            },
            {
                "regex": "ZTE B(A601|A910|A510)(?:[);/ ]|$)",
                "model": "Blade $1"
            },
            {
                "regex": "ZTE Blade (A[35]1|A7s|C370)",
                "model": "Blade $1"
            },
            {
                "regex": "ZTE BA610T(?:[);/ ]|$)",
                "model": "Blade A610"
            },
            {
                "regex": "ZTE[- ]([a-z0-9\\-_ ]+) Build",
                "model": "$1"
            },
            {
                "regex": "ZTE-(?:G |G-)?([a-z0-9 _]+)",
                "model": "$1"
            },
            {
                "regex": "U?ZTE[ _]?([a-z0-9]+)",
                "model": "$1"
            }
        ]
    },
    "Onix": {
        "regex": "(?:ONIX S405|AT101-1116|ONIX_8_3G_01)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(AT101-1116)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ONIX_8_3G_01(?:[);/ ]|$)",
                "model": "8\" Tablet 3G"
            },
            {
                "regex": "(S405)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Zuum": {
        "regex": "Zuum[ _-]|Android 6.+ UNIQ(?: Build|[);])|(?:ROCKET III?|Akus (?:PRO|[ZP]1?)|AURA_Z|COVET|MAGNO(?:-S| P[13])?|ONIX(?: S)?|STEDI|STELLAR(?:[ _](?:Z|PRO|[MP]1|M2))?|GRAVITY [ZM]|AURA (?:PRIME|PLUS JLO|PRO JLO|PRO|[ZM]1|X)|COVET_PRO_LITE|RONI|Android.*; (?:GRANT|LIMIT)|Gravity Life|SENS (?:M1|G)|ULTRA Z|NOVUS TAB)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOVUS TAB",
                "device": "tablet",
                "model": "Novus Tab"
            },
            {
                "regex": "AKUS PRO",
                "model": "Akus Pro"
            },
            {
                "regex": "AKUS ([ZP]1?)",
                "model": "Akus $1"
            },
            {
                "regex": "AURA_Z(?:[);/ ]|$)",
                "model": "Aura Z"
            },
            {
                "regex": "COVET_PRO_LITE",
                "model": "Covet Pro Lite"
            },
            {
                "regex": "COVET PRO",
                "model": "Covet Pro"
            },
            {
                "regex": "COVET Mini",
                "model": "Covet Mini"
            },
            {
                "regex": "COVET( [XZ])?",
                "model": "Covet$1"
            },
            {
                "regex": "Magno Pro",
                "model": "Magno Pro"
            },
            {
                "regex": "MAGNO PLUS",
                "model": "Magno Plus"
            },
            {
                "regex": "Magno C Plus",
                "model": "Magno C Plus"
            },
            {
                "regex": "MAGNO-S",
                "model": "Magno S"
            },
            {
                "regex": "MAGNO( C[12]?| P[13])?",
                "model": "Magno$1"
            },
            {
                "regex": "ONIX S",
                "model": "Onix S"
            },
            {
                "regex": "ONIX",
                "model": "Onix"
            },
            {
                "regex": "SENS (M1|G)",
                "model": "Sens $1"
            },
            {
                "regex": "STEDI",
                "model": "Stedi"
            },
            {
                "regex": "STELLAR PRO",
                "model": "Stellar Pro"
            },
            {
                "regex": "STELLAR PLUS",
                "model": "Stellar Plus"
            },
            {
                "regex": "STELLAR ([MP]\\d|Z)",
                "model": "Stellar $1"
            },
            {
                "regex": "STELLAR MINI",
                "model": "Stellar Mini"
            },
            {
                "regex": "STELLAR Max",
                "model": "Stellar Max"
            },
            {
                "regex": "STELLAR",
                "model": "Stellar"
            },
            {
                "regex": "GRAVITY ([MZ])",
                "model": "Gravity $1"
            },
            {
                "regex": "Gravity Life",
                "model": "Gravity Life"
            },
            {
                "regex": "AURA PRIME",
                "model": "Aura Prime"
            },
            {
                "regex": "AURA PLUS JLO",
                "model": "Aura Plus J.Lo"
            },
            {
                "regex": "AURA PRO JLO",
                "model": "Aura Pro J.Lo"
            },
            {
                "regex": "AURA PRO",
                "model": "Aura Pro"
            },
            {
                "regex": "AURA ([ZM]1|X)",
                "model": "Aura $1"
            },
            {
                "regex": "RONI",
                "model": "Roni"
            },
            {
                "regex": "ULTRA Z",
                "model": "Ultra Z"
            },
            {
                "regex": "ROCKET (III?)",
                "model": "Rocket $1"
            },
            {
                "regex": "Android 6.+; UNIQ(?: Build|[);])",
                "model": "Uniq"
            },
            {
                "regex": "Android.+; LIMIT(?: Build|[);])",
                "model": "Limit"
            },
            {
                "regex": "GRANT",
                "model": "Grant"
            },
            {
                "regex": "Zuum[ _-]([^;/]+) Build",
                "model": "$1"
            },
            {
                "regex": "Zuum[ _-]?([^;/)]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Zen": {
        "regex": "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))|(?:AdmireGlam|M72 Smart)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AdmireGlam",
                "model": "Admire Glam"
            },
            {
                "regex": "ADMIRE[_ ]SENSE\\+",
                "model": "Admire Sense+"
            },
            {
                "regex": "ADMIRE[_ ]SWADESH\\+",
                "model": "Admire Swadesh+"
            },
            {
                "regex": "ADMIRE[_ ]SENSE[_ ]DUO",
                "model": "Admire Sense Duo"
            },
            {
                "regex": "ADMIRE[_ ]CURVE[_ ]NEO",
                "model": "Admire Curve Neo"
            },
            {
                "regex": "ADMIRE[_ ]CURVE\\+",
                "model": "Admire Curve+"
            },
            {
                "regex": "ADMIRE[_ ]NEO\\+",
                "model": "Admire Neo+"
            },
            {
                "regex": "ADMIRE[_ ]DUO",
                "model": "Admire Duo"
            },
            {
                "regex": "ADMIRE[_ ]SHINE",
                "model": "Admire Shine"
            },
            {
                "regex": "ADMIRE[_ ]INFINITY",
                "model": "Admire Infinity"
            },
            {
                "regex": "ADMIRE[_ ]Unity",
                "model": "Admire Unity"
            },
            {
                "regex": "ADMIRE[_ ]STRONG",
                "model": "Admire Strong"
            },
            {
                "regex": "ADMIRE[_ ]GLORY\\+",
                "model": "Admire Glory+"
            },
            {
                "regex": "(M72 Smart)",
                "model": "$1"
            },
            {
                "regex": "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))",
                "model": "$1"
            }
        ]
    },
    "Zync": {
        "regex": "ZYNC|(Cloud Z5|Z1000|Z18|Z99|Z99[_ ][23]G|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Z18| DuZ99al Core|Z99[_ ][23]G|Z99 Dual Core|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)",
                "model": "$1"
            },
            {
                "regex": "(Z1000[^/;]+)Build",
                "model": "$1"
            },
            {
                "regex": "Cloud (Z5)",
                "model": "Cloud $1"
            },
            {
                "regex": "ZYNC Cloud[ _]([^;]+)Build",
                "model": "Cloud $1"
            },
            {
                "regex": "ZYNC[ _]([^;]+)Build",
                "model": "$1"
            }
        ]
    },
    "Lemhoov": {
        "regex": "Lemhoov",
        "device": "smartphone",
        "models": [
            {
                "regex": "Lemhoov[ _-]([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "MStar": {
        "regex": "MStar(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "ZALA": {
        "regex": "ZALA(?: SmartBox)? (DV9135)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "MTC": {
        "regex": "MTC[ _](968|97[82]|970|982[OT]?|1078)|(?:MTC[_ ])?SMART[ _]?(?:Race[2]?|Sprint|Run|Turbo|Surf[2]?)[ _]4G|MTC975|Smart Bit|Smart_(?:LINE|Light)|(?:MTC[ _])?SMART[ _](?:Run|Start[_ ][23])|Redbox Mini 5\\(MTS\\)|MTS TV|DV8235|DV9135|DV9157-C|DV8304-C|Osmartphona",
        "device": "smartphone",
        "models": [
            {
                "regex": "Osmartphona",
                "model": "Osmartphona"
            },
            {
                "regex": "MTC[ _]?(97[258]|970[H]?|982[OT]?|968)",
                "model": "$1"
            },
            {
                "regex": "MTC[ _](1078)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "SMART[ _]Race[ _]4G",
                "model": "Smart Race 4G"
            },
            {
                "regex": "SMART[ _]Race2[ _]4G",
                "model": "Smart Race 2 4G"
            },
            {
                "regex": "(?:MTC_)?SMART[ _]Sprint[ _]4G",
                "model": "Smart Sprint 4G"
            },
            {
                "regex": "(?:MTC_)?SMART[ _]Start[ _]([23])",
                "model": "Smart Start $1"
            },
            {
                "regex": "Smart_LINE",
                "model": "Smart Line"
            },
            {
                "regex": "Smart_Light",
                "model": "Smart Light"
            },
            {
                "regex": "Smart Bit",
                "model": "Smart Bit"
            },
            {
                "regex": "SMART[ _]?Run(?:[ _]4G)?",
                "model": "Smart Run 4G"
            },
            {
                "regex": "SMART[ _]Surf2[ _]4G",
                "model": "Smart Surf 2 4G"
            },
            {
                "regex": "SMART[ _]Surf[ _]4G",
                "model": "Smart Surf 4G"
            },
            {
                "regex": "SMART[ _]Turbo[ _]4G",
                "model": "Smart Turbo 4G"
            },
            {
                "regex": "Redbox Mini 5\\(MTS\\)",
                "device": "tv",
                "model": "Redbox Mini 5"
            },
            {
                "regex": "MTS TV Box (\\d{3})",
                "device": "tv",
                "model": "SB-$1"
            },
            {
                "regex": "DV8304-C",
                "device": "tv",
                "model": "SuperWave DV8304-C"
            },
            {
                "regex": "(DV8235|DV9135|DV9157)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Megacable": {
        "regex": "OTT Xview AV1(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "OTT Xview AV1",
                "model": "Xview+"
            }
        ]
    },
    "MegaFon": {
        "regex": "MegaFon|MFLoginPh|MegLogPh|(MFLogin[34]T?|MS3B|SP-A5|SP-A20i|KM8-ATV-MF)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MFLoginPh|MegLogPh",
                "model": "Login+"
            },
            {
                "regex": "MFLogin4",
                "model": "Login 4 LTE"
            },
            {
                "regex": "MFLogin3T|MegaFon Login 3",
                "model": "Login 3",
                "device": "tablet"
            },
            {
                "regex": "MS3B|Megafon Optima",
                "model": "Optima"
            },
            {
                "regex": "SP-A20i",
                "model": "Mint"
            },
            {
                "regex": "(SP-A5|SP-W1)",
                "model": "$1"
            },
            {
                "regex": "MegaFon V9+",
                "device": "tablet",
                "model": "V9 Plus"
            },
            {
                "regex": "(KM8-ATV-MF)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Inoi": {
        "regex": "INOI|(?:A126|A1[68]1|A170_Plus|A161_Plus|(?:Android 12(?:[\\d.]*);(?: [\\w-]+;)? (?:A151))|(?:Android 11(?:[\\d.]*);(?: [\\w-]+;)? (?:A17[01]|A180))|A181_Plus|A171_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "inoiPad mini 2\\+32 Wi-Fi\\+3G",
                "device": "tablet",
                "model": "Pad Mini 2+32"
            },
            {
                "regex": "inoiPad 2\\+32 Wi-Fi\\+3G",
                "device": "tablet",
                "model": "Pad 2+32"
            },
            {
                "regex": "inoiPad 128\\+4GB Wi-Fi\\+4G",
                "device": "tablet",
                "model": "Pad 4+128"
            },
            {
                "regex": "inoiPad mini 1\\+16 Wi-Fi",
                "device": "tablet",
                "model": "Pad Mini 1+16 WiFi"
            },
            {
                "regex": "inoiPad Pro",
                "device": "tablet",
                "model": "Pad Pro"
            },
            {
                "regex": "inoiPad 64GB Wi-Fi\\+3G",
                "device": "tablet",
                "model": "Pad WiFi+3G"
            },
            {
                "regex": "INOI easyphone",
                "model": "Easy Phone"
            },
            {
                "regex": "INOI (2|5) Lite (2019|2021)",
                "model": "$1 Lite ($2)"
            },
            {
                "regex": "INOI[_ ]([123])[_ ]LITE",
                "model": "$1 Lite"
            },
            {
                "regex": "(A126|A17[01])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "A17[01]_Plus",
                "model": "A72"
            },
            {
                "regex": "A181_Plus",
                "model": "A181 Plus"
            },
            {
                "regex": "A(1[58]1)",
                "model": "A$1"
            },
            {
                "regex": "A180",
                "model": "Note 12"
            },
            {
                "regex": "(?: A161|A161_Plus)(?:[);/ ]|$)",
                "model": "A62"
            },
            {
                "regex": "INOI ([257]) (?:\\d\\+\\d+ )?(2019|202[01])(?:[);/ ]|$)",
                "model": "$1 ($2)"
            },
            {
                "regex": "INOI[_ ]([^);/]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Vertex": {
        "regex": "Vertex[_ -]|(?:Luck|Luck_L1[02]0_[34]G|Lion_Dual|V709X|TAB X8|TAB X10|Tab [43]G (?:7-2|8-1|10-1)|Tab_3G_7-1|Pro_P3[01]0_4G|Lion_DC|Baccara|Eagle[ _]4G|ImpressMAX|Lion [1-3])(?:[);/ ]|$)|Impress[ _]([^;/]+)(?:Build|\\))",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Vertex_)?Luck[_ ]L[_ ](5045)[_ ]([34])G",
                "model": "Luck L $1 $2G"
            },
            {
                "regex": "(Lion_Dual|Lion_DC|Baccara|Eagle[ _]4G|Luck[_ ]L1[023]0(?:[_ ][34]G)?|Luck)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Impress ?MAX(?:[);/ ]|$)",
                "model": "Impress Max"
            },
            {
                "regex": "IMPRESS ECLIPSE(?:[);/ ]|$)",
                "model": "Impress Eclipse"
            },
            {
                "regex": "Pro_P(3[01]0)_4G(?:[);/ ]|$)",
                "model": "Pro P$1 4G"
            },
            {
                "regex": "Impress_Luck[_ ]?4G_NFC(?:[);/ ]|$)",
                "model": "Impress Luck 4G NFC"
            },
            {
                "regex": "Lion ([1-3])(?:[);/ ]|$)",
                "model": "Impress Lion $1"
            },
            {
                "regex": "(Impress[ _][a-z]+)([34])G(?:Build|\\))",
                "model": "$1 $2G"
            },
            {
                "regex": "(Impress[ _](?:[^;/]+))(?:Build|\\))",
                "model": "$1"
            },
            {
                "regex": "(V709X)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "TAB X(8|10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Tab X$1"
            },
            {
                "regex": "Tab[ _]([43])G[ _]([78]|10)-([21])",
                "device": "tablet",
                "model": "Tab $1G $2.$3\""
            }
        ]
    },
    "Starway": {
        "regex": "Andromeda[ _]S(707|84[05]|850|8)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Andromeda S$1"
    },
    "Savio": {
        "regex": " (TB-PO1|TB-B01|TB-G01)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Schok": {
        "regex": "Schok[ _]|FreedomTurboXL",
        "device": "smartphone",
        "models": [
            {
                "regex": "Schok Volt SV55",
                "model": "Volt SV55"
            },
            {
                "regex": "FreedomTurboXL",
                "model": "Freedom Turbo XL"
            }
        ]
    },
    "Simbans": {
        "regex": "TangoTab|Presto[ )]|PicassoTab_[X9]|PICASSOTABX14|Ultimax|Valumax|S72-B|SX2W",
        "device": "tablet",
        "models": [
            {
                "regex": "TangoTab[_ ]?(\\d+|X)",
                "model": "TangoTab $1"
            },
            {
                "regex": "TangoTab",
                "model": "TangoTab"
            },
            {
                "regex": "Ultimax",
                "model": "Ultimax"
            },
            {
                "regex": "Valumax",
                "model": "Valumax"
            },
            {
                "regex": "PicassoTab_?(X14|XL?|9)",
                "model": "Picasso Tab $1"
            },
            {
                "regex": "Presto",
                "model": "Presto"
            },
            {
                "regex": "S72-B",
                "model": "S72-B"
            },
            {
                "regex": "SX2W",
                "model": "SX2W"
            }
        ]
    },
    "MYFON": {
        "regex": "MYPAD7s",
        "device": "tablet",
        "model": "My Pad 7s"
    },
    "X-TIGI": {
        "regex": "X[-_]TIGI|Hope(?:[78]|10)[_ ](?:Mate|Max|Pro|Plus|LTE)|JOY(?:10|8) Mate|JOY10_LTE|Photo_P15_Lite|SHARP_2|SHARP1|V18 pro_A|Bison1",
        "device": "smartphone",
        "models": [
            {
                "regex": "X-TIGI_JOY10_PRO",
                "model": "Joy 10 Pro",
                "device": "tablet"
            },
            {
                "regex": "X-TIGI_JOY10",
                "model": "Joy 10",
                "device": "tablet"
            },
            {
                "regex": "X[_ ]TIGI[_ ]JOY7_TV",
                "model": "Joy 7 TV",
                "device": "tablet"
            },
            {
                "regex": "(?:X_TIGI_)?JOY(10|[78])[ _]Mate",
                "model": "Joy $1 Mate",
                "device": "tablet"
            },
            {
                "regex": "Hope([78])[_ ](Mate|Max)",
                "model": "Hope $1 $2",
                "device": "tablet"
            },
            {
                "regex": "Hope ?8 LTE",
                "model": "Hope 8 LTE",
                "device": "tablet"
            },
            {
                "regex": "Hope10[_ ]Pro",
                "model": "Hope 10 Pro",
                "device": "tablet"
            },
            {
                "regex": "Hope10[_ ]Plus",
                "model": "Hope 10 Plus",
                "device": "tablet"
            },
            {
                "regex": "X-TIGI_JOY7_MAX",
                "model": "Joy 7 Max",
                "device": "tablet"
            },
            {
                "regex": "JOY10_LTE",
                "model": "Joy 10 LTE",
                "device": "tablet"
            },
            {
                "regex": "Bison1",
                "model": "Bison 1"
            },
            {
                "regex": "X-TIGI[_ ]V28[_ ]LTE",
                "model": "V28 LTE"
            },
            {
                "regex": "X[-_]TIGI[_ ]V19",
                "model": "V19"
            },
            {
                "regex": "V18 pro_A",
                "model": "V18 Pro"
            },
            {
                "regex": "X[-_]TIGI[_ ]A1[_ ]?Plus",
                "model": "A1 Plus"
            },
            {
                "regex": "X-TIGI[_ ]Photo[_ ]P11",
                "model": "Photo P11"
            },
            {
                "regex": "Photo_P15_Lite",
                "model": "Photo P15 Lite"
            },
            {
                "regex": "SHARP_?([12])",
                "model": "Sharp $1"
            },
            {
                "regex": "X[-_]TIGI[ _-]([^/;)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Hot Pepper": {
        "regex": "(?:HPP-(GS1|L55B)|VLE5|Puya|HPPL6[03]A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HPP-GS1",
                "model": "Ghost"
            },
            {
                "regex": "HPPL60A",
                "model": "Chilaca"
            },
            {
                "regex": "HPPL63A",
                "model": "Panca"
            },
            {
                "regex": "VLE5",
                "model": "Poblano"
            },
            {
                "regex": "Puya",
                "model": "Puya",
                "device": "tablet"
            },
            {
                "regex": "HPP-L55B",
                "model": "Serrano"
            }
        ]
    },
    "Xiaolajiao": {
        "regex": "(LA2-(?:L|S[N]?)|HLA Note(?:3|1-L)|L7620DE|20190416Q|20170608S|20180322D|20190325D|20190718Q|20190417Q|20180101M|20170605Q)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HLA Note3(?:[);/ ]|$)",
                "model": "Red Pepper Note 3"
            },
            {
                "regex": "HLA Note1-L(?:[);/ ]|$)",
                "model": "Note 1"
            },
            {
                "regex": "(LA2-(?:L|S[N]?))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(20190416Q|L7620DE|20180101M|20170605Q)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "20170608S(?:[);/ ]|$)",
                "model": "Red Pepper Plus"
            },
            {
                "regex": "20180322D(?:[);/ ]|$)",
                "model": "E Sports"
            },
            {
                "regex": "20190325D(?:[);/ ]|$)",
                "model": "Red Pepper 8X Pro"
            },
            {
                "regex": "20190718Q(?:[);/ ]|$)",
                "model": "Red Pepper 9X"
            },
            {
                "regex": "20190417Q(?:[);/ ]|$)",
                "model": "Mate 30 Max"
            }
        ]
    },
    "Ritmix": {
        "regex": "(RMD[-_](?:10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)|RMP-(?:450|50[56]|530|600))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "RMD[-_](10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)(?:[);/ ]|$)",
                "model": "RMD-$1"
            },
            {
                "regex": "RMP[-_](450|50[56]|530|600)(?:[);/ ]|$)",
                "model": "RMP-$1",
                "device": "smartphone"
            }
        ]
    },
    "Ross&Moor": {
        "regex": "RM(D)?[-_](974R|600|550|790)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "RM$1-$2"
    },
    "R-TV": {
        "regex": "R-TV BOX[ _]?(MINI\\+|X99|X10 PRO|[RXS]10)",
        "device": "tv",
        "model": "Box $1"
    },
    "NEXBOX": {
        "regex": "(MXQ|MXQ-Pro)-NEXBOX|NEXBOX-([^) ]+)",
        "device": "tv",
        "models": [
            {
                "regex": "MXQ-Pro-NEXBOX",
                "model": "MXQ Pro"
            },
            {
                "regex": "MXQ-NEXBOX",
                "model": "MXQ"
            },
            {
                "regex": "NEXBOX-([^) ]+)",
                "model": "$1"
            }
        ]
    },
    "True": {
        "regex": "TRUE BEYOND TAB 3G|HPH07|SMART[ _](4G Adventure(?: Pro)?|MAX 4\\.0 PLUS|4G[ _](?:MAX 5\\.5|GEN C [45]\\.[05]|M1 Plus|Champion|Speedy 5\\.0 Plus|Speedy[_ ]5inch|P1))|Alpha 5G|SMART Champ 4\\.0|TRUE SMART 7\\.0 Quadcore|SMART 4G M1|SMART TAB 4G (?:e-Biz|M1)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Alpha 5G(?:[);/ ]|$)",
                "model": "Alpha 5G"
            },
            {
                "regex": "SMART MAX 4\\.0 PLUS",
                "model": "Smart Max 4.0 Plus"
            },
            {
                "regex": "SMART Champ 4\\.0",
                "model": "Smart Champ 4.0"
            },
            {
                "regex": "SMART 4G Gen C ([45]\\.[05])",
                "model": "Smart 4G Gen C $1\""
            },
            {
                "regex": "SMART 4G Speedy 5\\.0 Plus",
                "model": "Smart 4G Speedy 5.0 Plus"
            },
            {
                "regex": "SMART 4G Adventure Pro",
                "model": "Smart 4G Adventure Pro"
            },
            {
                "regex": "SMART 4G Adventure",
                "model": "Smart 4G Adventure"
            },
            {
                "regex": "SMART 4G MAX 5\\.5",
                "model": "Smart 4G Max 5.5"
            },
            {
                "regex": "SMART[ _]4G[_ ]Speedy[_ ]5inch",
                "model": "Smart 4G Speedy 5"
            },
            {
                "regex": "SMART[ _]4G[_ ]Champion",
                "model": "Smart 4G Champion"
            },
            {
                "regex": "SMART[ _]4G[_ ]P1 Prime",
                "model": "Smart 4G P1 Prime"
            },
            {
                "regex": "SMART[ _]4G[_ ]P1",
                "model": "Smart 4G P1"
            },
            {
                "regex": "SMART[ _]4G M1 Plus",
                "model": "Smart 4G M1 Plus"
            },
            {
                "regex": "SMART 4G M1",
                "model": "Smart 4G M1"
            },
            {
                "regex": "SMART TAB 4G M1",
                "device": "tablet",
                "model": "Smart Tab 4G M1"
            },
            {
                "regex": "SMART TAB 4G e-Biz PRO",
                "device": "tablet",
                "model": "Smart Tab 4G e-Biz Pro"
            },
            {
                "regex": "SMART TAB 4G e-Biz",
                "device": "tablet",
                "model": "Smart Tab 4G e-Biz"
            },
            {
                "regex": "TRUE BEYOND TAB 3G",
                "device": "tablet",
                "model": "Beyond Tab 3G"
            },
            {
                "regex": "TRUE SMART 7\\.0 Quadcore",
                "device": "tablet",
                "model": "Smart Tab 7.0 QuadCore"
            },
            {
                "regex": "HPH07",
                "device": "tv",
                "model": "ID TV HPH07"
            }
        ]
    },
    "Yandex": {
        "regex": "(?:YNDX-?00(?:0SB|10[12]|055|07[1-9]|08[01]|09[1-6])|YandexModule2-00001|yandexstation_2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YandexModule2-00001",
                "device": "tv",
                "model": "Module"
            },
            {
                "regex": "YNDX-?(0007[1-9]|0008[01]|0009[1-6]|0010[12])",
                "device": "tv",
                "model": "YNDX-$1"
            },
            {
                "regex": "YNDX-?000SB",
                "model": "YNDX-000SB"
            },
            {
                "regex": "YNDX-?00055",
                "device": "smart speaker",
                "model": "SmartSpeak Duo Max"
            },
            {
                "regex": "yandexstation_2",
                "device": "smart speaker",
                "model": "Station 2"
            }
        ]
    },
    "FORME": {
        "regex": "FORME[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "FORME[ _-]F520(?:[);/ ]|$)",
                "model": "Forever"
            },
            {
                "regex": "FORME[ _-](A[35]7|R7S?|P6)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Shuttle": {
        "regex": "(PNT-704[025])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "BDF": {
        "regex": "(?:BDF[- ](?:819|P10|M107|K107H|KT107|MT6753|X20|P30)|K960N_MT(?:6580|6753)(?:_32_N)?|m107_\\d+a_64_q|ZL80)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "BDF[- ](819|P10|M107|K107H|KT107|MT6753|X20|P30)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "m107_\\d",
                "model": "M107"
            },
            {
                "regex": "ZL80",
                "model": "ZL80"
            },
            {
                "regex": "K960N_MT(6580|6753)(_32_N)?(?:[);/ ]|$)",
                "model": "BK960N MT$1"
            }
        ]
    },
    "HiHi": {
        "regex": "HIHI-",
        "device": "tablet",
        "models": [
            {
                "regex": "HIHI-(4[01])KH-TAB-0?1",
                "model": "$1KH-TAB-01"
            }
        ]
    },
    "Hi": {
        "regex": "(?:(?<!Thrill )Boost(?:[ _](?:Hypa|Max|Ultra))?(?: Build|[;)])|HMR(?:5012|5450)|Crusader|(?:VHIX-)?VHIX-\\w+(?:-[A-Z])?|HX-(?:\\d{2}[FHU]\\d{2}FB)|43FSY112X[bcd]?|32HSY119X|39HSY111X|55USY151X|50USY151X|65USY151X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Boost[ _](Hypa|Max|Ultra)(?:[);/ ]|$)",
                "model": "Boost $1"
            },
            {
                "regex": "Boost(?:[);/ ]|$)",
                "model": "Boost"
            },
            {
                "regex": "HMR5012(?:[);/ ]|$)",
                "model": "Boost Go"
            },
            {
                "regex": "(HMR5450|Crusader)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "VHIX-40F152MSYb",
                "device": "tv",
                "model": "VHIX-40F152MSY"
            },
            {
                "regex": "HX-(\\d{2}[FHU]\\d{2}FB)",
                "device": "tv",
                "model": "HX-$1"
            },
            {
                "regex": "(?:VHIX-)?VHIX-(\\w+)",
                "device": "tv",
                "model": "VHIX-$1"
            },
            {
                "regex": "(32HSY119X|39HSY111X|55USY151X|43FSY112X[bcd]?|50USY151X|65USY151X)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Boost": {
        "regex": "(?:Pulse Retro|Pulse Sky|Pulse Glide|Cabana|StrikaPlay)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Pulse Retro|Pulse Sky|Pulse Glide)",
                "model": "$1"
            },
            {
                "regex": "(Cabana)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "StrikaPlay",
                "device": "tablet",
                "model": "Strika Play"
            }
        ]
    },
    "Highscreen": {
        "regex": "HIGHSCREEN|(Easy[- ]Power(?:[- ]Pro)?|Pure[_ ](?:Power|F)|Power Ice(?: Max)?|Easy[_ ]([SFL]|XL)(?:_Pro)?|Razar_Pro|Power Rage(?: Evo)?|Zera-S-Power|Zera[ _][UFS]|Power[ _]?Five[ _]?(?:Pro|Evo|Max|Max(?:Lite|2))|Power(?:Four|Five)|BOOST II(?:se)?|Fest(?:XL)?(?:-Pro)?|Tasty|Boost3|Boost 3(?: Pro)? SE|Expanse|Explosion|Hercules|Alpha Rage|VergeM|Ice2|Prime [LS]|Spade|Spark 2|Alpha GT[RX]|Wallet|Thunder|Razar|COSMO DUO|Prime Mini SE| Bay|Omega Q)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Power Ice(?:[ ](?:Max|Evo))?|Power Rage(?: Evo)?|Zera[ _][UFS]|Alpha GT[RX]|Wallet)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "PowerFivePro(?:[);/ ]|$)",
                "model": "Power Five Pro"
            },
            {
                "regex": "PowerFiveMaxLite(?:[);/ ]|$)",
                "model": "Power Five Max Lite"
            },
            {
                "regex": "PowerFiveMax2(?:[);/ ]|$)",
                "model": "Power Five Max 2"
            },
            {
                "regex": "Power Five Evo(?:[);/ ]|$)",
                "model": "Power Five Evo"
            },
            {
                "regex": "Power Five Max(?:[);/ ]|$)",
                "model": "Power Five Max"
            },
            {
                "regex": "Power[_ ]?Five(?:[);/ ]|$)",
                "model": "Power Five"
            },
            {
                "regex": "Spade(?:[);/ ]|$)",
                "model": "Spade"
            },
            {
                "regex": "Spark 2(?:[);/ ]|$)",
                "model": "Spark 2"
            },
            {
                "regex": "FestXL-Pro(?:[);/ ]|$)",
                "model": "Fest XL Pro"
            },
            {
                "regex": "FestXL(?:[);/ ]|$)",
                "model": "Fest XL"
            },
            {
                "regex": "Fest-Pro(?:[);/ ]|$)",
                "model": "Fest Pro"
            },
            {
                "regex": "Fest(?:[);/ ]|$)",
                "model": "Fest"
            },
            {
                "regex": "Bay(?:[);/ ]|$)",
                "model": "Bay"
            },
            {
                "regex": "PowerFour(?:[);/ ]|$)",
                "model": "Power Four"
            },
            {
                "regex": "Pure[_ ]Power(?:[);/ ]|$)",
                "model": "Pure Power"
            },
            {
                "regex": "Pure[ _]F(?:[);/ ]|$)",
                "model": "Pure F"
            },
            {
                "regex": "Razar_Pro(?:[);/ ]|$)",
                "model": "Razar Pro"
            },
            {
                "regex": "Razar(?:[);/ ]|$)",
                "model": "Razar"
            },
            {
                "regex": "Easy[_ ]([SLF]|XL)[_ ]Pro(?:[);/ ]|$)",
                "model": "Easy $1 Pro"
            },
            {
                "regex": "Easy[_ ]([SFL]|XL)(?:[);/ ]|$)",
                "model": "Easy $1"
            },
            {
                "regex": "(?:HIGHSCREEN )?Easy[- ]Power[- ]Pro(?:[);/ ]|$)",
                "model": "Easy Power Pro"
            },
            {
                "regex": "(?:HIGHSCREEN )?Easy-Power(?:[);/ ]|$)",
                "model": "Easy Power"
            },
            {
                "regex": "Explosion",
                "model": "Explosion"
            },
            {
                "regex": "BOOST II(?:[);/ ]|$)",
                "model": "Boost 2"
            },
            {
                "regex": "BOOST IIse(?:[);/ ]|$)",
                "model": "Boost 2 SE"
            },
            {
                "regex": "Boost 3 SE(?:[);/ ]|$)",
                "model": "Boost 3 SE"
            },
            {
                "regex": "Boost 3 Pro SE(?:[);/ ]|$)",
                "model": "Boost 3 Pro SE"
            },
            {
                "regex": "BOOST3(?:[);/ ]|$)",
                "model": "Boost 3"
            },
            {
                "regex": "Zera-S-Power(?:[);/ ]|$)",
                "model": "Zera S Power"
            },
            {
                "regex": "Tasty(?:[);/ ]|$)",
                "model": "Tasty"
            },
            {
                "regex": "VergeM(?:[);/ ]|$)",
                "model": "Verge M"
            },
            {
                "regex": "WinWin(?:[);/ ]|$)",
                "model": "WinWin"
            },
            {
                "regex": "Expanse(?:[);/ ]|$)",
                "model": "Expanse"
            },
            {
                "regex": "Hercules(?:[);/ ]|$)",
                "model": "Hercules"
            },
            {
                "regex": "Thunder",
                "model": "Thunder"
            },
            {
                "regex": "Alpha Rage(?:[);/ ]|$)",
                "model": "Alpha Rage"
            },
            {
                "regex": "Ice2(?:[);/ ]|$)",
                "model": "Ice 2"
            },
            {
                "regex": "Prime Mini SE(?:[);/ ]|$)",
                "model": "Prime Mini SE"
            },
            {
                "regex": "Prime ([LS])(?:[);/ ]|$)",
                "model": "Prime $1"
            },
            {
                "regex": "COSMO DUO",
                "model": "Cosmo Duo"
            },
            {
                "regex": "Omega Q",
                "model": "Omega Q"
            }
        ]
    },
    "CVTE": {
        "regex": "CVTE[_ ](MSD338_(:?1G|512M))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Globex": {
        "regex": "(GU1011C|GU8012C|GU7013C|GU730C|GU-6012B)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "GU8012C(?:[);/ ]|$)",
                "model": "X8"
            },
            {
                "regex": "GU-6012B(?:[);/ ]|$)",
                "model": "GU6012B"
            },
            {
                "regex": "(GU1011C|GU7013C|GU730C)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Atom": {
        "regex": "ATOM-(108A[ML]|216AL|216RK|216AM)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Qumo": {
        "regex": "QUMO[ _]?|(?:Quest[ _]?(?:408|410|45[56]|50[679])|Vega[ _]?78[23]|Sirius[ _]?(?:1001|890))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:QUMO[ _]?)?Vega[ _]?(78[23]|8002)(?:[);/ ]|$)",
                "model": "Vega $1"
            },
            {
                "regex": "Yooda(?:[);/ ]|$)",
                "model": "Yooda"
            },
            {
                "regex": "Sirius[ _]?(1001|890)(?:[);/ ]|$)",
                "model": "Sirius $1"
            },
            {
                "regex": "(?:QUMO[ _]?)?(Sirius 101-4G 8GB Black|Altair 701 8GB Black|Altair 71 4GB Black|Altair 700[24]|Altair 70[16]|Vega_803i)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:QUMO[ _])?Quest[ _]?(35[34]|40[268]|410|45[2568]|47[46]|50[679]|5[137]0|574|600)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Quest $1"
            }
        ]
    },
    "Qubo": {
        "regex": "(?:Cronos|MINERVA(?:_32GB)?|X668_64GB|X626_4G|Hermes|T104_64GB)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MINERVA(?:_32GB)?(?:[);/ ]|$)",
                "model": "Minerva"
            },
            {
                "regex": "X668_64GB",
                "model": "X668"
            },
            {
                "regex": "(Cronos|Hermes|X626_4G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "T104_64GB(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T104"
            }
        ]
    },
    "Umax": {
        "regex": "VisionBook[ _]|([78]Qa_3G|7A_3G|VB_10Q_Plus|10A_LTE_eea|(?:8|10)C_LTE|10L-PLUS)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(VisionBook[ _](?:10Qi|7Q[i]?|8Q[ei]?|P70|8Qi_3G)(?:[ _](?:[34]G|Plus|LTE))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(7A(?:[ _](?:[34]G)))(?:[);/ ]|$)",
                "model": "VisionBook $1"
            },
            {
                "regex": "([78])Qa_3G(?:[);/ ]|$)",
                "model": "VisionBook $1Qa 3G"
            },
            {
                "regex": "VisionBook_10Q_LTE(?:[);/ ]|$)",
                "model": "VisionBook 10Q LTE"
            },
            {
                "regex": "(8|10)C_LTE(?:[);/ ]|$)",
                "model": "VisionBook $1C LTE"
            },
            {
                "regex": "10L-PLUS",
                "model": "VisionBook 10L Plus"
            },
            {
                "regex": "VisionBook_10Q_Pro(?:[);/ ]|$)",
                "model": "VisionBook 10Q Pro"
            },
            {
                "regex": "10A_LTE_eea(?:[);/ ]|$)",
                "model": "VisionBook 10A LTE"
            },
            {
                "regex": "VB_10Q_Plus(?:[);/ ]|$)",
                "model": "VisionBook 10Q Plus"
            },
            {
                "regex": "VisionBook_P50Plus_LTE(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "VisionBook P50 Plus LTE"
            },
            {
                "regex": "(VisionBook[ _](?:P50 LTE|P55 X2 LTE|P55 LTE(?: Pro)?))(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Mann": {
        "regex": "MANN[ _]|(ZUG 3|ZUG 5S(?: Q)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MANN[ _](8S)",
                "model": "$1"
            },
            {
                "regex": "(ZUG 3|ZUG 5S(?: Q)?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Unihertz": {
        "regex": "((?<!Astra )Titan(_pocket)?|Jelly(?:-Pro| Star| Max|2(?:_JP)?| 2E)|Atom_X?L|Ticktock(?:-S)?|UNIA62_S01|Titan Slim|TANK 01|TANK 2 PRO|TANK2|TANK 3|TANK MINI 1|OB-(?:P10|P08|A98))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Jelly)-Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "Jelly2(?:_JP)?(?:[);/ ]|$)",
                "model": "Jelly 2"
            },
            {
                "regex": "Jelly 2E",
                "model": "Jelly 2E"
            },
            {
                "regex": "Jelly Star",
                "model": "Jelly Star"
            },
            {
                "regex": "Jelly Max",
                "model": "Jelly Max"
            },
            {
                "regex": "Titan_pocket",
                "model": "Titan Pocket"
            },
            {
                "regex": "Titan Slim",
                "model": "Titan Slim"
            },
            {
                "regex": "Ticktock-S",
                "model": "Ticktock S"
            },
            {
                "regex": "UNIA62_S01",
                "model": "Ticktock E"
            },
            {
                "regex": "Ticktock",
                "model": "Ticktock"
            },
            {
                "regex": "TANK 01",
                "model": "Tank 01"
            },
            {
                "regex": "(Titan|Atom_X?L)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "TANK 2 PRO",
                "model": "Tank 2 Pro"
            },
            {
                "regex": "OB-A98",
                "model": "Tank 4 Pro"
            },
            {
                "regex": "TANK MINI 1",
                "model": "Tank Mini 1"
            },
            {
                "regex": "TANK ?([23])",
                "model": "8849 Tank $1"
            },
            {
                "regex": "OB-(P10|P08)",
                "device": "tablet",
                "model": "Tank Pad $1"
            }
        ]
    },
    "Chuwi": {
        "regex": "(?:CW-(Hi8-super|Hi12|V99i?|V17HD3G|VX8-3G|V88-QUAD|V9-DUAL|V88S|Vi[78]|[HV]i10 (?:pro|plus))|Hi10 (?:Pro|plus)|HiPad[ -](?:X|X?Pro|Air|Max)|HiPadX|HiBox-hero|HiBook(?: pro)?|Hi(?:[89]|10)[ _]?(?:Air|[_ ]?X?Pro(?:_PAD)?)|HiPad ?Plus|Hi8SE|Vi8 plus|Vi10(?: ?Pro)?|Surpad|HiPadPro)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(CW-Hi8-super)(?:[);/ ]|$)",
                "model": "Hi8"
            },
            {
                "regex": "(?:CW-)?(Vi10|Hi10|Vi8) plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "CW-(V88)-QUAD(?:[);/ ]|$)",
                "model": "$1 Quad"
            },
            {
                "regex": "CW-(V9)-DUAL(?:[);/ ]|$)",
                "model": "$1 Dual"
            },
            {
                "regex": "CW-(V17HD|VX8)-?(3G)(?:[);/ ]|$)",
                "model": "$1 $2"
            },
            {
                "regex": "(?:CW-)?(Hi10) pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "HiBook pro(?:[);/ ]|$)",
                "model": "HiBook Pro"
            },
            {
                "regex": "HiBook(?:[);/ ]|$)",
                "model": "HiBook"
            },
            {
                "regex": "HiPad ?X(?:[);/ ]|$)",
                "model": "HiPad X"
            },
            {
                "regex": "HiPad ?Pro(?:[);/ ]|$)",
                "model": "HiPad Pro"
            },
            {
                "regex": "HiPad ?XPro(?:[);/ ]|$)",
                "model": "HiPad X Pro"
            },
            {
                "regex": "HiPad-Air(?:[);/ ]|$)",
                "model": "HiPad Air"
            },
            {
                "regex": "HiPad ?Plus(?:[);/ ]|$)",
                "model": "HiPad Plus"
            },
            {
                "regex": "HiPad ?Max(?:[);/ ]|$)",
                "model": "HiPad Max"
            },
            {
                "regex": "Hi([89]) ?Air(?:[);/ ]|$)",
                "model": "Hi$1 Air"
            },
            {
                "regex": "Hi8SE(?:[);/ ]|$)",
                "model": "Hi8 SE"
            },
            {
                "regex": "Hi10_XPro_Pad",
                "model": "Hi10 XPro Pad"
            },
            {
                "regex": "Hi10 ?XPro",
                "model": "Hi10 XPro"
            },
            {
                "regex": "Hi([89]) ?pro(?:[);/ ]|$)",
                "model": "Hi$1 Pro"
            },
            {
                "regex": "Vi10 Plus(?:[);/ ]|$)",
                "model": "Vi10 Plus"
            },
            {
                "regex": "Vi10 ?Pro(?:[);/ ]|$)",
                "model": "Vi10 Pro"
            },
            {
                "regex": "Vi10(?:[);/ ]|$)",
                "model": "Vi10"
            },
            {
                "regex": "Surpad(?:[);/ ]|$)",
                "model": "SurPad"
            },
            {
                "regex": "HiBox-hero(?:[);/ ]|$)",
                "model": "HiBox Hero",
                "device": "desktop"
            },
            {
                "regex": "CW-(Vi[78]|Hi12|V99i?|V88S)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bezkam": {
        "regex": "BEZKAM (BK-RAM2)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NG Optics": {
        "regex": "(NG3128HD)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "KATV1": {
        "regex": "(KATV-01) PRO(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1 Pro"
    },
    "Ghong": {
        "regex": "GHONG(V10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Ghost": {
        "regex": "GHOST G03(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "G03(?:[);/ ]|$)",
                "model": "G03"
            }
        ]
    },
    "Xoro": {
        "regex": "XORO[ _]|(?:TelePAD(?:795|731|1032|10A3|7A3)|HMT(?:390Q?|400)|HST 260)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TelePAD(7|10)A3 4G(?:[);/ ]|$)",
                "model": "TelePad $1 A3 4G"
            },
            {
                "regex": "TelePAD(795|731|1032)(?:[);/ ]|$)",
                "model": "TelePad $1"
            },
            {
                "regex": "MegaPAD3204V5(?:[);/ ]|$)",
                "model": "MegaPad 3204 V5"
            },
            {
                "regex": "HMT(390Q?|400)(?:[);/ ]|$)",
                "model": "HMT $1",
                "device": "portable media player"
            },
            {
                "regex": "HST 260(?:[);/ ]|$)",
                "model": "HST 260",
                "device": "tv"
            }
        ]
    },
    "Vinga": {
        "regex": "VMP-(015-162|021-82|041-162|011-81|025-324|045-664|046-664)(?:[);/ ]|$)|VMP023\\.",
        "device": "tv",
        "models": [
            {
                "regex": "VMP-021-82",
                "model": "021"
            },
            {
                "regex": "VMP-025-324",
                "model": "025"
            },
            {
                "regex": "VMP-015-162",
                "model": "015"
            },
            {
                "regex": "VMP-041-162",
                "model": "041"
            },
            {
                "regex": "VMP-045-664",
                "model": "045"
            },
            {
                "regex": "VMP-011-81",
                "model": "011"
            },
            {
                "regex": "VMP-046-664",
                "model": "046"
            },
            {
                "regex": "VMP023\\.",
                "model": "023"
            }
        ]
    },
    "Viumee": {
        "regex": "(?:SMART[_ ]EV[56]|EV7_Pro|EV6 ELITE|EV5 X|EV7_Play| EV7)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(EV7)_Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "(EV6) ELITE",
                "model": "$1 Elite"
            },
            {
                "regex": "(EV7)_Play",
                "model": "$1 Play"
            },
            {
                "regex": "EV5 X",
                "model": "EV5 X"
            },
            {
                "regex": "EV7(?:[);/ ]|$)",
                "model": "EV7"
            },
            {
                "regex": "SMART[_ ](EV[56])",
                "model": "Smart $1"
            }
        ]
    },
    "Nuvo": {
        "regex": "Nuvo[_ ](NS35|Blue ND40|Green[_ ]ND[_ ]45)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nuvo[_ ](NS35)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Blue (ND40)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Green[_ ]ND[_ ]45(?:[);/ ]|$)",
                "model": "ND45"
            }
        ]
    },
    "Sunvell": {
        "regex": "(?:Sunwell_)?(?:T95ZPLUS|T95[KU]PRO|MINIM8S|MXQ-H3)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:Sunwell_)?T95ZPLUS",
                "model": "T95Z Plus"
            },
            {
                "regex": "(T95[KU])PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "MINIM8S(?:[);/ ]|$)",
                "model": "Mini M8S"
            },
            {
                "regex": "MXQ-H3(?:[);/ ]|$)",
                "model": "MXQ-H3"
            }
        ]
    },
    "Ugoos": {
        "regex": "UGOOS[-_ ]|(?:Android 11(?:[\\d.]*);(?: [\\w-]+;)? UT8|TOX[34](?:_Plus)?)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "UGOOS-UT3 ?Plus",
                "model": "UT3 Plus"
            },
            {
                "regex": "TOX3_Plus",
                "model": "TOX3 Plus"
            },
            {
                "regex": "(UT8|TOX[34])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "UGOOS[- _](\\w{2}\\d+\\w?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Yxtel": {
        "regex": "YXTEL_([HU]1|U3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "PROFiLO": {
        "regex": "PROFILO(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "Proline": {
        "regex": "Proline_|(?:H10882M-TN|H1088[28]M|H1010|M504)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Proline[_ ]FalconXL",
                "device": "smartphone",
                "model": "Falcon XL"
            },
            {
                "regex": "M504",
                "device": "smartphone",
                "model": "Falcon X"
            },
            {
                "regex": "(H10882M-TN|H1088[28]M|H1010)",
                "model": "$1"
            }
        ]
    },
    "Yota": {
        "regex": "(YD20[16]|YOTA 3[+])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YD20[16](?:[);/ ]|$)",
                "model": "Phone 2"
            },
            {
                "regex": "YOTA 3[+](?:[);/ ]|$)",
                "model": "Phone 3 Plus"
            }
        ]
    },
    "Mystery": {
        "regex": "MYSTERY|(MID-(?:123G|72[12]|7[01348]3G|753G|8[23]3G))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MID-(123G|72[12]|7[01348]3G|753G|8[23]3G)(?:[);/ ]|$)",
                "model": "MID-$1"
            },
            {
                "regex": "MYSTERY[_ ]TV[_ ](D\\d{4}[A-Z]{2}\\d{2})",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Ritzviva": {
        "regex": "(RITZVIVA[_ ]S500C)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "S500C"
    },
    "DeWalt": {
        "regex": "DeWalt (MD501)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Runbo": {
        "regex": "Runbo|F1-TT(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Runbo[ _-]?(X5-W|F1 Plus|[PF]1-TT|F1-EN|[FH]1|TT|Q5-S|X5-King|X6|Q5)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "F1-TT",
                "model": "F1-TT"
            },
            {
                "regex": "RunboP2",
                "device": "tablet",
                "model": "P2"
            }
        ]
    },
    "NewsMy": {
        "regex": "(CarPad-(?:II|III)-P)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "Newsday": {
        "regex": "Newsday[_ ](E1|A[12]|N2\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Daewoo": {
        "regex": "Daewoo|(DTA-07IDRF)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(DTA-07IDRF)(?:[);/ ]|$)",
                "model": "Archive 7P"
            },
            {
                "regex": "Daewoo (Android TV 638)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "Daewoo, ?([a-z0-9_ -]+), ?(?:wired|wireless)",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "Vesta": {
        "regex": "VESTA_SMART|VESTA32LD86(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "VESTA32LD86",
                "model": "SmartTV 32LD86S"
            },
            {
                "regex": "VESTA_SMART_TV",
                "model": "SmartTV"
            }
        ]
    },
    "Spectrum": {
        "regex": "(CARBONO_5|CUARZO_6|DIAMANTE_5|VULCANO_55)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VULCANO_55(?:[);/ ]|$)",
                "model": "Vulcano 5.5\""
            },
            {
                "regex": "CARBONO_5(?:[);/ ]|$)",
                "model": "Carbono 5.0\""
            },
            {
                "regex": "CUARZO_6(?:[);/ ]|$)",
                "model": "Cuarzo 6.0\""
            },
            {
                "regex": "DIAMANTE_5(?:[);/ ]|$)",
                "model": "Diamante 5.0\""
            }
        ]
    },
    "Kivi": {
        "regex": "KIVI [24]K|(?:24H600G[RU]|24FR50WU|24HK30B|32HR55GU|32H700GU|32F700WU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|50U730GR|55U600(?:G[RU]|KD)|65UP50GU|55U[PC]50G[RU]|50U600G[RU]|50UX10S|55UR50G[RU]|40FK30G|40FR5[02]BR|43U(?:800B[RU]|600KD|K3[05]G|700GR)|50FK30G|50UK35G|32HR50GR|32[FH]700GR|55UC30G|55U730GR|32HK30G|40FK30G|32HR50GU|32FR50(?:WR|BU)|32FK3[02]G|32F700WR|32H600KD|40U600KD|32H600G[RU])(?:_-Ver0[0-9])?(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(55UC30G|40FK30G|43UK30G|32HR50G[RU]|32HK30G|32FK32G)_-Ver0([0-9])(?:[);/ ]|$)",
                "model": "$1 v$2"
            },
            {
                "regex": "(\\d{2}(?:[HFU]|U[CPRXKX]|[BHF][RK])\\d{2,3}(?:[GW][RU]|B[UR]|KD|[BGS]))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "KIVI ([24]K Android TV)",
                "model": "$1"
            }
        ]
    },
    "DiverMax": {
        "regex": "DiverMax",
        "device": "tv",
        "models": [
            {
                "regex": "DiverMax SpeedBox 3 SB1800(?:[);/ ]|$)",
                "model": "SpeedBox 3"
            }
        ]
    },
    "Divisat": {
        "regex": "(?:Divisat|X-MEDIA|DVS X3|OPTIMA_T-II|J-LINK II)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "J-LINK II",
                "model": "J-Link II"
            },
            {
                "regex": "(?:DVS )?(J-Link|X3)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "X-MEDIA(?:[);/ ]|$)",
                "model": "X-Media"
            },
            {
                "regex": "OPTIMA_T-II(?:[);/ ]|$)",
                "model": "Optima T-II"
            }
        ]
    },
    "ArtLine": {
        "regex": "ARTLINE[ _-](KMX3)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "DIXON": {
        "regex": "DIXON_|(?:ACK1010|KT5512|HK7-3502|DN6015|DFM48|TS-M105G-1|TS_M103A|TS-M704F-1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(ACK1010|KT5512|DFM48)",
                "model": "$1"
            },
            {
                "regex": "HK7-3502",
                "model": "Solis"
            },
            {
                "regex": "DN6015",
                "model": "Astrum"
            },
            {
                "regex": "TS-(M105G|M704F)-1",
                "device": "tablet",
                "model": "TS-$1-1"
            },
            {
                "regex": "TS_M103A",
                "device": "tablet",
                "model": "TS-M103A"
            },
            {
                "regex": "DIXON_XK1_3G(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "XK1 3G"
            }
        ]
    },
    "Kanji": {
        "regex": "KJ[-_](OB0[23]|YU_?BI|SMART4K|GOCHI|ALFARK|AC0[25])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "KJ[-_]OB03",
                "model": "Cata 7"
            },
            {
                "regex": "KJ-GOCHI",
                "model": "Gochi"
            },
            {
                "regex": "KJ[-_]OB02",
                "model": "Ailu Max"
            },
            {
                "regex": "KJ[-_]YU_?BI",
                "model": "Yubi 3G"
            },
            {
                "regex": "KJ[-_]ALFARK",
                "model": "Alfa"
            },
            {
                "regex": "KJ-(AC0[25])",
                "model": "KJ-$1"
            },
            {
                "regex": "KJ-SMART4K",
                "device": "tv",
                "model": "Smart 4K"
            }
        ]
    },
    "Kaiomy": {
        "regex": "KaiCloud[ ]?(7[48]4|942)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "KaiCloud $1"
    },
    "National": {
        "regex": "(NX-32THS100)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Shift Phones": {
        "regex": "(SHIFT6mq?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "RTK": {
        "regex": "ESKIMO_K5001(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "ESKIMO!"
    },
    "RugGear": {
        "regex": "(?:RugGear|RG(?:310|500|65[05]|702|7[13]0|850)|RG725)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(RG[0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "RG725",
                "model": "RG725"
            }
        ]
    },
    "RuggeTech": {
        "regex": "(FieldPad 8)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(FieldPad 8)",
                "model": "$1"
            }
        ]
    },
    "Rhino": {
        "regex": "(?:PACE A1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Pace A1"
    },
    "Ruggex": {
        "regex": "Rhino-Quest(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Rhino-Quest(?:[);/ ]|$)",
                "model": "Rhino Quest"
            }
        ]
    },
    "Maxcom": {
        "regex": "MAXCOM|(?:MS(?:45[036]|505|507_STRONG|514|57[12]|651)|MS457(?:PLUS)?|RS-401|Neva Rise S1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(MS457)PLUS(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "(MS507)_STRONG(?:[);/ ]|$)",
                "model": "$1 Strong"
            },
            {
                "regex": "MS(45[0367]|505|514|57[12]|651)(?:[);/ ]|$)",
                "model": "MS$1"
            },
            {
                "regex": "(?:MAXCOM )(MK241)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "RS-401(?:[);/ ]|$)",
                "model": "RS-401"
            },
            {
                "regex": "Neva Rise S1",
                "model": "Neva Rise S1"
            }
        ]
    },
    "Luna": {
        "regex": "(?:LUNA[ _](?:[VG]55|G[56]0|G9|G6E|V6)|TG-L800S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LUNA[ _]([VG]55|G[56]0|G9|G6E|V6)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(TG-L800S)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Luxor": {
        "regex": "LUXOR, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Protruly": {
        "regex": "PROTRULY[ _](D[78]|V10S)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "JFone": {
        "regex": "JFone[ _](JS501)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Uhans": {
        "regex": "(A101S)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Soyes": {
        "regex": "(?:SOYES[ _](?:[67]S|XS|XS11)|S10-H|XS12 PRO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SOYES[ _]([67]S|XS11|XS)",
                "model": "$1"
            },
            {
                "regex": "S10-H",
                "model": "S10-H"
            },
            {
                "regex": "XS12 PRO",
                "model": "XS12 Pro"
            }
        ]
    },
    "Zidoo": {
        "regex": "ZIDOO[ _](H6 Pro|X6 Pro|X9S|Z10|X[1589]|X20 Pro|Z9S)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Zfiner": {
        "regex": "ZFINERY900(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Y900"
    },
    "EKINOX": {
        "regex": "(?:E8_Ultra)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E8_Ultra",
                "model": "E8 Ultra"
            }
        ]
    },
    "iGet": {
        "regex": "iGET SMART|(?:SMART[_ ](?:L20X|G10[12]|S7[02]|G71|G81[H]?|L10[234]|L11|L3[12]|W[12]0X|W101|W3[12]|W8[4X]|W20[23]|L206)(?:_eea)?|Android 5(?:[\\d.]*);(?: [\\w-]+;)? (?:S100))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:SMART[_ ])?S100(?:[);/ ]|$)",
                "model": "Smart S100"
            },
            {
                "regex": "SMART[_ ](L20X|G10[12]|S7[02]|G71|G81[H]?|L10[234]|L11|W[12]0X|W101|W8[4X]|W3[12]|W20[23]|L206|L3[12])",
                "model": "Smart $1"
            }
        ]
    },
    "Phicomm": {
        "regex": "(PHICOMM|E5051)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "C630 \\(CLUE L\\)(?:[);/ ]|$)",
                "model": "Clue L"
            },
            {
                "regex": "E653\\(ENERGY L\\)(?:[);/ ]|$)",
                "model": "Energy L"
            },
            {
                "regex": "PHICOMM ENERGY 3\\+(?:[);/ ]|$)",
                "model": "Energy 3+"
            },
            {
                "regex": "E5051(?:[);/ ]|$)",
                "model": "Energy 4S"
            },
            {
                "regex": "C6051(?:[);/ ]|$)",
                "model": "Clue 2S"
            },
            {
                "regex": "PHICOMM[ _]Clue[ _]([^/;)]+)(?: Build|[);])",
                "model": "Clue $1"
            }
        ]
    },
    "Huadoo": {
        "regex": "Huadoo[ _]|(?: HG11)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Huadoo[ _](HG0[46]|HG11|V[34])",
                "model": "$1"
            },
            {
                "regex": "HG11(?:[);/ ]|$)",
                "model": "HG11"
            }
        ]
    },
    "Gome": {
        "regex": "(?:GOME[_ ](?:201[678].+|C7_Note(?:_Plus)?|U9|S[17])|Fenmmy_Note)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GOME[_ ](?:2018X38A)(?:[);/ ]|$)",
                "model": "C72"
            },
            {
                "regex": "GOME[_ ](?:2018X07A)(?:[);/ ]|$)",
                "model": "C7"
            },
            {
                "regex": "GOME[_ ](?:2017X05A)(?:[);/ ]|$)",
                "model": "C71"
            },
            {
                "regex": "GOME[_ ](?:2017X82A)(?:[);/ ]|$)",
                "model": "C51"
            },
            {
                "regex": "GOME[_ ](?:2016G68A)(?:[);/ ]|$)",
                "model": "K1"
            },
            {
                "regex": "GOME[_ ](?:2016M25A)(?:[);/ ]|$)",
                "model": "U1"
            },
            {
                "regex": "GOME[_ ](?:2017M27A)(?:[);/ ]|$)",
                "model": "U7"
            },
            {
                "regex": "GOME[_ ](?:2017M95A)(?:[);/ ]|$)",
                "model": "U7 Mini"
            },
            {
                "regex": "GOME[_ ](?:2018M29A)(?:[);/ ]|$)",
                "model": "U9"
            },
            {
                "regex": "GOME[_ ](C7_Note(?:_Plus)?|U9|S[17])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:GOME[_ ])?(Fenmmy_Note)(?:[);/ ]|$)",
                "device": "phablet",
                "model": "$1"
            }
        ]
    },
    "Voyo": {
        "regex": "(?:VOYO[_ ](?:A15)|i8-Max|Q101-4G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "i8-Max(?:[);/ ]|$)",
                "model": "i8 Max"
            },
            {
                "regex": "(Q101)-4G(?:[);/ ]|$)",
                "model": "$1 4G"
            },
            {
                "regex": "VOYO[_ ](A15)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ryte": {
        "regex": "(?:RYTE U55 LTE|RT701)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RYTE (U55 LTE)",
                "model": "$1"
            },
            {
                "regex": "(RT701)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Vontar": {
        "regex": "(HK1 (?:Max|MINI\\+?|PLUS|PRO)|KK MAX|VONTAR[_ -](?:Z[58]|[VH]1|KIII|MX-4K|X[234]|R3|H728)|H618|DQ08)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "DQ08(?:[);/ ]|$)",
                "model": "DQ08"
            },
            {
                "regex": "VONTAR[_ -](Z[58]|[VH]1|KIII|MX-4K|X[234]|H618|H728|R3)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "HK1 Max(?:[);/ ]|$)",
                "model": "HK1 Max"
            },
            {
                "regex": "KK MAX(?:[);/ ]|$)",
                "model": "KK Max"
            },
            {
                "regex": "HK1 MINI\\+(?:[);/ ]|$)",
                "model": "HK1 Mini Plus"
            },
            {
                "regex": "HK1 MINI(?:[);/ ]|$)",
                "model": "HK1 Mini"
            },
            {
                "regex": "HK1 PLUS(?:[);/ ]|$)",
                "model": "HK1 Plus"
            },
            {
                "regex": "HK1 PRO(?:[);/ ]|$)",
                "model": "HK1 Pro"
            }
        ]
    },
    "Vorke": {
        "regex": "VORKE[ _](Z[157]|Z6(?: Plus)?)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Wigor": {
        "regex": "(?:Wigor (?:V4))(?:[);/ ]|$)|Android 7(?:[\\d.]*);(?: [\\w-]+;)? V3(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Wigor (V4)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(V3)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "NEXON": {
        "regex": "NEXON[ _](X[1235]\\+|X[123589]|X10)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "ONN": {
        "regex": "onn\\.|Onn 2k|(?:1000(?:7148[135]|0356[12]|0520[6-9]|11886(?:C?A|_GTW)|26191|43279|44018G?|7148[1356]A?|92980A?|1188[56]|15685-[AE])|ONA19TB00[327]|1001(?:10027|10603|4666[03]|35794|3592[0345])|O8HD|TBBVNC10000520[78])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(1000(?:92980A?|7148[135]A|0356[12]|0520[6-9]|11886(?:C?A|_GTW)|1188[56]|15685-[AE]|26191|43279|44018G?|7148[1356]A?)|ONA19TB00[327]|O8HD|1001(?:4666[03]|10027|10603|35794|3592[0345])|TBBVNC10000520[78])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(4K Streaming Box)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "2k TV stick",
                "device": "tv",
                "model": "2K TV Stick"
            }
        ]
    },
    "EXO": {
        "regex": "(?:Tablet)?EXO_|(?:Wave[_-]i101[GLRS]|Wave[_ ]i007[BT]?|Wave i101[Hb]|Wave i007Kids)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Wave i007Kids(?:[);/ ]|$)",
                "model": "Wave i007 Kids"
            },
            {
                "regex": "(?:Tablet)?(?:EXO_)?(Wave[_-]i101[GLRS]|Wave[_ ]i007[BT]?|Wave i101[Hb])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Q.Bell": {
        "regex": "(QPHONE[_ ](?:10\\.1|9\\.[12]|7\\.1|5\\.[246])|QTAB10EW)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(QPHONE[_ ](?:10\\.1|9\\.[12]|7\\.1|5\\.[246]))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "QTAB10EW",
                "device": "tablet",
                "model": "QTAB10EW"
            }
        ]
    },
    "Datawind": {
        "regex": "DW-[A-Z0-9]{5}(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(DW-PS3G5)(?:[);/ ]|$)",
                "model": "Pocket Surfer 3G5"
            },
            {
                "regex": "DW-UBT7W",
                "device": "tablet",
                "model": "Ubislate 7W"
            }
        ]
    },
    "Droidlogic": {
        "regex": "(i96 Pro)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Droxio": {
        "regex": "DROXIO (C40|A47|B45|KENTIA)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "3GO": {
        "regex": "(?:Aplay ?[34])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Aplay ?([34])",
                "device": "tablet",
                "model": "Aplay $1"
            }
        ]
    },
    "Goophone": {
        "regex": "Goophone[ _]|(?:M(G492|L7[JK]2)CH|MN(4A2|8J2)ZP|MGA92ZP|MKU82ZP|MNGW2CH|MNH02CH|MNRM2CH)[/]A(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:MG492CH|MGA92ZP)[/]A(?:[);/ ]|$)",
                "model": "I6 Plus"
            },
            {
                "regex": "ML7[JK]2CH[/]A(?:[);/ ]|$)",
                "model": "I6"
            },
            {
                "regex": "MKU82ZP[/]A(?:[);/ ]|$)",
                "model": "I6S"
            },
            {
                "regex": "MNGW2CH[/]A(?:[);/ ]|$)",
                "model": "I6S Plus"
            },
            {
                "regex": "(?:MN4A2ZP|MNH02CH)[/]A(?:[);/ ]|$)",
                "model": "I7"
            },
            {
                "regex": "(?:MN8J2ZP|MNRM2CH)[/]A(?:[);/ ]|$)",
                "model": "I7 Plus"
            },
            {
                "regex": "S4 MEGA(?:[);/ ]|$)",
                "model": "S4 Mega"
            },
            {
                "regex": "Goophone i([69])(?:[);/ ]|$)",
                "model": "I$1"
            }
        ]
    },
    "PocketBook": {
        "regex": "PocketBook[ _/]",
        "device": "tablet",
        "models": [
            {
                "regex": "A7(?:[);/ ]|$)",
                "model": "A7"
            },
            {
                "regex": "A10 3G(?:[);/ ]|$)",
                "model": "A10 3G"
            },
            {
                "regex": "A10(?:[);/ ]|$)",
                "model": "A10"
            },
            {
                "regex": "SURFpad2(?:[);/ ]|$)",
                "model": "SURFpad 2"
            },
            {
                "regex": "PocketBook SURFpad 3 \\(([\\d]+)[,.]([\\d]+)[\"]?\\)(?:[);/ ]|$)",
                "model": "SURFpad 3 $1.$2\""
            },
            {
                "regex": "SURFpad 4 ([LMS])(?:[);/ ]|$)",
                "model": "SURFpad 4 $1"
            },
            {
                "regex": "PocketBook/(515|614|62[23467]|63[012]|64[01]|650|740|801|840|970)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bitmore": {
        "regex": "(?:Mobitab10c-3G|Tab1011Q_II|Colortab[ _]?(10(?:M| II)?|816i))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Mobitab)(10)c-3G(?:[);/ ]|$)",
                "model": "$1 $2C 3G"
            },
            {
                "regex": "Tab1011Q_II(?:[);/ ]|$)",
                "model": "Tab1011Q II"
            },
            {
                "regex": "Colortab[ _]?(10(?:M| II)?|816i)(?:[);/ ]|$)",
                "model": "ColorTab $1"
            }
        ]
    },
    "Bittium": {
        "regex": "Bittium",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tough Mobile 2(?:[);/ ]|$)",
                "model": "Tough Mobile 2"
            }
        ]
    },
    "Kuliao": {
        "regex": "KULIAO (K10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Sugar": {
        "regex": "SUGAR[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUGAR Y([78]) MAX(?:[);/ ]|$)",
                "model": "Y$1 Max"
            },
            {
                "regex": "SUGAR S60 pro(?:[);/ ]|$)",
                "model": "S60 Pro"
            },
            {
                "regex": "SUGAR F7 Mini(?:[);/ ]|$)",
                "model": "F7 Mini"
            },
            {
                "regex": "SUGAR[ _]([^);/]+) ?Dual(?: Build|[);])",
                "model": "$1 Dual"
            },
            {
                "regex": "SUGAR[ _]([^);/]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Subor": {
        "regex": "SUBOR[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "SUBOR[ _](S5|2019)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SUBOR[_ ]K10PLUS(?:[);/ ]|$)",
                "model": "K10 Plus"
            }
        ]
    },
    "Xshitou": {
        "regex": "Xshitou[_ ](P7)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "JKL": {
        "regex": "JKL[_ ](A28)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Gree": {
        "regex": "(?:G0[256]15D|G0245D|G0335D)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "G0515D",
                "model": "Tosot 5G"
            },
            {
                "regex": "G0615D",
                "model": "Tosot 7G"
            },
            {
                "regex": "(G0215D|G0245D|G0335D)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Vodacom": {
        "regex": "(?:Vodacom)[ _]|(?:Kicka 5 Plus 4G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Kicka 5 Plus 4G",
                "device": "smartphone",
                "model": "Kicka 5 Plus 4G"
            },
            {
                "regex": "(?:Vodacom)[ _](Power Tab 10)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "VKworld": {
        "regex": "(?:(?:VK700)-MAX|VK700 Pro|T5SE|VK700[0X]|vk6050|vk6735|vk700)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(VK700)-MAX(?:[);/ ]|$)",
                "model": "$1 Max"
            },
            {
                "regex": "(VK700) Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "T5SE(?:[);/ ]|$)",
                "model": "T5 SE"
            },
            {
                "regex": "VK(700[0X]|6050|6735|700)(?:[);/ ]|$)",
                "model": "VK$1"
            }
        ]
    },
    "Mito": {
        "regex": "MITO[- _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "MITO[- _]3255(?:[);/ ]|$)",
                "device": "tv",
                "model": "3255"
            },
            {
                "regex": "MITO[- _]A37[_ ]Z1plus",
                "model": "A37 Z1 Plus"
            },
            {
                "regex": "MITO[- _](A(?:19[_ ][12]GB|37[_ ]Z1|36[_ ]W1|[0-9]+)|311)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MITO[- _](T(?:[0-9]+))(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "TWM": {
        "regex": "Amazing[ _](X[35]s|X[123567]|A5S|A3[025]|A[468]|A4S|A5[057]|P6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Amazing[ _](X[35])s(?:[);/ ]|$)",
                "model": "Amazing $1S"
            },
            {
                "regex": "Amazing[ _](A5S|X[123567]|A[468]|A4S|A5[057]|A3[025])(?:[);/ ]|$)",
                "model": "Amazing $1"
            },
            {
                "regex": "Amazing[ _](P6)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Amazing $1"
            }
        ]
    },
    "TWZ": {
        "regex": "TWZ[-_ ](?:TabPlay|Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])|TWZQQ1|(?:OX_X1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TWZ[_ ]TabPlay[_ ](12[56])",
                "device": "tablet",
                "model": "TabPlay $1"
            },
            {
                "regex": "TWZ[-_ ]?(Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])",
                "model": "$1"
            },
            {
                "regex": "OX_X1",
                "model": "OX X1"
            }
        ]
    },
    "Oale": {
        "regex": "(?:Apex(?:[123])|CC1 PRO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(CC1) PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "Apex([123])",
                "model": "Apex $1"
            }
        ]
    },
    "Mobo": {
        "regex": "(?:(?:MOBO[_ ]MB7005|MT7-421HD)|(?:MT7-442D|MT7-411D))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:MOBO[_ ])?(MB7005|MT7-421HD|MT7-442D|MT7-411D)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Macoox": {
        "regex": "(MC-X7MINI)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "MC-X7 Mini"
    },
    "Prixton": {
        "regex": "(?:T1700Q-)?PRIXTON|(T7012Q)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "PRIXTON (C18)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(T701[24]Q|T1700Q)",
                "model": "$1"
            }
        ]
    },
    "Mafe": {
        "regex": "Mafe_(?:M8[12]0|M825)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mafe_M820",
                "model": "Shine M820"
            },
            {
                "regex": "Mafe_(M810|M825)",
                "model": "$1"
            }
        ]
    },
    "Magnus": {
        "regex": "(?:Magnus[ _](?:bravoZ[23]0|Infinity_?(?:G8|G11))|bravo Z40|Bravo Z11|bravo[-_]Z[12]2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "bravo[ _-]?(Z[234]0|Z11|Z[12]2)",
                "model": "Bravo $1"
            },
            {
                "regex": "(?:Magnus[ _])?Infinity_?(G8|G11)",
                "model": "Infinity $1"
            }
        ]
    },
    "Newland": {
        "regex": "NLS-(?:MT90|NFT10|MT65)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NLS-MT90",
                "model": "MT90 Orca"
            },
            {
                "regex": "NLS-MT65",
                "device": "peripheral",
                "model": "MT65 Beluga IV"
            },
            {
                "regex": "NLS-NFT10",
                "model": "NFT10 Pilot Pro"
            }
        ]
    },
    "Orbic": {
        "regex": "(?:RC(?:2200|501|545|555|60[89])L|R678EL|R8L5T|RC608L2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "R678EL",
                "model": "Magic 5G"
            },
            {
                "regex": "RC501L",
                "model": "Slim"
            },
            {
                "regex": "RC545L",
                "model": "Maui"
            },
            {
                "regex": "RC555L",
                "model": "Wonder"
            },
            {
                "regex": "RC2200L",
                "model": "Journey V"
            },
            {
                "regex": "RC608L",
                "model": "Joy"
            },
            {
                "regex": "RC609L",
                "model": "Q10"
            },
            {
                "regex": "R8L5T",
                "device": "tablet",
                "model": "Tab8 5G"
            }
        ]
    },
    "RedLine": {
        "regex": "(?:Space_M10|S[678]00[ _]MAX|IP-[678]0 MAX|RED360 Air 8K)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(Space_M10)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "RED360 Air 8K",
                "model": "RED360 Air 8K"
            },
            {
                "regex": "S([678]00)[ _]MAX",
                "model": "S$1 Max"
            },
            {
                "regex": "IP-([678]0) MAX",
                "model": "IP-$1 Max"
            }
        ]
    },
    "RED": {
        "regex": "(?:H1A1000)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Hydrogen One"
    },
    "RED-X": {
        "regex": "RED_X_",
        "device": "smartphone",
        "models": [
            {
                "regex": "RED_X_RX2441_4G(?:[);/ ]|$)",
                "model": "RX2441"
            }
        ]
    },
    "Contixo": {
        "regex": "Contixo|(?:CX-1045 3G|KT995 3G|CX1045|B108_4G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CX-?1045(?: 3G)?(?:[);/ ]|$)",
                "model": "CX-1045 3G"
            },
            {
                "regex": "CX-?1065(?: 3G)?(?:[);/ ]|$)",
                "model": "CX-1065 3G"
            },
            {
                "regex": "CONTIXO GX 1035(?:[);/ ]|$)",
                "model": "GX-1035 4G 10.1\""
            },
            {
                "regex": "Contixo GT1160 4G(?:[);/ ]|$)",
                "model": "GT1160 4G 10.1\""
            },
            {
                "regex": "B105(?:[);/ ]|$)",
                "model": "B105 3G 10.1\""
            },
            {
                "regex": "B108(?:[_ ]4G)?(?:[);/ ]|$)",
                "model": "B108 4G 10.1\""
            },
            {
                "regex": "KT107(?: 3G)?(?:[);/ ]|$)",
                "model": "KT107 3G 10.1\""
            },
            {
                "regex": "K109(?:[);/ ]|$)",
                "model": "KT109 4G 10.1\""
            },
            {
                "regex": "KT715 3G(?:[);/ ]|$)",
                "model": "KT715 3G 7.0\""
            },
            {
                "regex": "KT995(?:[);/ ]|$)",
                "model": "KT995 3G 10.1\""
            },
            {
                "regex": "KT ?1100GT(?: 4G)?(?:[);/ ]|$)",
                "model": "KT1100GT"
            }
        ]
    },
    "E-Ceros": {
        "regex": "(?:CT9716(?:-B)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CT9716(?:[);/ ]|$)",
                "model": "Revolution"
            },
            {
                "regex": "CT9716-B(?:[);/ ]|$)",
                "model": "Revolution HD"
            }
        ]
    },
    "How": {
        "regex": "(?:HT-705XS|705-G Go|1001-G Go)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(HT-705XS)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(1001-G Go)(?:[);/ ]|$)",
                "model": "HT-1001G Go Kids"
            },
            {
                "regex": "(705-G Go)(?:[);/ ]|$)",
                "model": "HT-$1"
            }
        ]
    },
    "multibox": {
        "regex": "(Fundroid MB(?:18|216))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Multilaser": {
        "regex": "Multilaser[ _]|ML-TI-MS|(?:MS50[LGXM]|M7[_-]3G[_-](?:PLUS|QC_3|QUAD_CORE)|MS5\\.V2|M9-3G|MS45S_A6|ML([02]1|12)-M7s[- ]?Quad-?Core| ML01-M7-SD|MS45S|MS50S|MS60[XZ]|M7SQC_Plus|MS80X|MS40[GS]|MS55M|MS70|M7_3G_A10|M7_3G|M7S_PLUS|M10A?_3G|M7-3G QUAD CORE|M7s_?Lite|M[79]_WIFI|ML-(?:SO|WI)-M9-3G|M10A-Lite|M10_4G_PRO|MS50L?_4G|MS60F(?:_PLUS)?|MS45S_A6_(?:Teen|Senior)|MLX8|ML-WI-M7_3G_PLUS|KIDPAD_LITE|M8_4G)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Multilaser[ _]([EFG])[_ ]Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "Multilaser[_ ]Elite[_ ]2",
                "model": "Elite 2"
            },
            {
                "regex": "Multilaser[ _]F[_ ]Pro[ _]2(?:[);/ ]|$)",
                "model": "F Pro 2"
            },
            {
                "regex": "Multilaser[ _]G[_ ]Max(?:[);/ ]|$)",
                "model": "G Max"
            },
            {
                "regex": "Multilaser[ _]GMAX_2(?:[);/ ]|$)",
                "model": "G Max 2"
            },
            {
                "regex": "Multilaser[ _]G_?MAX_2_SE",
                "model": "G Max 2 SE"
            },
            {
                "regex": "Multilaser[ _]G(?:[);/ ]|$)",
                "model": "G"
            },
            {
                "regex": "Multilaser[ _]G[ _]2(?:[);/ ]|$)",
                "model": "G2"
            },
            {
                "regex": "Multilaser[ _]E[_ ]Lite(?:[);/ ]|$)",
                "model": "E Lite"
            },
            {
                "regex": "Multilaser[ _]([H])[_ ]5G(?:[);/ ]|$)",
                "model": "$1 5G"
            },
            {
                "regex": "Multilaser[ _]([FEH])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Multilaser[ _]ZAPP(?:[);/ ]|$)",
                "model": "ZAPP"
            },
            {
                "regex": "Multilaser[ _]ZAPP[ _]II[ _]3G(?:[);/ ]|$)",
                "model": "ZAPP II"
            },
            {
                "regex": "MS60F_PLUS(?:[);/ ]|$)",
                "model": "MS60F Plus"
            },
            {
                "regex": "MS45S_A6_Senior",
                "model": "MS45S A6 Senior"
            },
            {
                "regex": "MS45S_A6_Teen",
                "model": "MS45S A6 Teen"
            },
            {
                "regex": "(MS50[LGXSM]|MS45S_A6|MS40[GS]|MS55M|MS60F|MS70|MS60[XZ]|MS45S|MS80X|MS50L?_4G|MS5\\.V2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:ML-WI-)?M7[_-]3G[_-]PLUS(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7 3G Plus"
            },
            {
                "regex": "M7S_PLUS",
                "device": "tablet",
                "model": "M7S Plus"
            },
            {
                "regex": "M([79])_WIFI(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M$1 WiFi"
            },
            {
                "regex": "M10_4G_PRO(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M10 4G Pro"
            },
            {
                "regex": "M8_4G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M8 4G"
            },
            {
                "regex": "M7SQC_PLUS(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7SQC Plus"
            },
            {
                "regex": "M7-3G_QC_3(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7 3G Quad Core 3"
            },
            {
                "regex": "M7-3G[ _]QUAD[ _]CORE(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7 3G Quad Core"
            },
            {
                "regex": "ML([02]1|12)-M7s[- ]?Quad-?Core(?:[);/ ]|$)",
                "device": "tablet",
                "model": "ML$1-M7s Quad Core"
            },
            {
                "regex": "M7s_?Lite(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7s Lite"
            },
            {
                "regex": "ML01-M7-SD(?:[);/ ]|$)",
                "device": "tablet",
                "model": "ML01-M7 SD"
            },
            {
                "regex": "M10A-Lite(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M10A Lite"
            },
            {
                "regex": "(?:ML-(?:SO|WI)-)?M9-3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M9 3G"
            },
            {
                "regex": "M7_3G_A10(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M7 3G A10"
            },
            {
                "regex": "MLX8(?:[);/ ]|$)",
                "device": "tablet",
                "model": "X8 4G"
            },
            {
                "regex": "M(10A?|7)_3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "M$1 3G"
            },
            {
                "regex": "KIDPAD_LITE(?:[);/ ]|$)",
                "device": "tablet",
                "model": "KidPad Lite"
            },
            {
                "regex": "ML-TI-(MS\\d+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Positivo BGH": {
        "regex": "(?:T1060B|S455|Positivo (?:Twist|Ypy|Mini I)|Twist[ _](?:\\(2018\\)|2 (?:Fit|Pro)|Mini|Tab|Metal(?: 32GB)?|Max|XL|SE|[23SM])|KC770|G1101T)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S455(?:[);/ ]|$)",
                "model": "Selfie"
            },
            {
                "regex": "Twist \\(2018\\)(?:[);/ ]|$)",
                "model": "Twist (2018)"
            },
            {
                "regex": "Twist Metal 32GB(?:[);/ ]|$)",
                "model": "Twist Metal 32GB"
            },
            {
                "regex": "Twist Metal(?:[);/ ]|$)",
                "model": "Twist Metal"
            },
            {
                "regex": "Twist Max(?:[);/ ]|$)",
                "model": "Twist Max"
            },
            {
                "regex": "Twist[ _]Mini(?:[);/ ]|$)",
                "model": "Twist Mini"
            },
            {
                "regex": "Twist 2 Fit(?:[);/ ]|$)",
                "model": "Twist 2 Fit"
            },
            {
                "regex": "Twist 2 Go(?:[);/ ]|$)",
                "model": "Twist 2 Go"
            },
            {
                "regex": "Twist 2 Pro(?:[);/ ]|$)",
                "model": "Twist 2 Pro"
            },
            {
                "regex": "Twist XL(?:[);/ ]|$)",
                "model": "Twist XL"
            },
            {
                "regex": "Twist SE(?:[);/ ]|$)",
                "model": "Twist SE"
            },
            {
                "regex": "(?:Positivo )?Twist ([23SM])(?:[);/ ]|$)",
                "model": "Twist $1"
            },
            {
                "regex": "(?:Positivo )Mini I(?:[);/ ]|$)",
                "model": "Mini I"
            },
            {
                "regex": "(T1060B|KC770|G1101T)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Positivo Ypy (AB7F|AB10H|L1050E)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Ypy $1"
            },
            {
                "regex": "Twist Tab(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Twist Tab"
            }
        ]
    },
    "Maxtron": {
        "regex": "Maxtron[ _-](V[327]|V1[2357]|V20|S[89]|T1|Genio|Apollo|PLUTO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Maxtron[ _-]PLUTO",
                "model": "Pluto"
            },
            {
                "regex": "Maxtron[ _-](V[327]|S[89]|V1[2357]|V20|Apollo)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Maxtron[ _-](T1|Genio)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Philco": {
        "regex": "PHILCO[ /]|(PCS0[12]|PH350B|PTB(?:10|[78])R|PTB7PAP_PTB7PAB_PTB7PAR|Hit Max|Hit P1[023]|HIT P8|HIT P10a|TP7A4|TP10A1I)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HIT P10a",
                "model": "Hit P10a"
            },
            {
                "regex": "Hit (P1[023]|P8)",
                "model": "Hit $1"
            },
            {
                "regex": "(PCS0[12]|PH350B|Hit Max)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(PTB(?:10|[78])R|TP7A4|TP10A1I)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "PHILCO Android TV(?:[);/ ]|$)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "PH60D16DSGWN4K(?:[);/ ]|$)",
                "device": "tv",
                "model": "PH60D16DSGWN4K"
            },
            {
                "regex": "PTB7PAP_PTB7PAB_PTB7PAR(?:[);/ ]|$)",
                "device": "tablet",
                "model": "PTB7PA"
            }
        ]
    },
    "SEMP TCL": {
        "regex": "(?:GO[35]E|5101J|GO3C(?: Plus)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "5101J(?:[);/ ]|$)",
                "model": "L9 Plus"
            },
            {
                "regex": "GO3C Plus(?:[);/ ]|$)",
                "model": "GO! 3C Plus"
            },
            {
                "regex": "GO3C(?:[);/ ]|$)",
                "model": "GO! 3C"
            },
            {
                "regex": "(GO[35]E)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Newman": {
        "regex": "Newman[ _](P308|K1|G5i)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Swipe": {
        "regex": "(?:Slate2|Swipe_(?:Elite_3M?|Strike8)|Elite_(?:Grace|VR)|EliteDual|Elite (?:Prime|Star|Note|Sense|Power)|Konnect (?:Prime|Power|Neo 4G))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Konnect Power",
                "model": "Konnect Power"
            },
            {
                "regex": "Konnect Prime",
                "model": "Konnect Prime"
            },
            {
                "regex": "Konnect Neo 4G",
                "model": "Konnect Neo 4G"
            },
            {
                "regex": "(?:Swipe_)?Elite[_ ]?(Sense|VR|3M?|Grace|Star|Prime|Note|Dual|Power)(?:[);/ ]|$)",
                "model": "Elite $1"
            },
            {
                "regex": "Slate2(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Slate 2"
            },
            {
                "regex": "Swipe[_ ]Strike8",
                "device": "tablet",
                "model": "Strike 8"
            }
        ]
    },
    "Owwo": {
        "regex": "(?:OWWO[ _]?(?:[1457]S|Q[78])|CARNIVAL B5)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "OWWO[ _]?([1457]S|Q[78])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CARNIVAL B5(?:[);/ ]|$)",
                "model": "Carnival B5"
            }
        ]
    },
    "TD Systems": {
        "regex": "(K(?:24|32)DLX9HS|K40DLM8FS|K40DLX9FS|K50DLX9US|K50DLJ10US|K43DLJ10US|K32DLX10HS|K32DLJ12HS)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Ravoz": {
        "regex": "RAVOZ[ _](Z[3567] (?:Lite|Pro)|Z[3-7]|R[4789]|V[1235])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Tone": {
        "regex": "TONE[ _-](e19|m1[57]|e2[01])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "AT&T": {
        "regex": "ATT_|(?:EA1002|EA21100[125]|EABF22206A|U(?:202|304|31[89]|328|380|626|668|6080|705)AA|QS5509A|V340U|V350U|WTATTRW2|SL112A|SL219A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:ATT_)?EA211101(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "Cingular Flex"
            },
            {
                "regex": "(?:ATT_)?U1030AA(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "Cingular Flex 2"
            },
            {
                "regex": "(?:ATT_)?U102AA(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "Cingular Flip IV"
            },
            {
                "regex": "EA211005",
                "model": "Fusion 5G"
            },
            {
                "regex": "U304AA",
                "model": "Radiant Core"
            },
            {
                "regex": "U705AA",
                "model": "Radiant Max"
            },
            {
                "regex": "EA211001",
                "model": "Radiant Max 5G"
            },
            {
                "regex": "QS5509A",
                "model": "Axia"
            },
            {
                "regex": "SL219A",
                "model": "Verge"
            },
            {
                "regex": "U318AA",
                "model": "Calypso"
            },
            {
                "regex": "U319AA",
                "model": "Calypso 2"
            },
            {
                "regex": "U328AA",
                "model": "Calypso 3"
            },
            {
                "regex": "U380AA",
                "model": "Calypso 4"
            },
            {
                "regex": "U202AA",
                "model": "Maestro"
            },
            {
                "regex": "EA1002",
                "model": "Maestro Max"
            },
            {
                "regex": "V350U",
                "model": "Maestro Plus"
            },
            {
                "regex": "U626AA",
                "model": "Maestro 3"
            },
            {
                "regex": "EA211002",
                "model": "Motivate 2"
            },
            {
                "regex": "EABF22206A",
                "model": "Motivate 3"
            },
            {
                "regex": "SL112A",
                "model": "Motivate 4"
            },
            {
                "regex": "U668AA",
                "model": "Motivate Max"
            },
            {
                "regex": "WTATTRW2",
                "model": "Vista"
            },
            {
                "regex": "U6080AA",
                "model": "Propel 5G"
            },
            {
                "regex": "V340U(?:[);/ ]|$)",
                "model": "Fusion Z"
            }
        ]
    },
    "BIHEE": {
        "regex": "(ZBH-)?BIHEE",
        "device": "smartphone",
        "models": [
            {
                "regex": "(A1[1268]|A[78]\\+|A[56])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Enot": {
        "regex": "Enot[ _-](E102|J101)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Kooper": {
        "regex": "Kooper-mobile-W502(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Mobile W502"
    },
    "Lesia": {
        "regex": "ANOVA A5(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Anova A5"
    },
    "Anry": {
        "regex": "ANRY-(RS10|[SX]20|E30|1006)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tinai": {
        "regex": "Tinai (K[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Winds": {
        "regex": "(?:NOTE GRACE V)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOTE GRACE V",
                "model": "Note Grace V"
            }
        ]
    },
    "Asano": {
        "regex": "(?:32LH7010T|32LH8030S|43L[FU]8120T|43LU8030S|43LU8130S|32LH8[10]10T|32LH7030S|32LF7130S|28LH701[10]T|43LU8010T|24LH701[01]T|24L[HF]7020T|24LF8010T|24LH801[01]T|28LH81[12]0T|40LF7030S|40LF7010T|5[05]LU8120T|42LF7110T|32LH7011T|32LF7120T|32LF8120T|50LU8110T|50LU8130S|40LF8120T|50LF7010T|43LF7202T|43LF7010T|32LH8011T|32LF7111T|40LF8130S|40LF7030ST|42LF8120T|42LF8130S|43LU6000T|50LU6000T|32LH5000T|55LU8030S)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(\\d{2})(L[FHU]\\d+[ST]T?)(?:[);/ ]|$)",
                "model": "$1$2 $1.0\""
            }
        ]
    },
    "Phonemax": {
        "regex": "(?:PHONEMAX[_ ](?:Saturn(?:[_ ]X)?|Mars|Venus X)|Rocky 2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PHONEMAX[_ ]Saturn[_ ]X(?:[);/ ]|$)",
                "model": "Saturn X"
            },
            {
                "regex": "PHONEMAX[_ ]Saturn(?:[);/ ]|$)",
                "model": "Saturn"
            },
            {
                "regex": "PHONEMAX[_ ]Mars(?:[);/ ]|$)",
                "model": "Mars"
            },
            {
                "regex": "PHONEMAX[_ ]Venus X(?:[);/ ]|$)",
                "model": "Venus X"
            },
            {
                "regex": "Rocky 2(?:[);/ ]|$)",
                "model": "Rocky 2"
            }
        ]
    },
    "Vipro": {
        "regex": "VIPRO[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ViPro S20(?:[);/ ]|$)",
                "model": "S20"
            },
            {
                "regex": "VIPRO PRO2X(?:[);/ ]|$)",
                "model": "Pro 2X"
            },
            {
                "regex": "Vipro Edge 2(?:[);/ ]|$)",
                "model": "Edge 2"
            },
            {
                "regex": "VIPRO PRO[ _-]?([0-9])(?:[);/ ]|$)",
                "model": "Pro $1"
            }
        ]
    },
    "Virzo": {
        "regex": "(?:V608C|V50[15]c|VT701)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "V(50[15]|608)C(?:[);/ ]|$)",
                "model": "V$1c"
            },
            {
                "regex": "(VT701)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "OzoneHD": {
        "regex": "Ozone HD|OzoneHD[ _]?(T2 WiFi|Nexo|4K(?: TV)?|Fun|Neo)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Kzen": {
        "regex": "(?:Ureki_U1|Victor V1|Lamia L01|DART KZ07|REX RX|Eva_E01|Majesty (?:M5|4G))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ureki_U1",
                "model": "Ureki U1"
            },
            {
                "regex": "Eva_E01",
                "model": "Eva E01"
            },
            {
                "regex": "Victor V1",
                "model": "Victor V1"
            },
            {
                "regex": "REX RX",
                "model": "Rex RX"
            },
            {
                "regex": "Lamia L01",
                "model": "Lamia L01"
            },
            {
                "regex": "Majesty (M5|4G)",
                "model": "Majesty $1"
            },
            {
                "regex": "DART KZ07",
                "device": "tablet",
                "model": "Dart KZ07"
            }
        ]
    },
    "Melrose": {
        "regex": "MELROSE[_ ](?:S9\\+?|S9P|2019)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MELROSE[_ ]S9\\+(?:[);/ ]|$)",
                "model": "S9 Plus"
            },
            {
                "regex": "MELROSE[_ ](S9|S9P)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "MELROSE_2019(?:[);/ ]|$)",
                "model": "2019 Ultra Slim 3.4\""
            }
        ]
    },
    "Crony": {
        "regex": "CRONY-7021(?:[);/ ]|$)",
        "device": "tablet",
        "model": "7021"
    },
    "T96": {
        "regex": "T96mini(?:[);/ ]|$)",
        "device": "tv",
        "model": "Mini"
    },
    "TADAAM": {
        "regex": "TADAAM",
        "device": "tv",
        "models": [
            {
                "regex": "TADAAM BOX(?:[);/ ]|$)",
                "model": "TV Box"
            }
        ]
    },
    "Takara": {
        "regex": "(MID169|MID211H)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tronsmart": {
        "regex": "(Orion R68G|Draco AW80|Draco H3|Vega S95_(?:Meta|Pro|Telos))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Amigoo": {
        "regex": "AMIGOO (R300|R9 Max|M1 Max|X15)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Lumigon": {
        "regex": "Lumigon[ _](T3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "NEKO": {
        "regex": "(?:NEKO_(?:WK?_)?LT[-_](\\w+)|LT-\\d{2}N(?:[HF]8020S|X8001S|F7021S))(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:NEKO_)?(?:WK?_)?LT[-_](\\w+)(?:[);/ ]|$)",
                "model": "LT-$1"
            }
        ]
    },
    "Neomi": {
        "regex": "NEO[ ]?(90[689])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Neo $1"
    },
    "Eltex": {
        "regex": "(?:NV5(?:01|10)WAC|NV501|NV731|NV[57]10WB|NV72[01]WB|NV711WAC|NV73[01]WB)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "NV(501|510|711)WAC(?:[);/ ]|$)",
                "model": "NV-$1-Wac"
            },
            {
                "regex": "NV(501|731)(?:[);/ ]|$)",
                "model": "NV-$1"
            },
            {
                "regex": "NV(\\d{3})WB(?:[);/ ]|$)",
                "model": "NV-$1-WB"
            }
        ]
    },
    "Senkatel": {
        "regex": "Senkatel[ _]|(?:MaximusT1001)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MaximusT1001",
                "model": "Maximus T1001"
            },
            {
                "regex": "Senkatel[ _](T1009|T8002|T701[12]|T9702)",
                "model": "$1"
            }
        ]
    },
    "Bobarry": {
        "regex": "(?:K10[ ]?SE)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "K10 SE"
    },
    "Wortmann": {
        "regex": "TERRA[ _]PAD[ _](\\d+)(_V2)?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Terra Pad $1$2"
    },
    "BB Mobile": {
        "regex": "bb-mobile|Techno[-_ ](8\\.0|9\\.7|TQ863Q|X595BT|X800BJ|S700BF|I700AJ|10\\.1 LTE TQ060X|7\\.0 LTE TQ763I|I785AP|I101BI)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Techno[_ ]S700BF(?:[);/ ]|$)",
                "model": "Techno 7.0\" Pioneer LTE S700BF"
            },
            {
                "regex": "Techno[_ ]10\\.1 LTE TQ060X(?:[);/ ]|$)",
                "model": "Techno 10.0\" LTE TQ060X"
            },
            {
                "regex": "Techno[_ ]TQ863Q(?:[);/ ]|$)",
                "model": "Techno 8.0\" Poplar LTE TQ863Q"
            },
            {
                "regex": "Techno[_ ]I700AJ(?:[);/ ]|$)",
                "model": "Techno 7.0\" Mozg LTE I700AJ"
            },
            {
                "regex": "Techno[-_ ]I785AP(?:[);/ ]|$)",
                "model": "Techno 7.85\" Mozg I785AP"
            },
            {
                "regex": "Techno[_ ]X800BJ(?:[);/ ]|$)",
                "model": "Techno 8.0\" Mozg X800BJ"
            },
            {
                "regex": "Techno[-_ ]I101BI(?:[);/ ]|$)",
                "model": "Techno 10.1\" Mozg I101BI"
            },
            {
                "regex": "Techno[_ ]7\\.0 LTE TQ763I(?:[);/ ]|$)",
                "model": "Techno 7.0\" Kalash LTE TQ763I"
            },
            {
                "regex": "(FirstTab TP-17)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Techno[_ ](9\\.7|[78]\\.0) 3G(?:[);/ ]|$)",
                "model": "Techno $1\" 3G"
            },
            {
                "regex": "Techno[_ ](?:X595BT)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Techno Spark 3G X595BT"
            }
        ]
    },
    "2E": {
        "regex": "(?:E500A_2019|2E E450 2018)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E500A_2019(?:[);/ ]|$)",
                "model": "E500A (2019)"
            },
            {
                "regex": "2E E450 2018(?:[);/ ]|$)",
                "model": "E450 (2018)"
            }
        ]
    },
    "Billion": {
        "regex": "Capture\\+(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Capture Plus"
    },
    "Telkom": {
        "regex": "(TVB-100)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Tele2": {
        "regex": "Tele2[ _]|Tele2fon",
        "device": "smartphone",
        "models": [
            {
                "regex": "Tele2fon[_ ]V6",
                "model": "V6"
            },
            {
                "regex": "Tele2[ _](Mi[dn]i)[ _]1[_.]1(?:[);/ ]|$)",
                "model": "$1 1.1"
            },
            {
                "regex": "Tele2[ _]Midi[ _]2[_.]0(?:[);/ ]|$)",
                "model": "Midi 2.0"
            },
            {
                "regex": "Tele2[ _]((?:Maxi|Midi)(?:[_ ](?:Plus|LTE))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Tele2[ _](Mi[dn]i)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "ALDI NORD": {
        "regex": "ALDINORD, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "ALDI S\xdcD": {
        "regex": "ALDISUED, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "Alfawise": {
        "regex": "(?:Alfawise (?:A9)|(?:A95X_R1|Z28Pro))(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(A95X_R1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Z28Pro(?:[);/ ]|$)",
                "model": "Z28 Pro"
            },
            {
                "regex": "Alfawise (A9)",
                "model": "$1"
            }
        ]
    },
    "Klipad": {
        "regex": "KLIPAD_|(?:KL-V905|KL(2108NBE|[46]889|489[08]|9878A?E?|3669|759[01]|50[05]|638DK|60[15]|988)?(?:_EEA)?|7589AN|KL628_HL|KL628KO|KL4898[_ -]A50|V356B?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:KLIPAD_)?(V355B?|KL600|KL-V905|V356B?|KL50[05]|KL60[15])(?:_EEA)?(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(KL[46]889|7589AN|KL759[01]|KL9878A?E?|KL628KO|KL3669|KL489[08]|KL988|KL2108NBE|KL638DK)(?:_EEA)?(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "KL628_HL",
                "device": "tablet",
                "model": "KL628HL"
            },
            {
                "regex": "KL4898[_ -]A50",
                "device": "tablet",
                "model": "KL4898-A50"
            }
        ]
    },
    "SQOOL": {
        "regex": "SQOOL-V(41?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "V$1"
    },
    "TurboPad": {
        "regex": "Turbopad[-_ ]?(72[34]|80[23]|912|101[456]|Pro)(?:NEW)?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TurboKids": {
        "regex": "(?:Turbokids[-_ ]?(TMNT|3G|S4|Princess|3GNEW)|Monsterpad 3G| TMNT)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Monsterpad 3G",
                "model": "MonsterPad 3G"
            },
            {
                "regex": "Turbokids[-_ ]?3GNEW",
                "model": "3G New"
            },
            {
                "regex": "TMNT(?:[);/ ]|$)",
                "model": "TMNT"
            },
            {
                "regex": "Turbokids[-_ ]?(TMNT|3G|S4|Princess)",
                "model": "$1"
            }
        ]
    },
    "T\xfcrk Telekom": {
        "regex": "Turk Telekom",
        "device": "smartphone",
        "models": [
            {
                "regex": "TT175(?:[);/ ]|$)",
                "model": "TT175"
            }
        ]
    },
    "FRESH": {
        "regex": "FRESH SMART TV",
        "device": "tablet",
        "model": "Smart TV"
    },
    "Jinga": {
        "regex": "Jinga[-_ ]|(?:(?:Fresh|Optim)4G|Pass(?:Plus|3G)|PicassoNote|Hotz[_ ]M1|WinPRO|Touch4G|(?<!Qupi TV )Start(?:3G|LTE)?|IGO[ _]L[41]|Basco[ _](?:L3|L[45]00|L45[01]|XS1|S2|M1)|M500-1|Hit4G|A450|Neon(?!/)|IGO_L3|JoyPRO|Fresh|GoalPlus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Optim4G(?:[);/ ]|$)",
                "model": "Optim 4G"
            },
            {
                "regex": "Fresh4G(?:[);/ ]|$)",
                "model": "Fresh 4G"
            },
            {
                "regex": "Hotz[_ ]M1(?:[);/ ]|$)",
                "model": "Hotz M1"
            },
            {
                "regex": "Hit4G(?:[);/ ]|$)",
                "model": "Hit 4G"
            },
            {
                "regex": "PassPlus(?:[);/ ]|$)",
                "model": "Pass Plus"
            },
            {
                "regex": "Pass3G(?:[);/ ]|$)",
                "model": "Pass 3G"
            },
            {
                "regex": "GoalPlus(?:[);/ ]|$)",
                "model": "Goal Plus"
            },
            {
                "regex": "(Win|Joy)PRO(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "Touch4G(?:[);/ ]|$)",
                "model": "Touch 4G"
            },
            {
                "regex": "Start3G(?:[);/ ]|$)",
                "model": "Start 3G"
            },
            {
                "regex": "StartLTE(?:[);/ ]|$)",
                "model": "Start LTE"
            },
            {
                "regex": "Start(?:[);/ ]|$)",
                "model": "Start"
            },
            {
                "regex": "PicassoNote(?:[);/ ]|$)",
                "model": "Picasso Note"
            },
            {
                "regex": "Jinga Iron(?:[);/ ]|$)",
                "model": "Iron"
            },
            {
                "regex": "Fresh(?:[);/ ]|$)",
                "model": "Fresh"
            },
            {
                "regex": "IGO_L3(?:[);/ ]|$)",
                "model": "IGO L3"
            },
            {
                "regex": "Jinga Basco neo(?:[);/ ]|$)",
                "model": "Basco Neo"
            },
            {
                "regex": "M500-1(?:[);/ ]|$)",
                "model": "Basco M500 3G"
            },
            {
                "regex": "(?:Jinga[ _])?Basco[ _](L[13]|L[45]00|XS1|S2|L45[01]|M1)(?:[);/ ]|$)",
                "model": "Basco $1"
            },
            {
                "regex": "Jinga Trezor S1 Plus(?:[);/ ]|$)",
                "model": "Trezor S1 Plus"
            },
            {
                "regex": "JINGA_IGO_L2(?:[);/ ]|$)",
                "model": "IGO L2"
            },
            {
                "regex": "(?:JINGA[_ ])?IGO[_ ]([ML]1|L4)(?:[);/ ]|$)",
                "model": "IGO $1"
            },
            {
                "regex": "(?:JINGA[_ ])?(Neon|A450)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Jio": {
        "regex": "Jio/[^/]+/|LS1542QWN?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LS1542QWN?(?:[);/ ]|$)",
                "model": "JioPhone Next"
            },
            {
                "regex": "Jio/([^/]+)/",
                "model": "$1"
            }
        ]
    },
    "Twoe": {
        "regex": "(?:TWOE[-_ ]E450R|F534L|F572L|E500A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TWOE[-_ ](E450R)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(F534L|F572L|E500A)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "iTruck": {
        "regex": "iTRUCK 7 3G(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "7.0\" 3G"
    },
    "Torex": {
        "regex": "(?:TOREX[- _](?:PS12|S18|S27|PAD 8 ?PRO|PAD818)|PAD831B|TOREX831B)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TOREX-(PS12)",
                "model": "$1"
            },
            {
                "regex": "TOREX831B",
                "model": "Pad 831B"
            },
            {
                "regex": "(?:TOREX[_ ])?PAD(831B|818)",
                "model": "Pad $1"
            },
            {
                "regex": "TOREX PAD 8 ?PRO",
                "model": "Pad 8 Pro"
            },
            {
                "regex": "TOREX[- ](S18|S27)",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "Doffler": {
        "regex": "(24DHS54|32GHS5[67]|40KFS57|32KHS57|43KUS65|24[KG]HS57|24GHS55|50KUS65|40GHS57|43GUS65|55KUS65|65KUS65|42GFS56)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Oyyu": {
        "regex": "OYYUT11(?:[);/ ]|$)",
        "device": "tablet",
        "model": "T11 3G"
    },
    "Primux": {
        "regex": "Primux|SirocoY|Omega6_4G(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Primux_ioxphone(?:[);/ ]|$)",
                "model": "IOX Phone"
            },
            {
                "regex": "PrimuxDelta6(?:[);/ ]|$)",
                "model": "Delta 6"
            },
            {
                "regex": "PrimuxKappa(P50[01])(?:[);/ ]|$)",
                "model": "Kappa $1"
            },
            {
                "regex": "PrimuxKappa(?:[);/ ]|$)",
                "model": "Kappa"
            },
            {
                "regex": "Primux_Beta2(?:[);/ ]|$)",
                "model": "Beta 2"
            },
            {
                "regex": "Primux_?Omega([57])(?:[);/ ]|$)",
                "model": "Omega $1"
            },
            {
                "regex": "Omega6_4G(?:[);/ ]|$)",
                "model": "Omega 6 4G"
            },
            {
                "regex": "PrimuxUP(?:[);/ ]|$)",
                "device": "tablet",
                "model": "UP"
            },
            {
                "regex": "PrimuxZonda4(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Zonda 4"
            },
            {
                "regex": "Primux_Siroco6(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Siroco 6"
            },
            {
                "regex": "SirocoY(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Siroco Y"
            }
        ]
    },
    "iMars": {
        "regex": "(?:IMARS VEGA X7|VIVI_8|MILKY_WAY_M2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IMARS VEGA X7",
                "model": "Vega X7"
            },
            {
                "regex": "VIVI_8",
                "model": "VIVI 8"
            },
            {
                "regex": "MILKY_WAY_M2",
                "model": "Milky Way M2"
            }
        ]
    },
    "Logic": {
        "regex": "LOGIC[_ ]|(?:LOGIC[_ ](X4 Plus|X50|X[135]|X4M|L4T|L5D|X5[AFT]|X57A|X60G|L50T?|L57|L6[0135]|X60_PLUS)(:?[_ ]LITE2?)?|L55[ABS]|Q-502|L68_Ultra)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LOGIC[_ ]X60_PLUS(?:[);/ ]|$)",
                "model": "X60 Plus"
            },
            {
                "regex": "L68_Ultra",
                "model": "L68 Ultra"
            },
            {
                "regex": "LOGIC[_ ](L65|X5|X4M)[_ ]LITE(?:[);/ ]|$)",
                "model": "$1 Lite"
            },
            {
                "regex": "LOGIC[_ ](L65)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "LOGIC[_ ](X5)[_ ]LITE2(?:[);/ ]|$)",
                "model": "$1 Lite 2"
            },
            {
                "regex": "LOGIC[_ ](X4 Plus|X50|X[13]|X4M|L4T|L5D|L6[013]|X5[AFT]|X57A|X60G)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(L50T?|L55[ABS]|L57|Q-502)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Cloud": {
        "regex": "(?:Cirrus_C2|Cyclone_C4|Storm_C3|Stratus_C[57](?:_Elite)?|Stratus C8|Sunshine_T1|Typhoon_C6|Sunshine_T1_Elite)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Stratus_C5_Elite",
                "model": "Stratus C5 Elite"
            },
            {
                "regex": "(Cirrus_C2|Cyclone_C4|Storm_C3|Stratus[_ ]C[578]|Typhoon_C6)",
                "model": "$1"
            },
            {
                "regex": "(Sunshine_T1(?:_Elite)?)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Cloudpad": {
        "regex": "\\+VT(?:107C|Q007C)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "\\+VT(107C)",
                "model": "+VT$1"
            },
            {
                "regex": "\\+VTQ(007C)",
                "model": "+VTQ$1"
            }
        ]
    },
    "Cloudfone": {
        "regex": "CloudFone[ _]|(?:Thrill[ _](?:Boost[ ]?(2|3)?|Power|Snap|Access|Plus 16GB|Lite|HD)|Excite Prime 2 Pro|Excite Prime|ExciteC|NBA Edition|Go SP|Next Infinity Plus|Next Infinity|Next Lite|Go Connect)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Thrill Boost 2 Plus(?:[);/ ]|$)",
                "model": "Thrill Boost 2 Plus"
            },
            {
                "regex": "Thrill Boost (2|3)(?:[);/ ]|$)",
                "model": "Thrill Boost $1"
            },
            {
                "regex": "Thrill[ _]Boost(?:[);/ ]|$)",
                "model": "Thrill Boost"
            },
            {
                "regex": "Thrill Snap(?:[);/ ]|$)",
                "model": "Thrill Snap"
            },
            {
                "regex": "Thrill Plus 16GB(?:[);/ ]|$)",
                "model": "Thrill Plus 16GB"
            },
            {
                "regex": "Thrill Power(?:[);/ ]|$)",
                "model": "Thrill Power"
            },
            {
                "regex": "Thrill Access(?:[);/ ]|$)",
                "model": "Thrill Access"
            },
            {
                "regex": "Thrill Lite(?:[);/ ]|$)",
                "model": "Thrill Lite"
            },
            {
                "regex": "Thrill HD(?:[);/ ]|$)",
                "model": "Thrill HD"
            },
            {
                "regex": "Excite Prime 2 Pro",
                "model": "Excite Prime 2 Pro"
            },
            {
                "regex": "Excite Prime 2",
                "model": "Excite Prime 2"
            },
            {
                "regex": "Excite Prime",
                "model": "Excite Prime"
            },
            {
                "regex": "ExciteC",
                "model": "Excite C"
            },
            {
                "regex": "NBA Edition(?:[);/ ]|$)",
                "model": "NBA Edition"
            },
            {
                "regex": "(Go SP(?: 2)?|Next Infinity (?:Pro|Plus)|Next Infinity|Go Connect(?: Lite)?(?: 2)?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Next Lite(?:[);/ ]|$)",
                "model": "Next Lite"
            },
            {
                "regex": "Next(?:[);/ ]|$)",
                "model": "Next"
            }
        ]
    },
    "V\xf6lfen": {
        "regex": "Nexo-TAB-7(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nexo-TAB-7(?: Build|[;)])",
                "device": "tablet",
                "model": "Nexo TAB7"
            }
        ]
    },
    "Vsmart": {
        "regex": "(?:Joy [123]\\+|Joy [34]|Active 1\\+|Bee 3|Active [13]|V341U|Bee Lite|Aris| Bee|Star [345])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Joy ([123])\\+(?:[);/ ]|$)",
                "model": "Joy $1 Plus"
            },
            {
                "regex": "Joy ([34])(?:[);/ ]|$)",
                "model": "Joy $1"
            },
            {
                "regex": "Active 1\\+(?:[);/ ]|$)",
                "model": "Active 1 Plus"
            },
            {
                "regex": "Bee 3(?:[);/ ]|$)",
                "model": "Bee 3"
            },
            {
                "regex": "Bee Lite",
                "model": "Bee Lite"
            },
            {
                "regex": "Bee(?:[);/ ]|$)",
                "model": "Bee"
            },
            {
                "regex": "Star (\\d)(?:[);/ ]|$)",
                "model": "Star $1"
            },
            {
                "regex": "Active (\\d)(?:[);/ ]|$)",
                "model": "Active $1"
            },
            {
                "regex": "V341U(?:[);/ ]|$)",
                "model": "Hobson"
            },
            {
                "regex": "Aris Pro",
                "model": "Aris Pro"
            },
            {
                "regex": "Aris",
                "model": "Aris"
            }
        ]
    },
    "MiXzo": {
        "regex": "(?:MiXzo[ _])?(?:ME ?10(?:2[35]|30)|MX1037|MX1024|MX10[24]1|MX1397)([ _][34]G)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MiXzo[_ ]ME ?(1023|1030)(?:[_ ]([34])G)(?:[);/ ]|$)",
                "model": "ME$1 $2G"
            },
            {
                "regex": "MiXzo[_ ]MX1021(?:[_ ]3G)?(?:[);/ ]|$)",
                "model": "MX1021 3G"
            },
            {
                "regex": "(?:MiXzo[ _])?MX(1037|1041|1024|1397)[ _]4G(?:[);/ ]|$)",
                "model": "MX$1 4G"
            },
            {
                "regex": "ME ?1025",
                "model": "ME1025 3G"
            }
        ]
    },
    "Openbox": {
        "regex": "(?:Openbox (?:A[3489](?: (?:Pro|Lite))?|GOLD)|AS1_HD|AS_?4K[_-](?:CI(?:_PRO|_Lite)?(?:_PLUS)?|PLUS|2X)|AS_?4K)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Openbox (A[3489](?: (?:Pro|Lite))?)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "AS_4K_CI_PRO_PLUS",
                "model": "AS 4K CI Pro Plus"
            },
            {
                "regex": "AS_4K_CI_Lite",
                "model": "AS 4K CI Lite"
            },
            {
                "regex": "AS_?4K_CI_PRO",
                "model": "AS 4K CI Pro"
            },
            {
                "regex": "AS_?4K[_-](2X|CI)",
                "model": "AS 4K $1"
            },
            {
                "regex": "AS_?4K[_-]PLUS",
                "model": "AS 4K Plus"
            },
            {
                "regex": "AS1_HD",
                "model": "AS1 HD"
            },
            {
                "regex": "AS_?4K",
                "model": "AS 4K"
            },
            {
                "regex": "OPENBOX GOLD",
                "model": "Gold"
            }
        ]
    },
    "Ziox": {
        "regex": "ZIOX[_ ]|(?:Astra Viva 4G|Astra (?:(?:NXT|Curve|Young) Pro|(?:Metal|Titan|Young|Curve) 4G|Star|Blaze)|Duo(?:tel|pix)[ _]\\w\\d{1,2})(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZIOX[_ ]F9[_ ]PRO(?:[);/ ]|$)",
                "model": "F9 Pro"
            },
            {
                "regex": "Astra (Viva|Titan|Young|Metal|Curve) 4G(?:[);/ ]|$)",
                "model": "Astra $1 4G"
            },
            {
                "regex": "Astra (Star|Blaze)(?:[);/ ]|$)",
                "model": "Astra $1"
            },
            {
                "regex": "Astra (NXT|Curve|Young) Pro(?:[);/ ]|$)",
                "model": "Astra $1 Pro"
            },
            {
                "regex": "Duopix F9 Pro",
                "model": "Duopix F9 Pro"
            },
            {
                "regex": "Duo(tel|pix)[ _](\\w\\d{1,2})(?:[);/ ]|$)",
                "model": "Duo$1 $2"
            }
        ]
    },
    "iDroid": {
        "regex": "(?:APACHE G6|iDroid Royal V5|BALR_?X7(?:_PAK)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "APACHE G6",
                "model": "Apache G6"
            },
            {
                "regex": "Royal V5",
                "model": "Royal V5"
            },
            {
                "regex": "BALR_?X7",
                "model": "Barl X7"
            }
        ]
    },
    "Aoson": {
        "regex": "(?:aoson ?(?:R10[1-3]|S[78]|M707TG|M96T)(?:[_ ]?Pro)?|R103)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:aoson ?)?R10([1-3])(?:[);/ ]|$)",
                "model": "R10$1 10.1\""
            },
            {
                "regex": "aoson ?S7_Pro(?:[);/ ]|$)",
                "model": "S7 Pro 7.0\""
            },
            {
                "regex": "aoson ?S7(?:[);/ ]|$)",
                "model": "S7 7.0\""
            },
            {
                "regex": "aoson ?S8Pro(?:[);/ ]|$)",
                "model": "S8 Pro 8.0\""
            },
            {
                "regex": "aoson ?(M707TG|M96T)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "FireFly Mobile": {
        "regex": "(?:AURII[ _](?:FAME|VIVID|INSPIRE|MAGNUM|Passion|Virtuoso|RAZOR|ULTRA|Secret Lite|AMUSE[_ ]3G|FORCE|FUSION|F8[_ ]Premium|XCITE|DELIGHT|DREAM[_ ](?:MINI|One)|AMUSE_4G)|SECRET_XR?|INTENSE[ _](?:POWER|METAL_2|XT)|RAZOR_PLUS_4G|SUPER SWEET|SWEET MINI|Dream_One_8|INSPIRE_4G|S90_Q|INTENSE_METAL_4G|INTENSE (?:5|XL)|VIVID_PRO|VIVID_PREMIUM)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AURII[ _]FORCE(?:[);/ ]|$)",
                "model": "Aurii Force"
            },
            {
                "regex": "AURII[ _]VIVID(?:[);/ ]|$)",
                "model": "Aurii Vivid"
            },
            {
                "regex": "AURII[ _]INSPIRE(?:[);/ ]|$)",
                "model": "Aurii Inspire"
            },
            {
                "regex": "AURII[ _]RAZOR(?:[);/ ]|$)",
                "model": "Aurii Razor"
            },
            {
                "regex": "RAZOR_PLUS_4G(?:[);/ ]|$)",
                "model": "Aurii Razor Plus"
            },
            {
                "regex": "AURII[ _]DELIGHT(?:[);/ ]|$)",
                "model": "Aurii Delight"
            },
            {
                "regex": "AURII[ _]DREAM[_ ]MINI(?:[);/ ]|$)",
                "model": "Aurii Dream Mini"
            },
            {
                "regex": "AURII[ _]FAME(?:[);/ ]|$)",
                "model": "Aurii Fame"
            },
            {
                "regex": "AURII[ _]AMUSE[ _]4G(?:[);/ ]|$)",
                "model": "Aurii Amuse 4G"
            },
            {
                "regex": "Dream_One_8(?:[);/ ]|$)",
                "model": "Aurii Dream One 8"
            },
            {
                "regex": "AURII[ _]DREAM[_ ]One(?:[);/ ]|$)",
                "model": "Aurii Dream One"
            },
            {
                "regex": "AURII[ _]ULTRA(?:[);/ ]|$)",
                "model": "Aurii Ultra"
            },
            {
                "regex": "AURII[ _]AMUSE[_ ]3G(?:[);/ ]|$)",
                "model": "Aurii Amuse 3G"
            },
            {
                "regex": "AURII[ _]FUSION(?:[);/ ]|$)",
                "model": "Aurii Fusion"
            },
            {
                "regex": "AURII[ _]MAGNUM(?:[);/ ]|$)",
                "model": "Aurii Magnum"
            },
            {
                "regex": "VIVID_PRO(?:[);/ ]|$)",
                "model": "Aurii Vivid Pro"
            },
            {
                "regex": "VIVID_PREMIUM(?:[);/ ]|$)",
                "model": "Aurii Vivid Premium"
            },
            {
                "regex": "AURII[ _]XCITE(?:[);/ ]|$)",
                "model": "Aurii xCite"
            },
            {
                "regex": "SECRET_(XR?)(?:[);/ ]|$)",
                "model": "Aurii Secret $1"
            },
            {
                "regex": "AURII[ _]((?:Passion|Virtuoso|Secret Lite|F8[_ ]Premium))(?:[);/ ]|$)",
                "model": "Aurii $1"
            },
            {
                "regex": "INTENSE POWER(?:[);/ ]|$)",
                "model": "Intense Power"
            },
            {
                "regex": "INTENSE_XT(?:[);/ ]|$)",
                "model": "Intense XT"
            },
            {
                "regex": "INTENSE_METAL_4G(?:[);/ ]|$)",
                "model": "Intense Metal 4G"
            },
            {
                "regex": "INTENSE_METAL_2(?:[);/ ]|$)",
                "model": "Intense Metal 2"
            },
            {
                "regex": "SUPER SWEET(?:[);/ ]|$)",
                "model": "Super Sweet"
            },
            {
                "regex": "SWEET MINI(?:[);/ ]|$)",
                "model": "Sweet Mini"
            },
            {
                "regex": "Inspire_4G",
                "model": "Inspire 4G"
            },
            {
                "regex": "INTENSE (5|XL)",
                "model": "Intense $1"
            },
            {
                "regex": "(S90_Q)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "FISE": {
        "regex": "Fise_",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fise_32433_3G(?:[);/ ]|$)",
                "device": "feature phone",
                "model": "M32433 3G"
            }
        ]
    },
    "I KALL": {
        "regex": "IKALL",
        "device": "smartphone",
        "model": ""
    },
    "i-Cherry": {
        "regex": "iCherry_?",
        "device": "smartphone",
        "models": [
            {
                "regex": "iCherry[ _](C(?:25[1258]|21[16]|110|121|22[01379]|23[03])|X1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "iCherry-C256",
                "device": "tablet",
                "model": "C256 Nano 3G"
            }
        ]
    },
    "NextTab": {
        "regex": "TAB (A40[13]0)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Time2": {
        "regex": "(TC1050G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1 10.1\""
    },
    "Sunstech": {
        "regex": "(TAB(?:2323GMQC|1081|918QC|917QC-(?:8|16)GB)|TAB1090)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Hotwav": {
        "regex": "(?:Venus[_ ](?:X[12]|X1[0245679]|R8 PLUS|R[236-9]|R1[028]|X16-1)|Cosmos[ _](?:V8_lite|V19_Plus|V2[0-3]|U2?|V1[359]|V[45689]|V8-2)|Pearl K[123]|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13])|Hot[_ ]6|Symbol (?:M1|X|Max|R60|Pro|S4)|Symbol|Note 12 EF|Cyber (?:[78X]|1[35])|Cyber (?:9|1[36]|X) Pro|Cosmos|W10 Pro|TAB R8(?! 5G)|TAB R[57]|TAB R[69] (?:Pro|Ultra|Plus)|T5 Pro| M5i|Hyper 7(?: Pro|S)?)(?:[);/ ]|$)|(?:Android 8(?:[\\d.]*);(?: [\\w-]+;)? M5 Plus|Android 12(?:[\\d.]*);(?: [\\w-]+;)? W10|Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:T7(?: Pro)?|T5 Max|W11))(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cosmos[ _]V8_lite(?:[);/ ]|$)",
                "model": "Cosmos V8 Lite"
            },
            {
                "regex": "Hot[_ ]6?(?:[);/ ]|$)",
                "model": "Hot 6"
            },
            {
                "regex": "Venus R8 PLUS",
                "model": "Venus R8 Plus"
            },
            {
                "regex": "Venus[_ ]X16(?:-1)?(?:[);/ ]|$)",
                "model": "Venus X16"
            },
            {
                "regex": "Venus[_ ](X[12]|X1[0245679]|R[236-9]|R1[028])(?:[);/ ]|$)",
                "model": "Venus $1"
            },
            {
                "regex": "Cyber (\\d*|X) Pro",
                "model": "Cyber $1 Pro"
            },
            {
                "regex": "Cyber X",
                "model": "Cyber X"
            },
            {
                "regex": "Cyber (\\d*)",
                "model": "Cyber $1"
            },
            {
                "regex": "Hyper 7 Pro",
                "model": "Hyper 7 Pro"
            },
            {
                "regex": "Hyper 7S",
                "model": "Hyper 7S"
            },
            {
                "regex": "Hyper 7",
                "model": "Hyper 7"
            },
            {
                "regex": "T5 Max",
                "model": "T5 Max"
            },
            {
                "regex": "Symbol (S4|M1)",
                "model": "Symbol $1"
            },
            {
                "regex": "(W10|T[57]) Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "W10?(?:[);/ ]|$)",
                "model": "W10"
            },
            {
                "regex": "(T7)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M5i(?:[);/ ]|$)",
                "model": "M5i"
            },
            {
                "regex": "W11(?:[);/ ]|$)",
                "model": "W11"
            },
            {
                "regex": "Pearl K(3) (2021)",
                "model": "Pearl K$1 ($2)"
            },
            {
                "regex": "Symbol R60",
                "device": "phablet",
                "model": "Symbol R60"
            },
            {
                "regex": "Note 12 EF",
                "device": "phablet",
                "model": "Note 12 EF"
            },
            {
                "regex": "TAB R([569]) Pro",
                "device": "tablet",
                "model": "Tab R$1 Pro"
            },
            {
                "regex": "TAB R([9]) Plus",
                "device": "tablet",
                "model": "Tab R$1 Plus"
            },
            {
                "regex": "TAB R6 Ultra",
                "device": "tablet",
                "model": "Tab R6 Ultra"
            },
            {
                "regex": "TAB R([578])",
                "device": "tablet",
                "model": "Tab R$1"
            },
            {
                "regex": "(Cosmos[ _](?:V19_Plus|V2[0-3]|U2?|V1[359]|V[45689])|Pearl K[123](?: Prime)?|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13])|Symbol (?:X|Max)|Cosmos|M5 Plus)(?:-2)?(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Symbol Pro",
                "model": "Symbol Pro"
            },
            {
                "regex": "Symbol",
                "model": "Symbol"
            }
        ]
    },
    "Tetratab": {
        "regex": "CASEBOOK_3(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Casebook 3"
    },
    "Dolamee": {
        "regex": "Dolamee[_ -](D[56])(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Invin": {
        "regex": "INVIN[ _-]|(?:IPC002|KM5PRO)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "INVIN[ _-](X[24]|KM[678])",
                "model": "$1"
            },
            {
                "regex": "KM5PRO",
                "model": "KM5 Pro"
            },
            {
                "regex": "(IPC002)",
                "model": "$1"
            }
        ]
    },
    "Doopro": {
        "regex": "Doopro P3(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "P3"
    },
    "IQM": {
        "regex": "IQM (?:picasso|vivaldi|newton)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "IQM picasso(?:[);/ ]|$)",
                "model": "Picasso"
            },
            {
                "regex": "IQM vivaldi(?:[);/ ]|$)",
                "model": "Vivaldi"
            },
            {
                "regex": "IQM newton(?:[);/ ]|$)",
                "model": "Newton"
            }
        ]
    },
    "Nos": {
        "regex": "Nos (?:FIVE|NOVU|NEVA|Roya)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NOS FIVE(?:[);/ ]|$)",
                "model": "Five"
            },
            {
                "regex": "NOS NOVU III(?:[);/ ]|$)",
                "model": "Novu III"
            },
            {
                "regex": "NOS NOVU II(?:[);/ ]|$)",
                "model": "Novu II"
            },
            {
                "regex": "NOS NOVU(?:[);/ ]|$)",
                "model": "Novu"
            },
            {
                "regex": "NOS NEVA 80(?:[);/ ]|$)",
                "model": "Neva 80"
            },
            {
                "regex": "NOS Roya(?:[);/ ]|$)",
                "model": "Roya"
            }
        ]
    },
    "Accent": {
        "regex": "Accent_|(?:FAST7 ?3G|PEARL[_ ]A[24567]|TANK_P55|CAMELEON[_ ](?:C[456]|A1|H2)(?:[_ ]PLUS)?|Speed[- ](?:[AXYM]2|X2\\+)|SURF1000|KIDZY70|SPEED_S8)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ACCENT[_ ]NEON(?:[);/ ]|$)",
                "model": "Neon"
            },
            {
                "regex": "ACCENT[_ ](?:Nubia)?([56]0K)(?:28_512)?(?:[);/ ]|$)",
                "model": "Nubia $1"
            },
            {
                "regex": "CAMELEON[_ ]C([65])[_ ]PLUS(?:[);/ ]|$)",
                "model": "Cameleon C$1 Plus"
            },
            {
                "regex": "Speed[- _]([AXYM]2|S8)(?:[);/ ]|$)",
                "model": "Speed $1"
            },
            {
                "regex": "Speed-X2\\+(?:[);/ ]|$)",
                "model": "Speed X2 Plus"
            },
            {
                "regex": "CAMELEON[_ ](C[456]|A1|H2)(?:[);/ ]|$)",
                "model": "Cameleon $1"
            },
            {
                "regex": "PEARL A4 Lite(?:[);/ ]|$)",
                "model": "Pearl A4 Lite"
            },
            {
                "regex": "PEARL A4 PLUS(?:[);/ ]|$)",
                "model": "Pearl A4 Plus"
            },
            {
                "regex": "PEARL[_ ]A([24567])(?:[);/ ]|$)",
                "model": "Pearl A$1"
            },
            {
                "regex": "TANK_P55(?:[);/ ]|$)",
                "model": "Tank P55"
            },
            {
                "regex": "FAST7 ?3G(?:[);/ ]|$)",
                "device": "tablet",
                "model": "FAST7 3G"
            },
            {
                "regex": "SURF1000(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Surf 1000"
            },
            {
                "regex": "KIDZY70(?:[);/ ]|$)",
                "device": "tablet",
                "model": "Kidzy 70"
            }
        ]
    },
    "Avenzo": {
        "regex": "Avenzo(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MOB4 4G(?:[);/ ]|$)",
                "model": "Mob 4 4G"
            },
            {
                "regex": "MOB4PRO 4G(?:[);/ ]|$)",
                "model": "Mob 4 Pro 4G"
            }
        ]
    },
    "Beelink": {
        "regex": "(?:Beelink (?:G[ST]1|LAKE I|SEA I|A1)|GTKing(?:_AT(?:_ATV)?|II)?|GT1mini-2|GT1-mini(?:[-_]AT(?:_ATV)?)?|R68 II|Amlogic Alvatech GT1)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Beelink (G[ST]1|LAKE I|SEA I|A1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Amlogic Alvatech GT1(?:[);/ ]|$)",
                "model": "GT1"
            },
            {
                "regex": "GT1-mini(?:-AT(?:_ATV)?)?(?:[);/ ]|$)",
                "model": "GT1 Mini"
            },
            {
                "regex": "GT1mini-2(?:[);/ ]|$)",
                "model": "GT1 Mini 2"
            },
            {
                "regex": "GTKing PRO(?:[);/ ]|$)",
                "model": "GT King Pro"
            },
            {
                "regex": "GTKingII(?:[);/ ]|$)",
                "model": "GT King II"
            },
            {
                "regex": "GTKing(?:_AT(?:_ATV)?)?(?:[);/ ]|$)",
                "model": "GT King"
            },
            {
                "regex": "R68 II(?:[);/ ]|$)",
                "model": "R68 II"
            }
        ]
    },
    "MAXVI": {
        "regex": "MAXVI[ _](?:MS401)(?:[);/ ]|$)|\\w*_?MAXVI?_\\w+|MS502[_ ]Orion|MS531",
        "device": "smartphone",
        "models": [
            {
                "regex": "MAXVI[ _](MS401)",
                "model": "$1"
            },
            {
                "regex": "MS531",
                "model": "MS531 Vega"
            },
            {
                "regex": "MS502[_ ]Orion",
                "model": "MS502 Orion"
            },
            {
                "regex": "\\w*MAXVI_(P11|K10|X[358]00)_",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "MDC Store": {
        "regex": "(?:Prime_S|M300 4G|MDC M5|Nova Pro|Grand Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Prime_S(?:[);/ ]|$)",
                "model": "Prime S"
            },
            {
                "regex": "Nova Pro",
                "model": "Nova Pro"
            },
            {
                "regex": "Grand Pro",
                "model": "Grand Pro"
            },
            {
                "regex": "(M300) 4G(?:[);/ ]|$)",
                "model": "$1 4G"
            },
            {
                "regex": "MDC M5(?:[);/ ]|$)",
                "model": "M5"
            }
        ]
    },
    "MDTV": {
        "regex": "MDTV(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "meanIT": {
        "regex": "meanIT[ _]|(?:meanIT[ _](?:C[12]|X10|X[126]|MG430|Q[145]|C[18]0C[18]1)|Smartphone_X5)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Smartphone_X5",
                "model": "X5"
            },
            {
                "regex": "meanIT[ _]Q1 plus(?:[);/ ]|$)",
                "model": "Q1 Plus"
            },
            {
                "regex": "meanIT[ _](C[12]|X[126]|MG430|Q[145])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "meanIT[ _](X[12]0|C[18]0C[18]1)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Kenxinda": {
        "regex": "Three[_ ]Proofings[_ ]W([5-9])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Three Proofings W$1"
    },
    "X-BO": {
        "regex": "X[-]?BO (V[78]|V1[01]|V[89]\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "X88": {
        "regex": "X88pro10",
        "device": "tv",
        "model": "Pro 10"
    },
    "X96": {
        "regex": "(?:X96Air_(?:A100|100W|V2|P[1-3])|X96_X6_I|X96Max_Plus_?(?:Ultra|[25]|Q[12])?|X96MATE_PLUS|X96MINI_11)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "X96Air_(100W|A100|V2|P[1-3])",
                "model": "Air $1"
            },
            {
                "regex": "X96Max_Plus_Ultra",
                "model": "Max Plus Ultra"
            },
            {
                "regex": "X96Max_Plus_?([25]|Q[12])",
                "model": "Max Plus $1"
            },
            {
                "regex": "X96Max_Plus",
                "model": "Max Plus"
            },
            {
                "regex": "X96_X6_I",
                "model": "X6i"
            },
            {
                "regex": "X96MATE_PLUS",
                "model": "Mate Plus"
            },
            {
                "regex": "X96MINI_11",
                "model": "Mini 11"
            }
        ]
    },
    "X96Q": {
        "regex": "X96Q(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "Xgody": {
        "regex": "XGODY|(?:Y19\\(EU\\)|XGT_EEA|N01Pro| N02)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "XGODY Y17(?:[);/ ]|$)",
                "model": "Y17"
            },
            {
                "regex": "Y19\\(EU\\)",
                "model": "Y19"
            },
            {
                "regex": "XGT_EEA",
                "device": "tablet",
                "model": "XGT"
            },
            {
                "regex": "N01Pro",
                "device": "tablet",
                "model": "N01 Pro"
            },
            {
                "regex": " N02(?:[);/ ]|$)",
                "device": "tablet",
                "model": "N02"
            },
            {
                "regex": "XGODY_X96(?:[);/ ]|$)",
                "model": "X96",
                "device": "tv"
            }
        ]
    },
    "Alcor": {
        "regex": "(Access_Q784C)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "iBrit": {
        "regex": "IBRIT_|(?:SI5[12]|i5Plus|POWER_X|Z2Lite|Diamond Pro Max)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Diamond Pro Max",
                "model": "Diamond Pro Max"
            },
            {
                "regex": "IBRIT_I([57])(?:[);/ ]|$)",
                "model": "I$1"
            },
            {
                "regex": "i5Plus",
                "model": "I5 Plus"
            },
            {
                "regex": "iBRIT_POWER6(?:[);/ ]|$)",
                "model": "Power 6"
            },
            {
                "regex": "iBRIT_Speed Pro(?:[);/ ]|$)",
                "model": "Speed Pro"
            },
            {
                "regex": "SI51(?:[);/ ]|$)",
                "model": "Speed"
            },
            {
                "regex": "SI52(?:[);/ ]|$)",
                "model": "Speed Plus"
            },
            {
                "regex": "POWER_X(?:[);/ ]|$)",
                "model": "Power X"
            },
            {
                "regex": "Z2Lite",
                "model": "Z2 Lite"
            },
            {
                "regex": "iBRIT_AF51(?:[);/ ]|$)",
                "model": "AF51"
            }
        ]
    },
    "Ovvi": {
        "regex": "Jumbo X1",
        "device": "smartphone",
        "model": "Jumbo X1"
    },
    "Fero": {
        "regex": "Fero[_ ]|Royale[_ ](?:[YX]2|A1)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fero_Y1",
                "model": "Y1"
            },
            {
                "regex": "Royale Y2 Lite",
                "model": "Royale Y2 Lite"
            },
            {
                "regex": "Royale[_ ]([YX]2|A1)",
                "model": "Royale $1"
            },
            {
                "regex": "FERO PACE",
                "model": "Pace"
            },
            {
                "regex": "A4001 Plus 2019",
                "model": "A4001 Plus (2019)"
            },
            {
                "regex": "A4001 Plus",
                "model": "A4001 Plus"
            },
            {
                "regex": "Fero[ _](A4001|A450[23]|A5001|L100|Iris|Power|Mega LTE|Vibe|J1)",
                "model": "$1"
            }
        ]
    },
    "Ruio": {
        "regex": "Ruio[ _]|(?:M671M4|i7Plus|S5[05]06|S518)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ruio[ _](S4)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Ruio[ _])?(S5|i7)Plus(?:[);/ ]|$)",
                "model": "$1 Plus"
            },
            {
                "regex": "M671M4",
                "model": "Cola 4G"
            },
            {
                "regex": "(S5[05]06|S518)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Transpeed": {
        "regex": "Transpeed[_ ]|(?:TR99 MINI\\+|TR99|8K618-T)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "TR99 MINI\\+",
                "model": "TR99 Mini Plus"
            },
            {
                "regex": "(?:Transpeed[_ ])?(TR99|H616|6K|X4S?|8K618-T)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "VVETIME": {
        "regex": "ZYVV1(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "V1"
    },
    "A1": {
        "regex": "(?:A1 (?:Alpha|Alpha 20\\+)|Alpha 20|Alpha Eco)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A1 Alpha 20\\+",
                "model": "Alpha 20 Plus"
            },
            {
                "regex": "Alpha 20",
                "model": "Alpha 20"
            },
            {
                "regex": "Alpha 21",
                "model": "Alpha 21"
            },
            {
                "regex": "Alpha Eco",
                "model": "Alpha Eco"
            },
            {
                "regex": "A1 Alpha",
                "model": "Alpha"
            }
        ]
    },
    "Swisstone": {
        "regex": "swisstone (SD 5[13]0)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "P-UP": {
        "regex": "MD-0[143]P(?:[);/ ]|$)",
        "device": "phablet",
        "models": [
            {
                "regex": "MD-04P(?:[);/ ]|$)",
                "model": "Mode 1 RR"
            },
            {
                "regex": "MD-03P(?:[);/ ]|$)",
                "model": "Mode 1 RS"
            },
            {
                "regex": "MD-01P(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Mode 1 MD-01P"
            }
        ]
    },
    "Pacific Research Alliance": {
        "regex": "Armadillo Phone",
        "device": "smartphone",
        "model": "Armadillo Phone"
    },
    "Paladin": {
        "regex": "Paladin TV",
        "device": "tv",
        "model": "TV Box"
    },
    "iVooMi": {
        "regex": "(?:Innelo_1|iV 505|Me 1\\+|Me 3S|Me [2345]|Android 8(?:[\\d.]*);(?: [\\w-]+;)? (?:i2_Lite|i2))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Innelo_1",
                "model": "Innelo 1"
            },
            {
                "regex": "iV 505",
                "model": "Me 1"
            },
            {
                "regex": "i2_Lite",
                "model": "i2 Lite"
            },
            {
                "regex": "i2(?:[);/ ]|$)",
                "model": "i2"
            },
            {
                "regex": "Me 1\\+",
                "model": "Me 1+"
            },
            {
                "regex": "Me ([2345]S?)",
                "model": "Me $1"
            }
        ]
    },
    "Pixelphone": {
        "regex": "Pixelphone S1(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "S1"
    },
    "Pixela": {
        "regex": "Infineum[_ ](Z4?5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Infineum $1"
    },
    "Iris": {
        "regex": "(?:Vox[_ ](?:[45]S|Alpha|POP|STEEL Plus|Energy|FORTIS|VERO)|IS2_?Plus|IS[36]Plus|IS2S|Next_P(?:_PRO)?|NEXT U|NEXT P\\+|IRS002-16|X1 mini|Iris_Pad_G8020|G7060|G7100|G8060)(?:[);/ ]|$)|android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:N30)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Vox[_ ]([45])S",
                "model": "Vox $1S"
            },
            {
                "regex": "N30(?: Build|[;)])",
                "model": "N30"
            },
            {
                "regex": "VOX[_ ]FORTIS",
                "model": "Vox Fortis"
            },
            {
                "regex": "VOX[_ ]VERO",
                "model": "Vox Vero"
            },
            {
                "regex": "VOX Alpha Plus",
                "model": "Vox Alpha Plus"
            },
            {
                "regex": "VOX STEEL Plus",
                "model": "Vox Steel Plus"
            },
            {
                "regex": "VOX Alpha",
                "model": "Vox Alpha"
            },
            {
                "regex": "VOX Energy",
                "model": "Vox Energy"
            },
            {
                "regex": "VOX POP plus",
                "model": "Vox Pop Plus"
            },
            {
                "regex": "VOX POP Pro",
                "model": "Vox Pop Pro"
            },
            {
                "regex": "Next_P_PRO",
                "model": "Next P Pro"
            },
            {
                "regex": "NEXT[_ ]([PU]\\+?)",
                "model": "Next $1"
            },
            {
                "regex": "IS([236])_?Plus",
                "model": "IS$1 Plus"
            },
            {
                "regex": "IRS002-16",
                "model": "I-S6"
            },
            {
                "regex": "IS2S",
                "model": "IS2S"
            },
            {
                "regex": "X1 mini",
                "model": "X1 Mini"
            },
            {
                "regex": "(?:Iris_Pad_)?(G7060|G7100|G80[26]0)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Fonos": {
        "regex": "Fonos-|(?:Android 10(?:[\\d.]*);(?:[\\d.]*)(?: [\\w-]+;)? O3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Fonos-(O\\d)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "O3(?: Build|[;)])",
                "model": "O3"
            }
        ]
    },
    "Xtouch": {
        "regex": "(?:Xtouch[ _](?:X10|A5|X)|XBot[_ ](?:Senior|Junior)|X9_16GB|XP10_Wifi)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Xtouch[ _](X10|A5|X)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "X9_16GB(?:[);/ ]|$)",
                "model": "X9"
            },
            {
                "regex": "XBot[_ ](Senior|Junior)",
                "model": "XBot $1"
            },
            {
                "regex": "XP10_Wifi",
                "device": "tablet",
                "model": "XP10 WiFi"
            }
        ]
    },
    "Conquest": {
        "regex": "Conquest[-_ ](?:S\\d+|F2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Conquest[-_ ]S(\\d+)",
                "model": "S$1"
            },
            {
                "regex": "Conquest-F2",
                "model": "F2"
            }
        ]
    },
    "Zatec": {
        "regex": "ZATEC[_ ]|(?:[ ]WIND|ZPAD_1|ZPLAY1_2018|Zpower_(?:Plus|2018))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZATEC[_ ]GRAVITY(?:[);/ ]|$)",
                "model": "Gravity"
            },
            {
                "regex": "[ ]WIND(?:[);/ ]|$)",
                "model": "Wind"
            },
            {
                "regex": "ZPLAY1_2018",
                "model": "Zplay (2018)"
            },
            {
                "regex": "Zpower_2018",
                "model": "Zpower (2018)"
            },
            {
                "regex": "Zpower_Plus",
                "model": "Zpower Plus"
            },
            {
                "regex": "ZPAD_1",
                "device": "tablet",
                "model": "ZPad"
            }
        ]
    },
    "Selecline": {
        "regex": "Selecline[ _]|(?:S4T7IN|ST19101|S3T10IN)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(ST19101|S4T7IN|S3T10IN)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Selecline 10(?:[);/ ]|$)",
                "model": "10"
            }
        ]
    },
    "Selenga": {
        "regex": "Selenga",
        "device": "tv",
        "models": [
            {
                "regex": "Selenga[ _](A[1345])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Starlight": {
        "regex": "Starlight|(?:VENUS_PLUS|My_Star_X|My_star_18|RIO STAR|C_Note(?:_Pro)?|Star_Mix_2|I_STAR_PLUS|star_plus_plus|star_two|I star (?:one|two)|Milan_Pro|Gionee_?Star)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Milan_Pro",
                "model": "Milan Pro"
            },
            {
                "regex": "Gionee_?Star",
                "model": "Gionee Star"
            },
            {
                "regex": "My_Star_X",
                "model": "My Star X"
            },
            {
                "regex": "My_star_18",
                "model": "My Star 18"
            },
            {
                "regex": "RIO STAR",
                "model": "Rio Star"
            },
            {
                "regex": "VENUS_PLUS",
                "model": "Venus Plus"
            },
            {
                "regex": "C_Note_Pro",
                "model": "C Note Pro"
            },
            {
                "regex": "C_Note",
                "model": "C Note"
            },
            {
                "regex": "Star_Mix_2",
                "model": "Star Mix 2"
            },
            {
                "regex": "I_STAR_PLUS",
                "model": "I Star Plus"
            },
            {
                "regex": "I star two|star_two",
                "model": "I Star Two"
            },
            {
                "regex": "I star one",
                "model": "I Star One"
            },
            {
                "regex": "Starlight_ROME_X",
                "model": "Rome X"
            },
            {
                "regex": "star_plus_plus",
                "model": "Star++"
            }
        ]
    },
    "Geo Phone": {
        "regex": "GEO_?PHONE_",
        "device": "feature phone",
        "models": [
            {
                "regex": "GEO_?PHONE_(T1[59])_4G(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GEO_?PHONE_T19I_4G(?:[);/ ]|$)",
                "model": "T19i"
            }
        ]
    },
    "GEOFOX": {
        "regex": "GEOFOX[_ ]MID ?(743\\+?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "MID$1"
    },
    "Tinmo": {
        "regex": "TiNMO[- _](A11|K3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Verico": {
        "regex": "(?:RP-UDM0[12]A|RP-UDP05A|JO-UQM10A|UQM1[23]A)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(RP-UDM0[12]A|RP-UDP05A|JO-UQM10A)",
                "model": "Uni Pad $1"
            },
            {
                "regex": "(UQM1[23]A)",
                "model": "Uni Pad PM-$1"
            }
        ]
    },
    "TTEC": {
        "regex": "(Magictab (?:9GX|7GE|718))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TTfone": {
        "regex": "TTfone",
        "device": "smartphone",
        "models": [
            {
                "regex": "TT20(?:[);/ ]|$)",
                "model": "TT20"
            }
        ]
    },
    "eSTAR": {
        "regex": "eSTAR[_ ](?:Grand|GO\\!?|Zoom Quad|Gemini|MINI[_ ]3G|BEAUTY|MOON)|(?:Digni-Smart|MERCURY HD Quad core|MID1020L|takee 1)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "eSTAR (Grand|GO\\!?) (HD Intel|IPS Intel|IPS|HD|Intel) Quad Core 3G",
                "model": "$1 $2 Quad Core 3G"
            },
            {
                "regex": "eSTAR (Zoom Quad|Gemini|GO)",
                "model": "$1"
            },
            {
                "regex": "eSTAR GRAND HD quad core( [34]G)?",
                "model": "Grand HD Quad Core$1"
            },
            {
                "regex": "eSTAR GRAND",
                "model": "Grand"
            },
            {
                "regex": "MERCURY HD Quad core",
                "model": "Mercury HD Quad core"
            },
            {
                "regex": "eSTAR BEAUTY HD Quad core",
                "model": "Beauty HD Quad Core"
            },
            {
                "regex": "eSTAR MOON HD Quad core",
                "model": "Moon HD Quad Core 3G"
            },
            {
                "regex": "eSTAR BEAUTY 2 HD Quad core",
                "model": "Beauty 2 HD Quad Core"
            },
            {
                "regex": "eSTAR[_ ]MINI[_ ]3G",
                "model": "Mini 3G"
            },
            {
                "regex": "(MID1020L)",
                "model": "$1"
            },
            {
                "regex": "takee 1",
                "device": "smartphone",
                "model": "Takee 1"
            },
            {
                "regex": "Digni-Smart",
                "device": "smartphone",
                "model": "Digni Smart"
            }
        ]
    },
    "Hometech": {
        "regex": "(?:Ideal (?:10S|Tab [79]|8S)|ALFA(?:10T[BX]|7LM)|ALFA10TX_PRO|ALFA[_ ](?:10R[CX]|10BS|10TM?|8TX?|10MB|10YC|7RS|[78]M?RC|7M|8S[TL]|8RX|8MG|11 BT|10BT_V2)|HT[ _](?:7RT|8MZ)|7_PREMIUM_PRO)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Ideal (?:10S|Tab 9|8S))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "ALFA[_ ]?10TX_PRO",
                "model": "ALFA 10TX Pro"
            },
            {
                "regex": "ALFA[_ ]?(10R[CX]|10YC|10BS|10T[BMX]?|7RS|[78]M?RC|7L?M|10MB|8TX?|8S[TL]|8RX|8MG|11 BT|10BT_V2)(?:[);/ ]|$)",
                "model": "ALFA $1"
            },
            {
                "regex": "7_PREMIUM_PRO",
                "model": "7 Premium Pro"
            },
            {
                "regex": "Ideal Tab 7 Ips( 3G)?",
                "model": "Ideal Tab 7 IPS$1"
            },
            {
                "regex": "HT[ _](7RT|8MZ)(?:[);/ ]|$)",
                "model": "HT $1"
            }
        ]
    },
    "ExMobile": {
        "regex": "(?:EX(?:29|45)i|CHAT_5\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CHAT_5+",
                "model": "Chat 5 Plus"
            },
            {
                "regex": "EX(29|45)i(?:[);/ ]|$)",
                "model": "EX $1i"
            }
        ]
    },
    "Exmart": {
        "regex": "Exmart[ _](K1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Hipstreet": {
        "regex": "HS_|10DTB12(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "HS_9DTB39(?:[);/ ]|$)",
                "model": "Pulse"
            },
            {
                "regex": "10DTB12(?:[);/ ]|$)",
                "model": "Phoenix"
            },
            {
                "regex": "HS_([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Hiremco": {
        "regex": "Hiremco|(?:Matador Pro Air|X6-PRO|MATADOR[- ]PRO|Matador)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "X6-PRO",
                "model": "X6 Pro"
            },
            {
                "regex": "Matrix",
                "model": "Matrix"
            },
            {
                "regex": "Matador Pro Air",
                "model": "Matador Pro Air"
            },
            {
                "regex": "MATADOR[- ]PRO",
                "model": "Matador Pro"
            },
            {
                "regex": "Matador",
                "model": "Matador"
            },
            {
                "regex": "HIREMCO(?:[);/ ]|$)",
                "model": "Smart TV"
            }
        ]
    },
    "Navitech": {
        "regex": "(NeoTab)[ _-]((?:S1[23]0|S125|H85|H11[05]|KID741|S9700))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1 $2"
    },
    "NorthTech": {
        "regex": "(NT-TP10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "TouchPad 10.0\""
    },
    "UNIWA": {
        "regex": "UNIWA[ _]|(?:W888)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "UNIWA[ _](X5|F40)",
                "model": "$1"
            },
            {
                "regex": "(W888)",
                "model": "$1"
            }
        ]
    },
    "ASSE": {
        "regex": "ASSE[-._ ](Q[35]s?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Andowl": {
        "regex": "(?:ANDOWL-)?(Q[45]|QG9|QK9MAX)(?:[);/ ]|$)|Andowl",
        "device": "tv",
        "model": "$1"
    },
    "Silelis": {
        "regex": "Silelis[ _](T-1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Bluedot": {
        "regex": "BLUEDOT[_ ]|(?:BNT-71|BNT-801W)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:BLUEDOT[_ ])?(BNP-500)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(BNT-71|BNT-801W)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Planet Computers": {
        "regex": "(?:Cosmo_Communicator|Gemini[_ ]4G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Cosmo_Communicator)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Gemini[_ ]4G)(?:[);/ ]|$)",
                "model": "Gemini 4G"
            }
        ]
    },
    "Play Now": {
        "regex": "Play Now ",
        "device": "tv",
        "models": [
            {
                "regex": "PLAY NOW TV BOX 2(?:[);/ ]|$)",
                "model": "TV Box 2"
            }
        ]
    },
    "Reach": {
        "regex": "(Allure[_ ](?:Ultra(?:[_]Curve)?|Secure|Admire|Rise)|Opulent X)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Realix": {
        "regex": "(RxIS202)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "MobiWire": {
        "regex": "MobiGo|(?:Kiona|KANUNA|Halona|IKOSORA\\+|Kicka[_ ][45][ _]Plus|Kicka Zoom|Kohana|Kayeta|Kosumi|KWANITA|Lonan|Hotah|Kicka 5|Kiona|Smart[ _]?(?:[CEN]11|N12|P24)|Sakari|V Smart 2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "KANUNA",
                "model": "Kanuna"
            },
            {
                "regex": "KWANITA",
                "model": "Kwanita"
            },
            {
                "regex": "MobiGo2L",
                "model": "MobiGo 2L"
            },
            {
                "regex": "V Smart 2",
                "model": "V Smart 2"
            },
            {
                "regex": "Smart[ _]?([CEN]11|N12|P24)",
                "model": "Smart $1"
            },
            {
                "regex": "(IKOSORA\\+|Kiona|Kicka[_ ][45][ _]Plus|Kohana|Kayeta|Kosumi|Lonan|Halona|Hotah|Kicka 5|Kicka Zoom|Kiona|Sakari)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Hezire": {
        "regex": "(HTB801|HBook-Pro)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Hurricane": {
        "regex": "Hurricane[ _]|(?:Flame_Plus|Glaze|Cobra|Ridge Plus|Rush Plus|DZIRE|Android 7(?:[\\d.]*);(?: [\\w-]+;)? Beam|Vulcan|SAGE|Iris Plus 2021|VortexPlus|Excite|Flint|Panther|Slam|Epic)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Hurricane[ _]IGNITE",
                "model": "Ignite"
            },
            {
                "regex": "Hurricane[ _]Bolt",
                "model": "Bolt"
            },
            {
                "regex": "Hurricane[ _]VORTEX",
                "model": "Vortex"
            },
            {
                "regex": "Hurricane[ _]GIGA",
                "model": "Giga"
            },
            {
                "regex": "Glaze",
                "model": "Glaze"
            },
            {
                "regex": "Cobra",
                "model": "Cobra"
            },
            {
                "regex": "DZIRE",
                "model": "Dzire"
            },
            {
                "regex": "SAGE",
                "model": "Sage"
            },
            {
                "regex": "Beam",
                "model": "Beam"
            },
            {
                "regex": "Slam",
                "model": "Slam"
            },
            {
                "regex": "Epic",
                "model": "Epic"
            },
            {
                "regex": "Vulcan",
                "model": "Vulcan"
            },
            {
                "regex": "Flame_Plus",
                "model": "Flame Plus"
            },
            {
                "regex": "Ridge Plus",
                "model": "Ridge Plus"
            },
            {
                "regex": "Rush Plus",
                "model": "Rush Plus"
            },
            {
                "regex": "Iris Plus 2021",
                "model": "Iris Plus (2021)"
            },
            {
                "regex": "VortexPlus",
                "model": "Vortex Plus"
            },
            {
                "regex": "Excite",
                "model": "Excite"
            },
            {
                "regex": "Flint",
                "model": "Flint"
            },
            {
                "regex": "Panther",
                "model": "Panther"
            }
        ]
    },
    "iSWAG": {
        "regex": "ISWAG[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "iSWAG[_ ]ACTIV",
                "model": "Activ"
            },
            {
                "regex": "iSWAG[_ ]KRONOS",
                "model": "Kronos"
            },
            {
                "regex": "iSWAG[_ ]Lynx",
                "model": "Lynx"
            },
            {
                "regex": "iSWAG[_ ]MEGA",
                "model": "Mega"
            },
            {
                "regex": "iSWAG[_ ]MANTRA",
                "model": "Mantra"
            },
            {
                "regex": "iSWAG[_ ]NEMESIS",
                "model": "Nemesis"
            },
            {
                "regex": "iSWAG[_ ]NEO",
                "model": "Neo"
            },
            {
                "regex": "ISWAG[_ ]VIPER",
                "model": "Viper"
            }
        ]
    },
    "Reeder": {
        "regex": "(?:reeder[_ ](?:3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE|M7_Go|TV)|M8_Go|M8Go2020|M10SPlus|P12Curve|M10 Pro LTE|M10 Blue Max|P13[ _]Blue[ _]Plus(?:[ _]2022)?|P13_Max_Blue|P13[_ ]Blue[_ ]Ma(?:ks|x|xL)|P13_Blue|P13[ _]Blue[ _]202[12]|M7Plus|A8i-Q2|M7Go_2019|S19 Max(?: Pro S(?: Zoom)?| \\d{2}GB|L 128GB| Pro)|M10 GO|S23 Pro Max|S19 Max|P11SE_Art)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "A8i-Q2",
                "model": "A8i Q2"
            },
            {
                "regex": "P11SE_Art",
                "model": "P11SE Art"
            },
            {
                "regex": "reeder[_ ](3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "M10SPlus",
                "model": "M10S Plus"
            },
            {
                "regex": "M7Plus",
                "model": "M7 Plus"
            },
            {
                "regex": "(?:reeder_)?(?:M7Go_2019|M7_Go)",
                "model": "M7 Go"
            },
            {
                "regex": "M8Go2020",
                "model": "M8 Go (2020)"
            },
            {
                "regex": "(?:reeder_)?(M8|M10)[_ ]Go",
                "model": "$1 Go"
            },
            {
                "regex": "M10 Blue Max",
                "model": "M10 Blue Max"
            },
            {
                "regex": "M10 Pro LTE",
                "model": "M10 Pro LTE"
            },
            {
                "regex": "P12Curve",
                "device": "smartphone",
                "model": "P12 Curve"
            },
            {
                "regex": "P13 Blue Max PL",
                "device": "smartphone",
                "model": "P13 Blue Pro Lite"
            },
            {
                "regex": "P13_Blue_Maks",
                "device": "smartphone",
                "model": "P13 Blue Maks"
            },
            {
                "regex": "P13_Blue_Plus_2022",
                "device": "smartphone",
                "model": "P13 Blue Plus (2022)"
            },
            {
                "regex": "P13_Blue_Plus",
                "device": "smartphone",
                "model": "P13 Blue Plus"
            },
            {
                "regex": "P13 Blue Max Pro 2021",
                "device": "smartphone",
                "model": "P13 Blue Max Pro (2021)"
            },
            {
                "regex": "P13 Blue Max Lite",
                "device": "smartphone",
                "model": "P13 Blue Max Lite"
            },
            {
                "regex": "P13 Blue Max Pro",
                "device": "smartphone",
                "model": "P13 Blue Max Pro"
            },
            {
                "regex": "P13 Blue 202([12])",
                "device": "smartphone",
                "model": "P13 Blue (202$1)"
            },
            {
                "regex": "P13 Blue MaxL? 202([012])",
                "device": "smartphone",
                "model": "P13 Blue Max (202$1)"
            },
            {
                "regex": "P13[_ ]Blue[_ ]Max|P13_Max_Blue",
                "device": "smartphone",
                "model": "P13 Blue Max"
            },
            {
                "regex": "P13_Blue",
                "device": "smartphone",
                "model": "P13 Blue"
            },
            {
                "regex": "S19 Max (?:32|64)GB",
                "device": "smartphone",
                "model": "S19 Max"
            },
            {
                "regex": "S19 MaxL 128GB",
                "device": "smartphone",
                "model": "S19 Max L"
            },
            {
                "regex": "S19 Max Pro S Zoom",
                "device": "smartphone",
                "model": "S19 Max Pro S Zoom"
            },
            {
                "regex": "S19 Max Pro S Edge",
                "device": "smartphone",
                "model": "S19 Max Pro S Edge"
            },
            {
                "regex": "S19 Max Pro S",
                "device": "smartphone",
                "model": "S19 Max Pro S"
            },
            {
                "regex": "S19 Max Pro",
                "device": "smartphone",
                "model": "S19 Max Pro"
            },
            {
                "regex": "S19 Max",
                "device": "smartphone",
                "model": "S19 Max"
            },
            {
                "regex": "S23 Pro Max",
                "device": "smartphone",
                "model": "S23 Pro Max"
            },
            {
                "regex": "REEDER TV",
                "device": "tv",
                "model": "Smart TV"
            }
        ]
    },
    "ELARI": {
        "regex": "ELARI|(?:KidPhone4G)(?:[);/ ]|$)",
        "device": "wearable",
        "models": [
            {
                "regex": "ELARI 4G Wink",
                "model": "4G Wink"
            },
            {
                "regex": "KidPhone4G",
                "model": "KidPhone 4G"
            }
        ]
    },
    "Epik One": {
        "regex": "(K501 Plus|[ ]K5(?:0[0-4]|1[01]|03[TS]|3[456]|4[05]|73|03HD)|[ ]K60[01]|[ ]X507T|[ ]K40[56]|[ ]T700|Android 8([\\d.]*);(?: [\\w-]+;)? X400|RS550)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "K501 Plus",
                "model": "Leo Plus"
            },
            {
                "regex": "RS550",
                "model": "RS550"
            },
            {
                "regex": "K501",
                "model": "Leo"
            },
            {
                "regex": "K500",
                "model": "Omega Lite"
            },
            {
                "regex": "K502",
                "model": "Omega"
            },
            {
                "regex": "K503T",
                "model": "Leo Turbo"
            },
            {
                "regex": "K503S",
                "model": "Leo Pro"
            },
            {
                "regex": "K503HD",
                "model": "Leo HD"
            },
            {
                "regex": "K503",
                "model": "Leo Max"
            },
            {
                "regex": "K504",
                "model": "Titan 3G"
            },
            {
                "regex": "X507T",
                "model": "Titan II"
            },
            {
                "regex": "K510",
                "model": "Bolt"
            },
            {
                "regex": "K511",
                "model": "Bolt Pro"
            },
            {
                "regex": "K534",
                "model": "Hada"
            },
            {
                "regex": "K535",
                "model": "Hada Turbo"
            },
            {
                "regex": "K545",
                "model": "Rocket"
            },
            {
                "regex": "K536",
                "model": "Royal"
            },
            {
                "regex": "K540",
                "model": "Excalibur"
            },
            {
                "regex": "X400",
                "model": "Pebble X400"
            },
            {
                "regex": "K573",
                "model": "Panther"
            },
            {
                "regex": "K600",
                "model": "Jupiter"
            },
            {
                "regex": "K601",
                "model": "Jupiter One"
            },
            {
                "regex": "K406",
                "model": "Pebble Plus"
            },
            {
                "regex": "K405",
                "model": "Pebble II"
            },
            {
                "regex": "T700",
                "model": "Palette",
                "device": "tablet"
            }
        ]
    },
    "Altice": {
        "regex": "Altice[ _]|(SX41|Android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:S32|S42|S32_(?:Plus|NFC)))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(SX41|S32|S42|S32_Plus|S32_NFC)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Altice[ _](S62|S31|S43)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Kult": {
        "regex": "(Ambition|Beyond)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Beyond": {
        "regex": "(?:SURVE(10|[26-8]|[12] PRO)|Home9)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SURVE([12]) PRO",
                "model": "Surve $1 Pro"
            },
            {
                "regex": "SURVE(10|[26-8])",
                "model": "Surve $1"
            },
            {
                "regex": "Home9",
                "model": "Home 9"
            }
        ]
    },
    "BioRugged": {
        "regex": "(?:BioWolf 8-F30|BIOWOLF8F30|Ruggbo 20 Lite)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "BioWolf 8-F30|BIOWOLF8F30",
                "model": "BioWolf 8-F30"
            },
            {
                "regex": "Ruggbo 20 Lite",
                "model": "Ruggbo 20 Lite"
            }
        ]
    },
    "VAIO": {
        "regex": "(?:VPA051|VA-10J)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VPA051",
                "model": "Phone A"
            },
            {
                "regex": "(VA-10J)",
                "model": "$1"
            }
        ]
    },
    "Spark": {
        "regex": "Spark Plus 3(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Plus 3",
                "model": "Plus 3"
            }
        ]
    },
    "Sparx": {
        "regex": "Sparx[ _]|(?:Android 1[34](?:[\\d.]*);(?: [\\w-]+;)? Neo 11|NEO_6|NEO 5|Neo_6_plus|Neo 5 Pro|Neo X|Neo 8 Lite|Edge 20 Pro|Ultra 8 Pro|Ultra 8)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Edge 20 Pro",
                "model": "Edge 20 Pro"
            },
            {
                "regex": "Edge 20",
                "model": "Edge 20"
            },
            {
                "regex": "Neo ([89])i",
                "model": "Neo $1i"
            },
            {
                "regex": "Neo 7 Ultra",
                "model": "Neo 7 Ultra"
            },
            {
                "regex": "Neo 8 Lite",
                "model": "Neo 8 Lite"
            },
            {
                "regex": "Neo ([578]) Pro",
                "model": "Neo $1 Pro"
            },
            {
                "regex": "Neo[ _]([5687])[ _]Plus",
                "model": "Neo $1 Plus"
            },
            {
                "regex": "Neo[ _]([567]|11)",
                "model": "Neo $1"
            },
            {
                "regex": "Neo X",
                "model": "Neo X"
            },
            {
                "regex": "Ultra 11",
                "model": "Ultra 11"
            },
            {
                "regex": "Ultra 8 Pro",
                "model": "Ultra 8 Pro"
            },
            {
                "regex": "Ultra 8",
                "model": "Ultra 8"
            },
            {
                "regex": "Sparx S7",
                "model": "S7"
            }
        ]
    },
    "SPC": {
        "regex": "(?:GRAVITY [34]G(?:_2019)?|GRAVITY2-4G|GRAVITY_4|GRAVITY_OCTACORE|GRAVITY[ -_](?:Max|SE|PRO|2-MAX|[23]|3_MINI|3_SE|ULTIMATE 2)|SPC (?:GEN|SMART)|SPC_ALIEN(?:_STICK)?|ZEUS_4G(?:_PRO)?|SPC Glow9\\.7|Lightyear|Laika|L70_Lite|L60 Turbo|L60 Pro|FLOW 7|SMART_ULTIMATE(?:_64)?|DISCOVERY_2_ME|Discovery (?:Pro|SE))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "GRAVITY_OCTACORE",
                "model": "Gravity OctaCore"
            },
            {
                "regex": "GRAVITY ([34])G_2019",
                "model": "Gravity (2019) $1G"
            },
            {
                "regex": "GRAVITY ([34])G",
                "model": "Gravity $1G"
            },
            {
                "regex": "Gravity Max",
                "model": "Gravity Max"
            },
            {
                "regex": "GRAVITY PRO",
                "model": "Gravity Pro"
            },
            {
                "regex": "GRAVITY SE",
                "model": "Gravity SE"
            },
            {
                "regex": "GRAVITY-2-MAX",
                "model": "Gravity 2 Max"
            },
            {
                "regex": "GRAVITY 2|GRAVITY2-4G",
                "model": "Gravity 2"
            },
            {
                "regex": "GRAVITY ULTIMATE 2",
                "model": "Gravity Ultimate 2"
            },
            {
                "regex": "GRAVITY_3_MINI",
                "model": "Gravity 3 Mini"
            },
            {
                "regex": "GRAVITY_3_SE",
                "model": "Gravity 3 SE"
            },
            {
                "regex": "GRAVITY_([43])",
                "model": "Gravity $1"
            },
            {
                "regex": "SPC Glow9\\.7",
                "model": "Glow 9.7\""
            },
            {
                "regex": "Lightyear",
                "model": "Lightyear"
            },
            {
                "regex": "L70_Lite",
                "model": "L70 Lite"
            },
            {
                "regex": "FLOW 7",
                "model": "Flow 7"
            },
            {
                "regex": "Laika",
                "model": "Laika"
            },
            {
                "regex": "ZEUS_4G_PRO",
                "device": "smartphone",
                "model": "Zeus 4G Pro"
            },
            {
                "regex": "ZEUS_4G",
                "device": "smartphone",
                "model": "Zeus 4G"
            },
            {
                "regex": "SMART_ULTIMATE(?:_64)?",
                "device": "smartphone",
                "model": "Smart Ultimate"
            },
            {
                "regex": "SPC SMART PLUS",
                "device": "smartphone",
                "model": "Smart Plus"
            },
            {
                "regex": "SPC SMART LITE",
                "device": "smartphone",
                "model": "Smart Lite"
            },
            {
                "regex": "SPC SMART MAX",
                "device": "smartphone",
                "model": "Smart Max"
            },
            {
                "regex": "SPC SMART",
                "device": "smartphone",
                "model": "Smart"
            },
            {
                "regex": "SPC GEN MAX",
                "device": "smartphone",
                "model": "Gen Max"
            },
            {
                "regex": "SPC GEN LITE",
                "device": "smartphone",
                "model": "Gen Lite"
            },
            {
                "regex": "SPC GEN Plus",
                "device": "smartphone",
                "model": "Gen Plus"
            },
            {
                "regex": "SPC GEN",
                "device": "smartphone",
                "model": "Gen"
            },
            {
                "regex": "DISCOVERY_2_ME",
                "device": "smartphone",
                "model": "Discovery 2 Me"
            },
            {
                "regex": "(L60 Turbo|L60 Pro|Discovery (?:Pro|SE))",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "SPC_ALIEN_STICK",
                "device": "tv",
                "model": "Alien Stick"
            },
            {
                "regex": "SPC_ALIEN",
                "device": "tv",
                "model": "Alien"
            }
        ]
    },
    "Winmax": {
        "regex": "(?:Winmax[ _](?:XC14|XC[46]|TX30)|PolarH4|Tiger_X12)(?:[);/ ]|$)|MAUI.+Winmax_BD45",
        "device": "smartphone",
        "models": [
            {
                "regex": "PolarH4",
                "model": "Polar H4"
            },
            {
                "regex": "Tiger_X12",
                "model": "Tiger X12"
            },
            {
                "regex": "Winmax[ _](XC14|XC[46])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Winmax[ _](TX30)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "MAUI.+Winmax_(BD45)",
                "device": "feature phone",
                "model": "$1"
            }
        ]
    },
    "Zebra": {
        "regex": " (MC2[27]00|TC15|TC2[01567]|TC5[12567]|TC7[05]x|TC7[57]|TC700H|ET51|MC33|MC93|EC30|EC55|PS20J|VC8300)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(TC15|TC2[01567]|TC5[12567]|TC7[05]x|TC7[57]|TC700H|MC33|EC30|EC55)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(ET51)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(MC2[27]00|MC93|PS20J)(?:[);/ ]|$)",
                "device": "peripheral",
                "model": "$1"
            },
            {
                "regex": "(VC8300)",
                "device": "car browser",
                "model": "$1"
            }
        ]
    },
    "Thuraya": {
        "regex": "Thuraya[ _](X5-Touch)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Bkav": {
        "regex": "Bphone[ _](B111[45]|B2017)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Bphone $1"
    },
    "Brandt": {
        "regex": "Brandt|(?:BPRIME|BSTAR\\+?|BPRIMES|B-ONE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BRANDT ([UF]HD) TV",
                "device": "tv",
                "model": "$1 TV"
            },
            {
                "regex": "(BPRIME|BSTAR\\+?|BPRIMES|B-ONE)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bigben": {
        "regex": "(?:GAMETAB-ONE|Bigtech_B_RU)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "GAMETAB-ONE",
                "model": "GameTab-One"
            },
            {
                "regex": "Bigtech_B",
                "model": "BigTech B"
            }
        ]
    },
    "SMARTEC": {
        "regex": "(?:Atractivo|SmartabS4)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Atractivo)",
                "model": "$1"
            },
            {
                "regex": "SmartabS4",
                "device": "tablet",
                "model": "Smartab S4"
            }
        ]
    },
    "Asanzo": {
        "regex": "ASANZO[ _](?:A2|S[23]|[SZ]5|S3_PLUS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ASANZO[ _]S3[ _]PLUS",
                "model": "S3 Plus"
            },
            {
                "regex": "ASANZO[ _](A2|S[23]|[SZ]5)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Artizlee": {
        "regex": "Artizlee[ _]S9|ATL-(?:16|21(?:PLUS|[XT])?|31|26)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "ATL-21PLUS(?:[);/ ]|$)",
                "model": "ATL-21 Plus"
            },
            {
                "regex": "(ATL-(?:16|21[XT]?|31|26))(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Artizlee[ _]S9",
                "device": "smartphone",
                "model": "S9"
            }
        ]
    },
    "Mint": {
        "regex": "(?:Pearl_Neo|M4CRD?|Emerald_M55CR|Mint[ _](?:VirGo|Orion))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pearl_(Neo)",
                "model": "Pearl $1"
            },
            {
                "regex": "Emerald[_ ]M55CR",
                "model": "Emerald"
            },
            {
                "regex": "M4CR",
                "model": "Clover"
            },
            {
                "regex": "(?:Mint[_ ])?VirGo",
                "model": "VirGo"
            },
            {
                "regex": "(?:Mint[_ ])?Orion",
                "model": "Orion"
            }
        ]
    },
    "Mintt": {
        "regex": "(?:Cool|Fresh|Ultra)?Mintt",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mintt (M3)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Coolmintt ?(Blaze 2|Tribe|A[3578]|M[12]|P[13]|X7)(?:[);/ ]|$)",
                "model": "CoolMintt $1"
            },
            {
                "regex": "Ultramintt ?(A[56]|R1|S[12]|X[56]|Y[35])(?:[);/ ]|$)",
                "model": "UltraMintt $1"
            },
            {
                "regex": "UltraMintt ?(T10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "UltraMintt $1"
            },
            {
                "regex": "FRESHMINTT ?(A7|A10)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "FreshMintt $1"
            }
        ]
    },
    "Premio": {
        "regex": "(?:AXE_II|186HS2080531|186HS1050531|186HS1050232|186FT1080231|185FT5050231|X7[05]-2021|PREMIO[ _](?:S50|P420|P451)|Android 8(?:[\\d.]*);(?: [\\w-]+;)? Axe)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "186HS2080531",
                "model": "X1"
            },
            {
                "regex": "AXE_II",
                "model": "Axe II"
            },
            {
                "regex": "Axe",
                "model": "Axe"
            },
            {
                "regex": "186HS1050531",
                "model": "P541"
            },
            {
                "regex": "185FT5050231",
                "model": "P511"
            },
            {
                "regex": "186FT1080231",
                "model": "P571"
            },
            {
                "regex": "186HS1050232",
                "model": "P630"
            },
            {
                "regex": "X(7[05])-2021",
                "model": "X$1 (2021)"
            },
            {
                "regex": "PREMIO[ _](S50|P420|P451)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Trifone": {
        "regex": "Passion[-_](?:1S|PRO|PLUS)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Passion-1S",
                "model": "Passion 1S"
            },
            {
                "regex": "Passion-Plus",
                "model": "Passion Plus"
            },
            {
                "regex": "Passion_Pro",
                "model": "Passion Pro"
            }
        ]
    },
    "Bluewave": {
        "regex": "(?:33GT HD|WV8R-M|WV8R[_-]N|WV8-[ML])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "33GT HD",
                "model": "Wave 8 HD+"
            },
            {
                "regex": "WV8R-M",
                "model": "Wave 8 Red Marshmallow"
            },
            {
                "regex": "WV8-M",
                "model": "Wave 8"
            },
            {
                "regex": "WV8-L",
                "model": "Wave 8 HD+"
            },
            {
                "regex": "WV8R[_-]N",
                "model": "Wave 8 Red Nougat"
            }
        ]
    },
    "Siragon": {
        "regex": "Siragon|(?:SP[_-](?:5[0124]50|5[34]00|61[05]0|7200))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Siragon[_ ])?(?:SP[_-](5[0124]50|5[34]00|61[05]0|7200))",
                "model": "SP-$1"
            }
        ]
    },
    "Siswoo": {
        "regex": "APRIX C55(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Aprix C55"
    },
    "Poppox": {
        "regex": "Poppox P3",
        "device": "smartphone",
        "model": "P3"
    },
    "POPTEL": {
        "regex": "POPTEL|P9000_MAX(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "P9000_MAX(?:[);/ ]|$)",
                "model": "P9000 Max"
            },
            {
                "regex": "POPTEL K1(?:[);/ ]|$)",
                "model": "K1"
            }
        ]
    },
    "Zentality": {
        "regex": "(?:C-723ULTRA|C-70[13] ?ULTRA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "C-(\\d+) ?Ultra",
                "model": "C-$1 Ultra"
            }
        ]
    },
    "ONVO": {
        "regex": "ONVO[ _]|\\d{2}OV|(?:Apollo Premium4K TV|0V50500|OV43400)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(0V50500|OV43400)[,;]?",
                "model": "$1"
            },
            {
                "regex": "(?:ONVO[_ ])?(\\d{2}OV[a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Apollo Premium4K TV(?:[);/ ]|$)",
                "model": "Apollo Premium"
            },
            {
                "regex": "SMART TV",
                "model": "Smart TV"
            }
        ]
    },
    "Black Bear": {
        "regex": "(B6 Master|B6 Note X)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Black Box": {
        "regex": "Black Box",
        "device": "tv",
        "models": [
            {
                "regex": "Tv Pro(?:[);/ ]|$)",
                "model": "TV Pro"
            }
        ]
    },
    "OpelMobile": {
        "regex": "Opel ?Mobile|(?:OpelMobile_Smart(?:JX|X1)|Easy_Smart_2|Rugged60Q)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Easy_Smart_2",
                "model": "Easy Smart 2"
            },
            {
                "regex": "Rugged60Q",
                "model": "Rugged 60Q"
            },
            {
                "regex": "OpelMobile_SmartJX",
                "model": "SmartJX"
            },
            {
                "regex": "OpelMobile_SmartX1",
                "model": "SmartX1 4G"
            },
            {
                "regex": "Opel Mobile SmartX6",
                "model": "SmartX6"
            }
        ]
    },
    "NuAns": {
        "regex": "NEO \\[Reloaded\\](?:[);/ ]|$)",
        "device": "smartphone",
        "model": "NEO Reloaded"
    },
    "Koolnee": {
        "regex": "(K1 Trio)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Sansui": {
        "regex": "Sansui[_ ]|(?:S505024)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S505024",
                "model": "Horizon 2"
            },
            {
                "regex": "Sansui[_ ](Switch|Play|Fun|SA4[01]|U4[56]|U3[02]|Nova)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Sico": {
        "regex": "SICO[_ ](?:PLUS|e1002|Topaz)|(?:Express3-Max|SSR3-1-51-5M|SSD-1-53-13M|Mega2(?:max)?|Express3|Diamond 2|Plus3_4G|Plus2 4G|Infinity Max|Nile X|More_3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SICO[_ ]PLUS2|Plus2 4G",
                "model": "Plus 2"
            },
            {
                "regex": "More_3",
                "model": "More 3"
            },
            {
                "regex": "Plus3_4G",
                "model": "Plus 3"
            },
            {
                "regex": "SICO[_ ]PLUS",
                "model": "Plus"
            },
            {
                "regex": "SICO[_ ]Topaz",
                "model": "Topaz"
            },
            {
                "regex": "Mega2max",
                "model": "Mega 2 Max"
            },
            {
                "regex": "Mega2",
                "model": "Mega 2"
            },
            {
                "regex": "Nile X",
                "model": "Nile X"
            },
            {
                "regex": "SSR3-1-51-5M",
                "model": "Pro 3"
            },
            {
                "regex": "SSD-1-53-13M",
                "model": "Diamond"
            },
            {
                "regex": "Diamond 2",
                "model": "Diamond 2"
            },
            {
                "regex": "Infinity Max",
                "model": "Infinity Max"
            },
            {
                "regex": "SICO[_ ]e1002",
                "device": "tablet",
                "model": "E1002"
            },
            {
                "regex": "Express3-Max",
                "device": "tablet",
                "model": "Express 3 Max"
            },
            {
                "regex": "Express3",
                "device": "tablet",
                "model": "Express 3"
            }
        ]
    },
    "Smadl": {
        "regex": "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)|SMADL[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)",
                "model": "Safari"
            },
            {
                "regex": "SMADL[ _]Matri([2X])",
                "model": "Matri $1"
            }
        ]
    },
    "EXCEED": {
        "regex": "(EX7SL?4|EX7X4|EX10S4|EX7W1 Plus|EX8S1)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Tymes": {
        "regex": "Tymes[ _](V5)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Solone": {
        "regex": "SOLONE|(?:E1457|W145[02]|Sun_S5501)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E1457",
                "model": "Earth Iron E1457"
            },
            {
                "regex": "W1450",
                "model": "Wind Breeze W1450"
            },
            {
                "regex": "W1452",
                "model": "Wind Air W1452"
            },
            {
                "regex": "SOLONE A47",
                "model": "SL-A47"
            },
            {
                "regex": "Sun_S5501",
                "model": "Sun S5501"
            },
            {
                "regex": "SOLONE[ _]Elite[ _]L5501",
                "model": "Elite L5501"
            },
            {
                "regex": "SOLONE[ _]SUMO[_ ]S5001",
                "model": "Sumo S5001"
            },
            {
                "regex": "SOLONE[ _](SL-K40|S5002)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "FarEasTone": {
        "regex": "Smart ?(601|550|50[59])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Smart $1"
    },
    "Smailo": {
        "regex": "Smailo_(2GO)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Smart Kassel": {
        "regex": "SK5501(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SK5501(?:[);/ ]|$)",
                "model": "SK5501"
            }
        ]
    },
    "Smart Tech": {
        "regex": "Smarttech[;,]",
        "device": "tv",
        "model": ""
    },
    "Colors": {
        "regex": "(?:Colors[ _](S(?:[19]|11)|P70|P[456]5|P32|E15|P50 Plus)|Pride_1A|P52_Pride5C|P90_Pride5X|P95_Pride_7s|P77_Pride_1E|P88_Pride_1X)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pride_1A(?:[);/ ]|$)",
                "model": "Pride 1A"
            },
            {
                "regex": "P95_Pride_7s(?:[);/ ]|$)",
                "model": "Pride 7S"
            },
            {
                "regex": "P77_Pride_1E(?:[);/ ]|$)",
                "model": "Pride 1E"
            },
            {
                "regex": "P52_Pride5C(?:[);/ ]|$)",
                "model": "Pride 5C"
            },
            {
                "regex": "P90_Pride5X(?:[);/ ]|$)",
                "model": "Pride 5X"
            },
            {
                "regex": "P88_Pride_1X(?:[);/ ]|$)",
                "model": "Pride 1X"
            },
            {
                "regex": "Colors[ _](S(?:[19]|11)|P70|E15|P[456]5|P32|P50 Plus)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Honeywell": {
        "regex": "(?:EDA5[01]K?|EDA[47]0|EDA71_G|EDA5[12]|CK65|CT[46]0|CT45P|CN80|EDA61K)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(CT45P)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(EDA5[01]K?|EDA[47]0|EDA5[12]|EDA61K)(?:[);/ ]|$)",
                "model": "ScanPal $1"
            },
            {
                "regex": "EDA71",
                "device": "tablet",
                "model": "ScanPal EDA71"
            },
            {
                "regex": "(CK65|CT[46]0|CN80)(?:[);/ ]|$)",
                "device": "peripheral",
                "model": "Dolphin $1"
            }
        ]
    },
    "Electroneum": {
        "regex": "electroneum(M1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "High Q": {
        "regex": "(ELT070[46]H|ELT0802H)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Pluzz": {
        "regex": "Pluzz[_-](Z552|PL5[05]10|PL4010|PL501[46]|Elite_Dual)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "IKU Mobile": {
        "regex": "IKU[_ ]|(?:Powerful_K55i|Curvy C50L)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Powerful_K55i|Curvy C50L)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "IKU[_ ](A22|A[457]0|X[23]|K3|i[34])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "IKU[_ ](T[123])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "IKU[_ ]T[_ ]Max(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T Max"
            }
        ]
    },
    "IKI Mobile": {
        "regex": "(?:GO5_55|BLESS_GO55|BLESSPLUS|KF4Go|KF5bless|GO4\\.5)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GO5_55",
                "model": "Go 5.5\""
            },
            {
                "regex": "GO4\\.5",
                "model": "Go 4.5\""
            },
            {
                "regex": "BLESS_GO55",
                "model": "Bless Go 5.5\""
            },
            {
                "regex": "BLESSPLUS",
                "model": "Bless Plus"
            },
            {
                "regex": "(KF4Go|KF5bless)",
                "model": "$1"
            }
        ]
    },
    "CG Mobile": {
        "regex": "(?:CG_OMEGA6|Omega (?:[38])|CG_EON_Blaze_Pro|CG\\|EON Blaze GOLD|Blaze [GN])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Omega ([38])(?:[);/ ]|$)",
                "model": "Omega $1"
            },
            {
                "regex": "CG_OMEGA6(?:[);/ ]|$)",
                "model": "Omega 6"
            },
            {
                "regex": "CG_EON_Blaze_Pro(?:[);/ ]|$)",
                "model": "EON Blaze Pro"
            },
            {
                "regex": "CG\\|EON Blaze GOLD(?:[);/ ]|$)",
                "model": "EON Blaze Gold"
            },
            {
                "regex": "Blaze ([GN])",
                "model": "Blaze $1"
            }
        ]
    },
    "IUNI": {
        "regex": "IUNI[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "IUNI[ _](U3|i1|N1)",
                "model": "$1"
            }
        ]
    },
    "Ordissimo": {
        "regex": "(LeNumero[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Necnot": {
        "regex": "(M002[DGQK]-2|M002N|M002N-3T|M002W-2T|6M-3T)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Einstein": {
        "regex": "Einstein(T3)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "AfriOne": {
        "regex": "(CYGNUSX?|Gravity Z2|ChampionPro)(?:[);/ ]|$)",
        "device": "phablet",
        "models": [
            {
                "regex": "CYGNUSX(?:[);/ ]|$)",
                "model": "Cygnus X"
            },
            {
                "regex": "CYGNUS(?:[);/ ]|$)",
                "model": "Cygnus"
            },
            {
                "regex": "Gravity Z2(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Gravity Z2"
            },
            {
                "regex": "ChampionPro(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Champion Pro"
            }
        ]
    },
    "Connex": {
        "regex": "(?:CTAB1044hn|CTAB-1044|SEN_1055_ARM)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(CTAB1044hn|CTAB-1044)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "SEN_1055_ARM",
                "model": "Serenity 1055 10.1\""
            }
        ]
    },
    "Connectce": {
        "regex": "(?:CP6001A)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Connect Core 6"
    },
    "ClearPHONE": {
        "regex": "ClearPHONE",
        "device": "smartphone",
        "models": [
            {
                "regex": "ClearPHONE ([246]20)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Clementoni": {
        "regex": "(?:CLEMPAD[_ ](?:6_XL|HR_Plus|HR|[68]|7_S|201[89])|ClemPhone_7|MFC_(?:2018|8))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CLEMPAD_(201[89])",
                "model": "Clempad ($1)"
            },
            {
                "regex": "MFC_2018",
                "model": "Clempad (2018)"
            },
            {
                "regex": "MFC_8",
                "model": "Clempad 8"
            },
            {
                "regex": "CLEMPAD_7_S",
                "model": "Clempad 7S"
            },
            {
                "regex": "Clempad[_ ](6_XL|HR_Plus|HR|[68])",
                "model": "Clempad $1"
            },
            {
                "regex": "ClemPhone[ _](7)",
                "device": "smartphone",
                "model": "Clemphone $1"
            }
        ]
    },
    "Cell-C": {
        "regex": "Cell_?C_|(?:Android 5(?:[\\d.]*);(?: [\\w-]+;)? (?:Summit|Fantasy))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cell_C_(Summit_Plus|Fame|Evolve)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Summit(?:[);/ ]|$)",
                "model": "Summit"
            },
            {
                "regex": "Fantasy(?:[);/ ]|$)",
                "model": "Fantasy"
            },
            {
                "regex": "CELLC_Evolve",
                "device": "tablet",
                "model": "Evolve"
            }
        ]
    },
    "VC": {
        "regex": "(?:Camellia_II|Cactus II|Maple III|Maple-II|Cactus-Pro|LavenderII|Jasmine-II)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Camellia_II|Cactus II|Maple III)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Cactus-Pro",
                "model": "Cactus Pro"
            },
            {
                "regex": "(Maple|Jasmine|Lavender)-?II(?:[);/ ]|$)",
                "model": "$1 II"
            }
        ]
    },
    "Cellacom": {
        "regex": "Cellacom|(?:S51_lite|X501_Prime)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cellacom_S62(?:[);/ ]|$)",
                "model": "S62"
            },
            {
                "regex": "S51_lite(?:[);/ ]|$)",
                "model": "S51 Lite"
            },
            {
                "regex": "X501_Prime(?:[);/ ]|$)",
                "model": "X501 Prime"
            }
        ]
    },
    "CellAllure": {
        "regex": "(?:Cool_Extreme_2|Earn2 CL|Earn|Fashion2Plus|Fashion[ _]C|Cool Duo|CHIC_X1|Miracle XS|Miracle 6.0 S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Cool_Extreme_2|Earn2 CL|Earn|Fashion[ _]C|Cool Duo|Miracle XS|Miracle 6\\.0 S)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Fashion2Plus",
                "model": "Fashion 2 Plus"
            },
            {
                "regex": "CHIC_X1",
                "model": "Chic X1"
            }
        ]
    },
    "EagleSoar": {
        "regex": "(EE10A|Z-F1010)",
        "device": "tablet",
        "model": "$1"
    },
    "Eagle": {
        "regex": "Eagle[ _](Classic Pro|Elite|Gold)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Invens": {
        "regex": "(?:Diamond D[56]|Fighter|Eager|Royal R[1-8]|Android 9(?:[\\d.]*);(?: [\\w-]+;)? (?:MAX[89]|MAX_2))(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "MAX[_ ]?([89]|2)(?:[);/ ]|$)",
                "model": "Max $1"
            },
            {
                "regex": "(Fighter|Eager|Royal R[1-8]|Diamond D[56])",
                "model": "$1"
            }
        ]
    },
    "Chico Mobile": {
        "regex": "(?:ALTO (?:Bombo|classic|Estrella|JUEGO|SUBIR|[235])|FUEGO MAX|OJOS[ _](?:CIELO|CAMBIO|NUBE|[68i]|ORO|VIVIR|Plus|DOS mini|DOS|LUNA|X1)|AVANCE classic)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ALTO Bombo",
                "model": "Alto Bombo"
            },
            {
                "regex": "ALTO classic",
                "model": "Alto Classic"
            },
            {
                "regex": "AVANCE classic",
                "model": "Avance Classic"
            },
            {
                "regex": "ALTO Estrella",
                "model": "Alto Estrella"
            },
            {
                "regex": "ALTO JUEGO",
                "model": "Alto Juego"
            },
            {
                "regex": "ALTO SUBIR",
                "model": "Alto Subir"
            },
            {
                "regex": "ALTO ([235])",
                "model": "Alto $1"
            },
            {
                "regex": "OJOS[ _]([68i]|X1)",
                "model": "Ojos $1"
            },
            {
                "regex": "OJOS NUBE",
                "model": "Ojos Nube"
            },
            {
                "regex": "OJOS CAMBIO",
                "model": "Ojos Cambio"
            },
            {
                "regex": "OJOS ORO",
                "model": "Ojos Oro"
            },
            {
                "regex": "OJOS LUNA",
                "model": "Ojos Luna"
            },
            {
                "regex": "OJOS CIELO",
                "model": "Ojos Cielo"
            },
            {
                "regex": "OJOS PLUS",
                "model": "Ojos Plus"
            },
            {
                "regex": "OJOS VIVIR",
                "model": "Ojos Vivir"
            },
            {
                "regex": "OJOS DOS mini",
                "model": "Ojos DOS Mini"
            },
            {
                "regex": "OJOS DOS",
                "model": "Ojos DOS"
            },
            {
                "regex": "FUEGO MAX",
                "device": "tablet",
                "model": "Fuego Max"
            }
        ]
    },
    "Claresta": {
        "regex": "Claresta[ _]|(?:AirPhoneS[56]|AirPhone K6)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AirPhone ?(S[56]|K6)",
                "model": "AirPhone $1"
            },
            {
                "regex": "Claresta (F3) PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "Claresta[ _](F4)",
                "model": "$1"
            }
        ]
    },
    "Camfone": {
        "regex": "(?:Camfone (?:SE)|Hero[_ ](?:H5\\+|SE2|H[579]|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s)|Mega 10|Furious 7 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Hero[_ ](?:H5\\+|SE2|H[579]|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s)|Mega 10)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Furious 7 Pro",
                "model": "Furious 7 Pro"
            },
            {
                "regex": "Camfone (SE)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Bell": {
        "regex": "(?:FibeTV|Bell Streamer)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "FibeTV",
                "model": "FibeTV"
            },
            {
                "regex": "Streamer",
                "model": "Streamer"
            }
        ]
    },
    "Bellphone": {
        "regex": "Bp100 X-Plus(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "BP 100 X-Plus"
    },
    "Gini": {
        "regex": "Gini[ _]|(?:SW17W13|SW17W08)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gini[ _]W(7)",
                "model": "W$1"
            },
            {
                "regex": "Gini[ _]n(8)",
                "model": "N$1"
            },
            {
                "regex": "Gini[ _]s5Pro|SW17W13",
                "model": "S5 Pro"
            },
            {
                "regex": "SW17W08",
                "model": "S5"
            },
            {
                "regex": "Gini[ _]Tab[ _](V[78])",
                "device": "tablet",
                "model": "Tab $1"
            }
        ]
    },
    "MIVO": {
        "regex": "(Caryota [1245789]|Jazz J[13] 2018)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(Caryota [1245789])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Jazz (J[13]) 2018",
                "model": "Jazz $1 (2018)"
            }
        ]
    },
    "Jesy": {
        "regex": "Jesy_(J7)|J9S_PRO(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "J9S_PRO",
                "model": "J9s Pro"
            },
            {
                "regex": "Jesy_(J7)",
                "model": "$1"
            }
        ]
    },
    "Teknosa": {
        "regex": "Preo[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Preo Teknosa P1",
                "model": "Preo P1"
            },
            {
                "regex": "Preo[ _]P([23])",
                "model": "Preo P$1"
            }
        ]
    },
    "Hyve": {
        "regex": "(?:Pryme 01|ST01)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pryme 01",
                "model": "Pryme 01"
            },
            {
                "regex": "ST01",
                "model": "Storm ST01"
            }
        ]
    },
    "EWIS": {
        "regex": "(?:OCTA T720Q|OCTA-T700M-T2)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "OCTA T720Q",
                "model": "Octa T720Q"
            },
            {
                "regex": "OCTA-T700M-T2",
                "model": "Octa T700M T2"
            }
        ]
    },
    "Leader Phone": {
        "regex": "(Vyper|N-5[07]|N-45|LP DAISY|LP_(?:Spectrum_S2|VEYRON|PRADO|Pro1|B-50|EVORA_light)|LP_T70|LP[ _]INFINITY\\+?|LP T70 Lite|INFINITY_light|Alphatel_T1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "N-45 light",
                "model": "N-45 Light"
            },
            {
                "regex": "Vyper PRO",
                "model": "Vyper Pro"
            },
            {
                "regex": "LP DAISY",
                "model": "Daisy"
            },
            {
                "regex": "LP_VEYRON",
                "model": "Veyron"
            },
            {
                "regex": "LP_PRADO",
                "model": "Prado"
            },
            {
                "regex": "LP_B-50",
                "model": "B50"
            },
            {
                "regex": "LP_Spectrum_S2",
                "model": "Spectrum S2"
            },
            {
                "regex": "INFINITY_light",
                "model": "Infinity Light"
            },
            {
                "regex": "LP INFINITY\\+",
                "model": "Infinity Plus"
            },
            {
                "regex": "LP_INFINITY",
                "model": "Infinity"
            },
            {
                "regex": "LP_EVORA_light",
                "model": "Evora Light"
            },
            {
                "regex": "LP T70 Lite",
                "device": "tablet",
                "model": "T70 Lite"
            },
            {
                "regex": "LP_T70",
                "device": "tablet",
                "model": "T70"
            },
            {
                "regex": "(?:LP_)?(Vyper|N-5[07]|N-45|Pro1|Alphatel_T1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Cavion": {
        "regex": "(?:Cavion[_ ](?:Solid[_ ]4[\\._]5|Base[ _](?:7|7_3G_Silver|5[._]0|10|7\\.2 Quad)|10_3GRQ)|base10_3g_silver|Cavion7\\.1quad|M1092Q)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cavion[_ ]Solid[_ ]4[._]5",
                "model": "Solid 4.5\""
            },
            {
                "regex": "Cavion[ _]BASE[ _]5[._]0",
                "model": "Base 5.0\""
            },
            {
                "regex": "CAVION_10_3GRQ",
                "device": "tablet",
                "model": "Base 10 3GR Quad"
            },
            {
                "regex": "Cavion(?:7\\.1quad)",
                "device": "tablet",
                "model": "Base 7.1\" Quad"
            },
            {
                "regex": "Cavion Base 7\\.2 Quad",
                "device": "tablet",
                "model": "Base 7.2\" Quad"
            },
            {
                "regex": "Cavion Base 10",
                "device": "tablet",
                "model": "Base 10"
            },
            {
                "regex": "Cavion Base 7 Dual",
                "device": "tablet",
                "model": "Base 7.0\" Dual"
            },
            {
                "regex": "Cavion Base 7 Quad",
                "device": "tablet",
                "model": "Base 7.0\" Quad"
            },
            {
                "regex": "(?:Cavion_)?Base_?(7|10)_3G_Silver",
                "device": "tablet",
                "model": "Base $1.0\" 3G Silver"
            },
            {
                "regex": "(M1092Q)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Canaima": {
        "regex": "CNM6762(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(CNM6762)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Canal+": {
        "regex": "CANAL PLUS",
        "device": "tv",
        "models": [
            {
                "regex": "CANAL PLUS BOX(?:[);/ ]|$)",
                "model": "TV Box"
            }
        ]
    },
    "GLX": {
        "regex": "(?:GLX (?:Aria|Dorna|Taban|Shine|Spark|ASA)|SHAHIN III?|Maad\\+?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GLX ASA",
                "model": "Asa"
            },
            {
                "regex": "SHAHIN III",
                "model": "Shahin III"
            },
            {
                "regex": "Shahin II",
                "model": "Shahin II"
            },
            {
                "regex": "Maad\\+",
                "model": "Maad Plus"
            },
            {
                "regex": "Maad",
                "model": "Maad"
            },
            {
                "regex": "GLX (Aria|Taban|Shine|Spark)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GLX (Dorna)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Seeken": {
        "regex": "Seeken[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Seeken[_ -](SG1|SJ1)",
                "model": "$1"
            },
            {
                "regex": "Seeken[_ -](ST-101)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Jivi": {
        "regex": "(?:Revolution TnT3|Xtreme_(?:[37]|3x)|Xtreme (?:XT84|XT309|XT309 Plus|1)|Opus S3|JSPQ65|Prime (?:P3[09]0|P4442?|P30))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Revolution (TnT3)",
                "model": "Revolution $1"
            },
            {
                "regex": "Opus S3",
                "model": "Opus S3"
            },
            {
                "regex": "JSPQ65",
                "model": "JSP Q65"
            },
            {
                "regex": "Xtreme (XT84)",
                "model": "Xtreme Klick $1"
            },
            {
                "regex": "Prime (P4442?|P3[09]0|P30)",
                "model": "Prime $1"
            },
            {
                "regex": "Xtreme (XT309) Plus",
                "model": "Xtreme View Pro $1 Plus"
            },
            {
                "regex": "Xtreme (XT309)",
                "model": "Xtreme View $1"
            },
            {
                "regex": "Xtreme[ _]([137]|3x)(?:[);/ ]|$)",
                "model": "Xtreme $1"
            }
        ]
    },
    "NOVO": {
        "regex": "(Bonvi Note|Bonvi Prime|Bonvi Pro|Borneo_Pro|Vi_Note)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Winnovo": {
        "regex": "Winnovo|(?:T10LTE|H(?:7|10)_US)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "T10LTE(?:[);/ ]|$)",
                "model": "T10 LTE"
            },
            {
                "regex": "H(7|10)_US(?:[);/ ]|$)",
                "model": "H$1"
            },
            {
                "regex": "Winnovo[ _]?(M866|M798|VTab|750[PK]|T2)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Winnovo[ _](V51)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "Winnovo[ _](K5[46]|K43)[a-z]{2}",
                "device": "smartphone",
                "model": "$1"
            }
        ]
    },
    "WE": {
        "regex": "WE (A[15]0|B3|F[12]0|E[12]|L[3469]|R[34]|V[34]|S1|X[13]|T1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Trio": {
        "regex": "Trio V51 DT(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "V51DT"
    },
    "Seuic": {
        "regex": "(?:AUTOID ?(?:9N|Q[79])|CRUISE[12])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(CRUISE[12])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "AUTOID ?(9N|Q[79])(?:[);/ ]|$)",
                "model": "AUTOID $1"
            }
        ]
    },
    "CENTEK": {
        "regex": "CT-(87(?:4[03]|24|32|50)|85(?:[67]5|5[08]|32|4[03])|88(?:4[03]|32|24)|8932)(?:[);/ ]|$)",
        "device": "tv",
        "model": "CT-$1"
    },
    "Centric": {
        "regex": "(?:Centric[- ]CM(?:5001|33[23]1|3321Plus)|CM4331|CM2221)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Centric[- ])?CM5001",
                "model": "A1"
            },
            {
                "regex": "(?:Centric[- ])?CM3321Plus",
                "model": "P1 Plus"
            },
            {
                "regex": "(?:Centric[- ])?CM3321",
                "model": "P1"
            },
            {
                "regex": "(?:Centric[- ])?CM3331",
                "model": "L3"
            },
            {
                "regex": "(?:Centric[- ])?CM4331",
                "model": "G1"
            },
            {
                "regex": "(?:Centric[- ])?CM2221",
                "model": "L1"
            }
        ]
    },
    "Kata": {
        "regex": "Kata[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Kata[ _-](C3|L1|M3s|M4s?|V[56])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Kata[ _-]i5-\\w",
                "model": "I5"
            },
            {
                "regex": "Kata-(T5)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "Kata-Tmini4(?:[);/ ]|$)",
                "device": "tablet",
                "model": "T Mini 4"
            },
            {
                "regex": "Kata Box 2(?:[);/ ]|$)",
                "device": "tv",
                "model": "Box 2"
            }
        ]
    },
    "Hardkernel": {
        "regex": "ODROID[-]?(C2|[NU]2|XU[34])(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "ODROID $1"
    },
    "Wiseasy": {
        "regex": "(WISENET5|WPOS-3)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Shtrikh-M": {
        "regex": "SHTRIH-SMARTPOS-F2(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "Smartpos F2"
    },
    "BBK": {
        "regex": "65LEX-8234-UTS2C|(?:32LEX-7272|24LEX-7269|([65]5|50|4[023]|3[29]|2[48])LEX[-_](81(?:27|39|45|58|6[12]|7[34])|71(?:[23]7|4[345]|5[45]|6[2368]|[57]8|7[15])|72(?:0[24]|1[23]|25|36|4[69]|5[579]|6[04]|8[789]|9[12])|82(?:02|4[369]|5[87]|65|89)|9201)[_/-]?([FU]?TS2C)(?:-T9)?|(?:3[29]|24)LEX-7289(?:-c)?|65LEX-8262)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(\\d{2})LEX[-_](\\d{3,4})[_/-]?([FU]?TS2C)",
                "model": "$1LEX-$2/$3"
            },
            {
                "regex": "(3[29]|24|65)LEX-(7289|8262)(?:-c)?(?:[);/ ]|$)",
                "model": "$1LEX-$2/TS2C"
            },
            {
                "regex": "(\\d{2})LEX[-_](\\d{3,4})",
                "model": "$1LEX-$2"
            }
        ]
    },
    "4ife": {
        "regex": "4ife (4K Smart TV Box)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Westpoint": {
        "regex": "WESTPOINT[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "(TETS-4919SM)",
                "model": "$1"
            }
        ]
    },
    "Wintouch": {
        "regex": "Q93S",
        "device": "tablet",
        "model": "Q93S"
    },
    "Aiuto": {
        "regex": "(AT702)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Seatel": {
        "regex": "Seatel",
        "device": "smartphone",
        "models": [
            {
                "regex": "Seatel[ _](L2|V8[AE]|T[5-8]|R6|V[89])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ditecma": {
        "regex": "(M1092R(?:-[12]|V[45])?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Datamini": {
        "regex": "(K908H4G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "3GNET": {
        "regex": "(?<!NetType/)3GNET[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "3GNET[ _](U8|T800|U6s)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "3GNET[ _]T ?900",
                "model": "T900"
            }
        ]
    },
    "Yoka TV": {
        "regex": "KB2 PRO(?:[);/ ]|$)",
        "device": "tv",
        "model": "KB2 Pro"
    },
    "Formovie": {
        "regex": "Xming",
        "device": "peripheral",
        "models": [
            {
                "regex": "Xming Google TV(?:[);/ ]|$)",
                "model": "Xming"
            }
        ]
    },
    "Formuler": {
        "regex": "Formuler[ _]|(?:S_TURBO_PRO)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Formuler[ _](Z(?:8|10)(?: Pro)?|Z Alpha)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "S_TURBO_PRO(?:[);/ ]|$)",
                "model": "S Turbo Pro"
            }
        ]
    },
    "Malata": {
        "regex": "(?:Build/)?Malata[ _]?([a-z0-9]+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "MBOX": {
        "regex": "MBOX3?(?:[);/ ]|$)",
        "device": "tv",
        "model": ""
    },
    "IT": {
        "regex": "IT-(?:1101S?|1101-QUAD)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "IT-1101-QUAD",
                "model": "1101 Quad"
            },
            {
                "regex": "IT-(1101S?)",
                "model": "$1"
            }
        ]
    },
    "Navcity": {
        "regex": "NP-752Go(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NP-752Go",
                "model": "NP-752 Go"
            }
        ]
    },
    "Jeka": {
        "regex": "(?:JK(?:960|[71]03) 3G|JK702|JK101|JK[17]00 v2\\.0)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "JK(960|[71]03) 3G(?:[);/ ]|$)",
                "model": "JK $1 3G"
            },
            {
                "regex": "JK(702|[17]00 v2\\.0|101)(?:[);/ ]|$)",
                "model": "JK $1"
            }
        ]
    },
    "Jiake": {
        "regex": "JK-?(760)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "JK-$1"
    },
    "iQ&T": {
        "regex": "iQ&T|iQ&amp;T|(?:IFoo (?:U200|H55|S50))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:iQ&T|iQ&amp;T) (N8)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(IFoo (?:U200|H55|S50))(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Mantra": {
        "regex": "(MFSTAB(?:_74G)?)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Datalogic": {
        "regex": "(?:MEMOR )([12]0|1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Memor $1"
    },
    "mipo": {
        "regex": "mipo[ _]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Naomi Phone": {
        "regex": "(?:NAOMIPHONE Ambar|DAMMAR)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NAOMIPHONE Ambar(?:[);/ ]|$)",
                "model": "Ambar"
            },
            {
                "regex": "DAMMAR(?:[);/ ]|$)",
                "model": "Dammar"
            }
        ]
    },
    "Navitel": {
        "regex": "NAVITEL[ _]|(?:T737PRO|T505PRO|T500 3G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:NAVITEL[ _])?(T70[07]|T500) 3G(?:[);/ ]|$)",
                "model": "$1 3G"
            },
            {
                "regex": "NAVITEL[ _](T757)LTE(?:[);/ ]|$)",
                "model": "$1 LTE"
            },
            {
                "regex": "NAVITEL[ _](A73[0157]|A650)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "T(505|737)PRO(?:[);/ ]|$)",
                "model": "T$1 Pro"
            },
            {
                "regex": "RE900 Full HD(?:[);/ ]|$)",
                "model": "RE900 Full HD"
            }
        ]
    },
    "Linnex": {
        "regex": "LI(22)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Li $1"
    },
    "SuperTab": {
        "regex": "(?:SuperTab(?:A10|K7|S7G)|K7 Kids)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SuperTab(A10|K7|S7G)",
                "model": "$1"
            },
            {
                "regex": "K7 Kids",
                "model": "K7 Kids"
            }
        ]
    },
    "Suzuki": {
        "regex": "SUZUKI[ _]|(?:ECOPAD7|SUMOPad10)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SUMOPAD(8100|10)(?:[);/ ]|$)",
                "model": "SumoPad $1"
            },
            {
                "regex": "ECOPAD7",
                "model": "ECOPad 7"
            }
        ]
    },
    "NEVIR": {
        "regex": "Nevir,([a-z0-9_ -]+),(?:wired|wireless)",
        "device": "tv",
        "model": "$1"
    },
    "Master-G": {
        "regex": "MASTER-G[;,]|NEOQC4G(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "NEOQC4G",
                "model": "GPad Neo QC 4G"
            },
            {
                "regex": "MASTER-G,([a-z0-9_ -]+),(?:wired|wireless)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "EUROLUX": {
        "regex": "EUROLUX[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "EUROLUX, ?([a-z0-9_ -]+), ?(?:wired|wireless)",
                "model": "$1"
            }
        ]
    },
    "TORNADO": {
        "regex": "TORNADO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "TORNADO, ?([a-z0-9_ -]+)\\*?, ?(?:wired|wireless)",
                "model": "$1"
            }
        ]
    },
    "Philips": {
        "regex": "Philips|NETTV/|2020/2021 UHD Android|10BDL4151T|Xenium (?:S[25]66|S706)|(?:NeoViu D1|PI3210G|TPM1[79]1E|70PUH6774_96|QM152E|QM16[134]E|TLE(?:821L|722G)|AND1E|S397|W5510|S410J|SCN550)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(10BDL4151T)",
                "device": "smart display",
                "model": "$1"
            },
            {
                "regex": "(?:Philips[_ ])?Xenium[ _](S[25]66|V787|S706)(?:[);/ ]|$)",
                "model": "Xenium $1"
            },
            {
                "regex": "(?:Philips[_ ])?(X818|X588)(?:[);/ ]|$)",
                "model": "Xenium $1"
            },
            {
                "regex": "(?:Philips[_ ])?(S397|W5510)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:AND1E|Google)(?: TV)?(?:[);/ ]|$)",
                "model": "Android TV",
                "device": "tv"
            },
            {
                "regex": "(PI3210G)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(TPM1[79]1E)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "QM152E(?:[);/ ]|$)",
                "model": "",
                "device": "tv"
            },
            {
                "regex": "(QM16[134]E)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "(70PUH6774)_96",
                "model": "$1/96 4K UHD",
                "device": "tv"
            },
            {
                "regex": "(202[01])/(?:20)?(2[12]) (?:Philips )?UHD Android",
                "model": "Smart TV UHD ($1-20$2)",
                "device": "tv"
            },
            {
                "regex": "(TLE821L)(?:[);/ ]|$)",
                "model": "$1 4G LTE",
                "device": "tablet"
            },
            {
                "regex": "(TLE722G)(?:[);/ ]|$)",
                "model": "$1",
                "device": "tablet"
            },
            {
                "regex": "(?:S410J)(?:[);/ ]|$)",
                "model": "M9 Pro",
                "device": "tablet"
            },
            {
                "regex": "Philips, BDP([0-9]{4})",
                "model": "Blu-ray Player (BDP$1)",
                "device": "tv"
            },
            {
                "regex": "Philips, ([a-z0-9-]+)",
                "model": "$1",
                "device": "tv"
            },
            {
                "regex": "(NETTV/[0-9.]{5})",
                "model": "NetTV Series",
                "device": "tv"
            },
            {
                "regex": "UHD Android TV",
                "model": "Smart TV UHD",
                "device": "tv"
            },
            {
                "regex": "Philips-FISIO ([a-z0-9]+)",
                "model": "Fisio $1"
            },
            {
                "regex": "NeoViu D1",
                "device": "peripheral",
                "model": "NeoViu D1"
            },
            {
                "regex": "SCN550",
                "device": "peripheral",
                "model": "Screeneo U5"
            },
            {
                "regex": "Philips[ _-]?([a-z0-9\\-@]+)",
                "model": "$1"
            }
        ]
    },
    "INCAR": {
        "regex": "(KZCAR)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "FaRao Pro": {
        "regex": "(FTRW100)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Nabi": {
        "regex": "(?:DMTAB-(?:IN08A|NV08B|NV2[04]A)|NBTY07SMKG|NBFP07PMKG|SNB02-NV7A|NABI2-NV7A)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "DMTAB-(?:IN08A|NV08B)",
                "model": "Dream Tab HD 8.0\""
            },
            {
                "regex": "DMTAB-NV(2[04])A",
                "model": "Big Tab HD $1.0\""
            },
            {
                "regex": "NBTY07SMKG",
                "model": "Barbie Tab 7.0\""
            },
            {
                "regex": "NBFP07PMKG",
                "model": "Fisher Price Learning Tab 7.0\""
            },
            {
                "regex": "SNB02-NV7A",
                "model": "2S Tab"
            },
            {
                "regex": "NABI2-NV7A",
                "model": "2 Tab"
            }
        ]
    },
    "StrawBerry": {
        "regex": "StrawBerry[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "StrawBerry[ _](SX|QX15)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "STRONG": {
        "regex": "LEAP-S1|SH6B7CE_EU012",
        "device": "tv",
        "models": [
            {
                "regex": "LEAP-S1",
                "model": "LEAP-S1"
            },
            {
                "regex": "(SH6B7CE)_(EU012)",
                "model": "$1-$2"
            }
        ]
    },
    "Gresso": {
        "regex": "Gresso[ _]|(?:REGAL R2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "REGAL R2",
                "model": "Regal R2"
            },
            {
                "regex": "Gresso[ _]Regal(?:[);/ ]|$)",
                "model": "Regal"
            }
        ]
    },
    "Pendoo": {
        "regex": "Pendoo|A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4|(?:PNDP60L10BLK|PNDP60M7PUR)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Pendoo ?(T95Z|X10) PLUS",
                "model": "$1 Plus"
            },
            {
                "regex": "Pendoo ?X8PRO+",
                "model": "X8 Pro+"
            },
            {
                "regex": "Pendoo[ \\.]?(X9[29]|T95)",
                "model": "$1"
            },
            {
                "regex": "pendoo mini",
                "model": "Mini"
            },
            {
                "regex": "X11 PRO",
                "model": "X11 Pro"
            },
            {
                "regex": "A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4",
                "model": "A5X Max"
            },
            {
                "regex": "(PNDP60L10BLK|PNDP60M7PUR)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "PiPO": {
        "regex": "Pipo[_ ]|PipoM9Pro",
        "device": "tablet",
        "models": [
            {
                "regex": "Pipo[_ ]([TP]9)",
                "model": "$1"
            },
            {
                "regex": "PipoM9Pro",
                "model": "M9 Pro"
            },
            {
                "regex": "PIPO[_ ](X10|X9S)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Engel": {
        "regex": "(EN1007Q)plus(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1 Plus"
    },
    "Genesis": {
        "regex": "(SK-Mtek GT730[15])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Infomir": {
        "regex": "(MAG(?:200|[23]50|425A))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "InfoKit": {
        "regex": "(TVB-906X)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Blloc": {
        "regex": "(Zero18)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Huskee": {
        "regex": "(?:VULKANO|ST-810)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VULKANO",
                "model": "Vulkano"
            },
            {
                "regex": "(ST-810)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "SOLE": {
        "regex": "SOLE[_ ]POP[_ ]S([45]0)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Pop S$1"
    },
    "SOLO": {
        "regex": "(?:SOLO[_ ](?:Aspire(?: M)?)|Inspire_U5(?:_PLUS)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:SOLO[_ ](Aspire(?: M)?))",
                "model": "$1"
            },
            {
                "regex": "Inspire_U5_PLUS",
                "model": "Inspire U5 Plus"
            },
            {
                "regex": "Inspire_U5",
                "model": "Inspire U5"
            }
        ]
    },
    "OINOM": {
        "regex": "OINOM[_ ](V9D|V7H|V[679])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Singtech": {
        "regex": "Singtech|(?:Sapphire[_ ](?:H50S|H7S?|H90)|Infinity_I(?:1|_Mix))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Sapphire[_ ](H50S|H7S?|H90)(?:[);/ ]|$)",
                "model": "Sapphire $1"
            },
            {
                "regex": "Singtech[ _](Q2|S1)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Infinity_I1(?:[);/ ]|$)",
                "model": "Infinity I1"
            },
            {
                "regex": "Infinity_I_Mix(?:[);/ ]|$)",
                "model": "Infinity I Mix"
            }
        ]
    },
    "TEENO": {
        "regex": "TEENO",
        "device": "smartphone",
        "models": [
            {
                "regex": "TEENO[_ ](S9|A1|i12|S11)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "v-mobile": {
        "regex": "Vmobile[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Vmobile[ _](J7)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Vmobile XS Pro(?:[);/ ]|$)",
                "model": "XS Pro"
            }
        ]
    },
    "OASYS": {
        "regex": "(TEG9300)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Aspera": {
        "regex": "ASPERA|(?:Wren|Jazz 2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ASPERA[ _](R5h|R9|RT3|A4[02]|A50|F30|R40)(?:_4G)?(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Wren(?:[);/ ]|$)",
                "model": "Wren"
            },
            {
                "regex": "Jazz 2(?:[);/ ]|$)",
                "model": "Jazz 2"
            }
        ]
    },
    "Vision Touch": {
        "regex": "Vision ?Touch",
        "device": "smartphone",
        "models": [
            {
                "regex": "VisionTouchLife",
                "model": "Life"
            },
            {
                "regex": "Inspire",
                "model": "Inspire"
            }
        ]
    },
    "NOBUX": {
        "regex": "SMART_VOLT_NX5(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Smart Volt NX5"
    },
    "Hitech": {
        "regex": "(Amaze[ _](?:S2_4G|S[56] 4G|S1|S[56](?: Plus)?))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "F150": {
        "regex": "(?:Bison2021|B2021|[HR]2022|Air1 Pro| Air1| B[12] Pro|(?:B2|Air2) Ultra|Action A5Pro|Raptor (?:5G|LTD)|Android 12(?:[\\d.]*);(?: [\\w-]+;)? (?:B1)|Android 1[34](?:[\\d.]*);(?: [\\w-]+;)? (?:Raptor|B2))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "B2 Ultra",
                "model": "B2 Ultra"
            },
            {
                "regex": "Raptor 5G",
                "model": "Raptor 5G"
            },
            {
                "regex": "Raptor LTD",
                "model": "Raptor LTD"
            },
            {
                "regex": "Raptor",
                "model": "Raptor"
            },
            {
                "regex": "Action A5Pro",
                "model": "Action A5 Pro"
            },
            {
                "regex": "([HR]2022|Air1 (?:Ultra Pro|Ultra\\+?|Pro)|Air1|B[12] Pro|Air2 Ultra)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:Bison2021|B2021)(?:[);/ ]|$)",
                "model": "B2021"
            },
            {
                "regex": "(B[12])(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "BilimLand": {
        "regex": "BilimBook mini(?:[);/ ]|$)",
        "device": "desktop",
        "model": "BilimBook Mini"
    },
    "Greentel": {
        "regex": "(?:X1_Light(?:_Lte)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X1_Light(?:_Lte)?",
                "model": "X1 Light LTE"
            }
        ]
    },
    "Gretel": {
        "regex": "Gretel|(?:GT6000)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(GT6000)",
                "model": "$1"
            },
            {
                "regex": "Gretel; (A[67])",
                "model": "$1"
            }
        ]
    },
    "Kyowon": {
        "regex": "(KA-E410W)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "LT Mobile": {
        "regex": "LT[ _-](?:E1[68]|P[89]|9701|9902|P10I|NOTE 10[SM]|NOTE 30|C1[45]00|C26|C3[1235]00|C3750|S10[ _]Lite|S10|S33|S9_NOTE|M[56]|M5_lite|C1300|6217|6509|2003|C60)|(?:C3[67]00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LT[- ]NOTE ([13]0[SM]?)",
                "model": "Note $1"
            },
            {
                "regex": "LT_S9_NOTE",
                "model": "Note S9"
            },
            {
                "regex": "LT[ _-]C3100",
                "model": "P9"
            },
            {
                "regex": "LT[ _-]C3200",
                "model": "P10"
            },
            {
                "regex": "LT[ _-]C3750",
                "model": "P40"
            },
            {
                "regex": "LT[ _-]C1400",
                "model": "P7s"
            },
            {
                "regex": "LT[ _-]C3500",
                "model": "P10 Plus"
            },
            {
                "regex": "(?:LT[ _-])?C3600",
                "model": "P20"
            },
            {
                "regex": "(?:LT[ _-])?C3700",
                "model": "P30"
            },
            {
                "regex": "LT[ _-](C3300|C1500)",
                "model": "$1"
            },
            {
                "regex": "LT[ _]S10[ _]Lite",
                "model": "S10 Lite"
            },
            {
                "regex": "LT[ _]S10",
                "model": "S10"
            },
            {
                "regex": "LT[ _]C1300",
                "model": "W7"
            },
            {
                "regex": "LT[ _]P10I",
                "model": "P10i"
            },
            {
                "regex": "LT[ _]9701",
                "model": "M50"
            },
            {
                "regex": "LT[ _]6217",
                "model": "M15"
            },
            {
                "regex": "LT[ _]6509",
                "model": "M40"
            },
            {
                "regex": "LT[ _]9902",
                "model": "M60"
            },
            {
                "regex": "LT[ _]2003",
                "model": "M25 Power"
            },
            {
                "regex": "LT[ _]S33",
                "model": "S33"
            },
            {
                "regex": "LT[ _]P([89])(?:[);/ ]|$)",
                "model": "P$1"
            },
            {
                "regex": "LT[ _]E(1[68])(?:[);/ ]|$)",
                "model": "E$1"
            },
            {
                "regex": "LT[ _]C(60|26)(?:[);/ ]|$)",
                "model": "C$1"
            },
            {
                "regex": "LT[ _]M([56])[_ ]lite(?:[);/ ]|$)",
                "model": "M$1 Lite"
            },
            {
                "regex": "LT[ _]M([56])(?:[);/ ]|$)",
                "model": "M$1"
            }
        ]
    },
    "ONYX BOOX": {
        "regex": "(?:KON_TIKI(2)?|Nova3Color|GoColor7|Lomonosov3?|Poke2Color|NovaAirC|NoteAir(?:2P?|[34]C)|TabUltraCPro|LIVINGSTONE[23]|MC_FAUST[23]|DARWIN[9X]|MC_DARWIN[678]|MC_GAMA4|MC_Cristo4|MC_NovaPro|VOLTA[45]|Kon_Tiki3|FAUST[56]|GALILEO|Poke3|KANT2)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "VOLTA([45])",
                "model": "Volta $1"
            },
            {
                "regex": "NovaAirC",
                "model": "Nova Air C"
            },
            {
                "regex": "MC_NovaPro",
                "model": "Nova Pro"
            },
            {
                "regex": "NoteAir2P",
                "model": "Nova Air 2 Plus"
            },
            {
                "regex": "NoteAir2",
                "model": "Nova Air 2"
            },
            {
                "regex": "Nova3Color",
                "model": "Nova 3 Color"
            },
            {
                "regex": "Poke2Color",
                "model": "Poke 2 Color"
            },
            {
                "regex": "Poke3",
                "model": "Poke 3"
            },
            {
                "regex": "KANT2",
                "model": "Kant 2"
            },
            {
                "regex": "KON_TIKI([23])?",
                "model": "Kon Tiki $1"
            },
            {
                "regex": "Lomonosov(3)",
                "model": "Lomonosov $1"
            },
            {
                "regex": "Lomonosov",
                "model": "Lomonosov"
            },
            {
                "regex": "(?:MC_)?FAUST([2356])",
                "model": "Faust $1"
            },
            {
                "regex": "(?:MC_)?DARWIN([6789X])",
                "model": "Darwin $1"
            },
            {
                "regex": "MC_GAMA4",
                "model": "Gama 4"
            },
            {
                "regex": "GALILEO",
                "model": "Galileo"
            },
            {
                "regex": "GoColor7",
                "model": "Go Color 7"
            },
            {
                "regex": "MC_Cristo4",
                "model": "Monte Cristo 4"
            },
            {
                "regex": "LIVINGSTONE([23])",
                "model": "Living Stone $1"
            },
            {
                "regex": "NoteAir([34])C",
                "model": "Note Air $1C"
            },
            {
                "regex": "TabUltraCPro",
                "model": "Tab Ultra C Pro"
            }
        ]
    },
    "AIRON": {
        "regex": "AIRBOOK PRO 8S(?:[);/ ]|$)",
        "device": "tablet",
        "model": "AirBook Pro 8S"
    },
    "5IVE": {
        "regex": "Tarzan F1(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Tarzan F1"
    },
    "GFive": {
        "regex": "GFIVE[_ ]|(?:PRESIDENT_GOLD_(9|10)|President Gpower 1|Stark(?![_ ]K1)|Gpad70[12]|Speedo_1|4G Ultra Pro|4G 6700|4G Style)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PRESIDENT_GOLD_(9|10)",
                "model": "President Gold $1"
            },
            {
                "regex": "President Gpower 1",
                "model": "President GPower 1"
            },
            {
                "regex": "GFIVE[_ ]President[_ ]Xhero[_ ](\\d)",
                "model": "President XHero $1"
            },
            {
                "regex": "President (A97)",
                "model": "President $1"
            },
            {
                "regex": "President Classic (\\d)",
                "model": "President Classic $1"
            },
            {
                "regex": "President G6 Plus",
                "model": "President G6 Plus"
            },
            {
                "regex": "President G10 Fashion",
                "model": "President G10 Fashion"
            },
            {
                "regex": "President ?\\(?G(\\d)\\)?",
                "model": "President G$1"
            },
            {
                "regex": "President Tango (\\d)",
                "model": "President Tango $1"
            },
            {
                "regex": "GFIVE[_ ]President[_ ]Smart[_ ](A98|\\d)",
                "model": "President Smart $1"
            },
            {
                "regex": "Stark",
                "model": "Stark"
            },
            {
                "regex": "Speedo_1",
                "model": "Speedo 1"
            },
            {
                "regex": "4G Ultra Pro",
                "model": "4G Ultra Pro"
            },
            {
                "regex": "4G Style",
                "model": "4G Style"
            },
            {
                "regex": "4G 6700",
                "model": "4G 6700"
            },
            {
                "regex": "GPad(70[12])",
                "device": "tablet",
                "model": "GPad$1"
            }
        ]
    },
    "KINGZONE": {
        "regex": "KINGZONE_|K1[_ ]turbo",
        "device": "smartphone",
        "models": [
            {
                "regex": "KINGZONE_(N5)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "K1[_ ]turbo",
                "model": "K1 Turbo"
            }
        ]
    },
    "M-Tech": {
        "regex": "(?:Eros[_ ](4G|Star|Smart|Plus|Power)|MTECH (?:ACE9|TURBO L\\d+|TEZ 4G|JAZBAA)|Foto3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EROS 4G",
                "model": "Eros 4G"
            },
            {
                "regex": "Eros[_ ]Star",
                "model": "Eros Star"
            },
            {
                "regex": "Eros[_ ]Smart",
                "model": "Eros Smart"
            },
            {
                "regex": "Eros[_ ]Plus",
                "model": "Eros Plus"
            },
            {
                "regex": "Eros[_ ]Power",
                "model": "Eros Power"
            },
            {
                "regex": "ACE9",
                "model": "Ace 9"
            },
            {
                "regex": "JAZBAA",
                "model": "JAZBAA"
            },
            {
                "regex": "TEZ 4G",
                "model": "TEZ 4G"
            },
            {
                "regex": "Foto3",
                "model": "Foto 3"
            },
            {
                "regex": "TURBO L(\\d+)",
                "model": "Turbo L$1"
            }
        ]
    },
    "Fantec": {
        "regex": "FAN-M300H(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "M300H"
    },
    "AURIS": {
        "regex": "(TB-703G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "YUHO": {
        "regex": "YUHO_|(?:Netra(?:[_ ](?:Plus|Lite))?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YUHO_(O2|H2|Y[123])_PRO",
                "model": "$1 Pro"
            },
            {
                "regex": "YUHO_Vast_Plus",
                "model": "Vast Plus"
            },
            {
                "regex": "YUHO_Y1_ACE",
                "model": "Y1 Ace"
            },
            {
                "regex": "YUHO_Y1_StarS",
                "model": "Y1 Star S"
            },
            {
                "regex": "YUHO_Y1_STAR",
                "model": "Y1 Star"
            },
            {
                "regex": "YUHO_O1_LITE",
                "model": "O1 Lite"
            },
            {
                "regex": "(?:YUHO_)?(Vast2?|O[12]|Y2|Netra(?:[_ ](?:Plus|Lite))?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "F2 Mobile": {
        "regex": "(?:Z8PLUS|Z8POCKET|LT5216|F80s_plus|C8Finger|F80 PIABELLA|i8_ROKR|LT1[68])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Z8PLUS",
                "model": "Z8 Plus"
            },
            {
                "regex": "i8_ROKR",
                "model": "i8 Rokr"
            },
            {
                "regex": "Z8POCKET",
                "model": "Z8 Pocket"
            },
            {
                "regex": "F80s_plus",
                "model": "F80s Plus"
            },
            {
                "regex": "F80 PIABELLA",
                "model": "F80 Piabella"
            },
            {
                "regex": "(LT5216|LT1[68])(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "C8Finger",
                "model": "C8 Finger"
            }
        ]
    },
    "Zaith": {
        "regex": "(Z3211G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Zealot": {
        "regex": "Zealot(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box"
    },
    "Spectralink": {
        "regex": "(Versity (?:9640|9553))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vega": {
        "regex": "Vega (Q7128)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Bleck": {
        "regex": "(?:BE_(xl|se|o2|fr|et|dg)|BL-919845)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "BE_(xl|se|o2|fr|et|dg)(?:[);/ ]|$)",
                "model": "BE $1"
            },
            {
                "regex": "BL-919845",
                "device": "tablet",
                "model": "BE clever 7.0\""
            }
        ]
    },
    "BS Mobile": {
        "regex": "(?:RUNE III?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RUNE (III?)(?:[);/ ]|$)",
                "model": "Rune $1"
            }
        ]
    },
    "RoyQueen": {
        "regex": "(?:RQ[ -](Regal R8|713S|712|768)|Bishop-RQ451)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RQ (Regal R8)",
                "model": "$1"
            },
            {
                "regex": "Bishop-RQ451",
                "model": "Bishop"
            },
            {
                "regex": "RQ-(713S|712|768)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Remdun": {
        "regex": "RD(?:16Q|86E)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "RD(16Q|86E)(?:[);/ ]|$)",
                "model": "RD$1"
            }
        ]
    },
    "Revo": {
        "regex": "Revo[_ ](?:Youplus|555)|RevoYou",
        "device": "smartphone",
        "models": [
            {
                "regex": "Revo_Youplus",
                "model": "You Plus"
            },
            {
                "regex": "Revo[ _]?(You|555)",
                "model": "$1"
            }
        ]
    },
    "Axioo": {
        "regex": "Axioo[_ ]|PICOp(?:hone|ad)[_-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Axioo[_ ](AX[45])",
                "model": "$1"
            },
            {
                "regex": "PICOphone_(L1|M4N|M4P_M3|M4U_M2_M)",
                "model": "PicoPhone $1"
            },
            {
                "regex": "PICOphone_M2",
                "model": "PicoPhone M2 M"
            },
            {
                "regex": "PICOpad[_-](7H_7|7H|GGT)(?:_3G)?",
                "device": "tablet",
                "model": "PicoPad $1 3G"
            }
        ]
    },
    "Pico": {
        "regex": "(?:Pico (?:G2 4K|Neo ?3|4)|A8110)(?:[);/ ]|$)",
        "device": "wearable",
        "models": [
            {
                "regex": "Neo3 Link",
                "model": "Neo 3 Link"
            },
            {
                "regex": "Pico (G2 4K|Neo 3|4)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(A8110)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "STG Telecom": {
        "regex": "STG[ _](A[12] Pro|[AS]1|X[1-3]|X20|S[1-3]0|[BCHP]10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "SMT Telecom": {
        "regex": "(?:CRUSH_X565|BLAZE_X500)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "CRUSH_X565",
                "model": "Crush X565"
            },
            {
                "regex": "BLAZE_X500",
                "model": "Blaze X500"
            }
        ]
    },
    "Rivo": {
        "regex": "PHANTOM (?:PZ|RX)|RHYTHM[ _]RX|(?:STORM_S8(?: ?plus)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "STORM_S8plus",
                "model": "Storm S8 Plus"
            },
            {
                "regex": "STORM_S8",
                "model": "Storm S8"
            },
            {
                "regex": "PHANTOM PZ ?(2[05]|[13]5|4|18)(?:[);/ ]|$)",
                "model": "Phantom PZ$1"
            },
            {
                "regex": "PHANTOM RX ?(298|387)(?:[);/ ]|$)",
                "model": "Phantom RX$1"
            },
            {
                "regex": "RHYTHM[ _]RX ?([15-9]0|[467]5|[12]80|150|[14]00)(?:[);/ ]|$)",
                "model": "Rhythm RX$1"
            }
        ]
    },
    "Four Mobile": {
        "regex": "(?:Four[ _]?(S600|S300I|S185|K500|S61)|S62_Eco_3|S186_Sky_3|S710 Ruby)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Four[ _]?(S600|S300I|K500)",
                "model": "$1"
            },
            {
                "regex": "Four[ _]?S185",
                "model": "S185 Sky 2"
            },
            {
                "regex": "S186_Sky_3",
                "model": "S186 Sky 3"
            },
            {
                "regex": "Four[ _]?S61",
                "model": "S61 Eco 2"
            },
            {
                "regex": "S62_Eco_3",
                "model": "S62 Eco 3"
            },
            {
                "regex": "S710 Ruby",
                "model": "S710 Ruby"
            }
        ]
    },
    "7 Mobile": {
        "regex": "(?:SWEGUE|DRENA|Kamba(?:_2)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Swegue",
                "model": "Swegue"
            },
            {
                "regex": "DRENA",
                "model": "Drena"
            },
            {
                "regex": "Kamba_2",
                "model": "Kamba 2"
            },
            {
                "regex": "Kamba",
                "model": "Kamba"
            }
        ]
    },
    "UZ Mobile": {
        "regex": "Uzbekistan(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Uzbekistan"
    },
    "KREZ": {
        "regex": "KREZ[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "KREZ[_ ](SL502)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "KREZ[_ ](TM100[12]S8)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1 3G"
            }
        ]
    },
    "KRIP": {
        "regex": "KRIP_|K(?:4[bm]|5[bdm]|6b|55h?|57|65|700A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:KRIP_)?K(4[bm]?|5[bdm]|6b|55h?|57|65|700A)(?:[);/ ]|$)",
                "model": "K$1"
            }
        ]
    },
    "Kurio": {
        "regex": "Kurio|C15100m",
        "device": "tablet",
        "models": [
            {
                "regex": "C15100m(?:[);/ ]|$)",
                "model": "Tab 2"
            },
            {
                "regex": "Kurio[_ ]?(10S|7S)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Kurio[_ ]?Phone(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Phone C14500"
            }
        ]
    },
    "Inch": {
        "regex": "Inch (?:Regulus (?:7\\.85|II)|Avior 3)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Regulus 7\\.85)",
                "model": "$1\""
            },
            {
                "regex": "(Regulus II|Avior 3)",
                "model": "$1"
            }
        ]
    },
    "UTime": {
        "regex": "UTIME[ _](U6|G7|U100|[TX]1|FX)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "L-Max": {
        "regex": "(?:Sapphire 8|Sapphire[76]|Mega plus[23])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mega plus([23])",
                "model": "Mega Plus $1"
            },
            {
                "regex": "Sapphire ?([678])",
                "model": "Sapphire $1"
            }
        ]
    },
    "WIWA": {
        "regex": "WIWA DREAM PLAYER(?:[);/ ]|$)",
        "device": "tv",
        "model": "Dream Player TV"
    },
    "FMT": {
        "regex": "(?:16M4HI105024|FMT-NM7058-02|FXT113R|176HS1050(?:232|531)|175WT1050231|175HS1050231|175FT1050241|Global3 B01|FunPad-8Max)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "16M4HI105024",
                "model": "Netsurfer Storm"
            },
            {
                "regex": "Global3 B01",
                "model": "Global3 B01"
            },
            {
                "regex": "FMT-NM7058-02",
                "model": "Flash"
            },
            {
                "regex": "176HS1050531",
                "model": "Falcon"
            },
            {
                "regex": "176HS1050232",
                "model": "B52"
            },
            {
                "regex": "175WT1050231",
                "model": "Eagle"
            },
            {
                "regex": "175HS1050231",
                "model": "Tomcat"
            },
            {
                "regex": "175FT1050241",
                "model": "Viper"
            },
            {
                "regex": "(FXT113R)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "FunPad-8Max",
                "device": "tablet",
                "model": "FunPad 8 Max"
            }
        ]
    },
    "mPhone": {
        "regex": "mPhone ?([68]|7 Plus|7s)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Cobalt": {
        "regex": "Cobalt[ _-](?:SM|T)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cobalt[ _-]SM_(55?|6)",
                "model": "SM$1"
            },
            {
                "regex": "Cobalt[ _-]T((?:7|10))[ _]3G",
                "device": "tablet",
                "model": "T$1 3G"
            },
            {
                "regex": "Cobalt[ _-]T((?:7|10))[ _]wifi",
                "device": "tablet",
                "model": "T$1 WiFi"
            }
        ]
    },
    "New Balance": {
        "regex": "NB (RunIQ)(?:[);/ ]|$)",
        "device": "wearable",
        "model": "$1"
    },
    "AOYODKG": {
        "regex": "AOYODKG",
        "device": "tablet",
        "models": [
            {
                "regex": "AOYODKG[_ ](A38)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Xtratech": {
        "regex": "(?:BRIO[_ ]X31|XM14G|X10MT(?:16|87))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(BRIO[_ ]X31)",
                "model": "$1"
            },
            {
                "regex": "XM14G",
                "device": "tablet",
                "model": "IguanaPad XM14G"
            },
            {
                "regex": "X10MT16",
                "device": "tablet",
                "model": "X10MT16"
            },
            {
                "regex": "X10MT87",
                "device": "tablet",
                "model": "IguanaPad 10.1\""
            }
        ]
    },
    "XGIMI": {
        "regex": "(?:XGIMI TV|XK03H|MoGo Pro)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "XK03H",
                "model": "Horizon Pro"
            },
            {
                "regex": "MoGo Pro",
                "model": "MoGo Pro"
            }
        ]
    },
    "VIVIBright": {
        "regex": "(F30UP)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Raspberry": {
        "regex": "Raspberry (Pi [0-9]+)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Tambo": {
        "regex": "(TA-(?:2[_ ](?:3G|Pro)|5[05][_ ]Power|[1-4]|[1246]0))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Smooth Mobile": {
        "regex": "Smooth|S2 Advance(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S2 Advance",
                "model": "S2 Advance"
            },
            {
                "regex": "Smooth 5\\.5 lite",
                "model": "Smooth 5.5 Lite"
            },
            {
                "regex": "Smooth (5\\.[05]|6\\.[015])(?:[);/ ]|$)",
                "model": "Smooth $1"
            },
            {
                "regex": "Smooth626(?:[);/ ]|$)",
                "model": "Smooth 6.26"
            },
            {
                "regex": "Smooth 6\\.26 (Lite|Max|Pro)(?:[);/ ]|$)",
                "model": "Smooth 6.26 $1"
            },
            {
                "regex": "Smooth Note 6\\.8(?:[);/ ]|$)",
                "model": "Smooth Note 6.8"
            },
            {
                "regex": "Smooth (8GT)(?:[);/ ]|$)",
                "model": "Smooth $1",
                "device": "tablet"
            }
        ]
    },
    "Smotreshka": {
        "regex": "Smotreshka Box (115NA|413NA|213a?)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Gooweel": {
        "regex": "Gooweel| M5 Pro(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gooweel; (S7);",
                "model": "$1"
            },
            {
                "regex": "M5 Pro",
                "model": "M5 Pro"
            }
        ]
    },
    "Elekta": {
        "regex": "ELED-(?:4[238]S[AM]{2}RT|5[05](?:CV_)?SMART_UHD|32SMART)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "ELED-(4[238])S[AM]{2}RT(?:[);/ ]|$)",
                "model": "$1\" FHD LED Smart TV"
            },
            {
                "regex": "ELED-55CV_SMART_UHD(?:[);/ ]|$)",
                "model": "55\" UHD Curved LED Smart TV"
            },
            {
                "regex": "ELED-(50)SMART_UHD(?:[);/ ]|$)",
                "model": "$1\" UHD LED Smart TV"
            },
            {
                "regex": "ELED-(32)SMART(?:[);/ ]|$)",
                "model": "$1\" HD LED Smart TV"
            }
        ]
    },
    "YASIN": {
        "regex": "YASIN ",
        "device": "tv",
        "models": [
            {
                "regex": "YASIN ([24])K G Smart TV",
                "model": "$1K G Smart TV"
            },
            {
                "regex": "YASIN (?:Android|2K) (?:Android )?TV(?:[);/ ]|$)",
                "model": "2K Smart TV"
            },
            {
                "regex": "YASIN 4K Android TV(?:[);/ ]|$)",
                "model": "4K Smart TV"
            }
        ]
    },
    "Blow": {
        "regex": "(?:LaserTAB10|PlatinumTAB(?:11|8)_4G|PlatinumTAB10V22|PlatinumTAB10_4G_V\\d|BlackTab7_3G_V2|BlackTAB7)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "LaserTAB10",
                "model": "Laser Tab 10"
            },
            {
                "regex": "PlatinumTAB11_4G",
                "model": "Platinum Tab 11 4G"
            },
            {
                "regex": "PlatinumTAB8_4G",
                "model": "Platinum Tab 8 4G"
            },
            {
                "regex": "PlatinumTAB10V22",
                "model": "Platinum Tab 10 V22"
            },
            {
                "regex": "PlatinumTAB10_4G_(V\\d)",
                "model": "Platinum Tab 10 4G $1"
            },
            {
                "regex": "BlackTab7_3G_V2",
                "model": "Black Tab 3G V2"
            },
            {
                "regex": "BlackTAB7",
                "model": "Black Tab 3G"
            }
        ]
    },
    "FNF": {
        "regex": "(?:ifive[_ ]?(?:mini[_ ][43]G?S|X2|Mini3|3|Air|Pro 2))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "ifive[_ ]mini[_ ]([43]G?S)",
                "model": "iFive Mini $1"
            },
            {
                "regex": "ifive(X2|3)",
                "model": "iFive $1"
            },
            {
                "regex": "ifiveMini3",
                "model": "iFive Mini 3"
            },
            {
                "regex": "ifive ?Air",
                "model": "iFive Air"
            },
            {
                "regex": "ifive Pro 2",
                "model": "iFive Pro 2"
            }
        ]
    },
    "iMan": {
        "regex": "(i5800C|i6800|Victor(?:_S)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "VAVA": {
        "regex": "VAVA[ _](X3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "ivvi": {
        "regex": "ivvi[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ivvi P60_X11 Plus",
                "model": "P60-X11 Plus"
            },
            {
                "regex": "ivvi[ _](P60)[_ ](\\w\\d+)",
                "model": "$1-$2"
            },
            {
                "regex": "ivvi[ _]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Dragon Touch": {
        "regex": "(?:Notepad[_ ](?:K10|102|Y80)|MAX 10|T12M_EEA|Y88X__PLUS)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "MAX 10",
                "model": "Max 10"
            },
            {
                "regex": "T12M",
                "model": "T12M"
            },
            {
                "regex": "Y88X__PLUS",
                "model": "Y88X Plus"
            },
            {
                "regex": "Notepad[_ ](K10|102|Y80)",
                "model": "Notepad $1"
            }
        ]
    },
    "Dreamgate": {
        "regex": "Sens 5(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Sens 5(?:[);/ ]|$)",
                "model": "Sens 5"
            }
        ]
    },
    "AOpen": {
        "regex": "(WT(?:22|19)M-FI)(?:[);/ ]|$)",
        "device": "smart display",
        "model": "eTILE $1"
    },
    "AG Mobile": {
        "regex": "(Hashtag|Shine|Chacer)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "DIGIFORS": {
        "regex": "DIGIFORS (400)(?:[);/ ]|$)",
        "device": "tv",
        "model": "Smart $1"
    },
    "DISH": {
        "regex": "(?:WTCELERO5G|Celero(?:3[ _])?5G\\+?|SN339D)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Celero5G\\+",
                "model": "Celero 5G+"
            },
            {
                "regex": "SN339D",
                "model": "Celero 5G SC"
            },
            {
                "regex": "Celero3 5G\\+",
                "model": "Celero 3 5G+"
            },
            {
                "regex": "Celero3 5G",
                "model": "Celero 3 5G"
            },
            {
                "regex": "WTCELERO5G|Celero5G",
                "model": "Celero 5G"
            }
        ]
    },
    "VIWA": {
        "regex": "(?:LIGHT MINI|VIWA A5\\+|LIGHT PLUS|LIGHT ONE|POWER P1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LIGHT MINI",
                "model": "Light Mini"
            },
            {
                "regex": "LIGHT PLUS",
                "model": "Light Plus"
            },
            {
                "regex": "LIGHT ONE",
                "model": "Light One"
            },
            {
                "regex": "VIWA A5\\+",
                "model": "Light A5 Plus"
            },
            {
                "regex": "POWER P1",
                "model": "Power P1"
            }
        ]
    },
    "M-Horse": {
        "regex": "M-HORSE|(?:Pure (?:3|2A?)|Pure ?1|Power1|Top_(?:S[78]|P9|H740|10|i7|Note8)|Android 14(?:[\\d.]*);(?: [\\w-]+;)? (?:C6[78])|Top-V30)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pure ?([13]|2A?)(?:[);/ ]|$)",
                "model": "Pure $1"
            },
            {
                "regex": "Power1",
                "model": "Power 1"
            },
            {
                "regex": "Top[_ -](S[78]|P9|H740|10|i7|V30)",
                "model": "Top $1"
            },
            {
                "regex": "TOP_Note8",
                "model": "Top Note 8"
            },
            {
                "regex": " (C6[78])(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "M-KOPA": {
        "regex": "M-KOPA",
        "device": "smartphone",
        "models": [
            {
                "regex": "(X20|X2)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "ProVision": {
        "regex": "ProVision (S1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Sirin Labs": {
        "regex": "(?:FINNEY U1|SOLARIN)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:FINNEY U1)(?:[);/ ]|$)",
                "model": "Finney U1"
            },
            {
                "regex": "(?:SOLARIN)(?:[);/ ]|$)",
                "model": "Solarin"
            }
        ]
    },
    "SK Broadband": {
        "regex": "BHX-UH200|BID-AT200",
        "device": "tv",
        "models": [
            {
                "regex": "BHX-UH200(?:[);/ ]|$)",
                "model": "BHX-UH200"
            },
            {
                "regex": "BID-AT200(?:[);/ ]|$)",
                "model": "B TV Smart 3 (2021)"
            }
        ]
    },
    "Humax": {
        "regex": "Humax[;,_]|(AIVI-N3000RV)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Humax[;,] ([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Humax_liberty,([a-z0-9]+),(?:wired|wireless)",
                "model": "$1"
            },
            {
                "regex": "(AIVI-N3000RV)(?:[);/ ]|$)",
                "device": "car browser",
                "model": "$1"
            }
        ]
    },
    "Humanware": {
        "regex": "BrailleNote",
        "device": "tablet",
        "models": [
            {
                "regex": "BrailleNote Touch \\+(?:[);/ ]|$)",
                "model": "BrailleNote Touch Plus"
            },
            {
                "regex": "BrailleNote Touch(?:[);/ ]|$)",
                "model": "BrailleNote Touch"
            }
        ]
    },
    "Perfeo": {
        "regex": "Perfeo",
        "device": "tv",
        "models": [
            {
                "regex": "Perfeo_PF_A4551",
                "model": "CHRONO"
            },
            {
                "regex": "Perfeo_PF_A4552",
                "model": "RATE"
            },
            {
                "regex": "Perfeo_PF_A4553",
                "model": "MATRIX"
            }
        ]
    },
    "CGV": {
        "regex": "CGV_(Ultimate T8)",
        "device": "smartphone",
        "model": "$1"
    },
    "Telia": {
        "regex": "Telia",
        "device": "tv",
        "models": [
            {
                "regex": "Nordic",
                "model": "TV Box Nordic"
            },
            {
                "regex": "Telia box",
                "model": "TV Box"
            }
        ]
    },
    "Canal Digital": {
        "regex": "S70CDS(?:[);/ ]|$)",
        "device": "tv",
        "model": "OnePlace"
    },
    "ZIFRO": {
        "regex": "ZIFRO|(?:ZT-97003G)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(ZT-9700)3G",
                "model": "$1 3G"
            }
        ]
    },
    "SmartBook": {
        "regex": "SMARTBOOK[ _]S",
        "device": "tablet",
        "models": [
            {
                "regex": "SMARTBOOK[ _]SB ?13",
                "model": "SB13"
            },
            {
                "regex": "SMARTBOOK[ _](S9Q9|S7QS|S9\\+)",
                "model": "$1"
            }
        ]
    },
    "Kiowa": {
        "regex": "KIOWA[_ ]|(?:[AS]5|X4)_CRISTAL(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(X4|[AS]5)_CRISTAL",
                "model": "$1 Cristal"
            },
            {
                "regex": "S5 ULTRA",
                "model": "S5 Ultra"
            }
        ]
    },
    "Sprint": {
        "regex": "AQT(100|8[02])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "AQT$1"
    },
    "Bundy": {
        "regex": "(?:BTOUCH7_PLUS|SWEET 5\\+ 2019|SWEET ?[56]\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SWEET 5\\+ 2019",
                "model": "Sweet 5 Plus (2019)"
            },
            {
                "regex": "SWEET ?([65])\\+",
                "model": "Sweet $1 Plus"
            },
            {
                "regex": "BTOUCH7_PLUS",
                "device": "tablet",
                "model": "B-Touch 7 Plus"
            }
        ]
    },
    "Covia": {
        "regex": "(CP-J55a|CP-J55aW|CP-J55aX)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Elevate": {
        "regex": "(?:LUNA (V57|V55A|G58|G62|G60X)|V55C|G55 LITE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(V55C)",
                "model": "Luna $1"
            },
            {
                "regex": "(G55)[_ ]LITE",
                "model": "Luna $1 Lite"
            },
            {
                "regex": "LUNA (V57|V55A|G58|G62|G60X)",
                "model": "Luna $1"
            }
        ]
    },
    "Stylo": {
        "regex": "STYLO|(?:TARISTAB[234]|Luna|CPE91|VS571|VS5502|S57_A[ZL]URE|BOLD_PLUS|INKOSI(?:_PRO)?|INKULU_PRO|Ithemba|S56 MIST|S55 Nova|INKOSI_PRO_4G|S40_VISTA|S50_JADE|S50_BOLD|S64_ALPHA|S53_STARK|S40_LIFE|LIFE_2|S49[_ ](?:MONO|POISE|ECO)| [27]21|721_PRO|DQR22|MOSCOW|SWIFT_4G|STEP_UP|APEX_5G|ARCTIC|S61 JAZZ|Sirius Plus Tab 10|DVK87 Orion 8 Tab|DVK82 Mercury|EBY33)(?:[);/ ]|$)| (?:BRAVE|SATURN)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "STYLO[ _](F1|Viva)",
                "model": "$1"
            },
            {
                "regex": "STYLO[ _]SONIC",
                "model": "Sonic"
            },
            {
                "regex": "STEP_UP",
                "model": "Step Up"
            },
            {
                "regex": "SWIFT_4G",
                "model": "Swift 4G"
            },
            {
                "regex": "INKOSI_PRO_4G",
                "model": "Inkosi Pro 4G"
            },
            {
                "regex": "721_PRO",
                "model": "721 Pro"
            },
            {
                "regex": "([27]21)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "STYLO[ _]S9[_ ]TOPAZ",
                "model": "S9 Topaz"
            },
            {
                "regex": "SV61 VECTOR\\+",
                "model": "SV61 Vector Plus"
            },
            {
                "regex": "SM61 MAGIC\\+",
                "model": "SM61 Magic Plus"
            },
            {
                "regex": "S61 JAZZ",
                "model": "S61 Jazz"
            },
            {
                "regex": "S57_AZURE",
                "model": "S57 Azure"
            },
            {
                "regex": "S57_ALURE",
                "model": "S57 Alure"
            },
            {
                "regex": "S56 MIST",
                "model": "S56 Mist"
            },
            {
                "regex": "CPE91",
                "model": "S54 Zen"
            },
            {
                "regex": "S55 Nova",
                "model": "S55 Nova"
            },
            {
                "regex": "S40_VISTA",
                "model": "S40 Vista"
            },
            {
                "regex": "S50_JADE",
                "model": "S50 Jade"
            },
            {
                "regex": "S50_BOLD",
                "model": "S50 Bold"
            },
            {
                "regex": "Ithemba",
                "model": "Ithemba"
            },
            {
                "regex": "ARCTIC",
                "model": "Arctic"
            },
            {
                "regex": "EBY33",
                "model": "Horizon"
            },
            {
                "regex": "S53_STARK",
                "model": "S53 Stark"
            },
            {
                "regex": "S40_LIFE",
                "model": "S40 Life"
            },
            {
                "regex": "LIFE_2",
                "model": "Life 2"
            },
            {
                "regex": "MOSCOW",
                "model": "Moscow"
            },
            {
                "regex": "APEX_5G",
                "model": "Apex 5G"
            },
            {
                "regex": "S49[_ ]POISE",
                "model": "S49 Poise"
            },
            {
                "regex": "S49[_ ]MONO",
                "model": "S49 Mono"
            },
            {
                "regex": "S49[_ ]ECO",
                "model": "S49 Eco"
            },
            {
                "regex": "S64_ALPHA",
                "model": "S64 Alpha"
            },
            {
                "regex": "Luna",
                "model": "Luna"
            },
            {
                "regex": "DQR22",
                "model": "Jupiter"
            },
            {
                "regex": "INKOSI_PRO",
                "model": "Inkosi Pro"
            },
            {
                "regex": "INKOSI",
                "model": "Inkosi"
            },
            {
                "regex": "INKULU_PRO",
                "model": "Inkulu Pro"
            },
            {
                "regex": "BOLD_PLUS",
                "model": "Bold Plus"
            },
            {
                "regex": "BRAVE",
                "model": "Brave"
            },
            {
                "regex": "RAIN",
                "model": "Rain"
            },
            {
                "regex": "SATURN",
                "model": "Saturn"
            },
            {
                "regex": "DVK82 Mercury",
                "model": "DVK82 Mercury"
            },
            {
                "regex": "Stylo[_ ](521)",
                "model": "$1"
            },
            {
                "regex": "(VS571|VS5502)",
                "model": "$1"
            },
            {
                "regex": "TARISTAB([2-4])",
                "device": "tablet",
                "model": "Taris Tab $1"
            },
            {
                "regex": "DVK87",
                "device": "tablet",
                "model": "Orion 8 Tab"
            },
            {
                "regex": "Sirius Plus Tab 10",
                "device": "tablet",
                "model": "Sirius Plus Tab 10"
            }
        ]
    },
    "Galaxy Innovations": {
        "regex": "(?:GI (?:UNI2|iTV912|Fly T2)|Gi-98Quick)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "GI iTV912",
                "model": "iTV912"
            },
            {
                "regex": "Gi-98Quick",
                "model": "98 Quick"
            },
            {
                "regex": "GI UNI2",
                "model": "Uni 2"
            },
            {
                "regex": "GI Fly T2",
                "model": "Fly T2"
            }
        ]
    },
    "Benzo": {
        "regex": "(?:Class S300 LTE|G-PADLITE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "G-PADLITE",
                "device": "tablet",
                "model": "GPad Lite"
            },
            {
                "regex": "(Class S300 LTE)",
                "model": "$1"
            }
        ]
    },
    "Vexia": {
        "regex": "(?:Zippers Tab 10i 3G)|Vexia FCS E2 CLM",
        "device": "tablet",
        "models": [
            {
                "regex": "Vexia FCS E2 CLM",
                "model": "Elegance E2 CLM"
            },
            {
                "regex": "(Zippers Tab 10i 3G)",
                "model": "$1"
            }
        ]
    },
    "HiMax": {
        "regex": "HIMAX[_ ]|PURE_III(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "POLYMER( X)?",
                "model": "Polymer$1"
            },
            {
                "regex": "HIMAX[_ ]PURE[_ ]3S",
                "model": "Pure 3S"
            },
            {
                "regex": "PURE_III",
                "model": "Pure 3"
            }
        ]
    },
    "Packard Bell": {
        "regex": "(PB1009|M10[45]00|M7500|M7600-D|DAYTONA-G12|MONZA-T7|SILVERSTONE-T(?:5A|10)|EasyNote TV11HC)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "DAYTONA-G12",
                "device": "smartphone",
                "model": "Daytona G12"
            },
            {
                "regex": "MONZA-T7",
                "model": "Monza T7"
            },
            {
                "regex": "SILVERSTONE-(T5A|T10)",
                "model": "Silverstone $1"
            },
            {
                "regex": "(PB1009|M10[45]00|M7500|M7600-D)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "EasyNote TV11HC",
                "device": "desktop",
                "model": "EasyNote TV11HC"
            }
        ]
    },
    "Qnet Mobile": {
        "regex": "Passion[ _]P|Hynex plus|Stark K1|Hynex H[356]|Levin V[12]|Aston A[357]\\+",
        "device": "smartphone",
        "models": [
            {
                "regex": "Passion[ _](P[0-9]+)",
                "model": "Passion $1"
            },
            {
                "regex": "Hynex plus( 2)?",
                "model": "Hynex Plus$1"
            },
            {
                "regex": "Stark K1",
                "model": "Stark K1"
            },
            {
                "regex": "Hynex (H[356])\\+",
                "model": "Hynex $1 Plus"
            },
            {
                "regex": "Hynex (H[35])",
                "model": "Hynex $1"
            },
            {
                "regex": "Levin (V[12])",
                "model": "Levin $1"
            },
            {
                "regex": "Aston A([357])\\+",
                "model": "Aston A$1 Plus"
            }
        ]
    },
    "Bluebird": {
        "regex": "(VF550|EF501R?)(:_RU)?(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Mara": {
        "regex": "Mara(?: Phones)?[ _](Z1?|X1|S)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "BMAX": {
        "regex": "(?:I11_Plus(?:_EEA)?|(?:I11|I10(Plus)?|I9_Plus)_(?:EEA|ROW)|I9_Plus|I10_Plus|Android 11(?:[\\d.]*);(?: [\\w-]+;)? I11|I10_Pro|I10Plus)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "I10_?(Plus|Pro)?(?:_(?:EEA|ROW))?(?:[);/ ]|$)",
                "model": "MaxPad I10 $1"
            },
            {
                "regex": "I11(?:_EEA)?(?:[);/ ]|$)",
                "model": "MaxPad I11"
            },
            {
                "regex": "I(11|9)_Plus(?:_EEA|_ROW)?(?:[);/ ]|$)",
                "model": "MaxPad I$1 Plus"
            }
        ]
    },
    "Geotex": {
        "regex": "(GTX-R10i Pro|GTX-R10i|GTX-98Q)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "DING DING": {
        "regex": "DINGDING[ _-](SK\\d)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Trident": {
        "regex": "(A23 Max|A75 Pro Max)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Trimble": {
        "regex": "MobileMapper",
        "device": "smartphone",
        "models": [
            {
                "regex": "MobileMapper60(?:_2)?(?:[);/ ]|$)",
                "model": "MobileMapper 60"
            }
        ]
    },
    "OKSI": {
        "regex": "(GEN-10|GT1001)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Taiga System": {
        "regex": "(?:TP_1_3000)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "TaigaPhone 1"
    },
    "Glofiish": {
        "regex": "glofiish[ _]|(?:Gpad_U)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Gpad_U",
                "model": "G Pad U"
            },
            {
                "regex": "Gpad Air",
                "device": "tablet",
                "model": "G Pad Air"
            }
        ]
    },
    "Glory Star": {
        "regex": "StarOS",
        "device": "tablet",
        "model": ""
    },
    "Polar": {
        "regex": "Polar(?:_W?K?)?[_ ]P\\d{2}|(?:P42L31T2CSM|P32L33T2CSM)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:Polar(?:_W?K?)?[_ ])?(P\\d{2}[LU]\\d{2}T2S?CSM)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "PolarLine": {
        "regex": "PolarLine[_ ](?:W?K?[_ ])?(\\d{2}P[LU]\\d{2}S?TC-SM)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "MyGica": {
        "regex": "MyGica[_ ]",
        "device": "tv",
        "models": [
            {
                "regex": "HDR (Quad Core|Smart TV) Box",
                "model": "HDR $1 Box"
            },
            {
                "regex": "Quad core Enjoy tv box",
                "model": "Quad Core Enjoy TV Box"
            },
            {
                "regex": "ATV(19[60]0|495 Pro 16G)",
                "model": "ATV$1"
            }
        ]
    },
    "neoCore": {
        "regex": "neocore_?",
        "device": "tablet",
        "models": [
            {
                "regex": "neocore_N1G1(?:[);/ ]|$)",
                "model": "N1 G1"
            },
            {
                "regex": "neocore E1-2(?:[);/ ]|$)",
                "model": "E1+"
            },
            {
                "regex": "neocore_E1R1(?:[);/ ]|$)",
                "model": "E1 R1"
            },
            {
                "regex": "NEOCORE_E2(?:[);/ ]|$)",
                "model": "E2"
            }
        ]
    },
    "Novex": {
        "regex": "(NWX-40F171MSY|NVX-32H219MSY|NVX-43U329MSY|NVX-39H211MSY|NWX-43F149MSYv?|NWX-24H121MSY|NWX-24H121WSY|NWX-32H171MSY|NVX-55U321MSY|NVX-50U329MSY|NWX-65U169TSY-A|NVX-65U321MSY|NVX-75U131MSY)x?(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Epson": {
        "regex": "(?:Projector|STI6110)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "Projector",
                "model": "HA14A LCD Projector"
            },
            {
                "regex": "STI6110",
                "model": "EF-100"
            }
        ]
    },
    "Awow": {
        "regex": "(?:AWOW_)?(?:UTBook|CreaPad_100[359](?:_EEA)?)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:AWOW_)?(UTBook|CreaPad_100[359])",
                "model": "$1"
            }
        ]
    },
    "Mitsui": {
        "regex": "(MC32020)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Gocomma": {
        "regex": "H1-C-ALADENG",
        "device": "wearable",
        "model": "W5"
    },
    "LEMFO": {
        "regex": "(?:LEM1[456]|LEM12Pro)(?:[);/ ]|$)",
        "device": "wearable",
        "models": [
            {
                "regex": "(LEM12)Pro",
                "model": "$1 Pro"
            },
            {
                "regex": "(LEM1[456])",
                "model": "$1"
            }
        ]
    },
    "Urovo": {
        "regex": "(?:DT[245]0|i6200[AS])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(DT[245]0|i6200[AS])",
                "device": "peripheral",
                "model": "$1"
            }
        ]
    },
    "Neon IQ": {
        "regex": "(?:NQT-(?:101|7)[34]GIQ(?:11)?|NQT-7W)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(NQT-1013GIQ11)",
                "model": "$1"
            },
            {
                "regex": "NQT-101([34])GIQ",
                "model": "Tab 10.1\" $1G"
            },
            {
                "regex": "NQT-7([34])GIQ",
                "model": "Tab 7\" $1G"
            },
            {
                "regex": "NQT-7W",
                "model": "Tab 7\" WiFi"
            }
        ]
    },
    "Aocos": {
        "regex": "AOCOS ([^);/]+)(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "Parrot Mobile": {
        "regex": "(Xplorer_2)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Partner Mobile": {
        "regex": "EV1 PRO|Partner[_ ]Evolution(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Partner[_ ]Evolution",
                "model": "Evolution"
            },
            {
                "regex": "EV1 PRO",
                "model": "EV1 Pro"
            }
        ]
    },
    "Bubblegum": {
        "regex": "(BUB6R-3T)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Erisson": {
        "regex": "(24LM8002CT2|65ULES910T2SM|42FLEA73T2SM|40FLES900T2SM|42FLES901T2SM|43FLES90[0125]T2SM|42FLX9060T2|32LX9000CT|39LES80T2SM|32LX9051T2|43ULX9060T2|32LX9050T2|32LES905T2SM|55ULES92T2SM|55ULES901T2SM|55ULX9005T2|32LEA73T2SM|32LES90[24]T2SM|40FLX9000CT2|40FLES901T2SM|42FLES904T2SM|32LES90[136]T2SM)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Liberton": {
        "regex": "((?:24|32)TP1HDTA1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Soho Style": {
        "regex": "((?:S1586K|SS(?:5[23]14|5[47]24)G))(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Shivaki": {
        "regex": "STV[-_](55LED41|40LED25S|40LED42S|32LED42S|32LED30C)(?:[);/ ]|$)",
        "device": "tv",
        "model": "STV-$1"
    },
    "Meizu": {
        "regex": "Meizu|MZ-(?!Fast)[A-Z]|(?<!POCO )(M04[05]|MZ-16th(?: Plus)?|MZ-16[st]|M7[12]1C|M35[1356]|M612C|M578CA|M181[36]|M1822|M681C|M6T|MX[ -]?[2345](?: Pro)?|(?:MZ-)?m[1-6] note|M621C|M1852|M57[18]C|M3[ESX]|M3 Max|M031|m1 metal|M1 E|(?<!Nubia |STELLAR )M2|M2 E|M5s Build|(?<!TicWatch )PRO [567]|PRO 7-[HS]| 15 Lite| 16th|MZ-15 (?:Lite|Plus)|15 Plus|MZ-16 X| 16 X| 16T|MX6| M5c|16s Pro|Android 8(?:[\\d.]*);(?: [\\w-]+;)? 16|Mblu 2[12]|Mblu 22 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:MZ-)?M571C",
                "device": "phablet",
                "model": "M2 Note"
            },
            {
                "regex": "(?:MZ-|Meizu-)?m([1-6])[_ ]note(?:[);/ ]|$)",
                "device": "phablet",
                "model": "M$1 Note"
            },
            {
                "regex": "20 Inf",
                "model": "20 Infinity"
            },
            {
                "regex": "Mblu 22 Pro",
                "model": "Mblu 22 Pro"
            },
            {
                "regex": "Mblu (2[12])",
                "model": "Mblu $1"
            },
            {
                "regex": "Lucky 08",
                "model": "Lucky 08"
            },
            {
                "regex": "(?:MZ-)?M1 E(?:[);/ ]|$)",
                "model": "M1E"
            },
            {
                "regex": "M2 E(?:[);/ ]|$)",
                "model": "M2E"
            },
            {
                "regex": "(?:MZ-)?M578C[A]?|M2(?:[);/ ]|$)",
                "model": "M2"
            },
            {
                "regex": "M681C(?:[);/ ]|$)",
                "model": "M3 Note",
                "device": "phablet"
            },
            {
                "regex": "M621C(?:[);/ ]|$)",
                "model": "M5 Note",
                "device": "phablet"
            },
            {
                "regex": "M711C(?:[);/ ]|$)",
                "model": "M6"
            },
            {
                "regex": "M721C(?:[);/ ]|$)",
                "model": "M6 Note",
                "device": "phablet"
            },
            {
                "regex": "(M6T|MX6|M3E|M3X)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "(?:MZ-)?M3S(?:[);/ ]|$)",
                "model": "M3s"
            },
            {
                "regex": "(?:MZ-)?M3 Max(?:[);/ ]|$)",
                "model": "M3 Max"
            },
            {
                "regex": "M5S|M612C",
                "model": "M5S"
            },
            {
                "regex": "(?:MZ-)?M5c(?:[);/ ]|$)",
                "model": "M5c"
            },
            {
                "regex": "(M04[05]|MX[ -]?2)(?:[);/ ]|$)",
                "model": "MX2"
            },
            {
                "regex": "(M35[1356]|MX[ -]?3)(?:[);/ ]|$)",
                "model": "MX3"
            },
            {
                "regex": "MX[ -]?4 Pro(?:[);/ ]|$)",
                "model": "MX4 Pro"
            },
            {
                "regex": "MX[ -]?4(?:[);/ ]|$)",
                "model": "MX4"
            },
            {
                "regex": "(Meizu[- _])?MX[ -]?5(?:[);/ ]|$)",
                "model": "MX5"
            },
            {
                "regex": "m1 metal",
                "model": "M1 Metal"
            },
            {
                "regex": "M1813(?:[);/ ]|$)",
                "model": "M8"
            },
            {
                "regex": "(?:M1816|M8 lite)(?:[);/ ]|$)",
                "model": "M8 Lite"
            },
            {
                "regex": "M8c Pro(?:[);/ ]|$)",
                "model": "M8c Pro"
            },
            {
                "regex": "PRO 7-[HS](?:[);/ ]|$)",
                "model": "PRO 7"
            },
            {
                "regex": "PRO ([76]) Plus(?:[);/ ]|$)",
                "model": "PRO $1 Plus"
            },
            {
                "regex": "PRO ([567])",
                "model": "PRO $1"
            },
            {
                "regex": "M031(?:[);/ ]|$)",
                "model": "MX Dual Core"
            },
            {
                "regex": "M1852(?:[);/ ]|$)",
                "model": "X8"
            },
            {
                "regex": "M1822(?:[);/ ]|$)",
                "model": "Note 8"
            },
            {
                "regex": "(?:MZ-)?16T(?:[);/ ]|$)",
                "model": "16T"
            },
            {
                "regex": "(?:MZ-)?16th Plus(?:[);/ ]|$)",
                "model": "16th Plus"
            },
            {
                "regex": "(?:MZ-)?15 Plus(?:[);/ ]|$)",
                "model": "15 Plus"
            },
            {
                "regex": "(?:MZ-15 Lite| 15 Lite)(?:[);/ ]|$)",
                "model": "15 Lite"
            },
            {
                "regex": "MZ-16th| 16th(?:[);/ ]|$)",
                "model": "16th"
            },
            {
                "regex": "(?:MZ-)?16 X(?:[);/ ]|$)",
                "model": "16X"
            },
            {
                "regex": "16(?: Build|[;)]|$)",
                "model": "16"
            },
            {
                "regex": "(?:MZ-)?16s Pro(?:[);/ ]|$)",
                "model": "16s Pro"
            },
            {
                "regex": "meizu (17|C9|2[10]) Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "MZ-?M3(?:[);/ ]|$)",
                "model": "M3"
            },
            {
                "regex": "(?:Meizu[_ ])?note([89]|21)(?:[);/ ]|$)",
                "device": "phablet",
                "model": "Note $1"
            },
            {
                "regex": "(?:MZ-)?Meizu[_ ]([^/;]+) Build",
                "model": "$1"
            },
            {
                "regex": "(?:MZ-)?Meizu[_ ]([a-z0-9_]+)",
                "model": "$1"
            },
            {
                "regex": "MZ-([^/;]+) Build",
                "model": "$1"
            }
        ]
    },
    "Athesi": {
        "regex": "(?:AP570[12]|AP5705S|AP6301)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(AP570[12]|AP5705S|AP6301)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Atmaca Elektronik": {
        "regex": "ATMACA_",
        "device": "tv",
        "model": ""
    },
    "Atvio": {
        "regex": "(100011886BK)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "XY Auto": {
        "regex": "(YT5760[ABL]|YT5716C?|YT7216C?|YT7260[BL]|YT9216[BC]J|YT9213AJ|YT9270)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "Alps": {
        "regex": "(?:FF-5000|ZQ8003|825X_Pro|03_v89_jbl|benz_hy1920x720|8227L_demo|tb8163p3_bsp)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(FF-5000)",
                "device": "car browser",
                "model": "$1"
            },
            {
                "regex": "(ZQ8003|825X_Pro|benz_hy|8227L_demo|tb8163p3_bsp)(?:1920x720)?",
                "device": "car browser",
                "model": "$1"
            }
        ]
    },
    "Starwind": {
        "regex": "Smart_Starwind|(?:SW-LED(?:24SG303|32SB30[024]|42SB300|43SB30[04]|40SG300|40SB30[04]|43SG30[20]|43UB40[04]|43UG40[0135]|32SG3(?:0[01245]|11)|55UG40[03]|58UG401|5[05]UB401|50UG40[03]|65UG403|5[08]UB400|58UA401|65UG402))(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SW-LED(\\d{2}[SU][ABG]\\d{3})",
                "model": "SW-LED$1"
            }
        ]
    },
    "QTECH": {
        "regex": "(?:QMP_K8| QMP-M1-N-IP)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "QMP[_-](K8|M1)",
                "model": "QMP $1"
            }
        ]
    },
    "Prology": {
        "regex": "(MPC-(?:[57]0|65|100)|MPC-110DSP)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "Polestar": {
        "regex": "Polestar(?:[);/ ]|$)",
        "device": "car browser",
        "model": ""
    },
    "Porsche": {
        "regex": "Porsche Rear Seat Entertainment",
        "device": "car browser",
        "model": ""
    },
    "Portfolio": {
        "regex": "(V100M4L)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "NavRoad": {
        "regex": "(?:NEXO (?:Smarty|handy|SMART DUO|Evo)|MOVIO 2)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nexo Smarty",
                "model": "Nexo Smarty"
            },
            {
                "regex": "Nexo handy",
                "model": "Nexo Handy"
            },
            {
                "regex": "NEXO SMART DUO",
                "device": "tablet",
                "model": "Nexo Smart Duo"
            },
            {
                "regex": "NEXO EVO",
                "device": "tablet",
                "model": "Nexo Evo"
            },
            {
                "regex": "MOVIO 2",
                "device": "tablet",
                "model": "Movio 2"
            }
        ]
    },
    "Smarty": {
        "regex": "Smarty[_ ]",
        "device": "tablet",
        "models": [
            {
                "regex": "Mini ?(7L?)",
                "model": "Mini $1"
            },
            {
                "regex": "Maxi 10L",
                "model": "Maxi 10L"
            }
        ]
    },
    "Leff": {
        "regex": "(32[FH]540S|32H5[235]0T|(?:32|40)F550T|32H650S|43U540S|43U550T|5[05]U5[14]0S|55U630S|(?:43|65)U520S|40F540S|43F5[35]0T|32H511T|24F560T|24H5[125]0T|28H540S|28H541T|28H550T|50U541T|50U550T|50U6[23]0S|55U620S|43F511T|43F520T|43U570T|43[FU]541T)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "DF": {
        "regex": "(?:JAGUAR|SATURN|TIGER|PUMA)-0\\dC?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "JAGUAR-01",
                "model": "Jaguar 01"
            },
            {
                "regex": "SATURN-(02C?)",
                "model": "Saturn $1"
            },
            {
                "regex": "TIGER-01",
                "model": "Tiger 01"
            },
            {
                "regex": "PUMA-01",
                "model": "Puma 01"
            }
        ]
    },
    "BDQ": {
        "regex": "(?:SMART_B19|Destiny)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "SMART_B19",
                "model": "Smart B19"
            },
            {
                "regex": "Destiny",
                "device": "tablet",
                "model": "Destiny"
            }
        ]
    },
    "TuCEL": {
        "regex": "(TL554B|TC504B)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "FEONAL": {
        "regex": "(K11[038]|D118)_EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Sunmi": {
        "regex": "(?:V1s-G|T2s_LITE|V2_PRO-ST)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "T2s_LITE(?:[);/ ]|$)",
                "device": "smart display",
                "model": "T2s Lite"
            },
            {
                "regex": "(V1s)-G",
                "model": "$1"
            },
            {
                "regex": "V2_PRO-ST",
                "model": "V2 Pro ST"
            }
        ]
    },
    "iData": {
        "regex": "iData[ _]|(?:Android 13(?:[\\d.]*);(?: [\\w-]+;)? T3_Pro)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "T3_Pro",
                "model": "T3 Pro"
            },
            {
                "regex": "iData[ _](K1|50|i3AL)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "iDino": {
        "regex": "NOTEBOOK6(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Notebook 6"
    },
    "IDC": {
        "regex": "IDC_Voice_20_4G(?:[);/ ]|$)",
        "device": "feature phone",
        "model": "Voice 20"
    },
    "AIDATA": {
        "regex": "(?:AIDATA ELDE 10 TABLET|ADT_?1061(?:_1)?|ADT1012L)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "ADT_?1061(?:_1)?",
                "model": "ADT 1061"
            },
            {
                "regex": "ADT1012L",
                "model": "ADT 1012L"
            },
            {
                "regex": "ELDE 10",
                "model": "ELDE 10"
            }
        ]
    },
    "Ematic": {
        "regex": "(EGQ101)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "GLONYX": {
        "regex": "Quartz(T10-3)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Quartz $1"
    },
    "Zyrex": {
        "regex": "ZT216",
        "device": "tablet",
        "model": "ZT216"
    },
    "Orbita": {
        "regex": "(OT-DVB\\d{2})(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "TAG Tech": {
        "regex": "(?:TAG[ -]TAB[ -]III?|TAGPhone)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TAG[ -]TAB[ -](III?)",
                "model": "Tab $1"
            },
            {
                "regex": "TAGPhone advanced",
                "device": "smartphone",
                "model": "Phone Advanced"
            },
            {
                "regex": "TAGPhone(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "Phone"
            }
        ]
    },
    "DUNNS Mobile": {
        "regex": "DUNNS[ _]|DunnsExecutive",
        "device": "smartphone",
        "models": [
            {
                "regex": "DUNNS[ _](Slinger)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "DUNNS[ _]?(?:MOBILE[ _])?(703GDC|AT1001|Executive)(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "inovo": {
        "regex": "(I 618 APP plus\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "I 618 APP plus\\+",
                "model": "I618 App Plus+"
            }
        ]
    },
    "iNOVA": {
        "regex": "(EX1080)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "eNOVA": {
        "regex": "eNOVA|(?:TAE08N10)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "eNOVA TAB 10 LTE",
                "device": "tablet",
                "model": "Tab 10\" LTE"
            },
            {
                "regex": "(TAE08N10)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Amino": {
        "regex": "(?:Amigo7x?(?:YUF|SCB)?)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Amigo7x",
                "model": "Amigo 7x"
            },
            {
                "regex": "Amigo7",
                "model": "Amigo 7"
            }
        ]
    },
    "Saiet": {
        "regex": "(?:STS5[57]0|STS502|STS602)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(STS5[57]0|STS602)",
                "model": "Sicuro Smart $1"
            },
            {
                "regex": "(STS502)",
                "model": "$1"
            }
        ]
    },
    "Magicsee": {
        "regex": "(?:N5NOVA|IRON\\+|N5Max_X4)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "N5NOVA",
                "model": "N5 Nova"
            },
            {
                "regex": "IRON\\+",
                "model": "Iron+"
            },
            {
                "regex": "N5Max_X4",
                "model": "N5 Max X4"
            }
        ]
    },
    "Obabox": {
        "regex": "(?:OBA_?(?:SMART_3|Conecta_Max|Conecta_4G))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "OBASMART_3",
                "model": "Smart 3"
            },
            {
                "regex": "OBA_(Conecta_(?:Max|4G))",
                "model": "$1"
            }
        ]
    },
    "iKon": {
        "regex": "(IK-102[58]|IK-1106|IK-7108|IK-787)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "iKonia": {
        "regex": "(?:Jarvis7_85)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Jarvis 7.85"
    },
    "QLink": {
        "regex": "(?:Scepter[ _]?8(?: Tablet)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Scepter[ _]?8",
                "model": "Scepter 8"
            }
        ]
    },
    "IRA": {
        "regex": "(?:IRA_DUO|IRAW7258)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(IRAW7258)",
                "model": "$1"
            },
            {
                "regex": "IRA_DUO",
                "model": "Duo Tablet"
            }
        ]
    },
    "Microtech": {
        "regex": "(?:ETL101(?:GB|AL)|ETW101GT(?:_C)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "ETW101GT",
                "model": "E-Tab WiFi"
            },
            {
                "regex": "ETL101(?:GB|AL)",
                "model": "E-Tab LTE"
            }
        ]
    },
    "G-PLUS": {
        "regex": "(?:GNE-N001S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GNE-N001S",
                "model": "A3"
            }
        ]
    },
    "Gplus": {
        "regex": "GTV-|(?:Gplus[ _](?:[ZXP]10\\+?|N809|F53|S9701|FW6950|A2_Plus|S10)|GMC-(?:7127M|668[NM]))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GMC-7127M",
                "model": "X20"
            },
            {
                "regex": "GMC-668N",
                "model": "Q20S"
            },
            {
                "regex": "GMC-668M",
                "model": "Q20"
            },
            {
                "regex": "Gplus[ _]([ZXP]10\\+?|N809|F53|S9701|FW6950|A2_Plus|S10)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "GTV-(50PU744N)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Eurocase": {
        "regex": "(EUTB_758G?)",
        "device": "tablet",
        "models": [
            {
                "regex": "EUTB_758G_TABI_Argos_KIDS",
                "model": "TABI Argos Kids 758G"
            }
        ]
    },
    "VEON": {
        "regex": "VEON[_ ]|(?:VEON[_ ](?:C8680)|VN50WOS2021)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VEON[_ ](C8680)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "VEON 4K Smart TV(?:[);/ ]|$)",
                "device": "tv",
                "model": "4K Smart TV"
            },
            {
                "regex": "(VN50WOS2021)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "FiGi": {
        "regex": "FIGI[_ ]|(?:Note_(?:[37]|11)_Pro|Note_(?:1C|5)|Note_1_Lite|Nopal|[MGF]two|Hola)(?:[);/ ]|$)|Android 8(?:[\\d.]*);(?: [\\w-]+;)? Fj(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nopal",
                "model": "Nopal"
            },
            {
                "regex": "FIGI[_ ]P40 Max",
                "model": "P40 Max"
            },
            {
                "regex": "FIGI[_ ]P40",
                "model": "P40"
            },
            {
                "regex": "Hola",
                "model": "Hola"
            },
            {
                "regex": "([MGF])two",
                "model": "$1two"
            },
            {
                "regex": "(FSE1020)",
                "model": "$1"
            },
            {
                "regex": "Fj(?: Build|[;)])",
                "model": "Fj"
            },
            {
                "regex": "Note_1C",
                "model": "Note 1C"
            },
            {
                "regex": "Note_5",
                "model": "Note 5"
            },
            {
                "regex": "Note_([37]|11)_Pro",
                "device": "phablet",
                "model": "Note $1 Pro"
            },
            {
                "regex": "Note_(1)_Lite",
                "device": "phablet",
                "model": "Note $1 Lite"
            }
        ]
    },
    "iSafe Mobile": {
        "regex": "(?:IS655|IS[35]30)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(IS[35]30)",
                "model": "$1"
            },
            {
                "regex": "(IS655)",
                "model": "$1.RG"
            }
        ]
    },
    "Tigers": {
        "regex": "TIS001[_-]|TIS_?001",
        "device": "smartphone",
        "models": [
            {
                "regex": "TIS001[_-]S([34])(?:[);/ ]|$)",
                "model": "TIS001 S$1"
            },
            {
                "regex": "TIS001[_-]T2(?:[);/ ]|$)",
                "model": "TIS001 T2"
            },
            {
                "regex": "TIS_?001([ABC])?",
                "model": "TIS001$1"
            }
        ]
    },
    "Redfox": {
        "regex": "(?:Wizpad_)?Valuer_V8",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:Wizpad_)?Valuer_V8",
                "model": "Wizpad Valuer V8"
            }
        ]
    },
    "Vinabox": {
        "regex": "Vinabox",
        "device": "tv",
        "models": [
            {
                "regex": "Vinabox[-_ ]X(\\d*)[-_ ](2018)",
                "model": "X$1 ($2)"
            },
            {
                "regex": "Vinabox[-_ ]X(\\d*)[-_ ]?Plus",
                "model": "X$1 Plus"
            },
            {
                "regex": "Vinabox[-_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Beista": {
        "regex": "(X104)-EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "YOTOPT": {
        "regex": "(?:X109|(?:Y103|Y61|Q11)[-_]EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Y103|Q11|Y61)[-_]EEA",
                "model": "$1"
            },
            {
                "regex": "(X109)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Ookee": {
        "regex": "OokeeOne",
        "device": "smartphone",
        "model": "One"
    },
    "TOSCIDO": {
        "regex": "(?:(?:T1[235]|T151|T2[1268]|T181|P101)-EEA|W-?109)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(T1[235]|T151|T2[1268]|P101|T181)-EEA(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "W-?109(?:[);/ ]|$)",
                "model": "W109"
            }
        ]
    },
    "b2m": {
        "regex": "Decade 53(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Decade 53"
    },
    "Koslam": {
        "regex": "(KL1071Z|KL1084)",
        "device": "tablet",
        "model": "$1"
    },
    "S2Tel": {
        "regex": "S2TEL[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "S2TEL-(Q8)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Massgo": {
        "regex": "Massgo[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Massgo[ _]VI2S",
                "model": "Vi2 S"
            },
            {
                "regex": "Massgo[ _]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Angelcare": {
        "regex": "angelcare[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "F20 ?pro",
                "model": "F20 Pro"
            },
            {
                "regex": "angelcare[ _]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "iPEGTOP": {
        "regex": "IPEGTOP",
        "device": "smartphone",
        "models": [
            {
                "regex": "iPEGTOP[ _](Z26)",
                "model": "$1"
            }
        ]
    },
    "Jedi": {
        "regex": "Remix (?:Pro|Mini)",
        "device": "desktop",
        "models": [
            {
                "regex": "Remix Pro",
                "device": "tablet",
                "model": "Remix Pro"
            },
            {
                "regex": "Remix Mini",
                "model": "Remix Mini"
            }
        ]
    },
    "Technopc": {
        "regex": "(?:UP10SI[34]6LA|UP918|UP7[67]8|UP1018|UP10_SH36LAG|Ultrapad_UP10\\.S36LA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(UP10SI[34]6LA|UP918|UP778|UP768|UP1018)",
                "model": "UltraPad $1"
            },
            {
                "regex": "(?:Ultrapad_)?UP10[_.](SH36LAG|S36LA)",
                "model": "UltraPad UP10$1"
            }
        ]
    },
    "Techstorm": {
        "regex": "Allwinner Nitro Pro(?:[);/ ]|$)",
        "device": "tv",
        "model": "Nitro Pro"
    },
    "OMIX": {
        "regex": "OMIX[ _.]|(?:X600 NFC|Android 1[12](?:[\\d.]*);(?: [\\w-]+;)? X[467]00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X600 NFC",
                "model": "X600 NFC"
            },
            {
                "regex": "X(\\d*)",
                "model": "X$1"
            }
        ]
    },
    "Nexa": {
        "regex": "Nexa[ _](?:Atlas|Vega N1)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Nexa[ _](Vega N1)",
                "model": "$1"
            },
            {
                "regex": "Nexa[ _](Atlas)",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "Onkyo": {
        "regex": "(?:DP-CMX1|TA2C-M8)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(TA2C-M8)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(DP-CMX1)",
                "model": "$1"
            }
        ]
    },
    "Royole": {
        "regex": "Royole",
        "device": "tablet",
        "models": [
            {
                "regex": "FlexPai 2",
                "model": "FlexPai 2"
            },
            {
                "regex": "FlexPai",
                "model": "FlexPai"
            }
        ]
    },
    "DORLAND": {
        "regex": "(Aloha_5G)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Hamlet": {
        "regex": "Hamlet[ _]|XZPAD412LTE",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:Hamlet[ _])?XZPAD(412W|412LTE)",
                "model": "Zelig Pad $1"
            }
        ]
    },
    "Vorcom": {
        "regex": "(?:SXPro|S7-classic|SXPRO_classic|Quartz(?:PRO|LITE)|ULTRAPAD)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SXPRO_classic",
                "model": "SX Pro Classic"
            },
            {
                "regex": "SXPro",
                "model": "SX Pro"
            },
            {
                "regex": "S7-classic",
                "model": "S7 Classic"
            },
            {
                "regex": "QuartzLITE",
                "model": "Quartz Lite"
            },
            {
                "regex": "QuartzPRO",
                "model": "Quartz Pro"
            },
            {
                "regex": "ULTRAPAD",
                "model": "Ultra Pad"
            }
        ]
    },
    "UNNO": {
        "regex": "UNNO[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "UNNO[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "VDVD": {
        "regex": "VDVD[_ ](P20|IX21)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Autan": {
        "regex": "R2021W2(?:[);/ ]|$)",
        "device": "wearable",
        "models": [
            {
                "regex": "(R2021W2)",
                "model": "$1"
            }
        ]
    },
    "ecom": {
        "regex": "(Smart-Ex02|Ex-Handy 10)(?: (?:ROW|RUS))?(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "LOKMAT": {
        "regex": "(APPLLP Max|APPLLP2?)(?:[);/ ]|$)",
        "device": "wearable",
        "model": "$1"
    },
    "Joy": {
        "regex": "Joy (?:HH|JD)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Joy[ _]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "iWaylink": {
        "regex": "(?:MC401_GWL)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(MC401)_GWL",
                "device": "peripheral",
                "model": "$1"
            }
        ]
    },
    "VOGA": {
        "regex": "VOGA[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "VOGA 55909",
                "model": "V"
            }
        ]
    },
    "Haipai": {
        "regex": "Haipai",
        "device": "smartphone",
        "models": [
            {
                "regex": "Haipai ?noble S6",
                "model": "Noble S6"
            }
        ]
    },
    "OYSIN": {
        "regex": "OYSIN[ _]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Leke": {
        "regex": "Leke[ _]Pad-([^/;)]+)(?: Build|[);])",
        "device": "tablet",
        "model": "Pad-$1"
    },
    "ROADMAX": {
        "regex": "FORTIUS QUAD 7(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Fortius Quad 7",
                "model": "Fortius Quad 7"
            }
        ]
    },
    "BDsharing": {
        "regex": "BDS2 Plus",
        "device": "smartphone",
        "model": "BDS2 Plus"
    },
    "Pelitt": {
        "regex": "Pelitt[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pelitt T1 MAX",
                "model": "T1 Max"
            },
            {
                "regex": "Pelitt T1 PLUS",
                "model": "T1 Plus"
            }
        ]
    },
    "Benesse": {
        "regex": "(TAB-A03-(?:BR2|BS))(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Airtel": {
        "regex": "(?:(?:Airtel[ _])|(?:VIDA_i501))",
        "device": "smartphone",
        "models": [
            {
                "regex": "Airpad 7-s",
                "device": "tablet",
                "model": "AirPad 7S"
            },
            {
                "regex": "Imagine(?:[);/ ]|$)",
                "model": "Imagine"
            },
            {
                "regex": "VIDA_i501",
                "model": "Vida i501"
            }
        ]
    },
    "MAXX": {
        "regex": "(T1270G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TENPLUS": {
        "regex": "TENPLUS[_ ]([^/;)]+)(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "HAOVM": {
        "regex": "(T2000)(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "VUCATIMES": {
        "regex": "VucaPad",
        "device": "tablet",
        "models": [
            {
                "regex": "VucaPad_(\\w+)",
                "model": "$1"
            }
        ]
    },
    "Aoro": {
        "regex": "Aoro[ _]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "EBEN": {
        "regex": "EBEN[ _]([^/;)]+)(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "X-AGE": {
        "regex": "G1LITE(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "G1 Lite"
    },
    "Zonko": {
        "regex": "(?:K101_EEA|K118)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "K(101|118)",
                "model": "K$1"
            }
        ]
    },
    "TJC": {
        "regex": "Metal_Tablet_10(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Metal Tablet 10"
    },
    "TJD": {
        "regex": "(MT-1011QR)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "HOTREALS": {
        "regex": "HOTREALS",
        "device": "tablet",
        "models": [
            {
                "regex": "HOTREALS(?:[);/ ]|$)",
                "model": "Tablet PC 10.1\""
            }
        ]
    },
    "Zeeker": {
        "regex": "ZEEKER",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZEEKER[ _](P10|T100)",
                "model": "$1"
            }
        ]
    },
    "AUX": {
        "regex": "AUX[ _]([^/;)]+)(?:_TD)",
        "device": "smartphone",
        "model": "$1"
    },
    "Neolix": {
        "regex": "Neolix[ _-]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Neolix[ _-]T7[_ ]",
                "model": "T7"
            },
            {
                "regex": "Neolix[ _-]1-C-",
                "model": "1C"
            },
            {
                "regex": "Neolix[ _-]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "ATMAN": {
        "regex": "ATMAN[ _-]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "EYU": {
        "regex": "EYU[ _-](T53|T7)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "FOODO": {
        "regex": "FOODO[ _-](X10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "YEPEN": {
        "regex": "M20201419(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "M20201419",
                "model": "X12 Pro Max"
            }
        ]
    },
    "BROR": {
        "regex": "BROR[_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Vortex": {
        "regex": "(Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:HD65)|ZG65|SYNQ|CMG101|CM62|CG65|T10M_Pro|HD55|HD60[iL]?|HD62|HD68|ZTAB10|BTAB10|HD65[ _](?:Choice|Select|Ultra|PLUS)|ZG55|ZG65 Pro|V39TPHE01S|V32TPHDE1S|V24TPHDE1S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "ZG65 Pro",
                "model": "ZG65 Pro"
            },
            {
                "regex": "HD65[_ ]Choice",
                "model": "HD65 Choice"
            },
            {
                "regex": "HD65[_ ]Ultra",
                "model": "HD65 Ultra"
            },
            {
                "regex": "HD65[_ ]Select",
                "model": "HD65 Select"
            },
            {
                "regex": "HD65[_ ]PLUS",
                "model": "HD65 Plus"
            },
            {
                "regex": "(SYNQ|CM62|CG65|ZG55|HD55|HD60[iL]?|HD6[258]|ZG65)",
                "model": "$1"
            },
            {
                "regex": "(CMG101)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "T10M_Pro",
                "device": "tablet",
                "model": "T10M Pro"
            },
            {
                "regex": "ZTAB10",
                "device": "tablet",
                "model": "Z Tab 10"
            },
            {
                "regex": "BTAB10",
                "device": "tablet",
                "model": "B Tab 10"
            },
            {
                "regex": "(V39TPHE01S|V32TPHDE1S|V24TPHDE1S)",
                "device": "tv",
                "model": "$1"
            }
        ]
    },
    "Xiaodu": {
        "regex": "(XDH-(?:0F-A1|1[78]-A1|21-A1|29-B1|2A-B1)|XD-SDD05-2101)(?:[);/ ]|$)",
        "device": "smart display",
        "model": "$1"
    },
    "AXXA": {
        "regex": "AXXA[ _]",
        "device": "smartphone",
        "models": [
            {
                "regex": "AXXA[ _](S\\d+)[ _]PLUS",
                "model": "$1 Plus"
            },
            {
                "regex": "AXXA[ _](S\\d+)",
                "model": "$1"
            }
        ]
    },
    "AYYA": {
        "regex": "AYYA[ _]|(?:Ayat101)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AYYA[ _](T1)",
                "model": "$1"
            },
            {
                "regex": "Ayat101",
                "model": "Ayat 101"
            }
        ]
    },
    "Future Mobile Technology": {
        "regex": "(FXT810R)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "MBK": {
        "regex": "(MBK-T2101)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "MBI": {
        "regex": "MBI[_ ](R7)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "OUJIA": {
        "regex": "OUJIA",
        "device": "smartphone",
        "models": [
            {
                "regex": "2018-S10MAX",
                "model": "S10 Max"
            },
            {
                "regex": "OUJIA(?:2018)?[-_ ]S20",
                "model": "S20"
            },
            {
                "regex": "S27 PLUS",
                "model": "S27 Plus"
            },
            {
                "regex": "OUJIA[ _](S10|S8|S11|T50|S2[79]|2019)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Qware": {
        "regex": "QW[ _-]TB-\\w+",
        "device": "tablet",
        "models": [
            {
                "regex": "TB-9718Q",
                "model": "Pro 5"
            },
            {
                "regex": "TB-1380Q",
                "model": "Pro 4"
            },
            {
                "regex": "TB-1317Q",
                "model": "Pro 3"
            },
            {
                "regex": "TB-1517D",
                "model": "Tabby"
            },
            {
                "regex": "QW[ _-](TB-\\w+)",
                "model": "$1"
            }
        ]
    },
    "Listo": {
        "regex": "Webpad[_ ]?(100[123]|7007)",
        "device": "tablet",
        "model": "WebPad $1"
    },
    "ECON": {
        "regex": "(EX-32HS01[67]B|EX-32HS006B|EX-39HS004B|EX-50US003B|EX-60US001B|EX-40FS001W)",
        "device": "tv",
        "model": "$1"
    },
    "LNMBBS": {
        "regex": "(H11)-EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "SNAMI": {
        "regex": "SNAMI[_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "TeachTouch": {
        "regex": "TeachTouch[_ ]",
        "device": "peripheral",
        "models": [
            {
                "regex": "TeachTouch (Table)",
                "model": "$1"
            }
        ]
    },
    "Facetel": {
        "regex": "(?:Q3_EEA|Q3pro|Q10-EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Q3_EEA(?:[);/ ]|$)",
                "model": "Q3"
            },
            {
                "regex": "Q10-EEA(?:[);/ ]|$)",
                "model": "Q10"
            },
            {
                "regex": "Q3pro(?:[);/ ]|$)",
                "model": "Q3 Pro"
            }
        ]
    },
    "HLLO": {
        "regex": "(SMB-H8009)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "YUMKEM": {
        "regex": "(?:U320|(?:L211|N10|U221|U310)-EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(L211|N10|U221|U310)-EEA",
                "model": "$1"
            },
            {
                "regex": "U320",
                "model": "U320"
            }
        ]
    },
    "TTK-TV": {
        "regex": "TTK Box 214",
        "device": "tv",
        "model": "SB-214"
    },
    "Famous": {
        "regex": "Famous|Red Royal Edition",
        "device": "smartphone",
        "models": [
            {
                "regex": "Red 5\\+",
                "model": "Red 5 Plus"
            },
            {
                "regex": "Red Royal Edition",
                "model": "Red Royal Edition"
            },
            {
                "regex": "5Plus",
                "model": "5 Plus"
            },
            {
                "regex": "Famous 5",
                "model": "5"
            },
            {
                "regex": "Famous[_ ]TAB[_ ]10",
                "device": "tablet",
                "model": "Tab 10"
            }
        ]
    },
    "ZIK": {
        "regex": "ZIK[_ ](W1027)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "PlusStyle": {
        "regex": "PS_TAB_(WB01)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Tab $1"
    },
    "New Bridge": {
        "regex": "(NBTB10[12])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Intel": {
        "regex": "NUC10i3FNH",
        "device": "desktop",
        "models": [
            {
                "regex": "NUC10i3FNH",
                "model": "NUC 10"
            }
        ]
    },
    "Infiniton": {
        "regex": "INFINITON[_ -]|Earth 7\\.0'3G|EARTH10",
        "device": "smartphone",
        "models": [
            {
                "regex": "INFINITON[_ -]T5",
                "model": "T5"
            },
            {
                "regex": "Earth 7\\.0'3G",
                "device": "tablet",
                "model": "Earth 7\" 3G"
            },
            {
                "regex": "EARTH10",
                "device": "tablet",
                "model": "Earth 10.1\" 3G"
            }
        ]
    },
    "Backcell": {
        "regex": "(BK2021)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "PAPYRE": {
        "regex": "PAPYRE[_ ]",
        "device": "tablet",
        "models": [
            {
                "regex": "PAPYRE[_ ]pad_7\\.1",
                "model": "Pad 7.1\""
            }
        ]
    },
    "I-INN": {
        "regex": "COMMUNICATOR[_ ]9\\.7[_ ]3G",
        "device": "tablet",
        "model": "Communicator 9.7\" 3G"
    },
    "Emporia": {
        "regex": "emporia[_ ]|(?:Android 9(?:[\\d.]*);(?: [\\w-]+;)? S3mini|Android 13(?:[\\d.]*);(?: [\\w-]+;)? E5mini)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S3mini",
                "model": "S3 Mini"
            },
            {
                "regex": "E5mini",
                "model": "E5 Mini"
            },
            {
                "regex": "emporia[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "BLISS": {
        "regex": "BLISS-T6|(BPM9727)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "BLISS-T6",
                "model": "T6"
            },
            {
                "regex": "(BPM9727)",
                "model": "$1"
            }
        ]
    },
    "Entity": {
        "regex": "ENT11QF12(?:[);/ ]|$)",
        "device": "tablet",
        "model": "ENT11QF12"
    },
    "Envizen": {
        "regex": "(?:ClickTabDSh18)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "ClickTab DSH18"
    },
    "Denali": {
        "regex": "(DT0704K08|DT070[25]W08)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "E-Tab $1"
    },
    "DreamTab": {
        "regex": "(DRN-[78]09)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "DL": {
        "regex": "Smartphone[ _]DL|DL_Horizon_Selfie|Tablet_DL_\\d{4}|Smartphone[_ ](?:YZU[_ ]DS53)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Smartphone[_ ]YZU[_ ]DS53",
                "model": "YZU DS53"
            },
            {
                "regex": "DL[_ ]Horizon[ _]H8",
                "model": "Horizon H8"
            },
            {
                "regex": "DL_Horizon_Selfie",
                "model": "Horizon Selfie"
            },
            {
                "regex": "Tablet_DL_3910",
                "device": "tablet",
                "model": "iPlayer Kids"
            },
            {
                "regex": "Tablet_DL_(\\d{4})",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "DIGICOM": {
        "regex": "DIGICOM[_ ]",
        "device": "tablet",
        "models": [
            {
                "regex": "DIGICOM[_ ](A10_LTE)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Digicom[_ ]DTOK",
                "device": "smartphone",
                "model": "DTok"
            }
        ]
    },
    "InFone": {
        "regex": "(?:INFONE (?:XE?)|GORILLA 9 PLUS|X_RAINBOW)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GORILLA 9 PLUS",
                "model": "Gorilla 9 Plus"
            },
            {
                "regex": "X_RAINBOW",
                "model": "X Rainbow"
            },
            {
                "regex": "INFONE (XE?)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Redway": {
        "regex": "(?:Redway_7|redway7_pro|redway10_lite)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "redway10_lite",
                "model": "10 Lite"
            },
            {
                "regex": "redway7_pro",
                "model": "7 Pro"
            },
            {
                "regex": "Redway_7",
                "model": "7"
            }
        ]
    },
    "iNo Mobile": {
        "regex": "(?:iNO SCOUT 2|SGINO6|iNO S9)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "iNO SCOUT 2",
                "model": "Scout 2"
            },
            {
                "regex": "SGINO6",
                "model": "6"
            },
            {
                "regex": "iNO S9",
                "model": "S9"
            }
        ]
    },
    "iReplace": {
        "regex": "Frog ?One(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Frog One"
    },
    "GEOZON": {
        "regex": "GEOZON[_ ]([^/;)]+)(?: Build|[);])",
        "device": "wearable",
        "model": "$1"
    },
    "actiMirror": {
        "regex": "Desk21T-03",
        "device": "peripheral",
        "models": [
            {
                "regex": "(Desk21T-03)",
                "model": "$1"
            }
        ]
    },
    "Raylandz": {
        "regex": "XPOWER_P6000(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "XPOWER_P6000",
                "model": "XPower P6000"
            }
        ]
    },
    "OTTO": {
        "regex": "OTTO (CR05)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Kenbo": {
        "regex": " (O[76]1|E61Pro|O31 Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E61Pro",
                "model": "E61 Pro"
            },
            {
                "regex": "O31 Plus",
                "model": "O31 Plus"
            },
            {
                "regex": "(O[76]1)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "VALE": {
        "regex": "(?:V12E-LTE-8128|V10E-LTE-464)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "V(1[02])E-LTE",
                "model": "V$1E LTE"
            }
        ]
    },
    "VALEM": {
        "regex": "PHANTOM_Z",
        "device": "tablet",
        "model": "Phantom Z"
    },
    "ENACOM": {
        "regex": "(M1045W|PIXBA2019)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Yuno": {
        "regex": "YUNO\\.|ULX-(?:55UTCS3234|32TCS226|43UTCS347|39TCS222|50UTCS3234|43FTCS2234|32TCSW2234|24TCS221)",
        "device": "tv",
        "models": [
            {
                "regex": "ULX-(\\d{2}[FU]?TCSW?\\d{2,4})-T9",
                "model": "ULX-$1-T9"
            },
            {
                "regex": "ULX-(\\d{2}[FU]?TCSW?\\d{2,4})",
                "model": "ULX-$1"
            }
        ]
    },
    "Handheld": {
        "regex": "(?:ALGIZ_RT8|NAUTIZ_X2)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(NAUTIZ_X2)(?:[);/ ]|$)",
                "device": "smartphone",
                "model": "$1"
            },
            {
                "regex": "(ALGIZ_RT8)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "HDC": {
        "regex": "(?:H10_ONE)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "H10_ONE",
                "model": "H10 One"
            }
        ]
    },
    "Victurio": {
        "regex": "(VI10[68]|VI86)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "TouchPad $1"
    },
    "MyMobile": {
        "regex": "MY MOBILE (708)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Equator": {
        "regex": "Axis(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Axis"
    },
    "Imaq": {
        "regex": "IMAQ",
        "device": "tv",
        "models": [
            {
                "regex": "IMAQ TETRA(?:[);/ ]|$)",
                "model": "Tetra"
            }
        ]
    },
    "Imose": {
        "regex": "BAM-II",
        "device": "smartphone",
        "model": "BAM-II"
    },
    "OneClick": {
        "regex": "X-music II pro|X-music (?:S|\u2162|III)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X-music II pro",
                "model": "X-Music II Pro"
            },
            {
                "regex": "X-music (?:\u2162|III)",
                "model": "X-Music III"
            },
            {
                "regex": "X-music (S)",
                "model": "X-Music $1"
            }
        ]
    },
    "D-Tech": {
        "regex": "(?:D5-L|DT07-TAB4G|LM-01)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DT07-TAB4G",
                "device": "tablet",
                "model": "DT07 Tab 4G"
            },
            {
                "regex": "(LM-01)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "(D5-L)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "nJoy": {
        "regex": "(?:nJoy[_ ])?(Deimos 7|Kali_8|Turnus_8|Tityos_10|Arcas_7|Theia_10|Chronos_10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "iXTech": {
        "regex": "(IX701)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "IOTWE": {
        "regex": "T95pro(?:[);/ ]|$)",
        "device": "tv",
        "model": "T95 Pro"
    },
    "Legend": {
        "regex": "(RST)_(B\\d{4}HD)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1-$2"
    },
    "BlueSky": {
        "regex": "BSS(45|50)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "BSS$1"
    },
    "Vue Micro": {
        "regex": " (81V)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Touch Plus": {
        "regex": " (770[NG]|1100AS)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Elong Mobile": {
        "regex": " (6CS)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "HexaByte": {
        "regex": "(?:HB_X7)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "X7"
    },
    "HiKing": {
        "regex": "HIKING[_ ]|(?:HK-MH501|Fun5)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "HIKING[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "HK-(MH501)",
                "model": "$1"
            },
            {
                "regex": "Fun5",
                "model": "Fun 5"
            }
        ]
    },
    "Hytera": {
        "regex": "(?:PTC760|PNC5[56]0)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(PTC760|PNC5[56]0)",
                "device": "peripheral",
                "model": "$1"
            }
        ]
    },
    "PIRANHA": {
        "regex": "PIRANHA[_ ]|(?:Ultra 4 Tab 9\\.0|Ultra 5 Tab White|Piranha8032)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Pro II Tab 7\\.0",
                "model": "Pro II"
            },
            {
                "regex": "Ultra 4 Tab 9\\.0",
                "model": "Ultra 4"
            },
            {
                "regex": "Ultra 5 Tab White",
                "model": "Ultra 5"
            },
            {
                "regex": "Piranha8032",
                "model": "8032"
            }
        ]
    },
    "CipherLab": {
        "regex": "(RK25WO|RK[29]5|RS35|RS51_HS)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "BrandCode": {
        "regex": "(?:L1f-pluss|Brandcode B6S)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "L1f-pluss",
                "model": "L1f Plus"
            },
            {
                "regex": "Brandcode B6S",
                "model": "B6S"
            }
        ]
    },
    "Lumitel": {
        "regex": "(L950[23])(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Mango": {
        "regex": "Mango[_ ](?:AKABUTO_4G|S5|SQ7)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mango_AKABUTO_4G",
                "device": "feature phone",
                "model": "Akabuto 4G"
            },
            {
                "regex": "Mango[_ ](S5|SQ7)",
                "model": "$1"
            }
        ]
    },
    "NTT West": {
        "regex": "HB-(2000)(?:[);/ ]|$)",
        "device": "tv",
        "model": "HikariBox+ $1"
    },
    "JREN": {
        "regex": "(JR-J71)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Wanmukang": {
        "regex": "(?:ZC-339)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(ZC-339)",
                "device": "desktop",
                "model": "$1"
            }
        ]
    },
    "Tibuta": {
        "regex": "Tibuta[_ ]|TAB_868_PRO(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Tibuta[_ ]MasterPad-(E100)",
                "model": "MasterPad $1"
            },
            {
                "regex": "TAB_(868)_PRO",
                "model": "Tab $1 Pro"
            }
        ]
    },
    "ATOL": {
        "regex": "(?:ATOL (?:150F)|Smart_(?:Prime|SLIM_Plus))(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "Smart_Prime",
                "model": "Smart Prime"
            },
            {
                "regex": "Smart_Slim_plus",
                "model": "Smart Slim Plus"
            },
            {
                "regex": "ATOL (150F)",
                "model": "$1"
            }
        ]
    },
    "Filimo": {
        "regex": "Filimo",
        "device": "tv",
        "models": [
            {
                "regex": "Filimo Box FB-101(?:[);/ ]|$)",
                "model": "FB-101"
            }
        ]
    },
    "FILIX": {
        "regex": "(?:FX4423)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Ultra M FX4423"
    },
    "Odotpad": {
        "regex": "(?:FIRE_V[78]|POMELO-MAX\\+)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "FIRE_V([78])",
                "model": "Dragon Fruit Fire V$1"
            },
            {
                "regex": "POMELO-MAX\\+",
                "model": "Pomelo Max+"
            }
        ]
    },
    "Orbsmart": {
        "regex": "Orbsmart[_ ]",
        "device": "tv",
        "models": [
            {
                "regex": "Orbsmart[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "TOX": {
        "regex": "TOX1",
        "device": "tv",
        "model": "1"
    },
    "Topsion": {
        "regex": "TOPSION|TP01_box(?:[);/ ]|$)",
        "device": "tv",
        "model": "TP01"
    },
    "Ceibal": {
        "regex": "(?:ACRUX|BELLATRIX|BETELGEUSE|GACRUX|Kil-82WFDC|U800B)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "ACRUX",
                "model": "\xc1crux"
            },
            {
                "regex": "BELLATRIX",
                "model": "Bellatrix"
            },
            {
                "regex": "BETELGEUSE",
                "model": "Betelgeuse"
            },
            {
                "regex": "GACRUX",
                "model": "Gacrux"
            },
            {
                "regex": "Kil-82WFDC",
                "model": "Kiland T8"
            },
            {
                "regex": "(U800B)",
                "model": "$1"
            }
        ]
    },
    "Wecool": {
        "regex": "(WM1001)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Weelikeit": {
        "regex": "(?:C81W_EEA|P16W|F21W)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(P16W|C81W|F21W)(?:_EEA)?",
                "model": "$1"
            }
        ]
    },
    "M3 Mobile": {
        "regex": "(?:M3US20W|M3SL20|M3SM15X)(?:[);/ ]|$)",
        "device": "peripheral",
        "models": [
            {
                "regex": "M3US20W",
                "model": "US20W"
            },
            {
                "regex": "M3SL20",
                "model": "SL20"
            },
            {
                "regex": "M3SM15X",
                "model": "SM15X"
            }
        ]
    },
    "Hugerock": {
        "regex": "Hugerock|T101_2021(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Hugerock[_ ](T70H)",
                "model": "$1"
            },
            {
                "regex": "T101_2021",
                "model": "T101 (2021)"
            }
        ]
    },
    "Geanee": {
        "regex": "(JT08-X1|JT10-90|JT10-81B|JT10-X)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TOPDON": {
        "regex": "(ArtiDiag800 BT)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Coopers": {
        "regex": "(CP20)(?:_EEA)?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "COOD-E": {
        "regex": "COOD-E",
        "device": "tv",
        "models": [
            {
                "regex": "TV 4K(?:[);/ ]|$)",
                "model": "TV Box 4K"
            }
        ]
    },
    "Lovme": {
        "regex": "Lovme[-_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "LOGAN": {
        "regex": "LOGAN_(Panita)_3G(?:[);/ ]|$)",
        "device": "feature phone",
        "model": "$1"
    },
    "DASS": {
        "regex": "DASS[-_ ](H-ONE)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Redbean": {
        "regex": "(i-Jupiter)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "ENIE": {
        "regex": "(?:android 8(?:[\\d.]*);(?: [\\w-]+;)? E4Pro|VT8216)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "E4Pro",
                "model": "E4 Pro"
            },
            {
                "regex": "(VT8216)",
                "model": "$1"
            }
        ]
    },
    "Dcode": {
        "regex": "DS-(?:BD[123]|CR1|CL[23] Pro|X1|CL[234] Lite|CL[1-4])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DS-CR1",
                "model": "Cypher"
            },
            {
                "regex": "DS-CL([23]) Pro",
                "model": "Cygnal $1 Pro"
            },
            {
                "regex": "DS-CL([234]) Lite",
                "model": "Cygnal $1 Lite"
            },
            {
                "regex": "DS-CL([234])",
                "model": "Cygnal $1"
            },
            {
                "regex": "DS-BD1",
                "model": "Bold"
            },
            {
                "regex": "DS-CL1",
                "model": "Cygnal"
            },
            {
                "regex": "DS-BD3 Pro",
                "model": "Bold 3 Pro"
            },
            {
                "regex": "DS-BD([23])",
                "model": "Bold $1"
            },
            {
                "regex": "DS-(X1)",
                "model": "$1"
            }
        ]
    },
    "Pritom": {
        "regex": "Pritom_|(?:K7_A101(?:_EEA)?|Android 1[01](?:[\\d.]*);(?: [\\w-]+;)? (?:M10_Lite|M10_EEA|M10_(?:PLUS|Air)(?:_EEA)?|P7_EEA)|M10_R0[24]|P7PRO|M10_C01_EEA|TOUCH 7)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "M10_Lite",
                "model": "M10 Lite"
            },
            {
                "regex": "M10_R0([24])",
                "model": "M10 R0$1"
            },
            {
                "regex": "TOUCH 7",
                "model": "Touch 7"
            },
            {
                "regex": "K7_A101",
                "model": "K7 A101"
            },
            {
                "regex": "M10_Air",
                "model": "M10 Air"
            },
            {
                "regex": "M10_PLUS",
                "model": "M10 Plus"
            },
            {
                "regex": "(?:Pritom[_ ])?M10_C01",
                "model": "M10 C01"
            },
            {
                "regex": "Pritom[_ ]M10|M10_EEA",
                "model": "M10"
            },
            {
                "regex": "P7_EEA",
                "model": "P7"
            },
            {
                "regex": "P7PRO",
                "model": "TronPad P7 Pro"
            }
        ]
    },
    "Unblock Tech": {
        "regex": "(?:S900PROBT|S900_Pro)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "S900PROBT",
                "model": "S900 Pro BT"
            },
            {
                "regex": "S900_Pro",
                "model": "S900 Pro"
            }
        ]
    },
    "Chainway": {
        "regex": "(?:C66)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(C66)",
                "model": "$1"
            }
        ]
    },
    "Harper": {
        "regex": "HARPER|(?:HARPER[_ ])?(?:ABX-332|ABX-[12]10|24R470TS|32R750TS|32R670TS|40F660TS|40F750TS|43U750TS|24R490TS|65U660TS|43F6[69]0TS|50U660TS|32R751TS|43F750TS|85U750TS)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:HARPER[_ ])?(ABX-332|ABX-[12]10|32R751TS|40F660TS|24R490TS|65U660TS|50U660TS)",
                "model": "$1"
            },
            {
                "regex": "(?:HARPER[ _-]?)?(\\d{2}[QUFR]\\d{3}TS)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Venstar": {
        "regex": "(ACE10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "CMF": {
        "regex": "(?:A015|A001)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A001",
                "model": "Phone 2 Pro"
            },
            {
                "regex": "A015",
                "model": "Phone 1"
            }
        ]
    },
    "Nothing": {
        "regex": "(?:A06[35]|AIN065|A142P?|Phone \\(2a\\)|A059P?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "A063|A015",
                "model": "Phone 1"
            },
            {
                "regex": "A(?:IN)?065",
                "model": "Phone 2"
            },
            {
                "regex": "A142P",
                "model": "Phone 2a Plus"
            },
            {
                "regex": "A142|Phone \\(2a\\)",
                "model": "Phone 2a"
            },
            {
                "regex": "A059P",
                "model": "Phone 3a Pro"
            },
            {
                "regex": "A059",
                "model": "Phone 3a"
            }
        ]
    },
    "Gazer": {
        "regex": "Gazer_TV",
        "device": "tv",
        "model": "Smart TV"
    },
    "WizarPos": {
        "regex": "WIZARPOS[ _]([^/;)]+)(?: Build|[);])",
        "device": "peripheral",
        "model": "$1"
    },
    "Optoma": {
        "regex": "Optoma[-_ ]",
        "device": "peripheral",
        "models": [
            {
                "regex": "Optoma-UHD",
                "model": "UHD55"
            }
        ]
    },
    "Zinox": {
        "regex": "KidsLegacyTabPro|Zpad-X8-PRO",
        "device": "tablet",
        "models": [
            {
                "regex": "KidsLegacyTabPro",
                "model": "Kids Legacy Tab Pro"
            },
            {
                "regex": "Zpad-X8-PRO",
                "model": "Zpad X8 Pro"
            }
        ]
    },
    "YUNDOO": {
        "regex": "YUNDOO[ _-]([^/;)]+)(?: Build|[);])",
        "device": "tv",
        "model": "$1"
    },
    "Billow": {
        "regex": "(MD09TV)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Dany": {
        "regex": "(?:Signature-S8|Monster 4GXX|AMAZE AX-50 Advance)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Signature-S8)",
                "model": "$1"
            },
            {
                "regex": "Monster 4GXX",
                "model": "Monster 4G"
            },
            {
                "regex": "AMAZE AX-50 Advance",
                "device": "tv",
                "model": "Amaze AX-50 Advance"
            }
        ]
    },
    "DreamStar": {
        "regex": "DREAMSTAR",
        "device": "tv",
        "models": [
            {
                "regex": "DREAMSTAR([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Ollee": {
        "regex": "Ollee008twoa(?:[);/ ]|$)",
        "device": "tablet",
        "model": "008 TwoA"
    },
    "Dtac": {
        "regex": "Dtac[_ ]?Phone[_ ]?([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "Phone $1"
    },
    "NINETOLOGY": {
        "regex": "NINETOLOGY[_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "NINETEC": {
        "regex": "NINETEC",
        "device": "tablet",
        "models": [
            {
                "regex": "UltraTab 10 Pro",
                "model": "UltraTab 10 Pro"
            },
            {
                "regex": "Platinum 10 G3",
                "model": "Platinum 10 G3"
            }
        ]
    },
    "NASCO": {
        "regex": "(?:NASCO (?:TANGO 7)|SNAP_PRO)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TANGO 7",
                "model": "Tango 7"
            },
            {
                "regex": "SNAP_PRO",
                "model": "Snap Pro",
                "device": "smartphone"
            }
        ]
    },
    "ELE-GATE": {
        "regex": "ELE-GATE(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box"
    },
    "Elecson": {
        "regex": "Meeplus_1(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "MeePlus One"
    },
    "NEXT": {
        "regex": "(Discovery_XT|Revolution-X69K)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Next & NextStar": {
        "regex": "^NEXT |LGE; YE-[0-9a-z]+(?:-4K)?;|MyBox(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "2000 WiFi",
                "model": "2000 WiFi"
            },
            {
                "regex": "2000 HD FTA",
                "model": "2000 HD FTA"
            },
            {
                "regex": "2000-HD PLUS",
                "model": "2000 HD Plus"
            },
            {
                "regex": "2000-HD",
                "model": "2000 HD"
            },
            {
                "regex": "NEXT 64",
                "model": "64"
            },
            {
                "regex": "2071",
                "model": "2071"
            },
            {
                "regex": "YE-2000HD CX",
                "model": "YE-2000HD CX"
            },
            {
                "regex": "YE-2000 USB",
                "model": "YE-2000 USB"
            },
            {
                "regex": "MyBox(?:[);/ ]|$)",
                "model": "MyBox"
            },
            {
                "regex": "LGE; (YE-[0-9a-z]+)-4K;",
                "model": "$1 4K"
            },
            {
                "regex": "LGE; (YE-[0-9a-z]+);",
                "model": "$1"
            }
        ]
    },
    "iMuz": {
        "regex": "(?:Revolution A8|muPAD[_ ][KT]10|muPAD10[24]|muPADT7|muPAD 7S)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(Revolution A8|muPAD[_ ][KT]10)",
                "model": "$1"
            },
            {
                "regex": "muPAD[ _]?(10[24]|T7|7S)",
                "model": "muPAD $1"
            }
        ]
    },
    "ECOO": {
        "regex": "ECOO[ _]E0[45]",
        "device": "smartphone",
        "models": [
            {
                "regex": "ECOO[ _]E04[ _]3GB\\+|Ecoo E04_PLUS",
                "model": "Aurora Plus"
            },
            {
                "regex": "ECOO[ _]E04[ _]3GB",
                "model": "Aurora"
            },
            {
                "regex": "ECOO[ _](E0[45])",
                "model": "$1"
            }
        ]
    },
    "Dom.ru": {
        "regex": "(Movix Pro(?: Voice)?|Movix Go)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Carbon Mobile": {
        "regex": "Carbon 1 Mark II",
        "device": "smartphone",
        "model": "One Mark II"
    },
    "ChiliGreen": {
        "regex": "E-Board[ -]MX05[45]",
        "device": "tablet",
        "models": [
            {
                "regex": "E-Board[ -](MX05[45])",
                "model": "E-Board $1"
            }
        ]
    },
    "D-Link": {
        "regex": "(DTB-7168G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Scosmos": {
        "regex": "(Pi 5\\.5L)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "QFX": {
        "regex": "(TLW-100[BG]?)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Dinax": {
        "regex": "DX_TA_?(7001|SL83)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "DX TA $1"
    },
    "Dinalink": {
        "regex": "Dynalink",
        "device": "tv",
        "models": [
            {
                "regex": "Dynalink TV BOX(?:[);/ ]|$)",
                "model": "TV Box"
            }
        ]
    },
    "EFT": {
        "regex": "EFT_(H[234])(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Youin": {
        "regex": "YOU-BOX(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "YOU-BOX(?:[);/ ]|$)",
                "model": "You-Box"
            }
        ]
    },
    "Youwei": {
        "regex": "Youwei[ _]",
        "device": "tv",
        "models": [
            {
                "regex": "youwei[ _]mini5G(?:[);/ ]|$)",
                "model": "Mini 5G"
            },
            {
                "regex": "youwei box",
                "model": "Box X1"
            }
        ]
    },
    "Yooz": {
        "regex": "YPAD(P70[12])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "MyPad $1"
    },
    "VIDA": {
        "regex": "VIDA[-_ ](?:i-?(401|512|450)|V401)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "VIDA[-_ ](?:i-?(\\d+))",
                "model": "i$1"
            },
            {
                "regex": "VIDA[-_ ](V401)",
                "model": "$1"
            }
        ]
    },
    "iMI": {
        "regex": "(?:Vin 5|Vin3 S|Vin3(?: Lite)?|Messi No\\.1|Messi 3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Vin3 S",
                "model": "Vin 3 S"
            },
            {
                "regex": "Vin3 Lite",
                "model": "Vin 3 Lite"
            },
            {
                "regex": "Vin ?(3|5)",
                "model": "Vin $1"
            },
            {
                "regex": "Messi (No\\.1|3)",
                "model": "Messi $1"
            }
        ]
    },
    "Marshal": {
        "regex": "Marshal[_ -]?ME",
        "device": "smartphone",
        "models": [
            {
                "regex": "Marshal[_ -]?ME-(700A|720|617)",
                "device": "tablet",
                "model": "ME-$1"
            },
            {
                "regex": "Marshal[_ -]?ME-(34[78]|352|36[456])",
                "model": "ME-$1"
            }
        ]
    },
    "V-HOME": {
        "regex": "(?:V-HOME_)?(32LH1210|43LF1210|(?:5[05]|65|43)LU1210|24LH1211|24LH1203)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "V-HOPE": {
        "regex": "V[- ]hope[_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "BuzzTV": {
        "regex": "(XR4500)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Avaya": {
        "regex": "Avaya Vantage(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "Vantage K175"
    },
    "PINE64": {
        "regex": "PINE ([^/;)]+)(?: Build|[);])",
        "device": "peripheral",
        "model": "$1"
    },
    "Duubee": {
        "regex": "Duubee[ _]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Blackpcs": {
        "regex": "(EO104K)[-_]BL(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1-BL"
    },
    "GoldMaster": {
        "regex": "(?:Netta 2 Pro|NETTA 3|Netta 3\\.100m|BENGAL_6|DETROIT 3|i-910|i-9[02]5)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Netta 2 Pro",
                "model": "Netta 2 Pro",
                "device": "tv"
            },
            {
                "regex": "i-(910|9[02]5)",
                "model": "i-$1",
                "device": "tv"
            },
            {
                "regex": "Netta 3(?:\\.100m)?",
                "model": "Netta 3",
                "device": "tv"
            },
            {
                "regex": "BENGAL_6",
                "model": "Bengal 6"
            },
            {
                "regex": "DETROIT 3",
                "model": "Detroit 3"
            }
        ]
    },
    "Facime": {
        "regex": "FLEET_7(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Fleet 7"
    },
    "FPT": {
        "regex": "FPT[_ ](X1[05]|X[39]|X50|S68 4G)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "iFIT": {
        "regex": "IFT1018(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Compass"
    },
    "iNavi": {
        "regex": "(ITP-XD80L)(?: Build|[);])",
        "device": "tablet",
        "models": [
            {
                "regex": "ITP-XD80L",
                "model": "U+ Pad8"
            }
        ]
    },
    "10moons": {
        "regex": "10moons[_ ]([^/;)]+)(?: Build|[);])",
        "device": "tv",
        "model": "$1"
    },
    "Soda": {
        "regex": "soda (?:S2|[SE]1|FIRE)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "soda FIRE",
                "model": "Fire"
            },
            {
                "regex": "soda (S2|[SE]1)",
                "model": "$1"
            }
        ]
    },
    "Rizzen": {
        "regex": "(NovaTab_R10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Figgers": {
        "regex": "Figgers",
        "device": "smartphone",
        "models": [
            {
                "regex": "Figgers[_ ](F3|DragonX)",
                "model": "$1"
            }
        ]
    },
    "DRAGON": {
        "regex": "DRAGON[_ ](OTT)",
        "device": "tv",
        "model": "$1"
    },
    "Skyline": {
        "regex": "(?:SKYLINE[_ ])?(32YST5970|50UST5970|24YST5970|40LST597[05]|32YST5975|43LST5975|43U6510|5[58]U7510|43LST5970)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Hiberg": {
        "regex": "(?:32Y_STV-R|HIBERGQLED\\d{2}Y|HIBERG\\d{2}YUHD(?:-R)?|(?:5[05]|43|65)YUHD-R)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "HIBERGQLED(\\d{2}Y)(?:[);/ ]|$)",
                "model": "QLED $1"
            },
            {
                "regex": "(?:HIBERG)?(\\d{2})YUHD-R",
                "model": "$1Y UHD-R"
            },
            {
                "regex": "HIBERG(\\d{2})YUHD",
                "model": "$1Y UHD"
            },
            {
                "regex": "(32Y_STV-R)",
                "model": "$1"
            }
        ]
    },
    "Hartens": {
        "regex": "(HTY[_-]\\d{2}\\w+-(?:S2|H[ACK]22|S2-T9|V[DNZS])|HTY-32HDR06G|HTY_43FHD06B|HTY-43F06B-VZ|HTY-50UHD05B|HTY-24H06W-VZ(?:-M)?|HTV-55U11B-VS|43F01)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "43F01(?:[);/ ]|$)",
                "model": "HTV-43F01-T2C"
            },
            {
                "regex": "HTY-24H06W-VZ-M",
                "model": "HTY-24H06W-VZ"
            },
            {
                "regex": "HT([YV])[_-](\\d{2}(?:[^/;)]+))(?: Build|[);])",
                "model": "HT$1-$2"
            }
        ]
    },
    "AMA": {
        "regex": "AMA[ _](A703)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Xcruiser": {
        "regex": "(XDSR785HDR_AVANT)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Revomovil": {
        "regex": "(?:S6523(?:[ _]RU)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S6523",
                "model": "S21"
            }
        ]
    },
    "OSCAL": {
        "regex": "(?:Spider 8|S60Pro|MARINE [12]|MODERN 8|PILOT [123]|FLAT [12]C?|Tiger 1[023]|android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:Pad 1[158]|Pad 8)|android 12(?:[\\d.]*);(?: [\\w-]+;)? (?:C[678]0|C30 Pro|Pad (?:[167]0|13))|Pad [78]0 WiFi|Pad 100)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MODERN 8",
                "model": "Modern 8"
            },
            {
                "regex": "MARINE ([12])",
                "model": "Marine $1"
            },
            {
                "regex": "PILOT ([123])",
                "model": "Pilot $1"
            },
            {
                "regex": "C30 Pro",
                "model": "C30 Pro"
            },
            {
                "regex": "FLAT ([12])C",
                "model": "Flat $1C"
            },
            {
                "regex": "FLAT (2)",
                "model": "Flat $1"
            },
            {
                "regex": "S60Pro",
                "model": "S60 Pro"
            },
            {
                "regex": "Tiger (1[023])",
                "model": "Tiger $1"
            },
            {
                "regex": "(C[678]0)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Pad ([78]0) WiFi",
                "device": "tablet",
                "model": "Pad $1 WiFi"
            },
            {
                "regex": "Pad (100|[167]0|1[1358]|8)",
                "device": "tablet",
                "model": "Pad $1"
            },
            {
                "regex": "Spider 8",
                "device": "tablet",
                "model": "Spider 8"
            }
        ]
    },
    "UE": {
        "regex": "UE Pad 1",
        "device": "tablet",
        "model": "Pad 1"
    },
    "Hykker": {
        "regex": "Hykker_MyTab10",
        "device": "tablet",
        "model": "MyTab10"
    },
    "Fluo": {
        "regex": "(?:S554020|F_Plus)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "S554020",
                "model": "L"
            },
            {
                "regex": "F_Plus",
                "model": "F Plus"
            }
        ]
    },
    "Quatro": {
        "regex": "Quatro (8|10|FSM1453)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "White Mobile": {
        "regex": "AM1010V(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "AM1010V",
                "model": "Omega Lite 3"
            }
        ]
    },
    "ALLINmobile": {
        "regex": "ALLINmobile_ARENA(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Arena"
    },
    "PRIME": {
        "regex": "PRIME (O8)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "TETC": {
        "regex": "TETC[ -](F\\d)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vizmo": {
        "regex": "VIZ(?:101|070)TAB[78]11",
        "device": "tablet",
        "models": [
            {
                "regex": "VIZ070TAB(\\d{3})",
                "model": "TAB $1 7\""
            },
            {
                "regex": "VIZ101TAB(\\d{3})",
                "model": "TAB $1 10.1\""
            }
        ]
    },
    "Uniden": {
        "regex": "Uniden[ _](C505|Prime 500)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "FoxxD": {
        "regex": "FOXXD|(?:L590A)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:FOXXD )?(C65|L590A)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "KZG": {
        "regex": "KZG[_ ](Scope)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "iYou": {
        "regex": "iYOU[_ ](M1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Sewoo": {
        "regex": "(NBP-60)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "Switel": {
        "regex": "eSmart[_ ]([EM]2|M3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "eSmart $1"
    },
    "Farassoo": {
        "regex": "(FAST81[08])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Xwave": {
        "regex": "Xpad_(M9_3G)",
        "device": "tablet",
        "model": "xPad $1"
    },
    "DEALDIG": {
        "regex": "(BOXD7)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "TecToy": {
        "regex": "TECTOY_5029Y(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "ON 128GB"
    },
    "MygPad": {
        "regex": "MygPad[_ ]([^/;)]+)(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "Mobell": {
        "regex": "(?:Mobell[ _](?:S50)|NOVA P3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Mobell[ _](S50)",
                "model": "$1"
            },
            {
                "regex": "NOVA P3",
                "model": "Nova P3"
            }
        ]
    },
    "Mobvoi": {
        "regex": "TicWatch (Pro 3 Ultra GPS|C2|C2\\+|Pro [5S]|S2?)(?:[);/ ]|$)",
        "device": "wearable",
        "model": "TicWatch $1"
    },
    "Smartex": {
        "regex": "(?:Android 7(?:[\\d.]*);(?: [\\w-]+;)? M512| M520| M700)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(M512|M520|M700)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Citycall": {
        "regex": "(Life X6)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Maxfone": {
        "regex": "(Max80 Plus)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Fxtec": {
        "regex": "QX1000(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Pro1 X"
    },
    "Netmak": {
        "regex": "NM-NETPAD7(?:[);/ ]|$)",
        "device": "tablet",
        "model": "NetPad 7"
    },
    "VIVIMAGE": {
        "regex": "VIVIMAGE[ _]([^/;)]+)(?:_EEA)?(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "X-Mobile": {
        "regex": "XMOBILE|(?:XM-SW1|X63Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:XMOBILE) X7(?:[);/ ]|$)",
                "model": "X7"
            },
            {
                "regex": "X63Pro",
                "model": "X63 Pro"
            },
            {
                "regex": "XM-SW1",
                "model": "Smart WiFi"
            }
        ]
    },
    "JoySurf": {
        "regex": "(?:TB-JS101A)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "JS10"
    },
    "DEYI": {
        "regex": "DEYI-?(10M18)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Khadas": {
        "regex": " (VIM2)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Sunmax": {
        "regex": "Model[ _][6ADSY](?:[ _]pro)?(?:[ _]4G)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Model_6_pro_4G",
                "model": "Model 6 Pro 4G"
            },
            {
                "regex": "(Model S 4G)",
                "model": "$1"
            },
            {
                "regex": "(Model [6ADSY])",
                "model": "$1"
            }
        ]
    },
    "Kapsys": {
        "regex": "(SmartVision3)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "YELLYOUTH": {
        "regex": "(YY-\\d{3}[a-z]?)",
        "device": "tablet",
        "model": "$1"
    },
    "SSKY": {
        "regex": "(Y777_Fire)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "XCOM": {
        "regex": "XCOM[ _](?:X520|ISMART)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "XCOM[ _](X520)",
                "model": "$1"
            },
            {
                "regex": "XCOM[ _]ISMART",
                "model": "iSmart"
            }
        ]
    },
    "Winstar": {
        "regex": "Winstar S-?5",
        "device": "smartphone",
        "models": [
            {
                "regex": "Winstar S-?5",
                "model": "S5"
            }
        ]
    },
    "Waltter": {
        "regex": "Waltter NEO 10\\.1",
        "device": "tablet",
        "model": "Neo 10.1\""
    },
    "LPX-G": {
        "regex": "LPX-G BOX",
        "device": "tv",
        "models": [
            {
                "regex": "LPX-G Box Max",
                "model": "Box Max"
            }
        ]
    },
    "VALTECH": {
        "regex": "TAB7Q804VAL",
        "device": "tablet",
        "model": "TAB-7Q804VAL"
    },
    "Sankey": {
        "regex": "TAB7A3G05",
        "device": "tablet",
        "model": "TAB-7A3G05"
    },
    "GIRASOLE": {
        "regex": "(?:Android 8(?:[\\d.]*);(?: [\\w-]+;)? TAB5)(?: Build|[;)])",
        "device": "tablet",
        "model": "TAB5"
    },
    "MOVISUN": {
        "regex": "(TAB-S1)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Samtech": {
        "regex": "(T3G_04|TWIFI-06)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Samtron": {
        "regex": "(?:SAMTRON(?:_W)?_)?(43SA70[15]|50SA707|55SA703|43SA701)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "MwalimuPlus": {
        "regex": "(MP01A3G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "OLTO": {
        "regex": "OLTO[_-]|(?:43ST20[HU]|32ST[23]0H)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(?:OLTO-)?(\\d{2}ST\\d{2}[HU])",
                "model": "$1"
            }
        ]
    },
    "DSIC": {
        "regex": "(RD86QE)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Mascom": {
        "regex": "Mascom (S750|SS289|WS517)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Vormor": {
        "regex": "VORMOR-X5-pro(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "X5 Pro"
    },
    "SOSH": {
        "regex": "SoshPhone",
        "device": "smartphone",
        "model": "SoshPhone"
    },
    "Oangcc": {
        "regex": "(?:Tab_A6|A1[35]_EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Tab_(A6)",
                "model": "Tab $1"
            },
            {
                "regex": "(A1[35])_EEA",
                "model": "Tab $1"
            }
        ]
    },
    "Everex": {
        "regex": "Fine 7B(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Fine 7B"
    },
    "Everis": {
        "regex": "(E011[1346-9]|E0120)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Guophone": {
        "regex": "(XP9800)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "GVC Pro": {
        "regex": "LGE; (?:GVC-[a-z0-9]+|[0-9]{2}GW[0-9]{4}\\d*);",
        "device": "tv",
        "models": [
            {
                "regex": "LGE; ([0-9]{2}GW\\d+);",
                "model": "$1"
            },
            {
                "regex": "LGE; GVC-([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "Unitech": {
        "regex": "EA(?:500Plus|520|602|630)(?:_US)?(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EA500Plus(?:[);/ ]|$)",
                "model": "EA500 Plus"
            },
            {
                "regex": "(EA(?:520|602|630))(?:_US)?(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "GTMEDIA": {
        "regex": "(GTCOMBO)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Energy Sistem": {
        "regex": "ENERGY[ _-]?([^;/)]+)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "Energy Phone ([^;/)]+)(?: Build|[;)])",
                "model": "Energy Phone $1"
            },
            {
                "regex": "Energy Tablet ([^;/)]+)(?: Build|[;)])",
                "device": "tablet",
                "model": "Energy Tablet $1"
            },
            {
                "regex": "ENERGY i10 DUAL",
                "device": "tablet",
                "model": "i10 Dual"
            },
            {
                "regex": "ENERGY[ _-]?([^;/]+) Build",
                "device": "tablet",
                "model": "$1"
            }
        ]
    },
    "WANSA": {
        "regex": "LGE; WLE[0-9a-z]+;|(?:WUD55H7762SN|WUD55G7762S)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(WUD55H7762SN|WUD55G7762S)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "LGE; (WLE[0-9a-z]+);",
                "model": "$1"
            }
        ]
    },
    "XElectron": {
        "regex": "(V1277)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "ViBox": {
        "regex": "ViBox[ _](V[25])[_ ]Pro(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1 Pro"
    },
    "BMXC": {
        "regex": "(?:BMXC[_ ]?(?:80[01])| M863(?:-EEA)?)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(M863)",
                "model": "$1"
            },
            {
                "regex": "BMXC[_ ]?(80[01])",
                "model": "$1"
            }
        ]
    },
    "V-Gen": {
        "regex": "(Albatros C2)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Nedaphone": {
        "regex": "NEDAPHONE[ _](V9)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Beafon": {
        "regex": "(?:Class_C250|TW10)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(TW10)",
                "device": "tablet",
                "model": "Tab Lite $1"
            },
            {
                "regex": "(Class_C250)",
                "model": "$1"
            }
        ]
    },
    "RelNAT": {
        "regex": "RelNAT[_ ](Premier)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "TeloSystems": {
        "regex": "TELO[_ ](?:TE6|M5|TE580_CO)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "TELO[_ ](TE6|TE580_CO)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "TELO_M5",
                "device": "peripheral",
                "model": "M5"
            }
        ]
    },
    "Frunsi": {
        "regex": "(RubensTab_T11)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "MIWANG": {
        "regex": "MIWANG[_ ](M2s)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "HeadWolf": {
        "regex": "(?:Hpad[12]|Wpad3| F3A)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Hpad([12])",
                "model": "HPad$1"
            },
            {
                "regex": "Wpad(3)",
                "model": "WPad$1"
            },
            {
                "regex": "F3A(?:[);/ ]|$)",
                "model": "FPad3"
            }
        ]
    },
    "Zamolxe": {
        "regex": "(ZXT-10HL323S|ZXT-10FL323G-PRO)",
        "device": "tablet",
        "model": "$1"
    },
    "REGAL": {
        "regex": "Regal (?:TAB 10\\.1|G[o0][o0]gle TV)|REGAL, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tablet",
        "models": [
            {
                "regex": "Regal (TAB 10\\.1)",
                "model": "$1"
            },
            {
                "regex": "Regal G[o0][o0]gle TV",
                "device": "tv",
                "model": "Smart TV"
            },
            {
                "regex": "REGAL, ([a-z0-9_ -]+), (?:wired|wireless)",
                "device": "tv",
                "model": ""
            }
        ]
    },
    "Great Asia": {
        "regex": "(?:E101GCM|TK_E720_EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TK_(E720)",
                "model": "TK-$1"
            },
            {
                "regex": "(E101GCM)",
                "model": "$1"
            }
        ]
    },
    "PC Smart": {
        "regex": "QUICKTAB PLUS",
        "device": "tablet",
        "model": "QuickTab Plus"
    },
    "Ephone": {
        "regex": "(?:EP19_star|EP19)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EP19_star",
                "model": "EP19 Star"
            },
            {
                "regex": "EP19",
                "model": "EP19"
            }
        ]
    },
    "SYH": {
        "regex": "Young (Y56|Y36\\+|Y[35]5|Y51\\+)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Young $1"
    },
    "YunSong": {
        "regex": "(?:YS[78]pro|YS6 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "YS([678]) ?pro",
                "model": "YS$1 Pro"
            }
        ]
    },
    "iRobot": {
        "regex": "(PALADIN EVO)",
        "device": "tablet",
        "model": "$1"
    },
    "BRAVE": {
        "regex": "(BT7X1|EX10SL4|BTXS1)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Attila": {
        "regex": "(Magic_1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Roam Cat": {
        "regex": "ROAM[_ ]CAT[ _](M8)",
        "device": "smartphone",
        "model": "$1"
    },
    "DIMO": {
        "regex": "(8800i)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "NuVision": {
        "regex": "(TM800A620M|TM101A620M)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "SANY": {
        "regex": "SANY V8",
        "device": "smartphone",
        "models": [
            {
                "regex": "SANY V8 Pro",
                "model": "V8 Pro"
            },
            {
                "regex": "SANY V8",
                "model": "V8"
            }
        ]
    },
    "Bookeen": {
        "regex": "(Cybook)[ -]Tablet(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Botech": {
        "regex": "(?:58BSE9503|WZONE)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "58BSE9503",
                "model": "58BSE9503"
            },
            {
                "regex": "WZONE",
                "model": "Wzone"
            }
        ]
    },
    "Pano": {
        "regex": "(Boom P1)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "BluSlate": {
        "regex": "BLUSLATE([67])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Educational Tablet $1"
    },
    "Lectrus": {
        "regex": "LECT-TAB(1011H?|0711)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "LECT-TAB$1"
    },
    "LeBest": {
        "regex": "(?:LeBest[_ ](?:L9)|L202206)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "L202206",
                "model": "L19 Pro"
            },
            {
                "regex": "LeBest[_ ](L9)",
                "model": "$1"
            }
        ]
    },
    "BenWee": {
        "regex": "BenWee[ _-]?(?:[^;/)]+)(?: Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "BenWee W5 ?pro",
                "model": "W5 Pro"
            },
            {
                "regex": "BenWee[ _-]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "FFF SmartLife": {
        "regex": "(?:FFFTAB10a4)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "TAB-10A4"
    },
    "Versus": {
        "regex": "(V-Pad Pop)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "NGpon": {
        "regex": "Android 4(?:[\\d.]*);(?: [\\w-]+;)? (3188HD)(?: Build|[;)])",
        "device": "tv",
        "model": "$1"
    },
    "Rupa": {
        "regex": "Pyramid A5X|RUPA[_.]smartTV",
        "device": "tv",
        "models": [
            {
                "regex": "Pyramid A5X",
                "model": "Pyramid A5X"
            },
            {
                "regex": "RUPA[_.]smartTV",
                "model": "Smart TV"
            }
        ]
    },
    "SEBBE": {
        "regex": "(S2[23])_EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Webfleet": {
        "regex": "PRO 8475(?:[);/ ]|$)",
        "device": "car browser",
        "model": "Pro 8475"
    },
    "ROiK": {
        "regex": "ROiK ?(10)(?:[);/ ]|$)",
        "device": "car browser",
        "model": "$1"
    },
    "Kinstone": {
        "regex": "(KST103SD(?:-L)?)",
        "device": "tablet",
        "model": "$1"
    },
    "HIPER": {
        "regex": "HIPER[ -](?:MEDIA|[MS]-Pad)|(?:U(?:43|50|65)YQ2200GR|H32YQ2200GR|H24YQ2200GR(?:-2)?|MEDIA TV M5)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "HIPER[ -]([SM])-Pad",
                "device": "tablet",
                "model": "$1-Pad"
            },
            {
                "regex": "MEDIA STICK 4K",
                "model": "Media Stick 4K"
            },
            {
                "regex": "MEDIA TV (i4 Pro|i4|[46]K|M5)",
                "model": "Media TV $1"
            },
            {
                "regex": "(U(?:43|50|65)YQ2200GR|H32YQ2200GR|H24YQ2200GR)",
                "model": "$1"
            }
        ]
    },
    "TopDevice": {
        "regex": "TopDevice|TDTV\\d{2}[BC][SQ]\\d{2}[FHU]|TDT45(?:18|41)_4G|TDT3778_Wi_E|TDT3887_Wi_D|TDT4528_4G_E",
        "device": "tv",
        "models": [
            {
                "regex": "(?:TopDevice_)?(TDTV\\d{2}[BC][SQ]\\d{2}[FHU])",
                "model": "$1"
            },
            {
                "regex": "TDT4518_4G",
                "device": "tablet",
                "model": "A8"
            },
            {
                "regex": "TDT4541_4G",
                "device": "tablet",
                "model": "A10"
            },
            {
                "regex": "TDT3778_Wi_E",
                "device": "tablet",
                "model": "K8"
            },
            {
                "regex": "TDT3887_Wi_D",
                "device": "tablet",
                "model": "K7"
            },
            {
                "regex": "TDT4528_4G_E",
                "device": "tablet",
                "model": "C8"
            }
        ]
    },
    "Ctroniq": {
        "regex": "(?:SNOOK-X10)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "SNOOK-X10",
                "model": "Snook X10"
            }
        ]
    },
    "Punos": {
        "regex": "Punos (10)",
        "device": "tablet",
        "model": "$1"
    },
    "ANXONIT": {
        "regex": "(AnPad_U2)",
        "device": "tablet",
        "model": "$1"
    },
    "Vityaz": {
        "regex": "(24LH1207|(?:43|5[05])LU1222|43L[FU]1204|50LU1204|43LF1212|32LH1212|32LH1221)(?:-V)?(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "VIIPOO": {
        "regex": "(?:vi20220819)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "vi20220819",
                "model": "R6"
            }
        ]
    },
    "GOODTEL": {
        "regex": "(?:G(?:3|10)_EEA|CNOTE 50|G10_US)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "G(3|10)_(?:EEA|US)",
                "model": "G$1"
            },
            {
                "regex": "CNOTE 50",
                "device": "smartphone",
                "model": "CNOTE 50"
            }
        ]
    },
    "Viper": {
        "regex": "(Z08MK)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "HAOQIN": {
        "regex": "(SpaceTab_H20)(?:_EEA)?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Advantage Air": {
        "regex": "(PIC7GS8)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "OneLern": {
        "regex": "OneLern(DB\\d{3})(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Motiv": {
        "regex": "(TurboPhone4G Compact 2108)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Olkya": {
        "regex": "Olkya (Liger 71G)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Oking": {
        "regex": "OK-(?:LS[12]|smart11|LX[56])(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "OK-smart11",
                "model": "Smart 11"
            },
            {
                "regex": "OK-(LS[12]|LX[56])",
                "model": "$1"
            }
        ]
    },
    "Inhon": {
        "regex": "Inhon[_ ](V6)(?:_EEA)?(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "SKK Mobile": {
        "regex": "(?:LYNX_LUXE|Hyper X Dragon|HYPER X BLADE(?: II)?)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LYNX_LUXE",
                "model": "Lynx Luxe"
            },
            {
                "regex": "Hyper X Dragon",
                "model": "Hyper X Dragon"
            },
            {
                "regex": "HYPER X BLADE II",
                "model": "Hyper X Blade II"
            },
            {
                "regex": "HYPER X BLADE",
                "model": "Hyper X Blade"
            }
        ]
    },
    "NeuTab": {
        "regex": "neutab ?k1(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "neutab ?k1",
                "model": "K1"
            }
        ]
    },
    "Kraft": {
        "regex": "(?:Kraft[_ -])?KTV-(\\w+)",
        "device": "tv",
        "model": "KTV-$1"
    },
    "Zoom": {
        "regex": "Android 8(?:[\\d.]*);(?: [\\w-]+;)? (LitePro)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Linsay": {
        "regex": "LINSAY[_ ]|(?:F10XIPSQ|F10XIPG)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(F10XIPSQ|F10XIPG)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "LINSAY[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Disney": {
        "regex": "(?:MARVEL|FROZEN|Toy_story)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Toy_story",
                "model": "TOY STORY"
            },
            {
                "regex": "(MARVEL|FROZEN)",
                "model": "$1"
            }
        ]
    },
    "WAF": {
        "regex": "(F808NM|F803YM)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Geant": {
        "regex": "GEANT[_ ](T\\d)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Galactic": {
        "regex": "Galactic[_ ](Astro)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Zigo": {
        "regex": "(?:Eon45i)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "Eon45i",
                "model": "Eon 45i"
            }
        ]
    },
    "AEEZO": {
        "regex": "(TK701|TK806)_EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TPS": {
        "regex": "TPS-(SC10)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Conceptum": {
        "regex": "(GoCAM_G301)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "DPA": {
        "regex": "(?:DPA_ZETA|DPA H3)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DPA_ZETA",
                "model": "Zeta"
            },
            {
                "regex": "DPA (H3)",
                "model": "$1"
            }
        ]
    },
    "SkyStream": {
        "regex": "SKYSTREAM[_ ](?:3Plus|One)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SKYSTREAM[_ ]3Plus",
                "model": "III Plus"
            },
            {
                "regex": "SKYSTREAM[_ ]One",
                "model": "One"
            }
        ]
    },
    "Skytech": {
        "regex": "LGE; ST-[0-9a-z]+;|(?:50ST3204)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "(50ST3204)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "LGE; (ST-[0-9a-z]+);",
                "model": "$1"
            }
        ]
    },
    "Supraim": {
        "regex": "(SN10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Bolva": {
        "regex": "B_TAB1021(?:[);/ ]|$)",
        "device": "tablet",
        "model": "B-TAB1021"
    },
    "DIJITSU": {
        "regex": "DIJITSU_|LGE; [0-9]{2}DW[0-9]\\d*;|(?:DCT 90)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DCT 90",
                "model": "DCT 90"
            },
            {
                "regex": "DIJITSU[_ ]Smart[_ ]A11s",
                "model": "Smart A11s"
            },
            {
                "regex": "LGE; ([0-9]{2}DW\\d*);",
                "model": "$1",
                "device": "tv"
            }
        ]
    },
    "Hathway": {
        "regex": "(DVB-ATV100)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "iLepo": {
        "regex": "ILEPO[ _](MXQ-4K)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "SEEWO": {
        "regex": "SEEWO[ _](SD02)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "TOPSHOWS": {
        "regex": "TOPSHOWS[ _-](X[19])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "KN Mobile": {
        "regex": "knmobile[_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Green Orange": {
        "regex": "(?:GO 55303)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "GO 55303",
                "model": "C5 GO"
            }
        ]
    },
    "UOOGOU": {
        "regex": "UOOGOU",
        "device": "smartphone",
        "models": [
            {
                "regex": "UOOGOU[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "MLAB": {
        "regex": "MLAB[ _-]",
        "device": "tablet",
        "models": [
            {
                "regex": "MLAB[ _-]GLOWY([78]|10)",
                "model": "Glowy $1"
            }
        ]
    },
    "Zeblaze": {
        "regex": "(THOR 4 Plus|THOR S|THOR PRO)(?:[);/ ]|$)",
        "device": "wearable",
        "models": [
            {
                "regex": "THOR (S|4 Plus)(?:[);/ ]|$)",
                "model": "Thor $1"
            },
            {
                "regex": "THOR PRO",
                "model": "Thor Pro"
            }
        ]
    },
    "noDROPOUT": {
        "regex": "NODROPOUT[_ ]",
        "device": "tablet",
        "models": [
            {
                "regex": "NODROPOUT[_ ]([^/;)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Gfone": {
        "regex": "G-Fone ?(\\d{1,3})",
        "device": "feature phone",
        "model": "$1"
    },
    "TechniSat": {
        "regex": "TechniPhone 5(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "TechniPhone 5"
    },
    "Durabook": {
        "regex": "(Diamond R8)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "DangcapHD": {
        "regex": "DangcapHD",
        "device": "tv",
        "models": [
            {
                "regex": "D8 Pro",
                "model": "D8 Pro"
            }
        ]
    },
    "Panodic": {
        "regex": "Panodic(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box"
    },
    "Panoramic": {
        "regex": "Panoramic[_ ](FQ-058/2)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Platoon": {
        "regex": "(PLT-[12]00)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Premier": {
        "regex": "(?:MAXI 20|Premier P50)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "MAXI 20",
                "model": "Maxi 20"
            },
            {
                "regex": "Premier P50",
                "model": "P50"
            }
        ]
    },
    "A95X": {
        "regex": "A95X",
        "device": "tv",
        "models": [
            {
                "regex": "A95X Plus",
                "model": "Plus"
            },
            {
                "regex": "A95X F3 Slim",
                "model": "F3 Slim"
            },
            {
                "regex": "A95X MAX \\+",
                "model": "Max+"
            },
            {
                "regex": "A95X_F3Air_II",
                "model": "F3 Air II"
            },
            {
                "regex": "A95X MAX",
                "model": "Max"
            },
            {
                "regex": "A95X PRO",
                "model": "Pro"
            },
            {
                "regex": "A95X F3 Air",
                "model": "F3 Air"
            },
            {
                "regex": "A95X ?Z2PLUS",
                "model": "Z2 Plus"
            },
            {
                "regex": "A95X[ _-]?(F[1-4]|R[1235]|[AWZ]2|A1)",
                "model": "$1"
            }
        ]
    },
    "ibowin": {
        "regex": "(M10ES11)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "MultiPOS": {
        "regex": "MultiPOS[ _]?(X9)(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "$1"
    },
    "BAFF": {
        "regex": "BAFF\\d{2}|(?:32YSTV-R|32Y-HD-R)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "BAFF(\\d{2})YFHD",
                "model": "$1Y FHD"
            },
            {
                "regex": "(?:BAFF)?(\\d{2})Y-?(STV(?:-R)?|HD-R)",
                "model": "$1Y $2"
            }
        ]
    },
    "GroBerwert": {
        "regex": "GroBerwert[ _]?(HD7)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "BARTEC": {
        "regex": "Pixavi",
        "device": "smartphone",
        "models": [
            {
                "regex": "Pixavi[ _](Phone)",
                "model": "Pixavi $1"
            }
        ]
    },
    "FOSSiBOT": {
        "regex": "(?:android 1[23](?:[\\d.]*);(?: [\\w-]+;)? (?:F10[12])|android 1[34](?:[\\d.]*);(?: [\\w-]+;)? (?:F105|S3 Pro)|F10[167] Pro|F101 P|DT[12]|F109|F112 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DT1 Lite",
                "device": "tablet",
                "model": "DT1 Lite"
            },
            {
                "regex": "(DT[12])(?:[);/ ]|$)",
                "device": "tablet",
                "model": "$1"
            },
            {
                "regex": "S3 Pro",
                "model": "S3 Pro"
            },
            {
                "regex": "F109 S",
                "model": "F109 S"
            },
            {
                "regex": "F(10[167]|112) Pro",
                "model": "F$1 Pro"
            },
            {
                "regex": "F101 P",
                "model": "F101 P"
            },
            {
                "regex": "F(10[1259])(?:[);/ ]|$)",
                "model": "F$1"
            }
        ]
    },
    "free": {
        "regex": "(?:Freebox Player Mini|Free_Wi-Kif4G_4G)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Freebox Player Mini",
                "model": "Freebox Player Mini"
            },
            {
                "regex": "Free_Wi-Kif4G_4G",
                "device": "feature phone",
                "model": "Wi-Kif 4G"
            }
        ]
    },
    "Nanho": {
        "regex": "android 7(?:[\\d.]*);(?: [\\w-]+;)? (?:F101)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "F101(?:[);/ ]|$)",
                "model": "F101"
            }
        ]
    },
    "Vekta": {
        "regex": "(LD-24SR(?:4715|4815|4850)BS|LD-65SU8815BS|LD-32SR(?:4850|4815|511[25])BS|LD-32SF4850BS|LD-39SR4815BS|LD-50SU(?:8921|8815)BS|LD-55SU8815BS|LD-43SU8821BS|LD-43SF(?:4850|4815)BS(?:-T9)?)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Accesstyle": {
        "regex": "(U43EY1500B|[FH]32EY1500B|F32EY1000B)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "SobieTech": {
        "regex": "SobieTech",
        "device": "peripheral",
        "models": [
            {
                "regex": "SOBIETECH SLP",
                "model": "Smart LED 3D Projector"
            }
        ]
    },
    "Lime": {
        "regex": "Lime(?:Z2PLUS|T95)",
        "device": "tv",
        "models": [
            {
                "regex": "LimeZ2PLUS",
                "model": "TV Box Z2+"
            },
            {
                "regex": "Lime(T95)",
                "model": "$1"
            }
        ]
    },
    "VETAS": {
        "regex": "VETAS[_ ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Canguro": {
        "regex": "(M75TG)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Gamma": {
        "regex": "(EDU-7MT4)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Xcell": {
        "regex": "(Enia)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Epic": {
        "regex": "(ePad 7i)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "AMCV": {
        "regex": "(LE-3[29]ZTHS25|LE-5[05]ZTUS30|LE-50ZTUS32|LE-43ZTFS25)(?:-[ABF])?(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Sber": {
        "regex": "(SberBox|SaluteTV|SBDV-00006)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Sveon": {
        "regex": "(SBX604)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "DSDevices": {
        "regex": "(DSCS9)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "VOLKANO": {
        "regex": "(VK-740-BL)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "A&K": {
        "regex": "(G4040)",
        "device": "feature phone",
        "model": "$1"
    },
    "BASE": {
        "regex": "BASE[_ ](Varia)",
        "device": "smartphone",
        "model": "$1"
    },
    "BAUHN": {
        "regex": "(?:BAUHN|ATV85UHDW-0122)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "ATV85UHDW-0122",
                "model": "ATV85UHDW-0122"
            }
        ]
    },
    "CKK Mobile": {
        "regex": "CKK (Inspire 1|Garnet)|(?:DUKE[78]|DUKE 3|DUKE\\s+II)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "DUKE ?([378])",
                "model": "DUKE $1"
            },
            {
                "regex": "DUKE\\s+II",
                "model": "DUKE 2"
            },
            {
                "regex": "CKK (Inspire 1|Garnet)",
                "model": "$1"
            }
        ]
    },
    "SPURT": {
        "regex": "Spurt[_ ]|(?: K700)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "(?:Spurt[_ ])?K([78]00)",
                "model": "K$1"
            }
        ]
    },
    "Z-Kai": {
        "regex": "(ZMOOTH)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Ar\xe7elik": {
        "regex": "Arcelik",
        "device": "tv",
        "model": ""
    },
    "TwinMOS": {
        "regex": "TwinTAB|(?:MQ703G)(?:_1)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(MQ703G)(?:_1)?",
                "model": "$1"
            },
            {
                "regex": "TwinTAB-(T103GQ1)",
                "model": "$1"
            }
        ]
    },
    "Getnord": {
        "regex": "Getnord[- ]([^/;)]+)(?: Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "FreeYond": {
        "regex": "(?:2305003M|2306004M|23080(?:05M|11M))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "2305003M",
                "model": "M5A"
            },
            {
                "regex": "2308005M",
                "model": "M6"
            },
            {
                "regex": "2308011M",
                "model": "M5"
            },
            {
                "regex": "2306004M",
                "model": "F9S"
            }
        ]
    },
    "N-one": {
        "regex": "(?:Npad[ _-]?(?:X1?|plus|Air|Pro|Y1|[SQ])|TAB011)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "TAB011",
                "model": "NPad Mini"
            },
            {
                "regex": "Npad[ _-]?plus",
                "model": "NPad Plus"
            },
            {
                "regex": "Npad[ _-]?Air",
                "model": "NPad Air"
            },
            {
                "regex": "Npad[ _-]?Pro",
                "model": "NPad Pro"
            },
            {
                "regex": "NpadS",
                "model": "NPad S"
            },
            {
                "regex": "NpadQ",
                "model": "NPad Q"
            },
            {
                "regex": "Npad[ _]([^/;)]+)(?: Build|[);])",
                "model": "NPad $1"
            }
        ]
    },
    "Maunfeld": {
        "regex": "(MLT(?:43|55)USD02G?|MLT32HSX02|MLT55USX02|MLT43FSX02|MQT55USD03)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "GTX": {
        "regex": "(?:GTX_)?JACULUS(?:[_ ](01|V2))?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Jaculus $1"
    },
    "SAILF": {
        "regex": "(?:20220728MT)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "I13 Pro"
    },
    "Salora": {
        "regex": "Salora(?:_cx)?[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "SmartTV;",
                "model": "Smart TV"
            }
        ]
    },
    "Dyon": {
        "regex": "DYON[;, ]",
        "device": "tv",
        "models": [
            {
                "regex": "2K Google TV",
                "model": "2K Smart TV"
            }
        ]
    },
    "Hisense": {
        "regex": "(?:HS-)?Hisense ([^;/]+) Build|Hisense|HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9-]*|HNR(?:320T|55[01]T)|E270BSA|HWCD100E|HITV300C|HITV205N|M470BS[AE]|EG98|E2281|EG680|I46D1G|HAT4KDTV|HITV10[12]C|HLTE(?:[237]00T|229T|200M|203T|202N|21[023567][TM]|22[67]T|22[13]E|230E|239E|103E|310[TM]|31[16]T|500T|501N|510[TM]|556N|7[23]0T|720E|M800)|KS(?:907|964)|U972|U601S Pro|U972_Pro|HiSmart [24]K ATV4|HiSmartTV A4",
        "device": "smartphone",
        "models": [
            {
                "regex": "E270BSA",
                "device": "tablet",
                "model": "Sero 7"
            },
            {
                "regex": "HITV10[12]C",
                "device": "tablet",
                "model": "E22"
            },
            {
                "regex": "M470BS[AE]",
                "device": "tablet",
                "model": "Sero 7 Pro"
            },
            {
                "regex": "E2281",
                "device": "tablet",
                "model": "Sero 8"
            },
            {
                "regex": "HLTE202N",
                "model": "A5"
            },
            {
                "regex": "HLTE203T",
                "model": "A5 Pro CC"
            },
            {
                "regex": "HLTE700T",
                "model": "A6"
            },
            {
                "regex": "HLTE730T",
                "model": "A6L"
            },
            {
                "regex": "HNR320T",
                "model": "A7"
            },
            {
                "regex": "HLTE556N",
                "model": "A9"
            },
            {
                "regex": "M50 Lite 2021",
                "model": "M50 Lite (2021)"
            },
            {
                "regex": "E50s \\d+GB|HLTE239E",
                "model": "E50s"
            },
            {
                "regex": "Infinity E MAX",
                "model": "Infinity E Max"
            },
            {
                "regex": "HLTE221E|E MAX(?:[);/ ]|$)",
                "model": "E Max"
            },
            {
                "regex": "HLTE501N",
                "model": "V Plus"
            },
            {
                "regex": "KS907",
                "model": "V3"
            },
            {
                "regex": "HLTE223E",
                "model": "H30"
            },
            {
                "regex": "HLTE720E",
                "model": "U30"
            },
            {
                "regex": "I46D1G",
                "model": "Smartfren Andromax R"
            },
            {
                "regex": "EG680",
                "model": "Smartfren Andromax Z"
            },
            {
                "regex": "EG98",
                "model": "Smartfren Andromax U2"
            },
            {
                "regex": "HLTE200T(?:[);/ ]|$)",
                "model": "F26"
            },
            {
                "regex": "HLTE210T(?:[);/ ]|$)",
                "model": "F28"
            },
            {
                "regex": "HLTE215T(?:[);/ ]|$)",
                "model": "F29"
            },
            {
                "regex": "HLTE213T(?:[);/ ]|$)",
                "model": "King Kong 4"
            },
            {
                "regex": "HLTE311T(?:[);/ ]|$)",
                "model": "King Kong 4 Pro"
            },
            {
                "regex": "HLTE216[TM](?:[);/ ]|$)",
                "model": "King Kong 5"
            },
            {
                "regex": "HLTE316T(?:[);/ ]|$)",
                "model": "King Kong 5 Pro"
            },
            {
                "regex": "HLTE226T(?:[);/ ]|$)",
                "model": "King Kong 6"
            },
            {
                "regex": "F8 MINI(?:[);/ ]|$)",
                "model": "F8 Mini"
            },
            {
                "regex": "HLTE217T(?:[);/ ]|$)",
                "model": "F30S"
            },
            {
                "regex": "HLTE227T(?:[);/ ]|$)",
                "model": "F40"
            },
            {
                "regex": "HNR550T(?:[);/ ]|$)",
                "model": "F50"
            },
            {
                "regex": "HNR551T(?:[);/ ]|$)",
                "model": "F50 Plus"
            },
            {
                "regex": "HLTE310[TM](?:[);/ ]|$)",
                "model": "H18"
            },
            {
                "regex": "HLTE510[TM](?:[);/ ]|$)",
                "model": "H20"
            },
            {
                "regex": "HLTE103E",
                "model": "E20"
            },
            {
                "regex": "Hisense E50 128G",
                "model": "E50"
            },
            {
                "regex": "Hisense E50 Lite 64G",
                "model": "E50 Lite"
            },
            {
                "regex": "HLTE229T",
                "model": "R7 Pro"
            },
            {
                "regex": "HLTE500T(?:[);/ ]|$)",
                "model": "H11"
            },
            {
                "regex": "(?:HLTE230E|Infinity H40 Lite)(?:[);/ ]|$)",
                "model": "Infinity H40 Lite"
            },
            {
                "regex": "HLTEM800",
                "model": "Xiaohaitun 2"
            },
            {
                "regex": "HLTE720T(?:[);/ ]|$)",
                "model": "U30",
                "device": "phablet"
            },
            {
                "regex": "HWCD100E(?:[);/ ]|$)",
                "model": "U40 Lite"
            },
            {
                "regex": "(HLTE300T|HLTE200M|HLTE212T)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "HITV300C(?:[);/ ]|$)",
                "model": "E9"
            },
            {
                "regex": "E260T\\+(?:[);/ ]|$)",
                "model": "Nana"
            },
            {
                "regex": "(U972|U601S)[ _]Pro(?:[);/ ]|$)",
                "model": "$1 Pro"
            },
            {
                "regex": "Infinity H([56]0) ZOOM(?:[);/ ]|$)",
                "model": "Infinity H$1 Zoom"
            },
            {
                "regex": "Infinity E30SE(?:[);/ ]|$)",
                "model": "Infinity E30 SE"
            },
            {
                "regex": "(HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9-]*|U972)",
                "model": "$1"
            },
            {
                "regex": "(HAT4KDTV|HiSmart [24]K ATV4|HiSmartTV A4)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Hisense;SmartTV;([a-z0-9_ -]+)V[ST];",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Hisense;SmartTV;([a-z0-9_ -]+);",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "Hisense; ?SmartTV_([0-9]{4})_1;",
                "device": "tv",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "(HE43A6500UWTS)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "HITV205N(?:[);/ ]|$)",
                "device": "portable media player",
                "model": "Touch"
            },
            {
                "regex": "KS964(?:[);/ ]|$)",
                "model": "U3 (2019)"
            },
            {
                "regex": "(?:HS-)?Hisense (U3) 2021(?: Build|[);])",
                "model": "U3 (2021)"
            },
            {
                "regex": "(?:HS-)?Hisense ([^;/)]+) Pro(?: Build|[);])",
                "model": "$1 Pro"
            },
            {
                "regex": "(?:HS-)?Hisense ([^;/)]+) Plus(?: Build|[);])",
                "model": "$1 Plus"
            },
            {
                "regex": "(?:HS-)?Hisense ([^;/)]+)(?: Build|[);])",
                "model": "$1"
            },
            {
                "regex": "(?:HS-)?Hisense ([^/]+)/",
                "model": "$1"
            }
        ]
    },
    "HiBy": {
        "regex": "(?:R6III)(?:[);/ ]|$)",
        "device": "portable media player",
        "model": "R6 Gen III"
    },
    "VOLIA": {
        "regex": "(VOL001)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Sagemcom": {
        "regex": "Sagemcom[;, \\-_]|(DIW3930|DCTIW362_PLAY)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "DCTIW362_PLAY",
                "model": "DCTIW362 Play"
            },
            {
                "regex": "(DI384|DIW350|DIW387|DIW3930)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Sagemcom[;,] ([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Sagemcom\\-OTT\\-([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Sagemcom_Broadband_SAS,([a-z0-9_ -]+),(?:wired|wireless)",
                "model": "$1"
            }
        ]
    },
    "XGEM": {
        "regex": "XGEM[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "XGEM[;,] ?([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "MeMobile": {
        "regex": "Grace (9|10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Grace $1"
    },
    "WeChip": {
        "regex": "V10(?:[);/ ]|$)",
        "device": "tv",
        "model": "V10"
    },
    "TriaPlay": {
        "regex": "TriaPlayBox(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV Box"
    },
    "AirTouch": {
        "regex": "AirTouch PERFORMANCE",
        "device": "car browser",
        "models": [
            {
                "regex": "PERFORMANCE 10x",
                "model": "Performance 10x"
            }
        ]
    },
    "Eyemoo": {
        "regex": "NXTEPaper-S1",
        "device": "tablet",
        "model": "NXT EPaper S1"
    },
    "Ajib": {
        "regex": "ajib ",
        "device": "smartphone",
        "models": [
            {
                "regex": "ajib X1",
                "model": "X1"
            },
            {
                "regex": "ajib l1",
                "model": "L1"
            },
            {
                "regex": "ajib i10",
                "model": "I10"
            }
        ]
    },
    "QWATT": {
        "regex": "(Q\\d{2}Y[FHK]-(?:M[GB]|PB))(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "HiGrace": {
        "regex": "(OC101)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "PAGRAER": {
        "regex": "(?:PAGRAER (?:P50 Pro)|PGR3042)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "PGR3042",
                "model": "A35 Pro"
            },
            {
                "regex": "PAGRAER (P50 Pro)",
                "model": "$1"
            }
        ]
    },
    "DIALN": {
        "regex": "X8ULTRA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "X8 Ultra"
    },
    "AUPO": {
        "regex": "AUPO[ _]Zeus",
        "device": "tablet",
        "models": [
            {
                "regex": "AUPO[ _]Zeus 10 Pro",
                "model": "Zeus 10 Pro"
            }
        ]
    },
    "CCIT": {
        "regex": "CCIT[_ ]|CCITA715G|(?:KT[236]00Pro)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CCIT[ _]Xedition",
                "device": "smartphone",
                "model": "X Edition"
            },
            {
                "regex": "CCIT[ _]405(?: Build|[);])",
                "model": "Vogue 405",
                "device": "smartphone"
            },
            {
                "regex": "KT([236]00)Pro",
                "model": "KT$1 Pro"
            },
            {
                "regex": "CCIT[_ ]?([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Green Lion": {
        "regex": "G-10 (?:ULTRA|PRO)|G-20ULTRA|G-8 PRO",
        "device": "tablet",
        "models": [
            {
                "regex": "G-([12]0) ?ULTRA",
                "model": "G-$1 Ultra"
            },
            {
                "regex": "G-(8|10) PRO",
                "model": "G-$1 Pro"
            }
        ]
    },
    "VANWIN": {
        "regex": "VANWIN[ -_]?(V62)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Globmall": {
        "regex": "Globmall[ _](X4)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "CALME": {
        "regex": "(?:4G (?:mega power|POWER|MAXX|Hot|Cloud|SPARK|Prime|Premium|STAR|Smart|Music|LITE)|4G[- _]Hero)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "4G mega power",
                "model": "4G Mega Power"
            },
            {
                "regex": "4G MAXX",
                "model": "4G Maxx"
            },
            {
                "regex": "4G Hot",
                "model": "4G Hot"
            },
            {
                "regex": "4G[- _]Hero",
                "model": "4G Hero"
            },
            {
                "regex": "4G SMART",
                "model": "4G Smart"
            },
            {
                "regex": "4G STAR",
                "model": "4G Star"
            },
            {
                "regex": "4G Prime",
                "model": "4G Prime"
            },
            {
                "regex": "4G SPARK",
                "model": "4G Spark"
            },
            {
                "regex": "4G Premium",
                "model": "4G Premium"
            },
            {
                "regex": "4G LITE",
                "model": "4G Lite"
            },
            {
                "regex": "4G POWER",
                "model": "4G Power"
            },
            {
                "regex": "4G Music",
                "model": "4G Music"
            },
            {
                "regex": "4G Cloud",
                "model": "4G Cloud"
            }
        ]
    },
    "GlocalMe": {
        "regex": "S20iQ19(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "S20i"
    },
    "Heimat": {
        "regex": "HEIMAT[ _](H43PU2303SVF|H65PU2303SVF)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "AngelTech": {
        "regex": "Android 8(?:[\\d.]*);(?: [\\w-]+;)? P80(?: Build|[);])",
        "device": "tablet",
        "model": "P80"
    },
    "MAGCH": {
        "regex": "(M82[01])(?:-EEA)?(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "MAG": {
        "regex": "(CRD55-UHD9|CRD65-UHD11)(?: Build|[);])",
        "device": "tv",
        "model": "$1"
    },
    "S-Color": {
        "regex": "(GT40 Ultra|SU15 Pro)(?: Build|[);])",
        "device": "tablet",
        "model": "$1"
    },
    "W&O": {
        "regex": "(?:X9 CALL2| WO (?:[789]|1[02])(?: Ultra)?|WO Pad (?:Pro|Max|\\d{2}))(?: Build|[);])",
        "device": "wearable",
        "models": [
            {
                "regex": "WO Pad Max",
                "device": "tablet",
                "model": "WO Pad Max"
            },
            {
                "regex": "WO Pad (13)",
                "device": "tablet",
                "model": "WO Pad $1"
            },
            {
                "regex": "WO ([89]) Ultra",
                "device": "tablet",
                "model": "WO$1 Ultra"
            },
            {
                "regex": "WO Pad Pro",
                "device": "tablet",
                "model": "WO Pad Pro"
            },
            {
                "regex": "WO (1[02]|[789])",
                "device": "tablet",
                "model": "WO$1"
            },
            {
                "regex": "X9 CALL2",
                "model": "X9 Call 2"
            }
        ]
    },
    "Cuiud": {
        "regex": "cuiud",
        "device": "smartphone",
        "models": [
            {
                "regex": "Cuiud F7",
                "model": "F7"
            },
            {
                "regex": "CUIUD A91",
                "model": "A91"
            }
        ]
    },
    "C Idea": {
        "regex": "CM(?:[58]22|(?:85|78)00plus)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(CM[58]22)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "CM(85|78)00plus(?:[);/ ]|$)",
                "model": "CM$100 Plus"
            }
        ]
    },
    "Daria": {
        "regex": "(DM-B50104)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "Wainyok": {
        "regex": " (P10X)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Aceline": {
        "regex": "(24HHY1|32HHY1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "CADENA": {
        "regex": "CADENA[_ ]",
        "device": "tv",
        "models": [
            {
                "regex": "CADENA[_ ]Pro[_ ]([^;/)]+)(?: Build|[);])",
                "model": "Pro $1"
            }
        ]
    },
    "Jin Tu": {
        "regex": "JIN[ _]TU[ _]([^;/)]+)(?: Build|[);])",
        "device": "peripheral",
        "model": "$1"
    },
    "Whoop": {
        "regex": "(TAB-8US2|TAB-10US)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TECHNOSAT": {
        "regex": "TECHNOSAT[ _]",
        "device": "tv",
        "models": [
            {
                "regex": "X98mini",
                "model": "X98 Mini"
            },
            {
                "regex": "TECHNOSAT[ _](W2)",
                "model": "$1"
            }
        ]
    },
    "Lville": {
        "regex": "(TPC1013)",
        "device": "tablet",
        "model": "$1"
    },
    "KENSHI": {
        "regex": "(?:Android 1[34](?:[\\d.]*);(?: [\\w-]+;)? (?:E1[01278]|E28|E38|H3[48]|H2[14]|H19|H1[14]|H44)|Pad Lite E[45]8|Armor_C1w|Armor C1 Max|Armor (?:P1(?:[sw]| Pro)|I2w|V1s|H[12]s|I1 Slim)|Kenshi[_ ]K10|Pad Pro E11[01])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "Armor I1 Slim",
                "device": "smartphone",
                "model": "Armor I1 Slim"
            },
            {
                "regex": "Armor[_ ](C1w|I2w|P1s|P1w|V1s|H[12]s|C1 Max|P1 Pro)",
                "device": "smartphone",
                "model": "Armor $1"
            },
            {
                "regex": "Kenshi[_ ](K10)(?:[);/ ]|$)",
                "model": "$1"
            },
            {
                "regex": "Pad Lite (E[45]8)",
                "model": "Pad Lite $1"
            },
            {
                "regex": "Pad Pro (E11[01])",
                "model": "Pad Pro $1"
            },
            {
                "regex": " (E1[01278]|E28|E38|H3[48]|H2[14]|H19|H1[14]|H44)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "KENWOOD": {
        "regex": "(KWSA80K)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "HOLLEBERG": {
        "regex": "HGTV-LED(\\d{2}[FU]?HDSQ?\\d{3}T2)(?:[);/ ]|$)",
        "device": "tv",
        "model": "HGTV-LED$1"
    },
    "CEPTER": {
        "regex": "CEPTER(TAB10[1L])",
        "device": "tablet",
        "model": "$1"
    },
    "SoulLink": {
        "regex": "Soullink[ _](S1)",
        "device": "tv",
        "model": "$1"
    },
    "Clovertek": {
        "regex": "Clovertek[ _](G12)",
        "device": "tablet",
        "model": "$1"
    },
    "Padpro": {
        "regex": "GT40promax",
        "device": "tablet",
        "model": "GT40 Pro Max"
    },
    "GOLDBERG": {
        "regex": "(?:EVO-VX1)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "EVO-VX1",
                "model": "EVO VX1"
            }
        ]
    },
    "Tuvio": {
        "regex": "(STV-32DHBK2R-T9|STV-32FDFBK1R|STV-65DUBK1R|STV-43FDUBK1R|TQ55UFBTV1|TD86UFBTV1|TQ50UFBCV1|TD32HF[GW]EV1|TD43FFGTV1|TD50UFGEV1|TD55UFBHV1|TD55UFGEV1|TQ65UFBCV1|TD(?:[67]5|43)UFGCV1|TD43[UF]FBHV1|TD50UF[BG]HV1|TD65UFBSV1|TD55UFGHV1|TQ65UFBHV1|TD43UFBSV1|TD32HFBHV1|TD24HFBHV1|TD43FFBSV1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "WS": {
        "regex": "(TD-TP010G-2)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "FLYCOAY": {
        "regex": "(Y121-EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "KVADRA": {
        "regex": "KVADRA_",
        "device": "tablet",
        "models": [
            {
                "regex": "KVADRA_T",
                "model": "T"
            }
        ]
    },
    "Azeyou": {
        "regex": "(AT1011E)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Azupik": {
        "regex": "Azupik",
        "device": "tablet",
        "model": ""
    },
    "ExtraLink": {
        "regex": "ESP-300(?:[);/ ]|$)",
        "device": "peripheral",
        "model": "Smart Life ESP-300"
    },
    "VNPT Technology": {
        "regex": "VNT_Tab8(?:[);/ ]|$)",
        "device": "tablet",
        "model": "VNT-Tab8"
    },
    "Arival": {
        "regex": "BioniQP116(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Bioniq P116"
    },
    "VILLAON": {
        "regex": "VILLAON[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "V6751L",
                "model": "V30 RS"
            },
            {
                "regex": "V651W",
                "model": "V40"
            },
            {
                "regex": "V651L",
                "model": "V40s"
            },
            {
                "regex": "V501W",
                "model": "V20 SE"
            },
            {
                "regex": "VILLAON[_ ]([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "VIMOQ": {
        "regex": "VIMOQ",
        "device": "smartphone",
        "models": [
            {
                "regex": "A631LO(?:[);/ ]|$)",
                "model": "A49 Play"
            },
            {
                "regex": "P662LO(?:[);/ ]|$)",
                "model": "P40"
            },
            {
                "regex": "S661LS(?:[);/ ]|$)",
                "model": "Vision 3"
            }
        ]
    },
    "Neoregent": {
        "regex": "KT1007_EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "KT1007"
    },
    "Retroid Pocket": {
        "regex": "Retroid Pocket",
        "device": "console",
        "models": [
            {
                "regex": "Pocket ([23]) ?(?:Plus|\\+)",
                "model": "$1 Plus"
            },
            {
                "regex": "Pocket 4 Pro",
                "model": "4 Pro"
            },
            {
                "regex": "Pocket ([235])",
                "model": "$1"
            }
        ]
    },
    "Renova": {
        "regex": "(TLE-(?:32|43F|50U)SBM)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "GoldStar": {
        "regex": "(LT-55U900)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "ANBERNIC": {
        "regex": "(?:RG405[VM]|RG505|RG556|RG406V|RGCUBE)(?:[);/ ]|$)",
        "device": "console",
        "models": [
            {
                "regex": "RGCUBE",
                "model": "RG Cube"
            },
            {
                "regex": "RG([0-9]{3}[A-Z]?)(?:[);/ ]|$)",
                "model": "RG$1"
            }
        ]
    },
    "ANCEL": {
        "regex": "ANCEL",
        "device": "tablet",
        "models": [
            {
                "regex": "Ancel(801)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Aocwei": {
        "regex": "(?:X900_US|X700_EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "X([79]00)_(?:EEA|US)",
                "model": "X$1"
            }
        ]
    },
    "SMUX": {
        "regex": "SMUX ?BOX A1(?:[);/ ]|$)",
        "device": "tv",
        "model": "A1"
    },
    "AAUW": {
        "regex": "Android 13(?:[\\d.]*);(?: [\\w-]+;)? (?:M50)( Build|[;)])",
        "device": "tablet",
        "model": "M50"
    },
    "Rocket": {
        "regex": "(ZC-P95)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "TYD": {
        "regex": "(TYD-109([_ ]Pro)?)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "NETWIT": {
        "regex": "NETWIT_([^;/)]+)( Build|[;)])",
        "device": "tv",
        "model": "$1"
    },
    "HongTop": {
        "regex": "HongTop",
        "device": "tv",
        "models": [
            {
                "regex": "HongTop_Projector",
                "device": "peripheral",
                "model": "Projector"
            },
            {
                "regex": "HONGTOP_box",
                "model": "Smart TV"
            }
        ]
    },
    "Orange Pi": {
        "regex": "OrangePi[_ ]?([^;/)]+)( Build|[;)])",
        "device": "peripheral",
        "model": "$1"
    },
    "VIKUSHA": {
        "regex": "(V-Z[45]0)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Atozee": {
        "regex": "(?:(?:CP20|YQ10S)_(?:MAX|Gold)|YQ10SK|AT81K|CP10)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "CP20_Gold",
                "model": "CP20 Gold"
            },
            {
                "regex": "YQ10S_MAX",
                "model": "YQ10S Max"
            },
            {
                "regex": "YQ10S_Gold",
                "model": "YQ10S Gold"
            },
            {
                "regex": "(AT81K|CP10|YQ10SK)",
                "model": "$1"
            }
        ]
    },
    "Relndoo": {
        "regex": " (TB02)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Scoole": {
        "regex": "(SL-LED\\d{2}S\\d{2}T2SU?)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "rephone": {
        "regex": "(?:2000_000170_00)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "2000_000170_00",
                "model": "rephone (Gen 1)"
            }
        ]
    },
    "BYJU'S": {
        "regex": "LRNS10GIL0(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(LRNS10GIL0)",
                "model": "$1"
            }
        ]
    },
    "BYYBUO": {
        "regex": "BYYBUO|(?:SmartPad_(?:K7|T10|A10)_(?:EU|L)|SmartPad_T10)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:BYYBUO_)?SmartPad_(K7|T10|A10)(?:_EU|_L)?",
                "model": "SmartPad $1"
            }
        ]
    },
    "Haixu": {
        "regex": "Haixu[_ ]?([^;/)]+)( Build|[;)])",
        "device": "smartphone",
        "model": "$1"
    },
    "HONKUAHG": {
        "regex": " (EV10)( Build|[;)])",
        "device": "tablet",
        "model": "$1"
    },
    "SWOFY": {
        "regex": "SWOFY[_ ]",
        "device": "portable media player",
        "models": [
            {
                "regex": "SWOFY[_ ]M503-Pro",
                "model": "M503 Pro"
            }
        ]
    },
    "Moondrop": {
        "regex": "MD-PH-001(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "MIAD01"
    },
    "Vision Technology": {
        "regex": "LGE; VS-[0-9a-z]+;|XS100MINI(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "XS100MINI(?:[);/ ]|$)",
                "model": "XS100 Mini"
            },
            {
                "regex": "LGE; (VS-[0-9a-z]+);",
                "model": "$1"
            }
        ]
    },
    "WOZIFAN": {
        "regex": "W10_EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "W10"
    },
    "Newal": {
        "regex": "NEWAL[_ ]?([^;/)]+)( Build|[;)])",
        "device": "tv",
        "model": "$1"
    },
    "Hanson": {
        "regex": "Hanson[_ ]?([^;/)]+)( Build|[;)])",
        "device": "tablet",
        "model": "$1"
    },
    "Tivax": {
        "regex": "(MiTraveler 958)",
        "device": "tablet",
        "model": "$1"
    },
    "Nordfrost": {
        "regex": "(Y-(?:4301|4001)-FHD-R)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Ringing Bells": {
        "regex": "RINGING BELLS",
        "device": "smartphone",
        "models": [
            {
                "regex": "Smart 101",
                "model": "Smart 101 4G"
            }
        ]
    },
    "Atouch": {
        "regex": "(?:S-Tab10?|M-T[34])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(M-T[34])",
                "model": "$1"
            },
            {
                "regex": "S-Tab(10?)",
                "model": "S-Tab$1"
            }
        ]
    },
    "Metz": {
        "regex": "METZ 2K TV",
        "device": "tv",
        "model": "2K Smart TV"
    },
    "EGOTEK": {
        "regex": "(EGO1003)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "ZZB": {
        "regex": "(ZB30)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Dykemann": {
        "regex": "Sternenschein (G-\\d{2})(?:[);/ ]|$)",
        "device": "tv",
        "model": "Sternenschein $1"
    },
    "BYD": {
        "regex": "For BYD AUTO",
        "device": "car browser",
        "model": "CarPad"
    },
    "ROCH": {
        "regex": "(RH-LE\\d{2}DSY-C)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "DMOAO": {
        "regex": "(?:DMOAO_)?(?:D[23]_EEA)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(?:DMOAO_)?(D[23])_EEA(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Hyatta": {
        "regex": "Model[ _](5|6s)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "Model $1"
    },
    "PVBox": {
        "regex": "PVBOX_P5_PRO",
        "device": "tv",
        "model": "P5 Pro"
    },
    "XREAL": {
        "regex": "(?:X4000)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "X4000",
                "model": "Beam Pro"
            }
        ]
    },
    "SENNA": {
        "regex": "(?:SENNA_)?(32SN6000H|43SN6000F)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "ATMPC": {
        "regex": "(?:(IT)_(701A)|IT-801B)(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(IT)[_-](701A|801B)",
                "model": "$1-$2"
            }
        ]
    },
    "Jambo": {
        "regex": " (?:JP[12])( Build|[;)])",
        "device": "smartphone",
        "models": [
            {
                "regex": "JP1",
                "model": "JamboPhone"
            },
            {
                "regex": "JP2",
                "model": "JamboPhone 2"
            }
        ]
    },
    "LYOTECH LABS": {
        "regex": "LFi ONE(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "LFi One"
    },
    "MESWAO": {
        "regex": "(MES-B[13])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "SERVO": {
        "regex": "(?:SERVO 16MAX)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "16 Max"
    },
    "COLORROOM": {
        "regex": "(K10C|C3_Pro)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "E-TACHI": {
        "regex": "(?:A5SLIM)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "A5 Slim"
    },
    "CPDEVICE": {
        "regex": "APOLLO10 PRO(?:[);/ ]|$)",
        "device": "car browser",
        "model": "Apollo 10 Pro"
    },
    "XPPen": {
        "regex": "(?:MagicDrawingPad)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Magic Drawing Pad"
    },
    "Korax": {
        "regex": "Korax|era8K Pro(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "era8K Pro",
                "model": "era8K Pro"
            },
            {
                "regex": "Korax[_ -]?([^;/)]+)(?: Build|[;)])",
                "model": "$1"
            }
        ]
    },
    "Ehlel": {
        "regex": "Ehlel[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "Ehlel C7 PRO",
                "model": "Modun C7 Pro"
            }
        ]
    },
    "Hemilton": {
        "regex": "Tab1000(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Pro Tab 1000"
    },
    "Umiio": {
        "regex": "P60_Ultra_5G(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "P60_Ultra_5G",
                "model": "P60 Ultra 5G"
            }
        ]
    },
    "Adreamer": {
        "regex": "LeoPad[_ ]10[XS]?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "LeoPad[_ ](10[XS])",
                "model": "LeoPad $1"
            },
            {
                "regex": "LeoPad[_ ]10",
                "model": "LeoPad 10"
            }
        ]
    },
    "RENSO": {
        "regex": "(?:NEP N(?:11?|9))(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "NEP N(11?|9)",
                "model": "Nep N$1"
            }
        ]
    },
    "AZOM": {
        "regex": "AZOM[_ ]",
        "device": "smartphone",
        "models": [
            {
                "regex": "River 1",
                "model": "River 1"
            }
        ]
    },
    "DUDU AUTO": {
        "regex": "DUDU(\\d)",
        "device": "car browser",
        "model": "DUDU$1"
    },
    "Temigereev": {
        "regex": "TG ?(15|30)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "TG $1"
    },
    "Biegedy": {
        "regex": "B(2[1239])(?:_U)?_(?:EEA|US)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "B$1"
    },
    "Blackphone": {
        "regex": "(?:BLACKPHONE_Blackphone_K330_3G)(?:[);/ ]|$)",
        "device": "feature phone",
        "model": "K330"
    },
    "Blackton": {
        "regex": "Bt[_ -](\\d{2}FSU?\\d{2}B)(?:[);/ ]|$)",
        "device": "tv",
        "model": "Bt $1"
    },
    "Eudora": {
        "regex": "(?:E65 Pro)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "E65 Pro"
    },
    "Acepad": {
        "regex": "(?:A130[_-]202[34])(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "A130[_-](202[34])",
                "model": "A130 ($1)"
            }
        ]
    },
    "PLDT": {
        "regex": "Aura[_ ]TELPAD[_ ]MT7",
        "device": "tablet",
        "models": [
            {
                "regex": "Aura[_ ]TELPAD[_ ]MT7",
                "device": "peripheral",
                "model": "TelPad MT7"
            }
        ]
    },
    "MEGAMAX": {
        "regex": "MEGAMAX(?:_W_)?(\\d{2}MG11FSM)",
        "device": "tv",
        "model": "$1"
    },
    "PRISM+": {
        "regex": "PrismPlus",
        "device": "tv",
        "models": [
            {
                "regex": "(\\d)K Pro Android TV",
                "model": "$1K Pro Smart TV"
            }
        ]
    },
    "SINGER": {
        "regex": "SINGER",
        "device": "tv",
        "models": [
            {
                "regex": "4K GSMART TV",
                "model": "4K Smart TV"
            },
            {
                "regex": "SINGER ANDROID TV",
                "model": "Smart TV"
            }
        ]
    },
    "Everfine": {
        "regex": "(32EVF5000S)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Elista": {
        "regex": "(B50UHD4EKC)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Horion": {
        "regex": "(WEE5-75EU-FDVB)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "ZIFFLER": {
        "regex": "(65W600U)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Dora": {
        "regex": "(65DYW60)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Weston": {
        "regex": "(65WS3205)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Viendo": {
        "regex": "(V65G2)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "simfer": {
        "regex": "(43SFSW4M)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Stilevs": {
        "regex": "STILEVS|ST65SMWOS4K(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "ST65SMWOS4K",
                "model": "ST65SMWOS4K"
            },
            {
                "regex": "STILEVS SMART TV(?:[);/ ]|$)",
                "model": "Smart TV"
            }
        ]
    },
    "TV+": {
        "regex": "(?:TVPLUS BOX)(?:[);/ ]|$)",
        "device": "tv",
        "model": "Smart TV"
    },
    "G-Guard": {
        "regex": "G Guard",
        "device": "tv",
        "models": [
            {
                "regex": "SMART TV",
                "model": "Smart TV"
            }
        ]
    },
    "Altibox": {
        "regex": "Altibox",
        "device": "tv",
        "model": "Smart TV"
    },
    "Supermax": {
        "regex": "Supermax",
        "device": "tv",
        "models": [
            {
                "regex": "MX11 prime",
                "model": "MX11 Prime"
            }
        ]
    },
    "WildRed": {
        "regex": "(42QWS9001|32QWS9002)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "LUO": {
        "regex": "LU-(V78)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "hoco": {
        "regex": "hoco[_ -]?([^;/)]+)( Build|[;)])",
        "device": "tablet",
        "model": "$1"
    },
    "SOWLY": {
        "regex": "AG_1088_(A133P?|A523P)",
        "device": "tablet",
        "model": "$1"
    },
    "HAVIT": {
        "regex": "HAVIT",
        "device": "peripheral",
        "models": [
            {
                "regex": "PJ209 PRO",
                "model": "PJ209 Pro"
            }
        ]
    },
    "CONSUNG": {
        "regex": "(N101[AB])(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "FONTEL": {
        "regex": "(FT1000|FT800)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Romsat": {
        "regex": "(43FSQ2020T2|32HSQ1220T2)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Icone Gold": {
        "regex": "(SWU-6522)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "KMC": {
        "regex": "(K22M43298U)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Gazal": {
        "regex": "Gazal_100|(GA50F-OS)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "Gazal_100MIX",
                "model": "100 Mix"
            },
            {
                "regex": "Gazal_100",
                "model": "100"
            },
            {
                "regex": "(GA50F-OS)",
                "model": "$1"
            }
        ]
    },
    "Galatec": {
        "regex": "(TVS-SU5007)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "CUD": {
        "regex": "CUD (GO) (2024)",
        "device": "smartphone",
        "model": "$1 ($2)"
    },
    "RAZZ": {
        "regex": "(C50USY24F|K55USY23|H43QSY24F)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "McLaut": {
        "regex": "McLaut TV(?:[);/ ]|$)",
        "device": "tv",
        "model": "Smart TV"
    },
    "MORTAL": {
        "regex": "Mortal (T1)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "JUSYEA": {
        "regex": "(J10)_(?:EEA|US)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "Trecfone": {
        "regex": "17_Pro_Max(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "17 Pro Max"
    },
    "Spider": {
        "regex": "RED ([1369]0)(?:[);/ ]|$)",
        "device": "tv",
        "model": "Red $1"
    },
    "Denka": {
        "regex": "DENKA TV",
        "device": "tv",
        "model": "Smart TV"
    },
    "Dawlance": {
        "regex": "DAWLANCE[ _]",
        "device": "tv",
        "models": [
            {
                "regex": "GSMART 4KTV",
                "model": "4K Smart TV"
            }
        ]
    },
    "Sambox": {
        "regex": "SAMBOX[_ ]|KM22(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "SAMBOX_KM_35_PRO",
                "model": "KM35 Pro"
            },
            {
                "regex": "KM(22)",
                "model": "KM$1"
            }
        ]
    },
    "Nesons": {
        "regex": "(N50HQ2305SVF|N43HQ2304SVF|N32HR2301SF|N32HF2302SF)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Cogeco": {
        "regex": "(?:EPICO 4K)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "EPICO 4K",
                "model": "Epico 4K Cloud PVR"
            }
        ]
    },
    "Caixun": {
        "regex": "(?:CAIXUN AndroidTV)(?:[);/ ]|$)",
        "device": "tv",
        "models": [
            {
                "regex": "CAIXUN AndroidTV",
                "model": "Smart TV"
            }
        ]
    },
    "EcoStar": {
        "regex": "(?:EcostarTV)(?:[);/ ]|$)",
        "device": "tv",
        "model": "Smart TV"
    },
    "Fision": {
        "regex": "(?:Fision TV Plus)(?:[);/ ]|$)",
        "device": "tv",
        "model": "TV+"
    },
    "MULTYNET": {
        "regex": "MULTYNET FHD",
        "device": "tv",
        "model": "Smart TV"
    },
    "andersson": {
        "regex": "(TBX11)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "AileTV": {
        "regex": "AILETV",
        "device": "tv",
        "model": "Smart TV"
    },
    "DuoTV": {
        "regex": "duoTV",
        "device": "tv",
        "model": "Smart TV"
    },
    "Indurama": {
        "regex": "INDURAMA",
        "device": "tv",
        "model": "Smart TV"
    },
    "Magenta": {
        "regex": "MagentaTV",
        "device": "tv",
        "models": [
            {
                "regex": "MagentaTV ONE \\(2",
                "model": "TV One (Gen 2)"
            },
            {
                "regex": "MagentaTV ONE",
                "model": "TV One"
            },
            {
                "regex": "MagentaTV Box",
                "model": "TV Box"
            }
        ]
    },
    "Nexar": {
        "regex": "NTV[-_](U50C614S|H43C612N)(?:[);/ ]|$)",
        "device": "tv",
        "model": "NTV-$1"
    },
    "Qupi": {
        "regex": "Qupi TV",
        "device": "tv",
        "models": [
            {
                "regex": "Qupi TV Start",
                "model": "TV Start"
            }
        ]
    },
    "Sencrom": {
        "regex": "SENCROM",
        "device": "tv",
        "models": [
            {
                "regex": "Redrobox 4K PLUS",
                "model": "Redro Box 4K Plus"
            }
        ]
    },
    "InfinityPro": {
        "regex": "InfinityProTV",
        "device": "tv",
        "model": "Smart TV"
    },
    "HOMII": {
        "regex": "XBOOK_12(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "XBOOK_12",
                "model": "XBOOK 12"
            }
        ]
    },
    "NOVIS": {
        "regex": "(NTV-H3230TS)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "ApoloSign": {
        "regex": "(EM103A)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "V7": {
        "regex": "(BUV7TBLT10A)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "KGTEL": {
        "regex": "(Nova_10_Pro_4G)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "LUNNEN": {
        "regex": "Lunnen|TL65611S01|TL4648S01",
        "device": "tablet",
        "models": [
            {
                "regex": "Ground (11|10\\.4)",
                "model": "Ground $1"
            },
            {
                "regex": "TL65611S01",
                "model": "Ground 11"
            },
            {
                "regex": "TL4648S01",
                "model": "Ground 8.4"
            }
        ]
    },
    "Qiuwoky": {
        "regex": "(?:Android 14(?:[\\d.]*);(?: [\\w-]+;)? (?:C10S))(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(C10S)",
                "model": "$1"
            }
        ]
    },
    "ZIOVO": {
        "regex": "(Z168)_EEA(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "XB": {
        "regex": "(XB-T11i)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "KTC": {
        "regex": "(55UE-BYVB)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Tricolor": {
        "regex": "(K43UH90[12]|K32HH902|H32H500[01]SA)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Vitumi": {
        "regex": "Vitumi[_ ]",
        "device": "tablet",
        "models": [
            {
                "regex": "Vitumi 10.1",
                "model": "Kids TV46410B01 10.1\""
            }
        ]
    },
    "G-Vill": {
        "regex": "(G1000 Pro|G[12]000)(?:[);/ ]|$)",
        "device": "tablet",
        "model": "$1"
    },
    "VASOUN": {
        "regex": "(L10-T11|L10_T08)(?:[_-]EEA)?(?:[);/ ]|$)",
        "device": "tablet",
        "models": [
            {
                "regex": "(L10)[_-](T11|T08)",
                "model": "$1-$2"
            }
        ]
    },
    "GlobalSec": {
        "regex": "GLOBALSEC TAB TEN(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Tab Ten"
    },
    "ACD": {
        "regex": "ACD-Tab-10S",
        "device": "tablet",
        "model": "Tab 10S"
    },
    "RunGee": {
        "regex": "RunGee X9",
        "device": "smartphone",
        "model": "X9"
    },
    "VOIX": {
        "regex": "VOIX[_](U10)(?:[);/ ]|$)",
        "device": "smartphone",
        "model": "$1"
    },
    "YIKEMI": {
        "regex": "Pad6 PLUS(?:[);/ ]|$)",
        "device": "tablet",
        "model": "Pad 6 Plus"
    },
    "Eplutus": {
        "regex": "(AN-232)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "waipu.tv": {
        "regex": "waipu tv stick(?:[);/ ]|$)",
        "device": "tv",
        "model": "4K Stick"
    },
    "AI+": {
        "regex": "AI\\+ ([^);/]+)( Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "Edanix": {
        "regex": "(Rocky_MT1)( Build|[);])",
        "device": "smartphone",
        "model": "$1"
    },
    "BNCF": {
        "regex": "BPad_Mini_SE(?:[);/ ]|$)",
        "device": "tablet",
        "model": "BPad Mini SE"
    },
    "T\xfcrksat": {
        "regex": "(KF-1500)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Genius Devices": {
        "regex": "GD (S1 ATV)(?:[);/ ]|$)",
        "device": "tv",
        "model": "$1"
    },
    "Unknown": {
        "regex": "Plasma Mobile|WebTV/(\\d+\\.\\d+)|PC; OpenHarmony|TV Bro| BOX|BOX | BOX |roku|YouView|DirectFB|avdn/|wired|wireless|AndroidTV|cordova-amazon-fireos|wv-atv|SDSTB|SDOTT|(?:M10 Ultra|FO-R15|TVBOX|Smart[ _-]?TV|SmartATV|M8S\\+ 4K|PCBox|rk(?:3128|322x|3368)(?:[_-]box)?|H10 PLAY|Smart AIO TV|TVBOX_L|L-BOX|TVBOX-5G|mips.+(?:Opera TV|wireless|wired)|smartbox|TV BOX|BOX TV|I12Pro Max|(?:audi_)?ks1280x480|AT&T TV|RealtekATV|AOSP on r33a0|tv001 on rtd289x|hx322x_box|X98_S500|8K3528-T|MX10|V88|H8S|X92|AI PONT|tv\\.plus|WayDroid x86_64 Device|MediaBox|Cloud Phone|HK1RBOX-X4)(?:[);/ ]|$)",
        "device": "smartphone",
        "models": [
            {
                "regex": "LGE; ([a-z0-9-]+);",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "WebTV/(\\d+\\.\\d+)",
                "device": "tv",
                "model": "Web TV"
            },
            {
                "regex": "M10 Ultra(?:[);/ ]|$)",
                "device": "phablet",
                "model": "M10 Ultra"
            },
            {
                "regex": "(FO-R15|X98_S500|8K3528-T|MX10|V88|H8S|X92|AI PONT)(?:[);/ ]|$)",
                "device": "tv",
                "model": "$1"
            },
            {
                "regex": "BOX|BOX | BOX |roku|YouView|DirectFB|avdn/|wired|wireless|AndroidTV|cordova-amazon-fireos|wv-atv|SDSTB|SDOTT|(Smart[ _-]?TV|SmartATV|PCBox|hx322x_box|rk(?:3128|322x|3368)(?:[_-]box)?|TVBOX|Smart AIO TV|TVBOX_L|L-BOX|TVBOX-5G|AT&T TV|RealtekATV|TV Bro|AOSP on r33a0|tv001 on rtd289x|tv.plus|MediaBox|HK1RBOX-X4)(?:[);/ ]|$)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "M8S\\+ 4K(?:[);/ ]|$)",
                "device": "tv",
                "model": "M8S+ 4K"
            },
            {
                "regex": "H10 PLAY(?:[);/ ]|$)",
                "device": "tv",
                "model": "H10 Play"
            },
            {
                "regex": "(?:Opera TV|wireless|wired|smartbox|TV BOX|BOX TV)(?:[);/ ]|$)",
                "device": "tv",
                "model": ""
            },
            {
                "regex": "I12Pro Max(?:[);/ ]|$)",
                "model": "i12 Pro Max"
            },
            {
                "regex": "(?:audi_)?ks1280x480",
                "device": "car browser",
                "model": "Audi KS"
            },
            {
                "regex": "WayDroid x86_64 Device",
                "device": "desktop",
                "model": ""
            },
            {
                "regex": "PC; OpenHarmony",
                "device": "desktop",
                "model": ""
            }
        ]
    }
};

});

parcelRegister("fmsQW", function(module, exports) {
module.exports = {
    "Acer": {
        "regex": "FBMD/(?:Aspire E5-421G|Z5WAL|One S1003);",
        "device": "desktop",
        "models": [
            {
                "regex": "FBMD/Aspire E5-421G;",
                "model": "Aspire E5-421G"
            },
            {
                "regex": "FBMD/Z5WAL;",
                "model": "Aspire E5-511"
            },
            {
                "regex": "FBMD/One S1003;",
                "model": "One 10"
            }
        ]
    },
    "Asus": {
        "regex": "FBMD/(?:K50IN|K54L|T100HAN|T103HAF|UX360CAK|X550LB|X553MA|X555LN|X556UQK);",
        "device": "desktop",
        "models": [
            {
                "regex": "FBMD/K50IN;",
                "model": "K50IN"
            },
            {
                "regex": "FBMD/K54L;",
                "model": "K54L"
            },
            {
                "regex": "FBMD/T100HAN;",
                "model": "Transformer Book"
            },
            {
                "regex": "FBMD/T103HAF;",
                "model": "Transformer Mini"
            },
            {
                "regex": "FBMD/UX360CAK;",
                "model": "ZenBook Flip"
            },
            {
                "regex": "FBMD/X550LB;",
                "model": "X550LB"
            },
            {
                "regex": "FBMD/X553MA;",
                "model": "X553MA"
            },
            {
                "regex": "FBMD/X555LN;",
                "model": "X555LN"
            },
            {
                "regex": "FBMD/X556UQK;",
                "model": "X556UQK"
            }
        ]
    },
    "Alienware": {
        "regex": "FBMD/(?:Alienware [0-9]{2,3}R[0-9]{1,2}|Area-51m|R3|R4|Alienware Aurora R[0-9]+(:? [0-9]+)?);",
        "device": "desktop",
        "models": [
            {
                "regex": "Alienware 15R3;",
                "model": "Alienware 15 R3"
            },
            {
                "regex": "Alienware 17R4;",
                "model": "Alienware 17 R4"
            },
            {
                "regex": "Area-51m;",
                "model": "Area-51m"
            },
            {
                "regex": "Aurora (R[0-9]+)",
                "model": "Aurora $1"
            }
        ]
    },
    "Dell": {
        "regex": "FBMD/(?:Latitude E4300|Inspiron 3541|XPS 15 95[35]0);",
        "device": "desktop",
        "models": [
            {
                "regex": "Latitude E4300",
                "model": "Latitude E4300"
            },
            {
                "regex": "Inspiron 3541",
                "model": "Inspiron 3541"
            },
            {
                "regex": "XPS 15 9530",
                "model": "XPS 15 9530"
            },
            {
                "regex": "XPS 15 9550",
                "model": "XPS 15 9550"
            }
        ]
    },
    "HP": {
        "regex": "FBMD/((?:Compaq|HP) |23-f364)",
        "device": "desktop",
        "models": [
            {
                "regex": "Compaq Presario CQ61 Notebook PC",
                "model": "Compaq Presario CQ61"
            },
            {
                "regex": "HP Pavilion x2 Detachable",
                "model": "Pavilion x2"
            },
            {
                "regex": "HP Laptop 15-bs0xx",
                "model": "15 Laptop PC"
            },
            {
                "regex": "HP ENVY x360 Convertible 15-bp0xx",
                "model": "ENVY x360 Convertible PC"
            },
            {
                "regex": "HP EliteBook (25[67]0p)",
                "model": "EliteBook $1"
            },
            {
                "regex": "HP ProBook (440 G5|6[35]60b)",
                "model": "ProBook $1"
            },
            {
                "regex": "HP Pavilion dv6 Notebook PC",
                "model": "Pavilion dv6"
            },
            {
                "regex": "HP Pavilion Notebook",
                "model": "Pavilion"
            },
            {
                "regex": "HP Spectre x360 Convertible",
                "model": "Spectre x360"
            },
            {
                "regex": "HP Pavilion All-in-One 24-r0xx",
                "model": "Pavilion 24-r0xx All-in-One Desktop PC",
                "device": "desktop"
            },
            {
                "regex": "23-f364",
                "model": "Pavilion TouchSmart 23-f364 All-in-One Desktop PC",
                "device": "desktop"
            }
        ]
    },
    "Lenovo": {
        "regex": "FBMD/(?:37021C5|80E5|80SM|80VR);",
        "device": "desktop",
        "models": [
            {
                "regex": "FBMD/37021C5;",
                "model": "ThinkPad Helix 3702"
            },
            {
                "regex": "FBMD/80E5;",
                "model": "G50-80"
            },
            {
                "regex": "FBMD/80SM;",
                "model": "Ideapad 310-15ISK"
            },
            {
                "regex": "FBMD/80VR;",
                "model": "Legion Y720"
            }
        ]
    },
    "Schneider": {
        "regex": "FBMD/SCL141CTP;",
        "device": "desktop",
        "model": "Notebook 14\" Cherry Trail"
    },
    "Thomson": {
        "regex": "FBMD/TH360R12\\.32CTW;",
        "device": "desktop",
        "model": "Prestige TH-360R12.32CTW"
    },
    "Toshiba": {
        "regex": "FBMD/Satellite ",
        "device": "desktop",
        "models": [
            {
                "regex": "Satellite (A[25]00|C650|C855|L650|S855)",
                "model": "Satellite $1"
            },
            {
                "regex": "Satellite ([^;\\)]+);",
                "model": "Satellite $1"
            }
        ]
    }
};

});

parcelRegister("jO8RA", function(module, exports) {
module.exports = {
    "Airties": {
        "regex": "Airties",
        "device": "tv",
        "models": [
            {
                "regex": "Airties; ?([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "ALDI NORD": {
        "regex": "ALDINORD[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "ALDI S\xdcD": {
        "regex": "ALDISUED[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "ALDISUED, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": ""
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Altech UEC": {
        "regex": "Altech UEC",
        "device": "tv",
        "models": [
            {
                "regex": "Altech UEC; ?([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "Altimo": {
        "regex": "ALTIMO[;,]",
        "device": "tv",
        "model": ""
    },
    "Altus": {
        "regex": "Altus[;,)]",
        "device": "tv",
        "model": ""
    },
    "Amazon": {
        "regex": "Amazon.+AMZ",
        "device": "tv",
        "models": [
            {
                "regex": "Amazon.+AMZ-([a-z0-9_ -]+)_Build_",
                "model": "$1"
            }
        ]
    },
    "andersson": {
        "regex": "ANDERSSON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "AOC": {
        "regex": "AOC",
        "device": "tv",
        "models": [
            {
                "regex": "(LE(?:32|43)S5970(?:s)?-(?:20|28|30)|LE55U7970-30|LE43S5977-20|U60856|S50856)",
                "model": "$1"
            },
            {
                "regex": "AOC;([a-z0-9_ \\-/]+);",
                "model": "$1"
            }
        ]
    },
    "ARRIS": {
        "regex": "ARRIS[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "FS-ARS-01B",
                "model": "FS-ARS-01B"
            }
        ]
    },
    "Atlantic Electrics": {
        "regex": "ATLANTIC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Atvio": {
        "regex": "ATVIO",
        "device": "tv",
        "models": [
            {
                "regex": "55D1620",
                "model": "55D1620"
            }
        ]
    },
    "AWOX": {
        "regex": "LGE/XianYou/AWOX",
        "device": "tv",
        "models": [
            {
                "regex": "LGE/XianYou/AWOX; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "AYA": {
        "regex": "AYA[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "BangOlufsen": {
        "regex": "Bangolufsen",
        "device": "tv",
        "model": "BeoVision"
    },
    "Beko": {
        "regex": "Beko[;,)]",
        "device": "tv",
        "model": ""
    },
    "Blaupunkt": {
        "regex": "Blaupunkt_UMC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "LC-65CUG8052E",
                "model": "LC-65CUG8052E"
            }
        ]
    },
    "Botech": {
        "regex": "Botech[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "(ATV R[12])",
                "model": "$1"
            }
        ]
    },
    "Bush": {
        "regex": "BUSH[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Cecotec": {
        "regex": "CECOTEC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Celcus": {
        "regex": "CELCUS[;,)]",
        "device": "tv",
        "model": ""
    },
    "Changhong": {
        "regex": "Changhong",
        "device": "tv",
        "models": [
            {
                "regex": "Changhong; ?([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "CLAYTON": {
        "regex": "CLAYTON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Continental Edison": {
        "regex": "CONTINENTAL_EDI[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "coocaa": {
        "regex": "coocaa[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "coocaa; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "CreNova": {
        "regex": "CreNova",
        "device": "tv",
        "model": "CNV001"
    },
    "Crown": {
        "regex": "CROWN[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Cultraview": {
        "regex": "Cultraview690[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "LaTivu_(?:\\d+[.\\d]+)_([0-9]{4})",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Daewoo": {
        "regex": "Daewoo[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Digihome": {
        "regex": "DIGIHOME[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "DIKOM": {
        "regex": "DIKOM[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "DIORA": {
        "regex": "DIORA[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "DMM": {
        "regex": "DMM",
        "device": "tv",
        "model": "Dreambox"
    },
    "EGL": {
        "regex": "EGL[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Elektroland": {
        "regex": "ELEKTROLAND[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "ELECTRONIA": {
        "regex": "ELECTRONIA[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "elit": {
        "regex": "ELIT[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "ENDURO": {
        "regex": "ENDURO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Essentielb": {
        "regex": "ESSENTIELB[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Express LUCK": {
        "regex": "Expressluck[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "([24]K)TV",
                "model": "$1 TV"
            }
        ]
    },
    "FINIX": {
        "regex": "FINIX[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Finlux": {
        "regex": "FINLUX[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "FITCO": {
        "regex": "FITCO, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "F&U": {
        "regex": "FU[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Fuego": {
        "regex": "FUEGO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "FUJICOM": {
        "regex": "FUJICOM[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Funai": {
        "regex": "FUNAI[;,)]",
        "device": "tv",
        "model": ""
    },
    "GN Electronics": {
        "regex": "GN_ELECTRONICS[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "GoGEN": {
        "regex": "GOGEN[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Graetz": {
        "regex": "GRAETZ[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Grundig": {
        "regex": "(OWB|(?:Amazon.+)?Grundig)",
        "device": "tv",
        "models": [
            {
                "regex": "G7",
                "model": "G7"
            },
            {
                "regex": "Amazon.+Grundig-([a-z0-9_ -]+)_Build_",
                "model": "$1"
            }
        ]
    },
    "Haier": {
        "regex": "(?:HHW_)?HAIER",
        "device": "tv",
        "models": [
            {
                "regex": "LE55X7000U",
                "model": "LE55X7000U"
            }
        ]
    },
    "Hanseatic": {
        "regex": "HANSEATIC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Hi-Level": {
        "regex": "HI-LEVEL[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "HIGH1ONE": {
        "regex": "HIGH_ONE[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Hisense": {
        "regex": "Hisense|Eurofins_Digital_Testing",
        "device": "tv",
        "models": [
            {
                "regex": "32A35EEVS",
                "model": "32A35EEVS"
            },
            {
                "regex": "40A35EEVS",
                "model": "40A35EEVS"
            },
            {
                "regex": "50ADEVTOOL",
                "model": "50ADEVTOOL"
            },
            {
                "regex": "50A53FEVS",
                "model": "50A53FEVS"
            },
            {
                "regex": "50A6101EX",
                "model": "50A6101EX"
            },
            {
                "regex": "50A683FEVS",
                "model": "50A683FEVS"
            },
            {
                "regex": "55A6100EE",
                "model": "55A6100EE"
            },
            {
                "regex": "55A69FEVS",
                "model": "55A69FEVS"
            },
            {
                "regex": "55U62QGAVT",
                "model": "55U62QGAVT"
            },
            {
                "regex": "50A6502EA",
                "model": "50A6502EA"
            },
            {
                "regex": "50A60GEVS",
                "model": "50A60GEVS"
            },
            {
                "regex": "75U9KAAT",
                "model": "75U9KAAT"
            },
            {
                "regex": "MICALIDVB6886",
                "model": "MICALIDVB6886"
            },
            {
                "regex": "(L[A-Z]{2,3}[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,6}[0-9]?[A-Z]?)",
                "model": "$1"
            },
            {
                "regex": "(H[A-Z]?[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,4})",
                "model": "$1"
            },
            {
                "regex": "SmartTV_([0-9]{4})_",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Hitachi": {
        "regex": "Hitachi[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "49D2900",
                "model": "49D2900"
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "HOFER": {
        "regex": "HOFER[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Horizon": {
        "regex": "HORIZON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "HOTACK": {
        "regex": "HOTACK",
        "device": "peripheral",
        "model": ""
    },
    "Hotel": {
        "regex": "HOTEL[;,)]",
        "device": "tv",
        "model": ""
    },
    "Humax": {
        "regex": "Humax|hdr1000s",
        "device": "tv",
        "models": [
            {
                "regex": "(HD-FOX C|HD (FOX\\+|NANO)|iCord (HD\\+|MINI|Cable)|(CX|IR)HD-5100(C|S)|HM9503HD)",
                "model": "$1"
            },
            {
                "regex": "HMS1000S",
                "model": "HMS-1000S"
            },
            {
                "regex": "FVP4000T",
                "model": "FVP-4000T"
            },
            {
                "regex": "HGS1000S",
                "model": "HGS-1000S"
            },
            {
                "regex": "HDR1000S",
                "model": "HDR-1000S"
            },
            {
                "regex": "HDR4000T",
                "model": "HDR-4000T"
            },
            {
                "regex": "Humax; ([^);/]+)",
                "model": "$1"
            }
        ]
    },
    "HUMElab": {
        "regex": "HUMELAB[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Hyundai": {
        "regex": "HYUNDAI[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Ikea": {
        "regex": "Ikea",
        "device": "tv",
        "model": ""
    },
    "Intek": {
        "regex": "Intek",
        "device": "tv",
        "models": [
            {
                "regex": "(Vantage|VT-100|VT-1)",
                "model": "$1"
            }
        ]
    },
    "Inverto": {
        "regex": "Inverto",
        "device": "tv",
        "models": [
            {
                "regex": "inverto; ([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "(Volksbox Web Edition|Volksbox Essential|Volksbox II|Volksbox)",
                "model": "$1"
            }
        ]
    },
    "JVC": {
        "regex": "AFTSO001|JVC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "AFTSO001",
                "model": "4K (2019)"
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Kalley": {
        "regex": "KALLEY[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "32D1620",
                "model": "32D1620"
            }
        ]
    },
    "Kendo": {
        "regex": "KENDO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "KUBO": {
        "regex": "KUBO[;,)]",
        "device": "tv",
        "model": ""
    },
    "Laurus": {
        "regex": "LAURUS[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Lenco": {
        "regex": "LENCO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Myros": {
        "regex": "MYROS[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Navon": {
        "regex": "NAVON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "NILAIT": {
        "regex": "NILAIT[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Aiwa": {
        "regex": "LGE/SQY/RCA",
        "device": "tv",
        "models": [
            {
                "regex": "LGE/SQY/RCA; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "AXEN": {
        "regex": "LGE/ATMACA/AXEN",
        "device": "tv",
        "models": [
            {
                "regex": "LGE/ATMACA/AXEN; ([a-z0-9]+)-",
                "model": "$1"
            }
        ]
    },
    "Dyon": {
        "regex": "LGE/KONKA/DYON",
        "device": "tv",
        "models": [
            {
                "regex": "SMART-32-X-EOS",
                "model": "Smart 32 X-EOS"
            }
        ]
    },
    "EAS Electric": {
        "regex": "EAS_ELECTRIC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Edenwood": {
        "regex": "EDENWOOD[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "ONVO": {
        "regex": "(?:SILICONPLAYER|XianYou)/ONVO",
        "device": "tv",
        "models": [
            {
                "regex": "(?:SILICONPLAYER|XianYou)/ONVO; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "DIJITSU": {
        "regex": "LGE/SILICONPLAYER/DIJITSU",
        "device": "tv",
        "models": [
            {
                "regex": "LGE/SILICONPLAYER/DIJITSU; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "simfer": {
        "regex": "LGE/WALTON/SIMFER",
        "device": "tv",
        "models": [
            {
                "regex": "LGE/WALTON/SIMFER; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "Sunny": {
        "regex": "(?:ATMACA|XianYou)/SUNNY",
        "device": "tv",
        "models": [
            {
                "regex": "(?:ATMACA|XianYou)/SUNNY; ([a-z0-9]+)-",
                "model": "$1"
            },
            {
                "regex": "(?:ATMACA|XianYou)/SUNNY.+(2018)\\)",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "(?:ATMACA|XianYou)/SUNNY;",
                "model": "Smart TV"
            }
        ]
    },
    "Kydos": {
        "regex": "KYDOS[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Skytech": {
        "regex": "LGE/WALTON/SKYTECH",
        "device": "tv",
        "models": [
            {
                "regex": "LGE/WALTON/SKYTECH; ([a-z0-9-]+);",
                "model": "$1"
            }
        ]
    },
    "LG": {
        "regex": "LGE ?;",
        "device": "tv",
        "models": [
            {
                "regex": "XU43WT180N",
                "model": "XU43WT180N"
            },
            {
                "regex": "43LJ614V-ZA",
                "model": "43LJ614V-ZA"
            },
            {
                "regex": "55SK850V-ZA",
                "model": "55SK850V-ZA"
            },
            {
                "regex": "KEY0000213F1z",
                "model": "KEY0000213F1z"
            },
            {
                "regex": "KEY0000213F",
                "model": "KEY0000213F"
            },
            {
                "regex": "KEY000000(2E|2F|3B|3F)",
                "model": "KEY000000$1"
            },
            {
                "regex": "(NetCast [0-9]{1}\\.[0-9]{1}|GLOBAL_PLAT3)",
                "model": "$1"
            },
            {
                "regex": "(OLED[0-9]{2}[A-Z0-9]{3}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "(OLED[0-9]{2}[A-Z][0-9][A-Z](?:-Z)?)",
                "model": "$1"
            },
            {
                "regex": "(OLED[0-9]{2}[A-Z0-9]{2})",
                "model": "$1"
            },
            {
                "regex": "([0-9]{2}[A-Z]{2}[0-9]{4}[A-Z0-9]{1}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "([0-9]{2}NANO[0-9]{3}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "([0-9]{2}NANO[0-9]{2})",
                "model": "$1"
            },
            {
                "regex": "LGE;? (?:HOTEL\\-TV; )?([0-9]{2}[a-z0-9]{4,9}(?:\\-[a-z]{2,3})?)",
                "model": "$1"
            },
            {
                "regex": "LGE;? ?([0-9]{2}[A-Z]{2}[0-9]{2,4}[A-Z]?)",
                "model": "$1"
            },
            {
                "regex": "LGE;? ?([0-9]{2}QNED[0-9]{3}[A-Z]{2})",
                "model": "$1"
            },
            {
                "regex": "LM21U",
                "model": "LM21U"
            },
            {
                "regex": "32LM",
                "model": "32LM"
            }
        ]
    },
    "Lifemaxx": {
        "regex": "Lifemaxx[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Linsar": {
        "regex": "LINSAR[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Loewe": {
        "regex": "Loewe",
        "device": "tv",
        "models": [
            {
                "regex": "40A35EEVS",
                "model": "40A35EEVS"
            },
            {
                "regex": "50A683FEVS",
                "model": "50A683FEVS"
            },
            {
                "regex": "([A-Z]{2}[0-9]{3})",
                "model": "$1"
            }
        ]
    },
    "Logik": {
        "regex": "DIXONS-LOGIK[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Luxor": {
        "regex": "LUXOR[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Manhattan": {
        "regex": "Manhattan",
        "device": "tv",
        "models": [
            {
                "regex": "T3",
                "model": "T3"
            }
        ]
    },
    "Medion": {
        "regex": "Medion",
        "device": "tv",
        "models": [
            {
                "regex": "MEDION, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": ""
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "MEGA VISION": {
        "regex": "MEGA_VISION[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Miray": {
        "regex": "MIRAY",
        "device": "tv",
        "models": [
            {
                "regex": "LEDM-322NIP",
                "model": "LEDM-322NIP"
            }
        ]
    },
    "Mitchell & Brown": {
        "regex": "MITCHELL_BROWN[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "MStar": {
        "regex": "MStar[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "([24])KTV18",
                "model": "$1KTV18"
            }
        ]
    },
    "MTC": {
        "regex": "MTC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "([24])K_Android_TV_V01",
                "model": "$1K Android TV"
            }
        ]
    },
    "NABO": {
        "regex": "NABO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Neo": {
        "regex": "NEO, ([a-z0-9_ -]+), (?:wired|wireless)",
        "device": "tv",
        "model": ""
    },
    "NEXON": {
        "regex": "NEXON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "NEXT": {
        "regex": "NEXT[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Nokia": {
        "regex": "NOKIA[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Nordmende": {
        "regex": "NORDMENDE[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Metz": {
        "regex": "Metz",
        "device": "tv",
        "models": [
            {
                "regex": "Metz; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "NORMANDE": {
        "regex": "NORMANDE[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "OCEANIC": {
        "regex": "OCEANIC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "ok.": {
        "regex": "OK[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Orava": {
        "regex": "ORAVA[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Panasonic": {
        "regex": "Panasonic",
        "device": "tv",
        "models": [
            {
                "regex": "TX-50JX700E",
                "model": "TX-50JX700E"
            },
            {
                "regex": "VIERA (201[1-9])",
                "model": "VIERA ($1)"
            },
            {
                "regex": "(DIGA [A-Z]{1}[0-9]{4})",
                "model": "$1"
            },
            {
                "regex": "DIGA Webkit ([A-Z]{1}[0-9]{4})",
                "model": "DIGA $1"
            },
            {
                "regex": "SmartTV(201[89]|202[0-2])",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Panasonic\\..+\\.([0-9]{4})(?:[);/ ]|$)",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Panasonic;Viera([0-9]{4});",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "_TV_[A-Z0-9_]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "PEAQ": {
        "regex": "PEAQ",
        "device": "tv",
        "model": ""
    },
    "TCL SCBC": {
        "regex": "SCBC[;,)]|_TV_[A-Z0-9_]+_TCL_SCBC",
        "device": "tv",
        "models": [
            {
                "regex": "SCBC586",
                "model": "SCBC586"
            },
            {
                "regex": "43D1850",
                "model": "43D1850"
            },
            {
                "regex": "_TV_[A-Z0-9]+_TCL_SCBC_Tbrowser_2k20",
                "model": "Smart TV (2020)"
            }
        ]
    },
    "PPDS": {
        "regex": "Philips.+([0-9]{2}H[FHOU][HKLST][0-9]{4}[^),;]+)",
        "device": "tv",
        "model": "$1"
    },
    "Philips": {
        "regex": "(?:Philips|TPVision)|NETTV/",
        "device": "tv",
        "models": [
            {
                "regex": "(?:Philips|TPVision)[,;](?: |Philips;)?((?! )[^),;]+)",
                "model": "$1"
            },
            {
                "regex": "NETTV/[0-9.]{5}",
                "model": "NetTV Series"
            }
        ]
    },
    "Polaroid": {
        "regex": "POLAROID[;,)]",
        "device": "tv",
        "model": ""
    },
    "PROFiLO": {
        "regex": "PROFILO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "Profilo[,;] ?((?! |HbbTV|MB130)[^),;/]+)",
                "model": "$1"
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "PROSONIC": {
        "regex": "PROSONIC[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Qilive": {
        "regex": "QILIVE[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "RCA Tablets": {
        "regex": "RCA;",
        "device": "tv",
        "models": [
            {
                "regex": "RCA; ([a-z0-9]+);",
                "model": "$1"
            }
        ]
    },
    "REGAL": {
        "regex": "REGAL[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Saba": {
        "regex": "Saba[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Salora": {
        "regex": "Salora(?:_cx)?[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Samsung": {
        "regex": "Samsung|Maple_2011",
        "device": "tv",
        "models": [
            {
                "regex": "SmartTV(201[2-9]|202[0-4]):([^);/]+)",
                "model": "$2"
            },
            {
                "regex": "SmartTV(201[2-9]|202[0-4])",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "Maple_2011",
                "model": "Smart TV (2011)"
            }
        ]
    },
    "SCHAUB LORENZ": {
        "regex": "SCHAUB_LORENZ[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "SCHONTECH": {
        "regex": "SCHONTECH[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "SEG": {
        "regex": "SEG[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "SEHMAX": {
        "regex": "SEHMAX[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Selevision": {
        "regex": "Selevision",
        "device": "tv",
        "models": [
            {
                "regex": "Selevision; (?:Selevision )?([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "(EMC1000i)",
                "model": "$1"
            }
        ]
    },
    "Sharp": {
        "regex": "(?:UMC-)?Sharp",
        "device": "tv",
        "models": [
            {
                "regex": "SHARP, ([a-z0-9_ -]+), (?:wired|wireless)",
                "model": ""
            },
            {
                "regex": "Sharp-([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "Sharp[,;] ?((?! |HbbTV|MB130)[^),;/]+)",
                "model": "$1"
            },
            {
                "regex": "(LE[0-9]{3}[A-Z]{0,3})",
                "model": "$1"
            },
            {
                "regex": "LC-([^);/,]+)",
                "model": "LC-$1"
            },
            {
                "regex": "BLA-43",
                "model": "BLA-43"
            },
            {
                "regex": "UMC_2KAndroidTV_2019",
                "model": "2K Android TV"
            },
            {
                "regex": "UMC_AndroidTV_2021",
                "model": "Android TV"
            },
            {
                "regex": "UMC_GoogleTV_2019",
                "model": "Google TV"
            }
        ]
    },
    "Silva Schneider": {
        "regex": "SILVA_SCHNEIDER[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Skyworth": {
        "regex": "Sky_?worth|SKW690|SWTV[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "SKWE20E21",
                "model": "SKWE20E21"
            },
            {
                "regex": "Sky_worth;([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "LaTivu_(?:\\d+[.\\d]+)_([0-9]{4})",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Smart Electronic": {
        "regex": "Smart[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "Smart; ([^);/]+)",
                "model": "$1"
            },
            {
                "regex": "([A-Z]{2}[0-9]{2}|ZAPPIX)",
                "model": "$1"
            }
        ]
    },
    "Solas": {
        "regex": "SOLAS[;,]",
        "device": "tv",
        "model": ""
    },
    "Sony": {
        "regex": "Sony",
        "device": "tv",
        "models": [
            {
                "regex": "(KDL-GR[12])",
                "model": "$1"
            },
            {
                "regex": "KDL-GN([56])",
                "model": "KDL-GN$1"
            },
            {
                "regex": "BRAVIA (VH1|4K VH2)",
                "model": "BRAVIA $1"
            },
            {
                "regex": "(K[DM]L?-?[0-9]{2}[A-Z]{1}[0-9]{4}[A-Z]{1})",
                "model": "$1"
            },
            {
                "regex": "(K[DM]L?-?[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1})",
                "model": "$1"
            },
            {
                "regex": "(K[DM]L?-?[0-9]{2}[A-Z]{1,2}[0-9]{1,5})",
                "model": "$1"
            }
        ]
    },
    "Star-Light": {
        "regex": "STAR LIGHT[;,)]",
        "device": "tv",
        "model": ""
    },
    "SULPICE TV": {
        "regex": "SULPICE_TV[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "TALBERG": {
        "regex": "TALBERG[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "TD Systems": {
        "regex": "TDSystems[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "SmartTV(2019|2020)",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Technicolor": {
        "regex": "Technicolor",
        "device": "tv",
        "models": [
            {
                "regex": "uzw4054ttg",
                "model": "UZW4054TTG"
            }
        ]
    },
    "Technika": {
        "regex": "TECHNIKA[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "TechniSat": {
        "regex": "TechniSat",
        "device": "tv",
        "models": [
            {
                "regex": "((DigiCorder|MultyVision|Digit) (ISIO S|ISIO C|ISIO))",
                "model": "$1"
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "TechnoTrend": {
        "regex": "TechnoTrend",
        "device": "tv",
        "models": [
            {
                "regex": "([A-Z]{1}-[0-9]{3})",
                "model": "$1"
            }
        ]
    },
    "Techwood": {
        "regex": "Techwood[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Telefunken": {
        "regex": "Telefunken",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "TCL": {
        "regex": "(?:Amazon.+)?TCL",
        "device": "tv",
        "models": [
            {
                "regex": "(32D1820|(?:39|55)D2900|32D2930|(?:32|43)S4900)",
                "model": "$1"
            },
            {
                "regex": "TCL[,;] ?((?! |HbbTV|MB130)[^),;/]+)",
                "model": "$1"
            },
            {
                "regex": "Amazon.+TCL-([a-z0-9_ -]+)_Build_",
                "model": "$1"
            }
        ]
    },
    "Thomson": {
        "regex": "THOMSON[,]?|THOM",
        "device": "tv",
        "models": [
            {
                "regex": "(TB28D19DHS-01|T28D18SFS-01B)",
                "model": "$1 28.0\""
            },
            {
                "regex": "(T32RTM5040|T32D18SFS-01B)",
                "model": "$1 32.0\""
            },
            {
                "regex": "(T43FSL5031|T43D18SFS-01B)",
                "model": "$1 43.0\""
            },
            {
                "regex": "(T40D18SFS-01B)",
                "model": "$1 40.0\""
            },
            {
                "regex": "(T49D18SFS-01B)",
                "model": "$1 49.0\""
            },
            {
                "regex": "(T55D18[SD]FS-01B)",
                "model": "$1 55.0\""
            },
            {
                "regex": "40FB5426",
                "model": "40FB5426"
            }
        ]
    },
    "TOKYO": {
        "regex": "TOKYO[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "TOKTCLED32S",
                "model": "TOKTCLED32S"
            }
        ]
    },
    "TUCSON": {
        "regex": "TUCSON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Turbo-X": {
        "regex": "TURBO-?X[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Top-Tech": {
        "regex": "Toptech690[;,]",
        "device": "tv",
        "models": [
            {
                "regex": "LaTivu_(?:\\d+[.\\d]+)_([0-9]{4})",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Toshiba": {
        "regex": "(?:Amazon.+)?Toshiba",
        "device": "tv",
        "models": [
            {
                "regex": "40L2600",
                "model": "40L2600"
            },
            {
                "regex": "(([0-9]{2}|DTV_)[A-Z]{2}[0-9]{1,3})",
                "model": "$1"
            },
            {
                "regex": "Amazon.+Toshiba-([a-z0-9_ -]+)_Build_",
                "model": "$1"
            },
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Tsinghua Tongfang": {
        "regex": "THTF_CVTE[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "LE40GY15",
                "model": "LE40GY15"
            }
        ]
    },
    "UNITED": {
        "regex": "UNITED[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "VANGUARD": {
        "regex": "VANGUARD[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Videoweb": {
        "regex": "videoweb|tv2n",
        "device": "tv",
        "models": [
            {
                "regex": "(tv2n)",
                "model": "$1"
            },
            {
                "regex": "(videowebtv)",
                "model": "VideoWeb TV"
            }
        ]
    },
    "Visitech": {
        "regex": "VISITECH[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "VORTEX (RO)": {
        "regex": "VORTEX[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "VOX": {
        "regex": "VOX[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Walker": {
        "regex": "WALKER[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Waltham": {
        "regex": "WALTHAM[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "We. by Loewe.": {
        "regex": "WeByLoewe[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "40A35EEVS",
                "model": "40A35EEVS"
            },
            {
                "regex": "43A71FEVS",
                "model": "43A71FEVS"
            },
            {
                "regex": "50A683FEVS",
                "model": "50A683FEVS"
            }
        ]
    },
    "WELLINGTON": {
        "regex": "WELLINGTON[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "WONDER": {
        "regex": "WONDER[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "X.Vision": {
        "regex": "X-VISION[;,)]",
        "device": "tv",
        "model": ""
    },
    "Vestel": {
        "regex": "(?:Vestel.+VESTEL|(?:BBC_CUSTOMERS|VESTEL)[;,)])",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            }
        ]
    },
    "Ar\xe7elik": {
        "regex": "Arcelik",
        "device": "tv",
        "model": ""
    },
    "XGEM": {
        "regex": "XGEM[;,)]",
        "device": "tv",
        "models": [
            {
                "regex": "XGEM[;,)] ?([a-z0-9]+)(?:[);/ ]|$)",
                "model": "$1"
            }
        ]
    },
    "Xiaomi": {
        "regex": "Amazon.+Xiaomi",
        "device": "tv",
        "models": [
            {
                "regex": "AFTANNA0",
                "model": "F2 4K (2022)"
            },
            {
                "regex": "Amazon.+Xiaomi-([a-z0-9_ -]+)_Build_",
                "model": "$1"
            }
        ]
    },
    "Unknown": {
        "regex": "OEM, ([a-z0-9_ -]+), (?:wired|wireless)|_TV_[A-Z0-9]+_([0-9]{4});|LaTivu_(?:\\d+[.\\d]+)_([0-9]{4})",
        "device": "tv",
        "models": [
            {
                "regex": "_TV_[A-Z0-9]+_([0-9]{4});",
                "model": "Smart TV ($1)"
            },
            {
                "regex": "LaTivu_(?:\\d+[.\\d]+)_([0-9]{4})",
                "model": "Smart TV ($1)"
            }
        ]
    }
};

});

parcelRegister("5wqFi", function(module, exports) {
module.exports = {
    "Telefunken": {
        "regex": "Telefunken Shell",
        "device": "tv",
        "model": ""
    },
    "JVC": {
        "regex": "JVC Shell",
        "device": "tv",
        "model": ""
    },
    "Leff": {
        "regex": "Leff Shell",
        "device": "tv",
        "model": ""
    },
    "Leben": {
        "regex": "Leben Shell",
        "device": "tv",
        "model": ""
    },
    "Lumus": {
        "regex": "LUMUS Shell",
        "device": "tv",
        "model": ""
    },
    "Erisson": {
        "regex": "Erisson[_ ]Shell",
        "device": "tv",
        "model": ""
    },
    "BBK": {
        "regex": "BBK shell",
        "device": "tv",
        "model": ""
    },
    "Novex": {
        "regex": "Novex shell",
        "device": "tv",
        "model": ""
    },
    "Digma": {
        "regex": "Digma Shell",
        "device": "tv",
        "model": ""
    },
    "AMCV": {
        "regex": "AMCV Shell",
        "device": "tv",
        "model": ""
    },
    "Mystery": {
        "regex": "Mystery Shell",
        "device": "tv",
        "model": ""
    },
    "ECON": {
        "regex": "ECON Shell",
        "device": "tv",
        "model": ""
    },
    "Starwind": {
        "regex": "Starwind Shell",
        "device": "tv",
        "model": ""
    },
    "Kvant": {
        "regex": "Kvant Shell",
        "device": "tv",
        "model": ""
    },
    "Hi": {
        "regex": "Hi Shell",
        "device": "tv",
        "model": ""
    },
    "AKIRA": {
        "regex": "AKIRA Shell",
        "device": "tv",
        "model": ""
    },
    "Loview": {
        "regex": "Loview Shell",
        "device": "tv",
        "model": ""
    },
    "Supra": {
        "regex": "Supra Shell",
        "device": "tv",
        "model": ""
    },
    "Yuno": {
        "regex": "Yuno Shell",
        "device": "tv",
        "model": ""
    },
    "TCL": {
        "regex": "TCL/TCL-",
        "device": "tv",
        "model": ""
    },
    "RCA Tablets": {
        "regex": "TCL/RCA-",
        "device": "tv",
        "model": ""
    },
    "Thomson": {
        "regex": "TCL/THOM-",
        "device": "tv",
        "model": ""
    },
    "DEXP": {
        "regex": "DEXP Shell",
        "device": "tv",
        "model": ""
    }
};

});

parcelRegister("fBeds", function(module, exports) {
module.exports = {
    "Archos": {
        "regex": "Archos.*GAMEPAD([2]?)",
        "device": "console",
        "model": "Gamepad $1"
    },
    "Microsoft": {
        "regex": "Xbox",
        "device": "console",
        "models": [
            {
                "regex": "Xbox Series X",
                "model": "Xbox Series X"
            },
            {
                "regex": "Xbox One X",
                "model": "Xbox One X"
            },
            {
                "regex": "Xbox One",
                "model": "Xbox One"
            },
            {
                "regex": "XBOX_ONE_ED",
                "model": "Xbox One S"
            },
            {
                "regex": "Xbox",
                "model": "Xbox 360"
            }
        ]
    },
    "Nintendo": {
        "regex": "Nintendo (([3]?DS[i]?)|Wii[U]?|Switch|GameBoy)",
        "device": "console",
        "model": "$1"
    },
    "OUYA": {
        "regex": "OUYA",
        "device": "console",
        "model": "OUYA"
    },
    "Sanyo": {
        "regex": "Aplix_SANYO",
        "device": "console",
        "model": "3DO TRY"
    },
    "Sega": {
        "regex": "Dreamcast|Aplix_SEGASATURN",
        "device": "console",
        "models": [
            {
                "regex": "Dreamcast",
                "model": "Dreamcast"
            },
            {
                "regex": "Aplix_SEGASATURN",
                "model": "Saturn"
            }
        ]
    },
    "JXD": {
        "regex": "JXD_S601WIFI",
        "device": "console",
        "model": "S601 WiFi"
    },
    "Sony": {
        "regex": "(?:PlayStation ?(4 Pro|[2-5]|Portable|Vita)|sony_tv;ps5;|\\(PS3\\))",
        "device": "console",
        "models": [
            {
                "regex": "sony_tv;ps5;",
                "model": "PlayStation 5"
            },
            {
                "regex": "PlayStation 4 PRO",
                "model": "PlayStation 4 Pro"
            },
            {
                "regex": "\\(PS3\\)",
                "model": "PlayStation 3"
            },
            {
                "regex": "PlayStation ?(4 Pro|[2-5]|Portable|Vita)",
                "model": "PlayStation $1"
            }
        ]
    },
    "Retroid Pocket": {
        "regex": "Retroid Pocket",
        "device": "console",
        "models": [
            {
                "regex": "Pocket ([23]) ?(?:Plus|\\+)",
                "model": "$1 Plus"
            },
            {
                "regex": "Pocket 4 Pro",
                "model": "4 Pro"
            },
            {
                "regex": "Pocket ([235])",
                "model": "$1"
            }
        ]
    }
};

});

parcelRegister("4u0TT", function(module, exports) {
module.exports = {
    "BMW": {
        "regex": "AFTLBT962E2(?:[);/ ]|$)",
        "device": "car browser",
        "models": [
            {
                "regex": "AFTLBT962E2(?:[);/ ]|$)",
                "model": "Car (2022)"
            }
        ]
    },
    "Jeep": {
        "regex": "AFTLFT962X3(?:[);/ ]|$)",
        "device": "car browser",
        "models": [
            {
                "regex": "AFTLFT962X3(?:[);/ ]|$)",
                "model": "Wagoneer"
            }
        ]
    },
    "Tesla": {
        "regex": "(?:Tesla/(?:(?:develop|feature|terminal-das-fsd-eap)-)?[0-9.]+|QtCarBrowser)",
        "device": "car browser",
        "models": [
            {
                "regex": "QtCarBrowser",
                "model": "Model S"
            },
            {
                "regex": "Tesla/[0-9.]+",
                "model": ""
            }
        ]
    },
    "MAC AUDIO": {
        "regex": "Mac Audio Spro",
        "device": "car browser",
        "models": [
            {
                "regex": "Spro",
                "model": "S Pro"
            }
        ]
    },
    "Topway": {
        "regex": "sp9853i_1h10_vmm",
        "device": "car browser",
        "models": [
            {
                "regex": "sp9853i_1h10_vmm",
                "model": "TS9"
            }
        ]
    }
};

});

parcelRegister("d31g9", function(module, exports) {
module.exports = {
    "Nikon": {
        "regex": "Coolpix S800c",
        "device": "camera",
        "model": "Coolpix S800c"
    },
    "Samsung": {
        "regex": "EK-G[CN][0-9]{3}",
        "device": "camera",
        "models": [
            {
                "regex": "EK-GN120",
                "model": "Galaxy NX"
            },
            {
                "regex": "EK-GC100",
                "model": "Galaxy Camera"
            },
            {
                "regex": "EK-GC110",
                "model": "Galaxy Camera WiFi only"
            },
            {
                "regex": "EK-GC200",
                "model": "Galaxy Camera 2"
            },
            {
                "regex": "EK-GC([0-9]{3})",
                "model": "Galaxy Camera $1"
            }
        ]
    }
};

});

parcelRegister("hI2qM", function(module, exports) {
module.exports = {
    "Apple": {
        "regex": "(?:Apple-)?iPod",
        "device": "portable media player",
        "models": [
            {
                "regex": "(?:Apple-)?iPod1[C,_]?1",
                "model": "iPod Touch 1G"
            },
            {
                "regex": "(?:Apple-)?iPod2[C,_]?1",
                "model": "iPod Touch 2G"
            },
            {
                "regex": "(?:Apple-)?iPod3[C,_]?1",
                "model": "iPod Touch 3"
            },
            {
                "regex": "(?:Apple-)?iPod4[C,_]?1",
                "model": "iPod Touch 4"
            },
            {
                "regex": "(?:Apple-)?iPod5[C,_]?1",
                "model": "iPod Touch 5"
            },
            {
                "regex": "(?:Apple-)?iPod7[C,_]?1",
                "model": "iPod Touch 6"
            },
            {
                "regex": "(?:Apple-)?iPod9[C,_]?1|iPodTouch7",
                "model": "iPod Touch 7"
            },
            {
                "regex": "(?:Apple-)?iPod",
                "model": "iPod Touch"
            }
        ]
    },
    "Cowon": {
        "regex": "COWON ([^;/]+) Build",
        "device": "portable media player",
        "model": "$1"
    },
    "FiiO": {
        "regex": "FiiO",
        "device": "portable media player",
        "models": [
            {
                "regex": "M11 Plus LTD",
                "model": "M11 Plus LTD"
            },
            {
                "regex": "FiiO M(11S|1[157]|6)",
                "model": "M$1"
            }
        ]
    },
    "Microsoft": {
        "regex": "Microsoft ZuneHD",
        "device": "portable media player",
        "model": "Zune HD"
    },
    "Panasonic": {
        "regex": "(SV-MV100)",
        "device": "portable media player",
        "model": "$1"
    },
    "Samsung": {
        "regex": "YP-(G[SIPB]?1|G[57]0|GB70D)",
        "device": "portable media player",
        "models": [
            {
                "regex": "YP-G[B]?1",
                "model": "Galaxy Player 4.0"
            },
            {
                "regex": "YP-G70",
                "model": "Galaxy Player 5.0"
            },
            {
                "regex": "YP-GS1",
                "model": "Galaxy Player 3.6"
            },
            {
                "regex": "YP-GI1",
                "model": "Galaxy Player 4.2"
            },
            {
                "regex": "YP-GP1",
                "model": "Galaxy Player 5.8"
            },
            {
                "regex": "YP-G50",
                "model": "Galaxy Player 50"
            },
            {
                "regex": "YP-GB70D",
                "model": "Galaxy Player 70 Plus"
            }
        ]
    },
    "Wizz": {
        "regex": "(DV-PTB1080)(?:[);/ ]|$)",
        "device": "portable media player",
        "model": "$1"
    },
    "Shanling": {
        "regex": "Shanling M6",
        "device": "portable media player",
        "models": [
            {
                "regex": "Shanling (M6\\(21\\))",
                "model": "$1"
            }
        ]
    },
    "Sylvania": {
        "regex": "(SLTDVD102[34])",
        "device": "portable media player",
        "model": "$1"
    },
    "KuGou": {
        "regex": "KuGou[_ -](P5)",
        "device": "portable media player",
        "model": "$1"
    },
    "Surfans": {
        "regex": "(Y57A)(?:[);/ ]|$)",
        "device": "portable media player",
        "model": "$1"
    },
    "Oilsky": {
        "regex": "Oilsky (M501|M303)(?:-Pro)?(?:[);/ ]|$)",
        "device": "portable media player",
        "models": [
            {
                "regex": "M303-Pro",
                "model": "M303 Pro"
            },
            {
                "regex": "(M501|M303)",
                "model": "$1"
            }
        ]
    },
    "Diofox": {
        "regex": "Diofox[ _](M8|M10|M508)(?:[);/ ]|$)",
        "device": "portable media player",
        "model": "$1"
    },
    "MECHEN": {
        "regex": "MECHEN",
        "device": "portable media player",
        "models": [
            {
                "regex": "MECHEN[- _]([^;/)]+)[- _]Pro(?: Build|[);])",
                "model": "$1 Pro"
            },
            {
                "regex": "MECHEN[- _]([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    },
    "Fanvace": {
        "regex": "Fanvace",
        "device": "portable media player",
        "models": [
            {
                "regex": "Fanvace[- _]([^;/)]+)(?: Build|[);])",
                "model": "$1"
            }
        ]
    }
};

});

parcelRegister("5dNRI", function(module, exports) {
module.exports = {
    "org.telegram.messenger": "Telegram",
    "org.telegram.messenger.web": "Telegram",
    "com.snapchat.android": "Snapchat",
    "info.sunista.app": "Sanista Persian Instagram",
    "com.instapro.app": "InstaPro",
    "com.tencent.mm": "WeChat",
    "com.kakao.talk": "KakaoTalk",
    "com.ayoba.ayoba": "Ayoba",
    "snapu2b.com": "SnapU2B",
    "com.facebook.katana": "Facebook",
    "com.facebook.orca": "Facebook Messenger",
    "com.yahoo.onesearch": "Yahoo OneSearch",
    "jp.co.yahoo.android.yjtop": "Yahoo! Japan",
    "it.ideasolutions.kyms": "KYMS - Keep Your Media Safe",
    "it.tolelab.fvd": "FVD - Free Video Downloader",
    "kik.android": "Kik",
    "com.tinder": "Tinder",
    "com.videochat.livu": "LivU",
    "io.metamask": "MetaMask",
    "com.totalav.android": "TotalAV",
    "com.fsecure.ms.saunalahti_m": "Elisa Turvapaketti",
    "com.fsecure.ms.ziggo": "Ziggo Safe Online",
    "com.aol.mobile.aolapp": "AOL",
    "com.fancyclean.security.antivirus": "Fancy Security",
    "com.google.android.gms": "Google Play",
    "com.appsinnova.android.keepclean": "KeepClean",
    "com.turtc": "TurTc",
    "com.sony.nfx.app.sfrc": "News Suite by Sony",
    "com.rcplatform.livechat": "Tumile",
    "jp.gocro.smartnews.android": "SmartNews",
    "com.lenovo.anyshare.gps": "SHAREit",
    "com.espn.score_center": "ESPN",
    "com.active.cleaner": "Active Cleaner",
    "com.hld.anzenbokusucal": "Calculator Photo Vault",
    "com.hld.anzenbokusufake": "Calculator Hide Photos",
    "com.hld.anzenbokusu": "Sgallery",
    "com.huawei.appmarket": "AppGallery",
    "com.michatapp.im": "MiChat",
    "com.michatapp.im.lite": "MiChat Lite",
    "com.noxgroup.app.security": "Nox Security",
    "phone.cleaner.antivirus.speed.booster": "Super Cleaner",
    "com.yy.hiyo": "Hago",
    "com.instagram.android": "Instagram",
    "com.instagram.barcelona": "Threads",
    "com.microsoft.office.outlook": "Microsoft Outlook",
    "com.microsoft.bing": "Microsoft Bing",
    "com.microsoft.bingintl": "Microsoft Bing",
    "com.nhn.android.search": "Naver",
    "com.jb.security": "GO Security",
    "com.fsecure.ms.safe": "F-Secure SAFE",
    "com.jaumo": "Jaumo",
    "com.jaumo.prime": "Jaumo Prime",
    "com.skout.android": "SKOUT",
    "com.hornet.android": "Hornet",
    "com.fsecure.ms.darty": "Darty S\xe9curit\xe9",
    "com.fsecure.ms.dc": "F-Secure Mobile Security",
    "com.fsecure.ms.swisscom.sa": "Swisscom Internet Security",
    "com.andrewshu.android.reddit": "Reddit is fun",
    "com.andrewshu.android.redditdonation": "Reddit is fun",
    "org.quantumbadger.redreader": "RedReader",
    "com.sina.weibo": "Sina Weibo",
    "com.wiseplay": "Wiseplay",
    "com.fsecure.ms.nifty": "Always Safe Security 24",
    "com.zeebusiness.news": "Zee Business",
    "com.awesapp.isp": "iSafePlay",
    "com.baidu.searchbox": "Baidu Box App",
    "hesoft.T2S": "T2S",
    "hippeis.com.photochecker": "Photo Sherlock",
    "com.thinkfree.searchbyimage": "Reverse Image Search",
    "com.tct.launcher": "Joy Launcher",
    "com.tcl.live": "TCL Live",
    "com.harshad.someto": "Social Media Explorer",
    "com.reddit.frontpage": "Reddit",
    "com.opera.app.news": "Opera News",
    "com.palmteam.imagesearch": "Search By Image",
    "com.sharekaro.app": "ShareKaro",
    "com.til.timesnews": "NewsPoint",
    "com.transsion.XOSLauncher": "XOS Launcher",
    "com.transsion.hilauncher": "HiOS Launcher",
    "com.transsion.itel.launcher": "itel Launcher",
    "com.twitter.android": "Twitter",
    "com.waze": "Waze",
    "com.tuya.smartlife": "Tuya Smart Life",
    "com.cleanmaster.mguard": "Clean Master",
    "com.cleanmaster.mguard.huawei": "Clean Master",
    "de.twokit.castbrowsernexusplayer": "TV Cast",
    "de.twokit.video.tv.cast.browser.firetv": "TV Cast",
    "de.twokit.video.tv.cast.browser.lg": "TV Cast",
    "de.twokit.video.tv.cast.browser.samsung": "TV Cast",
    "com.cleanmaster.security": "CM Security",
    "com.antivirus.master.cmsecurity": "CM Security",
    "idm.video.free": "IDM Video Download Manager",
    "mobi.deallauncher.coupons.shopping": "Coupons & Deals",
    "com.wukongtv.wkcast.intl": "Quick Cast",
    "com.tt.android.dm.view": "Download Manager",
    "com.fsecure.ms.kpn.veilig": "KPN Veilig",
    "com.fsecure.ms.actshield": "ACT Shield",
    "com.fsecure.ms.talktalksa": "TalkTalk SuperSafe",
    "com.fsecure.ms.dnafi": "DNA Digiturva",
    "com.fsecure.ms.teliasweden": "Telia Trygg",
    "com.fsecure.ms.upc.ch": "UPC Internet Security",
    "com.fsecure.ms.sfr": "SFR S\xe9curit\xe9",
    "com.fsecure.ms.sonera": "Telia Turvapaketti",
    "com.bifrostwallet.app": "Bifrost Wallet",
    "com.anydesk.anydeskandroid": "AnyDesk Remote Desktop",
    "com.google.android.youtube": "YouTube",
    "io.bluewallet.bluewallet": "BlueWallet",
    "com.google.android.apps.searchlite": "Google Go",
    "com.snaptube.premium": "SnapTube",
    "com.myhomescreen.sms": "Messenger Home",
    "com.myhomescreen.email": "Email Home",
    "com.myhomescreen.weather": "Weather Home",
    "com.myhomescreen.access": "Big Keyboard",
    "com.myhomescreen.messenger.home.emoji.lite": "Messenger Lite",
    "com.myhomescreen.fitness": "Fit Home",
    "com.myhomescreen.news": "News Home",
    "com.amazon.webapps.gms.search": "Google Search App",
    "com.huawei.fastapp": "Huawei Quick App Center",
    "com.flatfish.cal.privacy": "HideX",
    "com.sweep.cleaner.trash.junk": "Sweep",
    "com.google.android.apps.maps": "Google Maps",
    "com.box.video.downloader": "BOX Video Downloader",
    "com.oxoo.kinogo": "Kinogo.ge",
    "com.tradron.hdvideodownloader": "Download Hub",
    "net.daum.android.daum": "Daum",
    "com.massimple.nacion.gcba.es": "+Simple",
    "com.massimple.nacion.parana.es": "+Simple",
    "com.microsoft.math": "Microsoft Math Solver",
    "com.instabridge.android": "Instabridge",
    "com.repotools.whatplay": "Whatplay",
    "com.saf.seca": "SearchCraft",
    "com.huawei.hwsearch": "Petal Search",
    "com.playit.videoplayer": "PLAYit",
    "com.droidlogic.xlauncher": "X Launcher",
    "nu.bi.moya": "Moya",
    "com.microsoft.copilot": "Microsoft Copilot",
    "com.nate.android.portalmini": "nate",
    "za.co.tracker.consumer": "Tracker Connect",
    "com.larus.wolf": "Cici",
    "com.qihoo.security": "360 Security",
    "com.infinix.xshare": "XShare",
    "com.transsion.magicshow": "Visha",
    "com.bigqsys.photosearch.searchbyimage2020": "Photo Search",
    "com.stickypassword.android": "Sticky Password",
    "com.nytimes.crossword": "The Crossword",
    "castify.roku": "Castify",
    "com.castify": "Castify",
    "mojeek.app": "Mojeek",
    "org.aka.messenger": "Aka Messenger",
    "org.aka.lite": "Aka Messenger Lite",
    "the.best.gram": "Bestgram",
    "ir.ilmili.telegraph": "Graph Messenger",
    "org.torproject.android": "Orbot",
    "free.vpn.unblock.proxy.vpnmonster": "VPN Monster",
    "com.udicorn.proxy": "Blue Proxy",
    "com.v2.vpn.security.free": "V2Free",
    "com.surfshark.vpnclient.android": "Surfshark",
    "com.omshyapps.vpn": "Omshy VPN",
    "com.kuto.vpn": "KUTO VPN",
    "com.ezt.vpn": "EZVPN",
    "com.nocardteam.nocardvpn": "NoCard VPN",
    "com.nocardteam.nocardvpn.lite": "NoCard VPN Lite"
};

});

parcelRegister("7qznj", function(module, exports) {
module.exports = [
    {
        "regex": "jpameblo;(\\d+\\.[.\\d]+)",
        "name": "Ameba",
        "version": "$1"
    },
    {
        "regex": "CSDNApp/(\\d+\\.[.\\d]+)",
        "name": "CSDN",
        "version": "$1"
    },
    {
        "regex": "binu(?:/(\\d+[.\\d]+))?",
        "name": "Moya",
        "version": ""
    },
    {
        "regex": "KPN_Veilig[ /](\\d+\\.[.\\d]+)",
        "name": "KPN Veilig",
        "version": "$1"
    },
    {
        "regex": "NAVER/(\\d+[.\\d]+) CFNetwork",
        "name": "Naver",
        "version": "$1"
    },
    {
        "regex": "NAVER\\(inapp; search; .+; (\\d+[.\\d]+);.+\\)",
        "name": "Naver",
        "version": "$1"
    },
    {
        "regex": "NAVER\\(inapp; search; .+; (\\d+[.\\d]+)\\)",
        "name": "Naver",
        "version": "$1"
    },
    {
        "regex": "NAVER\\(inapp; naverdicapp; .+; (\\d+[.\\d]+)\\)",
        "name": "NAVER Dictionary",
        "version": "$1"
    },
    {
        "regex": "Chrome/Soldier_([\\d.]+)",
        "name": "Soldier",
        "version": "$1"
    },
    {
        "regex": "AndroidDownloadManager(?:[ /]([\\d.]+))?",
        "name": "AndroidDownloadManager",
        "version": "$1"
    },
    {
        "regex": "(?:Apple)?News(?:[ /][\\d.]+)? Version(?:[ /]([\\d.]+))?",
        "name": "Apple News",
        "version": "$1"
    },
    {
        "regex": "appletv\\.client",
        "name": "Apple TV",
        "version": ""
    },
    {
        "regex": "AudienceNetworkForAndroid.+(?:FBAV)(?:[ /]([\\d.]+))?",
        "name": "Facebook Audience Network",
        "version": "$1"
    },
    {
        "regex": "(?:mLite|MessengerLite(?:ForiOS)?).*(?:FBAV)(?:[ /]([\\d.]+))?",
        "name": "Facebook Messenger Lite",
        "version": "$1"
    },
    {
        "regex": "(?:MessengerForiOS|MESSENGER|FB_IAB/Orca-Android).*(?:FBAV)(?:[ /]([\\d.]+))?",
        "name": "Facebook Messenger",
        "version": "$1"
    },
    {
        "regex": "(?:GroupsForiOS).*(?:FBAV)(?:[ /]([\\d.]+))?",
        "name": "Facebook Groups",
        "version": "$1"
    },
    {
        "regex": "FBAN/EMA.+FBAV(?:[ /]([\\d.]+))?",
        "name": "Facebook Lite",
        "version": "$1"
    },
    {
        "regex": "FBAN/FBPageAdmin.+FBAV(?:[ /]([\\d.]+))?",
        "name": "Meta Business Suite",
        "version": "$1"
    },
    {
        "regex": "(?:FBAV|com\\.facebook\\.katana|facebook-mobile/1\\.0|facebook-mobile/|Facebook/)(?:[ /]([\\d.]+))?",
        "name": "Facebook",
        "version": "$1"
    },
    {
        "regex": "(?:FBAN|FBSV|FBID|FBBV)/",
        "name": "Facebook",
        "version": ""
    },
    {
        "regex": "Instagram[ /]([\\d.]+)?",
        "name": "Instagram",
        "version": "$1"
    },
    {
        "regex": "Barcelona[ /]([\\d.]+)?",
        "name": "Threads",
        "version": "$1"
    },
    {
        "regex": "FeedR(?!eader)(?:/([\\d.]+))?",
        "name": "FeedR",
        "version": "$1"
    },
    {
        "regex": "com\\.google\\.android\\.apps\\.searchlite",
        "name": "Google Go",
        "version": ""
    },
    {
        "regex": "com\\.google\\.android\\.apps\\.photos",
        "name": "Google Photos",
        "version": ""
    },
    {
        "regex": "com\\.google\\.android\\.apps\\.magazines",
        "name": "Google Play Newsstand",
        "version": ""
    },
    {
        "regex": "com\\.google\\.GooglePlus",
        "name": "Google Plus",
        "version": ""
    },
    {
        "regex": "Google\\.DriveExtension(?:/([\\d.]+))?",
        "name": "Google Drive",
        "version": "$1"
    },
    {
        "regex": "OPA/([\\d.]+)",
        "name": "Google Assistant",
        "version": "$1"
    },
    {
        "regex": "wxwork/(\\d+[.\\d]+)",
        "name": "WeCom",
        "version": "$1"
    },
    {
        "regex": "MicroMessenger/([\\d.]+)",
        "name": "WeChat",
        "version": "$1"
    },
    {
        "regex": "WeChat/([\\d.]+)",
        "name": "WeChat",
        "version": "$1"
    },
    {
        "regex": "WeChatShareExtensionNew/([\\d.]+)",
        "name": "WeChat Share Extension",
        "version": "$1"
    },
    {
        "regex": "DingTalk/([0-9.]+)",
        "name": "DingTalk",
        "version": "$1"
    },
    {
        "regex": ".*__weibo__([0-9.]+)__",
        "name": "Sina Weibo",
        "version": "$1"
    },
    {
        "regex": "Pinterest(?: for (?:Android(?: Tablet)?|iOS))?(?:/([\\d.]+))?",
        "name": "Pinterest",
        "version": "$1"
    },
    {
        "regex": "Podcatcher Deluxe",
        "name": "Podcatcher Deluxe",
        "version": ""
    },
    {
        "regex": "com\\.google\\.(?:android|ios)\\.youtube(?:/([\\d.]+))?",
        "name": "YouTube",
        "version": "$1"
    },
    {
        "regex": "YouTube/([\\d.]+)[JK]",
        "name": "YouTube",
        "version": "$1"
    },
    {
        "regex": "Rutube(?:TV)?BlackAndroid",
        "name": "Rutube",
        "version": "$1"
    },
    {
        "regex": "com\\.netflix\\.mediaclient(?:/(\\d+\\.[\\d.]+))?",
        "name": "Netflix",
        "version": "$1"
    },
    {
        "regex": "Downcast/(\\d+\\.[\\d.]+)?(?:.+(?:!Mac)|$)",
        "name": "Downcast",
        "version": "$1"
    },
    {
        "regex": "Flipp-iOS/.+CFNetwork",
        "name": "Flipp",
        "version": ""
    },
    {
        "regex": "Flipp-iOS/(\\d+[.\\d]+)",
        "name": "Flipp",
        "version": "$1"
    },
    {
        "regex": "WhatsApp(?:/2)?$",
        "name": "Signal",
        "version": ""
    },
    {
        "regex": "WhatsApp/([\\d.]+).+CloudAPI",
        "name": "WhatsApp Business",
        "version": "$1"
    },
    {
        "regex": "WhatsApp(?:Electron|\\-app|\\-linux-app)?(?:[ /]([\\d.]+))?",
        "name": "WhatsApp",
        "version": "$1"
    },
    {
        "regex": "YoWhatsApp2Plus(?:/(\\d+[.\\d]+))?",
        "name": "WhatsApp+2",
        "version": "$1"
    },
    {
        "regex": "YoFMWhatsApp(?:/(\\d+[.\\d]+))?",
        "name": "FM WhatsApp",
        "version": "$1"
    },
    {
        "regex": "(?:Yo)?GBWhatsApp(?:/(\\d+[.\\d]+))?",
        "name": "GBWhatsApp",
        "version": "$1"
    },
    {
        "regex": "YoYoWhatsApp(?:/(\\d+[.\\d]+))?",
        "name": "Yo WhatsApp",
        "version": "$1"
    },
    {
        "regex": "ANWhatsApp(?:/(\\d+[.\\d]+))?",
        "name": "AN WhatsApp",
        "version": "$1"
    },
    {
        "regex": "Telegram/(\\d+[.\\d]+) CFNetwork",
        "name": "Telegram",
        "version": ""
    },
    {
        "regex": "(?:^com\\.google\\.android\\.apps\\.youtube\\.music/|^YouTubeMusic(?:Dev)?/)([\\d.]+)?",
        "name": "Youtube Music",
        "version": "$1"
    },
    {
        "regex": "Line(?:[ /]([\\d.]+))",
        "name": "Line",
        "version": "$1"
    },
    {
        "regex": "Instacast(?:HD)?/([\\d\\.abc]+) CFNetwork/([\\d.]+) Darwin/([\\d.]+)",
        "name": "Instacast",
        "version": "$1"
    },
    {
        "regex": "Pocket Casts(?:, (?:Android|iOS) v([\\d.]+))?",
        "name": "Pocket Casts",
        "version": "$1"
    },
    {
        "regex": "Podcat/([\\d.]+)",
        "name": "Podcat",
        "version": "$1"
    },
    {
        "regex": "BeyondPod",
        "name": "BeyondPod",
        "version": ""
    },
    {
        "regex": "(?:^Overcast/([\\d.]+)|^Overcast.*Apple Watch)",
        "name": "Overcast",
        "version": "$1"
    },
    {
        "regex": "(?:CastBox|fm\\.castbox\\.audiobook\\.radio\\.podcast)/?([\\d.]+)?",
        "name": "CastBox",
        "version": "$1"
    },
    {
        "regex": "Podkicker( (?:Pro|Classic))?/([\\d.]+)",
        "name": "Podkicker$1",
        "version": "$2"
    },
    {
        "regex": "PodcastRepublic/([\\d.]+)",
        "name": "Podcast Republic",
        "version": "$1"
    },
    {
        "regex": "Castro/(\\d+)",
        "name": "Castro",
        "version": "$1"
    },
    {
        "regex": "Castro 2 ([\\d.]+)/[\\d]+ Like iTunes",
        "name": "Castro 2",
        "version": "$1"
    },
    {
        "regex": "Castro 2",
        "name": "Castro 2",
        "version": ""
    },
    {
        "regex": "DoggCatcher",
        "name": "DoggCatcher",
        "version": ""
    },
    {
        "regex": "(?:PodcastAddict/v([\\d]+)|^Podcast Addict)",
        "name": "Podcast & Radio Addict",
        "version": "$1"
    },
    {
        "regex": "Podcat(?:%202)?/([\\d]+) CFNetwork",
        "name": "Podcat",
        "version": "$1"
    },
    {
        "regex": "iCatcher[^\\d]+([\\d.]+)",
        "name": "iCatcher",
        "version": "$1"
    },
    {
        "regex": "YelpApp/([\\d.]+)",
        "name": "Yelp Mobile",
        "version": "$1"
    },
    {
        "regex": "jp\\.co\\.yahoo\\.(?:android\\.yjtop|ipn\\.appli)/([\\d.]+)",
        "name": "Yahoo! Japan",
        "version": "$1"
    },
    {
        "regex": "RSSRadio/([\\d]+)?",
        "name": "RSSRadio",
        "version": "$1"
    },
    {
        "regex": "SogouSearch Android[\\d.]+ version([\\d.]+)?",
        "name": "SogouSearch App",
        "version": "$1"
    },
    {
        "regex": "NewsArticle/([\\d.]+)?",
        "name": "NewsArticle App",
        "version": "$1"
    },
    {
        "regex": "tieba/([\\d.]+)?",
        "name": "tieba",
        "version": "$1"
    },
    {
        "regex": "com\\.douban\\.group/([\\d.]+)?",
        "name": "douban App",
        "version": "$1"
    },
    {
        "regex": "(?:com\\.google\\.GoogleMobile|GSA|GoogleApp)/([\\d.]+)?",
        "name": "Google Search App",
        "version": "$1"
    },
    {
        "regex": "Google/(\\d+[.\\d]+)? CFNetwork",
        "name": "Google Search App",
        "version": "$1"
    },
    {
        "regex": "(?:Google|SearchWith)Lens/(\\d+[.\\d]+)?",
        "name": "Google Lens",
        "version": "$1"
    },
    {
        "regex": "Flipboard/([\\d.]+)?",
        "name": "Flipboard App",
        "version": "$1"
    },
    {
        "regex": "baiduboxapp/([\\d.]+)?",
        "name": "Baidu Box App",
        "version": "$1"
    },
    {
        "regex": "baiduinput/([\\d.]+)?",
        "name": "Baidu Input",
        "version": "$1"
    },
    {
        "regex": "PetalSearch/([\\d.]+)?",
        "name": "Petal Search",
        "version": "$1"
    },
    {
        "regex": "Crosswalk(?!.*(?:Streamy|QwantMobile))/([\\d.]+)?",
        "name": "CrosswalkApp",
        "version": "$1"
    },
    {
        "regex": "Twitter for iPhone[/]?([\\d.]+)?",
        "name": "Twitter",
        "version": "$1"
    },
    {
        "regex": "Twitter/([\\d.]+)",
        "name": "Twitter",
        "version": "$1"
    },
    {
        "regex": "TwitterAndroid[/]?([\\d.]+)?",
        "name": "Twitter",
        "version": "$1"
    },
    {
        "regex": "^Pocket Casts",
        "name": "Pocket Casts",
        "version": ""
    },
    {
        "regex": "(?:^GaanaAndroid-|^Gaana-iOS|^Gaana/)([\\d.]+)?",
        "name": "Gaana",
        "version": "$1"
    },
    {
        "regex": "TopBuzz/([\\d.]+)",
        "name": "TopBuzz",
        "version": "$1"
    },
    {
        "regex": "(?:Safari/[\\d.]+)?Snapchat/?([\\d.]+)",
        "name": "Snapchat",
        "version": "$1"
    },
    {
        "regex": "CronetSnapDevSheldon",
        "name": "Snapchat",
        "version": ""
    },
    {
        "regex": "AhaRadio2/([\\d.]+)",
        "name": "Aha Radio 2",
        "version": "$1"
    },
    {
        "regex": "Unibox/([\\d.]+)",
        "name": "Unibox",
        "version": ""
    },
    {
        "regex": "strimio(?:-desktop)/(\\d+\\.(?:[.\\d]+))?",
        "name": "Strimio",
        "version": "$1"
    },
    {
        "regex": "UnityPlayer/([\\d.]+)",
        "name": "UnityPlayer",
        "version": "$1"
    },
    {
        "regex": "UCURSOS/v([\\d.]+)",
        "name": "U-Cursos",
        "version": "$1"
    },
    {
        "regex": "RobloxApp/([\\d.]+)",
        "name": "Roblox",
        "version": "$1"
    },
    {
        "regex": "Viber(?:/(\\d+[.\\d]+))?",
        "name": "Viber",
        "version": "$1"
    },
    {
        "regex": "Siri/1",
        "name": "Siri",
        "version": "1.0"
    },
    {
        "regex": "LinkedIn(?:App)?(?:\\]?/([\\d.]+))?",
        "name": "LinkedIn",
        "version": "$1"
    },
    {
        "regex": "Instapaper/([\\d.]+)",
        "name": "Instapaper",
        "version": "$1"
    },
    {
        "regex": "Keeper/([\\d.]+)",
        "name": "Keeper Password Manager",
        "version": "$1"
    },
    {
        "regex": "Skyeng Teachers/([\\d.]+)",
        "name": "Skyeng Teachers",
        "version": "$1"
    },
    {
        "regex": "Kik/([\\d.]+) \\(Android",
        "name": "Kik",
        "version": "$1"
    },
    {
        "regex": "Procast/?([\\d.]+)?",
        "name": "Procast",
        "version": "$1"
    },
    {
        "regex": "DeviantArt/([\\d.]+)",
        "name": "DeviantArt",
        "version": ""
    },
    {
        "regex": "discord/([\\d.]+).+Electron",
        "name": "Discord",
        "version": "$1"
    },
    {
        "regex": "discord(?:-Updater)?/([\\d.]+)",
        "name": "Discord",
        "version": ""
    },
    {
        "regex": "Covenant%20Eyes/([\\d.]+)",
        "name": "Covenant Eyes",
        "version": "$1"
    },
    {
        "regex": "HP%20Smart/([\\d.]+)",
        "name": "HP Smart",
        "version": ""
    },
    {
        "regex": "Bitsboard/([\\d.]+)",
        "name": "Bitsboard",
        "version": "$1"
    },
    {
        "regex": "Betbull/([\\d.]+)",
        "name": "BetBull",
        "version": ""
    },
    {
        "regex": "U-Cursos/([\\d.]+)",
        "name": "U-Cursos",
        "version": ""
    },
    {
        "regex": "1PasswordThumbs/([\\d.]+)",
        "name": "1Password",
        "version": "$1"
    },
    {
        "regex": "(?:Microsoft Office )?(Access|Excel|OneDrive for Business|OneNote|PowerPoint|Project|Publisher|Visio|Word)(?: 20\\d{2})?[ /]\\(?(\\d+\\.[\\d.]*)",
        "name": "Microsoft Office $1",
        "version": "$2"
    },
    {
        "regex": "^Mozilla/4\\.0 \\(compatible; ms-office; MSOffice[ /]([\\d.]+)",
        "name": "Microsoft Office",
        "version": "$1"
    },
    {
        "regex": "Microsoft Office SyncProc ([\\d.]+)",
        "name": "Microsoft Office",
        "version": "$1"
    },
    {
        "regex": "Microsoft Lync ([\\d.]+)",
        "name": "Microsoft Lync",
        "version": "$1"
    },
    {
        "regex": "Microsoft\\.Data\\.Mashup",
        "name": "Microsoft Power Query",
        "version": ""
    },
    {
        "regex": "WpsM?office/([\\d.]+)",
        "name": "WPS Office",
        "version": "$1"
    },
    {
        "regex": "OneDriveiOSApp/([\\d.]+)",
        "name": "Microsoft OneDrive",
        "version": "$1"
    },
    {
        "regex": "Microsoft Office Existence Discovery",
        "name": "Microsoft Office",
        "version": ""
    },
    {
        "regex": "(?:Microsoft Office Mobile|officemobile)[ /]([\\d.]+)",
        "name": "Microsoft Office Mobile",
        "version": "$1"
    },
    {
        "regex": "Skype/([\\d.]+)",
        "name": "Skype",
        "version": "$1"
    },
    {
        "regex": "OC/([\\d.]+) \\(Skype for Business\\)",
        "name": "Skype for Business",
        "version": "$1"
    },
    {
        "regex": "iPhoneLync/([\\d.]+)",
        "name": "Skype for Business",
        "version": "$1"
    },
    {
        "regex": "WebexTeams",
        "name": "Webex Teams",
        "version": ""
    },
    {
        "regex": "GroupMe/([\\d.]+)",
        "name": "GroupMe",
        "version": "$1"
    },
    {
        "regex": "AppName/(?:musical_ly|trill) app_version/([\\d.]+)",
        "name": "TikTok",
        "version": "$1"
    },
    {
        "regex": "(?:TikTok[/ ]|com\\.zhiliaoapp\\.musically|musical_ly_|trill_)(\\d+\\.(?:[.\\d]+))?",
        "name": "TikTok",
        "version": "$1"
    },
    {
        "regex": "(?:musically_go|ultralite) app_version/([\\d.]+)",
        "name": "TikTok Lite",
        "version": "$1"
    },
    {
        "regex": "aweme(?: app_version)?/([\\d.]+)",
        "name": "Douyin",
        "version": "$1"
    },
    {
        "regex": "Copied/(\\d+[.\\d]+) CFNetwork",
        "name": "Copied",
        "version": ""
    },
    {
        "regex": "Pic%20Collage/(\\d+[.\\d]+) CFNetwork",
        "name": "Pic Collage",
        "version": "$1"
    },
    {
        "regex": "Papers/(\\d+[.\\d]+) CFNetwork",
        "name": "Papers",
        "version": "$1"
    },
    {
        "regex": "RoboForm/(\\d+[.\\d]+) CFNetwork",
        "name": "RoboForm",
        "version": ""
    },
    {
        "regex": "Slack/(\\d+[.\\d]+) CFNetwork",
        "name": "Slack",
        "version": ""
    },
    {
        "regex": "com\\.tinyspeck\\.chatlyio/(\\d+[.\\d]+)",
        "name": "Slack",
        "version": "$1"
    },
    {
        "regex": "KAKAOTALK (\\d+\\.(?:[.\\d]+))?",
        "name": "KakaoTalk",
        "version": "$1"
    },
    {
        "regex": "ShopeeVN/([\\d.]+)",
        "name": "Shopee",
        "version": "$1"
    },
    {
        "regex": "SPORT1/([\\d.]+)",
        "name": "SPORT1",
        "version": ""
    },
    {
        "regex": "Clovia/([\\d.]+)",
        "name": "Clovia",
        "version": "$1"
    },
    {
        "regex": "ShowMe/([\\d.]+)",
        "name": "ShowMe",
        "version": "$1"
    },
    {
        "regex": "Wattpad/([\\d.]+)",
        "name": "Wattpad",
        "version": "$1"
    },
    {
        "regex": "WSJ/([\\d.]+)",
        "name": "The Wall Street Journal",
        "version": ""
    },
    {
        "regex": "WH%20Questions/([\\d.]+)",
        "name": "WH Questions",
        "version": "$1"
    },
    {
        "regex": "whisper/([\\d.]+)",
        "name": "Whisper",
        "version": ""
    },
    {
        "regex": "Opal/([\\d.]+)",
        "name": "Opal Travel",
        "version": "$1"
    },
    {
        "regex": "Zalo/([\\d.]+)|Zalo (?:android|iOS)",
        "name": "Zalo",
        "version": "$1"
    },
    {
        "regex": "Yandex/([\\d.]+)",
        "name": "Yandex",
        "version": ""
    },
    {
        "regex": "ZenKit/([\\d.]+)",
        "name": "Zen",
        "version": "$1"
    },
    {
        "regex": "Zoho%20Chat/([\\d.]+)",
        "name": "Zoho Chat",
        "version": "$1"
    },
    {
        "regex": "Thunder/(\\d+[.\\d]+)",
        "name": "Thunder",
        "version": "$1"
    },
    {
        "regex": "CGNBrowser/(\\d+[.\\d]+)",
        "name": "CGN",
        "version": "$1"
    },
    {
        "regex": "(?:Podbean/.+App |Podbean/Android generic |Podbean/iOS \\([^)]+\\) )(\\d+[.\\d]+)",
        "name": "Podbean",
        "version": "$1"
    },
    {
        "regex": "TuneIn Radio Pro(?:[^/]*)/(\\d+[.\\d]+)",
        "name": "TuneIn Radio Pro",
        "version": "$1"
    },
    {
        "regex": "TuneIn(?:(?: |%20)Radio(?:[^/]*))?/?(\\d+[.\\d]+)?",
        "name": "TuneIn Radio",
        "version": "$1"
    },
    {
        "regex": "devcasts/(\\d+[.\\d]+)",
        "name": "DevCasts",
        "version": "$1"
    },
    {
        "regex": "Swoot/(\\d+[.\\d]+)",
        "name": "Swoot",
        "version": "$1"
    },
    {
        "regex": "(?:^RadioPublic[/ ](?:Android|iOS)[- ])(\\d+\\.[.\\d]+)",
        "name": "RadioPublic",
        "version": "$1"
    },
    {
        "regex": "Podimo/(\\d+[.\\d]+)",
        "name": "Podimo",
        "version": "$1"
    },
    {
        "regex": "com\\.evolve\\.podcast/(\\d+[.\\d]+)",
        "name": "Evolve Podcast",
        "version": "$1"
    },
    {
        "regex": "Rocket\\.Chat\\+?/(\\d+[.\\d]+)",
        "name": "Rocket Chat",
        "version": "$1"
    },
    {
        "regex": "^Pandora Audio.+Android",
        "name": "Pandora",
        "version": ""
    },
    {
        "regex": "^WirtschaftsWoche-iOS-(\\d+[.\\d]+)",
        "name": "Wirtschafts Woche",
        "version": "$1"
    },
    {
        "regex": "^TVirl/(\\d+[.\\d]+)",
        "name": "TVirl",
        "version": "$1"
    },
    {
        "regex": "2?chMate/(\\d+[.\\d]+)",
        "name": "ChMate",
        "version": "$1"
    },
    {
        "regex": "2tch/(\\d+[.\\d]+)",
        "name": "2tch",
        "version": "$1"
    },
    {
        "regex": "Ciisaa/(\\d+[.\\d]+)",
        "name": "Ciisaa",
        "version": "$1"
    },
    {
        "regex": "BB2C (\\d+[.\\d]+)",
        "name": "BB2C",
        "version": "$1"
    },
    {
        "regex": "twinkle/(\\d+[.\\d]+)",
        "name": "twinkle",
        "version": "$1"
    },
    {
        "regex": "JaneStyle_iOS/(\\d+[.\\d]+)",
        "name": "JaneStyle",
        "version": "$1"
    },
    {
        "regex": "BNC/.+\\(Android (\\d+[.\\d]+)\\)",
        "name": "Binance",
        "version": "$1"
    },
    {
        "regex": "Binance/(\\d+[.\\d]+)",
        "name": "Binance",
        "version": "$1"
    },
    {
        "regex": "ru\\.mail\\.my/(\\d+[.\\d]+)",
        "name": "My World",
        "version": "$1"
    },
    {
        "regex": "OK(?:Android|iOS)/([\\d.]+)",
        "name": "Odnoklassniki",
        "version": "$1"
    },
    {
        "regex": "yakyak/(\\d+[.\\d]+)",
        "name": "YakYak",
        "version": "$1"
    },
    {
        "regex": "(?:maglev|Teams)/(\\d+[.\\d]+)",
        "name": "Teams",
        "version": "$1"
    },
    {
        "regex": "TeamsMobile-(?:Android|iOS)",
        "name": "Teams",
        "version": ""
    },
    {
        "regex": "SohuNews/(\\d+\\.[.\\d]+)",
        "name": "SohuNews",
        "version": "$1"
    },
    {
        "regex": "StreamlabsOBS/(\\d+[.\\d]+)",
        "name": "Streamlabs OBS",
        "version": "$1"
    },
    {
        "regex": "Blitz/([\\d.]+)",
        "name": "Blitz",
        "version": "$1"
    },
    {
        "regex": "OfferUp/([\\d.]+)",
        "name": "OfferUp",
        "version": "$1"
    },
    {
        "regex": "Vuhuv/([\\d.]+)",
        "name": "Vuhuv",
        "version": "$1"
    },
    {
        "regex": ".+/(?:gfibertv|gftv200)-([\\d]+)-",
        "name": "Google Fiber TV",
        "version": "$1"
    },
    {
        "regex": "QuickCast$",
        "name": "QuickCast",
        "version": ""
    },
    {
        "regex": "Aliexpress(?:Android)?/([\\d.]+)",
        "name": "AliExpress",
        "version": "$1"
    },
    {
        "regex": "(?:lazada_android|AliApp\\(LA)[/ _](\\d+\\.[\\d.]+)",
        "name": "Lazada",
        "version": "$1"
    },
    {
        "regex": "(?:taobao_android|AliApp\\(TB)[/ _](\\d+\\.[\\d.]+)",
        "name": "Taobao",
        "version": "$1"
    },
    {
        "regex": "(?:AlipayClient|AliApp\\(AP)[/ _](\\d+\\.[\\d.]+)",
        "name": "Alipay",
        "version": "$1"
    },
    {
        "regex": "Blue Proxy/([\\d.]+)",
        "name": "Blue Proxy",
        "version": "$1"
    },
    {
        "regex": "ntvmobil/",
        "name": "NTV Mobil",
        "version": ""
    },
    {
        "regex": "COAF%20SMART%20Citizen/",
        "name": "COAF SMART Citizen",
        "version": ""
    },
    {
        "regex": "GitHub ?Desktop/([\\d.]+)",
        "name": "GitHub Desktop",
        "version": "$1"
    },
    {
        "regex": "logioptionsplus/([\\d.]+)",
        "name": "Logi Options+",
        "version": "$1"
    },
    {
        "regex": "EmbyTheater/([\\d.]+)",
        "name": "Emby Theater",
        "version": "$1"
    },
    {
        "regex": "y8-browser/([\\d.]+)",
        "name": "Y8 Browser",
        "version": "$1"
    },
    {
        "regex": "NuMuKiBrowser/([\\d.]+)",
        "name": "NuMuKi Browser",
        "version": "$1"
    },
    {
        "regex": "LandisGyrAIMbrowser/(\\d+[.\\d]+)",
        "name": "Landis+Gyr AIM Browser",
        "version": "$1"
    },
    {
        "regex": "(?:Code/|VSCode )(\\d+[.\\d]+)",
        "name": "Visual Studio Code",
        "version": "$1"
    },
    {
        "regex": "Wireshark/(\\d+[.\\d]+)",
        "name": "Wireshark",
        "version": "$1"
    },
    {
        "regex": "Magician",
        "name": "Samsung Magician",
        "version": ""
    },
    {
        "regex": "Razer Central PC",
        "name": "Razer Synapse",
        "version": ""
    },
    {
        "regex": "git/(\\d+[.\\d]+)",
        "name": "Git",
        "version": "$1"
    },
    {
        "regex": "^GooglePodcasts/(\\d+\\.[.\\d]+)",
        "name": "Google Podcasts",
        "version": "$1"
    },
    {
        "regex": "Microsoft-CryptoAPI/(\\d+[.\\d]+)",
        "name": "Windows CryptoAPI",
        "version": ""
    },
    {
        "regex": "Microsoft-Delivery-Optimization",
        "name": "Windows Delivery Optimization",
        "version": ""
    },
    {
        "regex": "Windows-Update-Agent",
        "name": "Windows Update Agent",
        "version": ""
    },
    {
        "regex": "^MSDW",
        "name": "Dr. Watson",
        "version": ""
    },
    {
        "regex": "qBittorrent/(\\d+[.\\d]+)",
        "name": "qBittorrent",
        "version": "$1"
    },
    {
        "regex": "^CPUID",
        "name": "CPU-Z",
        "version": ""
    },
    {
        "regex": "AIDA64",
        "name": "AIDA64",
        "version": ""
    },
    {
        "regex": "HandBrake Win Upd (\\d+[.\\d]+)",
        "name": "HandBrake",
        "version": "$1"
    },
    {
        "regex": "CCleaner, (\\d+[.\\d]+)",
        "name": "CCleaner",
        "version": "$1"
    },
    {
        "regex": "Microsoft Edge Update/(\\d+[.\\d]+)",
        "name": "Edge Update",
        "version": "$1"
    },
    {
        "regex": "Google(?:Software| )Update/(\\d+[.\\d]+)",
        "name": "Chrome Update",
        "version": "$1"
    },
    {
        "regex": "Bose Music",
        "name": "Bose Music",
        "version": ""
    },
    {
        "regex": "HikConnect",
        "name": "Hik-Connect",
        "version": ""
    },
    {
        "regex": "Cortana (\\d+[.\\d]+)",
        "name": "Cortana",
        "version": "$1"
    },
    {
        "regex": "Opera News/(\\d+[.\\d]+)",
        "name": "Opera News",
        "version": "$1"
    },
    {
        "regex": "(?:Acrobat|ReaderServices)/(\\d+[.\\d]+)",
        "name": "Adobe Acrobat Reader",
        "version": "$1"
    },
    {
        "regex": "CreativeCloud/(\\d+[.\\d]+)",
        "name": "Adobe Creative Cloud",
        "version": "$1"
    },
    {
        "regex": "rekordbox/(\\d+[.\\d]+)",
        "name": "rekordbox",
        "version": "$1"
    },
    {
        "regex": "Microsoft-WNS/(\\d+[.\\d]+)",
        "name": "Windows Push Notification Services",
        "version": "$1"
    },
    {
        "regex": "Microsoft BITS/(\\d+[.\\d]+)",
        "name": "Background Intelligent Transfer Service",
        "version": "$1"
    },
    {
        "regex": "ERA Agent Update",
        "name": "ESET Remote Administrator",
        "version": ""
    },
    {
        "regex": "EpicGamesLauncher/(\\d+[.\\d]+)",
        "name": "Epic Games Launcher",
        "version": "$1"
    },
    {
        "regex": "Microsoft-WebDAV-MiniRedir",
        "name": "WebDAV",
        "version": ""
    },
    {
        "regex": "Battle\\.net/(\\d+[.\\d]+)",
        "name": "Battle.net",
        "version": "$1"
    },
    {
        "regex": "Bookshelf-Android/(\\d+[.\\d]+)",
        "name": "Bookshelf",
        "version": "$1"
    },
    {
        "regex": "RaveSocial/(\\d+[.\\d]+)",
        "name": "Rave Social",
        "version": "$1"
    },
    {
        "regex": "wordcookies/(\\d+[.\\d]+)",
        "name": "Word Cookies!",
        "version": "$1"
    },
    {
        "regex": "com\\.meevii\\.bibleKJV/(\\d+[.\\d]+)",
        "name": "Bible KJV",
        "version": "$1"
    },
    {
        "regex": "MetaTrader 5 Terminal/(\\d+[.\\d]+)",
        "name": "MetaTrader",
        "version": "$1"
    },
    {
        "regex": "com\\.paint\\.bynumber/(\\d+[.\\d]+)",
        "name": "Paint by Number",
        "version": "$1"
    },
    {
        "regex": "zepeto_global/(\\d+[.\\d]+)",
        "name": "ZEPETO",
        "version": "$1"
    },
    {
        "regex": "Jungle Disk Workgroup HTTP",
        "name": "Jungle Disk",
        "version": ""
    },
    {
        "regex": "(?:mirall|Nextcloud-android)/(\\d+[.\\d]+)",
        "name": "Nextcloud",
        "version": "$1"
    },
    {
        "regex": "GoNativeIOS/(\\d+[.\\d]+)",
        "name": "GoNative",
        "version": "$1"
    },
    {
        "regex": "Pandora/(\\d+[.\\d]+)",
        "name": "Pandora",
        "version": "$1"
    },
    {
        "regex": "Blackboard/(\\d+[.\\d]+)?",
        "name": "Blackboard",
        "version": "$1"
    },
    {
        "regex": "TIM/(\\d+[.\\d]+)",
        "name": "TIM",
        "version": "$1"
    },
    {
        "regex": "TencentDocs/(\\d+[.\\d]+)",
        "name": "Tencent Docs",
        "version": "$1"
    },
    {
        "regex": "QQ/(\\d+[.\\d]+) V1_IPH_SQ_",
        "name": "QQ",
        "version": "$1"
    },
    {
        "regex": "QQMusic/(\\d+[.\\d]+)",
        "name": "QQMusic",
        "version": "$1"
    },
    {
        "regex": "etoro-cordova-app",
        "name": "eToro",
        "version": ""
    },
    {
        "regex": "Avid Link Desktop App/(\\d+[.\\d]+)",
        "name": "Avid Link",
        "version": "$1"
    },
    {
        "regex": "Netflix/(\\d+[.\\d]+)",
        "name": "Netflix",
        "version": "$1"
    },
    {
        "regex": "GoogleTagManager/(\\d+[.\\d]+)",
        "name": "Google Tag Manager",
        "version": "$1"
    },
    {
        "regex": "Adobe Synchronizer (\\d+[.\\d]+)",
        "name": "Adobe Synchronizer",
        "version": "$1"
    },
    {
        "regex": "BlueStacks(?: 5)?/(\\d+[.\\d]+)",
        "name": "BlueStacks",
        "version": "$1"
    },
    {
        "regex": "WindowsPowerShell/(\\d+[.\\d]+)",
        "name": "PowerShell",
        "version": "$1"
    },
    {
        "regex": "PAN GlobalProtect/(\\d+[.\\d]+)",
        "name": "GlobalProtect",
        "version": "$1"
    },
    {
        "regex": "Theyub v(\\d+[.\\d]+)",
        "name": "Theyub",
        "version": "$1"
    },
    {
        "regex": "BBCNewsUKWatchApp/(\\d+[.\\d]+)",
        "name": "BBC News",
        "version": "$1"
    },
    {
        "regex": "TradingView/(\\d+[.\\d]+)",
        "name": "TradingView",
        "version": "$1"
    },
    {
        "regex": "Instabridge(?:/([\\d.]+))?",
        "name": "Instabridge",
        "version": "$1"
    },
    {
        "regex": "Be Focused/(\\d+\\.[.\\d]+)?",
        "name": "Be Focused",
        "version": "$1"
    },
    {
        "regex": "Focus Matrix/(\\d+\\.[.\\d]+)?",
        "name": "Focus Matrix",
        "version": "$1"
    },
    {
        "regex": "Focuskeeper/(\\d+\\.[.\\d]+)?",
        "name": "Focus Keeper",
        "version": "$1"
    },
    {
        "regex": "WindowsStoreSDK",
        "name": "Microsoft Store",
        "version": ""
    },
    {
        "regex": "Asus Update/(\\d+\\.[.\\d]+)",
        "name": "ASUS Updater",
        "version": "$1"
    },
    {
        "regex": "imoAndroid/(20\\d{2}\\.[.\\d]+)",
        "name": "IMO HD Video Calls & Chat",
        "version": "$1"
    },
    {
        "regex": "imoAndroid/(\\d+\\.[.\\d]+)",
        "name": "IMO International Calls & Chat",
        "version": "$1"
    },
    {
        "regex": "(?:Bing)?Sapphire/(\\d+\\.[.\\d]+)",
        "name": "Microsoft Bing",
        "version": "$1"
    },
    {
        "regex": "BingWeb(?:/([\\d.]+))?|bingipadclient",
        "name": "Microsoft Bing",
        "version": "$1"
    },
    {
        "regex": "NewsSapphire/(\\d+\\.[.\\d]+)",
        "name": "Microsoft Start",
        "version": "$1"
    },
    {
        "regex": "CopilotSapphire/(\\d+\\.[.\\d]+)",
        "name": "Microsoft Copilot",
        "version": "$1"
    },
    {
        "regex": ".+HiSearch/(\\d+\\.[.\\d]+)",
        "name": "HiSearch",
        "version": "$1"
    },
    {
        "regex": "RDDocuments/(\\d+\\.[.\\d]+)",
        "name": "RDDocuments",
        "version": "$1"
    },
    {
        "regex": "FSCDCSafe[ /](\\d+\\.[.\\d]+)",
        "name": "F-Secure SAFE",
        "version": "$1"
    },
    {
        "regex": "Twitterrific",
        "name": "Twitterrific",
        "version": ""
    },
    {
        "regex": "UconnectLive",
        "name": "Uconnect LIVE",
        "version": ""
    },
    {
        "regex": "Wayback%20Machine%20Extension",
        "name": "Wayback Machine",
        "version": ""
    },
    {
        "regex": "com\\.Nanoteq\\.QmunicateH10p.+/(\\d+\\.[.\\d]+) \\(",
        "name": "Q-municate",
        "version": "$1"
    },
    {
        "regex": "NET\\.mede",
        "name": "NET.mede",
        "version": ""
    },
    {
        "regex": "My%20Bentley",
        "name": "My Bentley",
        "version": ""
    },
    {
        "regex": "Skyeng%20App",
        "name": "Skyeng",
        "version": ""
    },
    {
        "regex": "Skyeng%20Teachers",
        "name": "Skyeng Teachers",
        "version": ""
    },
    {
        "regex": "(Millennium/|Millennium%20Corp)",
        "name": "Bank Millenium",
        "version": ""
    },
    {
        "regex": "MBolsa",
        "name": "MBolsa",
        "version": ""
    },
    {
        "regex": "(MEmpresas|Millennium%20Empresas)",
        "name": "MEmpresas",
        "version": ""
    },
    {
        "regex": "OrangeRadio/(\\d+\\.[.\\d]+)",
        "name": "Orange Radio",
        "version": "$1"
    },
    {
        "regex": "Radio%20Italiane/(\\d+\\.[.\\d]+)",
        "name": "Radio Italiane",
        "version": "$1"
    },
    {
        "regex": "com\\.apple\\.Safari\\.SearchHelper/(\\d+\\.[.\\d]+)",
        "name": "Safari Search Helper",
        "version": "$1"
    },
    {
        "regex": "Citrix%20Viewer",
        "name": "Citrix Workspace",
        "version": ""
    },
    {
        "regex": "com\\.mercbank\\.s1mobileipad",
        "name": "Mercantile Bank of Michigan",
        "version": ""
    },
    {
        "regex": "D-Stream%20Air",
        "name": "DStream Air",
        "version": ""
    },
    {
        "regex": "ExpediaBookings",
        "name": "Expedia",
        "version": ""
    },
    {
        "regex": "Windows Antivirus (\\d+\\.[.\\d]+)",
        "name": "Windows Antivirus",
        "version": "$1"
    },
    {
        "regex": "^Reflect",
        "name": "Macrium Reflect",
        "version": ""
    },
    {
        "regex": "Opera autoupdate agent",
        "name": "Opera Updater",
        "version": ""
    },
    {
        "regex": "Ballz/(\\d+\\.[.\\d]+)",
        "name": "Ballz",
        "version": "$1"
    },
    {
        "regex": "rnps-action-cards/(\\d+\\.[.\\d]+)",
        "name": "RNPS Action Cards",
        "version": "$1"
    },
    {
        "regex": "PlexMediaServer/(\\d+\\.[.\\d]+)",
        "name": "Plex Media Server",
        "version": "$1"
    },
    {
        "regex": "FreeSafeIP",
        "name": "SafeIP",
        "version": ""
    },
    {
        "regex": "Surfshark(?:Android)?/([\\d.]+)",
        "name": "Surfshark",
        "version": "$1"
    },
    {
        "regex": "APP/yym-hago-and(\\d+\\.[.\\d]+)",
        "name": "Hago",
        "version": "$1"
    },
    {
        "regex": "Azureus (\\d+\\.[.\\d]+)",
        "name": "Vuze",
        "version": "$1"
    },
    {
        "regex": "IPM",
        "name": "Adobe IPM",
        "version": ""
    },
    {
        "regex": "Adobe NGL|NGL Client/(\\d+\\.[.\\d]+)",
        "name": "Adobe NGL",
        "version": "$1"
    },
    {
        "regex": "/Satoshi:(\\d+\\.[.\\d]+)/",
        "name": "Bitcoin Core",
        "version": "$1"
    },
    {
        "regex": "/Shibetoshi:(\\d+\\.[.\\d]+)/",
        "name": "Dogecoin Core",
        "version": "$1"
    },
    {
        "regex": "Amazon\\.com/(\\d+\\.[.\\d]+)",
        "name": "Amazon Shopping",
        "version": "$1"
    },
    {
        "regex": "de\\.mobile\\.android\\.app/(\\d+\\.[.\\d]+)",
        "name": "mobile.de",
        "version": "$1"
    },
    {
        "regex": "de\\.mobile\\.android\\.app/(.*) \\((\\d+\\.[.\\d]+)\\)",
        "name": "mobile.de",
        "version": "$2"
    },
    {
        "regex": "jitsi-meet/",
        "name": "Jitsi Meet",
        "version": ""
    },
    {
        "regex": "Waste My Time! Extension/(\\d+\\.[.\\d]+)",
        "name": "Don't Waste My Time!",
        "version": "$1"
    },
    {
        "regex": "1Password/(\\d+\\.[.\\d]+)",
        "name": "1Password",
        "version": "$1"
    },
    {
        "regex": "iOSStartsidenApp",
        "name": "Startsiden",
        "version": ""
    },
    {
        "regex": "HisThumbnail",
        "name": "HisThumbnail",
        "version": ""
    },
    {
        "regex": "OneSearch/(\\d+\\.[.\\d]+)",
        "name": "Yahoo OneSearch",
        "version": "$1"
    },
    {
        "regex": "anonymized by Abelssoft",
        "name": "AntiBrowserSpy",
        "version": ""
    },
    {
        "regex": "Anonymisiert durch AlMiSoft(?! Browser-Maulkorb)",
        "name": "Browser-Anonymizer",
        "version": ""
    },
    {
        "regex": "DaumApps/(\\d+\\.[.\\d]+)?",
        "name": "Daum",
        "version": "$1"
    },
    {
        "regex": "AT&T TV",
        "name": "DIRECTV",
        "version": ""
    },
    {
        "regex": "Reddit/Version (\\d+\\.[.\\d]+)/",
        "name": "Reddit",
        "version": "$1"
    },
    {
        "regex": "TuyaSmart/(\\d+\\.[.\\d]+)",
        "name": "Tuya Smart Life",
        "version": "$1"
    },
    {
        "regex": "(?:Spotify(?:-Lite)?/(\\d+\\.[.\\d]+|12\\d+)|^spotify_)",
        "name": "Spotify",
        "version": "$1"
    },
    {
        "regex": "(?:AmazonMusic|^Harley)(?:(?:%2F|/)(\\d+\\.[.\\d]+))?",
        "name": "Amazon Music",
        "version": "$1"
    },
    {
        "regex": "Klarna/(\\d+\\.[.\\d]+)?",
        "name": "Klarna",
        "version": "$1"
    },
    {
        "regex": "^R/(\\d+[.\\d]+)",
        "name": "R",
        "version": "$1"
    },
    {
        "regex": "RadioAppFree/",
        "name": "RadioApp",
        "version": ""
    },
    {
        "regex": "^(?:Audible, Android, |com\\.audible\\.playersdk\\.player/|Audible/)(\\d+\\.[.\\d]+)?",
        "name": "Audible",
        "version": "$1"
    },
    {
        "regex": "Overcast/?(\\d+\\.[.\\d]+)? \\(\\+http://overcast\\.fm/; (?:Apple Watch|iOS) podcast",
        "name": "Overcast",
        "version": "$1"
    },
    {
        "regex": "^HTTPrequestmaker",
        "name": "HTTP request maker",
        "version": ""
    },
    {
        "regex": "^bonprix mobile App (\\d+\\.[.\\d]+)",
        "name": "BonPrix",
        "version": "$1"
    },
    {
        "regex": "Safari Quora (\\d+\\.[.\\d]+)",
        "name": "Quora",
        "version": "$1"
    },
    {
        "regex": "RelesysApp/(\\d+\\.[.\\d]+) \\(\\d{1,2}\\) net\\.relesysapp\\.jj2go",
        "name": "JJ2GO",
        "version": "$1"
    },
    {
        "regex": "MyWatchParty/(\\d+\\.[.\\d]+)",
        "name": "My Watch Party",
        "version": "$1"
    },
    {
        "regex": "LoseIt!/(\\d+\\.[.\\d]+)",
        "name": "LoseIt!",
        "version": "$1"
    },
    {
        "regex": "ActionExtension/([\\d.]+)",
        "name": "ActionExtension",
        "version": "$1"
    },
    {
        "regex": "^Adori(?:-Dev|-Listen)?/([\\d.]+)",
        "name": "Adori",
        "version": "$1"
    },
    {
        "regex": "^Agora/([\\d.]+)",
        "name": "Agora",
        "version": "$1"
    },
    {
        "regex": "^Airr(?:%20Beta)?/([\\d.]+)|^Airr \\(",
        "name": "Airr",
        "version": "$1"
    },
    {
        "regex": "^Airsonic/(\\d+\\.[.\\d]+)",
        "name": "Airsonic",
        "version": "$1"
    },
    {
        "regex": "(?:AllYouCanBooksApp|^AllYouCanBooks/([\\d.]+))",
        "name": "All You Can Books",
        "version": "$1"
    },
    {
        "regex": "^AllHitMusicRadio/([\\d.]+)",
        "name": "AllHitMusicRadio",
        "version": "$1"
    },
    {
        "regex": "^Amazon;AF",
        "name": "Amazon Fire",
        "version": ""
    },
    {
        "regex": "^Anchor/([\\d.]+)",
        "name": "Anchor",
        "version": "$1"
    },
    {
        "regex": "^AnchorFM/(\\d+\\.[.\\d]+)",
        "name": "AnchorFM",
        "version": "$1"
    },
    {
        "regex": "(?:^Anghami Android |^Anghami/|^\u0623\u0646\u063A\u0627\u0645\u064A/)([\\d.]+)",
        "name": "Anghami",
        "version": "$1"
    },
    {
        "regex": "(?:^AntennaPod/|^de\\.danoeh\\.antennapod/|antenna/)([\\d.]+)?",
        "name": "AntennaPod",
        "version": "$1"
    },
    {
        "regex": "^Anybox/([\\d.]+)",
        "name": "Anybox",
        "version": "$1"
    },
    {
        "regex": "^Anytime/(\\d+\\.[.\\d]+).*amugofjava",
        "name": "Anytime Podcast Player",
        "version": "$1"
    },
    {
        "regex": "^APKXDL",
        "name": "APK Downloader",
        "version": ""
    },
    {
        "regex": "^Apollo/([\\d.]+)",
        "name": "Apollo",
        "version": "$1"
    },
    {
        "regex": "(?:^MessagesViewService/|^Messages/|^Messages Share Extension/|^MessagesNotificationExtension/)([\\d.]+)",
        "name": "Apple iMessage",
        "version": "$1"
    },
    {
        "regex": "(?:^Podcasts/|^Balados/|^Podcasti/|^Podcastit/|^Podcasturi/|^Podcasty/|^Podcast\u2019ler/|^Podkaster/|^Podcaster/|^Podcastok/|^\u041F\u043E\u0434\u043A\u0430\u0441\u0442\u0438/|^\u041F\u043E\u0434\u043A\u0430\u0441\u0442\u044B/|^\u05E4\u05D5\u05D3\u05E7\u05D0\u05E1\u05D8\u05D9\u05DD/|^\u0627\u0644\u0628\u0648\u062F\u0643\u0627\u0633\u062A/|^\u092A\u0949\u0921\u0915\u093E\u0938\u094D\u091F/|^\u0E1E\u0E47\u0E2D\u0E14\u0E04\u0E32\u0E2A\u0E17\u0E4C/|^\u64AD\u5BA2/|^\uD31F\uCE90\uC2A4\uD2B8/|^\u30DD\u30C3\u30C9\u30AD\u30E3\u30B9\u30C8/|^\u0625\u0633\u0645\u0639\u0644\u064A/|^\u041F\u043E\u0434\u043A\u0430\u0441\u0442\u0442\u0430\u0440/|^Podcast/|AirPodcasts/)([\\d.]+)?",
        "name": "Apple Podcasts",
        "version": "$1"
    },
    {
        "regex": "^Recordatorios/([\\d.]+)",
        "name": "Apple Reminders",
        "version": "$1"
    },
    {
        "regex": "^Arvocast/([\\d.]+)",
        "name": "Arvocast",
        "version": "$1"
    },
    {
        "regex": "^Radio\\.com/(\\d+\\.[.\\d]+)",
        "name": "Audacy",
        "version": "$1"
    },
    {
        "regex": "^Audio/([\\d.]+)",
        "name": "Audio",
        "version": "$1"
    },
    {
        "regex": "^Android_AudioNow",
        "name": "Audio Now",
        "version": ""
    },
    {
        "regex": "^Awasu/(\\d+\\.[.\\d]+)",
        "name": "Awasu",
        "version": "$1"
    },
    {
        "regex": "^Bear/([\\d.]+)",
        "name": "Bear",
        "version": "$1"
    },
    {
        "regex": "^Bible/([\\d.]+)",
        "name": "Bible",
        "version": "$1"
    },
    {
        "regex": "^Bolt/([\\d.]+)",
        "name": "Bolt",
        "version": "$1"
    },
    {
        "regex": "^Bookmobile/([\\d.]+)",
        "name": "Bookmobile",
        "version": "$1"
    },
    {
        "regex": "^Boom/([\\d.]+)",
        "name": "Boom",
        "version": "$1"
    },
    {
        "regex": "^Boomplay/(\\d+\\.[.\\d]+)",
        "name": "Boomplay",
        "version": "$1"
    },
    {
        "regex": "^Bose/(\\d+\\.[.\\d]+)",
        "name": "Bose SoundTouch",
        "version": "$1"
    },
    {
        "regex": "^bPod$",
        "name": "bPod",
        "version": ""
    },
    {
        "regex": "^breez/(\\d+\\.[.\\d]+)",
        "name": "Breez",
        "version": "$1"
    },
    {
        "regex": "^Broadcast/(\\d+\\.[.\\d]+)",
        "name": "Broadcast",
        "version": "$1"
    },
    {
        "regex": "BroadwayPodcastNetwork/iOS",
        "name": "Broadway Podcast Network",
        "version": ""
    },
    {
        "regex": "^(?:Browser|browser_iso)/([\\d.]+)",
        "name": "Browser app",
        "version": "$1"
    },
    {
        "regex": "^BrowserPlus/([\\d.]+)",
        "name": "BrowserPlus",
        "version": "$1"
    },
    {
        "regex": "^Bullhorn(?:/([\\d.]+))?",
        "name": "Bullhorn",
        "version": "$1"
    },
    {
        "regex": "^Capital/([\\d.]+)",
        "name": "Capital",
        "version": "$1"
    },
    {
        "regex": "^capsule\\.fm/([\\d.]+)|^capsule-android",
        "name": "capsule.fm",
        "version": "$1"
    },
    {
        "regex": "^Castamatic/([\\d.]+)",
        "name": "Castamatic",
        "version": "$1"
    },
    {
        "regex": "^Castaway/([\\d.]+)",
        "name": "Castaway",
        "version": "$1"
    },
    {
        "regex": "^CastBox/(\\d+\\.[.\\d]+)",
        "name": "CastBox",
        "version": "$1"
    },
    {
        "regex": "^Classic FM/([\\d.]+)",
        "name": "Classic FM",
        "version": "$1"
    },
    {
        "regex": "^Client/([\\d.]+)",
        "name": "Client",
        "version": "$1"
    },
    {
        "regex": "^Cosmicast/([\\d.]+)",
        "name": "Cosmicast",
        "version": "$1"
    },
    {
        "regex": "CPod/(\\d+\\.[.\\d]+)",
        "name": "CPod",
        "version": "$1"
    },
    {
        "regex": "^damus/([\\d.]+)",
        "name": "Damus",
        "version": "$1"
    },
    {
        "regex": "(?:be\\.standaard\\.audio|^DS podcast/|DS%20Podcast/)([\\d.]+)?",
        "name": "De Standaard",
        "version": "$1"
    },
    {
        "regex": "^DManager/([\\d.]+)",
        "name": "DManager",
        "version": "$1"
    },
    {
        "regex": "^doubleTwist CloudPlayer",
        "name": "DoubleTwist CloudPlayer",
        "version": ""
    },
    {
        "regex": "^Doughnut/([\\d.]+)",
        "name": "Doughnut",
        "version": "$1"
    },
    {
        "regex": "^Downie/([\\d.]+)",
        "name": "Downie",
        "version": "$1"
    },
    {
        "regex": "^Downloader/([\\d.]+)",
        "name": "Downloader",
        "version": "$1"
    },
    {
        "regex": "^EMAudioPlayer (\\d+\\.[.\\d]+)",
        "name": "EMAudioPlayer",
        "version": "$1"
    },
    {
        "regex": "^Expo/(\\d+\\.[.\\d]+)",
        "name": "Expo",
        "version": "$1"
    },
    {
        "regex": "^CFR%20Plus/([\\d.]+)",
        "name": "faidr",
        "version": "$1"
    },
    {
        "regex": "^Fathom/([\\d.]+)",
        "name": "Fathom",
        "version": "$1"
    },
    {
        "regex": "^FeedStation/(\\d+\\.[.\\d]+)",
        "name": "FeedStation",
        "version": "$1"
    },
    {
        "regex": "^Files/([\\d.]+)",
        "name": "Files",
        "version": "$1"
    },
    {
        "regex": "^Fountain(?:app)?/([\\d.]+)",
        "name": "Fountain",
        "version": "$1"
    },
    {
        "regex": "^Garmin fenix 5X Plus/(\\d+\\.[.\\d]+)",
        "name": "Garmin fenix 5X",
        "version": "$1"
    },
    {
        "regex": "^Garmin Forerunner (?:\\d+)(?: Music| Solar)?/(\\d+\\.[.\\d]+)",
        "name": "Garmin Forerunner",
        "version": "$1"
    },
    {
        "regex": "^Gold/([\\d.]+)",
        "name": "Gold",
        "version": "$1"
    },
    {
        "regex": "^GoldenPod/(\\d+\\.[.\\d]+)",
        "name": "GoldenPod",
        "version": "$1"
    },
    {
        "regex": "^GoLoud/([\\d.]+)",
        "name": "GoLoud",
        "version": "$1"
    },
    {
        "regex": "Goodpods(?:\\.Android|\\.iOS)? ?/ ?([\\d.]+)",
        "name": "Goodpods",
        "version": "$1"
    },
    {
        "regex": "^GoodReader(?:4|IPad)?/([\\d.]+)",
        "name": "GoodReader",
        "version": "$1"
    },
    {
        "regex": "\\(Fuchsia\\).* CrKey/(:?\\d+\\.[.\\d]+)",
        "name": "Google Nest Hub",
        "version": ""
    },
    {
        "regex": "^Guacamole/([\\d.]+)",
        "name": "Guacamole",
        "version": "$1"
    },
    {
        "regex": "^Hammel/([\\d.]+)",
        "name": "Hammel",
        "version": "$1"
    },
    {
        "regex": "^HardCast/([\\d.]+)",
        "name": "HardCast",
        "version": "$1"
    },
    {
        "regex": "^Hark/([\\d.]+)",
        "name": "Hark Audio",
        "version": "$1"
    },
    {
        "regex": "^Heart/([\\d.]+)",
        "name": "Heart",
        "version": "$1"
    },
    {
        "regex": "hermespod\\.com/v?([\\d.]+)",
        "name": "HermesPod",
        "version": "$1"
    },
    {
        "regex": "^HiCast/([\\d.]+)",
        "name": "HiCast",
        "version": "$1"
    },
    {
        "regex": "^Himalaya(?:_test)?/([\\d.]+)",
        "name": "Himalaya",
        "version": "$1"
    },
    {
        "regex": "^HyperCatcher/([\\d.]+)",
        "name": "HyperCatcher",
        "version": "$1"
    },
    {
        "regex": "^(?:iHeartRadio|iHeartPodcasts)/([\\d.]+)",
        "name": "iHeartRadio",
        "version": "$1"
    },
    {
        "regex": "^IOSAudiobooks/([\\d.]+)",
        "name": "Audiobooks",
        "version": "$1"
    },
    {
        "regex": "^iVoox(?:App|New)?[ /]?([\\d.]+)?",
        "name": "iVoox",
        "version": "$1"
    },
    {
        "regex": "^Jam/(\\d+\\.[.\\d]+)",
        "name": "Jam",
        "version": "$1"
    },
    {
        "regex": "^(?:com\\.jio\\.media\\.jiobeats/(\\d+\\.[.\\d]+)|com\\.saavn\\.android|^[sS]aavn)",
        "name": "JioSaavn",
        "version": "$1"
    },
    {
        "regex": "KajabiMobileApp|KajabiPodcast",
        "name": "Kajabi",
        "version": ""
    },
    {
        "regex": "^KakaoTalk/(\\d+\\.[.\\d]+)",
        "name": "KakaoTalk",
        "version": "$1"
    },
    {
        "regex": "^Kids(?:%20| )Listen/([\\d.]+)",
        "name": "Kids Listen",
        "version": "$1"
    },
    {
        "regex": "^KidspodMobileClient/([\\d.]+)",
        "name": "KidsPod",
        "version": "$1"
    },
    {
        "regex": "^KKBOX/(\\d+\\.[.\\d]+)",
        "name": "KKBOX",
        "version": "$1"
    },
    {
        "regex": "^(?:Laughable.+iOS|Laughable)/(\\d+\\.[.\\d]+)",
        "name": "Laughable",
        "version": "$1"
    },
    {
        "regex": "^LBC/([\\d.]+)",
        "name": "LBC",
        "version": "$1"
    },
    {
        "regex": "LG Player (\\d+\\.[.\\d]+)",
        "name": "LG Player",
        "version": "$1"
    },
    {
        "regex": "^Listen(?:(?: |%20)App)?/([\\d.]+)",
        "name": "Listen",
        "version": "$1"
    },
    {
        "regex": "^Liulo/([\\d.]+)",
        "name": "Liulo",
        "version": "$1"
    },
    {
        "regex": "Listen5[ /]([\\d.]+)",
        "name": "Just Listen",
        "version": "$1"
    },
    {
        "regex": "^(?:Luminary(?:Preprod)?|luminary\\.next)/([\\d.]+)",
        "name": "Luminary",
        "version": "$1"
    },
    {
        "regex": "^Megaphone\\.fm",
        "name": "Megaphone",
        "version": ""
    },
    {
        "regex": "^Menucast/(\\d+\\.[.\\d]+)",
        "name": "Menucast",
        "version": "$1"
    },
    {
        "regex": "^Messenger/([\\d.]+)",
        "name": "MessengerX",
        "version": "$1"
    },
    {
        "regex": "^Mimir(?:-macOS)?/([\\d.]+)",
        "name": "Mimir",
        "version": "$1"
    },
    {
        "regex": "^MobileSMS/([\\d.]+)",
        "name": "MobileSMS",
        "version": "$1"
    },
    {
        "regex": "^Moon ?FM/([\\d.]+)",
        "name": "MoonFM",
        "version": "$1"
    },
    {
        "regex": "^myTuner(?:(?:%20Radio%20app|iOS%20Free|_podcasts_androidplayer)/ ?([\\d.]+)?)?",
        "name": "MyTuner",
        "version": "$1"
    },
    {
        "regex": "^Newsly$",
        "name": "Newsly",
        "version": ""
    },
    {
        "regex": "^NRC(?: |%20)Audio/([\\d.]+)",
        "name": "NRC Audio",
        "version": "$1"
    },
    {
        "regex": "(?:NRC-Nieuws/|nl\\.nrc\\.nrcapp |com\\.twipemobile\\.nrc )([\\d.]+)",
        "name": "NRC",
        "version": "$1"
    },
    {
        "regex": "^Outcast[/ ]?([\\d.]+)?",
        "name": "Outcast",
        "version": "$1"
    },
    {
        "regex": "^Podcast Overhaul/(\\d+\\.[.\\d]+)",
        "name": "Overhaul FM",
        "version": "$1"
    },
    {
        "regex": "^Palco MP3/(\\d+\\.[.\\d]+)",
        "name": "Palco MP3",
        "version": "$1"
    },
    {
        "regex": "^PeaCast/(\\d+\\.[.\\d]+)",
        "name": "PeaCast",
        "version": "$1"
    },
    {
        "regex": "^Player FM|^Player%20FM|^Alpha%20PlayerFM/",
        "name": "Player FM",
        "version": ""
    },
    {
        "regex": "^Podbay/([\\d.]+)",
        "name": "Podbay",
        "version": "$1"
    },
    {
        "regex": "^PodcastGuru[ /]([\\d.]+)",
        "name": "Podcast Guru",
        "version": "$1"
    },
    {
        "regex": "^Podcast Player/(\\d+\\.[.\\d]+)",
        "name": "Podcast Player",
        "version": "$1"
    },
    {
        "regex": "^PodcastRepublic/(\\d+\\.[.\\d]+)",
        "name": "Podcast Republic",
        "version": "$1"
    },
    {
        "regex": "^Podcastly[/ ]?(\\d+\\.[.\\d]+)?",
        "name": "Podcastly",
        "version": "$1"
    },
    {
        "regex": "^Podchaser |^Podchaser-Parser",
        "name": "Podchaser",
        "version": ""
    },
    {
        "regex": "^Podclipper/([\\d.]+)",
        "name": "Podclipper",
        "version": "$1"
    },
    {
        "regex": "^PodCruncher/(\\d+\\.[.\\d]+)",
        "name": "PodCruncher",
        "version": "$1"
    },
    {
        "regex": "^Podeo/([\\d.]+)",
        "name": "Podeo",
        "version": "$1"
    },
    {
        "regex": "^Podfriend[ /](\\d+\\.[.\\d]+)",
        "name": "Podfriend",
        "version": "$1"
    },
    {
        "regex": "(?:^Podhero(?:%20Alpha)?/|^Swoot[/ ](?:Agent[/ ])?)([\\d.]+)",
        "name": "Podhero",
        "version": "$1"
    },
    {
        "regex": "^Podimo/(\\d+\\.[.\\d]+)",
        "name": "Podimo",
        "version": "$1"
    },
    {
        "regex": "PodKast$",
        "name": "PodKast",
        "version": ""
    },
    {
        "regex": "^Podkicker(?: Pro)/(\\d+\\.[.\\d]+)",
        "name": "Podkicker Pro",
        "version": "$1"
    },
    {
        "regex": "PodLP/(\\d+\\.[.\\d]+)",
        "name": "PodLP",
        "version": "$1"
    },
    {
        "regex": "^(?:Podme android app|PodMe)/(\\d+\\.[.\\d]+)?",
        "name": "PodMe",
        "version": "$1"
    },
    {
        "regex": "^PodMN/(?:iOS|Android) (\\d+\\.[.\\d]+)",
        "name": "PodMN",
        "version": "$1"
    },
    {
        "regex": "^PodNL/([\\d.]+)",
        "name": "PodNL",
        "version": "$1"
    },
    {
        "regex": "^(?:Podopolo|podopolo)/?([\\d.]+)",
        "name": "Podopolo",
        "version": "$1"
    },
    {
        "regex": "^Podplay/(\\d+\\.[.\\d]+)",
        "name": "Podplay",
        "version": "$1"
    },
    {
        "regex": "^Pods/",
        "name": "Pods",
        "version": "$1"
    },
    {
        "regex": "^Podurama/(\\d+\\.[.\\d]+)",
        "name": "Podurama",
        "version": "$1"
    },
    {
        "regex": "^PodTrapper$",
        "name": "PodTrapper",
        "version": ""
    },
    {
        "regex": "^Podvine/(\\d+\\.[.\\d]+)",
        "name": "Podvine",
        "version": "$1"
    },
    {
        "regex": "^Podverse/",
        "name": "Podverse",
        "version": ""
    },
    {
        "regex": "(?:Podyssey App|com\\.toysinboxes\\.Echo|fm\\.podyssey\\.podcasts|^Podyssey)/?([\\d.]+)?",
        "name": "Podyssey",
        "version": "$1"
    },
    {
        "regex": "^PugpigBolt (\\d+\\.[.\\d]+)",
        "name": "PugPig Bolt",
        "version": "$1"
    },
    {
        "regex": "^radio\\.([a-z]{2}|net)[ /]([\\d.]+)",
        "name": "radio.$1",
        "version": "$2"
    },
    {
        "regex": "^GetPodcast[ /]([\\d.]+)",
        "name": "GetPodcast",
        "version": "$1"
    },
    {
        "regex": "^radio\\.next[ /]([\\d.]+)",
        "name": "Radio Next",
        "version": "$1"
    },
    {
        "regex": "(?:^Radioline%202/(\\d+\\.[.\\d]+)|^Radioline$)",
        "name": "Radioline",
        "version": "$1"
    },
    {
        "regex": "^Repod/(\\d+\\.[.\\d]+)",
        "name": "Repod",
        "version": "$1"
    },
    {
        "regex": "^rhythmbox/(\\d+\\.[.\\d]+)",
        "name": "Rhythmbox",
        "version": "$1"
    },
    {
        "regex": "^SachNoi\\.?app/([\\d.]+)",
        "name": "SachNoi",
        "version": "$1"
    },
    {
        "regex": "^sp-agent",
        "name": "Samsung Podcasts",
        "version": ""
    },
    {
        "regex": "^(?:ServeStream(?: Dynamo)?/?(\\d+\\.[.\\d]+)?)",
        "name": "ServeStream",
        "version": "$1"
    },
    {
        "regex": "^Shadow/([\\d.]+)",
        "name": "Shadow",
        "version": "$1"
    },
    {
        "regex": "^Shadowrocket/([\\d.]+)",
        "name": "Shadowrocket",
        "version": "$1"
    },
    {
        "regex": "^(?:SiriusXM|sxm-android|sxm-apple)/([\\d.]+)",
        "name": "SiriusXM",
        "version": "$1"
    },
    {
        "regex": "^Snipd/([\\d.]+)",
        "name": "Snipd",
        "version": "$1"
    },
    {
        "regex": "^Sodes/([\\d.]+)",
        "name": "'sodes",
        "version": "$1"
    },
    {
        "regex": "(?:Sonnet/(?:Android|iOS)|^Simple Podcast Player/(\\d+\\.[.\\d]+))",
        "name": "Sonnet",
        "version": "$1"
    },
    {
        "regex": "^sony_tv;ps5;",
        "name": "Sony PlayStation 5",
        "version": ""
    },
    {
        "regex": "^SoundOn/([\\d.]+)",
        "name": "SoundOn",
        "version": "$1"
    },
    {
        "regex": "^SoundWaves-(\\d+\\.[.\\d]+)",
        "name": "SoundWaves",
        "version": "$1"
    },
    {
        "regex": "Spreaker/([\\d.]+)",
        "name": "Spreaker",
        "version": "$1"
    },
    {
        "regex": "^Stitcher/|^Stitcher Demo/|^AlexaMediaPlayer/Stitcher",
        "name": "Stitcher",
        "version": ""
    },
    {
        "regex": "^StoryShots/(\\d+\\.[.\\d]+)",
        "name": "StoryShots",
        "version": "$1"
    },
    {
        "regex": "^Swinsian/([\\d.]+)",
        "name": "Swinsian",
        "version": "$1"
    },
    {
        "regex": "^ThePodcastApp/(\\d+\\.[.\\d]+)",
        "name": "Podcast App",
        "version": "$1"
    },
    {
        "regex": "^TREBLE/([\\d.]+)",
        "name": "Treble.fm",
        "version": "$1"
    },
    {
        "regex": "^Turtlecast/(\\d+\\.[.\\d]+)",
        "name": "Turtlecast",
        "version": "$1"
    },
    {
        "regex": "^Ubook Player$",
        "name": "Ubook Player",
        "version": ""
    },
    {
        "regex": "^VictorReader Stream Trek",
        "name": "Victor Reader Stream Trek",
        "version": ""
    },
    {
        "regex": "^VictorReader Stream V3",
        "name": "Victor Reader Stream 3",
        "version": ""
    },
    {
        "regex": "^(?:VictorReader Stream 503|VictorReader_)",
        "name": "Victor Reader Stream New Generation",
        "version": ""
    },
    {
        "regex": "^Vodacast/([\\d.]+)",
        "name": "Vodacast",
        "version": "$1"
    },
    {
        "regex": "^WynkMusic/(\\d+\\.[.\\d]+)",
        "name": "Wynk Music",
        "version": "$1"
    },
    {
        "regex": "^Xiaoyuzhou/(\\d+\\.[.\\d]+)",
        "name": "Xiao Yu Zhou",
        "version": "$1"
    },
    {
        "regex": "^Ya(ndex)?\\.Music/",
        "name": "Yandex Music",
        "version": ""
    },
    {
        "regex": "^yapa/([\\d.]+)",
        "name": "Yapa",
        "version": "$1"
    },
    {
        "regex": "Zune/(\\d+\\.[.\\d]+)",
        "name": "Zune",
        "version": ""
    },
    {
        "regex": "UCast/([\\d.]+)",
        "name": "UCast",
        "version": "$1"
    },
    {
        "regex": "(?:^NPROneAndroid$|(?:^NPR%20One|nprone_android)/([\\d.]+))",
        "name": "NPR",
        "version": "$1"
    },
    {
        "regex": "Uforia/([\\d.]+)",
        "name": "Uforia",
        "version": "$1"
    },
    {
        "regex": "^LAT-Native-App",
        "name": "L.A. Times",
        "version": ""
    },
    {
        "regex": "(?:^NYT(?: |%20)?Audio(?:-iOS)?|nytios)/([\\d.]+)",
        "name": "The New York Times",
        "version": "$1"
    },
    {
        "regex": "^LiSTNR[.\\w]*/([\\d.]+)",
        "name": "LiSTNR",
        "version": "$1"
    },
    {
        "regex": "^Podu_player$",
        "name": "podU",
        "version": "$1"
    },
    {
        "regex": "^TiviMate/([\\d.]+)",
        "name": "TiviMate",
        "version": "$1"
    },
    {
        "regex": "IPTV/([\\d.]+)",
        "name": "IPTV",
        "version": "$1"
    },
    {
        "regex": "IPTV Pro/([\\d.]+)",
        "name": "IPTV Pro",
        "version": "$1"
    },
    {
        "regex": "^com\\.audials(?:\\.paid)?/([\\d.]+)",
        "name": "Audials",
        "version": "$1"
    },
    {
        "regex": "^CoolerFM/([\\d.]+)",
        "name": "Cooler",
        "version": "$1"
    },
    {
        "regex": "^Metacast/([\\d.]+)",
        "name": "Metacast",
        "version": "$1"
    },
    {
        "regex": "^mowPod/([\\d.]+)",
        "name": "mowPod",
        "version": "$1"
    },
    {
        "regex": "com\\.meecel\\.feedreader\\.RssDemonAd",
        "name": "RSSDemon",
        "version": ""
    },
    {
        "regex": "^Virgin(?:%20|\\s)Radio/([\\d.]+)",
        "name": "Virgin Radio",
        "version": "$1"
    },
    {
        "regex": "MetaMask(?:Mobile)?",
        "name": "MetaMask",
        "version": ""
    },
    {
        "regex": "\\+Simple Browser",
        "name": "+Simple",
        "version": ""
    },
    {
        "regex": "Bitwarden_Mobile/([\\d.]+)",
        "name": "Bitwarden",
        "version": "$1"
    },
    {
        "regex": "MXPlayer/([\\d.]+)",
        "name": "MX Player",
        "version": "$1"
    },
    {
        "regex": "HistoryHound/([\\d.]+)",
        "name": "HistoryHound",
        "version": "$1"
    },
    {
        "regex": "Quicksilver",
        "name": "Quicksilver",
        "version": ""
    },
    {
        "regex": "CamScanner/([\\d.]+)",
        "name": "CamScanner",
        "version": "$1"
    },
    {
        "regex": "OBS/(\\d+[.\\d]+)",
        "name": "OBS Studio",
        "version": "$1"
    },
    {
        "regex": "XSplitBroadcaster/(\\d+[.\\d]+)",
        "name": "XSplit Broadcaster",
        "version": "$1"
    },
    {
        "regex": "twitch-desktop-electron-platform.*spotlight/(\\d+[.\\d]+)",
        "name": "Twitch Studio",
        "version": "$1"
    },
    {
        "regex": "Stream Master$",
        "name": "Stream Master",
        "version": ""
    },
    {
        "regex": "Freespoke/(\\d+\\.[.\\d]+)",
        "name": "Freespoke",
        "version": "$1"
    },
    {
        "regex": "Whatplay",
        "name": "Whatplay",
        "version": ""
    },
    {
        "regex": "Lark/(\\d+[.\\d]+)",
        "name": "Lark",
        "version": "$1"
    },
    {
        "regex": "SearchCraft/(\\d+[.\\d]+)",
        "name": "SearchCraft",
        "version": "$1"
    },
    {
        "regex": "DeFiWallet/(\\d+[.\\d]+)",
        "name": "Crypto.com DeFi Wallet",
        "version": "$1"
    },
    {
        "regex": "Clipbox\\+/(\\d+[.\\d]+)",
        "name": "Clipbox+",
        "version": "$1"
    },
    {
        "regex": "appname/HideX",
        "name": "HideX",
        "version": ""
    },
    {
        "regex": "HMSCore(?:[ /]([\\d.]+))?(?!.*HuaweiBrowser)",
        "name": "Huawei Mobile Services",
        "version": "$1"
    },
    {
        "regex": "appname/PLAYit",
        "name": "PLAYit",
        "version": ""
    },
    {
        "regex": "Autopliuslt(?:/([\\d.]+))?",
        "name": "Autoplius.lt",
        "version": "$1"
    },
    {
        "regex": "HCom(?:/([\\d.]+))?",
        "name": "Hotels.com",
        "version": "$1"
    },
    {
        "regex": "CoinbaseRetail(?:/([\\d.]+))?",
        "name": "Coinbase",
        "version": "$1"
    },
    {
        "regex": "De Telegraaf(?:/([\\d.]+))?",
        "name": "De Telegraaf",
        "version": "$1"
    },
    {
        "regex": "waipu/([\\d.]+)",
        "name": "waipu.tv",
        "version": "$1"
    },
    {
        "regex": "Redditor",
        "name": "Redditor",
        "version": ""
    },
    {
        "regex": "com\\.topbuzz\\.videoen/([\\d.]+)",
        "name": "BuzzVideo",
        "version": "$1"
    },
    {
        "regex": "GlobalProtect",
        "name": "GlobalProtect",
        "version": ""
    },
    {
        "regex": "Trade Me(?:/([\\d.]+))?",
        "name": "Trade Me",
        "version": "$1"
    },
    {
        "regex": "XING(?:-iPhone)?/([\\d.]+)",
        "name": "XING",
        "version": "$1"
    },
    {
        "regex": "Bridge/([\\d.]+)",
        "name": "Bridge",
        "version": "$1"
    },
    {
        "regex": "iPlayTV/([\\d.]+)",
        "name": "iPlayTV",
        "version": "$1"
    },
    {
        "regex": "momoWebView/([\\d.]+)",
        "name": "MOMO",
        "version": "$1"
    },
    {
        "regex": "nate_app;appver:([\\d.]+)",
        "name": "nate",
        "version": "$1"
    },
    {
        "regex": "SOFI_APP_VERSION=([\\d.]+)",
        "name": "SoFi",
        "version": "$1"
    },
    {
        "regex": "WNYC(?: App)?[/ ]?([\\d.]+)?",
        "name": "WNYC",
        "version": "$1"
    },
    {
        "regex": "com\\.theepochtimes\\.mobile/([\\d.]+)",
        "name": "The Epoch Times",
        "version": "$1"
    },
    {
        "regex": "ReutersNews(?: App)?[/ ]?([\\d.]+)?",
        "name": "Reuters News",
        "version": "$1"
    },
    {
        "regex": "WatchFree/([\\d.]+)",
        "name": "WatchFree+",
        "version": "$1"
    },
    {
        "regex": "obsidian/([\\d.]+)",
        "name": "Obsidian",
        "version": "$1"
    },
    {
        "regex": "Perplexity",
        "name": "Perplexity",
        "version": ""
    },
    {
        "regex": "XShare",
        "name": "XShare",
        "version": ""
    },
    {
        "regex": "VISHAAPP ([\\d.]+)",
        "name": "Visha",
        "version": "$1"
    },
    {
        "regex": "nyt_android/([\\d.]+)",
        "name": "The Crossword",
        "version": "$1"
    },
    {
        "regex": "mojeek-app",
        "name": "Mojeek",
        "version": ""
    },
    {
        "regex": "Fiddler/(\\d+[.\\d]+)",
        "name": "Fiddler Classic",
        "version": "$1"
    },
    {
        "regex": "ZONApp/(?:iOS|Android)/([\\d.]+)",
        "name": "ZEIT ONLINE",
        "version": "$1"
    },
    {
        "regex": "tracepal(?:\\.app)?/([\\d.]+)",
        "name": "TracePal",
        "version": "$1"
    },
    {
        "regex": "topsecret\\.chat/([\\d.]+)",
        "name": "TopSecret Chat",
        "version": "$1"
    },
    {
        "regex": "Kwai/([\\d.]+)",
        "name": "Kwai",
        "version": "$1"
    },
    {
        "regex": "Kwai_Pro/([\\d.]+)",
        "name": "Kwai Pro",
        "version": "$1"
    },
    {
        "regex": "Sooplive Webview/([\\d.]+)",
        "name": "SOOP",
        "version": "$1"
    },
    {
        "regex": "GoEuro(?:Android|IOS )/([\\d.]+)",
        "name": "GoEuro",
        "version": "$1"
    },
    {
        "regex": "BOOM v([\\d.]+)",
        "name": "Boom360",
        "version": "$1"
    },
    {
        "regex": "WallaNews/([\\d.]+)",
        "name": "Walla News",
        "version": "$1"
    },
    {
        "regex": "TRP_iPhone_App/([\\d.]+)",
        "name": "TRP Retail Locator",
        "version": "$1"
    },
    {
        "regex": "Townnews-Now/([\\d.]+)",
        "name": "TownNews Now",
        "version": "$1"
    },
    {
        "regex": "^Klara/",
        "name": "Klara",
        "version": ""
    },
    {
        "regex": "EdmodoAndroid/([\\d.]+)",
        "name": "Edmodo",
        "version": "$1"
    },
    {
        "regex": "HFEducationIOS/([\\d.]+)",
        "name": "HeartFocus Education",
        "version": "$1"
    },
    {
        "regex": "HFIOS/([\\d.]+)",
        "name": "HeartFocus",
        "version": "$1"
    },
    {
        "regex": "OpenVAS-VT ([\\d.]+)",
        "name": "OpenVAS",
        "version": "$1"
    },
    {
        "regex": "appdb/([\\d.]+)",
        "name": "appdb",
        "version": "$1"
    },
    {
        "regex": "Apache/([\\d.]+)",
        "name": "Apache",
        "version": "$1"
    },
    {
        "regex": "smzdm ([\\d.]+)",
        "name": "smzdm",
        "version": "$1"
    },
    {
        "regex": "Zite/([\\d.]+)",
        "name": "Zite",
        "version": "$1"
    },
    {
        "regex": "DeepL/",
        "name": "DeepL",
        "version": ""
    },
    {
        "regex": "anythingllm-desktop/([\\d.]+)",
        "name": "Anything LLM",
        "version": "$1"
    },
    {
        "regex": "opgg-electron-app/([\\d.]+)",
        "name": "OP.GG",
        "version": "$1"
    },
    {
        "regex": "VidJuiceUniTube/([\\d.]+)",
        "name": "VidJuice UniTube",
        "version": "$1"
    },
    {
        "regex": "^Seekr/([\\d\\.]+).*Android",
        "name": "Seekr",
        "version": "$1"
    },
    {
        "regex": "^Seekr/([\\d\\.]+).*CFNetwork",
        "name": "Seekr",
        "version": "$1"
    },
    {
        "regex": "^Superbalist/([\\d.]+)",
        "name": "Superbalist",
        "version": "$1"
    },
    {
        "regex": " (?!(?:AppleWebKit|brave|Cypress|Franz|Mailspring|Notion|Basecamp|Evernote|catalyst|ramboxpro|BlueMail|BeakerBrowser|Dezor|TweakStyle|Colibri|Polypane|Singlebox|Skye|VibeMate|(?:d|LT|Glass|Sushi|Flash|OhHai)Browser|Sizzy))([a-z0-9]*)(?:-desktop|-electron-app)?/(\\d+\\.[\\d.]+).*Electron/",
        "name": "$1",
        "version": "$2"
    },
    {
        "regex": "AppVersion/([\\d.]+).+appname/((?!\\(null\\))[^/; ]*)",
        "name": "$2",
        "version": "$1"
    },
    {
        "regex": "(?!AlohaBrowser)([^/;]*)/(\\d+\\.[\\d.]+) \\((?:iPhone|iPad); (?:iOS|iPadOS) [0-9.]+; Scale/[0-9.]+\\)",
        "name": "$1",
        "version": "$2"
    }
];

});

parcelRegister("jjVmX", function(module, exports) {
module.exports = [
    {
        "regex": "Audacious(?:[ /]([\\d.]+))?",
        "name": "Audacious",
        "version": "$1"
    },
    {
        "regex": "(?:AlexaMediaPlayer/|^AlexaMediaPlayer/|^Echo/|Amazon;Echo(?:_|;)|^AlexaService/|^Alexa Mobile Voice/)([a-z\\d]+\\.[a-z.\\d]+)?",
        "name": "Alexa",
        "version": "$1"
    },
    {
        "regex": "Banshee(?:[ /]([\\d.]+))?",
        "name": "Banshee",
        "version": "$1"
    },
    {
        "regex": "Boxee(?:[ /]([\\d.]+))?",
        "name": "Boxee",
        "version": "$1"
    },
    {
        "regex": "Clementine(?:[ /]([\\d.]+))?",
        "name": "Clementine",
        "version": "$1"
    },
    {
        "regex": "Deezer(?:/([\\d.]+))?",
        "name": "Deezer",
        "version": "$1"
    },
    {
        "regex": "iTunes(?:-iPhone|-iPad)?(?:/([\\d.]+))?",
        "name": "iTunes",
        "version": "$1"
    },
    {
        "regex": "FlyCast(?:/([\\d.]+))?",
        "name": "FlyCast",
        "version": "$1"
    },
    {
        "regex": "foobar2000(?:/([\\d.]+))?",
        "name": "Foobar2000",
        "version": "$1"
    },
    {
        "regex": "MediaMonkey(?:[ /](\\d+[.\\d]+))?",
        "name": "MediaMonkey",
        "version": "$1"
    },
    {
        "regex": "Miro(?:/(\\d+[.\\d]+))?",
        "name": "Miro",
        "version": "$1"
    },
    {
        "regex": "NexPlayer(?:/(\\d+[.\\d]+))?",
        "name": "NexPlayer",
        "version": "$1"
    },
    {
        "regex": "Nightingale(?:/([\\d.]+))?",
        "name": "Nightingale",
        "version": "$1"
    },
    {
        "regex": "QuickTime(?:(?:(?:.+qtver=)|(?:(?: E-)?[\\./]))([\\d.]+))?",
        "name": "QuickTime",
        "version": "$1"
    },
    {
        "regex": "Songbird(?:/([\\d.]+))?",
        "name": "Songbird",
        "version": "$1"
    },
    {
        "regex": "SubStream(?:/([\\d.]+))?",
        "name": "SubStream",
        "version": "$1"
    },
    {
        "regex": "Sonos/([\\d.]+)?",
        "name": "SONOS",
        "version": "$1"
    },
    {
        "regex": "(?:Lib)?VLC(?:/([\\d.]+))?",
        "name": "VLC",
        "version": "$1"
    },
    {
        "regex": "Winamp(?:MPEG)?(?:/(\\d+[.\\d]+))?",
        "name": "Winamp",
        "version": "$1"
    },
    {
        "regex": "J\\. River Internet Reader/(\\d+\\.[.\\d]+)",
        "name": "JRiver Media Center",
        "version": "$1"
    },
    {
        "regex": "(?:Windows-Media-Player|NSPlayer)(?:/(\\d+[.\\d]+))?",
        "name": "Windows Media Player",
        "version": "$1"
    },
    {
        "regex": "XBMC(?:/([\\d.]+))?",
        "name": "XBMC",
        "version": "$1"
    },
    {
        "regex": "Kodi(?:/([\\d.]+))?",
        "name": "Kodi",
        "version": "$1"
    },
    {
        "regex": "stagefright(?:/([\\d.]+))?",
        "name": "Stagefright",
        "version": "$1"
    },
    {
        "regex": "GoogleChirp(?:/(\\d+[.\\d]+))?",
        "name": "Google Podcasts",
        "version": "$1"
    },
    {
        "regex": "Music Player Daemon (?:(\\d+[.\\d]+))?",
        "name": "Music Player Daemon",
        "version": "$1"
    },
    {
        "regex": "mpv (?:(\\d+[.\\d]+))?",
        "name": "mpv",
        "version": "$1"
    },
    {
        "regex": "HTC Streaming Player",
        "name": "HTC Streaming Player",
        "version": ""
    },
    {
        "regex": "MediaGo(?:/([\\w\\.]+))?",
        "name": "Sony Media Go",
        "version": "$1"
    },
    {
        "regex": "MPlayer[ /](\\d+\\.[\\d.])",
        "name": "MPlayer",
        "version": "$1"
    },
    {
        "regex": "Downcast/(\\d+\\.[\\d.]+)?",
        "name": "Downcast",
        "version": "$1"
    },
    {
        "regex": "^Juice/([\\d.]+)",
        "name": "Juice",
        "version": "$1"
    },
    {
        "regex": "just_audio/(\\d+\\.[.\\d]+)",
        "name": "Just Audio",
        "version": "$1"
    },
    {
        "regex": "^Kasts/(\\d+\\.[.\\d]+)",
        "name": "Kasts",
        "version": "$1"
    },
    {
        "regex": "MixerBox(?:%20Pro)?/([.\\d]+)",
        "name": "MixerBox",
        "version": "$1"
    },
    {
        "regex": "^MusicBee(?:/(\\d+\\.[.\\d]+))?",
        "name": "MusicBee",
        "version": "$1"
    },
    {
        "regex": "^amarok/(\\d+\\.[.\\d]+)",
        "name": "Amarok",
        "version": "$1"
    },
    {
        "regex": "Hubhopper/([\\d.]+)",
        "name": "Hubhopper",
        "version": "$1"
    },
    {
        "regex": "StudioDisplay/(\\d+\\.[\\d.]+)",
        "name": "StudioDisplay",
        "version": "$1"
    },
    {
        "regex": "JHV/SWHV-([.\\d+]+)",
        "name": "JHelioviewer",
        "version": "$1"
    },
    {
        "regex": "com\\.devcoder\\.iptvxtreamplayer",
        "name": "Xtream Player",
        "version": ""
    },
    {
        "regex": "DIGA(?:Plus/(\\d+\\.[.\\d]+))?",
        "name": "DIGA",
        "version": "$1"
    },
    {
        "regex": "YouView(?:HTML/(\\d+\\.[.\\d]+))?",
        "name": "YouView",
        "version": "$1"
    }
];

});

parcelRegister("55zDA", function(module, exports) {
module.exports = {
    "mark.via.gg": "Via",
    "mark.via.gp": "Via",
    "mark.via.gq": "Via",
    "mark.via.pm": "Via",
    "mark.viah": "Via",
    "com.pure.mini.browser": "Pure Mini Browser",
    "pure.lite.browser": "Pure Lite Browser",
    "acr.browser.Hexa": "Hexa Web Browser",
    "acr.browser.raisebrowserfull": "Raise Fast Browser",
    "acr.tez.browse": "Browspeed Browser",
    "com.Fast.BrowserUc.lite": "Fast Browser UC Lite",
    "acr.browser.barebones": "Lightning Browser",
    "anar.app.darkweb": "Dark Web Browser",
    "com.darkbrowser": "Dark Browser",
    "com.kiwibrowser.browser": "Kiwi",
    "com.cloudmosa.puffinFree": "Puffin Web Browser",
    "com.cloudmosa.puffin": "Puffin Web Browser",
    "com.cloudmosa.puffinIncognito": "Puffin Incognito Browser",
    "com.cloudmosa.puffinCloudBrowser": "Puffin Cloud Browser",
    "com.aloha.browser": "Aloha Browser",
    "com.cake.browser": "Cake Browser",
    "com.UCMobile.intl": "UC Browser",
    "com.iebrowser.fast": "IE Browser Fast",
    "com.internet.browser.secure": "Internet Browser Secure",
    "acr.browser.linxy": "Vegas Browser",
    "com.oh.bro": "OH Browser",
    "com.oh.brop": "OH Private Browser",
    "com.duckduckgo.mobile.android": "DuckDuckGo Privacy Browser",
    "net.onecook.browser": "Stargon",
    "com.mi.globalbrowser.mini": "Mint Browser",
    "com.hisense.odinbrowser": "Odin Browser",
    "com.brave.browser": "Brave",
    "com.brave.browser_beta": "Brave",
    "org.mozilla.klar": "Firefox Klar",
    "phx.hot.browser": "Anka Browser",
    "com.anka.browser": "Anka Browser",
    "org.mozilla.focus": "Firefox Focus",
    "org.mozilla.tv.firefox": "Firefox Focus",
    "com.vivaldi.browser": "Vivaldi",
    "web.browser.dragon": "Dragon Browser",
    "org.easyweb.browser": "Easy Browser",
    "com.xbrowser.play": "XBrowser Mini",
    "com.sharkeeapp.browser": "Sharkee Browser",
    "com.mobiu.browser": "Lark Browser",
    "com.qflair.browserq": "Pluma",
    "com.noxgroup.app.browser": "Nox Browser",
    "com.jio.web": "JioSphere",
    "com.ume.browser.cust": "Ume Browser",
    "com.ume.browser.international": "Ume Browser",
    "com.ume.browser.bose": "Ume Browser",
    "com.ume.browser.euas": "Ume Browser",
    "com.ume.browser.latinamerican": "Ume Browser",
    "com.ume.browser.mexicotelcel": "Ume Browser",
    "com.ume.browser.venezuelavtelca": "Ume Browser",
    "com.ume.browser.northamerica": "Ume Browser",
    "com.ume.browser.newage": "Ume Browser",
    "com.kuto.browser": "KUTO Mini Browser",
    "com.dolphin.browser.zero": "Dolphin Zero",
    "mobi.mgeek.TunnyBrowser": "Dolphin",
    "nextapp.atlas": "Atlas",
    "org.mozilla.rocket": "Firefox Rocket",
    "com.mx.browser": "Maxthon",
    "com.ecosia.android": "Ecosia",
    "org.lineageos.jelly": "Jelly",
    "com.opera.gx": "Opera GX",
    "br.marcelo.monumentbrowser": "Monument Browser",
    "com.airfind.deltabrowser": "Delta Browser",
    "com.apusapps.browser": "APUS Browser",
    "com.ask.browser": "Ask.com",
    "com.browser.tssomas": "Super Fast Browser",
    "iron.web.jalepano.browser": "SuperFast Browser",
    "yuce.browser.mini": "Ui Browser Mini",
    "SavySoda.PrivateBrowsing": "SavySoda",
    "savannah.internet.web.browser": "Savannah Browser",
    "com.gl9.cloudBrowser": "Surf Browser",
    "com.ucold.browser.secure.browse": "UC Browser Mini",
    "com.mycompany.app.soulbrowser": "Soul Browser",
    "com.quickbig.browser": "Indian UC Mini Browser",
    "com.opera.browser": "Opera",
    "com.opera.mini.native": "Opera Mini",
    "com.wSilverMobBrowser": "SilverMob US",
    "com.ksmobile.cb": "CM Browser",
    "com.cmcm.armorfly": "Armorfly Browser",
    "org.mini.freebrowser": "CM Mini",
    "com.anc.web.browser": "Comfort Browser",
    "fast.explorer.web.browser": "Fast Explorer",
    "net.soti.surf": "SOTI Surf",
    "com.lexi.browser": "Lexi Browser",
    "com.browser.pintar": "Smart Browser",
    "com.belva.browser": "Belva Browser",
    "com.belva.safe.browser": "Belva Browser",
    "com.youcare.browser": "YouCare",
    "org.lilo.mobile.android2020": "Lilo",
    "com.opera.cryptobrowser": "Opera Crypto",
    "AlohaBrowser": "Aloha Browser",
    "mark.via": "Via",
    "com.xpp.floatbrowser": "Float Browser",
    "com.kiddoware.kidsafebrowser": "Kids Safe Browser",
    "com.hideitpro.vbrowser": "vBrowser",
    "com.cgbrowser.rn": "CG Browser",
    "com.azka.browser.anti.blokir": "Azka Browser",
    "com.azka.browser": "Azka Browser",
    "com.micromaxinfo.browser": "Mmx Browser",
    "com.zeesitech.bitchutebrowser": "Bitchute Browser",
    "nova.all.video.downloader": "Nova Video Downloader Pro",
    "tukidev.pronhubbrowser.tanpavpn": "PronHub Browser",
    "com.crowbar.beaverlite": "Frost",
    "com.crowbar.beaverbrowser": "Frost+",
    "com.lenovo.browser": "Lenovo Browser",
    "com.transsion.phoenix": "Phoenix Browser",
    "quick.browser.secure": "Quick Browser",
    "com.asus.browser": "Asus Browser",
    "com.opera.touch": "Opera Touch",
    "com.ghostery.android.ghostery": "Ghostery Privacy Browser",
    "com.oceanhero.search": "OceanHero",
    "com.mebrowser.webapp": "Me Browser",
    "info.plateaukao.einkbro": "EinkBro",
    "com.fevdev.nakedbrowser": "Naked Browser",
    "com.fevdev.nakedbrowserlts": "Naked Browser",
    "com.fevdev.nakedbrowserpro": "Naked Browser Pro",
    "com.yasirshakoor.ducbrowser": "DUC Browser",
    "com.wDesiBrowser_13255326": "Desi Browser",
    "com.huawei.browser": "Huawei Browser Mobile",
    "com.phantom.me": "Phantom.me",
    "com.opera.mini.android": "Opera Mini",
    "jp.ejimax.berrybrowser": "Berry Browser",
    "com.fulldive.mobile": "Fulldive",
    "com.talpa.hibrowser": "Hi Browser",
    "org.midorinext.android": "Midori Lite",
    "reactivephone.msearch": "Smart Search & Web Browser",
    "com.sibimobilelab.amazebrowser": "Amaze Browser",
    "com.alohamobile.browser.lite": "Aloha Browser Lite",
    "com.tcl.browser": "BrowseHere",
    "com.seraphic.openinet.pre": "Open Browser",
    "com.seraphic.openinet.cvte": "Open Browser",
    "privatebrowser.securebrowser.com.klar": "Secure Private Browser",
    "in.pokebbrowser.bukablokirsitus": "HUB Browser",
    "com.wOpenBrowser_12576500": "Open Browser fast 5G",
    "com.wOpenbrowser_13506467": "Open Browser 4U",
    "com.MaxTube.browser": "MaxTube Browser",
    "com.ninexgen.chowbo": "Chowbo",
    "net.pertiller.debuggablebrowser": "Debuggable Browser",
    "com.appssppa.idesktoppcbrowser": "iDesktop PC Browser",
    "pi.browser": "Pi Browser",
    "com.xooloo.internet": "Xooloo Internet",
    "com.u_browser": "U Browser",
    "ai.blokee.browser.android": "Bloket",
    "com.vast.vpn.proxy.unblock": "Vast Browser",
    "com.security.xvpn.z35kb": "X-VPN",
    "com.security.xvpn.z35kb.amazon": "X-VPN",
    "com.security.xvpn.z35kb.huawei": "X-VPN",
    "com.yandex.browser.lite": "Yandex Browser Lite",
    "com.yandex.browser.beta": "Yandex Browser",
    "com.yandex.browser.alpha": "Yandex Browser",
    "cz.seznam.sbrowser": "Seznam Browser",
    "com.morrisxar.nav88": "Office Browser",
    "com.rabbit.incognito.browser": "Rabbit Private Browser",
    "arun.com.chromer": "Lynket Browser",
    "jp.hazuki.yuzubrowser": "Yuzu Browser",
    "com.swiftariel.browser.cherry": "Cherry Browser",
    "id.browser.vivid3": "Vivid Browser Mini",
    "com.browser.yo.indian": "Yo Browser",
    "com.mercandalli.android.browser": "G Browser",
    "com.bf.browser": "BXE Browser",
    "com.qihoo.browser": "360 Secure Browser",
    "com.qihoo.contents": "360 Secure Browser",
    "com.qihoo.haosou": "360 Secure Browser",
    "com.qihoo.padbrowser": "360 Secure Browser",
    "com.qihoo.sonybrowser": "360 Secure Browser",
    "org.zirco": "Zirco Browser",
    "org.tint": "Tint Browser",
    "com.skyfire.browser": "Skyfire",
    "com.sonymobile.smallbrowser": "Sony Small Browser",
    "org.hola": "hola! Browser",
    "it.ideasolutions.amerigo": "Amerigo",
    "org.xbrowser.prosuperfast": "xBrowser Pro Super Fast",
    "org.plus18.android": "18+ Privacy Browser",
    "com.beyond.privatebrowser": "Beyond Private Browser",
    "com.blacklion.browser": "Black Lion Browser",
    "com.opera.mini.native.ShonizME": "Opera Mini",
    "com.tuc.mini.st": "TUC Mini Browser",
    "com.roidtechnologies.appbrowzer": "AppBrowzer",
    "com.futuristic.sx": "SX Browser",
    "hot.fiery.browser": "Fiery Browser",
    "in.nismah.yagi": "YAGI",
    "com.apn.mobile.browser.cherry": "APN Browser",
    "com.apn.mobile.browser.umeatt": "APN Browser",
    "com.apn.mobile.browser.zte": "APN Browser",
    "com.tencent.mtt": "QQ Browser",
    "com.wordly.translate.browser": "NextWord Browser",
    "idm.internet.download.manager": "1DM Browser",
    "idm.internet.download.manager.plus": "1DM+ Browser",
    "com.veeraapps.newadult": "Adult Browser",
    "com.xnxbrowser.rampage": "XNX Browser",
    "com.xtremecast": "XtremeCast",
    "com.xvideobrowserlite.xvideoDownloaderbrowserlite": "X Browser Lite",
    "com.xxnxx.browser.proxy.vpn": "xBrowser",
    "com.sweetbrowser.ice": "Sweet Browser",
    "com.mcent.browser": "mCent",
    "com.htc.sense.browser": "HTC Browser",
    "com.browlser": "Browlser",
    "app.browserhub.download": "Browser Hup Pro",
    "com.flyperinc.flyperlink": "Flyperlink",
    "com.w3engineers.banglabrowser": "Bangla Browser",
    "com.coccoc.trinhduyet": "Coc Coc",
    "com.browser.explore": "Explore Browser",
    "com.microsoft.emmx": "Microsoft Edge",
    "com.explore.web.browser": "Web Browser & Explorer",
    "privacy.explorer.fast.safe.browser": "Privacy Explorer Fast Safe",
    "app.soundy.browser": "Soundy Browser",
    "com.ivvi.browser": "IVVI Browser",
    "com.nomone.vrbrowser": "NOMone VR Browser",
    "com.opus.browser": "Opus Browser",
    "com.arvin.browser": "Arvin",
    "com.pawxy.browser": "Pawxy",
    "com.internet.tvbrowser": "LUJO TV Browser",
    "com.logicui.tvbrowser2": "LogicUI TV Browser",
    "com.opera.browser.afin": "Opera",
    "com.opera.browser.beta": "Opera",
    "com.quark.browser": "Quark",
    "jp.co.yahoo.android.ybrowser": "Yahoo! Japan Browser",
    "com.tv.browser.open": "Open TV Browser",
    "com.ornet.torbrowser": "OrNET Browser",
    "com.browsbit": "BrowsBit",
    "org.mozilla.firefox": "Firefox Mobile",
    "com.yandex.browser": "Yandex Browser",
    "com.opera.mini.native.beta": "Opera Mini",
    "com.sec.android.app.sbrowser": "Samsung Browser",
    "com.sec.android.app.sbrowser.lite": "Samsung Browser Lite",
    "com.browser.elmurzaev": "World Browser",
    "every.browser.inc": "Every Browser",
    "com.mi.globalbrowser": "Mi Browser",
    "nu.tommie.inbrowser": "InBrowser",
    "com.insta.browser": "Insta Browser",
    "com.alohamobile.vertexsurf": "Vertex Surf",
    "com.hollabrowser.meforce": "Holla Web Browser",
    "org.torbrowser.torproject": "Tor Browser",
    "org.torproject.torbrowser": "Tor Browser",
    "com.marslab.browserz": "MarsLab Web Browser",
    "com.mini.web.browser": "Sunflower Browser",
    "com.cavebrowser": "Cave Browser",
    "com.zordo.browser": "Zordo Browser",
    "freedom.theanarch.org.freedom": "Freedom Browser",
    "com.lechneralexander.privatebrowser": "Private Internet Browser",
    "com.airfind.browser": "Airfind Secure Browser",
    "com.securex.browser": "SecureX",
    "com.sec.android.app.sbrowser.beta": "Samsung Browser",
    "threads.thor": "Thor",
    "com.androidbull.incognito.browser": "Incognito Browser",
    "com.mosoft.godzilla": "Godzilla Browser",
    "com.oceanbrowser.mobile.android": "Ocean Browser",
    "com.qmamu.browser": "Qmamu",
    "com.techlastudio.bfbrowser": "BF Browser",
    "com.befaster.bfbrowser": "BF Browser",
    "app.nextinnovations.brokeep": "BroKeep Browser",
    "org.lilo.app": "Lilo",
    "proxy.browser.unblock.sites.proxybrowser.unblocksites": "Proxy Browser",
    "com.hotsurf.browser": "HotBrowser",
    "vpn.video.downloader": "VD Browser",
    "com.aospstudio.tvsearch": "Quick Search TV",
    "com.go.browser": "GO Browser",
    "com.apgsolutionsllc.APGSOLUTIONSLLC0007": "Basic Web Browser",
    "com.phlox.tvwebbrowser": "TV Bro",
    "com.lovense.vibemate": "VibeMate",
    "dev.sect.lotus.browser.videoapp": "Lotus",
    "com.qjy.browser": "QJY TV Browser",
    "com.airwatch.browser": "VMware AirWatch",
    "com.microsoft.intune.mam.managedbrowser": "Intune Managed Browser",
    "com.tencent.bang": "Bang",
    "com.outcoder.browser": "Surfy Browser",
    "ginxdroid.gdm": "GinxDroid Browser",
    "on.browser": "OnBrowser Lite",
    "com.pico.browser.overseas": "PICO Browser",
    "com.cliqz.browser": "Cliqz",
    "org.hola.prem": "hola! Browser",
    "com.baidu.browser.inter": "Baidu Browser",
    "org.torproject.torbrowser_alpha": "Tor Browser",
    "com.ilegendsoft.mercury": "Mercury",
    "com.apn.mobile.browser.coolpad": "APN Browser",
    "com.apn.mobile.browser.infosonics": "APN Browser",
    "net.dezor.browser": "Dezor",
    "com.involta.involtago": "Involta Go",
    "jp.ddo.pigsty.HabitBrowser": "Habit Browser",
    "org.browser.owl": "Owl Browser",
    "com.orbitum.browser": "Orbitum",
    "com.appsverse.photon": "Photon",
    "fr.agrange.bbbrowser": "Keyboard Browser",
    "com.stealthmobile.browser": "Stealth Browser",
    "com.wcd.talkto": "TalkTo",
    "com.foxylab.airfox": "Proxynet",
    "io.github.mthli.goodbrowser": "Good Browser",
    "app.proxyiumbrowser.android": "Proxyium",
    "com.vuhuv": "Vuhuv",
    "com.fast.fireBrowser": "Fire Browser",
    "acr.browser.lightning": "Lightning Browser Plus",
    "birapp.dark.web": "Dark Web",
    "birapp.dark.web.private": "Dark Web Private",
    "com.hihonor.baidu.browser": "HONOR Browser",
    "com.browser.pintar.vpn": "Pintar Browser",
    "com.ucimini.internetbrowser": "Browser Mini",
    "de.baumann.browser": "FOSS Browser",
    "com.oversea.mybrowser": "Peach Browser",
    "com.apptec360.android.browser": "AppTec Secure Browser",
    "com.ojr.browser.anti.blokir": "OJR Browser",
    "com.vworldc.tusk": "TUSK",
    "com.stoutner.privacybrowser.standard": "Privacy Browser",
    "com.techlastudio.proxyfoxbrowser": "ProxyFox",
    "com.vielianztlabs.browser": "ProxyMax",
    "com.keepsolid.privatebrowser": "KeepSolid Browser",
    "com.onionsearchengine.focus": "ONIONBrowser",
    "com.best.quick.browser": "Ai Browser",
    "miada.tv.webbrowser": "Internet Webbrowser",
    "com.kaweapp.webexplorer": "Web Explorer",
    "com.halo.browser": "Halo Browser",
    "com.mmbox.xbrowser": "MMBOX XBrowser",
    "com.tvwebbrowser.v22": "TV-Browser Internet",
    "com.tvwebbrowserpaid.v22": "TV-Browser Internet",
    "xnx.browser.browse.Xnxnewx": "XnBrowse",
    "com.metax.browser": "Open Browser Lite",
    "com.getkeepsafe.browser": "Keepsafe Browser",
    "com.hawk.android.browser": "Hawk Turbo Browser",
    "com.zte.nubrowser": "ZTE Browser",
    "com.cloaktp.browser": "Cloak Private Browser",
    "company.thebrowser.arc": "Arc Search",
    "com.android.webview": "Chrome Webview",
    "com.heytap.browser": "HeyTapBrowser"
};

});

parcelRegister("7dXwq", function(module, exports) {
// prettier-ignore
module.exports = {
    'V1': 'Via',
    '1P': 'Pure Mini Browser',
    '4P': 'Pure Lite Browser',
    '1R': 'Raise Fast Browser',
    'R1': 'Rabbit Private Browser',
    'FQ': 'Fast Browser UC Lite',
    'FJ': 'Fast Explorer',
    '1L': 'Lightning Browser',
    '1C': 'Cake Browser',
    '1I': 'IE Browser Fast',
    '1V': 'Vegas Browser',
    '1O': 'OH Browser',
    '3O': 'OH Private Browser',
    '1X': 'XBrowser Mini',
    '1S': 'Sharkee Browser',
    '2L': 'Lark Browser',
    '3P': 'Pluma',
    '1A': 'Anka Browser',
    'AZ': 'Azka Browser',
    '1D': 'Dragon Browser',
    '1E': 'Easy Browser',
    'DW': 'Dark Web Browser',
    'D6': 'Dark Browser',
    '18': '18+ Privacy Browser',
    '1B': '115 Browser',
    'DM': '1DM Browser',
    '1M': '1DM+ Browser',
    '2B': '2345 Browser',
    '3B': '360 Secure Browser',
    '36': '360 Phone Browser',
    '7B': '7654 Browser',
    'AA': 'Avant Browser',
    'AB': 'ABrowse',
    '4A': 'Acoo Browser',
    'BW': 'AdBlock Browser',
    'A7': 'Adult Browser',
    '8A': 'Ai Browser',
    'A9': 'Airfind Secure Browser',
    'AF': 'ANT Fresco',
    'AG': 'ANTGalio',
    'AL': 'Aloha Browser',
    'AH': 'Aloha Browser Lite',
    'A8': 'ALVA',
    '9A': 'AltiBrowser',
    'AM': 'Amaya',
    'A3': 'Amaze Browser',
    'A5': 'Amerigo',
    'AO': 'Amigo',
    'AN': 'Android Browser',
    '3A': 'AOL Explorer',
    'AE': 'AOL Desktop',
    'AD': 'AOL Shield',
    'A4': 'AOL Shield Pro',
    '2A': 'Aplix',
    'A6': 'AppBrowzer',
    '0A': 'AppTec Secure Browser',
    'AP': 'APUS Browser',
    'AR': 'Arora',
    'AX': 'Arctic Fox',
    'AV': 'Amiga Voyager',
    'AW': 'Amiga Aweb',
    'PN': 'APN Browser',
    '6A': 'Arachne',
    'RA': 'Arc Search',
    'R5': 'Armorfly Browser',
    'AI': 'Arvin',
    'AK': 'Ask.com',
    'AU': 'Asus Browser',
    'A0': 'Atom',
    'AT': 'Atomic Web Browser',
    'A2': 'Atlas',
    'AS': 'Avast Secure Browser',
    'VG': 'AVG Secure Browser',
    'AC': 'Avira Secure Browser',
    'A1': 'AwoX',
    '7A': 'Awesomium',
    '5B': 'Basic Web Browser',
    'BA': 'Beaker Browser',
    'BM': 'Beamrise',
    'F7': 'BF Browser',
    'BB': 'BlackBerry Browser',
    '6B': 'Bluefy',
    'H1': 'BrowseHere',
    'B8': 'Browser Hup Pro',
    'BD': 'Baidu Browser',
    'BS': 'Baidu Spark',
    'BG': 'Bang',
    'B9': 'Bangla Browser',
    'BI': 'Basilisk',
    'BV': 'Belva Browser',
    'B5': 'Beyond Private Browser',
    'BE': 'Beonex',
    'B2': 'Berry Browser',
    'BT': 'Bitchute Browser',
    '9B': 'BizBrowser',
    'BH': 'BlackHawk',
    'B0': 'Bloket',
    'BJ': 'Bunjalloo',
    'BL': 'B-Line',
    'B6': 'Black Lion Browser',
    'BU': 'Blue Browser',
    'BO': 'Bonsai',
    'BN': 'Borealis Navigator',
    'BR': 'Brave',
    'BK': 'BriskBard',
    'K2': 'BroKeep Browser',
    'B3': 'Browspeed Browser',
    'BX': 'BrowseX',
    'BZ': 'Browzar',
    'B7': 'Browlser',
    'M9': 'Browser Mini',
    '4B': 'BrowsBit',
    'BY': 'Biyubi',
    'BF': 'Byffox',
    'B4': 'BXE Browser',
    'CA': 'Camino',
    '5C': 'Catalyst',
    'XP': 'Catsxp',
    '0C': 'Cave Browser',
    'CL': 'CCleaner',
    'C8': 'CG Browser',
    'CJ': 'ChanjetCloud',
    'C6': 'Chedot',
    'C9': 'Cherry Browser',
    'C0': 'Centaury',
    'CQ': 'Cliqz',
    'CC': 'Coc Coc',
    'C4': 'CoolBrowser',
    'C2': 'Colibri',
    '6C': 'Columbus Browser',
    'CD': 'Comodo Dragon',
    'C1': 'Coast',
    'CX': 'Charon',
    'G0': 'ChatGPT Atlas',
    'CE': 'CM Browser',
    'C7': 'CM Mini',
    'CF': 'Chrome Frame',
    'HC': 'Headless Chrome',
    'CH': 'Chrome',
    'CI': 'Chrome Mobile iOS',
    'CK': 'Conkeror',
    'CM': 'Chrome Mobile',
    '3C': 'Chowbo',
    '7C': 'Classilla',
    'CN': 'CoolNovo',
    '4C': 'Colom Browser',
    'CO': 'CometBird',
    '2C': 'Comfort Browser',
    'CB': 'COS Browser',
    'CW': 'Cornowser',
    'C3': 'Chim Lac',
    'CP': 'ChromePlus',
    'CR': 'Chromium',
    'C5': 'Chromium GOST',
    'CY': 'Cyberfox',
    'CS': 'Cheshire',
    '8C': 'Cromite',
    'RC': 'Crow Browser',
    'CT': 'Crusta',
    'CG': 'Craving Explorer',
    'CZ': 'Crazy Browser',
    'CU': 'Cunaguaro',
    'CV': 'Chrome Webview',
    'YC': 'CyBrowser',
    'DB': 'dbrowser',
    'PD': 'Peeps dBrowser',
    'DK': 'Dark Web',
    'DP': 'Dark Web Private',
    'D1': 'Debuggable Browser',
    'DC': 'Decentr',
    'DE': 'Deepnet Explorer',
    'DG': 'deg-degan',
    'DA': 'Deledao',
    'DT': 'Delta Browser',
    'D0': 'Desi Browser',
    'DS': 'DeskBrowse',
    'D3': 'Dezor',
    'II': 'Diigo Browser',
    'D2': 'DoCoMo',
    'DF': 'Dolphin',
    'DZ': 'Dolphin Zero',
    'DO': 'Dorado',
    'DR': 'Dot Browser',
    'DL': 'Dooble',
    'DI': 'Dillo',
    'DU': 'DUC Browser',
    'DD': 'DuckDuckGo Privacy Browser',
    'E1': 'East Browser',
    'EC': 'Ecosia',
    'EW': 'Edge WebView',
    'EV': 'Every Browser',
    'EI': 'Epic',
    'EL': 'Elinks',
    'EN': 'EinkBro',
    'EB': 'Element Browser',
    'EE': 'Elements Browser',
    'EO': 'Eolie',
    'EX': 'Explore Browser',
    'EZ': 'eZ Browser',
    'E2': 'EudoraWeb',
    'EU': 'EUI Browser',
    'EP': 'GNOME Web',
    'G1': 'G Browser',
    'ES': 'Espial TV Browser',
    'FG': 'fGet',
    'FA': 'Falkon',
    'FX': 'Faux Browser',
    'F8': 'Fire Browser',
    'F4': 'Fiery Browser',
    'F1': 'Firefox Mobile iOS',
    'FB': 'Firebird',
    'FD': 'Fluid',
    'FE': 'Fennec',
    'FF': 'Firefox',
    'FK': 'Firefox Focus',
    'FY': 'Firefox Reality',
    'FR': 'Firefox Rocket',
    '1F': 'Firefox Klar',
    'F0': 'Float Browser',
    'FL': 'Flock',
    'FP': 'Floorp',
    'FO': 'Flow',
    'F2': 'Flow Browser',
    'FM': 'Firefox Mobile',
    'FW': 'Fireweb',
    'FN': 'Fireweb Navigator',
    'FH': 'Flash Browser',
    'FS': 'Flast',
    'F5': 'Flyperlink',
    'F9': 'FOSS Browser',
    'FU': 'FreeU',
    'F6': 'Freedom Browser',
    'FT': 'Frost',
    'F3': 'Frost+',
    'FI': 'Fulldive',
    'GA': 'Galeon',
    'G8': 'Gener8',
    'GH': 'Ghostery Privacy Browser',
    'GI': 'GinxDroid Browser',
    'GB': 'Glass Browser',
    'GD': 'Godzilla Browser',
    'G3': 'Good Browser',
    'GE': 'Google Earth',
    'GP': 'Google Earth Pro',
    'GO': 'GOG Galaxy',
    'GR': 'GoBrowser',
    'GK': 'GoKu',
    'G2': 'GO Browser',
    'RN': 'GreenBrowser',
    'HW': 'Habit Browser',
    'H7': 'Halo Browser',
    'HB': 'Harman Browser',
    'HS': 'HasBrowser',
    'HA': 'Hawk Turbo Browser',
    'HQ': 'Hawk Quick Browser',
    'HE': 'Helio',
    'HN': 'Herond Browser',
    'HX': 'Hexa Web Browser',
    'H8': 'HeyTapBrowser',
    'HI': 'Hi Browser',
    'HO': 'hola! Browser',
    'H4': 'Holla Web Browser',
    'H5': 'HotBrowser',
    'HJ': 'HotJava',
    'H6': 'HONOR Browser',
    'HT': 'HTC Browser',
    'HU': 'Huawei Browser Mobile',
    'HP': 'Huawei Browser',
    'HM': 'Harmony 360 Browser',
    'H3': 'HUB Browser',
    'IO': 'iBrowser',
    'IS': 'iBrowser Mini',
    'IB': 'IBrowse',
    'I6': 'iDesktop PC Browser',
    'IC': 'iCab',
    'I2': 'iCab Mobile',
    '4I': 'iNet Browser',
    'I1': 'Iridium',
    'I3': 'Iron Mobile',
    'I4': 'IceCat',
    'ID': 'IceDragon',
    'IV': 'Isivioo',
    'I8': 'IVVI Browser',
    'IW': 'Iceweasel',
    '2I': 'Impervious Browser',
    'N3': 'Incognito Browser',
    'IN': 'Inspect Browser',
    'I9': 'Insta Browser',
    'IE': 'Internet Explorer',
    'I7': 'Internet Browser Secure',
    '5I': 'Internet Webbrowser',
    '3I': 'Intune Managed Browser',
    'I5': 'Indian UC Mini Browser',
    'Z0': 'InBrowser',
    'IG': 'Involta Go',
    'IM': 'IE Mobile',
    'IR': 'Iron',
    'JB': 'Japan Browser',
    'JS': 'Jasmine',
    'JA': 'JavaFX',
    'JL': 'Jelly',
    'JI': 'Jig Browser',
    'JP': 'Jig Browser Plus',
    'JO': 'JioSphere',
    'JZ': 'JUZI Browser',
    'KB': 'K.Browser',
    'KF': 'Keepsafe Browser',
    'K7': 'KeepSolid Browser',
    'KS': 'Kids Safe Browser',
    'KI': 'Kindle Browser',
    'KM': 'K-meleon',
    'KJ': 'K-Ninja',
    'KO': 'Konqueror',
    'KP': 'Kapiko',
    'KE': 'Keyboard Browser',
    'KN': 'Kinza',
    'K4': 'Kitt',
    'KW': 'Kiwi',
    'KD': 'Kode Browser',
    'KU': 'KUN',
    'KT': 'KUTO Mini Browser',
    'KY': 'Kylo',
    'KZ': 'Kazehakase',
    'LB': 'Cheetah Browser',
    'LD': 'Ladybird',
    'LA': 'Lagatos Browser',
    'GN': 'Legan Browser',
    'LR': 'Lexi Browser',
    'LV': 'Lenovo Browser',
    'LF': 'LieBaoFast',
    'LG': 'LG Browser',
    'LH': 'Light',
    'L4': 'Lightning Browser Plus',
    'L1': 'Lilo',
    'LI': 'Links',
    'RI': 'Liri Browser',
    'LC': 'LogicUI TV Browser',
    'IF': 'Lolifox',
    'L3': 'Lotus',
    'LO': 'Lovense Browser',
    'LT': 'LT Browser',
    'LU': 'LuaKit',
    'LJ': 'LUJO TV Browser',
    'LL': 'Lulumi',
    'LS': 'Lunascape',
    'LN': 'Lunascape Lite',
    'LX': 'Lynx',
    'L2': 'Lynket Browser',
    'MD': 'Mandarin',
    'MP': 'Maple',
    'M5': 'MarsLab Web Browser',
    'M7': 'MaxBrowser',
    'M1': 'mCent',
    'MB': 'MicroB',
    'MC': 'NCSA Mosaic',
    'MZ': 'Meizu Browser',
    'ME': 'Mercury',
    'M2': 'Me Browser',
    'MF': 'Mobile Safari',
    'MI': 'Midori',
    'M3': 'Midori Lite',
    'M6': 'MixerBox AI',
    'MO': 'Mobicip',
    'MU': 'Mi Browser',
    'MS': 'Mobile Silk',
    'MK': 'Mogok Browser',
    'M8': 'Motorola Internet Browser',
    'MN': 'Minimo',
    'MT': 'Mint Browser',
    'MX': 'Maxthon',
    'M4': 'MaxTube Browser',
    'MA': 'Maelstrom',
    '3M': 'Mises',
    'MM': 'Mmx Browser',
    'NM': 'MxNitro',
    'MY': 'Mypal',
    'MR': 'Monument Browser',
    'MW': 'MAUI WAP Browser',
    'N7': 'Naenara Browser',
    'NW': 'Navigateur Web',
    'NK': 'Naked Browser',
    'NA': 'Naked Browser Pro',
    'NR': 'NFS Browser',
    'N5': 'Ninetails',
    'NB': 'Nokia Browser',
    'NO': 'Nokia OSS Browser',
    'NV': 'Nokia Ovi Browser',
    'N2': 'Norton Private Browser',
    'NX': 'Nox Browser',
    'N1': 'NOMone VR Browser',
    'N6': 'NOOK Browser',
    'NE': 'NetSurf',
    'NF': 'NetFront',
    'NL': 'NetFront Life',
    'NP': 'NetPositive',
    'NS': 'Netscape',
    'WR': 'NextWord Browser',
    'N8': 'Ninesky',
    'NT': 'NTENT Browser',
    'NU': 'Nuanti Meta',
    'NI': 'Nuviu',
    'O9': 'Ocean Browser',
    'OC': 'Oculus Browser',
    'O6': 'Odd Browser',
    'O1': 'Opera Mini iOS',
    'OB': 'Obigo',
    'O2': 'Odin',
    '2O': 'Odin Browser',
    'H2': 'OceanHero',
    'OD': 'Odyssey Web Browser',
    'OF': 'Off By One',
    'O5': 'Office Browser',
    'HH': 'OhHai Browser',
    'OL': 'OnBrowser Lite',
    'OE': 'ONE Browser',
    'N4': 'Onion Browser',
    '1N': 'ONIONBrowser',
    'Y1': 'Opera Crypto',
    'OX': 'Opera GX',
    'OG': 'Opera Neon',
    'OH': 'Opera Devices',
    'OI': 'Opera Mini',
    'OM': 'Opera Mobile',
    'OP': 'Opera',
    'ON': 'Opera Next',
    'OO': 'Opera Touch',
    'OU': 'Orbitum',
    'OA': 'Orca',
    'OS': 'Ordissimo',
    'OR': 'Oregano',
    'O0': 'Origin In-Game Overlay',
    'OY': 'Origyn Web Browser',
    'O8': 'OrNET Browser',
    'OV': 'Openwave Mobile Browser',
    'O3': 'OpenFin',
    'O4': 'Open Browser',
    '4U': 'Open Browser 4U',
    '5G': 'Open Browser fast 5G',
    '5O': 'Open Browser Lite',
    'O7': 'Open TV Browser',
    'OW': 'OmniWeb',
    'OT': 'Otter Browser',
    '4O': 'Owl Browser',
    'JR': 'OJR Browser',
    'PL': 'Palm Blazer',
    'PM': 'Pale Moon',
    'PY': 'Polypane',
    '8P': 'Prism',
    'PP': 'Oppo Browser',
    'P6': 'Opus Browser',
    'PR': 'Palm Pre',
    '2E': 'Pocket Internet Explorer',
    '7I': 'Puffin Cloud Browser',
    '6I': 'Puffin Incognito Browser',
    'PU': 'Puffin Secure Browser',
    '2P': 'Puffin Web Browser',
    'PW': 'Palm WebPro',
    'PA': 'Palmscape',
    'P7': 'Pawxy',
    '0P': 'Peach Browser',
    'PE': 'Perfect Browser',
    'K6': 'Perk',
    'P1': 'Phantom.me',
    'PH': 'Phantom Browser',
    'PX': 'Phoenix',
    'PB': 'Phoenix Browser',
    '5P': 'Photon',
    'N9': 'Pintar Browser',
    'P9': 'PirateBrowser',
    'P8': 'PICO Browser',
    'PF': 'PlayFree Browser',
    'PK': 'PocketBook Browser',
    'PO': 'Polaris',
    'PT': 'Polarity',
    'LY': 'PolyBrowser',
    '9P': 'Presearch',
    'BP': 'Privacy Browser',
    'PI': 'PrivacyWall',
    'P4': 'Privacy Explorer Fast Safe',
    'X5': 'Cloak Private Browser',
    'P3': 'Private Internet Browser',
    'P5': 'Proxy Browser',
    '7P': 'Proxyium',
    '6P': 'Proxynet',
    '2F': 'ProxyFox',
    '2M': 'ProxyMax',
    'P2': 'Pi Browser',
    'P0': 'PronHub Browser',
    'PC': 'PSI Secure Browser',
    'RW': 'Reqwireless WebViewer',
    'RO': 'Roccat',
    'PS': 'Microsoft Edge',
    'QA': 'Qazweb',
    'QI': 'Qiyu',
    'QJ': 'QJY TV Browser',
    'Q3': 'Qmamu',
    'Q4': 'Quick Search TV',
    'Q2': 'QQ Browser Lite',
    'Q1': 'QQ Browser Mini',
    'QQ': 'QQ Browser',
    'QS': 'Quick Browser',
    'QT': 'Qutebrowser',
    'QU': 'Quark',
    'Q6': 'QuarkPC',
    'Q7': 'Quetta',
    'QZ': 'QupZilla',
    'QM': 'Qwant Mobile',
    'Q5': 'QtWeb',
    'QW': 'QtWebEngine',
    'R3': 'Rakuten Browser',
    'R4': 'Rakuten Web Search',
    'R2': 'Raspbian Chromium',
    'RT': 'RCA Tor Explorer',
    'RE': 'Realme Browser',
    'RK': 'Rekonq',
    'RM': 'RockMelt',
    'RB': 'Roku Browser',
    'SB': 'Samsung Browser',
    '3L': 'Samsung Browser Lite',
    'SA': 'Sailfish Browser',
    'R0': 'SberBrowser',
    'S8': 'Seewo Browser',
    'SC': 'SEMC-Browser',
    'SE': 'Sogou Explorer',
    'SO': 'Sogou Mobile Browser',
    'RF': 'SOTI Surf',
    '2S': 'Soul Browser',
    'T0': 'Soundy Browser',
    'SF': 'Safari',
    'PV': 'Safari Technology Preview',
    'S5': 'Safe Exam Browser',
    'SW': 'SalamWeb',
    'VN': 'Savannah Browser',
    'SD': 'SavySoda',
    'S9': 'Secure Browser',
    'SV': 'SFive',
    'SH': 'Shiira',
    'K1': 'Sidekick',
    'S1': 'SimpleBrowser',
    '3S': 'SilverMob US',
    'ZB': 'Singlebox',
    'SY': 'Sizzy',
    'K3': 'Skye',
    'SK': 'Skyfire',
    'KL': 'SkyLeap',
    'SS': 'Seraphic Sraf',
    'KK': 'SiteKiosk',
    'SL': 'Sleipnir',
    '8B': 'SlimBoat',
    'S6': 'Slimjet',
    'S7': 'SP Browser',
    '9S': 'Sony Small Browser',
    '8S': 'Secure Private Browser',
    'X2': 'SecureX',
    'T1': 'Stampy Browser',
    '7S': '7Star',
    'SQ': 'Smart Browser',
    '6S': 'Smart Search & Web Browser',
    'LE': 'Smart Lenovo Browser',
    'OZ': 'Smooz',
    'SN': 'Snowshoe',
    'K5': 'Spark',
    'B1': 'Spectre Browser',
    'S2': 'Splash',
    'SI': 'Sputnik Browser',
    'SR': 'Sunrise',
    '0S': 'Sunflower Browser',
    'SP': 'SuperBird',
    'SU': 'Super Fast Browser',
    '5S': 'SuperFast Browser',
    'HR': 'Sushi Browser',
    'S3': 'surf',
    '4S': 'Surf Browser',
    'RY': 'Surfy Browser',
    'SG': 'Stargon',
    'S0': 'START Internet Browser',
    '5A': 'Stealth Browser',
    'S4': 'Steam In-Game Overlay',
    'ST': 'Streamy',
    'SX': 'Swiftfox',
    'W7': 'Swiftweasel',
    'SZ': 'Seznam Browser',
    'W1': 'Sweet Browser',
    '2X': 'SX Browser',
    'TP': 'T+Browser',
    'TR': 'T-Browser',
    'TO': 't-online.de Browser',
    'TT': 'TalkTo',
    'TA': 'Tao Browser',
    'T2': 'tararia',
    'TH': 'Thor',
    '1T': 'Tor Browser',
    'TF': 'TenFourFox',
    'TB': 'Tenta Browser',
    'TE': 'Tesla Browser',
    'TZ': 'Tizen Browser',
    'TI': 'Tint Browser',
    'TL': 'TrueLocation Browser',
    'TC': 'TUC Mini Browser',
    'TK': 'TUSK',
    'TU': 'Tungsten',
    'TG': 'ToGate',
    'T3': 'Total Browser',
    'TQ': 'TQ Browser',
    'TS': 'TweakStyle',
    'TV': 'TV Bro',
    'T4': 'TV-Browser Internet',
    'U0': 'U Browser',
    'UB': 'UBrowser',
    'UC': 'UC Browser',
    'UH': 'UC Browser HD',
    'UM': 'UC Browser Mini',
    'UT': 'UC Browser Turbo',
    'UI': 'Ui Browser Mini',
    'UP': 'UPhone Browser',
    'UR': 'UR Browser',
    'UZ': 'Uzbl',
    'UE': 'Ume Browser',
    'V0': 'vBrowser',
    'VA': 'Vast Browser',
    'V3': 'VD Browser',
    'VR': 'Veera',
    'VE': 'Venus Browser',
    'WD': 'Vewd Browser',
    'V5': 'VibeMate',
    'N0': 'Nova Video Downloader Pro',
    'VS': 'Viasat Browser',
    'VI': 'Vivaldi',
    'VV': 'vivo Browser',
    'V2': 'Vivid Browser Mini',
    'VB': 'Vision Mobile Browser',
    'V4': 'Vertex Surf',
    'VM': 'VMware AirWatch',
    'V6': 'VMS Mosaic',
    'VK': 'Vonkeror',
    'VU': 'Vuhuv',
    'WI': 'Wear Internet Browser',
    'WP': 'Web Explorer',
    'W3': 'Web Browser & Explorer',
    'W5': 'Webian Shell',
    'W4': 'WebDiscover',
    'WE': 'WebPositive',
    'W6': 'Weltweitimnetz Browser',
    'WX': 'Wexond',
    'WF': 'Waterfox',
    'WB': 'Wave Browser',
    'WA': 'Wavebox',
    'WH': 'Whale Browser',
    'W2': 'Whale TV Browser',
    'WO': 'wOSBrowser',
    '3W': 'w3m',
    'WT': 'WeTab Browser',
    '1W': 'World Browser',
    'WL': 'Wolvic',
    'WK': 'Wukong Browser',
    'WY': 'Wyzo',
    'YG': 'YAGI',
    'YJ': 'Yahoo! Japan Browser',
    'YA': 'Yandex Browser',
    'Y4': 'Yandex Browser Corp',
    'YL': 'Yandex Browser Lite',
    'YN': 'Yaani Browser',
    'Y2': 'Yo Browser',
    'YB': 'Yolo Browser',
    'YO': 'YouCare',
    'Y3': 'YouBrowser',
    'YZ': 'Yuzu Browser',
    'XR': 'xBrowser',
    'X3': 'MMBOX XBrowser',
    'XB': 'X Browser Lite',
    'X0': 'X-VPN',
    'X1': 'xBrowser Pro Super Fast',
    'XN': 'XNX Browser',
    'XT': 'XtremeCast',
    'XS': 'xStand',
    'XI': 'Xiino',
    'X4': 'XnBrowse',
    'XO': 'Xooloo Internet',
    'XV': 'Xvast',
    'ZE': 'Zetakey',
    'ZV': 'Zvu',
    'ZI': 'Zirco Browser',
    'ZR': 'Zordo Browser',
    'ZT': 'ZTE Browser'
};

});

parcelRegister("aaVhi", function(module, exports) {
module.exports = [
    {
        "regex": "NetFront",
        "name": "NetFront"
    },
    {
        "regex": "Edge/",
        "name": "Edge"
    },
    {
        "regex": "Trident",
        "name": "Trident"
    },
    {
        "regex": "Chr[o0]me/(?!1?\\d\\.|2[0-7]\\.)",
        "name": "Blink"
    },
    {
        "regex": "(?:Apple)?WebKit",
        "name": "WebKit"
    },
    {
        "regex": "Presto",
        "name": "Presto"
    },
    {
        "regex": "Goanna",
        "name": "Goanna"
    },
    {
        "regex": "(?<!like )Clecko",
        "name": "Clecko"
    },
    {
        "regex": "(?<!like )Gecko",
        "name": "Gecko"
    },
    {
        "regex": "KHTML",
        "name": "KHTML"
    },
    {
        "regex": "NetSurf",
        "name": "NetSurf"
    },
    {
        "regex": "Servo",
        "name": "Servo"
    },
    {
        "regex": "Ekioh(?:Flow)?",
        "name": "EkiohFlow"
    },
    {
        "regex": "xChaos_Arachne",
        "name": "Arachne"
    },
    {
        "regex": "LibWeb\\+LibJs",
        "name": "LibWeb"
    },
    {
        "regex": "ArkWeb/",
        "name": "ArkWeb"
    },
    {
        "regex": "Maple (?!III)(\\d+[.\\d]+)|Maple\\d{4}",
        "name": "Maple"
    }
];

});

parcelRegister("bVQTI", function(module, exports) {
module.exports = [
    {
        "regex": "HeyTapBrowser/([\\d.]+)",
        "name": "HeyTapBrowser",
        "version": "$1"
    },
    {
        "regex": "QuarkPC/(\\d+\\.[\\.\\d]+)",
        "name": "QuarkPC",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "AltiBrowser/([\\d.]+)",
        "name": "AltiBrowser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Maple (?!III)(\\d+[.\\d]+)|Maple\\d{4}",
        "name": "Maple",
        "version": "$1",
        "engine": {
            "default": "Maple"
        }
    },
    {
        "regex": "Singlebox/(\\d+\\.[\\.\\d]+)",
        "name": "Singlebox",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "RCATorExplorer",
        "name": "RCA Tor Explorer",
        "version": ""
    },
    {
        "regex": "TQBrowser",
        "name": "TQ Browser",
        "version": ""
    },
    {
        "regex": "XXXAndroidApp",
        "name": "XnBrowse",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "ProxyFox",
        "name": "ProxyFox",
        "version": ""
    },
    {
        "regex": "PrivacyBrowser",
        "name": "Privacy Browser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TUSK/(\\d+[.\\d]+)",
        "name": "TUSK",
        "version": "$1"
    },
    {
        "regex": "Dezor/(\\d+[.\\d]+)",
        "name": "Dezor",
        "version": "$1"
    },
    {
        "regex": "OJR Browser/([\\d.]+)",
        "name": "OJR Browser",
        "version": "$1"
    },
    {
        "regex": "SecureBrowser/([\\d.]+)",
        "name": "AppTec Secure Browser",
        "version": "$1"
    },
    {
        "regex": "Veera/([\\d.]+)",
        "name": "Veera",
        "version": "$1"
    },
    {
        "regex": "Ninesky(?:-android-mobile)?/([\\d.]+)",
        "name": "Ninesky",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Perk/([\\d.]+)",
        "name": "Perk",
        "version": "$1"
    },
    {
        "regex": "Presearch \\(Tempest\\)",
        "name": "Presearch",
        "version": ""
    },
    {
        "regex": "QtWeb Internet Browser(?:/(\\d+[.\\d]+))?",
        "name": "QtWeb",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "UPhoneWebBrowser(\\d+[.\\d]+)",
        "name": "UPhone Browser",
        "version": "$1"
    },
    {
        "regex": "(?:MIB|MotorolaWebKit.*Version)/(\\d+[.\\d]+)",
        "name": "Motorola Internet Browser",
        "version": "$1"
    },
    {
        "regex": "iNet Browser(?: (\\d+[.\\d]+))?",
        "name": "iNet Browser",
        "version": "$1"
    },
    {
        "regex": "Prism/([\\d.]+)",
        "name": "Prism",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Awesomium/([\\d.]+)",
        "name": "Awesomium",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Roccat(?:/(\\d+[.\\d]+))?",
        "name": "Roccat",
        "version": "$1"
    },
    {
        "regex": "Swiftweasel(?:/(\\d+[.\\d]+))?",
        "name": "Swiftweasel",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "wkbrowser (\\d+[.\\d]+)",
        "name": "Wukong Browser",
        "version": "$1"
    },
    {
        "regex": "KUN/(\\d+[.\\d]+)",
        "name": "KUN",
        "version": "$1"
    },
    {
        "regex": "NaenaraBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Naenara Browser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "nook browser(?:/(\\d+[.\\d]+))?",
        "name": "NOOK Browser",
        "version": "$1"
    },
    {
        "regex": "xChaos_Arachne/5\\.(\\d+\\.[.\\d]+)",
        "name": "Arachne",
        "version": "$1"
    },
    {
        "regex": "WeltweitimnetzBrowser/(\\d+\\.[.\\d]+)",
        "name": "Weltweitimnetz Browser",
        "version": "$1"
    },
    {
        "regex": "(?:Ladybird|LibWeb\\+LibJS/.*Browser)/(\\d+\\.[.\\d]+)",
        "name": "Ladybird",
        "version": "$1",
        "engine": {
            "default": "LibWeb"
        }
    },
    {
        "regex": "Kitt/(\\d+\\.[.\\d]+)",
        "name": "Kitt",
        "version": "$1"
    },
    {
        "regex": "sppm_bizbrowser",
        "name": "BizBrowser",
        "version": ""
    },
    {
        "regex": "SkyLeap/(\\d+\\.[.\\d]+)",
        "name": "SkyLeap",
        "version": "$1"
    },
    {
        "regex": "MaxBrowser/(\\d+\\.[.\\d]+)",
        "name": "MaxBrowser",
        "version": "$1"
    },
    {
        "regex": "YouBrowser/(\\d+\\.[.\\d]+)",
        "name": "YouBrowser",
        "version": "$1"
    },
    {
        "regex": "MixerBox-Browser",
        "name": "MixerBox AI",
        "version": ""
    },
    {
        "regex": "EudoraWeb (\\d+[.\\d]+)",
        "name": "EudoraWeb",
        "version": "$1"
    },
    {
        "regex": "Eolie",
        "name": "Eolie",
        "version": ""
    },
    {
        "regex": "^w3m/(\\d+[.\\d]+)",
        "name": "w3m",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "Classilla/",
        "name": "Classilla",
        "version": "$1",
        "engine": {
            "default": "Clecko"
        }
    },
    {
        "regex": "WebianShell/(\\d+[.\\d]+)",
        "name": "Webian Shell",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Vonkeror(?:/(\\d+[.\\d]+))?",
        "name": "Vonkeror",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Wyzo/(\\d+\\.[.\\d]+)",
        "name": "Wyzo",
        "version": "$1"
    },
    {
        "regex": "Liri/(\\d+\\.[.\\d]+)",
        "name": "Liri Browser",
        "version": "$1"
    },
    {
        "regex": "Columbus/(\\d+\\.[.\\d]+)",
        "name": "Columbus Browser",
        "version": "$1"
    },
    {
        "regex": "GreenBrowser",
        "name": "GreenBrowser",
        "version": "",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "K-Ninja/(\\d+\\.[.\\d]+)",
        "name": "K-Ninja",
        "version": "$1"
    },
    {
        "regex": "^PB(\\d+\\.[.\\d]+)",
        "name": "PirateBrowser",
        "version": "$1"
    },
    {
        "regex": "EastBrowser/(\\d+\\.[.\\d]+)",
        "name": "East Browser",
        "version": "$1"
    },
    {
        "regex": "Qiyu/(\\d+\\.[.\\d]+)",
        "name": "Qiyu",
        "version": "$1"
    },
    {
        "regex": "WebDiscover/(\\d+\\.[.\\d]+)",
        "name": "WebDiscover",
        "version": "$1"
    },
    {
        "regex": "LeganBrowser/(\\d+\\.[.\\d]+)",
        "name": "Legan Browser",
        "version": "$1"
    },
    {
        "regex": "Acoo Browser",
        "name": "Acoo Browser",
        "version": "",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "Aplix_.*_browser/(\\d+\\.[.\\d]+)",
        "name": "Aplix",
        "version": "$1"
    },
    {
        "regex": "Mogok/(\\d+\\.[.\\d]+)",
        "name": "Mogok Browser",
        "version": "$1"
    },
    {
        "regex": "(?:IOS)?TrueLocationBrowser/(\\d+\\.[.\\d]+)",
        "name": "TrueLocation Browser",
        "version": "$1"
    },
    {
        "regex": "DiigoBrowser$",
        "name": "Diigo Browser",
        "version": ""
    },
    {
        "regex": ".*OnBrowserLite(\\d+\\.[.\\d]+)",
        "name": "OnBrowser Lite",
        "version": "$1"
    },
    {
        "regex": "Bluefy/(\\d+\\.[.\\d]+)",
        "name": "Bluefy",
        "version": "$1"
    },
    {
        "regex": "(?:Novarra-Vision|Vision-Browser)(?:/(\\d+[.\\d]+))?",
        "name": "Vision Mobile Browser",
        "version": "$1"
    },
    {
        "regex": "SurfyBrowser/(\\d+[.\\d]+)",
        "name": "Surfy Browser",
        "version": "$1"
    },
    {
        "regex": "18\\+/([\\d.]+)",
        "name": "18+ Privacy Browser",
        "version": "$1"
    },
    {
        "regex": "GoKu-iOS/(\\d+[.\\d]+)",
        "name": "GoKu",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Ask\\.com Mobile Browser",
        "name": "Ask.com",
        "version": ""
    },
    {
        "regex": "Bang/(\\d+[.\\d]+)",
        "name": "Bang",
        "version": "$1"
    },
    {
        "regex": "ManagedBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Intune Managed Browser",
        "version": "$1"
    },
    {
        "regex": "Lotus/(\\d+[.\\d]+)",
        "name": "Lotus",
        "version": "$1"
    },
    {
        "regex": "JuziBrowser",
        "name": "JUZI Browser",
        "version": ""
    },
    {
        "regex": "Ninetails(?:/(\\d+[.\\d]+))?",
        "name": "Ninetails",
        "version": "$1"
    },
    {
        "regex": "Wexond(?:/(\\d+[.\\d]+))?",
        "name": "Wexond",
        "version": "$1"
    },
    {
        "regex": "catalyst(?:/(\\d+[.\\d]+))?",
        "name": "Catalyst",
        "version": "$1"
    },
    {
        "regex": "Impervious(?:/(\\d+[.\\d]+))?",
        "name": "Impervious Browser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "RakutenBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Rakuten Browser",
        "version": "$1"
    },
    {
        "regex": "RakutenWebSearch(?:/(\\d+[.\\d]+))?",
        "name": "Rakuten Web Search",
        "version": "$1"
    },
    {
        "regex": "VibeMate(?:/(\\d+[.\\d]+))?",
        "name": "VibeMate",
        "version": "$1"
    },
    {
        "regex": "yixia\\.browser/com\\.donerbrowser\\.app/",
        "name": "Colom Browser",
        "version": ""
    },
    {
        "regex": "tararia/(\\d+\\.[.\\d]+)",
        "name": "tararia",
        "version": "$1"
    },
    {
        "regex": "SberBrowser/(\\d+\\.[.\\d]+)",
        "name": "SberBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Raspbian Chromium/(?:(\\d+[.\\d]+))?",
        "name": "Raspbian Chromium",
        "version": "$1"
    },
    {
        "regex": "Quick Search TV(?:/(?:Wild Moon Edition )?(\\d+[.\\d]+))?",
        "name": "Quick Search TV",
        "version": "$1"
    },
    {
        "regex": "Skye/(\\d+\\.[.\\d]+)",
        "name": "Skye",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "VD/\\d+",
        "name": "VD Browser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "\\[(?:HB/29|PB/(?:66|81))\\]",
        "name": "SecureX",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "\\[HS/\\d+\\]",
        "name": "HotBrowser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "\\[PB/\\d+\\]",
        "name": "Proxy Browser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "^Normalized (?:iPad|iPhone) \\(iOS Safari\\)",
        "name": "Onion Browser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "fGet/",
        "name": "fGet",
        "version": ""
    },
    {
        "regex": "Nuviu/(?:(\\d+[.\\d]+))?",
        "name": "Nuviu",
        "version": "$1"
    },
    {
        "regex": "DoCoMo/(?:(\\d+[.\\d]+))?",
        "name": "DoCoMo",
        "version": "$1"
    },
    {
        "regex": "com\\.airfind\\.browser/(?:(\\d+[.\\d]+))?",
        "name": "Airfind Secure Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "ArcMobile2(?:/(\\d+\\.[.\\d]+);)?",
        "name": "Arc Search",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Nuanti(?:Meta)?/(\\d+\\.[.\\d]+)",
        "name": "Nuanti Meta",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "RokuBrowser/(\\d+\\.[.\\d]+)",
        "name": "Roku Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "PicoBrowser/(\\d+\\.[.\\d]+)",
        "name": "PICO Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Alva/(\\d+\\.[.\\d]+)",
        "name": "ALVA",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Norton/(\\d+\\.[.\\d]+)",
        "name": "Norton Private Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Odd/(\\d+\\.[.\\d]+)",
        "name": "Odd Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Safari/537\\.36 (?:Browser|Navegador)",
        "name": "APN Browser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "YAGI/(\\d+\\.[.\\d]+)",
        "name": "YAGI",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "InspectBrowser",
        "name": "Inspect Browser",
        "version": ""
    },
    {
        "regex": "Keepsafe Browser(?:/(\\d+[.\\d]+))?",
        "name": "Keepsafe Browser",
        "version": "$1"
    },
    {
        "regex": "(.*)Vast Browser/(\\d+\\.[.\\d]+)",
        "name": "Vast Browser",
        "version": "$2",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "bloket",
        "name": "Bloket",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(.*)U Browser(\\d+\\.[.\\d]+)",
        "name": "U Browser",
        "version": "$2",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+).+TeslaBrowser/",
        "name": "Tesla Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+).+Sparrow",
        "name": "Viasat Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Sparrow/.+CFNetwork",
        "name": "Viasat Browser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Lilo/(\\d+\\.[.\\d]+)",
        "name": "Lilo",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Lilo/.+CFNetwork",
        "name": "Lilo",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "lexi/(\\d+[.\\d]+)",
        "name": "Lexi Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Floorp/(\\d+[.\\d]+)",
        "name": "Floorp",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "SurfBrowser/(\\d+[.\\d]+)",
        "name": "Surf Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Decentr",
        "name": "Decentr",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "youcare-android-app",
        "name": "YouCare",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "youcare-ios-app",
        "name": "YouCare",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "ABB/(\\d+[.\\d]+)",
        "name": "AdBlock Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "\\d+/tclwebkit(?:\\d+[.\\d]*)",
        "name": "BrowseHere",
        "version": ""
    },
    {
        "regex": "HiBrowser/v?(\\d+[.\\d]+)",
        "name": "Hi Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "CYBrowser/(\\d+[.\\d]+)",
        "name": "CyBrowser",
        "version": "$1"
    },
    {
        "regex": "Chrome/.+ SiteKiosk (\\d+[.\\d]+)",
        "name": "SiteKiosk",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SiteKiosk (\\d+[.\\d]+)",
        "name": "SiteKiosk",
        "version": "$1"
    },
    {
        "regex": "ReqwirelessWeb/(\\d+[.\\d]+)",
        "name": "Reqwireless WebViewer",
        "version": "$1"
    },
    {
        "regex": "T\\+Browser/(\\d+[.\\d]+)",
        "name": "T+Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Private Browser/(\\d+[.\\d]+) Chrome/",
        "name": "Secure Private Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "ChanjetCloud/(\\d+[.\\d]+)",
        "name": "ChanjetCloud",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SushiBrowser/(\\d+[.\\d]+)",
        "name": "Sushi Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "dBrowser/(\\d+[.\\d]+)",
        "name": "Peeps dBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "LTBrowser/(\\d+[.\\d]+)",
        "name": "LT Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "lagatos-browser/(\\d+[.\\d]+)",
        "name": "Lagatos Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "psi-secure-browser/(\\d+[.\\d]+)",
        "name": "PSI Secure Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Harman_Browser/(\\d+[.\\d]+)",
        "name": "Harman Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "bonsai-browser/(\\d+[.\\d]+)",
        "name": "Bonsai",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "spectre-browser/(\\d+[.\\d]+)",
        "name": "Spectre Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "FlashBrowser/(\\d+[.\\d]+)",
        "name": "Flash Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Secure/(?:(\\d+[.\\d]+))?",
        "name": "Secure Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Arvin/(\\d+[.\\d]+)",
        "name": "Arvin",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Version/.+Chrome/.+EdgW/(\\d+[.\\d]+)",
        "name": "Edge WebView",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Mandarin Browser/(\\d+[.\\d]+)",
        "name": "Mandarin",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Torrent/(\\d+[.\\d]+)",
        "name": "Maelstrom",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Helio/(\\d+[.\\d]+)",
        "name": "Helio",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "7654Browser/(\\d+[.\\d]+)",
        "name": "7654 Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Qazweb/(\\d+[.\\d]+)",
        "name": "Qazweb",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Degdegan/(\\d+[.\\d]+)",
        "name": "deg-degan",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "JavaFX/(\\d+[.\\d]+)",
        "name": "JavaFX",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chedot/(\\d+[.\\d]+)",
        "name": "Chedot",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+) .*\\(Chromium GOST\\)",
        "name": "Chromium GOST",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "(?:DeledaoPersonal|DeledaoFamily)/(\\d+[.\\d]+)",
        "name": "Deledao",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "HasBrowser/(\\d+[.\\d]+)",
        "name": "HasBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Byffox/(\\d+[.\\d]+)",
        "name": "Byffox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+) .*AgentWeb.+UCBrowser",
        "name": "CoolBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "DotBrowser/(\\d+[.\\d]+)",
        "name": "Dot Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "CravingExplorer/(\\d+[.\\d]+)",
        "name": "Craving Explorer",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "DeskBrowse/(\\d+[.\\d]+)",
        "name": "DeskBrowse",
        "version": "$1"
    },
    {
        "regex": "Lolifox/(\\d+[.\\d]+)",
        "name": "Lolifox",
        "version": "$1"
    },
    {
        "regex": "PiBrowser/(\\d+[.\\d]+)",
        "name": "Pi Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "qutebrowser/(\\d+\\.[.\\d]+) .*Chrome",
        "name": "Qutebrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "qutebrowser(?:/(\\d+[.\\d]+))?",
        "name": "Qutebrowser",
        "version": "$1"
    },
    {
        "regex": "flast/(\\d+[.\\d]+)",
        "name": "Flast",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "PolyBrowser/(\\d+[.\\d]+)",
        "name": "PolyBrowser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Chrome.+BriskBard/(\\d+[.\\d]+)",
        "name": "BriskBard",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "BriskBard(?:/(\\d+[.\\d]+))?",
        "name": "BriskBard",
        "version": "$1"
    },
    {
        "regex": "GinxDroid(?:Browser)?/(\\d+[.\\d]+)",
        "name": "GinxDroid Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Avira(?:Scout)?/(\\d+[.\\d]+)",
        "name": "Avira Secure Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "VenusBrowser/(\\d+[.\\d]+)",
        "name": "Venus Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome.+Otter(?:[ /](\\d+[.\\d]+))?",
        "name": "Otter Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Otter(?:[ /](\\d+[.\\d]+))?",
        "name": "Otter Browser",
        "version": "$1"
    },
    {
        "regex": "Chrome.+Smooz/(\\d+[.\\d]+)",
        "name": "Smooz",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Smooz/(\\d+[.\\d]+)",
        "name": "Smooz",
        "version": "$1"
    },
    {
        "regex": "BanglaBrowser/(\\d+\\.[.\\d]+)",
        "name": "Bangla Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Cornowser/(\\d+[.\\d]+)",
        "name": "Cornowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Orca/(\\d+[.\\d]+)",
        "name": "Orca",
        "version": "$1"
    },
    {
        "regex": "Android (?:[\\d.]+;) ?(?:[^;]+;)? Flow\\) AppleWebKit/537.+Chrome/\\d{3}",
        "name": "Flow Browser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Flow/(?:(\\d+[.\\d]+))",
        "name": "Flow",
        "version": "$1",
        "engine": {
            "default": "EkiohFlow"
        }
    },
    {
        "regex": "Ekioh/(?:(\\d+[.\\d]+))",
        "name": "Flow",
        "version": "$1",
        "engine": {
            "default": "EkiohFlow"
        }
    },
    {
        "regex": "xStand/(\\d+[.\\d]+)",
        "name": "xStand",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Biyubi/(\\d+[.\\d]+)",
        "name": "Biyubi",
        "version": "$1"
    },
    {
        "regex": "(?:Perfect%20Browser(?:-iPad)?|Perfect(?:BrowserPro)?)/(\\d+[.\\d]+)",
        "name": "Perfect Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Browser/Phantom/V(\\d+[.\\d]+)",
        "name": "Phantom Browser",
        "version": "$1"
    },
    {
        "regex": "AwoX(?:/(\\d+[.\\d]+))? Browser",
        "name": "AwoX",
        "version": "$1"
    },
    {
        "regex": "Zetakey/(\\d+[.\\d]+)",
        "name": "Zetakey",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "PlayFreeBrowser/(?:(\\d+[.\\d]+))?",
        "name": "PlayFree Browser",
        "version": "$1"
    },
    {
        "regex": "(?:chimlac_browser|chimlac)/(?:(\\d+[.\\d]+))",
        "name": "Chim Lac",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Odin/(?:(\\d+[.\\d]+))",
        "name": "Odin",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Tbrowser/(\\d+[.\\d]+)",
        "name": "T-Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "com\\.tcl\\.browser",
        "name": "BrowseHere",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "WhaleBrowser/(\\d+[.\\d]+)",
        "name": "Whale TV Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SFive(?:_Android)?/.+ Chrome/(\\d+[.\\d]+)",
        "name": "SFive",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SFive_IOS/(\\d+[.\\d]+)",
        "name": "SFive",
        "version": "$1"
    },
    {
        "regex": "Navigateur web/(?:(\\d+[.\\d]+))?",
        "name": "Navigateur Web",
        "version": "$1"
    },
    {
        "regex": "Sraf(?:[/ ](\\d+[.\\d]+))?",
        "name": "Seraphic Sraf",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SeewoBrowser/(?:(\\d+[.\\d]+))?",
        "name": "Seewo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:Kode(?:iOS)?/(?:(\\d+[.\\d]+))?|TansoDL)",
        "name": "Kode Browser",
        "version": "$1"
    },
    {
        "regex": "UR/(?:(\\d+[.\\d]+))",
        "name": "UR Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OceanHero/([.\\d]+)",
        "name": "OceanHero",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/.+ SLBrowser/(?:(\\d+[.\\d]+))?",
        "name": "Smart Lenovo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SLBrowser/(?:(\\d+[.\\d]+))?",
        "name": "Smart Lenovo Browser",
        "version": "$1"
    },
    {
        "regex": "Browzar",
        "name": "Browzar",
        "version": ""
    },
    {
        "regex": "Stargon/(?:(\\d+[.\\d]+))?",
        "name": "Stargon",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "NFSBrowser/(?:(\\d+[.\\d]+))?",
        "name": "NFS Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Borealis/(\\d+[.\\d]+)",
        "name": "Borealis Navigator",
        "version": "$1"
    },
    {
        "regex": "YoloBrowser/(?:(\\d+[.\\d]+))?",
        "name": "Yolo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "PHX/(?:(\\d+[.\\d]+))?",
        "name": "Phoenix Browser",
        "version": "$1"
    },
    {
        "regex": "PrivacyWall/(?:(\\d+[.\\d]+))?",
        "name": "PrivacyWall",
        "version": "$1"
    },
    {
        "regex": "Ghostery:?(\\d+[.\\d]+)?",
        "name": "Ghostery Privacy Browser",
        "version": "$1"
    },
    {
        "regex": "Cliqz",
        "name": "Cliqz",
        "version": ""
    },
    {
        "regex": "Firefox/.*(?:Turkcell-)?YaaniBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Yaani Browser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:Turkcell-)?YaaniBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Yaani Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "SEB/(?:(\\d+[.\\d]+))?",
        "name": "Safe Exam Browser",
        "version": "$1"
    },
    {
        "regex": "Colibri/(?:(\\d+[.\\d]+))?",
        "name": "Colibri",
        "version": "$1"
    },
    {
        "regex": "Xvast/(?:(\\d+[.\\d]+))?",
        "name": "Xvast",
        "version": "$1"
    },
    {
        "regex": "TungstenBrowser/(?:(\\d+[.\\d]+))?",
        "name": "Tungsten",
        "version": "$1"
    },
    {
        "regex": "Lulumi-browser/(?:(\\d+[.\\d]+))?",
        "name": "Lulumi",
        "version": "$1"
    },
    {
        "regex": "ybrowser/(?:(\\d+[.\\d]+))?",
        "name": "Yahoo! Japan Browser",
        "version": "$1"
    },
    {
        "regex": "iLunascapeLite/(?:(\\d+\\.[.\\d]+))?",
        "name": "Lunascape Lite",
        "version": "$1"
    },
    {
        "regex": "Chrome/.+ i?Lunascape(?:[/ ](\\d+\\.[.\\d]+))?",
        "name": "Lunascape",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "i?Lunascape(?:[/ ](\\d+\\.[.\\d]+))?",
        "name": "Lunascape",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Polypane/(?:(\\d+[.\\d]+))?",
        "name": "Polypane",
        "version": "$1"
    },
    {
        "regex": "OhHaiBrowser/(?:(\\d+[.\\d]+))?",
        "name": "OhHai Browser",
        "version": "$1"
    },
    {
        "regex": "Sizzy/(?:(\\d+[.\\d]+))?",
        "name": "Sizzy",
        "version": "$1"
    },
    {
        "regex": "GlassBrowser/(?:(\\d+[.\\d]+))?",
        "name": "Glass Browser",
        "version": "$1"
    },
    {
        "regex": "ToGate/(?:(\\d+[.\\d]+))?",
        "name": "ToGate",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "(?:AirWatch Browser v|AirWatchBrowser/)(?:(\\d+[.\\d]+))?",
        "name": "VMware AirWatch",
        "version": "$1"
    },
    {
        "regex": "AOL (\\d+[.\\d]+)",
        "name": "AOL Explorer",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "ADG/(?:(\\d+[.\\d]+))?",
        "name": "AOL Desktop",
        "version": "$1"
    },
    {
        "regex": "Elements Browser/(?:(\\d+[.\\d]+))?",
        "name": "Elements Browser",
        "version": "$1"
    },
    {
        "regex": "Light/(\\d+[.\\d]+)",
        "name": "Light",
        "version": "$1"
    },
    {
        "regex": "Valve Steam GameOverlay/(?:(\\d+[.\\d]+))?",
        "name": "Steam In-Game Overlay",
        "version": "$1"
    },
    {
        "regex": "115Browser/(?:(\\d+[.\\d]+))?",
        "name": "115 Browser",
        "version": "$1"
    },
    {
        "regex": "Atom/(?:(\\d+[.\\d]+))?",
        "name": "Atom",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Wolvic/(\\d+\\.[.\\d]+)",
        "name": "Wolvic",
        "version": "$1"
    },
    {
        "regex": "Mobile VR.+Firefox",
        "name": "Firefox Reality",
        "version": ""
    },
    {
        "regex": "AVG(?:/(\\d+[.\\d]+))?",
        "name": "AVG Secure Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "AT/(\\d+[.\\d]+)",
        "name": "AVG Secure Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Start/(?:(\\d+[.\\d]+))?",
        "name": "START Internet Browser",
        "version": "$1"
    },
    {
        "regex": "Lovense(?:/(\\d+[.\\d]+))?",
        "name": "Lovense Browser",
        "version": "$1"
    },
    {
        "regex": "(?:com\\.airfind\\.deltabrowser|AirSearch)(?:/(\\d+[.\\d]+))?",
        "name": "Delta Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:Ordissimo|webissimo3)(?:/(\\d+[.\\d]+))?",
        "name": "Ordissimo",
        "version": "$1"
    },
    {
        "regex": "CCleaner(?:/(\\d+[.\\d]+))?",
        "name": "CCleaner",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "AlohaLite(?:/(\\d+[.\\d]+))?",
        "name": "Aloha Browser Lite",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TaoBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Tao Browser",
        "version": "$1"
    },
    {
        "regex": "Atlas/(\\d+[.\\d]+)$",
        "name": "ChatGPT Atlas",
        "version": "$1"
    },
    {
        "regex": "Falkon(?:/(\\d+[.\\d]+))?",
        "name": "Falkon",
        "version": "$1"
    },
    {
        "regex": "mCent(?:/(\\d+[.\\d]+))?",
        "name": "mCent",
        "version": "$1"
    },
    {
        "regex": "SalamWeb(?:/(\\d+[.\\d]+))?",
        "name": "SalamWeb",
        "version": "$1"
    },
    {
        "regex": "BlackHawk(?:/(\\d+[.\\d]+))?",
        "name": "BlackHawk",
        "version": "$1"
    },
    {
        "regex": "Minimo(?:/(\\d+[.\\d]+))?",
        "name": "Minimo",
        "version": "$1"
    },
    {
        "regex": "WIB(?:/(\\d+[.\\d]+))?",
        "name": "Wear Internet Browser",
        "version": "$1"
    },
    {
        "regex": "Origyn Web Browser",
        "name": "Origyn Web Browser",
        "version": ""
    },
    {
        "regex": "Kinza(?:/(\\d+[.\\d]+))?",
        "name": "Kinza",
        "version": "$1"
    },
    {
        "regex": "Beamrise(?:/(\\d+[.\\d]+))?",
        "name": "Beamrise",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Faux(?:/(\\d+[.\\d]+))?",
        "name": "Faux Browser",
        "version": "$1"
    },
    {
        "regex": "splash Version(?:/(\\d+[.\\d]+))?",
        "name": "Splash",
        "version": "$1"
    },
    {
        "regex": "MZBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Meizu Browser",
        "version": "$1"
    },
    {
        "regex": "COSBrowser(?:/(\\d+[.\\d]+))?",
        "name": "COS Browser",
        "version": "$1"
    },
    {
        "regex": "Crusta(?:/(\\d+[.\\d]+))?",
        "name": "Crusta",
        "version": "$1"
    },
    {
        "regex": "Hawk/TurboBrowser(?:/v?(\\d+[.\\d]+))?",
        "name": "Hawk Turbo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Hawk/QuickBrowser(?:/v?(\\d+[.\\d]+))?",
        "name": "Hawk Quick Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "FreeU(?:/(\\d+[.\\d]+))?",
        "name": "FreeU",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "NoxBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Nox Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Basilisk(?:/(\\d+[.\\d]+))?",
        "name": "Basilisk",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "SputnikBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Sputnik Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TNSBrowser(?:/(\\d+[.\\d]+))?",
        "name": "K.Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OculusBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Oculus Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Jio(?:Browser|Pages|Sphere)(?:/(\\d+[.\\d]+))?",
        "name": "JioSphere",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SY/(\\d+[.\\d]+) Chrome/",
        "name": "Stampy Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/.+ Hola(?:/(\\d+[.\\d]+))?",
        "name": "hola! Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SlimBoat/(?:(\\d+[.\\d]+))",
        "name": "SlimBoat",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Slimjet/(?:(\\d+[.\\d]+))",
        "name": "Slimjet",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:7Star|Kuaiso)/(?:(\\d+[.\\d]+))",
        "name": "7Star",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "MxNitro/(?:(\\d+[.\\d]+))",
        "name": "MxNitro",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "HuaweiBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Huawei Browser Mobile",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "HBPC/(\\d+[.\\d]+)",
        "name": "Huawei Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "ZTE ?Browser/",
        "name": "ZTE Browser",
        "version": "$1"
    },
    {
        "regex": "VivoBrowser(?:/(\\d+[.\\d]+))?",
        "name": "vivo Browser",
        "version": "$1"
    },
    {
        "regex": "RealmeBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Realme Browser",
        "version": "$1"
    },
    {
        "regex": "Beaker ?Browser(?:[/ ](\\d+[.\\d]+))?",
        "name": "Beaker Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "QwantiOS/(\\d+[.\\d]+)",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chrome/.*QwantMobile(?:/(\\d+[.\\d]+))?",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "QwantMobile(?:/(\\d+[.\\d]+))?",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Qwant/(\\d+[.\\d]+)",
        "name": "Qwant Mobile",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "TenFourFox(?:/(\\d+[.\\d]+))?",
        "name": "TenFourFox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Chrome/.+ AOLShield(?:/(\\d+[.\\d]+))?",
        "name": "AOL Shield Pro",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "AOLShield(?:/(\\d+[.\\d]+))?",
        "name": "AOL Shield",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?<!motorola |; )Edge[ /](\\d+[.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "Edge"
        }
    },
    {
        "regex": "EdgiOS[ /](\\d+[.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "EdgA[ /](\\d+[.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Edg[ /](\\d+[.\\d]+)",
        "name": "Microsoft Edge",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Browser/harmony360Browser/(\\d+[.\\d]+)$",
        "name": "Harmony 360 Browser",
        "version": "$1",
        "engine": {
            "default": "ArkWeb"
        }
    },
    {
        "regex": "QIHU 360[ES]E|QihooBrowserHD/(\\d+[.\\d]+)",
        "name": "360 Secure Browser",
        "version": "$1"
    },
    {
        "regex": "Chrome.+Safari/537\\.36/(\\d+[.\\d]+)$",
        "name": "360 Secure Browser",
        "version": "$1"
    },
    {
        "regex": "360 Aphone Browser(?:[ /]?\\(?(\\d+[.\\d]+)(?:beta)?\\)?)?",
        "name": "360 Phone Browser",
        "version": "$1"
    },
    {
        "regex": "SailfishBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Sailfish Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "IceCat(?:/(\\d+[.\\d]+))?",
        "name": "IceCat",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Mobicip",
        "name": "Mobicip",
        "version": "",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Camino(?:/(\\d+[.\\d]+))?",
        "name": "Camino",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Waterfox(?:/(\\d+[.\\d]+))?",
        "name": "Waterfox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "VertexSurf/(\\d+\\.[.\\d]+)",
        "name": "Vertex Surf",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome/.+ AlohaBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Aloha Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "AlohaBrowser(?:App)?(?:/(\\d+[.\\d]+))?",
        "name": "Aloha Browser",
        "version": "$1"
    },
    {
        "regex": "Aloha/",
        "name": "Aloha Browser",
        "version": ""
    },
    {
        "regex": "Chrome.+(?:Avast(?:SecureBrowser)?|ASW|Safer)(?:/(\\d+[.\\d]+))?",
        "name": "Avast Secure Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "(?:Avast(?:SecureBrowser)?|ASW|Safer)(?:/(\\d+[.\\d]+))?",
        "name": "Avast Secure Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Epic(?:/(\\d+[.\\d]+))",
        "name": "Epic",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Fennec(?:/(\\d+[.\\d]+))?",
        "name": "Fennec",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Firefox.*Tablet browser (\\d+[.\\d]+)",
        "name": "MicroB",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Maemo Browser(?: (\\d+[.\\d]+))?",
        "name": "MicroB",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Deepnet Explorer (\\d+[.\\d]+)?",
        "name": "Deepnet Explorer",
        "version": "$1"
    },
    {
        "regex": "Avant ?Browser",
        "name": "Avant Browser",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "OppoBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Oppo Browser",
        "version": "$1"
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+) .*MRCHROME",
        "name": "Amigo",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "AtomicBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Atomic Web Browser",
        "version": "$1"
    },
    {
        "regex": "Bunjalloo(?:/(\\d+[.\\d]+))?",
        "name": "Bunjalloo",
        "version": "$1"
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+).*Brave/",
        "name": "Brave",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Brave(?: Chrome)?(?:/(\\d+[.\\d]+))?",
        "name": "Brave",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Iridium(?:/(\\d+[.\\d]+))?",
        "name": "Iridium",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Iceweasel(?:/(\\d+[.\\d]+))?",
        "name": "Iceweasel",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "WebPositive",
        "name": "WebPositive",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": ".*Goanna.*PaleMoon(?:/(\\d+[.\\d]+))?",
        "name": "Pale Moon",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "PaleMoon(?:/(\\d+[.\\d]+))?",
        "name": "Pale Moon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "CometBird(?:/(\\d+[.\\d]+))?",
        "name": "CometBird",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "IceDragon(?:/(\\d+[.\\d]+))?",
        "name": "IceDragon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Flock(?:/(\\d+[.\\d]+))?",
        "name": "Flock",
        "version": "$1",
        "engine": {
            "default": "Gecko",
            "versions": {
                "3": "WebKit"
            }
        }
    },
    {
        "regex": "JigBrowserPlus/(?:(\\d+[.\\d]+))?",
        "name": "Jig Browser Plus",
        "version": "$1"
    },
    {
        "regex": "jig browser(?: web;|9i?)?(?:[/ ](\\d+[.\\d]+))?",
        "name": "Jig Browser",
        "version": "$1"
    },
    {
        "regex": "Kapiko(?:/(\\d+[.\\d]+))?",
        "name": "Kapiko",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Kylo(?:/(\\d+[.\\d]+))?",
        "name": "Kylo",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Origin/(?:(\\d+[.\\d]+))?",
        "name": "Origin In-Game Overlay",
        "version": "$1"
    },
    {
        "regex": "Cunaguaro(?:/(\\d+[.\\d]+))?",
        "name": "Cunaguaro",
        "version": "$1"
    },
    {
        "regex": "(?:TO-Browser/TOB|DT-Browser/DTB)(\\d+[.\\d]+)",
        "name": "t-online.de Browser",
        "version": "$1"
    },
    {
        "regex": "Kazehakase(?:/(\\d+[.\\d]+))?",
        "name": "Kazehakase",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "ArcticFox(?:/(\\d+[.\\d]+))?",
        "name": "Arctic Fox",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "Mypal(?:/(\\d+[.\\d]+))?",
        "name": "Mypal",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "Centaury(?:/(\\d+[.\\d]+))?",
        "name": "Centaury",
        "version": "$1",
        "engine": {
            "default": "Goanna"
        }
    },
    {
        "regex": "(?:Focus|Klar)(?:/(\\d+[.\\d]+))",
        "name": "Firefox Focus",
        "version": "$1"
    },
    {
        "regex": "Cyberfox(?:/(\\d+[.\\d]+))?",
        "name": "Cyberfox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Firefox/(\\d+\\.[.\\d]+).*\\(Swiftfox\\)",
        "name": "Swiftfox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "UCBrowserHD/(\\d[\\d.]+)",
        "name": "UC Browser HD",
        "version": "$1"
    },
    {
        "regex": "UCMini(?:[ /]?(\\d+[.\\d]+))?",
        "name": "UC Browser Mini",
        "version": "$1"
    },
    {
        "regex": "UC[ ]?Browser.* \\(UCMini\\)",
        "name": "UC Browser Mini",
        "version": ""
    },
    {
        "regex": "Chrome.+uc mini browser(\\d+[.\\d]+)?",
        "name": "UC Browser Mini",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "UCTurbo(?:[ /]?(\\d+[.\\d]+))?",
        "name": "UC Browser Turbo",
        "version": "$1"
    },
    {
        "regex": "UC[ ]?Browser.* \\(UCTurbo\\)",
        "name": "UC Browser Turbo",
        "version": ""
    },
    {
        "regex": "ArkWeb/(?:\\d+[.\\d]+) (?:Mobile )?UC[ ]?Browser(?:[ /]?(\\d+[.\\d]+))?$",
        "name": "UC Browser",
        "version": "$1",
        "engine": {
            "default": "ArkWeb"
        }
    },
    {
        "regex": "UC[ ]?Browser(?:[ /]?(\\d+[.\\d]+))?",
        "name": "UC Browser",
        "version": "$1"
    },
    {
        "regex": "UCWEB(?:[ /]?(\\d+[.\\d]+))?",
        "name": "UC Browser",
        "version": "$1"
    },
    {
        "regex": "UC AppleWebKit",
        "name": "UC Browser",
        "version": ""
    },
    {
        "regex": "UC%20Browser/(\\d+[.\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)",
        "name": "UC Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chrome.+UC Browser(\\d+[.\\d]+)",
        "name": "UC Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Firefox.+UCKai/(\\d+[.\\d]+)",
        "name": "UC Browser",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:Mobile|Tablet).*Servo.*Firefox(?:/(\\d+[.\\d]+))?",
        "name": "Firefox Mobile",
        "version": "$1",
        "engine": {
            "default": "Servo"
        }
    },
    {
        "regex": "(?:Mobile|Tablet).*Firefox(?:/(\\d+[.\\d]+))?",
        "name": "Firefox Mobile",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "FxiOS/(\\d+[.\\d]+)",
        "name": "Firefox Mobile iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": ".*Servo.*Firefox(?:/(\\d+[.\\d]+))?",
        "name": "Firefox",
        "version": "$1",
        "engine": {
            "default": "Servo"
        }
    },
    {
        "regex": "(?!.*Opera[ /])Firefox(?:[ /](\\d+[.\\d]+))?",
        "name": "Firefox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:BonEcho|GranParadiso|Lorentz|Minefield|Namoroka|Shiretoko)[ /](\\d+[.\\d]+)",
        "name": "Firefox",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "ANTFresco(?:[/ ](\\d+[.\\d]+))?",
        "name": "ANT Fresco",
        "version": "$1"
    },
    {
        "regex": "ANTGalio(?:/(\\d+[.\\d]+))?",
        "name": "ANTGalio",
        "version": "$1"
    },
    {
        "regex": "(?:Espial|Escape)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Espial TV Browser",
        "version": "$1"
    },
    {
        "regex": "RockMelt(?:/(\\d+[.\\d]+))?",
        "name": "RockMelt",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Fireweb Navigator(?:/(\\d+[.\\d]+))?",
        "name": "Fireweb Navigator",
        "version": "$1"
    },
    {
        "regex": "Fireweb(?:/(\\d+[.\\d]+))?",
        "name": "Fireweb",
        "version": "$1"
    },
    {
        "regex": "(?:Navigator|Netscape6?)(?:/(\\d+[.\\d]+))?",
        "name": "Netscape",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:Polarity)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Polarity",
        "version": "$1"
    },
    {
        "regex": "(?:QupZilla)(?:[/ ](\\d+[.\\d]+))?",
        "name": "QupZilla",
        "version": "$1"
    },
    {
        "regex": "(?:Dooble)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Dooble",
        "version": "$1"
    },
    {
        "regex": "Whale/(\\d+[.\\d]+)",
        "name": "Whale Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Obigo[ ]?(?:InternetBrowser|Browser)?(?:[ /]([a-z0-9]*))?",
        "name": "Obigo",
        "version": "$1"
    },
    {
        "regex": "Obigo|Teleca",
        "name": "Obigo",
        "version": ""
    },
    {
        "regex": "Chrome/.+ OP(?:RG)?X(?:/(\\d+[.\\d]+))?",
        "name": "Opera GX",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OP(?:RG)?X(?:/(\\d+[.\\d]+))?",
        "name": "Opera GX",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Opera(?:%20)?GX/.+CFNetwork/.+Darwin/",
        "name": "Opera GX",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:Opera Tablet.*Version|Opera/.+(?<!SymbOS; )Opera Mobi.+Version|Mobile.+OPR)/(\\d+[.\\d]+)",
        "name": "Opera Mobile",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "MMS/(\\d+[.\\d]+)",
        "name": "Opera Neon",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OMI/(\\d+[.\\d]+)",
        "name": "Opera Devices",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Opera%20Touch/(\\d+[.\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)",
        "name": "Opera Touch",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Opera%20Touch/.+CFNetwork/.+Darwin/.+(?!.*x86_64)",
        "name": "Opera Touch",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "OPT/(\\d+[.\\d]+)",
        "name": "Opera Touch",
        "version": "$1"
    },
    {
        "regex": "Opera/(\\d+\\.[.\\d]+) .*(?<!SymbOS; )Opera Mobi",
        "name": "Opera Mobile",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "Opera ?Mini/(?:att/)?(\\d+[.\\d]+)",
        "name": "Opera Mini",
        "version": "$1",
        "engine": {
            "default": "Presto"
        }
    },
    {
        "regex": "Opera ?Mini.+Version/(\\d+[.\\d]+)",
        "name": "Opera Mini",
        "version": "$1",
        "engine": {
            "default": "Presto"
        }
    },
    {
        "regex": "OPiOS/(\\d+[.\\d]+)",
        "name": "Opera Mini iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Opera%20Mini/(\\d+[.\\d]+) CFNetwork",
        "name": "Opera Mini iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Opera.+Edition Next.+Version/(\\d+[.\\d]+)",
        "name": "Opera Next",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "(?:Opera|OPR)[/ ](?:9\\.80.*Version/)?(\\d+\\.[.\\d]+) .*Edition Next",
        "name": "Opera Next",
        "version": "$1",
        "engine": {
            "default": "Presto",
            "versions": {
                "15": "Blink"
            }
        }
    },
    {
        "regex": "(?:Opera[/ ]?|OPR[/ ])(?:9\\.80.*Version/)?(\\d+[.\\d]+)",
        "name": "Opera",
        "version": "$1",
        "engine": {
            "default": "",
            "versions": {
                "7": "Presto",
                "15": "Blink",
                "3.5": "Elektra"
            }
        }
    },
    {
        "regex": "Opera/.+CFNetwork",
        "name": "Opera",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chrome.+Opera/",
        "name": "Opera",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "rekonq(?:/(\\d+[.\\d]+))?",
        "name": "Rekonq",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "CoolNovo(?:/(\\d+[.\\d]+))?",
        "name": "CoolNovo",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:Comodo[ _])?Dragon/(\\d+[.\\d]+)",
        "name": "Comodo Dragon",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "ChromePlus(?:/(\\d+[.\\d]+))?",
        "name": "ChromePlus",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Conkeror(?:/(\\d+[.\\d]+))?",
        "name": "Conkeror",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Konqueror(?:/(\\d+[.\\d]+))?",
        "name": "Konqueror",
        "version": "$1",
        "engine": {
            "default": "KHTML",
            "versions": {
                "4": ""
            }
        }
    },
    {
        "regex": "bdhonorbrowser/(\\d+[.\\d]+)",
        "name": "HONOR Browser",
        "version": "$1"
    },
    {
        "regex": "(?:baidubrowser|bdbrowser(?:(?:hd)?_i18n)?|FlyFlow|BaiduHD)(?:[/ ](\\d+[.\\d]*))?",
        "name": "Baidu Browser",
        "version": "$1"
    },
    {
        "regex": "(?:(?:BD)?Spark(?:Safe)?|BIDUBrowser)[/ ](\\d+[.\\d]*)",
        "name": "Baidu Spark",
        "version": "$1"
    },
    {
        "regex": "YaBrowser(?:/(\\d+[.\\d]*)) YaApp_iOS",
        "name": "Yandex Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "iP(?:hone|ad).*YaBrowser(?:/(\\d+[.\\d]*))",
        "name": "Yandex Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "YaBrowser(?:/(\\d+[.\\d]*)) \\(lite\\)?",
        "name": "Yandex Browser Lite",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "YaBrowser/(\\d+[.\\d]*).*corp",
        "name": "Yandex Browser Corp",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "YaBrowser(?:/(\\d+[.\\d]*))(?: \\((alpha|beta)\\))?",
        "name": "Yandex Browser",
        "version": "$1 $2",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Ya(?:ndex)?SearchBrowser(?:/(\\d+[.\\d]*))",
        "name": "Yandex Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Viv(?:aldi)?/(\\d+[.\\d]+)",
        "name": "Vivaldi",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "TweakStyle(?:/(\\d+[.\\d]+))?",
        "name": "TweakStyle",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome.+Midori Browser/(\\d+[.\\d]+)",
        "name": "Midori",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Midori(?:[ /](\\d+[.\\d]+))?",
        "name": "Midori",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Mercury/(?:(\\d+[.\\d]+))?",
        "name": "Mercury",
        "version": "$1"
    },
    {
        "regex": "Chrome.+Maxthon/\\d{4}",
        "name": "Maxthon",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome.+(?:MxBrowser|Maxthon)(?:.+\\(portable\\))?/(\\d+\\.[.\\d]+)",
        "name": "Maxthon",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "4.2": "Blink"
            }
        }
    },
    {
        "regex": "(?:Maxthon(?:%20Browser)?|MxBrowser(?:-inhouse|-iPhone)?|MXiOS)[ /](\\d+[.\\d]+)?",
        "name": "Maxthon",
        "version": "$1",
        "engine": {
            "default": "",
            "versions": {
                "3": "WebKit"
            }
        }
    },
    {
        "regex": "(?:Maxthon|MyIE2)",
        "name": "Maxthon",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Puffin/(\\d+[.\\d]+)FP",
        "name": "Puffin Cloud Browser",
        "version": "$1"
    },
    {
        "regex": "Puffin/(\\d+[.\\d]+)(?:[LMW]D)",
        "name": "Puffin Secure Browser",
        "version": "$1"
    },
    {
        "regex": "Puffin/(\\d+[.\\d]+)(?:[AILW][PT]|M)?",
        "name": "Puffin Web Browser",
        "version": "$1"
    },
    {
        "regex": "MobileIron(?:/(\\d+[.\\d]+))?",
        "name": "Iron Mobile",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome(?:/(\\d+\\.[.\\d]+) )?.*Iron",
        "name": "Iron",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Iron/(\\d+[.\\d]+)",
        "name": "Iron",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Epiphany(?:/(\\d+[.\\d]+))?",
        "name": "GNOME Web",
        "version": "$1",
        "engine": {
            "default": "Gecko",
            "versions": {
                "2.9.16": "",
                "2.28": "WebKit"
            }
        }
    },
    {
        "regex": "LieBaoFast(?:[ /](\\d+[.\\d]+))?",
        "name": "LieBaoFast",
        "version": "$1"
    },
    {
        "regex": "LBBrowser(?:[ /](\\d+[.\\d]+))?",
        "name": "Cheetah Browser",
        "version": "$1"
    },
    {
        "regex": "SE (\\d+[.\\d]+)",
        "name": "Sogou Explorer",
        "version": "$1"
    },
    {
        "regex": "QQBrowserLite/([\\d.]+)",
        "name": "QQ Browser Lite",
        "version": "$1"
    },
    {
        "regex": "M?QQBrowser/Mini([.\\d]+)?",
        "name": "QQ Browser Mini",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "M?QQ(?:Browser|\u6D4F\u89C8\u5668)(?:/([.\\d]+))?",
        "name": "QQ Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:MIUIBrowser|MiuiBrowser)(?:/(\\d+[.\\d]+))?",
        "name": "Mi Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "(?:coc_coc_browser|coccocbrowser|CocCoc)(?:/(\\d+[.\\d]+))?",
        "name": "Coc Coc",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "(?:DuckDuckGo|Ddg)/(\\d+[.\\d]*)",
        "name": "DuckDuckGo Privacy Browser",
        "version": "$1"
    },
    {
        "regex": "(?:DDG-Android-|ddg_android/)(\\d+[.\\d]*)",
        "name": "DuckDuckGo Privacy Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Samsung ?Browser(?:[/ ](\\d+[.\\d]+))?",
        "name": "Samsung Browser",
        "version": "$1"
    },
    {
        "regex": "(?:SFB(?:rowser)?)/(\\d+[.\\d]+)",
        "name": "Super Fast Browser",
        "version": "$1"
    },
    {
        "regex": "com\\.browser\\.tssomas(?:/(\\d+[.\\d]+))?",
        "name": "Super Fast Browser",
        "version": "$1"
    },
    {
        "regex": "EUI Browser(?:/(\\d+[.\\d]+))?",
        "name": "EUI Browser",
        "version": "$1"
    },
    {
        "regex": "UBrowser(?:/(\\d+[.\\d]+))?",
        "name": "UBrowser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Streamy(?:/(\\d+[.\\d]+))?",
        "name": "Streamy",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "isivioo",
        "name": "Isivioo",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Chrome/.+Tenta/(\\d+[.\\d]+)",
        "name": "Tenta Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Tenta/(\\d+[.\\d]+)",
        "name": "Tenta Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Rocket/(\\d+[.\\d]+)",
        "name": "Firefox Rocket",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Web Explorer/(\\d+\\.[.\\d]+) .*Chrome",
        "name": "Web Explorer",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "webexplorer/(\\d+)",
        "name": "Web Explorer",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Chrome.+SznProhlizec/(\\d+[.\\d]+)",
        "name": "Seznam Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SznProhlizec/(\\d+[.\\d]+)",
        "name": "Seznam Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "SogouMobileBrowser/(\\d+[.\\d]+)",
        "name": "Sogou Mobile Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Mint Browser/(\\d+[.\\d]+)",
        "name": "Mint Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Ecosia (?:android|ios)@(\\d+[.\\d]+)",
        "name": "Ecosia",
        "version": "$1",
        "engine": {
            "default": "",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "ACHEETAHI",
        "name": "CM Browser",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Chrome/.+ (?:LeBrowser|MobileLenovoBrowser)(?:/(\\d+[.\\d]+))?",
        "name": "Lenovo Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "LeBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Lenovo Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Kiwi Chrome",
        "name": "Kiwi",
        "version": "",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Mb2345Browser/(\\d+[.\\d]+)",
        "name": "2345 Browser",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "Silk/(\\d+[.\\d]+) like Chrome",
        "name": "Mobile Silk",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Silk(?:/(\\d+[.\\d]+))?",
        "name": "Mobile Silk",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "iBrowser/Mini(\\d+\\.\\d+)",
        "name": "iBrowser Mini",
        "version": "$1"
    },
    {
        "regex": "iBrowser/(\\d+\\.[.\\d]+)?",
        "name": "iBrowser",
        "version": "$1"
    },
    {
        "regex": "IBrowse(?:[ /](\\d+[.\\d]+))?",
        "name": "IBrowse",
        "version": "$1"
    },
    {
        "regex": "UP\\.Browser(?:/(\\d+[.\\d]+))?",
        "name": "Openwave Mobile Browser",
        "version": "$1"
    },
    {
        "regex": "Openwave(?:/(\\d+[.\\d]+))?",
        "name": "Openwave Mobile Browser",
        "version": "$1"
    },
    {
        "regex": "OneBrowser(?:[ /](\\d+[.\\d]+))?",
        "name": "ONE Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "GoBrowser(?:/(\\d+[.\\d]+))?",
        "name": "GoBrowser",
        "version": "$1"
    },
    {
        "regex": "(?:NokiaBrowser|BrowserNG|WicKed|Nokia-Communicator-WWW-Browser)(?:/(\\d+[.\\d]+))?",
        "name": "Nokia Browser",
        "version": "$1"
    },
    {
        "regex": "Series60/5\\.0",
        "name": "Nokia Browser",
        "version": "7.0"
    },
    {
        "regex": "Series60/(\\d+[.\\d]+)",
        "name": "Nokia OSS Browser",
        "version": "$1"
    },
    {
        "regex": "S40OviBrowser/(\\d+[.\\d]+)",
        "name": "Nokia Ovi Browser",
        "version": "$1"
    },
    {
        "regex": "^Nokia|Nokia[EN]?\\d+",
        "name": "Nokia Browser",
        "version": ""
    },
    {
        "regex": "Sleipnir(?:(?:%20Browser)?[ /](\\d+[.\\d]+))?",
        "name": "Sleipnir",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "NTENTBrowser(?:/(\\d+[.\\d]+))?",
        "name": "NTENT Browser",
        "version": "$1"
    },
    {
        "regex": "TV Bro/(\\d+[.\\d]+)",
        "name": "TV Bro",
        "version": "$1"
    },
    {
        "regex": "Quark(?:/(\\d+[.\\d]+))?",
        "name": "Quark",
        "version": "$1"
    },
    {
        "regex": "MonumentBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Monument Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "BlueBrowser(?:/(\\d+[.\\d]+))?",
        "name": "Blue Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "JAPAN Browser(?:/(\\d+[.\\d]+))?",
        "name": "Japan Browser",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "OpenFin/(?:(\\d+[.\\d]+))",
        "name": "OpenFin",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "SuperBird(?:/(\\d+[.\\d]+))?",
        "name": "SuperBird",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "Soul(?:Browser)?$|Soul/",
        "name": "Soul Browser",
        "version": "",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "LG Browser(?:/(\\d+[.\\d]+))",
        "name": "LG Browser",
        "version": "$1"
    },
    {
        "regex": "QtWebEngine/(\\d+[.\\d]+)",
        "name": "QtWebEngine",
        "version": "$1",
        "engine": {
            "default": ""
        }
    },
    {
        "regex": "iPhone;.* like Mac OS X.* Chrome(?:/(\\d+[.\\d]+))? Mobile/\\w{5,7} Safari/",
        "name": "Chrome Mobile iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?: wv\\)|Version/).* Chrome(?:/(\\d+[.\\d]+))?",
        "name": "Chrome Webview",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "CrMo(?:/(\\d+[.\\d]+))?",
        "name": "Chrome Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "CriOS(?:/(\\d+[.\\d]+))?",
        "name": "Chrome Mobile iOS",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chrome(?:/(\\d+[.\\d]+))? Mobile",
        "name": "Chrome Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "chromeframe(?:/(\\d+[.\\d]+))?",
        "name": "Chrome Frame",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Chromium(?:/(\\d+[.\\d]+))?",
        "name": "Chromium",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": ".*Chromium(?:_(\\d+[.\\d]+))?",
        "name": "Chromium",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "HeadlessChrome(?:/(\\d+[.\\d]+))?",
        "name": "Headless Chrome",
        "version": "$1",
        "engine": {
            "default": "Blink"
        }
    },
    {
        "regex": "Chrome(?!book)(?:/(\\d+[.\\d]+))?",
        "name": "Chrome",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "28": "Blink"
            }
        }
    },
    {
        "regex": "PocketBook/",
        "name": "PocketBook Browser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:Tizen|SLP) ?Browser(?:/(\\d+[.\\d]+))?",
        "name": "Tizen Browser",
        "version": "$1"
    },
    {
        "regex": "Tizen (?:\\d+\\.[.\\d]+)[^\\.\\d].* Version/(\\d+[.\\d]+) (?:TV|Mobile|like)",
        "name": "Tizen Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit",
            "versions": {
                "4": "Blink"
            }
        }
    },
    {
        "regex": "Blazer(?:/(\\d+[.\\d]+))?",
        "name": "Palm Blazer",
        "version": "$1"
    },
    {
        "regex": "Pre/(\\d+[.\\d]+)",
        "name": "Palm Pre",
        "version": "$1"
    },
    {
        "regex": "(?:hpw|web)OS/(\\d+[.\\d]+)",
        "name": "wOSBrowser",
        "version": "$1"
    },
    {
        "regex": "WebPro(?:[ /](\\d+[.\\d]+))?",
        "name": "Palm WebPro",
        "version": "$1"
    },
    {
        "regex": "Palmscape(?:[ /](\\d+[.\\d]+))?",
        "name": "Palmscape",
        "version": "$1"
    },
    {
        "regex": "Jasmine(?:[ /](\\d+[.\\d]+))?",
        "name": "Jasmine",
        "version": "$1"
    },
    {
        "regex": "Lynx(?:/(\\d+[.\\d]+))?",
        "name": "Lynx",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "NCSA_Mosaic(?:/(\\d+[.\\d]+))?",
        "name": "NCSA Mosaic",
        "version": "$1"
    },
    {
        "regex": "VMS_Mosaic(?:/(\\d+[.\\d]+))?",
        "name": "VMS Mosaic",
        "version": "$1"
    },
    {
        "regex": "ABrowse(?: (\\d+[.\\d]+))?",
        "name": "ABrowse",
        "version": "$1"
    },
    {
        "regex": "amaya(?:/(\\d+[.\\d]+))?",
        "name": "Amaya",
        "version": "$1"
    },
    {
        "regex": "AmigaVoyager(?:/(\\d+[.\\d]+))?",
        "name": "Amiga Voyager",
        "version": "$1"
    },
    {
        "regex": "Amiga-Aweb(?:/(\\d+[.\\d]+))?",
        "name": "Amiga Aweb",
        "version": "$1"
    },
    {
        "regex": "Arora(?:/(\\d+[.\\d]+))?",
        "name": "Arora",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Beonex(?:/(\\d+[.\\d]+))?",
        "name": "Beonex",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "bline(?:/(\\d+[.\\d]+))?",
        "name": "B-Line",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "BrowseX \\((\\d+[.\\d]+)",
        "name": "BrowseX",
        "version": "$1"
    },
    {
        "regex": "Charon(?:[/ ](\\d+[.\\d]+))?",
        "name": "Charon",
        "version": "$1"
    },
    {
        "regex": "Cheshire(?:/(\\d+[.\\d]+))?",
        "name": "Cheshire",
        "version": "$1"
    },
    {
        "regex": "dbrowser",
        "name": "dbrowser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Dillo(?:/(\\d+[.\\d]+))?",
        "name": "Dillo",
        "version": "$1",
        "engine": {
            "default": "Dillo"
        }
    },
    {
        "regex": "Dolfin(?:/(\\d+[.\\d]+))?|dolphin",
        "name": "Dolphin",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Elinks(?:[ /](\\d+[.\\d]+))?",
        "name": "Elinks",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "Element Browser(?:[ /](\\d+[.\\d]+))?",
        "name": "Element Browser",
        "version": "$1"
    },
    {
        "regex": "eZBrowser(?:/(\\d+[.\\d]+))?",
        "name": "eZ Browser",
        "version": "$1"
    },
    {
        "regex": "Firebird(?! Build)(?:/(\\d+[.\\d]+))?",
        "name": "Firebird",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Fluid(?:/(\\d+[.\\d]+))?",
        "name": "Fluid",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Galeon(?:/(\\d+[.\\d]+))?",
        "name": "Galeon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "(?:Google Earth Pro|Google%20Earth%20Pro)(?:/(\\d+[.\\d]+))?",
        "name": "Google Earth Pro",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "GoogleEarth/(\\d+\\.[.\\d]+)[^\\.\\d].*client:(?:Plus|Pro)",
        "name": "Google Earth Pro",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Google ?Earth(?:/v?(\\d+[.\\d]+))?",
        "name": "Google Earth",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "HotJava(?:/(\\d+[.\\d]+))?",
        "name": "HotJava",
        "version": "$1"
    },
    {
        "regex": "iCabMobile(?:[ /](\\d+[.\\d]+))?",
        "name": "iCab Mobile",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "iCab(?:[ /](\\d+[.\\d]+))?",
        "name": "iCab",
        "version": "$1",
        "engine": {
            "default": "iCab",
            "versions": {
                "4": "WebKit"
            }
        }
    },
    {
        "regex": "Crazy Browser (\\d+[.\\d]+)",
        "name": "Crazy Browser",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "IEMobile[ /](\\d+[.\\d]+)",
        "name": "IE Mobile",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE (\\d+\\.[.\\d]+)[^\\.\\d].*XBLWP7",
        "name": "IE Mobile",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE.*Trident/4\\.0",
        "name": "Internet Explorer",
        "version": "8.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE.*Trident/5\\.0",
        "name": "Internet Explorer",
        "version": "9.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE.*Trident/6\\.0",
        "name": "Internet Explorer",
        "version": "10.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "Trident/[78]\\.0",
        "name": "Internet Explorer",
        "version": "11.0",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "MSIE (\\d+[.\\d]+)",
        "name": "Internet Explorer",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "IE[ /](\\d+[.\\d]+)",
        "name": "Internet Explorer",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "(?:MSPIE|Pocket Internet Explorer)[ /](\\d+[.\\d]+)",
        "name": "Pocket Internet Explorer",
        "version": "$1",
        "engine": {
            "default": "Trident"
        }
    },
    {
        "regex": "Kindle/(\\d+[.\\d]+)",
        "name": "Kindle Browser",
        "version": "$1"
    },
    {
        "regex": "K-meleon(?:/(\\d+[.\\d]+))?",
        "name": "K-meleon",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "Links(?: \\((\\d+[.\\d]+))?",
        "name": "Links",
        "version": "$1",
        "engine": {
            "default": "Text-based"
        }
    },
    {
        "regex": "LuaKit(?:/(\\d+[.\\d]+))?",
        "name": "LuaKit",
        "version": "$1"
    },
    {
        "regex": "OmniWeb(?:/[v]?(\\d+[.\\d]+))?",
        "name": "OmniWeb",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?<!/)Phoenix(?:/(\\d+[.\\d]+))?",
        "name": "Phoenix",
        "version": "$1"
    },
    {
        "regex": "NetFrontLifeBrowser(?:/(\\d+[.\\d]+))?",
        "name": "NetFront Life",
        "version": "$1",
        "engine": {
            "default": "NetFront"
        }
    },
    {
        "regex": "Browser/(?:NetFont-|NF|NetFront)(\\d+[.\\d]+)",
        "name": "NetFront",
        "version": "$1",
        "engine": {
            "default": "NetFront"
        }
    },
    {
        "regex": "NetFront(?:/(\\d+[.\\d]+))?",
        "name": "NetFront",
        "version": "$1",
        "engine": {
            "default": "NetFront"
        }
    },
    {
        "regex": "PLAYSTATION|NINTENDO 3|AppleWebKit.+ N[XF]/\\d+\\.\\d+\\.\\d+",
        "name": "NetFront",
        "version": ""
    },
    {
        "regex": "NetPositive(?:/(\\d+[.\\d]+))?",
        "name": "NetPositive",
        "version": "$1"
    },
    {
        "regex": "Odyssey Web Browser(?:.*OWB/(\\d+[.\\d]+))?",
        "name": "Odyssey Web Browser",
        "version": "$1"
    },
    {
        "regex": "OffByOne",
        "name": "Off By One",
        "version": ""
    },
    {
        "regex": "(?:Oregano|OreganMediaBrowser)(?:[ /](\\d+[.\\d]+))?",
        "name": "Oregano",
        "version": "$1"
    },
    {
        "regex": "(?:Polaris|Embider)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Polaris",
        "version": "$1"
    },
    {
        "regex": "SEMC-Browser(?:[/ ](\\d+[.\\d]+))?",
        "name": "SEMC-Browser",
        "version": "$1"
    },
    {
        "regex": "Shiira(?:[/ ](\\d+[.\\d]+))?",
        "name": "Shiira",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Skyfire(?:[/ ](\\d+[.\\d]+))?",
        "name": "Skyfire",
        "version": "$1"
    },
    {
        "regex": "Snowshoe(?:/(\\d+[.\\d]+))?",
        "name": "Snowshoe",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Sunrise(?:Browser)?(?:/(\\d+[.\\d]+))?",
        "name": "Sunrise",
        "version": "$1"
    },
    {
        "regex": "WeTab-Browser",
        "name": "WeTab Browser",
        "version": ""
    },
    {
        "regex": "Xiino(?:/(\\d+[.\\d]+))?",
        "name": "Xiino",
        "version": "$1"
    },
    {
        "regex": "BlackBerry|PlayBook|BB10",
        "name": "BlackBerry Browser",
        "version": ""
    },
    {
        "regex": "Browlser/(\\d+[.\\d]+)",
        "name": "Browlser",
        "version": "$1"
    },
    {
        "regex": "(?<! like )Android(?!\\.)",
        "name": "Android Browser",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Coast(?:/(\\d+[.\\d]+))?",
        "name": "Coast",
        "version": "$1"
    },
    {
        "regex": "Opera%20Coast/(\\d+[.\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)",
        "name": "Coast",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Surf(?:/(\\d+[.\\d]+))?",
        "name": "surf",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Safari%20Technology%20Preview/(\\d+[.\\d]+)",
        "name": "Safari Technology Preview",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:(?:iPod|iPad|iPhone).+Version|MobileSafari)/(\\d+[.\\d]+)",
        "name": "Mobile Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "NetworkingExtension/.+ Network/.+ iOS/(\\d+[.\\d]+)",
        "name": "Mobile Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:Version/(\\d+\\.[.\\d]+) .*)?Mobile.*Safari/",
        "name": "Mobile Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?!^AppleCoreMedia/1\\.0\\.0)(?:iPod|(?<!Apple TV; U; CPU )iPhone|iPad)",
        "name": "Mobile Safari",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Version/(\\d+\\.[.\\d]+) .*Safari/|(?:Safari|Safari(?:%20)?%E6%B5%8F%E8%A7%88%E5%99%A8)/?\\d+",
        "name": "Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "NetworkingExtension/(\\d+[.\\d]+).+ CFNetwork",
        "name": "Safari",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "Macintosh",
        "name": "Safari",
        "version": "",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?:\\w{1,5}[_ ])?Dorado(?: WAP-Browser)?(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "Dorado",
        "version": "$1"
    },
    {
        "regex": "NetSurf(?:/(\\d+[.\\d]+))?",
        "name": "NetSurf",
        "version": "$1",
        "engine": {
            "default": "NetSurf"
        }
    },
    {
        "regex": "Uzbl",
        "name": "Uzbl",
        "version": ""
    },
    {
        "regex": "SimpleBrowser",
        "name": "SimpleBrowser",
        "version": ""
    },
    {
        "regex": "Zvu(?:/(\\d+[.\\d]+))?",
        "name": "Zvu",
        "version": "$1",
        "engine": {
            "default": "Gecko"
        }
    },
    {
        "regex": "GOGGalaxyClient/(\\d+[.\\d]+)?",
        "name": "GOG Galaxy",
        "version": "$1"
    },
    {
        "regex": "WAP Browser/MAUI|(?:\\w*)Maui Wap Browser|MAUI[- ]Browser",
        "name": "MAUI WAP Browser",
        "version": ""
    },
    {
        "regex": "SP%20Browser/(\\d+[.\\d]+)",
        "name": "SP Browser",
        "version": "$1",
        "engine": {
            "default": "WebKit"
        }
    },
    {
        "regex": "(?<!like )Gecko(?!/\\d+ SlimerJS)",
        "name": "Firefox",
        "version": "",
        "engine": {
            "default": "Gecko"
        }
    }
];

});

parcelRegister("kMcQA", function(module, exports) {
module.exports = [
    {
        "regex": "PhantomJS(?:/(\\d+[.\\d]+))?",
        "name": "PhantomJS",
        "version": "$1",
        "url": "https://phantomjs.org/"
    },
    {
        "regex": "IPinfoClient/.*/(\\d+[.\\d]+)",
        "name": "IPinfo",
        "version": "$1",
        "url": "https://github.com/ipinfo"
    },
    {
        "regex": "kiwi-tcms/(\\d+[.\\d]+)",
        "name": "Kiwi TCMS",
        "version": "$1",
        "url": "https://kiwitcms.org"
    },
    {
        "regex": "tcms-api/(\\d+[.\\d]+)",
        "name": "Kiwi TCMS API",
        "version": "$1",
        "url": "https://kiwitcms.org"
    },
    {
        "regex": "Fuzz Faster U Fool v(\\d+[.\\d]+)",
        "name": "FFUF",
        "version": "$1",
        "url": "https://github.com/ffuf/ffuf"
    },
    {
        "regex": "Slim Framework",
        "name": "Slim Framework",
        "version": "",
        "url": "https://www.slimframework.com/"
    },
    {
        "regex": "msray-plus",
        "name": "Msray-Plus",
        "version": "",
        "url": "https://github.com/super-l/msray"
    },
    {
        "regex": "HTMLParser(?:/(\\d+[.\\d]+))?",
        "name": "HTML Parser",
        "version": "$1",
        "url": "https://htmlparser.sourceforge.net/"
    },
    {
        "regex": "^got(?:/(\\d+\\.[.\\d]+))? \\(",
        "name": "got",
        "version": "$1",
        "url": "https://github.com/sindresorhus/got"
    },
    {
        "regex": "Typhoeus",
        "name": "Typhoeus",
        "version": "",
        "url": "https://github.com/typhoeus/typhoeus"
    },
    {
        "regex": "req/v([.\\d]+)",
        "name": "req",
        "version": "$1",
        "url": "https://github.com/imroc/req"
    },
    {
        "regex": "quic-go[ -]HTTP/3",
        "name": "quic-go",
        "version": "",
        "url": "https://github.com/lucas-clemente/quic-go"
    },
    {
        "regex": "azure-data-factory(?:/(\\d+[.\\d]+))?",
        "name": "Azure Data Factory",
        "version": "$1",
        "url": "https://azure.microsoft.com/en-us/products/data-factory/"
    },
    {
        "regex": "Dart/(\\d+[.\\d]+)",
        "name": "Dart",
        "version": "$1",
        "url": "https://dart.dev/"
    },
    {
        "regex": "r-curl(?:/(\\d+[.\\d]+))?",
        "name": "r-curl",
        "version": "$1",
        "url": "https://github.com/jeroen/curl"
    },
    {
        "regex": "python-httpx(?:/(\\d+[.\\d]+))?",
        "name": "HTTPX",
        "version": "$1",
        "url": "https://www.python-httpx.org/"
    },
    {
        "regex": "fasthttp(?:/(\\d+[.\\d]+))?",
        "name": "fasthttp",
        "version": "$1",
        "url": "https://github.com/valyala/fasthttp"
    },
    {
        "regex": "geoipupdate(?:/(\\d+[.\\d]+))?",
        "name": "GeoIP Update",
        "version": "$1",
        "url": "https://github.com/maxmind/geoipupdate"
    },
    {
        "regex": "PHP-Curl-Class(?:/(\\d+[.\\d]+))?",
        "name": "PHP cURL Class",
        "version": "$1",
        "url": "https://github.com/php-curl-class/php-curl-class"
    },
    {
        "regex": "Cpanel-HTTP-Client(?:/(\\d+[.\\d]+))?",
        "name": "cPanel HTTP Client",
        "version": "$1",
        "url": "https://www.cpanel.net/"
    },
    {
        "regex": "AnyEvent-HTTP(?:/(\\d+[.\\d]+))?",
        "name": "AnyEvent HTTP",
        "version": "$1",
        "url": "http://software.schmorp.de/pkg/AnyEvent"
    },
    {
        "regex": "SlimerJS/(\\d+[.\\d]+)",
        "name": "SlimerJS",
        "version": "$1",
        "url": "https://www.slimerjs.org/"
    },
    {
        "regex": "Jaunt/(\\d+[.\\d]+)",
        "name": "Jaunt",
        "version": "$1",
        "url": "https://jaunt-api.com/"
    },
    {
        "regex": "Cypress/(\\d+[.\\d]+)",
        "name": "Cypress",
        "version": "$1",
        "url": "https://github.com/cypress-io/cypress"
    },
    {
        "regex": "Wget(?:/(\\d+[.\\d]+))?",
        "name": "Wget",
        "version": "$1"
    },
    {
        "regex": "Guzzle(?:Http)?(?:/(\\d+[.\\d]+))?",
        "name": "Guzzle (PHP HTTP Client)",
        "version": "$1"
    },
    {
        "regex": "^Symfony HttpClient/",
        "name": "Symfony",
        "version": "$1"
    },
    {
        "regex": "(?:lib)?curl(?:/(\\d+[.\\d]+))?",
        "name": "curl",
        "version": "$1"
    },
    {
        "regex": "python-requests(?:/(\\d+[.\\d]+))?",
        "name": "Python Requests",
        "version": "$1"
    },
    {
        "regex": "Python-httplib2(?:/(\\d+[.\\d]+))?",
        "name": "httplib2",
        "version": "$1",
        "url": "https://pypi.org/project/httplib2/"
    },
    {
        "regex": "Python-urllib3?(?:/?(\\d+[.\\d]+))?",
        "name": "Python urllib",
        "version": "$1"
    },
    {
        "regex": "Apache-HttpClient(?:/?(\\d+[.\\d]+))?",
        "name": "Apache HTTP Client",
        "version": "$1"
    },
    {
        "regex": "Java-http-client(?:/?(\\d+[.\\d]+))?",
        "name": "Java HTTP Client",
        "version": "$1"
    },
    {
        "regex": "Java/?(\\d+[.\\d]+)",
        "name": "Java",
        "version": "$1"
    },
    {
        "regex": "(?:perlclient|libwww-perl)(?:/?(\\d+[.\\d]+))?",
        "name": "Perl",
        "version": "$1"
    },
    {
        "regex": "grpc-java-okhttp/([\\d.]+)",
        "name": "gRPC-Java",
        "version": "$1",
        "url": "https://github.com/grpc/grpc-java"
    },
    {
        "regex": "(?:okhttp|network-okhttp3)/([\\d.]+)",
        "name": "OkHttp",
        "version": "$1"
    },
    {
        "regex": "okhttp3-([\\d.]+)",
        "name": "OkHttp",
        "version": "$1"
    },
    {
        "regex": "HTTP_Request2(?:/(\\d+[.\\d]+))?",
        "name": "HTTP_Request2",
        "version": "$1",
        "url": "https://pear.php.net/package/http_request2"
    },
    {
        "regex": "Mechanize(?:/(\\d+[.\\d]+))?",
        "name": "Mechanize",
        "version": "$1",
        "url": "https://github.com/sparklemotion/mechanize"
    },
    {
        "regex": "aiohttp(?:/(\\d+[.\\d]+))?",
        "name": "aiohttp",
        "version": "$1"
    },
    {
        "regex": "Google-HTTP-Java-Client(?:/(\\d+[\\.\\w-]+))?",
        "name": "Google HTTP Java Client",
        "version": "$1"
    },
    {
        "regex": "WWW-Mechanize(?:/(\\d+[.\\d]+))?",
        "name": "WWW-Mechanize",
        "version": "$1"
    },
    {
        "regex": "Faraday(?: v(\\d+[.\\d]+))?",
        "name": "Faraday",
        "version": "$1",
        "url": "https://github.com/lostisland/faraday"
    },
    {
        "regex": "(?:Go-http-client|^Go )/?(?:(\\d+[.\\d]+))?(?: package http)?",
        "name": "Go-http-client",
        "version": "$1"
    },
    {
        "regex": "urlgrabber(?:/(\\d+[.\\d]+))?",
        "name": "urlgrabber (yum)",
        "version": "$1"
    },
    {
        "regex": "libdnf(?:/(\\d+[.\\d]+))?",
        "name": "libdnf",
        "version": "$1"
    },
    {
        "regex": "HTTPie(?:/(\\d+[.\\d]+))?",
        "name": "HTTPie",
        "version": "$1"
    },
    {
        "regex": "rest-client/(\\d+\\.[.\\d]+) .*ruby",
        "name": "REST Client for Ruby",
        "version": "$1"
    },
    {
        "regex": "RestSharp/(\\d+[.\\d]+)",
        "name": "RestSharp",
        "version": "$1",
        "url": "https://github.com/restsharp/RestSharp"
    },
    {
        "regex": "scalaj-http/(\\d+[.\\d]+)",
        "name": "ScalaJ HTTP",
        "version": "$1",
        "url": "https://github.com/scalaj/scalaj-http"
    },
    {
        "regex": "REST::Client/(\\d+)",
        "name": "Perl REST::Client",
        "version": "$1",
        "url": "https://metacpan.org/pod/REST::Client"
    },
    {
        "regex": "node-fetch/?(\\d+[.\\d]+)?",
        "name": "Node Fetch",
        "version": "$1",
        "url": "https://github.com/node-fetch/node-fetch"
    },
    {
        "regex": "electron-fetch/?(\\d+[.\\d]+)?",
        "name": "Electron Fetch",
        "version": "$1",
        "url": "https://github.com/arantes555/electron-fetch"
    },
    {
        "regex": "ReactorNetty/(\\d+[.\\d]+)",
        "name": "ReactorNetty",
        "version": "$1",
        "url": "https://github.com/reactor/reactor-netty"
    },
    {
        "regex": "PostmanRuntime(?:/(\\d+[.\\d]+))?",
        "name": "Postman Desktop",
        "version": "$1",
        "url": "https://github.com/postmanlabs/postman-runtime"
    },
    {
        "regex": "insomnia(?:/(\\d+[.\\d]+))?",
        "name": "Insomnia REST Client",
        "version": "$1",
        "url": "https://insomnia.rest"
    },
    {
        "regex": "Jakarta Commons-HttpClient/([.\\d]+)",
        "name": "Jakarta Commons HttpClient",
        "version": "$1",
        "url": "https://hc.apache.org/httpclient-3.x"
    },
    {
        "regex": "WinHttp\\.WinHttpRequest.+([.\\d]+)",
        "name": "WinHttp WinHttpRequest",
        "version": "$1"
    },
    {
        "regex": "WinHTTP",
        "name": "Windows HTTP",
        "version": ""
    },
    {
        "regex": "Embarcadero URI Client/([.\\d]+)",
        "name": "Embarcadero URI Client",
        "version": "$1"
    },
    {
        "regex": "Mikrotik/([.\\d]+)",
        "name": "Mikrotik Fetch",
        "version": "$1"
    },
    {
        "regex": "GRequests(?:/(\\d+[.\\d]+))?",
        "name": "GRequests",
        "version": "$1"
    },
    {
        "regex": "akka-http/([.\\d]+)",
        "name": "Akka HTTP",
        "version": "$1"
    },
    {
        "regex": "aria2(?:/(\\d+[.\\d]+))?",
        "name": "Aria2",
        "version": "$1"
    },
    {
        "regex": "(?:BTWebClient/|^uTorrent/)",
        "name": "uTorrent",
        "version": ""
    },
    {
        "regex": "gvfs/(?:(\\d+[.\\d]+))?",
        "name": "gvfs",
        "version": "$1"
    },
    {
        "regex": "uclient-fetch",
        "name": "uclient-fetch",
        "version": ""
    },
    {
        "regex": "cpprestsdk/([.\\d]+)",
        "name": "C++ REST SDK",
        "version": "$1"
    },
    {
        "regex": "lua-resty-http/([.\\d]+).+ngx_",
        "name": "LUA OpenResty NGINX",
        "version": "$1"
    },
    {
        "regex": "unirest-java/([.\\d]+)",
        "name": "Unirest for Java",
        "version": "$1"
    },
    {
        "regex": "jsdom/([.\\d]+)",
        "name": "jsdom",
        "version": "$1"
    },
    {
        "regex": "hackney/([.\\d]+)",
        "name": "hackney",
        "version": "$1"
    },
    {
        "regex": "go-resty/([.\\d]+)",
        "name": "Resty",
        "version": "$1"
    },
    {
        "regex": "pa11y/([.\\d]+)",
        "name": "Pa11y",
        "version": "$1"
    },
    {
        "regex": "ultimate_sitemap_parser/([.\\d]+)",
        "name": "Ultimate Sitemap Parser",
        "version": "$1"
    },
    {
        "regex": "Artifactory/([.\\d]+)",
        "name": "Artifactory",
        "version": "$1"
    },
    {
        "regex": "BSRPC ([.\\d]+)",
        "name": "Open Build Service",
        "version": "$1"
    },
    {
        "regex": "Buildah/([.\\d]+)",
        "name": "Buildah",
        "version": "$1"
    },
    {
        "regex": "buildkit/v?([.\\d]+)",
        "name": "BuildKit",
        "version": "$1"
    },
    {
        "regex": "containerd/v?([.\\d]+)",
        "name": "Containerd",
        "version": "$1"
    },
    {
        "regex": "containers/([.\\d]+)",
        "name": "containers",
        "version": "$1"
    },
    {
        "regex": "cri-o/([.\\d]+)",
        "name": "cri-o",
        "version": "$1"
    },
    {
        "regex": "docker/([.\\d]+)",
        "name": "docker",
        "version": "$1"
    },
    {
        "regex": "go-containerregistry/v([.\\d]+)",
        "name": "go-container registry",
        "version": "$1"
    },
    {
        "regex": "libpod/([.\\d]+)",
        "name": "libpod",
        "version": "$1"
    },
    {
        "regex": "skopeo/([.\\d]+)",
        "name": "Skopeo",
        "version": "$1"
    },
    {
        "regex": "Helm/([.\\d]+)",
        "name": "Helm",
        "version": "$1"
    },
    {
        "regex": "harbor-registry-client",
        "name": "Harbor registry client",
        "version": ""
    },
    {
        "regex": "axios(?:/?(\\d+[.\\d]+))?",
        "name": "Axios",
        "version": "$1"
    },
    {
        "regex": "^CarrierWave/(\\d+\\.[.\\d]+)",
        "name": "CarrierWave",
        "version": "$1"
    },
    {
        "regex": "^Deno/(\\d+\\.[.\\d]+)",
        "name": "Deno",
        "version": "$1"
    },
    {
        "regex": "^Down/(\\d+\\.[.\\d]+)",
        "name": "Down",
        "version": "$1"
    },
    {
        "regex": "^Lavf/",
        "name": "ffmpeg",
        "version": "$1"
    },
    {
        "regex": "^FileDownloader/(\\d+\\.[.\\d]+)",
        "name": "FileDownloader",
        "version": "$1"
    },
    {
        "regex": "^git-annex/(\\d+\\.[.\\d]+)",
        "name": "git-annex",
        "version": "$1"
    },
    {
        "regex": "^GStreamer(?: souphttpsrc)[ /](\\d+\\.[.\\d]+)?",
        "name": "GStreamer",
        "version": "$1"
    },
    {
        "regex": "^HTTP-Tiny/(\\d+\\.[.\\d]+)",
        "name": "HTTP:Tiny",
        "version": "$1"
    },
    {
        "regex": "KaiOS Downloader",
        "name": "KaiOS Downloader",
        "version": ""
    },
    {
        "regex": "^libsoup/(\\d+\\.[.\\d]+)",
        "name": "libsoup",
        "version": "$1"
    },
    {
        "regex": "^Android\\.LVLDM$",
        "name": "Android License Verification Library",
        "version": "$1"
    },
    {
        "regex": "^PRDownloader$",
        "name": "PRDownloader",
        "version": ""
    },
    {
        "regex": "^reqwest/(\\d+\\.[.\\d]+)",
        "name": "reqwest",
        "version": "$1"
    },
    {
        "regex": "^resty-requests",
        "name": "resty-requests",
        "version": ""
    },
    {
        "regex": "^Ruby",
        "name": "ruby",
        "version": ""
    },
    {
        "regex": "^SafariViewService/(\\d+\\.[.\\d]+)",
        "name": "Safari View Service",
        "version": "$1"
    },
    {
        "regex": "^undici$",
        "name": "undici",
        "version": ""
    },
    {
        "regex": "^URL/Emacs Emacs/(\\d+\\.[.\\d]+)",
        "name": "Emacs",
        "version": "$1"
    },
    {
        "regex": "^FDM[ /]([\\d.]+)",
        "name": "Free Download Manager",
        "version": "$1"
    },
    {
        "regex": "OkDownload/([\\d.]+)",
        "name": "OKDownload Library",
        "version": "$1"
    },
    {
        "regex": "^Libsyn4-?(?:peek|download)$",
        "name": "Libsyn",
        "version": ""
    },
    {
        "regex": "AppleCoreMedia/1\\.0\\.0",
        "name": "iOS Application",
        "version": ""
    },
    {
        "regex": "cpp-httplib(?:/(\\d+[.\\d]+))?",
        "name": "cpp-httplib",
        "version": "$1",
        "url": "https://github.com/yhirose/cpp-httplib"
    },
    {
        "regex": "Definitely-Not-Requests",
        "name": "Requests",
        "version": "",
        "url": "https://github.com/psf/requests"
    },
    {
        "regex": "Stealer ([\\d.]+)",
        "name": "Stealer",
        "version": "$1",
        "url": "https://github.com/hotrush/stealer/"
    },
    {
        "regex": "Mandrill-PHP(?:/(\\d+[.\\d]+))?",
        "name": "Mandrill PHP",
        "version": "$1",
        "url": "https://bitbucket.org/mailchimp/mandrill-api-php/src/master/"
    },
    {
        "regex": "^Podgrab",
        "name": "Podgrab",
        "version": "",
        "url": "https://github.com/akhilrex/podgrab"
    },
    {
        "regex": "^Podcast Provider.*?Radio Downloader ([\\d.]+)",
        "name": "Radio Downloader",
        "version": "$1",
        "url": "https://nerdoftheherd.com/tools/radiodld/"
    },
    {
        "regex": "^ESP32 HTTP Client/([\\d.]+)",
        "name": "ESP32 HTTP Client",
        "version": "$1",
        "url": "https://github.com/espressif/arduino-esp32"
    },
    {
        "regex": "babashka\\.http-client(?:/(\\d+[.\\d]+))?",
        "name": "Babashka HTTP Client",
        "version": "$1",
        "url": "https://github.com/babashka/http-client"
    },
    {
        "regex": "http\\.rb(?:/(\\d+[.\\d]+))?",
        "name": "http.rb",
        "version": "$1",
        "url": "https://github.com/httprb/http"
    },
    {
        "regex": "node-superagent(?:/(\\d+[.\\d]+))?",
        "name": "superagent",
        "version": "$1",
        "url": "https://github.com/ladjs/superagent"
    },
    {
        "regex": "CakePHP",
        "name": "CakePHP",
        "version": "",
        "url": "https://www.cakephp.org/"
    },
    {
        "regex": "request\\.js",
        "name": "request",
        "version": "",
        "url": "https://github.com/request/request"
    },
    {
        "regex": "qbhttp(?:/(\\d+[.\\d]+))?",
        "name": "QbHttp",
        "version": "$1",
        "url": "https://github.com/OpenQb/QbHttp"
    },
    {
        "regex": "httprs(?:/(\\d+[.\\d]+))?",
        "name": "httprs",
        "version": "$1",
        "url": "https://github.com/http-server-rs/http-server"
    },
    {
        "regex": "Boto3(?:/(\\d+[.\\d]+))?",
        "name": "Boto3",
        "version": "$1",
        "url": "https://github.com/boto/boto3"
    },
    {
        "regex": "Python-xmlrpc(?:/(\\d+[.\\d]+))?",
        "name": "XML-RPC",
        "version": "$1",
        "url": "https://docs.python.org/3/library/xmlrpc.html"
    },
    {
        "regex": "ICAP-Client-Library(?:/(\\d+[.\\d]+))?",
        "name": "ICAP Client",
        "version": "$1",
        "url": "https://github.com/Peoplecantfly/icapserver"
    },
    {
        "regex": "Cygwin-Setup(?:/(\\d+[.\\d]+))?",
        "name": "Cygwin",
        "version": "$1",
        "url": "https://www.cygwin.com/"
    },
    {
        "regex": "azsdk-python-storage-blob(?:/(\\d+[.\\d]+))?",
        "name": "Azure Blob Storage",
        "version": "$1",
        "url": "https://learn.microsoft.com/en-us/azure/storage/blobs/storage-quickstart-blobs-python"
    },
    {
        "regex": "trafilatura(?:/(\\d+[.\\d]+))?",
        "name": "trafilatura",
        "version": "$1",
        "url": "https://github.com/adbar/trafilatura"
    },
    {
        "regex": "sqlmap(?:/(\\d+[.\\d]+))?",
        "name": "sqlmap",
        "version": "$1",
        "url": "https://sqlmap.org/"
    },
    {
        "regex": "vimeo\\.php(?: (\\d+[.\\d]+))?",
        "name": "vimeo.php",
        "version": "$1",
        "url": "https://github.com/vimeo/vimeo.php"
    },
    {
        "regex": "^PHP/?(\\d+[.\\d]+)",
        "name": "PHP",
        "version": "$1",
        "url": ""
    },
    {
        "regex": "go-network-v(\\d+[.\\d]+)",
        "name": "go-network",
        "version": "$1",
        "url": ""
    },
    {
        "regex": "Bun/(\\d+\\.[.\\d]+)",
        "name": "Bun",
        "version": "$1",
        "url": "https://bun.sh/"
    },
    {
        "regex": "Apidog/(\\d+\\.[.\\d]+)",
        "name": "Apidog",
        "version": "$1",
        "url": "https://apidog.com/"
    },
    {
        "regex": "webchk v(\\d+\\.[.\\d]+)",
        "name": "webchk",
        "version": "$1",
        "url": "https://github.com/amgedr/webchk"
    },
    {
        "regex": "MatomoTrackerSDK/(\\d+[.\\d]+)",
        "name": "MatomoTracker",
        "version": "$1",
        "url": "https://github.com/matomo-org/matomo-sdk-ios"
    },
    {
        "regex": "libHTTP/(\\d+[.\\d]+)",
        "name": "LibHTTP",
        "version": "$1",
        "url": "https://www.libhttp.org/"
    },
    {
        "regex": "BIC Tracker",
        "name": "BIC Tracker",
        "version": "",
        "url": "https://github.com/Simbiat/BIC-Tracker"
    },
    {
        "regex": "Lodestone PHP Parser",
        "name": "Lodestone PHP Parser",
        "version": "",
        "url": "https://github.com/Simbiat/lodestone-parser"
    }
];

});

parcelRegister("biKDk", function(module, exports) {
module.exports = [
    {
        "regex": "Akregator(?:/(\\d+[.\\d]+))?",
        "name": "Akregator",
        "version": "$1",
        "url": "http://userbase.kde.org/Akregator"
    },
    {
        "regex": "Apple-PubSub(?:/(\\d+[.\\d]+))?",
        "name": "Apple PubSub",
        "version": "$1",
        "url": "https://developer.apple.com/library/mac/documentation/Darwin/Reference/ManPages/man1/pubsub.1.html"
    },
    {
        "regex": "BashPodder",
        "name": "BashPodder",
        "version": "",
        "url": "http://lincgeek.org/bashpodder/"
    },
    {
        "regex": "Breaker/v?([\\d.]+)",
        "name": "Breaker",
        "version": "$1",
        "url": "https://www.breaker.audio/"
    },
    {
        "regex": "FeedDemon(?:/(\\d+[.\\d]+))?",
        "name": "FeedDemon",
        "version": "$1",
        "url": "http://www.feeddemon.com/"
    },
    {
        "regex": "Feeddler(?:RSS|PRO)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Feeddler RSS Reader",
        "version": "$1",
        "url": "http://www.chebinliu.com/projects/iphone/feeddler-rss-reader/"
    },
    {
        "regex": "QuiteRSS(?:[/ ](\\d+[.\\d]+))?",
        "name": "QuiteRSS",
        "version": "$1",
        "url": "https://quiterss.org"
    },
    {
        "regex": "gPodder/([\\d.]+)",
        "name": "gPodder",
        "version": "$1",
        "url": "http://gpodder.org/"
    },
    {
        "regex": "JetBrains Omea Reader(?:[/ ](\\d+[.\\d]+))?",
        "name": "JetBrains Omea Reader",
        "version": "$1",
        "url": "http://www.jetbrains.com/omea/reader/"
    },
    {
        "regex": "Liferea(?:[/ ](\\d+[.\\d]+))?",
        "name": "Liferea",
        "version": "$1",
        "url": "http://liferea.sf.net/"
    },
    {
        "regex": "(?:NetNewsWire|Evergreen.+MacOS)(?:[/ ](\\d+[.\\d]+))?",
        "name": "NetNewsWire",
        "version": "$1",
        "url": "http://netnewswireapp.com/"
    },
    {
        "regex": "NewsBlur (?:iPhone|iPad) App(?: v(\\d+[.\\d]+))?",
        "name": "NewsBlur Mobile App",
        "version": "$1",
        "url": "http://www.newsblur.com"
    },
    {
        "regex": "NewsBlur(?:/(\\d+[.\\d]+))",
        "name": "NewsBlur",
        "version": "$1",
        "url": "http://www.newsblur.com"
    },
    {
        "regex": "newsbeuter(?:[/ ](\\d+[.\\d]+))?",
        "name": "Newsbeuter",
        "version": "$1",
        "url": "http://www.newsbeuter.org/"
    },
    {
        "regex": "PritTorrent/([\\d.]+)",
        "name": "PritTorrent",
        "version": "$1",
        "url": "http://bitlove.org"
    },
    {
        "regex": "Pulp[/ ](\\d+[.\\d]+)",
        "name": "Pulp",
        "version": "$1",
        "url": "http://www.acrylicapps.com/pulp/"
    },
    {
        "regex": "ReadKit(?:[/ ](\\d+[.\\d]+))?",
        "name": "ReadKit",
        "version": "$1",
        "url": "http://readkitapp.com/"
    },
    {
        "regex": "Reeder[/ ](\\d+[.\\d]+)",
        "name": "Reeder",
        "version": "$1",
        "url": "http://reederapp.com/"
    },
    {
        "regex": "RSSBandit(?:[/ ](\\d+[.\\d]+))?",
        "name": "RSS Bandit",
        "version": "$1",
        "url": "http://www.rssbandit.org)"
    },
    {
        "regex": "RSS Junkie(?:[/ ](\\d+[.\\d]+))?",
        "name": "RSS Junkie",
        "version": "$1",
        "url": "https://play.google.com/store/apps/details?id=com.bitpowder.rssjunkie"
    },
    {
        "regex": "RSSOwl(?:[/ ](\\d+[.\\d]+))?",
        "name": "RSSOwl",
        "version": "$1",
        "url": "https://www.rssowl.org/"
    },
    {
        "regex": "Stringer",
        "name": "Stringer",
        "version": "",
        "url": "https://github.com/swanson/stringer"
    },
    {
        "regex": "^castero (\\d+\\.[.\\d]+)",
        "name": "castero",
        "version": "$1",
        "url": "https://github.com/xgi/castero"
    },
    {
        "regex": "^castget (\\d+\\.[.\\d]+)",
        "name": "castget",
        "version": "$1",
        "url": "https://castget.johndal.com/"
    },
    {
        "regex": "^Newsboat/([a-z\\d\\.]+)",
        "name": "Newsboat",
        "version": "$1",
        "url": "https://newsboat.org/index.html"
    },
    {
        "regex": "^Playapod(?: Lite)?/(\\d+\\.[.\\d]+)",
        "name": "Playapod",
        "version": "$1",
        "url": "https://playapod.com/"
    },
    {
        "regex": "PodPuppy (\\d+\\.[.\\d]+)",
        "name": "PodPuppy",
        "version": "$1",
        "url": "https://github.com/felixwatts/PodPuppy"
    },
    {
        "regex": "^Reeder/([\\d.]+)",
        "name": "Reeder",
        "version": "$1",
        "url": "https://reederapp.com/"
    }
];

});

parcelRegister("5Fe5h", function(module, exports) {
module.exports = [
    {
        "regex": "Outlook-Express(?:/(\\d+[.\\d]+))?",
        "name": "Outlook Express",
        "version": "$1"
    },
    {
        "regex": "^Outlook-iOS/(?:.+\\((\\d+[.\\d]+)\\)$)?",
        "name": "Microsoft Outlook",
        "version": "$1"
    },
    {
        "regex": "(?:(?:Microsoft )?Outlook|MacOutlook)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Microsoft Outlook",
        "version": "$1"
    },
    {
        "regex": "WindowsMail(?:/(\\d+[.\\d]+))",
        "name": "Windows Mail",
        "version": "$1"
    },
    {
        "regex": "(?:Thunderbird|Icedove|Shredder)(?:/(\\d+[.\\d]+))?",
        "name": "Thunderbird",
        "version": "$1"
    },
    {
        "regex": "Spicebird/(\\d+\\.[.\\d]+)",
        "name": "Spicebird",
        "version": "$1"
    },
    {
        "regex": "Airmail(?: (\\d+[.\\d]+))?",
        "name": "Airmail",
        "version": "$1"
    },
    {
        "regex": "Lotus-Notes(?:/(\\d+[.\\d]+))?",
        "name": "Lotus Notes",
        "version": "$1"
    },
    {
        "regex": "Barca(?:Pro)?(?:[/ ](\\d+[.\\d]+))?",
        "name": "Barca",
        "version": "$1"
    },
    {
        "regex": "Postbox(?:[/ ](\\d+[.\\d]+))?",
        "name": "Postbox",
        "version": "$1"
    },
    {
        "regex": "MailBar(?:[/ ](\\d+[.\\d]+))?",
        "name": "MailBar",
        "version": "$1"
    },
    {
        "regex": "The Bat!(?: Voyager)?(?:[/ ](\\d+[.\\d]+))?",
        "name": "The Bat!",
        "version": "$1"
    },
    {
        "regex": "DAVdroid(?:/(\\d+[.\\d]+))?",
        "name": "DAVdroid",
        "version": "$1"
    },
    {
        "regex": "(?:SeaMonkey|Iceape)(?:/(\\d+[.\\d]+))?",
        "name": "SeaMonkey",
        "version": "$1"
    },
    {
        "regex": "Live5ch/(\\d+[.\\d]+)",
        "name": "Live5ch",
        "version": "$1"
    },
    {
        "regex": "JaneView/",
        "name": "JaneView",
        "version": ""
    },
    {
        "regex": "BathyScaphe/",
        "name": "BathyScaphe",
        "version": ""
    },
    {
        "regex": "Raindrop\\.io/(\\d+[.\\d]+)",
        "name": "Raindrop.io",
        "version": "$1"
    },
    {
        "regex": "Franz/(\\d+[.\\d]+)",
        "name": "Franz",
        "version": "$1"
    },
    {
        "regex": "Mailspring/(\\d+[.\\d]+)",
        "name": "Mailspring",
        "version": "$1"
    },
    {
        "regex": "Notion/(\\d+[.\\d]+)",
        "name": "Notion",
        "version": "$1"
    },
    {
        "regex": "Basecamp[0-9]/?(\\d+[.\\d]+)",
        "name": "Basecamp",
        "version": "$1"
    },
    {
        "regex": "Evernote/?(\\d+[.\\d]+)",
        "name": "Evernote",
        "version": "$1"
    },
    {
        "regex": "ramboxpro/(\\d+\\.[.\\d]+)?",
        "name": "Rambox Pro",
        "version": "$1"
    },
    {
        "regex": "Mailbird/(\\d+\\.[.\\d]+)/",
        "name": "Mailbird",
        "version": "$1"
    },
    {
        "regex": "Yahoo%20Mail",
        "name": "Yahoo Mail",
        "version": ""
    },
    {
        "regex": "jp.co.yahoo.ymail/([\\d.]+)",
        "name": "Yahoo! Mail",
        "version": "$1"
    },
    {
        "regex": "eM ?Client/(\\d+\\.[.\\d]+)",
        "name": "eM Client",
        "version": "$1"
    },
    {
        "regex": "NaverMailApp/(\\d+\\.[.\\d]+)",
        "name": "NAVER Mail",
        "version": "$1"
    },
    {
        "regex": "^Mail/([\\d.]+)",
        "name": "Apple Mail",
        "version": "$1"
    },
    {
        "regex": "Foxmail/(\\d+[.\\d]+)",
        "name": "Foxmail",
        "version": "$1"
    },
    {
        "regex": "MailMaster(?:PC|_Android_Mobile)?/(\\d+[.\\d]+)",
        "name": "Mail Master",
        "version": "$1"
    },
    {
        "regex": "BlueMail/(\\d+[.\\d]+)",
        "name": "BlueMail",
        "version": "$1"
    },
    {
        "regex": "mailapp/(\\d+\\.[.\\d]+)",
        "name": "MailApp",
        "version": "$1"
    },
    {
        "regex": "Android-Gmail",
        "name": "Gmail",
        "version": ""
    }
];

});

parcelRegister("bqJQ3", function(module, exports) {
module.exports = [
    {
        "regex": "KolibriOS",
        "name": "KolibriOS",
        "version": ""
    },
    {
        "regex": "Coolita OS QJY/.+LiteOS(\\d+[.\\d]+)",
        "name": "Coolita OS",
        "version": "$1"
    },
    {
        "regex": "Coolita OS QJY/(\\d+[.\\d]+)",
        "name": "Coolita OS",
        "version": "$1"
    },
    {
        "regex": "^NEXT ",
        "name": "RTOS & Next",
        "version": ""
    },
    {
        "regex": "(?:Pacific|(?<!like )Quest).+OculusBrowser|Standalone HMD|PortalGo",
        "name": "Meta Horizon",
        "version": ""
    },
    {
        "regex": "LeafOS",
        "name": "LeafOS",
        "version": ""
    },
    {
        "regex": "Cloud Phone",
        "name": "Puffin OS",
        "version": ""
    },
    {
        "regex": "RisingOS",
        "name": "risingOS",
        "version": ""
    },
    {
        "regex": ".+.cm(\\d).x86_64",
        "name": "Azure Linux",
        "version": "$1"
    },
    {
        "regex": "Linux[/-].+-(azure|Microsoft)",
        "name": "Azure Linux",
        "version": ""
    },
    {
        "regex": "ViziOS/(\\d+[.\\d]+)",
        "name": "ViziOS",
        "version": "$1"
    },
    {
        "regex": "VIZIO(?: SmartCast|-DTV)",
        "name": "ViziOS",
        "version": ""
    },
    {
        "regex": "blackPanther OS",
        "name": "blackPanther OS",
        "version": ""
    },
    {
        "regex": "WoPhone(?:/(\\d+[.\\d]+))?",
        "name": "WoPhone",
        "version": "$1"
    },
    {
        "regex": "KIN\\.(?:One|Two) (\\d+[.\\d]+)",
        "name": "KIN OS",
        "version": "$1"
    },
    {
        "regex": "Star-Blade OS",
        "name": "Star-Blade OS",
        "version": ""
    },
    {
        "regex": "Qtopia/(\\d+[.\\d]+)",
        "name": "Qtopia",
        "version": "$1"
    },
    {
        "regex": "OpenVMS V(\\d+[.\\d]+)",
        "name": "OpenVMS",
        "version": "$1"
    },
    {
        "regex": "AROS",
        "name": "AROS",
        "version": ""
    },
    {
        "regex": "\\(NEXT\\)",
        "name": "NeXTSTEP",
        "version": ""
    },
    {
        "regex": "NEWS-OS (\\d+[.\\d]+)",
        "name": "NEWS-OS",
        "version": "$1"
    },
    {
        "regex": "ULTRIX (\\d+[.\\d]+)",
        "name": "ULTRIX",
        "version": "$1"
    },
    {
        "regex": "Turbolinux/(\\d+[.\\d]+)",
        "name": "Turbolinux",
        "version": "$1"
    },
    {
        "regex": "Joli OS/(\\d+[.\\d]+)",
        "name": "Joli OS",
        "version": "$1"
    },
    {
        "regex": "GENIX (\\d+[.\\d]+)",
        "name": "GENIX",
        "version": "$1"
    },
    {
        "regex": "gNewSense/.*\\((\\d+[.\\d]+)",
        "name": "gNewSense",
        "version": "$1"
    },
    {
        "regex": "Geos (\\d+[.\\d]+)",
        "name": "GEOS",
        "version": "$1"
    },
    {
        "regex": "MOT-.*LinuxOS/",
        "name": "Motorola EZX",
        "version": ""
    },
    {
        "regex": "Baidu Yi",
        "name": "Baidu Yi",
        "version": ""
    },
    {
        "regex": "\uBD89\uC740\uBCC4|Fedora/(?:\\d+\\.[\\d.-]+)\\.rs(\\d+(?:[_.]\\d+)*)",
        "name": "Red Star",
        "version": "$1"
    },
    {
        "regex": "Linux/(?:\\d+\\.[\\d.-]+)-(?:pve|v(\\d)\\+)",
        "name": "Proxmox VE",
        "version": "$1"
    },
    {
        "regex": "Linux/(?:\\d+\\.[\\d.-]+)-(?:\\d+[.\\d]+)stab(?:\\d+[.\\d]+)",
        "name": "OpenVZ",
        "version": ""
    },
    {
        "regex": "rocky/(\\d+[.\\d]+)",
        "name": "Rocky Linux",
        "version": "$1"
    },
    {
        "regex": "clear-linux-os/(\\d+[.\\d]+)",
        "name": "Clear Linux OS",
        "version": "$1"
    },
    {
        "regex": "alpine/(\\d+[.\\d]+)",
        "name": "Alpine Linux",
        "version": "$1"
    },
    {
        "regex": "scientific/(\\d+[.\\d]+)",
        "name": "Scientific Linux",
        "version": "$1"
    },
    {
        "regex": "eulerosv(\\d)r(\\d+)",
        "name": "EulerOS",
        "version": "$1.$2"
    },
    {
        "regex": "loongnix-server/(\\d+[.\\d]+)",
        "name": "Loongnix",
        "version": "$1"
    },
    {
        "regex": "Linux/(?:\\d+\\.[\\d.-]+)\\.lns(\\d+(?:[_.]\\d+)*)\\.loongarch64",
        "name": "Loongnix",
        "version": "$1"
    },
    {
        "regex": "AOSC OS",
        "name": "AOSC OS",
        "version": ""
    },
    {
        "regex": "SerenityOS|Ladybird/",
        "name": "SerenityOS",
        "version": ""
    },
    {
        "regex": "Helix Phone",
        "name": "HELIX OS",
        "version": ""
    },
    {
        "regex": "Armadillo",
        "name": "Armadillo OS",
        "version": ""
    },
    {
        "regex": "Webian",
        "name": "Webian",
        "version": ""
    },
    {
        "regex": "Linux.*Liri/",
        "name": "Liri OS",
        "version": ""
    },
    {
        "regex": "FRITZ!OS(?:/0(\\d+[.\\d]+))?",
        "name": "FRITZ!OS",
        "version": "$1"
    },
    {
        "regex": "UOS$",
        "name": "UOS",
        "version": ""
    },
    {
        "regex": "Raspbian/(\\d+[.\\d]+)",
        "name": "Raspbian",
        "version": "$1"
    },
    {
        "regex": "Raspbian",
        "name": "Raspberry Pi OS",
        "version": ""
    },
    {
        "regex": "BrightSign/(?:[A-Z0-9]+)/(\\d+[.\\d]+)",
        "name": "BrightSignOS",
        "version": "$1"
    },
    {
        "regex": "BrightSign/(\\d+[.\\d]+)",
        "name": "BrightSignOS",
        "version": "$1"
    },
    {
        "regex": "LuneOS",
        "name": "LuneOS",
        "version": ""
    },
    {
        "regex": "Linux/(?:\\d+\\.[\\d.-]+)\\.el(\\d+(?:[_.]\\d+)*)uek",
        "name": "Oracle Linux",
        "version": "$1"
    },
    {
        "regex": ".+kali(\\d)",
        "name": "Kali",
        "version": "$1"
    },
    {
        "regex": "TiVoOS/(\\d+[.\\d]+)",
        "name": "TiVo OS",
        "version": "$1"
    },
    {
        "regex": "VIDAA/(\\d+[.\\d]+)",
        "name": "VIDAA",
        "version": "$1"
    },
    {
        "regex": "PICO.+OS(\\d+[.\\d]*)",
        "name": "PICO OS",
        "version": "$1"
    },
    {
        "regex": "RED OS; Linux",
        "name": "RedOS",
        "version": ""
    },
    {
        "regex": "Mikrotik/(\\d)\\.x",
        "name": "RouterOS",
        "version": "$1"
    },
    {
        "regex": "FINNEY U1",
        "name": "Sirin OS",
        "version": ""
    },
    {
        "regex": "Nova; Linux",
        "name": "Nova",
        "version": ""
    },
    {
        "regex": "Android 10.+bliss_maple",
        "name": "Bliss OS",
        "version": "12"
    },
    {
        "regex": ".+tlinux(\\d)",
        "name": "TencentOS",
        "version": "$1"
    },
    {
        "regex": ".+.amzn(\\d)(?:int)?.x86_64|Linux/.+aws",
        "name": "Amazon Linux",
        "version": "$1"
    },
    {
        "regex": "Linux/.+-c9$",
        "name": "Amazon Linux",
        "version": "2023"
    },
    {
        "regex": " COS like Android",
        "name": "China OS",
        "version": ""
    },
    {
        "regex": "Android (\\d+[.\\d]*); ClearPHONE",
        "name": "ClearOS Mobile",
        "version": "$1"
    },
    {
        "regex": "Plasma Mobile",
        "name": "Plasma Mobile",
        "version": ""
    },
    {
        "regex": "KreaTV/0\\.0\\.0\\.0",
        "name": "KreaTV",
        "version": ""
    },
    {
        "regex": "KreaTV/(\\d+[.\\d]+)",
        "name": "KreaTV",
        "version": "$1"
    },
    {
        "regex": "Linux (?:[^;]+); Opera TV(?: Store)?/|^Opera/\\d+\\.\\d+ \\(Linux mips",
        "name": "Opera TV",
        "version": ""
    },
    {
        "regex": "OPR/.+TV Store/(\\d+[.\\d]+)",
        "name": "Opera TV",
        "version": "$1"
    },
    {
        "regex": "Grid OS (\\d+[.\\d]+)",
        "name": "GridOS",
        "version": "$1"
    },
    {
        "regex": "CaixaMagica",
        "name": "Caixa M\xe1gica",
        "version": ""
    },
    {
        "regex": "Mageia; Linux",
        "name": "Mageia",
        "version": ""
    },
    {
        "regex": "(?:WH|WhaleTV)/?(\\d+[.\\d]+)",
        "name": "Whale OS",
        "version": "$1"
    },
    {
        "regex": "Zeasn/.*TBrowser/2\\.0",
        "name": "Whale OS",
        "version": "1"
    },
    {
        "regex": "Zeasn/",
        "name": "Whale OS",
        "version": ""
    },
    {
        "regex": "Tizen[ /]?(\\d+[.\\d]+)?",
        "name": "Tizen",
        "version": "$1"
    },
    {
        "regex": "Maple (?!III)(?:\\d+[.\\d]+)|Maple_?\\d{4}|HbbTV/.+Samsung",
        "name": "Tizen",
        "version": ""
    },
    {
        "regex": "Android (\\d+[.\\d]+)-RT",
        "name": "YunOS",
        "version": "$1"
    },
    {
        "regex": "(?:Ali)?YunOS[ /]?(\\d+[.\\d]+)?",
        "name": "YunOS",
        "version": "$1"
    },
    {
        "regex": "Windows Phone;FBSV/(\\d+[.\\d]+)",
        "name": "Windows Phone",
        "version": "$1"
    },
    {
        "regex": "(?:Windows Phone (?:OS)?|wds)[ /]?(\\d+[.\\d]+)",
        "name": "Windows Phone",
        "version": "$1"
    },
    {
        "regex": "XBLWP7|Windows Phone",
        "name": "Windows Phone",
        "version": ""
    },
    {
        "regex": "Windows CE(?: (\\d+[.\\d]+))?",
        "name": "Windows CE",
        "version": "$1"
    },
    {
        "regex": "(?:IEMobile|Windows ?Mobile)(?: (\\d+[.\\d]+))?",
        "name": "Windows Mobile",
        "version": "$1"
    },
    {
        "regex": "Windows NT 6\\.2; ARM;",
        "name": "Windows RT",
        "version": ""
    },
    {
        "regex": "Windows NT 6\\.3; ARM;",
        "name": "Windows RT",
        "version": "8.1"
    },
    {
        "regex": "Windows IoT 10\\.0",
        "name": "Windows IoT",
        "version": "10"
    },
    {
        "regex": "KAIOS(?:/(\\d+[.\\d]+))?",
        "name": "KaiOS",
        "version": "$1"
    },
    {
        "regex": "OpenHarmony(?:[/ ](\\d+[.\\d]+))?",
        "name": "OpenHarmony",
        "version": "$1"
    },
    {
        "regex": "HarmonyOS(?:[/ ](\\d+[.\\d]+))?",
        "name": "HarmonyOS",
        "version": "$1"
    },
    {
        "regex": "Hmos/1",
        "name": "HarmonyOS",
        "version": "1.0.0"
    },
    {
        "regex": "RazoDroiD(?: v(\\d+[.\\d]*))?",
        "name": "RazoDroiD",
        "version": "$1"
    },
    {
        "regex": "MildWild(?: CM-(\\d+[.\\d]*))?",
        "name": "MildWild",
        "version": "$1"
    },
    {
        "regex": "CyanogenMod(?:[\\-/](?:CM)?(\\d+[.\\d]*))?",
        "name": "CyanogenMod",
        "version": "$1"
    },
    {
        "regex": "(?:.*_)?MocorDroid(?:(\\d+[.\\d]*))?",
        "name": "MocorDroid",
        "version": "$1"
    },
    {
        "regex": "FydeOS",
        "name": "FydeOS",
        "version": ""
    },
    {
        "regex": "Fire OS(?:/(\\d+[.\\d]*))?",
        "name": "Fire OS",
        "version": "$1"
    },
    {
        "regex": "(?:Andr[o0]id (\\d([\\d.])*);? |Amazon;|smarttv_)AFT|AEO[ACBHKT]|KF[ADFGJKMORSTQ]|.*FIRETVSTICK2018",
        "name": "Fire OS",
        "versions": [
            {
                "regex": "Andr[o0]id 1[01].+ (?:AFT|KF[ADFGJKMORSTQ])",
                "version": "8"
            },
            {
                "regex": "Andr[o0]id 9.+ (?:AEO[AHT]|AFT|KF[ADFGJKMORSTQ])|AFTSO001",
                "version": "7"
            },
            {
                "regex": "Andr[o0]id 7|.+FIRETVSTICK2018",
                "version": "6"
            },
            {
                "regex": "Andr[o0]id 5\\.1",
                "version": "5"
            },
            {
                "regex": "Andr[o0]id 4\\.4\\.3",
                "version": "4.5.1"
            },
            {
                "regex": "Andr[o0]id 4\\.4\\.2",
                "version": "4"
            },
            {
                "regex": "Andr[o0]id 4\\.2\\.2",
                "version": "3"
            },
            {
                "regex": "Andr[o0]id 4\\.0\\.[34]",
                "version": "3"
            },
            {
                "regex": "Andr[o0]id 4\\.0",
                "version": "2"
            },
            {
                "regex": "Andr[o0]id 2\\.3\\.3",
                "version": "1"
            }
        ]
    },
    {
        "regex": "cordova-amazon-fireos",
        "name": "Fire OS",
        "version": ""
    },
    {
        "regex": "revengeos_x2",
        "name": "Revenge OS",
        "version": "2"
    },
    {
        "regex": "Lineage_(\\d+[.\\d]*)",
        "name": "Lineage OS",
        "version": "$1"
    },
    {
        "regex": "(?:Android (\\d([\\d.])*);? )?lineage_\\w+",
        "name": "Lineage OS",
        "versions": [
            {
                "regex": "Android 16",
                "version": "23"
            },
            {
                "regex": "Android 15",
                "version": "22"
            },
            {
                "regex": "Android 14",
                "version": "21"
            },
            {
                "regex": "Android 13",
                "version": "20.0"
            },
            {
                "regex": "Android 12\\.1",
                "version": "19.1"
            },
            {
                "regex": "Android 12",
                "version": "19.0"
            },
            {
                "regex": "Android 11",
                "version": "18.0"
            },
            {
                "regex": "Android 10",
                "version": "17.0"
            },
            {
                "regex": "Android 9",
                "version": "16.0"
            },
            {
                "regex": "Android 8\\.1",
                "version": "15.1"
            },
            {
                "regex": "Android 8",
                "version": "15.0"
            },
            {
                "regex": "Android 7\\.1",
                "version": "14.1"
            },
            {
                "regex": "Android 7",
                "version": "14.0"
            },
            {
                "regex": "Android 6",
                "version": "13.0"
            },
            {
                "regex": "Android 5\\.1",
                "version": "12.1"
            },
            {
                "regex": "Android 5",
                "version": "12.0"
            },
            {
                "regex": "Android 4\\.4",
                "version": "11.0"
            },
            {
                "regex": "Android 4\\.3",
                "version": "10.2"
            },
            {
                "regex": "Android 4\\.2",
                "version": "10.1"
            },
            {
                "regex": "Android 4",
                "version": "9.1.0"
            }
        ]
    },
    {
        "regex": "Android 8(?:[\\d.]*);(?: [\\w-]+;)? rr_fortuna3g",
        "name": "Resurrection Remix OS",
        "version": "6"
    },
    {
        "regex": "RemixOS|Remix (?:Pro|Mini)",
        "name": "Remix OS",
        "versions": [
            {
                "regex": "RemixOS 5",
                "version": "1"
            },
            {
                "regex": "RemixOS 6|Remix Mini",
                "version": "2"
            },
            {
                "regex": "Remix Pro",
                "version": "3"
            }
        ]
    },
    {
        "regex": "FreeBSD.+Android",
        "name": "FreeBSD",
        "version": ""
    },
    {
        "regex": "Chrome/(\\d+\\.[.\\d]+) Odd/|SM-R(?:8[6-9]|9)|LEM14",
        "name": "Wear OS",
        "version": ""
    },
    {
        "regex": "SeewoOS x86_64 (\\d+[.\\d]+)",
        "name": "SeewoOS",
        "version": "$1"
    },
    {
        "regex": "(?:CrOS [a-z0-9_]+ |.*Build/R\\d+-)(\\d+[.\\d]+)|Chromebook",
        "name": "Chrome OS",
        "version": "$1"
    },
    {
        "regex": "(?:Android (?:9|1[0-6])[.\\d]*|Linux x86_64); (?:asurada|atlas|brask|brox|brya|cherry|coral|corsola|dedede|drallion|elm|eve|fizz|geralt|grunt|guybrush|hana|hatch|jacuzzi|kalista|kukui|nami|nautilus|nirva|nissa|nocturne|octopus|ovis|puff|pyro|rammus|rauru|reef|rex|sand|sarien|skyrim|snappy|soraka|staryu|strongbad|trogdor|volteer|zork)\\)",
        "name": "Chrome OS",
        "version": ""
    },
    {
        "regex": "Linux; Andr0id[; ](\\d+[.\\d]*)",
        "name": "Android TV",
        "version": "$1"
    },
    {
        "regex": "Android[; ](\\d+[.\\d]*).+(?:(?:Android(?: UHD)?|AT&T|Google|Smart)[ _]?TV|AOSP on r33a0|BRAVIA|wv-atv)",
        "name": "Android TV",
        "version": "$1"
    },
    {
        "regex": "Windows.+Andr0id TV|.+(?:K_?Android_?TV_|AndroidTV|GoogleTV_)",
        "name": "Android TV",
        "version": ""
    },
    {
        "regex": "(?:Android API \\d+|\\d+/tclwebkit(?:\\d+[.\\d]*)|(?:(?<!\\d )Android/\\d{2}|Android (?!1[0-6])\\d{2})(?![^; ]))",
        "name": "Android",
        "versions": [
            {
                "regex": "Android API 36|36/tclwebkit|Android[ /]36",
                "version": "16"
            },
            {
                "regex": "Android API 35|35/tclwebkit|Android[ /]35",
                "version": "15"
            },
            {
                "regex": "Android API 34|34/tclwebkit|Android[ /]34",
                "version": "14"
            },
            {
                "regex": "Android API 33|33/tclwebkit|Android[ /]33",
                "version": "13"
            },
            {
                "regex": "Android API 32|32/tclwebkit|Android[ /]32",
                "version": "12.1"
            },
            {
                "regex": "Android API 31|31/tclwebkit|Android[ /]31",
                "version": "12"
            },
            {
                "regex": "Android API 30|30/tclwebkit|Android[ /]30",
                "version": "11"
            },
            {
                "regex": "Android API 29|29/tclwebkit|Android[ /]29",
                "version": "10"
            },
            {
                "regex": "Android API 28|28/tclwebkit|Android[ /]28",
                "version": "9"
            },
            {
                "regex": "Android API 27|27/tclwebkit|Android[ /]27",
                "version": "8.1"
            },
            {
                "regex": "Android API 26|26/tclwebkit|Android[ /]26",
                "version": "8"
            },
            {
                "regex": "Android API 25|25/tclwebkit|Android[ /]25",
                "version": "7.1"
            },
            {
                "regex": "Android API 24|24/tclwebkit|Android[ /]24",
                "version": "7"
            },
            {
                "regex": "Android API 23|23/tclwebkit|Android[ /]23",
                "version": "6"
            },
            {
                "regex": "Android API 22|22/tclwebkit|Android[ /]22",
                "version": "5.1"
            },
            {
                "regex": "Android API 21|21/tclwebkit|Android[ /]21",
                "version": "5"
            },
            {
                "regex": "Android API (?:20|19)|(?:20|19)/tclwebkit|Android[ /](?:20|19)",
                "version": "4.4"
            },
            {
                "regex": "Android API 18|18/tclwebkit|Android[ /]18",
                "version": "4.3"
            },
            {
                "regex": "Android API 17|17/tclwebkit|Android[ /]17",
                "version": "4.2"
            },
            {
                "regex": "Android API 16|16/tclwebkit|Android[ /]16",
                "version": "4.1"
            },
            {
                "regex": "Android API 15|15/tclwebkit|Android[ /]15",
                "version": "4.0.3"
            },
            {
                "regex": "Android API 14|14/tclwebkit|Android[ /]14",
                "version": "4.0.1"
            }
        ]
    },
    {
        "regex": "Android Marshmallow",
        "name": "Android",
        "version": "6"
    },
    {
        "regex": "(?:Podbean|Podimo)(?:.*)/Android|Rutube(?:TV)?BlackAndroid",
        "name": "Android",
        "version": ""
    },
    {
        "regex": "(?:Android OS|OMDroid|sdk_gphone64_arm64-userdebug|StarOS)[ /](\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Pinterest for Android(?: Tablet)?/.*; (\\d(?:[\\d.]*))\\)$",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android; (\\d+[.\\d]*); Mobile;",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android;(\\d+[.\\d]*);API",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android \\(\\d{2}/(\\d+[.\\d]*);",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "[ ]([\\d.]+)\\) AppleWebKit.*ROBLOX Android App",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:(?:Orca-)?(?<!like |/|RadioPublic |Anghami |Callpod Keeper for |com\\.linkedin\\.)Android|Adr|AOSP)[ /]?(?:[a-z]+ )?(\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:Allview_TX1_Quasar|Cosmote_My_mini_Tab) (\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android ?(?:jelly bean|Kit Kat|S\\.O\\. Ginger Bread|The FireCyano|:) (\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:Orca-Android|FB4A).*FBSV/(\\d+[.\\d]*);",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "\\(Android:.*\\); API (\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Android-(\\d+[.\\d]*);",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": " Adr |.*(?<!like |/ )Android|Silk-Accelerated=[a-z]{4,5}",
        "name": "Android",
        "version": ""
    },
    {
        "regex": "BeyondPod|AntennaPod|Podkicker|DoggCatcher|okhttp|Podcatcher Deluxe|Sonos/.+\\(ACR_|.*WhatsApp/.*A$",
        "name": "Android",
        "version": ""
    },
    {
        "regex": "Linux; diordnA[; ](\\d+[.\\d]*)",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "^A/(\\d+[.\\d]*)/",
        "name": "Android",
        "version": "$1"
    },
    {
        "regex": "Sailfish|Jolla",
        "name": "Sailfish OS",
        "version": ""
    },
    {
        "regex": "AmigaOS[ ]?(\\d+[.\\d]+)",
        "name": "AmigaOS",
        "version": "$1"
    },
    {
        "regex": "AmigaOS|AmigaVoyager|Amiga-AWeb",
        "name": "AmigaOS",
        "version": ""
    },
    {
        "regex": "ThreadX(?:_OS)?(?:/(\\d+[.\\d]*))?",
        "name": "ThreadX",
        "version": "$1"
    },
    {
        "regex": "Nucleus(?:(?: |/v?)(\\d+[.\\d]*))?",
        "name": "MTK / Nucleus",
        "version": "$1"
    },
    {
        "regex": "MTK(?:(?: |/v?)(\\d+[.\\d]*))?",
        "name": "MTK / Nucleus",
        "version": "$1"
    },
    {
        "regex": "MRE/(\\d+)\\.(\\d+).*;MAUI",
        "name": "MRE",
        "version": "$1.$2"
    },
    {
        "regex": "Linspire",
        "name": "Linspire",
        "version": ""
    },
    {
        "regex": "LindowsOS",
        "name": "LindowsOS",
        "version": ""
    },
    {
        "regex": "Zenwalk GNU Linux",
        "name": "Zenwalk",
        "version": ""
    },
    {
        "regex": "Linux.+kanotix",
        "name": "Kanotix",
        "version": ""
    },
    {
        "regex": "moonOS/(\\d+.[\\d.]+)",
        "name": "moonOS",
        "version": "$1"
    },
    {
        "regex": "Foresight Linux",
        "name": "Foresight Linux",
        "version": ""
    },
    {
        "regex": "Pardus/(\\d+.[\\d.]+)",
        "name": "Pardus",
        "version": "$1"
    },
    {
        "regex": "Librem 5",
        "name": "PureOS",
        "version": ""
    },
    {
        "regex": "uclient-fetch",
        "name": "OpenWrt",
        "version": ""
    },
    {
        "regex": "RokuOS/.+RokuOS (\\d+.[\\d.]+)",
        "name": "Roku OS",
        "version": "$1"
    },
    {
        "regex": "Roku(?:OS|4640X)?/(?:DVP|Pluto)?-?(\\d+[.\\d]+)?",
        "name": "Roku OS",
        "version": "$1"
    },
    {
        "regex": "Roku; (?:AP|UI); (\\d+[.\\d]+)",
        "name": "Roku OS",
        "version": "$1"
    },
    {
        "regex": "RokuBrowser/.+\\(TV-([a-z0-9]+)-(\\d+.[\\d.]+)\\)",
        "name": "Roku OS",
        "version": "$2"
    },
    {
        "regex": "dvkbuntu",
        "name": "DVKBuntu",
        "version": ""
    },
    {
        "regex": "Helio/(\\d+[.\\d]+)",
        "name": "Lumin OS",
        "version": "$1"
    },
    {
        "regex": "HasCodingOs (\\d+[.\\d]+)",
        "name": "HasCodingOS",
        "version": "$1"
    },
    {
        "regex": "PCLinuxOS/(\\d+[.\\d]+)",
        "name": "PCLinuxOS",
        "version": "$1"
    },
    {
        "regex": "(Ordissimo|webissimo3)",
        "name": "Ordissimo",
        "version": ""
    },
    {
        "regex": "(?:Win|Sistema )Fenix",
        "name": "Fenix",
        "version": ""
    },
    {
        "regex": "TOS; Linux",
        "name": "TmaxOS",
        "version": ""
    },
    {
        "regex": "Maemo",
        "name": "Maemo",
        "version": ""
    },
    {
        "regex": "Arch ?Linux(?:[ /\\-](\\d+[.\\d]+))?",
        "name": "Arch Linux",
        "version": "$1"
    },
    {
        "regex": "VectorLinux(?: package)?(?:[ /\\-](\\d+[.\\d]+))?",
        "name": "VectorLinux",
        "version": "$1"
    },
    {
        "regex": "sles/(\\d+[.\\d]+)",
        "name": "SUSE",
        "version": "$1"
    },
    {
        "regex": "(?:rhel|Red Hat Enterprise Linux Server)/(\\d+[.\\d]+)",
        "name": "Red Hat",
        "version": "$1"
    },
    {
        "regex": ".+redhat-linux-gnu|rhel|Red Hat Enterprise Linux Server",
        "name": "Red Hat",
        "version": ""
    },
    {
        "regex": "CentOS Stream (\\d)",
        "name": "CentOS Stream",
        "version": "$1"
    },
    {
        "regex": "centos(?: Linux)?/(\\d+[.\\d]+) ",
        "name": "CentOS",
        "version": "$1"
    },
    {
        "regex": ".+.el(\\d+(?:[_.]\\d+)*).(?:centos|x86_64)",
        "name": "CentOS",
        "version": "$1"
    },
    {
        "regex": "CentOS Linux (\\d)",
        "name": "CentOS",
        "version": "$1"
    },
    {
        "regex": "Fedora/.+.fc(\\d+)",
        "name": "Fedora",
        "version": "$1"
    },
    {
        "regex": "Mandriva(?: Linux)?/.+mdv(\\d+[.\\d]+)",
        "name": "Mandriva",
        "version": "$1"
    },
    {
        "regex": "Linux Mint/(\\d)",
        "name": "Mint",
        "version": "$1"
    },
    {
        "regex": "Zorin OS (\\d+)",
        "name": "ZorinOS",
        "version": "$1"
    },
    {
        "regex": "Ubuntu[-/]hardy",
        "name": "Ubuntu",
        "version": "8.04"
    },
    {
        "regex": "debian/stretch",
        "name": "Debian",
        "version": "9.13"
    },
    {
        "regex": "Ubuntu[-/]feisty",
        "name": "Ubuntu",
        "version": "7.04"
    },
    {
        "regex": "Ubuntu[-/]edgy",
        "name": "Ubuntu",
        "version": "6.10"
    },
    {
        "regex": "Ubuntu[-/]dapper",
        "name": "Ubuntu",
        "version": "6.06"
    },
    {
        "regex": "Ubuntu[-/]breezy",
        "name": "Ubuntu",
        "version": "5.10"
    },
    {
        "regex": "Ubuntu[ /](\\d+[.\\d]+)",
        "name": "Ubuntu",
        "version": "$1"
    },
    {
        "regex": "Linux; .*((?:Debian|Knoppix|Mint|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack))[ /](\\d+[.\\d]+)",
        "name": "$1",
        "version": "$2"
    },
    {
        "regex": "Deepin[ /](\\d+[.\\d]+)",
        "name": "Deepin",
        "version": "$1"
    },
    {
        "regex": "(Debian|Knoppix|Mint(?! Browser)|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack|Freebox|ASPLinux)(?:(?: Enterprise)? Linux)?(?:[ /\\-](\\d+[.\\d]+))?",
        "name": "$1",
        "version": "$2"
    },
    {
        "regex": "OS ROSA; Linux",
        "name": "Rosa",
        "version": ""
    },
    {
        "regex": "(?:Web0S; .*WEBOS|webOS|web0S|Palm webOS|hpwOS)(?:[/]?(\\d+[.\\d]+))?",
        "name": "webOS",
        "version": "$1",
        "versions": [
            {
                "regex": "WEBOS(\\d+[.\\d]+)",
                "version": "$1"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/120",
                "version": "25"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/108",
                "version": "24"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/94",
                "version": "23"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/87",
                "version": "22"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/79",
                "version": "6"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/68",
                "version": "5"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/53",
                "version": "4"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Chr[o0]me/38",
                "version": "3"
            },
            {
                "regex": "WEBOS1",
                "version": "1"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Safari/538",
                "version": "2"
            },
            {
                "regex": "Web0S; Linux/SmartTV.+Safari/537",
                "version": "1"
            }
        ]
    },
    {
        "regex": "(?:PalmOS|Palm OS)(?:[/ ](\\d+[.\\d]+))?|Palm",
        "name": "palmOS",
        "version": "$1"
    },
    {
        "regex": "Xiino(?:.*v\\. (\\d+[.\\d]+))?",
        "name": "palmOS",
        "version": "$1"
    },
    {
        "regex": "MorphOS(?:[ /](\\d+[.\\d]+))?",
        "name": "MorphOS",
        "version": "$1"
    },
    {
        "regex": "FBW.+FBSV/(\\d+[.\\d]*);",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "Windows.+OS: (\\d+[.\\d]*)",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "Windows; ?(\\d+[.\\d]*);",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "mingw32|winhttp|WhatsApp/.*W$",
        "name": "Windows",
        "version": ""
    },
    {
        "regex": "(?:Windows(?:-Update-Agent)?|Microsoft-(?:CryptoAPI|Delivery-Optimization|WebDAV-MiniRedir|WNS)|WINDOWS_64)/(\\d+\\.\\d+)",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "Windows-(1[01])-",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "CYGWIN_NT-10\\.0|Win(?:dows )?NT 10\\.0|Windows[ /]10",
        "name": "Windows",
        "version": "10"
    },
    {
        "regex": "CYGWIN_NT-6\\.4|Windows NT 6\\.4|Windows 10|win10",
        "name": "Windows",
        "version": "10"
    },
    {
        "regex": "Windows[/-](2016|2019|2022|2025)Server",
        "name": "Windows",
        "version": "Server $1"
    },
    {
        "regex": "Windows/2012ServerR2",
        "name": "Windows",
        "version": "Server 2012 R2"
    },
    {
        "regex": "CYGWIN_NT-6\\.3|Windows NT 6\\.3|Windows[ /]8\\.1",
        "name": "Windows",
        "version": "8.1"
    },
    {
        "regex": "Windows/2012Server",
        "name": "Windows",
        "version": "Server 2012"
    },
    {
        "regex": "CYGWIN_NT-6\\.2|Windows NT 6\\.2|Windows 8|post2008Server",
        "name": "Windows",
        "version": "8"
    },
    {
        "regex": "Windows/2008ServerR2",
        "name": "Windows",
        "version": "Server 2008 R2"
    },
    {
        "regex": "CYGWIN_NT-6\\.1|Windows NT 6\\.1|Windows[ /]7|win7|Windows \\(6\\.1",
        "name": "Windows",
        "version": "7"
    },
    {
        "regex": "CYGWIN_NT-6\\.0|Windows NT 6\\.0|Windows Vista",
        "name": "Windows",
        "version": "Vista"
    },
    {
        "regex": "CYGWIN_NT-5\\.2|Windows NT 5\\.2|Windows Server 2003 / XP x64|Windows/2003Server",
        "name": "Windows",
        "version": "Server 2003"
    },
    {
        "regex": "CYGWIN_NT-5\\.1|Windows NT 5\\.1|(?:Microsoft-)?Windows[ -]XP",
        "name": "Windows",
        "version": "XP"
    },
    {
        "regex": "CYGWIN_NT-5\\.0|Windows NT 5\\.0|Windows 2000",
        "name": "Windows",
        "version": "2000"
    },
    {
        "regex": "CYGWIN_NT-4\\.0|Windows NT 4\\.0|WinNT(?! 10)|Windows NT",
        "name": "Windows",
        "version": "NT"
    },
    {
        "regex": "CYGWIN_ME-4\\.90|Win 9x 4\\.90|Windows ME",
        "name": "Windows",
        "version": "ME"
    },
    {
        "regex": "CYGWIN_98-4\\.10|Win98|Windows 98",
        "name": "Windows",
        "version": "98"
    },
    {
        "regex": "CYGWIN_95-4\\.0|Win32|Win95|Windows 95|Windows_95",
        "name": "Windows",
        "version": "95"
    },
    {
        "regex": "Windows 3\\.1",
        "name": "Windows",
        "version": "3.1"
    },
    {
        "regex": "Windows|.+win32|Win64|MSDW|HandBrake Win Upd|Microsoft BITS|ms-office; MSOffice",
        "name": "Windows",
        "version": ""
    },
    {
        "regex": "OS/Microsoft_Windows_NT_(\\d+\\.\\d+)",
        "name": "Windows",
        "version": "$1"
    },
    {
        "regex": "Haiku",
        "name": "Haiku OS",
        "version": ""
    },
    {
        "regex": "Apple ?TV.*CPU (?:iPhone )?OS ((?:9|1[0-9]|26)[_.]\\d+(?:[_.]\\d+)*)",
        "name": "tvOS",
        "version": "$1"
    },
    {
        "regex": "Apple TV; iOS ((?:9|1[0-9]|26)[_.]\\d+(?:[_.]\\d+)*)",
        "name": "tvOS",
        "version": "$1"
    },
    {
        "regex": "iOS(?:; |/)((?:9|1[0-9]|26)\\.\\d+(?:[_.]\\d+)*) (?:model/)?AppleTV",
        "name": "tvOS",
        "version": "$1"
    },
    {
        "regex": "tvOS[ /]?((?:9|1[0-9]|26)\\.\\d+(?:[_.]\\d+)*);?",
        "name": "tvOS",
        "version": "$1"
    },
    {
        "regex": "AppleTV(?:/?(\\d+[.\\d]+))?",
        "name": "tvOS",
        "version": "$1"
    },
    {
        "regex": "(?:Watch1,[12]/|Watch OS,|watchOS[ /]?)(\\d+[.\\d]*)?",
        "name": "watchOS",
        "version": "$1"
    },
    {
        "regex": "Apple Watch(?!;)",
        "name": "watchOS",
        "version": ""
    },
    {
        "regex": "FBMD/iPad;.*FBSV/ ?(1[3-9]|26).(\\d+[.\\d]*);",
        "name": "iPadOS",
        "version": "$1.$2"
    },
    {
        "regex": "iPad(?:OS)?[ /](1[3-9]|26)\\.(\\d+[.\\d]*)",
        "name": "iPadOS",
        "version": "$1.$2"
    },
    {
        "regex": "^iPad(?:\\d+[\\,\\d]*)/(1[3-9]|26)\\.(\\d+[.\\d]*)",
        "name": "iPadOS",
        "version": "$1.$2"
    },
    {
        "regex": "iPad(?:; (?:iOS|iPadOS|iPhone OS)|.+CPU (?:iPad ?|iPhone )?OS) ((1[3-9]|26)+(?:[_.]\\d+)*)",
        "name": "iPadOS",
        "version": "$1"
    },
    {
        "regex": "iOS/(1[3-9]|26)\\.(\\d+[.\\d]*).+Apple/iPad",
        "name": "iPadOS",
        "version": "$1.$2"
    },
    {
        "regex": "iPhone OS,(1[3-9]|26)\\.(\\d+[.\\d]*).+iPad",
        "name": "iPadOS",
        "version": "$1.$2"
    },
    {
        "regex": "iphoneos(1[3-9]|26)\\.(\\d+[.\\d]*); iPad",
        "name": "iPadOS",
        "version": "$1.$2"
    },
    {
        "regex": "Pinterest for iOS/.*iPad.*; (\\d(?:[\\d.]*))[)]$",
        "name": "iPadOS",
        "version": "$1"
    },
    {
        "regex": "iPad/([89]|1[012])\\.(\\d+[.\\d]*)",
        "name": "iOS",
        "version": "$1.$2"
    },
    {
        "regex": "^(?:iPad|iPhone)(?:\\d+[\\,\\d]*)[/_](\\d+[.\\d]+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iphoneos(1[3-9]|26)\\.(\\d+[.\\d]*); iPhone",
        "name": "iOS",
        "version": "$1.$2"
    },
    {
        "regex": "Pinterest for iOS/.*iPhone.*; (\\d(?:[\\d.]*))[)]$",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iOS (\\d+[.\\d]+)\\)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iPhone OS ([0-9]{1})([0-9]{1})([0-9]{1})",
        "name": "iOS",
        "version": "$1.$2.$3"
    },
    {
        "regex": "(?:CPU OS|iPh(?:one)?[ _]OS|iPhone.+ OS|PodMN.+iPhone|iOS)[ _/]19(?:[_.])?(\\d+(?:[._]\\d+)*)",
        "name": "iOS",
        "version": "26.$1"
    },
    {
        "regex": "(?:CPU OS|iPh(?:one)?[ _]OS|iPhone.+ OS|PodMN.+iPhone|iOS)[ _/](\\d+(?:[_.]\\d+)*)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:iPhone ?OS|iOS(?: Version)?)(?:/|; |,)(\\d+[.\\d]+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "^(?!com\\.apple\\.Safari\\.SearchHelper|Safari|NetworkingExtension).*(?:CFNetwork|Mana)/.+ Darwin/(\\d+[.\\d]+)(?!.*(?:x86_64|i386|PowerMac|Power%20Macintosh))",
        "name": "iOS",
        "versions": [
            {
                "regex": "Darwin/25\\.0\\.0",
                "version": "26"
            },
            {
                "regex": "Darwin/24\\.5\\.0",
                "version": "18.5"
            },
            {
                "regex": "Darwin/24\\.4\\.0",
                "version": "18.4"
            },
            {
                "regex": "Darwin/24\\.3\\.0",
                "version": "18.3"
            },
            {
                "regex": "Darwin/24\\.2\\.0",
                "version": "18.2"
            },
            {
                "regex": "Darwin/24\\.1\\.0",
                "version": "18.1"
            },
            {
                "regex": "Darwin/24\\.0\\.0",
                "version": "18.0"
            },
            {
                "regex": "Darwin/23\\.6\\.0",
                "version": "17.6"
            },
            {
                "regex": "Darwin/23\\.5\\.0",
                "version": "17.5"
            },
            {
                "regex": "Darwin/23\\.4\\.0",
                "version": "17.4"
            },
            {
                "regex": "Darwin/23\\.3\\.0",
                "version": "17.3"
            },
            {
                "regex": "Darwin/23\\.2\\.0",
                "version": "17.2"
            },
            {
                "regex": "Darwin/23\\.1\\.0",
                "version": "17.1"
            },
            {
                "regex": "Darwin/23\\.0\\.0",
                "version": "17.0"
            },
            {
                "regex": "Darwin/22\\.6\\.0",
                "version": "16.6"
            },
            {
                "regex": "Darwin/22\\.5\\.0",
                "version": "16.5"
            },
            {
                "regex": "Darwin/22\\.4\\.0",
                "version": "16.4"
            },
            {
                "regex": "Darwin/22\\.3\\.0",
                "version": "16.3"
            },
            {
                "regex": "Darwin/22\\.2\\.0",
                "version": "16.2"
            },
            {
                "regex": "Darwin/22\\.1\\.0",
                "version": "16.1"
            },
            {
                "regex": "Darwin/22\\.0\\.0",
                "version": "16.0"
            },
            {
                "regex": "Darwin/21\\.6\\.0",
                "version": "15.6"
            },
            {
                "regex": "Darwin/21\\.5\\.0",
                "version": "15.5"
            },
            {
                "regex": "Darwin/21\\.4\\.0",
                "version": "15.4"
            },
            {
                "regex": "Darwin/21\\.3\\.0",
                "version": "15.3"
            },
            {
                "regex": "Darwin/21\\.2\\.0",
                "version": "15.2"
            },
            {
                "regex": "Darwin/21\\.1\\.0",
                "version": "15.1"
            },
            {
                "regex": "Darwin/21\\.0\\.0",
                "version": "15.0"
            },
            {
                "regex": "Darwin/20\\.6\\.0",
                "version": "14.7"
            },
            {
                "regex": "Darwin/20\\.5\\.0",
                "version": "14.6"
            },
            {
                "regex": "Darwin/20\\.4\\.0",
                "version": "14.5"
            },
            {
                "regex": "Darwin/20\\.3\\.0",
                "version": "14.4"
            },
            {
                "regex": "Darwin/20\\.2\\.0",
                "version": "14.3"
            },
            {
                "regex": "Darwin/20\\.1\\.0",
                "version": "14.2"
            },
            {
                "regex": "Darwin/20\\.0\\.0",
                "version": "14.0"
            },
            {
                "regex": "Darwin/19\\.6\\.0",
                "version": "13.6"
            },
            {
                "regex": "Darwin/19\\.5\\.0",
                "version": "13.5"
            },
            {
                "regex": "Darwin/19\\.4\\.0",
                "version": "13.4"
            },
            {
                "regex": "Darwin/19\\.3\\.0",
                "version": "13.3.1"
            },
            {
                "regex": "Darwin/19\\.2\\.0",
                "version": "13.3"
            },
            {
                "regex": "Darwin/19\\.0\\.0",
                "version": "13.0"
            },
            {
                "regex": "Darwin/18\\.7\\.0",
                "version": "12.4"
            },
            {
                "regex": "Darwin/18\\.6\\.0",
                "version": "12.3"
            },
            {
                "regex": "Darwin/18\\.5\\.0",
                "version": "12.2"
            },
            {
                "regex": "Darwin/18\\.2\\.0",
                "version": "12.1"
            },
            {
                "regex": "Darwin/18\\.0\\.0",
                "version": "12.0"
            },
            {
                "regex": "Darwin/17\\.7\\.0",
                "version": "11.4.1"
            },
            {
                "regex": "Darwin/17\\.6\\.0",
                "version": "11.4"
            },
            {
                "regex": "Darwin/17\\.5\\.0",
                "version": "11.3"
            },
            {
                "regex": "Darwin/17\\.4\\.0",
                "version": "11.2.6"
            },
            {
                "regex": "Darwin/17\\.3\\.0",
                "version": "11.2"
            },
            {
                "regex": "CFNetwork/889",
                "version": "11.1"
            },
            {
                "regex": "CFNetwork/887",
                "version": "11.0"
            },
            {
                "regex": "CFNetwork/811",
                "version": "10.3"
            },
            {
                "regex": "CFNetwork/808\\.3",
                "version": "10.3"
            },
            {
                "regex": "CFNetwork/808\\.2",
                "version": "10.2"
            },
            {
                "regex": "CFNetwork/808\\.1",
                "version": "10.1"
            },
            {
                "regex": "CFNetwork/808\\.0",
                "version": "10.0"
            },
            {
                "regex": "CFNetwork/808",
                "version": "10"
            },
            {
                "regex": "CFNetwork/758\\.5\\.3",
                "version": "9.3.5"
            },
            {
                "regex": "CFNetwork/758\\.4\\.3",
                "version": "9.3.2"
            },
            {
                "regex": "CFNetwork/758\\.3\\.15",
                "version": "9.3"
            },
            {
                "regex": "CFNetwork/758\\.2\\.[78]",
                "version": "9.2"
            },
            {
                "regex": "CFNetwork/758\\.1\\.6",
                "version": "9.1"
            },
            {
                "regex": "CFNetwork/758\\.0\\.2",
                "version": "9.0"
            },
            {
                "regex": "CFNetwork/711\\.5\\.6",
                "version": "8.4.1"
            },
            {
                "regex": "CFNetwork/711\\.4\\.6",
                "version": "8.4"
            },
            {
                "regex": "CFNetwork/711\\.3\\.18",
                "version": "8.3"
            },
            {
                "regex": "CFNetwork/711\\.2\\.23",
                "version": "8.2"
            },
            {
                "regex": "CFNetwork/711\\.1\\.1[26]",
                "version": "8.1"
            },
            {
                "regex": "CFNetwork/711\\.0\\.6",
                "version": "8.0"
            },
            {
                "regex": "CFNetwork/672\\.1",
                "version": "7.1"
            },
            {
                "regex": "CFNetwork/672\\.0",
                "version": "7.0"
            },
            {
                "regex": "CFNetwork/609\\.1",
                "version": "6.1"
            },
            {
                "regex": "CFNetwork/60[29]",
                "version": "6.0"
            },
            {
                "regex": "CFNetwork/548\\.1",
                "version": "5.1"
            },
            {
                "regex": "CFNetwork/548\\.0",
                "version": "5.0"
            },
            {
                "regex": "CFNetwork/485\\.13",
                "version": "4.3"
            },
            {
                "regex": "CFNetwork/485\\.12",
                "version": "4.2"
            },
            {
                "regex": "CFNetwork/485\\.10",
                "version": "4.1"
            },
            {
                "regex": "CFNetwork/485\\.2",
                "version": "4.0"
            },
            {
                "regex": "CFNetwork/467\\.12",
                "version": "3.2"
            },
            {
                "regex": "CFNetwork/459",
                "version": "3.1"
            }
        ]
    },
    {
        "regex": "(?:iPhone|iPod_touch)/(\\d+[.\\d]*)(?: hw)?/",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iOS(\\d+\\.\\d+\\.\\d+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iOS(\\d+)\\.(\\d+)0",
        "name": "iOS",
        "version": "$1.$2"
    },
    {
        "regex": "FBMD/iPhone;.*FBSV/ ?(\\d+[.\\d]+);",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:FBIOS|Messenger(?:Lite)?ForiOS).*FBSV/ ?(\\d+[.\\d]*);",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iPhone OS,([\\d.]+).+(?:iPhone|iPod)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iPad.+; (\\d+[.\\d]+);",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "iPhone.+; Version (\\d+[.\\d]+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "OS=iOS;OSVer=(\\d+[.\\d]+);",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "os=Apple-iOS.+osversion=(\\d+[.\\d]+)/",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:Apple-)?(?<!like )(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "dv\\(iPh.+ov\\((\\d+(?:[_.]\\d+)*)\\);",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "(?:Podcasts/(?:[\\d.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|\\(iOS\\)|iOS; Opera|Overcast|Castro|Podcat|iCatcher|RSSRadio/|MobileSafari/|WhatsApp/.*i$)(?!.*x86_64)",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "iTunes-(AppleTV|iPod|iPad|iPhone)/(?:[\\d.]+)",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "iOS[ /]Version ([\\d.]+)",
        "name": "iOS",
        "version": "$1"
    },
    {
        "regex": "Sonos/.+\\(ICRU_",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "CaptiveNetworkSupport|AirPlay|.*[ \\.\\-/]iOS(?!@)",
        "name": "iOS",
        "version": ""
    },
    {
        "regex": "(?:CFNetwork|Mana|StudioDisplay)/.+Darwin(?:/|; )(?:[\\d.]+).+(?:x86_64|i386|Power%20Macintosh)|(?:x86_64-apple-)?darwin(?:[\\d.]+)|C?Python.*Darwin|PowerMac|com\\.apple\\.Safari\\.SearchHelper|^(?:NetworkingExtension|Safari)",
        "name": "Mac",
        "versions": [
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?25\\.0\\.0",
                "version": "26"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?24\\.5\\.0",
                "version": "15.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?24\\.4\\.0",
                "version": "15.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?24\\.3\\.0",
                "version": "15.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?24\\.2\\.0",
                "version": "15.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?24\\.1\\.0",
                "version": "15.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?24\\.0\\.0",
                "version": "15.0"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.6\\.0",
                "version": "14.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.5\\.0",
                "version": "14.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.4\\.0",
                "version": "14.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.3\\.0",
                "version": "14.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.2\\.0",
                "version": "14.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.1\\.0",
                "version": "14.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?23\\.0\\.0",
                "version": "14.0"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.6\\.0",
                "version": "13.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.5\\.0",
                "version": "13.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.4\\.0",
                "version": "13.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.3\\.0",
                "version": "13.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.2\\.0",
                "version": "13.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.1\\.0",
                "version": "13.0.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?22\\.0\\.0",
                "version": "13.0"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.6\\.0",
                "version": "12.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.5\\.0",
                "version": "12.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.4\\.0",
                "version": "12.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.3\\.0",
                "version": "12.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.2\\.0",
                "version": "12.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.1\\.0",
                "version": "12.0.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?21\\.0\\.0",
                "version": "12.0"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?20\\.6\\.0",
                "version": "11.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?20\\.5\\.0",
                "version": "11.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?20\\.4\\.0",
                "version": "11.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?20\\.3\\.0",
                "version": "11.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?20\\.2\\.0.*",
                "version": "11.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?20\\.[01]\\.0",
                "version": "11.0"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?19\\.6\\.0",
                "version": "10.15.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?19\\.5\\.0",
                "version": "10.15.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?19\\.4\\.0",
                "version": "10.15.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?19\\.3\\.0",
                "version": "10.15.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?19\\.2\\.0",
                "version": "10.15.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?19\\.0\\.0",
                "version": "10.15"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?18\\.7\\.0",
                "version": "10.14"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?18\\.6\\.0",
                "version": "10.14.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?18\\.5\\.0",
                "version": "10.14.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?18\\.2\\.0",
                "version": "10.14.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?18\\.0\\.0",
                "version": "10.14"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.7\\.0",
                "version": "10.13.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.6\\.0",
                "version": "10.13.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.5\\.0",
                "version": "10.13.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.4\\.0",
                "version": "10.13.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.3\\.0",
                "version": "10.13.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.2\\.0",
                "version": "10.13.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?17\\.0\\.0",
                "version": "10.13"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.7\\.0",
                "version": "10.12.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.6\\.0",
                "version": "10.12.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.5\\.0",
                "version": "10.12.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.4\\.0",
                "version": "10.12.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.3\\.0",
                "version": "10.12.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.2\\.0",
                "version": "10.12.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.1\\.0",
                "version": "10.12.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?16\\.0\\.0",
                "version": "10.12"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?15\\.6\\.0",
                "version": "10.11.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?15\\.5\\.0",
                "version": "10.11.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?15\\.4\\.0",
                "version": "10.11.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?15\\.3\\.0",
                "version": "10.11.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?15\\.2\\.0",
                "version": "10.11.2"
            },
            {
                "regex": "CFNetwork/760",
                "version": "10.11"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?14\\.5\\.0",
                "version": "10.10.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?14\\.4\\.0",
                "version": "10.10.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?14\\.3\\.0",
                "version": "10.10.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?14\\.1\\.0",
                "version": "10.10.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?14\\.0\\.0",
                "version": "10.10"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?13\\.4\\.0",
                "version": "10.9.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?13\\.3\\.0",
                "version": "10.9.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?13\\.2\\.0",
                "version": "10.9.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?13\\.1\\.0",
                "version": "10.9.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?13\\.0\\.0",
                "version": "10.9.0"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?12\\.6\\.0",
                "version": "10.8.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?12\\.5\\.0",
                "version": "10.8.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?12\\.4\\.0",
                "version": "10.8.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?12\\.3\\.0",
                "version": "10.8.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?12\\.2\\.0",
                "version": "10.8.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?12\\.1\\.0",
                "version": "10.8.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?11\\.5\\.0",
                "version": "10.7.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?11\\.4\\.2",
                "version": "10.7.5"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?11\\.4\\.0",
                "version": "10.7.4"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?11\\.3\\.0",
                "version": "10.7.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?11\\.2\\.0",
                "version": "10.7.2"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?11\\.1\\.0",
                "version": "10.7.1"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?10\\.8\\.0",
                "version": "10.6.8"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?10\\.7\\.[34]",
                "version": "10.6.7"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?10\\.3\\.0",
                "version": "10.6.3"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?10\\.0\\.0",
                "version": "10.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?9\\.8\\.0",
                "version": "10.5.8"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?9\\.7\\.1",
                "version": "10.5.7"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?9\\.6\\.2",
                "version": "10.5.6"
            },
            {
                "regex": "(?:x86_64-apple-)?Darwin(?:/|; )?9\\.5\\.[05]",
                "version": "10.5.5"
            }
        ]
    },
    {
        "regex": "Macintosh;Mac OS X \\((\\d+[.\\d]+)\\);",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "Mac[ +]OS[ +]?X(?:[ /,](?:Version )?(\\d+(?:[_.]\\d+)+))?",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "Mac (?:OS/)?(\\d+(?:[_.]\\d+)+)",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "(?:macOS(?:\\(Catalyst\\))?[ /,]|Mac(?:os)?-)(\\d+[.\\d]+)",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "Macintosh; OS X (\\d+[.\\d]+)",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "OSX/(\\d+[.\\d]+)",
        "name": "Mac",
        "version": "$1"
    },
    {
        "regex": "Darwin|Macintosh|Mac[ _]PowerPC|PPC|iMac|MacBook|.*macOS|AppleExchangeWebServices|com\\.apple\\.trustd|Sonos/.+\\(MDCR_|WhatsApp/.*N$",
        "name": "Mac",
        "version": ""
    },
    {
        "regex": "Fuchsia",
        "name": "Fuchsia",
        "version": ""
    },
    {
        "regex": "(?:BB10;.+Version|Black[Bb]erry[0-9a-z]+|Black[Bb]erry.+Version)/(\\d+[.\\d]+)",
        "name": "BlackBerry OS",
        "version": "$1"
    },
    {
        "regex": "RIM Tablet OS (\\d+[.\\d]+)",
        "name": "BlackBerry Tablet OS",
        "version": "$1"
    },
    {
        "regex": "RIM Tablet OS|QNX|Play[Bb]ook",
        "name": "BlackBerry Tablet OS",
        "version": ""
    },
    {
        "regex": "BlackBerry",
        "name": "BlackBerry OS",
        "version": ""
    },
    {
        "regex": "bPod",
        "name": "BlackBerry OS",
        "version": ""
    },
    {
        "regex": "BeOS[ +]?(\\d[.\\d]*)?",
        "name": "BeOS",
        "version": "$1"
    },
    {
        "regex": "Symbian/3.+NokiaBrowser/7\\.3",
        "name": "Symbian^3",
        "version": "Anna"
    },
    {
        "regex": "Symbian/3.+NokiaBrowser/7\\.4",
        "name": "Symbian^3",
        "version": "Belle"
    },
    {
        "regex": "Symbian/3",
        "name": "Symbian^3",
        "version": ""
    },
    {
        "regex": "(?:Series ?60|SymbOS|S60)(?:[ /]?(\\d+[.\\d]+|V\\d+))?",
        "name": "Symbian OS Series 60",
        "version": "$1"
    },
    {
        "regex": "Series40",
        "name": "Symbian OS Series 40",
        "version": ""
    },
    {
        "regex": "SymbianOS/(\\d+[.\\d]+)",
        "name": "Symbian OS",
        "version": "$1"
    },
    {
        "regex": "MeeGo|WeTab",
        "name": "MeeGo",
        "version": ""
    },
    {
        "regex": "Symbian(?: OS)?|SymbOS",
        "name": "Symbian OS",
        "version": ""
    },
    {
        "regex": "Nokia",
        "name": "Symbian",
        "version": ""
    },
    {
        "regex": "(?:Mobile|Tablet);.+Firefox/\\d+\\.\\d+",
        "name": "Firefox OS",
        "version": ""
    },
    {
        "regex": "RISC OS(?:-NC)?(?:[ /](\\d+[.\\d]+))?",
        "name": "RISC OS",
        "version": "$1"
    },
    {
        "regex": "Inferno(?:[ /](\\d+[.\\d]+))?",
        "name": "Inferno",
        "version": "$1"
    },
    {
        "regex": "bada(?:[ /](\\d+[.\\d]+))?",
        "name": "Bada",
        "version": "$1"
    },
    {
        "regex": "REX; U;",
        "name": "REX",
        "version": ""
    },
    {
        "regex": "(?:Brew(?!-Applet)(?: MP)?|BMP)(?:[ /](\\d+[.\\d]+))?",
        "name": "Brew",
        "version": "$1"
    },
    {
        "regex": "GoogleTV(?:[ /](\\d+[.\\d]+))?",
        "name": "Google TV",
        "version": "$1"
    },
    {
        "regex": "WebTV/(\\d+[.\\d]+)",
        "name": "WebTV",
        "version": "$1"
    },
    {
        "regex": "(?:SunOS|Solaris)(?:[/ ](\\d+[.\\d]+))?",
        "name": "Solaris",
        "version": "$1"
    },
    {
        "regex": "AIX(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "AIX",
        "version": "$1"
    },
    {
        "regex": "HP-UX(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "HP-UX",
        "version": "$1"
    },
    {
        "regex": "ElectroBSD(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "ElectroBSD",
        "version": "$1"
    },
    {
        "regex": "FreeBSD(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "FreeBSD",
        "version": "$1"
    },
    {
        "regex": "NetBSD(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "NetBSD",
        "version": "$1"
    },
    {
        "regex": "OpenBSD(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "OpenBSD",
        "version": "$1"
    },
    {
        "regex": "DragonFly(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "DragonFly",
        "version": "$1"
    },
    {
        "regex": "Syllable(?:[/ ]?(\\d+[.\\d]+))?",
        "name": "Syllable",
        "version": "$1"
    },
    {
        "regex": "IRIX(?:;64)?(?:[/ ]?(\\d+[.\\d]+))",
        "name": "IRIX",
        "version": "$1"
    },
    {
        "regex": "OSF1(?:[/ ]?v?(\\d+[.\\d]+))?",
        "name": "OSF1",
        "version": "$1"
    },
    {
        "regex": "Nintendo (Wii|Switch)",
        "name": "Nintendo",
        "version": "$1"
    },
    {
        "regex": "PlayStation.+; Linux (\\d+[.\\d]+)",
        "name": "PlayStation",
        "version": "$1"
    },
    {
        "regex": "PlayStation ?(\\d)(?:[/ ](?:Pro )?(\\d+[.\\d]+))?",
        "name": "PlayStation",
        "version": "$1.$2"
    },
    {
        "regex": "Xbox|KIN\\.(?:One|Two)",
        "name": "Xbox",
        "version": "360"
    },
    {
        "regex": "Nitro|Nintendo ([3]?DS[i]?)",
        "name": "Nintendo Mobile",
        "version": "$1"
    },
    {
        "regex": "PlayStation ((?:Portable|Vita))",
        "name": "PlayStation Portable",
        "version": "$1"
    },
    {
        "regex": "OS/2; Warp (\\d+[.\\d]+)",
        "name": "OS/2",
        "version": "$1"
    },
    {
        "regex": "OS/2",
        "name": "OS/2",
        "version": ""
    },
    {
        "regex": "Linux/(\\d+[.\\d]+)",
        "name": "GNU/Linux",
        "version": "$1"
    },
    {
        "regex": "Linux[^a-z]|Cinnamon/(?:\\d+[.\\d]+)|.+(?:pc|unknown)-linux-gnu|X11",
        "name": "GNU/Linux",
        "version": ""
    },
    {
        "regex": "Java ME|(J2ME|Profile)/MIDP|MIDP-(?:\\d+[.\\d]+)/CLDC|Configuration/CLDC|Java; U; MIDP|MMP/\\d\\.\\d",
        "name": "Java ME",
        "version": ""
    }
];

});

parcelRegister("gKnA4", function(module, exports) {
module.exports = [
    {
        "regex": "WireReaderBot",
        "name": "WireReaderBot",
        "category": "Feed Fetcher",
        "url": "https://wirereader.app/"
    },
    {
        "regex": "monitoring360bot",
        "name": "360 Monitoring",
        "category": "Site Monitor",
        "url": "https://www.360monitoring.io",
        "producer": {
            "name": "Plesk International GmbH",
            "url": "https://www.plesk.com"
        }
    },
    {
        "regex": "Cloudflare-Healthchecks",
        "name": "Cloudflare Health Checks",
        "category": "Service Agent",
        "url": "https://developers.cloudflare.com/health-checks/",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "360Spider",
        "name": "360Spider",
        "category": "Search bot",
        "url": "https://www.so.com/help/help_3_2.html",
        "producer": {
            "name": "Online Media Group, Inc.",
            "url": ""
        }
    },
    {
        "regex": "Aboundex",
        "name": "Aboundexbot",
        "category": "Search bot",
        "url": "http://www.aboundex.com/crawler/",
        "producer": {
            "name": "Aboundex.com",
            "url": "http://www.aboundex.com"
        }
    },
    {
        "regex": "AcoonBot",
        "name": "Acoon",
        "category": "Search bot",
        "url": "http://www.acoon.de/robot.asp",
        "producer": {
            "name": "Acoon GmbH",
            "url": "http://www.acoon.de"
        }
    },
    {
        "regex": "AddThis\\.com",
        "name": "AddThis.com",
        "category": "Social Media Agent",
        "url": "",
        "producer": {
            "name": "Clearspring Technologies, Inc.",
            "url": "http://www.clearspring.com"
        }
    },
    {
        "regex": "AhrefsBot",
        "name": "aHrefs Bot",
        "category": "Crawler",
        "url": "https://ahrefs.com/robot",
        "producer": {
            "name": "Ahrefs Pte Ltd",
            "url": "https://ahrefs.com/robot"
        }
    },
    {
        "regex": "AhrefsSiteAudit",
        "name": "AhrefsSiteAudit",
        "category": "Site Monitor",
        "url": "https://ahrefs.com/robot/site-audit",
        "producer": {
            "name": "Ahrefs Pte Ltd",
            "url": "https://ahrefs.com/"
        }
    },
    {
        "regex": "ia_archiver|alexabot|verifybot",
        "name": "Alexa Crawler",
        "category": "Search bot",
        "url": "https://support.alexa.com/hc/en-us/sections/200100794-Crawlers",
        "producer": {
            "name": "Alexa Internet",
            "url": "https://www.alexa.com"
        }
    },
    {
        "regex": "alexa site audit",
        "name": "Alexa Site Audit",
        "category": "Site Monitor",
        "url": "https://support.alexa.com/hc/en-us/articles/200450194",
        "producer": {
            "name": "Alexa Internet",
            "url": "https://www.alexa.com"
        }
    },
    {
        "regex": "Amazonbot",
        "name": "Amazon Bot",
        "category": "Crawler",
        "url": "https://developer.amazon.com/support/amazonbot",
        "producer": {
            "name": "Amazon.com, Inc.",
            "url": "https://www.amazon.com/"
        }
    },
    {
        "regex": "AmazonAdBot",
        "name": "Amazon AdBot",
        "category": "Crawler",
        "url": "https://adbot.amazon.com/",
        "producer": {
            "name": "Amazon.com, Inc.",
            "url": "https://www.amazon.com/"
        }
    },
    {
        "regex": "Amazon[ -]Route ?53[ -]Health[ -]Check[ -]Service",
        "name": "Amazon Route53 Health Check",
        "category": "Service Agent",
        "producer": {
            "name": "Amazon Web Services",
            "url": "https://aws.amazon.com/"
        }
    },
    {
        "regex": "AmorankSpider",
        "name": "Amorank Spider",
        "category": "Crawler",
        "url": "http://amorank.com/webcrawler.html",
        "producer": {
            "name": "Amorank",
            "url": "http://www.amorank.com"
        }
    },
    {
        "regex": "ApacheBench",
        "name": "ApacheBench",
        "category": "Benchmark",
        "url": "https://httpd.apache.org/docs/2.4/programs/ab.html",
        "producer": {
            "name": "The Apache Software Foundation",
            "url": "https://www.apache.org/foundation/"
        }
    },
    {
        "regex": "Applebot",
        "name": "Applebot",
        "category": "Crawler",
        "url": "https://support.apple.com/en-us/119829",
        "producer": {
            "name": "Apple Inc",
            "url": "https://www.apple.com/"
        }
    },
    {
        "regex": "iTMS",
        "name": "iTMS",
        "category": "Crawler",
        "url": "https://support.apple.com/en-us/119829",
        "producer": {
            "name": "Apple Inc",
            "url": "https://www.apple.com/"
        }
    },
    {
        "regex": "AppSignalBot",
        "name": "AppSignalBot",
        "category": "Site Monitor",
        "url": "https://docs.appsignal.com/uptime-monitoring/",
        "producer": {
            "name": "AppSignal",
            "url": "https://appsignal.com/"
        }
    },
    {
        "regex": "Arachni",
        "name": "Arachni",
        "category": "Security Checker",
        "url": "https://www.arachni-scanner.com/",
        "producer": {
            "name": "Sarosys LLC",
            "url": "https://www.sarosys.com/"
        }
    },
    {
        "regex": "AspiegelBot",
        "name": "AspiegelBot",
        "category": "Crawler",
        "url": "https://aspiegel.com/",
        "producer": {
            "name": "Huawei",
            "url": "https://www.huawei.com/"
        }
    },
    {
        "regex": "Castro 2, Episode Duration Lookup",
        "name": "Castro 2",
        "category": "Service Agent",
        "url": "http://supertop.co/castro/",
        "producer": {
            "name": "Supertop",
            "url": "http://supertop.co"
        }
    },
    {
        "regex": "Curious George",
        "name": "Analytics SEO Crawler",
        "category": "Crawler",
        "url": "http://www.analyticsseo.com/crawler",
        "producer": {
            "name": "Analytics SEO",
            "url": "http://www.analyticsseo.com"
        }
    },
    {
        "regex": "archive\\.org_bot|special_archiver",
        "name": "archive.org bot",
        "category": "Crawler",
        "url": "https://archive.org/details/archive.org_bot",
        "producer": {
            "name": "The Internet Archive",
            "url": "https://archive.org"
        }
    },
    {
        "regex": "Ask Jeeves/Teoma",
        "name": "Ask Jeeves",
        "category": "Search bot",
        "url": "",
        "producer": {
            "name": "Ask Jeeves Inc.",
            "url": "http://www.ask.com"
        }
    },
    {
        "regex": "Backlink-Check\\.de",
        "name": "Backlink-Check.de",
        "category": "Crawler",
        "url": "http://www.backlink-check.de/bot.html",
        "producer": {
            "name": "Mediagreen Medienservice",
            "url": "http://www.backlink-check.de"
        }
    },
    {
        "regex": "BacklinkCrawler",
        "name": "BacklinkCrawler",
        "category": "Crawler",
        "url": "http://www.backlinktest.com/crawler.html",
        "producer": {
            "name": "2.0Promotion GbR",
            "url": "http://www.backlinktest.com"
        }
    },
    {
        "regex": "Baidu.*spider|baidu Transcoder",
        "name": "Baidu Spider",
        "category": "Search bot",
        "url": "http://www.baidu.com/search/spider.htm",
        "producer": {
            "name": "Baidu",
            "url": "http://www.baidu.com"
        }
    },
    {
        "regex": "BazQux",
        "name": "BazQux Reader",
        "url": "https://bazqux.com/fetcher",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Better Uptime Bot",
        "name": "Better Uptime Bot",
        "category": "Site Monitor",
        "url": "https://betteruptime.com/faq",
        "producer": {
            "name": "Better Uptime",
            "url": "https://betteruptime.com/"
        }
    },
    {
        "regex": "MSNBot|msrbot|bingbot|bingadsbot|BingPreview|msnbot-(UDiscovery|NewsBlogs)|adidxbot",
        "name": "BingBot",
        "category": "Search bot",
        "url": "http://search.msn.com/msnbot.htmn",
        "producer": {
            "name": "Microsoft Corporation",
            "url": "http://www.microsoft.com"
        }
    },
    {
        "regex": "Blackbox Exporter",
        "name": "Blackbox Exporter",
        "category": "Site Monitor",
        "url": "https://github.com/prometheus/blackbox_exporter",
        "producer": {
            "name": "Prometheus",
            "url": "https://prometheus.io/"
        }
    },
    {
        "regex": "Blekkobot",
        "name": "Blekkobot",
        "category": "Search bot",
        "url": "http://blekko.com/about/blekkobot",
        "producer": {
            "name": "Blekko",
            "url": "http://blekko.com"
        }
    },
    {
        "regex": "BLEXBot",
        "name": "BLEXBot Crawler",
        "category": "Crawler",
        "url": "http://webmeup-crawler.com",
        "producer": {
            "name": "WebMeUp",
            "url": "http://webmeup.com"
        }
    },
    {
        "regex": "Bloglovin",
        "name": "Bloglovin",
        "url": "http://www.bloglovin.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Blogtrottr",
        "name": "Blogtrottr",
        "url": "",
        "category": "Feed Fetcher",
        "producer": {
            "name": "Blogtrottr Ltd",
            "url": "https://blogtrottr.com/"
        }
    },
    {
        "regex": "BoardReader Blog Indexer",
        "name": "BoardReader Blog Indexer",
        "category": "Crawler",
        "producer": {
            "name": "BoardReader",
            "url": "https://boardreader.com/"
        }
    },
    {
        "regex": "BountiiBot",
        "name": "Bountii Bot",
        "category": "Search bot",
        "url": "http://bountii.com/contact.php",
        "producer": {
            "name": "Bountii Inc.",
            "url": "http://bountii.com"
        }
    },
    {
        "regex": "Browsershots",
        "name": "Browsershots",
        "category": "Service Agent",
        "url": "http://browsershots.org/faq",
        "producer": {
            "name": "Browsershots.org",
            "url": "http://browsershots.org"
        }
    },
    {
        "regex": "BUbiNG",
        "name": "BUbiNG",
        "category": "Crawler",
        "url": "http://law.di.unimi.it/BUbiNG.html",
        "producer": {
            "name": "The Laboratory for Web Algorithmics (LAW)",
            "url": "http://law.di.unimi.it/software.php#buging"
        }
    },
    {
        "regex": "(?<!HTC)[ _]Butterfly/",
        "name": "Butterfly Robot",
        "category": "Search bot",
        "url": "http://labs.topsy.com/butterfly",
        "producer": {
            "name": "Topsy Labs",
            "url": "http://labs.topsy.com"
        }
    },
    {
        "regex": "CareerBot",
        "name": "CareerBot",
        "category": "Crawler",
        "url": "http://www.career-x.de/bot.html",
        "producer": {
            "name": "career-x GmbH",
            "url": "http://www.career-x.de"
        }
    },
    {
        "regex": "CCBot",
        "name": "ccBot crawler",
        "category": "Crawler",
        "url": "http://commoncrawl.org/faq/",
        "producer": {
            "name": "reddit inc.",
            "url": "http://www.reddit.com"
        }
    },
    {
        "regex": "Cliqzbot",
        "name": "Cliqzbot",
        "category": "Crawler",
        "url": "http://cliqz.com/company/cliqzbot",
        "producer": {
            "name": "10betterpages GmbH",
            "url": "http://cliqz.com"
        }
    },
    {
        "regex": "Cloudflare-AMP",
        "name": "CloudFlare AMP Fetcher",
        "category": "Crawler",
        "url": "https://amp.cloudflare.com/doc/fetcher.html",
        "producer": {
            "name": "CloudFlare",
            "url": "http://www.cloudflare.com"
        }
    },
    {
        "regex": "Cloudflare-?Diagnostics",
        "name": "Cloudflare Diagnostics",
        "category": "Site Monitor",
        "url": "https://www.cloudflare.com/",
        "producer": {
            "name": "Cloudflare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "CloudFlare-AlwaysOnline",
        "name": "CloudFlare Always Online",
        "category": "Site Monitor",
        "url": "https://www.cloudflare.com/always-online",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "Cloudflare-SSLDetector",
        "name": "Cloudflare SSL Detector",
        "category": "Site Monitor",
        "url": "https://developers.cloudflare.com/fundamentals/reference/cloudflare-site-crawling/",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "Cloudflare Custom Hostname Verification",
        "name": "Cloudflare Custom Hostname Verification",
        "category": "Service Agent",
        "url": "https://developers.cloudflare.com/fundamentals/reference/cloudflare-site-crawling/",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "Cloudflare-Traffic-Manager",
        "name": "Cloudflare Traffic Manager",
        "category": "Site Monitor",
        "url": "https://developers.cloudflare.com/fundamentals/reference/cloudflare-site-crawling/",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "Cloudflare-Smart-Transit",
        "name": "Cloudflare Smart Transit",
        "category": "Site Monitor",
        "url": "https://developers.cloudflare.com/fundamentals/reference/cloudflare-site-crawling/",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "CloudflareObservatory",
        "name": "Cloudflare Observatory",
        "category": "Site Monitor",
        "url": "https://developers.cloudflare.com/speed/speed-test/run-speed-test",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "https://developers\\.cloudflare\\.com/security-center/",
        "name": "Cloudflare Security Insights",
        "category": "Site Monitor",
        "url": "https://developers.cloudflare.com/fundamentals/reference/cloudflare-site-crawling/",
        "producer": {
            "name": "CloudFlare",
            "url": "https://www.cloudflare.com/"
        }
    },
    {
        "regex": "coccoc\\.com",
        "name": "C\u1ED1c C\u1ED1c Bot",
        "url": "https://help.coccoc.com/en/search-engine/coccoc-robots",
        "category": "Search bot",
        "producer": {
            "name": "C\u1ED1c C\u1ED1c",
            "url": "https://coccoc.com/"
        }
    },
    {
        "regex": "collectd",
        "name": "Collectd",
        "url": "https://collectd.org/",
        "category": "Site Monitor",
        "producer": {
            "name": "Collectd",
            "url": "https://collectd.org/"
        }
    },
    {
        "regex": "CommaFeed",
        "name": "CommaFeed",
        "url": "http://www.commafeed.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "CSS Certificate Spider",
        "name": "CSS Certificate Spider",
        "category": "Crawler",
        "url": "http://www.css-security.com/certificatespider/",
        "producer": {
            "name": "Certified Security Solutions",
            "url": "https://www.css-security.com/company/about-us/"
        }
    },
    {
        "regex": "Datadog Agent|Datadog/?Synthetics",
        "name": "Datadog Agent",
        "url": "https://github.com/DataDog/dd-agent",
        "category": "Site Monitor",
        "producer": {
            "name": "Datadog",
            "url": "https://www.datadoghq.com/"
        }
    },
    {
        "regex": "Datanyze",
        "name": "Datanyze",
        "url": "",
        "category": "Crawler",
        "producer": {
            "name": "Datanyze",
            "url": "https://www.datanyze.com"
        }
    },
    {
        "regex": "Dataprovider",
        "name": "Dataprovider",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Dataprovider B.V.",
            "url": "https://www.dataprovider.com/"
        }
    },
    {
        "regex": "Daum(?!(?:Apps|Device))",
        "name": "Daum",
        "category": "Search bot",
        "url": "http://tab.search.daum.net/aboutWebSearch_en.html",
        "producer": {
            "name": "Daum Communications Corp.",
            "url": "http://www.kakaocorp.com/main"
        }
    },
    {
        "regex": "Dazoobot",
        "name": "Dazoobot",
        "category": "Search bot",
        "url": "",
        "producer": {
            "name": "DAZOO.FR",
            "url": "http://dazoo.fr"
        }
    },
    {
        "regex": "discobot",
        "name": "Discobot",
        "category": "Search bot",
        "url": "http://discoveryengine.com/discobot.html",
        "producer": {
            "name": "Discovery Engine",
            "url": "http://discoveryengine.com"
        }
    },
    {
        "regex": "Domain Re-Animator Bot|support@domainreanimator\\.com",
        "name": "Domain Re-Animator Bot",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Domain Re-Animator, LLC",
            "url": "http://domainreanimator.com"
        }
    },
    {
        "regex": "DotBot",
        "name": "DotBot",
        "category": "Crawler",
        "url": "http://www.opensiteexplorer.org/dotbot",
        "producer": {
            "name": "SEOmoz, Inc.",
            "url": "http://moz.com/"
        }
    },
    {
        "regex": "DuckDuck(?:Go-Favicons-)?Bot",
        "name": "DuckDuckBot",
        "category": "Search bot",
        "url": "https://duckduckgo.com/duckduckgo-help-pages/results/duckduckbot/",
        "producer": {
            "name": "DuckDuckGo",
            "url": "https://duckduckgo.com/"
        }
    },
    {
        "regex": "DuckAssistBot",
        "name": "DuckAssistBot",
        "category": "Search bot",
        "url": "https://duckduckgo.com/duckduckgo-help-pages/results/duckassistbot/",
        "producer": {
            "name": "DuckDuckGo",
            "url": "https://duckduckgo.com/"
        }
    },
    {
        "regex": "EasouSpider",
        "name": "Easou Spider",
        "category": "Search bot",
        "url": "http://www.easou.com/search/spider.html",
        "producer": {
            "name": "easou ICP",
            "url": "http://www.easou.com"
        }
    },
    {
        "regex": "eCairn-Grabber",
        "name": "eCairn-Grabber",
        "category": "Crawler",
        "producer": {
            "name": "eCairn",
            "url": "https://ecairn.com"
        }
    },
    {
        "regex": "EMail Exractor",
        "name": "EMail Exractor",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "evc-batch",
        "name": "evc-batch",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "eVenture Capital Partners II, LLC",
            "url": "http://www.eventures.vc/"
        }
    },
    {
        "regex": "Exabot|ExaleadCloudview",
        "name": "ExaBot",
        "category": "Crawler",
        "url": "http://www.exabot.com/go/robot",
        "producer": {
            "name": "Dassault Syst\xe8mes",
            "url": "http://www.3ds.com"
        }
    },
    {
        "regex": "ExactSeek Crawler",
        "name": "ExactSeek Crawler",
        "category": "Search bot",
        "url": "http://www.exactseek.com",
        "producer": {
            "name": "Jayde Online, Inc.",
            "url": "http://www.jaydeonlineinc.com"
        }
    },
    {
        "regex": "Ezooms",
        "name": "Ezooms",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "SEOmoz, Inc.",
            "url": "http://moz.com/"
        }
    },
    {
        "regex": "facebook(?:catalog|externalhit|externalua|platform|scraper)",
        "name": "Facebook Crawler",
        "category": "Social Media Agent",
        "url": "https://developers.facebook.com/docs/sharing/webmasters/web-crawlers",
        "producer": {
            "name": "Meta Platforms, Inc.",
            "url": "https://www.meta.com/"
        }
    },
    {
        "regex": "meta-externalagent",
        "name": "Meta-ExternalAgent",
        "category": "Crawler",
        "url": "https://developers.facebook.com/docs/sharing/webmasters/web-crawlers",
        "producer": {
            "name": "Meta Platforms, Inc.",
            "url": "https://www.meta.com/"
        }
    },
    {
        "regex": "meta-externalfetcher",
        "name": "Meta-ExternalFetcher",
        "category": "Social Media Agent",
        "url": "https://developers.facebook.com/docs/sharing/webmasters/web-crawlers",
        "producer": {
            "name": "Meta Platforms, Inc.",
            "url": "https://www.meta.com/"
        }
    },
    {
        "regex": "meta-webindexer",
        "name": "Meta-WebIndexer",
        "category": "Social Media Agent",
        "url": "https://developers.facebook.com/docs/sharing/webmasters/web-crawlers",
        "producer": {
            "name": "Meta Platforms, Inc.",
            "url": "https://www.meta.com/"
        }
    },
    {
        "regex": "meta-externalads",
        "name": "Meta-ExternalAds",
        "category": "Social Media Agent",
        "url": "https://developers.facebook.com/docs/sharing/webmasters/web-crawlers",
        "producer": {
            "name": "Meta Platforms, Inc.",
            "url": "https://www.meta.com/"
        }
    },
    {
        "regex": "FacebookBot",
        "name": "FacebookBot",
        "category": "Crawler",
        "url": "https://developers.facebook.com/docs/sharing/bot",
        "producer": {
            "name": "Meta Platforms, Inc.",
            "url": "https://www.meta.com/"
        }
    },
    {
        "regex": "Feedbin",
        "name": "Feedbin",
        "url": "http://feedbin.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "FeedBurner",
        "name": "FeedBurner",
        "url": "http://www.feedburner.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Feed Wrangler",
        "name": "Feed Wrangler",
        "url": "https://feedwrangler.net/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "David Smith & Developing Perspective, LLC",
            "url": "https://david-smith.org"
        }
    },
    {
        "regex": "Feedly",
        "name": "Feedly",
        "url": "http://www.feedly.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Feedspot",
        "name": "Feedspot",
        "url": "http://www.feedspot.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Fever/",
        "name": "Fever",
        "url": "http://feedafever.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "FlipboardProxy|FlipboardRSS",
        "name": "Flipboard",
        "url": "http://flipboard.com/browserproxy",
        "category": "Feed Fetcher",
        "producer": {
            "name": "Flipboard",
            "url": "http://flipboard.com/"
        }
    },
    {
        "regex": "Findxbot",
        "name": "Findxbot",
        "category": "Crawler",
        "url": "http://www.findxbot.com"
    },
    {
        "regex": "FreshRSS",
        "name": "FreshRSS",
        "category": "Feed Fetcher",
        "url": "https://freshrss.org/"
    },
    {
        "regex": "Genieo",
        "name": "Genieo Web filter",
        "category": "",
        "url": "http://www.genieo.com/webfilter.html",
        "producer": {
            "name": "Genieo",
            "url": "http://www.genieo.com"
        }
    },
    {
        "regex": "GigablastOpenSource",
        "name": "Gigablast",
        "category": "Search bot",
        "url": "https://github.com/gigablast/open-source-search-engine",
        "producer": {
            "name": "Matt Wells",
            "url": "http://www.gigablast.com/faq.html"
        }
    },
    {
        "regex": "Gluten Free Crawler",
        "name": "Gluten Free Crawler",
        "category": "Crawler",
        "url": "http://glutenfreepleasure.com/",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "gobuster",
        "name": "Gobuster",
        "url": "https://github.com/OJ/gobuster"
    },
    {
        "regex": "ichiro/mobile goo",
        "name": "Goo",
        "category": "Search bot",
        "url": "http://search.goo.ne.jp/option/use/sub4/sub4-1",
        "producer": {
            "name": "NTT Resonant",
            "url": "http://goo.ne.jp"
        }
    },
    {
        "regex": "Storebot-Google",
        "name": "Google StoreBot",
        "category": "Crawler"
    },
    {
        "regex": "Google Favicon",
        "name": "Google Favicon",
        "category": "Crawler"
    },
    {
        "regex": "Google Search Console",
        "name": "Google Search Console",
        "category": "Crawler",
        "url": "https://search.google.com/search-console/about",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Google Page Speed Insights",
        "name": "Google PageSpeed Insights",
        "category": "Site Monitor",
        "url": "http://developers.google.com/speed/pagespeed/insights/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "google_partner_monitoring",
        "name": "Google Partner Monitoring",
        "category": "Site Monitor",
        "url": "",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Google-Cloud-Scheduler",
        "name": "Google Cloud Scheduler",
        "category": "Crawler",
        "url": "https://cloud.google.com/scheduler",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com"
        }
    },
    {
        "regex": "Google-Structured-Data-Testing-Tool",
        "name": "Google Structured Data Testing Tool",
        "category": "Validator",
        "url": "https://search.google.com/structured-data/testing-tool",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "GoogleStackdriverMonitoring",
        "name": "Google Stackdriver Monitoring",
        "category": "Site Monitor",
        "url": "https://cloud.google.com/monitoring",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com"
        }
    },
    {
        "regex": "Google-Transparency-Report",
        "name": "Google Transparency Report",
        "category": "Site Monitor",
        "url": "https://transparencyreport.google.com/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Google-CloudVertexBot",
        "name": "Google-CloudVertexBot",
        "category": "Crawler",
        "url": "https://developers.google.com/search/docs/crawling-indexing/google-common-crawlers#google-cloudvertexbot",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "via ggpht\\.com GoogleImageProxy",
        "name": "Gmail Image Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Google-Document-Conversion",
        "name": "Google-Document-Conversion",
        "category": "Service Agent",
        "url": "https://support.google.com/drive/answer/176692?hl=en",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "GoogleDocs; apps-spreadsheets",
        "name": "Google Sheets",
        "category": "Service Agent",
        "url": "https://workspace.google.com/products/sheets/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "GoogleDocs; apps-presentations",
        "name": "Google Slides",
        "category": "Service Agent",
        "url": "https://workspace.google.com/products/slides/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "GoogleDocs;",
        "name": "Google Docs",
        "category": "Service Agent",
        "url": "https://docs.google.com/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "SeznamEmailProxy",
        "name": "Seznam Email Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Seznam.cz, a.s.",
            "url": "http://www.seznam.cz/"
        }
    },
    {
        "regex": "Seznam-Zbozi-robot",
        "name": "Seznam Zbozi.cz",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Seznam.cz, a.s.",
            "url": "https://www.zbozi.cz/"
        }
    },
    {
        "regex": "Heurekabot-Feed",
        "name": "Heureka Feed",
        "category": "Crawler",
        "url": "https://sluzby.heureka.cz/napoveda/heurekabot/",
        "producer": {
            "name": "Heureka.cz, a.s.",
            "url": "https://www.heureka.cz/"
        }
    },
    {
        "regex": "ShopAlike",
        "name": "ShopAlike",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Visual Meta",
            "url": "https://www.shopalike.cz/"
        }
    },
    {
        "regex": "deepcrawl\\.com",
        "name": "Lumar",
        "category": "Crawler",
        "url": "https://deepcrawl.com/bot",
        "producer": {
            "name": "Lumar",
            "url": "https://www.lumar.io/"
        }
    },
    {
        "regex": "Googlebot-News",
        "name": "Googlebot News",
        "category": "Search bot",
        "url": "https://developers.google.com/search/docs/crawling-indexing/overview-google-crawlers",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Adwords-(?:DisplayAds|Express|Instant)|Google Web Preview|Google[ -]Publisher[ -]Plugin|Google-(?:adstxt|Ads-Conversions|Ads-Qualify|Adwords|AMPHTML|Assess|Extended|HotelAdsVerifier|InspectionTool|Lens|PageRenderer|Read-Aloud|Shopping-Quality|Site-Verification|Sites-Thumbnails|speakr|Stale-Content-Probe|Test|Youtube-Links)|(?:AdsBot|APIs|Feedfetcher|Mediapartners)-Google(?:-Mobile)?|Google(?:AdSenseInfeed|AssociationService|bot|Other|Prober|Producer|Sites)|Google.*/\\+/web/snippet",
        "name": "Googlebot",
        "category": "Search bot",
        "url": "https://developers.google.com/search/docs/crawling-indexing/overview-google-crawlers",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "^Google$",
        "name": "Googlebot",
        "category": "Search bot",
        "url": "https://developers.google.com/search/docs/crawling-indexing/overview-google-crawlers",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Google-Safety",
        "name": "Google-Safety",
        "category": "Crawler",
        "url": "https://developers.google.com/search/docs/crawling-indexing/google-special-case-crawlers",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "DuplexWeb-Google",
        "name": "DuplexWeb-Google",
        "category": "Crawler",
        "url": "https://developers.google.com/search/docs/crawling-indexing/google-special-case-crawlers",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "Google-Area120-PrivacyPolicyFetcher",
        "name": "Google Area 120 Privacy Policy Fetcher",
        "category": "Crawler",
        "url": "https://area120.google.com/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "HubSpot ",
        "name": "HubSpot",
        "category": "Crawler",
        "producer": {
            "name": "HubSpot Inc.",
            "url": "https://www.hubspot.com"
        }
    },
    {
        "regex": "vuhuv(?:Bot|RBT)",
        "name": "vuhuvBot",
        "category": "Search bot",
        "url": "https://vuhuv.com/bot.html"
    },
    {
        "regex": "HTTPMon",
        "name": "HTTPMon",
        "category": "Site Monitor",
        "url": "http://www.httpmon.com",
        "producer": {
            "name": "towards GmbH",
            "url": "http://www.towards.ch/"
        }
    },
    {
        "regex": "ICC-Crawler",
        "name": "ICC-Crawler",
        "category": "Crawler",
        "url": "http://www.nict.go.jp/en/univ-com/plan/crawl.html",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "inoreader\\.com",
        "name": "inoreader",
        "category": "Feed Reader",
        "url": "https://www.inoreader.com"
    },
    {
        "regex": "iisbot",
        "name": "IIS Site Analysis",
        "category": "Crawler",
        "url": "http://www.iis.net/iisbot.html",
        "producer": {
            "name": "Microsoft Corporation",
            "url": "http://www.microsoft.com"
        }
    },
    {
        "regex": "ips-agent",
        "name": "IPS Agent",
        "category": "Crawler",
        "producer": {
            "name": "VeriSign, Inc",
            "url": "http://www.verisign.com/"
        }
    },
    {
        "regex": "IP-Guide\\.com",
        "name": "IP-Guide Crawler",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "",
            "url": "https://ip-guide.com"
        }
    },
    {
        "regex": "k6/",
        "name": "K6",
        "url": "https://k6.io/"
    },
    {
        "regex": "kouio",
        "name": "Kouio",
        "url": "http://kouio.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "larbin",
        "name": "Larbin web crawler",
        "category": "Crawler",
        "url": "http://larbin.sourceforge.net",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "[A-z0-9]*-Lighthouse",
        "name": "Lighthouse",
        "category": "Site Monitor",
        "url": "https://developers.google.com/web/tools/lighthouse",
        "producer": {
            "name": "Lighthouse",
            "url": "https://developers.google.com/web/tools/lighthouse"
        }
    },
    {
        "regex": "last-modified\\.com",
        "name": "LastMod Bot",
        "category": "Site Monitor",
        "url": "https://last-modified.com/en/about",
        "producer": {
            "name": "",
            "url": "https://last-modified.com/en"
        }
    },
    {
        "regex": "linkdexbot|linkdex\\.com",
        "name": "Linkdex Bot",
        "category": "Search bot",
        "url": "http://www.linkdex.com/bots",
        "producer": {
            "name": "Mojeek Ltd.",
            "url": "http://www.mojeek.com"
        }
    },
    {
        "regex": "LinkedInBot",
        "name": "LinkedIn Bot",
        "category": "Social Media Agent",
        "url": "http://www.linkedin.com",
        "producer": {
            "name": "LinkedIn",
            "url": "http://www.linkedin.com"
        }
    },
    {
        "regex": "ltx71",
        "name": "LTX71",
        "category": "Security Checker",
        "url": "https://ltx71.com/",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Mail\\.RU",
        "name": "Mail.Ru Bot",
        "category": "Search bot",
        "url": "http://help.mail.ru/webmaster/indexing/robots/types_robots",
        "producer": {
            "name": "Mail.Ru Group",
            "url": "http://corp.mail.ru"
        }
    },
    {
        "regex": "magpie-crawler",
        "name": "Magpie-Crawler",
        "category": "Social Media Agent",
        "url": "http://www.brandwatch.com/magpie-crawler/",
        "producer": {
            "name": "Brandwatch",
            "url": "http://www.brandwatch.com"
        }
    },
    {
        "regex": "MagpieRSS",
        "name": "MagpieRSS",
        "url": "http://magpierss.sourceforge.net/",
        "category": "Feed Parser",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "masscan-ng",
        "name": "masscan-ng",
        "url": "https://github.com/bi-zone/masscan-ng",
        "category": "Crawler",
        "producer": {
            "name": "BIZON, OOO",
            "url": "https://bi.zone/"
        }
    },
    {
        "regex": ".*masscan",
        "name": "masscan",
        "url": "https://github.com/robertdavidgraham/masscan",
        "category": "Crawler",
        "producer": {
            "name": "Robert Graham",
            "url": "https://github.com/robertdavidgraham"
        }
    },
    {
        "regex": "Mastodon/",
        "name": "Mastodon Bot",
        "category": "Social Media Agent"
    },
    {
        "regex": "meanpathbot",
        "name": "Meanpath Bot",
        "category": "Search bot",
        "url": "http://www.meanpath.com/meanpathbot.html",
        "producer": {
            "name": "Meanpath",
            "url": "http://www.meanpath.com"
        }
    },
    {
        "regex": "MetaJobBot",
        "name": "MetaJobBot",
        "category": "Crawler",
        "url": "http://www.metajob.at/the/crawler",
        "producer": {
            "name": "MetaJob",
            "url": "http://www.metajob.at"
        }
    },
    {
        "regex": "MetaInspector",
        "name": "MetaInspector",
        "category": "Crawler",
        "url": "https://github.com/jaimeiniesta/metainspector"
    },
    {
        "regex": "MixrankBot",
        "name": "MixRank Bot",
        "category": "Crawler",
        "url": "http://mixrank.com",
        "producer": {
            "name": "Online Media Group, Inc.",
            "url": ""
        }
    },
    {
        "regex": "MJ12bot",
        "name": "MJ12 Bot",
        "category": "Search bot",
        "url": "http://majestic12.co.uk/bot.php",
        "producer": {
            "name": "Majestic-12",
            "url": "http://majestic12.co.uk"
        }
    },
    {
        "regex": "Mnogosearch",
        "name": "Mnogosearch",
        "category": "Search bot",
        "url": "http://www.mnogosearch.org/",
        "producer": {
            "name": "Lavtech.Com Corp.",
            "url": ""
        }
    },
    {
        "regex": "MojeekBot",
        "name": "MojeekBot",
        "category": "Search bot",
        "url": "http://www.mojeek.com/bot.html",
        "producer": {
            "name": "Mojeek Ltd.",
            "url": "http://www.mojeek.com"
        }
    },
    {
        "regex": "munin",
        "name": "Munin",
        "category": "Site Monitor",
        "url": "http://munin-monitoring.org/",
        "producer": {
            "name": "Munin",
            "url": "http://munin-monitoring.org/"
        }
    },
    {
        "regex": "NalezenCzBot",
        "name": "NalezenCzBot",
        "category": "Crawler",
        "url": "http://www.nalezen.cz/about-crawler",
        "producer": {
            "name": "Jaroslav Kubo\u0161",
            "url": ""
        }
    },
    {
        "regex": "check_http/v",
        "name": "Nagios check_http",
        "category": "Site Monitor",
        "url": "https://nagios.org",
        "producer": {
            "name": "Nagios Plugins Development Team",
            "url": "https://nagios.org"
        }
    },
    {
        "regex": "nbertaupete95\\(at\\)gmail\\.com",
        "name": "nbertaupete95",
        "category": "Crawler"
    },
    {
        "regex": "Netcraft(?: Web Server Survey| SSL Server Survey|SurveyAgent)",
        "name": "Netcraft Survey Bot",
        "category": "Search bot",
        "url": "",
        "producer": {
            "name": "Netcraft",
            "url": "http://www.netcraft.com"
        }
    },
    {
        "regex": "netEstate NE Crawler",
        "name": "netEstate",
        "category": "Crawler",
        "url": "http://www.website-datenbank.de/Impressum",
        "producer": {
            "name": "netEstate GmbH",
            "url": "https://www.netestate.de/en/"
        }
    },
    {
        "regex": "Netvibes",
        "name": "Netvibes",
        "url": "http://www.netvibes.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "NewsBlur .*(?:Fetcher|Finder)",
        "name": "NewsBlur",
        "url": "http://www.newsblur.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "NewsGatorOnline",
        "name": "NewsGator",
        "url": "http://www.newsgator.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "nlcrawler",
        "name": "NLCrawler",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Northern Light",
            "url": "http://northernlight.com"
        }
    },
    {
        "regex": "Nmap Scripting Engine",
        "name": "Nmap",
        "category": "Security Checker",
        "url": "https://nmap.org/book/nse.html",
        "producer": {
            "name": "Nmap",
            "url": "https://nmap.org/"
        }
    },
    {
        "regex": "Nuzzel",
        "name": "Nuzzel",
        "category": "Crawler",
        "producer": {
            "name": "Nuzzel",
            "url": "https://www.nuzzel.com/"
        }
    },
    {
        "regex": "NodePing",
        "name": "NodePing",
        "category": "Site Monitor",
        "url": "https://nodeping.com",
        "producer": {
            "name": "NodePing",
            "url": "https://nodeping.com"
        }
    },
    {
        "regex": "Octopus [\\d.]+",
        "name": "Octopus"
    },
    {
        "regex": "OnlineOrNot\\.com_bot",
        "name": "OnlineOrNot Bot",
        "category": "Site Monitor",
        "url": "https://onlineornot.com/website-monitoring",
        "producer": {
            "name": "OnlineOrNot",
            "url": "https://onlineornot.com"
        }
    },
    {
        "regex": "omgili",
        "name": "Omgili bot",
        "category": "Search bot",
        "url": "http://www.omgili.com/Crawler.html",
        "producer": {
            "name": "Omgili",
            "url": "http://www.omgili.com"
        }
    },
    {
        "regex": "OpenindexSpider",
        "name": "Openindex Spider",
        "category": "Search bot",
        "url": "http://www.openindex.io/en/webmasters/spider.html",
        "producer": {
            "name": "Openindex B.V.",
            "url": "http://www.openindex.io"
        }
    },
    {
        "regex": "spbot",
        "name": "OpenLinkProfiler",
        "category": "Crawler",
        "url": "http://openlinkprofiler.org/bot",
        "producer": {
            "name": "Axandra GmbH",
            "url": "http://www.axandra.com"
        }
    },
    {
        "regex": "OpenWebSpider",
        "name": "OpenWebSpider",
        "category": "Crawler",
        "url": "http://www.openwebspider.org",
        "producer": {
            "name": "OpenWebSpider Lab",
            "url": "http://lab.openwebspider.org"
        }
    },
    {
        "regex": "OrangeBot|VoilaBot",
        "name": "Orange Bot",
        "category": "Search bot",
        "url": "http://lemoteur.orange.fr",
        "producer": {
            "name": "Orange",
            "url": "http://www.orange.fr"
        }
    },
    {
        "regex": "PaperLiBot",
        "name": "PaperLiBot",
        "category": "Search bot",
        "url": "http://support.paper.li/entries/20023257-what-is-paper-li",
        "producer": {
            "name": "Smallrivers SA",
            "url": "http://www.paper.li"
        }
    },
    {
        "regex": "phantomas/",
        "name": "Phantomas",
        "category": "Site Monitor",
        "url": "https://github.com/macbre/phantomas"
    },
    {
        "regex": "phpservermon",
        "name": "PHP Server Monitor",
        "category": "Site Monitor",
        "url": "https://github.com/phpservermon/phpservermon",
        "producer": {
            "name": "PHP Server Monitor",
            "url": "http://www.phpservermonitor.org/"
        }
    },
    {
        "regex": "Pocket(?:ImageCache|Parser)",
        "name": "Pocket",
        "category": "Read-it-later Service",
        "url": "https://getpocket.com/pocketparser_ua",
        "producer": {
            "name": "Read It Later, Inc.",
            "url": "https://getpocket.com/"
        }
    },
    {
        "regex": "PritTorrent",
        "name": "PritTorrent",
        "category": "Crawler",
        "url": "https://github.com/astro/prittorrent",
        "producer": {
            "name": "Bitlove",
            "url": "http://bitlove.org/"
        }
    },
    {
        "regex": "PRTG Network Monitor",
        "name": "PRTG Network Monitor",
        "category": "Network Monitor",
        "url": "https://www.paessler.com/prtg",
        "producer": {
            "name": "Paessler AG",
            "url": "https://www.paessler.com"
        }
    },
    {
        "regex": "psbot",
        "name": "Picsearch bot",
        "category": "Search bot",
        "url": "http://www.picsearch.com/bot.html",
        "producer": {
            "name": "Picsearch",
            "url": "http://www.picsearch.com"
        }
    },
    {
        "regex": "Pingdom(?:\\.com|TMS)",
        "name": "Pingdom Bot",
        "category": "Site Monitor",
        "url": "",
        "producer": {
            "name": "Pingdom AB",
            "url": "https://www.pingdom.com"
        }
    },
    {
        "regex": "Quora Link Preview",
        "name": "Quora Link Preview",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Quora",
            "url": "http://www.quora.com"
        }
    },
    {
        "regex": "Quora-Bot",
        "name": "Quora Bot",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Quora",
            "url": "https://www.quora.com/"
        }
    },
    {
        "regex": "RamblerMail",
        "name": "RamblerMail Image Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Rambler&Co",
            "url": "https://rambler-co.ru/"
        }
    },
    {
        "regex": "QuerySeekerSpider",
        "name": "QuerySeekerSpider",
        "category": "Crawler",
        "url": "http://queryseeker.com/bot.html",
        "producer": {
            "name": "QueryEye Inc.",
            "url": "http://queryeye.com"
        }
    },
    {
        "regex": "Qwantify|Qwantbot",
        "name": "Qwantbot",
        "category": "Crawler",
        "url": "https://help.qwant.com/bot/",
        "producer": {
            "name": "Qwant Corporation",
            "url": "https://www.qwant.com/"
        }
    },
    {
        "regex": "Rainmeter",
        "name": "Rainmeter",
        "category": "Crawler",
        "url": "https://www.rainmeter.net"
    },
    {
        "regex": "redditbot",
        "name": "Reddit Bot",
        "category": "Social Media Agent",
        "url": "http://www.reddit.com/feedback",
        "producer": {
            "name": "reddit inc.",
            "url": "http://www.reddit.com"
        }
    },
    {
        "regex": "Riddler",
        "name": "Riddler",
        "category": "Security search bot",
        "url": "https://riddler.io/about",
        "producer": {
            "name": "F-Secure",
            "url": "https://www.f-secure.com"
        }
    },
    {
        "regex": "rogerbot",
        "name": "Rogerbot",
        "category": "Crawler",
        "url": "http://moz.com/help/pro/what-is-rogerbot-",
        "producer": {
            "name": "SEOmoz, Inc.",
            "url": "http://moz.com/"
        }
    },
    {
        "regex": "ROI Hunter",
        "name": "ROI Hunter",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Roihunter a.s.",
            "url": "http://roihunter.com/"
        }
    },
    {
        "regex": "SafeDNSBot",
        "name": "SafeDNSBot",
        "category": "Crawler",
        "url": "https://www.safedns.com/searchbot",
        "producer": {
            "name": "SafeDNS, Inc.",
            "url": "https://www.safedns.com/"
        }
    },
    {
        "regex": "Scrapy",
        "name": "Scrapy",
        "category": "Crawler",
        "url": "http://scrapy.org"
    },
    {
        "regex": "Screaming Frog SEO Spider",
        "name": "Screaming Frog SEO Spider",
        "category": "Crawler",
        "url": "http://www.screamingfrog.co.uk/seo-spider",
        "producer": {
            "name": "Screaming Frog Ltd",
            "url": "http://www.screamingfrog.co.uk"
        }
    },
    {
        "regex": "ScreenerBot",
        "name": "ScreenerBot",
        "category": "Crawler",
        "url": "http://www.screenerbot.com",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "SemrushBot",
        "name": "SemrushBot",
        "category": "Crawler",
        "url": "https://www.semrush.com/bot/",
        "producer": {
            "name": "Semrush Inc.",
            "url": "https://www.semrush.com/"
        }
    },
    {
        "regex": "BacklinksExtendedBot",
        "name": "BacklinksExtendedBot",
        "category": "Crawler",
        "url": "https://www.semrush.com/bot/",
        "producer": {
            "name": "Semrush Inc.",
            "url": "https://www.semrush.com/"
        }
    },
    {
        "regex": "SerpReputationManagementAgent",
        "name": "Semrush Reputation Management",
        "category": "Service Agent",
        "url": "https://www.semrush.com/bot/",
        "producer": {
            "name": "Semrush Inc.",
            "url": "https://www.semrush.com/"
        }
    },
    {
        "regex": "SplitSignalBot",
        "name": "SplitSignalBot",
        "category": "Crawler",
        "url": "https://www.semrush.com/bot/",
        "producer": {
            "name": "Semrush Inc.",
            "url": "https://www.semrush.com/"
        }
    },
    {
        "regex": "SiteAuditBot",
        "name": "SiteAuditBot",
        "category": "Crawler",
        "url": "https://www.semrush.com/bot/",
        "producer": {
            "name": "Semrush Inc.",
            "url": "https://www.semrush.com/"
        }
    },
    {
        "regex": "SensikaBot",
        "name": "Sensika Bot",
        "category": "",
        "url": "",
        "producer": {
            "name": "Sensika",
            "url": "http://sensika.com"
        }
    },
    {
        "regex": "SEOENG(?:World)?Bot",
        "name": "SEOENGBot",
        "category": "Crawler",
        "url": "http://www.seoengine.com/seoengbot.htm",
        "producer": {
            "name": "SEO Engine",
            "url": "http://www.seoengine.com"
        }
    },
    {
        "regex": "seoscanners\\.net",
        "name": "Seoscanners.net",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SkypeUriPreview",
        "name": "Skype URI Preview",
        "category": "Service Agent",
        "url": "",
        "producer": {
            "name": "Skype Communications S.\xe0.r.l.",
            "url": "https://www.skype.com"
        }
    },
    {
        "regex": "SeznamBot|SklikBot|Seznam screenshot-generator",
        "name": "Seznam Bot",
        "category": "Search bot",
        "url": "http://www.mapy.cz/cz/seznambot.html",
        "producer": {
            "name": "Seznam.cz, a.s.",
            "url": "http://www.seznam.cz/"
        }
    },
    {
        "regex": "shopify-partner-homepage-scraper",
        "name": "Shopify Partner",
        "category": "Crawler",
        "url": "https://www.shopify.com/partners",
        "producer": {
            "name": "Shopify",
            "url": "https://www.shopify.com/"
        }
    },
    {
        "regex": "ShopWiki",
        "name": "ShopWiki",
        "category": "Search tools",
        "url": "http://www.shopwiki.com/wiki/Help:Bot",
        "producer": {
            "name": "ShopWiki Corp.",
            "url": "http://www.shopwiki.com"
        }
    },
    {
        "regex": "SilverReader",
        "name": "SilverReader",
        "url": "http://silverreader.com",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "SimplePie",
        "name": "SimplePie",
        "url": "http://www.simplepie.org",
        "category": "Feed Parser",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "SISTRIX Crawler",
        "name": "SISTRIX Crawler",
        "category": "Crawler",
        "url": "http://crawler.sistrix.net",
        "producer": {
            "name": "SISTRIX GmbH",
            "url": "http://www.sistrix.de"
        }
    },
    {
        "regex": "compatible; (?:SISTRIX )?Optimizer",
        "name": "SISTRIX Optimizer",
        "category": "Crawler",
        "url": "https://optimizer.sistrix.com",
        "producer": {
            "name": "SISTRIX GmbH",
            "url": "http://www.sistrix.de"
        }
    },
    {
        "regex": "SiteSucker",
        "name": "SiteSucker",
        "category": "Crawler",
        "url": "http://ricks-apps.com/osx/sitesucker/"
    },
    {
        "regex": "sixy\\.ch",
        "name": "Sixy.ch",
        "category": "Site Monitor",
        "url": "http://sixy.ch",
        "producer": {
            "name": "Manuel Kasper",
            "url": "https://neon1.net/"
        }
    },
    {
        "regex": "Slackbot|Slack-ImgProxy",
        "name": "Slackbot",
        "category": "Crawler",
        "url": "https://api.slack.com/robots",
        "producer": {
            "name": "Slack Technologies",
            "url": "http://slack.com"
        }
    },
    {
        "regex": "Sogou[ -](?:head|inst|Orion|Pic|Test|web)[ -]spider|New-Sogou-Spider",
        "name": "Sogou Spider",
        "category": "Search bot",
        "url": "http://www.sogou.com/docs/help/webmasters.htm",
        "producer": {
            "name": "Sohu, Inc.",
            "url": "http://www.sogou.com"
        }
    },
    {
        "regex": "Sosospider|Sosoimagespider",
        "name": "Soso Spider",
        "category": "Search bot",
        "url": "http://help.soso.com/webspider.htm",
        "producer": {
            "name": "Tencent Holdings",
            "url": "http://www.soso.com"
        }
    },
    {
        "regex": "Sprinklr",
        "name": "Sprinklr",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Sprinklr, Inc.",
            "url": "https://www.sprinklr.com/"
        }
    },
    {
        "regex": "SSL Labs",
        "name": "SSL Labs",
        "category": "Validator",
        "url": "https://www.ssllabs.com/about/assessment.html",
        "producer": {
            "name": "SSL Labs",
            "url": "https://www.ssllabs.com/about/assessment.html"
        }
    },
    {
        "regex": "StatusCake",
        "name": "StatusCake",
        "category": "Site Monitor",
        "url": "https://www.statuscake.com",
        "producer": {
            "name": "StatusCake",
            "url": "https://www.statuscake.com"
        }
    },
    {
        "regex": "Superfeedr bot",
        "name": "Superfeedr Bot",
        "category": "Feed Fetcher",
        "url": "",
        "producer": {
            "name": "Superfeedr",
            "url": "https://superfeedr.com/"
        }
    },
    {
        "regex": "Sparkler",
        "name": "Sparkler",
        "category": "Crawler",
        "url": "https://github.com/USCDataScience/sparkler"
    },
    {
        "regex": "Spinn3r",
        "name": "Spinn3r",
        "category": "Crawler",
        "url": "http://spinn3r.com/robot",
        "producer": {
            "name": "Tailrank Inc",
            "url": "http://spinn3r.com"
        }
    },
    {
        "regex": "SputnikBot",
        "name": "Sputnik Bot",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SputnikFaviconBot",
        "name": "Sputnik Favicon Bot",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SputnikImageBot",
        "name": "Sputnik Image Bot",
        "category": "Crawler",
        "url": ""
    },
    {
        "regex": "SurveyBot",
        "name": "Survey Bot",
        "category": "Search bot",
        "url": "http://www.domaintools.com/webmasters/surveybot.php",
        "producer": {
            "name": "Domain Tools",
            "url": "http://www.domaintools.com"
        }
    },
    {
        "regex": "TarmotGezgin",
        "name": "Tarmot Gezgin",
        "url": "http://www.tarmot.com/gezgin/",
        "category": "Search bot"
    },
    {
        "regex": "TelegramBot",
        "name": "TelegramBot",
        "url": "https://telegram.org/blog/bot-revolution"
    },
    {
        "regex": "TLSProbe",
        "name": "TLSProbe",
        "url": "https://scan.trustnet.venafi.com/",
        "category": "Security search bot",
        "producer": {
            "name": "Venafi TrustNet",
            "url": "https://www.venafi.com"
        }
    },
    {
        "regex": "TinEye-bot",
        "name": "TinEye Crawler",
        "category": "Search bot",
        "url": "http://www.tineye.com/crawler.html",
        "producer": {
            "name": "Id\xe9e Inc.",
            "url": "http://ideeinc.com"
        }
    },
    {
        "regex": "Tiny Tiny RSS",
        "name": "Tiny Tiny RSS",
        "url": "http://tt-rss.org",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "theoldreader\\.com",
        "name": "theoldreader",
        "category": "Feed Reader",
        "url": "https://theoldreader.com"
    },
    {
        "regex": "Trackable/0\\.1",
        "name": "Chartable",
        "category": "Site Monitor",
        "url": "https://help.chartable.com/article/34-what-is-the-trackable-analytics-prefix",
        "producer": {
            "name": "Chartable",
            "url": "https://chartable.com"
        }
    },
    {
        "regex": "trendictionbot",
        "name": "Trendiction Bot",
        "category": "Crawler",
        "url": "http://www.trendiction.de/bot",
        "producer": {
            "name": "Talkwalker Inc.",
            "url": "http://www.talkwalker.com"
        }
    },
    {
        "regex": "TurnitinBot",
        "name": "TurnitinBot",
        "category": "Crawler",
        "url": "http://www.turnitin.com/robot/crawlerinfo.html",
        "producer": {
            "name": "iParadigms, LLC.",
            "url": "http://www.turnitin.com"
        }
    },
    {
        "regex": "TweetedTimes",
        "name": "TweetedTimes Bot",
        "category": "Crawler",
        "url": "https://tweetedtimes.com/",
        "producer": {
            "name": "TweetedTimes",
            "url": "https://tweetedtimes.com/"
        }
    },
    {
        "regex": "TweetmemeBot",
        "name": "Tweetmeme Bot",
        "category": "Crawler",
        "url": "http://tweetmeme.com/",
        "producer": {
            "name": "Mediasift",
            "url": ""
        }
    },
    {
        "regex": "Twingly Recon",
        "name": "Twingly Recon",
        "category": "Crawler",
        "producer": {
            "name": "Twingly",
            "url": "https://www.twingly.com"
        }
    },
    {
        "regex": "Twitterbot",
        "name": "Twitterbot",
        "category": "Social Media Agent",
        "url": "https://dev.twitter.com/docs/cards/getting-started",
        "producer": {
            "name": "Twitter",
            "url": "http://www.twitter.com"
        }
    },
    {
        "regex": "UniversalFeedParser",
        "name": "UniversalFeedParser",
        "category": "Feed Fetcher",
        "url": "https://github.com/kurtmckee/feedparser",
        "producer": {
            "name": "Kurt McKee",
            "url": "https://github.com/kurtmckee"
        }
    },
    {
        "regex": "via secureurl\\.fwdcdn\\.com",
        "name": "UkrNet Mail Proxy",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "UkrNet Ltd",
            "url": "https://www.ukr.net/"
        }
    },
    {
        "regex": "Uptime(?:bot)?/",
        "name": "Uptimebot",
        "category": "Site Monitor",
        "url": "https://uptime.com/uptime-bot",
        "producer": {
            "name": "Uptime",
            "url": "https://uptime.com/"
        }
    },
    {
        "regex": "UptimeRobot",
        "name": "UptimeRobot",
        "category": "Site Monitor",
        "url": "https://uptimerobot.com/",
        "producer": {
            "name": "Uptime Robot",
            "url": "https://uptimerobot.com/"
        }
    },
    {
        "regex": "URLAppendBot",
        "name": "URLAppendBot",
        "category": "Crawler",
        "url": "http://www.profound.net/urlappendbot.html",
        "producer": {
            "name": "Profound Networks",
            "url": "http://www.profound.net"
        }
    },
    {
        "regex": "Vagabondo",
        "name": "Vagabondo",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "WiseGuys",
            "url": "http://www.wise-guys.nl/"
        }
    },
    {
        "regex": "vkShare; ",
        "name": "VK Share Button",
        "category": "Crawler",
        "url": "https://dev.vk.com/en/widgets/share",
        "producer": {
            "name": "VK",
            "url": "https://vk.com/"
        }
    },
    {
        "regex": "VKRobot",
        "name": "VK Robot",
        "category": "Crawler",
        "url": "https://dev.vk.com/en/",
        "producer": {
            "name": "VK",
            "url": "https://vk.com/"
        }
    },
    {
        "regex": "VSMCrawler",
        "name": "Visual Site Mapper Crawler",
        "category": "Crawler",
        "url": "http://www.visualsitemapper.com/crawler",
        "producer": {
            "name": "Alentum Software Ltd.",
            "url": "http://www.alentum.com"
        }
    },
    {
        "regex": "Jigsaw",
        "name": "W3C CSS Validator",
        "category": "Validator",
        "url": "http://jigsaw.w3.org/css-validator",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C_I18n-Checker",
        "name": "W3C I18N Checker",
        "category": "Validator",
        "url": "http://validator.w3.org/i18n-checker",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C-checklink",
        "name": "W3C Link Checker",
        "category": "Validator",
        "url": "http://validator.w3.org/checklink",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C_Validator|Validator\\.nu",
        "name": "W3C Markup Validation Service",
        "category": "Validator",
        "url": "http://validator.w3.org/services",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C-mobileOK",
        "name": "W3C MobileOK Checker",
        "category": "Validator",
        "url": "http://validator.w3.org/mobile",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "W3C_Unicorn",
        "name": "W3C Unified Validator",
        "category": "Validator",
        "url": "http://validator.w3.org/unicorn",
        "producer": {
            "name": "W3C",
            "url": "http://www.w3.org"
        }
    },
    {
        "regex": "P3P Validator",
        "name": "W3C P3P Validator",
        "category": "Validator",
        "url": "https://www.w3.org/P3P/validator.html",
        "producer": {
            "name": "W3C",
            "url": "https://www.w3.org"
        }
    },
    {
        "regex": "Wappalyzer",
        "name": "Wappalyzer",
        "url": "https://github.com/AliasIO/Wappalyzer",
        "producer": {
            "name": "AliasIO",
            "url": "https://github.com/AliasIO"
        }
    },
    {
        "regex": "PTST/",
        "name": "WebPageTest",
        "category": "Site Monitor",
        "url": "https://www.webpagetest.org"
    },
    {
        "regex": "WeSEE",
        "name": "WeSEE:Search",
        "category": "Search bot",
        "url": "http://www.wesee.com/bot",
        "producer": {
            "name": "WeSEE Ltd",
            "url": "http://www.wesee.com"
        }
    },
    {
        "regex": "WebbCrawler",
        "name": "WebbCrawler",
        "category": "Crawler",
        "url": "http://badcheese.com/crawler.html",
        "producer": {
            "name": "Steve Webb",
            "url": "http://badcheese.com"
        }
    },
    {
        "regex": "websitepulse[+ ]checker",
        "name": "WebSitePulse",
        "category": "Site Monitor",
        "url": "http://badcheese.com/crawler.html",
        "producer": {
            "name": "WebSitePulse",
            "url": "http://www.websitepulse.com/"
        }
    },
    {
        "regex": "WordPress.+isitwp\\.com",
        "name": "IsItWP",
        "category": "Crawler",
        "url": "https://www.isitwp.com/",
        "producer": {
            "name": "WPBeginner, LLC",
            "url": "https://www.wpbeginner.com/"
        }
    },
    {
        "regex": "Automattic Analytics Crawler",
        "name": "Automattic Analytics",
        "category": "Crawler",
        "url": "https://wordpress.com/crawler/",
        "producer": {
            "name": "Wordpress.org",
            "url": "https://wordpress.org/"
        }
    },
    {
        "regex": "WordPress\\.com mShots",
        "name": "WordPress.com mShots",
        "category": "Service Agent",
        "url": "https://wordpress.org/",
        "producer": {
            "name": "Wordpress.org",
            "url": "https://wordpress.org/"
        }
    },
    {
        "regex": "wp\\.com feedbot",
        "name": "wp.com feedbot",
        "category": "Feed Fetcher",
        "url": "https://wordpress.com/",
        "producer": {
            "name": "Automattic, Inc.",
            "url": "https://automattic.com/"
        }
    },
    {
        "regex": "WordPress",
        "name": "WordPress",
        "category": "Service Agent",
        "url": "https://wordpress.org/",
        "producer": {
            "name": "Wordpress.org",
            "url": "https://wordpress.org/"
        }
    },
    {
        "regex": "Wotbox",
        "name": "Wotbox",
        "category": "Search bot",
        "url": "http://www.wotbox.com/bot/",
        "producer": {
            "name": "Wotbox",
            "url": "http://www.wotbox.com"
        }
    },
    {
        "regex": "XenForo",
        "name": "XenForo",
        "category": "Service Agent",
        "url": "https://xenforo.com/",
        "producer": {
            "name": "XenForo Ltd.",
            "url": "https://xenforo.com/"
        }
    },
    {
        "regex": "yacybot",
        "name": "YaCy",
        "category": "Search bot",
        "url": "http://yacy.net/bot.html",
        "producer": {
            "name": "YaCy",
            "url": "http://yacy.net"
        }
    },
    {
        "regex": "Yahoo! Slurp|Yahoo!-AdCrawler",
        "name": "Yahoo! Slurp",
        "category": "Search bot",
        "url": "http://help.yahoo.com/ysearch/slurp",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "Yahoo Link Preview|Yahoo:LinkExpander:Slingstone",
        "name": "Yahoo! Link Preview",
        "category": "Crawler",
        "url": "https://help.yahoo.com/kb/mail/yahoo-link-preview-SLN23615.html",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "YahooMailProxy",
        "name": "Yahoo! Mail Proxy",
        "category": "Service Agent",
        "url": "https://help.yahoo.com/kb/yahoo-mail-proxy-SLN28749.html",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "YahooCacheSystem",
        "name": "Yahoo! Cache System",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": "Y!J-BRW",
        "name": "Yahoo! Japan BRW",
        "category": "Crawler",
        "url": "https://support.yahoo-net.jp/PccSearch/s/article/H000007955",
        "producer": {
            "name": "Yahoo! Japan Corp.",
            "url": "https://www.yahoo.co.jp/"
        }
    },
    {
        "regex": "Y!J-WSC",
        "name": "Yahoo! Japan WSC",
        "category": "Crawler",
        "url": "https://support.yahoo-net.jp/PccSearch/s/article/H000007955",
        "producer": {
            "name": "Yahoo! Japan Corp.",
            "url": "https://www.yahoo.co.jp/"
        }
    },
    {
        "regex": "Y!J-ASR",
        "name": "Yahoo! Japan ASR",
        "category": "Crawler",
        "url": "https://support.yahoo-net.jp/PccSearch/s/article/H000007955",
        "producer": {
            "name": "Yahoo! Japan Corp.",
            "url": "https://www.yahoo.co.jp/"
        }
    },
    {
        "regex": "^Y!J",
        "name": "Yahoo! Japan",
        "category": "Crawler",
        "url": "https://support.yahoo-net.jp/PccSearch/s/article/H000007955",
        "producer": {
            "name": "Yahoo! Japan Corp.",
            "url": "https://www.yahoo.co.jp/"
        }
    },
    {
        "regex": "Yandex(?:(?:\\.Gazeta |Accessibility|Additional|Com|Mobile|MobileScreenShot|RenderResources|Screenshot|Sprav)?Bot|(?:Additional|AdNet|Antivirus|Blogs|Calendar|Catalog|Dialogs|Direct|Favicons|ForDomain|ImageResizer|Images|Market|Media|Metrika|News|OntoDB(?:API)?|Pagechecker|Partner|RCA|SearchShop|(?:News|Site)links|Tracker|Turbo|Userproxy|Verticals|Vertis|Video|Webmaster))|YaDirectFetcher",
        "name": "Yandex Bot",
        "category": "Search bot",
        "url": "https://yandex.com/support/webmaster/robot-workings/check-yandex-robots.html",
        "producer": {
            "name": "Yandex LLC",
            "url": "https://yandex.com/company/"
        }
    },
    {
        "regex": "Yeti|NaverJapan|AdsBot-Naver",
        "name": "Yeti/Naverbot",
        "category": "Search bot",
        "url": "http://help.naver.com/robots/",
        "producer": {
            "name": "Naver",
            "url": "http://www.naver.com"
        }
    },
    {
        "regex": "YoudaoBot",
        "name": "Youdao Bot",
        "category": "Search bot",
        "url": "http://www.youdao.com/help/webmaster/spider",
        "producer": {
            "name": "NetEase, Inc.",
            "url": "http://corp.163.com"
        }
    },
    {
        "regex": "YOURLS",
        "name": "Yourls",
        "category": "Crawler",
        "url": "http://yourls.org"
    },
    {
        "regex": "YRSpider|YYSpider",
        "name": "Yunyun Bot",
        "category": "Search bot",
        "url": "http://www.yunyun.com/SiteInfo.php?r=about",
        "producer": {
            "name": "YunYun",
            "url": "http://www.yunyun.com"
        }
    },
    {
        "regex": "zgrab",
        "name": "zgrab",
        "category": "Security Checker",
        "url": "https://github.com/zmap/zgrab"
    },
    {
        "regex": "Zookabot",
        "name": "Zookabot",
        "category": "Crawler",
        "url": "http://zookabot.com",
        "producer": {
            "name": "Hwacha ApS",
            "url": "http://hwacha.dk"
        }
    },
    {
        "regex": "ZumBot",
        "name": "ZumBot",
        "category": "Search bot",
        "url": "http://help.zum.com/inquiry",
        "producer": {
            "name": "ZUM internet",
            "url": "http://www.zuminternet.com/"
        }
    },
    {
        "regex": "YottaaMonitor",
        "name": "Yottaa Site Monitor",
        "category": "Site Monitor",
        "url": "http://www.yottaa.com/products/site-monitor",
        "producer": {
            "name": "Yottaa",
            "url": "http://www.yottaa.com/"
        }
    },
    {
        "regex": "Yahoo Ad monitoring.*yahoo-ad-monitoring-SLN24857",
        "name": "Yahoo Gemini",
        "category": "Crawler",
        "url": "https://help.yahoo.com/kb/yahoo-ad-monitoring-SLN24857.html",
        "producer": {
            "name": "Yahoo! Inc.",
            "url": "http://www.yahoo.com"
        }
    },
    {
        "regex": ".*Java.*outbrain",
        "name": "Outbrain",
        "category": "Crawler",
        "url": "",
        "producer": {
            "name": "Outbrain",
            "url": "http://www.outbrain.com/"
        }
    },
    {
        "regex": "HubPages.*crawlingpolicy",
        "name": "HubPages",
        "category": "Crawler",
        "url": "https://hubpages.com/help/crawlingpolicy",
        "producer": {
            "name": "HubPages, Inc.",
            "url": "https://discover.hubpages.com/"
        }
    },
    {
        "regex": "Pinterest(?:bot)?/.*www\\.pinterest\\.com",
        "name": "Pinterest",
        "url": "https://help.pinterest.com/en/business/article/pinterest-crawler",
        "category": "Crawler",
        "producer": {
            "name": "Pinterest",
            "url": "https://www.pinterest.com/"
        }
    },
    {
        "regex": ".*Site24x7",
        "name": "Site24x7 Website Monitoring",
        "category": "Site Monitor",
        "url": "https://www.site24x7.com/site24x7-faq.html",
        "producer": {
            "name": "Site24x7",
            "url": "https://www.site24x7.com"
        }
    },
    {
        "regex": ".* HLB",
        "name": "Site24x7 Defacement Monitor",
        "category": "Site Monitor",
        "url": "https://support.site24x7.com/portal/en/kb/articles/default-user-agent-used-in-website-defacement-monitor",
        "producer": {
            "name": "Site24x7",
            "url": "https://www.site24x7.com/"
        }
    },
    {
        "regex": "s~snapchat-proxy",
        "name": "Snapchat Proxy",
        "category": "Crawler",
        "url": "https://www.snapchat.com",
        "producer": {
            "name": "Snapchat Inc.",
            "url": "https://www.snapchat.com"
        }
    },
    {
        "regex": "Snap URL Preview Service",
        "name": "Snap URL Preview Service",
        "category": "Service Agent",
        "url": "https://developers.snap.com/robots",
        "producer": {
            "name": "Snapchat Inc.",
            "url": "https://www.snapchat.com/"
        }
    },
    {
        "regex": "SnapchatAds",
        "name": "Snapchat Ads",
        "category": "Crawler",
        "url": "https://businesshelp.snapchat.com/s/article/adsbot-crawler?language=en_US",
        "producer": {
            "name": "Snapchat Inc.",
            "url": "https://www.snapchat.com/"
        }
    },
    {
        "regex": "Let's Encrypt validation server",
        "name": "Let's Encrypt Validation",
        "category": "Service Agent",
        "url": "https://letsencrypt.org/how-it-works/",
        "producer": {
            "name": "Let's Encrypt",
            "url": "https://letsencrypt.org"
        }
    },
    {
        "regex": "GrapeshotCrawler",
        "name": "Grapeshot",
        "category": "Crawler",
        "url": "https://www.grapeshot.com/crawler",
        "producer": {
            "name": "Grapeshot",
            "url": "https://www.grapeshot.com"
        }
    },
    {
        "regex": "www\\.monitor\\.us",
        "name": "Monitor.Us",
        "category": "Site Monitor",
        "url": "http://www.monitor.us",
        "producer": {
            "name": "Monitor.Us",
            "url": "http://www.monitor.us"
        }
    },
    {
        "regex": "Catchpoint",
        "name": "Catchpoint",
        "category": "Site Monitor",
        "url": "https://www.catchpoint.com/",
        "producer": {
            "name": "Catchpoint Systems",
            "url": "https://www.catchpoint.com/"
        }
    },
    {
        "regex": "bitlybot",
        "name": "BitlyBot",
        "category": "Crawler",
        "url": "https://bitly.com",
        "producer": {
            "name": "Bitly, Inc.",
            "url": "https://bitly.com"
        }
    },
    {
        "regex": "Zao/",
        "name": "Zao",
        "category": "Crawler"
    },
    {
        "regex": "lycos",
        "name": "Lycos"
    },
    {
        "regex": "Slurp",
        "name": "Inktomi Slurp"
    },
    {
        "regex": "Speedy Spider",
        "name": "Speedy"
    },
    {
        "regex": "ScoutJet",
        "name": "ScoutJet"
    },
    {
        "regex": "nrsbot|netresearch",
        "name": "NetResearchServer"
    },
    {
        "regex": "scooter",
        "name": "Scooter"
    },
    {
        "regex": "gigabot",
        "name": "Gigabot"
    },
    {
        "regex": "charlotte",
        "name": "Charlotte"
    },
    {
        "regex": "Pompos",
        "name": "Pompos"
    },
    {
        "regex": "ichiro",
        "name": "ichiro"
    },
    {
        "regex": "PagePeeker",
        "name": "PagePeeker",
        "category": "Crawler",
        "url": "https://pagepeeker.com/robots/",
        "producer": {
            "name": "PAGEPEEKER SRL",
            "url": "https://pagepeeker.com/"
        }
    },
    {
        "regex": "WebThumbnail",
        "name": "WebThumbnail"
    },
    {
        "regex": "Willow Internet Crawler",
        "name": "Willow Internet Crawler"
    },
    {
        "regex": "EmailWolf",
        "name": "EmailWolf"
    },
    {
        "regex": "NetLyzer FastProbe",
        "name": "NetLyzer FastProbe"
    },
    {
        "regex": "AdMantX.*admantx\\.com",
        "name": "ADMantX"
    },
    {
        "regex": "Server Density Service Monitoring",
        "name": "Server Density"
    },
    {
        "regex": "RSSRadio \\(Push Notification Scanner;support@dorada\\.co\\.uk\\)",
        "name": "RSSRadio Bot"
    },
    {
        "regex": "^sentry",
        "name": "Sentry Bot",
        "producer": {
            "name": "Sentry",
            "url": "https://sentry.io"
        }
    },
    {
        "regex": "^Spotify/[\\d.]+$",
        "name": "Spotify",
        "producer": {
            "name": "Spotify",
            "url": "https://www.spotify.com"
        }
    },
    {
        "regex": "The Knowledge AI",
        "name": "The Knowledge AI",
        "category": "Crawler"
    },
    {
        "regex": "Embedly",
        "name": "Embedly",
        "category": "Crawler",
        "url": "https://support.embed.ly/hc/en-us",
        "producer": {
            "name": "A Medium, Corp.",
            "url": "https://medium.com/"
        }
    },
    {
        "regex": "BrandVerity",
        "name": "BrandVerity",
        "category": "Crawler",
        "url": "https://www.brandverity.com/why-is-brandverity-visiting-me",
        "producer": {
            "name": "BrandVerity, Inc.",
            "url": "https://www.brandverity.com/"
        }
    },
    {
        "regex": "Kaspersky Lab CFR link resolver",
        "name": "Kaspersky",
        "category": "Security Checker",
        "url": "https://www.kaspersky.com/",
        "producer": {
            "name": "AO Kaspersky Lab",
            "url": "https://www.kaspersky.com/"
        }
    },
    {
        "regex": "eZ Publish Link Validator",
        "name": "eZ Publish Link Validator",
        "category": "Crawler",
        "url": "https://ez.no/",
        "producer": {
            "name": "eZ Systems AS",
            "url": "https://ez.no/"
        }
    },
    {
        "regex": "woorankreview",
        "name": "WooRank",
        "category": "Search bot",
        "url": "https://www.woorank.com/",
        "producer": {
            "name": "WooRank sprl",
            "url": "https://www.woorank.com/"
        }
    },
    {
        "regex": "Siteimprove",
        "name": "Siteimprove",
        "category": "Search bot",
        "url": "https://siteimprove.com/",
        "producer": {
            "name": "Siteimprove GmbH",
            "url": "https://siteimprove.com/"
        }
    },
    {
        "regex": "CATExplorador",
        "name": "CATExplorador",
        "category": "Search bot",
        "url": "https://fundacio.cat/ca/domini/",
        "producer": {
            "name": "Fundaci\xf3 puntCAT",
            "url": "https://fundacio.cat/ca/domini/"
        }
    },
    {
        "regex": "Buck",
        "name": "Buck",
        "category": "Search bot",
        "url": "https://hypefactors.com/",
        "producer": {
            "name": "Hypefactors A/S",
            "url": "https://hypefactors.com/"
        }
    },
    {
        "regex": "tracemyfile",
        "name": "TraceMyFile",
        "category": "Search bot",
        "url": "https://www.tracemyfile.com/",
        "producer": {
            "name": "Idee Inc.",
            "url": "http://ideeinc.com/"
        }
    },
    {
        "regex": "zelist\\.ro feed parser",
        "name": "Ze List",
        "url": "https://www.zelist.ro/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "Treeworks SRL",
            "url": "https://www.tree.ro/"
        }
    },
    {
        "regex": "weborama-fetcher",
        "name": "Weborama",
        "category": "Search bot",
        "url": "https://weborama.com/",
        "producer": {
            "name": "Weborama SA",
            "url": "https://weborama.com/"
        }
    },
    {
        "regex": "BoardReader Favicon Fetcher",
        "name": "BoardReader",
        "category": "Search bot",
        "url": "https://boardreader.com/",
        "producer": {
            "name": "Effyis Inc",
            "url": "https://boardreader.com/"
        }
    },
    {
        "regex": "IDG/(?:EU|IT|RU|UK)",
        "name": "IDG",
        "category": "Crawler",
        "url": "https://www.spaziodati.eu/",
        "producer": {
            "name": "SpazioDati S.r.l.",
            "url": "https://www.spaziodati.eu/"
        }
    },
    {
        "regex": "Bytespider",
        "name": "Bytespider",
        "category": "Search bot",
        "url": "https://bytedance.com/",
        "producer": {
            "name": "ByteDance Ltd.",
            "url": "https://bytedance.com/"
        }
    },
    {
        "regex": "TikTokSpider",
        "name": "TikTokSpider",
        "category": "Search bot",
        "url": "https://www.tiktok.com/",
        "producer": {
            "name": "TikTok Inc.",
            "url": "https://www.tiktok.com/"
        }
    },
    {
        "regex": "WikiDo",
        "name": "WikiDo",
        "category": "Search bot",
        "url": "https://www.wikido.com/",
        "producer": {
            "name": "Fotolitografie Fiorentine di Becchi Antonio s.n.c.",
            "url": "https://www.wikido.com/"
        }
    },
    {
        "regex": "Awario(?:Smart)?Bot",
        "name": "Awario",
        "category": "Search bot",
        "url": "https://awario.com/bots.html",
        "producer": {
            "name": "TechFusion Ltd.",
            "url": "https://www.techfusion.com.cy/"
        }
    },
    {
        "regex": "AwarioRssBot",
        "name": "Awario",
        "category": "Feed Fetcher",
        "url": "https://awario.com/bots.html",
        "producer": {
            "name": "TechFusion Ltd.",
            "url": "https://www.techfusion.com.cy/"
        }
    },
    {
        "regex": "oBot",
        "name": "oBot",
        "category": "Search bot",
        "url": "https://www.xforce-security.com/crawler/",
        "producer": {
            "name": "IBM Germany Research & Development GmbH",
            "url": "https://exchange.xforce.ibmcloud.com/"
        }
    },
    {
        "regex": "SMTBot",
        "name": "SMTBot",
        "category": "Search bot",
        "url": "https://www.similartech.com/smtbot",
        "producer": {
            "name": "SimilarTech Ltd.",
            "url": "https://www.similartech.com/"
        }
    },
    {
        "regex": "LCC",
        "name": "LCC",
        "category": "Search bot",
        "url": "https://corpora.uni-leipzig.de/crawler_faq.html",
        "producer": {
            "name": "Universit\xe4t Leipzig",
            "url": "https://www.uni-leipzig.de/"
        }
    },
    {
        "regex": "Startpagina-Linkchecker",
        "name": "Startpagina Linkchecker",
        "category": "Search bot",
        "url": "https://www.startpagina.nl/linkchecker",
        "producer": {
            "name": "Startpagina B.V.",
            "url": "https://www.startpagina.nl/"
        }
    },
    {
        "regex": "MoodleBot-Linkchecker",
        "name": "MoodleBot Linkchecker",
        "category": "Search bot",
        "url": "https://docs.moodle.org/en/Usage",
        "producer": {
            "name": "Moodle Pty Ltd",
            "url": "https://moodle.org/"
        }
    },
    {
        "regex": "GTmetrix",
        "name": "GTmetrix",
        "category": "Crawler",
        "url": "https://gtmetrix.com/",
        "producer": {
            "name": "Carbon60 Operating Co. Ltd.",
            "url": "https://www.carbon60.com/"
        }
    },
    {
        "regex": "CyberFind ?Crawler",
        "name": "CyberFind Crawler",
        "category": "Crawler",
        "url": "https://www.cyberfind.net/bot.html",
        "producer": {
            "name": "Find.tf",
            "url": "https://find.tf/"
        }
    },
    {
        "regex": "Nutch",
        "name": "Nutch-based Bot",
        "category": "Crawler",
        "url": "https://nutch.apache.org",
        "producer": {
            "name": "The Apache Software Foundation",
            "url": "https://www.apache.org/foundation/"
        }
    },
    {
        "regex": "Seobility",
        "name": "Seobility",
        "category": "Crawler",
        "url": "https://www.seobility.net/en/faq/?category=crawling#!aboutourbot"
    },
    {
        "regex": "Vercelbot",
        "name": "Vercel Bot",
        "category": "Service bot",
        "url": "https://vercel.com"
    },
    {
        "regex": "Grammarly",
        "name": "Grammarly",
        "category": "Service bot",
        "url": "https://www.grammarly.com"
    },
    {
        "regex": "Robozilla",
        "name": "Robozilla",
        "category": "Crawler"
    },
    {
        "regex": "Domains Project",
        "name": "Domains Project",
        "category": "Crawler",
        "url": "https://domainsproject.org"
    },
    {
        "regex": "PetalBot",
        "name": "Petal Bot",
        "category": "Crawler",
        "url": "https://aspiegel.com/petalbot"
    },
    {
        "regex": "SerendeputyBot",
        "name": "Serendeputy Bot",
        "category": "Crawler",
        "url": "https://serendeputy.com/about/serendeputy-bot"
    },
    {
        "regex": "ias-(?:va|sg).*admantx.*service-fetcher|admantx\\.com.*service-fetcher",
        "name": "ADmantX Service Fetcher",
        "category": "Service bot",
        "url": "https://www.admantx.com/service-fetcher.html"
    },
    {
        "regex": "SemanticScholarBot",
        "name": "Semantic Scholar Bot",
        "category": "Crawler",
        "url": "https://www.semanticscholar.org/crawler"
    },
    {
        "regex": "VelenPublicWebCrawler",
        "name": "Velen Public Web Crawler",
        "category": "Crawler",
        "url": "https://hunter.io/robot"
    },
    {
        "regex": "Barkrowler",
        "name": "Barkrowler",
        "category": "Crawler",
        "url": "http://www.exensa.com/crawl"
    },
    {
        "regex": "BDCbot",
        "name": "BDCbot",
        "category": "Crawler",
        "url": "https://bigweb.bigdatacorp.com.br/pages/faq.aspx",
        "producer": {
            "name": "BIG Data Solucoes Em Tecnologia de Informatica LTDA",
            "url": "https://bigdatacorp.com.br/"
        }
    },
    {
        "regex": "adbeat",
        "name": "Adbeat",
        "category": "Crawler",
        "url": "https://www.adbeat.com/operation_policy",
        "producer": {
            "name": "PPC Labs LLC",
            "url": "https://www.adbeat.com/"
        }
    },
    {
        "regex": "(?:BuiltWith|BW/)",
        "name": "BuiltWith",
        "category": "Crawler",
        "url": "https://builtwith.com/biup",
        "producer": {
            "name": "BuiltWith Pty Ltd",
            "url": "https://builtwith.com/"
        }
    },
    {
        "regex": "https://whatis\\.contentkingapp\\.com",
        "name": "ContentKing",
        "category": "Site Monitor",
        "url": "https://whatis.contentkingapp.com/",
        "producer": {
            "name": "ContentKing BV",
            "url": "https://www.contentkingapp.com/"
        }
    },
    {
        "regex": "MicroAdBot",
        "name": "MicroAdBot",
        "category": "Crawler",
        "url": "https://www.microad.co.jp/",
        "producer": {
            "name": "MicroAd, Inc.",
            "url": "https://www.microad.co.jp/"
        }
    },
    {
        "regex": "PingAdmin\\.Ru",
        "name": "PingAdmin.Ru",
        "category": "Site Monitor",
        "url": "https://ping-admin.ru/"
    },
    {
        "regex": "notifyninja.+monitoring",
        "name": "Notify Ninja",
        "category": "Site Monitor",
        "url": "http://notifyninja.com"
    },
    {
        "regex": "WebDataStats",
        "name": "WebDataStats",
        "category": "Crawler",
        "url": "https://webdatastats.com/policy.html",
        "producer": {
            "name": "WebTehRazrabotka LLC",
            "url": "https://webdatastats.com/"
        }
    },
    {
        "regex": "parse\\.ly scraper",
        "name": "parse.ly",
        "category": "Crawler",
        "url": "https://www.parse.ly/help/integration/crawler",
        "producer": {
            "name": "Parsely, Inc.",
            "url": "https://www.parse.ly/"
        }
    },
    {
        "regex": "Nimbostratus-Bot",
        "name": "Nimbostratus Bot",
        "category": "Site Monitor",
        "url": "http://cloudsystemnetworks.com"
    },
    {
        "regex": "HeartRails_Capture",
        "name": "HeartRails Capture",
        "category": "Service Agent",
        "url": "http://capture.heartrails.com"
    },
    {
        "regex": "Project-Resonance",
        "name": "Project Resonance",
        "category": "Crawler",
        "url": "https://project-resonance.com/",
        "producer": {
            "name": "RedHunt Labs Limited",
            "url": "https://redhuntlabs.com/"
        }
    },
    {
        "regex": "DataXu",
        "name": "DataXu",
        "category": "Service Agent",
        "url": "https://advertising.roku.com/dataxu",
        "producer": {
            "name": "Roku, Inc.",
            "url": "https://roku.com"
        }
    },
    {
        "regex": "Cocolyzebot",
        "name": "Cocolyzebot",
        "category": "Crawler",
        "url": "https://cocolyze.com/en/cocolyzebot",
        "producer": {
            "name": "VSI INNOVATION SAS",
            "url": "https://vsi-innovation.com/"
        }
    },
    {
        "regex": "veryhip",
        "name": "VeryHip",
        "category": "Crawler",
        "url": "https://veryhip.com/",
        "producer": {
            "name": "VeryHip",
            "url": "https://veryhip.com/"
        }
    },
    {
        "regex": "LinkpadBot",
        "name": "LinkpadBot",
        "category": "Crawler",
        "url": "https://www.linkpad.org/",
        "producer": {
            "name": "Solomono LLC",
            "url": "https://www.linkpad.org/"
        }
    },
    {
        "regex": "MuscatFerret",
        "name": "MuscatFerret",
        "category": "Crawler",
        "url": "http://www.webtop.com/"
    },
    {
        "regex": "PageThing\\.com",
        "name": "PageThing",
        "category": "Crawler",
        "url": "https://www.pagething.com/",
        "producer": {
            "name": "SPECIALNOISE LTD",
            "url": "https://www.specialnoise.com/"
        }
    },
    {
        "regex": "ArchiveBox",
        "name": "ArchiveBox",
        "url": "https://archivebox.io/",
        "category": "Crawler",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Choosito",
        "name": "Choosito",
        "url": "https://www.choosito.com/",
        "category": "Crawler",
        "producer": {
            "name": "Choosito! Inc.",
            "url": "https://www.choosito.com/"
        }
    },
    {
        "regex": "datagnionbot",
        "name": "datagnionbot",
        "url": "https://www.datagnion.com/bot.html",
        "category": "Crawler",
        "producer": {
            "name": "DATAGNION GMBH",
            "url": "https://www.datagnion.com/"
        }
    },
    {
        "regex": "WhatCMS",
        "name": "WhatCMS",
        "url": "https://whatcms.org/",
        "category": "Crawler",
        "producer": {
            "name": "Nineteen Ten LLC",
            "url": "https://whatcms.org/"
        }
    },
    {
        "regex": "httpx",
        "name": "httpx",
        "url": "https://github.com/projectdiscovery/httpx",
        "category": "Crawler",
        "producer": {
            "name": "ProjectDiscovery, Inc.",
            "url": "https://projectdiscovery.io/"
        }
    },
    {
        "regex": ".*\\.oast\\.",
        "name": "Interactsh",
        "category": "Security Checker",
        "url": "https://github.com/projectdiscovery/interactsh",
        "producer": {
            "name": "ProjectDiscovery, Inc.",
            "url": "https://projectdiscovery.io/"
        }
    },
    {
        "regex": "(?:expanseinc|paloaltonetworks)\\.com",
        "name": "Cortex Xpanse",
        "category": "Security Checker",
        "url": "https://docs-cortex.paloaltonetworks.com/r/1/Cortex-Xpanse/Scanning-activity",
        "producer": {
            "name": "Palo Alto Networks, Inc.",
            "url": "https://www.paloaltonetworks.com/"
        }
    },
    {
        "regex": "HuaweiWebCatBot",
        "name": "HuaweiWebCatBot",
        "category": "Crawler",
        "url": "https://isecurity.huawei.com",
        "producer": {
            "name": "Huawei Technologies Co., Ltd.",
            "url": "https://huawei.com"
        }
    },
    {
        "regex": "Hatena-Favicon",
        "name": "Hatena Favicon",
        "category": "Crawler",
        "url": "https://www.hatena.ne.jp/faq/",
        "producer": {
            "name": "Hatena Co., Ltd.",
            "url": "https://www.hatena.ne.jp"
        }
    },
    {
        "regex": "Hatena-?Bookmark",
        "name": "Hatena Bookmark",
        "category": "Crawler",
        "url": "https://www.hatena.ne.jp/faq/",
        "producer": {
            "name": "Hatena Co., Ltd.",
            "url": "https://www.hatena.ne.jp"
        }
    },
    {
        "regex": "RyowlEngine",
        "name": "Ryowl",
        "category": "Crawler",
        "url": "https://ryowl.org"
    },
    {
        "regex": "OdklBot",
        "name": "Odnoklassniki Bot",
        "category": "Crawler",
        "url": "https://odnoklassniki.ru"
    },
    {
        "regex": "Mediatoolkitbot",
        "name": "Mediatoolkit Bot",
        "category": "Crawler",
        "url": "https://mediatoolkit.com"
    },
    {
        "regex": "ZoominfoBot",
        "name": "ZoominfoBot",
        "category": "Crawler",
        "url": "https://www.zoominfo.com"
    },
    {
        "regex": "WeViKaBot",
        "name": "WeViKaBot",
        "category": "Crawler",
        "url": "http://www.wevika.de"
    },
    {
        "regex": "SEOkicks",
        "name": "SEOkicks",
        "category": "Crawler",
        "url": "https://www.seokicks.de/robot.html",
        "producer": {
            "name": "SEOkicks",
            "url": "https://www.seokicks.de/"
        }
    },
    {
        "regex": "Plukkie",
        "name": "Plukkie",
        "category": "Crawler",
        "url": "http://www.botje.com/plukkie.htm"
    },
    {
        "regex": "proximic;",
        "name": "Comscore",
        "category": "Crawler",
        "url": "https://www.comscore.com/Web-Crawler"
    },
    {
        "regex": "SurdotlyBot",
        "name": "SurdotlyBot",
        "category": "Crawler",
        "url": "http://sur.ly/bot.html"
    },
    {
        "regex": "Gowikibot",
        "name": "Gowikibot",
        "category": "Crawler",
        "url": "http:/www.gowikibot.com"
    },
    {
        "regex": "SabsimBot",
        "name": "SabsimBot",
        "category": "Crawler",
        "url": "https://sabsim.com"
    },
    {
        "regex": "LumtelBot",
        "name": "LumtelBot",
        "category": "Crawler",
        "url": "https://lumtel.com"
    },
    {
        "regex": "PiplBot",
        "name": "PiplBot",
        "category": "Crawler",
        "url": "http://www.pipl.com/bot"
    },
    {
        "regex": "woobot",
        "name": "WooRank",
        "category": "Crawler",
        "url": "https://www.woorank.com/bot"
    },
    {
        "regex": "Cookiebot",
        "name": "Cookiebot",
        "category": "Crawler",
        "url": "https://support.cookiebot.com/hc/en-us/articles/360014264140-Scanner-User-Agent",
        "producer": {
            "name": "Cybot A/S",
            "url": "https://www.cybot.com/"
        }
    },
    {
        "regex": "NetSystemsResearch",
        "name": "NetSystemsResearch",
        "category": "Security Checker",
        "url": "https://www.netsystemsresearch.com/",
        "producer": {
            "name": "NET SYSTEMS RESEARCH LLC",
            "url": "https://www.netsystemsresearch.com/"
        }
    },
    {
        "regex": "CensysInspect",
        "name": "CensysInspect",
        "category": "Security Checker",
        "url": "https://about.censys.io/",
        "producer": {
            "name": "Censys, Inc.",
            "url": "https://censys.io/"
        }
    },
    {
        "regex": "gdnplus\\.com",
        "name": "GDNP",
        "category": "Crawler",
        "url": "https://gdnplus.com/",
        "producer": {
            "name": "Global Digital Network Plus, LLC",
            "url": "https://gdnplus.com/"
        }
    },
    {
        "regex": "WellKnownBot",
        "name": "WellKnownBot",
        "category": "Crawler",
        "url": "https://well-known.dev"
    },
    {
        "regex": "Adsbot",
        "name": "Adsbot",
        "category": "Crawler",
        "url": "https://seostar.co/robot/"
    },
    {
        "regex": "MTRobot",
        "name": "MTRobot",
        "category": "Crawler",
        "url": "https://metrics-tools.de/robot.html",
        "producer": {
            "name": "Metrics Tools",
            "url": "https://metrics-tools.de/"
        }
    },
    {
        "regex": "serpstatbot",
        "name": "serpstatbot",
        "category": "Crawler",
        "url": "http://serpstatbot.com/",
        "producer": {
            "name": "Netpeak Ltd",
            "url": "https://netpeak.net/"
        }
    },
    {
        "regex": "colly",
        "name": "colly",
        "category": "Crawler",
        "url": "https://github.com/gocolly/colly/"
    },
    {
        "regex": "l9tcpid",
        "name": "l9tcpid",
        "category": "Security Checker",
        "url": "https://github.com/LeakIX/l9tcpid"
    },
    {
        "regex": "l9explore",
        "name": "l9explore",
        "category": "Security Checker",
        "url": "https://github.com/LeakIX/l9explore"
    },
    {
        "regex": "l9scan/|^Lkx-.*/",
        "name": "LeakIX",
        "category": "Security Checker",
        "url": "https://leakix.net/",
        "producer": {
            "name": "BaDaaS SRL",
            "url": "https://leakix.net/"
        }
    },
    {
        "regex": "MegaIndex\\.ru",
        "name": "MegaIndex",
        "category": "Crawler",
        "url": "https://megaindex.com/crawler"
    },
    {
        "regex": "Seekport",
        "name": "Seekport",
        "category": "Crawler",
        "url": "https://bot.seekport.com/",
        "producer": {
            "name": "SISTRIX GmbH",
            "url": "https://www.sistrix.de/"
        }
    },
    {
        "regex": "Seolyt(?:Bot)?",
        "name": "SeolytBot",
        "category": "Crawler",
        "url": "https://seolyt.com/"
    },
    {
        "regex": "YaK/",
        "name": "YaK",
        "category": "Crawler",
        "url": "https://www.linkfluence.com/",
        "producer": {
            "name": "Linkfluence SAS",
            "url": "https://www.linkfluence.com/"
        }
    },
    {
        "regex": "KomodiaBot",
        "name": "KomodiaBot",
        "category": "Crawler",
        "url": "http://www.komodia.com/newwiki/index.php/URL_server_crawler",
        "producer": {
            "name": "Komodia Inc.",
            "url": "https://www.komodia.com/"
        }
    },
    {
        "regex": "KStandBot",
        "name": "KStandBot",
        "category": "Crawler",
        "url": "https://url-classification.io/wiki/index.php?title=URL_server_crawler",
        "producer": {
            "name": "Komodia Inc.",
            "url": "https://www.komodia.com/"
        }
    },
    {
        "regex": "Neevabot",
        "name": "Neevabot",
        "category": "Search bot",
        "url": "https://neeva.com/neevabot",
        "producer": {
            "name": "Neeva Inc.",
            "url": "https://neeva.com/"
        }
    },
    {
        "regex": "Chatwork LinkPreview",
        "name": "Chatwork LinkPreview",
        "category": "Service Agent",
        "url": "https://go.chatwork.com/en/",
        "producer": {
            "name": "kubell Co., Ltd.",
            "url": "https://www.kubell.com/en/"
        }
    },
    {
        "regex": "LinkPreview",
        "name": "LinkPreview",
        "category": "Service Agent",
        "url": "https://www.linkpreview.net/"
    },
    {
        "regex": "JungleKeyThumbnail",
        "name": "JungleKeyThumbnail",
        "category": "Crawler",
        "url": "https://junglekey.com/"
    },
    {
        "regex": "rocketmonitor(?:bot)?",
        "name": "RocketMonitorBot",
        "category": "Site Monitor",
        "url": "https://www.radiomast.io/docs/stream-monitoring/technical_details.html",
        "producer": {
            "name": "Radio Mast, Inc.",
            "url": "https://www.radiomast.io/"
        }
    },
    {
        "regex": "SitemapParser-VIPnytt",
        "name": "SitemapParser-VIPnytt",
        "category": "Crawler",
        "url": "https://github.com/VIPnytt/SitemapParser/"
    },
    {
        "regex": "^Turnitin",
        "name": "Turnitin",
        "category": "Crawler",
        "url": "https://turnitin.com/robot/crawlerinfo.html"
    },
    {
        "regex": "DMBrowser|DMBrowser-[UB]V",
        "name": "Dotcom Monitor",
        "category": "Site Monitor",
        "url": "https://www.dotcom-monitor.com"
    },
    {
        "regex": "ThinkChaos/",
        "name": "ThinkChaos",
        "category": "Crawler"
    },
    {
        "regex": "Thinkbot/",
        "name": "Thinkbot",
        "category": "Crawler"
    },
    {
        "regex": "DataForSeoBot",
        "name": "DataForSeoBot",
        "category": "Crawler",
        "url": "https://dataforseo.com/dataforseo-bot"
    },
    {
        "regex": "Discordbot",
        "name": "Discord Bot",
        "category": "Service Agent",
        "url": "https://discordapp.com"
    },
    {
        "regex": "Linespider",
        "name": "Linespider",
        "category": "Crawler",
        "url": "https://lin.ee/4dwXkTH"
    },
    {
        "regex": "Cincraw",
        "name": "Cincraw",
        "category": "Crawler",
        "url": "http://cincrawdata.net/bot/"
    },
    {
        "regex": "CISPA Web Analyzer",
        "name": "CISPA Web Analyzer",
        "category": "Crawler",
        "url": "https://notify.cispa.de/",
        "producer": {
            "name": "CISPA - Helmholtz-Zentrum f\xfcr Informationssicherheit gGmbH",
            "url": "https://cispa.de/en"
        }
    },
    {
        "regex": "IonCrawl",
        "name": "IONOS Crawler",
        "category": "Crawler",
        "url": "https://www.ionos.de/terms-gtc/faq-crawler-en/",
        "producer": {
            "name": "IONOS SE",
            "url": "https://www.ionos.de/"
        }
    },
    {
        "regex": "Crawldad",
        "name": "Crawldad",
        "category": "Crawler",
        "url": "https://gist.github.com/jayhardee9/2f2a2c4dba26564ee040ae32e0dd0972"
    },
    {
        "regex": "https://securitytxt-scan\\.cs\\.hm\\.edu/",
        "name": "security.txt scanserver",
        "category": "Security Checker",
        "url": "https://securitytxt-scan.cs.hm.edu/",
        "producer": {
            "name": "Hochschule f\xfcr angewandte Wissenschaften M\xfcnchen",
            "url": "https://www.hm.edu/"
        }
    },
    {
        "regex": "TigerBot",
        "name": "TigerBot",
        "category": "Crawler",
        "url": "https://tiger.ch/"
    },
    {
        "regex": "TestCrawler",
        "name": "TestCrawler",
        "category": "Crawler",
        "url": "https://www.comcepta.com/"
    },
    {
        "regex": "CrowdTanglebot",
        "name": "CrowdTangle",
        "category": "Crawler",
        "url": "https://help.crowdtangle.com/en/articles/3009319-crowdtangle-bot",
        "producer": {
            "name": "CrowdTangle, Inc.",
            "url": "https://www.crowdtangle.com/"
        }
    },
    {
        "regex": "Sellers\\.Guide Crawler by Primis",
        "name": "Sellers.Guide",
        "category": "Crawler",
        "url": "https://sellers.guide/",
        "producer": {
            "name": "McCann Disciplines, Ltd.",
            "url": "https://www.primis.tech/"
        }
    },
    {
        "regex": "OnalyticaBot",
        "name": "Onalytica",
        "category": "Crawler",
        "url": "https://www.airslate.com/bot/explore/onalytica-bot",
        "producer": {
            "name": "airSlate, Inc.",
            "url": "https://www.airslate.com/"
        }
    },
    {
        "regex": "deepnoc",
        "name": "deepnoc",
        "category": "Crawler",
        "url": "https://deepnoc.com/bot",
        "producer": {
            "name": "deepnoc, GmbH",
            "url": "https://deepnoc.com/"
        }
    },
    {
        "regex": "Newslitbot",
        "name": "Newslitbot",
        "category": "Crawler",
        "url": "https://www.newslit.co/",
        "producer": {
            "name": "Newslit, LLC.",
            "url": "https://www.newslit.co/"
        }
    },
    {
        "regex": "um-(?:ANS|CC|FC|IC|LN)",
        "name": "uMBot",
        "category": "Crawler",
        "url": "https://www.ubermetrics-technologies.com/",
        "producer": {
            "name": "Ubermetrics Technologies GmbH",
            "url": "https://www.ubermetrics-technologies.com/"
        }
    },
    {
        "regex": "Abonti",
        "name": "Abonti",
        "category": "Crawler",
        "url": "http://abonti.com/"
    },
    {
        "regex": "collection@infegy\\.com",
        "name": "Infegy",
        "category": "Crawler",
        "url": "https://infegy.com/",
        "producer": {
            "name": "Infegy, Inc.",
            "url": "https://infegy.com/"
        }
    },
    {
        "regex": "HTTP Banner Detection \\(https://security\\.ipip\\.net\\)",
        "name": "IPIP",
        "category": "Security Checker",
        "url": "https://security.ipip.net/",
        "producer": {
            "name": "Beijing Tiantexin Tech. Co., Ltd.",
            "url": "https://en.ipip.net/"
        }
    },
    {
        "regex": "ev-crawler",
        "name": "Headline",
        "category": "Crawler",
        "url": "https://headline.com/legal/crawler",
        "producer": {
            "name": "e.ventures Managementgesellschaft mbH",
            "url": "https://headline.com/"
        }
    },
    {
        "regex": "webprosbot",
        "name": "WebPros",
        "category": "Crawler",
        "url": "https://webpros.com/",
        "producer": {
            "name": "WebPros Holdco B.V.",
            "url": "https://webpros.com/"
        }
    },
    {
        "regex": "ELB-HealthChecker",
        "name": "Amazon ELB",
        "category": "Site Monitor",
        "url": "https://aws.amazon.com/elasticloadbalancing/",
        "producer": {
            "name": "Amazon.com, Inc.",
            "url": "https://www.amazon.com/"
        }
    },
    {
        "regex": "Wheregoes\\.com Redirect Checker",
        "name": "WhereGoes",
        "category": "Crawler",
        "url": "https://wheregoes.com/"
    },
    {
        "regex": "project_patchwatch",
        "name": "Project Patchwatch",
        "category": "Crawler",
        "url": "http://66.240.192.82/"
    },
    {
        "regex": "InternetMeasurement",
        "name": "InternetMeasurement",
        "category": "Crawler",
        "url": "https://internet-measurement.com/"
    },
    {
        "regex": "DomainAppender",
        "name": "DomainAppender",
        "category": "Crawler",
        "url": "https://www.profound.net/product/domain_append/",
        "producer": {
            "name": "Profound Networks, LLC",
            "url": "https://www.profound.net/"
        }
    },
    {
        "regex": "FreeWebMonitoring SiteChecker",
        "name": "FreeWebMonitoring",
        "category": "Site Monitor",
        "url": "https://www.freewebmonitoring.com/bot.html",
        "producer": {
            "name": "GreenWave Online, Inc.",
            "url": "http://www.greenwaveonline.com/"
        }
    },
    {
        "regex": "Page Modified Pinger",
        "name": "Page Modified Pinger",
        "category": "Site Monitor",
        "url": "https://www.pagemodified.com/",
        "producer": {
            "name": "Valley Hosting, LLC",
            "url": "https://www.pagemodified.com/"
        }
    },
    {
        "regex": "adstxtlab\\.com",
        "name": "adstxtlab.com",
        "category": "Crawler",
        "url": "https://adstxtlab.com/validator.php",
        "producer": {
            "name": "Jaohawi AB",
            "url": "https://adstxtlab.com/"
        }
    },
    {
        "regex": "Iframely",
        "name": "Iframely",
        "category": "Crawler",
        "url": "https://iframely.com/",
        "producer": {
            "name": "Itteco Software, Corp.",
            "url": "https://iframely.com/"
        }
    },
    {
        "regex": "DomainStatsBot",
        "name": "DomainStatsBot",
        "category": "Crawler",
        "url": "https://domainstats.com/pages/our-bot",
        "producer": {
            "name": "Domainstats Ltd",
            "url": "https://domainstats.com/"
        }
    },
    {
        "regex": "aiHitBot",
        "name": "aiHitBot",
        "category": "Crawler",
        "url": "https://www.aihitdata.com/about"
    },
    {
        "regex": "DomainCrawler/",
        "name": "DomainCrawler",
        "category": "Crawler",
        "url": "https://domaincrawler.com/about-us/"
    },
    {
        "regex": "DNSResearchBot",
        "name": "DNSResearchBot",
        "category": "Crawler"
    },
    {
        "regex": "GitCrawlerBot",
        "name": "GitCrawlerBot",
        "category": "Crawler"
    },
    {
        "regex": "AdAuth",
        "name": "AdAuth",
        "category": "Crawler",
        "url": "https://www.adauth.com"
    },
    {
        "regex": "faveeo\\.com",
        "name": "Faveeo",
        "category": "Crawler",
        "url": "http://www.faveeo.com"
    },
    {
        "regex": "kozmonavt\\.",
        "name": "Kozmonavt",
        "category": "Crawler",
        "url": "https://kozmonavt.ml"
    },
    {
        "regex": "CriteoBot/",
        "name": "CriteoBot",
        "category": "Crawler",
        "url": "https://www.criteo.com/criteo-crawler/"
    },
    {
        "regex": "PayPal IPN",
        "name": "PayPal IPN",
        "category": "Service Agent",
        "url": "https://developer.paypal.com/api/nvp-soap/ipn/IPNIntro/",
        "producer": {
            "name": "PayPal, Inc.",
            "url": "https://www.paypal.com/"
        }
    },
    {
        "regex": "MaCoCu",
        "name": "MaCoCu",
        "category": "Crawler",
        "url": "https://www.clarin.si/info/macocu-massive-collection-and-curation-of-monolingual-and-bilingual-data/",
        "producer": {
            "name": "Jo\u017Eef Stefan Institute",
            "url": "https://www.ijs.si/ijsw/JSI"
        }
    },
    {
        "regex": "CLASSLA",
        "name": "CLASSLA-web",
        "category": "Crawler",
        "url": "https://www.clarin.si/info/classla-web-crawler/",
        "producer": {
            "name": "Jo\u017Eef Stefan Institute",
            "url": "https://www.ijs.si/ijsw/JSI"
        }
    },
    {
        "regex": "dnt-policy@eff\\.org",
        "name": "EFF Do Not Track Verifier",
        "category": "Crawler",
        "url": "https://www.eff.org/issues/do-not-track",
        "producer": {
            "name": "Electronic Frontier Foundation",
            "url": "https://www.eff.org/"
        }
    },
    {
        "regex": "InfoTigerBot",
        "name": "InfoTigerBot",
        "category": "Crawler",
        "url": "https://infotiger.com/bot",
        "producer": {
            "name": "Infotiger UG",
            "url": "https://infotiger.com/"
        }
    },
    {
        "regex": "(?:Birdcrawlerbot|CrawlaDeBot)",
        "name": "Birdcrawlerbot",
        "category": "Crawler",
        "url": "https://crawla.de/de/index.php",
        "producer": {
            "name": "Swoppen Systems GmbH",
            "url": "https://www.swoppen.com/de"
        }
    },
    {
        "regex": "ScamadviserExternalHit",
        "name": "Scamadviser External Hit",
        "category": "Crawler",
        "url": "https://www.scamadviser.com/",
        "producer": {
            "name": "Ecommerce Operations B.V.",
            "url": "https://www.scamadviser.com/"
        }
    },
    {
        "regex": "ZaldamoSearchBot",
        "name": "Zaldamo",
        "category": "Crawler",
        "url": "https://www.zaldamo.com/search.html",
        "producer": {
            "name": "Zaldamo, LLC.",
            "url": "https://www.zaldamo.com/"
        }
    },
    {
        "regex": "AFB",
        "name": "Allloadin Favicon Bot",
        "category": "Crawler",
        "url": "https://allloadin.com/"
    },
    {
        "regex": "LinkWalker",
        "name": "LinkWalker",
        "category": "Crawler",
        "url": "https://www.phishlabs.com/",
        "producer": {
            "name": "PhishLabs, Inc.",
            "url": "https://www.phishlabs.com/"
        }
    },
    {
        "regex": "RenovateBot",
        "name": "RenovateBot",
        "category": "Security Checker",
        "url": "https://github.com/renovatebot/renovate",
        "producer": {
            "name": "White Source Ltd.",
            "url": "https://www.mend.io/free-developer-tools/renovate/"
        }
    },
    {
        "regex": "INETDEX-BOT",
        "name": "Inetdex Bot",
        "category": "Crawler",
        "url": "https://www.inetdex.com/"
    },
    {
        "regex": "NETZZAPPEN",
        "name": "NETZZAPPEN",
        "category": "Crawler",
        "url": "https://www.netzzappen.com/",
        "producer": {
            "name": "Marc Huemer",
            "url": "https://www.netzzappen.com/"
        }
    },
    {
        "regex": "panscient\\.com",
        "name": "Panscient",
        "category": "Crawler",
        "url": "https://www.panscient.com/faq.htm",
        "producer": {
            "name": "Panscient, Inc.",
            "url": "https://www.panscient.com/"
        }
    },
    {
        "regex": "research@pdrlabs\\.net",
        "name": "PDR Labs",
        "category": "Security Checker",
        "url": "https://web.archive.org/web/20220420054123/http://www.pdrlabs.net/",
        "producer": {
            "name": "PDR Labs",
            "url": "https://web.archive.org/web/20220420054123/http://www.pdrlabs.net/"
        }
    },
    {
        "regex": "Nicecrawler",
        "name": "NiceCrawler",
        "category": "Crawler",
        "url": "https://www.nicecrawler.com/",
        "producer": {
            "name": "Intelium Corp.",
            "url": "https://www.intelium.com/"
        }
    },
    {
        "regex": "t3versionsBot",
        "name": "t3versions",
        "category": "Crawler",
        "url": "https://www.t3versions.com/bot",
        "producer": {
            "name": "Torben Hansen",
            "url": "https://www.t3versions.com/"
        }
    },
    {
        "regex": "Crawlson",
        "name": "Crawlson",
        "category": "Crawler",
        "url": "https://www.crawlson.com/about",
        "producer": {
            "name": "Crawlson",
            "url": "https://www.crawlson.com/"
        }
    },
    {
        "regex": "tchelebi",
        "name": "tchelebi",
        "category": "Crawler",
        "url": "https://tchelebi.io/",
        "producer": {
            "name": "NormShield, Inc.",
            "url": "https://blackkite.com/"
        }
    },
    {
        "regex": "JobboerseBot",
        "name": "JobboerseBot",
        "category": "Crawler",
        "url": "https://www.xing.com/jobs",
        "producer": {
            "name": "New Work SE",
            "url": "https://www.xing.com/"
        }
    },
    {
        "regex": "RepoLookoutBot",
        "name": "Repo Lookout",
        "category": "Security Checker",
        "url": "https://www.repo-lookout.org/",
        "producer": {
            "name": "Crissy Field GmbH",
            "url": "https://www.crissyfield.de/"
        }
    },
    {
        "regex": "PATHspider",
        "name": "PATHspider",
        "category": "Security Checker",
        "url": "https://pathspider.net/",
        "producer": {
            "name": "MAMI Project",
            "url": "https://mami-project.eu/"
        }
    },
    {
        "regex": "everyfeed-spider",
        "name": "Everyfeed",
        "url": "https://web.archive.org/web/20050930235914/http://www.everyfeed.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Exchange check",
        "name": "Exchange check",
        "category": "Security Checker",
        "url": "https://github.com/GossiTheDog/scanning",
        "producer": {
            "name": "Kevin Beaumont",
            "url": "https://doublepulsar.com/"
        }
    },
    {
        "regex": "Sublinq",
        "name": "Sublinq",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20220626191617/https://sublinq.com/",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "Gregarius",
        "name": "Gregarius",
        "category": "Feed Fetcher",
        "url": "https://web.archive.org/web/20100614011837/http://devlog.gregarius.net/docs/ua/",
        "producer": {
            "name": "",
            "url": ""
        }
    },
    {
        "regex": "COMODO DCV",
        "name": "COMODO DCV",
        "category": "Service Agent",
        "url": "https://www.comodo.com/",
        "producer": {
            "name": "Comodo Security Solutions, Inc.",
            "url": "https://www.comodo.com/"
        }
    },
    {
        "regex": "Sectigo DCV|acme\\.sectigo\\.com",
        "name": "Sectigo DCV",
        "category": "Service Agent",
        "url": "https://sectigo.com/",
        "producer": {
            "name": "Sectigo Limited",
            "url": "https://sectigo.com/"
        }
    },
    {
        "regex": "KlarnaBot-(?:DownloadProductImage|EnrichProducts|PriceWatcher)",
        "name": "KlarnaBot",
        "category": "Crawler",
        "url": "https://docs.klarna.com/klarna-bot/",
        "producer": {
            "name": "Klarna Bank AB",
            "url": "https://www.klarna.com/"
        }
    },
    {
        "regex": "Taboolabot",
        "name": "Taboolabot",
        "category": "Crawler",
        "url": "https://help.taboola.com/hc/en-us/articles/115002347594-The-Taboola-Crawler",
        "producer": {
            "name": "Taboola, Inc.",
            "url": "https://www.taboola.com/"
        }
    },
    {
        "regex": "Asana",
        "name": "Asana",
        "category": "Crawler",
        "url": "https://asana.com/",
        "producer": {
            "name": "Asana, Inc.",
            "url": "https://asana.com/"
        }
    },
    {
        "regex": "Chrome Privacy Preserving Prefetch Proxy",
        "name": "Chrome Privacy Preserving Prefetch Proxy",
        "category": "Service Agent",
        "url": "https://developer.chrome.com/blog/private-prefetch-proxy/",
        "producer": {
            "name": "Google Inc.",
            "url": "https://www.google.com/"
        }
    },
    {
        "regex": "URLinspectorBot",
        "name": "URLinspector",
        "category": "Site Monitor",
        "url": "https://www.urlinspector.com/bot/",
        "producer": {
            "name": "LinkResearchTools GmbH",
            "url": "https://www.linkresearchtools.com/"
        }
    },
    {
        "regex": "EntferBot",
        "name": "Entfer",
        "category": "Crawler",
        "url": "https://entfer.com/",
        "producer": {
            "name": "Entfer Ltd.",
            "url": "https://entfer.com/"
        }
    },
    {
        "regex": "TagInspector",
        "name": "Tag Inspector",
        "category": "Crawler",
        "url": "https://taginspector.com/",
        "producer": {
            "name": "InfoTrust, LLC",
            "url": "https://infotrust.com/"
        }
    },
    {
        "regex": "pageburst",
        "name": "Pageburst",
        "category": "Crawler",
        "url": "https://pageburstls.elsevier.com/",
        "producer": {
            "name": "Elsevier Ltd",
            "url": "https://www.elsevier.com/"
        }
    },
    {
        "regex": ".+diffbot",
        "name": "Diffbot",
        "category": "Crawler",
        "url": "https://docs.diffbot.com/docs/getting-started-with-crawl",
        "producer": {
            "name": "Diffbot Technologies Corp.",
            "url": "https://www.diffbot.com/"
        }
    },
    {
        "regex": "DisqusAdstxtCrawler",
        "name": "Disqus",
        "category": "Crawler",
        "url": "https://help.disqus.com/en/articles/1765357-ads-txt-implementation-guide",
        "producer": {
            "name": "Disqus, Inc.",
            "url": "https://disqus.com/"
        }
    },
    {
        "regex": "startmebot",
        "name": "start.me",
        "category": "Crawler",
        "url": "https://about.start.me/",
        "producer": {
            "name": "start.me BV",
            "url": "https://about.start.me/"
        }
    },
    {
        "regex": "2ip bot",
        "name": "2ip",
        "category": "Crawler",
        "url": "https://2ip.io/"
    },
    {
        "regex": "ReqBin Curl Client",
        "name": "ReqBin",
        "category": "Crawler",
        "url": "https://reqbin.com/curl"
    },
    {
        "regex": "XoviBot",
        "name": "XoviBot",
        "category": "Crawler",
        "url": "https://www.xovibot.net",
        "producer": {
            "name": "Xovi GmbH",
            "url": "http://www.xovi.de"
        }
    },
    {
        "regex": "Overcast/.+Podcast Sync",
        "name": "Overcast Podcast Sync",
        "category": "Service Agent",
        "url": "https://overcast.fm/podcasterinfo"
    },
    {
        "regex": "^Verity",
        "name": "GumGum Verity",
        "category": "Service Agent",
        "url": "https://gumgum.com/verity"
    },
    {
        "regex": "hackermention",
        "name": "hackermention",
        "category": "Feed Reader",
        "url": "https://github.com/snarfed/hackermention"
    },
    {
        "regex": "BitSightBot",
        "name": "BitSight",
        "category": "Security Checker",
        "url": "https://www.bitsight.com/",
        "producer": {
            "name": "BitSight Technologies, Inc.",
            "url": "https://www.bitsight.com/"
        }
    },
    {
        "regex": "Ezgif",
        "name": "Ezgif",
        "category": "Service Agent",
        "url": "https://ezgif.com/about"
    },
    {
        "regex": "intelx\\.io_bot",
        "name": "Intelligence X",
        "category": "Crawler",
        "url": "https://intelx.io/",
        "producer": {
            "name": "Kleissner Investments s.r.o.",
            "url": "https://intelx.io/"
        }
    },
    {
        "regex": "FemtosearchBot",
        "name": "Femtosearch",
        "category": "Crawler",
        "url": "http://femtosearch.com/",
        "producer": {
            "name": "Grier Forensics, LLC",
            "url": "https://www.grierforensics.com/"
        }
    },
    {
        "regex": "AdsTxtCrawler/",
        "name": "AdsTxtCrawler",
        "category": "Crawler",
        "url": "https://github.com/InteractiveAdvertisingBureau/adstxtcrawler",
        "producer": {
            "name": "IAB Technology Laboratory, Inc.",
            "url": "https://iabtechlab.com/"
        }
    },
    {
        "regex": "Morningscore",
        "name": "Morningscore Bot",
        "category": "Crawler",
        "url": "https://morningscore.io/",
        "producer": {
            "name": "Morningscore",
            "url": "https://morningscore.io/"
        }
    },
    {
        "regex": "Uptime-Kuma",
        "name": "Uptime-Kuma",
        "category": "Site Monitor",
        "url": "https://github.com/louislam/uptime-kuma"
    },
    {
        "regex": "OAI-SearchBot",
        "name": "OAI-SearchBot",
        "category": "Crawler",
        "url": "https://platform.openai.com/docs/bots",
        "producer": {
            "name": "OpenAI OpCo, LLC",
            "url": "https://openai.com/"
        }
    },
    {
        "regex": "GPTBot",
        "name": "GPTBot",
        "category": "Crawler",
        "url": "https://platform.openai.com/docs/bots",
        "producer": {
            "name": "OpenAI OpCo, LLC",
            "url": "https://openai.com/"
        }
    },
    {
        "regex": "ChatGPT-User",
        "name": "ChatGPT-User",
        "category": "Crawler",
        "url": "https://platform.openai.com/docs/bots",
        "producer": {
            "name": "OpenAI OpCo, LLC",
            "url": "https://openai.com/"
        }
    },
    {
        "regex": "BrightEdge Crawler",
        "name": "BrightEdge",
        "category": "Crawler",
        "url": "https://www.brightedge.com/",
        "producer": {
            "name": "BrightEdge Technologies, Inc",
            "url": "https://www.brightedge.com/"
        }
    },
    {
        "regex": "sfFeedReader",
        "name": "sfFeedReader",
        "url": "https://github.com/diem-project/sfFeed2Plugin",
        "category": "Feed Fetcher"
    },
    {
        "regex": "cyberscan\\.io",
        "name": "Cyberscan",
        "category": "Security Checker",
        "url": "https://www.cyberscan.io/",
        "producer": {
            "name": "DGC Verwaltungs GmbH",
            "url": "https://dgc.org/"
        }
    },
    {
        "regex": "researchscan\\.comsys\\.rwth-aachen\\.de",
        "name": "Research Scan",
        "category": "Crawler",
        "url": "http://researchscan.comsys.rwth-aachen.de/",
        "producer": {
            "name": "RWTH Aachen University",
            "url": "https://www.comsys.rwth-aachen.de/"
        }
    },
    {
        "regex": "newspaper",
        "name": "Scraping Robot",
        "category": "Crawler",
        "url": "https://scrapingrobot.com/",
        "producer": {
            "name": "Sprious LLC",
            "url": "https://sprious.com/"
        }
    },
    {
        "regex": "Ant(?:\\.com beta|Bot)",
        "name": "Ant",
        "category": "Crawler",
        "url": "https://www.ant.com/",
        "producer": {
            "name": "Ant.com Ltd.",
            "url": "https://www.ant.com/"
        }
    },
    {
        "regex": "WebwikiBot",
        "name": "Webwiki",
        "category": "Crawler",
        "url": "https://www.webwiki.com/",
        "producer": {
            "name": "webwiki GmbH",
            "url": "https://www.webwiki.com/"
        }
    },
    {
        "regex": "phpMyAdmin",
        "name": "phpMyAdmin",
        "category": "Service Agent",
        "url": "https://www.phpmyadmin.net/"
    },
    {
        "regex": "Matomo/[\\d.]+",
        "name": "Matomo",
        "category": "Service Agent",
        "url": "https://github.com/matomo-org/matomo",
        "producer": {
            "name": "InnoCraft Ltd",
            "url": "https://matomo.org/"
        }
    },
    {
        "regex": "Prometheus",
        "name": "Prometheus",
        "category": "Service Agent",
        "url": "https://github.com/prometheus/prometheus",
        "producer": {
            "name": "The Linux Foundation",
            "url": "https://www.cncf.io/"
        }
    },
    {
        "regex": "ArchiveTeam ArchiveBot",
        "name": "ArchiveBot",
        "category": "Crawler",
        "url": "https://wiki.archiveteam.org/index.php?title=ArchiveBot",
        "producer": {
            "name": "ArchiveTeam",
            "url": "https://wiki.archiveteam.org/"
        }
    },
    {
        "regex": "MADBbot",
        "name": "MADBbot",
        "category": "Crawler",
        "url": "https://madb.zapto.org/bot.html"
    },
    {
        "regex": "MeltwaterNews",
        "name": "MeltwaterNews",
        "category": "Crawler",
        "producer": {
            "name": "Meltwater Deutschland GmbH",
            "url": "https://www.meltwater.com/"
        }
    },
    {
        "regex": "owler",
        "name": "OWLer",
        "category": "Crawler",
        "url": "https://openwebsearch.eu/owler/",
        "producer": {
            "name": "Open Search Foundation e.V.",
            "url": "https://openwebsearch.eu/"
        }
    },
    {
        "regex": "bbc\\.co\\.uk/display/men/Page\\+Monitor",
        "name": "BBC Page Monitor",
        "category": "Site Monitor",
        "url": "https://confluence.dev.bbc.co.uk/display/men/Page+Monitor",
        "producer": {
            "name": "BBC",
            "url": "https://www.bbc.com/"
        }
    },
    {
        "regex": "BBC-Forge-URL-Monitor-Twisted",
        "name": "BBC Forge URL Monitor",
        "category": "Site Monitor",
        "url": "https://www.bbc.com/",
        "producer": {
            "name": "BBC",
            "url": "https://www.bbc.com/"
        }
    },
    {
        "regex": "ClaudeBot",
        "name": "ClaudeBot",
        "category": "Crawler",
        "url": "https://github.com/ClaudeBot/ClaudeBot"
    },
    {
        "regex": "Imagesift",
        "name": "ImageSift",
        "category": "Crawler",
        "url": "https://imagesift.com/",
        "producer": {
            "name": "Castle Global, Inc.",
            "url": "https://thehive.ai/"
        }
    },
    {
        "regex": "TactiScout",
        "name": "TactiScout",
        "category": "Crawler",
        "url": "https://find-it.world/TempCrawl/Crawltheque.php",
        "producer": {
            "name": "Tactikast"
        }
    },
    {
        "regex": "Brightbot",
        "name": "BrightBot",
        "category": "Crawler",
        "url": "https://www.brightbot.app/",
        "producer": {
            "name": "Bright Interactive Ltd",
            "url": "https://www.builtbybright.com/"
        }
    },
    {
        "regex": "DaspeedBot",
        "name": "DaspeedBot",
        "category": "Crawler",
        "url": "https://daspeed.io/",
        "producer": {
            "name": "DAWAP SARL",
            "url": "https://dawap.fr/"
        }
    },
    {
        "regex": "StractBot",
        "name": "Stract",
        "category": "Crawler",
        "url": "https://stract.com/webmasters",
        "producer": {
            "name": "Stract",
            "url": "https://github.com/StractOrg/stract/"
        }
    },
    {
        "regex": "GeedoBot",
        "name": "GeedoBot",
        "category": "Crawler",
        "url": "https://geedo.com/bot/"
    },
    {
        "regex": "GeedoProductSearch",
        "name": "GeedoProductSearch",
        "category": "Crawler",
        "url": "https://geedo.com/product-search/"
    },
    {
        "regex": "BackupLand",
        "name": "BackupLand",
        "category": "Crawler",
        "url": "https://go.backupland.com/",
        "producer": {
            "name": "\u041E\u041E\u041E \xab\u041A\u0412\u0410\u0420\u0422\u0410\xbb",
            "url": "https://go.backupland.com/"
        }
    },
    {
        "regex": "Konturbot",
        "name": "Konturbot",
        "category": "Crawler",
        "url": "https://kontur.ru/",
        "producer": {
            "name": "\u0410\u041E \xab\u041F\u0424 \xab\u0421\u041A\u0411 \u041A\u043E\u043D\u0442\u0443\u0440\xbb",
            "url": "https://kontur.ru/"
        }
    },
    {
        "regex": "keys-so-bot",
        "name": "Keys.so",
        "category": "Crawler",
        "url": "https://www.keys.so/",
        "producer": {
            "name": "\u041E\u041E\u041E \xab\u041C\u041E\u0414\u0415\u0421\u041A\u041E\xbb",
            "url": "https://www.modesco.ru/"
        }
    },
    {
        "regex": "LetsearchBot",
        "name": "LetSearch",
        "category": "Crawler",
        "url": "https://letsearch.ru/bots"
    },
    {
        "regex": "Example3",
        "name": "Example3",
        "category": "Crawler",
        "url": "https://www.example3.com/"
    },
    {
        "regex": "StatOnlineRuBot",
        "name": "StatOnline.ru",
        "category": "Crawler",
        "url": "https://statonline.ru/",
        "producer": {
            "name": "\u041E\u041E\u041E \xab\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0434\u043E\u043C\u0435\u043D\u043D\u044B\u0445 \u0438\u043C\u0435\u043D \u0420\u0415\u0413.\u0420\u0423\xbb",
            "url": "https://statonline.ru/"
        }
    },
    {
        "regex": "Spawning-AI",
        "name": "Spawning AI",
        "category": "Crawler",
        "url": "https://spawning.ai/",
        "producer": {
            "name": "Spawning, Inc",
            "url": "https://spawning.ai/"
        }
    },
    {
        "regex": "domain research project",
        "name": "Domain Research Project",
        "category": "Crawler",
        "url": "https://trentwil.es/domains.html",
        "producer": {
            "name": "Trent Wiles",
            "url": "https://trentwil.es/"
        }
    },
    {
        "regex": "getodin\\.com",
        "name": "Odin",
        "category": "Security Checker",
        "url": "https://docs.getodin.com/",
        "producer": {
            "name": "Cyble Inc.",
            "url": "https://cyble.com/"
        }
    },
    {
        "regex": "YouBot",
        "name": "YouBot",
        "category": "Crawler",
        "url": "https://about.you.com/youbot/",
        "producer": {
            "name": "SuSea, Inc.",
            "url": "https://you.com/"
        }
    },
    {
        "regex": "SiteScoreBot",
        "name": "SiteScore",
        "category": "Crawler",
        "url": "https://sitescore.ai/"
    },
    {
        "regex": "MBCrawler",
        "name": "Monitor Backlinks",
        "category": "Crawler",
        "url": "https://www.seoptimer.com/monitor-backlinks/",
        "producer": {
            "name": "SEOptimer",
            "url": "https://www.seoptimer.com/"
        }
    },
    {
        "regex": "mariadb-mysql-kbs-bot",
        "name": "MariaDB/MySQL Knowledge Base",
        "category": "Crawler",
        "url": "https://github.com/williamdes/mariadb-mysql-kbs",
        "producer": {
            "name": "WDES SAS",
            "url": "https://wdes.fr/en/"
        }
    },
    {
        "regex": "GitHubCopilotChat",
        "name": "GitHubCopilotChat",
        "category": "Crawler",
        "url": "https://github.com/aaamoon/copilot-gpt4-service"
    },
    {
        "regex": "^pdrl\\.fm",
        "name": "Podroll Analyzer",
        "category": "Crawler",
        "url": "https://podroll.fm"
    },
    {
        "regex": "PodUptime/",
        "name": "PodUptime",
        "category": "Site Monitor",
        "url": "https://poduptime.com"
    },
    {
        "regex": "anthropic-ai",
        "name": "Anthropic AI",
        "category": "Crawler",
        "url": "https://www.anthropic.com/",
        "producer": {
            "name": "Anthropic, PBC",
            "url": "https://www.anthropic.com/"
        }
    },
    {
        "regex": "NetpeakCheckerBot",
        "name": "Netpeak Checker",
        "category": "Crawler",
        "url": "https://netpeaksoftware.com/checker",
        "producer": {
            "name": "Netpeak LTD",
            "url": "https://netpeaksoftware.com/"
        }
    },
    {
        "regex": "SandobaCrawler",
        "name": "Sandoba//Crawler",
        "category": "Crawler",
        "url": "https://www.sandoba.com/en/crawler/",
        "producer": {
            "name": "SANDOBA//EBUSINESS SOLUTIONS",
            "url": "https://www.sandoba.com/"
        }
    },
    {
        "regex": "SirdataBot",
        "name": "Sirdata",
        "category": "Crawler",
        "url": "https://semantic-api.docs.sirdata.net/contextual-api/contextual-api/introduction",
        "producer": {
            "name": "Sirdata SAS",
            "url": "https://www.sirdata.com/"
        }
    },
    {
        "regex": "CheckMarkNetwork",
        "name": "CheckMark Network",
        "category": "Crawler",
        "url": "https://www.checkmarknetwork.com/spider.html/",
        "producer": {
            "name": "Exipert, Inc.",
            "url": "https://www.checkmarknetwork.com/"
        }
    },
    {
        "regex": "cohere-(?:ai|command|training)",
        "name": "Cohere AI",
        "category": "Crawler",
        "url": "https://cohere.com/",
        "producer": {
            "name": "Cohere, Inc.",
            "url": "https://cohere.com/"
        }
    },
    {
        "regex": "PerplexityBot",
        "name": "PerplexityBot",
        "category": "Crawler",
        "url": "https://docs.perplexity.ai/guides/bots",
        "producer": {
            "name": "Perplexity AI, Inc.",
            "url": "https://www.perplexity.ai/"
        }
    },
    {
        "regex": "Perplexity-User",
        "name": "Perplexity-User",
        "category": "Crawler",
        "url": "https://docs.perplexity.ai/guides/bots",
        "producer": {
            "name": "Perplexity AI, Inc.",
            "url": "https://www.perplexity.ai/"
        }
    },
    {
        "regex": "TTD-Content",
        "name": "The Trade Desk Content",
        "category": "Crawler",
        "url": "https://www.thetradedesk.com/us/ttd-content",
        "producer": {
            "name": "The Trade Desk, Inc.",
            "url": "https://www.thetradedesk.com/"
        }
    },
    {
        "regex": "montastic-monitor",
        "name": "Montastic Monitor",
        "category": "Site Monitor",
        "url": "https://www.montastic.com/",
        "producer": {
            "name": "Metadot, Corp.",
            "url": "https://www.metadot.com/"
        }
    },
    {
        "regex": "Ruby, Twurly v",
        "name": "Twurly",
        "category": "Crawler",
        "url": "https://twurly.org/"
    },
    {
        "regex": "Mixnode(?:Cache)?",
        "name": "Mixnode",
        "category": "Crawler",
        "url": "https://www.mixnode.com/",
        "producer": {
            "name": "Mixnode Technologies, Inc.",
            "url": "https://www.mixnode.com/"
        }
    },
    {
        "regex": "CSSCheck",
        "name": "CSSCheck",
        "category": "Validator"
    },
    {
        "regex": "MicrosoftPreview",
        "name": "Microsoft Preview",
        "category": "Service Agent",
        "url": "https://www.bing.com/webmasters/help/which-crawlers-does-bing-use-8c184ec0",
        "producer": {
            "name": "Microsoft Corporation",
            "url": "https://www.microsoft.com/"
        }
    },
    {
        "regex": "s~virustotalcloud",
        "name": "VirusTotal Cloud",
        "category": "Crawler",
        "url": "https://www.virustotal.com/",
        "producer": {
            "name": "Chronicle Security Ireland Limited",
            "url": "https://chronicle.security/"
        }
    },
    {
        "regex": "TinEye",
        "name": "TinEye",
        "category": "Crawler",
        "url": "https://tineye.com/",
        "producer": {
            "name": "Id\xe9e, Inc.",
            "url": "https://tineye.com/"
        }
    },
    {
        "regex": "e~arsnova-filter-system",
        "name": "ARSNova Filter System",
        "category": "Crawler",
        "url": "https://particify.de/en/",
        "producer": {
            "name": "Particify Gerhardt & Weingarten OHG",
            "url": "https://particify.de/en/"
        }
    },
    {
        "regex": "botify",
        "name": "Botify",
        "category": "Crawler",
        "url": "https://www.botify.com/",
        "producer": {
            "name": "BOTIFY SAS",
            "url": "https://www.botify.com/"
        }
    },
    {
        "regex": "adscanner",
        "name": "Adscanner",
        "category": "Crawler",
        "url": "https://www.alleyesonscreens.com/",
        "producer": {
            "name": "AdScanner d.o.o",
            "url": "https://www.alleyesonscreens.com/"
        }
    },
    {
        "regex": "online-webceo-bot",
        "name": "WebCEO",
        "category": "Crawler",
        "url": "https://www.webceo.com/",
        "producer": {
            "name": "WebCEO, LLC",
            "url": "https://www.webceo.com/"
        }
    },
    {
        "regex": "NetTrack",
        "name": "NetTrack",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20160607151934/https://nettrack.info/"
    },
    {
        "regex": "htmlyse",
        "name": "htmlyse",
        "category": "Crawler",
        "url": "https://www.htmlyse.com/",
        "producer": {
            "name": "Vistex LTD",
            "url": "https://www.htmlyse.com/"
        }
    },
    {
        "regex": "TrendsmapResolver",
        "name": "Trendsmap",
        "category": "Crawler",
        "url": "https://www.trendsmap.com/",
        "producer": {
            "name": "Trendsmap Pty Ltd",
            "url": "https://www.trendsmap.com/"
        }
    },
    {
        "regex": "Shareaholic(?:bot)?",
        "name": "Steve Bot",
        "category": "Crawler",
        "url": "https://www.shareaholic.com/steve",
        "producer": {
            "name": "Shareaholic, Inc.",
            "url": "https://www.shareaholic.com/"
        }
    },
    {
        "regex": "keycdn-tools:",
        "name": "KeyCDN Tools",
        "category": "Service Agent",
        "url": "https://tools.keycdn.com/geo"
    },
    {
        "regex": "keycdn-tools/",
        "name": "KeyCDN Tools",
        "category": "Service Agent",
        "url": "https://tools.keycdn.com/",
        "producer": {
            "name": "proinity LLC",
            "url": "https://www.keycdn.com/"
        }
    },
    {
        "regex": "Arquivo-web-crawler",
        "name": "Arquivo.pt",
        "category": "Crawler",
        "url": "https://sobre.arquivo.pt/en/help/crawling-and-archiving-web-content/",
        "producer": {
            "name": "FCT|FCCN",
            "url": "https://www.fct.pt/"
        }
    },
    {
        "regex": "WhatsMyIP\\.org",
        "name": "WhatsMyIP.org",
        "category": "Service Agent",
        "url": "https://www.whatsmyip.org/ua/"
    },
    {
        "regex": "SenutoBot",
        "name": "Senuto",
        "category": "Crawler",
        "url": "https://www.senuto.com/",
        "producer": {
            "name": "Senuto Sp. z o.o.",
            "url": "https://www.senuto.com/"
        }
    },
    {
        "regex": "GozleBot",
        "name": "Gozle",
        "category": "Crawler",
        "url": "https://gozle.com.tm/en/blog/post/1",
        "producer": {
            "name": "Doly Horjun HJ",
            "url": "https://gozle.com.tm/"
        }
    },
    {
        "regex": "Quantcastbot",
        "name": "Quantcast",
        "category": "Crawler",
        "url": "https://www.quantcast.com/bot/",
        "producer": {
            "name": "Quantcast Corp.",
            "url": "https://www.quantcast.com/"
        }
    },
    {
        "regex": "FontRadar",
        "name": "FontRadar",
        "category": "Crawler",
        "url": "https://www.fontradar.com/",
        "producer": {
            "name": "EMDASH SAS",
            "url": "https://www.fontradar.com/"
        }
    },
    {
        "regex": "ViberUrlDownloader",
        "name": "Viber Url Downloader",
        "category": "Service Agent",
        "url": "https://www.viber.com/",
        "producer": {
            "name": "Viber Media S.\xe0 r.l.",
            "url": "https://www.viber.com/"
        }
    },
    {
        "regex": "^Zeno$",
        "name": "Zeno",
        "category": "Crawler",
        "url": "https://github.com/internetarchive/Zeno",
        "producer": {
            "name": "The Internet Archive",
            "url": "https://archive.org/"
        }
    },
    {
        "regex": "Barracuda Sentinel",
        "name": "Barracuda Sentinel",
        "category": "Service Agent",
        "url": "https://sentinel.barracudanetworks.com/",
        "producer": {
            "name": "Barracuda Networks, Inc.",
            "url": "https://www.barracudanetworks.com/"
        }
    },
    {
        "regex": "RuxitSynthetic",
        "name": "RuxitSynthetic",
        "category": "Site Monitor",
        "url": "https://community.dynatrace.com/t5/Troubleshooting/Basic-Commands-for-Synthetic/ta-p/198164",
        "producer": {
            "name": "Dynatrace LLC",
            "url": "https://www.dynatrace.com/"
        }
    },
    {
        "regex": "DynatraceSynthetic",
        "name": "DynatraceSynthetic",
        "category": "Site Monitor",
        "url": "https://community.dynatrace.com/t5/Troubleshooting/Basic-Commands-for-Synthetic/ta-p/198164",
        "producer": {
            "name": "Dynatrace LLC",
            "url": "https://www.dynatrace.com/"
        }
    },
    {
        "regex": "sitebulb",
        "name": "Sitebulb",
        "category": "Crawler",
        "url": "https://sitebulb.com/",
        "producer": {
            "name": "Sitebulb Limited",
            "url": "https://sitebulb.com/"
        }
    },
    {
        "regex": "Monsidobot",
        "name": "Monsidobot",
        "category": "Crawler",
        "url": "https://monsido.com/bot-html",
        "producer": {
            "name": "Monsido LLC",
            "url": "https://monsido.com/"
        }
    },
    {
        "regex": "AccompanyBot",
        "name": "AccompanyBot",
        "category": "Crawler",
        "url": "https://www.accompany.com/",
        "producer": {
            "name": "Accompani, Inc",
            "url": "https://www.accompany.com/"
        }
    },
    {
        "regex": "Ghost Inspector",
        "name": "Ghost Inspector",
        "category": "Site Monitor",
        "url": "https://docs.ghostinspector.com/faq/#how-do-i-detect-ghost-inspector-test-runner-traffic-on-my-site",
        "producer": {
            "name": "Ghost Inspector, Inc.",
            "url": "https://www.ghostinspector.com/"
        }
    },
    {
        "regex": "Google-Apps-Script",
        "name": "Google Apps Script",
        "category": "Service Agent",
        "url": "https://www.google.com/script/start/"
    },
    {
        "regex": "SiteOne-Crawler",
        "name": "SiteOne Crawler",
        "category": "Crawler",
        "url": "https://crawler.siteone.io/bot/",
        "producer": {
            "name": "SiteOne s.r.o.",
            "url": "https://www.siteone.io/"
        }
    },
    {
        "regex": "Detectify",
        "name": "Detectify",
        "category": "Security Checker",
        "url": "https://support.detectify.com/support/solutions/articles/48001049001-how-to-allow-detectify-to-access-your-site",
        "producer": {
            "name": "Detectify AB",
            "url": "https://detectify.com/"
        }
    },
    {
        "regex": "DomCopBot",
        "name": "DomCop Bot",
        "category": "Crawler",
        "url": "https://www.domcop.com/bot",
        "producer": {
            "name": "Axeman Technology Solutions LLP",
            "url": "https://axemantech.com/"
        }
    },
    {
        "regex": "Paqlebot",
        "name": "Paqlebot",
        "category": "Crawler",
        "url": "https://www.paqle.dk/about/paqlebot",
        "producer": {
            "name": "Paqle A/S",
            "url": "https://www.paqle.dk/"
        }
    },
    {
        "regex": "Wibybot",
        "name": "Wibybot",
        "category": "Crawler",
        "url": "https://www.wiby.me/"
    },
    {
        "regex": "Synapse",
        "name": "Synapse",
        "category": "Crawler",
        "url": "https://github.com/matrix-org/synapse"
    },
    {
        "regex": "OSZKbot",
        "name": "OSZKbot",
        "category": "Crawler",
        "url": "http://mekosztaly.oszk.hu/mia/",
        "producer": {
            "name": "National Szechenyi Library",
            "url": "https://webarchivum.oszk.hu/"
        }
    },
    {
        "regex": "ZoomBot",
        "name": "ZoomBot",
        "category": "Crawler",
        "url": "https://suite.seozoom.it/bot.html",
        "producer": {
            "name": "SEO Cube S.r.l.",
            "url": "https://www.seocube.it/"
        }
    },
    {
        "regex": "RavenCrawler",
        "name": "RavenCrawler",
        "category": "Crawler",
        "url": "https://raventools.com/site-auditor/",
        "producer": {
            "name": "TapClicks, Inc.",
            "url": "https://www.tapclicks.com/"
        }
    },
    {
        "regex": "KadoBot",
        "name": "KadoBot",
        "category": "Crawler",
        "url": "https://www.kadolijst.nl/bot",
        "producer": {
            "name": "Kadolijst",
            "url": "https://www.kadolijst.nl/"
        }
    },
    {
        "regex": "Dubbotbot",
        "name": "Dubbotbot",
        "category": "Crawler",
        "url": "https://help.dubbot.com/en/articles/6746594-example-custom-user-agent",
        "producer": {
            "name": "DubBot",
            "url": "https://dubbot.com/"
        }
    },
    {
        "regex": "Swiftbot",
        "name": "Swiftbot",
        "category": "Crawler",
        "url": "https://swiftype.com/swiftbot",
        "producer": {
            "name": "Elasticsearch, B.V.",
            "url": "https://www.elastic.co/"
        }
    },
    {
        "regex": "EyeMonIT",
        "name": "EyeMonit",
        "category": "Site Monitor",
        "url": "https://eyemonit.com/",
        "producer": {
            "name": "EyeMonit",
            "url": "https://eyemonit.com/"
        }
    },
    {
        "regex": "ThousandEyes",
        "name": "ThousandEyes",
        "category": "Site Monitor",
        "url": "https://www.thousandeyes.com/",
        "producer": {
            "name": "Cisco Systems, Inc.",
            "url": "https://www.cisco.com/"
        }
    },
    {
        "regex": "OmtrBot",
        "name": "OmtrBot",
        "category": "Site Monitor"
    },
    {
        "regex": "WebMon",
        "name": "WebMon",
        "category": "Site Monitor"
    },
    {
        "regex": "AdsTxtCrawlerTP",
        "name": "AdsTxtCrawlerTP",
        "category": "Crawler"
    },
    {
        "regex": "fragFINN",
        "name": "fragFINN",
        "category": "Crawler",
        "url": "https://www.fragfinn.de/",
        "producer": {
            "name": "fragFINN e.V.",
            "url": "https://www.fragfinn.de/"
        }
    },
    {
        "regex": "Clickagy",
        "name": "Clickagy",
        "category": "Crawler",
        "url": "https://www.clickagy.com/",
        "producer": {
            "name": "Clickagy, LLC",
            "url": "https://www.clickagy.com/"
        }
    },
    {
        "regex": "kiwitcms-gitops",
        "name": "Kiwi TCMS GitOps",
        "category": "Service Agent",
        "url": "https://kiwitcms.org",
        "producer": {
            "name": "Open Technologies Bulgaria, Ltd.",
            "url": "https://kiwitcms.org"
        }
    },
    {
        "regex": "webtru_crawler",
        "name": "webtru",
        "category": "Crawler",
        "url": "https://webtru.io/",
        "producer": {
            "name": "DataSign Inc.",
            "url": "https://datasign.jp/"
        }
    },
    {
        "regex": "URLSuMaBot",
        "name": "URLSuMaBot",
        "category": "Crawler",
        "url": "https://www.urlsuma.de/"
    },
    {
        "regex": "360JK yunjiankong",
        "name": "360JK",
        "category": "Site Monitor",
        "url": "http://jk.cloud.360.cn/",
        "producer": {
            "name": "360 Security Technology Inc.",
            "url": "https://www.360.cn/"
        }
    },
    {
        "regex": "UCSBNetworkMeasurement",
        "name": "UCSB Network Measurement",
        "category": "Crawler",
        "url": "https://www.it.ucsb.edu/",
        "producer": {
            "name": "University of California, Santa Barbara",
            "url": "https://www.it.ucsb.edu/"
        }
    },
    {
        "regex": "Plesk screenshot bot",
        "name": "Plesk Screenshot Service",
        "category": "Service Agent",
        "url": "https://support.plesk.com/hc/en-us/articles/13302778306199-What-is-Plesk-Screenshot-Service",
        "producer": {
            "name": "Plesk International GmbH",
            "url": "https://www.plesk.com/"
        }
    },
    {
        "regex": "Who\\.is",
        "name": "Who.is Bot",
        "category": "Crawler",
        "url": "https://who.is/"
    },
    {
        "regex": "Probely",
        "name": "Probely",
        "category": "Security Checker",
        "url": "https://probely.com/sos/",
        "producer": {
            "name": "Probely - Solu\xe7\xf5es de Ciberseguran\xe7a, S.A.",
            "url": "https://probely.com/"
        }
    },
    {
        "regex": "Uptimia",
        "name": "Uptimia",
        "category": "Site Monitor",
        "url": "https://www.uptimia.com/",
        "producer": {
            "name": "JJ Online GmbH",
            "url": "https://www.uptimia.com/"
        }
    },
    {
        "regex": "2GDPR",
        "name": "2GDPR",
        "category": "Service Agent",
        "url": "https://2gdpr.com/tos",
        "producer": {
            "name": "2GDPR",
            "url": "https://2gdpr.com/"
        }
    },
    {
        "regex": "abuse\\.xmco\\.fr",
        "name": "Serenety",
        "category": "Security Checker",
        "url": "https://abuse.xmco.fr/",
        "producer": {
            "name": "XMCO, SASU",
            "url": "https://www.xmco.fr/"
        }
    },
    {
        "regex": "CheckHost",
        "name": "CheckHost",
        "category": "Site Monitor",
        "url": "https://check-host.net/",
        "producer": {
            "name": "CheckHost",
            "url": "https://check-host.net/"
        }
    },
    {
        "regex": "LAC_IAHarvester",
        "name": "LAC IA Harvester",
        "category": "Crawler",
        "url": "https://library-archives.canada.ca/eng/services/government-canada/web-social-media-preservation-program/Pages/web-archive.aspx",
        "producer": {
            "name": "Library and Archives Canada",
            "url": "https://library-archives.canada.ca/"
        }
    },
    {
        "regex": "InsytfulBot",
        "name": "InsytfulBot",
        "category": "Crawler",
        "url": "https://www.insytful.com/",
        "producer": {
            "name": "Zengenti Limited",
            "url": "https://www.zengenti.com/"
        }
    },
    {
        "regex": "statista\\.com",
        "name": "Statista",
        "category": "Crawler",
        "url": "https://www.statista.com/",
        "producer": {
            "name": "Statista, Inc.",
            "url": "https://www.statista.com/"
        }
    },
    {
        "regex": "SubstackContentFetch",
        "name": "Substack Content Fetch",
        "category": "Crawler",
        "url": "https://substack.com/",
        "producer": {
            "name": "Substack, Inc.",
            "url": "https://substack.com/"
        }
    },
    {
        "regex": "^ds9",
        "name": "Deep SEARCH 9",
        "category": "Crawler",
        "url": "https://www.copyright.com/blog/ccc-expands-corporate-solutions-offering-with-new-technology/",
        "producer": {
            "name": "Copyright Clearance Center, Inc.",
            "url": "https://www.copyright.com/"
        }
    },
    {
        "regex": "LiveJournal\\.com",
        "name": "LiveJournal",
        "url": "https://www.livejournal.com/",
        "category": "Feed Fetcher",
        "producer": {
            "name": '\u041E\u041E\u041E "\u0421\u0418\u041C"',
            "url": "https://www.livejournal.com/"
        }
    },
    {
        "regex": "bitdiscovery",
        "name": "Tenable.asm",
        "category": "Security Checker",
        "url": "https://bitdiscovery.com/",
        "producer": {
            "name": "Tenable, Inc.",
            "url": "https://www.tenable.com/"
        }
    },
    {
        "regex": "Castopod",
        "name": "Castopod",
        "category": "Crawler",
        "url": "https://www.castopod.org/"
    },
    {
        "regex": "Elastic/Synthetics",
        "name": "Elastic Synthetics",
        "category": "Site Monitor",
        "url": "https://github.com/elastic/synthetics",
        "producer": {
            "name": "Elasticsearch B.V.",
            "url": "https://www.elastic.co/"
        }
    },
    {
        "regex": "WDG_Validator",
        "name": "WDG HTML Validator",
        "category": "Validator",
        "url": "http://www.htmlhelp.com/tools/validator/"
    },
    {
        "regex": "scan@aegis.network",
        "name": "Aegis",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20180910002802/http://www.aegis.network/"
    },
    {
        "regex": "CrawlyProjectCrawler",
        "name": "Crawly Project",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20240326141952/https://crawlyproject.digitaldragon.dev/"
    },
    {
        "regex": "BDFetch",
        "name": "BDFetch",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20130821043949/http://www.branddimensions.com/"
    },
    {
        "regex": "PunkMap",
        "name": "Punk Map",
        "category": "Security Checker",
        "url": "https://github.com/openeasm/punkmap"
    },
    {
        "regex": "GenomeCrawlerd",
        "name": "Deepfield Genome",
        "category": "Crawler",
        "url": "https://www.nokia.com/networks/ip-networks/deepfield/genome/",
        "producer": {
            "name": "Nokia Corporation",
            "url": "https://www.nokia.com/"
        }
    },
    {
        "regex": "Gaisbot",
        "name": "Gaisbot",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20090604121511/https://gais.cs.ccu.edu.tw/robot.php"
    },
    {
        "regex": "FAST-WebCrawler",
        "name": "AlltheWeb",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20041020050801/http://www.alltheweb.com/help/webmaster/crawler"
    },
    {
        "regex": "ducks\\.party",
        "name": "ducks.party",
        "category": "Security Checker",
        "url": "https://ducks.party/"
    },
    {
        "regex": "DepSpid",
        "name": "DepSpid",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20080321224033/http://about.depspid.net/"
    },
    {
        "regex": "Website-info\\.net",
        "name": "Website-info",
        "category": "Crawler",
        "url": "https://website-info.net/robot",
        "producer": {
            "name": "Meins und Vogel GmbH",
            "url": "https://muv.com/"
        }
    },
    {
        "regex": "RedekenBot",
        "name": "RedekenBot",
        "category": "Crawler",
        "url": "https://www.redeken.com/en/help/bot.html",
        "producer": {
            "name": "Redeken",
            "url": "https://www.redeken.com/"
        }
    },
    {
        "regex": "semaltbot",
        "name": "semaltbot",
        "category": "Crawler",
        "url": "https://semalt.net/",
        "producer": {
            "name": "Semalt LP",
            "url": "https://semalt.net/"
        }
    },
    {
        "regex": "MakeMerryBot",
        "name": "MakeMerryBot",
        "category": "Crawler",
        "url": "https://makemerry.app/bots"
    },
    {
        "regex": "Timpibot",
        "name": "Timpibot",
        "category": "Crawler",
        "url": "https://timpi.io/",
        "producer": {
            "name": "Timpi Inc.",
            "url": "https://timpi.io/"
        }
    },
    {
        "regex": "Validbot",
        "name": "ValidBot",
        "category": "Crawler",
        "url": "https://www.validbot.com/",
        "producer": {
            "name": "Jake Olefsky LLC",
            "url": "https://www.validbot.com/"
        }
    },
    {
        "regex": "NPBot",
        "name": "NameProtectBot",
        "category": "Crawler",
        "url": "https://www.cscglobal.com/cscglobal/home/",
        "producer": {
            "name": "NameProtect, Inc.",
            "url": "https://www.cscglobal.com/"
        }
    },
    {
        "regex": "domaincodex\\.com",
        "name": "Domain Codex",
        "category": "Crawler",
        "url": "https://www.domaincodex.com/",
        "producer": {
            "name": "Erie Data Systems, LLC",
            "url": "https://www.eriedatasys.com/"
        }
    },
    {
        "regex": "Swisscows Favicons",
        "name": "Swisscows Favicons",
        "category": "Crawler",
        "url": "https://swisscows.com/",
        "producer": {
            "name": "Swisscows AG",
            "url": "https://swisscows.com/"
        }
    },
    {
        "regex": "leak\\.info",
        "name": "leak.info",
        "category": "Crawler",
        "url": "http://www.leak.info/"
    },
    {
        "regex": "workona",
        "name": "Workona",
        "category": "Crawler",
        "url": "https://workona.com/",
        "producer": {
            "name": "Workona, Inc.",
            "url": "https://workona.com/"
        }
    },
    {
        "regex": "Bloglines",
        "name": "Bloglines",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20140309033202/http://www.bloglines.com/",
        "producer": {
            "name": "Reply!, Inc.",
            "url": "https://www.reply.com/"
        }
    },
    {
        "regex": "heritrix",
        "name": "Heritrix",
        "category": "Crawler",
        "url": "https://webarchive.jira.com/wiki/display/Heritrix/Heritrix",
        "producer": {
            "name": "The Internet Archive",
            "url": "https://archive.org"
        }
    },
    {
        "regex": "search\\.marginalia\\.nu",
        "name": "Marginalia",
        "category": "Crawler",
        "url": "https://www.marginalia.nu/marginalia-search/for-webmasters/",
        "producer": {
            "name": "Marginalia",
            "url": "https://www.marginalia.nu/"
        }
    },
    {
        "regex": "vu-server-health-scanner",
        "name": "VU Server Health Scanner",
        "category": "Security Checker",
        "url": "https://130.37.198.75/index.html",
        "producer": {
            "name": "VU Amsterdam",
            "url": "https://vu.nl/en"
        }
    },
    {
        "regex": "Functionize",
        "name": "Functionize",
        "category": "Crawler",
        "url": "https://www.functionize.com/",
        "producer": {
            "name": "Functionize, Inc.",
            "url": "https://www.functionize.com/"
        }
    },
    {
        "regex": "Prerender",
        "name": "Prerender",
        "category": "Crawler",
        "url": "https://docs.prerender.io/docs/33-overview-of-prerender-crawlers",
        "producer": {
            "name": "saas.group Inc.",
            "url": "https://saas.group/"
        }
    },
    {
        "regex": "bl\\.uk_ldfc_bot",
        "name": "The British Library Legal Deposit Bot",
        "category": "Crawler",
        "url": "https://www.bl.uk/",
        "producer": {
            "name": "The British Library",
            "url": "https://www.bl.uk/"
        }
    },
    {
        "regex": "Miniature\\.io",
        "name": "Miniature.io",
        "category": "Service Agent",
        "url": "https://miniature.io/",
        "producer": {
            "name": "LCX Ventures Ltd",
            "url": "https://www.lcxventures.com/"
        }
    },
    {
        "regex": "Convertify",
        "name": "Convertify",
        "category": "Service Agent",
        "url": "https://www.convertify.app/",
        "producer": {
            "name": "Convertify",
            "url": "https://www.convertify.app/"
        }
    },
    {
        "regex": "ZoteroTranslationServer",
        "name": "Zotero Translation Server",
        "category": "Service Agent",
        "url": "https://github.com/wikimedia/mediawiki-services-zotero",
        "producer": {
            "name": "The Wikimedia Foundation, Inc.",
            "url": "https://www.wikimedia.org/"
        }
    },
    {
        "regex": "MuckRack",
        "name": "MuckRack",
        "category": "Crawler",
        "url": "https://muckrack.com/",
        "producer": {
            "name": "Muck Rack, LLC",
            "url": "https://muckrack.com/"
        }
    },
    {
        "regex": "Golfe",
        "name": "Golfe",
        "category": "Crawler",
        "url": "http://www.goo-olfe.ae/bot.html"
    },
    {
        "regex": "SpiderLing",
        "name": "SpiderLing",
        "category": "Crawler",
        "url": "https://nlp.fi.muni.cz/projects/biwec/",
        "producer": {
            "name": "Natural Language Processing Centre",
            "url": "https://nlp.fi.muni.cz/"
        }
    },
    {
        "regex": "Bravebot",
        "name": "Bravebot",
        "category": "Search bot",
        "url": "https://search.brave.com/help/brave-search-crawler",
        "producer": {
            "name": "Brave Software, Inc.",
            "url": "https://brave.com/"
        }
    },
    {
        "regex": "1001FirmsBot",
        "name": "1001FirmsBot",
        "category": "Crawler",
        "url": "https://www.1001firms.com/1001firmsbot.php"
    },
    {
        "regex": "SteamChatURLLookup",
        "name": "Steam Chat URL Lookup",
        "category": "Service Agent",
        "url": "https://help.steampowered.com/en/faqs/view/595C-42F4-3B66-E02F",
        "producer": {
            "name": "Valve Corporation",
            "url": "https://www.valvesoftware.com/"
        }
    },
    {
        "regex": "ohdear\\.app",
        "name": "Oh Dear",
        "category": "Site Monitor",
        "url": "https://ohdear.app/docs/faq/what-is-the-oh-dear-crawler-doing-in-my-logs",
        "producer": {
            "name": "Immutable, SNC",
            "url": "https://ohdear.app/"
        }
    },
    {
        "regex": "Inspici",
        "name": "Inspici",
        "category": "Crawler",
        "url": "https://www.inspici.com/",
        "producer": {
            "name": "Inspici, LLC",
            "url": "https://www.inspici.com/"
        }
    },
    {
        "regex": "peer39_crawler",
        "name": "Peer39",
        "category": "Crawler",
        "url": "https://www.peer39.com/crawler-notice",
        "producer": {
            "name": "Peer39 Tech, LLC",
            "url": "https://www.peer39.com/"
        }
    },
    {
        "regex": "Pandalytics",
        "name": "Pandalytics",
        "category": "Crawler",
        "url": "https://www.domainsbot.com/business-intelligence/",
        "producer": {
            "name": "DomainsBot, Inc.",
            "url": "https://www.domainsbot.com/"
        }
    },
    {
        "regex": "CloudServerMarketSpider",
        "name": "CloudServerMarketSpider",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20151228225429/https://cloudservermarket.com/spider.html"
    },
    {
        "regex": "Pigafetta",
        "name": "Pigafetta",
        "category": "Crawler",
        "url": "https://visual-seo.com/Pigafetta-Bot",
        "producer": {
            "name": "aStonish Studio Srl",
            "url": "http://www.astonishstudio.com/"
        }
    },
    {
        "regex": "Cotoyogi",
        "name": "Cotoyogi",
        "category": "Crawler",
        "url": "https://ds.rois.ac.jp/center8/crawler/",
        "producer": {
            "name": "Joint Support-Center for Data Science Research (ROIS-DS)",
            "url": "https://ds.rois.ac.jp/"
        }
    },
    {
        "regex": "SuggestBot",
        "name": "SuggestBot",
        "category": "Crawler",
        "url": "https://github.com/nettrom/suggestbot"
    },
    {
        "regex": "cms-experiment",
        "name": "CMS Experiment",
        "category": "Security Checker",
        "url": "https://securitee.org/cms-experiment-fall2024/"
    },
    {
        "regex": "SiteCheckerBotCrawler",
        "name": "SiteCheckerBotCrawler",
        "category": "Crawler",
        "url": "https://sitechecker.pro/",
        "producer": {
            "name": "Cyber Circus Limited",
            "url": "https://sitechecker.pro/"
        }
    },
    {
        "regex": "SBIder",
        "name": "SBIder",
        "category": "Crawler",
        "url": "https://www.sitesell.com/sbider.html",
        "producer": {
            "name": "SiteSell Inc.",
            "url": "https://www.sitesell.com/"
        }
    },
    {
        "regex": "LightspeedSystemsCrawler",
        "name": "LightspeedSystemsCrawler",
        "category": "Crawler",
        "url": "https://www.lightspeedsystems.com/",
        "producer": {
            "name": "Lightspeed Systems, Inc.",
            "url": "https://www.lightspeedsystems.com/"
        }
    },
    {
        "regex": "Research JLU",
        "name": "Research JLU",
        "category": "Crawler",
        "url": "https://www.uni-giessen.de/en/research",
        "producer": {
            "name": "Justus Liebig University Giessen",
            "url": "https://www.uni-giessen.de/en"
        }
    },
    {
        "regex": "(?:hgf|OS)AlphaXCrawl",
        "name": "AlphaXCrawl",
        "category": "Crawler",
        "url": "https://www.fim.uni-passau.de/en/data-science/research/open-search",
        "producer": {
            "name": "University of Passau",
            "url": "https://www.uni-passau.de/en/"
        }
    },
    {
        "regex": "WPMU DEV",
        "name": "WPMU DEV",
        "category": "Crawler",
        "url": "https://wpmudev.com/docs/wpmu-dev-plugins/broken-link-checker/#broken-link-checker-user-agent",
        "producer": {
            "name": "Incsub, LLC.",
            "url": "https://incsub.com/"
        }
    },
    {
        "regex": "SnoopSecInspect",
        "name": "SnoopSecInspect",
        "category": "Security Checker",
        "url": "https://web.archive.org/web/20241206193253/https://snoopsec.us.to/"
    },
    {
        "regex": "ModatScanner",
        "name": "ModatScanner",
        "category": "Security Checker",
        "url": "https://www.modat.io/scanning",
        "producer": {
            "name": "Modat B.V.",
            "url": "https://www.modat.io/"
        }
    },
    {
        "regex": "researchcyber\\.net",
        "name": "researchcyber.net",
        "category": "Security Checker",
        "url": "https://web.archive.org/web/20241219082407/https://researchcyber.net/"
    },
    {
        "regex": "CrystalSemanticsBot",
        "name": "CrystalSemanticsBot",
        "category": "Crawler",
        "url": "https://web.archive.org/web/20121230203310/http://www.crystalsemantics.com/user-agent/",
        "producer": {
            "name": "Crystal Semantics Ltd.",
            "url": "https://web.archive.org/web/20121029062239/http://www.crystalsemantics.com/"
        }
    },
    {
        "regex": "najdu\\.s\\.holubem\\.eu",
        "name": "najdu.s.holubem.eu",
        "category": "Crawler",
        "url": "https://najdu.s.holubem.eu/"
    },
    {
        "regex": "VORTEX/",
        "name": "VORTEX",
        "category": "Crawler",
        "url": "https://marty.anstey.ca/robots/vortex"
    },
    {
        "regex": "xtate/(\\d+\\.[.\\d]+)",
        "name": "xtate",
        "category": "Crawler",
        "url": "https://github.com/babycoff/xtate"
    },
    {
        "regex": "FediList Agent/",
        "name": "FediList",
        "category": "Social Media Agent",
        "url": "https://fedilist.com/"
    },
    {
        "regex": "Grafana/(\\d+\\.[.\\d]+)",
        "name": "Grafana",
        "category": "Site Monitor",
        "url": "https://github.com/grafana/grafana",
        "producer": {
            "name": "Grafana Labs",
            "url": "https://grafana.com/"
        }
    },
    {
        "regex": "github-camo",
        "name": "Github Camo",
        "category": "Crawler",
        "url": "https://github.com/atmos/camo",
        "producer": {
            "name": "Github",
            "url": "https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/about-anonymized-urls"
        }
    },
    {
        "regex": "Bluesky",
        "name": "Bluesky",
        "category": "Social Media Agent",
        "url": "https://bsky.app",
        "producer": {
            "name": "Bluesky Social PBC",
            "url": "https://bsky.app"
        }
    },
    {
        "regex": "OpenGraph\\.io",
        "name": "OpenGraph.io",
        "category": "Crawler",
        "url": "https://www.opengraph.io",
        "producer": {
            "name": "OpenGraph.io",
            "url": "https://www.opengraph.io"
        }
    },
    {
        "regex": "microsoft-flow/",
        "name": "Microsoft Power Automate",
        "category": "Service Agent",
        "url": "https://www.microsoft.com/en-us/power-platform/products/power-automate",
        "producer": {
            "name": "Microsoft Corporation",
            "url": "https://www.microsoft.com/"
        }
    },
    {
        "regex": "Simbiat Software",
        "name": "Simbiat Software",
        "category": "Crawler",
        "url": "https://www.simbiat.eu",
        "producer": {
            "name": "Simbiat Software",
            "url": "https://www.simbiat.eu"
        }
    },
    {
        "regex": "IbouBot",
        "name": "IbouBot",
        "category": "Search bot",
        "url": "https://ibou.io/iboubot.html"
    },
    {
        "regex": "AddSearchBot",
        "name": "AddSearchBot",
        "category": "Crawler",
        "url": "https://www.addsearch.com/docs/indexing/whitelisting-addsearch-bot/",
        "producer": {
            "name": "AddSearch Oy",
            "url": "https://www.addsearch.com/"
        }
    },
    {
        "regex": "TerraCotta",
        "name": "TerraCotta",
        "category": "Crawler",
        "url": "https://github.com/CeramicTeam/CeramicTerracotta",
        "producer": {
            "name": "Ceramic, Inc.",
            "url": "https://ceramic.ai/"
        }
    },
    {
        "regex": "KeybaseBot",
        "name": "KeybaseBot",
        "category": "Social Media Agent",
        "url": "http://keybase.io",
        "producer": {
            "name": "Zoom Video Communications, Inc",
            "url": "https://www.zoom.com/"
        }
    },
    {
        "regex": "Replicate-Bot",
        "name": "Replicate-Bot",
        "category": "Service Agent",
        "url": "https://replicate.com/",
        "producer": {
            "name": "Replicate, Inc.",
            "url": "https://replicate.com/"
        }
    },
    {
        "regex": "cypex\\.ai",
        "name": "Cypex",
        "category": "Security Checker",
        "url": "https://cypex.ai/scanning/",
        "producer": {
            "name": "Cypex",
            "url": "https://cypex.ai/"
        }
    },
    {
        "regex": "fhms-its-research-scanner",
        "name": "FHMS ITS Research Scanner",
        "category": "Security Checker",
        "url": "https://fb02itsscan02.fh-muenster.de/",
        "producer": {
            "name": "University of Applied Sciences Muenster",
            "url": "https://www.fh-muenster.de/"
        }
    },
    {
        "regex": "Together-Bot",
        "name": "Together-Bot",
        "category": "Crawler",
        "url": "https://www.together.ai/",
        "producer": {
            "name": "Together Computer Inc.",
            "url": "https://www.together.ai/"
        }
    },
    {
        "regex": "xAI-Bot",
        "name": "xAI-Bot",
        "category": "Crawler",
        "url": "https://x.ai/",
        "producer": {
            "name": "X.AI LLC",
            "url": "https://x.ai/"
        }
    },
    {
        "regex": "Groq-Bot",
        "name": "Groq-Bot",
        "category": "Crawler",
        "url": "https://groq.com/",
        "producer": {
            "name": "Groq, Inc.",
            "url": "https://groq.com/"
        }
    },
    {
        "regex": "bigsur\\.ai",
        "name": "Big Sur AI",
        "category": "Crawler",
        "url": "https://bigsur.ai/",
        "producer": {
            "name": "Big Sur AI, Inc.",
            "url": "https://bigsur.ai/"
        }
    },
    {
        "regex": "FirecrawlAgent",
        "name": "FirecrawlAgent",
        "category": "Service Agent",
        "url": "https://www.firecrawl.dev/",
        "producer": {
            "name": "SideGuide Technologies, Inc.",
            "url": "https://www.sideguide.dev/"
        }
    },
    {
        "regex": "nuhk|grub-client|Download Demon|SearchExpress|Microsoft URL Control|borg|altavista|dataminr\\.com|teoma|oegp|http%20client|htdig|mogimogi|larbin|scrubby|searchsight|semanticdiscovery|snappy|zeal(?!ot)|dataparksearch|findlinks|BrowserMob|URL2PNG|ZooShot|GomezA|Google SketchUp|Read%20Later|7Siters|centuryb\\.o\\.t9|InterNaetBoten|EasyBib AutoCite|Bidtellect|tomnomnom/meg|cortex|Re-re Studio|adreview|AHC/|NameOfAgent|Request-Promise|ALittle Client|Hello,? world|wp_is_mobile|0xAbyssalDoesntExist|Anarchy99|^revolt|nvd0rz|xfa1|Hakai|gbrmss|fuck-your-hp|IDBTE4M CODE87|Antoine|Insomania|Hells-Net|b3astmode|Linux Gnu \\(cow\\)|Test Certificate Info|iplabel|Magellan|TheSafex?Internetx?Search|Searcherx?web|kirkland-signature|LinkChain|survey-security-dot-txt|infrawatch|Time/|r00ts3c-owned-you|nvdorz|Root Slut|NiggaBalls|BotPoke|GlobalWebSearch|xx032_bo9vs83_2a|sslshed|geckotrail|Wordup|Keydrop|\\(compatible\\)|John Recon|SPARK COMMIT|masjesu|Komaru_The_Cat|Jesus Christ of Nazareth is LORD|Kowai|Hakai|LoliSec|LMAO|^xenu|^(?:chrome|firefox|Abcd|Dark|KvshClient|Node.js|Report Runner|url|Zeus|ZmEu)$|OnlyScans|TheInternetSearchx|Laravel Reaver|bang2013|libredtail",
        "name": "Generic Bot"
    },
    {
        "regex": "[a-z0-9_-]*(?:(?<!cu|power[ _]|m[ _])bot(?![ _]TAB|[ _]?5[0-9]|[ _]Senior|[ _]Junior)|analyzer|appengine|archiver?|checker|collector|crawl|crawler|(?<!node-|uclient-|Mikrotik/\\d\\.[x\\d] |electron-)fetch(?:er)?|indexer|inspector|monitor|(?<!Microsoft |banshee-)project(?!or)|(?<!Google Wap |Blue |SpeedMode; )proxy|(?<!P)research|resolver|robots|(?<!Cam)scanner|scraper|script|searcher|(?<!-)security|spider(?! 8)|study|transcoder|uptime|user[ _]?agent|validator|-(?:AI|Extended|User)/)(?:[^a-z]|$)",
        "name": "Generic Bot"
    }
];

});

parcelRegister("1SXpl", function(module, exports) {
module.exports = {
    "Dell": [
        "MDDR(JS)?",
        "MDDC(JS)?",
        "MDDS(JS)?"
    ],
    "Acer": [
        "MAAR(JS)?"
    ],
    "Sony": [
        "MASE(JS)?",
        "MASP(JS)?",
        "MASA(JS)?"
    ],
    "Asus": [
        "MAAU",
        "NP0[26789]",
        "ASJB",
        "ASU2(JS)?"
    ],
    "Samsung": [
        "MASM(JS)?",
        "SMJB"
    ],
    "Lenovo": [
        "MALC(JS)?",
        "MALE(JS)?",
        "MALN(JS)?",
        "LCJB",
        "LEN2"
    ],
    "Toshiba": [
        "MATM(JS)?",
        "MATB(JS)?",
        "MATP(JS)?",
        "TNJB",
        "TAJB"
    ],
    "Medion": [
        "MAMD"
    ],
    "MSI": [
        "MAMI(JS)?",
        "MAM3"
    ],
    "Gateway": [
        "MAGW(JS)?"
    ],
    "Fujitsu": [
        "MAFS(JS)?",
        "FSJB"
    ],
    "Compaq": [
        "CPDTDF",
        "CPNTDF(JS?)",
        "CMNTDF(JS)?",
        "CMDTDF(JS)?"
    ],
    "HP": [
        "HPCMHP",
        "HPNTDF(JS)?",
        "HPDTDF(JS)?"
    ],
    "Hyrican": [
        "MANM(JS)?"
    ],
    "Ordissimo": [
        "Ordissimo",
        "webissimo3"
    ]
};

});

parcelRegister("3psI7", function(module, exports) {
module.exports = [
    {
        "regex": "Dalvik/[\\d.]+ [(]Linux; U; ?Android ?(?:[\\d.]+;) ?(.+)(?: Build|MIUI)/",
        "name": "$1"
    },
    {
        "regex": "^MQQBrowser/[\\d.]+/Adr \\(Linux; U; (?:[\\d\\.]+;) ?(?:[a-z]{2}(?:-[a-z]{2})?;)(.+) Build/",
        "name": "$1"
    },
    {
        "regex": "Adr [\\d\\.]+; +(?:[a-z]{2}(?:[_-][a-z]{2})?;)\\s(.+)[)] +U2/(?:[\\d.]+) UCBrowser",
        "name": "$1"
    },
    {
        "regex": "^JUC ?\\(Linux; ?U; ?(?:[\\d.]+;) ?(?:[a-z]{2}(?:[_-][a-z]{2});) ?([^;]+); ?\\d+\\*\\d+;?\\) ?UCWEB",
        "name": "$1"
    },
    {
        "regex": "WhatsApp/.+ Device/(?:(?:[^-]+)-)?(.+)$",
        "name": "$1"
    },
    {
        "regex": "(?:like Mac.+FBDV|FBMD)/([^;]+);",
        "name": "$1"
    },
    {
        "regex": "Instagram (?:[\\d.]+) +[(]([^;]+);",
        "name": "$1"
    },
    {
        "regex": "CFNetwork/.+Darwin/.+(?:[(]x86_64[)])? +[(]([^)]+)[)]$",
        "name": "$1"
    },
    {
        "regex": "IEMobile/[0-9].+;(?:[^;]+); ?([^;]+);",
        "name": "$1"
    },
    {
        "regex": "IEMobile/[0-9].+;(?:[^;]+); ?([^)]+)[)] like",
        "name": "$1"
    },
    {
        "regex": "IEMobile/[0-9].+; ?([^)]+)[)]",
        "name": "$1"
    },
    {
        "regex": "Windows (?:Mobile|Phone) (?:[\\d\\.]+;{1,2}) Android (?:[\\d\\.]+;{1,2})(?: WebView/[0-9].0;)?(?:[^;]+); ([^;]+)\\) AppleWebKit",
        "name": "$1"
    },
    {
        "regex": "^([^/]+)[_ ](?:TD-LTE|TD)/(?:V\\d|\\d\\.0) ?(?:Linux/[\\d.]+)? Android/",
        "name": "$1"
    },
    {
        "regex": "^([^/]+)/(?:V\\d|\\d\\.0) ?(?:Linux/[\\d.]+)? Android/",
        "name": "$1"
    },
    {
        "regex": "Android.+; ([^;]+); U; .+\\).+Tenta/",
        "name": "$1"
    },
    {
        "regex": "Android +(?:[^;]+;{1,2}) ?(?:\\s*[a-z]{2}(?:[_-][a-z]{2})?;)? ?([^;]+); Android/.+Release/",
        "name": "$1"
    },
    {
        "regex": "Android +(?:[^;]+;{1,2})? ?(?:[^;]+;)? ?([^/;]+)(?:/(?:[\\d.]+) Android/|(?:/.*)?\\) Linux/| Release/.+AppleWebKit.+Build/)",
        "name": "$1"
    },
    {
        "regex": "[; ]([^;]+); HMSCore [\\d\\.]+; GMSCore [\\d\\.]+",
        "name": "$1"
    },
    {
        "regex": "Android +(?:[^;]+;{1,2}) ?(?:[^;]+;)? ?([^/;]+)(?:Release/.+Build ?/| Build ?/.+AppleWebKit|; HMSCore|; wv\\) AppleWebKit|; HPT/|/.+CTC/|; iPhone; Build/|; GMSCore)",
        "name": "$1"
    },
    {
        "regex": "Android +(?:[^;]+;{1,2}) ?(?:arm(?:_.*)?;|[a-z]{2}(?:[_-][a-z]{2})?;)? ?(.*?)(?:(?:; smart-tv)?[)] ?ShieldExperience|;? Build ?/|\\)? ?AppleWebKit|/[\\w]+\\) AppleWebKit)",
        "name": "$1"
    },
    {
        "regex": "BlackBerry; +U; +([^;]+); +(?:[a-z]{2}(?:[_-][a-z]{2})?;)?",
        "name": "$1"
    },
    {
        "regex": "Android OS.+; +([^;]+);?[)] AppleWebKit/.+UnityPlayer",
        "name": "$1"
    },
    {
        "regex": "^(.+)/(?:[\\d\\.]+).+ObigoInternetBrowser",
        "name": "$1"
    },
    {
        "regex": "InettvBrowser/(?:[\\d\\.]+).+\\(.+\\) ?(.+); CC/",
        "name": "$1"
    },
    {
        "regex": "dv\\(iPh([^)]+)\\);pr\\(UCBrowser/",
        "name": "iPhone$1"
    },
    {
        "regex": "dv\\(([^)]+)\\);pr\\(UCBrowser/",
        "name": "$1"
    },
    {
        "regex": "[\\(, ](iP(?:hone|[ao]d)|Watch)(\\d{1,2}),(\\d{1,2})[ ;\\]]",
        "name": "$1$2,$3"
    },
    {
        "regex": "(?:Non)?AppStore; Apple/(.*?)\\)",
        "name": "$1"
    },
    {
        "regex": "^com\\.ipspirates\\.ort v\\.\\d{3} \\((.*), ?Android",
        "name": "$1"
    },
    {
        "regex": "\\(Mobile; (?!LYF)([^;]+); (?:Android; )?rv:[\\d\\.]+(?:; CAEN)?\\) Gecko/[\\d\\.]+ Firefox/[\\d\\.]+ KAIOS/",
        "name": "$1"
    }
];

});

parcelRegister("hTC6h", function(module, exports) {
module.exports = {
    "360": {
        "1503-a01": "->n4",
        "1509-a00": "->q5 plus",
        "1603-a03": "->n4a",
        "1607-a01": "->n5s",
        "1807-a01": "->n7",
        "n4": "DS=5.5;RS=1080x1920;SZ=75.7x149x8.3;WT=140;RE=2016;OI=1;OV=6.0;RM=4096;CP=194;",
        "n4a": "DS=5.5;RS=1080x1920;SZ=75.6x150x8.2;WT=167;RE=2016;OI=1;OV=6.0;RM=3072;CP=118;",
        "n5s": "DS=5.5;RS=1080x1920;SZ=76.9x153.5x8;WT=170;RE=2017;OI=1;OV=7.1;RM=6144;CP=196;SM=2;",
        "q5 plus": "DS=6;RS=1080x1920;SZ=80x156.5x8.3;WT=175;RE=2016;OI=1;OV=6.0;RM=4096;CP=173;",
        "n7": "DS=5.99;RS=1080x2160;SZ=75.2x155.9x8.35;WT=190;RM=6144;CP=61;RE=2018.05;OI=1;OV=8.1;SM=2;",
        "1803-a01": "->n7 lite",
        "n7 lite": "DS=5.99;RS=1080x2160;SZ=75.2x155.9x8.35;WT=180;RE=2018.08;RM=6144;CP=61;OI=1;OV=8.1;SM=2;",
        "1809-a01": "->n7 pro",
        "n7 pro": "DS=5.99;RS=1080x2160;SZ=73.9x153.5x7.7;WT=182;RE=2018.08;RM=6144;CP=62;OI=1;OV=8.1;SM=2;",
        "1713-a01": "->n6 lite",
        "n6 lite": "DS=5.5;RS=1080x1920;SZ=75.94x152.35x8.25;WT=160;RE=2017.12;RM=4096;CP=19;OI=1;OV=7.1;SM=2;",
        "1707-a01": "->n6",
        "n6": "DS=5.93;RS=1080x2160;SZ=75.9x157.8x8.7;WT=182;RE=2017.12;RM=4096;CP=19;OI=1;OV=7.1;SM=2;",
        "1801-a01": "->n6 pro",
        "n6 pro": "DS=6;RS=1080x2160;SZ=75.64x157.2x8.15;WT=182;RE=2017.11;RM=6144;CP=19;OI=1;OV=7.1;SM=2;",
        "n4s": "DS=5.5;RS=1080x1920;SZ=74.6x151.3x8.35;WT=169;RE=2016;OI=1;OV=6;RM=4096;CP=194;",
        "1505-a02": "->n4s",
        "1505-a01": "->n4s",
        "n5": "DS=5.5;RS=1080x1920;SZ=76x152x8.25;WT=156;RE=2017;OI=1;OV=6;RM=6144;CP=196;",
        "1605-a01": "->n5"
    },
    "8848": {
        "m3": "RE=2016.08;CP=115;RM=4096;WT=220;DS=5;RS=1080x1920;SM=1;",
        "m4": "RE=2017.08;CP=173;RM=6144;DS=5.15;RS=1080x1920;OI=1;OV=7.0;SM=2;",
        "m5": "RE=2018.08;CP=25;RM=6144;WT=228;DS=5.65;RS=1080x2160;OI=1;OV=8.1;SM=2;SZ=73.9x167.5x11.9;",
        "m6": "RM=12288;CP=141;OI=1;OV=10;DS=6.01;RS=1080x2340;"
    },
    "2e": {
        "e450 (2018)": "DS=4.5;RS=480x854;SZ=74.2x133x8.7;WT=133;RM=1024;CP=58;OI=1;OV=8.1;",
        "e450 2018": "->e450 (2018)",
        "e500a (2019)": "DS=5;RS=480x960;SZ=72x142x8.7;WT=149;RM=1024;CP=58;OI=1;OV=8.1;SM=2;",
        "e500a 2019": "->e500a (2019)"
    },
    "malata": {
        "i5": "OI=1;OV=2.3.6;SZ=61.24x115.6x11.95;WT=128"
    },
    "3q": {
        "ac0731b": "->qoo! q-pad",
        "ac0732c": "->qoo! lite",
        "ac1024c": "->qoo! q-pad",
        "ac7803c": "->qoo! lite",
        "bc9710am": "->qoo! q-pad",
        "lc0720c": "->qoo! q-pad",
        "lc1016c": "->qoo! q-pad",
        "mt0729b": "->qoo! q-pad",
        "mt0729d": "->qoo! q-pad",
        "mt0739d": "->qoo! q-pad",
        "mt0811b": "->qoo! q-pad",
        "qoo! lite": "DS=7.0;RS=1280x800;SZ=190x113x8;WT=320;RM=1024;CP=201;OI=1;OV=4.2;",
        "qoo! q-pad": "DS=7.0;RS=800x480;RM=512;CP=31;OI=1;OV=4.0;SZ=200x120x11;WT=360;",
        "rc0718c": "->qoo! q-pad",
        "rc0719h": "->qoo! q-pad",
        "rc0721b": "->qoo! q-pad",
        "rc0722c": "->qoo! q-pad",
        "rc0726b": "->qoo! q-pad",
        "rc0734h": "->qoo! q-pad",
        "rc0743h": "->qoo! q-pad",
        "rc0813c": "->qoo! q-pad",
        "rc0817c": "->qoo! q-pad",
        "rc1018c": "->qoo! q-pad",
        "rc1019g": "->qoo! q-pad",
        "rc1025f": "->qoo! q-pad",
        "rc1301c": "->qoo! q-pad",
        "rc9711b": "->qoo! q-pad",
        "rc9712c": "->qoo! q-pad",
        "rc9716b": "->qoo! q-pad",
        "rc9717b": "->qoo! q-pad",
        "rc9724c": "->qoo! q-pad",
        "rc9726c": "->qoo! q-pad",
        "rc9727f": "->qoo! q-pad",
        "rc9730c": "->qoo! q-pad",
        "rc9731c": "->qoo! q-pad",
        "ts0807b": "->qoo! q-pad",
        "ts1013b": "->qoo! q-pad",
        "vm1017a": "->qoo! q-pad",
        "rc0727h": "->qoo! lite"
    },
    "4good": {
        "light a103": "DS=4.5;RS=540x960;SZ=74.2x133x8.7;WT=133;RM=1024;CP=9;RE=2017.02;OI=1;OV=6;SM=2;",
        "light b100": "DS=4.5;RS=540x960;SZ=67x134x8.8;WT=121;RE=2017;OI=1;OV=7.0;RM=1024;CP=86;",
        "people g410": "DS=5;RS=1080x1920;SZ=72x146x8;WT=131;RE=2016.10;OI=1;OV=6.0;RM=1024;CP=5;",
        "people g503": "DS=5.5;RS=720x1280;SZ=77.5x154x10.5;WT=171;RE=2016;OI=1;OV=6.0;RM=1024;CP=5;",
        "people gt300": "DS=10.1;RS=1280x800;SM=2;SZ=241x170x10;WT=530;RE=;OI=1;OV=7.0;RM=1024;CP=93;",
        "people": "DS=5.5;RS=720x1280;SZ=77x156x8.9;WT=162;RE=2016;OI=1;OV=5.1;RM=1024;CP=56;",
        "s450m 4g": "DS=4.5;RS=480x854;SZ=65x130x9;WT=153;SM=2;RE=2016.02;OI=1;OV=5.1;RM=1024;CP=310;",
        "s501m 3g": "DS=5;RS=480x854;SZ=72x145x8;WT=167;SM=2;OI=1;OV=4.4;RM=512;CP=24;",
        "s555m 4g": "->people",
        "light a104": "DS=5;RM=1024;RS=720x1280;OI=1;OV=7;CP=56;SM=2;WT=149;SZ=72x143x9.4;RE=2017.05;",
        "t700i 3g": "DS=7;RS=1024x600;OI=1;OV=4.4;RM=512;WT=269;SZ=188x108x10;CP=311;"
    },
    "4ife": null,
    "a1": null,
    "ace": {
        "buzz 1 lite": "DS=4.97;RS=480x960;SZ=75.9x159x9.9;WT=155;RE=2019;",
        "buzz 2 lite": "DS=6.1;RS=720x1440;SZ=76.6x159.6x9.7;WT=170;RE=2020;",
        "buzz 1 plus": "DS=5.47;RS=720x1440;SZ=75.9x159.6x9.9;WT=162;RE=2019;",
        "buzz 2 plus": "DS=6.1;RS=720x1440;SZ=73.6x155.6x9.5;WT=162;RE=2020;",
        "buzz 1": "DS=5;RS=480x960;SZ=75.9x159.6x9.9;WT=155;RE=2019;",
        "urban 1": "DS=5.47;RS=720x1440;SZ=75.9x159x9.9;WT=162;RE=2018;",
        "urban 1 pro": "DS=5.7;RS=720x1440;SZ=75.9x159x9.9;WT=162;RE=2019;",
        "clever 1": "DS=6.19;RS=720x1440;SZ=75.9x159x9.9;WT=190;RE=2019;"
    },
    "evoo": {
        "evmfv2": "DS=5.03;DP=320;RS=720x1440;RM=3021;GP=4;OI=1;OV=9;"
    },
    "yumkem": {
        "n10": "DS=9.43;DP=160;RS=1280x800;RM=3805;GP=55;OI=1;OV=10;",
        "n10-eea": ">-n10"
    },
    "zen": {
        "admire shine": "DS=3.89;DP=240;RS=480x800;RM=916;OI=1;OV=7;"
    },
    "kzen": {
        "eva e01": "DS=4.47;DP=240;RS=480x960;RM=940;GP=4;OI=1;OV=8.1;",
        "eva_e01": ">-eva e01"
    },
    "mitsui": {
        "mc32020": "DS=5.03;DP=320;RS=720x1440;RM=2046;OI=1;OV=9;"
    },
    "bittium": {
        "tough mobile 2": "DS=5.25;DP=420;RS=1080x1920;RM=3889;OI=1;OV=11;"
    },
    "digidragon": {
        "ds502": "DS=4.88;DP=220;RS=480x960;RM=968;OI=1;OV=11;",
        "ds6261": "DS=5.1;DP=220;RS=480x1014;RM=2032;OI=1;OV=11;",
        "ds6018": "DS=5.89;DP=240;RS=600x1280;RM=1973;GP=55;OI=1;OV=11;"
    },
    "parrot mobile": {
        "xplorer 2": "DS=4.47;DP=240;RS=480x960;RM=972;OI=1;OV=8.1;",
        "xplorer_2": ">-xplorer 2"
    },
    "tps": {
        "sc10": "DS=8.09;DP=280;RS=1200x1920;RM=4208;GP=55;OI=1;OV=9;",
        "tps-sc10": ">-sc10"
    },
    "teracube": {
        "teracube_one": "DS=5.26;DP=480;RS=1080x2280;RM=6066;OI=1;OV=10;",
        "teracube_2e": "DS=5.37;DP=320;RS=720x1560;RM=3982;GP=25;OI=1;OV=11;"
    },
    "cobalt": {
        "t10 3g": "DS=9.43;DP=160;RS=1280x800;RM=1003;OI=1;OV=7;"
    },
    "zik": {
        "w1027": "DS=7.09;DP=213;RS=1280x800;RM=2023;OI=1;OV=10;"
    },
    "sankey": {
        "tab-7a3g05": "DS=7.42;DP=160;RS=1024x600;RM=937;OI=1;OV=8.1;",
        "tab7a3g05": ">-tab-7a3g05"
    },
    "sprint": {
        "aqt100": "DS=7.09;DP=213;RS=1280x800;RM=956;GP=6;OI=1;OV=5.1;",
        "aqt82": "DS=7.09;DP=213;RS=1280x800;RM=2007;GP=6;OI=1;OV=7.1;"
    },
    "dewalt": {
        "md501": "DS=4.59;DP=320;RS=720x1280;RM=2019;OI=1;OV=6;"
    },
    "winmax": {
        "tiger x12": "DS=3.13;DP=160;RS=320x385;RM=4000;OI=1;OV=8.1;"
    },
    "acer": {
        "a1-810": "->iconia a",
        "a1-811": "->iconia a",
        "allegro": "DS=3.6;RS=480x800;SZ=59x116x13;WT=126;RE=2011.10;RM=512;CP=49;OI=4;OV=7.5;SM=1;",
        "aspire e5-421g": "DS=14;SZ=345.44x228.6x25.4;RS=1366x768;WT=2299.7;CP=92;RE=2014.10;RM=8192;OS=Windows 8.1;",
        "aspire e5-421g-88jf": "->aspire e5-421g",
        "iconia a": "DS=7.9;RS=1024x768;SZ=209x146x11;WT=410;RE=2013.05;RM=1024;CP=12;OI=1;OV=4.2;",
        "iconia tab a1-810": "->iconia a",
        "neotouch p400": "DS=3.2;RS=320x480;SZ=59.3x115x12;WT=125;RE=2010.02;RM=256;CP=145;OS=Windows Mobile 6.5.3;",
        "neotouch s200": "DS=3.8;RS=480x800;SZ=63x118.6x12;WT=130;RE=2009.10;RM=256;CP=150;OS=Windows Mobile 6.5;"
    },
    "airo wireless": {
        "a25is": "DS=2.8;RS=240x320;SZ=68x142.4x24.4;WT=275;RE=2009.08;RM=102.4;CP=;OS=;"
    },
    "accent": null,
    "acteck": null,
    "advan": null,
    "advance": null,
    "afrione": null,
    "agm": {
        "a8 se": "RE=2017.05;DS=5;RS=720x1280;RM=2048;CP=17;SM=2;SZ=83x159x16;WT=247;OI=1;OV=7.0;",
        "a9": "RE=2018.10;DS=5.99;RS=1080x2160;RM=4096;CP=214;WT=251;SZ=81.4x168.0x12.6;OI=1;OV=8.1;",
        "a8": "RE=2017.02;DS=5;RS=720x1280;RM=3072;CP=17;SZ=83x159x16;WT=247;OI=1;OV=7.0;",
        "x1": "RE=2016.10;DS=5.5;RS=1080x1920;RM=4096;CP=65;SZ=79.1x163x11.6;WT=205;OI=1;OV=5.0;",
        "a9 ru": "->a9"
    },
    "ainol": {
        "novo 10 hero": "RE=2012.11;RM=1024;OI=1;OV=4.1;RS=1280x800;DS=10.1;SZ=262x178x10;WT=672;CP=352;",
        "novo10 hero": "->novo 10 hero",
        "novo 9 spark": "RE=2013.03;SZ=240.9x185.6x10.6;WT=642.3;DS=9.7;RS=2048x1536;OI=1;OV=4.1;CP=351;RM=2048;",
        "novo9-spark": "->novo 9 spark"
    },
    "airness": null,
    "airties": null,
    "ais": null,
    "lava": {
        "benco y30": "DS=5.71;RS=720x1520;SZ=71.3x147.2x9.6;WT=156;OI=1;OV=9;SM=2;CP=165;RM=1024;",
        "af9030": "->benco y30"
    },
    "aiuto": null,
    "aiwa": null,
    "akai": {
        "glory g5": "DS=4;RS=480x800;SZ=65.3x125.8x9.5;WT=110;OI=1;OV=4.4.2;SM=1;CP=24;RM=512;RE=2015;",
        "tab 7800": "DS=7.0;RS=800x480;RE=2013.11;OI=1;OV=4.2.2;RM=512;CP=195;",
        "tab-7800": "->tab 7800"
    },
    "alba": null,
    "alcatel": {
        "5002f": "->1a (2020)",
        "1a (2020)": "RE=2020.05;SZ=71.6x146.1x9.9;WT=168;DS=5.5;RS=720x1440;OI=1;OV=10;CP=229;RM=1024;",
        "5002a": "->1b (2020)",
        "5002d": "->1b (2020)",
        "5002h": "->1b (2020)",
        "1b (2020)": "RE=2020.05;SZ=71.6x146.1x9.9;WT=168;DS=5.5;RS=720x1440;OI=1;OV=10;CP=229;RM=2048;",
        "5009a": "->1c",
        "5009d": "->1c",
        "1c": "DS=5.34;RS=480x960;SZ=70.6x146.9x9.2;WT=156;OI=1;OV=7.0;SM=2;RM=1024;CP=58;RE=2019.01;",
        "4034t": "->1e",
        "1e": "DS=4;RS=480x800;SZ=64x122x9.7;WT=110;OI=1;OV=8.1;RM=1024;CP=58;",
        "5028a": "->1s (2020)",
        "5028d": "->1s (2020)",
        "1s (2020)": "RE=2020.05;SZ=74.6x158.7x8.5;WT=165;DS=6.22;RS=720x1520;OI=1;OV=10;CP=164;RM=3072;",
        "5030d": "->1se (2020)",
        "1se (2020)": "RE=2020.10;SZ=75.2x159.2x8.7;WT=175;DS=6.22;RS=720x1520;OI=1;OV=10;CP=109;RM=3072;",
        "9009g": "->1t",
        "1t": "RE=2018.02;SZ=189.5x111x9.2;WT=245;DS=7.0;RS=1024x600;OI=1;OV=8.1;CP=163;RM=1024;",
        "5007a": "->1v (2020)",
        "5007u": "->1v (2020)",
        "1v (2020)": "RE=2020.05;SZ=74.8x158.7x8.9;WT=160;DS=6.22;RS=720x1520;OI=1;OV=10;CP=164;RM=2048;",
        "5029e": "->3 (2020)",
        "3 (2020)": "RE=2020.01;DS=6.22;SZ=75x158x7;WT=165;RS=720x1520;OI=1;OV=10;RM=4096;CP=171;",
        "5006d": "->3c (2019)",
        "3c (2019)": "RE=2019.08;DS=6.7;RS=720x1440;SZ=83.4x173.4x8.1;WT=189.5;OI=1;OV=9;CP=163;RM=2048;",
        "5029d": "->3l (2020)",
        "5029y": "->3l (2020)",
        "3l (2020)": "RE=2020.05;SZ=74.6x158.7x8.5;WT=165;DS=6.22;RS=720x1520;OI=1;OV=10;CP=171;RM=4096;",
        "5039d": "->3l",
        "5039y": "->3l",
        "5034d": "->3l",
        "3l": "RE=2019.01;SZ=69.7x151.1x8;WT=145;DS=5.94;RS=720x1560;OI=1;OV=8.1;CP=8;RM=2048;",
        "8088q": "->3t 10",
        "8088x": "->3t 10",
        "3t 10": "RE=2019.01;SZ=260x156.6x9;WT=440;DS=10;RS=1280x800;OI=1;OV=9;CP=230;RM=2048;",
        "9027f": "->3t 8.0\"",
        "9027t": "->3t 8.0\"",
        "9027w": "->3t 8.0\"",
        "9027x": "->3t 8.0\"",
        "3t 8.0\"": "RE=2018.10;SZ=209.5x125x8.3;WT=279;DS=8.0;RS=1280x800;OI=1;OV=8.1;CP=231;RM=1024;",
        "4003a": "->one touch pixi 3 4\"",
        "4003j": "->one touch pixi 3 4\"",
        "4013e": "->one touch pixi 3 4\"",
        "4013j": "->one touch pixi 3 4\"",
        "4013k": "->one touch pixi 3 4\"",
        "4013m": "->one touch pixi 3 4\"",
        "4013x": "->one touch pixi 3 4\"",
        "4014a": "->one touch pixi 3 4\"",
        "4014e": "->one touch pixi 3 4\"",
        "4014k": "->one touch pixi 3 4\"",
        "4014m": "->one touch pixi 3 4\"",
        "4014x": "->one touch pixi 3 4\"",
        "4114e": "->one touch pixi 3 4\"",
        "one touch pixi 3 4\"": "RS=480x800;DS=4;CP=36;RM=2048;OI=1;OV=4.4;SZ=64.4x121.6x11.6;WT=110;RE=2015.05;",
        "4009a": "->one touch pixi 3 3.5\"",
        "4009f": "->one touch pixi 3 3.5\"",
        "4009i": "->one touch pixi 3 3.5\"",
        "4009k": "->one touch pixi 3 3.5\"",
        "4009m": "->one touch pixi 3 3.5\"",
        "4009s": "->one touch pixi 3 3.5\"",
        "4009x": "->one touch pixi 3 3.5\"",
        "one touch pixi 3 3.5\"": "RS=320x480;DS=3.5;CP=36;RM=2048;OI=1;OV=4.4;SZ=62x112.2x11.9;WT=100;RE=2015.02;",
        "4009d": "->one touch pixi 3 3.5\" dual sim",
        "4009e": "->one touch pixi 3 3.5\" dual sim",
        "4015t": "->one touch pop c1",
        "4016a": "->one touch pop c1",
        "one touch 4015a": "->one touch pop c1",
        "4015a": "->one touch pop c1",
        "one touch 4015x": "->one touch pop c1",
        "4015x": "->one touch pop c1",
        "one touch pop c1": "RS=320x480;RE=2013.09;SZ=62x112.5x12;WT=100;DS=3.5;OI=1;OV=4.2;RM=512;",
        "4016d": "->one touch pop c1 dual sim",
        "4016x": "->one touch pop c1 dual sim",
        "one touch 4015d": "->one touch pop c1 dual sim",
        "one touch 4015n": "->one touch pop c1 dual sim",
        "4017a": "->one touch pixi 4 3.5\"",
        "4017d": "->one touch pixi 4 3.5\"",
        "4017e": "->one touch pixi 4 3.5\"",
        "4017f": "->one touch pixi 4 3.5\"",
        "4017s": "->one touch pixi 4 3.5\"",
        "4017x": "->one touch pixi 4 3.5\"",
        "one touch pixi 4 3.5\"": "RE=2016.01;SZ=62x116x10;WT=120;DS=3.5;RS=320x480;OI=1;OV=5.1;CP=36;RM=512;",
        "4018a": "->one touch pop d1",
        "4018d": "->one touch pop d1",
        "4018e": "->one touch pop d1",
        "4018f": "->one touch pop d1",
        "4018m": "->one touch pop d1",
        "4018x": "->one touch pop d1",
        "one touch pop d1": "RE=2014.08;SZ=62x112.2x12;WT=101;DS=3.5;RS=320x480;OI=1;OV=4.4;CP=36;RM=512;SM=2;",
        "4024d": "->one touch pixi first",
        "4024e": "->one touch pixi first",
        "4024x": "->one touch pixi first",
        "one touch pixi first": "RE=2015.09;SZ=64.4x122.1x9.7;WT=125;DS=4.0;RS=480x800;OI=1;OV=4.4;CP=88;RM=512;",
        "4027a": "->one touch pixi 3 4.5\"",
        "4027d": "->one touch pixi 3 4.5\"",
        "4027n": "->one touch pixi 3 4.5\"",
        "4027x": "->one touch pixi 3 4.5\"",
        "4028a": "->one touch pixi 3 4.5\"",
        "4028e": "->one touch pixi 3 4.5\"",
        "4028j": "->one touch pixi 3 4.5\"",
        "4028s": "->one touch pixi 3 4.5\"",
        "5019d": "->one touch pixi 3 4.5\"",
        "one touch pixi 3 4.5\"": "RE=2015.01;SZ=65.1x132.2x10;WT=125;DS=4.5;RS=480x854;OI=1;OV=4.4;CP=36;RM=512;",
        "4032a": "->one touch pop c2",
        "4032x": "->one touch pop c2",
        "one touch pop c2": "RE=2014.07;SZ=64.4x122x12;WT=116;DS=4.0;RS=480x800;CP=36;OI=1;OV=4.2;RM=512;",
        "4032d": "->one touch pop c2 dual sim",
        "4032e": "->one touch pop c2 dual sim",
        "4034a": "->one touch pixi 4 4\"",
        "4034d": "->one touch pixi 4 4\"",
        "4034e": "->one touch pixi 4 4\"",
        "4034g": "->one touch pixi 4 4\"",
        "4034l": "->one touch pixi 4 4\"",
        "4034x": "->one touch pixi 4 4\"",
        "one touch pixi 4 4\"": "RE=2016.01;SZ=64.4x121.3x9.7;WT=;DS=4.0;RS=480x800;OI=1;OV=6;CP=58;RM=512;",
        "4035a": "->one touch pop d3",
        "4035d": "->one touch pop d3",
        "4035x": "->one touch pop d3",
        "4035y": "->one touch pop d3",
        "one touch pop d3": "DS=4;RS=480x800;SZ=64.4x121.6x12.05;WT=114;RE=2014.08;RM=1024;CP=24;OI=1;OV=4.4;",
        "4045a": "->one touch pop 2 4\"",
        "4045x": "->one touch pop 2 4\"",
        "one touch pop 2 4\"": "RE=2014.09;SZ=64.4x121.5x12.4;WT=125;DS=4.0;RS=480x800;OI=1;OV=5;CP=17;RM=512;SM=1;",
        "4045d": "->one touch pop 2 4\" dual sim",
        "4045e": "->one touch pop 2 4\" dual sim",
        "5007g": "->1v (2020)",
        "5039d ru": "->3l",
        "5039d eea": "->3l",
        "5009d ru": "->1c",
        "5034d ru": "->3l",
        "4034l eea": "->one touch pixi 4 4\"",
        "5002w": "->1b (2020)",
        "5002u": "->1b (2020)",
        "6056a": "->3l",
        "5002f ru": "->1a (2020)",
        "5002d ru": "->1b (2020)",
        "5002d eea": "->1b (2020)",
        "5029y ru": "->3l (2020)",
        "5028d eea": "->1s (2020)",
        "5030d ru": "->1se (2020)",
        "5002h ru": "->1b (2020)",
        "5029d eea": "->3l (2020)",
        "4045l": "->one touch pop 2 4\"",
        "5029a": "->3l (2020)",
        "5030d eea": "->1se (2020)",
        "5030u": "->1se (2020)",
        "5030f eea": "->1se (2020)",
        "5002b": "->1b (2020)",
        "5002f eea": "->1a (2020)",
        "5002h eea": "->1b (2020)",
        "6056h": "->3l",
        "5007u ru": "->1v (2020)",
        "5007o": "->1s (2020)",
        "5002j": "->1b (2020)",
        "6056d": "->3l",
        "5007s": "->1v (2020)",
        "5002e": "->1b (2020)",
        "5002s": "->1b (2020)",
        "5006g": "->3c (2019)",
        "5030a": "->1se (2020)",
        "5029f": "->3l (2020)",
        "5002x": "->1b (2020)",
        "5030m": "->1se (2020)",
        "5002m": "->1b (2020)",
        "5002l": "->1b (2020)",
        "5030j": "->1se (2020)",
        "5006a": "->3c (2019)",
        "5002h tr": "->1b (2020)",
        "5007u eea": "->1v (2020)",
        "5029y eea": "->3l (2020)",
        "a463bg": "->one touch pixi 3 3.5\"",
        "9013a": "->1t",
        "9027q": "->3t 8.0\"",
        "9032x": "->3t 8.0\"",
        "9032x ru": "->3t 8.0\"",
        "9032t": "->3t 8.0\"",
        "9013t": "->1t",
        "9032x eea": "->3t 8.0\"",
        "9032x tr": "->3t 8.0\""
    },
    "alcor": {
        "access q784c": "DS=7;RS=1024x600;SZ=192x114x10;RM=1024;CP=93;OI=1;OV=7;SM=2;"
    },
    "aldi nord": null,
    "aldi s\xfcd": null,
    "alfawise": null,
    "aligator": null,
    "allcall": null,
    "hotwav": {
        "symbol r60": "DS=6.6;RS=720x1600;OI=1;OV=10;SM=2;RM=3072;CP=9;",
        "pearl k2": "DS=6.26;RS=720x1520;SZ=;WT=;RE=2019;OI=1;OV=9;RM=3072;CP=84;",
        "magic q8": "RS=720x1280;DS=5.5;OI=1;OV=8;SM=2;RM=3072;RE=2018.03;SZ=152x75.5x7.3;",
        "magic 5 plus": "RE=2018.09;SM=2;OI=1;OV=7;DS=5;RM=1024;",
        "magic 13": "DS=5;OI=1;OV=7;RM=2048;RS=720x1280;SM=2;WT=164;CP=9;SZ=72.1x145.3x9;",
        "magic 11": "RS=720x1280;RE=2018.05;RM=3072;DS=6;CP=4;SM=2;OI=1;OV=7;",
        "cosmos v23": "RE=2017.05;OI=1;OV=6.0;RM=3072;DS=4.7;RS=720x1280;WT=164;SZ=81.4x163.0x7.7;SM=2;CP=6;",
        "cosmos v22": "RE=2017.08;SZ=81.4x163.0x7.8;WT=160;DS=4.7;RS=720x1280;RM=2048;CP=6;OI=1;OV=6.0;",
        "venus r9": "RS=540x960;DS=5.5;OI=1;OV=6.0;RM=1024;SM=2;RE=2017.09;CP=6;WT=155;",
        "venus x2": "RS=540x960;SZ=68.9x141.1x7.9;DS=5.5;SM=2;OI=1;OV=4.4.2;RM=1024;CP=6;",
        "venus x16": "DS=5.5;RE=2016.08;OI=1;OV=5.1;CP=24;RM=512;RS=360x640;SM=2;",
        "venus x16-1": "->venus x16",
        "symbol x": "DS=5.7;RS=720x1498;SZ=71x146.3x7.8;WT=189;RE=2018;OI=1;OV=8.1;RM=2048;CP=5;",
        "symbol max": "DS=6.26;RS=720x1520;SZ=;WT=;RE=2018;OI=1;OV=8.1;RM=2048;CP=293;",
        "venus x10": "OI=1;OV=6.0;SZ=72x145x8.45;WT=137;RS=720x1280;DS=5;RM=1024;CP=58;",
        "venus x12": "RE=2017;OI=1;OV=5.1;DS=5;WT=137;SZ=72x148.6x9.5;RS=720x1280;RM=1024;CP=;",
        "venus x14": "DS=5;RS=480x854;RM=1024;OI=1;OV=5.1;CP=6;",
        "venus x15": "RE=2017;OI=1;OV=5.1;DS=5;SZ=72x145.9x9.5;WT=147;RS=480x854;RM=1024;CP=;",
        "venus x19": "RE=2017;OI=1;OV=5.1;DS=5;SZ=72x145.6x9;WT=149;RS=720x1280;RM=1024;CP=;",
        "pearl k2 2020": "->pearl k2"
    },
    "alldocube": {
        "iplay 20": "DS=10.1;RS=1920x1200;SZ=245.2x149.4x7.95;WT=450;RM=4096;CP=109;RE=2020.07;OI=1;OV=10;",
        "iplay 40": "DS=10.4;RS=2000x1200;SZ=248.1x157.9x8.2;WT=474;RM=8192;CP=199;RE=2021.01;OI=1;OV=10;",
        "iplay40": "->iplay 40"
    },
    "eurostar": null,
    "fondi": null,
    "famoco": null,
    "mipo": {
        "m17": "DS=5.48;DP=320;RS=720x1600;RM=4040;GP=55;OI=1;OV=13;",
        "m59": "DS=5.6;DP=480;RS=1080x2460;RM=8158;OI=1;OV=13;"
    },
    "daria": null,
    "qin": null,
    "vocal": null,
    "xsmart": null,
    "rtk": null,
    "inovo": null,
    "goldberg": null,
    "kenshi": null,
    "villaon": null,
    "hmd": null,
    "rhino": null,
    "rephone": null,
    "haixu": null,
    "moondrop": null,
    "datang": null,
    "evolio": null,
    "ebest": null,
    "essential": null,
    "eton": null,
    "easypix": null,
    "fnb": null,
    "goly": null,
    "garmin-asus": null,
    "vios": null,
    "weiimi": null,
    "palm": {
        "pepito": "DS=4.59;DP=320;RS=720x1280;RM=2969;GP=24;OI=1;OV=8.1;",
        "pvg100": ">-pepito",
        "pvg100e ru": "->pepito",
        "pvg100e": "->pepito"
    },
    "glocalme": {
        "s20i": "DS=5.26;DP=480;RS=1080x2280;RM=3932;GP=87;OI=1;OV=9;",
        "s20iq19": ">-s20i"
    },
    "x-age": {
        "g1 lite": "DS=5.03;DP=320;RS=720x1440;RM=1954;GP=4;OI=1;OV=8.1;",
        "g1lite": "->g1 lite"
    },
    "deyi": {
        "10m18": "DS=7.09;DP=213;RS=1280x800;RM=2044;OI=1;OV=8.1;",
        "deyi-10m18": "->10m18"
    },
    "senseit": {
        "a109": "DS=4.08;DP=240;RS=480x854;RM=980;OI=1;OV=6;",
        "j2": "DS=7.42;DP=160;RS=1024x600;RM=948;OI=1;OV=8.1;"
    },
    "atol": {
        "smart prime": "DS=3.89;DP=240;RS=480x800;RM=4019;OI=1;OV=11;",
        "prime": "->smart prime"
    },
    "viewsonic": {
        "viewpad m10": "DS=9.43;DP=160;RS=1280x800;RM=993;OI=1;OV=7;"
    },
    "pixpro": {
        "pixpro_l1_pro": ">-l1 pro",
        "l1 pro": "DS=5.03;DP=320;RS=720x1440;RM=1999;OI=1;OV=10;"
    },
    "smt telecom": null,
    "ninetology": null,
    "infinix": {
        "hot 10": "RE=2020.09;SZ=77.6x171.1x8.9;WT=195;DS=6.78;RS=720x1640;OI=1;OV=10;CP=319;RM=3072;",
        "x682b": "->hot 10",
        "x682c": "->hot 10",
        "hot 10 play": "RE=2021.01;SZ=78x171.8x8.9;WT=207;DS=6.82;RS=720x1640;OI=1;OV=10;CP=284;RM=2048;",
        "x688c": "->hot 10 play",
        "x688b": "->hot 10 play",
        "hot 9": "RE=2020.03;SZ=76.8x165.4x8.8;WT=185;DS=6.6;RS=720x1600;OI=1;OV=10;CP=355;RM=2048;",
        "x655": "->hot 9",
        "x655d": "->hot 9",
        "x655c": "->hot 9",
        "note 11 pro": "RE=2021.10;SZ=78.4x173.1x8.7;WT=;DS=6.95;RS=1080x2460;OI=1;OV=11;CP=350;RM=4096;",
        "x697": "->note 11 pro",
        "note 7": "RE=2020.04;SZ=79x173.4x8.8;WT=206;DS=6.95;RS=720x1640;OI=1;OV=10;CP=319;RM=4096;",
        "x690": "->note 7",
        "x690b": "->note 7",
        "note 7 lite": "RE=2020.04;SZ=76.8x165.4x8.8;WT=185;DS=6.6;RS=720x1600;OI=1;OV=10;CP=319;RM=4096;",
        "x656": "->note 7 lite",
        "note 8": "RE=2020.10;SZ=78.8x175.3x9;WT=;DS=6.95;RS=720x1640;OI=1;OV=10;CP=226;RM=6144;",
        "x692": "->note 8",
        "hot 9 play": "RE=2020.04;SZ=78x171.8x8.9;WT=209;DS=6.82;RS=720x1640;OI=1;OV=9;CP=44;RM=2048;",
        "x680": "->hot 9 play",
        "x680f": "->hot 9 play",
        "x680c": "->hot 9 play;RM=4096;CP=355;",
        "x680b": "->hot 9 play;RM=3072;CP=355;",
        "smart 5": "RE=2020.09;SZ=76.4x165.5x8.8;WT=;DS=6.6;RS=720x1600;OI=1;OV=10;CP=337;RM=2048;",
        "x657": "->smart 5",
        "x657b": "->smart 5",
        "x657c": "->smart 5",
        "x6811": "->zero x pro",
        "zero x pro": "RE=2021.09;SZ=75.7x164.1x7.8;WT=193;DS=6.67;RS=1080x2400;OI=1;OV=11;CP=321;RM=8192;",
        "zero 5": "RE=2018;SZ=82.4x166.4x8;WT=197;DS=5.98;RS=1080x1920;OI=1;OV=7.0;CP=343;RM=6144;",
        "x603": "->zero 5",
        "note 5": "RE=2018;SZ=75x158x8.4;WT=173;DS=6.0;RS=1080x2160;OI=1;OV=8.1;CP=63;RM=3072;",
        "x604": "->note 5",
        "x604b": "->note 5",
        "zero 8i": "RE=2020.12;SZ=76.1x168.7x9.1;WT=210.5;DS=6.85;RS=1080x2460;OI=1;OV=10;CP=325;RM=8192;",
        "x687b": "->zero 8i",
        "zero 8": "RE=2020.08;SZ=76.1x168.7x9.1;WT=205;DS=6.85;RS=1080x2460;OI=1;OV=10;CP=325;RM=8192;",
        "x687": "->zero 8",
        "note 8i": "RE=2020.10;SZ=77.7x171.4x8.9;WT=;DS=6.78;RS=720x1640;OI=1;OV=10;CP=226;RM=4096;AL=X683;",
        "x683": "->note 8i",
        "note 10 pro": "RE=2021.05;SZ=78.3x172.8x7.8;WT=;DS=6.95;RS=1080x2460;OI=1;OV=11;CP=321;RM=6144",
        "x695c": "->note 10 pro",
        "x695": "->note 10 pro",
        "x695d": "->note 10 pro",
        "note 10": "RE=2021.05;SZ=78.7x173.2x8.8;WT=;DS=6.95;RS=1080x2460;OI=1;OV=11;CP=322;RM=4096;",
        "x693": "->note 10",
        "hot 8": "RE=2019.09;SZ=76.3x165x8.7;WT=179;DS=6.52;RS=720x1600;OI=1;OV=9.0;CP=44;RM=2048;",
        "x650": "->hot 8",
        "x650b": "->hot 8;RM=4096;",
        "x650d": "->hot 8;RM=4096;",
        "x650c": "->hot 8;RM=4096;",
        "s5 pro": "RE=2020.03;SZ=76.9x162.5x9;WT=195;DS=6.53;RS=1080x2340;OI=1;OV=10;CP=38;RM=4096;",
        "x660c": "->s5 pro",
        "x660b": "->s5 pro",
        "x660": "->s5 pro",
        "zero 6": "RE=2019.03;SZ=;WT=178;DS=6.18;SM=2;RS=1080x2246;OI=1;OV=8.0;CP=205;RM=6144;",
        "x620b": "->zero 6",
        "zero 6 pro": "RE=2019.03;SZ=;WT=178;DS=6.18;SM=2;RS=1080x2246;OI=1;OV=8.0;CP=205;RM=6144;",
        "x620": "->zero 6 pro",
        "mz-infinix x695c": "->note 10 pro",
        "x683b": "->note 8i",
        "x690c": "->note 7"
    },
    "allview": {
        "2 speed quad": "RE=2013.09;SZ=152.5x200x9.8;WT=472.4;DS=8.0;RS=768x1024;OI=1;OV=4.2.2;RM=1024;",
        "P10 Life": "RE=2019.01;SZ=71.9x149.4x9.4;WT=177.6;DS=5.34;RS=480x960;OI=1;OV=8.1;CP=405;RM=2048;",
        "P10 Mini": "RE=2019.04;SZ=76.5x161.5x8.8;WT=182;DS=5.99;RS=720x1440;OI=1;OV=8.1;CP=405;RM=3072;",
        "P10 Pro": "RE=2019.04;SZ=76.5x161.5x8.8;WT=182;DS=5.99;RS=720x1440;OI=1;OV=8.1;CP=405;RM=3072;",
        "a10 lite (2019)": "RE=2018.10;SZ=71.8x145.5x9.9;WT=152;DS=5.34;RS=480x960;OI=1;OV=8.1;CP=58;RM=1024;",
        "a10 plus": "RE=2018.11;SZ=71.8x151x9.6;WT=150;DS=5.34;RS=480x960;OI=1;OV=8.1 Or;CP=5;RM=1024;",
        "a5 easy tm": "->a5 easy",
        "a5 easy": "RE=2015.08;SZ=62.5x125x9.9;WT=121;DS=4.0;RS=480x800;OI=1;OV=5.1;CP=24;RM=1024;",
        "allwatch V": "RE=2018.06;SZ=40x42x9.4;WT=39;DS=1.3;RS=240x240;",
        "ax4 nano plus": "RE=2015.06;SZ=108x189x10;WT=300;DS=7.0;RS=600x1024;OI=1;OV=4.4.2;CP=187;RM=512;",
        "ax4 nano": "RE=2014.01;SZ=107.8x190.9x9.3;WT=256.2;DS=7.0;RS=480x800;OI=1;OV=4.2;RM=512;",
        "ax501q": "RE=2016.06;SZ=192x108.5x9.9;WT=253.6;DS=7.0;RS=1024x600;OI=1;OV=5.1;CP=163;RM=1024;",
        "city plus": "RE=2013.08;SZ=122x192.5x7.9;WT=289;DS=7.0;RS=600x1024;OI=1;OV=4.1;RM=512;",
        "city": "RE=2013.10;SZ=122x192.5x7.9;WT=282;DS=7.0;RS=600x1024;OI=1;OV=4.1.1;RM=512;",
        "e2 jump": "RE=2015.02;SZ=66.8x134.6x11;WT=152;DS=4.5;RS=480x854;OI=1;OV=4.4.2;CP=7;RM=1024",
        "e2 living": "RE=2014.05;SZ=61.9x124.6x9.5;WT=119.8;DS=4.0;RS=480x800;OI=1;OV=4.4.2;RM=512;",
        "e3 living": "RE=2015.08;SZ=65.8x133.3x9.8;WT=135.5;DS=4.5;RS=480x854;OI=1;OV=5.1;CP=79;RM=1024",
        "e3 sign": "RE=2015.03;SZ=75.9x152.5x9.3;WT=161.9;DS=5.5;RS=720x1280;OI=1;OV=4.4.2;CP=7;RM=2048;",
        "hybrid s": "RE=2018.12;SZ=44x50.6x14.6;WT=88;DS=1.22;RS=240x240;",
        "hybrid t": "RE=2018.12;SZ=44x50.6x14.6;WT=88;DS=1.22;RS=240x240;",
        "impera s": "RE=2014.06;SZ=72.1x144.9x8.8;WT=156.2;DS=5.0;RS=720x1280;OI=4;OV=8.1;CP=33;RM=1024;",
        "p10 max": "RE=2019.04;SZ=77.7x160.7x8.3;WT=172;DS=5.99;RS=480x960;OI=1;OV=8.1 Or;CP=405;RM=1024;",
        "p10 style": "RE=2018.10;SZ=70x145.8x8.8;WT=140;DS=5.34;RS=480x960;OI=1;OV=8.1 Or;CP=8;RM=1024;",
        "p4 emagic": "RE=2016.03;SZ=64.4x125.6x10;WT=105;DS=4.0;RS=480x800;OI=1;OV=5.1;CP=5;RM=1024;",
        "p5 emagic": "RE=2016.03;SZ=66.5x133.1x9;WT=105;DS=4.5;RS=480x800;OI=1;OV=5.1;CP=5;RM=1024;",
        "p5 energy": "RE=2015.09;SZ=66.2x134.2x11.2;WT=156.5;DS=4.5;RS=480x854;OI=1;OV=5.1;CP=310;RM=1024;",
        "p5 life": "RE=2014.12;SZ=66.4x133.2x9;WT=127;DS=4.5;RS=480x854;OI=1;OV=5.0;CP=7;RM=1024;",
        "p6 emagic": "RE=2016.03;SZ=72x145x9.7;WT=138;DS=5.0;RS=480x854;OI=1;OV=5.1;CP=163;RM=1024;",
        "p6 energy lite": "RE=2016.06;SZ=72x140.8x9.6;WT=175;DS=5.0;RS=480x854;OI=1;OV=6.0;CP=5;RM=1024;",
        "p6 energy mini": "RE=2017.03;SZ=72.4x143x10.3;WT=175;DS=5.0;RS=480x854;OI=1;OV=6.0;CP=9;RM=1024;",
        "p6 energy": "RE=2015.01;SZ=71.5x144.5x10.3;WT=176.6;DS=5.0;RS=720x1280;OI=1;OV=5.0;CP=7;RM=1024;",
        "p6 life": "RE=2014.05;SZ=73.2x145.9x8.9;WT=147.3;DS=5.0;RS=720x1280;OI=1;OV=4.4.2;RM=1024;",
        "p6 lite": "RE=2016.03;SZ=72x145x9.7;WT=138;DS=5.0;RS=480x854;OI=1;OV=5.1;CP=163;RM=1024;",
        "p6 pro": "RE=2015.11;SZ=73x144x8.1;WT=154;DS=5.0;RS=720x1280;OI=1;OV=5.1;RM=1024;",
        "p6 quad": "RE=2013.04;SZ=70x135x8.6;WT=131.9;DS=4.65;RS=720x1280;OI=1;OV=4.1.2;RM=1024;",
        "p7 pro": "RE=2016.09;SZ=72x144x9;WT=165;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=9;RM=2048;",
        "p7 seon": "RE=2014.07;SZ=77.7x157x8.4;WT=146.4;DS=5.5;RS=720x1280;OI=1;OV=4.4.2;CP=182;RM=1024;",
        "p7 xtreme": "RE=2014.04;SZ=66.3x139.7x8.5;WT=143.1;DS=4.7;RS=720x1280;OI=1;OV=4.2.2;CP=2;RM=1024;",
        "p8 energy mini": "RE=2016.01;SZ=72x143.3x8.9;WT=200;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=5;RM=2048;",
        "p8 energy pro": "RE=2016.02;SZ=81.2x160.9x8.4;WT=209.8;DS=6.0;RS=1080x1920;OI=1;OV=5.1;CP=118;RM=3072;",
        "p8 energy": "RE=2015.09;SZ=76x152x8.5;WT=212;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=79;RM=2048;",
        "p8 pro": "RE=2018.01;SZ=75.2x153x8;WT=186.5;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=9;RM=2048;AL=P8 PRO;",
        "p9 energy lite (2017)": "RE=2017.06;SZ=72.4x148.7x9.1;WT=161;DS=5.2;RS=720x1280;OI=1;OV=7.0;CP=118;RM=3072;",
        "p9 energy lite": "RE=2016.09;SZ=73.2x149x8.2;WT=174;DS=5.3;RS=720x1280;OI=1;OV=6.0;CP=40;RM=3072;",
        "p9 energy mini tm": "->p9 energy mini",
        "p9 energy mini": "RE=2016.09;SZ=71x144x9.9;WT=181;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=9;RM=3072;",
        "p9 energy": "RE=2016.09;SZ=75.3x152.3x8.2;WT=183;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=117;RM=4096;",
        "v1 viper i 4g": "RE=1970.01;SZ=68.3x137.3x9.6;WT=149.9;DS=4.7;RS=480x854;OI=1;OV=4.4.2;CP=7;RM=1024;",
        "v1 viper i4g tm": "->v1 viper i 4g",
        "v1 viper i4g": "->v1 viper i 4g",
        "v2 viper e": "RE=2016.04;SZ=66x132x9.1;WT=133.2;DS=4.5;RS=480x854;OI=1;OV=5.1;CP=5;RM=1024;",
        "v2 viper i 4g": "RE=2016.04;SZ=72x143.5x8.3;WT=144.5;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=79;RM=2048;",
        "v2 viper i tm": "->v2 viper i",
        "v2 viper i4g": "->v2 viper i 4g",
        "v2 viper i": "RE=2015.12;SZ=72x143.3x8.9;WT=153;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=5;RM=1024;",
        "v2 viper s": "RE=2016.10;SZ=74.5x146x8.2;WT=141.6;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=118;RM=3072;",
        "v2 viper x plus": "RE=2015.10;SZ=77x154x7.2;WT=155.3;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=118;RM=3072;",
        "v2 viper x": "RE=2015.10;SZ=77x154x7.2;WT=155.3;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=118;RM=1024;",
        "v2 viper xe": "RE=2016.10;SZ=76.6x154.4x9.2;WT=178;DS=5.5;RS=720x1280;OI=1;OV=6.0;CP=9;RM=3072;",
        "v2 viper": "RE=2015.10;SZ=67x137.2x7.9;WT=143;DS=4.7;RS=720x1280;OI=1;OV=5.0;CP=79;RM=1024",
        "v3 viper": "RE=2018.01;SZ=71.8x148.3x8.1;WT=143.6;DS=5.5;RS=720x1440;OI=1;OV=8.0;CP=9;RM=3072;",
        "v4 viper pro": "RE=2020.01;SZ=82x171x8.8;WT=191.6;DS=6.8;RS=640x1352;OI=1;OV=9.0;CP=405;RM=2048;",
        "v4 viper": "RE=2019.09;SZ=70.9x145.8x8.5;WT=138;DS=5.7;RS=720x1520;OI=1;OV=9.0;CP=44;RM=2048;",
        "viva 1003g lite": "RE=2019.09;SZ=171.7x246.2x10.7;WT=505.2;DS=10.1;RS=800x1280;OI=1;OV=8.1;CP=163;RM=1024;",
        "viva 1003g": " RE=2019.08;SZ=171.7x246.2x10.7;WT=479.4;DS=10.1;RS=800x1280;OI=1;OV=9.0;CP=163;RM=2048;",
        "viva 803g": "RE=2020.04;SZ=124x208x9.5;WT=330;DS=8.0;RS=800x1280;OI=1;OV=9.0;CP=163;RM=1024;",
        "viva c703": "RE=2019.10;SZ=108.3x188.5x9.7;WT=242;DS=7.0;RS=600x1024;OI=1;OV=8.1;RM=1024;",
        "viva h10 lte": "RE=2014.12;SZ=244x174x10.5;WT=510.2;DS=10.1;RS=1280x800;OI=1;OV=4.4.4;CP=120;RM=1024;",
        "viva h1001 lte": "RE=2016.03;SZ=257.5x155x10;WT=510;DS=10.1;RS=1280x800;OI=1;OV=5.1;CP=74;RM=1024;",
        "viva h7": "SZ=108x188x9;WT=265;DS=7.0;RS=600x1024;OI=1;OV=4.4.4;CP=120;RM=1024;",
        "viva h8 lte": "RE=2014.06;SZ=210x122x9;WT=324.4;DS=8.0;RS=1280x800;OI=1;OV=4.4.4;CP=120;RM=1024;",
        "viva home": "RE=2019.07;SZ=266.3x418.5x19.5;WT=2018.3;DS=17.3;RS=1080x1920;OI=1;OV=9.0;CP=144;RM=2048;",
        "vivah10lte": "->viva h10 lte",
        "x1 soul": "RE=2013.11;SZ=69x143x7.9;WT=129.4;DS=5.0;RS=1080x1920;OI=1;OV=4.2;CP=112;RM=2048;",
        "x2 soul mini": "RE=2014.10;SZ=67.4x139.8x5.2;WT=97;DS=4.8;RS=720x1280;OI=1;OV=4.4.2;CP=2;RM=1024;",
        "x2 soul style": "RE=2015.11;SZ=71.2x142.4x7;WT=128;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=79;RM=2048;",
        "x2 soul": "RE=2014.05;SZ=70.1x145.1x5.6;WT=129;DS=5.0;RS=1080x1920;OI=1;OV=4.2.2;CP=2;RM=2048;",
        "x2 twin": "RE=2014.08;SZ=70.1x140.3x8;WT=149.7;DS=5.0;RS=720x1280;OI=1;OV=4.4.2;RM=1024;",
        "x3 soul lite": "RE=2016.06;SZ=70.6x145.3x8.5;WT=142.7;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=79;RM=3072;",
        "x3 soul mini": "RE=2016.02;SZ=69.5x142.6x7.2;WT=129;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=79;RM=1024;",
        "x3 soul plus": "RE=2016.07;SZ=75.3x153x7.6;WT=175;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=117;RM=4096;",
        "x3 soul pro": "RE=2016.02;SZ=74.9x154.3x7;WT=144;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=117;RM=4096;",
        "x3 soul style": "RE=2016.06;SZ=75.6x154.5x8.2;WT=162.2;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=118;RM=3072;",
        "x3 soul": "RE=2016.01;SZ=74.6x151.9x6.9;WT=147.6;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=118;RM=3072;",
        "x4 soul infinity l": "RE=2017.09;SZ=72.6x152x8.5;WT=155;DS=5.7;RS=720x1440;OI=1;OV=7.0;CP=9;RM=2048;",
        "x4 soul infinity n": "RE=2017.09;SZ=72.6x152x8.5;WT=155;DS=5.7;RS=720x1440;OI=1;OV=7.0;CP=162;RM=4096;",
        "x4 soul infinity plus": "RE=2017.09;SZ=75.2x158.7x8;WT=156;DS=6.0;RS=1080x2160;OI=1;OV=7.1;CP=232;RM=6144;",
        "x4 soul infinity s": "RE=2017.09;SZ=72.6x152x8.5;WT=155;DS=5.7;RS=720x1440;OI=1;OV=7.0;CP=162;RM=3072;",
        "x4 soul infinity z": "RE=2017.09;SZ=72.6x152x8.5;WT=155;DS=5.7;RS=720x1440;OI=1;OV=7.0;CP=162;RM=4096;",
        "x4 soul lite": "RE=2017.06;SZ=75.9x155.4x7.8;WT=150.4;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=40;RM=3072;",
        "x4 soul mini s": "RE=2017.06;SZ=72x142x8.4;WT=145;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=9;RM=1024;",
        "x4 soul mini": "RE=2017.04;SZ=73.9x143.5x7.7;WT=144;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=9;RM=2048;",
        "x4 soul style": "RE=2017.03;SZ=74.5x156.5x8.3;WT=181;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=117;RM=4096;",
        "x4 soul vision": "RE=2017.09;SZ=75.6x153.1x10.3;WT=202;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=40;RM=3072;",
        "x4 soul xtreme": "RE=2017.06;SZ=83.3x166.4x9.1;WT=226.9;DS=6.0;RS=1080x1920;OI=1;OV=7.0;CP=353;RM=4096;",
        "x4 soul": "RE=2017.02;SZ=76.4x154.2x7.4;WT=167.5;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=117;RM=4096;",
        "x5 soul mini": "RE=2018.08;SZ=70.2x149.4x8.8;WT=156;DS=5.67;RS=720x1498;OI=1;OV=8.1;CP=405;RM=2048;",
        "x5 soul pro": "RE=2018.06;SZ=75.5x155x7.9;WT=210;DS=6.2;RS=1080x2246;OI=1;OV=8.1;CP=290;RM=4096;",
        "x5 soul style": "RE=2018.11;SZ=76.3x157.2x8.1;WT=168;DS=6.2;RS=720x1500;OI=1;OV=8.1;CP=171;RM=3072;",
        "x5 soul": "RE=2018.08;SZ=72x149x7.9;WT=185;DS=5.86;RS=720x1520;OI=1;OV=8.1;CP=171;RM=4096;AL=X5_Soul;",
        "x6 soul mini": "RE=2019.05;SZ=76.4x158.3x8.3;WT=175.7;DS=6.2;RS=720x1520;OI=1;OV=9.0;CP=171;RM=2048;",
        "x6 soul xtreme": "RE=2019.04;SZ=74.3x157x8.9;WT=176.6;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=114;RM=4096;",
        "x7 soul pro": " RE=2020.05;SZ=76.8x161.9x8.3;WT=193;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=19;RM=4096;",
        "x7 soul style": "RE=2020.05;SZ=75.2x157.6x8.3;WT=184.7;DS=6.21;RS=720x1520;OI=1;OV=9.0;CP=63;RM=4096;"
    },
    "altek": {
        "leo": "DS=3.2;RS=480x800;SZ=56.1x111.9x15.5;WT=140;RE=;RM=;CP=;OI=1;OV=2.1;"
    },
    "amazon": {
        "fire hd 10 (2017)": "DS=10.1;RS=1920x1200;SZ=262x159x9.8;WT=500;RE=2017.10;RM=2048;CP=99;OI=1;OV=5.1;",
        "fire hd 10 (2019)": "DS=10.1;RS=1920x1200;SZ=262x159x9.8;WT=504;RE=2019.09;RM=2048;CP=97;OI=1;OV=9;",
        "fire hd 10": "DS=10.1;RS=1280x800;SZ=262x159x7.7;WT=432;RE=2015.09;RM=1024;CP=100;OI=1;OV=5;",
        "fire hd 6": "DS=6.3;RS=1280x800;SZ=104.1x170.2x10.2;WT=290;RE=2014.09;RM=1024;CP=100;OI=1;OV=4.4;",
        "fire hd 7": "DS=7;RS=1280x800;SZ=190.5x127x10.7;WT=337;RE=2014.09;RM=1024;CP=100;OI=1;OV=4.4;",
        "fire hd 8 (2020)": "DS=8;RS=1280x800;SZ=202x137x9.7;WT=355;RE=;RM=2048;CP=101;OI=1;OV=9;",
        "fire hdx 8.9": "DS=8.9;RS=2560x1600;SZ=231.1x157.5x7.6;WT=389;RE=2014.09;RM=2048;CP=94;OI=1;OV=4.4;",
        "fire phone": "DS=4.7;RS=720x1280;SZ=66x140x9;WT=160;RE=2014.06;RM=2048;CP=94;OI=1;OV=4.2.2;",
        "kfarwi": "->fire hd 6",
        "kfaswi": "->fire hd 7",
        "kfmawi": "->fire hd 10 (2019)",
        "kfonwi": "->fire hd 8 (2020)",
        "kfsawi": "->fire hdx 8.9",
        "kfsuwi": "->fire hd 10 (2017)",
        "kftbwi": "->fire hd 10",
        "kftt": "->kindle fire hd",
        "kindle fire hd": "DS=7;RS=1280x800;SZ=193x137x10.3;WT=395;RE=2012.09;RM=1024;CP=29;OI=1;OV=4;",
        "kindle fire": "DS=7;RS=1024x600;SZ=190x120x11.4;WT=413;RE=2011.09;RM=512;CP=;OI=1;OV=2.3;",
        "sd4930ur": "->fire phone",
        "fire hd 8 plus (2020)": "DS=8;RS=800x1280;SZ=137x202x9.7;WT=355;RE=;RM=3072;CP=101;OI=1;OV=9;",
        "fire hd 8": "DS=8;RS=800x1280;SZ=128x214x7.7;WT=311;RE=2015.09;RM=1024;CP=;OI=1;OV=5;",
        "fire": "DS=7;RS=600x1024;SZ=115x191x10.6;WT=313;RE=2015.09;RM=1024;CP=;OI=1;OV=5;",
        "kindle fire 2": "DS=7;RS=1024x600;SZ=189x120x11.5;WT=400;RE=2012.09;RM=1024;CP=190;OI=1;OV=4;",
        "kindle fire hd (2013)": "DS=7;RS=1280x800;SZ=191x128x10.6;WT=345;RE=2013.09;RM=1024;CP=;OI=1;OV=4.2.2;",
        "kindle fire hd 8.9 4g lte": "DS=8.9;RS=1920x1200;SZ=240x164x8.8;WT=575;RE=2012.09;RM=1024;CP=95;OI=1;OV=4;",
        "kindle fire hd 8.9": "DS=8.9;RS=1920x1200;SZ=240x164x8.8;WT=567;RE=2012.09;RM=1024;CP=95;OI=1;OV=4;",
        "kindle fire hdx 7": "DS=7;RS=1920x1200;SZ=186x128x9;WT=311;RE=2013.09;RM=2048;CP=94;OI=1;OV=4.2.2;",
        "kindle fire hdx 8.9": "DS=8.9;RS=2560x1600;SZ=231x158x7.8;WT=384;RE=2013.09;RM=2048;CP=94;OI=1;OV=4.2.2;",
        "silk/1.0.22.153 10033210": "->kindle fire"
    },
    "amgoo": {
        "am410": "->unico",
        "am518": "->c1",
        "c1": "RM=1024;DS=5;RS=480x854;OI=1;OV=7;",
        "unico": "DS=4.5;RS=480x800;RM=1024;OI=1;OV=7;"
    },
    "amoi": {
        "a862w": "DS=4.5;RS=540x960;SZ=67.3x134.5x10.6;WT=150;RM=1024;CP=200;OI=1;OV=4.1;SM=2;",
        "a100": "DS=1.5;RS=128x128;SZ=45.0x85.5x18;WT=;RE=;RM=;CP=;OS=;",
        "a102": "DS=1.5;RS=128x128;SZ=45.0x85.5x18;WT=75;RE=;RM=;CP=;OS=;",
        "a10": "DS=1.4;RS=128x128;SZ=43x107.5x15.5;WT=;RE=;RM=;CP=;OS=;",
        "a200": "DS=1.5;RS=128x128;SZ=41.0x82.0x15;WT=;RE=;RM=;CP=;OS=;",
        "a203": "DS=1.5;RS=128x128;SZ=46.0x101.0x13.4;WT=72;RE=;RM=;CP=;OS=;",
        "a208": "DS=1.8;RS=128x160;SZ=47.0x92.0x16;WT=85;RE=;RM=;CP=;OS=;",
        "a726w": "DS=4;RS=480x800;SZ=;WT=;RE=;RM=512;CP=;OI=1;OV=4.2;",
        "a900w": "DS=5.5;RS=720x1280;SZ=;WT=;RE=;RM=1024;CP=7;OI=1;OV=4.2;",
        "a920w": "DS=5;RS=720x1280;SZ=70.5x140x8.3;WT=160;RE=;RM=2048;CP=112;OI=1;OV=4.2;",
        "a928w": "DS=5;RS=1080x1920;SZ=71x140x8;WT=140;RE=;RM=2048;CP=2;OI=1;OV=4.4;",
        "a955w": "DS=5.5;RS=1080x1920;SZ=;WT=;RE=;RM=2048;CP=182;OI=1;OV=4.4;",
        "e72": "DS=2;RS=176x220;SZ=44.8x100.0x14.8;WT=85;RE=;RM=;CP=;OS=;",
        "e78": "DS=2.5;RS=320x240;SZ=62.0x115.0x12.7;WT=131;RE=;RM=61.44;CP=;OS=;",
        "f100": "DS=2.2;RS=240x320;SZ=;WT=;RE=;RM=;CP=;OS=;",
        "f106": "DS=2.6;RS=240x320;SZ=54x121x11;WT=96;RE=;RM=;CP=;OS=;",
        "f16": "DS=2.2;RS=176x220;SZ=;WT=;RE=;RM=;CP=;OS=;",
        "f200e": "DS=2.4;RS=240x320;SZ=50.8x116.5x13;WT=91;RE=;RM=;CP=;OS=;",
        "f203": "DS=2.4;RS=240x320;SZ=51x113x15.5;WT=111;RE=;RM=;CP=;OS=;",
        "f205": "DS=3;RS=240x400;SZ=51x109x16.7;WT=110;RE=;RM=;CP=;OS=;",
        "f208": "DS=3.2;RS=240x400;SZ=54.5x112.5x12.6;WT=;RE=;RM=;CP=;OS=;",
        "f209": "DS=2.6;RS=240x320;SZ=55x121x16.1;WT=128;RE=;RM=;CP=;OS=;",
        "f210": "DS=3.2;RS=240x400;SZ=57x110x13;WT=104;RE=;RM=;CP=;OS=;",
        "f30": "DS=2.8;RS=240x400;SZ=49x102x16.5;WT=96;RE=;RM=;CP=;OS=;",
        "f320": "DS=2.8;RS=240x400;SZ=51x105x16;WT=100;RE=;RM=;CP=;OS=;",
        "f36": "DS=2.4;RS=240x320;SZ=51.6x105.6x12.8;WT=100;RE=;RM=;CP=;OS=;",
        "f56": "DS=2.8;RS=240x400;SZ=49x102x16.95;WT=98;RE=;RM=;CP=;OS=;",
        "f60": "DS=2.6;RS=240x400;SZ=48x101x16.4;WT=102;RE=;RM=;CP=;OS=;",
        "gsm6711a": "DS=2.5;RS=320x240;SZ=62.8x115.5x13.2;WT=126;RE=;RM=;CP=;OS=;",
        "m300": "DS=2;RS=144x176;SZ=46.0x104.0x12.9;WT=80;RE=;RM=;CP=;OS=;",
        "m3": "DS=1.8;RS=128x160;SZ=46.0x93.0x16.5;WT=92;RE=;RM=;CP=;OS=;",
        "n310": "DS=4;RS=320x480;SZ=66x120x12.5;WT=136;RE=;RM=;CP=;OS=;",
        "n60": "DS=3.2;RS=240x400;SZ=55.5x110.5x12.5;WT=104;RE=;RM=;CP=;OS=;",
        "n700": "DS=3.5;RS=320x480;SZ=62x115x13;WT=125;RE=;RM=;CP=;OI=1;OV=2.3;",
        "n79": "DS=3.5;RS=320x480;SZ=63x115x12.8;WT=125;RE=;RM=;CP=145;OI=1;OV=2.2;",
        "n800": "DS=2.8;RS=480x640;SZ=59.0x109.0x15.7;WT=135;RE=;RM=;CP=;OS=;",
        "n807": "DS=4;RS=480x800;SZ=64x124x11;WT=140;RE=;RM=;CP=;OI=1;OV=4;",
        "n808": "DS=4.3;RS=480x800;SZ=69x128x12.5;WT=;RE=;RM=;CP=;OI=1;OV=4;",
        "n810": "DS=2.8;RS=240x320;SZ=59.0x109.0x16.1;WT=135;RE=;RM=61.44;CP=;OS=;",
        "n828p": "DS=4.5;RS=540x960;SZ=;WT=;RE=;RM=1024;CP=7;OI=1;OV=4.2;",
        "n89": "DS=4;RS=480x800;SZ=65x125x10.95;WT=140;RE=;RM=512;CP=;OI=1;OV=2.3;",
        "n8i": "DS=2.8;RS=240x320;SZ=59.6x118.8x15.6;WT=138;RE=;RM=61.44;CP=;OS=;",
        "s500": "DS=2.4;RS=240x320;SZ=49.6x118x11.8;WT=100;RE=;RM=;CP=;OS=;",
        "s501": "DS=2.4;RS=240x320;SZ=50.5x118.5x11.77;WT=100;RE=;RM=;CP=;OS=;",
        "s520": "DS=2.6;RS=240x400;SZ=51x106x16;WT=120;RE=;RM=;CP=;OS=;",
        "s525": "DS=2.8;RS=240x400;SZ=51.4x110.7x15.4;WT=128;RE=;RM=;CP=;OS=;",
        "s532": "DS=2.8;RS=240x400;SZ=51x108x16.5;WT=110;RE=;RM=;CP=;OS=;",
        "s58": "DS=2.8;RS=240x400;SZ=50.6x106x12;WT=112;RE=;RM=;CP=;OS=;",
        "s600": "DS=3;RS=240x400;SZ=51x110x16.5;WT=155;RE=;RM=;CP=;OS=;",
        "s660": "DS=3.2;RS=240x400;SZ=53x113x17.9;WT=110;RE=;RM=;CP=;OS=;",
        "wma8505": "DS=2;RS=176x220;SZ=49.0x112.0x12.5;WT=;RE=;RM=;CP=;OS=;",
        "wma8507": "DS=2;RS=176x220;SZ=46.0x95.0x17.1;WT=93;RE=;RM=;CP=;OS=;",
        "wma8508": "DS=2;RS=176x220;SZ=48.0x95.0x15.9;WT=;RE=;RM=;CP=;OS=;",
        "wma8512": "DS=2;RS=176x220;SZ=45.4x100.0x13.9;WT=87;RE=;RM=;CP=;OS=;",
        "wma8515": "DS=2;RS=176x220;SZ=45.4x100.0x13.9;WT=87;RE=;RM=;CP=;OS=;",
        "wma8517": "DS=2.2;RS=176x220;SZ=48.6x98.6x18.2;WT=;RE=;RM=;CP=;OS=;",
        "wma8701a": "DS=2.2;RS=240x320;SZ=51.6x100.6x16;WT=120;RE=;RM=;CP=;OS=;",
        "wma8703": "DS=2.2;RS=240x320;SZ=48.0x109.4x13.8;WT=100;RE=;RM=;CP=;OS=;",
        "wma8709": "DS=2.2;RS=240x320;SZ=45.0x102.7x14;WT=;RE=;RM=;CP=;OS=;",
        "wma8710": "DS=2.2;RS=240x320;SZ=47.6x97.0x14.4;WT=;RE=;RM=;CP=;OS=;",
        "wma9109": "DS=2;RS=176x220;SZ=;WT=;RE=;RM=;CP=;OS=;",
        "wma9110": "DS=2;RS=176x220;SZ=;WT=;RE=;RM=;CP=;OS=;"
    },
    "airtel": {
        "imagine": "DS=4.9;DP=200;RS=480x854;RM=2008;GP=55;OI=1;OV=12;"
    },
    "visual land": {
        "elite10qhpro": "->prestige elite 10qh pro",
        "elite10qh": "->prestige elite 10qh",
        "prestige elite 10qh": "DS=7.09;DP=213;RS=1280x800;RM=2045;OI=1;OV=11;",
        "prestige elite 10qh pro": "DS=7.55;DP=200;RS=1280x800;RM=1998;OI=1;OV=13;"
    },
    "dialog": {
        "blaze mini": "DS=3.89;DP=240;RS=480x800;RM=443;OI=1;OV=8.1;"
    },
    "apple": {
        "iphone 11": "DS=6.1;RS=828x1792;SZ=75.7x150.9x8.3;WT=194;RE=2019.09;RM=4096;CP=59;OS=iOS 13;SM=1;",
        "iphone 11 pro": "DS=5.8;RS=1125x2436;SZ=71.4x144x8.1;WT=188;RE=2019.09;RM=4096;CP=59;OS=iOS 13;SM=1",
        "iphone 11 pro max": "DS=6.5;RS=1242x2688;SZ=77.8x158x8.1;WT=226;RE=2019.09;RM=4096;CP=59;OS=iOS 13;SM=1",
        "homepod": "WT=2500;",
        "ipad 2": "DS=9.7;RS=1024x768;SZ=241.2x185.7x8.8;WT=613;RE=2011.03;RM=512;CP=105;OS=iOS 9.3.5;",
        "ipad 4": "DS=9.7;RS=2048x1536;SZ=241.2x185.7x9.4;WT=662;RE=2012.10;RM=1024;CP=104;OS=iOS 10.3.4;",
        "ipad air 2": "DS=9.7;RS=2048x1536;SZ=240x169.5x6.1;WT=437;RE=2014.10;RM=2048;CP=106;OS=iOS 8.1;",
        "ipad air": "DS=9.7;RS=2048x1536;SZ=240x169.5x7.5;WT=469;RE=2013.10;RM=1024;CP=108;OS=iOS 7;",
        "ipad mini 3": "DS=7.9;RS=2048x1536;SZ=200x134.7x7.5;WT=341;RE=2014.10;RM=1024;CP=108;OS=iOS 8.1;",
        "ipad mini 4": "DS=7.9;RS=2048x1536;SZ=203.2x134.6x6.1;WT=304;RE=2015.09;RM=2048;CP=108;OS=iOS 8.1;",
        "ipad mini": "DS=7.9;RS=1024x768;SZ=200x134.7x7.2;WT=312;RE=2012.10;RM=512;CP=105;OS=iOS 8.1;",
        "ipad": "DS=9.7;RS=1024x768;SZ=243x190x13;WT=730;RE=2010.01;RM=256;CP=123;OS=;",
        "iphone 12 mini": "RE=2020.10;SZ=64.2x131.5x7.4;WT=135;DS=5.4;RS=1080x2340;OS=iO;CP=122;RM=4096;",
        "a2399": "->iphone 12 mini",
        "a2176": "->iphone 12 mini",
        "a2398": "->iphone 12 mini",
        "a2400": "->iphone 12 mini",
        "iphone 12 pro max": "RE=2020.10;SZ=78.1x160.8x7.4;WT=228;DS=6.7;RS=1284x2778;OS=iOS 14;CP=122;RM=6144;",
        "a2411": "->iphone 12 pro max",
        "a2342": "->iphone 12 pro max",
        "a2410": "->iphone 12 pro max",
        "a2412": "->iphone 12 pro max",
        "iphone 12 pro": "RE=2020.10;SZ=71.5x146.7x7.4;WT=189;DS=6.1;RS=1170x2532;OS=iOS 14;CP=122;RM=6144;",
        "a2407": "->iphone 12 pro",
        "a23418": "->iphone 12 pro",
        "a2406": "->iphone 12 pro",
        "a2408": "->iphone 12 pro",
        "iphone 12": "RE=2020.10;SZ=71.5x146.7x7.4;WT=164;DS=6.1;RS=1170x2532;OS=iOS 14;CP=122;RM=4096;",
        "iphone 3gs": "DS=3.5;RS=320x480;SZ=62.1x115.5x12.3;WT=135;RE=2009.06;RM=256;CP=;OS=;",
        "iphone 4s": "RE=2011.10;SZ=58.6x115.2x9.3;WT=140;DS=3.5;RS=640x960;OS=;CP=105;RM=512;",
        "iphone 4 verizon": "DS=3.5;RS=640x960;SZ=58.6x115.2x9.3;WT=137;RE=2011.01;RM=512;CP=123;OS=;",
        "iphone 4": "DS=3.5;RS=640x960;SZ=58.6x114.3x9.3;WT=137;RE=2010.06;RM=512;CP=123;OS=;",
        "iphone 5": "RE=2012.09;SZ=58.6x123.8x7.6;WT=112;DS=4.0;RS=640x1136;OS=;CP=124;RM=1024;",
        "iphone 5c": "RE=2013.09;SZ=59.2x124.4x9;WT=132;DS=4.0;RS=640x1136;OS=;CP=124;RM=1024;",
        "iphone 5s": "RE=2013.09;SZ=58.6x123.8x7.6;WT=112;DS=4.0;RS=640x1136;OS=;CP=108;RM=1024;",
        "iphone 6 plus": "RE=2014.09;SZ=77.8x158.1x7.1;WT=172;DS=5.5;RS=1080x1920;OS=;CP=125;RM=1024;",
        "iphone 6": "RE=2014.09;SZ=67x138.1x6.9;WT=129;DS=4.7;RS=750x1334;OS=iO;CP=125;RM=1024;",
        "iphone 6s plus": "RE=2015.09;SZ=77.9x158.2x7.3;WT=192;DS=5.5;RS=1080x1920;OS=;CP=126;RM=2048;",
        "iphone 6s": "RE=2015.09;SZ=67.1x138.3x7.1;WT=143;DS=4.7;RS=750x1334;OS=;CP=126;RM=2048;",
        "iphone 7 plus": "RE=2016.09;SZ=77.9x158.2x7.3;WT=188;DS=5.5;RS=1080x1920;OS=;CP=127;RM=3072;",
        "iphone 7": "RE=2016.09;SZ=67.1x138.3x7.1;WT=138;DS=4.7;RS=750x1334;OS=;CP=127;RM=2048;",
        "iphone 8 plus": "RE=2017.09;SZ=78.1x158.4x7.5;WT=202;DS=5.5;RS=1080x1920;OS=;CP=128;RM=3072;",
        "iphone 8": "RE=2017.09;SZ=67.3x138.4x7.3;WT=148;DS=4.7;RS=750x1334;OS=;CP=128;RM=2048;",
        "iphone se (2020)": "RE=2020.04;SZ=67.3x138.4x7.3;WT=148;DS=4.7;RS=750x1334;OS=;CP=129;RM=3072;",
        "a2275": "->iphone se (2020)",
        "a2296": "->iphone se (2020)",
        "a2298": "->iphone se (2020)",
        "iphone se": "RE=2016.04;SZ=58.6x123.8x7.6;WT=113;DS=4.0;RS=640x1136;OS=;CP=126;RM=2048;",
        "a1662": "->iphone se",
        "a1723": "->iphone se",
        "a1724": "->iphone se",
        "iphone x": "RE=2017.09;SZ=70.9x143.6x7.7;WT=174;DS=5.8;RS=1125x2436;OS=;CP=128;RM=3072;",
        "a1865": "->iphone x",
        "a1901": "->iphone x",
        "a1902": "->iphone x",
        "a1903": "->iphone x",
        "iphone xr": "RE=2018.09;SZ=75.7x150.9x8.3;WT=194;DS=6.1;RS=828x1792;OS=;CP=130;RM=3072;",
        "a2105": "->iphone xr",
        "a1984": "->iphone xr",
        "a2107": "->iphone xr",
        "a2108": "->iphone xr",
        "a2106": "->iphone xr",
        "iphone xs max": "RE=2018.09;SZ=77.4x157.5x7.7;WT=208;DS=6.5;RS=1242x2688;OS=;CP=130;RM=4096;",
        "a1921": "->iphone xs max",
        "a2101": "->iphone xs max",
        "a2102": "->iphone xs max",
        "a2104": "->iphone xs max",
        "iphone xs": "RE=2018.09;SZ=70.9x143.6x7.7;WT=177;DS=5.8;RS=1125x2436;OS=;CP=130;RM=4096;",
        "a2097": "->iphone xs",
        "a1920": "->iphone xs",
        "a2100": "->iphone xs",
        "a2098": "->iphone xs",
        "iphone": "DS=3.5;RS=320x480;SZ=61x115x11.6;WT=135;RE=2007.01;RM=102.4;CP=;OS=;",
        "ipod5,1": "->ipod touch 5",
        "ipod touch 5": "DS=4;RS=640x1136;SZ=58.6x123.4x6.1;WT=88;RE=2012.09;RM=512;CP=105;OS=;",
        "a1509": "->ipod touch 5",
        "a1421": "->ipod touch 5",
        "ipod touch": "DS=3.5;RS=320x480;SZ=61x109x8;WT=119;RE=2007.09;RM=102.4;CP=;OS=;",
        "watch se 40mm": "DS=1.6;RS=324x394;SZ=;WT=;RE=2020.09;RM=1024;CP=193;OS=;",
        "watch se 44mm": "DS=1.8;RS=368x448;SZ=;WT=;RE=2020.09;RM=1024;CP=193;OS=;",
        "watch se (40mm)": "->watch se 40mm",
        "watch se (44mm)": "->watch se 44mm",
        "watch series 5 40mm": "DS=1.6;RS=324x394;SZ=34x40x10.74;WT=30.8;RE=2019.09;RM=1024;CP=193;OS=;",
        "watch series 5 44mm": "DS=1.8;RS=368x448;SZ=38x44x10.74;WT=36.5;RE=2019.09;RM=1024;CP=193;OS=;",
        "watch series 6 40mm": "DS=1.6;RS=324x394;SZ=;WT=;RE=2020.09;RM=1024;CP=192;OS=;",
        "watch series 6 44mm": "DS=1.8;RS=368x448;SZ=;WT=;RE=2020.09;RM=1024;CP=192;OS=;",
        "watch series 5 (40mm)": "->watch series 5 40mm",
        "watch series 5 (44mm)": "->watch series 5 44mm",
        "watch series 6 (40mm)": "->watch series 6 40mm",
        "watch series 6 (44mm)": "->watch series 6 44mm",
        "ipad3,6": "->ipad 4",
        "iphone8,4": "->iphone se",
        "ipad4,1": "->ipad air",
        "iphone12,1": "->iphone 11",
        "iphone7,2": "->iphone 6",
        "iphone8,1": "->iphone 6s",
        "ipad3,4": "->ipad 4",
        "iphone12,3": "->iphone 11 pro",
        "iphone7,1": "->iphone 6 plus",
        "iphone8,2": "->iphone 6s plus",
        "iphone10,2": "->iphone 8 plus",
        "iphone9,4": "->iphone 7 plus",
        "iphone9,2": "->iphone 7 plus",
        "iphone13,4": "->iphone 12 pro max",
        "iphone13,3": "->iphone 12 pro",
        "iphone13,2": "->iphone 12",
        "iphone10,3": "->iphone x",
        "iphone10,5": "->iphone 8 plus",
        "iphone11,6": "->iphone xs max",
        "iphone12,5": "->iphone 11 pro max",
        "iphone12,8": "->iphone se (2020)",
        "iphone10,6": "->iphone x",
        "iphone ios/16.6": "->iphone",
        "iphone13,1": "->iphone 12 mini",
        "iphone2,1": "->iphone 3gs",
        "iphone3,1": "->iphone 4",
        "iphone5,1": "->iphone 5",
        "iphone5,2": "->iphone 5",
        "iphone5,4": "->iphone 5c",
        "iphone6,2": "->iphone 5s",
        "iphone11,8": "->iphone xr",
        "iphone11,2": "->iphone xs",
        "iphone9,3": "->iphone 7",
        "iphone10,4": "->iphone 8",
        "iphone9,1": "->iphone 7",
        "iphone4,1": "->iphone 4s",
        "iphone/6s ios/11.3": "->iphone 6s",
        "iphone10,1": "->iphone 8",
        "iphone6,1": "->iphone 5s",
        "iphone5,3": "->iphone 5c",
        "ipad5,3": "->ipad air 2",
        "ipad5,2": "->ipad mini 4",
        "ipad5,1": "->ipad mini 4",
        "ipad5,4": "->ipad air 2",
        "ipad4,8": "->ipad mini 3",
        "ipad4,9": "->ipad mini 3",
        "ipad4,2": "->ipad air",
        "ipad4,3": "->ipad air",
        "ipad3,5": "->ipad 4",
        "ipad2,5": "->ipad mini",
        "ipad2,7": "->ipad mini",
        "ipad2,3": "->ipad 2",
        "ipad2,4": "->ipad 2",
        "ipad2,1": "->ipad 2",
        "watch6,2": "->watch series 6 44mm",
        "watch6,3": "->watch series 6 40mm",
        "watch6,4": "->watch series 6 44mm"
    },
    "archos": {
        "101 cobalt": "DS=10.1;RS=1024x600;SZ=272.5x161x12.15;WT=690;RM=1024;CP=72;RE=2015.10;OI=1;OV=4.2;",
        "101 neon": "DS=10.1;RS=1024x600;SZ=272x161x12.1;WT=690;RE=2014.10;RM=1024;CP=102;OI=1;OV=4.2;",
        "101 platinum": "DS=10.1;RS=1280x800;SZ=261x161x9.9;WT=530;RM=1024;CP=93;OI=1;OV=7;",
        "101 titanium": "DS=10.1;RS=1280x800;SZ=263x174x10.5;WT=650;RE=2013.01;RM=1024;CP=73;OI=1;OV=4.1;",
        "101 xenon": "DS=10.1;RS=1280x800;SZ=246x175x10;WT=630;RM=1024;CP=107;OI=1;OV=4.2;",
        "101 xs 2": "DS=10.1;RS=1280x800;SZ=273x169x10.1;WT=636;RE=2013.11;RM=2048;CP=80;OI=1;OV=4.2;",
        "101b helium 4g": "DS=10.1;RS=1280x800;SZ=261x161x9.9;WT=560;RM=1024;CP=121;OI=1;OV=6.0;",
        "101g9": "DS=10.1;RS=1280x800;SZ=276x167x12.6;WT=675;RE=;RM=;CP=;OI=1;OV=4;",
        "101 g9": "->101g9",
        "40 titanium": "DS=4;RS=480x800;SZ=65x125x8.5;WT=124;RE=2014.02;RM=512;CP=24;OI=1;OV=4.2.2;",
        "45 platinum": "RE=2013;SZ=71.8x142.5x9.2;WT=150;DS=4.5;RS=540x960;OI=1;OV=4.1.2;CP=110;RM=1024;",
        "50 helium 4g": "RE=2014;SZ=71.5x145x9;WT=160;DS=5.0;RS=720x1280;OI=1;OV=4.3;CP=111;RM=1024;",
        "50 oxygen": "RE=2013;SZ=70.5x143x9.9;WT=130;DS=5.0;RS=1080x1920;OI=1;OV=4.2.2;CP=112;RM=1024;",
        "50 platinum": "RE=2013;SZ=72.4x143.4x8.9;WT=160.2;DS=5.0;RS=540x960;OI=1;OV=4.1.2;CP=110;RM=1024;",
        "50 power": "RE=2016.07;SZ=72.2x145x9.2;WT=148;DS=5.0;RS=720x1280;OI=1;OV=5.0;RM=2048;CP=56;",
        "50 titanium": "DS=5;RS=540x960;SZ=73.7x144.5x9.9;WT=160;RE=2013;RM=512;CP=24;OI=1;OV=4.2.2;",
        "53 titanium": "DS=5.3;RS=480x854;SZ=76.6x152.7x10.1;WT=200;RE=2013;RM=512;CP=24;OI=1;OV=4.2.2;",
        "55 platinum": "DS=5.5;RS=720x1280;SZ=72.6x144x8.7;WT=164;RM=1024;CP=88;OI=1;OV=5.1;SM=2;",
        "70 titanium": "DS=7;RS=1024x600;SZ=198x115x8.6;WT=280;RE=2013;RM=1024;CP=73;OI=1;OV=4.1;",
        "70b titanium": "CP=73;",
        "80 cobalt": "DS=8;RS=1024x768;SZ=203x153.5x11.5;WT=470;RE=2012.11;RM=1024;CP=73;OI=1;OV=4;",
        "80 titanium": "DS=8;RS=1024x768;SZ=200x154x9.9;WT=440;RE=2013.01;RM=1024;CP=73;OI=1;OV=4.1;",
        "97 carbon": "DS=9.7;RS=1024x768;SZ=239x184x11.5;WT=620;RE=2012;RM=1024;CP=73;OI=1;OV=4;",
        "97 xenon": "DS=9.7;RS=1024x768;SZ=248x188x11.5;WT=650;RE=2012;RM=512;CP=73;OI=1;OV=4;",
        "ac101bhe": "->101b helium 4g",
        "gamepad": "DS=7;RS=1024x600;SZ=229.8x118.7x15.4;WT=330;RE=2012.08;RM=1024;CP=73;OI=1;OV=4.1;",
        "a70gp": "->gamepad",
        "oxygen 63": "RE=2019.02;SZ=75.8x159.2x9.3;WT=162;DS=6.26;RS=720x1520;OI=1;OV=9.0;CP=109;RM=4096;",
        "yl-50 power": "->50 power",
        "oxygen 57": "RE=2019.02;SZ=70.7x147.8x9.3;WT=150;DS=5.71;RS=720x1520;OI=1;OV=9.0;CP=109;RM=3072;",
        "50 graphite": "RE=2017.02;SZ=72.7x144x8.9;WT=160;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=9;RM=1024;",
        "oxygen 68xl": "RE=2019.02;SZ=81.6x173.5x9;WT=214;DS=6.85;RS=640x1352;OI=1;OV=9.0;CP=47;RM=3072;",
        "saphir 50x": "RE=2018.04;SZ=76x146.6x13;WT=210;DS=5.0;RS=720x1280;OI=1;OV=7.0 ;CP=113;RM=2048;",
        "diamond omega": "DS=5.73;RS=1080x2040;SZ=72.7x147.5x8.5;WT=170;RE=2017.10;RM=8192;CP=25;OI=1;OV=7.1;",
        "diamond": "RE=2019.02;SZ=74.1x158.7x8.6;WT=166;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=114;RM=4096;",
        "diamond alpha +": "RE=2017.08;SZ=72.5x146.7x7.5;WT=155;DS=5.2;RS=1080x1920;OI=1;OV=6.0;CP=115;RM=6144;",
        "diamond tab": "RE=2017.08;SZ=255x163x8;WT=510;DS=10.1;RS=2560x1600;OI=1;OV=7.0;CP=116;RM=4096;",
        "55 graphite": "RE=2017.02;SZ=77.2x157.8x7.8;WT=;DS=5.5;RS=720x1280;OI=1;OV=7.0;CP=9;RM=2048;",
        "sense 55s": "RE=2017.06;SZ=74.2x142.5x8;WT=130;DS=5.2;RS=1080x1920;OI=1;OV=7.0;RM=2048;CP=69;",
        "sense 50x": "RE=2017.06;SZ=78.9x153x12.6;WT=223;DS=5.0;RS=1080x1920;OI=1;OV=7.0;CP=69;RM=3072;",
        "diamond alpha": "RE=2017.06;SZ=72.5x146.7x7.5;WT=155;DS=5.2;RS=1080x1920;OI=1;OV=6.0;CP=115;RM=4096;",
        "diamond gamma": "RE=2017.06;SZ=77.0x155.6x8.0;WT=162;DS=5.5;RS=720x1280;OI=1;OV=7;CP=35;RM=3072;SM=2;",
        "50 saphir": "RE=2017.02;SZ=75.9x146.6x13.9;WT=;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=9;RM=2048;",
        "55b cobalt": "RE=2017.01;SZ=79x155x0;WT=188;DS=5.5;RS=720x1280;OI=1;OV=6.0;CP=10;RM=1024;",
        "50b cobalt": "RE=2017.01;SZ=72x144x0;WT=160;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=10;RM=1024;",
        "diamond 2 plus": "RE=2016.05;SZ=73.8x148.3x8.3;WT=193;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=117;RM=4096;",
        "55 cobalt plus": "RE=2016.01;SZ=77x152.5x8.3;WT=130;DS=5.5;RS=720x1280;OI=1;OV=5.1.1;CP=56;RM=2048;",
        "50 cobalt": "RE=2016.01;SZ=71.5x141.5x9.2;WT=135;DS=5.0;RS=720x1280;OI=1;OV=5.1.1;CP=56;RM=1024;",
        "diamond plus": "RE=2015.09;SZ=76.4x152.6x8.4;WT=160;DS=5.5;RS=1080x1920;OI=1;OV=5.1.1;CP=118;RM=2048;",
        "diamond s": "RE=2015.09;SZ=71.5x145x6.5;WT=118;DS=5.0;RS=720x1280;OI=1;OV=5.1.1;CP=118;RM=2048;",
        "50d helium 4g": "RE=2015.07;SZ=72.2x146x8.4;WT=154;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=17;RM=1024;",
        "50b helium 4g": "RE=2014.10;SZ=71.5x145x9;WT=160;DS=5.0;RS=720x1280;OI=1;OV=4.4.4;CP=17;RM=1024;",
        "50 diamond": "RE=2014.10;SZ=70.4x146x8;WT=142;DS=5.0;RS=1080x1920;OI=1;OV=4.4.4;CP=22;RM=2048;",
        "40 cesium": "RE=2014.09;SZ=;WT=;DS=4.0;RS=480x800;OI=4;OV=8.1;CP=119;RM=512;",
        "45c platinum": "RE=2014.08;SZ=67.5x133x8.9;WT=138;DS=4.5;RS=480x854;OI=1;OV=4.4.2;CP=7;RM=512;",
        "40c titanium": "RE=2014.02;SZ=65x126x10;WT=110;DS=4.0;RS=480x800;OI=1;OV=4.4;CP=24;RM=512;",
        "50b platinum": "RE=2014.08;SZ=73x146.8x8.3;WT=160;DS=5.0;RS=540x960;OI=1;OV=4.4.2;CP=7;RM=512;",
        "80 helium 4g": "DS=8;RS=1024x768;SZ=213x155x11.3;WT=430;RE=2014.02;RM=1024;CP=111;OI=1;OV=4.3;",
        "64 xenon": "RE=2014.02;SZ=90.6x170.7x9.3;WT=232;DS=6.4;RS=720x1280;OI=1;OV=4.2.2;CP=7;RM=1024;",
        "50c oxygen": "RE=2014.02;SZ=69.8x145x7.64;WT=140;DS=5.0;RS=720x1280;OI=1;OV=4.2.2;CP=2;RM=1024;",
        "40b titanium": "RE=2014.02;SZ=61x125x8.5;WT=115;DS=4.0;RS=480x800;OI=1;OV=4.2.2;RM=512;CP=24;",
        "45 helium 4g": "RE=2014;SZ=67x135x9.8;WT=140;DS=4.5;RS=480x800;OI=1;OV=4.3;CP=111;RM=1024;",
        "53 platinum": "RE=2013;SZ=78x153.6x9.3;WT=189.9;DS=5.3;RS=540x960;OI=1;OV=4.1.2;CP=110;RM=1024;",
        "101 oxygen": "DS=10.1;RS=1920x1200;SZ=240x172x10;WT=510;RE=2015.08;RM=2048;CP=82;OI=1;OV=4.4.4;",
        "101 helium 4g": "DS=10.1;RS=1280x800;SZ=250x174x10;WT=538;RE=;RM=1024;CP=120;OI=1;OV=4.4;",
        "101 internet tablet": "DS=10.1;RS=1024x600;SZ=270x150x12;WT=480;RE=;RM=;CP=;OI=1;OV=2.2;",
        "101 saphir": "DS=10.1;RS=1280x800;SZ=181x265.4x13.4;WT=600;RE=;RM=1024;CP=144;OI=1;OV=7;",
        "101 xs": "DS=10.1;RS=1280x800;SZ=273x170x8;WT=600;RE=;RM=1024;CP=95;OI=1;OV=4.0.3;",
        "28 internet tablet": "DS=2.8;RS=240x320;SZ=54x100x9;WT=68;RE=;RM=;CP=;OI=1;OV=2.2;",
        "32 internet tablet": "DS=3.2;RS=240x400;SZ=55x105x9;WT=72;RE=;RM=;CP=;OI=1;OV=2.2;",
        "43 internet tablet": "DS=4.3;RS=854x480;SZ=65x135x9;WT=130;RE=;RM=;CP=;OI=1;OV=2.2;",
        "45 titanium": "DS=4.5;RS=480x854;SZ=68.2x133.8x10;WT=152;RE=;RM=512;CP=24;OI=1;OV=4.2.2;",
        "45b helium 4g": "DS=4.5;RS=480x854;SZ=67x135x9.75;WT=140;RE=;RM=512;CP=17;OI=1;OV=4.4.4;",
        "5 internet tablet": "DS=4.8;RS=480x800;SZ=;WT=286;RE=;RM=256;CP=;OI=1;OV=1.6;",
        "50 cesium": "DS=5;RS=720x1280;SZ=72.5x147x8.5;WT=150;RE=2015.08;RM=1024;CP=10;OS=;",
        "50 helium plus": "DS=5;RS=720x1280;SZ=71x143x9.3;WT=161;RE=2015.06;RM=1024;CP=56;OI=1;OV=5.1;",
        "50c helium 4g": "DS=5;RS=480x854;SZ=73.5x146x9.1;WT=;RE=;RM=1024;CP=154;OI=1;OV=4.4.4;",
        "50e helium 4g": "DS=5;RS=720x1280;SZ=72.5x147x8.5;WT=150;RE=;RM=1024;CP=10;OI=1;OV=5.1;",
        "55 helium plus": "DS=5.5;RS=720x1280;SZ=78x155x8.3;WT=168;RE=2015.06;RM=1024;CP=56;OI=1;OV=5.1;",
        "7 home tablet": "DS=7;RS=480x800;SZ=107x203x12;WT=388;RE=;RM=;CP=;OI=1;OV=2.1;",
        "70 helium 4g": "DS=7;RS=1024x600;SZ=190x108.5x9.4;WT=260;RE=;RM=1024;CP=120;OI=1;OV=4.4;",
        "70 internet tablet": "DS=7;RS=800x480;SZ=201x114x14;WT=400;RE=;RM=;CP=;OI=1;OV=2.2;",
        "70b internet tablet": "DS=7;RS=1024x600;SZ=201x115x11.5;WT=330;RE=2011.12;RM=;CP=;OI=1;OV=3.2;",
        "8 home tablet": "DS=8;RS=800x600;SZ=220x263x12;WT=800;RE=;RM=;CP=;OS=;",
        "80 cesium": "DS=8;RS=800x1280;SZ=123x215x8.6;WT=360;RE=;RM=1024;CP=155;OS=;",
        "80 g9": "DS=8;RS=1024x768;SZ=226x155x11.7;WT=482;RE=;RM=;CP=;OI=1;OV=4;",
        "80b helium 4g": "DS=8;RS=1280x800;SZ=210x122x9.3;WT=320;RE=;RM=1024;CP=120;OI=1;OV=4.4;",
        "90 neon": "DS=9;RS=800x480;SZ=239x148x11.6;WT=480;RE=;RM=1024;CP=;OI=1;OV=4.2;",
        "97 neon": "DS=9.7;RS=1024x768;SZ=241x186x11.5;WT=648;RE=;RM=;CP=;OI=1;OV=4.2;",
        "97 titanium hd": "DS=9.7;RS=2048x1536;SZ=240x184x9;WT=640;RE=;RM=1024;CP=;OI=1;OV=4.1;",
        "arnova 7": "DS=7;RS=800x480;SZ=120x193.3x12.6;WT=340;RE=;RM=;CP=;OI=1;OV=2.2;",
        "childpad": "DS=7;RS=800x480;SZ=223x142x12.2;WT=380;RE=;RM=1024;CP=;OI=1;OV=4;",
        "diamond 2 note": "DS=6;RS=1440x2560;SZ=82.7x158.35x8.7;WT=150;RE=2016.02;RM=3072;CP=85;OI=1;OV=6;",
        "yl-archos 50 power": "->50 power",
        "55plus": "->55 cobalt plus",
        "ac50bhe": "->50b helium 4g"
    },
    "arian space": {
        "70": "DS=7.0;RS=1024x600;RM=512;OI=1;OV=5.1;SZ=191x110x10;WT=260;CP=331;",
        "71": "DS=7.1;RS=1024x600;RM=512;OI=1;OV=7.0;SM=2;SZ=191x110x10;WT=260;CP=330;",
        "80": "DS=8;RS=1024x600;RM=512;OI=1;OV=7.0;SM=2;SZ=208x123x10;WT=312;CP=287;",
        "100": "DS=10.1;RS=1024x600;RM=512;OI=1;OV=7.0;SM=2;SZ=250x159x10;WT=508;CP=330;",
        "100 st1004pg": "->100",
        "71 st7002pg": "->71",
        "70 st7001rw": "->70",
        "80 ss8003pg": "->80"
    },
    "ark": {
        "benefa1": "->benefit a1",
        "benefit a1": "RS=480x800;DS=4;RM=512;CP=17;OI=1;OV=4.4;SZ=63.9x123.6x10;WT=125;SM=2;"
    },
    "armphone": null,
    "arnova": null,
    "arris": null,
    "artel": null,
    "artizlee": null,
    "asano": null,
    "asanzo": {
        "a2": "DS=5.0;RS=480x960;SZ=66.2x143x9.75;WT=160;RE=2019.03;RM=1024;CP=58;OI=1;OV=8.1;"
    },
    "ask": null,
    "assistant": {
        "agio": "OI=1;OV=6.0;SM=2;WT=136;SZ=71x142x8.7;RS=720x1280;DS=5;CP=5;RM=1024;RE=2017;",
        "ap-108": "->cetus",
        "as-5432": "->agio",
        "cetus": "DS=10;RS=1920x1200;SZ=241x171x9.5;WT=;RE=2018;OI=1;OV=8.0;RM=2048;CP=40;"
    },
    "asus": {
        "zenpad 10": "DS=10.1;RS=1920x1200;SZ=251.77x172.17x8.95;WT=490;RE=2017.05;RM=2048;CP=74;OI=1;OV=7;",
        "p00c": "->zenpad 10",
        "z300m": "->zenpad 10",
        "p021": "->zenpad 10",
        "p023": "->zenpad 10",
        "p028": "->zenpad 10",
        "p01t 1": "->zenpad 10",
        "p00l": "->zenpad 10",
        "zenfone zoom": "RE=2015.09;SZ=78.8x158.9x12;WT=185;DS=5.5;RS=1080x1920;OI=1;OV=5.0;CP=209;RM=4096;",
        "zx551ml": "->zenfone zoom",
        "z00xs": "->zenfone zoom",
        "zenfone v live": "RE=2017.09;SZ=72.6x146.6x7.6;WT=147.1;DS=5.2;RS=1080x1920;OI=1;OV=7;CP=173;RM=4096;",
        "a009": "->zenfone v live",
        "v520kl": "->zenfone v live",
        "zenfone v": "->zenfone v live",
        "a006": "->zenfone v live",
        "zenfone selfie": "RE=2015.06;SZ=77.2x156.5x10.8;WT=170;DS=5.5;RS=1080x1920;OI=1;OV=5.0;CP=22;RM=2048;",
        "z00ud": "->zenfone selfie",
        "z00udh": "->zenfone selfie",
        "z00udc": "->zenfone selfie",
        "z00udb": "->zenfone selfie",
        "zd551kl": "->zenfone selfie",
        "zenfone pegasus": "RE=2014.12;SZ=73x146x9.9;WT=140;DS=5.0;RS=720x1280;OI=1;OV=4.4;CP=154;RM=2048;",
        "x002": "->zenfone pegasus",
        "x003": "->zenfone pegasus",
        "zenfone pegasus 5000": "CP=118;RE=2016;RM=2048;OI=1;OV=5.1;SZ=76.4x155x9;RS=1080x1920;DS=5.5;SM=2;",
        "x005": "->zenfone pegasus 5000",
        "zenfone pegasus 3s max": "RE=2017.01;SZ=73.7x149.5x8.9;WT=175;DS=5.2;RS=720x1280;OI=1;OV=7;CP=40;RM=3072;",
        "zc521tl": "->zenfone pegasus 3s max",
        "x00gd": "->zenfone pegasus 3s max",
        "zenfone pegasus 2 plus": "RE=2015.07;SZ=75.5x151.8x8.1;WT=156;DS=5.5;RS=1080x1920;OI=1;OV=5.1.1;CP=22;RM=3072;",
        "x550": "->zenfone pegasus 2 plus",
        "zenfone max": "RE=2016.05;SZ=77.5x156x10.6;WT=202;DS=5.5;RS=720x1280;OI=1;OV=6.0.1;CP=22;RM=2048;",
        "zc550kl": "->zenfone max",
        "z010d": "->zenfone max",
        "zenfone max pro": "->zenfone max pro m1",
        "zb602kl": "->zenfone max pro",
        "zenfone max pro m2": "RE=2018.12;SZ=75.5x157.9x8.5;WT=175;DS=6.26;RS=1080x2280;OI=1;OV=8.1;CP=61;RM=3072;",
        "zb631kl": "->zenfone max pro m2",
        "x01bda": "->zenfone max pro m2",
        "zenfone max pro m1": "RE=2018.04;SZ=76x159x8.5;WT=180;DS=5.99;RS=1080x2160;OI=1;OV=8.1;CP=205;RM=3072;",
        "zb601kl": "->zenfone max pro m1",
        "x00t": "->zenfone max pro m1",
        "x00td": "->zenfone max pro m1",
        "x00tdb": "->zenfone max pro m1",
        "x00tda": "->zenfone max pro m1",
        "x00tde": "->zenfone max pro m1",
        "zenfone max plus m1": "RE=2017.11;SZ=73x152.6x8.8;WT=160;DS=5.7;RS=1080x2160;OI=1;OV=7;CP=162;RM=2048;",
        "x018d": "->zenfone max plus m1",
        "zb570tl": "->zenfone max plus m1",
        "zenfone max m2": "RE=2018.12;SZ=76.3x158.4x7.7;WT=160;DS=6.26;RS=720x1520;OI=1;OV=8.1;CP=64;RM=3072;",
        "zb633kl": "->zenfone max m2",
        "x01ad": "->zenfone max m2",
        "x01bd": "->zenfone max m2",
        "zenfone max m1": "RE=2018.02;SZ=70.9x147.3x8.7;WT=150;DS=5.5;RS=720x1440;OI=1;OV=8;CP=20;RM=2048",
        "zb555kl": "->zenfone max m1",
        "x00pd": "->zenfone max m1",
        "x00ps": "->zenfone max m1",
        "zenfone live": "RE=2017.02;SZ=71.7x141.2x8;WT=120;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=17;RM=2048;",
        "a007": "->zenfone live",
        "z00yd": "->zenfone live",
        "zb501kl": "->zenfone live",
        "zb553kl": "->zenfone live;RE=2017.10;SZ=75.9x155.7x7.9;WT=144;DS=5.5;RS=720x1280;OI=1;OV=7;CP=20;RM=2048;",
        "zenfone live l1": "RE=2018.05;SZ=71.8x147.3x8.2;WT=140;DS=5.5;RS=720x1440;OI=1;OV=8.0;CP=20;SM=2;RM=2048;",
        "x00rd": "->zenfone live l1;RM=1024;",
        "g552kl": "->zenfone live l1;RM=1024;OI=1;OV=7.0;",
        "za550kl": "->zenfone live l1",
        "zenfone lite l1": "RE=2018.10;SZ=71.8x147.3x8.2;WT=140;DS=5.45;RS=720x1440;OI=1;OV=8.0;CP=43;RM=2048;",
        "za551kl": "->zenfone lite l1",
        "g553kl": "->zenfone lite l1",
        "zenfone go": "RE=2015.12;SZ=67x135x10.1;WT=133.5;DS=4.5;RS=480x854;OI=1;OV=5.1;CP=58;RM=1024;",
        "zc451tg": "->zenfone go",
        "x009da": "->zb450kl",
        "zb450kl": "->zenfone go;RE=2016.07;CP=17;OI=1;OV=6;DS=4.5;WT=135;SZ=66.7x136.5x11.2;",
        "x007d": "->zenfone go",
        "l001": "->zenfone go",
        "x013d": "->zb551kl",
        "x013dc": "->zb551kl",
        "x013da": "->zb551kl",
        "x013db": "->zb551kl",
        "zb551kl": "->zenfone go;RE=2016.04;SZ=76.9x151x10.7;WT=160;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=78;RM=2048;",
        "x00bd": "->zb500kg",
        "zb500kg": "->zenfone go",
        "zb500kl": "->zenfone go",
        "z00vd": "->zenfone go",
        "z00sd": "->zc451tg",
        "zenfone go tv": "DS=5.5;RS=720x1280;SZ=76.9x151x10.7;WT=160;CP=111;RM=2048;SM=2;OI=1;OV=5.1;RE=2016.05;",
        "g550kl": "->zenfone go tv",
        "zenfone go plus": "RE=2016.04;SZ=66.7x136.5x11.2;WT=125;DS=4.5;RS=480x854;OI=1;OV=5.1;CP=33;RM=1024;",
        "zb452kg": "->zenfone go plus",
        "x014d": "->zenfone go plus",
        "zenfone c": "DS=4.5;RS=480x854;SZ=67x136.5x10.9;WT=150;RE=2015.01;RM=1024;CP=206;OI=1;OV=4.4.2;",
        "z007": "->zenfone c",
        "zc451cg": "->zenfone c",
        "a002": "->zenfone ar",
        "a002a": "->zenfone ar",
        "v570kl": "->zenfone ar",
        "zs571kl": "->zenfone ar",
        "zenfone ar": "DS=5.7;RS=1440x2560;SZ=77.7x158.67x8.95;WT=170;RE=2017.01;RM=6144;CP=208;OI=1;OV=7;",
        "zs671ks": "->zenfone 7 pro",
        "i002dd": "->zenfone 7 pro",
        "zenfone 7 pro": "DS=6.7;RS=1080x2400;SZ=77.28x165.08x9.6;WT=230;RE=2020.08;RM=8192;CP=207;OI=1;OV=11;",
        "i002d": "->zenfone 7",
        "zs670ks": "->zenfone 7",
        "zenfone 7": "RE=2020.08;SZ=77.3x165.1x9.6;WT=230;DS=6.67;RS=1080x2400;OI=1;OV=10;CP=207;RM=6144;",
        "zenfone 6": "RE=2014.01;SZ=84.3x166.9x9.9;WT=196;DS=6.0;RS=720x1280;OI=1;OV=4.3 ;CP=131;RM=2048;",
        "t00g": "->zenfone 6",
        "z002": "->zenfone 6",
        "i01wd": "->zs630kl",
        "i01wdx": "->zs630kl",
        "zs630kl": "->zenfone 6;RE=2019.05;SZ=75.4x159.1x9.2;WT=190;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=197;RM=6144;",
        "zenfone 5z": "RE=2018.02;SZ=75.7x153x7.9;WT=165;DS=6.2;RS=1080x2246;OI=1;OV=8.0;CP=198;RM=4096;",
        "z01rd": "->zenfone 5z",
        "zs620kl": "->zenfone 5z",
        "zenfone 5": "DS=5;RS=720x1280;SZ=72.8x148.2x10.3;WT=145;RE=2014.01;RM=2048;CP=131;OI=1;OV=4.3;",
        "t00j": "->zenfone 5",
        "t00f": "->a501cg",
        "a502cg": "->zenfone 5",
        "a500cg": "->zenfone 5",
        "x00qda": "->zenfone 5",
        "x00qd": "->ze620kl",
        "x00qsa": "->ze620kl",
        "zf620kl": "->ze620kl",
        "ze620kl": "->>zenfone 5;DS=6.2;RS=1080x2246;SZ=75.65x153x7.7;WT=165;RE=2018.02;RM=6144;CP=205;OI=1;OV=9;",
        "a500kl": "->zenfone 5 lte",
        "zenfone 5 lte": "RE=2014.06;SZ=72.8x148.2x10.3;WT=145;DS=5.0;RS=720x1280;OI=1;OV=4.4.2;CP=111;RM=1024;",
        "t00p": "->zenfone 5 lte",
        "zenfone 5 lite": "RE=2018.09;SZ=76.2x160.6x7.8;WT=168;DS=6.0;RS=1080x2160;OI=1;OV=7.1.1;CP=19;RM=3072;",
        "zc600kl": "->zenfone 5 lite",
        "x017d": "->zenfone 5 lite",
        "x017da": "->zenfone 5 lite",
        "t00k": "->zenfone 5 lite",
        "x00lda": "->zenfone 4 selfie",
        "zd553kl": "->zenfone 4 selfie",
        "zenfone 4 selfie": "DS=5.5;RS=720x1280;SZ=76.2x155.7x7.9;WT=144;RE=2017.08;RM=4096;CP=43;OI=1;OV=8.1;",
        "zenfone 4 selfie pro": "RE=2017.08;SZ=74.8x154x6.9;WT=147;DS=5.5;RS=1080x1920;OI=1;OV=7 ;CP=204;RM=4096;",
        "zd552kl": "->zenfone 4 selfie pro",
        "z01md": "->zenfone 4 selfie pro",
        "z01mda": "->zenfone 4 selfie pro",
        "zenfone 4 pro": "RE=2017.08;SZ=75.6x156.9x7.6;WT=175;DS=5.5;RS=1080x1920;OI=1;OV=7.1.1;CP=25;RM=6144;",
        "zs551kl": "->zenfone 4 pro",
        "z01gd": "->zenfone 4 pro",
        "z01gs": "->zenfone 4 pro",
        "zc554kl": "->zenfone 4 max",
        "x015d": "->zenfone 4 max plus",
        "zenfone 4 max plus": "DS=5.5;RS=720x1280;SZ=76.9x154x8.9;WT=181;RE=2017.07;OI=1;OV=7;CP=20;RM=3072;",
        "z012s": "->zenfone 3",
        "z012db": "->zenfone 3",
        "z012d": "->zenfone 3",
        "z012da": "->zenfone 3",
        "z012dc": "->zenfone 3",
        "z012de": "->zenfone 3",
        "z017db": "->zenfone 3",
        "z017d": "->zenfone 3",
        "z017da": "->zenfone 3",
        "ze552kl": "->zenfone 3",
        "zenfone 3": "DS=5.5;RS=1080x1920;SZ=77.38x152.59x7.69;WT=155;RE=2016.05;RM=4096;CP=204;OI=1;OV=6.0.1;",
        "z01hd": "->zenfone 3 zoom",
        "z01hda": "->zenfone 3 zoom",
        "ze553kl": "->zenfone 3 zoom",
        "zenfone 3 zoom": "DS=5.5;RS=1080x1920;SZ=77x154.3x7.99;WT=170;RE=2017.02;RM=4096;CP=204;OI=1;OV=6.1;",
        "a001": "->zenfone 3 ultra",
        "zenfone 3 ultra": "DS=6.8;RS=1080x1920;SZ=93.9x186.4x6.8;WT=233;RE=2016.05;RM=4096;CP=115;OI=1;OV=6;",
        "x00dd": "->zc553kl",
        "zc553kl": "->zenfone 3 max;DS=5.5;RS=1080x1920;SZ=76.24x151.4x8.3;WT=175;RE=2016;OI=1;OV=6.0;RM=2048;CP=43;",
        "x00ds": "->zenfone 3 max",
        "x008dc": "->zenfone 3 max",
        "x008db": "->zenfone 3 max",
        "zenfone 3 max": "DS=5.2;RS=720x1280;SZ=73.7x149.5x8.55;WT=148;RE=2016;RM=3072;CP=86;OI=1;OV=7;",
        "zenfone 3 laser": "DS=5.5;RS=1080x1920;SZ=76x149x7.9;WT=150;RE=2016.07;RM=4096;CP=43;OI=1;OV=7.1;",
        "zc551kl": "->zenfone 3 laser",
        "z01bd": "->zenfone 3 laser",
        "z01bs": "->zenfone 3 laser",
        "z01bda": "->zenfone 3 laser",
        "ze551ml": "->zenfone 2;WT=170;OI=1;OV=5.0.1;",
        "ux360cak": "->zenbook flip",
        "zenbook flip": "DS=13.3;RS=1920x1080;SZ=322.8x219.9x13.7;WT=1290;RM=8192;CP=203;RE=2019.04;OS=Windows 10;",
        "ze500cl": "->zenfone 2;DS=5;RS=720x1280;SZ=71.5x148.1x10.9;WT=155;CP=18;OI=1;OV=5;",
        "zenfone 2": "DS=5.5;RS=1080x1920;SZ=77.2x152.5x10.9;WT=170;RE=2015.03;RM=2048;CP=16;OI=1;OV=6;SM=2;",
        "ze500kl": "->zenfone 2 laser",
        "zenfone 2 laser": "DS=5;RS=720x1280;SZ=71.5x143.7x10.5;WT=140;RE=2015.08;RM=2048;CP=17;OI=1;OV=5;SM=2;",
        "zenfone 2e": "DS=5;RS=720x1280;SZ=71.4x148.1x10.9;WT=155;RE=2015.07;RM=1024;CP=18;OI=1;OV=5;",
        "ze554kl": "->zenfone 4",
        "z01kda": "->zenfone 4",
        "z01ks": "->zenfone 4",
        "x00ld": "->zenfone 4",
        "z01kd": "->zenfone 4",
        "zenfone 4": "DS=5.5;RS=1080x1920;SZ=75.2x155.4x7.7;WT=165;RE=2017.08;RM=4096;CP=19;OI=1;OV=7.1;SM=2;TT=71200;",
        "zc520kl": "->zenfone 4 max",
        "x00hd": "->zenfone 4 max",
        "x00id": "->zenfone 4 max",
        "x00kd": "->zenfone 4 max",
        "zenfone 4 max": "DS=5.2;RS=720x1280;SZ=73.3x150.5x8.73;WT=156;RE=2017.10;RM=2048;CP=20;OI=1;OV=7;SM=2;",
        "fonepad 8": "DS=8;RS=800x1280;SZ=120x214x8.9;WT=328;RE=2014.06;RM=2048;CP=16;OI=1;OV=4.4;",
        "fonepad note 6": "DS=6;RS=1080x1920;SZ=88.8x164.8x10.3;WT=210;RE=2013.10;RM=2048;CP=131;OI=1;OV=4.4;",
        "fonepad": "DS=7;RS=1280x800;SZ=120.1x196.4x10.4;WT=340;RE=2013.02;RM=1024;CP=132;OI=1;OV=4.1;",
        "k00g": "->fonepad note 6",
        "k016": "->fonepad 8",
        "me172v": "->memo pad",
        "me301t": "->memo pad smart 10",
        "me371mg": "->fonepad",
        "memo pad 10": "DS=10.1;RS=1280x800;SZ=256x174x9.9;WT=525;RE=2014.10;RM=1024;CP=134;OI=1;OV=4.4.2;",
        "k00f": "->memo pad 10",
        "memo pad 7": "DS=7;RS=1280x800;SZ=189.3x113.7x9.6;WT=295;RE=;RM=1024;CP=135;OI=1;OV=4.4.2;",
        "k01a": "->memo pad 7",
        "k013": "->memo pad 7",
        "k00r": "->memo pad 7",
        "k007": "->memo pad 7",
        "memo pad 8": "DS=8;RS=1920x1200;SZ=213x123x7.45;WT=299;RE=2014.06;RM=2048;CP=136;OI=1;OV=4.4;",
        "k00l": "->memo pad 8",
        "k011": "->memo pad 8",
        "memo pad fhd 10": "DS=10;RS=1920x1200;SZ=264.6x182.4x9.5;WT=580;RE=2013.06;RM=2048;CP=18;OI=1;OV=4.2;",
        "me302c": "->memo pad fhd 10",
        "memo pad hd 7": "DS=7;RS=1280x800;SZ=196.8x120.6x10.8;WT=302;RE=2013.07;RM=1024;CP=12;OI=1;OV=4.2.1;",
        "k00u": "->memo pad hd 7",
        "me173x": "->memo pad hd 7",
        "memo pad smart 10": "DS=10.1;RS=1280x800;SZ=263x180.8x9.9;WT=580;RE=2013.02;RM=1024;CP=137;OI=1;OV=4.1;",
        "memo pad": "DS=7;RS=1024x600;SZ=196x119x11;WT=370;RE=2013.01;RM=1024;CP=133;OI=1;OV=4.1;",
        "zenpad z10": "RE=2016.10;SZ=242.3x166.1x7.1;WT=490;DS=9.7;RS=2048x1536;OI=1;OV=6.0;CP=328;RM=3072;",
        "p001": "->zenpad z10",
        "zenpad z8": "RE=2016.06;SZ=205.2x136.4x7.62;WT=320.1;DS=7.9;RS=2048x1536;OI=1;OV=6.0;CP=328;RM=2048;",
        "p008": "->zenpad z8",
        "zenpad 7.0": "RE=2015.08;SZ=189x110.9x8.7;WT=272;DS=7.0;RS=1280x800;OI=1;OV=5.0;CP=211;RM=2048;",
        "p01v": "->zenpad 7.0",
        "p01w": "->zenpad 7.0",
        "zenpad c 7.0": "RE=2015.06;SZ=189x108x8.4;WT=265;DS=7.0;RS=1024x600;OI=1;OV=5.0;CP=329;RM=1024;",
        "p01y s": "->zenpad c 7.0",
        "p01y": "->zenpad c 7.0",
        "p01z": "->zenpad c 7.0",
        "padfone 2": "DS=4.7;RS=720x1280;SZ=68.9x137.9x9;WT=135;RE=2012.10;RM=2048;CP=134;OI=1;OV=4.4;",
        "padfone infinity": "DS=5;RS=1080x1920;SZ=72.8x143.5x8.9;WT=145;RE=2013.02;RM=2048;CP=138;OI=1;OV=4.4;",
        "padfone mini": "DS=4;RS=480x800;SZ=119.43x199.85x13.91;WT=260;RE=2014.01;RM=1024;CP=18;OI=1;OV=4.3;",
        "padfone s": "DS=5;RS=1080x1920;SZ=72.5x143.4x10;WT=150;RE=2014.03;CP=139;RM=2048;OI=1;OV=4.4.2;",
        "padfone t004": "->padfone infinity",
        "padfone x mini": "DS=4.5;RS=854x480;SZ=66.3x132.1x12.7;WT=148.8;RE=2014.10;CP=18;RM=1024;",
        "padfone": "DS=4.3;RS=540x960;SZ=65.4x128x9.2;WT=129;RE=2011.06;RM=1024;CP=140;OI=1;OV=4.0.3;",
        "rog phone 2": "DS=6.59;RS=1080x2340;SZ=77.6x171x9.5;WT=240;RM=8192;CP=197;RE=2019.07;OI=1;OV=9;SM=2;",
        "i001d": "->rog phone 2",
        "i001da": "->rog phone 2",
        "i001db": "->rog phone 2",
        "i001dc": "->rog phone 2",
        "i001de": "->rog phone 2",
        "rog phone": "DS=6.0;RS=1080x2160;SZ=76.2x158.8x8.6;WT=200;RE=2018.06;RM=8192;CP=198;OI=1;OV=9;SM=2;",
        "rog phone 3": "DS=6.59;RS=1080x2340;SZ=78x171x9.85;WT=240;RE=2020.07;RM=8192;CP=141;OI=1;OV=10;",
        "i003d": "->rog phone 3",
        "i003dd": "->rog phone 3",
        "i005dc": "->rog phone 5",
        "i005da": "->rog phone 5",
        "zs673ks": "->rog phone 5",
        "rog phone 5": "RE=2021.05;SZ=77.3x172.8x10.3;WT=238;DS=6.78;RS=1080x2448;OI=1;OV=11;CP=305;RM=8192;",
        "zenfone 8": "RE=2021.05;SZ=68.5x148x8.9;WT=169;DS=5.9;RS=1080x2400;OI=1;OV=11;CP=305;RM=6144;",
        "zs590ks": "->zenfone 8",
        "i006d": "->zenfone 8",
        "t00e": "->padfone mini",
        "t00i": "->zenfone 4",
        "t00n": "->padfone s",
        "t00q": "->zenfone 4",
        "t00t": "->padfone x mini",
        "transformer pad tf103c": "DS=10.1;RS=1280x800;SZ=257.4x178.4x19.8;WT=1100;RE=;RM=1024;CP=135;OI=1;OV=4.4;",
        "k010": "->transformer pad tf103c",
        "x00is": "->zenfone 4 max",
        "z008": "->zenfone 2",
        "z008d": "->zenfone 2",
        "z00a": "->zenfone 2",
        "z00ad": "->zenfone 2",
        "z00ada": "->zenfone 2",
        "z00adb": "->zenfone 2",
        "z00d": "->zenfone 2",
        "z00ed": "->zenfone 2 laser",
        "z00md": "->zenfone 2 laser",
        "z00rd": "->zenfone 2 laser",
        "z00td": "->zenfone 2 laser",
        "z00wd": "->zenfone 2 laser",
        "z011d": "->zenfone 2 laser",
        "z01qd": "->rog phone",
        "zs661ks": "->rog phone 3",
        "zs600kl": "->rog phone",
        "zs660kl": "->rog phone 2",
        "ze520kl": "->zenfone 3",
        "x00tdc": "->zenfone max pro m1",
        "x009dd": "->zenfone go",
        "x009d": "->zenfone go",
        "x008d": "->zenfone 3 max",
        "padfone t00c": "->padfone mini",
        "z00ld": "->zenfone 2 laser",
        "z017dc": "->zenfone 3",
        "x018dc": "->zenfone max plus m1",
        "z010dd": "->zenfone max",
        "x00ad": "->zenfone go",
        "x008da": "->zenfone 3 max",
        "i005d": "->rog phone 5",
        "z010da": "->zenfone max",
        "zs676ks": "->rog phone 5",
        "zenfone go zb500kl": "->zenfone go",
        "i005db": "->rog phone 5",
        "asus-x01ad": "->zenfone max m2",
        "z01bdc": "->zenfone 3 laser",
        "z01bdb": "->zenfone 3 laser",
        "z011dd": "->zenfone 2 laser",
        "z010db": "->zenfone max",
        "z00ldd": "->zenfone 2 laser",
        "x00ddb": "->zenfone 3 max",
        "x00dda": "->zenfone 3 max",
        "x00adc": "->zenfone go",
        "x00ada": "->zenfone go",
        "x009db": "->zenfone go",
        "ai2205 c": "->zenfone 7",
        "ai2205 a": "->zenfone 7",
        "k017": "->memo pad 7",
        "k015": "->memo pad 8",
        "ast21": "->memo pad 8",
        "p002": "->zenpad 7.0"
    },
    "at&t": {
        "axia": "DS=5.5;RS=480x854;SZ=78.5x154.9x8.9;WT=178;RE=2019.01;OI=1;OV=8.1.0;RM=1024;CP=10;",
        "qs5509a": "->axia"
    },
    "atvio": null,
    "atom": null,
    "audiovox": null,
    "avenzo": {
        "av115": "->mob 4 4g",
        "mob 4 4g": "DS=5.0;RS=720x1280;WT=148;SZ=71.5x145x8.3;OI=1;OV=6.0;RM=1024;CP=118;",
        "mob4 4g": "->mob 4 4g"
    },
    "avh": {
        "excer 10 pro": "DS=10;RS=1280x800;OI=1;OV=7.0;RM=1024;RS=2018.09;WT=320;"
    },
    "avvio": {
        "765": "RE=2013.12;WT=110;DS=3.5;RS=320x480;SZ=63x113x13.3;RM=512;OI=1;OV=4.2;",
        "774": "DS=4;RS=480x800;SZ=65.6x124.55x9.6;WT=180;RE=2016;OI=1;OV=4.4.2;RM=512;CP=36;",
        "765765": "->765",
        "765 765": "->765",
        "colombia (2018)": "DS=5.0;RS=720x1280;SZ=73.1x144x9.5;WT=150;RM=1024;CP=5;OI=1;OV=7;",
        "colombia 2018": "->colombia (2018)",
        "avvio774": "->774"
    },
    "axxion": null,
    "azumi mobile": null,
    "bellphone": {
        "bp 100 x-plus": "DS=5.7;RM=1024;OI=1;OV=8;SM=2;",
        "bp100 x-plus": "->bp 100 x-plus"
    },
    "benq": null,
    "bitel": {
        "b8407": "RE=2014.11;DS=4;RS=480x800;SZ=63.6x125x10.3;WT=;CP=36;RM=512;SM=2;OI=1;OV=4.4;",
        "b8408": "RE=2015.06;DS=4;RS=480x800;SZ=;WT=;CP=36;RM=512;SM=1;OI=1;OV=4.4;",
        "b8409": "RE=2015.09;DS=4;RS=480x800;SZ=;WT=;CP=24;RM=512;SM=1;OI=1;OV=4.4;",
        "b9505": "DS=5;RS=480x854;SZ=72x140.1x8.7;WT=;RE=2016.08;OI=1;OV=7;RM=1024;CP=86;SM=2;"
    },
    "bitmore": {
        "mobitab 10c 3g": "DS=10.1;RS=1024x720;SZ=241.6x170.5x10.6;WT=500;RE=2016.09;CP=163;RM=1024;OI=1;OV=5.1;",
        "mobitab10c-3g": "->mobitab 10c 3g",
        "tab1011q ii": "DS=10.1;RS=1024x600;SZ=;WT=509;RE=2015.06;CP=163;RM=1024;OI=1;OV=4.4.2;"
    },
    "bkav": {
        "bphone b1115": "DS=5;RS=1080x1920;RE=2015.07;RM=3072"
    },
    "black bear": {
        "b6 master": "DS=5;RS=480x960;SZ=66.2x137.7x9.6;WT=144;CP=109;RM=1024;RE=2018.12;OI=1;OV=8.1;SM=2;",
        "b6 note x": "DS=5.5;RS=720x1280;SZ=70.6x147.9x9.4;WT=147.9;CP=109;RM=2048;RE=2018.11;OI=1;OV=8.1;SM=2;"
    },
    "uz mobile": {
        "uzbekistan": "DS=5.9;RS=720x1520;RM=4096;OI=1;OV=9;CP=40;"
    },
    "kurio": {
        "phone c14500": "OI=1;OV=4.2;RM=1024;DS=4.0;RS=480x800;SZ=63.5x121x10.5;WT=400;SM=1;RE=2015.04;CP=210;",
        "kuriophone": "->phone c14500",
        "10s": "OI=1;OV=4.2;RM=1024;DS=10.1;RS=1280x800;WT=725;SZ=275.1x183.9x13;CP=316;",
        "kurio10s": "->10s",
        "7s": "DS=7;RS=1024x600;WT=400;SZ=200x127x12;CP=317;OI=1;OV=4.2;",
        "kurio7s": "->7s"
    },
    "blackview": {
        "10": "->hero 10",
        "a100": "RE=2021.06;SZ=77.6x166.3x8.8;WT=195;DS=6.67;RS=1080x2400;OI=1;OV=11;CP=114;RM=6144;",
        "a200 pro": "RE=2023.07;SZ=73.6x162.2x8.6;WT=196;DS=6.67;RS=1080x2400;OI=1;OV=13;CP=389;RM=12288;",
        "a50": "RE=2022.03;SZ=72.9x156.4x8.9;WT=156;DS=6.01;RS=720x1560;OI=1;OV=11;CP=374;RM=3072;",
        "a52": "RE=2022.11;SZ=62x164.2x9.1;WT=183.6;DS=6.5;RS=720x1600;OI=1;OV=12;CP=109;RM=2048;",
        "a52 pro": "RE=2023.02;SZ=62x164.2x9.1;WT=183.6;DS=6.5;RS=720x1600;OI=1;OV=13;CP=385;RM=4096;",
        "a53": "RE=2023.03;SZ=76.9x164.6x9.4;WT=193;DS=6.5;RS=720x1600;OI=1;OV=12;CP=44;RM=3072;",
        "a55 pro": "RE=2022.03;SZ=76.7x164.8x9.2;WT=197;DS=6.53;RS=720x1600;OI=1;OV=11;CP=355;RM=4096;",
        "a55": "RE=2021.12;SZ=76.7x164.5x9.1;WT=196;DS=6.53;RS=720x1600;OI=1;OV=11;CP=44;RM=3072;",
        "a60 pro": "DS=6.1;RS=600x1280;SZ=74x156.8x9.8;WT=170;RE=2019.05;OI=1;OV=9.0;RM=3072;CP=44;",
        "a60": "DS=6.1;SZ=74x156.8x9.8;WT=171;RS=600x1280;RE=2019.05;CP=4;RM=1024;OI=1;OV=8.1;SM=2;",
        "a60pro": "->a60 pro",
        "a70 pro": "RE=2021.12;SZ=77x165.2x9.6;WT=205;DS=6.52;RS=720x1600;OI=1;OV=11;CP=374;RM=4096;",
        "a70": "RE=2021.01;SZ=77.5x165.3x8.3;WT=205;DS=6.52;RS=720x1600;OI=1;OV=11;CP=109;RM=3072;",
        "a7": "DS=5;RS=720x1280;SZ=71x143x9.5;WT=176;RE=2017;OI=1;OV=7.0;RM=1024;CP=4;",
        "a80 plus": "RE=2020.12;SZ=77.8x162.8x8.8;WT=180;DS=6.49;RS=720x1560;OI=1;OV=10;CP=355;RM=4096;",
        "a80 pro": "DS=6.49;RS=720x1560;SZ=77x162.75x8.8;WT=180;RE=2019;OI=1;OV=9.0;RM=4096;CP=232",
        "a85": "RE=2022.11;SZ=76.1x164.3x8.7;WT=193;DS=6.5;RS=720x1612;OI=1;OV=12;CP=385;RM=8192;",
        "a80plus": "->a80 plus",
        "a80pro": "->a80 pro",
        "a80s": "RE=2021.01;SZ=76.3x157.6x8.8;WT=180;DS=6.22;RS=720x1520;OI=1;OV=10;CP=355;RM=4096;",
        "a90": "RE=2021.05;SZ=77.6x166.3x8.8;WT=185;DS=6.39;RS=720x1560;OI=1;OV=11;CP=290;RM=4096;",
        "a95": "RE=2022.01;SZ=75.5x163.7x8.6;WT=195;DS=6.53;RS=720x1600;OI=1;OV=11;CP=114;RM=8192;",
        "a96": "RE=2023.09;SZ=74.2x161.8x8.6;WT=193.9;DS=6.5;RS=1080x2400;OI=1;OV=13;CP=389;RM=8192;",
        "active 10 pro": "RE=2024.12;SZ=267.6x179x19.5;WT=1214;DS=10.95;RS=1920x1200;OI=1;OV=14;CP=386;RM=12288;",
        "active 8 pro": "RE=2023.07;SZ=256.3x165.8x16.8;WT=976;DS=10.36;RS=2000x1200;OI=1;OV=12;CP=389;RM=8192;",
        "bl5000": "RE=2021.07;SZ=80.4x164x12.8;WT=273;DS=6.36;RS=1080x2300;OI=1;OV=11;CP=302;RM=8192;",
        "bl6000 pro": "RE=2020.11;SZ=81.3x166.7x12.8;WT=273;DS=6.36;RS=1080x2300;OI=1;OV=10;CP=344;RM=8192;",
        "bl6000pro": "->bl6000 pro",
        "bl8000": "RE=2024.01;SZ=82.6x179.5x17;WT=385;DS=6.78;RS=1080x2460;OI=1;OV=13;CP=368;RM=12288;",
        "bl8800 pro": "RE=2022.05;SZ=83.5x176.2x17.7;WT=367;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=302;RM=8192;",
        "bl8800": "RE=2022.05;SZ=83.5x176.2x17.7;WT=367;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=302;RM=8192;",
        "bl8800pro": "->bl8800 pro",
        "bl9000 pro": "RE=2024.04;SZ=82.6x179.5x17;WT=412;DS=6.78;RS=1080x2460;OI=1;OV=14;CP=390;RM=12288;",
        "bl9000": "RE=2024.01;SZ=82.6x179.5x17;WT=413;DS=6.78;RS=1080x2460;OI=1;OV=13;CP=390;RM=12288;",
        "bv4000 pro": "DS=4.7;RS=720x1280;SZ=74.2x143.9x13.25;WT=205;RE=2017;OI=1;OV=7.0;RM=2048;CP=4;",
        "bv4000pro-ru": "->bv4000 pro",
        "bv4000pro": "->bv4000 pro",
        "bv4800 pro": "RE=2024.12;SZ=81.5x174.7x13.5;WT=285;DS=6.56;RS=720x1612;OI=1;OV=14;CP=385;RM=4096;",
        "bv4900 pro": "RE=2020.10;SZ=78.1x157.5x13.7;WT=261;DS=5.7;RS=720x1440;OI=1;OV=10;CP=355;RM=4096;",
        "bv4900": "DS=5.7;RS=720x1440;SZ=78.1x157.5x13.7;WT=261;RE=2020;OI=1;OV=10;RM=3072;CP=44;",
        "bv4900pro": "->bv4900 pro",
        "bv4900s": "RE=2021.10;SZ=78.1x157.5x13.7;WT=261;DS=5.7;RS=720x1440;OI=1;OV=11;CP=109;RM=2048;",
        "bv5100": "RE=2020.11;SZ=77.7x159.4x13.7;WT=275;DS=5.7;RS=720x1440;OI=1;OV=10;CP=355;RM=4096;",
        "bv5200 pro": "RE=2022.12;SZ=77.9x161.6x13.7;WT=268;DS=6.1;RS=720x1560;OI=1;OV=12;CP=38;RM=4096;",
        "bv5200": "RE=2022.09;SZ=77.9x161.6x13.7;WT=268;DS=6.1;RS=720x1560;OI=1;OV=12;CP=44;RM=4096;",
        "bv5300 pro": "RE=2023.05;SZ=77.6x161.5x15;WT=273;DS=6.1;RS=720x1560;OI=1;OV=12;CP=38;RM=4096;",
        "bv5500": "DS=5.5;RS=720x1440;SZ=75.5x152.2x14;WT=225;RE=2019;OI=1;OV=8.1;RM=2048;CP=5;",
        "bv5800 pro": "DS=5.5;RS=720x1440;SZ=78.5x156.9x15.5;WT=253;RE=2018;OI=1;OV=8.1;RM=2048;CP=8;",
        "bv5800pro ru": "->bv5800 pro",
        "bv5900": "DS=5.7;RS=720x1520;SZ=80x159x15;WT=268;RE=2019;OI=1;OV=9.0;RM=3072;CP=44;",
        "bv6000 ru": "->bv6000",
        "bv6000": "DS=4.7;RS=720x1280;SZ=81x152.3x16.6;WT=247;RE=2016;OI=1;OV=6.0;RM=3072;CP=117;",
        "bv6000s ru": "->bv6000s",
        "bv6000s": "DS=4.7;RS=720x1280;SZ=81x152.3x16.6;WT=247;RE=2016;OI=1;OV=6.0;RM=2048;CP=79;",
        "bv6100": "DS=6.88;RS=640x1352;SZ=89.7x181x11.5;WT=315;RE=2019;OI=1;OV=9.0;RM=3072;CP=44;",
        "bv6200 pro": "RE=2023.07;SZ=82x174.4x19.2;WT=438;DS=6.56;RS=720x1612;OI=1;OV=13;CP=38;RM=4096;",
        "bv6300 pro": "DS=5.7;RS=720x1440;SZ=78.2x159.6x12.8;WT=230;RE=2020;OI=1;OV=10;RM=6144;CP=114;",
        "bv6300": "DS=5.7;RS=720x1440;SZ=78.2x159.6x12.8;WT=230;RE=2020;OI=1;OV=10;RM=3072;CP=171;",
        "bv6300pro": "->bv6300 pro",
        "bv6600 pro": "RE=2021.09;SZ=79.4x159x18;WT=325;DS=5.7;RS=720x1440;OI=1;OV=11;CP=342;RM=4096;",
        "bv6600": "RE=2021.03;SZ=79.4x159x18;WT=325;DS=5.7;RS=720x1440;OI=1;OV=10;CP=355;RM=4096;",
        "bv6600e": "RE=2021.09;SZ=79.4x159x18;WT=325;DS=5.7;RS=720x1440;OI=1;OV=11;CP=109;RM=4096;",
        "bv6600pro": "->bv6600 pro",
        "bv6800 pro": "DS=5.7;RS=1080x2160;SZ=81x162.2x14.8;WT=275;RE=2018;OI=1;OV=8.0;RM=4096;CP=162;",
        "bv6800pro ru": "->bv6800 pro",
        "bv6800pro": "->bv6800 pro",
        "bv7100": "RE=2022.09;SZ=81.4x174x18.9;WT=460;DS=6.58;RS=1080x2408;OI=1;OV=12;CP=322;RM=6144;",
        "bv7200": "RE=2022.10;SZ=81.6x165.3x16;WT=288;DS=6.1;RS=720x1560;OI=1;OV=12;CP=322;RM=6144;",
        "bv7300": "RE=2025.04;SZ=85x186x24;WT=528;DS=6.67;RS=720x1604;OI=1;OV=14;CP=382;RM=6144;",
        "bv8100": "RE=2024.05;SZ=81.2x175.8x18.1;WT=360;DS=6.5;RS=1080x2400;OI=1;OV=14;CP=389;RM=8192;",
        "bv8200": "RE=2024.12;SZ=81.1x174.6x16.5;WT=370;DS=6.5;RS=1080x2400;OI=1;OV=14;CP=381;RM=12288;",
        "bv8800": "RE=2021.12;SZ=83.5x176.2x17.7;WT=367;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=350;RM=8192;TT=254849;TG=1752;",
        "bv8900": "RE=2023.05;SZ=82.2x172.4x19.8;WT=398;DS=6.5;RS=1080x2408;OI=1;OV=13;CP=346;RM=8192;",
        "bv9200": "RE=2022.12;SZ=81.8x174.5x13.6;WT=310;DS=6.6;RS=1080x2408;OI=1;OV=12;CP=350;RM=8192;",
        "bv9300": "RE=2023.05;SZ=85.6x184.6x22.8;WT=520;DS=6.7;RS=1080x2388;OI=1;OV=12;CP=389;RM=12288;",
        "bv9800 pro": "RE=2019.10;SZ=81x168.5x14.8;WT=322;DS=6.3;RS=1080x2340;OI=1;OV=9.0;CP=114;RM=6144;",
        "bv9800pro": "->bv9800 pro",
        "bv9900e": "RE=2020.09;SZ=78.3x156.5x14.2;WT=273;DS=5.84;RS=1080x2280;OI=1;OV=10;CP=346;RM=6144;",
        "color 8": "RE=2024.01;SZ=77.4x167.8x9.1;WT=214;DS=6.75;RS=720x1600;OI=1;OV=13;CP=388;RM=8192;",
        "hero 10": "RE=2024.05;SZ=75.5x169x8.1;WT=198;DS=6.9;RS=1080x2560;OI=1;OV=13;CP=389;RM=12288;",
        "mega 1": "RE=2024.03;SZ=268.7x169x7.6;WT=528;DS=11.5;RS=2000x1200;OI=1;OV=13;CP=389;RM=8192;",
        "mega 2": "RE=2025.04;SZ=281.7x177.2x8;WT=615;DS=12.0;RS=2000x1200;OI=1;OV=15;CP=383;RM=12288;",
        "mega 3": "RE=2025.06;SZ=278.5x180.5x7.4;WT=555;DS=12.1;RS=2560x1600;OI=1;OV=15;CP=381;RM=12288;",
        "mega 8": "RE=2025.04;SZ=302x197.5x7.9;WT=736;DS=13.0;RS=1920x1200;OI=1;OV=15;CP=384;RM=12288;",
        "n6000": "RE=2023.07;SZ=65.3x133x18.4;WT=208;DS=4.3;RS=540x1200;OI=1;OV=13;CP=389;RM=8192;",
        "shark 8": "RE=2023.11;SZ=76.6x168.5x8.4;WT=198.3;DS=6.78;RS=1080x2460;OI=1;OV=13;CP=389;RM=8192;",
        "shark 9": "RE=2024.10;SZ=75.6x164.8x8.7;WT=200;DS=6.67;RS=720x1604;OI=1;OV=14;CP=387;RM=8192;",
        "tab 10 pro": "RE=2021.12;SZ=243x162x8.8;WT=588;DS=10.1;RS=1920x1200;OI=1;OV=11;CP=392;RM=8192;",
        "tab 10": "RE=2021.06;SZ=243x162x8.4;WT=523;DS=10.1;RS=1920x1200;OI=1;OV=11;CP=393;RM=4096;",
        "tab 11 se": "RE=2023.02;SZ=249x156.7x8.1;WT=512;DS=10.36;RS=2000x1200;OI=1;OV=12;CP=385;RM=8192;",
        "tab 11 wifi": "RE=2023.06;SZ=247x156.8x7.6;WT=442;DS=10.36;RS=2000x1200;OI=1;OV=12;CP=98;RM=8192",
        "tab 11": "RE=2021.11;SZ=247x156.7x8.1;WT=460;DS=10.36;RS=2000x1200;OI=1;OV=11;CP=199;RM=8192;",
        "tab 12 pro": "RE=2023.03;SZ=238.5x157.5x7.4;WT=430;DS=10.1;RS=1920x1200;OI=1;OV=12;CP=385;RM=8192;",
        "tab 12": "RE=2022.05;SZ=238.5x157.5x7.4;WT=430;DS=10.1;RS=1920x1200;OI=1;OV=11;CP=109;RM=4096;",
        "tab 13": "RE=2022.08;SZ=238.8x157.6x7.7;WT=450;DS=10.1;RS=1920x1200;OI=1;OV=12;CP=322;RM=6144;",
        "tab 15": "RE=2022.10;SZ=246.4x161.5x7.3;WT=525;DS=10.5;RS=1920x1200;OI=1;OV=12;CP=318;RM=8192;",
        "tab 16 pro": "RE=2024.05;SZ=256.8x167x7.5;WT=503;DS=11.0;RS=1920x1200;OI=1;OV=14;CP=388;RM=8192;",
        "tab 16": "RE=2023.02;SZ=260.1x164.7x8;WT=533;DS=11.0;RS=2000x1200;OI=1;OV=12;CP=388;RM=8192;",
        "tab 18": "RE=2023.11;SZ=277.6x173.2x7.9;WT=632;DS=12.0;RS=2000x1200;OI=1;OV=13;CP=389;RM=12288;",
        "tab 50 wifi": "RE=2023.09;SZ=211.2x126.2x9.7;WT=355;DS=8.0;RS=1280x800;OI=1;OV=13;RM=4096;",
        "tab 60 pro": "RE=2025.01;SZ=242.7x161.5x8.5;WT=543;DS=10.1;RS=1280x800;OI=1;OV=14;CP=385;RM=4096",
        "tab 60": "RE=2023.09;SZ=211.7x124.4x8.4;WT=338;DS=8.68;RS=1340x800;OI=1;OV=13;CP=385;RM=4096;",
        "tab 6": "RE=2021.11;SZ=207.6x124x9.5;WT=365;DS=8.0;RS=1280x800;OI=1;OV=11;CP=374;RM=3072;",
        "tab 7": "RE=2022.07;SZ=241.3x160x8.9;WT=536;DS=10.1;RS=1280x800;OI=1;OV=11;CP=374;RM=3072;",
        "tab 70 wifi": "RE=2023.09;SZ=246.5x163x9.9;WT=520.5;DS=10.1;RS=1280x800;OI=1;OV=13;CP=391;RM=3072;",
        "tab 80": "RE=2023.09;SZ=241x156x7.5;WT=484;DS=10.1;RS=1280x800;OI=1;OV=13;CP=385;RM=4096;",
        "tab 8e": "RE=2021.01;SZ=243.6x162.4x8.9;WT=600;DS=10.1;RS=1920x1200;OI=1;OV=10;CP=109;RM=3072;",
        "tab 9 wifi": "RE=2024.06;SZ=246.8x161.8x9.1;WT=540;DS=11.0;RS=1920x1200;OI=1;OV=14;CP=385;RM=6144;",
        "tab 90 wifi": "RE=2024.06;SZ=256.9x168.5x9.5;WT=540;DS=10.92;RS=1280x800;OI=1;OV=14;CP=385;RM=4096;",
        "tab 9": "RE=2021.03;SZ=243.7x162.5x8.5;WT=570;DS=10.1;RS=1920x1200;OI=1;OV=10;CP=318;RM=4096;",
        "tab9": "->tab 9",
        "wave 6c": "RE=2023.12;SZ=76.5x164.7x9.7;WT=191;DS=6.5;RS=720x1600;OI=1;OV=13;CP=109;RM=2048;",
        "wave 8": "RE=2024.11;SZ=75.2x163.2x8.8;WT=192;DS=6.56;RS=720x1612;OI=1;OV=14;CP=385;RM=4096;",
        "wave 8c": "RE=2024.11;SZ=75.2x163.2x8.8;WT=193;DS=6.56;RS=720x1612;OI=1;OV=14;CP=109;RM=2048",
        "k": "->bv8900"
    },
    "bravis": {
        "a506": "->crystal",
        "a510 je4g": "->a510 jeans 4g",
        "a553": "->discovery",
        "n1 550_cruiser": "->n1-550 cruiser",
        "n1-570 space": "->space",
        "nb851": "DS=8;RS=1280x800;SZ=206.5x122.8x7.7;WT=332;RE=2018;OI=1;OV=8.1;RM=1024;CP=163;",
        "nb871": "DS=8;RS=1280x800;SZ=206.5x122.8x7.7;WT=332;RE=2018;OI=1;OV=8.1;RM=1024;CP=74;",
        "nb961": "DS=9.6;RS=1280x800;SZ=226x160x9.5;WT=490;RE=2017;OI=1;OV=6.0;RM=2048;CP=163;SM=2;",
        "neo": "->a401 neo",
        "x500": "->trace pro",
        "delta": "DS=5;RS=540x960;SZ=69x138x8.9;WT=125;RE=2015;RM=512;CP=7;SM=2;OI=1;OV=5.1;",
        "crystal": "DS=5;RS=720x1280;SZ=71.6x141.9x8.6;WT=160;RE=2018;RM=1024;CP=5;SM=2;",
        "discovery": "DS=5.5;RS=720x1280;SZ=77x153.8x7.9;WT=177;RE=2017;RM=1024;CP=5;OI=1;OV=5.1;SM=2;",
        "tau": "DS=5;RS=720x1280;SZ=70.8x142.5x6.5;WT=169;RE=2014;RM=1024;CP=7;OI=1;OV=4.2;SM=2;",
        "trace pro": "DS=5;RS=720x1280;SZ=71.3x141.7x9.65;WT=182;RE=2017;RM=2048;CP=5;OI=1;OV=6;SM=2;",
        "trend": "DS=5;RS=720x1280;SZ=71.5x145x8.3;WT=146;RE=2015;RM=1024;CP=6;OI=1;OV=5.1;SM=2;",
        "b501 easy": "->easy",
        "b501": "->easy",
        "easy": "DS=5;RS=480x854;SZ=72.80x144.80x9.80;WT=146;RE=2016;RM=512;CP=6;OI=1;OV=5.1;SM=2;",
        "n1-570": "->space",
        "space": "DS=5.72;RS=720x1440;SZ=73x152x9.2;WT=174;RE=2018;RM=2048;CP=8;OI=1;OV=8.1;SM=2;",
        "a554": "->a554 grand",
        "a554 grand": "DS=5.5;RS=720x1280;SZ=78x156x10.5;WT=198;RE=2017;RM=2048;CP=4;OI=1;OV=7;SM=2;",
        "s500": "->s500 diamond",
        "s500 diamond": "DS=5;RS=720x1280;SZ=68.3x140x8.5;WT=164;RE=2017;RM=2048;CP=4;OI=1;OV=6;",
        "a505 joy plus": "DS=5;RS=720x1280;SZ=70x142x8.2;WT=152;RE=2017;RM=1024;CP=5;OI=1;OV=6;SM=2;",
        "a552 joy max": "DS=5.5;RS=720x1280;SZ=77x153x8.3;WT=184;RE=2017;RM=1024;CP=5;OI=1;OV=6;SM=2;",
        "atlas a551": "->a551 atlas",
        "a551 atlas": "DS=5.5;RS=720x1280;SZ=78.3x157.5x8.8;WT=206;RE=2016;RM=1024;CP=5;OI=1;OV=5.1;SM=2;",
        "a503 joy": "DS=5;RS=720x1280;SZ=71x141x8.8;WT=155;RE=2016;RM=1024;CP=5;OI=1;OV=6;SM=2;",
        "a504 trace": "DS=5;RS=720x1280;SZ=71.3x141x8.7;WT=178;RE=2016;RM=1024;CP=5;OI=1;OV=6;SM=2;",
        "a512 harmony pro": "DS=5;RS=720x1280;SZ=72x146x10;WT=143;RE=2018.12;RM=2048;CP=4;OI=1;OV=6;SM=2;",
        "a510 jeans 4g": "DS=5;RS=720x1280;SZ=70x142x8.5;WT=155;RE=2018;RM=1024;CP=9;OI=1;OV=8.1;SM=2;",
        "a509 jeans": "DS=5;RS=720x1280;SZ=70x142x8.5;WT=155;RE=2018;RM=1024;CP=5;OI=1;OV=8.1;SM=2;",
        "a401 neo": "DS=4;RS=480x800;SZ=63x122.5x9.5;WT=103;RE=2016;RM=512;CP=5;OI=1;OV=5.1;",
        "n1 550 cruiser": "->n1-550 cruiser",
        "n1-550 cruiser": "DS=5.5;RS=640x1280;SZ=70x146.5x9.5;WT=212;RE=2018.11;RM=2048;CP=4;OI=1;OV=8.1;",
        "omega": "DS=5;RS=720x1280;SZ=76.6x145.3x8.4;WT=146;RE=2015;RM=1024;CP=1;OI=1;OV=4.4;",
        "a505plus": "->a505 joy plus",
        "a552max": "->a552 joy max"
    },
    "bb mobile": {
        "techno 10.0\" lte tq060x": "DS=10.1;RS=1024x600;SZ=243x165.8x10.5;WT=550;RM=1024;CP=74;OI=1;OV=5.1;SM=2;",
        "techno 10.1 lte tq060x": "->techno 10.0\" lte tq060x",
        "techno 10.1\" mozg i101bi": "DS=10.1;RS=1024x600;SZ=243x166x10;WT=535;OI=1;OV=5.1;RM=1024;CP=211;SM=2;",
        "techno i101bi": "->techno 10.1\" mozg i101bi"
    },
    "beyond": null,
    "bangolufsen": null,
    "barnes & noble": {
        "nook bnrv200": "DS=7.0;RS=1024x600;"
    },
    "beeline": {
        "e700": "SM=2;OI=1;OV=4.1;WT=120;SZ=61.7x116x12.6;RS=480x800;DS=4;",
        "fast 2": "SM=1;OI=1;OV=5.1;WT=160;SZ=71.5x143.7x9.4;RS=480x854;DS=5;RM=1024;CP=56;RE=2015.12;",
        "fast": "SM=1;OI=1;OV=5.1;WT=125;SZ=72.6x145.5x8.8;RS=480x854;DS=5;RM=1024;CP=56;RE=2015.09;",
        "pro 2": "SM=1;OI=1;OV=5.0;WT=154;SZ=67.4x134.5x10.3;RS=480x854;DS=4.5;RM=1024;CP=1;RE=2015.12;",
        "pro 3": "SM=1;OI=1;OV=5.1;WSZ=72.6x144x8.7;WT=152;DS=5;RS=480x854;RM=1024;CP=6;",
        "pro 4": "SM=2;RE=2015;WT=130;OI=1;OV=5.1;SZ=66.0x136.0x9.3;DS=4.5;RS=480x854;RM=1024;CP=1;",
        "pro 6": "RE=2017.04;SZ=67x133x9.8;RM=1024;WT=130;DS=4.5;RS=480x854;CP=86;OI=1;OV=7.0;",
        "smart 2": "SM=1;OI=1;OV=4.4;WT=124;SZ=64.7x126x10.7;DS=4;RS=480x800;CP=119;RM=512;",
        "smart 3": "SM=1;OI=1;OV=4.4;WT=122;SZ=64x125.5x9.7;DS=4;RS=480x800;CP=210;RM=512;",
        "smart 4": "SM=1;OI=1;OV=5.0;WT=237;SZ=66x136x9.3;DS=4.5;RS=480x854;CP=1;RM=1024;",
        "smart dual": "SM=2;OI=1;OV=4.4.2;RE=2015.07;CP=24;RM=512;DS=4;RS=480x800;",
        "smart2": "->smart 2"
    },
    "bird": {
        "doeasy e700": "DS=4.5;RS=480x854;RE=2014.03;SM=2;RM=512;"
    },
    "billion": {
        "capture plus": "DS=5.5;RS=1080x1920;SZ=76.5x153x8.5;WT=176;RM=3072;CP=81;RE=2017.09;OI=1;OV=7.1;SM=2;",
        "capture+": "->capture plus"
    },
    "bezkam": {
        "bk-ram2": "DS=5.5;RS=720x1280;SZ=72.2x146.4x9.2;WT=170;RM=2048;CP=79;RE=2017.07;SM=2;OI=1;OV=5.1;"
    },
    "bigben": {
        "gametab-one": "DS=7;RS=1024x600;SZ=187x110x12;WT=346;CP=80;RM=2048;OI=1;OV=4.2;"
    },
    "bihee": {
        "a11": "WT=174.4;SZ=72x144.2x9.2;RS=480x854;DS=5;CP=10;RM=2048;RE=2017.09;OI=1;OV=7.1.2;",
        "a12": "DS=5.5;RS=720x1280;SZ=70x148x8.2;WT=142.5;RE=2017.09;OI=1;OV=6;RM=2048;CP=9;"
    },
    "black fox": {
        "b3+": "WT=175;DS=5;RS=720x1280;SZ=71x143x9.5;RM=2048;CP=9;OI=1;OV=7;",
        "b3": "DS=5;RS=720x1280;SZ=71x143x9.5;WT=175;RE=2017;OI=1;OV=7.0;RM=1024;CP=4;",
        "b4 mini nfc": "DS=4.95;RS=480x960;SZ=65.7x138x9.6;WT=136;RE=2019;OI=1;OV=8.1;RM=1024;CP=8;",
        "b4 mini": "DS=4.95;RS=480x960;SZ=65.7x138x9.6;WT=136;RE=2019;OI=1;OV=8.1;RM=1024;CP=5;",
        "b4": "DS=4.95;RS=480x960;SZ=65.7x138x9.6;WT=136;RE=2018;OI=1;OV=8.1;RM=2048;CP=8;",
        "b5+": "DS=5.45;RS=720x1440;SZ=70.7x146.7x9.6;WT=170;RE=2018;OI=1;OV=8.1;RM=2048;CP=8;",
        "b5": "DS=5.45;RS=480x960;SZ=70.7x146.7x9.6;WT=170;RE=2018;OI=1;OV=8.1;RM=1024;CP=58;",
        "b6": "DS=5.45;RS=480x960;SZ=72x149x9;WT=170;RE=2019;OI=1;OV=8.1;RM=1024;CP=58;",
        "b7 fox+": "DS=5.45;RS=720x1440;SZ=70x149x8;WT=163;RE=2019;OI=1;OV=8.1;RM=2048;CP=8;",
        "b7": "DS=5.45;RS=720x1440;SZ=70x149x8;WT=163;RE=2019;OI=1;OV=8.1;RM=1024;CP=8;",
        "b7r fox": "DS=5.5;RS=720x1440;SZ=71.4x147.7x8.5;WT=;RE=2020;OI=1;OV=9.0;RM=2048;CP=84;",
        "b8 fox+": "DS=5.5;RS=720x1280;SZ=76.8x153.5x8.75;WT=150;RE=2017;OI=1;OV=6.0;RM=1024;CP=9;",
        "b8 fox": "DS=5;RS=720x1280;SZ=72.6x145x8.3;WT=153;RE=2017;OI=1;OV=5.0;RM=1024;CP=56;",
        "bmm 431d": "DS=4.5;RS=540x960;SZ=66x129.9x9.5;WT=;RE=2016;OI=1;OV=6.0;RM=1024;CP=5;",
        "bmm 532 s": "->bmm 532s",
        "bmm 532s": "DS=5;RS=720x1280;SZ=73.9x144.9x9.3;WT=160;RE=2016;OI=1;OV=5.1;RM=1024;CP=4;",
        "bmm 533d": "DS=5;RS=720x1280;SM=2;OI=1;OV=5.1;SZ=73.9x144.9x9.3;WT=126;RM=1024;CP=5;",
        "bmm 541s": "DS=5;RS=720x1280;SZ=72.6x145x8.3;WT=153;RE=2017;OI=1;OV=5.0;RM=1024;CP=56;",
        "bmm 542s": "DS=5.5;RS=720x1280;SZ=73.9x144.9x9.3;WT=126;OI=1;OV=5.1;SM=2;CP=5;RM=1024;RE=2017;",
        "bmm441s": "->b8 fox",
        "bmm442s": "->b8 fox+",
        "bmm443d": "->b7 fox+",
        "bmm531a": "->b5",
        "bmm541d": "->b3",
        "bmm541w": "->b7r fox",
        "bmm542d": "->b3+",
        "bmm543d": "->b4",
        "bmm543s": "->b4",
        "bmm441d": "->b4 mini",
        "bmm541b": "->b4 mini nfc",
        "bmm541a": "->b5+",
        "bmm531d": "->b6",
        "bmm442d": "->b7",
        "bmm-542s": "->bmm 542s",
        "bmm441b": "->b8 fox+",
        "bmm441a": "->b8 fox"
    },
    "\xf6wn": {
        "fun 5(4g)": "->fun 5 4g",
        "fun 5 4g": "DS=5;RS=480x854;WT=130;SZ=72x146x9;RM=1024;CP=86;OI=1;OV=7;",
        "own fun 5(4g)": "->fun 5 4g"
    },
    "colors": {
        "pride 5c": "DS=5.1;DP=220;RS=480x1014;RM=1024;SM=2;OI=1;OV=8;RE=2018.08;SM=2;",
        "p52 pride5c": "->pride 5c",
        "pride 5x": "DS=5.5;",
        "p90 pride5x": "->pride 5x",
        "s9": "DS=5.2;RS=720x1280;SM=2;OI=1;OV=7.0;CP=9;RM=2048;",
        "s11": "DS=5.2;RS=720x1280;SZ=72.9x148.4x7.85;SM=2;OI=1;OV=7.0;CP=9;RM=3072;",
        "s1": "DS=5.5;RS=720x1280;OI=1;OV=7.0;CP=4;RM=1024;SM=2;",
        "p70": "DS=5;RS=720x1280;OI=1;OV=7.0;RM=2048;CP=9;",
        "pride 1a": "DS=4;WT=183;RM=512;"
    },
    "huawei": {
        "moa-tl00": "->honor play 9a",
        "moa-al00": "->honor play 9a",
        "moa-al20": "->honor play 9a",
        "honor play 9a": "RE=2020.05;SZ=74.1x159.1x9;WT=185;DS=6.3;RS=720x1600;OI=1;OV=10;CP=38;RM=4096;",
        "pct-l29": "->honor view 20",
        "vna-l29": "->honor view 20",
        "honor view 20": "RE=2018.12;SZ=75.4x156.9x8.1;WT=180;DS=6.4;RS=1080x2310;OI=1;OV=9.0;CP=52;RM=6144;",
        "oxf-an10": "->honor view 30 pro",
        "honor view 30 pro": "RE=2019.11;SZ=75.8x162.7x8.8;WT=206;DS=6.57;RS=1080x2400;OI=1;OV=10;CP=54;RM=8192;",
        "oxf-an00": "->honor view 30",
        "honor view 30": "RE=2020.02;SZ=75.8x162.7x8.9;WT=213;DS=6.57;RS=1080x2400;OI=1;OV=10;CP=54;RM=6144;",
        "jat-tl00": "->honor play 8a",
        "jat-al00": "->honor play 8a",
        "honor play 8a": "RE=2019.01;SZ=73.5x156.3x8;WT=150;DS=6.09;RS=720x1560;OI=1;OV=9.0;CP=38;RM=3072;",
        "jmm-al00": "->honor v9 play",
        "jmm-al10": "->honor v9 play",
        "jmm-tl10": "->honor v9 play",
        "honor v9 play": "DS=5.2;RS=720x1280;SZ=73.2x147.9x7.65;WT=145;RE=2017;OI=1;OV=7.0;RM=3072;CP=40;",
        "vog-al00": "->p30 pro",
        "p30 pro": "RE=2020.05;SZ=73.4x158x8.4;WT=192;DS=6.47;RS=1080x2340;OI=1;OV=10;CP=52;RM=6144;",
        "knt-al10": "->honor v8",
        "knt-tl10": "->honor v8",
        "knt-ul10": "->honor v8",
        "honor v8": "RE=2016.05;SZ=77.6x157x7.8;WT=170;DS=5.7;RS=1080x1920;OI=1;OV=6.0;CP=216;RM=4096;",
        "lra-lx1": "->honor 30i",
        "honor 30i": "DS=6.3;RS=1080x2400;SZ=73.2x157.2x7.7;WT=171.5;RE=2020.09;RM=4096;CP=37;OI=1;OV=10;SM=2;",
        "honor 4c pro": "DS=5;RS=720x1280;SZ=71.8x143.1x9.7;WT=160;RE=2015.04;RM=2048;CP=56;OI=1;OV=5.1;SM=2;",
        "jmm-l22": "->honor 6c pro",
        "honor 6c pro": "DS=5.2;RS=720x1280;SZ=73.2x147.9x7.7;WT=145;RE=2017.09;RM=3072;CP=40;OI=1;OV=7;SM=2;",
        "nem-l21": "->honor 7 lite",
        "honor 7 lite": "DS=5.2;RS=1080x1920;SZ=73.8x147.1x8.3;WT=156;RE=2016.06;RM=2048;CP=66;OI=1;OV=6;",
        "lld-l21": "->honor 9 lite",
        "lld-l31": "->honor 9 lite",
        "lld-tl10": "->honor 9 lite",
        "lld-al00": "->honor 9 lite",
        "lld-al10": "->honor 9 lite",
        "honor 9 lite": "DS=5.7;RS=1080x2160;SZ=71.9x151x7.6;WT=149;RE=2018.01;RM=4096;CP=42;OI=1;OV=8;",
        "moa-lx9n": "->honor 9a",
        "honor 9a": "DS=6.3;RS=720x1600;SZ=74.06x159.07x9.04;WT=185;RE=2020.06;RM=3072;CP=47;OI=1;OV=10;",
        "lld-al20": "->honor 9i",
        "lld-al30": "->honor 9i",
        "honor 9i": "RE=2018.07;SZ=71.8x149.2x7.7;WT=152;DS=5.84;RS=1080x2280;OI=1;OV=8.0;CP=42;RM=3072;",
        "tny-al00": "->honor magic 2",
        "tny-tl00": "->honor magic 2",
        "honor magic 2": "RE=2018.10;SZ=75.1x157.3x8.3;WT=206;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=52;RM=6144;",
        "nts-al00": "->honor magic",
        "honor magic": "RE=2016.12;SZ=69.9x146.1x7.8;WT=145;DS=5.09;RS=1440x2560;OI=1;OV=6.0;CP=216;RM=4096;",
        "rvl-al09": "->honor note 10",
        "honor note 10": "RE=2017.07;SZ=85x177x7.7;WT=230;DS=6.95;RS=1080x2220;OI=1;OV=8.1;CP=50;RM=6144;",
        "vky-tl00": "->p10 plus",
        "p10 plus": "RE=2017.02;SZ=74.2x153.5x7;WT=165;DS=5.5;RS=1440x2560;OI=1;OV=7.0;CP=221;RM=4096;",
        "pct-tl10": "->honor v20",
        "pct-al10": "->honor v20",
        "honor v20": "RE=2018.12;SZ=75.4x156.9x8.1;WT=180;DS=6.4;RS=1080x2310;OI=1;OV=9.0;CP=52;RM=6144;",
        "jdn-w09": "->honor pad 2",
        "jdn-al00": "->honor pad 2",
        "honor pad 2": "RE=2016.10;DS=8.0;RS=1920x1200;SZ=209.3x123x8.1;WT=340;OI=1;OV=6.0;CP=22;RM=3072;",
        "krj-w09": "->honor pad v6",
        "honor pad v6": "RE=2020.05;SZ=245.2x154.9x7.8;WT=480;DS=10.4;RS=2000x1200;OI=1;OV=10;CP=53;RM=6144;",
        "ksa-al10": "->honor play 3e",
        "honor play 3e": "RE=2019.09;SZ=70.8x147.1x8.5;WT=146;DS=5.71;RS=720x1520;OI=1;OV=9.0;CP=47;RM=2048;",
        "tnnh-an00": "->honor play 4",
        "honor play 4": "RE=2020.06;SZ=78.5x170x8.9;WT=213;DS=6.81;RS=1080x2400;OI=1;OV=10;CP=45;RM=8192;",
        "scl-al00": "->honor 4a",
        "scl-cl00": "->honor 4a",
        "scl-tl00": "->honor 4a",
        "scl-tl00h": "->honor 4a",
        "honor 4a": "DS=5;RS=720x1280;SZ=72.1x143.5x8.5;WT=155;RE=2015.08;RM=2048;CP=10;OI=1;OV=5.1;SM=1;",
        "pra-tl10": "->honor 8 lite",
        "pra-al00": "->honor 8 lite",
        "pra-al00x": "->honor 8 lite",
        "honor 8 lite": "DS=5.2;RS=1080x1920;SZ=72.94x147.2x7.6;WT=147;RE=2017.02;RM=3072;CP=48;OI=1;OV=7;",
        "ven-l22": "->honor 8 smart",
        "honor 8 smart": "DS=5.2;RS=1080x1920;SZ=72.6x146.8x7.5;WT=147;RE=2016.05;RM=2048;CP=66;OI=1;OV=6;",
        "jat-l41": "->honor 8a pro",
        "honor 8a pro": "RE=2019.04;SZ=73.5x156.3x8;WT=150;DS=6.09;RS=720x1560;OI=1;OV=9.0;CP=38;RM=2048;",
        "jat-lx1": "->honor 8a",
        "jat-lx3": "->honor 8a",
        "jat-l29": "->honor 8a",
        "honor 8a": "RE=2020.05;SZ=73.5x156.3x8.2;WT=150;DS=6.09;RS=720x1560;OI=1;OV=9.0;CP=38;RM=3072;",
        "jsn-al00": "->honor 8x",
        "jsn-al00a": "->honor 8x",
        "jsn-l21": "->honor 8x",
        "jsn-l23": "->honor 8x",
        "jsn-l42": "->honor 8x",
        "jsn-tl00": "->honor 8x",
        "jsn-l22": "->honor 8x",
        "honor 8x": "RE=2018.09;SZ=76.6x160.4x7.8;WT=175;DS=6.5;RS=1080x2340;OI=1;OV=8.1;CP=28;RM=4096;",
        "ksa-al00": "->honor 8s",
        "ksa-lx2": "->honor 8s",
        "ksa-lx3": "->honor 8s",
        "ksa-lx9": "->honor 8s",
        "honor 8s": "RE=2019.04;SZ=70.8x147.1x8.5;WT=146;DS=5.71;RS=720x1520;OI=1;OV=9.0;CP=44;RM=2048;",
        "bmh-an10": "->honor 30",
        "bmh-an20": "->honor 30",
        "bmh-tn10": "->honor 30",
        "mxw-an00": "->honor 30",
        "honor 30": "DS=6.53;RS=1080x2400;SZ=160.3x74.2x8.1;WT=185;RE=2020.04;RM=6144;CP=53;OI=1;OV=10;SM=2;",
        "bkk-al00": "->honor 8c",
        "bkk-al10": "->honor 8c",
        "bkk-l21": "->honor 8c",
        "bkk-l22": "->honor 8c",
        "bkk-lx2": "->honor 8c",
        "bkk-tl00": "->honor 8c",
        "honor 8c": "DS=6.3;RS=720x1520;SZ=75.94x158.72x7.98;WT=167;RE=2018.11;RM=4096;CP=64;OI=1;OV=8.1;",
        "bkl-l09s": "->honor view 10",
        "bkl-l04": "->honor view 10",
        "honor view 10": "DS=5.99;RS=1080x2160;SZ=74.98x157x6.97;WT=172;RE=2017.12;RM=6144;CP=50;OI=1;OV=9;",
        "bkl-al20": "->honor v10",
        "bkl-l09": "->honor v10",
        "bkl-al00": "->honor v10",
        "bkl-tl10": "->honor v10",
        "honor v10": "RS=1080x2160;DS=5.99;CP=50;RM=6144;OI=1;OV=8.0;SZ=74.98x157x6.97;WT=172;RE=2017.12;",
        "cdy-an90": "->honor 30s",
        "cdy-nx9a": "->honor 30s",
        "cdy-an95": "->honor 30s",
        "cdy-tn90": "->honor 30s",
        "honor 30s": "DS=6.5;RS=1080x2400;SZ=75x162.3x8.6;WT=190;RE=2020.05;RM=6144;CP=55;OI=1;OV=10;SM=2;",
        "duk-al20": "->honor v9",
        "honor v9": "RE=2017.04;DS=5.7;RS=1440x2560;SZ=77.5x157x6.97;WT=184;OI=1;OV=7.0;SM=2;CP=221;RM=6144;",
        "duk-l09": "->honor 8 pro",
        "duk-tl30": "->honor 8 pro",
        "honor 8 pro": "RE=2017.04;SZ=77.5x157x7;WT=184;DS=5.7;RS=1440x2560;OI=1;OV=7.0;221;RM=4096;",
        "ebg-an00": "->honor 30 pro",
        "ebg-tn00": "->honor 30 pro",
        "honor 30 pro": "DS=6.57;RS=1080x2340;SZ=73.6x160.3x8.4;WT=186;RE=2020.04;RM=8192;CP=54;OI=1;OV=10;SM=2;",
        "ebg-an10": "->honor 30 pro plus",
        "ebg-n19": "->honor 30 pro plus",
        "honor 30 pro+": "->honor 30 pro plus",
        "honor 30 pro plus": "DS=6.57;RS=1080x2340;SZ=73.6x160.3x8.4;WT=190;RE=2020.04;RM=8192;CP=54;OI=1;OV=10;SM=2;",
        "edi-al10": "->honor note 8",
        "honor note 8": "DS=6.6;RS=1440x2560;SZ=90.9x178.8x7.18;WT=219;RE=2016.08;RM=4096;CP=225;OI=1;OV=6;",
        "mar-lx1h": "->honor 20s",
        "yal-al50": "->honor 20s",
        "yal-tl50": "->honor 20s",
        "honor 20s": "DS=6.15;RS=1080x2312;SZ=72.7x152.9x7.4;WT=159;RE=2019.10;RM=6144;CP=28;OI=1;OV=9;SM=2;",
        "dua-tl00": "->honor play 7",
        "dua-al00": "->honor play 7",
        "honor play 7": "DS=5.45;RS=720x1440;SZ=70.9x146.5x8.3;WT=142;RE=2018.05;OI=1;OV=8.1;RM=2048;CP=8;",
        "dua-l22": "->honor 7s",
        "dua-lx3": "->honor 7s",
        "dua-l12": "->honor 7s",
        "honor 7s": "DS=5.45;RS=720x1440;SZ=70.9x146.5x8.3;WT=142;RE=2018.05;RM=2048;CP=8;OI=1;OV=8.1;",
        "dua-lx9": "->honor 9s",
        "honor 9s": "RE=2020.04;SZ=70.9x146.5x8.4;WT=144;DS=5.45;RS=720x1440;OI=1;OV=10;CP=47;RM=2048;",
        "hlk-al10": "->honor 9x pro",
        "hlk-tl10": "->honor 9x pro",
        "hlk-l41": "->honor 9x pro",
        "hlk-l42": "->honor 9x pro",
        "honor 9x pro": "DS=6.6;RS=1080x2340;SZ=77.2x163.1x8.8;WT=206;RE=2020.02;RM=6144;CP=57;OI=1;OV=10;",
        "hry-lx1meb": "->honor 10 lite",
        "hry-al00": "->honor 10 lite",
        "hry-al00a": "->honor 10 lite",
        "hry-tl00": "->honor 10 lite",
        "hry-tl00a": "->honor 10 lite",
        "hry-lx1": "->honor 10 lite",
        "hry-lx2": "->honor 10 lite",
        "lx1meb": "->honor 10 lite",
        "hry-l21": "->honor 10 lite",
        "honor 10 lite": "DS=6.21;RS=1080x2340;SZ=73.64x154.8x8;WT=162;RE=2018.09;RM=4096;CP=28;OI=1;OV=9;SM=2;",
        "hry-lx1t": "->honor 10i",
        "honor 10i": "DS=6.21;RS=1080x2340;SZ=73.64x154.8x7.95;WT=164;RE=2019.03;RM=4096;CP=28;OI=1;OV=9;SM=2;",
        "lra-al00": "->honor 20 lite",
        "lra-tl00": "->honor 20 lite",
        "honor 20 lite": "DS=6.21;RS=1080x2340;SZ=73.6x154.8x8;WT=164;RE=2019.04;RM=4096;CP=28;OI=1;OV=9;SM=2;",
        "mya-tl10": "->honor 6 play",
        "honor 6 play": "DS=5;RS=720x1280;SZ=72x143.8x8.85;WT=150;RE=2014.08;RM=2048;CP=69;OI=1;OV=6;SM=1;",
        "hdl-al09": "->honor water play 8.0",
        "hdl-w09": "->honor water play 8.0",
        "honor water play 8.0": "DS=8;RS=1920x1200;SZ=209.1x119.6x8;WT=309;RE=2018.10;OI=1;OV=8.0;RM=4096;CP=42;",
        "hdn-l09": "->honor water play 10.1",
        "hdn-w09": "->honor water play 10.1",
        "honor water play 10.1": "DS=10.1;RS=1920x1200;SZ=248x173x7.8;WT=465;RE=2017.10;OI=1;OV=7.0;RM=3072;CP=42;",
        "hlk-tl00": "->honor 9x",
        "hlk-al00": "->honor 9x",
        "hlk-al00a": "->honor 9x",
        "honor 9x": "DS=6.6;RS=1080x2340;SZ=77.3x163.5x8.8;WT=196.8;RE=2019.10;RM=4096;CP=37;OI=1;OV=9;",
        "pe-ul00": "->honor 6 plus",
        "pe-tl10": "->honor 6 plus",
        "pe-tl20": "->honor 6 plus",
        "pe-tl00m": "->honor 6 plus",
        "pe-cl00": "->honor 6 plus",
        "honor 6 plus": "DS=5.5;RS=1080x1920;SZ=75.7x150.5x7.5;WT=165;RE=2014.12;RM=3072;CP=70;OI=1;OV=4.4;SM=2;",
        "kiw-cl00": "->honor 5x",
        "kiw-al10": "->honor 5x",
        "kiw-tl00h": "->honor 5x",
        "kiw-tl00": "->honor 5x",
        "kiw-tc00": "->honor 5x",
        "kiw-l21": "->honor 5x",
        "kiw-l22": "->honor 5x",
        "kiw-l23": "->honor 5x",
        "kiw-l24": "->honor 5x",
        "kiw-ul00": "->honor 5x",
        "honor 5x": "DS=5.5;RS=1080x1920;SZ=76.3x151.3x8.2;WT=158;RE=2015.11;RM=2048;CP=68;OI=1;OV=5.1;SM=2;",
        "cor-al00": "->honor play",
        "cor-al10": "->honor play",
        "cor-tl10": "->honor play",
        "cor-l29": "->honor play",
        "cor-l09": "->honor play",
        "honor play": "RE=2018.07;SZ=74.3x157.9x7.5;WT=176;DS=6.3;RS=1080x2340;OI=1;OV=8.1;CP=50;RM=4096;",
        "bln-l21": "->honor 6x",
        "bln-l22": "->honor 6x",
        "bln-l24": "->honor 6x",
        "bln-al10": "->honor 6x",
        "bln-al20": "->honor 6x",
        "bln-al30": "->honor 6x",
        "bln-al40": "->honor 6x",
        "bln-tl00": "->honor 6x",
        "bln-tl10": "->honor 6x",
        "honor 6x": "DS=5.5;RS=1080x1920;SZ=76.2x150.9x8.2;WT=162;RE=2016.10;RM=3072;CP=48;OI=1;OV=6;SM=2;",
        "bnd-al00": "->honor 7x",
        "bnd-al10": "->honor 7x",
        "bnd-l21": "->honor 7x",
        "bnd-l24": "->honor 7x",
        "bnd-l31": "->honor 7x",
        "bnd-tl10": "->honor 7x",
        "bnd-l22": "->honor 7x",
        "bnd-l2": "->honor 7x",
        "honor 7x": "RE=2017.12;SZ=75.3x156.5x7.6;WT=165;DS=5.93;RS=1080x2160;OI=1;OV=7.0;CP=42;RM=3072;",
        "aum-l41": "->honor 7c",
        "lnd-al30": "->honor 7c",
        "lnd-l29": "->honor 7c",
        "lnd-tl40": "->honor 7c",
        "lnd-al40": "->honor 7c",
        "lnd-tl30": "->honor 7c",
        "honor 7c": "DS=6;RS=720x1440;SZ=76.7x158.3x7.8;WT=164;RE=2018.04;RM=3072;CP=214;OI=1;OV=8;",
        "cun-al00": "->honor 5 play",
        "cun-tl00": "->honor 5 play",
        "honor 5 play": "DS=5;RS=720x1280;SZ=72x143x8.9;WT=138;RE=;RM=2048;CP=56;OI=1;OV=5.1;SM=1;",
        "nem-tl00h": "->honor 5c dual sim",
        "nem-l22": "->honor 5c dual sim",
        "honor 5c dual sim": "->5c",
        "nem-al10": "->honor 5c",
        "nem-tl00": "->honor 5c",
        "nem-ul10": "->honor 5c",
        "nem-l51": "->honor 5c",
        "honor 5c": "DS=5.2;RS=1080x1920;SZ=73.8x147.1x8.3;WT=165;RE=2016.05;RM=2048;CP=66;OI=1;OV=6;SM=2;",
        "cam-al00": "->honor 5a",
        "cam-tl00": "->honor 5a",
        "cam-tl00h": "->honor 5a",
        "honor 5a": "DS=5.5;RS=720x1280;SZ=77.1x154.3x8.5;WT=168;RE=2016.07;RM=2048;CP=65;OI=1;OV=6;SM=2;",
        "aum-al00": "->honor 7a",
        "aum-al20": "->honor 7a",
        "aum-l33": "->honor 7a",
        "aum-tl20": "->honor 7a",
        "aum-al00in": "->honor 7a",
        "honor 7a": "DS=5.7;RS=720x1440;SZ=73x152.4x7.8;WT=150;RE=2018.04;RM=2048;CP=43;OI=1;OV=8;",
        "aqm-al10": "->honor 4t pro",
        "aqm-tl10": "->honor 4t pro",
        "honor 4t pro": "DS=6.3;RS=1080x2400;SZ=73.2x157.4x7.8;WT=165;RE=2020.04;RM=6144;CP=57;OI=1;OV=10;SM=2;",
        "are-al00": "->honor 8x max",
        "are-al10": "->honor 8x max",
        "are-l22": "->honor 8x max",
        "are-l22hn": "->honor 8x max",
        "are-tl00": "->honor 8x max",
        "honor 8x max": "RE=2018.09;SZ=86.3x177.6x8.1;WT=210;DS=7.12;RS=1080x2244;OI=1;OV=8.1;CP=61;RM=4096;",
        "ask-al00x": "->honor play 3",
        "ask-al20": "->honor play 3",
        "honor play 3": "RE=2019.09;SZ=76.1x159.8x8.1;WT=176;DS=6.39;RS=720x1560;OI=1;OV=9;CP=37;RM=4096;",
        "ath-al00": "->honor 7i",
        "ath-cl00": "->honor 7i",
        "ath-tl00": "->honor 7i",
        "ath-tl00h": "->honor 7i",
        "ath-ul00": "->honor 7i",
        "honor 7i": "DS=5.2;RS=1080x1920;SZ=71.2x141.6x7.8;WT=160;RE=2015.08;RM=3072;CP=22;OI=1;OV=5.1;",
        "ana-an00": "->p40 5g",
        "ana-nx9": "->p40 5g",
        "ana-tn00": "->p40 5g",
        "ana-lx4": "->p40 5g",
        "p40 5g": "RE=2020.03;SZ=71.1x148.9x8.5;WT=175;DS=6.1;RS=1080x2340;OI=1;OV=10;CP=54;RM=6144;",
        "aka-l29": "->honor 9c",
        "honor 9c": "RE=2020.04;SZ=76.1x159.8x8.1;WT=176;DS=6.39;RS=720x1560;OI=1;OV=10;CP=213;RM=4096;",
        "aka-al10": "->honor play 4t",
        "aka-tl10": "->honor play 4t",
        "honor play 4t": "RE=2020.04;SZ=76.1x159.8x8.1;WT=176;DS=6.39;RS=720x1560;OI=1;OV=10;CP=213;RM=6144;",
        "ags2-al00hn": "->honor tab 5",
        "jdn2-w09hn": "->honor tab 5",
        "jdn2-al00hn": "->honor tab 5",
        "honor tab 5": "RE=2019.05;SZ=204.2x122.2x8.2;WT=310;DS=8.0;RS=1920x1200;OI=1;OV=9.0;CP=28;RM=3072;",
        "yal-l41": "->honor 20 pro",
        "yal-al10": "->honor 20 pro",
        "honor 20 pro": "DS=6.26;RS=1080x2340;SZ=74x154.6x8.4;WT=182;RE=2019.05;RM=8192;CP=52;OI=1;OV=9;SM=2;",
        "yal-al00": "->honor 20",
        "yal-l21": "->honor 20",
        "yal-tl00": "->honor 20",
        "honor 20": "DS=6.26;RS=1080x2340;SZ=73.97x154.25x7.87;WT=174;RE=2019.03;RM=6144;CP=52;OI=1;OV=9;SM=2;",
        "hry-al00t": "->honor 20i",
        "hry-al00ta": "->honor 20i",
        "honor 20i": "DS=6.21;RS=1080x2340;SZ=73.6x154.8x8;WT=164;RE=2019.04;RM=6144;CP=28;OI=1;OV=9;SM=2;",
        "col-l29": "->honor 10",
        "col-al00": "->honor 10",
        "col-al10": "->honor 10",
        "col-tl10": "->honor 10",
        "col-tl00": "->honor 10",
        "col-l10": "->honor 10",
        "honor 10": "DS=5.84;RS=1080x2280;SZ=71.2x149.6x7.7;WT=153;RE=2018.04;RM=4096;CP=50;OI=1;OV=8.1;SM=2;",
        "che-tl00h": "->honor 4x",
        "che1-cl10": "->honor 4x",
        "che1-cl20": "->honor 4x",
        "che1-l04": "->honor 4x",
        "che2-l11": "->honor 4x",
        "che2-l12": "->honor 4x",
        "che2-l23": "->honor 4x",
        "che2-tl00": "->honor 4x",
        "che2-tl00h": "->honor 4x",
        "che2-tl00m": "->honor 4x",
        "che2-ul00": "->honor 4x",
        "che-tl00": "->honor 4x",
        "hw-che1-cl10": "->honor 4x",
        "honor  4x": "DS=5.5;RS=720x1280;SZ=77.2x152.9x8.7;WT=170;RE=2014.10;RM=2048;CP=17;OI=1;OV=4.4;SM=2;",
        "chm-tl00": "->honor play 4c",
        "chm-tl00h": "->honor play 4c",
        "chm-ul00": "->honor play 4c",
        "hw-chm-cl00": "->honor play 4c",
        "honor play 4c": "RS=720x1280;DS=5;CP=3;RM=2048;OI=1;OV=4.4.2;SZ=71.9x143.3x8.8;WT=162;RE=2015.04;",
        "chm-u01": "->honor 4c",
        "honor 4c": "DS=5;RS=720x1280;SZ=71.9x143.3x8.8;WT=162;RE=2015.04;RM=2048;CP=3;OI=1;OV=4.4;SM=2;",
        "dig-l21hn": "->honor 6c",
        "honor 6c": "DS=5;RS=720x1280;SZ=69.9x143x7.3;WT=138;RE=2017.04;RM=3072;CP=35;OI=1;OV=6;SM=2",
        "dli-al10": "->honor 6a",
        "dli-tl20": "->honor 6a",
        "dli-l22": "->honor 6a",
        "dli-l42": "->honor 6a",
        "honor 6a": "DS=5;RS=720x1280;SZ=70.95x143.7x8.2;WT=143;RE=2017.07;RM=2048;CP=43;OI=1;OV=7;SM=2;",
        "dnn-lx9": "->x10 lite",
        "honor x10 lite": "DS=6.67;RS=1080x2400;SZ=76.88x165.65x9.26;WT=206;RM=4096;CP=213;OI=1;OV=10;SM=2;RE=2020.11;",
        "stf-al10": "->honor 9",
        "stf-l09": "->honor 9",
        "stf-l09s": "->honor 9",
        "stf-tl10": "->honor 9",
        "stf-al00": "->honor 9",
        "honor 9": "RE=2017.06;SZ=70.9x147.3x7.5;WT=155;DS=5.15;RS=1080x1920;OI=1;OV=7.0;CP=221;RM=4096;",
        "frd-al00": "->honor 8",
        "frd-al10": "->honor 8",
        "frd-dl00": "->honor 8",
        "frd-l02": "->honor 8",
        "frd-l04": "->honor 8",
        "frd-l09": "->honor 8",
        "frd-l14": "->honor 8",
        "frd-l19": "->honor 8",
        "vat-l19": "->honor 8",
        "honor 8": "DS=5.2;RS=71x145.5x7.5;SZ=71x145.5x7.45;WT=153;RE=2016.07;RM=4096;CP=216;OI=1;OV=8;",
        "h60-l01": "->honor 6",
        "h60-l02": "->honor 6",
        "h60-l03": "->honor 6",
        "h60-l04": "->honor 6",
        "h60-l11": "->honor 6",
        "h60-l12": "->honor 6",
        "h60-j1": "->honor 6",
        "mogolia": "->honor 6",
        "hw-h60-j1": "->honor 6",
        "honor 6": "DS=5;RS=1080x1920;SZ=69.7x139.6x7.5;WT=130;RE=2014.08;RM=3072;CP=30;OI=1;OV=4.4;SM=2;",
        "plk-cl00": "->honor 7",
        "plk-al10": "->honor 7",
        "plk-l01": "->honor 7",
        "plk-tl00": "->honor 7",
        "plk-tl01h": "->honor 7",
        "plk-ul00": "->honor 7",
        "hw-plk-cl00": "->honor 7",
        "plk": "->honor 7",
        "honor 7": "DS=5.2;RS=1080x1920;SZ=71.9x143.2x8.5;WT=157;RE=2015.06;OI=1;OV=6;RM=3072;CP=223;",
        "y6 pro": "RE=2015.10;SZ=71.8x143.1x9.7;WT=160;DS=5.0;RS=720x1280;OI=1;OV=5.1.1;CP=56;RM=2048;",
        "tit-u02": "->y6 pro",
        "y5 pro (2017)": "RE=2017.04;SZ=72x143.8x8.4;WT=150;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=69;RM=2048;",
        "mya-l13": "->y5 pro (2017)",
        "4afrika": "DS=4;RS=480x800;SZ=63.7x124.5x10.5;WT=130;RE=2013.02;RM=512;CP=212;OI=4;OV=8;",
        "ale-l21": "->p8 lite (2015)",
        "ale-tl00": "->p8 lite (2015)",
        "ale-ul00": "->p8 lite (2015)",
        "503hw": "->p8 lite (2015)",
        "ale-l02": "->p8 lite (2015)",
        "ale-l23": "->p8 lite (2015)",
        "p8 lite (2015)": "DS=5;RS=720x1280;SZ=70.6x143x7.7;WT=131;RE=2015.04;OI=1;OV=5.0.2;RM=2048;CP=3;SM=2;",
        "608hw": "->nova lite",
        "nova lite": "DS=5.2;RS=1080x1920;SZ=72.94x147.2x7.6;WT=147;RE=2017.10;OI=1;OV=7.0;RM=3072;CP=48;SM=2;",
        "701hw": "->mediapad m3 lite",
        "cpn-al00": "->mediapad m3 lite",
        "cpn-l09": "->mediapad m3 lite",
        "cpn-w09": "->mediapad m3 lite",
        "mediapad m3 lite": "RE=2017.06;SZ=213.3x123.3x7.5;WT=310;DS=8.0;RS=1920x1200;OI=1;OV=7.0;CP=35;RM=4096;",
        "pot-tl00a": "->9s",
        "pot-al00a": "->9s",
        "enjoy 9s": "->9s",
        "9s": "DS=6.21;RS=1080x2340;SZ=73.4x155.2x8;WT=160;RE=2019.03;OI=1;OV=9;SM=2;RM=4096;CP=28;",
        "704hw": "->nova 2 lite",
        "nova 2 lite": "DS=5.99;RS=720x1440;SZ=76.7x158.3x7.8;WT=155;RE=2018.03;OI=1;OV=8.0;RM=3072;CP=43;",
        "ags-l03": "->mediapad t3 10",
        "ags-l09": "->mediapad t3 10",
        "ags-w09": "->mediapad t3 10",
        "mediapad t3 10": "RE=2017.05;SZ=229.8x159.8x8;WT=460;DS=9.6;RS=1280x800;OI=1;OV=7.0;CP=20;RM=2048;",
        "ags2-al00": "->enjoy tablet 10.1",
        "enjoy tablet 10.1": "DS=10.1;RS=1920x1200;WT=460;SZ=243x164x8;RM=4096;CP=42;OI=1;OV=8.0;SM=1;RE=2018.11;",
        "ags2-l03": "->mediapad t5 10",
        "ags2-l09": "->mediapad t5 10",
        "ags2-w09": "->mediapad t5 10",
        "ags2-w19": "->mediapad t5 10",
        "mediapad t5 10": "RE=2018.08;SZ=243x164x7.8;WT=460;DS=10.1;RS=1920x1200;OI=1;OV=8.0;CP=42;RM=2048;",
        "ags3-l09": "->matepad t10s",
        "ags3-w09": "->matepad t10s",
        "matepad t 10s": "->matepad t10s",
        "matepad t10s": "RE=2020.09;SZ=240.2x159x7.9;WT=450;DS=10.1;RS=1920x1200;OI=1;OV=10;CP=213;RM=2048;",
        "alp-al00": "->mate 10",
        "alp-tl00": "->mate 10",
        "alp-l29": "->mate 10",
        "alp-l09": "->mate 10",
        "mate 10": "RE=2017.10;SZ=77.8x150.5x8.2;WT=186;DS=5.9;RS=1440x2560;OI=1;OV=8.0;CP=50;RM=4096;",
        "amn-lx1": "->y5 (2019)",
        "amn-lx2": "->y5 (2019)",
        "amn-lx3": "->y5 (2019)",
        "amn-lx9": "->y5 (2019)",
        "y5 (2019)": "RE=2019.04;SZ=70.8x147.1x8.5;WT=146;DS=5.71;RS=720x1520;OI=1;OV=9.0;CP=44;RM=2048;",
        "ane-al00": "->nova 3e",
        "nova 3e": "WT=145;SZ=71.2x148.6x7.4;DS=5.84;RS=1080x2280;RM=4096;CP=42;RE=2018.03;SM=2;OI=1;OV=8.0;",
        "ane-lx1": "->p20 lite",
        "ane-lx2j": "->p20 lite",
        "ane-lx2": "->p20 lite",
        "ane-lx3": "->p20 lite",
        "ane-tl00": "->p20 lite",
        "hwv32": "->p20 lite",
        "p20 lite": "RE=2018.03;SZ=71.2x148.6x7.4;WT=145;DS=5.84;RS=1080x2280;OI=1;OV=8.0;CP=42;RM=4096;SM=2;",
        "aqm-al00": "->enjoy 10s",
        "aqm-tl00": "->enjoy 10s",
        "enjoy 10s": "DS=6.3;RS=1080x2400;SZ=73.2x157.4x7.8;WT=163;RM=6144;CP=37;RE=2019.09;OI=1;OV=9;",
        "aqm-lx1": "->y8p",
        "y8p": "RE=2020.05;SZ=73.2x157.4x7.8;WT=163;DS=6.3;RS=1080x2400;OI=1;OV=10;CP=37;RM=4096;",
        "ars-al00": "->y max",
        "ars-l22": "->y max",
        "ars-tl00": "->y max",
        "y max": "RE=2018.11;SZ=86.2x177.6x8.5;WT=210;DS=7.12;RS=1080x2244;OI=1;OV=8.1;CP=61;RM=4096;",
        "art-al00m": "->enjoy 10",
        "art-al00x": "->enjoy 10",
        "art-tl00x": "->enjoy 10",
        "art-tl00m": "->enjoy 10",
        "enjoy 10": "DS=6.39;RS=720x1560;SZ=76.1x159.8x8.1;WT=176;RM=4096;CP=37;RE=2019.11;OI=1;OV=9;SM=2;",
        "art-l28": "->y7p",
        "y7p": "RE=2020.02;SZ=76.1x159.8x8.1;WT=176;DS=6.39;RS=720x1560;OI=1;OV=9;CP=37;RM=4096;",
        "art-l29": "->p40 lite e",
        "art-l29n": "->p40 lite e nfc",
        "p40 lite e nfc": "RE=2020.03;SZ=76.1x159.8x8.1;WT=176;DS=6.39;RS=720x1560;OI=1;OV=9.0;CP=37;RM=4096;",
        "p40 lite e": "RE=2020.03;SZ=76.1x159.8x8.1;WT=176;DS=6.39;RS=720x1560;OI=1;OV=9.0;CP=37;RM=4096;",
        "ascend d1": "DS=4.5;RS=720x1280;SZ=64x129x8.9;WT=132;RE=2012.07;OI=1;OV=4;RM=1024;CP=29;",
        "p40 lite": "RE=2020.02;SZ=76.3x159.2x8.7;WT=183;DS=6.4;RS=1080x2310;OI=1;OV=10;CP=57;RM=6144;",
        "jny-lx1": "->p40 lite",
        "z100-tl10": "->ascend d3",
        "z100-cl00": "->ascend d3",
        "z100-ul00": "->ascend d3",
        "ascend d3": "DS=6.1;RS=1080x1920;OI=1;OV=4.4;RE=2014;RM=2048;CP=30;",
        "u8818": "->ascend g300",
        "ascend g300": "DS=4;RS=480x800;SZ=63x122.5x10.5;RE=2012.04;WT=140;OI=1;OV=2.3;RM=512;CP=31;",
        "g527-u081": "->ascend g527",
        "ascend g527": "DS=4.5;RS=540x960;SZ=67.5x134.5x9.9;RE=2013.08;OI=1;OV=4.1;WT=150;RM=1024;CP=32;",
        "c8817d": "->ascend g620s",
        "g620s-l01": "->ascend g620s",
        "g620s-l03": "->ascend g620s",
        "ascend g620s": "DS=5;RS=720x1280;SZ=72.05x142.95x8.5;RM=1024;WT=160;SM=1;OI=1;OV=4.4;SP=17;RE=2015.07;",
        "g630-u251": "->ascend g630",
        "ascend g630": "DS=5;RS=720x1280;SZ=71.7x143x7.8;RM=1024;WT=165;OI=1;OV=4.3;RE=2014.07;CP=33;",
        "g730-c00": "->ascend g730",
        "ascend g730": "DS=5.5;RS=540x960;SZ=78.3x151.5x9.6;WT=180;OI=1;OV=4.3;RE=2014.04;RM=1024;CP=7;SM=2;",
        "g7-l01": "->ascend g7",
        "g7-tl00": "->ascend g7",
        "ascend g7": "DS=5.5;RS=720x1280;SZ=77.3x153.5x7.6;WT=165;OI=1;OV=4.4;RE=2014.10;RM=2048;CP=17;SM=1;",
        "ascend mate 2": "RS=1080x1920;DS=6.1;CP=78;RM=2048;OI=1;OV=4.2.2;SZ=84.9x161x9.54;WT=202;RE=2014.02;",
        "mt2l03": "->ascend mate 2",
        "mt2-l03": "->ascend mate 2",
        "u9200": "->ascend p1",
        "ascend p1": "DS=4.3;RS=540x960;RE=2012.05;WT=110;SZ=64.8x127.4x7.7;SM=1;OI=1;OV=4;RM=1024;CP=14;",
        "p7-l10": "->ascend p7",
        "ascend p7": "DS=5;RS=1080x1920;SZ=68.8x139.8x6.5;WT=124;OI=1;OV=4.4;RE=2014.05;RM=2048;CP=34;SM=1;",
        "h1711": "->ascend xt2",
        "ascend xt2": "DS=5.5;RS=720x1280;SZ=76.2x153.4x8.4;WT=165.00;RM=2048;CP=35;OI=1;OV=7;SM=1;RE=2017.10;",
        "y221-u12": "->ascend y221",
        "y221-u22": "->ascend y221",
        "y221-u03": "->ascend y221",
        "y221-u33": "->ascend y221",
        "y221-u43": "->ascend y221",
        "y221-u53": "->ascend y221",
        "ascend y221": "DS=3.5;RS=320x480;RE=2014.12;WT=130;SZ=60.6x116.5x12.3;OI=1;OV=4.4;CP=36;RM=512;",
        "y320-u10": "->ascend y320",
        "y320-t00": "->ascend y320",
        "y320-u05": "->ascend y320",
        "ascend y320": "DS=4;SZ=63.2x123.3x11.1;RS=480x800;OI=1;OV=4.2;RE=2013.12;WT=123;RM=512;CP=24;",
        "mt7-l09": "->ascend mate 7",
        "mt7-tl00": "->ascend mate 7",
        "mt7-tl10": "->ascend mate 7",
        "mt7-cl00": "->ascend mate 7",
        "ascend mate 7": "RE=2014.09;SZ=81x157x7.9;WT=185;DS=6.0;RS=1080x1920;OI=1;OV=4.4.2;CP=70;RM=2048;",
        "bucare y330-u05": "->ascend y330",
        "y330-u05": "->ascend y330",
        "ascend y330": "DS=4;SZ=63.5x122.1x11.3;RS=480x800;WT=126;SM=2;OI=1;OV=4.2;RM=512;CP=24;RE=2014.03;",
        "541-u02": "->ascend y5c",
        "ascend y5c": "DS=4.5;RS=480x800;SZ=66.7x134.3x10;WT=141;SM=2;RM=1024;OI=1;OV=4.4;CP=6;RE=2017.08;",
        "ath-ul01": "->shotx",
        "ath-ul06": "->shotx",
        "shotx": "DS=5.2;RS=1080x1920;SZ=71.2x141.6x7.8;WT=160;RE=2015.08;RM=2048;CP=22;OI=1;OV=5.1;",
        "atu-al10": "->enjoy 8e",
        "atu-tl10": "->enjoy 8e",
        "enjoy 8e": "DS=5.7;RS=720x1440;SZ=73x152.4x7.8;WT=150;RM=3072;CP=43;RE=2018.03;OI=1;OV=8;SM=1;",
        "atu-l21": "->y6 (2018)",
        "atu-l22": "->y6 (2018)",
        "atu-lx3": "->y6 (2018)",
        "atu-l11": "->y6 (2018)",
        "y6 (2018)": "RE=2018.04;SZ=73x152.4x7.8;WT=150;DS=5.7;RS=720x1440;OI=1;OV=8.0;CP=20;RM=2048;",
        "atu-l31": "->y6 prime (2018)",
        "atu-l42": "->y6 prime (2018)",
        "y6 prime (2018)": "RE=2018.04;SZ=73x152.4x7.8;WT=150;DS=5.7;RS=720x1440;OI=1;OV=8.0;CP=20;RM=2048;",
        "bac-l01": "->nova 2 plus",
        "bac-l03": "->nova 2 plus",
        "bac-al00": "->nova 2 plus",
        "bac-tl00": "->nova 2 plus",
        "bac-l21": "->nova 2 plus dual sim",
        "bac-l22": "->nova 2 plus dual sim",
        "bac-l23": "->nova 2 plus dual sim",
        "nova 2 plus": "RE=2017.05;SZ=74.9x153.9x6.9;WT=169;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=42;RM=4096;SM=1;",
        "bah-al00": "->mediapad m3 lite 10",
        "bah-l09": "->mediapad m3 lite 10",
        "mediapad m3 lite 10": "DS=10.1;RS=1920x1200;SZ=241.3x171.5x7.1;WT=310.0;RE=2017.05;RM=4096;CP=35;OI=1;OV=7.0;",
        "bah2-al00": "->mediapad m5 lite",
        "bah2-al10": "->mediapad m5 lite",
        "bah2-l09": "->mediapad m5 lite",
        "bah2-w19": "->mediapad m5 lite",
        "bah2-w09": "->mediapad m5 lite",
        "mediapad m5 lite": "RE=2018.09;SZ=243.4x162.2x7.7;WT=475;DS=10.1;RS=1920x1200;OI=1;OV=8.0;CP=42;RM=4096;",
        "bah3-al00": "->matepad 10.4\"",
        "bah3-l09": "->matepad 10.4\"",
        "bah3-w09": "->matepad 10.4\"",
        "matepad 10.4\"": "RE=2020.04;SZ=245.2x155x7.4;WT=450;DS=10.4;RS=2000x1200;OI=1;OV=10;CP=57;RM=3072;",
        "bg2-u01": "->mediapad t3 7",
        "bg2-u03": "->mediapad t3 7",
        "bg2-w09": "->mediapad t3 7",
        "mediapad t3 7": "RE=2017.04;SZ=179x103.7x8.6;WT=250;DS=7.0;RS=1024x600;OI=1;OV=6.0;CP=184;RM=1024;",
        "mediapad t2 7.0 pro": "RE=2016.08;SZ=187.4x105.8x8.2;WT=250;DS=7.0;RS=1920x1080;OI=1;OV=5.1 ;CP=22;RM=2048;",
        "ple-701l": "->mediapad t2 7.0 pro",
        "ple-703l": "->mediapad t2 7.0 pro",
        "bgo-dl09": "->mediapad t2 7.0 pro",
        "bgo-l03": "->mediapad t2 7.0",
        "mediapad t2 7.0": "RE=2016.08;SZ=191.8x107x8.5;WT=278;DS=7.0;RS=1024x600;OI=1;OV=6;CP=215;RM=1024;",
        "bla-l09": "->mate 10 pro",
        "bla-l29": "->mate 10 pro",
        "bla-tl00": "->mate 10 pro",
        "bla-al00": "->mate 10 pro",
        "bla-a09": "->mate 10 pro",
        "mate 10 pro": "RE=2017.10;SZ=74.5x154.2x7.9;WT=178;DS=6.0;RS=1080x2160;OI=1;OV=8.0;CP=50;RM=4096;",
        "bll-l22": "->gr5 (2017)",
        "bll-l21": "->gr5 (2017)",
        "gr5 (2017)": "DS=5.5;RS=1080x1920;SZ=76.3x151.3x8.15;;WT=162;RE=2017;RM=3072;CP=48;OI=1;OV=6.0;SM=2;",
        "bll-l23": "->mate 9 lite",
        "mate 9 lite": "DS=5.5;RS=1080x1920;SZ=76.3x151.3x8.15;;WT=162;RE=2017;RM=3072;CP=48;OI=1;OV=6.0;SM=2;",
        "bnd-l34": "->mate se",
        "mate se": "RS=1080x2160;DS=5.93;CP=42;RN=4096;OI=1;OV=7.0;SZ=75.3x156.5x7.6;WT=165;RE=2018.03;",
        "btv-dl09": "->mediapad m3",
        "btv-w09": "->mediapad m3 8",
        "mediapad m3 8": "RE=2016.09;SZ=215.5x124.2x7.3;WT=326;DS=8.4;RS=2560x1600;OI=1;OV=6.0;216;RM=4096;",
        "mediapad m3": "->mediapad m3 8",
        "bzk-l00": "->mediapad t3 8",
        "bzk-w00": "->mediapad t3 8",
        "kob-l09": "->mediapad t3 8",
        "kob-w09": "->mediapad t3 8",
        "mediapad t3 8": "RS=1280x800;DS=8;CP=20;RM=2048;OI=1;OV=7.0;SZ=211.1x124.7x8;WT=350;RE=2017.04;",
        "bzt-al00": "->mediapad c5 10.1",
        "bzt-al10": "->mediapad c5 10.1",
        "c5 10 (2020)": "->mediapad c5 10.1",
        "mediapad c5 10.1": "RM=4096;RE=2020.07;DS=10.4;SZ=245.2x154.96x7.35;WT=450;RS=2000x1200;CP=57;SM=1;OI=1;OV=10;",
        "c8500s": "RS=240x320;DS=2.8;CP=217;RM=256;OI=1;OV=2.2;SZ=56x104x13.8;WT=110;RE=2011.07;",
        "c8812": "RS=480x800;DS=4;CP=218;RM=1024;OI=1;OV=4.0;SZ=62.66x122.3x11.39;WT=135;RE=2012.05;",
        "c8813": "RS=480x854;DS=4.5;CP=219;RM=512;OI=1;OV=4.1;SZ=67x132.5x9.3;WT=130;RE=2012.05;",
        "c8813q": "RS=480x854;DS=4.5;CP=220;RM=512;OI=1;OV=4.1;SZ=67x132.5x9.3;WT=156;RE=2012.05;",
        "c8815": "RS=540x960;DS=5;CP=220;RM=1024;OI=1;OV=4.1;SZ=73.6x142x9.7;WT=170;RE=2013.08;",
        "cag-l22": "->y3 (2018)",
        "cag-l02": "->y3 (2018)",
        "y3 (2018)": "RE=2018.05;SZ=73.7x145.1x9.5;WT=175;DS=5.0;RS=480x854;OI=1;OV=8.0;CP=86;RM=1024;",
        "cag-l03": "->y5 lite (2018)",
        "cag-l23": "->y5 lite (2018)",
        "y5 lite (2018)": "RE=2018.12;SZ=70.9x146.5x8.3;WT=142;DS=5.45;RS=720x1440;OI=1;OV=8.1;CP=8;RM=1024;",
        "cam-l03": "->y6ii",
        "cam-l21": "->y6ii",
        "cam-l32": "->y6ii",
        "y6ii": "RE=2016.09;SZ=72x143.8x8.9;WT=140;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=79;RM=1024;",
        "can-l01": "->nova",
        "can-l02": "->nova",
        "can-l03": "->nova",
        "can-l11": "->nova",
        "can-l12": "->nova",
        "can-l13": "->nova",
        "caz-al00": "->nova",
        "caz-al10": "->nova",
        "caz-tl10": "->nova",
        "caz-tl20": "->nova",
        "nova": "RE=2016.09;SZ=69.1x141.2x7.1;WT=146;DS=5.0;RS=1080x1920;OI=1;OV=6.0.1;CP=204;RM=3072;",
        "nova 7 se": "RE=2020.04;SZ=75x162.3x8.6;WT=189;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=55;RM=6144;",
        "chc-u01": "->g play mini",
        "chc-u03": "->g play mini",
        "chc-u23": "->g play mini",
        "g play mini": "DS=5;RS=720x1280;SZ=71.9x143.3x8.8;WT=162;RE=2015.04;RM=2048;CP=3;OI=1;OV=4.4;SM=2;",
        "clt-al00": "->p20 pro",
        "clt-al01": "->p20 pro",
        "clt-l09": "->p20 pro",
        "clt-l29": "->p20 pro",
        "clt-tl00": "->p20 pro",
        "clt-tl01": "->p20 pro",
        "hw-01k": "->p20 pro",
        "clt-l29c": "->p20 pro",
        "clt-l09c": "->p20 pro",
        "clt-al00l": "->p20 pro",
        "clt-l04": "->p20 pro",
        "p20 pro": "RE=2018.05;SZ=73.9x155x7.8;WT=180;DS=6.1;RS=1080x2240;OI=1;OV=8.1;CP=50;RM=6144;",
        "cmr-al19": "->mediapad m5 10.8",
        "cmr-al09": "->mediapad m5 10.8",
        "cmr-w09": "->mediapad m5 10.8",
        "mediapad m5 10.8": "RE=2018.04;SZ=258.7x171.8x7.3;WT=498;DS=10.8;RS=2560x1600;OI=1;OV=8.0;CP=222;RM=4096;",
        "cmr-w19": "->mediapad m5 pro 10.8",
        "mediapad m5 pro 10.8": "RE=2018.02;SZ=258.7x171.8x7.3;WT=498;DS=10.8;RS=2560x1600;OI=1;OV=8.0;CP=221;RM=4096;",
        "sht-al09": "->mediapad m5 8.4",
        "sht-w09": "->mediapad m5 8.4",
        "mediapad m5 8.4": "RE=2018.02;SZ=212.6x124.8x7.3;WT=316;DS=8.4;RS=2560x1600;OI=1;OV=8.0;CP=222;RM=4096;",
        "cro-u00": "->y3 (2017)",
        "cro-l02": "->y3 (2017)",
        "cro-l22": "->y3 (2017)",
        "y3 (2017)": "RE=2017.05;SZ=73.7x145.1x9.5;WT=175;DS=5.0;RS=480x854;OI=1;OV=6.0;CP=58;RM=1024;",
        "cro-l03": "->y5 lite (2017)",
        "cro-l23": "->y5 lite (2017)",
        "y5 lite (2017)": "RE=2017.04;SZ=72x143.8x8.4;WT=150;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=69;RM=2048;",
        "crr-l09": "->mate s",
        "crr-ul00": "->mate s",
        "crr-ul20": "->mate s",
        "mate s": "E=2015.09;SZ=75.3x149.8x7.2;WT=156;DS=5.5;RS=1080x1920;OI=1;OV=5.1.1;CP=223;RM=3072;",
        "cun-l01": "->y5ii",
        "cun-l02": "->y5ii",
        "cun-l03": "->y5ii",
        "cun-l21": "->y5ii",
        "cun-l22": "->y5ii",
        "cun-l23": "->y5ii",
        "cun-l33": "->y5ii",
        "cun-u29": "->y5ii",
        "y5ii": "RE=2016.04;SZ=72x143.8x8.9;WT=135;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=56;RM=1024;",
        "d-02h": "->d tab compact",
        "d-02k": "->d tab compact",
        "d-01j": "->d tab compact",
        "d tab compact": "DS=8.4;RS=2560x1600;SZ=215.5x124.2x7.3;WT=326;SM=1;RM=3072;CP=216;RE=2016.10;OI=1;OV=6.0;",
        "d-01k": "->dtab d-01k",
        "dtab d-01k": "DS=10.1;RS=1920x1200;SZ=248x173x7.8;WT=475;RM=3072;CP=42;OI=1;OV=7.0;RE=2017.10;SM=1;",
        "dig-tl10": "->enjoy 6s",
        "dig-al00": "->enjoy 6s",
        "enjoy 6s": "DS=5;RS=720x1280;SZ=69.9x143.5x7.6;WT=138;RM=3072;CP=35;RE=2017.01;OI=1;OV=6;SM=2;",
        "dig-l01": "->nova smart",
        "nova smart": "RE=2016.12;SZ=69.9x143.5x7.6;WT=138;DS=5.0;RS=720x1280;OI=1;OV=6;CP=35;",
        "dig-l21": "->gr3 (2017)",
        "dig-l22": "gr3 (2017)",
        "gr3 (2017)": "DS=5.2;RS=1080x1920;SZ=72.94x147.2x7.6;WT=147;RE=2017;RM=3072;CP=48;OI=1;OV=7;SM=2;",
        "dig-l23": "->p9 lite smart",
        "p9 lite smart": "DS=5;RS=720x1280;SZ=69.9x143.5x7.6;WT=138;RM=3072;CP=35;RE=2017.01;OI=1;OV=6;SM=2;",
        "dra-al00": "->y5 prime (2018)",
        "dra-l01": "->y5 (2018)",
        "dra-l21": "->y5 (2018)",
        "dra-lx3": "->y5 (2018)",
        "y5 (2018)": "RE=2018.05;SZ=70.9x146.5x8.3;WT=142;DS=5.45;RS=720x1440;OI=1;OV=8.1;CP=8;RM=2048;",
        "dua-lx2": "y5 (2018)",
        "dua-l21": "y5 (2018)",
        "dra-tl00": "->y5 prime (2018)",
        "dra-lx2": "->y5 prime (2018)",
        "y5 prime (2018)": "->y5 (2018)",
        "dra-lx5": "->y5 lite",
        "y5 lite": "RE=2018.12;SZ=70.9x146.5x8.3;WT=142;DS=5.45;RS=720x1440;OI=1;OV=8.1;CP=8;RM=1024;",
        "dra-lx9": "->y5p",
        "y5p": "RE=2020.05;SZ=70.9x146.5x8.4;WT=144;DS=5.45;RS=720x1440;OI=1;OV=10;CP=47;RM=2048",
        "dub-lx2": "->y7 pro (2019)",
        "dub-al00": "->y7 pro (2019)",
        "dub-al20": "->y7 pro (2019)",
        "y7 pro (2019)": "RE=2019.01;SZ=76.9x158.9x8.1;WT=168;DS=6.26;RS=720x1520;OI=1;OV=8.1;CP=224;RM=3072;",
        "dub-lx1": "->y7 (2019)",
        "dub-lx3": "->y7 (2019)",
        "dub-tl00": "->y7 (2019)",
        "y7 (2019)": "RE=2019.01;SZ=76.9x158.9x8.1;WT=168;DS=6.26;RS=720x1520;OI=1;OV=8.1;CP=224;RM=3072;",
        "dvc-tn20": "->enjoy 20 pro",
        "dvc-an20": "->enjoy 20 pro",
        "enjoy 20 pro": "DS=6.5;RS=1080x2400;SZ=160x75.3x8.4;WT=192;RM=6144;CP=45;RE=2020.06;OI=1;OV=10;SM=2;",
        "ele-al00": "->p30",
        "ele-tl00": "->p30",
        "p30": "RE=2019.05;SZ=71.4x149.1x7.6;WT=165;DS=6.1;RS=1080x2340;OI=1;OV=9.0;CP=52;RM=8192;",
        "els-an00": "->p40 pro",
        "els-tn00": "->p40 pro",
        "els-nx9": "->p40 pro",
        "els-n04": "->p40 pro",
        "p40 pro": "RE=2020.05;SZ=72.6x158.2x9;WT=209;DS=6.58;RS=1200x2640;OI=1;OV=10;CP=54;RM=8192;",
        "els-an10": "->p40 pro plus",
        "els-n39": "->p40 pro plus",
        "p40 pro plus": "RE=2020.05;SZ=72.6x158.2x9;WT=226;DS=6.58;RS=1200x2640;OI=1;OV=10;CP=54;RM=8192;",
        "eml-al00": "->p20",
        "eml-l09": "->p20",
        "eml-l29": "->p20",
        "eml-tl00": "->p20",
        "p20": "RE=2018.05;SZ=70.8x149.1x7.7;WT=165;DS=5.8;RS=1080x2240;OI=1;OV=8.1;CP=50;RM=4096;",
        "stk-tl00": "->enjoy 10 plus",
        "stk-al00": "->enjoy 10 plus",
        "enjoy 10 plus": "RE=2019.09;SZ=77.3x163.5x8.8;WT=163.5;DS=6.59;RS=1080x2340;OI=1;OV=9.0;CP=37;RM=4096;",
        "med-al00": "->enjoy 10e",
        "med-tl00": "->enjoy 10e",
        "enjoy 10e": "DS=6.3;RS=720x1600;SZ=74.1x159.1x9.04;WT=185;RM=4096;CP=38;OI=1;OV=10;SM=2;RE=2020.03;SM=2;",
        "tag-al00": "->enjoy 5s",
        "tag-cl00": "->enjoy 5s",
        "tag-tl00": "->enjoy 5s",
        "enjoy 5s": "DS=5;RS=720x1280;SZ=71x143x7.6;WT=135;RM=2048;CP=39;OI=1;OV=5.1;SM=2;RE=2015.12",
        "nce-al10": "->enjoy 6",
        "nce-al00": "->enjoy 6",
        "nce-tl10": "->enjoy 6",
        "enjoy 6": "DS=5;RS=720x1280;SZ=70.4x143.2x7.9;WT=145;RM=3072;CP=40;RE=2016.10;OI=1;OV=6;SM=2;",
        "trt-al00": "->enjoy 7 plus",
        "trt-al00a": "->enjoy 7 plus",
        "trt-tl10a": "->enjoy 7 plus",
        "enjoy 7 plus": "DS=5.5;RS=720x1280;SZ=76.4x153.6x8.4;WT=165;RM=3072;CP=35;RE=2013.04;OI=1;OV=7;",
        "sla-al00": "->enjoy 7",
        "sla-tl10": "->enjoy 7",
        "sla-tl00": "->enjoy 7",
        "enjoy 7": "DS=5;RS=720x1280;SZ=71x143.5x8.05;WT=145;RM=3072;CP=20;OI=1;OV=7;RE=2017.07",
        "fig-al00": "->enjoy 7s",
        "fig-tl00": "->enjoy 7s",
        "fig-tl10": "->enjoy 7s",
        "fig-al10": "->enjoy 7s",
        "enjoy 7s": "DS=5.65;RS=1080x2160;SZ=72.1x150.1x7.5;WT=143;RE=2017.12;OI=1;OV=8;RM=3072;CP=42;",
        "ldn-tl20": "->enjoy 8",
        "ldn-al10": "->enjoy 8",
        "ldn-al20": "->enjoy 8",
        "ldn-tl00": "->enjoy 8",
        "enjoy 8": "DS=5.99;RS=720x1440;WT=155;SZ=76.7x158.3x7.8;RM=3072;CP=43;RE=2018.03;OI=1;OV=8;",
        "mrd-al00": "enjoy 9e",
        "mrd-tl00": "enjoy 9e",
        "enjoy 9e": "DS=6.09;RS=720x1560;SZ=73.5x156.28x8;WT=150;RM=3072;CP=44;RE=2019.03;OI=1;OV=9;SM=2;",
        "eva-al00": "->p9",
        "eva-cl00": "->p9",
        "eva-dl00": "->p9",
        "eva-l09": "->p9",
        "eva-tl00": "->p9",
        "p9": "RE=2016.04;SZ=70.9x145x7;WT=144;DS=5.2;RS=1080x1920;OI=1;OV=6.0;CP=225;RM=3072;",
        "evr-al00": "->mate 20 x",
        "evr-an00": "->mate 20 x",
        "evr-n29": "->mate 20 x",
        "evr-tl00": "->mate 20 x",
        "mate 20 x": "RE=2018.10;SZ=85.4x174.6x8.2;WT=232;DS=7.2;RS=1080x2244;OI=1;OV=9.0;CP=52;RM=6144;",
        "fdr-a01l": "->mediapad t2 10.0\" pro",
        "fdr-a01w": "->mediapad t2 10.0\" pro",
        "fdr-a03l": "->mediapad t2 10.0\" pro",
        "mediapad t2 10.0\" pro": "RE=2016.08;SZ=259.1x156.4x8.5;WT=495;DS=10.0;RS=1920x1200;OI=1;OV=5.1;CP=22;RM=2048;",
        "fig-lx1": "->p smart",
        "fig-lx2": "->p smart",
        "p smart": "RE=2017.12;SZ=72.1x150.1x7.5;WT=143;DS=5.65;RS=1080x2160;OI=1;OV=8.0;CP=42;RM=3072;",
        "fla-al20": "->y9 (2018)",
        "fla-lx1": "->y9 (2018)",
        "fla-tl10": "->y9 (2018)",
        "y9 (2018)": "RE=2018.05;SZ=75.3x157.2x7.9;WT=170;DS=5.93;RS=1080x2160;OI=1;OV=8.0;CP=42;RM=3072;",
        "frl-l22": "->y9a",
        "frl-l23": "->y9a",
        "y9a": "RE=2020.09;SZ=76.5x163.5x9;WT=197;DS=6.63;RS=1080x2400;OI=1;OV=10;CP=226;RM=6144;",
        "u8665": "->fusion 2",
        "fusion 2": "DS=3.5;RS=320x480;SZ=61x115.8x11.7;WT=124.2;RE=2012.10;RM=512;CP=46;OI=1;OV=2.3;SM=1;",
        "g735-l03": "->g play",
        "g735-l12": "->g play",
        "g735-l23": "->g play",
        "g play": "DS=5.5;RS=720x1280;SZ=77.2x152.9x8.65;WT=170;RE=2015.01;RM=2048;CP=3;OI=1;OV=4.4;SM=2;",
        "g2800": "RS=128x128;DS=1.5;SZ=45x109x14.2;WT=70;",
        "g510-0010": "->ascend g510",
        "g510-0100": "->ascend g510",
        "ascend g510": "RE=2013.01;SZ=67x134x9.9;WT=150;DS=4.5;RS=480x854;OI=1;OV=4.1;CP=219;RM=512;",
        "g525-u00": "->ascend g525",
        "ascend g525": "RE=2013.01;SZ=66.8x134x9.9;WT=155;DS=4.5;RS=540x960;OI=1;OV=4.1;CP=110;RM=1024;",
        "g610-c00": "->g610s",
        "g610-u00": "->g610s",
        "g610-u20": "->g610s",
        "g610s": "RE=2013.06;SZ=73.6x142x9.9;WT=170;DS=5.0;RS=540x960;OI=1;OV=4.2;CP=27;RM=1024;",
        "g621-tl00": "->g621",
        "g621-tl00m": "->g621",
        "g621": "DS=5;RS=720x1280;SZ=72.05x142.95x8.5;WT=160;RE=2014.09;RM=1024;CP=17;OI=1;OV=4.4;SM=2;",
        "g6310": "RE=2012.03;SZ=59.8x113x12.5;WT=;DS=2.4;RS=320x240;RM=256;",
        "g6609": "RE=2012.04;SZ=60.5x113.8x11.5;WT=98;DS=2.4;RS=320x240;",
        "g6800": "RE=2012.03;SZ=59x117x12.2;WT=;DS=2.8;RS=240x320;",
        "g750-t01": "->honor 3x",
        "honor 3x": "DS=5.5;RS=720x1280;SZ=77.4x149.5x8.9;WT=162;RE=2013.12;RM=2048;CP=7;OI=1;OV=4.2;SM=2;",
        "gem-701l": "->mediapad x2",
        "gem-702l": "->mediapad x2",
        "gem-703l": "->mediapad x2",
        "mediapad x2": "RE=2015.05;SZ=183.5x103.9x7.2;WT=239;DS=7.0;RS=1920x1200;OI=1;OV=5;CP=227;RM=2048;",
        "glk-al00": "->nova 5i",
        "glk-lx1u": "->nova 5i",
        "glk-lx1": "->nova 5i",
        "glk-lx2": "->nova 5i",
        "glk-lx3": "->nova 5i",
        "glk-tl00": "->nova 5i",
        "nova 5i": "RE=2019.07;SZ=75.9x159.1x8.3;WT=178;DS=6.4;RS=1080x2310;OI=1;OV=9.0;CP=37;RM=6144;",
        "kii-l21": "->gr5",
        "gr5": "DS=5.5;RS=1080x1920;SZ=76.3x151.3x8.15;WT=158;RE=2016.02;RM=2048;CP=22;OI=1;OV=5.1;SM=2;",
        "gra-l09": "->p8",
        "gra-ul00": "->p8",
        "gra-ul10": "->p8",
        "gra-tl00": "->p8",
        "p8": "RE=2015.04;SZ=72.1x144.9x6.4;WT=144;DS=5.2;RS=1080x1920;OI=1;OV=4.4.2;CP=227;RM=3072;",
        "rio-l03": "->gx8",
        "gx8": "DS=5.5;RS=1080x1920;SZ=76.5x152x7.5;WT=167;RE=2015.10;RM=2048;CP=22;OI=1;OV=5.1;SM=2;",
        "h30-t00": "->honor 3c",
        "h30-t10": "->honor 3c",
        "h30-c00": "->honor 3c",
        "h30-l01m": "->honor 3c",
        "h30-l01": "->honor 3c",
        "h30-l02": "->honor 3c",
        "h30-u10": "->honor 3c",
        "honor 3c": "DS=5;RS=720x1280;SZ=71.4x139.5x9.2;WT=140;RE=2013.12;RM=2048;CP=7;OI=1;OV=4.2;SM=2;",
        "hol-u19": "->honor 3c lite",
        "honor 3c lite": "DS=5;RS=720x1280;SZ=72.3x142.2x9.4;WT=156;RE=2013.12;RM=1024;CP=7;OI=1;OV=4.2;SM=2;",
        "h867g": "DS=3.5;RS=320x480;WT=128;SZ=61x117x13;OI=1;OV=4.0.4;",
        "hma-al00": "->mate 20",
        "hma-tl00": "->mate 20",
        "hma-l09": "->mate 20",
        "hma-l29": "->mate 20",
        "hma-lx9": "->mate 20",
        "mate 20": "RE=2018.10;SZ=77.2x158.2x8.3;WT=188;DS=6.53;RS=1080x2244;OI=1;OV=9.0;CP=52;RM=6144",
        "u9508": "->honor 2",
        "honor 2": "DS=4.5;RS=720x1280;SZ=67.5x134x10.5;WT=145;RE=2012.09;RM=2048;CP=;OI=1;OV=4;SM=1;",
        "y6 (2019)": "RE=2019.03;SZ=73.5x156.3x8;WT=150;DS=6.09;RS=720x1560;OI=1;OV=9.0;CP=44;RM=2048;",
        "mrd-lx3": "->y6 (2019)",
        "mrd-lx1": "->y6 (2019)",
        "mrd-lx1n": "->y6 (2019)",
        "mrd-lx1f": "->y6 (2019)",
        "matepad pro": "RE=2019.11;SZ=246x159x7.2;WT=460;DS=10.8;RS=2560x1600;OI=1;OV=10;CP=327;RM=6144;",
        "mrx-al09": "->matepad pro",
        "mrx-w09": "->matepad pro",
        "mt2-l05": "->ascend mate 2",
        "mt2-l01": "->ascend mate 2",
        "ney-nx9": "->p40 pro",
        "huawei": "->y7 (2019)",
        "nova can-l11": "->nova",
        "ale-cl00": "->p8 lite (2015)",
        "fig-la1": "->p smart",
        "evr-l29": "->mate 20 x",
        "ele-l29": "->p30",
        "ele-l04": "->p30",
        "fig-lx3": "->p smart",
        "pra-lx2": "->nova lite",
        "eva-l19": "->p9",
        "tit-l01": "->y6 pro",
        "cam-l23": "->y6ii",
        "dig-l03": "->p9 lite smart",
        "fla-lx2": "->y9 (2018)",
        "fla-lx3": "->y9 (2018)",
        "ele-l09": "->p30",
        "eva-al10": "->p9",
        "ana-al00": "->p40",
        "med-al20": "->enjoy 10e",
        "eva-l29": "->p9",
        "crr-cl00": "->mate s",
        "clt-l0j": "->p20 pro",
        "kii-l22": "->gr5",
        "p7-l07": "->ascend p7",
        "els-n29": "->p40 pro plus",
        "fig-l11": "->p smart",
        "alp-l29s": "->mate 10",
        "frl-l21": "->y9a",
        "bla-l29s": "->mate 10 pro",
        "ane-l23": "->p20 lite",
        "jny-l01": "->p40 lite",
        "jny-l21": "->p40 lite",
        "fla-l23": "->y9 (2018)",
        "art-tl00": "->enjoy 10",
        "ana-n29": "->p40",
        "alp-l09s": "->mate 10",
        "fig-l31": "->p smart",
        "y6 2019": "->y6 (2019)",
        "y6prime": "->y6 prime (2018)",
        "ane-l22": "->p20 lite",
        "u9500": "->ascend d1",
        "y541-u02": "->ascend y5c",
        "hw-huawei c8500s": "->c8500s",
        "hw-huawei c8813": "->c8813",
        "hw-huawei c8815": "->c8815",
        "huaweig510-0100": "->g510-0100",
        "g610-c00 build huaweig610-c00) uc": "->g610-c00",
        "huawei-h867g": "->h867g",
        "hw-h30-c00": "->honor 3c",
        "honor h30-l01m": "->honor 3c",
        "honor h30-l02": "->honor 3c",
        "honor h30-l01": "->honor 3c",
        "pra-lx3": "->nova lite",
        "huawei-u8665": "->u8665",
        "tit-al00": "->y6 pro",
        "ags3-al09": "->matepad t10s",
        "605hw": "->mediapad t2 10.0\" pro",
        "ags2-w09hn": "->mediapad t5 10",
        "ags3-al00": "->matepad t10s",
        "jdn2-al50hn": "->mediapad m5 lite",
        "606hw": "->mediapad t2 10.0\" pro"
    },
    "ipro": {
        "amber 5s pro": "DS=5.0;RS=540x960;RM=1024;CP=58;SM=2;OI=1;OV=8.1;",
        "amber 6": "DS=5.5;RS=480x960;RM=1024;SZ=70.5x147.5x9.4;WT=160;OI=1;OV=8.1;CP=8;SM=2;",
        "amber 7s": "DS=5.5;RS=480x800;SZ=70.5x147.5x9.4;WT=160;RM=1024;OI=1;OV=8.1;CP=58;SM=2;",
        "amber5s pro": "->amber 5s pro",
        "amber6": "->amber 6",
        "amber7s": "->amber 7s",
        "jade 7s": "DS=5.72;RS=480x960;SZ=73.5x153.8x9.5;RM=1024;CP=58;SM=2;",
        "jade7s": "->jade 7s",
        "phoenix 5.0s": "->phonenix 50s",
        "phonenix 50s": "DS=5;RS=640x960;OI=1;OV=7.0;RM=1024;CP=5;",
        "phonenix50s": "->phonenix 50s",
        "zafiro": "DS=5.45;RS=480x960;SZ=73.5x153.8x9.5;RM=1024;CP=5;OI=1;OV=8.1;SM=2;"
    },
    "clarmin": {
        "c1": "RE=2018.07;RM=3072;DS=5;RS=720x1440;SM=2;CP=8;",
        "b5": "DS=5.5;RM=2048;RS=720x1280;OI=1;OV=7.0;CP=5;SZ=78.4x157.6x9.15;SM=2;",
        "b6": "OI=1;OV=6.0;RM=3072;DS=5.5;RS=1080x1920;SZ=76.7x154.3x9.8;WT=213;CP=118;"
    },
    "zync": {
        "cloud 605": "RE=2013.11;OI=1;OV=4.2;DS=6.5;RS=800x480;RM=512;",
        "cloud z5": "RE=2013.07;RM=512;SZ=140.4x80.9x10.2;WT=192;DS=5;RS=800x480;OI=1;OV=4.0;",
        "z5": "->cloud z5"
    },
    "zyq": {
        "braw 3g": "RE=2016.03;SZ=83x160x14.5;WT=219;",
        "q3623": "->braw 3g"
    },
    "engel": {
        "en1007q plus": "RE=2014.10;SZ=225x174x70;RM=1024;WT=700;",
        "en1007qplus": "->en1007q plus"
    },
    "tiphone": {
        "t67": "DS=2.2;RS=240x320;WT=105;SZ=58x106x13.4;RE=2009;SM=2;"
    },
    "ulefone": {
        "note 13p": "RE=2021.11;SZ=75.7x162.3x9.9;WT=198.5;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=348;RM=4096;",
        "note 12p": "RE=2021.10;SZ=79.1x173.6x10.2;WT=237;DS=6.82;RS=720x1640;OI=1;OV=11;CP=109;RM=4096",
        "note 10p": "RE=2022.03;SZ=76.7x165.2x9.7;WT=203;DS=6.52;RS=720x1600;OI=1;OV=11;CP=374;RM=3072;",
        "note 6p": "RE=2021.10;SZ=73.4x155.4x8.5;WT=155;DS=6.1;RS=720x1560;OI=1;OV=11;CP=109;RM=2048;",
        "note 9p": "RE=2020.07;SZ=76.7x166x9.2;WT=188;DS=6.52;RS=720x1600;OI=1;OV=10;CP=171;RM=4096;",
        "note 11p": "RE=2021.01;SZ=77.2x166.9x10;WT=184;DS=6.55;RS=720x1600;OI=1;OV=11;CP=290;RM=8192;",
        "armor 2": "RE=2017.08;SZ=78.3x159x14.5;WT=270;DS=5.0;RS=1080x1920;OI=1;OV=7.0;CP=232;RM=6144;TT=81125",
        "armor 3": "RE=2018.09;SZ=79.2x164.8x18.14;WT=364;DS=5.7;RS=1080x2160;OI=1;OV=8.1;CP=63;RM=4096;TT=71229;"
    },
    "formuler": {
        "z8 pro": "RE=2019;OI=1;OV=7.1;SZ=105x105x22;RM=2048;CP=228;",
        "z8": "RE=2019;OI=1;OV=7.0;SZ=105x105x22;RM=2048;CP=228;"
    },
    "geotel": {
        "amigo": "DS=5.2;RS=720x1280;SZ=75x150.55x9.8;WT=160;RE=2017;OI=1;OV=7.0;RM=3072;CP=118;",
        "g1": "DS=5;RS=720x1280;SZ=80.3x156.6x19.3;WT=280;RE=2017;OI=1;OV=7.0;RM=2048;CP=4;",
        "note": "DS=5.5;RS=720x1280;SZ=76.8x152.9x8.2;WT=147;RE=2017;OI=1;OV=6.0;RM=3072;CP=86;"
    },
    "firefly mobile": {
        "intense power": "DS=5.5;RS=720x1280;CP=6;RM=2048;RE=2016.05;OI=1;OV=5.1;",
        "intense metal 2": "DS=5.5;RS=720x1280;OI=1;OV=6.0;",
        "intense xt": "DS=5.7;RS=480x960;RM=1024;OI=1;OV=8.1;RE=2018.10;SM=2;",
        "aurii xcite": "DS=5.34;RS=480x960;OI=1;OV=8.1;RM=1024;RE=2018.11;SM=2;"
    },
    "panasonic": {
        "eluga ray 700": "RE=2017.09;SZ=75.4x153.8x8.9;WT=182;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=118;RM=3072;",
        "lumix dmc-cm1": "DS=4.7;RS=1920x1080;SZ=135.4x68x21.1;WT=204;RE=2014.12;RM=2048;CP=139;OI=1;OV=4.4.2;",
        "dmc-cm1": "->lumix dmc-cm1",
        "p55 novo 4g": "RE=2016.10;SZ=73.8x147.95x8.15;WT=155;DS=5.3;RS=720x1280;OI=1;OV=6.0;CP=2;RM=3072;",
        "toughpad fz-x1": "DS=5;RS=720x1280;SZ=86.4x165.1x30.5;WT=408;RE=2014.06;RM=2048;CP=138;OI=1;OV=4.2.2;",
        "fz-x1": "->toughpad fz-x1",
        "viera (2019)": "DS=42;RS=1920x1080;RE=2019;",
        "p554g": "->p55 novo 4g",
        "p55 novo": "->p55 novo 4g"
    },
    "oneplus": {
        "1": "->one",
        "2": "RE=2015.07;SZ=74.9x151.8x9.9;WT=175;DS=5.5;RS=1080x1920;OI=1;OV=5.1;CP=96;RM=3072;",
        "3": "RE=2016.07;SZ=74.7x152.7x7.4;WT=158;DS=5.5;RS=1080x1920;OI=1;OV=6.0.1;CP=173;RM=6144;",
        "5": "RE=2017.06;SZ=74.1x154.2x7.3;WT=153;DS=5.5;RS=1080x1920;OI=1;OV=7.1.1;CP=25;RM=6144;",
        "7": "RE=2019.05;SZ=74.8x157.7x8.2;WT=182;DS=6.41;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=6144;",
        "8": "RE=2020.04;SZ=72.9x160.2x8;WT=180;DS=6.55;RS=1080x2400;OI=1;OV=10;CP=207;RM=8192;",
        "one a2005": "->2",
        "one a2003": "->2",
        "one a2001": "->2",
        "a3000": "->3",
        "a3003": "->3",
        "oneplus3": "->3",
        "a5000": "->5",
        "gm1903": "->7",
        "gm1900": "->7",
        "gm1901": "->7",
        "gm1905": "->7",
        "in2013": "->8",
        "in2017": "->8",
        "in2010": "->8",
        "in2011": "->8",
        "in2015": "->8",
        "3t": "RE=2016.10;SZ=74.7x152.7x7.4;WT=158;DS=5.5;RS=1080x1920;OI=1;OV=6.0.1;CP=173;RM=6144;",
        "a3010": "->3t",
        "5t": "RE=2017.11;SZ=75x156.1x7.3;WT=162;DS=6.01;RS=1080x2160;OI=1;OV=7.1.1;CP=25;RM=6144;",
        "a5010": "->5t",
        "6t": "RE=2018.10;SZ=74.8x157.5x8.2;WT=185;DS=6.41;RS=1080x2340;OI=1;OV=9.0;CP=198;RM=6144;",
        "a6013": "->6t",
        "a6010": "->6t",
        "7 pro": "RE=2019.05;SZ=75.9x162.6x8.8;WT=206;DS=6.67;RS=1440x3120;OI=1;OV=9.0;CP=234;RM=6144;",
        "gm1910": "->7 pro",
        "gm1913": "->7 pro",
        "gm1915": "->7 pro",
        "gm1917": "->7 pro",
        "gm1911": "->7 pro",
        "7t": "RE=2019.09;SZ=74.4x160.9x8.1;WT=190;DS=6.55;RS=1080x2400;OI=1;OV=10;CP=197;RM=8192;",
        "hd1901": "->7t",
        "hd1903": "->7t",
        "hd1900": "->7t",
        "7t pro": "RE=2019.10;SZ=75.9x162.6x8.8;WT=206;DS=6.67;RS=1440x3120;OI=1;OV=10;CP=197;RM=8192;",
        "hd1913": "->7t pro",
        "hd1910": "->7t pro",
        "hd1911": "->7t pro",
        "7t pro 5g": "RE=2019.05;SZ=75.9x162.6x8.8;WT=206;DS=6.67;RS=1440x3120;OI=1;OV=9.0;CP=234;RM=6144;",
        "gm1920": "->7t pro 5g",
        "hd1925": "->7t pro 5g",
        "8 pro": "RE=2020.04;SZ=74.4x165.3x8.5;WT=199;DS=6.78;RS=1440x3168;OI=1;OV=10;CP=207;RM=8192;",
        "in2020": "->8 pro",
        "in2023": "->8 pro",
        "in2021": "->8 pro",
        "in2025": "->8 pro",
        "8t": "RE=2020.10;SZ=74.1x160.7x8.4;WT=188;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=207;RM=8192;",
        "kb2000": "->8t",
        "kb2001": "->8t",
        "kb2003": "->8t",
        "nord 5g": "RE=2020.07;SZ=73.3x158.3x8.2;WT=184;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=242;RM=6144;",
        "ac2003": "->nord 5g",
        "ac2001": "->nord 5g",
        "one": "RE=2014.04;SZ=75.9x152.9x8.9;WT=162;DS=5.5;RS=1080x1920;OI=1;OV=4.4.2;CP=243;RM=3072;",
        "a0001": "->one",
        "x": "RE=2015.10;SZ=69x140x6.9;WT=138;DS=5.0;RS=1080x1920;OI=1;OV=5.1.1;CP=243;RM=3072;",
        "one e1003": "->x",
        "one e1001": "->x",
        "one e1005": "->x",
        "clover": "DS=6.52;RS=720x1560;SM=2;OI=1;OV=10;CP=244;RM=4096;",
        "be2012": "->clover",
        "du oneplus3": "->3",
        "next-os oneplus3": "->3",
        "hd1917": "->7t pro",
        "kb2005": "->8t",
        "gm1925": "->7t pro 5g",
        "hd1907": "->7t",
        "hd1905": "->7t"
    },
    "utok": {
        "450d": "DS=4.5;RS=480x854;SZ=66.8x132x9.5;WT=140;RM=512;OI=1;OV=4.2.2;CP=24;"
    },
    "google": {
        "nexus 5": "RE=2013.10;SZ=69.2x137.9x8.6;WT=130;DS=4.95;RS=1080x1920;OI=1;OV=4.4;CP=94;RM=2048;",
        "nexus 5x": "RE=2015.09;SZ=72.6x147x7.9;WT=136;DS=5.2;RS=1080x1920;OI=1;OV=6.0;CP=157;RM=2048;",
        "nexus 7": "RE=2012.06;SZ=198.5x120x10.5;WT=340;DS=7.0;RS=1280x800;OI=1;OV=4.1.2;CP=137;RM=1024;",
        "nexus 7 2013": "->nexus 7",
        "phone/nexus 5": "->nexus 5",
        "aosp on hammerhead": "->nexus 5",
        "ainovo flame (nexus 7)": "->nexus 7"
    },
    "imo mobile": {
        "q3 plus": "DS=5;RS=480x960;SZ=65.8x141x9.1;WT=132;OI=1;OV=8.1;RM=1024;CP=83;RE=2018.09;",
        "s2": "DS=5;RS=720x1280;WT=171;SZ=72x142x8.2;OI=1;OV=8.1;RE=2018.09;RM=1024;CP=9;",
        "tab y5": "DS=7;RS=800x480;RSZ=197x124x11.5;WT=352;RE=2013;SM=1;CP=246;RM=512;OI=1;OV=4.0.4;",
        "tab z6": "DS=7;RS=800x480;SZ=200x118x13.5;WT=390;RE=2012.09;SM=1;CP=245;RM=512;OI=1;OV=4.0.3;",
        "tab z7": "DS=7;RS=1024x600;SZ=198x124x11;WT=399;RE=2012.10;OI=1;OV=4.0.3;CP=180;RM=512;",
        "imo q3 plus": "->q3 plus",
        "imo s2": "->s2",
        "imo y5": "->tab y5",
        "imo z6": "->tab z6",
        "imo z7": "->tab z7"
    },
    "motorola": {
        "v360": "RE=2005.01;SZ=47x90x24;WT=104;DS=1.9;RS=176x220;",
        "mb886": "RE=2012.07;SZ=69.9x133.5x8.4;WT=140;DS=4.5;RS=720x1280;OI=1;OV=4.0.4;CP=14;RM=1024;",
        "moto g7": "RE=2019.02;SZ=75.3x157x8;WT=172;DS=6.2;RS=1080x2270;OI=1;OV=9.0;CP=64;RM=4096;",
        "moto g(7)": "->moto g7",
        "moto g6 play": "RE=2018.04;SZ=72.2x154.4x9;WT=175;DS=5.7;RS=720x1440;OI=1;OV=8.0;CP=43;RM=2048;",
        "moto g(6) play": "->moto g6 play",
        "moto g7 supra": "RE=2018.02;DS=6.2;SZ=76x159x9.3;WT=198;RS=720x1520;OI=1;OV=9.0;CP=64;RM=3072;",
        "moto g(7) supra": "->moto g7 supra",
        "moto g7 plus": "RE=2019.02;SZ=75.3x157x8.3;WT=176;DS=6.2;RS=1080x2270;OI=1;OV=9.0;CP=205;RM=4096;",
        "xt1965-6": "->moto g7 plus",
        "moto e5 play": "RE=2018.04;SZ=74x151x9;WT=150;DS=5.2;RS=720x1280;OI=1;OV=8.0;CP=281;RM=2048;",
        "razr 5g": "RE=2020.09;SZ=72.6x169.2x7.9;WT=192;DS=6.2;RS=876x2142;OI=1;OV=10;CP=242;RM=8192;",
        "razr": "RE=2019.11;SZ=72x172x6.9;WT=205;DS=6.2;RS=876x2142;OI=1;OV=9.0;CP=62;RM=6144;",
        "one macro": "RE=2019.10;SZ=75.4x157.6x9;WT=186;DS=6.2;RS=720x1520;OI=1;OV=9.0;CP=114;RM=4096;",
        "moto c plus": "RE=2017.05;SZ=72.3x144x10;WT=162;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=9;RM=1024;",
        "one 5g uw": "RE=2020.10;SZ=73.9x167.9x8.9;WT=209.8;DS=6.7;RS=1080x2520;OI=1;OV=10;CP=242;RM=4096;",
        "moto z4": "RE=2019.05;SZ=75x158x7.4;WT=165;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=258;RM=4096;",
        "moto e6": "RE=2019.07;SZ=72.3x149.7x8.6;WT=159;DS=5.5;RS=720x1440;OI=1;OV=9.0;CP=282;RM=2048;",
        "moto g power": "RE=2020.02;SZ=75.8x159.9x9.6;WT=199;DS=6.4;RS=1080x2300;OI=1;OV=10;CP=283;RM=4096;",
        "moto g power (xt2041dl)": "->moto g power",
        "moto e5 go": "RE=2017.07;SZ=71.2x147.88x9.19;WT=145;DS=5.3;RS=480x960;OI=1;OV=8.0;CP=20;RM=1024;",
        "moto g8 power lite": "RE=2020.04;SZ=75.8x164.9x9.2;WT=200;DS=6.5;RS=720x1600;OI=1;OV=9.0;CP=38;RM=4096;",
        "moto g(8) power lite": "->moto g8 power lite",
        "moto e7 plus": "RE=2020.09;SZ=75.7x165.2x9.2;WT=200;DS=6.5;RS=720x1600;OI=1;OV=10;CP=244;RM=4096;",
        "moto e(7) plus": "->moto e7 plus",
        "moto e7": "RE=2020.09;SZ=75.7x164.9x8.9;WT=180;DS=6.5;RS=720x1600;OI=1;OV=10;CP=284;RM=2048;",
        "moto e(7)": "->moto e7",
        "moto g9 power": "RE=2020.09;SZ=76.8x172.1x9.7;WT=221;DS=6.8;RS=720x1640;OI=1;OV=10;CP=285;RM=4096;",
        "moto g(9) power": "->moto g9 power",
        "moto c": "RE=2017.05;SZ=73.6x145.5x9;WT=154;DS=5.0;RS=480x854;OI=1;OV=7.0;CP=86;RM=1024;",
        "a953": "RE=2010.09;SZ=60.5x116.3x13.7;WT=169;DS=3.7;RS=480x854;OI=1;OV=2.2;CP=29;RM=512;",
        "motoa953": "->a953",
        "admiral": "RE=2011.09;SZ=62x119x12.2;WT=134;DS=3.1;RS=480x640;OI=1;OV=2.3.4;CP=286;RM=512;",
        "xt603": "->admiral",
        "atrix": "RE=2012.05;SZ=60.5x119.8x9.9;WT=129.7;DS=4.0;RS=480x854;OI=1;OV=2.3.7;CP=31;RM=512;",
        "xt682": "->atrix",
        "atrix tv": "->atrix",
        "xt687": "->atrix tv",
        "moto g": "RE=2014.09;SZ=70.7x141.5x11;WT=149;DS=5.0;RS=720x1280;OI=1;OV=4.4.4;CP=78;RM=1024;",
        "xt1028": "->moto g",
        "xt1032": "->moto g",
        "xt1033": "->moto g",
        "xt1031": "->moto g",
        "xt1034": "->moto g",
        "xt1068": "->moto g",
        "xt1069": "->moto g",
        "moto g3": "RE=2015.05;SZ=72.4x142.1x11.6;WT=155;DS=5.0;RS=720x1280;OI=1;OV=5.1.1;CP=17;RM=1024;",
        "motog3": "->moto g3",
        "moto g4": "RE=2016.05;SZ=76.6x153x9.8;WT=155;DS=5.5;RS=1080x1920;OI=1;OV=6.0.1;CP=65;RM=2048;",
        "moto g (4)": "->moto g4",
        "moto razr 40 ultra": "RE=2023.06;SZ=74x170.8x7;WT=184.5;DS=6.9;RS=1080x2640;OI=1;OV=13;CP=373;RM=8192;TT=975461;TG=3645;",
        "xt2321-2": "->moto razr 40 ultra",
        "xt2321-3": "->moto razr 40 ultra",
        "motog3-te": "->moto g3",
        "moto g(7) plus": "->moto g7 plus",
        "xt1039": "->moto g",
        "xt2071-4": "->razr 5g",
        "lineage osprey": "->moto g",
        "xt1750": "->moto c",
        "xt1725": "->moto c plus",
        "xt1723": "->moto c plus",
        "xt1721": "->moto c plus",
        "xt1754": "->moto c",
        "xt1756": "->moto c",
        "k": "->moto razr 40 ultra",
        "xt2081-1": "->moto e7 plus",
        "xt2055-2": "->moto g8 power lite"
    },
    "nuvo": {
        "nd40": "RE=2014.12;RS=480x800;WT=130;SZ=63x128x9.6;DS=4;SM=2;OI=1;OV=4.4;",
        "blue nd40": "->nd40",
        "nd45": "RE=2015.05;WT=135;SZ=68x135x9.2;RS=480x854;DS=4.5;SM=2;OI=1;OV=4.4;",
        "green nd 45": "->nd45",
        "ns35": "RE=2015.05;WT=120;SZ=61.5x114.5x10.6;RS=320x480;DS=3.5;SM=2;OI=1;OV=4.4;"
    },
    "newland": {
        "nft10 pilot pro": "DS=5.03;DP=320;RS=720x1440;RM=3884;GP=25;OI=1;OV=11;",
        "nls-nft10": ">-nft10 pilot pro"
    },
    "estar": {
        "mid1020l": "DS=9.43;DP=240;RS=1200x1920;RM=3997;GP=25;OI=1;OV=10;",
        "digni smart": "DS=3.33;DP=120;RS=240x320;RM=951;GP=76;OI=1;OV=8.1;",
        "digni-smart": ">-digni smart"
    },
    "biorugged": {
        "biowolf 8-f30": "DS=4.72;DP=320;RS=800x1280;RM=1951;GP=4;OI=1;OV=9;",
        "biowolf8f30": ">-biowolf 8-f30"
    },
    "sansui": {
        "sansui_nova": "DS=4.47;DP=240;RS=480x960;RM=1004;OI=1;OV=8.1;"
    },
    "miray": {
        "midm f10": "DS=9.43;DP=240;RS=1200x1920;RM=2041;GP=76;OI=1;OV=8.1;"
    },
    "byju\\\\'s": {
        "lrns10gil0": "DS=9.43;DP=160;RS=1280x800;RM=3962;OI=1;OV=10;",
        "k": "->lrns10gil0"
    },
    "kapsys": {
        "smartvision3": "DS=4.44;DP=260;RS=640x960;RM=3979;OI=1;OV=11;"
    },
    "samsung": {
        "galaxy s8": "RE=2017.03;SZ=68.1x148.9x8;WT=155;DS=5.8;RS=1440x2960;OI=1;OV=7;CP=271;RM=4096;TT=199022;TG=6656;",
        "sm-g950w": "->galaxy s8",
        "sm-g950n": "->galaxy s8",
        "sm-g950": "->galaxy s8",
        "scv36": "->galaxy s8",
        "sm-g9508": "->galaxy s8",
        "sm-g9500": "->galaxy s8",
        "sm-g950u": "->galaxy s8",
        "sc-02j": "->galaxy s8",
        "sm-g950f": "->galaxy s8",
        "sm-g950u1": "->galaxy s8",
        "galaxy a15 5g": "RE=2023.12;SZ=76.8x160.1x8.4;WT=200;DS=6.5;RS=1080x2340;OI=1;OV=14;CP=380;RM=4096;TT=306274;TG=1747;",
        "sm-a156b": "->galaxy a15 5g",
        "sm-a156m": "->galaxy a15 5g",
        "sm-a156u1": "->galaxy a15 5g",
        "sm-a156e": "->galaxy a15 5g",
        "sm-s156v": "->galaxy a15 5g",
        "sm-a156w": "->galaxy a15 5g",
        "galaxy z flip 5": "RE=2023.07;SZ=71.9x165.1x6.9;WT=187;DS=6.7;RS=1080x2640;OI=1;OV=13;CP=377;RM=8192;TT=1200783;TG=5478;",
        "sm-f731n": "->galaxy z flip 5",
        "sm-f731u1": "->galaxy z flip 5",
        "sm-f731w": "->galaxy z flip 5",
        "sm-f7310": "->galaxy z flip 5",
        "sm-f731b": "->galaxy z flip 5",
        "galaxy z flip 3": "RE=2021.08;SZ=72.2x166x6.9;WT=183;DS=6.7;RS=1080x2640;OI=1;OV=11;CP=305;RM=8192;TT=596866;TG=3441;",
        "sm-f711w": "->galaxy z flip 3",
        "sm-f711b": "->galaxy z flip 3",
        "scg12": "->galaxy z flip 3",
        "sc-54b": "->galaxy z flip 3",
        "sm-f711u": "->galaxy z flip 3",
        "sm-f711u1": "->galaxy z flip 3",
        "sm-f711n": "->galaxy z flip 3",
        "sm-f7110": "->galaxy z flip 3",
        "galaxy z fold 3 5g": "RE=2021.08;SZ=128.1x158.2x6.4;WT=271;DS=7.6;RS=1768x2208;OI=1;OV=11;CP=305;RM=12288;TT=635918;TG=12719;",
        "sm-f926n": "->galaxy z fold 3 5g",
        "sm-f926w": "->galaxy z fold 3 5g",
        "sm-f926u1": "->galaxy z fold 3 5g",
        "sm-f926b": "->galaxy z fold 3 5g",
        "sc-55b": "->galaxy z fold 3 5g",
        "scg11": "->galaxy z fold 3 5g",
        "sm-f9260": "->galaxy z fold 3 5g",
        "sm-f926u": "->galaxy z fold 3 5g",
        "galaxy a56 5g": "RE=2025.03;SZ=77.5x162.2x7.4;WT=198;DS=6.7;RS=1080x2340;OI=1;OV=15;CP=379;RM=6144;TT=908689;TG=3899;",
        "sm-a566e": "->galaxy a56 5g",
        "sm-a566b": "->galaxy a56 5g",
        "sm-a566v": "->galaxy a56 5g",
        "galaxy camera": "RE=2012.08;SZ=70.8x128.7x19.1;WT=300;DS=4.8;RS=720x1280;OI=1;OV=4.1;CP=233;RM=1024;",
        "ek-gc100": "->galaxy camera",
        "galaxy camera 2": "DS=4.8;RS=720x1280;SZ=71.2x132.5x19.3;WT=283;RE=2014;OI=1;OV=4.3;RM=2048;CP=233;",
        "ek-gc200": "->galaxy camera 2",
        "galaxy camera wifi only": "DS=4.8;RS=720x1280;WT=300;SZ=70.8x128.7x19.1;RM=1024;OI=1;OV=4.1;SM=0;",
        "ek-gc110": "->galaxy camera wifi only",
        "galaxy nx": "RS=720x1280;DS=4.8;CP=233;OI=1;OV=4.1;SZ=101.46x136.5x56;RE=2013;",
        "ek-gn120": "->galaxy nx",
        "e2152": "DS=2.0;RS=128x160;SZ=45.7x111.6x13.5;WT=80.0;RE=;RM=;CP=;OS=;",
        "gt-s3850": "RE=2011.05;SZ=60.6x109.9x11.7;WT=102;DS=3.2;RS=240x320;",
        "gt-i9500.": "->galaxy s4",
        "sch-i959": "->galaxy s4",
        "sc-04e": "->galaxy s4",
        "gt-i9500": "->galaxy s4",
        "sgh-m919n": "->galaxy s4",
        "sch-i545": "->galaxy s4",
        "sm-s975l": "->galaxy s4",
        "sch-r970c": "->galaxy s4",
        "sgh-m919": "->galaxy s4",
        "gt-i9502": "->galaxy s4",
        "galaxy s4": "RE=2013.05;SZ=69.8x136.6x7.9;WT=130;DS=5.0;RS=1080x1920;OI=1;OV=4.2.2;CP=138;RM=2048;",
        "galaxy s5": "RE=2014.02;SZ=72.5x142x8.1;WT=145;DS=5.1;RS=1080x1920;OI=1;OV=4.4.2;CP=243;RM=2048;",
        "sm-g900w8": "->galaxy s5",
        "sm-g900f": "->galaxy s5",
        "sm-s902l": "->galaxy s5",
        "sm-g906l": "->galaxy s5",
        "sm-g906k": "->galaxy s5",
        "sm-s903vl": "->galaxy s5",
        "sm-g906s": "->galaxy s5",
        "scl23": "->galaxy s5",
        "sch-i500": "RE=2010.09;SZ=64.2x122.4x9.9;WT=116;DS=4;RS=480x800;SM=1;RM=512;CP=13;OI=1;OV=2.1;",
        "galaxy fold": "RE=2019.02;SZ=117.9x160.9x6.9;WT=263;DS=7.3;RS=1536x2152;OI=1;OV=9.0;CP=234;RM=12288;",
        "sm-f9000": "->galaxy fold",
        "sm-f900u": "->galaxy fold",
        "sm-f907b": "->galaxy fold",
        "sm-f907n": "->galaxy fold",
        "sm-f900f": "->galaxy fold",
        "sm-f900w": "->galaxy fold",
        "scv44": "->galaxy fold",
        "galaxy grand": "RE=2012.12;SZ=76.9x143.5x9.6;WT=162;DS=5.0;RS=480x800;OI=1;OV=4.1.2;CP=235;RM=1024;",
        "gt-i9080": "->galaxy grand",
        "gt-i9128i": "->galaxy grand",
        "galaxy grand 2": "RE=2013.09;SZ=75.3x146.8x8.9;WT=163;DS=5.25;RS=720x1280;OI=1;OV=4.3;CP=78;RM=1536;",
        "sm-g710": "->galaxy grand 2",
        "sm-g7105": "->galaxy grand 2",
        "sm-g7102": "->galaxy grand 2",
        "sm-g710l": "->galaxy grand 2",
        "sm-g7106": "->galaxy grand 2",
        "sm-g7108": "->galaxy grand 2",
        "sm-g7109": "->galaxy grand 2",
        "sm-g7102t": "->galaxy grand 2",
        "sm-g7105h": "->galaxy grand 2",
        "sm-g7105l": "->galaxy grand 2",
        "sm-g710k": "->galaxy grand 2",
        "sm-g710s": "->galaxy grand 2",
        "galaxy grand duos": "RE=2012.12;SZ=76.9x143.5x9.6;WT=162;DS=5.0;RS=480x800;OI=1;OV=4.1.2;CP=235;RM=1024;",
        "gt-i9082": "->galaxy grand duos",
        "gt-i9082l": "->galaxy grand duos",
        "galaxy grand neo": "RE=2014.01;SZ=77.1x143.7x9.6;WT=163;DS=5.01;RS=480x800;OI=1;OV=4.2;CP=236;RM=1024;",
        "gt-i9060": "->galaxy grand neo",
        "galaxy grand neo duos": "DS=5;RS=480x800;SZ=77.10x143.70x9.6;WT=166;CP=236;RM=1024;RE=2014.05;OI=1;OV=4.2;SM=2;",
        "gt-i9063t": "->galaxy grand neo duos",
        "galaxy gran neo duos tv": "->galaxy grand neo duos",
        "galaxy grand neo+": "DS=5;RS=480x800;SZ=77.10x143.7x9.6;WT=165;CP=236;RM=1024;OI=1;OV=4.2;RE=2014.05;SM=1;",
        "gt-i9168": "->galaxy grand neo+",
        "galaxy grand prime": "RE=2014.09;SZ=72.1x144.8x8.6;WT=156;DS=5.0;RS=540x960;OI=1;OV=4.4.4;CP=17;RM=1024;",
        "sm-g5308w": "->galaxy grand prime",
        "sm-g530bt": "->galaxy grand prime",
        "sm-g530m": "->galaxy grand prime",
        "sm-g530mu": "->galaxy grand prime",
        "sm-g5306w": "->galaxy grand prime",
        "sm-s920l": "->galaxy grand prime",
        "sm-g530h": "->galaxy grand prime",
        "sm-g530f": "->galaxy grand prime",
        "sm-g530az": "->galaxy grand prime",
        "sm-g530t": "->galaxy grand prime",
        "sm-g530w": "->galaxy grand prime",
        "sm-g530r7": "->galaxy grand prime",
        "sm-g5309w": "->galaxy grand prime",
        "sm-g530p": "->galaxy grand prime",
        "sm-g530a": "->galaxy grand prime",
        "sm-g530r4": "->galaxy grand prime",
        "sm-g531f": "->galaxy grand prime",
        "sm-g531h": "->galaxy grand prime",
        "galaxy tab a 7.0\" wifi": "RE=2016.05;SZ=186.9x108.8x8.7;WT=283;DS=7.0;RS=1280x800;OI=1;OV=5.1.1;CP=17;RM=1536;SM=0;",
        "sm-t280": "->galaxy tab a 7.0\" wifi",
        "galaxy tab a 10.1\" (2019)": "RE=2019.02;SZ=245.2x149.4x7.5;WT=469;DS=10.1;RS=1920x1200;OI=1;OV=9.0;CP=237;RM=2048;",
        "sm-t515": "->galaxy tab a 10.1\" (2019)",
        "galaxy a11": "RE=2020.05;SZ=76.3x161.4x8;WT=177;DS=6.4;RS=720x1560;OI=1;OV=10;CP=214;RM=2048;",
        "sm-a115m": "->galaxy a11",
        "sm-a115f": "->galaxy a11",
        "sm-a115a": "->galaxy a11",
        "sm-a115ap": "->galaxy a11",
        "sm-a115az": "->galaxy a11",
        "sm-a115u": "->galaxy a11",
        "sm-a115u1": "->galaxy a11",
        "sm-a115w": "->galaxy a11",
        "galaxy a12": "RE=2020.10;SZ=75.8x164x8.9;WT=205;DS=6.5;RS=720x1600;OI=1;OV=10;CP=38;RM=3072;",
        "sm-a125f": "->galaxy a12",
        "sm-a125m": "->galaxy a12",
        "sm-a127f": "->galaxy a12;OI=1;OV=11;CP=250;",
        "galaxy grand prime plus": "RE=2016.10;SZ=72.1x144.8x8.9;WT=160;DS=5.0;RS=540x960;OI=1;OV=6.0;CP=69;RM=1536;",
        "sm-g532f": "->galaxy grand prime plus",
        "galaxy grand prime ve duos": "RE=2014.09;SZ=72.1x144.8x8.6;WT=156;DS=5.0;RS=540x960;OI=1;OV=4.4.4;CP=238;RM=1024;SM=2;",
        "sm-g531y": "->galaxy grand prime ve duos",
        "sm-g531bt": "->galaxy grand prime ve duos",
        "sm-g531m": "->galaxy grand prime ve duos",
        "galaxy j2 prime": "RE=2016.10;SZ=72.1x144.8x8.9;WT=160;DS=5.0;RS=540x960;OI=1;OV=6.0;CP=69;RM=1536;",
        "sm-g532m": "->galaxy j2 prime",
        "sm-g532g": "->galaxy j2 prime",
        "galaxy mega 2": "RE=2014.09;SZ=84.9x163.6x8.6;WT=194;DS=6.0;RS=720x1280;OI=1;OV=4.4.3;CP=239;RM=1536;",
        "sm-g750f": "->galaxy mega 2",
        "sm-g750h": "->galaxy mega 2",
        "sm-g750a": "->galaxy mega 2",
        "sm-g7509": "->galaxy mega 2",
        "galaxy mega 5.8": "RE=2013.04;SZ=82.4x162.6x9;WT=182;DS=5.8;RS=540x960;CP=235;OI=1;OV=4.2.2;RM=1536;SM=2;",
        "gt-i9152": "->galaxy mega 5.8",
        "gt-i9158": "->galaxy mega 5.8",
        "galaxy mega 6.3": "RE=2013.04;SZ=88x167.6x8;WT=199;DS=6.3;RS=720x1280;OI=1;OV=4.2.2;CP=78;RM=1536;",
        "gt-i9205": "->galaxy mega 6.3",
        "gt-i9200": "->galaxy mega 6.3",
        "galaxy note": "RE=2011.09;SZ=83x146.9x9.7;WT=178;DS=5.3;RS=800x1280;OI=1;OV=2.3.5;CP=240;RM=1024;",
        "gt-n7000": "->galaxy note",
        "galaxy note 10": "RE=2019.08;SZ=71.8x151x7.9;WT=168;DS=6.3;RS=1080x2280;OI=1;OV=9.0;CP=67;RM=8192;",
        "sm-n970f": "->galaxy note 10",
        "sm-n970u": "->galaxy note 10",
        "sm-n970x": "->galaxy note 10",
        "sm-n9700": "->galaxy note 10",
        "sm-n970u1": "->galaxy note 10",
        "sm-n970w": "->galaxy note 10",
        "sm-n971n": "->galaxy note 10",
        "galaxy note 10 lite": "RE=2020.01;SZ=76.1x163.7x8.7;WT=199;DS=6.7;RS=1080x2400;OI=1;OV=10;CP=241;RM=6144;",
        "sm-n770x": "->galaxy note 10 lite",
        "sm-n770f": "->galaxy note 10 lite",
        "galaxy note 10+": "RE=2019.08;SZ=77.2x162.3x7.9;WT=196;DS=6.8;RS=1440x3040;OI=1;OV=9.0;CP=67;RM=12288;",
        "sm-n9750": "->galaxy note 10+",
        "sm-n975f": "->galaxy note 10+",
        "sm-n975u": "->galaxy note 10+",
        "sm-n975u1": "->galaxy note 10+",
        "sm-n975w": "->galaxy note 10+",
        "sm-n976v": "->galaxy note 10+",
        "sc-01m": "->galaxy note 10+",
        "sm-n975x": "->galaxy note 10+",
        "sm-n975xu": "->galaxy note 10+",
        "sm-n9760": "->galaxy note 10+",
        "sm-n976n": "->galaxy note 10+",
        "sm-n976u": "->galaxy note 10+",
        "sm-n976q": "->galaxy note 10+",
        "scv45": "->galaxy note 10+",
        "galaxy note 7": "RE=2016.08;SZ=73.9x153.5x7.9;WT=169;DS=5.7;RS=1440x2560;OI=1;OV=6.0.1;CP=270;RM=4096;",
        "sm-n930f": "->galaxy note 7",
        "sm-n930s": "->galaxy note 7",
        "sm-n930t": "->galaxy note 7",
        "sm-n9300": "->galaxy note 7",
        "sm-n930v": "->galaxy note 7",
        "sm-n930p": "->galaxy note 7",
        "scv34": "->galaxy note 7",
        "sm-n930x": "->galaxy note 7",
        "sm-n930k": "->galaxy note 7",
        "sm-n930a": "->galaxy note 7",
        "sm-n930l": "->galaxy note 7",
        "sm-n930u": "->galaxy note 7",
        "sm-n930r4": "->galaxy note 7",
        "sm-n930r6": "->galaxy note 7",
        "sm-n930r7": "->galaxy note 7",
        "sm-n930w8": "->galaxy note 7",
        "galaxy a10": "RE=2019.02;SZ=75.6x155.6x7.9;WT=168;DS=6.2;RS=720x1520;OI=1;OV=9.0;CP=248;RM=2048;",
        "sm-a105n": "->galaxy a10",
        "sm-a105f": "->galaxy a10",
        "sm-a105fn": "->galaxy a10",
        "galaxy a10e": "DS=5.8;RS=720x1560;SZ=69.6x147.3x8.4;WT=141;RE=2019.06;RM=2048;CP=248;OI=1;OV=10;",
        "sm-s102dl": "->galaxy a10e",
        "sm-a102n": "->galaxy a10e",
        "sm-a102u": "->galaxy a10e",
        "sm-a102w": "->galaxy a10e",
        "sm-a107m": "->galaxy a10s",
        "sm-a107f": "->galaxy a10s",
        "galaxy a10s": "RE=2019.08;SZ=75.8x156.9x7.8;WT=168;DS=6.2;RS=720x1520;OI=1;OV=9;CP=171;RM=2048;",
        "galaxy note 20 5g": "RE=2020.08;SZ=75.2x161.6x8.3;WT=192;DS=6.7;RS=1080x2400;OI=1;OV=10;CP=249;RM=8192;",
        "sm-n9810": "->galaxy note 20 5g",
        "sm-n981b": "->galaxy note 20 5g",
        "sm-n981n": "->galaxy note 20 5g",
        "sm-n981u1": "->galaxy note 20 5g",
        "sm-n981u": "->galaxy note 20 5g",
        "sm-n981w": "->galaxy note 20 5g",
        "galaxy a20": "RE=2019.05;SZ=74.7x158.4x7.8;WT=169;DS=6.4;RS=720x1560;OI=1;OV=9.0;CP=248;RM=3072;",
        "sc-02m": "->galaxy a20",
        "sm-a205u": "->galaxy a20",
        "scv46": "->galaxy a20",
        "sm-a205u1": "->galaxy a20",
        "sm-a205w": "->galaxy a20",
        "sm-a205yn": "->galaxy a20",
        "sm-a205s": "->galaxy a20",
        "scv46-u": "->galaxy a20",
        "scv46-j": "->galaxy a20",
        "galaxy a20e": "RE=2019.04;SZ=69.7x147.4x8.4;WT=141;DS=5.8;RS=720x1560;OI=1;OV=9.0;CP=248;RM=3072;",
        "sm-a202f": "->galaxy a20e",
        "galaxy a20s": "RE=2019.09;SZ=77.5x163.3x8;WT=183;DS=6.5;RS=720x1560;OI=1;OV=9.0;CP=214;RM=2048;",
        "sm-a2070": "->galaxy a20s",
        "sm-a207m": "->galaxy a20s",
        "sm-a207f": "->galaxy a20s",
        "galaxy a21": "RE=2020.04;SZ=76.7x167.8x8.1;WT=193;DS=6.5;RS=720x1600;OI=1;OV=10;CP=38;RM=3072;",
        "sm-a215u": "->galaxy a21",
        "sm-a215u1": "->galaxy a21",
        "sm-a215w": "->galaxy a21",
        "sm-a215dl": "->galaxy a21",
        "scv49": "->galaxy a21",
        "sc-42a": "->galaxy a21",
        "galaxy a21s": "RE=2020.05;SZ=75.3x163.7x8.9;WT=192;DS=6.5;RS=720x1600;OI=1;OV=10;CP=250;RM=2048;",
        "sm-a217f": "->galaxy a21s",
        "sm-a217n": "->galaxy a21s",
        "galaxy a3 (2015)": "RE=2014.10;SZ=65.5x130.1x6.9;WT=110.3;DS=4.5;RS=540x960;OI=1;OV=4.4.4;CP=17;RM=1024;",
        "sm-a3009": "->galaxy a3 (2015)",
        "sm-a300yz": "->galaxy a3 (2015)",
        "sm-a3000": "->galaxy a3 (2015)",
        "sm-a300xu": "->galaxy a3 (2015)",
        "sm-a300h": "->galaxy a3 (2015)",
        "sm-a300y": "->galaxy a3 (2015)",
        "sm-a300xz": "->galaxy a3 (2015)",
        "sm-a300x": "->galaxy a3 (2015)",
        "galaxy a3 (2016)": "RE=2015.12;SZ=65.2x134.5x7.3;WT=132;DS=4.7;RS=720x1280;OI=1;OV=5.1.1;CP=251;RM=1536;",
        "sm-a310x": "->galaxy a3 (2016)",
        "sm-a310m": "->galaxy a3 (2016)",
        "sm-a310f": "->galaxy a3 (2016)",
        "sm-a310n0": "->galaxy a3 (2016)",
        "sm-a310y": "->galaxy a3 (2016)",
        "galaxy a3 (2017)": "RE=2017.01;SZ=66.2x135.4x7.9;WT=138;DS=4.7;RS=720x1280;OI=1;OV=6.0.1;CP=252;RM=2048;",
        "sm-a320y": "->galaxy a3 (2017)",
        "sm-a320x": "->galaxy a3 (2017)",
        "sm-a320fl": "->galaxy a3 (2017)",
        "galaxy a30": "RE=2019.02;SZ=74.7x158.5x7.7;WT=165;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=237;RM=3072;",
        "scv43": "->galaxy a30",
        "sm-a305n": "->galaxy a30",
        "scv43-j": "->galaxy a30",
        "scv43-u": "->galaxy a30",
        "galaxy a30s": "RE=2019.08;SZ=74.7x158.5x7.8;WT=169;DS=6.4;RS=720x1560;OI=1;OV=9.0;CP=237;RM=3072;",
        "sm-a307g": "->galaxy a30s",
        "galaxy a31": "RE=2020.05;SZ=73.1x159.3x8.6;WT=185;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=253;RM=4096;",
        "sm-a315g": "->galaxy a31",
        "sm-a315f": "->galaxy a31",
        "sm-a315n": "->galaxy a31",
        "galaxy a40": "RE=2019.05;SZ=69.2x144.4x7.9;WT=140;DS=5.9;RS=1080x2340;OI=1;OV=9.0;CP=237;RM=4096;",
        "sm-a405fm": "->galaxy a40",
        "sm-a405s": "->galaxy a40",
        "galaxy a40s": "RE=2019.04;SZ=75.1x159.1x8.5;WT=174;DS=6.4;RS=720x1560;OI=1;OV=9.0;CP=237;RM=4096;",
        "sm-a3051": "->galaxy a40s",
        "sm-a3050": "->galaxy a40s",
        "sm-a3058": "->galaxy a40s",
        "galaxy a41": "RE=2020.05;SZ=69.8x149.9x7.9;WT=152;DS=6.1;RS=1080x2400;OI=1;OV=10;CP=253;RM=4096;",
        "sm-a415f": "->galaxy a41",
        "sc-41a": "->galaxy a41",
        "scv48": "->galaxy a41",
        "galaxy a5": "RE=2014.10;SZ=69.7x139.3x6.7;WT=123;DS=5.0;RS=720x1280;OI=1;OV=4.4.4;CP=17;RM=2048;",
        "sm-a500y": "->galaxy a5",
        "sm-a500l": "->galaxy a5",
        "sm-a5009": "->galaxy a5",
        "sm-a500": "->galaxy a5",
        "sm-a500w": "->galaxy a5",
        "sm-a500s": "->galaxy a5",
        "sm-a500yz": "->galaxy a5",
        "galaxy a5 (2016)": "RE=2015.12;SZ=71x144.8x7.3;WT=155;DS=5.2;RS=1080x1920;OI=1;OV=5.1.1;CP=254;RM=2048;",
        "sm-a510m": "->galaxy a5 (2016)",
        "sm-a5100": "->galaxy a5 (2016)",
        "sm-a510x": "->galaxy a5 (2016)",
        "sm-a510s": "->galaxy a5 (2016)",
        "sm-a510y": "->galaxy a5 (2016)",
        "sm-a510l": "->galaxy a5 (2016)",
        "sm-a510k": "->galaxy a5 (2016)",
        "sm-a5108": "->galaxy a5 (2016)",
        "galaxy a5 (2017)": "RE=2017.01;SZ=71.4x146.1x7.9;WT=157;DS=5.2;RS=1080x1920;OI=1;OV=6.0.1;CP=255;RM=3072;",
        "sm-a520x": "->galaxy a5 (2017)",
        "sm-a520k": "->galaxy a5 (2017)",
        "sm-a520l": "->galaxy a5 (2017)",
        "sm-a520f": "->galaxy a5 (2017)",
        "sm-a520s": "->galaxy a5 (2017)",
        "sm-a520w": "->galaxy a5 (2017)",
        "galaxy a5 duos": "RE=2014.10;SZ=69.7x139.3x6.7;WT=123;DS=5.0;RS=720x1280;OI=1;OV=4.4.4;CP=17;RM=2048;SM=2;",
        "sm-a500k": "->galaxy a5 duos",
        "sm-a500g": "->galaxy a5 duos",
        "galaxy a50": "RE=2019.02;SZ=74.7x158.5x7.7;WT=166;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=256;RM=4096;",
        "sm-505fn": "->galaxy a50",
        "sm-a505u": "->galaxy a50",
        "sm-a505x": "->galaxy a50",
        "sm-a505n": "->galaxy a50",
        "sm-a505u1": "->galaxy a50",
        "sm-a505w": "->galaxy a50",
        "sm-a505yn": "->galaxy a50",
        "sm-s506dl": "->galaxy a50",
        "galaxy a50s": "RE=2019.08;SZ=74.5x158.5x7.7;WT=169;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=257;RM=4096;",
        "sm-a5070": "->galaxy a50s",
        "sm-a507fn": "->galaxy a50s",
        "galaxy a51": "RE=2019.12;SZ=73.6x158.5x7.9;WT=172;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=257;RM=4096;",
        "sm-a515f": "->galaxy a51",
        "sm-a515w": "->galaxy a51",
        "sm-s515dl": "->galaxy a51",
        "sm-a515u": "->galaxy a51",
        "galaxy a51 5g": "RE=2020.08;SZ=73.4x158.8x8.6;WT=188.8;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=242;RM=6144;",
        "scg07": "->galaxy a51 5g",
        "sm-a5160": "->galaxy a51 5g",
        "sm-a516b": "->galaxy a51 5g",
        "sm-a516n": "->galaxy a51 5g",
        "sm-a516u": "->galaxy a51 5g",
        "sm-a516u1": "->galaxy a51 5g",
        "sm-a516v": "->galaxy a51 5g",
        "sc-54a": "->galaxy a51 5g",
        "galaxy a6": "RE=2018.05;SZ=70.8x149.9x7.7;WT=162;DS=5.6;RS=720x1480;OI=1;OV=8.0;CP=252;RM=3072;",
        "sm-a600p": "->galaxy a6",
        "sm-a600a": "->galaxy a6",
        "sm-a600n": "->galaxy a6",
        "sm-a600t": "->galaxy a6",
        "sm-a600fn": "->galaxy a6",
        "sm-a600g": "->galaxy a6",
        "sm-a600t1": "->galaxy a6",
        "sm-a600x": "->galaxy a6",
        "sm-a600az": "->galaxy a6",
        "sm-a600gn": "->galaxy a6",
        "sm-a600f": "->galaxy a6",
        "sm-a600u": "->galaxy a6",
        "galaxy a6+": "RE=2018.05;SZ=75.7x160.2x7.9;WT=186;DS=6.0;RS=1080x2220;OI=1;OV=8.0;CP=214;RM=3072;",
        "sm-a605gn": "->galaxy a6+",
        "sm-a605x": "->galaxy a6+",
        "sm-a6050": "->galaxy a6+",
        "sm-a6058": "->galaxy a6+",
        "sm-a605g": "->galaxy a6+",
        "sm-a605f": "->galaxy a6+",
        "sm-a605fn": "->galaxy a6+",
        "galaxy a60": "RE=2019.04;SZ=73.9x155.3x7.9;WT=168;DS=6.3;RS=1080x2340;OI=1;OV=9.0;CP=258;RM=6144;",
        "sm-a6060": "->galaxy a60",
        "sm-a606y": "->galaxy a60",
        "galaxy a6s (2018)": "RE=2018.10;SZ=76.5x156.3x8.4;WT=183;DS=6.0;RS=1080x2160;OI=1;OV=8.0;CP=61;RM=6144;",
        "sm-g6200": "->galaxy a6s (2018)",
        "galaxy a7": "RE=2015.01;SZ=76.2x151x6.3;WT=141;DS=5.5;RS=1080x1920;OI=1;OV=4.4.4;CP=22;RM=2048;",
        "sm-a7009": "->galaxy a7",
        "sm-a700yd": "->galaxy a7",
        "sm-a700x": "->galaxy a7",
        "sm-a7000": "->galaxy a7",
        "sm-a700h": "->galaxy a7",
        "galaxy a7 (2016)": "RE=2015.12;SZ=74.1x151.5x7.3;WT=172;DS=5.5;RS=1080x1920;OI=1;OV=5.1.1;CP=254;RM=3072;",
        "sm-a7108": "->galaxy a7 (2016)",
        "sm-a710x": "->galaxy a7 (2016)",
        "sm-a710l": "->galaxy a7 (2016)",
        "sm-a710f": "->galaxy a7 (2016)",
        "sm-a710s": "->galaxy a7 (2016)",
        "sm-a710k": "->galaxy a7 (2016)",
        "galaxy a7 (2017)": "RE=2017.01;SZ=77.6x156.8x7.9;WT=186;DS=5.7;RS=1080x1920;OI=1;OV=6.0.1;CP=255;RM=3072;",
        "sm-a720x": "->galaxy a7 (2017)",
        "sm-a720f": "->galaxy a7 (2017)",
        "sm-a720s": "->galaxy a7 (2017)",
        "galaxy a7 (2018)": "RE=2018.09;SZ=76.8x159.8x7.5;WT=168;DS=6.0;RS=1080x2220;OI=1;OV=8.0;CP=259;RM=4096;",
        "sm-a750g": "->galaxy a7 (2018)",
        "sm-a750x": "->galaxy a7 (2018)",
        "sm-a750gn": "->galaxy a7 (2018)",
        "sm-a750f": "->galaxy a7 (2018)",
        "sm-a750n": "->galaxy a7 (2018)",
        "sm-a750c": "->galaxy a7 (2018)",
        "galaxy a70": "RE=2019.05;SZ=76.7x164.3x7.9;WT=183;DS=6.7;RS=1080x2400;OI=1;OV=9.0;CP=258;RM=6144;",
        "sm-a705fn": "->galaxy a70",
        "sm-a705x": "->galaxy a70",
        "sm-a705f": "->galaxy a70",
        "sm-a705mn": "->galaxy a70",
        "galaxy a70s": "RE=2019.09;SZ=76.7x164.3x7.9;WT=187;DS=6.7;RS=1080x2400;OI=1;OV=9.0;CP=258;RM=6144;",
        "sm-a7070": "->galaxy a70s",
        "sm-a707f": "->galaxy a70s",
        "galaxy a71": "RE=2019.12;SZ=76x163.6x7.7;WT=179;DS=6.7;RS=1080x2400;OI=1;OV=10;CP=261;RM=6144;",
        "sm-a715w": "->galaxy a71",
        "sm-a71": "->galaxy a71",
        "galaxy a71 5g": "RE=2020.04;SZ=75.5x162.5x8.1;WT=185;DS=6.7;RS=1080x2400;OI=1;OV=10;CP=262;RM=6144;",
        "sm-a716u": "->galaxy a71 5g",
        "sm-a7160": "->galaxy a71 5g",
        "sm-a716b": "->galaxy a71 5g",
        "sm-a716u1": "->galaxy a71 5g",
        "sm-a716v": "->galaxy a71 5g",
        "galaxy a8": "RE=2015.08;SZ=76.8x158x5.9;WT=151;DS=5.7;RS=1080x1920;OI=1;OV=5.1;CP=22;RM=2048;",
        "sm-a800i": "->galaxy a8",
        "sm-a8000": "->galaxy a8",
        "sm-a800s": "->galaxy a8",
        "sm-a800f": "->galaxy a8",
        "sm-a800x": "->galaxy a8",
        "scv32": "->galaxy a8",
        "sm-a530f": "->galaxy a8",
        "galaxy a8 (2016)": "RE=2016.09;SZ=76.8x156.6x7.2;WT=182;DS=5.7;RS=1080x1920;OI=1;OV=6.0.1;CP=264;RM=3072;",
        "sm-a810f": "->galaxy a8 (2016)",
        "sm-a810s": "->galaxy a8 (2016)",
        "sm-a810yz": "->galaxy a8 (2016)",
        "galaxy a8 (2018)": "RE=2017.12;SZ=70.6x149.2x8.4;WT=172;DS=5.6;RS=1080x2220;OI=1;OV=7.1.1;CP=259;RM=4096;",
        "sm-a530x": "->galaxy a8 (2018)",
        "sm-a530w": "->galaxy a8 (2018)",
        "sm-a530n": "->galaxy a8 (2018)",
        "sm-a530m": "->galaxy a8 (2018)",
        "galaxy a8 star": "RE=2018.06;SZ=77x162.4x7.6;WT=191;DS=6.3;RS=1080x2220;OI=1;OV=8.0;CP=61;RM=4096;",
        "sm-g885f": "->galaxy a8 star",
        "sm-g885y": "->galaxy a8 star",
        "sm-g885s": "->galaxy a8 star",
        "galaxy a8+ (2018)": "RE=2017.12;SZ=75.7x159.9x8.3;WT=191;DS=6.0;RS=1080x2220;OI=1;OV=7.1.1;CP=259;RM=4096;",
        "sm-a730f": "->galaxy a8+ (2018)",
        "sm-a730x": "->galaxy a8+ (2018)",
        "galaxy a80": "RE=2019.04;SZ=76.5x165.2x9.3;WT=220;DS=6.7;RS=1080x2400;OI=1;OV=9.0;CP=261;RM=8192;",
        "sm-a8050": "->galaxy a80",
        "sm-a805n": "->galaxy a80",
        "sm-a805x": "->galaxy a80",
        "sm-a805f": "->galaxy a80",
        "galaxy a8s": "RE=2018.12;SZ=74.9x158.4x7.4;WT=173;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=62;RM=6144;",
        "sm-g8870": "->galaxy a8s",
        "sm-g887f": "->galaxy a8s",
        "sm-a8s": "->galaxy a8s",
        "galaxy a9": "RE=2015.12;SZ=80.9x161.7x7.4;WT=200;DS=6.0;RS=1080x1920;OI=1;OV=5.1.1;CP=115;RM=3072;",
        "sm-a9000": "->galaxy a9",
        "sm-a900f": "->galaxy a9",
        "galaxy a9 (2018)": "RE=2018.10;SZ=77x162.5x7.8;WT=183;DS=6.3;RS=1080x2220;OI=1;OV=8.0;CP=61;RM=6144;",
        "sm-a920x": "->galaxy a9 (2018)",
        "sm-a920f": "->galaxy a9 (2018)",
        "sm-a9200": "->galaxy a9 (2018)",
        "sm-a920n": "->galaxy a9 (2018)",
        "galaxy a9 pro": "RE=2016.05;SZ=80.9x161.7x7.9;WT=210;DS=6.0;RS=1080x1920;OI=1;OV=6.0.1;CP=115;RM=4096;",
        "sm-a9100": "->galaxy a9 pro",
        "sm-a910f": "->galaxy a9 pro",
        "sm-g887n": "->galaxy a9 pro",
        "galaxy a9 star": "RE=2018.06;SZ=77x162.4x7.6;WT=191;DS=6.3;RS=1080x2220;OI=1;OV=8.0;CP=61;RM=4096;",
        "sm-g8858": "->galaxy a9 star",
        "sm-g8850": "->galaxy a9 star",
        "galaxy a90": "RE=2019.09;SZ=76.4x164.8x8.4;WT=206;DS=6.7;RS=1080x2400;OI=1;OV=9.0;CP=234;RM=6144;",
        "sm-a908n": "->galaxy a90",
        "sm-a908b": "->galaxy a90",
        "galaxy ace": "RE=2011.01;SZ=59.9x112.4x11.5;WT=113;DS=3.5;RS=320x480;OI=1;OV=2.3;CP=145;RM=278;",
        "gt-s5830l": "->galaxy ace",
        "gt-s5830": "->galaxy ace",
        "galaxy ace 2": "RE=2012.02;SZ=62.2x118.3x10.5;WT=122;DS=3.8;RS=480x800;OI=1;OV=2.3;CP=266;RM=768;",
        "gt-i8160p-orange": "->galaxy ace 2",
        "gt-i8160": "->galaxy ace 2",
        "gt-i8160p": "->galaxy ace 2",
        "galaxy s21+ 5g": "RE=2021.01;SZ=75.6x161.5x7.8;WT=200;DS=6.7;RS=1080x2400;OI=1;OV=11;CP=267;RM=8192;",
        "sm-g9960": "->galaxy s21+ 5g",
        "sm-g996u1": "->galaxy s21+ 5g",
        "sm-g996w": "->galaxy s21+ 5g",
        "sm-g996b": "->galaxy s21+ 5g",
        "sm-g996n": "->galaxy s21+ 5g",
        "sm-g996u": "->galaxy s21+ 5g",
        "scg10": "->galaxy s21+ 5g",
        "galaxy note 20 ultra": "RE=2020.08;SZ=77.2x164.8x8.1;WT=208;DS=6.9;RS=1440x3088;OI=1;OV=10;CP=249;RM=8192;",
        "sm-n985f": "->galaxy note 20 ultra",
        "galaxy note 20 ultra 5g": "RE=2020.08;SZ=77.2x164.8x8.1;WT=208;DS=6.9;RS=1440x3088;OI=1;OV=10;CP=249;RM=12288;",
        "sm-n986b": "->galaxy note 20 ultra 5g",
        "sm-n986n": "->galaxy note 20 ultra 5g",
        "sm-n9860": "->galaxy note 20 ultra 5g",
        "scg06": "->galaxy note 20 ultra 5g",
        "sc-53a": "->galaxy note 20 ultra 5g",
        "galaxy c9 pro": "RE=2016.10;SZ=80.7x162.9x6.9;WT=189;DS=6.0;RS=1080x1920;OI=1;OV=6.0.1;CP=268;RM=6144;",
        "sm-c9008": "->galaxy c9 pro",
        "sm-c900f": "->galaxy c9 pro",
        "galaxy s10e": "RE=2019.02;SZ=69.9x142.2x7.9;WT=150;DS=5.8;RS=1080x2280;OI=1;OV=9.0;CP=269;RM=6144;",
        "sm-g9700": "->galaxy s10e",
        "sm-g970n": "->galaxy s10e",
        "sm-g9708": "->galaxy s10e",
        "sm-g970w": "->galaxy s10e",
        "sm-g970x": "->galaxy s10e",
        "galaxy s20": "RE=2020.02;SZ=69.1x151.7x7.9;WT=163;DS=6.2;RS=1440x3200;OI=1;OV=10;CP=249;RM=8192;",
        "sm-g980f": "->galaxy s20",
        "galaxy s20 5g": "RE=2020.02;SZ=69.1x151.7x7.9;WT=163;DS=6.2;RS=1440x3200;OI=1;OV=10;CP=249;RM=8192;",
        "sm-g981b": "->galaxy s20 5g",
        "scg01": "->galaxy s20 5g",
        "sm-g981v": "->galaxy s20 5g",
        "sc-51a": "->galaxy s20 5g",
        "sc51aa": "->galaxy s20 5g",
        "galaxy s21 ultra 5g": "RE=2021.01;SZ=75.6x165.1x8.9;WT=227;DS=6.8;RS=1440x3200;OI=1;OV=11;CP=267;RM=12288;",
        "sm-g9980": "->galaxy s21 ultra 5g",
        "sm-g998u": "->galaxy s21 ultra 5g",
        "sm-g998u1": "->galaxy s21 ultra 5g",
        "sm-g998w": "->galaxy s21 ultra 5g",
        "sm-g998b": "->galaxy s21 ultra 5g",
        "sm-g998n": "->galaxy s21 ultra 5g",
        "galaxy s21 5g": "RE=2021.01;SZ=71.2x151.7x7.9;WT=169;DS=6.2;RS=1080x2400;OI=1;OV=11;CP=267;RM=8192;",
        "sm-g9910": "->galaxy s21 5g",
        "sm-g991b": "->galaxy s21 5g",
        "sm-g991n": "->galaxy s21 5g",
        "sm-g991w": "->galaxy s21 5g",
        "sm-g991u1": "->galaxy s21 5g",
        "scg09": "->galaxy s21 5g",
        "galaxy a01": "RE=2019.12;SZ=70.9x146.2x8.3;WT=149;DS=5.7;RS=720x1520;OI=1;OV=10;CP=41;RM=2048;",
        "sm-a015a": "->galaxy a01",
        "sm-a015m": "->galaxy a01",
        "sm-a015t1": "->galaxy a01",
        "sm-a015u": "->galaxy a01",
        "sm-a015u1": "->galaxy a01",
        "sm-a015v": "->galaxy a01",
        "sm-s111dl": "->galaxy a01",
        "galaxy a01 core": "RE=2020.07;SZ=67.5x141.7x8.6;WT=150;DS=5.3;RS=720x1480;OI=1;OV=10;CP=8;RM=1024;",
        "sm-a013f": "->galaxy a01 core",
        "sm-a013g": "->galaxy a01 core",
        "galaxy a02s": "RE=2020.09;SZ=75.9x164.2x9.1;WT=196;DS=6.5;RS=720x1600;OI=1;OV=10;CP=214;RM=2048;",
        "sm-a025f": "->galaxy a02s",
        "sm-a025g": "->galaxy a02s",
        "sm-a025m": "->galaxy a02s",
        "galaxy s20 fe 5g": "RE=2020.09;SZ=74.5x159.8x8.4;WT=190;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=141;RM=6144;",
        "sm-g7810": "->galaxy s20 fe 5g",
        "sm-g781b": "->galaxy s20 fe 5g",
        "sm-g781n": "->galaxy s20 fe 5g",
        "sm-g781u": "->galaxy s20 fe 5g",
        "sm-g781u1": "->galaxy s20 fe 5g",
        "sm-g781v": "->galaxy s20 fe 5g",
        "sm-g781w": "->galaxy s20 fe 5g",
        "sm-g780g": "->galaxy s20 fe;",
        "sm-g780f": "->galaxy s20 fe",
        "galaxy s20 fe": "RE=2020.09;SZ=74.5x159.8x8.4;WT=190;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=249;RM=6144;",
        "galaxy s4 zoom": "RE=2013.06;SZ=63.5x125.5x15.4;WT=208;DS=4.3;RS=540x960;OI=1;OV=4.2.2;CP=;RM=1536;",
        "sm-c105a": "->galaxy s4 zoom",
        "sm-c105": "->galaxy s4 zoom",
        "sm-c101": "->galaxy s4 zoom",
        "sm-c105l": "->galaxy s4 zoom",
        "galaxy s6": "RE=2015.05;SZ=70.6x143.5x6.9;WT=140;DS=5.1;RS=1440x2560;OI=1;OV=5.0.2;CP=264;RM=3072;",
        "sm-g920": "->galaxy s6",
        "sm-g920w8": "->galaxy s6",
        "sm-g920v": "->galaxy s6",
        "sm-g920x": "->galaxy s6",
        "sm-g920f": "->galaxy s6",
        "sm-g920i": "->galaxy s6",
        "sm-g920p": "->galaxy s6",
        "sm-g9200": "->galaxy s6",
        "sm-g920l": "->galaxy s6",
        "sm-s907vl": "->galaxy s6",
        "sm-g920k": "->galaxy s6",
        "sm-g920t": "->galaxy s6",
        "sm-g920r4": "->galaxy s6",
        "sc-05g": "->galaxy s6",
        "galaxy s6 edge": "RE=2015.05;SZ=70.1x142.1x7;WT=132;DS=5.1;RS=1440x2560;OI=1;OV=5.0.2;CP=264;RM=3072;",
        "sm-g925a": "->galaxy s6 edge",
        "sm-g9250": "->galaxy s6 edge",
        "sm-g925x": "->galaxy s6 edge",
        "sm-g925i": "->galaxy s6 edge",
        "sm-g925s": "->galaxy s6 edge",
        "sm-g925p": "->galaxy s6 edge",
        "sm-g925d": "->galaxy s6 edge",
        "sm-g925t": "->galaxy s6 edge",
        "sm-g925k": "->galaxy s6 edge",
        "scv31": "->galaxy s6 edge",
        "404sc": "->galaxy s6 edge",
        "sm-g925l": "->galaxy s6 edge",
        "galaxy s6 edge+": "RE=2015.08;SZ=75.8x154.4x6.9;WT=153;DS=5.7;RS=1440x2560;OI=1;OV=5.1.1;CP=264;RM=4096;",
        "sm-g928g": "->galaxy s6 edge+",
        "sm-g928p": "->galaxy s6 edge+",
        "sm-g928w8": "->galaxy s6 edge+",
        "sm-g928l": "->galaxy s6 edge+",
        "sm-g928x": "->galaxy s6 edge+",
        "sm-g928a": "->galaxy s6 edge+",
        "sm-g9287c": "->galaxy s6 edge+",
        "sm-g928i": "->galaxy s6 edge+",
        "sm-g928v": "->galaxy s6 edge+",
        "sm-g9280": "->galaxy s6 edge+",
        "sm-g928s": "->galaxy s6 edge+",
        "sm-g9287": "->galaxy s6 edge+",
        "sm-g928k": "->galaxy s6 edge+",
        "sm-g928r4": "->galaxy s6 edge+",
        "sm-g928t": "->galaxy s6 edge+",
        "galaxy s7": "RE=2016.02;SZ=69.6x142.4x7.9;WT=152;DS=5.1;RS=1440x2560;OI=1;OV=6.0;CP=270;RM=4096;",
        "sm-g930s": "->galaxy s7",
        "sm-g9300": "->galaxy s7",
        "sm-g930x": "->galaxy s7",
        "sm-g930v": "->galaxy s7",
        "sm-g930k": "->galaxy s7",
        "sm-g930l": "->galaxy s7",
        "sm-g9308": "->galaxy s7",
        "sm-g930": "->galaxy s7",
        "sm-g930r4": "->galaxy s7",
        "sm-g930r6": "->galaxy s7",
        "sm-g930r7": "->galaxy s7",
        "sm-g930vc": "->galaxy s7",
        "sm-g930vl": "->galaxy s7",
        "sm-g930p": "->galaxy s7",
        "sm-g930f": "->galaxy s7",
        "sm-g930w8": "->galaxy s7",
        "galaxy note 8": "RE=2017.08;SZ=74.8x162.5x8.6;WT=195;DS=6.3;RS=1440x2960;OI=1;OV=7.1.1;CP=271;RM=6144;",
        "sm-n950u1": "->galaxy note 8",
        "sm-n950f": "->galaxy note 8",
        "scv37": "->galaxy note 8",
        "sc-01k": "->galaxy note 8",
        "sm-n950u": "->galaxy note 8",
        "galaxy ace 4": "RE=2014.06;SZ=62.9x121.4x11;WT=130.3;DS=4.0;RS=480x800;OI=1;OV=4.4.2;RM=1024",
        "sm-g313hy": "->galaxy ace 4",
        "sm-g313mu": "->galaxy ace 4",
        "sm-g313ml": "->galaxy ace 4",
        "sm-g313my": "->galaxy ace 4",
        "sm-g313m": "->galaxy ace 4",
        "sm-g313f": "->galaxy ace 4",
        "galaxy ace 4 lite": "->galaxy ace 4",
        "sm-g313u": "->galaxy ace 4 lite",
        "sm-g313hz": "->galaxy ace 4 lite",
        "sm-g313hn": "->galaxy ace 4 lite",
        "sm-g313h": "->galaxy ace 4 lite",
        "galaxy alpha": "RE=2014.08;SZ=65.5x132.4x6.7;WT=115;DS=4.7;RS=720x1280;OI=1;OV=4.4.4;CP=243;RM=2048;",
        "sm-g850a": "->galaxy alpha",
        "sm-g850m": "->galaxy alpha",
        "sm-g850y": "->galaxy alpha",
        "sm-g850k": "->galaxy alpha",
        "sm-g850l": "->galaxy alpha",
        "sm-g850s": "->galaxy alpha",
        "sm-g850w": "->galaxy alpha",
        "sm-g850x": "->galaxy alpha",
        "sm-g8508s": "->galaxy alpha",
        "galaxy c7 pro": "RE=2017.01;SZ=77.2x156.5x7;WT=172;DS=5.7;RS=1080x1920;OI=1;OV=6.0.1;CP=272;RM=4096;",
        "sm-c7018": "->galaxy c7 pro",
        "sm-c701f": "->galaxy c7 pro",
        "sm-c7010": "->galaxy c7 pro",
        "sm-c701x": "->galaxy c7 pro",
        "galaxy c7": "RE=2016.05;SZ=77.2x156.6x6.8;WT=169;DS=5.7;RS=1080x1920;OI=1;OV=6.0.1;CP=81;RM=4096;",
        "sm-c7000": "->galaxy c7",
        "sm-c700x": "->galaxy c7",
        "galaxy tab s7 11.0\" 5g": "RE=2020.08;SZ=253.8x165.3x6.3;DS=11;WT=502;RS=2560x1600;SM=1;OI=1;OV=10;RM=6144;CP=141;",
        "sm-t878u": "->galaxy tab s7 11.0\" 5g",
        "galaxy tab s7 11.0\" lte": "RE=2020.08;SZ=253.8x165.3x6.3;WT=498;DS=11.0;RS=2560x1600;OI=1;OV=10;CP=141;RM=6144;",
        "sm-t875": "->galaxy tab s7 11.0\" lte",
        "sm-t875n": "->galaxy tab s7 11.0\" lte",
        "galaxy tab s7+ 12.4\" 5g": "RE=2020.08;SZ=285x185x5.7;DS=12.4;WT=575;RS=2800x1752;OI=1;OV=10;CP=141;RM=6144;",
        "sm-t976b": "->galaxy tab s7+ 12.4\" 5g",
        "galaxy a52": "RE=2021.05;SZ=75.1x159.9x8.4;WT=189;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=273;RM=4096;",
        "sm-a525f": "->galaxy a52",
        "galaxy a32": "RE=2021.02;SZ=73.6x158.9x8.4;WT=184;DS=6.4;RS=1080x2400;OI=1;OV=11;CP=226;RM=4096;",
        "sm-a325f": "->galaxy a32",
        "galaxy a32 5g": "RE=2021.01;SZ=76.1x164.2x9.1;WT=205;DS=6.5;RS=720x1600;OI=1;OV=11;CP=274;RM=4096;",
        "sm-a326b": "->galaxy a32 5g",
        "sm-a326br": "->galaxy a32 5g",
        "scg08": "->galaxy a32 5g",
        "galaxy a72": "RE=2021.05;SZ=77.4x165x8.4;WT=203;DS=6.7;RS=1080x2400;OI=1;OV=11;CP=273;RM=6144;",
        "sm-a725f": "->galaxy a72",
        "galaxy folder": "RE=2015.07;SZ=60.2x122x15.3;WT=155;DS=3.8;RS=480x800;OI=1;OV=5.1;RM=1536;",
        "sm-g155s": "->galaxy folder",
        "sm-g150nk": "->galaxy folder",
        "sm-g150n0": "->galaxy folder",
        "sm-g150nl": "->galaxy folder",
        "sm-g150ns": "->galaxy folder",
        "galaxy folder 2": "RE=2017.07;SZ=60.2x122x16.1;WT=165;DS=3.8;RS=480x800;OI=1;OV=6.0;CP=20;RM=2048;",
        "sm-g160n": "->galaxy folder 2",
        "sm-g1600": "->galaxy folder 2",
        "sm-g1650": "->galaxy folder 2",
        "sm-g165n": "->galaxy folder 2",
        "galaxy c5 pro": "RE=2017.05;SZ=71.4x145.7x7;WT=145;DS=5.2;RS=1080x1920;OI=1;OV=7.0;CP=272;RM=4096;",
        "sm-c5018": "->galaxy c5 pro",
        "sm-c5010": "->galaxy c5 pro",
        "galaxy c5": "RE=2016.05;SZ=72x145.9x6.7;WT=143;DS=5.2;RS=1080x1920;OI=1;OV=6.0.1;65;RM=4096;",
        "sm-c5000": "->galaxy c5",
        "sm-c500x": "->galaxy c5",
        "galaxy c8": "RE=2017.09;SZ=74.7x152.4x7.9;WT=180;DS=5.5;RS=1080x1920;OI=1;OV=7.1;CP=174;RM=4096;SM=2;",
        "sm-c7100": "->galaxy c8",
        "sm-c7108": "->galaxy c8",
        "galaxy m12": "RE=2021.02;SZ=75.9x164x9.7;WT=221;DS=6.5;RS=720x1600;OI=1;OV=11;CP=250;RM=4096",
        "sm-m127f": "->galaxy m12",
        "sm-m127g": "->galaxy m12",
        "galaxy z flip 5g": "RE=2020.07;SZ=73.6x167.3x7.2;WT=183;DS=6.7;RS=1080x2636;OI=1;OV=10;CP=141;RM=8192;",
        "sm-f7070": "->galaxy z flip 5g",
        "sm-f707b": "->galaxy z flip 5g",
        "sm-f707n": "->galaxy z flip 5g",
        "sm-f707u": "->galaxy z flip 5g",
        "sm-f707u1": "->galaxy z flip 5g",
        "sm-f707w": "->galaxy z flip 5g",
        "scg04": "->galaxy z flip 5g",
        "galaxy a42 5g": "RE=2020.12;SZ=75.9x164.4x8.6;WT=193;DS=6.6;RS=720x1600;OI=1;OV=10;CP=275;RM=4096",
        "sm-a4260": "->galaxy a42 5g",
        "sm-a426b": "->galaxy a42 5g",
        "sm-a426n": "->galaxy a42 5g",
        "galaxy a90 5g": "RE=2019.09;SZ=76.4x164.8x8.4;WT=206;DS=6.7;RS=1080x2400;OI=1;OV=9.0;CP=234;RM=6144;",
        "sm-a9080": "->galaxy a90 5g",
        "galaxy m51": "RE=2020.08;SZ=76.3x163.9x9.5;WT=213;DS=6.7;RS=1080x2400;OI=1;OV=10;CP=260;RM=6144;",
        "sm-m515f": "->galaxy m51",
        "galaxy m20": "RE=2019.01;SZ=74.5x156.4x8.8;WT=186;DS=6.3;RS=1080x2340;OI=1;OV=8.1;CP=237;RM=3072;",
        "sm-m205n": "->galaxy m20",
        "sm-m205m": "->galaxy m20",
        "sm-m205f": "->galaxy m20",
        "sm-m205g": "->galaxy m20",
        "sm-m205fn": "->galaxy m20",
        "galaxy m11": "RE=2020.05;SZ=76.3x161.4x9;WT=197;DS=6.4;RS=720x1560;OI=1;OV=10;CP=214;RM=3072;",
        "sm-m115f": "->galaxy m11",
        "sm-m115m": "->galaxy m11",
        "galaxy m01 core": "RE=2020.07;SZ=67.5x141.7x8.6;WT=150;DS=5.3;RS=720x1480;OI=1;OV=10;CP=8;RM=1024;",
        "sm-m013f": "->galaxy m01 core",
        "galaxy m01s": "RE=2020.07;SZ=75.8x156.9x7.8;WT=168;DS=6.2;RS=720x1520;OI=1;OV=9.0;CP=47;RM=3072;",
        "sm-m017f": "->galaxy m01s",
        "galaxy m02s": "RE=2021.01;SZ=75.9x164.2x9.1;WT=196;DS=6.5;RS=720x1600;OI=1;OV=10;CP=214;RM=3072;",
        "sm-m025f": "->galaxy m02s",
        "sm-g9758": "->galaxy s10+",
        "galaxy s10+": "RE=2019.02;SZ=74.1x157.6x7.8;WT=175;DS=6.4;RS=1440x3040;OI=1;OV=9.0;CP=269;RM=8192;",
        "sm-g975n": "->galaxy s10+",
        "sm-g975x": "->galaxy s10+",
        "sc-04l": "->galaxy s10+",
        "scv42": "->galaxy s10+",
        "galaxy s20 ultra 5g": "RE=2020.02;SZ=76x166.9x8.8;WT=222;DS=6.9;RS=1440x3200;OI=1;OV=10;CP=249;RM=12288;",
        "sm-g988b": "->galaxy s20 ultra 5g",
        "sm-g9880": "->galaxy s20 ultra 5g",
        "scg03": "->galaxy s20 ultra 5g",
        "galaxy s20+ 5g": "RE=2020.02;SZ=73.7x161.9x7.8;WT=188;DS=6.7;RS=1440x3200;OI=1;OV=10;CP=249;RM=12288;",
        "sm-g986b": "->galaxy s20+ 5g",
        "sc-52a": "->galaxy s20+ 5g",
        "sm-g986n": "->galaxy s20+ 5g",
        "galaxy s20+": "RE=2020.02;SZ=73.7x161.9x7.8;WT=186;DS=6.7;RS=1440x3200;OI=1;OV=10;CP=249;RM=8192;",
        "sm-g985f": "->galaxy s20+",
        "scg02": "->galaxy s20+",
        "galaxy s10": "RE=2019.02;SZ=77.1x162.6x7.9;WT=198;DS=6.7;RS=1440x3040;OI=1;OV=9.0;CP=269;RM=8192;",
        "sm-g977t": "->galaxy s10",
        "sm-g973f": "->galaxy s10",
        "sm-g977p": "->galaxy s10",
        "sm-g977u": "->galaxy s10",
        "sc-03l": "->galaxy s10",
        "sm-g977b": "->galaxy s10",
        "sm-g977n": "->galaxy s10",
        "scv41": "->galaxy s10",
        "galaxy note 5": "RE=2015.08;SZ=76.1x153.2x7.6;WT=171;DS=5.7;RS=1440x2560;OI=1;OV=5.1.1;CP=264;RM=4096;",
        "sm-n920v": "->galaxy note 5",
        "sm-n920t": "->galaxy note 5",
        "sm-n920x": "->galaxy note 5",
        "sm-n920f": "->galaxy note 5",
        "sm-n920i": "->galaxy note 5",
        "sm-n920s": "->galaxy note 5",
        "sm-n920c": "->galaxy note 5",
        "sm-n920k": "->galaxy note 5",
        "sm-n920r7": "->galaxy note 5",
        "sm-n9200": "->galaxy note 5",
        "sm-n920l": "->galaxy note 5",
        "sm-n920g": "->galaxy note 5",
        "sm-n920r6": "->galaxy note 5",
        "sm-n920r4": "->galaxy note 5",
        "sm-n920w8": "->galaxy note 5",
        "sm-n920p": "->galaxy note 5",
        "galaxy note 9": "RE=2018.08;SZ=76.4x161.9x8.8;WT=201;DS=6.4;RS=1440x2960;OI=1;OV=8.1;CP=241;RM=6144;",
        "scv40": "->galaxy note 9",
        "sc-01l": "->galaxy note 9",
        "sm-n960f": "->galaxy note 9",
        "sm-n960u": "->galaxy note 9",
        "sm-n960n": "->galaxy note 9",
        "galaxy note edge": "RE=2014.09;SZ=82.4x151.3x8.3;WT=174;DS=5.6;RS=1600x2560;OI=1;OV=4.4.4;CP=276;RM=3072",
        "sc-01g": "->galaxy note edge",
        "galaxy note fe": "->galaxy note fan edition",
        "galaxy note fan edition": "RE=2017.07;SZ=73.9x153.5x7.9;WT=167;DS=5.7;RS=1440x2560;OI=1;OV=7.1.1;CP=270;RM=4096;",
        "sm-n935f": "->galaxy note fan edition",
        "sm-n935s": "->galaxy note fan edition",
        "sm-n935l": "->galaxy note fan edition",
        "sm-n935k": "->galaxy note fan edition",
        "galaxy pocket 2": "RE=2014.09;SZ=60.8x109.9x11.7;WT=107;DS=3.3;RS=240x320;OI=1;OV=4.4.2;CP=277;RM=512;",
        "sm-g110h": "->galaxy pocket 2",
        "sm-g110m": "->galaxy pocket 2",
        "sm-g110b": "->galaxy pocket 2",
        "galaxy on5": "RE=2015.10;SZ=72.1x142.3x8.5;WT=149;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=278;RM=1536;",
        "sm-g5500": "->galaxy on5",
        "sm-g550t1": "->galaxy on5",
        "sm-g550t2": "->galaxy on5",
        "sm-g550fy": "->galaxy on5",
        "sm-g5510": "->galaxy on5",
        "sm-g5520": "->galaxy on5",
        "sm-s550tl": "->galaxy on5",
        "sm-g550t": "->galaxy on5",
        "galaxy on7": "RE=2015.10;SZ=77.5x151.8x8.2;WT=172;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=17;RM=1536;",
        "sm-g6000": "->galaxy on7",
        "sm-g600fy": "->galaxy on7",
        "sm-g600f": "->galaxy on7",
        "galaxy on7 (2016)": "RE=2016.09;SZ=75x151.7x8;WT=167;DS=5.5;RS=1080x1920;OI=1;OV=6.0.1;CP=81;RM=3072;",
        "sm-g6100": "->galaxy on7 (2016)",
        "sm-g610k": "->galaxy on7 (2016)",
        "sm-g610l": "->galaxy on7 (2016)",
        "sm-g610s": "->galaxy on7 (2016)",
        "galaxy s4 mini": "RE=2013.05;SZ=61.3x124.6x8.9;WT=107;DS=4.3;RS=540x960;OI=1;OV=4.2.2;CP=32;RM=1536;",
        "gt-i9190": "->galaxy s4 mini",
        "sch-i435": "->galaxy s4 mini",
        "gt-i9192": "->galaxy s4 mini",
        "gt-i9195": "->galaxy s4 mini",
        "gt-i9195i": "->galaxy s4 mini",
        "galaxy s9+": "RE=2018.02;SZ=73.8x158.1x8.5;WT=189;DS=6.2;RS=1440x2960;OI=1;OV=8.0;CP=241;RM=6144;",
        "sc-03k": "->galaxy s9+",
        "scv39": "->galaxy s9+",
        "sm-g965f": "->galaxy s9+",
        "sm-g965n": "->galaxy s9+",
        "sm-g965x": "->galaxy s9+",
        "galaxy s9": "RE=2018.02;SZ=68.7x147.7x8.5;WT=163;DS=5.8;RS=1440x2960;OI=1;OV=8.0;CP=241;RM=4096;",
        "sm-g960": "->galaxy s9",
        "sc-02k": "->galaxy s9",
        "sm-g960x": "->galaxy s9",
        "sm-g960n": "->galaxy s9",
        "scv38": "->galaxy s9",
        "sm-g960f": "->galaxy s9",
        "galaxy xcover 4": "RE=2017.05;SZ=73.3x146.2x9.7;WT=172;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=279;RM=2048;",
        "sm-g390f": "->galaxy xcover 4",
        "sm-g390w": "->galaxy xcover 4",
        "sm-g390y": "->galaxy xcover 4",
        "galaxy young 2": "RE=2014.06;SZ=59.9x109.8x11.8;WT=108;DS=3.5;RS=320x480;CP=280;OI=1;OV=4.4.2;RM=512;",
        "sm-g130h": "->galaxy young 2",
        "sm-g130hn": "->galaxy young 2",
        "sm-g130m": "->galaxy young 2",
        "sm-g130u": "->galaxy young 2",
        "sm-g130e": "->galaxy young 2",
        "sm-g130bt": "->galaxy young 2",
        "galaxy note ii": "RE=2012.08;SZ=80.5x151.1x9.4;WT=183;DS=5.5;RS=720x1280;OI=1;OV=4.1.1;CP=233;RM=2048;",
        "sph-l900": "->galaxy note ii",
        "gt-n7100": "->galaxy note ii",
        "sch-i605": "->galaxy note ii",
        "sch-r950": "->galaxy note ii",
        "sch-n719": "->galaxy note ii",
        "n7100": "->galaxy note ii",
        "galaxy j5 (2015)": "RE=2015.06;SZ=71.8x142.1x7.9;WT=146;DS=5.0;RS=720x1280;OI=1;OV=5.1;CP=17;RM=1536;",
        "sm-j5008": "->galaxy j5 (2015)",
        "sm-j500n0": "->galaxy j5 (2015)",
        "sm-j5007": "->galaxy j5 (2015)",
        "sm-j500h": "->galaxy j5 (2015)",
        "sm-j500f": "->galaxy j5 (2015)",
        "galaxy j5 (2016)": "RE=2016.03;SZ=72.3x145.8x8.1;WT=159;DS=5.2;RS=720x1280;OI=1;OV=6.0.1;CP=17;RM=2048;",
        "sm-g510h": "->galaxy j5 (2016)",
        "sm-5108": "->galaxy j5 (2016)",
        "sm-j5108": "->galaxy j5 (2016)",
        "sm-j510g": "->galaxy j5 (2016)",
        "sm-j510mn": "->galaxy j5 (2016)",
        "sm-j510un": "->galaxy j5 (2016)",
        "sm-j510y": "->galaxy j5 (2016)",
        "sm-j510fn": "->galaxy j5 (2016)",
        "sm-j510h": "->galaxy j5 (2016)",
        "sm-j510k": "->galaxy j5 (2016)",
        "sm-j510l": "->galaxy j5 (2016)",
        "sm-j510gn": "->galaxy j5 (2016)",
        "sm-j510s": "->galaxy j5 (2016)",
        "galaxy j5 (2017)": "RE=2017.06;SZ=71.3x146.2x8;WT=160;DS=5.2;RS=720x1280;OI=1;OV=7.0;CP=252;RM=2048;",
        "sm-j530f": "->galaxy j5 (2017)",
        "sm-j530g": "->galaxy j5 (2017)",
        "galaxy j5 prime": "RE=2016.09;SZ=69.5x142.8x8.1;WT=143;DS=5.0;RS=720x1280;OI=1;OV=6.0.1;CP=279;RM=2048;",
        "sm-g570m": "->galaxy j5 prime",
        "sm-g570y": "->galaxy j5 prime",
        "sm-g570f": "->galaxy j5 prime",
        "sm-g5700": "->galaxy j5 prime",
        "galaxy j6": "RE=2018.05;SZ=70.2x149.3x8.2;WT=154;DS=5.6;RS=720x1480;OI=1;OV=8.0;CP=252;RM=2048;",
        "sm-j600g": "->galaxy j6",
        "sm-j600gf": "->galaxy j6",
        "sm-j600f": "->galaxy j6",
        "sm-j600n": "->galaxy j6",
        "sm-j600l": "->galaxy j6",
        "galaxy j6+": "RE=2018.09;SZ=76.9x161.4x7.9;WT=178;DS=6.0;RS=720x1480;OI=1;OV=8.1;CP=20;RM=3072;",
        "sm-j610f": "->galaxy j6+",
        "galaxy j7": "RE=2015.06;SZ=78.7x152.2x7.5;WT=171;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=22;RM=1536;",
        "sm-j7008": "->galaxy j7",
        "sm-j700k": "->galaxy j7",
        "sm-j700f": "->galaxy j7",
        "sm-j710mn": "->galaxy j7",
        "sm-j710f": "->galaxy j7",
        "galaxy j7 (2015)": "->galaxy j7",
        "sm-j700p": "->galaxy j7 (2015)",
        "galaxy j7 (2016)": "RE=2016.05;SZ=76x151.7x7.8;WT=170;DS=5.5;RS=720x1280;OI=1;OV=6.0.1;CP=252;RM=2048;",
        "sm-j700t": "->galaxy j7 (2016)",
        "sm-j7109": "->galaxy j7 (2016)",
        "sm-j700t1": "->galaxy j7 (2016)",
        "sm-j710gn": "->galaxy j7 (2016)",
        "galaxy j7 (2017)": "RE=2017.05;SZ=76.2x151.4x8.6;WT=167.3;DS=5.5;RS=720x1280;OI=1;OV=7.0.1;CP=204;RM=2048;",
        "sm-j727f": "->galaxy j7 (2017)",
        "sm-j727a": "->galaxy j7 (2017)",
        "sm-j727u": "->galaxy j7 (2017)",
        "sm-j727s": "->galaxy j7 (2017)",
        "sm-j727r4": "->galaxy j7 (2017)",
        "sm-j730k": "->galaxy j7 (2017)",
        "galaxy z fold 2 5g": "RE=2020.08;SZ=128.2x159.2x6.9;WT=282;DS=7.6;RS=1768x2208;OI=1;OV=10;CP=141;RM=12288;",
        "sm-f916b": "->galaxy z fold 2 5g",
        "sm-f916n": "->galaxy z fold 2 5g",
        "sm-f916q": "->galaxy z fold 2 5g",
        "sm-f916u": "->galaxy z fold 2 5g",
        "sm-f916u1": "->galaxy z fold 2 5g",
        "sm-f916w": "->galaxy z fold 2 5g",
        "scg05": "->galaxy z fold 2 5g",
        "sm-f9160": "->galaxy z fold 2 5g",
        "sm-a105m": "->galaxy a10",
        "sm-a525m": "->galaxy a52",
        "sm-a705gm": "->galaxy a70",
        "sm-a307fn": "->galaxy a30s",
        "sm-g975u": "->galaxy s10+",
        "sm-a750fn": "->galaxy a7 (2018)",
        "sm-g965u1": "->galaxy s9+",
        "sm-a326u": "->galaxy a32 5g",
        "sm-a325m": "->galaxy a32",
        "sm-a505fn": "->galaxy a50",
        "sm-g960u": "->galaxy s9",
        "sm-g975f": "->galaxy s10+",
        "sm-g965u": "->galaxy s9+",
        "k": "->galaxy a10",
        "rr fortuna3g": "->galaxy grand prime",
        "samsung-sm-n920a": "->galaxy note 5",
        "sm-g530fz": "->galaxy grand prime",
        "sm-g530y": "->galaxy grand prime",
        "galaxy note 2": "->galaxy note ii",
        "sm-n986u1": "->galaxy note 20 ultra 5g",
        "scl24": "->galaxy note edge",
        "samsung-gt-i9168 td": "->galaxy grand neo+",
        "samsung-sm-g530az": "->galaxy grand prime",
        "samsung-sm-g530a": "->galaxy grand prime",
        "samsung-sm-g750a": "->galaxy mega 2",
        "samsung-sm-g7509": "->galaxy mega 2",
        "sm-n975c": "->galaxy note 10+",
        "sm-n950n": "->galaxy note 8",
        "sm-n986w": "->galaxy note 20 ultra 5g",
        "sm-n986u": "->galaxy note 20 ultra 5g",
        "sm-n976b": "->galaxy note 10+",
        "sm-n9600": "->galaxy note 9",
        "sm-n950w": "->galaxy note 8",
        "sm-n9500": "->galaxy note 8",
        "sm-n960u1": "->galaxy note 9",
        "sm-n960w": "->galaxy note 9",
        "sm-f900u1": "->galaxy fold",
        "sm-n986c": "->galaxy note 20 ultra 5g",
        "sm-g991u": "->galaxy s21 5g",
        "sm-a510k/kku1cqk1": "->galaxy a5 (2016)",
        "sm-a500k/ktu1aoa1": "->galaxy a5 duos",
        "sm-a605x)": "->galaxy a6+",
        "sm-a605fn/a605fnxxu1ard7": "->galaxy a6+",
        "sm-a710k/kku1cql1": "->galaxy a7 (2016)",
        "gt-i8160p-orange/i8160pbvlk3": "->galaxy ace 2",
        "samsung-sm-g850a": "->galaxy alpha",
        "samsung-sm-j727a": "->galaxy j7 (2017)",
        "samsung-gt-i9505+": "->galaxy s4",
        "sprd-galaxy-s4": "->galaxy s4",
        "samsung-sch-i959": "->galaxy s4",
        "samsung-sm-c105a": "->galaxy s4 zoom",
        "sm-g900f-orange": "->galaxy s5",
        "sprd-galaxy-s5": "->galaxy s5",
        "samsung-sm-g925a": "->galaxy s6 edge",
        "samsung-sm-g928a": "->galaxy s6 edge+",
        "sm-g928k/kku3dql1": "->galaxy s6 edge+",
        "sm-a205gn": "->galaxy a20",
        "sm-s906l": "->galaxy s6",
        "sm-g928n0": "->galaxy s6 edge+",
        "sm-a705u": "->galaxy a70",
        "sm-j510fq": "->galaxy j5 (2016)",
        "sm-a9 pro": "->galaxy a9 pro",
        "sm-m20": "->galaxy m20",
        "sm-a720m": "->galaxy a7 (2017)",
        "sm-a217m": "->galaxy a21s",
        "sm-g930t1": "->galaxy s7",
        "samsung-sm-g930az": "->galaxy s7",
        "sm-g970u1": "->galaxy s10e",
        "sm-a013m": "->galaxy a01 core",
        "sm-a500fu": "->galaxy a5 duos",
        "sm-a105g": "->galaxy a10",
        "sm-g900v": "->galaxy s5",
        "sm-j610fn": "->galaxy j6+",
        "sm-a505fm": "->galaxy a50",
        "sm-a300f": "->galaxy a3 (2015)",
        "sm-a205g": "->galaxy a20",
        "sm-j600fn": "->galaxy j6",
        "sm-g988n": "->galaxy s20 ultra 5g",
        "sm-g9650": "->galaxy s9+",
        "sm-a510f": "->galaxy a5 (2016)",
        "sm-a500f": "->galaxy a5 duos",
        "sm-a305fn": "->galaxy a30",
        "sm-g975u1": "->galaxy s10+",
        "sm-g970f": "->galaxy s10e",
        "sm-a307gt": "->galaxy a30s",
        "sm-a505gt": "->galaxy a50",
        "sm-g9750": "->galaxy s10+",
        "lineage j5y17lte": "->galaxy j5 (2017)",
        "sm-g986u": "->galaxy s20+ 5g",
        "sm-a205fn": "->galaxy a20",
        "sm-a205f": "->galaxy a20",
        "sm-a305f": "->galaxy a30",
        "sm-g981w": "->galaxy s20 5g",
        "sm-g9810": "->galaxy s20 5g",
        "sm-g973w": "->galaxy s10",
        "sm-j530fm": "->galaxy j5 (2017)",
        "sm-a405fn": "->galaxy a40",
        "sm-g9980u1": "->galaxy s21 ultra 5g",
        "gt-i8160l": "->galaxy ace 2",
        "gt-i9505-orange": "->galaxy s4",
        "gt-i9505/i9505xxubmea": "->galaxy s4",
        "gt-i9505": "->galaxy s4",
        "gt-i9505g": "->galaxy s4",
        "sm-j610g": "->galaxy j6+",
        "sm-a305gt": "->galaxy a30",
        "sm-a505f": "->galaxy a50",
        "sm-a505g": "->galaxy a50",
        "sm-a305g": "->galaxy a30",
        "sm-g975w": "->galaxy s10+",
        "sm-g970u": "->galaxy s10e",
        "sm-a015f": "->galaxy a01",
        "sm-a705w": "->galaxy a70",
        "sm-a705yn": "->galaxy a70",
        "sm-a025u": "->galaxy a02s",
        "sm-g973c": "->galaxy s10",
        "sc-52b": "->galaxy s21 ultra 5g",
        "sc-04f": "->galaxy s5",
        "sm-a305yn": "->galaxy a30",
        "sm-a320f": "->galaxy a3 (2017)",
        "sm-g9860": "->galaxy s20+ 5g",
        "sm-g988w": "->galaxy s20 ultra 5g",
        "sm-g973n": "->galaxy s10",
        "sm-g9730": "->galaxy s10",
        "sm-a515u1": "->galaxy a51",
        "sm-g981n": "->galaxy s20 5g",
        "sm-g973u1": "->galaxy s10",
        "sm-g973u": "->galaxy s10",
        "sm-a102u1": "->galaxy a10e",
        "sm-g988u": "->galaxy s20 ultra 5g",
        "sm-a125u": "->galaxy a12",
        "sm-a015g": "->galaxy a01",
        "sm-a307gn": "->galaxy a30s",
        "sm-j530k": "->galaxy j5 (2017)",
        "sm-j530s": "->galaxy j5 (2017)",
        "sm-j530l": "->galaxy j5 (2017)",
        "sm-c9000": "->galaxy c9 pro",
        "sm-a325n": "->galaxy a32",
        "sm-a7050": "->galaxy a70",
        "sm-a015az": "->galaxy a01",
        "sm-a025az": "->galaxy a02s",
        "shv-e300k": "->galaxy s4",
        "sm-s115dl": "->galaxy a11",
        "sm-j700h": "->galaxy j7",
        "sm-g991q": "->galaxy s21 5g",
        "sm-g988u1": "->galaxy s20 ultra 5g",
        "sm-g986u1": "->galaxy s20+ 5g",
        "sm-g981u1": "->galaxy s20 5g",
        "sm-a025a": "->galaxy a02s",
        "sm-g981u": "->galaxy s20 5g",
        "sm-g960u1": "->galaxy s9",
        "sm-g9600": "->galaxy s9",
        "sm-g960w": "->galaxy s9",
        "sm-a505gn": "->galaxy a50",
        "sm-a025u1": "->galaxy a02s",
        "sm-j710k": "->galaxy j7",
        "sm-j710fq": "->galaxy j7",
        "sm-a125n": "->galaxy a12",
        "sm-a305gn": "->galaxy a30",
        "sm-a125u1": "->galaxy a12",
        "sm-a127m": "->galaxy a12",
        "sm-g986w": "->galaxy s20+ 5g",
        "sm-g925f": "->galaxy s6 edge",
        "sm-a025v": "->galaxy a02s",
        "lineage serranoltexx": "->galaxy s4 mini",
        "sm-g928f": "->galaxy s6 edge+",
        "sm-g928c": "->galaxy s6 edge+",
        "sm-a725m": "->galaxy a72",
        "sm-s215dl": "->galaxy a21",
        "sm-s205dl": "->galaxy a20",
        "sc-04g": "->galaxy s6 edge",
        "sm-g965w": "->galaxy s9+",
        "sm-s426dl": "->galaxy a42 5g",
        "sm-j500fn": "->galaxy j5 (2015)",
        "sm-a700fd": "->galaxy a7",
        "sm-g991a": "->galaxy s21 5g",
        "sm-a500h": "->galaxy a5 duos",
        "sm-a710m": "->galaxy a7 (2016)",
        "sm-a710fd": "->galaxy a7 (2016)",
        "sm-a510fd": "->galaxy a5 (2016)",
        "sm-a7100": "->galaxy a7 (2016)",
        "sm-g998t": "->galaxy s21 ultra 5g",
        "sm-g998p": "->galaxy s21 ultra 5g",
        "sch-i545pp": "->galaxy s4",
        "sm-g996p": "->galaxy s21+ 5g",
        "sm-a125a": "->galaxy a12",
        "sm-a125t": "->galaxy a12",
        "sm-a125p": "->galaxy a12",
        "sm-a102j": "->galaxy a21",
        "sm-a115v": "->galaxy a11",
        "sm-a215t": "->galaxy a21",
        "sm-a215p": "->galaxy a21",
        "sm-a215r4": "->galaxy a21",
        "sm-a326j": "->galaxy a32 5g",
        "sm-g925j": "->galaxy s6 edge",
        "sm-j510": "->galaxy j5 (2016)",
        "sm-j710": "->galaxy j7 (2016)",
        "sm-a5ooh": "->galaxy a5",
        "sm-g920s": "->galaxy s6",
        "samsung-sm-g920a": "->galaxy s6",
        "sm-a6": "->galaxy a6",
        "sm-a6+": "->galaxy a6+",
        "sm-g490f": "->galaxy s5",
        "samsung-sm-g828a": "->galaxy s6 edge",
        "sm-g850f": "->galaxy alpha",
        "sm-g850fq": "->galaxy alpha",
        "sm-g900fq": "->galaxy s5",
        "sm-m127n": "->galaxy m12",
        "sm-a505ft": "->galaxy a50",
        "sm-g973x": "->galaxy s10",
        "sm-a125v": "->galaxy a12",
        "sm-j530fd": "->galaxy j5 (2017)",
        "sm-g991r4": "->galaxy s21 5g",
        "sm-a716t": "->galaxy a71 5g",
        "sm-a516t": "->galaxy a51 5g",
        "sm-j600gt": "->galaxy j6",
        "sm-a707w": "->galaxy a70s",
        "sm-s127dl": "->galaxy a12",
        "sm-s124dl": "->galaxy a02s",
        "sm-a125w": "->galaxy a12",
        "sm-a426u": "->galaxy a42 5g",
        "sm-a426u1": "->galaxy a42 5g",
        "sm-a326u1": "->galaxy a32 5g",
        "sm-a326w": "->galaxy a32 5g",
        "sm-s326dl": "->galaxy a32 5g",
        "sm-a516f": "->galaxy a51 5g",
        "sm-a217x": "->galaxy a21s",
        "sm-t976n": "->galaxy tab s7+ 12.4\" 5g",
        "sm-t978u": "->galaxy tab s7+ 12.4\" 5g",
        "sm-t517": "->galaxy tab a 10.1\" (2019)",
        "sm-t517p": "->galaxy tab a 10.1\" (2019)",
        "sm-t510": "->galaxy tab a 10.1\" (2019)",
        "sm-t515n": "->galaxy tab a 10.1\" (2019)",
        "sm-t515x": "->galaxy tab a 10.1\" (2019)"
    },
    "intex": {
        "aqua v3g": "RE=2015.01;DS=3.5;RS=320x480;SZ=62x115.1x9.5;WT=104;RM=512;CP=277;OI=1;OV=4.4;",
        "aqua lions x1+": "DS=5.2;RS=720x1280;SZ=74.4x150x9;WT=170;RE=2017;OI=1;OV=7.0;RM=3072;CP=9;",
        "aqua lions x1": "DS=5.2;RS=720x1280;SZ=74.4x150x9;WT=170;RE=2017;OI=1;OV=7.0;RM=2018;CP=9;",
        "cloud c1": "DS=4;RS=480x800;SZ=64x125x11.2;WT=119;RE=2017;OI=1;OV=7.0;RM=1024;CP=21;",
        "aqua lions 3": "DS=5;RS=720x1280;SZ=72.2x146.5x10.1;WT=167;RE=2017;OI=1;OV=7.0;RM=2048;CP=9;",
        "im0318nd": "->aqua lions 3",
        "aqua star 4g": "DS=5;RS=720x1280;SZ=72.6x143x9;WT=150;RE=2015;OI=1;OV=5.1;RM=1024;CP=56",
        "aqua4g": "->aqua star 4g",
        "aqua a4": "DS=4;RS=480x800;SZ=64x125x11.2;WT=119;RE=2017;OI=1;OV=7.0;RM=1024;CP=360;",
        "aqua a4 plus": "DS=4.5;RS=480x854;SZ=68x136.4x11.1;WT=134;RE=2017;OI=1;OV=7.0;RM=1024;CP=21;",
        "aqua 3g": "DS=4;OI=1;OV=4.2;RM=512;RE=2014.06;RS=480x800;WT=105;SZ=65x125x10;CP=287;",
        "aqua active": "RE=2013.04;DS=3.5;RM=256;WT=122;SZ=49.70x115.30x13.80;OI=1;OV=2.3;RS=320x480;",
        "aqua.active": "->aqua active",
        "aqua glory": "RE=2013.01;DS=4;RM=256;CP=246;WT=114;SZ=67.3x114x11.8;OI=1;OV=2.3;RS=320x480;SM=2;",
        "aqua star": "DS=5;RS=480x854;SZ=72.9x141x8;WT=130;RE=2014;OI=1;OV=4.4.2;RM=1024;CP=1;",
        "aqua style": "DS=4;RS=480x800;SZ=62.5x119.7x9.3;WT=110;RE=2014;OI=1;OV=4.4.2;RM=1024;CP=1;",
        "cloud fame 4g": "DS=4.5;RS=480x854;SZ=68x134.2x9;WT=120;RE=2016;OI=1;OV=6.0;RM=1024;CP=310;",
        "aqua lions n1": "DS=4;RS=480x800;SZ=64.3x124.9x10.2;WT=112;RE=2017;OI=1;OV=7.0;RM=1024;CP=113;",
        "aqua lions e3": "DS=5;RS=720x1280;SZ=73x145x8;WT=154;RE=2018;OI=1;OV=7.0;RM=2048;CP=361;",
        "aqua lions 2": "DS=5;RS=480x854;SZ=72x143.8x9.8;WT=158;RE=2017;OI=1;OV=7.0;RM=1024;CP=21;",
        "aqua 4.5e": "RE=2014.12;SZ=68.9x133.4x8.9;WT=132;DS=4.5;RS=480x854;OI=1;OV=4.4.2;CP=288;RM=512;",
        "fame 4g": "->cloud fame 4g"
    },
    "irbis": {
        "tz22": "DS=10.1;RS=1024x600;SZ=261x163x11.6;WT=540;CP=163;RM=1024;OI=1;OV=5.1;RE=2016.04;",
        "tz72": "DS=7;RS=1024x600;SZ=192x120x11;WT=270;CP=74;RM=1024;OI=1;OV=5.1;RE=2016.05;",
        "tz85": "DS=8;RS=1280x800;WT=360;SZ=208x124x9;CP=163;RM=1024;OI=1;OV=5.1;RE=2016.06;",
        "tz13": "DS=10.1;RS=1024x600;SZ=259x149x11;WT=515;CP=163;RM=1024;OI=1;OV=5.1;RE=2016.07;",
        "tz711": "DS=7;RS=1024x600;WT=260;SZ=188.31x108.2x10.3;CP=6;RM=1024;OI=1;OV=9.0;SM=2;RE=2020.09;",
        "tz192": "DS=10.1;RS=1280x800;SZ=254x153x10.1;WT=527;OI=1;OV=6.0;CP=21;RM=2048;SM=2;RE=2017.06;",
        "tz191": "DS=10.1;RS=1280x800;SZ=241.6x170.5x10.2;WT=540;OI=1;OV=6.0;CP=21;RM=2048;SM=2;RE=2017.06;",
        "tz185": "DS=10.1;RS=1024x600;SZ=250.8x158.8x10.2;WT=530;OI=1;OV=6.0;CP=287;RM=1024;SM=2;RE=2017.02;",
        "tz174": "DS=10.1;RS=1024x600;SZ=250x159x10;WT=500;OI=1;OV=6.0;RM=1024;CP=287;RM=1024;SM=2;RE=2017.06;",
        "tz171": "DS=10.1;RS=1280x800;SZ=241.6x170.5x10.2;WT=540;OI=1;OV=6.0;CP=21;RM=1024;SM=2;RE=2016.11;",
        "tz104": "DS=10.1;RS=1024x600;SZ=251x159x10.2;WT=562;OI=1;OV=5.1;CP=21;RM=1024;SM=2;RE=2016.09;",
        "tz761": "DS=7;RS=1024x600;SZ=188.8x108.5x10.8;WT=260;OI=1;OV=6.0;CP=21;RM=512;SM=2;RE=2016.11;",
        "tz151": "DS=10.1;RS=1280x800;SZ=253.6x174x12.9;WT=615;OI=1;OV=8.1;CP=287;RM=1024;SM=2;RE=2019.06;",
        "tz791": "DS=7;RS=1280x800;SZ=186.78x109.6x9.95;WT=260;OI=1;OV=6.0;CP=21;RM=1024;SM=2;RE=2016.11;",
        "tz722": "DS=7;RS=1024x600;SZ=188x108.3x10.2;WT=263;OI=1;OV=8.1;CP=74;RM=1024;SM=2;RE=2018;"
    },
    "vivo": {
        "1601": "->v5",
        "1603": "->y55l",
        "1606": "->y53i",
        "1609": "->v5 lite",
        "1610": "->y55s",
        "1611": "->v5 plus",
        "1612": "->v5s",
        "1613": "->y25",
        "1707": "->y51 (2015)",
        "1713": "->v5s",
        "1714": "->y69",
        "1716": "->v7 plus",
        "1718": "->v7",
        "1719": "->y65",
        "1720": "->x20 plus",
        "1721": "->x20",
        "1723": "->v9",
        "1724": "->y71",
        "1725": "->x21",
        "1726": "->y83 pro",
        "1727": "->v9 youth",
        "1801": "->y71i",
        "1802": "->y83",
        "1803": "->y81",
        "1804": "->v11 pro",
        "1805": "->nex",
        "1806": "->v11i",
        "1807": "->y95",
        "1808": "->y81",
        "1811": "->y91",
        "1812": "->y81i",
        "1813": "->nex dual display",
        "1814": "->y93",
        "1815": "->y93",
        "1816": "->y91i",
        "1817": "->y91",
        "1818": "->v15 pro",
        "1819": "->v15",
        "1823": "->y90",
        "1850": "->v7 plus",
        "1851": "->v9 pro",
        "1901": "->y15",
        "1902": "->y17",
        "1904": "->y12",
        "1906": "->y11",
        "1907": "->v17 neo",
        "1908": "->y90",
        "1909": "->v17 pro",
        "1910": "->v17 pro",
        "1912": "->nex 3",
        "1915": "->y19",
        "1916": "->u10",
        "1917": "->z1x",
        "1918": "->z1 pro",
        "1919": "->v17",
        "1920": "->v17",
        "1921": "->u20",
        "1929": "->y1s",
        "1933": "->v19",
        "1935": "->y50",
        "1937": "->x50 lite",
        "1938": "->y30",
        "1939": "->y30",
        "1940": "->y12",
        "1951": "->z1 pro",
        "2004": "->x50",
        "2005": "->x50 5g",
        "2006": "->x50 pro",
        "2007": "->y12i",
        "2015": "->y1s",
        "2018": "->v20 pro",
        "iqoo z5": "RE=2021.09;SZ=76.7x164.7x8.5;WT=193;DS=6.67;RS=1080x2400;OI=1;OV=11;CP=359;RM=8192;",
        "v2148a": "->iqoo z5",
        "x flip": "RE=2023.04;SZ=75.3x166.4x7.8;WT=198;DS=6.74;RS=1080x2520;OI=1;OV=13;CP=373;RM=12288;TT=1060911;TG=3930;",
        "v2256a": "->x flip",
        "x fold 3 pro": "RE=2024.03;SZ=142.4x160x5.2;WT=236;DS=8.03;RS=2200x2480;OI=1;OV=14;CP=378;RM=12288;TT=2066322;TG=6791;",
        "v2337a": "->x fold 3 pro",
        "x fold 3": "RE=2024.03;SZ=142.7x160x4.7;WT=219;DS=8.03;RS=2200x2480;OI=1;OV=14;CP=377;RM=12288;TT=1650000;",
        "v2303a": "->x fold 3",
        "x fold 2": "RE=2023.04;SZ=143.4x161.3x6;WT=279;DS=8.03;RS=1916x2160;OI=1;OV=13;CP=377;RM=12288;TT=1314521;TG=4769;",
        "v2266a": "->x fold 2",
        "x fold+": "RE=2022.09;SZ=144.9x162x6.3;WT=311;DS=8.03;RS=1916x2160;OI=1;OV=12;CP=373;RM=12288;",
        "v2229a": "->x fold+",
        "x50 5g": "RE=2020.06;SZ=75.4x159.5x7.6;WT=174.5;DS=6.56;RS=1080x2376;OI=1;OV=10;CP=242;RM=8192;",
        "x90 pro": "RE=2022.11;SZ=74.5x164.1x9.3;WT=214.9;DS=6.78;RS=1260x2800;OI=1;OV=13;CP=376;RM=8192;TT=1228735;TG=4273;",
        "v2242a": "->x90 pro",
        "v2219": "->x90 pro",
        "x100": "RE=2023.11;SZ=75.2x164.1x8.5;WT=202;DS=6.78;RS=1260x2800;OI=1;OV=14;CP=375;RM=12288;TT=2098442;TG=6177",
        "v2309a": "->x100",
        "v2308": "->x100",
        "t1 5g": "RE=2022.02;SZ=75.8x164x8.3;WT=187;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=358;RM=4096;A",
        "v2115a": "->t1 5g",
        "v2141": "->t1 5g",
        "v2150": "->t1 5g",
        "v2157": "->t1 5g",
        "iqoo 8 pro": "RE=2021.08;SZ=75.2x165x9.2;WT=205;DS=6.78;RS=1440x3200;OI=1;OV=11;CP=305;RM=8192;",
        "v2141a": "->iqoo 8 pro",
        "iqoo 8": "RE=2021.08;SZ=75.1x159x8.6;WT=200;DS=6.56;RS=1080x2376;OI=1;OV=11;CP=305;RM=8192;",
        "v2136a": "->iqoo 8",
        "s10": "RE=2021.07;SZ=73.7x158.2x7.3;WT=173;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=306;RM=8192;",
        "v2121a": "->s10",
        "nex a": "RE=2018.06;SZ=77x162x8;WT=199;DS=6.59;RS=1080x2316;OI=1;OV=9.0;CP=62;RM=6144;",
        "nex s": "RE=2018.06;SZ=77x162x8;WT=199;DS=6.59;RS=1080x2316;OI=1;OV=8.1;CP=198;RM=8192;",
        "y53": "RE=2017.03;SZ=71.4x144.2x7.6;WT=137;DS=5.0;RS=540x960;OI=1;OV=6;CP=20;RM=2048;",
        "1606a": "->y53",
        "y1s": "RE=2020.11;SZ=75.1x155.1x8.3;WT=161;DS=6.22;RS=720x1520;OI=1;OV=10;CP=38;RM=2048;",
        "2015 21": "->y1s",
        "y53s": "RE=2021.06;SZ=75.3x164x8.5;WT=189;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=307;RM=8192;",
        "v2058": "->y53s",
        "v2111a": "->y53s",
        "v2123a": "->y53s",
        "v5": "RE=2016.11;SZ=75.5x153.8x7.6;WT=154;DS=5.5;RS=720x1280;OI=1;OV=6.0;CP=40;RM=4096;",
        "y55": "RE=2016.10;SZ=72.9x147.9x7.5;WT=142;DS=5.2;RS=720x1280;OI=1;OV=6;CP=43;RM=2048;",
        "y55l": "->y55",
        "y55a": "->y55",
        "y53i": "RE=2018.04;SZ=71.4x144.2x7.6;WT=137;DS=5.0;RS=540x960;OI=1;OV=6;CP=20;RM=2048;",
        "v5 plus": "RE=2017.01;SZ=74x152.6x7.3;WT=158.6;DS=5.5;RS=1080x1920;OI=1;OV=6;CP=204;RM=4096;",
        "v5s": "RE=2017.04;SZ=75.5x153.8x7.6;WT=154;DS=5.5;RS=720x1280;OI=1;OV=6;CP=40;RM=4096;",
        "v5 lite": "RE=2017.01;SZ=75.5x153.8x7.6;WT=155;DS=5.5;RS=720x1280;OI=1;OV=6;CP=40;RM=3072;",
        "y55s": "RE=2017.02;SZ=72.9x147.9x7.5;WT=142;DS=5.2;RS=720x1280;OI=1;OV=6;CP=20;RM=2048;SM=2;",
        "x50": "RE=2020.07;SZ=75.4x159.5x7.6;WT=173;DS=6.56;RS=1080x2376;OI=1;OV=10;CP=261;RM=8192;",
        "v2005a": "->x50 pro",
        "x50 pro": "RE=2020.06;SZ=72.8x158.5x8;WT=181.5;DS=6.56;RS=1080x2376;OI=1;OV=10;CP=242;RM=8192;",
        "v2001a": "->x50",
        "1907 19": "->v17 neo",
        "v17 neo": "RE=2019.08;SZ=75.2x159.5x8.1;WT=179;DS=6.38;RS=1080x2340;OI=1;OV=9.0;CP=253;RM=6144",
        "v17 pro": "RE=2019.09;SZ=74.7x159x9.8;WT=201.8;DS=6.44;RS=1080x2400;OI=1;OV=9.0;CP=258;RM=8192;",
        "y19": "RE=2019.11;SZ=76.5x162.2x8.9;WT=193;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=253;RM=4096;",
        "z1x": "RE=2019.09;SZ=75.2x159.5x8.1;WT=189.6;DS=6.38;RS=1080x2340;OI=1;OV=9.0;CP=289;RM=6144;",
        "z1 pro": "RE=2019.07;SZ=77.3x162.4x8.9;WT=201;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=289;RM=4096",
        "v17": "RE=2019.11;SZ=74.2x159x8.5;WT=176;DS=6.44;RS=1080x2400;OI=1;OV=9.0;CP=258;RM=8192;",
        "u20": "RE=2019.11;SZ=76.5x162.2x8.9;WT=193;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=258;RM=4096;",
        "v19": "RE=2020.04;SZ=75x159.6x8.5;WT=186.5;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=289;RM=8192;",
        "v2034a": "->y30",
        "v2036a": "->y30",
        "y30": "RE=2020.05;SZ=76.5x162x9.1;WT=197;DS=6.47;RS=720x1560;OI=1;OV=10;CP=38;RM=4096;",
        "v1824a": "->iqoo",
        "v1824ba": "->iqoo",
        "iqoo": "RE=2019.03;SZ=75.2x157.7x8.5;WT=196;DS=6.41;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=6144;",
        "v1955a": "->iqoo 3",
        "iqoo 3": "RE=2020.02;SZ=74.9x158.5x9.2;WT=214.5;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=207;RM=6144;",
        "v2024a": "->iqoo 5",
        "iqoo 5": "E=2020.08;SZ=75.6x160x8.3;WT=197;DS=6.56;RS=1080x2376;OI=1;OV=10;CP=207;RM=8192;",
        "v2025a": "->iqoo 5 pro",
        "iqoo 5 pro": "RE=2020.08;SZ=73.3x159.6x8.9;WT=198;DS=6.56;RS=1080x2376;OI=1;OV=10;CP=207;RM=8192;",
        "iqoo neo": "RE=2019.07;SZ=75.2x159.5x8.1;WT=198.5;DS=6.38;RS=1080x2340;OI=1;OV=9.0;CP=198;RM=6144;",
        "v1914a": "->iqoo neo",
        "iqoo neo 3": "RE=2020.04;SZ=75.6x163.7x8.9;WT=198.1;DS=6.57;RS=1080x2408;OI=1;OV=10;CP=207;RM=6144;",
        "v1981a": "->iqoo neo 3",
        "iqoo neo 855": "RE=2019.10;SZ=75.2x159.5x8.1;WT=198.5;DS=6.38;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=6144;",
        "v1936a": "->iqoo neo 855",
        "v1936al": "->iqoo neo 855",
        "iqoo pro": "RE=2019.08;SZ=75.7x158.8x9.3;WT=215;DS=6.41;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=8192;",
        "v1922a": "->iqoo pro",
        "iqoo pro 5g": "RE=2019.08;SZ=75.7x158.8x9.3;WT=217;DS=6.41;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=8192;",
        "v1916a": "->iqoo pro 5g",
        "v15 pro": "RE=2019.02;SZ=74.7x157.3x8.2;WT=185;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=258;RM=6144;",
        "y69": "RE=2017.08;SZ=75.5x154.6x7.7;WT=162.8;DS=5.5;RS=720x1280;OI=1;OV=7.0;CP=40;RM=3072;",
        "v7 plus": "RE=2017.09;SZ=75.8x155.9x7.7;WT=160;DS=5.99;RS=720x1440;OI=1;OV=7.1.2;CP=214;RM=4096;",
        "v7": "RE=2017.11;SZ=72.8x149.3x7.9;WT=139;DS=5.7;RS=720x1440;OI=1;OV=7.1.2;CP=214;RM=4096;",
        "y65": "RE=2017.10;SZ=75.8x153.6x7.5;WT=157;DS=5.5;RS=720x1280;OI=1;OV=7.1;CP=20;RM=3072;",
        "x20a": "->x20",
        "x20": "RE=2017.09;SZ=75.2x155.9x7.2;WT=159;DS=6.01;RS=1080x2160;OI=1;OV=7.1.1;CP=61;RM=4096;",
        "v9": "RE=2018.05;SZ=75.1x154.8x7.9;WT=150;DS=6.3;RS=1080x2280;OI=1;OV=8.1;CP=272;RM=4096;",
        "y71a": "->y71",
        "y71": "RE=2018.04;SZ=75.7x155.9x7.8;WT=150;DS=6.0;RS=720x1440;OI=1;OV=8.1;CP=20;RM=3072;",
        "x21": "RE=2018.05;SZ=74.8x154.5x7.4;WT=156.2;DS=6.28;RS=1080x2280;OI=1;OV=8.1;CP=61;RM=6144;",
        "x21a": "->x21",
        "y83 pro": "RE=2018.09;SZ=75.2x155.2x7.7;WT=152;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=171;RM=4096;",
        "v9 youth": "RE=2018.04;SZ=75.1x154.8x7.9;WT=150;DS=6.3;RS=1080x2280;OI=1;OV=8.1;CP=214;RM=4096;",
        "1801i": "->y71i",
        "y71i": "RE=2018.10;SZ=75.7x155.9x7.8;WT=150;DS=6.0;RS=720x1440;OI=1;OV=8.1;CP=20;RM=2048;",
        "1808i": "->y81",
        "y81": "RE=2018.06;SZ=75x155.1x7.8;WT=146.5;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=171;RM=3072;",
        "v11 pro": "RE=2018.09;SZ=75x157.9x7.9;WT=156;DS=6.41;RS=1080x2340;OI=1;OV=8.1;CP=61;RM=6144;",
        "nex": "RE=2018.06;SZ=77x162x8;WT=199;DS=6.59;RS=1080x2316;OI=1;OV=8.1;CP=198;RM=8192;",
        "v11i": "RE=2018.09;SZ=75.6x156x8.1;WT=164;DS=6.3;RS=1080x2280;OI=1;OV=8.1;CP=290;RM=6144;",
        "y95": "RE=2018.11;SZ=75.1x155.1x8.3;WT=163.5;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=41;RM=3072;",
        "y91": "RE=2018.11;SZ=75.1x155.1x8.3;WT=163.5;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=41;RM=2048;",
        "1812 19": "->y81i",
        "y81i": "RE=2018.10;SZ=75x155.1x7.8;WT=143;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=44;RM=2048;",
        "v1818t": "->y93",
        "v1818a": "->y93",
        "y93": "RE=2018.11;SZ=75.1x155.1x8.3;WT=163.5;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=41;RM=4096;",
        "y91i": "RE=2018.11;SZ=75.1x155.1x8.3;WT=163.5;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=41;RM=2048;",
        "v15": "RE=2019.03;SZ=75.9x161.2x8.5;WT=189.5;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=114;RM=6144;",
        "1908 19": "->y90",
        "y90": "RE=2019.07;SZ=75.1x155.1x8.3;WT=163.5;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=44;RM=2048;",
        "v9 pro": "RE=2018.06;SZ=75x154.8x7.9;WT=150;DS=6.3;RS=1080x2280;OI=1;OV=8.1;CP=61;RM=6144;",
        "y15": "RE=2019.05;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=171;RM=4096;",
        "y17": "RE=2019.04;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=38;RM=4096;",
        "y12": "RE=2019.06;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=171;RM=3072;",
        "1906 20": "->y11",
        "y11": "RE=2019.10;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=41;RM=2048;",
        "Y50": "RE=2020.04;SZ=76.5x162x9.1;WT=197;DS=6.53;RS=1080x2400;OI=1;OV=10;CP=283;RM=8192;",
        "v20 pro": "RE=2020.09;SZ=74.2x158.8x7.4;WT=170;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=242;RM=8192;",
        "iqoo u1": "RE=2020.07;SZ=76.6x162.1x8.5;WT=190;DS=6.53;RS=1080x2340;OI=1;OV=10;CP=273;RM=6144;",
        "v2023a": "->iqoo u1",
        "iqoo z1": "RE=2020.05;SZ=75.6x164x8.9;WT=195;DS=6.57;RS=1080x2408;OI=1;OV=10;CP=296;RM=6144;",
        "v1986a": "->iqoo z1",
        "iqoo z1x": "RE=2020.07;SZ=76.5x164.2x9.1;WT=199.5;DS=6.57;RS=1080x2408;OI=1;OV=10;CP=242;RM=6144;",
        "v2012a": "->iqoo z1x",
        "iqoo z5x": "RE=2019.05;SZ=77.3x162.4x8.9;WT=204.1;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=62;RM=4096;",
        "v1919a": "->iqoo z5x",
        "nex 3": "RE=2019.09;SZ=76.1x167.4x9.4;WT=217.3;DS=6.89;RS=1080x2256;OI=1;OV=9.0;CP=234;RM=8192;",
        "v1923a": "->nex 3",
        "nex 3s": "RE=2020.05;SZ=76.1x167.4x9.4;WT=219.5;DS=6.89;RS=1080x2256;OI=1;OV=10;CP=207;RM=8192;",
        "v1950a": "->nex 3s",
        "y20g": "RE=2021.01;SZ=76.3x164.4x8.4;WT=192.3;DS=6.51;RS=720x1600;OI=1;OV=10;CP=226;RM=4096;",
        "v2037": "->y20g",
        "s1": "RE=2019.05;SZ=76x162x8.5;WT=189.5;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=114;RM=4096;",
        "v1831a": "->s1",
        "v1831t": "->s1",
        "s1 pro": "RE=2019.05;SZ=74.7x157.3x8.2;WT=185;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=258;RM=6144;",
        "v1832a": "->s1 pro",
        "v1832t": "->s1 pro",
        "s5": "RE=2019.11;SZ=73.9x157.9x8.6;WT=188;DS=6.44;RS=1080x2400;OI=1;OV=9.0;CP=289;RM=8192;",
        "v1932a": "->s5",
        "s6 5g": "RE=2020.05;SZ=74.7x161.2x8.7;WT=181;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=262;RM=6144;",
        "v1962a": "->s6 5g",
        "s7": "RE=2020.08;SZ=74.2x158.8x7.4;WT=170;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=242;RM=8192;",
        "v2020ca": "->s7",
        "v2020a": "->s7",
        "u3": "RE=2019.10;SZ=76.5x162.2x8.9;WT=193;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=258;RM=4096;",
        "v1941a": "->u3",
        "u3x": "RE=2019.09;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=283;RM=3072;",
        "v1928a": "->u3x",
        "v1": "DS=5;RS=720x1280;SZ=71x143.3x6.78;WT=145;RE=2015.07;OI=1;OV=5.0;RM=2048;CP=17;",
        "x70": "RE=2021.09;SZ=75.4x160.1x7.6;WT=182;DS=6.56;RS=1080x2376;OI=1;OV=11;CP=324;RM=8192;",
        "v2133a": "->x70",
        "x20 plus": "RE=2017.09;SZ=80.1x165.3x7.5;WT=181.5;DS=6.43;RS=1080x2160;OI=1;OV=7.1.1;CP=61;RM=4096;",
        "x20plus": "->x20 plus",
        "x21s": "RE=2018.09;SZ=75x157.9x7.9;WT=156;DS=6.41;RS=1080x2340;OI=1;OV=8.1;CP=61;RM=6144;",
        "v1814a": "->x21s",
        "v1814t": "->x21s",
        "x23": "RE=2018.09;SZ=74.1x157.7x7.5;WT=160.5;DS=6.41;RS=1080x2340;OI=1;OV=8.1;CP=298;RM=8192;",
        "v1809t": "->x23",
        "v1816a": "->x23",
        "v1809a": "->x23",
        "v1816t": "->x23",
        "x27": "RE=2019.05;SZ=74.3x157.7x9;WT=188;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=62;RM=8192;",
        "v1829t": "->x27",
        "v1838a": "->x27",
        "v1829a": "->x27",
        "v1838t": "->x27",
        "x27 pro": "RE=2019.04;SZ=74.6x165.7x9;WT=200;DS=6.7;RS=1080x2460;OI=1;OV=9.0;CP=62;RM=8192;",
        "v1836t": "->x27 pro",
        "v1836a": "->x27 pro",
        "x30": "RE=2019.12;SZ=74.1x158.5x8.8;WT=196.5;DS=6.44;RS=1080x2400;OI=1;OV=9.0;CP=262;RM=8192;",
        "v1938ct": "->x30",
        "x30 pro": "RE=2019.12;SZ=74.1x158.5x8.8;WT=198.5;DS=6.44;RS=1080x2400;OI=1;OV=9.0;CP=262;RM=8192;",
        "v1938t": "->x30 pro",
        "x3v": "RE=2015.01;SZ=71.0x143.3x6.8;WT=166;DS=5;RS=720x1280;OI=1;OV=4.4;CP=111;RM=2048;",
        "bbg-vivo x3v": "->x3v",
        "x50 pro plus": "RE=2020.06;SZ=73x158.5x8.8;WT=192.2;DS=6.56;RS=1080x2376;OI=1;OV=10;CP=207;RM=8192;",
        "v2011a": "->x50 pro plus",
        "x50 pro+": "->x50 pro plus",
        "x5max v": "RE=2014.12;SZ=78.0x153.9x4.8;WT=146;DS=5.5;RS=1080x1920;OI=1;OV=4.4;CP=22;RM=2048;",
        "viv-vivo x5max v": "->x5max v",
        "y3": "RE=2020.12;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=38;RM=4096;",
        "v1901a": "->y3",
        "v1901t": "->y3",
        "y3 standard": "RE=2019.11;SZ=76.7x159.4x8.9;WT=191.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=41;RM=3072;",
        "v1930a": "->y3 standard",
        "y50": "RE=2020.04;SZ=76.5x162x9.1;WT=197;DS=6.53;RS=1080x2400;OI=1;OV=10;CP=283;RM=8192;",
        "v1965a": "->y50",
        "y5s": "RE=2019.11;SZ=76.5x162.2x8.9;WT=193;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=253;RM=6144;",
        "v1934a": "->y5s",
        "y70s": "RE=2020.05;SZ=76.6x162x8.5;WT=190;DS=6.53;RS=1080x2340;OI=1;OV=10;CP=299;RM=6144;",
        "v2002a": "->y70s",
        "y73": "DS=5.99;RS=720x1440;SZ=75.74x155.87x7.8;WT=150;RE=2018.09;OI=1;OV=8.1;RM=3072;CP=41;",
        "v1731ca": "->y73",
        "y7s": "DS=6.38;RS=1080x2340;SZ=75.23x159.53x8.13;WT=179;RE=2019.06;OI=1;OV=9.0;RM=6144;CP=253;",
        "v1913a": "->y7s",
        "v1913t": "->y7s",
        "y81s": "DS=6.22;RS=720x1520;SZ=75x155.06x7.77;WT=146;RE=2018.06;OI=1;OV=8.1;RM=3072;CP=171;",
        "v1732t": "->y81s",
        "v1732a": "->y81s",
        "v2080a": "->s7t",
        "s7t": "RE=2021.02;SZ=74.2x158.8x7.4;WT=169;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=297;RM=8192;",
        "v21e": "RE=2021.04;SZ=74.37x161.24x7.38;WT=171;DS=6.44;RS=1080x2400;CP=273;RM=8192;OI=1;OV=11;SM=2",
        "v2061": "->v21e",
        "v21": "RE=2021.04;SZ=73.90x159.68x7.29;WT=176;DS=6.44;RS=1080x2404;CP=300;RM=8192;OI=1;OV=11;SM=2;",
        "v2066": "->v21",
        "v2108": "->v21",
        "y51": "RE=2020.12;SZ=75.3x163.9x8.4;WT=188;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=283;RM=8192;",
        "v2030": "->y51",
        "v2035": "->y51",
        "y51a": "->y51",
        "y54s": "RE=2021.11;SZ=75.4x164.2x8.5;WT=188.4;DS=6.51;RS=720x1600;OI=1;OV=11;CP=302;RM=6144;",
        "v2045a": "->y54s",
        "y76s": "RE=2021.11;SZ=75x163.8x7.8;WT=175;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=356;RM=8192;",
        "v2156a": "->y76s",
        "y20 (2021)": "RE=2020.12;SZ=76.3x164.4x8.4;WT=192;DS=6.51;RS=720x1600;OI=1;OV=10;CP=38;RM=4096;",
        "v2043": "->y20 (2021)",
        "v2043 21": "->y20 (2021)",
        "v20 (2021)": "RE=2020.12;SZ=74.2x161.3x7.4;WT=171;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=261;RM=8192;",
        "v2040": "->v20 (2021)",
        "y89": "RE=2019.01;SZ=75x154.8x7.9;WT=149.3;DS=6.26;RS=1080x2280;OI=1;OV=8.1;CP=272;RM=4096;",
        "v1730ea": "->y89",
        "y93s": "RE=2018.12;SZ=75.1x155.1x8.3;WT=165;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=171;RM=4096;",
        "v1818ct": "->y93s",
        "v1818ca": "->y93s",
        "y97": "RE=2018.09;SZ=75.6x155.9x8.1;WT=162;DS=6.3;RS=1080x2280;OI=1;OV=8.1;CP=290;RM=4096;",
        "v1813t": "->y97",
        "v1813a": "->y97",
        "y9s": "RE=2019.12;SZ=75.2x159.3x8.7;WT=186.7;DS=6.38;RS=1080x2340;OI=1;OV=9.0;CP=283;RM=8192;",
        "v1945a": "->y9s",
        "z1": "RE=2018.05;SZ=75x154.8x7.9;WT=149.3;DS=6.26;RS=1080x2280;OI=1;OV=8.1;CP=61;RM=4096;",
        "v1801a0": "->z1",
        "z1i": "RE=2017.07;SZ=75x154.8x7.9;WT=149.3;DS=6.26;RS=1080x2280;OI=1;OV=8.1;CP=205;RM=4096;",
        "v1730da": "->z1i",
        "v1730dt": "->z1i",
        "z3": "RE=2018.10;SZ=75.6x156x8.1;WT=164;DS=6.3;RS=1080x2280;OI=1;OV=8.1;CP=298;RM=4096;",
        "v1813ba": "->z3",
        "v1813bt": "->z3",
        "z3x": "RE=2019.04;SZ=75x154.8x7.9;WT=150;DS=6.26;RS=1080x2280;OI=1;OV=9.0;CP=61;RM=4096;",
        "v1730ga": "->z3x",
        "z5": "RE=2019.07;SZ=75.2x159.5x8.1;WT=187;DS=6.38;RS=1080x2340;OI=1;OV=9.0;CP=289;RM=6144",
        "v1921a": "->z5",
        "z5x": "RE=2019.05;SZ=77.3x162.4x8.9;WT=204.1;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=62;RM=4096;",
        "v1911a": "->z5x",
        "z5x (2020)": "RE=2020.06;SZ=77.3x162.4x8.9;WT=204.1;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=289;RM=4096;",
        "v1990a": "->z5x (2020)",
        "z6": "RE=2020.02;SZ=75.1x164x9.2;WT=201;DS=6.57;RS=1080x2400;OI=1;OV=10;CP=242;RM=6144;",
        "v1963a": "->z6",
        "y20": "RE=2020.08;SZ=76.3x164.4x8.4;WT=192.3;DS=6.51;RS=720x1600;OI=1;OV=10;CP=244;RM=3072;",
        "v2027": "->y20",
        "v2029": "->y20",
        "v20 se": "RE=2020.09;SZ=74.1x161x7.8;WT=171;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=283;RM=8192;",
        "v2023": "->v20 se",
        "v2022": "->v20 se",
        "v20": "RE=2020.09;SZ=74.2x161.3x7.4;WT=171;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=273;RM=8192;",
        "v2025": "->v20",
        "y20i": "RE=2020.08;SZ=76.3x164.4x8.4;WT=192.3;DS=6.51;RS=720x1600;OI=1;OV=10;CP=244;RM=3072;",
        "v2032": "->y20i",
        "y31": "RE=2021.01;SZ=75.3x163.9x8.4;WT=188;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=285;RM=4096;",
        "y31l": "->y31",
        "y31a": "->y31",
        "v2036": "->y31",
        "y73s": "RE=2020.11;SZ=74x161x7.7;WT=171.7;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=274;RM=8192;",
        "v2031a": "->y73s",
        "x60": "RE=2020.12;SZ=75x159.6x7.4;WT=175.6;DS=6.56;RS=1080x2376;OI=1;OV=11;CP=301;RM=8192;",
        "v2046a": "->x60",
        "y52s": "RE=2020.12;SZ=75.4x164.2x8.4;WT=185.5;DS=6.58;RS=1080x2408;OI=1;OV=10;CP=274;RM=6144;",
        "v2057a": "->y52s",
        "y52": "RE=2021.05;SZ=75.3x164x8.5;WT=193;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=302;RM=4096;",
        "v2053": "->y52",
        "y72 5g": "RE=2021.05;SZ=75.3x164x8.5;WT=193;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=302;RM=8192;",
        "v2041": "->y72 5g",
        "x21i": "RE=2018.05;SZ=75x154.4x7;WT=159;DS=6.28;RS=1080x2280;OI=1;OV=8.1;CP=290;RM=6144;",
        "x21i a": "->x21i",
        "y30g": "RE=2021.03;SZ=76.3x164.4x8.4;WT=191.4;DS=6.51;RS=720x1600;OI=1;OV=11;CP=253;RM=8192;",
        "v2066ba": "->y30g",
        "v2066a": "->y30g",
        "iqoo z3": "RE=2021.03;SZ=75.3x164x8.5;WT=185.5;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=303;RM=6144;",
        "v2073a": "->iqoo z3",
        "x60 pro": "RE=2021.03;SZ=73.2x158.6x7.6;WT=179;DS=6.56;RS=1080x2376;OI=1;OV=11;CP=304;RM=12288;",
        "v2047a": "->x60 pro",
        "v2046": "->x60 pro",
        "x60 pro plus": "RE=2021.01;SZ=73.4x158.6x9.1;WT=191;DS=6.56;RS=1080x2376;OI=1;OV=11;CP=305;RM=8192;",
        "v2056a": "->x60 pro plus",
        "s9 (2021)": "RE=2021.03;SZ=73.9x158.4x7.4;WT=173;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=306;RM=8192;",
        "v2072a": "->s9 (2021)",
        "s9e": "RE=2021.03;SZ=73.9x158.4x7.5;WT=175;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=297;RM=8192;",
        "v2048a": "->s9e",
        "iqoo neo 5": "RE=2021.03;SZ=76.4x163.3x8.4;WT=196;DS=6.62;RS=1080x2400;OI=1;OV=11;CP=304;RM=8192;",
        "v2055a": "->iqoo neo 5",
        "y20s": "RE=2020.10;SZ=76.3x164.4x8.4;WT=192.3;DS=6.51;RS=720x1600;OI=1;OV=10;CP=244;RM=4096;",
        "v2038": "->y20s",
        "y21s": "RE=2021.09;SZ=76.1x164.3x8;WT=182;DS=6.51;RS=720x1600;OI=1;OV=11;CP=334;RM=4096;SM=2;",
        "v2110": "->y21s",
        "y60s": "RE=2021.12;RS=75.3x159.5x7.49;WT=173;DS=6.57;RS=1080x2340;OI=1;OV=10;CP=242;RM=8192;",
        "v2006": "->y60s",
        "v21 5g": "RE=2021.05;SZ=73.9x159.7x7.3;WT=176;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=300;RM=8192;",
        "v2050": "->v21 5g",
        "iqoo 7 5g": "RE=2021.01;SZ=75.8x162.2x8.7;WT=209.5;DS=6.62;RS=1080x2400;OI=1;OV=11;CP=305;RM=8192;",
        "i2012": "->iqoo 7 5g",
        "y20g (2021)": "RE=2021.01;SZ=76.3x164.4x8.4;WT=192.3;DS=6.51;RS=720x1600;OI=1;OV=10;CP=226;RM=4096;",
        "v2065": "->y20g (2021)",
        "y12s (2021)": "RE=2021.05;SZ=76.3x164.4x8.4;WT=191;DS=6.51;RS=720x1600;OI=1;OV=11;CP=41;RM=3072;",
        "v2069": "->y12s (2021)",
        "v2026 21": "->y12s (2021)",
        "y12s": "RE=2020.11;SZ=76.3x164.4x8.4;WT=191;DS=6.51;RS=720x1600;OI=1;OV=10;CP=38;RM=3072;",
        "v2026": "->y12s",
        "v2033": "->y12s",
        "y30 (2021)": "RE=2021.01;SZ=75.3x163.9x8.4;WT=188;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=285;RM=4096;",
        "v2099a": "->y30 (2021)",
        "iqoo u1x": "RE=2020.10;SZ=76.3x164.4x8.4;WT=192.3;DS=6.51;RS=720x1600;OI=1;OV=10;CP=285;RM=4096;",
        "v2065a": "->iqoo u1x",
        "iqoo u3": "RE=2020.12;SZ=75.4x164.2x8.4;WT=185.5;DS=6.58;RS=1080x2408;OI=1;OV=10;CP=300;RM=6144;",
        "v2061a": "->iqoo u3",
        "iqoo 3 5g": "RE=2020.02;SZ=74.9x158.5x9.2;WT=214.5;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=207;RM=6144;",
        "i1927": "->iqoo 3 5g",
        "i1928": "->iqoo 3 5g",
        "y51s": "RE=2020.07;SZ=76.6x162x8.5;WT=190;DS=6.53;RS=1080x2340;OI=1;OV=10;CP=299;RM=6144;",
        "v2031": "->y51s",
        "y31s": "RE=2021.01;SZ=75.4x164.2x8.4;WT=185.5;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=307;RM=4096;",
        "v2054a": "->y31s",
        "v2068a": "->y31s",
        "v2068": "->y31s",
        "y11s": "RE=2020.10;SZ=76.3x164.4x8.4;WT=191;DS=6.51;RS=720x1600;OI=1;OV=10;CP=244;RM=3072;",
        "v2028": "->y11s",
        "iqoo 7": "RE=2021.01;SZ=75.8x162.2x8.7;WT=209.5;DS=6.62;RS=1080x2400;OI=1;OV=11;CP=305;RM=8192;",
        "v2049a": "->iqoo 7",
        "i2009": "->iqoo 7",
        "x5 pro": "RE=2015.05;SZ=73.5x147.9x6.4;WT=151;DS=5.2;RS=1080x1920;OI=1;OV=5.0;CP=22;RM=2048;",
        "x5pro": "->x5 pro",
        "x5pro l": "->x5 pro",
        "x5pro d": "->x5 pro",
        "nex dual display": "RE=2018.12;SZ=75.3x157.2x8.1;WT=199;DS=6.39;RS=1080x2340;OI=1;OV=9.0;CP=198;RM=10240;",
        "v1821t": "->nex dual display",
        "v1821a": "->nex dual display",
        "x9 plus": "RE=2016.11;SZ=79x162x7.5;WT=199;DS=5.88;RS=1080x1920;OI=1;OV=6.0;CP=196;RM=6144;",
        "x9plus": "->x9 plus",
        "x9plus l": "->x9 plus",
        "x5pro v": "RE=2015.07;SZ=73.45x147.9x6.44;WT=147;DS=5.2;RS=1080x1920;OI=1;OV=5.0;CP=22;RM=2048;",
        "y913": "RE=2014.11;RS=480x854;DS=4.5;CP=17;RM=1024;OI=1;OV=4.4.4;SZ=65.85x130.4x8.6;WT=142;SM=2;",
        "y51l": "DS=5;RS=540x960;SZ=71.7x143.8x7.52;WT=157;RE=2016.01;OI=1;OV=5.0.2;RM=1024;CP=17;SM=2;",
        "u10": "RE=2019.09;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=283;RM=3072;",
        "y67": "RE=2016.11;SZ=75.5x153.8x7.6;WT=154;DS=5.5;RS=720x1280;OI=1;OV=6.0;CP=40;RM=4096;",
        "y67l": "->y67",
        "y67a": "->y67",
        "y12i": "RE=2020.07;SZ=76.8x159.4x8.9;WT=190.5;DS=6.35;RS=720x1544;OI=1;OV=9.0;CP=41;RM=3072;",
        "y23": "DS=4.5;RS=480x854;SZ=66.2x132.5x8.65;WT=141;RE=2014;OI=1;OV=4.4;RM=1024;CP=111;",
        "y23l": "->y23",
        "y27": "DS=4.7;RS=720x1280;SZ=68.1x136.9x6.99;WT=137;RE=2015;OI=1;OV=4.4;RM=1024;CP=17;",
        "y27l": "->y27",
        "y25": "RE=2017.03;SZ=66.4x130.7x9.2;WT=;DS=4.5;RS=480x854;OI=1;OV=5.1;CP=5;RM=1024;",
        "y51 (2015)": "RE=2015.12;SZ=71.7x143.8x7.5;WT=157;DS=5.0;RS=540x960;OI=1;OV=5.0.2;CP=17;RM=2048;",
        "y83": "RE=2018.05;SZ=75.2x155.2x7.7;WT=150;DS=6.22;RS=720x1520;OI=1;OV=8.1;CP=171;RM=4096;",
        "y83a": "->y83",
        "y85": "RE=2018.03;SZ=75.2x155.8x7.9;WT=150;DS=6.26;RS=1080x2280;OI=1;OV=8.1;CP=214;RM=4096;",
        "y85a": "->y85",
        "y37": "RE=2015.08;SZ=77x154x6.8;WT=165;DS=5.5;RS=720x1280;OI=1;OV=5.0;CP=22;RM=2048;",
        "y37a": "->y37",
        "x7": "RE=2016.06;SZ=71.3x147.3x7.2;WT=151;DS=5.2;RS=1080x1920;OI=1;OV=5.1;CP=115;RM=4096;",
        "x7l": "->x7",
        "x6": "RE=2015.11;SZ=73.8x147.9x6.7;WT=135.5;DS=5.2;RS=1080x1920;OI=1;OV=5.1;CP=332;RM=4096;",
        "x6a": "->x6",
        "x6l": "->x6",
        "x6d": "->x6",
        "x9": "RE=2016.11;SZ=74x152.6x7;WT=154;DS=5.5;RS=1080x1920;OI=1;OV=6.1;CP=204;RM=4096;",
        "x9l": "->x9",
        "y66": "RE=2017.03;SZ=75.8x153.6x7.5;WT=157;DS=5.5;RS=720x1280;OI=1;OV=6.1;CP=43;RM=3072;",
        "y66l": "->y66",
        "y75": "RE=2017.12;SZ=72.8x149.3x7.9;WT=142;DS=5.7;RS=720x1440;CP=166;RM=4096;OI=1;OV=7;",
        "y75a": "->y75",
        "y66i": "RE=2017.12;SZ=75.79x153.56x7.49;WT=157;DS=5.5;RS=720x1280;CP=20;RM=3072;OI=1;OV=7;",
        "y66i a": "->y66i",
        "y79": "RE=2017.11;SZ=75.7x155.9x7.7;WT=160;DS=5.99;RS=720x1440;CP=204;RM=4096;OI=1;OV=7;",
        "y79a": "->y79",
        "y12a": "RE=2021.06;SZ=76.3x164.4x8.4;WT=191;DS=6.51;RS=720x1600;OI=1;OV=11;CP=41;RM=3072;",
        "v2102": "->y12a",
        "y33s": "RE=2021.08;SZ=76.1x164.3x8;WT=182;DS=6.58;RS=1080x2408;OI=1;OV=11;CP=226;RM=8192;",
        "v2109": "->y33s",
        "v3 max": "RE=2016.04;SZ=77.1x153.9x7.6;WT=168;DS=5.5;RS=1080x1920;OI=1;OV=5.1;CP=115;RM=4096;",
        "v3max a": "->v3 max",
        "v3max": "->v3 max",
        "v3max l": "->v3 max",
        "x50 lite": "RE=2020.05;SZ=75.2x159.3x8.7;WT=190.2;DS=6.38;RS=1080x2340;OI=1;OV=10;CP=283;RM=8192;",
        "x21 ud": "RE=2018.03;SZ=74.8x154.5x7.4;WT=156.2;DS=6.28;RS=1080x2280;OI=1;OV=8.1;CP=61;RM=6144",
        "x21ud a": "->x21 ud",
        "x21ud": "->x21 ud",
        "iqoo 9": "RE=2022.02;SZ=75.1x159.1x8.6;WT=200;DS=6.56;RS=1080x2376;OI=1;OV=12;CP=305;RM=8192",
        "v2171a": "->iqoo 9",
        "i2017": "->iqoo 9",
        "iqoo 9 pro": "RE=2022.01;SZ=75.2x164.8x8.8;WT=204;DS=6.78;RS=1440x3200;OI=1;OV=12;CP=357;RM=8192",
        "v2172a": "->iqoo 9 pro",
        "i2022": "->iqoo 9 pro",
        "iqoo 9 se": "RE=2022.02;SZ=76.4x163.2x8.4;WT=199;DS=6.62;RS=1080x2400;OI=1;OV=12;CP=305;RM=8192;",
        "i2019": "->iqoo 9 se",
        "v23e 5g": "RE=2021.11;SZ=74.3x160.9x7.4;WT=172;DS=6.44;RS=1080x2400;OI=1;OV=11;CP=356;RM=8192;",
        "v2126": "->v23e 5g",
        "y15a": "RE=2021.11;SZ=75.2x164x8.3;WT=179;DS=6.51;RS=720x1600;OI=1;OV=11;CP=38;RM=4096;",
        "v2134": "->y15a",
        "y15s": "RE=2021.11;SZ=75.2x164x8.3;WT=179;DS=6.51;RS=720x1600;OI=1;OV=11;CP=38;RM=3072;",
        "v2120": "->y15s",
        "v2125": "->y15s",
        "x50e": "RE=2020.09;SZ=75x162.1x8.9;WT=200.4;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=242;RM=8192;",
        "v1930": "->x50e",
        "iqoo u5": "RE=2021.12;SZ=75.8x164x8.3;WT=185;DS=6.58;RS=1080x2408;OI=1;OV=12;CP=358;RM=4096;",
        "v2165a": "->iqoo u5",
        "iqoo z6": "RE=2022.03;SZ=75.8x164x8.3;WT=185;DS=6.58;RS=1080x2408;OI=1;OV=12;CP=358;RM=4096",
        "i2203": "->iqoo z6",
        "i2127": "->iqoo z6",
        "i2202": "->iqoo z6",
        "i2206": "->iqoo z6",
        "iqoo z6 pro": "RE=2022.04;SZ=73.6x159.7x8.5;WT=180;DS=6.44;RS=1080x2404;OI=1;OV=12;CP=359;RM=6144",
        "i2126": "->iqoo z6 pro",
        "x note": "RE=2022.04;SZ=80.3x168.8x8.4;WT=221;DS=7.0;RS=1440x3080;OI=1;OV=12;CP=357;RM=8192;",
        "v2170a": "->x note",
        "x fold": "RE=2022.04;SZ=144.9x162x6.3;WT=311;DS=8.03;RS=1916x2160;OI=1;OV=12;CP=357;RM=12288;",
        "v2178a": "->x fold",
        "v2330": "->x fold 3 pro",
        "v2139": "->y15s",
        "x20plus a": "->x20 plus",
        "v2059a": "->x60",
        "y69a": "->y69",
        "v2031 21": "->y51s",
        "v2036 21": "->y31",
        "v2045": "->x60",
        "v2039": "->y12s (2021)",
        "1920 20": "->v17",
        "i2011": "->iqoo z3",
        "v1937": "->x50 lite",
        "v2029 pk": "->y20",
        "v2047": "->x60 pro plus",
        "v2060": "->y72 5g",
        "v2024": "->y51",
        "v2042": "->y12s",
        "v2048": "->y20 (2021)",
        "1901 19": "->y15",
        "v2154": "->y55",
        "v2117": "->y75",
        "z1pro": "->z1 pro",
        "v9youth": "->v9 youth",
        "v9pro": "->v9 pro",
        "y31s 5g": "->y31s",
        "v2220a": "->iqoo z6",
        "iqoo3": "->iqoo neo 3",
        "v2249": "->y27",
        "v2236a": "->y11",
        "v1936tl": "->iqoo neo 855",
        "v2156fa": "->y76s",
        "iqoo z3 5g": "->iqoo z3",
        "v17 sd665": "->v17",
        "iqoo5": "->iqoo neo 5"
    },
    "mobicel": {
        "r7": "DS=5.7;RS=480x101;SZ=71x146x9.6;WT=167;RE=2020.04;RM=1024;CP=4;OI=1;OV=8.1;SM=2",
        "r7 1": "->r7",
        "hype": "OI=1;OV=8.1;SZ=74.3x153.7x8;WT=164;RE=2019.03;CP=76;DS=5.99;RM=1024;",
        "trendy plus": "DS=5;SZ=73.7x146.3x9.8;RS=480x854;RM=1024;OI=1;OV=7;SM=1;",
        "r7 2": "->r7"
    },
    "vernee": {
        "apollo lite": "DS=5.5;RS=1080x1920;SZ=76.2x152x9.2;WT=175;RE=2016.04;OI=1;OV=6.0.1;RM=4096;CP=291;",
        "apollo x": "DS=5.5;RS=1080x1920;SZ=76.2x152x9.2;WT=175;RE=2017.12;OI=1;OV=7.0;RM=4096;CP=291;SM=2;",
        "m5": "DS=5.2;RS=720x1280;SZ=72.6x147.3x6.9;WT=145;RE=2017.08;OI=1;OV=7.0;RM=4096;CP=40;",
        "mars pro": "DS=5.5;RS=1080x1920;SZ=74x151x7.6;WT=161;RE=2017;OI=1;OV=7.1;RM=6144;CP=292;",
        "thor e": "RE=2017.05;SZ=70.1x144x8.6;WT=149;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=118;RM=3072;",
        "thor plus": "DS=5.5;RS=720x1280;SZ=76.7x153x8.7;WT=189;RE=2017.07;OI=1;OV=7.0;RM=3072;CP=118;",
        "x2": "DS=6;RS=720x1440;SZ=;WT=;RE=2019;OI=1;OV=9.0;RM=3072;CP=293;",
        "x2 euro": "->x2",
        "m7": "RE=2018.03;SZ=156x80x11.2;WT=178;DS=5.8;RS=1080x1920;OI=1;OV=8.0;CP=40;RM=4096;",
        "m7 eea": "->m7",
        "t3 pro": "RE=2018.07;SZ=70.3x147.0x9.8;WT=159;DS=5.5;RS=1440x720;OI=1;OV=8.0;CP=84;RM=3072;"
    },
    "sony": {
        "xperia 5 ii": "RE=2020.09;SZ=68x158x8;WT=163;DS=6.1;RS=1080x2520;OI=1;OV=10;CP=207;RM=8192;",
        "sog02": "->xperia 5 ii",
        "a002so": "->xperia 5 ii",
        "xq-as62": "->xperia 5 ii",
        "xq-as52": "->xperia 5 ii",
        "xq-as72": "->xperia 5 ii",
        "so-52a": "->xperia 5 ii",
        "xperia z5": "RE=2015.09;SZ=72x146x7.3;WT=154;DS=5.2;RS=1080x1920;OI=1;OV=5.1.1;CP=96;RM=3072;",
        "501so": "->xperia z5",
        "e6653": "->xperia z5",
        "so-01h": "->xperia z5",
        "sov32": "->xperia z5",
        "e6603": "->xperia z5",
        "xperia t2 ultra": "RE=2014.01;SZ=83.8x165.2x7.7;WT=171.7;DS=6.0;RS=720x1280;OI=1;OV=4.3;CP=294;RM=1024;",
        "xm50t": "->xperia t2 ultra",
        "d5303": "->xperia t2 ultra",
        "d5306": "->xperia t2 ultra",
        "xm50h": "->xperia t2 ultra",
        "d5316": "->xperia t2 ultra",
        "xperia z ultra": "RE=2013.06;SZ=92.2x179.4x6.5;WT=212;DS=6.4;RS=1080x1920;OI=1;OV=4.2;CP=94;RM=2048;",
        "sonyc6806": "->xperia z ultra",
        "xl39h": "->xperia z ultra",
        "c6806": "->xperia z ultra",
        "c6802": "->xperia z ultra",
        "c6833": "->xperia z ultra",
        "sol24": "->xperia z ultra",
        "c6843": "->xperia z ultra",
        "xperia 1": "RE=2019.02;SZ=72x167x8.2;WT=178;DS=6.5;RS=1644x3840;OI=1;OV=9.0;CP=234;RM=6144;",
        "j8170": "->xperia 1",
        "j9110": "->xperia 1",
        "j8110": "->xperia 1",
        "802so": "->xperia 1",
        "so-03l": "->xperia 1",
        "sov40": "->xperia 1",
        "xperia 10": "RE=2019.02;SZ=68x156x8.4;WT=162;DS=6.0;RS=1080x2520;OI=1;OV=9.0;CP=19;RM=3072;",
        "i3113": "->xperia 10",
        "i3123": "->xperia 10",
        "i4113": "->xperia 10",
        "xperia 10 ii": "RE=2020.02;SZ=69x157x8.2;WT=151;DS=6.0;RS=1080x2520;OI=1;OV=10;CP=283;RM=4096;",
        "a001so": "->xperia 10 ii",
        "xq-au52": "->xperia 10 ii",
        "xq-at52": "->xperia 10 ii",
        "so-41a": "->xperia 10 ii",
        "sov43": "->xperia 10 ii",
        "xq-au42": "->xperia 10 ii",
        "xperia 10 plus": "RE=2019.02;SZ=73x167x8.3;WT=180;DS=6.5;RS=1080x2520;OI=1;OV=9.0;CP=205;RM=4096;",
        "i4293": "->xperia 10 plus",
        "i3223": "->xperia 10 plus",
        "i4213": "->xperia 10 plus",
        "xperia 5": "RE=2019.09;SZ=68x158x8.2;WT=164;DS=6.1;RS=1080x2520;OI=1;OV=9.0;CP=234;RM=6144;",
        "901so": "->xperia 5",
        "sov41": "->xperia 5",
        "j8270": "->xperia 5",
        "so-01m": "->xperia 5",
        "j8210": "->xperia 5",
        "xperia 8": "DS=6;RS=1080x2520;SZ=69x158x8.1;WT=170;RE=2019.10;OI=1;OV=9.0;RM=4096;CP=19;",
        "902so": "->xperia 8",
        "sov42": "->xperia 8",
        "xperia xa": "RE=2016.02;SZ=66.8x143.6x7.9;WT=137.4;DS=5.0;RS=720x1280;OI=1;OV=6.0.1;CP=117;RM=2048;",
        "f3111": "->xperia xa",
        "f3113": "->xperia xa",
        "f3115": "->xperia xa",
        "xperia xa ultra": "RE=2016.05;SZ=79x164x8.4;WT=202;DS=6.0;RS=1080x1920;OI=1;OV=6.0.1;CP=117;RM=3072;",
        "f3213": "->xperia xa ultra",
        "f3211": "->xperia xa ultra",
        "f3215": "->xperia xa ultra",
        "xperia xa1": "RE=2017.02;SZ=67x145x8;WT=143;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=174;RM=3072;",
        "g3116": "->xperia xa1",
        "g3123": "->xperia xa1",
        "xperia xa1 plus": "RE=2017.08;SZ=75x155x8.7;WT=189;DS=5.5;RS=1080x1920;OI=1;OV=7.0;CP=174;RM=3072;",
        "g3423": "->xperia xa1 plus",
        "g3412": "->xperia xa1 plus",
        "g3416": "->xperia xa1 plus",
        "g3421": "->xperia xa1 plus",
        "xperia x performance": "RE=2016.02;SZ=70.4x143.7x8.7;WT=164.4;DS=5.0;RS=1080x1920;OI=1;OV=6.0.1;CP=173;RM=3072;",
        "sov33": "->xperia x performance",
        "so-04h": "->xperia x performance",
        "502so": "->xperia x performance",
        "f8131": "->xperia x performance",
        "xperia xa2": "RE=2018.01;SZ=70x142x9.7;WT=171;DS=5.2;RS=1080x1920;OI=1;OV=8.0;CP=19;RM=3072;",
        "h3133": "->xperia xa2",
        "h3113": "->xperia xa2",
        "h3123": "->xperia xa2",
        "xperia xz": "RE=2016.09;SZ=72x146x8.1;WT=161;DS=5.2;RS=1080x1920;OI=1;OV=6.0.1;CP=173;RM=3072;",
        "f8331": "->xperia xz",
        "601so": "->xperia xz",
        "f8332": "->xperia xz",
        "so-01j": "->xperia xz",
        "sov34": "->xperia xz",
        "xperia xz1": "RE=2017.08;SZ=73.4x148x7.4;WT=155;DS=5.2;RS=1080x1920;OI=1;OV=8.0;CP=25;RM=4096;",
        "701so": "->xperia xz1",
        "sov36": "->xperia xz1",
        "g8342": "->xperia xz1",
        "so-01k": "->xperia xz1",
        "xperia xz1 compact": "RE=2017.08;SZ=65x129x9.3;WT=140;DS=4.6;RS=720x1280;OI=1;OV=8.0;CP=25;RM=4096;",
        "so-02k": "->xperia xz1 compact",
        "g8441": "->xperia xz1 compact",
        "xperia xz2": "RE=2018.02;SZ=72x153x11.1;WT=198;DS=5.7;RS=1080x2160;OI=1;OV=8.0;CP=198;RM=4096;",
        "h8216": "->xperia xz2",
        "h8324": "->xperia xz2",
        "sov37": "->xperia xz2",
        "h8314": "->xperia xz2",
        "h8296": "->xperia xz2",
        "702so": "->xperia xz2",
        "so-03k": "->xperia xz2",
        "h8276": "->xperia xz2",
        "xperia xz premium": "RE=2017.02;SZ=77x156x7.9;WT=195;DS=5.46;RS=3840x2160;OI=1;OV=7.1;CP=25;RM=4096;",
        "g8141": "->xperia xz premium",
        "so-04j": "->xperia xz premium",
        "so-04k": "->xperia xz premium",
        "xperia xa2 ultra": "RE=2018.01;SZ=80x163x9.5;WT=221;DS=6.0;RS=1080x1920;OI=1;OV=8.0;CP=19;RM=4096;",
        "h4213": "->xperia xa2 ultra",
        "h3223": "->xperia xa2 ultra",
        "xperia xa2 plus dual": "RE=2017.07;SZ=75x157x9.6;WT=205;DS=6.0;RS=1080x2160;OI=1;OV=8.0;CP=19;RM=4096;SM=2;",
        "h4413": "->xperia xa2 plus dual",
        "h4493": "->xperia xa2 plus dual",
        "xperia sp": "RE=2013.03;SZ=67.1x130.6x10;WT=155;DS=4.6;RS=720x1280;OI=1;OV=4.1;CP=15;RM=1024;",
        "sonyc5306": "->xperia sp",
        "sonyc5303": "->xperia sp",
        "c5306": "->xperia sp",
        "c5303": "->xperia sp",
        "c5302": "->xperia sp",
        "xperia s": "RE=2012.01;SZ=64x128x10.6;WT=144;DS=4.3;RS=720x1280;OI=1;OV=2.3;CP=202;RM=1024;",
        "lt26i": "->xperia s",
        "sonyericssonlt26i": "->xperia s",
        "sonyericssonlt26i-o": "->xperia s",
        "sonylt26iv": "->xperia s",
        "sonylt26i": "->xperia s",
        "xperia sl": "RE=2012.08;SZ=64x128x10.6;WT=144;DS=4.3;RS=720x1280;OI=1;OV=4.0.4;CP=202;RM=1024;",
        "lt26ii": "->xperia sl",
        "xperia t": "RE=2012.08;SZ=67.3x129.4x9.4;WT=139;DS=4.55;RS=720x1280;OI=1;OV=4.0.4;CP=140;RM=1024;",
        "lt30p": "->xperia t",
        "sonylt30p": "->xperia t",
        "sonylt30p-o": "->xperia t",
        "xperia t lte": "RE=2012.10;SZ=67.3x129.4x9.4;WT=148;DS=4.55;RS=720x1280;OI=1;OV=4.0.4;CP=14;RM=1024;",
        "sonylt30a": "->xperia t lte",
        "lt30a": "->xperia t lte",
        "xperia t2 ultra dual": "RE=2014.01;SZ=83.8x165.2x7.7;WT=171.8;DS=6.0;RS=720x1280;OI=1;OV=4.3;CP=78;RM=1024;SM=2;",
        "d5322": "->xperia t2 ultra dual",
        "xperia m": "RE=2013.06;SZ=62x124x9.3;WT=115;DS=4.0;RS=480x854;OI=1;OV=4.1;CP=295;RM=1024;",
        "sonyc1905": "->xperia m",
        "sonyc1904": "->xperia m",
        "c1905": "->xperia m",
        "c1904": "->xperia m",
        "xperia xz3": "RE=2018.08;SZ=73x158x9.9;WT=193;DS=6.0;RS=1440x2880;OI=1;OV=9.0;CP=198;RM=4096;",
        "h8416": "->xperia xz3",
        "h9436": "->xperia xz3",
        "h9493": "->xperia xz3",
        "so-01l": "->xperia xz3",
        "801so": "->xperia xz3",
        "sov39": "->xperia xz3",
        "xperia z1": "RE=2013.09;SZ=74x144x8.5;WT=170;DS=5.0;RS=1080x1920;OI=1;OV=4.2;CP=94;RM=2048;",
        "sonyc6903": "->xperia z1",
        "c6903": "->xperia z1",
        "so-01f": "->xperia z1",
        "c6906": "->xperia z1",
        "sonyc6906": "->xperia z1",
        "l39h": "->xperia z1",
        "c6916": "->xperia z1",
        "sonyso-02f": "->xperia z1",
        "c6902": "->xperia z1",
        "c6943": "->xperia z1",
        "so-02f": "->xperia z1",
        "sol23": "->xperia z1",
        "xperia z3": "RE=2014.09;SZ=72x146x7.3;WT=152;DS=5.2;RS=1080x1920;OI=1;OV=4.4.4;CP=243;RM=3072;",
        "d6653": "->xperia z3",
        "d6603": "->xperia z3",
        "so-01g": "->xperia z3",
        "sol26": "->xperia z3",
        "401so": "->xperia z3",
        "d6616": "->xperia z3",
        "d6646": "->xperia z3",
        "d6643": "->xperia z3",
        "xperia 1 ii": "RE=2020.02;SZ=71.1x165.1x7.6;WT=181.4;DS=6.5;RS=1644x3840;OI=1;OV=10;CP=207;RM=8192;",
        "xq-at42": "->xperia 1 ii",
        "xq-at51": "->xperia 1 ii",
        "sog01": "->xperia 1 ii",
        "so-51a": "->xperia 1 ii",
        "xperia xzs": "RE=2017.02;SZ=72x146x8.1;WT=161;DS=5.2;RS=1080x1920;OI=1;OV=7.1;CP=173;RM=4096;",
        "g8232": "->xperia xzs",
        "g8231": "->xperia xzs",
        "sov35": "->xperia xzs",
        "so-03j": "->xperia xzs",
        "602so": "->xperia xzs",
        "xperia m2": "RE=2014.02;SZ=71.1x139.7x8.6;WT=148;DS=4.8;RS=540x960;OI=1;OV=4.3;CP=78;RM=1024;",
        "d2305": "->xperia m2",
        "d2306": "->xperia m2",
        "d2303": "->xperia m2",
        "xperia c4": "RE=2015.05;SZ=77.4x150.3x7.9;WT=147;DS=5.5;RS=1080x1920;OI=1;OV=5.0;CP=332;RM=2048;",
        "e5306": "->xperia c4",
        "e5353": "->xperia c4",
        "e5303": "->xperia c4",
        "sonysol23": "->xperia z1",
        "g8188": "->xperia xz premium",
        "xq-as42": "->xperia 5 ii",
        "so51aa": "->xperia 1 ii",
        "g8341": "->xperia xz1",
        "i3213": "->xperia 10 plus",
        "sov42-u": "->xperia 8",
        "g8142": "->xperia xz premium",
        "h3213": "->xperia xa2 ultra",
        "g3112": "->xperia xa1",
        "h4233": "->xperia xa2 ultra",
        "g3121": "->xperia xa1",
        "xq-au51": "->xperia 10 ii",
        "xq-at72": "->xperia 1 ii"
    },
    "gionee": {
        "f103 pro": "RE=2016.09;SZ=70.5x145.3x8.5;WT=143;DS=5;RS=720x1280;OI=1;OV=6.0;RM=3072;",
        "s11 lite": "RE=2017.11;SZ=72.6x153.8x7.9;WT=141;DS=5.7;RS=720x1440;OI=1;OV=7.1;CP=43;RM=4096;",
        "f205": "RE=2018.01;SZ=70.7x148.4x8;WT=135.6;DS=5.45;RS=720x1440;OI=1;OV=7.1;CP=8;RM=2048;",
        "f9": "DS=5.71;RS=720x1520;SZ=70.9x147.3x8.9;WT=158;RE=2019.09;OI=1;OV=9.0;RM=3072;CP=109;"
    },
    "walton": {
        "primo c1": "RS=320x480;DS=3.5;RM=512;OI=1;OV=2.3;SZ=61x116x12;WT=112.17;RE=2013.04;SM=2;",
        "primo d2": "RE=2013.09;SZ=63x118.63x12.35;WT=107;DS=3.5;RS=320x480;OI=1;OV=4.2.2;RM=256;SM=2;",
        "primo d8": "DS=4;RS=480x800;SZ=66x128x11;WT=120;RE=2016;OI=1;OV=6.0;RM=512;CP=5;",
        "primo e8": "DS=4.5;RS=480x854;SZ=68.2x133.5x10.4;WT=132;RE=2016;OI=1;OV=6.0;RM=512;CP=287;",
        "primo f7": "DS=5;RS=480x854;SZ=73.7x146.3x9.8;WT=120;RE=2016;OI=1;OV=6.0;RM=1024;CP=58;",
        "primo g6": "RE=2015.10;WT=135;SZ=64.7x131.4x8.0;OI=1;OV=5.1;RM=1024;DS=4.5;RS=480x854;",
        "primo g7": "DS=5.5;RS=720x1280;SZ=80x152x10.5;WT=190;RE=2017;OI=1;OV=7.0;RM=1024;CP=5;",
        "primo h4": "DS=5;RS=720x1280;SZ=71x143x8;WT=136;RE=2015;OI=1;OV=5.1;RM=1024;CP=5;",
        "primo h6": "DS=5;RS=720x1280;SZ=71.2x143.2x8.4;WT=141;RE=2016;OI=1;OV=6.0;RM=2048;CP=56;",
        "primo hm": "DS=5;RS=480x854;SZ=72x144x10.5;WT=193;RE=2014;OI=1;OV=4.2.2;RM=1024;CP=7;",
        "primo r4": "DS=5;RS=720x1280;SZ=70.3x143x7.9;WT=136;RE=2016;OI=1;OV=5.0;RM=2048;CP=79;",
        "primo r6": "RE=2019.09;SM=2;WT=164;DS=6.1;SZ=73.5x155.6x8.85;RS=720x1520;OI=1;OV=9;RM=3072;CP=109;",
        "primo e10 plus": "DS=5;RM=1024;OI=1;OV=8.1;RE=2019;SZ=74.2x145x10;WT=156;RS=480x854;CP=;SM=2;",
        "nexg n73": "DS=5.48;DP=320;RS=720x1600;RM=3937;OI=1;OV=13;",
        "primo f7s": "DS=4.08;DP=240;RS=480x854;RM=1011;OI=1;OV=7;",
        "primo hm7": "DS=6.27;DP=280;RS=720x1600;RM=2604;OI=1;OV=11;",
        "nexg n71": "DS=5.52;DP=320;RS=720x1612;RM=3937;OI=1;OV=13;",
        "primo x4": "DS=4.59;DP=480;RS=1080x1920;RM=3996;OI=1;OV=6;",
        "primo g8i": "DS=4.47;DP=240;RS=480x960;RM=2010;OI=1;OV=8.1;",
        "primo nf4 2gb": "DS=4.47;DP=240;RS=480x960;RM=2002;GP=4;OI=1;OV=9;",
        "primo walpad 8g v2": "DS=7.19;DP=210;RS=1280x800;RM=4018;GP=76;OI=1;OV=11;",
        "primo hm5": "DS=5.37;DP=320;RS=720x1560;RM=2960;GP=76;OI=1;OV=10;",
        "primo r6 max": "DS=5.26;DP=320;RS=720x1520;RM=2961;GP=55;OI=1;OV=9;",
        "primo_r6_max": ">-primo r6 max",
        "orbit y70": "DS=6.31;DP=280;RS=720x1612;RM=2994;GP=55;OI=1;OV=13;",
        "primo walpad 8g": "DS=9.43;DP=160;RS=1280x800;RM=4029;GP=76;OI=1;OV=11;",
        "walpad_8g": ">-primo walpad 8g",
        "primo nx6": "DS=5.6;DP=480;RS=1080x2460;RM=3928;OI=1;OV=11;",
        "primo nx4 mini": "DS=4.59;DP=320;RS=720x1280;RM=3064;OI=1;OV=6;",
        "primo nh4": "DS=4.47;DP=240;RS=480x960;RM=1003;OI=1;OV=8.1;",
        "primo_nh4": ">-primo nh4",
        "primo x4 pro": "DS=4.59;DP=480;RS=1080x1920;RM=4010;OI=1;OV=6;",
        "primo r4 plus": "DS=4.59;DP=320;RS=720x1280;RM=3078;OI=1;OV=5.1;",
        "primo gm2 plus": "DS=4.59;DP=320;RS=720x1280;RM=2069;OI=1;OV=7;",
        "primo e12": "DS=4.08;DP=240;RS=480x854;RM=933;OI=1;OV=10;",
        "primo nf4": "DS=4.47;DP=240;RS=480x960;RM=925;GP=4;OI=1;OV=8.1;",
        "primo s6 dual": "DS=5.03;DP=320;RS=720x1440;RM=3015;GP=4;OI=1;OV=8.1;",
        "primo nh3i": "DS=4.59;DP=320;RS=720x1280;RM=1004;OI=1;OV=7;",
        "primo s7": "DS=6.01;DP=280;RS=720x1520;RM=3962;GP=25;OI=1;OV=9;",
        "primo e8s": "DS=4.08;DP=240;RS=480x854;RM=970;OI=1;OV=7;",
        "primo g9": "DS=5.03;DP=320;RS=720x1440;RM=1908;GP=55;OI=1;OV=9;",
        "rx7 mini": "DS=5.26;DP=320;RS=720x1520;RM=2890;OI=1;OV=9;",
        "primo gh8": "DS=5.19;DP=320;RS=720x1498;RM=1908;GP=55;OI=1;OV=9;",
        "primo_gh8": ">-primo gh8",
        "primo f9": "DS=4.47;DP=240;RS=480x960;RM=935;GP=4;OI=1;OV=9;",
        "primo e10": "DS=4.08;DP=240;RS=480x854;RM=473;OI=1;OV=8.1;",
        "primo h7s": "DS=5.03;DP=320;RS=720x1440;RM=1945;GP=4;OI=1;OV=8.1;",
        "primo_h7s": ">-primo h7s",
        "primo e9": "DS=4.08;DP=240;RS=480x854;RM=1005;OI=1;OV=8.1;",
        "primo_e9": ">-primo e9",
        "nexg n8": "DS=5.6;DP=480;RS=1080x2460;RM=6040;OI=1;OV=13;",
        "primo gf6": "DS=4.08;DP=240;RS=480x854;RM=1011;OI=1;OV=7;",
        "primo_gf6": ">-primo gf6",
        "primo h8 pro": "DS=5.26;DP=320;RS=720x1520;RM=2961;GP=55;OI=1;OV=9;",
        "primo ef10": "DS=5.03;DP=320;RS=720x1440;RM=917;GP=55;OI=1;OV=11;",
        "primo rx8 mini": "DS=5.37;DP=480;RS=1080x2340;RM=3853;GP=38;OI=1;OV=10;",
        "nexg n72": "DS=6.27;DP=280;RS=720x1600;RM=3937;OI=1;OV=13;",
        "primo walpad 10h pro": "DS=9.72;DP=240;RS=1200x2000;RM=8117;OI=1;OV=13;",
        "primo rm4": "DS=5.48;DP=320;RS=720x1600;RM=4024;GP=76;OI=1;OV=10;",
        "primo gh10": "DS=5.48;DP=320;RS=720x1600;RM=1980;GP=55;OI=1;OV=11;",
        "primo rx9": "DS=5.48;DP=320;RS=720x1600;RM=3973;GP=25;OI=1;OV=11;",
        "primo_rx9": ">-primo rx9",
        "primo f8s": "DS=4.47;DP=240;RS=480x960;RM=993;OI=1;OV=8.1;",
        "orbit y20": "DS=5.48;DP=320;RS=720x1600;RM=1982;GP=55;OI=1;OV=11;",
        "primo s6 infinity": "DS=5.03;DP=320;RS=720x1440;RM=3008;OI=1;OV=8;",
        "primo_s6_infinity": ">-primo s6 infinity",
        "primo g8i 4g": "DS=4.47;DP=240;RS=480x960;RM=1886;OI=1;OV=8.1;",
        "primo h9": "DS=5.37;DP=320;RS=720x1560;RM=1908;GP=55;OI=1;OV=9;",
        "primo ef8 4g": "DS=4.47;DP=240;RS=480x960;RM=960;OI=1;OV=8.1;",
        "primo rm3": "DS=4.59;DP=320;RS=720x1280;RM=3064;OI=1;OV=6;",
        "primo nh5": "DS=4.47;DP=240;RS=480x960;RM=934;GP=4;OI=1;OV=8.1;",
        "lt750": "DS=4.59;DP=320;RS=720x1280;RM=3078;OI=1;OV=5.1;",
        "primo zx3": "DS=4.59;DP=480;RS=1080x1920;RM=4021;OI=1;OV=7;",
        "primo nh3 lite": "DS=4.59;DP=320;RS=720x1280;RM=1004;OI=1;OV=7;",
        "primo gh7": "DS=4.47;DP=240;RS=480x960;RM=1010;OI=1;OV=7;",
        "primo h9 pro": "DS=5.37;DP=320;RS=720x1560;RM=4017;GP=76;OI=1;OV=10;",
        "primo f10": "DS=4.47;DP=240;RS=480x960;RM=1999;OI=1;OV=10;",
        "primo s8": "DS=5.6;DP=480;RS=1080x2460;RM=6036;OI=1;OV=11;",
        "primo gm3 plus": "DS=4.47;DP=240;RS=480x960;RM=1953;GP=4;OI=1;OV=8.1;",
        "primo_gm3_plus": ">-primo gm3 plus",
        "primo ef9": "DS=4.47;DP=240;RS=480x960;RM=1003;OI=1;OV=8.1;",
        "orbit y12": "DS=5.52;DP=320;RS=720x1612;RM=1985;GP=55;OI=1;OV=13;",
        "primo s6": "DS=4.59;DP=320;RS=720x1280;RM=2980;OI=1;OV=7;",
        "primo gm2": "DS=4.59;DP=320;RS=720x1280;RM=1004;OI=1;OV=7;",
        "primo em2": "DS=4.47;DP=240;RS=480x960;RM=1004;OI=1;OV=8.1;",
        "primo gf7": "DS=4.47;DP=240;RS=480x960;RM=915;OI=1;OV=8.1;",
        "primo r5": "DS=5.03;DP=320;RS=720x1440;RM=1948;GP=4;OI=1;OV=8.1;",
        "primo walpad 10h": "DS=9.43;DP=240;RS=1200x1920;RM=3956;OI=1;OV=11;",
        "primo nf3": "DS=4.59;DP=320;RS=720x1280;RM=1004;OI=1;OV=7;",
        "primo_nf3": ">-primo nf3",
        "primo r8": "DS=5.48;DP=320;RS=720x1600;RM=4017;GP=25;OI=1;OV=10;",
        "primo_r8": ">-primo r8",
        "primo n5": "DS=5.6;DP=320;RS=720x1640;RM=4021;GP=25;OI=1;OV=11;",
        "primo_n5": ">-primo n5",
        "primo r9": "DS=5.48;DP=320;RS=720x1600;RM=2921;GP=25;OI=1;OV=11;",
        "primo_r9": ">-primo r9",
        "primo nh3": "DS=4.59;DP=320;RS=720x1280;RM=2069;OI=1;OV=7;",
        "primo_nh3": ">-primo nh3",
        "primo zx4": "DS=5.48;DP=480;RS=1080x2400;RM=8079;OI=1;OV=11;",
        "primo_zx4": ">-primo zx4",
        "primo r5 plus": "DS=5.03;DP=320;RS=720x1440;RM=3014;GP=4;OI=1;OV=8.1;",
        "xanon x20": "DS=5.6;DP=480;RS=1080x2460;RM=8122;OI=1;OV=13;",
        "primo hm6": "DS=5.48;DP=320;RS=720x1600;RM=1956;GP=55;OI=1;OV=10;",
        "primo_hm6": ">-primo hm6",
        "primo x5": "DS=5.03;DP=480;RS=1080x2160;RM=6128;OI=1;OV=8.1;",
        "walton primo x5": ">-primo x5",
        "primo rm2 mini": "DS=4.59;DP=320;RS=720x1280;RM=2072;OI=1;OV=5.1;",
        "primo nf5": "DS=5.6;DP=320;RS=720x1640;RM=2992;GP=76;OI=1;OV=10;",
        "primo_nf5": ">-primo nf5",
        "primo h6 plus": "DS=4.59;DP=320;RS=720x1280;RM=3076;OI=1;OV=7;",
        "primo_h6_plus": ">-primo h6 plus",
        "primo gh7i": "DS=4.47;DP=240;RS=480x960;RM=993;OI=1;OV=8.1;",
        "primo_gh7i": ">-primo gh7i",
        "primo gm4": "DS=5.37;DP=320;RS=720x1560;RM=1955;GP=55;OI=1;OV=10;",
        "primo_gm4": ">-primo gm4",
        "primo hm4": "DS=4.59;DP=320;RS=720x1280;RM=1002;OI=1;OV=7;",
        "primo_hm4": ">-primo hm4",
        "primo rx7": "DS=5.37;DP=480;RS=1080x2340;RM=4028;OI=1;OV=9;",
        "primo_rx7": ">-primo rx7",
        "primo hm4 plus": "DS=4.59;DP=320;RS=720x1280;RM=2067;OI=1;OV=7;",
        "primo_hm4_plus": ">-primo hm4 plus",
        "primo rx8": "DS=5.48;DP=320;RS=720x1600;RM=4008;GP=25;OI=1;OV=10;",
        "primo_rx8": ">-primo rx8",
        "orbit m20": "DS=5.48;DP=320;RS=720x1600;RM=3965;GP=55;OI=1;OV=11;",
        "primo rx6": "DS=5.03;DP=320;RS=720x1440;RM=3025;OI=1;OV=8.1;",
        "primo_rx6": ">-primo rx6",
        "primo s7 pro": "DS=5.37;DP=480;RS=1080x2340;RM=6017;OI=1;OV=9;",
        "primo e11": "DS=4.08;DP=240;RS=480x854;RM=937;GP=4;OI=1;OV=9;",
        "primo_e11": ">-primo e11",
        "primo n4": "DS=5.48;DP=320;RS=720x1600;RM=2974;OI=1;OV=9;",
        "primo walpad 10p": "DS=6.29;DP=360;RS=1200x1920;RM=6031;OI=1;OV=10;",
        "walpad 10p": ">-primo walpad 10p",
        "primo gh9": "DS=5.37;DP=320;RS=720x1560;RM=1926;GP=76;OI=1;OV=10;",
        "primo_gh9": ">-primo gh9",
        "primo gm3": "DS=4.47;DP=240;RS=480x960;RM=910;GP=4;OI=1;OV=8.1;",
        "nexg n74": "DS=3.66;DP=480;RS=720x1600;RM=3926;OI=1;OV=14;",
        "nexg n26": "DS=3.68;DP=480;RS=720x1612;RM=3926;OI=1;OV=14;",
        "primo d10": "DS=4.47;DP=240;RS=480x960;RM=1004;OI=1;OV=10;",
        "nexg n71 plus": "DS=6.31;DP=280;RS=720x1612;RM=3937;GP=76;OI=1;OV=13;",
        "primo s5": "DS=4.59;DP=320;RS=720x1280;RM=3063;OI=1;OV=6;",
        "primo h10": "DS=5.48;DP=320;RS=720x1600;RM=2921;GP=25;OI=1;OV=11;",
        "primo d9": "DS=3.89;DP=240;RS=480x800;RM=472;OI=1;OV=8.1;",
        "walpad8g": "->primo walpad 8g",
        "walpad 8g": "->primo walpad 8g"
    },
    "krip": {
        "k55": "DS=5.03;DP=320;RS=720x1440;RM=1966;GP=4;OI=1;OV=8.1;",
        "k700a": "DS=4.47;DP=240;RS=480x960;RM=1000;OI=1;OV=8.1;",
        "k4": "DS=3.89;DP=240;RS=480x800;RM=990;OI=1;OV=8.1;"
    },
    "hafury": {
        "mix": "DS=4.59;DP=320;RS=720x1280;RM=2069;OI=1;OV=7;"
    },
    "purism": null,
    "wileyfox": {
        "spark": "DS=5;RS=720x1280;SZ=70.4x143x8.65;WT=134;RE=2016;OI=1;OV=6.0.1;RM=1024;CP=308;",
        "spark +": "DS=5;RS=720x1280;SZ=70.4x143x8.65;WT=134;RE=2016;OI=1;OV=6.0;RM=2048;CP=308;",
        "spark x": "DS=5.5;RS=720x1280;SZ=78.6x154.35x8.75;WT=162;RE=2016;OI=1;OV=6.0;RM=2048;CP=79;",
        "storm": "DS=5.5;RS=1080x1920;SZ=77.3x155.6x9.2;WT=155;RE=2015;OI=1;OV=5.1.1;RM=3072;CP=22;",
        "swift": "DS=5;RS=720x1280;SZ=71x141.15x9.37;WT=135;RE=2015;OI=1;OV=5.1.1;RM=2048;CP=17;",
        "swift 2": "DS=5;RS=720x1280;SZ=71.9x143.7x8.64;WT=158;RE=2016;OI=1;OV=6.0.1;RM=2048;CP=43;",
        "swift 2 plus": "DS=5;RS=720x1280;SZ=71.9x143.7x8.64;WT=158;RE=2016;OI=1;OV=6.0.1;RM=3072;CP=43;",
        "swift 2 x": "DS=5.2;RS=1080x1920;SZ=72.2x144x8.8;WT=155;RE=2017;OI=1;OV=6.0.1;RM=3072;CP=43;",
        "pro": "DS=5;RS=720x1280;SZ=72.5x147x8.2;WT=;RE=2017;OS=Windows 10 Mobile;RM=2048;CP=10;",
        "crackling": "->swift"
    },
    "weimei": {
        "weplus 3": "DS=6;RS=720x1440;SZ=76.6x160x8.2;WT=188;RE=2018.01;CP=292;RM=4096;OI=1;OV=7;"
    },
    "wink": {
        "city s": "DS=5;RS=540x960;SZ=74x144x8.5;WT=139;RE=2015.05;RM=1024;CP=5;OI=1;OV=5.1;",
        "city se": "DS=4.5;RS=480x854;SZ=67.0x136.0x9.5;WT=130;RM=1024;CP=4;OI=1;OV=6;",
        "glory": "DS=5;CP=36;RM=1024;RS=480x854;WT=135;SZ=72x144x8;SM=2;OI=1;OV=4.4.3;",
        "world se": "SZ=64x124x10.9;DS=4;RS=480x800;WT=129;OI=1;OV=5;RM=512;CP=7;SM=2;"
    },
    "nuu mobile": {
        "a1": "DS=4;RS=480x800;SZ=63x121.4x9.9;WT=;RE=2016;OI=1;OV=5.1;RM=512;CP=5;",
        "a3": "DS=5;RS=480x854;SZ=71.6x143.76x9.9;WT=;RE=2016;OI=1;OV=6.0;RM=1024;CP=5;",
        "g2": "DS=5.99;RS=1080x2160;SZ=73.6x158.5x8.55;WT=;RE=2018;OI=1;OV=8.0;RM=4096;CP=40;",
        "s6001l": "->g2",
        "g3": "DS=5.7;RS=720x1440;SZ=70x153x9;WT=;RE=2018;OI=1;OV=7.1;RM=4096;CP=309;",
        "n5702l": "->g3",
        "m3": "DS=5.5;RS=720x1280;SZ=77.5x151.6x7.9;WT=;RE=2017;OI=1;OV=7.0;RM=2048;CP=86;",
        "n5001l": "DS=5;RS=720x1280;SZ=71.1x142.2x7.9;WT=152;RE=2016;OI=1;OV=5.1 Lollipop;RM=1024;CP=56;",
        "x5": "DS=5.5;RS=1080x1920;SZ=76.45x152.9x7.87;WT=;RE=2017;OI=1;OV=7.0;RM=3072;CP=162;",
        "m2": "DS=5;RS=720x1280;SZ=71.88x143.76x7.37;WT=;RE=2017;OI=1;OV=7.0;RM=2048;CP=86;",
        "m19": "DS=5.5;RS=720x1440;SZ=72x150.3x9.2;WT=165;RE=2020.09;SM=2;OI=1;OV=9.0;RM=3072;CP=8;",
        "s5501l": "->m19",
        "nuu a1": "->a1",
        "nuu a3": "->a3",
        "nuu m3": "->m3",
        "nuu x5": "->x5",
        "nuu m2": "->m2"
    },
    "digifors": {
        "400": "->smart 400",
        "smart 400": "SZ=92x92x18;WT=450;RM=2048;OI=1;OV=7.1;CP=314;"
    },
    "digi": {
        "r1": "DS=5.03;DP=320;RS=720x1440;RM=3014;GP=4;OI=1;OV=8.1;",
        "c1": "DS=4.59;DP=320;RS=720x1280;RM=1949;GP=4;OI=1;OV=8.1;",
        "k1": "DS=5.03;DP=480;RS=1080x2160;RM=6099;OI=1;OV=8.1;",
        "r2": "DS=5.37;DP=320;RS=720x1560;RM=4294;OI=1;OV=9;",
        "k2": "DS=5.37;DP=480;RS=1080x2340;RM=6039;OI=1;OV=9;",
        "c2": "DS=5.37;DP=320;RS=720x1560;RM=3221;GP=76;OI=1;OV=9;"
    },
    "pipo": {
        "p9": "DS=10.1;RS=1920x1200;RM=2048;CP=82;OI=1;OV=4.4;SZ=248x174x10;WT=580;RE=2014.06;",
        "m9 pro": "DS=10.1;RS=1920x1200;RM=2048;CP=80;OI=1;OV=4.2;SZ=248x175x12;WT=580;RE=2013.06;",
        "t9": "DS=8.9;RS=1920x1200;RM=2048;CP=2;OI=1;OV=4.2;SZ=218x161x10;WT=470;RE=2014.06;",
        "x9s": "DS=8.9;RS=1920x1200;RE=2016.07;OI=3;OV=10;SZ=217x147.5x60;WT=630;CP=315;RM=2048;",
        "x10": "DS=10.8;RS=1280x800;RE=2016.04;OI=3;OV=10;SZ=178x118x50;WT=850;CP=189;RM=4096",
        "pipom9pro": "->m9 pro"
    },
    "mivo": {
        "caryota 1": "DS=6;RS=720x1280;RM=2048;RE=2017.06;OI=1;OV=5.1;",
        "caryota 2": "DS=6;RS=720x1280;RM=2048;RE=2017.06;OI=1;OV=5.1;",
        "jazz j1 (2018)": "RM=1024;DS=5;OI=1;OV=6.0;SM=2;RS=360x640;",
        "jazz j1 2018": "->jazz j1 (2018)"
    },
    "realme": {
        "1": "RE=2018.05;SZ=75.2x156.5x7.8;WT=155;DS=6.0;RS=1080x2160;OI=1;OV=8.1;CP=290;RM=3072;",
        "2": "RE=2018.08;SZ=75.6x156.2x8.2;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=3072;",
        "3": "RE=2019.05;SZ=75.6x156.1x8.3;WT=175;DS=6.22;RS=720x1520;OI=1;OV=9.0;CP=290;RM=3072;",
        "5": "RE=2019.08;SZ=75.6x164.4x9.3;WT=198;DS=6.5;RS=720x1600;OI=1;OV=9.0;CP=283;RM=3072;",
        "6": "RE=2020.03;SZ=74.8x162.1x8.9;WT=191;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=325;RM=4096;",
        "7": "RE=2020.09;SZ=75.4x162.3x9.4;WT=196.5;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=321;RM=6144;",
        "8": "RE=2021.03;SZ=73.9x160.6x8;WT=177;DS=6.4;RS=1080x2400;OI=1;OV=11;CP=321;RM=4096;",
        "c30": "RE=2022.06;SZ=75.6x164.1x8.5;WT=182;DS=6.5;RS=720x1600;OI=1;OV=11;CP=366;RM=2048;",
        "rmx3581": "->c30",
        "cph1861": "->1",
        "rmx1809": "->2",
        "rmx1805": "->2",
        "rmx1833": "->3",
        "rmx1821": "->3",
        "rmx1825": "->3",
        "rmx1919": "->5",
        "rmx1911": "->5",
        "rmx1927": "->5",
        "rmx2001": "->6",
        "rmx2151": "->7",
        "rmx2155": "->7",
        "rmx3085": "->8",
        "2 pro": "RE=2018.09;SZ=74x156.7x8.5;WT=174;DS=6.3;RS=1080x2340;OI=1;OV=8.1;CP=61;RM=4096;",
        "rmx1801": "->2 pro",
        "rmx1807": "->2 pro",
        "rmx1803": "->2 pro",
        "3 pro": "RE=2019.04;SZ=74.2x156.8x8.3;WT=172;DS=6.3;RS=1080x2340;OI=1;OV=9.0;CP=62;RM=4096;",
        "rmx1851": "->3 pro",
        "3i": "RE=2019.07;SZ=75.6x156.1x8.3;WT=175;DS=6.2;RS=720x1520;OI=1;OV=9.0;CP=114;RM=3072;",
        "rmx1827": "->3i",
        "5 pro": "RE=2019.08;SZ=74.2x157x8.9;WT=184;DS=6.3;RS=1080x2340;OI=1;OV=9.0;CP=289;RM=4096;",
        "rmx1971": "->5 pro",
        "rmx1973": "->5 pro",
        "5i": "RE=2020.01;SZ=75x164.4x9.3;WT=195;DS=6.52;RS=720x1600;OI=1;OV=9.0;CP=283;RM=3072;",
        "rmx2030": "->5i",
        "rmx2032": "->5i",
        "5s": "RE=2019.11;SZ=75.6x164.4x9.3;WT=198;DS=6.5;RS=720x1600;OI=1;OV=9.0;CP=283;RM=4096;",
        "rmx1925": "->5s",
        "6 pro": "RE=2020.05;SZ=75.8x163.8x8.9;WT=202;DS=6.6;RS=1080x2400;OI=1;OV=10;CP=273;RM=6144;",
        "rmx2063": "->6 pro",
        "rmx2061": "->6 pro",
        "6i": "RE=2020.03;SZ=75.4x164.4x9;WT=199;DS=6.5;RS=720x1600;OI=1;OV=10;CP=226;RM=3072;",
        "rmx2040": "->6i",
        "rmx2042": "->6i",
        "6s": "RE=2020.05;SZ=74.8x162.1x8.9;WT=191;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=325;RM=4096",
        "rmx2002": "->6s",
        "c1": "RE=2018.09;SZ=75.6x156.2x8.2;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=2048;",
        "rmx1811": "->c1",
        "c11": "RE=2020.06;SZ=75.9x164.4x9.1;WT=196;DS=6.5;RS=720x1560;OI=1;OV=10;CP=323;RM=2048;",
        "rmx2185": "->c11",
        "c12": "RE=2020.08;SZ=75.9x164.5x9.8;WT=209;DS=6.5;RS=720x1560;OI=1;OV=10;CP=323;RM=3072;",
        "rmx2189": "->c12",
        "c15": "RE=2020.07;SZ=75.9x164.5x9.8;WT=209;DS=6.5;RS=720x1600;OI=1;OV=10;CP=323;RM=3072;",
        "rmx2180": "->c15",
        "c2": "RE=2019.04;SZ=73.7x154.3x8.5;WT=166;DS=6.1;RS=720x1560;OI=1;OV=9.0;CP=171;RM=2048;",
        "rmx1943": "->c2",
        "rmx1945": "->c2",
        "rmx1941": "->c2",
        "rmx1942": "->c2",
        "c3": "RE=2020.06;SZ=75x164.4x9;WT=195;DS=6.5;RS=720x1600;OI=1;OV=10;CP=319;RM=2048;",
        "rmx2021": "->c3",
        "rmx2020": "->c3",
        "rmx2027": "->c3",
        "u1": "RE=2018.11;SZ=74x157x8;WT=168;DS=6.3;RS=1080x2340;OI=1;OV=8.1;CP=114;RM=3072;",
        "rmx1831": "->u1",
        "v3 5g": "DS=6.5;RS=720x1600;SZ=76x164.4x8.6;WT=189;RE=2020.09;OI=1;OV=10;RM=8192;CP=274",
        "rmx2200": "->v3 5g",
        "rmx2201": "->v3 5g",
        "v5 5g": "RE=2020.11;SZ=75.1x162.2x9.1;WT=195;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=320;RM=6144;",
        "7 5g": "->v5 5g",
        "rmx2111": "->v5 5g",
        "x": "RE=2019.05;SZ=76x161.2x9.4;WT=191;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=62;RM=4096;",
        "rmx1901": "->x",
        "rmx1903": "->x",
        "x2": "RE=2019.09;SZ=75.2x158.7x8.6;WT=182;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=260;RM=4096;",
        "rmx1992": "->x2",
        "rmx1991": "->x2",
        "x2 pro": "RE=2019.10;SZ=75.7x161x8.7;WT=199;DS=6.5;RS=1080x2400;OI=1;OV=9.0;CP=197;RM=6144;",
        "rmx1931": "->x2 pro",
        "x3": "RE=2020.06;SZ=75.8x163.8x8.9;WT=202;DS=6.6;RS=1080x2400;OI=1;OV=10;CP=197;RM=6144;",
        "rmx2142": "->x3",
        "rmx2081": "->x3",
        "x3 super zoom": "RE=2020.05;SZ=75.8x163.8x8.9;WT=202;DS=6.6;RS=1080x2400;OI=1;OV=10;CP=197;RM=8192;",
        "rmx2086": "->x3 super zoom",
        "x50 5g": "RE=2020.01;SZ=75.8x163.8x8.9;WT=202;DS=6.57;RS=1080x2400;OI=1;OV=10;CP=242;RM=6144;",
        "rmx2025": "->x50 5g",
        "rmx2051": "->x50 5g",
        "x50 pro": "RE=2020.02;SZ=74.2x159x8.9;WT=205;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=141;RM=6144;",
        "rmx2071": "->x50 pro",
        "x50 pro player": "RE=2020.05;SZ=74.2x159x8.9;WT=209;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=207;RM=6144;",
        "rmx2072": "->x50 pro player",
        "x7 5g": "RE=2020.09;SZ=74.4x160.9x8.1;WT=175;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=300;RM=6144;",
        "rmx2176": "->x7 5g",
        "x7 pro 5g": "RE=2020.09;SZ=75.1x160.8x8.5;WT=184;DS=6.55;RS=1080x2400;OI=1;OV=10;CP=296;RM=6144",
        "rmx2121": "->x7 pro 5g",
        "xt": "RE=2019.09;SZ=75.2x158.7x8.6;WT=183;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=289;RM=4096;",
        "rmx1921": "->xt",
        "x50 pro 5g": "DS=6.44;RS=1080x2400;SZ=;WT=;RE=2020.05;OI=1;OV=10;RM=6144;CP=207;",
        "rmx2076": "->x50 pro 5g",
        "rmx2075": "->x50 pro 5g",
        "7 pro": "RE=2020.09;SZ=74.3x160.9x8.7;WT=182;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=273;RM=6144;",
        "rmx2170": "->7 pro",
        "rmx2085": "->x3 super zoom",
        "c21": "RE=2021.03;SZ=76.4x165.2x8.9;WT=190;DS=6.5;RS=720x1600;OI=1;OV=10;CP=323;RM=3072;",
        "rmx3201": "->c21",
        "7i": "RE=2020.12;SZ=75.9x164.5x9.8;WT=208;DS=6.5;RS=720x1600;OI=1;OV=10;CP=322;RM=4096;",
        "rmx2103": "->7i",
        "c20": "RE=2021.01;SZ=76.4x165.2x8.9;WT=190;DS=6.5;RS=720x1600;OI=1;OV=10;CP=323;RM=2048;",
        "rmx3063": "->c20",
        "narzo 20 pro": "RE=2020.09;SZ=75.4x162.3x9.4;WT=191;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=321;RM=6144;",
        "rmx2161": "->narzo 20 pro",
        "rmx2163": "->narzo 20 pro",
        "gt neo": "RE=2021.03;SZ=73.3x158.5x8.4;WT=179;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=324;RM=6144;",
        "rmx3031": "->gt neo",
        "8 pro": "RE=2021.03;SZ=73.9x160.6x8.1;WT=176;DS=6.4;RS=1080x2400;OI=1;OV=11;CP=273;RM=6144;",
        "rmx3081": "->8 pro",
        "q2 5g": "RE=2020.10;SZ=75.1x162.2x9.1;WT=194;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=320;RM=4096;",
        "rmx2117": "->q2 5g",
        "c15 qualcomm edition": "RE=2020.10;SZ=75.9x164.5x9.8;WT=209;DS=6.5;RS=720x1600;OI=1;OV=10;CP=244;RM=3072;",
        "rmx2195": "->c15 qualcomm edition",
        "narzo 20": "RE=2020.09;SZ=75.9x164.5x9.8;WT=208;DS=6.5;RS=720x1600;OI=1;OV=10;CP=322;RM=4096;",
        "rmx2193": "->narzo 20",
        "c17": "RE=2020.09;SZ=75.5x164.1x8.9;WT=188;DS=6.5;RS=720x1600;OI=1;OV=10;CP=244;RM=4096;",
        "rmx2101": "->c17",
        "narzo 20a": "RE=2020.09;SZ=75.4x164.4x8.9;WT=195;DS=6.5;RS=720x1600;OI=1;OV=10;CP=283;RM=3072;",
        "rmx2050": "->narzo 20a",
        "rmx2144": "->x50 5g",
        "q2 pro": "RE=2020.10;SZ=74.4x160.9x8.1;WT=175;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=320;RM=8192;",
        "rmx2173": "->q2 pro",
        "v15 5g": "RE=2021.01;SZ=74.4x160.9x8.1;WT=176;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=320;RM=6144;",
        "rmx3092": "->v15 5g",
        "v11 5g": "RE=2021.02;SZ=;WT=186;DS=6.5;RS=720x1600;OI=1;OV=11;CP=302;RM=4096;",
        "rmx3121": "->v11 5g",
        "v13 5g": "RE=2021.03;SZ=74.8x162.5x8.5;WT=185;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=302;RM=8192;",
        "rmx3041": "->v13 5g",
        "rmx3093": "->v15 5g",
        "gt 5g": "RE=2021.03;SZ=73.3x158.5x8.4;WT=186;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=305;RM=8192;",
        "rmx2202": "->gt 5g",
        "c11 (2021)": "RE=2021.06;SZ=76.4x165.2x8.9;WT=190;DS=6.52;RS=720x1600;OI=1;OV=11;CP=109;RM=2048;",
        "rmx3231": "->c11 (2021)",
        "c25": "RE=2021.03;SZ=75.9x164.5x9.6;WT=209;DS=6.5;RS=720x1600;OI=1;OV=11;CP=319;RM=4096;",
        "rmx3191": "->c25",
        "c21y": "RE=2021.06;SZ=76x164.5x9.1;WT=200;DS=6.5;RS=720x1600;OI=1;OV=10;CP=318;RM=3072;",
        "rmx3261": "->c21y",
        "8 5g": "RE=2021.04;SZ=74.8x162.5x8.5;WT=185;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=302;RM=4096;",
        "rmx3241": "->8 5g",
        "narzo 30 5g": "RE=2021.05;SZ=74.8x162.5x8.5;WT=185;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=302;RM=4096;",
        "rmx3242": "->narzo 30 5g",
        "gt neo flash": "RE=2021.05;SZ=73.3x158.5x8.4;WT=179;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=324;RM=8192;",
        "rmx3350": "->gt neo flash",
        "x7 pro extreme edition": "DS=6.55;RS=1080x2400;SZ=73.4x159.9x7.8;WT=170;RE=2021;OI=1;OV=11;RM=8192;CP=296;",
        "rmx3115": "->x7 pro extreme edition",
        "q3 pro 5g": "RE=2021.04;SZ=73.3x158.5x8.4;WT=179;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=326;RM=6144;",
        "rmx2205": "->q3 pro 5g",
        "narzo 30a": "RE=2021.02;SZ=75.9x164.5x9.8;WT=205;DS=6.5;RS=720x1600;OI=1;OV=10;CP=322;RM=3072;",
        "rmx3171": "->narzo 30a",
        "c25s": "RE=2021.06;SZ=75.9x164.5x9.6;WT=209;DS=6.5;RS=720x1600;OI=1;OV=11;CP=322;RM=4096;",
        "rmx3195": "->c25s",
        "narzo 50": "RE=2022.02;SZ=75.5x164.1x8.5;WT=194;DS=6.6;RS=1080x2412;OI=1;OV=11;CP=350;RM=4096;",
        "rmx3286": "->narzo 50",
        "rmx3193": "->c25",
        "rmx2194": "->c15 qualcomm edition",
        "rmx1853": "->3 pro",
        "rmx3122": "->v11 5g",
        "rmx3203": "->c21",
        "rmx3263": "->c21y",
        "rmx2022": "->c3",
        "rmx3042": "->v13 5g",
        "rmx3061": "->c20",
        "rmx1822": "->3",
        "rmx1929": "->5s",
        "rmx2003": "->6",
        "rmx2112": "->v5 5g",
        "rmx3043": "->v13 5g",
        "rmx2083": "->x3",
        "rmx3262": "->c21y",
        "rmx3197": "->c25s",
        "g70 series": "->c3",
        "rmx2063l1": "->6 pro",
        "rmx3623": "->c30",
        "c25 series": "->c25",
        "rmx2183": "->c15"
    },
    "sharp": {
        "aquos s3 mini": "RE=2018.03;SZ=73x142.7x7.8;WT=140;DS=5.5;RS=1080x2040;OI=1;OV=7.1.1;CP=19;RM=6144;",
        "fs8018": "->aquos s3 mini",
        "aquos zero 6": "RE=2021.10;SZ=73x158x7.9;WT=146;DS=6.4;RS=1080x2340;OI=1;OV=11;CP=275;RM=8192;",
        "shg04": "->aquos zero 6",
        "a102sh": "->aquos zero 6",
        "sh-rm18": "->aquos zero 6",
        "aquos zero6": "->aquos zero 6"
    },
    "lg": {
        "v30": "RE=2017.08;SZ=75.4x151.7x7.3;WT=158;DS=6.0;RS=1440x2880;OI=1;OV=7.1.2;CP=25;RM=4096;",
        "lg-h933": "->v30",
        "lg-h932pr": "->v30",
        "lg-ls998": "->v30",
        "lg-us998": "->v30",
        "lg-as998": "->v30",
        "lg-h930": "->v30",
        "lg-h931": "->v30",
        "lg-h932": "->v30",
        "lgm-v300k": "->v30",
        "lgm-v300l": "->v30",
        "lgm-v300s": "->v30",
        "lg-h930re": "->v30",
        "v30 plus": "RE=2018.05;SZ=75.4x151.7x7.3;WT=157;DS=6.0;RS=1440x2880;OI=1;OV=8.0;CP=198;RM=6144;",
        "lgv35": "->v30 plus",
        "g6": "RE=2017.02;SZ=71.9x148.9x7.9;WT=163;DS=5.7;RS=1440x2880;OI=1;OV=7.0;CP=208;RM=4096;",
        "lg-h873": "->g6",
        "lg-h872": "->g6",
        "lgus997": "->g6",
        "lg-h871": "->g6",
        "lg-h870s": "->g6",
        "lg-as993": "->g6",
        "lg-h870ar": "->g6",
        "lg-h870i": "->g6",
        "lgm-g600s": "->g6",
        "lgm-g600l": "->g6",
        "lg-us997": "->g6",
        "lg-h870": "->g6",
        "lg-ls993": "->g6",
        "lg-h870ds": "->g6",
        "vs988": "->g6",
        "k52": "RE=2020.09;SZ=76.7x165x8.4;WT=188;DS=6.6;RS=720x1600;OI=1;OV=10;CP=38;RM=4096;",
        "lm-k520": "->k52",
        "w10": "RE=2019.06;SZ=76.2x156x8.5;WT=164;DS=6.19;RS=720x1512;OI=1;OV=9.0;CP=171;RM=3072;",
        "lmx130im": "->w10",
        "k40s": "RE=2019.08;SZ=73.9x156.3x8.6;WT=186;DS=6.1;RS=720x1520;OI=1;OV=9.0;CP=171;RM=2048;",
        "lm-x430": "->k40s",
        "v50 thinq": "RE=2019.02;SZ=76.1x159.2x8.3;WT=183;DS=6.4;RS=1440x3120;OI=1;OV=9.0;CP=234;RM=6144;",
        "lm-v450": "->v50 thinq",
        "lm-v500n": "->v50 thinq",
        "v60 thinq 5g": "RE=2020.02;SZ=77.6x169.3x8.9;WT=213;DS=6.8;RS=1080x2460;OI=1;OV=10;CP=207;RM=8192;",
        "a001lg": "->v60 thinq 5g",
        "lm-v600": "->v60 thinq 5g",
        "v40 thinq": "RE=2018.10;SZ=75.7x158.8x7.6;WT=169;DS=6.4;RS=1440x3120;OI=1;OV=8.1;CP=198;RM=6144;",
        "lm-v405ebw": "->v40 thinq",
        "lm-v405": "->v40 thinq",
        "lm-v409n": "->v40 thinq",
        "lm-v40": "->v40 thinq",
        "fortune": "DS=5;RS=480x854;SZ=72.4x144.78x7.9;WT=;RE=2017.02;OI=1;OV=6.0.1;RM=1536;CP=10;",
        "lg-m153": "->fortune",
        "g4": "RE=2015.04;SZ=76.1x148.9x6.3;WT=155;DS=5.5;RS=1440x2560;OI=1;OV=5.1.1;CP=157;RM=3072;",
        "lg-h812": "->g4",
        "lgh810": "->g4",
        "lgls991": "->g4",
        "lgus991": "->g4",
        "lg-f500l": "->g4",
        "lg-h810": "->g4",
        "lg-f500s": "->g4",
        "lg-f500k": "->g4",
        "lg-h811": "->g4",
        "lg-h815": "->g4",
        "lg-h818": "->g4",
        "lgv32": "->g4",
        "lg-h819": "->g4",
        "stylo 3": "RE=2016.12;SZ=79.8x155.6x7.4;WT=149;DS=5.7;RS=720x1280;OI=1;OV=7.0;CP=40;RM=3072;",
        "lgl84vl": "->stylo 3",
        "lg-m430": "->stylo 3",
        "lgl83bl": "->stylo 3",
        "k4 lte": "RE=2016.01;SZ=66.7x131.9x8.9;WT=120;DS=4.5;RS=480x854;OI=1;OV=5.1.1;CP=10;RM=1024;",
        "lg-k130": "->k4 lte",
        "k20 plus": "RE=2016.12;SZ=75.2x148.6x7.9;WT=140;DS=5.3;RS=720x1280;OI=1;OV=7.0;CP=20;RM=2048;",
        "lg-tp260": "->k20 plus",
        "lgmp260": "->k20 plus",
        "k40": "RE=2019.02;SZ=71.9x153x8.3;WT=144;DS=5.7;RS=720x1440;OI=1;OV=8.1;CP=171;RM=2048;",
        "lm-x420": "->k40",
        "k7": "RE=2016.01;SZ=72.5x143.6x9.1;WT=161;DS=5.0;RS=480x854;OI=1;OV=5.1;CP=58;RM=1024;",
        "lg-x210": "->k7",
        "lgms330": "->k7",
        "lg-k330": "->k7",
        "lg-k332": "->k7",
        "g3 beat": "RE=2014.07;SZ=69.6x137.7x10.3;WT=134;DS=5.0;RS=720x1280;OI=1;OV=4.4.2;CP=111;RM=1024;",
        "lg-d723": "->g3 beat",
        "lg-d725": "->g3 beat",
        "lg-d725pr": "->g3 beat",
        "lg-d726": "->g3 beat",
        "lg-d728": "->g3 beat",
        "stylus 2": "RE=2016.02;SZ=79.6x155x7.4;WT=142;DS=5.7;RS=720x1280;OI=1;OV=6.0;CP=17;RM=1536;",
        "lg-k520": "->stylus 2",
        "lg-f720s": "->stylus 2",
        "stylus 2 plus": "RE=2016.05;SZ=79.6x155x7.4;WT=146;DS=5.7;RS=1080x1920;OI=1;OV=6.0;CP=43;RM=2048;",
        "lg-k530": "->stylus 2 plus",
        "lg-k535": "->stylus 2 plus",
        "v10": "RE=2016.01;SZ=74.8x146x8.8;WT=142;DS=5.3;RS=720x1280;OI=1;OV=5.1.1;CP=17;RM=1024",
        "lg-h900": "->v10",
        "lg-h960": "->v10",
        "lg-k428": "->v10",
        "lg-h962": "->v10",
        "lg-h961s": "->v10",
        "lg-h961n": "->v10",
        "lg-h901": "->v10",
        "rs987": "->v10",
        "vs990": "->v10",
        "spirit": "RE=2015.02;SZ=66.1x133.3x10;WT=124.4;DS=4.7;RS=720x1280;OI=1;OV=5.0.1;CP=17;RM=1024;",
        "lg-h440n": "->spirit",
        "lg-h440ar": "->spirit",
        "lg-h440": "->spirit",
        "risio 2": "RS=480x854;DS=5;CP=10;RM=2048;OI=1;OV=6.0.1;SZ=73.66x144.78x7.62;WT=136.08;RE=2017.04;",
        "lg-m154": "->risio 2",
        "k30": "RE=2018.05;SZ=75x148.6x8.6;WT=168.1;DS=5.3;RS=720x1280;OI=1;OV=7.1;CP=20;RM=2048;",
        "lgl322dl": "->k30",
        "lm-x410um": "->k30",
        "lm-x320": "->k30",
        "k3": "RE=2016.08;SZ=67.7x133.8x9.4;WT=127;DS=4.5;RS=480x854;OI=1;OV=6.0;CP=10;RM=1024;",
        "lgls450": "->k3",
        "k3 (2017)": "RE=2016.12;SZ=69.8x133.9x9.5;WT=132;DS=4.5;RS=480x854;OI=1;OV=6.0.1;CP=10;RM=1024;",
        "lg-as110": "->k3 (2017)",
        "x300": "DS=5;RS=720x1280;SZ=72.1x144.8x8.09;WT=142;RE=2016;OI=1;OV=7.0;RM=2048;CP=20;",
        "lgm-k120l": "->x300",
        "lgm-k120s": "->x300",
        "lgm-k120k": "->x300",
        "q6": "RE=2017.07;SZ=69.3x142.5x8.1;WT=149;DS=5.5;RS=1080x2160;OI=1;OV=7.1.1;CP=35;RM=2048;",
        "lgm-x600s": "->q6",
        "lg-m700": "->q6",
        "lgm-x600l": "->q6",
        "lgm-x600k": "->q6",
        "lg-us700": "->q6",
        "q61": "RE=2020.05;SZ=77.5x164.5x8.3;WT=;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=38;RM=4096;",
        "lm-q630": "->q61",
        "lm-q630n": "->q61",
        "stylo 6": "RE=2020.05;SZ=77.7x171.2x8.6;WT=219;DS=6.8;RS=1080x2460;OI=1;OV=10;CP=38;RM=3072;",
        "lm-q730": "->stylo 6",
        "q51": "RE=2020.02;SZ=77.5x164.5x8.4;WT=;DS=6.5;RS=720x1520;OI=1;OV=10;CP=171;RM=3072;",
        "lm-q510n": "->q51",
        "stylo 5": "RE=2019.06;SZ=77.7x160x8.4;WT=179;DS=6.2;RS=1080x2160;OI=1;OV=9.0;CP=214;RM=3072;",
        "lgl722dl": "->stylo 5",
        "lm-q720": "->stylo 5",
        "k50": "RE=2019.02;SZ=77x161.3x8.7;WT=170;DS=6.26;RS=720x1520;OI=1;OV=9.0;CP=171;RM=3072;",
        "802lg": "->k50",
        "lm-x520": "->k50",
        "jojo": "RS=1440x2880;DS=6;CP=25;RM=4096;OI=1;OV=7.1.2;SZ=75.4x151.7x7.4;WT=158;RE=2017.09;",
        "l-02k": "->jojo",
        "k31": "RE=2020.08;SZ=71.1x147.8x8.6;WT=146;DS=5.7;RS=720x1520;OI=1;OV=10;CP=171;RM=2048;",
        "lm-k300": "->k31",
        "k22": "RE=2020.09;SZ=75.4x155.7x8.4;WT=169.5;DS=6.2;RS=720x1520;OI=1;OV=10;CP=229;RM=2048;",
        "lm-k200": "->k22",
        "k42": "RE=2020.09;SZ=76.7x165x8.4;WT=182;DS=6.6;RS=720x1600;OI=1;OV=10;CP=171;RM=3072;",
        "lm-k420": "->k42",
        "k51": "RE=2020.02;SZ=76.7x165.2x8.3;WT=194.5;DS=6.55;RS=720x1600;OI=1;OV=9.0;CP=38;RM=3072;",
        "lm-k500": "->k51",
        "lgl555dl": "->k51",
        "velvet 4g": "RE=2020.07;SZ=74.1x167.1x7.9;WT=180;DS=6.8;RS=1080x2460;OI=1;OV=10;CP=198;RM=6144;",
        "lm-g910": "->velvet 4g",
        "k8 (2017)": "RE=2016.12;SZ=72.1x144.5x8;WT=144;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=209;RM=1536;",
        "lg-m200": "->k8 (2017)",
        "x charge": "DS=5.5;RS=720x1280;WR=164.1;CP=40;RM=2048;RE=2017.11;SZ=78.1x154.7x8.4;",
        "lg-sp320": "->x charge",
        "lg-m327": "->x charge",
        "velvet 5g": "RE=2020.08;SZ=74.1x167.2x7.9;WT=;DS=6.8;RS=1080x2460;OI=1;OV=10;CP=242;RM=6144;",
        "l-52a": "->velvet 5g",
        "lm-g900": "->velvet 5g",
        "lm-g900n": "->velvet 5g",
        "lm-g900tm": "->velvet 5g",
        "v50s thinq": "RE=2019.10;SZ=75.8x159.3x8.4;WT=192;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=8192;",
        "lm-v510n": "->v50s thinq",
        "wing": "RE=2020.09;SZ=74.5x169.5x10.9;WT=260;DS=6.8;RS=1080x2460;OI=1;OV=10;CP=242;RM=8192",
        "lm-f100": "->wing",
        "lm-f100n": "->wing",
        "g8x thinq": "RE=2019.09;SZ=75.8x159.3x8.4;WT=192;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=6144;",
        "lm-g850": "->g8x thinq",
        "901lg": "->g8x thinq",
        "q70": "RE=2019.09;SZ=76.8x162.1x8.3;WT=198;DS=6.4;RS=1080x2310;OI=1;OV=9.0;CP=258;RM=4096;",
        "lm-q730n": "->q70",
        "lm-q620": "->q70",
        "q92": "RE=2020.08;SZ=77.3x166.5x8.5;WT=193;DS=6.67;RS=1080x2400;OI=1;OV=10;CP=242;RM=6144;",
        "q92 5g": "->q92",
        "lm-q920n": "->q92",
        "q9 one": "RE=2018.08;SZ=71.9x153.2x7.9;WT=156;DS=6.1;RS=1440x3120;OI=1;OV=8.1;CP=25;RM=4096;",
        "lm-q927l": "->q9 one",
        "lancet": "OS=Windows Phone 8.1;RE=2015;CP=17;RM=1024;DS=4.5;SZ=64.7x129.8x10.7;WT=143;RS=480x854;",
        "vs820": "->lancet",
        "lucid 2": "RE=2013.04;SZ=62.8x122.5x9.8;WT=129;DS=4.3;RS=540x960;OI=1;OV=4.1.2;CP=14;RM=1024;",
        "vs870 4g": "->lucid 2",
        "g2": "RE=2013.08;SZ=70.9x138.5x8.9;WT=143;DS=5.2;RS=1080x1920;OI=1;OV=4.2.2;CP=94;RM=2048;",
        "l-01f": "->g2",
        "lg-f320l": "->g2",
        "g5": "RE=2016.02;SZ=73.9x149.4x7.7;WT=159;DS=5.3;RS=1440x2560;OI=1;OV=6.0.1;CP=173;RM=4096;",
        "lg-h831": "->g5",
        "lg-h868": "->g5",
        "lg-f700k": "->g5",
        "lgls992": "->g5",
        "lg-h830": "->g5",
        "lg-f700l": "->g5",
        "lg-h850": "->g5",
        "lg-h860": "->g5",
        "vs987": "->g5",
        "rs988": "->g5",
        "lgus992": "->g5",
        "lg-h820": "->g5",
        "lg-f700s": "->g5",
        "k20": "RE=2019.08;SZ=71.9x148.6x8.3;WT=152;DS=5.45;RS=480x960;OI=1;OV=9.0;CP=8;RM=1024;",
        "lm-x120": "->k20",
        "vs501": "->k20",
        "lg-m255": "->k20",
        "k41s": "RE=2020.02;SZ=76.5x165.8x8.3;WT=191.7;DS=6.55;RS=720x1600;OI=1;OV=9.0;CP=171;RM=3072;",
        "lm-k410": "->k41s",
        "g3": "RE=2014.05;SZ=74.6x146.3x8.9;WT=149;DS=5.5;RS=1440x2560;OI=1;OV=4.4.2;CP=243;RM=2048;",
        "lg-d858hk": "->g3",
        "lgls990": "->g3",
        "vs985 4g": "->g3",
        "lg-d855": "->g3",
        "lg-d852": "->g3",
        "l90": "RE=2014.02;SZ=66x131.6x9.7;WT=126;DS=4.7;RS=540x960;OI=1;OV=4.4.2;CP=78;RM=1024;",
        "lg-d405": "->l90",
        "lg-d415": "->l90",
        "v20": "RE=2016.09;SZ=78.1x159.7x7.6;WT=174;DS=5.7;RS=1440x2560;OI=1;OV=7.0;CP=173;RM=4096;",
        "lg-h918": "->v20",
        "lg-us996": "->v20",
        "lg-f800k": "->v20",
        "lg-h990": "->v20",
        "lgv34": "->v20",
        "lg-ls997": "->v20",
        "lg-h910": "->v20",
        "lg-f800l": "->v20",
        "lg-f800s": "->v20",
        "vs995": "->v20",
        "vs996": "->v30",
        "rebel 3": "DS=5;RS=480x854;SZ=73.66x144.78x7.9;WT=136;RE=2018;OI=1;OV=6.0.1;RM=2048;CP=10;",
        "lgl158vl": "->rebel 3",
        "k51s": "RE=2020.02;SZ=76.7x165.2x8.3;WT=194.5;DS=6.55;RS=720x1600;OI=1;OV=9.0;CP=38;RM=3072;",
        "lm-k510": "->k51s",
        "q stylus plus": "RE=2018.06;SZ=77.7x160.1x8.1;WT=171;DS=6.2;RS=1080x2160;OI=1;OV=8.1;CP=40;RM=3072;",
        "k4 (2017)": "RE=2016.12;SZ=72.6x144.7x7.9;WT=138;DS=5.0;RS=480x854;OI=1;OV=6.0.1;CP=10;RM=1024;",
        "lg-m160": "->k4 (2017)",
        "lgl57bl": "->k4 (2017)",
        "k8 (2018)": "RE=2016.12;SZ=72.1x144.5x8;WT=144;DS=5.0;RS=720x1280;OI=1;OV=7.0;CP=209;RM=1536;",
        "lgus215": "->k8 (2018)",
        "q7": "RE=2018.05;SZ=69.3x143.8x8.4;WT=145;DS=5.5;RS=1080x2160;OI=1;OV=8.1;CP=312;RM=3072;",
        "lm-q610.fg": "->q7",
        "lm-q710.fg": "->q7",
        "v35": "RE=2018.05;SZ=75.4x151.7x7.3;WT=157;DS=6.0;RS=1440x2880;OI=1;OV=8.0;CP=198;RM=6144;",
        "lm-v350": "->v35",
        "lm-v350n": "->v35",
        "v60": "RE=2020.02;SZ=77.6x169.3x8.9;WT=213;DS=6.8;RS=1080x2460;OI=1;OV=10;CP=207;RM=8192;",
        "l-51a": "->v60",
        "q stylus": "RE=2018.06;SZ=77.7x160.1x8.1;WT=171;DS=6.2;RS=1080x2160;OI=1;OV=8.1;CP=40;RM=3072",
        "801lg": "->q stylus",
        "stylo 3 plus": "RE=2017.05;SZ=79.8x155.7x7.4;WT=150;DS=5.7;RS=1080x1920;OI=1;OV=7.0;CP=35;RM=2048;",
        "lg-tp450": "->stylo 3 plus",
        "lgmp450": "->stylo 3 plus",
        "stylus 3": "RE=2016.12;SZ=79.8x155.6x7.4;WT=149;DS=5.7;RS=720x1280;OI=1;OV=7.0;CP=40;RM=3072;",
        "lg-m400": "->stylus 3",
        "stylo 4": "RE=2018.06;SZ=77.7x160x8.1;WT=172;DS=6.2;RS=1080x2160;OI=1;OV=8.1;CP=214;RM=2048;",
        "lg-q710al": "->stylo 4",
        "lg-q710pl": "->stylo 4",
        "lml713dl": "->stylo 4",
        "x screen": "RE=2016.02;SZ=71.8x142.6x7.1;WT=120;DS=4.93;RS=720x1280;OI=1;OV=6.0;CP=17;RM=2048;",
        "lg-k500": "->x screen",
        "ray": "RE=2015.11;SZ=76.4x152.5x9.3;WT=158;DS=5.5;RS=720x1280;OI=1;OV=5.1;CP=313;RM=1024;",
        "lg-x190": "->ray",
        "it": "DS=5;RS=720x1280;SZ=72x145x8;WT=140;RE=2018;OI=1;OV=8.1;RM=3072;CP=20;",
        "lgv36": "->it",
        "q9": "RE=2019.01;SZ=71.9x153.2x7.9;WT=159;DS=6.1;RS=1440x3120;OI=1;OV=8.1;CP=208;RM=4096;",
        "lm-q925k": "->q9",
        "lm-q925l": "->q9",
        "lm-q925s": "->q9",
        "solo lte": "DS=5.7;RS=720x1440;SZ=71.9x153x8.3;WT=150;RE=2019;OI=1;OV=8.1;RM=2048;CP=214;",
        "lgl423dl": "->solo lte",
        "l bello": "RE=2014.08;SZ=70.6x138.1x10.7;WT=137;DS=5.0;RS=480x854;OI=1;OV=4.4.2;CP=7;RM=1024;",
        "lg-d335": "->l bello",
        "lg-d335e": "->l bello",
        "lg-d331": "->l bello",
        "bello 2": "RE=2015.07;SZ=71.6x140.8x9.6;WT=155;DS=5.0;RS=480x854;OI=1;OV=5.1.1;RM=1024;",
        "lg-x150": "->bello 2",
        "lg-x155": "->bello 2",
        "lg-x165g": "->bello 2",
        "x5": "DS=5.5;RS=720x1280;SZ=78.1x154.7x8.9;WT=171;RE=2018.08;OI=1;OV=8.0;RM=2048;CP=40;",
        "x5-lg": "->x5",
        "lm-x510k": "->x5",
        "lm-x510l": "->x5",
        "lm-x510s": "->x5",
        "x4+": "RE=2018.01;SZ=75.1x148.6x8.6;WT=172.3;DS=5.3;RS=720x1280;OI=1;OV=7.0;CP=20;RM=2048;",
        "lm-x410l": "->x4+",
        "lm-x415l": "->x4+",
        "lm-x415s": "->x4+",
        "x4": "DS=5.3;RS=720x1280;SZ=75.1x148.6x8.6;WT=164;RE=2018;OI=1;OV=7.1.2;RM=2048;CP=20;",
        "lm-x410k": "->x4",
        "lm-x415k": "->x4",
        "lm-x410s": "->x4",
        "x4 (2019)": "DS=5.7;RS=720x1440;SZ=71.9x153x8.3;WT=150;RE=2019;OI=1;OV=8.1;RM=2048;CP=171;",
        "lm-x420n": "->x4 (2019)",
        "x6": "DS=6.26;RS=720x1520;SZ=77x161.3x8.7;WT=172;RE=2019;OI=1;OV=9.0;RM=3072;CP=171;",
        "lm-x625n1": "->x6",
        "x6 (2019)": "->x6",
        "lm-x625n": "->x6 (2019)",
        "zero": "RE=2015.09;SZ=71.8x142x7.4;WT=150;DS=5.0;RS=720x1280;OI=1;OV=5.1.1;CP=17;RM=1536",
        "lg-h650": "->zero",
        "zone 4": "RE=2018.03;SZ=71.9x144.8x7.9;WT=140.3;DS=5.0;RS=720x1280;OI=1;OV=7.1.2;CP=20;RM=2048;",
        "lm-x210vpp": "->zone 4",
        "x2": "RE=2018.06;SZ=73.2x146.3x8.2;WT=152;OI=1;OV=7.1.2;CP=10;RM=2048;DS=5;RS=720x1280;SM=1;",
        "lm-x210k": "->x2",
        "x power 3": "RE=2017.07;SZ=78.1x154.7x8.9;WT=171;DS=5.5;RS=720x1280;OI=1;OV=8.1;CP=20;RM=2048;",
        "lm-x510wm": "->x power 3",
        "x power 2": "RE=2017.02;SZ=78.1x154.7x8.4;WT=164;DS=5.5;RS=720x1280;OI=1;OV=7.0;CP=40;RM=1536;",
        "lg-m320": "->x power 2",
        "x power": "RE=2016.05;SZ=74.9x148.9x7.9;WT=139;DS=5.3;RS=720x1280;OI=1;OV=6.0.1;CP=79;RM=2048;",
        "lg-k220": "->x power",
        "style 3": "DS=6.1;RE=2020.06;WY=160;SZ=72x152x8.7;RS=1440x3120;RM=4096;CP=198;OI=1;OV=10;SM=1;",
        "l-41a": "->style 3",
        "wine smart h410": "SM=1;OI=1;OV=5.1;WT=143;SZ=58.7x117.7x16.6;DS=3.2;RS=320x480;RM=1024;",
        "lg-h410": "->wine smart h410",
        "l60": "RE=2014.08;SZ=66.3x124.1x11.8;WT=119;DS=4.3;RS=480x800;OI=1;OV=4.4.2;RM=512;",
        "lg-x145": "->l60",
        "x style": "RE=2016.05;SZ=71.4x144.8x6.9;WT=121;DS=5.0;RS=720x1280;OI=1;OV=6.0.1;CP=10;RM=1536;",
        "lg-k200": "->x style",
        "g3 stylus": "RE=2014.08;SZ=75.9x149.3x10.2;WT=163;DS=5.5;RS=540x960;OI=1;OV=4.4.2;CP=7;RM=1024;",
        "lg-d693n": "->g3 stylus",
        "lg-d693": "->g3 stylus",
        "lg-d693tr": "->g3 stylus",
        "lg-d690n": "->g3 stylus",
        "g4 stylus": "RE=2015.04;SZ=79.2x154.3x9.6;WT=163;DS=5.7;RS=720x1280;OI=1;OV=5.0;CP=17;RM=1024;",
        "lg-h542": "->g4 stylus",
        "lg-h630": "->g4 stylus",
        "g8": "RE=2019.02;SZ=71.8x151.9x8.4;WT=167;DS=6.1;RS=1440x3120;OI=1;OV=9.0;CP=234;RM=6144;",
        "lm-g820": "->g8",
        "lm-g820n": "->g8",
        "g7 thinq": "RE=2018.05;SZ=71.9x153.2x7.9;WT=162;DS=6.1;RS=1440x3120;OI=1;OV=8.0;CP=198;RM=4096;",
        "lg-g710": "->g7 thinq",
        "lm-g710n": "->g7 thinq",
        "lm-g710": "->g7 thinq",
        "lm-g710vm": "->g7 thinq",
        "g3 cat. 6": "RE=2014.01;SZ=74.6x146.3x9.1;WT=154;DS=5.5;RS=1440x2560;OI=1;OV=4.4.2;CP=276;RM=3072;",
        "lg-f460": "->g3 cat. 6",
        "lg-f460s": "->g3 cat. 6",
        "lg-f460l": "->g3 cat. 6",
        "lg-f460k": "->g3 cat. 6",
        "l fino": "RE=2014.08;SZ=67.9x127.5x11.9;WT=145;DS=4.5;RS=480x800;OI=1;OV=4.4.2;CP=33;RM=1024;",
        "lg-d290": "->l fino",
        "lg-d295": "->l fino",
        "f70": "RE=2014.02;SZ=66.4x127.2x10;WT=129.6;DS=4.5;RS=480x800;OI=1;OV=4.4.2;CP=111;RM=1024;",
        "lg-d315": "->f70",
        "l70": "RE=2014.02;SZ=66.8x127.2x9.5;WT=124;DS=4.5;RS=480x800;OI=1;OV=4.4.2;CP=119;RM=1024;SM=1;",
        "lg-d320": "->l70",
        "stylo 2": "RE=2016.04;SZ=79.5x155x7.4;WT=144.6;DS=5.7;RS=720x1280;OI=1;OV=6.0;CP=17;RM=2048;",
        "lgls775": "->stylo 2",
        "aka": "RE=2015.03;SZ=71.9x138.7x10;WT=135;DS=5.0;RS=720x1280;OI=1;OV=4.4.2;CP=78;RM=1536;",
        "lg-h788": "->aka",
        "g4 beat": "RE=2015.07;SZ=72.6x142.7x9.9;WT=139;DS=5.2;RS=1080x1920;OI=1;OV=5.1.1;CP=22;RM=1536;",
        "lg-h735": "->g4 beat",
        "g8s thinq": "RE=2019.02;SZ=76.6x155.3x8;WT=181;DS=6.21;RS=1080x2248;OI=1;OV=9.0;CP=234;RM=6144;",
        "lm-g810": "->g8s thinq",
        "g2 mini": "RE=2014.02;SZ=66x129.6x9.8;WT=121;DS=4.7;RS=540x960;OI=1;OV=4.4.2;CP=111;RM=1024;",
        "lg-d618": "->g2 mini",
        "lg-d620": "->g2 mini",
        "g4c": "RE=2015.05;SZ=69.8x139.7x10.2;WT=136;DS=5.0;RS=720x1280;OI=1;OV=5.0.2;CP=17;RM=1024;",
        "lg-h525n": "->g4c",
        "g4s": "DS=4.7;RS=720x1280;SZ=65x133x10;WT=150;RE=2014;OI=1;OV=4.2.2 Jelly Bean;RM=2048;CP=2;",
        "lg-h736": "->g4s",
        "k10": "RE=2016.01;SZ=74.8x146x8.8;WT=142;DS=5.3;RS=720x1280;OI=1;OV=5.1.1;CP=17;RM=1024;",
        "lg-f670s": "->k10",
        "lg-k410": "->k10",
        "lg-k420": "->k10",
        "lg-f670l": "->k10",
        "lgms428": "->k10",
        "k8": "RE=2016.02;SZ=71.5x144.6x8.7;WT=157;DS=5.0;RS=720x1280;OI=1;OV=6.0;CP=79;RM=1536;",
        "lg-k350": "->k8",
        "leon": "RE=2015.02;SZ=64.9x129.9x10.9;WT=140;DS=4.5;RS=480x854;OI=1;OV=5.0.1;CP=17;RM=1024;",
        "lg-h324": "->leon",
        "lg-h340n": "->leon",
        "rebel 4": "DS=5;RS=720x1280;SZ=71.9x144.8x7.9;WT=140;RE=2018;OI=1;OV=8.1;RM=2048;CP=20;",
        "lml211bl": "->rebel 4",
        "lml212vl": "->rebel 4",
        "risio": "RS=480x854;DS=4.5;CP=17;RM=2048;OI=1;OV=5.1;SZ=65.02x129.79x10.92;WT=136.93;RE=2015.06;",
        "lg-h343": "->risio",
        "phoenix": "RS=320x480;DS=3.2;CP=145;OI=1;OV=2.2;SZ=58.93x113.28x13.21;WT=129;RE=2011.04;",
        "lg-p505r": "->phoenix",
        "phoenix 2": "DS=5;RS=720x1280;SZ=71.4x144.5x8.6;WT=114;RE=2016;OI=1;OV=6.0;RM=1536;CP=10;",
        "lg-k371": "->phoenix 2",
        "phoenix 3": "RS=480x854;DS=5;CP=10;RM=1536;OI=1;OV=6.0.1;SZ=73.66x144.78x7.62;WT=136.08;RE=2017.05;",
        "lg-m150": "->phoenix 3",
        "phoenix 4": "RS=720x1280;DS=5;CP=20;RM=2048;OI=1;OV=7.1.2;SZ=71.9x144.8x7.9;WT=140;RE=2018.09;",
        "lm-x210apm": "->phoenix 4",
        "k5": "RE=2016.03;SZ=71.6x145x8.9;WT=128;DS=5.0;RS=480x854;OI=1;OV=5.1;CP=7;RM=1024;",
        "lg-x220": "->k5",
        "tribute 5": "DS=5;RS=480x854;SZ=72.4x143.5x8.9;WT=138;RE=2016;OI=1;OV=5.1.1;RM=1024;CP=10;",
        "lgls675": "->tribute 5",
        "tribute empire": "DS=5;RS=720x1280;SZ=71.9x144.8x8.1;WT=140;RE=2019;OI=1;OV=8.1;RM=2048;CP=40;",
        "lm-x220pm": "->tribute empire",
        "lg-h871s": "->g6",
        "lg-h930ds": "->v30 plus",
        "lgls676": "->x style",
        "lg-d410": "->l90",
        "lg-f600l": "->v10",
        "lg-f600k": "->v10",
        "lg-d856": "->g3",
        "lg-m322": "->x charge",
        "lg-d851": "->g3",
        "lg-h915": "->v20",
        "lgl24": "->g3",
        "lgl31l": "->f70",
        "lg-d800": "->g2",
        "lm-v500": "->v50 thinq",
        "lgm-g600k": "->g6",
        "lg-f720l": "->stylus 2",
        "lg-f750k": "->x power",
        "lg-f650s": "->x screen",
        "lg-f650l": "->x screen",
        "lg-f650k": "->x screen",
        "lg-f670k": "->k10",
        "lgl355dl": "->k31",
        "lm-v600v": "->v60 thinq 5g",
        "lg-f520k": "->aka",
        "lg-f470k": "->g3 beat",
        "lg-h910pr": "->v20",
        "lg-h320": "->leon",
        "lg-as990": "->g3",
        "lm-g820v": "->g8",
        "lg-rs988": "->g5",
        "lm-g910n": "->velvet 4g",
        "lg-m703": "->q6",
        "lm-g900v": "->velvet 5g",
        "lg-m320g": "->x power 2",
        "lm-g850n": "->g8x thinq",
        "lg-m470": "->stylo 3 plus",
        "lg-m470f": "->stylo 3 plus",
        "lg-k425": "->k10",
        "lg-h961an": "->v10",
        "lg-h872pr": "->g6",
        "lg-h870v": "->g6",
        "lg-h858": "->g5",
        "lm-x210s": "->x2",
        "lm-x210l": "->x2",
        "lg-vs985": "->g3",
        "lg-ls980": "->g2",
        "lg-d802tr": "->g2",
        "lg-us601": "->x charge",
        "lg-m700v": "->q6",
        "lg-f370s": "->f70",
        "lgus990": "->g3",
        "lgus610": "->x power",
        "lgus110": "->k3 (2017)",
        "lgs02": "->x screen",
        "lgl56vl": "->x style",
        "lgl53bl": "->x style",
        "lgk520": "->stylus 2",
        "lgk500j": "->x screen",
        "lgk200f": "->x style",
        "lgas992": "->g5",
        "lg-d321": "->l70",
        "lgls620": "->l70",
        "lg-d625": "->g2 mini",
        "lg-f320k": "->g2",
        "lg-d610": "->g2 mini",
        "lg-f520s": "->aka",
        "lg-h340ar": "->leon",
        "lgl82vl": "->stylo 2",
        "lgl81al": "->stylo 2",
        "lg-m700n": "->q6",
        "lg-k420pr": "->k10",
        "lg-k420ds": "->k10",
        "lg-h990ds": "->v20",
        "lg-h968": "->v10",
        "lg-h900pr": "->v10",
        "lg-h734": "->g4s",
        "lg-h525": "->g4c",
        "lg-f600s": "->v10",
        "lg-f400k": "->g3",
        "lg-d850": "->g3",
        "lg-d806": "->g2",
        "lg-d805": "->g2",
        "lg-d803": "->g2",
        "lg-d802t": "->g2",
        "lg-d801": "->g2",
        "lg-d722j": "->g3 beat",
        "lg-d693ar": "->g3 stylus",
        "lg-d610tr": "->g2 mini",
        "lg-d610ar": "->g2 mini",
        "lg-d400": "->l90",
        "lg-d320ar": "->l70",
        "lg-d329": "->l70",
        "lg-d337": "->l bello",
        "lg-f320s": "->g2",
        "lg-f370l": "->f70",
        "lg-f370k": "->f70",
        "lg-h788n": "->aka",
        "lg-f520l": "->aka",
        "lg-f470s": "->g3 beat",
        "lg-f470l": "->g3 beat",
        "lg-f400s": "->g3",
        "lg-f400l": "->g3",
        "lg-h788tr": "->aka",
        "lg-h788sg": "->aka",
        "lg-h815t": "->g4",
        "lgd855": "->g3",
        "lgv31": "->g3",
        "lgd850": "->g3",
        "lg-x147": "->l60",
        "lg-x140": "->l60",
        "lg-ls990": "->g3",
        "lg-f720k": "->stylus 2",
        "lgas323": "->l70",
        "vs986": "->g4",
        "us215": "->k8 (2018)",
        "lm-x410pm": "->k30",
        "lg-d802": "->g2",
        "vs980 4g": "->g2",
        "lg-x240": "->k8 (2017)",
        "lm-x212(g)": "->k8 (2018)",
        "lg-d325": "->l70",
        "lg-h422": "->spirit",
        "l-01k": "->v30 plus"
    },
    "minix": {
        "neo u1": "RM=2048;OI=1;OV=5.1.1;CP=333;",
        "neo-u1": "->neo u1"
    },
    "blu": {
        "vivo 8l": "DS=5.3;RS=720x1280;SZ=74.4x150.5x8;WT=161;RE=2017.08;OI=1;OV=7.0;RM=3072;CP=118;",
        "8l": "->vivo 8l",
        "xl2": "->vivo xl2",
        "vivo xl2": "RE=2017.01;SZ=76.6x154x9.2;WT=175;DS=5.5;RS=720x1280;OI=1;OV=6.0;CP=69;RM=3072;",
        "xl3": "->vivo xl3",
        "vivo xl3": "RE=2018.02;SZ=70.7x147.7x8;WT=143;DS=5.5;RS=720x1440;OI=1;OV=8.0;CP=9;RM=3072;",
        "xl4": "->vivo xl4",
        "vivo go": "RE=2018.12;SZ=75.2x156.7x8.4;WT=155;DS=6.0;RS=720x1440;OI=1;OV=9.0;CP=8;RM=1024;",
        "go": "->vivo go",
        "vivo xl4": "RE=2018.12;SZ=76.2x157.2x8;WT=178;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=171;RM=3072;",
        "vivo 5r": "RE=2016.09;SZ=75.6x154.5x8.3;WT=166;DS=5.5;RS=1080x1920;OI=1;OV=6.0;CP=118;RM=3072;",
        "5r": "->vivo 5r",
        "vivo one plus": "RE=2018.04;SZ=76.7x164.8x8.6;WT=173;DS=6.0;RS=720x1440;OI=1;OV=7.1;CP=8;RM=2048;",
        "one plus": "->vivo one plus",
        "vivo one plus (2019)": "RE=2019.01;SZ=75.2x156.7x8.3;WT=178;DS=6.2;RS=720x1500;OI=1;OV=8.1;CP=8;RM=2048;",
        "one plus 2019": "->vivo one plus (2019)",
        "vivo xl3 plus": "RE=2018.03;SZ=76.5x158.1x8.2;WT=169;DS=6.0;RS=720x1440;OI=1;OV=7.1.2;CP=20;RM=3072;",
        "xl3 plus": "->vivo xl3 plus",
        "vivo xi": "RE=2018.09;SZ=72.9x149x7.9;WT=187;DS=5.9;RS=720x1520;OI=1;OV=8.1;CP=171;RM=3072;",
        "xi": "->vivo xi",
        "vivo xi plus": "RE=2018.08;SZ=75.5x155x7.8;WT=199;DS=6.2;RS=1080x2246;OI=1;OV=8.1;CP=114;RM=4096;",
        "vivo xi+": "->vivo xi plus",
        "xi plus": "->vivo xi plus",
        "xi+": "->vivo xi plus",
        "c6 (2020)": "RE=2020.10;SZ=78.4x160.7x10.3;WT=230;DS=6.0;RS=720x1440;OI=1;OV=10;RM=1024;",
        "c6 2020": "->c6 (2020)",
        "view mega": "RE=2020.04;DP=320;SZ=78x167.5x9.4;WT=189;DS=6.0;RS=720x1440;OI=1;OV=9.0;CP=44;RM=2048;",
        "b110dl": "->view mega",
        "life one x3": "DS=4.59;DP=480;RS=1080x1920;RM=2996;OI=1;OV=7;",
        "life one x2": "DS=4.59;DP=480;RS=1080x1920;RM=3812;GP=24;OI=1;OV=6;",
        "studio g": "DS=4.08;DP=240;RS=480x854;RM=482;OI=1;OV=6;",
        "studio x8 hd": "DS=4.59;DP=320;RS=720x1280;RM=984;OI=1;OV=8.1;",
        "studio g3": "DS=4.08;DP=240;RS=480x854;RM=947;OI=1;OV=7;",
        "studio g plus": "DS=4.6;DP=213;RS=480x854;RM=1014;OI=1;OV=5.1;",
        "life xl": "DS=4.59;DP=320;RS=720x1280;RM=1000;OI=1;OV=5.1;",
        "studio j5": "DS=4.59;DP=320;RS=720x1280;RM=973;OI=1;OV=6;",
        "studio_j5": ">-studio j5",
        "studio g hd lte": "DS=4.59;DP=320;RS=720x1280;RM=973;OI=1;OV=6;",
        "view 5": "DS=6.31;DP=280;RS=720x1612;RM=2953;GP=76;OI=1;OV=14;",
        "b160v": "->view 5"
    },
    "doogee": {
        "s61": "RE=2022.06;SZ=81.4x167.4x14.6;WT=266;DS=6.0;RS=720x1440;OI=1;OV=12;CP=348;RM=6144;",
        "s61 pro": "RE=2022.06;SZ=81.4x167.4x14.6;WT=266;DS=6.0;RS=720x1440;OI=1;OV=12;CP=348;RM=6144;",
        "bl9000": "RE=2024.01;SZ=82.6x179.5x17;WT=413;DS=6.78;RS=1080x2460;OI=1;OV=13;CP=390;RM=12288;",
        "s61pro": "->s61 pro"
    },
    "noa": {
        "vivo": "DS=5.45;RS=640x1280;SZ=70.9x148.7x8.9;WT=155;RE=2018.12;OI=1;OV=8.1;RM=2048;CP=83;"
    },
    "oukitel": {
        "c22": "RE=2020.10;SZ=73.7x150.5x8.9;WT=178;DS=5.86;RS=720x1520;CP=44;RM=4096;OI=1;OV=10;",
        "c15 pro": "RE=2019.03;SZ=73.7x156.1x9.5;WT=168;DS=6.09;RS=600x1280;CP=44;RM=2048;OI=1;OV=9;",
        "c16 pro": "RE=2019.06;SZ=70.3x146.4x9.5;WT=153;DS=5.71;RS=720x1520;CP=44;RM=3072;OI=1;OV=9;",
        "k10000": "RE=2015.12;SZ=75.0x157.0x14.0;WT=320;DS=5.5;RS=720x1280;CP=56;RM=2048;OI=1;OV=5.1;",
        "k10000 max": "RE=2017.03;SZ=75.0x157.0x14.0;WT=320;DS=5.5;RS=1080x1920;CP=39;RM=3072;OI=1;OV=7;",
        "k10000 pro": "RE=2017.05;SZ=77.8x161.7x14.0;WT=292;DS=5.5;RS=1080x1920;CP=162;RM=3072;OI=1;OV=7;",
        "k4000": "RE=2015.08;SZ=70.6x143.0x11.0;WT=208;DS=5;RS=720x1280;CP=56;RM=2048;OI=1;OV=5.1;",
        "k4000 lite": "DS=5;RS=540x960;SZ=72x145.6x12.5;WT=208;RE=2016.01;OI=1;OV=5.1;RM=2048;CP=56;"
    },
    "we": {
        "a10": "RE=2018.08;OI=1;OV=8.1;RS=480x640;WT=115.5;SZ=63.3x123x10.1;DS=4;RM=512;",
        "a50": "RE=2018.11;OI=1;OV=8.1;RS=480x854;WT=225;SZ=73.5x146x10.1;DS=5;RM=512;",
        "f10": "RE=2018.08;OI=1;OV=8.1;RS=480x960;WT=161;SZ=65x138x9.6;DS=4.95;RM=1024;SM=2;",
        "f20": "RE=2018.08;OI=1;OV=8.1;RS=480x960;WT=175.7;SZ=72x148x9.2;DS=5.45;RM=1024;SM=2;",
        "l9": "RE=2019.08;OI=1;OV=8.1;RS=720x1080;WT=159.7;SZ=72x143.5x9.5;DS=5;RM=1024;SM=2;",
        "r4": "RE=2019.05;OI=1;OV=8.1;RS=720x1080;WT=159.7;SZ=72x143.5x9.5;DS=5;RM=1024;SM=2;",
        "v4": "RE=2019.06;OI=1;OV=8.1;RS=720x1440;WT=154;SZ=70.36x148.76x8.95;DS=5.5;RM=2048;SM=2;",
        "l3": "RE=2017.01;OI=1;OV=6.0;RS=480x854;WT=146;SZ=65.8x133x9.5;DS=4.5;RM=1024;SM=2;CP=58;"
    },
    "supra": {
        "m74c 4g": "RE=2015;OI=1;OV=5.1;RS=1024x600;WT=247;DS=7;SZ=188x107.8x10.3;CP=335;RM=512;SM=2;"
    },
    "tecno mobile": {
        "spark go (2022)": "RE=2021.12;SZ=76x164.5x9;WT=199;DS=6.52;RS=720x1600;OI=1;OV=11;RM=2048;",
        "tecno kg5m": "->spark go (2022)",
        "r7+": "DS=5.5;RM=1024;RS=720x1280;OI=1;OV=10;CP=293;",
        "tecno rc6": "->r7+",
        "pop 5 go": "DS=6.1;RS=720x1520;RE=2022.04;SZ=164.87x76.09x9.52;OI=1;OV=11;CP=44;RM=3072;SM=2;",
        "tecno bd1": "->pop 5 go",
        "f2 lte": "RE=2018.05;SZ=74x143.8x9.6;WT=168.5;DS=5;RS=480x854;OI=1;OV=8.1;CP=293;RM=1024;SM=2;",
        "tecno f2lte": "->f2 lte",
        "s9": "DS=7;RS=1024x600;OI=1;OV=4.2;RM=1024;SZ=193x111x9.5;SM=2;",
        "tecno s9": "->s9",
        "pova": "RE=2020.10;SZ=77.6x171.2x9.4;WT=;DS=6.8;RS=720x1640;OI=1;OV=10;CP=226;RM=4096;",
        "tecno ld7j": "->pova",
        "tecno ld7": "->pova",
        "pova 2": "RE=2021.06;SZ=78.8x173.3x9.6;WT=;DS=6.95;RS=1080x2460;OI=1;OV=11;CP=322;RM=4096;",
        "tecno le7n": "->pova 2",
        "pova neo": "RE=2021.12;SZ=77.3x171.4x9.1;WT=;DS=6.8;RS=720x1640;OI=1;OV=11;CP=284;RM=4096;",
        "tecno le6": "->pova neo",
        "camon i4": "RE=2019.05;SZ=75.80x156.90x7.96;WT=141;DS=6.22;RS=720x1520;SM=2;OI=1;OV=9;CP=44;RM=4096;",
        "tecno cb7j": "->camon i4",
        "tecno cb7": "->camon i4",
        "camon iclick 2": "RE=2018.10;SZ=75.6x156.8x7.8;WT=145;DS=6.2;RS=720x1500;OI=1;OV=8.1;CP=171;RM=4096;SM=2;",
        "tecno id6": "->camon iclick 2",
        "d1": "OI=1;OV=4.2;SZ=69.3x114.9x11.7;DS=2.6;RS=320x480;CP=24;RM=512;",
        "tecno d1": "->d1",
        "d3": "OI=1;OV=2.3;SZ=62.5x115.5x11.3;DS=3.5;RS=320x480;RM=512;SM=2;",
        "tecno d3": "->d3",
        "f4 pro": "RE=2018.06;SZ=71.9x151.5x8.5;WT=140;DS=5.45;RS=480x960;OI=1;OV=7;CP=336;RM=1024",
        "tecno f4 pro": "->f4 pro",
        "phantom 8": "RE=2018.04;SZ=79.5x160x7.9;WT=185;DS=5.7;RS=1080x1920;OI=1;OV=7;CP=353;RM=6144;",
        "tecno ax8": "->phantom 8",
        "phantom x": "RE=2021.06;SZ=73.8x163.5x8.7;WT=201;DS=6.7;RS=1080x2340;OI=1;OV=11;CP=321;RM=8192;",
        "tecno ac8": "->phantom x",
        "camon i": "SZ=71.7x152.2x7.5;WT=172;DS=5.65;RS=720x1440;RM=3072;OI=1;OV=7;SM=2;CP=9;",
        "tecno in5": "->camon i",
        "camon 18 premier": "RE=2021.10;SZ=75.9x163.8x8.2;WT=200.6;DS=6.7;RS=1080x2400;OI=1;OV=11;CP=350;RM=8192;SM=2;",
        "tecno ch9n": "->camon 18 premier",
        "camon 16": "RE=2020.10;SZ=77.2x170.9x9.2;WT=207;DS=6.8;RS=720x1640;OI=1;OV=10;CP=319;RM=4096;",
        "tecno ce9h": "->camon 16",
        "tecno ce7": "->camon 16",
        "camon 16 premier": "RE=2020.09;SZ=77.2x170.6x9.1;WT=210;DS=6.85;RS=1080x2460;OI=1;OV=10;CP=325;RM=8192;",
        "tecno ce9": "->camon 16 premier",
        "camon 16 pro": "RE=2020.09;SZ=77.2x170.9x9.2;WT=207;DS=6.8;RS=720x1640;OI=1;OV=10;CP=319;RM=4096;",
        "tecno ce8": "->camon 16 pro",
        "camon 16 s": "RE=2020.11;SZ=76.5x164.5x9;WT=207;DS=6.6;RS=720x1600;OI=1;OV=10;CP=171;RM=4096;SM=2;",
        "tecno cd6j": "->camon 16 s",
        "camon 17": "RE=2021.05;SZ=76.5x164.5x9;WT=201;DS=6.6;RS=720x1600;OI=1;OV=11;CP=322;RM=4096;",
        "tecno cg6": "->camon 17",
        "tecno cg6j": "->camon 17",
        "camon 15": "RE=2020.02;SZ=76.4x164.1x8.8;WT=196;DS=6.6;RS=720x1600;OI=1;OV=10;CP=171;RM=4096;",
        "tecno cd7": "->camon 15",
        "spark 6 go": "RE=2020.11;SZ=76.3x165.6x9.1;WT=193.5;DS=6.52;RS=720x1600;OI=1;OV=10;CP=337;RM=3072;",
        "tecno ke5k": "->spark 6 go",
        "tecno ke5": "->spark 6 go",
        "tecno ke5j": "->spark 6 go",
        "spark 6": "RE=2020.09;SZ=77.3x170.8x9.2;WT=193.5;DS=6.8;RS=720x1640;OI=1;OV=10;CP=319;RM=4096;",
        "tecno ke7": "->spark 6",
        "camon 16 se": "RE=2020.10;SZ=77.2x170.9x9.2;WT=207;DS=6.8;RS=720x1640;OI=1;OV=10;CP=319;RM=4096;",
        "tecno ce7j": "->camon 16 se",
        "camon 15 pro": "RE=2020.02;SZ=77.7x163.3x9.1;WT=203;DS=6.6;RS=1080x2340;OI=1;OV=10;CP=38;RM=6144;",
        "tecno cd8": "->camon 15 pro",
        "spark 5 air": "RE=2020.05;SZ=79.3x174.6x9.1;WT=175;DS=7.0;RS=720x1640;OI=1;OV=10;CP=44;RM=2048;SM=2;",
        "tecno kd6": "->spark 5 air",
        "tecno kd6a": "->spark 5 air",
        "spark 6 air": "RE=2020.07;SZ=79.4x174.7x9.3;WT=193.5;DS=7.0;RS=720x1640;OI=1;OV=10;CP=44;RM=2048;SM=2;",
        "tecno ke6": "->spark 6 air",
        "tecno ke6j": "->spark 6 air",
        "camon isky": "RE=2018.04;SZ=147.5x70.8x8.3;WT=137;RS=480x960;DS=5.45;OI=1;OV=8.1;CP=293;RM=2048;SM=2;",
        "tecno in2": "->camon isky",
        "camon i sky": "->camon isky",
        "camon 12 air": "RE=2019.10;SZ=76.1x164.2x8.2;WT=181;DS=6.55;RS=720x1600;OI=1;OV=9;CP=44;RM=3072;",
        "tecno cc6": "->camon 12 air",
        "tecno kc3": "->camon 12 air",
        "camon 11": "RE=2018.09;SZ=76x156.5x5.6;WT=150;DS=6.2;RS=720x1500;OI=1;OV=8.1;CP=44;RM=3072;",
        "tecno cf7k": "->camon 11",
        "tecno cf7": "->camon 11",
        "camon 11 pro": "RE=2018.09;SZ=76x156.5x5.6;WT=155;DS=6.2;RS=720x1500;OI=1;OV=8.1;CP=171;RM=6144;",
        "tecno cf8": "->camon 11 pro",
        "wx3 pro": "RE=2017.07;DS=5;RS=480x854;SZ=73x145x10.9;SM=2;RM=1024;OI=1;OV=7;CP=5;",
        "tecno wx3p": "->wx3 pro",
        "pop 1": "RE=2018.03;SZ=71.9x151.5x8.5;WT=140;DS=5.45;RS=480x960;OI=1;OV=7.0;CP=336;RM=1024;",
        "tecno f3": "->pop 1",
        "camon x": "RE=2018.05;SZ=75.8x158.6x7.75;WT=154;DS=6.0;RS=720x1440;OI=1;OV=8.1;RM=3072;CP=166;SM=2;",
        "tecno ca7": "->camon x",
        "pop 3": "RE=2019.12;OI=1;OV=8.1;RM=1024;SZ=75.4x154.3x9.95;WT=;DS=5.7;RS=480x960;SM=2;",
        "tecno bb2": "->pop 3",
        "f7": "RE=2013.04;SM=2;SZ=70.8x143.5x9.1;WT=;DS=5;RS=720x1280;CP=;RM=1024;OI=1;OV=4.2;",
        "tecno f7": "->f7",
        "f7 phantom": "->f7",
        "pouvoir 3 plus": "RE=2019.08;SZ=76x159x9.2;WT=180;DS=6.35;RS=720x1548;OI=1;OV=9;CP=171;RM=6144;",
        "tecno lb8": "->pouvoir 3 plus",
        "tecno lb8a": "->pouvoir 3 plus",
        "camon cx": "RE=2017.03;SZ=75.8x152.8x5.6;WT=150;DS=5.5;RS=1080x1920;OI=1;OV=7;CP=162;RM=2048;",
        "tecno camon cx": "->camon cx",
        "wx4": "DS=5;RS=720x1280;SZ=71.2x143.1x8.5;WT=164;RE=2017.08;OI=1;OV=7;RM=1024;CP=9;",
        "tecno wx4": "->wx4",
        "s6": "DS=5;RS=480x854;SZ=72x145x9.6;WT=127;RE=2017.09;OI=1;OV=7;RM=1024;CP=5;SM=2;",
        "tecno s6": "->s6",
        "l9": "RE=2017.05;SM=2;WT=170;SZ=76.2x151x8.2;DS=5.5;RS=720x1280;OI=1;OV=7;RM=1024;",
        "tecno l9": "->l9",
        "h5": "OI=1;OV=4.2;SZ=65.8x124x11.6;WT=;DS=4;RS=480x800;RM=512;CP=24;RE=2014.05;",
        "tecno h5": "->h5",
        "droidpad 7g": "DS=7;SZ=181.25x102.8x9.7;WT=208;RS=1024x600;RM=2048;CP=230;OI=1;OV=10;SM=1;",
        "tecno p704a": "->droidpad 7g",
        "droidpad 7d": "RE=2017.04;DS=7;RS=1024x600;WT=268;RM=1024;CP=163;SM=2;OI=1;OV=7;",
        "tecno p701": "->droidpad 7d",
        "droidpad 8d": "DS=8;RS=1280x800;SZ=211x123x8.3;WT=;SM=2;RM=1024;CP=339;OI=1;OV=5.1;RE=2016.04;",
        "tecno dp8d": "->droidpad 8d",
        "camon i2x": "DS=6.2;RS=720x1520;SZ=76x156.6x7.9;WT=;RE=2018;OI=1;OV=8.1;RM=4096;CP=171;SM=2;",
        "tecno id5b": "->camon i2x",
        "camon 12": "RE=2019.08;SZ=75.8x166x8.2;WT=170.7;DS=6.52;RS=720x1600;OI=1;OV=9;CP=171;RM=4096;",
        "tecno cc7": "->camon 12",
        "tecno cc7s": "->camon 12",
        "camon 12 pro": "RE=2019.09;SZ=75.5x158.6x7.8;WT=161;DS=6.35;RS=720x1600;OI=1;OV=9;CP=171;RM=6144;",
        "tecno cc9": "->camon 12 pro",
        "spark 4": "RE=2019.09;SZ=75.9x165.3x8.2;WT=;DS=6.52;RS=720x1600;OI=1;OV=9.0;RM=2048;SM=2;",
        "tecno kc8": "->spark 4",
        "tecno kc2": "->spark 4",
        "tecno kc2j": "->spark 4",
        "tecno kc8s": "->spark 4",
        "spark 5": "RE=2020.05;SZ=76.3x164.7x8.8;WT=194;DS=6.6;RS=720x1600;OI=1;OV=10;CP=44;RM=2048;SM=2;",
        "tecno kd7h": "->spark 5",
        "tecno kd7s": "->spark 5",
        "spark 5 pro": "RE=2020.07;SZ=76.3x164.7x8.8;WT=;DS=6.6;RS=720x1600;OI=1;OV=10;CP=340;RM=3072;",
        "tecno kd7": "->spark 5 pro",
        "spark 2": "RE=2018.06;SZ=76.2x159.4x7.8;WT=175;DS=6.0;RS=720x1440;OI=1;OV=8.1;CP=5;RM=1024;",
        "tecno ka7": "->spark 2",
        "tecno ka7o": "->spark 2",
        "spark 3": "RE=2019.04;SZ=75.8x155.3x8.2;WT=;DS=6.2;RS=720x1500;OI=1;OV=9;CP=44;RM=2048;",
        "tecno kb7": "->spark 3",
        "tecno kb7j": "->spark 3",
        "spark 3 pro": "RE=2019.04;SZ=75.5x154.3x7.9;WT=;DS=6.2;RS=720x1500;OI=1;OV=9;CP=44;RM=2048;",
        "tecno kb8": "->spark 3 pro",
        "camon 15 air": "RE=2020.04;SZ=76.5x164.5x9;WT=196;DS=6.6;RS=720x1600;OI=1;OV=10;CP=171;RM=3072;",
        "tecno cd6s": "->camon 15 air",
        "tecno cd6": "->camon 15 air",
        "camon 15 premier": "RE=2020.04;SZ=77.7x163.3x9.1;WT=203;DS=6.6;RS=1080x2340;OI=1;OV=10;CP=38;RM=6144;",
        "tecno cd8j": "->camon 15 premier",
        "spark youth": "RE=2019.03;OI=1;OV=8.1;SZ=76.6x156.95x8.1;WT=155;CP=5;DS=6;RM=1024;SM=2;",
        "tecno ka6": "->spark youth",
        "spark 4 air": "DS=6.1;RS=720x1560;SZ=75x156.1x9.2;WT=;RE=2019.08;OI=1;OV=9;RM=2048;CP=44;",
        "tecno kc6": "->spark 4 air",
        "tecno kc6s": "->spark 4 air",
        "tecno kc1j": "->spark 4 air",
        "camon x pro": "RE=2018.03;SZ=75.2x158x5.2;WT=148;DS=6.0;RS=1080x2160;OI=1;OV=8.1;CP=166;RM=4096;",
        "tecno ca8": "->camon x pro",
        "r6s": "DS=5;RS=480x854;SZ=72x145x8.6;WT=133;RM=1024;RE=2017.07;CP=86;OI=1;OV=7;",
        "tecno r6s": "->r6s",
        "spark air": "RE=2019.08;SZ=75x156.1x9.2;WT=174;DS=6.1;RS=720x1560;OI=1;OV=9;CP=44;RM=1024;",
        "tecno kc1": "->spark air",
        "spark go": "->spark air",
        "tecno kc1h": "->spark go",
        "spark 7": "RE=2021.04;SZ=76.1x164.8x9.5;WT=203;DS=6.5;RS=720x1600;OI=1;OV=11;CP=340;RM=2048;",
        "tecno kf6n": "->spark 7",
        "tecno kf6m": "->spark 7",
        "tecno kf6k": "->spark 7",
        "tecno kf6j": "->spark 7",
        "tecno kf6": "->spark 7",
        "tecno pr651h": "->spark 7",
        "tecno pr651": "->spark 7",
        "tecno kf6i": "->spark 7",
        "tecno pr651e": "->spark 7",
        "spark 7t": "RE=2021.06;SZ=76.1x164.8x9.5;WT=205;DS=6.52;RS=720x1600;OI=1;OV=11;CP=348;RM=4096;",
        "tecno kf6p": "->spark 7t",
        "spark 8p": "RE=2021.10;SZ=76.1x164.5x8.9;WT=203;DS=6.6;RS=1080x2408;OI=1;OV=11;CP=164;RM=4096;",
        "tecno kg7n": "->spark 8p",
        "tecno kg7": "->spark 8p",
        "spark 8 pro": "RE=2021.12;SZ=76.8x169x8.8;WT=;DS=6.8;RS=1080x2460;OI=1;OV=11;CP=322;RM=4096;",
        "tecno kg8": "->spark 8 pro",
        "spark 8": "RE=2021.09;SZ=76.1x164.8x9.2;WT=200;DS=6.52;RS=720x1600;OI=1;OV=11;CP=171;RM=2048;",
        "tecno kg6": "->spark 8",
        "tecno kg6k": "->spark 8",
        "spark 8t": "RE=2021.12;SZ=75.9x164.3x8.9;WT=;DS=6.6;RS=1080x2408;OI=1;OV=11;CP=348;RM=4096;",
        "tecno kg6p": "->spark 8t",
        "spark 8c": "RE=2022.01;SZ=76x164.6x8.95;WT=193;DS=6.6;RS=720x1612;OI=1;OV=11;CP=354;RM=4096;SM=2;",
        "tecno kg5n": "->spark 8c",
        "spark 7 pro": "RE=2021.04;SZ=76.2x164.9x8.8;WT=193;DS=6.6;RS=720x1600;OI=1;OV=11;CP=226;RM=4096;",
        "tecno kf8": "->spark 7 pro",
        "camon 17 pro": "RE=2021.05;SZ=77x168.9x9;WT=201;DS=6.8;RS=1080x2460;OI=1;OV=11;CP=321;RM=8192;",
        "tecno cg8": "->camon 17 pro",
        "camon 17p": "RE=2021.05;SZ=76.4x168.7x8.8;WT=;DS=6.8;RS=1080x2460;OI=1;OV=11;CP=322;RM=6144;",
        "tecno cg7n": "->camon 17p",
        "tecno cg7": "->camon 17p",
        "camon 18": "RE=2021.10;SZ=76.7x168.9x8.8;WT=;DS=6.8;RS=1080x2460;OI=1;OV=11;CP=349;RM=4096;",
        "tecno ch6n": "->camon 18",
        "camon 18p": "RE=2021.10;SZ=76.7x168.9x8.8;WT=;DS=6.8;RS=1080x2460;OI=1;OV=11;CP=350;RM=8192;",
        "tecno ch7n": "->camon 18p",
        "camon cm": "DS=5.7;RS=720x1440;SZ=71.7x152.5x5.6;WT=150;RE=2018.01;OI=1;OV=7;RM=2048;CP=9;SM=2;",
        "tecno ca6": "->camon cm",
        "camon c9": "DS=5.5;RS=1080x1920;SZ=76.4x153x10.35;WT=;RE=2016.06;OI=1;OV=6;RM=2048;CP=118;",
        "tecno-c9": "->camon c9",
        "spark 7p": "RE=2021.04;SZ=77.9x171.9x9.2;WT=;DS=6.8;RS=720x1640;OI=1;OV=11;CP=319;RM=4096;",
        "tecno kf7j": "->spark 7p",
        "pop 4 air": "RE=2021.05;DS=6.52;RS=540x1200;SZ=73.8x144x10.6;WT=183;SM=2;RM=1024;CP=341;OI=1;OV=10;",
        "tecno bc1": "->pop 4 air",
        "camon isky 3": "RE=2029.03;DS=6.2;RM=2048;CP=44;SZ=75.54x154.29x7.9;RS=720x1500;WT=150;OI=1;OV=9;SM=2;",
        "tecno kb3": "->camon isky 3",
        "spark 4 lite": "RE=2019.12;SZ=75.8x166.7x8.4;WT=;DS=6.52;RS=720x1600;OI=1;OV=9.0;CP=44;RM=2048;",
        "tecno bb4k": "->spark 4 lite",
        "pop 5": "RE=2021.07;SZ=75.7x157.7x9.6;WT=;DS=6.1;RS=720x1560;OI=1;OV=10;RM=1024;",
        "tecno bd2p": "->pop 5",
        "pop 4 lte": "->pop 4",
        "tecno bc1s": "->pop 4 lte",
        "pop 4": "RE=2020.07;SZ=77.3x160x9.5;WT=;DS=6.0;RS=480x960;OI=1;OV=10;RM=2048;CP=8;SM=2;",
        "tecno bc2c": "->pop 4",
        "pop 4 pro": "DS=6.52;RS=540x1200;SZ=77.58x167.11x9.55;RE=2020.07;OI=1;OV=10;RM=2048;CP=8;",
        "tecno bc3": "->pop 4 pro",
        "pouvoir 4": "RE=2020.07;SZ=79.6x174.9x9.2;WT=;DS=7.0;RS=720x1640;OI=1;OV=10;CP=44;RM=3072;",
        "tecno lc7s": "->pouvoir 4",
        "tecno lc7": "->pouvoir 4",
        "pouvoir 4 pro": "RE=2020.07;SZ=79.6x174.9x9.2;WT=;DS=7.0;RS=720x1640;OI=1;OV=10;CP=171;RM=4096;",
        "tecno lc8": "->pouvoir 4 pro",
        "pouvoir 3": "RE=2019.06;SZ=76.7x157.6x8.5;WT=168;DS=6.2;RS=720x1500;OI=1;OV=8.1;CP=293;RM=2048;",
        "tecno lb7": "->pouvoir 3",
        "pouvoir 3 air": "RE=2019.08;SZ=78.2x163x9.3;WT=;DS=6.0;RS=480x960;OI=1;OV=9;CP=44;RM=1024;",
        "tecno lc6a": "->pouvoir 3 air",
        "tecno lc6": "->pouvoir 3 air",
        "pouvoir 2": "RE=2018.05;SZ=76.8x159.8x8.5;WT=167;DS=6.0;RS=720x1440;OI=1;OV=8.1;RM=2048;CP=9;",
        "tecno la7": "->pouvoir 2",
        "pouvoir 2 pro": "RE=2018.08;SZ=76.8x159.8x8.2;WT=171;DS=6.0;RS=720x1440;OI=1;OV=8.1;RM=3072;CP=9;",
        "tecno la7 pro": "->pouvoir 2 pro",
        "pouvoir 1": "RE=2018.05;SZ=77.2x154.5x8.8;WT=164;DS=5.5;RS=720x1280;OI=1;OV=7;CP=336;RM=1024;",
        "tecno la6": "->pouvoir 1",
        "tecno le7": "->pova 2",
        "tecno le6h": "->pova neo",
        "mz-tecno ke7": "->spark 6",
        "tecno bd2": "->pop 5",
        "tecno bc2": "->pop 4",
        "tecno kf6ks": "->spark 7",
        "tecno ch9": "->camon 18 premier",
        "tecno ch6": "->camon 18",
        "tecno kg5j": "->spark 8c",
        "tecno kg5k": "->spark 8c",
        "tecno ch6h": "->camon 18",
        "tecno kg7h": "->spark 8p",
        "tecno kg5h": "->spark go (2022)",
        "kg6k": "->spark 8",
        "tecno cg8h": "->camon 17 pro",
        "tecno cf7s": "->camon 11",
        "tecno bd2d": "->pop 5",
        "tecno ch7": "->camon 18p",
        "tecno ca6s": "->camon cm",
        "tecno-mobile ch9n": "->camon 18 premier",
        "ch6n": "->camon 18",
        "tecno kg5q": "->spark 8c",
        "tecno ca8s": "->camon x pro",
        "kg6p": "->spark 8t",
        "kg8": "->spark 8 pro",
        "tecno kf6h": "->spark 7",
        "ch9n": "->camon 18 premier",
        "tecno kg5": "->spark go (2022)",
        "tecno camon i4": "->camon i4",
        "kg5k": "->spark 8c",
        "dp8d": "->droidpad 8d"
    },
    "premier": {
        "maxi 20": "DS=5.26;DP=320;RS=720x1520;RM=2960;GP=76;OI=1;OV=10;"
    },
    "wiko": {
        "u feel": "RE=2016.05;SZ=70.7x143x8.6;WT=145;DS=5;RS=720x1280;CP=79;RM=3072;OI=1;OV=6;",
        "fever": "RE=2015.09;SZ=73.8x148x8.3;WT=143;DS=5.2;RS=1080x1920;CP=118;RM=2048;OI=1;OV=6;",
        "barry": "RE=2014.03;SZ=73.8x145.8x9.7;WT=155;DS=5;RS=480x854;CP=24;RM=512;OI=1;OV=4;",
        "birdy": "RE=2014.05;SZ=67x132x9.6;WT=141;DS=4.5;RS=480x854;CP=7;RM=1024;OI=1;OV=4;",
        "view 3 lite": "RE=2019.05;SZ=70.7x148.4x8.5;WT=147;DS=6.09;RS=720x1520;CP=109;RM=2048;OI=1;OV=9;",
        "w-v800-tvm": "->view 3 lite",
        "w-v800-eea": "->view 3 lite",
        "w-v800-ope": "->view 3 lite",
        "view 3": "RE=2019.05;SZ=76.5x159.0x8.2;WT=178;DS=6.26;RS=720x1520;CP=171;RM=3072;OI=1;OV=9;",
        "w-p311-ope": "->view 3",
        "w-p311-eea": "->view 3",
        "y60": "RE=2019.04;SZ=71.8x146.8x9.3;WT=177.7;DS=5.45;RS=480x960;OI=1;OV=9.0;CP=293;RM=1024;TT=32000;",
        "w-k510-eea": "->y60",
        "w-k510-tvm": "->y60",
        "w-k510-sun": "->y60",
        "w-k510-ope": "->y60",
        "w-k510-byt": "->y60",
        "w-k510-th": "->y60",
        "w-k510s-swi": "->y60",
        "w-v800-tim": "->view 3 lite",
        "w-v800-du": "->view 3 lite",
        "w-p311-tvm": "->view 3",
        "u feel ecom": "->u feel"
    },
    "inoi": {
        "2": "DS=5;RS=480x854;SZ=73.1x144x9.45;WT=162;RE=2018.04;OI=1;OV=7;RM=1024;CP=9;",
        "3": "DS=5;RS=480x960;SZ=67x139x10;WT=141;RE=2018.07;OI=1;OV=7;RM=1024;CP=8;",
        "3 power": "DS=5;RS=480x960;SZ=67x139x13;WT=163;RE=2018.04;OI=1;OV=7;RM=1024;CP=5;",
        "3 lite": "DS=5;RS=480x960;SZ=67x139x10;WT=141;RE=2018.04;OI=1;OV=7;RM=1024;CP=5;"
    },
    "hisense": {
        "infinity h40 rock": "SZ=76.4x166.2x9.47;WT=201;DS=6.52;RS=1080x2340;RM=4096;OI=1;OV=10;CP=290;RE=2020.04;",
        "h30 lite": "OI=1;OV=9;SZ=73.6x153.7x9;WT=156;RE=2019.07;CP=109;DS=6.1;RM=3072;"
    },
    "poco": {
        "m4 pro 5g": "RE=2021.11;SZ=75.8x163.6x8.8;WT=195;DS=6.6;RS=1080x2400;OI=1;OV=11;CP=365;RM=6144;",
        "21091116ag": "->m4 pro 5g",
        "f2 pro": "RE=2020.05;SZ=75.4x163.3x8.9;WT=219;DS=6.67;RS=1080x2400;OI=1;OV=10;CP=207;RM=6144;TT=538221;",
        "m2004j11g": "->f2 pro",
        "m3": "RE=2020.11;SZ=77.3x162.3x9.6;WT=198;DS=6.53;RS=1080x2340;OI=1;OV=10;CP=285;RM=4096;TT=177904;",
        "m2010j19cg": "->m3",
        "m2010j19ci": "->m3",
        "x3 nfc": "RE=2020.09;SZ=76.8x165.3x9.4;WT=215;DS=6.67;RS=1080x2400;OI=1;OV=10;CP=364;RM=6144;TT=283750;",
        "m2007j20ct": "->x3 nfc",
        "m2007j20cg": "->x3 nfc",
        "x4 pro 5g": "RE=2022.02;SZ=76.1x164.2x8.1;WT=205;DS=6.67;RS=1080x2400;OI=1;OV=11;CP=358;RM=6144;TT=335353;",
        "2201116pi": "->x4 pro 5g",
        "x3": "RE=2020.09;SZ=76.8x165.3x10.1;WT=225;DS=6.67;RS=1080x2400;OI=1;OV=10;CP=364;RM=6144;TT=301581;",
        "x3 sn": "->x3",
        "m2007j20ci": "->x3",
        "c3": "RE=2020.10;SZ=77.1x164.9x9;WT=194;DS=6.43;RS=720x1600;OI=1;OV=10;CP=348;RM=3072;TT=196042;",
        "m2006c3mi": "->c3",
        "m3 pro 5g": "RE=2021.05;SZ=75.3x161.8x8.9;WT=190;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=302;RM=4096;TT=302680",
        "m2103k19pg": "->m3 pro 5g",
        "m2103k19py": "->m3 pro 5g",
        "camellia": "->m3 pro 5g",
        "m2103k19pi": "->m3 pro 5g",
        "c51": "RE=2023.04;SZ=76.8x164.9x9.1;WT=192;DS=6.52;RS=720x1600;OI=1;OV=13;CP=367;",
        "2305epcc4g": "->c51",
        "2201116pg": "->x4 pro 5g",
        "poco x3 nfc": "->x3 nfc",
        "mzb0e6din": "->c51",
        "2302epcc4i": "->c51",
        "mzb9965in": "->x3",
        "mzb07z4in": "->x3",
        "mzb07z3in": "->x3",
        "mzb07z1in": "->x3",
        "mzb07z2in": "->x3",
        "mzb07z0in": "->x3",
        "2302epcc4h": "->c51"
    },
    "oppo": {
        "f17": "RE=2020.09;SZ=72.8x159.8x7.5;WT=163;DS=6.44;RS=1080x2400;OI=1;OV=10;CP=285;RM=4096;",
        "cph2095": "->f17",
        "cph2643": "->f27 pro+",
        "f27 pro+": "RE=2024.06;SZ=74.3x162.7x7.9;WT=177;DS=6.7;RS=1080x2412;OI=1;OV=14;CP=368;RM=8192;",
        "a15": "RE=2020.10;SZ=75.4x164x7.9;WT=175;DS=6.52;RS=720x1600;OI=1;OV=10;CP=38;RM=2048;",
        "a31c": "RE=2015.04;SZ=65.5x131.9x8;WT=135;DS=4.5;RS=480x854;OI=1;OV=4.4;CP=17;RM=1024;",
        "f5 youth": "RE=2017.11;SZ=76x156.5x7.5;WT=152;DS=6.0;RS=1080x2160;OI=1;OV=7.1;CP=166;RM=3072;",
        "cph1725": "->f5 youth",
        "ob-oppo a31c": "->a31c",
        "cph2185": "->a15",
        "k5": "RE=2019.10;SZ=75.2x158.7x8.6;WT=182;DS=6.4;RS=1080x2340;OI=1;OV=9.0;CP=260;RM=6144",
        "pcnm00": "->k5",
        "find x5 pro": "RE=2022.02;SZ=;WT=218;DS=6.7;RS=1440x3216;OI=1;OV=12;CP=357;RM=8192;",
        "pffm20": "->find x5 pro",
        "pfem10": "->find x5 pro",
        "find x3 pro": "RE=2021.03;SZ=74x163.6x8.3;WT=193;DS=6.7;RS=1440x3216;OI=1;OV=11;CP=305;RM=8192;",
        "opg03": "->find x3 pro",
        "cph2173": "->find x3 pro",
        "peem00": "->find x3 pro",
        "find x2 pro": "RE=2020.03;SZ=74.4x165.2x8.8;WT=217;DS=6.7;RS=1440x3168;OI=1;OV=10;CP=207;RM=12288;",
        "opg01": "->find x2 pro",
        "cph2025": "->find x2 pro",
        "pdem30": "->find x2 pro",
        "find x2 lite": "RE=2020.04;SZ=74.3x160.3x8;WT=180;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=242;RM=8192;",
        "cph2005": "->find x2 lite",
        "pad air": "RE=2022.05;SZ=245.1x154.8x6.9;WT=440;DS=10.36;RS=2000x1200;OI=1;OV=12;CP=363;RM=4096;",
        "opd2102a": "->pad air",
        "opd2102": "->pad air",
        "a15s": "RE=2020.12;SZ=75.4x164x7.9;WT=177;DS=6.52;RS=720x1600;OI=1;OV=10;CP=38;RM=4096;",
        "cph2179": "->a15s",
        "a11": "RE=2019.10;SZ=75.6x163.6x9.1;WT=195;DS=6.5;RS=720x1600;OI=1;OV=9;CP=283;RM=4096;",
        "pchm10": "->a11",
        "a11x": "DS=6.5;RS=720x1600;SZ=75.6x163.6x9.1;WT=195;RE=2019.10;OI=1;OV=9;RM=8192;CP=283;",
        "pchm00": "->a11x",
        "find x2": "RE=2020.03;SZ=74.5x164.9x8;WT=209;DS=6.7;RS=1440x3168;OI=1;OV=10;CP=207;RM=8192;",
        "pdem10": "->find x2",
        "cph2023": "->find x2",
        "pdet10": "->find x2",
        "find 7a": "RE=2014.03;SZ=75x152.6x9.2;WT=170;DS=5.5;RS=1080x1920;OI=1;OV=4.3;CP=139;RM=2048;",
        "x9007": "->find 7a",
        "x9006": "->find 7a",
        "x9000": "->find 7a",
        "find 7": "RE=2014.03;SZ=75x152.6x9.2;WT=171;DS=5.5;RS=1440x2560;OI=1;OV=4.3;CP=243;RM=3072;",
        "x9076": "->find 7",
        "x9070": "->find 7",
        "x9077": "->find 7",
        "a12": "RE=2020.04;SZ=75.5x155.9x8.3;WT=165;DS=6.22;RS=720x1520;OI=1;OV=9;CP=38;RM=3072;",
        "cph2077": "->a12",
        "cph2083": "->a12",
        "a3": "RE=2018.04;SZ=75.3x156x7.8;WT=159;DS=6.2;RS=1080x2280;OI=1;OV=8.1;CP=290;RM=4096;",
        "padm00": "->a3",
        "cph1837": "->a3",
        "padt00": "->a3",
        "a31": "RE=2020.02;SZ=75.5x163.9x8.3;WT=180;DS=6.5;RS=720x1600;OI=1;OV=9;CP=342;RM=4096;",
        "cph2015": "->a31",
        "cph2031": "->a31",
        "cph2073": "->a31",
        "cph2081": "->a31",
        "a3s": "RE=2017.07;SZ=75.6x156.2x8.2;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=2048;",
        "cph1805": "->a3s",
        "cph1803": "->a3s",
        "cph1853": "->a3s",
        "pbbm30": "->a3s",
        "a5": "RE=2017.07;SZ=75.6x156.2x8.2;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=3072;",
        "pbam00": "->a5",
        "pbbt30": "->a5",
        "cph1809": "->a5",
        "pbat00": "->a5",
        "ax5": "RE=2017.07;SZ=75.6x156.2x8.2;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=3072;",
        "cph1851": "->ax5",
        "ax5s": "RE=2019.03;SZ=75.4x155.9x8.2;WT=170;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=38;RM=2048;",
        "cph1920": "->ax5s",
        "a5 (2020)": "RE=2019.09;SZ=75.4x163.6x9.1;WT=195;DS=6.5;RS=720x1600;OI=1;OV=9;CP=283;RM=4096;",
        "cph1943": "->a5 (2020)",
        "cph1931": "->a5 (2020)",
        "cph1933": "->a5 (2020)",
        "a52": "RE=2020.04;SZ=75.5x162x8.9;WT=192;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=283;RM=4096;",
        "cph2061": "->a52",
        "pdam10": "->a52",
        "cph2069": "->a52",
        "a32": "RE=2020.09;SZ=75.1x163.9x8.4;WT=186;DS=6.5;RS=720x1600;OI=1;OV=10;CP=244;RM=4096;",
        "pdvm00": "->a32",
        "a53": "RE=2020.08;SZ=75.1x163.9x8.4;WT=186;DS=6.5;RS=720x1600;OI=1;OV=10;CP=244;RM=4096;",
        "cph2127": "->a53",
        "a57": "RE=2016.11;SZ=72.9x149.1x7.7;WT=147;DS=5.2;RS=720x1280;OI=1;OV=6;CP=35;RM=3072;",
        "cph1701": "->a57",
        "a5s": "RE=2019.03;SZ=75.4x155.9x8.2;WT=170;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=38;RM=2048;",
        "cph1912": "->a5s",
        "cph1910": "->a5s",
        "cph1909": "->a5s",
        "a7": "RE=2018.11;SZ=75.4x155.9x8.1;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=3072;",
        "cph1905": "->a7",
        "pbfm00": "->a7",
        "cph1901": "->a7",
        "pbft00": "->a7",
        "a7x": "RE=2018.09;SZ=74x156.7x8;WT=169;DS=6.3;RS=1080x2340;OI=1;OV=8.1;CP=290;RM=4096;",
        "pbbt00": "->a7x",
        "pbbm00": "->a7x",
        "a71": "RE=2017.09;SZ=73.8x148.1x7.6;WT=137;DS=5.2;RS=720x1280;OI=1;OV=7.1;CP=40;RM=3072;",
        "cph1717": "->a71",
        "cph1801": "->a71 (2018)",
        "a71 (2018)": "RE=2018.02;SZ=73.8x148.1x7.6;WT=137;DS=5.2;RS=720x1280;OI=1;OV=7.1;CP=214;RM=2048;",
        "a72": "RE=2020.04;SZ=75.5x162x8.9;WT=192;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=283;RM=4096;",
        "pdyt20": "->pdym20",
        "pdym20": "->a72;RE=2020.07;SZ=75x162.2x7.9;WT=175;CP=274;",
        "cph2067": "->a72",
        "a77": "RE=2017.07;SZ=75.9x153.3x7.4;WT=148;DS=5.5;RS=1080x1920;OI=1;OV=7.1;CP=204;RM=4096;",
        "cph1715": "->a77",
        "a7n": "RE=2019.04;SZ=75.4x155.9x8.2;WT=170;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=38;RM=4096;",
        "pcdm00": "->a7n",
        "pcdt00": "->a7n",
        "a83": "RE=2018.01;SZ=73.1x150.5x7.7;WT=143;DS=5.7;RS=720x1440;OI=1;OV=7.1;CP=166;RM=2048;",
        "cph1729": "->a83",
        "a9 (2020)": "RE=2019.09;SZ=75.6x163.6x9.1;WT=195;DS=6.5;RS=720x1600;OI=1;OV=9;CP=283;RM=4096;",
        "cph1937": "->a9 (2020)",
        "pchm30": "->a9 (2020)",
        "cph1941": "->a9 (2020)",
        "a9": "RE=2019.04;SZ=76.1x162x8.3;WT=190;DS=6.53;RS=1080x2340;OI=1;OV=9;CP=114;RM=4096;",
        "pcam10": "->a9",
        "pcat10": "->a9",
        "cph1938": "->a9",
        "a16": "RE=2021.07;SZ=75.6x163.8x8.4;WT=190;DS=6.52;RS=720x1600;OI=1;OV=11;CP=348;RM=3072;",
        "cph2269": "->a16",
        "a16s": "SZ=75.6x163.78x8.4;WT=190;RS=720x1600;DS=6.52;OI=1;OV=11;CP=348;RM=4096;RE=2021.08;",
        "cph2271": "->a16s",
        "a9x": "RE=2019.05;SZ=76.1x162x8.3;WT=190;DS=6.53;RS=1080x2340;OI=1;OV=9.0;CP=114;RM=6144;",
        "pcem00": "->a9x",
        "pcet00": "->a9x",
        "a8": "RE=2019.12;SZ=75.5x163.9x8.3;WT=180;DS=6.5;RS=720x1600;OI=1;OV=9;CP=342;RM=4096;",
        "pdbm00": "->a8",
        "a91": "RE=2019.12;SZ=73.3x160.2x7.9;WT=172;DS=6.4;RS=1080x2400;OI=1;OV=9;CP=114;RM=4096;",
        "pcpm00": "->a91",
        "cph2001": "->a91",
        "cph2021": "->a91",
        "a92": "RE=2020.05;SZ=75.5x162x8.9;WT=192;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=283;RM=6144;",
        "cph2059": "->a92",
        "a92s": "RE=2020.04;SZ=75.5x163.8x8.1;WT=184;DS=6.57;RS=1080x2400;OI=1;OV=10;CP=344;RM=6144;",
        "pdkt00": "->a92s",
        "pdkm00": "->a92s",
        "ax7": "RE=2018.11;SZ=75.4x155.9x8.1;WT=168;DS=6.2;RS=720x1520;OI=1;OV=8.1;CP=214;RM=3072;SM=2;",
        "cph1903": "->ax7",
        "f11 pro": "RE=2019.03;SZ=76.1x161.3x8.8;WT=190;DS=6.53;RS=1080x2340;OI=1;OV=9;CP=114;RM=4096;",
        "cph1969": "->f11 pro",
        "cph1987": "->f11 pro",
        "f11": "RE=2019.03;SZ=76.1x162x8.3;WT=188;DS=6.53;RS=1080x2340;OI=1;OV=9;CP=114;RM=4096;",
        "cph1911": "->f11",
        "cph1913": "->f11",
        "cph1915": "->f11",
        "r17 pro": "RE=2018.08;SZ=74.6x157.6x7.9;WT=183;DS=6.4;RS=1080x2340;OI=1;OV=8.1;CP=62;RM=6144;",
        "cph1877": "->r17 pro",
        "pbdm00": "->r17 pro",
        "pbdt00": "->r17 pro",
        "r17": "RE=2018.08;SZ=74.9x157.5x7.5;WT=182;DS=6.4;RS=1080x2340;OI=1;OV=8.1;CP=298;RM=6144;",
        "pbem00": "->r17",
        "cph1879": "->r17",
        "pbet00": "->r17",
        "f17 pro": "RE=2020.09;SZ=73.8x160.1x7.5;WT=164;DS=6.43;RS=1080x2400;OI=1;OV=10;CP=345;RM=8192;",
        "cph2119": "->f17 pro",
        "reno 2z": "RE=2019.08;SZ=75.8x162.4x8.7;WT=195;DS=6.53;RS=1080x2340;OI=1;OV=9;CP=346;RM=8192;",
        "cph1945": "->reno 2z",
        "pckm80": "->reno 2z",
        "cph1951": "->reno 2z",
        "reno 2": "RE=2019.08;SZ=74.3x160x9.5;WT=189;DS=6.5;RS=1080x2400;OI=1;OV=9;CP=260;RM=8192;",
        "cph1907": "->reno 2",
        "pckm00": "->reno 2",
        "reno 2f": "RE=2019.08;SZ=75.8x162.4x8.7;WT=195;DS=6.5;RS=1080x2340;OI=1;OV=9;CP=114;RM=8192;",
        "cph1989": "->reno 2f",
        "reno": "RE=2019.04;SZ=74.3x156.6x9;WT=185;DS=6.4;RS=1080x2340;OI=1;OV=9;CP=62;RM=6144;",
        "cph1917": "->reno",
        "pcat00": "->reno",
        "pcam00": "->reno",
        "pccm00": "->reno 10x zoom",
        "reno 10x zoom": "RE=2019.04;SZ=77.2x162x9.3;WT=210;DS=6.6;RS=1080x2340;OI=1;OV=9;CP=234;RM=6144;",
        "cph1919": "->reno 10x zoom",
        "reno 3": "RE=2020.03;SZ=73.3x160.2x7.9;WT=170;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=346;RM=8192;",
        "cph2043": "->reno 3",
        "reno 3 5g": "RE=2019.12;SZ=74.3x160.3x8;WT=181;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=347;RM=8192;",
        "pdcm00": "->reno 3 5g",
        "reno 3 pro": "RE=2020.03;SZ=73.4x158.8x8.1;WT=175;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=345;RM=8192;",
        "cph2035": "->reno 3 pro",
        "cph2037": "->reno 3 pro",
        "cph2009": "->reno 3 pro",
        "pcrm00": "->reno 3 pro",
        "cph2036": "->reno 3 pro",
        "reno 3 lite": "RE=2020.02;SZ=74.3x160.3x8.0;WT=180;DS=6.4;RS=1080x2400;CP=242;RM=8192;OI=1;OV=10;",
        "pcrt01": "->reno 3 lite",
        "reno 3a": "SZ=74x161x8.2;WT=175;DS=6.44;CP=283;RS=1080x2400;RM=6144;OI=1;OV=10;RE-2020.06;",
        "cph2013": "->reno 3a",
        "reno 4 4g": "RE=2020.07;SZ=73.9x160.3x7.7;WT=165;DS=6.4;RS=1080x2400;OI=1;OV=10;CP=273;RM=8192",
        "cph2113": "->reno 4 4g",
        "a1k": "RE=2019.04;SZ=73.8x154.5x8.4;WT=170;DS=6.1;RS=720x1560;OI=1;OV=9;CP=171;RM=2048;",
        "cph1923": "->a1k",
        "f7": "RE=2018.03;SZ=75.3x156x7.8;WT=158;DS=6.23;RS=1080x2280;OI=1;OV=8.1;CP=290;RM=4096;",
        "cph1859": "->f7",
        "cph1821": "->f7",
        "cph1819": "->f7",
        "f9": "RE=2018.08;SZ=74x156.7x8;WT=169;DS=6.3;RS=1080x2340;OI=1;OV=8.1;CP=290;RM=4096;",
        "cph1881": "->f9",
        "cph1825": "->f9",
        "find x": "RE=2018.06;SZ=74.2x156.7x9.4;WT=186;DS=6.42;RS=1080x2340;OI=1;OV=8.1;CP=198;RM=8192;",
        "paft00": "->find x",
        "cph1871": "->find x",
        "cph1875": "->find x",
        "pafm00": "->find x",
        "f5": "RE=2017.10;SZ=76x156.5x7.5;WT=152;DS=6.0;RS=1080x2160;OI=1;OV=7.1.1;CP=166;RM=4096;",
        "cph1723": "->f5",
        "cph1727": "->f5",
        "k1": "RE=2018.10;SZ=75.5x158.3x7.4;WT=156;DS=6.4;RS=1080x2340;OI=1;OV=8.1;CP=61;RM=4096;",
        "pbcm30": "->k1",
        "pbct10": "->k1",
        "k3": "RE=2019.05;SZ=76x161.2x9.4;WT=191;DS=6.5;RS=1080x2340;OI=1;OV=9;CP=62;RM=6144",
        "cph1955": "->k3",
        "reno 4 5g": "RE=2020.06;SZ=74x159.3x7.8;WT=183;DS=6.43;RS=1080x2400;OI=1;OV=10;CP=242;RM=8192;",
        "pdpt00": "->reno 4 5g",
        "pdpm00": "->reno 4 5g",
        "cph2091": "->reno 4 5g",
        "reno 5": "RE=2020.12;SZ=73.3x159.1x7.7;WT=171;DS=6.4;RS=1080x2400;OI=1;OV=11;CP=273;RM=8192;",
        "cph2159": "->reno 5",
        "reno 5a": "OI=1;OV=11;RM=6144;WT=182;SZ=74.60x162x8.20;DS=6.5;RS=1080x2400;CP=242;RE=2021.12;",
        "cph2199": "->reno 5a",
        "a101op": "->reno 5a",
        "reno 6": "RE=2021.07;SZ=73.3x159.1x7.8;WT=173;DS=6.4;RS=1080x2400;OI=1;OV=11;CP=273;RM=8192;",
        "cph2235": "->reno 6",
        "peqm00": "->reno 6",
        "cph2251": "->reno 6",
        "reno 6 pro": "RE=2021.05;SZ=73.1x160x7.6;WT=177;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=324;RM=8192;",
        "pepm00": "->reno 6 pro",
        "reno 6 pro 5g": "RE=2021.05;SZ=73.1x160x7.6;WT=177;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=324;RM=8192;",
        "cph2249": "->reno 6 pro 5g",
        "cph2247": "->reno 6 pro 5g",
        "reno 6 pro+": "->reno 6 pro plus",
        "penm00": "->reno 6 pro plus",
        "reno 6 pro plus": "RE=2021.05;SZ=72.5x160.8x8;WT=188;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=304;RM=8192;",
        "reno 5z": "RE=2021.04;SZ=73.4x160.1x7.8;WT=173;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=300;RM=8192;",
        "cph2211": "->reno 5z",
        "reno5 pro 5g": "->reno 5 pro 5g",
        "reno 5 pro 5g": "RE=2020.12;SZ=73.2x159.7x7.6;WT=173;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=296;RM=8192;",
        "pdsm00": "->reno 5 pro 5g",
        "pdst00": "->reno 5 pro 5g",
        "cph2207": "->reno 5 pro 5g",
        "cph2201": "->reno 5 pro 5g",
        "reno 5 5g": "RE=2020.12;SZ=73.4x159.1x7.9;WT=172;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=242;RM=8192;",
        "pegt00": "->reno 5 5g",
        "pegm00": "->reno 5 5g",
        "cph2145": "->reno 5 5g",
        "reno 5 lite": "RE=2021.03;SZ=73.2x160.1x7.8;WT=172;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=345;RM=8192;",
        "cph2205": "->reno 5 lite",
        "reno 5 pro plus 5g": "RE=2020.12;SZ=72.5x159.9x8;WT=184;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=207;RM=8192;",
        "pdrm00": "->reno 5 pro plus 5g",
        "pdrt00": "->reno 5 pro plus 5g",
        "reno 5f": "RE=2021.03;SZ=73.2x160.1x7.8;WT=172;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=345;RM=8192;",
        "cph2217": "->reno 5f",
        "a94": "RE=2021.03;SZ=73.2x160.1x7.8;WT=172;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=345;RM=8192;",
        "cph2203": "->a94",
        "a74 5g": "RE=2021.04;SZ=74.7x162.9x8.4;WT=190;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=307;RM=6144;",
        "cph2197": "->a74 5g",
        "a54 5g": "RE=2021.04;SZ=74.7x162.9x8.4;WT=190;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=307;RM=4096;",
        "cph2195": "->a54 5g",
        "cph2303": "->a54 5g",
        "opg02": "->a54 5g",
        "a55s 5g": "RE=2021.11;SZ=74.7x162.1x8.2;WT=178;DS=6.5;RS=1080x2400;CP=307;RM=4096;OI=1;OV=11;",
        "a102op": "->a55s 5g",
        "cph2309": "->a55s 5g",
        "a55": "RE=2021.10;SZ=75.7x163.6x8.4;WT=193;DS=6.51;RS=720x1600;CP=323;RM=4096;OI=1;OV=11;",
        "cph2325": "->a55",
        "a55 5g": "RE=2021.01;SZ=75.7x163.9x8.4;WT=186;DS=6.5;RS=720x1600;CP=302;RM=6144;OI=1;OV=11;",
        "pemm00": "->a55 5g",
        "pemt00": "->a55 5g",
        "pemm20": "->a55 5g",
        "r11 plus": "RE=2017.06;SZ=81.5x165.8x7.8;WT=188;DS=6.0;RS=1080x1920;OI=1;OV=7.1.1;CP=61;RM=6144;",
        "r11 pluskt": "->r11 plus",
        "r15": "RE=2018.03;SZ=75.2x155.1x7.4;WT=175;DS=6.28;RS=1080x2280;OI=1;OV=8.1;CP=290;RM=4096;",
        "pact00": "->r15",
        "cph1835": "->r15",
        "pacm00": "->r15",
        "paam00": "->r15",
        "r15 pro": "RE=2018.03;SZ=75.2x156.5x8;WT=180;DS=6.28;RS=1080x2280;OI=1;OV=8.1;CP=61;RM=6144;",
        "cph1831": "->r15 pro",
        "cph1833": "->r15 pro",
        "paat00": "->r15 pro",
        "find muse": "RE=2013.03;SZ=63.5x123x9.9;WT=;DS=4.0;RS=480x800;OI=1;OV=4.2;CP=24;RM=512;",
        "r821": "->find muse",
        "r821t": "->find muse",
        "reno 6 z 5g": "RE=2021.07;SZ=73.4x160.2x7.9;WT=173;DS=6.4;RS=1080x2400;OI=1;OV=11;CP=300;RM=8192;",
        "cph2237": "->reno 6 z 5g",
        "reno 4 pro 5g": "RE=2020.06;SZ=72.5x159.6x7.6;WT=172;DS=6.55;RS=1080x2400;OI=1;OV=10;CP=242;RM=8192;",
        "pdnt00": "->reno 4 pro 5g",
        "pdnm00": "->reno 4 pro 5g",
        "cph2089": "->reno 4 pro 5g",
        "reno 5g": "RE=2019.04;SZ=77.2x162x9.3;WT=215;DS=6.6;RS=1080x2340;OI=1;OV=9.0;CP=234;RM=8192;",
        "cph1921": "->reno 5g",
        "reno 4z 5g": "RE=2020.09;SZ=75.5x163.8x8.1;WT=184;DS=6.57;RS=1080x2400;OI=1;OV=10;CP=344;RM=8192;TT=295562;",
        "cph2065": "->reno 4z 5g",
        "reno4 z 5g": "->reno 4z 5g",
        "reno 4 se 5g": "RE=2020.09;SZ=73.9x160.5x7.8;WT=169;DS=6.43;RS=1080x2400;CP=274;RM=8192;OI=1;OV=10;TT=301000;",
        "peam00": "->reno 4 se 5g",
        "peat00": "->reno 4 se 5g",
        "k9 pro 5g": "RE=2021.09;SZ=73.5x158.7x8.5;WT=180;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=324;RM=8192;",
        "peym00": "->k9 pro 5g",
        "k9 5g": "RE=2021.05;SZ=73.4x159.1x7.9;WT=172;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=242;RM=8192;TT=449750;",
        "pexm00": "->k9 5g",
        "cph2123": "->a93",
        "a93": "RE=2021.01;SZ=74.7x162.9x8.4;WT=188;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=307;RM=8192;",
        "pehm00": "->a93",
        "peht00": "->a93",
        "a73 5g": "RE=2020.11;SZ=75x162.2x7.9;WT=177;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=274;RM=8192;",
        "cph2161": "->a73 5g",
        "find x3": "RE=2021.03;SZ=74x163.6x8.3;WT=193;DS=6.7;RS=1440x3216;OI=1;OV=11;CP=207;RM=8192;",
        "pedm00": "->find x3",
        "find x3 lite": "RE=2021.03;SZ=73.4x159.1x7.9;WT=172;DS=6.43;RS=1080x2400;OI=1;OV=11;CP=242;RM=8192;",
        "find x3 neo": "RE=2021.03;SZ=72.5x159.9x8;WT=184;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=207;RM=12288;",
        "reno 8 pro": "RE=2022.07;SZ=73.4x160.6x7.7;WT=179;DS=6.4;RS=1080x2400;OI=1;OV=12;CP=369;RM=8192;TG=2694;TT=619610;",
        "cph2359": "->reno 8 pro",
        "a97": "RE=2022.07;SZ=75.1x163.8x8;WT=188;DS=6.6;RS=1080x2408;OI=1;OV=12;CP=372;RM=12288;",
        "pftm10": "->a97",
        "cph2139": "->a53",
        "a001op": "->reno 3 5g",
        "a002op": "->reno 3a",
        "cph2121": "->a93",
        "pcht30": "->a11x",
        "cph2131": "->a53",
        "cph2263": "->a74 5g",
        "pdat10": "->a52",
        "r11 plusk": "->r11 plus",
        "pcrt00": "->reno 3 pro",
        "pemt20": "->a55 5g",
        "a103op": "->reno 5a",
        "cph2333": "->a94",
        "cph2275": "->a16",
        "reno5 z 5g": "->reno 5z",
        "reno5 5g": "->reno 5 5g",
        "cph1939": "->a9",
        "pdct00": "->reno 3",
        "pccm40": "->reno 5g",
        "chp1723": "->f5",
        "cph2407": "->a57",
        "reno6 5g": "->reno 6",
        "reno6 z 5g": "->reno 6 z 5g",
        "reno6 pro 5g": "->reno 6 pro 5g",
        "reno5 lite": "->reno 5 lite",
        "reno5 a 5g": "->reno 5a",
        "reno5 4g": "->reno 5",
        "cph2048": "->reno 3 5g",
        "cph1821ex": "->f7",
        "reno4 se 5g": "->reno 4 se 5g",
        "rx17pro": "->r17 pro",
        "pcht10": "->a11",
        "cph2669": "->a3",
        "chp2365": "->a94"
    },
    "maze": {
        "alpha": "DS=6;RS=1080x1920;SZ=82.5x159.8x8.1;WT=225;RE=2017.06;OI=1;OV=7;RM=6144;CP=343;",
        "alpha x": "DS=6;RS=1080x2160;SZ=74.6x156.4x8.1;WT=209;RE=2017.10;OI=1;OV=7;RM=6144;CP=343;",
        "comet": "DS=5.7;RS=720x1440;SZ=73.5x158.8x9.9;WT=234;RE=2017.11;OI=1;OV=7;RM=4096;CP=162;",
        "blade": "DS=5.5;RS=1080x1920;SZ=77x158.5x8;WT=190;RE=2017.04;OI=1;OV=6;RM=3072;CP=118;"
    },
    "nomi": {
        "libra 4 lte": "DS=8;RS=1280x800;SZ=212x124x9.5;WT=350;OI=1;OV=8.1;RM=1024;CP=163;",
        "c080034": "->libra 4 lte"
    },
    "i-mobile": {
        "i-note 2": "RS=800x480;DS=7;CP=219;OI=1;OV=4.1;SZ=194.8x123x12.8;WT=300;"
    },
    "kiowa": {
        "s5 cristal": "RE=2018.07;WT=;DS=5;RS=480x854;OI=1;OV=8.1;CP=6;RM=1024;SM=2"
    },
    "cgv": {
        "ultimate t8": "RE=2015.04;SZ=77.1x151.4x12.2;WT=210;DS=5;RS=720x1280;OI=1;OV=8.1;CP=;RM=2048;SM=2"
    },
    "hoffmann": {
        "x play": "RE=;SZ=71.3x142.5x9.2;WT=165.3;DS=5;RS=;OI=1;OV=6;CP=;RM=2048;SM=2",
        "x-play": "->x play"
    },
    "cyrus": {
        "apel": "RE=2013;SZ=66x132x9.8;WT=130;DS=4.5;RS=540x960;OI=1;OV=4.1;CP=235;RM=512;",
        "cyrusapel": "->apel"
    },
    "xiaomi": {
        "m2006c3mg": "->redmi 9c",
        "redmi 9c": "RE=2020.06;SZ=77x164.9x9;WT=196;DS=6.53;RS=720x1600;OI=1;OV=10;CP=348;RM=2048;",
        "22011119uy": "->redmi 10 (2022)",
        "redmi 10 (2022)": "RE=2022.02;SZ=75.5x162x8.9;WT=181;DS=6.5;RS=1080x2400;OI=1;OV=10;CP=349;RM=4096;",
        "23053rn02y": "->redmi 12",
        "redmi 12": "RE=2023.06;SZ=76.3x168.6x8.2;WT=198.5;DS=6.79;RS=1080x2460;OI=1;OV=13;CP=349;RM=2048;TT=258006;TG=1303;",
        "redmi 9c nfc": "RE=2020.08;SZ=77.1x164.9x9;WT=196;DS=6.53;RS=720x1600;OI=1;OV=10;CP=348;RM=2048;",
        "m2006c3mng": "->redmi 9c nfc",
        "redmi note 8 pro": "RE=2019.08;SZ=76.4x161.4x8.8;WT=200;DS=6.53;RS=1080x2340;OI=1;OV=9;CP=325;GP=120;RM=4096;TT=224759;TG=6999;",
        "redmi note 9 pro": "RE=2020.04;SZ=76.7x165.8x8.8;WT=209;DS=6.67;RS=1080x2400;OI=1;OV=10;CP=273;RM=6144;TT=279625;TG=1785;",
        "m2003j6b2g": "->redmi note 9 pro",
        "redmi 10": "RE=2021.08;SZ=75.5x162x8.9;WT=181;DS=6.5;RS=1080x2400;OI=1;OV=11;CP=349;RM=4096;",
        "21061119dg": "->redmi 10",
        "redmi 10c": "RE=2022.03;SZ=76.6x169.6x8.3;WT=190;DS=6.71;RS=720x1650;OI=1;OV=11;CP=363;RM=3072;",
        "220333qny": "->redmi 10c",
        "mi 11 lite": "RE=2021.03;SZ=75.7x160.5x6.8;WT=157;DS=6.55;RS=1080x2400;OI=1;OV=11;CP=364;RM=4096;TT=290172;TG=1796;",
        "m2101k9ag": "->mi 11 lite",
        "m1906g7g": "->redmi note 8 pro",
        "m2003j6a1i": "->redmi note 9 pro",
        "joyeuse": "->redmi note 9 pro",
        "begonia": "->redmi note 8 pro",
        "m2006c3mt": "->redmi 9c",
        "21061119ag": "->redmi 10 (2022)",
        "m2101k9ai": "->mi 11 lite",
        "mi 11 lite 4g": "->mi 11 lite",
        "21061119al": "->redmi 10 (2022)",
        "21121119sg": "->redmi 10 (2022)",
        "220333qag": "->redmi 10c",
        "21121119vl": "->redmi 10 (2022)",
        "220333ql": "->redmi 10c",
        "redmi 10 2022": "->redmi 10 (2022)",
        "angelican": "->redmi 9c nfc",
        "23053rn02a": "->redmi 12",
        "23053rn02l": "->redmi 12",
        "23053rn02i": "->redmi 12"
    },
    "kalley": {
        "black z": "WT=202;DS=6.5;RS=720x1600;SZ=76.3x164.8x8.9;OI=1;OV=12;CP=394;RM=6144;",
        "black g 2": "WT=202;DS=6.5;RS=720x1600;SZ=76.3x164.8x8.9;OI=1;OV=12;CP=394;RM=4096;",
        "element pro 2": "DS=5.5;RM=1024;SM=2",
        "pro 2": "->element pro 2"
    },
    "just5": {
        "blaster": "SZ=71.6x144.5x9.5;WT=185"
    }
};

});

const $2bcd0cec9f1e299c$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $6c9672d0931fa990$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $6c9672d0931fa990$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $6c9672d0931fa990$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $6c9672d0931fa990$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $6c9672d0931fa990$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6c9672d0931fa990$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $6c9672d0931fa990$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $6c9672d0931fa990$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($6c9672d0931fa990$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $6c9672d0931fa990$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $6c9672d0931fa990$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $6c9672d0931fa990$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $6c9672d0931fa990$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $6c9672d0931fa990$var$stringToByteArray$1(str);
    return $6c9672d0931fa990$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $6c9672d0931fa990$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $6c9672d0931fa990$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $6c9672d0931fa990$export$c62426fdd000a97e = function(str) {
    try {
        return $6c9672d0931fa990$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $6c9672d0931fa990$export$6c40052bed430212(value) {
    return $6c9672d0931fa990$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $6c9672d0931fa990$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$6c9672d0931fa990$var$isValidKey(prop)) continue;
        target[prop] = $6c9672d0931fa990$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $6c9672d0931fa990$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $6c9672d0931fa990$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6c9672d0931fa990$var$getDefaultsFromGlobal = ()=>$6c9672d0931fa990$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $6c9672d0931fa990$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $6c9672d0931fa990$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $6c9672d0931fa990$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $6c9672d0931fa990$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $2bcd0cec9f1e299c$export$6d3c090e66a883b1)() || $6c9672d0931fa990$var$getDefaultsFromGlobal() || $6c9672d0931fa990$var$getDefaultsFromEnvVariable() || $6c9672d0931fa990$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $6c9672d0931fa990$export$9c11895284c8adad = (productName)=>$6c9672d0931fa990$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $6c9672d0931fa990$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $6c9672d0931fa990$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $6c9672d0931fa990$export$3dfb6827a9f89756 = ()=>$6c9672d0931fa990$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $6c9672d0931fa990$export$5539a1a3afe87d6 = (name)=>$6c9672d0931fa990$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6c9672d0931fa990$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $6c9672d0931fa990$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $6c9672d0931fa990$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c9672d0931fa990$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $6c9672d0931fa990$export$4b5284a3025a455(JSON.stringify(header)),
        $6c9672d0931fa990$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $6c9672d0931fa990$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $6c9672d0931fa990$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($6c9672d0931fa990$var$emulatorStatus))if ($6c9672d0931fa990$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $6c9672d0931fa990$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $6c9672d0931fa990$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $6c9672d0931fa990$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$6c9672d0931fa990$export$5b4d24b45140ad90(window.location.host) || $6c9672d0931fa990$var$emulatorStatus[name] === isRunningEmulator || $6c9672d0931fa990$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $6c9672d0931fa990$var$previouslyDismissed) return;
    $6c9672d0931fa990$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $6c9672d0931fa990$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $6c9672d0931fa990$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $6c9672d0931fa990$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $6c9672d0931fa990$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $6c9672d0931fa990$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($6c9672d0931fa990$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $6c9672d0931fa990$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $6c9672d0931fa990$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $6c9672d0931fa990$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $6c9672d0931fa990$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $6c9672d0931fa990$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $6c9672d0931fa990$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $6c9672d0931fa990$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $6c9672d0931fa990$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $6c9672d0931fa990$export$f2f6a8999f8ebd30() {
    return $6c9672d0931fa990$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $6c9672d0931fa990$export$7e7b1a9668aaed8() {
    const ua = $6c9672d0931fa990$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $6c9672d0931fa990$export$202944b2d2824246() {
    return $6c9672d0931fa990$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $6c9672d0931fa990$export$5d1d834fbbf8bab7() {
    return $6c9672d0931fa990$export$588c7fdda06fbb0a.NODE_CLIENT === true || $6c9672d0931fa990$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $6c9672d0931fa990$export$95df08bae54cb4df() {
    return !$6c9672d0931fa990$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $6c9672d0931fa990$export$ef10bcfb06572016() {
    return !$6c9672d0931fa990$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $6c9672d0931fa990$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $6c9672d0931fa990$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $6c9672d0931fa990$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $6c9672d0931fa990$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $6c9672d0931fa990$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $6c9672d0931fa990$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $6c9672d0931fa990$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $6c9672d0931fa990$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $6c9672d0931fa990$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $6c9672d0931fa990$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $6c9672d0931fa990$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $6c9672d0931fa990$var$replaceTemplate(template, data) {
    return template.replace($6c9672d0931fa990$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $6c9672d0931fa990$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $6c9672d0931fa990$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $6c9672d0931fa990$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $6c9672d0931fa990$export$c5a53ce6a17cf18d($6c9672d0931fa990$export$c62426fdd000a97e(parts[0]) || '');
        claims = $6c9672d0931fa990$export$c5a53ce6a17cf18d($6c9672d0931fa990$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$5f870fcca7ae6a88 = function(token) {
    const claims = $6c9672d0931fa990$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$701c661ec91095f2 = function(token) {
    const claims = $6c9672d0931fa990$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $6c9672d0931fa990$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $6c9672d0931fa990$export$fc970ed23da99565 = function(token) {
    const claims = $6c9672d0931fa990$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c9672d0931fa990$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $6c9672d0931fa990$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $6c9672d0931fa990$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $6c9672d0931fa990$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $6c9672d0931fa990$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($6c9672d0931fa990$var$isObject(aProp) && $6c9672d0931fa990$var$isObject(bProp)) {
            if (!$6c9672d0931fa990$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $6c9672d0931fa990$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $6c9672d0931fa990$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $6c9672d0931fa990$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $6c9672d0931fa990$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $6c9672d0931fa990$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $6c9672d0931fa990$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $6c9672d0931fa990$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $6c9672d0931fa990$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $6c9672d0931fa990$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $6c9672d0931fa990$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($6c9672d0931fa990$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $6c9672d0931fa990$var$noop;
        if (observer.error === undefined) observer.error = $6c9672d0931fa990$var$noop;
        if (observer.complete === undefined) observer.complete = $6c9672d0931fa990$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $6c9672d0931fa990$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $6c9672d0931fa990$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $6c9672d0931fa990$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $6c9672d0931fa990$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $6c9672d0931fa990$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $6c9672d0931fa990$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($6c9672d0931fa990$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $6c9672d0931fa990$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($6c9672d0931fa990$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $6c9672d0931fa990$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($6c9672d0931fa990$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $6c9672d0931fa990$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $6c9672d0931fa990$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $6c9672d0931fa990$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $6c9672d0931fa990$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $6c9672d0931fa990$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $6c9672d0931fa990$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $6c9672d0931fa990$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $6c9672d0931fa990$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $6c9672d0931fa990$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $6c9672d0931fa990$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $6c9672d0931fa990$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($6c9672d0931fa990$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $6c9672d0931fa990$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $6c9672d0931fa990$var$indicator(i);
}
function $6c9672d0931fa990$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c9672d0931fa990$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $7e2e34d8482c77be$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $7e2e34d8482c77be$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $6c9672d0931fa990$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($7e2e34d8482c77be$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $7e2e34d8482c77be$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $7e2e34d8482c77be$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $7e2e34d8482c77be$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $7e2e34d8482c77be$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $7e2e34d8482c77be$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $7e2e34d8482c77be$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $4a1763e4248d914b$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $4a1763e4248d914b$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($4a1763e4248d914b$export$243e62d78d3b544d || ($4a1763e4248d914b$export$243e62d78d3b544d = {}));
const $4a1763e4248d914b$var$levelStringToEnum = {
    'debug': $4a1763e4248d914b$export$243e62d78d3b544d.DEBUG,
    'verbose': $4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE,
    'info': $4a1763e4248d914b$export$243e62d78d3b544d.INFO,
    'warn': $4a1763e4248d914b$export$243e62d78d3b544d.WARN,
    'error': $4a1763e4248d914b$export$243e62d78d3b544d.ERROR,
    'silent': $4a1763e4248d914b$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $4a1763e4248d914b$var$defaultLogLevel = $4a1763e4248d914b$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $4a1763e4248d914b$var$ConsoleMethod = {
    [$4a1763e4248d914b$export$243e62d78d3b544d.DEBUG]: 'log',
    [$4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$4a1763e4248d914b$export$243e62d78d3b544d.INFO]: 'info',
    [$4a1763e4248d914b$export$243e62d78d3b544d.WARN]: 'warn',
    [$4a1763e4248d914b$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $4a1763e4248d914b$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $4a1763e4248d914b$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $4a1763e4248d914b$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $4a1763e4248d914b$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $4a1763e4248d914b$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $4a1763e4248d914b$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $4a1763e4248d914b$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $4a1763e4248d914b$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $4a1763e4248d914b$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $4a1763e4248d914b$export$c622e99c0ce7b1c9(level) {
    $4a1763e4248d914b$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $4a1763e4248d914b$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $4a1763e4248d914b$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $4a1763e4248d914b$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $4a1763e4248d914b$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $a6f488ce4cf7dbe7$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a6f488ce4cf7dbe7$var$idbProxyableTypes;
let $a6f488ce4cf7dbe7$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a6f488ce4cf7dbe7$var$getIdbProxyableTypes() {
    return $a6f488ce4cf7dbe7$var$idbProxyableTypes || ($a6f488ce4cf7dbe7$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a6f488ce4cf7dbe7$var$getCursorAdvanceMethods() {
    return $a6f488ce4cf7dbe7$var$cursorAdvanceMethods || ($a6f488ce4cf7dbe7$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a6f488ce4cf7dbe7$var$cursorRequestMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transactionDoneMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transactionStoreNamesMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transformCache = new WeakMap();
const $a6f488ce4cf7dbe7$export$407448d2b89b1813 = new WeakMap();
function $a6f488ce4cf7dbe7$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a6f488ce4cf7dbe7$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a6f488ce4cf7dbe7$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a6f488ce4cf7dbe7$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a6f488ce4cf7dbe7$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $a6f488ce4cf7dbe7$var$transactionDoneMap.set(tx, done);
}
let $a6f488ce4cf7dbe7$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $a6f488ce4cf7dbe7$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $a6f488ce4cf7dbe7$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $a6f488ce4cf7dbe7$export$43caf9889c228507(callback) {
    $a6f488ce4cf7dbe7$var$idbProxyTraps = callback($a6f488ce4cf7dbe7$var$idbProxyTraps);
}
function $a6f488ce4cf7dbe7$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), storeNames, ...args);
        $a6f488ce4cf7dbe7$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a6f488ce4cf7dbe7$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), args);
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b($a6f488ce4cf7dbe7$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(func.apply($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), args));
    };
}
function $a6f488ce4cf7dbe7$var$transformCachableValue(value) {
    if (typeof value === 'function') return $a6f488ce4cf7dbe7$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a6f488ce4cf7dbe7$var$cacheDonePromiseForTransaction(value);
    if ($a6f488ce4cf7dbe7$export$23f2a1d2818174ef(value, $a6f488ce4cf7dbe7$var$getIdbProxyableTypes())) return new Proxy(value, $a6f488ce4cf7dbe7$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a6f488ce4cf7dbe7$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a6f488ce4cf7dbe7$var$transformCache.has(value)) return $a6f488ce4cf7dbe7$var$transformCache.get(value);
    const newValue = $a6f488ce4cf7dbe7$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a6f488ce4cf7dbe7$var$transformCache.set(value, newValue);
        $a6f488ce4cf7dbe7$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a6f488ce4cf7dbe7$export$3b14a55fb2447963 = (value)=>$a6f488ce4cf7dbe7$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $92f73a92431170de$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $92f73a92431170de$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $92f73a92431170de$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $92f73a92431170de$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $92f73a92431170de$var$cachedMethods = new Map();
function $92f73a92431170de$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($92f73a92431170de$var$cachedMethods.get(prop)) return $92f73a92431170de$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $92f73a92431170de$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $92f73a92431170de$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $92f73a92431170de$var$cachedMethods.set(prop, method);
    return method;
}
(0, $a6f488ce4cf7dbe7$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$92f73a92431170de$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$92f73a92431170de$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8b041be78626b50a$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($8b041be78626b50a$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $8b041be78626b50a$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $8b041be78626b50a$var$name$q = "@firebase/app";
const $8b041be78626b50a$var$version$1 = "0.14.6";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$logger = new (0, $4a1763e4248d914b$export$efa9a398d6368992)('@firebase/app');
const $8b041be78626b50a$var$name$p = "@firebase/app-compat";
const $8b041be78626b50a$var$name$o = "@firebase/analytics-compat";
const $8b041be78626b50a$var$name$n = "@firebase/analytics";
const $8b041be78626b50a$var$name$m = "@firebase/app-check-compat";
const $8b041be78626b50a$var$name$l = "@firebase/app-check";
const $8b041be78626b50a$var$name$k = "@firebase/auth";
const $8b041be78626b50a$var$name$j = "@firebase/auth-compat";
const $8b041be78626b50a$var$name$i = "@firebase/database";
const $8b041be78626b50a$var$name$h = "@firebase/data-connect";
const $8b041be78626b50a$var$name$g = "@firebase/database-compat";
const $8b041be78626b50a$var$name$f = "@firebase/functions";
const $8b041be78626b50a$var$name$e = "@firebase/functions-compat";
const $8b041be78626b50a$var$name$d = "@firebase/installations";
const $8b041be78626b50a$var$name$c = "@firebase/installations-compat";
const $8b041be78626b50a$var$name$b = "@firebase/messaging";
const $8b041be78626b50a$var$name$a = "@firebase/messaging-compat";
const $8b041be78626b50a$var$name$9 = "@firebase/performance";
const $8b041be78626b50a$var$name$8 = "@firebase/performance-compat";
const $8b041be78626b50a$var$name$7 = "@firebase/remote-config";
const $8b041be78626b50a$var$name$6 = "@firebase/remote-config-compat";
const $8b041be78626b50a$var$name$5 = "@firebase/storage";
const $8b041be78626b50a$var$name$4 = "@firebase/storage-compat";
const $8b041be78626b50a$var$name$3 = "@firebase/firestore";
const $8b041be78626b50a$var$name$2 = "@firebase/ai";
const $8b041be78626b50a$var$name$1 = "@firebase/firestore-compat";
const $8b041be78626b50a$var$name = "firebase";
const $8b041be78626b50a$var$version = "12.6.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $8b041be78626b50a$export$9f30fa0c10967f7f = '[DEFAULT]';
const $8b041be78626b50a$var$PLATFORM_LOG_STRING = {
    [$8b041be78626b50a$var$name$q]: 'fire-core',
    [$8b041be78626b50a$var$name$p]: 'fire-core-compat',
    [$8b041be78626b50a$var$name$n]: 'fire-analytics',
    [$8b041be78626b50a$var$name$o]: 'fire-analytics-compat',
    [$8b041be78626b50a$var$name$l]: 'fire-app-check',
    [$8b041be78626b50a$var$name$m]: 'fire-app-check-compat',
    [$8b041be78626b50a$var$name$k]: 'fire-auth',
    [$8b041be78626b50a$var$name$j]: 'fire-auth-compat',
    [$8b041be78626b50a$var$name$i]: 'fire-rtdb',
    [$8b041be78626b50a$var$name$h]: 'fire-data-connect',
    [$8b041be78626b50a$var$name$g]: 'fire-rtdb-compat',
    [$8b041be78626b50a$var$name$f]: 'fire-fn',
    [$8b041be78626b50a$var$name$e]: 'fire-fn-compat',
    [$8b041be78626b50a$var$name$d]: 'fire-iid',
    [$8b041be78626b50a$var$name$c]: 'fire-iid-compat',
    [$8b041be78626b50a$var$name$b]: 'fire-fcm',
    [$8b041be78626b50a$var$name$a]: 'fire-fcm-compat',
    [$8b041be78626b50a$var$name$9]: 'fire-perf',
    [$8b041be78626b50a$var$name$8]: 'fire-perf-compat',
    [$8b041be78626b50a$var$name$7]: 'fire-rc',
    [$8b041be78626b50a$var$name$6]: 'fire-rc-compat',
    [$8b041be78626b50a$var$name$5]: 'fire-gcs',
    [$8b041be78626b50a$var$name$4]: 'fire-gcs-compat',
    [$8b041be78626b50a$var$name$3]: 'fire-fst',
    [$8b041be78626b50a$var$name$1]: 'fire-fst-compat',
    [$8b041be78626b50a$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$8b041be78626b50a$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $8b041be78626b50a$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $8b041be78626b50a$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b041be78626b50a$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $8b041be78626b50a$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $8b041be78626b50a$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $8b041be78626b50a$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $8b041be78626b50a$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($8b041be78626b50a$export$9566bce3835c0f28.has(componentName)) {
        $8b041be78626b50a$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $8b041be78626b50a$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $8b041be78626b50a$export$b4e3c36c855b14b5.values())$8b041be78626b50a$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $8b041be78626b50a$export$fb03ad8d3d5c5f76.values())$8b041be78626b50a$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $8b041be78626b50a$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $8b041be78626b50a$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $8b041be78626b50a$export$9f30fa0c10967f7f) {
    $8b041be78626b50a$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $8b041be78626b50a$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $8b041be78626b50a$export$38e311c93c671bec(obj) {
    if ($8b041be78626b50a$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $8b041be78626b50a$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $8b041be78626b50a$export$3685d89b9c3cdfaf() {
    $8b041be78626b50a$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $8b041be78626b50a$var$ERROR_FACTORY = new (0, $6c9672d0931fa990$export$3fa6e1b18a3b2d40)('app', 'Firebase', $8b041be78626b50a$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8b041be78626b50a$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $7e2e34d8482c77be$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $8b041be78626b50a$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $8b041be78626b50a$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $6c9672d0931fa990$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $8b041be78626b50a$var$FirebaseServerAppImpl extends $8b041be78626b50a$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $8b041be78626b50a$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $8b041be78626b50a$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $8b041be78626b50a$export$d29d5299a7137abc($8b041be78626b50a$var$name$q, $8b041be78626b50a$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $8b041be78626b50a$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $8b041be78626b50a$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $8b041be78626b50a$export$31499a9cd224b78c = $8b041be78626b50a$var$version;
function $8b041be78626b50a$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $8b041be78626b50a$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $8b041be78626b50a$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $6c9672d0931fa990$export$3dfb6827a9f89756)());
    if (!options) throw $8b041be78626b50a$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $8b041be78626b50a$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $6c9672d0931fa990$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $6c9672d0931fa990$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $8b041be78626b50a$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $7e2e34d8482c77be$export$436a80eea5d5c0c5)(name);
    for (const component of $8b041be78626b50a$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $8b041be78626b50a$var$FirebaseAppImpl(options, config, container);
    $8b041be78626b50a$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $8b041be78626b50a$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $6c9672d0931fa990$export$4e09c449d6c407f7)() && !(0, $6c9672d0931fa990$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $8b041be78626b50a$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($8b041be78626b50a$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($8b041be78626b50a$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $6c9672d0931fa990$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $8b041be78626b50a$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $8b041be78626b50a$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $8b041be78626b50a$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $7e2e34d8482c77be$export$436a80eea5d5c0c5)(nameString);
    for (const component of $8b041be78626b50a$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $8b041be78626b50a$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $8b041be78626b50a$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $8b041be78626b50a$export$f9962582c9e66d99(name = $8b041be78626b50a$export$9f30fa0c10967f7f) {
    const app = $8b041be78626b50a$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $8b041be78626b50a$export$9f30fa0c10967f7f && (0, $6c9672d0931fa990$export$3dfb6827a9f89756)()) return $8b041be78626b50a$export$c55cfd413944906d();
    if (!app) throw $8b041be78626b50a$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $8b041be78626b50a$export$68ddedf7d44b3bdf() {
    return Array.from($8b041be78626b50a$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $8b041be78626b50a$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($8b041be78626b50a$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $8b041be78626b50a$export$b4e3c36c855b14b5.delete(name);
    } else if ($8b041be78626b50a$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $8b041be78626b50a$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $8b041be78626b50a$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $8b041be78626b50a$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $8b041be78626b50a$var$logger.warn(warning.join(' '));
        return;
    }
    $8b041be78626b50a$export$c930050e7bb63965(new (0, $7e2e34d8482c77be$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $8b041be78626b50a$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $8b041be78626b50a$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $4a1763e4248d914b$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $8b041be78626b50a$export$c622e99c0ce7b1c9(logLevel) {
    (0, $4a1763e4248d914b$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$DB_NAME = 'firebase-heartbeat-database';
const $8b041be78626b50a$var$DB_VERSION = 1;
const $8b041be78626b50a$var$STORE_NAME = 'firebase-heartbeat-store';
let $8b041be78626b50a$var$dbPromise = null;
function $8b041be78626b50a$var$getDbPromise() {
    if (!$8b041be78626b50a$var$dbPromise) $8b041be78626b50a$var$dbPromise = (0, $92f73a92431170de$export$ca0ed41b1a2af7e)($8b041be78626b50a$var$DB_NAME, $8b041be78626b50a$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($8b041be78626b50a$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $8b041be78626b50a$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $8b041be78626b50a$var$dbPromise;
}
async function $8b041be78626b50a$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $8b041be78626b50a$var$getDbPromise();
        const tx = db.transaction($8b041be78626b50a$var$STORE_NAME);
        const result = await tx.objectStore($8b041be78626b50a$var$STORE_NAME).get($8b041be78626b50a$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $6c9672d0931fa990$export$dd24e9cd51226c56)) $8b041be78626b50a$var$logger.warn(e.message);
        else {
            const idbGetError = $8b041be78626b50a$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $8b041be78626b50a$var$logger.warn(idbGetError.message);
        }
    }
}
async function $8b041be78626b50a$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $8b041be78626b50a$var$getDbPromise();
        const tx = db.transaction($8b041be78626b50a$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($8b041be78626b50a$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $8b041be78626b50a$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $6c9672d0931fa990$export$dd24e9cd51226c56)) $8b041be78626b50a$var$logger.warn(e.message);
        else {
            const idbGetError = $8b041be78626b50a$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $8b041be78626b50a$var$logger.warn(idbGetError.message);
        }
    }
}
function $8b041be78626b50a$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8b041be78626b50a$var$MAX_HEADER_BYTES = 1024;
const $8b041be78626b50a$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $8b041be78626b50a$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $8b041be78626b50a$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $8b041be78626b50a$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $8b041be78626b50a$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $8b041be78626b50a$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $8b041be78626b50a$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $8b041be78626b50a$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $8b041be78626b50a$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $6c9672d0931fa990$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $8b041be78626b50a$var$logger.warn(e);
            return '';
        }
    }
}
function $8b041be78626b50a$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $8b041be78626b50a$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $8b041be78626b50a$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($8b041be78626b50a$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($8b041be78626b50a$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $8b041be78626b50a$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $6c9672d0931fa990$export$3865db50535c2055)()) return false;
        else return (0, $6c9672d0931fa990$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $8b041be78626b50a$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $8b041be78626b50a$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $8b041be78626b50a$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $8b041be78626b50a$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $6c9672d0931fa990$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $8b041be78626b50a$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8b041be78626b50a$var$registerCoreComponents(variant) {
    $8b041be78626b50a$export$c930050e7bb63965(new (0, $7e2e34d8482c77be$export$16fa2f45be04daa8)('platform-logger', (container)=>new $8b041be78626b50a$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $8b041be78626b50a$export$c930050e7bb63965(new (0, $7e2e34d8482c77be$export$16fa2f45be04daa8)('heartbeat', (container)=>new $8b041be78626b50a$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $8b041be78626b50a$export$d29d5299a7137abc($8b041be78626b50a$var$name$q, $8b041be78626b50a$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $8b041be78626b50a$export$d29d5299a7137abc($8b041be78626b50a$var$name$q, $8b041be78626b50a$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $8b041be78626b50a$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $8b041be78626b50a$var$registerCoreComponents('');


var $c3111c3e3c6a9bdc$var$name = "firebase";
var $c3111c3e3c6a9bdc$var$version = "12.6.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $8b041be78626b50a$export$d29d5299a7137abc)($c3111c3e3c6a9bdc$var$name, $c3111c3e3c6a9bdc$var$version, 'app');


// Firebase configuration loaded from environment variables
// Configuration is set via .env files (see .env.example for setup)
/**
 * Build Firebase configuration from environment variables
 * Parcel will inline these values at build time based on the active .env file
 */ function $55096a08d23c1fd2$var$buildFirebaseConfig() {
    // Access environment variables directly with fallbacks to prevent build errors
    const FIREBASE_API_KEY = "AIzaSyA56OuUsCcUa4WW7eVIUXfiiBgHFRLTTaw";
    const FIREBASE_AUTH_DOMAIN = "gallarie-39634.firebaseapp.com";
    const FIREBASE_PROJECT_ID = "gallarie-39634";
    const FIREBASE_STORAGE_BUCKET = "gallarie-39634.appspot.com";
    const FIREBASE_MESSAGING_SENDER_ID = "160067803330";
    const FIREBASE_APP_ID = "1:160067803330:web:245d4052c92968ab70c35b";
    const FIREBASE_USE_EMULATOR = "false";
    const FIREBASE_FUNCTIONS_EMULATOR_HOST = "localhost:5001";
    const config = {
        apiKey: FIREBASE_API_KEY,
        authDomain: FIREBASE_AUTH_DOMAIN,
        projectId: FIREBASE_PROJECT_ID,
        storageBucket: FIREBASE_STORAGE_BUCKET,
        messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
        appId: FIREBASE_APP_ID
    };
    // Add emulator settings if enabled
    if (FIREBASE_USE_EMULATOR === 'true') {
        config.useEmulator = true;
        config.functionsEmulatorHost = FIREBASE_FUNCTIONS_EMULATOR_HOST || 'localhost:5001';
    }
    return config;
}
function $55096a08d23c1fd2$export$57570b1603cf6adb() {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return 'local (emulator)';
    if (hostname.includes('staging') || hostname.includes('stag')) return 'staging';
    if (hostname.includes('dev')) return 'development';
    // Production for everything else
    return 'production';
}
function $55096a08d23c1fd2$export$72e5f7374eb9f854() {
    const config = $55096a08d23c1fd2$var$buildFirebaseConfig();
    const env = $55096a08d23c1fd2$export$57570b1603cf6adb();
    console.log(`Firebase environment: ${env}`);
    console.log(`Firebase project: ${config.projectId}`);
    return config;
}


var $88feee6a131c186a$exports = {};
var $47a1491670bab221$exports = {};
var $0dfd84acba45df8f$exports = {};
// eslint-disable-next-line no-undef
$0dfd84acba45df8f$exports = [
    'Kylo',
    'Espial TV Browser',
    'LUJO TV Browser',
    'LogicUI TV Browser',
    'Open TV Browser',
    'Seraphic Sraf',
    'Opera Devices',
    'Crow Browser',
    'Vewd Browser',
    'TiviMate',
    'Quick Search TV',
    'QJY TV Browser',
    'TV Bro'
];


/**
 * restore original userAgent from clientHints object
 * @param {string} userAgent
 * @param {ResultClientHints} clientHints
 */ function $47a1491670bab221$var$restoreUserAgentFromClientHints(userAgent, clientHints) {
    if (!$47a1491670bab221$var$hasDeviceModelByClientHints(clientHints)) return userAgent;
    const deviceModel = clientHints.device.model;
    if (deviceModel === '') return userAgent;
    let newUserAgent = '' + userAgent;
    if ($47a1491670bab221$var$hasUserAgentClientHintsFragment(newUserAgent)) {
        const osHints = $47a1491670bab221$var$attr(clientHints, 'os', {});
        const osVersion = $47a1491670bab221$var$attr(osHints, 'version', '');
        newUserAgent = newUserAgent.replace(/(Android (?:10[.\d]*; K|1[1-5]))/, `Android ${osVersion !== '' ? osVersion : '10'}; ${deviceModel}`);
    }
    if (!$47a1491670bab221$var$hasDesktopFragment(newUserAgent)) return newUserAgent;
    newUserAgent = newUserAgent.replace(/(X11; Linux x86_64)/, `X11; Linux x86_64; ${deviceModel}`);
    return newUserAgent;
}
/**
 * match for base regex rule
 * @param str
 * @param userAgent
 * @returns {RegExpExecArray}
 */ function $47a1491670bab221$var$matchUserAgent(str, userAgent) {
    let regex = '(?:^|[^A-Z_-])(?:' + $47a1491670bab221$var$normalizeRegExp(str) + ')';
    let match = new RegExp(regex, 'i');
    return match.exec(userAgent);
}
function $47a1491670bab221$var$normalizeRegExp(regex) {
    return '' + regex.replace(new RegExp('/', 'g'), '\\/').replace(new RegExp('\\+\\+', 'g'), '+');
}
function $47a1491670bab221$var$getBaseRegExp(str) {
    const regex = '(?:^|[^A-Z0-9_-]|[^A-Z0-9-]_|sprd-|MZ-)(?:' + $47a1491670bab221$var$normalizeRegExp(str) + ')';
    return new RegExp(regex, 'i');
}
function $47a1491670bab221$var$matchReplace(template, matches) {
    let max = matches.length - 1 || 1;
    if (template.indexOf('$') !== -1) for(let nb = 1; nb <= max; nb++){
        if (template.indexOf('$' + nb) === -1) continue;
        let replace = matches[nb] !== void 0 ? matches[nb] : '';
        template = template.replace(new RegExp('\\$' + nb, 'g'), replace);
    }
    return template;
}
/**
 * @param {string|null} val1
 * @param {string|null} val2
 * @return {boolean}
 */ function $47a1491670bab221$var$fuzzyCompare(val1, val2) {
    return val1 !== null && val2 !== null && val1.replace(/ /gi, '').toLowerCase() === val2.replace(/ /gi, '').toLowerCase();
}
/**
 * @param {number|string} value1
 * @param {number|string} value2
 * @param {number} num
 * @return {boolean}
 */ function $47a1491670bab221$var$fuzzyCompareNumber(value1, value2, num = 3) {
    return parseFloat(value1).toFixed(num) === parseFloat(value2).toFixed(num);
}
/**
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {boolean}
 */ function $47a1491670bab221$var$fuzzyBetweenNumber(value, min, max) {
    return value >= min && value <= max;
}
/**
 * create hash from string
 * @param {string} str
 * @return {string}
 */ function $47a1491670bab221$var$createHash(str) {
    let hash = 0, i = 0, len = str.length;
    while(i < len)hash = (hash << 5) - hash + str.charCodeAt(i++) << 0;
    return hash.toString(16);
}
/**
 * Compare versions
 * @param {string} ver1
 * @param {string} ver2
 * @return {number}
 */ function $47a1491670bab221$var$versionCompare(ver1, ver2) {
    if (ver1 === ver2) return 0;
    let left = ver1.split('.');
    let right = ver2.split('.');
    let len = Math.min(left.length, right.length);
    for(let i = 0; i < len; i++){
        if (left[i] === right[i]) continue;
        if (parseInt(left[i]) > parseInt(right[i])) return 1;
        if (parseInt(left[i]) < parseInt(right[i])) return -1;
    }
    if (left.length > right.length) return 1;
    if (left.length < right.length) return -1;
    return 0;
}
/**
 * @param {string} version
 * @param {*} maxMinorParts - how many version chars trim
 * @returns {string}
 */ function $47a1491670bab221$var$versionTruncate(version, maxMinorParts) {
    let versionParts = String(version).split('.');
    if (maxMinorParts !== null && maxMinorParts !== '' && versionParts.length > maxMinorParts) versionParts = versionParts.slice(0, 1 + maxMinorParts);
    return versionParts.join('.');
}
/**
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasAndroidTableFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Android( [.0-9]+)?; Tablet;|Tablet(?! PC)|.*-tablet$', userAgent) !== null;
}
/**
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasOperaTableFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Opera Tablet', userAgent) !== null;
}
/**
 * Checks for the presence of a string in the UATouch
 * @param {string} userAgent
 * @returns {boolean}
 */ function $47a1491670bab221$var$hasTouchFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Touch', userAgent) !== null;
}
function $47a1491670bab221$var$hasVRFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Android( [.0-9]+)?; Mobile VR;| VR ', userAgent) !== null;
}
/**
 * @param {string} userAgent
 * @returns {boolean}
 */ function $47a1491670bab221$var$hasAndroidMobileFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Android( [.0-9]+)?; Mobile;|.*-mobile$', userAgent) !== null;
}
/**
 * All devices running Opera TV Store are assumed to be a tv
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasOperaTVStoreFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Opera TV Store| OMI/', userAgent) !== null;
}
/**
 * All devices running Puffin Secure Browser that contain letter 'D' are assumed to be desktops
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasPuffinDesktopFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Puffin/(?:\\d+[.\\d]+)[LMW]D', userAgent) !== null;
}
/**
 * All devices running Puffin Web Browser that contain letter 'P' are assumed to be smartphones
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasPuffinSmartphoneFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Puffin/(?:\\d+[.\\d]+)[AIFLW]P', userAgent) !== null;
}
/**
 * All devices running Puffin Web Browser that contain letter 'T' are assumed to be tablets
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasPuffinTabletFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Puffin/(?:\\d+[.\\d]+)[AILW]T', userAgent) !== null;
}
/**
 * All devices containing TV fragment are assumed to be a tv
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasAndroidTVFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('Andr0id|(?:Android(?: UHD)?|Google) TV|\\(lite\\) TV|BRAVIA|Firebolt| TV$', userAgent) !== null;
}
/**
 * All devices running Tizen TV or SmartTV are assumed to be a tv
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasTVFragment(userAgent) {
    return $47a1491670bab221$var$matchUserAgent('SmartTV|Tizen.+ TV .+$', userAgent) !== null;
// |\\(TV;
}
/**
 * Check combinations in string that relate only to desktop UA
 * @param {string} userAgent
 * @returns {boolean}
 */ function $47a1491670bab221$var$hasDesktopFragment(userAgent) {
    const DESKTOP_PATTERN = '(?:Windows (?:NT|IoT)|X11; Linux x86_64)';
    const DESKTOP_EXCLUDE_PATTERN = [
        'CE-HTML',
        ' Mozilla/|Andr[o0]id|Tablet|Mobile|iPhone|Windows Phone|ricoh|OculusBrowser',
        'PicoBrowser|Lenovo|compatible; MSIE|Trident/|Tesla/|XBOX|FBMD/|ARM; ?([^)]+)'
    ].join('|');
    return $47a1491670bab221$var$getBaseRegExp(DESKTOP_PATTERN).exec(userAgent) !== null && !($47a1491670bab221$var$getBaseRegExp(DESKTOP_EXCLUDE_PATTERN).exec(userAgent) !== null);
}
function $47a1491670bab221$var$hasTVClient(name) {
    return $0dfd84acba45df8f$exports.indexOf(name) !== -1;
}
/**
 * Check combinations is string that UserAgent ClientHints
 * @param {string} userAgent
 * @return {boolean}
 */ function $47a1491670bab221$var$hasUserAgentClientHintsFragment(userAgent) {
    return /Android (?:10[.\d]*; K(?: Build\/|[;)])|1[1-5]\)) AppleWebKit/i.test(userAgent);
}
/**
 *
 * @param {ResultClientHints|*} clientHints
 * @return {boolean}
 */ function $47a1491670bab221$var$hasDeviceModelByClientHints(clientHints) {
    return clientHints && clientHints.device && clientHints.device.model;
}
/**
 * @param {string} name
 * @return {boolean}
 */ function $47a1491670bab221$var$hasDeviceModelWrong(name) {
    return !!(name === '' || [
        'LeafOS on ARM64'
    ].includes(name));
}
/**
 * Get value by attribute for object or default value
 * @param {object} options
 * @param {string }propName
 * @param {*} defaultValue
 * @return {*|null}
 */ function $47a1491670bab221$var$attr(options, propName, defaultValue) {
    return options !== void 0 && options[propName] !== void 0 ? options[propName] : defaultValue !== void 0 ? defaultValue : null;
}
/**
 * Values become keys, and keys become values
 * @param {*} obj -
 * @returns {*}
 */ function $47a1491670bab221$var$revertObject(obj) {
    return Object.assign({}, ...Object.entries(obj).map(([a, b])=>({
            [b]: a
        })), {});
}
/**
 * Remove chars for string
 * @param {string} str
 * @param {string} chars
 * @returns {any}
 */ function $47a1491670bab221$var$trimChars(str, chars) {
    let start = 0, end = str.length;
    while(start < end && str[start] === chars)++start;
    while(end > start && str[end - 1] === chars)--end;
    return start > 0 || end < str.length ? str.substring(start, end) : str;
}
function $47a1491670bab221$var$getGroupForUserAgentTokens(tokens) {
    let groupIndex = 0;
    return tokens.reduce((group = {}, token)=>{
        if (token === '') return;
        let data = token.match(/^\((.*)\)$/);
        if (data !== null) {
            groupIndex++;
            group['#' + groupIndex] = data[1].split(/[;,] /);
            return group;
        }
        let rowSlash = token.split('/');
        if (rowSlash.length === 2) {
            group[rowSlash[0]] = rowSlash[1];
            return group;
        }
        groupIndex++;
        group['#' + groupIndex] = token;
        return group;
    }, {});
}
function $47a1491670bab221$var$getTokensForUserAgent(userAgent) {
    return userAgent.split(/ (?![^(]*\))/i);
}
/**
 * Split UserAgent to tokens and groups
 *
 * @param userAgent
 * @returns {{groups: *, userAgent: *, tokens: *}}
 */ function $47a1491670bab221$var$splitUserAgent(userAgent) {
    const tokens = $47a1491670bab221$var$getTokensForUserAgent(userAgent);
    const groups = $47a1491670bab221$var$getGroupForUserAgentTokens(tokens);
    const parts = [];
    for(let key in groups){
        if (typeof groups[key] !== 'string' || !groups[key]) continue;
        if (key && String(key).charAt(0) === '#') {
            if (!groups[key].match(/[/;]/i) && !groups[key].match(/^\s*[\d.]+/i)) {
                parts.push(String(groups[key]).toLowerCase());
                continue;
            }
            continue;
        }
        parts.push(String(key).toLowerCase());
    }
    const hash = $47a1491670bab221$var$createHash(parts.join('.')).replace('-', '');
    const path = parts.join('.');
    return {
        tokens: tokens,
        groups: groups,
        hash: hash,
        path: path
    };
}
const $47a1491670bab221$var$OS_WEIGHTS = [
    {
        regex: 'cfnetwork|darwin|mac os|apple ?tv',
        wt: 'apple general'
    },
    {
        regex: 'watch ?os',
        wt: 'apple watch os'
    },
    {
        regex: 'android|linux; andr0id|/tclwebkit',
        wt: 'android general'
    },
    {
        regex: 'windows',
        wt: 'windows'
    },
    {
        regex: '\\(x11;',
        wt: 'linux general'
    },
    {
        regex: 'linux; ?tizen',
        wt: 'tizen'
    },
    {
        regex: '[ \\(]web[0o]s',
        wt: 'webos general'
    }
];
function $47a1491670bab221$var$splitOsUserAgent(userAgent) {
    const parts = [];
    for (const record of $47a1491670bab221$var$OS_WEIGHTS){
        const match = new RegExp($47a1491670bab221$var$normalizeRegExp(record.regex), 'i');
        if (match.exec(userAgent)) parts.push(record.wt);
    }
    const hash = $47a1491670bab221$var$createHash(parts.join('.')).replace('-', '');
    const path = parts.join('.');
    return {
        hash: hash,
        path: path
    };
}
const $47a1491670bab221$var$mergeDeep = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === 'object' && !Array.isArray(obj);
    const isDeep = (prop)=>isObject(source[prop]) && target.hasOwnProperty(prop) && isObject(target[prop]);
    const replaced = Object.getOwnPropertyNames(source).map((prop)=>({
            [prop]: isDeep(prop) ? $47a1491670bab221$var$mergeDeep(target[prop], source[prop]) : source[prop] ? source[prop] : target[prop]
        })).reduce((a, b)=>({
            ...a,
            ...b
        }), {});
    return {
        ...target,
        ...replaced
    };
};
const $47a1491670bab221$var$sortObject = (o)=>Object.keys(o).sort().reduce((r, k)=>(r[k] = o[k], r), {});
$47a1491670bab221$exports = {
    mergeDeep: $47a1491670bab221$var$mergeDeep,
    sortObject: $47a1491670bab221$var$sortObject,
    hasTVClient: $47a1491670bab221$var$hasTVClient,
    matchUserAgent: $47a1491670bab221$var$matchUserAgent,
    fuzzyCompare: $47a1491670bab221$var$fuzzyCompare,
    fuzzyCompareNumber: $47a1491670bab221$var$fuzzyCompareNumber,
    fuzzyBetweenNumber: $47a1491670bab221$var$fuzzyBetweenNumber,
    versionCompare: $47a1491670bab221$var$versionCompare,
    versionTruncate: $47a1491670bab221$var$versionTruncate,
    hasVRFragment: $47a1491670bab221$var$hasVRFragment,
    hasAndroidTableFragment: $47a1491670bab221$var$hasAndroidTableFragment,
    hasOperaTableFragment: $47a1491670bab221$var$hasOperaTableFragment,
    hasOperaTVStoreFragment: $47a1491670bab221$var$hasOperaTVStoreFragment,
    hasAndroidMobileFragment: $47a1491670bab221$var$hasAndroidMobileFragment,
    hasAndroidTVFragment: $47a1491670bab221$var$hasAndroidTVFragment,
    hasDesktopFragment: $47a1491670bab221$var$hasDesktopFragment,
    hasUserAgentClientHintsFragment: $47a1491670bab221$var$hasUserAgentClientHintsFragment,
    hasDeviceModelByClientHints: $47a1491670bab221$var$hasDeviceModelByClientHints,
    hasTVFragment: $47a1491670bab221$var$hasTVFragment,
    hasTouchFragment: $47a1491670bab221$var$hasTouchFragment,
    attr: $47a1491670bab221$var$attr,
    revertObject: $47a1491670bab221$var$revertObject,
    trimChars: $47a1491670bab221$var$trimChars,
    splitUserAgent: $47a1491670bab221$var$splitUserAgent,
    splitOsUserAgent: $47a1491670bab221$var$splitOsUserAgent,
    matchReplace: $47a1491670bab221$var$matchReplace,
    hasPuffinDesktopFragment: $47a1491670bab221$var$hasPuffinDesktopFragment,
    hasPuffinSmartphoneFragment: $47a1491670bab221$var$hasPuffinSmartphoneFragment,
    hasPuffinTabletFragment: $47a1491670bab221$var$hasPuffinTabletFragment,
    hasDeviceModelWrong: $47a1491670bab221$var$hasDeviceModelWrong,
    getBaseRegExp: $47a1491670bab221$var$getBaseRegExp,
    restoreUserAgentFromClientHints: $47a1491670bab221$var$restoreUserAgentFromClientHints
};


const { attr: $88feee6a131c186a$var$attr } = $47a1491670bab221$exports;
var $5098919fcba0dff2$exports = {};
var $1f6812d7f7ca9c04$exports = {};
var $7bdad46458c9f578$exports = {};

/**
 * @param {string} result
 * @return {string}
 */ function $7bdad46458c9f578$var$fixStringName(result) {
    return result.replace(new RegExp('_', 'g'), ' ').replace(/ TD$/i, '');
}
/**
 * @param {string} result
 * @return {string}
 */ function $7bdad46458c9f578$var$fixStringVersion(result) {
    result = result.replace(new RegExp('_', 'g'), '.');
    result = result.replace(new RegExp('[.]$', 'g'), '');
    return result.trim();
}
class $7bdad46458c9f578$var$ParserAbstract {
    constructor(){
        this.collection = null;
        this.type = null;
        this.versionTruncation = null;
        this.maxUserAgentSize = null;
    }
    /**
   * A special method that overwrites placeholders in a string
   * @param {string} item
   * @param {array} matches
   * @return {string|*}
   */ buildByMatch(item, matches) {
        item = item || '';
        item = item.toString();
        return $47a1491670bab221$exports.matchReplace(item, matches);
    }
    /**
   * helper prepare base regExp + part regExp
   * @param {string} str
   * @return {RegExp}
   */ getBaseRegExp(str) {
        return $47a1491670bab221$exports.getBaseRegExp(str);
    }
    /**
   * @param {string} model
   * @param matches
   * @return {*}
   */ buildModel(model, matches) {
        model = $7bdad46458c9f578$var$fixStringName(this.buildByMatch(model, matches));
        return model === 'Build' ? null : model;
    }
    /**
   * Set the number of characters in the version where number is the number of characters +1
   * There is a line string version 1.2.3.4.555
   * If you set 0 we get version 1, if 2 we get 1.2.3 and so on.
   * @param {number} num
   */ setVersionTruncation(num) {
        this.versionTruncation = num;
    }
    /**
   * Set string size limit for the useragent
   * @param {number} size
   */ setMaxUserAgentSize(size) {
        this.maxUserAgentSize = size;
    }
    /**
   * Prepare user agent for restrict rules
   * @param {string|*} userAgent
   * @returns {string|*}
   */ prepareUserAgent(userAgent) {
        if (userAgent && this.maxUserAgentSize && this.maxUserAgentSize < userAgent.length) return String(userAgent.substr(0, this.maxUserAgentSize));
        return userAgent;
    }
    /**
   * @param {string|number} version
   * @param {array} matches
   * @return {string}
   */ buildVersion(version, matches) {
        version = $7bdad46458c9f578$var$fixStringVersion(this.buildByMatch(version, matches));
        const skipVersion = [
            'Portable',
            ''
        ];
        if (skipVersion.indexOf(version) !== -1) return version;
        return $47a1491670bab221$exports.versionTruncate(version, this.versionTruncation);
    }
}
$7bdad46458c9f578$exports = $7bdad46458c9f578$var$ParserAbstract;




var $gX8Np = parcelRequire("gX8Np");
const $1f6812d7f7ca9c04$var$COLLECTION_BRAND_LIST = $47a1491670bab221$exports.revertObject($gX8Np);
class $1f6812d7f7ca9c04$var$DeviceParserAbstract extends $7bdad46458c9f578$exports {
    constructor(){
        super();
        this.resultModelRegex = false; // used in tests
    }
    getAvailableBrands() {
        return Object.keys(this.getCollectionBrands());
    }
    getCollectionBrands() {
        return $1f6812d7f7ca9c04$var$COLLECTION_BRAND_LIST;
    }
    /**
   * @param {string} userAgent
   * @param {string[]} brandIndexes
   * @returns {[]}
   */ parseAll(userAgent, brandIndexes = []) {
        return this.#parse(userAgent, false, brandIndexes);
    }
    /**
   * iteration item parse, see __parse
   * @param {string} cursor
   * @param {string} userAgent
   * @return {{model: *, id: *, type, brand}|null}
   * @private
   */ #parseForBrand(cursor, userAgent) {
        let item = this.collection[cursor];
        if (item === void 0) return null;
        let model = '';
        let deviceType = '';
        let brandName = '';
        let regex = item['regex'];
        let match = this.getBaseRegExp(regex).exec(userAgent);
        if (match) {
            brandName = String(cursor).trim();
            if (brandName === 'Unknown') brandName = '';
            if (item['device'] !== void 0) deviceType = item['device'];
            if (item['models'] !== void 0) {
                let models = item['models'];
                for(let i = 0, l = models.length; i < l; i++){
                    let data = models[i];
                    regex = data.regex;
                    let modelMatch = this.getBaseRegExp(regex).exec(userAgent);
                    if (modelMatch) {
                        model = this.buildModel(data.model, modelMatch);
                        if (data.device !== void 0) deviceType = data.device;
                        if (data.brand !== void 0) brandName = data.brand;
                        break;
                    }
                }
            } else if (item['model'] !== void 0) model = this.buildModel(item['model'], match);
            let brandId = this.getBrandIdByName(brandName);
            let result = {
                id: brandId !== void 0 ? brandId : '',
                brand: brandName,
                model: model ? String(model).trim() : '',
                type: deviceType
            };
            if (this.resultModelRegex) result.regex = regex;
            return result;
        }
        return null;
    }
    /**
   * iterations parse for collection
   * @param {string} userAgent
   * @param {boolean} canBreak
   * @param {string[]} brandIndexes
   * @return {[]}
   * @private
   */ #parse(userAgent, canBreak = true, brandIndexes = []) {
        const output = [];
        if (brandIndexes.length) for (let cursorId of brandIndexes){
            const cursor = this.getBrandNameById(cursorId);
            const result = this.#parseForBrand(cursor, userAgent);
            if (result === null) continue;
            output.push(result);
            if (canBreak) break;
        }
        if (!output.length) for(let cursor in this.collection){
            const result = this.#parseForBrand(cursor, userAgent);
            if (result === null) continue;
            output.push(result);
            if (canBreak) break;
        }
        return output;
    }
    /**
   * Result brand and model
   * @param {string} userAgent    - useragent string
   * @param {array} brandIndexes  - check the devices in this list
   * @return {{model: (string|string), id: (*|string), type: string, brand: string}|null}
   */ parse(userAgent, brandIndexes = []) {
        userAgent = this.prepareUserAgent(userAgent);
        let result = this.#parse(userAgent, true, brandIndexes);
        if (result.length) {
            // if it is fake device iphone/ipad then result empty
            if (result[0].brand === 'Apple' && /android /i.test(userAgent)) return {
                id: '',
                brand: '',
                model: '',
                type: ''
            };
            return result[0];
        }
        return null;
    }
    /**
   * get brand short id by name
   * @param {string} brandName
   * @return {string|void}
   */ getBrandIdByName(brandName) {
        return $1f6812d7f7ca9c04$var$COLLECTION_BRAND_LIST[brandName];
    }
    /**
   * get brand name by short id
   * @param {string} id
   * @return {string|void}
   */ getBrandNameById(id) {
        return $gX8Np[id];
    }
}
$1f6812d7f7ca9c04$exports = $1f6812d7f7ca9c04$var$DeviceParserAbstract;



class $5098919fcba0dff2$var$Mobile extends $1f6812d7f7ca9c04$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("doq08"));
    }
}
$5098919fcba0dff2$exports = $5098919fcba0dff2$var$Mobile;


var $22eb8546cbbee8f0$exports = {};

var $a86fa4b852e0efb3$exports = {};
$a86fa4b852e0efb3$exports = {
    DESKTOP: 'desktop',
    SMARTPHONE: 'smartphone',
    TABLET: 'tablet',
    FEATURE_PHONE: 'feature phone',
    CONSOLE: 'console',
    TV: 'tv',
    CAR_BROWSER: 'car browser',
    SMART_DISPLAY: 'smart display',
    CAMERA: 'camera',
    PORTABLE_MEDIA_PLAYER: 'portable media player',
    PHABLET: 'phablet',
    SMART_SPEAKER: 'smart speaker',
    WEARABLE: 'wearable',
    PERIPHERAL: 'peripheral'
};



class $22eb8546cbbee8f0$var$Notebook extends $1f6812d7f7ca9c04$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("fmsQW"));
    }
    /**
   * @param userAgent
   * @returns {null|{model: string, id: string, type: string, brand: string}}
   */ parse(userAgent) {
        if (!this.isFBMD(userAgent)) return null;
        let resultParse = super.parse(userAgent);
        if (resultParse) {
            let result = {
                id: '',
                type: $a86fa4b852e0efb3$exports.DESKTOP,
                brand: '',
                model: ''
            };
            result.id = resultParse.id;
            result.brand = resultParse.brand;
            result.model = resultParse.model;
            return result;
        }
        return null;
    }
    /**
   * has check userAgent fragment is FBMD
   * @param {String} userAgent
   * @return {Boolean}
   */ isFBMD(userAgent) {
        let regex = 'FBMD/';
        let match = this.getBaseRegExp(regex).exec(userAgent);
        return match !== null;
    }
}
$22eb8546cbbee8f0$exports = $22eb8546cbbee8f0$var$Notebook;


var $407264a87b5c9052$exports = {};



class $407264a87b5c9052$var$HbbTv extends $1f6812d7f7ca9c04$exports {
    /**
   *
   */ constructor(){
        super();
        this.collection = (parcelRequire("jO8RA"));
    }
    /**
   * @param {string} userAgent
   * @param brandIndexes
   * @returns {null|{model: string, id: string, type: string, brand: string}}
   */ parse(userAgent, brandIndexes) {
        // only parse user agents containing fragments: hbbtv or SmartTvA
        if (!this.isHubTv(userAgent)) return null;
        let result = {
            id: '',
            type: '',
            brand: '',
            model: ''
        };
        let resultParse = super.parse(userAgent, brandIndexes);
        if (resultParse) {
            result.id = resultParse.id;
            result.brand = resultParse.brand;
            result.model = resultParse.model;
            result.type = resultParse.type;
        }
        if (!result.type) result.type = $a86fa4b852e0efb3$exports.TV;
        return result;
    }
    /**
   * has check userAgent fragment is hub tv
   * @param {String} userAgent
   * @return {Boolean}
   */ isHubTv(userAgent) {
        let regex = '(?:HbbTV|SmartTvA)/([1-9]{1}(?:[.][0-9]{1}){1,2})';
        let match = this.getBaseRegExp(regex).exec(userAgent);
        return match !== null;
    }
}
$407264a87b5c9052$exports = $407264a87b5c9052$var$HbbTv;


var $127410077136c7d3$exports = {};



class $127410077136c7d3$var$ShellTv extends $1f6812d7f7ca9c04$exports {
    /**
   *
   */ constructor(){
        super();
        this.collection = (parcelRequire("5wqFi"));
    }
    /**
   * @param {string} userAgent
   * @returns {null|{model: string, id: string, type: string, brand: string}}
   */ parse(userAgent) {
        if (!this.isShellTv(userAgent)) return null;
        let result = {
            id: '',
            type: $a86fa4b852e0efb3$exports.TV,
            brand: '',
            model: ''
        };
        let resultParse = super.parse(userAgent);
        if (resultParse) {
            result.id = resultParse.id;
            result.brand = resultParse.brand;
            result.model = resultParse.model;
        }
        return result;
    }
    /**
   * has check userAgent fragment is shell tv
   * @param {String} userAgent
   * @return {Boolean}
   */ isShellTv(userAgent) {
        const regex = '[a-z]+[ _]Shell[ _]\\w{6}|tclwebkit(\\d+[.\\d]*)';
        const match = this.getBaseRegExp(regex).exec(userAgent);
        return match !== null;
    }
}
$127410077136c7d3$exports = $127410077136c7d3$var$ShellTv;


var $9df9b6da98745d30$exports = {};


class $9df9b6da98745d30$var$Console extends $1f6812d7f7ca9c04$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("fBeds"));
    }
}
$9df9b6da98745d30$exports = $9df9b6da98745d30$var$Console;


var $81a2f51c312f4a4f$exports = {};


class $81a2f51c312f4a4f$var$CarBrowser extends $1f6812d7f7ca9c04$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("4u0TT"));
    }
}
$81a2f51c312f4a4f$exports = $81a2f51c312f4a4f$var$CarBrowser;


var $d14192cbf2c5a49a$exports = {};


class $d14192cbf2c5a49a$var$Camera extends $1f6812d7f7ca9c04$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("d31g9"));
    }
}
$d14192cbf2c5a49a$exports = $d14192cbf2c5a49a$var$Camera;


var $6a4e63ed821d479a$exports = {};


class $6a4e63ed821d479a$var$PortableMediaPlayer extends $1f6812d7f7ca9c04$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("hI2qM"));
    }
}
$6a4e63ed821d479a$exports = $6a4e63ed821d479a$var$PortableMediaPlayer;


var $5358240e24b4c7df$exports = {};
var $d036a7e08aaccad9$exports = {};

var $401ef96fa6d346f1$exports = {};

var $6b929fe91f6b6fc3$exports = {};
$6b929fe91f6b6fc3$exports = {
    MOBILE_APP: 'mobile app',
    BROWSER: 'browser',
    LIBRARY: 'library',
    MEDIA_PLAYER: 'mediaplayer',
    FEED_READER: 'feed reader',
    PIM: 'pim'
};


var $abbb6e95ac5e086a$exports = {};
$abbb6e95ac5e086a$exports = {
    "0": {
        "0": [
            7,
            91,
            309,
            347,
            369,
            426,
            461,
            480,
            483,
            488,
            560
        ],
        "1": [
            18,
            72,
            89,
            223,
            232,
            276,
            303,
            304,
            340,
            344,
            420,
            439,
            485
        ],
        "2": [
            1,
            3,
            24
        ],
        "3": [
            1
        ]
    },
    "19826": {
        "1": [
            301
        ]
    },
    "308060": {
        "1": [
            396
        ]
    },
    "1382250": {
        "0": [
            164
        ]
    },
    "2358908": {
        "2": [
            123
        ]
    },
    "2437038": {
        "0": [
            329
        ]
    },
    "2439163": {
        "0": [
            84
        ]
    },
    "4352225": {
        "0": [
            569
        ]
    },
    "4669617": {
        "0": [
            346
        ]
    },
    "5523339": {
        "5": [
            27
        ]
    },
    "5660145": {
        "0": [
            357
        ]
    },
    "6039864": {
        "2": [
            22
        ]
    },
    "6322786": {
        "0": [
            483
        ]
    },
    "6468087": {
        "1": [
            409
        ]
    },
    "6999762": {
        "0": [
            346
        ]
    },
    "7095382": {
        "0": [
            303
        ]
    },
    "8046990": {
        "1": [
            350
        ]
    },
    "9139662": {
        "1": [
            181
        ]
    },
    "9690313": {
        "0": [
            483
        ]
    },
    "10764936": {
        "1": [
            559
        ]
    },
    "11322577": {
        "0": [
            182
        ]
    },
    "11869884": {
        "1": [
            559
        ]
    },
    "11878147": {
        "1": [
            453
        ]
    },
    "12483032": {
        "2": [
            31
        ]
    },
    "14890961": {
        "0": [
            483
        ]
    },
    "15942024": {
        "0": [
            376
        ]
    },
    "17124302": {
        "0": [
            277
        ]
    },
    "17144731": {
        "1": [
            145
        ]
    },
    "18353764": {
        "1": [
            61
        ]
    },
    "18884351": {
        "0": [
            406
        ]
    },
    "20389582": {
        "1": [
            32
        ]
    },
    "21505618": {
        "1": [
            559
        ]
    },
    "21931179": {
        "4": [
            5
        ]
    },
    "22035597": {
        "0": [
            61
        ]
    },
    "22180864": {
        "0": [
            560
        ]
    },
    "22967125": {
        "1": [
            86
        ]
    },
    "23057062": {
        "1": [
            453
        ]
    },
    "24743942": {
        "1": [
            541
        ]
    },
    "24821779": {
        "0": [
            93
        ]
    },
    "25011263": {
        "0": [
            387
        ]
    },
    "26627776": {
        "0": [
            488
        ]
    },
    "26994829": {
        "0": [
            483
        ]
    },
    "27464470": {
        "0": [
            530
        ]
    },
    "27810946": {
        "1": [
            239
        ]
    },
    "27877385": {
        "0": [
            372
        ]
    },
    "28292465": {
        "0": [
            426
        ]
    },
    "28387235": {
        "0": [
            404
        ]
    },
    "29511629": {
        "0": [
            560
        ]
    },
    "31389569": {
        "1": [
            414
        ]
    },
    "31950925": {
        "0": [
            560
        ]
    },
    "32238535": {
        "1": [
            28
        ]
    },
    "34722479": {
        "0": [
            227
        ]
    },
    "34840759": {
        "0": [
            446
        ]
    },
    "35003179": {
        "0": [
            370
        ]
    },
    "35579332": {
        "2": [
            132
        ]
    },
    "36506516": {
        "5": [
            33
        ]
    },
    "37109863": {
        "0": [
            206
        ]
    },
    "38322915": {
        "0": [
            458
        ]
    },
    "38400403": {
        "0": [
            483
        ]
    },
    "39027585": {
        "0": [
            480
        ]
    },
    "39438938": {
        "0": [
            480
        ]
    },
    "41575166": {
        "0": [
            483
        ]
    },
    "41872849": {
        "1": [
            61
        ]
    },
    "42408242": {
        "0": [
            560
        ]
    },
    "42872667": {
        "1": [
            515
        ]
    },
    "43533439": {
        "0": [
            483
        ]
    },
    "44195986": {
        "1": [
            229
        ]
    },
    "44546204": {
        "0": [
            346
        ]
    },
    "45729317": {
        "0": [
            560
        ]
    },
    "45960742": {
        "0": [
            458
        ]
    },
    "47390339": {
        "2": [
            30
        ]
    },
    "47720741": {
        "1": [
            51
        ]
    },
    "48699953": {
        "1": [
            13
        ]
    },
    "48849052": {
        "0": [
            192
        ]
    },
    "48990983": {
        "1": [
            425
        ]
    },
    "49689089": {
        "0": [
            458
        ]
    },
    "49910633": {
        "5": [
            10
        ]
    },
    "50174643": {
        "0": [
            186
        ]
    },
    "50718664": {
        "2": [
            59
        ]
    },
    "51216994": {
        "3": [
            34
        ]
    },
    "51533858": {
        "0": [
            527
        ]
    },
    "52370160": {
        "1": [
            20
        ]
    },
    "52490842": {
        "1": [
            46
        ]
    },
    "52753270": {
        "0": [
            560
        ]
    },
    "52948980": {
        "0": [
            483
        ]
    },
    "53711528": {
        "1": [
            109
        ]
    },
    "54535766": {
        "1": [
            539
        ]
    },
    "54611125": {
        "0": [
            185
        ]
    },
    "55059779": {
        "0": [
            483
        ]
    },
    "55107418": {
        "0": [
            346
        ]
    },
    "55111256": {
        "2": [
            107
        ]
    },
    "55211138": {
        "0": [
            544
        ]
    },
    "55363670": {
        "0": [
            560
        ]
    },
    "55517460": {
        "0": [
            400
        ]
    },
    "56366875": {
        "3": [
            17
        ]
    },
    "57984670": {
        "3": [
            22
        ]
    },
    "58364015": {
        "1": [
            436
        ]
    },
    "58864371": {
        "0": [
            488
        ]
    },
    "58975892": {
        "0": [
            560
        ]
    },
    "59153330": {
        "0": [
            404
        ]
    },
    "59625102": {
        "0": [
            580
        ]
    },
    "59937590": {
        "0": [
            560
        ]
    },
    "60912286": {
        "0": [
            83
        ]
    },
    "61640636": {
        "1": [
            133
        ]
    },
    "61995893": {
        "0": [
            411
        ]
    },
    "63847241": {
        "0": [
            90
        ]
    },
    "63876706": {
        "0": [
            356
        ]
    },
    "63963087": {
        "1": [
            245
        ]
    },
    "65107365": {
        "4": [
            10
        ]
    },
    "66014715": {
        "1": [
            20
        ]
    },
    "67833893": {
        "0": [
            84
        ]
    },
    "68233211": {
        "1": [
            590
        ]
    },
    "68346369": {
        "1": [
            546
        ]
    },
    "68416500": {
        "0": [
            387
        ]
    },
    "69069605": {
        "0": [
            480
        ]
    },
    "69083353": {
        "1": [
            29
        ]
    },
    "70305296": {
        "0": [
            470
        ]
    },
    "71098192": {
        "1": [
            559
        ]
    },
    "71335209": {
        "0": [
            560
        ]
    },
    "73526992": {
        "1": [
            44
        ]
    },
    "73668773": {
        "0": [
            6
        ]
    },
    "74363495": {
        "1": [
            309
        ]
    },
    "75472901": {
        "0": [
            560
        ]
    },
    "75640236": {
        "0": [
            346
        ]
    },
    "75654507": {
        "1": [
            159
        ]
    },
    "75696646": {
        "1": [
            385
        ]
    },
    "76021087": {
        "0": [
            387
        ]
    },
    "76532769": {
        "1": [
            366
        ]
    },
    "76542198": {
        "0": [
            401
        ]
    },
    "76975216": {
        "1": [
            137
        ]
    },
    "77507853": {
        "0": [
            374
        ]
    },
    "77750263": {
        "0": [
            458
        ]
    },
    "79491136": {
        "0": [
            569
        ]
    },
    "6611b99": {
        "1": [
            596
        ]
    },
    "64f06218": {
        "1": [
            30
        ]
    },
    "1da7aa91": {
        "1": [
            33
        ]
    },
    "398f0260": {
        "1": [
            34
        ]
    },
    "5ccce94": {
        "1": [
            22
        ]
    },
    "658cf6de": {
        "1": [
            35
        ]
    },
    "640055de": {
        "1": [
            55
        ]
    },
    "2beb4ee2": {
        "1": [
            55
        ]
    },
    "129cddef": {
        "1": [
            350
        ]
    },
    "344cb1b0": {
        "1": [
            56
        ]
    },
    "59d39944": {
        "1": [
            56
        ]
    },
    "4a59b8f0": {
        "0": [
            3,
            27,
            70,
            180,
            199,
            218,
            225,
            310,
            326,
            358,
            398,
            412,
            423,
            457,
            463,
            467,
            484,
            492,
            495,
            509,
            525,
            527,
            528,
            529,
            530,
            531,
            532,
            533,
            535,
            544,
            545,
            546,
            560,
            568
        ],
        "1": [
            58,
            117,
            215,
            251,
            302
        ],
        "2": [
            20,
            30,
            58
        ],
        "3": [
            20
        ],
        "5": [
            2,
            7
        ]
    },
    "7f5c31e": {
        "1": [
            344
        ]
    },
    "1f902e13": {
        "1": [
            59
        ]
    },
    "4f0ef7f8": {
        "1": [
            61
        ]
    },
    "92c40fc": {
        "1": [
            63
        ]
    },
    "5fb7579f": {
        "1": [
            66
        ]
    },
    "27d5ccc7": {
        "1": [
            71
        ]
    },
    "2f9c0317": {
        "1": [
            72
        ]
    },
    "7a3642a3": {
        "1": [
            73
        ]
    },
    "6a3b267e": {
        "1": [
            74
        ]
    },
    "3c96b99c": {
        "1": [
            75
        ]
    },
    "43edce65": {
        "1": [
            76
        ]
    },
    "39f54364": {
        "1": [
            267
        ]
    },
    "1e92efad": {
        "1": [
            77
        ]
    },
    "3dd6e55a": {
        "1": [
            80
        ]
    },
    "13a0a37d": {
        "1": [
            20
        ]
    },
    "8f3ba1f": {
        "1": [
            81
        ]
    },
    "66b5673d": {
        "1": [
            84
        ]
    },
    "692d347f": {
        "1": [
            85
        ]
    },
    "5d897ec4": {
        "1": [
            90
        ]
    },
    "323f05c8": {
        "1": [
            91
        ]
    },
    "300d3c35": {
        "1": [
            100
        ]
    },
    "718111fa": {
        "1": [
            101
        ]
    },
    "5f4f7b7b": {
        "1": [
            101
        ]
    },
    "130974f9": {
        "1": [
            101
        ]
    },
    "211b09b4": {
        "1": [
            87
        ]
    },
    "6e920439": {
        "1": [
            102
        ]
    },
    "1f9de86": {
        "1": [
            103
        ]
    },
    "3124b3f6": {
        "1": [
            104
        ]
    },
    "37c9e73f": {
        "1": [
            105
        ]
    },
    "65526e28": {
        "1": [
            107
        ]
    },
    "1d326e8d": {
        "1": [
            77
        ]
    },
    "15a47874": {
        "1": [
            109
        ]
    },
    "333c1727": {
        "1": [
            110
        ]
    },
    "7c3ecd6a": {
        "1": [
            111
        ]
    },
    "7ad63d98": {
        "1": [
            112
        ]
    },
    "3da9694": {
        "1": [
            113
        ]
    },
    "8fa4497": {
        "1": [
            114
        ]
    },
    "6b273bd1": {
        "1": [
            115
        ]
    },
    "37c70a": {
        "1": [
            116
        ]
    },
    "33f312e3": {
        "1": [
            116
        ]
    },
    "207b7604": {
        "1": [
            116
        ]
    },
    "1012ee05": {
        "1": [
            116
        ]
    },
    "3b56bbc": {
        "1": [
            116,
            118,
            119,
            124
        ],
        "5": [
            2
        ]
    },
    "8da0ec": {
        "1": [
            124
        ]
    },
    "4f37f528": {
        "1": [
            122
        ]
    },
    "56e8a9aa": {
        "1": [
            141
        ]
    },
    "738bbe65": {
        "1": [
            142
        ]
    },
    "72d34f10": {
        "1": [
            143
        ]
    },
    "2c68de83": {
        "1": [
            144
        ]
    },
    "645277ea": {
        "1": [
            146
        ]
    },
    "19c66c43": {
        "1": [
            147
        ]
    },
    "1292d3f6": {
        "1": [
            148
        ]
    },
    "679f0d14": {
        "1": [
            149
        ]
    },
    "4b803672": {
        "1": [
            150
        ]
    },
    "27cf3767": {
        "1": [
            151
        ]
    },
    "454eaf67": {
        "1": [
            153
        ]
    },
    "dd4": {
        "1": [
            126
        ]
    },
    "17974f21": {
        "1": [
            154
        ]
    },
    "577ae6ac": {
        "1": [
            155
        ]
    },
    "6103dd": {
        "1": [
            164
        ]
    },
    "245faa1c": {
        "1": [
            164
        ]
    },
    "3e9af5b7": {
        "1": [
            165
        ]
    },
    "6e6497c7": {
        "1": [
            506
        ]
    },
    "2030b3cb": {
        "1": [
            166
        ]
    },
    "699e2a1": {
        "1": [
            167
        ]
    },
    "26b729e7": {
        "1": [
            174
        ]
    },
    "5159fb2": {
        "1": [
            176
        ]
    },
    "55170cb5": {
        "1": [
            177
        ]
    },
    "3778790c": {
        "1": [
            177
        ]
    },
    "1dd9a466": {
        "1": [
            40
        ]
    },
    "df840ea": {
        "1": [
            178
        ]
    },
    "6f2ccde0": {
        "1": [
            179
        ]
    },
    "50718bdc": {
        "1": [
            182
        ]
    },
    "6fb35b87": {
        "1": [
            158
        ]
    },
    "650cd5cc": {
        "1": [
            95
        ]
    },
    "5e26a56f": {
        "1": [
            183
        ]
    },
    "59091c9c": {
        "1": [
            185
        ]
    },
    "104612fc": {
        "1": [
            187
        ]
    },
    "6dac5178": {
        "1": [
            188
        ]
    },
    "40d437b1": {
        "1": [
            188
        ]
    },
    "554b8cba": {
        "1": [
            192
        ]
    },
    "51241b7c": {
        "1": [
            194
        ]
    },
    "7b03f63": {
        "1": [
            41
        ]
    },
    "54f68627": {
        "1": [
            93
        ]
    },
    "31c55a43": {
        "1": [
            94
        ]
    },
    "3c844ae7": {
        "1": [
            131
        ]
    },
    "4e4649e0": {
        "1": [
            219
        ]
    },
    "73786ea2": {
        "1": [
            35
        ]
    },
    "af7a0f9": {
        "0": [
            286
        ],
        "1": [
            220
        ]
    },
    "650a3d3": {
        "0": [
            387
        ],
        "1": [
            221
        ]
    },
    "b2ad7d9": {
        "1": [
            127
        ]
    },
    "2f5cc74b": {
        "1": [
            42
        ]
    },
    "5e1090e3": {
        "1": [
            43
        ]
    },
    "62cee77": {
        "1": [
            224
        ]
    },
    "5a0a66af": {
        "1": [
            217
        ]
    },
    "27741e2": {
        "1": [
            217
        ]
    },
    "5505b4e3": {
        "1": [
            225
        ]
    },
    "4bac6dfa": {
        "1": [
            226
        ]
    },
    "430d79d4": {
        "1": [
            227
        ]
    },
    "5e5287c9": {
        "1": [
            228
        ]
    },
    "7a57c767": {
        "1": [
            230
        ]
    },
    "5b3b3f3c": {
        "1": [
            231
        ]
    },
    "23bba26d": {
        "1": [
            233
        ]
    },
    "407c15e6": {
        "1": [
            234
        ]
    },
    "499c17c9": {
        "1": [
            235
        ]
    },
    "3d7ad7e": {
        "1": [
            236
        ]
    },
    "5f1cd89a": {
        "1": [
            237
        ]
    },
    "5c0c55d8": {
        "1": [
            238
        ]
    },
    "6ed9b25c": {
        "1": [
            180
        ]
    },
    "143c92fb": {
        "1": [
            240
        ]
    },
    "4cf86625": {
        "1": [
            241
        ]
    },
    "2274a3c7": {
        "1": [
            242
        ]
    },
    "77ec3dc1": {
        "1": [
            246
        ]
    },
    "326261e0": {
        "1": [
            247
        ]
    },
    "1f035d2c": {
        "1": [
            248
        ]
    },
    "32b55ff7": {
        "1": [
            242
        ]
    },
    "6d90123e": {
        "0": [
            60,
            224,
            258,
            259,
            423,
            427,
            479,
            480
        ],
        "1": [
            6,
            12,
            14,
            18,
            54,
            91,
            121,
            140,
            554,
            567,
            568,
            569
        ]
    },
    "6dd99392": {
        "1": [
            249
        ]
    },
    "777919cc": {
        "1": [
            250
        ]
    },
    "73c2d5b7": {
        "1": [
            239
        ]
    },
    "30a95a": {
        "1": [
            37,
            252
        ]
    },
    "74411e1d": {
        "1": [
            252
        ]
    },
    "357f4990": {
        "1": [
            253
        ]
    },
    "5e263ca3": {
        "1": [
            254
        ]
    },
    "1033edaa": {
        "1": [
            255
        ]
    },
    "605a11aa": {
        "1": [
            108
        ]
    },
    "62f7b1a8": {
        "1": [
            257
        ]
    },
    "8d003e2": {
        "1": [
            258
        ]
    },
    "4cbdbc14": {
        "1": [
            259
        ]
    },
    "253a96ae": {
        "1": [
            261
        ]
    },
    "67b30281": {
        "1": [
            260
        ]
    },
    "50c7b3c": {
        "1": [
            262
        ]
    },
    "1b8db1d9": {
        "1": [
            263
        ]
    },
    "38e2f340": {
        "1": [
            125
        ]
    },
    "4143d20c": {
        "1": [
            264
        ]
    },
    "ca85836": {
        "1": [
            265
        ]
    },
    "6e8a34f0": {
        "0": [
            437,
            480
        ],
        "1": [
            16,
            270
        ]
    },
    "61a29ab2": {
        "1": [
            266
        ]
    },
    "5db7bc82": {
        "1": [
            271
        ]
    },
    "808d9a": {
        "0": [
            545,
            558,
            560,
            569
        ],
        "1": [
            3,
            18,
            81,
            272
        ]
    },
    "ae60a22": {
        "1": [
            273
        ]
    },
    "232c9817": {
        "1": [
            274
        ]
    },
    "7886acd2": {
        "1": [
            31
        ]
    },
    "5338e7e2": {
        "1": [
            275
        ]
    },
    "1797bd82": {
        "1": [
            27
        ]
    },
    "b56770f": {
        "1": [
            13
        ]
    },
    "4fd199d7": {
        "0": [
            560
        ],
        "1": [
            13,
            317,
            506
        ]
    },
    "67e3c952": {
        "1": [
            277
        ]
    },
    "316e6128": {
        "1": [
            278
        ]
    },
    "447fd81d": {
        "1": [
            279
        ]
    },
    "473a529f": {
        "1": [
            280
        ]
    },
    "13df7338": {
        "1": [
            282
        ]
    },
    "3435305f": {
        "1": [
            283
        ]
    },
    "778bec83": {
        "1": [
            283
        ]
    },
    "322f463": {
        "1": [
            281
        ]
    },
    "5df44960": {
        "1": [
            281
        ]
    },
    "35f587b5": {
        "1": [
            284
        ]
    },
    "6a3d132b": {
        "1": [
            285
        ]
    },
    "374f66ab": {
        "1": [
            286
        ]
    },
    "728db14a": {
        "1": [
            287
        ]
    },
    "687a6aee": {
        "1": [
            288
        ]
    },
    "71056e58": {
        "1": [
            289
        ]
    },
    "5b8a6c2a": {
        "1": [
            290
        ]
    },
    "1557403f": {
        "1": [
            129
        ]
    },
    "bec1db2": {
        "0": [
            78,
            437,
            447,
            568
        ],
        "1": [
            5,
            14,
            15,
            17,
            18,
            19,
            567
        ]
    },
    "23e64330": {
        "1": [
            291
        ]
    },
    "40afd6bd": {
        "1": [
            292
        ]
    },
    "61f64276": {
        "1": [
            293
        ]
    },
    "5efa2e3d": {
        "1": [
            294
        ]
    },
    "b5f02d": {
        "1": [
            295
        ]
    },
    "7035c518": {
        "1": [
            296
        ]
    },
    "482f27b1": {
        "1": [
            139
        ]
    },
    "297fea6": {
        "1": [
            180
        ]
    },
    "7b1ed138": {
        "1": [
            297
        ]
    },
    "51212d86": {
        "1": [
            8
        ]
    },
    "1f237de5": {
        "1": [
            298
        ]
    },
    "1f538420": {
        "1": [
            299
        ]
    },
    "1dee3693": {
        "1": [
            300
        ]
    },
    "21e603d6": {
        "1": [
            24
        ]
    },
    "43ecf3ab": {
        "1": [
            302
        ]
    },
    "6d68d251": {
        "1": [
            308
        ]
    },
    "614e91c0": {
        "1": [
            298
        ]
    },
    "117e6d44": {
        "1": [
            310
        ]
    },
    "7e755cfb": {
        "1": [
            311
        ]
    },
    "7f2651e2": {
        "1": [
            312
        ]
    },
    "ecfbf23": {
        "1": [
            268
        ]
    },
    "358fed6e": {
        "1": [
            313
        ]
    },
    "6b28c92d": {
        "1": [
            267
        ]
    },
    "1bb20664": {
        "1": [
            314
        ]
    },
    "6b00cfc": {
        "1": [
            99
        ]
    },
    "1d079209": {
        "1": [
            318
        ]
    },
    "76c8dec0": {
        "1": [
            319
        ]
    },
    "7a90caba": {
        "1": [
            181
        ]
    },
    "67b6dced": {
        "1": [
            181
        ]
    },
    "7a318527": {
        "1": [
            320
        ]
    },
    "14223a44": {
        "1": [
            321
        ]
    },
    "12b09dbf": {
        "1": [
            322
        ]
    },
    "2f095817": {
        "1": [
            47
        ]
    },
    "1b1f6": {
        "1": [
            323
        ]
    },
    "7e27d3d2": {
        "1": [
            123
        ]
    },
    "4e39735d": {
        "1": [
            596
        ]
    },
    "4abd423a": {
        "1": [
            324
        ]
    },
    "4328bcf9": {
        "1": [
            325
        ]
    },
    "2fb2d23f": {
        "1": [
            325
        ]
    },
    "9c59076": {
        "1": [
            325
        ]
    },
    "5662fd91": {
        "1": [
            189
        ]
    },
    "5dbdf2ea": {
        "1": [
            190
        ]
    },
    "6aa5715b": {
        "1": [
            191
        ]
    },
    "5aeb839d": {
        "1": [
            327
        ]
    },
    "644a20": {
        "1": [
            49
        ]
    },
    "6d594a38": {
        "1": [
            331
        ]
    },
    "28f5d91b": {
        "1": [
            150
        ]
    },
    "4a784dd0": {
        "1": [
            11
        ]
    },
    "61a3c2de": {
        "0": [
            194,
            250,
            501,
            545,
            560,
            571
        ],
        "1": [
            596
        ],
        "3": [
            41
        ]
    },
    "7a316e20": {
        "1": [
            320
        ]
    },
    "6c32d913": {
        "1": [
            512
        ]
    },
    "22c1fbd9": {
        "1": [
            513
        ]
    },
    "79cf3b53": {
        "1": [
            322
        ]
    },
    "15903b19": {
        "1": [
            521
        ]
    },
    "2066a337": {
        "1": [
            131
        ]
    },
    "bab3566": {
        "1": [
            272
        ]
    },
    "e5c73d7": {
        "1": [
            522
        ]
    },
    "47570e72": {
        "1": [
            266
        ]
    },
    "6b7005f1": {
        "1": [
            523
        ]
    },
    "3357c991": {
        "1": [
            524
        ]
    },
    "88ee080": {
        "1": [
            525
        ]
    },
    "48d83466": {
        "1": [
            514
        ]
    },
    "411c133a": {
        "1": [
            526
        ]
    },
    "18b54701": {
        "1": [
            527
        ]
    },
    "13f212ee": {
        "1": [
            528
        ]
    },
    "15b84346": {
        "1": [
            529
        ]
    },
    "3c127317": {
        "1": [
            530
        ]
    },
    "47390d7a": {
        "1": [
            531
        ]
    },
    "17a1acf3": {
        "1": [
            46
        ]
    },
    "74d58ede": {
        "1": [
            48
        ]
    },
    "2d086836": {
        "1": [
            49
        ]
    },
    "47231cb1": {
        "1": [
            50
        ]
    },
    "338fd249": {
        "1": [
            46
        ]
    },
    "3c22e1f0": {
        "1": [
            46
        ]
    },
    "2121dc43": {
        "1": [
            45
        ]
    },
    "2988a378": {
        "1": [
            532
        ]
    },
    "4aa7ef85": {
        "1": [
            532
        ]
    },
    "17f6021f": {
        "1": [
            78
        ]
    },
    "314bd05d": {
        "1": [
            79
        ]
    },
    "24258fb4": {
        "1": [
            79
        ]
    },
    "11f77aba": {
        "1": [
            269
        ]
    },
    "3fcab9a8": {
        "1": [
            533
        ]
    },
    "55fe38a4": {
        "1": [
            521
        ]
    },
    "5f0b131c": {
        "1": [
            534
        ]
    },
    "60d6f4cc": {
        "1": [
            535
        ]
    },
    "6aa2a447": {
        "1": [
            536
        ]
    },
    "9fa0c78": {
        "0": [
            77,
            119,
            170,
            194,
            346,
            347,
            560
        ],
        "1": [
            16,
            19,
            537
        ]
    },
    "3d78834f": {
        "1": [
            538,
            540
        ]
    },
    "2cdfa059": {
        "1": [
            539
        ]
    },
    "300b4166": {
        "1": [
            540
        ]
    },
    "54975a62": {
        "1": [
            542
        ]
    },
    "75641bdf": {
        "1": [
            543
        ]
    },
    "6c8b1d55": {
        "1": [
            71
        ]
    },
    "2458104d": {
        "1": [
            315
        ]
    },
    "2a467107": {
        "1": [
            267
        ]
    },
    "2cfa571c": {
        "1": [
            544
        ]
    },
    "6ba9d24": {
        "1": [
            545
        ]
    },
    "7a8eacfd": {
        "1": [
            152
        ]
    },
    "149dc12c": {
        "1": [
            152
        ]
    },
    "7229ca2f": {
        "1": [
            547
        ]
    },
    "ac9ab57": {
        "1": [
            7
        ]
    },
    "21853eab": {
        "1": [
            1
        ]
    },
    "5d0f3c97": {
        "1": [
            0
        ]
    },
    "52406af8": {
        "1": [
            120
        ]
    },
    "2c2a1a3b": {
        "1": [
            548
        ]
    },
    "238b9601": {
        "1": [
            549
        ]
    },
    "486a1d91": {
        "1": [
            416
        ]
    },
    "77b73efb": {
        "1": [
            416
        ]
    },
    "2460167c": {
        "1": [
            550
        ]
    },
    "41c3ed84": {
        "1": [
            550
        ]
    },
    "25ad0c38": {
        "1": [
            594
        ]
    },
    "2ea1c973": {
        "1": [
            551
        ]
    },
    "4315ff0f": {
        "1": [
            594
        ]
    },
    "1c6c16c": {
        "1": [
            589
        ]
    },
    "5727f664": {
        "1": [
            588
        ]
    },
    "77acea5f": {
        "1": [
            552
        ]
    },
    "60a7f679": {
        "1": [
            553
        ]
    },
    "7fe80084": {
        "1": [
            21
        ]
    },
    "4f76725f": {
        "1": [
            555
        ]
    },
    "6b00451e": {
        "0": [
            289
        ],
        "1": [
            179
        ]
    },
    "5c638706": {
        "1": [
            150
        ]
    },
    "5b0e768": {
        "1": [
            130
        ]
    },
    "57ab8aa7": {
        "1": [
            131
        ]
    },
    "39341bd0": {
        "1": [
            557
        ]
    },
    "521bf748": {
        "1": [
            558
        ]
    },
    "1b84ee51": {
        "1": [
            559
        ]
    },
    "79c4af7b": {
        "1": [
            560
        ]
    },
    "3f77a896": {
        "1": [
            561
        ]
    },
    "1d086cf1": {
        "1": [
            243
        ]
    },
    "29ff4c2a": {
        "1": [
            244
        ]
    },
    "5ca49e95": {
        "1": [
            245
        ]
    },
    "7d35f3e9": {
        "1": [
            562
        ]
    },
    "2ad6f018": {
        "1": [
            563
        ]
    },
    "151e3377": {
        "1": [
            564
        ]
    },
    "1ea986e9": {
        "1": [
            565
        ]
    },
    "3020e9d6": {
        "1": [
            201
        ]
    },
    "18fd2": {
        "1": [
            195,
            205
        ]
    },
    "2385c977": {
        "1": [
            222
        ]
    },
    "334518a2": {
        "1": [
            222
        ]
    },
    "3367454a": {
        "1": [
            566
        ]
    },
    "62b538a6": {
        "0": [
            20,
            427,
            491,
            511,
            558,
            560,
            565,
            567
        ],
        "1": [
            5,
            6,
            18,
            81,
            568,
            569
        ]
    },
    "7ee73c5e": {
        "1": [
            133
        ]
    },
    "42fd8375": {
        "1": [
            131
        ]
    },
    "5cad79be": {
        "1": [
            571
        ]
    },
    "642391a3": {
        "1": [
            570
        ]
    },
    "6c57f370": {
        "1": [
            572
        ]
    },
    "7950a8fb": {
        "1": [
            573
        ]
    },
    "2b825521": {
        "1": [
            573
        ]
    },
    "364018b5": {
        "1": [
            130
        ]
    },
    "14a88734": {
        "1": [
            132
        ]
    },
    "4f58acf2": {
        "1": [
            574
        ]
    },
    "50a992bc": {
        "1": [
            575
        ]
    },
    "47cbd01e": {
        "1": [
            576
        ]
    },
    "57fd2dd8": {
        "1": [
            577
        ]
    },
    "500b49c9": {
        "1": [
            578
        ]
    },
    "5c567f1e": {
        "1": [
            579
        ]
    },
    "6e3af63": {
        "1": [
            580
        ]
    },
    "5e9824f": {
        "1": [
            581
        ]
    },
    "2ff64c14": {
        "1": [
            38
        ]
    },
    "7c7c7cf1": {
        "1": [
            128
        ]
    },
    "799e6057": {
        "1": [
            52
        ]
    },
    "22c88329": {
        "0": [
            495,
            549
        ],
        "1": [
            582
        ]
    },
    "16e880e1": {
        "1": [
            583
        ]
    },
    "54220ab2": {
        "1": [
            584
        ]
    },
    "76e1ad1e": {
        "1": [
            584
        ]
    },
    "1ca58c66": {
        "1": [
            37
        ]
    },
    "1c2da514": {
        "1": [
            586
        ]
    },
    "405439c8": {
        "1": [
            587
        ]
    },
    "48fad096": {
        "1": [
            29
        ]
    },
    "6edd9d": {
        "1": [
            591
        ]
    },
    "3899197e": {
        "1": [
            592
        ]
    },
    "55acc83c": {
        "1": [
            595
        ]
    },
    "41e50426": {
        "1": [
            131
        ]
    },
    "62a0d368": {
        "1": [
            593
        ]
    },
    "6e309bc8": {
        "0": [
            278
        ]
    },
    "56eb4e2f": {
        "0": [
            293
        ]
    },
    "af21991": {
        "0": [
            291
        ]
    },
    "4d15443d": {
        "0": [
            359
        ]
    },
    "7031df7d": {
        "0": [
            502
        ]
    },
    "76af7357": {
        "0": [
            312
        ]
    },
    "15659c90": {
        "0": [
            488,
            560
        ]
    },
    "3dd4f491": {
        "0": [
            505
        ]
    },
    "53f62b04": {
        "0": [
            503
        ]
    },
    "69fbf1c2": {
        "0": [
            504
        ]
    },
    "965963b": {
        "0": [
            313
        ]
    },
    "7f28a744": {
        "0": [
            558
        ]
    },
    "56106e0e": {
        "0": [
            397
        ]
    },
    "1b275251": {
        "0": [
            398
        ]
    },
    "6ca1e808": {
        "0": [
            506
        ]
    },
    "4e8b34ae": {
        "0": [
            314
        ]
    },
    "7eca0f9e": {
        "0": [
            163
        ]
    },
    "473507d6": {
        "0": [
            316
        ]
    },
    "7fcdae16": {
        "0": [
            508
        ]
    },
    "6b2667e2": {
        "0": [
            297
        ]
    },
    "25eb4113": {
        "0": [
            330
        ]
    },
    "6216a88e": {
        "0": [
            428
        ]
    },
    "7c303dd1": {
        "0": [
            392
        ]
    },
    "5f24e38b": {
        "0": [
            487
        ]
    },
    "2a494854": {
        "0": [
            488
        ]
    },
    "99bd518": {
        "0": [
            169,
            174,
            224,
            286,
            316,
            427,
            447,
            480,
            483,
            488
        ]
    },
    "faba664": {
        "0": [
            148,
            229,
            319,
            427,
            488
        ],
        "5": [
            24
        ]
    },
    "7a6d6e8c": {
        "0": [
            482
        ]
    },
    "54c7b064": {
        "0": [
            394
        ]
    },
    "f7d30b3": {
        "0": [
            391
        ]
    },
    "76bff86f": {
        "0": [
            322
        ]
    },
    "5ec11b22": {
        "0": [
            393
        ]
    },
    "6eac16f3": {
        "0": [
            485
        ]
    },
    "5740c8e5": {
        "0": [
            510
        ]
    },
    "6431d3e6": {
        "0": [
            507
        ]
    },
    "2fe6ab0a": {
        "0": [
            507
        ]
    },
    "7a18517f": {
        "0": [
            513
        ]
    },
    "5b28c4a": {
        "0": [
            512
        ]
    },
    "38c184d8": {
        "0": [
            572
        ]
    },
    "424720f6": {
        "0": [
            429
        ]
    },
    "58e43cda": {
        "0": [
            515
        ]
    },
    "4d83398c": {
        "0": [
            514
        ]
    },
    "585fc3c7": {
        "0": [
            420
        ]
    },
    "ea11d9": {
        "0": [
            420
        ]
    },
    "5fb3a7eb": {
        "0": [
            360
        ]
    },
    "540c366e": {
        "0": [
            517
        ]
    },
    "5e1abacc": {
        "0": [
            518
        ]
    },
    "2131004b": {
        "0": [
            306
        ]
    },
    "4d08972a": {
        "0": [
            206,
            233,
            338,
            353,
            356
        ]
    },
    "169cda9d": {
        "0": [
            357
        ]
    },
    "24a89c04": {
        "0": [
            357
        ]
    },
    "d03b344": {
        "0": [
            357
        ]
    },
    "2c640643": {
        "0": [
            357
        ]
    },
    "3bd7620b": {
        "0": [
            357
        ]
    },
    "7ed7e089": {
        "0": [
            354
        ]
    },
    "34308fb2": {
        "0": [
            336
        ]
    },
    "58b992ec": {
        "0": [
            336
        ]
    },
    "728dff79": {
        "0": [
            324
        ]
    },
    "4fa269ee": {
        "0": [
            362
        ]
    },
    "a1149b2": {
        "0": [
            363
        ]
    },
    "645388ab": {
        "0": [
            519
        ]
    },
    "28bc3429": {
        "0": [
            522
        ]
    },
    "750534d7": {
        "0": [
            523
        ]
    },
    "6023f433": {
        "0": [
            457
        ]
    },
    "4f141f03": {
        "0": [
            525
        ]
    },
    "7b492946": {
        "0": [
            323
        ]
    },
    "70c776d1": {
        "0": [
            318
        ]
    },
    "71bcae57": {
        "0": [
            287
        ]
    },
    "5dbdf301": {
        "0": [
            288
        ]
    },
    "7f652bde": {
        "0": [
            419
        ]
    },
    "1f7718fe": {
        "0": [
            418
        ]
    },
    "5ae2a92c": {
        "0": [
            497
        ]
    },
    "2ca1376f": {
        "0": [
            536
        ]
    },
    "44e007f5": {
        "0": [
            537
        ]
    },
    "3564f3e8": {
        "0": [
            395
        ]
    },
    "18e04c75": {
        "0": [
            327
        ]
    },
    "7b82d98c": {
        "0": [
            332
        ]
    },
    "77515d89": {
        "0": [
            328
        ]
    },
    "6a6d79e8": {
        "0": [
            422
        ]
    },
    "6234fb9": {
        "0": [
            538
        ]
    },
    "9608acd": {
        "0": [
            539
        ]
    },
    "4baf1578": {
        "0": [
            498
        ]
    },
    "7161d192": {
        "0": [
            307
        ]
    },
    "542cc1dd": {
        "0": [
            303
        ]
    },
    "36ba7aed": {
        "0": [
            308
        ]
    },
    "19357bf1": {
        "0": [
            308
        ]
    },
    "7cd8d423": {
        "0": [
            499
        ]
    },
    "eaff85f": {
        "0": [
            409
        ]
    },
    "21e300d6": {
        "0": [
            565
        ]
    },
    "1da73598": {
        "0": [
            408
        ]
    },
    "1e2778f7": {
        "0": [
            454
        ]
    },
    "51fdf893": {
        "0": [
            412
        ]
    },
    "54f512f4": {
        "0": [
            462
        ]
    },
    "21bf8e0b": {
        "0": [
            464
        ]
    },
    "39243b6": {
        "0": [
            542
        ]
    },
    "22e55ace": {
        "0": [
            465
        ]
    },
    "6e72df1e": {
        "0": [
            544
        ]
    },
    "56dee9ca": {
        "0": [
            364
        ]
    },
    "1b9393ec": {
        "0": [
            364
        ]
    },
    "70c212d1": {
        "0": [
            468
        ]
    },
    "1d6dd896": {
        "0": [
            477
        ]
    },
    "3df20d84": {
        "0": [
            547
        ]
    },
    "785a52d2": {
        "0": [
            548
        ]
    },
    "82cceba": {
        "0": [
            460,
            560
        ]
    },
    "746ead4d": {
        "0": [
            379
        ]
    },
    "2e2e2a10": {
        "0": [
            374,
            381,
            382,
            385,
            387
        ]
    },
    "6cf54841": {
        "0": [
            346
        ]
    },
    "7ee4f155": {
        "0": [
            374
        ]
    },
    "1e6fc7dc": {
        "0": [
            381
        ]
    },
    "3a1182c": {
        "0": [
            387
        ]
    },
    "f1764aa": {
        "0": [
            387
        ]
    },
    "6b006c27": {
        "0": [
            386,
            387,
            488
        ]
    },
    "3a09285c": {
        "0": [
            458
        ]
    },
    "6abb16e1": {
        "0": [
            459
        ]
    },
    "844b6ed": {
        "0": [
            540
        ]
    },
    "52898bd8": {
        "0": [
            311
        ]
    },
    "8c33d0c": {
        "0": [
            168
        ]
    },
    "61a3ecbd": {
        "0": [
            321
        ]
    },
    "742a6b1b": {
        "0": [
            493
        ]
    },
    "17decbcc": {
        "0": [
            415,
            416
        ]
    },
    "188cdfa5": {
        "0": [
            496
        ]
    },
    "3de94874": {
        "0": [
            541
        ]
    },
    "4f75e1a": {
        "0": [
            550
        ]
    },
    "52d5be04": {
        "0": [
            390
        ]
    },
    "65c69a5b": {
        "0": [
            361
        ]
    },
    "5105b97c": {
        "0": [
            431
        ]
    },
    "7c5b66c8": {
        "0": [
            431
        ]
    },
    "551a9e70": {
        "0": [
            294
        ]
    },
    "4b7f7351": {
        "0": [
            62
        ]
    },
    "3c1327b8": {
        "0": [
            569
        ]
    },
    "7b3c2abe": {
        "0": [
            192
        ]
    },
    "1ea4871f": {
        "0": [
            551
        ]
    },
    "47ea967a": {
        "0": [
            552
        ]
    },
    "377c08b1": {
        "0": [
            553
        ]
    },
    "bdcff70": {
        "0": [
            554
        ]
    },
    "5c9990f9": {
        "0": [
            436
        ]
    },
    "7b9dd6ce": {
        "0": [
            436
        ]
    },
    "9912c7d": {
        "0": [
            555
        ]
    },
    "310df7a4": {
        "0": [
            475
        ]
    },
    "68c6428d": {
        "0": [
            490
        ]
    },
    "6dafc0cf": {
        "0": [
            346
        ]
    },
    "45cfcb09": {
        "0": [
            405
        ]
    },
    "f92f964": {
        "0": [
            556
        ]
    },
    "1122d932": {
        "0": [
            494
        ]
    },
    "655b680e": {
        "0": [
            401,
            403
        ]
    },
    "68e4780e": {
        "0": [
            557
        ]
    },
    "65f545fe": {
        "0": [
            426
        ]
    },
    "58de233b": {
        "0": [
            425
        ]
    },
    "1f923fea": {
        "0": [
            365
        ]
    },
    "2eb36d58": {
        "0": [
            366
        ]
    },
    "795ceca7": {
        "0": [
            367
        ]
    },
    "178b6913": {
        "0": [
            305
        ]
    },
    "7803b3ce": {
        "0": [
            480
        ],
        "1": [
            14,
            18,
            140
        ]
    },
    "7874461c": {
        "0": [
            561
        ]
    },
    "43935ceb": {
        "0": [
            159
        ]
    },
    "775ceccd": {
        "0": [
            301
        ]
    },
    "2f6f1de6": {
        "0": [
            298
        ]
    },
    "72f4d459": {
        "0": [
            317
        ]
    },
    "3c7407ee": {
        "0": [
            337
        ]
    },
    "3c4a182d": {
        "0": [
            524
        ]
    },
    "6ddf9f33": {
        "0": [
            573
        ]
    },
    "7a642848": {
        "0": [
            439
        ]
    },
    "31cd6f4c": {
        "0": [
            281
        ]
    },
    "5dbc10bc": {
        "0": [
            283
        ]
    },
    "37491da4": {
        "0": [
            285
        ]
    },
    "3051658c": {
        "0": [
            440
        ]
    },
    "bb741c": {
        "0": [
            441
        ]
    },
    "63fdf457": {
        "0": [
            452
        ]
    },
    "4c609d24": {
        "0": [
            448
        ]
    },
    "314005e2": {
        "0": [
            417
        ]
    },
    "60d0e032": {
        "0": [
            295
        ]
    },
    "6f6d2146": {
        "0": [
            451
        ]
    },
    "5b079a94": {
        "0": [
            421
        ]
    },
    "12ebd5e5": {
        "0": [
            296
        ]
    },
    "7cc3c6a5": {
        "0": [
            446
        ]
    },
    "6b006449": {
        "0": [
            375
        ]
    },
    "5df38145": {
        "0": [
            376
        ]
    },
    "57ff5ad3": {
        "0": [
            281
        ]
    },
    "6ab9c0a6": {
        "0": [
            383
        ]
    },
    "5fe29b7b": {
        "0": [
            478
        ]
    },
    "faa4cd5": {
        "0": [
            445
        ]
    },
    "e1ed5c3": {
        "0": [
            443
        ]
    },
    "48f707e2": {
        "0": [
            340
        ]
    },
    "749473c9": {
        "0": [
            368
        ]
    },
    "2d0bf7a3": {
        "0": [
            261
        ]
    },
    "59ebfefd": {
        "0": [
            260
        ]
    },
    "3b25ae02": {
        "0": [
            262
        ]
    },
    "694633e4": {
        "0": [
            263
        ]
    },
    "23d7256b": {
        "0": [
            264
        ]
    },
    "57cec7b9": {
        "0": [
            265
        ]
    },
    "61b52838": {
        "0": [
            266
        ]
    },
    "af619fa": {
        "0": [
            268
        ]
    },
    "46cf990f": {
        "0": [
            273
        ]
    },
    "392aa50a": {
        "0": [
            276
        ]
    },
    "5e1c3170": {
        "0": [
            401
        ]
    },
    "3e90fd9a": {
        "0": [
            401,
            403
        ]
    },
    "21324e55": {
        "0": [
            239
        ]
    },
    "45f81015": {
        "0": [
            239
        ]
    },
    "353de659": {
        "0": [
            256
        ]
    },
    "1f0c9ab5": {
        "0": [
            257
        ]
    },
    "501dcd25": {
        "0": [
            371
        ]
    },
    "1b2da8c": {
        "0": [
            343
        ]
    },
    "1beda657": {
        "0": [
            435
        ]
    },
    "2b8406ab": {
        "0": [
            516
        ]
    },
    "4cab510a": {
        "0": [
            434
        ]
    },
    "22040b2f": {
        "0": [
            432
        ]
    },
    "377a507f": {
        "0": [
            433
        ]
    },
    "3df765ee": {
        "0": [
            331
        ]
    },
    "7a175b94": {
        "0": [
            467
        ]
    },
    "23ef0d36": {
        "0": [
            575
        ]
    },
    "3705af": {
        "0": [
            574
        ]
    },
    "7030eb3d": {
        "0": [
            240
        ]
    },
    "e5a59de": {
        "0": [
            241
        ]
    },
    "3ccd243c": {
        "0": [
            242
        ]
    },
    "30b7302f": {
        "0": [
            244
        ]
    },
    "59902af1": {
        "0": [
            245
        ]
    },
    "5e05953c": {
        "0": [
            246
        ]
    },
    "32e1b4c9": {
        "0": [
            247
        ]
    },
    "59a4c164": {
        "0": [
            248
        ]
    },
    "11e64d9e": {
        "0": [
            249
        ]
    },
    "53a58e13": {
        "0": [
            251
        ]
    },
    "4c252a0e": {
        "0": [
            252
        ]
    },
    "6ddfb72e": {
        "0": [
            252
        ]
    },
    "235501a6": {
        "0": [
            253
        ]
    },
    "7e516753": {
        "0": [
            254
        ]
    },
    "33e34e": {
        "0": [
            255
        ]
    },
    "6b003848": {
        "0": [
            234
        ]
    },
    "5933f224": {
        "0": [
            236
        ]
    },
    "3f106904": {
        "0": [
            237
        ]
    },
    "427f2abe": {
        "0": [
            238
        ]
    },
    "2401ebad": {
        "0": [
            469
        ]
    },
    "1124629e": {
        "0": [
            563
        ]
    },
    "2e90d1b0": {
        "0": [
            226
        ]
    },
    "72e111fe": {
        "0": [
            228
        ]
    },
    "776059cb": {
        "0": [
            335
        ]
    },
    "6b0037fb": {
        "0": [
            303
        ]
    },
    "3f74083b": {
        "0": [
            333
        ]
    },
    "7780a157": {
        "0": [
            334
        ]
    },
    "45eaf9a7": {
        "0": [
            231
        ]
    },
    "570d52c3": {
        "0": [
            230
        ]
    },
    "24e1b338": {
        "0": [
            210
        ]
    },
    "12457c3a": {
        "0": [
            211
        ]
    },
    "3b277632": {
        "0": [
            212
        ]
    },
    "307c56a6": {
        "0": [
            213
        ]
    },
    "7f8193cd": {
        "0": [
            214
        ]
    },
    "8e510dd": {
        "0": [
            215
        ]
    },
    "3ede4d42": {
        "0": [
            215
        ]
    },
    "211cda0d": {
        "0": [
            218
        ]
    },
    "33a45adf": {
        "0": [
            216
        ]
    },
    "144877e": {
        "0": [
            219
        ]
    },
    "70729fe5": {
        "0": [
            220
        ]
    },
    "1a89cb8a": {
        "0": [
            325
        ]
    },
    "59bc7ec8": {
        "0": [
            280
        ]
    },
    "305669d3": {
        "0": [
            221
        ]
    },
    "21c1de8a": {
        "0": [
            222
        ]
    },
    "418c6eed": {
        "0": [
            303
        ]
    },
    "6448c544": {
        "0": [
            223
        ]
    },
    "21de60f6": {
        "0": [
            397
        ]
    },
    "5fa09aca": {
        "0": [
            576
        ]
    },
    "46f5e286": {
        "0": [
            470
        ]
    },
    "37aee222": {
        "0": [
            472
        ]
    },
    "17af7a6a": {
        "0": [
            209
        ]
    },
    "2ea6d4da": {
        "0": [
            577
        ]
    },
    "683fa6": {
        "0": [
            471
        ]
    },
    "3b608c54": {
        "0": [
            473
        ]
    },
    "78192fba": {
        "0": [
            404
        ]
    },
    "3e292efb": {
        "0": [
            578
        ]
    },
    "69e78bbc": {
        "0": [
            208
        ]
    },
    "5476214e": {
        "0": [
            270
        ]
    },
    "90f4e17": {
        "0": [
            271
        ]
    },
    "36d8d2ff": {
        "0": [
            272
        ]
    },
    "17e09e10": {
        "0": [
            526,
            527,
            532
        ]
    },
    "1f2770cf": {
        "0": [
            205
        ]
    },
    "2aaf4c5": {
        "0": [
            206
        ]
    },
    "359eef15": {
        "0": [
            194
        ]
    },
    "27dab218": {
        "0": [
            194
        ]
    },
    "78a2c30d": {
        "0": [
            194
        ]
    },
    "214980fd": {
        "0": [
            331
        ]
    },
    "1dcabeed": {
        "0": [
            202
        ]
    },
    "7ee4ee86": {
        "0": [
            204
        ]
    },
    "3d89898d": {
        "0": [
            137
        ]
    },
    "1f5bfd8b": {
        "0": [
            152
        ]
    },
    "7488addb": {
        "0": [
            189
        ]
    },
    "9ebb596": {
        "0": [
            191
        ]
    },
    "7892b1a7": {
        "0": [
            193
        ]
    },
    "15028f0d": {
        "0": [
            195
        ]
    },
    "5b3b07a2": {
        "0": [
            200
        ]
    },
    "46d98529": {
        "0": [
            201
        ]
    },
    "5d58e91": {
        "0": [
            203
        ]
    },
    "78e7bc5b": {
        "0": [
            197
        ]
    },
    "438c2942": {
        "0": [
            198
        ]
    },
    "4b0f358c": {
        "0": [
            185
        ]
    },
    "6184a561": {
        "0": [
            189
        ]
    },
    "31e7c291": {
        "0": [
            190
        ]
    },
    "1c8e0a1c": {
        "0": [
            186
        ]
    },
    "550312de": {
        "0": [
            176
        ]
    },
    "11c8f44": {
        "0": [
            176
        ]
    },
    "742cb490": {
        "0": [
            175
        ]
    },
    "4039a95a": {
        "0": [
            549
        ]
    },
    "5a009914": {
        "0": [
            549
        ]
    },
    "a4c3a90": {
        "0": [
            181
        ]
    },
    "595f3c71": {
        "0": [
            181
        ]
    },
    "79fe76fa": {
        "0": [
            179
        ]
    },
    "cb6622d": {
        "0": [
            179
        ]
    },
    "3051617b": {
        "0": [
            179
        ]
    },
    "fb24b26": {
        "0": [
            179
        ]
    },
    "52c4aad6": {
        "0": [
            178
        ]
    },
    "38b33f66": {
        "0": [
            177
        ]
    },
    "14b3037d": {
        "0": [
            412
        ]
    },
    "18408bd3": {
        "0": [
            412
        ]
    },
    "79fe4c1c": {
        "0": [
            412
        ]
    },
    "61289ea2": {
        "0": [
            339
        ]
    },
    "1f143bbe": {
        "0": [
            424
        ]
    },
    "30f87476": {
        "0": [
            183
        ]
    },
    "1bc54a04": {
        "0": [
            184
        ]
    },
    "1441d7cd": {
        "0": [
            184
        ]
    },
    "176a7b31": {
        "0": [
            467
        ]
    },
    "4aa3374a": {
        "0": [
            579
        ]
    },
    "3bd72951": {
        "0": [
            384
        ]
    },
    "794cc2fe": {
        "0": [
            141
        ]
    },
    "752cefd9": {
        "0": [
            173
        ]
    },
    "26a7b746": {
        "0": [
            172
        ]
    },
    "3c39851e": {
        "0": [
            138
        ]
    },
    "53d1af95": {
        "0": [
            142
        ]
    },
    "3bfb90e0": {
        "0": [
            143
        ]
    },
    "6a5fbf3a": {
        "0": [
            149
        ]
    },
    "ef0236a": {
        "0": [
            149
        ]
    },
    "5c5edd87": {
        "0": [
            279
        ]
    },
    "1a17a918": {
        "0": [
            150
        ]
    },
    "5f0dff6b": {
        "0": [
            153
        ]
    },
    "4943ec8d": {
        "0": [
            155
        ]
    },
    "204e28f8": {
        "0": [
            164
        ]
    },
    "4788895b": {
        "0": [
            165
        ]
    },
    "4314dbd7": {
        "0": [
            404
        ]
    },
    "231831e5": {
        "0": [
            397
        ]
    },
    "7269395b": {
        "0": [
            432
        ]
    },
    "788e7acb": {
        "0": [
            166
        ]
    },
    "636aa8b8": {
        "0": [
            167
        ]
    },
    "6e6dc2a8": {
        "0": [
            162
        ]
    },
    "134cad6": {
        "0": [
            146
        ]
    },
    "26ee4c68": {
        "0": [
            151
        ]
    },
    "841bb33": {
        "0": [
            154
        ]
    },
    "53b23277": {
        "0": [
            156
        ]
    },
    "6868d1c2": {
        "0": [
            266
        ]
    },
    "4a3efb3c": {
        "0": [
            161
        ]
    },
    "17972d7e": {
        "0": [
            428
        ]
    },
    "748120b2": {
        "0": [
            158
        ]
    },
    "47dc4c0e": {
        "0": [
            160
        ]
    },
    "2ee2db60": {
        "0": [
            310
        ]
    },
    "621f9a60": {
        "0": [
            428
        ]
    },
    "6188a7e8": {
        "0": [
            398
        ]
    },
    "4d8a3306": {
        "0": [
            144
        ]
    },
    "7c0c5199": {
        "0": [
            411
        ]
    },
    "5c35b52d": {
        "0": [
            411
        ]
    },
    "76823f0": {
        "0": [
            140
        ]
    },
    "3bb720c3": {
        "0": [
            145
        ]
    },
    "3ba83501": {
        "0": [
            147
        ]
    },
    "14d51e65": {
        "0": [
            397
        ]
    },
    "7281f249": {
        "0": [
            377,
            378
        ]
    },
    "1e1ac528": {
        "0": [
            407
        ]
    },
    "32a36174": {
        "0": [
            196
        ]
    },
    "35499bc6": {
        "0": [
            491
        ]
    },
    "c0aa48f": {
        "0": [
            474
        ]
    },
    "4fd0b481": {
        "0": [
            139
        ]
    },
    "3d8b9222": {
        "0": [
            475
        ]
    },
    "267a15c6": {
        "0": [
            267
        ]
    },
    "760b3174": {
        "0": [
            438
        ]
    },
    "2b177c02": {
        "0": [
            136
        ]
    },
    "5d395e0f": {
        "0": [
            135
        ]
    },
    "6ecd25c1": {
        "0": [
            134
        ]
    },
    "7453c7ec": {
        "0": [
            133
        ]
    },
    "79bac35d": {
        "0": [
            132
        ]
    },
    "5ef5136e": {
        "0": [
            131
        ]
    },
    "4a5ad3b6": {
        "0": [
            130
        ]
    },
    "63a34972": {
        "0": [
            129
        ]
    },
    "480967a0": {
        "0": [
            128
        ]
    },
    "4fc3da0e": {
        "0": [
            371
        ]
    },
    "af64a49": {
        "0": [
            274
        ]
    },
    "14db1b3f": {
        "0": [
            456
        ]
    },
    "735fe9": {
        "0": [
            456
        ]
    },
    "5ba56d61": {
        "0": [
            455
        ]
    },
    "340d29b1": {
        "0": [
            217
        ]
    },
    "27d1141d": {
        "0": [
            442
        ]
    },
    "44cfb1f9": {
        "0": [
            125
        ]
    },
    "4ea123d8": {
        "0": [
            127
        ]
    },
    "3a1348c6": {
        "0": [
            412
        ]
    },
    "63f3be0a": {
        "0": [
            520
        ]
    },
    "4e2b8ad2": {
        "0": [
            522
        ]
    },
    "1896950b": {
        "0": [
            522
        ]
    },
    "776ef960": {
        "0": [
            521
        ]
    },
    "af5d8ba": {
        "0": [
            521
        ]
    },
    "7c7883d2": {
        "0": [
            561
        ]
    },
    "32a0ce1b": {
        "0": [
            349
        ]
    },
    "7f9fe38e": {
        "0": [
            520
        ]
    },
    "6075bfbc": {
        "0": [
            564
        ]
    },
    "cc5f00": {
        "0": [
            569
        ]
    },
    "c577aa3": {
        "0": [
            569
        ]
    },
    "36753bb7": {
        "0": [
            477
        ]
    },
    "6f308faa": {
        "0": [
            124
        ]
    },
    "67167a8f": {
        "0": [
            122
        ]
    },
    "3b0d63c5": {
        "0": [
            388
        ]
    },
    "4efc18c5": {
        "0": [
            302
        ]
    },
    "20c739ea": {
        "0": [
            490
        ]
    },
    "48ddec04": {
        "0": [
            304
        ]
    },
    "447a5ac6": {
        "0": [
            121
        ]
    },
    "331f2a39": {
        "0": [
            389
        ]
    },
    "5b0126e9": {
        "0": [
            120
        ]
    },
    "173d43e5": {
        "0": [
            100
        ]
    },
    "6d94bc2e": {
        "0": [
            342
        ]
    },
    "759144c4": {
        "0": [
            106,
            346
        ]
    },
    "7ee527a5": {
        "0": [
            118
        ]
    },
    "2b2b4ce0": {
        "0": [
            116
        ]
    },
    "7194c7e2": {
        "0": [
            117
        ]
    },
    "551fd809": {
        "0": [
            115
        ]
    },
    "7bfb9a8f": {
        "0": [
            489
        ]
    },
    "426141aa": {
        "0": [
            346
        ]
    },
    "7b3a5116": {
        "0": [
            429
        ]
    },
    "251b5c40": {
        "0": [
            440
        ]
    },
    "72c5a707": {
        "0": [
            410
        ]
    },
    "7ee4f14f": {
        "0": [
            371
        ]
    },
    "1b7e903e": {
        "0": [
            238
        ]
    },
    "12d6295e": {
        "0": [
            114
        ]
    },
    "5f858a25": {
        "0": [
            476
        ]
    },
    "4fca2c5d": {
        "0": [
            476
        ]
    },
    "7826dfe3": {
        "0": [
            476
        ]
    },
    "20cde204": {
        "0": [
            113
        ]
    },
    "5bb60a76": {
        "0": [
            112
        ]
    },
    "677fe668": {
        "0": [
            110
        ]
    },
    "3c84a3cf": {
        "0": [
            300
        ]
    },
    "4e1115be": {
        "0": [
            108
        ]
    },
    "1de87f14": {
        "0": [
            109
        ]
    },
    "4ec22847": {
        "0": [
            450
        ]
    },
    "546be3df": {
        "0": [
            449
        ]
    },
    "5bad4a7d": {
        "0": [
            449
        ]
    },
    "26b75b01": {
        "0": [
            286,
            374
        ]
    },
    "5e8d5dcf": {
        "0": [
            126
        ]
    },
    "6435efdd": {
        "0": [
            284
        ]
    },
    "30f8b285": {
        "0": [
            107
        ]
    },
    "4f676bf7": {
        "0": [
            373
        ]
    },
    "4502535f": {
        "0": [
            157
        ]
    },
    "1548d09b": {
        "0": [
            105
        ]
    },
    "49662f78": {
        "0": [
            100,
            104
        ]
    },
    "6cddfc29": {
        "0": [
            443
        ]
    },
    "2c565d24": {
        "0": [
            103
        ]
    },
    "45da1015": {
        "0": [
            444
        ]
    },
    "645c785c": {
        "0": [
            102
        ]
    },
    "42b0013f": {
        "0": [
            291
        ]
    },
    "76aa7c64": {
        "0": [
            268
        ]
    },
    "6bfd8d4e": {
        "0": [
            197
        ]
    },
    "6bc9acb": {
        "0": [
            430
        ]
    },
    "3ca1f66": {
        "0": [
            357
        ]
    },
    "32a19d27": {
        "0": [
            356
        ]
    },
    "4008fc62": {
        "0": [
            408
        ]
    },
    "26b75323": {
        "0": [
            480
        ]
    },
    "5db4e6d0": {
        "0": [
            101
        ]
    },
    "61ec01de": {
        "0": [
            100
        ]
    },
    "4f5adb27": {
        "0": [
            426
        ]
    },
    "2ce17a16": {
        "0": [
            559
        ]
    },
    "597ffed5": {
        "0": [
            171
        ]
    },
    "7caf0e1b": {
        "0": [
            273
        ]
    },
    "3536ef3f": {
        "0": [
            265
        ]
    },
    "484076a1": {
        "0": [
            232
        ]
    },
    "4197ab56": {
        "0": [
            301
        ]
    },
    "587275d8": {
        "0": [
            400
        ]
    },
    "22126d31": {
        "0": [
            399
        ]
    },
    "693975e9": {
        "0": [
            430
        ]
    },
    "745c2669": {
        "0": [
            99
        ]
    },
    "785a8b98": {
        "0": [
            480
        ]
    },
    "6b377e5c": {
        "0": [
            480
        ]
    },
    "2ffad74e": {
        "0": [
            431
        ]
    },
    "542ca407": {
        "0": [
            165
        ]
    },
    "1b976054": {
        "0": [
            98
        ]
    },
    "4f71e24": {
        "0": [
            97
        ]
    },
    "66e69efd": {
        "0": [
            402,
            403
        ]
    },
    "6787634a": {
        "0": [
            96
        ]
    },
    "3d043150": {
        "0": [
            381
        ]
    },
    "30ea32d6": {
        "0": [
            187
        ]
    },
    "7476455d": {
        "0": [
            95
        ]
    },
    "7fa04ef": {
        "0": [
            299
        ]
    },
    "2538a6aa": {
        "0": [
            299
        ]
    },
    "b09cbc2": {
        "0": [
            94
        ]
    },
    "5eb81ca9": {
        "0": [
            94
        ]
    },
    "69a2a973": {
        "0": [
            486
        ]
    },
    "2c857b23": {
        "0": [
            392
        ]
    },
    "2c08a841": {
        "0": [
            488
        ]
    },
    "6b006bc1": {
        "0": [
            376
        ]
    },
    "59119acd": {
        "0": [
            235
        ]
    },
    "396fe46": {
        "0": [
            93
        ]
    },
    "41310f78": {
        "0": [
            111
        ]
    },
    "1e85a525": {
        "0": [
            92
        ]
    },
    "6f117542": {
        "0": [
            85
        ]
    },
    "4f1081e7": {
        "0": [
            91
        ]
    },
    "5d886008": {
        "0": [
            89
        ]
    },
    "fa1457c": {
        "0": [
            88
        ]
    },
    "5fa66421": {
        "0": [
            88
        ]
    },
    "3b80f03a": {
        "0": [
            81
        ]
    },
    "13fbd910": {
        "0": [
            85,
            87
        ]
    },
    "6f11744a": {
        "0": [
            87
        ]
    },
    "6f117531": {
        "0": [
            86
        ]
    },
    "7a6e8059": {
        "0": [
            82
        ]
    },
    "46b6bd48": {
        "0": [
            82
        ]
    },
    "31e45aec": {
        "0": [
            39
        ]
    },
    "2dd7286b": {
        "0": [
            38
        ]
    },
    "3abb3a41": {
        "0": [
            37
        ]
    },
    "763f4a27": {
        "0": [
            36
        ]
    },
    "64648c1e": {
        "0": [
            80
        ]
    },
    "15b366a7": {
        "0": [
            266
        ]
    },
    "57fa076": {
        "0": [
            292,
            488
        ]
    },
    "492078e6": {
        "0": [
            79
        ]
    },
    "7c4cfe6f": {
        "0": [
            77
        ]
    },
    "404be749": {
        "0": [
            480
        ]
    },
    "61df2d3a": {
        "0": [
            75
        ]
    },
    "435758e2": {
        "0": [
            76
        ]
    },
    "4be02f88": {
        "0": [
            76
        ]
    },
    "654455f9": {
        "0": [
            74
        ]
    },
    "1ca881e9": {
        "0": [
            462
        ]
    },
    "77df3f9b": {
        "0": [
            77
        ]
    },
    "3c82c59d": {
        "0": [
            73
        ]
    },
    "2185ff6f": {
        "0": [
            72
        ]
    },
    "4165a34f": {
        "0": [
            71
        ]
    },
    "5621f9ff": {
        "0": [
            69
        ]
    },
    "57de42bd": {
        "0": [
            224
        ]
    },
    "725c9c59": {
        "0": [
            68
        ]
    },
    "4fd21c18": {
        "0": [
            67
        ]
    },
    "7e63eebc": {
        "0": [
            66
        ]
    },
    "7c09296c": {
        "0": [
            206
        ]
    },
    "788a1412": {
        "0": [
            65
        ]
    },
    "3aa5a7ff": {
        "0": [
            207
        ]
    },
    "c935e78": {
        "0": [
            64
        ]
    },
    "3c67dbab": {
        "0": [
            63
        ]
    },
    "547b9e60": {
        "0": [
            480
        ]
    },
    "6b008599": {
        "0": [
            405
        ]
    },
    "54207b8a": {
        "0": [
            315
        ]
    },
    "6e5d4552": {
        "0": [
            59
        ]
    },
    "3a66284a": {
        "0": [
            58
        ]
    },
    "6fdd0c3b": {
        "0": [
            57
        ]
    },
    "3696f014": {
        "0": [
            56
        ]
    },
    "f5c4fae": {
        "0": [
            55
        ]
    },
    "410de7ee": {
        "0": [
            54
        ]
    },
    "2bbf694d": {
        "0": [
            53
        ]
    },
    "af21782": {
        "0": [
            52
        ]
    },
    "6e50a801": {
        "0": [
            51
        ]
    },
    "2bc7313c": {
        "0": [
            50
        ]
    },
    "54dd5ca5": {
        "0": [
            49
        ]
    },
    "4e619e2a": {
        "0": [
            580
        ]
    },
    "7d6af43f": {
        "0": [
            48,
            533
        ]
    },
    "65edfdb6": {
        "0": [
            47
        ]
    },
    "af45e42": {
        "0": [
            46
        ]
    },
    "1980d29": {
        "0": [
            269
        ]
    },
    "7756d3af": {
        "0": [
            45
        ]
    },
    "60eea429": {
        "0": [
            44
        ]
    },
    "7836bb95": {
        "0": [
            43
        ]
    },
    "5cce58cb": {
        "0": [
            42
        ]
    },
    "1c551": {
        "0": [
            41
        ]
    },
    "76cc6a5f": {
        "0": [
            40
        ]
    },
    "4ac3572d": {
        "0": [
            35
        ]
    },
    "7e4f42be": {
        "0": [
            34
        ]
    },
    "5a2d4c4": {
        "0": [
            33,
            462,
            488,
            560
        ]
    },
    "6f243db8": {
        "0": [
            336
        ]
    },
    "5888d756": {
        "0": [
            480
        ]
    },
    "2e2b513a": {
        "0": [
            31
        ]
    },
    "4ac7fa4a": {
        "0": [
            351
        ]
    },
    "721b180b": {
        "0": [
            30
        ]
    },
    "4bf287c1": {
        "0": [
            32
        ]
    },
    "47ac57d6": {
        "0": [
            32
        ]
    },
    "36f71f7": {
        "0": [
            426
        ]
    },
    "75663d97": {
        "0": [
            29
        ]
    },
    "545e75fa": {
        "0": [
            28
        ]
    },
    "6dbe4190": {
        "0": [
            204
        ]
    },
    "7fb0c7ee": {
        "0": [
            429
        ]
    },
    "22a3b624": {
        "0": [
            26
        ]
    },
    "3345af77": {
        "0": [
            25
        ]
    },
    "1474b560": {
        "0": [
            24
        ]
    },
    "30b1eae4": {
        "0": [
            271
        ]
    },
    "31583e35": {
        "0": [
            23
        ]
    },
    "58c147e": {
        "0": [
            22
        ]
    },
    "783c440c": {
        "0": [
            21
        ]
    },
    "3e80f6c1": {
        "0": [
            20
        ]
    },
    "2849308f": {
        "0": [
            19
        ]
    },
    "5931b8d": {
        "0": [
            500
        ]
    },
    "4a6f0185": {
        "0": [
            462
        ]
    },
    "550fd924": {
        "0": [
            572
        ]
    },
    "5d4f72fe": {
        "0": [
            543
        ]
    },
    "52632bdd": {
        "0": [
            543
        ]
    },
    "746ba5c3": {
        "0": [
            543
        ]
    },
    "285071b3": {
        "0": [
            275
        ]
    },
    "742a3c5f": {
        "0": [
            429
        ]
    },
    "76fb464c": {
        "0": [
            565
        ]
    },
    "654f8347": {
        "0": [
            402
        ]
    },
    "66cbe888": {
        "0": [
            18
        ]
    },
    "6c324e85": {
        "0": [
            17
        ]
    },
    "af29bc8": {
        "0": [
            16
        ]
    },
    "41816f6a": {
        "0": [
            15
        ]
    },
    "1f6b2b37": {
        "0": [
            15
        ]
    },
    "59106e41": {
        "0": [
            14
        ]
    },
    "cf62bb5": {
        "0": [
            396
        ]
    },
    "2d6238f6": {
        "0": [
            483
        ]
    },
    "7cb575bb": {
        "0": [
            13
        ]
    },
    "6429bcdb": {
        "0": [
            12
        ]
    },
    "7395bf96": {
        "0": [
            316
        ]
    },
    "634b7ee6": {
        "0": [
            11
        ]
    },
    "441a1b8c": {
        "0": [
            374
        ]
    },
    "1e772076": {
        "0": [
            10
        ]
    },
    "269f8160": {
        "0": [
            9
        ]
    },
    "5658c291": {
        "0": [
            8
        ]
    },
    "2ce16a35": {
        "0": [
            300
        ]
    },
    "62ca149a": {
        "0": [
            103
        ]
    },
    "4305ac4e": {
        "0": [
            5
        ]
    },
    "2da75330": {
        "0": [
            414,
            416
        ]
    },
    "7a8ef3a4": {
        "0": [
            416
        ]
    },
    "6bd6064": {
        "0": [
            416
        ]
    },
    "d52b556": {
        "0": [
            188
        ]
    },
    "6eafb7ae": {
        "0": [
            83
        ]
    },
    "77acc473": {
        "0": [
            4
        ]
    },
    "354c02a9": {
        "0": [
            3
        ]
    },
    "7415ea0a": {
        "0": [
            2
        ]
    },
    "4e7cc556": {
        "0": [
            566
        ]
    },
    "b3aaecd": {
        "0": [
            570
        ]
    },
    "17efb90c": {
        "0": [
            535
        ]
    },
    "1a7c7b4": {
        "0": [
            373
        ]
    },
    "50aa949f": {
        "0": [
            1
        ]
    },
    "5b595245": {
        "0": [
            0
        ]
    },
    "2447f80d": {
        "0": [
            209
        ]
    },
    "468be248": {
        "0": [
            345
        ]
    },
    "319f3e7c": {
        "0": [
            290
        ]
    },
    "542d837f": {
        "0": [
            243
        ]
    },
    "37a77f": {
        "2": [
            24
        ]
    },
    "7a7a1188": {
        "2": [
            24
        ]
    },
    "124bb34d": {
        "2": [
            27
        ]
    },
    "22cffe9d": {
        "2": [
            27
        ]
    },
    "557218ac": {
        "2": [
            28
        ]
    },
    "72b5c3b": {
        "2": [
            28
        ]
    },
    "31aa22": {
        "2": [
            33
        ]
    },
    "34ea7e68": {
        "2": [
            33
        ]
    },
    "733dfaea": {
        "2": [
            34
        ]
    },
    "5e64c886": {
        "2": [
            34
        ]
    },
    "51a1c9e3": {
        "2": [
            25
        ]
    },
    "5142fee4": {
        "2": [
            38
        ]
    },
    "7edd8ae2": {
        "2": [
            39
        ]
    },
    "6935d4c3": {
        "2": [
            40
        ]
    },
    "5dab46db": {
        "2": [
            41
        ]
    },
    "1d46bc8c": {
        "2": [
            42
        ]
    },
    "37484c84": {
        "2": [
            43
        ]
    },
    "70872f4b": {
        "2": [
            44
        ]
    },
    "7f652076": {
        "2": [
            44
        ]
    },
    "455ab257": {
        "2": [
            45
        ]
    },
    "41bee789": {
        "2": [
            46
        ]
    },
    "47eeec5c": {
        "2": [
            47
        ]
    },
    "424d2e5c": {
        "2": [
            48
        ]
    },
    "6dcbc76a": {
        "2": [
            49
        ]
    },
    "1ed958d1": {
        "2": [
            50
        ]
    },
    "4b96d2df": {
        "2": [
            51
        ]
    },
    "69cbf2f": {
        "2": [
            52
        ]
    },
    "23bcc980": {
        "2": [
            54
        ]
    },
    "58aca1de": {
        "2": [
            55
        ]
    },
    "20d5943a": {
        "2": [
            56
        ]
    },
    "4c465254": {
        "2": [
            57
        ]
    },
    "37d7c8d4": {
        "2": [
            60
        ]
    },
    "54ff4bea": {
        "2": [
            61
        ]
    },
    "5d77d335": {
        "2": [
            63
        ]
    },
    "78505ff3": {
        "2": [
            65
        ]
    },
    "58c5049": {
        "2": [
            64
        ]
    },
    "3099fc": {
        "2": [
            66
        ]
    },
    "6adac32d": {
        "2": [
            67
        ]
    },
    "a45d0e3": {
        "2": [
            68
        ]
    },
    "38aa9831": {
        "2": [
            69
        ]
    },
    "3eef7d8b": {
        "2": [
            70
        ]
    },
    "b690215": {
        "2": [
            25
        ]
    },
    "7dd3a0ea": {
        "2": [
            21
        ]
    },
    "87c1849": {
        "2": [
            71
        ]
    },
    "13e4c585": {
        "2": [
            32
        ]
    },
    "448ad464": {
        "2": [
            19
        ]
    },
    "61b2d20c": {
        "2": [
            18
        ]
    },
    "20bf3b01": {
        "2": [
            17
        ]
    },
    "39c552e4": {
        "2": [
            16
        ]
    },
    "3cd0c741": {
        "2": [
            15
        ]
    },
    "2bc7435a": {
        "2": [
            29
        ]
    },
    "28b38ae1": {
        "2": [
            72
        ]
    },
    "60dd8c50": {
        "2": [
            36
        ]
    },
    "b0e3927": {
        "2": [
            37
        ]
    },
    "27ad9f40": {
        "2": [
            35
        ]
    },
    "eacf200": {
        "2": [
            73
        ]
    },
    "6571ec8": {
        "2": [
            74
        ]
    },
    "208b6b69": {
        "2": [
            75
        ]
    },
    "435b001c": {
        "2": [
            76
        ]
    },
    "8a84412": {
        "2": [
            81
        ]
    },
    "8a84403": {
        "2": [
            80
        ]
    },
    "244d78f4": {
        "2": [
            82
        ]
    },
    "5e9031e7": {
        "2": [
            84
        ]
    },
    "dc3ef15": {
        "2": [
            78
        ]
    },
    "5545e658": {
        "2": [
            79
        ]
    },
    "59afff4": {
        "2": [
            77
        ]
    },
    "35aab75d": {
        "2": [
            86
        ]
    },
    "30cf3e": {
        "2": [
            87
        ]
    },
    "95e801a": {
        "2": [
            88
        ]
    },
    "7fef78cc": {
        "2": [
            14
        ]
    },
    "2eef7f": {
        "2": [
            13
        ]
    },
    "1b89e": {
        "2": [
            10
        ]
    },
    "5de49c65": {
        "2": [
            12
        ]
    },
    "45d1d5be": {
        "2": [
            11
        ]
    },
    "78db8530": {
        "2": [
            9
        ]
    },
    "1908c": {
        "2": [
            8
        ]
    },
    "58f0c76": {
        "2": [
            89
        ]
    },
    "427b6876": {
        "2": [
            7
        ]
    },
    "60189c4c": {
        "2": [
            30
        ]
    },
    "435176fd": {
        "2": [
            6
        ]
    },
    "571a7973": {
        "2": [
            5
        ]
    },
    "1c6f874b": {
        "2": [
            4
        ]
    },
    "20d6812d": {
        "2": [
            112
        ]
    },
    "422fe8b2": {
        "2": [
            113
        ]
    },
    "70e439c4": {
        "2": [
            114
        ]
    },
    "469cd8ec": {
        "2": [
            115
        ]
    },
    "33e83e6b": {
        "2": [
            119
        ]
    },
    "4a108556": {
        "2": [
            120
        ]
    },
    "7a686eeb": {
        "2": [
            121
        ]
    },
    "20a26c40": {
        "2": [
            122
        ]
    },
    "399659e7": {
        "2": [
            124
        ]
    },
    "1f2770ae": {
        "2": [
            2
        ]
    },
    "2aeccc": {
        "2": [
            3
        ]
    },
    "818c9e1": {
        "2": [
            53
        ]
    },
    "47eeeb37": {
        "2": [
            125
        ]
    },
    "1f356b9f": {
        "2": [
            126
        ]
    },
    "4260d781": {
        "2": [
            127
        ]
    },
    "43c297c3": {
        "2": [
            128
        ]
    },
    "45dfed3f": {
        "2": [
            11
        ]
    },
    "7c5c7c14": {
        "2": [
            100
        ]
    },
    "4c3cffd7": {
        "2": [
            23
        ]
    },
    "1a07ab98": {
        "2": [
            0
        ]
    },
    "38beb9bb": {
        "2": [
            129
        ]
    },
    "76d79d76": {
        "2": [
            130
        ]
    },
    "4242688b": {
        "2": [
            131
        ]
    },
    "2b7a0ece": {
        "2": [
            133
        ]
    },
    "3af3f03b": {
        "2": [
            134
        ]
    },
    "1b178": {
        "2": [
            134
        ]
    },
    "3df5adec": {
        "2": [
            135
        ]
    },
    "17e7b": {
        "2": [
            136
        ]
    },
    "541e631e": {
        "2": [
            137
        ]
    },
    "545ef41d": {
        "2": [
            138
        ]
    },
    "7db37f66": {
        "2": [
            139
        ]
    },
    "19c8d11b": {
        "2": [
            140
        ]
    },
    "d0657ba": {
        "2": [
            141
        ]
    },
    "68c3c43e": {
        "2": [
            142
        ]
    },
    "291140f1": {
        "3": [
            14
        ]
    },
    "7ea0f00d": {
        "3": [
            12
        ]
    },
    "2f64cfa0": {
        "3": [
            6
        ]
    },
    "6aa09396": {
        "3": [
            6
        ]
    },
    "6d92ab97": {
        "3": [
            17
        ]
    },
    "41bea438": {
        "3": [
            17
        ]
    },
    "5949640c": {
        "3": [
            20
        ]
    },
    "b13e3d8": {
        "3": [
            11
        ]
    },
    "141349bc": {
        "3": [
            2
        ]
    },
    "4d96ba3a": {
        "3": [
            13
        ]
    },
    "2617a2ae": {
        "3": [
            13
        ]
    },
    "17521c9c": {
        "3": [
            13
        ]
    },
    "2d2169ce": {
        "3": [
            7
        ]
    },
    "1cc2ebf8": {
        "3": [
            21
        ]
    },
    "1cc2f390": {
        "3": [
            21
        ]
    },
    "7109de88": {
        "3": [
            15
        ]
    },
    "17fd00b7": {
        "3": [
            9
        ]
    },
    "39c16526": {
        "3": [
            4
        ]
    },
    "5c544d2b": {
        "3": [
            18
        ]
    },
    "6239cb6c": {
        "3": [
            18
        ]
    },
    "6b8727fc": {
        "3": [
            10
        ]
    },
    "3324d9": {
        "3": [
            10
        ]
    },
    "416772b": {
        "3": [
            22
        ]
    },
    "6a67a835": {
        "3": [
            8
        ]
    },
    "1018809f": {
        "3": [
            16
        ]
    },
    "2d2ca57c": {
        "3": [
            27
        ]
    },
    "4b45d58e": {
        "3": [
            29
        ]
    },
    "58e9d22c": {
        "3": [
            38
        ]
    },
    "25f0293d": {
        "3": [
            39
        ]
    },
    "59af678a": {
        "3": [
            40
        ]
    },
    "650a88ba": {
        "3": [
            41
        ]
    },
    "68778b84": {
        "3": [
            42
        ]
    },
    "3b1c18bc": {
        "3": [
            42
        ]
    },
    "79ff4fa3": {
        "3": [
            42
        ]
    },
    "3f25a42": {
        "4": [
            0
        ]
    },
    "4bbe9c71": {
        "4": [
            0
        ]
    },
    "4a959525": {
        "4": [
            0
        ]
    },
    "7694e40a": {
        "4": [
            1
        ]
    },
    "61ba53f3": {
        "4": [
            4
        ]
    },
    "725d7a7e": {
        "4": [
            5
        ]
    },
    "2f0d879f": {
        "4": [
            5
        ]
    },
    "6a62aba1": {
        "4": [
            8
        ]
    },
    "a1ad812": {
        "4": [
            9
        ]
    },
    "13153f00": {
        "4": [
            9
        ]
    },
    "37ff2cb1": {
        "4": [
            10
        ]
    },
    "228ba98b": {
        "4": [
            10
        ]
    },
    "30a802e2": {
        "4": [
            13
        ]
    },
    "5ccae259": {
        "4": [
            11
        ]
    },
    "41ad029e": {
        "4": [
            11
        ]
    },
    "274f98be": {
        "4": [
            12
        ]
    },
    "7c029ad5": {
        "4": [
            13
        ]
    },
    "34ae49": {
        "4": [
            15
        ]
    },
    "8fd0af": {
        "4": [
            16
        ]
    },
    "6f89de48": {
        "4": [
            16
        ]
    },
    "2dbf02d9": {
        "4": [
            17
        ]
    },
    "20d28ef2": {
        "4": [
            18
        ]
    },
    "738f2e4e": {
        "4": [
            19
        ]
    },
    "36ed040e": {
        "4": [
            20
        ]
    },
    "6afdac7e": {
        "4": [
            21
        ]
    },
    "1503ab70": {
        "5": [
            0
        ]
    },
    "3db7ef1a": {
        "5": [
            4
        ]
    },
    "752ffcf6": {
        "5": [
            4
        ]
    },
    "4757cb92": {
        "5": [
            6
        ]
    },
    "4757cb93": {
        "5": [
            6
        ]
    },
    "46b58382": {
        "5": [
            4
        ]
    },
    "25d2d0a2": {
        "5": [
            4
        ]
    },
    "592cfb1": {
        "5": [
            8
        ]
    },
    "3cbdb68c": {
        "5": [
            8
        ]
    },
    "31b858d8": {
        "5": [
            9
        ]
    },
    "17515ed5": {
        "5": [
            9
        ]
    },
    "3ea01e09": {
        "5": [
            11
        ]
    },
    "551feab2": {
        "5": [
            11
        ]
    },
    "c59604": {
        "5": [
            12
        ]
    },
    "1c32ec3d": {
        "5": [
            13
        ]
    },
    "6bcb545a": {
        "5": [
            13
        ]
    },
    "3bf52732": {
        "5": [
            14
        ]
    },
    "6cde2c63": {
        "1": [
            171,
            172
        ],
        "5": [
            15
        ]
    },
    "4e0bab2a": {
        "5": [
            16
        ]
    },
    "112e0d3b": {
        "5": [
            17
        ]
    },
    "6ae88a6b": {
        "5": [
            18
        ]
    },
    "36c39532": {
        "5": [
            19
        ]
    },
    "6bf49c41": {
        "5": [
            20
        ]
    },
    "3a90526b": {
        "5": [
            21
        ]
    },
    "26ef5426": {
        "5": [
            22
        ]
    },
    "56d6e1b6": {
        "5": [
            23
        ]
    },
    "5613403d": {
        "5": [
            2
        ]
    },
    "7337aeba": {
        "5": [
            3
        ]
    },
    "160d12d3": {
        "5": [
            1
        ]
    },
    "27a43feb": {
        "5": [
            2
        ]
    },
    "55eadea2": {
        "5": [
            25
        ]
    },
    "45a439fa": {
        "5": [
            28
        ]
    },
    "fd44742": {
        "5": [
            2
        ]
    },
    "1caa57c": {
        "5": [
            30
        ]
    },
    "77ed4b42": {
        "5": [
            31
        ]
    },
    "5fd6576b": {
        "5": [
            31
        ]
    },
    "484ee0d2": {
        "5": [
            26
        ]
    },
    "30f0e273": {
        "5": [
            27
        ]
    },
    "1e9b2c05": {
        "5": [
            32
        ]
    },
    "1411e0ce": {
        "5": [
            33
        ]
    },
    "51cc7784": {
        "5": [
            5
        ]
    },
    "7e5c0a40": {
        "5": [
            34
        ]
    },
    "40ffed18": {
        "5": [
            31
        ]
    },
    "2624d0d5": {
        "0": [
            485
        ]
    },
    "7f28fc39": {
        "0": [
            569
        ]
    },
    "53287af3": {
        "0": [
            488
        ]
    },
    "1a792b62": {
        "0": [
            403
        ]
    },
    "5ba04b6f": {
        "0": [
            387
        ]
    },
    "28af4f7a": {
        "0": [
            453
        ]
    },
    "244b4560": {
        "0": [
            404
        ]
    },
    "54d54800": {
        "0": [
            426
        ]
    },
    "6c705ed9": {
        "1": [
            20
        ]
    },
    "6448d285": {
        "1": [
            30
        ]
    },
    "6b8a0d18": {
        "1": [
            71
        ]
    },
    "22921d54": {
        "1": [
            6
        ]
    },
    "56b84538": {
        "1": [
            34
        ]
    },
    "db172ba": {
        "1": [
            81
        ]
    },
    "1b1c54be": {
        "1": [
            316
        ]
    },
    "4fd1fe02": {
        "1": [
            2
        ]
    },
    "2f4b0a26": {
        "0": [
            545
        ]
    },
    "4ab232d": {
        "0": [
            545
        ]
    },
    "4f6340c1": {
        "0": [
            545
        ]
    },
    "4a08909b": {
        "0": [
            454
        ]
    },
    "42b910bc": {
        "0": [
            545
        ]
    },
    "7f9b9165": {
        "0": [
            545
        ]
    },
    "24df9f73": {
        "0": [
            56
        ]
    },
    "45908b9f": {
        "5": [
            13
        ]
    },
    "290cce07": {
        "0": [
            356
        ]
    },
    "40b84e79": {
        "0": [
            356
        ]
    },
    "6d785826": {
        "0": [
            356
        ]
    },
    "5cb97baf": {
        "0": [
            420
        ]
    },
    "671d97ed": {
        "0": [
            420
        ]
    },
    "72c59687": {
        "0": [
            356
        ]
    },
    "5e98f831": {
        "0": [
            395
        ]
    },
    "7ef42f41": {
        "0": [
            395
        ]
    },
    "573614fa": {
        "0": [
            332
        ]
    },
    "76e1c425": {
        "0": [
            356
        ]
    },
    "3712edae": {
        "0": [
            356
        ]
    },
    "6501c8a6": {
        "0": [
            318
        ]
    },
    "301327b0": {
        "0": [
            395
        ]
    },
    "5f807a40": {
        "0": [
            356
        ]
    },
    "37f5bf6d": {
        "0": [
            356
        ]
    },
    "1ec9b293": {
        "0": [
            395
        ]
    },
    "5123edb5": {
        "0": [
            356
        ]
    },
    "4da0c63a": {
        "0": [
            580
        ]
    },
    "1f213b42": {
        "0": [
            356
        ]
    },
    "af10282": {
        "0": [
            488
        ]
    },
    "4f0e2a35": {
        "0": [
            356
        ]
    },
    "19c44dcb": {
        "0": [
            420
        ]
    },
    "4b46b42b": {
        "0": [
            488
        ]
    },
    "17eac4ca": {
        "0": [
            423
        ]
    },
    "1a2ae46b": {
        "0": [
            398
        ]
    },
    "137d6b89": {
        "0": [
            478
        ]
    },
    "515639ca": {
        "5": [
            13
        ]
    },
    "691aa86e": {
        "0": [
            387
        ]
    },
    "4d627cc6": {
        "0": [
            218
        ]
    },
    "6aa9b87d": {
        "0": [
            529
        ]
    },
    "5cab6702": {
        "0": [
            398
        ]
    },
    "35292aab": {
        "0": [
            387
        ]
    },
    "142cae87": {
        "0": [
            387
        ]
    },
    "22b39dbd": {
        "0": [
            320
        ]
    },
    "30fac0b1": {
        "1": [
            18
        ]
    },
    "2c76f011": {
        "0": [
            560
        ]
    },
    "2c76f013": {
        "0": [
            560
        ]
    },
    "4ea9d826": {
        "0": [
            408
        ]
    },
    "730e80bb": {
        "0": [
            387
        ]
    },
    "d7cad4e": {
        "0": [
            555
        ]
    },
    "19aa0c86": {
        "0": [
            352,
            355
        ]
    },
    "4c968639": {
        "3": [
            13
        ]
    },
    "6aad1e49": {
        "1": [
            18
        ]
    },
    "6963ae0a": {
        "1": [
            18
        ]
    },
    "1206a501": {
        "1": [
            18
        ]
    },
    "5a6bf1d1": {
        "1": [
            18
        ]
    },
    "3546ab1d": {
        "1": [
            18
        ]
    },
    "22236edb": {
        "1": [
            18
        ]
    },
    "2f505a2a": {
        "1": [
            18
        ]
    },
    "353ca0d5": {
        "1": [
            18
        ]
    },
    "58e5ed9": {
        "1": [
            18
        ]
    },
    "4dab668c": {
        "1": [
            18
        ]
    },
    "462ba7a0": {
        "0": [
            294
        ]
    },
    "2ecb5e41": {
        "0": [
            446
        ]
    },
    "49180d00": {
        "0": [
            569
        ]
    },
    "33a75d4": {
        "0": [
            467
        ]
    },
    "6e46ff7f": {
        "0": [
            300
        ]
    },
    "571dbb26": {
        "1": [
            116
        ]
    },
    "6ece12e5": {
        "0": [
            569
        ]
    },
    "74fabcc2": {
        "0": [
            569
        ]
    },
    "7c33dc1c": {
        "0": [
            569
        ]
    },
    "5923e7dc": {
        "0": [
            569
        ]
    },
    "5a068661": {
        "5": [
            29
        ]
    },
    "1f550b01": {
        "0": [
            540
        ]
    },
    "4ad86c4b": {
        "0": [
            403
        ]
    },
    "cafc9d6": {
        "0": [
            387
        ]
    },
    "7ad5aca4": {
        "0": [
            387
        ]
    },
    "afff8b2": {
        "1": [
            77
        ]
    },
    "181783a8": {
        "0": [
            405
        ]
    },
    "5f332956": {
        "0": [
            405
        ]
    },
    "1817d656": {
        "1": [
            18
        ]
    },
    "30a8c29e": {
        "0": [
            370
        ]
    },
    "38a863c9": {
        "0": [
            458
        ]
    },
    "14f52da8": {
        "0": [
            458
        ]
    },
    "ba8f2d9": {
        "0": [
            578
        ]
    },
    "6ed2ae22": {
        "0": [
            578
        ]
    },
    "647b6763": {
        "0": [
            458
        ]
    },
    "7b8d7bb2": {
        "0": [
            374
        ]
    },
    "6f7bdec8": {
        "0": [
            458
        ]
    },
    "1699cb73": {
        "0": [
            458
        ]
    },
    "4ec96a6e": {
        "0": [
            544
        ]
    },
    "308eb53c": {
        "0": [
            572
        ]
    },
    "6391e308": {
        "0": [
            572
        ]
    },
    "5bfc9216": {
        "0": [
            550
        ]
    },
    "6ef49e49": {
        "0": [
            544
        ]
    },
    "7ed40479": {
        "0": [
            544
        ]
    },
    "8bcb960": {
        "0": [
            544
        ]
    },
    "184e042d": {
        "0": [
            544
        ]
    },
    "4ec3a4e5": {
        "0": [
            544
        ]
    },
    "3b91c84e": {
        "0": [
            544
        ]
    },
    "120463b1": {
        "0": [
            544
        ]
    },
    "286f5d8e": {
        "0": [
            370
        ]
    },
    "53457eb0": {
        "0": [
            544
        ]
    },
    "6bc50689": {
        "0": [
            551
        ]
    },
    "63c48614": {
        "0": [
            463
        ]
    },
    "725af83b": {
        "0": [
            370
        ]
    },
    "6d880334": {
        "0": [
            370
        ]
    },
    "5f56c169": {
        "0": [
            458
        ]
    },
    "1cee4b5f": {
        "0": [
            458
        ]
    },
    "688f6f2d": {
        "0": [
            458
        ]
    },
    "7ef47d92": {
        "0": [
            544
        ]
    },
    "7ef47dd0": {
        "0": [
            544
        ]
    },
    "27f37f34": {
        "0": [
            544
        ]
    },
    "7abf641e": {
        "0": [
            527
        ]
    },
    "e3c05e5": {
        "0": [
            458
        ]
    },
    "7ae7be59": {
        "0": [
            458
        ]
    },
    "4f03725c": {
        "0": [
            374
        ]
    },
    "165dc09f": {
        "0": [
            578
        ]
    },
    "2a0f8da6": {
        "0": [
            578
        ]
    },
    "39cddfc4": {
        "0": [
            578
        ]
    },
    "4cb65b2a": {
        "0": [
            578
        ]
    },
    "6f93d99a": {
        "0": [
            578
        ]
    },
    "61e80b46": {
        "0": [
            578
        ]
    },
    "210ba16": {
        "0": [
            578
        ]
    },
    "56fc6163": {
        "0": [
            578
        ]
    },
    "7863846c": {
        "0": [
            578
        ]
    },
    "6a9173ea": {
        "0": [
            578
        ]
    },
    "295cf167": {
        "0": [
            578
        ]
    },
    "40104b76": {
        "0": [
            578
        ]
    },
    "52c39a11": {
        "0": [
            578
        ]
    },
    "2a8674ae": {
        "0": [
            578
        ]
    },
    "456d568e": {
        "0": [
            91
        ]
    },
    "2878fe9c": {
        "0": [
            458
        ]
    },
    "4edda591": {
        "0": [
            458
        ]
    },
    "eb41fb3": {
        "0": [
            458
        ]
    },
    "2197cb34": {
        "0": [
            458
        ]
    },
    "18b32774": {
        "0": [
            458
        ]
    },
    "315f651e": {
        "0": [
            578
        ]
    },
    "67ae608d": {
        "0": [
            527
        ]
    },
    "72cf5fdf": {
        "0": [
            353
        ]
    },
    "501a928": {
        "0": [
            572
        ]
    },
    "32098f80": {
        "0": [
            458
        ]
    },
    "1ea04e81": {
        "0": [
            458
        ]
    },
    "49e26001": {
        "0": [
            458
        ]
    },
    "72fa3446": {
        "0": [
            578
        ]
    },
    "304965a7": {
        "0": [
            458
        ]
    },
    "4d5baeac": {
        "0": [
            544
        ]
    },
    "3cce6c02": {
        "4": [
            6
        ]
    },
    "86821ec": {
        "4": [
            3
        ]
    },
    "80920a5": {
        "4": [
            10
        ]
    },
    "4a4494ae": {
        "3": [
            0
        ]
    },
    "26b3a494": {
        "3": [
            5
        ]
    },
    "5f8ebc0e": {
        "3": [
            20
        ]
    },
    "65c5475c": {
        "3": [
            23
        ]
    },
    "35957eb3": {
        "3": [
            24
        ]
    },
    "147ea9d8": {
        "3": [
            25
        ]
    },
    "1a733": {
        "3": [
            26
        ]
    },
    "4fc85d8e": {
        "3": [
            30
        ]
    },
    "3b534677": {
        "3": [
            30
        ]
    },
    "6058027f": {
        "3": [
            28
        ]
    },
    "4c26fc34": {
        "3": [
            17
        ]
    },
    "238b1468": {
        "3": [
            17
        ]
    },
    "65ec0cf": {
        "3": [
            17
        ]
    },
    "44be4fe5": {
        "3": [
            17
        ]
    },
    "276209b2": {
        "3": [
            17
        ]
    },
    "5a709a9e": {
        "1": [
            46
        ]
    },
    "387ea42a": {
        "1": [
            9
        ]
    },
    "6aa555ff": {
        "1": [
            25
        ]
    },
    "16e29333": {
        "1": [
            26
        ]
    },
    "3ebc9c9a": {
        "1": [
            54
        ]
    },
    "38d48be7": {
        "1": [
            57
        ]
    },
    "2238b28": {
        "1": [
            68
        ]
    },
    "3a96148f": {
        "1": [
            57
        ]
    },
    "5e74b2a0": {
        "1": [
            62
        ]
    },
    "3a953b7b": {
        "1": [
            67
        ]
    },
    "2c8177c2": {
        "1": [
            36
        ]
    },
    "1c12bb69": {
        "1": [
            69
        ]
    },
    "540908f9": {
        "1": [
            69
        ]
    },
    "77589af3": {
        "1": [
            65
        ]
    },
    "6a1f713e": {
        "1": [
            64
        ]
    },
    "3c81379c": {
        "2": [
            36
        ]
    },
    "60c3b5cd": {
        "1": [
            10
        ]
    },
    "113a2a07": {
        "1": [
            10
        ]
    },
    "56c81573": {
        "1": [
            70
        ]
    },
    "17fc34d5": {
        "1": [
            23
        ]
    },
    "2119c62c": {
        "1": [
            60
        ]
    },
    "711d740c": {
        "1": [
            96
        ]
    },
    "74f73dec": {
        "1": [
            97
        ]
    },
    "3587a8a9": {
        "1": [
            98
        ]
    },
    "38b80cd1": {
        "1": [
            98
        ]
    },
    "57fb82b4": {
        "1": [
            106
        ]
    },
    "1272f094": {
        "1": [
            106
        ]
    },
    "4a96e97e": {
        "1": [
            131
        ]
    },
    "aa66fd8": {
        "1": [
            4
        ]
    },
    "27b221b1": {
        "1": [
            136
        ]
    },
    "66d1b0f4": {
        "1": [
            134
        ]
    },
    "7effcd5e": {
        "1": [
            135
        ]
    },
    "76ec8f14": {
        "1": [
            35
        ]
    },
    "24f039a8": {
        "1": [
            138
        ]
    },
    "57a251f6": {
        "1": [
            35
        ]
    },
    "799de14d": {
        "1": [
            140
        ]
    },
    "32c4e7d8": {
        "1": [
            131
        ]
    },
    "4954bc28": {
        "1": [
            156
        ]
    },
    "28f5b9f4": {
        "3": [
            1
        ]
    },
    "4df6e8d": {
        "1": [
            157
        ]
    },
    "5c4f915d": {
        "1": [
            157
        ]
    },
    "25e02914": {
        "1": [
            158
        ]
    },
    "770a9985": {
        "1": [
            350
        ]
    },
    "1578b8e6": {
        "1": [
            160
        ]
    },
    "59fe64bf": {
        "1": [
            162
        ]
    },
    "d256fa0": {
        "1": [
            163
        ]
    },
    "19539e24": {
        "1": [
            161
        ]
    },
    "28420f2c": {
        "1": [
            168
        ]
    },
    "253b033d": {
        "1": [
            169
        ]
    },
    "7e7f8d16": {
        "1": [
            170
        ]
    },
    "57ea4ae3": {
        "1": [
            173
        ]
    },
    "5c50fe09": {
        "1": [
            184
        ]
    },
    "2de2cb1b": {
        "1": [
            193
        ]
    },
    "33dbdf02": {
        "1": [
            130
        ]
    },
    "77e8d094": {
        "1": [
            130
        ]
    },
    "55167ee1": {
        "1": [
            596
        ]
    },
    "3d692ea3": {
        "1": [
            195
        ]
    },
    "6d9d7883": {
        "1": [
            196
        ]
    },
    "a8d9c1c": {
        "1": [
            197
        ]
    },
    "5ad76344": {
        "1": [
            198
        ]
    },
    "746fc545": {
        "1": [
            199
        ]
    },
    "54768d38": {
        "1": [
            200
        ]
    },
    "2bae37a9": {
        "1": [
            201
        ]
    },
    "7a757a18": {
        "1": [
            202
        ]
    },
    "42a0e77": {
        "1": [
            203
        ]
    },
    "3ac4a95e": {
        "1": [
            204
        ]
    },
    "739d2cc0": {
        "1": [
            175
        ]
    },
    "76f87285": {
        "1": [
            206
        ]
    },
    "79ce7866": {
        "1": [
            207
        ]
    },
    "61701f07": {
        "1": [
            208
        ]
    },
    "16f19e77": {
        "1": [
            209
        ]
    },
    "3348b9": {
        "1": [
            210
        ]
    },
    "779567a1": {
        "1": [
            211
        ]
    },
    "5a7c4c3": {
        "1": [
            212
        ]
    },
    "54835fdd": {
        "1": [
            213
        ]
    },
    "316327bb": {
        "1": [
            214
        ]
    },
    "45fee51a": {
        "1": [
            216
        ]
    },
    "477bbb22": {
        "1": [
            218
        ]
    },
    "56afc97e": {
        "1": [
            256
        ]
    },
    "4c69b254": {
        "1": [
            83
        ]
    },
    "68fce97": {
        "1": [
            305
        ]
    },
    "d19f499": {
        "1": [
            92
        ]
    },
    "20cf3963": {
        "1": [
            306,
            307
        ]
    },
    "1a9a7598": {
        "1": [
            77
        ]
    },
    "59271c3f": {
        "1": [
            82
        ]
    },
    "4b1fc955": {
        "1": [
            116
        ]
    },
    "257bdbbd": {
        "1": [
            116
        ]
    },
    "686a8a39": {
        "1": [
            328
        ]
    },
    "2e851375": {
        "1": [
            328
        ]
    },
    "399174da": {
        "1": [
            596
        ]
    },
    "32c7d614": {
        "1": [
            329
        ]
    },
    "47d4fd11": {
        "1": [
            330
        ]
    },
    "1615ccb": {
        "1": [
            596
        ]
    },
    "6e09c04d": {
        "0": [
            404
        ]
    },
    "42526e59": {
        "0": [
            426
        ]
    },
    "1aba3bce": {
        "0": [
            477
        ]
    },
    "4cd08990": {
        "0": [
            401
        ]
    },
    "71bb82cd": {
        "0": [
            404
        ]
    },
    "7827f064": {
        "0": [
            480
        ]
    },
    "4a44e4b7": {
        "1": [
            81
        ]
    },
    "2583b0c1": {
        "0": [
            404
        ]
    },
    "389736b6": {
        "0": [
            404
        ]
    },
    "7a8c5abf": {
        "0": [
            120
        ]
    },
    "6b1b8276": {
        "1": [
            20
        ]
    },
    "5eb94628": {
        "0": [
            483
        ]
    },
    "6f6e514b": {
        "1": [
            241
        ]
    },
    "76bc090d": {
        "0": [
            427
        ]
    },
    "40b8a56f": {
        "1": [
            46
        ]
    },
    "58af9a3e": {
        "3": [
            16
        ]
    },
    "5dbdf2fd": {
        "0": [
            286
        ],
        "1": [
            220
        ]
    },
    "36539c41": {
        "1": [
            20
        ]
    },
    "68859c90": {
        "1": [
            19
        ]
    },
    "5d903ef8": {
        "0": [
            568
        ]
    },
    "150e18a4": {
        "0": [
            568
        ]
    },
    "77dd0786": {
        "0": [
            568
        ]
    },
    "5d8fca99": {
        "0": [
            568
        ]
    },
    "1fd8229d": {
        "0": [
            568
        ]
    },
    "77dd0787": {
        "0": [
            568
        ]
    },
    "5d8f563a": {
        "0": [
            568
        ]
    },
    "54be5dde": {
        "0": [
            568
        ]
    },
    "77dd0788": {
        "0": [
            568
        ]
    },
    "544d6ede": {
        "0": [
            568
        ]
    },
    "5d8ee1db": {
        "0": [
            568
        ]
    },
    "765b66e1": {
        "0": [
            568
        ]
    },
    "77dd0789": {
        "0": [
            568
        ]
    },
    "543f575d": {
        "0": [
            568
        ]
    },
    "5d8e6d7c": {
        "0": [
            568
        ]
    },
    "41752ba0": {
        "0": [
            568
        ]
    },
    "777abe73": {
        "0": [
            568
        ]
    },
    "5989c6fc": {
        "0": [
            568
        ]
    },
    "5d1105b3": {
        "0": [
            568
        ]
    },
    "5d1f1d34": {
        "0": [
            568
        ]
    },
    "7b9975f": {
        "0": [
            568
        ]
    },
    "96e6ffe": {
        "0": [
            568
        ]
    },
    "551ab4da": {
        "1": [
            245
        ]
    },
    "74eaab79": {
        "1": [
            245
        ]
    },
    "7b036166": {
        "1": [
            245
        ]
    },
    "52502d8c": {
        "1": [
            245
        ]
    },
    "5be760a9": {
        "1": [
            245
        ]
    },
    "7dd3bc59": {
        "1": [
            245
        ]
    },
    "389a33d5": {
        "1": [
            245
        ]
    },
    "62b375bf": {
        "1": [
            245
        ]
    },
    "c642f70": {
        "1": [
            585
        ]
    },
    "11f7ac6d": {
        "1": [
            245
        ]
    },
    "26e723be": {
        "1": [
            245
        ]
    },
    "1e43864e": {
        "1": [
            245
        ]
    },
    "662378ec": {
        "1": [
            81
        ]
    },
    "77dd078a": {
        "0": [
            568
        ]
    },
    "54313fdc": {
        "0": [
            568
        ]
    },
    "5d8df91d": {
        "0": [
            568
        ]
    },
    "c8ef05f": {
        "0": [
            568
        ]
    },
    "cc5a337": {
        "0": [
            346
        ]
    },
    "48b51487": {
        "0": [
            346
        ]
    },
    "7f4c97a": {
        "0": [
            346
        ]
    },
    "4311bbaa": {
        "0": [
            346
        ]
    },
    "16c9ae97": {
        "0": [
            346
        ]
    },
    "357f7ce7": {
        "0": [
            346
        ]
    },
    "7505cb5b": {
        "0": [
            346
        ]
    },
    "47e29567": {
        "0": [
            346
        ]
    },
    "6bd43f1b": {
        "0": [
            346
        ]
    },
    "79667dde": {
        "0": [
            346
        ]
    },
    "8c7489a": {
        "0": [
            346
        ]
    },
    "62a2b2db": {
        "0": [
            346
        ]
    },
    "6a43a6": {
        "0": [
            346
        ]
    },
    "5971269b": {
        "0": [
            346
        ]
    },
    "d27fb1d": {
        "0": [
            346
        ]
    },
    "3f213061": {
        "0": [
            346
        ]
    },
    "1aba39e0": {
        "0": [
            346
        ]
    },
    "503f9a5b": {
        "0": [
            346
        ]
    },
    "55e4fb64": {
        "0": [
            346
        ]
    },
    "3f66edd": {
        "0": [
            346
        ]
    },
    "5dd1d91e": {
        "0": [
            346
        ]
    },
    "6d87787e": {
        "0": [
            346
        ]
    },
    "7ca72292": {
        "0": [
            403
        ]
    },
    "134a596f": {
        "0": [
            273
        ]
    },
    "3bcc6209": {
        "1": [
            158
        ]
    },
    "78f1bc6c": {
        "1": [
            81
        ]
    },
    "49607d36": {
        "0": [
            346
        ]
    },
    "3b6633c8": {
        "0": [
            488
        ]
    },
    "2e29a703": {
        "1": [
            30
        ]
    },
    "791f97c": {
        "0": [
            431
        ]
    },
    "29831f8c": {
        "0": [
            343
        ]
    },
    "33355b80": {
        "0": [
            560
        ]
    },
    "7d1f6e5a": {
        "0": [
            560
        ]
    },
    "1bd2201d": {
        "0": [
            560
        ]
    },
    "742fc25": {
        "0": [
            483
        ]
    },
    "238a8468": {
        "0": [
            483
        ]
    },
    "6042228f": {
        "0": [
            483
        ]
    },
    "21b98a06": {
        "0": [
            426
        ]
    },
    "6c2c9717": {
        "1": [
            30
        ]
    },
    "5a6ef550": {
        "3": [
            23
        ]
    },
    "725e0a14": {
        "0": [
            560
        ]
    },
    "34d3cff4": {
        "0": [
            560
        ]
    },
    "3cb9666e": {
        "0": [
            374
        ]
    },
    "360e1d9e": {
        "0": [
            560
        ]
    },
    "277a506f": {
        "0": [
            374
        ]
    },
    "b2df8b3": {
        "0": [
            346
        ]
    },
    "20a2a735": {
        "0": [
            374
        ]
    },
    "507ec28": {
        "0": [
            374
        ]
    },
    "97f1bf5": {
        "0": [
            346
        ]
    },
    "3898116a": {
        "0": [
            346
        ]
    },
    "7e814cb0": {
        "0": [
            560
        ]
    },
    "4b22d889": {
        "0": [
            560
        ]
    },
    "4024115f": {
        "1": [
            81
        ]
    },
    "75e5aede": {
        "0": [
            560
        ]
    },
    "4d161859": {
        "0": [
            346
        ]
    },
    "26b73d45": {
        "1": [
            77
        ]
    },
    "742a6729": {
        "0": [
            387
        ]
    },
    "3763ba13": {
        "1": [
            20
        ]
    },
    "19030d3e": {
        "0": [
            427
        ]
    },
    "6d83beb": {
        "0": [
            255
        ]
    },
    "245bed5a": {
        "0": [
            346
        ]
    },
    "511421a7": {
        "0": [
            346
        ]
    },
    "4859d732": {
        "0": [
            568
        ]
    },
    "2119d1c3": {
        "4": [
            22
        ]
    },
    "2119d7b7": {
        "4": [
            23
        ]
    },
    "532a2293": {
        "4": [
            24
        ]
    },
    "513ee7e2": {
        "4": [
            25
        ]
    },
    "4187f9b2": {
        "4": [
            25
        ]
    },
    "135d1b2f": {
        "4": [
            26
        ]
    },
    "688e4686": {
        "2": [
            26
        ]
    },
    "36221afb": {
        "2": [
            65
        ]
    },
    "2db5ca0f": {
        "2": [
            90
        ]
    },
    "2efe02": {
        "2": [
            91
        ]
    },
    "2f24a2": {
        "2": [
            92
        ]
    },
    "3292e5": {
        "2": [
            93
        ]
    },
    "48d31db1": {
        "2": [
            94
        ]
    },
    "f9fbd5d": {
        "2": [
            94
        ]
    },
    "72746f67": {
        "2": [
            95
        ]
    },
    "4e84e039": {
        "2": [
            96
        ]
    },
    "7f78125": {
        "2": [
            97
        ]
    },
    "1252be8c": {
        "2": [
            98
        ]
    },
    "126ea89a": {
        "1": [
            455
        ]
    },
    "9e8cdfc": {
        "2": [
            99
        ]
    },
    "251ac6b7": {
        "2": [
            101
        ]
    },
    "414fdb4d": {
        "2": [
            102
        ]
    },
    "a30fd6c": {
        "2": [
            103
        ]
    },
    "3595da": {
        "2": [
            104
        ]
    },
    "7a30cc48": {
        "2": [
            105
        ]
    },
    "321bda3c": {
        "2": [
            106
        ]
    },
    "18b6f": {
        "2": [
            108
        ]
    },
    "5ab07188": {
        "3": [
            19
        ]
    },
    "69d936c4": {
        "3": [
            19
        ]
    },
    "60c8160": {
        "3": [
            31
        ]
    },
    "7d40b1d8": {
        "3": [
            31
        ]
    },
    "6fed6d4d": {
        "3": [
            32
        ]
    },
    "6fd7e22d": {
        "3": [
            33
        ]
    },
    "6464d14c": {
        "3": [
            34
        ]
    },
    "402776de": {
        "3": [
            34
        ]
    },
    "8b0e656": {
        "3": [
            34
        ]
    },
    "324ca03d": {
        "3": [
            35
        ]
    },
    "5238cf58": {
        "3": [
            35
        ]
    },
    "544c1807": {
        "3": [
            36
        ]
    },
    "b380dcd": {
        "3": [
            37
        ]
    },
    "5602304e": {
        "1": [
            55
        ]
    },
    "6ebd7feb": {
        "1": [
            67
        ]
    },
    "334b81a3": {
        "1": [
            67
        ]
    },
    "74b84bbe": {
        "1": [
            89
        ]
    },
    "2fc6d986": {
        "1": [
            89
        ]
    },
    "57df05e": {
        "1": [
            156
        ]
    },
    "3f7a17f4": {
        "1": [
            156
        ]
    },
    "85ebd7c": {
        "3": [
            1
        ]
    },
    "5b904545": {
        "3": [
            1
        ]
    },
    "3d7a7b1c": {
        "3": [
            1
        ]
    },
    "2f6a25": {
        "3": [
            1
        ]
    },
    "3b9416fd": {
        "1": [
            158
        ]
    },
    "55311a16": {
        "1": [
            158
        ]
    },
    "5c6c7f5b": {
        "1": [
            161
        ]
    },
    "139992bd": {
        "1": [
            161
        ]
    },
    "7ebce5bb": {
        "1": [
            506
        ]
    },
    "40b22b64": {
        "1": [
            320
        ]
    },
    "13a223a9": {
        "1": [
            320
        ]
    },
    "3115f55f": {
        "1": [
            321
        ]
    },
    "2df013c0": {
        "1": [
            321
        ]
    },
    "64752e69": {
        "1": [
            321
        ]
    },
    "2eb2d78f": {
        "1": [
            333
        ]
    },
    "338b476d": {
        "1": [
            334
        ]
    },
    "2310f56f": {
        "1": [
            334
        ]
    },
    "79731db5": {
        "1": [
            334
        ]
    },
    "7330ef99": {
        "1": [
            334
        ]
    },
    "7aaeed40": {
        "1": [
            335
        ]
    },
    "29ad8c30": {
        "1": [
            336
        ]
    },
    "66c25a6d": {
        "1": [
            336
        ]
    },
    "2db068": {
        "1": [
            336
        ]
    },
    "282e8cde": {
        "1": [
            337
        ]
    },
    "6437d696": {
        "1": [
            338
        ]
    },
    "3d30bc80": {
        "1": [
            338
        ]
    },
    "55b1b090": {
        "1": [
            339
        ]
    },
    "76db5add": {
        "1": [
            341
        ]
    },
    "43365bda": {
        "1": [
            342
        ]
    },
    "1cb9cc62": {
        "1": [
            343
        ]
    },
    "14316f92": {
        "1": [
            343
        ]
    },
    "7e4d5217": {
        "1": [
            343
        ]
    },
    "593c0043": {
        "1": [
            343
        ]
    },
    "fd2ff34": {
        "1": [
            344
        ]
    },
    "62fa84eb": {
        "1": [
            344
        ]
    },
    "3415fb47": {
        "1": [
            345
        ]
    },
    "554adb7": {
        "1": [
            346
        ]
    },
    "539d5bff": {
        "1": [
            347
        ]
    },
    "152e2a49": {
        "1": [
            348
        ]
    },
    "3157abec": {
        "1": [
            349
        ]
    },
    "2e7d7894": {
        "1": [
            349
        ]
    },
    "aabcf56": {
        "1": [
            349
        ]
    },
    "2dd41db0": {
        "1": [
            349
        ]
    },
    "5d712529": {
        "1": [
            350
        ]
    },
    "75dc80a7": {
        "1": [
            350
        ]
    },
    "6dd54b4b": {
        "1": [
            350
        ]
    },
    "75501b37": {
        "1": [
            350
        ]
    },
    "484a03d0": {
        "1": [
            350
        ]
    },
    "30cce032": {
        "1": [
            350
        ]
    },
    "3f9ca174": {
        "1": [
            350
        ]
    },
    "573726d9": {
        "1": [
            350
        ]
    },
    "1e872358": {
        "1": [
            350
        ]
    },
    "1ddecdcd": {
        "1": [
            350
        ]
    },
    "e542ce1": {
        "1": [
            350
        ]
    },
    "7edb398e": {
        "1": [
            351
        ]
    },
    "20e4d291": {
        "1": [
            352
        ]
    },
    "4e0cb70e": {
        "1": [
            353
        ]
    },
    "43eaedde": {
        "1": [
            354
        ]
    },
    "6662c0f0": {
        "1": [
            355
        ]
    },
    "58e7a8d": {
        "1": [
            356
        ]
    },
    "63ec6dfc": {
        "1": [
            357
        ]
    },
    "688811fc": {
        "1": [
            358
        ]
    },
    "7dbe943": {
        "1": [
            359
        ]
    },
    "647a5dcd": {
        "1": [
            360
        ]
    },
    "10dddfad": {
        "1": [
            361
        ]
    },
    "77a5589f": {
        "1": [
            362
        ]
    },
    "2e3b5f": {
        "1": [
            363
        ]
    },
    "2e3ea3": {
        "1": [
            364
        ]
    },
    "400cf2ee": {
        "1": [
            365
        ]
    },
    "2d1fbd17": {
        "1": [
            367
        ]
    },
    "5ccdd110": {
        "1": [
            368
        ]
    },
    "30a1c14a": {
        "1": [
            369
        ]
    },
    "314d3f40": {
        "1": [
            370
        ]
    },
    "50257aea": {
        "1": [
            370
        ]
    },
    "5e8fd0e2": {
        "1": [
            370
        ]
    },
    "20eac168": {
        "1": [
            371
        ]
    },
    "573982d0": {
        "1": [
            371
        ]
    },
    "43cf7ff0": {
        "1": [
            372
        ]
    },
    "333e1131": {
        "1": [
            372
        ]
    },
    "216e3080": {
        "1": [
            373
        ]
    },
    "2cb5e038": {
        "1": [
            373
        ]
    },
    "1cfe302b": {
        "1": [
            374
        ]
    },
    "48510e16": {
        "1": [
            60
        ]
    },
    "10c9205d": {
        "1": [
            376
        ]
    },
    "5f779608": {
        "1": [
            376
        ]
    },
    "2f73be0b": {
        "1": [
            376
        ]
    },
    "60a602cd": {
        "1": [
            377
        ]
    },
    "9eb5456": {
        "1": [
            378
        ]
    },
    "2eb302": {
        "1": [
            379
        ]
    },
    "2ea7baca": {
        "1": [
            380
        ]
    },
    "4f73b9cd": {
        "1": [
            381
        ]
    },
    "6f30fb8f": {
        "1": [
            382
        ]
    },
    "1389495e": {
        "1": [
            383
        ]
    },
    "5772fd88": {
        "1": [
            383
        ]
    },
    "692e948a": {
        "1": [
            384
        ]
    },
    "43a22cc1": {
        "1": [
            384
        ]
    },
    "6b6fa4a3": {
        "1": [
            386
        ]
    },
    "299588a7": {
        "1": [
            387
        ]
    },
    "4dd8907a": {
        "1": [
            388
        ]
    },
    "5f2ed70a": {
        "1": [
            389
        ]
    },
    "26a10c4b": {
        "1": [
            390
        ]
    },
    "55fa2dd6": {
        "1": [
            391
        ]
    },
    "21cd165f": {
        "1": [
            392
        ]
    },
    "2d488d0b": {
        "1": [
            393
        ]
    },
    "2e7ff86d": {
        "1": [
            393
        ]
    },
    "56c51ab": {
        "1": [
            393
        ]
    },
    "81ed582": {
        "1": [
            394
        ]
    },
    "16e17869": {
        "1": [
            395
        ]
    },
    "305cfd6a": {
        "1": [
            395
        ]
    },
    "498ee86c": {
        "1": [
            395
        ]
    },
    "2456d28": {
        "1": [
            396
        ]
    },
    "7424bb73": {
        "1": [
            397
        ]
    },
    "5a5a9dc2": {
        "1": [
            398
        ]
    },
    "3d9a7c8c": {
        "1": [
            399
        ]
    },
    "6e628b56": {
        "1": [
            399
        ]
    },
    "4dd15273": {
        "1": [
            399
        ]
    },
    "663ed888": {
        "1": [
            400
        ]
    },
    "67895d44": {
        "1": [
            400
        ]
    },
    "33131ed2": {
        "1": [
            400
        ]
    },
    "5412407a": {
        "0": [
            488
        ],
        "1": [
            401
        ]
    },
    "5cd6f5cc": {
        "1": [
            402
        ]
    },
    "1bc50478": {
        "1": [
            403
        ]
    },
    "30329e32": {
        "1": [
            404
        ]
    },
    "6e8ab77a": {
        "1": [
            405
        ]
    },
    "5e8f046": {
        "1": [
            406
        ]
    },
    "1f4a11ed": {
        "1": [
            406
        ]
    },
    "4e0d44e": {
        "1": [
            406
        ]
    },
    "50500cf2": {
        "1": [
            407
        ]
    },
    "5a439f78": {
        "1": [
            408
        ]
    },
    "5a8dc0ee": {
        "1": [
            409
        ]
    },
    "42cb28bc": {
        "1": [
            410
        ]
    },
    "63322dfc": {
        "1": [
            410
        ]
    },
    "7a1e4f62": {
        "1": [
            411
        ]
    },
    "743da6c": {
        "1": [
            411
        ]
    },
    "65e4265a": {
        "1": [
            411
        ]
    },
    "4e003309": {
        "1": [
            412
        ]
    },
    "3ec7240a": {
        "1": [
            413
        ]
    },
    "5fef64b": {
        "1": [
            413
        ]
    },
    "3c8f0b9d": {
        "1": [
            413
        ]
    },
    "6d0edfcb": {
        "1": [
            414
        ]
    },
    "27fcda74": {
        "1": [
            415
        ]
    },
    "4fcd6b9c": {
        "1": [
            415
        ]
    },
    "16faaa70": {
        "1": [
            416
        ]
    },
    "7cce0d7": {
        "1": [
            417
        ]
    },
    "2f5c4fd0": {
        "1": [
            418
        ]
    },
    "40453fb": {
        "1": [
            418
        ]
    },
    "5d98f233": {
        "1": [
            419
        ]
    },
    "3e79d53d": {
        "1": [
            421
        ]
    },
    "1440c5fa": {
        "1": [
            421
        ]
    },
    "1a1ad": {
        "1": [
            422
        ]
    },
    "344807cd": {
        "1": [
            422
        ]
    },
    "6810952b": {
        "1": [
            422
        ]
    },
    "549d22ea": {
        "1": [
            423
        ]
    },
    "4bdb777": {
        "1": [
            423
        ]
    },
    "5d205faf": {
        "1": [
            424
        ]
    },
    "77e88b02": {
        "1": [
            424
        ]
    },
    "43dc3733": {
        "1": [
            424
        ]
    },
    "6236a1b": {
        "1": [
            425
        ]
    },
    "e2debdb": {
        "1": [
            425
        ]
    },
    "3b52d432": {
        "1": [
            426
        ]
    },
    "46cbe1aa": {
        "1": [
            426
        ]
    },
    "78faddf4": {
        "1": [
            427
        ]
    },
    "3fcca261": {
        "1": [
            427
        ]
    },
    "564c9163": {
        "1": [
            427
        ]
    },
    "5213fb79": {
        "1": [
            427
        ]
    },
    "300adfb9": {
        "1": [
            428
        ]
    },
    "1ae01dda": {
        "1": [
            429
        ]
    },
    "3a7f4b7b": {
        "1": [
            430
        ]
    },
    "1a6b80c2": {
        "1": [
            431
        ]
    },
    "357c3f20": {
        "1": [
            431
        ]
    },
    "68e44d5f": {
        "1": [
            432
        ]
    },
    "7d1d3cb0": {
        "1": [
            433
        ]
    },
    "49c012d4": {
        "1": [
            433
        ]
    },
    "44333e65": {
        "1": [
            434
        ]
    },
    "b8de416": {
        "1": [
            434
        ]
    },
    "12c97e14": {
        "1": [
            434
        ]
    },
    "7a176b51": {
        "1": [
            434
        ]
    },
    "3aa56c08": {
        "1": [
            434
        ]
    },
    "5b1b1d4e": {
        "1": [
            434
        ]
    },
    "3e83d060": {
        "1": [
            435
        ]
    },
    "505f633a": {
        "1": [
            436
        ]
    },
    "6d5a684f": {
        "1": [
            437
        ]
    },
    "77958aaf": {
        "1": [
            437
        ]
    },
    "5db6df75": {
        "1": [
            437
        ]
    },
    "2b345f4b": {
        "1": [
            438
        ]
    },
    "3b91e0cb": {
        "1": [
            438
        ]
    },
    "41f42c73": {
        "1": [
            438
        ]
    },
    "c7a0e13": {
        "1": [
            439
        ]
    },
    "21c9486d": {
        "1": [
            440
        ]
    },
    "296739b5": {
        "1": [
            441
        ]
    },
    "6f95d90c": {
        "1": [
            442
        ]
    },
    "773c3975": {
        "1": [
            442
        ]
    },
    "706c0e13": {
        "1": [
            442
        ]
    },
    "788abf02": {
        "1": [
            442
        ]
    },
    "18396b6f": {
        "1": [
            442
        ]
    },
    "1982156b": {
        "1": [
            442
        ]
    },
    "280c2023": {
        "1": [
            443
        ]
    },
    "33d074b": {
        "1": [
            444
        ]
    },
    "1dd72f23": {
        "1": [
            444
        ]
    },
    "54e5110b": {
        "1": [
            445
        ]
    },
    "223e896b": {
        "1": [
            445
        ]
    },
    "49a002f5": {
        "1": [
            445
        ]
    },
    "40fedf91": {
        "1": [
            447
        ]
    },
    "415950c9": {
        "1": [
            448
        ]
    },
    "377c91a3": {
        "1": [
            448
        ]
    },
    "4a2b6898": {
        "1": [
            449
        ]
    },
    "7da35715": {
        "1": [
            449
        ]
    },
    "17005db0": {
        "1": [
            449
        ]
    },
    "6dc5d747": {
        "1": [
            450
        ]
    },
    "5ab77cb9": {
        "1": [
            451
        ]
    },
    "58c96d0": {
        "1": [
            451
        ]
    },
    "450e534e": {
        "1": [
            451
        ]
    },
    "1babb969": {
        "1": [
            451
        ]
    },
    "39662fbe": {
        "1": [
            452
        ]
    },
    "6fe96cc2": {
        "1": [
            452
        ]
    },
    "2f314737": {
        "1": [
            453
        ]
    },
    "182a2841": {
        "1": [
            453
        ]
    },
    "79370ce4": {
        "1": [
            162
        ]
    },
    "3eb48304": {
        "1": [
            162
        ]
    },
    "52ea46ed": {
        "1": [
            455
        ]
    },
    "4b091446": {
        "1": [
            457
        ]
    },
    "7904a41b": {
        "1": [
            458
        ]
    },
    "24b40dc5": {
        "1": [
            458
        ]
    },
    "65e42a6": {
        "1": [
            459
        ]
    },
    "8f382d5": {
        "1": [
            460
        ]
    },
    "4a8a572c": {
        "1": [
            461
        ]
    },
    "456ae5c3": {
        "1": [
            462
        ]
    },
    "79ab99d6": {
        "1": [
            463
        ]
    },
    "124b133b": {
        "1": [
            464
        ]
    },
    "7e29f8eb": {
        "1": [
            465
        ]
    },
    "1823bc91": {
        "1": [
            466
        ]
    },
    "360d2aee": {
        "1": [
            467
        ]
    },
    "57c4da62": {
        "1": [
            467
        ]
    },
    "2a459d73": {
        "1": [
            467
        ]
    },
    "167b3f28": {
        "1": [
            467
        ]
    },
    "59c705bd": {
        "1": [
            467
        ]
    },
    "13db0fe8": {
        "1": [
            468
        ]
    },
    "5e200450": {
        "1": [
            468
        ]
    },
    "9e9dfec": {
        "1": [
            106
        ]
    },
    "6abce7f4": {
        "1": [
            469
        ]
    },
    "3d97d912": {
        "1": [
            471
        ]
    },
    "3afef9c2": {
        "1": [
            470
        ]
    },
    "460acab0": {
        "1": [
            472
        ]
    },
    "7acf5c68": {
        "1": [
            471
        ]
    },
    "1de2061": {
        "1": [
            470
        ]
    },
    "6bfc7a64": {
        "1": [
            470
        ]
    },
    "39c9b191": {
        "1": [
            473
        ]
    },
    "5eb07c9a": {
        "1": [
            473
        ]
    },
    "6f0a7d7a": {
        "1": [
            474
        ]
    },
    "6a46975": {
        "1": [
            475
        ]
    },
    "1c5f3730": {
        "1": [
            476
        ]
    },
    "f1816c": {
        "1": [
            476
        ]
    },
    "21326b95": {
        "1": [
            477
        ]
    },
    "7a75c126": {
        "1": [
            477
        ]
    },
    "677f069d": {
        "1": [
            477
        ]
    },
    "6ff9829": {
        "1": [
            478
        ]
    },
    "2a5b44b1": {
        "1": [
            478
        ]
    },
    "4760cde8": {
        "1": [
            479
        ]
    },
    "7e6c45c4": {
        "1": [
            480
        ]
    },
    "30fd2368": {
        "1": [
            481
        ]
    },
    "1e987e34": {
        "1": [
            481
        ]
    },
    "7325606a": {
        "1": [
            482
        ]
    },
    "3e7b8e3e": {
        "1": [
            483
        ]
    },
    "3572d535": {
        "1": [
            484
        ]
    },
    "324f6f2f": {
        "1": [
            484
        ]
    },
    "3f7772f4": {
        "1": [
            485
        ]
    },
    "788530d2": {
        "1": [
            486
        ]
    },
    "53f9f9ca": {
        "1": [
            486
        ]
    },
    "1b28eb8f": {
        "1": [
            487
        ]
    },
    "57ce3c0f": {
        "1": [
            488
        ]
    },
    "30126c3": {
        "1": [
            489
        ]
    },
    "746cae26": {
        "1": [
            489
        ]
    },
    "335d1940": {
        "1": [
            489
        ]
    },
    "55bc8632": {
        "1": [
            490
        ]
    },
    "3f4a4254": {
        "1": [
            491
        ]
    },
    "e1eed01": {
        "1": [
            492
        ]
    },
    "3397f9ac": {
        "1": [
            493
        ]
    },
    "6d2ff67b": {
        "1": [
            494
        ]
    },
    "6afc31f1": {
        "1": [
            495
        ]
    },
    "616c91f5": {
        "1": [
            498
        ]
    },
    "6c4962d2": {
        "1": [
            496
        ]
    },
    "6af9f83f": {
        "1": [
            497
        ]
    },
    "4360969d": {
        "1": [
            498
        ]
    },
    "333a7527": {
        "1": [
            496
        ]
    },
    "645fb27f": {
        "1": [
            499
        ]
    },
    "303fd6a3": {
        "1": [
            499
        ]
    },
    "3e5908f0": {
        "1": [
            500
        ]
    },
    "46050e30": {
        "1": [
            501
        ]
    },
    "73c86a4f": {
        "1": [
            501
        ]
    },
    "7b80c8fa": {
        "1": [
            501
        ]
    },
    "c6131e8": {
        "1": [
            502
        ]
    },
    "796083bf": {
        "1": [
            502
        ]
    },
    "5650cdc3": {
        "1": [
            503
        ]
    },
    "1e95fd5f": {
        "1": [
            503
        ]
    },
    "393a32": {
        "1": [
            504
        ]
    },
    "609f80c9": {
        "2": [
            110
        ]
    },
    "7b9de37c": {
        "1": [
            505
        ]
    },
    "1b59a394": {
        "1": [
            507
        ]
    },
    "1980d": {
        "1": [
            508
        ]
    },
    "e361074": {
        "1": [
            509
        ]
    },
    "78168a59": {
        "1": [
            509
        ]
    },
    "6046971c": {
        "1": [
            509
        ]
    },
    "228ffedd": {
        "1": [
            510
        ]
    },
    "24c648d0": {
        "1": [
            511
        ]
    },
    "4c5e1a3e": {
        "2": [
            116
        ]
    },
    "12a800": {
        "2": [
            117
        ]
    },
    "6e634ce4": {
        "2": [
            118
        ]
    },
    "6620eaa5": {
        "1": [
            53
        ]
    },
    "77d8596a": {
        "1": [
            53
        ]
    },
    "3efba918": {
        "1": [
            381
        ]
    },
    "6f2841a": {
        "1": [
            437
        ]
    },
    "733d9184": {
        "1": [
            515
        ]
    },
    "68c010b6": {
        "1": [
            516
        ]
    },
    "559720f4": {
        "1": [
            517
        ]
    },
    "4a8ca8fa": {
        "1": [
            518
        ]
    },
    "719c4c9b": {
        "1": [
            519
        ]
    },
    "5d25343": {
        "1": [
            520
        ]
    },
    "4415290f": {
        "1": [
            556
        ]
    },
    "5f3f60bc": {
        "1": [
            556
        ]
    },
    "4bcfdcfb": {
        "1": [
            556
        ]
    },
    "7342d6c9": {
        "1": [
            556
        ]
    },
    "4d7e5fab": {
        "1": [
            20
        ]
    },
    "3dc0c565": {
        "1": [
            267
        ]
    },
    "20ae2f9c": {
        "0": [
            470
        ]
    },
    "6f1966ec": {
        "0": [
            568
        ]
    },
    "7df9d60c": {
        "1": [
            33
        ]
    },
    "1fb24d8b": {
        "2": [
            111
        ]
    },
    "40313a0a": {
        "0": [
            480
        ]
    },
    "f0821f8": {
        "0": [
            488
        ]
    },
    "56fd81c8": {
        "0": [
            480
        ]
    },
    "688aef6": {
        "3": [
            16
        ]
    },
    "3408be22": {
        "0": [
            527
        ]
    },
    "34082bbb": {
        "0": [
            527
        ]
    },
    "4228e24b": {
        "0": [
            560
        ]
    },
    "3403b2ca": {
        "0": [
            527
        ]
    },
    "34025d2f": {
        "0": [
            527
        ]
    },
    "2fd061c1": {
        "0": [
            458
        ]
    },
    "a50d6e6": {
        "0": [
            560
        ]
    },
    "457a4cb7": {
        "0": [
            346
        ]
    },
    "26b76abb": {
        "0": [
            480
        ]
    },
    "142487b6": {
        "0": [
            560
        ]
    },
    "7199b99b": {
        "0": [
            483
        ]
    },
    "7faac8f3": {
        "0": [
            483
        ]
    },
    "29f61294": {
        "0": [
            480
        ]
    },
    "7fa26f10": {
        "0": [
            403
        ]
    },
    "52bd70b8": {
        "0": [
            560
        ]
    },
    "1c2e628f": {
        "0": [
            369
        ]
    },
    "19c8248e": {
        "0": [
            560
        ]
    },
    "291f8d27": {
        "0": [
            466
        ]
    },
    "74358fc4": {
        "0": [
            466
        ]
    },
    "245c9fa7": {
        "0": [
            346
        ]
    },
    "e57ab9f": {
        "0": [
            458
        ]
    },
    "2188e8bc": {
        "0": [
            466
        ]
    },
    "212f2ea8": {
        "0": [
            458
        ]
    },
    "57242b5e": {
        "0": [
            458
        ]
    },
    "270cb85c": {
        "0": [
            466
        ]
    },
    "519adff7": {
        "0": [
            458
        ]
    },
    "36e1dc5b": {
        "0": [
            458
        ]
    },
    "59ea61fe": {
        "0": [
            460
        ]
    },
    "5b14bb61": {
        "0": [
            466
        ]
    },
    "221dc6c3": {
        "0": [
            346
        ]
    },
    "60c505c5": {
        "0": [
            462
        ]
    },
    "56b27b34": {
        "0": [
            462
        ]
    },
    "36551c00": {
        "0": [
            426
        ]
    },
    "1932e7c2": {
        "0": [
            346
        ]
    },
    "60f8d398": {
        "0": [
            348
        ]
    },
    "7db2b909": {
        "1": [
            81
        ]
    },
    "19f7996": {
        "0": [
            560
        ]
    },
    "2b0ee9be": {
        "0": [
            426
        ]
    },
    "771ee41e": {
        "1": [
            30
        ]
    },
    "79948ac8": {
        "0": [
            560
        ]
    },
    "73445ad9": {
        "0": [
            560
        ]
    },
    "7d9fa03c": {
        "0": [
            426
        ]
    },
    "75a97230": {
        "0": [
            560
        ]
    },
    "29611aa9": {
        "1": [
            30
        ]
    },
    "1912cd07": {
        "0": [
            346
        ]
    },
    "6f80ee69": {
        "0": [
            293
        ]
    },
    "16de0c9e": {
        "1": [
            30
        ]
    },
    "567503cf": {
        "0": [
            445
        ]
    },
    "6642c7a1": {
        "0": [
            397
        ]
    },
    "38ce987a": {
        "0": [
            369
        ]
    },
    "2a067496": {
        "0": [
            527
        ]
    },
    "57040f7e": {
        "0": [
            483
        ]
    },
    "248c0a9a": {
        "0": [
            346
        ]
    },
    "5a6c10f6": {
        "0": [
            560
        ]
    },
    "4ec2a6f2": {
        "0": [
            560
        ]
    },
    "6fa22f9d": {
        "0": [
            560
        ]
    },
    "3ff0bcea": {
        "0": [
            381
        ]
    },
    "9ee867": {
        "0": [
            381
        ]
    },
    "46b6e18c": {
        "0": [
            448
        ]
    },
    "16d7672a": {
        "0": [
            560
        ]
    },
    "5bfa8f3b": {
        "0": [
            480
        ]
    },
    "7a81a2a5": {
        "0": [
            483
        ]
    },
    "1f5860bf": {
        "0": [
            483
        ]
    },
    "5972718c": {
        "0": [
            483
        ]
    },
    "548d6168": {
        "0": [
            483
        ]
    },
    "1ed7f96f": {
        "0": [
            0
        ]
    },
    "3995be4c": {
        "0": [
            460
        ]
    },
    "6a6e1814": {
        "0": [
            458
        ]
    },
    "655728ab": {
        "0": [
            560
        ]
    },
    "3d4e28f5": {
        "0": [
            397
        ]
    },
    "155345c2": {
        "1": [
            30
        ]
    },
    "6f67987a": {
        "0": [
            426
        ]
    },
    "1219b4f": {
        "1": [
            30
        ]
    },
    "4611d70f": {
        "0": [
            527
        ]
    },
    "4c39c578": {
        "0": [
            404
        ]
    },
    "764da1b": {
        "0": [
            480
        ]
    },
    "122af6aa": {
        "0": [
            483
        ]
    },
    "5503e712": {
        "0": [
            483
        ]
    },
    "2909a5c8": {
        "0": [
            431
        ]
    },
    "44383d04": {
        "0": [
            483
        ]
    },
    "4902747d": {
        "0": [
            483
        ]
    },
    "586d4ec": {
        "0": [
            560
        ]
    },
    "75947b75": {
        "0": [
            483
        ]
    },
    "400a832b": {
        "0": [
            483
        ]
    },
    "21bdd9f7": {
        "0": [
            346
        ]
    },
    "45fa81cc": {
        "0": [
            560
        ]
    },
    "38bdccb": {
        "0": [
            483
        ]
    },
    "2b47803c": {
        "0": [
            346
        ]
    },
    "68ff1c8d": {
        "0": [
            560
        ]
    },
    "15b076a0": {
        "0": [
            560
        ]
    },
    "24ad3a4f": {
        "0": [
            560
        ]
    },
    "4ba821e0": {
        "0": [
            483
        ]
    },
    "665a11a0": {
        "0": [
            346
        ]
    },
    "6ed4e6ec": {
        "0": [
            403
        ]
    },
    "522fabb2": {
        "0": [
            560
        ]
    },
    "6ec7fe1a": {
        "0": [
            340
        ]
    },
    "19cf3662": {
        "0": [
            560
        ]
    },
    "df14300": {
        "0": [
            426,
            480
        ]
    },
    "421f81dc": {
        "0": [
            426,
            560
        ]
    },
    "58fdd306": {
        "0": [
            560
        ]
    },
    "2b61935b": {
        "0": [
            560
        ]
    },
    "1cae9f42": {
        "0": [
            374
        ]
    },
    "3bb9dbad": {
        "0": [
            560
        ]
    },
    "7256b6f9": {
        "0": [
            560
        ]
    },
    "26b250d3": {
        "0": [
            560
        ]
    },
    "2f56e815": {
        "0": [
            560
        ]
    },
    "2717c553": {
        "0": [
            374
        ]
    },
    "2ea0d0a7": {
        "0": [
            374
        ]
    },
    "6c0d7df6": {
        "0": [
            560
        ]
    },
    "568d1e84": {
        "0": [
            560
        ]
    },
    "44b37c32": {
        "0": [
            483
        ]
    },
    "b78a184": {
        "0": [
            483
        ]
    },
    "65de19e": {
        "0": [
            560
        ]
    },
    "7e0167b0": {
        "0": [
            343
        ]
    },
    "29a223af": {
        "0": [
            483
        ]
    },
    "514c523a": {
        "0": [
            431
        ]
    },
    "73fc8e49": {
        "0": [
            483
        ]
    },
    "7a94ca08": {
        "0": [
            560
        ]
    },
    "48ce3eee": {
        "0": [
            560
        ]
    },
    "1ca0e9c": {
        "0": [
            560
        ]
    },
    "52767bb3": {
        "0": [
            560
        ]
    },
    "52b13aa1": {
        "0": [
            560
        ]
    },
    "4deb4661": {
        "0": [
            374
        ]
    },
    "2c278bc2": {
        "0": [
            346
        ]
    },
    "4cf855a1": {
        "0": [
            346
        ]
    },
    "3f02dfb2": {
        "0": [
            346
        ]
    },
    "3803bca9": {
        "0": [
            346
        ]
    },
    "343a35d3": {
        "0": [
            343
        ]
    },
    "7c1cf0eb": {
        "0": [
            346
        ]
    },
    "3d401a13": {
        "0": [
            346
        ]
    },
    "677f70e8": {
        "0": [
            560
        ]
    },
    "6b08e178": {
        "0": [
            346
        ]
    },
    "52dff129": {
        "0": [
            346
        ]
    },
    "28ce1a91": {
        "0": [
            412
        ]
    },
    "46c3d5d5": {
        "0": [
            560
        ]
    },
    "4a4e6f1e": {
        "0": [
            560
        ]
    },
    "1936600e": {
        "0": [
            560
        ]
    },
    "1ff50bea": {
        "0": [
            346
        ]
    },
    "4315e06": {
        "0": [
            560
        ]
    },
    "5d518e74": {
        "0": [
            560
        ]
    },
    "aa8922": {
        "0": [
            480
        ]
    },
    "16c91c13": {
        "0": [
            560
        ]
    },
    "510a3254": {
        "0": [
            417
        ]
    },
    "2c7d7481": {
        "0": [
            560
        ]
    },
    "3f841c03": {
        "0": [
            560
        ]
    },
    "60dfcbe8": {
        "0": [
            483
        ]
    },
    "609cdc28": {
        "0": [
            421
        ]
    },
    "3a04960f": {
        "0": [
            560
        ]
    },
    "2ae8b1e6": {
        "0": [
            560
        ]
    },
    "9bcd820": {
        "0": [
            560
        ]
    },
    "2477138a": {
        "0": [
            480
        ]
    },
    "7bce00c4": {
        "0": [
            560
        ]
    },
    "18f7140c": {
        "0": [
            374
        ]
    },
    "1ce074a4": {
        "0": [
            431
        ]
    },
    "9f695dc": {
        "0": [
            458
        ]
    },
    "2491e40d": {
        "0": [
            381
        ]
    },
    "757a8795": {
        "0": [
            544
        ]
    },
    "57e64a07": {
        "0": [
            544
        ]
    },
    "3e6f98b5": {
        "0": [
            497
        ]
    },
    "1436422f": {
        "0": [
            497
        ]
    },
    "139cae3f": {
        "0": [
            497
        ]
    },
    "7380ba08": {
        "0": [
            497
        ]
    },
    "232fbb5a": {
        "0": [
            560
        ]
    },
    "523d4da": {
        "0": [
            560
        ]
    },
    "28b09a99": {
        "0": [
            387
        ]
    },
    "4e8a9cfc": {
        "0": [
            527
        ]
    },
    "606a158c": {
        "0": [
            527
        ]
    },
    "64df2c27": {
        "0": [
            387
        ]
    },
    "4170547d": {
        "0": [
            497
        ]
    },
    "1a72c0a6": {
        "0": [
            458
        ]
    },
    "37ea875a": {
        "0": [
            544
        ]
    },
    "3f4fbc79": {
        "0": [
            544
        ]
    },
    "2fbb9a0c": {
        "0": [
            544
        ]
    },
    "15b6eb0": {
        "0": [
            513
        ]
    },
    "1eca8e67": {
        "3": [
            11
        ]
    },
    "2a14701d": {
        "0": [
            513
        ]
    },
    "56fc06cc": {
        "3": [
            11
        ]
    },
    "99f599f": {
        "3": [
            11
        ]
    },
    "42a2d9b6": {
        "0": [
            397
        ]
    },
    "63a8561c": {
        "0": [
            397
        ]
    },
    "502dd6e": {
        "0": [
            533
        ]
    },
    "94080e9": {
        "0": [
            527
        ]
    },
    "f697ba8": {
        "0": [
            527
        ]
    },
    "f7e9c79": {
        "0": [
            483
        ]
    },
    "7f9b84d0": {
        "0": [
            560
        ]
    },
    "17ba57f1": {
        "0": [
            560
        ]
    },
    "102f8fbb": {
        "0": [
            381
        ]
    },
    "5a02ee88": {
        "0": [
            483
        ]
    },
    "4d698992": {
        "0": [
            560
        ]
    },
    "7d7b976c": {
        "0": [
            483
        ]
    },
    "5cd2dd4f": {
        "0": [
            346
        ]
    },
    "53b7ca26": {
        "0": [
            215
        ]
    },
    "3a7b1577": {
        "0": [
            480
        ]
    },
    "59c34717": {
        "0": [
            480
        ]
    },
    "711f5534": {
        "0": [
            483
        ]
    },
    "5caafafd": {
        "0": [
            483
        ]
    },
    "7ee4f153": {
        "0": [
            379
        ]
    },
    "184a073e": {
        "0": [
            483
        ]
    },
    "1479d9dd": {
        "0": [
            483
        ]
    },
    "2caf0439": {
        "0": [
            397
        ]
    },
    "5bea4b92": {
        "0": [
            483
        ]
    },
    "7a546e48": {
        "0": [
            560
        ]
    },
    "733cae99": {
        "0": [
            397
        ]
    },
    "18694dec": {
        "0": [
            483
        ]
    },
    "4821c280": {
        "1": [
            30
        ]
    },
    "677b8519": {
        "0": [
            374
        ]
    },
    "67c641b9": {
        "0": [
            527
        ]
    },
    "3cf61430": {
        "0": [
            527
        ]
    },
    "7a9493a": {
        "0": [
            480
        ]
    },
    "627ef426": {
        "0": [
            560
        ]
    },
    "85f5b12": {
        "0": [
            560
        ]
    },
    "5caa3d26": {
        "0": [
            483
        ]
    },
    "221f46b2": {
        "0": [
            560
        ]
    },
    "29f36585": {
        "0": [
            483
        ]
    },
    "2f45551e": {
        "0": [
            483
        ]
    },
    "28601a2b": {
        "0": [
            346
        ]
    },
    "e026170": {
        "0": [
            560
        ]
    },
    "231ba26e": {
        "0": [
            346
        ]
    },
    "18eb9a": {
        "0": [
            560
        ]
    },
    "aa3cc5c": {
        "0": [
            483
        ]
    },
    "6105c2ba": {
        "0": [
            560
        ]
    },
    "596fddc7": {
        "0": [
            560
        ]
    },
    "6bab5320": {
        "0": [
            483
        ]
    },
    "26bda69b": {
        "0": [
            346
        ]
    },
    "16dd2648": {
        "0": [
            483
        ]
    },
    "437ae360": {
        "0": [
            416
        ]
    },
    "22154fc0": {
        "0": [
            480
        ]
    },
    "68611bbc": {
        "0": [
            480
        ]
    },
    "2961ba07": {
        "0": [
            374
        ]
    },
    "42e89cb1": {
        "0": [
            560
        ]
    },
    "7a7a7ea2": {
        "0": [
            483
        ]
    },
    "14d48160": {
        "0": [
            560
        ]
    },
    "15365c74": {
        "0": [
            483
        ]
    },
    "1c4cfb19": {
        "0": [
            483
        ]
    },
    "6abd5b2c": {
        "0": [
            560
        ]
    },
    "39a9f2d5": {
        "0": [
            483
        ]
    },
    "77ced7f2": {
        "0": [
            560
        ]
    },
    "1b68a07e": {
        "0": [
            483
        ]
    },
    "1d5ac7fb": {
        "0": [
            483
        ]
    },
    "8d4320e": {
        "0": [
            483
        ]
    },
    "5b54eaa5": {
        "0": [
            468
        ]
    },
    "7bcc490": {
        "1": [
            81
        ]
    },
    "5ffcd198": {
        "0": [
            560
        ]
    },
    "3a03506d": {
        "0": [
            560
        ]
    },
    "2001842c": {
        "0": [
            560
        ]
    },
    "3969b180": {
        "1": [
            30
        ]
    },
    "5838600c": {
        "0": [
            483
        ]
    },
    "5a740d9c": {
        "0": [
            483
        ]
    },
    "1e931d23": {
        "0": [
            560
        ]
    },
    "26b76ae2": {
        "0": [
            480
        ]
    },
    "1f7261b": {
        "0": [
            483
        ]
    },
    "dc78a5a": {
        "1": [
            81
        ]
    },
    "1b65caa0": {
        "0": [
            194,
            480
        ]
    },
    "47fda490": {
        "0": [
            560
        ]
    },
    "3062f14c": {
        "0": [
            276
        ]
    },
    "473f479f": {
        "0": [
            403
        ]
    },
    "3e82832e": {
        "0": [
            483
        ]
    },
    "3533fa29": {
        "0": [
            403
        ]
    },
    "3b19c779": {
        "0": [
            483
        ]
    },
    "14f24eba": {
        "0": [
            483
        ]
    },
    "71be2e16": {
        "0": [
            483
        ]
    },
    "1a06e07c": {
        "0": [
            483
        ]
    },
    "12638eed": {
        "3": [
            5
        ]
    },
    "11903a66": {
        "3": [
            5
        ]
    },
    "3e9cbc72": {
        "3": [
            5
        ]
    },
    "6b6ddcfd": {
        "0": [
            427
        ]
    },
    "1fcab601": {
        "0": [
            427
        ]
    },
    "45d0759b": {
        "0": [
            427
        ]
    },
    "1f1faf8": {
        "0": [
            427
        ]
    },
    "31c93dce": {
        "0": [
            426
        ]
    },
    "3fc4bac2": {
        "0": [
            480
        ]
    },
    "1ca5591b": {
        "3": [
            5
        ]
    },
    "2b49a82c": {
        "0": [
            480
        ]
    },
    "1bbd2e38": {
        "0": [
            483
        ]
    },
    "462c3223": {
        "0": [
            560
        ]
    },
    "63293c23": {
        "0": [
            381
        ]
    },
    "729cd341": {
        "1": [
            84
        ]
    },
    "548a6272": {
        "0": [
            560
        ]
    },
    "b199bc1": {
        "0": [
            483
        ]
    },
    "6ebd28de": {
        "0": [
            369
        ]
    },
    "668fcec8": {
        "0": [
            397
        ]
    },
    "404ba65d": {
        "0": [
            397
        ]
    },
    "2e15835b": {
        "3": [
            5
        ]
    },
    "3a8fcee6": {
        "3": [
            5
        ]
    },
    "1d396e95": {
        "3": [
            5
        ]
    },
    "786dad4a": {
        "3": [
            5
        ]
    },
    "2c90ca4a": {
        "0": [
            483
        ]
    },
    "46ae5b9b": {
        "0": [
            483
        ]
    },
    "21e53a13": {
        "0": [
            483
        ]
    },
    "5c3b5a5": {
        "0": [
            374
        ]
    },
    "55e03f43": {
        "0": [
            560
        ]
    },
    "4d0b28e5": {
        "1": [
            81
        ]
    },
    "120c53d5": {
        "0": [
            483
        ]
    },
    "15cd32d9": {
        "0": [
            483
        ]
    },
    "131dda12": {
        "0": [
            494
        ]
    },
    "5df75797": {
        "0": [
            347
        ]
    },
    "7e85788b": {
        "1": [
            30
        ]
    },
    "50ff32f0": {
        "1": [
            81
        ]
    },
    "7030e81e": {
        "1": [
            81
        ]
    },
    "7c87a3e0": {
        "3": [
            6
        ]
    },
    "e1fda3f": {
        "0": [
            426
        ]
    },
    "630d1654": {
        "1": [
            34
        ]
    },
    "126402b7": {
        "0": [
            426
        ]
    },
    "5ec17e2e": {
        "1": [
            550
        ]
    },
    "46a93254": {
        "0": [
            374
        ]
    },
    "75f69776": {
        "0": [
            374
        ]
    },
    "5806c54c": {
        "0": [
            374
        ]
    },
    "24589a8b": {
        "0": [
            374
        ]
    },
    "4777b0d5": {
        "0": [
            374
        ]
    },
    "48b31981": {
        "3": [
            5
        ]
    },
    "57168c0b": {
        "0": [
            374
        ]
    },
    "3bae64a7": {
        "0": [
            374
        ]
    },
    "205e4944": {
        "0": [
            374
        ]
    },
    "1fa21001": {
        "0": [
            452
        ]
    },
    "f1e117c": {
        "0": [
            483
        ]
    },
    "61c3481a": {
        "0": [
            403
        ]
    },
    "6e829f39": {
        "0": [
            483
        ]
    },
    "49049a8": {
        "0": [
            483
        ]
    },
    "2c0229da": {
        "0": [
            483
        ]
    },
    "581abc89": {
        "0": [
            403
        ]
    },
    "7622b6c6": {
        "0": [
            403
        ]
    },
    "603dab49": {
        "0": [
            483
        ]
    },
    "5cc88cb4": {
        "0": [
            483
        ]
    },
    "74e55f48": {
        "0": [
            560
        ]
    },
    "7b4acb14": {
        "0": [
            560
        ]
    },
    "723a653f": {
        "0": [
            560
        ]
    },
    "3e28fc4a": {
        "0": [
            480
        ]
    },
    "35de2b6e": {
        "0": [
            346
        ]
    },
    "6a7da964": {
        "0": [
            346
        ]
    },
    "4b8d2cc0": {
        "0": [
            480
        ]
    },
    "5754e975": {
        "0": [
            560
        ]
    },
    "1797ca2b": {
        "0": [
            431
        ]
    },
    "4485798c": {
        "0": [
            431
        ]
    },
    "7d79928b": {
        "0": [
            431
        ]
    },
    "5ad5f1e6": {
        "0": [
            458
        ]
    },
    "4e30b504": {
        "0": [
            458
        ]
    },
    "3a413b8c": {
        "0": [
            458
        ]
    },
    "37dbfee8": {
        "0": [
            458
        ]
    },
    "2b36c206": {
        "0": [
            458
        ]
    },
    "39d1aa5a": {
        "0": [
            458
        ]
    },
    "5fc6dfe6": {
        "0": [
            480
        ]
    },
    "5be7755f": {
        "0": [
            483
        ]
    },
    "35729ac3": {
        "0": [
            560
        ]
    },
    "5bab0733": {
        "0": [
            483
        ]
    },
    "17a29fb2": {
        "0": [
            483
        ]
    },
    "5aafeeb8": {
        "0": [
            560
        ]
    },
    "5d82c022": {
        "0": [
            426
        ]
    },
    "6fc9a360": {
        "0": [
            480
        ]
    },
    "4b586e00": {
        "0": [
            483
        ]
    },
    "10c9fc78": {
        "0": [
            483
        ]
    },
    "482ba59": {
        "0": [
            483
        ]
    },
    "7fa6bb12": {
        "0": [
            483
        ]
    },
    "13d9367f": {
        "0": [
            427
        ]
    },
    "74bd94f3": {
        "0": [
            560
        ]
    },
    "23758d3e": {
        "0": [
            428
        ]
    },
    "47cfe533": {
        "0": [
            560
        ]
    },
    "60873cd8": {
        "0": [
            560
        ]
    },
    "503a9d38": {
        "0": [
            560
        ]
    },
    "16ab75b4": {
        "0": [
            480,
            488,
            560
        ]
    },
    "5db0cbfb": {
        "0": [
            483
        ]
    },
    "28a633a3": {
        "0": [
            404
        ]
    },
    "ebd7": {
        "0": [
            488
        ]
    },
    "398b4d31": {
        "1": [
            18
        ]
    },
    "5544ff3": {
        "1": [
            14
        ]
    },
    "c3b2224": {
        "0": [
            491
        ]
    },
    "5c1a96bd": {
        "1": [
            20
        ]
    },
    "7f2a6f82": {
        "0": [
            483
        ]
    },
    "2e27ac6": {
        "0": [
            483
        ]
    },
    "67953a7c": {
        "0": [
            483
        ]
    },
    "51e16783": {
        "0": [
            560
        ]
    },
    "25090f77": {
        "0": [
            426
        ]
    },
    "bca9a83": {
        "0": [
            483
        ]
    },
    "3a7988ba": {
        "0": [
            483
        ]
    },
    "9b4d33b": {
        "0": [
            483
        ]
    },
    "27112bf1": {
        "0": [
            483
        ]
    },
    "5d3b17c3": {
        "0": [
            404
        ]
    },
    "61c92fbc": {
        "0": [
            483
        ]
    },
    "4e215c3b": {
        "0": [
            483
        ]
    },
    "55a2b0f5": {
        "0": [
            483
        ]
    },
    "1329e1b8": {
        "0": [
            483
        ]
    },
    "5dae8384": {
        "0": [
            483
        ]
    },
    "7a5bf26": {
        "0": [
            152
        ]
    },
    "35fe370b": {
        "0": [
            483
        ]
    },
    "6fdf7d5d": {
        "0": [
            483
        ]
    },
    "996d06c": {
        "0": [
            483
        ]
    },
    "7df1c9": {
        "0": [
            483
        ]
    },
    "7e7f0fb5": {
        "0": [
            560
        ]
    },
    "20d0058c": {
        "0": [
            560
        ]
    },
    "d9f4e0c": {
        "0": [
            480
        ]
    },
    "15db6ec8": {
        "0": [
            483
        ]
    },
    "5441f76a": {
        "0": [
            560
        ]
    },
    "4412598c": {
        "0": [
            483
        ]
    },
    "301fa328": {
        "0": [
            483
        ]
    },
    "437464c4": {
        "0": [
            480
        ]
    },
    "ed77680": {
        "0": [
            483
        ]
    },
    "ee74a30": {
        "0": [
            560
        ]
    },
    "4a527aac": {
        "0": [
            480
        ]
    },
    "34cfa03c": {
        "0": [
            480
        ]
    },
    "142db543": {
        "0": [
            426
        ]
    },
    "4c5dfa9e": {
        "0": [
            346
        ]
    },
    "fc5e240": {
        "0": [
            311
        ]
    },
    "3fccaa3c": {
        "0": [
            427
        ]
    },
    "7f9e8e6d": {
        "0": [
            445
        ]
    },
    "7074732a": {
        "1": [
            81
        ]
    },
    "67053ac1": {
        "1": [
            81
        ]
    },
    "30933ce9": {
        "0": [
            480
        ]
    },
    "11ac0863": {
        "0": [
            480
        ]
    },
    "1a59dd68": {
        "0": [
            483
        ]
    },
    "7d5b51fa": {
        "1": [
            30
        ]
    },
    "3f605aa4": {
        "1": [
            81
        ]
    },
    "7155a4d7": {
        "0": [
            387
        ]
    },
    "2fc31689": {
        "0": [
            560
        ]
    },
    "325bc8cc": {
        "1": [
            73
        ]
    },
    "121babc2": {
        "1": [
            81
        ]
    },
    "2cd3959b": {
        "1": [
            81
        ]
    },
    "362a8370": {
        "1": [
            73
        ]
    },
    "7485b130": {
        "0": [
            483
        ]
    },
    "c8182cf": {
        "0": [
            483
        ]
    },
    "24f83bdc": {
        "0": [
            483
        ]
    },
    "6fb0de41": {
        "0": [
            560
        ]
    },
    "6c8b6699": {
        "0": [
            480
        ]
    },
    "fdddd5d": {
        "0": [
            403
        ]
    },
    "975a13a": {
        "0": [
            403
        ]
    },
    "19381c09": {
        "0": [
            480
        ]
    },
    "22a937ce": {
        "0": [
            403
        ]
    },
    "4e98f027": {
        "0": [
            480
        ]
    },
    "c8d8b94": {
        "0": [
            483
        ]
    },
    "3e280e59": {
        "0": [
            480
        ]
    },
    "66c22681": {
        "0": [
            403
        ]
    },
    "49815a53": {
        "0": [
            483
        ]
    },
    "190a935a": {
        "0": [
            480
        ]
    },
    "3157a84d": {
        "0": [
            403
        ]
    },
    "3163893a": {
        "0": [
            374
        ]
    },
    "ffb397c": {
        "0": [
            346
        ]
    },
    "6a9a4667": {
        "0": [
            403
        ]
    },
    "38d8576b": {
        "0": [
            403
        ]
    },
    "4d5793b0": {
        "0": [
            483
        ]
    },
    "3275de54": {
        "0": [
            480
        ]
    },
    "714bc7d9": {
        "0": [
            403
        ]
    },
    "6383d29f": {
        "0": [
            404
        ]
    },
    "4af93dbd": {
        "0": [
            483
        ]
    },
    "49deed11": {
        "0": [
            483
        ]
    },
    "3782fc18": {
        "0": [
            416
        ]
    },
    "5490ee73": {
        "0": [
            483
        ]
    },
    "e5e3c7a": {
        "0": [
            346
        ]
    },
    "5a4741ab": {
        "0": [
            483
        ]
    },
    "27a436a7": {
        "0": [
            480
        ]
    },
    "68bf61d3": {
        "0": [
            483
        ]
    },
    "5d24ee89": {
        "0": [
            480
        ]
    },
    "3a0ca6b7": {
        "0": [
            480
        ]
    },
    "14fc1448": {
        "0": [
            403
        ]
    },
    "75bd5302": {
        "0": [
            374
        ]
    },
    "40f0f1ba": {
        "0": [
            346
        ]
    },
    "46ed864e": {
        "0": [
            403
        ]
    },
    "391830b5": {
        "0": [
            403
        ]
    },
    "7660f30f": {
        "0": [
            403
        ]
    },
    "72398e51": {
        "0": [
            480
        ]
    },
    "273132d1": {
        "0": [
            483
        ]
    },
    "15eefff4": {
        "0": [
            404
        ]
    },
    "64c3e9e7": {
        "1": [
            54
        ]
    },
    "494c857a": {
        "0": [
            483
        ]
    },
    "1aa08861": {
        "0": [
            483
        ]
    },
    "5337462f": {
        "0": [
            346
        ]
    },
    "2c4cd1": {
        "0": [
            346
        ]
    },
    "38dbac5d": {
        "0": [
            346
        ]
    },
    "c78148d": {
        "0": [
            480
        ]
    },
    "376f770a": {
        "0": [
            480
        ]
    },
    "533c515d": {
        "0": [
            483
        ]
    },
    "2c684c12": {
        "0": [
            480
        ]
    },
    "6678f12c": {
        "0": [
            374
        ]
    },
    "1cb3299": {
        "0": [
            346
        ]
    },
    "23eebeaf": {
        "0": [
            480
        ]
    },
    "79bd9bc9": {
        "0": [
            403
        ]
    },
    "6c26556a": {
        "0": [
            480
        ]
    },
    "4fcb5049": {
        "0": [
            403
        ]
    },
    "20e84d98": {
        "0": [
            480
        ]
    },
    "3f9c118c": {
        "0": [
            483
        ]
    },
    "2217043d": {
        "0": [
            483
        ]
    },
    "2228d9e0": {
        "0": [
            483
        ]
    },
    "4da6209b": {
        "0": [
            480
        ]
    },
    "370d292f": {
        "0": [
            374
        ]
    },
    "352eebfd": {
        "0": [
            404
        ]
    },
    "130f4fb7": {
        "0": [
            483
        ]
    },
    "2d84c997": {
        "0": [
            560
        ]
    },
    "a263f32": {
        "0": [
            480
        ]
    },
    "4e1cdbf": {
        "0": [
            480
        ]
    },
    "3d32b112": {
        "0": [
            480
        ]
    },
    "7700ff38": {
        "0": [
            346
        ]
    },
    "40cf9f6e": {
        "0": [
            480
        ]
    },
    "285cdbae": {
        "0": [
            560
        ]
    },
    "e68f8e6": {
        "0": [
            560
        ]
    },
    "4d430b55": {
        "0": [
            560
        ]
    },
    "369c53ca": {
        "0": [
            560
        ]
    },
    "6bcc6d76": {
        "0": [
            560
        ]
    },
    "6a3a474f": {
        "1": [
            35
        ]
    },
    "2c8112d1": {
        "0": [
            483
        ]
    },
    "71a0630a": {
        "0": [
            568
        ]
    },
    "1a5a8635": {
        "0": [
            483
        ]
    },
    "133c513f": {
        "0": [
            480
        ]
    },
    "1e81d03b": {
        "1": [
            255
        ]
    },
    "47adb7a6": {
        "0": [
            560
        ]
    },
    "7897aae2": {
        "0": [
            420
        ]
    },
    "333c4ec5": {
        "0": [
            560
        ]
    },
    "6e01dd53": {
        "0": [
            231
        ]
    },
    "3a23ab96": {
        "0": [
            480
        ]
    },
    "6d910609": {
        "0": [
            480
        ]
    },
    "29cefa43": {
        "0": [
            426
        ]
    },
    "4af073b6": {
        "1": [
            81
        ]
    },
    "7288a316": {
        "0": [
            426
        ]
    },
    "88541fc": {
        "0": [
            427
        ]
    },
    "50da3fa6": {
        "0": [
            483
        ]
    },
    "666359f1": {
        "0": [
            560
        ]
    },
    "51fea6d4": {
        "0": [
            480
        ]
    },
    "333a5bcd": {
        "0": [
            480
        ]
    },
    "60169cbf": {
        "0": [
            346
        ]
    },
    "3762fcaa": {
        "0": [
            346
        ]
    },
    "7c9dc77f": {
        "0": [
            431
        ]
    },
    "5a88b8c8": {
        "0": [
            483
        ]
    },
    "436663a9": {
        "0": [
            427
        ]
    },
    "558a2d58": {
        "1": [
            81
        ]
    },
    "4f518fa8": {
        "1": [
            81
        ]
    },
    "52cb293": {
        "0": [
            560
        ]
    },
    "1c300f31": {
        "0": [
            483
        ]
    },
    "5f54a22e": {
        "0": [
            483
        ]
    },
    "79738eb9": {
        "0": [
            483
        ]
    },
    "3dbfc91": {
        "0": [
            483
        ]
    },
    "130cb2ea": {
        "0": [
            483
        ]
    },
    "4712cc13": {
        "0": [
            483
        ]
    },
    "21091c94": {
        "0": [
            483
        ]
    },
    "36b717d8": {
        "0": [
            401
        ]
    },
    "2c832ac1": {
        "0": [
            346
        ]
    },
    "1ac80934": {
        "0": [
            346
        ]
    },
    "3ab2ae8a": {
        "0": [
            346
        ]
    },
    "1f28bbb7": {
        "0": [
            346
        ]
    },
    "790425f8": {
        "0": [
            346
        ]
    },
    "43e43aca": {
        "0": [
            346
        ]
    },
    "15f72f77": {
        "0": [
            346
        ]
    },
    "66a10d78": {
        "0": [
            346
        ]
    },
    "5d6f8138": {
        "0": [
            346
        ]
    },
    "51e6a0c7": {
        "0": [
            346
        ]
    },
    "61d033bb": {
        "0": [
            346
        ]
    },
    "6312da15": {
        "0": [
            346
        ]
    },
    "70a518d8": {
        "0": [
            346
        ]
    },
    "28bc9fdd": {
        "0": [
            346
        ]
    },
    "4cb36f24": {
        "0": [
            346
        ]
    },
    "744d1fda": {
        "1": [
            241
        ]
    },
    "1ac74b0": {
        "1": [
            241
        ]
    },
    "6b852078": {
        "1": [
            241
        ]
    },
    "150efd21": {
        "1": [
            332
        ]
    },
    "164dbdb": {
        "1": [
            18
        ]
    },
    "577e5f76": {
        "0": [
            401
        ]
    },
    "9e19d54": {
        "0": [
            416
        ]
    },
    "77dd0785": {
        "0": [
            568
        ]
    },
    "546b0723": {
        "0": [
            568
        ]
    },
    "545cefa2": {
        "0": [
            568
        ]
    },
    "77dd105f": {
        "0": [
            568
        ]
    },
    "77dd1060": {
        "0": [
            568
        ]
    },
    "777abe33": {
        "0": [
            568
        ]
    },
    "777abe32": {
        "0": [
            568
        ]
    },
    "77dd0862": {
        "0": [
            568
        ]
    },
    "77dd0fb7": {
        "0": [
            568
        ]
    },
    "5234f3e8": {
        "1": [
            245
        ]
    },
    "296c0139": {
        "1": [
            245
        ]
    },
    "3ac6115b": {
        "1": [
            245
        ]
    },
    "127fd11a": {
        "1": [
            245
        ]
    },
    "59e81123": {
        "1": [
            245
        ]
    },
    "7f494dc7": {
        "1": [
            245
        ]
    },
    "1973d17": {
        "1": [
            18
        ]
    },
    "3fce512b": {
        "0": [
            371
        ]
    },
    "7a1ec9fd": {
        "0": [
            480
        ]
    },
    "664a08b0": {
        "1": [
            81
        ]
    },
    "46565a70": {
        "1": [
            81
        ]
    },
    "25bf8527": {
        "1": [
            30
        ]
    },
    "6f113624": {
        "1": [
            258
        ]
    },
    "969a304": {
        "0": [
            560
        ]
    },
    "19e9f765": {
        "0": [
            560
        ]
    },
    "4a02d6d6": {
        "0": [
            560
        ]
    },
    "35569f79": {
        "0": [
            560
        ]
    },
    "5d8f9306": {
        "1": [
            30
        ]
    },
    "3afcd282": {
        "0": [
            560
        ]
    },
    "1fb86073": {
        "0": [
            560
        ]
    },
    "214a0449": {
        "0": [
            560
        ]
    },
    "de8502a": {
        "0": [
            483
        ]
    },
    "5111ac9d": {
        "0": [
            480
        ]
    },
    "5c20096c": {
        "0": [
            560
        ]
    },
    "2c1f018a": {
        "0": [
            560
        ]
    },
    "150af27e": {
        "0": [
            300
        ]
    },
    "3d52c175": {
        "0": [
            480
        ]
    },
    "13867f56": {
        "0": [
            483
        ]
    },
    "22c5bd31": {
        "0": [
            483
        ]
    },
    "6b86d1b0": {
        "0": [
            483
        ]
    },
    "316634ca": {
        "0": [
            483
        ]
    },
    "5aafa273": {
        "0": [
            480
        ]
    },
    "1e2bc56d": {
        "0": [
            483
        ]
    },
    "4399a01a": {
        "0": [
            560
        ]
    },
    "7ce9e5d1": {
        "0": [
            560
        ]
    },
    "3dae3751": {
        "0": [
            483
        ]
    },
    "79b4322b": {
        "0": [
            483
        ]
    },
    "780c8371": {
        "0": [
            480
        ]
    },
    "7dbef8f2": {
        "0": [
            483
        ]
    },
    "7db4adb2": {
        "0": [
            483
        ]
    },
    "54686caf": {
        "0": [
            483
        ]
    },
    "268fd250": {
        "0": [
            483
        ]
    },
    "3521626e": {
        "0": [
            483
        ]
    },
    "ab0f422": {
        "0": [
            480
        ]
    },
    "38c7f992": {
        "0": [
            483
        ]
    },
    "1e02fd6d": {
        "0": [
            483
        ]
    },
    "3e3124ef": {
        "0": [
            480
        ]
    },
    "67d5ef4c": {
        "0": [
            483
        ]
    },
    "aef5f33": {
        "0": [
            483
        ]
    },
    "204bafb2": {
        "0": [
            480
        ]
    },
    "169548fe": {
        "0": [
            488
        ]
    },
    "76986c51": {
        "0": [
            356
        ]
    },
    "241a6417": {
        "0": [
            483
        ]
    },
    "2aa68471": {
        "1": [
            20
        ]
    },
    "2a92d0c8": {
        "0": [
            483
        ]
    },
    "347561f7": {
        "0": [
            483
        ]
    },
    "6f2febc5": {
        "0": [
            483
        ]
    },
    "219a1ec7": {
        "0": [
            527
        ]
    },
    "12fc1124": {
        "0": [
            560
        ]
    },
    "68f71001": {
        "0": [
            560
        ]
    },
    "6596fdf": {
        "0": [
            560
        ]
    },
    "69d85154": {
        "0": [
            560
        ]
    },
    "18aef751": {
        "0": [
            560
        ]
    },
    "62909d25": {
        "0": [
            560
        ]
    },
    "7b513f7b": {
        "0": [
            560
        ]
    },
    "ba41adc": {
        "1": [
            99
        ]
    },
    "6bfa56df": {
        "0": [
            483
        ]
    },
    "4a9ab573": {
        "0": [
            480
        ]
    },
    "6007072e": {
        "0": [
            483
        ]
    },
    "d982257": {
        "0": [
            346
        ]
    },
    "7c0ba487": {
        "0": [
            483
        ]
    },
    "6bf99b93": {
        "0": [
            483
        ]
    },
    "6b640517": {
        "0": [
            483
        ]
    },
    "617f04de": {
        "0": [
            483
        ]
    },
    "28ab79b0": {
        "0": [
            483
        ]
    },
    "7833b407": {
        "0": [
            483
        ]
    },
    "54d141ec": {
        "0": [
            483
        ]
    },
    "8b99ef9": {
        "0": [
            483
        ]
    },
    "63d995a7": {
        "0": [
            483
        ]
    },
    "569a5b63": {
        "0": [
            396
        ]
    },
    "1c7db9b6": {
        "1": [
            21
        ]
    },
    "2157fd44": {
        "1": [
            87
        ]
    },
    "64a180b9": {
        "0": [
            483
        ]
    },
    "65d8647d": {
        "0": [
            560
        ]
    },
    "2620494e": {
        "0": [
            480
        ]
    },
    "46f02cf": {
        "1": [
            81
        ]
    },
    "4b379dc7": {
        "0": [
            483
        ]
    },
    "1076e8b0": {
        "0": [
            483
        ]
    },
    "18680a52": {
        "0": [
            374
        ]
    },
    "2ee6ca7f": {
        "0": [
            483
        ]
    },
    "6d35d73": {
        "0": [
            483
        ]
    },
    "2f859093": {
        "0": [
            480
        ]
    },
    "2c55e551": {
        "0": [
            346
        ]
    },
    "77f66914": {
        "0": [
            560
        ]
    },
    "4f3923b7": {
        "0": [
            560
        ]
    },
    "231cdd1c": {
        "0": [
            560
        ]
    },
    "742a496d": {
        "1": [
            77
        ]
    },
    "9afb73": {
        "0": [
            480
        ]
    },
    "a34b131": {
        "0": [
            560
        ]
    },
    "3c53c130": {
        "0": [
            560
        ]
    },
    "2a5f771": {
        "0": [
            560
        ]
    },
    "3f2cc90e": {
        "0": [
            560
        ]
    },
    "2e123bb2": {
        "0": [
            560
        ]
    },
    "cbb8af3": {
        "1": [
            81
        ]
    },
    "9b7d215": {
        "1": [
            34
        ]
    },
    "3528ec5c": {
        "0": [
            527
        ]
    },
    "4c359e88": {
        "0": [
            560
        ]
    },
    "7e1da890": {
        "0": [
            560
        ]
    },
    "12c496d0": {
        "0": [
            527
        ]
    },
    "6a07bf82": {
        "0": [
            560
        ]
    },
    "6c236571": {
        "0": [
            527
        ]
    },
    "4bf92032": {
        "0": [
            527
        ]
    },
    "70a1c1d1": {
        "0": [
            527
        ]
    },
    "38e93a46": {
        "0": [
            560
        ]
    },
    "131ce373": {
        "0": [
            460
        ]
    },
    "3311cb50": {
        "0": [
            369
        ]
    },
    "213123ee": {
        "0": [
            374
        ]
    },
    "7df27c13": {
        "0": [
            387
        ]
    },
    "f44680d": {
        "0": [
            480
        ]
    },
    "521879bc": {
        "0": [
            560
        ]
    },
    "1b871722": {
        "0": [
            483
        ]
    },
    "47db9cab": {
        "0": [
            483
        ]
    },
    "5f686e40": {
        "0": [
            483
        ]
    },
    "24dbaf59": {
        "0": [
            426
        ]
    },
    "5be21418": {
        "0": [
            483
        ]
    },
    "761ee2ba": {
        "0": [
            483
        ]
    },
    "1bf5fd9e": {
        "1": [
            30
        ]
    },
    "2ec1f5b2": {
        "0": [
            369
        ]
    },
    "49951dbd": {
        "0": [
            483
        ]
    },
    "4d2fa061": {
        "0": [
            483
        ]
    },
    "64d209ae": {
        "0": [
            560
        ]
    },
    "5f7f2451": {
        "0": [
            560
        ]
    },
    "2ba75abd": {
        "0": [
            560
        ]
    },
    "7fa05910": {
        "0": [
            246
        ]
    },
    "6fc4579a": {
        "0": [
            483
        ]
    },
    "7e8d33e0": {
        "0": [
            560
        ]
    },
    "2f2e21a2": {
        "0": [
            560
        ]
    },
    "3751c74e": {
        "0": [
            560
        ]
    },
    "51802a8": {
        "0": [
            560
        ]
    },
    "19c78": {
        "0": [
            347
        ]
    },
    "655916f0": {
        "0": [
            483
        ]
    },
    "7ef762de": {
        "0": [
            403
        ]
    },
    "2fb30e44": {
        "0": [
            483
        ]
    },
    "6f9fddd1": {
        "0": [
            483
        ]
    },
    "52faa1d2": {
        "0": [
            403
        ]
    },
    "5a9ff083": {
        "0": [
            480
        ]
    },
    "115162b5": {
        "0": [
            483
        ]
    },
    "7b3b049b": {
        "0": [
            560
        ]
    },
    "63f1a1d": {
        "0": [
            416
        ]
    },
    "433f68a2": {
        "0": [
            374
        ]
    },
    "f3d21bc": {
        "0": [
            560
        ]
    },
    "2ab71a5b": {
        "0": [
            483
        ]
    },
    "56de4e22": {
        "0": [
            560
        ]
    },
    "153099c3": {
        "0": [
            403
        ]
    },
    "5671b915": {
        "0": [
            483
        ]
    },
    "75a6d97d": {
        "0": [
            483
        ]
    },
    "a035d74": {
        "0": [
            416
        ]
    },
    "11244e63": {
        "0": [
            483
        ]
    },
    "38f0a721": {
        "0": [
            374
        ]
    },
    "551c7c24": {
        "0": [
            483
        ]
    },
    "a21793f": {
        "0": [
            483
        ]
    },
    "6a4188fd": {
        "0": [
            480
        ]
    },
    "7de581f4": {
        "0": [
            403
        ]
    },
    "7a723f68": {
        "0": [
            483
        ]
    },
    "4a984a6e": {
        "0": [
            346
        ]
    },
    "46d059a5": {
        "0": [
            560
        ]
    },
    "121b3daa": {
        "0": [
            483
        ]
    },
    "1f080de": {
        "0": [
            560
        ]
    },
    "4f210648": {
        "0": [
            483
        ]
    },
    "5e4b3854": {
        "0": [
            560
        ]
    },
    "1b430069": {
        "0": [
            560
        ]
    },
    "d9a9e7a": {
        "1": [
            81
        ]
    },
    "7870ca03": {
        "0": [
            560
        ]
    },
    "1c2afa68": {
        "0": [
            483
        ]
    },
    "874ebea": {
        "0": [
            483
        ]
    },
    "279ae465": {
        "0": [
            426
        ]
    },
    "387b0363": {
        "0": [
            480
        ]
    },
    "54d4fb7e": {
        "0": [
            480
        ]
    },
    "47625dcc": {
        "0": [
            483
        ]
    },
    "aaafff2": {
        "0": [
            480
        ]
    },
    "7cf673a1": {
        "0": [
            403
        ]
    },
    "214a37f2": {
        "0": [
            483
        ]
    },
    "176d89": {
        "0": [
            483
        ]
    },
    "5bb527e5": {
        "0": [
            560
        ]
    },
    "7e305d77": {
        "0": [
            483
        ]
    },
    "24b571de": {
        "0": [
            560
        ]
    },
    "349d85c": {
        "0": [
            560
        ]
    },
    "1e28948e": {
        "0": [
            483
        ]
    },
    "77f99d8c": {
        "0": [
            483
        ]
    },
    "1d22fab9": {
        "0": [
            483
        ]
    },
    "66b7b047": {
        "0": [
            560
        ]
    },
    "69137c0c": {
        "0": [
            483
        ]
    },
    "64ba2cf": {
        "0": [
            560
        ]
    },
    "5ea93374": {
        "0": [
            560
        ]
    },
    "73cd250f": {
        "0": [
            560
        ]
    },
    "541c445b": {
        "0": [
            560
        ]
    },
    "77cf4801": {
        "0": [
            560
        ]
    },
    "4a75a297": {
        "0": [
            560
        ]
    },
    "7508adde": {
        "0": [
            560
        ]
    },
    "5c2976f6": {
        "0": [
            544
        ]
    },
    "c57": {
        "1": [
            18
        ]
    },
    "2ef292e8": {
        "0": [
            483
        ]
    },
    "7e289626": {
        "0": [
            560
        ]
    },
    "1e93058b": {
        "0": [
            560
        ]
    },
    "6a24009c": {
        "0": [
            560
        ]
    },
    "66bb8993": {
        "0": [
            346
        ]
    },
    "103a1fe": {
        "1": [
            6
        ]
    },
    "427dbe29": {
        "0": [
            560
        ]
    },
    "183b7af": {
        "0": [
            483
        ]
    },
    "14e62ed6": {
        "0": [
            480
        ]
    },
    "1d13abb5": {
        "0": [
            560
        ]
    },
    "5ae7727a": {
        "0": [
            483
        ]
    },
    "2455afbd": {
        "0": [
            483
        ]
    },
    "748acd63": {
        "0": [
            560
        ]
    },
    "364a515": {
        "0": [
            560
        ]
    },
    "5f65db26": {
        "0": [
            560
        ]
    },
    "7683d868": {
        "0": [
            483
        ]
    },
    "5c43eb60": {
        "0": [
            560
        ]
    },
    "2e91557a": {
        "0": [
            560
        ]
    },
    "3a546568": {
        "0": [
            560
        ]
    },
    "41ba45c3": {
        "0": [
            560
        ]
    },
    "6f3aa0a9": {
        "0": [
            560
        ]
    },
    "76a08104": {
        "0": [
            560
        ]
    },
    "1713e035": {
        "0": [
            560
        ]
    },
    "2e9dd687": {
        "0": [
            560
        ]
    },
    "638411c8": {
        "0": [
            560
        ]
    },
    "2a304f71": {
        "0": [
            560
        ]
    },
    "540c2e47": {
        "0": [
            560
        ]
    },
    "2ffd9639": {
        "0": [
            483
        ]
    },
    "57bf2492": {
        "0": [
            483
        ]
    },
    "78fe1608": {
        "0": [
            480
        ]
    },
    "45cab512": {
        "0": [
            560
        ]
    },
    "5dc578cc": {
        "0": [
            483
        ]
    },
    "453543f0": {
        "0": [
            560
        ]
    },
    "53f1fc4f": {
        "0": [
            560
        ]
    },
    "6743142b": {
        "0": [
            412
        ]
    },
    "7cddd20a": {
        "0": [
            560
        ]
    },
    "3d169694": {
        "0": [
            560
        ]
    },
    "16ea7a45": {
        "0": [
            483
        ]
    },
    "6ecec822": {
        "0": [
            488
        ]
    },
    "56dadb58": {
        "0": [
            483
        ]
    },
    "5f2ffd57": {
        "0": [
            483
        ]
    },
    "550d7867": {
        "0": [
            560
        ]
    },
    "d75bb7f": {
        "0": [
            483
        ]
    },
    "5ace913": {
        "0": [
            560
        ]
    },
    "4e314396": {
        "0": [
            560
        ]
    },
    "48a4ff80": {
        "0": [
            560
        ]
    },
    "7e98da4c": {
        "0": [
            560
        ]
    },
    "6da48067": {
        "0": [
            441
        ]
    },
    "2ea068be": {
        "0": [
            296
        ]
    },
    "3a10e792": {
        "0": [
            282
        ]
    },
    "1e930d69": {
        "0": [
            374
        ]
    },
    "818511a": {
        "0": [
            483
        ]
    },
    "42c166f1": {
        "0": [
            560
        ]
    },
    "149f7ebf": {
        "0": [
            560
        ]
    },
    "65d86d67": {
        "0": [
            560
        ]
    },
    "1a84df99": {
        "0": [
            560
        ]
    },
    "21bb67bc": {
        "0": [
            483
        ]
    },
    "68024f27": {
        "0": [
            560
        ]
    },
    "7eb0a283": {
        "0": [
            560
        ]
    },
    "4de9301d": {
        "0": [
            560
        ]
    },
    "503f335d": {
        "0": [
            560
        ]
    },
    "77299c30": {
        "0": [
            483
        ]
    },
    "7bba294": {
        "0": [
            483
        ]
    },
    "12a1a1ff": {
        "0": [
            483
        ]
    },
    "5ba0692b": {
        "1": [
            77
        ]
    },
    "6fe5da26": {
        "0": [
            488
        ]
    },
    "597942c2": {
        "0": [
            560
        ]
    },
    "6dbf4f8b": {
        "0": [
            560
        ]
    },
    "1f8838df": {
        "0": [
            480
        ]
    },
    "2189506c": {
        "0": [
            483
        ]
    },
    "38ee312d": {
        "0": [
            488
        ]
    },
    "3a00ea11": {
        "0": [
            488
        ]
    },
    "3c3811eb": {
        "0": [
            560
        ]
    },
    "1cac7664": {
        "0": [
            387
        ]
    },
    "24c29d80": {
        "0": [
            480
        ]
    },
    "2036cd9e": {
        "0": [
            488
        ]
    },
    "9fc9ac5": {
        "0": [
            404
        ]
    },
    "2319a5c4": {
        "0": [
            404
        ]
    },
    "58ca52c5": {
        "0": [
            480
        ]
    },
    "405fb966": {
        "0": [
            488
        ]
    },
    "54c3dc62": {
        "0": [
            560
        ]
    },
    "715b1489": {
        "0": [
            403
        ]
    },
    "27464eef": {
        "0": [
            560
        ]
    },
    "40e57376": {
        "0": [
            403
        ]
    },
    "3a692a31": {
        "0": [
            403
        ]
    },
    "2cf03a3e": {
        "0": [
            488
        ]
    },
    "59ebfb28": {
        "0": [
            560
        ]
    },
    "78b647a1": {
        "0": [
            403
        ]
    },
    "204ef60a": {
        "0": [
            488
        ]
    },
    "8bf95bc": {
        "0": [
            416
        ]
    },
    "64d6c14b": {
        "0": [
            480
        ]
    },
    "623939bf": {
        "0": [
            480
        ]
    },
    "2dc77a41": {
        "0": [
            488
        ]
    },
    "3b86812d": {
        "0": [
            480
        ]
    },
    "3aff0cc7": {
        "0": [
            374
        ]
    },
    "2cbbe6fc": {
        "0": [
            488
        ]
    },
    "504d5904": {
        "0": [
            480
        ]
    },
    "42d74a2d": {
        "0": [
            483
        ]
    },
    "7ffd5f97": {
        "0": [
            480
        ]
    },
    "738ce3d8": {
        "0": [
            480
        ]
    },
    "7cf63377": {
        "0": [
            480
        ]
    },
    "10801d54": {
        "0": [
            483
        ]
    },
    "6881e71d": {
        "0": [
            480
        ]
    },
    "24b5e682": {
        "0": [
            488
        ]
    },
    "47cb72d8": {
        "0": [
            488
        ]
    },
    "5f087002": {
        "0": [
            488
        ]
    },
    "4656c8c1": {
        "0": [
            480
        ]
    },
    "64a88ffd": {
        "0": [
            488
        ]
    },
    "5d1302f4": {
        "0": [
            480
        ]
    },
    "560373af": {
        "0": [
            488
        ]
    },
    "506d104e": {
        "0": [
            404
        ]
    },
    "bf94bc0": {
        "0": [
            480
        ]
    },
    "75f4bb6e": {
        "0": [
            480
        ]
    },
    "79ac14b4": {
        "0": [
            448
        ]
    },
    "363bf080": {
        "0": [
            480,
            488
        ]
    },
    "2cefa352": {
        "0": [
            387
        ]
    },
    "25bb7472": {
        "0": [
            259
        ]
    },
    "35c50704": {
        "0": [
            488
        ]
    },
    "255646e": {
        "0": [
            488
        ]
    },
    "64914e2b": {
        "0": [
            346
        ]
    },
    "58d504b4": {
        "0": [
            480
        ]
    },
    "34f47574": {
        "0": [
            488
        ]
    },
    "44080f3a": {
        "0": [
            403
        ]
    },
    "7cf770ef": {
        "0": [
            488
        ]
    },
    "22daea4c": {
        "0": [
            488
        ]
    },
    "3e6970b5": {
        "0": [
            488
        ]
    },
    "78c630d2": {
        "0": [
            560
        ]
    },
    "70a5e752": {
        "0": [
            404
        ]
    },
    "759ca0a0": {
        "0": [
            488
        ]
    },
    "5f7e116c": {
        "0": [
            421
        ]
    },
    "4a24baf1": {
        "0": [
            494
        ]
    },
    "4a3452c9": {
        "1": [
            81
        ]
    },
    "af7a0fd": {
        "0": [
            288
        ]
    },
    "18a557bb": {
        "0": [
            483
        ]
    },
    "7547fd1f": {
        "0": [
            403
        ]
    },
    "2ac3300a": {
        "1": [
            177
        ]
    },
    "388dacc5": {
        "0": [
            488
        ]
    },
    "1a787c04": {
        "0": [
            467
        ]
    },
    "1667a5ed": {
        "0": [
            404
        ]
    },
    "51bdda56": {
        "1": [
            20
        ]
    },
    "331cc1f1": {
        "0": [
            404
        ]
    },
    "1cd70b7f": {
        "0": [
            560
        ]
    },
    "359b116c": {
        "0": [
            560
        ]
    },
    "6c329fc9": {
        "1": [
            245
        ]
    },
    "4627a07f": {
        "1": [
            245
        ]
    },
    "74416f82": {
        "1": [
            245
        ]
    },
    "5b41fa8": {
        "1": [
            245
        ]
    },
    "4a0b70c0": {
        "1": [
            245
        ]
    },
    "65c6c48e": {
        "1": [
            245
        ]
    },
    "32b41c8e": {
        "1": [
            158
        ]
    },
    "6fa07d3": {
        "1": [
            157
        ]
    },
    "14aa59ec": {
        "0": [
            346
        ]
    },
    "1e99b528": {
        "0": [
            346
        ]
    },
    "ae73616": {
        "1": [
            245
        ]
    },
    "6b006c2d": {
        "0": [
            371
        ]
    },
    "4a5c1f16": {
        "1": [
            539
        ]
    },
    "d541d24": {
        "1": [
            30
        ]
    },
    "41ccd5ac": {
        "0": [
            404
        ]
    },
    "cdf4ee0": {
        "0": [
            480
        ]
    },
    "49bb5d46": {
        "1": [
            558
        ]
    },
    "6b0035d7": {
        "0": [
            118
        ]
    },
    "473d9724": {
        "0": [
            401
        ]
    },
    "2a4c125b": {
        "0": [
            488
        ]
    },
    "52839cfe": {
        "0": [
            401
        ]
    },
    "2281c213": {
        "1": [
            77
        ]
    },
    "344192af": {
        "0": [
            488
        ]
    },
    "2faf473d": {
        "0": [
            445
        ]
    },
    "3d815a23": {
        "0": [
            560
        ]
    },
    "4fb9575e": {
        "0": [
            560
        ]
    },
    "3a95f0b2": {
        "0": [
            560
        ]
    },
    "55e7d1da": {
        "0": [
            346
        ]
    },
    "44b499f9": {
        "0": [
            560
        ]
    },
    "2497f5fc": {
        "0": [
            560
        ]
    },
    "5a65d2d9": {
        "0": [
            480
        ]
    },
    "30f0d939": {
        "0": [
            488
        ]
    },
    "786b91cc": {
        "0": [
            346
        ]
    },
    "6ccbec6e": {
        "0": [
            480
        ]
    },
    "61670d3b": {
        "0": [
            480
        ]
    },
    "276cda9c": {
        "0": [
            488
        ]
    },
    "5f4a9017": {
        "0": [
            560
        ]
    },
    "3d8531c8": {
        "0": [
            560
        ]
    },
    "6570aa8c": {
        "0": [
            454
        ]
    },
    "60f2ebb4": {
        "0": [
            454
        ]
    },
    "13b75ed1": {
        "0": [
            454
        ]
    },
    "6bd343f": {
        "0": [
            488
        ]
    },
    "6c0a871e": {
        "0": [
            488
        ]
    },
    "42a57ca9": {
        "0": [
            488
        ]
    },
    "23a50fc4": {
        "0": [
            488
        ]
    },
    "3090d17c": {
        "0": [
            560
        ]
    },
    "1d6c76e5": {
        "0": [
            560
        ]
    },
    "1c7063fd": {
        "0": [
            488
        ]
    },
    "f873517": {
        "0": [
            560
        ]
    },
    "1754bd61": {
        "0": [
            488
        ]
    },
    "140a096e": {
        "0": [
            488
        ]
    },
    "37e85488": {
        "0": [
            488
        ]
    },
    "1791b69f": {
        "0": [
            488
        ]
    },
    "2db5e315": {
        "0": [
            560
        ]
    },
    "6a3769f7": {
        "0": [
            488
        ]
    },
    "13b5c5ea": {
        "0": [
            560
        ]
    },
    "36a4a4d4": {
        "0": [
            560
        ]
    },
    "3cd402f8": {
        "0": [
            483
        ]
    },
    "3408c110": {
        "0": [
            346
        ]
    },
    "659a792f": {
        "1": [
            9
        ]
    },
    "62ab92bb": {
        "0": [
            488
        ]
    },
    "354785c5": {
        "0": [
            560
        ]
    },
    "729370e8": {
        "0": [
            560
        ]
    },
    "749fdd7f": {
        "0": [
            560
        ]
    },
    "24e2339c": {
        "0": [
            488
        ]
    },
    "64b77653": {
        "0": [
            488
        ]
    },
    "1d1c912e": {
        "0": [
            488
        ]
    },
    "1fb162e0": {
        "0": [
            488
        ]
    },
    "5a49e340": {
        "0": [
            488
        ]
    },
    "3d7892df": {
        "0": [
            560
        ]
    },
    "32469d37": {
        "0": [
            480
        ]
    },
    "b51a391": {
        "0": [
            293
        ]
    },
    "6b70819e": {
        "0": [
            568
        ]
    },
    "1eeb931f": {
        "0": [
            489
        ]
    },
    "4a34893b": {
        "0": [
            560
        ]
    },
    "61341f8d": {
        "0": [
            488
        ]
    },
    "431aabb5": {
        "0": [
            488
        ]
    },
    "6509df06": {
        "0": [
            560
        ]
    },
    "28c1f7ca": {
        "0": [
            560
        ]
    },
    "2dad181e": {
        "0": [
            560
        ]
    },
    "48c918c5": {
        "0": [
            560
        ]
    },
    "99b56c9": {
        "0": [
            346
        ]
    },
    "624169d1": {
        "0": [
            560
        ]
    },
    "4f3b4a5c": {
        "0": [
            346
        ]
    },
    "5e6a182c": {
        "0": [
            560
        ]
    },
    "5b2ef68a": {
        "0": [
            488
        ]
    },
    "394ca6ea": {
        "0": [
            431
        ]
    },
    "70db8139": {
        "0": [
            488
        ]
    },
    "21ff0453": {
        "0": [
            488
        ]
    },
    "521cbcd0": {
        "0": [
            488
        ]
    },
    "78a1be2e": {
        "0": [
            488
        ]
    },
    "20598c4e": {
        "0": [
            387
        ]
    },
    "7f4ef52d": {
        "0": [
            387
        ]
    },
    "5ae87e18": {
        "0": [
            387
        ]
    },
    "4c11708f": {
        "0": [
            488
        ]
    },
    "14fb7ca2": {
        "0": [
            488
        ]
    },
    "523f48ad": {
        "0": [
            488
        ]
    },
    "27af26e6": {
        "0": [
            488
        ]
    },
    "4c23a712": {
        "0": [
            387
        ]
    },
    "d6bd243": {
        "0": [
            431
        ]
    },
    "69e92a95": {
        "0": [
            431
        ]
    },
    "3bace0ce": {
        "0": [
            387
        ]
    },
    "1991b89b": {
        "0": [
            480
        ]
    },
    "5c76679": {
        "0": [
            488
        ]
    },
    "4b3f0343": {
        "0": [
            387
        ]
    },
    "1b2ac236": {
        "0": [
            560
        ]
    },
    "23d81d7c": {
        "0": [
            560
        ]
    },
    "163cee5d": {
        "0": [
            488
        ]
    },
    "1ca23b2b": {
        "0": [
            560
        ]
    },
    "5a7e7448": {
        "0": [
            480
        ]
    },
    "2c5074eb": {
        "0": [
            488
        ]
    },
    "4eeab553": {
        "0": [
            346
        ]
    },
    "2a4933c2": {
        "0": [
            480
        ]
    },
    "659d8f3c": {
        "0": [
            560
        ]
    },
    "389324de": {
        "0": [
            560
        ]
    },
    "ab26eae": {
        "0": [
            346
        ]
    },
    "2c535327": {
        "0": [
            488
        ]
    },
    "46f48822": {
        "0": [
            488
        ]
    },
    "11fe209b": {
        "0": [
            560
        ]
    },
    "29c5ebad": {
        "0": [
            488
        ]
    },
    "4a75a151": {
        "0": [
            346
        ]
    },
    "4138b717": {
        "1": [
            84
        ]
    },
    "5fc702e6": {
        "0": [
            416
        ]
    },
    "845c027": {
        "0": [
            480
        ]
    },
    "730cc682": {
        "0": [
            488
        ]
    },
    "5dd48f27": {
        "0": [
            480
        ]
    },
    "d7bcf8d": {
        "0": [
            488
        ]
    },
    "1dcee2c9": {
        "0": [
            560
        ]
    },
    "4a8482cd": {
        "0": [
            488
        ]
    },
    "7aa4bfd0": {
        "0": [
            560
        ]
    },
    "792aa06d": {
        "0": [
            560
        ]
    },
    "2bc53284": {
        "0": [
            488
        ]
    },
    "26af3611": {
        "0": [
            488
        ]
    },
    "457f68e6": {
        "0": [
            488
        ]
    },
    "275ae267": {
        "0": [
            488
        ]
    },
    "d914372": {
        "0": [
            387
        ]
    },
    "36b624d1": {
        "0": [
            488
        ]
    },
    "470a6027": {
        "0": [
            488
        ]
    },
    "345d75ee": {
        "0": [
            480
        ]
    },
    "ef6fc3d": {
        "0": [
            488
        ]
    },
    "6ab27916": {
        "0": [
            480
        ]
    },
    "5c6cb178": {
        "0": [
            488
        ]
    },
    "6cb779c3": {
        "0": [
            488
        ]
    },
    "1d7b49e2": {
        "0": [
            488
        ]
    },
    "3ec58023": {
        "0": [
            488
        ]
    },
    "26da5519": {
        "0": [
            488
        ]
    },
    "7fc3e877": {
        "0": [
            488
        ]
    },
    "77110e01": {
        "0": [
            560
        ]
    },
    "39d0e567": {
        "0": [
            488
        ]
    },
    "5ba03bb5": {
        "0": [
            480
        ]
    },
    "27cb398a": {
        "0": [
            480
        ]
    },
    "3d91a702": {
        "0": [
            480
        ]
    },
    "4a1255ed": {
        "0": [
            560
        ]
    },
    "59f4c479": {
        "0": [
            488
        ]
    },
    "75f0e5df": {
        "0": [
            412
        ]
    },
    "7829fd55": {
        "1": [
            20
        ]
    },
    "70fa1108": {
        "0": [
            488
        ]
    },
    "78e41272": {
        "0": [
            488
        ]
    },
    "2f174afa": {
        "0": [
            488
        ]
    },
    "306114da": {
        "0": [
            488
        ]
    },
    "30f46f72": {
        "0": [
            404
        ]
    },
    "4c4e3ff5": {
        "0": [
            480
        ]
    },
    "40b960ea": {
        "0": [
            480
        ]
    },
    "2fb2707c": {
        "0": [
            263
        ]
    },
    "7d5c5237": {
        "0": [
            488
        ]
    },
    "737cae50": {
        "0": [
            488
        ]
    },
    "3974cad3": {
        "0": [
            480
        ]
    },
    "7716f4c3": {
        "0": [
            480
        ]
    },
    "2b3c47ba": {
        "0": [
            480
        ]
    },
    "228ee7c4": {
        "0": [
            488
        ]
    },
    "f458f13": {
        "1": [
            81
        ]
    },
    "70de08d8": {
        "0": [
            483
        ]
    },
    "b384817": {
        "0": [
            445
        ]
    },
    "77750e46": {
        "0": [
            483
        ]
    },
    "4169dad": {
        "0": [
            445
        ]
    },
    "41d2e3dc": {
        "0": [
            488
        ]
    },
    "79a29cd8": {
        "1": [
            77
        ]
    },
    "2f313a37": {
        "0": [
            476
        ]
    },
    "55cc1c21": {
        "0": [
            387
        ]
    },
    "3d7781ba": {
        "1": [
            81
        ]
    },
    "311ae3ef": {
        "1": [
            33
        ]
    },
    "6c4a14b9": {
        "1": [
            33
        ]
    },
    "32a38743": {
        "0": [
            426
        ]
    },
    "340c7831": {
        "0": [
            560
        ]
    },
    "34bb2fad": {
        "0": [
            346
        ]
    },
    "799c11a1": {
        "0": [
            416
        ]
    },
    "77070b15": {
        "0": [
            488
        ]
    },
    "2e327f6a": {
        "0": [
            480
        ]
    },
    "138ab454": {
        "0": [
            560
        ]
    },
    "2af7c7f6": {
        "0": [
            560
        ]
    },
    "22789fb1": {
        "0": [
            560
        ]
    },
    "7937ea02": {
        "0": [
            560
        ]
    },
    "5cfc32ce": {
        "0": [
            480
        ]
    },
    "51669cfb": {
        "0": [
            560
        ]
    },
    "6004d8c2": {
        "0": [
            488
        ]
    },
    "1c12b8d0": {
        "0": [
            488
        ]
    },
    "27eaee8d": {
        "0": [
            488
        ]
    },
    "6d5869b7": {
        "0": [
            488
        ]
    },
    "4ef43857": {
        "0": [
            488
        ]
    },
    "1078131e": {
        "0": [
            488
        ]
    },
    "1fec8ae": {
        "0": [
            346
        ]
    },
    "47f1212b": {
        "0": [
            560
        ]
    },
    "31252c3b": {
        "3": [
            6
        ]
    },
    "685014c8": {
        "1": [
            77
        ]
    },
    "47834d4a": {
        "0": [
            488
        ]
    },
    "30075a93": {
        "0": [
            569
        ]
    },
    "21e87592": {
        "0": [
            478
        ]
    },
    "3dc7413d": {
        "0": [
            478
        ]
    },
    "1c92c2c3": {
        "0": [
            485
        ]
    },
    "fb24fe8": {
        "0": [
            478
        ]
    },
    "3f24970": {
        "0": [
            480
        ]
    },
    "1d3fd2c7": {
        "0": [
            387
        ]
    },
    "91430e5": {
        "1": [
            186
        ]
    },
    "37fe4d7a": {
        "1": [
            186
        ]
    },
    "4fc897f8": {
        "0": [
            387
        ]
    },
    "5b4bebce": {
        "0": [
            387
        ]
    },
    "2f13469c": {
        "0": [
            387
        ]
    },
    "4824dc8f": {
        "0": [
            387
        ]
    },
    "23ce944a": {
        "0": [
            376,
            387
        ]
    },
    "4824dc8c": {
        "0": [
            387
        ]
    },
    "1598bd6c": {
        "0": [
            387
        ]
    },
    "7d64f9f8": {
        "0": [
            387
        ]
    },
    "564cafe8": {
        "0": [
            387
        ]
    },
    "7a398b6e": {
        "0": [
            186
        ]
    },
    "7b162a82": {
        "0": [
            186
        ]
    },
    "7ff3b4f3": {
        "0": [
            477
        ]
    },
    "3dfcd853": {
        "0": [
            387
        ]
    },
    "7f7bc347": {
        "0": [
            387
        ]
    },
    "2243b712": {
        "0": [
            387
        ]
    },
    "690e3bc5": {
        "0": [
            387
        ]
    },
    "1049f04d": {
        "0": [
            387
        ]
    },
    "399ac44": {
        "0": [
            387
        ]
    },
    "3c77d65f": {
        "0": [
            3
        ]
    },
    "5287336b": {
        "0": [
            477
        ]
    },
    "2c18abae": {
        "0": [
            477
        ]
    },
    "7b18aae0": {
        "0": [
            387
        ],
        "3": [
            41
        ]
    },
    "4733f984": {
        "0": [
            387
        ]
    },
    "46206cbf": {
        "0": [
            376
        ]
    },
    "20d967fc": {
        "0": [
            376
        ]
    },
    "79273ca7": {
        "0": [
            376
        ]
    },
    "fd0d12b": {
        "0": [
            376
        ]
    },
    "730d01e9": {
        "0": [
            82
        ]
    },
    "60e4515b": {
        "0": [
            82
        ]
    },
    "73ef3023": {
        "0": [
            186
        ]
    },
    "12c462b0": {
        "0": [
            488
        ]
    },
    "4d61fcde": {
        "1": [
            266
        ]
    },
    "9014f4e": {
        "0": [
            356
        ]
    },
    "55f65322": {
        "0": [
            488
        ]
    },
    "5856ab2c": {
        "0": [
            401
        ]
    },
    "737a0747": {
        "1": [
            39
        ]
    },
    "4b5b998b": {
        "0": [
            185
        ]
    },
    "57a8ff3a": {
        "0": [
            376
        ]
    },
    "49e1f6c4": {
        "0": [
            376
        ]
    },
    "707610ba": {
        "0": [
            376
        ]
    },
    "541bd165": {
        "0": [
            376
        ]
    },
    "438e5fc": {
        "0": [
            192
        ]
    },
    "5d5be1e1": {
        "0": [
            192
        ]
    },
    "31e529dc": {
        "0": [
            192
        ]
    },
    "53d330e0": {
        "0": [
            488
        ]
    },
    "75d8fd9a": {
        "0": [
            376
        ]
    },
    "22b7153a": {
        "0": [
            192
        ]
    },
    "879dc5e": {
        "0": [
            376
        ]
    },
    "1d06b5c5": {
        "0": [
            488
        ]
    },
    "2ba87c88": {
        "0": [
            186
        ]
    },
    "4e61ea89": {
        "0": [
            192
        ]
    },
    "22281af7": {
        "0": [
            376
        ]
    },
    "3ed5477d": {
        "0": [
            376
        ]
    },
    "240794d9": {
        "0": [
            376
        ]
    },
    "464b064": {
        "0": [
            376
        ]
    },
    "a7c97a1": {
        "0": [
            376
        ]
    },
    "d95328c": {
        "3": [
            22
        ]
    },
    "372264cd": {
        "3": [
            17
        ]
    },
    "51a64ed8": {
        "3": [
            17
        ]
    },
    "48c7e09b": {
        "0": [
            376
        ]
    },
    "b75a855": {
        "0": [
            376
        ]
    },
    "232253fa": {
        "0": [
            376
        ]
    },
    "39d3bac8": {
        "0": [
            186
        ]
    },
    "505828ca": {
        "0": [
            480
        ]
    },
    "8da01fd": {
        "0": [
            376
        ]
    },
    "789fc754": {
        "0": [
            192
        ]
    },
    "42daa64d": {
        "0": [
            376
        ]
    },
    "5e4dd513": {
        "0": [
            488
        ]
    },
    "3576bb01": {
        "0": [
            376
        ]
    },
    "353e36ad": {
        "0": [
            376
        ]
    },
    "428aff22": {
        "0": [
            488
        ]
    },
    "7c2a8e28": {
        "0": [
            560
        ]
    },
    "2590ec1f": {
        "0": [
            560
        ]
    },
    "8c6d065": {
        "0": [
            560
        ]
    },
    "19d8e45c": {
        "0": [
            560
        ]
    },
    "49e104aa": {
        "0": [
            560
        ]
    },
    "1c1e15a": {
        "0": [
            560
        ]
    },
    "58924a79": {
        "0": [
            488
        ]
    },
    "6025a80": {
        "0": [
            185
        ]
    },
    "87b893a": {
        "0": [
            477
        ]
    },
    "7356da8d": {
        "0": [
            477
        ]
    },
    "3e2d7def": {
        "0": [
            477
        ]
    },
    "1e3d2940": {
        "0": [
            488
        ]
    },
    "3e756d8": {
        "0": [
            488
        ]
    },
    "4e59269e": {
        "0": [
            488
        ]
    },
    "7f60e7ed": {
        "0": [
            488
        ]
    },
    "7f60e7eb": {
        "0": [
            488
        ]
    },
    "7439de14": {
        "0": [
            376
        ]
    },
    "11ee7aae": {
        "0": [
            488
        ]
    },
    "7b098617": {
        "0": [
            569
        ]
    },
    "5a7693c3": {
        "0": [
            488
        ]
    },
    "4c5e4a52": {
        "0": [
            478
        ]
    },
    "25d66f59": {
        "0": [
            478
        ]
    },
    "7a104527": {
        "0": [
            569
        ]
    },
    "8a4fb05": {
        "0": [
            387
        ]
    },
    "4993aa2c": {
        "0": [
            376
        ]
    },
    "473c1dce": {
        "0": [
            488
        ]
    },
    "f47daac": {
        "0": [
            387
        ]
    },
    "3fd83be1": {
        "0": [
            387
        ]
    },
    "61efeaf5": {
        "0": [
            387
        ]
    },
    "62f3cbef": {
        "0": [
            376
        ]
    },
    "78a81f1f": {
        "0": [
            376
        ]
    },
    "2bb3de3f": {
        "0": [
            569
        ]
    },
    "25ca2ebd": {
        "0": [
            486
        ]
    },
    "26a569f5": {
        "0": [
            486
        ]
    },
    "bed9b6b": {
        "0": [
            486
        ]
    },
    "1f2fc2f2": {
        "0": [
            486
        ]
    },
    "7aaa7434": {
        "0": [
            486
        ]
    },
    "349824af": {
        "0": [
            486
        ]
    },
    "707808f5": {
        "0": [
            486
        ]
    },
    "11ee7aac": {
        "0": [
            488
        ]
    },
    "44038a60": {
        "0": [
            376
        ]
    },
    "1da9b0ec": {
        "0": [
            376
        ]
    },
    "3c3c6bc7": {
        "0": [
            186
        ]
    },
    "191677e2": {
        "1": [
            559
        ]
    },
    "677fad7b": {
        "1": [
            559
        ]
    },
    "3598b2d4": {
        "1": [
            559
        ]
    },
    "36f20a12": {
        "1": [
            559
        ]
    },
    "f1cf1f8": {
        "1": [
            559
        ]
    },
    "5d812aaa": {
        "1": [
            559
        ]
    },
    "60e084c5": {
        "1": [
            559
        ]
    },
    "5b0529a2": {
        "1": [
            559
        ]
    },
    "28da3fff": {
        "1": [
            559
        ]
    },
    "26a13a0a": {
        "1": [
            559
        ]
    },
    "5f1f3db8": {
        "1": [
            559
        ]
    },
    "20e77aa2": {
        "0": [
            186
        ]
    },
    "6b92b8d4": {
        "0": [
            376
        ]
    },
    "44f57b45": {
        "0": [
            376
        ]
    },
    "37fedfbc": {
        "0": [
            376
        ]
    },
    "2c00615c": {
        "0": [
            376
        ]
    },
    "2c006161": {
        "0": [
            376
        ]
    },
    "1338117e": {
        "0": [
            376
        ]
    },
    "5505e5a": {
        "0": [
            480
        ]
    },
    "5b49c76f": {
        "0": [
            567
        ]
    },
    "4f8eca16": {
        "0": [
            569
        ]
    },
    "430cfcc1": {
        "0": [
            567
        ]
    },
    "72e6b970": {
        "0": [
            185
        ]
    },
    "8c5f86e": {
        "0": [
            192
        ]
    },
    "3f50e1a9": {
        "0": [
            376
        ]
    },
    "69fcdd9": {
        "0": [
            376
        ]
    },
    "70bb9642": {
        "0": [
            376
        ]
    },
    "b015356": {
        "0": [
            376
        ]
    },
    "6025a81": {
        "0": [
            185
        ]
    },
    "1a63ef17": {
        "0": [
            376
        ]
    },
    "1214d725": {
        "0": [
            488
        ]
    },
    "737475c4": {
        "0": [
            376
        ]
    },
    "3b5d5f74": {
        "0": [
            387
        ]
    },
    "9f9b7a1": {
        "0": [
            488
        ]
    },
    "4df74aa3": {
        "0": [
            376
        ]
    },
    "45d408c0": {
        "0": [
            376
        ]
    },
    "4d3444c8": {
        "0": [
            480
        ]
    },
    "17bed5e": {
        "0": [
            360
        ]
    },
    "2b9569d4": {
        "0": [
            359
        ]
    },
    "7c2acf99": {
        "0": [
            387
        ]
    },
    "34bd79a8": {
        "0": [
            533
        ]
    },
    "99c2795": {
        "0": [
            387
        ]
    },
    "7f1c7f3f": {
        "0": [
            360
        ]
    },
    "44d08d41": {
        "3": [
            6
        ]
    },
    "23e79872": {
        "3": [
            21
        ]
    },
    "5d72ca65": {
        "0": [
            376
        ]
    },
    "bdd23db": {
        "0": [
            387
        ]
    },
    "246bcf80": {
        "0": [
            387
        ]
    },
    "4382ba35": {
        "0": [
            387
        ]
    },
    "711292ac": {
        "0": [
            192
        ]
    },
    "ad267e9": {
        "0": [
            387
        ]
    },
    "3cc296ec": {
        "0": [
            387
        ]
    },
    "5136b404": {
        "0": [
            387
        ]
    },
    "7a065f2f": {
        "0": [
            412
        ]
    },
    "1b61b462": {
        "0": [
            488
        ]
    },
    "473e5fb5": {
        "0": [
            387
        ]
    },
    "7a423f52": {
        "0": [
            359
        ]
    },
    "14100ae3": {
        "0": [
            359
        ]
    },
    "3ce79839": {
        "0": [
            387
        ]
    },
    "597d2a86": {
        "0": [
            483
        ]
    },
    "17a8744c": {
        "0": [
            569
        ]
    },
    "4b7c69ed": {
        "0": [
            488
        ]
    },
    "420a2c2": {
        "0": [
            477
        ]
    },
    "12c411a2": {
        "0": [
            569
        ]
    },
    "1dcf4b28": {
        "0": [
            387
        ]
    },
    "64ea67cb": {
        "0": [
            359
        ]
    },
    "2358e8df": {
        "0": [
            387
        ]
    },
    "51f1f09": {
        "0": [
            488
        ]
    },
    "4c115529": {
        "0": [
            387
        ]
    },
    "7b327cda": {
        "0": [
            387
        ]
    },
    "526dc96b": {
        "0": [
            387
        ]
    },
    "2bb91813": {
        "0": [
            488
        ]
    },
    "4987a87c": {
        "0": [
            488
        ]
    },
    "17a29fb5": {
        "0": [
            488
        ]
    },
    "5776c771": {
        "0": [
            488
        ]
    },
    "203cdfb3": {
        "0": [
            480
        ]
    },
    "3e7375dd": {
        "0": [
            3
        ]
    },
    "1b20a242": {
        "0": [
            488
        ]
    },
    "6b9301ef": {
        "0": [
            387
        ]
    },
    "6e257023": {
        "0": [
            360
        ]
    },
    "2c9d7698": {
        "0": [
            360
        ]
    },
    "4c3e8e13": {
        "0": [
            360
        ]
    },
    "404ec948": {
        "0": [
            387
        ]
    },
    "6209b112": {
        "0": [
            387
        ]
    },
    "1db2a339": {
        "0": [
            387
        ]
    },
    "37b225bf": {
        "0": [
            387
        ]
    },
    "209d4ba4": {
        "0": [
            387
        ]
    },
    "4993a22e": {
        "0": [
            376
        ]
    },
    "4993a5ef": {
        "0": [
            376
        ]
    },
    "6e053dd9": {
        "0": [
            387
        ]
    },
    "148420b7": {
        "0": [
            387
        ]
    },
    "76da451b": {
        "0": [
            387
        ]
    },
    "6f18082d": {
        "0": [
            387
        ]
    },
    "de5f774": {
        "0": [
            387
        ]
    },
    "585d6a55": {
        "0": [
            387
        ]
    },
    "4b3b4037": {
        "0": [
            387
        ]
    },
    "220c354": {
        "0": [
            387
        ]
    },
    "191b181": {
        "0": [
            387
        ]
    },
    "6febc98e": {
        "0": [
            387
        ]
    },
    "598e9a7e": {
        "0": [
            387
        ]
    },
    "22029a6d": {
        "0": [
            387
        ]
    },
    "3f9df1b9": {
        "0": [
            387
        ]
    },
    "64cbd38f": {
        "0": [
            544
        ]
    },
    "60c59e6b": {
        "0": [
            387
        ]
    },
    "56678f0": {
        "0": [
            544
        ]
    },
    "690b032f": {
        "0": [
            480
        ]
    },
    "181144b3": {
        "0": [
            480
        ]
    },
    "cc27531": {
        "0": [
            488
        ]
    },
    "5b22e479": {
        "0": [
            404
        ]
    },
    "125e2062": {
        "0": [
            488
        ]
    },
    "6f817bd8": {
        "0": [
            480
        ]
    },
    "2a6bd938": {
        "0": [
            488
        ]
    },
    "394a75ac": {
        "0": [
            485
        ]
    },
    "4a4d2461": {
        "0": [
            488
        ]
    },
    "2baff5cf": {
        "0": [
            488
        ]
    },
    "7baabf37": {
        "0": [
            192
        ]
    },
    "7af7c576": {
        "0": [
            376
        ]
    },
    "2eb10690": {
        "0": [
            376
        ]
    },
    "188f0c48": {
        "0": [
            186
        ]
    },
    "349398e4": {
        "0": [
            376
        ]
    },
    "40210a29": {
        "0": [
            376
        ]
    },
    "363ea259": {
        "0": [
            186
        ]
    },
    "3ad9727c": {
        "0": [
            186
        ]
    },
    "52f4916": {
        "0": [
            376
        ]
    },
    "2074f618": {
        "0": [
            387
        ]
    },
    "742d3ac5": {
        "0": [
            376
        ]
    },
    "2dc6413c": {
        "0": [
            544
        ]
    },
    "19dc9e6e": {
        "0": [
            192
        ]
    },
    "523db43a": {
        "0": [
            192
        ]
    },
    "885431e": {
        "0": [
            192
        ]
    },
    "70668ea9": {
        "0": [
            192
        ]
    },
    "72b56242": {
        "0": [
            376
        ]
    },
    "512b716a": {
        "0": [
            376
        ]
    },
    "4ff1e9f2": {
        "0": [
            376
        ]
    },
    "6e9e4f69": {
        "0": [
            488
        ]
    },
    "677d219b": {
        "0": [
            488
        ]
    },
    "6e9e4f52": {
        "0": [
            488
        ]
    },
    "1b293647": {
        "0": [
            376
        ]
    },
    "7f9b8a91": {
        "0": [
            480
        ]
    },
    "4e5cc4f4": {
        "3": [
            42
        ]
    },
    "60be36e": {
        "0": [
            569
        ]
    },
    "51d7663c": {
        "0": [
            387
        ]
    },
    "82e0c07": {
        "0": [
            488
        ]
    },
    "60db7880": {
        "4": [
            2
        ]
    },
    "e0bc6d3": {
        "4": [
            7
        ]
    },
    "1b2da6ac": {
        "0": [
            458
        ]
    },
    "35eca178": {
        "0": [
            560
        ]
    },
    "9de91c2": {
        "0": [
            347
        ]
    },
    "7c2ec858": {
        "0": [
            336
        ]
    },
    "70e536df": {
        "0": [
            569
        ]
    },
    "6fe7f6d5": {
        "2": [
            62
        ]
    },
    "7f79bddd": {
        "0": [
            478
        ]
    },
    "347c9de9": {
        "0": [
            480
        ]
    },
    "54e3dd74": {
        "0": [
            416
        ]
    },
    "3f1d1e28": {
        "0": [
            416
        ]
    },
    "293bf45f": {
        "0": [
            488
        ]
    },
    "780356f4": {
        "0": [
            483
        ]
    },
    "51cbe47d": {
        "0": [
            488
        ]
    },
    "55f30ae": {
        "0": [
            488
        ]
    },
    "4b77dde1": {
        "0": [
            426
        ]
    },
    "1c8ce5e5": {
        "0": [
            431
        ]
    },
    "429bdf47": {
        "0": [
            96
        ]
    },
    "371ab823": {
        "0": [
            265
        ]
    },
    "98ec041": {
        "0": [
            96
        ]
    },
    "29571d94": {
        "0": [
            232
        ]
    }
};


const $401ef96fa6d346f1$var$CLIENT_TYPES_MAP = {};
$401ef96fa6d346f1$var$CLIENT_TYPES_MAP[$6b929fe91f6b6fc3$exports.BROWSER] = 0;
$401ef96fa6d346f1$var$CLIENT_TYPES_MAP[$6b929fe91f6b6fc3$exports.MOBILE_APP] = 1;
$401ef96fa6d346f1$var$CLIENT_TYPES_MAP[$6b929fe91f6b6fc3$exports.LIBRARY] = 2;
$401ef96fa6d346f1$var$CLIENT_TYPES_MAP[$6b929fe91f6b6fc3$exports.MEDIA_PLAYER] = 3;
$401ef96fa6d346f1$var$CLIENT_TYPES_MAP[$6b929fe91f6b6fc3$exports.FEED_READER] = 4;
$401ef96fa6d346f1$var$CLIENT_TYPES_MAP[$6b929fe91f6b6fc3$exports.PIM] = 5;
class $401ef96fa6d346f1$var$IndexerClient {
    /**
   * @param {string} userAgent
   * @param {string} type
   * @returns {null|array}
   */ static findClientRegexPositionsForUserAgent(userAgent, type) {
        let index = $401ef96fa6d346f1$var$CLIENT_TYPES_MAP[type];
        if (index === void 0) return null;
        let data = $47a1491670bab221$exports.splitUserAgent(userAgent);
        let positions = $abbb6e95ac5e086a$exports[data.hash];
        if (positions !== void 0 && positions[index] !== void 0) return positions[index];
        return null;
    }
}
$401ef96fa6d346f1$exports = $401ef96fa6d346f1$var$IndexerClient;


class $d036a7e08aaccad9$var$ClientAbstractParser extends $7bdad46458c9f578$exports {
    #clientIndexes = true;
    constructor(){
        super();
        this.collectionLength = 0;
        this.type = '';
    }
    get clientIndexes() {
        return this.#clientIndexes;
    }
    set clientIndexes(stage) {
        this.#clientIndexes = stage;
    }
    /**
   * @param {string} userAgent
   * @param {*} clientHintData
   * @returns {{name: (string|*), type: string, version: string}|null}
   */ parse(userAgent, clientHintData) {
        if (!userAgent) return null;
        userAgent = this.prepareUserAgent(userAgent);
        // scan indexes
        if (this.clientIndexes) {
            let result = this.parseUserAgentByPositions(userAgent);
            if (result !== null) return result;
        }
        // full scan
        for(let i = 0, l = this.collectionLength; i < l; i++){
            let result = this.parseUserAgentByPosition(userAgent, i);
            if (result !== null) return result;
        }
        return null;
    }
    parseUserAgentByPositions(userAgent) {
        const positions = $401ef96fa6d346f1$exports.findClientRegexPositionsForUserAgent(userAgent, String(this.type));
        if (positions !== null && positions.length) for(let i = 0, l = positions.length; i < l; i++){
            let result = this.parseUserAgentByPosition(userAgent, positions[i]);
            if (result !== null) return result;
        }
        return null;
    }
    /**
   * Inline parse userAgent by position collection
   *
   * @param {String} userAgent
   * @param {Number} position
   * @returns {{name: (string|*), type: string, version: string}|null}
   */ parseUserAgentByPosition(userAgent, position = 0) {
        let item = this.collection[position];
        if (item === void 0) return null;
        let regex = this.getBaseRegExp(item.regex);
        let match = regex.exec(userAgent);
        if (match !== null) return {
            type: String(this.type),
            name: this.buildByMatch(item.name, match),
            version: this.buildVersion(item.version, match)
        };
        return null;
    }
}
$d036a7e08aaccad9$exports = $d036a7e08aaccad9$var$ClientAbstractParser;


var $bce1a4c368b67d52$exports = {};


class $bce1a4c368b67d52$var$AppHints extends $7bdad46458c9f578$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("5dNRI"));
    }
    parse(clientHints) {
        if (!clientHints) return null;
        let appId = clientHints.app;
        if (!appId) return null;
        if (this.collection[appId] === void 0) return null;
        let name = this.collection[appId];
        return {
            name: String(name)
        };
    }
}
$bce1a4c368b67d52$exports = $bce1a4c368b67d52$var$AppHints;



const $5358240e24b4c7df$var$appHints = new $bce1a4c368b67d52$exports;

class $5358240e24b4c7df$var$MobileApp extends $d036a7e08aaccad9$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("7qznj"));
        this.collectionLength = this.collection.length;
        this.type = $6b929fe91f6b6fc3$exports.MOBILE_APP;
    }
    parseFromHashHintsApp(clientHints) {
        return $5358240e24b4c7df$var$appHints.parse(clientHints);
    }
    parseFromClientHints(clientHints) {
        const name = '';
        const version = '';
        return {
            name: name,
            version: version
        };
    }
    prepareParseResult(userAgent, data, hint, hash) {
        let name = '';
        let type = $6b929fe91f6b6fc3$exports.MOBILE_APP;
        let version = '';
        if (data) {
            name = data.name;
            version = data.version;
        }
        if (hash && name !== hash.name) {
            name = hash.name;
            version = '';
        }
        if (name === '') return null;
        return {
            name: String(name),
            type: String(type),
            version: String(version)
        };
    }
    /**
   * @param userAgent
   * @param clientHints
   * @returns {({name: string, type: string, version: string})|null}
   */ parse(userAgent, clientHints) {
        const hash = this.parseFromHashHintsApp(clientHints);
        const hint = this.parseFromClientHints(clientHints);
        const data = super.parse(userAgent, clientHints);
        return this.prepareParseResult(userAgent, data, hint, hash);
    }
}
$5358240e24b4c7df$exports = $5358240e24b4c7df$var$MobileApp;


var $80619a89b85c7ab3$exports = {};



class $80619a89b85c7ab3$var$MediaPlayer extends $d036a7e08aaccad9$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("jjVmX"));
        this.collectionLength = this.collection.length;
        this.type = $6b929fe91f6b6fc3$exports.MEDIA_PLAYER;
    }
    /**
   * @param {string} userAgent
   * @param clientHintsData
   * @returns {({name: (string|*), type: string, version: string} & {type: string})|null}
   */ parse(userAgent, clientHintsData) {
        let result = super.parse(userAgent, clientHintsData);
        if (result) {
            result = Object.assign(result, {
                type: $6b929fe91f6b6fc3$exports.MEDIA_PLAYER
            });
            return result;
        }
        return null;
    }
}
$80619a89b85c7ab3$exports = $80619a89b85c7ab3$var$MediaPlayer;


var $a522a30d1d8b49ce$exports = {};


var $45bcb04df39b7e68$exports = {};
// prettier-ignore
$45bcb04df39b7e68$exports = {
    'Android Browser': [
        'AN'
    ],
    'BlackBerry Browser': [
        'BB'
    ],
    'Baidu': [
        'BD',
        'BS',
        'H6'
    ],
    'Amiga': [
        'AV',
        'AW'
    ],
    'Chrome': [
        'CH',
        '2B',
        '7S',
        'A0',
        'AC',
        'A4',
        'AE',
        'AH',
        'AI',
        'AO',
        'AS',
        'BA',
        'BM',
        'BR',
        'C2',
        'C3',
        'C5',
        'C4',
        'C6',
        'CC',
        'CD',
        'CE',
        'CF',
        'CG',
        '1B',
        'CI',
        'CL',
        'CM',
        'CN',
        'CP',
        'CR',
        'CV',
        'CW',
        'DA',
        'DD',
        'DG',
        'DR',
        'EC',
        'EE',
        'EU',
        'EW',
        'FA',
        'FS',
        'GB',
        'GI',
        'H2',
        'HA',
        'HE',
        'HH',
        'HS',
        'I3',
        'IR',
        'JB',
        'KN',
        'KW',
        'LF',
        'LL',
        'LO',
        'M1',
        'MA',
        'MD',
        'MR',
        'MS',
        'MT',
        'MZ',
        'NM',
        'NR',
        'O0',
        'O2',
        'O3',
        'OC',
        'PB',
        'PT',
        'QU',
        'QW',
        'RM',
        'S4',
        'S6',
        'S8',
        'S9',
        'SB',
        'SG',
        'SS',
        'SU',
        'SV',
        'SW',
        'SY',
        'SZ',
        'T1',
        'TA',
        'TB',
        'TG',
        'TR',
        'TS',
        'TU',
        'TV',
        'UB',
        'UR',
        'VE',
        'VG',
        'VI',
        'VM',
        'WP',
        'WH',
        'XV',
        'YJ',
        'FH',
        'H8',
        'B1',
        'BO',
        'HB',
        'PC',
        'LA',
        'LT',
        'PD',
        'HR',
        'HU',
        'HP',
        'IO',
        'TP',
        'CJ',
        'HQ',
        'HI',
        'PN',
        'BW',
        'YO',
        'DC',
        'G8',
        'DT',
        'AP',
        'AK',
        'UI',
        'SD',
        'VN',
        '4S',
        '2S',
        'RF',
        'LR',
        'SQ',
        'BV',
        'L1',
        'F0',
        'KS',
        'V0',
        'C8',
        'AZ',
        'MM',
        'BT',
        'N0',
        'P0',
        'F3',
        'VS',
        'DU',
        'D0',
        'P1',
        'O4',
        '8S',
        'H3',
        'TE',
        'WB',
        'K1',
        'P2',
        'XO',
        'U0',
        'B0',
        'VA',
        'X0',
        'NX',
        'O5',
        'R1',
        'I1',
        'HO',
        'A5',
        'X1',
        '18',
        'B5',
        'B6',
        'TC',
        'A6',
        '2X',
        'F4',
        'YG',
        'WR',
        'NA',
        'DM',
        '1M',
        'A7',
        'XN',
        'XT',
        'XB',
        'W1',
        'HT',
        'B8',
        'F5',
        'B9',
        'WA',
        'T0',
        'HC',
        'O6',
        'P7',
        'LJ',
        'LC',
        'O7',
        'N2',
        'A8',
        'P8',
        'RB',
        '1W',
        'EV',
        'I9',
        'V4',
        'H4',
        '1T',
        'M5',
        '0S',
        '0C',
        'ZR',
        'D6',
        'F6',
        'RC',
        'WD',
        'P3',
        'FT',
        'A9',
        'X2',
        'N3',
        'GD',
        'O9',
        'Q3',
        'F7',
        'K2',
        'P5',
        'H5',
        'V3',
        'K3',
        'Q4',
        'G2',
        'R2',
        'WX',
        'XP',
        '3I',
        'BG',
        'R0',
        'JO',
        'OL',
        'GN',
        'W4',
        'QI',
        'E1',
        'RI',
        '8B',
        '5B',
        'K4',
        'WK',
        'T3',
        'K5',
        'MU',
        '9P',
        'K6',
        'VR',
        'N9',
        'M9',
        'F9',
        '0P',
        '0A',
        'JR',
        'D3',
        'TK',
        'BP',
        '2F',
        '2M',
        'K7',
        '1N',
        '8A',
        'H7',
        'X3',
        'T4',
        'X4',
        '5O',
        '8C',
        '3M',
        '6I',
        '2P',
        'PU',
        '7I',
        'X5',
        'AL',
        '3P',
        'W2',
        'ZB',
        'HN',
        'Q6',
        'Q7',
        'G0'
    ],
    'Firefox': [
        'FF',
        'BI',
        'BF',
        'BH',
        'BN',
        'C0',
        'CU',
        'EI',
        'F1',
        'FB',
        'FE',
        'AX',
        'FM',
        'FR',
        'FY',
        'I4',
        'IF',
        '8P',
        'IW',
        'LH',
        'LY',
        'MB',
        'MN',
        'MO',
        'MY',
        'OA',
        'OS',
        'PI',
        'PX',
        'QA',
        'S5',
        'SX',
        'TF',
        'TO',
        'WF',
        'ZV',
        'FP',
        'AD',
        '2I',
        'P9',
        'KJ',
        'WY',
        'VK',
        'W5',
        '7C',
        'N7',
        'W7'
    ],
    'Internet Explorer': [
        'IE',
        'CZ',
        'BZ',
        'IM',
        'PS',
        '3A',
        '4A',
        'RN',
        '2E'
    ],
    'Konqueror': [
        'KO'
    ],
    'NetFront': [
        'NF'
    ],
    'NetSurf': [
        'NE'
    ],
    'Nokia Browser': [
        'NB',
        'DO',
        'NO',
        'NV'
    ],
    'Opera': [
        'OP',
        'OG',
        'OH',
        'OI',
        'OM',
        'ON',
        'OO',
        'O1',
        'OX',
        'Y1'
    ],
    'Safari': [
        'SF',
        'S7',
        'MF',
        'SO',
        'PV'
    ],
    'Sailfish Browser': [
        'SA'
    ]
};


var $080a2fe2f6d503e1$exports = {};
class $080a2fe2f6d503e1$var$ArrayPath {
    /**
   * get key int or str
   * @param key
   * @returns {number|*}
   */ static getKey(key) {
        let intKey = parseInt(key);
        if (intKey.toString() === key) return intKey;
        return key;
    }
    /**
   * get value to object by path
   * @param obj
   * @param path
   * @param defaultValue
   * @returns {*}
   */ static get(obj, path, defaultValue) {
        if (typeof path === 'number') path = [
            path
        ];
        if (!path || path.length === 0) return obj;
        if (obj == null) return defaultValue;
        if (typeof path === 'string') return $080a2fe2f6d503e1$var$ArrayPath.get(obj, path.split('.'), defaultValue);
        let currentPath = $080a2fe2f6d503e1$var$ArrayPath.getKey(path[0]);
        let nextObj = obj[currentPath];
        if (nextObj === void 0) return defaultValue;
        if (path.length === 1) return nextObj;
        return $080a2fe2f6d503e1$var$ArrayPath.get(obj[currentPath], path.slice(1), defaultValue);
    }
    /**
   * set value to object by path
   * @param obj
   * @param path
   * @param value
   * @param doNotReplace
   * @returns {*}
   */ static set(obj, path, value, doNotReplace) {
        if (typeof path === 'number') path = [
            path
        ];
        if (!path || path.length === 0) return obj;
        if (typeof path === 'string') return $080a2fe2f6d503e1$var$ArrayPath.set(obj, path.split('.').map($080a2fe2f6d503e1$var$ArrayPath.getKey), value, doNotReplace);
        let currentPath = path[0];
        let currentValue = obj[currentPath] !== void 0 ? obj[currentPath] : void 0;
        if (path.length === 1) {
            if (currentValue === void 0 || !doNotReplace) obj[currentPath] = value;
            return currentValue;
        }
        if (currentValue === void 0) {
            if (typeof path[1] === 'number') obj[currentPath] = [];
            else obj[currentPath] = {};
        }
        return $080a2fe2f6d503e1$var$ArrayPath.set(obj[currentPath], path.slice(1), value, doNotReplace);
    }
}
$080a2fe2f6d503e1$exports = $080a2fe2f6d503e1$var$ArrayPath;



var $d84abbbfcb874689$exports = {};


class $d84abbbfcb874689$var$BrowserHints extends $7bdad46458c9f578$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("55zDA"));
    }
    parse(clientHints) {
        if (!clientHints) return null;
        let appId = clientHints.app;
        if (!appId) return null;
        if (this.collection[appId] === void 0) return null;
        let name = this.collection[appId];
        return {
            name: String(name)
        };
    }
}
$d84abbbfcb874689$exports = $d84abbbfcb874689$var$BrowserHints;



const $a522a30d1d8b49ce$var$BROWSER_SHORT = $47a1491670bab221$exports.revertObject((parcelRequire("7dXwq")));
const $a522a30d1d8b49ce$var$browserHints = new $d84abbbfcb874689$exports;
const $a522a30d1d8b49ce$var$CLIENTHINT_MAPPING = {
    'Chrome': [
        'Google Chrome'
    ],
    'Chrome Webview': [
        'Android WebView'
    ],
    'DuckDuckGo Privacy Browser': [
        'DuckDuckGo'
    ],
    'Edge WebView': [
        'Microsoft Edge WebView2'
    ],
    'Mi Browser': [
        'Miui Browser',
        'XiaoMiBrowser'
    ],
    'Microsoft Edge': [
        'Edge'
    ],
    'Norton Private Browser': [
        'Norton Secure Browser'
    ],
    'Vewd Browser': [
        'Vewd Core'
    ]
};
const $a522a30d1d8b49ce$var$BROWSERHINT_SKIP_VERSION = [
    'A0',
    'AL',
    'HP',
    'JR',
    'MU',
    'OM',
    'OP',
    'VR'
];
const $a522a30d1d8b49ce$var$compareBrandForClientHints = (brand)=>{
    for(let brandName in $a522a30d1d8b49ce$var$CLIENTHINT_MAPPING)for (let mapBrand of $a522a30d1d8b49ce$var$CLIENTHINT_MAPPING[brandName]){
        if (brand.toLowerCase() === mapBrand.toLowerCase()) return brandName;
    }
    return brand;
};


class $a522a30d1d8b49ce$var$Browser extends $d036a7e08aaccad9$exports {
    constructor(){
        super();
        this.engine_collection = (parcelRequire("aaVhi"));
        this.collection = (parcelRequire("bVQTI"));
        this.type = $6b929fe91f6b6fc3$exports.BROWSER;
        this.collectionLength = this.collection.length;
    }
    getCollectionBrowsers() {
        return $a522a30d1d8b49ce$var$BROWSER_SHORT;
    }
    getAvailableBrowsers() {
        return Object.keys(this.getCollectionBrowsers());
    }
    /**
   * Generates the result for the parse method
   *
   * @param {string} userAgent
   * @param {{}} data
   * @param {{}} hint
   * @param {{}} hash
   * @returns {null|ResultClient}
   */ prepareParseResult(userAgent, data, hint, hash) {
        let type = $6b929fe91f6b6fc3$exports.BROWSER;
        let name = '';
        let version = '';
        let engine = '';
        let engineVersion = '';
        let short = '';
        let family = '';
        // use client hints in favor of user agent data if possible
        if (hint && hint.name && hint.version) {
            name = hint.name;
            version = hint.version;
            short = hint.short_name;
            family = this.buildFamily(short);
            // If the version reported from the client hints is YYYY or YYYY.MM (e.g., 2022 or 2022.04),
            // then it is the Iridium browser
            // https://iridiumbrowser.de/news/
            if (/^202[0-4]/.test(version)) {
                name = 'Iridium';
                short = 'I1';
            }
            if (data) {
                // https://bbs.360.cn/thread-16096544-1-1.html
                if (/^15/.test(version) && /^114/.test(data.version)) {
                    name = '360 Secure Browser';
                    short = '3B';
                    engine = data.engine;
                    engineVersion = data.engine_version;
                }
                // If client hints report the following browsers, we use the version from useragent
                if (data.version && $a522a30d1d8b49ce$var$BROWSERHINT_SKIP_VERSION.indexOf(short) !== -1) version = data.version;
                if ('Vewd Browser' === name) {
                    engine = data.engine;
                    engineVersion = data.engine_version;
                }
                // If client hints report Chromium, but user agent detects a Chromium based browser, we favor this instead
                const hasChromeBased = ('Chromium' === name || 'Chrome Webview' === name) && data.name && [
                    'CR',
                    'CV',
                    'AN'
                ].indexOf(data.short_name) === -1;
                if (hasChromeBased) {
                    name = data.name;
                    short = data.short_name;
                    version = data.version;
                    family = this.buildFamily(short);
                }
                // Fix mobile browser names e.g. Chrome => Chrome Mobile
                if (name + ' Mobile' === data.name) {
                    name = data.name;
                    short = data.short_name;
                }
                // If user agent detects another browser, but the family matches, we use the detected engine from user agent
                if (name !== data.name && family === this.buildFamily(data.short_name)) {
                    engine = data.engine;
                    engineVersion = data.engine_version;
                }
                // If the browser name matches the client hints then browser engine overwrite
                if (name === data.name) {
                    engine = data.engine;
                    engineVersion = data.engine_version;
                }
                // In case the user agent reports a more detailed version, we try to use this instead
                if (data.version && data.version.indexOf(version) === 0 && $47a1491670bab221$exports.versionCompare(version, data.version) < 0) version = data.version;
            }
            // If DDG Private browser then set version empty string
            if ('DuckDuckGo Privacy Browser' === name) version = '';
            // In case client hints report a more detailed engine version, we try to use this instead
            if ('Blink' === engine && 'Iridium' !== name && $47a1491670bab221$exports.versionCompare(engineVersion, hint.version) < 0) engineVersion = hint.version;
        } else if (data !== null) {
            name = data.name;
            version = data.version;
            short = data.short_name;
            engine = data.engine;
            engineVersion = data.engine_version;
        }
        family = this.buildFamily(short);
        // is app id
        if (hash !== null && name !== hash.name) {
            name = hash.name;
            version = '';
            short = this.buildShortName(name);
            if (/Chrome\/.+ Safari\/537.36/.test(userAgent)) {
                engine = 'Blink';
                family = this.buildFamily(short) || 'Chrome';
                engineVersion = this.buildEngineVersion(userAgent, engine);
            }
        }
        // exclude Blink engine version for browsers
        if ('Blink' === engine && 'Flow Browser' === name) engineVersion = '';
        // the browser simulate ua for Android OS
        if ('Every Browser' === name) {
            family = 'Chrome';
            engine = 'Blink';
            engineVersion = '';
        }
        // This browser simulates user-agent of Firefox
        if ('TV-Browser Internet' === name && 'Gecko' === engine) {
            family = 'Chrome';
            engine = 'Blink';
            engineVersion = '';
        }
        // This browser correct family by browser engine
        if ([
            'Yaani Browser',
            'Wolvic'
        ].includes(name)) {
            if ('Blink' === engine) family = 'Chrome';
            if ('Gecko' === engine) family = 'Firefox';
        }
        if (name === '') return null;
        return {
            type: String(type),
            name: String(name),
            short_name: String(short),
            version: String(version),
            engine: String(engine),
            engine_version: String(engineVersion),
            family: String(family)
        };
    }
    /**
   * General method for parsing user-agent and client-hints
   *
   * @param {string} userAgent
   * @param {} clientHints
   * @returns {ResultClient|null}
   */ parse(userAgent, clientHints) {
        userAgent = this.prepareUserAgent(userAgent);
        const hash = this.parseFromHashHintsApp(clientHints);
        const hint = this.parseFromClientHints(clientHints);
        const data = this.parseFromUserAgent(userAgent, clientHints);
        return this.prepareParseResult(userAgent, data, hint, hash);
    }
    /**
   * Parses client-hints for getting the browser name from the application ID (clientHints.app)
   *
   * @param {ResultClientHints} clientHints
   * @return {{name: string}}
   */ parseFromHashHintsApp(clientHints) {
        return $a522a30d1d8b49ce$var$browserHints.parse(clientHints);
    }
    /**
   * Parses client-hints for getting browser name, version, short name
   *
   * @param {ResultClientHints} clientHints
   * @return {{name: string, short_name: string, version: string}}
   */ parseFromClientHints(clientHints) {
        let name = '';
        let short = '';
        let version = '';
        if (clientHints && clientHints.client) {
            const brands = $080a2fe2f6d503e1$exports.get(clientHints, 'client.brands', []);
            for (let brandItem of brands){
                let brand = $a522a30d1d8b49ce$var$compareBrandForClientHints(brandItem.brand);
                for(let browserName in this.getCollectionBrowsers()){
                    let shortName = this.getCollectionBrowsers()[browserName];
                    let found = $47a1491670bab221$exports.fuzzyCompare(`${brand}`, browserName) || $47a1491670bab221$exports.fuzzyCompare(`${brand} Browser`, browserName) || $47a1491670bab221$exports.fuzzyCompare(`${brand}`, browserName + ' Browser');
                    if (found) {
                        name = String(browserName);
                        short = String(shortName);
                        version = String(brandItem.version);
                        break;
                    }
                }
                // If we detected a brand, that is not chromium,
                // we will use it, otherwise we will look further
                if ('' !== name && 'Chromium' !== name && 'Microsoft Edge' !== name) break;
            }
            if (clientHints.client.version) version = String(clientHints.client.version);
        }
        return {
            name: name,
            short_name: short,
            version: this.buildVersion(version, [])
        };
    }
    /**
   * Inline parse userAgent by position collection
   *
   * @param {string} userAgent
   * @param {number} position
   * @return {{engine: *, name: string, short_name: *, engine_version: *, family: string, version: string}|null}
   */ parseUserAgentByPosition(userAgent, position = 0) {
        let item = this.collection[position];
        if (item === void 0) return null;
        let regex = this.getBaseRegExp(item.regex);
        let match = regex.exec(userAgent);
        if (match !== null) {
            let name = this.buildByMatch(item.name, match);
            name = this.buildName(name);
            let version = this.buildVersion(item.version, match);
            let short = this.buildShortName(name);
            let engine = this.buildEngine(item.engine !== void 0 ? item.engine : {}, version);
            if (engine === '') engine = this.parseEngine(userAgent);
            let engineVersion = this.buildEngineVersion(userAgent, engine);
            let family = this.buildFamily(short);
            return {
                name: name,
                short_name: String(short),
                version: version,
                engine: String(engine),
                engine_version: String(engineVersion),
                family: family
            };
        }
        return null;
    }
    parseFromUserAgent(userAgent) {
        if (!userAgent) return null;
        return super.parse(userAgent, {});
    }
    /**
   *  normalisation browser name from any case
   *
   * @param {string} name
   * @returns {string}
   */ buildName(name) {
        let result = name;
        let normalName = this.getCollectionBrowsers()[name];
        if (normalName === void 0) {
            let lname = name.toLowerCase();
            let browsers = this.getAvailableBrowsers();
            for(let i = 0, l = browsers.length; i < l; i++)if (lname === browsers[i].toLowerCase()) {
                result = browsers[i];
                break;
            }
        }
        return result;
    }
    /**
   * Get short code browser for full name browser
   *
   * @param {string} name
   * @return {string}
   */ buildShortName(name) {
        const UNKNOWN = 'UNK';
        let result = this.getCollectionBrowsers()[name];
        if (result !== void 0) return result;
        return UNKNOWN;
    }
    /**
   * Get browser family for short name browser
   *
   * @param {string} shortName
   * @returns {string}
   */ buildFamily(shortName) {
        for(let browserFamily in $45bcb04df39b7e68$exports){
            if (browserFamily && $45bcb04df39b7e68$exports[browserFamily] && $45bcb04df39b7e68$exports[browserFamily].indexOf(shortName) !== -1) return browserFamily;
        }
        return '';
    }
    /**
   * Get browser engine for engine name and versions
   *
   * @param {string} engine
   * @param {string} browserVersion
   * @return {string}
   */ buildEngine(engine, browserVersion) {
        let result = '';
        if (engine.hasOwnProperty('default') && engine.default !== '') result = engine.default;
        if (engine.hasOwnProperty('versions')) {
            let versions = Object.keys(engine.versions).sort($47a1491670bab221$exports.versionCompare);
            for(let i = 0, l = versions.length; i < l; i++)if (browserVersion !== '' && $47a1491670bab221$exports.versionCompare(browserVersion, versions[i]) >= 0) result = engine.versions[versions[i]];
        }
        return result;
    }
    /**
   * Get engine name for parser engines
   *
   * @param {string} userAgent
   * @returns {string}
   */ parseEngine(userAgent) {
        let result = '';
        for(let i = 0, l = this.engine_collection.length; i < l; i++){
            let item = this.engine_collection[i];
            let regex = this.getBaseRegExp(item.regex);
            let match = regex.exec(userAgent);
            if (match !== null) {
                result = item.name;
                break;
            }
        }
        return result;
    }
    /**
   * Get engine version for useragent and engine name
   *
   * @param {string} userAgent
   * @param {string} engine
   * @return {string}
   */ buildEngineVersion(userAgent, engine) {
        if (engine === '') return '';
        if (engine === 'Gecko' || engine === 'Clecko') {
            let pattern = '[ ](?:rv[: ])([0-9.]+)';
            let regexp = new RegExp(pattern, 'i');
            let match = regexp.exec(userAgent);
            if (match !== null && /(?:g|cl)ecko\/[0-9]{8,10}/i.test(userAgent)) return match[1];
        }
        let engineToken = '' + engine;
        if ('Blink' === engine) engineToken = 'Chr[o0]me|Chromium|Cronet';
        if ('LibWeb' === engine) engineToken = 'LibWeb\\+LibJs\\/';
        if ('Arachne' === engine) engineToken = 'Arachne\\/5\\.';
        let regexp = new RegExp('(?:' + engineToken + ')' + '\\s*[/_]?\\s*(((?=\\d+\\.\\d)\\d+[.\\d]*|\\d{1,7}(?=(?:\\D|$))))', 'i');
        let match = regexp.exec(userAgent);
        if (match !== null) return match[1];
        return '';
    }
}
$a522a30d1d8b49ce$exports = $a522a30d1d8b49ce$var$Browser;


var $edb256cd6a1e100f$exports = {};



class $edb256cd6a1e100f$var$Library extends $d036a7e08aaccad9$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("kMcQA"));
        this.collectionLength = this.collection.length;
        this.type = $6b929fe91f6b6fc3$exports.LIBRARY;
    }
    /**
   *
   * @param userAgent
   * @param clientHintsData
   * @returns {({name: (string|*), type: string, version: string} & {type: string})|null}
   */ parse(userAgent, clientHintsData) {
        let result = super.parse(userAgent, clientHintsData);
        if (result) {
            result = Object.assign(result, {
                type: $6b929fe91f6b6fc3$exports.LIBRARY
            });
            return result;
        }
        return null;
    }
}
$edb256cd6a1e100f$exports = $edb256cd6a1e100f$var$Library;


var $6d83baf9672b0a80$exports = {};



class $6d83baf9672b0a80$var$FeedReader extends $d036a7e08aaccad9$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("biKDk"));
        this.collectionLength = this.collection.length;
        this.type = $6b929fe91f6b6fc3$exports.FEED_READER;
    }
    /**
   *
   * @param userAgent
   * @param clientHintsData
   * @returns {({name: (string|*), type: string, version: string} & {type: string})|null}
   */ parse(userAgent, clientHintsData) {
        let result = super.parse(userAgent, clientHintsData);
        if (result) {
            result = Object.assign(result, {
                type: $6b929fe91f6b6fc3$exports.FEED_READER
            });
            return result;
        }
        return null;
    }
}
$6d83baf9672b0a80$exports = $6d83baf9672b0a80$var$FeedReader;


var $fcc94a58e0ae1264$exports = {};



class $fcc94a58e0ae1264$var$PIM extends $d036a7e08aaccad9$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("5Fe5h"));
        this.collectionLength = this.collection.length;
        this.type = $6b929fe91f6b6fc3$exports.PIM;
    }
    /**
   *
   * @param userAgent
   * @param clientHintsData
   * @returns {{name: (string|*), type: string, version: string} & {type: string}}
   */ parse(userAgent, clientHintsData) {
        let result = super.parse(userAgent, clientHintsData);
        if (result) {
            result = Object.assign(result, {
                type: $6b929fe91f6b6fc3$exports.PIM
            });
            return result;
        }
    }
}
$fcc94a58e0ae1264$exports = $fcc94a58e0ae1264$var$PIM;


var $4dc49b6f19c8e54b$exports = {};


var $825390c0848609c4$exports = {};
// prettier-ignore
$825390c0848609c4$exports = {
    'AIX': 'AIX',
    'AND': 'Android',
    'ADR': 'Android TV',
    'ALP': 'Alpine Linux',
    'AMZ': 'Amazon Linux',
    'AMG': 'AmigaOS',
    'ARM': 'Armadillo OS',
    'ARO': 'AROS',
    'ATV': 'tvOS',
    'ARL': 'Arch Linux',
    'AOS': 'AOSC OS',
    'ASP': 'ASPLinux',
    'AZU': 'Azure Linux',
    'BTR': 'BackTrack',
    'SBA': 'Bada',
    'BYI': 'Baidu Yi',
    'BEO': 'BeOS',
    'BLB': 'BlackBerry OS',
    'QNX': 'BlackBerry Tablet OS',
    'PAN': 'blackPanther OS',
    'BOS': 'Bliss OS',
    'BMP': 'Brew',
    'BSN': 'BrightSignOS',
    'CAI': "Caixa M\xe1gica",
    'CES': 'CentOS',
    'CST': 'CentOS Stream',
    'CLO': 'Clear Linux OS',
    'CLR': 'ClearOS Mobile',
    'COS': 'Chrome OS',
    'CRS': 'Chromium OS',
    'CHN': 'China OS',
    'COL': 'Coolita OS',
    'CYN': 'CyanogenMod',
    'DEB': 'Debian',
    'DEE': 'Deepin',
    'DFB': 'DragonFly',
    'DVK': 'DVKBuntu',
    'ELE': 'ElectroBSD',
    'EUL': 'EulerOS',
    'FED': 'Fedora',
    'FEN': 'Fenix',
    'FOS': 'Firefox OS',
    'FIR': 'Fire OS',
    'FOR': 'Foresight Linux',
    'FRE': 'Freebox',
    'BSD': 'FreeBSD',
    'FRI': 'FRITZ!OS',
    'FYD': 'FydeOS',
    'FUC': 'Fuchsia',
    'GNT': 'Gentoo',
    'GNX': 'GENIX',
    'GEO': 'GEOS',
    'GNS': 'gNewSense',
    'GRI': 'GridOS',
    'GTV': 'Google TV',
    'HPX': 'HP-UX',
    'HAI': 'Haiku OS',
    'IPA': 'iPadOS',
    'HAR': 'HarmonyOS',
    'HAS': 'HasCodingOS',
    'HEL': 'HELIX OS',
    'IRI': 'IRIX',
    'INF': 'Inferno',
    'JME': 'Java ME',
    'JOL': 'Joli OS',
    'KOS': 'KaiOS',
    'KAL': 'Kali',
    'KAN': 'Kanotix',
    'KIN': 'KIN OS',
    'KOL': 'KolibriOS',
    'KNO': 'Knoppix',
    'KTV': 'KreaTV',
    'KBT': 'Kubuntu',
    'LIN': 'GNU/Linux',
    'LEA': 'LeafOS',
    'LND': 'LindowsOS',
    'LNS': 'Linspire',
    'LEN': 'Lineage OS',
    'LIR': 'Liri OS',
    'LOO': 'Loongnix',
    'LBT': 'Lubuntu',
    'LOS': 'Lumin OS',
    'LUN': 'LuneOS',
    'VLN': 'VectorLinux',
    'MAC': 'Mac',
    'MAE': 'Maemo',
    'MAG': 'Mageia',
    'MDR': 'Mandriva',
    'SMG': 'MeeGo',
    'MET': 'Meta Horizon',
    'MCD': 'MocorDroid',
    'MON': 'moonOS',
    'EZX': 'Motorola EZX',
    'MIN': 'Mint',
    'MLD': 'MildWild',
    'MOR': 'MorphOS',
    'NBS': 'NetBSD',
    'MTK': 'MTK / Nucleus',
    'MRE': 'MRE',
    'NXT': 'NeXTSTEP',
    'NWS': 'NEWS-OS',
    'WII': 'Nintendo',
    'NDS': 'Nintendo Mobile',
    'NOV': 'Nova',
    'OS2': 'OS/2',
    'T64': 'OSF1',
    'OBS': 'OpenBSD',
    'OHS': 'OpenHarmony',
    'OVS': 'OpenVMS',
    'OVZ': 'OpenVZ',
    'OWR': 'OpenWrt',
    'OTV': 'Opera TV',
    'ORA': 'Oracle Linux',
    'ORD': 'Ordissimo',
    'PAR': 'Pardus',
    'PCL': 'PCLinuxOS',
    'PIC': 'PICO OS',
    'PLA': 'Plasma Mobile',
    'PSP': 'PlayStation Portable',
    'PS3': 'PlayStation',
    'PVE': 'Proxmox VE',
    'PUF': 'Puffin OS',
    'PUR': 'PureOS',
    'QTP': 'Qtopia',
    'PIO': 'Raspberry Pi OS',
    'RAS': 'Raspbian',
    'RHT': 'Red Hat',
    'RST': 'Red Star',
    'RED': 'RedOS',
    'REV': 'Revenge OS',
    'RIS': 'risingOS',
    'ROS': 'RISC OS',
    'ROC': 'Rocky Linux',
    'ROK': 'Roku OS',
    'RSO': 'Rosa',
    'ROU': 'RouterOS',
    'REM': 'Remix OS',
    'RRS': 'Resurrection Remix OS',
    'REX': 'REX',
    'RZD': 'RazoDroiD',
    'RXT': 'RTOS & Next',
    'SAB': 'Sabayon',
    'SSE': 'SUSE',
    'SAF': 'Sailfish OS',
    'SCI': 'Scientific Linux',
    'SEE': 'SeewoOS',
    'SER': 'SerenityOS',
    'SIR': 'Sirin OS',
    'SLW': 'Slackware',
    'SOS': 'Solaris',
    'SBL': 'Star-Blade OS',
    'SYL': 'Syllable',
    'SYM': 'Symbian',
    'SYS': 'Symbian OS',
    'S40': 'Symbian OS Series 40',
    'S60': 'Symbian OS Series 60',
    'SY3': 'Symbian^3',
    'TEN': 'TencentOS',
    'TDX': 'ThreadX',
    'TIZ': 'Tizen',
    'TIV': 'TiVo OS',
    'TOS': 'TmaxOS',
    'TUR': 'Turbolinux',
    'UBT': 'Ubuntu',
    'ULT': 'ULTRIX',
    'UOS': 'UOS',
    'VID': 'VIDAA',
    'VIZ': 'ViziOS',
    'WAS': 'watchOS',
    'WER': 'Wear OS',
    'WTV': 'WebTV',
    'WHS': 'Whale OS',
    'WIN': 'Windows',
    'WCE': 'Windows CE',
    'WIO': 'Windows IoT',
    'WMO': 'Windows Mobile',
    'WPH': 'Windows Phone',
    'WRT': 'Windows RT',
    'WPO': 'WoPhone',
    'XBX': 'Xbox',
    'XBT': 'Xubuntu',
    'YNS': 'YunOS',
    'ZEN': 'Zenwalk',
    'ZOR': 'ZorinOS',
    'IOS': 'iOS',
    'POS': 'palmOS',
    'WEB': 'Webian',
    'WOS': 'webOS'
};


var $b666eab1c5e24765$exports = {};
// prettier-ignore
$b666eab1c5e24765$exports = {
    'Android': [
        'AND',
        'CYN',
        'FIR',
        'REM',
        'RZD',
        'MLD',
        'MCD',
        'YNS',
        'GRI',
        'HAR',
        'ADR',
        'CLR',
        'BOS',
        'REV',
        'LEN',
        'SIR',
        'RRS',
        'WER',
        'PIC',
        'ARM',
        'HEL',
        'BYI',
        'RIS',
        'PUF',
        'LEA',
        'MET',
        'OHS'
    ],
    'AmigaOS': [
        'AMG',
        'MOR',
        'ARO'
    ],
    'BlackBerry': [
        'BLB',
        'QNX'
    ],
    'Brew': [
        'BMP'
    ],
    'BeOS': [
        'BEO',
        'HAI'
    ],
    'Chrome OS': [
        'COS',
        'CRS',
        'FYD',
        'SEE'
    ],
    'Firefox OS': [
        'FOS',
        'KOS'
    ],
    'Gaming Console': [
        'WII',
        'PS3'
    ],
    'Google TV': [
        'GTV'
    ],
    'IBM': [
        'OS2'
    ],
    'iOS': [
        'IOS',
        'ATV',
        'WAS',
        'IPA'
    ],
    'RISC OS': [
        'ROS'
    ],
    'GNU/Linux': [
        'LIN',
        'ARL',
        'DEB',
        'KNO',
        'MIN',
        'UBT',
        'KBT',
        'XBT',
        'LBT',
        'FED',
        'RHT',
        'VLN',
        'MDR',
        'GNT',
        'SAB',
        'SLW',
        'SSE',
        'CES',
        'BTR',
        'SAF',
        'ORD',
        'TOS',
        'RSO',
        'DEE',
        'FRE',
        'MAG',
        'FEN',
        'CAI',
        'PCL',
        'HAS',
        'LOS',
        'DVK',
        'ROK',
        'OWR',
        'OTV',
        'KTV',
        'PUR',
        'PLA',
        'FUC',
        'PAR',
        'FOR',
        'MON',
        'KAN',
        'ZEN',
        'LND',
        'LNS',
        'CHN',
        'AMZ',
        'TEN',
        'CST',
        'NOV',
        'ROU',
        'ZOR',
        'RED',
        'KAL',
        'ORA',
        'VID',
        'TIV',
        'BSN',
        'RAS',
        'UOS',
        'PIO',
        'FRI',
        'LIR',
        'WEB',
        'SER',
        'ASP',
        'AOS',
        'LOO',
        'EUL',
        'SCI',
        'ALP',
        'CLO',
        'ROC',
        'OVZ',
        'PVE',
        'RST',
        'EZX',
        'GNS',
        'JOL',
        'TUR',
        'QTP',
        'WPO',
        'PAN',
        'VIZ',
        'AZU',
        'COL'
    ],
    'Mac': [
        'MAC'
    ],
    'Mobile Gaming Console': [
        'PSP',
        'NDS',
        'XBX'
    ],
    'OpenVMS': [
        'OVS'
    ],
    'Real-time OS': [
        'MTK',
        'TDX',
        'MRE',
        'JME',
        'REX',
        'RXT',
        'KOL'
    ],
    'Other Mobile': [
        'WOS',
        'POS',
        'SBA',
        'TIZ',
        'SMG',
        'MAE',
        'LUN',
        'GEO'
    ],
    'Symbian': [
        'SYM',
        'SYS',
        'SY3',
        'S60',
        'S40'
    ],
    'Unix': [
        'SOS',
        'AIX',
        'HPX',
        'BSD',
        'NBS',
        'OBS',
        'DFB',
        'SYL',
        'IRI',
        'T64',
        'INF',
        'ELE',
        'GNX',
        'ULT',
        'NWS',
        'NXT',
        'SBL'
    ],
    'WebTV': [
        'WTV'
    ],
    'Windows': [
        'WIN'
    ],
    'Windows Mobile': [
        'WPH',
        'WMO',
        'WCE',
        'WRT',
        'WIO',
        'KIN'
    ],
    'Other Smart TV': [
        'WHS'
    ]
};


const $4dc49b6f19c8e54b$var$ANDROID_APP_LIST = [
    'com.hisense.odinbrowser',
    'com.seraphic.openinet.pre',
    'com.appssppa.idesktoppcbrowser',
    'every.browser.inc'
];
const $4dc49b6f19c8e54b$var$CLIENTHINT_MAPPING = {
    'GNU/Linux': [
        'Linux'
    ],
    'Mac': [
        'MacOS'
    ]
};
var $0e9d9e4237a1b5ea$exports = {};
// prettier-ignore
$0e9d9e4237a1b5ea$exports = {
    '11': '8',
    '10': '8',
    '9': '7',
    '7': '6',
    '5': '5',
    '4.4.3': '4.5.1',
    '4.4.2': '4',
    '4.2.2': '3',
    '4.0.3': '3',
    '4.0.2': '3',
    '4': '2',
    '2': '1'
};


var $41983a886db3d665$exports = {};
// prettier-ignore
$41983a886db3d665$exports = {
    '16': '23',
    '15': '22',
    '14': '21',
    '13': '20.0',
    '12.1': '19.1',
    '12': '19.0',
    '11': '18.0',
    '10': '17.0',
    '9': '16.0',
    '8.1.0': '15.1',
    '8.0.0': '15.0',
    '7.1.2': '14.1',
    '7.1.1': '14.1',
    '7.0': '14.0',
    '6.0.1': '13.0',
    '6.0': '13.0',
    '5.1.1': '12.1',
    '5.0.2': '12.0',
    '5.0': '12.0',
    '4.4.4': '11.0',
    '4.3': '10.2',
    '4.2.2': '10.1',
    '4.0.4': '9.1.0'
};


var $a7e0c1ba331caa66$exports = {};

var $2781f4e592a1ba1c$exports = {};
$2781f4e592a1ba1c$exports = {
    "54057834": [
        83
    ],
    "551cfc37": [
        4,
        42,
        56,
        59,
        66,
        67,
        75,
        78,
        81,
        90,
        92,
        93,
        95,
        96,
        97,
        100,
        104,
        105,
        106,
        107,
        108,
        110,
        112,
        113,
        115,
        117,
        118,
        119,
        120,
        122,
        123,
        124,
        130,
        131,
        312
    ],
    "21943e44": [
        1,
        4,
        11,
        49,
        50,
        55,
        56,
        75,
        110,
        159,
        162,
        163,
        170,
        172,
        173,
        182,
        185,
        268,
        290,
        292,
        296,
        297,
        298,
        301,
        302,
        312
    ],
    "506fa283": [
        14,
        83,
        84,
        85,
        86,
        87,
        114,
        135,
        188,
        191,
        195,
        197,
        201,
        203,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        213,
        215
    ],
    "66c62e22": [
        131,
        218,
        220,
        221,
        225,
        226,
        228,
        238,
        239,
        240,
        242,
        247,
        256,
        260,
        262,
        263,
        267
    ],
    "1b383910": [
        185
    ],
    "5506826f": [
        215
    ],
    "25489c00": [
        83
    ],
    "2694dcdb": [
        223
    ],
    "694380e": [
        78
    ],
    "657f4100": [
        187
    ],
    "64f9db97": [
        78
    ],
    "348c846b": [
        115,
        124
    ],
    "ce233bb": [
        114
    ],
    "144681d9": [
        223
    ]
};


class $a7e0c1ba331caa66$var$IndexerOs {
    /**
   * @param {string} userAgent
   * @returns {null|array}
   */ static findOsRegexPositionsForUserAgent(userAgent) {
        const data = $47a1491670bab221$exports.splitOsUserAgent(userAgent);
        const positions = $2781f4e592a1ba1c$exports[data.hash];
        return positions !== void 0 ? positions : null;
    }
}
$a7e0c1ba331caa66$exports = $a7e0c1ba331caa66$var$IndexerOs;


const $4dc49b6f19c8e54b$var$getVersionForMapping = (version, map)=>{
    const majorVersion = '' + version.split('.', 1)[0];
    if (map[version]) return map[version];
    if (map[majorVersion]) return map[majorVersion];
    return '';
};
const $4dc49b6f19c8e54b$var$compareOsForClientHints = (brand)=>{
    const lowerName = brand.toLowerCase();
    for(let mapName in $4dc49b6f19c8e54b$var$CLIENTHINT_MAPPING)for (let mapBrand of $4dc49b6f19c8e54b$var$CLIENTHINT_MAPPING[mapName]){
        if (lowerName === mapBrand.toLowerCase()) return mapName;
    }
    return brand;
};
function $4dc49b6f19c8e54b$var$comparePlatform(platform, bitness = '') {
    if (platform.indexOf('arm') !== -1) return 'ARM';
    if (platform.indexOf('loongarch64') !== -1) return 'LoongArch64';
    if (platform.indexOf('mips') !== -1) return 'MIPS';
    if (platform.indexOf('sh4') !== -1) return 'SuperH';
    if (platform.indexOf('sparc64') !== -1) return 'SPARC64';
    if (platform.indexOf('x64') !== -1 || platform.indexOf('x86') !== -1 && bitness === '64') return 'x64';
    if (platform.indexOf('x86') !== -1) return 'x86';
    return '';
}

class $4dc49b6f19c8e54b$var$OsAbstractParser extends $7bdad46458c9f578$exports {
    #osIndexes = false;
    get osIndexes() {
        return this.#osIndexes;
    }
    set osIndexes(stage) {
        this.#osIndexes = stage;
    }
    constructor(){
        super();
        this.collection = (parcelRequire("bqJQ3"));
    }
    /**
   * @param {string} name
   * @return {string}
   */ parseOsFamily(name) {
        for(let family in $b666eab1c5e24765$exports){
            if ($b666eab1c5e24765$exports[family].indexOf(name) !== -1) return String(family);
        }
        return '';
    }
    /**
   * Normalisation os name and get short code os
   *
   * @param name
   * @returns {{name: string, short: string}}
   */ getOsDataByName(name) {
        let short = 'UNK';
        let lname = String(name).toLowerCase();
        for(let key in $825390c0848609c4$exports)if (lname === String($825390c0848609c4$exports[key]).toLowerCase()) {
            name = $825390c0848609c4$exports[key];
            short = key;
            break;
        }
        return {
            name: name,
            short: short
        };
    }
    parseFromClientHints(hint) {
        if (!hint) return null;
        let name = '';
        let short = '';
        let version = '';
        let platform = '';
        let hintName = '';
        if (hint.os && hint.os.name) {
            platform = hint.os.platform;
            version = hint.os.version;
            hintName = hint.os.name;
            platform = $4dc49b6f19c8e54b$var$comparePlatform(platform.toLowerCase(), hint.os.bitness);
            hintName = $4dc49b6f19c8e54b$var$compareOsForClientHints(hintName);
            for(let osShort in $825390c0848609c4$exports){
                let osName = $825390c0848609c4$exports[osShort];
                if ($47a1491670bab221$exports.fuzzyCompare(hintName, osName)) {
                    name = String(osName);
                    short = String(osShort);
                    break;
                }
            }
        }
        if ('Windows' === name && '' !== version) {
            let majorVersion = ~~version.split('.', 1)[0];
            let minorVersion = ~~version.split('.', 2)[1];
            if (majorVersion === 0) {
                let minorVersionMapping = {
                    1: '7',
                    2: '8',
                    3: '8.1'
                };
                version = minorVersionMapping[minorVersion] ?? version;
            } else if (majorVersion > 0 && majorVersion < 11) version = '10';
            else if (majorVersion > 10) version = '11';
        }
        // On Windows, version 0.0.0 can be either 7, 8 or 8.1, so we return 0.0.0
        if ('Windows' !== name && '0.0.0' !== version && 0 === parseInt(version)) version = '';
        return {
            name: name,
            short_name: short,
            version: version,
            platform: platform
        };
    }
    parseUserAgentByPosition(userAgent, position) {
        let item = this.collection[position];
        let regex = this.getBaseRegExp(item.regex);
        let match = regex.exec(userAgent);
        if (match !== null) {
            let { name: name, short: short } = this.getOsDataByName(this.buildByMatch(item.name, match));
            let version = item.version !== void 0 ? this.buildVersion(item.version, match) : '';
            if (item.versions !== void 0) for (let versionItem of item.versions){
                let regex = this.getBaseRegExp(versionItem.regex);
                let match = regex.exec(userAgent);
                if (match !== null) {
                    version = this.buildVersion(versionItem.version, match);
                    break;
                }
            }
            return {
                name: name,
                short_name: short,
                version: version,
                platform: this.parsePlatform(userAgent),
                family: this.parseOsFamily(short)
            };
        }
        return null;
    }
    parseFromUserAgent(userAgent) {
        if (!userAgent) return null;
        if (this.osIndexes) {
            let positions = $a7e0c1ba331caa66$exports.findOsRegexPositionsForUserAgent(userAgent);
            if (positions !== null) for (let position of positions){
                let result = this.parseUserAgentByPosition(userAgent, position);
                if (result !== null) return result;
            }
        }
        for(let i = 0, l = this.collection.length; i < l; i++){
            let result = this.parseUserAgentByPosition(userAgent, i);
            if (result !== null) return result;
        }
        return null;
    }
    /**
   *
   * @param {string} userAgent
   * @param {ClientHintsResult} clientHints
   * @returns {null|{name: (string|*), short_name: string, family: string, version: string, platform: string}}
   */ parse(userAgent, clientHints) {
        let ua = $47a1491670bab221$exports.restoreUserAgentFromClientHints(this.prepareUserAgent(userAgent), clientHints);
        let hint = this.parseFromClientHints(clientHints);
        let data = this.parseFromUserAgent(ua);
        let name = '';
        let version = '';
        let platform = '';
        let short = '';
        let family = '';
        if (hint && hint.name) {
            name = hint.name;
            version = hint.version;
            platform = hint.platform;
            short = hint.short_name;
            // use version from user agent if non was provided in client hints, but os family from useragent matches
            if (data && '' === version && data && this.parseOsFamily(short) === data.family) version = data.version;
            // On Windows, version 0.0.0 can be either 7, 8 or 8.1
            if (data && 'Windows' === name && '0.0.0' === version) version = '10' === data.version ? '' : data.version;
            // If the OS name detected from client hints matches the OS family from user agent
            // but the os name is another, we use the one from user agent, as it might be more detailed
            if (data && data.family === name && data.name !== name) {
                name = data.name;
                if ('LeafOS' === name) {
                    version = '';
                    short = 'LEA';
                }
                if ('HarmonyOS' === name) {
                    version = '';
                    short = 'HAR';
                }
                if ('PICO OS' === name) {
                    version = data.version;
                    short = 'PIC';
                }
                if ('Fire OS' === name && '' !== hint.version) {
                    version = $4dc49b6f19c8e54b$var$getVersionForMapping(hint.version, $0e9d9e4237a1b5ea$exports);
                    short = 'FIR';
                }
            }
            // Chrome OS is in some cases reported as Linux in client hints, we fix this only if the version matches
            if (data && 'GNU/Linux' === name && 'Chrome OS' === data.name && hint.version === data.version) {
                name = data.name;
                short = data.short_name;
            }
            // Chrome OS is in some cases reported as Android in client hints
            if (data && 'Android' === name && 'Chrome OS' === data.name) {
                name = data.name;
                version = '';
                short = data.short_name;
            }
            // Meta Horizon is reported as Linux in client hints
            if (data && 'GNU/Linux' === name && 'Meta Horizon' === data.name) {
                name = data.name;
                short = data.short_name;
            }
        } else if (data) {
            name = data.name;
            version = data.version;
            short = data.short_name;
            platform = data.platform;
            family = data.family;
        }
        if (clientHints && data && clientHints.app) {
            if ($4dc49b6f19c8e54b$var$ANDROID_APP_LIST.indexOf(clientHints.app) !== -1 && 'Android' !== data.name) {
                name = 'Android';
                short = 'ADR';
                version = '';
            }
            if ('org.lineageos.jelly' === clientHints.app && 'Lineage OS' !== name) {
                name = 'Lineage OS';
                short = 'LEN';
                version = $4dc49b6f19c8e54b$var$getVersionForMapping(data.version, $41983a886db3d665$exports);
            }
            if ('org.mozilla.tv.firefox' === clientHints.app && 'Fire OS' !== name) {
                name = 'Fire OS';
                short = 'FIR';
                version = $4dc49b6f19c8e54b$var$getVersionForMapping(version, $0e9d9e4237a1b5ea$exports);
            }
        }
        if (platform === '' && data) platform = data.platform;
        if (name === '') return data;
        family = this.parseOsFamily(short);
        if (data === null || data.short_name !== short) short = this.getOsDataByName(name).short;
        return {
            name: String(name),
            version: String(version),
            short_name: String(short),
            platform: String(platform),
            family: String(family)
        };
    }
    /**
   * parse ua platform
   * @param {string} userAgent
   * @return {string}
   */ parsePlatform(userAgent) {
        if (this.getBaseRegExp('arm[ _;)ev]|.*arm$|.*arm64|aarch64|Apple ?TV|Watch ?OS|Watch1,[12]').test(userAgent)) return 'ARM';
        if (this.getBaseRegExp('loongarch64').test(userAgent)) return 'LoongArch64';
        if (this.getBaseRegExp('mips').test(userAgent)) return 'MIPS';
        if (this.getBaseRegExp('sh4').test(userAgent)) return 'SuperH';
        if (this.getBaseRegExp('sparc64').test(userAgent)) return 'SPARC64';
        if (this.getBaseRegExp('64-?bit|WOW64|(?:Intel)?x64|WINDOWS_64|win64|.*amd64|.*x86_?64').test(userAgent)) return 'x64';
        if (this.getBaseRegExp('.+32bit|.+win32|(?:i[0-9]|x)86|i86pc').test(userAgent)) return 'x86';
        return '';
    }
}
$4dc49b6f19c8e54b$exports = $4dc49b6f19c8e54b$var$OsAbstractParser;


var $6d3fc93af3cd0d3c$exports = {};


class $6d3fc93af3cd0d3c$var$BotAbstractParser extends $7bdad46458c9f578$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("gKnA4"));
    }
    /**
   * parse user agent is bot
   * @param {string} userAgent
   * @returns {{name: string, producer: {}, category: string, url: string}|null}
   */ parse(userAgent) {
        for(let i = 0, l = this.collection.length; i < l; i++){
            let item = this.collection[i];
            let regex = this.getBaseRegExp(item.regex);
            let match = regex.exec(userAgent);
            if (match !== null) {
                let producer = item.producer ? item.producer : {};
                if (producer.name === null) producer.name = '';
                return {
                    name: item.name ? item.name : '',
                    category: item.category ? item.category : '',
                    url: item.url ? item.url : '',
                    producer: producer
                };
            }
        }
        return null;
    }
}
$6d3fc93af3cd0d3c$exports = $6d3fc93af3cd0d3c$var$BotAbstractParser;


var $837d31c16149e6f6$exports = {};



const $837d31c16149e6f6$var$COLLECTION_BRAND_LIST = $47a1491670bab221$exports.revertObject((parcelRequire("gX8Np")));

class $837d31c16149e6f6$var$VendorFragmentAbstractParser extends $7bdad46458c9f578$exports {
    constructor(){
        super();
        this.collection = (parcelRequire("1SXpl"));
    }
    /**
   * @param {string} userAgent
   * @returns {ResultVendor|null}
   */ parse(userAgent) {
        for(let cursor in this.collection){
            let name = String(cursor);
            let collection = this.collection[name];
            for(let i = 0, l = collection.length; i < l; i++){
                let item = collection[i];
                let pattern = item + '[^a-z0-9]+';
                let regex = this.getBaseRegExp(pattern);
                let match = regex.exec(userAgent);
                if (match !== null) {
                    let brandId = $837d31c16149e6f6$var$COLLECTION_BRAND_LIST[name];
                    return {
                        name: name,
                        id: brandId !== void 0 ? brandId : ''
                    };
                }
            }
        }
        return null;
    }
}
$837d31c16149e6f6$exports = $837d31c16149e6f6$var$VendorFragmentAbstractParser;


var $63064923ad99e4d1$exports = {};



const $63064923ad99e4d1$var$COLLECTION_BRAND_LIST = $47a1491670bab221$exports.revertObject((parcelRequire("gX8Np")));
const $63064923ad99e4d1$var$createReplaceBrandRegexp = ()=>{
    let escapeeChars = [
        /\+/gi,
        /\./gi
    ];
    let replaceChars = [
        '\\+',
        '\\.'
    ];
    let customBrands = [
        'HUAWEI HUAWEI',
        'viv-vivo'
    ];
    let brands = customBrands.concat(Object.keys($63064923ad99e4d1$var$COLLECTION_BRAND_LIST)).join('|');
    for(let i = 0, l = escapeeChars.length; i < l; i++)brands = brands.replace(escapeeChars[i], replaceChars[i]);
    return new RegExp('(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(' + brands + ')[ _]', 'isg');
};
const $63064923ad99e4d1$var$normalizationUserAgent = (userAgent)=>{
    let rawUA = String(userAgent);
    if (/;ip(?:ad|hone): build\//i.test(rawUA) && /android /i.test(rawUA)) rawUA = rawUA.replace(/;ip(?:ad|hone):/i, '');
    return rawUA;
};
const $63064923ad99e4d1$var$REPLACE_BRAND_REGEXP = $63064923ad99e4d1$var$createReplaceBrandRegexp();

class $63064923ad99e4d1$var$AliasDevice extends $7bdad46458c9f578$exports {
    #replaceBrand = true;
    constructor(){
        super();
        this.collection = (parcelRequire("3psI7"));
    }
    /**
   * @return {boolean}
   */ hasReplaceBrand() {
        return Boolean(this.#replaceBrand);
    }
    /**
   * @param {boolean} replace
   */ setReplaceBrand(replace) {
        this.#replaceBrand = replace;
    }
    getBaseRegExp(str) {
        str = str.replace(new RegExp('/', 'g'), '\\/');
        str = str.replace(new RegExp('\\+\\+', 'g'), '+');
        str = '(?:' + str + ')';
        return new RegExp(str, 'i');
    }
    /**
   * @param {string} userAgent
   * @returns {{name: string}}
   */ parse(userAgent) {
        const result = {
            name: ''
        };
        if ($47a1491670bab221$exports.hasDesktopFragment(userAgent)) return result;
        userAgent = $63064923ad99e4d1$var$normalizationUserAgent(this.prepareUserAgent(userAgent));
        const isDecodeUA = /%[2-4][0-6A-F]/i.test(userAgent);
        let decodeUserAgent = '';
        try {
            decodeUserAgent = isDecodeUA ? decodeURIComponent(userAgent) : userAgent;
        } catch (err) {}
        for(let cursor in this.collection){
            const item = this.collection[cursor];
            const match = this.getBaseRegExp(item['regex']).exec(decodeUserAgent);
            if (match) {
                const name = this.buildByMatch(item['name'], match);
                if (name) result.name = name;
                if (this.hasReplaceBrand()) result.name = result.name.replace($63064923ad99e4d1$var$REPLACE_BRAND_REGEXP, '');
                break;
            }
        }
        if (result.name) result.name = result.name.trim();
        return result;
    }
}
$63064923ad99e4d1$exports = $63064923ad99e4d1$var$AliasDevice;



var $875ac1efa858937e$exports = {};
var $eaa86e5f68e1af25$exports = {};
$eaa86e5f68e1af25$exports = {
    "16": [
        "M1"
    ],
    "221": [
        "69"
    ],
    "710": [
        "NK"
    ],
    "721": [
        "69"
    ],
    "800": [
        "NK"
    ],
    "816": [
        "TP"
    ],
    "900": [
        "NK"
    ],
    "909": [
        "NK"
    ],
    "1201": [
        "OP"
    ],
    "1819": [
        "VV"
    ],
    "1825": [
        "CO"
    ],
    "2032": [
        "CO"
    ],
    "2039": [
        "CO"
    ],
    "5041": [
        "A9"
    ],
    "5058": [
        "A9"
    ],
    "5059": [
        "A9"
    ],
    "5061": [
        "A9"
    ],
    "5062": [
        "A9"
    ],
    "5202": [
        "A9"
    ],
    "5505": [
        "A9"
    ],
    "6002": [
        "A9"
    ],
    "6004": [
        "A9"
    ],
    "6201": [
        "A9"
    ],
    "6501": [
        "A9"
    ],
    "8051": [
        "AL"
    ],
    "8052": [
        "AL"
    ],
    "8054": [
        "AL"
    ],
    "8055": [
        "AL"
    ],
    "8056": [
        "AL"
    ],
    "8057": [
        "AL"
    ],
    "8063": [
        "AL"
    ],
    "8067": [
        "AL"
    ],
    "8068": [
        "AL"
    ],
    "8082": [
        "AL"
    ],
    "8084": [
        "AL"
    ],
    "8092": [
        "AL"
    ],
    "8095": [
        "TC"
    ],
    "8167": [
        "TC"
    ],
    "8182": [
        "TC"
    ],
    "8295": [
        "CO"
    ],
    "8950": [
        "TN"
    ],
    "9061": [
        "TC"
    ],
    "2013023": [
        "XI"
    ],
    "2014011": [
        "XI"
    ],
    "2014501": [
        "XI"
    ],
    "2014811": [
        "XI"
    ],
    "2014812": [
        "XI"
    ],
    "2014813": [
        "XI"
    ],
    "2014817": [
        "XI"
    ],
    "2014818": [
        "XI"
    ],
    "20190808": [
        "DV"
    ],
    "20200308": [
        "DV"
    ],
    "100003561": [
        "O4"
    ],
    "100003562": [
        "O4"
    ],
    "100005206": [
        "O4"
    ],
    "100005207": [
        "O4"
    ],
    "100005208": [
        "O4"
    ],
    "100005209": [
        "O4"
    ],
    "100011885": [
        "O4"
    ],
    "100011886": [
        "O4"
    ],
    "100026191": [
        "O4"
    ],
    "100043279": [
        "O4"
    ],
    "100071481": [
        "O4"
    ],
    "100071483": [
        "O4"
    ],
    "100071485": [
        "O4"
    ],
    "100071486": [
        "O4"
    ],
    "100110603": [
        "O4"
    ],
    "100135794": [
        "O4"
    ],
    "100135920": [
        "O4"
    ],
    "100135924": [
        "O4"
    ],
    "100135925": [
        "O4"
    ],
    "100146660": [
        "O4"
    ],
    "100146663": [
        "O4"
    ],
    "dmc-cm1": [
        "PA"
    ],
    "samsung ek-gn120": [
        "SA"
    ],
    "carpad-ii-p": [
        "NS"
    ],
    "carpad-iii-p": [
        "NS"
    ],
    "ultraocta-t8": [
        "A7"
    ],
    "kzcar": [
        "FC"
    ],
    "octa-core t8": [
        "A7"
    ],
    "octopus-core t8": [
        "A7"
    ],
    "quadcore-r16": [
        "A7"
    ],
    "quad-core t3 k2001o nwd": [
        "A7"
    ],
    "quad-core t3 k2001-nwd": [
        "A7"
    ],
    "f9212a": [
        "PI"
    ],
    "f9212b": [
        "PI"
    ],
    "ff-5000": [
        "XY"
    ],
    "mpc-70": [
        "5O"
    ],
    "polestar": [
        "7O"
    ],
    "mpc-50": [
        "5O"
    ],
    "mpc-65": [
        "5O"
    ],
    "mpc-110dsp": [
        "5O"
    ],
    "porsche rear seat entertainment": [
        "3F"
    ],
    "zq8003": [
        "XY"
    ],
    "quad-core t3 p1": [
        "A7"
    ],
    "825x_pro": [
        "XY"
    ],
    "sda-835tab": [
        "PI"
    ],
    "benz_hy1920x720": [
        "XY"
    ],
    "8227l_demo": [
        "XY"
    ],
    "quad-core t3 p3": [
        "A7"
    ],
    "sda-80tab": [
        "PI"
    ],
    "aivi-n3000rv": [
        "HX"
    ],
    "pro 8475": [
        "WBF"
    ],
    "roik10": [
        "ROI"
    ],
    "vc8300": [
        "PZ"
    ],
    "yt5760l": [
        "XYA"
    ],
    "yt5760b": [
        "XYA"
    ],
    "yt5760a": [
        "XYA"
    ],
    "yt5716c": [
        "XYA"
    ],
    "yt5716": [
        "XYA"
    ],
    "yt7216": [
        "XYA"
    ],
    "yt7216c": [
        "XYA"
    ],
    "yt7260b": [
        "XYA"
    ],
    "yt7260l": [
        "XYA"
    ],
    "yt9216cj": [
        "XYA"
    ],
    "yt9270": [
        "XYA"
    ],
    "yt9216bj": [
        "XYA"
    ],
    "yt9213aj": [
        "XYA"
    ],
    "mpc-100": [
        "5O"
    ],
    "sda-8tab": [
        "PI"
    ],
    "quad-core t3 k2001m": [
        "A7"
    ],
    "aftlbt962e2": [
        "KN"
    ],
    "airtouch performance 10x": [
        "AIT"
    ],
    "tb8163p3_bsp": [
        "XY"
    ],
    "dilink5.0 for byd auto": [
        "BYD"
    ],
    "apollo10 pro": [
        "CPD"
    ],
    "dudu7": [
        "DUD"
    ],
    "pixel 3": [
        "GO"
    ],
    "m2006c3lg": [
        "XI"
    ],
    "sm-a605g": [
        "SA"
    ],
    "redmi note 7": [
        "XI"
    ],
    "sm-g965f": [
        "SA"
    ],
    "sm-f926n": [
        "SA"
    ],
    "sm-j600l": [
        "SA"
    ],
    "ppa-lx2": [
        "HU"
    ],
    "sm-a217f": [
        "SA"
    ],
    "sm-a105m": [
        "SA"
    ],
    "sm-a525m": [
        "SA"
    ],
    "sm-t550": [
        "SA"
    ],
    "pixel 4a (5g)": [
        "GO"
    ],
    "sm-a705gm": [
        "SA"
    ],
    "sm-g610f": [
        "SA"
    ],
    "vog-l04": [
        "HU"
    ],
    "mi a1": [
        "XI"
    ],
    "vog-l29": [
        "HU"
    ],
    "sm-a307fn": [
        "SA"
    ],
    "sm-a127f": [
        "SA"
    ],
    "sm-a326b": [
        "SA"
    ],
    "oneplus a6013": [
        "ON"
    ],
    "poco f2 pro": [
        "0P"
    ],
    "sm-s727vl": [
        "SA"
    ],
    "sm-g975u": [
        "SA"
    ],
    "moto e(7i) power": [
        "MR"
    ],
    "mar-lx3a": [
        "HU"
    ],
    "mar-lx1a": [
        "HU"
    ],
    "sm-t290": [
        "SA"
    ],
    "pixel 2": [
        "GO"
    ],
    "sm-g990b": [
        "SA"
    ],
    "sm-g950f": [
        "SA"
    ],
    "sm-g930p": [
        "SA"
    ],
    "sm-a750fn": [
        "SA"
    ],
    "sm-g950u1": [
        "SA"
    ],
    "mya-l03": [
        "HU"
    ],
    "sm-g965u1": [
        "SA"
    ],
    "infinix x697": [
        "IF"
    ],
    "jny-lx1": [
        "HU"
    ],
    "cph2185": [
        "OP"
    ],
    "redmi note 9 pro": [
        "XI"
    ],
    "moto g play (2021)": [
        "MR"
    ],
    "sm-s908b": [
        "SA"
    ],
    "sm-a326u": [
        "SA"
    ],
    "sm-a325m": [
        "SA"
    ],
    "sm-a307g": [
        "SA"
    ],
    "sm-s260dl": [
        "SA"
    ],
    "art-l29n": [
        "HU"
    ],
    "sm-a102n": [
        "SA"
    ],
    "a509dl": [
        "TC"
    ],
    "nokia x20": [
        "NK"
    ],
    "vivo 1816": [
        "VV"
    ],
    "vivo 1606": [
        "VV"
    ],
    "cph1821": [
        "OP"
    ],
    "vivo 1910": [
        "VV"
    ],
    "eml-l29": [
        "HU"
    ],
    "sm-a528b": [
        "SA"
    ],
    "sm-g973f": [
        "SA"
    ],
    "redmi note 8 pro": [
        "XI"
    ],
    "sm-g930f": [
        "SA"
    ],
    "huawei mla-al10": [
        "HU"
    ],
    "pixel 5": [
        "GO"
    ],
    "kyv46": [
        "KY"
    ],
    "clt-al01": [
        "HU"
    ],
    "sm-a505fn": [
        "SA"
    ],
    "m2004j19c": [
        "XI"
    ],
    "5086a": [
        "AL"
    ],
    "5054s": [
        "AL"
    ],
    "moto g stylus": [
        "MR"
    ],
    "2107113sg": [
        "XI"
    ],
    "cph2251": [
        "OP"
    ],
    "tecno ka6": [
        "TB"
    ],
    "moto g(20)": [
        "MR"
    ],
    "cph2001": [
        "OP"
    ],
    "cph1933": [
        "OP"
    ],
    "infinix x658e": [
        "IF"
    ],
    "tecno lc6": [
        "TB"
    ],
    "itel a571l": [
        "IZ"
    ],
    "sm-g532f": [
        "SA"
    ],
    "sm-j320h": [
        "SA"
    ],
    "sm-g991b": [
        "SA"
    ],
    "alcatel_4060a": [
        "AL"
    ],
    "scm-al09": [
        "HU"
    ],
    "sm-a135f": [
        "SA"
    ],
    "sm-g950w": [
        "SA"
    ],
    "redmi 8a": [
        "XI"
    ],
    "sm-t835": [
        "SA"
    ],
    "m2101k7bl": [
        "XI"
    ],
    "google nexus 4": [
        "GO"
    ],
    "redmi note 8": [
        "XI"
    ],
    "sm-a125f": [
        "SA"
    ],
    "sm-a715f": [
        "SA"
    ],
    "lenovo tb128xu": [
        "LE"
    ],
    "mrd-lx1": [
        "HU"
    ],
    "sm-g998b": [
        "SA"
    ],
    "sm-a336b": [
        "SA"
    ],
    "sm-a115az": [
        "SA"
    ],
    "sm-g960u": [
        "SA"
    ],
    "sm-a037u": [
        "SA"
    ],
    "sm-s911u": [
        "SA"
    ],
    "sm-a536u": [
        "SA"
    ],
    "sm-a530w": [
        "SA"
    ],
    "sm-s901u1": [
        "SA"
    ],
    "kfmawi": [
        "KN"
    ],
    "bnd-al00": [
        "HU"
    ],
    "bg2-w09": [
        "HU"
    ],
    "sm-t865": [
        "SA"
    ],
    "m2010j19sy": [
        "XI"
    ],
    "sm-a536b": [
        "SA"
    ],
    "stk-lx1": [
        "HU"
    ],
    "sm-n9005": [
        "SA"
    ],
    "sm-g975f": [
        "SA"
    ],
    "sm-a202f": [
        "SA"
    ],
    "sm-g965u": [
        "SA"
    ],
    "nexus 4": [
        "GO"
    ],
    "5007g": [
        "AL"
    ],
    "jln-lx3": [
        "HU"
    ],
    "zte 8010": [
        "ZT"
    ],
    "mi 9": [
        "XI"
    ],
    "cet-al00": [
        "HU"
    ],
    "hma-l29": [
        "HU"
    ],
    "redmi 8a dual": [
        "XI"
    ],
    "orange tv box": [
        "OR"
    ],
    "sm-a032f": [
        "SA"
    ],
    "pixel 6": [
        "GO"
    ],
    "sm-g950n": [
        "SA"
    ],
    "sm-j105h": [
        "SA"
    ],
    "vne-lx3": [
        "HNR",
        "HU"
    ],
    "infinix x688b": [
        "IF"
    ],
    "infinix x665e": [
        "IF"
    ],
    "m2007j3sg": [
        "XI"
    ],
    "sm-s918w": [
        "SA"
    ],
    "sm-a136u1": [
        "SA"
    ],
    "sm-t503": [
        "SA"
    ],
    "zc554kl": [
        "AU"
    ],
    "dn2103": [
        "ON"
    ],
    "kfkawi": [
        "KN"
    ],
    "": [
        "AP",
        "OQ",
        "LG",
        "TLY"
    ],
    "2201116sg": [
        "XI"
    ],
    "sm-m426b": [
        "SA"
    ],
    "samsung sm-a032m": [
        "SA"
    ],
    "sgin_e10m": [
        "SGI"
    ],
    "iphone15,2": [
        "AP"
    ],
    "iq&t n8": [
        "QN"
    ],
    "hlte239e": [
        "HI"
    ],
    "model d": [
        "SUN"
    ],
    "model a": [
        "SUN"
    ],
    "model 6": [
        "SUN"
    ],
    "archos gamepad": [
        "AR"
    ],
    "archos gamepad2": [
        "AR"
    ],
    "retroid pocket 2plus": [
        "8R"
    ],
    "shield": [
        "NV"
    ],
    "dexp freya": [
        "DX"
    ],
    "retroid pocket 2+": [
        "8R"
    ],
    "razer edge 5g": [
        "RZ"
    ],
    "rg405v": [
        "ANC"
    ],
    "rg505": [
        "ANC"
    ],
    "retroid pocket 4 pro": [
        "8R"
    ],
    "retroid pocket 3 plus": [
        "CB",
        "8R"
    ],
    "rg556": [
        "ANC"
    ],
    "rg406v": [
        "ANC"
    ],
    "rgcube": [
        "ANC"
    ],
    "retroid pocket 5": [
        "8R"
    ],
    "rg405m": [
        "ANC"
    ],
    "20jjs0cu1m": [
        "LE"
    ],
    "hibox-hero": [
        "1C"
    ],
    "aspire v5-121": [
        "AC"
    ],
    "predator g9-793": [
        "AC"
    ],
    "macbookair6,2": [
        "AP"
    ],
    "inspiron 3541": [
        "DL"
    ],
    "latitude e4300": [
        "DL"
    ],
    "h135": [
        "DX"
    ],
    "hp elitebook 2560p": [
        "HP"
    ],
    "hp elitebook 2570p": [
        "HP"
    ],
    "macbookair2,1": [
        "AP"
    ],
    "macbookair3,1": [
        "AP"
    ],
    "macbookair3,2": [
        "AP"
    ],
    "macbookair4,1": [
        "AP"
    ],
    "macbookair4,2": [
        "AP"
    ],
    "macbookair5,1": [
        "AP"
    ],
    "macbookair5,2": [
        "AP"
    ],
    "macbookair6,1": [
        "AP"
    ],
    "macbookair7,1": [
        "AP"
    ],
    "macbookair7,2": [
        "AP"
    ],
    "macbookair8,1": [
        "AP"
    ],
    "macbookair8,2": [
        "AP"
    ],
    "macbookair9,1": [
        "AP"
    ],
    "macbookair10,1": [
        "AP"
    ],
    "macbookpro4,1": [
        "AP"
    ],
    "macbookpro5,1": [
        "AP"
    ],
    "macbookpro5,2": [
        "AP"
    ],
    "macbookpro5,5": [
        "AP"
    ],
    "macbookpro5,3": [
        "AP"
    ],
    "macbookpro5,4": [
        "AP"
    ],
    "macbookpro6,1": [
        "AP"
    ],
    "macbookpro6,2": [
        "AP"
    ],
    "macbookpro7,1": [
        "AP"
    ],
    "macbookpro8,1": [
        "AP"
    ],
    "macbookpro8,2": [
        "AP"
    ],
    "macbookpro8,3": [
        "AP"
    ],
    "macbookpro9,1": [
        "AP"
    ],
    "macbookpro9,2": [
        "AP"
    ],
    "macbookpro10,1": [
        "AP"
    ],
    "macbookpro10,2": [
        "AP"
    ],
    "macbookpro11,1": [
        "AP"
    ],
    "macbookpro11,2": [
        "AP"
    ],
    "macbookpro11,3": [
        "AP"
    ],
    "macbookpro11,4": [
        "AP"
    ],
    "macbookpro11,5": [
        "AP"
    ],
    "macbookpro12,1": [
        "AP"
    ],
    "macbookpro13,1": [
        "AP"
    ],
    "macbookpro13,2": [
        "AP"
    ],
    "macbookpro13,3": [
        "AP"
    ],
    "macbookpro14,1": [
        "AP"
    ],
    "macbookpro14,2": [
        "AP"
    ],
    "macbookpro14,3": [
        "AP"
    ],
    "macbookpro15,1": [
        "AP"
    ],
    "macbookpro15,3": [
        "AP"
    ],
    "macbookpro15,2": [
        "AP"
    ],
    "macbookpro15,4": [
        "AP"
    ],
    "macbookpro16,1": [
        "AP"
    ],
    "macbookpro16,4": [
        "AP"
    ],
    "macbookpro16,2": [
        "AP"
    ],
    "macbookpro16,3": [
        "AP"
    ],
    "macbookpro17,1": [
        "AP"
    ],
    "macbookpro1,1": [
        "AP"
    ],
    "macbookpro1,2": [
        "AP"
    ],
    "macbookpro2,1": [
        "AP"
    ],
    "macbookpro2,2": [
        "AP"
    ],
    "macbookpro3,1": [
        "AP"
    ],
    "macmini7,1": [
        "AP"
    ],
    "macbook7,1": [
        "AP"
    ],
    "macpro5,1": [
        "AP"
    ],
    "imac12,1": [
        "AP"
    ],
    "imac19,2": [
        "AP"
    ],
    "imac14,2": [
        "AP"
    ],
    "imac14,4": [
        "AP"
    ],
    "imac14,1": [
        "AP"
    ],
    "macbook8,1": [
        "AP"
    ],
    "imac10,1": [
        "AP"
    ],
    "imac20,1": [
        "AP"
    ],
    "macmini9,1": [
        "AP"
    ],
    "imac17,1": [
        "AP"
    ],
    "macbook9,1": [
        "AP"
    ],
    "macbook6,1": [
        "AP"
    ],
    "imac19,1": [
        "AP"
    ],
    "imac20,2": [
        "AP"
    ],
    "bilimbook mini": [
        "BA"
    ],
    "hp elitebook 820 g2": [
        "HP"
    ],
    "hp chromebook 11 g5": [
        "HP"
    ],
    "hp chromebook x360 11 g1 ee": [
        "HP"
    ],
    "hp chromebook 13 g1": [
        "HP"
    ],
    "aspire 4349": [
        "AC"
    ],
    "goclever netbook r103": [
        "GC",
        "3N"
    ],
    "macbookpro18,1": [
        "AP"
    ],
    "macbookpro18,3": [
        "AP"
    ],
    "macbookpro18,2": [
        "AP"
    ],
    "macbookpro18,4": [
        "AP"
    ],
    "imac18,1": [
        "AP"
    ],
    "imac18,2": [
        "AP"
    ],
    "imac18,3": [
        "AP"
    ],
    "imac21,1": [
        "AP"
    ],
    "imac21,2": [
        "AP"
    ],
    "imacpro1,1": [
        "AP"
    ],
    "powermac7,2": [
        "AP"
    ],
    "macbook4,1": [
        "AP"
    ],
    "imac13,2": [
        "AP"
    ],
    "imac7,1": [
        "AP"
    ],
    "imac13,1": [
        "AP"
    ],
    "imac6,1": [
        "AP"
    ],
    "imac9,1": [
        "AP"
    ],
    "imac12,2": [
        "AP"
    ],
    "macbookair1,1": [
        "AP"
    ],
    "imac5,2": [
        "AP"
    ],
    "imac8,1": [
        "AP"
    ],
    "macmini1,1": [
        "AP"
    ],
    "macmini4,1": [
        "AP"
    ],
    "macmini5,2": [
        "AP"
    ],
    "macmini6,2": [
        "AP"
    ],
    "macbook2,1": [
        "AP"
    ],
    "macbook3,1": [
        "AP"
    ],
    "macbook5,1": [
        "AP"
    ],
    "imac5,1": [
        "AP"
    ],
    "imac11,3": [
        "AP"
    ],
    "macpro1,1": [
        "AP"
    ],
    "macmini2,1": [
        "AP"
    ],
    "macmini3,1": [
        "AP"
    ],
    "imac11,1": [
        "AP"
    ],
    "imac14,3": [
        "AP"
    ],
    "powerbook6,7": [
        "AP"
    ],
    "powermac12,1": [
        "AP"
    ],
    "macbook1,1": [
        "AP"
    ],
    "macbook5,2": [
        "AP"
    ],
    "macpro2,1": [
        "AP"
    ],
    "macpro3,1": [
        "AP"
    ],
    "macpro4,1": [
        "AP"
    ],
    "powerbook5,6": [
        "AP"
    ],
    "macmini5,1": [
        "AP"
    ],
    "macmini6,1": [
        "AP"
    ],
    "powermac7,3": [
        "AP"
    ],
    "powermac8,2": [
        "AP"
    ],
    "powermac10,1": [
        "AP"
    ],
    "macmini5,3": [
        "AP"
    ],
    "imac11,2": [
        "AP"
    ],
    "remix mini": [
        "JD"
    ],
    "aquarius pro, std, elt series": [
        "HJ",
        "IX"
    ],
    "nuc10i3fnh": [
        "INT"
    ],
    "zc-339": [
        "WAN"
    ],
    "samsung chromebook 3": [
        "SA"
    ],
    "latitude 7390": [
        "DL"
    ],
    "satellite l50-c": [
        "TS"
    ],
    "samsung chromebook plus": [
        "SA"
    ],
    "satellite c655": [
        "TS"
    ],
    "satellite a100": [
        "TS"
    ],
    "satellite pro l300": [
        "TS"
    ],
    "inspiron n4050": [
        "DL"
    ],
    "inspiron 5567": [
        "DL"
    ],
    "inspiron 5545": [
        "DL"
    ],
    "inspiron 5468": [
        "DL"
    ],
    "inspiron 3558": [
        "DL"
    ],
    "inspiron 3542": [
        "DL"
    ],
    "inspiron 3521": [
        "DL"
    ],
    "f0cu0028rk": [
        "LE"
    ],
    "inspiron 13-5378": [
        "DL"
    ],
    "travelmate spin b118-g2-r": [
        "AC"
    ],
    "travelmate p653-m": [
        "AC"
    ],
    "travelmate 5760g": [
        "AC"
    ],
    "travelmate 8371": [
        "AC"
    ],
    "dell chromebook 13 (7310)": [
        "DL"
    ],
    "easynote tv11hc": [
        "94"
    ],
    "dell chromebook 11 (3180)": [
        "DL"
    ],
    "acer chromebook 15 (cb3-532)": [
        "AC"
    ],
    "hp chromebook x2": [
        "HP"
    ],
    "vostro 3546": [
        "DL"
    ],
    "vostro 14-3468": [
        "DL"
    ],
    "swift sf113-31": [
        "AC"
    ],
    "latitude e4310": [
        "DL"
    ],
    "k50ij": [
        "AU"
    ],
    "google pixelbook go": [
        "GO"
    ],
    "travelmate b118-m": [
        "AC"
    ],
    "mac14,3": [
        "AP"
    ],
    "mac14,9": [
        "AP"
    ],
    "mac14,2": [
        "AP"
    ],
    "mac13,1": [
        "AP"
    ],
    "mac13,2": [
        "AP"
    ],
    "mac14,14": [
        "AP"
    ],
    "mac14,7": [
        "AP"
    ],
    "mac14,5": [
        "AP"
    ],
    "mac14,6": [
        "AP"
    ],
    "mac14,10": [
        "AP"
    ],
    "mac14,12": [
        "AP"
    ],
    "mac14,15": [
        "AP"
    ],
    "mac14,13": [
        "AP"
    ],
    "mac14,8": [
        "AP"
    ],
    "mac15,4": [
        "AP"
    ],
    "mac15,5": [
        "AP"
    ],
    "mac15,7": [
        "AP"
    ],
    "mac15,9": [
        "AP"
    ],
    "mac15,11": [
        "AP"
    ],
    "mac15,3": [
        "AP"
    ],
    "mac15,6": [
        "AP"
    ],
    "mac15,8": [
        "AP"
    ],
    "mac15,10": [
        "AP"
    ],
    "chromebook 14 (cb3-431)": [
        "AC"
    ],
    "asus chromebook flip c302": [
        "AU"
    ],
    "asus chromebook flip c100pa": [
        "AU"
    ],
    "aspire xc-704g": [
        "AC"
    ],
    "aspire v5-573g": [
        "AC"
    ],
    "asus chromebook flip c101pa": [
        "AU"
    ],
    "lifebook ah532": [
        "FU"
    ],
    "gp70 2od": [
        "MZ"
    ],
    "hp engage one pro aio system": [
        "HP"
    ],
    "hp elitebook 8470p": [
        "HP"
    ],
    "hp compaq 8200 elite sff pc": [
        "HP"
    ],
    "impress_grip": [
        "VX"
    ],
    "archos diamond plus": [
        "AR"
    ],
    "aqua v3g": [
        "IX"
    ],
    "asus_z012de": [
        "AU"
    ],
    "intex aqua 4.5e": [
        "IX"
    ],
    "primo e10 plus": [
        "WA"
    ],
    "e260t+": [
        "HI"
    ],
    "fise_32433_3g": [
        "F8"
    ],
    "dixon_xk1_3g": [
        "X6"
    ],
    "tech_pad_kaios_one_3g": [
        "TP"
    ],
    "crosscall_core-s4_4g": [
        "C1"
    ],
    "alcatel4044t": [
        "AL"
    ],
    "ipro_k2_3g": [
        "IP"
    ],
    "cat b35": [
        "CA"
    ],
    "att_ea211101": [
        "6A"
    ],
    "nokia 2720 v flip": [
        "NK"
    ],
    "nokia_2720_flip": [
        "NK"
    ],
    "3088x": [
        "AL"
    ],
    "alcatel 4052c": [
        "AL"
    ],
    "alcatel 4052o": [
        "AL"
    ],
    "alcatel 4052r": [
        "AL"
    ],
    "alcatel 4052w": [
        "AL"
    ],
    "alcatel 4052z": [
        "AL"
    ],
    "alcatel 4056w": [
        "AL"
    ],
    "alcatel 4056z": [
        "AL"
    ],
    "alcatel a406dl": [
        "AL"
    ],
    "mango_akabuto_4g": [
        "MAN"
    ],
    "att_u102aa": [
        "6A"
    ],
    "att_u1030aa": [
        "6A"
    ],
    "alcatel4044c": [
        "AL"
    ],
    "alcatel4044o": [
        "AL"
    ],
    "alcatel4044v": [
        "AL"
    ],
    "ckt_u102ac": [
        "CK"
    ],
    "ckt_u1030ac": [
        "CK"
    ],
    "doppio_texter_3g": [
        "JQ"
    ],
    "blackphone_blackphone_k330_3g": [
        "BLP"
    ],
    "geophone_t19i_4g": [
        "GEP"
    ],
    "geo_phone_t15_4g": [
        "GEP"
    ],
    "geo_phone_t19_4g": [
        "GEP"
    ],
    "accent_nubia50k": [
        "00"
    ],
    "accent_nubia60k": [
        "00"
    ],
    "accent_60k28_512": [
        "00"
    ],
    "b300v": [
        "BU"
    ],
    "blu_tankmega_3g": [
        "BU"
    ],
    "blu_zoey_smart": [
        "BU"
    ],
    "multilaser_zapp": [
        "1R"
    ],
    "multilaser_zapp_ii_3g": [
        "1R"
    ],
    "m560m3": [
        "N4"
    ],
    "m561m3": [
        "N4"
    ],
    "m562f3": [
        "OR"
    ],
    "m571m3": [
        "N4"
    ],
    "red_x_rx2441_4g": [
        "RDX"
    ],
    "sigmamobile-s3500-3g": [
        "1S"
    ],
    "r3di_fr150": [
        "R3D"
    ],
    "symphony_pd1_4g_4g": [
        "SM"
    ],
    "bmobile_w125k_3g": [
        "BM"
    ],
    "digit_digit4g-bold_4g": [
        "DIG"
    ],
    "digit_digit4g-defender_4g": [
        "DIG"
    ],
    "digit_digit4g-elite_4g": [
        "DIG"
    ],
    "digit_digit4g-music_4g": [
        "DIG"
    ],
    "digit_digit4g-power_4g": [
        "DIG"
    ],
    "digit_digit4g-star_4g": [
        "DIG"
    ],
    "digit_digit4glite_4g": [
        "DIG"
    ],
    "digit_digit4gpowermax_4g": [
        "DIG"
    ],
    "digit_digit4g_shine_4g": [
        "DIG"
    ],
    "sanza-m560f3": [
        "OR"
    ],
    "energizer_e241": [
        "ED"
    ],
    "energizer_e241s": [
        "ED"
    ],
    "energizer_e242s_4g": [
        "ED"
    ],
    "energizer_e280s": [
        "ED"
    ],
    "energizer_e282sc_4g": [
        "ED"
    ],
    "energizer_h280a_512": [
        "ED"
    ],
    "idc_voice_20_4g": [
        "IDC"
    ],
    "free_wi-kif4g_4g": [
        "FRE"
    ],
    "telma_wi-kif+3g_3g": [
        "TEL"
    ],
    "telma_wi-kif+4g_4g": [
        "TEL"
    ],
    "telma_wikif_max_4g": [
        "TEL"
    ],
    "klt_k301": [
        "KLT"
    ],
    "aspera_f30_4g": [
        "AQ"
    ],
    "aspera_r40_4g": [
        "AQ"
    ],
    "condor_fp216l": [
        "C5"
    ],
    "logan_panita_3g": [
        "LGN"
    ],
    "maxcom mk241": [
        "7M"
    ],
    "iphone_4": [
        "AP"
    ],
    "mb886": [
        "MR"
    ],
    "sch-i500": [
        "SA"
    ],
    "phone/nexus 5": [
        "GO"
    ],
    "ipad3,6": [
        "AP"
    ],
    "iphone8,4": [
        "AP"
    ],
    "ipad4,1": [
        "AP"
    ],
    "nexus 5x": [
        "GO"
    ],
    "sm-t280": [
        "SA"
    ],
    "fever": [
        "WI"
    ],
    "m580": [
        "8L"
    ],
    "huawei huawei tit-u02": [
        "HU"
    ],
    "sm-t515": [
        "SA"
    ],
    "iphone12,1": [
        "AP"
    ],
    "inoi_5i_lite": [
        "I4"
    ],
    "iphone": [
        "AP"
    ],
    "x86_64": [
        "AP"
    ],
    "iphone7,2": [
        "AP"
    ],
    "lgt01": [
        "LG"
    ],
    "mediapad 7 lite ii": [
        "HU"
    ],
    "neosr620": [
        "LU"
    ],
    "iphone8,1": [
        "AP"
    ],
    "6025h_eea": [
        "AL"
    ],
    "bmh-tn10": [
        "HU"
    ],
    "ipad3,4": [
        "AP"
    ],
    "watch1,2": [
        "AP"
    ],
    "jln-lx1": [
        "HU"
    ],
    "pixel 6 pro": [
        "GO"
    ],
    "sm-n960n": [
        "SA"
    ],
    "sm-g930w8": [
        "SA"
    ],
    "huawei nxt-cl00": [
        "HU"
    ],
    "dra-l01": [
        "HU"
    ],
    "iphone12,3": [
        "AP"
    ],
    "xq-cc54": [
        "SO"
    ],
    "shtrih-smartpos-f2": [
        "RS"
    ],
    "wisenet5": [
        "W0"
    ],
    "odroidc2": [
        "HK"
    ],
    "odroid-xu4": [
        "HK"
    ],
    "odroid-xu3": [
        "HK"
    ],
    "odroid-u2": [
        "HK"
    ],
    "mfstab": [
        "Z0"
    ],
    "mfstab_74g": [
        "Z0"
    ],
    "teg9300": [
        "OC"
    ],
    "xgimi tv": [
        "QX"
    ],
    "raspberry pi 4": [
        "0R"
    ],
    "raspberry pi 3": [
        "0R"
    ],
    "dt40": [
        "9U"
    ],
    "projector": [
        "XP"
    ],
    "dt50": [
        "9U"
    ],
    "mobiprint 4+": [
        "ID"
    ],
    "v1s-g": [
        "2J"
    ],
    "ct60": [
        "WH"
    ],
    "ck65": [
        "WH"
    ],
    "idata k1": [
        "6Z"
    ],
    "pm80": [
        "FH"
    ],
    "mc401_gwl": [
        "QW"
    ],
    "dimagic cube dm011": [
        "D2"
    ],
    "miproja1": [
        "XI"
    ],
    "tps390": [
        "PW"
    ],
    "odroid-n2": [
        "HK"
    ],
    "teachtouch table": [
        "TEA"
    ],
    "desk21t-03": [
        "ACT"
    ],
    "mobigo2": [
        "ID",
        "6W"
    ],
    "cn80": [
        "WH"
    ],
    "tinker board s": [
        "AU"
    ],
    "tinker board": [
        "AU"
    ],
    "atol 150f": [
        "ATO"
    ],
    "ptc760": [
        "HYT"
    ],
    "wpos-3": [
        "W0"
    ],
    "m3us20w": [
        "M3M"
    ],
    "artidiag800 bt": [
        "TOD"
    ],
    "wizarpos q2": [
        "WIZ"
    ],
    "optoma-uhd": [
        "OPT"
    ],
    "eft_h2": [
        "EFT"
    ],
    "avaya vantage": [
        "AVA"
    ],
    "ct40": [
        "WH"
    ],
    "pine a64": [
        "PIN"
    ],
    "mc2700": [
        "PZ"
    ],
    "nbp-60": [
        "SEW"
    ],
    "smart_prime": [
        "ATO"
    ],
    "vormor-x5-pro": [
        "VOR"
    ],
    "smart_slim_plus": [
        "ATO"
    ],
    "mc2200": [
        "PZ"
    ],
    "mc93": [
        "PZ"
    ],
    "pnc550": [
        "HYT"
    ],
    "ps20j": [
        "PZ"
    ],
    "eft_h4": [
        "EFT"
    ],
    "eft_h3": [
        "EFT"
    ],
    "nls-mt65": [
        "N9"
    ],
    "i6200s": [
        "9U"
    ],
    "i6200a": [
        "9U"
    ],
    "seewo sd02": [
        "SE1"
    ],
    "telo_m5": [
        "TLS"
    ],
    "idata 50": [
        "6Z"
    ],
    "idata_i3al": [
        "6Z"
    ],
    "multiposx9": [
        "MPS"
    ],
    "sobietech slp": [
        "SOB"
    ],
    "miprojm05": [
        "XI"
    ],
    "dt20": [
        "9U"
    ],
    "jin tu x1": [
        "JIN"
    ],
    "m3sl20": [
        "M3M"
    ],
    "nl5h00x": [
        "LE"
    ],
    "pnc560": [
        "HYT"
    ],
    "esp-300": [
        "EXL"
    ],
    "hongtop_projector": [
        "HON"
    ],
    "orangepi_3_lts": [
        "ORP"
    ],
    "v2_pro-st": [
        "2J"
    ],
    "hy416": [
        "HOP"
    ],
    "lenovo projector701": [
        "LE"
    ],
    "hce600": [
        "CHC"
    ],
    "hce700": [
        "CHC"
    ],
    "m3sm15x": [
        "M3M"
    ],
    "aura_telpad_mt7_tablet": [
        "PLD"
    ],
    "neoviu d1": [
        "PH"
    ],
    "mogo pro": [
        "QX"
    ],
    "xming google tv": [
        "FRM"
    ],
    "scn550": [
        "PH"
    ],
    "sti6110": [
        "XP"
    ],
    "xk03h": [
        "QX"
    ],
    "havit pj209 pro": [
        "HAV"
    ],
    "t3_pro": [
        "6Z"
    ],
    "sm-f721u": [
        "SA"
    ],
    "note 13p": [
        "UL"
    ],
    "note 12p": [
        "UL"
    ],
    "22061218c": [
        "XI"
    ],
    "tecno lg7n": [
        "TB"
    ],
    "infinix x6819": [
        "IF"
    ],
    "rr_fortuna3g": [
        "SA"
    ],
    "tecno lg8n": [
        "TB"
    ],
    "infinix x676c": [
        "IF"
    ],
    "sc-54c": [
        "SA",
        "SU"
    ],
    "scg16": [
        "SA"
    ],
    "sc-55c": [
        "SA",
        "SU"
    ],
    "sm-w9023": [
        "SA"
    ],
    "infinix x6820": [
        "IF"
    ],
    "ego phab 3g": [
        "TOR"
    ],
    "22021119kr": [
        "XI"
    ],
    "v2229a": [
        "VV"
    ],
    "scg17": [
        "SA"
    ],
    "samsung-sm-n920a": [
        "SA"
    ],
    "samsung-sm-n915a": [
        "SA"
    ],
    "samsung-sm-n910a": [
        "SA"
    ],
    "sm-g530fz": [
        "SA"
    ],
    "sm-g530y": [
        "SA"
    ],
    "22101316c": [
        "XI"
    ],
    "22087ra4di": [
        "XI"
    ],
    "22101316ucp": [
        "XI"
    ],
    "sm-f721c": [
        "SA"
    ],
    "samsung sm-f7210": [
        "SA"
    ],
    "redmi note 11s 5g": [
        "XI"
    ],
    "redmi note 11 4g": [
        "XI"
    ],
    "redmi note 11 pro 5g": [
        "XI"
    ],
    "redmi note 11 se": [
        "XI"
    ],
    "redmi note 12 pro": [
        "XI"
    ],
    "redmi note 11 pro+ 5g": [
        "XI"
    ],
    "redmi note 11e": [
        "XI"
    ],
    "redmi note 11t 5g": [
        "XI"
    ],
    "redmi note 10t 5g": [
        "XI"
    ],
    "redmi note 11r": [
        "XI"
    ],
    "redmi note 11 pro+": [
        "XI"
    ],
    "redmi note 11e pro": [
        "XI"
    ],
    "redmi note 11t pro": [
        "XI"
    ],
    "redmi note 9 4g": [
        "XI"
    ],
    "22095ra98c": [
        "XI"
    ],
    "22101316uc": [
        "XI"
    ],
    "22111317i": [
        "XI"
    ],
    "22101316i": [
        "XI"
    ],
    "22101316up": [
        "XI"
    ],
    "22101317c": [
        "XI"
    ],
    "note 10p": [
        "UL"
    ],
    "note 6p": [
        "UL"
    ],
    "infinix x677": [
        "IF"
    ],
    "infinix x6815c": [
        "IF"
    ],
    "23021raa2y": [
        "XI"
    ],
    "23021raaeg": [
        "XI"
    ],
    "22101316ug": [
        "XI"
    ],
    "sm-f936w": [
        "SA"
    ],
    "m-ppxx530u": [
        "MC"
    ],
    "m-ppxx525u": [
        "MC"
    ],
    "m-ppxs552u": [
        "MC"
    ],
    "m-ppxs510l": [
        "MC"
    ],
    "infinix-x551": [
        "IF"
    ],
    "22101316g": [
        "XI"
    ],
    "23028ra60l": [
        "XI"
    ],
    "23049rad8c": [
        "XI"
    ],
    "23030rac7y": [
        "XI"
    ],
    "2303cra44a": [
        "XI"
    ],
    "22111317g": [
        "XI"
    ],
    "redmi_note_8": [
        "XI"
    ],
    "redmi_note_5": [
        "XI"
    ],
    "v2266a": [
        "VV"
    ],
    "sm-f721w": [
        "SA"
    ],
    "infinix x6716": [
        "IF"
    ],
    "2303era42l": [
        "XI"
    ],
    "galaxy note 20 ultra": [
        "SA"
    ],
    "galaxy note 20": [
        "SA"
    ],
    "galaxy note 10": [
        "SA"
    ],
    "galaxy note 10+": [
        "SA"
    ],
    "galaxy note 2": [
        "SA"
    ],
    "m1906g7g": [
        "XI"
    ],
    "infinix x6710": [
        "IF"
    ],
    "infinix x678b": [
        "IF"
    ],
    "tecno lh7n": [
        "TB"
    ],
    "redmi note 12s": [
        "XI"
    ],
    "redmi note 12": [
        "XI"
    ],
    "redmi note9 pro max": [
        "XI"
    ],
    "tecno lh6n": [
        "TB"
    ],
    "iphone15,4": [
        "AP"
    ],
    "iphone15,5": [
        "AP"
    ],
    "iphone16,1": [
        "AP"
    ],
    "iphone16,2": [
        "AP"
    ],
    "sm-f946b": [
        "SA"
    ],
    "sm-f731b": [
        "SA"
    ],
    "tecno mobile lg6n": [
        "TB"
    ],
    "iphone14,8": [
        "AP"
    ],
    "23054ra19c": [
        "XI"
    ],
    "2312crad3c": [
        "XI"
    ],
    "tecno lh8n": [
        "TB"
    ],
    "2312draabc": [
        "XI"
    ],
    "23090ra98c": [
        "XI"
    ],
    "2308cpxd0c": [
        "XI"
    ],
    "23076ra4bc": [
        "XI"
    ],
    "xiaomi mix fold 3": [
        "XI"
    ],
    "g9fpl": [
        "GO"
    ],
    "22101320c": [
        "XI"
    ],
    "pixel fold": [
        "GO"
    ],
    "2312dra50c": [
        "XI"
    ],
    "23027rad4i": [
        "XI"
    ],
    "iphone15,3": [
        "AP"
    ],
    "vnd_camellia": [
        "XI"
    ],
    "mi note 10 lite": [
        "XI"
    ],
    "huawei mt2-l05": [
        "HU"
    ],
    "sm-f926w": [
        "SA"
    ],
    "iphone14,7": [
        "AP"
    ],
    "iphone7,1": [
        "AP"
    ],
    "huawei mt2-l01": [
        "HU"
    ],
    "redmi_note_8_pro": [
        "XI"
    ],
    "sm-f711w": [
        "SA"
    ],
    "iphone8,2": [
        "AP"
    ],
    "sm-n986u1": [
        "SA"
    ],
    "samsung gt-n7105/n7105xxdmc3": [
        "SA"
    ],
    "xiaomi_2015052": [
        "XI"
    ],
    "tecno le7": [
        "TB"
    ],
    "m2103k19g": [
        "XI"
    ],
    "iphone10,2": [
        "AP"
    ],
    "zte a2121e": [
        "ZT"
    ],
    "iphone9,4": [
        "AP"
    ],
    "iphone9,2": [
        "AP"
    ],
    "sm-f926u1": [
        "SA"
    ],
    "m2101k7ag": [
        "XI"
    ],
    "m2007j22g": [
        "XI"
    ],
    "m2101k6g": [
        "XI"
    ],
    "sm-f711u1": [
        "SA"
    ],
    "sm-f711n": [
        "SA"
    ],
    "2201117ty": [
        "XI"
    ],
    "sm-f7110": [
        "SA"
    ],
    "kenzo": [
        "XI"
    ],
    "lm-f100": [
        "LG"
    ],
    "lm-f100n": [
        "LG"
    ],
    "bv6300": [
        "B2"
    ],
    "m5_note": [
        "M1"
    ],
    "5060a": [
        "AL"
    ],
    "5039y": [
        "AL"
    ],
    "5060j": [
        "AL"
    ],
    "cygnusx": [
        "AF"
    ],
    "cygnus": [
        "AF"
    ],
    "fenmmy_note": [
        "G5"
    ],
    "m-ppab500": [
        "MC"
    ],
    "iphone13,4": [
        "AP"
    ],
    "iphone13,3": [
        "AP"
    ],
    "iphone13,2": [
        "AP"
    ],
    "mi note 10 pro": [
        "XI"
    ],
    "scv44": [
        "SA"
    ],
    "md-04p": [
        "7P"
    ],
    "scl24": [
        "SA"
    ],
    "redmi note 10 lite": [
        "XI"
    ],
    "lumia 640 xl lte": [
        "MS",
        "NK"
    ],
    "lumia 950 xl dual sim": [
        "MS",
        "NK"
    ],
    "iphone14,2": [
        "AP"
    ],
    "iphone14,3": [
        "AP"
    ],
    "iphone14,5": [
        "AP"
    ],
    "scg06": [
        "SA"
    ],
    "infinix x6711": [
        "IF"
    ],
    "infinix x6815d": [
        "IF"
    ],
    "2312draabg": [
        "XI"
    ],
    "23117ra68g": [
        "XI"
    ],
    "23124ra7eo": [
        "XI"
    ],
    "2312dra50g": [
        "XI"
    ],
    "23129raa4g": [
        "XI"
    ],
    "2312dra50i": [
        "XI"
    ],
    "sm-f731n": [
        "SA"
    ],
    "sm-f731u1": [
        "SA"
    ],
    "sm-f731w": [
        "SA"
    ],
    "2311frafdc": [
        "XI"
    ],
    "23090ra98i": [
        "XI"
    ],
    "23090ra98g": [
        "XI"
    ],
    "infinix x6853": [
        "IF"
    ],
    "23129ra5fl": [
        "XI"
    ],
    "2312draabi": [
        "XI"
    ],
    "tecno mobile lh8n": [
        "TB"
    ],
    "tecno li9": [
        "TB"
    ],
    "sm-n985f": [
        "SA"
    ],
    "sm-f907b": [
        "SA"
    ],
    "infinix x6850": [
        "IF"
    ],
    "v2303a": [
        "VV"
    ],
    "tecno li7": [
        "TB"
    ],
    "v2337a": [
        "VV"
    ],
    "sm-n981b": [
        "SA"
    ],
    "sm-f707u": [
        "SA"
    ],
    "tecno li6": [
        "TB"
    ],
    "redmi note 13 pro 5g": [
        "XI"
    ],
    "redmi note 13 pro+ 5g": [
        "XI"
    ],
    "redmi note 13 5g": [
        "XI"
    ],
    "redmi note 12r": [
        "XI"
    ],
    "sm-f946w": [
        "SA"
    ],
    "redmi note 12r pro": [
        "XI"
    ],
    "infinix x6851": [
        "IF"
    ],
    "infinix x6851b": [
        "IF"
    ],
    "sm-f946n": [
        "SA"
    ],
    "sm-f9460": [
        "SA"
    ],
    "sm-n976n": [
        "SA"
    ],
    "sm-w7023": [
        "SA"
    ],
    "v2256a": [
        "VV"
    ],
    "infinix x6852": [
        "IF"
    ],
    "sm-w7024": [
        "SA"
    ],
    "sm-f7210": [
        "SA"
    ],
    "m2003j6a1i": [
        "XI"
    ],
    "m1908c3jg": [
        "XI"
    ],
    "tecno le6j": [
        "TB"
    ],
    "sm-f916b": [
        "SA"
    ],
    "a2121g": [
        "ZT"
    ],
    "sm-f711u": [
        "SA"
    ],
    "xig05": [
        "XI"
    ],
    "sm-f741w": [
        "SA"
    ],
    "sm-f741b": [
        "SA"
    ],
    "infinix x6850b": [
        "IF"
    ],
    "rubyplus": [
        "XI"
    ],
    "iphone10,3": [
        "AP"
    ],
    "iphone10,5": [
        "AP"
    ],
    "iphone11,6": [
        "AP"
    ],
    "iphone12,5": [
        "AP"
    ],
    "iphone12,8": [
        "AP"
    ],
    "redmi note 13": [
        "XI"
    ],
    "tecno mobile li6": [
        "TB"
    ],
    "tecno mobile li9": [
        "TB"
    ],
    "fcp-n49": [
        "HNR"
    ],
    "fcp-an10": [
        "HNR",
        "HU"
    ],
    "biloba": [
        "XI"
    ],
    "m1901f7g": [
        "XI"
    ],
    "m2003j6b1i": [
        "XI"
    ],
    "tecno_lh7n": [
        "TB"
    ],
    "infinix x6716b": [
        "IF"
    ],
    "infinix x6838": [
        "IF"
    ],
    "24115ra8ec": [
        "XI"
    ],
    "24090ra29c": [
        "XI"
    ],
    "2406ern9cc": [
        "XI"
    ],
    "sc-55d": [
        "SA",
        "SU"
    ],
    "meizu note21": [
        "M1"
    ],
    "tecno kl8": [
        "TB"
    ],
    "sm-w9024": [
        "SA"
    ],
    "sm-f956n": [
        "SA"
    ],
    "sm-n9760": [
        "SA"
    ],
    "sm-f7310": [
        "SA"
    ],
    "sm-n970w": [
        "SA"
    ],
    "grl-al10": [
        "HU"
    ],
    "24094rad4c": [
        "XI"
    ],
    "note 12 ef": [
        "HV"
    ],
    "redmi note 12 pro speed": [
        "XI"
    ],
    "redmi note 13 pro": [
        "XI"
    ],
    "24117rn76o": [
        "XI"
    ],
    "24090ra29g": [
        "XI"
    ],
    "24116raccg": [
        "XI"
    ],
    "24115ra8eg": [
        "XI"
    ],
    "24117rn76e": [
        "XI"
    ],
    "24117rn76g": [
        "XI"
    ],
    "24094rad4i": [
        "XI"
    ],
    "24094rad4g": [
        "XI"
    ],
    "24090ra29i": [
        "XI"
    ],
    "24115ra8ei": [
        "XI"
    ],
    "sm-f956b": [
        "SA"
    ],
    "2502fra65g": [
        "XI"
    ],
    "infinix x6855": [
        "IF"
    ],
    "infinix x6858": [
        "IF"
    ],
    "infinix x6856": [
        "IF"
    ],
    "23021raaei": [
        "XI"
    ],
    "sm-f741u": [
        "SA"
    ],
    "sm-f741u1": [
        "SA"
    ],
    "t803d": [
        "TC"
    ],
    "t702d": [
        "TC"
    ],
    "v2330": [
        "VV"
    ],
    "sm-f7410": [
        "SA"
    ],
    "tecno_lh8n": [
        "TB"
    ],
    "iphone17,5": [
        "AP"
    ],
    "sm-w9025": [
        "SA"
    ],
    "24117rn76l": [
        "XI"
    ],
    "infinix x6870": [
        "IF"
    ],
    "infinix x671": [
        "IF"
    ],
    "23021raa2g": [
        "XI"
    ],
    "pixel 10 pro fold": [
        "GO"
    ],
    "pixel 9 pro fold": [
        "GO"
    ],
    "ggh2x": [
        "GO"
    ],
    "gc15s": [
        "GO"
    ],
    "mbh-an10": [
        "HNR"
    ],
    "25104radac": [
        "XI"
    ],
    "25080rabdc": [
        "XI"
    ],
    "infinix x6857b": [
        "IF"
    ],
    "grl-lx9": [
        "HU"
    ],
    "23013rk75c": [
        "XI"
    ],
    "gi-626": [
        "A5"
    ],
    "5039d_ru": [
        "AL"
    ],
    "5039d_eea": [
        "AL"
    ],
    "5060d": [
        "AL"
    ],
    "5060d_ru": [
        "AL"
    ],
    "9002x": [
        "AL"
    ],
    "9022x": [
        "AL"
    ],
    "me371mg": [
        "AU"
    ],
    "k012": [
        "AU"
    ],
    "k00e": [
        "AU"
    ],
    "k00z": [
        "AU"
    ],
    "k016": [
        "AU"
    ],
    "k00g": [
        "AU"
    ],
    "m300": [
        "AW"
    ],
    "bv6100": [
        "B2"
    ],
    "revvlplus c3701a": [
        "CO"
    ],
    "as260": [
        "DX"
    ],
    "gn810": [
        "GI"
    ],
    "nexus 6": [
        "GO"
    ],
    "nexus 6p": [
        "HU"
    ],
    "hlte720t": [
        "HI"
    ],
    "hp slate 6 voice tab": [
        "HP"
    ],
    "htc_one_max": [
        "HT"
    ],
    "htc one max": [
        "HT"
    ],
    "mt2l03": [
        "HU"
    ],
    "huawei mt2l03": [
        "HU"
    ],
    "huawei mt7-l09": [
        "HU"
    ],
    "infinix x690": [
        "IF"
    ],
    "infinix x656": [
        "IF"
    ],
    "iqw603": [
        "LS"
    ],
    "m1 note": [
        "M1"
    ],
    "mz-m2 note": [
        "M1"
    ],
    "mz-m571c": [
        "M1"
    ],
    "m571c": [
        "M1"
    ],
    "m2 note": [
        "M1"
    ],
    "m681c": [
        "M1"
    ],
    "m3 note": [
        "M1"
    ],
    "m621c": [
        "M1"
    ],
    "mz-m6 note": [
        "M1"
    ],
    "m721c": [
        "M1"
    ],
    "meizu note8": [
        "M1"
    ],
    "meizu note9": [
        "M1"
    ],
    "m-pp2g530": [
        "MC"
    ],
    "m-ppag550": [
        "MC"
    ],
    "m-ppg700": [
        "MC"
    ],
    "m-ppxs531": [
        "MC"
    ],
    "m-pp2s550": [
        "MC"
    ],
    "m-ppxs551u": [
        "MC"
    ],
    "m-pp2s650": [
        "MC"
    ],
    "m-pp2s650c": [
        "MC"
    ],
    "m-mp75s23g": [
        "MC"
    ],
    "m-mp720m": [
        "MC"
    ],
    "m-mp721m": [
        "MC"
    ],
    "m-mp7s2a3g": [
        "MC"
    ],
    "m-mp7s2d3g": [
        "MC"
    ],
    "m-mp7s2b3g": [
        "MC"
    ],
    "m-mp7s2k3g": [
        "MC"
    ],
    "m-mp5303g": [
        "MC"
    ],
    "lumia 640 xl dual sim": [
        "MS",
        "NK"
    ],
    "rm-1096": [
        "MS"
    ],
    "lumia 950 xl": [
        "MS",
        "NK"
    ],
    "n1t": [
        "OP"
    ],
    "sm-f9000": [
        "SA"
    ],
    "samsung sm-f900u": [
        "SA"
    ],
    "samsung sm-f907b": [
        "SA"
    ],
    "samsung sm-f907n": [
        "SA"
    ],
    "samsung sm-f900f": [
        "SA"
    ],
    "gt-i9080": [
        "SA"
    ],
    "gt-i9128i": [
        "SA"
    ],
    "sm-g710": [
        "SA"
    ],
    "samsung sm-g7105": [
        "SA"
    ],
    "sm-g7102": [
        "SA"
    ],
    "sm-g710l": [
        "SA"
    ],
    "gt-i9082": [
        "SA"
    ],
    "gt-i9082l": [
        "SA"
    ],
    "gt-i9060": [
        "SA"
    ],
    "gt-i9063t": [
        "SA"
    ],
    "samsung-gt-i9168_td": [
        "SA"
    ],
    "sm-g5308w": [
        "SA"
    ],
    "sm-g530bt": [
        "SA"
    ],
    "sm-g530m": [
        "SA"
    ],
    "sm-g530mu": [
        "SA"
    ],
    "sm-g5306w": [
        "SA"
    ],
    "sm-s920l": [
        "SA"
    ],
    "samsung sm-g530h": [
        "SA"
    ],
    "sm-g530f": [
        "SA"
    ],
    "samsung-sm-g530az": [
        "SA"
    ],
    "sm-g530t": [
        "SA"
    ],
    "sm-g530w": [
        "SA"
    ],
    "sm-g530r7": [
        "SA"
    ],
    "sm-g5309w": [
        "SA"
    ],
    "sm-g530p": [
        "SA"
    ],
    "samsung-sm-g530a": [
        "SA"
    ],
    "sm-g530r4": [
        "SA"
    ],
    "samsung sm-g531f": [
        "SA"
    ],
    "samsung sm-g531h": [
        "SA"
    ],
    "samsung sm-g532f": [
        "SA"
    ],
    "sm-g531y": [
        "SA"
    ],
    "sm-g531bt": [
        "SA"
    ],
    "sm-g531m": [
        "SA"
    ],
    "sm-g532m": [
        "SA"
    ],
    "samsung sm-g532g": [
        "SA"
    ],
    "samsung sm-g532mt": [
        "SA"
    ],
    "sm-g750f": [
        "SA"
    ],
    "sm-g750h": [
        "SA"
    ],
    "sm-g7508q": [
        "SA"
    ],
    "samsung-sm-g750a": [
        "SA"
    ],
    "samsung-sm-g7509": [
        "SA"
    ],
    "gt-i9152": [
        "SA"
    ],
    "samsung gt-i9152": [
        "SA"
    ],
    "gt-i9158": [
        "SA"
    ],
    "gt-i9205": [
        "SA"
    ],
    "samsung gt-i9200": [
        "SA"
    ],
    "gt-n7000": [
        "SA"
    ],
    "sm-n970f": [
        "SA"
    ],
    "sm-n970u": [
        "SA"
    ],
    "sm-n970x": [
        "SA"
    ],
    "samsung sm-n9700": [
        "SA"
    ],
    "samsung sm-n970u1": [
        "SA"
    ],
    "samsung sm-n970w": [
        "SA"
    ],
    "samsung sm-n971n": [
        "SA"
    ],
    "sm-n770x": [
        "SA"
    ],
    "sm-n770f": [
        "SA"
    ],
    "sm-n9750": [
        "SA"
    ],
    "sm-n975f": [
        "SA"
    ],
    "sm-n975u": [
        "SA"
    ],
    "sm-n975u1": [
        "SA"
    ],
    "sm-n975w": [
        "SA"
    ],
    "sm-n976v": [
        "SA"
    ],
    "sc-01m": [
        "SA",
        "SU"
    ],
    "samsung sm-n975x": [
        "SA"
    ],
    "samsung sm-n975xu": [
        "SA"
    ],
    "samsung sm-n9760": [
        "SA"
    ],
    "samsung sm-n976n": [
        "SA"
    ],
    "sm-n976u": [
        "SA"
    ],
    "sm-n976q": [
        "SA"
    ],
    "scv45": [
        "SA"
    ],
    "sm-n980f": [
        "SA"
    ],
    "samsung sm-n980f": [
        "SA"
    ],
    "samsung sm-n981b": [
        "SA"
    ],
    "sm-n981n": [
        "SA"
    ],
    "sm-n981u1": [
        "SA"
    ],
    "sm-n981u": [
        "SA"
    ],
    "sm-n981w": [
        "SA"
    ],
    "samsung sm-n985f": [
        "SA"
    ],
    "sm-n986b": [
        "SA"
    ],
    "sm-n986n": [
        "SA"
    ],
    "samsung sm-n986b": [
        "SA"
    ],
    "samsung-sm-n9008v_td": [
        "SA"
    ],
    "sm-n9009": [
        "SA"
    ],
    "sm-n9008v": [
        "SA"
    ],
    "sm-n900v": [
        "SA"
    ],
    "sm-n900w8": [
        "SA"
    ],
    "sm-n900k": [
        "SA"
    ],
    "sm-n900p": [
        "SA"
    ],
    "samsung sm-n900t": [
        "SA"
    ],
    "samsung sm-n900v": [
        "SA"
    ],
    "samsung-sm-n900a": [
        "SA"
    ],
    "sc-01f": [
        "SA",
        "SU"
    ],
    "sm-n9006": [
        "SA"
    ],
    "sm-n9000q": [
        "SA"
    ],
    "sm-n900t": [
        "SA"
    ],
    "sm-n900s": [
        "SA"
    ],
    "samsung sm-n9005": [
        "SA"
    ],
    "samsung sm-n900": [
        "SA"
    ],
    "scl22": [
        "SA"
    ],
    "sm-n9002": [
        "SA"
    ],
    "sm-9005": [
        "SA"
    ],
    "sm-n750l": [
        "SA"
    ],
    "sm-n7500q": [
        "SA"
    ],
    "samsung sm-n7505": [
        "SA"
    ],
    "samsung sm-n750": [
        "SA"
    ],
    "samsung sm-n7502": [
        "SA"
    ],
    "n9100": [
        "SA"
    ],
    "sm-n910f": [
        "SA"
    ],
    "sm-910u": [
        "SA"
    ],
    "samsung sm-n915fy": [
        "SA"
    ],
    "sm-n916s": [
        "SA"
    ],
    "sm-n916k": [
        "SA"
    ],
    "sm-n916l": [
        "SA"
    ],
    "sm-n920v": [
        "SA"
    ],
    "sm-n920t": [
        "SA"
    ],
    "sm-n920x": [
        "SA"
    ],
    "sm-n920f": [
        "SA"
    ],
    "samsung sm-n920i": [
        "SA"
    ],
    "samsung sm-n920s": [
        "SA"
    ],
    "sm-n920c": [
        "SA"
    ],
    "sm-n920k": [
        "SA"
    ],
    "sm-n920r7": [
        "SA"
    ],
    "samsung sm-n9200": [
        "SA"
    ],
    "sm-n920l": [
        "SA"
    ],
    "sm-n920g": [
        "SA"
    ],
    "sm-n920r6": [
        "SA"
    ],
    "samsung sm-n920r4": [
        "SA"
    ],
    "samsung sm-n920w8": [
        "SA"
    ],
    "sm-n920p": [
        "SA"
    ],
    "sm-n9208": [
        "SA"
    ],
    "sm-n930f": [
        "SA"
    ],
    "sm-n930s": [
        "SA"
    ],
    "sm-n930t": [
        "SA"
    ],
    "sm-n9300": [
        "SA"
    ],
    "sm-n930v": [
        "SA"
    ],
    "sm-n930p": [
        "SA"
    ],
    "scv34": [
        "SA"
    ],
    "sm-n950u1": [
        "SA"
    ],
    "sm-n950f": [
        "SA"
    ],
    "scv37": [
        "SA"
    ],
    "samsung sm-n950f": [
        "SA"
    ],
    "sc-01k": [
        "SA",
        "SU"
    ],
    "scv40": [
        "SA"
    ],
    "sc-01l": [
        "SA",
        "SU"
    ],
    "sm-n960f": [
        "SA"
    ],
    "sc-01g": [
        "SA",
        "SU"
    ],
    "sm-n935f": [
        "SA"
    ],
    "sm-n935s": [
        "SA"
    ],
    "sm-n935l": [
        "SA"
    ],
    "sm-n935k": [
        "SA"
    ],
    "sph-l900": [
        "SA"
    ],
    "gt-n7100": [
        "SA"
    ],
    "sch-i605": [
        "SA"
    ],
    "sch-r950": [
        "SA",
        "UC"
    ],
    "sch-n719": [
        "SA"
    ],
    "n7100": [
        "SA"
    ],
    "gt-n7105t": [
        "SA"
    ],
    "gt-n7105": [
        "SA"
    ],
    "xm50t": [
        "SO"
    ],
    "d5303": [
        "SO"
    ],
    "d5306": [
        "SO"
    ],
    "xm50h": [
        "SO"
    ],
    "d5316": [
        "SO"
    ],
    "d5322": [
        "SO"
    ],
    "sonyc6806": [
        "SO"
    ],
    "xl39h": [
        "SO"
    ],
    "c6806": [
        "SO"
    ],
    "c6802": [
        "SO"
    ],
    "c6833": [
        "SO"
    ],
    "sol24": [
        "SO"
    ],
    "c6843": [
        "SO"
    ],
    "xperia z ultra": [
        "SO"
    ],
    "zur722m": [
        "SS"
    ],
    "phablet 5,3 q": [
        "T3"
    ],
    "trevi_reverse_5.5q": [
        "T3"
    ],
    "trevi phablet 6 s": [
        "T3"
    ],
    "hm note 1td": [
        "XI"
    ],
    "mi note lte": [
        "XI"
    ],
    "mi_note_pro": [
        "XI"
    ],
    "hm note 1w": [
        "XI"
    ],
    "redmi note 2": [
        "XI"
    ],
    "redmi_note_2": [
        "XI"
    ],
    "redmi_note_3": [
        "XI"
    ],
    "redmi note 3": [
        "XI"
    ],
    "hm note 1lte": [
        "XI"
    ],
    "hm note 1ltew": [
        "XI"
    ],
    "hm note 1lteglobal": [
        "XI"
    ],
    "redmi note 5 pro": [
        "XI"
    ],
    "redmi note 5a prime": [
        "XI"
    ],
    "redmi note 6 pro": [
        "XI"
    ],
    "redmi note 7 pro": [
        "XI"
    ],
    "m2003j15sc": [
        "XI"
    ],
    "samsung sm-f916b": [
        "SA"
    ],
    "sm-f916n": [
        "SA"
    ],
    "samsung sm-f916q": [
        "SA"
    ],
    "samsung sm-f916u": [
        "SA"
    ],
    "sm-f916u1": [
        "SA"
    ],
    "samsung sm-f916w": [
        "SA"
    ],
    "sm-n930x": [
        "SA"
    ],
    "sm-n930k": [
        "SA"
    ],
    "sm-n930a": [
        "SA"
    ],
    "sm-n930l": [
        "SA"
    ],
    "sm-n930u": [
        "SA"
    ],
    "sm-n930r4": [
        "SA"
    ],
    "sm-n930r6": [
        "SA"
    ],
    "sm-n930r7": [
        "SA"
    ],
    "sm-n930w8": [
        "SA"
    ],
    "samsung sm-g7106": [
        "SA"
    ],
    "samsung sm-g7108": [
        "SA"
    ],
    "samsung sm-g7109": [
        "SA"
    ],
    "samsung sm-g7102t": [
        "SA"
    ],
    "samsung sm-g7105h": [
        "SA"
    ],
    "samsung sm-g7105l": [
        "SA"
    ],
    "samsung sm-g710k": [
        "SA"
    ],
    "samsung sm-g710s": [
        "SA"
    ],
    "samsung sm-n9810": [
        "SA"
    ],
    "sm-n9860": [
        "SA"
    ],
    "sm-f900w": [
        "SA"
    ],
    "scg05": [
        "SA"
    ],
    "sm-f9160": [
        "SA"
    ],
    "sc-53a": [
        "SA",
        "SU"
    ],
    "sm-n975c": [
        "SA"
    ],
    "m2010j19sc": [
        "XI"
    ],
    "m2007j22c": [
        "XI"
    ],
    "note 9p": [
        "UL"
    ],
    "m2101k6i": [
        "XI"
    ],
    "itel w6502": [
        "IZ"
    ],
    "m2007j17c": [
        "XI"
    ],
    "m2101k7ai": [
        "XI"
    ],
    "tecno s9": [
        "TB"
    ],
    "m2101k6r": [
        "XI"
    ],
    "a001xm": [
        "XI"
    ],
    "astro6": [
        "MW"
    ],
    "m2101k6p": [
        "XI"
    ],
    "m2101k7bg": [
        "XI"
    ],
    "m2101k7bny": [
        "XI"
    ],
    "md-03p": [
        "7P"
    ],
    "note 11p": [
        "UL"
    ],
    "sm-n950u": [
        "SA"
    ],
    "htc6600lvw": [
        "HT"
    ],
    "redmi note 4": [
        "XI"
    ],
    "m5 note": [
        "M1"
    ],
    "sm-n960u": [
        "SA"
    ],
    "redmi note 8t": [
        "XI"
    ],
    "sm-n910c": [
        "SA"
    ],
    "symbol r60": [
        "HV"
    ],
    "k01n": [
        "AU"
    ],
    "k019": [
        "AU"
    ],
    "infinix x604": [
        "IF"
    ],
    "m1908c3jgg": [
        "XI"
    ],
    "m2101k7bi": [
        "XI"
    ],
    "m2103k19y": [
        "XI"
    ],
    "mi note 10": [
        "XI"
    ],
    "tecno ld7j": [
        "TB"
    ],
    "tecno le7n": [
        "TB"
    ],
    "tecno ld7": [
        "TB"
    ],
    "zte a2121l": [
        "ZT"
    ],
    "redmi note 9s": [
        "XI"
    ],
    "as360": [
        "DX"
    ],
    "redmi note 5": [
        "XI"
    ],
    "m6 note": [
        "M1"
    ],
    "infinix x692": [
        "IF"
    ],
    "infinix x690b": [
        "IF"
    ],
    "infinix x687b": [
        "IF"
    ],
    "infinix x687": [
        "IF"
    ],
    "infinix x683": [
        "IF"
    ],
    "infinix x695c": [
        "IF"
    ],
    "redmi note 5a": [
        "XI"
    ],
    "m10 ultra": [],
    "sm-n950n": [
        "SA"
    ],
    "sm-n971n": [
        "SA"
    ],
    "sm-n986w": [
        "SA"
    ],
    "zte 8010ru": [
        "ZT"
    ],
    "redmi note 4x": [
        "XI"
    ],
    "mi note 2": [
        "XI"
    ],
    "xig02": [
        "XI"
    ],
    "sm-f711b": [
        "SA"
    ],
    "joyeuse": [
        "XI"
    ],
    "redmi note 10 pro": [
        "XI"
    ],
    "m2103k19c": [
        "XI"
    ],
    "infinix x693": [
        "IF"
    ],
    "m2103k19i": [
        "XI"
    ],
    "redmi note 9": [
        "XI"
    ],
    "redmi note 10": [
        "XI"
    ],
    "redmi note 10s": [
        "XI"
    ],
    "redmi note 10t": [
        "XI"
    ],
    "redmi note 10 5g": [
        "XI"
    ],
    "redmi note 9t": [
        "XI"
    ],
    "redmi note 8 (2021)": [
        "XI"
    ],
    "sm-f926b": [
        "SA"
    ],
    "sm-n986u": [
        "SA"
    ],
    "sm-n976b": [
        "SA"
    ],
    "m2011j18c": [
        "XI"
    ],
    "sm-n9600": [
        "SA"
    ],
    "huawei mt7-tl10": [
        "HU"
    ],
    "htc0p3p7": [
        "HT"
    ],
    "sm-n910v": [
        "SA"
    ],
    "iphone10,6": [
        "AP"
    ],
    "sc-55b": [
        "SA",
        "SU"
    ],
    "scg11": [
        "SA"
    ],
    "scg12": [
        "SA"
    ],
    "sc-54b": [
        "SA",
        "SU"
    ],
    "sm-n950w": [
        "SA"
    ],
    "begonia": [
        "XI"
    ],
    "redmi note 9 pro max": [
        "XI"
    ],
    "redmi note 7s": [
        "XI"
    ],
    "mz-note9": [
        "M1"
    ],
    "mz-infinix x695c": [
        "IF",
        "M1"
    ],
    "mz-m5 note": [
        "M1"
    ],
    "sm-n9500": [
        "SA"
    ],
    "sc-02f": [
        "SA",
        "SU"
    ],
    "21091116c": [
        "XI"
    ],
    "itel l6503": [
        "IZ"
    ],
    "sm-n960u1": [
        "SA"
    ],
    "redmi note 10 pro max": [
        "XI"
    ],
    "21091116ac": [
        "XI"
    ],
    "21091116i": [
        "XI"
    ],
    "21091116uc": [
        "XI"
    ],
    "21121119sc": [
        "XI"
    ],
    "2201117tg": [
        "XI"
    ],
    "m1901f71": [
        "XI"
    ],
    "note_7_pro": [
        "J9"
    ],
    "redmi note 5a lite": [
        "XI"
    ],
    "infinix x663b": [
        "IF"
    ],
    "infinix x683b": [
        "IF"
    ],
    "infinix x605": [
        "IF"
    ],
    "note_3_pro": [
        "J9"
    ],
    "note_11_pro": [
        "J9"
    ],
    "infinix x695": [
        "IF"
    ],
    "sm-f9260": [
        "SA"
    ],
    "zte a2121": [
        "ZT"
    ],
    "21091116ai": [
        "XI"
    ],
    "2201117ti": [
        "XI"
    ],
    "tecno le6": [
        "TB"
    ],
    "2201117sy": [
        "XI"
    ],
    "2201117sg": [
        "XI"
    ],
    "infinix x663": [
        "IF"
    ],
    "infinix x6810": [
        "IF"
    ],
    "infinix x6811": [
        "IF"
    ],
    "infinix x695d": [
        "IF"
    ],
    "iphone14,6": [
        "AP"
    ],
    "samsung sm-f926w": [
        "SA"
    ],
    "2201117tl": [
        "XI"
    ],
    "sm-f926u": [
        "SA"
    ],
    "samsung sm-f711u": [
        "SA"
    ],
    "21091116ug": [
        "XI"
    ],
    "sm-n960w": [
        "SA"
    ],
    "samsung redmi note 9s": [
        "XI"
    ],
    "note_1_lite": [
        "J9"
    ],
    "2201117si": [
        "XI"
    ],
    "2201116ti": [
        "XI"
    ],
    "willow": [
        "XI"
    ],
    "2201116tg": [
        "XI"
    ],
    "rosemary": [
        "XI"
    ],
    "a101xm": [
        "XI"
    ],
    "tecno le8": [
        "TB"
    ],
    "22031116bg": [
        "XI"
    ],
    "m1901f7s": [
        "XI"
    ],
    "redmi note 11s": [
        "XI"
    ],
    "2201116si": [
        "XI"
    ],
    "22041219c": [
        "XI"
    ],
    "tecno le6h": [
        "TB"
    ],
    "infinix x698": [
        "IF"
    ],
    "infinix x6811b": [
        "IF"
    ],
    "infinix x604b": [
        "IF"
    ],
    "infinix x572-lte": [
        "IF"
    ],
    "infinix x572": [
        "IF"
    ],
    "infinix x571": [
        "IF"
    ],
    "infinix x610b": [
        "IF"
    ],
    "infinix x670": [
        "IF"
    ],
    "2201116sr": [
        "XI"
    ],
    "infinix x6815b": [
        "IF"
    ],
    "infinix x690c": [
        "IF"
    ],
    "tecno lf7": [
        "TB"
    ],
    "2201117sl": [
        "XI"
    ],
    "infinix x663c": [
        "IF"
    ],
    "infinix x6815": [
        "IF"
    ],
    "pipit": [
        "GO"
    ],
    "tecno lf7n": [
        "TB"
    ],
    "infinix x672": [
        "IF"
    ],
    "sm-f900u1": [
        "SA"
    ],
    "honor x10 max": [
        "HU"
    ],
    "kkg-an00": [
        "HU"
    ],
    "22041216c": [
        "XI"
    ],
    "sm-n986c": [
        "SA"
    ],
    "v2170a": [
        "VV"
    ],
    "v2178a": [
        "VV"
    ],
    "m2003j6b2g": [
        "XI"
    ],
    "m2003j6a1g": [
        "XI"
    ],
    "sm-n915s": [
        "SA"
    ],
    "sm-n915p": [
        "SA"
    ],
    "sm-n915l": [
        "SA"
    ],
    "sm-n915k": [
        "SA"
    ],
    "sm-n915g": [
        "SA"
    ],
    "sm-n915f": [
        "SA"
    ],
    "sm-n910s": [
        "SA"
    ],
    "infinix x676b": [
        "IF"
    ],
    "infinix x671b": [
        "IF"
    ],
    "infinix x663d": [
        "IF"
    ],
    "sm-f721n": [
        "SA"
    ],
    "22041216uc": [
        "XI"
    ],
    "m2003j15ss": [
        "XI"
    ],
    "m2002f4lg": [
        "XI"
    ],
    "m1910f4s": [
        "XI"
    ],
    "m1908c3ji": [
        "XI"
    ],
    "m1908c3jh": [
        "XI"
    ],
    "redmi note 11": [
        "XI"
    ],
    "redmi note 11 pro": [
        "XI"
    ],
    "sm-f936u": [
        "SA"
    ],
    "2201116sc": [
        "XI"
    ],
    "sm-f936b": [
        "SA"
    ],
    "sm-f721b": [
        "SA"
    ],
    "tecno lg6n": [
        "TB"
    ],
    "sm-f936n": [
        "SA"
    ],
    "samsung sm-f936n": [
        "SA"
    ],
    "sm-f721u1": [
        "SA"
    ],
    "sm-f9360": [
        "SA"
    ],
    "sm-f936u1": [
        "SA"
    ],
    "sm-g781b": [
        "SA"
    ],
    "a1601": [
        "OP"
    ],
    "clt-l29": [
        "HU"
    ],
    "safaricom_kimem_kerefa_4g": [
        "X1"
    ],
    "sm-a102u": [
        "SA"
    ],
    "sm-s134dl": [
        "SA"
    ],
    "iphone ios/16.6": [
        "AP"
    ],
    "pixel 7 pro": [
        "GO"
    ],
    "sm-g991u": [
        "SA"
    ],
    "ipod5,1": [
        "AP"
    ],
    "panasonic sv-mv100": [
        "PA"
    ],
    "hmt390q": [
        "XR"
    ],
    "hmt400": [
        "XR"
    ],
    "nw-z1000series": [
        "SO"
    ],
    "lenco diverso-700": [
        "LN"
    ],
    "drp29101": [
        "RC"
    ],
    "drp2091": [
        "RC"
    ],
    "nw-zx500series": [
        "SO"
    ],
    "musicpad_m1": [
        "V2"
    ],
    "musicpad_h1": [
        "V2"
    ],
    "hitv205n": [
        "HI"
    ],
    "nw-a300series": [
        "SO"
    ],
    "ipod7,1": [
        "AP"
    ],
    "nw-a100series": [
        "SO"
    ],
    "xdp-300r": [
        "PI"
    ],
    "r6iii": [
        "HBY"
    ],
    "swofy m503-pro": [
        "SWO"
    ],
    "da220hql": [
        "AC"
    ],
    "da241hl": [
        "AC"
    ],
    "vsd220": [
        "VS"
    ],
    "ifp7550-3": [
        "VS"
    ],
    "ifp9850-3": [
        "VS"
    ],
    "ifp8650-3": [
        "VS"
    ],
    "ifp6550-3": [
        "VS"
    ],
    "wt22m-fi": [
        "55"
    ],
    "wt19m-fi": [
        "55"
    ],
    "t2s_lite": [
        "2J"
    ],
    "xdh-0f-a1": [
        "XW"
    ],
    "xdh-17-a1": [
        "XW"
    ],
    "xdh-18-a1": [
        "XW"
    ],
    "xdh-21-a1": [
        "XW"
    ],
    "xdh-29-b1": [
        "XW"
    ],
    "xdh-2a-b1": [
        "XW"
    ],
    "10bdl4151t": [
        "PH"
    ],
    "da222hql": [
        "AC"
    ],
    "blm-00": [
        "HU"
    ],
    "xd-sdd05-2101": [
        "XW"
    ],
    "portalgo": [
        "OQ"
    ],
    "aeobc": [
        "KN"
    ],
    "aeokn": [
        "KN"
    ],
    "aeoch": [
        "KN"
    ],
    "aeocw": [
        "KN"
    ],
    "aeohy": [
        "KN"
    ],
    "aeocn": [
        "KN"
    ],
    "aeoat": [
        "KN"
    ],
    "aeota": [
        "KN"
    ],
    "aeobp": [
        "KN"
    ],
    "yndx-00055": [
        "YD"
    ],
    "yandexstation_2": [
        "YD"
    ],
    "aeorh": [
        "KN"
    ],
    "aeohp": [
        "KN"
    ],
    "i7u": [
        "A9"
    ],
    "i4u": [
        "A9"
    ],
    "i55d": [
        "A9"
    ],
    "i55k": [
        "A9"
    ],
    "i5e": [
        "A9"
    ],
    "i5k": [
        "A9"
    ],
    "i7d": [
        "A9"
    ],
    "advan m4": [
        "A9"
    ],
    "advan s40": [
        "A9"
    ],
    "s45e": [
        "A9"
    ],
    "s4z": [
        "A9"
    ],
    "s50h": [
        "A9"
    ],
    "s5e_nxt": [
        "A9"
    ],
    "s5j+": [
        "A9"
    ],
    "s7d": [
        "A9"
    ],
    "allcall_alpha": [
        "AA"
    ],
    "allcall_atom": [
        "AA"
    ],
    "allcall_bro": [
        "AA"
    ],
    "heat3": [
        "AA"
    ],
    "heat4": [
        "AA"
    ],
    "hot 1 mini+": [
        "AA"
    ],
    "hot 1 x": [
        "AA"
    ],
    "hot 2 x": [
        "AA"
    ],
    "hot5 mini": [
        "AA"
    ],
    "allcall_madrid": [
        "AA"
    ],
    "allcall_rio": [
        "AA"
    ],
    "allcall_rio_pro": [
        "AA"
    ],
    "allcall_rio_s": [
        "AA"
    ],
    "rio_x": [
        "AA"
    ],
    "allcall_s1": [
        "AA"
    ],
    "allcall_s1_x": [
        "AA"
    ],
    "allegro": [
        "AC"
    ],
    "v360": [
        "AC"
    ],
    "v370": [
        "AC"
    ],
    "e39": [
        "AC"
    ],
    "acer e320": [
        "AC"
    ],
    "acer e320-orange": [
        "AC"
    ],
    "s55": [
        "AC",
        "SI"
    ],
    "m220": [
        "AC"
    ],
    "tm01": [
        "AC"
    ],
    "e310": [
        "AC"
    ],
    "s510": [
        "AC"
    ],
    "s520": [
        "AC",
        "OB"
    ],
    "acer-z110": [
        "AC"
    ],
    "z130": [
        "AC"
    ],
    "z160": [
        "AC"
    ],
    "z150": [
        "AC"
    ],
    "z500": [
        "AC"
    ],
    "z520": [
        "AC"
    ],
    "t02": [
        "AC"
    ],
    "t03": [
        "AC"
    ],
    "t04": [
        "AC"
    ],
    "t06": [
        "AC"
    ],
    "t07": [
        "AC"
    ],
    "t08": [
        "AC"
    ],
    "acertd600": [
        "AC"
    ],
    "hollogram hi 4934": [
        "AD"
    ],
    "hollogram hl5446": [
        "AD"
    ],
    "hl6246": [
        "AD"
    ],
    "buzz 1 lite": [
        "AE"
    ],
    "buzz 1 plus": [
        "AE"
    ],
    "am530": [
        "AG"
    ],
    "am405": [
        "AG"
    ],
    "am415": [
        "AG"
    ],
    "am518": [
        "AG"
    ],
    "am515": [
        "AG"
    ],
    "am508": [
        "AG"
    ],
    "am527": [
        "AG"
    ],
    "am350": [
        "AG"
    ],
    "am535": [
        "AG"
    ],
    "am523": [
        "AG"
    ],
    "am520": [
        "AG"
    ],
    "am402": [
        "AG"
    ],
    "am450": [
        "AG"
    ],
    "am407": [
        "AG"
    ],
    "am355": [
        "AG"
    ],
    "am410": [
        "AG"
    ],
    "am509": [
        "AG"
    ],
    "eco e2": [
        "AK"
    ],
    "glory_g5": [
        "AK"
    ],
    "glory l3": [
        "AK",
        "BR"
    ],
    "glory o2": [
        "AK",
        "BR",
        "OT"
    ],
    "x6 metal": [
        "AK"
    ],
    "akai k40": [
        "AK"
    ],
    "akai leon quadra": [
        "AK",
        "PG"
    ],
    "akai_neo": [
        "AK"
    ],
    "5033x": [
        "AL"
    ],
    "5033e": [
        "AL"
    ],
    "5033g": [
        "AL"
    ],
    "5033o": [
        "AL"
    ],
    "5033y": [
        "AL"
    ],
    "5033m": [
        "AL"
    ],
    "5033t": [
        "AL"
    ],
    "5033x_eea": [
        "AL"
    ],
    "5033d_eea": [
        "AL"
    ],
    "5033f_eea": [
        "AL"
    ],
    "5033d": [
        "AL"
    ],
    "5033j": [
        "AL"
    ],
    "5033d_ru": [
        "AL"
    ],
    "5009d_ru": [
        "AL"
    ],
    "5009d": [
        "AL"
    ],
    "5009a": [
        "AL"
    ],
    "5003g": [
        "AL"
    ],
    "5003d": [
        "AL"
    ],
    "5003d_ru": [
        "AL"
    ],
    "5003a": [
        "AL"
    ],
    "5003d_eea": [
        "AL"
    ],
    "5024a": [
        "AL"
    ],
    "5024d_ru": [
        "AL"
    ],
    "5024j": [
        "AL"
    ],
    "5024d_eea": [
        "AL"
    ],
    "5028y_eea": [
        "AL"
    ],
    "5028a": [
        "AL"
    ],
    "5001a": [
        "AL"
    ],
    "5007a": [
        "AL"
    ],
    "5059a": [
        "AL"
    ],
    "5059x": [
        "AL"
    ],
    "5059d": [
        "AL"
    ],
    "5059y": [
        "AL"
    ],
    "5059i": [
        "AL"
    ],
    "5059t": [
        "AL"
    ],
    "5059d_ru": [
        "AL"
    ],
    "5008u": [
        "AL"
    ],
    "5008d_eea": [
        "AL"
    ],
    "5008y_eea": [
        "AL"
    ],
    "5008y_ru": [
        "AL"
    ],
    "5052d": [
        "AL"
    ],
    "5053y": [
        "AL"
    ],
    "5053k_eea": [
        "AL"
    ],
    "5053k_ru": [
        "AL"
    ],
    "5053y_ru": [
        "AL"
    ],
    "5052y": [
        "AL"
    ],
    "5052d_ru": [
        "AL"
    ],
    "5053a": [
        "AL"
    ],
    "5029e": [
        "AL"
    ],
    "5026j": [
        "AL"
    ],
    "5026d": [
        "AL"
    ],
    "5026a": [
        "AL"
    ],
    "5034d": [
        "AL"
    ],
    "5034d_ru": [
        "AL"
    ],
    "5099a": [
        "AL"
    ],
    "5099i": [
        "AL"
    ],
    "5099u": [
        "AL"
    ],
    "5099y": [
        "AL"
    ],
    "5099d": [
        "AL"
    ],
    "5099d_ru": [
        "AL"
    ],
    "5032w": [
        "AL"
    ],
    "5058i": [
        "AL"
    ],
    "5058a": [
        "AL"
    ],
    "5058i_ru": [
        "AL"
    ],
    "5058y": [
        "AL"
    ],
    "5048y_eea": [
        "AL"
    ],
    "5048a": [
        "AL"
    ],
    "5048u": [
        "AL"
    ],
    "5048y_ru": [
        "AL"
    ],
    "5086d": [
        "AL"
    ],
    "5086y": [
        "AL"
    ],
    "6062w": [
        "AL"
    ],
    "a501dl": [
        "AL"
    ],
    "a503dl": [
        "AL"
    ],
    "5046i": [
        "AL"
    ],
    "5046y": [
        "AL"
    ],
    "5046j": [
        "AL"
    ],
    "5046d": [
        "AL"
    ],
    "5046u": [
        "AL"
    ],
    "5046a": [
        "AL"
    ],
    "5046t": [
        "AL"
    ],
    "5049g": [
        "AL"
    ],
    "5011a": [
        "AL"
    ],
    "5049e": [
        "AL"
    ],
    "9008a": [
        "AL"
    ],
    "9008j": [
        "AL"
    ],
    "9008x": [
        "AL"
    ],
    "9008t": [
        "AL"
    ],
    "9008d": [
        "AL"
    ],
    "9008u": [
        "AL"
    ],
    "9008i": [
        "AL"
    ],
    "9008n": [
        "AL"
    ],
    "5046g": [
        "AL"
    ],
    "5046s": [
        "AL"
    ],
    "5049z": [
        "AL"
    ],
    "5049s": [
        "AL"
    ],
    "5085b": [
        "AL"
    ],
    "5085q": [
        "AL"
    ],
    "5085d": [
        "AL"
    ],
    "5085i": [
        "AL"
    ],
    "5085y": [
        "AL"
    ],
    "5085a": [
        "AL"
    ],
    "5085j": [
        "AL"
    ],
    "5085h": [
        "AL"
    ],
    "5085n": [
        "AL"
    ],
    "5085g": [
        "AL"
    ],
    "5085o": [
        "AL"
    ],
    "5090i": [
        "AL"
    ],
    "5090a": [
        "AL"
    ],
    "5090y": [
        "AL"
    ],
    "5059s": [
        "AL"
    ],
    "one touch 4007d": [
        "AL"
    ],
    "one_touch_4007d": [
        "AL"
    ],
    "alcatel one touch 4010a": [
        "AL"
    ],
    "one_touch_4033e": [
        "AL"
    ],
    "alcatel one touch 5020a": [
        "AL"
    ],
    "alcatel one touch 5035d": [
        "AL"
    ],
    "alcatel one touch 5035x": [
        "AL"
    ],
    "alcatel one touch 6033x": [
        "AL"
    ],
    "alcatel_one_touch_908f_orange": [
        "AL"
    ],
    "alcatel one touch 918": [
        "AL"
    ],
    "alcatel one touch 918a": [
        "AL"
    ],
    "alcatel one touch 918s": [
        "AL"
    ],
    "one_touch_960c": [
        "AL"
    ],
    "alcatel one touch 985": [
        "AL"
    ],
    "alcatel one touch 990c+": [
        "AL"
    ],
    "alcatel one touch 991": [
        "AL"
    ],
    "alcatel_one_touch_991": [
        "AL"
    ],
    "alcatel one touch 991d": [
        "AL"
    ],
    "alcatel one touch 993d": [
        "AL"
    ],
    "alcatel_one_touch_995": [
        "AL"
    ],
    "alcatel one touch 997d": [
        "AL"
    ],
    "5027b": [
        "AL"
    ],
    "alcatel one touch fierce": [
        "AL"
    ],
    "7040t": [
        "AL"
    ],
    "7040r": [
        "AL"
    ],
    "5056w": [
        "AL"
    ],
    "5056n": [
        "AL"
    ],
    "5054n": [
        "AL"
    ],
    "7048a": [
        "AL"
    ],
    "7048s": [
        "AL"
    ],
    "7048w": [
        "AL"
    ],
    "7048x": [
        "AL"
    ],
    "8030y": [
        "AL"
    ],
    "7055a": [
        "AL"
    ],
    "6037y": [
        "AL"
    ],
    "6037b": [
        "AL"
    ],
    "6037k": [
        "AL"
    ],
    "6016x": [
        "AL"
    ],
    "6016d": [
        "AL"
    ],
    "6016e": [
        "AL"
    ],
    "6036a": [
        "AL"
    ],
    "6036x": [
        "AL"
    ],
    "6036y": [
        "AL"
    ],
    "6050y": [
        "AL"
    ],
    "6039h": [
        "AL"
    ],
    "6039y": [
        "AL"
    ],
    "6039k": [
        "AL"
    ],
    "6045i": [
        "AL"
    ],
    "6045b": [
        "AL"
    ],
    "6045f": [
        "AL"
    ],
    "6045x": [
        "AL"
    ],
    "6045y": [
        "AL"
    ],
    "6045o": [
        "AL"
    ],
    "6055k": [
        "AL"
    ],
    "6055h": [
        "AL"
    ],
    "6055i": [
        "AL"
    ],
    "6055y": [
        "AL"
    ],
    "6055a": [
        "AL"
    ],
    "alcatel 6055u": [
        "AL"
    ],
    "6055b": [
        "AL"
    ],
    "6055d": [
        "AL"
    ],
    "6055z": [
        "AL"
    ],
    "6070k": [
        "AL"
    ],
    "6058a": [
        "AL"
    ],
    "6058x": [
        "AL"
    ],
    "6058d": [
        "AL"
    ],
    "6060s": [
        "AL"
    ],
    "6043d": [
        "AL"
    ],
    "6043a": [
        "AL"
    ],
    "5056i": [
        "AL"
    ],
    "one touch 4014d": [
        "AL"
    ],
    "4009a": [
        "AL"
    ],
    "4009i": [
        "AL"
    ],
    "4009f": [
        "AL"
    ],
    "4009k": [
        "AL"
    ],
    "4009m": [
        "AL"
    ],
    "4009s": [
        "AL"
    ],
    "4009x": [
        "AL"
    ],
    "4009d": [
        "AL"
    ],
    "4009e": [
        "AL"
    ],
    "4003a": [
        "AL"
    ],
    "4003j": [
        "AL"
    ],
    "4013e": [
        "AL"
    ],
    "4013j": [
        "AL"
    ],
    "4013k": [
        "AL"
    ],
    "4013x": [
        "AL"
    ],
    "4114e": [
        "AL"
    ],
    "4014a": [
        "AL"
    ],
    "4014k": [
        "AL"
    ],
    "4014m": [
        "AL"
    ],
    "4014x": [
        "AL"
    ],
    "4014e": [
        "AL"
    ],
    "4013m": [
        "AL"
    ],
    "4028a": [
        "AL"
    ],
    "4028j": [
        "AL"
    ],
    "4028s": [
        "AL"
    ],
    "4027a": [
        "AL"
    ],
    "4027n": [
        "AL"
    ],
    "4027d": [
        "AL"
    ],
    "4028e": [
        "AL"
    ],
    "4027x": [
        "AL"
    ],
    "5019d": [
        "AL"
    ],
    "5017a": [
        "AL"
    ],
    "5017e": [
        "AL"
    ],
    "5017d": [
        "AL"
    ],
    "5017o": [
        "AL"
    ],
    "5017x": [
        "AL"
    ],
    "5017b": [
        "AL"
    ],
    "4017a": [
        "AL"
    ],
    "4017d": [
        "AL"
    ],
    "4017e": [
        "AL"
    ],
    "4017f": [
        "AL"
    ],
    "4017s": [
        "AL"
    ],
    "4017x": [
        "AL"
    ],
    "4034d": [
        "AL"
    ],
    "4034a": [
        "AL"
    ],
    "4034e": [
        "AL"
    ],
    "4034g": [
        "AL"
    ],
    "4034x": [
        "AL"
    ],
    "4034l_eea": [
        "AL"
    ],
    "4060w": [
        "AL"
    ],
    "4060s": [
        "AL"
    ],
    "5010e": [
        "AL"
    ],
    "5010g": [
        "AL"
    ],
    "5010s": [
        "AL"
    ],
    "5010u": [
        "AL"
    ],
    "5010x": [
        "AL"
    ],
    "5045a": [
        "AL"
    ],
    "5045f": [
        "AL"
    ],
    "5045g": [
        "AL"
    ],
    "5045i": [
        "AL"
    ],
    "5045j": [
        "AL"
    ],
    "5045y": [
        "AL"
    ],
    "5145a": [
        "AL"
    ],
    "5041d": [
        "AL"
    ],
    "5012g": [
        "AL"
    ],
    "5012d": [
        "AL"
    ],
    "5012f": [
        "AL"
    ],
    "8050x": [
        "AL"
    ],
    "8050g": [
        "AL"
    ],
    "8050d": [
        "AL"
    ],
    "8050e": [
        "AL"
    ],
    "9001d": [
        "AL"
    ],
    "5098s": [
        "AL"
    ],
    "9001i": [
        "AL"
    ],
    "9001x": [
        "AL"
    ],
    "5023f": [
        "AL"
    ],
    "5023e": [
        "AL"
    ],
    "a571vl": [
        "AL"
    ],
    "a570bl": [
        "AL"
    ],
    "4024d": [
        "AL"
    ],
    "4024e": [
        "AL"
    ],
    "4024x": [
        "AL"
    ],
    "a464bg": [
        "AL"
    ],
    "a621bl": [
        "AL"
    ],
    "5098o": [
        "AL"
    ],
    "4045a": [
        "AL"
    ],
    "4045x": [
        "AL"
    ],
    "4045d": [
        "AL"
    ],
    "4045e": [
        "AL"
    ],
    "5042f": [
        "AL"
    ],
    "5042g": [
        "AL"
    ],
    "5042w": [
        "AL"
    ],
    "5042x": [
        "AL"
    ],
    "5042d": [
        "AL"
    ],
    "5042e": [
        "AL"
    ],
    "7043y": [
        "AL"
    ],
    "7044a": [
        "AL"
    ],
    "7044x": [
        "AL"
    ],
    "7043a": [
        "AL"
    ],
    "7043e": [
        "AL"
    ],
    "7043k": [
        "AL"
    ],
    "5015x": [
        "AL"
    ],
    "5065x": [
        "AL"
    ],
    "5016a": [
        "AL"
    ],
    "5015a": [
        "AL"
    ],
    "5015e": [
        "AL"
    ],
    "5016j": [
        "AL"
    ],
    "5116j": [
        "AL"
    ],
    "5065d": [
        "AL"
    ],
    "5065a": [
        "AL"
    ],
    "5065w": [
        "AL"
    ],
    "5025e": [
        "AL"
    ],
    "5025d": [
        "AL"
    ],
    "5054t": [
        "AL"
    ],
    "5015d": [
        "AL"
    ],
    "5051m": [
        "AL"
    ],
    "5051x": [
        "AL"
    ],
    "5051a": [
        "AL"
    ],
    "5051e": [
        "AL"
    ],
    "5051j": [
        "AL"
    ],
    "5051t": [
        "AL"
    ],
    "5051w": [
        "AL"
    ],
    "7070x": [
        "AL"
    ],
    "5051d": [
        "AL"
    ],
    "5056t": [
        "AL"
    ],
    "5056d": [
        "AL"
    ],
    "5056u": [
        "AL"
    ],
    "5056g": [
        "AL"
    ],
    "5056e": [
        "AL"
    ],
    "5056j": [
        "AL"
    ],
    "5056m": [
        "AL"
    ],
    "5056a": [
        "AL"
    ],
    "5095k": [
        "AL"
    ],
    "5095i": [
        "AL"
    ],
    "5095y": [
        "AL"
    ],
    "one touch 4015a": [
        "AL"
    ],
    "4016a": [
        "AL"
    ],
    "one touch 4015x": [
        "AL"
    ],
    "alcatel 4015t": [
        "AL"
    ],
    "4016d": [
        "AL"
    ],
    "one touch 4015d": [
        "AL"
    ],
    "one touch 4015n": [
        "AL"
    ],
    "4016x": [
        "AL"
    ],
    "4032a": [
        "AL"
    ],
    "4032x": [
        "AL"
    ],
    "4032d": [
        "AL"
    ],
    "4032e": [
        "AL"
    ],
    "5036d": [
        "AL"
    ],
    "alcatel one touch 7041x": [
        "AL"
    ],
    "alcatel one touch 7040k": [
        "AL"
    ],
    "7040a": [
        "AL"
    ],
    "7040f": [
        "AL"
    ],
    "7042a": [
        "AL"
    ],
    "alcatel one touch 7041d": [
        "AL"
    ],
    "7040d": [
        "AL"
    ],
    "7040e": [
        "AL"
    ],
    "4018a": [
        "AL"
    ],
    "4018d": [
        "AL"
    ],
    "4018e": [
        "AL"
    ],
    "4018f": [
        "AL"
    ],
    "4018m": [
        "AL"
    ],
    "4018x": [
        "AL"
    ],
    "4035x": [
        "AL"
    ],
    "4035y": [
        "AL"
    ],
    "4035d": [
        "AL"
    ],
    "4035a": [
        "AL"
    ],
    "5038d": [
        "AL"
    ],
    "5038x": [
        "AL"
    ],
    "5038a": [
        "AL"
    ],
    "5038e": [
        "AL"
    ],
    "5057m": [
        "AL"
    ],
    "5050a": [
        "AL"
    ],
    "5050s": [
        "AL"
    ],
    "5050x": [
        "AL"
    ],
    "5050y": [
        "AL"
    ],
    "7045y": [
        "AL"
    ],
    "5022e": [
        "AL"
    ],
    "5022d": [
        "AL"
    ],
    "5070d": [
        "AL"
    ],
    "6044d": [
        "AL"
    ],
    "7053d": [
        "AL"
    ],
    "a466bg": [
        "AL"
    ],
    "a574bl": [
        "AL"
    ],
    "5049w": [
        "AL"
    ],
    "5080u": [
        "AL"
    ],
    "5080x": [
        "AL"
    ],
    "5080q": [
        "AL"
    ],
    "5080a": [
        "AL"
    ],
    "5080d": [
        "AL"
    ],
    "5080f": [
        "AL"
    ],
    "5041c": [
        "AL"
    ],
    "timxl": [
        "AL"
    ],
    "5065n": [
        "AL"
    ],
    "4049d": [
        "AL"
    ],
    "4049e": [
        "AL"
    ],
    "4049g": [
        "AL"
    ],
    "4049m": [
        "AL"
    ],
    "4049x": [
        "AL"
    ],
    "5044a": [
        "AL"
    ],
    "5044d": [
        "AL"
    ],
    "5044i": [
        "AL"
    ],
    "5044k": [
        "AL"
    ],
    "5044y": [
        "AL"
    ],
    "5044t": [
        "AL"
    ],
    "5044o": [
        "AL"
    ],
    "5044p": [
        "AL"
    ],
    "4047x": [
        "AL"
    ],
    "4047f": [
        "AL"
    ],
    "4047d": [
        "AL"
    ],
    "4047n": [
        "AL"
    ],
    "5047d": [
        "AL"
    ],
    "5047y": [
        "AL"
    ],
    "5047i": [
        "AL"
    ],
    "5047u": [
        "AL"
    ],
    "4047g": [
        "AL"
    ],
    "sm-g9910": [
        "SA"
    ],
    "sm-g991n": [
        "SA"
    ],
    "sm-g991w": [
        "SA"
    ],
    "sm-g991u1": [
        "SA"
    ],
    "sm-g9980": [
        "SA"
    ],
    "sm-g998u": [
        "SA"
    ],
    "sm-g998u1": [
        "SA"
    ],
    "sm-g998w": [
        "SA"
    ],
    "sm-g998n": [
        "SA"
    ],
    "sm-g9960": [
        "SA"
    ],
    "sm-g996u1": [
        "SA"
    ],
    "sm-g996w": [
        "SA"
    ],
    "sm-g996b": [
        "SA"
    ],
    "sm-g996n": [
        "SA"
    ],
    "w717": [
        "HA"
    ],
    "myphonemy27": [
        "MY",
        "MY1"
    ],
    "s-tell m477": [
        "8L"
    ],
    "ek-5336": [
        "4K"
    ],
    "9.49.0.77": [
        "RM"
    ],
    "5.2.0.64": [
        "RM"
    ],
    "4.2.0.335": [
        "RM"
    ],
    "5.2.0.57": [
        "RM"
    ],
    "9.50.0.80": [
        "RM"
    ],
    "8.0.0.388": [
        "RM"
    ],
    "4.2.0.424": [
        "RM"
    ],
    "9.105.0.16": [
        "RM"
    ],
    "6.6.0.236": [
        "RM"
    ],
    "5.1.0.532": [
        "RM"
    ],
    "ek-5937": [
        "4K"
    ],
    "ek-5540": [
        "4K"
    ],
    "ek-8680": [
        "4K"
    ],
    "ek-5040": [
        "4K"
    ],
    "ek-6020": [
        "4K"
    ],
    "htc_tattoo_a3288": [
        "HT"
    ],
    "hammer titan 2": [
        "HAM",
        "UZ"
    ],
    "myphone_infinity_ii_lte": [
        "MY1"
    ],
    "mya17": [
        "MY"
    ],
    "myphone_pocket_18x9": [
        "MY1"
    ],
    "myphone_q-smart_iii": [
        "MY1"
    ],
    "nuvo blue nd40": [
        "N0"
    ],
    "nuvo green nd 45": [
        "N0"
    ],
    "nuvo_ns35": [
        "N0"
    ],
    "noain a900s": [
        "N1"
    ],
    "noain a913": [
        "N1"
    ],
    "noain_m15": [
        "N1"
    ],
    "noain m6": [
        "N1"
    ],
    "robin": [
        "N2"
    ],
    "navon_infinity": [
        "N3"
    ],
    "supreme chief": [
        "N3"
    ],
    "supreme_fine": [
        "N3"
    ],
    "supreme_fine_mini": [
        "N3"
    ],
    "supreme fine plus": [
        "N3"
    ],
    "superme_max": [
        "N3"
    ],
    "supreme_pro": [
        "N3"
    ],
    "navon supreme pure": [
        "N3"
    ],
    "supreme_pure_plus": [
        "N3"
    ],
    "mtn-l860": [
        "N4"
    ],
    "mtn-s620": [
        "N4"
    ],
    "noa c25": [
        "N5"
    ],
    "noa core forte": [
        "N5"
    ],
    "noa_e1": [
        "N5"
    ],
    "noa_h10": [
        "N5"
    ],
    "noa h10le": [
        "N5"
    ],
    "noa_h2": [
        "N5"
    ],
    "noa h4": [
        "N5"
    ],
    "noa h42": [
        "N5"
    ],
    "noa h43": [
        "N5"
    ],
    "noa_h44": [
        "N5"
    ],
    "noa_h44se": [
        "N5"
    ],
    "noa h4se": [
        "N5"
    ],
    "noa_h5": [
        "N5"
    ],
    "noa h6": [
        "N5"
    ],
    "noa_h8": [
        "N5"
    ],
    "noa_h9": [
        "N5"
    ],
    "hummerle": [
        "N5"
    ],
    "noa hummer lite": [
        "N5"
    ],
    "noa loop": [
        "N5"
    ],
    "noa_mg12": [
        "N5"
    ],
    "noa n2": [
        "N5"
    ],
    "noa next": [
        "N5"
    ],
    "nextse": [
        "N5"
    ],
    "noa_vision_h3": [
        "N5"
    ],
    "noa_vision_h3se": [
        "N5"
    ],
    "nobby s300": [
        "N6"
    ],
    "nobby s300 pro": [
        "N6"
    ],
    "nobby s500": [
        "N6"
    ],
    "nobby x800": [
        "N6"
    ],
    "nls-mt90": [
        "N9"
    ],
    "noblex n401": [
        "NB"
    ],
    "noblex n451": [
        "NB"
    ],
    "nbx-nb1012": [
        "NB"
    ],
    "nbx-t8a1ie": [
        "NB"
    ],
    "neffos c5/s100": [
        "NF"
    ],
    "neffos c5 max": [
        "NF"
    ],
    "tp601a": [
        "NF"
    ],
    "neffos_c9": [
        "NF"
    ],
    "neffos_c9a": [
        "NF"
    ],
    "neffos n1": [
        "NF"
    ],
    "neffos x1": [
        "NF"
    ],
    "neffos x1 lite": [
        "NF"
    ],
    "neffos x20 pro": [
        "NF"
    ],
    "neffos_x9": [
        "NF"
    ],
    "neffos y5": [
        "NF"
    ],
    "neffos y50": [
        "NF"
    ],
    "neffos y5l": [
        "NF"
    ],
    "neffos y5s": [
        "NF"
    ],
    "dynamic_fun": [
        "NG"
    ],
    "dynamic_maxi": [
        "NG"
    ],
    "dynamic racing 2": [
        "NG"
    ],
    "ngm dynamic racing 3": [
        "NG"
    ],
    "ngm dynamic star": [
        "NG"
    ],
    "forward_active": [
        "NG"
    ],
    "forwardendurance": [
        "NG"
    ],
    "forward_prime": [
        "NG"
    ],
    "forwardxtreme": [
        "NG"
    ],
    "forward_young": [
        "NG"
    ],
    "forwardzero": [
        "NG"
    ],
    "ngm legendxl": [
        "NG"
    ],
    "ngm orion": [
        "NG"
    ],
    "ngm spirit": [
        "NG"
    ],
    "ngm time": [
        "NG"
    ],
    "ngm vanity smart": [
        "NG"
    ],
    "ngm_winn": [
        "NG"
    ],
    "nokia 1": [
        "NK"
    ],
    "nokia 1 plus": [
        "NK"
    ],
    "ta-1035": [
        "NK"
    ],
    "nokia 2.1": [
        "NK"
    ],
    "ta-1032": [
        "NK"
    ],
    "nokia 3.1": [
        "NK"
    ],
    "nokia 3.1 plus": [
        "NK"
    ],
    "nokia 4.2": [
        "NK"
    ],
    "ta-1024": [
        "NK"
    ],
    "nokia 5.1": [
        "NK"
    ],
    "nokia 5.1 plus": [
        "NK"
    ],
    "ta-1003": [
        "NK"
    ],
    "ta-1054": [
        "NK"
    ],
    "ta-1021": [
        "NK"
    ],
    "nokia 6.1": [
        "NK"
    ],
    "ta-1041": [
        "NK"
    ],
    "nokia 7.1": [
        "NK"
    ],
    "ta-1004": [
        "NK"
    ],
    "ta-1052": [
        "NK"
    ],
    "nokia 8.1": [
        "NK"
    ],
    "nokia 6.1 plus": [
        "NK"
    ],
    "nokia 7 plus": [
        "NK"
    ],
    "nokia 8 sirocco": [
        "NK"
    ],
    "nokia": [
        "NK",
        "SA"
    ],
    "lumia 1520": [
        "NK"
    ],
    "1520.1": [
        "NK"
    ],
    "rm-915": [
        "NK",
        "VF"
    ],
    "rm-997": [
        "NK"
    ],
    "lumia 610": [
        "NK"
    ],
    "rm-1027": [
        "NK"
    ],
    "nokia 720t": [
        "NK"
    ],
    "800c": [
        "NK"
    ],
    "lumia 900": [
        "NK"
    ],
    "nokia 900": [
        "NK"
    ],
    "rm-910apacprc200": [
        "NK"
    ],
    "rm-892apachongko": [
        "NK"
    ],
    "nokia 925": [
        "NK"
    ],
    "rm-893": [
        "NK"
    ],
    "rm-910": [
        "NK"
    ],
    "lumia 928": [
        "NK"
    ],
    "nokia_x": [
        "NK"
    ],
    "nokia_xl": [
        "NK"
    ],
    "nuu_a1": [
        "NL"
    ],
    "nuu_a3": [
        "NL"
    ],
    "a6l-c": [
        "NL"
    ],
    "a6l-g": [
        "NL"
    ],
    "s6001l": [
        "NL"
    ],
    "n5702l": [
        "NL"
    ],
    "nuu_m3": [
        "NL"
    ],
    "n5001l": [
        "NL"
    ],
    "nuu_x5": [
        "NL"
    ],
    "nomi 3": [
        "NM"
    ],
    "nomi 3\\x81i": [
        "NM"
    ],
    "nomi 3s": [
        "NM"
    ],
    "nomi_i4510": [
        "NM"
    ],
    "i5012": [
        "NM"
    ],
    "i5013": [
        "NM"
    ],
    "i5014": [
        "NM"
    ],
    "i5032": [
        "NM"
    ],
    "i5050": [
        "NM"
    ],
    "nomi l003": [
        "NM"
    ],
    "nomi_l008": [
        "NM"
    ],
    "nomi n1": [
        "NM"
    ],
    "i5510": [
        "NM"
    ],
    "i5532": [
        "NM"
    ],
    "ns5002": [
        "NO"
    ],
    "ns5003": [
        "NO"
    ],
    "ns5005": [
        "NO"
    ],
    "ns5006": [
        "NO"
    ],
    "ns5008": [
        "NO"
    ],
    "ns5502": [
        "NO"
    ],
    "ns 5511": [
        "NO"
    ],
    "ns6": [
        "NO"
    ],
    "nim-450d": [
        "NU"
    ],
    "nim-550o": [
        "NU"
    ],
    "nim-600q": [
        "NU"
    ],
    "snexian mi430": [
        "NX"
    ],
    "nyx_a1": [
        "NY"
    ],
    "nyx_blink": [
        "NY"
    ],
    "nyx_ego": [
        "NY"
    ],
    "nyx_fenix": [
        "NY"
    ],
    "nyx_fly": [
        "NY"
    ],
    "nyx_fly_ii": [
        "NY"
    ],
    "nyx_fly_mini": [
        "NY"
    ],
    "nyx_hit": [
        "NY"
    ],
    "nyx_jak": [
        "NY"
    ],
    "nyx_join": [
        "NY"
    ],
    "nyx_noba": [
        "NY"
    ],
    "nyx_noba_ii": [
        "NY"
    ],
    "nyx_orbis": [
        "NY"
    ],
    "nyx rex": [
        "NY"
    ],
    "nyx_rex": [
        "NY"
    ],
    "nyx_shade": [
        "NY"
    ],
    "nyx_sky": [
        "NY"
    ],
    "nyx_spark": [
        "NY"
    ],
    "nyx_vox": [
        "NY"
    ],
    "nyx_zeuz_hd": [
        "NY"
    ],
    "neo6_lte": [
        "O1"
    ],
    "owwo 1s": [
        "O2"
    ],
    "owwo 4s": [
        "O2"
    ],
    "owwo 5s": [
        "O2"
    ],
    "owwo 7s": [
        "O2"
    ],
    "owwoq7": [
        "O2"
    ],
    "owwo q8": [
        "O2"
    ],
    "o+ 360 alpha plus 2.0": [
        "O3"
    ],
    "o+_air": [
        "O3"
    ],
    "o+ crunch": [
        "O3"
    ],
    "o+ ultra": [
        "O3"
    ],
    "o+ ultra 2.0": [
        "O3"
    ],
    "o+ upsized": [
        "O3"
    ],
    "o+ venti 4g": [
        "O3"
    ],
    "rc501l": [
        "O5"
    ],
    "rc555l": [
        "O5"
    ],
    "obi_s454": [
        "OB"
    ],
    "s503": [
        "OB"
    ],
    "s503+": [
        "OB"
    ],
    "s550": [
        "OB"
    ],
    "s451": [
        "OB"
    ],
    "falcon": [
        "OB"
    ],
    "s453": [
        "OB"
    ],
    "obi_s551": [
        "OB"
    ],
    "s502": [
        "OB"
    ],
    "obi_s520": [
        "OB"
    ],
    "s507": [
        "OB"
    ],
    "s452+": [
        "OB"
    ],
    "sj1.5": [
        "OB"
    ],
    "sj2.6": [
        "OB"
    ],
    "s400": [
        "OB"
    ],
    "s501": [
        "OB"
    ],
    "c15 pro": [
        "OE"
    ],
    "c16_pro": [
        "OE"
    ],
    "k10000": [
        "OE"
    ],
    "k10000 max": [
        "OE"
    ],
    "k10000 pro": [
        "OE"
    ],
    "k4000": [
        "OE"
    ],
    "k4000_lite": [
        "OE"
    ],
    "k4000 plus": [
        "OE"
    ],
    "k4000_pro": [
        "OE"
    ],
    "k5000": [
        "OE"
    ],
    "k6000": [
        "OE"
    ],
    "k6000 plus": [
        "OE"
    ],
    "k6000 pro": [
        "OE"
    ],
    "k7000": [
        "OE"
    ],
    "u20_plus": [
        "OE"
    ],
    "y4800": [
        "OE"
    ],
    "xp6700": [
        "OI"
    ],
    "xp7700": [
        "OI"
    ],
    "ouki": [
        "OK"
    ],
    "ouki_a18": [
        "OK"
    ],
    "ouki g5": [
        "OK"
    ],
    "ok a35": [
        "OK"
    ],
    "oka16s": [
        "OK"
    ],
    "oka50": [
        "OK"
    ],
    "oka50td": [
        "OK"
    ],
    "oku3": [
        "OK"
    ],
    "ouki oku3": [
        "OK"
    ],
    "one a2005": [
        "ON"
    ],
    "one a2003": [
        "ON"
    ],
    "one a2001": [
        "ON"
    ],
    "oneplus 3": [
        "ON"
    ],
    "oneplus a3000": [
        "ON"
    ],
    "oneplus a3003": [
        "ON"
    ],
    "du_oneplus3": [
        "ON"
    ],
    "next-os oneplus3": [
        "ON"
    ],
    "oneplus a3010": [
        "ON"
    ],
    "oneplus a5000": [
        "ON"
    ],
    "oneplus a5010": [
        "ON"
    ],
    "oneplus a6010": [
        "ON"
    ],
    "gm1903": [
        "ON"
    ],
    "gm1900": [
        "ON"
    ],
    "gm1901": [
        "ON"
    ],
    "gm1905": [
        "ON"
    ],
    "gm1910": [
        "ON"
    ],
    "gm1913": [
        "ON"
    ],
    "gm1915": [
        "ON"
    ],
    "gm1917": [
        "ON"
    ],
    "gm1911": [
        "ON"
    ],
    "hd1901": [
        "ON"
    ],
    "hd1903": [
        "ON"
    ],
    "hd1900": [
        "ON"
    ],
    "hd1913": [
        "ON"
    ],
    "hd1910": [
        "ON"
    ],
    "hd1911": [
        "ON"
    ],
    "gm1920": [
        "ON"
    ],
    "hd1925": [
        "ON"
    ],
    "in2013": [
        "ON"
    ],
    "in2017": [
        "ON"
    ],
    "in2010": [
        "ON"
    ],
    "in2020": [
        "ON"
    ],
    "in2023": [
        "ON"
    ],
    "ac2003": [
        "ON"
    ],
    "ac2001": [
        "ON"
    ],
    "a0001": [
        "ON"
    ],
    "one e1003": [
        "ON"
    ],
    "one e1001": [
        "ON"
    ],
    "one e1005": [
        "ON"
    ],
    "opsson d1": [
        "OO"
    ],
    "opsson imo1000": [
        "OO"
    ],
    "opsson-opsson-imo1000": [
        "OO"
    ],
    "iusai i500": [
        "OO",
        "NM"
    ],
    "iusai us16": [
        "OO"
    ],
    "iusai us8": [
        "OO"
    ],
    "iusai x2": [
        "OO"
    ],
    "opsson ivo 8800": [
        "OO"
    ],
    "opsson ivo6622": [
        "OO"
    ],
    "opsson ivo6655": [
        "OO"
    ],
    "opsson_q3": [
        "OO"
    ],
    "pchm10": [
        "OP"
    ],
    "pchm00": [
        "OP"
    ],
    "cph2077": [
        "OP"
    ],
    "cph2083": [
        "OP"
    ],
    "cph1923": [
        "OP"
    ],
    "padm00": [
        "OP"
    ],
    "cph1837": [
        "OP"
    ],
    "padt00": [
        "OP"
    ],
    "cph2015": [
        "OP"
    ],
    "cph2031": [
        "OP"
    ],
    "cph2073": [
        "OP"
    ],
    "cph2081": [
        "OP"
    ],
    "ob-oppo a31c": [
        "OP"
    ],
    "pdvm00": [
        "OP"
    ],
    "a37f": [
        "OP"
    ],
    "a37fw": [
        "OP"
    ],
    "cph1605": [
        "OP"
    ],
    "cph1805": [
        "OP"
    ],
    "cph1803": [
        "OP"
    ],
    "cph1853": [
        "OP"
    ],
    "pbbm30": [
        "OP"
    ],
    "pbam00": [
        "OP"
    ],
    "pbbt30": [
        "OP"
    ],
    "cph1809": [
        "OP"
    ],
    "pbat00": [
        "OP"
    ],
    "cph1943": [
        "OP"
    ],
    "cph1931": [
        "OP"
    ],
    "cph2061": [
        "OP"
    ],
    "pdam10": [
        "OP"
    ],
    "cph2069": [
        "OP"
    ],
    "cph2127": [
        "OP"
    ],
    "cph1701": [
        "OP"
    ],
    "cph1912": [
        "OP"
    ],
    "cph1910": [
        "OP"
    ],
    "cph1909": [
        "OP"
    ],
    "cph1905": [
        "OP"
    ],
    "pbfm00": [
        "OP"
    ],
    "cph1901": [
        "OP"
    ],
    "pbft00": [
        "OP"
    ],
    "cph1717": [
        "OP"
    ],
    "cph1801": [
        "OP"
    ],
    "pdyt20": [
        "OP"
    ],
    "pdym20": [
        "OP"
    ],
    "cph2067": [
        "OP"
    ],
    "cph1715": [
        "OP"
    ],
    "pcdm00": [
        "OP"
    ],
    "pcdt00": [
        "OP"
    ],
    "pbbt00": [
        "OP"
    ],
    "pbbm00": [
        "OP"
    ],
    "pdbm00": [
        "OP"
    ],
    "cph1729": [
        "OP"
    ],
    "cph1827": [
        "OP"
    ],
    "pcat10": [
        "OP"
    ],
    "cph1937": [
        "OP"
    ],
    "pchm30": [
        "OP"
    ],
    "cph1941": [
        "OP"
    ],
    "cph1938": [
        "OP"
    ],
    "pcpm00": [
        "OP"
    ],
    "cph2021": [
        "OP"
    ],
    "cph2059": [
        "OP"
    ],
    "pdkt00": [
        "OP"
    ],
    "pdkm00": [
        "OP"
    ],
    "pcem00": [
        "OP"
    ],
    "pcet00": [
        "OP"
    ],
    "cph1851": [
        "OP"
    ],
    "cph1920": [
        "OP"
    ],
    "cph1903": [
        "OP"
    ],
    "x9009": [
        "OP"
    ],
    "cph1911": [
        "OP"
    ],
    "cph1969": [
        "OP"
    ],
    "cph1987": [
        "OP"
    ],
    "cph1609": [
        "OP"
    ],
    "cph1613": [
        "OP"
    ],
    "cph1723": [
        "OP"
    ],
    "cph1727": [
        "OP"
    ],
    "cph1725": [
        "OP"
    ],
    "cph1859": [
        "OP"
    ],
    "cph1819": [
        "OP"
    ],
    "cph1881": [
        "OP"
    ],
    "cph1825": [
        "OP"
    ],
    "cph1823": [
        "OP"
    ],
    "x909": [
        "OP"
    ],
    "x909t": [
        "OP"
    ],
    "r827": [
        "OP"
    ],
    "r827t": [
        "OP"
    ],
    "x9076": [
        "OP"
    ],
    "x9070": [
        "OP"
    ],
    "x9077": [
        "OP"
    ],
    "x9007": [
        "OP"
    ],
    "x9006": [
        "OP"
    ],
    "x9000": [
        "OP"
    ],
    "oppo_r815t": [
        "OP"
    ],
    "r815": [
        "OP"
    ],
    "r815t": [
        "OP"
    ],
    "r815w": [
        "OP"
    ],
    "r8111": [
        "OP"
    ],
    "oppo_r821t": [
        "OP"
    ],
    "r821": [
        "OP"
    ],
    "r821t": [
        "OP"
    ],
    "u707t": [
        "OP"
    ],
    "paft00": [
        "OP"
    ],
    "cph1871": [
        "OP"
    ],
    "cph1875": [
        "OP"
    ],
    "pafm00": [
        "OP"
    ],
    "pahm00": [
        "OP"
    ],
    "cph2023": [
        "OP"
    ],
    "pdem10": [
        "OP"
    ],
    "cph2005": [
        "OP"
    ],
    "opg01": [
        "OP"
    ],
    "cph2025": [
        "OP"
    ],
    "pdem30": [
        "OP"
    ],
    "r1011": [
        "OP"
    ],
    "pbcm30": [
        "OP"
    ],
    "pbct10": [
        "OP"
    ],
    "cph1955": [
        "OP"
    ],
    "pcnm00": [
        "OP"
    ],
    "pclm50": [
        "OP"
    ],
    "n5207": [
        "OP"
    ],
    "n5209": [
        "OP"
    ],
    "r831": [
        "OP"
    ],
    "r831t": [
        "OP"
    ],
    "cph1913": [
        "OP"
    ],
    "cph1915": [
        "OP"
    ],
    "px": [
        "EL"
    ],
    "px_pro": [
        "EL"
    ],
    "r19": [
        "CB"
    ],
    "m13": [
        "L5"
    ],
    "m12": [
        "L5"
    ],
    "blade e01": [
        "ZT"
    ],
    "a103so": [
        "SO"
    ],
    "a102sh": [
        "SH"
    ],
    "jelly2_jp": [
        "UZ"
    ],
    "sog05": [
        "SO"
    ],
    "xq-bc42": [
        "SO"
    ],
    "ldn-l01": [
        "HU"
    ],
    "rmx3142": [
        "RE"
    ],
    "pfgm00": [
        "OP"
    ],
    "wp17": [
        "OE"
    ],
    "inoi 7 4+64 2021": [
        "I4"
    ],
    "redmi y2": [
        "XI"
    ],
    "tecno kf6p": [
        "TB"
    ],
    "tecno kg7n": [
        "TB"
    ],
    "tecno pr651": [
        "TB"
    ],
    "rmx3193": [
        "RE"
    ],
    "rmx3235": [
        "RE"
    ],
    "rmx3360": [
        "RE"
    ],
    "rmx3381": [
        "RE"
    ],
    "kingkong 5": [
        "CB"
    ],
    "cph2139": [
        "OP"
    ],
    "cph2249": [
        "OP"
    ],
    "g450 2021": [
        "DX"
    ],
    "21061119bi": [
        "XI"
    ],
    "inkosi": [
        "69"
    ],
    "tcl p590l": [
        "TC"
    ],
    "amoi n850": [
        "AO"
    ],
    "r831k": [
        "OP"
    ],
    "r831l": [
        "OP"
    ],
    "a33f": [
        "OP"
    ],
    "a33fw": [
        "OP"
    ],
    "r1001": [
        "OP"
    ],
    "cph1707": [
        "OP"
    ],
    "cph1719": [
        "OP"
    ],
    "cph1721": [
        "OP"
    ],
    "pact00": [
        "OP"
    ],
    "cph1835": [
        "OP"
    ],
    "pacm00": [
        "OP"
    ],
    "paam00": [
        "OP"
    ],
    "cph1831": [
        "OP"
    ],
    "cph1833": [
        "OP"
    ],
    "paat00": [
        "OP"
    ],
    "pbcm10": [
        "OP"
    ],
    "pbem00": [
        "OP"
    ],
    "cph1879": [
        "OP"
    ],
    "pbet00": [
        "OP"
    ],
    "cph1893": [
        "OP"
    ],
    "cph1877": [
        "OP"
    ],
    "pbdm00": [
        "OP"
    ],
    "pbdt00": [
        "OP"
    ],
    "cph2119": [
        "OP"
    ],
    "r8007": [
        "OP"
    ],
    "r8000": [
        "OP"
    ],
    "r2010": [
        "OP"
    ],
    "r2017": [
        "OP"
    ],
    "r8109": [
        "OP"
    ],
    "r8107": [
        "OP"
    ],
    "r6007": [
        "OP"
    ],
    "r7kf": [
        "OP"
    ],
    "r7plusm": [
        "OP"
    ],
    "r7plusf": [
        "OP"
    ],
    "r7005": [
        "OP"
    ],
    "r7007": [
        "OP"
    ],
    "oppor805": [
        "OP"
    ],
    "r805": [
        "OP"
    ],
    "r819": [
        "OP"
    ],
    "r819t": [
        "OP"
    ],
    "r8200": [
        "OP"
    ],
    "r8205": [
        "OP"
    ],
    "r8207": [
        "OP"
    ],
    "oppo_r823t": [
        "OP"
    ],
    "r823t": [
        "OP"
    ],
    "r829t": [
        "OP"
    ],
    "r830": [
        "OP"
    ],
    "r830s": [
        "OP"
    ],
    "r833t": [
        "OP"
    ],
    "x9079": [
        "OP"
    ],
    "cph1607": [
        "OP"
    ],
    "cph1611": [
        "OP"
    ],
    "oppo r9s plus": [
        "OP"
    ],
    "cph1917": [
        "OP"
    ],
    "pcat00": [
        "OP"
    ],
    "pcam00": [
        "OP"
    ],
    "pccm00": [
        "OP"
    ],
    "cph1919": [
        "OP"
    ],
    "cph1907": [
        "OP"
    ],
    "pckm00": [
        "OP"
    ],
    "cph1989": [
        "OP"
    ],
    "cph1945": [
        "OP"
    ],
    "pckm80": [
        "OP"
    ],
    "cph1951": [
        "OP"
    ],
    "cph2043": [
        "OP"
    ],
    "pdcm00": [
        "OP"
    ],
    "cph2035": [
        "OP"
    ],
    "cph2037": [
        "OP"
    ],
    "cph2009": [
        "OP"
    ],
    "pcrm00": [
        "OP"
    ],
    "cph2013": [
        "OP"
    ],
    "cph2113": [
        "OP"
    ],
    "pdpt00": [
        "OP"
    ],
    "pdpm00": [
        "OP"
    ],
    "cph2125": [
        "OP"
    ],
    "cph2109": [
        "OP"
    ],
    "pdnt00": [
        "OP"
    ],
    "pdnm00": [
        "OP"
    ],
    "peam00": [
        "OP"
    ],
    "peat00": [
        "OP"
    ],
    "cph1921": [
        "OP"
    ],
    "cph1983": [
        "OP"
    ],
    "pclm10": [
        "OP"
    ],
    "pdhm00": [
        "OP"
    ],
    "pcgm00": [
        "OP"
    ],
    "cph1979": [
        "OP"
    ],
    "pcdm10": [
        "OP"
    ],
    "pcdt10": [
        "OP"
    ],
    "oppot29": [
        "OP"
    ],
    "oppox9017": [
        "OP"
    ],
    "orange daytona": [
        "OR"
    ],
    "orange dive 30": [
        "OR"
    ],
    "orange dive 71": [
        "OR"
    ],
    "orange-dive72": [
        "OR"
    ],
    "orange dive 73": [
        "OR"
    ],
    "orange dublin": [
        "OR"
    ],
    "orange fova": [
        "OR"
    ],
    "orange gova": [
        "OR"
    ],
    "orange hi 4g": [
        "OR"
    ],
    "orange hiro": [
        "OR"
    ],
    "orange kivo": [
        "OR"
    ],
    "orange monte carlo": [
        "OR"
    ],
    "orange neva 80": [
        "OR"
    ],
    "orange neva play": [
        "OR"
    ],
    "orange nura": [
        "OR"
    ],
    "orange reyo": [
        "OR"
    ],
    "orange rise 30": [
        "OR"
    ],
    "orange-rise31": [
        "OR"
    ],
    "orange-rise32": [
        "OR"
    ],
    "orange_rise_33": [
        "OR"
    ],
    "orange rise 34": [
        "OR"
    ],
    "orange rise 40": [
        "OR"
    ],
    "orange-rise51": [
        "OR"
    ],
    "orange-rise52": [
        "OR"
    ],
    "orange rise 53": [
        "OR"
    ],
    "orange rise 54": [
        "OR"
    ],
    "orange rise 55": [
        "OR"
    ],
    "orange rono": [
        "OR"
    ],
    "orange roya": [
        "OR"
    ],
    "orange san francisco": [
        "OR"
    ],
    "orange tactile internet 2": [
        "OR"
    ],
    "orange tado": [
        "OR"
    ],
    "orange yomi": [
        "OR"
    ],
    "orange yumo": [
        "OR"
    ],
    "orange zali": [
        "OR"
    ],
    "ov-vertis-02": [
        "OV"
    ],
    "ov-vertis 5011 expi": [
        "OV"
    ],
    "vertis 5021 aim": [
        "OV"
    ],
    "ov-v10": [
        "OV"
    ],
    "own fun 5(4g)": [
        "OW"
    ],
    "own fun 6": [
        "OW"
    ],
    "own fun 7": [
        "OW"
    ],
    "own one": [
        "OW"
    ],
    "own one plus": [
        "OW"
    ],
    "own s3000d": [
        "OW"
    ],
    "own s3010": [
        "OW"
    ],
    "own s3020d": [
        "OW"
    ],
    "own s4010": [
        "OW"
    ],
    "own_s4025": [
        "OW"
    ],
    "s4035 3g": [
        "OW"
    ],
    "s4035_4g": [
        "OW"
    ],
    "own smart 9": [
        "OW"
    ],
    "antarctice": [
        "OY"
    ],
    "atlantic4g": [
        "OY"
    ],
    "indianv": [
        "OY"
    ],
    "oysters pacific 800": [
        "OY"
    ],
    "pacific 800i": [
        "OY"
    ],
    "pacific800i": [
        "OY"
    ],
    "pomp-w88a": [
        "P2"
    ],
    "pomp w89": [
        "P2"
    ],
    "king 7": [
        "P3"
    ],
    "king 7s": [
        "P3"
    ],
    "plum z405": [
        "P4"
    ],
    "w8480": [
        "P5"
    ],
    "polytron_p520": [
        "P5"
    ],
    "pw1100s": [
        "P5"
    ],
    "polytron.q2352": [
        "P5"
    ],
    "w7430": [
        "P5"
    ],
    "polytron w6500": [
        "P5"
    ],
    "polytron w7452": [
        "P5"
    ],
    "w7550": [
        "P5"
    ],
    "w8570": [
        "P5"
    ],
    "polytron r2508": [
        "P5"
    ],
    "r2401": [
        "P5"
    ],
    "polytron w1400": [
        "P5"
    ],
    "polytron_r3450": [
        "P5"
    ],
    "polytron_r3500": [
        "P5"
    ],
    "polytron_l501": [
        "P5"
    ],
    "polytron_r1500": [
        "P5"
    ],
    "polytron_r2403": [
        "P5"
    ],
    "polytron_r2406": [
        "P5"
    ],
    "polytron r2402": [
        "P5"
    ],
    "polytron r2407": [
        "P5"
    ],
    "polytron-r2457": [
        "P5"
    ],
    "polytron r2501": [
        "P5"
    ],
    "polytron r2506": [
        "P5"
    ],
    "polytron r2509se": [
        "P5"
    ],
    "w7531": [
        "P5"
    ],
    "polytron 4g450": [
        "P5"
    ],
    "polytron 4g500": [
        "P5"
    ],
    "polytron_4g503": [
        "P5"
    ],
    "polytron__4g550": [
        "P5"
    ],
    "polytron_4g501": [
        "P5"
    ],
    "polytron_4g551": [
        "P5"
    ],
    "polytron_4g502": [
        "P5"
    ],
    "protruly d7": [
        "P7"
    ],
    "protruly d8": [
        "P7"
    ],
    "protruly v10s": [
        "P7"
    ],
    "eluga_a2": [
        "PA"
    ],
    "eluga_i2": [
        "PA"
    ],
    "eluga note": [
        "PA"
    ],
    "eluga ray x": [
        "PA"
    ],
    "eluga turbo": [
        "PA"
    ],
    "p55 novo 4g": [
        "PA"
    ],
    "panasonic_t50": [
        "PA"
    ],
    "fz-n1": [
        "PA"
    ],
    "fz-x1": [
        "PA"
    ],
    "art-pcb-v116": [
        "PB"
    ],
    "bee-pcb-v216": [
        "PB"
    ],
    "clap-pcb-i316": [
        "PB"
    ],
    "ph4001": [
        "PC"
    ],
    "pcd 506": [
        "PD"
    ],
    "pcd508": [
        "PD"
    ],
    "pcd509": [
        "PD"
    ],
    "pentagram ego": [
        "PG"
    ],
    "pentagram monster": [
        "PG"
    ],
    "monster x5": [
        "PG"
    ],
    "philips_s396": [
        "PH"
    ],
    "philips t3566": [
        "PH"
    ],
    "philips w632": [
        "PH"
    ],
    "philips w832": [
        "PH"
    ],
    "pioneer": [
        "PI"
    ],
    "e60w": [
        "PI"
    ],
    "pioneer e80w": [
        "PI"
    ],
    "versus pioneer_p1": [
        "PI"
    ],
    "pioneer s90w": [
        "PI"
    ],
    "prov400": [
        "PL"
    ],
    "polaroid pspc505": [
        "PL"
    ],
    "pspc550": [
        "PL"
    ],
    "p5006a": [
        "PL"
    ],
    "p5526a": [
        "PL"
    ],
    "pspck21na": [
        "PL"
    ],
    "p5026a": [
        "PL"
    ],
    "pspcl20a0": [
        "PL"
    ],
    "pspcm20a0": [
        "PL"
    ],
    "p5046a": [
        "PL"
    ],
    "p5525a": [
        "PL"
    ],
    "p5047a": [
        "PL"
    ],
    "pspcz20a0": [
        "PL"
    ],
    "p5025a": [
        "PL"
    ],
    "pro4006": [
        "PL"
    ],
    "pro400b": [
        "PL"
    ],
    "pro450b": [
        "PL"
    ],
    "pro4611pr201": [
        "PL"
    ],
    "pro5701": [
        "PL"
    ],
    "prov350": [
        "PL"
    ],
    "sigma 5": [
        "PL",
        "1S"
    ],
    "p4005a": [
        "PL"
    ],
    "polaroid p5005a": [
        "PL"
    ],
    "p4006a": [
        "PL"
    ],
    "p4526a": [
        "PL"
    ],
    "muze c3": [
        "PR"
    ],
    "pap3350duo": [
        "PR"
    ],
    "pap3400duo": [
        "PR"
    ],
    "pap3540duo": [
        "PR"
    ],
    "pap4040_duo": [
        "PR"
    ],
    "pap4300 duo": [
        "PR"
    ],
    "pap4322duo": [
        "PR"
    ],
    "pap4500tduo": [
        "PR"
    ],
    "pap4505duo": [
        "PR"
    ],
    "pap5044duo": [
        "PR"
    ],
    "pap5500duo": [
        "PR"
    ],
    "pap5501": [
        "PR"
    ],
    "psp3502duo": [
        "PR"
    ],
    "psp5453duo": [
        "PR"
    ],
    "psp5504duo": [
        "PR"
    ],
    "ypy_s450": [
        "PS"
    ],
    "im-a840s": [
        "PT"
    ],
    "im-a850k": [
        "PT"
    ],
    "im-a850l": [
        "PT"
    ],
    "im-t100k": [
        "PT"
    ],
    "pantechp8000": [
        "PT"
    ],
    "pantechp8010": [
        "PT"
    ],
    "pantechp9060": [
        "PT"
    ],
    "pantechp9070": [
        "PT"
    ],
    "adr910l": [
        "PT"
    ],
    "adr910l 4g": [
        "PT"
    ],
    "im-a870k/2.10": [
        "PT"
    ],
    "pulid f11": [
        "PU"
    ],
    "f13": [
        "PU"
    ],
    "f15": [
        "PU"
    ],
    "pulid_f6": [
        "PU"
    ],
    "pulid t3": [
        "PU"
    ],
    "mob-5045": [
        "PV"
    ],
    "pixus hit 2": [
        "PX"
    ],
    "pixus_jet": [
        "PX"
    ],
    "pixus raze": [
        "PX"
    ],
    "quantum fit": [
        "QA"
    ],
    "quantum go": [
        "QA"
    ],
    "quantum mini": [
        "QA"
    ],
    "quantum muv pro": [
        "QA"
    ],
    "quantum muv up": [
        "QA"
    ],
    "quantum v": [
        "QA"
    ],
    "quantum you 2": [
        "QA"
    ],
    "quantum you e": [
        "QA"
    ],
    "qphone_10.1": [
        "QB"
    ],
    "qphone 5.4": [
        "QB"
    ],
    "qphone 9.1": [
        "QB"
    ],
    "q09": [
        "QH"
    ],
    "qilive 40": [
        "QI"
    ],
    "qilive 45": [
        "QI"
    ],
    "qilive 50": [
        "QI"
    ],
    "qilive 53": [
        "QI"
    ],
    "q10s5in4g": [
        "QI"
    ],
    "q10s5in4gr": [
        "QI"
    ],
    "q10s53in4g": [
        "QI"
    ],
    "q10s57in4g": [
        "QI"
    ],
    "q10s6in4g": [
        "QI"
    ],
    "q7s5in4g": [
        "QI"
    ],
    "q7s55in4g": [
        "QI"
    ],
    "q8s5in4gp": [
        "QI"
    ],
    "q8s55in4g2": [
        "QI"
    ],
    "q8s6in4g": [
        "QI"
    ],
    "q9s5in4g": [
        "QI"
    ],
    "qmobile a11note": [
        "QM"
    ],
    "qmobile_a2_lite": [
        "QM"
    ],
    "qmobile a30": [
        "QM"
    ],
    "qmobile a65": [
        "QM"
    ],
    "luna pro": [
        "QM",
        "69"
    ],
    "nice s": [
        "QM"
    ],
    "noir x1s": [
        "QM"
    ],
    "q-smart_s12": [
        "QM"
    ],
    "qmobile x25": [
        "QM"
    ],
    "qmobile z10": [
        "QM"
    ],
    "qumo_quest353": [
        "QO"
    ],
    "qumo_quest_354": [
        "QO"
    ],
    "qumo quest 402": [
        "QO"
    ],
    "qumo quest 406": [
        "QO"
    ],
    "qumo_quest452": [
        "QO"
    ],
    "qumo quest 458": [
        "QO"
    ],
    "qumo quest 476": [
        "QO"
    ],
    "qumo quest 507": [
        "QO"
    ],
    "qumo quest 570": [
        "QO"
    ],
    "qumo quest 600": [
        "QO"
    ],
    "quechua phone 5": [
        "QU"
    ],
    "io pro": [
        "R1"
    ],
    "via_a1": [
        "R4"
    ],
    "via_a1_plus": [
        "R4"
    ],
    "casper_via_a2": [
        "R4"
    ],
    "via_a3": [
        "R4"
    ],
    "via a4": [
        "R4"
    ],
    "casper_via_e1": [
        "R4"
    ],
    "casper_via_e1c": [
        "R4"
    ],
    "casper_via_e2": [
        "R4"
    ],
    "via_e3": [
        "R4"
    ],
    "via_f1": [
        "R4"
    ],
    "via_f2": [
        "R4"
    ],
    "via_f3": [
        "R4"
    ],
    "casper_via_g1": [
        "R4"
    ],
    "casper_via_g1_plus": [
        "R4"
    ],
    "casper via_g3": [
        "R4"
    ],
    "via_g4": [
        "R4"
    ],
    "casper_via_m1": [
        "R4"
    ],
    "casper_via_m2": [
        "R4"
    ],
    "casper_via_m3": [
        "R4"
    ],
    "via_m4": [
        "R4"
    ],
    "via_p2": [
        "R4"
    ],
    "via_s": [
        "R4"
    ],
    "casper_via_v10": [
        "R4"
    ],
    "casper_via_v3": [
        "R4"
    ],
    "casper_via_v5": [
        "R4"
    ],
    "casper_via_v6": [
        "R4"
    ],
    "casper_via_v8": [
        "R4"
    ],
    "via_v8c": [
        "R4"
    ],
    "casper_via_v9": [
        "R4"
    ],
    "roverphone": [
        "R6"
    ],
    "ritzviva_s500c": [
        "R7"
    ],
    "h1a1000": [
        "R8"
    ],
    "ravoz r4": [
        "R9"
    ],
    "ravoz r7": [
        "R9"
    ],
    "ravoz r8": [
        "R9"
    ],
    "ravoz z3": [
        "R9"
    ],
    "ravoz_z4": [
        "R9"
    ],
    "ravoz z7": [
        "R9"
    ],
    "rca rltp4028": [
        "RC"
    ],
    "cph1861": [
        "RE",
        "OP"
    ],
    "rmx1809": [
        "RE"
    ],
    "rmx1805": [
        "RE"
    ],
    "rmx1801": [
        "RE"
    ],
    "rmx1807": [
        "RE"
    ],
    "rmx1833": [
        "RE"
    ],
    "rmx1821": [
        "RE"
    ],
    "rmx1825": [
        "RE"
    ],
    "rmx1851": [
        "RE"
    ],
    "rmx1827": [
        "RE"
    ],
    "rmx1919": [
        "RE"
    ],
    "rmx1911": [
        "RE"
    ],
    "rmx1927": [
        "RE"
    ],
    "rmx1971": [
        "RE"
    ],
    "rmx2030": [
        "RE"
    ],
    "rmx2032": [
        "RE"
    ],
    "rmx1925": [
        "RE"
    ],
    "rmx2001": [
        "RE"
    ],
    "rmx2063": [
        "RE"
    ],
    "rmx2061": [
        "RE"
    ],
    "rmx2040": [
        "RE"
    ],
    "rmx2002": [
        "RE"
    ],
    "rmx1811": [
        "RE"
    ],
    "rmx2185": [
        "RE"
    ],
    "rmx2189": [
        "RE"
    ],
    "rmx2180": [
        "RE"
    ],
    "rmx1943": [
        "RE"
    ],
    "rmx1945": [
        "RE"
    ],
    "rmx1941": [
        "RE"
    ],
    "rmx1942": [
        "RE"
    ],
    "rmx2021": [
        "RE"
    ],
    "rmx2020": [
        "RE"
    ],
    "rmx2027": [
        "RE"
    ],
    "rmx1831": [
        "RE"
    ],
    "rmx2200": [
        "RE"
    ],
    "rmx2111": [
        "RE"
    ],
    "rmx1901": [
        "RE"
    ],
    "rmx1903": [
        "RE"
    ],
    "rmx1992": [
        "RE"
    ],
    "rmx1991": [
        "RE"
    ],
    "rmx1993": [
        "RE"
    ],
    "rmx1931": [
        "RE"
    ],
    "rmx2142": [
        "RE"
    ],
    "rmx2086": [
        "RE"
    ],
    "rmx2025": [
        "RE"
    ],
    "rmx2051": [
        "RE"
    ],
    "rmx2071": [
        "RE"
    ],
    "rmx2072": [
        "RE"
    ],
    "rmx2176": [
        "RE"
    ],
    "rmx2121": [
        "RE"
    ],
    "rmx1921": [
        "RE"
    ],
    "rg310": [
        "RG"
    ],
    "rg500": [
        "RG"
    ],
    "rg650": [
        "RG"
    ],
    "rg655": [
        "RG"
    ],
    "rg702": [
        "RG"
    ],
    "rg710": [
        "RG"
    ],
    "ruggear rg730": [
        "RG"
    ],
    "rg850": [
        "RG"
    ],
    "bbc100-1": [
        "RM"
    ],
    "blackberry 9220": [
        "RM"
    ],
    "blackberry 9800": [
        "RM"
    ],
    "blackberry 9930": [
        "RM"
    ],
    "sth100-2": [
        "RM"
    ],
    "sth100-1": [
        "RM"
    ],
    "bba100-2": [
        "RM"
    ],
    "bba100-1": [
        "RM"
    ],
    "stv100-1": [
        "RM"
    ],
    "stv100-3": [
        "RM"
    ],
    "stv100-4": [
        "RM"
    ],
    "stv100-2": [
        "RM"
    ],
    "bbg100-1": [
        "RM"
    ],
    "bbh100-1": [
        "RM"
    ],
    "bbf100-6": [
        "RM"
    ],
    "bbf100-7": [
        "RM"
    ],
    "bbf100-1": [
        "RM"
    ],
    "bbf100-2": [
        "RM"
    ],
    "bbf100-3": [
        "RM"
    ],
    "bbf100-4": [
        "RM"
    ],
    "bbf100-5": [
        "RM"
    ],
    "bbf100-9": [
        "RM"
    ],
    "bbe100-1": [
        "RM"
    ],
    "bbe100-2": [
        "RM"
    ],
    "bbe100-3": [
        "RM"
    ],
    "bbe100-4": [
        "RM"
    ],
    "bbe100-5": [
        "RM"
    ],
    "bbe100-6": [
        "RM"
    ],
    "bbe100-7": [
        "RM"
    ],
    "bbe100-8": [
        "RM"
    ],
    "bbe100-9": [
        "RM"
    ],
    "bbf100-8": [
        "RM"
    ],
    "bbb100-3": [
        "RM"
    ],
    "bbb100-5": [
        "RM"
    ],
    "bbb100-6": [
        "RM"
    ],
    "bbb100-7": [
        "RM"
    ],
    "bbb100-2": [
        "RM"
    ],
    "bbb100-4": [
        "RM"
    ],
    "bbd100-2": [
        "RM"
    ],
    "bbd100-6": [
        "RM"
    ],
    "bbd100-1": [
        "RM"
    ],
    "rinno r505": [
        "RN"
    ],
    "shock 5": [
        "RT"
    ],
    "nobu_a55_pro": [
        "AM"
    ],
    "poptel k1": [
        "0X"
    ],
    "avvio l800": [
        "AV"
    ],
    "avvio_l800": [
        "AV"
    ],
    "admire blaze": [
        "ZN"
    ],
    "rmx3661": [
        "RE"
    ],
    "v2160": [
        "VV"
    ],
    "v2203": [
        "VV"
    ],
    "v2228": [
        "VV"
    ],
    "v2208": [
        "VV"
    ],
    "x668_64gb": [
        "UQ"
    ],
    "wtvis01": [
        "V4"
    ],
    "t774b": [
        "TC"
    ],
    "t781s": [
        "TC"
    ],
    "t781spp": [
        "TC"
    ],
    "samba65s": [
        "IP"
    ],
    "rhino-quest": [
        "RUG"
    ],
    "rs-403": [
        "SYC"
    ],
    "p1_amateur": [
        "KS"
    ],
    "osmartphona": [
        "M9"
    ],
    "nco-lx3": [
        "HU"
    ],
    "runbof1": [
        "RU"
    ],
    "runbo f1 plus": [
        "RU"
    ],
    "runbof1-en": [
        "RU"
    ],
    "runbof1-tt": [
        "RU"
    ],
    "runboq5": [
        "RU"
    ],
    "runboq5-s": [
        "RU"
    ],
    "runbo-tt": [
        "RU"
    ],
    "runbox5-king": [
        "RU"
    ],
    "runbox5-w": [
        "RU"
    ],
    "runbox6": [
        "RU"
    ],
    "riviera f23": [
        "RV"
    ],
    "rmp-450": [
        "RX"
    ],
    "ritmix rmp-505": [
        "RX"
    ],
    "ritmix rmp-506": [
        "RX"
    ],
    "rmp-530": [
        "RX"
    ],
    "rmp-600": [
        "RX"
    ],
    "ryte u55 lte": [
        "RY"
    ],
    "phone 2": [
        "RZ"
    ],
    "8312d": [
        "S0"
    ],
    "g602": [
        "S0"
    ],
    "g703": [
        "S0"
    ],
    "g708g": [
        "S0"
    ],
    "n83-2cpu": [
        "S0"
    ],
    "n91": [
        "S0"
    ],
    "element p501": [
        "S1"
    ],
    "stx evo": [
        "S2"
    ],
    "stx mini": [
        "S2"
    ],
    "stx mini 2": [
        "S2"
    ],
    "stx ultra": [
        "S2"
    ],
    "stx ultra 2": [
        "S2"
    ],
    "sunvan s8888a": [
        "S3"
    ],
    "sunvan_s899": [
        "S3"
    ],
    "sunvan s899b": [
        "S3"
    ],
    "sunvan s899c": [
        "S3"
    ],
    "n8800": [
        "S4"
    ],
    "n9500": [
        "S4"
    ],
    "n9600": [
        "S4"
    ],
    "n9700": [
        "S4"
    ],
    "n9800": [
        "S4"
    ],
    "n9977": [
        "S4"
    ],
    "n9000": [
        "S4"
    ],
    "senseit a109": [
        "S6"
    ],
    "senseit e500": [
        "S6"
    ],
    "senseit l301": [
        "S6"
    ],
    "senseit r390": [
        "S6"
    ],
    "senseit t300": [
        "S6"
    ],
    "os103": [
        "S7"
    ],
    "sm919": [
        "S7"
    ],
    "oc106": [
        "S7"
    ],
    "oc105": [
        "S7"
    ],
    "oe106": [
        "S7"
    ],
    "dt1901a": [
        "S7"
    ],
    "od105": [
        "S7"
    ],
    "os105": [
        "S7"
    ],
    "de106": [
        "S7"
    ],
    "sm701": [
        "S7"
    ],
    "sm801": [
        "S7"
    ],
    "yq601": [
        "S7"
    ],
    "stk avenger 500": [
        "S8"
    ],
    "stk_sync_5e": [
        "S8"
    ],
    "stk sync 5z": [
        "S8"
    ],
    "sm-w750v": [
        "SA"
    ],
    "gt-i5800": [
        "SA"
    ],
    "sm-a015a": [
        "SA"
    ],
    "samsung sm-a015m": [
        "SA"
    ],
    "sm-a105n": [
        "SA"
    ],
    "sm-a105f": [
        "SA"
    ],
    "sm-a102w": [
        "SA"
    ],
    "samsung sm-s102dl": [
        "SA"
    ],
    "sm-a107m": [
        "SA"
    ],
    "sm-a107f": [
        "SA"
    ],
    "samsung sm-a115f": [
        "SA"
    ],
    "sm-a260g": [
        "SA"
    ],
    "sc-02m": [
        "SA",
        "SU"
    ],
    "sm-a205u": [
        "SA"
    ],
    "scv46": [
        "SA"
    ],
    "sm-a205u1": [
        "SA"
    ],
    "sm-a205w": [
        "SA"
    ],
    "sm-a205yn": [
        "SA"
    ],
    "samsung sm-a205s": [
        "SA"
    ],
    "samsung sm-a202f": [
        "SA"
    ],
    "sm-a2070": [
        "SA"
    ],
    "samsung sm-a207m": [
        "SA"
    ],
    "sm-a215u": [
        "SA"
    ],
    "samsung sm-a217f": [
        "SA"
    ],
    "sm-a3009": [
        "SA"
    ],
    "sm-a300yz": [
        "SA"
    ],
    "sm-a3000": [
        "SA"
    ],
    "sm-a300xu": [
        "SA"
    ],
    "samsung sm-a300h": [
        "SA"
    ],
    "samsung sm-a300y": [
        "SA"
    ],
    "sm-a310x": [
        "SA"
    ],
    "samsung sm-a310m": [
        "SA"
    ],
    "sm-a310f": [
        "SA"
    ],
    "samsung sm-a310n0": [
        "SA"
    ],
    "samsung sm-a310y": [
        "SA"
    ],
    "samsung sm-a320y": [
        "SA"
    ],
    "samsung sm-a320x": [
        "SA"
    ],
    "sm-a320fl": [
        "SA"
    ],
    "scv43": [
        "SA"
    ],
    "sm-a305n": [
        "SA"
    ],
    "sm-a315g": [
        "SA"
    ],
    "sm-a315f": [
        "SA"
    ],
    "samsung sm-a315n": [
        "SA"
    ],
    "sm-a405fm": [
        "SA"
    ],
    "sm-a405s": [
        "SA"
    ],
    "sm-a3051": [
        "SA"
    ],
    "sm-a3050": [
        "SA"
    ],
    "sm-a415f": [
        "SA"
    ],
    "sm-a500y": [
        "SA"
    ],
    "sm-a500l": [
        "SA"
    ],
    "sm-a5009": [
        "SA"
    ],
    "sm-a500": [
        "SA"
    ],
    "sm-a500w": [
        "SA"
    ],
    "sm-a500s": [
        "SA"
    ],
    "sm-a500x": [
        "SA"
    ],
    "sm-a510m": [
        "SA"
    ],
    "sm-a5100": [
        "SA"
    ],
    "sm-a510x": [
        "SA"
    ],
    "samsung sm-a510s": [
        "SA"
    ],
    "samsung sm-a510y": [
        "SA"
    ],
    "sm-a510l": [
        "SA"
    ],
    "samsung sm-a510k/kku1cqk1": [
        "SA"
    ],
    "sm-a5108": [
        "SA"
    ],
    "sm-a520x": [
        "SA"
    ],
    "sm-a520k": [
        "SA"
    ],
    "sm-a520l": [
        "SA"
    ],
    "samsung sm-a520f": [
        "SA"
    ],
    "samsung sm-a520s": [
        "SA"
    ],
    "samsung sm-a520w": [
        "SA"
    ],
    "samsung sm-a500k/ktu1aoa1": [
        "SA"
    ],
    "sm-a500g": [
        "SA"
    ],
    "sm-505fn": [
        "SA"
    ],
    "sm-a505u": [
        "SA"
    ],
    "samsung sm-a505x": [
        "SA"
    ],
    "sm-a505n": [
        "SA"
    ],
    "sm-a505u1": [
        "SA"
    ],
    "sm-a505w": [
        "SA"
    ],
    "samsung sm-a505yn": [
        "SA"
    ],
    "samsung sm-s506dl": [
        "SA"
    ],
    "sm-a5070": [
        "SA"
    ],
    "samsung sm-a507fn": [
        "SA"
    ],
    "samsung sm-a515f": [
        "SA"
    ],
    "sm-a600p": [
        "SA"
    ],
    "sm-a600a": [
        "SA"
    ],
    "sm-a600n": [
        "SA"
    ],
    "sm-a600t": [
        "SA"
    ],
    "sm-a600fn": [
        "SA"
    ],
    "sm-a600g": [
        "SA"
    ],
    "sm-a600t1": [
        "SA"
    ],
    "sm-a600x": [
        "SA"
    ],
    "sm-a600az": [
        "SA"
    ],
    "samsung sm-a600gn": [
        "SA"
    ],
    "samsung sm-a600f": [
        "SA"
    ],
    "sm-a600u": [
        "SA"
    ],
    "samsung sm-a605gn": [
        "SA"
    ],
    "samsung sm-a605x)": [
        "SA"
    ],
    "sm-a6050": [
        "SA"
    ],
    "sm-a6058": [
        "SA"
    ],
    "samsung sm-a605g": [
        "SA"
    ],
    "samsung sm-a605f": [
        "SA"
    ],
    "samsung sm-a605fn/a605fnxxu1ard7": [
        "SA"
    ],
    "sm-a6060": [
        "SA"
    ],
    "samsung sm-a606y": [
        "SA"
    ],
    "sm-g6200": [
        "SA"
    ],
    "sm-a7009": [
        "SA"
    ],
    "sm-a700yd": [
        "SA"
    ],
    "sm-a700x": [
        "SA"
    ],
    "samsung sm-a7000": [
        "SA"
    ],
    "samsung sm-a700h": [
        "SA"
    ],
    "sm-a7108": [
        "SA"
    ],
    "sm-a710x": [
        "SA"
    ],
    "samsung sm-a710l": [
        "SA"
    ],
    "sm-a710f": [
        "SA"
    ],
    "samsung sm-a710s": [
        "SA"
    ],
    "samsung sm-a710k/kku1cql1": [
        "SA"
    ],
    "sm-a720x": [
        "SA"
    ],
    "samsung sm-a720f": [
        "SA"
    ],
    "sm-a720s": [
        "SA"
    ],
    "sm-a750g": [
        "SA"
    ],
    "sm-a750x": [
        "SA"
    ],
    "samsung sm-a750gn": [
        "SA"
    ],
    "samsung sm-a750f": [
        "SA"
    ],
    "sm-a750n": [
        "SA"
    ],
    "sm-a750c": [
        "SA"
    ],
    "sm-a705fn": [
        "SA"
    ],
    "sm-a705x": [
        "SA"
    ],
    "sm-a705f": [
        "SA"
    ],
    "sm-a705mn": [
        "SA"
    ],
    "samsung sm-a7070": [
        "SA"
    ],
    "sm-a707f": [
        "SA"
    ],
    "sm-a715w": [
        "SA"
    ],
    "sm-a71": [
        "SA"
    ],
    "sm-a716u": [
        "SA"
    ],
    "sm-a800i": [
        "SA"
    ],
    "sm-a8000": [
        "SA"
    ],
    "sm-a800s": [
        "SA"
    ],
    "samsung sm-a800f": [
        "SA"
    ],
    "scv32": [
        "SA"
    ],
    "sm-a530f": [
        "SA"
    ],
    "sm-a810f": [
        "SA"
    ],
    "sm-a810s": [
        "SA"
    ],
    "samsung sm-a810yz": [
        "SA"
    ],
    "sm-a530x": [
        "SA"
    ],
    "samsung sm-a530w": [
        "SA"
    ],
    "samsung sm-a530n": [
        "SA"
    ],
    "sm-a530m": [
        "SA"
    ],
    "sm-g885f": [
        "SA"
    ],
    "samsung sm-g885y": [
        "SA"
    ],
    "samsung sm-g885s": [
        "SA"
    ],
    "sm-a730f": [
        "SA"
    ],
    "samsung sm-a8050": [
        "SA"
    ],
    "samsung sm-a805n": [
        "SA"
    ],
    "samsung sm-a805x": [
        "SA"
    ],
    "samsung sm-a805f": [
        "SA"
    ],
    "sm-g8870": [
        "SA"
    ],
    "sm-g887f": [
        "SA"
    ],
    "samsung sm-a9000": [
        "SA"
    ],
    "sm-a920x": [
        "SA"
    ],
    "samsung sm-a920f": [
        "SA"
    ],
    "samsung sm-a9200": [
        "SA"
    ],
    "sm-a920n": [
        "SA"
    ],
    "sm-a9[7]": [
        "SA"
    ],
    "samsung sm-a9100": [
        "SA"
    ],
    "sm-a910f": [
        "SA"
    ],
    "sm-g887n": [
        "SA"
    ],
    "samsung sm-g8858": [
        "SA"
    ],
    "sm-g8850": [
        "SA"
    ],
    "samsung sm-a908n": [
        "SA"
    ],
    "samsung sm-a908b": [
        "SA"
    ],
    "gt-s5830l": [
        "SA"
    ],
    "gt-s5830i": [
        "SA"
    ],
    "gt-s5830": [
        "SA"
    ],
    "gt-i8160p-orange/i8160pbvlk3": [
        "SA"
    ],
    "gt-i8160": [
        "SA"
    ],
    "gt-i8160p": [
        "SA"
    ],
    "samsung gt-s7275r/s7275rxxuamk2": [
        "SA"
    ],
    "sm-g313hy": [
        "SA"
    ],
    "sm-g313mu": [
        "SA"
    ],
    "sm-g313ml": [
        "SA"
    ],
    "sm-g313my": [
        "SA"
    ],
    "sm-g313m": [
        "SA"
    ],
    "sm-g313f": [
        "SA"
    ],
    "sm-g316m": [
        "SA"
    ],
    "sm-g313u": [
        "SA"
    ],
    "sm-g313hz": [
        "SA"
    ],
    "sm-g313hn": [
        "SA"
    ],
    "sm-g313h": [
        "SA"
    ],
    "sm-g318ml": [
        "SA"
    ],
    "samsung sm-g318h": [
        "SA"
    ],
    "gt-s7500": [
        "SA"
    ],
    "sm-g310hn": [
        "SA"
    ],
    "sm-g357m": [
        "SA"
    ],
    "sm-g357fz": [
        "SA"
    ],
    "sc-01h": [
        "SA",
        "SU"
    ],
    "samsung-sm-g850a": [
        "SA"
    ],
    "sm-g850m": [
        "SA"
    ],
    "sm-g850y": [
        "SA"
    ],
    "sm-g850k": [
        "SA"
    ],
    "sm-g850l": [
        "SA"
    ],
    "sm-g850s": [
        "SA"
    ],
    "sm-g850w": [
        "SA"
    ],
    "sm-g850x": [
        "SA"
    ],
    "samsung-sm-j327az": [
        "SA"
    ],
    "sm-j337az": [
        "SA"
    ],
    "gt-i5801": [
        "SA"
    ],
    "samsung sm-g386t": [
        "SA"
    ],
    "sm-g386t1": [
        "SA"
    ],
    "gt-i8520": [
        "SA"
    ],
    "gt-i8530": [
        "SA"
    ],
    "sm-g3858": [
        "SA"
    ],
    "samsung sm-c5000": [
        "SA"
    ],
    "samsung sm-c5018": [
        "SA"
    ],
    "samsung sm-c5010": [
        "SA"
    ],
    "samsung sm-c7000": [
        "SA"
    ],
    "sm-c7018": [
        "SA"
    ],
    "samsung sm-c701f": [
        "SA"
    ],
    "samsung sm-c7010": [
        "SA"
    ],
    "samsung sm-c7100": [
        "SA"
    ],
    "samsung sm-c7108": [
        "SA"
    ],
    "sm-c9008": [
        "SA"
    ],
    "sm-c900f": [
        "SA"
    ],
    "sch-s738c": [
        "SA"
    ],
    "gt-b5330": [
        "SA"
    ],
    "gt-b5330l": [
        "SA"
    ],
    "gt-i8262b": [
        "SA"
    ],
    "gt-i8262d": [
        "SA"
    ],
    "gt-i8260": [
        "SA"
    ],
    "gt-i8260l": [
        "SA"
    ],
    "gt-i8262": [
        "SA"
    ],
    "sm-g3556d": [
        "SA"
    ],
    "sm-g355m": [
        "SA"
    ],
    "sm-g355h": [
        "SA"
    ],
    "samsung gt-i8580": [
        "SA"
    ],
    "sm-g386f": [
        "SA"
    ],
    "sm-g3586v": [
        "SA"
    ],
    "sm-g386w": [
        "SA"
    ],
    "sm-g5108q": [
        "SA"
    ],
    "sm-g3568v": [
        "SA"
    ],
    "sm-g350": [
        "SA"
    ],
    "sm-s820l": [
        "SA"
    ],
    "sm-g361h": [
        "SA"
    ],
    "sgh-s730m": [
        "SA"
    ],
    "sch-r740c": [
        "SA"
    ],
    "sm-e500yz": [
        "SA"
    ],
    "sm-e5000": [
        "SA"
    ],
    "sm-s978l": [
        "SA"
    ],
    "sm-e500h": [
        "SA"
    ],
    "sm-e700h": [
        "SA"
    ],
    "gt-i8730": [
        "SA"
    ],
    "samsung sm-g3815/g3815xxubmk5": [
        "SA"
    ],
    "gt-s6810": [
        "SA"
    ],
    "gt-s6812c": [
        "SA"
    ],
    "gt-s6812": [
        "SA"
    ],
    "gt-s6790": [
        "SA"
    ],
    "sc-04j": [
        "SA",
        "SU"
    ],
    "sm-g155s": [
        "SA"
    ],
    "sm-g160n": [
        "SA"
    ],
    "sm-g1600": [
        "SA"
    ],
    "sm-g1650": [
        "SA"
    ],
    "sm-g7200": [
        "SA"
    ],
    "sm-g720n0": [
        "SA"
    ],
    "sm-g720ax": [
        "SA"
    ],
    "samsung sm-g7202": [
        "SA"
    ],
    "samsung-sm-j727az": [
        "SA"
    ],
    "sm-j100h": [
        "SA"
    ],
    "samsung sm-j100y": [
        "SA"
    ],
    "sm-j100vpp": [
        "SA"
    ],
    "sm-j120g": [
        "SA"
    ],
    "sm-j120h": [
        "SA"
    ],
    "sm-j120zn": [
        "SA"
    ],
    "sm-j120w": [
        "SA"
    ],
    "sm-j05h": [
        "SA"
    ],
    "samsung sm-j110g": [
        "SA"
    ],
    "samsung sm-j110h": [
        "SA"
    ],
    "sm-j111f": [
        "SA"
    ],
    "sm-j105f": [
        "SA"
    ],
    "sm-j105y": [
        "SA"
    ],
    "sm-j105b": [
        "SA"
    ],
    "sm-j105m": [
        "SA"
    ],
    "sm-j106f": [
        "SA"
    ],
    "sm-j106h": [
        "SA"
    ],
    "sm-j106b": [
        "SA"
    ],
    "sm-j200g": [
        "SA"
    ],
    "sm-j200f": [
        "SA"
    ],
    "samsung sm-j200m": [
        "SA"
    ],
    "sm-j260f": [
        "SA"
    ],
    "sm-j260g": [
        "SA"
    ],
    "sm-j260m": [
        "SA"
    ],
    "sm-j260a": [
        "SA"
    ],
    "sm-j260y": [
        "SA"
    ],
    "samsung sm-j260t1": [
        "SA"
    ],
    "samsung sm-s260dl": [
        "SA"
    ],
    "samsung sm-j200bt": [
        "SA"
    ],
    "sm-j210f": [
        "SA"
    ],
    "sm-j250f": [
        "SA"
    ],
    "sm-j250g": [
        "SA"
    ],
    "sm-j250y": [
        "SA"
    ],
    "samsung sm-j250n": [
        "SA"
    ],
    "samsung sm-j260az": [
        "SA"
    ],
    "sm-j3109": [
        "SA"
    ],
    "sm-j320fn": [
        "SA"
    ],
    "samsung sm-j320y": [
        "SA"
    ],
    "samsung sm-j320yz": [
        "SA"
    ],
    "samsung sm-j320zn": [
        "SA"
    ],
    "samsung sm-j320f": [
        "SA"
    ],
    "sm-j320w8": [
        "SA"
    ],
    "sm-j320n0": [
        "SA"
    ],
    "sm-j320r4": [
        "SA"
    ],
    "sm-j330g": [
        "SA"
    ],
    "samsung sm-j327r7": [
        "SA"
    ],
    "samsung sm-j327u": [
        "SA"
    ],
    "sm-j3308": [
        "SA"
    ],
    "sm-j3300": [
        "SA"
    ],
    "sm-j330l": [
        "SA"
    ],
    "sm-j330fn": [
        "SA"
    ],
    "samsung sm-j330n": [
        "SA"
    ],
    "sm-j337p": [
        "SA"
    ],
    "sm-j337u": [
        "SA"
    ],
    "sm-j337v": [
        "SA"
    ],
    "sm-j337vpp": [
        "SA"
    ],
    "samsung sm-j337w": [
        "SA"
    ],
    "samsung sm-j337a": [
        "SA"
    ],
    "sm-j337r4": [
        "SA"
    ],
    "sm-j327v": [
        "SA"
    ],
    "sm-j327p": [
        "SA"
    ],
    "samsung sm-j327r4": [
        "SA"
    ],
    "samsung sm-j327f": [
        "SA"
    ],
    "samsung sm-s327vl": [
        "SA"
    ],
    "sm-s337tl": [
        "SA"
    ],
    "sm-s357bl": [
        "SA"
    ],
    "sm-s367vl": [
        "SA"
    ],
    "sm-j327t1": [
        "SA"
    ],
    "samsung sm-j327w": [
        "SA"
    ],
    "samsung sm-j327a": [
        "SA"
    ],
    "samsung sm-j327t": [
        "SA"
    ],
    "sm-j3110": [
        "SA"
    ],
    "sm-j3119s": [
        "SA"
    ],
    "samsung-sm-j3119": [
        "SA"
    ],
    "sm-s320vl": [
        "SA"
    ],
    "sm-j337t": [
        "SA"
    ],
    "sm-j400f": [
        "SA"
    ],
    "sm-j410f": [
        "SA"
    ],
    "sm-j410g": [
        "SA"
    ],
    "samsung sm-j415f": [
        "SA"
    ],
    "sm-j415fn": [
        "SA"
    ],
    "samsung sm-j415g": [
        "SA"
    ],
    "samsung sm-j415gn": [
        "SA"
    ],
    "samsung sm-j415n": [
        "SA"
    ],
    "sm-j5008": [
        "SA"
    ],
    "sm-j500n0": [
        "SA"
    ],
    "sm-j5007": [
        "SA"
    ],
    "sm-j500h": [
        "SA"
    ],
    "samsung sm-j500f": [
        "SA"
    ],
    "sm-g510h": [
        "SA"
    ],
    "sm-5108": [
        "SA"
    ],
    "sm-j5108": [
        "SA"
    ],
    "sm-j510g": [
        "SA"
    ],
    "sm-j510mn": [
        "SA"
    ],
    "sm-j510un": [
        "SA"
    ],
    "sm-j510y": [
        "SA"
    ],
    "sm-j510fn": [
        "SA"
    ],
    "sm-j510h": [
        "SA"
    ],
    "sm-j510k": [
        "SA"
    ],
    "sm-j510l": [
        "SA"
    ],
    "sm-j510gn": [
        "SA"
    ],
    "sm-j510s": [
        "SA"
    ],
    "samsung sm-j530f": [
        "SA"
    ],
    "sm-j530g": [
        "SA"
    ],
    "sm-g570m": [
        "SA"
    ],
    "sm-g570y": [
        "SA"
    ],
    "sm-g570f": [
        "SA"
    ],
    "samsung sm-g5700": [
        "SA"
    ],
    "sm-j600g": [
        "SA"
    ],
    "sm-j600gf": [
        "SA"
    ],
    "sm-j600f": [
        "SA"
    ],
    "sm-j600n": [
        "SA"
    ],
    "sm-j610f": [
        "SA"
    ],
    "samsung sm-j7008": [
        "SA"
    ],
    "sm-j700k": [
        "SA"
    ],
    "sm-j700f": [
        "SA"
    ],
    "sm-j710mn": [
        "SA"
    ],
    "samsung sm-j710f": [
        "SA"
    ],
    "sm-j700p": [
        "SA"
    ],
    "sm-j700t": [
        "SA"
    ],
    "sm-j7109": [
        "SA"
    ],
    "samsung sm-j700t1": [
        "SA"
    ],
    "sm-j710gn": [
        "SA"
    ],
    "sm-j727f": [
        "SA"
    ],
    "samsung-sm-j727a": [
        "SA"
    ],
    "samsung sm-j727u": [
        "SA"
    ],
    "samsung sm-j727s": [
        "SA"
    ],
    "sm-j727r4": [
        "SA"
    ],
    "sm-j730k": [
        "SA"
    ],
    "sm-j737s": [
        "SA"
    ],
    "sm-j737p": [
        "SA"
    ],
    "sm-j737a": [
        "SA"
    ],
    "sm-j737v": [
        "SA"
    ],
    "sm-j737t1": [
        "SA"
    ],
    "sm-j737vpp": [
        "SA"
    ],
    "sm-j737t": [
        "SA"
    ],
    "samsung sm-j737u": [
        "SA"
    ],
    "samsung sm-j737r4": [
        "SA"
    ],
    "sm-j7[7]": [
        "SA"
    ],
    "samsung sm-j701f": [
        "SA"
    ],
    "sm-s757bl": [
        "SA"
    ],
    "samsung sm-s767vl": [
        "SA"
    ],
    "sm-j720m": [
        "SA"
    ],
    "sm-j720f": [
        "SA"
    ],
    "samsung sm-g615f": [
        "SA"
    ],
    "sm-g610m": [
        "SA"
    ],
    "sm-g611mt": [
        "SA"
    ],
    "sm-g611ff": [
        "SA"
    ],
    "samsung sm-g611m": [
        "SA"
    ],
    "sm-j730gm": [
        "SA"
    ],
    "samsung sm-j730g": [
        "SA"
    ],
    "sm-s737tl": [
        "SA"
    ],
    "samsung sm-j727t1": [
        "SA"
    ],
    "sm-c710f": [
        "SA"
    ],
    "sm-j810m": [
        "SA"
    ],
    "sm-j8 pro": [
        "SA"
    ],
    "sm-j9[7] prime": [
        "SA"
    ],
    "sm-j9[8] pro": [
        "SA"
    ],
    "element play": [
        "KL"
    ],
    "up 32": [
        "PS"
    ],
    "5002w": [
        "AL"
    ],
    "t766s": [
        "TC"
    ],
    "t790s": [
        "TC"
    ],
    "m9106": [
        "MOV"
    ],
    "art1": [
        "YE"
    ],
    "lio-l09": [
        "HU"
    ],
    "m8421": [
        "MOV"
    ],
    "sp-6100": [
        "31"
    ],
    "x67 5g": [
        "AR"
    ],
    "a508dl": [
        "TC"
    ],
    "uniqcell_a4": [
        "UNQ"
    ],
    "yolo": [
        "PS"
    ],
    "padua": [
        "CG"
    ],
    "bl60_tg17": [
        "BM"
    ],
    "benny10": [
        "IP"
    ],
    "easy_5_eea": [
        "KW"
    ],
    "5002u": [
        "AL"
    ],
    "c55 pro": [
        "4R"
    ],
    "trek": [
        "OLY"
    ],
    "fenix8_3g": [
        "4R"
    ],
    "mga-lx3": [
        "HU"
    ],
    "aura_z": [
        "ZU"
    ],
    "black_z": [
        "KL"
    ],
    "u328aa": [
        "6A"
    ],
    "v2206": [
        "VV"
    ],
    "hd1917": [
        "ON"
    ],
    "black_g_2": [
        "KL"
    ],
    "t771k": [
        "TC"
    ],
    "t779w": [
        "TC"
    ],
    "t767w": [
        "TC"
    ],
    "t767g": [
        "TC"
    ],
    "t603dl": [
        "TC"
    ],
    "t506d": [
        "TC"
    ],
    "t776o": [
        "TC"
    ],
    "t671g": [
        "TC"
    ],
    "v2139": [
        "VV"
    ],
    "t701dl": [
        "TC"
    ],
    "u626aa": [
        "6A"
    ],
    "n151dl": [
        "NK"
    ],
    "4188c": [
        "TC"
    ],
    "4188r": [
        "TC"
    ],
    "n150dl": [
        "NK"
    ],
    "v2169": [
        "VV"
    ],
    "sl101ae": [
        "CK"
    ],
    "220733sl": [
        "XI"
    ],
    "6027a": [
        "AL"
    ],
    "sl100ea": [
        "CK"
    ],
    "4188s": [
        "TC"
    ],
    "olax prime 12": [
        "OLA"
    ],
    "v2221": [
        "VV"
    ],
    "rc608l": [
        "O5"
    ],
    "multilaser_e_pro": [
        "1R"
    ],
    "logic l63": [
        "1L"
    ],
    "logic l65 lite": [
        "1L"
    ],
    "corn note1": [
        "4R"
    ],
    "yestel p30": [
        "YES"
    ],
    "art1_pro": [
        "YE"
    ],
    "aura plus jlo": [
        "ZU"
    ],
    "boost_max": [
        "3H"
    ],
    "boost": [
        "3H"
    ],
    "b60pro": [
        "BM"
    ],
    "c60 ultra": [
        "4R"
    ],
    "city5": [
        "KW"
    ],
    "cs22xa": [
        "C4"
    ],
    "cs22xa_eea": [
        "C4"
    ],
    "w626 lite": [
        "WQ"
    ],
    "mh-t6000": [
        "MOX"
    ],
    "ws5se": [
        "WQ"
    ],
    "ws626": [
        "WQ"
    ],
    "22071219ai": [
        "XI"
    ],
    "2210132c": [
        "XI"
    ],
    "6165s": [
        "TC"
    ],
    "6159a": [
        "TC"
    ],
    "6127a": [
        "TC"
    ],
    "6102a": [
        "TC"
    ],
    "6056a": [
        "AL"
    ],
    "6025a": [
        "AL"
    ],
    "6002a": [
        "AL"
    ],
    "6002d": [
        "AL"
    ],
    "4163d": [
        "TC"
    ],
    "4188l": [
        "TC"
    ],
    "5031a": [
        "AL"
    ],
    "5031d": [
        "AL"
    ],
    "5032o": [
        "AL"
    ],
    "5033fr": [
        "AL"
    ],
    "5033mp": [
        "AL"
    ],
    "5033tr": [
        "AL"
    ],
    "5033dr": [
        "AL"
    ],
    "5058j": [
        "AL"
    ],
    "5102l": [
        "TC"
    ],
    "5124j": [
        "TC"
    ],
    "5102p": [
        "TC"
    ],
    "5102o": [
        "TC"
    ],
    "5164d": [
        "TC"
    ],
    "alpha 5g": [
        "11"
    ],
    "cm17xa": [
        "C4"
    ],
    "ctr-lx3": [
        "HU"
    ],
    "digitplay1": [
        "DIG"
    ],
    "elite b65": [
        "SW"
    ],
    "elite_g55": [
        "SW"
    ],
    "faith29": [
        "N4"
    ],
    "genesis_126": [
        "MOK"
    ],
    "gla-lx3": [
        "HU"
    ],
    "hammer_blade_5g": [
        "HAM"
    ],
    "hammer_explorer_plus": [
        "HAM"
    ],
    "halo4 pro": [
        "ARP"
    ],
    "z3353ca": [
        "ZT"
    ],
    "studio x10l": [
        "BU"
    ],
    "wtckt01": [
        "CK"
    ],
    "rmx3493": [
        "RE"
    ],
    "rmx3396": [
        "RE"
    ],
    "rmx3572": [
        "RE"
    ],
    "i2201": [
        "VV"
    ],
    "samsung sm-a605k/kku1arj1": [
        "SA"
    ],
    "sm-a202k": [
        "SA"
    ],
    "sm-c115": [
        "SA"
    ],
    "sm-c111m": [
        "SA"
    ],
    "samsung sm-c111": [
        "SA"
    ],
    "samsung sm-s120vl": [
        "SA"
    ],
    "sm-m015g": [
        "SA"
    ],
    "samsung sm-m015f": [
        "SA"
    ],
    "sm-m105f": [
        "SA"
    ],
    "sm-m105g": [
        "SA"
    ],
    "sm-m105m": [
        "SA"
    ],
    "samsung sm-m107f": [
        "SA"
    ],
    "samsung sm-m115f": [
        "SA"
    ],
    "samsung sm-m205n": [
        "SA"
    ],
    "sm-m205m": [
        "SA"
    ],
    "sm-m205f": [
        "SA"
    ],
    "sm-m205g": [
        "SA"
    ],
    "samsung sm-m215f": [
        "SA"
    ],
    "samsung sm-m305f": [
        "SA"
    ],
    "sm-m307f": [
        "SA"
    ],
    "sm-m307fn": [
        "SA"
    ],
    "samsung sm-m3070": [
        "SA"
    ],
    "sm-m315f": [
        "SA"
    ],
    "samsung sm-m405f": [
        "SA"
    ],
    "sm-g5500": [
        "SA"
    ],
    "sm-g550t1": [
        "SA"
    ],
    "sm-g550t2": [
        "SA"
    ],
    "sm-g550fy": [
        "SA"
    ],
    "sm-g5510": [
        "SA"
    ],
    "sm-g5520": [
        "SA"
    ],
    "sm-s550tl": [
        "SA"
    ],
    "sm-g550t": [
        "SA"
    ],
    "sm-g5528": [
        "SA"
    ],
    "samsung sm-g6000": [
        "SA"
    ],
    "sm-g600fy": [
        "SA"
    ],
    "sm-g600f": [
        "SA"
    ],
    "samsung sm-g6100": [
        "SA"
    ],
    "sm-g610k": [
        "SA"
    ],
    "sm-g610l": [
        "SA"
    ],
    "samsung sm-g610s": [
        "SA"
    ],
    "sm-g611f": [
        "SA"
    ],
    "samsung sm-g611s": [
        "SA"
    ],
    "sm-g611k": [
        "SA"
    ],
    "sm-g611l": [
        "SA"
    ],
    "sm-g110h": [
        "SA"
    ],
    "sm-g110m": [
        "SA"
    ],
    "sm-g110b": [
        "SA"
    ],
    "gt-s5310": [
        "SA"
    ],
    "gt-s5301": [
        "SA"
    ],
    "gt-s5301l": [
        "SA"
    ],
    "gt-s5301b": [
        "SA"
    ],
    "gt-i9103": [
        "SA"
    ],
    "sm-g910s": [
        "SA"
    ],
    "gt-i9088": [
        "SA"
    ],
    "samsung-gt-i9008l": [
        "SA"
    ],
    "gt-i9018": [
        "SA"
    ],
    "gt-i9000m": [
        "SA"
    ],
    "gt-i9000": [
        "SA"
    ],
    "gt-i9070": [
        "SA"
    ],
    "samsung gt-i9070/i9070bulk1": [
        "SA"
    ],
    "gt-i9070p-orange/i9070pbvld3": [
        "SA"
    ],
    "sch-i919": [
        "SA"
    ],
    "gt-s7562": [
        "SA"
    ],
    "gt-s7562l": [
        "SA"
    ],
    "gt-s7582": [
        "SA"
    ],
    "sm-g316hu": [
        "SA"
    ],
    "gt-i9010": [
        "SA"
    ],
    "gt-i9100m": [
        "SA"
    ],
    "samsung gt-i9100/i9100bukj3": [
        "SA"
    ],
    "sc-02c": [
        "SA",
        "SU"
    ],
    "gt-i9100": [
        "SA"
    ],
    "gt-i9100t": [
        "SA"
    ],
    "gt-i9100g": [
        "SA"
    ],
    "gt-i9108": [
        "SA"
    ],
    "galaxy s ii": [
        "SA"
    ],
    "gt-i9100p": [
        "SA"
    ],
    "sm-g9100": [
        "SA"
    ],
    "ru; shv-e120s": [
        "SA"
    ],
    "gt-i9105": [
        "SA"
    ],
    "gt-i9105p": [
        "SA"
    ],
    "isw11sc": [
        "SA"
    ],
    "samsung-gt-i9300": [
        "SA"
    ],
    "sch-i535": [
        "SA"
    ],
    "gt-i9300-orange/i9300xxemf1": [
        "SA"
    ],
    "sch-i939i": [
        "SA"
    ],
    "sch-l710": [
        "SA"
    ],
    "sch-r530u": [
        "SA",
        "UC"
    ],
    "samsung gt-i9305/i9305xxuemkc": [
        "SA"
    ],
    "samsung gt-i8190/i8190xxaljl": [
        "SA"
    ],
    "gt-i8190l": [
        "SA"
    ],
    "samsung gt-i8190n/i8190nxxaml1": [
        "SA"
    ],
    "gt-i8200n": [
        "SA"
    ],
    "gt-i9001": [
        "SA"
    ],
    "sm-g977t": [
        "SA"
    ],
    "samsung sm-g973f": [
        "SA"
    ],
    "samsung sm-g977n": [
        "SA"
    ],
    "samsung sm-g977p": [
        "SA"
    ],
    "samsung sm-g977u": [
        "SA"
    ],
    "sc-03l": [
        "SA",
        "SU"
    ],
    "sm-g977b": [
        "SA"
    ],
    "sm-g977n": [
        "SA"
    ],
    "scv41": [
        "SA"
    ],
    "sm-g770f": [
        "SA"
    ],
    "samsung sm-g975n": [
        "SA"
    ],
    "samsung sm-g975x": [
        "SA"
    ],
    "sm-g975n": [
        "SA"
    ],
    "sc-04l": [
        "SA",
        "SU"
    ],
    "scv42": [
        "SA"
    ],
    "samsung sm-g9700": [
        "SA"
    ],
    "samsung sm-g970n": [
        "SA"
    ],
    "samsung sm-g9708": [
        "SA"
    ],
    "samsung sm-g970w": [
        "SA"
    ],
    "samsung sm-g970x": [
        "SA"
    ],
    "sm-g980f": [
        "SA"
    ],
    "sm-g981b": [
        "SA"
    ],
    "scg01": [
        "SA"
    ],
    "sm-g985f": [
        "SA"
    ],
    "scg02": [
        "SA"
    ],
    "sm-g986b": [
        "SA"
    ],
    "sc-52a": [
        "SA",
        "SU"
    ],
    "samsung-sm-g730a": [
        "SA"
    ],
    "sm-g730v": [
        "SA"
    ],
    "sm-g730w8": [
        "SA"
    ],
    "samsung-gt-i9505+": [
        "SA"
    ],
    "gt-i9500.": [
        "SA"
    ],
    "sprd-galaxy-s4": [
        "SA"
    ],
    "sch-i959": [
        "SA"
    ],
    "sc-04e": [
        "SA",
        "SU"
    ],
    "samsung gt-i9505x": [
        "SA"
    ],
    "samsung gt-i9500": [
        "SA"
    ],
    "samsung sgh-m919n": [
        "SA"
    ],
    "gt-i9500": [
        "SA"
    ],
    "sch-i545": [
        "SA"
    ],
    "sm-s975l": [
        "SA"
    ],
    "samsung sch-r970c": [
        "SA"
    ],
    "samsung-sch-i959": [
        "SA"
    ],
    "samsung sgh-m919": [
        "SA"
    ],
    "gt-i9502": [
        "SA"
    ],
    "gt-i9295": [
        "SA"
    ],
    "gt-i9190": [
        "SA"
    ],
    "sch-i435": [
        "SA"
    ],
    "gt-i9192": [
        "SA"
    ],
    "gt-i9195": [
        "SA"
    ],
    "samsung gt-i9195": [
        "SA"
    ],
    "gt-i9195i": [
        "SA"
    ],
    "samsung gt-i9192": [
        "SA"
    ],
    "samsung gt-i9506/i9506xxubna2": [
        "SA"
    ],
    "samsung-sm-c105a": [
        "SA"
    ],
    "sm-c105": [
        "SA"
    ],
    "samsung sm-c101": [
        "SA"
    ],
    "samsung sm-c105l": [
        "SA"
    ],
    "sm-g900w8": [
        "SA"
    ],
    "samsung sm-g900f-orange": [
        "SA"
    ],
    "sprd-galaxy-s5": [
        "SA"
    ],
    "sm-s902l": [
        "SA"
    ],
    "sm-g906l": [
        "SA"
    ],
    "sm-g906k": [
        "SA"
    ],
    "sm-s903vl": [
        "SA"
    ],
    "samsung sm-g906s": [
        "SA"
    ],
    "samsung sm-g870f": [
        "SA"
    ],
    "samsung sm-g870w": [
        "SA"
    ],
    "samsung-sm-g890a": [
        "SA"
    ],
    "sc-02g": [
        "SA",
        "SU"
    ],
    "samsung sm-g870a": [
        "SA"
    ],
    "samsung-sm-g9009d": [
        "SA"
    ],
    "sm-g860p": [
        "SA"
    ],
    "sm-g800": [
        "SA"
    ],
    "sm-g800f": [
        "SA"
    ],
    "sm-g903w": [
        "SA"
    ],
    "samsung sm-g903f": [
        "SA"
    ],
    "sm-g903m": [
        "SA"
    ],
    "sm-g920": [
        "SA"
    ],
    "sm-g920w8": [
        "SA"
    ],
    "sm-g920v": [
        "SA"
    ],
    "samsung sm-g920x": [
        "SA"
    ],
    "sm-g920f": [
        "SA"
    ],
    "sm-g920i": [
        "SA"
    ],
    "sm-g920p": [
        "SA"
    ],
    "sm-g9200": [
        "SA"
    ],
    "samsung sm-g920l": [
        "SA"
    ],
    "samsung sm-s907vl": [
        "SA"
    ],
    "sm-g920k": [
        "SA"
    ],
    "sm-g920t": [
        "SA"
    ],
    "sm-g920r4": [
        "SA"
    ],
    "sc-05g": [
        "SA",
        "SU"
    ],
    "samsung-sm-g925a": [
        "SA"
    ],
    "sm-g9250": [
        "SA"
    ],
    "samsung sm-g925x": [
        "SA"
    ],
    "sm-g925i": [
        "SA"
    ],
    "sm-g925s": [
        "SA"
    ],
    "sm-g925p": [
        "SA"
    ],
    "samsung sm-g925d": [
        "SA"
    ],
    "samsung sm-g925t": [
        "SA"
    ],
    "sm-g925k": [
        "SA"
    ],
    "scv31": [
        "SA"
    ],
    "404sc": [
        "SA"
    ],
    "samsung sm-g925l": [
        "SA"
    ],
    "sm-g928g": [
        "SA"
    ],
    "sm-g928p": [
        "SA"
    ],
    "sm-g928w8": [
        "SA"
    ],
    "sm-g928l": [
        "SA"
    ],
    "sm-g928x": [
        "SA"
    ],
    "samsung samsung-sm-g928a": [
        "SA"
    ],
    "samsung sm-g9287c": [
        "SA"
    ],
    "sm-g928i": [
        "SA"
    ],
    "samsung sm-g928v": [
        "SA"
    ],
    "sm-g9280": [
        "SA"
    ],
    "sm-g928s": [
        "SA"
    ],
    "samsung sm-g9287": [
        "SA"
    ],
    "samsung sm-g928k/kku3dql1": [
        "SA"
    ],
    "samsung sm-g928r4": [
        "SA"
    ],
    "samsung sm-g928t": [
        "SA"
    ],
    "sm-g930s": [
        "SA"
    ],
    "sm-g9300": [
        "SA"
    ],
    "samsung sm-g930x": [
        "SA"
    ],
    "sm-g930v": [
        "SA"
    ],
    "sm-g930k": [
        "SA"
    ],
    "sm-g930l": [
        "SA"
    ],
    "sm-g9308": [
        "SA"
    ],
    "sm-g930": [
        "SA"
    ],
    "samsung sm-g891a": [
        "SA"
    ],
    "sc-02h": [
        "SA",
        "SU"
    ],
    "sm-g935f": [
        "SA"
    ],
    "sm-g935x": [
        "SA"
    ],
    "samsung samsung-sm-g935a": [
        "SA"
    ],
    "samsung sm-g9350": [
        "SA"
    ],
    "samsung sm-g935w8": [
        "SA"
    ],
    "sm-g935s": [
        "SA"
    ],
    "sm-g935t": [
        "SA"
    ],
    "sm-g935v": [
        "SA"
    ],
    "scv33": [
        "SA"
    ],
    "samsung sm-g935u": [
        "SA"
    ],
    "samsung sm-g935p": [
        "SA"
    ],
    "samsung sm-g935k/kku1dql1": [
        "SA"
    ],
    "samsung sm-g935r4": [
        "SA"
    ],
    "sm-g935l": [
        "SA"
    ],
    "sm-g950": [
        "SA"
    ],
    "scv36": [
        "SA"
    ],
    "sm-g9508": [
        "SA"
    ],
    "samsung sm-g9500": [
        "SA"
    ],
    "samsung sm-g950w": [
        "SA"
    ],
    "samsung sm-g950u": [
        "SA"
    ],
    "sc-02j": [
        "SA",
        "SU"
    ],
    "samsung sm-g892u": [
        "SA"
    ],
    "samsung sm-g892a": [
        "SA"
    ],
    "sm-g8750": [
        "SA"
    ],
    "sm-g955f": [
        "SA"
    ],
    "sm-g955n": [
        "SA"
    ],
    "samsung sm-g955u": [
        "SA"
    ],
    "samsung sm-g955x": [
        "SA"
    ],
    "sm-g955": [
        "SA"
    ],
    "sm-g9550": [
        "SA"
    ],
    "scv35": [
        "SA"
    ],
    "sc-03j": [
        "SA",
        "SU"
    ],
    "sm-g960": [
        "SA"
    ],
    "sc-02k": [
        "SA",
        "SU"
    ],
    "sm-g960x": [
        "SA"
    ],
    "sm-g960n": [
        "SA"
    ],
    "scv38": [
        "SA"
    ],
    "samsung sm-g960f": [
        "SA"
    ],
    "sc-03k": [
        "SA",
        "SU"
    ],
    "scv39": [
        "SA"
    ],
    "samsung sm-g965f": [
        "SA"
    ],
    "samsung sm-g965n": [
        "SA"
    ],
    "samsung sm-g965x": [
        "SA"
    ],
    "gt-i9003": [
        "SA"
    ],
    "samsung-sm-j321az": [
        "SA"
    ],
    "samsung-sm-j326az": [
        "SA"
    ],
    "sm-j336az)": [
        "SA"
    ],
    "gt-i5700": [
        "SA"
    ],
    "gt-s5280": [
        "SA"
    ],
    "sch-i200 4g": [
        "SA"
    ],
    "sch-i200": [
        "SA"
    ],
    "sch-i829 build jzo54k) uc": [
        "SA"
    ],
    "sch-i829": [
        "SA"
    ],
    "sch-i699": [
        "SA"
    ],
    "gt-s7560m-parrot": [
        "SA"
    ],
    "samsung gt-s7560/s7560xxbnc2": [
        "SA"
    ],
    "sch-i739": [
        "SA"
    ],
    "gt-s7390": [
        "SA"
    ],
    "gt-s7580": [
        "SA"
    ],
    "sm-g318mz": [
        "SA"
    ],
    "sm-g318hz": [
        "SA"
    ],
    "gt-i8150": [
        "SA"
    ],
    "sm-t255s": [
        "SA"
    ],
    "samsung-sm-w2016": [
        "SA"
    ],
    "sm-w2018": [
        "SA"
    ],
    "sm-w2019": [
        "SA"
    ],
    "samsung sm-g600s": [
        "SA"
    ],
    "gt-i8552": [
        "SA"
    ],
    "gt-i8552b": [
        "SA"
    ],
    "samsung-gt-i8550": [
        "SA"
    ],
    "samsung-gt-i8558_td": [
        "SA"
    ],
    "sm-g3818": [
        "SA"
    ],
    "sm-g3812": [
        "SA"
    ],
    "gt-s7710": [
        "SA"
    ],
    "sm-g389f": [
        "SA"
    ],
    "samsung sm-g390f": [
        "SA"
    ],
    "samsung sm-g390w": [
        "SA"
    ],
    "sm-g390y": [
        "SA"
    ],
    "sm-g398fn": [
        "SA"
    ],
    "sm-g715fn": [
        "SA"
    ],
    "gt-s5360l": [
        "SA"
    ],
    "gt-s5360b": [
        "SA"
    ],
    "samsung gt-s5360t": [
        "SA"
    ],
    "gt-s5360": [
        "SA"
    ],
    "gt-b5510-orange/b5510bvlh1": [
        "SA"
    ],
    "gt-b5510": [
        "SA"
    ],
    "gt-b5512": [
        "SA"
    ],
    "gt-s6310": [
        "SA"
    ],
    "sm-g130h": [
        "SA"
    ],
    "sm-g130hn": [
        "SA"
    ],
    "sm-g130m": [
        "SA"
    ],
    "sm-g130u": [
        "SA"
    ],
    "sm-g130e": [
        "SA"
    ],
    "sm-g130bt": [
        "SA"
    ],
    "sm-g130bu": [
        "SA"
    ],
    "gt-s6312": [
        "SA"
    ],
    "sm-f700u": [
        "SA"
    ],
    "sm-g310r5": [
        "SA"
    ],
    "gt-i5500": [
        "SA"
    ],
    "gt-i5500l": [
        "SA"
    ],
    "gt-i5500m": [
        "SA"
    ],
    "samsung": [
        "SA"
    ],
    "gt-i8750": [
        "SA"
    ],
    "samsung-gt-i9508_td": [
        "SA"
    ],
    "gt-s5282": [
        "SA"
    ],
    "gt-s5300": [
        "SA"
    ],
    "gt-s5660": [
        "SA"
    ],
    "gt-s5839i": [
        "SA"
    ],
    "gt-s6010": [
        "SA"
    ],
    "gt-s6010l": [
        "SA"
    ],
    "gt-s6102": [
        "SA"
    ],
    "gt-s6500": [
        "SA"
    ],
    "gt-s6500d": [
        "SA"
    ],
    "gt-s6802": [
        "SA"
    ],
    "samsung-gt-s6818": [
        "SA"
    ],
    "gt-s7262": [
        "SA"
    ],
    "samsung-gt-s7568_td": [
        "SA"
    ],
    "gt-s7568": [
        "SA"
    ],
    "omnia w": [
        "SA"
    ],
    "sch-i519": [
        "SA"
    ],
    "sch-w2013": [
        "SA"
    ],
    "samsung-sgh-i317": [
        "SA"
    ],
    "sgh-i317m": [
        "SA"
    ],
    "samsung-sgh-i337": [
        "SA"
    ],
    "phone/samsung-sgh-i337": [
        "SA"
    ],
    "sgh-i337m": [
        "SA"
    ],
    "samsung-sgh-i437": [
        "SA"
    ],
    "samsung-sgh-i437p": [
        "SA"
    ],
    "samsung-sgh-i547": [
        "SA"
    ],
    "samsung-sgh-i577": [
        "SA"
    ],
    "samsung-sgh-i717": [
        "SA"
    ],
    "samsung-sgh-i747": [
        "SA"
    ],
    "sgh-i747": [
        "SA"
    ],
    "sgh-i747m": [
        "SA"
    ],
    "sgh-i897": [
        "SA"
    ],
    "sgh-i927": [
        "SA"
    ],
    "sgh-i997": [
        "SA"
    ],
    "samsung sgh-m819n": [
        "SA"
    ],
    "sgh-t589w": [
        "SA"
    ],
    "sgh-t599n": [
        "SA"
    ],
    "sgh-t889v": [
        "SA"
    ],
    "sgh-t959": [
        "SA"
    ],
    "sgh-t959v": [
        "SA"
    ],
    "sgh-t989": [
        "SA"
    ],
    "sgh-t989d": [
        "SA"
    ],
    "sgh-t999": [
        "SA"
    ],
    "sgh-t999l": [
        "SA"
    ],
    "sgh-t999n": [
        "SA"
    ],
    "sgh-t999v": [
        "SA"
    ],
    "shv-e110s": [
        "SA"
    ],
    "shv-e140l": [
        "SA"
    ],
    "shv-e160l": [
        "SA"
    ],
    "shv-e210k": [
        "SA"
    ],
    "shv-e210s": [
        "SA"
    ],
    "shv-e250k": [
        "SA"
    ],
    "shv-e250k/kkuemk8": [
        "SA"
    ],
    "samsung shv-e330l": [
        "SA"
    ],
    "shw-m110s": [
        "SA"
    ],
    "shw-m130l": [
        "SA"
    ],
    "shw-m380s": [
        "SA"
    ],
    "shw-m440s": [
        "SA"
    ],
    "sph-d700": [
        "SA"
    ],
    "sph-d710": [
        "SA"
    ],
    "sph-d710bst": [
        "SA"
    ],
    "sph-l300": [
        "SA"
    ],
    "samsung sph-l520": [
        "SA"
    ],
    "sph-l710": [
        "SA"
    ],
    "samsung sph-l720": [
        "SA"
    ],
    "sph-l720": [
        "SA"
    ],
    "samsung sph-l720t": [
        "SA"
    ],
    "sph-m830": [
        "SA"
    ],
    "sph-m930bst": [
        "SA"
    ],
    "sph-p500": [
        "SA"
    ],
    "vollo vi86": [
        "SA",
        "VIC"
    ],
    "aerial plus": [
        "SB"
    ],
    "fractal": [
        "SB"
    ],
    "andromax-c": [
        "SC"
    ],
    "smartfren andromax ad688g": [
        "SC"
    ],
    "smartfren andromax ad9a1h": [
        "SC"
    ],
    "smartfren andromax ad6b1h": [
        "SC"
    ],
    "smartfren andromax ad689g": [
        "SC"
    ],
    "smartfren andromax ad682h": [
        "SC"
    ],
    "andromax_u": [
        "SC"
    ],
    "pd6d1j": [
        "SC"
    ],
    "new andromax-i": [
        "SC"
    ],
    "sonyericssonwt19i": [
        "SE"
    ],
    "sonyericssonwt19iv": [
        "SE"
    ],
    "sonyericssonwt19i-o": [
        "SE"
    ],
    "wt19i": [
        "SE"
    ],
    "livewithwalkman": [
        "SE"
    ],
    "sonyericssonmt25i": [
        "SE"
    ],
    "mt25i": [
        "SE"
    ],
    "w960": [
        "SE"
    ],
    "so-02l": [
        "SE"
    ],
    "sonyericssonst17a": [
        "SE"
    ],
    "sonyericssonst17i": [
        "SE"
    ],
    "sonyericssonlt15": [
        "SE"
    ],
    "sonyericssonlt15i": [
        "SE"
    ],
    "sonyericssonlt15i-o": [
        "SE"
    ],
    "sonyericssonlt15a": [
        "SE"
    ],
    "lt15i": [
        "SE"
    ],
    "blade l3 plus": [
        "ZT"
    ],
    "blade l3": [
        "ZT"
    ],
    "blade v6 max": [
        "ZT"
    ],
    "blade v6 plus": [
        "ZT"
    ],
    "blade v6": [
        "ZT"
    ],
    "blade v7": [
        "ZT"
    ],
    "blade x7": [
        "ZT"
    ],
    "lumia 730 dual sim": [
        "NK"
    ],
    "bkl-l04": [
        "HU"
    ],
    "mya-l13": [
        "HU"
    ],
    "up580": [
        "UH"
    ],
    "sm-g901f": [
        "SA"
    ],
    "sm-g388f": [
        "SA"
    ],
    "gt-i9515": [
        "SA"
    ],
    "r8006": [
        "OP"
    ],
    "sonyericssonso-01c": [
        "SE"
    ],
    "sonyericssonlt15iv": [
        "SE"
    ],
    "sonyericssonlt18a": [
        "SE"
    ],
    "sonyericssonlt18i-o": [
        "SE"
    ],
    "sonyericssonlt18iv": [
        "SE"
    ],
    "lt18i": [
        "SE"
    ],
    "sonyericssonlt18i": [
        "SE"
    ],
    "sonyericssonst15i": [
        "SE"
    ],
    "st15a": [
        "SE"
    ],
    "st15i": [
        "SE"
    ],
    "sonyericssonsk17i": [
        "SE"
    ],
    "sonyericssonsk17a": [
        "SE"
    ],
    "sonyericssonsk17i-o": [
        "SE"
    ],
    "sonyericssonsk17iv": [
        "SE"
    ],
    "sk17a": [
        "SE"
    ],
    "sk17i": [
        "SE"
    ],
    "sonyericssonmt15i-o": [
        "SE"
    ],
    "sonyericssonmt15i": [
        "SE"
    ],
    "sonyericssonmt15a": [
        "SE"
    ],
    "mt11i": [
        "SE"
    ],
    "sonyericssonmt11i": [
        "SE"
    ],
    "sonyericssonmt11i-o": [
        "SE"
    ],
    "sonyericssonmt11iv": [
        "SE"
    ],
    "sonyericssonmt11a": [
        "SE"
    ],
    "sonyericssonr800x": [
        "SE"
    ],
    "sonyericssonr800at": [
        "SE"
    ],
    "r800x": [
        "SE"
    ],
    "sonyericssonmk16i": [
        "SE"
    ],
    "sonyericssonmk16a": [
        "SE"
    ],
    "mk16i": [
        "SE"
    ],
    "sonyericssonst18i": [
        "SE"
    ],
    "sonyericssonst18a": [
        "SE"
    ],
    "sonyericssonst18iv": [
        "SE"
    ],
    "st18i": [
        "SE"
    ],
    "mt27i": [
        "SE"
    ],
    "sonyericssonmt27i": [
        "SE"
    ],
    "sonyericssonx10iv": [
        "SE"
    ],
    "sonyericssonx10a": [
        "SE"
    ],
    "sonyericssonx10i": [
        "SE"
    ],
    "x10i": [
        "SE"
    ],
    "sonyericssone10iv": [
        "SE"
    ],
    "sonyericssone10a": [
        "SE"
    ],
    "e10i": [
        "SE"
    ],
    "sonyericssonu20a": [
        "SE"
    ],
    "sonyericssone15i-o": [
        "SE"
    ],
    "sonyericssone15i": [
        "SE"
    ],
    "sonyericssone15iv": [
        "SE"
    ],
    "e15i": [
        "SE"
    ],
    "sonyericssone15a": [
        "SE"
    ],
    "sharp-ads1": [
        "SH"
    ],
    "np601sh": [
        "SH"
    ],
    "509sh": [
        "SH"
    ],
    "sh-02h": [
        "SH"
    ],
    "305sh": [
        "SH"
    ],
    "402sh": [
        "SH"
    ],
    "sh-04g": [
        "SH"
    ],
    "sh-02j": [
        "SH"
    ],
    "sh-l02": [
        "SH"
    ],
    "shl22": [
        "SH"
    ],
    "sh-02e": [
        "SH"
    ],
    "sh-01g": [
        "SH"
    ],
    "sh-01h": [
        "SH"
    ],
    "sh-04h": [
        "SH"
    ],
    "605sh": [
        "SH"
    ],
    "sh-03j": [
        "SH"
    ],
    "shv39": [
        "SH"
    ],
    "shv41": [
        "SH"
    ],
    "701sh": [
        "SH"
    ],
    "sh-m09": [
        "SH"
    ],
    "shv42": [
        "SH"
    ],
    "sh-03k": [
        "SH"
    ],
    "706sh": [
        "SH"
    ],
    "803sh": [
        "SH"
    ],
    "sh-03g": [
        "SH"
    ],
    "shv44": [
        "SH"
    ],
    "808sh": [
        "SH"
    ],
    "sh-04l": [
        "SH"
    ],
    "sh-51a": [
        "SH"
    ],
    "shv40": [
        "SH"
    ],
    "shv40_u": [
        "SH"
    ],
    "702sh": [
        "SH"
    ],
    "shv33": [
        "SH"
    ],
    "shv38": [
        "SH"
    ],
    "fs8010": [
        "SH"
    ],
    "sh-m08": [
        "SH"
    ],
    "sh-01l": [
        "SH"
    ],
    "sh-01k": [
        "SH"
    ],
    "shv43": [
        "SH"
    ],
    "sh-z01": [
        "SH"
    ],
    "fs8032": [
        "SH"
    ],
    "sh-02m": [
        "SH"
    ],
    "shv45": [
        "SH"
    ],
    "fs8018": [
        "SH"
    ],
    "901sh": [
        "SH"
    ],
    "shv46": [
        "SH"
    ],
    "sh-m05": [
        "SH"
    ],
    "shv35": [
        "SH"
    ],
    "sh-c02": [
        "SH"
    ],
    "502sh": [
        "SH"
    ],
    "503sh": [
        "SH"
    ],
    "506sh": [
        "SH"
    ],
    "603sh": [
        "SH"
    ],
    "sh-z10": [
        "SH"
    ],
    "801sh": [
        "SH"
    ],
    "shv36": [
        "SH"
    ],
    "tg-l900s": [
        "SH"
    ],
    "507sh": [
        "SH"
    ],
    "s3-sh": [
        "SH"
    ],
    "s5-sh": [
        "SH"
    ],
    "fs8028": [
        "SH"
    ],
    "sh-06d": [
        "SH"
    ],
    "sh-07d": [
        "SH"
    ],
    "sh-10d": [
        "SH"
    ],
    "sh837w": [
        "SH"
    ],
    "fs8002": [
        "SH"
    ],
    "shv47": [
        "SH"
    ],
    "fs8009": [
        "SH"
    ],
    "blackphone 2": [
        "SJ"
    ],
    "selfix_slash6": [
        "SL"
    ],
    "selfix voyager-v45": [
        "SL"
    ],
    "roar e80": [
        "SM"
    ],
    "roar v20": [
        "SM"
    ],
    "symphony_w128": [
        "SM"
    ],
    "symphony w68": [
        "SM"
    ],
    "symphony_w72": [
        "SM"
    ],
    "symphony w82": [
        "SM"
    ],
    "symphony_w90": [
        "SM"
    ],
    "h4433": [
        "SO"
    ],
    "j8170": [
        "SO"
    ],
    "j9110": [
        "SO"
    ],
    "j8110": [
        "SO"
    ],
    "802so": [
        "SO"
    ],
    "so-03l": [
        "SO"
    ],
    "sov40": [
        "SO"
    ],
    "i3113": [
        "SO"
    ],
    "i3123": [
        "SO"
    ],
    "i4113": [
        "SO"
    ],
    "i4193": [
        "SO"
    ],
    "a001so": [
        "SO"
    ],
    "xq-au52": [
        "SO"
    ],
    "i4293": [
        "SO"
    ],
    "i3223": [
        "SO"
    ],
    "i4213": [
        "SO"
    ],
    "901so": [
        "SO"
    ],
    "sov41": [
        "SO"
    ],
    "j8270": [
        "SO"
    ],
    "so-01m": [
        "SO"
    ],
    "j8210": [
        "SO"
    ],
    "j9210": [
        "SO"
    ],
    "902so": [
        "SO"
    ],
    "sov42": [
        "SO"
    ],
    "sonyso-04e": [
        "SO"
    ],
    "so-04f": [
        "SO"
    ],
    "so-04g": [
        "SO"
    ],
    "xperia arc s": [
        "SO"
    ],
    "sonyericssonso-02c": [
        "SO"
    ],
    "sonyericssonso-03d": [
        "SO"
    ],
    "lt26w": [
        "SO"
    ],
    "sonyericssonlt26w": [
        "SO"
    ],
    "sonylt26w": [
        "SO"
    ],
    "c2305": [
        "SO"
    ],
    "c2304": [
        "SO"
    ],
    "s39h": [
        "SO"
    ],
    "d2533": [
        "SO"
    ],
    "d2502": [
        "SO"
    ],
    "e5306": [
        "SO"
    ],
    "e5353": [
        "SO"
    ],
    "e5303": [
        "SO"
    ],
    "e5343": [
        "SO"
    ],
    "e5363": [
        "SO"
    ],
    "e5333": [
        "SO"
    ],
    "e5506": [
        "SO"
    ],
    "e5553": [
        "SO"
    ],
    "e5563": [
        "SO"
    ],
    "e5533": [
        "SO"
    ],
    "sonyc1505": [
        "SO"
    ],
    "sonyc1504": [
        "SO"
    ],
    "sonyc1505v": [
        "SO"
    ],
    "sonyc1505-o": [
        "SO"
    ],
    "c1504": [
        "SO"
    ],
    "c1505": [
        "SO"
    ],
    "sonyc1604": [
        "SO"
    ],
    "sonyc1605": [
        "SO"
    ],
    "c1604": [
        "SO"
    ],
    "c1605": [
        "SO"
    ],
    "d2004": [
        "SO"
    ],
    "d2005": [
        "SO"
    ],
    "d2105": [
        "SO"
    ],
    "d2114": [
        "SO"
    ],
    "d2104": [
        "SO"
    ],
    "d2203": [
        "SO"
    ],
    "d2206": [
        "SO"
    ],
    "d2243": [
        "SO"
    ],
    "d2202": [
        "SO"
    ],
    "d2212": [
        "SO"
    ],
    "e3 dual": [
        "SO"
    ],
    "e2105": [
        "SO"
    ],
    "e2104": [
        "SO"
    ],
    "e2124": [
        "SO"
    ],
    "e2115": [
        "SO"
    ],
    "e2006": [
        "SO"
    ],
    "e2053": [
        "SO"
    ],
    "e2003": [
        "SO"
    ],
    "e2033": [
        "SO"
    ],
    "e2043": [
        "SO"
    ],
    "f3311": [
        "SO"
    ],
    "st27i": [
        "SO"
    ],
    "st27a": [
        "SO"
    ],
    "sonyst27i": [
        "SO"
    ],
    "sonyst27a": [
        "SO"
    ],
    "so-04d": [
        "SO"
    ],
    "lt28i": [
        "SO"
    ],
    "sonyericssonlt28h": [
        "SO"
    ],
    "sonyericssonlt28i": [
        "SO"
    ],
    "sonyericssonlt28at": [
        "SO"
    ],
    "lt28h": [
        "SO"
    ],
    "sonylt28h": [
        "SO"
    ],
    "st26i": [
        "SO"
    ],
    "sonyst26i": [
        "SO"
    ],
    "sonyst26i-o": [
        "SO"
    ],
    "st26a": [
        "SO"
    ],
    "sonyst26a": [
        "SO"
    ],
    "sonyc2104": [
        "SO"
    ],
    "c2104": [
        "SO"
    ],
    "c2105": [
        "SO"
    ],
    "g3313": [
        "SO"
    ],
    "g3311": [
        "SO"
    ],
    "g3312": [
        "SO"
    ],
    "h3311": [
        "SO"
    ],
    "h3321": [
        "SO"
    ],
    "h4311": [
        "SO"
    ],
    "h4331": [
        "SO"
    ],
    "i3312": [
        "SO"
    ],
    "i4332": [
        "SO"
    ],
    "i4312": [
        "SO"
    ],
    "xq-ad51": [
        "SO"
    ],
    "sonyc1905": [
        "SO"
    ],
    "sonyc1904": [
        "SO"
    ],
    "c1905": [
        "SO"
    ],
    "c1904": [
        "SO"
    ],
    "c2005": [
        "SO"
    ],
    "c2004": [
        "SO"
    ],
    "d2305": [
        "SO"
    ],
    "d2306": [
        "SO"
    ],
    "d2303": [
        "SO"
    ],
    "d2403": [
        "SO"
    ],
    "d2406": [
        "SO"
    ],
    "d2302": [
        "SO"
    ],
    "e2353": [
        "SO"
    ],
    "e2333": [
        "SO"
    ],
    "e2306": [
        "SO"
    ],
    "e2303": [
        "SO"
    ],
    "e2363": [
        "SO"
    ],
    "e2312": [
        "SO"
    ],
    "e5603": [
        "SO"
    ],
    "e5633": [
        "SO"
    ],
    "xperia mini pro": [
        "SO"
    ],
    "sonyst23i": [
        "SO"
    ],
    "st23i": [
        "SO"
    ],
    "sonyst23a": [
        "SO"
    ],
    "sonyst23iv": [
        "SO"
    ],
    "xperia neo v": [
        "SO"
    ],
    "lt22i": [
        "SO"
    ],
    "sonyericssonlt22i-o": [
        "SO"
    ],
    "sonyericssonlt22i": [
        "SO"
    ],
    "sonylt22i": [
        "SO"
    ],
    "xperia p": [
        "SO"
    ],
    "lt26i": [
        "SO"
    ],
    "sonyericssonlt26i": [
        "SO"
    ],
    "sonyericssonlt26i-o": [
        "SO"
    ],
    "sonylt26iv": [
        "SO"
    ],
    "sonylt26i": [
        "SO"
    ],
    "xperia s": [
        "SO"
    ],
    "lt26ii": [
        "SO"
    ],
    "sonyc5306": [
        "SO"
    ],
    "sonyc5303": [
        "SO"
    ],
    "c5306": [
        "SO"
    ],
    "c5303": [
        "SO"
    ],
    "c5302": [
        "SO"
    ],
    "xperia sp": [
        "SO"
    ],
    "so-05d": [
        "SO"
    ],
    "lt30p": [
        "SO"
    ],
    "sonylt30p": [
        "SO"
    ],
    "sonylt30p-o": [
        "SO"
    ],
    "sonylt30a": [
        "SO"
    ],
    "lt30a": [
        "SO"
    ],
    "d5106": [
        "SO"
    ],
    "d5103": [
        "SO"
    ],
    "d5102": [
        "SO"
    ],
    "st21i": [
        "SO"
    ],
    "sonyst21i-o": [
        "SO"
    ],
    "sonyst21i": [
        "SO"
    ],
    "sonyst21i2": [
        "SO"
    ],
    "sonyst21a2": [
        "SO"
    ],
    "st21i2": [
        "SO"
    ],
    "lt29i": [
        "SO"
    ],
    "xperia tx": [
        "SO"
    ],
    "st25a": [
        "SO"
    ],
    "sonyericssonst25i-o": [
        "SO"
    ],
    "sonyericssonst25iv": [
        "SO"
    ],
    "sonyericssonst25i": [
        "SO"
    ],
    "st25i": [
        "SO"
    ],
    "sonyst25i": [
        "SO"
    ],
    "sol22": [
        "SO"
    ],
    "sonylt25i": [
        "SO"
    ],
    "lt25i": [
        "SO"
    ],
    "xperia v": [
        "SO"
    ],
    "f5121": [
        "SO"
    ],
    "f5321": [
        "SO"
    ],
    "so-02j": [
        "SO"
    ],
    "f5122": [
        "SO"
    ],
    "sov33": [
        "SO"
    ],
    "so-04h": [
        "SO"
    ],
    "502so": [
        "SO"
    ],
    "f8131": [
        "SO"
    ],
    "f8132": [
        "SO"
    ],
    "f3111": [
        "SO"
    ],
    "f3113": [
        "SO"
    ],
    "f3115": [
        "SO"
    ],
    "f3112": [
        "SO"
    ],
    "f3116": [
        "SO"
    ],
    "f3213": [
        "SO"
    ],
    "f3211": [
        "SO"
    ],
    "f3215": [
        "SO"
    ],
    "f3216": [
        "SO"
    ],
    "f3212": [
        "SO"
    ],
    "g3116": [
        "SO"
    ],
    "g3123": [
        "SO"
    ],
    "g3423": [
        "SO"
    ],
    "g3412": [
        "SO"
    ],
    "g3416": [
        "SO"
    ],
    "g3421": [
        "SO"
    ],
    "g3426": [
        "SO"
    ],
    "g3221": [
        "SO"
    ],
    "h3133": [
        "SO"
    ],
    "h3113": [
        "SO"
    ],
    "h3123": [
        "SO"
    ],
    "h4113": [
        "SO"
    ],
    "h4133": [
        "SO"
    ],
    "h4413": [
        "SO"
    ],
    "h4493": [
        "SO"
    ],
    "h4213": [
        "SO"
    ],
    "h3223": [
        "SO"
    ],
    "f8331": [
        "SO"
    ],
    "601so": [
        "SO"
    ],
    "f8332": [
        "SO"
    ],
    "so-01j": [
        "SO"
    ],
    "sov34": [
        "SO"
    ],
    "g8141": [
        "SO"
    ],
    "so-04j": [
        "SO"
    ],
    "so-04k": [
        "SO"
    ],
    "701so": [
        "SO"
    ],
    "sov36": [
        "SO"
    ],
    "g8342": [
        "SO"
    ],
    "so-01k": [
        "SO"
    ],
    "so-02k": [
        "SO"
    ],
    "g8441": [
        "SO"
    ],
    "h8216": [
        "SO"
    ],
    "h8324": [
        "SO"
    ],
    "sov37": [
        "SO"
    ],
    "h8314": [
        "SO"
    ],
    "h8296": [
        "SO"
    ],
    "702so": [
        "SO"
    ],
    "so-03k": [
        "SO"
    ],
    "h8276": [
        "SO"
    ],
    "so-05k": [
        "SO"
    ],
    "h8266": [
        "SO"
    ],
    "h8166": [
        "SO"
    ],
    "sov38": [
        "SO"
    ],
    "h8416": [
        "SO"
    ],
    "h9436": [
        "SO"
    ],
    "h9493": [
        "SO"
    ],
    "so-01l": [
        "SO"
    ],
    "801so": [
        "SO"
    ],
    "sov39": [
        "SO"
    ],
    "g8232": [
        "SO"
    ],
    "g8231": [
        "SO"
    ],
    "sov35": [
        "SO"
    ],
    "so-03j": [
        "SO"
    ],
    "602so": [
        "SO"
    ],
    "sonyc6616": [
        "SO"
    ],
    "c6606": [
        "SO"
    ],
    "so-02e": [
        "SO"
    ],
    "c6603": [
        "SO"
    ],
    "sonyc6603": [
        "SO"
    ],
    "c6616": [
        "SO"
    ],
    "c6602": [
        "SO"
    ],
    "xperia z": [
        "SO"
    ],
    "sonyc6903": [
        "SO"
    ],
    "c6903": [
        "SO"
    ],
    "so-01f": [
        "SO"
    ],
    "c6906": [
        "SO"
    ],
    "sonyc6906": [
        "SO"
    ],
    "l39h": [
        "SO"
    ],
    "c6916": [
        "SO"
    ],
    "sonyso-02f": [
        "SO"
    ],
    "c6902": [
        "SO"
    ],
    "c6943": [
        "SO"
    ],
    "xperia z1": [
        "SO"
    ],
    "so-02f": [
        "SO"
    ],
    "d5503": [
        "SO"
    ],
    "xperia z1 compact": [
        "SO"
    ],
    "d6502": [
        "SO"
    ],
    "d6503": [
        "SO"
    ],
    "so-03f": [
        "SO"
    ],
    "d6543": [
        "SO"
    ],
    "d6563": [
        "SO"
    ],
    "d6653": [
        "SO"
    ],
    "d6603": [
        "SO"
    ],
    "so-01g": [
        "SO"
    ],
    "sol26": [
        "SO"
    ],
    "401so": [
        "SO"
    ],
    "d6616": [
        "SO"
    ],
    "d6646": [
        "SO"
    ],
    "d6643": [
        "SO"
    ],
    "d5803": [
        "SO"
    ],
    "d5833": [
        "SO"
    ],
    "so-02g": [
        "SO"
    ],
    "d6683": [
        "SO"
    ],
    "d6633": [
        "SO"
    ],
    "e6553": [
        "SO"
    ],
    "e6533": [
        "SO"
    ],
    "d6708": [
        "SO"
    ],
    "402so": [
        "SO"
    ],
    "so-03g": [
        "SO"
    ],
    "sov31": [
        "SO"
    ],
    "e6508": [
        "SO"
    ],
    "501so": [
        "SO"
    ],
    "e6653": [
        "SO"
    ],
    "so-01h": [
        "SO"
    ],
    "sov32": [
        "SO"
    ],
    "e6603": [
        "SO"
    ],
    "e5803": [
        "SO"
    ],
    "so-02h": [
        "SO"
    ],
    "e6633": [
        "SO"
    ],
    "e6883": [
        "SO"
    ],
    "e6853": [
        "SO"
    ],
    "so-03h": [
        "SO"
    ],
    "e6833": [
        "SO"
    ],
    "sonyc6506": [
        "SO"
    ],
    "c6502": [
        "SO"
    ],
    "c6506": [
        "SO"
    ],
    "c6503": [
        "SO"
    ],
    "xperia zl": [
        "SO"
    ],
    "c5502": [
        "SO"
    ],
    "c5503": [
        "SO"
    ],
    "spice mi-349": [
        "SP"
    ],
    "spice_mi-422": [
        "SP"
    ],
    "spice mi-502": [
        "SP"
    ],
    "spicemi-520": [
        "SP"
    ],
    "actoma ace": [
        "SQ"
    ],
    "santin ant.w": [
        "SQ"
    ],
    "santin #armor": [
        "SQ",
        "UL"
    ],
    "bitbiz_v58": [
        "SQ"
    ],
    "santin #candy u7": [
        "SQ"
    ],
    "candy u7 pro": [
        "SQ"
    ],
    "santin #dante": [
        "SQ"
    ],
    "dreamplus03a": [
        "SQ"
    ],
    "santin galaz": [
        "SQ"
    ],
    "santin greenorange": [
        "SQ"
    ],
    "santin halove": [
        "SQ"
    ],
    "santin js": [
        "SQ"
    ],
    "santin monica": [
        "SQ"
    ],
    "santin_n1": [
        "SQ"
    ],
    "santin n3": [
        "SQ"
    ],
    "santin newdun": [
        "SQ"
    ],
    "santin power": [
        "SQ"
    ],
    "santin s6": [
        "SQ"
    ],
    "santin v9": [
        "SQ"
    ],
    "santin ysl-y7": [
        "SQ"
    ],
    "schr9gr": [
        "SS"
    ],
    "1803-a01": [
        "36"
    ],
    "startrail iii": [
        "SX"
    ],
    "startrail 4": [
        "SX"
    ],
    "startrail 6 4g": [
        "SX"
    ],
    "startrail7": [
        "SX"
    ],
    "startrail 8": [
        "SX"
    ],
    "startrail5": [
        "SX"
    ],
    "startrail6": [
        "SX"
    ],
    "staraddict iii": [
        "SX"
    ],
    "nx601j": [
        "57"
    ],
    "nx513j": [
        "57"
    ],
    "nx595j": [
        "57"
    ],
    "nx591j": [
        "57"
    ],
    "nx563j": [
        "57"
    ],
    "nx551j": [
        "57"
    ],
    "nx523j_v1": [
        "57"
    ],
    "nx531j": [
        "57"
    ],
    "nx508j": [
        "57"
    ],
    "nx506j": [
        "57"
    ],
    "nx503a": [
        "57"
    ],
    "nx40x": [
        "57"
    ],
    "nx402": [
        "57"
    ],
    "n9810": [
        "ZT"
    ],
    "n9560": [
        "ZT"
    ],
    "n9521": [
        "ZT"
    ],
    "ta-1000": [
        "NK"
    ],
    "sm-a205gn": [
        "SA"
    ],
    "sky_3.5": [
        "SW"
    ],
    "sky 4.0d": [
        "SW"
    ],
    "sky 4.5lm": [
        "SW"
    ],
    "sky 5.0lm": [
        "SW"
    ],
    "sky 5.5q": [
        "SW"
    ],
    "sky_7.0w": [
        "SW"
    ],
    "elite 5.0m": [
        "SW"
    ],
    "elite_5_5_octa": [
        "SW"
    ],
    "elite 5.5l+": [
        "SW"
    ],
    "elite 6.0l": [
        "SW"
    ],
    "fuego 4.0t": [
        "SW"
    ],
    "fuego 5.0+": [
        "SW"
    ],
    "platinum_5.0m": [
        "SW"
    ],
    "platinum_m5": [
        "SW"
    ],
    "android edition by sfr staraddict": [
        "SX"
    ],
    "smartphone android by sfr staraddict ii": [
        "SX"
    ],
    "staraddict ii plus": [
        "SX"
    ],
    "staraddict 4": [
        "SX"
    ],
    "android edition starnaute": [
        "SX"
    ],
    "starnaute ii": [
        "SX"
    ],
    "starshine": [
        "SX",
        "HU"
    ],
    "starshine ii": [
        "SX"
    ],
    "android edition startext": [
        "SX"
    ],
    "startext ii": [
        "SX"
    ],
    "android edition startrail": [
        "SX"
    ],
    "startrail ii": [
        "SX",
        "HU"
    ],
    "startrail4": [
        "SX"
    ],
    "starxtrem": [
        "SX"
    ],
    "telenor_one_touch_c": [
        "T2"
    ],
    "telenor_smart_pro": [
        "T2"
    ],
    "telenor touch plus": [
        "T2"
    ],
    "trevi_phablet_4c": [
        "T3"
    ],
    "phablet 4s": [
        "T3"
    ],
    "phablet 4.5q": [
        "T3"
    ],
    "trevi_phablet_5_s": [
        "T3"
    ],
    "knight 2": [
        "T4"
    ],
    "thl t100s": [
        "T4"
    ],
    "thl__t100s": [
        "T4"
    ],
    "thl_t11": [
        "T4"
    ],
    "thl t6 pro": [
        "T4"
    ],
    "thl w11": [
        "T4"
    ],
    "tm-sm410": [
        "T8"
    ],
    "tm-sm500n": [
        "T8"
    ],
    "touchmate tm-sm540": [
        "T8"
    ],
    "coto w418": [
        "T9"
    ],
    "coto_t40017": [
        "T9"
    ],
    "tecno cb7j": [
        "TB"
    ],
    "tecno cb7": [
        "TB"
    ],
    "tecno id6": [
        "TB"
    ],
    "tecno d1": [
        "TB"
    ],
    "tecno d3": [
        "TB"
    ],
    "tecno f4 pro": [
        "TB"
    ],
    "tecno f7": [
        "TB"
    ],
    "tecno h5": [
        "TB"
    ],
    "l3": [
        "TB"
    ],
    "tecno m3": [
        "TB"
    ],
    "tecno_m3": [
        "TB"
    ],
    "tecno m7": [
        "TB"
    ],
    "tecno n3": [
        "TB"
    ],
    "tecno_n7": [
        "TB"
    ],
    "tecno_p3": [
        "TB"
    ],
    "tecno p3s": [
        "TB"
    ],
    "tecno p5": [
        "TB"
    ],
    "tecno p9": [
        "TB"
    ],
    "phantom6": [
        "TB"
    ],
    "phantom6-plus": [
        "TB"
    ],
    "tecno lb8": [
        "TB"
    ],
    "tecno q1": [
        "TB"
    ],
    "tecno s3": [
        "TB"
    ],
    "tecno s3c": [
        "TB"
    ],
    "tecno t3": [
        "TB"
    ],
    "tecno_t3": [
        "TB"
    ],
    "7040n": [
        "TC"
    ],
    "tcl a916": [
        "TC"
    ],
    "5152d": [
        "TC"
    ],
    "5199i": [
        "TC"
    ],
    "tcl-d662": [
        "TC"
    ],
    "tclgalag60(9108a)": [
        "TC"
    ],
    "tcl i718m": [
        "TC"
    ],
    "tcl j636d+": [
        "TC"
    ],
    "tcl j706t": [
        "TC"
    ],
    "5133a": [
        "TC"
    ],
    "5159j": [
        "TC"
    ],
    "5159a": [
        "TC"
    ],
    "a502dl": [
        "TC"
    ],
    "tcl m2m": [
        "TC"
    ],
    "tcl p301m": [
        "TC"
    ],
    "tcl p331m": [
        "TC"
    ],
    "tcl p332u": [
        "TC"
    ],
    "tcl p360w": [
        "TC"
    ],
    "tcl_p561u": [
        "TC"
    ],
    "tcl_p620m": [
        "TC"
    ],
    "tcl p728m": [
        "TC"
    ],
    "t780h": [
        "TC"
    ],
    "tcl s960": [
        "TC"
    ],
    "tcl_w939": [
        "TC"
    ],
    "tcl y910": [
        "TC"
    ],
    "telego_joy2": [
        "TG"
    ],
    "telego mate": [
        "TG"
    ],
    "telego-w503": [
        "TG"
    ],
    "foxtrot": [
        "TL"
    ],
    "telefunken outdoor lte": [
        "TL"
    ],
    "tf-sp5001": [
        "TL"
    ],
    "t-mobile_espresso": [
        "TM"
    ],
    "t-mobile g1": [
        "TM"
    ],
    "t-mobile g2": [
        "TM"
    ],
    "t-mobile mytouch 3g": [
        "TM"
    ],
    "t-mobile mytouch 3g slide": [
        "TM",
        "WI"
    ],
    "t-mobile_mytouch_q": [
        "TM"
    ],
    "revvl 2": [
        "TM"
    ],
    "revvl 2 plus": [
        "TM"
    ],
    "revvlry": [
        "TM"
    ],
    "t-mobile vivacity": [
        "TM"
    ],
    "5014g": [
        "TN"
    ],
    "every35": [
        "TN"
    ],
    "tlink350": [
        "TN"
    ],
    "tlink351": [
        "TN"
    ],
    "tlink355": [
        "TN"
    ],
    "tlink405": [
        "TN"
    ],
    "tlink455": [
        "TN"
    ],
    "tlink475": [
        "TN"
    ],
    "tech pad +q545": [
        "TP"
    ],
    "techpad x5": [
        "TP"
    ],
    "tmovi infinit lite": [
        "TQ"
    ],
    "infinit_lite_2": [
        "TQ"
    ],
    "tmovi prime": [
        "TQ"
    ],
    "tmovi_yeah_beat": [
        "TQ"
    ],
    "tmovi yeahlive": [
        "TQ"
    ],
    "turbo-x_a2": [
        "TR"
    ],
    "turbo-x_e3": [
        "TR"
    ],
    "turbo-x pi": [
        "TR"
    ],
    "turbox_s3": [
        "TR"
    ],
    "tsb_cloud_companion;toshiba_ac_and_az": [
        "TS"
    ],
    "toshiba_folio_and_a": [
        "TS"
    ],
    "is04": [
        "TS"
    ],
    "is11t": [
        "TS"
    ],
    "t-01c": [
        "TS"
    ],
    "t-01d": [
        "TS"
    ],
    "t-02d": [
        "TS"
    ],
    "startrail tt": [
        "TU",
        "SX"
    ],
    "nuclearsx-sp5": [
        "TV"
    ],
    "amazing a4": [
        "TW"
    ],
    "amazing a4s": [
        "TW"
    ],
    "amazing a5s": [
        "TW"
    ],
    "amazing a8": [
        "TW"
    ],
    "amazing x2": [
        "TW"
    ],
    "amazing x3": [
        "TW"
    ],
    "amazing_x3s": [
        "TW"
    ],
    "amazing x5": [
        "TW"
    ],
    "amazing x5s": [
        "TW"
    ],
    "amazing x6": [
        "TW"
    ],
    "tooky a19": [
        "TY"
    ],
    "tooky a9plus": [
        "TY"
    ],
    "tooky t1982": [
        "TY"
    ],
    "tooky t83": [
        "TY"
    ],
    "tooky t86": [
        "TY"
    ],
    "tooky t88": [
        "TY"
    ],
    "tooky w1": [
        "TY"
    ],
    "tm-4982": [
        "TZ"
    ],
    "tm-5201": [
        "TZ"
    ],
    "tm-3000": [
        "TZ"
    ],
    "tm-3200r": [
        "TZ"
    ],
    "tm-3204r": [
        "TZ"
    ],
    "tm-4003": [
        "TZ"
    ],
    "texet tm-4083": [
        "TZ"
    ],
    "tm-4377": [
        "TZ"
    ],
    "tm-4504": [
        "TZ"
    ],
    "tm-4510": [
        "TZ"
    ],
    "tm-4513": [
        "TZ"
    ],
    "tm-5003": [
        "TZ"
    ],
    "tm-5005": [
        "TZ"
    ],
    "tm-5017": [
        "TZ"
    ],
    "tm-5071": [
        "TZ"
    ],
    "tm-5073": [
        "TZ"
    ],
    "tm-5074": [
        "TZ"
    ],
    "tm-5075": [
        "TZ"
    ],
    "tm-5076": [
        "TZ"
    ],
    "tm-5077": [
        "TZ"
    ],
    "tm-5200": [
        "TZ"
    ],
    "tm-5204": [
        "TZ"
    ],
    "tm-5277": [
        "TZ"
    ],
    "tm-5377": [
        "TZ"
    ],
    "tm-5505": [
        "TZ"
    ],
    "tm-5513": [
        "TZ"
    ],
    "tm-5571": [
        "TZ"
    ],
    "tm-5581": [
        "TZ"
    ],
    "tm-6003": [
        "TZ"
    ],
    "tm-5508": [
        "TZ"
    ],
    "tm-4082r/x-driver": [
        "TZ"
    ],
    "x-force(tm-5009)": [
        "TZ"
    ],
    "x-forcetm-5009": [
        "TZ"
    ],
    "tm-5006": [
        "TZ"
    ],
    "tm-5503": [
        "TZ"
    ],
    "tm-5016": [
        "TZ"
    ],
    "tm-3500": [
        "TZ"
    ],
    "tm_5011": [
        "TZ"
    ],
    "x-plustm-5577": [
        "TZ"
    ],
    "x-plus(tm-5577)": [
        "TZ"
    ],
    "tm-4503": [
        "TZ"
    ],
    "tm-5010": [
        "TZ"
    ],
    "tm-5007": [
        "TZ"
    ],
    "tm-4071": [
        "TZ"
    ],
    "tm-4515": [
        "TZ"
    ],
    "a101s": [
        "U1"
    ],
    "visionbook p50 lte": [
        "UA"
    ],
    "visionbook p55 lte": [
        "UA"
    ],
    "visionbook p55 lte pro": [
        "UA"
    ],
    "uscc-e6762": [
        "UC"
    ],
    "uhappy up320": [
        "UH"
    ],
    "up350": [
        "UH"
    ],
    "up520": [
        "UH"
    ],
    "up720": [
        "UH"
    ],
    "up920": [
        "UH"
    ],
    "utok 450d": [
        "UK"
    ],
    "utok 451d": [
        "UK"
    ],
    "armor": [
        "UL"
    ],
    "armor_2": [
        "UL"
    ],
    "armor_3": [
        "UL"
    ],
    "armor 5s": [
        "UL"
    ],
    "armor_6": [
        "UL"
    ],
    "armor_6s": [
        "UL"
    ],
    "armor_7": [
        "UL"
    ],
    "armor_x": [
        "UL"
    ],
    "armor_x2": [
        "UL"
    ],
    "armor_x3": [
        "UL"
    ],
    "armor x5": [
        "UL"
    ],
    "armor_x6": [
        "UL"
    ],
    "be one": [
        "UL"
    ],
    "be_one_lite": [
        "UL"
    ],
    "be_pure": [
        "UL"
    ],
    "be_pure_lite": [
        "UL"
    ],
    "be touch": [
        "UL"
    ],
    "be touch 3": [
        "UL"
    ],
    "be_x": [
        "UL"
    ],
    "gemini pro": [
        "UL"
    ],
    "power_3": [
        "UL"
    ],
    "power_5": [
        "UL"
    ],
    "power_6": [
        "UL"
    ],
    "ulefone_s1_pro": [
        "UL"
    ],
    "s10_pro": [
        "UL"
    ],
    "ulefone s7": [
        "UL"
    ],
    "ulefone s8": [
        "UL"
    ],
    "u007 pro": [
        "UL"
    ],
    "u008 pro": [
        "UL"
    ],
    "ulefone_x": [
        "UL"
    ],
    "a5_pro": [
        "UM"
    ],
    "umi_diamond": [
        "UM"
    ],
    "umi_diamond_x": [
        "UM"
    ],
    "umi emax": [
        "UM"
    ],
    "umi_london": [
        "UM"
    ],
    "umi_max": [
        "UM"
    ],
    "umi touch": [
        "UM"
    ],
    "umi touch x": [
        "UM"
    ],
    "umidigi x": [
        "UM"
    ],
    "umidigi z": [
        "UM"
    ],
    "u903": [
        "UO"
    ],
    "u905": [
        "UO"
    ],
    "u5151": [
        "UO"
    ],
    "u513": [
        "UO"
    ],
    "u615": [
        "UO"
    ],
    "u613": [
        "UO"
    ],
    "u710": [
        "UO"
    ],
    "u611": [
        "UO"
    ],
    "u720": [
        "UO"
    ],
    "u-830": [
        "UO"
    ],
    "uniscope_t5588": [
        "US"
    ],
    "uniscope_u1205": [
        "US"
    ],
    "uniscope us618": [
        "US"
    ],
    "uniscope us818": [
        "US"
    ],
    "unonu um405 lite": [
        "UU"
    ],
    "u452tl": [
        "UX"
    ],
    "u504tl": [
        "UX"
    ],
    "u671c": [
        "UX"
    ],
    "u673c": [
        "UX"
    ],
    "u680c": [
        "UX"
    ],
    "u683cl": [
        "UX"
    ],
    "u693cl": [
        "UX"
    ],
    "jelly-pro": [
        "UZ"
    ],
    "titan": [
        "UZ"
    ],
    "t5se": [
        "V0"
    ],
    "vk700-max": [
        "V0"
    ],
    "voto-t8100": [
        "V1"
    ],
    "voto vt808": [
        "V1"
    ],
    "voto_vt818_td": [
        "V1"
    ],
    "voto vt818+": [
        "V1"
    ],
    "vt888": [
        "V1"
    ],
    "vt898": [
        "V1"
    ],
    "voto x2": [
        "V1"
    ],
    "gyga_qs": [
        "V2"
    ],
    "jax mini": [
        "V2"
    ],
    "jax_n": [
        "V2"
    ],
    "jax_s": [
        "V2"
    ],
    "jax_s_a7": [
        "V2"
    ],
    "volt s": [
        "V2"
    ],
    "volt_s_a7": [
        "V2"
    ],
    "volt_x": [
        "V2"
    ],
    "xylo q": [
        "V2"
    ],
    "zun x": [
        "V2"
    ],
    "zun xo": [
        "V2"
    ],
    "xa pro": [
        "V3"
    ],
    "vivax_fly3": [
        "V5"
    ],
    "fly5_lite": [
        "V5",
        "FL"
    ],
    "fun_s500": [
        "V5"
    ],
    "vivax point x551": [
        "V5"
    ],
    "vivax smart point x5010": [
        "V5"
    ],
    "venture v12": [
        "V6"
    ],
    "venture v2": [
        "V6"
    ],
    "venture v7": [
        "V6"
    ],
    "venture v8": [
        "V6"
    ],
    "vsun illusion": [
        "V9"
    ],
    "vsun race": [
        "V9"
    ],
    "vsun v9": [
        "V9"
    ],
    "videocon_a10": [
        "VD"
    ],
    "videocon a10": [
        "VD"
    ],
    "videocon a27i": [
        "VD"
    ],
    "v502430": [
        "VD"
    ],
    "aster p": [
        "VE"
    ],
    "constellation x": [
        "VE"
    ],
    "vodafone 845": [
        "VF"
    ],
    "vodafone 858": [
        "VF"
    ],
    "vodafone_858": [
        "VF"
    ],
    "vodafone 975n": [
        "VF"
    ],
    "vodafone 975": [
        "VF"
    ],
    "vodafone 785": [
        "VF"
    ],
    "vodafone 985n": [
        "VF"
    ],
    "vodafone smart 4 turbo": [
        "VF"
    ],
    "vodafone 890n": [
        "VF"
    ],
    "vodafone smart 4g": [
        "VF"
    ],
    "vfd320": [
        "VF"
    ],
    "vodafonesmartchat-msm7225a-v02c-sep272012-vodafone-ie": [
        "VF"
    ],
    "vfd 510": [
        "VF"
    ],
    "vfd 513": [
        "VF"
    ],
    "vf695": [
        "VF"
    ],
    "vfd 200": [
        "VF"
    ],
    "vf-696": [
        "VF"
    ],
    "vodafone smart ii": [
        "VF"
    ],
    "vf685": [
        "VF"
    ],
    "vodafone 875": [
        "VF"
    ],
    "vfd 100": [
        "VF"
    ],
    "vfd 300": [
        "VF"
    ],
    "vfd 610": [
        "VF"
    ],
    "vfd 720": [
        "VF"
    ],
    "vfd 900": [
        "VF"
    ],
    "vf-895n": [
        "VF"
    ],
    "vfd 600": [
        "VF"
    ],
    "vf-795": [
        "VF"
    ],
    "vfd 500": [
        "VF"
    ],
    "vfd 502": [
        "VF"
    ],
    "vodafone smart ultra 6": [
        "VF"
    ],
    "vfd 700": [
        "VF"
    ],
    "vfd 820": [
        "VF"
    ],
    "vorago cell-500": [
        "VG"
    ],
    "active 1+": [
        "VH"
    ],
    "bee 3": [
        "VH"
    ],
    "joy 1+": [
        "VH"
    ],
    "vk6050": [
        "V0"
    ],
    "vk6735": [
        "V0"
    ],
    "vk700": [
        "V0"
    ],
    "vk700 pro": [
        "V0"
    ],
    "vk700x": [
        "V0"
    ],
    "verykool cyprus ii jr s6004": [
        "VL"
    ],
    "verykools5019": [
        "VL"
    ],
    "verykoolsl5200": [
        "VL"
    ],
    "verykool wave pro s5021": [
        "VL"
    ],
    "creon f5": [
        "VN"
    ],
    "cx-508": [
        "VN"
    ],
    "venso cx-551": [
        "VN"
    ],
    "reiv 500": [
        "VN"
    ],
    "apollo lite": [
        "VR"
    ],
    "apollo x": [
        "VR"
    ],
    "vernee_m5": [
        "VR"
    ],
    "mars pro": [
        "VR"
    ],
    "thor e": [
        "VR"
    ],
    "thor plus": [
        "VR"
    ],
    "viewsonic a8+": [
        "VS"
    ],
    "viewsonic v500": [
        "VS"
    ],
    "viewphone3": [
        "VS"
    ],
    "vsp145m": [
        "VT"
    ],
    "vsp250g": [
        "VT"
    ],
    "vsp250s": [
        "VT"
    ],
    "vsp355s": [
        "VT"
    ],
    "venus go": [
        "VT"
    ],
    "venus_v3_5040_2gb": [
        "VT"
    ],
    "v3_5580_dual": [
        "VT"
    ],
    "venus v5": [
        "VT"
    ],
    "venus v6": [
        "VT"
    ],
    "venus z10": [
        "VT"
    ],
    "venus z20": [
        "VT"
    ],
    "vp5004a": [
        "VU"
    ],
    "v1824a": [
        "VV"
    ],
    "v1824ba": [
        "VV"
    ],
    "v1955a": [
        "VV"
    ],
    "v2024a": [
        "VV"
    ],
    "v2025a": [
        "VV"
    ],
    "v1914a": [
        "VV"
    ],
    "v1981a": [
        "VV"
    ],
    "v1936a": [
        "VV"
    ],
    "v1936al": [
        "VV"
    ],
    "v1922a": [
        "VV"
    ],
    "v1916a": [
        "VV"
    ],
    "v2023a": [
        "VV"
    ],
    "v1986a": [
        "VV"
    ],
    "v2012a": [
        "VV"
    ],
    "v1919a": [
        "VV"
    ],
    "vivo 1805": [
        "VV"
    ],
    "v1923a": [
        "VV"
    ],
    "v1924a": [
        "VV"
    ],
    "v1950a": [
        "VV"
    ],
    "v1821t": [
        "VV"
    ],
    "v1821a": [
        "VV"
    ],
    "vivo one": [
        "VV"
    ],
    "v1831a": [
        "VV"
    ],
    "v1831t": [
        "VV"
    ],
    "v1832a": [
        "VV"
    ],
    "v1832t": [
        "VV"
    ],
    "vivo s3+": [
        "VV"
    ],
    "v1932a": [
        "VV"
    ],
    "v1962a": [
        "VV"
    ],
    "v2020ca": [
        "VV"
    ],
    "v2020a": [
        "VV"
    ],
    "vivo s7t": [
        "VV"
    ],
    "v1941a": [
        "VV"
    ],
    "v1928a": [
        "VV"
    ],
    "vivo v1": [
        "VV"
    ],
    "vivo 1804": [
        "VV"
    ],
    "vivo 1806": [
        "VV"
    ],
    "vivo 1818": [
        "VV"
    ],
    "vivo 1909": [
        "VV"
    ],
    "vivo 1601": [
        "VV"
    ],
    "vivo 1609": [
        "VV"
    ],
    "vivo 1611": [
        "VV"
    ],
    "vivo 1713": [
        "VV"
    ],
    "vivo 1612": [
        "VV"
    ],
    "vivo 1718": [
        "VV"
    ],
    "vivo 1716": [
        "VV"
    ],
    "vivo 1723": [
        "VV"
    ],
    "vivo 1727": [
        "VV"
    ],
    "vivo x1": [
        "VV"
    ],
    "vivo 1721": [
        "VV"
    ],
    "vivo x20plus": [
        "VV"
    ],
    "vivo 1725": [
        "VV"
    ],
    "v1814a": [
        "VV"
    ],
    "v1814t": [
        "VV"
    ],
    "v1809t": [
        "VV"
    ],
    "v1816a": [
        "VV"
    ],
    "v1809a": [
        "VV"
    ],
    "v1816t": [
        "VV"
    ],
    "v1829t": [
        "VV"
    ],
    "v1838a": [
        "VV"
    ],
    "v1829a": [
        "VV"
    ],
    "v1838t": [
        "VV"
    ],
    "v1836t": [
        "VV"
    ],
    "v1836a": [
        "VV"
    ],
    "v1938ct": [
        "VV"
    ],
    "v1938t": [
        "VV"
    ],
    "bbg-vivo x3v": [
        "VV"
    ],
    "v2001a": [
        "VV"
    ],
    "v2005a": [
        "VV"
    ],
    "v2011a": [
        "VV"
    ],
    "viv-vivo x5max v": [
        "VV",
        "DO"
    ],
    "viv-vivo x5pro v": [
        "VV"
    ],
    "vivo x9plus": [
        "VV"
    ],
    "vivo xplay": [
        "VV"
    ],
    "vivo y11i t": [
        "VV"
    ],
    "vivo 1902": [
        "VV"
    ],
    "vivo 1915": [
        "VV"
    ],
    "vivo y19t": [
        "VV"
    ],
    "vivo_y19t": [
        "VV"
    ],
    "v1901a": [
        "VV"
    ],
    "v1901t": [
        "VV"
    ],
    "v1930a": [
        "VV"
    ],
    "v1965a": [
        "VV"
    ],
    "tecno-j8": [
        "TB"
    ],
    "tecno ce9": [
        "TB"
    ],
    "tecno ce9h": [
        "TB"
    ],
    "tecno ce8": [
        "TB"
    ],
    "tecno cd6j": [
        "TB"
    ],
    "tecno cg6": [
        "TB"
    ],
    "tecno cd7": [
        "TB"
    ],
    "tecno ke5k": [
        "TB"
    ],
    "tecno ke7": [
        "TB"
    ],
    "tecno ce7j": [
        "TB"
    ],
    "tecno cd8": [
        "TB"
    ],
    "tecno kd6": [
        "TB"
    ],
    "tecno ke5": [
        "TB"
    ],
    "tecno ke6": [
        "TB"
    ],
    "tecno ke6j": [
        "TB"
    ],
    "tecno in2": [
        "TB"
    ],
    "kd50": [
        "KK"
    ],
    "r7_1": [
        "4M"
    ],
    "airis tm50qz": [
        "AIR"
    ],
    "alpha 1v": [
        "LA"
    ],
    "af9030": [
        "LV"
    ],
    "amber8": [
        "IP"
    ],
    "aosp on bramble": [
        "GO"
    ],
    "amber8s": [
        "IP"
    ],
    "aosp on sunfish": [
        "GO"
    ],
    "ap5701": [
        "ATH"
    ],
    "ap5702": [
        "ATH"
    ],
    "astro 55r": [
        "MW"
    ],
    "astro 5t": [
        "MW"
    ],
    "astro 5x": [
        "MW"
    ],
    "aura pro": [
        "ZU"
    ],
    "aura pro jlo": [
        "ZU"
    ],
    "betacrux": [
        "H13"
    ],
    "bl50p_tg05": [
        "BM"
    ],
    "bl50p_tg06": [
        "BM"
    ],
    "bl50p_tg07": [
        "BM"
    ],
    "bl50": [
        "BM"
    ],
    "bl51_mv05": [
        "BM"
    ],
    "bl60_tg05": [
        "BM"
    ],
    "ds502": [
        "DDG"
    ],
    "ds6018": [
        "DDG"
    ],
    "ds6261": [
        "DDG"
    ],
    "flare y5": [
        "CH"
    ],
    "kempler_p3": [
        "KS"
    ],
    "nobu a55 pro": [
        "AM"
    ],
    "okapia x1": [
        "OA"
    ],
    "rock_x8+": [
        "E5"
    ],
    "tronik_1": [
        "4R"
    ],
    "thrill power": [
        "CD"
    ],
    "telma_f1_max_4g": [
        "TEL"
    ],
    "tinku lte": [
        "QUI"
    ],
    "tmaf025g": [
        "TM"
    ],
    "tmaf035g": [
        "TM"
    ],
    "tc15": [
        "PZ"
    ],
    "tc77": [
        "PZ"
    ],
    "hammer_energy_2_2022": [
        "HAM"
    ],
    "kc516 pro": [
        "KO"
    ],
    "kc516": [
        "KO"
    ],
    "clearphone 220": [
        "YW"
    ],
    "iswag neo": [
        "9I"
    ],
    "coolmintt blaze 2": [
        "OM"
    ],
    "iswag activ": [
        "9I"
    ],
    "vivo 1603": [
        "VV"
    ],
    "vivo 1610": [
        "VV"
    ],
    "v1934a": [
        "VV"
    ],
    "vivo 1719": [
        "VV"
    ],
    "vivo 1714": [
        "VV"
    ],
    "v2002a": [
        "VV"
    ],
    "vivo 1724": [
        "VV"
    ],
    "vivo 1801": [
        "VV"
    ],
    "v1731ca": [
        "VV"
    ],
    "v1913a": [
        "VV"
    ],
    "v1913t": [
        "VV"
    ],
    "vivo 1808": [
        "VV"
    ],
    "vivo 1803": [
        "VV"
    ],
    "vivo 1808i": [
        "VV"
    ],
    "vivo 1812": [
        "VV"
    ],
    "v1732t": [
        "VV"
    ],
    "v1732a": [
        "VV"
    ],
    "vivo 1726": [
        "VV"
    ],
    "v1730ea": [
        "VV"
    ],
    "vivo 1811": [
        "VV"
    ],
    "vivo 1817": [
        "VV"
    ],
    "viv-vivo y913": [
        "VV"
    ],
    "vivo 1820": [
        "VV"
    ],
    "vivo 1814": [
        "VV"
    ],
    "vivo 1815": [
        "VV"
    ],
    "v1818t": [
        "VV"
    ],
    "v1818a": [
        "VV"
    ],
    "v1818ct": [
        "VV"
    ],
    "v1818ca": [
        "VV"
    ],
    "vivo 1807": [
        "VV"
    ],
    "v1813t": [
        "VV"
    ],
    "v1813a": [
        "VV"
    ],
    "v1945a": [
        "VV"
    ],
    "v1801a0": [
        "VV"
    ],
    "v1730da": [
        "VV"
    ],
    "v1730dt": [
        "VV"
    ],
    "vivo 1917": [
        "VV"
    ],
    "v1813ba": [
        "VV"
    ],
    "v1813bt": [
        "VV"
    ],
    "v1730ga": [
        "VV"
    ],
    "v1921a": [
        "VV"
    ],
    "v1911a": [
        "VV"
    ],
    "v1990a": [
        "VV"
    ],
    "v1963a": [
        "VV"
    ],
    "baccara": [
        "VX"
    ],
    "eagle_4g": [
        "VX"
    ],
    "impress action": [
        "VX"
    ],
    "impress alfa": [
        "VX"
    ],
    "impress bravo": [
        "VX"
    ],
    "impress_calypso": [
        "VX"
    ],
    "impress click": [
        "VX"
    ],
    "impress cult": [
        "VX"
    ],
    "impress_dune": [
        "VX"
    ],
    "impress_eagle": [
        "VX"
    ],
    "impress_energy": [
        "VX"
    ],
    "impressmax": [
        "VX"
    ],
    "impress_wolf": [
        "VX"
    ],
    "impress xxl": [
        "VX"
    ],
    "lion_dual": [
        "VX"
    ],
    "sp5026i-scorpio": [
        "W1"
    ],
    "wigor v4": [
        "W2"
    ],
    "walton primo": [
        "WA"
    ],
    "primo d2": [
        "WA"
    ],
    "primo_d4": [
        "WA"
    ],
    "primo d6": [
        "WA"
    ],
    "primo d8": [
        "WA"
    ],
    "primo e8": [
        "WA"
    ],
    "primo f7": [
        "WA"
    ],
    "primo g4": [
        "WA"
    ],
    "primo g6": [
        "WA"
    ],
    "primo g7": [
        "WA"
    ],
    "primo h4": [
        "WA"
    ],
    "primo h6": [
        "WA"
    ],
    "primo_hm": [
        "WA"
    ],
    "primo r4": [
        "WA"
    ],
    "primo r6": [
        "WA"
    ],
    "primo s3 mini": [
        "WA"
    ],
    "primo_s5": [
        "WA"
    ],
    "primo s6 infinity": [
        "WA"
    ],
    "primo x4": [
        "WA"
    ],
    "primo x4 pro": [
        "WA"
    ],
    "wileyfox spark": [
        "WF"
    ],
    "wileyfox spark +": [
        "WF"
    ],
    "wileyfox spark x": [
        "WF"
    ],
    "wileyfox storm": [
        "WF"
    ],
    "wileyfox swift": [
        "WF"
    ],
    "swift 2": [
        "WF"
    ],
    "swift 2 plus": [
        "WF"
    ],
    "swift 2 x": [
        "WF"
    ],
    "at-as43d3": [
        "WG"
    ],
    "at-as45d1": [
        "WG"
    ],
    "barry": [
        "WI"
    ],
    "birdy": [
        "WI"
    ],
    "bloom": [
        "WI"
    ],
    "cink five": [
        "WI"
    ],
    "cink king": [
        "WI"
    ],
    "cink peax": [
        "WI"
    ],
    "cink peax 2": [
        "WI"
    ],
    "cink_peax_2": [
        "WI"
    ],
    "wiko-cink slim": [
        "WI"
    ],
    "cink_slim": [
        "WI"
    ],
    "cink+": [
        "WI"
    ],
    "darkfull": [
        "WI"
    ],
    "darkmoon": [
        "WI"
    ],
    "darknight": [
        "WI"
    ],
    "darkside": [
        "WI"
    ],
    "freddy": [
        "WI"
    ],
    "getaway": [
        "WI"
    ],
    "goa": [
        "WI"
    ],
    "harry": [
        "WI"
    ],
    "highway": [
        "WI"
    ],
    "highway_signs": [
        "WI"
    ],
    "iggy": [
        "WI"
    ],
    "jerry": [
        "WI"
    ],
    "jerry2": [
        "WI"
    ],
    "w_k300": [
        "WI"
    ],
    "jerry max": [
        "WI"
    ],
    "jimmy": [
        "WI"
    ],
    "kite": [
        "WI"
    ],
    "lenny": [
        "WI"
    ],
    "lenny2": [
        "WI"
    ],
    "lenny3": [
        "WI"
    ],
    "lenny3 max": [
        "WI"
    ],
    "lenny4": [
        "WI"
    ],
    "lenny4 plus": [
        "WI"
    ],
    "w_k400": [
        "WI"
    ],
    "u307as": [
        "WI"
    ],
    "ozzy": [
        "WI"
    ],
    "pulp": [
        "WI"
    ],
    "pulp 4g": [
        "WI"
    ],
    "pulp fab": [
        "WI"
    ],
    "pulp fab 4g": [
        "WI"
    ],
    "rainbow": [
        "WI"
    ],
    "rainbow 4g": [
        "WI"
    ],
    "rainbow jam": [
        "WI"
    ],
    "rainbow lite 4g": [
        "WI"
    ],
    "rainbow up": [
        "WI"
    ],
    "rainbow up 4g": [
        "WI"
    ],
    "w-u300": [
        "WI"
    ],
    "ridge": [
        "WI"
    ],
    "ridge 4g": [
        "WI"
    ],
    "ridge fab 4g": [
        "WI"
    ],
    "robby": [
        "WI"
    ],
    "slide": [
        "WI"
    ],
    "stairway": [
        "WI"
    ],
    "sublim": [
        "WI"
    ],
    "sunny": [
        "WI"
    ],
    "sunny2": [
        "WI"
    ],
    "sunny2 plus": [
        "WI"
    ],
    "sunny3": [
        "WI"
    ],
    "w-k360-tv": [
        "WI"
    ],
    "sunset": [
        "WI"
    ],
    "sunset2": [
        "WI"
    ],
    "tommy": [
        "WI"
    ],
    "tommy2": [
        "WI"
    ],
    "tommy2 plus": [
        "WI"
    ],
    "w_k600": [
        "WI"
    ],
    "tommy3": [
        "WI"
    ],
    "w_c200sn": [
        "WI"
    ],
    "u feel lite": [
        "WI"
    ],
    "u feel prime": [
        "WI"
    ],
    "u pulse": [
        "WI"
    ],
    "u pulse lite": [
        "WI"
    ],
    "w_c800": [
        "WI"
    ],
    "view2 go": [
        "WI"
    ],
    "w-p311-ope": [
        "WI"
    ],
    "w-p311-eea": [
        "WI"
    ],
    "w-v800-tvm": [
        "WI"
    ],
    "w-v800-eea": [
        "WI"
    ],
    "w-v800-ope": [
        "WI"
    ],
    "w-p611-eea": [
        "WI"
    ],
    "wc300": [
        "WI"
    ],
    "w_p200": [
        "WI"
    ],
    "wax": [
        "WI"
    ],
    "wim lite": [
        "WI"
    ],
    "w-k420-eea": [
        "WI"
    ],
    "w-k510-eea": [
        "WI"
    ],
    "w-k510-tvm": [
        "WI"
    ],
    "w-k510-sun": [
        "WI"
    ],
    "w-k510-ope": [
        "WI"
    ],
    "w-v720-eea": [
        "WI"
    ],
    "w-v720-ope": [
        "WI"
    ],
    ")": [
        "WL"
    ],
    "wiam #24": [
        "WL"
    ],
    "wolder_wiam_65": [
        "WL"
    ],
    "weplus_3": [
        "WM"
    ],
    "wink_city_s": [
        "WN"
    ],
    "wink_city_se": [
        "WN"
    ],
    "wieppo s5": [
        "WP"
    ],
    "wieppo s6 lite": [
        "WP"
    ],
    "wieppo s8": [
        "WP"
    ],
    "note grace v": [
        "WS"
    ],
    "zen 4.5": [
        "WY"
    ],
    "zen 4.7": [
        "WY"
    ],
    "wexler. zen 5": [
        "WY"
    ],
    "neon_ray": [
        "X1"
    ],
    "x-bo v10": [
        "X3",
        "WCP"
    ],
    "x-bo v11": [
        "X3"
    ],
    "xbo v7": [
        "X3"
    ],
    "xbo v8": [
        "X3"
    ],
    "x-bo v8+": [
        "X3"
    ],
    "x-bo v9+": [
        "X3"
    ],
    "xgody y17": [
        "XG"
    ],
    "skr-h0": [
        "XI"
    ],
    "skr-a0": [
        "XI"
    ],
    "skw-h0": [
        "XI"
    ],
    "skw-a0": [
        "XI"
    ],
    "dlt-a0": [
        "XI"
    ],
    "dlt-h0": [
        "XI"
    ],
    "shark kle-a0": [
        "XI"
    ],
    "shark mbu-a0": [
        "XI"
    ],
    "awm-a0": [
        "XI"
    ],
    "xiaomi_2013022": [
        "XI"
    ],
    "xiaomi_2014501": [
        "XI"
    ],
    "xiaomi_m2001j2e": [
        "XI"
    ],
    "m2002j9e": [
        "XI"
    ],
    "m2007j1sc": [
        "XI"
    ],
    "mi 1s": [
        "XI"
    ],
    "mi 2": [
        "XI"
    ],
    "mi 2a": [
        "XI"
    ],
    "mi 2s": [
        "XI"
    ],
    "mi 2sc": [
        "XI"
    ],
    "mi 3": [
        "XI"
    ],
    "xiaomi_2013061": [
        "XI"
    ],
    "mi 3w": [
        "XI"
    ],
    "mi-4c": [
        "XI"
    ],
    "mi 4 lte": [
        "XI"
    ],
    "mi 5s plus": [
        "XI"
    ],
    "mi 8 lite": [
        "XI"
    ],
    "mi9 pro 5g": [
        "XI"
    ],
    "mi 9 se": [
        "XI"
    ],
    "mi 9t pro": [
        "XI"
    ],
    "mi a2 lite": [
        "XI"
    ],
    "mi cc 9 meitu edition": [
        "XI"
    ],
    "mi max 2": [
        "XI"
    ],
    "mi max 3": [
        "XI"
    ],
    "mix": [
        "XI"
    ],
    "mix 2": [
        "XI"
    ],
    "mix 2s": [
        "XI"
    ],
    "mi mix 3": [
        "XI"
    ],
    "mi play": [
        "XI"
    ],
    "mi_play": [
        "XI"
    ],
    "mi-one": [
        "XI"
    ],
    "mi-one c1": [
        "XI"
    ],
    "mi-one_plus": [
        "XI"
    ],
    "mi-one plus": [
        "XI"
    ],
    "mi-oneplus": [
        "XI"
    ],
    "pocophone f1": [
        "XI"
    ],
    "poco f1": [
        "XI"
    ],
    "pocophone_f1": [
        "XI"
    ],
    "hm 1": [
        "XI"
    ],
    "m2004j7ac": [
        "XI"
    ],
    "m2004j7bc": [
        "XI"
    ],
    "hm 1s": [
        "XI"
    ],
    "hm 1sc": [
        "XI"
    ],
    "hm 1sw": [
        "XI"
    ],
    "redmi 1s": [
        "XI"
    ],
    "wt88047": [
        "XI"
    ],
    "hm2014819": [
        "XI"
    ],
    "hm 2a": [
        "XI"
    ],
    "redmi_3": [
        "XI"
    ],
    "redmi 3s": [
        "XI"
    ],
    "redmi 4a": [
        "XI"
    ],
    "redmi 5 plus": [
        "XI"
    ],
    "redmi 5a": [
        "XI"
    ],
    "m2006c3lc": [
        "XI"
    ],
    "redmi k20 pro": [
        "XI"
    ],
    "20190416q": [
        "XL"
    ],
    "20180322d": [
        "XL"
    ],
    "la2-l": [
        "XL"
    ],
    "la2-s": [
        "XL"
    ],
    "la2-sn": [
        "XL"
    ],
    "hla note3": [
        "XL"
    ],
    "20170608s": [
        "XL"
    ],
    "mc-x7mini": [
        "XM"
    ],
    "xi-ce655": [
        "XN"
    ],
    "xi-ceu4": [
        "XN"
    ],
    "xi-ceu8": [
        "XN"
    ],
    "black-1xm": [
        "XO"
    ],
    "omega 5.0": [
        "XO"
    ],
    "omega_5.5": [
        "XO"
    ],
    "xolo one": [
        "XO"
    ],
    "q1000 opus": [
        "XO"
    ],
    "q1000s plus": [
        "XO"
    ],
    "q1010i": [
        "XO"
    ],
    "q2000": [
        "XO"
    ],
    "q600": [
        "XO"
    ],
    "q600 club": [
        "XO"
    ],
    "q700": [
        "XO"
    ],
    "xolo_q800": [
        "XO"
    ],
    "q800": [
        "XO"
    ],
    "xolo_x1000": [
        "XO"
    ],
    "era 2x": [
        "XO"
    ],
    "xshitou p7": [
        "XS"
    ],
    "x-tigi_j110": [
        "XT"
    ],
    "x-tigi_photo p11": [
        "XT"
    ],
    "x_tigi_photo p16": [
        "XT"
    ],
    "x_tigi_v19": [
        "XT"
    ],
    "x-tigi_v28 lte": [
        "XT"
    ],
    "zen_u5+": [
        "XV"
    ],
    "yu5014": [
        "Y1"
    ],
    "yu4711": [
        "Y1"
    ],
    "yu5010a": [
        "Y1"
    ],
    "yu5010": [
        "Y1"
    ],
    "ao5510": [
        "Y1"
    ],
    "yu5510a": [
        "Y1"
    ],
    "yu5510": [
        "Y1"
    ],
    "yu5050": [
        "Y1"
    ],
    "m631y": [
        "Y2"
    ],
    "m651g_my": [
        "Y2"
    ],
    "yes mpy48": [
        "Y2"
    ],
    "yes mpy54": [
        "Y2"
    ],
    "yndx-000sb": [
        "YD"
    ],
    "yndx000sb": [
        "YD"
    ],
    "andy_35e2i": [
        "YE"
    ],
    "andy 3.5ei": [
        "YE"
    ],
    "andy_35ei2": [
        "YE"
    ],
    "andy_45el": [
        "YE"
    ],
    "andy 4.7t": [
        "YE"
    ],
    "andy_4e2i": [
        "YE"
    ],
    "4e4": [
        "YE"
    ],
    "yezz-ac4ei": [
        "YE"
    ],
    "andy_4ei2": [
        "YE"
    ],
    "andy_4el2_lte": [
        "YE"
    ],
    "andy_55ei": [
        "YE"
    ],
    "andy_5ei": [
        "YE"
    ],
    "andy 5ei": [
        "YE"
    ],
    "andy_5el": [
        "YE"
    ],
    "andy 5el2 lte": [
        "YE"
    ],
    "andy_5ml_lte": [
        "YE"
    ],
    "andy_5t": [
        "YE"
    ],
    "yezz andy a3.5ep": [
        "YE"
    ],
    "yezz-a4m": [
        "YE"
    ],
    "a5ei": [
        "YE"
    ],
    "andy_c5ql": [
        "YE"
    ],
    "yd206": [
        "YO"
    ],
    "yd201": [
        "YO"
    ],
    "yota 3+": [
        "YO"
    ],
    "la2-t": [
        "YS"
    ],
    "yusun w306": [
        "YS"
    ],
    "yusun w702": [
        "YS"
    ],
    "ytone_l919_td": [
        "YT"
    ],
    "ytone l985s": [
        "YT"
    ],
    "ytone l999": [
        "YT"
    ],
    "ytone m7x": [
        "YT"
    ],
    "yxtel_h1": [
        "YX"
    ],
    "yxtel_u1": [
        "YX"
    ],
    "yxtel_u3": [
        "YX"
    ],
    "avenzo mob4 4g": [
        "ZA"
    ],
    "avenzo mob4pro 4g": [
        "ZA"
    ],
    "zeemi m1": [
        "ZE"
    ],
    "zeemi m4": [
        "ZE"
    ],
    "zeemi m5": [
        "ZE"
    ],
    "zeemi m6": [
        "ZE"
    ],
    "zeemi m7": [
        "ZE"
    ],
    "zeemi m8": [
        "ZE"
    ],
    "leopardo z5517": [
        "ZK"
    ],
    "libelula z6001": [
        "ZK"
    ],
    "oso z5007": [
        "ZK"
    ],
    "pinguino z5519": [
        "ZK"
    ],
    "zebra z5516": [
        "ZK"
    ],
    "admireglam": [
        "ZN"
    ],
    "admire sxy": [
        "ZN"
    ],
    "cinemax 2+": [
        "ZN"
    ],
    "cinemax 3": [
        "ZN"
    ],
    "cinemax_4g": [
        "ZN"
    ],
    "cinemax_click": [
        "ZN"
    ],
    "cinemax1": [
        "ZN"
    ],
    "cinemax2": [
        "ZN"
    ],
    "za409": [
        "ZO"
    ],
    "zopo zp998": [
        "ZP",
        "XI"
    ],
    "zp998": [
        "ZP"
    ],
    "zopo_c2_mod": [
        "ZP"
    ],
    "zp330": [
        "ZP"
    ],
    "zp567": [
        "ZP"
    ],
    "zp370": [
        "ZP"
    ],
    "zp586": [
        "ZP"
    ],
    "zp563": [
        "ZP"
    ],
    "zp300": [
        "ZP"
    ],
    "zp300s": [
        "ZP"
    ],
    "zp300+": [
        "ZP"
    ],
    "zp781": [
        "ZP"
    ],
    "zp1790": [
        "ZP"
    ],
    "zopo flash x3": [
        "ZP"
    ],
    "zp900": [
        "ZP"
    ],
    "zp900h": [
        "ZP"
    ],
    "zp910": [
        "ZP"
    ],
    "zp950": [
        "ZP"
    ],
    "zp950+": [
        "ZP"
    ],
    "zp950h": [
        "ZP"
    ],
    "zp500": [
        "ZP"
    ],
    "zp500+": [
        "ZP"
    ],
    "zp800h": [
        "ZP"
    ],
    "zp810": [
        "ZP"
    ],
    "zp100": [
        "ZP"
    ],
    "zp980": [
        "ZP"
    ],
    "zopo_zp980": [
        "ZP"
    ],
    "zp200": [
        "ZP"
    ],
    "zp200+": [
        "ZP"
    ],
    "zp951": [
        "ZP"
    ],
    "zp952": [
        "ZP"
    ],
    "zp955": [
        "ZP"
    ],
    "zp1000": [
        "ZP"
    ],
    "zp1000s": [
        "ZP"
    ],
    "zp320": [
        "ZP"
    ],
    "zp520": [
        "ZP"
    ],
    "zp980+": [
        "ZP"
    ],
    "zp990": [
        "ZP"
    ],
    "zp999": [
        "ZP"
    ],
    "q3623": [
        "ZQ"
    ],
    "q2626": [
        "ZQ"
    ],
    "q2624": [
        "ZQ"
    ],
    "q638": [
        "ZQ"
    ],
    "q.boss p99": [
        "ZQ"
    ],
    "j77": [
        "ZQ"
    ],
    "q.dee r09": [
        "ZQ"
    ],
    "q.good m9": [
        "ZQ"
    ],
    "q.hi": [
        "ZQ"
    ],
    "q.hi s1": [
        "ZQ"
    ],
    "q.hot": [
        "ZQ"
    ],
    "q.hot p7 3g": [
        "ZQ"
    ],
    "q.mate r99": [
        "ZQ"
    ],
    "q.me": [
        "ZQ"
    ],
    "q.me phone7 3g": [
        "ZQ"
    ],
    "q.next b7": [
        "ZQ"
    ],
    "q.next j2": [
        "ZQ"
    ],
    "q.top-x8": [
        "ZQ"
    ],
    "q.up": [
        "ZQ"
    ],
    "q.up c5": [
        "ZQ"
    ],
    "q.you": [
        "ZQ"
    ],
    "q2688": [
        "ZQ"
    ],
    "q2729": [
        "ZQ"
    ],
    "q3022": [
        "ZQ"
    ],
    "q328 m9": [
        "ZQ"
    ],
    "q328": [
        "ZQ"
    ],
    "q668": [
        "ZQ"
    ],
    "q2602": [
        "ZQ"
    ],
    "q2623": [
        "ZQ"
    ],
    "q2728": [
        "ZQ"
    ],
    "z818l": [
        "ZT"
    ],
    "zte n9120": [
        "ZT"
    ],
    "z855": [
        "ZT"
    ],
    "z828": [
        "ZT"
    ],
    "z833": [
        "ZT"
    ],
    "zte a2020g pro": [
        "ZT"
    ],
    "zte a2020 pro": [
        "ZT"
    ],
    "902zt": [
        "ZT"
    ],
    "zte a2017u": [
        "ZT"
    ],
    "zte a2017g": [
        "ZT"
    ],
    "zte a2017": [
        "ZT"
    ],
    "gt-b7510": [
        "SA"
    ],
    "zte kis 3": [
        "ZT"
    ],
    "pct-l29": [
        "HU"
    ],
    "z798bl": [
        "ZT"
    ],
    "z799vl": [
        "ZT"
    ],
    "z899vl": [
        "ZT"
    ],
    "z828tl": [
        "ZT"
    ],
    "zte-z792": [
        "ZT"
    ],
    "z792": [
        "ZT"
    ],
    "z812": [
        "ZT"
    ],
    "zte-z812": [
        "ZT"
    ],
    "z815": [
        "ZT"
    ],
    "z831": [
        "ZT"
    ],
    "zuum_e60": [
        "ZU"
    ],
    "zuum_e40": [
        "ZU"
    ],
    "zuum m50": [
        "ZU"
    ],
    "stellar z": [
        "ZU"
    ],
    "stedi": [
        "ZU"
    ],
    "magno": [
        "ZU"
    ],
    "magno plus": [
        "ZU"
    ],
    "magno c": [
        "ZU"
    ],
    "covet": [
        "ZU"
    ],
    "covet z": [
        "ZU"
    ],
    "covet_pro_lite": [
        "ZU"
    ],
    "covet pro": [
        "ZU"
    ],
    "z986dl": [
        "ZT"
    ],
    "goophone s4 mega": [
        "G0"
    ],
    "goophone i9": [
        "G0"
    ],
    "gresso regal": [
        "82"
    ],
    "urbano progresso": [
        "KY"
    ],
    "goophone i6": [
        "G0"
    ],
    "primo gm3": [
        "WA"
    ],
    "primo gh7i": [
        "WA"
    ],
    "primo gf7": [
        "WA"
    ],
    "nokia g11": [
        "NK"
    ],
    "panasonic p50": [
        "PA"
    ],
    "panasonic p75": [
        "PA"
    ],
    "panasonic p77": [
        "PA"
    ],
    "passion p11": [
        "QY"
    ],
    "passion p7": [
        "QY"
    ],
    "passion p8": [
        "QY"
    ],
    "passion p9": [
        "QY"
    ],
    "zte b2017g": [
        "ZT"
    ],
    "zte a2018": [
        "ZT"
    ],
    "z999": [
        "ZT"
    ],
    "zte b2016": [
        "ZT"
    ],
    "zte a2019g pro": [
        "ZT"
    ],
    "zte a2015": [
        "ZT"
    ],
    "axonphone a1": [
        "ZT"
    ],
    "zte-blade": [
        "ZT"
    ],
    "zte 2050": [
        "ZT"
    ],
    "zte blade a0620": [
        "ZT"
    ],
    "blade a3 2019-t": [
        "ZT"
    ],
    "blade a310": [
        "ZT"
    ],
    "zte blade a452": [
        "ZT"
    ],
    "blade a460": [
        "ZT"
    ],
    "zte blade a462": [
        "ZT"
    ],
    "blade a465": [
        "ZT"
    ],
    "blade a5 2019-t": [
        "ZT"
    ],
    "zte blade a510": [
        "ZT"
    ],
    "blade_a510": [
        "ZT"
    ],
    "zte blade a512": [
        "ZT"
    ],
    "blade a0622": [
        "ZT"
    ],
    "blade a6 max": [
        "ZT"
    ],
    "zte blade a612": [
        "ZT"
    ],
    "zte blade a910": [
        "ZT"
    ],
    "zte v807": [
        "ZT"
    ],
    "zte v809": [
        "ZT"
    ],
    "zte n799d": [
        "ZT"
    ],
    "zte v829": [
        "ZT"
    ],
    "zte_v829": [
        "ZT"
    ],
    "zte blade l3 apex": [
        "ZT"
    ],
    "zte blade l5 plus": [
        "ZT"
    ],
    "zte blade l6": [
        "ZT"
    ],
    "zte blade l7": [
        "ZT"
    ],
    "zte blade l7a": [
        "ZT"
    ],
    "zte blade l8ru": [
        "ZT"
    ],
    "zte blade l8": [
        "ZT"
    ],
    "blade q lux": [
        "ZT"
    ],
    "402zt": [
        "ZT"
    ],
    "zte blade s6 plus": [
        "ZT"
    ],
    "zte t920": [
        "ZT"
    ],
    "z559dl": [
        "ZT"
    ],
    "blade v ultra": [
        "ZT"
    ],
    "zte blade v0730": [
        "ZT"
    ],
    "zte blade v0800": [
        "ZT"
    ],
    "zte blade v10 vita": [
        "ZT",
        "WCP"
    ],
    "zte blade v1000": [
        "ZT"
    ],
    "zte blade v0720": [
        "ZT"
    ],
    "zte blade v7 lite": [
        "ZT"
    ],
    "zte blade v0820": [
        "ZT"
    ],
    "zte blade v0850": [
        "ZT"
    ],
    "blade x9": [
        "ZT"
    ],
    "z716bl": [
        "ZT"
    ],
    "ctyon-a9": [
        "ZT"
    ],
    "z233vl": [
        "ZT"
    ],
    "zte v975": [
        "ZT"
    ],
    "zte grand era": [
        "ZT"
    ],
    "zte v9815": [
        "ZT"
    ],
    "zte u9815": [
        "ZT"
    ],
    "zte v970m": [
        "ZT"
    ],
    "zte v970": [
        "ZT"
    ],
    "zte v987": [
        "ZT"
    ],
    "zte v967s": [
        "ZT"
    ],
    "z959": [
        "ZT"
    ],
    "z956": [
        "ZT"
    ],
    "x501_usa_cricket": [
        "ZT"
    ],
    "z963u": [
        "ZT"
    ],
    "zte v779m": [
        "ZT"
    ],
    "zte v788d b17": [
        "ZT"
    ],
    "z936l": [
        "ZT"
    ],
    "602zt": [
        "ZT"
    ],
    "zte v882": [
        "ZT"
    ],
    "mo-01j": [
        "ZT"
    ],
    "n818s": [
        "ZT"
    ],
    "v8000_usa_cricket": [
        "ZT"
    ],
    "nx608j": [
        "57"
    ],
    "nx617j": [
        "57"
    ],
    "nx651j": [
        "57"
    ],
    "nx609j": [
        "57"
    ],
    "nx629j": [
        "57"
    ],
    "nx659j": [
        "57"
    ],
    "nx619j": [
        "57"
    ],
    "nx612j": [
        "57"
    ],
    "nubia z11 mini s": [
        "57"
    ],
    "nx569h": [
        "57"
    ],
    "nx569j": [
        "57"
    ],
    "nx589j": [
        "57"
    ],
    "nx606j": [
        "57"
    ],
    "nx611j": [
        "57"
    ],
    "nx616j": [
        "57"
    ],
    "nx627j": [
        "57"
    ],
    "nx406e": [
        "57"
    ],
    "nx404h": [
        "57"
    ],
    "nubia z9 max": [
        "57"
    ],
    "nx512j": [
        "57"
    ],
    "nubia z9 mini": [
        "57"
    ],
    "p545": [
        "ZT"
    ],
    "z5031o": [
        "ZT"
    ],
    "optus x start": [
        "ZT",
        "JG"
    ],
    "z6621o": [
        "ZT"
    ],
    "p609": [
        "ZT"
    ],
    "n9132": [
        "ZT"
    ],
    "z3001s": [
        "ZT"
    ],
    "n9130": [
        "ZT"
    ],
    "z930l": [
        "ZT"
    ],
    "k3dx-v5g": [
        "ZT"
    ],
    "v865m": [
        "ZT"
    ],
    "n9510": [
        "ZT"
    ],
    "n9515": [
        "ZT"
    ],
    "zte-x500": [
        "ZT"
    ],
    "dandelion": [
        "ZT"
    ],
    "astra nxt pro": [
        "ZX"
    ],
    "astra viva 4g": [
        "ZX"
    ],
    "ziox_f9_pro": [
        "ZX"
    ],
    "smart 4g gen c 4.0": [
        "11"
    ],
    "smart 4g gen c 5.0": [
        "11"
    ],
    "smart 4g gen c 5.5": [
        "11"
    ],
    "smart_4g_speedy_5inch": [
        "11"
    ],
    "smart 4g speedy 5.0 plus": [
        "11"
    ],
    "smart max 4.0 plus": [
        "11"
    ],
    "jumbo x1": [
        "30"
    ],
    "1503-a01": [
        "36"
    ],
    "1603-a03": [
        "36"
    ],
    "1607-a01": [
        "36"
    ],
    "1707-a01": [
        "36"
    ],
    "1713-a01": [
        "36"
    ],
    "1801-a01": [
        "36"
    ],
    "1807-a01": [
        "36"
    ],
    "1809-a01": [
        "36"
    ],
    "1509-a00": [
        "36"
    ],
    "8848 m3": [
        "88"
    ],
    "8848 m4": [
        "88"
    ],
    "8848 m5": [
        "88"
    ],
    "8848 m6": [
        "88"
    ],
    "nura 2": [
        "OR"
    ],
    "point_x2": [
        "V5"
    ],
    "polar3": [
        "L6"
    ],
    "704sh": [
        "SH"
    ],
    "l-01j": [
        "LG"
    ],
    "m2007j20cg": [
        "0P"
    ],
    "mo-01k": [
        "ZT"
    ],
    "sh-m07": [
        "SH"
    ],
    "n-06c": [
        "NE"
    ],
    "sh-m04": [
        "SH"
    ],
    "sh-m12": [
        "SH"
    ],
    "l-41a": [
        "LG"
    ],
    "sh-m11": [
        "SH"
    ],
    "sh-m13": [
        "SH"
    ],
    "shv48": [
        "SH"
    ],
    "x2-ht": [
        "HT"
    ],
    "901zt": [
        "ZT"
    ],
    "shv31": [
        "SH"
    ],
    "704kc": [
        "KY"
    ],
    "802lg": [
        "LG"
    ],
    "z-01k": [
        "ZT"
    ],
    "908sh": [
        "SH"
    ],
    "s7-sh": [
        "SH"
    ],
    "907sh": [
        "SH"
    ],
    "a001zt": [
        "ZT"
    ],
    "sw001sh": [
        "SH"
    ],
    "j9260": [
        "SO"
    ],
    "shg01": [
        "SH"
    ],
    "shv45-u": [
        "SH"
    ],
    "armor_6e": [
        "UL"
    ],
    "906sh": [
        "SH"
    ],
    "shv34": [
        "SH"
    ],
    "shv37_u": [
        "SH"
    ],
    "p-01j": [
        "PA"
    ],
    "kyf32": [
        "KY"
    ],
    "kyf35": [
        "KY"
    ],
    "sm-m317f": [
        "SA"
    ],
    "rmx1973": [
        "RE"
    ],
    "rmx2076": [
        "RE"
    ],
    "ana-nx9": [
        "HU"
    ],
    "xenium s566": [
        "PH"
    ],
    "xenium s266": [
        "PH"
    ],
    "art-l29": [
        "HU"
    ],
    "m2002j9g": [
        "XI"
    ],
    "s5 silk": [
        "HA"
    ],
    "bv6300pro": [
        "B2"
    ],
    "lra-lx1": [
        "HU"
    ],
    "wp5 pro": [
        "OE"
    ],
    "artel quadro pro": [
        "40"
    ],
    "artel tesla": [
        "40",
        "C7"
    ],
    "artel quadro": [
        "40"
    ],
    "artel air": [
        "40"
    ],
    "artel komi3": [
        "40"
    ],
    "artel tomchi": [
        "40"
    ],
    "artel premium": [
        "40"
    ],
    "artel u3_4g": [
        "40"
    ],
    "artel z5": [
        "40"
    ],
    "artel sentinel x": [
        "40"
    ],
    "artel sentinel x d5": [
        "40"
    ],
    "artel sentinel x 8g": [
        "40"
    ],
    "5002f_ru": [
        "AL"
    ],
    "5002d_ru": [
        "AL"
    ],
    "aligator s6500": [
        "4A"
    ],
    "5002d_eea": [
        "AL"
    ],
    "5002d": [
        "AL"
    ],
    "5002a": [
        "AL"
    ],
    "a1 alpha 20+": [
        "41"
    ],
    "a001op": [
        "OP"
    ],
    "a1 alpha": [
        "41"
    ],
    "quest": [
        "OQ",
        "CB"
    ],
    "elegance 6": [
        "K1"
    ],
    "5007u": [
        "AL"
    ],
    "w-v830-eea": [
        "WI"
    ],
    "w-v730-eea": [
        "WI"
    ],
    "v2027": [
        "VV"
    ],
    "v2023": [
        "VV"
    ],
    "5029y_ru": [
        "AL"
    ],
    "poco x3 nfc": [
        "0P"
    ],
    "tone e20": [
        "0T"
    ],
    "l-egantone-r": [
        "LM"
    ],
    "swisstone sd 530": [
        "1W"
    ],
    "swisstone sd 510": [
        "1W"
    ],
    "b110dl": [
        "BU"
    ],
    "z3153v": [
        "ZT"
    ],
    "jkm-al00a": [
        "HU"
    ],
    "redmi k30 5g": [
        "XI"
    ],
    "intense power": [
        "F3"
    ],
    "intense_metal_2": [
        "F3"
    ],
    "intense_xt": [
        "F3"
    ],
    "mi 9 lite": [
        "XI"
    ],
    "pot-lx1t": [
        "HU"
    ],
    "shark kle-h0": [
        "XI"
    ],
    "shark mbu-h0": [
        "XI"
    ],
    "rmx2170": [
        "RE"
    ],
    "rmx2085": [
        "RE"
    ],
    "rmx2075": [
        "RE"
    ],
    "sh-rm02": [
        "SH"
    ],
    "cdy-nx9a": [
        "HU"
    ],
    "advance l5": [
        "BU"
    ],
    "xq-at42": [
        "SO"
    ],
    "asus_i002d": [
        "AU"
    ],
    "f-03k": [
        "FU"
    ],
    "x4-sh": [
        "SH"
    ],
    "sol25": [
        "SO"
    ],
    "sog02": [
        "SO"
    ],
    "shg02": [
        "SH"
    ],
    "a002sh": [
        "SH"
    ],
    "a002so": [
        "SO"
    ],
    "a002op": [
        "OP"
    ],
    "402lg": [
        "LG"
    ],
    "sh-m10": [
        "SH"
    ],
    "dm-01j": [
        "SH"
    ],
    "l-02k": [
        "LG"
    ],
    "kyf33": [
        "KY"
    ],
    "304sh": [
        "SH"
    ],
    "atom_l": [
        "UZ"
    ],
    "f1-tt": [
        "RU"
    ],
    "fero a4001": [
        "F7"
    ],
    "fero a4502": [
        "F7"
    ],
    "fero l100": [
        "F7"
    ],
    "flare s5 plus": [
        "CH"
    ],
    "flares5litedtv": [
        "CH"
    ],
    "flare s5": [
        "CH"
    ],
    "scl23": [
        "SA"
    ],
    "shv32": [
        "SH"
    ],
    "huawei p7-l10": [
        "HU"
    ],
    "philips_xenium_v787": [
        "PH"
    ],
    "moto g(7)": [
        "MR"
    ],
    "zte a7020": [
        "ZT"
    ],
    "a001kc": [
        "KY"
    ],
    "j3173": [
        "SO"
    ],
    "arrowsrx": [
        "FU"
    ],
    "arrowsm04": [
        "FU"
    ],
    "arrowsm05": [
        "FU"
    ],
    "foxtrot2": [
        "TL"
    ],
    "innelo_1": [
        "0J"
    ],
    "in2011": [
        "ON"
    ],
    "zenfone max pro m1": [
        "AU"
    ],
    "tah-n29m": [
        "HU"
    ],
    "in2015": [
        "ON"
    ],
    "in2021": [
        "ON"
    ],
    "in2025": [
        "ON"
    ],
    "jef-an20": [
        "HU"
    ],
    "king kong cs": [
        "CB"
    ],
    "m2006c3li": [
        "XI"
    ],
    "m2006c3lvg": [
        "XI"
    ],
    "m2007j3sc": [
        "XI"
    ],
    "oneplus 5t": [
        "ON"
    ],
    "oneplus 7 pro": [
        "ON"
    ],
    "oneplus 7t pro": [
        "ON"
    ],
    "realme 3 pro": [
        "RE"
    ],
    "realme 5 pro": [
        "RE"
    ],
    "realme x": [
        "RE"
    ],
    "realme xt": [
        "RE"
    ],
    "realme x2 pro": [
        "RE"
    ],
    "xq-at52": [
        "SO"
    ],
    "xq-at51": [
        "SO"
    ],
    "xq-as52": [
        "SO"
    ],
    "xperia z3": [
        "SO"
    ],
    "xperia z3 compact": [
        "SO"
    ],
    "xperia z2": [
        "SO"
    ],
    "advance 5.2": [
        "BU"
    ],
    "pixelphone s1": [
        "8P"
    ],
    "u705t": [
        "OP"
    ],
    "vs820": [
        "LG"
    ],
    "vs870 4g": [
        "LG"
    ],
    "5042t": [
        "AL"
    ],
    "fire2 plus lte": [
        "I5"
    ],
    "le must 2": [
        "LM"
    ],
    "le2_x527": [
        "L1"
    ],
    "leeco le 2": [
        "L1"
    ],
    "le_spark": [
        "LM"
    ],
    "le_prime": [
        "LM"
    ],
    "moto g(6) play": [
        "MR"
    ],
    "moto g(7) supra": [
        "MR",
        "S5"
    ],
    "p6000 5.0 01": [
        "EL"
    ],
    "ine-lx2r": [
        "HU"
    ],
    "jkm-al00b": [
        "HU"
    ],
    "kingcomm c500": [
        "0A"
    ],
    "texet tm-5081": [
        "TZ"
    ],
    "picassonote": [
        "JG"
    ],
    "a140": [
        "DX"
    ],
    "a150": [
        "DX"
    ],
    "bq-5000g": [
        "BX"
    ],
    "bq-5521l": [
        "BX"
    ],
    "expanse": [
        "H2"
    ],
    "l-ement551": [
        "LM"
    ],
    "s4004m": [
        "DN"
    ],
    "hp554o": [
        "HN"
    ],
    "aq5001": [
        "MI"
    ],
    "advan s4+": [
        "A9"
    ],
    "l-01f": [
        "LG"
    ],
    "bq-5016g": [
        "BX"
    ],
    "bq-5540l": [
        "BX"
    ],
    "bq-6022g": [
        "BX"
    ],
    "amn-lx3": [
        "HU"
    ],
    "aligator rx710": [
        "4A"
    ],
    "aligator rx800": [
        "4A"
    ],
    "allure x": [
        "C5"
    ],
    "bush spira d5 dual camera": [
        "B1"
    ],
    "dra-lx9": [
        "HU"
    ],
    "zs661ks": [
        "AU"
    ],
    "rmx2155": [
        "RE"
    ],
    "5028d_eea": [
        "AL"
    ],
    "5029d": [
        "AL"
    ],
    "5030d_ru": [
        "AL"
    ],
    "5061k_eea": [
        "AL"
    ],
    "5061u_eea": [
        "AL"
    ],
    "atom_xl": [
        "UZ"
    ],
    "dnn-lx9": [
        "HU"
    ],
    "aligator_s5520": [
        "4A"
    ],
    "fonos-o1": [
        "F0"
    ],
    "hummer_2019_r": [
        "N5"
    ],
    "maxtron s9": [
        "6X"
    ],
    "wp5": [
        "OE"
    ],
    "wp7": [
        "OE"
    ],
    "wp6": [
        "OE"
    ],
    "wp8 pro": [
        "OE"
    ],
    "vibe p1": [
        "LE"
    ],
    "pot-lx1a": [
        "HU"
    ],
    "bq-6424l": [
        "BX"
    ],
    "bq-5732l": [
        "BX"
    ],
    "bq-5519g": [
        "BX"
    ],
    "bmm442s": [
        "BF"
    ],
    "armor_3w": [
        "UL"
    ],
    "armor_3wt": [
        "UL"
    ],
    "al350": [
        "DX"
    ],
    "al250": [
        "DX"
    ],
    "5006d": [
        "AL"
    ],
    "5024f_eea": [
        "AL"
    ],
    "5048i": [
        "AL"
    ],
    "wizard_2": [
        "A6"
    ],
    "w_p130": [
        "WI"
    ],
    "venus e4": [
        "VT"
    ],
    "conquest-s8": [
        "4C"
    ],
    "conquest-s6": [
        "4C"
    ],
    "conquest-s11": [
        "4C"
    ],
    "conquest-f2": [
        "4C"
    ],
    "conquest-s12": [
        "4C"
    ],
    "conquest-s16": [
        "4C"
    ],
    "conquest-s10": [
        "4C"
    ],
    "wp5000": [
        "OE"
    ],
    "c106-9": [
        "CO"
    ],
    "c105-e0": [
        "CO"
    ],
    "xtouch x10": [
        "4X"
    ],
    "pro_p300_4g": [
        "VX"
    ],
    "pro_p310_4g": [
        "VX"
    ],
    "multilaser_f_pro": [
        "1R"
    ],
    "bq-6030g": [
        "BX"
    ],
    "bv4900": [
        "B2"
    ],
    "titan_t5": [
        "HA"
    ],
    "v1600s": [
        "2N"
    ],
    "asus_ze551ml": [
        "AU"
    ],
    "i5070": [
        "NM"
    ],
    "vestel_5000": [
        "VT"
    ],
    "vestel_5000_dual": [
        "VT"
    ],
    "vestel_5000_2gb": [
        "VT"
    ],
    "prestigio 5500 duo": [
        "PR"
    ],
    "qumo quest 510": [
        "QO"
    ],
    "qumo quest474": [
        "QO"
    ],
    "quest456": [
        "QO"
    ],
    "quest455": [
        "QO"
    ],
    "quest 507": [
        "QO"
    ],
    "quest 506": [
        "QO"
    ],
    "simba sx1": [
        "GG"
    ],
    "ney-nx9": [
        "HU"
    ],
    "highway pure": [
        "WI"
    ],
    "mos1": [
        "RA"
    ],
    "blu_studio_xl": [
        "BU"
    ],
    "highway star": [
        "WI"
    ],
    "w-k130-tmv": [
        "WI"
    ],
    "w-k130-ope": [
        "WI"
    ],
    "w-k200": [
        "WI"
    ],
    "w-k130-eea": [
        "WI"
    ],
    "w-v600": [
        "WI"
    ],
    "wieppo e1": [
        "WP"
    ],
    "winpro": [
        "JG"
    ],
    "wind": [
        "0Z"
    ],
    "zatec_gravity": [
        "0Z"
    ],
    "rome_x": [
        "UM"
    ],
    "x527": [
        "L1"
    ],
    "x526": [
        "L1"
    ],
    "z10-e": [
        "L5"
    ],
    "bv6900": [
        "B2"
    ],
    "s397": [
        "PH"
    ],
    "s68pro": [
        "DO"
    ],
    "s90pro": [
        "DO"
    ],
    "s95pro": [
        "DO"
    ],
    "s40lite": [
        "DO"
    ],
    "lenovos90c": [
        "LE"
    ],
    "s90c": [
        "DO"
    ],
    "as155": [
        "DX"
    ],
    "k4000pro": [
        "OE"
    ],
    "evolveo strongphone q6 lte": [
        "EO"
    ],
    "bravis_spark": [
        "BV"
    ],
    "classic joy": [
        "GG"
    ],
    "classic_pro": [
        "GG"
    ],
    "smart_line": [
        "M9"
    ],
    "citi 609 4g cs6063ml": [
        "D2"
    ],
    "citi 653 4g cs6062ml": [
        "D2"
    ],
    "conquest_s16": [
        "4C"
    ],
    "drive_6s": [
        "KE"
    ],
    "drive_6": [
        "KE"
    ],
    "flow7": [
        "KE"
    ],
    "hammer_explorer": [
        "HAM"
    ],
    "hammer_iron_3_lte": [
        "HAM"
    ],
    "lm-v40": [
        "LG"
    ],
    "mar-lx3am": [
        "HU"
    ],
    "bq-5045l": [
        "BX"
    ],
    "bq-4030g": [
        "BX"
    ],
    "citi z400 3g ct4024pg": [
        "D2"
    ],
    "smart_light": [
        "M9"
    ],
    "a2_lite_nfc": [
        "HA"
    ],
    "ms502_orion": [
        "0D"
    ],
    "ms531": [
        "0D"
    ],
    "tm-5083": [
        "TZ"
    ],
    "tm-5084": [
        "TZ"
    ],
    "tm-5583": [
        "TZ"
    ],
    "tm-5584": [
        "TZ"
    ],
    "tm-5702": [
        "TZ"
    ],
    "tm-5703": [
        "TZ"
    ],
    "my_star_x": [
        "OL"
    ],
    "rio star": [
        "OL"
    ],
    "c_note_pro": [
        "OL"
    ],
    "dls-e0": [
        "CO"
    ],
    "xq-as72": [
        "SO"
    ],
    "v2022": [
        "VV"
    ],
    "m2006c3mii": [
        "XI"
    ],
    "msp95012": [
        "MA"
    ],
    "rg730": [
        "RG"
    ],
    "flow6s": [
        "KE"
    ],
    "x2_euro": [
        "VR"
    ],
    "n-02e": [
        "NE"
    ],
    "k-lite f3": [
        "KA"
    ],
    "primo s6 dual": [
        "WA"
    ],
    "primo rx6": [
        "WA"
    ],
    "primo nh4": [
        "WA"
    ],
    "primo nf4": [
        "WA"
    ],
    "cph1925": [
        "OP"
    ],
    "so-41a": [
        "SO"
    ],
    "xig01": [
        "XI"
    ],
    "asus_i003d": [
        "AU"
    ],
    "sog01": [
        "SO"
    ],
    "801fj": [
        "FU"
    ],
    "sh-rm12": [
        "SH"
    ],
    "404sh": [
        "SH"
    ],
    "scv47": [
        "SA"
    ],
    "scv48": [
        "SA"
    ],
    "so-51a": [
        "SO"
    ],
    "kyv48": [
        "KY"
    ],
    "shv43-u": [
        "SH"
    ],
    "arrowsm04-premium": [
        "FU"
    ],
    "f-51a": [
        "FU"
    ],
    "704hw": [
        "HU"
    ],
    "608hw": [
        "HU"
    ],
    "lio-n29": [
        "HU"
    ],
    "a001lg": [
        "LG"
    ],
    "sov43": [
        "SO"
    ],
    "kyv47": [
        "KY"
    ],
    "kyv44_u": [
        "KY"
    ],
    "kyv40": [
        "KY"
    ],
    "sh-rm11": [
        "SH"
    ],
    "m2006c3mg": [
        "XI"
    ],
    "m2006c3mng": [
        "XI"
    ],
    "med-lx9": [
        "HU"
    ],
    "els-n39": [
        "HU"
    ],
    "els-n04": [
        "HU"
    ],
    "els-an10": [
        "HU"
    ],
    "asus_x00ps": [
        "AU"
    ],
    "asus_z01gs": [
        "AU"
    ],
    "oukitel wp2": [
        "OE",
        "OK"
    ],
    "asus_x00t": [
        "AU"
    ],
    "par-lx1m": [
        "HU"
    ],
    "vox_5s": [
        "5I"
    ],
    "vox alpha plus": [
        "5I"
    ],
    "vox alpha": [
        "5I"
    ],
    "vox pop plus": [
        "5I"
    ],
    "vox pop pro": [
        "5I"
    ],
    "vivax_pro3": [
        "V5"
    ],
    "oukitel k7": [
        "OE",
        "OK"
    ],
    "neffos a5": [
        "NF"
    ],
    "andy 3.5eh": [
        "YE"
    ],
    "andy_a3.5ep": [
        "YE"
    ],
    "andy c3.5ei": [
        "YE"
    ],
    "andy 4ei": [
        "YE"
    ],
    "yezz andy ac4e": [
        "YE"
    ],
    "andy_3.5e2i": [
        "YE"
    ],
    "v2025": [
        "VV"
    ],
    "titanium s360": [
        "KA"
    ],
    "8676-m01": [
        "CO"
    ],
    "titanium s19": [
        "KA"
    ],
    "titanium s10": [
        "KA"
    ],
    "titanium s35": [
        "KA"
    ],
    "titanium s201": [
        "KA"
    ],
    "titanium s22": [
        "KA"
    ],
    "titanium s109": [
        "KA"
    ],
    "titanium s203": [
        "KA"
    ],
    "titanium s15": [
        "KA"
    ],
    "titanium s1": [
        "KA"
    ],
    "titanium s200 hd": [
        "KA"
    ],
    "titanium octane plus": [
        "KA"
    ],
    "titanium_3d-plex": [
        "KA"
    ],
    "yu5011": [
        "Y1"
    ],
    "r8001": [
        "OP"
    ],
    "w5510": [
        "PH"
    ],
    "z00sd": [
        "AU"
    ],
    "tf-sp4002": [
        "TL"
    ],
    "tf-sp5002": [
        "TL"
    ],
    "texet_x-medium_plus": [
        "TZ"
    ],
    "texet_ix-mini": [
        "TZ"
    ],
    "vibe c": [
        "LE"
    ],
    "x5_doogee": [
        "DO"
    ],
    "tinmo-a11": [
        "TF"
    ],
    "tinmo k3": [
        "TF"
    ],
    "tsd quadra a0505p": [
        "5A",
        "PG"
    ],
    "8298-m02": [
        "CO"
    ],
    "trooper 4.0": [
        "KZ"
    ],
    "uzte v808": [
        "ZT"
    ],
    "ginzzu st6010": [
        "GZ"
    ],
    "igo l1": [
        "JG"
    ],
    "igo_l4": [
        "JG"
    ],
    "ixionml4.7": [
        "DX"
    ],
    "touch4g": [
        "JG"
    ],
    "trendy plus": [
        "4M"
    ],
    "s5002": [
        "GZ"
    ],
    "s5021": [
        "GZ"
    ],
    "s5230": [
        "GZ"
    ],
    "sh-a01": [
        "SH"
    ],
    "shoot_1": [
        "DO"
    ],
    "shoot_2": [
        "DO"
    ],
    "flow5plus": [
        "KE"
    ],
    "w_c860": [
        "WI"
    ],
    "evolveo_strongphone_q7_lte": [
        "EO"
    ],
    "f52_09": [
        "BQ"
    ],
    "ex29i": [
        "XE"
    ],
    "ex45i": [
        "XE"
    ],
    "jy_g4c": [
        "JI"
    ],
    "m150storm": [
        "DX"
    ],
    "6042d": [
        "AL"
    ],
    "5560s": [
        "CO"
    ],
    "401sh": [
        "SH"
    ],
    "306sh": [
        "SH"
    ],
    "302kc": [
        "KY"
    ],
    "live_6plus": [
        "KE"
    ],
    "lavaa1": [
        "LV"
    ],
    "klipad_v355b": [
        "0K"
    ],
    "klipad_v355": [
        "0K"
    ],
    "klipad_kl600": [
        "0K"
    ],
    "lephonep1": [
        "L7"
    ],
    "slade_x55": [
        "O1"
    ],
    "live 5 plus": [
        "KE"
    ],
    "m-ppxg7": [
        "MC"
    ],
    "m-ppxs5": [
        "MC"
    ],
    "m-ppxs5p": [
        "MC"
    ],
    "m-ppxg5": [
        "MC"
    ],
    "m-ppxg4p": [
        "MC"
    ],
    "m-ppxg5m": [
        "MC"
    ],
    "start3g": [
        "JG"
    ],
    "pocket_2": [
        "MY1"
    ],
    "mars touch": [
        "V9"
    ],
    "zviii": [
        "SM"
    ],
    "bq-6045l": [
        "BX"
    ],
    "m2007j3sy": [
        "XI"
    ],
    "boost 3 se": [
        "H2"
    ],
    "uniwa x5": [
        "U2"
    ],
    "t770h": [
        "TC"
    ],
    "bravis neo": [
        "BV"
    ],
    "lion_dc": [
        "VX"
    ],
    "zopo 9xxquad": [
        "ZP"
    ],
    "millennia hero": [
        "CE"
    ],
    "bl350": [
        "DX"
    ],
    "fest-pro": [
        "H2"
    ],
    "myx12": [
        "MY"
    ],
    "myxi1 plus": [
        "MY"
    ],
    "myxi1 pro": [
        "MY"
    ],
    "myxi3": [
        "MY"
    ],
    "nomu s10": [
        "2N"
    ],
    "oukitel u15pro": [
        "OE",
        "OK"
    ],
    "oukitel u20plus": [
        "OE",
        "OK"
    ],
    "w-v800-tim": [
        "WI"
    ],
    "w-v800-du": [
        "WI"
    ],
    "w-v720-sun": [
        "WI"
    ],
    "w-p611-ope": [
        "WI"
    ],
    "w-p311-tvm": [
        "WI"
    ],
    "w-k420-tvm": [
        "WI"
    ],
    "w-k510-byt": [
        "WI"
    ],
    "w-k510-th": [
        "WI"
    ],
    "w-k510s-swi": [
        "WI"
    ],
    "gm 6 d": [
        "GN"
    ],
    "general mobile 4g dual": [
        "GN"
    ],
    "venus e3": [
        "VT"
    ],
    "vestel_5530": [
        "VT"
    ],
    "forme r7": [
        "F2"
    ],
    "general mobile 4g": [
        "GN"
    ],
    "apollo_lite": [
        "VR"
    ],
    "apollo_x": [
        "VR"
    ],
    "blackview a7": [
        "B2"
    ],
    "boost 3 pro se": [
        "H2"
    ],
    "scl-u31": [
        "HU"
    ],
    "seoul s8": [
        "HN"
    ],
    "sugar c11s": [
        "9S"
    ],
    "sugar s11": [
        "9S"
    ],
    "lon-al00-pd": [
        "HU"
    ],
    "plume l2": [
        "C5"
    ],
    "sh-d01": [
        "SH"
    ],
    "sh-m06": [
        "SH"
    ],
    "sh-m14": [
        "SH"
    ],
    "m2006j10c": [
        "XI"
    ],
    "moa-al20": [
        "HU"
    ],
    "f-42a": [
        "FU"
    ],
    "a001sh": [
        "SH"
    ],
    "p-02d": [
        "PA"
    ],
    "901kc": [
        "KY"
    ],
    "so-52a": [
        "SO"
    ],
    "scg07": [
        "SA"
    ],
    "sugar c12": [
        "9S"
    ],
    "801lg": [
        "LG"
    ],
    "dvc-tn20": [
        "HU"
    ],
    "shf34": [
        "SH"
    ],
    "kwsa80k": [
        "KNW"
    ],
    "gne-n001s": [
        "GPL"
    ],
    "earn2 cl": [
        "34"
    ],
    "liv 3s lte": [
        "YE"
    ],
    "liv 3 lte": [
        "YE"
    ],
    "ls5018fp": [
        "EW"
    ],
    "milan_pro": [
        "OL"
    ],
    "mobilemapper60": [
        "TRB"
    ],
    "ec55": [
        "PZ"
    ],
    "ea602": [
        "UNT"
    ],
    "elite l55": [
        "SW"
    ],
    "elite c63": [
        "SW"
    ],
    "elite a6": [
        "SW"
    ],
    "elite max": [
        "SW"
    ],
    "mp5184g": [
        "YM"
    ],
    "lex l11a": [
        "MTS"
    ],
    "lex l11e": [
        "MTS"
    ],
    "s20iq19": [
        "GME"
    ],
    "ikall": [
        "IKL"
    ],
    "ss5314g": [
        "68"
    ],
    "ss5424g": [
        "68"
    ],
    "ms571": [
        "7M"
    ],
    "ms572": [
        "7M"
    ],
    "shf33": [
        "SH"
    ],
    "shl25": [
        "SH"
    ],
    "kyx31": [
        "KY"
    ],
    "xq-au42": [
        "SO"
    ],
    "kb2000": [
        "ON"
    ],
    "scg03": [
        "SA"
    ],
    "sh-m16": [
        "SH"
    ],
    "zr01": [
        "95"
    ],
    "f-03l": [
        "FU"
    ],
    "f-06f": [
        "FU"
    ],
    "fjl21": [
        "FU"
    ],
    "t799b": [
        "TC"
    ],
    "p360x": [
        "AL"
    ],
    "s90-a": [
        "LE"
    ],
    "p70-a": [
        "LE"
    ],
    "m-ppxg450": [
        "MC"
    ],
    "m-ppxs532l": [
        "MC"
    ],
    "m-ppxs532u": [
        "MC"
    ],
    "ztg01": [
        "ZT"
    ],
    "pure f": [
        "H2"
    ],
    "echo_fusion": [
        "E4"
    ],
    "elite 5": [
        "L5"
    ],
    "u16 max": [
        "OE"
    ],
    "u7 max": [
        "OE"
    ],
    "u7 plus": [
        "OE"
    ],
    "u11_plus": [
        "OE"
    ],
    "l503f plus": [
        "HN"
    ],
    "bison": [
        "UM"
    ],
    "606sh": [
        "SH"
    ],
    "sh-m01": [
        "SH"
    ],
    "403sh": [
        "SH"
    ],
    "allure_ultra_curve": [
        "2R"
    ],
    "allure ultra": [
        "2R"
    ],
    "allure secure": [
        "2R"
    ],
    "allure_admire": [
        "2R"
    ],
    "allure_rise": [
        "2R"
    ],
    "noh-nx9": [
        "HU"
    ],
    "art-l28": [
        "HU"
    ],
    "noh-an00": [
        "HU"
    ],
    "hlk-l41": [
        "HU"
    ],
    "kiona": [
        "6W"
    ],
    "kicka_4_plus": [
        "6W"
    ],
    "kanuna": [
        "6W"
    ],
    "kohana": [
        "6W"
    ],
    "kosumi": [
        "6W"
    ],
    "kwanita": [
        "6W"
    ],
    "lonan": [
        "6W"
    ],
    "halona": [
        "6W"
    ],
    "hotah": [
        "6W"
    ],
    "kicka 5 plus": [
        "6W"
    ],
    "kicka 5": [
        "6W"
    ],
    "starmobile play neo": [
        "18"
    ],
    "starmobile play spark": [
        "18"
    ],
    "hammer_s": [
        "UM"
    ],
    "horizon_s": [
        "6I"
    ],
    "horizon +": [
        "6I"
    ],
    "inco aurora ii": [
        "6I"
    ],
    "techpad m5": [
        "TP"
    ],
    "huawei": [
        "HU"
    ],
    "hurricane_ignite": [
        "HR"
    ],
    "hurricane_bolt": [
        "HR"
    ],
    "hurricane vortex": [
        "HR"
    ],
    "hurricane_giga": [
        "HR"
    ],
    "ilium alpha 1s": [
        "LA"
    ],
    "ilium alpha 5s": [
        "LA"
    ],
    "ilium alpha 9": [
        "LA"
    ],
    "ilium alpha 7": [
        "LA"
    ],
    "imo q3 plus": [
        "IL"
    ],
    "imo s2": [
        "IL"
    ],
    "iswag viper": [
        "9I"
    ],
    "iswag_lynx": [
        "9I"
    ],
    "iswag_mantra": [
        "9I"
    ],
    "iswag mega": [
        "9I"
    ],
    "inoi 7 2020": [
        "I4"
    ],
    "lg-d858hk": [
        "LG"
    ],
    "k9_viraat_plus": [
        "KA"
    ],
    "ksa-lx3": [
        "HU"
    ],
    "le9920": [
        "LV"
    ],
    "le9910": [
        "LV"
    ],
    "le9920_p": [
        "LV"
    ],
    "lh9910": [
        "LV"
    ],
    "lh9920": [
        "LV"
    ],
    "15 lite": [
        "M1"
    ],
    "vivax_fly_v1": [
        "V5"
    ],
    "jazzx js7 pro": [
        "QM"
    ],
    "jazzx js2": [
        "QM"
    ],
    "jazzx js10": [
        "QM"
    ],
    "k501 plus": [
        "8E"
    ],
    "k501": [
        "8E"
    ],
    "k502": [
        "8E"
    ],
    "k503": [
        "8E"
    ],
    "k504": [
        "8E"
    ],
    "k510": [
        "8E"
    ],
    "k511": [
        "8E"
    ],
    "k534": [
        "8E"
    ],
    "k535": [
        "8E"
    ],
    "k540": [
        "8E"
    ],
    "k573": [
        "8E"
    ],
    "k600": [
        "8E"
    ],
    "k601": [
        "8E"
    ],
    "x507t": [
        "8E"
    ],
    "k406": [
        "8E"
    ],
    "k503t": [
        "8E"
    ],
    "k405": [
        "8E"
    ],
    "k545": [
        "8E"
    ],
    "fresh4g": [
        "JG"
    ],
    "prime_4_lite": [
        "MY1"
    ],
    "indigo": [
        "EX"
    ],
    "inco_plain_2": [
        "6I"
    ],
    "amazing_a57": [
        "TW"
    ],
    "altice s62": [
        "66"
    ],
    "altice_s31": [
        "66"
    ],
    "altice_s43": [
        "66"
    ],
    "amazing a30": [
        "TW"
    ],
    "amazing_a32": [
        "TW"
    ],
    "amazing_a35": [
        "TW"
    ],
    "amazing a6": [
        "TW"
    ],
    "amazing a50": [
        "TW"
    ],
    "amazing x7": [
        "TW"
    ],
    "asus_z00wd": [
        "AU"
    ],
    "asus ze500kl": [
        "AU"
    ],
    "amazing x1": [
        "TW"
    ],
    "dash x plus": [
        "BU"
    ],
    "ambition": [
        "8K"
    ],
    "beyond": [
        "8K"
    ],
    "blade a7 2019-t": [
        "ZT"
    ],
    "buzz 2": [
        "AE"
    ],
    "buzz 2 plus": [
        "AE"
    ],
    "buzz 2 lite": [
        "AE"
    ],
    "flare_y6_pro": [
        "CH"
    ],
    "flare_y7_pro": [
        "CH"
    ],
    "flare_y3s": [
        "CH"
    ],
    "gm 9 pro d": [
        "GN"
    ],
    "gm 9 pro": [
        "GN"
    ],
    "gm 9 plus": [
        "GN"
    ],
    "glk-lx1u": [
        "HU"
    ],
    "gravity z": [
        "ZU"
    ],
    "gravity_55_go": [
        "MW"
    ],
    "gravity_5_go": [
        "MW"
    ],
    "griffe t8": [
        "C5"
    ],
    "gs100": [
        "GS"
    ],
    "gs150": [
        "DX"
    ],
    "gs153": [
        "DX"
    ],
    "gs155": [
        "DX"
    ],
    "gs180": [
        "GS"
    ],
    "gs185": [
        "GS"
    ],
    "gs280": [
        "GS"
    ],
    "gs80": [
        "GS"
    ],
    "helio s60": [
        "H6"
    ],
    "helio s5": [
        "H6"
    ],
    "gs110": [
        "GS"
    ],
    "gs190": [
        "GS"
    ],
    "gs195": [
        "GS"
    ],
    "gs290": [
        "GS"
    ],
    "hercules": [
        "H2"
    ],
    "dns_s5008": [
        "DN"
    ],
    "dns s4509": [
        "DN"
    ],
    "elephone g5": [
        "EL"
    ],
    "elephone g6": [
        "EL"
    ],
    "elephone g7": [
        "EL"
    ],
    "elephone p2000l": [
        "EL"
    ],
    "elephone p3000s": [
        "EL"
    ],
    "pass3g": [
        "JG"
    ],
    "stellar 3g": [
        "E4",
        "ZU"
    ],
    "santin life shine": [
        "SQ",
        "J0"
    ],
    "2ps64": [
        "HT"
    ],
    "as160": [
        "DX"
    ],
    "1824-s0": [
        "CO"
    ],
    "f534l": [
        "6T"
    ],
    "f572l": [
        "6T"
    ],
    "easy5": [
        "KW"
    ],
    "feeling": [
        "E4"
    ],
    "flow6lite": [
        "KE"
    ],
    "gap yoq": [
        "40"
    ],
    "gl355": [
        "DX"
    ],
    "grand m3": [
        "BU"
    ],
    "live 7s": [
        "KE"
    ],
    "move8mini": [
        "KE"
    ],
    "winmax xc14": [
        "9W"
    ],
    "winmax xc6": [
        "9W"
    ],
    "winmax xc4": [
        "9W"
    ],
    "armor_2s": [
        "UL"
    ],
    "blade v8": [
        "ZT"
    ],
    "blade v0820": [
        "ZT"
    ],
    "503hw": [
        "HU"
    ],
    "venus e2 plus": [
        "VT"
    ],
    "venus e2 plus dual": [
        "VT"
    ],
    "exodus 1": [
        "HT"
    ],
    "fs8015": [
        "SH"
    ],
    "fs8016": [
        "SH"
    ],
    "gsmart_classic_lite": [
        "GG"
    ],
    "l38011": [
        "LE"
    ],
    "tc51": [
        "PZ"
    ],
    "tc56": [
        "PZ"
    ],
    "tc20": [
        "PZ"
    ],
    "tc75": [
        "PZ"
    ],
    "tc700h": [
        "PZ"
    ],
    "tc25": [
        "PZ"
    ],
    "tc70x": [
        "PZ"
    ],
    "tc75x": [
        "PZ"
    ],
    "tele2_midi_lte": [
        "2L"
    ],
    "blu_s1": [
        "BU"
    ],
    "blu touchbook g7": [
        "BU"
    ],
    "blu vivo selfie": [
        "BU",
        "VV"
    ],
    "blu_neo_energy_mini": [
        "BU"
    ],
    "blu_studio_x5": [
        "BU"
    ],
    "blu dash 4.5": [
        "BU"
    ],
    "blu life mark": [
        "BU"
    ],
    "blu life one x": [
        "BU"
    ],
    "thuraya x5-touch": [
        "O0"
    ],
    "bmm 532 s": [
        "BF"
    ],
    "bphone b1115": [
        "BK"
    ],
    "bphone b1114": [
        "BK"
    ],
    "bphone b2017": [
        "BK"
    ],
    "bprime": [
        "8B"
    ],
    "bstar": [
        "8B"
    ],
    "bstar+": [
        "8B"
    ],
    "bprimes": [
        "8B"
    ],
    "b-one": [
        "8B"
    ],
    "awm501": [
        "AW"
    ],
    "awm509": [
        "AW"
    ],
    "awm561": [
        "AW"
    ],
    "aurii_amuse_3g": [
        "F3"
    ],
    "aurii ultra": [
        "F3"
    ],
    "venus e5": [
        "VT"
    ],
    "stf-l09s": [
        "HU"
    ],
    "spc smart lite": [
        "FS"
    ],
    "lg-h831": [
        "LG"
    ],
    "moto e5 play": [
        "MR"
    ],
    "element_pro_2": [
        "KL"
    ],
    "lm-x410(fg)": [
        "LG"
    ],
    "l-ement 505": [
        "LM"
    ],
    "l-ement 553": [
        "LM"
    ],
    "l-ement_403": [
        "LM"
    ],
    "lamcy c100": [
        "I8"
    ],
    "lamcy l400": [
        "I8"
    ],
    "lamcy l300": [
        "I8"
    ],
    "atractivo": [
        "80"
    ],
    "asanzo a2": [
        "90"
    ],
    "asanzo s2": [
        "90"
    ],
    "asanzo s3": [
        "90"
    ],
    "asanzo z5": [
        "90"
    ],
    "asanzo_s5": [
        "90"
    ],
    "asanzo_s3_plus": [
        "90"
    ],
    "artizlee_s9": [
        "21"
    ],
    "cameleon_c5": [
        "00"
    ],
    "cameleon_c6": [
        "00"
    ],
    "cameleon_c6_plus": [
        "00"
    ],
    "coolmintt m1": [
        "OM"
    ],
    "coolmintt p1": [
        "OM"
    ],
    "coolmintt p3": [
        "OM"
    ],
    "ultramintt r1": [
        "OM"
    ],
    "coolmintta3": [
        "OM"
    ],
    "ultramintt s1": [
        "OM"
    ],
    "coolminttm2": [
        "OM"
    ],
    "ultramintts2": [
        "OM"
    ],
    "flare_y7_lte": [
        "CH"
    ],
    "flare_y7": [
        "CH"
    ],
    "flare_y3": [
        "CH"
    ],
    "flare y3 mini": [
        "CH"
    ],
    "flare y3 pro": [
        "CH"
    ],
    "flare s7 plus": [
        "CH"
    ],
    "flare s7 max": [
        "CH"
    ],
    "chivas_55": [
        "AV"
    ],
    "city55": [
        "KW"
    ],
    "clarmin c1": [
        "L8"
    ],
    "clever 1": [
        "AE"
    ],
    "urban 1": [
        "AE"
    ],
    "urban 1 pro": [
        "AE"
    ],
    "buzz 1": [
        "AE"
    ],
    "amber7s": [
        "IP"
    ],
    "amber6": [
        "IP"
    ],
    "amber5s_pro": [
        "IP"
    ],
    "blaupunkt_sm_02": [
        "BP"
    ],
    "blink": [
        "4M"
    ],
    "berry1": [
        "4M"
    ],
    "berry 2": [
        "4M"
    ],
    "berry_plus": [
        "4M"
    ],
    "186hs2080531": [
        "FP"
    ],
    "186hs1050531": [
        "FP"
    ],
    "186hs1050232": [
        "FP"
    ],
    "186ft1080231": [
        "FP"
    ],
    "185ft5050231": [
        "FP"
    ],
    "flare s7 lite": [
        "CH"
    ],
    "flare y6": [
        "CH"
    ],
    "flare_a2": [
        "CH"
    ],
    "flare j8": [
        "CH"
    ],
    "flare j8 lte": [
        "CH"
    ],
    "flare j6": [
        "CH"
    ],
    "flare j6 plus": [
        "CH"
    ],
    "flare_j2_2018": [
        "CH"
    ],
    "flare_hd_5": [
        "CH"
    ],
    "flare_hd_4": [
        "CH"
    ],
    "flare_j2_max": [
        "CH"
    ],
    "flare_j2_prime": [
        "CH"
    ],
    "flare_j6s": [
        "CH"
    ],
    "flare_j6_mini": [
        "CH"
    ],
    "flare_s7": [
        "CH"
    ],
    "flare_s7_deluxe": [
        "CH"
    ],
    "flare_s7_mini": [
        "CH"
    ],
    "flare_s7_power": [
        "CH"
    ],
    "flare_s7_prime": [
        "CH"
    ],
    "pixel v2": [
        "LV"
    ],
    "phonemax_venus x": [
        "5P"
    ],
    "pearl a7": [
        "00"
    ],
    "pearl a5": [
        "00"
    ],
    "pearl_a2": [
        "00"
    ],
    "passion-1s": [
        "TJ"
    ],
    "passion-plus": [
        "TJ"
    ],
    "passion_pro": [
        "TJ",
        "QY"
    ],
    "plum z407": [
        "P4"
    ],
    "plum z516": [
        "P4"
    ],
    "iphone13,1": [
        "AP"
    ],
    "casper_via_v6x": [
        "R4"
    ],
    "404kc": [
        "KY"
    ],
    "7071a": [
        "AL"
    ],
    "7071d": [
        "AL"
    ],
    "7071x": [
        "AL"
    ],
    "point_x501": [
        "V5"
    ],
    "poppox p3": [
        "P0"
    ],
    "up_groove": [
        "18"
    ],
    "up prime": [
        "18"
    ],
    "up_selfie": [
        "18"
    ],
    "up_xtreme": [
        "18"
    ],
    "up_xl": [
        "18"
    ],
    "asus_t00t": [
        "AU"
    ],
    "asus_t00e": [
        "AU"
    ],
    "pearl a4 lite": [
        "00"
    ],
    "pearl a6": [
        "00"
    ],
    "phonenix50s": [
        "IP"
    ],
    "photo_p15_lite": [
        "XT"
    ],
    "platinum b4": [
        "SW"
    ],
    "platinum c4": [
        "SW"
    ],
    "platinum c55": [
        "SW"
    ],
    "platinum d5": [
        "SW"
    ],
    "platinum p9": [
        "SW"
    ],
    "platinum p9 pro": [
        "SW"
    ],
    "platinum x": [
        "SW"
    ],
    "platinum_b5": [
        "SW"
    ],
    "platinum_a4": [
        "SW"
    ],
    "platinum_e5": [
        "SW"
    ],
    "blade l5": [
        "ZT"
    ],
    "blade s6": [
        "ZT"
    ],
    "blade v8q": [
        "ZT"
    ],
    "sonysol23": [
        "SO"
    ],
    "infobar a01": [
        "KD"
    ],
    "4047a": [
        "AL"
    ],
    "5044s": [
        "AL"
    ],
    "5044g": [
        "AL"
    ],
    "a577vl": [
        "AL"
    ],
    "azumi a35c_lite": [
        "AM"
    ],
    "azumi a35clite": [
        "AM"
    ],
    "azumi a50c+": [
        "AM"
    ],
    "azumi a50tq": [
        "AM"
    ],
    "azumi_iro_a4_q": [
        "AM"
    ],
    "a862w": [
        "AO"
    ],
    "iphone2,1": [
        "AP"
    ],
    "iphone3,1": [
        "AP"
    ],
    "iphone5,1": [
        "AP"
    ],
    "iphone5,2": [
        "AP"
    ],
    "iphone5,4": [
        "AP"
    ],
    "iphone6,2": [
        "AP"
    ],
    "iphone11,8": [
        "AP"
    ],
    "iphone11,2": [
        "AP"
    ],
    "archos 40 titanium": [
        "AR"
    ],
    "archos 45 platinum": [
        "AR"
    ],
    "archos 45 titanium": [
        "AR"
    ],
    "archos 50 helium 4g": [
        "AR"
    ],
    "archos 50 oxygen": [
        "AR"
    ],
    "archos 50 platinum": [
        "AR"
    ],
    "yl-archos 50 power": [
        "AR"
    ],
    "archos 50 titanium": [
        "AR"
    ],
    "a50ti": [
        "AR"
    ],
    "archos 53 platinum": [
        "AR"
    ],
    "archos 53 titanium": [
        "AR"
    ],
    "archos 55 platinum": [
        "AR"
    ],
    "archos oxygen 63": [
        "AR"
    ],
    "asus_z00yd": [
        "AU"
    ],
    "padfone": [
        "AU"
    ],
    "padfone 2": [
        "AU"
    ],
    "padfone infinity": [
        "AU"
    ],
    "asus_t00n": [
        "AU"
    ],
    "padfone t004": [
        "AU"
    ],
    "asus_z01qd": [
        "AU"
    ],
    "zs600kl": [
        "AU"
    ],
    "asus_i001da": [
        "AU"
    ],
    "asus_i001d": [
        "AU"
    ],
    "asus_i001dc": [
        "AU"
    ],
    "asus_i001de": [
        "AU"
    ],
    "asus_i001db": [
        "AU"
    ],
    "zs660kl": [
        "AU"
    ],
    "asus_i003dd": [
        "AU"
    ],
    "asus_z008": [
        "AU"
    ],
    "z00d": [
        "AU"
    ],
    "asus_z008d": [
        "AU"
    ],
    "asus_z00ada": [
        "AU"
    ],
    "asus_z00adb": [
        "AU"
    ],
    "asus_z00ad": [
        "AU"
    ],
    "asus_z00a": [
        "AU"
    ],
    "asus_z00rd": [
        "AU"
    ],
    "asus_z00ed": [
        "AU"
    ],
    "asus_z00md": [
        "AU"
    ],
    "asus_z00td": [
        "AU"
    ],
    "asus_z011d": [
        "AU"
    ],
    "asus zenfone 2e": [
        "AU"
    ],
    "asus_z012s": [
        "AU"
    ],
    "ze520kl": [
        "AU"
    ],
    "asus_z012d": [
        "AU"
    ],
    "asus_z016d": [
        "AU"
    ],
    "asus_z01fd": [
        "AU"
    ],
    "zs550kl": [
        "AU"
    ],
    "asus_z01bs": [
        "AU"
    ],
    "asus_z01bd": [
        "AU"
    ],
    "zc551kl": [
        "AU"
    ],
    "asus_x00dd": [
        "AU"
    ],
    "zc553kl": [
        "AU"
    ],
    "asus_x00ds": [
        "AU"
    ],
    "asus_a001": [
        "AU"
    ],
    "asus_z01hd": [
        "AU"
    ],
    "ze553kl": [
        "AU"
    ],
    "asus_t00i": [
        "AU"
    ],
    "asus_t00q": [
        "AU"
    ],
    "asus_x00ld": [
        "AU"
    ],
    "asus_z01ks": [
        "AU"
    ],
    "ze554kl": [
        "AU"
    ],
    "asus_z01kda": [
        "AU"
    ],
    "asus_x00kd": [
        "AU"
    ],
    "zc520kl": [
        "AU"
    ],
    "asus_x00hd": [
        "AU"
    ],
    "asus_x00id": [
        "AU"
    ],
    "asus_x00is": [
        "AU"
    ],
    "asus_x015d": [
        "AU"
    ],
    "asus_z01gd": [
        "AU"
    ],
    "zs551kl": [
        "AU"
    ],
    "asus_x00lda": [
        "AU"
    ],
    "asus_z01md": [
        "AU"
    ],
    "zd553kl": [
        "AU"
    ],
    "zd552kl": [
        "AU"
    ],
    "asus_t00f": [
        "AU"
    ],
    "asus_t00j": [
        "AU"
    ],
    "asus_x00qd": [
        "AU"
    ],
    "asus_x00qsa": [
        "AU"
    ],
    "ze620kl": [
        "AU"
    ],
    "asus_t00k": [
        "AU"
    ],
    "asus_x017d": [
        "AU"
    ],
    "asus_x017da": [
        "AU"
    ],
    "zc600kl": [
        "AU"
    ],
    "asus_t00p": [
        "AU"
    ],
    "asus_z01rd": [
        "AU"
    ],
    "zs620kl": [
        "AU"
    ],
    "asus_t00g": [
        "AU"
    ],
    "asus_z002": [
        "AU"
    ],
    "zs630kl": [
        "AU"
    ],
    "asus_i01wd": [
        "AU"
    ],
    "asus_i01wdx": [
        "AU"
    ],
    "asus_a002": [
        "AU"
    ],
    "asus_a002a": [
        "AU"
    ],
    "asus_z007": [
        "AU"
    ],
    "asus_z00vd": [
        "AU"
    ],
    "asus_z00sd": [
        "AU"
    ],
    "asus_l001": [
        "AU"
    ],
    "asus_x00bd": [
        "AU"
    ],
    "z00vd": [
        "AU"
    ],
    "zb500kg": [
        "AU"
    ],
    "zb551kl": [
        "AU"
    ],
    "asus_x007d": [
        "AU"
    ],
    "zb500kl": [
        "AU"
    ],
    "asus_x014d": [
        "AU"
    ],
    "g550kl": [
        "AU"
    ],
    "g553kl": [
        "AU"
    ],
    "asus_a007": [
        "AU"
    ],
    "zb501kl": [
        "AU"
    ],
    "zb553kl": [
        "AU"
    ],
    "za550kl": [
        "AU"
    ],
    "asus_x00rd": [
        "AU"
    ],
    "g552kl": [
        "AU"
    ],
    "asus_z010d": [
        "AU"
    ],
    "asus_x00pd": [
        "AU"
    ],
    "zb555kl": [
        "AU"
    ],
    "asus_x01ad": [
        "AU"
    ],
    "zb633kl": [
        "AU"
    ],
    "asus_x01bd": [
        "AU"
    ],
    "asus_x018d": [
        "AU"
    ],
    "zb602kl": [
        "AU"
    ],
    "asus_x00td": [
        "AU"
    ],
    "zb601kl": [
        "AU"
    ],
    "asus_x01bda": [
        "AU"
    ],
    "zb631kl": [
        "AU"
    ],
    "asus_x003": [
        "AU"
    ],
    "asus_x002": [
        "AU"
    ],
    "asus_x550": [
        "AU"
    ],
    "asus_x00gd": [
        "AU"
    ],
    "asus_x005": [
        "AU"
    ],
    "asus_z00ud": [
        "AU"
    ],
    "asus_a006": [
        "AU"
    ],
    "asus_a009": [
        "AU"
    ],
    "asus_z00xs": [
        "AU"
    ],
    "avvio_765 avvio 765": [
        "AV"
    ],
    "avvio774": [
        "AV"
    ],
    "avvio_775": [
        "AV"
    ],
    "avvio786": [
        "AV"
    ],
    "aw500": [
        "AW"
    ],
    "aw790": [
        "AW"
    ],
    "awm533": [
        "AW"
    ],
    "bush 4 android": [
        "B1"
    ],
    "bush 5 android": [
        "B1"
    ],
    "a60": [
        "B2"
    ],
    "a60pro": [
        "B2"
    ],
    "blackview a8": [
        "B2"
    ],
    "a80pro": [
        "B2"
    ],
    "alife p1": [
        "B2"
    ],
    "alife s1": [
        "B2"
    ],
    "bv4000pro": [
        "B2"
    ],
    "bv5500": [
        "B2"
    ],
    "bv5800 pro": [
        "B2"
    ],
    "bv5900": [
        "B2"
    ],
    "bv6000": [
        "B2"
    ],
    "bv6000s": [
        "B2"
    ],
    "bv6800pro": [
        "B2"
    ],
    "bv7000 pro": [
        "B2"
    ],
    "bv8000pro": [
        "B2"
    ],
    "bv9000pro-f": [
        "B2"
    ],
    "bv9100": [
        "B2"
    ],
    "bv9500": [
        "B2"
    ],
    "bv9600": [
        "B2"
    ],
    "bv9600pro": [
        "B2"
    ],
    "bv9700pro": [
        "B2"
    ],
    "bv9800": [
        "B2"
    ],
    "bv9900": [
        "B2"
    ],
    "dm550": [
        "B2"
    ],
    "blackview e7s": [
        "B2"
    ],
    "omega_pro": [
        "B2"
    ],
    "p10000_pro": [
        "B2"
    ],
    "bluboo dual": [
        "B3"
    ],
    "maya": [
        "B3"
    ],
    "bluboo mini": [
        "B3"
    ],
    "picasso 4g": [
        "B3"
    ],
    "bluboos8": [
        "B3"
    ],
    "xfire": [
        "B3"
    ],
    "xfire2": [
        "B3"
    ],
    "bo-frsp4": [
        "B4"
    ],
    "bo-lfsp4": [
        "B4"
    ],
    "bo-lfspsl4": [
        "B4"
    ],
    "bo-lfspbs5": [
        "B4"
    ],
    "bo-lfspsl6qci": [
        "B4"
    ],
    "beeline e700": [
        "B5"
    ],
    "beeline fast": [
        "B5"
    ],
    "beeline_fast_2": [
        "B5"
    ],
    "beeline pro 2": [
        "B5"
    ],
    "beeline_pro_3": [
        "B5"
    ],
    "beeline pro 4": [
        "B5"
    ],
    "beeline_pro_6": [
        "B5"
    ],
    "beeline smart2": [
        "B5"
    ],
    "beeline smart 3": [
        "B5"
    ],
    "beeline smart 4": [
        "B5"
    ],
    "beeline smart dual": [
        "B5"
    ],
    "bihee a11": [
        "B8"
    ],
    "bihee a12": [
        "B8"
    ],
    "zbh-bihee a5": [
        "B8"
    ],
    "bihee a6": [
        "B8"
    ],
    "bihee a7+": [
        "B8"
    ],
    "bihee a8+": [
        "B8"
    ],
    "bluegood v6": [
        "BD"
    ],
    "bmm541d": [
        "BF"
    ],
    "bmm542d": [
        "BF"
    ],
    "bmm543d": [
        "BF"
    ],
    "bmm543s": [
        "BF"
    ],
    "bmm441d": [
        "BF"
    ],
    "bmm531b": [
        "BF"
    ],
    "bmm541b": [
        "BF"
    ],
    "bmm531a": [
        "BF"
    ],
    "bmm541a": [
        "BF"
    ],
    "bmm531d": [
        "BF"
    ],
    "bmm442d": [
        "BF"
    ],
    "bmm443d": [
        "BF"
    ],
    "bmm541w": [
        "BF"
    ],
    "bmm441s": [
        "BF"
    ],
    "bmm 431d": [
        "BF"
    ],
    "bmm_533d": [
        "BF"
    ],
    "bmm 541s": [
        "BF"
    ],
    "bmm-542s": [
        "BF"
    ],
    "bgh joy 303": [
        "BG"
    ],
    "bgh joy smart a5c": [
        "BG"
    ],
    "bgh joy smart a6": [
        "BG"
    ],
    "bgh joy smart a7g": [
        "BG"
    ],
    "bgh joy smart axs ii": [
        "BG"
    ],
    "bgh joy smart axs ii d": [
        "BG"
    ],
    "bgh joy v6": [
        "BG"
    ],
    "bgh joy x2": [
        "BG"
    ],
    "bgh joy x5": [
        "BG"
    ],
    "bird i600": [
        "BI"
    ],
    "bird i7": [
        "BI"
    ],
    "bird t900": [
        "BI"
    ],
    "bird-v8": [
        "BI"
    ],
    "bird_w5": [
        "BI"
    ],
    "ax1010": [
        "BM"
    ],
    "ax1015": [
        "BM"
    ],
    "ax1016": [
        "BM"
    ],
    "bmobile ax1020": [
        "BM"
    ],
    "ax1020": [
        "BM"
    ],
    "ax1030": [
        "BM"
    ],
    "ax1035": [
        "BM"
    ],
    "ax1040": [
        "BM"
    ],
    "ax1045": [
        "BM"
    ],
    "ax1050": [
        "BM"
    ],
    "ax1055": [
        "BM"
    ],
    "ax1060": [
        "BM"
    ],
    "ax1065": [
        "BM"
    ],
    "ax1065e": [
        "BM"
    ],
    "ax1070": [
        "BM"
    ],
    "ax1070e": [
        "BM"
    ],
    "ax1071": [
        "BM"
    ],
    "ax1072": [
        "BM"
    ],
    "ax1073": [
        "BM"
    ],
    "ax1073+": [
        "BM"
    ],
    "ax1074": [
        "BM"
    ],
    "ax1075": [
        "BM"
    ],
    "ax1085": [
        "BM"
    ],
    "ax1091": [
        "BM"
    ],
    "ax-340": [
        "BM"
    ],
    "ax510": [
        "BM"
    ],
    "ax512": [
        "BM"
    ],
    "ax515": [
        "BM"
    ],
    "ax520": [
        "BM"
    ],
    "ax524": [
        "BM"
    ],
    "ax525": [
        "BM"
    ],
    "ax530": [
        "BM"
    ],
    "ax535": [
        "BM"
    ],
    "ax540": [
        "BM"
    ],
    "ax570": [
        "BM"
    ],
    "ax600": [
        "BM"
    ],
    "ax605": [
        "BM"
    ],
    "ax610": [
        "BM"
    ],
    "bmobile_ax610": [
        "BM"
    ],
    "bmobile_ax620": [
        "BM"
    ],
    "ax650": [
        "BM"
    ],
    "ax660": [
        "BM"
    ],
    "ax670": [
        "BM"
    ],
    "ax675": [
        "BM"
    ],
    "bmobile_ax680": [
        "BM"
    ],
    "ax680+": [
        "BM"
    ],
    "ax681": [
        "BM"
    ],
    "ax683": [
        "BM"
    ],
    "ax685": [
        "BM"
    ],
    "ax690": [
        "BM"
    ],
    "ax7oo": [
        "BM"
    ],
    "ax705": [
        "BM"
    ],
    "ax710": [
        "BM"
    ],
    "ax745": [
        "BM"
    ],
    "bmobile_ax810": [
        "BM"
    ],
    "ax820": [
        "BM"
    ],
    "ax821": [
        "BM"
    ],
    "ax823": [
        "BM"
    ],
    "ax920": [
        "BM"
    ],
    "ax921": [
        "BM"
    ],
    "ax922": [
        "BM"
    ],
    "bmobile_t35ac": [
        "BM"
    ],
    "blaupunkt sl 01": [
        "BP"
    ],
    "blaupunkt sl 02": [
        "BP"
    ],
    "blaupunkt sl 04": [
        "BP"
    ],
    "blaupunkt sm 01": [
        "BP"
    ],
    "501 sz": [
        "BR"
    ],
    "brondi 620 sz": [
        "BR"
    ],
    "brondi_730_4g_hd": [
        "BR"
    ],
    "centurion": [
        "BR"
    ],
    "centurion 3": [
        "BR"
    ],
    "gladiator": [
        "BR"
    ],
    "gladiator-2": [
        "BR"
    ],
    "gladiator 3": [
        "BR"
    ],
    "gladiator_4": [
        "BR"
    ],
    "glory": [
        "BR"
    ],
    "glory 2": [
        "BR"
    ],
    "glory3": [
        "BR"
    ],
    "glory 4": [
        "BR"
    ],
    "luxury": [
        "BR"
    ],
    "luxury 3": [
        "BR"
    ],
    "luxury 4": [
        "BR"
    ],
    "luxury 5": [
        "BR"
    ],
    "sensuelle": [
        "BR"
    ],
    "victory": [
        "BR"
    ],
    "victory 2": [
        "BR"
    ],
    "victory 3": [
        "BR"
    ],
    "b8407": [
        "BT"
    ],
    "b8408": [
        "BT"
    ],
    "bitel b8409": [
        "BT"
    ],
    "b8410": [
        "BT"
    ],
    "bitel_b8411": [
        "BT"
    ],
    "bitel-b8413": [
        "BT"
    ],
    "b8414": [
        "BT"
    ],
    "b8415": [
        "BT"
    ],
    "b8416": [
        "BT"
    ],
    "b8502": [
        "BT"
    ],
    "b8503": [
        "BT"
    ],
    "b8504": [
        "BT"
    ],
    "b8506": [
        "BT"
    ],
    "b8601": [
        "BT"
    ],
    "b8604": [
        "BT"
    ],
    "b8606": [
        "BT"
    ],
    "b9401": [
        "BT"
    ],
    "b9501": [
        "BT"
    ],
    "b9502": [
        "BT"
    ],
    "b9503": [
        "BT"
    ],
    "b9504": [
        "BT"
    ],
    "b9505": [
        "BT"
    ],
    "blu advance 4.0": [
        "BU"
    ],
    "blu advance 4.0 l": [
        "BU"
    ],
    "advance 4.0m": [
        "BU"
    ],
    "advance 5.0 hd": [
        "BU"
    ],
    "advance a4": [
        "BU"
    ],
    "blu dash 3.5": [
        "BU"
    ],
    "blu dash 3.5 viva": [
        "BU"
    ],
    "blu dash 4.0": [
        "BU"
    ],
    "blu dash 5.0": [
        "BU"
    ],
    "dash 5.0+": [
        "BU"
    ],
    "blu dash jr": [
        "BU"
    ],
    "dash jr k": [
        "BU"
    ],
    "blu dash l": [
        "BU"
    ],
    "dash l2": [
        "BU"
    ],
    "dash l3": [
        "BU"
    ],
    "blu dash m": [
        "BU"
    ],
    "blu dash music 4.0": [
        "BU"
    ],
    "blu dash x": [
        "BU"
    ],
    "dash_x_plus_lte": [
        "BU"
    ],
    "dash x2": [
        "BU"
    ],
    "blu dash x2": [
        "BU"
    ],
    "dash xl": [
        "BU"
    ],
    "blu energy diamond": [
        "BU",
        "E1"
    ],
    "blu energy x plus": [
        "BU",
        "E1"
    ],
    "blu energy x plus 2": [
        "BU",
        "E1"
    ],
    "energy xl": [
        "BU",
        "E1"
    ],
    "blu grand 5.5 hd": [
        "BU"
    ],
    "blu grand x lte": [
        "BU"
    ],
    "grand xl lte": [
        "BU"
    ],
    "blu life one": [
        "BU"
    ],
    "life one x2": [
        "BU"
    ],
    "blu life view": [
        "BU"
    ],
    "blu life xl": [
        "BU"
    ],
    "blu magic": [
        "BU"
    ],
    "blu neo x": [
        "BU",
        "SPX"
    ],
    "blu neo x plus": [
        "BU"
    ],
    "blu neo xl": [
        "BU"
    ],
    "pure xl": [
        "BU"
    ],
    "blu quattro 4.5": [
        "BU"
    ],
    "blu r1 hd": [
        "BU"
    ],
    "r1 plus": [
        "BU"
    ],
    "blu studio 5.0": [
        "BU"
    ],
    "blu studio 5.0 c": [
        "BU"
    ],
    "blu studio 5.0 ii": [
        "BU"
    ],
    "studio 5.0k": [
        "BU"
    ],
    "blu studio 5.3 ii": [
        "BU"
    ],
    "studio 5.5": [
        "BU"
    ],
    "blu studio c": [
        "BU"
    ],
    "studio c hd": [
        "BU"
    ],
    "studio j1": [
        "BU"
    ],
    "studio j2": [
        "BU"
    ],
    "studio j5": [
        "BU"
    ],
    "studio j8": [
        "BU"
    ],
    "studio m hd": [
        "BU"
    ],
    "studio m5 plus": [
        "BU"
    ],
    "studio mega": [
        "BU"
    ],
    "blu studio one": [
        "BU"
    ],
    "studio selfie": [
        "BU"
    ],
    "blu studio selfie 2": [
        "BU"
    ],
    "blu studio selfie lte": [
        "BU"
    ],
    "studio view xl": [
        "BU",
        "WI"
    ],
    "blu studio x8 hd": [
        "BU"
    ],
    "blu studio x": [
        "BU"
    ],
    "tank xtreme 5.0": [
        "BU"
    ],
    "tank xtreme pro": [
        "BU"
    ],
    "blu vivo 4.65": [
        "BU",
        "VV"
    ],
    "blu vivo air lte": [
        "BU",
        "VV"
    ],
    "a501 bright": [
        "BV",
        "AC"
    ],
    "a503 joy": [
        "BV"
    ],
    "a504 trace": [
        "BV"
    ],
    "a505 joy plus": [
        "BV"
    ],
    "a509_jeans": [
        "BV"
    ],
    "a510_jeans_4g": [
        "BV"
    ],
    "a512 harmony pro": [
        "BV"
    ],
    "atlas a551": [
        "BV"
    ],
    "a552 joy max": [
        "BV"
    ],
    "bravis a554": [
        "BV"
    ],
    "bravis biz": [
        "BV"
    ],
    "nx505j": [
        "57"
    ],
    "nx507j": [
        "57"
    ],
    "frl-l23": [
        "HU"
    ],
    "s20 ultra apex 2021": [
        "IH"
    ],
    "sp-5400": [
        "31"
    ],
    "v2029": [
        "VV"
    ],
    "v2032": [
        "VV"
    ],
    "v2043": [
        "VV"
    ],
    "kb2001": [
        "ON"
    ],
    "kb2003": [
        "ON"
    ],
    "v2040": [
        "VV"
    ],
    "energy x 2": [
        "BU",
        "E1"
    ],
    "block 3 mini": [
        "SB"
    ],
    "block_mini": [
        "SB"
    ],
    "element max": [
        "KL"
    ],
    "f10_prime": [
        "GB"
    ],
    "hl4936": [
        "AD"
    ],
    "hwcd100e": [
        "HI"
    ],
    "kempler_p1": [
        "KS"
    ],
    "xp8800": [
        "OI"
    ],
    "p52_pride5c": [
        "9C"
    ],
    "net_titan": [
        "K2"
    ],
    "spark plus 3": [
        "PK"
    ],
    "ana-lx4": [
        "HU"
    ],
    "be2012": [
        "ON"
    ],
    "be2025": [
        "ON"
    ],
    "be2028": [
        "ON"
    ],
    "frl-l22": [
        "HU"
    ],
    "g90 pro": [
        "BU"
    ],
    "g90": [
        "BU"
    ],
    "jef-nx9": [
        "HU"
    ],
    "ppa-lx3": [
        "HU"
    ],
    "v2030": [
        "VV"
    ],
    "net_volt": [
        "K2"
    ],
    "x50 pro+": [
        "VV"
    ],
    "prime_s": [
        "3D"
    ],
    "akus z": [
        "ZU"
    ],
    "corn r20": [
        "4R"
    ],
    "p90_pride5x": [
        "9C"
    ],
    "sm-m115m": [
        "SA"
    ],
    "sm-m127f": [
        "SA"
    ],
    "sm-m127g": [
        "SA"
    ],
    "samsung sm-a326b": [
        "SA"
    ],
    "samsung sm-a326br": [
        "SA"
    ],
    "sm-m013f": [
        "SA"
    ],
    "sm-m017f": [
        "SA"
    ],
    "sm-m025f": [
        "SA"
    ],
    "zte blade l210": [
        "ZT"
    ],
    "zte blade v10": [
        "ZT",
        "WCP"
    ],
    "zte blade a5 2020": [
        "ZT"
    ],
    "zte blade a3 2020": [
        "ZT"
    ],
    "zte blade l130": [
        "ZT"
    ],
    "zte blade a3 lite": [
        "ZT"
    ],
    "zte blade a531": [
        "ZT"
    ],
    "zte blade a522": [
        "ZT"
    ],
    "zte blade a521": [
        "ZT"
    ],
    "zte blade a321": [
        "ZT"
    ],
    "zte_blade_l2": [
        "ZT"
    ],
    "zte_blade_c2_plus": [
        "ZT"
    ],
    "zte blade g plus android-mms/2.0": [
        "ZT"
    ],
    "zte_blade_iii": [
        "ZT"
    ],
    "sm-g981v": [
        "SA"
    ],
    "sm-g9758": [
        "SA"
    ],
    "sm-g770u1": [
        "SA"
    ],
    "sm-g988b": [
        "SA"
    ],
    "sm-s906l": [
        "SA"
    ],
    "sm-g928n0": [
        "SA"
    ],
    "sm-g930r4": [
        "SA"
    ],
    "sm-g930r6": [
        "SA"
    ],
    "sm-g930r7": [
        "SA"
    ],
    "sm-g930vc": [
        "SA"
    ],
    "sm-g930vl": [
        "SA"
    ],
    "sm-g7810": [
        "SA"
    ],
    "sm-g781n": [
        "SA"
    ],
    "sm-g781u": [
        "SA"
    ],
    "sm-g781u1": [
        "SA"
    ],
    "sm-g781v": [
        "SA"
    ],
    "sm-g781w": [
        "SA"
    ],
    "samsung sm-a716s": [
        "SA"
    ],
    "sm-a015t1": [
        "SA"
    ],
    "sm-a015u": [
        "SA"
    ],
    "sm-a015u1": [
        "SA"
    ],
    "sm-a015v": [
        "SA"
    ],
    "sm-s111dl": [
        "SA"
    ],
    "samsung sm-a013f": [
        "SA"
    ],
    "samsung sm-a013g": [
        "SA"
    ],
    "sm-a025f": [
        "SA"
    ],
    "sm-a025g": [
        "SA"
    ],
    "sm-a025m": [
        "SA"
    ],
    "sm-a115a": [
        "SA"
    ],
    "sm-a115ap": [
        "SA"
    ],
    "sm-a115u": [
        "SA"
    ],
    "sm-a115u1": [
        "SA"
    ],
    "sm-a115w": [
        "SA"
    ],
    "sm-a125m": [
        "SA"
    ],
    "sm-a217n": [
        "SA"
    ],
    "sm-a215u1": [
        "SA"
    ],
    "sm-a215w": [
        "SA"
    ],
    "sm-a215dl": [
        "SA"
    ],
    "sm-a300xz": [
        "SA"
    ],
    "sm-a300x": [
        "SA"
    ],
    "sm-a3058": [
        "SA"
    ],
    "samsung sm-f7070": [
        "SA"
    ],
    "samsung sm-f707b": [
        "SA"
    ],
    "samsung sm-f707n": [
        "SA"
    ],
    "samsung sm-f707u": [
        "SA"
    ],
    "samsung sm-f707u1": [
        "SA"
    ],
    "samsung sm-f707w": [
        "SA"
    ],
    "sm-g715a": [
        "SA"
    ],
    "sm-g715u": [
        "SA"
    ],
    "sm-g715u1": [
        "SA"
    ],
    "sm-g715w": [
        "SA"
    ],
    "sm-g889a": [
        "SA"
    ],
    "sm-g889f": [
        "SA"
    ],
    "sm-g889g": [
        "SA"
    ],
    "sm-g889yb": [
        "SA"
    ],
    "samsung sm-a430f": [
        "SA"
    ],
    "samsung sm-a705u": [
        "SA"
    ],
    "sm-a515w": [
        "SA"
    ],
    "samsung sm-s515dl": [
        "SA"
    ],
    "sm-a5160": [
        "SA"
    ],
    "sm-a516b": [
        "SA"
    ],
    "sm-a516n": [
        "SA"
    ],
    "sm-a516u": [
        "SA"
    ],
    "sm-a516u1": [
        "SA"
    ],
    "sm-a516v": [
        "SA"
    ],
    "sm-g3558": [
        "SA"
    ],
    "sm-g3559": [
        "SA"
    ],
    "sm-a7160": [
        "SA"
    ],
    "sm-a716b": [
        "SA"
    ],
    "sm-a716u1": [
        "SA"
    ],
    "sm-a716v": [
        "SA"
    ],
    "sm-g150nk": [
        "SA"
    ],
    "sm-g150n0": [
        "SA"
    ],
    "sm-g150nl": [
        "SA"
    ],
    "sm-g150ns": [
        "SA"
    ],
    "samsung sm-a4260": [
        "SA"
    ],
    "samsung sm-a426b": [
        "SA"
    ],
    "samsung sm-a426n": [
        "SA"
    ],
    "scg04": [
        "SA"
    ],
    "sc-54a": [
        "SA",
        "SU"
    ],
    "sc-41a": [
        "SA",
        "SU"
    ],
    "sc-02l": [
        "SA",
        "SU"
    ],
    "sc-05l": [
        "SA",
        "SU"
    ],
    "sc-42a": [
        "SA",
        "SU"
    ],
    "sc-51a": [
        "SA",
        "SU"
    ],
    "samsung sm-a9080": [
        "SA"
    ],
    "sm-a900f": [
        "SA"
    ],
    "sm-a8s": [
        "SA"
    ],
    "samsung sm-m105y": [
        "SA"
    ],
    "sm-m515f": [
        "SA"
    ],
    "sm-j100g": [
        "SA"
    ],
    "sm-s777c": [
        "SA"
    ],
    "sm-j120p": [
        "SA"
    ],
    "sm-j510fq": [
        "SA"
    ],
    "sm-f415f": [
        "SA"
    ],
    "sm-f127g": [
        "SA"
    ],
    "samsung sm-c500x": [
        "SA"
    ],
    "sm-c700x": [
        "SA"
    ],
    "sm-c701x": [
        "SA"
    ],
    "sm-a730x": [
        "SA"
    ],
    "sm-a500yz": [
        "SA"
    ],
    "sm-a800x": [
        "SA"
    ],
    "sm-w2015": [
        "SA"
    ],
    "sm-g8508s": [
        "SA"
    ],
    "sm-g165n": [
        "SA"
    ],
    "sm-g3589w": [
        "SA"
    ],
    "sm-j300h": [
        "SA"
    ],
    "sm-s10 lite": [
        "SA"
    ],
    "sm-j8 plus": [
        "SA"
    ],
    "sm-a9 pro": [
        "SA"
    ],
    "sm-j7 pro": [
        "SA"
    ],
    "sm-m20": [
        "SA"
    ],
    "sm-m30": [
        "SA"
    ],
    "sm-m30s": [
        "SA"
    ],
    "sm-g3518": [
        "SA"
    ],
    "samsung-sm-g3518_td android/4.3 release/11.15.2013 browser/": [
        "SA"
    ],
    "samsung sm-a720m": [
        "SA"
    ],
    "samsung sm-g400g": [
        "SA"
    ],
    "samsung sm-g400f": [
        "SA"
    ],
    "sm-g5108": [
        "SA"
    ],
    "sm-g316u": [
        "SA"
    ],
    "platinum_f5": [
        "SW"
    ],
    "platinum_g5": [
        "SW"
    ],
    "platinum_g55": [
        "SW"
    ],
    "platinum_uno": [
        "SW"
    ],
    "plume l3": [
        "C5"
    ],
    "plume l3 smart": [
        "C5"
    ],
    "smart 4g champion": [
        "11"
    ],
    "smart 4g p1": [
        "11"
    ],
    "smart 4g p1 prime": [
        "11"
    ],
    "smart_ev5": [
        "8V"
    ],
    "smart ev6": [
        "8V"
    ],
    "smart ev5": [
        "8V"
    ],
    "kyv44_u2": [
        "KY"
    ],
    "sh-rm15": [
        "SH"
    ],
    "vpa051": [
        "5V"
    ],
    "bluedot bnp-500": [
        "2B"
    ],
    "htv31": [
        "HT"
    ],
    "p-03e": [
        "PA"
    ],
    "sh-m12-y": [
        "SH"
    ],
    "sp-5250": [
        "31"
    ],
    "spin max 2": [
        "CH"
    ],
    "ssb-508e": [
        "JT"
    ],
    "starmobile play go": [
        "18"
    ],
    "sugar c13": [
        "9S"
    ],
    "sugar f20": [
        "9S"
    ],
    "sugar p1": [
        "9S"
    ],
    "sugar s20": [
        "9S"
    ],
    "sugar s20s": [
        "9S"
    ],
    "sugar y12s": [
        "9S"
    ],
    "sugar y16": [
        "9S"
    ],
    "block go": [
        "SB"
    ],
    "block 3": [
        "SB"
    ],
    "advance l4": [
        "BU"
    ],
    "alien x lite": [
        "IH"
    ],
    "alien x lite pro": [
        "IH"
    ],
    "alien_x": [
        "IH"
    ],
    "alien_x_apex": [
        "IH"
    ],
    "amazing_a55": [
        "TW"
    ],
    "apex1": [
        "O7"
    ],
    "apex3": [
        "O7"
    ],
    "basco l3": [
        "JG"
    ],
    "basco l400": [
        "JG"
    ],
    "basco l500": [
        "JG"
    ],
    "basco s2": [
        "JG"
    ],
    "basco xs1": [
        "JG"
    ],
    "aquaris_m4.5": [
        "BX",
        "IX"
    ],
    "apollo 5 neo": [
        "RF",
        "VR"
    ],
    "5033q": [
        "AL"
    ],
    "elite m45": [
        "SW"
    ],
    "elite go": [
        "SW"
    ],
    "elite m5plus": [
        "SW",
        "TP"
    ],
    "elite t4": [
        "SW"
    ],
    "c6 2019": [
        "BU"
    ],
    "c5 2019": [
        "BU"
    ],
    "c4 2019": [
        "BU"
    ],
    "c210ae": [
        "WI"
    ],
    "iswag_nemesis": [
        "9I"
    ],
    "aura x": [
        "ZU"
    ],
    "lm-x120": [
        "LG"
    ],
    "sm-a217m": [
        "SA"
    ],
    "sm-g930t1": [
        "SA"
    ],
    "sm-a515u": [
        "SA"
    ],
    "samsung-sm-g930az": [
        "SA"
    ],
    "sm-a115m": [
        "SA"
    ],
    "sm-g970u1": [
        "SA"
    ],
    "sm-a013m": [
        "SA"
    ],
    "sm-g780f": [
        "SA"
    ],
    "4034t": [
        "AL"
    ],
    "5003u": [
        "AL"
    ],
    "5008a": [
        "AL"
    ],
    "5008t": [
        "AL"
    ],
    "5033s": [
        "AL"
    ],
    "5053d_eea": [
        "AL"
    ],
    "5059j": [
        "AL"
    ],
    "are-l22": [
        "HU"
    ],
    "astro_5_go_lte": [
        "MW"
    ],
    "elephone p7000": [
        "EL"
    ],
    "b6 master": [
        "5B"
    ],
    "b6 note x": [
        "5B"
    ],
    "opelmobile_smartjx": [
        "2O"
    ],
    "neo [reloaded]": [
        "NJ"
    ],
    "nubia z11 mini": [
        "57"
    ],
    "cherry_mobile_fuze_mini": [
        "CH"
    ],
    "motorola razr 5g": [
        "MR"
    ],
    "motorola razr": [
        "MR"
    ],
    "lenovo z5s": [
        "LE"
    ],
    "active 3": [
        "VH"
    ],
    "aquaris x2 pro": [
        "BX",
        "IX"
    ],
    "aquaris x2": [
        "BX",
        "IX"
    ],
    "armor 9e": [
        "UL"
    ],
    "armor 8": [
        "UL"
    ],
    "armor 9": [
        "UL"
    ],
    "armor 7e": [
        "UL"
    ],
    "armor x5 pro": [
        "UL"
    ],
    "armor x7": [
        "UL"
    ],
    "armor x8": [
        "UL"
    ],
    "armor x7 pro": [
        "UL"
    ],
    "zte blade a7 2020": [
        "ZT"
    ],
    "hype": [
        "4M"
    ],
    "orange mahpee": [
        "OR"
    ],
    "homtom ht 17 pro": [
        "HM"
    ],
    "honor 4c pro": [
        "HU"
    ],
    "k1 trio": [
        "7K"
    ],
    "16th": [
        "M1"
    ],
    "16th plus": [
        "M1"
    ],
    "saturn selfie": [
        "V9"
    ],
    "sansui_switch": [
        "12"
    ],
    "sansui play": [
        "12"
    ],
    "sansui fun": [
        "12"
    ],
    "sansui sa41": [
        "12"
    ],
    "sansui u46": [
        "12"
    ],
    "sansui_u30": [
        "12"
    ],
    "sansui_sa40": [
        "12"
    ],
    "sansui_nova": [
        "12"
    ],
    "sansui u45": [
        "12"
    ],
    "sansui_u32": [
        "12"
    ],
    "sico_plus": [
        "13"
    ],
    "safari": [
        "14"
    ],
    "titanium frames s7": [
        "KA"
    ],
    "tymes v5": [
        "15"
    ],
    "delight th201": [
        "TN"
    ],
    "dash l5x": [
        "BU"
    ],
    "dash l4x": [
        "BU"
    ],
    "dash l5 lte": [
        "BU"
    ],
    "dash l4 lte": [
        "BU"
    ],
    "dandy": [
        "4M"
    ],
    "e1457": [
        "16"
    ],
    "w1450": [
        "16"
    ],
    "w1452": [
        "16"
    ],
    "vs5513": [
        "VU"
    ],
    "vs4011": [
        "VU"
    ],
    "vr6031": [
        "VU"
    ],
    "vox steel plus": [
        "5I"
    ],
    "vox energy": [
        "5I"
    ],
    "vox 4s": [
        "5I"
    ],
    "vivi_8": [
        "1I"
    ],
    "smart601": [
        "17"
    ],
    "smart550": [
        "17"
    ],
    "smart509": [
        "17"
    ],
    "smart 505": [
        "17"
    ],
    "smart8": [
        "OW"
    ],
    "smadl matri2": [
        "14"
    ],
    "smadl matrix": [
        "14"
    ],
    "sky_pro_iii": [
        "SW"
    ],
    "sky 55m": [
        "SW"
    ],
    "premio s50": [
        "FP"
    ],
    "vision_pro": [
        "TQ"
    ],
    "visionbook_p50plus_lte": [
        "UA"
    ],
    "visionbook p55 x2 lte": [
        "UA"
    ],
    "vision ultra": [
        "TQ"
    ],
    "victor v1": [
        "1K",
        "U4"
    ],
    "via_a1_1": [
        "R4"
    ],
    "colors s9": [
        "9C"
    ],
    "colors s11": [
        "9C"
    ],
    "colors s1": [
        "9C"
    ],
    "colors p70": [
        "9C"
    ],
    "colors p65": [
        "9C"
    ],
    "colors p50 plus": [
        "9C"
    ],
    "colors p45": [
        "9C"
    ],
    "colombia_2018": [
        "AV"
    ],
    "excite prime 2 pro": [
        "CD",
        "HR"
    ],
    "eda50": [
        "WH"
    ],
    "eda50k": [
        "WH"
    ],
    "eda70": [
        "WH"
    ],
    "eda51": [
        "WH"
    ],
    "electroneumm1": [
        "03"
    ],
    "elite t55": [
        "SW"
    ],
    "elite_b5": [
        "SW"
    ],
    "energye500": [
        "ED",
        "E1"
    ],
    "energye500s_eu": [
        "ED",
        "E1"
    ],
    "epix": [
        "TQ"
    ],
    "era5x": [
        "XO"
    ],
    "era_4x": [
        "XO"
    ],
    "era_4x_2gb": [
        "XO"
    ],
    "eternity_g25": [
        "HN"
    ],
    "premio p420": [
        "FP"
    ],
    "premio p451": [
        "FP"
    ],
    "pride_1a": [
        "9C"
    ],
    "tango_lite": [
        "4M"
    ],
    "tank_p55": [
        "00"
    ],
    "platinum_o": [
        "SW"
    ],
    "pluzz_z552": [
        "22"
    ],
    "pluzz_pl5510": [
        "22"
    ],
    "pluzz_pl5010": [
        "22"
    ],
    "pluzz_pl4010": [
        "22"
    ],
    "pluzz-pl5016": [
        "22"
    ],
    "pluzz-pl5014": [
        "22"
    ],
    "pluzz_elite_dual": [
        "22"
    ],
    "polytron r250a": [
        "P5"
    ],
    "polytron_p552": [
        "P5"
    ],
    "polytron r2452": [
        "P5"
    ],
    "polaroid pspt350": [
        "PL"
    ],
    "powerful_k55i": [
        "8I"
    ],
    "primuxkappa": [
        "6P"
    ],
    "primux_beta2": [
        "6P"
    ],
    "primux_omega5": [
        "6P"
    ],
    "prixton c18": [
        "2P"
    ],
    "magnus bravoz20": [
        "23"
    ],
    "magnus bravoz30": [
        "23"
    ],
    "magnus infinityg8": [
        "23"
    ],
    "magnus_infinity_g11": [
        "23"
    ],
    "mars note": [
        "V9"
    ],
    "mars nocam": [
        "V9"
    ],
    "magic q8": [
        "HV"
    ],
    "ok6000 plus": [
        "OE"
    ],
    "okwu sigma": [
        "QK",
        "1S"
    ],
    "omega 8": [
        "G3"
    ],
    "omega 3": [
        "G3"
    ],
    "omega icon 2": [
        "CH"
    ],
    "odyssey o2": [
        "Z4"
    ],
    "odyssey range": [
        "Z4"
    ],
    "ocean_9": [
        "V6"
    ],
    "ocean_8": [
        "V6"
    ],
    "ocean9l": [
        "V6"
    ],
    "ocean 6": [
        "V6"
    ],
    "nuu_m2": [
        "NL"
    ],
    "magic 5 plus": [
        "HV"
    ],
    "magic 13": [
        "HV"
    ],
    "magic 11": [
        "HV"
    ],
    "magic 9": [
        "HV"
    ],
    "magic 8": [
        "HV"
    ],
    "mito_a19_2gb": [
        "8M"
    ],
    "mito_a19_1gb": [
        "8M"
    ],
    "mito a21": [
        "8M"
    ],
    "mito a17": [
        "8M"
    ],
    "mint_m353": [
        "AV"
    ],
    "ls50f": [
        "EW"
    ],
    "ls50": [
        "EW"
    ],
    "ls5": [
        "EW"
    ],
    "ls5518h": [
        "EW"
    ],
    "ls5718": [
        "EW"
    ],
    "lt500 pro": [
        "QM"
    ],
    "lenumero1": [
        "OS"
    ],
    "leagoo m6": [
        "L5"
    ],
    "le must": [
        "LM"
    ],
    "le starter l": [
        "LM"
    ],
    "le_hello": [
        "LM"
    ],
    "laiq dubai": [
        "LQ"
    ],
    "l-ement550": [
        "LM"
    ],
    "l-ement501": [
        "LM"
    ],
    "l-ement451": [
        "LM"
    ],
    "l-ement401": [
        "LM"
    ],
    "l-ement350": [
        "LM"
    ],
    "l-ement500": [
        "LM"
    ],
    "l-ement500l": [
        "LM"
    ],
    "l-ite 400m": [
        "LM"
    ],
    "l-ite 452": [
        "LM"
    ],
    "l-ite 504 hd": [
        "LM"
    ],
    "l-ite 506 hd": [
        "LM"
    ],
    "l-ite 506r hd": [
        "LM"
    ],
    "l-ite 552 hd": [
        "LM"
    ],
    "l-egantone": [
        "LM"
    ],
    "ilium l900": [
        "LA"
    ],
    "iuni u3": [
        "3U"
    ],
    "iuni i1": [
        "3U"
    ],
    "ibiza_f2": [
        "DO"
    ],
    "point_x1": [
        "V5"
    ],
    "m-ppag4": [
        "MC"
    ],
    "m-ppxs7": [
        "MC"
    ],
    "m-ppxs7p": [
        "MC"
    ],
    "6060x": [
        "AL"
    ],
    "ms50l_4g": [
        "1R"
    ],
    "ms60f_plus": [
        "1R"
    ],
    "ms60f": [
        "1R"
    ],
    "platinum_a55": [
        "SW"
    ],
    "platinum_a5": [
        "SW"
    ],
    "platinum_4_0plus": [
        "SW"
    ],
    "platinum 5.5c": [
        "SW"
    ],
    "platinum a57": [
        "SW"
    ],
    "platinum m4": [
        "SW"
    ],
    "qs701": [
        "QH"
    ],
    "qphone_9.2": [
        "QB"
    ],
    "qphone_5.6": [
        "QB"
    ],
    "qphone 7.1": [
        "QB"
    ],
    "q9s55in4g": [
        "QI"
    ],
    "q_smart_be": [
        "MY1"
    ],
    "roarv95": [
        "SM"
    ],
    "roar_v150": [
        "SM"
    ],
    "roar_v78": [
        "SM"
    ],
    "royale a1": [
        "F7"
    ],
    "royale y2 lite": [
        "F7"
    ],
    "royale y2": [
        "F7"
    ],
    "ruio_s4": [
        "RL"
    ],
    "ruio_s5plus": [
        "RL"
    ],
    "festxl-pro": [
        "H2"
    ],
    "fest": [
        "H2"
    ],
    "fighter": [
        "32"
    ],
    "eager": [
        "32"
    ],
    "e70 ultra": [
        "51"
    ],
    "elite t6": [
        "SW"
    ],
    "elite a5": [
        "SW"
    ],
    "dandy_zam": [
        "4M"
    ],
    "gravity z2": [
        "AF"
    ],
    "championpro": [
        "AF"
    ],
    "cp6001a": [
        "53"
    ],
    "clemphone_7": [
        "33"
    ],
    "citi power 4g cs5026pl": [
        "D2"
    ],
    "changhongr8": [
        "C2"
    ],
    "changhong x1-k": [
        "C2"
    ],
    "changhongz9": [
        "C2"
    ],
    "changhongz9s": [
        "C2"
    ],
    "changhongz1s": [
        "C2"
    ],
    "changhongs18": [
        "C2"
    ],
    "changhongx6": [
        "C2"
    ],
    "cg_omega6": [
        "G3"
    ],
    "centric s50g": [
        "FI"
    ],
    "cell_c_summit_plus": [
        "02"
    ],
    "cell_c_fame": [
        "02"
    ],
    "camellia_ii": [
        "VB"
    ],
    "cactus ii": [
        "VB"
    ],
    "maple iii": [
        "VB"
    ],
    "cactus-pro": [
        "VB"
    ],
    "maple-ii": [
        "VB"
    ],
    "lavenderii": [
        "VB"
    ],
    "jasmine-ii": [
        "VB"
    ],
    "cameleon a1": [
        "00"
    ],
    "citi z540 4g ct5009pl": [
        "D2"
    ],
    "clever gem s52": [
        "AO"
    ],
    "clever gleam s45": [
        "AO"
    ],
    "clever pad p7": [
        "AO"
    ],
    "clever-wave s50": [
        "AO"
    ],
    "clevertouch s46": [
        "AO"
    ],
    "clever joy s40": [
        "AO"
    ],
    "clever lite s41": [
        "AO"
    ],
    "cool_extreme_2": [
        "34"
    ],
    "earn": [
        "34"
    ],
    "fashion2plus": [
        "34"
    ],
    "fashion c": [
        "34"
    ],
    "cool duo": [
        "34"
    ],
    "flame_plus": [
        "HR"
    ],
    "colors e15": [
        "9C"
    ],
    "fun s1": [
        "V5"
    ],
    "alto bombo": [
        "CI"
    ],
    "alto classic": [
        "CI"
    ],
    "alto estrella": [
        "CI"
    ],
    "alto juego": [
        "CI"
    ],
    "alto subir": [
        "CI"
    ],
    "ojos i": [
        "CI"
    ],
    "ojos nube": [
        "CI"
    ],
    "ojos oro": [
        "CI"
    ],
    "chico ojos 6": [
        "CI"
    ],
    "ojos_8": [
        "CI"
    ],
    "ojos cambio": [
        "CI"
    ],
    "chic_x1": [
        "34"
    ],
    "airphones6": [
        "25"
    ],
    "airphones5": [
        "25"
    ],
    "claresta f4": [
        "25"
    ],
    "claresta f3 pro": [
        "25"
    ],
    "airphone k6": [
        "25"
    ],
    "concorde_raptor_z55": [
        "CC"
    ],
    "colors p55": [
        "9C"
    ],
    "colors p32": [
        "9C"
    ],
    "clarmin b5": [
        "L8"
    ],
    "caryota 1": [
        "2D"
    ],
    "caryota 2": [
        "2D"
    ],
    "caryota 4": [
        "2D"
    ],
    "caryota 5": [
        "2D"
    ],
    "caryota 7": [
        "2D"
    ],
    "caryota 8": [
        "2D"
    ],
    "caryota 9": [
        "2D"
    ],
    "jesy_j7": [
        "JS"
    ],
    "jazz j3 2018": [
        "2D"
    ],
    "jazz j1 2018": [
        "2D"
    ],
    "fero_iris": [
        "F7"
    ],
    "fero power": [
        "F7"
    ],
    "fero pace": [
        "F7"
    ],
    "fero a5001": [
        "F7"
    ],
    "fero a4503": [
        "F7"
    ],
    "fero mega lte": [
        "F7"
    ],
    "fero vibe": [
        "F7"
    ],
    "fendy_ds": [
        "4M"
    ],
    "zorro 001": [
        "CB"
    ],
    "prime_18x9": [
        "MY1"
    ],
    "omega_lite_3c": [
        "CH"
    ],
    "hero_h5+": [
        "BC"
    ],
    "hero_se2": [
        "BC"
    ],
    "hero_xr_plus": [
        "BC"
    ],
    "hero sx": [
        "BC"
    ],
    "hero 12": [
        "BC"
    ],
    "hero 11": [
        "BC"
    ],
    "hero_13": [
        "BC"
    ],
    "hero se3 max": [
        "BC"
    ],
    "hero_h9": [
        "BC"
    ],
    "hero_h7_plus": [
        "BC"
    ],
    "honey y1": [
        "BC"
    ],
    "honey y2s": [
        "BC"
    ],
    "gome_c7_note": [
        "G5"
    ],
    "go5_55": [
        "2K"
    ],
    "bless_go55": [
        "2K"
    ],
    "blessplus": [
        "2K"
    ],
    "bp100 x-plus": [
        "9B"
    ],
    "gome_2018x07a": [
        "G5"
    ],
    "g2299": [
        "SO"
    ],
    "gini w7": [
        "1G"
    ],
    "gini n8": [
        "1G"
    ],
    "gini s5pro": [
        "1G"
    ],
    "gp10x2019": [
        "IZ"
    ],
    "ph544": [
        "MM"
    ],
    "ph604": [
        "MM"
    ],
    "p12curve": [
        "RD"
    ],
    "prau8": [
        "SS"
    ],
    "pra100": [
        "SS"
    ],
    "zte 9000ru": [
        "ZT"
    ],
    "mtech turbo l9": [
        "72"
    ],
    "mtech turbo l10": [
        "72"
    ],
    "mtech jazbaa": [
        "72"
    ],
    "cmcc-m860": [
        "C3"
    ],
    "prime3lite": [
        "MY1"
    ],
    "prime_18x9_lte": [
        "MY1"
    ],
    "primo d9": [
        "WA"
    ],
    "primo e9": [
        "WA"
    ],
    "primo f8s": [
        "WA"
    ],
    "primo g8i 4g": [
        "WA"
    ],
    "primo g8i": [
        "WA"
    ],
    "primo h7s": [
        "WA"
    ],
    "primo h8": [
        "WA"
    ],
    "primo h8 pro": [
        "WA"
    ],
    "primo g9": [
        "WA"
    ],
    "primo f9": [
        "WA"
    ],
    "primo h9": [
        "WA"
    ],
    "primo h9 pro": [
        "WA"
    ],
    "primo s7 pro": [
        "WA"
    ],
    "primo s7": [
        "WA"
    ],
    "walton primo h1": [
        "WA"
    ],
    "primo h5": [
        "WA"
    ],
    "preo teknosa p1": [
        "29"
    ],
    "preo p3": [
        "29"
    ],
    "preo_p2": [
        "29"
    ],
    "primuxkappap501": [
        "6P"
    ],
    "primuxkappap500": [
        "6P"
    ],
    "primuxomega7": [
        "6P"
    ],
    "cavion_solid_4_5": [
        "CJ"
    ],
    "cavion base 5.0": [
        "CJ"
    ],
    "am412": [
        "AG"
    ],
    "vyper": [
        "LL"
    ],
    "glx aria": [
        "GX"
    ],
    "glx taban": [
        "GX"
    ],
    "glx shine": [
        "GX",
        "J0"
    ],
    "glx spark": [
        "GX"
    ],
    "glx asa": [
        "GX"
    ],
    "pryme 01": [
        "7H"
    ],
    "st01": [
        "7H"
    ],
    "speed55": [
        "AM"
    ],
    "sparkle v": [
        "KA"
    ],
    "seeken_sg1": [
        "24"
    ],
    "seeken-sj1": [
        "24"
    ],
    "rock_x11": [
        "E5"
    ],
    "polytron-r2507": [
        "P5"
    ],
    "sdq-55024l grey": [
        "DE"
    ],
    "sdq-52001g": [
        "DE"
    ],
    "sdq-50002g grey": [
        "DE"
    ],
    "sdq-57004l": [
        "DE"
    ],
    "sdq_52001g": [
        "DE"
    ],
    "sdq-55044l": [
        "DE"
    ],
    "secret_xr": [
        "F3"
    ],
    "s8-kc": [
        "KY"
    ],
    "dm-01k": [
        "LG"
    ],
    "wx10k": [
        "KY"
    ],
    "f-52a": [
        "FU"
    ],
    "np805sh": [
        "SH"
    ],
    "sh-m15": [
        "SH"
    ],
    "shf31": [
        "SH"
    ],
    "l-52a": [
        "LG"
    ],
    "revolution tnt3": [
        "VJ"
    ],
    "xtreme xt84": [
        "VJ"
    ],
    "xtreme xt309 plus": [
        "VJ"
    ],
    "xtreme 1": [
        "VJ"
    ],
    "xtreme_7": [
        "VJ"
    ],
    "xtreme_3": [
        "VJ"
    ],
    "xtreme_3x": [
        "VJ"
    ],
    "xylo_t": [
        "V2"
    ],
    "xtouch_a5": [
        "4X"
    ],
    "we a10": [
        "3W"
    ],
    "we a50": [
        "3W"
    ],
    "we f10": [
        "3W"
    ],
    "we f20": [
        "3W"
    ],
    "we l9": [
        "3W"
    ],
    "we r4": [
        "3W"
    ],
    "we v4": [
        "3W"
    ],
    "we l3": [
        "3W"
    ],
    "we l4": [
        "3W"
    ],
    "we r3": [
        "3W"
    ],
    "we s1": [
        "3W"
    ],
    "we x1": [
        "3W"
    ],
    "we v3": [
        "3W"
    ],
    "we b3": [
        "3W"
    ],
    "we e2": [
        "3W"
    ],
    "we l6": [
        "3W"
    ],
    "we e1": [
        "3W"
    ],
    "we t1": [
        "3W"
    ],
    "we x3": [
        "3W"
    ],
    "redmi y1 lite": [
        "XI"
    ],
    "innos_d6000": [
        "26",
        "IN"
    ],
    "innosr545": [
        "LU",
        "IN"
    ],
    "sm-g986n": [
        "SA"
    ],
    "sm-g9880": [
        "SA"
    ],
    "lm-v510n": [
        "LG"
    ],
    "lm-q927l": [
        "LG"
    ],
    "lm-q920n": [
        "LG"
    ],
    "lm-q730n": [
        "LG"
    ],
    "lm-g850": [
        "LG"
    ],
    "lm-g900": [
        "LG"
    ],
    "lm-g900n": [
        "LG"
    ],
    "lm-g910": [
        "LG"
    ],
    "lm-k200": [
        "LG"
    ],
    "lm-k300": [
        "LG"
    ],
    "lm-k420": [
        "LG"
    ],
    "lm-k500": [
        "LG"
    ],
    "lm-q510n": [
        "LG"
    ],
    "lm-q630": [
        "LG"
    ],
    "lm-q630n": [
        "LG"
    ],
    "lm-q730": [
        "LG"
    ],
    "lm-v450": [
        "LG"
    ],
    "lm-x430": [
        "LG"
    ],
    "lm-v600": [
        "LG"
    ],
    "lm-x520": [
        "LG"
    ],
    "griffe t3": [
        "C5"
    ],
    "impress_lion_3g": [
        "VX"
    ],
    "impress_lion_4g": [
        "VX"
    ],
    "impress_pear": [
        "VX"
    ],
    "impress_ra": [
        "VX"
    ],
    "intex aqua lions x1+": [
        "IX"
    ],
    "intex aqua lions x1": [
        "IX"
    ],
    "intex cloud c1": [
        "IX"
    ],
    "griffe t3pro": [
        "C5"
    ],
    "trio v51 dt": [
        "J1"
    ],
    "trt-tl10a": [
        "HU"
    ],
    "soyes xs": [
        "8S"
    ],
    "plume l4 pro": [
        "C5"
    ],
    "plume l8 pro": [
        "C5"
    ],
    "plume l6 pro": [
        "C5"
    ],
    "plume l4": [
        "C5"
    ],
    "zafiro": [
        "IP"
    ],
    "alto 5": [
        "CI"
    ],
    "alto 3": [
        "CI"
    ],
    "alto 2": [
        "CI"
    ],
    "winnovo_k56hl": [
        "W5"
    ],
    "winnovo_k54ho": [
        "W5"
    ],
    "winnovo_k43fo": [
        "W5"
    ],
    "ln9910": [
        "LV"
    ],
    "s58pro": [
        "DO"
    ],
    "smartway_t1": [
        "KK"
    ],
    "motorola one macro": [
        "MR"
    ],
    "woozei45": [
        "E2"
    ],
    "autoid9n": [
        "61"
    ],
    "bold n1": [
        "BU"
    ],
    "primux_ioxphone": [
        "6P"
    ],
    "centric cm5001": [
        "62"
    ],
    "centric-cm3321": [
        "62"
    ],
    "centric cm3331": [
        "62"
    ],
    "cg_eon_blaze_pro": [
        "G3"
    ],
    "surve10": [
        "63"
    ],
    "surve6": [
        "63"
    ],
    "surve7": [
        "63"
    ],
    "surve8": [
        "63"
    ],
    "surve1 pro": [
        "63"
    ],
    "surve2 pro": [
        "63"
    ],
    "surve2": [
        "63"
    ],
    "sveglio_h1": [
        "GH"
    ],
    "sveglio q1": [
        "GH"
    ],
    "twz y60": [
        "Z1"
    ],
    "twz y68": [
        "Z1"
    ],
    "twz a49": [
        "Z1"
    ],
    "twz a55": [
        "Z1"
    ],
    "twz-a567": [
        "Z1"
    ],
    "twz qq2": [
        "Z1"
    ],
    "twzqq1": [
        "Z1"
    ],
    "twz a95": [
        "Z1"
    ],
    "twz y52": [
        "Z1"
    ],
    "up_rave": [
        "18"
    ],
    "up sense": [
        "18"
    ],
    "elite 45t": [
        "SW"
    ],
    "elite 4t": [
        "SW"
    ],
    "elite 5t": [
        "SW"
    ],
    "elite_5_0t": [
        "SW"
    ],
    "elite_a55": [
        "SW"
    ],
    "elite_vr": [
        "0W"
    ],
    "energy e12": [
        "ED",
        "E1"
    ],
    "geotel_amigo": [
        "GE"
    ],
    "im0318nd": [
        "IX"
    ],
    "inoi_3": [
        "I4"
    ],
    "zte blade a5 2019ru": [
        "ZT"
    ],
    "inoi 5 2021": [
        "I4"
    ],
    "is2_plus": [
        "5I"
    ],
    "is2s": [
        "5I"
    ],
    "is2plus": [
        "5I"
    ],
    "iv 505": [
        "0J"
    ],
    "friendly_th101": [
        "TN"
    ],
    "forme a57": [
        "F2"
    ],
    "forme p6": [
        "F2"
    ],
    "hl5575": [
        "AD"
    ],
    "hl5667": [
        "AD"
    ],
    "hl5767": [
        "AD"
    ],
    "hl6575": [
        "AD"
    ],
    "kata-c3": [
        "K0"
    ],
    "kata-l1": [
        "K0"
    ],
    "kata-m3s": [
        "K0"
    ],
    "kata-m4": [
        "K0"
    ],
    "kata-v6": [
        "K0"
    ],
    "kata-v5": [
        "K0"
    ],
    "i5": [
        "K0"
    ],
    "kf4go": [
        "2K"
    ],
    "kf5bless": [
        "2K"
    ],
    "icherry_c223": [
        "3I"
    ],
    "icherry_c258": [
        "3I"
    ],
    "icherry_x1": [
        "3I"
    ],
    "cavion solid 4.5": [
        "CJ"
    ],
    "camfone se": [
        "BC"
    ],
    "cameleon c4": [
        "00"
    ],
    "carnival b5": [
        "O2"
    ],
    "centric cm3321plus": [
        "62"
    ],
    "cg|eon blaze gold": [
        "G3"
    ],
    "citi z560 4g cs5021ml": [
        "D2"
    ],
    "cosmos v23": [
        "HV"
    ],
    "cosmos v22": [
        "HV"
    ],
    "cosmos v21": [
        "HV"
    ],
    "cosmos v20": [
        "HV"
    ],
    "cosmos u2": [
        "HV"
    ],
    "cosmos_v19": [
        "HV"
    ],
    "cosmos_v19_plus": [
        "HV"
    ],
    "cosmos_v8_lite": [
        "HV"
    ],
    "cosmos_v5": [
        "HV"
    ],
    "cosmos_v6": [
        "HV"
    ],
    "cosmos_v9": [
        "HV"
    ],
    "onix s405": [
        "OX",
        "ZU"
    ],
    "jci va-10j": [
        "5V"
    ],
    "scv49": [
        "SA"
    ],
    "shg03": [
        "SH"
    ],
    "ftj162b": [
        "FT"
    ],
    "isw13ht": [
        "HT"
    ],
    "itel l6002p": [
        "IZ"
    ],
    "fjl22": [
        "FU"
    ],
    "j3273": [
        "SO"
    ],
    "np806sh": [
        "SH"
    ],
    "np602si": [
        "98"
    ],
    "zte ba520": [
        "ZT"
    ],
    "kyv42_u": [
        "KY"
    ],
    "f-05g": [
        "FU"
    ],
    "f-04f": [
        "FU"
    ],
    "m2010j19cg": [
        "0P"
    ],
    "bq-6430l": [
        "BX"
    ],
    "bq-5046l": [
        "BX"
    ],
    "bq-5047l": [
        "BX"
    ],
    "bq-5740g": [
        "BX"
    ],
    "5002h_ru": [
        "AL"
    ],
    "aligator s5540": [
        "4A"
    ],
    "np501sh": [
        "SH"
    ],
    "v3913": [
        "WI"
    ],
    "v503630": [
        "VD"
    ],
    "v505024": [
        "VD"
    ],
    "v505920": [
        "VD"
    ],
    "v505820": [
        "VD"
    ],
    "v505430": [
        "VD"
    ],
    "v504630": [
        "VD"
    ],
    "v406018": [
        "VD"
    ],
    "zumbo_s_2017_lite": [
        "M6"
    ],
    "zumbo_s_2017": [
        "M6"
    ],
    "zumbo s 2017 lite": [
        "M6"
    ],
    "zumbo s 2017": [
        "M6"
    ],
    "zopo_x1i": [
        "ZP"
    ],
    "ziox f9 pro": [
        "ZX"
    ],
    "l-05e": [
        "LG"
    ],
    "f-01m": [
        "FU"
    ],
    "np807sh": [
        "SH"
    ],
    "aurii_delight": [
        "F3"
    ],
    "aurii_dream_mini": [
        "F3"
    ],
    "aurii_dream_one": [
        "F3"
    ],
    "supreme_fine_micro": [
        "N3"
    ],
    "strongphoneq9": [
        "EO"
    ],
    "selfie_two": [
        "CH"
    ],
    "seatel v8e": [
        "89"
    ],
    "seatel v8a": [
        "89"
    ],
    "seatel t8": [
        "89"
    ],
    "seatel t7": [
        "89"
    ],
    "seatel r6": [
        "89"
    ],
    "seatel v8": [
        "89"
    ],
    "seatel v9": [
        "89"
    ],
    "seatel_l2": [
        "89"
    ],
    "seatel_t5": [
        "89"
    ],
    "seatel_t6": [
        "89"
    ],
    "jade8s": [
        "IP"
    ],
    "nitro_5x": [
        "MW"
    ],
    "nitro_5r": [
        "MW"
    ],
    "nitro_55r": [
        "MW"
    ],
    "nitro 5 go": [
        "MW"
    ],
    "nitro 4s lte": [
        "MW"
    ],
    "next_p_pro": [
        "5I"
    ],
    "newsday_e1": [
        "ND"
    ],
    "newsday_a2": [
        "ND"
    ],
    "newsday_a1": [
        "ND"
    ],
    "nitro 4 go": [
        "MW"
    ],
    "3gnet u8": [
        "2Q"
    ],
    "3gnet t800": [
        "2Q"
    ],
    "3gnet u6s": [
        "2Q"
    ],
    "3gnet t 900": [
        "2Q"
    ],
    "malata i5": [
        "87"
    ],
    "malata z8": [
        "87"
    ],
    "z105": [
        "87"
    ],
    "malata i10": [
        "87"
    ],
    "malata i8": [
        "87"
    ],
    "itel-it1553": [
        "IZ"
    ],
    "itel-it1410": [
        "IZ"
    ],
    "jk-760": [
        "KJ"
    ],
    "inco flex 2s": [
        "6I"
    ],
    "inco s4": [
        "6I"
    ],
    "inco bloom 2": [
        "6I",
        "WI"
    ],
    "infineum_z45": [
        "9O"
    ],
    "infineum z5": [
        "9O"
    ],
    "ifoo u200": [
        "QN"
    ],
    "ifoo h55": [
        "QN"
    ],
    "imo_s80": [
        "IL"
    ],
    "imo q": [
        "IL"
    ],
    "omega_lite_4": [
        "CH"
    ],
    "omega_hd_duo": [
        "CH"
    ],
    "omega lite 3s": [
        "CH"
    ],
    "omega icon lite 2": [
        "CH"
    ],
    "omega hd 5": [
        "CH"
    ],
    "ob_421": [
        "A5"
    ],
    "ob-728": [
        "A5"
    ],
    "ob-627": [
        "A5"
    ],
    "np-752go": [
        "NC"
    ],
    "noir x": [
        "ZM"
    ],
    "maximus d1": [
        "ZM"
    ],
    "memor 10": [
        "6D"
    ],
    "n8216": [
        "MI"
    ],
    "n8301": [
        "MI"
    ],
    "naomiphone ambar": [
        "NP"
    ],
    "a76plus": [
        "LV"
    ],
    "a75 max": [
        "E9"
    ],
    "n-57": [
        "LL"
    ],
    "n-50": [
        "LL"
    ],
    "n-45": [
        "LL"
    ],
    "n-45 light": [
        "LL"
    ],
    "lh9810": [
        "LV"
    ],
    "li22": [
        "LW"
    ],
    "sugar f7": [
        "9S"
    ],
    "sugar c9": [
        "9S"
    ],
    "sugar c7": [
        "9S"
    ],
    "subor s5": [
        "06"
    ],
    "subor 2019": [
        "06"
    ],
    "subor_k10plus": [
        "06"
    ],
    "vibe p1 turbo": [
        "LE"
    ],
    "ftj17c00": [
        "FT"
    ],
    "ftu18a00": [
        "FT"
    ],
    "ft142d": [
        "FT"
    ],
    "sol23": [
        "SO"
    ],
    "sp-5050": [
        "31"
    ],
    "titanium_moghul": [
        "KA"
    ],
    "strawberry qx15": [
        "71"
    ],
    "strawberry sx": [
        "71"
    ],
    "s8402": [
        "BT"
    ],
    "s8402l": [
        "BT"
    ],
    "s8501": [
        "BT"
    ],
    "s8501l": [
        "BT"
    ],
    "nba edition": [
        "CD"
    ],
    "navon m505 lte": [
        "N3"
    ],
    "navon f552": [
        "N3"
    ],
    "navon d504": [
        "N3"
    ],
    "gtouch_stella": [
        "G9"
    ],
    "stella xs": [
        "G9"
    ],
    "stella x": [
        "G9"
    ],
    "stellar pro": [
        "ZU"
    ],
    "stellar": [
        "ZU"
    ],
    "stellar plus": [
        "ZU"
    ],
    "stellar mini": [
        "ZU"
    ],
    "stellar m1": [
        "ZU"
    ],
    "stellar p1": [
        "ZU"
    ],
    "stella omega": [
        "G9"
    ],
    "star_mix_2": [
        "OL"
    ],
    "mx5": [
        "M1"
    ],
    "redmi_3s": [
        "XI"
    ],
    "noa_h4se": [
        "N5"
    ],
    "htc_desire_816": [
        "HT"
    ],
    "a40c": [
        "AM"
    ],
    "moto_c_plus": [
        "MR"
    ],
    "mi_5x": [
        "XI"
    ],
    "hot_6": [
        "HV"
    ],
    "hot 6": [
        "HV"
    ],
    "zplay1_2018": [
        "0Z"
    ],
    "zpower_2018": [
        "0Z"
    ],
    "zpower_plus": [
        "0Z"
    ],
    "zero18": [
        "7B"
    ],
    "vulkano": [
        "H5"
    ],
    "plume p6 pro lte": [
        "C5"
    ],
    "q infinity": [
        "QM"
    ],
    "q infinity f": [
        "QM"
    ],
    "q infinity pro": [
        "QM"
    ],
    "qmobile q infinity e lite": [
        "QM"
    ],
    "qmobile q infinity c": [
        "QM"
    ],
    "qmobile q infinity b": [
        "QM"
    ],
    "q05a": [
        "QH"
    ],
    "kempler_8_plus": [
        "KS"
    ],
    "konnect_502": [
        "DA"
    ],
    "konnect506": [
        "DA"
    ],
    "modern s10": [
        "GK"
    ],
    "modern s1": [
        "GK"
    ],
    "modern s6": [
        "GK",
        "L2"
    ],
    "modern s9": [
        "GK"
    ],
    "modern s7": [
        "GK"
    ],
    "modern_s3": [
        "GK"
    ],
    "sole_pop_s50": [
        "9L"
    ],
    "solo_aspire": [
        "JL"
    ],
    "solone sl-k40": [
        "16"
    ],
    "solone a47": [
        "16"
    ],
    "solone_elite_l5501": [
        "16"
    ],
    "solone_sumo_s5001": [
        "16"
    ],
    "sole pop s40": [
        "9L"
    ],
    "solo aspire m": [
        "JL"
    ],
    "solone_s5002": [
        "16"
    ],
    "speed-y2": [
        "00"
    ],
    "speed-x2": [
        "00"
    ],
    "speed-m2": [
        "00"
    ],
    "speed-x2+": [
        "00"
    ],
    "speed a2": [
        "00"
    ],
    "oinom v9": [
        "0O"
    ],
    "oinom_v7h": [
        "0O"
    ],
    "u feel ecom": [
        "WI"
    ],
    "u feel": [
        "WI"
    ],
    "w_c800s": [
        "WI"
    ],
    "sm-a526u": [
        "SA"
    ],
    "sm-a5360": [
        "SA"
    ],
    "sm-a536u1": [
        "SA"
    ],
    "sm-a536w": [
        "SA"
    ],
    "so-04e": [
        "SO"
    ],
    "wildfire e1 plus": [
        "HT"
    ],
    "2201116pi": [
        "0P"
    ],
    "comio c2 lite": [
        "C6"
    ],
    "pap5430": [
        "PR"
    ],
    "moto z": [
        "MR"
    ],
    "eluga u3": [
        "PA"
    ],
    "eluga ray 810": [
        "PA"
    ],
    "eluga ray 610": [
        "PA"
    ],
    "keneksi_libra_dual": [
        "K3"
    ],
    "asus_x00tdc": [
        "AU"
    ],
    "6125d_tr": [
        "TC"
    ],
    "inoi_5_pro": [
        "I4"
    ],
    "myphone agua rio": [
        "MY",
        "MY1"
    ],
    "myphone agua rio lite": [
        "MY",
        "MY1"
    ],
    "myphone agua rio fun": [
        "MY",
        "MY1"
    ],
    "myphone agua infinity": [
        "MY",
        "MY1"
    ],
    "qsmart_canopus": [
        "QM"
    ],
    "qsmart i6i 2020": [
        "QM"
    ],
    "primo em2": [
        "WA"
    ],
    "primo ef9": [
        "WA"
    ],
    "primo ef8 4g": [
        "WA"
    ],
    "primo e10": [
        "WA"
    ],
    "powermaxp490s_as": [
        "ED"
    ],
    "nova can-l11": [
        "HU"
    ],
    "hisense infinity h60 lite": [
        "HI"
    ],
    "hisense infinity h60 5g": [
        "HI"
    ],
    "hisense infinity h50s 5g": [
        "HI"
    ],
    "trekker-x2": [
        "C1"
    ],
    "symphony z9": [
        "SM"
    ],
    "spice v801": [
        "SP"
    ],
    "htc wildfire x": [
        "HT"
    ],
    "symphony r100": [
        "SM"
    ],
    "primo ef7": [
        "WA"
    ],
    "primo e8s": [
        "WA"
    ],
    "primo e8+": [
        "WA"
    ],
    "polytron r2509": [
        "P5"
    ],
    "vertu ti": [
        "VE"
    ],
    "armor x10 pro": [
        "UL"
    ],
    "hisense e31 lite": [
        "HI"
    ],
    "asus_x009dd": [
        "AU"
    ],
    "impress_bear": [
        "VX"
    ],
    "impress_vega": [
        "VX"
    ],
    "halo 4 lte": [
        "I5"
    ],
    "sm-g955w": [
        "SA"
    ],
    "symphony_z12": [
        "SM"
    ],
    "symphony z50": [
        "SM"
    ],
    "tecno-w5": [
        "TB"
    ],
    "haier_i50": [
        "HA"
    ],
    "haier_al40": [
        "HA"
    ],
    "tecno-w3": [
        "TB"
    ],
    "bv4000": [
        "B2"
    ],
    "bv4000pro-ru": [
        "B2"
    ],
    "impress_funk": [
        "VX"
    ],
    "impress_stone": [
        "VX"
    ],
    "inoi_6i": [
        "I4"
    ],
    "infinix x624b": [
        "IF"
    ],
    "infinix x609b": [
        "IF"
    ],
    "infinix x606d": [
        "IF"
    ],
    "infinix x606b": [
        "IF"
    ],
    "infinix x559c": [
        "IF"
    ],
    "infinix x5514d": [
        "IF"
    ],
    "im-a910s": [
        "PT"
    ],
    "im-a910l": [
        "PT"
    ],
    "im-a910k": [
        "PT"
    ],
    "oinom_v7": [
        "0O"
    ],
    "oinom_v9d": [
        "0O"
    ],
    "oinom_v6": [
        "0O"
    ],
    "sapphire_h7": [
        "52"
    ],
    "singtech_q2": [
        "52"
    ],
    "singtech s1": [
        "52"
    ],
    "siragon sp-5150": [
        "31"
    ],
    "sapphire h50s": [
        "52"
    ],
    "sapphire h7s": [
        "52"
    ],
    "sapphire h90": [
        "52"
    ],
    "super sweet": [
        "F3"
    ],
    "sweet mini": [
        "F3"
    ],
    "studio_g_hd": [
        "BU"
    ],
    "starxtrem5": [
        "SX"
    ],
    "starxtrem 6": [
        "SX"
    ],
    "starxtrem ii": [
        "SX"
    ],
    "starxtrem 4": [
        "SX"
    ],
    "starxtrem3": [
        "SX"
    ],
    "starmobile play click": [
        "18"
    ],
    "starlight_rome_x": [
        "OL"
    ],
    "ssr3-1-51-5m": [
        "13"
    ],
    "ssd-1-53-13m": [
        "13"
    ],
    "ssb408d": [
        "YM"
    ],
    "ssb-508d": [
        "JT"
    ],
    "ssb-508": [
        "YM"
    ],
    "sico_plus2": [
        "13"
    ],
    "ss4g9 mira": [
        "5Y"
    ],
    "ss4g7 sole": [
        "5Y"
    ],
    "ss4g1 luna": [
        "5Y",
        "69"
    ],
    "ss4g8 nora": [
        "5Y"
    ],
    "ss4g6 lola": [
        "5Y"
    ],
    "si51": [
        "7I"
    ],
    "si52": [
        "7I"
    ],
    "via_a1_plus_64": [
        "R4"
    ],
    "vibe s3i": [
        "LE"
    ],
    "vibe s5i": [
        "LE"
    ],
    "vibe s6i": [
        "LE"
    ],
    "vibe s6i plus": [
        "LE"
    ],
    "vibe s7i": [
        "LE"
    ],
    "vibe_s2i": [
        "LE"
    ],
    "vibe v7": [
        "LE"
    ],
    "teeno_s9": [
        "91"
    ],
    "teeno_a1": [
        "91"
    ],
    "teeno s11": [
        "91"
    ],
    "vmobile j7": [
        "JM"
    ],
    "vmobile xs pro": [
        "JM"
    ],
    "nitro_4s": [
        "MW"
    ],
    "slay ii": [
        "SB"
    ],
    "titanium s5": [
        "KA"
    ],
    "evercoss a5z": [
        "E9"
    ],
    "aspera r5h": [
        "AQ"
    ],
    "aspera rt3": [
        "AQ"
    ],
    "aspera a40": [
        "AQ"
    ],
    "aspera a42": [
        "AQ"
    ],
    "aspera a50": [
        "AQ"
    ],
    "wren": [
        "AQ"
    ],
    "platinum 4.0": [
        "SW"
    ],
    "platinum 5.0+": [
        "SW"
    ],
    "v769m": [
        "ZT"
    ],
    "astro_x4": [
        "MW"
    ],
    "alfa a114 quad": [
        "KA"
    ],
    "visiontouchlife": [
        "9V"
    ],
    "vision touch inspire": [
        "9V"
    ],
    "z836f": [
        "ZT"
    ],
    "a50_style_plus": [
        "AM"
    ],
    "eg98": [
        "HI"
    ],
    "inco plain2 s": [
        "6I"
    ],
    "alba 4": [
        "1A"
    ],
    "aura power 4g plus": [
        "KA"
    ],
    "a97 2gb plus": [
        "LV"
    ],
    "a576cc": [
        "AL"
    ],
    "tank xtreme 4.0": [
        "BU"
    ],
    "pure xr": [
        "BU"
    ],
    "pure mini": [
        "BU"
    ],
    "smart_volt_nx5": [
        "JN"
    ],
    "smart plus lte": [
        "OW"
    ],
    "wink city s": [
        "WN"
    ],
    "wink_glory": [
        "WN"
    ],
    "wink_world_se": [
        "WN"
    ],
    "wink_share_se": [
        "WN"
    ],
    "wink_glory_se": [
        "WN"
    ],
    "andi wink 4g": [
        "IB",
        "WN"
    ],
    "andi 5g blink 4g": [
        "IB",
        "4M"
    ],
    "amosta3g5": [
        "FR"
    ],
    "amaze_s2_4g": [
        "H8"
    ],
    "amaze s6 4g": [
        "H8"
    ],
    "amaze s5 plus": [
        "H8"
    ],
    "amaze s5": [
        "H8"
    ],
    "amaze s6 plus": [
        "H8"
    ],
    "hitech amaze s1": [
        "H8"
    ],
    "amaze s5 4g": [
        "H8"
    ],
    "amaze_s6": [
        "H8"
    ],
    "z45_amaze": [
        "VD"
    ],
    "z45_dazzle": [
        "VD"
    ],
    "z45q star": [
        "VD"
    ],
    "z50 nova": [
        "VD"
    ],
    "sm-a022g": [
        "SA"
    ],
    "sm-a525f": [
        "SA"
    ],
    "sm-a325f": [
        "SA"
    ],
    "sm-a725f": [
        "SA"
    ],
    "sm-m205fn": [
        "SA"
    ],
    "samsung sm-g996u": [
        "SA"
    ],
    "ppa-lx1": [
        "HU"
    ],
    "a80plus": [
        "B2"
    ],
    "v2036": [
        "VV"
    ],
    "bison2021": [
        "5F"
    ],
    "rmx3201": [
        "RE"
    ],
    "kingkong mini2": [
        "CB"
    ],
    "m2010j19sg": [
        "XI"
    ],
    "m2007j17g": [
        "XI"
    ],
    "m2007j3si": [
        "XI"
    ],
    "pdsm00": [
        "OP"
    ],
    "note 20 pro": [
        "CB"
    ],
    "poco m3": [
        "0P"
    ],
    "rmx2103": [
        "RE"
    ],
    "bv5100": [
        "B2"
    ],
    "a60plus": [
        "B2"
    ],
    "m2007j20ci": [
        "0P"
    ],
    "s96pro": [
        "DO"
    ],
    "s88pro": [
        "DO"
    ],
    "s59pro": [
        "DO"
    ],
    "s40pro": [
        "DO"
    ],
    "m2006c3mi": [
        "0P"
    ],
    "bl6000pro": [
        "B2"
    ],
    "be2029": [
        "ON"
    ],
    "bq-6630l": [
        "BX"
    ],
    "v2026": [
        "VV"
    ],
    "x95pro": [
        "DO"
    ],
    "4087u_ru": [
        "AL"
    ],
    "archos oxygen 57": [
        "AR"
    ],
    "archos oxygen 68xl": [
        "AR"
    ],
    "archos sense 50x": [
        "AR"
    ],
    "m2101k9ag": [
        "XI"
    ],
    "t782h": [
        "TC"
    ],
    "5030e": [
        "AL"
    ],
    "hlte230e": [
        "HI"
    ],
    "t766h_eea": [
        "TC"
    ],
    "u705ac": [
        "CK"
    ],
    "u705aa": [
        "6A"
    ],
    "lgl722dl": [
        "LG"
    ],
    "be2013": [
        "ON"
    ],
    "be2015": [
        "ON"
    ],
    "be2011": [
        "ON"
    ],
    "kb2005": [
        "ON"
    ],
    "in2019": [
        "ON"
    ],
    "gm1925": [
        "ON"
    ],
    "motorola one 5g uw": [
        "MR"
    ],
    "e7110": [
        "KY"
    ],
    "moto z4": [
        "MR"
    ],
    "lm-k520": [
        "LG"
    ],
    "moto e6": [
        "MR"
    ],
    "moto g power (xt2041dl)": [
        "MR"
    ],
    "moto e5 go": [
        "MR"
    ],
    "verykools5005": [
        "VL"
    ],
    "kylin40": [
        "IP"
    ],
    "ilium m9s": [
        "LA"
    ],
    "t766a": [
        "TC"
    ],
    "pspck20na": [
        "PL"
    ],
    "ilium m5s": [
        "LA"
    ],
    "ilium m7s": [
        "LA"
    ],
    "psptd21na": [
        "PL"
    ],
    "roni": [
        "ZU"
    ],
    "hyundai_eternity_g57l": [
        "HN"
    ],
    "moto g(8) power lite": [
        "MR"
    ],
    "t790y": [
        "TC"
    ],
    "alpha rage": [
        "H2"
    ],
    "tecno cc6": [
        "TB"
    ],
    "tecno cf7": [
        "TB"
    ],
    "tecno bb4k": [
        "TB"
    ],
    "tecno cc7": [
        "TB"
    ],
    "tecno kd7": [
        "TB"
    ],
    "tecno kc8": [
        "TB"
    ],
    "meizu m8": [
        "M1"
    ],
    "vergem": [
        "H2"
    ],
    "c8": [
        "OE",
        "OK"
    ],
    "c8 4g": [
        "OE",
        "OK"
    ],
    "bqru_bqru-5058": [
        "BX"
    ],
    "luck": [
        "VX"
    ],
    "life geo": [
        "FL"
    ],
    "k8000": [
        "OE"
    ],
    "pulsar": [
        "EX"
    ],
    "torex s18": [
        "7T"
    ],
    "rmx3063": [
        "RE"
    ],
    "rmx2163": [
        "RE"
    ],
    "bmm441w": [
        "BF"
    ],
    "rm-1118": [
        "MS"
    ],
    "m2010j19si": [
        "XI"
    ],
    "m2010j19ci": [
        "0P"
    ],
    "logic l61": [
        "1L"
    ],
    "ebg-tn00": [
        "HU"
    ],
    "note 8p": [
        "UL"
    ],
    "n20pro": [
        "DO"
    ],
    "bq-5745l": [
        "BX"
    ],
    "bq-6631g": [
        "BX"
    ],
    "bq-5533g": [
        "BX"
    ],
    "bq-5031g": [
        "BX"
    ],
    "bmm441b": [
        "BF"
    ],
    "bl160": [
        "DX"
    ],
    "a340": [
        "DX"
    ],
    "a10_max": [
        "A2"
    ],
    "itel w6001": [
        "IZ"
    ],
    "itel a14ru": [
        "IZ"
    ],
    "itel a16 plus ru": [
        "IZ"
    ],
    "itel a44 powerru": [
        "IZ"
    ],
    "itel l5002": [
        "IZ"
    ],
    "itel l5503": [
        "IZ"
    ],
    "itel l6004": [
        "IZ"
    ],
    "itel w6003": [
        "IZ"
    ],
    "itel a23s": [
        "IZ"
    ],
    "itel w6002": [
        "IZ"
    ],
    "itel a52 lite": [
        "IZ"
    ],
    "itel l6005": [
        "IZ"
    ],
    "itel s12": [
        "IZ"
    ],
    "itel w6002e": [
        "IZ"
    ],
    "itel l6501": [
        "IZ"
    ],
    "itel l6502": [
        "IZ"
    ],
    "itel w5505": [
        "IZ"
    ],
    "itel l5502": [
        "IZ"
    ],
    "itel l5505": [
        "IZ"
    ],
    "itel l6006": [
        "IZ"
    ],
    "itel l6003p": [
        "IZ"
    ],
    "itel w6004p": [
        "IZ"
    ],
    "gionee a1": [
        "GI"
    ],
    "gionee f9": [
        "GI"
    ],
    "gionee s11 lite": [
        "GI"
    ],
    "m2012k11ag": [
        "0P"
    ],
    "m2011k2c": [
        "XI"
    ],
    "m2007j3sp": [
        "XI"
    ],
    "le2123": [
        "ON"
    ],
    "le2120": [
        "ON"
    ],
    "kb2007": [
        "ON"
    ],
    "asus_i005da": [
        "AU"
    ],
    "m2102j20sg": [
        "0P"
    ],
    "rmx3031": [
        "RE"
    ],
    "m2012k11c": [
        "XI"
    ],
    "xq-as62": [
        "SO"
    ],
    "v2054a": [
        "VV"
    ],
    "v2049a": [
        "VV"
    ],
    "t799h": [
        "TC"
    ],
    "rmx3081": [
        "RE"
    ],
    "rmx2151": [
        "RE"
    ],
    "rmx2117": [
        "RE"
    ],
    "t671h": [
        "TC"
    ],
    "poco x3": [
        "0P"
    ],
    "v2028": [
        "VV"
    ],
    "ang-an00": [
        "HU"
    ],
    "artel t10": [
        "40"
    ],
    "b130dl": [
        "BU"
    ],
    "cubot j9": [
        "CB"
    ],
    "poco m2 pro": [
        "0P"
    ],
    "blu dash m2": [
        "BU",
        "M1"
    ],
    "ravoz_z6": [
        "R9"
    ],
    "lmx130im": [
        "LG"
    ],
    "rmx2195": [
        "RE"
    ],
    "rmx2193": [
        "RE"
    ],
    "rmx2101": [
        "RE"
    ],
    "rmx2081": [
        "RE"
    ],
    "rmx2050": [
        "RE"
    ],
    "ravoz z5 pro": [
        "R9"
    ],
    "ravoz z5": [
        "R9"
    ],
    "ravoz z5 lite": [
        "R9"
    ],
    "m2006c3lii": [
        "XI"
    ],
    "m2007j17i": [
        "XI"
    ],
    "m2007j20ct": [
        "0P"
    ],
    "5062z": [
        "TM"
    ],
    "5062w": [
        "TM"
    ],
    "5007z": [
        "TM"
    ],
    "5007w": [
        "TM"
    ],
    "cdy-nx9b": [
        "HU"
    ],
    "i1927": [
        "VV"
    ],
    "titanium_s9plus": [
        "KA"
    ],
    "x1_light_lte": [
        "3G"
    ],
    "mito_a35": [
        "8M"
    ],
    "mi_4i": [
        "XI"
    ],
    "nop-an00": [
        "HU"
    ],
    "tecno ke5j": [
        "TB"
    ],
    "rmx2161": [
        "RE"
    ],
    "rmx2144": [
        "RE"
    ],
    "m685y4": [
        "Y2"
    ],
    "mobiistar c2": [
        "M6"
    ],
    "mobiistar c1": [
        "M6"
    ],
    "mobiistar c1 shine": [
        "M6",
        "J0"
    ],
    "mobiistar e1": [
        "M6"
    ],
    "lg-h873": [
        "LG"
    ],
    "lg-h933": [
        "LG"
    ],
    "lg-h932pr": [
        "LG"
    ],
    "lg-ls998": [
        "LG"
    ],
    "lg-us998": [
        "LG"
    ],
    "lg-as998": [
        "LG"
    ],
    "lg-h930": [
        "LG"
    ],
    "lg-h931": [
        "LG"
    ],
    "lg-h932": [
        "LG"
    ],
    "lgm-v300k": [
        "LG"
    ],
    "lgm-v300l": [
        "LG"
    ],
    "lgm-v300s": [
        "LG"
    ],
    "lgv35": [
        "LG"
    ],
    "lt950": [
        "QM"
    ],
    "liv1": [
        "YE"
    ],
    "zenfone max pro m2": [
        "AU",
        "M1"
    ],
    "koobee f2": [
        "KB"
    ],
    "kyg01": [
        "KY"
    ],
    "kyf40": [
        "KY"
    ],
    "lg-h868": [
        "LG"
    ],
    "lt-note 10s": [
        "QL"
    ],
    "logic_x60_plus": [
        "1L"
    ],
    "lt700 pro": [
        "QM"
    ],
    "asus_z01mda": [
        "AU"
    ],
    "asus_x009d": [
        "AU"
    ],
    "asus_x008d": [
        "AU"
    ],
    "padfone t00c": [
        "AU"
    ],
    "padfone t008": [
        "AU"
    ],
    "vivo 5 mini": [
        "BU",
        "VV"
    ],
    "zte 2050ru": [
        "ZT"
    ],
    "mi 4w": [
        "XI"
    ],
    "mi mix 2s": [
        "XI"
    ],
    "president_gold_9": [
        "0G"
    ],
    "president_gold_10": [
        "0G"
    ],
    "hlk-l42": [
        "HU"
    ],
    "hot pro 2": [
        "QM"
    ],
    "heyou30": [
        "E2"
    ],
    "asus_z00ld": [
        "AU"
    ],
    "v512930": [
        "VD"
    ],
    "f103 pro": [
        "GI"
    ],
    "m2011k2g": [
        "XI"
    ],
    "pro 7-s": [
        "M1"
    ],
    "pro 7 plus": [
        "M1"
    ],
    "pro 7": [
        "M1"
    ],
    "e500a": [
        "6T"
    ],
    "cool55": [
        "KW"
    ],
    "curvy c50l": [
        "8I"
    ],
    "kingzone_n5": [
        "KF"
    ],
    "isprit u50": [
        "VN"
    ],
    "isprit-u50-lte": [
        "VN"
    ],
    "ixiones250": [
        "DX"
    ],
    "iuni n1": [
        "3U"
    ],
    "helios": [
        "K3"
    ],
    "irs002-16": [
        "5I"
    ],
    "easy62": [
        "KW"
    ],
    "one mini 2": [
        "HT"
    ],
    "ath-cl00": [
        "HU"
    ],
    "myleagoo e4": [
        "L5"
    ],
    "oukitel c2": [
        "OE",
        "OK"
    ],
    "oukitel u10": [
        "OE",
        "OK"
    ],
    "oukitel u2": [
        "OE",
        "OK"
    ],
    "oysters_pacificv": [
        "OY"
    ],
    "duopix f9": [
        "ZX"
    ],
    "e2 noir": [
        "QM"
    ],
    "cm4331": [
        "62"
    ],
    "era 2v": [
        "XO"
    ],
    "if9002": [
        "I0"
    ],
    "if9003": [
        "I0"
    ],
    "if9029": [
        "I0"
    ],
    "easysmartm3": [
        "0F"
    ],
    "easysmart m2": [
        "0F",
        "M1"
    ],
    "eros 4g": [
        "72"
    ],
    "es750": [
        "DX"
    ],
    "energy phone pro 3": [
        "E1"
    ],
    "zs670ks": [
        "AU"
    ],
    "zs671ks": [
        "AU"
    ],
    "flow_5": [
        "KE"
    ],
    "flow 5plus": [
        "KE"
    ],
    "fan-m300h": [
        "FB"
    ],
    "fun_18x9": [
        "MY1"
    ],
    "fun_s20": [
        "V5"
    ],
    "flare hd 3": [
        "CH"
    ],
    "mi_a2_lite": [
        "XI"
    ],
    "dub-al00a": [
        "HU"
    ],
    "mi_8_lite": [
        "XI"
    ],
    "quantum2 500": [
        "GC"
    ],
    "quest 410": [
        "QO"
    ],
    "quest408": [
        "QO"
    ],
    "quest509": [
        "QO"
    ],
    "s-tell_m480": [
        "8L"
    ],
    "s-tell m461": [
        "8L"
    ],
    "gl255": [
        "DX"
    ],
    "yu5551": [
        "Y1"
    ],
    "quattro l55 hd": [
        "KA"
    ],
    "torex-s27": [
        "7T"
    ],
    "yuho_o2": [
        "Y0"
    ],
    "yuho_o2_pro": [
        "Y0"
    ],
    "yuho_vast": [
        "Y0"
    ],
    "yuho_vast2": [
        "Y0"
    ],
    "yuho_vast_plus": [
        "Y0"
    ],
    "yuho_y1_ace": [
        "Y0"
    ],
    "yuho_y1_pro": [
        "Y0"
    ],
    "yuho_y1_star": [
        "Y0"
    ],
    "yuho_y3_pro": [
        "Y0"
    ],
    "yuho_y2_pro": [
        "Y0"
    ],
    "yuho_y2": [
        "Y0"
    ],
    "yuho_o1_lite": [
        "Y0"
    ],
    "yuho_o1": [
        "Y0"
    ],
    "yuho_h2_pro": [
        "Y0"
    ],
    "z8plus": [
        "2F"
    ],
    "z8pocket": [
        "2F"
    ],
    "v2057a": [
        "VV"
    ],
    "v2046a": [
        "VV"
    ],
    "v2031ea": [
        "VV"
    ],
    "v2031a": [
        "VV"
    ],
    "v2034a": [
        "VV"
    ],
    "v2036a": [
        "VV"
    ],
    "ala-an70": [
        "HU"
    ],
    "ask-al20": [
        "HU"
    ],
    "pecm30": [
        "OP"
    ],
    "pect30": [
        "OP"
    ],
    "pefm00": [
        "OP"
    ],
    "perm00": [
        "OP"
    ],
    "pegt00": [
        "OP"
    ],
    "pegm10": [
        "OP"
    ],
    "pegt10": [
        "OP"
    ],
    "pehm00": [
        "OP"
    ],
    "peht00": [
        "OP"
    ],
    "pemm00": [
        "OP"
    ],
    "pemt00": [
        "OP"
    ],
    "pemm20": [
        "OP"
    ],
    "mxw-tn00": [
        "HU"
    ],
    "rmx2173": [
        "RE"
    ],
    "rmx2201": [
        "RE"
    ],
    "rmx3092": [
        "RE"
    ],
    "rmx3121": [
        "RE"
    ],
    "rmx3041": [
        "RE"
    ],
    "v2061a": [
        "VV"
    ],
    "v2065a": [
        "VV"
    ],
    "v2099a": [
        "VV"
    ],
    "v2047a": [
        "VV"
    ],
    "v2048a": [
        "VV"
    ],
    "v2055a": [
        "VV"
    ],
    "v2056a": [
        "VV"
    ],
    "v2066ba": [
        "VV"
    ],
    "v2066a": [
        "VV"
    ],
    "v2068a": [
        "VV"
    ],
    "v2072a": [
        "VV"
    ],
    "v2073a": [
        "VV"
    ],
    "pcrt01": [
        "OP"
    ],
    "pdym10": [
        "OP"
    ],
    "pdyt10": [
        "OP"
    ],
    "pdrm00": [
        "OP"
    ],
    "pdrt00": [
        "OP"
    ],
    "pdst00": [
        "OP"
    ],
    "pedm00": [
        "OP"
    ],
    "yok-an10": [
        "HU"
    ],
    "dt1902a": [
        "S7"
    ],
    "m2012k11ac": [
        "XI"
    ],
    "v2080a": [
        "VV"
    ],
    "20190325d": [
        "XL"
    ],
    "20190718q": [
        "XL"
    ],
    "rmx3093": [
        "RE"
    ],
    "peem00": [
        "OP"
    ],
    "m2102j2sc": [
        "XI"
    ],
    "u318aa": [
        "6A"
    ],
    "r15_pro": [
        "CB"
    ],
    "b355": [
        "DX"
    ],
    "t155": [
        "DX"
    ],
    "xl150": [
        "DX"
    ],
    "pacifice": [
        "OY"
    ],
    "z6410s": [
        "ZT"
    ],
    "z6400c": [
        "ZT"
    ],
    "z610dl": [
        "ZT"
    ],
    "z60s": [
        "LV"
    ],
    "z5151v": [
        "ZT"
    ],
    "z455": [
        "DX"
    ],
    "z355": [
        "DX"
    ],
    "venturev10": [
        "V6"
    ],
    "venus_g": [
        "4M"
    ],
    "versity 9640": [
        "43"
    ],
    "via_a3_plus": [
        "R4"
    ],
    "via_g3": [
        "R4"
    ],
    "view2 plus": [
        "WI"
    ],
    "beeline e600": [
        "B5"
    ],
    "beeline_smart_6": [
        "B5"
    ],
    "bihee a18": [
        "B8"
    ],
    "bihee a16": [
        "B8"
    ],
    "be_xl": [
        "UB"
    ],
    "be_se": [
        "UB"
    ],
    "be_o2": [
        "UB"
    ],
    "be_fr": [
        "UB"
    ],
    "be_et": [
        "UB"
    ],
    "be_dg": [
        "UB"
    ],
    "moto e(7) plus": [
        "MR"
    ],
    "moto e(7)": [
        "MR"
    ],
    "moto g(9) power": [
        "MR"
    ],
    "moto z (2": [
        "MR"
    ],
    "m2006c3mt": [
        "XI"
    ],
    "c5l 2020": [
        "BU"
    ],
    "bv6600": [
        "B2"
    ],
    "pegm00": [
        "OP"
    ],
    "rmx2202": [
        "RE"
    ],
    "rmx3085": [
        "RE"
    ],
    "v2041": [
        "VV"
    ],
    "m7_eea": [
        "VR"
    ],
    "b350": [
        "DX"
    ],
    "g250": [
        "DX"
    ],
    "g155": [
        "DX"
    ],
    "g150": [
        "DX"
    ],
    "brown 1": [
        "MY"
    ],
    "bl155": [
        "DX"
    ],
    "a160": [
        "DX"
    ],
    "pixel v2+": [
        "LV"
    ],
    "infinity_k": [
        "T2"
    ],
    "mito_a37_z1": [
        "8M"
    ],
    "lt note 10m": [
        "QL"
    ],
    "stg x1": [
        "GQ"
    ],
    "stg a1": [
        "GQ"
    ],
    "stg a1 pro": [
        "GQ"
    ],
    "stg s1": [
        "GQ"
    ],
    "stg x3": [
        "GQ"
    ],
    "stg x2": [
        "GQ"
    ],
    "stg s10": [
        "GQ"
    ],
    "stg s30": [
        "GQ"
    ],
    "stg s20": [
        "GQ"
    ],
    "stg a2 pro": [
        "GQ"
    ],
    "stg_b10": [
        "GQ"
    ],
    "cloudfone next": [
        "CD"
    ],
    "tecno kc2j": [
        "TB"
    ],
    "tecno ab7": [
        "TB"
    ],
    "tecno lc6a": [
        "TB"
    ],
    "tecno lb8a": [
        "TB"
    ],
    "tecno kc3": [
        "TB"
    ],
    "tecno kc6": [
        "TB"
    ],
    "tecno kc2": [
        "TB"
    ],
    "tecno sa7s": [
        "TB"
    ],
    "lm-k410": [
        "LG"
    ],
    "dm-02h": [
        "LG"
    ],
    "vs810pp": [
        "LG"
    ],
    "vs425": [
        "LG"
    ],
    "dvc-an20": [
        "HU"
    ],
    "w-k380-tvm": [
        "WI"
    ],
    "w-k560-eea": [
        "WI"
    ],
    "w-v730-tvm": [
        "WI"
    ],
    "w-v830-ope": [
        "WI"
    ],
    "phicomm clue c230": [
        "1P"
    ],
    "302hw": [
        "HU"
    ],
    "2gbstar": [
        "CE"
    ],
    "2gbxpress": [
        "CE"
    ],
    "cliq2": [
        "CE"
    ],
    "aqua star 4g": [
        "IX"
    ],
    "campus prime": [
        "CE"
    ],
    "astro-s451": [
        "1U"
    ],
    "astro s501": [
        "1U",
        "OB"
    ],
    "astro 5s": [
        "MW"
    ],
    "astro x55": [
        "MW"
    ],
    "woxter_q27": [
        "WX"
    ],
    "woxter_zielo_z800": [
        "WX"
    ],
    "woxter_zielo_z420": [
        "WX"
    ],
    "uniq": [
        "CE",
        "ZU"
    ],
    "lg-d405": [
        "LG"
    ],
    "16m4hi105024": [
        "1F"
    ],
    "fmt-nm7058-02": [
        "1F"
    ],
    "176hs1050531": [
        "1F"
    ],
    "176hs1050232": [
        "1F"
    ],
    "175hs1050231": [
        "1F"
    ],
    "175ft1050241": [
        "1F"
    ],
    "tecno kf6n": [
        "TB"
    ],
    "tecno cg8": [
        "TB"
    ],
    "tecno cg7n": [
        "TB"
    ],
    "hisense infinity h40 lite": [
        "HI"
    ],
    "zte blade v0710": [
        "ZT"
    ],
    "mione p2+": [
        "X7",
        "MO"
    ],
    "qin 1s+": [
        "XI"
    ],
    "sc51aa": [
        "SA"
    ],
    "scg08": [
        "SA"
    ],
    "scg09": [
        "SA"
    ],
    "scg10": [
        "SA"
    ],
    "a004sh": [
        "SH"
    ],
    "a003sh": [
        "SH"
    ],
    "shf32": [
        "SH"
    ],
    "sh-m17": [
        "SH"
    ],
    "g8188": [
        "SO"
    ],
    "8298-a01": [
        "CO"
    ],
    "is05": [
        "SH"
    ],
    "sbm102sh2": [
        "SH"
    ],
    "scv43-u": [
        "SA"
    ],
    "scv46-u": [
        "SA"
    ],
    "scv43-j": [
        "SA"
    ],
    "a101so": [
        "SO"
    ],
    "m2102k1g": [
        "XI"
    ],
    "scv46-j": [
        "SA"
    ],
    "dm-01h": [
        "SH"
    ],
    "xiaomi_mdt2": [
        "XI"
    ],
    "sh-01fdq": [
        "SH"
    ],
    "kyv32": [
        "KY"
    ],
    "rune ii": [
        "BY"
    ],
    "rune iii": [
        "BY"
    ],
    "runbop1-tt": [
        "RU"
    ],
    "runboh1": [
        "RU"
    ],
    "rq regal r8": [
        "RQ"
    ],
    "royal r8": [
        "32"
    ],
    "royal r7": [
        "32"
    ],
    "royal r6": [
        "32"
    ],
    "royal r5": [
        "32"
    ],
    "royal r4": [
        "32"
    ],
    "royal r3": [
        "32"
    ],
    "royal r2": [
        "32"
    ],
    "royal r1": [
        "32"
    ],
    "rook from ee": [
        "E6"
    ],
    "revo_youplus": [
        "RP"
    ],
    "revoyou": [
        "RP"
    ],
    "revo 555": [
        "RP"
    ],
    "ramos r10": [
        "RA"
    ],
    "ramos r9": [
        "RA"
    ],
    "ramos mos1max": [
        "RA"
    ],
    "ramos m7": [
        "RA"
    ],
    "quattro_l50_hd": [
        "KA"
    ],
    "quattro l45 ips": [
        "KA"
    ],
    "quattro l52 vr": [
        "KA"
    ],
    "qphone 5.2": [
        "QB"
    ],
    "q-titano bos": [
        "QA"
    ],
    "q-titano x": [
        "QA"
    ],
    "q-titano m1": [
        "QA"
    ],
    "q-titano_007i": [
        "QA"
    ],
    "q-titano h1": [
        "QA"
    ],
    "q-titano-h2": [
        "QA"
    ],
    "q-titano ak47": [
        "QA"
    ],
    "president gpower 1": [
        "0G"
    ],
    "platinum 6.0+": [
        "SW"
    ],
    "platinum 5.5+": [
        "SW"
    ],
    "platinum 6.0": [
        "SW"
    ],
    "point x450": [
        "V5"
    ],
    "pacificvs": [
        "OY"
    ],
    "pacificv": [
        "OY"
    ],
    "pacific4g": [
        "OY"
    ],
    "pra557": [
        "SS"
    ],
    "pra507": [
        "SS"
    ],
    "picophone_l1": [
        "XA"
    ],
    "picophone_m4n": [
        "XA"
    ],
    "picophone_m4p_m3": [
        "XA"
    ],
    "picophone_m4u_m2_m": [
        "XA"
    ],
    "picophone_m2(m)": [
        "XA"
    ],
    "phantom pz 20": [
        "6R"
    ],
    "phantom pz25": [
        "6R"
    ],
    "phantom pz35": [
        "6R"
    ],
    "phantom pz4": [
        "6R"
    ],
    "phantom rx298": [
        "6R"
    ],
    "rivo rhythm rx50": [
        "6R"
    ],
    "rhythm rx 10": [
        "6R"
    ],
    "rhythm rx180": [
        "6R"
    ],
    "rhythm rx280": [
        "6R"
    ],
    "rhythm rx400": [
        "6R"
    ],
    "rhythm rx90": [
        "6R"
    ],
    "rhythm rx45": [
        "6R"
    ],
    "rhythm rx100": [
        "6R"
    ],
    "rhythm rx150": [
        "6R"
    ],
    "rhythm rx65": [
        "6R"
    ],
    "rhythm rx60": [
        "6R"
    ],
    "rhythm rx70": [
        "6R"
    ],
    "rhythm rx75": [
        "6R"
    ],
    "rhythm rx80": [
        "6R"
    ],
    "phantom rx387": [
        "6R"
    ],
    "phantom pz15": [
        "6R"
    ],
    "phantom pz18": [
        "6R"
    ],
    "mito a38": [
        "8M"
    ],
    "mito_a80": [
        "8M"
    ],
    "medion p5004": [
        "MD"
    ],
    "medion p5005": [
        "MD"
    ],
    "medion x6001": [
        "MD"
    ],
    "melrose s9": [
        "0E"
    ],
    "melrose s9+": [
        "0E"
    ],
    "melrose s9p": [
        "0E"
    ],
    "ms50_4g": [
        "1R"
    ],
    "ms50m": [
        "1R"
    ],
    "msp4507": [
        "MA"
    ],
    "msp4509": [
        "MA"
    ],
    "msp94501": [
        "MA"
    ],
    "msp95009": [
        "MA"
    ],
    "msp96002": [
        "MA"
    ],
    "mtech ace9": [
        "72"
    ],
    "four s600": [
        "44"
    ],
    "fours300i": [
        "44"
    ],
    "four_s185": [
        "44"
    ],
    "four_k500": [
        "44"
    ],
    "four_s61": [
        "44"
    ],
    "joy 2+": [
        "VH"
    ],
    "jer-an20": [
        "HU"
    ],
    "joy 3+": [
        "VH"
    ],
    "joy 3": [
        "VH"
    ],
    "joy 4": [
        "VH"
    ],
    "jelly2": [
        "UZ"
    ],
    "cdy-an20": [
        "HU"
    ],
    "uzbekistan": [
        "3Z"
    ],
    "krez sl502": [
        "5K"
    ],
    "jinga_basco_l1": [
        "JG"
    ],
    "kuriophone": [
        "6K"
    ],
    "dns s4704": [
        "DN"
    ],
    "inco_flex": [
        "6I"
    ],
    "inco_bloom": [
        "6I"
    ],
    "inco_colors": [
        "6I"
    ],
    "zteu819": [
        "ZT"
    ],
    "utime g7": [
        "6U"
    ],
    "utime_u100": [
        "6U"
    ],
    "utime x1": [
        "6U"
    ],
    "utime fx": [
        "6U"
    ],
    "utime_t1": [
        "6U"
    ],
    "ice2": [
        "H2"
    ],
    "hammer_force": [
        "HAM"
    ],
    "wp12": [
        "OE"
    ],
    "oneplus 8": [
        "ON"
    ],
    "6025h": [
        "AL"
    ],
    "zopo one y": [
        "ZP"
    ],
    "zopo one x": [
        "ZP"
    ],
    "zopo one t": [
        "ZP"
    ],
    "zopo one p": [
        "ZP"
    ],
    "mega plus3": [
        "LJ"
    ],
    "mega plus2": [
        "LJ"
    ],
    "sapphire 8": [
        "LJ"
    ],
    "sapphire7": [
        "LJ"
    ],
    "sapphire6": [
        "LJ"
    ],
    "mphone 7s": [
        "X0"
    ],
    "mphone 6": [
        "X0"
    ],
    "mphone 7 plus": [
        "X0"
    ],
    "mphone8": [
        "X0"
    ],
    "cobalt_sm_5": [
        "XC"
    ],
    "cobalt_sm_55": [
        "XC"
    ],
    "cobalt_sm_6": [
        "XC"
    ],
    "kodak smartway t3": [
        "KK"
    ],
    "be2026": [
        "ON"
    ],
    "brio_x31": [
        "X8"
    ],
    "elite c55": [
        "SW"
    ],
    "elite_b55": [
        "SW"
    ],
    "astro": [
        "4M"
    ],
    "astro 4.5": [
        "MW"
    ],
    "astro 4": [
        "MW"
    ],
    "astro x5": [
        "MW"
    ],
    "astro x55 lte": [
        "MW"
    ],
    "astro 55n lte": [
        "MW"
    ],
    "astro 5p": [
        "MW"
    ],
    "astro_4p": [
        "MW"
    ],
    "ta-2": [
        "73"
    ],
    "ta-3": [
        "73"
    ],
    "ta-4": [
        "73"
    ],
    "ta-20": [
        "73"
    ],
    "ta-1": [
        "73"
    ],
    "ta-10": [
        "73"
    ],
    "ta-2_3g": [
        "73"
    ],
    "ta-2_pro": [
        "73"
    ],
    "ta-40": [
        "73"
    ],
    "ta-60": [
        "73"
    ],
    "ta-50_power": [
        "73"
    ],
    "ta-55_power": [
        "73"
    ],
    "mar-lx2b": [
        "HU"
    ],
    "rx7 mini": [
        "WA"
    ],
    "netra": [
        "Y0"
    ],
    "netra_plus": [
        "Y0"
    ],
    "netra_lite": [
        "Y0"
    ],
    "nitro 5p": [
        "MW"
    ],
    "note 4cam": [
        "TP"
    ],
    "xq dual": [
        "M6"
    ],
    "kingkong 5 pro": [
        "CB"
    ],
    "shark prs-h0": [
        "XI"
    ],
    "le2110": [
        "ON"
    ],
    "v2046": [
        "VV"
    ],
    "md-01p": [
        "7P"
    ],
    "m2012k11g": [
        "XI"
    ],
    "m2102k1c": [
        "XI"
    ],
    "rmx3231": [
        "RE"
    ],
    "rmx3191": [
        "RE"
    ],
    "w-v745-tvm": [
        "WI"
    ],
    "v2038": [
        "VV"
    ],
    "m2101k9g": [
        "XI"
    ],
    "v2006": [
        "VV"
    ],
    "sh-h01": [
        "SH"
    ],
    "gionee f205": [
        "GI"
    ],
    "s5501l": [
        "NL"
    ],
    "mega2": [
        "13"
    ],
    "p55 max": [
        "PA"
    ],
    "panasonic p6": [
        "PA"
    ],
    "1826-i01": [
        "CO"
    ],
    "k9_smart_plus": [
        "KA"
    ],
    "infinity e4": [
        "T2"
    ],
    "infinity_e3": [
        "T2"
    ],
    "infinity_e2": [
        "T2"
    ],
    "infinity_a2": [
        "T2"
    ],
    "infinity_i1": [
        "52"
    ],
    "infinity_i_mix": [
        "52"
    ],
    "infinity_k2": [
        "T2"
    ],
    "infinit_x_cam": [
        "TQ"
    ],
    "infinit mx": [
        "TQ"
    ],
    "infinit mx pro": [
        "TQ"
    ],
    "infinit lite 2": [
        "TQ"
    ],
    "iku k3": [
        "8I"
    ],
    "iku i4": [
        "8I"
    ],
    "iku i3": [
        "8I"
    ],
    "tornado": [
        "EX"
    ],
    "tornado3g": [
        "EX"
    ],
    "uzte grand v7": [
        "ZT"
    ],
    "valencia2_y100": [
        "DO"
    ],
    "venus x1": [
        "HV"
    ],
    "venus x17": [
        "HV"
    ],
    "venus r8 plus": [
        "HV"
    ],
    "venus_r10": [
        "HV"
    ],
    "venus_r12": [
        "HV"
    ],
    "venus_r18": [
        "HV"
    ],
    "venus_r2": [
        "HV"
    ],
    "venus_r3": [
        "HV"
    ],
    "venus_r6": [
        "HV"
    ],
    "venus_r7": [
        "HV"
    ],
    "venus_r8": [
        "HV"
    ],
    "venus_r9": [
        "HV"
    ],
    "vertis 4004 you": [
        "OV"
    ],
    "verykool luna ii s4513": [
        "VL",
        "69"
    ],
    "verykoolsl5560": [
        "VL"
    ],
    "verykools5527": [
        "VL"
    ],
    "verykools5526": [
        "VL"
    ],
    "verykools5525": [
        "VL"
    ],
    "verykools5524": [
        "VL"
    ],
    "verykools5035": [
        "VL"
    ],
    "verykools5034": [
        "VL"
    ],
    "verykool atlas s5014": [
        "VL"
    ],
    "verykool_giant_s5020": [
        "VL"
    ],
    "verykool lotus s5001": [
        "VL"
    ],
    "verykool s5017": [
        "VL"
    ],
    "verykools5007": [
        "VL"
    ],
    "verykools5037": [
        "VL"
    ],
    "verykool s5015": [
        "VL"
    ],
    "verykool helix s5025": [
        "VL"
    ],
    "verykool s400": [
        "VL"
    ],
    "verykool leo s4002": [
        "VL"
    ],
    "verykool s401": [
        "VL"
    ],
    "verykool cyprus s6001": [
        "VL"
    ],
    "verykool s354": [
        "VL"
    ],
    "verykool s4006": [
        "VL"
    ],
    "verykool s4510": [
        "VL"
    ],
    "verykool sol quatro jr 5003": [
        "VL"
    ],
    "verykool sol s5013": [
        "VL"
    ],
    "verykool sol quatro s5016": [
        "VL"
    ],
    "verykools4006q": [
        "VL"
    ],
    "verykools4006t": [
        "VL"
    ],
    "verykools4007": [
        "VL"
    ],
    "verykools5001": [
        "VL"
    ],
    "verykool_s5516": [
        "VL"
    ],
    "verykool dorado s5017q": [
        "VL"
    ],
    "verykools5036": [
        "VL"
    ],
    "verykools5204": [
        "VL"
    ],
    "verykools5528jr": [
        "VL"
    ],
    "verykools5702": [
        "VL"
    ],
    "verykoolsl5029": [
        "VL"
    ],
    "verykoolsl5565": [
        "VL"
    ],
    "vgotel ocean 6": [
        "V6"
    ],
    "verykoolsl5550": [
        "VL"
    ],
    "verykools5530": [
        "VL"
    ],
    "verykools5030": [
        "VL"
    ],
    "verykool giant s5020": [
        "VL"
    ],
    "verykool sl5009": [
        "VL"
    ],
    "verykool sl5011": [
        "VL"
    ],
    "verykools4008": [
        "VL"
    ],
    "verykool_fusion_ii_sl4502": [
        "VL"
    ],
    "verykoolsl6010": [
        "VL"
    ],
    "vivax_fly_v550": [
        "V5"
    ],
    "vivax fly 2": [
        "V5",
        "FL"
    ],
    "vowney": [
        "EL"
    ],
    "vowney lite": [
        "EL"
    ],
    "vox_fortis": [
        "5I"
    ],
    "vox_vero": [
        "5I"
    ],
    "vphone-x3": [
        "L6"
    ],
    "vphone x3": [
        "L6"
    ],
    "quantum up": [
        "QA"
    ],
    "life zen": [
        "FL"
    ],
    "life play": [
        "FL"
    ],
    "pure micro": [
        "N3"
    ],
    "a003zt": [
        "ZT"
    ],
    "komu_x1": [
        "KM"
    ],
    "komu_k55": [
        "KM"
    ],
    "komu_k30": [
        "KM"
    ],
    "k60": [
        "KM",
        "KB"
    ],
    "kruger&matz move 6": [
        "KE"
    ],
    "shark 5000": [
        "L5"
    ],
    "s550 pro": [
        "CB",
        "OB"
    ],
    "s5140": [
        "GZ"
    ],
    "s7": [
        "SC",
        "6G"
    ],
    "nx529jq": [
        "57"
    ],
    "v210101": [
        "VP"
    ],
    "ark ukozi u5": [
        "A6"
    ],
    "leagoo z5c": [
        "L5"
    ],
    "ulefone_s1": [
        "UL"
    ],
    "mi 9t": [
        "XI"
    ],
    "lgls990": [
        "LG"
    ],
    "iphone9,3": [
        "AP"
    ],
    "lt c3100": [
        "QL"
    ],
    "lg-f320l": [
        "LG"
    ],
    "lgm-k121s": [
        "LG"
    ],
    "vivo y51l": [
        "VV"
    ],
    "huawei ale-cl00": [
        "HU"
    ],
    "ht50": [
        "HM"
    ],
    "samsung sm-a500fu": [
        "SA"
    ],
    "sm-g900fd": [
        "SA"
    ],
    "lenovo a2010-a": [
        "LE"
    ],
    "tecno-c9": [
        "TB"
    ],
    "psp3552duo": [
        "PR"
    ],
    "psp3511duo": [
        "PR"
    ],
    "philips s327": [
        "PH"
    ],
    "asus_z017db": [
        "AU"
    ],
    "tecno w5 lite": [
        "TB"
    ],
    "ine-lx1": [
        "HU"
    ],
    "ine-lx2": [
        "HU"
    ],
    "atu-l11": [
        "HU"
    ],
    "bv5500plus": [
        "B2"
    ],
    "cph2065": [
        "OP"
    ],
    "psp7510duo": [
        "PR"
    ],
    "samsung sm-a105fn": [
        "SA"
    ],
    "trt-lx3": [
        "HU"
    ],
    "bv9800pro": [
        "B2"
    ],
    "tone_e21": [
        "0T"
    ],
    "vivo x21i a": [
        "VV"
    ],
    "asus_z017d": [
        "AU"
    ],
    "starnaute4": [
        "SX"
    ],
    "lgms345": [
        "LG"
    ],
    "lg-m160": [
        "LG"
    ],
    "archos 55 cobalt plus": [
        "AR"
    ],
    "lava_ri": [
        "LV"
    ],
    "fig-la1": [
        "HU"
    ],
    "bv9500pro": [
        "B2"
    ],
    "sla-l02": [
        "HU"
    ],
    "lex727": [
        "L1"
    ],
    "hry-lx1": [
        "HU"
    ],
    "lenovo a1000": [
        "LE"
    ],
    "vivo x5pro": [
        "VV"
    ],
    "hisense c30": [
        "HI"
    ],
    "archos 50e neon": [
        "AR",
        "JG"
    ],
    "mi a3": [
        "XI"
    ],
    "moto c": [
        "MR"
    ],
    "nx575j": [
        "57"
    ],
    "lgl58vl": [
        "LG"
    ],
    "impress_tor": [
        "VX"
    ],
    "lg-h918": [
        "LG"
    ],
    "vivo 1938": [
        "VV"
    ],
    "azumi_iro_a5_q": [
        "AM"
    ],
    "blu studio c 5+5 lte": [
        "BU"
    ],
    "vivo 1907_19": [
        "VV"
    ],
    "vivo 1907": [
        "VV"
    ],
    "vivo 1906": [
        "VV"
    ],
    "vivo 1851": [
        "VV"
    ],
    "lava z66": [
        "LV"
    ],
    "vivo 1920": [
        "VV"
    ],
    "motorola one vision": [
        "MR"
    ],
    "tecno kb3": [
        "TB"
    ],
    "lgl23": [
        "LG"
    ],
    "impress disco": [
        "VX"
    ],
    "lg-h820": [
        "LG"
    ],
    "venus_v3_5020": [
        "VT"
    ],
    "venus_v3_5570": [
        "VT"
    ],
    "venus_x2": [
        "HV"
    ],
    "venus_x16-1": [
        "HV"
    ],
    "vergatario 5": [
        "ZT"
    ],
    "vergatario5plus": [
        "ZT"
    ],
    "vertex impress max": [
        "VX"
    ],
    "vertex impress_open": [
        "VX"
    ],
    "motog3-te": [
        "MR"
    ],
    "motorola xt1563": [
        "MR"
    ],
    "intex aqua lions t1 lite": [
        "IX"
    ],
    "intex aqua a4 plus": [
        "IX"
    ],
    "intex aqua a4": [
        "IX"
    ],
    "intex aqua lions 2": [
        "IX"
    ],
    "intex aqua lions 3": [
        "IX"
    ],
    "intex aqua lions e3": [
        "IX"
    ],
    "intex aqua lions n1": [
        "IX"
    ],
    "intex aqua lions t1": [
        "IX"
    ],
    "intex aqua crystal+": [
        "IX"
    ],
    "intex aqua fulvu e5": [
        "IX"
    ],
    "intex aqua jewel 2": [
        "IX"
    ],
    "intex aqua s1": [
        "IX"
    ],
    "intex aqua s3": [
        "IX"
    ],
    "i505": [
        "NM"
    ],
    "i501": [
        "NM"
    ],
    "i500": [
        "NM"
    ],
    "i450": [
        "NM"
    ],
    "i401": [
        "NM"
    ],
    "i400": [
        "NM"
    ],
    "i550": [
        "NM"
    ],
    "i552": [
        "NM"
    ],
    "i5800c": [
        "U4"
    ],
    "i6800": [
        "U4"
    ],
    "i9355a": [
        "IP"
    ],
    "vava x3": [
        "WV"
    ],
    "sm-e7009": [
        "SA"
    ],
    "sm-e7000": [
        "SA"
    ],
    "sm-e700f": [
        "SA"
    ],
    "sm-e700m": [
        "SA"
    ],
    "htc6500lvw": [
        "HT"
    ],
    "htc6435lvw": [
        "HT"
    ],
    "htc0p9c2": [
        "HT"
    ],
    "htc0p4e1": [
        "HT"
    ],
    "htc6515lvw": [
        "HT"
    ],
    "htc6525lvw": [
        "HT"
    ],
    "htcb810x": [
        "HT"
    ],
    "htcbutterflys901s": [
        "HT"
    ],
    "htcd526h": [
        "HT"
    ],
    "htcd620h": [
        "HT"
    ],
    "htcd816x": [
        "HT"
    ],
    "htconemini2": [
        "HT"
    ],
    "htcpn071": [
        "HT"
    ],
    "htc_0p4e2": [
        "HT"
    ],
    "ixion x150": [
        "DX"
    ],
    "ixion p350": [
        "DX"
    ],
    "ixion ms255": [
        "DX"
    ],
    "ixion ml350": [
        "DX"
    ],
    "htc_0p9o2": [
        "HT"
    ],
    "vfd 730": [
        "VF"
    ],
    "vfd 630": [
        "VF"
    ],
    "htc 2q7a100": [
        "HT"
    ],
    "sm-a105g": [
        "SA"
    ],
    "neffos x1 max": [
        "NF"
    ],
    "asus_z01hda": [
        "AU"
    ],
    "redmi 4": [
        "XI"
    ],
    "redmi 7": [
        "XI"
    ],
    "pro5023pve03": [
        "PL"
    ],
    "lgl158vl": [
        "LG"
    ],
    "lg-ls777": [
        "LG"
    ],
    "sm-g900v": [
        "SA"
    ],
    "sm-j610fn": [
        "SA"
    ],
    "sm-j120fn": [
        "SA"
    ],
    "was-lx3": [
        "HU"
    ],
    "htc_d526h": [
        "HT"
    ],
    "htc_d610x": [
        "HT"
    ],
    "htc_d620h": [
        "HT"
    ],
    "htc_d626ph": [
        "HT"
    ],
    "htc_d816": [
        "HT"
    ],
    "htc_d816d": [
        "HT"
    ],
    "sm-a505fm": [
        "SA"
    ],
    "zte t221": [
        "ZT"
    ],
    "avvio 787": [
        "AV"
    ],
    "avvio 777": [
        "AV"
    ],
    "avvio 768": [
        "AV"
    ],
    "zte t610": [
        "ZT"
    ],
    "zte t617": [
        "ZT"
    ],
    "zte v5 pro": [
        "ZT"
    ],
    "hisense f17 pro": [
        "HI"
    ],
    "hisense f23 plus": [
        "HI"
    ],
    "hisense f32": [
        "HI"
    ],
    "highscreen power_five": [
        "H2"
    ],
    "redmi 5": [
        "XI"
    ],
    "v504730": [
        "VD"
    ],
    "flare_p1_mini": [
        "CH"
    ],
    "flare_j3_plus": [
        "CH"
    ],
    "flare_j3": [
        "CH"
    ],
    "flare_lite_3s": [
        "CH"
    ],
    "flare_j2s": [
        "CH"
    ],
    "flarej3plus": [
        "CH"
    ],
    "flare_5": [
        "CH"
    ],
    "flare_j2_dtv": [
        "CH"
    ],
    "me 1+": [
        "0J"
    ],
    "ivvi f1s": [
        "UI"
    ],
    "ivvi v1m-s": [
        "UI"
    ],
    "ivvi v2": [
        "UI"
    ],
    "ivvi i1-s": [
        "UI"
    ],
    "tecno ca8": [
        "TB"
    ],
    "huawei scl-l21": [
        "HU"
    ],
    "huawei scl-l04": [
        "HU"
    ],
    "huawei scl-l03": [
        "HU"
    ],
    "huawei scl-l02": [
        "HU"
    ],
    "psp5517duo": [
        "PR"
    ],
    "psp5508duo": [
        "PR"
    ],
    "psp5507duo": [
        "PR"
    ],
    "psp5505duo": [
        "PR"
    ],
    "psp5551duo": [
        "PR"
    ],
    "psp5470duo": [
        "PR"
    ],
    "motorola one hyper": [
        "MR"
    ],
    "motorola one power": [
        "MR"
    ],
    "motorola edge plus": [
        "MR"
    ],
    "motorola edge": [
        "MR"
    ],
    "motorola one fusion": [
        "MR",
        "O1"
    ],
    "motorola one fusion+": [
        "MR"
    ],
    "hisense a2t": [
        "HI"
    ],
    "hisense infinity h11": [
        "HI"
    ],
    "kyocera-e6820": [
        "KY"
    ],
    "hisense f16": [
        "HI"
    ],
    "hisense f27": [
        "HI"
    ],
    "hisense h12": [
        "HI"
    ],
    "hisense f35": [
        "HI"
    ],
    "hisense infinity e8": [
        "HI"
    ],
    "gionee f205 lite": [
        "GI"
    ],
    "yeah_go": [
        "TQ"
    ],
    "sm-a300f": [
        "SA"
    ],
    "2106118c": [
        "XI"
    ],
    "tecno_b1f": [
        "TB"
    ],
    "x-tigi_v18 pro": [
        "XT"
    ],
    "iphone10,4": [
        "AP"
    ],
    "primo gh11": [
        "WA"
    ],
    "sm-a510k": [
        "SA"
    ],
    "lenovo k8 note": [
        "LE"
    ],
    "lenovo k8 plus": [
        "LE"
    ],
    "lg-h871s": [
        "LG"
    ],
    "gm 5 plus d": [
        "GN"
    ],
    "asus_z017dc": [
        "AU"
    ],
    "lenovo k14": [
        "LE"
    ],
    "hisense e60 lite": [
        "HI"
    ],
    "hisense v40s": [
        "HI"
    ],
    "infinix x662b": [
        "IF"
    ],
    "infinix x6511e": [
        "IF"
    ],
    "sm-a035g": [
        "SA"
    ],
    "sm-a336m": [
        "SA"
    ],
    "impress_lux": [
        "VX"
    ],
    "pluto__26": [
        "MJ"
    ],
    "pluto_26n": [
        "MJ"
    ],
    "play club": [
        "18"
    ],
    "play style": [
        "18"
    ],
    "navon d405": [
        "N3"
    ],
    "ta-1053": [
        "NK"
    ],
    "ta-1044": [
        "NK"
    ],
    "qmobile energy x2": [
        "QM",
        "E1"
    ],
    "qmobile energy x1": [
        "QM",
        "E1"
    ],
    "qmobile black two": [
        "QM"
    ],
    "qmobile a600": [
        "QM"
    ],
    "micromax q440": [
        "MI"
    ],
    "micromax q440plus": [
        "MI"
    ],
    "micromax q452": [
        "MI"
    ],
    "micromax q454": [
        "MI"
    ],
    "micromax q4601": [
        "MI"
    ],
    "micromax q470": [
        "MI"
    ],
    "micromax_q353": [
        "MI"
    ],
    "micromax_q353p": [
        "MI"
    ],
    "redmi 6 pro": [
        "XI"
    ],
    "redmi 6": [
        "XI"
    ],
    "quantum_400_lite": [
        "GC"
    ],
    "quantum_500_lite": [
        "GC"
    ],
    "zte blade a0622": [
        "ZT"
    ],
    "a507dl": [
        "TC"
    ],
    "lgl84vl": [
        "LG"
    ],
    "htc u11 plus": [
        "HT",
        "OE"
    ],
    "lgl455dl": [
        "LG"
    ],
    "asus_z017da": [
        "AU"
    ],
    "impress_forest": [
        "VX"
    ],
    "lgls675": [
        "LG"
    ],
    "lg-h872": [
        "LG"
    ],
    "lgus997": [
        "LG"
    ],
    "moto g(8)": [
        "MR"
    ],
    "rmx1803": [
        "RE"
    ],
    "htc u11": [
        "HT"
    ],
    "sm-a205g": [
        "SA"
    ],
    "redmi 6a": [
        "XI"
    ],
    "htc u11 life": [
        "HT"
    ],
    "bv5500pro": [
        "B2"
    ],
    "evr-l29": [
        "HU"
    ],
    "lgms631": [
        "LG"
    ],
    "lg-k130": [
        "LG"
    ],
    "vivo 1823": [
        "VV"
    ],
    "vfd 620": [
        "VF"
    ],
    "vfd 527": [
        "VF"
    ],
    "moto e6 play": [
        "MR"
    ],
    "vivo 1921": [
        "VV"
    ],
    "thrill boost 2 plus": [
        "CD"
    ],
    "eluga i6": [
        "PA"
    ],
    "col-al10": [
        "HU"
    ],
    "lenovo l78011": [
        "LE"
    ],
    "lenovo l38012": [
        "LE"
    ],
    "lenovo l78031": [
        "LE"
    ],
    "lenovo pb2-650y": [
        "LE"
    ],
    "vky-l09": [
        "HU"
    ],
    "sm-j600fn": [
        "SA"
    ],
    "ele-l29": [
        "HU"
    ],
    "cph2161": [
        "OP"
    ],
    "rne-l01": [
        "HU"
    ],
    "ane-lx2": [
        "HU"
    ],
    "w_p200cm": [
        "WI"
    ],
    "lg-m200": [
        "LG"
    ],
    "sm-g988n": [
        "SA"
    ],
    "hisense f18": [
        "HI"
    ],
    "sm-g9650": [
        "SA"
    ],
    "hisense f25": [
        "HI"
    ],
    "neon_ray_pro": [
        "X1"
    ],
    "redmi s2": [
        "XI"
    ],
    "mi mix 2": [
        "XI"
    ],
    "sm-a510f": [
        "SA"
    ],
    "psp7550duo": [
        "PR"
    ],
    "sm-a500f": [
        "SA"
    ],
    "sm-a305fn": [
        "SA"
    ],
    "zte blade a5 2019": [
        "ZT"
    ],
    "lg-sp320": [
        "LG"
    ],
    "kyocera-e6920": [
        "KY"
    ],
    "tecno r6s": [
        "TB"
    ],
    "sm-g975u1": [
        "SA"
    ],
    "psp3532duo": [
        "PR"
    ],
    "psp5515duo": [
        "PR"
    ],
    "psp5506duo": [
        "PR"
    ],
    "lg-h440n": [
        "LG"
    ],
    "moto g(9) play": [
        "MR"
    ],
    "lg-m154": [
        "LG"
    ],
    "eluga_ray_700": [
        "PA"
    ],
    "sm-g360f": [
        "SA"
    ],
    "sm-g970f": [
        "SA"
    ],
    "sm-a207f": [
        "SA"
    ],
    "sm-a307gt": [
        "SA"
    ],
    "wiko u520as": [
        "WI"
    ],
    "ta-1012": [
        "NK"
    ],
    "tecno kd7h": [
        "TB"
    ],
    "moto g(7) play": [
        "MR"
    ],
    "lya-l09": [
        "HU"
    ],
    "doro 8040": [
        "DR"
    ],
    "rmx3261": [
        "RE"
    ],
    "im-100s": [
        "PT"
    ],
    "im-100k": [
        "PT"
    ],
    "im-100gn": [
        "PT"
    ],
    "primo rm2 mini": [
        "WA"
    ],
    "primo r4 plus": [
        "WA"
    ],
    "primo zx2 mini": [
        "WA"
    ],
    "primo zx2": [
        "WA"
    ],
    "primo zx2 lite": [
        "WA"
    ],
    "primo_rh2": [
        "WA"
    ],
    "primo_gf4": [
        "WA"
    ],
    "primo_ef3": [
        "WA"
    ],
    "primo_nh_lite": [
        "WA"
    ],
    "primo nx4 mini": [
        "WA"
    ],
    "primo nx4": [
        "WA"
    ],
    "primo nh2": [
        "WA"
    ],
    "lg-d723": [
        "LG"
    ],
    "lg-d725": [
        "LG"
    ],
    "lg-d725pr": [
        "LG"
    ],
    "lg-d726": [
        "LG"
    ],
    "lg-d728": [
        "LG"
    ],
    "huawei mla-l11": [
        "HU"
    ],
    "sm-a505gt": [
        "SA"
    ],
    "lenovo k50-t5": [
        "LE"
    ],
    "samsung sm-a105m": [
        "SA"
    ],
    "ze552kl": [
        "AU"
    ],
    "agm a9 ru": [
        "A3"
    ],
    "agm a9": [
        "A3"
    ],
    "agm a10": [
        "A3"
    ],
    "agm a7": [
        "A3"
    ],
    "agm x3": [
        "A3"
    ],
    "aligator s6000": [
        "4A",
        "LE"
    ],
    "aeonsr570": [
        "LU"
    ],
    "zte blade a7 2019": [
        "ZT"
    ],
    "lex820": [
        "L1"
    ],
    "lg-h812": [
        "LG"
    ],
    "symbol x": [
        "HV"
    ],
    "symbol max": [
        "HV"
    ],
    "eluga_i7_ee": [
        "PA"
    ],
    "s2 lite": [
        "UM"
    ],
    "picasso": [
        "B3"
    ],
    "pro 5": [
        "M1"
    ],
    "prime l": [
        "H2"
    ],
    "m500-1": [
        "JG"
    ],
    "m5 pro": [
        "6G"
    ],
    "hashtag": [
        "J0"
    ],
    "shine": [
        "J0"
    ],
    "chacer": [
        "J0"
    ],
    "f5_15": [
        "BQ"
    ],
    "iron-bone dg750": [
        "DO"
    ],
    "onyx": [
        "EX"
    ],
    "spade": [
        "H2"
    ],
    "spark 2": [
        "H2"
    ],
    "lg-us996": [
        "LG"
    ],
    "lg-k520": [
        "LG"
    ],
    "moto e (4)": [
        "MR"
    ],
    "lm-k510": [
        "LG"
    ],
    "lgl423dl": [
        "LG"
    ],
    "lg-tp450": [
        "LG"
    ],
    "lg-x150": [
        "LG"
    ],
    "lg-x145": [
        "LG"
    ],
    "lg-h410": [
        "LG"
    ],
    "lg-d335": [
        "LG"
    ],
    "lgl322dl": [
        "LG"
    ],
    "lg-q710al": [
        "LG"
    ],
    "lg-m400": [
        "LG"
    ],
    "lm-v500n": [
        "LG"
    ],
    "lgm-g600s": [
        "LG"
    ],
    "lgl555dl": [
        "LG"
    ],
    "lg-h870": [
        "LG"
    ],
    "lg-h900": [
        "LG"
    ],
    "lg-d415": [
        "LG"
    ],
    "lm-q620": [
        "LG"
    ],
    "lg-h500": [
        "LG"
    ],
    "lm-g900tm": [
        "LG"
    ],
    "lg-h440ar": [
        "LG"
    ],
    "lg-h440": [
        "LG"
    ],
    "lg-h420": [
        "LG"
    ],
    "lg-f700s": [
        "LG"
    ],
    "lg-m327": [
        "LG"
    ],
    "lg-m430": [
        "LG"
    ],
    "lg-x210": [
        "LG"
    ],
    "lg-k200": [
        "LG"
    ],
    "lg-h990": [
        "LG"
    ],
    "lg-h930re": [
        "LG"
    ],
    "lg-h930ds": [
        "LG"
    ],
    "lg-us997": [
        "LG"
    ],
    "lg-x155": [
        "LG"
    ],
    "lg-x165g": [
        "LG"
    ],
    "lg-h522": [
        "LG"
    ],
    "lg-f800k": [
        "LG"
    ],
    "lg-f700k": [
        "LG"
    ],
    "lg-f460": [
        "LG"
    ],
    "lg-h819": [
        "LG"
    ],
    "lgls992": [
        "LG"
    ],
    "lg-k500": [
        "LG"
    ],
    "lg-x190": [
        "LG"
    ],
    "lgls991": [
        "LG"
    ],
    "lgus991": [
        "LG"
    ],
    "lgv32": [
        "LG"
    ],
    "lg-as110": [
        "LG"
    ],
    "lg-d680": [
        "LG"
    ],
    "lm-x210": [
        "LG"
    ],
    "lgm-k120l": [
        "LG"
    ],
    "lgm-k120s": [
        "LG"
    ],
    "lgm-k120k": [
        "LG"
    ],
    "lgm-x600s": [
        "LG"
    ],
    "lgv36": [
        "LG"
    ],
    "lgm-x600l": [
        "LG"
    ],
    "lgm-x600k": [
        "LG"
    ],
    "lg-us700": [
        "LG"
    ],
    "lg-q710pl": [
        "LG"
    ],
    "lm-q925k": [
        "LG"
    ],
    "lg-h871": [
        "LG"
    ],
    "lg-h870s": [
        "LG"
    ],
    "lg-h845": [
        "LG"
    ],
    "lgls676": [
        "LG"
    ],
    "lg-f670s": [
        "LG"
    ],
    "lg-k410": [
        "LG"
    ],
    "lg-m710": [
        "LG"
    ],
    "lgms550": [
        "LG"
    ],
    "lg-d410": [
        "LG"
    ],
    "lg-d290": [
        "LG"
    ],
    "lg-d295": [
        "LG"
    ],
    "lg-d320": [
        "LG"
    ],
    "lg-d315": [
        "LG"
    ],
    "lgm-g600l": [
        "LG"
    ],
    "lg-g710": [
        "LG"
    ],
    "lm-x410.fg": [
        "LG"
    ],
    "lm-x220qma": [
        "LG"
    ],
    "lm-x210cmr": [
        "LG"
    ],
    "lm-q925s": [
        "LG"
    ],
    "lg-f500l": [
        "LG"
    ],
    "lg-h810": [
        "LG"
    ],
    "lg-f500s": [
        "LG"
    ],
    "lg-f500k": [
        "LG"
    ],
    "lg-as993": [
        "LG"
    ],
    "lg-f700l": [
        "LG"
    ],
    "lg-f800l": [
        "LG"
    ],
    "lg-h830": [
        "LG"
    ],
    "lg-h870ar": [
        "LG"
    ],
    "lg-h870i": [
        "LG"
    ],
    "lg-d373": [
        "LG"
    ],
    "lgls755": [
        "LG"
    ],
    "lgls450": [
        "LG"
    ],
    "lgl57bl": [
        "LG"
    ],
    "lgmp450": [
        "LG"
    ],
    "lgls775": [
        "LG"
    ],
    "lgm-x800k": [
        "LG"
    ],
    "lgm-x401s": [
        "LG"
    ],
    "lgm-x320s": [
        "LG"
    ],
    "lgm-x320l": [
        "LG"
    ],
    "lgm-x320k": [
        "LG"
    ],
    "lgms428": [
        "LG"
    ],
    "lgus215": [
        "LG"
    ],
    "lgus992": [
        "LG"
    ],
    "lgv34": [
        "LG"
    ],
    "lg-ls997": [
        "LG"
    ],
    "lg-h962": [
        "LG"
    ],
    "lg-h910": [
        "LG"
    ],
    "lg-h961s": [
        "LG"
    ],
    "lg-e440": [
        "LG"
    ],
    "lg-d693n": [
        "LG"
    ],
    "lg-d693": [
        "LG"
    ],
    "lg-d693tr": [
        "LG"
    ],
    "lg-d690n": [
        "LG"
    ],
    "lg-d690": [
        "LG"
    ],
    "lg-d686": [
        "LG"
    ],
    "lgms395": [
        "LG"
    ],
    "lg-h788": [
        "LG"
    ],
    "lg-f460s": [
        "LG"
    ],
    "lg-f460l": [
        "LG"
    ],
    "lg-f460k": [
        "LG"
    ],
    "lg-f600l": [
        "LG"
    ],
    "lg-f690l": [
        "LG"
    ],
    "lg-f600k": [
        "LG"
    ],
    "lg-d856": [
        "LG"
    ],
    "lg-d335e": [
        "LG"
    ],
    "lg-d331": [
        "LG"
    ],
    "lg-ls993": [
        "LG"
    ],
    "lg-m322": [
        "LG"
    ],
    "lg-f620k": [
        "LG"
    ],
    "lg-d851": [
        "LG"
    ],
    "lg-h635": [
        "LG"
    ],
    "lg-f740l": [
        "LG"
    ],
    "lg-f720s": [
        "LG"
    ],
    "lg-h700": [
        "LG"
    ],
    "lg-h915": [
        "LG"
    ],
    "lg-h970": [
        "LG"
    ],
    "lg-h960": [
        "LG"
    ],
    "lg-k428": [
        "LG"
    ],
    "lg-k530": [
        "LG"
    ],
    "lg-k535": [
        "LG"
    ],
    "lg-k550": [
        "LG"
    ],
    "lg-m210": [
        "LG"
    ],
    "lg-m257": [
        "LG"
    ],
    "lgl24": [
        "LG"
    ],
    "lg-p710": [
        "LG"
    ],
    "lg-p715": [
        "LG"
    ],
    "lg-p875": [
        "LG"
    ],
    "lg-p875h": [
        "LG"
    ],
    "lgms500": [
        "LG"
    ],
    "lgls740": [
        "LG"
    ],
    "lgls660": [
        "LG"
    ],
    "lgl31l": [
        "LG"
    ],
    "lgl41c": [
        "LG"
    ],
    "lg-x135": [
        "LG"
    ],
    "lg-e460": [
        "LG"
    ],
    "lg-e475f": [
        "LG"
    ],
    "lg-e470f": [
        "LG"
    ],
    "lg-e467f": [
        "LG"
    ],
    "lg-e465f": [
        "LG"
    ],
    "lg-e975": [
        "LG"
    ],
    "lg-e435f": [
        "LG"
    ],
    "lg-e415f": [
        "LG"
    ],
    "lg-d125": [
        "LG"
    ],
    "lg-d722": [
        "LG"
    ],
    "lg-d800": [
        "LG"
    ],
    "lgl83bl": [
        "LG"
    ],
    "lm-k315im": [
        "LG"
    ],
    "lm-k400": [
        "LG"
    ],
    "lm-k920": [
        "LG"
    ],
    "lm-v405ebw": [
        "LG"
    ],
    "s-tell m556": [
        "8L"
    ],
    "5029d_eea": [
        "AL"
    ],
    "psp5530duo": [
        "PR"
    ],
    "psp3495duo": [
        "PR"
    ],
    "psp3510duo": [
        "PR"
    ],
    "haier t54p": [
        "HA"
    ],
    "htc_2q4d100": [
        "HT"
    ],
    "psp5513duo": [
        "PR"
    ],
    "htc_e9x": [
        "HT"
    ],
    "htc_m9pw": [
        "HT"
    ],
    "htc one m9": [
        "HT"
    ],
    "htc 2pq910": [
        "HT"
    ],
    "inoi_5x_lite": [
        "I4"
    ],
    "htc_u-2u": [
        "HT"
    ],
    "nomi_i5001": [
        "NM"
    ],
    "infinix x627v": [
        "IF"
    ],
    "infinix x655d": [
        "IF"
    ],
    "infinix x655c": [
        "IF"
    ],
    "tecno ka7": [
        "TB"
    ],
    "infinix x626": [
        "IF"
    ],
    "infinix x655": [
        "IF"
    ],
    "haier a42p": [
        "HA"
    ],
    "inoi_3_lite": [
        "I4"
    ],
    "tecno wx3": [
        "TB"
    ],
    "umi_super": [
        "UM"
    ],
    "blackberry 9790": [
        "RM"
    ],
    "tecno ra8": [
        "TB"
    ],
    "ioutdoor x": [
        "OF"
    ],
    "asus_x00tdb": [
        "AU"
    ],
    "nomi_i4500": [
        "NM"
    ],
    "thl5000": [
        "T4"
    ],
    "inoi_1_lite": [
        "I4"
    ],
    "tecno ra6": [
        "TB"
    ],
    "jat-l29": [
        "HU"
    ],
    "lgh810": [
        "LG"
    ],
    "lg-m153": [
        "LG"
    ],
    "azumi_v5": [
        "AM"
    ],
    "psp5502duo": [
        "PR"
    ],
    "tecno kc1": [
        "TB"
    ],
    "tecno_w4": [
        "TB"
    ],
    "tecno kb8": [
        "TB"
    ],
    "tecno b1": [
        "TB"
    ],
    "tecno ka9": [
        "TB"
    ],
    "tecno kb2j": [
        "TB"
    ],
    "infinix x606": [
        "IF"
    ],
    "flycat optimum 5003": [
        "QC",
        "FL"
    ],
    "flycat optimum 5004": [
        "QC",
        "FL"
    ],
    "flycat optimum 5001": [
        "QC",
        "FL"
    ],
    "flycat optimum 5002": [
        "QC",
        "FL"
    ],
    "flycat optimum 5501": [
        "QC",
        "FL"
    ],
    "power 2": [
        "L5"
    ],
    "power 2 pro": [
        "L5"
    ],
    "light mini": [
        "6V"
    ],
    "viwa a5+": [
        "6V"
    ],
    "light plus": [
        "6V"
    ],
    "light a104": [
        "4G"
    ],
    "alpha gtr": [
        "H2"
    ],
    "cyrusapel": [
        "C4"
    ],
    "t3 pro": [
        "VR"
    ],
    "m9 pro": [
        "L5"
    ],
    "neon": [
        "JG"
    ],
    "power 5": [
        "L5"
    ],
    "vita s": [
        "QM"
    ],
    "s70lite": [
        "DO"
    ],
    "s80lite": [
        "DO"
    ],
    "s9_pro": [
        "UL"
    ],
    "start": [
        "JG"
    ],
    "startlte": [
        "JG"
    ],
    "wallet": [
        "H2"
    ],
    "x10s": [
        "DO"
    ],
    "droxio kentia": [
        "D8"
    ],
    "droxio a47": [
        "D8"
    ],
    "joy_tv": [
        "EX"
    ],
    "g255": [
        "DX"
    ],
    "t200": [
        "T4"
    ],
    "w867": [
        "HA"
    ],
    "prime s": [
        "H2"
    ],
    "joypro": [
        "JG"
    ],
    "gt6000": [
        "GF"
    ],
    "a6": [
        "GF"
    ],
    "a7": [
        "GF"
    ],
    "fresh": [
        "JG"
    ],
    "london": [
        "UM"
    ],
    "m3 max": [
        "M1"
    ],
    "m445": [
        "DX"
    ],
    "a450": [
        "JG"
    ],
    "a239s": [
        "B5"
    ],
    "x60l": [
        "DO"
    ],
    "z155": [
        "DX"
    ],
    "z255": [
        "DX"
    ],
    "mix2": [
        "DO"
    ],
    "mx6": [
        "M1"
    ],
    "pure 3": [
        "9H"
    ],
    "pure1": [
        "9H"
    ],
    "pure 2a": [
        "9H"
    ],
    "r6 lite": [
        "B2"
    ],
    "s10 pro": [
        "2N"
    ],
    "u15 pro": [
        "OE"
    ],
    "sm-g9750": [
        "SA"
    ],
    "lancelot": [
        "XI"
    ],
    "lineage_j5y17lte": [
        "SA"
    ],
    "zs590ks": [
        "AU"
    ],
    "zte a2021": [
        "ZT"
    ],
    "vivo 2018": [
        "VV"
    ],
    "v2037": [
        "VV"
    ],
    "sm-g986u": [
        "SA"
    ],
    "vivo 1919": [
        "VV"
    ],
    "v2031": [
        "VV"
    ],
    "v2033": [
        "VV"
    ],
    "v2035": [
        "VV"
    ],
    "vivo 1935": [
        "VV"
    ],
    "vivo 1951": [
        "VV"
    ],
    "stk-lx3": [
        "HU"
    ],
    "hyundai_eternity_g60": [
        "HN"
    ],
    "zte a2021l": [
        "ZT"
    ],
    "moto g(7) plus": [
        "MR"
    ],
    "moto e6s": [
        "MR"
    ],
    "ldn-lx3": [
        "HU"
    ],
    "ta-1027": [
        "NK"
    ],
    "ele-l04": [
        "HU"
    ],
    "huawei vns-l53": [
        "HU"
    ],
    "trt-l53": [
        "HU"
    ],
    "fig-lx3": [
        "HU"
    ],
    "huawei vns-l23": [
        "HU"
    ],
    "glam": [
        "NY"
    ],
    "blade v8 se": [
        "ZT"
    ],
    "sm-a205fn": [
        "SA"
    ],
    "rmx3241": [
        "RE"
    ],
    "rmx3242": [
        "RE"
    ],
    "sh-41a": [
        "SH"
    ],
    "cph2123": [
        "OP"
    ],
    "zte 9000": [
        "ZT"
    ],
    "hyundai_eternity_g57": [
        "HN"
    ],
    "lm-k525": [
        "LG"
    ],
    "lm-k526": [
        "LG"
    ],
    "ta-1039": [
        "NK"
    ],
    "moto x play": [
        "MR"
    ],
    "moto z3 play": [
        "MR"
    ],
    "moto z3": [
        "MR"
    ],
    "motorola one vision plus": [
        "MR"
    ],
    "moto g play": [
        "MR"
    ],
    "moto g(8) power": [
        "MR"
    ],
    "sne-lx3": [
        "HU"
    ],
    "moto g(9) plus": [
        "MR"
    ],
    "lenovo k13 note": [
        "LE"
    ],
    "lenovo k10 note": [
        "LE"
    ],
    "mi 10": [
        "XI"
    ],
    "mi 10 pro": [
        "XI"
    ],
    "mi 10t": [
        "XI"
    ],
    "mi 5": [
        "XI"
    ],
    "mi 5s": [
        "XI"
    ],
    "moto g(8) play": [
        "MR"
    ],
    "philips x818": [
        "PH"
    ],
    "philips x588": [
        "PH"
    ],
    "philips s395": [
        "PH"
    ],
    "pic-lx9": [
        "HU"
    ],
    "pra-lx2": [
        "HU"
    ],
    "r2 plus": [
        "BU"
    ],
    "r2 lte": [
        "BU"
    ],
    "pure view": [
        "BU"
    ],
    "rocky 2": [
        "5P"
    ],
    "was-lx2j": [
        "HU"
    ],
    "x-treme pq52": [
        "1S"
    ],
    "x-treme_pq51": [
        "1S"
    ],
    "xt1575": [
        "MR"
    ],
    "xt1580": [
        "MR"
    ],
    "xt1581": [
        "MR"
    ],
    "xt1585": [
        "MR"
    ],
    "xt1650": [
        "MR"
    ],
    "ulefone_note 7": [
        "UL"
    ],
    "zte a2017x": [
        "ZT"
    ],
    "zte blade l0510": [
        "ZT"
    ],
    "armor 11 5g": [
        "UL"
    ],
    "armor 7": [
        "UL"
    ],
    "b2021": [
        "5F"
    ],
    "bison gt": [
        "UM"
    ],
    "cph2095": [
        "OP"
    ],
    "cph2135": [
        "OP"
    ],
    "cph2179": [
        "OP"
    ],
    "cph2239": [
        "OP"
    ],
    "drive9": [
        "KE"
    ],
    "iron_2": [
        "HAM"
    ],
    "archos 50 power": [
        "AR"
    ],
    "sm-a205f": [
        "SA"
    ],
    "sm-a305f": [
        "SA"
    ],
    "zte blade l4 pro": [
        "ZT"
    ],
    "zte bv0720": [
        "ZT"
    ],
    "zte c880a": [
        "ZT"
    ],
    "neffos c5 plus": [
        "NF"
    ],
    "nomi i5071": [
        "NM"
    ],
    "noa_n8": [
        "N5"
    ],
    "inoi_6_lite": [
        "I4"
    ],
    "infinix x603": [
        "IF"
    ],
    "s50_pro": [
        "2N"
    ],
    "s55_lite": [
        "DO"
    ],
    "senseit_j2": [
        "S6"
    ],
    "sm-j260fu": [
        "SA"
    ],
    "tecno la7 pro": [
        "TB"
    ],
    "zte blade a5 pro": [
        "ZT"
    ],
    "zte blade v1000ru": [
        "ZT"
    ],
    "zte blade l210ru": [
        "ZT"
    ],
    "vivo 1940": [
        "VV"
    ],
    "vce-l22": [
        "HU"
    ],
    "v350u": [
        "6A"
    ],
    "tecno bc2c": [
        "TB"
    ],
    "tecno bc3": [
        "TB"
    ],
    "ultramintt a5": [
        "OM"
    ],
    "r1plus_1": [
        "4M"
    ],
    "zte a7000": [
        "ZT"
    ],
    "zte blade a0605": [
        "ZT"
    ],
    "zte blade v0840": [
        "ZT"
    ],
    "htc 2pzf1": [
        "HT"
    ],
    "psp7511duo": [
        "PR"
    ],
    "psp7501duo": [
        "PR"
    ],
    "psp3537duo": [
        "PR"
    ],
    "psp3533duo": [
        "PR"
    ],
    "y8 plus": [
        "DO"
    ],
    "impress_astra4g": [
        "VX"
    ],
    "impress_eagle4g": [
        "VX"
    ],
    "impress_rosso": [
        "VX"
    ],
    "impress_city": [
        "VX"
    ],
    "impress_flash": [
        "VX"
    ],
    "impress_zeon4g": [
        "VX"
    ],
    "impress_zeon3g": [
        "VX"
    ],
    "impress_luck4g_nfc": [
        "VX"
    ],
    "vivo xl2": [
        "BU",
        "VV"
    ],
    "was-l03t": [
        "HU"
    ],
    "bluboo maya max": [
        "B3"
    ],
    "moto g 5s plus": [
        "MR"
    ],
    "psp3423duo": [
        "PR"
    ],
    "hit4g": [
        "JG"
    ],
    "hisense l675": [
        "HI"
    ],
    "uniwa f40": [
        "U2"
    ],
    "impress_game": [
        "VX"
    ],
    "inoi_5i": [
        "I4"
    ],
    "hisense infinity h12": [
        "HI"
    ],
    "impress_luck": [
        "VX"
    ],
    "bv9000pro": [
        "B2"
    ],
    "bv5800pro_ru": [
        "B2"
    ],
    "easy_xl_pro": [
        "H2"
    ],
    "neffos c7 lite": [
        "NF"
    ],
    "asus_x018dc": [
        "AU"
    ],
    "cph2091": [
        "OP"
    ],
    "cph2089": [
        "OP"
    ],
    "cph2121": [
        "OP"
    ],
    "cph2145": [
        "OP"
    ],
    "cph2159": [
        "OP"
    ],
    "cph2285": [
        "OP"
    ],
    "cph2219": [
        "OP"
    ],
    "cph2217": [
        "OP"
    ],
    "cph2213": [
        "OP"
    ],
    "cph2211": [
        "OP"
    ],
    "cph2209": [
        "OP"
    ],
    "cph2207": [
        "OP"
    ],
    "cph2205": [
        "OP"
    ],
    "cph2203": [
        "OP"
    ],
    "cph2201": [
        "OP"
    ],
    "cph2197": [
        "OP"
    ],
    "cph2195": [
        "OP"
    ],
    "cph2173": [
        "OP"
    ],
    "hd1907": [
        "ON"
    ],
    "hd1905": [
        "ON"
    ],
    "mi 10t pro": [
        "XI"
    ],
    "mi 10t lite": [
        "XI"
    ],
    "m2101k9c": [
        "XI"
    ],
    "m2102j20si": [
        "0P"
    ],
    "m2103k19pg": [
        "0P"
    ],
    "m2103k19py": [
        "0P"
    ],
    "meizu 17 pro": [
        "M1"
    ],
    "nokia 2.2": [
        "NK"
    ],
    "nokia 2.3": [
        "NK"
    ],
    "nokia 2.4": [
        "NK"
    ],
    "nokia 3.2": [
        "NK"
    ],
    "nokia 8.3 5g": [
        "NK"
    ],
    "nokia c01 plus": [
        "NK"
    ],
    "nokia c10": [
        "NK"
    ],
    "nokia c20": [
        "NK"
    ],
    "nokia g10": [
        "NK"
    ],
    "poco x3 pro": [
        "0P"
    ],
    "poco m3 pro": [
        "0P"
    ],
    "poco m3 pro 5g": [
        "0P"
    ],
    "poco f3": [
        "0P"
    ],
    "sm-g981w": [
        "SA"
    ],
    "sm-g9810": [
        "SA"
    ],
    "vivo 1901": [
        "VV"
    ],
    "vivo 1918": [
        "VV"
    ],
    "vivo 1904": [
        "VV"
    ],
    "vivo 1933": [
        "VV"
    ],
    "asus_i006d": [
        "AU"
    ],
    "asus_i004d": [
        "AU"
    ],
    "asus_x00tda": [
        "AU"
    ],
    "artel q21_pro": [
        "40"
    ],
    "zte blade a31 lite ru": [
        "ZT"
    ],
    "zte a7030ru": [
        "ZT"
    ],
    "vivo 2006": [
        "VV"
    ],
    "vivo 2004": [
        "VV"
    ],
    "v2066": [
        "VV"
    ],
    "v2061": [
        "VV"
    ],
    "zs673ks": [
        "AU"
    ],
    "fig-al10": [
        "HU"
    ],
    "sm-g973w": [
        "SA"
    ],
    "nord n10 5g": [
        "ON"
    ],
    "le2100": [
        "ON"
    ],
    "le2101": [
        "ON"
    ],
    "le2125": [
        "ON"
    ],
    "lenovo a6000": [
        "LE",
        "ON"
    ],
    "oneplus a6003": [
        "ON"
    ],
    "zte blade a5 2020ru": [
        "ZT"
    ],
    "zte blade a7 2019ru": [
        "ZT"
    ],
    "zte blade v10 vita ru": [
        "ZT",
        "WCP"
    ],
    "zte blade a3 2020ru": [
        "ZT"
    ],
    "zte blade a3 2019ru": [
        "ZT"
    ],
    "asus_z01kd": [
        "AU"
    ],
    "asus_z016s": [
        "AU"
    ],
    "asus_z012db": [
        "AU"
    ],
    "asus_z012da": [
        "AU"
    ],
    "asus_x00qda": [
        "AU"
    ],
    "sm-j330f": [
        "SA"
    ],
    "sm-j530fm": [
        "SA"
    ],
    "sm-j730f": [
        "SA"
    ],
    "sm-j730fm": [
        "SA"
    ],
    "senseit e510": [
        "S6"
    ],
    "senseit r450": [
        "S6"
    ],
    "redmi 8": [
        "XI"
    ],
    "impress_cube": [
        "VX"
    ],
    "impress_pluto": [
        "VX"
    ],
    "impress_fire": [
        "VX"
    ],
    "impress click nfc": [
        "VX"
    ],
    "impress_aero": [
        "VX"
    ],
    "impress_blade": [
        "VX"
    ],
    "impress_aqua": [
        "VX"
    ],
    "impress_life": [
        "VX"
    ],
    "impress_phonic": [
        "VX"
    ],
    "impress_win": [
        "VX"
    ],
    "impress_vira": [
        "VX"
    ],
    "impress_indigo": [
        "VX"
    ],
    "redmi 7a": [
        "XI"
    ],
    "redmi 3": [
        "XI"
    ],
    "redmi 3x": [
        "XI"
    ],
    "redmi 4x": [
        "XI"
    ],
    "vivo 1720": [
        "VV"
    ],
    "vivo one plus": [
        "BU",
        "VV"
    ],
    "powermaxp600s": [
        "ED"
    ],
    "impress eclipse": [
        "VX"
    ],
    "impress_action": [
        "VX"
    ],
    "venus_v4": [
        "VT"
    ],
    "vivo 5r": [
        "BU",
        "VV"
    ],
    "sm-a405fn": [
        "SA"
    ],
    "nokia 9": [
        "NK"
    ],
    "htc one x9 dual sim": [
        "HT"
    ],
    "htc one_m8 dual sim": [
        "HT"
    ],
    "htc one m9_prime camera edition": [
        "HT"
    ],
    "htc one m9plus": [
        "HT"
    ],
    "htc one m9 plus": [
        "HT"
    ],
    "htc u play": [
        "HT"
    ],
    "htc desire 10 pro": [
        "HT"
    ],
    "htc 2pzm3": [
        "HT"
    ],
    "htc desire 816 dual sim": [
        "HT"
    ],
    "htc desire 650 dual sim": [
        "HT"
    ],
    "htc desire 816": [
        "HT"
    ],
    "htc6535lvw": [
        "HT"
    ],
    "htc_s9u": [
        "HT"
    ],
    "htc_m8x": [
        "HT"
    ],
    "htc_d816x": [
        "HT"
    ],
    "htc_d10i": [
        "HT"
    ],
    "htc_0p6b": [
        "HT"
    ],
    "htc one x10": [
        "HT"
    ],
    "htc one a9s": [
        "HT"
    ],
    "htc one a9": [
        "HT"
    ],
    "htc one s9": [
        "HT"
    ],
    "htc one_e8 dual sim": [
        "HT"
    ],
    "htc one_e8": [
        "HT"
    ],
    "htc m8d": [
        "HT"
    ],
    "htc one m8s": [
        "HT"
    ],
    "htc6545lvw": [
        "HT"
    ],
    "htc desire 825 dual sim": [
        "HT"
    ],
    "impress tor": [
        "VX"
    ],
    "bv9000": [
        "B2"
    ],
    "htc desire 12": [
        "HT"
    ],
    "htc 2pxh3": [
        "HT"
    ],
    "pro": [
        "WF"
    ],
    "x1 mini": [
        "5I"
    ],
    "vivo 1912": [
        "VV"
    ],
    "vivo nex s": [
        "VV"
    ],
    "vivo z3x": [
        "VV"
    ],
    "huawei nmo-l31": [
        "HU"
    ],
    "zte a0622": [
        "ZT"
    ],
    "vivo 8l": [
        "BU",
        "VV"
    ],
    "zte blade v0920": [
        "ZT"
    ],
    "hisense rock 5": [
        "HI"
    ],
    "myphone_pocket_pro": [
        "MY1"
    ],
    "meizu c9 pro": [
        "M1"
    ],
    "meizu m8 lite": [
        "M1"
    ],
    "huawei mla-tl10": [
        "HU"
    ],
    "huawei mla-tl00": [
        "HU"
    ],
    "huawei nxt-l09": [
        "HU"
    ],
    "eva-l19": [
        "HU"
    ],
    "jsn-l22": [
        "HU"
    ],
    "inoi 5 lite 2021": [
        "I4"
    ],
    "inoi 2 lite 2021": [
        "I4"
    ],
    "inoi 2 2021": [
        "I4"
    ],
    "k15_plus": [
        "OE"
    ],
    "infinix x612": [
        "IF"
    ],
    "infinix x657": [
        "IF"
    ],
    "infinix x657b": [
        "IF"
    ],
    "infinix x657c": [
        "IF"
    ],
    "infinix x680f": [
        "IF"
    ],
    "infinix x688c": [
        "IF"
    ],
    "infinix x682b": [
        "IF"
    ],
    "infinix x682c": [
        "IF"
    ],
    "infinix x660c": [
        "IF"
    ],
    "infinix x650": [
        "IF"
    ],
    "infinix x609": [
        "IF"
    ],
    "infinix x653c": [
        "IF"
    ],
    "infinix x627": [
        "IF"
    ],
    "infinix x625c": [
        "IF"
    ],
    "infinix x650b": [
        "IF"
    ],
    "infinix x650d": [
        "IF"
    ],
    "infinix x652b": [
        "IF"
    ],
    "ine-tl00": [
        "HU"
    ],
    "infinix x559": [
        "IF"
    ],
    "huawei tit-l01": [
        "HU"
    ],
    "htcd200lvwpp": [
        "HT"
    ],
    "myphone fun4": [
        "MY1"
    ],
    "alp-l29": [
        "HU"
    ],
    "evolveo strongphone g7": [
        "EO"
    ],
    "flow 7s": [
        "KE"
    ],
    "htc u12+": [
        "HT"
    ],
    "htc 2pzc100": [
        "HT"
    ],
    "htc 2q55100": [
        "HT"
    ],
    "htc_u-3u": [
        "HT"
    ],
    "sm-g9980u1": [
        "SA"
    ],
    "5045d": [
        "AL"
    ],
    "gt-s7560": [
        "SA"
    ],
    "gt-s7560m": [
        "SA"
    ],
    "gt-i9305t": [
        "SA"
    ],
    "gt-i8160l": [
        "SA"
    ],
    "gt-i8190": [
        "SA"
    ],
    "gt-i8190n": [
        "SA"
    ],
    "samsung gt-i8190n/i8190nxxamg3": [
        "SA"
    ],
    "gt-i9070p": [
        "SA"
    ],
    "gt-i9300": [
        "SA"
    ],
    "samsung gt-i9300/i9300xxugml2": [
        "SA"
    ],
    "gt-i9300t": [
        "SA"
    ],
    "gt-i9305": [
        "SA"
    ],
    "samsung gt-i9505-orange": [
        "SA"
    ],
    "samsung gt-i9505/i9505xxubmea": [
        "SA"
    ],
    "gt-i9505": [
        "SA"
    ],
    "gt-i9505g": [
        "SA"
    ],
    "cor-l29": [
        "HU"
    ],
    "alp-l09": [
        "HU"
    ],
    "ine-lx1r": [
        "HU"
    ],
    "lon-l29": [
        "HU"
    ],
    "ldn-lx2": [
        "HU"
    ],
    "blu studio g": [
        "BU"
    ],
    "blu studio c 8+8": [
        "BU"
    ],
    "cam-l23": [
        "HU"
    ],
    "dig-l03": [
        "HU"
    ],
    "cam-ul00": [
        "HU"
    ],
    "sla-l23": [
        "HU"
    ],
    "trt-l21a": [
        "HU"
    ],
    "atu-lx3": [
        "HU"
    ],
    "aum-l29": [
        "HU"
    ],
    "fla-lx2": [
        "HU"
    ],
    "fla-lx3": [
        "HU"
    ],
    "rne-l23": [
        "HU"
    ],
    "par-lx9": [
        "HU"
    ],
    "bac-l21": [
        "HU"
    ],
    "bla-a09": [
        "HU"
    ],
    "clt-l04": [
        "HU"
    ],
    "bac-l22": [
        "HU"
    ],
    "5033a": [
        "AL"
    ],
    "5052a": [
        "AL"
    ],
    "5059z": [
        "AL"
    ],
    "blu studio touch": [
        "BU"
    ],
    "blu advance 5.0": [
        "BU"
    ],
    "y550-l03": [
        "HU"
    ],
    "bll-l21": [
        "HU"
    ],
    "mya-l23": [
        "HU"
    ],
    "ultra dream": [
        "HN"
    ],
    "ultra link": [
        "HN"
    ],
    "ultra shine": [
        "HN",
        "J0"
    ],
    "ultra shadow": [
        "HN"
    ],
    "ultra style": [
        "HN"
    ],
    "ultra latitude": [
        "HN"
    ],
    "ultra charm": [
        "HN"
    ],
    "ultra active": [
        "HN"
    ],
    "b8405": [
        "BT"
    ],
    "samsung sm-j610g": [
        "SA"
    ],
    "sm-j400m": [
        "SA"
    ],
    "sm-j250m": [
        "SA"
    ],
    "sm-j106m": [
        "SA"
    ],
    "sm-a305gt": [
        "SA"
    ],
    "sm-a505f": [
        "SA"
    ],
    "sm-a505g": [
        "SA"
    ],
    "samsung sm-a305g": [
        "SA"
    ],
    "sm-g975w": [
        "SA"
    ],
    "sm-g970u": [
        "SA"
    ],
    "atu-l42": [
        "HU"
    ],
    "che-tl00": [
        "HU"
    ],
    "ele-l09": [
        "HU"
    ],
    "eva-al10": [
        "HU"
    ],
    "fla-al10": [
        "HU"
    ],
    "hma-tl00": [
        "HU"
    ],
    "hry-al00": [
        "HU"
    ],
    "lon-al00": [
        "HU"
    ],
    "lya-al10": [
        "HU"
    ],
    "sne-al00": [
        "HU"
    ],
    "vog-l09": [
        "HU"
    ],
    "blade a475": [
        "ZT"
    ],
    "blade a520": [
        "ZT"
    ],
    "blade a530": [
        "ZT"
    ],
    "blade a602": [
        "ZT"
    ],
    "zte blade apex": [
        "ZT"
    ],
    "blade apex2": [
        "ZT",
        "O7"
    ],
    "blade g lte": [
        "ZT"
    ],
    "blade g lux": [
        "ZT"
    ],
    "zte blade iii": [
        "ZT"
    ],
    "blade l110": [
        "ZT"
    ],
    "blade l2": [
        "ZT"
    ],
    "blade v9": [
        "ZT"
    ],
    "blade l2 plus": [
        "ZT"
    ],
    "z971": [
        "ZT"
    ],
    "blade v580": [
        "ZT"
    ],
    "z978": [
        "ZT"
    ],
    "z839": [
        "ZT"
    ],
    "blade vec": [
        "ZT"
    ],
    "z965": [
        "ZT"
    ],
    "z983": [
        "ZT"
    ],
    "z982": [
        "ZT"
    ],
    "z981": [
        "ZT"
    ],
    "n9520": [
        "ZT"
    ],
    "zte-c_n780": [
        "ZT"
    ],
    "z717bl": [
        "ZT"
    ],
    "z717vl": [
        "ZT"
    ],
    "z233v": [
        "ZT"
    ],
    "z232tl": [
        "ZT"
    ],
    "z353vl": [
        "ZT"
    ],
    "z852": [
        "ZT"
    ],
    "zte grand memo lte": [
        "ZT"
    ],
    "zte grand x": [
        "ZT"
    ],
    "z957": [
        "ZT"
    ],
    "z987": [
        "ZT"
    ],
    "n9101": [
        "ZT"
    ],
    "z718tl": [
        "ZT"
    ],
    "kis ii max": [
        "ZT"
    ],
    "zte kis lite": [
        "ZT"
    ],
    "z835": [
        "ZT"
    ],
    "z963vl": [
        "ZT"
    ],
    "z768g": [
        "ZT"
    ],
    "zte-mimosa x": [
        "ZT"
    ],
    "n8000_usa_cricket": [
        "ZT"
    ],
    "zte n900d": [
        "ZT"
    ],
    "zte_n9511": [
        "ZT"
    ],
    "nx573j": [
        "57"
    ],
    "nx907j": [
        "57"
    ],
    "nx541j": [
        "57"
    ],
    "nx597j": [
        "57"
    ],
    "nx529j": [
        "57"
    ],
    "nx403a": [
        "57"
    ],
    "nx510j": [
        "57"
    ],
    "nx521j": [
        "57"
    ],
    "nx511j": [
        "57"
    ],
    "z820": [
        "ZT"
    ],
    "z851m": [
        "ZT"
    ],
    "z851": [
        "ZT"
    ],
    "n9136": [
        "ZT"
    ],
    "z832": [
        "ZT"
    ],
    "n9137": [
        "ZT"
    ],
    "zte-u v880": [
        "ZT"
    ],
    "zte u790 build grk39f) uc": [
        "ZT"
    ],
    "zte u793 build mocordroid2.3.5) uc": [
        "ZT"
    ],
    "zte_u807": [
        "ZT"
    ],
    "zte u817": [
        "ZT"
    ],
    "zte u930hd": [
        "ZT"
    ],
    "zte u960s3": [
        "ZT"
    ],
    "n9180": [
        "ZT"
    ],
    "n958st": [
        "ZT"
    ],
    "v9180": [
        "ZT"
    ],
    "u9180": [
        "ZT"
    ],
    "n918st": [
        "ZT"
    ],
    "zte v795": [
        "ZT"
    ],
    "zte v889m": [
        "ZT"
    ],
    "n9519": [
        "ZT"
    ],
    "z836bl": [
        "ZT"
    ],
    "z837vl": [
        "ZT"
    ],
    "z557bl": [
        "ZT"
    ],
    "z861bl": [
        "ZT"
    ],
    "z862vl": [
        "ZT"
    ],
    "z955a": [
        "ZT"
    ],
    "z958": [
        "ZT"
    ],
    "z917vl": [
        "ZT"
    ],
    "z916bl": [
        "ZT"
    ],
    "zuum blaze": [
        "ZU"
    ],
    "zuum_zen_i": [
        "ZU"
    ],
    "infinix x612b": [
        "IF"
    ],
    "infinix x680": [
        "IF"
    ],
    "lenovo l18081": [
        "LE"
    ],
    "lava lh9950": [
        "LV"
    ],
    "lava le9930": [
        "LV"
    ],
    "lenovo l19041": [
        "LE"
    ],
    "lenovo l19111": [
        "LE"
    ],
    "lenovo l38041": [
        "LE"
    ],
    "lenovo l38043": [
        "LE"
    ],
    "lenovo l58091": [
        "LE"
    ],
    "lenovo l10041": [
        "LE"
    ],
    "lenovo l38111": [
        "LE"
    ],
    "lenovo l78032": [
        "LE"
    ],
    "lenovo l79031": [
        "LE"
    ],
    "lio-an00p": [
        "HU"
    ],
    "lenovo z6 pro": [
        "LE"
    ],
    "lenovo a2020a40": [
        "LE"
    ],
    "lenovo a6010pro": [
        "LE"
    ],
    "mercury": [
        "TR"
    ],
    "nomi i5011": [
        "NM"
    ],
    "nomi i5010": [
        "NM"
    ],
    "nomi i506": [
        "NM"
    ],
    "nomi_i4070": [
        "NM"
    ],
    "crono 54": [
        "MJ"
    ],
    "psp3515duo_ru": [
        "PR"
    ],
    "psp3515duo": [
        "PR"
    ],
    "power_5s": [
        "UL"
    ],
    "power_3s": [
        "UL"
    ],
    "power_3l": [
        "UL"
    ],
    "powermaxp490s_eu": [
        "ED"
    ],
    "psp3528duo": [
        "PR"
    ],
    "psp3527duo": [
        "PR"
    ],
    "psp3512duo": [
        "PR"
    ],
    "psp3468duo": [
        "PR"
    ],
    "smart5plus32gb": [
        "NG"
    ],
    "lenovo pb1-770m": [
        "LE"
    ],
    "lenovo x3a40": [
        "LE"
    ],
    "lenovo s1la40": [
        "LE"
    ],
    "paris_x": [
        "UL"
    ],
    "lenovo l78051": [
        "LE"
    ],
    "lenovo l39051": [
        "LE"
    ],
    "vivo xl3 plus": [
        "BU",
        "VV"
    ],
    "lenovo a7010": [
        "LE"
    ],
    "htc 2q4r100": [
        "HT"
    ],
    "htc u11 eyes": [
        "HT"
    ],
    "doro 8035": [
        "DR"
    ],
    "xt1609": [
        "MR"
    ],
    "xt1565": [
        "MR"
    ],
    "xt1564": [
        "MR"
    ],
    "xt1635-01": [
        "MR"
    ],
    "z558vl": [
        "ZT"
    ],
    "n9517": [
        "ZT"
    ],
    "z986u": [
        "ZT"
    ],
    "santin ovvi": [
        "SQ"
    ],
    "p6000_plus": [
        "UL"
    ],
    "asus_x00tde": [
        "AU"
    ],
    "neffos c9s": [
        "NF"
    ],
    "neffos c7s": [
        "NF"
    ],
    "neffos c9 max": [
        "NF"
    ],
    "nobby x800 pro": [
        "N6"
    ],
    "mi mix 3 5g": [
        "XI"
    ],
    "mi 8": [
        "XI"
    ],
    "mi 8 explorer edition": [
        "XI"
    ],
    "mi 3c": [
        "XI"
    ],
    "mi max": [
        "XI"
    ],
    "axon mini": [
        "ZT"
    ],
    "mi a2": [
        "XI"
    ],
    "myphone_fun6lite": [
        "MY1"
    ],
    "myphone_fun_7_lte": [
        "MY1"
    ],
    "myphone_fun_18x9_eea": [
        "MY1"
    ],
    "oppo r9sk": [
        "OP"
    ],
    "robby2": [
        "WI"
    ],
    "luck_l120_4g": [
        "VX"
    ],
    "luck_l100_3g": [
        "VX"
    ],
    "lt_s10_lite": [
        "QL"
    ],
    "iqa27x_e": [
        "LS"
    ],
    "iris90": [
        "LV"
    ],
    "htc u12 life": [
        "HT"
    ],
    "goalplus": [
        "JG"
    ],
    "redmi go": [
        "XI"
    ],
    "redmi 4 prime": [
        "XI"
    ],
    "pvg100e_ru": [
        "PM"
    ],
    "pvg100": [
        "PM"
    ],
    "archos core 57s ultra": [
        "AR"
    ],
    "archos core 55s ultra": [
        "AR"
    ],
    "archos access 50s 4g": [
        "AR"
    ],
    "a511 harmony": [
        "BV",
        "AC"
    ],
    "soldier": [
        "EL"
    ],
    "hammer_iron_3": [
        "HAM"
    ],
    "nomi_i5710": [
        "NM"
    ],
    "oppo r11s": [
        "OP"
    ],
    "oppo r11st": [
        "OP"
    ],
    "oppo r11 pluskt": [
        "OP"
    ],
    "alpha 20": [
        "41"
    ],
    "bkl-al00": [
        "HU"
    ],
    "bla-al00": [
        "HU"
    ],
    "core-x4": [
        "C1"
    ],
    "rmx3350": [
        "RE"
    ],
    "rmx3115": [
        "RE"
    ],
    "rmx2205": [
        "RE"
    ],
    "sm-a015f": [
        "SA"
    ],
    "tecno f2lte": [
        "TB"
    ],
    "zte blade a3 2019": [
        "ZT"
    ],
    "lenovo z90-7": [
        "LE"
    ],
    "lenovo x3c50": [
        "LE"
    ],
    "lenovo x3 lite": [
        "LE"
    ],
    "tis001_s4": [
        "JY"
    ],
    "twist 4": [
        "PS"
    ],
    "sm-a705w": [
        "SA"
    ],
    "sm-a705yn": [
        "SA"
    ],
    "lenovo k30-w": [
        "LE"
    ],
    "lenovo x3c70": [
        "LE"
    ],
    "lenovo l38031": [
        "LE"
    ],
    "thl t12": [
        "T4"
    ],
    "j9s_pro": [
        "JS"
    ],
    "iqg550": [
        "LS"
    ],
    "omix x300": [
        "QQ"
    ],
    "blueline": [
        "GO"
    ],
    "sm-a025u": [
        "SA"
    ],
    "xq-be52": [
        "SO"
    ],
    "tc21": [
        "PZ"
    ],
    "infinix x6511b": [
        "IF"
    ],
    "infinix x689f": [
        "IF"
    ],
    "itel p681lm": [
        "IZ"
    ],
    "p13_blue_maks": [
        "RD"
    ],
    "alfa 1": [
        "L5"
    ],
    "so-41b": [
        "SO"
    ],
    "so-52b": [
        "SO"
    ],
    "a102so": [
        "SO"
    ],
    "cph2099": [
        "OP"
    ],
    "opg02": [
        "OP"
    ],
    "asus_i005dc": [
        "AU"
    ],
    "m2101k9r": [
        "XI"
    ],
    "cph2199": [
        "OP"
    ],
    "sne-lx2": [
        "HU"
    ],
    "cph2303": [
        "OP"
    ],
    "sh-51b": [
        "SH"
    ],
    "sc-51b": [
        "SA",
        "SU"
    ],
    "f-05j": [
        "FU"
    ],
    "f-41b": [
        "FU"
    ],
    "sh-01m": [
        "SH"
    ],
    "moto g(8) plus": [
        "MR"
    ],
    "201hw": [
        "HU"
    ],
    "sog04": [
        "SO"
    ],
    "sh-53a": [
        "SH"
    ],
    "sm-g973c": [
        "SA"
    ],
    "so-51b": [
        "SO"
    ],
    "sc-52b": [
        "SA",
        "SU"
    ],
    "moto g(30)": [
        "MR"
    ],
    "moto g pro": [
        "MR"
    ],
    "sog03": [
        "SO"
    ],
    "a101op": [
        "OP"
    ],
    "a101sh": [
        "SH"
    ],
    "xq-as42": [
        "SO"
    ],
    "sc-53b": [
        "SA",
        "SU"
    ],
    "sonyericssonis11s": [
        "SE"
    ],
    "f-01k": [
        "FU"
    ],
    "f-02h": [
        "FU"
    ],
    "shv37": [
        "SH"
    ],
    "sc-04f": [
        "SA",
        "SU"
    ],
    "sc-03e": [
        "SA",
        "SU"
    ],
    "so51aa": [
        "SO"
    ],
    "stk-l22": [
        "HU"
    ],
    "moto g (5) plus": [
        "MR"
    ],
    "f-05f": [
        "FU"
    ],
    "rm02": [
        "FU"
    ],
    "huawei vns-l52": [
        "HU"
    ],
    "g8341": [
        "SO"
    ],
    "mi 8 ud": [
        "XI"
    ],
    "mi 8 se": [
        "XI"
    ],
    "mi 9 transparent edition": [
        "XI"
    ],
    "mi 6": [
        "XI"
    ],
    "motorola razr (2020)": [
        "MR"
    ],
    "motorola one 5g ace": [
        "MR"
    ],
    "philips s561": [
        "PH"
    ],
    "moto e(6) plus": [
        "MR"
    ],
    "sm-a305yn": [
        "SA"
    ],
    "asus_x008dc": [
        "AU"
    ],
    "asus_x008db": [
        "AU"
    ],
    "aura note 2": [
        "KA"
    ],
    "aqua s9 pro": [
        "IX"
    ],
    "vivo 1606a": [
        "VV"
    ],
    "lava lmx06": [
        "LV"
    ],
    "mi cc 9": [
        "XI"
    ],
    "mi cc 9e": [
        "XI"
    ],
    "mi cc9 pro": [
        "XI"
    ],
    "mi 8 pro": [
        "XI"
    ],
    "mi 6x": [
        "XI"
    ],
    "meizu m8c pro": [
        "M1"
    ],
    "meizu 16xs": [
        "M1"
    ],
    "redmi k20 pro premium edition": [
        "XI"
    ],
    "redmi k30 pro": [
        "XI"
    ],
    "rmx3171": [
        "RE"
    ],
    "rmx2042": [
        "RE"
    ],
    "redmi k20": [
        "XI"
    ],
    "redmi k30": [
        "XI"
    ],
    "redmi y3": [
        "XI"
    ],
    "sm-a605fn": [
        "SA"
    ],
    "impress_sunset4g": [
        "VX"
    ],
    "inoi_7i_lite": [
        "I4"
    ],
    "smart bit": [
        "M9"
    ],
    "le2121": [
        "ON"
    ],
    "nomi_i5730": [
        "NM"
    ],
    "hisense u605": [
        "HI"
    ],
    "tecno kf6m": [
        "TB"
    ],
    "sm-m325fv": [
        "SA"
    ],
    "samsung sm-m325f": [
        "SA"
    ],
    "sm-m325f": [
        "SA"
    ],
    "v2058": [
        "VV"
    ],
    "rmx3195": [
        "RE"
    ],
    "vivo 2015": [
        "VV"
    ],
    "nokia 1.3": [
        "NK"
    ],
    "nokia 3.4": [
        "NK"
    ],
    "nokia 5.3": [
        "NK"
    ],
    "nokia 1.4": [
        "NK"
    ],
    "nokia 5.4": [
        "NK"
    ],
    "nokia 7.2": [
        "NK"
    ],
    "nokia 2 v": [
        "NK"
    ],
    "nokiax2ds": [
        "NK"
    ],
    "nokia 6.2": [
        "NK"
    ],
    "bv4900pro": [
        "B2"
    ],
    "lm-q520n": [
        "LG"
    ],
    "moto g(10)": [
        "MR"
    ],
    "moto g fast": [
        "MR"
    ],
    "lenovo k12 pro": [
        "LE"
    ],
    "moto g 5g": [
        "MR"
    ],
    "iphone9,1": [
        "AP"
    ],
    "tecno f4": [
        "TB"
    ],
    "inoi_7i": [
        "I4"
    ],
    "moto g (5)": [
        "MR"
    ],
    "myphone_prime_3": [
        "MY1"
    ],
    "moto e5 plus": [
        "MR"
    ],
    "moto e5": [
        "MR"
    ],
    "meizu m8c": [
        "M1"
    ],
    "a80s": [
        "B2"
    ],
    "alcatel_5004r": [
        "AL"
    ],
    "bv5100pro": [
        "B2"
    ],
    "bv9900pro": [
        "B2"
    ],
    "col-tl10": [
        "HU"
    ],
    "fp3": [
        "FA"
    ],
    "hisense u40": [
        "HI"
    ],
    "htc 10": [
        "HT"
    ],
    "htc 10 evo": [
        "HT"
    ],
    "ht37pro": [
        "HM"
    ],
    "ht70": [
        "HM"
    ],
    "htc_m9u": [
        "HT"
    ],
    "htc_a9u": [
        "HT"
    ],
    "htcd160lvw": [
        "HT"
    ],
    "meizu m6s": [
        "M1"
    ],
    "vivo nex a": [
        "VV"
    ],
    "mz-u20": [
        "M1"
    ],
    "mz-u10": [
        "M1"
    ],
    "psp7590duo": [
        "PR"
    ],
    "psp5553duo": [
        "PR"
    ],
    "psp5545duo": [
        "PR"
    ],
    "x-play": [
        "H1"
    ],
    "x-go": [
        "H1"
    ],
    "x-pro": [
        "H1"
    ],
    "x_ultra": [
        "H1"
    ],
    "philips_x586": [
        "PH"
    ],
    "sm-a320f": [
        "SA"
    ],
    "coolpad r116": [
        "CO"
    ],
    "vox s504 3g vs5016pg": [
        "D2",
        "LG"
    ],
    "vox s502f 3g vs5004mg": [
        "D2",
        "LG"
    ],
    "vox s502 3g vs5003mg": [
        "D2",
        "LG",
        "OB"
    ],
    "vox s501 3g vs5002pg": [
        "D2",
        "LG",
        "OB"
    ],
    "vox g450 3g vs4001pg": [
        "D2"
    ],
    "p13_blue_max": [
        "RD"
    ],
    "pcam10": [
        "OP"
    ],
    "m2002j9s": [
        "XI"
    ],
    "c11_f": [
        "OE"
    ],
    "c10 pro": [
        "OE"
    ],
    "c11_pro": [
        "OE"
    ],
    "c12 plus": [
        "OE"
    ],
    "c12 pro": [
        "OE"
    ],
    "cc1 pro": [
        "O7"
    ],
    "tecno ax8": [
        "TB"
    ],
    "tecno la6": [
        "TB"
    ],
    "tecno k7": [
        "TB"
    ],
    "tecno wx4": [
        "TB"
    ],
    "tecno camon cx": [
        "TB"
    ],
    "tecno l9 plus": [
        "TB"
    ],
    "bv9000pro-ru": [
        "B2"
    ],
    "bv9000-ru": [
        "B2"
    ],
    "bv9000-f": [
        "B2"
    ],
    "cgv_ultimate t8": [
        "37"
    ],
    "rmx2194": [
        "RE"
    ],
    "c23 pro": [
        "OE"
    ],
    "c107-9": [
        "CO"
    ],
    "hisense c20s": [
        "HI"
    ],
    "huawei rio-l01": [
        "HU"
    ],
    "asus_z010dd": [
        "AU"
    ],
    "asus_x00ad": [
        "AU"
    ],
    "mi 5c": [
        "XI"
    ],
    "lenovo pb2-650m": [
        "LE"
    ],
    "lenovo k52e78": [
        "LE"
    ],
    "asus_x008da": [
        "AU"
    ],
    "ht20pro": [
        "HM"
    ],
    "meizu 6t": [
        "M1"
    ],
    "mi 4s": [
        "XI"
    ],
    "psp7551duo": [
        "PR"
    ],
    "bv6800pro_ru": [
        "B2"
    ],
    "lgm-x800l": [
        "LG"
    ],
    "cph2269": [
        "OP"
    ],
    "tecno ka7o": [
        "TB"
    ],
    "tecno rb6s": [
        "TB"
    ],
    "tecno sa2s": [
        "TB"
    ],
    "vivo one plus 2019": [
        "BU",
        "VV"
    ],
    "vivo xl4": [
        "BU",
        "VV"
    ],
    "vivo xi": [
        "BU",
        "VV"
    ],
    "vivo xi plus": [
        "BU",
        "VV"
    ],
    "xrover c": [
        "L5"
    ],
    "xrover": [
        "L5"
    ],
    "xt1676": [
        "MR"
    ],
    "xt1039": [
        "MR"
    ],
    "bluboo_s8_plus": [
        "B3"
    ],
    "sailfish": [
        "GO"
    ],
    "aosp on taimen": [
        "GO"
    ],
    "aosp on blueline": [
        "GO"
    ],
    "a33w": [
        "OP"
    ],
    "so-02d": [
        "SO"
    ],
    "y19(eu)": [
        "XG"
    ],
    "amoi_n89": [
        "AO"
    ],
    "cheetah": [
        "CB"
    ],
    "harrier from ee": [
        "E6"
    ],
    "z2_pro": [
        "UM"
    ],
    "ginzzu rs7d": [
        "GZ"
    ],
    "ginzzu rs91d": [
        "GZ"
    ],
    "ginzzu r8 dual": [
        "GZ"
    ],
    "qumo quest 574": [
        "QO"
    ],
    "qumo quest 530": [
        "QO"
    ],
    "z250": [
        "DX"
    ],
    "ac50bhe": [
        "AR"
    ],
    "lt700_pro": [
        "QM"
    ],
    "lt5216": [
        "2F"
    ],
    "f80s_plus": [
        "2F"
    ],
    "k1_turbo": [
        "KF"
    ],
    "k1 turbo": [
        "KF"
    ],
    "smart ultra 6": [
        "VF"
    ],
    "c13 pro": [
        "OE"
    ],
    "c17 pro": [
        "OE"
    ],
    "4045l": [
        "AL"
    ],
    "6039s": [
        "AL"
    ],
    "710c": [
        "HT"
    ],
    "fun 4 2018": [
        "BM"
    ],
    "flare_j2_lite": [
        "CH"
    ],
    "gome_2018m29a": [
        "G5"
    ],
    "rmx1853": [
        "RE"
    ],
    "s60lite": [
        "DO"
    ],
    "s5_cristal": [
        "46"
    ],
    "x4_cristal": [
        "46"
    ],
    "a5_cristal": [
        "46"
    ],
    "sweet 5+ 2019": [
        "4Q"
    ],
    "sweet6+": [
        "4Q"
    ],
    "sweet 5+": [
        "4Q"
    ],
    "swegue": [
        "J7"
    ],
    "drena": [
        "J7"
    ],
    "cronos": [
        "UQ"
    ],
    "cherry_x740": [
        "CH"
    ],
    "cp-j55a": [
        "75"
    ],
    "cp-j55aw": [
        "75"
    ],
    "cp-j55ax": [
        "75"
    ],
    "coral 4": [
        "49"
    ],
    "quantum_2_400s": [
        "GC"
    ],
    "quantum_2_500_rugged": [
        "GC"
    ],
    "quantum_2_550": [
        "GC"
    ],
    "quantum_5_500_rugged": [
        "GC"
    ],
    "quantum_3_550_rugged": [
        "GC"
    ],
    "quantum_3_500_lite": [
        "GC"
    ],
    "quantum_3_500": [
        "GC"
    ],
    "rome x": [
        "UM"
    ],
    "stylo f1": [
        "69"
    ],
    "stylo sv61 vector+": [
        "69"
    ],
    "stylo_s9_topaz": [
        "69"
    ],
    "stylo sm61 magic+": [
        "69"
    ],
    "s57_azure": [
        "69"
    ],
    "s57_alure": [
        "69"
    ],
    "glaze": [
        "HR"
    ],
    "rebel": [
        "4M"
    ],
    "regal r2": [
        "82"
    ],
    "riviera u963": [
        "RV"
    ],
    "hm-i559-fl": [
        "HA"
    ],
    "hm-i560-fl": [
        "HA"
    ],
    "hm-g553-fl": [
        "HA"
    ],
    "hm-n701-fl": [
        "HA"
    ],
    "5028d": [
        "AL"
    ],
    "5029a": [
        "AL"
    ],
    "5030d": [
        "AL"
    ],
    "5030d_eea": [
        "AL"
    ],
    "5030u": [
        "AL"
    ],
    "5030e_ru": [
        "AL"
    ],
    "5030f_eea": [
        "AL"
    ],
    "5061u": [
        "AL"
    ],
    "vyper pro": [
        "LL"
    ],
    "lp daisy": [
        "LL"
    ],
    "machfive": [
        "KA"
    ],
    "machone": [
        "KA"
    ],
    "machoneplus": [
        "KA"
    ],
    "powerfive": [
        "H2"
    ],
    "starmobile up max": [
        "18"
    ],
    "grand max": [
        "BU"
    ],
    "grand mini": [
        "BU"
    ],
    "grand2c": [
        "LV"
    ],
    "gome 2017x82a": [
        "G5"
    ],
    "ultra_vision_plus": [
        "HN"
    ],
    "cameleon c5": [
        "00"
    ],
    "c8finger": [
        "2F"
    ],
    "xq-bt44": [
        "SO"
    ],
    "xq-bc72": [
        "SO"
    ],
    "asus_i005d": [
        "AU"
    ],
    "kyv35": [
        "KY"
    ],
    "j9150": [
        "SO"
    ],
    "class s300 lte": [
        "4Y"
    ],
    "exmart k1": [
        "4Z"
    ],
    "matter": [
        "6I"
    ],
    "milky_way_m2": [
        "1I"
    ],
    "minerva": [
        "UQ"
    ],
    "mito_a37_z1plus": [
        "8M"
    ],
    "mito_a36_w1": [
        "8M"
    ],
    "minerva_32gb": [
        "UQ"
    ],
    "mito a77": [
        "8M"
    ],
    "mito a900": [
        "8M"
    ],
    "dns s-4003": [
        "DN"
    ],
    "himax polymer x": [
        "W3"
    ],
    "himax polymer": [
        "W3"
    ],
    "himax_pure_3s": [
        "W3"
    ],
    "himax pure 3s": [
        "W3"
    ],
    "hymi 5s plus": [
        "HN"
    ],
    "juno q6": [
        "2M"
    ],
    "juno q7": [
        "2M"
    ],
    "juno_q5": [
        "2M"
    ],
    "p8_3d": [
        "EL"
    ],
    "p8_max": [
        "EL"
    ],
    "lte_lima": [
        "TL"
    ],
    "lp_veyron": [
        "LL"
    ],
    "lp_prado": [
        "LL"
    ],
    "luna_ii": [
        "MY1"
    ],
    "luna g55": [
        "L9",
        "69"
    ],
    "lte mike": [
        "TL"
    ],
    "lavax10": [
        "LV"
    ],
    "passion p1": [
        "QY"
    ],
    "passion p2": [
        "QY"
    ],
    "passion p3": [
        "QY"
    ],
    "passion p5": [
        "QY"
    ],
    "passion p6": [
        "QY"
    ],
    "hynex plus": [
        "QY"
    ],
    "hynex plus 2": [
        "QY"
    ],
    "stark k1": [
        "QY"
    ],
    "hynex h3": [
        "QY"
    ],
    "hynex h3+": [
        "QY"
    ],
    "hynex h6+": [
        "QY"
    ],
    "hynex h5+": [
        "QY"
    ],
    "hynex h5": [
        "QY"
    ],
    "levin v1": [
        "QY"
    ],
    "levin v2": [
        "QY"
    ],
    "sm-a037f": [
        "SA"
    ],
    "21061119dg": [
        "XI"
    ],
    "rmx3363": [
        "RE"
    ],
    "tecno bd2p": [
        "TB"
    ],
    "m2012k10c": [
        "XI"
    ],
    "nokia xr20": [
        "NK"
    ],
    "21061119ag": [
        "XI"
    ],
    "tecno kf6j": [
        "TB"
    ],
    "rmx2156": [
        "RE"
    ],
    "sm-a225f": [
        "SA"
    ],
    "moto g(50)": [
        "MR"
    ],
    "zte blade a31ru": [
        "ZT"
    ],
    "zte blade a51 lite ru": [
        "ZT"
    ],
    "zte blade a51ru": [
        "ZT"
    ],
    "zte blade a51": [
        "ZT"
    ],
    "legend max": [
        "4M"
    ],
    "v2050": [
        "VV"
    ],
    "zte blade a31": [
        "ZT"
    ],
    "rmx3161": [
        "RE"
    ],
    "rmx3366": [
        "RE"
    ],
    "cph2235": [
        "OP"
    ],
    "wp13": [
        "OE"
    ],
    "kingkong 7": [
        "CB"
    ],
    "armor 11t 5g": [
        "UL"
    ],
    "armor 8 pro": [
        "UL"
    ],
    "de2117": [
        "ON"
    ],
    "dn2101": [
        "ON"
    ],
    "bison pro": [
        "UM"
    ],
    "i2012": [
        "VV"
    ],
    "m2101k9ai": [
        "XI"
    ],
    "t671f": [
        "TC"
    ],
    "sm-g9860": [
        "SA"
    ],
    "redmi 9": [
        "XI"
    ],
    "s97pro": [
        "DO"
    ],
    "eb2101": [
        "ON"
    ],
    "eb2103": [
        "ON"
    ],
    "t766u": [
        "TC"
    ],
    "t775h": [
        "TC"
    ],
    "zte a7030": [
        "ZT"
    ],
    "zte a2022pg": [
        "ZT"
    ],
    "zte 8030ru": [
        "ZT"
    ],
    "power armor 13": [
        "UL"
    ],
    "tecno kf6k": [
        "TB"
    ],
    "hisense e50 lite": [
        "HI"
    ],
    "hisense e50": [
        "HI"
    ],
    "hisense infinity h50": [
        "HI"
    ],
    "hisense infinity h50 lite": [
        "HI"
    ],
    "live 9": [
        "KE"
    ],
    "flow 9": [
        "KE"
    ],
    "n40pro": [
        "DO"
    ],
    "x96pro": [
        "DO"
    ],
    "w-v745-eea": [
        "WI"
    ],
    "w-k610-eea": [
        "WI"
    ],
    "v2043_21": [
        "VV"
    ],
    "infinix x689c": [
        "IF"
    ],
    "moto g(100)": [
        "MR"
    ],
    "infinix x659b": [
        "IF"
    ],
    "infinix x689": [
        "IF"
    ],
    "infinix x689b": [
        "IF"
    ],
    "infinix x689d": [
        "IF"
    ],
    "m2012k11ai": [
        "XI"
    ],
    "mi 11 lite": [
        "XI"
    ],
    "mi cc9 pro premium edition": [
        "XI"
    ],
    "m2102k1ac": [
        "XI"
    ],
    "moto g (5s)": [
        "MR"
    ],
    "moto z2": [
        "MR"
    ],
    "sm-m625f": [
        "SA"
    ],
    "sm-g988w": [
        "SA"
    ],
    "sm-g973n": [
        "SA"
    ],
    "sm-g9730": [
        "SA"
    ],
    "sm-g780g": [
        "SA"
    ],
    "a440": [
        "DX"
    ],
    "sm-a526b": [
        "SA"
    ],
    "sm-a5260": [
        "SA"
    ],
    "sm-a515u1": [
        "SA"
    ],
    "galahad": [
        "XI"
    ],
    "mi 11i": [
        "XI"
    ],
    "mi 11": [
        "XI"
    ],
    "hmd global nokia 2.3": [
        "NK"
    ],
    "bq-6051g": [
        "BX"
    ],
    "sm-g981n": [
        "SA"
    ],
    "sm-g973u1": [
        "SA"
    ],
    "sm-g973u": [
        "SA"
    ],
    "sm-g525f": [
        "SA"
    ],
    "sm-f700n": [
        "SA"
    ],
    "sm-f700f": [
        "SA"
    ],
    "nx669j": [
        "57"
    ],
    "tecno sc7s": [
        "TB"
    ],
    "tecno rb7s": [
        "TB"
    ],
    "tecno lb6": [
        "TB"
    ],
    "le_connect": [
        "LM"
    ],
    "tecno kc6s": [
        "TB"
    ],
    "ithemba": [
        "69"
    ],
    "nubia m2": [
        "57"
    ],
    "i7i 2020": [
        "QM"
    ],
    "s56 mist": [
        "69"
    ],
    "switch go": [
        "4M"
    ],
    "s53_stark": [
        "69"
    ],
    "ack1010": [
        "X6"
    ],
    "kicka 5 plus 4g": [
        "VM",
        "6W"
    ],
    "m2010j19sl": [
        "XI"
    ],
    "magno c1": [
        "ZU"
    ],
    "tecno lc7s": [
        "TB"
    ],
    "tecno kd7s": [
        "TB"
    ],
    "tecno cd6s": [
        "TB"
    ],
    "wp10": [
        "OE"
    ],
    "wp9": [
        "OE"
    ],
    "xt2125-4": [
        "MR"
    ],
    "asus_z010da": [
        "AU"
    ],
    "asus_z00udb": [
        "AU"
    ],
    "le2127": [
        "ON"
    ],
    "le2117": [
        "ON"
    ],
    "i1928": [
        "VV"
    ],
    "itel w5006x": [
        "IZ"
    ],
    "pulse_1": [
        "4M"
    ],
    "s86pro": [
        "DO"
    ],
    "s88plus": [
        "DO"
    ],
    "s62 pro": [
        "CA"
    ],
    "s40_life": [
        "69"
    ],
    "s30 ultra apex 2021": [
        "IH"
    ],
    "s21 ultra 4g 2021_eea": [
        "IH"
    ],
    "v2065": [
        "VV"
    ],
    "motorola edge 20 lite": [
        "MR"
    ],
    "ht3_pro": [
        "HM"
    ],
    "ht3 pro": [
        "HM"
    ],
    "xq-ad52": [
        "SO"
    ],
    "x19 s": [
        "CB"
    ],
    "x19": [
        "CB"
    ],
    "iql626": [
        "LS"
    ],
    "k7_pro": [
        "OE"
    ],
    "k3_pro": [
        "OE"
    ],
    "k13_pro": [
        "OE"
    ],
    "mi note 3": [
        "XI"
    ],
    "life_2": [
        "69"
    ],
    "venus v7": [
        "VT"
    ],
    "u4001": [
        "UU"
    ],
    "vf550": [
        "J8"
    ],
    "via_p3": [
        "R4"
    ],
    "trendy 2": [
        "4M"
    ],
    "vivo xi+": [
        "BU",
        "VV"
    ],
    "vivo z1i": [
        "VV"
    ],
    "nokia x71": [
        "NK"
    ],
    "move9": [
        "KE"
    ],
    "mara z": [
        "J4"
    ],
    "mara phones z1": [
        "J4"
    ],
    "mara phones x1": [
        "J4"
    ],
    "mara s": [
        "J4"
    ],
    "moto z (2)": [
        "MR"
    ],
    "ta-1038": [
        "NK"
    ],
    "ta-1033": [
        "NK"
    ],
    "ta-1028": [
        "NK"
    ],
    "ta-1025": [
        "NK"
    ],
    "ta-1020": [
        "NK"
    ],
    "myphone_city_2": [
        "MY1"
    ],
    "myphone_fun_6": [
        "MY1"
    ],
    "nokia c1 plus": [
        "NK"
    ],
    "zs672ks": [
        "AU"
    ],
    "lenovo pb1-750m": [
        "LE"
    ],
    "cp3706as": [
        "CO"
    ],
    "cp3669as": [
        "CO"
    ],
    "c6 2020": [
        "BU"
    ],
    "i3213": [
        "SO"
    ],
    "nubia n11": [
        "57"
    ],
    "cph2271": [
        "OP"
    ],
    "tecno cc7s": [
        "TB"
    ],
    "hisense infinity e30 lite": [
        "HI"
    ],
    "c note 2": [
        "UM"
    ],
    "samsung sm-m426b": [
        "SA"
    ],
    "nx549j": [
        "57"
    ],
    "sm-a102u1": [
        "SA"
    ],
    "tecno w2": [
        "TB"
    ],
    "lenovo l78121": [
        "LE"
    ],
    "sm-g988u": [
        "SA"
    ],
    "sm-m022g": [
        "SA"
    ],
    "sm-a125u": [
        "SA"
    ],
    "m2012k11i": [
        "XI"
    ],
    "zte 8030": [
        "ZT"
    ],
    "wkg-lx9": [
        "HU"
    ],
    "lm-v500": [
        "LG"
    ],
    "sm-a015g": [
        "SA"
    ],
    "v2069": [
        "VV"
    ],
    "mi 5x": [
        "XI"
    ],
    "sm-a226b": [
        "SA"
    ],
    "jsc-an00": [
        "HU"
    ],
    "sm-a307gn": [
        "SA"
    ],
    "rocket ii": [
        "ZU"
    ],
    "sm-j810f": [
        "SA"
    ],
    "rio_ss": [
        "4M"
    ],
    "oppo a79kt": [
        "OP"
    ],
    "nomi i6030": [
        "NM"
    ],
    "nomi_i5511": [
        "NM"
    ],
    "lg-us701": [
        "LG"
    ],
    "lgm-x401l": [
        "LG"
    ],
    "lgm-k121l": [
        "LG"
    ],
    "lgm-k121k": [
        "LG"
    ],
    "lgm-g600k": [
        "LG"
    ],
    "lgms210": [
        "LG"
    ],
    "lg-f720l": [
        "LG"
    ],
    "xq-bt52": [
        "SO"
    ],
    "archos 55 helium": [
        "AR"
    ],
    "bv9500plus": [
        "B2"
    ],
    "sm-m215g": [
        "SA"
    ],
    "n5501l": [
        "NL"
    ],
    "sm-j810g": [
        "SA"
    ],
    "sov42-u": [
        "SO"
    ],
    "sm-j530k": [
        "SA"
    ],
    "sm-j530s": [
        "SA"
    ],
    "sm-j530l": [
        "SA"
    ],
    "c18_pro": [
        "OE"
    ],
    "cp3648at": [
        "CO"
    ],
    "lm-q815l": [
        "LG"
    ],
    "lm-q815k": [
        "LG"
    ],
    "zte a7020ru": [
        "ZT"
    ],
    "ale-l02": [
        "HU"
    ],
    "3917jr": [
        "95"
    ],
    "p710": [
        "95"
    ],
    "c330": [
        "95"
    ],
    "g8142": [
        "SO"
    ],
    "startrail 8 nfc": [
        "SX"
    ],
    "coolpad e501_eu": [
        "CO"
    ],
    "t766h_ru": [
        "TC"
    ],
    "zte a2020ru pro": [
        "ZT"
    ],
    "coolpad e502": [
        "CO"
    ],
    "vox v40 3g vt4055mg": [
        "D2"
    ],
    "clik plus": [
        "4M"
    ],
    "wp12 pro": [
        "OE"
    ],
    "jat-al00": [
        "HU"
    ],
    "ixion ms550": [
        "DX"
    ],
    "intex cloud glory n": [
        "IX"
    ],
    "santin v9 pro": [
        "SQ"
    ],
    "santin d": [
        "SQ"
    ],
    "santin classone": [
        "SQ"
    ],
    "zte blade v7 plus": [
        "ZT"
    ],
    "huawei y560-l01": [
        "HU"
    ],
    "p760": [
        "8L"
    ],
    "x-treme_pq20": [
        "1S"
    ],
    "x-treme_pq37": [
        "1S"
    ],
    "bv9600e": [
        "B2"
    ],
    "x-treme_pq36": [
        "1S"
    ],
    "vivo 1916": [
        "VV"
    ],
    "noa vivo": [
        "N5"
    ],
    "itel w6004": [
        "IZ"
    ],
    "zte 9030": [
        "ZT"
    ],
    "zte a2021e": [
        "ZT"
    ],
    "fs8014": [
        "SH"
    ],
    "psp7572duo": [
        "PR"
    ],
    "htc_e9pw": [
        "HT"
    ],
    "le2111": [
        "ON"
    ],
    "w-v750bn-eea": [
        "WI"
    ],
    "h8116": [
        "SO"
    ],
    "m6 mirror": [
        "GI"
    ],
    "mz-m1 e": [
        "M1"
    ],
    "mz-m3": [
        "M1"
    ],
    "mz-mx4": [
        "M1"
    ],
    "mz-m3 max": [
        "M1"
    ],
    "lenovo k5 pro": [
        "LE"
    ],
    "sm-a260f": [
        "SA"
    ],
    "lg-f750k": [
        "LG"
    ],
    "ang-lx1": [
        "HU"
    ],
    "h3213": [
        "SO"
    ],
    "ah9910": [
        "LV"
    ],
    "cdy-an95": [
        "HU"
    ],
    "oce-an10": [
        "HU"
    ],
    "zte v1000": [
        "ZT"
    ],
    "dt2002c": [
        "S7"
    ],
    "zte v1050": [
        "ZT"
    ],
    "v2121a": [
        "VV"
    ],
    "vivo x20plus a": [
        "VV"
    ],
    "pdet10": [
        "OP"
    ],
    "vivo nex": [
        "VV"
    ],
    "peqm00": [
        "OP"
    ],
    "peym00": [
        "OP"
    ],
    "v2111a": [
        "VV"
    ],
    "sm-c9000": [
        "SA"
    ],
    "htc 2q55300": [
        "HT"
    ],
    "l7620de": [
        "XL"
    ],
    "v2059a": [
        "VV"
    ],
    "konka 418": [
        "KO"
    ],
    "pepm00": [
        "OP"
    ],
    "penm00": [
        "OP"
    ],
    "cdy-tn90": [
        "HU"
    ],
    "m2104k10i": [
        "0P"
    ],
    "pexm00": [
        "OP"
    ],
    "nza-al00": [
        "HNR"
    ],
    "brq-al00": [
        "HU"
    ],
    "bkl-tl10": [
        "HU"
    ],
    "brq-an00": [
        "HU"
    ],
    "ana-al00": [
        "HU"
    ],
    "meizu 18 pro": [
        "M1"
    ],
    "meizu 18": [
        "M1"
    ],
    "vivo v3max a": [
        "VV"
    ],
    "vivo v3max": [
        "VV"
    ],
    "vivo v3max l": [
        "VV"
    ],
    "vivo x21i": [
        "VV"
    ],
    "vivo x21ud a": [
        "VV"
    ],
    "vivo x21ud": [
        "VV"
    ],
    "vivo go": [
        "BU",
        "VV"
    ],
    "vivo x9i": [
        "VV"
    ],
    "vivo x9s l": [
        "VV"
    ],
    "vivo x9s plus": [
        "VV"
    ],
    "vivo x9s plus l": [
        "VV"
    ],
    "vivo xplay6": [
        "VV"
    ],
    "vivo y71": [
        "VV"
    ],
    "vivo y71a": [
        "VV"
    ],
    "vivo y75s": [
        "VV"
    ],
    "vivo y83": [
        "VV"
    ],
    "vivo y83a": [
        "VV"
    ],
    "vivo y85a": [
        "VV"
    ],
    "vivo y85": [
        "VV"
    ],
    "vivo x21a": [
        "VV"
    ],
    "vivo 2005": [
        "VV"
    ],
    "v2143a": [
        "VV"
    ],
    "v2141a": [
        "VV"
    ],
    "v2136a": [
        "VV"
    ],
    "v2134a": [
        "VV"
    ],
    "v2123a": [
        "VV"
    ],
    "v2133a": [
        "VV"
    ],
    "v2106a": [
        "VV"
    ],
    "v2085a": [
        "VV"
    ],
    "htc u-3w": [
        "HT"
    ],
    "htc 2q4d200": [
        "HT"
    ],
    "hnr550t": [
        "HI"
    ],
    "hnr551t": [
        "HI"
    ],
    "hlte216m": [
        "HI"
    ],
    "20190620g": [
        "GI"
    ],
    "rmx2052": [
        "RE"
    ],
    "rmx3122": [
        "RE"
    ],
    "noh-an01": [
        "HU"
    ],
    "sm-a325n": [
        "SA"
    ],
    "vivo x6plus a": [
        "VV"
    ],
    "vivo x7plus": [
        "VV"
    ],
    "vivo 1937": [
        "VV"
    ],
    "vivo 1613": [
        "VV"
    ],
    "vivo 1707": [
        "VV"
    ],
    "vivo x5l": [
        "VV"
    ],
    "vivo x5pro l": [
        "VV"
    ],
    "vivo x5pro d": [
        "VV"
    ],
    "vivo y613": [
        "VV"
    ],
    "vivo y66i a": [
        "VV"
    ],
    "vivo y66i": [
        "VV"
    ],
    "vivo y79": [
        "VV"
    ],
    "vivo y79a": [
        "VV"
    ],
    "vivo x9plus l": [
        "VV"
    ],
    "vivo 1801i": [
        "VV"
    ],
    "vivo 1802": [
        "VV"
    ],
    "vivo 1812_19": [
        "VV"
    ],
    "vivo 1820_19": [
        "VV"
    ],
    "vivo 1850": [
        "VV"
    ],
    "vivo 2015_21": [
        "VV"
    ],
    "vivo y75a": [
        "VV"
    ],
    "vivo y75": [
        "VV"
    ],
    "vivo x6a": [
        "VV"
    ],
    "vivo x20a": [
        "VV"
    ],
    "vivo x21": [
        "VV"
    ],
    "vivo y69a": [
        "VV"
    ],
    "vivo x710l": [
        "VV"
    ],
    "vivo xplay6l": [
        "VV"
    ],
    "vivo y67l": [
        "VV"
    ],
    "vivo y67a": [
        "VV"
    ],
    "vivo y67": [
        "VV"
    ],
    "vivo xplay5s": [
        "VV"
    ],
    "blu vivo 5 mini": [
        "BU",
        "VV"
    ],
    "vivo y66l": [
        "VV"
    ],
    "vivo x9l": [
        "VV"
    ],
    "vivo 1908": [
        "VV"
    ],
    "vivo 1908_19": [
        "VV"
    ],
    "vivo 4g_r": [
        "N5"
    ],
    "vivo x6s a": [
        "VV"
    ],
    "vivo x6splus d": [
        "VV"
    ],
    "vivo y21l": [
        "VV"
    ],
    "vivo y51": [
        "VV"
    ],
    "vivo y51a": [
        "VV"
    ],
    "vivo x6plus d": [
        "VV"
    ],
    "vivo 1906_20": [
        "VV"
    ],
    "vivo y27": [
        "VV"
    ],
    "vivo y27l": [
        "VV"
    ],
    "vivo y23l": [
        "VV"
    ],
    "vivo 2007": [
        "VV"
    ],
    "vivo x6plus l": [
        "VV"
    ],
    "vivo x6l": [
        "VV"
    ],
    "vivo x6d": [
        "VV"
    ],
    "vivo xl3": [
        "BU",
        "VV"
    ],
    "vivo xplay5a": [
        "VV"
    ],
    "vivo x7l": [
        "VV"
    ],
    "vivo y31l": [
        "VV"
    ],
    "vivo y31a": [
        "VV"
    ],
    "vivo y31": [
        "VV"
    ],
    "vivo y66": [
        "VV"
    ],
    "vivo 1813": [
        "VV"
    ],
    "vivo y55l": [
        "VV"
    ],
    "vivo y55a": [
        "VV"
    ],
    "vivo y55": [
        "VV"
    ],
    "vivo y37a": [
        "VV"
    ],
    "vivo y37": [
        "VV"
    ],
    "f2_color5_5": [
        "ZP"
    ],
    "f5_color_m5": [
        "ZP"
    ],
    "f80 piabella": [
        "2F"
    ],
    "flow 4 plus": [
        "KE"
    ],
    "cosmos v15": [
        "HV"
    ],
    "cosmos v13": [
        "HV"
    ],
    "cosmos v4": [
        "HV"
    ],
    "cosmos v8": [
        "HV"
    ],
    "cosmos v8-2": [
        "HV"
    ],
    "dingding-sk7": [
        "5D"
    ],
    "dingding sk5": [
        "5D"
    ],
    "dive 50": [
        "OR"
    ],
    "dive 50 dual": [
        "OR"
    ],
    "gionee s10l": [
        "GI"
    ],
    "gionee s10b": [
        "GI"
    ],
    "gionee s10bl": [
        "GI"
    ],
    "tecno kc8s": [
        "TB"
    ],
    "m4_r2": [
        "MN"
    ],
    "kempler_9": [
        "KS"
    ],
    "io light": [
        "R1"
    ],
    "io 3d": [
        "R1"
    ],
    "neffos_c7a": [
        "NF"
    ],
    "s49_poise": [
        "69"
    ],
    "s49 mono": [
        "69"
    ],
    "s49 eco": [
        "69"
    ],
    "s55 nova": [
        "69"
    ],
    "5001u": [
        "AL"
    ],
    "santin 11 xs max": [
        "SQ"
    ],
    "pure plus": [
        "4M"
    ],
    "psp7512duo": [
        "PR"
    ],
    "psp3471duo": [
        "PR"
    ],
    "psp5552duo": [
        "PR"
    ],
    "psp3470duo": [
        "PR"
    ],
    "psp5511duo": [
        "PR"
    ],
    "psp5518duo": [
        "PR"
    ],
    "psp5520duo": [
        "PR"
    ],
    "psp7570duo": [
        "PR"
    ],
    "itel a52s lite": [
        "IZ"
    ],
    "x_tigi_a1": [
        "XT"
    ],
    "micromax q421": [
        "MI"
    ],
    "micromax q402plus": [
        "MI"
    ],
    "micromax q357": [
        "MI"
    ],
    "micromax bharat 5": [
        "MI"
    ],
    "micromax c1a": [
        "MI"
    ],
    "micromax c2apls": [
        "MI"
    ],
    "k10000 mix": [
        "OE",
        "XI"
    ],
    "cobra": [
        "HR"
    ],
    "easy_xl": [
        "H2"
    ],
    "alcatel_6060c": [
        "AL"
    ],
    "lg-f650s": [
        "LG"
    ],
    "lg-f650l": [
        "LG"
    ],
    "lg-f650k": [
        "LG"
    ],
    "m4 ss4453-r": [
        "MN"
    ],
    "m555i": [
        "8L"
    ],
    "m557": [
        "8L"
    ],
    "p2lite": [
        "B2"
    ],
    "c103": [
        "CO"
    ],
    "c105-8": [
        "CO"
    ],
    "htc desire 10 lifestyle": [
        "HT"
    ],
    "htc desire 530": [
        "HT"
    ],
    "htc desire 630 dual sim": [
        "HT"
    ],
    "c106": [
        "CO"
    ],
    "c106-8": [
        "CO"
    ],
    "coolpad 5370": [
        "CO"
    ],
    "micromax q465": [
        "MI"
    ],
    "micromax q462": [
        "MI"
    ],
    "micromax e451": [
        "MI"
    ],
    "lg-h950": [
        "LG"
    ],
    "lg-k120": [
        "LG"
    ],
    "lg-h634": [
        "LG"
    ],
    "lg-f670k": [
        "LG"
    ],
    "lg-f570s": [
        "LG"
    ],
    "was-lx2": [
        "HU"
    ],
    "ppa-al20": [
        "HU"
    ],
    "primo gh9": [
        "WA"
    ],
    "p13_blue_plus": [
        "RD"
    ],
    "orange nola play": [
        "OR"
    ],
    "neo lte": [
        "4M"
    ],
    "rmx3203": [
        "RE"
    ],
    "n5002l": [
        "NL"
    ],
    "myphone_prime_5": [
        "MY1"
    ],
    "mdg1": [
        "XI"
    ],
    "nen-lx1": [
        "HU"
    ],
    "nen-l22": [
        "HU"
    ],
    "koz-al40": [
        "HNR"
    ],
    "hlte103e": [
        "HI"
    ],
    "hisense v40": [
        "HI"
    ],
    "hisense u3 2021": [
        "HI"
    ],
    "hisense infinity h50 zoom": [
        "HI"
    ],
    "hisense infinity h40": [
        "HI"
    ],
    "hisense h40 lite": [
        "HI"
    ],
    "gravity m": [
        "ZU"
    ],
    "live 8": [
        "KE"
    ],
    "moto e(6i)": [
        "MR"
    ],
    "moto e(7) power": [
        "MR"
    ],
    "blackberry 9900": [
        "RM"
    ],
    "blackberry 9700": [
        "RM"
    ],
    "daytona-g12": [
        "94"
    ],
    "2109119dg": [
        "XI"
    ],
    "21081111rg": [
        "XI"
    ],
    "cph2036": [
        "OP"
    ],
    "cph2237": [
        "OP"
    ],
    "cph2247": [
        "OP"
    ],
    "de2118": [
        "ON"
    ],
    "like 11 panda pro 2022": [
        "IH"
    ],
    "proline_falconxl": [
        "P6"
    ],
    "ridge plus": [
        "HR"
    ],
    "rush plus": [
        "HR"
    ],
    "p13_blue": [
        "RD"
    ],
    "s64_alpha": [
        "69"
    ],
    "hero_ds": [
        "4M"
    ],
    "azumi v4": [
        "AM"
    ],
    "azumi a5": [
        "AM"
    ],
    "pace 2 lite": [
        "KT"
    ],
    "4good s502m 4g": [
        "4G"
    ],
    "psp5524duo": [
        "PR"
    ],
    "v2109": [
        "VV"
    ],
    "v2026_21": [
        "VV"
    ],
    "wp15": [
        "OE"
    ],
    "tecno cg6j": [
        "TB"
    ],
    "v2068": [
        "VV"
    ],
    "rmx3151": [
        "RE"
    ],
    "ravoz z7 pro": [
        "R9"
    ],
    "revvl v+ 5g": [
        "TM"
    ],
    "r2022": [
        "5F"
    ],
    "nx666j": [
        "57"
    ],
    "nth-nx9": [
        "HNR"
    ],
    "kt5512": [
        "X6"
    ],
    "motorola edge 20 pro": [
        "MR",
        "SPX"
    ],
    "zenfone 5z": [
        "AU"
    ],
    "nokia c1 2nd edition": [
        "NK"
    ],
    "tecno bc1s": [
        "TB"
    ],
    "v2102": [
        "VV"
    ],
    "v2110": [
        "VV"
    ],
    "v2105": [
        "VV"
    ],
    "sm-m022f": [
        "SA"
    ],
    "zte 9030ru": [
        "ZT"
    ],
    "moto g(60)": [
        "MR"
    ],
    "shark ksr-a0": [
        "XI"
    ],
    "santin shuguo": [
        "SQ"
    ],
    "rmx3263": [
        "RE"
    ],
    "sm-a7050": [
        "SA"
    ],
    "16 x": [
        "M1"
    ],
    "16t": [
        "M1"
    ],
    "4087u": [
        "AL"
    ],
    "4087u_eea": [
        "AL"
    ],
    "5002b": [
        "AL"
    ],
    "5002f_eea": [
        "AL"
    ],
    "5002h": [
        "AL"
    ],
    "5002h_eea": [
        "AL"
    ],
    "a23 max": [
        "Q5"
    ],
    "a3s": [
        "UM"
    ],
    "a3x": [
        "UM"
    ],
    "a355": [
        "DX"
    ],
    "a7s": [
        "UM"
    ],
    "axe_ii": [
        "FP"
    ],
    "c19": [
        "OE"
    ],
    "c22": [
        "OE"
    ],
    "cp3320as2": [
        "CO"
    ],
    "elite e55": [
        "SW"
    ],
    "koz-al00": [
        "HNR"
    ],
    "s40_vista": [
        "69"
    ],
    "sky black": [
        "SW"
    ],
    "titan_1": [
        "4M"
    ],
    "via x20": [
        "R4"
    ],
    "zoom_1": [
        "4M"
    ],
    "infinix pr652b": [
        "IF"
    ],
    "infinix x6812": [
        "IF"
    ],
    "a11 pro max": [
        "UM"
    ],
    "6125f": [
        "TC"
    ],
    "6125d": [
        "TC"
    ],
    "6056h": [
        "AL"
    ],
    "g450": [
        "DX"
    ],
    "impress wave": [
        "VX"
    ],
    "15 plus": [
        "M1"
    ],
    "tp_1_3000": [
        "U5"
    ],
    "g3212": [
        "SO"
    ],
    "g3112": [
        "SO"
    ],
    "cavion_base_5_0": [
        "CJ"
    ],
    "cpe91": [
        "69"
    ],
    "clik": [
        "4M"
    ],
    "benefit_m9": [
        "A6"
    ],
    "dzire": [
        "HR"
    ],
    "fame": [
        "4M"
    ],
    "fame_ds": [
        "4M"
    ],
    "gpad_u": [
        "U6"
    ],
    "beam": [
        "4M",
        "HR"
    ],
    "aquaris vs": [
        "BX",
        "IX"
    ],
    "u601s pro": [
        "HI"
    ],
    "tecno l9": [
        "TB"
    ],
    "tecno s6": [
        "TB"
    ],
    "vulcan": [
        "HR"
    ],
    "sprint4g": [
        "N5"
    ],
    "philips s257": [
        "PH"
    ],
    "philips s318": [
        "PH"
    ],
    "philips s386": [
        "PH"
    ],
    "quantum_470_rugged_pro": [
        "GC"
    ],
    "quantum_ii_500_n": [
        "GC"
    ],
    "beeline smart 8": [
        "B5"
    ],
    "archos 50 saphir": [
        "AR"
    ],
    "archos 40 power": [
        "AR"
    ],
    "archos 50 platinum 4g": [
        "AR"
    ],
    "a8 max": [
        "B2"
    ],
    "blackview a8 max": [
        "B2"
    ],
    "life one x2 mini": [
        "BU"
    ],
    "gx290": [
        "GS"
    ],
    "lm-x220n": [
        "LG"
    ],
    "ls5018f": [
        "EW"
    ],
    "lio-an00m": [
        "HU"
    ],
    "lgl355dl": [
        "LG"
    ],
    "lenovo k13": [
        "LE"
    ],
    "lm-v600v": [
        "LG"
    ],
    "ilium alpha 1t": [
        "LA"
    ],
    "hammer_blade_3": [
        "HAM"
    ],
    "g9 pro": [
        "BU"
    ],
    "m2004j19pi": [
        "0P"
    ],
    "pomelo": [
        "XI"
    ],
    "sm-a015az": [
        "SA"
    ],
    "sm-a025az": [
        "SA"
    ],
    "sm-m305m": [
        "SA"
    ],
    "sm-m022m": [
        "SA"
    ],
    "lg-f520k": [
        "LG"
    ],
    "lg-f470k": [
        "LG"
    ],
    "a6_mini": [
        "EL"
    ],
    "v2053": [
        "VV"
    ],
    "noh-al10": [
        "HU"
    ],
    "moa-tl00": [
        "HU"
    ],
    "med-al20": [
        "HU"
    ],
    "pcht30": [
        "OP"
    ],
    "tnn-an00": [
        "HU"
    ],
    "htcd160lvwpp": [
        "HT"
    ],
    "zte t320": [
        "ZT"
    ],
    "shv-e300k": [
        "SA"
    ],
    "shv-e330s": [
        "SA"
    ],
    "t770b": [
        "TC"
    ],
    "t774h": [
        "TC"
    ],
    "sm-s115dl": [
        "SA"
    ],
    "sm-m526b": [
        "SA"
    ],
    "sm-m225fv": [
        "SA"
    ],
    "sm-j700h": [
        "SA"
    ],
    "sm-g991q": [
        "SA"
    ],
    "sm-g988u1": [
        "SA"
    ],
    "sm-g986u1": [
        "SA"
    ],
    "sm-g981u1": [
        "SA"
    ],
    "sm-a022f": [
        "SA"
    ],
    "sm-a025a": [
        "SA"
    ],
    "hk7-3502": [
        "X6"
    ],
    "s10-h": [
        "8S"
    ],
    "zte blade l9ru": [
        "ZT"
    ],
    "cph2273": [
        "OP"
    ],
    "tecno kf6": [
        "TB"
    ],
    "psp3504duo": [
        "PR"
    ],
    "hisense infinity e30": [
        "HI"
    ],
    "hisense infinity e30se": [
        "HI"
    ],
    "h4233": [
        "SO"
    ],
    "hlte223e.40": [
        "HI"
    ],
    "hisense e max": [
        "HI"
    ],
    "hisense e40 lite": [
        "HI"
    ],
    "hammer_energy_2": [
        "HAM"
    ],
    "u202aa": [
        "6A"
    ],
    "tet-an00": [
        "HU"
    ],
    "oxp-an00": [
        "HU"
    ],
    "oce-an50": [
        "HU"
    ],
    "oce-al50": [
        "HU"
    ],
    "htc u20 5g": [
        "HT"
    ],
    "hnr320t": [
        "HI"
    ],
    "hjc-an90": [
        "HNR"
    ],
    "cdl-an50": [
        "HU"
    ],
    "cdy-tn20": [
        "HU"
    ],
    "cnd-an00": [
        "HU"
    ],
    "dvc-an00": [
        "HU"
    ],
    "impress_reef": [
        "VX"
    ],
    "sm-g610y": [
        "SA"
    ],
    "bv6000s_ru": [
        "B2"
    ],
    "impress_saturn": [
        "VX"
    ],
    "bv9900e": [
        "B2"
    ],
    "sh-54b": [
        "SH"
    ],
    "2107113sr": [
        "XI"
    ],
    "shg05": [
        "SH"
    ],
    "shg04": [
        "SH"
    ],
    "ntn-an20": [
        "HNR"
    ],
    "so-53b": [
        "SO"
    ],
    "sbm203sh": [
        "SH"
    ],
    "sbm302sh": [
        "SH"
    ],
    "f-01j": [
        "FU"
    ],
    "e6683": [
        "SO"
    ],
    "rna-an00": [
        "HNR"
    ],
    "sm-g981u": [
        "SA"
    ],
    "zte blade a7 2020ru": [
        "ZT"
    ],
    "chl-al00": [
        "HNR",
        "HU"
    ],
    "bln-al10": [
        "HU"
    ],
    "impress_lagune": [
        "VX"
    ],
    "sharp aquos s2 4/64": [
        "SH"
    ],
    "zte blade l130ru": [
        "ZT"
    ],
    "stylo_viva": [
        "69"
    ],
    "view 1": [
        "BU"
    ],
    "qs31": [
        "QH"
    ],
    "tecno cc9": [
        "TB"
    ],
    "tecno cg7": [
        "TB"
    ],
    "tecno kc1j": [
        "TB"
    ],
    "mc32020": [
        "0Y"
    ],
    "lm-x440zm": [
        "LG"
    ],
    "dn6015": [
        "X6"
    ],
    "d701": [
        "BU"
    ],
    "revvlry+": [
        "TM"
    ],
    "k7 power": [
        "OE"
    ],
    "luna": [
        "69"
    ],
    "s50_jade": [
        "69"
    ],
    "a4_lite": [
        "HA"
    ],
    "alo": [
        "40"
    ],
    "awm539": [
        "AW"
    ],
    "ax824": [
        "BM"
    ],
    "ax824+": [
        "BM"
    ],
    "ax960": [
        "BM"
    ],
    "bbb100-1": [
        "RM"
    ],
    "bv5800": [
        "B2"
    ],
    "bv9500-ru": [
        "B2"
    ],
    "bv5800_ru": [
        "B2"
    ],
    "covet mini": [
        "ZU"
    ],
    "ghia_l1": [
        "GH"
    ],
    "lm-q727s": [
        "LG"
    ],
    "qtouch_q85": [
        "QH"
    ],
    "trendy_lite": [
        "4M"
    ],
    "stellar m2": [
        "ZU"
    ],
    "hyundai_eternity_g50": [
        "HN"
    ],
    "5048y": [
        "AL"
    ],
    "5048u_eea": [
        "AL"
    ],
    "vox a10 3g vs4002pg": [
        "D2"
    ],
    "vox flash 4g vs5015ml": [
        "D2",
        "LG"
    ],
    "vox s503 4g vs5008ml": [
        "D2",
        "LG",
        "OB"
    ],
    "vox s507 4g vs5022pl": [
        "D2",
        "OB"
    ],
    "lenovo k520": [
        "LE"
    ],
    "keneksi-fire 2": [
        "K3"
    ],
    "lnd-al40": [
        "HU"
    ],
    "zteu960e": [
        "ZT"
    ],
    "tcl 302u": [
        "TC"
    ],
    "sugar t30": [
        "9S"
    ],
    "sugar c60": [
        "9S"
    ],
    "g3121": [
        "SO"
    ],
    "w-k380-tvm2g": [
        "WI"
    ],
    "primo n4": [
        "WA"
    ],
    "gsmart arty a3": [
        "GG"
    ],
    "bv2000": [
        "B2"
    ],
    "ht7pro": [
        "HM"
    ],
    "ht7": [
        "HM"
    ],
    "ht5": [
        "HM"
    ],
    "as-5411": [
        "A8"
    ],
    "b501 easy": [
        "BV"
    ],
    "gionee s10cl": [
        "GI"
    ],
    "gionee s10c": [
        "GI"
    ],
    "eluga_f": [
        "PA"
    ],
    "lenovo k14 plus": [
        "LE"
    ],
    "nokia g21": [
        "NK"
    ],
    "sm-g990u": [
        "SA"
    ],
    "sm-g9900": [
        "SA"
    ],
    "sm-a526w": [
        "SA"
    ],
    "mi 11 lite 4g": [
        "XI"
    ],
    "5028y_ru": [
        "AL"
    ],
    "bq-6001l": [
        "BX"
    ],
    "inoi_6i_lite": [
        "I4"
    ],
    "inoi_5i_pro": [
        "I4"
    ],
    "koobee y3": [
        "KB"
    ],
    "sugar s60 pro": [
        "9S"
    ],
    "ivvi ss1-01": [
        "UI"
    ],
    "ivvi ss1-03": [
        "UI"
    ],
    "ivvi i3p-02": [
        "UI"
    ],
    "ivvi sk5": [
        "UI"
    ],
    "ivvi f2-t": [
        "UI"
    ],
    "ivvi v1m": [
        "UI"
    ],
    "ivvi f3c": [
        "UI"
    ],
    "ivvi v3-t": [
        "UI"
    ],
    "elegance_4_0_black": [
        "K1"
    ],
    "elegance_4_0": [
        "K1"
    ],
    "cm2221": [
        "62"
    ],
    "psp5522duo": [
        "PR"
    ],
    "psp3514duo": [
        "PR"
    ],
    "psp3514duo_ru": [
        "PR"
    ],
    "psp3416duo": [
        "PR"
    ],
    "psp3406duo": [
        "PR"
    ],
    "magno-s": [
        "ZU"
    ],
    "lg-h910pr": [
        "LG"
    ],
    "lgl63bl": [
        "LG"
    ],
    "lg-f690s": [
        "LG"
    ],
    "lenovo x2-eu": [
        "LE"
    ],
    "lg-h320": [
        "LG"
    ],
    "lg-f240s": [
        "LG"
    ],
    "lg-d838": [
        "LG"
    ],
    "lg-as990": [
        "LG"
    ],
    "tecno kg6": [
        "TB"
    ],
    "tecno pr651h": [
        "TB"
    ],
    "v2031_21": [
        "VV"
    ],
    "v2036_21": [
        "VV"
    ],
    "v2045": [
        "VV"
    ],
    "v2111": [
        "VV"
    ],
    "v2118a": [
        "VV"
    ],
    "vivo 1929": [
        "VV"
    ],
    "w-v680-eea": [
        "WI"
    ],
    "21091116ag": [
        "0P"
    ],
    "xt830c": [
        "MR"
    ],
    "tc26": [
        "PZ"
    ],
    "inoi easyphone": [
        "I4"
    ],
    "sm-g960u1": [
        "SA"
    ],
    "sm-g9600": [
        "SA"
    ],
    "sm-g960w": [
        "SA"
    ],
    "n5502l": [
        "NL"
    ],
    "lava lmg01": [
        "LV"
    ],
    "m5go": [
        "TP"
    ],
    "ht80": [
        "HM"
    ],
    "ax1078": [
        "BM"
    ],
    "x-treme_pq54 max": [
        "1S"
    ],
    "x-treme_pq38": [
        "1S"
    ],
    "wildfire e lite": [
        "HT"
    ],
    "wildfire e3": [
        "HT"
    ],
    "wildfire e2": [
        "HT"
    ],
    "w-v851-eea": [
        "WI"
    ],
    "w-v680-ope": [
        "WI"
    ],
    "motorola defy": [
        "MR"
    ],
    "w-k211-eea": [
        "WI"
    ],
    "rmx3370": [
        "RE"
    ],
    "rmx3430": [
        "RE"
    ],
    "le2115": [
        "ON"
    ],
    "rp01": [
        "UM"
    ],
    "lm-q725s": [
        "LG"
    ],
    "vox_s513_4g_vs5035ml": [
        "D2"
    ],
    "htc desire 20 pro": [
        "HT"
    ],
    "ntn-lx1": [
        "HNR"
    ],
    "g310": [
        "GN"
    ],
    "g510": [
        "GN"
    ],
    "g700": [
        "GN"
    ],
    "huawei g700": [
        "HU"
    ],
    "huawei g700-u10": [
        "HU"
    ],
    "g501": [
        "GN"
    ],
    "g301": [
        "GN"
    ],
    "pro 6 plus": [
        "M1"
    ],
    "eva-l29": [
        "HU"
    ],
    "centric cm3321": [
        "62"
    ],
    "go sp": [
        "CD"
    ],
    "go sp 2": [
        "CD"
    ],
    "next infinity plus": [
        "CD"
    ],
    "go connect lite 2": [
        "CD"
    ],
    "go connect lite)": [
        "CD"
    ],
    "go connect": [
        "CD"
    ],
    "zte blade a31 plus ru": [
        "ZT"
    ],
    "zte blade a31 lite": [
        "ZT"
    ],
    "sm-a037g": [
        "SA"
    ],
    "sm-e625f": [
        "SA"
    ],
    "sm-a505gn": [
        "SA"
    ],
    "sm-a526u1": [
        "SA"
    ],
    "blade": [
        "M0"
    ],
    "comet": [
        "M0"
    ],
    "moto e20": [
        "MR"
    ],
    "moto g(40) fusion": [
        "MR",
        "O1"
    ],
    "moto g(60)s": [
        "MR"
    ],
    "lm-q310n": [
        "LG"
    ],
    "elz-an00": [
        "HNR"
    ],
    "nam-lx9": [
        "HU"
    ],
    "motorola one 5g": [
        "MR"
    ],
    "redmi 9t": [
        "XI"
    ],
    "p13 blue 2021": [
        "RD"
    ],
    "moto g stylus 5g": [
        "MR"
    ],
    "a455": [
        "DX"
    ],
    "g660": [
        "DX"
    ],
    "samsung sm-a025u1": [
        "SA"
    ],
    "v2052": [
        "VV"
    ],
    "v2059": [
        "VV"
    ],
    "v2145a": [
        "VV"
    ],
    "v2148a": [
        "VV"
    ],
    "wiko u614as": [
        "WI"
    ],
    "bq-5560l": [
        "BX"
    ],
    "cph2131": [
        "OP"
    ],
    "drive 8": [
        "KE"
    ],
    "am-h200": [
        "AL"
    ],
    "mz-tecno ke7": [
        "TB",
        "M1"
    ],
    "mz-stk-lx1": [
        "HU",
        "M1"
    ],
    "mz-m2010j19sy": [
        "XI",
        "M1"
    ],
    "mz-m2": [
        "M1"
    ],
    "redmi 9c nfc": [
        "XI"
    ],
    "redmi 9c": [
        "XI"
    ],
    "redmi 9a": [
        "XI"
    ],
    "silver_max": [
        "KL"
    ],
    "kis c341": [
        "ZT"
    ],
    "e553": [
        "HN"
    ],
    "zte blade a0722": [
        "ZT"
    ],
    "ulefone_armor_5": [
        "UL"
    ],
    "wp1": [
        "OE"
    ],
    "zte axon 7": [
        "ZT"
    ],
    "u ultra": [
        "HT"
    ],
    "power_2": [
        "L5"
    ],
    "s60 lite": [
        "DO"
    ],
    "zte blade a520c": [
        "ZT"
    ],
    "zte blade a330": [
        "ZT"
    ],
    "zte blade a601": [
        "ZT"
    ],
    "zte blade a610c": [
        "ZT"
    ],
    "6156h": [
        "TC"
    ],
    "6125h_ru": [
        "TC"
    ],
    "5007u_ru": [
        "AL"
    ],
    "yk_p30_eea": [
        "HZ"
    ],
    "xplorer_2": [
        "H9"
    ],
    "stk ace": [
        "S8"
    ],
    "itel p13 plus": [
        "IZ"
    ],
    "itel a45": [
        "IZ"
    ],
    "itel l6004l": [
        "IZ"
    ],
    "cruise1": [
        "61"
    ],
    "lenovo l38082": [
        "LE"
    ],
    "v2039": [
        "VV"
    ],
    "nam-al00": [
        "HU"
    ],
    "nubia 8011": [
        "57"
    ],
    "tesla_sp9_2": [
        "C7"
    ],
    "tc52": [
        "PZ"
    ],
    "tc57": [
        "PZ"
    ],
    "griffe t9 plus": [
        "C5"
    ],
    "philips s309": [
        "PH"
    ],
    "philips s337": [
        "PH"
    ],
    "philips s616": [
        "PH"
    ],
    "philips v377": [
        "PH"
    ],
    "philips_v526": [
        "PH"
    ],
    "switch1": [
        "4M"
    ],
    "stratus_c5": [
        "1J"
    ],
    "stylo_521": [
        "69"
    ],
    "cyclone_c4": [
        "1J"
    ],
    "cph2137": [
        "OP"
    ],
    "d60lx": [
        "KK"
    ],
    "b50pro": [
        "BM"
    ],
    "x50l": [
        "DO"
    ],
    "vs571": [
        "69"
    ],
    "x1 dual": [
        "M6"
    ],
    "vfd 528": [
        "VF"
    ],
    "vfd 525": [
        "VF"
    ],
    "v2 pro": [
        "VR"
    ],
    "u25_pro": [
        "OE"
    ],
    "u23": [
        "OE"
    ],
    "u1 mini": [
        "40"
    ],
    "u4": [
        "40"
    ],
    "tecno f1": [
        "TB"
    ],
    "tecno in5": [
        "TB"
    ],
    "tecno k9": [
        "TB"
    ],
    "tecno s6s": [
        "TB"
    ],
    "tecno w1": [
        "TB"
    ],
    "tecno cx air": [
        "TB"
    ],
    "u17": [
        "OE"
    ],
    "u18": [
        "OE"
    ],
    "u22": [
        "OE"
    ],
    "vs5502": [
        "69"
    ],
    "thl_knight_1": [
        "T4"
    ],
    "ale-l23": [
        "HU"
    ],
    "k503s": [
        "8E"
    ],
    "elite h5": [
        "SW"
    ],
    "moto maxx": [
        "MR"
    ],
    "moto z2 force": [
        "MR"
    ],
    "itel w5005": [
        "IZ"
    ],
    "itel l5002p": [
        "IZ"
    ],
    "neffos c5a": [
        "NF"
    ],
    "neffos c5s": [
        "NF"
    ],
    "smart_start_3": [
        "M9"
    ],
    "r4 lte": [
        "4M"
    ],
    "re1": [
        "KO"
    ],
    "r2_plus": [
        "MN"
    ],
    "rio_zam": [
        "4M"
    ],
    "sage": [
        "HR"
    ],
    "sm-j701m": [
        "SA"
    ],
    "sm-j701mt": [
        "SA"
    ],
    "sm-j710k": [
        "SA"
    ],
    "sm-j710fq": [
        "SA"
    ],
    "qin 2": [
        "XI"
    ],
    "qin 2 pro": [
        "XI"
    ],
    "s3_pro": [
        "UM"
    ],
    "stellar p3": [
        "ZU"
    ],
    "ss5214g": [
        "68"
    ],
    "sm-a605k": [
        "SA"
    ],
    "zte blade 10 vita": [
        "ZT"
    ],
    "zte a2019 pro": [
        "ZT"
    ],
    "v3991an": [
        "WI"
    ],
    "zte blade a610": [
        "ZT"
    ],
    "zte blade a210": [
        "ZT"
    ],
    "studio g2 hd": [
        "BU"
    ],
    "studio xl 2": [
        "BU"
    ],
    "alfa 2": [
        "L5"
    ],
    "alfa 5": [
        "L5"
    ],
    "trunk 1": [
        "EL"
    ],
    "sm-j200h": [
        "SA"
    ],
    "sm-j120m": [
        "SA"
    ],
    "sm-j120f": [
        "SA"
    ],
    "sm-j111m": [
        "SA"
    ],
    "sm-j110m": [
        "SA"
    ],
    "fly life buzz": [
        "FL"
    ],
    "gm 5 d": [
        "GN"
    ],
    "zte blade v8 mini": [
        "ZT"
    ],
    "zte a0616": [
        "ZT"
    ],
    "senseit a250": [
        "S6"
    ],
    "senseit r500": [
        "S6"
    ],
    "senseit t100": [
        "S6"
    ],
    "senseit t250": [
        "S6"
    ],
    "senseit a247": [
        "S6"
    ],
    "senseit_c155": [
        "S6"
    ],
    "senseit w289": [
        "S6"
    ],
    "rmx3357": [
        "RE"
    ],
    "tecno ch9n": [
        "TB"
    ],
    "tecno ch6n": [
        "TB"
    ],
    "tecno bd3": [
        "TB"
    ],
    "tecno kf6i": [
        "TB"
    ],
    "zte blade l9": [
        "ZT"
    ],
    "zte a2022": [
        "ZT"
    ],
    "zte a2322g": [
        "ZT"
    ],
    "vivo 1920_20": [
        "VV"
    ],
    "neo_1": [
        "4M"
    ],
    "i2011": [
        "VV"
    ],
    "f-51b": [
        "FU"
    ],
    "a102op": [
        "OP"
    ],
    "a103zt": [
        "ZT"
    ],
    "sc-56b": [
        "SA",
        "SU"
    ],
    "sh-m19": [
        "SH"
    ],
    "cph2309": [
        "OP"
    ],
    "fcg01": [
        "FU"
    ],
    "xq-be42": [
        "SO"
    ],
    "like_hi10_2021": [
        "IH"
    ],
    "rmx2022": [
        "RE"
    ],
    "rocket iii": [
        "ZU"
    ],
    "21061119al": [
        "XI"
    ],
    "2107119dc": [
        "XI"
    ],
    "cph2223": [
        "OP"
    ],
    "cph2325": [
        "OP"
    ],
    "cph2365": [
        "OP"
    ],
    "meizu 18s": [
        "M1"
    ],
    "tecno ch7n": [
        "TB"
    ],
    "sm-a125n": [
        "SA"
    ],
    "smartisan u3 pro": [
        "S7"
    ],
    "micromax e7533": [
        "MI"
    ],
    "oneplus 7t": [
        "ON"
    ],
    "tecno bd2": [
        "TB"
    ],
    "tecno rc6": [
        "TB"
    ],
    "v1937": [
        "VV"
    ],
    "v2029_pk": [
        "VV"
    ],
    "w-k211-tvm": [
        "WI"
    ],
    "zte 8000": [
        "ZT"
    ],
    "itel l5006c": [
        "IZ"
    ],
    "itel l5007": [
        "IZ"
    ],
    "itel p651w": [
        "IZ"
    ],
    "itel p681l": [
        "IZ"
    ],
    "itel w4001": [
        "IZ"
    ],
    "moto e": [
        "MR"
    ],
    "moto g(9)": [
        "MR"
    ],
    "armor x9": [
        "UL"
    ],
    "rmx3042": [
        "RE"
    ],
    "rmx3265": [
        "RE"
    ],
    "rmx3268": [
        "RE"
    ],
    "rmx3269": [
        "RE"
    ],
    "primo gh10": [
        "WA"
    ],
    "realme 6 pro": [
        "RE"
    ],
    "power armor 14": [
        "UL"
    ],
    "moto e30": [
        "MR"
    ],
    "moto e40": [
        "MR"
    ],
    "motorola edge 20": [
        "MR"
    ],
    "symphony atom ii": [
        "SM"
    ],
    "stellar max": [
        "ZU"
    ],
    "ev7_pro": [
        "8V"
    ],
    "hmr5012": [
        "3H"
    ],
    "argon": [
        "NY"
    ],
    "pearl k2 prime": [
        "HV"
    ],
    "qmp_k8": [
        "Q9"
    ],
    "lg-f820l": [
        "LG"
    ],
    "nexo smarty": [
        "7R",
        "3Y"
    ],
    "nexo handy": [
        "7R"
    ],
    "a1000s_lite": [
        "XO"
    ],
    "poco x3_sn": [
        "0P"
    ],
    "lava lzg403": [
        "LV"
    ],
    "note_4cam": [
        "TP"
    ],
    "ntn-lx3": [
        "HNR"
    ],
    "myphone_now_esim": [
        "MY1"
    ],
    "zte bv0800": [
        "ZT"
    ],
    "moto g(50) 5g": [
        "MR"
    ],
    "sh-rm18": [
        "SH"
    ],
    "samsung sm-g965u1": [
        "SA"
    ],
    "4063f": [
        "AL"
    ],
    "6125h": [
        "TC"
    ],
    "6025h_ru": [
        "AL"
    ],
    "dfm48": [
        "X6"
    ],
    "jlh-an00": [
        "HNR"
    ],
    "iris plus 2021": [
        "HR"
    ],
    "lex829": [
        "L1"
    ],
    "sm-a037m": [
        "SA"
    ],
    "htc one m7": [
        "HT"
    ],
    "santin fs500z": [
        "SQ"
    ],
    "santin s505": [
        "SQ"
    ],
    "primo n3": [
        "WA"
    ],
    "power1": [
        "9H"
    ],
    "qmobile i8i pro": [
        "QM"
    ],
    "zte blade a6": [
        "ZT"
    ],
    "cph2071": [
        "OP"
    ],
    "ultraj8": [
        "FI"
    ],
    "v141": [
        "SM"
    ],
    "smart_b19": [
        "QD"
    ],
    "shock5.5": [
        "RT"
    ],
    "tl554b": [
        "4U"
    ],
    "tc504b": [
        "4U"
    ],
    "sky prestige": [
        "SW"
    ],
    "pspcl30a0": [
        "PL"
    ],
    "psp5523duo": [
        "PR"
    ],
    "psp3513duo_ru": [
        "PR"
    ],
    "zte b2015": [
        "ZT"
    ],
    "matrix gravity": [
        "50",
        "4M"
    ],
    "limit": [
        "ZU"
    ],
    "onix": [
        "ZU"
    ],
    "duopix f1": [
        "ZX"
    ],
    "duopix r1": [
        "ZX"
    ],
    "astra titan 4g": [
        "ZX"
    ],
    "astra young 4g": [
        "ZX"
    ],
    "starmobile astra": [
        "18"
    ],
    "astra star": [
        "ZX"
    ],
    "astra curve pro": [
        "ZX"
    ],
    "astra young pro": [
        "ZX"
    ],
    "astra metal 4g": [
        "ZX"
    ],
    "astra blaze": [
        "ZX"
    ],
    "astra curve 4g": [
        "ZX"
    ],
    "admire_curve_neo": [
        "ZN"
    ],
    "xtouch x": [
        "4X"
    ],
    "xbot_senior": [
        "4X"
    ],
    "xbot junior": [
        "4X"
    ],
    "x9_16gb": [
        "4X"
    ],
    "ax1077+": [
        "BM"
    ],
    "berry": [
        "4M"
    ],
    "jad-al50": [
        "HU"
    ],
    "oppo a37m": [
        "OP"
    ],
    "p-02e": [
        "PA"
    ],
    "shl21": [
        "SH"
    ],
    "kcp01k": [
        "KY"
    ],
    "vm670": [
        "LG"
    ],
    "sh-09d": [
        "SH"
    ],
    "micromax e313": [
        "MI"
    ],
    "micromax d333": [
        "MI"
    ],
    "micromax d305": [
        "MI"
    ],
    "micromax q301": [
        "MI"
    ],
    "micromax q326": [
        "MI"
    ],
    "micromax q338": [
        "MI"
    ],
    "micromax q413": [
        "MI"
    ],
    "micromax q4251": [
        "MI"
    ],
    "blade v9 vita": [
        "ZT"
    ],
    "xiaomi 11t": [
        "XI"
    ],
    "xiaomi 11t pro": [
        "XI"
    ],
    "mi 10 lite 5g": [
        "XI"
    ],
    "mi 11 lite 5g": [
        "XI"
    ],
    "xiaomi 11 lite 5g ne": [
        "XI"
    ],
    "redmi 10": [
        "XI"
    ],
    "platinum k55": [
        "SW",
        "WK"
    ],
    "so-01e": [
        "SO"
    ],
    "sonysol22": [
        "SO"
    ],
    "sonysol21": [
        "SO"
    ],
    "f-04g": [
        "FU"
    ],
    "rex rx": [
        "1K"
    ],
    "smooth 6.1": [
        "HH"
    ],
    "light a103": [
        "4G"
    ],
    "selfix_q5_urban": [
        "SL"
    ],
    "flair": [
        "A3"
    ],
    "ultra 2": [
        "A3"
    ],
    "flair s1": [
        "LV"
    ],
    "flair p8": [
        "LV"
    ],
    "freedom access": [
        "A3",
        "J5"
    ],
    "agm glory g1": [
        "A3",
        "AK"
    ],
    "u319aa": [
        "6A"
    ],
    "azumi_iro_a5_ql": [
        "AM"
    ],
    "orbit_ll": [
        "FI"
    ],
    "sbm005sh": [
        "SH"
    ],
    "sbm003sh": [
        "SH"
    ],
    "sbm103sh": [
        "SH"
    ],
    "sbm303sh": [
        "SH"
    ],
    "sh-02l": [
        "SH"
    ],
    "am506": [
        "AG"
    ],
    "bush spira b3 5": [
        "B1"
    ],
    "smart 4g m1 plus": [
        "11"
    ],
    "z12 pro": [
        "QM"
    ],
    "gli": [
        "QM"
    ],
    "gli lite": [
        "QM"
    ],
    "i10 2019": [
        "QM"
    ],
    "i10 2020": [
        "QM"
    ],
    "a9 indian": [
        "KA"
    ],
    "admire glory+": [
        "ZN"
    ],
    "sm-j810y": [
        "SA"
    ],
    "tecno kb2h": [
        "TB"
    ],
    "tecno bb4": [
        "TB"
    ],
    "lava le9830": [
        "LV"
    ],
    "lava lf9810_2gb": [
        "LV"
    ],
    "lava lh9930": [
        "LV"
    ],
    "mp1801": [
        "3M"
    ],
    "primo e11": [
        "WA"
    ],
    "primo gh8": [
        "WA"
    ],
    "primo r6 max": [
        "WA"
    ],
    "primo rx7": [
        "WA"
    ],
    "primo_nf4_2gb": [
        "WA"
    ],
    "g10 max": [
        "ZM"
    ],
    "mione hero 1": [
        "X7",
        "MO"
    ],
    "mtech turbo l7": [
        "72"
    ],
    "xlife-514q": [
        "SP"
    ],
    "xlife-441q": [
        "SP"
    ],
    "xlife-victor5": [
        "SP"
    ],
    "xlife-415": [
        "SP"
    ],
    "xlife-m5q+": [
        "SP"
    ],
    "xlife-m5 pro": [
        "SP"
    ],
    "xlife-431q": [
        "SP"
    ],
    "spice xlife-512": [
        "SP"
    ],
    "spice xlife-m5+": [
        "SP"
    ],
    "xlife-405": [
        "SP"
    ],
    "xlife-proton5 pro": [
        "SP"
    ],
    "xlife-electro55hd": [
        "SP"
    ],
    "cloud tread": [
        "IX"
    ],
    "snap psn-h116": [
        "PL"
    ],
    "col-l10": [
        "HU"
    ],
    "rmx3061": [
        "RE"
    ],
    "sp-5450": [
        "31"
    ],
    "rmx1822": [
        "RE"
    ],
    "studio x12": [
        "BU"
    ],
    "sts570": [
        "Y7"
    ],
    "stg x20": [
        "GQ"
    ],
    "sh-r10a": [
        "SH"
    ],
    "cph2241": [
        "OP"
    ],
    "tecno kd6a": [
        "TB"
    ],
    "tecno ce7": [
        "TB"
    ],
    "cph2263": [
        "OP"
    ],
    "rmx1929": [
        "RE"
    ],
    "rmx2003": [
        "RE"
    ],
    "211033mi": [
        "0P"
    ],
    "lm-k310im": [
        "LG"
    ],
    "lm-k610im": [
        "LG"
    ],
    "p13_max_blue": [
        "RD"
    ],
    "p13 blue max 2020": [
        "RD"
    ],
    "pcs02": [
        "4P"
    ],
    "t9s": [
        "OD"
    ],
    "spc gen": [
        "FS"
    ],
    "spc gen lite": [
        "FS"
    ],
    "spc gen max": [
        "FS"
    ],
    "spc gen plus": [
        "FS"
    ],
    "spc smart": [
        "FS"
    ],
    "spc smart max": [
        "FS"
    ],
    "spc smart plus": [
        "FS"
    ],
    "5007o": [
        "AL"
    ],
    "5002j": [
        "AL"
    ],
    "bee lite": [
        "VH"
    ],
    "zte a2020n3 pro": [
        "ZT"
    ],
    "z3351s": [
        "ZT"
    ],
    "obasmart_3": [
        "7Y"
    ],
    "oba_conecta_max": [
        "7Y"
    ],
    "hot 5": [
        "QM"
    ],
    "hl9000": [
        "AD"
    ],
    "gionee f9 plus": [
        "GI"
    ],
    "flare_s8_pro": [
        "CH"
    ],
    "flare s8 lite": [
        "CH"
    ],
    "flare_s8_deluxe": [
        "CH"
    ],
    "alien_x_apex_2020": [
        "IH"
    ],
    "sm-a305gn": [
        "SA"
    ],
    "sm-g955u1": [
        "SA"
    ],
    "imo q4 pro": [
        "IL",
        "60"
    ],
    "hpp-gs1": [
        "U8"
    ],
    "vle5": [
        "U8"
    ],
    "m671m4": [
        "RL"
    ],
    "lm-x600im": [
        "LG"
    ],
    "lm-x440zmw": [
        "LG"
    ],
    "lm-g820v": [
        "LG"
    ],
    "lg-rs988": [
        "LG"
    ],
    "lm-q610(fgn)": [
        "LG"
    ],
    "lava lf6810": [
        "LV"
    ],
    "konnect_608": [
        "DA"
    ],
    "lava lzg01": [
        "LV"
    ],
    "e940-2795-00": [
        "GS"
    ],
    "gplus x10": [
        "8G"
    ],
    "gplus n809": [
        "8G"
    ],
    "gplus z10": [
        "8G"
    ],
    "e6921": [
        "KY"
    ],
    "positivo q20": [
        "PS",
        "QA"
    ],
    "primo r8": [
        "WA"
    ],
    "primo rx8 mini": [
        "WA"
    ],
    "shg06": [
        "SH"
    ],
    "sh-rm19": [
        "SH"
    ],
    "veon_c8680": [
        "WC"
    ],
    "sm-m326b": [
        "SA"
    ],
    "bmm532d": [
        "BF"
    ],
    "bmm441a": [
        "BF"
    ],
    "21121119sg": [
        "XI"
    ],
    "armor x9 pro": [
        "UL"
    ],
    "armor 12 5g": [
        "UL"
    ],
    "ae9010": [
        "2X"
    ],
    "ae9950": [
        "2X"
    ],
    "bmm431s": [
        "BF"
    ],
    "bmm531s": [
        "BF"
    ],
    "cph2321": [
        "OP"
    ],
    "mt2110": [
        "ON"
    ],
    "lm-g910n": [
        "LG"
    ],
    "live 9s": [
        "KE"
    ],
    "ihunt cyber wolf 5g": [
        "IH"
    ],
    "cp03": [
        "CO"
    ],
    "ntn-l22": [
        "HNR"
    ],
    "mp02": [
        "UM"
    ],
    "mp01": [
        "UM"
    ],
    "h2022": [
        "5F"
    ],
    "lava lxx501": [
        "LV"
    ],
    "moto g200 5g": [
        "MR"
    ],
    "lenovo l70081": [
        "LE"
    ],
    "pfdm00": [
        "OP"
    ],
    "p13 blue max 128 gb": [
        "RD"
    ],
    "redmi k30 pro zoom edition": [
        "XI"
    ],
    "shark prs-a0": [
        "XI"
    ],
    "sm-a035f": [
        "SA"
    ],
    "sm-a125u1": [
        "SA"
    ],
    "sm-a127m": [
        "SA"
    ],
    "evolveo strongphone g9": [
        "EO"
    ],
    "fendy plus": [
        "4M"
    ],
    "gplus p10": [
        "8G"
    ],
    "4187d": [
        "TC"
    ],
    "5033fp": [
        "AL"
    ],
    "5033yr": [
        "AL"
    ],
    "bq-5060l": [
        "BX"
    ],
    "tecno bd1": [
        "TB"
    ],
    "tecno bd4": [
        "TB"
    ],
    "tecno kg8": [
        "TB"
    ],
    "w-v750bn-ope": [
        "WI"
    ],
    "xq-bq72": [
        "SO"
    ],
    "xq-be72": [
        "SO"
    ],
    "zs676ks": [
        "AU"
    ],
    "zte blade a31 plus": [
        "ZT"
    ],
    "lenovo z6 lite": [
        "LE"
    ],
    "oneplus 9r": [
        "ON"
    ],
    "samsung sm-g990e": [
        "SA"
    ],
    "samsung sm-g990b": [
        "SA"
    ],
    "xt2137-2": [
        "MR"
    ],
    "t766h_tr": [
        "TC"
    ],
    "sm-m526br": [
        "SA"
    ],
    "sm-g986w": [
        "SA"
    ],
    "sm-g925f": [
        "SA"
    ],
    "itel a16 plus": [
        "IZ"
    ],
    "fs408": [
        "FL"
    ],
    "infinix x6812b": [
        "IF"
    ],
    "wildfire e1": [
        "HT"
    ],
    "infinix x680d": [
        "IF"
    ],
    "infinix x660b": [
        "IF"
    ],
    "infinix x660": [
        "IF"
    ],
    "infinix x655f": [
        "IF"
    ],
    "is655": [
        "9J"
    ],
    "via_e4": [
        "R4"
    ],
    "via_f20": [
        "R4"
    ],
    "zte a2020u pro": [
        "ZT"
    ],
    "zte a2021g": [
        "ZT"
    ],
    "z5156cc": [
        "ZT"
    ],
    "a600dl": [
        "TC"
    ],
    "in_2b": [
        "MI"
    ],
    "le fizz": [
        "LM"
    ],
    "hit max": [
        "4P"
    ],
    "m2103k19pi": [
        "0P"
    ],
    "lm-v700n": [
        "LG"
    ],
    "tecno ac8": [
        "TB"
    ],
    "oneplus 9 pro": [
        "ON"
    ],
    "blu life x lte": [
        "BU"
    ],
    "t671e": [
        "TC"
    ],
    "t671o": [
        "TC"
    ],
    "t767h": [
        "TC"
    ],
    "t773o": [
        "TC"
    ],
    "t781": [
        "TC"
    ],
    "t810s": [
        "TC"
    ],
    "t810h": [
        "TC"
    ],
    "v2114": [
        "VV"
    ],
    "v2108": [
        "VV"
    ],
    "rmx3393": [
        "RE"
    ],
    "i2009": [
        "VV"
    ],
    "x8_soul_style": [
        "A2"
    ],
    "v2047": [
        "VV"
    ],
    "infinix x6511": [
        "IF"
    ],
    "gome 2017m95a": [
        "G5"
    ],
    "titan p4000 pro 2021_eea": [
        "IH",
        "UZ"
    ],
    "vivax fly6": [
        "V5",
        "FL"
    ],
    "s21 plus 2021_eea": [
        "IH"
    ],
    "note 7t": [
        "UL"
    ],
    "via g5": [
        "R4"
    ],
    "w-v851-ope": [
        "WI"
    ],
    "itel w5001p": [
        "IZ"
    ],
    "itel p651l": [
        "IZ"
    ],
    "itel a611w": [
        "IZ"
    ],
    "u3h": [
        "EL"
    ],
    "itel a571w": [
        "IZ"
    ],
    "venus_v3_5070": [
        "VT"
    ],
    "doogee x5mp": [
        "DO"
    ],
    "a3_mini": [
        "LV"
    ],
    "ione note": [
        "MI"
    ],
    "outdoor lte": [
        "TL"
    ],
    "opulent x": [
        "2R"
    ],
    "ookeeone": [
        "OJ"
    ],
    "x9pro": [
        "DO"
    ],
    "x7pro": [
        "DO"
    ],
    "x6pro": [
        "DO"
    ],
    "sbm200sh": [
        "SH"
    ],
    "studio x10+": [
        "BU"
    ],
    "decade 53": [
        "2Y"
    ],
    "outdoor wt4": [
        "TL"
    ],
    "outdoor wt4-s": [
        "TL"
    ],
    "s2052gb": [
        "KA"
    ],
    "massgo_vi5_plus": [
        "8Y"
    ],
    "massgo_vi5": [
        "8Y"
    ],
    "massgo_vi2s": [
        "8Y"
    ],
    "massgo_one": [
        "8Y"
    ],
    "massgo e5": [
        "8Y"
    ],
    "bison n1": [
        "UM"
    ],
    "i_star_plus": [
        "OL"
    ],
    "gionee s10 lite": [
        "GI"
    ],
    "hisense infinity e max": [
        "HI"
    ],
    "hisense t5 plus": [
        "HI"
    ],
    "hisense f24": [
        "HI"
    ],
    "hisense h30 lite": [
        "HI"
    ],
    "hisense h30": [
        "HI"
    ],
    "hisense infinity h30 lite": [
        "HI"
    ],
    "hisense infinity h40 rock": [
        "HI"
    ],
    "hisense infinity h30": [
        "HI"
    ],
    "hisense u40 lite": [
        "HI"
    ],
    "hisense m50 lite 2021": [
        "HI"
    ],
    "rmx3361": [
        "RE"
    ],
    "omix x500": [
        "QQ"
    ],
    "tecno kg6k": [
        "TB"
    ],
    "ef501r": [
        "J8"
    ],
    "asus zenfone go zb500kl": [
        "AU"
    ],
    "zen 5+": [
        "WY"
    ],
    "ipegtop z26": [
        "X9"
    ],
    "gsmart guru g1": [
        "GG"
    ],
    "nexa vega n1": [
        "7X"
    ],
    "schr9gl": [
        "SS"
    ],
    "xt2201-2": [
        "MR"
    ],
    "chl-an00": [
        "HNR",
        "HU"
    ],
    "v2171a": [
        "VV"
    ],
    "hebe-bd00": [
        "8X"
    ],
    "sm-w2022": [
        "SA"
    ],
    "rmx3300": [
        "RE"
    ],
    "nx667j": [
        "57"
    ],
    "meizu 17": [
        "M1"
    ],
    "mi 9 roy": [
        "XI"
    ],
    "lsa-an00": [
        "HNR"
    ],
    "zte a2322": [
        "ZT"
    ],
    "zte a2022p": [
        "ZT"
    ],
    "pfjm10": [
        "OP"
    ],
    "rmx2112": [
        "RE"
    ],
    "rmx3043": [
        "RE"
    ],
    "rmx3125": [
        "RE"
    ],
    "rmx3461": [
        "RE"
    ],
    "dp-cmx1": [
        "9Q"
    ],
    "jsc-al50": [
        "HU"
    ],
    "noh-al00": [
        "HU"
    ],
    "wkg-an00": [
        "HU"
    ],
    "pfum10": [
        "OP"
    ],
    "pfvm10": [
        "OP"
    ],
    "v2156a": [
        "VV"
    ],
    "v2157a": [
        "VV"
    ],
    "v2154a": [
        "VV"
    ],
    "v2131a": [
        "VV"
    ],
    "v2130a": [
        "VV"
    ],
    "v2115a": [
        "VV"
    ],
    "v2102a": [
        "VV"
    ],
    "v2069a": [
        "VV"
    ],
    "v2158a": [
        "VV"
    ],
    "coolpad t2-00": [
        "CO"
    ],
    "andromax a16c3h": [
        "SC"
    ],
    "kopo_a1": [
        "KP"
    ],
    "kopo l6": [
        "KP"
    ],
    "kopo k11": [
        "KP"
    ],
    "gn8003l": [
        "GI"
    ],
    "gn8003": [
        "GI"
    ],
    "hera-bd00": [
        "8X"
    ],
    "vp002": [
        "UW"
    ],
    "vp001": [
        "UW"
    ],
    "vp003": [
        "UW"
    ],
    "zte 7530n": [
        "ZT"
    ],
    "tyh601m": [
        "HU"
    ],
    "tyh612m": [
        "U9"
    ],
    "tyh611m": [
        "U9"
    ],
    "tyh211u": [
        "U9"
    ],
    "tyh201h": [
        "U9"
    ],
    "zte a2022h": [
        "ZT"
    ],
    "zte a2122h": [
        "ZT"
    ],
    "2109119bc": [
        "XI"
    ],
    "2201122c": [
        "XI"
    ],
    "2201123c": [
        "XI"
    ],
    "chl-al60": [
        "HU"
    ],
    "tet-an50": [
        "HU"
    ],
    "clt-al00l": [
        "HU"
    ],
    "frl-tn00": [
        "HU"
    ],
    "jer-tn20": [
        "HU"
    ],
    "frl-an00a": [
        "HU"
    ],
    "tet-al00": [
        "HU"
    ],
    "jef-tn20": [
        "HU"
    ],
    "aloha_5g": [
        "ZD"
    ],
    "glk-tl00": [
        "HU"
    ],
    "noh-an50": [
        "HU"
    ],
    "v2023ea": [
        "VV"
    ],
    "v1962ba": [
        "VV"
    ],
    "2112123ac": [
        "XI"
    ],
    "elz-an10": [
        "HNR"
    ],
    "elz-an20": [
        "HNR"
    ],
    "conquest-s20": [
        "4C"
    ],
    "nth-an00": [
        "HNR"
    ],
    "rna-tn00": [
        "HNR"
    ],
    "rte-al00": [
        "HU"
    ],
    "jad-al00": [
        "HU"
    ],
    "bal-al00": [
        "HU"
    ],
    "hjc-lx9": [
        "HNR",
        "HU"
    ],
    "wkg-tn00": [
        "HU"
    ],
    "mld-al10": [
        "HU"
    ],
    "mld-al00": [
        "HU"
    ],
    "jad-al60": [
        "HU"
    ],
    "oce-an00": [
        "HU"
    ],
    "pdat10": [
        "OP"
    ],
    "lava z61p": [
        "LV"
    ],
    "newman g5i": [
        "0N"
    ],
    "16s pro": [
        "M1"
    ],
    "oppo r11s plust": [
        "OP"
    ],
    "oppo r11s plus": [
        "OP"
    ],
    "oppo r11 plusk": [
        "OP"
    ],
    "oppo r11 plus": [
        "OP"
    ],
    "oppo a59st": [
        "OP"
    ],
    "konka 509": [
        "KO"
    ],
    "v2162a": [
        "VV"
    ],
    "oppo a79k": [
        "OP"
    ],
    "oppo a79": [
        "OP"
    ],
    "oppo a77t": [
        "OP"
    ],
    "oppo a73t": [
        "OP"
    ],
    "angelcare_f20": [
        "6J"
    ],
    "angelcare f20pro": [
        "6J"
    ],
    "v2045a": [
        "VV"
    ],
    "pgcm10": [
        "OP"
    ],
    "pfcm00": [
        "OP"
    ],
    "peum00": [
        "OP"
    ],
    "pecm20": [
        "OP"
    ],
    "allure m2": [
        "C5",
        "M1"
    ],
    "smart_turbo_4g": [
        "M9"
    ],
    "soyes xs11": [
        "8S"
    ],
    "zera s": [
        "H2"
    ],
    "thrill plus 16gb": [
        "CD"
    ],
    "lg-sp200": [
        "LG"
    ],
    "meo smart a80": [
        "ZT"
    ],
    "le up": [
        "LM"
    ],
    "lio+": [
        "QA"
    ],
    "sugar_y18": [
        "9S"
    ],
    "sugar_p11": [
        "9S"
    ],
    "iphone4,1": [
        "AP"
    ],
    "tank xtreme": [
        "BU"
    ],
    "1872-a0": [
        "CO"
    ],
    "unno p8": [
        "UY"
    ],
    "r7plust": [
        "OP"
    ],
    "r7plus": [
        "OP"
    ],
    "xiaomi_m2001j1e": [
        "XI"
    ],
    "vdvd ix21": [
        "QJ"
    ],
    "cmcc m670": [
        "C3"
    ],
    "g0515d": [
        "G6"
    ],
    "rmx2083": [
        "RE"
    ],
    "2201117pg": [
        "0P"
    ],
    "abr-al00": [
        "HU"
    ],
    "gia-an00": [
        "HNR"
    ],
    "tah-an00": [
        "HU"
    ],
    "v1930": [
        "VV"
    ],
    "pelm00": [
        "OP"
    ],
    "xt2071-4": [
        "MR"
    ],
    "xt2153-1": [
        "MR"
    ],
    "xt2143-1": [
        "MR"
    ],
    "zte t630": [
        "ZT"
    ],
    "zte t520": [
        "ZT"
    ],
    "zte blade a476": [
        "ZT"
    ],
    "zte blade a515": [
        "ZT"
    ],
    "zte blade a110": [
        "ZT"
    ],
    "zte blade a410": [
        "ZT"
    ],
    "zte ba601": [
        "ZT"
    ],
    "zte ba910": [
        "ZT"
    ],
    "zte ba610t": [
        "ZT"
    ],
    "zte ba510": [
        "ZT"
    ],
    "zte blade l111": [
        "ZT"
    ],
    "1505-a02": [
        "36"
    ],
    "1605-a01": [
        "36"
    ],
    "smart-ex02 row": [
        "ZZ"
    ],
    "p651 2021": [
        "ZT"
    ],
    "htc u-1w": [
        "HT"
    ],
    "starnaute3": [
        "SX"
    ],
    "stk life 8": [
        "S8"
    ],
    "storm 2e pluz": [
        "S8"
    ],
    "sweet5": [
        "KW"
    ],
    "t5_lite": [
        "DO"
    ],
    "ac45ne": [
        "AR"
    ],
    "m72 smart": [
        "ZN"
    ],
    "m6plus": [
        "TP"
    ],
    "m655": [
        "8L"
    ],
    "joy hh5524a": [
        "JP"
    ],
    "joy jd5546g": [
        "JP"
    ],
    "joy jd5024g": [
        "JP"
    ],
    "like_7": [
        "IH"
    ],
    "lp_pro1": [
        "LL"
    ],
    "lp_b-50": [
        "LL"
    ],
    "qsmart x10": [
        "QM"
    ],
    "twist 2 go": [
        "3P"
    ],
    "plume l1 plus": [
        "C5"
    ],
    "like hi5": [
        "IH"
    ],
    "lefit": [
        "LM"
    ],
    "gionee f6 pro": [
        "GI"
    ],
    "pcrt00": [
        "OP"
    ],
    "yu fly f9": [
        "YF",
        "FL"
    ],
    "voga 55909": [
        "7W"
    ],
    "huawei crr-ul20": [
        "HU"
    ],
    "huawei crr-cl00": [
        "HU"
    ],
    "huagan ht6": [
        "QZ",
        "HM"
    ],
    "haipainoble s6": [
        "XH"
    ],
    "kkg-an70": [
        "HU"
    ],
    "iv2201": [
        "ON"
    ],
    "ne2210": [
        "ON"
    ],
    "mgi-an00": [
        "HNR"
    ],
    "v2172a": [
        "VV"
    ],
    "zte 9030n": [
        "ZT"
    ],
    "zte 9040n": [
        "ZT"
    ],
    "titan_pocket": [
        "UZ"
    ],
    "v2165a": [
        "VV"
    ],
    "v2164a": [
        "VV"
    ],
    "v2163a": [
        "VV"
    ],
    "xt2175-2": [
        "MR"
    ],
    "xt2171-3": [
        "MR"
    ],
    "cma-an00": [
        "HNR"
    ],
    "zte a2021h": [
        "ZT"
    ],
    "zte a2020 sp": [
        "ZT"
    ],
    "zte 9000n": [
        "ZT"
    ],
    "zte 8012n": [
        "ZT"
    ],
    "22011119ti": [
        "XI"
    ],
    "nat-tn70": [
        "YY"
    ],
    "meizu 18x": [
        "M1"
    ],
    "meizu 18s pro": [
        "M1"
    ],
    "new-an90": [
        "HNR"
    ],
    "asus_i005db": [
        "AU"
    ],
    "any-an00": [
        "HU"
    ],
    "vtr-tl00": [
        "HU"
    ],
    "vivo x20plus ud": [
        "VV"
    ],
    "oysin x60": [
        "QF"
    ],
    "perm10": [
        "OP"
    ],
    "pemt20": [
        "OP"
    ],
    "pvg100e": [
        "PM"
    ],
    "qmobile i5i 2019": [
        "QM"
    ],
    "qmobile i5i 2018": [
        "QM"
    ],
    "lead 3": [
        "L5"
    ],
    "gm discovery ii": [
        "GN"
    ],
    "pelitt t1 max": [
        "8J"
    ],
    "tecno kg5n": [
        "TB"
    ],
    "a20pro": [
        "B2"
    ],
    "power 3s": [
        "UL"
    ],
    "pelitt t1 plus": [
        "8J"
    ],
    "hammer_energy": [
        "HAM"
    ],
    "ht16pro": [
        "HM"
    ],
    "i5030": [
        "NM"
    ],
    "i5031": [
        "NM"
    ],
    "i508": [
        "NM"
    ],
    "i5530": [
        "NM"
    ],
    "huawei vns-al00": [
        "HU"
    ],
    "huawei vns-tl00": [
        "HU"
    ],
    "axe_m_lte": [
        "MY1"
    ],
    "as-5412": [
        "A8"
    ],
    "huawei gra-ul10": [
        "HU"
    ],
    "huawei gra-tl00": [
        "HU"
    ],
    "bds2 plus": [
        "8Z"
    ],
    "xq-bq52": [
        "SO"
    ],
    "allure m1 plus": [
        "C5"
    ],
    "allure m3 lite": [
        "C5"
    ],
    "aqua s9": [
        "CH",
        "IX"
    ],
    "aqua s9 max": [
        "CH",
        "IX"
    ],
    "v2130": [
        "VV"
    ],
    "rmx3472": [
        "RE"
    ],
    "tecno kg5m": [
        "TB"
    ],
    "wp16": [
        "OE"
    ],
    "bq-5565l": [
        "BX"
    ],
    "excite": [
        "HR"
    ],
    "mywigo excite 3": [
        "MG",
        "HR"
    ],
    "excite prime": [
        "CD",
        "HR"
    ],
    "mywigo excite giii": [
        "MG",
        "HR"
    ],
    "excite prime 2": [
        "CD",
        "HR"
    ],
    "excitec": [
        "CD"
    ],
    "hype_x": [
        "4M"
    ],
    "x1_light": [
        "3G"
    ],
    "itel l5503l": [
        "IZ"
    ],
    "beryllium": [
        "XI"
    ],
    "crackling": [
        "WF"
    ],
    "tecno id3k": [
        "TB"
    ],
    "tecno id5a": [
        "TB"
    ],
    "tecno kb2": [
        "TB"
    ],
    "tecno ia5": [
        "TB"
    ],
    "rmx3262": [
        "RE"
    ],
    "w-v830-id": [
        "WI"
    ],
    "hit p10": [
        "4P"
    ],
    "cyber 9 pro": [
        "HV"
    ],
    "infinix x662": [
        "IF"
    ],
    "a105sh": [
        "SH"
    ],
    "samsung sm-m536b": [
        "SA"
    ],
    "gm6_tur": [
        "GN"
    ],
    "primo zx4": [
        "WA"
    ],
    "rmx3310": [
        "RE"
    ],
    "v2132": [
        "VV"
    ],
    "v2135": [
        "VV"
    ],
    "kyv47-j": [
        "KY"
    ],
    "kyf42": [
        "KY"
    ],
    "kyf38": [
        "KY"
    ],
    "redmi k40": [
        "XI"
    ],
    "redmi k40 pro+": [
        "XI"
    ],
    "redmi k40 pro": [
        "XI"
    ],
    "n1374dl": [
        "NK"
    ],
    "micromax e6523": [
        "MI"
    ],
    "6056d": [
        "AL"
    ],
    "6156a": [
        "TC"
    ],
    "6156d": [
        "TC"
    ],
    "sm-a025v": [
        "SA"
    ],
    "v2116": [
        "VV"
    ],
    "t5c": [
        "L5"
    ],
    "plus e": [
        "UM"
    ],
    "umi plus e": [
        "UM"
    ],
    "lex626": [
        "L1"
    ],
    "le x522": [
        "L1"
    ],
    "samsung sm-m236b": [
        "SA"
    ],
    "sm-a528n": [
        "SA"
    ],
    "is530": [
        "9J"
    ],
    "rx600": [
        "4A"
    ],
    "rx700": [
        "4A"
    ],
    "s48c": [
        "CA"
    ],
    "d6 lite": [
        "B3"
    ],
    "d6 pro": [
        "B3"
    ],
    "conquest-s19": [
        "4C"
    ],
    "g1lite": [
        "XQ"
    ],
    "5007s": [
        "AL"
    ],
    "a104sh": [
        "SH"
    ],
    "a103sh": [
        "SH"
    ],
    "v2166a": [
        "VV"
    ],
    "a103op": [
        "OP"
    ],
    "nx701j": [
        "57"
    ],
    "abr-al60": [
        "HU"
    ],
    "jln-al00": [
        "HU"
    ],
    "22041211ac": [
        "XI"
    ],
    "redmi k30i 5g": [
        "XI"
    ],
    "sh-m20": [
        "SH"
    ],
    "mix 3": [
        "XI"
    ],
    "moto g31(w)": [
        "MR"
    ],
    "22011211c": [
        "XI"
    ],
    "22021211rc": [
        "XI"
    ],
    "shark par-a0": [
        "XI"
    ],
    "lge-an10": [
        "HNR",
        "HU",
        "LG"
    ],
    "sm-w2021": [
        "SA"
    ],
    "tna-an00": [
        "HNR"
    ],
    "tfy-an00": [
        "HU"
    ],
    "v2168a": [
        "VV"
    ],
    "aoro_a7": [
        "RW"
    ],
    "sm-f7000": [
        "SA"
    ],
    "f-01h": [
        "FU"
    ],
    "oppo r7splus": [
        "OP"
    ],
    "vk7000": [
        "V0"
    ],
    "a553 power": [
        "E7"
    ],
    "grand energy": [
        "BU"
    ],
    "hero2": [
        "ZP"
    ],
    "studio g hd lte": [
        "BU"
    ],
    "thunder": [
        "H2"
    ],
    "stk sync 5z plus": [
        "S8"
    ],
    "mobiistar lai zoro 3": [
        "M6"
    ],
    "lex620": [
        "L1"
    ],
    "lex622": [
        "L1"
    ],
    "lex650": [
        "L1"
    ],
    "lex651": [
        "L1"
    ],
    "lex653": [
        "L1"
    ],
    "lex657": [
        "L1"
    ],
    "lg-f560k": [
        "LG"
    ],
    "lg-f620l": [
        "LG"
    ],
    "sm-e426b": [
        "SA"
    ],
    "s2_pro": [
        "UM"
    ],
    "s2 pro": [
        "QM"
    ],
    "p13 blue 2022": [
        "RD"
    ],
    "p13 blue max pro 2021": [
        "RD"
    ],
    "p13 blue max pro": [
        "RD"
    ],
    "p13 blue maxl 2021": [
        "RD"
    ],
    "p13 blue maxl 2022": [
        "RD"
    ],
    "zeeker p10": [
        "WZ"
    ],
    "via_e30": [
        "R4"
    ],
    "archos 55 diamond selfie": [
        "AR"
    ],
    "rp05": [
        "UM"
    ],
    "k15 pro": [
        "OE"
    ],
    "bv6600e": [
        "B2"
    ],
    "bv8800": [
        "B2"
    ],
    "bv6600pro": [
        "B2"
    ],
    "tecno w5006s": [
        "TB"
    ],
    "aux_t5001": [
        "XU"
    ],
    "mann 8s": [
        "5M"
    ],
    "neolix x9-jd": [
        "8F"
    ],
    "hltem800": [
        "HI"
    ],
    "atman-x5": [
        "YH"
    ],
    "eyu t53": [
        "UF"
    ],
    "foodo x10": [
        "FJ"
    ],
    "ivvi i3-01": [
        "UI"
    ],
    "ivvi p60": [
        "UI"
    ],
    "ivvi p60_p40": [
        "UI"
    ],
    "ivvi p60_x11 plus": [
        "UI"
    ],
    "ivvi p60_x12": [
        "UI"
    ],
    "ivvi p60_x50": [
        "UI"
    ],
    "ivvi m40": [
        "UI"
    ],
    "ivvi m10 pro": [
        "UI"
    ],
    "kt20201199": [
        "KT"
    ],
    "kt20201188": [
        "KT"
    ],
    "ldxa-2022": [
        "KT"
    ],
    "ldxa-2122": [
        "KT"
    ],
    "m20201419": [
        "YG"
    ],
    "neolix-t7_nggz_c": [
        "8F"
    ],
    "neolix-t7_ng_c": [
        "8F"
    ],
    "20190619g": [
        "GI"
    ],
    "20190417q": [
        "XL"
    ],
    "20190418q": [
        "GI"
    ],
    "pcct00": [
        "OP"
    ],
    "sh-s40p": [
        "SH"
    ],
    "neolix 1-c-ng": [
        "8F"
    ],
    "neolix 1-c-t": [
        "8F"
    ],
    "neolix 1-c-ngbh": [
        "8F"
    ],
    "changhongr9": [
        "C2"
    ],
    "fla-al00": [
        "HU"
    ],
    "lnd-tl30": [
        "HU"
    ],
    "lineage_ss2": [
        "SH"
    ],
    "lineage_osprey": [
        "MR"
    ],
    "lineage_a6020": [
        "LE"
    ],
    "lineage_c106": [
        "L1"
    ],
    "hydrogen": [
        "XI"
    ],
    "lineage_fs504": [
        "FL"
    ],
    "lineage_serranoltexx": [
        "SA"
    ],
    "mogolia": [
        "HU"
    ],
    "sm-a225m": [
        "SA"
    ],
    "oneplus 8t": [
        "ON"
    ],
    "hisense v50": [
        "HI"
    ],
    "hisense u50": [
        "HI"
    ],
    "nokia x100": [
        "NK"
    ],
    "hisense h50 lite": [
        "HI"
    ],
    "bird_l600": [
        "BI"
    ],
    "bird_l7": [
        "BI"
    ],
    "ax1092": [
        "BM"
    ],
    "htc_pyramid": [
        "HT"
    ],
    "hisense l675 pro": [
        "HI"
    ],
    "g3223": [
        "SO"
    ],
    "moto e(6s)": [
        "MR"
    ],
    "sugar s30": [
        "9S"
    ],
    "haier g32": [
        "HA"
    ],
    "studio j8 lte": [
        "BU"
    ],
    "voyager2_dg310": [
        "DO"
    ],
    "5033f": [
        "AL"
    ],
    "sm-a235n": [
        "SA"
    ],
    "sm-a235f": [
        "SA"
    ],
    "samsung sm-a235n": [
        "SA"
    ],
    "samsung sm-a135f": [
        "SA"
    ],
    "samsung sm-a336b": [
        "SA"
    ],
    "samsung sm-a336e": [
        "SA"
    ],
    "pearl k2 2020": [
        "HV"
    ],
    "ht26": [
        "HM"
    ],
    "ht37": [
        "HM"
    ],
    "trekker-x3": [
        "C1"
    ],
    "beeline smart 6": [
        "B5"
    ],
    "infinix x625b": [
        "IF"
    ],
    "tecno sa6s": [
        "TB"
    ],
    "sm-m236q": [
        "SA"
    ],
    "lenovo s920": [
        "LE"
    ],
    "lenovo s930": [
        "LE"
    ],
    "lenovo s939": [
        "LE"
    ],
    "lenovo s938t": [
        "LE"
    ],
    "lenovo s860": [
        "LE"
    ],
    "lenovo s820c": [
        "LE"
    ],
    "lenovo s820": [
        "LE"
    ],
    "lenovo s750": [
        "LE"
    ],
    "lenovo s720": [
        "LE"
    ],
    "lenovo s890": [
        "LE"
    ],
    "philips xenium v787": [
        "PH"
    ],
    "redmi 10c": [
        "XI"
    ],
    "sm-g928k": [
        "SA"
    ],
    "sm-g928f": [
        "SA"
    ],
    "sm-g928c": [
        "SA"
    ],
    "impress_play": [
        "VX"
    ],
    "thl t6c": [
        "T4"
    ],
    "eluga x1": [
        "PA"
    ],
    "symphony z45": [
        "SM"
    ],
    "lenovo k12 note": [
        "LE"
    ],
    "sm-g990w": [
        "SA"
    ],
    "hisense h50": [
        "HI"
    ],
    "sm-a135u": [
        "SA"
    ],
    "titan pocket": [
        "UZ"
    ],
    "bravis_a506": [
        "BV"
    ],
    "bravis delta": [
        "BV"
    ],
    "bravis_a553": [
        "BV"
    ],
    "b501": [
        "BV"
    ],
    "n1_550_cruiser": [
        "BV"
    ],
    "bravis omega": [
        "BV"
    ],
    "bravis power": [
        "BV"
    ],
    "bravis s500": [
        "BV"
    ],
    "n1-570 space": [
        "BV"
    ],
    "bravis tau": [
        "BV"
    ],
    "bravis x500": [
        "BV"
    ],
    "bravis_trend": [
        "BV"
    ],
    "sprd-boway-i5": [
        "BW"
    ],
    "i6": [
        "BW"
    ],
    "boway i7": [
        "BW"
    ],
    "boway_u3": [
        "BW"
    ],
    "boway_u7": [
        "BW"
    ],
    "v100": [
        "BW"
    ],
    "boway_v95pro": [
        "BW"
    ],
    "bq-5500l": [
        "BX"
    ],
    "bqs_5505": [
        "BX"
    ],
    "bq aquaris": [
        "BX",
        "IX"
    ],
    "bq aquaris 4": [
        "BX",
        "IX"
    ],
    "bq aquaris 5": [
        "BX",
        "IX"
    ],
    "bq aquaris 5 hd": [
        "BX",
        "IX"
    ],
    "bq aquaris 5.7": [
        "BX",
        "IX"
    ],
    "aquaris_a4.5": [
        "BX",
        "IX"
    ],
    "aquaris c": [
        "BX",
        "IX"
    ],
    "aquaris e4": [
        "BX",
        "IX"
    ],
    "aquaris e4.5": [
        "BX",
        "IX"
    ],
    "aquaris e5": [
        "BX",
        "IX"
    ],
    "aquaris e5 fhd": [
        "BX",
        "IX"
    ],
    "aquaris e6": [
        "BX",
        "IX"
    ],
    "aquaris m": [
        "BX",
        "IX"
    ],
    "aquaris m10": [
        "BX",
        "IX"
    ],
    "aquaris m5": [
        "BX",
        "IX"
    ],
    "aquaris u": [
        "BX",
        "IX"
    ],
    "aquaris u lite": [
        "BX",
        "IX"
    ],
    "aquaris u plus": [
        "BX",
        "IX"
    ],
    "aquaris u2": [
        "BX",
        "IX"
    ],
    "aquaris u2 lite": [
        "BX",
        "IX"
    ],
    "aquaris v": [
        "BX",
        "IX"
    ],
    "aquaris v plus": [
        "BX",
        "IX"
    ],
    "aquaris x": [
        "BX",
        "IX"
    ],
    "aquaris x pro": [
        "BX",
        "IX"
    ],
    "aquaris x5": [
        "BX",
        "IX"
    ],
    "aquaris x5 plus": [
        "BX",
        "IX"
    ],
    "bqs-4010": [
        "BX"
    ],
    "bqs-3510": [
        "BX"
    ],
    "bq-6000l": [
        "BX"
    ],
    "bq-6200l": [
        "BX"
    ],
    "bq-5206l": [
        "BX"
    ],
    "bq-5071": [
        "BX"
    ],
    "bqs-4800": [
        "BX"
    ],
    "bq-5511l": [
        "BX"
    ],
    "bqs-3503": [
        "BX"
    ],
    "bq-5022": [
        "BX"
    ],
    "bqru-5022": [
        "BX"
    ],
    "bq-5008l": [
        "BX"
    ],
    "bqs-4501 bristol": [
        "BX"
    ],
    "bqs-5065": [
        "BX"
    ],
    "bq-5340": [
        "BX"
    ],
    "bqs-5002": [
        "BX"
    ],
    "bqs-5003": [
        "BX"
    ],
    "bq-5001l": [
        "BX"
    ],
    "bq-4001g": [
        "BX"
    ],
    "bqru-5054": [
        "BX"
    ],
    "bqs-4570": [
        "BX"
    ],
    "bqs-4503": [
        "BX"
    ],
    "bqs-4004": [
        "BX"
    ],
    "bq-5032": [
        "BX"
    ],
    "bq-5515": [
        "BX"
    ],
    "bqs-5045": [
        "BX"
    ],
    "bq-5515l": [
        "BX"
    ],
    "bq-5519l": [
        "BX"
    ],
    "bq-5015l": [
        "BX"
    ],
    "bqs-4510": [
        "BX"
    ],
    "bq-4526": [
        "BX"
    ],
    "bqru-4526": [
        "BX"
    ],
    "bq-5004g": [
        "BX"
    ],
    "bq-4501g": [
        "BX"
    ],
    "bqru-4500": [
        "BX"
    ],
    "bqru-4583": [
        "BX"
    ],
    "bq-4585": [
        "BX"
    ],
    "bq-5011g": [
        "BX"
    ],
    "bqs-5030": [
        "BX"
    ],
    "bq-5056": [
        "BX"
    ],
    "bq-5002g": [
        "BX"
    ],
    "bqs-4560": [
        "BX"
    ],
    "bqs-5502": [
        "BX"
    ],
    "bqs-5025": [
        "BX"
    ],
    "bq-8068l": [
        "BX"
    ],
    "bq-5005l": [
        "BX"
    ],
    "bq-5530l": [
        "BX"
    ],
    "bq-5007l": [
        "BX"
    ],
    "bq-5507l": [
        "BX"
    ],
    "bq-5591": [
        "BX"
    ],
    "bq-5518g": [
        "BX"
    ],
    "bq-6050": [
        "BX"
    ],
    "bqs-5501": [
        "BX"
    ],
    "bqs-4502": [
        "BX"
    ],
    "bqs-5006": [
        "BX"
    ],
    "bqs-5070": [
        "BX"
    ],
    "bq-6040l": [
        "BX"
    ],
    "bq-5730l": [
        "BX"
    ],
    "bq-6042l": [
        "BX"
    ],
    "bq-5731l": [
        "BX"
    ],
    "bqs-5520": [
        "BX"
    ],
    "bq-6016l": [
        "BX"
    ],
    "bqs-5001": [
        "BX"
    ],
    "bqs-5011": [
        "BX"
    ],
    "bqs-4707": [
        "BX"
    ],
    "bqs-4515": [
        "BX"
    ],
    "bq-5508l": [
        "BX"
    ],
    "bq-5707g": [
        "BX"
    ],
    "bqru-5503": [
        "BX"
    ],
    "bqs-4009": [
        "BX"
    ],
    "bqs-4001": [
        "BX"
    ],
    "bqs-5004": [
        "BX"
    ],
    "bqru-5525": [
        "BX"
    ],
    "bq-6010g": [
        "BX"
    ],
    "bqs-5010": [
        "BX"
    ],
    "bq-5012l": [
        "BX"
    ],
    "bqs-4550": [
        "BX"
    ],
    "bqs-4505": [
        "BX"
    ],
    "bq-5052": [
        "BX"
    ],
    "bq-5082": [
        "BX"
    ],
    "bqs-4005": [
        "BX"
    ],
    "bqs-4008": [
        "BX"
    ],
    "bqru-5033": [
        "BX"
    ],
    "bq-4077": [
        "BX"
    ],
    "bq-5003l": [
        "BX"
    ],
    "bq-5541l": [
        "BX"
    ],
    "bq-5520l": [
        "BX"
    ],
    "bqs-4516": [
        "BX"
    ],
    "bqs-5060": [
        "BX"
    ],
    "bq-5701l": [
        "BX"
    ],
    "bqru-5060": [
        "BX"
    ],
    "bqru-5201": [
        "BX"
    ],
    "bq-5201": [
        "BX"
    ],
    "bqru-5202": [
        "BX"
    ],
    "bq-5700l": [
        "BX"
    ],
    "bq-5010g": [
        "BX"
    ],
    "bqru_5590": [
        "BX"
    ],
    "bq-5702": [
        "BX"
    ],
    "bqs-5020": [
        "BX"
    ],
    "bq-5211": [
        "BX"
    ],
    "bqru-5057": [
        "BX"
    ],
    "bq-5512l": [
        "BX"
    ],
    "bq-5528l": [
        "BX"
    ],
    "bq-5044": [
        "BX"
    ],
    "bq-5209l": [
        "BX"
    ],
    "bqru-4072": [
        "BX"
    ],
    "bq5059": [
        "BX"
    ],
    "bqru-5059": [
        "BX"
    ],
    "bq-5059": [
        "BX"
    ],
    "bq-5514g": [
        "BX"
    ],
    "bqru-5037": [
        "BX"
    ],
    "bq-5514l": [
        "BX"
    ],
    "bq-5058": [
        "BX"
    ],
    "bq-5594": [
        "BX"
    ],
    "bq-6035l": [
        "BX"
    ],
    "bqru-5510": [
        "BX"
    ],
    "bq-5535l": [
        "BX"
    ],
    "bqs-5050": [
        "BX"
    ],
    "bqru-5204": [
        "BX"
    ],
    "bqru-5504": [
        "BX"
    ],
    "bq-5301": [
        "BX"
    ],
    "bqs-5005": [
        "BX"
    ],
    "bqs-5009": [
        "BX"
    ],
    "bqs-5000 tokyo": [
        "BX"
    ],
    "bqru-5000": [
        "BX"
    ],
    "bq-5009l": [
        "BX"
    ],
    "bqs-4555": [
        "BX"
    ],
    "bqs-5055": [
        "BX"
    ],
    "bq-5516l": [
        "BX"
    ],
    "bq-5517l": [
        "BX"
    ],
    "bqru-6015l": [
        "BX"
    ],
    "bq-6015l": [
        "BX"
    ],
    "bq-4026": [
        "BX"
    ],
    "bqru-4028": [
        "BX"
    ],
    "bqs-4007": [
        "BX"
    ],
    "bqs-5500": [
        "BX"
    ],
    "bq-5302g": [
        "BX"
    ],
    "bq-5300g": [
        "BX"
    ],
    "bqs-4701": [
        "BX"
    ],
    "bqs-4003": [
        "BX"
    ],
    "bqs-4525": [
        "BX"
    ],
    "bqru-5203": [
        "BX"
    ],
    "bqs-5515": [
        "BX"
    ],
    "bqs-4702": [
        "BX"
    ],
    "bezkam bk-ram2": [
        "BZ"
    ],
    "hind 5.1": [
        "C0"
    ],
    "x417_amaze": [
        "C0"
    ],
    "x418 zest": [
        "C0"
    ],
    "x421 nova": [
        "C0"
    ],
    "x422 exotic": [
        "C0"
    ],
    "x425 shavit": [
        "C0"
    ],
    "x428 astute": [
        "C0"
    ],
    "action-x3": [
        "C1"
    ],
    "core-x3": [
        "C1"
    ],
    "crosscall element": [
        "C1"
    ],
    "odyssey s1": [
        "C1"
    ],
    "odyssey_plus": [
        "C1"
    ],
    "trekker-m1": [
        "C1"
    ],
    "trekker-m1 core": [
        "C1"
    ],
    "trekker-s1": [
        "C1"
    ],
    "trekker-x1": [
        "C1"
    ],
    "trekker-x4": [
        "C1"
    ],
    "crosscall wild": [
        "C1"
    ],
    "1501_m02": [
        "C3"
    ],
    "9930i": [
        "C3"
    ],
    "a1303": [
        "C3"
    ],
    "m651cy": [
        "C3"
    ],
    "a309w": [
        "C3"
    ],
    "m812c": [
        "C3"
    ],
    "cyrus_cs25": [
        "C4"
    ],
    "cyrus_cs30": [
        "C4"
    ],
    "pgn607": [
        "C5"
    ],
    "pgn609": [
        "C5"
    ],
    "pgn606": [
        "C5"
    ],
    "pgn613": [
        "C5"
    ],
    "pgn608": [
        "C5"
    ],
    "pgn611": [
        "C5"
    ],
    "pgn612": [
        "C5"
    ],
    "pgn-507": [
        "C5"
    ],
    "pgn511": [
        "C5"
    ],
    "allure m1": [
        "C5"
    ],
    "allure m3": [
        "C5"
    ],
    "pkt-301": [
        "C5"
    ],
    "pgn-403": [
        "C5"
    ],
    "pgn-504": [
        "C5"
    ],
    "pgn-509": [
        "C5"
    ],
    "pgn-508": [
        "C5"
    ],
    "pgn-506": [
        "C5"
    ],
    "pgn-404": [
        "C5"
    ],
    "phs-601": [
        "C5"
    ],
    "pgn-505": [
        "C5"
    ],
    "pgn513": [
        "C5"
    ],
    "pgn521": [
        "C5"
    ],
    "phq519": [
        "C5"
    ],
    "phq520": [
        "C5"
    ],
    "phq525": [
        "C5"
    ],
    "phq526": [
        "C5"
    ],
    "griffe t2": [
        "C5"
    ],
    "griffe t5": [
        "C5"
    ],
    "griffe t6": [
        "C5"
    ],
    "griffe t7": [
        "C5"
    ],
    "griffe t8 plus": [
        "C5"
    ],
    "griffe t9": [
        "C5"
    ],
    "pgn522": [
        "C5"
    ],
    "pgn523": [
        "C5"
    ],
    "plume h1": [
        "C5"
    ],
    "plume l1": [
        "C5"
    ],
    "plume l2 pro": [
        "C5"
    ],
    "plume l3 plus": [
        "C5"
    ],
    "pgn409": [
        "C5"
    ],
    "pgn527": [
        "C5"
    ],
    "pgn515": [
        "C5"
    ],
    "pgn516": [
        "C5"
    ],
    "pgn518": [
        "C5"
    ],
    "pgn517": [
        "C5"
    ],
    "pgn528": [
        "C5"
    ],
    "pgn514": [
        "C5"
    ],
    "pgn605": [
        "C5"
    ],
    "pgn610": [
        "C5"
    ],
    "plume p8 pro": [
        "C5"
    ],
    "comio p1": [
        "C6"
    ],
    "comio s1 lite": [
        "C6"
    ],
    "teslaevo5.0": [
        "C7"
    ],
    "tesla smartphone 3": [
        "C7"
    ],
    "tesla_sp3.1_lite": [
        "C7"
    ],
    "tesla sp3.2 lite": [
        "C7"
    ],
    "tesla_sp3.3": [
        "C7"
    ],
    "tesla_sp3.3 lite": [
        "C7"
    ],
    "tesla smartphone 6": [
        "C7"
    ],
    "smartphone_6.1": [
        "C7"
    ],
    "sp6.2": [
        "C7"
    ],
    "sp6.2_lite": [
        "C7"
    ],
    "tesla_sp6.3": [
        "C7"
    ],
    "tesla_sp9": [
        "C7"
    ],
    "tesla_sp9.1": [
        "C7"
    ],
    "tesla_sp9.1l": [
        "C7"
    ],
    "flyfix 6 c-713": [
        "C8",
        "FL"
    ],
    "concord m10": [
        "C8"
    ],
    "cagi-omega": [
        "C9"
    ],
    "b15q": [
        "CA"
    ],
    "cubot a5": [
        "CB"
    ],
    "cubot c11": [
        "CB"
    ],
    "cubot_c6w": [
        "CB"
    ],
    "cubot c9+": [
        "CB"
    ],
    "cubot cheetah 2": [
        "CB"
    ],
    "cubot dinosaur": [
        "CB"
    ],
    "cubot echo": [
        "CB"
    ],
    "cubot gt72e": [
        "CB"
    ],
    "cubot gt99": [
        "CB"
    ],
    "cubot h3": [
        "CB"
    ],
    "cubot_j3": [
        "CB"
    ],
    "cubot king kong": [
        "CB"
    ],
    "king_kong_3": [
        "CB"
    ],
    "kingkong_mini": [
        "CB"
    ],
    "cubot magic": [
        "CB"
    ],
    "cubot_manito": [
        "CB"
    ],
    "cubot max": [
        "CB"
    ],
    "cubot note plus": [
        "CB"
    ],
    "cubot_note_s": [
        "CB"
    ],
    "cubot note_s": [
        "CB"
    ],
    "cubot_nova": [
        "CB"
    ],
    "cubot one": [
        "CB"
    ],
    "cubot one-s": [
        "CB"
    ],
    "cubot_p20": [
        "CB"
    ],
    "cubot_p7": [
        "CB"
    ],
    "cubot p9": [
        "CB"
    ],
    "cubot_power": [
        "CB"
    ],
    "quest lite": [
        "CB"
    ],
    "cubot r11": [
        "CB"
    ],
    "cubot r9": [
        "CB"
    ],
    "cubot rainbow": [
        "CB",
        "WI"
    ],
    "rainbow 2": [
        "CB",
        "WI"
    ],
    "s222": [
        "CB"
    ],
    "s308": [
        "CB"
    ],
    "cubot x18": [
        "CB"
    ],
    "cubot_x18_plus": [
        "CB"
    ],
    "cubot x6": [
        "CB"
    ],
    "cubot x9": [
        "CB"
    ],
    "concorde smartphone 4300": [
        "CC"
    ],
    "thrill access": [
        "CD"
    ],
    "thrill boost": [
        "CD"
    ],
    "thrill boost 2": [
        "CD"
    ],
    "thrill boost 3": [
        "CD"
    ],
    "thrill snap": [
        "CD"
    ],
    "celkon a.r 40": [
        "CE"
    ],
    "celkon_a10": [
        "CE"
    ],
    "celkon a119q": [
        "CE"
    ],
    "celkon a125": [
        "CE"
    ],
    "celkon a15": [
        "CE"
    ],
    "celkon a66": [
        "CE"
    ],
    "celkon*a86": [
        "CE"
    ],
    "celkon a9 dual": [
        "CE"
    ],
    "celkon a9+": [
        "CE"
    ],
    "cherry mobile amber w380": [
        "CH"
    ],
    "flare 4": [
        "CH"
    ],
    "flarea1": [
        "CH"
    ],
    "flare_a2_lite": [
        "CH"
    ],
    "flare a3": [
        "CH"
    ],
    "flare_hd_max": [
        "CH"
    ],
    "flare_j1": [
        "CH"
    ],
    "flare_j1_mini": [
        "CH"
    ],
    "flare j2 mini": [
        "CH"
    ],
    "flare j2s": [
        "CH"
    ],
    "flarej3": [
        "CH"
    ],
    "flare_j3_lite": [
        "CH"
    ],
    "flare j5": [
        "CH"
    ],
    "flare lite": [
        "CH"
    ],
    "flare p1": [
        "CH"
    ],
    "flare_p1_lite": [
        "CH"
    ],
    "flare_p3": [
        "CH"
    ],
    "flare s play": [
        "CH"
    ],
    "flare_s4": [
        "CH"
    ],
    "flare s4 lite": [
        "CH"
    ],
    "flare s4 max": [
        "CH"
    ],
    "flare s4 max lte": [
        "CH"
    ],
    "flare_s5_mini": [
        "CH"
    ],
    "flare s6": [
        "CH",
        "L2"
    ],
    "flare_s6_lite": [
        "CH"
    ],
    "flare_s6_plus": [
        "CH"
    ],
    "flare s6 power": [
        "CH"
    ],
    "flare s8": [
        "CH"
    ],
    "flare_x_v2": [
        "CH"
    ],
    "flare x2": [
        "CH"
    ],
    "flare xl plus": [
        "CH"
    ],
    "flare2x": [
        "CH"
    ],
    "cherry life": [
        "CH"
    ],
    "omega hd 4": [
        "CH"
    ],
    "cherry razor": [
        "CH"
    ],
    "cherry snap": [
        "CH"
    ],
    "cherry sonic": [
        "CH"
    ],
    "yl-coolpad_5210s": [
        "CO"
    ],
    "5860s": [
        "CO"
    ],
    "coolpad 5890": [
        "CO"
    ],
    "coolpad 5950": [
        "CO"
    ],
    "yl-coolpad_7230-b": [
        "CO"
    ],
    "yl-coolpad_7260": [
        "CO"
    ],
    "coolpad 7295+": [
        "CO"
    ],
    "coolpad 7295a": [
        "CO"
    ],
    "coolpad 7296": [
        "CO"
    ],
    "coolpad-8076_td": [
        "CO"
    ],
    "coolpad8190_cmcc": [
        "CO"
    ],
    "8190q": [
        "CO"
    ],
    "coolpad8198t_cmcc": [
        "CO"
    ],
    "coolpad8295m": [
        "CO"
    ],
    "8676-a01": [
        "CO"
    ],
    "coolpad8720q_cmcc": [
        "CO"
    ],
    "coolpad8720q": [
        "CO"
    ],
    "c106-7": [
        "CO"
    ],
    "orl-c0": [
        "CO"
    ],
    "cool_9s": [
        "CO"
    ],
    "vcr-i0": [
        "CO"
    ],
    "vcr-a0": [
        "CO"
    ],
    "1831-a0": [
        "CO"
    ],
    "coolpad flo": [
        "CO"
    ],
    "cp3705a": [
        "CO"
    ],
    "cp3705as": [
        "CO"
    ],
    "cp3648a": [
        "CO"
    ],
    "mts-t0": [
        "CO"
    ],
    "cp8676_i02": [
        "CO"
    ],
    "cp8298_i00": [
        "CO"
    ],
    "cp8676_i03": [
        "CO"
    ],
    "c771": [
        "CS"
    ],
    "c811 4g": [
        "CS"
    ],
    "venus 1": [
        "CX"
    ],
    "wing 5": [
        "CX"
    ],
    "wing9": [
        "CX"
    ],
    "doopro p3": [
        "D0"
    ],
    "datsun_d5001": [
        "D1"
    ],
    "datsun_d5500": [
        "D1"
    ],
    "citi atl 4g cs5029ml": [
        "D2"
    ],
    "citi z530 3g": [
        "D2"
    ],
    "hit q401 3g ht4039pg": [
        "D2"
    ],
    "hit q500 3g ht5035pg": [
        "D2"
    ],
    "idx5": [
        "D2"
    ],
    "idxd5": [
        "D2"
    ],
    "idxq5": [
        "D2"
    ],
    "digma linx 4.5 pt452e": [
        "D2"
    ],
    "linx 6.0 ps604m": [
        "D2"
    ],
    "linx a400 3g lt4001pg": [
        "D2",
        "SO"
    ],
    "linx a420 3g ls4019pg": [
        "D2"
    ],
    "linx a450 3g lt4028pg": [
        "D2",
        "SO",
        "JG"
    ],
    "linx a452 3g lt4030pg": [
        "D2",
        "SO"
    ],
    "linx a453 3g lt4038pg": [
        "D2",
        "SO"
    ],
    "linx alfa 3g lt4047mg": [
        "D2",
        "SO"
    ],
    "linx argo 3g lt4054mg": [
        "D2",
        "SO"
    ],
    "linx atom 3g lt4049pg": [
        "D2",
        "SO"
    ],
    "linx b510 3g lt5037mg": [
        "D2",
        "SO"
    ],
    "linx base 4g lt5052ml": [
        "D2",
        "SO"
    ],
    "linx c500 3g lt5001pg": [
        "D2",
        "SO"
    ],
    "linx joy 3g lt5048mg": [
        "D2",
        "SO"
    ],
    "linx pay 4g ls5053ml": [
        "D2"
    ],
    "linx ps474s": [
        "D2"
    ],
    "linx rage 4g ls5040pl": [
        "D2"
    ],
    "linx trix 4g ls5041pl": [
        "D2"
    ],
    "linx x1 3g ls4050mg": [
        "D2"
    ],
    "linx x1 pro 3g ls4051mg": [
        "D2"
    ],
    "vox s502 4g vs5013ml": [
        "D2",
        "LG",
        "OB"
    ],
    "digicel dl810": [
        "D3"
    ],
    "digi c1": [
        "D4"
    ],
    "digi_k1": [
        "D4"
    ],
    "digi r1": [
        "D4"
    ],
    "dw-ps3g5": [
        "D7"
    ],
    "droxio b45": [
        "D8"
    ],
    "droxio c40": [
        "D8"
    ],
    "konnect402": [
        "DA"
    ],
    "konnect_504": [
        "DA"
    ],
    "konnect_601": [
        "DA"
    ],
    "konnect602": [
        "DA"
    ],
    "konnect_607": [
        "DA"
    ],
    "dialog k35": [
        "DG"
    ],
    "dell_aero": [
        "DL"
    ],
    "dell venue": [
        "DL"
    ],
    "venue pro": [
        "DL"
    ],
    "xcd35": [
        "DL"
    ],
    "dns_s4003": [
        "DN"
    ],
    "dns s4502": [
        "DN"
    ],
    "s4505m": [
        "DN"
    ],
    "sd01m": [
        "DN"
    ],
    "doogee-bigboy-dg600": [
        "DO"
    ],
    "bl12000": [
        "DO"
    ],
    "bl12000 pro": [
        "DO"
    ],
    "bl5000": [
        "B2",
        "DO"
    ],
    "bl5500_lite": [
        "DO"
    ],
    "bl7000": [
        "DO"
    ],
    "bl9000": [
        "B2",
        "DO"
    ],
    "discovery dg500": [
        "DO",
        "GN"
    ],
    "discovery2-dg500c": [
        "DO"
    ],
    "hitman_dg850": [
        "DO"
    ],
    "kissme-dg580": [
        "DO"
    ],
    "leo_dg280": [
        "DO"
    ],
    "mint-dg330": [
        "DO"
    ],
    "doogee-titans-dg150": [
        "DO"
    ],
    "titans2_dg700": [
        "DO"
    ],
    "turbo dg2014": [
        "DO"
    ],
    "y100_plus": [
        "DO"
    ],
    "valencia2_y100_plus": [
        "DO"
    ],
    "valencia2_y100pro": [
        "DO"
    ],
    "voyager dg300": [
        "DO"
    ],
    "voyager2 dg310": [
        "DO"
    ],
    "x5max": [
        "DO"
    ],
    "x5max_pro": [
        "DO"
    ],
    "x9 mini": [
        "DO"
    ],
    "x6_soul_xtreme": [
        "A2"
    ],
    "x4_soul_vision": [
        "A2"
    ],
    "x5_soul_style": [
        "A2"
    ],
    "signature l": [
        "OA"
    ],
    "signature pro": [
        "OA"
    ],
    "signature touch": [
        "OA"
    ],
    "lumia 640 lte dual sim": [
        "MS",
        "NK"
    ],
    "lumia 640 lte": [
        "MS",
        "NK"
    ],
    "microsoft; lumia 640 dual sim; cortana 1.8.12.15063; 10.0.0.0.15063.1868": [
        "MS",
        "NK"
    ],
    "lumia 535 dual sim": [
        "MS",
        "NK"
    ],
    "f4502": [
        "MV"
    ],
    "v350c": [
        "CK"
    ],
    "u325ac": [
        "CK"
    ],
    "armor 10 5g": [
        "UL"
    ],
    "tecno cf8": [
        "TB"
    ],
    "tecno wx3p": [
        "TB"
    ],
    "tecno f3": [
        "TB"
    ],
    "tecno ca7": [
        "TB"
    ],
    "tecno bb2": [
        "TB"
    ],
    "tecno ba2": [
        "TB"
    ],
    "tecno b1f": [
        "TB"
    ],
    "tecno w3 pro": [
        "TB"
    ],
    "tecno ca6": [
        "TB"
    ],
    "tecno bc1": [
        "TB"
    ],
    "tecno kf7j": [
        "TB"
    ],
    "tecno rb8s": [
        "TB"
    ],
    "tecno kc1h": [
        "TB"
    ],
    "tecno kb7j": [
        "TB"
    ],
    "tecno b1p": [
        "TB"
    ],
    "tecno cf7k": [
        "TB"
    ],
    "tecno id5b": [
        "TB"
    ],
    "tecno cd6": [
        "TB"
    ],
    "tecno bc2": [
        "TB"
    ],
    "tecno b1g": [
        "TB"
    ],
    "tecno cd8j": [
        "TB"
    ],
    "tecno lc7": [
        "TB"
    ],
    "tecno lc8": [
        "TB"
    ],
    "tecno kf8": [
        "TB"
    ],
    "tecno kb7": [
        "TB"
    ],
    "tecno la7": [
        "TB"
    ],
    "tecno lb7": [
        "TB"
    ],
    "tecno ra7": [
        "TB"
    ],
    "le2113": [
        "ON"
    ],
    "iphone14,4": [
        "AP"
    ],
    "iphone/6s ios/11.3": [
        "AP"
    ],
    "t766j": [
        "TC"
    ],
    "ks907": [
        "HI"
    ],
    "samsung sm-a725m": [
        "SA"
    ],
    "samsung sm-a022m": [
        "SA"
    ],
    "moto g stylus (2021)": [
        "MR"
    ],
    "xq-au51": [
        "SO"
    ],
    "xq-bc52": [
        "SO"
    ],
    "lg-m703": [
        "LG"
    ],
    "cosmas": [
        "CG"
    ],
    "ct_cosmas_v": [
        "CG"
    ],
    "kaz-n20": [
        "9K"
    ],
    "5002e": [
        "AL"
    ],
    "5002s": [
        "AL"
    ],
    "power 3": [
        "UM"
    ],
    "moto g power (2021)": [
        "MR"
    ],
    "moto g 5g plus": [
        "MR"
    ],
    "5006g": [
        "AL"
    ],
    "5030a": [
        "AL"
    ],
    "5029f": [
        "AL"
    ],
    "4187m": [
        "TC"
    ],
    "5002x": [
        "AL"
    ],
    "5102b": [
        "TC"
    ],
    "a7 pro": [
        "UM"
    ],
    "a9 pro": [
        "UM"
    ],
    "alcatel_5002r": [
        "AL"
    ],
    "b60pro_mv03": [
        "BM"
    ],
    "e603": [
        "HN"
    ],
    "g50 mega": [
        "BU"
    ],
    "g50 plus": [
        "BU"
    ],
    "iku a40": [
        "8I"
    ],
    "in_note1": [
        "MI"
    ],
    "k4m": [
        "WK"
    ],
    "k503hd": [
        "8E"
    ],
    "nen-lx3": [
        "HU"
    ],
    "neon ray 2": [
        "X1",
        "JG"
    ],
    "5087z": [
        "TC"
    ],
    "5033xr": [
        "AL"
    ],
    "v2055": [
        "VV"
    ],
    "v2060": [
        "VV"
    ],
    "v2054": [
        "VV"
    ],
    "v2024": [
        "VV"
    ],
    "smarte11": [
        "6W"
    ],
    "studio x10": [
        "BU"
    ],
    "twist 4 pro": [
        "PS"
    ],
    "dazen 6a": [
        "DZ"
    ],
    "m6 2021": [
        "BU"
    ],
    "miracle xs": [
        "34"
    ],
    "ilium m7t": [
        "LA"
    ],
    "mtech tez 4g": [
        "72"
    ],
    "rmx3197": [
        "RE"
    ],
    "ws067": [
        "WQ"
    ],
    "ks964": [
        "HI"
    ],
    "rc545l": [
        "O5"
    ],
    "t790z": [
        "TM"
    ],
    "t790w": [
        "TM"
    ],
    "5030m": [
        "AL"
    ],
    "5061a": [
        "AL"
    ],
    "5102m": [
        "TC"
    ],
    "5107g": [
        "TC"
    ],
    "5130m": [
        "TC"
    ],
    "5002m": [
        "AL"
    ],
    "5004s": [
        "TC"
    ],
    "akus pro": [
        "ZU"
    ],
    "akus z1": [
        "ZU"
    ],
    "5002l": [
        "AL"
    ],
    "5030j": [
        "AL"
    ],
    "5102k": [
        "TC"
    ],
    "5130j": [
        "TC"
    ],
    "5006a": [
        "AL"
    ],
    "5024i": [
        "AL"
    ],
    "5101a": [
        "TC"
    ],
    "5148a": [
        "TC"
    ],
    "kodak smartway l1 pro": [
        "KK"
    ],
    "kodak smartway m2": [
        "KK",
        "M1"
    ],
    "kodak_smartway_l1": [
        "KK"
    ],
    "smartway l2": [
        "KK"
    ],
    "smartway_f1": [
        "KK"
    ],
    "dsb-0220": [
        "DR"
    ],
    "dsb-0230": [
        "DR"
    ],
    "bold m7": [
        "BU"
    ],
    "aspera_r9": [
        "AQ"
    ],
    "k5m": [
        "WK"
    ],
    "k5d": [
        "WK"
    ],
    "k6b": [
        "WK"
    ],
    "k5b": [
        "WK"
    ],
    "k55h": [
        "WK"
    ],
    "k65": [
        "WK"
    ],
    "k57": [
        "WK"
    ],
    "platinum h5": [
        "SW"
    ],
    "platinum j5": [
        "SW"
    ],
    "smooth 5.0": [
        "HH"
    ],
    "smooth 5.5": [
        "HH"
    ],
    "smooth 6.5": [
        "HH"
    ],
    "smooth 6.26 lite": [
        "HH"
    ],
    "smooth626": [
        "HH"
    ],
    "wtcelero5g": [
        "DQ"
    ],
    "w-k610-fra": [
        "WI"
    ],
    "w-v755-eea": [
        "WI"
    ],
    "w-k560-tvm": [
        "WI"
    ],
    "w-v850-eea": [
        "WI"
    ],
    "opal 4s": [
        "IP"
    ],
    "opelmobile_smartx1": [
        "2O"
    ],
    "boost ultra": [
        "3H"
    ],
    "elite p55": [
        "SW"
    ],
    "elite h55": [
        "SW"
    ],
    "elite c5": [
        "SW"
    ],
    "elite p5": [
        "SW"
    ],
    "corn r40": [
        "4R"
    ],
    "corn r10": [
        "4R"
    ],
    "corn x5": [
        "4R"
    ],
    "corn x55": [
        "4R"
    ],
    "corn_x4": [
        "4R"
    ],
    "v5_nano": [
        "EV"
    ],
    "blade a7s 2020-t": [
        "ZT"
    ],
    "blade a30": [
        "ZT"
    ],
    "blade a51": [
        "ZT"
    ],
    "blade a3 2020-t": [
        "ZT"
    ],
    "blade a5 2020-t": [
        "ZT"
    ],
    "blade a3": [
        "ZT"
    ],
    "blade a320": [
        "ZT"
    ],
    "v2042": [
        "VV"
    ],
    "v2048": [
        "VV"
    ],
    "v2057": [
        "VV"
    ],
    "v2070": [
        "VV"
    ],
    "v2101": [
        "VV"
    ],
    "v2104": [
        "VV"
    ],
    "v2120": [
        "VV"
    ],
    "v2124": [
        "VV"
    ],
    "v2129": [
        "VV"
    ],
    "cp3503l": [
        "CO"
    ],
    "cp3504l": [
        "CO"
    ],
    "khatar h-20 pro": [
        "HG"
    ],
    "ec1002": [
        "CK"
    ],
    "ec211001": [
        "CK"
    ],
    "ec211002": [
        "CK"
    ],
    "ec211003": [
        "CK"
    ],
    "ec211004": [
        "CK"
    ],
    "amico_smartphone_4g": [
        "BR"
    ],
    "mafe_m820": [
        "FQ"
    ],
    "bl54pro": [
        "BM"
    ],
    "bl54_pro": [
        "BM"
    ],
    "u304ac": [
        "CK"
    ],
    "dammar": [
        "NP"
    ],
    "sky_55_eea": [
        "KW"
    ],
    "ihunt s60 discovery pro 2022": [
        "IH",
        "FS"
    ],
    "s10 tank pro 2020": [
        "IH"
    ],
    "symbol m1": [
        "HV"
    ],
    "sakari": [
        "6W"
    ],
    "digicel dl755": [
        "D3"
    ],
    "iswag kronos": [
        "9I"
    ],
    "sharp_2": [
        "XT"
    ],
    "storm_c3": [
        "1J"
    ],
    "v608c": [
        "ZV"
    ],
    "cp3321at": [
        "CO"
    ],
    "gtel infinity 8s": [
        "GV"
    ],
    "l55s": [
        "1L"
    ],
    "l55b": [
        "1L"
    ],
    "l55a": [
        "1L"
    ],
    "logic x50": [
        "1L"
    ],
    "logic l60": [
        "1L"
    ],
    "gtel infinity 9": [
        "GV"
    ],
    "ea211001": [
        "6A"
    ],
    "ea211002": [
        "6A"
    ],
    "stratus_c5_elite": [
        "1J"
    ],
    "core-m5": [
        "C1"
    ],
    "astro 5 pro": [
        "MW"
    ],
    "action-x5": [
        "C1"
    ],
    "core-m4": [
        "C1"
    ],
    "c6l 2020": [
        "BU"
    ],
    "c5l": [
        "BU"
    ],
    "c6l": [
        "BU"
    ],
    "c6l 2021": [
        "BU"
    ],
    "c5l plus": [
        "BU"
    ],
    "stg_c10": [
        "GQ"
    ],
    "hk9-4010": [
        "YI"
    ],
    "turkcell t80": [
        "UR"
    ],
    "turk telekom tt175": [
        "2U"
    ],
    "telekom puls": [
        "TM"
    ],
    "evm4g3": [
        "0Q"
    ],
    "neffos c5l": [
        "NF"
    ],
    "turkcell t40": [
        "UR"
    ],
    "turkcell t50": [
        "UR"
    ],
    "turkcell t60": [
        "UR"
    ],
    "turkcell t70": [
        "UR"
    ],
    "turkcell t10": [
        "UR"
    ],
    "turkcell turbo t50": [
        "UR"
    ],
    "turkcell maxi plus 5": [
        "UR"
    ],
    "turkcell t20)": [
        "UR",
        "HU"
    ],
    "turkcell maxipro5": [
        "UR",
        "HU"
    ],
    "sm-e225f": [
        "SA"
    ],
    "m5plus": [
        "TP"
    ],
    "joy pro": [
        "SB"
    ],
    "miracle 6.0 s": [
        "34"
    ],
    "rd86e": [
        "RH"
    ],
    "sens 5": [
        "DY"
    ],
    "sp-001": [
        "HQ"
    ],
    "v340u": [
        "6A"
    ],
    "v341u": [
        "VH"
    ],
    "sm-s215dl": [
        "SA"
    ],
    "a1 alpha 21": [
        "41"
    ],
    "evermiracle plus": [
        "EV"
    ],
    "p9000_max": [
        "0X"
    ],
    "note 20": [
        "CB"
    ],
    "note 7": [
        "CB"
    ],
    "gt20": [
        "HF"
    ],
    "2109119di": [
        "XI"
    ],
    "max 3": [
        "CB"
    ],
    "6025d_eea": [
        "AL"
    ],
    "blaupunkt sf02": [
        "BP"
    ],
    "b140dl": [
        "BU"
    ],
    "tmrvl4g": [
        "TM"
    ],
    "aosp on hammerhead": [
        "GO"
    ],
    "xperia e3 (aosp)": [
        "SO"
    ],
    "iphone10,1": [
        "AP"
    ],
    "lephone t2v": [
        "L7"
    ],
    "lephone t6+v": [
        "L7"
    ],
    "lephone t708": [
        "L7"
    ],
    "lephone k8": [
        "L7"
    ],
    "lephone t13": [
        "L7"
    ],
    "lephone t16": [
        "L7"
    ],
    "lephone t7+": [
        "L7"
    ],
    "lephone t7a": [
        "L7"
    ],
    "lephone w7+": [
        "L7"
    ],
    "lephone t25": [
        "L7"
    ],
    "lephone k9": [
        "L7"
    ],
    "lephone t6+": [
        "L7"
    ],
    "lephone t5v": [
        "L7"
    ],
    "lephone t708v": [
        "L7"
    ],
    "bror_w68": [
        "XF"
    ],
    "bror t60": [
        "XF"
    ],
    "synq": [
        "JW"
    ],
    "cph2371": [
        "OP"
    ],
    "ky-51b": [
        "KY"
    ],
    "sm-a032m": [
        "SA"
    ],
    "sm-a035m": [
        "SA"
    ],
    "tecno kf6ks": [
        "TB"
    ],
    "sm-a135m": [
        "SA"
    ],
    "sm-a235m": [
        "SA"
    ],
    "2201122g": [
        "XI"
    ],
    "moto g22": [
        "MR"
    ],
    "moto g51 5g": [
        "MR"
    ],
    "moto g71 5g": [
        "MR"
    ],
    "lm-k330": [
        "LG"
    ],
    "zte axon 10 pro": [
        "ZT"
    ],
    "liv 1s": [
        "YE"
    ],
    "stellar p4": [
        "ZU"
    ],
    "scg14": [
        "SA"
    ],
    "sc-52c": [
        "SA",
        "SU"
    ],
    "hisense e50 128g": [
        "HI"
    ],
    "alpha 5v": [
        "LA"
    ],
    "orange neva leaf": [
        "OR"
    ],
    "atlantic454": [
        "OY"
    ],
    "atlanticv": [
        "OY"
    ],
    "lmcv1": [
        "2N"
    ],
    "smart start 3": [
        "M9",
        "JG"
    ],
    "summit": [
        "02"
    ],
    "multilaser_gmax_2": [
        "1R"
    ],
    "sm-a536e": [
        "SA"
    ],
    "sm-a336e": [
        "SA"
    ],
    "cph2363": [
        "OP"
    ],
    "cph2307": [
        "OP"
    ],
    "cph2305": [
        "OP"
    ],
    "shw-m570s": [
        "SA"
    ],
    "tecno ch9": [
        "TB"
    ],
    "tecno ch6": [
        "TB"
    ],
    "tfy-lx1": [
        "HNR",
        "HU"
    ],
    "x626_4g": [
        "UQ"
    ],
    "wildfire e2 plus": [
        "HT"
    ],
    "myphone_fun_9": [
        "MY1"
    ],
    "le wave": [
        "LM"
    ],
    "le swipe": [
        "LM"
    ],
    "le omega": [
        "LM"
    ],
    "konnect_556": [
        "DA"
    ],
    "xiaomi 11 lite ne": [
        "XI"
    ],
    "wp18": [
        "OE"
    ],
    "armor x8i": [
        "UL"
    ],
    "ayya t1": [
        "YR"
    ],
    "easy k55": [
        "KW",
        "WK"
    ],
    "cph2421": [
        "OP"
    ],
    "cph2373": [
        "OP"
    ],
    "cph2349": [
        "OP"
    ],
    "cph2293": [
        "OP"
    ],
    "camellia": [
        "0P"
    ],
    "2201123g": [
        "XI"
    ],
    "a70": [
        "B2"
    ],
    "a70 pro": [
        "B2"
    ],
    "switch plus": [
        "4M"
    ],
    "4065f": [
        "AL"
    ],
    "fxt810r": [
        "FF"
    ],
    "gravity life": [
        "ZU"
    ],
    "eternity_h68": [
        "HN"
    ],
    "awm999": [
        "AW"
    ],
    "bac-l03": [
        "HU"
    ],
    "tq14": [
        "NY"
    ],
    "ultra z": [
        "ZU"
    ],
    "z9 plus": [
        "AW",
        "QM"
    ],
    "xt1063": [
        "MR"
    ],
    "xt1064": [
        "MR"
    ],
    "xt1095": [
        "MR"
    ],
    "studio g4": [
        "BU"
    ],
    "poco m4 pro 5g": [
        "0P"
    ],
    "mbi r7": [
        "FK"
    ],
    "oujia s10": [
        "JB"
    ],
    "oujia s27": [
        "JB"
    ],
    "oujia 2018-s10max": [
        "JB"
    ],
    "oujia s27 plus": [
        "JB"
    ],
    "oujia s29": [
        "JB"
    ],
    "oujia_s10": [
        "JB"
    ],
    "oujia2018-s20": [
        "JB"
    ],
    "oujia s20": [
        "JB"
    ],
    "oujia 2019": [
        "JB"
    ],
    "okp6 pro": [
        "OK"
    ],
    "20180101m": [
        "XL"
    ],
    "20170605q": [
        "XL"
    ],
    "gns2161b": [
        "GI"
    ],
    "gau0820": [
        "GI"
    ],
    "lt_c3500": [
        "QL"
    ],
    "nokia 3.1 a": [
        "NK"
    ],
    "elite aquarius": [
        "FY",
        "HJ",
        "IX"
    ],
    "dexp ixion es2 5''": [
        "DX"
    ],
    "220233l2c": [
        "XI"
    ],
    "blu neo 5.5": [
        "BU"
    ],
    "v2140": [
        "VV"
    ],
    "v2125": [
        "VV"
    ],
    "v2118": [
        "VV"
    ],
    "sweet 55": [
        "KW"
    ],
    "soft5": [
        "KW"
    ],
    "v2141": [
        "VV"
    ],
    "sm-m336bu": [
        "SA"
    ],
    "sm-a826s": [
        "SA"
    ],
    "sm-g990u1": [
        "SA"
    ],
    "sm-a736b": [
        "SA"
    ],
    "sm-a326k": [
        "SA"
    ],
    "realme g70 series": [
        "RE"
    ],
    "sm-a226l": [
        "SA"
    ],
    "sm-s205dl": [
        "SA"
    ],
    "le_pulse": [
        "LM"
    ],
    "le prime": [
        "LM"
    ],
    "alien x pro 2021": [
        "IH"
    ],
    "2201116pg": [
        "0P"
    ],
    "s59": [
        "AC",
        "DO"
    ],
    "boston 4g": [
        "GG"
    ],
    "life4g": [
        "OY"
    ],
    "2112123ag": [
        "XI"
    ],
    "220333qag": [
        "XI"
    ],
    "220333qny": [
        "XI"
    ],
    "ne2215": [
        "ON"
    ],
    "rmx3462": [
        "RE"
    ],
    "p61": [
        "GI"
    ],
    "shark ksr-h0": [
        "XI"
    ],
    "orange neva zen": [
        "OR"
    ],
    "orange neva start": [
        "OR",
        "JG"
    ],
    "core-m4 go": [
        "C1"
    ],
    "santin opsson": [
        "SQ"
    ],
    "staraddict 6": [
        "SX"
    ],
    "m5c": [
        "M1"
    ],
    "explay fresh": [
        "EX",
        "JG"
    ],
    "bal-l49": [
        "HU"
    ],
    "hon h01": [
        "C2"
    ],
    "sc-51c": [
        "SA",
        "SU"
    ],
    "scg13": [
        "SA"
    ],
    "shg07": [
        "SH"
    ],
    "asus_a001d": [
        "AU"
    ],
    "asus_x013db": [
        "AU"
    ],
    "cosmote xplore": [
        "1O"
    ],
    "flare 2.1": [
        "CH"
    ],
    "flare 2.0": [
        "CH"
    ],
    "s9-kc": [
        "KY"
    ],
    "i2126": [
        "VV"
    ],
    "i2019": [
        "VV"
    ],
    "bq-6645l": [
        "BX"
    ],
    "poco x4 pro 5g": [
        "0P"
    ],
    "poco x3 gt": [
        "0P"
    ],
    "poco m4 pro": [
        "0P"
    ],
    "p8_mini": [
        "EL"
    ],
    "htc_m10h": [
        "HT"
    ],
    "c1-u02": [
        "CO"
    ],
    "one pro": [
        "UM"
    ],
    "nova pro": [
        "3D"
    ],
    "p95_pride_7s": [
        "9C"
    ],
    "sc-04g": [
        "SA",
        "SU"
    ],
    "cph2423": [
        "ON",
        "OP"
    ],
    "cph2399": [
        "ON",
        "OP"
    ],
    "cph2381": [
        "ON",
        "OP"
    ],
    "6165h": [
        "TC"
    ],
    "21121210g": [
        "0P"
    ],
    "2107113si": [
        "XI"
    ],
    "22031116ai": [
        "0P"
    ],
    "v2134": [
        "VV"
    ],
    "v2126": [
        "VV"
    ],
    "v2044": [
        "VV"
    ],
    "sm-m336k": [
        "SA"
    ],
    "sm-e236b": [
        "SA"
    ],
    "ne2217": [
        "ON"
    ],
    "ne2211": [
        "ON"
    ],
    "i2203": [
        "VV"
    ],
    "i2127": [
        "VV"
    ],
    "moto g52": [
        "MR"
    ],
    "motorola edge 30 pro": [
        "MR"
    ],
    "zte a71 5g": [
        "ZT"
    ],
    "cph2341": [
        "OP"
    ],
    "cph2343": [
        "OP"
    ],
    "cph2333": [
        "OP"
    ],
    "aris pro": [
        "VH"
    ],
    "aris": [
        "VH"
    ],
    "cma-lx3": [
        "HNR"
    ],
    "cma-lx2": [
        "HNR"
    ],
    "tecno kg5j": [
        "TB"
    ],
    "tecno kg5k": [
        "TB"
    ],
    "tecno ch6h": [
        "TB"
    ],
    "tecno bd4i": [
        "TB"
    ],
    "tfy-lx2": [
        "HNR"
    ],
    "u696cl": [
        "UX"
    ],
    "v2149": [
        "VV"
    ],
    "v2146": [
        "VV"
    ],
    "v2153": [
        "VV"
    ],
    "v2151": [
        "VV"
    ],
    "hit p13": [
        "4P"
    ],
    "rmx3516": [
        "RE"
    ],
    "rmx3511": [
        "RE"
    ],
    "rmx3501": [
        "RE"
    ],
    "orange nola fun": [
        "OR"
    ],
    "220233l2g": [
        "XI"
    ],
    "21091116ui": [
        "XI"
    ],
    "rmx3301": [
        "RE"
    ],
    "rmx3312": [
        "RE"
    ],
    "rmx3521": [
        "RE"
    ],
    "rmx3392": [
        "RE"
    ],
    "note_7p": [
        "UL"
    ],
    "bq-6061l": [
        "BX"
    ],
    "vfd 301": [
        "VF"
    ],
    "vfd 710": [
        "VF"
    ],
    "vfd 501": [
        "VF"
    ],
    "vienna": [
        "UL"
    ],
    "gm6": [
        "GN"
    ],
    "glo": [
        "4M"
    ],
    "h3413": [
        "SO"
    ],
    "rc2200l": [
        "O5"
    ],
    "itel w6503": [
        "IZ"
    ],
    "kyf41": [
        "KY"
    ],
    "2201117pi": [
        "0P"
    ],
    "megafon sp-w1": [
        "MP"
    ],
    "omnia7": [
        "SA"
    ],
    "gt-s7530": [
        "SA"
    ],
    "sgh-i677": [
        "SA"
    ],
    "gt-i8350": [
        "SA"
    ],
    "sgh-i937": [
        "SA"
    ],
    "bishop-rq451": [
        "RQ"
    ],
    "telenor smart pro 2": [
        "T2"
    ],
    "cm990": [
        "HU"
    ],
    "bv6000_ru": [
        "B2"
    ],
    "cinemax_infinity": [
        "ZN"
    ],
    "cinemax_prime": [
        "ZN"
    ],
    "diamond 2": [
        "13"
    ],
    "dream_one_8": [
        "F3"
    ],
    "digicel dl2 xl": [
        "D3"
    ],
    "diamond_lte": [
        "TL"
    ],
    "dexp_es1050": [
        "DX"
    ],
    "desire r8 lite": [
        "CH",
        "HT"
    ],
    "desire r6": [
        "CH",
        "HT"
    ],
    "desire r6 plus": [
        "CH",
        "HT"
    ],
    "desay d18": [
        "DS"
    ],
    "d1_pro": [
        "B3"
    ],
    "phantom5": [
        "TB"
    ],
    "fire2 air lte": [
        "I5"
    ],
    "fire2 pro lte": [
        "I5"
    ],
    "fire_plus_lte": [
        "I5"
    ],
    "fire3 mini": [
        "I5"
    ],
    "fire2 lte": [
        "I5"
    ],
    "evermiracle s": [
        "EV"
    ],
    "eversolo": [
        "EV"
    ],
    "evershineii": [
        "EV"
    ],
    "everglory ii": [
        "EV"
    ],
    "everallureii": [
        "EV"
    ],
    "evermiracle power": [
        "EV"
    ],
    "evertrendy+4g": [
        "EV"
    ],
    "era_x": [
        "XO"
    ],
    "era_hd": [
        "XO"
    ],
    "era_4g": [
        "XO"
    ],
    "era 4k": [
        "XO"
    ],
    "era 4g": [
        "XO"
    ],
    "energy_diamond_mini": [
        "BU",
        "E1"
    ],
    "elegance 5.0 lite": [
        "K1"
    ],
    "elegance_4.5": [
        "K1"
    ],
    "elite photopro": [
        "SW"
    ],
    "1505-a01": [
        "36"
    ],
    "y7plus": [
        "DO"
    ],
    "u_pro": [
        "EL"
    ],
    "sc-53c": [
        "SA",
        "SU"
    ],
    "scg15": [
        "SA"
    ],
    "so-53c": [
        "SO"
    ],
    "sog06": [
        "SO"
    ],
    "v2144": [
        "VV"
    ],
    "smart hd pro": [
        "QM"
    ],
    "smart 4g adventure pro": [
        "11"
    ],
    "sharp1": [
        "XT"
    ],
    "sharp aquos s2": [
        "SH"
    ],
    "sac-a0": [
        "CO"
    ],
    "rocket pro": [
        "QM"
    ],
    "rocket lite": [
        "QM"
    ],
    "qsmart x40": [
        "QM"
    ],
    "qsmart x20": [
        "QM"
    ],
    "pearl k3": [
        "HV"
    ],
    "pearl k1": [
        "HV"
    ],
    "myg1": [
        "MY"
    ],
    "mya18": [
        "MY"
    ],
    "max9": [
        "32"
    ],
    "max8": [
        "32"
    ],
    "max_2": [
        "32"
    ],
    "max_1_plus": [
        "YE"
    ],
    "max 2": [
        "CB"
    ],
    "mark 2": [
        "QM"
    ],
    "lava lh9931": [
        "LV"
    ],
    "clt-l0j": [
        "HU"
    ],
    "cameleon c5 plus": [
        "00"
    ],
    "zte skate 2": [
        "ZT"
    ],
    "power armor14 pro": [
        "UL"
    ],
    "nx709j": [
        "57"
    ],
    "nx679j": [
        "57"
    ],
    "tecno kg7h": [
        "TB"
    ],
    "tecno kg5h": [
        "TB"
    ],
    "tecno bd4a": [
        "TB"
    ],
    "tecno b1c": [
        "TB"
    ],
    "vivo 1901_19": [
        "VV"
    ],
    "tfy-lx3": [
        "HNR"
    ],
    "v2131": [
        "VV"
    ],
    "rmx3560": [
        "RE"
    ],
    "bold_plus": [
        "69"
    ],
    "brave": [
        "69"
    ],
    "1825-i01": [
        "CO"
    ],
    "1825-e0": [
        "CO"
    ],
    "6159k": [
        "TC"
    ],
    "6125h_eea": [
        "TC"
    ],
    "220233l2i": [
        "XI"
    ],
    "iq4490i": [
        "FL"
    ],
    "iq4418": [
        "FL"
    ],
    "myphone axe 3g": [
        "MY1"
    ],
    "myphone infinity lte": [
        "MY1"
    ],
    "myphone infinity 3g": [
        "MY1"
    ],
    "myphone cube 16gb": [
        "MY1"
    ],
    "primo r5": [
        "WA"
    ],
    "primo r5 plus": [
        "WA"
    ],
    "primo gm3 plus": [
        "WA"
    ],
    "popper2": [
        "RT"
    ],
    "polarh4": [
        "9W"
    ],
    "power_x": [
        "7I"
    ],
    "plus3_4g": [
        "13"
    ],
    "play click lte": [
        "18"
    ],
    "pl620": [
        "PC"
    ],
    "p77_pride_1e": [
        "9C"
    ],
    "nopal": [
        "J9"
    ],
    "new 7": [
        "V6"
    ],
    "new 5": [
        "V6"
    ],
    "net_lite": [
        "K2"
    ],
    "neon_nova": [
        "X1"
    ],
    "neon plus": [
        "X1",
        "JG"
    ],
    "neon lite": [
        "X1",
        "JG"
    ],
    "neon storm": [
        "X1",
        "JG"
    ],
    "n5704l": [
        "NL"
    ],
    "n1_551 gloss": [
        "BV"
    ],
    "myxi1": [
        "MY"
    ],
    "myx9": [
        "MY"
    ],
    "myx8": [
        "MY"
    ],
    "myx5": [
        "MY"
    ],
    "myx3": [
        "MY"
    ],
    "myx2": [
        "MY"
    ],
    "myria_l550": [
        "M8"
    ],
    "myria l500": [
        "M8"
    ],
    "mynx1": [
        "MY"
    ],
    "mya16": [
        "MY"
    ],
    "mya15": [
        "MY"
    ],
    "mya13": [
        "MY"
    ],
    "mya12": [
        "MY"
    ],
    "mya11i": [
        "MY"
    ],
    "mya11": [
        "MY"
    ],
    "my29s": [
        "MY"
    ],
    "mtwo": [
        "J9"
    ],
    "ml-ti-ms80": [
        "1R"
    ],
    "cma-lx1": [
        "HNR"
    ],
    "cyber 8": [
        "HV"
    ],
    "sx41": [
        "66"
    ],
    "studio j8m": [
        "BU"
    ],
    "studio g3": [
        "BU"
    ],
    "sparkse": [
        "N5"
    ],
    "solid 4 g2": [
        "B2"
    ],
    "v50dc": [
        "VD"
    ],
    "v4_viper_pro": [
        "A2"
    ],
    "titanium_s9_plus": [
        "KA"
    ],
    "tf5x": [
        "TL"
    ],
    "omega x": [
        "CH"
    ],
    "mione_pubg_1": [
        "X7",
        "MO"
    ],
    "i97": [
        "SM"
    ],
    "i74": [
        "SM"
    ],
    "i68": [
        "SM"
    ],
    "i5plus": [
        "7I"
    ],
    "i30": [
        "SM"
    ],
    "i18": [
        "SM"
    ],
    "hyundai_eternity_g50w": [
        "HN"
    ],
    "agora 8 plus": [
        "KG"
    ],
    "panasonic_eluga_c": [
        "PA"
    ],
    "gap": [
        "40"
    ],
    "power plus 3": [
        "FL"
    ],
    "so-51c": [
        "SO"
    ],
    "a101kc": [
        "KY"
    ],
    "a201so": [
        "SO"
    ],
    "a201sh": [
        "SH"
    ],
    "asus rog phone 5": [
        "AU"
    ],
    "lm-g900v": [
        "LG"
    ],
    "mga-lx9": [
        "HU"
    ],
    "rmx2063l1": [
        "RE"
    ],
    "22011119uy": [
        "XI"
    ],
    "any-lx1": [
        "HNR"
    ],
    "i8_rokr": [
        "2F"
    ],
    "titan p15000 pro 5g": [
        "IH",
        "UZ"
    ],
    "ne2213": [
        "ON"
    ],
    "grand pro": [
        "3D"
    ],
    "kyv43_j": [
        "KY"
    ],
    "rmx3286": [
        "RE"
    ],
    "tecno mobile kg6k": [
        "TB"
    ],
    "tecno cg8h": [
        "TB"
    ],
    "slide lite": [
        "49",
        "WI"
    ],
    "sky 5.0pro ii": [
        "SW"
    ],
    "seoul mix": [
        "HN",
        "XI"
    ],
    "seoul eco": [
        "HN"
    ],
    "seoul 5 plus": [
        "HN"
    ],
    "selfix_es732_experius": [
        "SL"
    ],
    "secret_x": [
        "F3"
    ],
    "gm 6": [
        "GN"
    ],
    "go4.5": [
        "2K"
    ],
    "up octa": [
        "18"
    ],
    "itel s661w": [
        "IZ"
    ],
    "itel s661lpn": [
        "IZ"
    ],
    "itel s661ln": [
        "IZ"
    ],
    "itel s661l": [
        "IZ"
    ],
    "itel a661l": [
        "IZ"
    ],
    "itel a661w": [
        "IZ"
    ],
    "infinix zero 4": [
        "IF"
    ],
    "itel a551l": [
        "IZ"
    ],
    "itel a509wm": [
        "IZ"
    ],
    "asus-x01ad": [
        "AU"
    ],
    "cph2375": [
        "OP"
    ],
    "desire eye": [
        "HT"
    ],
    "bl60m_mv05": [
        "BM"
    ],
    "infinix x6816d": [
        "IF"
    ],
    "infinix x6816c": [
        "IF"
    ],
    "infinix x665b": [
        "IF"
    ],
    "infinix x665": [
        "IF"
    ],
    "itel p682lpn": [
        "IZ"
    ],
    "trident a75 pro max": [
        "Q5"
    ],
    "w-k521-eea": [
        "WI"
    ],
    "infinix x675": [
        "IF"
    ],
    "lg-ms870": [
        "LG"
    ],
    "impress_noda": [
        "LK",
        "VX"
    ],
    "ibrit_af51": [
        "7I"
    ],
    "halo 5 3g": [
        "I5"
    ],
    "v6_metal": [
        "QM"
    ],
    "v505c": [
        "ZV"
    ],
    "v501c": [
        "ZV"
    ],
    "v356b": [
        "0K"
    ],
    "v356": [
        "0K"
    ],
    "v2 2018": [
        "QM"
    ],
    "v155": [
        "SM"
    ],
    "v145": [
        "SM"
    ],
    "v142": [
        "SM"
    ],
    "v140": [
        "SM"
    ],
    "v128": [
        "SM"
    ],
    "v102": [
        "SM"
    ],
    "v105": [
        "SM"
    ],
    "ut3g": [
        "UU"
    ],
    "unonu x4g": [
        "UU"
    ],
    "point_x503": [
        "V5"
    ],
    "x7_soul_style": [
        "A2",
        "I1"
    ],
    "a40 indian": [
        "KA"
    ],
    "a40 indian plus": [
        "KA"
    ],
    "a40_indian": [
        "KA"
    ],
    "a9_indian": [
        "KA"
    ],
    "a45 indian": [
        "KA"
    ],
    "xt1806": [
        "MR"
    ],
    "xt1802": [
        "MR"
    ],
    "xt1801": [
        "MR"
    ],
    "discovery elite": [
        "GN"
    ],
    "discovery air": [
        "GN"
    ],
    "dorel 3s": [
        "UK"
    ],
    "dorel 4": [
        "UK"
    ],
    "i star two": [
        "OL"
    ],
    "i star one": [
        "OL"
    ],
    "i120": [
        "SM"
    ],
    "i6i 2020": [
        "QM"
    ],
    "i7plus": [
        "RL"
    ],
    "i72": [
        "SM"
    ],
    "i75": [
        "SM"
    ],
    "i65": [
        "SM"
    ],
    "infinity a4": [
        "C5"
    ],
    "infinity max": [
        "13"
    ],
    "inspire_u5": [
        "JL"
    ],
    "inspire_u5_plus": [
        "JL"
    ],
    "inspire_4g": [
        "F3"
    ],
    "infinix x623b": [
        "IF"
    ],
    "infinix x623": [
        "IF"
    ],
    "infinix x622": [
        "IF"
    ],
    "infinix x620b": [
        "IF"
    ],
    "infinix x620": [
        "IF"
    ],
    "infinix x5515i": [
        "IF"
    ],
    "infinix x5515f": [
        "IF"
    ],
    "infinix x5515": [
        "IF"
    ],
    "infinity_light": [
        "LL"
    ],
    "infinity_i5": [
        "C5"
    ],
    "infinity_i4": [
        "C5"
    ],
    "intex_iv0118nd": [
        "IX"
    ],
    "intex ip0418nd": [
        "IX"
    ],
    "intex im0118nd": [
        "IX"
    ],
    "i15": [
        "SM"
    ],
    "cph2411": [
        "ON",
        "OP"
    ],
    "cyber 7": [
        "HV"
    ],
    "moto g 5g (2022)": [
        "MR"
    ],
    "sm-g525n": [
        "SA"
    ],
    "rmx3562": [
        "RE"
    ],
    "22041219i": [
        "XI"
    ],
    "v2183a": [
        "VV"
    ],
    "pftm20": [
        "OP"
    ],
    "heyou60": [
        "E2"
    ],
    "z30 pro": [
        "SM"
    ],
    "z30": [
        "SM"
    ],
    "maad+": [
        "GX"
    ],
    "maad": [
        "GX"
    ],
    "masstel_n668": [
        "2M"
    ],
    "maxtron_v13": [
        "6X"
    ],
    "maxtron v13": [
        "6X"
    ],
    "maxtron apollo": [
        "6X"
    ],
    "maxtron-v17": [
        "6X"
    ],
    "maxtron v12": [
        "6X"
    ],
    "maxtron v15": [
        "6X"
    ],
    "maxtron v20": [
        "6X"
    ],
    "maxtron pluto": [
        "6X"
    ],
    "v94": [
        "SM"
    ],
    "v92": [
        "SM"
    ],
    "v96": [
        "SM"
    ],
    "v97": [
        "SM"
    ],
    "v98": [
        "SM"
    ],
    "v99": [
        "SM"
    ],
    "venus z30": [
        "VT"
    ],
    "axioo_ax5": [
        "XA"
    ],
    "axioo ax5": [
        "XA"
    ],
    "spice f311": [
        "SP"
    ],
    "star_plus_plus": [
        "OL"
    ],
    "star_two": [
        "OL"
    ],
    "sunny3 mini": [
        "WI"
    ],
    "tecno cf7s": [
        "TB"
    ],
    "qmobile x700 pro": [
        "QM"
    ],
    "qmobile x700 pro lite": [
        "QM"
    ],
    "qmobile x700 pro ii": [
        "QM"
    ],
    "qmobile x33": [
        "QM"
    ],
    "qmobile x32": [
        "QM"
    ],
    "qmobile x32 power": [
        "QM"
    ],
    "qmobile x29": [
        "QM"
    ],
    "qmobile s6s": [
        "QM"
    ],
    "qmobile s6 plus": [
        "QM"
    ],
    "qmobile s2 plus": [
        "QM"
    ],
    "qmobile s1 pro": [
        "QM"
    ],
    "qmobile i8i": [
        "QM"
    ],
    "qmobile i7i pro": [
        "QM"
    ],
    "qmobile i6 metal one": [
        "QM"
    ],
    "kiowa s5 ultra": [
        "46"
    ],
    "q-smart_plus": [
        "MY1",
        "QM"
    ],
    "qmobile i6 metal 2017": [
        "QM"
    ],
    "fero a4001 plus 2019": [
        "F7"
    ],
    "flare j1 lite": [
        "CH"
    ],
    "freedomturboxl": [
        "ZG"
    ],
    "gionee f205 pro": [
        "GI"
    ],
    "go1006": [
        "G1"
    ],
    "go1452": [
        "G1"
    ],
    "snami m380": [
        "SNA"
    ],
    "snami_m340": [
        "SNA"
    ],
    "raptor": [
        "QUE",
        "5F"
    ],
    "famous 5": [
        "FAM"
    ],
    "famous red 5+": [
        "FAM"
    ],
    "famous 5plus": [
        "FAM"
    ],
    "emporia_s2": [
        "EMR"
    ],
    "frogone": [
        "IRE"
    ],
    "infiniton_t5": [
        "INF"
    ],
    "bk2021": [
        "BAC"
    ],
    "db8plus": [
        "DBP"
    ],
    "dl_horizon_selfie": [
        "DL0"
    ],
    "digicom dtok": [
        "DIC"
    ],
    "infone xe": [
        "IN1"
    ],
    "infone x": [
        "IN1"
    ],
    "ino scout 2": [
        "INO"
    ],
    "xpower_p6000": [
        "RAY"
    ],
    "otto cr05": [
        "OTT"
    ],
    "o71": [
        "KEN"
    ],
    "o61": [
        "KEN"
    ],
    "tian_p3000": [
        "IH"
    ],
    "tis_001": [
        "JY"
    ],
    "tis001c": [
        "JY"
    ],
    "tis001b": [
        "JY"
    ],
    "tis001a": [
        "JY"
    ],
    "tis001": [
        "JY"
    ],
    "titanp6000": [
        "IH"
    ],
    "infinix x5516c": [
        "IF"
    ],
    "infinix x5516b": [
        "IF"
    ],
    "infinix x5516": [
        "IF"
    ],
    "jazz 2": [
        "AQ"
    ],
    "lava lf9820": [
        "LV"
    ],
    "lava lf9810": [
        "LV"
    ],
    "lava le9940": [
        "LV"
    ],
    "l553": [
        "HN"
    ],
    "itel w6501": [
        "IZ"
    ],
    "itel w5005p": [
        "IZ"
    ],
    "iqw626": [
        "LS"
    ],
    "iqd10s": [
        "LS"
    ],
    "infinix x652c": [
        "IF"
    ],
    "infinity e5": [
        "C5",
        "T2"
    ],
    "infinity e5 pro": [
        "C5",
        "T2"
    ],
    "flare s8 max": [
        "CH"
    ],
    "i8i dual": [
        "QM"
    ],
    "cirrus_c2": [
        "1J"
    ],
    "cirrus 6": [
        "FL"
    ],
    "infinity cinema 2": [
        "QM"
    ],
    "infinity triple": [
        "QM"
    ],
    "infinity santos": [
        "QM"
    ],
    "zte-v9vita": [
        "ZT"
    ],
    "infinity prime 2": [
        "QM"
    ],
    "panasonic p85 nxt": [
        "PA"
    ],
    "panasonic p55 nxt": [
        "PA"
    ],
    "next infinity": [
        "CD"
    ],
    "next infinity pro": [
        "CD"
    ],
    "blu studio x mini": [
        "BU"
    ],
    "5028y": [
        "AL"
    ],
    "sm-f700u1": [
        "SA"
    ],
    "v2196a": [
        "VV"
    ],
    "cph2409": [
        "ON",
        "OP"
    ],
    "sm-e025f": [
        "SA"
    ],
    "sm-g965w": [
        "SA"
    ],
    "gold_pro": [
        "KL"
    ],
    "gplus f53": [
        "8G"
    ],
    "gplus_s9701": [
        "8G"
    ],
    "gplus_fw6950": [
        "8G"
    ],
    "gplus_a2_plus": [
        "8G"
    ],
    "bqru-6631g_a11": [
        "BX"
    ],
    "itel l5006s": [
        "IZ"
    ],
    "cph2353": [
        "OP"
    ],
    "sog08": [
        "SO"
    ],
    "opg04": [
        "OP"
    ],
    "x8_soul_pro": [
        "A2"
    ],
    "ihunt like 12": [
        "IH"
    ],
    "cph2339": [
        "OP"
    ],
    "v2127": [
        "VV"
    ],
    "xq-ct72": [
        "SO"
    ],
    "pgjm10": [
        "OP"
    ],
    "rmx3471": [
        "RE"
    ],
    "22021211rg": [
        "0P"
    ],
    "impress_groove": [
        "VX"
    ],
    "2203129g": [
        "XI"
    ],
    "med-lx2": [
        "HU"
    ],
    "infinix x6512": [
        "IF"
    ],
    "infinix x573": [
        "IF"
    ],
    "infinix x510": [
        "IF"
    ],
    "symphony p7 pro": [
        "SM"
    ],
    "leagoo-power_2": [
        "L5"
    ],
    "lenovo xt2081-4": [
        "LE"
    ],
    "opus s3": [
        "VJ"
    ],
    "panasonic p110": [
        "PA"
    ],
    "perla": [
        "IP"
    ],
    "pro_selfie": [
        "SW"
    ],
    "5002h_tr": [
        "AL"
    ],
    "p13 blue max lite 32gb": [
        "RD"
    ],
    "p13 blue max lite": [
        "RD"
    ],
    "heyou50": [
        "E2"
    ],
    "tecno ke5s": [
        "TB"
    ],
    "eluga_a3_pro": [
        "PA"
    ],
    "amico smartphone xl": [
        "BR"
    ],
    "nitro 55c": [
        "MW"
    ],
    "w-v730-id": [
        "WI"
    ],
    "c6930": [
        "KY"
    ],
    "infinix x6817": [
        "IF"
    ],
    "b131dl": [
        "BU"
    ],
    "sm-a536n": [
        "SA"
    ],
    "zenfone 5": [
        "AU"
    ],
    "tecno bd2d": [
        "TB"
    ],
    "rmx3388": [
        "RE"
    ],
    "sm-m336b": [
        "SA"
    ],
    "sm-s426dl": [
        "SA"
    ],
    "tecno be7": [
        "TB"
    ],
    "moto g4 plus": [
        "MR"
    ],
    "moto g5": [
        "MR"
    ],
    "moto g4": [
        "MR"
    ],
    "motorola edge 30 fusion": [
        "MR",
        "O1"
    ],
    "ea211005": [
        "6A"
    ],
    "sky black2": [
        "SW"
    ],
    "akus p1": [
        "ZU"
    ],
    "rmx3561": [
        "RE"
    ],
    "redmi_5_plus": [
        "XI"
    ],
    "i2017": [
        "VV"
    ],
    "t766h": [
        "TC"
    ],
    "rmx3571": [
        "RE"
    ],
    "twist 4g": [
        "PS"
    ],
    "gn2200": [
        "ON"
    ],
    "sh-s50": [
        "SH"
    ],
    "w-v745-ope": [
        "WI"
    ],
    "i2202": [
        "VV"
    ],
    "gionee p15": [
        "GI"
    ],
    "buzz 3": [
        "AE"
    ],
    "220333qbi": [
        "XI"
    ],
    "eluga i8": [
        "PA"
    ],
    "i2022": [
        "VV"
    ],
    "21121119vl": [
        "XI"
    ],
    "primo h10": [
        "WA"
    ],
    "a203so": [
        "SO"
    ],
    "studio x10 2022": [
        "BU"
    ],
    "i2206": [
        "VV"
    ],
    "heyou20": [
        "E2"
    ],
    "cph2387": [
        "OP"
    ],
    "sm-a137f": [
        "SA"
    ],
    "tecno bd4h": [
        "TB"
    ],
    "v2185a": [
        "VV"
    ],
    "sh-51c": [
        "SH"
    ],
    "22021211ri": [
        "0P"
    ],
    "xq-bc62": [
        "SO"
    ],
    "sm-a226br": [
        "SA"
    ],
    "moto e22s": [
        "MR"
    ],
    "zte blade a7s": [
        "ZT"
    ],
    "elite j55": [
        "SW"
    ],
    "s501a": [
        "IP"
    ],
    "tecno-n8s": [
        "TB"
    ],
    "r678el": [
        "O5"
    ],
    "xq-bq62": [
        "SO"
    ],
    "infinix x559f": [
        "IF"
    ],
    "v23gb": [
        "LV"
    ],
    "buzz 3 plus": [
        "AE"
    ],
    "v2152": [
        "VV"
    ],
    "v2157": [
        "VV"
    ],
    "v2145": [
        "VV"
    ],
    "primo hm6": [
        "WA"
    ],
    "v2115": [
        "VV"
    ],
    "p650 2021": [
        "ZT"
    ],
    "hisense e20s": [
        "HI"
    ],
    "rp02": [
        "UM"
    ],
    "nokia g400 5g": [
        "NK"
    ],
    "w-v730-ope": [
        "WI"
    ],
    "orange sanza touch": [
        "OR"
    ],
    "xq-cc72": [
        "SO"
    ],
    "lenovo l71061": [
        "LE"
    ],
    "vivo 1939": [
        "VV"
    ],
    "is330": [
        "9J"
    ],
    "motorola edge 30": [
        "MR"
    ],
    "zte_blade_a5_2019": [
        "ZT"
    ],
    "ut10": [
        "UNI"
    ],
    "lex821": [
        "L1"
    ],
    "aurii_razor": [
        "F3"
    ],
    "archos 62 xenon": [
        "AR"
    ],
    "archos 59 xenon": [
        "AR"
    ],
    "iris50": [
        "LV"
    ],
    "iris51": [
        "LV"
    ],
    "iris60c": [
        "LV"
    ],
    "p508": [
        "NG"
    ],
    "p509": [
        "NG"
    ],
    "p550": [
        "NG"
    ],
    "p551": [
        "NG"
    ],
    "p6_emagic": [
        "A2"
    ],
    "850_4g": [
        "BR"
    ],
    "aura": [
        "SX"
    ],
    "aura plus": [
        "SX"
    ],
    "aura ultra": [
        "SX"
    ],
    "axis": [
        "EQ1"
    ],
    "azumi a4": [
        "AM"
    ],
    "azumi a4+": [
        "AM"
    ],
    "azumi akane": [
        "AM"
    ],
    "axxa_s45_plus": [
        "AXX"
    ],
    "axxa s71": [
        "AXX"
    ],
    "bam-ii": [
        "IM1"
    ],
    "x-music ii pro": [
        "ONC"
    ],
    "x-music s": [
        "ONC"
    ],
    "x-music \u2172": [
        "ONC"
    ],
    "ms45s_a6_senior": [
        "1R"
    ],
    "ms45s_a6_teen": [
        "1R"
    ],
    "sonylt28i": [
        "SO"
    ],
    "zte_blade_q_lux": [
        "ZT"
    ],
    "black_pro": [
        "KL"
    ],
    "bloom4": [
        "6I"
    ],
    "hit p10a": [
        "4P"
    ],
    "mc33": [
        "PZ"
    ],
    "moto g stylus (2022)": [
        "MR"
    ],
    "r255b": [
        "P5"
    ],
    "iv0318nd": [
        "IX"
    ],
    "cosmos u": [
        "HV"
    ],
    "cosmos": [
        "HV"
    ],
    "d5-l": [
        "DTE"
    ],
    "desire_r6_lite": [
        "CH",
        "HT"
    ],
    "dialog_blaze_mini": [
        "DG"
    ],
    "duotel_d1": [
        "ZX"
    ],
    "easy55": [
        "KW"
    ],
    "eco_s": [
        "6I"
    ],
    "impress u too": [
        "VX"
    ],
    "shv-e120l": [
        "SA"
    ],
    "shv-e120k": [
        "SA"
    ],
    "shv-e120s": [
        "SA"
    ],
    "videocon a54": [
        "VD"
    ],
    "n1530dl": [
        "NK"
    ],
    "nokia c20 plus": [
        "NK"
    ],
    "ah9110": [
        "2X"
    ],
    "smooth 5.5 lite": [
        "HH"
    ],
    "r8106": [
        "OP"
    ],
    "r8201": [
        "OP"
    ],
    "r8206": [
        "OP"
    ],
    "5007u_eea": [
        "AL"
    ],
    "5029y": [
        "AL"
    ],
    "5029y_eea": [
        "AL"
    ],
    "archos 50b neon": [
        "AR",
        "JG"
    ],
    "tecno ch6i": [
        "TB"
    ],
    "tecno ci8n": [
        "TB"
    ],
    "wp20": [
        "OE"
    ],
    "zte a2023p": [
        "ZT"
    ],
    "zte a2023pg": [
        "ZT"
    ],
    "t676k": [
        "TC"
    ],
    "tecno ch7": [
        "TB"
    ],
    "sm-e426s": [
        "SA"
    ],
    "alpha 3v": [
        "LA"
    ],
    "sm-j500fn": [
        "SA"
    ],
    "v5_viper": [
        "A2"
    ],
    "sugar y13s": [
        "9S"
    ],
    "sm-g935k": [
        "SA"
    ],
    "pgkm10": [
        "ON"
    ],
    "rmx3372": [
        "RE"
    ],
    "rmx3478": [
        "RE"
    ],
    "t676h": [
        "TC"
    ],
    "21121210c": [
        "XI"
    ],
    "wp15 s": [
        "OE"
    ],
    "bl8800pro": [
        "B2"
    ],
    "armor x10": [
        "UL"
    ],
    "bee": [
        "VH"
    ],
    "nokia 8 v 5g uw": [
        "NK"
    ],
    "shark par-h0": [
        "XI"
    ],
    "e5823": [
        "SO"
    ],
    "haier_t53p": [
        "HA"
    ],
    "a55 pro": [
        "B2"
    ],
    "a90": [
        "B2"
    ],
    "5031g": [
        "AL"
    ],
    "a126": [
        "I4"
    ],
    "a555": [
        "DX"
    ],
    "sm-a700fd": [
        "SA"
    ],
    "p9000": [
        "EL"
    ],
    "p9000_lite": [
        "EL"
    ],
    "paris_lite": [
        "UL"
    ],
    "lava_r1s": [
        "LV"
    ],
    "c_note": [
        "OL"
    ],
    "nls-nft10": [
        "N9"
    ],
    "c1 lite": [
        "M6"
    ],
    "bss50": [
        "BSS"
    ],
    "bss45": [
        "BSS"
    ],
    "axe": [
        "FP"
    ],
    "ax684": [
        "BM"
    ],
    "ax686a": [
        "BM"
    ],
    "ax687": [
        "BM"
    ],
    "avvio_q503": [
        "AV"
    ],
    "apex2": [
        "O7"
    ],
    "alphatel_t1": [
        "LL"
    ],
    "a30-ru": [
        "B2"
    ],
    "6cs": [
        "ELM"
    ],
    "5eq": [
        "YE"
    ],
    "lt50+": [
        "AM"
    ],
    "e13": [
        "HA"
    ],
    "a202so": [
        "SO"
    ],
    "sog07": [
        "SO"
    ],
    "so-52c": [
        "SO"
    ],
    "a202sh": [
        "SH"
    ],
    "ticktock": [
        "UZ"
    ],
    "xq-cc44": [
        "SO"
    ],
    "yu5012": [
        "MI"
    ],
    "cma-an40": [
        "HNR",
        "HU"
    ],
    "isprit u50 lte": [
        "VN"
    ],
    "cph2275": [
        "OP"
    ],
    "premier5": [
        "UNP"
    ],
    "rmx3492": [
        "RE"
    ],
    "sm-a3360": [
        "SA"
    ],
    "lenovo x2-to": [
        "LE"
    ],
    "lenovo x2-cu": [
        "LE"
    ],
    "lenovo x2-ap": [
        "LE"
    ],
    "fx4423": [
        "FIL"
    ],
    "flare j5 mini": [
        "CH"
    ],
    "flare j5s": [
        "CH"
    ],
    "flare j3s": [
        "CH"
    ],
    "flare j3 mini": [
        "CH"
    ],
    "flare j3 max": [
        "CH"
    ],
    "flare_a1_roam": [
        "CH"
    ],
    "flare_p3_plus": [
        "CH"
    ],
    "flare_p3_lite": [
        "CH"
    ],
    "fj": [
        "J9"
    ],
    "hb_x7": [
        "HEX"
    ],
    "hiking_a18": [
        "HIK"
    ],
    "hl5576": [
        "AD"
    ],
    "rk25wo": [
        "CIP"
    ],
    "l1f-pluss": [
        "BRA"
    ],
    "v12fnlite": [
        "WI"
    ],
    "l60 turbo": [
        "FS"
    ],
    "l60 pro": [
        "FS"
    ],
    "l601f": [
        "HN"
    ],
    "l9502": [
        "LUM"
    ],
    "l9503": [
        "LUM"
    ],
    "lg-m320g": [
        "LG"
    ],
    "live 7": [
        "KE"
    ],
    "lt_c3300": [
        "QL"
    ],
    "lt_c1500": [
        "QL"
    ],
    "lt_s10": [
        "QL"
    ],
    "luna v57": [
        "ELE",
        "69"
    ],
    "luna v55a": [
        "ELE",
        "69"
    ],
    "luna g62": [
        "ELE",
        "69"
    ],
    "luna g60x": [
        "ELE",
        "69"
    ],
    "luna g58": [
        "ELE",
        "69"
    ],
    "m10 nano": [
        "EV"
    ],
    "mango s5": [
        "MAN"
    ],
    "mango_sq7": [
        "MAN"
    ],
    "impress open": [
        "VX"
    ],
    "archos 50c neon": [
        "AR",
        "JG"
    ],
    "archos 50b platinum": [
        "AR"
    ],
    "archos 35b titanium": [
        "AR"
    ],
    "archos 40c titanium": [
        "AR"
    ],
    "archos 40c tiv2": [
        "AR"
    ],
    "archos 40d titanium": [
        "AR"
    ],
    "archos 45 neon": [
        "AR",
        "JG"
    ],
    "archos 45b titanium": [
        "AR"
    ],
    "archos 45c platinum": [
        "AR"
    ],
    "archos 50c helium": [
        "AR"
    ],
    "archos 50c oxygen": [
        "AR"
    ],
    "archos 52 platinum": [
        "AR"
    ],
    "archos 59 titanium": [
        "AR"
    ],
    "arctic450": [
        "OY"
    ],
    "m50a": [
        "E9"
    ],
    "m50a max": [
        "E9"
    ],
    "mark 5": [
        "QM"
    ],
    "micromax bharat 5 pro": [
        "MI"
    ],
    "micromax bharat 5 plus": [
        "MI"
    ],
    "micromax c2a": [
        "MI"
    ],
    "mione hero 5": [
        "X7",
        "MO"
    ],
    "mione iii": [
        "X7",
        "MO"
    ],
    "mione n10pro": [
        "X7",
        "MO"
    ],
    "pgz110": [
        "ON"
    ],
    "zun_n": [
        "V2"
    ],
    "sm-g991v": [
        "SA"
    ],
    "pixel 6a": [
        "GO"
    ],
    "xq-bq42": [
        "SO"
    ],
    "sh-52c": [
        "SH"
    ],
    "shl23": [
        "SH"
    ],
    "v2203a": [
        "VV"
    ],
    "itel l6006f": [
        "IZ"
    ],
    "htc dezire z": [
        "HT"
    ],
    "kirei a5q plus": [
        "AM"
    ],
    "cubot note s": [
        "CB"
    ],
    "sm-a526n": [
        "SA"
    ],
    "pfem10": [
        "OP"
    ],
    "air1 pro": [
        "5F"
    ],
    "coolpad_2041_s0": [
        "CO"
    ],
    "reno4 z 5g": [
        "OP"
    ],
    "reno5 pro 5g": [
        "OP"
    ],
    "tecno ci6n": [
        "TB"
    ],
    "reno5 z 5g": [
        "OP"
    ],
    "archos access 45 4g": [
        "AR"
    ],
    "honor x10 pro": [
        "HU"
    ],
    "find x3 neo": [
        "OP"
    ],
    "sm-g991a": [
        "SA"
    ],
    "alpha gtx": [
        "H2"
    ],
    "primo gm2 plus": [
        "WA"
    ],
    "primo gm2": [
        "WA"
    ],
    "pulse retro": [
        "BOO"
    ],
    "pulse sky": [
        "BOO"
    ],
    "pulse glide": [
        "BOO"
    ],
    "q01a": [
        "QH"
    ],
    "qmobile blue 5": [
        "QM"
    ],
    "r2 3g": [
        "BU"
    ],
    "r1_lite": [
        "LV"
    ],
    "r40k": [
        "E9"
    ],
    "r70": [
        "E9"
    ],
    "r5c": [
        "E9"
    ],
    "r30": [
        "SM"
    ],
    "aqua lite": [
        "IX"
    ],
    "iphone6,1": [
        "AP"
    ],
    "p30 pro": [
        "HM"
    ],
    "p88_pride_1x": [
        "9C"
    ],
    "redmi 4 pro": [
        "XI"
    ],
    "redmi 6 pro extreme": [
        "XI"
    ],
    "s10 tank 2020": [
        "IH"
    ],
    "s5506": [
        "RL"
    ],
    "s5710": [
        "4A"
    ],
    "z6201v": [
        "ZT"
    ],
    "coolpad_2041": [
        "CO"
    ],
    "kylin50i": [
        "IP"
    ],
    "pacific454": [
        "OY"
    ],
    "victor_s": [
        "U4"
    ],
    "victor": [
        "U4"
    ],
    "venus_v3_5580": [
        "VT"
    ],
    "xq-ct54": [
        "SO"
    ],
    "v2162": [
        "VV"
    ],
    "v2154": [
        "VV"
    ],
    "v2150": [
        "VV"
    ],
    "v2147": [
        "VV"
    ],
    "v2117": [
        "VV"
    ],
    "zte a31 lite": [
        "ZT"
    ],
    "nokia c21 plus": [
        "NK",
        "OE"
    ],
    "peppa-l23b": [
        "HU"
    ],
    "any-nx1": [
        "HNR"
    ],
    "vivo z1pro": [
        "VV"
    ],
    "vivo v9youth": [
        "VV"
    ],
    "vivo v9pro": [
        "VV"
    ],
    "v2207a": [
        "VV"
    ],
    "22041216g": [
        "0P"
    ],
    "s7t 5g": [
        "VV"
    ],
    "sm-a500h": [
        "SA"
    ],
    "wp19": [
        "OE"
    ],
    "find x2 pro": [
        "OP"
    ],
    "find x2 lite": [
        "OP"
    ],
    "g300": [
        "GN"
    ],
    "lge-an20": [
        "HNR",
        "LG"
    ],
    "lge-nx9": [
        "HNR",
        "LG"
    ],
    "22041219g": [
        "XI"
    ],
    "sm-j100fn": [
        "SA"
    ],
    "pure_f": [
        "H2"
    ],
    "rhythm_rx75": [
        "6R"
    ],
    "x1_atom_l": [
        "LV"
    ],
    "agora xi": [
        "KG"
    ],
    "p750i": [
        "8L"
    ],
    "oukitel-c3": [
        "OE",
        "OK"
    ],
    "omega_hd_4": [
        "CH"
    ],
    "karbonn_vue_1": [
        "KA"
    ],
    "kl500": [
        "0K"
    ],
    "kl601": [
        "0K"
    ],
    "kogan agora 9": [
        "KG"
    ],
    "orange rise32": [
        "OR"
    ],
    "orange viking l508": [
        "OR"
    ],
    "p6_energy_lite_tm": [
        "A2"
    ],
    "v55c": [
        "ELE"
    ],
    "v75": [
        "SM"
    ],
    "6102h": [
        "TC"
    ],
    "mga-lx9n": [
        "HU"
    ],
    "itel w5004d": [
        "IZ"
    ],
    "razar": [
        "H2"
    ],
    "zera_f": [
        "H2"
    ],
    "redmi_4": [
        "XI"
    ],
    "redmi_4a": [
        "XI"
    ],
    "redmi_4x": [
        "XI"
    ],
    "redmi_3x": [
        "XI"
    ],
    "tecno-l8plus": [
        "TB"
    ],
    "tecno-l8": [
        "TB"
    ],
    "seoul 9": [
        "HN"
    ],
    "sm-j327vpp": [
        "SA"
    ],
    "sm-j327r6": [
        "SA"
    ],
    "rmx3581": [
        "RE"
    ],
    "stellar 4g": [
        "E4",
        "ZU"
    ],
    "tet-an10": [
        "HU"
    ],
    "karbonn x21": [
        "KA"
    ],
    "max2 plus": [
        "YE"
    ],
    "cph2459": [
        "ON",
        "OP"
    ],
    "doro 8100": [
        "DR"
    ],
    "elite e55max": [
        "SW"
    ],
    "lava lzg403 225": [
        "LV"
    ],
    "220333ql": [
        "XI"
    ],
    "fne-an00": [
        "HNR"
    ],
    "htc desire 12s": [
        "HT"
    ],
    "mate30 rs": [
        "HU"
    ],
    "t601dl": [
        "TC"
    ],
    "redmi y1": [
        "XI"
    ],
    "lovme-x50": [
        "LOV"
    ],
    "lovme x20": [
        "LOV"
    ],
    "lovme-t9": [
        "LOV"
    ],
    "lovme-t6": [
        "LOV"
    ],
    "lovme-x22": [
        "LOV"
    ],
    "lovme x6": [
        "LOV"
    ],
    "lovme x10": [
        "LOV"
    ],
    "lovme-t19": [
        "LOV"
    ],
    "i-jupiter": [
        "RE1"
    ],
    "i-t60": [
        "IST"
    ],
    "i5c": [
        "A9"
    ],
    "i25": [
        "SM"
    ],
    "i21": [
        "SM"
    ],
    "i20": [
        "SM"
    ],
    "hyundai h7": [
        "HN"
    ],
    "hyundai aero plus": [
        "HN"
    ],
    "htc one x9": [
        "HT"
    ],
    "v2199a": [
        "VV"
    ],
    "eluga z1": [
        "PA"
    ],
    "r7sf": [
        "OP"
    ],
    "r7g": [
        "OP"
    ],
    "r7f": [
        "OP"
    ],
    "iris880": [
        "LV"
    ],
    "iris80": [
        "LV"
    ],
    "iris60": [
        "LV"
    ],
    "iris53": [
        "LV"
    ],
    "vsun touch": [
        "V9"
    ],
    "wave 4.0 ii": [
        "IP"
    ],
    "wave 5.0": [
        "IP"
    ],
    "kyy31": [
        "KY"
    ],
    "lenovo a6020l36": [
        "LE"
    ],
    "lm-g850n": [
        "LG"
    ],
    "m2004j19g": [
        "XI"
    ],
    "sm-a710m": [
        "SA"
    ],
    "sm-a710k": [
        "SA"
    ],
    "sm-a710fd": [
        "SA"
    ],
    "sm-a510fd": [
        "SA"
    ],
    "ec30": [
        "PZ"
    ],
    "e4pro": [
        "ENI"
    ],
    "lg-m470": [
        "LG"
    ],
    "lg-m470f": [
        "LG"
    ],
    "lg-m257pr": [
        "LG"
    ],
    "lg-k425": [
        "LG"
    ],
    "lg-h961an": [
        "LG"
    ],
    "lg-h872pr": [
        "LG"
    ],
    "lg-h870v": [
        "LG"
    ],
    "lg-h858": [
        "LG"
    ],
    "z6252ca": [
        "ZT"
    ],
    "v2132a": [
        "VV"
    ],
    "symphony z22": [
        "SM"
    ],
    "multilaser_g_2": [
        "1R"
    ],
    "multilaser_f_pro_2": [
        "1R"
    ],
    "lt-note 30": [
        "QL"
    ],
    "ds-bd1": [
        "DCO"
    ],
    "mar-l21b": [
        "HU"
    ],
    "mi cc 9 pro": [
        "XI"
    ],
    "micromax a107": [
        "MI"
    ],
    "micromax q380": [
        "MI"
    ],
    "jax_q": [
        "V2"
    ],
    "micromax q340": [
        "MI"
    ],
    "blade s6 lite": [
        "ZT"
    ],
    "rmx3574": [
        "RE"
    ],
    "6127i": [
        "TC"
    ],
    "micromax_hs3": [
        "MI"
    ],
    "micromax hs2": [
        "MI"
    ],
    "micromax hs1": [
        "MI"
    ],
    "micromax q409": [
        "MI"
    ],
    "micromax q415": [
        "MI"
    ],
    "aster t": [
        "VE"
    ],
    "aster": [
        "VE"
    ],
    "b3 maxi": [
        "STR"
    ],
    "b3 simply": [
        "STR"
    ],
    "r15": [
        "CB"
    ],
    "cameleon h2": [
        "00"
    ],
    "dass h-one": [
        "DAS"
    ],
    "ex10": [
        "GT"
    ],
    "extreme x9": [
        "GT"
    ],
    "f3prime": [
        "GB"
    ],
    "zte a2022l": [
        "ZT"
    ],
    "g55 lite": [
        "ELE"
    ],
    "eko star g50": [
        "EK"
    ],
    "eko novy g50": [
        "EK"
    ],
    "d65lx": [
        "KK"
    ],
    "f40g2": [
        "FI"
    ],
    "g008": [
        "GN"
    ],
    "g253": [
        "DX"
    ],
    "g550": [
        "DX"
    ],
    "go404": [
        "G1"
    ],
    "go506": [
        "G1"
    ],
    "gtwo": [
        "J9"
    ],
    "hk-mh501": [
        "HIK"
    ],
    "hl7257": [
        "AD"
    ],
    "s90_q": [
        "F3"
    ],
    "selfix_q3_rebel": [
        "SL"
    ],
    "selfix_q6_stallion": [
        "SL"
    ],
    "selfix_v41_pro_mardigras": [
        "SL"
    ],
    "shark 1": [
        "L5"
    ],
    "shark 6300": [
        "L5"
    ],
    "sj1-5": [
        "OB"
    ],
    "sj2.2": [
        "OB"
    ],
    "sj3.2": [
        "OB"
    ],
    "noa x2 plus": [
        "C5M",
        "N5"
    ],
    "noaxpower": [
        "C5M"
    ],
    "noa_hummer": [
        "N5"
    ],
    "5053d": [
        "AL"
    ],
    "c3600": [
        "QL"
    ],
    "c3700": [
        "QL"
    ],
    "c66": [
        "CHA"
    ],
    "tecno kh7n": [
        "TB"
    ],
    "w-k610-sui": [
        "WI"
    ],
    "agm_h5_pro": [
        "A3"
    ],
    "cph2359": [
        "OP"
    ],
    "22041216i": [
        "XI"
    ],
    "sm-a7100": [
        "SA"
    ],
    "abr-lx9": [
        "HU"
    ],
    "foto3": [
        "72"
    ],
    "flare_s6_max": [
        "CH"
    ],
    "flare_s6_deluxe": [
        "CH"
    ],
    "flint": [
        "HR"
    ],
    "fly4": [
        "V5",
        "FL"
    ],
    "fun5": [
        "HIK"
    ],
    "ftwo": [
        "J9"
    ],
    "go 2": [
        "QA",
        "YE"
    ],
    "grand m2 lte": [
        "BU",
        "M1"
    ],
    "grand m2": [
        "BU",
        "M1"
    ],
    "grand m2x": [
        "BU"
    ],
    "grand xl": [
        "BU"
    ],
    "grant": [
        "ZU"
    ],
    "gtel vivo4": [
        "GV"
    ],
    "gtel_vivo3": [
        "GV"
    ],
    "gtel x6plus": [
        "GV"
    ],
    "gtel x5plus": [
        "GV"
    ],
    "gtel_x5s": [
        "GV"
    ],
    "gtel_x5mini": [
        "GV"
    ],
    "gtel x6mini": [
        "GV"
    ],
    "gtel x6s": [
        "GV"
    ],
    "lt c1400": [
        "QL"
    ],
    "lm-x210s": [
        "LG"
    ],
    "lm-x210l": [
        "LG"
    ],
    "atom 2x": [
        "LV"
    ],
    "active 1": [
        "VH"
    ],
    "a240": [
        "MI",
        "DX"
    ],
    "e601f": [
        "HN"
    ],
    "e61pro": [
        "KEN"
    ],
    "e503f": [
        "HN"
    ],
    "e465go": [
        "HN"
    ],
    "lenovo l38083": [
        "LE"
    ],
    "lgl163bl": [
        "LG"
    ],
    "lg-vs985": [
        "LG"
    ],
    "lg-ls980": [
        "LG"
    ],
    "lt p8": [
        "QL"
    ],
    "lt p9": [
        "QL"
    ],
    "lt p10i": [
        "QL"
    ],
    "partner evolution": [
        "PAR"
    ],
    "panther": [
        "HR"
    ],
    "nokia 3 v": [
        "NK"
    ],
    "nokia 3.1 c": [
        "NK"
    ],
    "s32": [
        "66"
    ],
    "s32_plus": [
        "66"
    ],
    "s42": [
        "CA",
        "66"
    ],
    "s52": [
        "CA"
    ],
    "s60 discovery plus": [
        "IH"
    ],
    "pffm10": [
        "OP"
    ],
    "w-v770": [
        "WI"
    ],
    "220333qpg": [
        "0P"
    ],
    "mix 2s art": [
        "XI"
    ],
    "bl8800": [
        "B2"
    ],
    "a063": [
        "NOT"
    ],
    "nx702j": [
        "57"
    ],
    "dio-an00": [
        "HNR"
    ],
    "t8s": [
        "L5"
    ],
    "m2001j2g": [
        "XI"
    ],
    "mate xs": [
        "HU"
    ],
    "mate 40 rs": [
        "HU"
    ],
    "honor x10 5g": [
        "HU"
    ],
    "honor x10 lite": [
        "HU"
    ],
    "kle-ao": [
        "XI"
    ],
    "honor 9c": [
        "HU"
    ],
    "honor 9a": [
        "HU"
    ],
    "honor 30s": [
        "HU"
    ],
    "honor 30": [
        "HU"
    ],
    "m1908f1xe": [
        "XI"
    ],
    "doogee x7 pro": [
        "DO"
    ],
    "m2001c3k3i": [
        "XI"
    ],
    "m1906f9si": [
        "XI"
    ],
    "m1906f9sh": [
        "XI"
    ],
    "m1902f1g": [
        "XI"
    ],
    "6102d": [
        "TC"
    ],
    "bv4900s": [
        "B2"
    ],
    "lenovo s60-a": [
        "LE"
    ],
    "shark ktus-h0": [
        "XI"
    ],
    "reno5 5g": [
        "OP"
    ],
    "sm-g998t": [
        "SA"
    ],
    "sm-g998p": [
        "SA"
    ],
    "sm-a135u1": [
        "SA"
    ],
    "x point": [
        "TZ"
    ],
    "y530": [
        "HU"
    ],
    "lg-f180s": [
        "LG"
    ],
    "x600 nfc": [
        "QQ"
    ],
    "sm-m135f": [
        "SA"
    ],
    "pfzm10": [
        "OP"
    ],
    "pgim10": [
        "OP"
    ],
    "sdy-an00": [
        "HNR"
    ],
    "cph2401": [
        "ON",
        "OP"
    ],
    "cph2385": [
        "OP"
    ],
    "y20t": [
        "VV"
    ],
    "y30g": [
        "VV"
    ],
    "y31s 5g": [
        "VV"
    ],
    "y33s": [
        "VV"
    ],
    "y50t": [
        "VV"
    ],
    "y55s 5g": [
        "VV"
    ],
    "t776h": [
        "TC"
    ],
    "sch-i545pp": [
        "SA"
    ],
    "santin ng3": [
        "SQ"
    ],
    "a1603": [
        "OP"
    ],
    "mi 4lte": [
        "XI"
    ],
    "p10000 pro": [
        "B2"
    ],
    "l925": [
        "A6"
    ],
    "e5606": [
        "SO"
    ],
    "bravo z40": [
        "23"
    ],
    "bravo-z22": [
        "23"
    ],
    "bravo_z12": [
        "23"
    ],
    "brandcode b6s": [
        "BRA"
    ],
    "bv2000s": [
        "B2"
    ],
    "bv500": [
        "B2"
    ],
    "celkon q4gplus": [
        "CE"
    ],
    "ego_max_s": [
        "TOR"
    ],
    "ego_surf_i": [
        "TOR"
    ],
    "ego_surf_s": [
        "TOR"
    ],
    "droidz quad": [
        "TOR",
        "MR"
    ],
    "droidz beat tv": [
        "TOR",
        "MR"
    ],
    "droidz avatar tv": [
        "TOR",
        "MR"
    ],
    "droidz easy": [
        "TOR",
        "MR"
    ],
    "droidz excel": [
        "TOR",
        "MR"
    ],
    "droidz rotate": [
        "TOR",
        "MR"
    ],
    "droidz sport": [
        "TOR",
        "MR"
    ],
    "droidz match tv": [
        "TOR",
        "MR"
    ],
    "droidz blast": [
        "TOR",
        "MR"
    ],
    "droidz atom x": [
        "TOR",
        "MR"
    ],
    "droidz motion": [
        "TOR",
        "MR"
    ],
    "droidz sky 3g": [
        "TOR",
        "MR"
    ],
    "droidz play": [
        "TOR",
        "MR"
    ],
    "droidz trend": [
        "TOR",
        "MR"
    ],
    "droidz force": [
        "TOR",
        "MR"
    ],
    "droidz span": [
        "TOR",
        "MR"
    ],
    "droidz swivel": [
        "TOR",
        "MR"
    ],
    "droidz atom s": [
        "TOR",
        "MR"
    ],
    "droidz smart": [
        "TOR",
        "MR"
    ],
    "evolveo strongphone d2 mini": [
        "EO"
    ],
    "hs-l671": [
        "HI"
    ],
    "hs-l695": [
        "HI"
    ],
    "karbonn aura power": [
        "KA"
    ],
    "kafit v900": [
        "N4"
    ],
    "komu k70": [
        "KM"
    ],
    "komu k45": [
        "KM"
    ],
    "kingstar i15": [
        "KIN"
    ],
    "kingstar-a11": [
        "KIN"
    ],
    "kingstara17": [
        "KIN"
    ],
    "karbonn aura sleek 4g": [
        "KA"
    ],
    "karbonn aura power 4g": [
        "KA"
    ],
    "lanin t4": [
        "LA1"
    ],
    "noir a8": [
        "QM"
    ],
    "noir a1": [
        "QM"
    ],
    "noir a1 lite": [
        "QM"
    ],
    "noir_x1s": [
        "QM"
    ],
    "venus_v3_5045": [
        "VT"
    ],
    "venus_v3_5040": [
        "VT"
    ],
    "vestel_5530_dual": [
        "VT"
    ],
    "venus_v3_5030": [
        "VT"
    ],
    "venus_v3_5010": [
        "VT"
    ],
    "xt1225": [
        "MR"
    ],
    "xt1514": [
        "MR"
    ],
    "xt1524": [
        "MR"
    ],
    "xt1526": [
        "MR"
    ],
    "xt1527": [
        "MR"
    ],
    "xt912": [
        "MR"
    ],
    "22041219pi": [
        "0P"
    ],
    "zte a2020n2 pro": [
        "ZT"
    ],
    "xiaomi redmi 8a/8a dual": [
        "XI"
    ],
    "general_mobile_4g_dual": [
        "GN"
    ],
    "gm_5_d": [
        "GN"
    ],
    "redmi_6a": [
        "XI"
    ],
    "redmi_6": [
        "XI"
    ],
    "primo rm4": [
        "WA"
    ],
    "sm-a536v": [
        "SA"
    ],
    "hisense h60 smart": [
        "HI"
    ],
    "z6251v": [
        "ZT"
    ],
    "o+ 8.38z android": [
        "O3"
    ],
    "o+ 8.97 android": [
        "O3"
    ],
    "myphone rio 2 lite": [
        "MY",
        "MY1"
    ],
    "myphone rio 2": [
        "MY",
        "MY1"
    ],
    "myphone rio pixie": [
        "MY",
        "MY1"
    ],
    "myphone rio 2 fun": [
        "MY",
        "MY1"
    ],
    "sharp aquos p6": [
        "SH"
    ],
    "sharp aquos s2 4": [
        "SH"
    ],
    "venus z40": [
        "VT"
    ],
    "rmx3503": [
        "RE"
    ],
    "primo n5": [
        "WA"
    ],
    "tecno be6j": [
        "TB"
    ],
    "lg-d802tr": [
        "LG"
    ],
    "xiaomi_m1902f1t": [
        "XI"
    ],
    "duopix f9 pro": [
        "ZX"
    ],
    "dtacphonex3": [
        "DTA"
    ],
    "dtacphonet3": [
        "DTA"
    ],
    "dtacphones3": [
        "DTA"
    ],
    "doro 8042": [
        "DR"
    ],
    "rmx3506": [
        "RE"
    ],
    "redmi 9t nfc": [
        "XI"
    ],
    "cube 5.0_2gb": [
        "XO"
    ],
    "p13 blue max pl": [
        "RD"
    ],
    "o3": [
        "F0"
    ],
    "o31 plus": [
        "KEN"
    ],
    "o+ sonic": [
        "O3"
    ],
    "o+_360_hd_2.0": [
        "O3"
    ],
    "o+_360_alpha_plus_2.0": [
        "O3"
    ],
    "o+ xfinit": [
        "O3"
    ],
    "o+ ultra lite": [
        "O3"
    ],
    "nyx_alter": [
        "NY"
    ],
    "o+ 8.98 android": [
        "O3"
    ],
    "o+ 8.37y android": [
        "O3"
    ],
    "o+ evo 4g": [
        "O3"
    ],
    "o+ grande": [
        "O3"
    ],
    "o+ 8.17 android": [
        "O3"
    ],
    "o+ 8.33 android": [
        "O3"
    ],
    "o+ 8.37z android": [
        "O3"
    ],
    "o+ 8.38 android": [
        "O3"
    ],
    "o+ 8.92": [
        "O3"
    ],
    "o+ 8.93 android": [
        "O3"
    ],
    "o+ 360": [
        "O3"
    ],
    "o+ 360 hd": [
        "O3"
    ],
    "o+ 360 alpha": [
        "O3"
    ],
    "o+ 360 alpha plus": [
        "O3"
    ],
    "o+ 8.6 android": [
        "O3"
    ],
    "o+ 8.52 android(8gb)": [
        "O3"
    ],
    "o+ 8.12 android": [
        "O3"
    ],
    "o+_8.12_android": [
        "O3"
    ],
    "o+ 8.91 android": [
        "O3"
    ],
    "o+ 8.31z android": [
        "O3"
    ],
    "o+ 8.15 android": [
        "O3"
    ],
    "o+ presto 700 lte": [
        "O3",
        "10"
    ],
    "nuu_a3l": [
        "NL"
    ],
    "nuu_q500": [
        "NL"
    ],
    "odyssey aeon": [
        "Z4",
        "O1"
    ],
    "odyssey_j9": [
        "Z4"
    ],
    "odyssey_dtv7": [
        "Z4"
    ],
    "odyssey_dtv6": [
        "Z4"
    ],
    "odyssey j5": [
        "Z4"
    ],
    "odyssey victory": [
        "Z4"
    ],
    "odyssey j10": [
        "Z4"
    ],
    "odyssey j10 mini": [
        "Z4"
    ],
    "odyssey glaze+": [
        "Z4"
    ],
    "odyssey_ultra": [
        "Z4"
    ],
    "odyssey_flame": [
        "Z4"
    ],
    "odyssey popo": [
        "Z4"
    ],
    "odyssey_ace": [
        "Z4"
    ],
    "odyssey saga": [
        "Z4"
    ],
    "odyssey sacred": [
        "Z4"
    ],
    "odysseynext": [
        "Z4"
    ],
    "odyssey perri": [
        "Z4"
    ],
    "odyssey tytan": [
        "Z4"
    ],
    "odyssey swift": [
        "Z4"
    ],
    "odyssey_evo": [
        "Z4"
    ],
    "nomi i507": [
        "NM"
    ],
    "nomi_i503": [
        "NM"
    ],
    "nomi i504": [
        "NM"
    ],
    "nomi 6 plus": [
        "NM"
    ],
    "nitro_5m": [
        "MW"
    ],
    "nitro 55m": [
        "MW"
    ],
    "nitro_55_lte": [
        "MW"
    ],
    "nitro 551": [
        "TAL"
    ],
    "nautiz_x2": [
        "HAN"
    ],
    "asus_z01bdc": [
        "AU"
    ],
    "asus_z01bdb": [
        "AU"
    ],
    "asus_z011dd": [
        "AU"
    ],
    "asus_z010db": [
        "AU"
    ],
    "asus_z00udh": [
        "AU"
    ],
    "asus_z00ldd": [
        "AU"
    ],
    "asus_x00ddb": [
        "AU"
    ],
    "asus_x00dda": [
        "AU"
    ],
    "mega2max": [
        "13"
    ],
    "mega 10": [
        "BC"
    ],
    "meeplus_1": [
        "EL1"
    ],
    "majesty 4g": [
        "1K"
    ],
    "majesty m5": [
        "1K"
    ],
    "doogee x9 pro": [
        "DO"
    ],
    "doogee x7_pro": [
        "DO"
    ],
    "doogee x5_max_pro": [
        "DO"
    ],
    "doogee x5 max pro": [
        "DO"
    ],
    "discovery ii mini": [
        "GN"
    ],
    "discovery": [
        "EX",
        "GN"
    ],
    "discovery elite plus": [
        "GN"
    ],
    "discovery_xt": [
        "NEX"
    ],
    "ecoo e04 3gb": [
        "ECC"
    ],
    "ecoo e04": [
        "ECC"
    ],
    "ecoo_e04_3gb+": [
        "ECC"
    ],
    "ecoo_e05": [
        "ECC"
    ],
    "ecoo e04_plus": [
        "ECC"
    ],
    "lava a89": [
        "LV"
    ],
    "k-touch m1s": [
        "KT"
    ],
    "lava_a44": [
        "LV"
    ],
    "mafe_m810": [
        "FQ"
    ],
    "mafe_m825": [
        "FQ"
    ],
    "masstel_juno_q5plus": [
        "2M"
    ],
    "masstel_juno_s6": [
        "2M"
    ],
    "masstel n535": [
        "2M"
    ],
    "masstel lt52": [
        "2M"
    ],
    "masstel  n435": [
        "2M"
    ],
    "masstel_n600s": [
        "2M"
    ],
    "masstel_n558": [
        "2M"
    ],
    "masstel n660s": [
        "2M"
    ],
    "masstel n6": [
        "2M"
    ],
    "masstel n515": [
        "2M"
    ],
    "masstel b380": [
        "2M"
    ],
    "masstel n412": [
        "2M"
    ],
    "masstel n420": [
        "2M"
    ],
    "masstel n456": [
        "2M"
    ],
    "masstel n470": [
        "2M"
    ],
    "masstel n506": [
        "2M"
    ],
    "masstel n510": [
        "2M"
    ],
    "masstel n525": [
        "2M"
    ],
    "masstel n660": [
        "2M"
    ],
    "mach six vr": [
        "KA"
    ],
    "fne-nx9": [
        "HNR"
    ],
    "rmx3311": [
        "RE"
    ],
    "sm-g990b2": [
        "SA"
    ],
    "ctr-lx1": [
        "HU"
    ],
    "pocket": [
        "CB",
        "MY1"
    ],
    "power p1": [
        "6V"
    ],
    "carbon 1 mark ii": [
        "CA1"
    ],
    "moto g stylus 5g (2022)": [
        "MR"
    ],
    "v2205": [
        "VV"
    ],
    "tecno be8": [
        "TB"
    ],
    "asus_ai2201_a": [
        "AU"
    ],
    "cph2415": [
        "ON",
        "OP"
    ],
    "vne-n41": [
        "HNR"
    ],
    "s35": [
        "DO"
    ],
    "s98pro": [
        "DO"
    ],
    "s98": [
        "DO"
    ],
    "s61pro": [
        "DO"
    ],
    "s89pro": [
        "DO"
    ],
    "sm-m135fu": [
        "SA"
    ],
    "2206122sc": [
        "XI"
    ],
    "2203121c": [
        "XI"
    ],
    "s35t": [
        "DO"
    ],
    "infinix x6816": [
        "IF"
    ],
    "moto e32": [
        "MR"
    ],
    "huawei kii-l22": [
        "HU"
    ],
    "e380": [
        "AC"
    ],
    "e2_jump": [
        "A2"
    ],
    "e-boda sunny v37": [
        "EB",
        "WI"
    ],
    "dynamic jumpl": [
        "NG"
    ],
    "dynamic jump": [
        "NG"
    ],
    "a201op": [
        "OP"
    ],
    "a204sh": [
        "SH"
    ],
    "hammer_explorer_pro": [
        "HAM"
    ],
    "hammer_energy_18x9": [
        "HAM"
    ],
    "hammer energy 3g": [
        "HAM",
        "E1"
    ],
    "hammer iron": [
        "HAM"
    ],
    "v2180a": [
        "VV"
    ],
    "moto g52j 5g": [
        "MR"
    ],
    "telego_nova_3": [
        "TG"
    ],
    "agora go": [
        "KG"
    ],
    "gla-al00": [
        "HU"
    ],
    "huawei rio-al00": [
        "HU"
    ],
    "huawei mla-l12": [
        "HU"
    ],
    "impress_nero": [
        "VX"
    ],
    "impress_frost": [
        "VX"
    ],
    "shark ktus-a0": [
        "XI"
    ],
    "huawei p8max": [
        "HU"
    ],
    "sm-a037u1": [
        "SA"
    ],
    "tone-m17": [
        "0T"
    ],
    "infinix zero 4 plus": [
        "IF"
    ],
    "m-ppxx555u": [
        "MC"
    ],
    "panasonic p85": [
        "PA"
    ],
    "pi 5.5l": [
        "SCO"
    ],
    "tlw-100": [
        "QFX"
    ],
    "zte v0840": [
        "ZT"
    ],
    "compact_e2_plus": [
        "M8"
    ],
    "condor allure a55 slim": [
        "C5"
    ],
    "intense rise": [
        "Z4"
    ],
    "intense hype": [
        "Z4"
    ],
    "intense game": [
        "Z4"
    ],
    "x-tigi_v33": [
        "XT"
    ],
    "x-tigi_v18": [
        "XT"
    ],
    "x-tigi_v21": [
        "XT"
    ],
    "xt1750": [
        "MR"
    ],
    "xt1725": [
        "MR"
    ],
    "xt1723": [
        "MR"
    ],
    "xt1721": [
        "MR"
    ],
    "xt1662": [
        "MR"
    ],
    "xt1570": [
        "MR"
    ],
    "xt1093": [
        "MR"
    ],
    "x_tigi_a1plus": [
        "XT"
    ],
    "xt1754": [
        "MR"
    ],
    "xt1756": [
        "MR"
    ],
    "xylo p": [
        "V2"
    ],
    "eros_star": [
        "72"
    ],
    "eros smart": [
        "72"
    ],
    "eternity g25": [
        "HN"
    ],
    "eternity_h65": [
        "HN"
    ],
    "eternity_h67": [
        "HN"
    ],
    "ev6 elite": [
        "8V"
    ],
    "ev5 x": [
        "8V"
    ],
    "ev7_play": [
        "8V"
    ],
    "ev7": [
        "8V"
    ],
    "eva_e01": [
        "1K"
    ],
    "e-tel i240": [
        "E8"
    ],
    "e-tel i300": [
        "E8"
    ],
    "e-tel n7": [
        "E8"
    ],
    "e-tel n6": [
        "E8"
    ],
    "e-tel o9": [
        "E8"
    ],
    "e-tel i7c": [
        "E8"
    ],
    "zte a2016": [
        "ZT"
    ],
    "vivid_pro": [
        "F3"
    ],
    "vida_i501": [
        "7U"
    ],
    "vida_i450": [
        "VID"
    ],
    "vida i-450": [
        "VID"
    ],
    "vida_i512": [
        "VID"
    ],
    "vida-i401": [
        "VID"
    ],
    "vida-v401": [
        "VID"
    ],
    "vision lte": [
        "I5"
    ],
    "vin 5": [
        "IMI"
    ],
    "vin3 s": [
        "IMI"
    ],
    "vin3": [
        "IMI"
    ],
    "vin3 lite": [
        "IMI"
    ],
    "marshal me-348": [
        "MAR"
    ],
    "marshal me-347": [
        "MAR"
    ],
    "marshal_me-364": [
        "MAR"
    ],
    "marshal me-364": [
        "MAR"
    ],
    "marshal me-365": [
        "MAR"
    ],
    "marshal me-366": [
        "MAR"
    ],
    "messi no.1": [
        "IMI"
    ],
    "messi 3": [
        "IMI"
    ],
    "v-hope e928": [
        "VHO"
    ],
    "v hope v918": [
        "VHO"
    ],
    "redmi_s2": [
        "XI"
    ],
    "z3352ca": [
        "ZT"
    ],
    "iris870": [
        "LV"
    ],
    "iris821": [
        "LV"
    ],
    "iris820": [
        "LV"
    ],
    "iris702": [
        "LV"
    ],
    "iris41": [
        "LV"
    ],
    "iris 870s": [
        "LV"
    ],
    "iris 870": [
        "LV"
    ],
    "iris 870 4g": [
        "LV"
    ],
    "iris 860": [
        "LV"
    ],
    "iris 821": [
        "LV"
    ],
    "iris 820": [
        "LV"
    ],
    "pixel4x": [
        "GO"
    ],
    "ja2-smp0601": [
        "AW"
    ],
    "lgl22": [
        "LG"
    ],
    "htx21": [
        "KD"
    ],
    "htl21": [
        "KD"
    ],
    "aquaris vs plus": [
        "BX",
        "IX"
    ],
    "aquaris c plus": [
        "BX",
        "IX"
    ],
    "azumi k55ql": [
        "AM"
    ],
    "b3pro": [
        "STR"
    ],
    "comio c1 pro": [
        "C6"
    ],
    "crusader": [
        "3H"
    ],
    "d600": [
        "BU"
    ],
    "d510": [
        "BU"
    ],
    "d500": [
        "BU"
    ],
    "d6": [
        "B3"
    ],
    "f9_plus": [
        "GB"
    ],
    "eluga_y_pro": [
        "PA"
    ],
    "eluga_y": [
        "PA"
    ],
    "eluga ray 600": [
        "PA"
    ],
    "eluga ray 530": [
        "PA"
    ],
    "flex-3": [
        "6I"
    ],
    "flow6": [
        "KE"
    ],
    "fpt_x15": [
        "FPT"
    ],
    "htc_u-1u": [
        "HT"
    ],
    "htc_m10f": [
        "HT"
    ],
    "htc desire 555": [
        "HT"
    ],
    "htc desire 550": [
        "HT"
    ],
    "b8lite": [
        "L8"
    ],
    "b8plus": [
        "L8"
    ],
    "b5pro": [
        "MI",
        "L8"
    ],
    "bpro": [
        "BT"
    ],
    "b260": [
        "DX"
    ],
    "b245": [
        "DX"
    ],
    "b1s": [
        "STR"
    ],
    "infinix x668c": [
        "IF"
    ],
    "j5": [
        "CB",
        "QM"
    ],
    "lava ln9810": [
        "LV"
    ],
    "lava le9820": [
        "LV"
    ],
    "lava le9810": [
        "LV"
    ],
    "micromax q351": [
        "MI"
    ],
    "micromax q350r": [
        "MI"
    ],
    "micromax aq4502": [
        "MI"
    ],
    "micromax e453": [
        "MI"
    ],
    "micromax q3001": [
        "MI"
    ],
    "micromax q303": [
        "MI"
    ],
    "micromax q350": [
        "MI"
    ],
    "micromax q349": [
        "MI"
    ],
    "micromax q3301": [
        "MI"
    ],
    "micromax q352": [
        "MI"
    ],
    "micromax q354": [
        "MI"
    ],
    "micromax q480": [
        "MI"
    ],
    "mito a880": [
        "8M"
    ],
    "k-kool": [
        "WI"
    ],
    "jax x": [
        "V2"
    ],
    "itel s11plus": [
        "IZ"
    ],
    "itel p12": [
        "IZ"
    ],
    "intex_aqua_4.0_4g": [
        "IX"
    ],
    "intex_cloud_style_4g": [
        "IX"
    ],
    "intex aqua young 4g": [
        "IX"
    ],
    "intex aqua trend lite": [
        "IX"
    ],
    "intex aqua amaze+": [
        "IX"
    ],
    "intex aqua costa": [
        "IX"
    ],
    "intex aqua crystal": [
        "IX"
    ],
    "intex aqua supreme+": [
        "IX"
    ],
    "intex aqua strong 5.1+": [
        "IX"
    ],
    "intex aqua prime 4g": [
        "IX"
    ],
    "intex aqua lions 4g": [
        "IX"
    ],
    "intex aqua 4g mini": [
        "IX"
    ],
    "intense_metal_4g": [
        "F3"
    ],
    "intense xl": [
        "F3"
    ],
    "intense 5": [
        "F3"
    ],
    "infinix zero 3": [
        "IF"
    ],
    "i-style 713": [
        "IO"
    ],
    "i-mobile iq ii": [
        "IO"
    ],
    "flare p1 plus": [
        "CH"
    ],
    "soda s2": [
        "SOD"
    ],
    "soda e1": [
        "SOD"
    ],
    "soda fire": [
        "SOD"
    ],
    "tecno ci8": [
        "TB"
    ],
    "rmx3610": [
        "RE"
    ],
    "rp03": [
        "UM"
    ],
    "rp04": [
        "UM"
    ],
    "pffm20": [
        "OP"
    ],
    "pgp110": [
        "ON"
    ],
    "poco f4 gt": [
        "0P"
    ],
    "xq-aq62": [
        "SO"
    ],
    "qin2 pro": [
        "XI"
    ],
    "mzb8298in": [
        "XI"
    ],
    "22041216ug": [
        "0P"
    ],
    "22041219ny": [
        "XI"
    ],
    "asus_ai2201_b": [
        "AU"
    ],
    "asus_ai2201_c": [
        "AU"
    ],
    "armor 15": [
        "UL"
    ],
    "lge-an00": [
        "HNR",
        "LG"
    ],
    "air1": [
        "5F"
    ],
    "xq-be62": [
        "SO"
    ],
    "infinix x6823c": [
        "IF"
    ],
    "22071219cg": [
        "0P"
    ],
    "moto g82 5g": [
        "MR"
    ],
    "moto g42": [
        "MR"
    ],
    "tecno kg5p": [
        "TB"
    ],
    "nx709s": [
        "57"
    ],
    "zte a2023g": [
        "ZT"
    ],
    "mi 11 ultra": [
        "XI"
    ],
    "realme 8i": [
        "RE"
    ],
    "rmx3371": [
        "RE"
    ],
    "rmx3474": [
        "RE"
    ],
    "asus_ai2202": [
        "AU"
    ],
    "22041219pg": [
        "0P"
    ],
    "poco x4 gt": [
        "0P"
    ],
    "asus_ai2201_f": [
        "AU"
    ],
    "2207117bpg": [
        "0P"
    ],
    "v2202": [
        "VV"
    ],
    "v2218a": [
        "VV"
    ],
    "v2207": [
        "VV"
    ],
    "v2201": [
        "VV"
    ],
    "v2209": [
        "VV"
    ],
    "hisense e50s 128gb": [
        "HI"
    ],
    "t602dl": [
        "TC"
    ],
    "tecno kh6": [
        "TB"
    ],
    "moto g62 5g": [
        "MR"
    ],
    "rmx3551": [
        "RE"
    ],
    "pgam10": [
        "OP"
    ],
    "cph2413": [
        "ON",
        "OP"
    ],
    "xiaomi 12 lite": [
        "XI"
    ],
    "22081212c": [
        "XI"
    ],
    "cph2469": [
        "ON",
        "OP"
    ],
    "xiaomi 12x": [
        "XI"
    ],
    "redmi k40 gaming": [
        "XI"
    ],
    "sm-a136b": [
        "SA"
    ],
    "sm-e135f": [
        "SA"
    ],
    "rmx3475": [
        "RE"
    ],
    "redmi 8 series": [
        "XI"
    ],
    "redmi 9t, note 9 4g, 9 power": [
        "XI"
    ],
    "cph2357": [
        "OP"
    ],
    "find n": [
        "OP"
    ],
    "epic pro_1": [
        "4M",
        "HR"
    ],
    "pal-al00": [
        "HU"
    ],
    "pal-lx9": [
        "HU"
    ],
    "iku a22": [
        "8I"
    ],
    "w-v750bn-tvm": [
        "WI"
    ],
    "sm-g996p": [
        "SA"
    ],
    "rmx3513": [
        "RE"
    ],
    "black shark 4s": [
        "XI"
    ],
    "black shark 4s pro": [
        "XI"
    ],
    "black shark 4": [
        "XI"
    ],
    "black shark 4 pro": [
        "XI"
    ],
    "gplus p10+": [
        "8G"
    ],
    "gplus p10 2022": [
        "8G"
    ],
    "ihunt like 12 pro": [
        "IH"
    ],
    "ihunt titan x 5g": [
        "IH",
        "UZ"
    ],
    "ihunt s22 ultra": [
        "IH"
    ],
    "ihunt s22 plus": [
        "IH"
    ],
    "iku x2": [
        "8I"
    ],
    "sm-a125a": [
        "SA"
    ],
    "sm-a125t": [
        "SA"
    ],
    "agm glory_g1s": [
        "A3",
        "AK"
    ],
    "bq-5765l": [
        "BX"
    ],
    "bqru-6868l": [
        "BX"
    ],
    "tech pad x10": [
        "TP"
    ],
    "nitro 55n": [
        "MW"
    ],
    "nitro_5n": [
        "MW"
    ],
    "nitro 4n lte": [
        "MW"
    ],
    "nile x": [
        "13"
    ],
    "p2": [
        "HA"
    ],
    "element-p5501": [
        "S1"
    ],
    "element p5500": [
        "S1"
    ],
    "everfancy iii": [
        "EV"
    ],
    "pan-l29": [
        "HU"
    ],
    "flare xl 2": [
        "CH"
    ],
    "flare x lite": [
        "CH"
    ],
    "flare_s5_max": [
        "CH"
    ],
    "flare_s5": [
        "CH"
    ],
    "flare s5 power": [
        "CH"
    ],
    "flare s5 max": [
        "CH"
    ],
    "flare j7": [
        "CH"
    ],
    "flare j2": [
        "CH"
    ],
    "flare j1s": [
        "CH"
    ],
    "flare j1 plus": [
        "CH"
    ],
    "flare j1": [
        "CH"
    ],
    "flare infinity": [
        "CH"
    ],
    "fivo plus": [
        "2I"
    ],
    "fivo lite": [
        "2I"
    ],
    "jspq65": [
        "VJ"
    ],
    "itel s13 pro": [
        "IZ"
    ],
    "itel s13": [
        "IZ"
    ],
    "up vision": [
        "18"
    ],
    "up neo": [
        "18"
    ],
    "up snap": [
        "18"
    ],
    "urano 47": [
        "MJ"
    ],
    "micromax q4101": [
        "MI"
    ],
    "ns5004": [
        "NO"
    ],
    "archos sense 55 s": [
        "AR"
    ],
    "tc55": [
        "PZ"
    ],
    "chat_5+": [
        "XE"
    ],
    "ultym5": [
        "HU"
    ],
    "eluga_a3": [
        "PA"
    ],
    "eluga_i2_activ": [
        "PA"
    ],
    "rltp5567": [
        "RC"
    ],
    "mtt ideal": [
        "MQ"
    ],
    "infinit 2": [
        "TQ"
    ],
    "titanium t355": [
        "LT"
    ],
    "cph1939": [
        "OP"
    ],
    "figgers f3": [
        "FIG"
    ],
    "figgers dragonx": [
        "FIG"
    ],
    "admire_dragon": [
        "ZN"
    ],
    "v2204": [
        "VV"
    ],
    "sm-s136dl": [
        "SA"
    ],
    "versity 9553": [
        "43"
    ],
    "tecno ci6": [
        "TB"
    ],
    "tecno kh7": [
        "TB"
    ],
    "cph2457": [
        "OP"
    ],
    "sm-m135m": [
        "SA"
    ],
    "tecno r8s": [
        "TB"
    ],
    "infinix x6823": [
        "IF"
    ],
    "hit p12": [
        "4P"
    ],
    "c5l max": [
        "BU"
    ],
    "tecno be6": [
        "TB"
    ],
    "oreo": [
        "4M"
    ],
    "hy-002 plus": [
        "SQ"
    ],
    "cirrus 13": [
        "FL"
    ],
    "pesm10": [
        "OP"
    ],
    "asus_ai2201_d": [
        "AU"
    ],
    "kingkong mini2 pro": [
        "CB"
    ],
    "220733sfg": [
        "XI"
    ],
    "22071212ag": [
        "XI"
    ],
    "mobicel metro2": [
        "4M"
    ],
    "honor play 4t": [
        "HU"
    ],
    "s50_bold": [
        "69"
    ],
    "5033ep": [
        "AL"
    ],
    "bmm431b": [
        "BF"
    ],
    "s6523 ru": [
        "REV"
    ],
    "s60pro": [
        "OSC"
    ],
    "mp06": [
        "UM"
    ],
    "mp05": [
        "UM"
    ],
    "pacifici4g": [
        "OY"
    ],
    "impress mars": [
        "VX"
    ],
    "wbl7519": [
        "GI"
    ],
    "wbl7361": [
        "GI"
    ],
    "itel a15r": [
        "IZ"
    ],
    "w-k211-th": [
        "WI"
    ],
    "itel w4001s": [
        "IZ"
    ],
    "itel w5504": [
        "IZ"
    ],
    "itel w5003": [
        "IZ"
    ],
    "itel w4003": [
        "IZ"
    ],
    "ath-tl00": [
        "HU"
    ],
    "iro a55 q": [
        "AM"
    ],
    "iqoo u1x": [
        "VV"
    ],
    "iqoo u1": [
        "VV"
    ],
    "motorola p30 note": [
        "MR"
    ],
    "mbu-a0": [
        "XI"
    ],
    "inkulu_pro": [
        "69"
    ],
    "inkosi_pro": [
        "69"
    ],
    "legend pro_1": [
        "4M"
    ],
    "dqr22": [
        "69"
    ],
    "elite v55": [
        "SW"
    ],
    "epic_1": [
        "4M"
    ],
    "nnh-an00": [
        "HNR"
    ],
    "pdct00": [
        "OP"
    ],
    "p smart s": [
        "HU"
    ],
    "moscow": [
        "69"
    ],
    "721_pro": [
        "69"
    ],
    "pot-l01": [
        "HU"
    ],
    "oneplus 8 lite": [
        "ON"
    ],
    "step_up": [
        "69"
    ],
    "x70-2021": [
        "FP"
    ],
    "titan slim": [
        "UZ"
    ],
    "zte blade a52 lite": [
        "ZT"
    ],
    "22081212ug": [
        "XI"
    ],
    "6165a": [
        "TC"
    ],
    "bv7100": [
        "B2"
    ],
    "nokia g11 plus": [
        "NK"
    ],
    "w10 pro": [
        "HV"
    ],
    "wp20 pro": [
        "OE"
    ],
    "x97pro": [
        "DO"
    ],
    "sm-a336n": [
        "SA"
    ],
    "sm-a047f": [
        "SA"
    ],
    "samsung sm-a047f": [
        "SA"
    ],
    "hpb-an00": [
        "HNR"
    ],
    "a2010l36": [
        "LE"
    ],
    "sm-a125p": [
        "SA"
    ],
    "sm-a102j": [
        "SA"
    ],
    "oneplus 9": [
        "ON"
    ],
    "sm-a115v": [
        "SA"
    ],
    "sm-a215t": [
        "SA"
    ],
    "sm-a215p": [
        "SA"
    ],
    "sm-a215r4": [
        "SA"
    ],
    "sm-a326j": [
        "SA"
    ],
    "gionee_max pro": [
        "GI"
    ],
    "konka a800": [
        "KO"
    ],
    "cs45xa": [
        "C4"
    ],
    "rk25": [
        "CIP"
    ],
    "sm-m236l": [
        "SA"
    ],
    "huawei rio-l02": [
        "HU"
    ],
    "itel w5002": [
        "IZ"
    ],
    "itel a14": [
        "IZ"
    ],
    "itel l6006s": [
        "IZ"
    ],
    "itel l5007s": [
        "IZ"
    ],
    "infinix x6511g": [
        "IF"
    ],
    "itel a510w": [
        "IZ"
    ],
    "itel a509w": [
        "IZ"
    ],
    "itel a507ls": [
        "IZ"
    ],
    "arctic": [
        "69"
    ],
    "220733sg": [
        "XI"
    ],
    "urano27": [
        "MJ"
    ],
    "umi zero": [
        "UM"
    ],
    "umi c1": [
        "UM"
    ],
    "ghongv12": [
        "C2"
    ],
    "forward_next": [
        "NG"
    ],
    "ixion ml245": [
        "DX"
    ],
    "ixion m850": [
        "DX",
        "KC"
    ],
    "ixion m750": [
        "DX",
        "KC"
    ],
    "ixion m545": [
        "DX"
    ],
    "ixion m355": [
        "DX",
        "M1"
    ],
    "i_smart": [
        "V6"
    ],
    "k9 smart selfie": [
        "KA"
    ],
    "k9 smart eco": [
        "KA"
    ],
    "k9 smart eco plus": [
        "KA"
    ],
    "iqf 200": [
        "LS"
    ],
    "intex elyt dual_plus": [
        "IX"
    ],
    "intex elyt e7": [
        "IX"
    ],
    "intex elyt e6": [
        "IX"
    ],
    "intex elyt dual": [
        "IX"
    ],
    "inova": [
        "SM"
    ],
    "impress_fortune": [
        "VX"
    ],
    "impress_event": [
        "VX"
    ],
    "impress_genius": [
        "VX"
    ],
    "impress_lightning": [
        "VX"
    ],
    "impress_lotus": [
        "VX"
    ],
    "impress_new": [
        "VX"
    ],
    "impress_razor": [
        "VX"
    ],
    "impress_spring": [
        "VX"
    ],
    "gorilla 9 plus": [
        "IN1"
    ],
    "go-x": [
        "NY"
    ],
    "go onyx plus": [
        "G1",
        "EX"
    ],
    "go onyx mini": [
        "G1",
        "EX"
    ],
    "go onyx lte": [
        "G1",
        "EX"
    ],
    "go onyx hd": [
        "G1",
        "EX"
    ],
    "fun value 4g": [
        "OW"
    ],
    "ft162d": [
        "FT"
    ],
    "fs8026": [
        "SH"
    ],
    "fs8025": [
        "SH"
    ],
    "freedom c105": [
        "J5"
    ],
    "fpt_x9": [
        "FPT"
    ],
    "fpt_x10": [
        "FPT"
    ],
    "fpt x50": [
        "FPT"
    ],
    "fpt x3": [
        "FPT"
    ],
    "fpt s68 4g": [
        "FPT"
    ],
    "yu fly f8": [
        "YF",
        "FL"
    ],
    "sico topaz": [
        "13"
    ],
    "sgino6": [
        "INO"
    ],
    "sakura_fte1": [
        "FT"
    ],
    "s90_apex": [
        "IH"
    ],
    "s62_eco_3": [
        "44"
    ],
    "s5500": [
        "AA"
    ],
    "s51_lite": [
        "CEL"
    ],
    "s518": [
        "RL"
    ],
    "s5006": [
        "RL"
    ],
    "s2 advance": [
        "HH"
    ],
    "s186_sky_3": [
        "44"
    ],
    "s17": [
        "HM"
    ],
    "s104g": [
        "L7"
    ],
    "s100apex": [
        "IH"
    ],
    "rs-401": [
        "7M"
    ],
    "ru1": [
        "KO"
    ],
    "rltp5573": [
        "RC"
    ],
    "rio_rw": [
        "4M"
    ],
    "rio_bn": [
        "4M"
    ],
    "quatro 10": [
        "QUA"
    ],
    "quatro 8": [
        "QUA"
    ],
    "quatro fsm1453": [
        "QUA"
    ],
    "quantum fly": [
        "QA",
        "FL"
    ],
    "5053y_eea": [
        "AL"
    ],
    "p6901": [
        "WI"
    ],
    "mobiistar e selfie": [
        "M6"
    ],
    "m653": [
        "C3"
    ],
    "lg-us601": [
        "LG"
    ],
    "lg-m700v": [
        "LG"
    ],
    "lg-f430l": [
        "LG"
    ],
    "lg-f370s": [
        "LG"
    ],
    "gm 5": [
        "GN"
    ],
    "gionee f6l": [
        "GI"
    ],
    "coolpad e2c": [
        "CO"
    ],
    "coolpad cor-i0": [
        "CO"
    ],
    "aqua ring": [
        "IX"
    ],
    "aqua q8": [
        "IX"
    ],
    "am1010v": [
        "WHI"
    ],
    "allinmobile_arena": [
        "ALI"
    ],
    "aerial": [
        "SB"
    ],
    "ads1": [
        "SH"
    ],
    "primo gh7": [
        "WA"
    ],
    "primo gf6": [
        "WA"
    ],
    "primo g8": [
        "WA"
    ],
    "prime p444": [
        "VJ"
    ],
    "prime p4442": [
        "VJ"
    ],
    "prime p390": [
        "VJ"
    ],
    "prime p300": [
        "VJ"
    ],
    "prime p30": [
        "VJ"
    ],
    "prime o8": [
        "PRM"
    ],
    "positivo slim": [
        "PS"
    ],
    "plus2 4g": [
        "13"
    ],
    "pi_plus": [
        "QK"
    ],
    "pi plus": [
        "QK"
    ],
    "philips x598": [
        "PH"
    ],
    "philips s369": [
        "PH"
    ],
    "pearl_neo": [
        "MIN"
    ],
    "pearl a4": [
        "00"
    ],
    "pearl a4 plus": [
        "00"
    ],
    "panasonic p99": [
        "PA"
    ],
    "22071219ci": [
        "0P"
    ],
    "220733si": [
        "XI"
    ],
    "cph2477": [
        "OP"
    ],
    "rmx3612": [
        "RE"
    ],
    "poco m4 5g": [
        "0P"
    ],
    "pgbm10": [
        "OP"
    ],
    "vne-lx1": [
        "HNR"
    ],
    "u616at": [
        "WI"
    ],
    "v2143": [
        "VV"
    ],
    "v2158": [
        "VV"
    ],
    "v2168": [
        "VV"
    ],
    "v2188a": [
        "VV"
    ],
    "rmx3624": [
        "RE"
    ],
    "rmx3630": [
        "RE"
    ],
    "rmx3395": [
        "RE"
    ],
    "rmx3563": [
        "RE"
    ],
    "rmx3690": [
        "RE"
    ],
    "sm-m136b": [
        "SA"
    ],
    "sm-m536s": [
        "SA"
    ],
    "moto e32(s)": [
        "MR"
    ],
    "moto g32": [
        "MR"
    ],
    "moto g72": [
        "MR"
    ],
    "infinix x665c": [
        "IF"
    ],
    "cph2337": [
        "OP"
    ],
    "cph2455": [
        "OP"
    ],
    "cph2461": [
        "OP"
    ],
    "cph2473": [
        "OP"
    ],
    "i2208": [
        "VV"
    ],
    "infinix x6827": [
        "IF"
    ],
    "infinix x668": [
        "IF"
    ],
    "n152dl": [
        "NK"
    ],
    "axioo_ax4": [
        "XA"
    ],
    "ax950": [
        "BM"
    ],
    "ax925": [
        "BM"
    ],
    "ax825": [
        "BM"
    ],
    "avvio_pro550": [
        "AV"
    ],
    "avvio pro550": [
        "AV",
        "PL"
    ],
    "avvio_pro450": [
        "AV"
    ],
    "avvio_a400": [
        "AV"
    ],
    "avance classic": [
        "CI"
    ],
    "aurii_vivid": [
        "F3"
    ],
    "aurii_magnum": [
        "F3"
    ],
    "aurii_inspire": [
        "F3"
    ],
    "aurii_fame": [
        "F3"
    ],
    "aurii_amuse_4g": [
        "F3"
    ],
    "universetap": [
        "OE"
    ],
    "uniden_c505": [
        "UND"
    ],
    "uniden c505": [
        "UND"
    ],
    "umi_fair": [
        "UM"
    ],
    "u972_pro": [
        "HI"
    ],
    "u972": [
        "HI"
    ],
    "pftm10": [
        "OP"
    ],
    "pha120": [
        "OP"
    ],
    "pggm10": [
        "OP"
    ],
    "nco-al00": [
        "HU"
    ],
    "ldox-2130": [
        "KT"
    ],
    "v2166ba": [
        "VV"
    ],
    "v2219a": [
        "VV"
    ],
    "m2004j15sc": [
        "XI"
    ],
    "shg08": [
        "SH"
    ],
    "pixel 7": [
        "GO"
    ],
    "sh-m22": [
        "SH"
    ],
    "dco-al00": [
        "HU"
    ],
    "ava-pa00": [
        "YY"
    ],
    "tyh622m": [
        "U9"
    ],
    "sog09": [
        "SO"
    ],
    "xq-ct44": [
        "SO"
    ],
    "tfy-an40": [
        "HNR",
        "HU"
    ],
    "adt-an00": [
        "HNR"
    ],
    "tdt-ma01": [
        "YY"
    ],
    "v2217a": [
        "VV"
    ],
    "tetc-f5": [
        "TET"
    ],
    "rmo-an00": [
        "HNR",
        "HU"
    ],
    "vne-an00": [
        "HNR",
        "HU"
    ],
    "cosmos three": [
        "CH",
        "HV"
    ],
    "crono 64": [
        "MJ"
    ],
    "desire r7 lite": [
        "CH",
        "HT"
    ],
    "diamond d1": [
        "18"
    ],
    "diamond d5": [
        "32"
    ],
    "diamond d6": [
        "32"
    ],
    "diamond m": [
        "BU"
    ],
    "diamond_x": [
        "UM"
    ],
    "u6 prime": [
        "E9"
    ],
    "v7_metal": [
        "QM"
    ],
    "vfd720": [
        "VF"
    ],
    "vfd 822": [
        "VF"
    ],
    "vfd 529": [
        "VF"
    ],
    "w-k130-byt": [
        "WI"
    ],
    "z2lite": [
        "7I"
    ],
    "z50_pro": [
        "LV"
    ],
    "z518": [
        "P4"
    ],
    "z519": [
        "P4"
    ],
    "z9a": [
        "L5"
    ],
    "zte a0722": [
        "ZT"
    ],
    "me 3s": [
        "0J"
    ],
    "me 2": [
        "0J"
    ],
    "me 3": [
        "0J"
    ],
    "me 4": [
        "0J"
    ],
    "me 5": [
        "0J"
    ],
    "mercury tough": [
        "V9",
        "TR"
    ],
    "aqua tough": [
        "V9",
        "IX"
    ],
    "aqua twist": [
        "IX"
    ],
    "huawei tag-l32": [
        "HU"
    ],
    "huawei tag-l23": [
        "HU"
    ],
    "huawei tag-l22": [
        "HU"
    ],
    "huawei tag-l21": [
        "HU"
    ],
    "huawei tag-l13": [
        "HU"
    ],
    "huawei tag-l03": [
        "HU"
    ],
    "huawei tag-l01": [
        "HU"
    ],
    "huawei rio-ul00": [
        "HU"
    ],
    "huawei rio-tl00": [
        "HU"
    ],
    "alh-bd00": [
        "8X"
    ],
    "sm-a135n": [
        "SA"
    ],
    "xq-cq72": [
        "SO"
    ],
    "lgus990": [
        "LG"
    ],
    "lgus610": [
        "LG"
    ],
    "lgus110": [
        "LG"
    ],
    "lgs02": [
        "LG"
    ],
    "lgl56vl": [
        "LG"
    ],
    "lgl53bl": [
        "LG"
    ],
    "lgk520": [
        "LG"
    ],
    "lgk500j": [
        "LG"
    ],
    "lgk200f": [
        "LG"
    ],
    "lgas992": [
        "LG"
    ],
    "lg-m151": [
        "LG"
    ],
    "lg-k600": [
        "LG"
    ],
    "lg-k557": [
        "LG"
    ],
    "fantasy": [
        "02"
    ],
    "fero_j1": [
        "F7"
    ],
    "flare_x_v3": [
        "CH"
    ],
    "flare_s_play": [
        "CH"
    ],
    "esmart_m2": [
        "SWI"
    ],
    "esmart e2": [
        "SWI"
    ],
    "esmart m3": [
        "SWI"
    ],
    "j7 pro": [
        "QM"
    ],
    "ivvi f2s": [
        "UI"
    ],
    "ix ultra": [
        "ZM"
    ],
    "sigma_4_0": [
        "OPH",
        "1S"
    ],
    "beeta_4_0": [
        "OPH"
    ],
    "active 5.0": [
        "OPH"
    ],
    "admire_unity": [
        "ZN"
    ],
    "v2212": [
        "VV"
    ],
    "v2214": [
        "VV"
    ],
    "v2164ka": [
        "VV"
    ],
    "zte 8031": [
        "ZT"
    ],
    "a208sh": [
        "SH"
    ],
    "xtreme xt309": [
        "VJ"
    ],
    "x_tigi_photo p20": [
        "XT"
    ],
    "x_tigi_v16": [
        "XT"
    ],
    "x_tigi_a2": [
        "XT"
    ],
    "x_rainbow": [
        "IN1"
    ],
    "z51": [
        "LV"
    ],
    "z92": [
        "LV"
    ],
    "z61": [
        "LV"
    ],
    "asus_x00adc": [
        "AU"
    ],
    "asus_x00ada": [
        "AU"
    ],
    "asus_x009db": [
        "AU"
    ],
    "alpha 950xl": [
        "LA"
    ],
    "aquaris m5.5": [
        "BX",
        "IX"
    ],
    "duubee e1": [
        "DUU"
    ],
    "t5 pro": [
        "HV"
    ],
    "bush spira e2x 5\" smartphone": [
        "B1"
    ],
    "bush spira d2 5.5\" smartphone": [
        "B1"
    ],
    "bush spira c2 5\" smartphone": [
        "B1"
    ],
    "bush spira b2 5 smartphone": [
        "B1"
    ],
    "turbo-x_epsilon": [
        "TR"
    ],
    "turbo-x y": [
        "TR"
    ],
    "turbo-x i": [
        "TR"
    ],
    "turbo-x lamda": [
        "TR"
    ],
    "turbo-x_pi_4g": [
        "TR"
    ],
    "turbox_i4g": [
        "TR"
    ],
    "turbo_x_pi 1 4g": [
        "TR"
    ],
    "lenovo s580": [
        "LE"
    ],
    "lenovo s660": [
        "LE"
    ],
    "lamia l01": [
        "1K"
    ],
    "l590a": [
        "FOD"
    ],
    "kzg scope": [
        "KZG"
    ],
    "iyou_m1": [
        "IYO"
    ],
    "navtech_touchy_f2": [
        "KLT"
    ],
    "tecno_wx3": [
        "TB"
    ],
    "pkt411": [
        "C5"
    ],
    "itel p661w": [
        "IZ"
    ],
    "itel w4002": [
        "IZ"
    ],
    "power armor x11 pro": [
        "UL"
    ],
    "view xl": [
        "WI"
    ],
    "sm-j260mu": [
        "SA"
    ],
    "motorola edge 30 ultra": [
        "MR"
    ],
    "moto e22i": [
        "MR"
    ],
    "zvii": [
        "SM"
    ],
    "moon": [
        "E4"
    ],
    "momo3s": [
        "MOS",
        "PY"
    ],
    "mobiistar_lai zumbo_s_2017_lite": [
        "M6"
    ],
    "mobiistar_lai zumbo_s_2017": [
        "M6"
    ],
    "mobiistar zumbo j2": [
        "M6"
    ],
    "mobiistar zoro 5": [
        "M6"
    ],
    "mobiistar lai z1 4g": [
        "M6"
    ],
    "mobell s50": [
        "MOB"
    ],
    "m512": [
        "SM1"
    ],
    "m50e-1a": [
        "DG"
    ],
    "m50 max": [
        "E9"
    ],
    "m4-ss4458-r": [
        "MN"
    ],
    "m bot 54": [
        "LM"
    ],
    "m bot 51": [
        "LM"
    ],
    "lt_s9_note": [
        "QL"
    ],
    "lt18": [
        "2F"
    ],
    "lt16": [
        "2F"
    ],
    "lp infinity+": [
        "LL"
    ],
    "look": [
        "E4"
    ],
    "logic x4 plus": [
        "1L"
    ],
    "logic instrument fieldbook f1b": [
        "LH",
        "1L"
    ],
    "light one": [
        "6V"
    ],
    "life x6": [
        "CIT"
    ],
    "y8": [
        "DO"
    ],
    "x90l": [
        "DO"
    ],
    "vhem": [
        "WI"
    ],
    "sm-a236b": [
        "SA"
    ],
    "b1 pro": [
        "5F"
    ],
    "x7_soul_pro": [
        "A2",
        "I1"
    ],
    "t phone pro": [
        "TM"
    ],
    "t phone": [
        "TM"
    ],
    "zte a7040": [
        "ZT"
    ],
    "rainbow lite": [
        "WI"
    ],
    "conquest s21": [
        "4C"
    ],
    "tecno ca6s": [
        "TB"
    ],
    "a2020n3": [
        "ZT"
    ],
    "itel s663l": [
        "IZ"
    ],
    "vne-lx2": [
        "HNR"
    ],
    "any-lx2": [
        "HNR"
    ],
    "huawei g6-l11": [
        "HU"
    ],
    "tectoy_5029y": [
        "TEC"
    ],
    "infocus m260": [
        "FO"
    ],
    "infocus m812a": [
        "FO"
    ],
    "infocus m680": [
        "FO"
    ],
    "hongqi hq1": [
        "SQ"
    ],
    "g-tide_e520": [
        "GT"
    ],
    "g-tide vans 8": [
        "GT"
    ],
    "swipe_elite_3m": [
        "0W"
    ],
    "swipe_elite_3": [
        "0W"
    ],
    "sun_s5501": [
        "16"
    ],
    "starmobile play max": [
        "18"
    ],
    "starnaute 3": [
        "SX"
    ],
    "mya9 dtv": [
        "MY"
    ],
    "mya8 dtv": [
        "MY"
    ],
    "mya7 dtv": [
        "MY"
    ],
    "mya10": [
        "MY"
    ],
    "my807": [
        "MY"
    ],
    "rs35": [
        "CIP"
    ],
    "max80 plus": [
        "7M1"
    ],
    "kingkong mini 3": [
        "CB"
    ],
    "infinix x6826b": [
        "IF"
    ],
    "xq-aq52": [
        "SO"
    ],
    "sh-53c": [
        "SH"
    ],
    "rky-an00": [
        "HNR",
        "HU"
    ],
    "mga-al00": [
        "HU"
    ],
    "2207122mc": [
        "XI"
    ],
    "ctr-lx2": [
        "HU"
    ],
    "gla-lx1": [
        "HU"
    ],
    "itel p682l": [
        "IZ"
    ],
    "p7plus": [
        "LV"
    ],
    "lephone_w7r": [
        "L7"
    ],
    "p8 max": [
        "GI"
    ],
    "m300-l09": [
        "HU"
    ],
    "htc desire 22 pro": [
        "HT"
    ],
    "qx1000": [
        "FXT"
    ],
    "v2180ga": [
        "VV"
    ],
    "v2164pa": [
        "VV"
    ],
    "g0615d": [
        "G6"
    ],
    "v2231a": [
        "VV"
    ],
    "ixion es850": [
        "DX"
    ],
    "ixion es550": [
        "DX"
    ],
    "so-54c": [
        "SO"
    ],
    "rmx3623": [
        "RE"
    ],
    "memor 20": [
        "6D"
    ],
    "neva rise s1": [
        "7M"
    ],
    "nco-lx1": [
        "HU"
    ],
    "any-lx3": [
        "HNR"
    ],
    "eve-lx9": [
        "HU"
    ],
    "sm-g3300": [
        "SA"
    ],
    "samsung sm-g925j": [
        "SA"
    ],
    "sm-a605x": [
        "SA"
    ],
    "samsung sm-a605x": [
        "SA"
    ],
    "sm-j510": [
        "SA"
    ],
    "sm-j710": [
        "SA"
    ],
    "samsung sm-g955fd": [
        "SA"
    ],
    "samsung galaxy s10+": [
        "SA"
    ],
    "samsung sm-j727v": [
        "SA"
    ],
    "samsung sm-j727t": [
        "SA"
    ],
    "sm-j710fn": [
        "SA"
    ],
    "sm-a5ooh": [
        "SA"
    ],
    "sm-a045f": [
        "SA"
    ],
    "sm-g920s": [
        "SA"
    ],
    "samsung-sm-g920a": [
        "SA"
    ],
    "sm-g935a": [
        "SA"
    ],
    "samsung sm-g935a": [
        "SA"
    ],
    "sm-a6": [
        "SA"
    ],
    "sm-a6+": [
        "SA"
    ],
    "samsung sm-j727a": [
        "SA"
    ],
    "sm-j8": [
        "SA"
    ],
    "samsung sm-g490f": [
        "SA"
    ],
    "samsung-sm-g828a": [
        "SA"
    ],
    "samsung-sm-g870a": [
        "SA"
    ],
    "santin armor 2": [
        "SQ",
        "UL"
    ],
    "samsung sm-g925a": [
        "SA"
    ],
    "roma r2": [
        "GG"
    ],
    "sm-g360v": [
        "SA"
    ],
    "sm-g360p": [
        "SA"
    ],
    "sm-g360m": [
        "SA"
    ],
    "sm-g360hu": [
        "SA"
    ],
    "sm-g850f": [
        "SA"
    ],
    "sm-g850fq": [
        "SA"
    ],
    "sm-g850a": [
        "SA"
    ],
    "sm-g801f": [
        "SA"
    ],
    "sm-g800r4": [
        "SA"
    ],
    "sm-g800hq": [
        "SA"
    ],
    "sm-g800h": [
        "SA"
    ],
    "sm-g360h": [
        "SA"
    ],
    "idroid royal v5": [
        "IC"
    ],
    "idolx 6040": [
        "AL"
    ],
    "icherry c221": [
        "3I"
    ],
    "plume l5": [
        "C5"
    ],
    "bq-6353l": [
        "BX"
    ],
    "armor 17 pro": [
        "UL"
    ],
    "armor x6 pro": [
        "UL"
    ],
    "itel a631w": [
        "IZ"
    ],
    "zte 7540n": [
        "ZT"
    ],
    "power armor 18t": [
        "UL"
    ],
    "tank 01": [
        "UZ"
    ],
    "infinix x6821": [
        "IF"
    ],
    "asus_ai2202_b": [
        "AU"
    ],
    "bne-lx1": [
        "HU"
    ],
    "dco-lx9": [
        "HU"
    ],
    "s96gt": [
        "DO"
    ],
    "micromax q306": [
        "MI"
    ],
    "note_1c": [
        "J9"
    ],
    "itel p552w": [
        "IZ"
    ],
    "asus_ai2203_d": [
        "AU"
    ],
    "sh-rm19s": [
        "SH"
    ],
    "xm-sw1": [
        "XMO"
    ],
    "v2220a": [
        "VV"
    ],
    "v2190a": [
        "VV"
    ],
    "sh-m24": [
        "SH"
    ],
    "wildfire e plus": [
        "HT"
    ],
    "sm-g900f": [
        "SA"
    ],
    "sm-g900fq": [
        "SA"
    ],
    "andromax c46b2h": [
        "HA",
        "SC"
    ],
    "andromax b26d2h": [
        "SC"
    ],
    "heyou10": [
        "E2"
    ],
    "hermes": [
        "UQ"
    ],
    "hl4736": [
        "AD"
    ],
    "hl5585": [
        "AD"
    ],
    "phoenix 2": [
        "FL"
    ],
    "philips_w3568": [
        "PH"
    ],
    "pap7500": [
        "PR"
    ],
    "pap5503duo": [
        "PR"
    ],
    "sf1": [
        "OB"
    ],
    "roar_a50": [
        "SM"
    ],
    "qmobile z8 plus": [
        "QM"
    ],
    "qmobile x950": [
        "QM"
    ],
    "model y": [
        "SUN"
    ],
    "smartvision3": [
        "KAP"
    ],
    "ctr-al00": [
        "HU"
    ],
    "a201kc": [
        "KY"
    ],
    "bq-5033": [
        "BX"
    ],
    "xt2241-1": [
        "MR"
    ],
    "primo hm5": [
        "WA"
    ],
    "z pro": [
        "UM"
    ],
    "y777_fire": [
        "SSK"
    ],
    "y6c": [
        "DO"
    ],
    "xylo x": [
        "V2"
    ],
    "xm300": [
        "L2"
    ],
    "xm200 pro": [
        "L2"
    ],
    "xcom x520": [
        "XCO"
    ],
    "xcom ismart": [
        "XCO"
    ],
    "x5maxpro": [
        "DO"
    ],
    "x5max_s": [
        "DO"
    ],
    "x5_pro": [
        "AK"
    ],
    "x501_prime": [
        "CEL"
    ],
    "x5 metal": [
        "AK"
    ],
    "x3_pro_slim": [
        "AK"
    ],
    "x28": [
        "LV"
    ],
    "x28 plus": [
        "LV"
    ],
    "x3 pro slim": [
        "AK"
    ],
    "x-treme_pq17": [
        "1S"
    ],
    "x-treme_pq14": [
        "1S"
    ],
    "wolder_34": [
        "WL"
    ],
    "wolder_27": [
        "WL"
    ],
    "wolder wiam #65": [
        "WL"
    ],
    "wolder wiam #51": [
        "WL"
    ],
    "wolder wiam #23": [
        "WL"
    ],
    "wise2_plus": [
        "TG"
    ],
    "winstar s-5": [
        "WIS"
    ],
    "wileyfox surf": [
        "WF"
    ],
    "wiam_33": [
        "WL"
    ],
    "wiam_65_lite": [
        "WL"
    ],
    "vr bot 552": [
        "LM"
    ],
    "vr bot 552 plus": [
        "LM"
    ],
    "pocket 3": [
        "CB"
    ],
    "bv5200": [
        "B2"
    ],
    "bv7200": [
        "B2"
    ],
    "asus_ai2203_c": [
        "AU"
    ],
    "cph2471": [
        "OP"
    ],
    "motorola edge 30 neo": [
        "MR"
    ],
    "lenovo l71091": [
        "LE"
    ],
    "air1 ultra": [
        "5F"
    ],
    "primo gh10i": [
        "WA"
    ],
    "zte 9100n": [
        "ZT"
    ],
    "infinix x6825": [
        "IF"
    ],
    "santin hexin-h2-a": [
        "SQ"
    ],
    "santin hexin-h3": [
        "SQ"
    ],
    "vertex_luck_l_5045_3g": [
        "VX"
    ],
    "redmi 9t nfc_sn": [
        "XI"
    ],
    "lt c3200": [
        "QL"
    ],
    "tf6": [
        "TL"
    ],
    "symbol": [
        "HV"
    ],
    "symbol pro": [
        "HV"
    ],
    "star7 3g": [
        "4R"
    ],
    "star 6.0 g65": [
        "EK"
    ],
    "star 5.5 g55": [
        "EK"
    ],
    "star 5.0 g50": [
        "EK"
    ],
    "star 4.0 g40": [
        "EK"
    ],
    "zte c2017": [
        "ZT"
    ],
    "tecno wx3lte": [
        "TB"
    ],
    "redmi 10 2022": [
        "XI"
    ],
    "ef501": [
        "J8"
    ],
    "santin bdsharing": [
        "SQ"
    ],
    "apk ukozi u6": [
        "A6"
    ],
    "luck l130": [
        "VX"
    ],
    "stark": [
        "0G"
    ],
    "rd86qe": [
        "DSI"
    ],
    "s32_nfc": [
        "66"
    ],
    "rk95": [
        "CIP"
    ],
    "eda61k": [
        "WH"
    ],
    "v18 pro_a": [
        "XT"
    ],
    "thomson serea500": [
        "TN"
    ],
    "mascom s750": [
        "MA1"
    ],
    "npa205sh": [
        "SH"
    ],
    "abr-al80": [
        "HU"
    ],
    "2211133c": [
        "XI"
    ],
    "v2241a": [
        "VV"
    ],
    "cet-al60": [
        "HU"
    ],
    "v2244a": [
        "VV"
    ],
    "anp-an00": [
        "HNR"
    ],
    "shg10": [
        "SH"
    ],
    "a202zt": [
        "ZT"
    ],
    "sc-56c": [
        "SA",
        "SU"
    ],
    "xq-cq44": [
        "SO"
    ],
    "mgz-bd00": [
        "8X"
    ],
    "v2243a": [
        "VV"
    ],
    "p-01k": [
        "PA"
    ],
    "f-52b": [
        "FU"
    ],
    "v2238a": [
        "VV"
    ],
    "phm110": [
        "OP"
    ],
    "pgw110": [
        "OP"
    ],
    "land rover explore r": [
        "L6"
    ],
    "infinix x680c": [
        "IF"
    ],
    "new 11": [
        "V6"
    ],
    "soshphone": [
        "SOS"
    ],
    "sts550": [
        "Y7"
    ],
    "symphony z32": [
        "SM"
    ],
    "i5g": [
        "A9"
    ],
    "hisense f17": [
        "HI"
    ],
    "hisense f28": [
        "HI"
    ],
    "g355": [
        "DX"
    ],
    "f1x4g": [
        "TEL"
    ],
    "f2_plus": [
        "KB"
    ],
    "evm4g6": [
        "0Q"
    ],
    "redmi 10 5g": [
        "XI"
    ],
    "xiaomi 12 pro": [
        "XI"
    ],
    "xiaomi 12t pro": [
        "XI"
    ],
    "xiaomi 12t": [
        "XI"
    ],
    "sm-m127n": [
        "SA"
    ],
    "redmi 10a": [
        "XI"
    ],
    "x95i": [
        "DO"
    ],
    "x93": [
        "DO"
    ],
    "x95": [
        "DO"
    ],
    "redmi 9at": [
        "XI"
    ],
    "xp9800": [
        "CUO"
    ],
    "memor 1": [
        "6D"
    ],
    "af9020": [
        "LV"
    ],
    "ea630": [
        "UNT"
    ],
    "tp601e": [
        "NF"
    ],
    "tp601c": [
        "NF"
    ],
    "tp601b": [
        "NF"
    ],
    "thomson t510h": [
        "TN"
    ],
    "t47_09": [
        "BQ"
    ],
    "sugar c-88dual": [
        "9S"
    ],
    "sp5040-casiopea ii": [
        "W1"
    ],
    "sonim-xp7700": [
        "OI"
    ],
    "sonim-xp5700": [
        "OI"
    ],
    "i-mobile iq z pro": [
        "IO"
    ],
    "i-mobile iq z bright": [
        "IO"
    ],
    "v1277": [
        "XEL"
    ],
    "qmp-m1-n-ip": [
        "Q9"
    ],
    "sm-a505ft": [
        "SA"
    ],
    "itel p551w": [
        "IZ"
    ],
    "zte blade a51 lite": [
        "ZT"
    ],
    "redmi a1+": [
        "XI"
    ],
    "mi 10 lite zoom": [
        "XI"
    ],
    "sm-a042f": [
        "SA"
    ],
    "zte v817": [
        "ZT"
    ],
    "zte blade c2 plus": [
        "ZT"
    ],
    "lg-d950": [
        "LG"
    ],
    "lg-d375ar": [
        "LG"
    ],
    "lg-e445": [
        "LG"
    ],
    "lg-d685": [
        "LG"
    ],
    "lg-e977": [
        "LG"
    ],
    "lg-d321": [
        "LG"
    ],
    "lg-us780": [
        "LG"
    ],
    "lgls620": [
        "LG"
    ],
    "lg-e450f": [
        "LG"
    ],
    "lg-d625": [
        "LG"
    ],
    "lg-ls840": [
        "LG"
    ],
    "lg-f510l": [
        "LG"
    ],
    "lg-f320k": [
        "LG"
    ],
    "lg-f340s": [
        "LG"
    ],
    "lg-d610": [
        "LG"
    ],
    "lg-e410": [
        "LG"
    ],
    "lg-d285": [
        "LG"
    ],
    "lg-d107": [
        "LG"
    ],
    "lg-d120": [
        "LG"
    ],
    "lg-vs450pp": [
        "LG"
    ],
    "lg-e986": [
        "LG"
    ],
    "lg-d160": [
        "LG"
    ],
    "vs930 4g": [
        "LG"
    ],
    "lg-p712": [
        "LG"
    ],
    "lg-e435": [
        "LG"
    ],
    "lg-p655h": [
        "LG"
    ],
    "lg-p714": [
        "LG"
    ],
    "lg-f520s": [
        "LG"
    ],
    "lg-f200k": [
        "LG"
    ],
    "energy phone pro": [
        "E1"
    ],
    "energy phone pro qi": [
        "E1"
    ],
    "energy phone pro hd": [
        "E1"
    ],
    "energy phone colors": [
        "E1"
    ],
    "studio energy": [
        "BU"
    ],
    "energy phone max 2+": [
        "E1"
    ],
    "sm-g973x": [
        "SA"
    ],
    "s8_plus_a": [
        "B3"
    ],
    "s8a": [
        "B3"
    ],
    "s710 ruby": [
        "44"
    ],
    "s61 jazz": [
        "69"
    ],
    "s5us": [
        "EM"
    ],
    "s5701l": [
        "NL"
    ],
    "s55b": [
        "E9"
    ],
    "s55a": [
        "E9"
    ],
    "s505024": [
        "12"
    ],
    "rx460": [
        "4A"
    ],
    "zte 8045": [
        "ZT"
    ],
    "poco m5s": [
        "0P"
    ],
    "a1_pro": [
        "UM"
    ],
    "huawei p6 s-u06": [
        "HU"
    ],
    "zte blade l370": [
        "ZT"
    ],
    "poco c40": [
        "0P"
    ],
    "htc desire 620g dual sim": [
        "HT"
    ],
    "s6523": [
        "REV"
    ],
    "cet-lx9": [
        "HU"
    ],
    "poco f4": [
        "0P"
    ],
    "eve-lx9n": [
        "HU"
    ],
    "razor_plus_4g": [
        "F3"
    ],
    "w10": [
        "HV"
    ],
    "kingkong 6": [
        "CB"
    ],
    "a101bm": [
        "KY"
    ],
    "eda51k": [
        "WH"
    ],
    "eda40": [
        "WH"
    ],
    "e10_pro": [
        "EL"
    ],
    "senseit e400": [
        "S6",
        "PC"
    ],
    "mix 3 the palace museum edition": [
        "XI"
    ],
    "poco m5": [
        "0P"
    ],
    "poco c3": [
        "0P"
    ],
    "mi cc9e": [
        "XI"
    ],
    "lenovo s60a": [
        "LE"
    ],
    "redmi 10 prime": [
        "XI"
    ],
    "redmi k30 ultra": [
        "XI"
    ],
    "redmi k30s ultra": [
        "XI"
    ],
    "redmi 10x 4g": [
        "XI"
    ],
    "redmi 9 prime": [
        "XI"
    ],
    "mi 11 pro": [
        "XI"
    ],
    "mi 11 le": [
        "XI"
    ],
    "mi 11 lite 5g ne": [
        "XI"
    ],
    "hn3-u01": [
        "HU"
    ],
    "atrix hd": [
        "MR"
    ],
    "xiaomi 12s ultra": [
        "XI"
    ],
    "xiaomi 12s pro": [
        "XI"
    ],
    "xiaomi 12s": [
        "XI"
    ],
    "redmi 10 prime+ 5g": [
        "XI"
    ],
    "redmi 9 power": [
        "XI"
    ],
    "redmi 10x pro": [
        "XI"
    ],
    "xiaomi_m1805d1st": [
        "XI"
    ],
    "holly-u19": [
        "HU"
    ],
    "albatros c2": [
        "VGE"
    ],
    "nova p3": [
        "MOB"
    ],
    "notrino": [
        "49"
    ],
    "noa_stilo": [
        "N5"
    ],
    "next_p": [
        "5I"
    ],
    "next u": [
        "5I"
    ],
    "next p+": [
        "5I"
    ],
    "newsday_n2+": [
        "ND"
    ],
    "nedaphone v9": [
        "NDP"
    ],
    "movic-w2": [
        "MV"
    ],
    "star n9589": [
        "S4"
    ],
    "redmi pro": [
        "XI"
    ],
    "jy-g4s": [
        "JI"
    ],
    "huawei p7-l07": [
        "HU"
    ],
    "jy-g5s": [
        "JI"
    ],
    "tornado slim": [
        "FL"
    ],
    "class_c250": [
        "BEF"
    ],
    "s61": [
        "DO"
    ],
    "archos core 62s": [
        "AR"
    ],
    "revel 3g": [
        "CH"
    ],
    "relnat premier": [
        "REL"
    ],
    "itel w5503": [
        "IZ"
    ],
    "telo_te6": [
        "TLS"
    ],
    "22081212g": [
        "XI"
    ],
    "rky-lx1": [
        "HNR"
    ],
    "tecno ad8": [
        "TB"
    ],
    "rmx3663": [
        "RE"
    ],
    "rmx3686": [
        "RE"
    ],
    "rmx3687": [
        "RE"
    ],
    "pgu110": [
        "OP"
    ],
    "nokia g60 5g": [
        "NK"
    ],
    "via f30 plus": [
        "R4"
    ],
    "zte blade a52": [
        "ZT"
    ],
    "infinix x6826": [
        "IF"
    ],
    "sm-a236e": [
        "SA"
    ],
    "sm-a236u1": [
        "SA"
    ],
    "miwang m2s": [
        "MIW"
    ],
    "ihunt note ultra": [
        "IH"
    ],
    "mp03": [
        "UM"
    ],
    "mp04": [
        "UM"
    ],
    "mp08": [
        "UM"
    ],
    "v2166": [
        "VV"
    ],
    "itel s11x": [
        "IZ"
    ],
    "itel s11xb": [
        "IZ"
    ],
    "is6plus": [
        "5I"
    ],
    "is3plus": [
        "5I"
    ],
    "iris88_lite": [
        "LV"
    ],
    "iris88_go": [
        "LV"
    ],
    "iris88s": [
        "LV"
    ],
    "iris88": [
        "LV"
    ],
    "iris65": [
        "LV"
    ],
    "iris42": [
        "LV"
    ],
    "iris 50 pro": [
        "LV"
    ],
    "iris 31": [
        "LV"
    ],
    "i2_lite": [
        "0J"
    ],
    "i2": [
        "0J"
    ],
    "hisense hi 1 pro": [
        "HI"
    ],
    "note 6": [
        "UL"
    ],
    "note 9": [
        "CB"
    ],
    "lt600t": [
        "ZOO",
        "SO"
    ],
    "primo f10": [
        "WA"
    ],
    "primo nf5": [
        "WA"
    ],
    "sky55_eea": [
        "KW"
    ],
    "zte n939sc": [
        "ZT"
    ],
    "yu yureka black": [
        "Y1"
    ],
    "nokia c5 endi": [
        "NK"
    ],
    "nokia c2 tennen": [
        "NK"
    ],
    "r1 lite": [
        "I7"
    ],
    "red royal edition": [
        "FAM"
    ],
    "ixion el450": [
        "DX"
    ],
    "ep19_star": [
        "EPH"
    ],
    "ep19": [
        "EPH"
    ],
    "archos sense 55 dc": [
        "AR"
    ],
    "archos sense 50 dc": [
        "AR"
    ],
    "archos core 50p": [
        "AR"
    ],
    "zte blade a315": [
        "ZT"
    ],
    "young y56": [
        "SYH"
    ],
    "young y35": [
        "SYH"
    ],
    "young y51+": [
        "SYH"
    ],
    "young y55": [
        "SYH"
    ],
    "young y36+": [
        "SYH"
    ],
    "ys7pro": [
        "YUS"
    ],
    "ys8pro": [
        "YUS"
    ],
    "ys6 pro": [
        "YUS"
    ],
    "yu 6000": [
        "Y1"
    ],
    "lava z3 up 2": [
        "LV"
    ],
    "2206123sc": [
        "XI"
    ],
    "a204so": [
        "SO"
    ],
    "a101fc": [
        "FU"
    ],
    "fio-bd00": [
        "8X"
    ],
    "scg18": [
        "SA"
    ],
    "sm-a233c": [
        "SA"
    ],
    "v2242a": [
        "VV"
    ],
    "pgx110": [
        "OP"
    ],
    "phj110": [
        "OP"
    ],
    "bne-al00": [
        "HU"
    ],
    "rmx3611": [
        "RE"
    ],
    "pcd pl5507": [
        "PC"
    ],
    "pcd_ph4002": [
        "PC"
    ],
    "pcd_ph3501": [
        "PC"
    ],
    "pcd_e400": [
        "PC"
    ],
    "panasonic t41": [
        "PA"
    ],
    "panasonic t33": [
        "PA"
    ],
    "panasonic p41": [
        "PA"
    ],
    "pam412": [
        "C5"
    ],
    "forward_evolve": [
        "NG"
    ],
    "kenny": [
        "WI"
    ],
    "kayeta": [
        "6W"
    ],
    "kata-m4s": [
        "K0"
    ],
    "karbonn yuva 2": [
        "KA"
    ],
    "abr-al90": [
        "HU"
    ],
    "halo3_pro": [
        "ARP"
    ],
    "5024f": [
        "AL"
    ],
    "5024d": [
        "AL"
    ],
    "2q8l10000": [
        "HT"
    ],
    "gionee s10c pro": [
        "GI"
    ],
    "alfa l": [
        "LV"
    ],
    "aquaris e5 hd": [
        "BX",
        "IX"
    ],
    "wildfire r70": [
        "HT"
    ],
    "v4 nano": [
        "EV"
    ],
    "v4+": [
        "EV"
    ],
    "v75m": [
        "SM"
    ],
    "v120": [
        "SM"
    ],
    "v130": [
        "SM"
    ],
    "kicka zoom": [
        "6W"
    ],
    "htc desire 19s": [
        "HT"
    ],
    "htc desire 19+": [
        "HT"
    ],
    "hapi10": [
        "2M"
    ],
    "m4crd": [
        "MIN"
    ],
    "m4cr": [
        "MIN"
    ],
    "m370i": [
        "I0"
    ],
    "m370": [
        "I0"
    ],
    "m350 pro": [
        "QM"
    ],
    "haier_a41": [
        "HA"
    ],
    "magic_1": [
        "ATI"
    ],
    "global3 b01": [
        "1F"
    ],
    "autoid q9": [
        "61"
    ],
    "autoid q7": [
        "61"
    ],
    "20190419q": [
        "GI"
    ],
    "pccm40": [
        "OP"
    ],
    "roam_cat m8": [
        "ROC"
    ],
    "ldox-2123": [
        "KT"
    ],
    "ldox-2121": [
        "KT"
    ],
    "hla note1-l": [
        "XL"
    ],
    "changhongs07": [
        "C2"
    ],
    "sany v8 pro": [
        "SAN"
    ],
    "sany v8": [
        "SAN"
    ],
    "orbis": [
        "NY"
    ],
    "opus 3": [
        "XO"
    ],
    "outdoor wt4 en": [
        "TL"
    ],
    "vivax pro m1": [
        "V5"
    ],
    "vivax fun s10": [
        "V5"
    ],
    "vivid_premium": [
        "F3"
    ],
    "desire620g": [
        "HT"
    ],
    "evmfv2": [
        "0Q"
    ],
    "kamba_2": [
        "J7"
    ],
    "kamba": [
        "J7"
    ],
    "forward ruby": [
        "NG"
    ],
    "forwardruby": [
        "NG"
    ],
    "agm_h5": [
        "A3"
    ],
    "blaze g": [
        "G3"
    ],
    "blaze n": [
        "G3"
    ],
    "noa_g1": [
        "C5M",
        "N5"
    ],
    "noain x9 plus": [
        "N1"
    ],
    "brown 2": [
        "MY"
    ],
    "blubood2": [
        "B3"
    ],
    "bonvi note": [
        "NO1"
    ],
    "bonvi prime": [
        "NO1"
    ],
    "bonvi pro": [
        "NO1"
    ],
    "borneo_pro": [
        "NO1"
    ],
    "boom p1": [
        "PAN"
    ],
    "vi_note": [
        "NO1"
    ],
    "coolpad c202": [
        "CO"
    ],
    "tecno bf7": [
        "TB"
    ],
    "lava lzg402 om": [
        "LV"
    ],
    "cph2495": [
        "OP"
    ],
    "lenovo k10e70": [
        "LE"
    ],
    "lebest l9": [
        "LEB"
    ],
    "tecno-mobile ch9n": [
        "TB"
    ],
    "voto v5x": [
        "V1"
    ],
    "voto v2i": [
        "V1"
    ],
    "volt_sv451_vision": [
        "VO1",
        "V2"
    ],
    "volt_5xl": [
        "SUR"
    ],
    "cosmo duo": [
        "H2"
    ],
    "micromax q333": [
        "MI"
    ],
    "micromax q324": [
        "MI"
    ],
    "htconem8eye": [
        "HT"
    ],
    "htconem8": [
        "HT"
    ],
    "htc_0pcv2": [
        "HT"
    ],
    "htc desire 510": [
        "HT"
    ],
    "benwee w5pro": [
        "BEN"
    ],
    "benwee l5": [
        "BEN"
    ],
    "tcl m2u": [
        "TC"
    ],
    "im-a930s": [
        "PT"
    ],
    "htc_v01": [
        "HT"
    ],
    "htc_po582": [
        "HT"
    ],
    "htc_pn071": [
        "HT"
    ],
    "htc_one_mini_2": [
        "HT"
    ],
    "htc_m8sx": [
        "HT"
    ],
    "htc_m8minx": [
        "HT"
    ],
    "titanium vista": [
        "KA"
    ],
    "tiger_lite": [
        "UL"
    ],
    "thrill_boost": [
        "CD"
    ],
    "thrill hd": [
        "CD"
    ],
    "thl t9+": [
        "T4"
    ],
    "thl t9 pro": [
        "T4"
    ],
    "thl t9 plus": [
        "T4"
    ],
    "telenor_smart_4g": [
        "T2"
    ],
    "tecno-n9s": [
        "TB"
    ],
    "tecno-n9": [
        "TB"
    ],
    "tecno-n8": [
        "TB"
    ],
    "tecno-n6s": [
        "TB"
    ],
    "tecno-n6": [
        "TB"
    ],
    "ox_x1": [
        "Z1"
    ],
    "lp-02": [
        "SH"
    ],
    "samsung sm-a035f": [
        "SA"
    ],
    "ann-an00": [
        "HNR"
    ],
    "sm-a315n": [
        "SA"
    ],
    "sm-m3070": [
        "SA"
    ],
    "primo vx": [
        "WA"
    ],
    "sm-g736b": [
        "SA"
    ],
    "sm-s911b": [
        "SA"
    ],
    "sm-s911n": [
        "SA"
    ],
    "sm-s916b": [
        "SA"
    ],
    "sm-s916n": [
        "SA"
    ],
    "sm-s918b": [
        "SA"
    ],
    "sm-s918n": [
        "SA"
    ],
    "v2227a": [
        "VV"
    ],
    "v2217": [
        "VV"
    ],
    "ravoz v3": [
        "R9"
    ],
    "itel s663ln": [
        "IZ"
    ],
    "ihunt cyber shark 4g": [
        "IH"
    ],
    "moto e22": [
        "MR"
    ],
    "ravoz v2": [
        "R9"
    ],
    "sh-13c": [
        "SH"
    ],
    "artel t21": [
        "40"
    ],
    "tecno mobile ch6n": [
        "TB"
    ],
    "cph2447": [
        "ON",
        "OP"
    ],
    "cph2481": [
        "OP"
    ],
    "22101320g": [
        "0P"
    ],
    "phq110": [
        "OP"
    ],
    "phk110": [
        "ON"
    ],
    "nx711j": [
        "57"
    ],
    "nx729j": [
        "57"
    ],
    "sm-a042m": [
        "SA"
    ],
    "sm-m045f": [
        "SA"
    ],
    "xt2201-6": [
        "MR"
    ],
    "wp18 pro": [
        "OE"
    ],
    "vna-lx2": [
        "HNR"
    ],
    "m2010j19gc": [
        "0P"
    ],
    "rmo-nx1": [
        "HNR"
    ],
    "rky-lx3": [
        "HNR"
    ],
    "wp21": [
        "OE"
    ],
    "s41pro": [
        "DO"
    ],
    "s89": [
        "DO"
    ],
    "mp17": [
        "UM"
    ],
    "mp18": [
        "UM"
    ],
    "crt-lx1": [
        "HNR"
    ],
    "infinix x666b": [
        "IF"
    ],
    "zte blade a32": [
        "ZT"
    ],
    "2210129sg": [
        "XI"
    ],
    "bv9200": [
        "B2"
    ],
    "neo_plus": [
        "4M"
    ],
    "22111317pg": [
        "0P"
    ],
    "sm-a515f": [
        "SA"
    ],
    "t507u": [
        "TC"
    ],
    "ixion xl240": [
        "DX"
    ],
    "sm-g800m": [
        "SA"
    ],
    "sm-g800y": [
        "SA"
    ],
    "sm-g800x": [
        "SA"
    ],
    "4good kids s45": [
        "4G"
    ],
    "4good s503m 3g": [
        "4G"
    ],
    "4good s500m 3g": [
        "4G"
    ],
    "4good s400m 3g": [
        "4G"
    ],
    "4good s350m 3g": [
        "4G"
    ],
    "starshine iii": [
        "SX"
    ],
    "shv-e330k": [
        "SA"
    ],
    "prime mini se": [
        "H2"
    ],
    "psp3534duo_ru": [
        "PR"
    ],
    "psp3416duo_eu": [
        "PR"
    ],
    "point x502": [
        "V5"
    ],
    "hl6577": [
        "AD"
    ],
    "hl6256": [
        "AD"
    ],
    "next lite": [
        "CD"
    ],
    "myphone uno": [
        "MY",
        "MY1"
    ],
    "vox s509 3g vs5032pg": [
        "D2"
    ],
    "vox_g501_4g_vs5033ml": [
        "D2"
    ],
    "s10-kc": [
        "KY"
    ],
    "motorola edge plus 5g uw (2022)": [
        "MR"
    ],
    "kc-s302": [
        "KY"
    ],
    "tecno kg5q": [
        "TB"
    ],
    "stratus_c7": [
        "1J"
    ],
    "power armor 16 pro": [
        "UL"
    ],
    "moto g53 5g": [
        "MR"
    ],
    "power armor 19": [
        "UL"
    ],
    "tecno l6502s": [
        "TB"
    ],
    "cph2483": [
        "OP"
    ],
    "motorola razr 2022": [
        "MR"
    ],
    "cph2437": [
        "OP"
    ],
    "cph2449": [
        "ON",
        "OP"
    ],
    "sm-a146u": [
        "SA"
    ],
    "sm-a236u": [
        "SA"
    ],
    "xq-cq54": [
        "SO"
    ],
    "p13 blue max pro 256 gb": [
        "RD"
    ],
    "sm-f700w": [
        "SA"
    ],
    "d60 pro": [
        "DO"
    ],
    "chp1723": [
        "OP"
    ],
    "sm-a037w": [
        "SA"
    ],
    "astro 8r": [
        "MW"
    ],
    "moto e13": [
        "MR"
    ],
    "hit p8": [
        "4P"
    ],
    "archos access 50 3g": [
        "AR"
    ],
    "nitro 8": [
        "MW"
    ],
    "view go": [
        "WI"
    ],
    "sm-s911w": [
        "SA"
    ],
    "urban 3": [
        "AE"
    ],
    "sm-s9180": [
        "SA"
    ],
    "mi a2 (aosp)": [
        "XI"
    ],
    "cph2505": [
        "OP"
    ],
    "v2230": [
        "VV"
    ],
    "zte 9047": [
        "ZT"
    ],
    "rmx3708": [
        "RE"
    ],
    "5061k": [
        "AL"
    ],
    "sm-s918u": [
        "SA"
    ],
    "itel s661lp": [
        "IZ"
    ],
    "motorola edge (2022)": [
        "MR"
    ],
    "x400": [
        "PS",
        "8E",
        "QQ"
    ],
    "ilium x400": [
        "LA"
    ],
    "lgm-x100s": [
        "LG"
    ],
    "c80": [
        "OSC"
    ],
    "c11": [
        "OE"
    ],
    "force": [
        "4M"
    ],
    "cyber dog 4g": [
        "IH"
    ],
    "ruby": [
        "4M"
    ],
    "cosmo lte": [
        "4M"
    ],
    "legend pro lte": [
        "4M"
    ],
    "22120rn86g": [
        "XI"
    ],
    "s3mini": [
        "EMR"
    ],
    "mascom ss289": [
        "MA1"
    ],
    "logic l65": [
        "1L"
    ],
    "sm-s536dl": [
        "SA"
    ],
    "realme c25 series": [
        "RE"
    ],
    "tecno bf7n": [
        "TB"
    ],
    "samsung sm-a145p": [
        "SA"
    ],
    "angelican": [
        "XI"
    ],
    "w888": [
        "U2"
    ],
    "nokia c31": [
        "NK"
    ],
    "tecno ca8s": [
        "TB"
    ],
    "itel a662l": [
        "IZ"
    ],
    "22126rn91y": [
        "XI"
    ],
    "redmi 12c": [
        "XI"
    ],
    "mz-itel a661l": [
        "IZ",
        "M1"
    ],
    "cp05": [
        "CO"
    ],
    "iphone12 pro max": [
        "AP"
    ],
    "gionee f8 neo": [
        "GI"
    ],
    "sm-w2020": [
        "SA"
    ],
    "sm-a125v": [
        "SA"
    ],
    "tecno mobile kg6p": [
        "TB"
    ],
    "symbol s4": [
        "HV"
    ],
    "ravoz z3 pro": [
        "R9"
    ],
    "primo e12": [
        "WA"
    ],
    "peppa-l03b": [
        "HU"
    ],
    "nex 3s 5g": [
        "VV"
    ],
    "artel q21": [
        "40"
    ],
    "masstel hapi 15": [
        "2M"
    ],
    "masstel hapi 30": [
        "2M"
    ],
    "cph2487": [
        "ON",
        "OP"
    ],
    "cph2417": [
        "ON",
        "OP"
    ],
    "pgt110": [
        "OP"
    ],
    "poco x5 gt pro": [
        "0P"
    ],
    "tecno ci7n": [
        "TB"
    ],
    "2210132g": [
        "XI"
    ],
    "s19 max 64gb": [
        "RD"
    ],
    "rmx3709": [
        "RE"
    ],
    "sm-a146b": [
        "SA"
    ],
    "sm-g990u2": [
        "SA"
    ],
    "2209116ag": [
        "XI"
    ],
    "a161": [
        "I4"
    ],
    "le max 2": [
        "L1"
    ],
    "n30": [
        "DO",
        "5I"
    ],
    "rmx3710": [
        "RE"
    ],
    "cph2407": [
        "OP"
    ],
    "infinix x6517": [
        "IF"
    ],
    "itel s663lc": [
        "IZ"
    ],
    "zte_blade_a31_plus_ru": [
        "ZT"
    ],
    "itel a512w": [
        "IZ"
    ],
    "epic_2": [
        "4M"
    ],
    "rmx2183": [
        "RE"
    ],
    "mz-meizu 18s": [
        "M1"
    ],
    "luna g9": [
        "L9",
        "69"
    ],
    "asus_ai2203_a": [
        "AU"
    ],
    "poco x5 5g": [
        "0P"
    ],
    "poco x5 pro 5g": [
        "0P"
    ],
    "ds-cl2 pro": [
        "DCO"
    ],
    "lava lzg401": [
        "LV"
    ],
    "berry pro": [
        "4M"
    ],
    "r7_2": [
        "4M"
    ],
    "itel a571wm": [
        "IZ"
    ],
    "sm-a145f": [
        "SA"
    ],
    "vi20220819": [
        "VII"
    ],
    "2211133g": [
        "XI"
    ],
    "tronik_3": [
        "4R"
    ],
    "zeeker t100": [
        "WZ"
    ],
    "zte a2022py": [
        "ZT"
    ],
    "infinix x6515": [
        "IF"
    ],
    "infocus m808": [
        "I0",
        "FO"
    ],
    "epic pro_2": [
        "4M",
        "HR"
    ],
    "zte blade a52ru": [
        "ZT"
    ],
    "vtl-202101": [
        "VE"
    ],
    "vipro edge 2": [
        "0V"
    ],
    "lg-h340ar": [
        "LG"
    ],
    "tecno mobile kg8": [
        "TB"
    ],
    "tecno kf6h": [
        "TB"
    ],
    "itel a631l": [
        "IZ"
    ],
    "star 3": [
        "VH"
    ],
    "star 4": [
        "VH"
    ],
    "itel l6006l": [
        "IZ"
    ],
    "sm-a136s": [
        "SA"
    ],
    "black shark 3s": [
        "XI"
    ],
    "ebg-n19": [
        "HU"
    ],
    "els-n29": [
        "HU"
    ],
    "ego note 4g": [
        "TOR"
    ],
    "g10+": [
        "SM"
    ],
    "tecno ki5q": [
        "TB"
    ],
    "v2237": [
        "VV"
    ],
    "sm-a546e": [
        "SA"
    ],
    "t610k": [
        "TC"
    ],
    "tecno ki5m": [
        "TB"
    ],
    "tecno ad9": [
        "TB"
    ],
    "power armor 18": [
        "UL"
    ],
    "bv5200 pro": [
        "B2"
    ],
    "air1 ultra+": [
        "5F"
    ],
    "v2186a": [
        "VV"
    ],
    "xt2335-3": [
        "MR"
    ],
    "tecno bf6": [
        "TB"
    ],
    "rs51_hs": [
        "CIP"
    ],
    "rs550": [
        "8E"
    ],
    "tecno in1 pro": [
        "TB"
    ],
    "turbophone4g compact 2108": [
        "MIV"
    ],
    "turbo_mini_f1": [
        "DO"
    ],
    "omega_lite_2": [
        "CH"
    ],
    "omega6_4g": [
        "6P"
    ],
    "okapia_mirage": [
        "OA"
    ],
    "ok-smart11": [
        "OKI"
    ],
    "ok-ls2": [
        "OKI"
    ],
    "ok-ls1": [
        "OKI"
    ],
    "ok-lx6": [
        "OKI"
    ],
    "ok-lx5": [
        "OKI"
    ],
    "ojos vivir": [
        "CI"
    ],
    "ojos plus": [
        "CI"
    ],
    "ojos dos mini": [
        "CI"
    ],
    "ojos dos": [
        "CI"
    ],
    "ober_primo e8": [
        "OBR"
    ],
    "scg19": [
        "SA"
    ],
    "sm-a346e": [
        "SA"
    ],
    "sm-a146p": [
        "SA"
    ],
    "luna g6e": [
        "L9",
        "69"
    ],
    "sm-s918u1": [
        "SA"
    ],
    "sm-s916u1": [
        "SA"
    ],
    "sm-s9110": [
        "SA"
    ],
    "sm-m146b": [
        "SA"
    ],
    "sm-g990w2": [
        "SA"
    ],
    "sm-g990u3": [
        "SA"
    ],
    "sm-a546b": [
        "SA"
    ],
    "moto g13": [
        "MR"
    ],
    "xt2243-2": [
        "MR"
    ],
    "itel a44 pro": [
        "IZ"
    ],
    "intex aqua style 3": [
        "IX"
    ],
    "ino s9": [
        "INO"
    ],
    "inoi 2 lite": [
        "I4"
    ],
    "inhon_v6": [
        "INH"
    ],
    "impress fortune": [
        "VX"
    ],
    "everstar q40": [
        "EV"
    ],
    "c2_color_m4": [
        "ZP"
    ],
    "xeno v1": [
        "2N"
    ],
    "z719dl": [
        "ZT"
    ],
    "xperia acro s": [
        "SE"
    ],
    "x4_soul_infinity_plus": [
        "A2"
    ],
    "vfd 512": [
        "VF"
    ],
    "vfd 511": [
        "VF"
    ],
    "vernee thor": [
        "VR"
    ],
    "umi z": [
        "UM"
    ],
    "5045x": [
        "AL"
    ],
    "m5 lite cdma": [
        "GI"
    ],
    "m457": [
        "8L"
    ],
    "m-ppxs510": [
        "MC"
    ],
    "m-ppxg551": [
        "MC"
    ],
    "m-ppxg515": [
        "MC"
    ],
    "m-ppxg512": [
        "MC"
    ],
    "m-ppxg511": [
        "MC"
    ],
    "m-ppxg510": [
        "MC"
    ],
    "m-ppxg415": [
        "MC"
    ],
    "m-ppxg410": [
        "MC"
    ],
    "m-ppas520": [
        "MC"
    ],
    "m-ppar450": [
        "MC"
    ],
    "m-ppag552": [
        "MC"
    ],
    "lynx_luxe": [
        "SKK"
    ],
    "lt_m6": [
        "QL"
    ],
    "lt_m5_lite": [
        "QL"
    ],
    "lt_m5": [
        "QL"
    ],
    "lp_evora_light": [
        "LL"
    ],
    "lp_infinity": [
        "LL"
    ],
    "lion 1": [
        "VX"
    ],
    "lion 2": [
        "VX"
    ],
    "lion 3": [
        "VX"
    ],
    "life x8": [
        "BU"
    ],
    "basco l451": [
        "JG"
    ],
    "basco l450": [
        "JG"
    ],
    "basco_m1": [
        "JG"
    ],
    "basco_l3": [
        "JG"
    ],
    "bay": [
        "H2"
    ],
    "balr_x7": [
        "IC"
    ],
    "balrx7_pak": [
        "IC"
    ],
    "aston a7+": [
        "QY"
    ],
    "aston a5+": [
        "QY"
    ],
    "aston a3+": [
        "QY"
    ],
    "asse.q5": [
        "ASS",
        "60"
    ],
    "asse-q3": [
        "ASS"
    ],
    "asse q5s": [
        "ASS"
    ],
    "xolo one hd": [
        "XO"
    ],
    "impress envy": [
        "VX"
    ],
    "eluga_pulse_x": [
        "PA"
    ],
    "eluga_pulse": [
        "PA"
    ],
    "eluga_mark_2": [
        "PA"
    ],
    "eluga_arc_2": [
        "PA"
    ],
    "eluga ray": [
        "PA"
    ],
    "eluga prim": [
        "PA"
    ],
    "eluga i3 mega": [
        "PA"
    ],
    "elite_grace": [
        "0W"
    ],
    "elite star": [
        "0W"
    ],
    "elite prime": [
        "0W"
    ],
    "elite note": [
        "0W"
    ],
    "elite 6.0l+": [
        "SW"
    ],
    "eko_star_g58": [
        "EK"
    ],
    "eko_star_g55": [
        "EK"
    ],
    "eko_star_g50e": [
        "EK"
    ],
    "echo push": [
        "E4"
    ],
    "hexin-h2-a": [
        "SQ"
    ],
    "hlte229t": [
        "HI"
    ],
    "gly1620": [
        "GI"
    ],
    "evolveo strongphone g5": [
        "EO"
    ],
    "lp_spectrum_s2": [
        "LL"
    ],
    "ln9821": [
        "LV"
    ],
    "ln9820": [
        "LV"
    ],
    "litepro": [
        "ZO1"
    ],
    "life 7s": [
        "S8"
    ],
    "koobee f2 plus": [
        "KB"
    ],
    "kachocolate": [
        "N4"
    ],
    "k700a": [
        "WK"
    ],
    "k536": [
        "8E"
    ],
    "uniden prime 500": [
        "UND"
    ],
    "gfive president a97": [
        "0G"
    ],
    "gfive_president_xhero_5": [
        "0G"
    ],
    "gfive president xhero 7": [
        "0G"
    ],
    "gfive president xhero 1": [
        "0G"
    ],
    "gfive_president_smart_a98": [
        "0G"
    ],
    "gfive president classic 1": [
        "0G"
    ],
    "gfive president classic 7": [
        "0G"
    ],
    "gfive president smart 2": [
        "0G"
    ],
    "gfive president smart 5": [
        "0G"
    ],
    "gfive president g6 plus": [
        "0G"
    ],
    "gfive president g10 fashion": [
        "0G"
    ],
    "gfive president tango 3(t3100)": [
        "0G"
    ],
    "gfive president(g6)": [
        "0G"
    ],
    "gfive president(g9)": [
        "0G"
    ],
    "gfive president(g10)": [
        "0G"
    ],
    "admire_sense+": [
        "ZN"
    ],
    "admire neo+": [
        "ZN"
    ],
    "admire shine": [
        "ZN",
        "J0"
    ],
    "admire_sense_duo": [
        "ZN"
    ],
    "admire_infinity": [
        "ZN"
    ],
    "admire_curve+": [
        "ZN"
    ],
    "admire strong": [
        "ZN"
    ],
    "admire_duo": [
        "ZN"
    ],
    "admire swadesh+": [
        "ZN"
    ],
    "ac7_dj17": [
        "YI"
    ],
    "ac45bhe": [
        "AR"
    ],
    "feel_plus": [
        "TEL"
    ],
    "geant_t3": [
        "GEN"
    ],
    "galactic_astro": [
        "GA1"
    ],
    "era1x": [
        "XO"
    ],
    "era1xpro": [
        "XO"
    ],
    "era x": [
        "XO"
    ],
    "era 2x 3gb": [
        "XO"
    ],
    "era 2": [
        "XO"
    ],
    "eon45i": [
        "ZIG"
    ],
    "ticktock-s": [
        "UZ"
    ],
    "moto g73 5g": [
        "MR"
    ],
    "2212arnc4l": [
        "XI"
    ],
    "v2231": [
        "VV"
    ],
    "crt-lx2": [
        "HNR"
    ],
    "a170_plus": [
        "I4"
    ],
    "pixel 7a": [
        "GO"
    ],
    "sm-a145r": [
        "SA"
    ],
    "rmx3627": [
        "RE"
    ],
    "xiaomi poco x3 nfc": [
        "0P",
        "XI"
    ],
    "nokia g22": [
        "NK"
    ],
    "hammer_construction": [
        "HAM"
    ],
    "v max": [
        "DO"
    ],
    "tecno ki7": [
        "TB"
    ],
    "23028rn4dg": [
        "XI"
    ],
    "z5157v": [
        "ZT"
    ],
    "sm-e045f": [
        "SA"
    ],
    "rmx3706": [
        "RE"
    ],
    "power armor 19t": [
        "UL"
    ],
    "tecno ki5k": [
        "TB"
    ],
    "pgt-an10": [
        "HNR"
    ],
    "22127rk46c": [
        "XI"
    ],
    "22101320i": [
        "0P"
    ],
    "tecno ad10": [
        "TB"
    ],
    "tecno ki5n": [
        "TB"
    ],
    "sts502": [
        "Y7"
    ],
    "lava z3 up": [
        "LV"
    ],
    "sm-a045m": [
        "SA"
    ],
    "hl6077": [
        "AD"
    ],
    "hola": [
        "J9"
    ],
    "ht28": [
        "STR",
        "HM"
    ],
    "ht16": [
        "STR",
        "HM"
    ],
    "panasonic t31": [
        "PA"
    ],
    "orange zilo": [
        "OR"
    ],
    "lenovo a526": [
        "LE"
    ],
    "lenovo a850+": [
        "LE"
    ],
    "vx20": [
        "4M"
    ],
    "vx19": [
        "4M"
    ],
    "m2004j19ag": [
        "XI"
    ],
    "220743fi": [
        "XI"
    ],
    "armor 12s": [
        "UL"
    ],
    "gplus s10": [
        "8G"
    ],
    "g512": [
        "GN"
    ],
    "g312": [
        "GN"
    ],
    "gsmart rey r3": [
        "GG"
    ],
    "igo_l3": [
        "JG"
    ],
    "huawei lyo-l02": [
        "HU"
    ],
    "huawei lyo-l01": [
        "HU"
    ],
    "hyper x dragon": [
        "SKK"
    ],
    "hyper x blade ii": [
        "SKK"
    ],
    "hyper x blade": [
        "SKK"
    ],
    "dtac phone joey jet 2": [
        "DTA"
    ],
    "dpa_zeta": [
        "DPA"
    ],
    "dpa h3": [
        "DPA"
    ],
    "sl05": [
        "BP"
    ],
    "slam": [
        "HR"
    ],
    "sm 02 2019": [
        "BP"
    ],
    "sm-j530gm": [
        "SA"
    ],
    "sm-j530y": [
        "SA"
    ],
    "sm-j530ym": [
        "SA"
    ],
    "sm-j530fd": [
        "SA"
    ],
    "aqua_power_hd": [
        "IX"
    ],
    "aqua_lifeiii": [
        "IX"
    ],
    "aqua_power_ii": [
        "IX"
    ],
    "aqua_slice_ii": [
        "IX"
    ],
    "im-a860k": [
        "PT"
    ],
    "im-a860l": [
        "PT"
    ],
    "im-a860s": [
        "PT"
    ],
    "im-a860vn": [
        "PT"
    ],
    "im-a850vn": [
        "PT"
    ],
    "im-a850s": [
        "PT"
    ],
    "ilium s130": [
        "LA"
    ],
    "ilium l820": [
        "LA"
    ],
    "ifoo s50": [
        "QN"
    ],
    "stk_transporter_1": [
        "S8"
    ],
    "stk life plus s": [
        "S8"
    ],
    "stk life 7 4g": [
        "S8"
    ],
    "stk life 7 3g": [
        "S8"
    ],
    "stk life 5": [
        "S8"
    ],
    "stk hero lite": [
        "S8"
    ],
    "storm_s8plus": [
        "6R"
    ],
    "storm_s8": [
        "6R"
    ],
    "symphony i110": [
        "SM"
    ],
    "spice f305": [
        "SP"
    ],
    "spice f302": [
        "SP"
    ],
    "spice f301": [
        "SP"
    ],
    "speed_s8": [
        "00"
    ],
    "sn10": [
        "SUP"
    ],
    "smartphone_yzu_ds53": [
        "DL0"
    ],
    "smartphone dl horizon h8": [
        "DL0"
    ],
    "smart champ 4.0": [
        "11"
    ],
    "smart 4g adventure": [
        "11"
    ],
    "smart 4g gen c 5.0\"\"": [
        "11"
    ],
    "sp413": [
        "C5"
    ],
    "stk ace plus": [
        "S8"
    ],
    "stk evo": [
        "S8"
    ],
    "sw17w13": [
        "1G"
    ],
    "sw17w08": [
        "1G"
    ],
    "t400 3g 2017": [
        "N3"
    ],
    "m2001j1g": [
        "XI"
    ],
    "lly-lx2": [
        "HNR"
    ],
    "lly-lx1": [
        "HNR"
    ],
    "lly-lx3": [
        "HNR",
        "HU"
    ],
    "celero3 5g+": [
        "DQ"
    ],
    "zte blade l220": [
        "ZT"
    ],
    "iphone5,3": [
        "AP"
    ],
    "primo zx3": [
        "WA"
    ],
    "primo s6": [
        "WA"
    ],
    "primo rm3s": [
        "WA"
    ],
    "primo rh3": [
        "WA"
    ],
    "primo nh3i": [
        "WA"
    ],
    "primo nh3": [
        "WA"
    ],
    "primo nh3 lite": [
        "WA"
    ],
    "primo nf3": [
        "WA"
    ],
    "primo hm4i": [
        "WA"
    ],
    "primo hm4+": [
        "WA"
    ],
    "primo hm4": [
        "WA"
    ],
    "e8_ultra": [
        "EKI"
    ],
    "dl501": [
        "D3"
    ],
    "spirit_plus": [
        "N3"
    ],
    "smart prime ii": [
        "49"
    ],
    "lgls996": [
        "LG"
    ],
    "lgls770": [
        "LG"
    ],
    "lgls751": [
        "LG"
    ],
    "lgls665": [
        "LG"
    ],
    "lgl82vl": [
        "LG"
    ],
    "lgl81al": [
        "LG"
    ],
    "lgl62vl": [
        "LG"
    ],
    "lgl61al": [
        "LG"
    ],
    "lgl52vl": [
        "LG"
    ],
    "lgl51al": [
        "LG"
    ],
    "lgl44vl": [
        "LG"
    ],
    "lgl43al": [
        "LG"
    ],
    "lgl18vc": [
        "LG"
    ],
    "lgas995": [
        "LG"
    ],
    "lg-ms323": [
        "LG"
    ],
    "lg-m700n": [
        "LG"
    ],
    "lg-k420pr": [
        "LG"
    ],
    "lg-k420ds": [
        "LG"
    ],
    "lg-k121": [
        "LG"
    ],
    "lg-k120gt": [
        "LG"
    ],
    "lg-h990ds": [
        "LG"
    ],
    "lg-h968": [
        "LG"
    ],
    "lg-h959": [
        "LG"
    ],
    "lg-h955": [
        "LG"
    ],
    "lg-h900pr": [
        "LG"
    ],
    "lg-h740": [
        "LG"
    ],
    "lg-h734": [
        "LG"
    ],
    "lg-h731": [
        "LG"
    ],
    "lg-h631": [
        "LG"
    ],
    "lg-h525": [
        "LG"
    ],
    "lg-h445": [
        "LG"
    ],
    "lg-h443": [
        "LG"
    ],
    "lg-h345": [
        "LG"
    ],
    "lg-f620s": [
        "LG"
    ],
    "lg-f610s": [
        "LG"
    ],
    "lg-f610k": [
        "LG"
    ],
    "lg-f600s": [
        "LG"
    ],
    "lg-f580l": [
        "LG"
    ],
    "lg-f510s": [
        "LG"
    ],
    "lg-f510k": [
        "LG"
    ],
    "lg-f400k": [
        "LG"
    ],
    "lg-f260s": [
        "LG"
    ],
    "lg-f220k": [
        "LG"
    ],
    "lg-f200s": [
        "LG"
    ],
    "lg-f200l": [
        "LG"
    ],
    "lg-f180l": [
        "LG"
    ],
    "lg-f180k": [
        "LG"
    ],
    "lg-e989": [
        "LG"
    ],
    "lg-e981h": [
        "LG"
    ],
    "lg-e980h": [
        "LG"
    ],
    "lg-e980": [
        "LG"
    ],
    "lg-e976": [
        "LG"
    ],
    "lg-e975k": [
        "LG"
    ],
    "lg-d959": [
        "LG"
    ],
    "lg-d958": [
        "LG"
    ],
    "lg-d955": [
        "LG"
    ],
    "lg-d950g": [
        "LG"
    ],
    "lg-d850": [
        "LG"
    ],
    "lg-d806": [
        "LG"
    ],
    "lg-d805": [
        "LG"
    ],
    "lg-d803": [
        "LG"
    ],
    "lg-d802t": [
        "LG"
    ],
    "lg-d801": [
        "LG"
    ],
    "lg-d722j": [
        "LG"
    ],
    "lg-d722ar": [
        "LG"
    ],
    "lg-d693ar": [
        "LG"
    ],
    "lg-d684": [
        "LG"
    ],
    "lg-d683": [
        "LG"
    ],
    "lg-d682tr": [
        "LG"
    ],
    "lg-d682": [
        "LG"
    ],
    "lg-d681": [
        "LG"
    ],
    "lg-d631": [
        "LG"
    ],
    "lg-d610tr": [
        "LG"
    ],
    "lg-d610ar": [
        "LG"
    ],
    "lg-d605": [
        "LG"
    ],
    "lg-d505": [
        "LG"
    ],
    "lg-d486": [
        "LG"
    ],
    "lg-d400": [
        "LG"
    ],
    "lg-d393": [
        "LG"
    ],
    "lg-d280": [
        "LG"
    ],
    "lg-d320ar": [
        "LG"
    ],
    "lg-d329": [
        "LG"
    ],
    "lg-d337": [
        "LG"
    ],
    "lg-d227": [
        "LG"
    ],
    "lg-d221": [
        "LG"
    ],
    "lg-d213ar": [
        "LG"
    ],
    "lg-d213": [
        "LG"
    ],
    "lg-d180f": [
        "LG"
    ],
    "lg-d175f": [
        "LG"
    ],
    "lg-d170": [
        "LG"
    ],
    "lg-d165ar": [
        "LG"
    ],
    "lg-d165": [
        "LG"
    ],
    "lg-d157f": [
        "LG"
    ],
    "lg-d150": [
        "LG"
    ],
    "lg-d120ar": [
        "LG"
    ],
    "lg-d105": [
        "LG"
    ],
    "lg-d100ar": [
        "LG"
    ],
    "lg-d100": [
        "LG"
    ],
    "lg-f310lr": [
        "LG"
    ],
    "lg-f310l": [
        "LG"
    ],
    "lg-f300s": [
        "LG"
    ],
    "lg-f300l": [
        "LG"
    ],
    "lg-f300k": [
        "LG"
    ],
    "lg-f320s": [
        "LG"
    ],
    "lg-f340k": [
        "LG"
    ],
    "lg-f340l": [
        "LG"
    ],
    "lg-f370l": [
        "LG"
    ],
    "lg-f370k": [
        "LG"
    ],
    "lg-h220": [
        "LG"
    ],
    "lg-h221": [
        "LG"
    ],
    "lg-h221ar": [
        "LG"
    ],
    "lg-h222": [
        "LG"
    ],
    "lg-h788n": [
        "LG"
    ],
    "lg-fl40l": [
        "LG"
    ],
    "lg-f520l": [
        "LG"
    ],
    "lg-f480s": [
        "LG"
    ],
    "lg-f480l": [
        "LG"
    ],
    "lg-f480k": [
        "LG"
    ],
    "lg-f470s": [
        "LG"
    ],
    "lg-f470l": [
        "LG"
    ],
    "lg-f440l": [
        "LG"
    ],
    "lg-f410s": [
        "LG"
    ],
    "lg-f400s": [
        "LG"
    ],
    "lg-f400l": [
        "LG"
    ],
    "lg-f350s": [
        "LG"
    ],
    "lg-f350l": [
        "LG"
    ],
    "lg-f350k": [
        "LG"
    ],
    "lg-d385": [
        "LG"
    ],
    "lg-d380": [
        "LG"
    ],
    "lg-d370": [
        "LG"
    ],
    "lg-h788tr": [
        "LG"
    ],
    "lg-h788sg": [
        "LG"
    ],
    "lg-h815t": [
        "LG"
    ],
    "lgl16c": [
        "LG"
    ],
    "lgl15g": [
        "LG"
    ],
    "lgls885": [
        "LG"
    ],
    "lgd855": [
        "LG"
    ],
    "lgv31": [
        "LG"
    ],
    "lgms323": [
        "LG"
    ],
    "lgvs450pp": [
        "LG"
    ],
    "lgd850": [
        "LG"
    ],
    "lg-x147": [
        "LG"
    ],
    "lg-x140": [
        "LG"
    ],
    "lg-x137": [
        "LG"
    ],
    "lg-x132": [
        "LG"
    ],
    "lg-x130g": [
        "LG"
    ],
    "lg-t480s": [
        "LG"
    ],
    "lg-t480k": [
        "LG"
    ],
    "lg-p716": [
        "LG"
    ],
    "lg-p713tr": [
        "LG"
    ],
    "lg-ls995": [
        "LG"
    ],
    "lg-ls990": [
        "LG"
    ],
    "lg-ls970": [
        "LG"
    ],
    "lg-e985t": [
        "LG"
    ],
    "lg-e612": [
        "LG"
    ],
    "lg-e610": [
        "LG"
    ],
    "lg-d956": [
        "LG"
    ],
    "lg-d951": [
        "LG"
    ],
    "lgms659": [
        "LG"
    ],
    "lgl39c": [
        "LG"
    ],
    "lgl01e": [
        "LG"
    ],
    "lg-f160": [
        "LG"
    ],
    "lg-f160l": [
        "LG"
    ],
    "lg-f160k": [
        "LG"
    ],
    "lg-f160lv": [
        "LG"
    ],
    "23013pc75g": [
        "0P"
    ],
    "23028rncag": [
        "XI"
    ],
    "23049pcd8g": [
        "0P"
    ],
    "sm-a245f": [
        "SA"
    ],
    "u668aa": [
        "6A"
    ],
    "moto g23": [
        "MR"
    ],
    "infinix x669c": [
        "IF"
    ],
    "infinix x669d": [
        "IF"
    ],
    "infinix x6831": [
        "IF"
    ],
    "infinix x6833b": [
        "IF"
    ],
    "infinix x6835b": [
        "IF"
    ],
    "sm-s9160": [
        "SA"
    ],
    "nokia x30 5g": [
        "NK"
    ],
    "v2246": [
        "VV"
    ],
    "rky-lx2": [
        "HNR"
    ],
    "t430w": [
        "TC"
    ],
    "t431d": [
        "TC"
    ],
    "t501c": [
        "TC"
    ],
    "t501l": [
        "TC"
    ],
    "pixel 4a 5g": [
        "GO"
    ],
    "black x": [
        "STV",
        "KL"
    ],
    "dijitsu_smart_a11s": [
        "DIJ"
    ],
    "cosmas_tf": [
        "CG"
    ],
    "elite n55": [
        "SW"
    ],
    "lenovo k15 plus": [
        "LE"
    ],
    "note 14": [
        "UL"
    ],
    "acer liquid": [
        "AC"
    ],
    "s100": [
        "DO",
        "IG"
    ],
    "cph2465": [
        "ON",
        "OP"
    ],
    "cph2467": [
        "ON",
        "OP"
    ],
    "pgt-n19": [
        "HNR"
    ],
    "phb110": [
        "ON"
    ],
    "lg-f720k": [
        "LG"
    ],
    "lgl164vl": [
        "LG"
    ],
    "impress strong": [
        "VX"
    ],
    "ideos x5 pro": [
        "HU"
    ],
    "i504 dream": [
        "NM"
    ],
    "hyundai ultra rock": [
        "HN"
    ],
    "note_5": [
        "J9"
    ],
    "infinix x6516": [
        "IF"
    ],
    "hisense u965": [
        "HI"
    ],
    "hisense u50 lite": [
        "HI"
    ],
    "hisense infinity e6": [
        "HI"
    ],
    "2209129sc": [
        "XI"
    ],
    "touch xl 2": [
        "CH"
    ],
    "top_s7": [
        "9H"
    ],
    "top_p9": [
        "9H"
    ],
    "top_h740": [
        "9H"
    ],
    "top_10": [
        "9H"
    ],
    "top_s8": [
        "9H"
    ],
    "top_note8": [
        "9H"
    ],
    "top_i7": [
        "9H"
    ],
    "top-v30": [
        "9H"
    ],
    "u3_4g": [
        "40"
    ],
    "u2": [
        "40"
    ],
    "u1": [
        "40"
    ],
    "cnote 50": [
        "GOO"
    ],
    "hisense c30 lite": [
        "HI"
    ],
    "5130e": [
        "TC"
    ],
    "5130i": [
        "TC"
    ],
    "telenor smart 2": [
        "T2"
    ],
    "s401a": [
        "IP"
    ],
    "nitro 55a": [
        "MW"
    ],
    "s6303l": [
        "NL"
    ],
    "galaxy s21+": [
        "SA"
    ],
    "three proofings w9": [
        "KX"
    ],
    "three proofings w7": [
        "KX"
    ],
    "toogo go 2": [
        "TOO",
        "QA",
        "YE"
    ],
    "thl 2015a": [
        "T4"
    ],
    "tele2fon_v6": [
        "2L"
    ],
    "telma f2": [
        "TEL"
    ],
    "telma_titan_4g": [
        "TEL"
    ],
    "telma f1+4g": [
        "TEL"
    ],
    "telma ego": [
        "TEL"
    ],
    "telo_te580_co": [
        "TLS"
    ],
    "techsmart t6": [
        "TE1"
    ],
    "techsmart t5+": [
        "TE1"
    ],
    "tarzan f1": [
        "5IV"
    ],
    "odyssey high": [
        "Z4"
    ],
    "oucitel c12pro": [
        "OE"
    ],
    "ojos luna": [
        "CI",
        "69"
    ],
    "ojos x1": [
        "CI"
    ],
    "ojos cielo": [
        "CI"
    ],
    "odyssey soar": [
        "Z4"
    ],
    "odyssey era": [
        "Z4"
    ],
    "oppo a83t": [
        "OP"
    ],
    "oppo a83": [
        "OP"
    ],
    "rmx3700": [
        "RE"
    ],
    "bv9300": [
        "B2"
    ],
    "itel p11": [
        "IZ"
    ],
    "p11": [
        "DX",
        "SM"
    ],
    "c32": [
        "OE"
    ],
    "c25": [
        "OE"
    ],
    "a95": [
        "B2"
    ],
    "a80": [
        "B2"
    ],
    "p50": [
        "CB"
    ],
    "techniphone 5": [
        "TX"
    ],
    "vox e502 4g vs5036pl": [
        "D2"
    ],
    "vox fire 4g vs5037pl": [
        "D2"
    ],
    "doogee t6pro": [
        "DO"
    ],
    "doogee y6": [
        "DO"
    ],
    "doogee_x9_pro": [
        "DO"
    ],
    "doogee dg550": [
        "DO"
    ],
    "doogee valencia2 y100pro": [
        "DO"
    ],
    "oukitel k4000 pro": [
        "OE",
        "OK"
    ],
    "like_8": [
        "IH"
    ],
    "ftj161e-vn": [
        "FT"
    ],
    "fte171a": [
        "FT"
    ],
    "fun_value": [
        "OW"
    ],
    "fun value lite": [
        "OW"
    ],
    "g-tide v7s": [
        "GT"
    ],
    "g-tide vans 8c": [
        "GT"
    ],
    "g-tide vans 9": [
        "GT"
    ],
    "furious 7 pro": [
        "BC"
    ],
    "paris": [
        "UL"
    ],
    "hisense infinity h60 zoom": [
        "HI"
    ],
    "hisense e32 lite": [
        "HI"
    ],
    "avvio_795": [
        "AV"
    ],
    "n100": [
        "DO"
    ],
    "a350": [
        "DX"
    ],
    "micromax a350": [
        "MI",
        "DX"
    ],
    "view max": [
        "FL"
    ],
    "view max pro": [
        "QM"
    ],
    "4188v": [
        "TC"
    ],
    "konnect power": [
        "0W"
    ],
    "konnect prime": [
        "0W"
    ],
    "konnect neo 4g": [
        "0W"
    ],
    "kogan agora 6": [
        "KG"
    ],
    "knmobile q55": [
        "KNM"
    ],
    "5001d_eea": [
        "AL"
    ],
    "5001d_ru": [
        "AL"
    ],
    "5001j": [
        "AL"
    ],
    "wim": [
        "WI"
    ],
    "eluga ray 500": [
        "PA"
    ],
    "sh-01e": [
        "SH"
    ],
    "bz02": [
        "FU"
    ],
    "rg725": [
        "RG"
    ],
    "go 55303": [
        "GRO"
    ],
    "uoogou t10": [
        "UOO"
    ],
    "jkopo f1": [
        "KP"
    ],
    "uoogou f9": [
        "UOO"
    ],
    "eluga i9": [
        "PA"
    ],
    "eluga i7": [
        "PA"
    ],
    "emerald_m55cr": [
        "MIN"
    ],
    "a41 power": [
        "KA"
    ],
    "a1 indian": [
        "KA"
    ],
    "aura storm": [
        "KA"
    ],
    "aura champ": [
        "KA"
    ],
    "eluga i4": [
        "PA"
    ],
    "intex aqua zenith": [
        "IX"
    ],
    "maxi 20": [
        "PR1"
    ],
    "m10+max": [
        "EV"
    ],
    "4188o": [
        "TC"
    ],
    "t768s": [
        "TC"
    ],
    "blade a31": [
        "ZT"
    ],
    "bl52": [
        "BM"
    ],
    "zte 9045": [
        "ZT"
    ],
    "figi p40 max": [
        "J9"
    ],
    "figi p40": [
        "J9"
    ],
    "figi fse1020": [
        "J9"
    ],
    "omega q": [
        "H2"
    ],
    "x540": [
        "LA"
    ],
    "kingkong power": [
        "CB"
    ],
    "zte a7050": [
        "ZT"
    ],
    "zte 8046": [
        "ZT"
    ],
    "v30t": [
        "DO"
    ],
    "v30": [
        "DO"
    ],
    "nokia_xplus": [
        "NK"
    ],
    "nokia xr21": [
        "NK"
    ],
    "nokia xr20 5g": [
        "NK"
    ],
    "nokia c2 2nd edition": [
        "NK"
    ],
    "motorola edge plus (2022)": [
        "MR"
    ],
    "htc desire 21 pro 5g": [
        "HT"
    ],
    "htc desire 628 dual sim": [
        "HT"
    ],
    "htc desire 728 dual sim": [
        "HT"
    ],
    "htc desire 728g dual sim": [
        "HT"
    ],
    "htc desire 828 dual sim": [
        "HT"
    ],
    "htc desire 830 dual sim": [
        "HT"
    ],
    "pgem10": [
        "OP"
    ],
    "a181_plus": [
        "I4"
    ],
    "mna-lx9": [
        "HU"
    ],
    "alt-l29": [
        "HU"
    ],
    "galaxy a72": [
        "SA"
    ],
    "mao-lx9n": [
        "HU"
    ],
    "lex725": [
        "L1"
    ],
    "cph2527": [
        "OP"
    ],
    "enjoy 20 se": [
        "HU"
    ],
    "v2239a": [
        "VV"
    ],
    "tecno ck7n": [
        "TB"
    ],
    "impress_intouch_3g": [
        "VX"
    ],
    "poco f5": [
        "0P"
    ],
    "poco f5 pro": [
        "0P"
    ],
    "lna-al00": [
        "HU"
    ],
    "23026rn54g": [
        "XI"
    ],
    "itel it1655": [
        "IZ"
    ],
    "redmi 10 power": [
        "XI"
    ],
    "galaxy s21 ultra": [
        "SA"
    ],
    "galaxy s21": [
        "SA"
    ],
    "galaxy s10": [
        "SA"
    ],
    "galaxy s20": [
        "SA"
    ],
    "galaxy s20+": [
        "SA"
    ],
    "galaxy a52": [
        "SA"
    ],
    "galaxy s10e": [
        "SA"
    ],
    "zte 9046": [
        "ZT"
    ],
    "galaxy s7 edge": [
        "SA"
    ],
    "finepowerc5": [
        "F1"
    ],
    "finepowerc1": [
        "F1"
    ],
    "eluga ray max": [
        "PA"
    ],
    "pixavi phone": [
        "BAR"
    ],
    "galaxy s20 ultra": [
        "SA"
    ],
    "sm-s911u1": [
        "SA"
    ],
    "sm-a346b": [
        "SA"
    ],
    "samsung sm-a346b": [
        "SA"
    ],
    "vtl-202201": [
        "VE"
    ],
    "22111317pi": [
        "0P"
    ],
    "blade a7 2019": [
        "ZT"
    ],
    "pgt-an20": [
        "HNR"
    ],
    "f101": [
        "FOS",
        "NAN"
    ],
    "coolpad f101": [
        "CO"
    ],
    "x-treme_pq18": [
        "1S"
    ],
    "i005da": [
        "AU"
    ],
    "anb-an00": [
        "HNR"
    ],
    "yal-l61": [
        "HU"
    ],
    "sttm21vapp": [
        "SH"
    ],
    "stg-al00": [
        "HU"
    ],
    "sm-a5460": [
        "SA"
    ],
    "ila r1": [
        "I7"
    ],
    "lna-lx9": [
        "HU"
    ],
    "x-style_s3502": [
        "1S"
    ],
    "xiaomi 13 lite": [
        "XI"
    ],
    "hg11": [
        "HD"
    ],
    "tecno_kf6n": [
        "TB"
    ],
    "vna-lx3": [
        "HNR"
    ],
    "lio-tn00": [
        "HU"
    ],
    "nokia c02": [
        "NK"
    ],
    "jack": [
        "MJ"
    ],
    "mao-lx9": [
        "HU"
    ],
    "ltk-lx3": [
        "HU"
    ],
    "sm-g991r4": [
        "SA"
    ],
    "vna-l29": [
        "HU"
    ],
    "hongmi 4a": [
        "XI"
    ],
    "asus_ai2203_b": [
        "AU"
    ],
    "k9 pro": [
        "OE"
    ],
    "v2254a": [
        "VV"
    ],
    "iqoo u3": [
        "VV"
    ],
    "blade l8": [
        "ZT"
    ],
    "htc one e9plus dual sim": [
        "HT"
    ],
    "studio m4 plus": [
        "BU"
    ],
    "studio x9 hd": [
        "BU"
    ],
    "studio view": [
        "BU"
    ],
    "studio mega lte": [
        "BU"
    ],
    "qmobile evok power": [
        "QM"
    ],
    "qmobile evok power lite": [
        "QM"
    ],
    "elite y": [
        "L5"
    ],
    "rmx3615": [
        "RE"
    ],
    "2304fpn6dg": [
        "XI"
    ],
    "2304fpn6dc": [
        "XI"
    ],
    "z5158": [
        "ZT"
    ],
    "iqoo neo 5 lite": [
        "VV"
    ],
    "v2301a": [
        "VV"
    ],
    "x-max": [
        "H1"
    ],
    "spicemi-520n": [
        "SP"
    ],
    "spice mi-526n": [
        "SP"
    ],
    "spicemi441": [
        "SP"
    ],
    "spicemi-509": [
        "SP"
    ],
    "spice mi-551": [
        "SP"
    ],
    "spice mi-549": [
        "SP"
    ],
    "spice mi-526": [
        "SP"
    ],
    "spice mi-518": [
        "SP"
    ],
    "spice mi-514": [
        "SP"
    ],
    "spice mi-513": [
        "SP"
    ],
    "spice mi-507": [
        "SP"
    ],
    "spice mi-506": [
        "SP"
    ],
    "spice mi-431": [
        "SP"
    ],
    "spice mi-359": [
        "SP"
    ],
    "sunny ss01": [
        "5Y",
        "WI"
    ],
    "sunny s52d": [
        "5Y",
        "WI"
    ],
    "m5i": [
        "HV"
    ],
    "m55c": [
        "E9"
    ],
    "m55b": [
        "E9"
    ],
    "m55a": [
        "E9"
    ],
    "m520": [
        "SM1"
    ],
    "m504": [
        "P6"
    ],
    "m5 plus": [
        "GI",
        "HV"
    ],
    "m5 mini": [
        "GI"
    ],
    "m2mini": [
        "GI"
    ],
    "a898 duo": [
        "MY"
    ],
    "vetas v9": [
        "VET"
    ],
    "vetas v10": [
        "VET",
        "WCP"
    ],
    "intex aqua power iv": [
        "IX"
    ],
    "itel a20": [
        "IZ"
    ],
    "itel a42 plus": [
        "IZ"
    ],
    "itel a43": [
        "IZ"
    ],
    "itel p31": [
        "IZ"
    ],
    "itel p51": [
        "IZ"
    ],
    "itel p41": [
        "IZ"
    ],
    "m762g": [
        "C3"
    ],
    "m700": [
        "SM1"
    ],
    "m8414": [
        "MOV"
    ],
    "m8415": [
        "MOV"
    ],
    "m8416": [
        "MOV"
    ],
    "m8418": [
        "MOV"
    ],
    "m8601": [
        "MOV"
    ],
    "m9103": [
        "MOV"
    ],
    "m9101b": [
        "MOV"
    ],
    "m9101a": [
        "MOV"
    ],
    "mint virgo": [
        "MIN"
    ],
    "mint_orion": [
        "MIN"
    ],
    "more_3": [
        "13"
    ],
    "echo prism": [
        "E4"
    ],
    "echo_studio": [
        "E4"
    ],
    "eko omega q55": [
        "EK"
    ],
    "eko star lte g60": [
        "EK"
    ],
    "eko omega lte q60": [
        "EK"
    ],
    "eks s45u": [
        "EM"
    ],
    "elitedual": [
        "0W"
    ],
    "enia": [
        "XCL"
    ],
    "epic": [
        "HR"
    ],
    "epic t": [
        "YE",
        "HR"
    ],
    "eros plus": [
        "72"
    ],
    "eros power": [
        "72"
    ],
    "fire 4": [
        "I5"
    ],
    "fire 4 pro": [
        "I5"
    ],
    "fire 4 plus": [
        "I5"
    ],
    "fun plus": [
        "FT"
    ],
    "f_plus": [
        "FLU"
    ],
    "itel a13plus": [
        "IZ"
    ],
    "itel a31plus": [
        "IZ"
    ],
    "itel a31": [
        "IZ"
    ],
    "23053rn02a": [
        "XI"
    ],
    "asus_ai2205_c": [
        "AU"
    ],
    "rmx3741": [
        "RE"
    ],
    "v2283a": [
        "VV"
    ],
    "2305epcc4g": [
        "0P"
    ],
    "bravis a504": [
        "BV"
    ],
    "infinix x669": [
        "IF"
    ],
    "23053rn02y": [
        "XI"
    ],
    "v2247": [
        "VV"
    ],
    "rmx3771": [
        "RE"
    ],
    "itel p662ln": [
        "IZ"
    ],
    "22127pc95i": [
        "0P"
    ],
    "22122rk93c": [
        "XI"
    ],
    "kingkong 9": [
        "CB"
    ],
    "ultramintt x5": [
        "OM"
    ],
    "zte v880h": [
        "ZT"
    ],
    "itel p662l": [
        "IZ"
    ],
    "vivo u20": [
        "VV"
    ],
    "tecno ki8": [
        "TB"
    ],
    "crt-nx1": [
        "HNR"
    ],
    "goa-lx9": [
        "HU"
    ],
    "xiaomi civi 1s": [
        "XI"
    ],
    "stg-lx1": [
        "HU"
    ],
    "mar-l21meb": [
        "HU"
    ],
    "tecno ck8n": [
        "TB"
    ],
    "joe": [
        "MJ"
    ],
    "bl8000": [
        "B2"
    ],
    "zte blade a53 pro": [
        "ZT"
    ],
    "via x30 plus": [
        "R4"
    ],
    "rmx3660": [
        "RE"
    ],
    "vne-an40": [
        "HNR"
    ],
    "rx17neo": [
        "OP"
    ],
    "sm-a526t": [
        "SA"
    ],
    "r15 dream mirror": [
        "OP"
    ],
    "reno6 5g": [
        "OP"
    ],
    "nova 6 5g": [
        "HU"
    ],
    "primo f7s": [
        "WA"
    ],
    "find x3 lite": [
        "OP"
    ],
    "l38043": [
        "LE"
    ],
    "tecno mobile ch9n": [
        "TB"
    ],
    "itel s662lcn": [
        "IZ"
    ],
    "goa-al80": [
        "HU"
    ],
    "tecno ck6n": [
        "TB"
    ],
    "sm-a546u": [
        "SA"
    ],
    "wp21 ultra": [
        "OE"
    ],
    "wp22": [
        "OE"
    ],
    "wp23": [
        "OE"
    ],
    "tecno ck9n": [
        "TB"
    ],
    "tank2": [
        "UZ"
    ],
    "find x3 pro": [
        "OP"
    ],
    "philips w6610": [
        "PH"
    ],
    "mi 8lite": [
        "XI"
    ],
    "sh60_23230": [
        "FPS"
    ],
    "redmi 12": [
        "XI"
    ],
    "iqoo neo 3": [
        "VV"
    ],
    "angela-l02b": [
        "HU"
    ],
    "crt-an00": [
        "HNR"
    ],
    "mna-al00": [
        "HU"
    ],
    "aura sleek 4g": [
        "KA"
    ],
    "m1912g7bc": [
        "XI"
    ],
    "jad-al80": [
        "HU"
    ],
    "iqoo neo 5s": [
        "VV"
    ],
    "22120rn86i": [
        "XI"
    ],
    "zte ba521": [
        "ZT"
    ],
    "zte blade c370": [
        "ZT"
    ],
    "sm-a716t": [
        "SA"
    ],
    "sm-a516t": [
        "SA"
    ],
    "fig-l11": [
        "HU"
    ],
    "r9 plustm a": [
        "OP"
    ],
    "b2017g": [
        "ZT"
    ],
    "ixion e345": [
        "DX"
    ],
    "santin gp-50": [
        "SQ"
    ],
    "oppo f19 pro": [
        "OP"
    ],
    "mga-al40": [
        "HU"
    ],
    "onc": [
        "XI"
    ],
    "nx679s": [
        "57"
    ],
    "solid_4g1": [
        "B2"
    ],
    "rmx3617": [
        "RE"
    ],
    "ds-x1": [
        "DCO"
    ],
    "tecno bf7h": [
        "TB"
    ],
    "tecno mobile bf7n": [
        "TB"
    ],
    "v2249": [
        "VV"
    ],
    "bv5300 pro": [
        "B2"
    ],
    "cph2493": [
        "ON",
        "OP"
    ],
    "rmx3760": [
        "RE"
    ],
    "23076rn4bi": [
        "XI"
    ],
    "sp65_66440": [
        "FPS"
    ],
    "pgfm10": [
        "OP"
    ],
    "hlte556n": [
        "HI"
    ],
    "wod-lx1": [
        "HNR",
        "HU"
    ],
    "rep-an00": [
        "HNR"
    ],
    "v2253": [
        "VV"
    ],
    "cph2577": [
        "OP"
    ],
    "motorola edge 40 pro": [
        "MR"
    ],
    "itel a662lm": [
        "IZ"
    ],
    "wdy-lx1": [
        "HNR",
        "HU"
    ],
    "foa-lx9": [
        "HU"
    ],
    "sa50_21620": [
        "FPS"
    ],
    "php110": [
        "ON"
    ],
    "cph2565": [
        "OP"
    ],
    "phantom6s": [
        "TB"
    ],
    "mascom ws517": [
        "MA1"
    ],
    "cph2419": [
        "ON",
        "OP"
    ],
    "fero a4001 plus": [
        "F7"
    ],
    "itel p682lp": [
        "IZ"
    ],
    "nx712j": [
        "57"
    ],
    "cph2531": [
        "OP"
    ],
    "ali-an00": [
        "HNR"
    ],
    "armor 21": [
        "UL"
    ],
    "itel a507lsp": [
        "IZ"
    ],
    "tecno-l5": [
        "TB"
    ],
    "tecno mobile ki5q": [
        "TB"
    ],
    "itel a14s": [
        "IZ"
    ],
    "rmo-nx3": [
        "HNR"
    ],
    "s100pro": [
        "DO"
    ],
    "polytron r2507": [
        "P5"
    ],
    "zte 8140n": [
        "ZT"
    ],
    "t431u": [
        "TC"
    ],
    "conquest-s23": [
        "4C"
    ],
    "lava lzx409": [
        "LV"
    ],
    "neon ray ultra": [
        "X1",
        "JG"
    ],
    "xs12 pro": [
        "8S"
    ],
    "xiaomi 13 pro": [
        "XI"
    ],
    "tecno s1": [
        "TB"
    ],
    "v2229": [
        "VV"
    ],
    "rmx3830": [
        "RE"
    ],
    "rmx3740": [
        "RE"
    ],
    "samsung sm-m546b": [
        "SA"
    ],
    "sparx neo 7 pro": [
        "SPX"
    ],
    "sparx neo 7": [
        "SPX"
    ],
    "samsung sm-a546w": [
        "SA"
    ],
    "redmi 10x lte": [
        "XI"
    ],
    "new 22": [
        "V6"
    ],
    "walton primo x5": [
        "WA"
    ],
    "itel s665ln": [
        "IZ"
    ],
    "sparx neo 7 ultra": [
        "SPX"
    ],
    "takee 1": [
        "6E"
    ],
    "rea-nx9": [
        "HNR"
    ],
    "reno5 k 5g": [
        "OP"
    ],
    "base_varia": [
        "BAS"
    ],
    "agora lite": [
        "KG"
    ],
    "agora 4g pro": [
        "KG"
    ],
    "ckk inspire 1": [
        "CKK"
    ],
    "ckk garnet": [
        "CKK"
    ],
    "v2302": [
        "VV"
    ],
    "infinix x6835": [
        "IF"
    ],
    "explosion": [
        "H2"
    ],
    "v2254": [
        "VV"
    ],
    "r15 neo": [
        "OP"
    ],
    "asus_ai2205_d": [
        "AU"
    ],
    "v2238": [
        "VV"
    ],
    "sm-a546u1": [
        "SA"
    ],
    "avvio_793": [
        "AV"
    ],
    "smart 4g m1": [
        "11"
    ],
    "honor play 4t pro": [
        "HU"
    ],
    "sm-a146m": [
        "SA"
    ],
    "meo smart a40": [
        "ZT"
    ],
    "link55": [
        "KW"
    ],
    "slide2": [
        "WI"
    ],
    "sm-a236m": [
        "SA"
    ],
    "p13 blue max 128 gb 2022": [
        "RD"
    ],
    "vx20 pro": [
        "4M"
    ],
    "x20 pro": [
        "CB"
    ],
    "htc desire 526g dual sim": [
        "HT"
    ],
    "monaco": [
        "LQ"
    ],
    "apollo": [
        "VR"
    ],
    "q-502": [
        "1L"
    ],
    "htc desire 600 dual sim": [
        "HT"
    ],
    "smarta35": [
        "ZT"
    ],
    "c1_max": [
        "EL"
    ],
    "23053rn02l": [
        "XI"
    ],
    "moto g14": [
        "MR"
    ],
    "sm-a346m": [
        "SA"
    ],
    "sm-a145m": [
        "SA"
    ],
    "sm-j600gt": [
        "SA"
    ],
    "vx4": [
        "VP",
        "LG"
    ],
    "k700": [
        "SPU"
    ],
    "amz-l29": [
        "HU"
    ],
    "wiam #71": [
        "WL"
    ],
    "dream": [
        "TR"
    ],
    "lenovo k51c78": [
        "LE"
    ],
    "lenovo s90-u": [
        "LE"
    ],
    "amoi n828": [
        "AO"
    ],
    "multilaser_g_max_2_se_64": [
        "1R"
    ],
    "sm-a047m": [
        "SA"
    ],
    "pixel 8 pro": [
        "GO"
    ],
    "a205kc": [
        "KY"
    ],
    "sog10": [
        "SO"
    ],
    "sc-53d": [
        "SA",
        "SU"
    ],
    "so-52d": [
        "SO"
    ],
    "sc-52d": [
        "SA",
        "SU"
    ],
    "sonyso-02e": [
        "SO"
    ],
    "rea-an00": [
        "HNR"
    ],
    "agt-an00": [
        "HNR"
    ],
    "sh-01d": [
        "SH"
    ],
    "multilaser_h_5g": [
        "1R"
    ],
    "23028rn4di": [
        "XI"
    ],
    "phw110": [
        "OP"
    ],
    "s6501l": [
        "NL"
    ],
    "cph2451": [
        "ON",
        "OP"
    ],
    "cph2491": [
        "ON",
        "OP"
    ],
    "cph2513": [
        "ON",
        "OP"
    ],
    "cph2515": [
        "ON",
        "OP"
    ],
    "cph2389": [
        "ON",
        "OP"
    ],
    "cph2519": [
        "OP"
    ],
    "cph2521": [
        "OP"
    ],
    "cph2523": [
        "OP"
    ],
    "a301op": [
        "OP"
    ],
    "cph2591": [
        "OP"
    ],
    "cph2525": [
        "OP"
    ],
    "cph2529": [
        "OP"
    ],
    "cph2551": [
        "ON",
        "OP"
    ],
    "cph2569": [
        "ON",
        "OP"
    ],
    "cph2579": [
        "OP"
    ],
    "pjc110": [
        "OP"
    ],
    "phv110": [
        "OP"
    ],
    "scg21": [
        "SA"
    ],
    "v3": [
        "W2"
    ],
    "vivo v3": [
        "VV"
    ],
    "f-10d": [
        "FU"
    ],
    "f-04e": [
        "FU"
    ],
    "f-12d": [
        "FU"
    ],
    "cyber 13 pro": [
        "HV"
    ],
    "zte blade a33+": [
        "ZT"
    ],
    "23078pnd5g": [
        "XI"
    ],
    "tecno ad11": [
        "TB"
    ],
    "lava lxx503": [
        "LV"
    ],
    "ge2ae": [
        "GO"
    ],
    "xq-dq72": [
        "SO"
    ],
    "infinix x6739": [
        "IF"
    ],
    "xq-dc72": [
        "SO"
    ],
    "panasonic t45 4g": [
        "PA"
    ],
    "asus_ai2302": [
        "AU"
    ],
    "2306epn60g": [
        "XI"
    ],
    "mobicel_r6": [
        "4M"
    ],
    "nova lite3plus": [
        "HU"
    ],
    "nova 5t pro": [
        "HU"
    ],
    "v2250": [
        "VV"
    ],
    "zte_blade_l130ru": [
        "ZT"
    ],
    "tecno_ca7": [
        "TB"
    ],
    "zte_blade_a0620": [
        "ZT"
    ],
    "e5051": [
        "1P"
    ],
    "e5018": [
        "BI"
    ],
    "e435 plus": [
        "HN"
    ],
    "dsr_r8": [
        "CH"
    ],
    "dsr_r7p": [
        "CH"
    ],
    "dsr_r7": [
        "CH"
    ],
    "dunns slinger": [
        "UD"
    ],
    "duke8": [
        "CKK"
    ],
    "duke 3": [
        "CKK"
    ],
    "duke   ii": [
        "CKK"
    ],
    "dopod 7p": [
        "DP"
    ],
    "lt c1300": [
        "QL"
    ],
    "qin3ultra": [
        "XI"
    ],
    "dl5003ql": [
        "DD"
    ],
    "dl5503ql": [
        "DD"
    ],
    "cynus f7": [
        "MB"
    ],
    "cynus e6": [
        "MB"
    ],
    "cynus e4": [
        "MB"
    ],
    "cynus e10": [
        "MB"
    ],
    "cubix cube 3": [
        "CH"
    ],
    "dash_jr_3g": [
        "BU"
    ],
    "dagger dg550": [
        "DO"
    ],
    "cynus t8": [
        "MB"
    ],
    "itel a32f": [
        "IZ"
    ],
    "beeline smart 5": [
        "B5"
    ],
    "y100x": [
        "DO"
    ],
    "getnord-onyx": [
        "GNO"
    ],
    "onida_i4g1": [
        "OIN"
    ],
    "qsmart rocket": [
        "QM"
    ],
    "digit4g e3 pro": [
        "DIG"
    ],
    "qmobile i6 metal 2018": [
        "QM"
    ],
    "digit4g e2 pro": [
        "DIG"
    ],
    "gn5001s": [
        "GI"
    ],
    "sparx neo 5 plus": [
        "SPX"
    ],
    "2310fpca4g": [
        "0P"
    ],
    "23106rn0da": [
        "XI"
    ],
    "23078rkd5c": [
        "XI"
    ],
    "23053rn02i": [
        "XI"
    ],
    "2305003m": [
        "FEY"
    ],
    "blade l210": [
        "ZT"
    ],
    "blade l210ru": [
        "ZT"
    ],
    "via x30": [
        "R4"
    ],
    "ver-an10": [
        "HNR"
    ],
    "ver-an00": [
        "HNR"
    ],
    "wtattrw2": [
        "6A"
    ],
    "itel s681ln": [
        "IZ"
    ],
    "motorola edge 40": [
        "MR"
    ],
    "23127pn0cc": [
        "XI"
    ],
    "23116pn5bc": [
        "XI"
    ],
    "g0dzq": [
        "GO"
    ],
    "g1mnw": [
        "GO"
    ],
    "g82u8": [
        "GO"
    ],
    "g9bqd": [
        "GO"
    ],
    "mzb0e6din": [
        "0P"
    ],
    "v2320": [
        "VV"
    ],
    "v2317": [
        "VV"
    ],
    "v2310": [
        "VV"
    ],
    "wdy-an00": [
        "HNR"
    ],
    "tecno bg6": [
        "TB"
    ],
    "air1 ultra pro": [
        "5F"
    ],
    "zte blade a53": [
        "ZT"
    ],
    "redmi k30s": [
        "XI"
    ],
    "redmi k30 pro zoom": [
        "XI"
    ],
    "redmi k20pro": [
        "XI"
    ],
    "wp28": [
        "OE"
    ],
    "wp27": [
        "OE"
    ],
    "wp26": [
        "OE"
    ],
    "wp23 pro": [
        "OE"
    ],
    "cyber x pro": [
        "HV"
    ],
    "kingkong star": [
        "CB"
    ],
    "infinix x6731b": [
        "IF"
    ],
    "infinix x6731": [
        "IF"
    ],
    "rp08": [
        "UM"
    ],
    "rmx3823": [
        "RE"
    ],
    "rmx3770": [
        "RE"
    ],
    "rmx3619": [
        "RE"
    ],
    "motorola edge 40 neo": [
        "MR"
    ],
    "pixel 8": [
        "GO"
    ],
    "motorola razr 40": [
        "MR"
    ],
    "motorola razr 40 ultra": [
        "MR"
    ],
    "nubia 8150n": [
        "57"
    ],
    "sm-s711b": [
        "SA"
    ],
    "moto g84 5g": [
        "MR"
    ],
    "moto g54 5g": [
        "MR"
    ],
    "v31gt": [
        "DO"
    ],
    "v2304a": [
        "VV"
    ],
    "v2302a": [
        "VV"
    ],
    "v2282a": [
        "VV"
    ],
    "v2279a": [
        "VV"
    ],
    "v2322": [
        "VV"
    ],
    "v2314a": [
        "VV"
    ],
    "v2313a": [
        "VV"
    ],
    "v2278a": [
        "VV"
    ],
    "v2271a": [
        "VV"
    ],
    "v2270a": [
        "VV"
    ],
    "v2248": [
        "VV"
    ],
    "v2245a": [
        "VV"
    ],
    "mi 11x pro": [
        "XI"
    ],
    "mi 11x": [
        "XI"
    ],
    "alp-l29s": [
        "HU"
    ],
    "moto g53y 5g": [
        "MR"
    ],
    "tecno mobile ki7": [
        "TB"
    ],
    "xq-de72": [
        "SO"
    ],
    "sm-s236dl": [
        "SA"
    ],
    "sm-s146vl": [
        "SA"
    ],
    "sm-m346b1": [
        "SA"
    ],
    "sm-m346b": [
        "SA"
    ],
    "sm-a055f": [
        "SA"
    ],
    "rmx3820": [
        "RE"
    ],
    "rmx3636": [
        "RE"
    ],
    "rmx3624_natv_vf": [
        "RE"
    ],
    "power armor x11": [
        "UL"
    ],
    "sm-a057f": [
        "SA"
    ],
    "sm-a146u1": [
        "SA"
    ],
    "sm-a146w": [
        "SA"
    ],
    "sm-a245n": [
        "SA"
    ],
    "sm-a3460": [
        "SA"
    ],
    "sm-a346n": [
        "SA"
    ],
    "nx713j": [
        "57"
    ],
    "jelly star": [
        "UZ"
    ],
    "i2217": [
        "VV"
    ],
    "e940-2849-00": [
        "GS"
    ],
    "cyber x": [
        "HV"
    ],
    "asus_ai2205_a": [
        "AU"
    ],
    "23077rabdc": [
        "XI"
    ],
    "23076rn8dy": [
        "XI"
    ],
    "23046pnc9c": [
        "XI"
    ],
    "hammer_iron_4": [
        "HAM"
    ],
    "hammer_blade_4": [
        "HAM"
    ],
    "220733spi": [
        "0P"
    ],
    "220733sph": [
        "0P"
    ],
    "220733sh": [
        "XI"
    ],
    "20220728mt": [
        "SLF"
    ],
    "23049pcd8i": [
        "0P"
    ],
    "2302epcc4i": [
        "0P"
    ],
    "23028rncai": [
        "XI"
    ],
    "bv5300": [
        "B2"
    ],
    "b135dl": [
        "BU"
    ],
    "ae9120": [
        "2X"
    ],
    "ae9220": [
        "2X"
    ],
    "ae9240": [
        "2X"
    ],
    "ae9150": [
        "2X"
    ],
    "ae9260": [
        "2X"
    ],
    "i2212": [
        "VV"
    ],
    "gwkk3": [
        "GO"
    ],
    "gp4bc": [
        "GO"
    ],
    "gkws6": [
        "GO"
    ],
    "gc3ve": [
        "GO"
    ],
    "zte blade a54": [
        "ZT"
    ],
    "zte a2023": [
        "ZT"
    ],
    "zte 9050n": [
        "ZT"
    ],
    "xq-dc54": [
        "SO"
    ],
    "z992": [
        "ZT"
    ],
    "dialogtabpro": [
        "DG"
    ],
    "dialog q178": [
        "DG"
    ],
    "home9": [
        "63"
    ],
    "superb_plus": [
        "I5"
    ],
    "eda52": [
        "WH"
    ],
    "superb": [
        "I5"
    ],
    "lg-e987": [
        "LG"
    ],
    "lgas323": [
        "LG"
    ],
    "energy phone neo": [
        "E1"
    ],
    "snap_pro": [
        "NAS"
    ],
    "a350 tv": [
        "EX"
    ],
    "s554020": [
        "FLU"
    ],
    "shine 12t": [
        "AA",
        "J0"
    ],
    "shine 12": [
        "AA",
        "J0"
    ],
    "new 12": [
        "V6"
    ],
    "new 15": [
        "V6"
    ],
    "orbit y50": [
        "WA"
    ],
    "orbit y21": [
        "WA"
    ],
    "neo_6": [
        "SPX"
    ],
    "neo 5": [
        "SPX"
    ],
    "lava lzx407": [
        "LV"
    ],
    "force f15": [
        "NOV"
    ],
    "force g20": [
        "NOV"
    ],
    "fri-nx9": [
        "HNR"
    ],
    "diamond pro max": [
        "7I"
    ],
    "ali-nx1": [
        "HNR"
    ],
    "23076pc4bi": [
        "0P"
    ],
    "2306004m": [
        "FEY"
    ],
    "2312fpca6g": [
        "0P"
    ],
    "ihunt fit runner": [
        "IH"
    ],
    "nitro n62": [
        "MW"
    ],
    "mx-a10r": [
        "MW"
    ],
    "magno c2": [
        "ZU"
    ],
    "celero5g": [
        "DQ"
    ],
    "celero5g+": [
        "DQ"
    ],
    "digit infinity": [
        "DIG"
    ],
    "digit infinity max": [
        "DIG",
        "13"
    ],
    "digit glory1": [
        "DIG"
    ],
    "digit4g energy max": [
        "DIG",
        "E1"
    ],
    "aligator_s6100": [
        "4A"
    ],
    "sm-a057m": [
        "SA"
    ],
    "sm-a055m": [
        "SA"
    ],
    "sm-a137fn": [
        "SA"
    ],
    "sm-s7110": [
        "SA"
    ],
    "symphony z60": [
        "SM"
    ],
    "unia62_s01": [
        "UZ"
    ],
    "volla phone 22": [
        "VOP"
    ],
    "volla phone x23": [
        "VOP"
    ],
    "nu65": [
        "IPL"
    ],
    "23108rn04y": [
        "XI"
    ],
    "lava be_u": [
        "LV"
    ],
    "i2301": [
        "VV"
    ],
    "i2216": [
        "VV"
    ],
    "i2214": [
        "VV"
    ],
    "i2213": [
        "VV"
    ],
    "i2207": [
        "VV"
    ],
    "i2223": [
        "VV"
    ],
    "grace 9": [
        "MEM"
    ],
    "ds-cl3 pro": [
        "DCO"
    ],
    "ds-cl3 lite": [
        "DCO"
    ],
    "ds-bd3": [
        "DCO"
    ],
    "pjg110": [
        "OP"
    ],
    "pja110": [
        "ON"
    ],
    "phu110": [
        "OP"
    ],
    "phs110": [
        "OP"
    ],
    "pht110": [
        "OP"
    ],
    "n6000": [
        "B2"
    ],
    "a200 pro": [
        "B2"
    ],
    "v2307": [
        "VV"
    ],
    "v2303": [
        "VV"
    ],
    "sparx neo x": [
        "SPX"
    ],
    "miz-bd00": [
        "8X"
    ],
    "tecno_ki5m": [
        "TB"
    ],
    "n156dl": [
        "NK"
    ],
    "glk-lx3": [
        "HU"
    ],
    "v2244": [
        "VV"
    ],
    "v2312": [
        "VV"
    ],
    "v2324": [
        "VV"
    ],
    "v2325": [
        "VV"
    ],
    "infinix x6832": [
        "IF"
    ],
    "rmx3785": [
        "RE"
    ],
    "q5.8": [
        "UNQ"
    ],
    "space a5.8": [
        "UNQ"
    ],
    "ws054": [
        "WQ"
    ],
    "armadillo phone": [
        "PRA"
    ],
    "ttfone tt20": [
        "TTF"
    ],
    "core-z5": [
        "C1"
    ],
    "qrash": [
        "QA"
    ],
    "tagphone": [
        "7G"
    ],
    "corn_c4": [
        "4R"
    ],
    "safaricom et kimem": [
        "X1"
    ],
    "tesla_sp6_4_lite": [
        "C7"
    ],
    "ultramintt a6": [
        "OM"
    ],
    "ravoz v1": [
        "R9"
    ],
    "coolmintt a7": [
        "OM"
    ],
    "bullittgrouplimited s61": [
        "CA"
    ],
    "coolmintt x7": [
        "OM"
    ],
    "rmx3782": [
        "RE"
    ],
    "rmx3780": [
        "RE"
    ],
    "rmx3890": [
        "RE"
    ],
    "23100rn82l": [
        "XI"
    ],
    "ap6301": [
        "ATH"
    ],
    "ack2326": [
        "A0"
    ],
    "aprix c55": [
        "SIS"
    ],
    "astro 55t": [
        "MW"
    ],
    "bl63_tg07": [
        "BM"
    ],
    "c5 max": [
        "BU"
    ],
    "c5 plus": [
        "BU"
    ],
    "cp3636a": [
        "CO"
    ],
    "crt-nx3": [
        "HNR"
    ],
    "eabf22206a": [
        "6A"
    ],
    "ea500plus": [
        "UNT"
    ],
    "24069pc21i": [
        "0P"
    ],
    "l622": [
        "HN"
    ],
    "l604": [
        "HN"
    ],
    "g50": [
        "BU"
    ],
    "g61": [
        "BU"
    ],
    "g70": [
        "BU"
    ],
    "g71": [
        "BU"
    ],
    "g91": [
        "BU"
    ],
    "ms5514g": [
        "YM"
    ],
    "pl571us": [
        "PC"
    ],
    "5131a": [
        "TC"
    ],
    "5164a": [
        "TC"
    ],
    "5033tp": [
        "TC"
    ],
    "5133mp": [
        "TC"
    ],
    "chcnav": [
        "CHC"
    ],
    "allure a8 pro": [
        "C5"
    ],
    "elite_d55": [
        "SW"
    ],
    "enie e2": [
        "FRT"
    ],
    "ikosora+": [
        "6W"
    ],
    "vimoq p662lo": [
        "VIM"
    ],
    "vimoq a631lo": [
        "VIM"
    ],
    "vimoq s661ls": [
        "VIM"
    ],
    "ob_588": [
        "A5"
    ],
    "platinum_b4p": [
        "SW"
    ],
    "art 3s": [
        "YE"
    ],
    "quantum q30": [
        "QA"
    ],
    "smooth 6.0": [
        "HH"
    ],
    "u668ac": [
        "CK"
    ],
    "cm17xa_eea": [
        "C4"
    ],
    "siragon_sp_7200": [
        "31"
    ],
    "uni 10x": [
        "UNQ"
    ],
    "uni go": [
        "UNQ"
    ],
    "chw-lx3": [
        "HU"
    ],
    "frl-l21": [
        "HU"
    ],
    "element 5": [
        "KL"
    ],
    "airtel imagine": [
        "7U"
    ],
    "stylo rain": [
        "69"
    ],
    "elite n55max": [
        "SW"
    ],
    "bl53_tg06": [
        "BM"
    ],
    "ct45p": [
        "WH"
    ],
    "advannasapro": [
        "A9"
    ],
    "6065a": [
        "AL"
    ],
    "5003x": [
        "AL"
    ],
    "5131e": [
        "AL"
    ],
    "6002j": [
        "AL"
    ],
    "s6003l": [
        "NL"
    ],
    "v2252": [
        "VV"
    ],
    "v2239": [
        "VV"
    ],
    "v2230a": [
        "VV"
    ],
    "tmrv065g": [
        "TM"
    ],
    "t phone (2023)": [
        "TM"
    ],
    "x-treme pq55": [
        "1S"
    ],
    "xiaomi 14 pro": [
        "XI"
    ],
    "via m35": [
        "R4"
    ],
    "sparx s7": [
        "SPX"
    ],
    "sm-s135dl": [
        "SA"
    ],
    "sm-a336bn": [
        "SA"
    ],
    "sm-s711u": [
        "SA"
    ],
    "tiger 12": [
        "OSC"
    ],
    "zte 8550": [
        "ZT"
    ],
    "sky b63": [
        "SW"
    ],
    "nokia g42 5g": [
        "NK"
    ],
    "thinkphone by motorola": [
        "MR"
    ],
    "via m30 plus": [
        "R4"
    ],
    "honor magic 2 3d": [
        "HU"
    ],
    "samsung sm-a156b": [
        "SA"
    ],
    "infinix hot 3 lte": [
        "IF"
    ],
    "nova 6se": [
        "HU"
    ],
    "2311drk48g": [
        "0P"
    ],
    "shark 8": [
        "B2"
    ],
    "23129rn51x": [
        "XI"
    ],
    "honor play 8a": [
        "HU"
    ],
    "rmx3834": [
        "RE"
    ],
    "kingkong 8": [
        "CB"
    ],
    "pjs110": [
        "OP"
    ],
    "phn110": [
        "OP"
    ],
    "tiger 10": [
        "OSC"
    ],
    "rmx3762": [
        "RE"
    ],
    "sl112a": [
        "6A"
    ],
    "sl112c": [
        "CK"
    ],
    "xanon x20": [
        "WA"
    ],
    "mzb8257in": [
        "XI"
    ],
    "omix.x5": [
        "QQ"
    ],
    "noh-an80": [
        "HU"
    ],
    "lava lex402": [
        "LV",
        "L1"
    ],
    "lt_9701": [
        "QL"
    ],
    "23122pcd1g": [
        "0P"
    ],
    "2311drn14i": [
        "XI"
    ],
    "poco c65": [
        "0P"
    ],
    "pgt-n09": [
        "HNR"
    ],
    "tmrv06p5g": [
        "TM"
    ],
    "wp32": [
        "OE"
    ],
    "wp30 pro": [
        "OE"
    ],
    "wp33 pro": [
        "OE"
    ],
    "wp19 pro": [
        "OE"
    ],
    "24031pn0dc": [
        "XI"
    ],
    "23127pn0cg": [
        "XI"
    ],
    "23117rk66c": [
        "XI"
    ],
    "asus_ai2401_d": [
        "AU"
    ],
    "asus_ai2401_c": [
        "AU"
    ],
    "realme 8": [
        "RE"
    ],
    "rmx3888": [
        "RE"
    ],
    "rmx3842": [
        "RE"
    ],
    "rmx3840": [
        "RE"
    ],
    "rmx3701": [
        "RE"
    ],
    "sm-a356e": [
        "SA"
    ],
    "sm-a556e": [
        "SA"
    ],
    "sm-a556b": [
        "SA"
    ],
    "sm-e546b": [
        "SA"
    ],
    "sm-a256b": [
        "SA"
    ],
    "sm-a2360": [
        "SA"
    ],
    "sm-a057g": [
        "SA"
    ],
    "samsung sm-s926b": [
        "SA"
    ],
    "sm-a156m": [
        "SA"
    ],
    "sm-a155m": [
        "SA"
    ],
    "sm-a155f": [
        "SA"
    ],
    "sm-a156u1": [
        "SA"
    ],
    "samsung sm-a356b": [
        "SA"
    ],
    "t phone pro (2023)": [
        "TM"
    ],
    "moto g24 power": [
        "MR"
    ],
    "moto g24": [
        "MR"
    ],
    "lmg820um1": [
        "LG"
    ],
    "i2304": [
        "VV"
    ],
    "i2220": [
        "VV"
    ],
    "nx769j": [
        "57"
    ],
    "nx721j": [
        "57"
    ],
    "v2236": [
        "VV"
    ],
    "v2234_pk": [
        "VV"
    ],
    "v2234": [
        "VV"
    ],
    "v2236a": [
        "VV"
    ],
    "via f30": [
        "R4"
    ],
    "poco x6 pro 5g": [
        "0P"
    ],
    "poco x6 5g": [
        "0P"
    ],
    "poco m6 pro": [
        "0P"
    ],
    "infinix x6528": [
        "IF"
    ],
    "infinix x6837": [
        "IF"
    ],
    "infinix x6525": [
        "IF"
    ],
    "infinix x6526": [
        "IF"
    ],
    "infinix x6525b": [
        "IF"
    ],
    "infinix x6826c": [
        "IF"
    ],
    "itel s665l": [
        "IZ"
    ],
    "itel a632w": [
        "IZ"
    ],
    "itel a507lv": [
        "IZ"
    ],
    "v2332": [
        "VV"
    ],
    "xiaomi 13t pro": [
        "XI"
    ],
    "rmx3750": [
        "RE"
    ],
    "rmx3867": [
        "RE"
    ],
    "asus_ai2202_c": [
        "AU"
    ],
    "ain065": [
        "NOT"
    ],
    "v2312a": [
        "VV"
    ],
    "tecno kj5": [
        "TB"
    ],
    "tecno kj5n": [
        "TB"
    ],
    "tecno ki7s": [
        "TB"
    ],
    "tecno ck8nb": [
        "TB"
    ],
    "tecno bg7n": [
        "TB"
    ],
    "tecno bg7": [
        "TB"
    ],
    "tecno mobile bg7n": [
        "TB"
    ],
    "tecno kj6": [
        "TB"
    ],
    "tecno bg6i": [
        "TB"
    ],
    "tecno bg6h": [
        "TB"
    ],
    "tronik_12s": [
        "4R"
    ],
    "2310fpca4i": [
        "0P"
    ],
    "23122pcd1i": [
        "0P"
    ],
    "23128pc33i": [
        "0P"
    ],
    "23124rn87i": [
        "XI"
    ],
    "coolmintt a8": [
        "OM"
    ],
    "2311drk48i": [
        "0P"
    ],
    "2311drk48c": [
        "XI"
    ],
    "23113rkc6c": [
        "XI"
    ],
    "v2331": [
        "VV"
    ],
    "poco c51": [
        "0P"
    ],
    "alpha a10": [
        "NOV"
    ],
    "ajib x1": [
        "AJI"
    ],
    "ajib l1": [
        "AJI"
    ],
    "u6080aa": [
        "6A"
    ],
    "ver-n49": [
        "HNR"
    ],
    "t610e": [
        "TC"
    ],
    "lly-an00": [
        "HNR",
        "HU"
    ],
    "lava lzx404": [
        "LV"
    ],
    "lava lxx504": [
        "LV"
    ],
    "buzz 4 ultra": [
        "AE"
    ],
    "buzz 4 note": [
        "AE"
    ],
    "cph2499": [
        "OP"
    ],
    "cph2585": [
        "ON",
        "OP"
    ],
    "iqoo u3x 5g": [
        "VV"
    ],
    "reno7 se": [
        "OP"
    ],
    "rmx3517": [
        "RE"
    ],
    "reno7 pro": [
        "OP"
    ],
    "reno7": [
        "OP"
    ],
    "reno6 z 5g": [
        "OP"
    ],
    "reno6 pro 5g": [
        "OP"
    ],
    "reno5 lite": [
        "OP"
    ],
    "reno5 a 5g": [
        "OP"
    ],
    "reno5 4g": [
        "OP"
    ],
    "ravoz z3 lite": [
        "R9"
    ],
    "primo ef10": [
        "WA"
    ],
    "pjj110": [
        "OP"
    ],
    "pje110": [
        "ON"
    ],
    "pjd110": [
        "ON"
    ],
    "phz110": [
        "OP"
    ],
    "phy110": [
        "OP"
    ],
    "v2344a": [
        "VV"
    ],
    "v2339a": [
        "VV"
    ],
    "v2338a": [
        "VV"
    ],
    "v2329a": [
        "VV"
    ],
    "v2324a": [
        "VV"
    ],
    "v2318": [
        "VV"
    ],
    "v2309a": [
        "VV"
    ],
    "v2307a": [
        "VV"
    ],
    "v2241ha": [
        "VV"
    ],
    "xiaomi 13": [
        "XI"
    ],
    "maa-an10": [
        "HNR"
    ],
    "meizu 21": [
        "M1"
    ],
    "hisense e50 lite 64gb": [
        "HI"
    ],
    "hisense u31": [
        "HI"
    ],
    "hisense v40i": [
        "HI"
    ],
    "maa-an00": [
        "HNR"
    ],
    "myphone n23": [
        "MY1"
    ],
    "smini": [
        "DO"
    ],
    "s19 max pro s zoom": [
        "RD"
    ],
    "s19 max pro s": [
        "RD"
    ],
    "tank mini 1": [
        "UZ"
    ],
    "tank 3": [
        "UZ"
    ],
    "wod-lx2": [
        "HNR"
    ],
    "wdy-lx2": [
        "HNR"
    ],
    "bvl-an16": [
        "HNR"
    ],
    "note 50": [
        "CB"
    ],
    "note 30": [
        "CB"
    ],
    "note 40": [
        "CB"
    ],
    "note 21": [
        "CB"
    ],
    "note 16 pro": [
        "UL"
    ],
    "mag-an00": [
        "HNR"
    ],
    "mp33": [
        "UM"
    ],
    "htc u23 pro": [
        "HT"
    ],
    "color 8": [
        "B2"
    ],
    "cph2557": [
        "OP"
    ],
    "alp-an00": [
        "HNR"
    ],
    "agm_note_n1": [
        "A3"
    ],
    "rbn-nx1": [
        "HNR"
    ],
    "mao-al00": [
        "HU"
    ],
    "gia-an80": [
        "HNR"
    ],
    "g702": [
        "GN"
    ],
    "alt-al10": [
        "HU"
    ],
    "alt-al00": [
        "HU"
    ],
    "aln-al80": [
        "HU"
    ],
    "aln-al10": [
        "HU"
    ],
    "aln-al00": [
        "HU"
    ],
    "pagraer p50 pro": [
        "PAG"
    ],
    "foa-al00": [
        "HU"
    ],
    "g52l": [
        "BU"
    ],
    "g316": [
        "GN"
    ],
    "gmc-7127m": [
        "8G"
    ],
    "gmc-668n": [
        "8G"
    ],
    "gmc-668m": [
        "8G"
    ],
    "fin-al60a": [
        "HU"
    ],
    "ada-al00u": [
        "HU"
    ],
    "ada-al00": [
        "HU"
    ],
    "ctr-al20": [
        "HU"
    ],
    "bal-al60": [
        "HU"
    ],
    "bon-al00": [
        "HU"
    ],
    "bra-al00": [
        "HU"
    ],
    "rky-an10": [
        "HNR"
    ],
    "studio mini 2023": [
        "BU"
    ],
    "g314": [
        "GN"
    ],
    "new 16": [
        "V6"
    ],
    "neo_6_plus": [
        "SPX"
    ],
    "neo 5 pro": [
        "SPX"
    ],
    "neo x": [
        "SPX"
    ],
    "pam524": [
        "C5"
    ],
    "ravoz v5": [
        "R9"
    ],
    "i85": [
        "SM"
    ],
    "x-style_s5502": [
        "1S"
    ],
    "i80": [
        "SM"
    ],
    "cph2611": [
        "ON",
        "OP"
    ],
    "cph2583": [
        "ON",
        "OP"
    ],
    "cph2603": [
        "OP"
    ],
    "cph2599": [
        "OP"
    ],
    "cph2581": [
        "ON",
        "OP"
    ],
    "cph2573": [
        "ON",
        "OP"
    ],
    "cph2617": [
        "OP"
    ],
    "cph2553": [
        "OP"
    ],
    "cph2048": [
        "OP"
    ],
    "covet x": [
        "ZU"
    ],
    "clever 3": [
        "AE"
    ],
    "city4": [
        "KW"
    ],
    "bold n2": [
        "BU"
    ],
    "clk-lx1": [
        "HNR"
    ],
    "play dash": [
        "18"
    ],
    "phicomm c6051": [
        "1P"
    ],
    "duke7": [
        "CKK"
    ],
    "doro_8020x": [
        "DR"
    ],
    "ccit xedition": [
        "CNT"
    ],
    "opsson ivo 6677": [
        "OO"
    ],
    "ccit 405": [
        "CNT"
    ],
    "a397i": [
        "LE"
    ],
    "j9l": [
        "BU"
    ],
    "j10": [
        "CB"
    ],
    "via m30": [
        "R4"
    ],
    "v2323a": [
        "VV"
    ],
    "v2334a": [
        "VV"
    ],
    "v2321": [
        "VV"
    ],
    "v2311": [
        "VV"
    ],
    "tecno kj7": [
        "TB"
    ],
    "v2285a": [
        "VV"
    ],
    "v2251": [
        "VV"
    ],
    "v2242": [
        "VV"
    ],
    "v2240": [
        "VV"
    ],
    "v2232a": [
        "VV"
    ],
    "v2225": [
        "VV"
    ],
    "24030pn60g": [
        "XI"
    ],
    "sh-51d": [
        "SH"
    ],
    "shg09": [
        "SH"
    ],
    "xig04": [
        "XI"
    ],
    "xq-dq44": [
        "SO"
    ],
    "a065": [
        "NOT"
    ],
    "a142": [
        "NOT"
    ],
    "tas-l09": [
        "HU"
    ],
    "tagphone advanced": [
        "7G"
    ],
    "c21 plus": [
        "OE"
    ],
    "cruise2": [
        "61"
    ],
    "h166": [
        "FPS"
    ],
    "g91s": [
        "BU"
    ],
    "b2 ultra": [
        "5F"
    ],
    "b2 pro": [
        "5F"
    ],
    "clk-lx2": [
        "HNR"
    ],
    "f101 pro": [
        "FOS"
    ],
    "f102": [
        "FOS"
    ],
    "sparx neo 7 ultra 8gb": [
        "SPX"
    ],
    "bv8900": [
        "B2"
    ],
    "elite power": [
        "0W"
    ],
    "speedo_1": [
        "0G"
    ],
    "mi9 lite": [
        "XI"
    ],
    "a100": [
        "B2"
    ],
    "v2342": [
        "VV"
    ],
    "v2327": [
        "VV"
    ],
    "wiko t10": [
        "WI"
    ],
    "qmobile z9": [
        "QM"
    ],
    "samsung sm-a127f": [
        "SA"
    ],
    "zte z10": [
        "ZT"
    ],
    "mi9se": [
        "XI"
    ],
    "redmi 13c": [
        "XI"
    ],
    "nokia g20": [
        "NK"
    ],
    "bluboo s1": [
        "B3"
    ],
    "qmobile j2": [
        "QM"
    ],
    "sparx neo 8 pro": [
        "SPX"
    ],
    "new 24": [
        "V6"
    ],
    "infinix x6528b": [
        "IF"
    ],
    "huawei tit-u02": [
        "HU"
    ],
    "samsung sm-a525f": [
        "SA"
    ],
    "nokia c12": [
        "NK"
    ],
    "bv6200 pro": [
        "B2"
    ],
    "sa55 2gb/16gb 2400mah gms": [
        "FPS"
    ],
    "p670": [
        "FPS"
    ],
    "c70": [
        "OSC"
    ],
    "c60": [
        "OSC"
    ],
    "n20": [
        "DO"
    ],
    "v20pro": [
        "DO"
    ],
    "maimang 9": [
        "HU"
    ],
    "p80": [
        "CB",
        "ANG"
    ],
    "sm-a156b": [
        "SA"
    ],
    "moto g04": [
        "MR"
    ],
    "bvl-an20": [
        "HNR"
    ],
    "tiger_x12": [
        "9W"
    ],
    "sm-a156e": [
        "SA"
    ],
    "zte 8050": [
        "ZT"
    ],
    "fgd-al00": [
        "HU"
    ],
    "iris fuel f1": [
        "LV"
    ],
    "panasonic_eluga_i3": [
        "PA"
    ],
    "polytron r2457": [
        "P5"
    ],
    "iqoo z1x 5g": [
        "VV"
    ],
    "r1 hd": [
        "BU"
    ],
    "p60": [
        "CB"
    ],
    "sparx neo 8 plus": [
        "SPX"
    ],
    "gtm_5v.5": [
        "GP"
    ],
    "sm-m236b": [
        "SA"
    ],
    "v2219": [
        "VV"
    ],
    "v2308": [
        "VV"
    ],
    "clk-an00": [
        "HNR"
    ],
    "mi max3pro": [
        "XI"
    ],
    "coolmintttribe": [
        "OM"
    ],
    "sm-s9210": [
        "SA"
    ],
    "sm-s921b": [
        "SA"
    ],
    "samsung sm-s921w": [
        "SA"
    ],
    "sm-s921u": [
        "SA"
    ],
    "sm-s921u1": [
        "SA"
    ],
    "sm-s921n": [
        "SA"
    ],
    "sm-s9280": [
        "SA"
    ],
    "sm-s928u1": [
        "SA"
    ],
    "sm-s928u": [
        "SA"
    ],
    "sm-s928n": [
        "SA"
    ],
    "sm-s928b": [
        "SA"
    ],
    "sm-s928w": [
        "SA"
    ],
    "sm-s928q": [
        "SA"
    ],
    "sm-s921q": [
        "SA"
    ],
    "ky-42c": [
        "KY"
    ],
    "sh65 2gb/32gb 4800mah gms": [
        "FPS",
        "SH"
    ],
    "oneplus a6000": [
        "ON"
    ],
    "sm-a426n": [
        "SA"
    ],
    "nokia c300": [
        "NK"
    ],
    "hd62": [
        "JW"
    ],
    "symphony g100": [
        "SM"
    ],
    "nokia g100": [
        "NK"
    ],
    "g100": [
        "GN"
    ],
    "infinix x6836": [
        "IF"
    ],
    "sm-a256e": [
        "SA"
    ],
    "sm-a145p": [
        "SA"
    ],
    "wileyfox swift 2 plus": [
        "WF"
    ],
    "s19 maxl 128gb": [
        "RD"
    ],
    "s19 max 32gb": [
        "RD"
    ],
    "itel p661n": [
        "IZ"
    ],
    "s19 max pro": [
        "RD"
    ],
    "x700": [
        "QQ"
    ],
    "pgt-an00": [
        "HNR",
        "HU"
    ],
    "sm-a526a": [
        "SA"
    ],
    "sm-s9260": [
        "SA"
    ],
    "shine 12 pro": [
        "AA",
        "J0"
    ],
    "bv4800": [
        "B2"
    ],
    "s51": [
        "DO"
    ],
    "5131g": [
        "TC"
    ],
    "novisea a10": [
        "NOS"
    ],
    "pju110": [
        "OP"
    ],
    "5g ug phone u23": [
        "ZT"
    ],
    "ul40": [
        "A0"
    ],
    "cuiud f7": [
        "CUI"
    ],
    "asus_i007d": [
        "AU"
    ],
    "a463bg": [
        "AL"
    ],
    "sm-s515dl": [
        "SA"
    ],
    "zte 7160n": [
        "ZT"
    ],
    "rmx3999": [
        "RE"
    ],
    "mi5x": [
        "XI"
    ],
    "v2230ea": [
        "VV"
    ],
    "tecno mobile kj7": [
        "TB"
    ],
    "xt2301-5": [
        "MR"
    ],
    "nokia c22": [
        "NK"
    ],
    "ds-cl2 lite": [
        "DCO"
    ],
    "zte 8150n": [
        "ZT"
    ],
    "zte 7060": [
        "ZT"
    ],
    "zte blade a33s": [
        "ZT"
    ],
    "zte blade a53+": [
        "ZT"
    ],
    "infinix x6817b": [
        "IF"
    ],
    "agm g2": [
        "A3"
    ],
    "nokia x10": [
        "NK"
    ],
    "bv8900 pro": [
        "B2"
    ],
    "bv9300 pro": [
        "B2"
    ],
    "agm_h6": [
        "A3"
    ],
    "sm-m115f": [
        "SA"
    ],
    "myphone jet": [
        "R3",
        "MY1"
    ],
    "mipo_m25": [
        "MIP"
    ],
    "mipo_m46_pro": [
        "MIP"
    ],
    "modern 8": [
        "OSC"
    ],
    "new 10": [
        "V6"
    ],
    "elite a63max": [
        "SW"
    ],
    "bold n3": [
        "BU"
    ],
    "sh-52d": [
        "SH"
    ],
    "dm-b50104": [
        "DAR"
    ],
    "flat 1c": [
        "OSC"
    ],
    "nexg n71": [
        "WA"
    ],
    "dct 90": [
        "DIJ"
    ],
    "ds-cl3": [
        "DCO"
    ],
    "bv6200": [
        "B2"
    ],
    "armor x12 pro": [
        "UL"
    ],
    "armor x13": [
        "UL"
    ],
    "armor 24": [
        "UL"
    ],
    "sl004t": [
        "KB"
    ],
    "armor 20wt": [
        "UL"
    ],
    "ds-bd2": [
        "DCO"
    ],
    "lt_6509": [
        "QL"
    ],
    "mp07": [
        "UM"
    ],
    "new 20": [
        "V6"
    ],
    "k9 pro 5g": [
        "OP",
        "OE"
    ],
    "k9s": [
        "OP"
    ],
    "k9x": [
        "OP"
    ],
    "ds-cl1": [
        "DCO"
    ],
    "mp09": [
        "UM"
    ],
    "mione pro plus": [
        "X7",
        "MO"
    ],
    "sm-a4260": [
        "SA"
    ],
    "goa-al80u": [
        "HU"
    ],
    "ulefone_s11": [
        "UL"
    ],
    "a303op": [
        "OP"
    ],
    "c5l 2021": [
        "BU"
    ],
    "c30 pro": [
        "OSC"
    ],
    "c31 pro": [
        "OE"
    ],
    "c31": [
        "OE"
    ],
    "f22": [
        "QIN"
    ],
    "gplus x10+": [
        "8G"
    ],
    "d61l": [
        "KK"
    ],
    "f21 pro": [
        "QIN"
    ],
    "f22 pro": [
        "QIN"
    ],
    "f22pro": [
        "QIN"
    ],
    "x-treme_pq18_max": [
        "1S"
    ],
    "nokia c21": [
        "NK"
    ],
    "nokia c30": [
        "NK"
    ],
    "orb s": [
        "R1"
    ],
    "ravoz z6 pro": [
        "R9"
    ],
    "oppo a33m": [
        "OP"
    ],
    "oppo_a33m": [
        "OP"
    ],
    "a727_infinity_pro": [
        "GV"
    ],
    "neffos c5": [
        "NF"
    ],
    "p5_energy": [
        "A2"
    ],
    "tit-l01": [
        "HU"
    ],
    "digiceldl1plus": [
        "D3"
    ],
    "sm-c5010": [
        "SA"
    ],
    "gar-an60": [
        "WI"
    ],
    "sh60 2gb/32gb 3000mah hms": [
        "FPS",
        "SH"
    ],
    "armor x12": [
        "UL"
    ],
    "sm-a908n": [
        "SA"
    ],
    "a1 alpha eco": [
        "41"
    ],
    "itel a663lc": [
        "IZ"
    ],
    "itel a665l": [
        "IZ"
    ],
    "itel a666l": [
        "IZ"
    ],
    "itel a666ln": [
        "IZ"
    ],
    "itel p663ln": [
        "IZ"
    ],
    "lava lxx506": [
        "LV"
    ],
    "mp27": [
        "UM"
    ],
    "mp34": [
        "UM"
    ],
    "nokia c210": [
        "NK"
    ],
    "nokia g310 5g": [
        "NK"
    ],
    "nokia g50": [
        "NK"
    ],
    "tecno ck6": [
        "TB"
    ],
    "via a40": [
        "R4"
    ],
    "via_x40": [
        "R4"
    ],
    "vocal v1": [
        "VOC"
    ],
    "v30pro": [
        "DO"
    ],
    "v20s": [
        "DO"
    ],
    "zte blade a34": [
        "ZT"
    ],
    "xsmart nova 7": [
        "XSM"
    ],
    "xig03": [
        "XI"
    ],
    "v2272a": [
        "VV"
    ],
    "v2318a": [
        "VV"
    ],
    "aligator rx850": [
        "4A"
    ],
    "move 10": [
        "KE"
    ],
    "go1": [
        "YE"
    ],
    "go2": [
        "YE"
    ],
    "le000z93p": [
        "LV"
    ],
    "logic x57a": [
        "1L"
    ],
    "mobigo2l": [
        "6W"
    ],
    "rcareno5011619": [
        "RC"
    ],
    "helio 30": [
        "SM"
    ],
    "go 3": [
        "YE"
    ],
    "smooth note 6.8": [
        "HH"
    ],
    "mintt m3": [
        "OM"
    ],
    "vp005": [
        "UW"
    ],
    "stg h10": [
        "GQ"
    ],
    "eskimo_k5001": [
        "RTK"
    ],
    "primo r9": [
        "WA"
    ],
    "ms5424g": [
        "YM"
    ],
    "in_2c": [
        "MI"
    ],
    "iku x3": [
        "8I"
    ],
    "alpha 9v": [
        "LA"
    ],
    "bl40_mv12": [
        "BM"
    ],
    "bl60 pro": [
        "BM"
    ],
    "bl61": [
        "BM"
    ],
    "bl62": [
        "BM"
    ],
    "i2302": [
        "VV"
    ],
    "comio c1": [
        "C6"
    ],
    "cph2607": [
        "OP"
    ],
    "cph2609": [
        "ON",
        "OP"
    ],
    "nokia c32": [
        "NK"
    ],
    "mp29": [
        "UM"
    ],
    "realme x7 max 5g": [
        "RE"
    ],
    "xq-dq54": [
        "SO"
    ],
    "v2309": [
        "VV"
    ],
    "nokia c3": [
        "NK"
    ],
    "cph1821ex": [
        "OP"
    ],
    "htc_d628u": [
        "HT"
    ],
    "v1936tl": [
        "VV"
    ],
    "ctr-l81": [
        "HU"
    ],
    "z5x 712": [
        "VV"
    ],
    "life one x3": [
        "BU"
    ],
    "yal-tl50": [
        "HU"
    ],
    "b1550vl": [
        "BU"
    ],
    "wp36": [
        "OE"
    ],
    "i2219": [
        "VV"
    ],
    "pjf110": [
        "ON"
    ],
    "pjh110": [
        "OP"
    ],
    "itel p665l": [
        "IZ"
    ],
    "bvl-n49": [
        "HNR"
    ],
    "xt2323-3": [
        "MR"
    ],
    "buzz 4pro": [
        "AE"
    ],
    "flow 10": [
        "KE"
    ],
    "lava lzx414": [
        "LV"
    ],
    "lava lxx508": [
        "LV"
    ],
    "lava lxx505": [
        "LV"
    ],
    "voto v2": [
        "V1"
    ],
    "a170": [
        "I4"
    ],
    "a171": [
        "I4"
    ],
    "a180": [
        "I4"
    ],
    "gionee m15": [
        "GI"
    ],
    "g71 plus": [
        "BU"
    ],
    "i 618 app plus+": [
        "IN3"
    ],
    "iplus p3": [
        "IPL"
    ],
    "live 10s": [
        "KE"
    ],
    "sf04 4g": [
        "BP"
    ],
    "wiko t50": [
        "WI"
    ],
    "cp12": [
        "CO"
    ],
    "k16": [
        "OE"
    ],
    "ihunt s24 ultra": [
        "IH"
    ],
    "ihunt s23 ultra": [
        "IH"
    ],
    "hammer iron v": [
        "HAM"
    ],
    "le link": [
        "LM"
    ],
    "p11000 pro": [
        "IH"
    ],
    "rmx3751": [
        "RE"
    ],
    "vortex cm62": [
        "JW"
    ],
    "vortex hd65 choice": [
        "JW"
    ],
    "v2315": [
        "VV"
    ],
    "e940-2796-00": [
        "GS"
    ],
    "e940-2878-03": [
        "GS"
    ],
    "edge 20 pro": [
        "SPX"
    ],
    "e940-2766-00": [
        "GS"
    ],
    "e940-2797-00": [
        "GS"
    ],
    "ds-cl2": [
        "DCO"
    ],
    "innova10": [
        "SM"
    ],
    "lt 2003": [
        "QL"
    ],
    "hppl60a": [
        "U8"
    ],
    "nexg n6": [
        "WA"
    ],
    "nexg n70": [
        "WA"
    ],
    "nokia c200": [
        "NK"
    ],
    "power_armor14_pro": [
        "UL"
    ],
    "power armor 16s": [
        "UL"
    ],
    "s41 max": [
        "DO"
    ],
    "s41 plus": [
        "DO"
    ],
    "moto g34 5g": [
        "MR"
    ],
    "s19 max pro s edge": [
        "RD"
    ],
    "celero3 5g": [
        "DQ"
    ],
    "digitnext_ultra": [
        "DIG"
    ],
    "digit4g_e4_pro": [
        "DIG"
    ],
    "nokia c1": [
        "NK"
    ],
    "fin-al60": [
        "HU"
    ],
    "zte 7531n": [
        "ZT"
    ],
    "cha-al80": [
        "HU"
    ],
    "bal-al80": [
        "HU"
    ],
    "tecno cl6": [
        "TB"
    ],
    "rmx3843": [
        "RE"
    ],
    "rmx3868": [
        "RE"
    ],
    "rmx3998": [
        "RE"
    ],
    "scg20": [
        "SA"
    ],
    "meizu 20": [
        "M1"
    ],
    "meizu 20 pro": [
        "M1"
    ],
    "bvl-an00": [
        "HNR"
    ],
    "asus_ai2401_h": [
        "AU"
    ],
    "kingkong_ax": [
        "CB"
    ],
    "lly-nx1": [
        "HNR"
    ],
    "23129rn51h": [
        "XI"
    ],
    "e5mini": [
        "EMR"
    ],
    "clk-lx3": [
        "HNR",
        "HU"
    ],
    "cg65": [
        "JW"
    ],
    "konka_i256": [
        "KO"
    ],
    "linq l10": [
        "QM"
    ],
    "linq x100": [
        "QM"
    ],
    "i-style 8.5": [
        "IO"
    ],
    "fuel f1 mini": [
        "LV"
    ],
    "evo-vx1": [
        "GOB"
    ],
    "nim-500q": [
        "NU"
    ],
    "my_star_18": [
        "OL"
    ],
    "bkl-l09s": [
        "HU"
    ],
    "bla-l29s": [
        "HU"
    ],
    "flare_selfie": [
        "CH"
    ],
    "mione xs max": [
        "X7",
        "MO"
    ],
    "mla-l12": [
        "HU"
    ],
    "lem-al00": [
        "HU"
    ],
    "buzz 4": [
        "AE"
    ],
    "buzz 4s": [
        "AE"
    ],
    "v2218": [
        "VV"
    ],
    "xq-cq62": [
        "SO"
    ],
    "xq-de54": [
        "SO"
    ],
    "xq-dq62": [
        "SO"
    ],
    "24053py09c": [
        "XI"
    ],
    "v2312ba": [
        "VV"
    ],
    "pot-lx2": [
        "HU"
    ],
    "twist 4 mini": [
        "PS"
    ],
    "ady-al00": [
        "HU"
    ],
    "gar-an00": [
        "WI"
    ],
    "rmx3841": [
        "RE"
    ],
    "bal-an20": [
        "WI"
    ],
    "atlas w": [
        "ZT"
    ],
    "stg-lx2": [
        "HU"
    ],
    "armor_c1w": [
        "KHI"
    ],
    "i003d": [
        "AU"
    ],
    "rmx3844": [
        "RE"
    ],
    "v2339": [
        "VV"
    ],
    "vca-an00": [
        "HNR",
        "HU"
    ],
    "rmx3852": [
        "RE"
    ],
    "xt2131-4": [
        "MR"
    ],
    "v2317a": [
        "VV"
    ],
    "v2284a": [
        "VV"
    ],
    "juliaqn-l21b": [
        "HU"
    ],
    "buzz 4lite": [
        "AE"
    ],
    "ga01180-us": [
        "GO"
    ],
    "tyh631m": [
        "U9"
    ],
    "rmx3512": [
        "RE"
    ],
    "n155dl": [
        "NK"
    ],
    "rmx3870": [
        "RE"
    ],
    "tecno mobile ci8n": [
        "TB"
    ],
    "buzz 4 prime": [
        "AE"
    ],
    "elite p55max": [
        "SW"
    ],
    "elite r55": [
        "SW"
    ],
    "s6512l": [
        "NL"
    ],
    "u680ac": [
        "CK"
    ],
    "sm-e156b": [
        "SA"
    ],
    "t607dl": [
        "TC"
    ],
    "f106 pro": [
        "FOS"
    ],
    "g025i": [
        "GO"
    ],
    "e940-2849-01": [
        "GS"
    ],
    "tecno mobile bg6": [
        "TB"
    ],
    "sm-s156v": [
        "SA"
    ],
    "rmx3618": [
        "RE"
    ],
    "hbp-al00": [
        "HU"
    ],
    "cph2439": [
        "OP"
    ],
    "orbit y70": [
        "WA"
    ],
    "cph2613": [
        "ON",
        "OP"
    ],
    "tecno cl9": [
        "TB"
    ],
    "2312bpc51h": [
        "0P"
    ],
    "pixel 8a": [
        "GO"
    ],
    "g020a": [
        "GO"
    ],
    "g020m": [
        "GO"
    ],
    "g020p": [
        "GO"
    ],
    "lava lzx411": [
        "LV"
    ],
    "lava lix402": [
        "LV"
    ],
    "origin_679": [
        "TN"
    ],
    "e7446": [
        "MI"
    ],
    "e7533": [
        "MI"
    ],
    "v2034": [
        "VV"
    ],
    "v2156fa": [
        "VV"
    ],
    "w-k521-ope": [
        "WI"
    ],
    "x63pro": [
        "XMO"
    ],
    "wave 6c": [
        "B2"
    ],
    "ghl1x": [
        "GO"
    ],
    "rmx3850": [
        "RE"
    ],
    "v2222": [
        "VV"
    ],
    "xq-de44": [
        "SO"
    ],
    "v2333": [
        "VV"
    ],
    "v2334": [
        "VV"
    ],
    "v2336": [
        "VV"
    ],
    "v2352a": [
        "VV"
    ],
    "redmi 12 5g": [
        "XI"
    ],
    "xiaomi 14 ultra": [
        "XI"
    ],
    "poco x4 gt pro": [
        "0P"
    ],
    "redmi k50 mercedes-amg f1 team": [
        "XI"
    ],
    "redmi k50 pro": [
        "XI"
    ],
    "redmi k50 ultra": [
        "XI"
    ],
    "redmi k60": [
        "XI"
    ],
    "redmi k60 pro": [
        "XI"
    ],
    "villaon v30": [
        "VI1"
    ],
    "n6001l": [
        "NL"
    ],
    "motorola razr plus 2023": [
        "MR"
    ],
    "motorola razr 2023": [
        "MR"
    ],
    "motorola edge 50 pro": [
        "MR"
    ],
    "motorola edge 2023": [
        "MR"
    ],
    "motorola edge plus 2023": [
        "MR"
    ],
    "s22 flip": [
        "CA"
    ],
    "revolution-x69k": [
        "NEX"
    ],
    "sm-a022m": [
        "SA"
    ],
    "nubia z17": [
        "57"
    ],
    "pjb110": [
        "OP"
    ],
    "lt-c3750": [
        "QL"
    ],
    "l79031": [
        "LE"
    ],
    "mnt-bd00": [
        "8X"
    ],
    "22120rn86c": [
        "XI"
    ],
    "sm-a8050": [
        "SA"
    ],
    "23124rn87g": [
        "XI"
    ],
    "hd65_ultra": [
        "JW"
    ],
    "itel s667ln": [
        "IZ"
    ],
    "itel s666ln": [
        "IZ"
    ],
    "itel a507lm": [
        "IZ"
    ],
    "itel a511lp": [
        "IZ"
    ],
    "itel s662lc": [
        "IZ"
    ],
    "luna v6": [
        "L9",
        "69"
    ],
    "tecno mobile bf6": [
        "TB"
    ],
    "wildfire e3 lite": [
        "HT"
    ],
    "23124rn87c": [
        "XI"
    ],
    "rmx3765": [
        "RE"
    ],
    "phf110": [
        "OP"
    ],
    "sh-m26": [
        "SH"
    ],
    "itel p683l": [
        "IZ"
    ],
    "itel a663l": [
        "IZ"
    ],
    "z60 plus": [
        "SM"
    ],
    "smartv22": [
        "VF"
    ],
    "sn304ae": [
        "CK"
    ],
    "sparx neo 7 plus": [
        "SPX"
    ],
    "jelly 2e": [
        "UZ"
    ],
    "sm-e346b": [
        "SA"
    ],
    "s19 max": [
        "RD"
    ],
    "sh-c06": [
        "SH"
    ],
    "n50s": [
        "DO"
    ],
    "mp26": [
        "UM"
    ],
    "v2319": [
        "VV"
    ],
    "t609dl": [
        "TC"
    ],
    "sm-a805f": [
        "SA"
    ],
    "w-k610-tvm": [
        "WI"
    ],
    "fri-an00": [
        "HNR",
        "HU"
    ],
    "note 23": [
        "CB"
    ],
    "note 24": [
        "CB"
    ],
    "cph2351": [
        "OP"
    ],
    "a151": [
        "I4"
    ],
    "moto g go": [
        "MR"
    ],
    "xiaomi 14 pro ti": [
        "XI"
    ],
    "xiaomi 13 ultra": [
        "XI"
    ],
    "lt_9902": [
        "QL"
    ],
    "t431q": [
        "TC"
    ],
    "a161_plus": [
        "I4"
    ],
    "p63l": [
        "PD"
    ],
    "f92 e 5g": [
        "BU"
    ],
    "dvk82 mercury": [
        "69"
    ],
    "blk-al00": [
        "HU"
    ],
    "y51a": [
        "VV"
    ],
    "xt2093dl": [
        "MR"
    ],
    "hisense e60": [
        "HI"
    ],
    "hisense u964": [
        "HI"
    ],
    "hbn-al10": [
        "HU"
    ],
    "xiaomi civi": [
        "XI"
    ],
    "xiaomi 12 pro dimensity": [
        "XI"
    ],
    "samsung sm-a015v": [
        "SA"
    ],
    "sm-m015f": [
        "SA"
    ],
    "meizu m10": [
        "M1"
    ],
    "weimei_neon2": [
        "WM"
    ],
    "2q55100": [
        "HT"
    ],
    "z00udh": [
        "AU"
    ],
    "iris x8s": [
        "LV"
    ],
    "ady-lx9": [
        "HU"
    ],
    "hbn-lx9": [
        "HU"
    ],
    "gravity 5.5 lte": [
        "MW"
    ],
    "v2352": [
        "VV"
    ],
    "rmx3910": [
        "RE"
    ],
    "y51 pk": [
        "VV"
    ],
    "fun +": [
        "FT"
    ],
    "zte blade l3": [
        "ZT"
    ],
    "bravo z11": [
        "23"
    ],
    "f100l": [
        "GI"
    ],
    "samsung sm-e225f": [
        "SA"
    ],
    "qmobile s2": [
        "QM"
    ],
    "glk-lx2": [
        "HU"
    ],
    "2404arn45a": [
        "XI"
    ],
    "vt8216": [
        "ENI"
    ],
    "sgh-t399": [
        "SA"
    ],
    "v2140a": [
        "VV"
    ],
    "22120rn86h": [
        "XI"
    ],
    "qmobile s9": [
        "QM"
    ],
    "v2406": [
        "VV"
    ],
    "poco f6 pro": [
        "0P"
    ],
    "cph2605": [
        "ON",
        "OP"
    ],
    "24048rn6cg": [
        "XI"
    ],
    "sm-a546v": [
        "SA"
    ],
    "sparx ultra 11": [
        "SPX"
    ],
    "grace 10": [
        "MEM"
    ],
    "24069pc21g": [
        "0P"
    ],
    "2404apc5fg": [
        "0P"
    ],
    "blackberry key2": [
        "RM"
    ],
    "blackberry motion": [
        "RM",
        "MR"
    ],
    "pixel 9 pro xl": [
        "GO"
    ],
    "pamr0008in": [
        "MR"
    ],
    "v2345": [
        "VV"
    ],
    "rmx3997": [
        "RE"
    ],
    "comio x1 note": [
        "C6"
    ],
    "rc609l": [
        "O5"
    ],
    "rc608l2": [
        "O5"
    ],
    "smart_ultimate_64": [
        "FS"
    ],
    "hbn-al80": [
        "HU"
    ],
    "hbp-lx9": [
        "HU"
    ],
    "itel p663l": [
        "IZ"
    ],
    "cp12p": [
        "CO"
    ],
    "armor 23 ultra": [
        "UL"
    ],
    "mp13": [
        "UM"
    ],
    "pjy110": [
        "OP"
    ],
    "asus_ai2401_a": [
        "AU"
    ],
    "smart_ultimate": [
        "FS"
    ],
    "xt2233-2": [
        "MR"
    ],
    "xt2225-1": [
        "MR"
    ],
    "xt-2201": [
        "MR"
    ],
    "z2352n": [
        "57"
    ],
    "zg65 pro": [
        "JW"
    ],
    "hmd pulse pro": [
        "HMD"
    ],
    "24040rn64y": [
        "XI"
    ],
    "2312frafdi": [
        "0P"
    ],
    "2312crnccl": [
        "XI"
    ],
    "23113rkc6g": [
        "0P"
    ],
    "v2337": [
        "VV"
    ],
    "v2366ga": [
        "VV"
    ],
    "v2324ha": [
        "VV"
    ],
    "v2412": [
        "VV"
    ],
    "motorola moto g8 power": [
        "MR"
    ],
    "infinix x6871": [
        "IF"
    ],
    "zte nubia z20": [
        "57",
        "ZT"
    ],
    "bl9000 pro": [
        "B2",
        "DO"
    ],
    "v2354a": [
        "VV"
    ],
    "tecno cl7": [
        "TB"
    ],
    "sm-m346b2": [
        "SA"
    ],
    "sm-c5560": [
        "SA"
    ],
    "sm-a5560": [
        "SA"
    ],
    "sm-a546s": [
        "SA"
    ],
    "sm-a155n": [
        "SA"
    ],
    "n55 pro": [
        "DO"
    ],
    "24069ra21c": [
        "XI"
    ],
    "sm-e146b": [
        "SA"
    ],
    "sm-g977p": [
        "SA"
    ],
    "conquest_s20": [
        "4C"
    ],
    "lava le9940_w": [
        "LV"
    ],
    "jkm-l03": [
        "HU"
    ],
    "23088pnd5r": [
        "XI"
    ],
    "2308011m": [
        "FEY"
    ],
    "gionee s11": [
        "GI"
    ],
    "gionee m7": [
        "GI"
    ],
    "gionee f6": [
        "GI"
    ],
    "qmobile xli": [
        "QM"
    ],
    "enjoy z 5g": [
        "HU"
    ],
    "enjoy 20 plus 5g": [
        "HU"
    ],
    "enjoy 20e helio p35": [
        "HU"
    ],
    "enjoy 20 5g": [
        "HU"
    ],
    "enjoy 10e": [
        "HU"
    ],
    "enjoy 20 pro 5g": [
        "HU"
    ],
    "rmx3993": [
        "RE"
    ],
    "sm-m446k": [
        "SA"
    ],
    "rmx3851": [
        "RE"
    ],
    "sm-g977u": [
        "SA"
    ],
    "origin_679_pro": [
        "TN"
    ],
    "u380ac": [
        "CK"
    ],
    "g61s": [
        "BU"
    ],
    "rmx3871": [
        "RE"
    ],
    "cyber 15": [
        "HV"
    ],
    "u6080ac": [
        "CK"
    ],
    "amico smartphone xs": [
        "BR"
    ],
    "rmx3853": [
        "RE"
    ],
    "rmx3939": [
        "RE"
    ],
    "poco f6": [
        "0P"
    ],
    "tank 2 pro": [
        "UZ"
    ],
    "v2069ba": [
        "VV"
    ],
    "v2327a": [
        "VV"
    ],
    "v2343a": [
        "VV"
    ],
    "pjv110": [
        "OP"
    ],
    "wp35": [
        "OE"
    ],
    "t phone 2": [
        "TM"
    ],
    "v2410": [
        "VV"
    ],
    "v2366ha": [
        "VV"
    ],
    "hmd pulse plus": [
        "HMD"
    ],
    "hmd pulse": [
        "HMD"
    ],
    "e7200": [
        "KY"
    ],
    "i2218": [
        "VV"
    ],
    "cph2631": [
        "OP"
    ],
    "cph2629": [
        "OP"
    ],
    "cph2625": [
        "OP"
    ],
    "a401xm": [
        "XI"
    ],
    "bvl-n59": [
        "HNR"
    ],
    "sm-s926w": [
        "SA"
    ],
    "sm-s926u": [
        "SA"
    ],
    "sm-s926u1": [
        "SA"
    ],
    "sm-s926n": [
        "SA"
    ],
    "sm-s926b": [
        "SA"
    ],
    "sm-s921w": [
        "SA"
    ],
    "sm-a156w": [
        "SA"
    ],
    "itel a667l": [
        "IZ"
    ],
    "zte axon 11 5g": [
        "ZT"
    ],
    "itel a513w": [
        "IZ"
    ],
    "itel a509wp": [
        "IZ"
    ],
    "itel a661wp": [
        "IZ"
    ],
    "aligator_s5550": [
        "4A"
    ],
    "pjr110": [
        "OP"
    ],
    "v2361a": [
        "VV"
    ],
    "mp38": [
        "UM"
    ],
    "v2339fa": [
        "VV"
    ],
    "zg55": [
        "JW"
    ],
    "z2356": [
        "ZT"
    ],
    "zte a2024h": [
        "ZT"
    ],
    "23116pn5bg": [
        "XI"
    ],
    "pilot 2": [
        "OSC"
    ],
    "tecno mobile kj6": [
        "TB"
    ],
    "tc27": [
        "PZ"
    ],
    "wp38": [
        "OE"
    ],
    "x30p": [
        "CB"
    ],
    "xp9900": [
        "OI"
    ],
    "ali-nx3": [
        "HNR",
        "HU"
    ],
    "pace a1": [
        "RHI"
    ],
    "rmx3783": [
        "RE"
    ],
    "bv8100": [
        "B2"
    ],
    "armor 26 ultra": [
        "UL"
    ],
    "armor 22": [
        "UL"
    ],
    "a302zt": [
        "ZT"
    ],
    "silver_max_pro_2": [
        "KL"
    ],
    "reno4 se 5g": [
        "OP"
    ],
    "inkosi_pro_4g": [
        "69"
    ],
    "g901": [
        "GN"
    ],
    "g53": [
        "BU"
    ],
    "core_x": [
        "XSM"
    ],
    "vipro s20": [
        "0V"
    ],
    "jdy-lx1": [
        "HNR"
    ],
    "eli-an00": [
        "HNR"
    ],
    "amico smartphone s+": [
        "BR"
    ],
    "tyh632m": [
        "U9"
    ],
    "be pro": [
        "UL"
    ],
    "bloom2": [
        "WI"
    ],
    "hero 10": [
        "B2"
    ],
    "2000_000170_00": [
        "REP"
    ],
    "five pro": [
        "LM"
    ],
    "kl605": [
        "0K"
    ],
    "sm-a908b": [
        "SA"
    ],
    "solar pro": [
        "LM"
    ],
    "iqoo 8": [
        "VV"
    ],
    "iqoo 8 pro": [
        "VV"
    ],
    "i6 metal hd": [
        "QM"
    ],
    "sne-l01": [
        "HU"
    ],
    "rbn-nx3": [
        "HNR",
        "HU"
    ],
    "vodafone pro 4g": [
        "VF"
    ],
    "hero h5": [
        "BC"
    ],
    "hero h7": [
        "BC"
    ],
    "halo2 lte": [
        "I5"
    ],
    "haixu v11": [
        "XHU"
    ],
    "zte a2023h": [
        "ZT"
    ],
    "zte 9042n": [
        "ZT"
    ],
    "sup-bd00": [
        "8X"
    ],
    "twist 5 max": [
        "PS"
    ],
    "gfy-al00": [
        "HU"
    ],
    "ane-l23": [
        "HU"
    ],
    "sm-a707w": [
        "SA"
    ],
    "pe-cl00": [
        "HU"
    ],
    "sm-a606y": [
        "SA"
    ],
    "p780": [
        "95"
    ],
    "orbit m20": [
        "WA"
    ],
    "digni-smart": [
        "6E"
    ],
    "ae9230": [
        "2X"
    ],
    "a30_plus": [
        "A2"
    ],
    "raptor ltd": [
        "5F"
    ],
    "k12": [
        "OE"
    ],
    "s95": [
        "DO"
    ],
    "elite g63": [
        "SW"
    ],
    "dk10": [
        "DO"
    ],
    "clk-nx1": [
        "HNR"
    ],
    "a52 pro": [
        "B2"
    ],
    "air2 ultra": [
        "5F"
    ],
    "s200m": [
        "IP"
    ],
    "doro liberto 825": [
        "DR"
    ],
    "doro 8030": [
        "DR"
    ],
    "hisense e70": [
        "HI"
    ],
    "ihunt titan p15000 ultra": [
        "IH",
        "UZ"
    ],
    "clk-nx2": [
        "HNR"
    ],
    "drive 10": [
        "KE"
    ],
    "rmx3576": [
        "RE"
    ],
    "koz-al00cm": [
        "HNR",
        "HU"
    ],
    "m1903c3gi": [
        "XI"
    ],
    "m1912g7be": [
        "XI"
    ],
    "m1903f10i": [
        "XI"
    ],
    "m1810f6li": [
        "XI"
    ],
    "poco m6": [
        "0P"
    ],
    "stylo sonic": [
        "69"
    ],
    "hisense u70 pro": [
        "HI"
    ],
    "jdy-an00": [
        "HNR"
    ],
    "xt2141-1": [
        "MR"
    ],
    "chp2219": [
        "OP"
    ],
    "xt2131dl": [
        "MR"
    ],
    "ae9310": [
        "2X"
    ],
    "xt2321-3": [
        "MR"
    ],
    "xt2251-1": [
        "MR"
    ],
    "xt2171-2": [
        "MR"
    ],
    "xt2169-1": [
        "MR"
    ],
    "xt2129-2": [
        "MR"
    ],
    "xt2127-2": [
        "MR"
    ],
    "xt2093-3": [
        "MR"
    ],
    "xt2093-7": [
        "MR"
    ],
    "xt2335-2": [
        "MR"
    ],
    "xt2315-1": [
        "MR"
    ],
    "xt2083-9": [
        "MR"
    ],
    "xt2115-1": [
        "MR"
    ],
    "xt2129-1": [
        "MR"
    ],
    "xt2221-1": [
        "MR"
    ],
    "xt2215-1": [
        "MR"
    ],
    "xt2303-2": [
        "MR"
    ],
    "xt2131-1": [
        "MR"
    ],
    "xt2091-8": [
        "LE"
    ],
    "xt2129-3": [
        "LE",
        "MR"
    ],
    "panb0015in": [
        "MR"
    ],
    "pamr0010in": [
        "MR"
    ],
    "pamr0002in": [
        "MR"
    ],
    "panv0009in": [
        "MR"
    ],
    "md-ph-001": [
        "MOD"
    ],
    "m1908c3kg": [
        "XI"
    ],
    "m1904f3bg": [
        "XI"
    ],
    "lunar pro": [
        "LM"
    ],
    "villaon v6751l": [
        "VI1"
    ],
    "2qc9200": [
        "HT"
    ],
    "xt2201-1": [
        "MR"
    ],
    "xt2113-2": [
        "MR"
    ],
    "23076ra4br": [
        "XI"
    ],
    "mzb9965in": [
        "0P"
    ],
    "mzb8743in": [
        "0P"
    ],
    "mzb8458in": [
        "XI"
    ],
    "mzb8255in": [
        "XI"
    ],
    "mzb0a5hin": [
        "XI"
    ],
    "mzb07z4in": [
        "0P"
    ],
    "mzb07z3in": [
        "0P"
    ],
    "mzb07z1in": [
        "0P"
    ],
    "m2004j11g": [
        "0P"
    ],
    "iqoo z1": [
        "VV"
    ],
    "iqoo 5 pro": [
        "VV"
    ],
    "iqoo 5": [
        "VV"
    ],
    "eve-lx3": [
        "HU"
    ],
    "bne-lx3": [
        "HU"
    ],
    "xq-ec72": [
        "SO"
    ],
    "v2353a": [
        "VV"
    ],
    "t phone 2 pro": [
        "TM"
    ],
    "tmrv075g": [
        "TM"
    ],
    "tmrv07p5g": [
        "TM"
    ],
    "m1908c3kh": [
        "XI"
    ],
    "m1908c3ig": [
        "XI"
    ],
    "m1908c3ic": [
        "XI"
    ],
    "m1903c3gg": [
        "XI"
    ],
    "m1903c3ei": [
        "XI"
    ],
    "m1805e10a": [
        "XI"
    ],
    "mzb07z2in": [
        "0P"
    ],
    "tyh641m": [
        "U9"
    ],
    "digi r2": [
        "D4"
    ],
    "y9plus": [
        "DO"
    ],
    "doro 8030/8031/8028": [
        "DR"
    ],
    "desay tl1266": [
        "DS"
    ],
    "zh-cn": [
        "DS"
    ],
    "desayts518": [
        "DS"
    ],
    "desay ts808": [
        "DS"
    ],
    "desay_ts908_cmcc": [
        "DS"
    ],
    "datang s11": [
        "DT"
    ],
    "datang s18": [
        "DT"
    ],
    "datang-datang-s18i": [
        "DT"
    ],
    "datang s62l": [
        "DT"
    ],
    "doov_d2": [
        "DV"
    ],
    "doov-doov_d300": [
        "DV"
    ],
    "doov d350": [
        "DV"
    ],
    "doov d8": [
        "DV"
    ],
    "doov s1": [
        "DV"
    ],
    "doov s2y": [
        "DV"
    ],
    "doov t60": [
        "DV"
    ],
    "dewalt md501": [
        "DW"
    ],
    "al140": [
        "DX"
    ],
    "al240": [
        "DX"
    ],
    "b340": [
        "DX"
    ],
    "b450": [
        "DX"
    ],
    "bl150": [
        "DX"
    ],
    "bl250": [
        "DX"
    ],
    "bs150": [
        "DX"
    ],
    "bs155": [
        "DX"
    ],
    "bs160": [
        "DX"
    ],
    "bs250": [
        "DX"
    ],
    "bs550": [
        "DX"
    ],
    "bs650": [
        "DX"
    ],
    "ixion_es255": [
        "DX"
    ],
    "ixion es350": [
        "DX"
    ],
    "ixion es950": [
        "DX"
    ],
    "ixion m340": [
        "DX"
    ],
    "ixion ml250": [
        "DX"
    ],
    "ml450": [
        "DX"
    ],
    "ms550": [
        "DX"
    ],
    "ms650": [
        "DX"
    ],
    "senior": [
        "DX"
    ],
    "heyou1": [
        "E2"
    ],
    "heyou3": [
        "E2"
    ],
    "heyou5": [
        "E2"
    ],
    "wooze_i5": [
        "E2"
    ],
    "wooze_i55": [
        "E2"
    ],
    "wooze_l": [
        "E2"
    ],
    "wooze_xl": [
        "E2"
    ],
    "m4magic": [
        "E3"
    ],
    "evolio_m5pro": [
        "E3"
    ],
    "evolio_m6": [
        "E3"
    ],
    "evolio s4 cobalt": [
        "E3"
    ],
    "evolio_s5": [
        "E3"
    ],
    "evolio x10": [
        "E3"
    ],
    "echo_dune": [
        "E4"
    ],
    "echo_holi": [
        "E4"
    ],
    "echo_horizon_lite": [
        "E4"
    ],
    "horizon_m": [
        "E4"
    ],
    "echo java": [
        "E4"
    ],
    "echo_max": [
        "E4"
    ],
    "echo moss": [
        "E4"
    ],
    "echo_note": [
        "E4"
    ],
    "echo power": [
        "E4"
    ],
    "echo smart": [
        "E4"
    ],
    "echo_smart_4g": [
        "E4"
    ],
    "rock x9+": [
        "E5"
    ],
    "hawk_from_ee": [
        "E6"
    ],
    "ergo a500 best": [
        "E7"
    ],
    "ergo_a500_best": [
        "E7"
    ],
    "a502_aurum": [
        "E7"
    ],
    "a503 optima": [
        "E7"
    ],
    "a503-optima": [
        "E7"
    ],
    "ergo_a550_maxx": [
        "E7"
    ],
    "ergo a550 maxx": [
        "E7"
    ],
    "a551 sky 4g": [
        "E7"
    ],
    "a555 universe": [
        "E7"
    ],
    "ergo_a556": [
        "E7"
    ],
    "ergo b500 first": [
        "E7"
    ],
    "b502 basic": [
        "E7"
    ],
    "b504_unit": [
        "E7"
    ],
    "b505_unit_4g": [
        "E7"
    ],
    "b506_intro": [
        "E7"
    ],
    "ergo f500": [
        "E7"
    ],
    "ergo f501": [
        "E7"
    ],
    "f501_magic": [
        "E7"
    ],
    "ergo f502": [
        "E7"
    ],
    "force f500": [
        "E7"
    ],
    "prime b400": [
        "E7"
    ],
    "v540_level": [
        "E7"
    ],
    "v550_vision": [
        "E7"
    ],
    "v551 aura": [
        "E7"
    ],
    "v570_big_ben": [
        "E7"
    ],
    "e-tel_i250": [
        "E8"
    ],
    "evercoss a65": [
        "E9"
    ],
    "evercoss_a74a": [
        "E9"
    ],
    "a75a*": [
        "E9"
    ],
    "evercoss a7b": [
        "E9"
    ],
    "evercoss a7l": [
        "E9"
    ],
    "evercoss a7r": [
        "E9"
    ],
    "evercoss a7z": [
        "E9"
    ],
    "m50 star": [
        "E9"
    ],
    "u50a_plus": [
        "E9"
    ],
    "ebest s10": [
        "EA"
    ],
    "t3482": [
        "EA"
    ],
    "ebest t7": [
        "EA"
    ],
    "ebest_u1": [
        "EA"
    ],
    "ebest w70": [
        "EA"
    ],
    "eclipse_g400m": [
        "EB"
    ],
    "eclipse_g500": [
        "EB"
    ],
    "energy400": [
        "ED",
        "E1"
    ],
    "energy 400 lte": [
        "ED",
        "E1"
    ],
    "energy 400s": [
        "ED",
        "E1"
    ],
    "energy_500_lte": [
        "ED",
        "E1"
    ],
    "energy e520 lte": [
        "ED",
        "E1"
    ],
    "energy s500": [
        "ED",
        "E1"
    ],
    "energy s600": [
        "ED",
        "E1"
    ],
    "powermaxp490": [
        "ED"
    ],
    "ph-1": [
        "EE"
    ],
    "eko omega q47": [
        "EK"
    ],
    "eko omega q50": [
        "EK"
    ],
    "eko omega q57": [
        "EK"
    ],
    "elephone-p10c": [
        "EL"
    ],
    "elephone p2000": [
        "EL"
    ],
    "elephone-p2000": [
        "EL"
    ],
    "elephone_p3000s-64bit": [
        "EL"
    ],
    "elephone p5000": [
        "EL"
    ],
    "p6000": [
        "EL"
    ],
    "elephone p6000": [
        "EL"
    ],
    "elephone p6000 02": [
        "EL"
    ],
    "p6000plus": [
        "EL"
    ],
    "p6000+": [
        "EL"
    ],
    "p6000 pro": [
        "EL"
    ],
    "elephone p8000": [
        "EL"
    ],
    "elephone s2": [
        "EL"
    ],
    "elephone trunk": [
        "EL"
    ],
    "s5ls": [
        "EM"
    ],
    "x4uplus": [
        "EM"
    ],
    "eton-d510": [
        "EN"
    ],
    "eton i12": [
        "EN"
    ],
    "eton i6": [
        "EN"
    ],
    "eton i95": [
        "EN"
    ],
    "eton p1": [
        "EN"
    ],
    "eton p3": [
        "EN"
    ],
    "eton-t730d": [
        "EN"
    ],
    "eton t860": [
        "EN"
    ],
    "eton t890": [
        "EN"
    ],
    "evolveo strongphone g2": [
        "EO"
    ],
    "evolveo strongphone g4": [
        "EO"
    ],
    "evolveo strongphone g8": [
        "EO"
    ],
    "evolveo_strongphone_q8_lte": [
        "EO"
    ],
    "evolveo_xtraphone_4.5_q4": [
        "EO"
    ],
    "easyphone ep5": [
        "EP"
    ],
    "onyx-1s": [
        "EU"
    ],
    "onyx-3s": [
        "EU"
    ],
    "everclassic": [
        "EV"
    ],
    "everglory": [
        "EV"
    ],
    "evermagic": [
        "EV"
    ],
    "evermellow d45": [
        "EV"
    ],
    "evermellow d50": [
        "EV"
    ],
    "evermiracle": [
        "EV"
    ],
    "evermiracle nano": [
        "EV"
    ],
    "evershine": [
        "EV"
    ],
    "eversmart": [
        "EV"
    ],
    "everstar": [
        "EV"
    ],
    "evertrendy": [
        "EV"
    ],
    "senwa s605": [
        "EW"
    ],
    "s5018": [
        "EW"
    ],
    "s471": [
        "EW"
    ],
    "s905tl": [
        "EW"
    ],
    "s615": [
        "EW"
    ],
    "s-715": [
        "EW"
    ],
    "s725": [
        "EW"
    ],
    "s915": [
        "EW"
    ],
    "v705b": [
        "EW"
    ],
    "atlant": [
        "EX"
    ],
    "rioplay": [
        "EX"
    ],
    "finepower c1": [
        "F1"
    ],
    "finepower c2": [
        "F1"
    ],
    "finepower c3": [
        "F1"
    ],
    "finepower c4": [
        "F1"
    ],
    "finepower c5": [
        "F1"
    ],
    "finepower_c6": [
        "F1"
    ],
    "finepower d1": [
        "F1"
    ],
    "finepower d3": [
        "F1"
    ],
    "forme a37": [
        "F2"
    ],
    "forme_f520": [
        "F2"
    ],
    "forme r7s": [
        "F2"
    ],
    "aurii_f8_premium": [
        "F3"
    ],
    "aurii_force": [
        "F3"
    ],
    "aurii_fusion": [
        "F3"
    ],
    "aurii passion": [
        "F3"
    ],
    "aurii secret lite": [
        "F3"
    ],
    "aurii virtuoso": [
        "F3"
    ],
    "aurii_xcite": [
        "F3"
    ],
    "royale_x2": [
        "F7"
    ],
    "fero_y1": [
        "F7"
    ],
    "fp1": [
        "FA"
    ],
    "fp1u": [
        "FA"
    ],
    "fp2": [
        "FA"
    ],
    "fondi-d66": [
        "FD"
    ],
    "t602b": [
        "FD"
    ],
    "t702": [
        "FD"
    ],
    "atrium ii f55l2": [
        "FI"
    ],
    "epic f50g": [
        "FI",
        "HR"
    ],
    "f55l": [
        "FI"
    ],
    "gravity x55l": [
        "FI"
    ],
    "orion m50l": [
        "FI"
    ],
    "ultra m50g": [
        "FI"
    ],
    "trio f40lt": [
        "FI"
    ],
    "m405b": [
        "FI"
    ],
    "m405b_8gb": [
        "FI"
    ],
    "virtue3": [
        "FI"
    ],
    "iq448": [
        "FL"
    ],
    "fs502": [
        "FL"
    ],
    "fs517": [
        "FL"
    ],
    "fs516": [
        "FL"
    ],
    "fs518": [
        "FL"
    ],
    "fs522": [
        "FL"
    ],
    "fs523": [
        "FL"
    ],
    "fs504": [
        "FL"
    ],
    "fs506": [
        "FL"
    ],
    "fs507": [
        "FL"
    ],
    "fs508": [
        "FL"
    ],
    "fs511": [
        "FL"
    ],
    "fs514": [
        "FL"
    ],
    "fs553": [
        "FL"
    ],
    "iq4412 quad": [
        "FL"
    ],
    "fs403": [
        "FL"
    ],
    "iq444": [
        "FL"
    ],
    "iq444 quattro": [
        "FL"
    ],
    "iq237": [
        "FL"
    ],
    "iq452 quad": [
        "FL"
    ],
    "iq440": [
        "FL"
    ],
    "iq4411": [
        "FL"
    ],
    "iq4403": [
        "FL"
    ],
    "iq4401": [
        "FL"
    ],
    "iq447": [
        "FL"
    ],
    "iq456": [
        "FL"
    ],
    "iq4409 quad": [
        "FL"
    ],
    "iq432": [
        "FL"
    ],
    "fly iq436": [
        "FL"
    ],
    "iq4490": [
        "FL"
    ],
    "iq434": [
        "FL"
    ],
    "iq436i": [
        "FL"
    ],
    "iq4415 quad": [
        "FL"
    ],
    "iq4413_quad": [
        "FL"
    ],
    "iq4504 quad": [
        "FL"
    ],
    "iq454": [
        "FL"
    ],
    "iq430": [
        "FL"
    ],
    "iq270 firebird": [
        "FL"
    ],
    "iq270": [
        "FL"
    ],
    "fly_iq445": [
        "FL"
    ],
    "iq431": [
        "FL"
    ],
    "fly_iq450": [
        "FL"
    ],
    "iq450_quattro": [
        "FL"
    ],
    "fly iq256": [
        "FL"
    ],
    "fs524": [
        "FL"
    ],
    "life ace": [
        "FL"
    ],
    "life compact 4g": [
        "FL"
    ],
    "life jet": [
        "FL"
    ],
    "life sky": [
        "FL"
    ],
    "iq446": [
        "FL"
    ],
    "iq446 magic": [
        "FL"
    ],
    "fs528": [
        "FL"
    ],
    "fly_iq442": [
        "FL"
    ],
    "iq442 quad": [
        "FL"
    ],
    "fs451": [
        "FL"
    ],
    "fs512": [
        "FL"
    ],
    "fs455": [
        "FL"
    ],
    "fs510": [
        "FL"
    ],
    "fs456": [
        "FL"
    ],
    "fs457": [
        "FL"
    ],
    "fs459": [
        "FL"
    ],
    "fs527": [
        "FL"
    ],
    "fs452": [
        "FL"
    ],
    "fs501": [
        "FL"
    ],
    "fs551": [
        "FL"
    ],
    "fs505": [
        "FL"
    ],
    "fs454": [
        "FL"
    ],
    "fs509": [
        "FL"
    ],
    "iq4410 quad": [
        "FL"
    ],
    "photo pro": [
        "FL"
    ],
    "fs521": [
        "FL"
    ],
    "fs526": [
        "FL"
    ],
    "power plus 5000": [
        "FL"
    ],
    "fs554": [
        "FL"
    ],
    "fs530": [
        "FL"
    ],
    "iq255": [
        "FL"
    ],
    "iq449": [
        "FL"
    ],
    "fly iq441": [
        "FL"
    ],
    "fs520": [
        "FL"
    ],
    "slimline": [
        "FL"
    ],
    "fly iq4404": [
        "FL"
    ],
    "fs401": [
        "FL"
    ],
    "fs402": [
        "FL"
    ],
    "fs404": [
        "FL"
    ],
    "fs405": [
        "FL"
    ],
    "fs406": [
        "FL"
    ],
    "fs407": [
        "FL"
    ],
    "fs458": [
        "FL"
    ],
    "fs409": [
        "FL"
    ],
    "iq443": [
        "FL"
    ],
    "fly_iq285": [
        "FL"
    ],
    "iq236": [
        "FL"
    ],
    "iq451": [
        "FL"
    ],
    "iq240": [
        "FL"
    ],
    "fs529": [
        "FL"
    ],
    "fx100,7": [
        "FM"
    ],
    "conexis a1": [
        "FN"
    ],
    "conexis a2": [
        "FN"
    ],
    "conexis x1": [
        "FN"
    ],
    "conexis x2": [
        "FN"
    ],
    "sp5045v": [
        "FN"
    ],
    "infocus m2": [
        "FO",
        "M1"
    ],
    "infocus m310": [
        "FO"
    ],
    "infocus m810u": [
        "FO"
    ],
    "amosta 3g5": [
        "FR"
    ],
    "fte161e": [
        "FT"
    ],
    "fte161g": [
        "FT"
    ],
    "ftj161a": [
        "FT"
    ],
    "ft141b": [
        "FT"
    ],
    "ft142": [
        "FT"
    ],
    "ft142a": [
        "FT"
    ],
    "ftj152a": [
        "FT"
    ],
    "ftj152b": [
        "FT"
    ],
    "ftj162d": [
        "FT"
    ],
    "ftj162e": [
        "FT"
    ],
    "ftj17a00": [
        "FT"
    ],
    "ftj152d": [
        "FT"
    ],
    "ftj152c": [
        "FT"
    ],
    "ftj161b": [
        "FT"
    ],
    "ft142d_ltexm": [
        "FT"
    ],
    "f-02l": [
        "FU"
    ],
    "f-41a": [
        "FU"
    ],
    "f-04k": [
        "FU"
    ],
    "901fj": [
        "FU"
    ],
    "f-03d": [
        "FU"
    ],
    "f-03e": [
        "FU"
    ],
    "arrowsm03": [
        "FU"
    ],
    "f-01f": [
        "FU"
    ],
    "f-06e": [
        "FU"
    ],
    "f-02e": [
        "FU"
    ],
    "f-05d": [
        "FU"
    ],
    "f-08d": [
        "FU"
    ],
    "f-01l": [
        "FU"
    ],
    "f-04j": [
        "FU"
    ],
    "ml7j2ch/a": [
        "G0"
    ],
    "ml7k2ch/a": [
        "G0"
    ],
    "mg492ch/a": [
        "G0"
    ],
    "mga92zp/a": [
        "G0"
    ],
    "mku82zp": [
        "G0"
    ],
    "mngw2ch": [
        "G0"
    ],
    "mn4a2zp/a": [
        "G0"
    ],
    "mnh02ch": [
        "G0"
    ],
    "mn8j2zp/a": [
        "G0"
    ],
    "mnrm2ch": [
        "G0"
    ],
    "go onyx": [
        "G1",
        "EX"
    ],
    "go1402": [
        "G1"
    ],
    "go503": [
        "G1"
    ],
    "gome_c7_note_plus": [
        "G5"
    ],
    "gome 2017x05a": [
        "G5"
    ],
    "gome 2018x38a": [
        "G5"
    ],
    "gome 2016g68a": [
        "G5"
    ],
    "gome s1": [
        "G5"
    ],
    "gome s7": [
        "G5"
    ],
    "gome 2016m25a": [
        "G5"
    ],
    "gome 2017m27a": [
        "G5"
    ],
    "gome_u9": [
        "G5"
    ],
    "g0215d": [
        "G6"
    ],
    "g0245d": [
        "G6"
    ],
    "g0335d": [
        "G6"
    ],
    "aries_785": [
        "GC"
    ],
    "aries_7o": [
        "GC"
    ],
    "insignia 5": [
        "GC"
    ],
    "insignia_500": [
        "GC"
    ],
    "insignia_550i": [
        "GC"
    ],
    "insignia 5x": [
        "GC"
    ],
    "quantum_350": [
        "GC"
    ],
    "quantum 4": [
        "GC"
    ],
    "quantum_500": [
        "GC"
    ],
    "geotel g1": [
        "GE"
    ],
    "geotel_note": [
        "GE"
    ],
    "gsmart aku a1": [
        "GG"
    ],
    "gsmart_classic": [
        "GG"
    ],
    "gsmart g1310": [
        "GG"
    ],
    "gsmart maya m1 v2": [
        "GG"
    ],
    "gsmart roma r2": [
        "GG"
    ],
    "qs702": [
        "GH"
    ],
    "ghia_zeus_3g": [
        "GH"
    ],
    "gio-gionee_c600": [
        "GI"
    ],
    "gio-gionee_c610": [
        "GI"
    ],
    "dream_d1": [
        "GI"
    ],
    "gionee-e6/e6": [
        "GI"
    ],
    "f100a": [
        "GI"
    ],
    "f103s": [
        "GI"
    ],
    "f106l": [
        "GI"
    ],
    "gn100": [
        "GI"
    ],
    "gn100t": [
        "GI"
    ],
    "gionee-gn139/gn139": [
        "GI"
    ],
    "gionee-gn160t": [
        "GI"
    ],
    "gn205": [
        "GI"
    ],
    "gionee-gn700w/gn700w": [
        "GI"
    ],
    "gn700w": [
        "GI"
    ],
    "gionee-gn705w/gn705w": [
        "GI"
    ],
    "gn800": [
        "GI"
    ],
    "gn868": [
        "GI"
    ],
    "gn878": [
        "GI"
    ],
    "gn9000": [
        "GI"
    ],
    "gn9000l": [
        "GI"
    ],
    "gn9001": [
        "GI"
    ],
    "gn9002": [
        "GI"
    ],
    "gn9004": [
        "GI"
    ],
    "gn9005": [
        "GI"
    ],
    "gn9006": [
        "GI"
    ],
    "gn9008": [
        "GI"
    ],
    "gionee_gpad_g1": [
        "GI"
    ],
    "gionee_gpad_g2": [
        "GI"
    ],
    "m7 power": [
        "GI"
    ],
    "p5 mini": [
        "GI"
    ],
    "p7 max": [
        "GI"
    ],
    "gionee-v182/v182": [
        "GI"
    ],
    "gionee-v185/ v185": [
        "GI"
    ],
    "v188": [
        "GI"
    ],
    "v188s": [
        "GI"
    ],
    "goly a100": [
        "GL"
    ],
    "goly_x5": [
        "GL"
    ],
    "goly x6": [
        "GL"
    ],
    "garmin-asus a10": [
        "GM"
    ],
    "garmin-asus a50": [
        "GM"
    ],
    "garminfone": [
        "GM"
    ],
    "gm 5 plus": [
        "GN"
    ],
    "gm 8": [
        "GN"
    ],
    "gm8 go": [
        "GN"
    ],
    "gm 8 d": [
        "GN"
    ],
    "galaxy nexus": [
        "GO",
        "SA"
    ],
    "nexus 5": [
        "GO"
    ],
    "nexus one": [
        "GO"
    ],
    "nexus s - 4.1.1 - api 16 - 480x800": [
        "GO"
    ],
    "nexus s 4g": [
        "GO"
    ],
    "nexus s": [
        "GO"
    ],
    "pixel": [
        "GO"
    ],
    "g011a": [
        "GO"
    ],
    "pixel 2 xl": [
        "GO"
    ],
    "google 2xl": [
        "GO"
    ],
    "pixel 3 xl": [
        "GO"
    ],
    "pixel 3a": [
        "GO"
    ],
    "pixel 3a xl": [
        "GO"
    ],
    "pixel 4": [
        "GO"
    ],
    "pixel 4 xl": [
        "GO"
    ],
    "pixel 4a": [
        "GO"
    ],
    "pixel xl": [
        "GO"
    ],
    "gtm-5.5v.8-exclusive": [
        "GP"
    ],
    "gtm-5v.5pro": [
        "GP"
    ],
    "grape_gtm-5v.7": [
        "GP"
    ],
    "gtm-5v5": [
        "GP"
    ],
    "gigaset gs160": [
        "GS"
    ],
    "gigaset gs170": [
        "GS"
    ],
    "gs270": [
        "GS"
    ],
    "gs270 plus": [
        "GS"
    ],
    "gs370": [
        "GS"
    ],
    "gs370_plus": [
        "GS"
    ],
    "sm-s9080": [
        "SA"
    ],
    "sm-s908e": [
        "SA"
    ],
    "sm-s908n": [
        "SA"
    ],
    "sm-s908u": [
        "SA"
    ],
    "sm-s908u1": [
        "SA"
    ],
    "sm-s908w": [
        "SA"
    ],
    "samsung sm-s127dl": [
        "SA"
    ],
    "sm-s124dl": [
        "SA"
    ],
    "samsung sm-a125w": [
        "SA"
    ],
    "sm-a426u": [
        "SA"
    ],
    "sm-a426u1": [
        "SA"
    ],
    "sm-a326u1": [
        "SA"
    ],
    "sm-a326w": [
        "SA"
    ],
    "sm-a136u": [
        "SA"
    ],
    "sm-a136w": [
        "SA"
    ],
    "samsung sm-m022g": [
        "SA"
    ],
    "samsung sm-e5260": [
        "SA"
    ],
    "samsung sm-s326dl": [
        "SA"
    ],
    "sm-s9010": [
        "SA"
    ],
    "sm-s901b": [
        "SA"
    ],
    "sm-s901e": [
        "SA"
    ],
    "sm-s901n": [
        "SA"
    ],
    "sm-s901u": [
        "SA"
    ],
    "sm-s901w": [
        "SA"
    ],
    "sm-s9060": [
        "SA"
    ],
    "sm-s906b": [
        "SA"
    ],
    "sm-s906e": [
        "SA"
    ],
    "sm-s906n": [
        "SA"
    ],
    "sm-s906u": [
        "SA"
    ],
    "sm-s906u1": [
        "SA"
    ],
    "sm-s906w": [
        "SA"
    ],
    "w55se": [
        "WQ"
    ],
    "vortexplus": [
        "HR"
    ],
    "p650 pro": [
        "ZT"
    ],
    "6125a": [
        "TC"
    ],
    "d55l": [
        "KK"
    ],
    "ang-lx2": [
        "HU"
    ],
    "silver max lite": [
        "KL"
    ],
    "t775b": [
        "TC"
    ],
    "a10_lite_2gb": [
        "A2"
    ],
    "mt2111": [
        "ON"
    ],
    "v2142": [
        "VV"
    ],
    "rmx3491": [
        "RE"
    ],
    "black g": [
        "KL"
    ],
    "4187u": [
        "TC"
    ],
    "action-x3 pro": [
        "C1"
    ],
    "alcatel_5008r": [
        "AL"
    ],
    "art2pro": [
        "YE"
    ],
    "dl3pluspro": [
        "D3"
    ],
    "dl3": [
        "D3"
    ],
    "e475": [
        "HN"
    ],
    "e504": [
        "HN"
    ],
    "ea1002": [
        "6A"
    ],
    "easy_smart_2": [
        "2O"
    ],
    "element 4 plus": [
        "KL"
    ],
    "g51 plus": [
        "BU"
    ],
    "g91 pro": [
        "BU"
    ],
    "hisense f8 mini": [
        "HI"
    ],
    "htc desire 10 compact": [
        "HT"
    ],
    "i2018": [
        "VV"
    ],
    "k4b": [
        "WK"
    ],
    "krip_k4": [
        "WK"
    ],
    "logic l50": [
        "1L"
    ],
    "logic l50t": [
        "1L"
    ],
    "logic l57": [
        "1L"
    ],
    "mione_pro": [
        "X7",
        "MO"
    ],
    "moto e (xt2052dl)": [
        "MR"
    ],
    "moto e5 cruise": [
        "MR"
    ],
    "moto e5 supra": [
        "MR",
        "S5"
    ],
    "moto e6 (xt2005dl)": [
        "MR"
    ],
    "moto g play (xt2093dl)": [
        "MR"
    ],
    "moto g power (2022)": [
        "MR"
    ],
    "moto g pure": [
        "MR"
    ],
    "moto g stylus (xt2115dl)": [
        "MR"
    ],
    "moto g(10) power": [
        "MR"
    ],
    "moto g(6) forge": [
        "MR"
    ],
    "moto g(6) (xt1925dl)": [
        "MR"
    ],
    "motorola edge (2021)": [
        "MR"
    ],
    "motorola edge 20 fusion": [
        "MR",
        "O1"
    ],
    "motorola edge 5g uw (2021)": [
        "MR"
    ],
    "motorola one 5g uw ace": [
        "MR"
    ],
    "motoe2(4g-lte)": [
        "MR"
    ],
    "moto x4": [
        "MR"
    ],
    "moto g31": [
        "MR"
    ],
    "moto g41": [
        "MR"
    ],
    "moto g(7) optimo maxx(xt1955dl)": [
        "MR"
    ],
    "moto g(7) optimo (xt1952dl)": [
        "MR"
    ],
    "opel mobile smartx6": [
        "2O"
    ],
    "platinum_p4": [
        "SW"
    ],
    "redmi 8a pro": [
        "XI"
    ],
    "schok volt sv55": [
        "ZG"
    ],
    "sky prestigex": [
        "SW"
    ],
    "silver max pro": [
        "KL"
    ],
    "tecno bd4j": [
        "TB"
    ],
    "tecno kg5": [
        "TB"
    ],
    "tecno kg6p": [
        "TB"
    ],
    "tecno kg7": [
        "TB"
    ],
    "tecno pr651e": [
        "TB"
    ],
    "tecno sa1s pro": [
        "TB"
    ],
    "tis001-s3": [
        "JY"
    ],
    "tis001-t2": [
        "JY"
    ],
    "titan p8000 pro 2021": [
        "IH",
        "UZ"
    ],
    "twist 4 fit": [
        "PS"
    ],
    "tx9 pro": [
        "PT"
    ],
    "vmp0617": [
        "FV"
    ],
    "wiko u316at": [
        "WI"
    ],
    "liv2_lte": [
        "YE"
    ],
    "quantum q20": [
        "QA"
    ],
    "yes altitude 4": [
        "Y2"
    ],
    "clearphone 620": [
        "YW"
    ],
    "quantum five": [
        "QA"
    ],
    "w-k630-eea": [
        "WI"
    ],
    "vs986": [
        "LG"
    ],
    "ls1542qwn": [
        "JX"
    ],
    "doppio dp355": [
        "JQ"
    ],
    "liv2lte": [
        "YE"
    ],
    "mzb07z0in": [
        "0P"
    ],
    "v2359a": [
        "VV"
    ],
    "v2338": [
        "VV"
    ],
    "v2314": [
        "VV"
    ],
    "u12 life": [
        "HT"
    ],
    "v2341": [
        "VV"
    ],
    "eli-nx9": [
        "HNR"
    ],
    "armor 25t pro": [
        "UL"
    ],
    "a2322g": [
        "ZT"
    ],
    "panb0013in": [
        "MR"
    ],
    "mzb8746in": [
        "0P"
    ],
    "mzb8744in": [
        "0P"
    ],
    "hisense u60": [
        "HI"
    ],
    "gtt9q": [
        "GO"
    ],
    "gd1yq": [
        "GO"
    ],
    "g020g": [
        "GO"
    ],
    "g020c": [
        "GO"
    ],
    "g020b": [
        "GO"
    ],
    "sm-a236v": [
        "SA"
    ],
    "cph2665": [
        "OP"
    ],
    "stellar p7": [
        "ZU"
    ],
    "stellar p6": [
        "ZU"
    ],
    "20200808a1": [
        "WM1"
    ],
    "buzz 5 prime": [
        "AE"
    ],
    "buzz 5 pro": [
        "AE"
    ],
    "buzz 5": [
        "AE"
    ],
    "buzz 5 note": [
        "AE"
    ],
    "buzz 5 pro plus": [
        "AE"
    ],
    "g020e": [
        "GO"
    ],
    "elp-an00": [
        "HNR"
    ],
    "2pzc100": [
        "HT"
    ],
    "mzb8745in": [
        "0P"
    ],
    "mzb8741in": [
        "0P"
    ],
    "g025j": [
        "GO"
    ],
    "vivo y17": [
        "VV"
    ],
    "g1f8f": [
        "GO"
    ],
    "z2359": [
        "ZT"
    ],
    "sm-g990e": [
        "SA"
    ],
    "mx-a65": [
        "MW"
    ],
    "soft5p": [
        "KW"
    ],
    "g011c": [
        "GO"
    ],
    "gt60 pro": [
        "C5"
    ],
    "gt60": [
        "C5"
    ],
    "hd65_select": [
        "JW"
    ],
    "hd65_plus": [
        "JW"
    ],
    "hd65": [
        "JW"
    ],
    "cubot hafury v1": [
        "CB",
        "HF"
    ],
    "pjw110": [
        "OP"
    ],
    "lra-an00": [
        "HNR",
        "HU"
    ],
    "gbd-nx9": [
        "HNR"
    ],
    "elp-nx9": [
        "HNR",
        "HU"
    ],
    "xq-ec54": [
        "SO"
    ],
    "xq-ct62": [
        "SO"
    ],
    "xq-es54": [
        "SO"
    ],
    "xq-es72": [
        "SO"
    ],
    "sm-a356u1": [
        "SA"
    ],
    "hisense e32 pro": [
        "HI"
    ],
    "jny-l01": [
        "HU"
    ],
    "r570e": [
        "FPS"
    ],
    "pixpro l1 pro": [
        "PIX"
    ],
    "g013a": [
        "GO"
    ],
    "v2361ga": [
        "VV"
    ],
    "saturn": [
        "69"
    ],
    "santin k1": [
        "SQ"
    ],
    "omega hd 3": [
        "CH"
    ],
    "cam-l03": [
        "HU"
    ],
    "meizu c9": [
        "M1"
    ],
    "f3313": [
        "SO"
    ],
    "sm-j200bt": [
        "SA"
    ],
    "b5532": [
        "MD"
    ],
    "blade l7": [
        "ZT"
    ],
    "shahin iii": [
        "GX"
    ],
    "crush_x565": [
        "SMT"
    ],
    "blaze_x500": [
        "SMT"
    ],
    "nex 3 5g": [
        "VV"
    ],
    "2pzf1": [
        "HT"
    ],
    "reno ace 2 eva": [
        "OP"
    ],
    "w-k610-ope": [
        "WI"
    ],
    "smart 4g max 5.5": [
        "11"
    ],
    "rx17pro": [
        "OP"
    ],
    "honor 30 lite": [
        "HU"
    ],
    "hisense u30": [
        "HI"
    ],
    "sm-m536b": [
        "SA"
    ],
    "honor 30 pro+": [
        "HU"
    ],
    "cph2637": [
        "OP"
    ],
    "moto edge 20": [
        "MR"
    ],
    "phy120": [
        "OP"
    ],
    "honor 20 pro": [
        "HU"
    ],
    "m1803d5xa": [
        "XI"
    ],
    "lra-tl00": [
        "HU"
    ],
    "hry-l21": [
        "HU"
    ],
    "solar": [
        "LM"
    ],
    "andy 4e": [
        "YE"
    ],
    "tecno cl8": [
        "TB"
    ],
    "jny-l21": [
        "HU"
    ],
    "ilike u5 pro": [
        "AK"
    ],
    "eve-al00": [
        "HU"
    ],
    "jny-tl10": [
        "HU"
    ],
    "hisense f10": [
        "HI"
    ],
    "primo nx6": [
        "WA"
    ],
    "lge-n49b": [
        "HNR",
        "LG"
    ],
    "honor 20 lite": [
        "HU"
    ],
    "honor 9x lite": [
        "HU"
    ],
    "honor 8a pro": [
        "HU"
    ],
    "honor play 3e": [
        "HU"
    ],
    "honor 20i": [
        "HU"
    ],
    "wukong-l29a": [
        "HU"
    ],
    "honor play 8": [
        "HU"
    ],
    "juliaqn-l01b": [
        "HU"
    ],
    "doogee x98 pro": [
        "DO"
    ],
    "honor 9s": [
        "HU"
    ],
    "f7 youth": [
        "OP"
    ],
    "nova y60": [
        "HU"
    ],
    "pcht10": [
        "OP"
    ],
    "a181": [
        "I4"
    ],
    "orbit y20": [
        "WA"
    ],
    "ix pro": [
        "4M"
    ],
    "ix": [
        "4M"
    ],
    "ix-1": [
        "4M"
    ],
    "v2364a": [
        "VV"
    ],
    "x10_soul": [
        "A2"
    ],
    "x20_soul": [
        "A2"
    ],
    "v10_viper": [
        "A2"
    ],
    "smartphone_x5": [
        "09"
    ],
    "nexg n8": [
        "WA"
    ],
    "nexg n73": [
        "WA"
    ],
    "nexg n72": [
        "WA"
    ],
    "nexg n71 plus": [
        "WA"
    ],
    "l71061": [
        "LE"
    ],
    "l70081": [
        "LE"
    ],
    "ihunt s24 plus": [
        "IH"
    ],
    "ihunt_s23_plus": [
        "IH"
    ],
    "hisense e70 pro": [
        "HI"
    ],
    "panv0005in": [
        "MR"
    ],
    "panb0001in": [
        "MR"
    ],
    "moto g200": [
        "MR"
    ],
    "infinix x666": [
        "IF"
    ],
    "imo q5": [
        "IL",
        "60"
    ],
    "mito a67": [
        "8M"
    ],
    "nexg n25": [
        "WA"
    ],
    "nexg n9": [
        "WA"
    ],
    "nokia x7": [
        "NK"
    ],
    "pocket_18x9": [
        "MY1"
    ],
    "motorola e6s": [
        "MR"
    ],
    "nokia c2": [
        "NK"
    ],
    "ninetology z1+": [
        "NI1"
    ],
    "ninetology x1": [
        "NI1"
    ],
    "v2355": [
        "VV"
    ],
    "v2351": [
        "VV"
    ],
    "v2350": [
        "VV"
    ],
    "v2401": [
        "VV"
    ],
    "v2199ga": [
        "VV"
    ],
    "xt2137-1": [
        "MR"
    ],
    "m1908c3ih": [
        "XI"
    ],
    "a301sh": [
        "SH"
    ],
    "samsung sm-a235m": [
        "SA"
    ],
    "juliaqn-l23a": [
        "HU"
    ],
    "iplay 50 pro": [
        "3A"
    ],
    "2q6e1": [
        "HT"
    ],
    "ga02099": [
        "GO"
    ],
    "x75-2021": [
        "FP"
    ],
    "us215": [
        "LG"
    ],
    "a2023p": [
        "ZT"
    ],
    "a2022p": [
        "ZT"
    ],
    "a2022": [
        "ZT"
    ],
    "itel a667lp": [
        "IZ"
    ],
    "g4s1m": [
        "GO"
    ],
    "shift": [
        "4M"
    ],
    "hisense e40": [
        "HI"
    ],
    "i99": [
        "SM"
    ],
    "i66": [
        "SM"
    ],
    "ravoz z6 lite": [
        "R9"
    ],
    "spurt k800": [
        "SPU"
    ],
    "sm-a750f": [
        "SA"
    ],
    "philips v387": [
        "PH"
    ],
    "smart fly v500": [
        "V5"
    ],
    "okapiamagic": [
        "OA"
    ],
    "magic+": [
        "OA"
    ],
    "cph2687": [
        "OP"
    ],
    "cph2681": [
        "OP"
    ],
    "cph2643": [
        "OP"
    ],
    "cph2619": [
        "ON",
        "OP"
    ],
    "cph2621": [
        "ON",
        "OP"
    ],
    "cph2639": [
        "OP"
    ],
    "doov l525": [
        "DV"
    ],
    "v2346": [
        "VV"
    ],
    "gionee s9": [
        "GI"
    ],
    "gionee s10": [
        "GI"
    ],
    "hongmi 4": [
        "XI"
    ],
    "xolo black1x": [
        "XO"
    ],
    "ringing bells smart 101": [
        "RNB"
    ],
    "hongmi 5a": [
        "XI"
    ],
    "i-mobile iq xpro2": [
        "IO"
    ],
    "i-mobile_iq_big2": [
        "IO"
    ],
    "i-mobile iq z": [
        "IO"
    ],
    "xt2081-1": [
        "MR"
    ],
    "ultra 8 pro": [
        "SPX"
    ],
    "discovery pro": [
        "FS"
    ],
    "c51": [
        "OE"
    ],
    "c38": [
        "DX",
        "OE"
    ],
    "c36": [
        "OE"
    ],
    "c35": [
        "OE"
    ],
    "c33": [
        "OE"
    ],
    "b1": [
        "5F"
    ],
    "b2": [
        "5F"
    ],
    "armor p1s": [
        "KHI"
    ],
    "xt2225-2": [
        "MR"
    ],
    "orange rise 35": [
        "OR"
    ],
    "hlte720e": [
        "HI"
    ],
    "gdl xtreme 4": [
        "GDL"
    ],
    "gq3060tf3": [
        "UL"
    ],
    "itel a511lq": [
        "IZ"
    ],
    "nokia c12 pro": [
        "NK",
        "OE"
    ],
    "xt2091-7": [
        "LE"
    ],
    "xt2343-3": [
        "MR"
    ],
    "xt2221-2": [
        "MR"
    ],
    "xt2158-6": [
        "MR"
    ],
    "v max plus": [
        "DO"
    ],
    "v2343": [
        "VV"
    ],
    "s punk": [
        "DO"
    ],
    "mzb0ggwin": [
        "0P"
    ],
    "mzb0a5ein": [
        "XI"
    ],
    "mzb0a0min": [
        "0P"
    ],
    "lenovo z6 pro 5g": [
        "LE"
    ],
    "l78031": [
        "LE"
    ],
    "kyg03": [
        "KY"
    ],
    "energizer ultimate 65g": [
        "ED"
    ],
    "energizer power max p550s": [
        "ED"
    ],
    "energizer hardcase h570s": [
        "ED"
    ],
    "go3z5": [
        "GO"
    ],
    "fp5": [
        "FA"
    ],
    "g6qu3": [
        "GO"
    ],
    "zg65": [
        "JW"
    ],
    "z2350": [
        "ZT"
    ],
    "nova 6": [
        "HU"
    ],
    "nova 7 5g": [
        "HU"
    ],
    "nova 7i": [
        "HU"
    ],
    "nova 7 pro 5g": [
        "HU"
    ],
    "nova 7 se 5g": [
        "HU"
    ],
    "nova 8i": [
        "HU"
    ],
    "nova 8 se": [
        "HU"
    ],
    "nova 8": [
        "HU"
    ],
    "rmx3800": [
        "RE"
    ],
    "wp50": [
        "OE"
    ],
    "v2403a": [
        "VV"
    ],
    "s118": [
        "DO"
    ],
    "sm-a245m": [
        "SA"
    ],
    "rtg-nx9": [
        "HNR"
    ],
    "pro k10": [
        "NOV"
    ],
    "s41t": [
        "DO"
    ],
    "fri-an10": [
        "HNR"
    ],
    "a302op": [
        "OP"
    ],
    "motorola edge 50 fusion": [
        "MR",
        "O1"
    ],
    "motorola moto g84 5g": [
        "MR"
    ],
    "iqoo z5x": [
        "VV"
    ],
    "iqoo z5": [
        "VV"
    ],
    "iqoo z3 5g": [
        "VV"
    ],
    "t7": [
        "HV"
    ],
    "rmx3781": [
        "RE"
    ],
    "realme 7 pro": [
        "RE"
    ],
    "fla-l23": [
        "HU"
    ],
    "g013c": [
        "GO"
    ],
    "sharp aquos zero6": [
        "SH"
    ],
    "pr4jbx20a": [
        "UM"
    ],
    "pg2309gba": [
        "UM"
    ],
    "redmi k60 ultra": [
        "XI"
    ],
    "redmi turbo 3": [
        "XI"
    ],
    "2406ern9ci": [
        "XI"
    ],
    "rx pro": [
        "4M"
    ],
    "redmi k60e": [
        "XI"
    ],
    "xsmart mate 10": [
        "XSM"
    ],
    "ayat101": [
        "YR"
    ],
    "xt2013-2": [
        "MR"
    ],
    "xt2061-3": [
        "MR"
    ],
    "s501aplus": [
        "IP"
    ],
    "s cyber": [
        "DO"
    ],
    "24072px77c": [
        "XI"
    ],
    "xt2307-1": [
        "MR"
    ],
    "model 5": [
        "HYA"
    ],
    "model 6s": [
        "HYA"
    ],
    "studio g plus": [
        "BU"
    ],
    "lava lzg403 25": [
        "LV"
    ],
    "iku a70": [
        "8I"
    ],
    "lava lzx408": [
        "LV"
    ],
    "pka110": [
        "OP"
    ],
    "pjx110": [
        "ON"
    ],
    "tecno cl6k": [
        "TB"
    ],
    "x4000": [
        "XRL"
    ],
    "i2306": [
        "VV"
    ],
    "moto g64 5g": [
        "MR"
    ],
    "sh-54d": [
        "SH"
    ],
    "primo rx9": [
        "WA"
    ],
    "pearl k3 2021": [
        "HV"
    ],
    "rmx3930": [
        "RE"
    ],
    "plume l5 pro": [
        "C5"
    ],
    "hppl63a": [
        "U8"
    ],
    "astro 63r": [
        "MW"
    ],
    "bharat 5": [
        "MI"
    ],
    "mipo_m17": [
        "MIP"
    ],
    "kingkong x": [
        "CB"
    ],
    "kingkong ace 3": [
        "CB"
    ],
    "iqoo 7 india": [
        "VV"
    ],
    "iqoo 7 legend": [
        "VV"
    ],
    "iqoo 7": [
        "VV"
    ],
    "lava lzg409": [
        "LV"
    ],
    "rmx3995": [
        "RE"
    ],
    "2407frk8ec": [
        "XI"
    ],
    "2311bpn23c": [
        "XI"
    ],
    "xiaomi 14": [
        "XI"
    ],
    "xiaomi 13t": [
        "XI"
    ],
    "z2450": [
        "ZT"
    ],
    "lio-al10": [
        "HU"
    ],
    "lunar": [
        "LM"
    ],
    "buzz 5 ultra": [
        "AE"
    ],
    "bold k10": [
        "BU"
    ],
    "cubot x30": [
        "CB"
    ],
    "discovery se": [
        "FS"
    ],
    "g5nz6": [
        "GO"
    ],
    "g8vou": [
        "GO"
    ],
    "jp1": [
        "JAM"
    ],
    "lfi one": [
        "LTL"
    ],
    "mp25": [
        "UM"
    ],
    "mp24": [
        "UM"
    ],
    "mp20": [
        "UM"
    ],
    "mp19": [
        "UM"
    ],
    "mx-a64": [
        "MW"
    ],
    "ms651": [
        "7M"
    ],
    "alt-an00": [
        "HNR"
    ],
    "tecno bg6m": [
        "TB"
    ],
    "v2362a": [
        "VV"
    ],
    "servo 16max": [
        "SER"
    ],
    "ihunt s24 xtreme": [
        "IH"
    ],
    "g025n": [
        "GO"
    ],
    "energizer hard case g5": [
        "ED"
    ],
    "a0622": [
        "ZT"
    ],
    "a0616": [
        "ZT"
    ],
    "reno 6": [
        "OP"
    ],
    "reno 5": [
        "OP"
    ],
    "2pzm3": [
        "HT"
    ],
    "yuho_y1_stars": [
        "Y0"
    ],
    "xt2363-2": [
        "MR"
    ],
    "xt2343-1": [
        "MR"
    ],
    "hyper 7 pro": [
        "HV"
    ],
    "rmx3988": [
        "RE"
    ],
    "v17 sd665": [
        "VV"
    ],
    "pkd130": [
        "OP"
    ],
    "v2409": [
        "VV"
    ],
    "v2344": [
        "VV"
    ],
    "v2348": [
        "VV"
    ],
    "s6702x": [
        "NL"
    ],
    "pixel 9 pro": [
        "GO"
    ],
    "motorola razr 50": [
        "MR"
    ],
    "ds-cl4 lite": [
        "DCO"
    ],
    "nova60": [
        "C5"
    ],
    "zte 7543n": [
        "ZT"
    ],
    "z2351n": [
        "57"
    ],
    "lt s33": [
        "QL"
    ],
    "tecno mobile ch6i": [
        "TB"
    ],
    "rmx3992": [
        "RE"
    ],
    "rmx3990": [
        "RE"
    ],
    "rmx3933": [
        "RE"
    ],
    "rmx3921": [
        "RE"
    ],
    "rmx3869": [
        "RE"
    ],
    "pixel 9": [
        "GO"
    ],
    "jdy-lx2": [
        "HNR"
    ],
    "kingkong_es": [
        "CB"
    ],
    "blade10 ultra": [
        "DO"
    ],
    "blade10 pro": [
        "DO"
    ],
    "blade10": [
        "DO"
    ],
    "a5slim": [
        "ETH"
    ],
    "a015": [
        "CMF"
    ],
    "2407fpn8eg": [
        "XI"
    ],
    "sh-c03": [
        "SH"
    ],
    "ds-cr1": [
        "DCO"
    ],
    "w-k211-ope": [
        "WI"
    ],
    "sh-c04": [
        "SH"
    ],
    "z2453": [
        "ZT"
    ],
    "xt2401-2": [
        "MR"
    ],
    "vocal v11": [
        "VOC"
    ],
    "wp39": [
        "OE"
    ],
    "wp28 s": [
        "OE"
    ],
    "wp28 e": [
        "OE"
    ],
    "u play": [
        "HT"
    ],
    "ultra 8": [
        "SPX"
    ],
    "tecno kl5": [
        "TB"
    ],
    "tecno camon i4": [
        "TB"
    ],
    "phone (2a)": [
        "NOT"
    ],
    "iron va": [
        "HAM"
    ],
    "energizer energy s550": [
        "ED",
        "OB",
        "E1"
    ],
    "asus_ai2401_e": [
        "AU"
    ],
    "doogee s35": [
        "DO"
    ],
    "doogee n50": [
        "DO"
    ],
    "doogee n40 pro": [
        "DO"
    ],
    "g025e": [
        "GO"
    ],
    "cph2693": [
        "OP"
    ],
    "cph2667": [
        "OP"
    ],
    "cph2661": [
        "ON",
        "OP"
    ],
    "cph2663": [
        "ON",
        "OP"
    ],
    "cph2641": [
        "OP"
    ],
    "smart_p24": [
        "6W"
    ],
    "1907_19": [
        "VV"
    ],
    "blackview a55 pro": [
        "B2"
    ],
    "b160v": [
        "BU"
    ],
    "ihunt titan p10000 pro": [
        "IH",
        "UZ"
    ],
    "itel vision 2": [
        "IZ"
    ],
    "yale-l71a": [
        "HU"
    ],
    "yale-l61d": [
        "HU"
    ],
    "honor play 3": [
        "HU"
    ],
    "honor 9x pro": [
        "HU"
    ],
    "honor 9x": [
        "HU"
    ],
    "honor 8s": [
        "HU"
    ],
    "honor 8a": [
        "HU"
    ],
    "honor 20": [
        "HU"
    ],
    "honor 10i": [
        "HU"
    ],
    "y85a": [
        "VV"
    ],
    "y85": [
        "VV"
    ],
    "y83a": [
        "VV"
    ],
    "y71": [
        "VV"
    ],
    "y71a": [
        "VV"
    ],
    "nokia 8.3": [
        "NK"
    ],
    "m1903c3eg": [
        "XI"
    ],
    "m1582c_max": [
        "YM"
    ],
    "a6020l37": [
        "LE"
    ],
    "a6020a46": [
        "LE"
    ],
    "ehlel c7 pro": [
        "EHL"
    ],
    "armor 27t pro": [
        "UL"
    ],
    "armor 27 pro": [
        "UL"
    ],
    "armor 25t": [
        "UL"
    ],
    "aqm-tl10": [
        "HU"
    ],
    "art-tl00": [
        "HU"
    ],
    "xt2131-3": [
        "MR"
    ],
    "cp23nv3": [
        "CO"
    ],
    "cph2669": [
        "OP"
    ],
    "xt1710-10": [
        "MR"
    ],
    "blackview a55": [
        "B2"
    ],
    "mar-l21mea": [
        "HU"
    ],
    "sm-m156b": [
        "SA"
    ],
    "sm-m215f": [
        "SA"
    ],
    "sm-a426b": [
        "SA"
    ],
    "doogee v10": [
        "DO",
        "WCP"
    ],
    "tecno kl4": [
        "TB"
    ],
    "w-k630-tru": [
        "WI"
    ],
    "ana-n29": [
        "HU"
    ],
    "iqoo neo 5": [
        "VV",
        "SPX"
    ],
    "p60_ultra_5g": [
        "UM2"
    ],
    "2406apnfag": [
        "XI"
    ],
    "2312bpc51x": [
        "0P"
    ],
    "24066pc95i": [
        "0P"
    ],
    "rmx5000": [
        "RE"
    ],
    "nx725j": [
        "57"
    ],
    "a50uns": [
        "NB"
    ],
    "aligator_s6550": [
        "4A"
    ],
    "chp2365": [
        "OP"
    ],
    "nep n11": [
        "RE3"
    ],
    "nep n9": [
        "RE3"
    ],
    "rmx3920": [
        "RE"
    ],
    "v2426": [
        "VV"
    ],
    "v2418": [
        "VV"
    ],
    "v2404": [
        "VV"
    ],
    "v2403": [
        "VV"
    ],
    "v2347": [
        "VV"
    ],
    "v2356": [
        "VV"
    ],
    "hbn-al00": [
        "HU"
    ],
    "hammer_energy_x": [
        "HAM"
    ],
    "syco rs-442": [
        "SYC"
    ],
    "sts602": [
        "Y7"
    ],
    "villaon v501w": [
        "VI1"
    ],
    "infinix x6882": [
        "IF"
    ],
    "infinix x6861": [
        "IF"
    ],
    "infinix x6532": [
        "IF"
    ],
    "infinix x6531": [
        "IF"
    ],
    "infinix x6531b": [
        "IF"
    ],
    "infinix_x6517": [
        "IF"
    ],
    "infinix x6525d": [
        "IF"
    ],
    "infinix x6860": [
        "IF"
    ],
    "infinix x6720b": [
        "IF"
    ],
    "xt2343-6": [
        "MR"
    ],
    "xt2343-2": [
        "MR"
    ],
    "xt2333-1": [
        "MR"
    ],
    "x21i a": [
        "VV"
    ],
    "x21a": [
        "VV"
    ],
    "xt1970-2": [
        "MR"
    ],
    "gzpfo": [
        "GO"
    ],
    "gwvk6": [
        "GO"
    ],
    "gur25": [
        "GO"
    ],
    "gr83y": [
        "GO"
    ],
    "gkv4x": [
        "GO"
    ],
    "gec77": [
        "GO"
    ],
    "g8hhn": [
        "GO"
    ],
    "g576d": [
        "GO"
    ],
    "ga04851-us": [
        "GO"
    ],
    "g2ybb": [
        "GO"
    ],
    "g1b60": [
        "GO"
    ],
    "tiger 13": [
        "OSC"
    ],
    "ptp-an70": [
        "HNR"
    ],
    "u655ac": [
        "CK"
    ],
    "sm-g556b": [
        "SA"
    ],
    "cph3669": [
        "OP"
    ],
    "v2425a": [
        "VV"
    ],
    "2412dpc0ag": [
        "0P"
    ],
    "e6523": [
        "MI"
    ],
    "sea-tl00": [
        "HU"
    ],
    "bharat 5 plus": [
        "MI"
    ],
    "v2417a": [
        "VV"
    ],
    "v2410a": [
        "VV"
    ],
    "v2357a": [
        "VV"
    ],
    "v2353da": [
        "VV"
    ],
    "flc-an00": [
        "HNR",
        "HU"
    ],
    "redmi 14c": [
        "XI"
    ],
    "2405cpx3dc": [
        "XI"
    ],
    "xiaomi 14t pro": [
        "XI"
    ],
    "xiaomi 12": [
        "XI"
    ],
    "2409brn2cy": [
        "XI"
    ],
    "2409brn2ca": [
        "XI"
    ],
    "24049rn28l": [
        "XI"
    ],
    "rmx3996": [
        "RE"
    ],
    "sm-m356b": [
        "SA"
    ],
    "sm-s546vl": [
        "SA"
    ],
    "rmx3950": [
        "RE"
    ],
    "z2357n": [
        "ZT"
    ],
    "z2353": [
        "57"
    ],
    "innova30": [
        "SM"
    ],
    "innova20": [
        "SM"
    ],
    "sh-c05": [
        "SH"
    ],
    "tecno mobile kg5k": [
        "TB"
    ],
    "azom river 1": [
        "AZO"
    ],
    "aqua s10 pro": [
        "CH",
        "IX",
        "2N"
    ],
    "sm-a920f": [
        "SA"
    ],
    "tecno cla6": [
        "TB"
    ],
    "tecno cla5": [
        "TB"
    ],
    "sm-m556b": [
        "SA"
    ],
    "sm-a356b": [
        "SA"
    ],
    "xt2015-2": [
        "MR"
    ],
    "mz-meizu 20 inf": [
        "M1"
    ],
    "xt2409-5": [
        "MR"
    ],
    "buzz 5 lite": [
        "AE"
    ],
    "l24 ultra": [
        "LIB"
    ],
    "g15 pro max": [
        "LIB"
    ],
    "g24_mini": [
        "LIB"
    ],
    "g15_mini": [
        "LIB"
    ],
    "armor i1 slim": [
        "KHI"
    ],
    "alt-lx1": [
        "HNR"
    ],
    "rmx3951": [
        "RE"
    ],
    "tecno kl6": [
        "TB"
    ],
    "umidigi g9 5g": [
        "UM"
    ],
    "tecno ae11": [
        "TB"
    ],
    "meizu s6": [
        "M1"
    ],
    "v2405a": [
        "VV"
    ],
    "wp52": [
        "OE"
    ],
    "xt2453-2": [
        "MR"
    ],
    "moto g85 5g": [
        "MR"
    ],
    "v2424": [
        "VV"
    ],
    "v2417": [
        "VV"
    ],
    "sc-51d": [
        "SA",
        "SU"
    ],
    "2410fpcc5g": [
        "0P"
    ],
    "2405cpx3dg": [
        "XI"
    ],
    "tecno bg6s": [
        "TB"
    ],
    "ulefone armor 6e": [
        "UL"
    ],
    "tecno kl7": [
        "TB"
    ],
    "tecno kj8": [
        "TB"
    ],
    "tecno ae10": [
        "TB"
    ],
    "so-51d": [
        "SO"
    ],
    "sn339d": [
        "DQ"
    ],
    "sc-51e": [
        "SA",
        "SU"
    ],
    "rmx5003": [
        "RE"
    ],
    "wave 8": [
        "B2"
    ],
    "xt2271-5": [
        "MR"
    ],
    "moto e14": [
        "MR"
    ],
    "xq-ec44": [
        "SO"
    ],
    "cph2683": [
        "OP"
    ],
    "armor mini 20t pro": [
        "UL"
    ],
    "zte v70": [
        "ZT"
    ],
    "lenovo legion duel": [
        "LE"
    ],
    "vtl-202301": [
        "VE"
    ],
    "mipo_m33": [
        "MIP"
    ],
    "n6000 se": [
        "B2"
    ],
    "cuiud a91": [
        "CUI"
    ],
    "aix-an00": [
        "WI"
    ],
    "ds-bd3 pro": [
        "DCO"
    ],
    "e65 pro": [
        "EUD"
    ],
    "blackberry evolve x": [
        "RM"
    ],
    "xt2139-1": [
        "MR"
    ],
    "blackview color 8": [
        "B2"
    ],
    "oukitel wp23pro": [
        "OE",
        "OK"
    ],
    "gqml3": [
        "GO"
    ],
    "marie-l21bx": [
        "HU"
    ],
    "motorola razr 50 ultra": [
        "MR"
    ],
    "motorola moto e22": [
        "MR"
    ],
    "motorola edge 50 ultra": [
        "MR"
    ],
    "motorola edge 50 neo": [
        "MR"
    ],
    "motorola edge 50": [
        "MR"
    ],
    "meizu 21 pro": [
        "M1"
    ],
    "hmd fusion": [
        "HMD",
        "O1"
    ],
    "jelly max": [
        "UZ"
    ],
    "n55 plus": [
        "DO"
    ],
    "n55": [
        "DO"
    ],
    "moto g04s": [
        "MR"
    ],
    "f109": [
        "FOS"
    ],
    "f105": [
        "FOS"
    ],
    "cubot x50": [
        "CB"
    ],
    "advance a5 plus lte": [
        "BU"
    ],
    "advance a6": [
        "BU"
    ],
    "advance a5 lte": [
        "BU"
    ],
    "blu studio g2": [
        "BU"
    ],
    "c5 lte": [
        "BU"
    ],
    "tecno kh7h": [
        "TB"
    ],
    "venus_plus": [
        "OL"
    ],
    "v2419": [
        "VV"
    ],
    "i2403": [
        "VV"
    ],
    "xt2073-2": [
        "MR"
    ],
    "nx724j": [
        "57"
    ],
    "flow 11": [
        "KE"
    ],
    "g020h": [
        "GO"
    ],
    "xt2055-2": [
        "MR"
    ],
    "g020i": [
        "GO"
    ],
    "gfe4j": [
        "GO"
    ],
    "a201xm": [
        "XI"
    ],
    "y52s": [
        "VV"
    ],
    "y71t": [
        "VV"
    ],
    "y76s": [
        "VV"
    ],
    "sm-a725m": [
        "SA"
    ],
    "lyn-an00": [
        "HNR",
        "HU"
    ],
    "alt-lx2": [
        "HNR"
    ],
    "jdy-lx3": [
        "HNR",
        "HU"
    ],
    "alt-nx3": [
        "HNR",
        "HU"
    ],
    "gfy-lx2p": [
        "HNR"
    ],
    "alt-nx1": [
        "HNR"
    ],
    "m2001j2i": [
        "XI"
    ],
    "tecno kl5n": [
        "TB"
    ],
    "pkd110": [
        "OP"
    ],
    "mde5": [
        "XI"
    ],
    "ubs1": [
        "OY"
    ],
    "pjt110": [
        "OP"
    ],
    "t7 pro": [
        "HV"
    ],
    "t5 max": [
        "HV"
    ],
    "t506t": [
        "TC"
    ],
    "t506k": [
        "TC"
    ],
    "t506g": [
        "TC"
    ],
    "pags0005in": [
        "MR"
    ],
    "t507d": [
        "TC"
    ],
    "t506a": [
        "TC"
    ],
    "mi8 se": [
        "XI"
    ],
    "mi8se": [
        "XI"
    ],
    "mi8 youth": [
        "XI"
    ],
    "mi8 pro": [
        "XI"
    ],
    "mi8pro": [
        "XI"
    ],
    "mi8": [
        "XI"
    ],
    "sm-g736u": [
        "SA"
    ],
    "sm-s711n": [
        "SA"
    ],
    "max 5": [
        "CB"
    ],
    "itel p671l": [
        "IZ"
    ],
    "l78051": [
        "LE"
    ],
    "cat s52": [
        "CA"
    ],
    "lava lzg403 25i": [
        "LV"
    ],
    "alp-l09s": [
        "HU"
    ],
    "tecno mobile kj5n": [
        "TB"
    ],
    "gionee_star": [
        "OL"
    ],
    "l78071": [
        "LE"
    ],
    "l78011": [
        "LE"
    ],
    "l58091": [
        "LE"
    ],
    "l39051": [
        "LE"
    ],
    "l19111": [
        "LE"
    ],
    "l19041": [
        "LE"
    ],
    "neffos x20": [
        "NF"
    ],
    "fig-l31": [
        "HU"
    ],
    "blade a7 2020": [
        "ZT"
    ],
    "blade a5 2020ru": [
        "ZT"
    ],
    "blade a5 2020": [
        "ZT"
    ],
    "blade a5 2019": [
        "ZT"
    ],
    "blade a5 2019ru": [
        "ZT"
    ],
    "blade a3 2020ru": [
        "ZT"
    ],
    "blade a3 2020": [
        "ZT"
    ],
    "blade a3 2019ru": [
        "ZT"
    ],
    "blade a3 2019": [
        "ZT"
    ],
    "blade a7 2020ru": [
        "ZT"
    ],
    "blade l8ru": [
        "ZT"
    ],
    "blade v1000ru": [
        "ZT"
    ],
    "blade a3 lite": [
        "ZT"
    ],
    "2050ru": [
        "ZT"
    ],
    "y6 2019": [
        "HU"
    ],
    "y6prime": [
        "HU"
    ],
    "y6 pro 2019": [
        "HU"
    ],
    "ady-al10": [
        "HU"
    ],
    "moto g100": [
        "MR"
    ],
    "mde40": [
        "XI"
    ],
    "z7540": [
        "ZT"
    ],
    "nx302j": [
        "57"
    ],
    "xt2163-4": [
        "MR"
    ],
    "xt2045-3": [
        "MR"
    ],
    "2302epcc4h": [
        "0P"
    ],
    "t431p": [
        "TC"
    ],
    "dns-dns-s3504": [
        "DN"
    ],
    "sm-a256n": [
        "SA"
    ],
    "sm-a256u1": [
        "SA"
    ],
    "sm-a3560": [
        "SA"
    ],
    "meizu 15 plus": [
        "M1"
    ],
    "v2415a": [
        "VV"
    ],
    "tcl 10 5g uw": [
        "TC"
    ],
    "meizu x8": [
        "M1"
    ],
    "v2419a": [
        "VV"
    ],
    "cyber 13": [
        "HV"
    ],
    "pjz110": [
        "ON"
    ],
    "kingkong star 2": [
        "CB"
    ],
    "tecno cl7k": [
        "TB"
    ],
    "multilaser_elite_2": [
        "1R"
    ],
    "2410dpn6cc": [
        "XI"
    ],
    "mipo_m46_plus": [
        "MIP"
    ],
    "ada-al10u": [
        "HU"
    ],
    "pure_iii": [
        "W3"
    ],
    "lt750": [
        "WA"
    ],
    "v2423": [
        "VV"
    ],
    "m1810f6g": [
        "XI"
    ],
    "v2408a": [
        "VV"
    ],
    "ptp-an00": [
        "HNR"
    ],
    "24129pn74c": [
        "XI"
    ],
    "24117rk2cc": [
        "XI"
    ],
    "xiaomi15 pro": [
        "XI"
    ],
    "rmx5011": [
        "RE"
    ],
    "rmx5010": [
        "RE"
    ],
    "ptp-an10": [
        "HNR"
    ],
    "nx733j": [
        "57"
    ],
    "gpj41": [
        "GO"
    ],
    "flex 2": [
        "V6"
    ],
    "v max pro": [
        "DO"
    ],
    "meizu lucky 08": [
        "M1"
    ],
    "moto g75 5g": [
        "MR"
    ],
    "moto g45 5g": [
        "MR"
    ],
    "moto g35 5g": [
        "MR"
    ],
    "neo 8 lite": [
        "SPX"
    ],
    "poco c75": [
        "0P"
    ],
    "ivy-lx2": [
        "HU"
    ],
    "i2305": [
        "VV"
    ],
    "brp-nx1": [
        "HNR"
    ],
    "brc-an00": [
        "HNR"
    ],
    "unonu n55s": [
        "UU"
    ],
    "premier5max": [
        "UNP"
    ],
    "ptp-an60": [
        "HNR",
        "HU"
    ],
    "mz-meizu 20 pro": [
        "M1"
    ],
    "v2433": [
        "VV"
    ],
    "rmx3987": [
        "RE"
    ],
    "swift_4g": [
        "69"
    ],
    "2409brn2cl": [
        "XI"
    ],
    "brp-an00": [
        "HNR"
    ],
    "a142p": [
        "NOT"
    ],
    "agm_h_max": [
        "A3"
    ],
    "itel p671ln": [
        "IZ"
    ],
    "hmd skyline": [
        "HMD"
    ],
    "s200 x": [
        "DO"
    ],
    "s200": [
        "DO"
    ],
    "shark 9": [
        "B2"
    ],
    "concord_m20": [
        "C8"
    ],
    "movic f4501": [
        "MV"
    ],
    "premier pro": [
        "UNP"
    ],
    "mione q11": [
        "X7",
        "MO"
    ],
    "mione q1": [
        "X7",
        "MO"
    ],
    "viewphone q5": [
        "VS",
        "60"
    ],
    "cp12s": [
        "CO"
    ],
    "cp12q": [
        "CO"
    ],
    "pkc110": [
        "OP"
    ],
    "pju110_a1": [
        "OP"
    ],
    "n159v": [
        "HMD"
    ],
    "pgr3042": [
        "PAG"
    ],
    "neo 11": [
        "SPX"
    ],
    "mione u1": [
        "X7",
        "MO"
    ],
    "meet": [
        "HF"
    ],
    "lzx415": [
        "LV"
    ],
    "cph2524": [
        "OP"
    ],
    "c6l max": [
        "BU"
    ],
    "c 38": [
        "OE"
    ],
    "blade v 5g": [
        "HAM"
    ],
    "blackview a96": [
        "B2"
    ],
    "aeop520": [
        "2X"
    ],
    "cph2653": [
        "ON",
        "OP"
    ],
    "ane-l22": [
        "HU"
    ],
    "rmx5060": [
        "RE"
    ],
    "rmx5051": [
        "RE"
    ],
    "i2401": [
        "VV"
    ],
    "nx789j": [
        "57"
    ],
    "ptp-n49": [
        "HNR"
    ],
    "cph2655": [
        "ON",
        "OP"
    ],
    "cph2689": [
        "OP"
    ],
    "rmx5002": [
        "RE"
    ],
    "so-51e": [
        "SO"
    ],
    "v2426a": [
        "VV"
    ],
    "v2429a": [
        "VV"
    ],
    "v2430a": [
        "VV"
    ],
    "nx736j": [
        "57"
    ],
    "a2022pg": [
        "ZT"
    ],
    "rmx3938": [
        "RE"
    ],
    "rmx3941": [
        "RE"
    ],
    "pilot 1": [
        "OSC"
    ],
    "shv-e470s": [
        "SA"
    ],
    "f101 p": [
        "FOS"
    ],
    "2411drn47c": [
        "XI"
    ],
    "2409brn2cg": [
        "XI"
    ],
    "24095pcadg": [
        "0P"
    ],
    "alpha a16": [
        "NOV"
    ],
    "ds-cl4": [
        "DCO"
    ],
    "coco10_ultra_4g": [
        "4R"
    ],
    "cph2691": [
        "ON",
        "OP"
    ],
    "cph2651": [
        "OP"
    ],
    "cph2649": [
        "ON",
        "OP"
    ],
    "cph2645": [
        "ON",
        "OP"
    ],
    "asusai2501c": [
        "AU"
    ],
    "asusai2501b": [
        "AU"
    ],
    "24129rt7cc": [
        "XI"
    ],
    "24127rk2cc": [
        "XI"
    ],
    "24122rkc7c": [
        "XI"
    ],
    "umidigi g9t": [
        "UM"
    ],
    "rmx3940": [
        "RE"
    ],
    "blade gt": [
        "DO"
    ],
    "blade10 max": [
        "DO"
    ],
    "bv8200": [
        "B2"
    ],
    "bv7300": [
        "B2"
    ],
    "fire 6": [
        "DO"
    ],
    "kingkong ace 2": [
        "CB"
    ],
    "kingkong power 3": [
        "CB",
        "UM"
    ],
    "mblu 21": [
        "M1"
    ],
    "land rover luxury": [
        "L6"
    ],
    "ob_628": [
        "A5"
    ],
    "cud go 2024": [
        "CUD"
    ],
    "abr-lx1": [
        "HNR"
    ],
    "ctr-l91": [
        "HU"
    ],
    "v2422": [
        "VV"
    ],
    "amm-an00": [
        "HNR",
        "HU"
    ],
    "amg-an00": [
        "HNR",
        "HU"
    ],
    "amp-an00": [
        "HNR",
        "HU"
    ],
    "ptp-an20": [
        "HNR",
        "HU"
    ],
    "amp-an10": [
        "HNR"
    ],
    "tecno kl4h": [
        "TB"
    ],
    "nexg n74": [
        "WA"
    ],
    "new 26": [
        "V6"
    ],
    "brc-nx1": [
        "HNR",
        "HU"
    ],
    "aligator_s6600": [
        "4A"
    ],
    "lmk920": [
        "LG"
    ],
    "lmk200e": [
        "LG"
    ],
    "lmk200b": [
        "LG"
    ],
    "a2019g pro": [
        "ZT"
    ],
    "titan p8000 ultra carbon": [
        "IH",
        "UZ"
    ],
    "pa2310gbb": [
        "UM"
    ],
    "neon ray ultra m": [
        "X1",
        "JG"
    ],
    "new 25": [
        "V6"
    ],
    "mp21": [
        "UM"
    ],
    "hero_20_pro": [
        "AA"
    ],
    "five pro 32": [
        "LM"
    ],
    "aeop513": [
        "2X"
    ],
    "a301xm": [
        "XI"
    ],
    "v2111-eg": [
        "VV"
    ],
    "reno 4 pro": [
        "OP"
    ],
    "reno 11 pro": [
        "OP"
    ],
    "reno12 pro": [
        "OP"
    ],
    "reno10 pro": [
        "OP"
    ],
    "reno 11 f": [
        "OP"
    ],
    "mis-lx9": [
        "HU"
    ],
    "lava blaze": [
        "LV"
    ],
    "kl505": [
        "0K"
    ],
    "plu-al10": [
        "HU"
    ],
    "icl-lx9": [
        "HU"
    ],
    "gfy-lx1": [
        "HU"
    ],
    "bl52pro": [
        "BM"
    ],
    "v2405da": [
        "VV"
    ],
    "asusai2501": [
        "AU"
    ],
    "asusai2501a": [
        "AU"
    ],
    "24116rnc1i": [
        "XI"
    ],
    "17_pro_max": [
        "TRP"
    ],
    "sparx neo 8i": [
        "SPX"
    ],
    "stratus c8": [
        "1J"
    ],
    "hero 20": [
        "AA"
    ],
    "lt c60": [
        "QL"
    ],
    "nitro_g55": [
        "MW"
    ],
    "samsung sm-s911b": [
        "SA"
    ],
    "orbit y12": [
        "WA"
    ],
    "sm-a566e": [
        "SA"
    ],
    "sm-s721b": [
        "SA"
    ],
    "5g ug phone u25": [
        "ZT"
    ],
    "25010pn30g": [
        "XI"
    ],
    "25019pnf3c": [
        "XI"
    ],
    "raptor 5g": [
        "5F"
    ],
    "sparx neo 9i": [
        "SPX"
    ],
    "pkg110": [
        "ON"
    ],
    "24129pn74g": [
        "XI"
    ],
    "25028rn03a": [
        "XI"
    ],
    "pkb110": [
        "OP"
    ],
    "pkh110": [
        "OP"
    ],
    "pkp110": [
        "OP"
    ],
    "cph2695": [
        "OP"
    ],
    "cph2671": [
        "OP"
    ],
    "cph2697": [
        "OP"
    ],
    "cph2711": [
        "OP"
    ],
    "cph2701": [
        "OP"
    ],
    "asusai2501h": [
        "AU"
    ],
    "asusai2501e": [
        "AU"
    ],
    "a059p": [
        "NOT"
    ],
    "a059": [
        "NOT"
    ],
    "pixel 9a": [
        "GO"
    ],
    "motorola edge 60 fusion": [
        "MR",
        "O1"
    ],
    "2409fpcc4g": [
        "0P"
    ],
    "2407fpn8er": [
        "XI"
    ],
    "vi65pb1401na": [
        "FV"
    ],
    "wildfire e star": [
        "HT"
    ],
    "gfy-lx2": [
        "HNR"
    ],
    "flat 2": [
        "OSC"
    ],
    "fire 6 power": [
        "DO"
    ],
    "rmx5070": [
        "RE"
    ],
    "rmx5071": [
        "RE"
    ],
    "rmx5080": [
        "RE"
    ],
    "rmx5090": [
        "RE"
    ],
    "rmx5056": [
        "RE"
    ],
    "rmx5050": [
        "RE"
    ],
    "rmx3943": [
        "RE"
    ],
    "sm-m055f": [
        "SA"
    ],
    "tecno cm5": [
        "TB"
    ],
    "marine 2": [
        "OSC"
    ],
    "cph2699": [
        "OP"
    ],
    "24117rk2cg": [
        "0P"
    ],
    "24122rkc7g": [
        "0P"
    ],
    "z2458": [
        "ZT"
    ],
    "wp39 pro": [
        "OE"
    ],
    "wp36 pro": [
        "OE"
    ],
    "wp32_pro": [
        "OE"
    ],
    "wp23 plus": [
        "OE"
    ],
    "wp100 titan": [
        "OE",
        "UZ"
    ],
    "via m40": [
        "R4"
    ],
    "v40 pro": [
        "DO"
    ],
    "sm-a566b": [
        "SA"
    ],
    "sm-a556v": [
        "SA"
    ],
    "z2466": [
        "ZT"
    ],
    "villaon v651l": [
        "VI1"
    ],
    "v2438": [
        "VV"
    ],
    "v2430": [
        "VV"
    ],
    "u572ac": [
        "CK"
    ],
    "infinix x6962": [
        "IF"
    ],
    "xt2427-4": [
        "MR"
    ],
    "cp07": [
        "CO"
    ],
    "mky-an20": [
        "WI"
    ],
    "l202206": [
        "LEB"
    ],
    "blade gt ultra": [
        "DO"
    ],
    "armor 28 ultra": [
        "UL"
    ],
    "armor 30 pro": [
        "UL"
    ],
    "armor c1 max": [
        "KHI"
    ],
    "armor 27t": [
        "UL"
    ],
    "armor x31 pro": [
        "UL"
    ],
    "armor p1 pro": [
        "KHI"
    ],
    "armor mini 20 pro": [
        "UL"
    ],
    "agm_x6": [
        "A3"
    ],
    "nova60 i": [
        "C5"
    ],
    "mipo_m59": [
        "MIP"
    ],
    "magno p3": [
        "ZU"
    ],
    "magno p1": [
        "ZU"
    ],
    "nova_10_pro_4g": [
        "KGT"
    ],
    "infinix x6881": [
        "IF"
    ],
    "infinix x6880": [
        "IF"
    ],
    "hyper 7": [
        "HV"
    ],
    "hmd crest": [
        "HMD"
    ],
    "g518": [
        "GN"
    ],
    "g318": [
        "GN"
    ],
    "fire 6 max": [
        "DO"
    ],
    "c68": [
        "9H"
    ],
    "c67": [
        "9H"
    ],
    "armor x32": [
        "UL"
    ],
    "armor v1s": [
        "KHI"
    ],
    "armor p1w": [
        "KHI"
    ],
    "armor mini 20": [
        "UL"
    ],
    "armor 27": [
        "UL"
    ],
    "armor i2w": [
        "KHI"
    ],
    "2409brn2cc": [
        "XI"
    ],
    "shahin ii": [
        "GX"
    ],
    "sn509c": [
        "CK"
    ],
    "sl219a": [
        "6A"
    ],
    "plr-al00": [
        "HU"
    ],
    "ptp-n59": [
        "HNR"
    ],
    "ptp-n29": [
        "HNR"
    ],
    "pks110": [
        "OP"
    ],
    "pkr110": [
        "ON"
    ],
    "pkm110": [
        "OP"
    ],
    "pkl110": [
        "OP"
    ],
    "pkk110": [
        "OP"
    ],
    "pkj110": [
        "OP"
    ],
    "xt2437-4": [
        "MR"
    ],
    "xt1924-7": [
        "MR"
    ],
    "xt2087-1": [
        "MR"
    ],
    "v2451": [
        "VV"
    ],
    "xiaomi poco m6 pro": [
        "0P",
        "XI"
    ],
    "armor h1s": [
        "KHI"
    ],
    "plr-l29": [
        "HU"
    ],
    "pla-al10": [
        "HU"
    ],
    "icl-al20": [
        "HU"
    ],
    "icl-al10": [
        "HU"
    ],
    "v2444a": [
        "VV"
    ],
    "sm-s936u": [
        "SA"
    ],
    "sm-s931u": [
        "SA"
    ],
    "sm-e145f": [
        "SA"
    ],
    "pkv110": [
        "OP"
    ],
    "ver-n49dp": [
        "HNR"
    ],
    "sm-a516f": [
        "SA"
    ],
    "moto g15 power": [
        "MR"
    ],
    "moto g05": [
        "MR"
    ],
    "infinix x6873": [
        "IF"
    ],
    "htc exodus 1": [
        "HT"
    ],
    "cph2659": [
        "OP"
    ],
    "cph2647": [
        "ON",
        "OP"
    ],
    "redmi note 12 pro+ 5g": [
        "XI"
    ],
    "25028pc03g": [
        "0P"
    ],
    "2412dpc0ai": [
        "0P"
    ],
    "2412dpc0ag-art": [
        "0P"
    ],
    "sm-s711w": [
        "SA"
    ],
    "nexg n26": [
        "WA"
    ],
    "wp35 s": [
        "OE"
    ],
    "yuno": [
        "LM"
    ],
    "umidigi g9c": [
        "UM"
    ],
    "umidigi g9a": [
        "UM"
    ],
    "tecno kl8h": [
        "TB"
    ],
    "t702w": [
        "TC"
    ],
    "t614d": [
        "TC"
    ],
    "t611b": [
        "TC"
    ],
    "v2441": [
        "VV"
    ],
    "v2440": [
        "VV"
    ],
    "v2437": [
        "VV"
    ],
    "v2436": [
        "VV"
    ],
    "v2434": [
        "VV"
    ],
    "v2427": [
        "VV"
    ],
    "v2425": [
        "VV"
    ],
    "v2415": [
        "VV"
    ],
    "v2413": [
        "VV"
    ],
    "v2352ga": [
        "VV"
    ],
    "v2009a": [
        "VV"
    ],
    "z2465n": [
        "57"
    ],
    "sm-a366u1": [
        "SA"
    ],
    "sm-a366e": [
        "SA"
    ],
    "sm-a366b": [
        "SA"
    ],
    "wp35 pro": [
        "OE"
    ],
    "t509k": [
        "TC"
    ],
    "t433d": [
        "TC"
    ],
    "t509a": [
        "TC"
    ],
    "s118 pro": [
        "DO"
    ],
    "s200 plus": [
        "DO"
    ],
    "premier p50": [
        "PR1"
    ],
    "bq-6861l": [
        "BX"
    ],
    "bq-6761": [
        "BX"
    ],
    "blade10 power": [
        "DO"
    ],
    "yu5200": [
        "Y1"
    ],
    "v2458a": [
        "VV"
    ],
    "v2456a": [
        "VV"
    ],
    "v2435a": [
        "VV"
    ],
    "pkh120": [
        "OP"
    ],
    "v2416": [
        "VV"
    ],
    "rmx5030": [
        "RE"
    ],
    "rmx5020": [
        "RE"
    ],
    "v2420": [
        "VV"
    ],
    "a171_plus": [
        "I4"
    ],
    "nokia 02-4g": [
        "NK"
    ],
    "sbm106sh": [
        "SH"
    ],
    "sm-a356u": [
        "SA"
    ],
    "panasonic p55 novo": [
        "PA"
    ],
    "sm-a066e": [
        "SA"
    ],
    "wp200 pro": [
        "OE"
    ],
    "sm-a217x": [
        "SA"
    ],
    "25028rn03y": [
        "XI"
    ],
    "z5157y": [
        "ZT"
    ],
    "symphony p7": [
        "SM"
    ],
    "aura_power": [
        "KA"
    ],
    "blaupunkt_tx60": [
        "BP"
    ],
    "marine 1": [
        "OSC"
    ],
    "z2467": [
        "ZT"
    ],
    "z2464n": [
        "57"
    ],
    "rmx6688": [
        "RE"
    ],
    "wp55": [
        "OE"
    ],
    "rmx5303": [
        "RE"
    ],
    "rmx5085": [
        "RE"
    ],
    "rmx5079": [
        "RE"
    ],
    "rmx5078": [
        "RE"
    ],
    "rmx5061": [
        "RE"
    ],
    "rmx5032": [
        "RE"
    ],
    "rmx5031": [
        "RE"
    ],
    "pkz110": [
        "OP"
    ],
    "pkx110": [
        "ON"
    ],
    "pkt110": [
        "OP"
    ],
    "pilot 3": [
        "OSC"
    ],
    "gvu6c": [
        "GO"
    ],
    "gb7n6": [
        "GO"
    ],
    "g025h": [
        "GO"
    ],
    "doogee v11": [
        "DO"
    ],
    "25028rn03l": [
        "XI"
    ],
    "25053rt47c": [
        "XI"
    ],
    "25028pc03i": [
        "0P"
    ],
    "xt2255-1": [
        "MR"
    ],
    "sm-s938w": [
        "SA"
    ],
    "sm-s938u1": [
        "SA"
    ],
    "sm-s938n": [
        "SA"
    ],
    "sm-s938b": [
        "SA"
    ],
    "sm-s9380": [
        "SA"
    ],
    "sm-s937u": [
        "SA"
    ],
    "sm-s936b": [
        "SA"
    ],
    "sm-s931u1": [
        "SA"
    ],
    "sm-s931n": [
        "SA"
    ],
    "nx779j": [
        "57"
    ],
    "nx737j": [
        "57"
    ],
    "note 59": [
        "DO"
    ],
    "note 58": [
        "DO"
    ],
    "mblu 22 pro": [
        "M1"
    ],
    "moto g15": [
        "MR"
    ],
    "cph2729": [
        "OP"
    ],
    "blade20 turbo": [
        "DO"
    ],
    "wave 8c": [
        "B2"
    ],
    "v2357ea": [
        "VV"
    ],
    "vocal v2 lite": [
        "VOC"
    ],
    "vocal v0core": [
        "VOC"
    ],
    "24129pn74i": [
        "XI"
    ],
    "24108pce2i": [
        "0P"
    ],
    "primo x2mini": [
        "WA"
    ],
    "v2464a": [
        "VV"
    ],
    "v2454da": [
        "VV"
    ],
    "v2454a": [
        "VV"
    ],
    "v2452a": [
        "VV"
    ],
    "v2435": [
        "VV"
    ],
    "v2507": [
        "VV"
    ],
    "rmx5055": [
        "RE"
    ],
    "pld110": [
        "OP"
    ],
    "plb110": [
        "OP"
    ],
    "pkq110": [
        "OP"
    ],
    "dnn-an00": [
        "HNR",
        "HU"
    ],
    "dnp-nx9": [
        "HNR",
        "HU"
    ],
    "dny-nx9": [
        "HNR",
        "HU"
    ],
    "dvd-an80": [
        "HNR",
        "HU"
    ],
    "dvd-an00": [
        "HNR",
        "HU"
    ],
    "agi-an00": [
        "HNR",
        "HU"
    ],
    "abr-nx1": [
        "HNR",
        "HU"
    ],
    "abr-lx3": [
        "HNR",
        "HU"
    ],
    "abr-lx2": [
        "HNR",
        "HU"
    ],
    "pku110": [
        "OP"
    ],
    "pla110": [
        "OP"
    ],
    "sm-s936w": [
        "SA"
    ],
    "motorola razr ultra 2025": [
        "MR"
    ],
    "xt2245-1": [
        "MR"
    ],
    "xt2235-2": [
        "MR"
    ],
    "xt2231-1": [
        "MR"
    ],
    "v2453a": [
        "VV"
    ],
    "v2445ea": [
        "VV"
    ],
    "v2445a": [
        "VV"
    ],
    "v2443": [
        "VV"
    ],
    "v2428": [
        "VV"
    ],
    "sog11": [
        "SO"
    ],
    "sm-s9310": [
        "SA"
    ],
    "i2407": [
        "VV"
    ],
    "i2405": [
        "VV"
    ],
    "v1916t": [
        "VV"
    ],
    "wlz-tn00": [
        "HU"
    ],
    "live 12": [
        "KE"
    ],
    "jp2": [
        "JAM"
    ],
    "hmd xr21": [
        "HMD"
    ],
    "hmd arc": [
        "HMD"
    ],
    "hammer_construction_2_thermal_5g": [
        "HAM"
    ],
    "hammer_construction_2_5g": [
        "HAM"
    ],
    "f112 pro": [
        "FOS"
    ],
    "discovery_2_me": [
        "FS"
    ],
    "bold k50": [
        "BU"
    ],
    "apex_5g": [
        "69"
    ],
    "magno pro": [
        "ZU"
    ],
    "magno c plus": [
        "ZU"
    ],
    "kingkong power 5": [
        "CB",
        "L5"
    ],
    "tecno cm6": [
        "TB"
    ],
    "tecno cm8": [
        "TB"
    ],
    "a001": [
        "CMF"
    ],
    "s punk pro": [
        "DO"
    ],
    "s cyber pro": [
        "DO"
    ],
    "panasonic eluga tapp": [
        "PA"
    ],
    "25053pc47g": [
        "0P"
    ],
    "inoi_5x": [
        "I4"
    ],
    "l68_ultra": [
        "1L"
    ],
    "soyes 7s": [
        "8S"
    ],
    "perm10_k10": [
        "OP"
    ],
    "cph2725": [
        "OP"
    ],
    "25078ra3ey": [
        "XI"
    ],
    "25067pye3c": [
        "XI"
    ],
    "25042pn24c": [
        "XI"
    ],
    "v max s": [
        "DO"
    ],
    "sog13": [
        "SO"
    ],
    "sm-m166p": [
        "SA"
    ],
    "sm-e166p": [
        "SA"
    ],
    "sm-a356n": [
        "SA"
    ],
    "sm-a166e": [
        "SA"
    ],
    "sm-a165f": [
        "SA"
    ],
    "sm-a1560": [
        "SA"
    ],
    "sl219c": [
        "CK"
    ],
    "sh-m29": [
        "SH"
    ],
    "s3 pro": [
        "FOS"
    ],
    "s23 pro max": [
        "RD"
    ],
    "s119": [
        "DO"
    ],
    "rmx3952": [
        "RE"
    ],
    "play25_pro_4g": [
        "4R"
    ],
    "ob-a98": [
        "UZ"
    ],
    "nokia 8": [
        "NK"
    ],
    "lt c26": [
        "QL"
    ],
    "kingkong x pro": [
        "CB"
    ],
    "ajib i10": [
        "AJI"
    ],
    "u380aa": [
        "6A"
    ],
    "sm-a716s": [
        "SA"
    ],
    "rungee x9": [
        "RUN"
    ],
    "z2472": [
        "ZT"
    ],
    "xq-fs72": [
        "SO"
    ],
    "xq-fs44": [
        "SO"
    ],
    "rmx5062": [
        "RE"
    ],
    "plf110": [
        "ON"
    ],
    "plc110": [
        "ON"
    ],
    "pkc130": [
        "OP"
    ],
    "i2502": [
        "VV"
    ],
    "i2221": [
        "VV"
    ],
    "24095pcadi": [
        "0P"
    ],
    "lt e18": [
        "QL"
    ],
    "lt e16": [
        "QL"
    ],
    "itel a671lc": [
        "IZ"
    ],
    "hmd vibe": [
        "HMD"
    ],
    "black_e": [
        "KL"
    ],
    "alt-lx3": [
        "HNR"
    ],
    "2411drn47i": [
        "XI"
    ],
    "4g mega power": [
        "CAL"
    ],
    "4g maxx": [
        "CAL"
    ],
    "4g hot": [
        "CAL"
    ],
    "4g-hero": [
        "CAL"
    ],
    "4g smart": [
        "CAL"
    ],
    "4g prime": [
        "CAL"
    ],
    "4g ultra pro": [
        "0G"
    ],
    "4g style": [
        "0G"
    ],
    "4g star": [
        "CAL"
    ],
    "4g spark": [
        "CAL"
    ],
    "4g 6700": [
        "0G"
    ],
    "4g lite": [
        "CAL"
    ],
    "4g power": [
        "CAL"
    ],
    "4g music": [
        "CAL"
    ],
    "4g cloud": [
        "CAL"
    ],
    "dnp-an00": [
        "HNR"
    ],
    "armor 34 pro": [
        "UL"
    ],
    "action a5pro": [
        "5F"
    ],
    "armor x16": [
        "UL"
    ],
    "via x45": [
        "R4"
    ],
    "rmx5033": [
        "RE"
    ],
    "poco x7 pro": [
        "0P"
    ],
    "poco x7": [
        "0P"
    ],
    "poco c61": [
        "0P"
    ],
    "poco f7": [
        "0P"
    ],
    "poco f7 pro": [
        "0P"
    ],
    "poco f7 ultra": [
        "0P"
    ],
    "poco m7 pro 5g": [
        "0P"
    ],
    "nic-lx1": [
        "HNR"
    ],
    "nic-an00": [
        "HNR",
        "HU"
    ],
    "nic-lx2": [
        "HNR",
        "HU"
    ],
    "nic-lx3": [
        "HNR"
    ],
    "note58 pro": [
        "DO"
    ],
    "note59 pro+": [
        "DO"
    ],
    "mblu 22": [
        "M1"
    ],
    "infinix x6885": [
        "IF"
    ],
    "infinix x6728": [
        "IF"
    ],
    "infinix x6726b": [
        "IF"
    ],
    "infinix x6725c": [
        "IF"
    ],
    "infinix x6882b": [
        "IF"
    ],
    "infinix smart 8 pro": [
        "IF"
    ],
    "infinix smart 8": [
        "IF"
    ],
    "net hit": [
        "K2"
    ],
    "net alpha": [
        "K2"
    ],
    "aura prime": [
        "ZU"
    ],
    "aura m1": [
        "ZU"
    ],
    "aura z1": [
        "ZU"
    ],
    "itel c671l": [
        "IZ"
    ],
    "itel a6610l": [
        "IZ"
    ],
    "itel p666l": [
        "IZ"
    ],
    "f-51e": [
        "FU"
    ],
    "w11": [
        "HV"
    ],
    "phj110_a1": [
        "OP"
    ],
    "infinix x6532c": [
        "IF"
    ],
    "cph2773": [
        "OP"
    ],
    "sens g": [
        "ZU"
    ],
    "cls-al00": [
        "HU"
    ],
    "cls-al30": [
        "HU"
    ],
    "lt_6217": [
        "QL"
    ],
    "xenium s706": [
        "PH"
    ],
    "mrk-bd00": [
        "8X"
    ],
    "sp210": [
        "C3"
    ],
    "sp300": [
        "C3"
    ],
    "sp200": [
        "C3"
    ],
    "blk-lx9": [
        "HU"
    ],
    "blk-al80": [
        "HU"
    ],
    "bison1": [
        "XT"
    ],
    "alpha 1r": [
        "LA"
    ],
    "tlr-al00": [
        "HU"
    ],
    "zeus_4g_pro": [
        "FS"
    ],
    "iphone18,1": [
        "AP"
    ],
    "iphone18,2": [
        "AP"
    ],
    "iphone18,3": [
        "AP"
    ],
    "iphone18,4": [
        "AP"
    ],
    "fire 3 pro": [
        "DO"
    ],
    "fire 3 ultra": [
        "DO"
    ],
    "fire 3": [
        "DO"
    ],
    "cyber 16 pro": [
        "HV"
    ],
    "color 6": [
        "B2"
    ],
    "f109 s": [
        "FOS"
    ],
    "f107 pro": [
        "FOS"
    ],
    "blade20 pro": [
        "DO"
    ],
    "blade20 play": [
        "DO"
    ],
    "blade20 max": [
        "DO"
    ],
    "blade20 ultra": [
        "DO"
    ],
    "blade gt pro": [
        "DO"
    ],
    "blade gt play": [
        "DO"
    ],
    "blade20": [
        "DO"
    ],
    "blade10 energy": [
        "DO"
    ],
    "wp56": [
        "OE"
    ],
    "wp53 s": [
        "OE"
    ],
    "wp53 pro": [
        "OE"
    ],
    "wp53": [
        "OE"
    ],
    "wp55 ultra": [
        "OE"
    ],
    "wp300": [
        "OE"
    ],
    "pixel 10": [
        "GO"
    ],
    "pixel 10 pro": [
        "GO"
    ],
    "pixel 10 pro xl": [
        "GO"
    ],
    "xplore 1": [
        "B2"
    ],
    "hisense e71": [
        "HI"
    ],
    "sparx edge 20": [
        "SPX"
    ],
    "tyh651m-02": [
        "U9"
    ],
    "mtn-nx1": [
        "HNR",
        "HU"
    ],
    "mtn-an80": [
        "HNR",
        "HU"
    ],
    "mtn-an00": [
        "HNR",
        "HU"
    ],
    "25060rk16c": [
        "XI"
    ],
    "mz-meizu c9 pro": [
        "M1"
    ],
    "qmobile e1": [
        "QM"
    ],
    "25098pn5ac": [
        "XI"
    ],
    "buzz 7 note": [
        "AE"
    ],
    "clk-nx3": [
        "HNR"
    ],
    "v2534": [
        "VV"
    ],
    "v2531": [
        "VV"
    ],
    "v2529": [
        "VV"
    ],
    "v2527": [
        "VV"
    ],
    "v2521": [
        "VV"
    ],
    "v2520": [
        "VV"
    ],
    "v2518": [
        "VV"
    ],
    "v2513": [
        "VV"
    ],
    "v2511": [
        "VV"
    ],
    "v2510": [
        "VV"
    ],
    "v2509": [
        "VV"
    ],
    "v2508": [
        "VV"
    ],
    "xiaomi 14t": [
        "XI"
    ],
    "2509fpn0bc": [
        "XI"
    ],
    "bkq-an10": [
        "HNR"
    ],
    "xig07": [
        "XI"
    ],
    "25113pn0ec": [
        "XI"
    ],
    "xt2527-3": [
        "MR"
    ],
    "xt2507-5": [
        "MR"
    ],
    "xt2505-4": [
        "MR"
    ],
    "xt2451-4": [
        "MR"
    ],
    "wp210 pro": [
        "OE"
    ],
    "v max play": [
        "DO"
    ],
    "vtl-202402": [
        "VE"
    ],
    "thinkphone 25 by motorola": [
        "MR"
    ],
    "rugking": [
        "UL"
    ],
    "v2507a": [
        "VV"
    ],
    "v2530": [
        "VV"
    ],
    "v2506a": [
        "VV"
    ],
    "v2503": [
        "VV"
    ],
    "v2502": [
        "VV"
    ],
    "v2465a": [
        "VV"
    ],
    "v2463a": [
        "VV"
    ],
    "v2506": [
        "VV"
    ],
    "v2455": [
        "VV"
    ],
    "v2448": [
        "VV"
    ],
    "v2446": [
        "VV"
    ],
    "v2439": [
        "VV"
    ],
    "v2432": [
        "VV"
    ],
    "v2431": [
        "VV"
    ],
    "v2407": [
        "VV"
    ],
    "rmx5106": [
        "RE"
    ],
    "rmx5101": [
        "RE"
    ],
    "rmx5054": [
        "RE"
    ],
    "rmx5004": [
        "RE"
    ],
    "rmx3946": [
        "RE"
    ],
    "rmx3945": [
        "RE"
    ],
    "rmx3944": [
        "RE"
    ],
    "poco c85": [
        "0P"
    ],
    "poco c71": [
        "0P"
    ],
    "poco m7": [
        "0P"
    ],
    "2506bpn68g": [
        "XI"
    ],
    "pln110": [
        "OP"
    ],
    "ple110": [
        "OP"
    ],
    "pkw110": [
        "OP"
    ],
    "mz-meizu 20": [
        "M1"
    ],
    "mz-meizu 21": [
        "M1"
    ],
    "mz-meizu 21 note": [
        "M1"
    ],
    "mz-meizu note 16 pro": [
        "M1"
    ],
    "25010pn30c": [
        "XI"
    ],
    "voix_u10": [
        "VOI"
    ],
    "v smart 2": [
        "6W"
    ],
    "wod-lx3": [
        "HNR",
        "HU"
    ],
    "wildfire e5": [
        "HT"
    ],
    "abr-an00": [
        "HNR",
        "HU"
    ],
    "ai+ pulse 1": [
        "AL2"
    ],
    "ai+ nova 1 5g": [
        "AL2"
    ],
    "2508crn2be": [
        "XI"
    ],
    "25078ra3ee": [
        "XI"
    ],
    "25078ra3ea": [
        "XI"
    ],
    "25078pc3eg": [
        "0P"
    ],
    "25069ptebg": [
        "XI"
    ],
    "25062rn2dy": [
        "XI"
    ],
    "25062rn2de": [
        "XI"
    ],
    "25062rn2da": [
        "XI"
    ],
    "25062pc34g": [
        "0P"
    ],
    "25062pc34e": [
        "0P"
    ],
    "25028rn03i": [
        "XI"
    ],
    "25010pn30i": [
        "XI"
    ],
    "zte a2025h": [
        "ZT"
    ],
    "wildfire e7": [
        "HT"
    ],
    "v2505a": [
        "VV"
    ],
    "v2502a": [
        "VV"
    ],
    "hmd vibe 5g": [
        "HMD"
    ],
    "shr-an00": [
        "WI"
    ],
    "jlg-an00": [
        "WI"
    ],
    "villaon v651w": [
        "VI1"
    ],
    "plr-al30": [
        "HU"
    ],
    "rocky_mt1": [
        "EDX"
    ],
    "lmu-lx9": [
        "HU"
    ],
    "hed-lx9": [
        "HU"
    ],
    "i2505": [
        "VV"
    ],
    "i2410": [
        "VV"
    ],
    "i2409": [
        "VV"
    ],
    "i2404": [
        "VV"
    ],
    "hyper 7s": [
        "HV"
    ],
    "lgn-lx1": [
        "HNR",
        "HU"
    ],
    "kingkong 11": [
        "CB"
    ],
    "infinix zero 40": [
        "IF"
    ],
    "infinix zero 40 5g": [
        "IF"
    ],
    "infinix x6886": [
        "IF"
    ],
    "infinix-x6833b": [
        "IF"
    ],
    "infinix x6730": [
        "IF"
    ],
    "infinix x6730b": [
        "IF"
    ],
    "infinix gt 20 pro": [
        "IF"
    ],
    "cle-an00": [
        "HNR",
        "HU"
    ],
    "2409fpcc4i": [
        "0P"
    ],
    "ela-lx2": [
        "HNR"
    ],
    "brp-nx3": [
        "HNR",
        "HU"
    ],
    "brp-nx1m": [
        "HNR",
        "HU"
    ],
    "v2414": [
        "VV"
    ],
    "v2408": [
        "VV"
    ],
    "sm-a556u": [
        "SA"
    ],
    "rmx5313": [
        "RE"
    ],
    "rmx5111": [
        "RE"
    ],
    "rmx5250": [
        "RE"
    ],
    "rmx5116": [
        "RE"
    ],
    "rmx5110": [
        "RE"
    ],
    "nla-lx2p": [
        "HNR",
        "HU"
    ],
    "m2104k10ac": [
        "XI"
    ],
    "moto g play - 2023": [
        "MR"
    ],
    "gs55-6": [
        "GS"
    ],
    "gs57-6": [
        "GS"
    ],
    "gs53-6": [
        "GS"
    ],
    "g-tide e57": [
        "GT"
    ],
    "g-tide e60": [
        "GT"
    ],
    "g-tide e66": [
        "GT"
    ],
    "g-tide e72": [
        "GT"
    ],
    "g-tide e77": [
        "GT"
    ],
    "g-tide_a1": [
        "GT"
    ],
    "g-tide_s3": [
        "GT"
    ],
    "g-tide_s4": [
        "GT"
    ],
    "g-tide shining7": [
        "GT"
    ],
    "g-tide v6": [
        "GT"
    ],
    "rs61d ultimate": [
        "GZ"
    ],
    "rs62d ultimate": [
        "GZ"
    ],
    "rs71d": [
        "GZ"
    ],
    "rs74d": [
        "GZ"
    ],
    "rs81d": [
        "GZ"
    ],
    "rs8501": [
        "GZ"
    ],
    "rs8502": [
        "GZ"
    ],
    "ginzzu rs94d": [
        "GZ"
    ],
    "ginzzu_rs95d": [
        "GZ"
    ],
    "rs9602": [
        "GZ"
    ],
    "rs96d": [
        "GZ"
    ],
    "rs97d": [
        "GZ"
    ],
    "ginzzu_s4010": [
        "GZ"
    ],
    "s4020": [
        "GZ"
    ],
    "s4030": [
        "GZ"
    ],
    "ginzzu s4710": [
        "GZ"
    ],
    "s5040": [
        "GZ"
    ],
    "s5050": [
        "GZ"
    ],
    "s5120": [
        "GZ"
    ],
    "ginzzu st6040": [
        "GZ"
    ],
    "ginzzu st6120": [
        "GZ"
    ],
    "neo_a100": [
        "H1"
    ],
    "neo_a300": [
        "H1"
    ],
    "neo_a700": [
        "H1"
    ],
    "neo_a900": [
        "H1"
    ],
    "hoffmann x-max": [
        "H1"
    ],
    "hoffmann x-prime": [
        "H1"
    ],
    "hoffmann x twist": [
        "H1"
    ],
    "boost ii": [
        "H2"
    ],
    "boost iise": [
        "H2"
    ],
    "boost3": [
        "H2"
    ],
    "easy f": [
        "H2"
    ],
    "highscreen easy f pro": [
        "H2"
    ],
    "easy l": [
        "H2"
    ],
    "easy l pro": [
        "H2"
    ],
    "easy-power": [
        "H2"
    ],
    "highscreen easy-power-pro": [
        "H2"
    ],
    "easy power pro": [
        "H2"
    ],
    "easy-power-pro": [
        "H2"
    ],
    "easy_s": [
        "H2"
    ],
    "easy_s_pro": [
        "H2"
    ],
    "easy xl": [
        "H2"
    ],
    "easy xl pro": [
        "H2"
    ],
    "festxl": [
        "H2"
    ],
    "power five evo": [
        "H2"
    ],
    "power five max": [
        "H2"
    ],
    "powerfivemax2": [
        "H2"
    ],
    "powerfivemaxlite": [
        "H2"
    ],
    "powerfivepro": [
        "H2"
    ],
    "powerfour": [
        "H2"
    ],
    "power ice": [
        "H2"
    ],
    "power ice evo": [
        "H2"
    ],
    "power ice max": [
        "H2"
    ],
    "power rage": [
        "H2"
    ],
    "power rage evo": [
        "H2"
    ],
    "pure_power": [
        "H2"
    ],
    "razar_pro": [
        "H2"
    ],
    "tasty": [
        "H2"
    ],
    "winwin": [
        "H2"
    ],
    "zera f": [
        "H2"
    ],
    "zera_s": [
        "H2"
    ],
    "zera-s-power": [
        "H2"
    ],
    "zera u": [
        "H2"
    ],
    "hm-g152-fl": [
        "HA"
    ],
    "hm-g303-w": [
        "HA"
    ],
    "hm-g353-fl": [
        "HA"
    ],
    "hm-g552-fl": [
        "HA"
    ],
    "hm-g700-fl": [
        "HA"
    ],
    "hm-g701-fl": [
        "HA"
    ],
    "haier hw-n86w": [
        "HA"
    ],
    "haier_hw-w716_wcdma": [
        "HA"
    ],
    "haier hw-w718": [
        "HA"
    ],
    "haier_hw-w860_wcdma": [
        "HA"
    ],
    "haier hw-w910": [
        "HA"
    ],
    "hm-i557-fl": [
        "HA"
    ],
    "i6_infinity": [
        "HA"
    ],
    "hm-n505-fl": [
        "HA"
    ],
    "hm-n501-fl": [
        "HA"
    ],
    "hm-n700-fl": [
        "HA"
    ],
    "haier-sy0880": [
        "HA"
    ],
    "titan_t1": [
        "HA"
    ],
    "titan_t3": [
        "HA"
    ],
    "hw-w716": [
        "HA"
    ],
    "w716": [
        "HA"
    ],
    "w757": [
        "HA"
    ],
    "w860": [
        "HA"
    ],
    "w970": [
        "HA"
    ],
    "huadoo_hg04": [
        "HD"
    ],
    "huadoo hg06": [
        "HD"
    ],
    "huadoo hg11": [
        "HD"
    ],
    "huadoo v3": [
        "HD"
    ],
    "huadoo v4": [
        "HD"
    ],
    "hafury mix": [
        "HF",
        "XI"
    ],
    "hafury umax": [
        "HF"
    ],
    "hlte202n": [
        "HI"
    ],
    "hlte203t": [
        "HI"
    ],
    "hlte700t": [
        "HI"
    ],
    "hlte730t": [
        "HI"
    ],
    "hlte221e": [
        "HI"
    ],
    "hs-hisense e621t": [
        "HI"
    ],
    "hitv300c": [
        "HI"
    ],
    "hlte200t": [
        "HI"
    ],
    "hlte210t": [
        "HI"
    ],
    "hlte215t": [
        "HI"
    ],
    "hlte217t": [
        "HI"
    ],
    "hlte227t": [
        "HI"
    ],
    "hlte500t": [
        "HI"
    ],
    "hlte310t": [
        "HI"
    ],
    "hlte310m": [
        "HI"
    ],
    "hlte510t": [
        "HI"
    ],
    "hlte510m": [
        "HI"
    ],
    "hlte223e": [
        "HI"
    ],
    "hlte200m": [
        "HI"
    ],
    "hlte212t": [
        "HI"
    ],
    "hlte300t": [
        "HI"
    ],
    "hs-e920": [
        "HI"
    ],
    "hs-e968": [
        "HI"
    ],
    "hs-eg970": [
        "HI"
    ],
    "hs-g610": [
        "HI"
    ],
    "hs-i630m": [
        "HI"
    ],
    "hs-i630t": [
        "HI"
    ],
    "hs-l691": [
        "HI"
    ],
    "hs-t912": [
        "HI"
    ],
    "hs-t958": [
        "HI"
    ],
    "hs-t959s1": [
        "HI"
    ],
    "hs-t96": [
        "HI"
    ],
    "hs-u8": [
        "HI"
    ],
    "hs-u820": [
        "HI"
    ],
    "hs-u850": [
        "HI"
    ],
    "hs-u912": [
        "HI"
    ],
    "hs-u912c": [
        "HI"
    ],
    "hs-u929": [
        "HI"
    ],
    "hs-u939": [
        "HI"
    ],
    "hs-u950": [
        "HI"
    ],
    "hs-u966": [
        "HI"
    ],
    "hs-u970": [
        "HI"
    ],
    "hs-u98": [
        "HI"
    ],
    "hs-x1": [
        "HI"
    ],
    "hs-x68t_lte": [
        "HI"
    ],
    "hs-x68t": [
        "HI"
    ],
    "hs-x8c": [
        "HI"
    ],
    "hs-x8t": [
        "HI"
    ],
    "hisense i639m_lte": [
        "HI"
    ],
    "hisense i639t": [
        "HI"
    ],
    "hlte213t": [
        "HI"
    ],
    "hlte311t": [
        "HI"
    ],
    "hlte216t": [
        "HI"
    ],
    "hlte316t": [
        "HI"
    ],
    "hlte226t": [
        "HI"
    ],
    "i46d1g": [
        "HI"
    ],
    "eg680": [
        "HI"
    ],
    "hlte501n": [
        "HI"
    ],
    "homtom_ht16": [
        "HM"
    ],
    "ht17": [
        "HM"
    ],
    "ht17pro": [
        "HM"
    ],
    "ht20": [
        "HM"
    ],
    "ht3": [
        "HM"
    ],
    "ht30": [
        "HM"
    ],
    "ht7 pro": [
        "HM"
    ],
    "homtom ht7 pro": [
        "HM"
    ],
    "homtom nt17pro": [
        "HM"
    ],
    "g25523k": [
        "HN"
    ],
    "g25524k": [
        "HN"
    ],
    "g24027k": [
        "HN"
    ],
    "w25042l": [
        "HN"
    ],
    "ultra air": [
        "HN"
    ],
    "ultra energy": [
        "HN"
    ],
    "ultra energy lite": [
        "HN",
        "E1"
    ],
    "ultra energy plus": [
        "HN",
        "E1"
    ],
    "ultra live ii": [
        "HN"
    ],
    "ultra storm": [
        "HN"
    ],
    "ultra sync": [
        "HN"
    ],
    "ultra trend": [
        "HN"
    ],
    "ultra vision": [
        "HN"
    ],
    "ultra wave": [
        "HN"
    ],
    "hosin t50": [
        "HO"
    ],
    "hosin t50(open)": [
        "HO"
    ],
    "hosin t70": [
        "HO"
    ],
    "hosin_u7": [
        "HO"
    ],
    "hosin v70": [
        "HO"
    ],
    "elite x3": [
        "HP"
    ],
    "hasee e50 t1": [
        "HS"
    ],
    "hasee h45 t3": [
        "HS"
    ],
    "hasee w50 t2": [
        "HS"
    ],
    "hasee x50 ts": [
        "HS"
    ],
    "htv32": [
        "HT"
    ],
    "htc 608": [
        "HT"
    ],
    "htc6500lvw 4g": [
        "HT"
    ],
    "7 mozart": [
        "HT"
    ],
    "7 mozart t8698": [
        "HT"
    ],
    "7 trophy": [
        "HT"
    ],
    "7 trophy t8686": [
        "HT"
    ],
    "htc_802w": [
        "HT"
    ],
    "htc-a9192/1.0": [
        "HT"
    ],
    "adr6325": [
        "HT"
    ],
    "adr6410lvw": [
        "HT"
    ],
    "adr6410lvw 4g": [
        "HT"
    ],
    "adr6425lvw 4g": [
        "HT"
    ],
    "htc_amaze": [
        "HT"
    ],
    "amaze_4g": [
        "HT"
    ],
    "htc amaze 4g": [
        "HT"
    ],
    "amaze 4g": [
        "HT"
    ],
    "sprint apa7373kt": [
        "HT"
    ],
    "sprint apa9292kt": [
        "HT"
    ],
    "2pyb2": [
        "HT"
    ],
    "htc butterfly": [
        "HT"
    ],
    "htc_butterfly": [
        "HT"
    ],
    "butterfly2": [
        "HT"
    ],
    "htc_c525u-orange-ls/1.17.73.10": [
        "HT"
    ],
    "htc": [
        "HT"
    ],
    "htc_c715c": [
        "HT"
    ],
    "htc chacha a810e": [
        "HT"
    ],
    "htc_chacha_a810e": [
        "HT"
    ],
    "htc desire 2.33.161.6": [
        "HT"
    ],
    "htc desire": [
        "HT"
    ],
    "htc_desire_300": [
        "HT"
    ],
    "htc_desire_500": [
        "HT"
    ],
    "htc_desire_500/1.17.112.2": [
        "HT"
    ],
    "htc desire 500": [
        "HT"
    ],
    "0pcv1": [
        "HT"
    ],
    "htc_desire_600_dual_sim": [
        "HT"
    ],
    "htc desire 601": [
        "HT"
    ],
    "htc 608t": [
        "HT"
    ],
    "0pm92": [
        "HT"
    ],
    "htc_desire_a8181": [
        "HT"
    ],
    "desire_a8181": [
        "HT"
    ],
    "htc desire c": [
        "HT"
    ],
    "htc_desire_c": [
        "HT"
    ],
    "htc_desire_c/2.00.111.3": [
        "HT"
    ],
    "htc_desire_c_n/2.01.163.1": [
        "HT"
    ],
    "htc_desire_c-orange-ls": [
        "HT"
    ],
    "htc desire hd 1.75.163.2": [
        "HT"
    ],
    "desire hd": [
        "HT"
    ],
    "htc_desire_hd": [
        "HT"
    ],
    "htc desire hd": [
        "HT"
    ],
    "htc desire hd a9191": [
        "HT"
    ],
    "htc desire s": [
        "HT"
    ],
    "desire s": [
        "HT"
    ],
    "htc desire sv": [
        "HT"
    ],
    "htc_desire_u_dual_sim": [
        "HT"
    ],
    "htc desire v": [
        "HT"
    ],
    "htc_desire_v": [
        "HT"
    ],
    "htc desire x": [
        "HT"
    ],
    "htc_desire_x": [
        "HT"
    ],
    "htc_desire_x-orange-ls/1.14.75.1": [
        "HT"
    ],
    "htc_desirehd": [
        "HT"
    ],
    "htc_desirehd_a9191": [
        "HT"
    ],
    "htc_desirehd_a9192": [
        "HT"
    ],
    "htc_desirehd-orange-ls": [
        "HT"
    ],
    "htc/desires/1.32.163.1": [
        "HT"
    ],
    "htc_desires_s510e": [
        "HT"
    ],
    "htc_desires-orange-ls": [
        "HT"
    ],
    "htc_desiresv": [
        "HT"
    ],
    "htc_desirez_a7272": [
        "HT"
    ],
    "htc_dream": [
        "HT"
    ],
    "adr6300": [
        "HT"
    ],
    "adr6410lra": [
        "HT"
    ],
    "htc/evo_3d/3.28.163.1": [
        "HT"
    ],
    "htc evo 3d gsm": [
        "HT"
    ],
    "evo 3d gsm": [
        "HT"
    ],
    "htc evo 3d x515m": [
        "HT"
    ],
    "pg86100": [
        "HT"
    ],
    "pc36100": [
        "HT"
    ],
    "evo3d_x515m": [
        "HT"
    ],
    "htc/explorer/1.41.161.3": [
        "HT"
    ],
    "htc explorer a310e": [
        "HT"
    ],
    "htc_explorer_a310e": [
        "HT"
    ],
    "htc glacier": [
        "HT"
    ],
    "htc_gratia_a6380": [
        "HT"
    ],
    "htc_h1000c": [
        "HT"
    ],
    "htc_h2000c": [
        "HT"
    ],
    "nexushd2": [
        "HT",
        "GO"
    ],
    "htc hd2": [
        "HT"
    ],
    "hd7": [
        "HT"
    ],
    "htc hd7 lte 4g+ for at&amp;t": [
        "HT"
    ],
    "htc hero": [
        "HT"
    ],
    "htc incredible s": [
        "HT"
    ],
    "htc_incredibles_s710e": [
        "HT"
    ],
    "incredibles_s710e": [
        "HT"
    ],
    "htl23": [
        "HT"
    ],
    "htl22": [
        "HT"
    ],
    "htc legend 2.05.163.1": [
        "HT"
    ],
    "htc liberty": [
        "HT"
    ],
    "htc magic": [
        "HT"
    ],
    "htc merge": [
        "HT"
    ],
    "htc 802d": [
        "HT"
    ],
    "htc_one/3.63.161.6": [
        "HT"
    ],
    "htc_one": [
        "HT"
    ],
    "htc one": [
        "HT"
    ],
    "htcone": [
        "HT"
    ],
    "htc one 801e": [
        "HT"
    ],
    "2pq93": [
        "HT"
    ],
    "htc one dual sim": [
        "HT"
    ],
    "0paj5": [
        "HT"
    ],
    "htc one_m8": [
        "HT"
    ],
    "one m8": [
        "HT"
    ],
    "0pja10": [
        "HT"
    ],
    "0pja2": [
        "HT"
    ],
    "htc_one_mini": [
        "HT"
    ],
    "htc one mini": [
        "HT"
    ],
    "htc_one_mini/3.10.161.6": [
        "HT"
    ],
    "htc one s": [
        "HT"
    ],
    "htc_one_s": [
        "HT"
    ],
    "htc_one_s/3.16.161.9": [
        "HT"
    ],
    "htc_one_s-orange-ls": [
        "HT"
    ],
    "htc one sv": [
        "HT"
    ],
    "htc one v": [
        "HT"
    ],
    "htc_one_v": [
        "HT"
    ],
    "htc one x": [
        "HT"
    ],
    "pj83100/2.20.502.7": [
        "HT"
    ],
    "htc_one_x": [
        "HT"
    ],
    "htc_one_x/4.17.161.2": [
        "HT"
    ],
    "one x": [
        "HT"
    ],
    "htc one x+": [
        "HT"
    ],
    "x525a": [
        "HT"
    ],
    "htc_one_xl": [
        "HT"
    ],
    "htc one xl": [
        "HT"
    ],
    "htc/one_xl/5.08.163.2": [
        "HT"
    ],
    "htc_onesv": [
        "HT"
    ],
    "htc_onexplus": [
        "HT"
    ],
    "htc panache": [
        "HT"
    ],
    "htc_pg09410/1.30.502.1": [
        "HT"
    ],
    "htc_ph06130/1.23.502.1": [
        "HT"
    ],
    "htc_pn071-orange-ls/1.28.73.10": [
        "HT"
    ],
    "radar 4g": [
        "HT"
    ],
    "radar c110e": [
        "HT"
    ],
    "htc_rhyme_s510b": [
        "HT"
    ],
    "htc rhyme s510b": [
        "HT"
    ],
    "htc_ruby": [
        "HT"
    ],
    "htc_salsa_c510e": [
        "HT"
    ],
    "schubert": [
        "HT"
    ],
    "htc/sensation/3.32.161.52": [
        "HT"
    ],
    "htc sensation": [
        "HT"
    ],
    "sensationxe_beats_z715e": [
        "HT"
    ],
    "htc_sensation_xe_with_beats_audio": [
        "HT"
    ],
    "htc sensation xe with beats audio": [
        "HT"
    ],
    "htc sensation xe with beats audio z715a": [
        "HT"
    ],
    "htc sensation xe with beats audio z715e": [
        "HT"
    ],
    "sensationxl_beats_x315e": [
        "HT"
    ],
    "htc sensation xl with beats audio x315e": [
        "HT"
    ],
    "htc sensation z710e": [
        "HT"
    ],
    "sensation_z710e": [
        "HT"
    ],
    "htc_sensation-orange-ls": [
        "HT"
    ],
    "htc_sensationxe_beats_z715e": [
        "HT"
    ],
    "htc_sensationxl_beats-orange-ls": [
        "HT"
    ],
    "spark": [
        "HT"
    ],
    "htc_t120c": [
        "HT"
    ],
    "htc_t327w": [
        "HT"
    ],
    "htc t328w": [
        "HT"
    ],
    "htc_t329w": [
        "HT"
    ],
    "htc t528d": [
        "HT"
    ],
    "htc_t528w": [
        "HT"
    ],
    "adr6400l 4g": [
        "HT"
    ],
    "2pzc5": [
        "HT"
    ],
    "htv33": [
        "HT"
    ],
    "601ht": [
        "HT"
    ],
    "htc velocity 4g": [
        "HT"
    ],
    "htc_velocity_4g_x710s": [
        "HT"
    ],
    "htc vision": [
        "HT"
    ],
    "htc-vivo": [
        "HT"
    ],
    "htc vle_u": [
        "HT"
    ],
    "htc wildfire 2.24.164.1": [
        "HT"
    ],
    "htc wildfire": [
        "HT"
    ],
    "htc_wildfire_a3333": [
        "HT"
    ],
    "wildfire e": [
        "HT"
    ],
    "htc wildfire s a510e": [
        "HT"
    ],
    "wildfire s a510e": [
        "HT"
    ],
    "htc_x515c": [
        "HT"
    ],
    "htc_x515e": [
        "HT"
    ],
    "htc x515m": [
        "HT"
    ],
    "pot-al00a": [
        "HU"
    ],
    "pot-tl00a": [
        "HU"
    ],
    "u9500": [
        "HU"
    ],
    "huawei z100-ul00": [
        "HU"
    ],
    "u8818": [
        "HU"
    ],
    "g527-u081": [
        "HU"
    ],
    "g620s-l01": [
        "HU"
    ],
    "g620s-l03": [
        "HU"
    ],
    "c8817d": [
        "HU"
    ],
    "g630-u251": [
        "HU"
    ],
    "g7-l01": [
        "HU"
    ],
    "g7-tl00": [
        "HU"
    ],
    "huawei g730-c00": [
        "HU"
    ],
    "u9200": [
        "HU"
    ],
    "h1711": [
        "HU"
    ],
    "y221-u03": [
        "HU"
    ],
    "y221-u12": [
        "HU"
    ],
    "y221-u22": [
        "HU"
    ],
    "y221-u33": [
        "HU"
    ],
    "y221-u43": [
        "HU"
    ],
    "y221-u53": [
        "HU"
    ],
    "huawei y320-t00": [
        "HU"
    ],
    "huawei y320-u10": [
        "HU"
    ],
    "y320-u10": [
        "HU"
    ],
    "bucare y330-u05": [
        "HU"
    ],
    "y541-u02": [
        "HU"
    ],
    "hw-huawei_c8500s": [
        "HU"
    ],
    "huawei c8812": [
        "HU"
    ],
    "hw-huawei_c8813": [
        "HU"
    ],
    "huawei c8813q": [
        "HU"
    ],
    "hw-huawei_c8815": [
        "HU"
    ],
    "art-al00x": [
        "HU"
    ],
    "art-al00m": [
        "HU"
    ],
    "art-tl00x": [
        "HU"
    ],
    "stk-al00": [
        "HU"
    ],
    "stk-tl00": [
        "HU"
    ],
    "med-al00": [
        "HU"
    ],
    "med-tl00": [
        "HU"
    ],
    "aqm-al00": [
        "HU"
    ],
    "aqm-tl00": [
        "HU"
    ],
    "tag-al00": [
        "HU"
    ],
    "tag-cl00": [
        "HU"
    ],
    "tag-tl00": [
        "HU"
    ],
    "nce-al00": [
        "HU"
    ],
    "nce-al10": [
        "HU"
    ],
    "nce-tl10": [
        "HU"
    ],
    "dig-tl10": [
        "HU"
    ],
    "dig-al00": [
        "HU"
    ],
    "sla-al00": [
        "HU"
    ],
    "sla-tl10": [
        "HU"
    ],
    "trt-al00": [
        "HU"
    ],
    "trt-al00a": [
        "HU"
    ],
    "fig-tl10": [
        "HU"
    ],
    "fig-tl00": [
        "HU"
    ],
    "fig-al00": [
        "HU"
    ],
    "ldn-al10": [
        "HU"
    ],
    "ldn-al20": [
        "HU"
    ],
    "ldn-tl20": [
        "HU"
    ],
    "ldn-tl00": [
        "HU"
    ],
    "atu-al10": [
        "HU"
    ],
    "atu-tl10": [
        "HU"
    ],
    "mrd-tl00": [
        "HU"
    ],
    "mrd-al00": [
        "HU"
    ],
    "u8665": [
        "HU"
    ],
    "g735-l03": [
        "HU"
    ],
    "g735-l12": [
        "HU"
    ],
    "g735-l23": [
        "HU"
    ],
    "chc-u01": [
        "HU"
    ],
    "chc-u03": [
        "HU"
    ],
    "chc-u23": [
        "HU"
    ],
    "huawei g510-0010": [
        "HU"
    ],
    "huaweig510-0100": [
        "HU"
    ],
    "bittium tough mobile 2": [
        "ZB"
    ],
    "logic instrument fieldbook f1": [
        "LH",
        "1L"
    ],
    "jad-lx9": [
        "HU"
    ],
    "amber8s pro": [
        "IP"
    ],
    "hpp-l55b": [
        "U8"
    ],
    "boost hypa": [
        "3H"
    ],
    "elite f55": [
        "SW"
    ],
    "elite a65": [
        "SW"
    ],
    "midnight_sky": [
        "BR"
    ],
    "i12pro max": [],
    "hardcaseh500s": [
        "ED"
    ],
    "ruby5s": [
        "IP"
    ],
    "clearphone 420": [
        "YW"
    ],
    "coolmintta5": [
        "OM"
    ],
    "elite d5": [
        "SW"
    ],
    "heyou40": [
        "E2"
    ],
    "heyou20plus": [
        "E2"
    ],
    "lenumero2": [
        "OS"
    ],
    "mywx1 plus": [
        "MY"
    ],
    "ms507_strong": [
        "7M"
    ],
    "platinum k5": [
        "SW"
    ],
    "platinum_a7": [
        "SW"
    ],
    "ultramintt y5": [
        "OM"
    ],
    "quantum m": [
        "QA"
    ],
    "ravoz r9": [
        "R9"
    ],
    "sonim-xp3800": [
        "OI"
    ],
    "sonim-xp5800": [
        "OI"
    ],
    "sonim-xp3900": [
        "OI"
    ],
    "winnovo_v51": [
        "W5"
    ],
    "ultramintt x6": [
        "OM"
    ],
    "ultramintt y3": [
        "OM"
    ],
    "movic k2": [
        "MV"
    ],
    "krip_k55": [
        "WK"
    ],
    "titan_p6000_pro": [
        "IH"
    ],
    "nexus 2": [
        "GO"
    ],
    "iku a50": [
        "8I"
    ],
    "ih9-l614": [
        "YI"
    ],
    "khatar h-10 mini": [
        "HG"
    ],
    "kodak_smartway_x2": [
        "KK"
    ],
    "shift6mq": [
        "7S"
    ],
    "teeno_i12": [
        "91"
    ],
    "xi_ceu55": [
        "XN"
    ],
    "z6250cc": [
        "ZT"
    ],
    "z6750m": [
        "ZT"
    ],
    "a60uns": [
        "NB"
    ],
    "agm_h3": [
        "A3"
    ],
    "core-x5": [
        "C1"
    ],
    "p1 amateur": [
        "KS"
    ],
    "primo s8": [
        "WA"
    ],
    "primo s8 mini": [
        "WA"
    ],
    "smooth 6.26 max": [
        "HH"
    ],
    "smooth 6.26 pro": [
        "HH"
    ],
    "typhoon_c6": [
        "1J"
    ],
    "asus_x008": [
        "AU"
    ],
    "huawei g525-u00": [
        "HU"
    ],
    "huawei g610-c00": [
        "HU"
    ],
    "huawei g610-c00 build huaweig610-c00) uc": [
        "HU"
    ],
    "huawei g610-u00": [
        "HU"
    ],
    "g621-tl00m": [
        "HU"
    ],
    "g621-tl00": [
        "HU"
    ],
    "dig-l22": [
        "HU"
    ],
    "dig-l21": [
        "HU"
    ],
    "kii-l21": [
        "HU"
    ],
    "bll-l22": [
        "HU"
    ],
    "rio-l03": [
        "HU"
    ],
    "huawei-h867g": [
        "HU"
    ],
    "huawei h881c": [
        "HU"
    ],
    "h883g": [
        "HU"
    ],
    "u8860": [
        "HU"
    ],
    "col-l29": [
        "HU"
    ],
    "hry-tl00": [
        "HU"
    ],
    "hry-lx2": [
        "HU"
    ],
    "hry-lx1meb": [
        "HU"
    ],
    "hry-al00a": [
        "HU"
    ],
    "hry-lx1t": [
        "HU"
    ],
    "huawei u9508": [
        "HU"
    ],
    "yal-l21": [
        "HU"
    ],
    "yal-al00": [
        "HU"
    ],
    "yal-tl00": [
        "HU"
    ],
    "lra-al00": [
        "HU"
    ],
    "yal-l41": [
        "HU"
    ],
    "yal-al10": [
        "HU"
    ],
    "hry-al00ta": [
        "HU"
    ],
    "hry-al00t": [
        "HU"
    ],
    "yal-al50": [
        "HU"
    ],
    "mar-lx1h": [
        "HU"
    ],
    "mxw-an00": [
        "HU"
    ],
    "bmh-an10": [
        "HU"
    ],
    "bmh-an20": [
        "HU"
    ],
    "ebg-an00": [
        "HU"
    ],
    "ebg-an10": [
        "HU"
    ],
    "cdy-an90": [
        "HU"
    ],
    "h30-u10": [
        "HU"
    ],
    "h30-t00": [
        "HU"
    ],
    "h30-t10": [
        "HU"
    ],
    "hw-h30-c00": [
        "HU"
    ],
    "honor_h30-l01m": [
        "HU"
    ],
    "honor h30-l01m": [
        "HU"
    ],
    "honor h30-l02": [
        "HU"
    ],
    "honor h30-l01": [
        "HU"
    ],
    "hol-u19": [
        "HU"
    ],
    "huawei g750-t01": [
        "HU"
    ],
    "scl-tl00h": [
        "HU"
    ],
    "scl-cl00": [
        "HU"
    ],
    "scl-al00": [
        "HU"
    ],
    "chm-u01": [
        "HU"
    ],
    "aqm-al10": [
        "HU"
    ],
    "che2-tl00m": [
        "HU"
    ],
    "che2-l11": [
        "HU"
    ],
    "che2-l12": [
        "HU"
    ],
    "che2-ul00": [
        "HU"
    ],
    "che2-tl00": [
        "HU"
    ],
    "che-tl00h": [
        "HU"
    ],
    "che2-tl00h": [
        "HU"
    ],
    "hw-che1-cl10": [
        "HU"
    ],
    "che1-cl10": [
        "HU"
    ],
    "che1-cl20": [
        "HU"
    ],
    "che1-l04": [
        "HU"
    ],
    "che2-l23": [
        "HU"
    ],
    "cun-al00": [
        "HU"
    ],
    "cun-tl00": [
        "HU"
    ],
    "cam-al00": [
        "HU"
    ],
    "cam-tl00": [
        "HU"
    ],
    "cam-tl00h": [
        "HU"
    ],
    "nem-l51": [
        "HU"
    ],
    "nem-al10": [
        "HU"
    ],
    "nem-ul10": [
        "HU"
    ],
    "nem-tl00": [
        "HU"
    ],
    "nem-tl00h": [
        "HU"
    ],
    "nem-l22": [
        "HU"
    ],
    "kiw-l22": [
        "HU"
    ],
    "kiw-l24": [
        "HU"
    ],
    "kiw-cl00": [
        "HU"
    ],
    "kiw-l21": [
        "HU"
    ],
    "kiw-al10": [
        "HU"
    ],
    "kiw-ul00": [
        "HU"
    ],
    "kiw-tl00": [
        "HU"
    ],
    "kiw-tl00h": [
        "HU"
    ],
    "kiw-l23": [
        "HU"
    ],
    "hw-h60-j1": [
        "HU"
    ],
    "h60-l01": [
        "HU"
    ],
    "h60-l03": [
        "HU"
    ],
    "h60-l11": [
        "HU"
    ],
    "h60-l02": [
        "HU"
    ],
    "h60-l04": [
        "HU"
    ],
    "h60-l12": [
        "HU"
    ],
    "mya-tl10": [
        "HU"
    ],
    "pe-tl00m": [
        "HU"
    ],
    "pe-tl20": [
        "HU"
    ],
    "pe-tl10": [
        "HU"
    ],
    "pe-ul00": [
        "HU"
    ],
    "dli-al10": [
        "HU"
    ],
    "dli-l42": [
        "HU"
    ],
    "dli-tl20": [
        "HU"
    ],
    "dli-l22": [
        "HU"
    ],
    "dig-l21hn": [
        "HU"
    ],
    "jmm-l22": [
        "HU"
    ],
    "bln-tl10": [
        "HU"
    ],
    "bln-l22": [
        "HU"
    ],
    "bln-tl00": [
        "HU"
    ],
    "bln-l21": [
        "HU"
    ],
    "bln-l24": [
        "HU"
    ],
    "bln-al20": [
        "HU"
    ],
    "bln-al30": [
        "HU"
    ],
    "bln-al40": [
        "HU"
    ],
    "hw-plk-cl00": [
        "HU"
    ],
    "plk-ul00": [
        "HU"
    ],
    "plk-l01": [
        "HU"
    ],
    "plk-tl00": [
        "HU"
    ],
    "plk-tl01h": [
        "HU"
    ],
    "plk-al10": [
        "HU"
    ],
    "plk": [
        "HU"
    ],
    "nem-l21": [
        "HU"
    ],
    "aum-tl20": [
        "HU"
    ],
    "aum-l33": [
        "HU"
    ],
    "aum-al20": [
        "HU"
    ],
    "aum-al00": [
        "HU"
    ],
    "lnd-l29": [
        "HU"
    ],
    "lnd-tl40": [
        "HU"
    ],
    "aum-l41": [
        "HU"
    ],
    "lnd-al30": [
        "HU"
    ],
    "ath-al00": [
        "HU"
    ],
    "ath-ul00)": [
        "HU"
    ],
    "ath-tl00h)": [
        "HU"
    ],
    "dua-l22": [
        "HU"
    ],
    "dua-lx3": [
        "HU"
    ],
    "bnd-al10": [
        "HU"
    ],
    "bnd-l21": [
        "HU"
    ],
    "bnd-l31": [
        "HU"
    ],
    "bnd-l24": [
        "HU"
    ],
    "bnd-tl10": [
        "HU"
    ],
    "frd-l04": [
        "HU"
    ],
    "vat-l19": [
        "HU"
    ],
    "frd-l09": [
        "HU"
    ],
    "frd-l14": [
        "HU"
    ],
    "frd-l02": [
        "HU"
    ],
    "frd-l19": [
        "HU"
    ],
    "frd-al00": [
        "HU"
    ],
    "frd-al10": [
        "HU"
    ],
    "frd-dl00": [
        "HU"
    ],
    "pra-al00x": [
        "HU"
    ],
    "pra-al00": [
        "HU"
    ],
    "pra-tl10": [
        "HU"
    ],
    "duk-l09": [
        "HU"
    ],
    "duk-tl30": [
        "HU"
    ],
    "ven-l22": [
        "HU"
    ],
    "jat-lx3": [
        "HU"
    ],
    "jat-lx1": [
        "HU"
    ],
    "jat-l41": [
        "HU"
    ],
    "bkk-al00": [
        "HU"
    ],
    "bkk-al10": [
        "HU"
    ],
    "bkk-l21": [
        "HU"
    ],
    "bkk-l22": [
        "HU"
    ],
    "bkk-lx2": [
        "HU"
    ],
    "bkk-tl00": [
        "HU"
    ],
    "ksa-lx2": [
        "HU"
    ],
    "ksa-al00": [
        "HU"
    ],
    "ksa-lx9": [
        "HU"
    ],
    "jsn-l21": [
        "HU"
    ],
    "jsn-l42": [
        "HU"
    ],
    "jsn-l23": [
        "HU"
    ],
    "jsn-tl00": [
        "HU"
    ],
    "jsn-al00a": [
        "HU"
    ],
    "jsn-al00": [
        "HU"
    ],
    "are-al00": [
        "HU"
    ],
    "are-al10": [
        "HU"
    ],
    "are-tl00": [
        "HU"
    ],
    "are-l22hn": [
        "HU"
    ],
    "stf-al10": [
        "HU"
    ],
    "stf-l09": [
        "HU"
    ],
    "stf-tl10": [
        "HU"
    ],
    "stf-al00": [
        "HU"
    ],
    "lld-al00": [
        "HU"
    ],
    "lld-l21": [
        "HU"
    ],
    "lld-tl10": [
        "HU"
    ],
    "lld-al10": [
        "HU"
    ],
    "lld-l31": [
        "HU"
    ],
    "moa-lx9n": [
        "HU"
    ],
    "aka-l29": [
        "HU"
    ],
    "lld-al20": [
        "HU"
    ],
    "lld-al30": [
        "HU"
    ],
    "dua-lx9": [
        "HU"
    ],
    "hlk-al00": [
        "HU"
    ],
    "hlk-al00a": [
        "HU"
    ],
    "hlk-al10": [
        "HU"
    ],
    "nts-al00": [
        "HU"
    ],
    "tny-al00": [
        "HU"
    ],
    "tny-tl00": [
        "HU"
    ],
    "rvl-al09": [
        "HU"
    ],
    "edi-al10": [
        "HU"
    ],
    "vky-tl00": [
        "HU"
    ],
    "vog-al00": [
        "HU"
    ],
    "ana-an00": [
        "HU"
    ],
    "ana-tn00": [
        "HU"
    ],
    "cor-al10": [
        "HU"
    ],
    "cor-al00": [
        "HU"
    ],
    "cor-tl10": [
        "HU"
    ],
    "ask-al00x": [
        "HU"
    ],
    "ksa-al10": [
        "HU"
    ],
    "tnnh-an00": [
        "HU"
    ],
    "chm-tl00": [
        "HU"
    ],
    "chm-tl00h": [
        "HU"
    ],
    "chm-ul00": [
        "HU"
    ],
    "hw-chm-cl00": [
        "HU"
    ],
    "aka-al10": [
        "HU"
    ],
    "dua-tl00": [
        "HU"
    ],
    "dua-al00": [
        "HU"
    ],
    "jat-tl00": [
        "HU"
    ],
    "moa-al00": [
        "HU"
    ],
    "bkl-l09": [
        "HU"
    ],
    "bkl-al20": [
        "HU"
    ],
    "pct-tl10": [
        "HU"
    ],
    "pct-al10": [
        "HU"
    ],
    "knt-al10": [
        "HU"
    ],
    "knt-tl10": [
        "HU"
    ],
    "knt-ul10": [
        "HU"
    ],
    "knt-al20": [
        "HU"
    ],
    "duk-al20": [
        "HU"
    ],
    "jmm-al00": [
        "HU"
    ],
    "jmm-al10": [
        "HU"
    ],
    "jmm-tl10": [
        "HU"
    ],
    "oxf-an00": [
        "HU"
    ],
    "oxf-an10": [
        "HU"
    ],
    "tel-tn00": [
        "HU"
    ],
    "tel-an00a": [
        "HU"
    ],
    "tel-an00": [
        "HU"
    ],
    "tel-an10": [
        "HU"
    ],
    "scl-l01": [
        "HU"
    ],
    "hw-scl-l32": [
        "HU"
    ],
    "huawei lyo-l21": [
        "HU"
    ],
    "lyo-l21": [
        "HU"
    ],
    "ideos": [
        "HU"
    ],
    "ideos s7": [
        "HU"
    ],
    "ideos s7 slim": [
        "HU"
    ],
    "u8500": [
        "HU"
    ],
    "u8510": [
        "HU"
    ],
    "ideos x5": [
        "HU"
    ],
    "u8800": [
        "HU"
    ],
    "huawei-m931": [
        "HU"
    ],
    "pot-al10": [
        "HU"
    ],
    "alp-al00": [
        "HU"
    ],
    "alp-tl00": [
        "HU"
    ],
    "rne-l21": [
        "HU"
    ],
    "rne-l03": [
        "HU"
    ],
    "rne-al00": [
        "HU"
    ],
    "bla-l09": [
        "HU"
    ],
    "bla-l29": [
        "HU"
    ],
    "bla-tl00": [
        "HU"
    ],
    "hma-al00": [
        "HU"
    ],
    "hma-l09": [
        "HU"
    ],
    "sne-lx1": [
        "HU"
    ],
    "lya-l29": [
        "HU"
    ],
    "lya-l0c": [
        "HU"
    ],
    "lya-tl00": [
        "HU"
    ],
    "lya-al00": [
        "HU"
    ],
    "lya-al00p": [
        "HU"
    ],
    "evr-tl00": [
        "HU"
    ],
    "evr-n29": [
        "HU"
    ],
    "evr-al00": [
        "HU"
    ],
    "evr-an00": [
        "HU"
    ],
    "tas-al00": [
        "HU"
    ],
    "tas-tl00": [
        "HU"
    ],
    "tas-l29": [
        "HU"
    ],
    "tas-an00": [
        "HU"
    ],
    "spn-al00": [
        "HU"
    ],
    "lio-tl00": [
        "HU"
    ],
    "lio-al00": [
        "HU"
    ],
    "lio-l29": [
        "HU"
    ],
    "lio-an00": [
        "HU"
    ],
    "nxt-l29": [
        "HU"
    ],
    "huawei nxt-al10": [
        "HU"
    ],
    "mha-l09": [
        "HU"
    ],
    "mha-al00": [
        "HU"
    ],
    "mha-l29": [
        "HU"
    ],
    "mha-tl00": [
        "HU"
    ],
    "bll-l23": [
        "HU"
    ],
    "neo-al00": [
        "HU"
    ],
    "neo-l29": [
        "HU"
    ],
    "huawei crr-ul00": [
        "HU"
    ],
    "crr-l09": [
        "HU"
    ],
    "bnd-l34": [
        "HU"
    ],
    "tah-an00m": [
        "HU"
    ],
    "huawei caz-al00": [
        "HU"
    ],
    "huawei caz-al10": [
        "HU"
    ],
    "huawei caz-tl10": [
        "HU"
    ],
    "huawei caz-tl20": [
        "HU"
    ],
    "huawei can-l01": [
        "HU"
    ],
    "huawei can-l02": [
        "HU"
    ],
    "huawei can-l03": [
        "HU"
    ],
    "huawei can-l11": [
        "HU"
    ],
    "huawei can-l12": [
        "HU"
    ],
    "huawei can-l13": [
        "HU"
    ],
    "pic-al00": [
        "HU"
    ],
    "pic-tl00": [
        "HU"
    ],
    "hwv31": [
        "HU"
    ],
    "bac-l01": [
        "HU"
    ],
    "bac-tl00": [
        "HU"
    ],
    "bac-al00": [
        "HU"
    ],
    "rne-l22": [
        "HU"
    ],
    "rne-l02": [
        "HU"
    ],
    "hwi-al00": [
        "HU"
    ],
    "hwi-tl00": [
        "HU"
    ],
    "par-lx1": [
        "HU"
    ],
    "par-al00": [
        "HU"
    ],
    "par-tl00": [
        "HU"
    ],
    "par-tl20": [
        "HU"
    ],
    "ane-al00": [
        "HU"
    ],
    "ine-al00": [
        "HU"
    ],
    "vce-al00": [
        "HU"
    ],
    "vce-tl00": [
        "HU"
    ],
    "mar-al00": [
        "HU"
    ],
    "sea-al00": [
        "HU"
    ],
    "sea-al10": [
        "HU"
    ],
    "glk-al00": [
        "HU"
    ],
    "spn-tl00": [
        "HU"
    ],
    "wlz-al10": [
        "HU"
    ],
    "wlz-an00": [
        "HU"
    ],
    "jny-al10": [
        "HU"
    ],
    "jef-an00": [
        "HU"
    ],
    "jef-tn00": [
        "HU"
    ],
    "jer-tn10": [
        "HU"
    ],
    "jer-an10": [
        "HU"
    ],
    "cdy-tn00": [
        "HU"
    ],
    "cdy-an00": [
        "HU"
    ],
    "jny-lx2": [
        "HU"
    ],
    "dig-l01": [
        "HU"
    ],
    "was-al00": [
        "HU"
    ],
    "fig-lx1": [
        "HU"
    ],
    "fig-lx2": [
        "HU"
    ],
    "pot-lx2j": [
        "HU"
    ],
    "pot-lx1": [
        "HU"
    ],
    "pot-lx3": [
        "HU"
    ],
    "pot-lx1af": [
        "HU"
    ],
    "pot-al00": [
        "HU"
    ],
    "vtr-l09": [
        "HU"
    ],
    "vtr-al00": [
        "HU"
    ],
    "vtr-l29": [
        "HU"
    ],
    "was-lx1": [
        "HU"
    ],
    "was-tl10": [
        "HU"
    ],
    "was-lx1a": [
        "HU"
    ],
    "vky-l29": [
        "HU"
    ],
    "vky-al00": [
        "HU"
    ],
    "bac-l23": [
        "HU"
    ],
    "eml-al00": [
        "HU"
    ],
    "eml-l09": [
        "HU"
    ],
    "eml-tl00": [
        "HU"
    ],
    "ane-lx3": [
        "HU"
    ],
    "ane-lx1": [
        "HU"
    ],
    "ane-lx2j": [
        "HU"
    ],
    "ane-tl00": [
        "HU"
    ],
    "hwv32": [
        "HU"
    ],
    "clt-tl01": [
        "HU"
    ],
    "clt-l09": [
        "HU"
    ],
    "clt-al00": [
        "HU"
    ],
    "clt-tl00": [
        "HU"
    ],
    "hw-01k": [
        "HU"
    ],
    "ele-al00": [
        "HU"
    ],
    "ele-tl00": [
        "HU"
    ],
    "mar-lx2": [
        "HU"
    ],
    "mar-tl00": [
        "HU"
    ],
    "nic-lx1a": [
        "HU"
    ],
    "mar-lx1b": [
        "HU"
    ],
    "mar-lx3bm": [
        "HU"
    ],
    "mar-lx1m": [
        "HU"
    ],
    "hwv33": [
        "HU"
    ],
    "mar-lx2j": [
        "HU"
    ],
    "vog-tl00": [
        "HU"
    ],
    "hw-02l": [
        "HU"
    ],
    "vog-al10": [
        "HU"
    ],
    "els-an00": [
        "HU"
    ],
    "els-tn00": [
        "HU"
    ],
    "els-nx9": [
        "HU"
    ],
    "huawei p6-u06": [
        "HU"
    ],
    "huawei gra-ul00": [
        "HU"
    ],
    "huawei gra-l09": [
        "HU"
    ],
    "ale-l21": [
        "HU"
    ],
    "ale-tl00": [
        "HU"
    ],
    "ale-ul00": [
        "HU"
    ],
    "hi6210sft": [
        "HU"
    ],
    "pra-lx1": [
        "HU"
    ],
    "pra-la1": [
        "HU"
    ],
    "pra-lx3": [
        "HU"
    ],
    "eva-l09": [
        "HU"
    ],
    "eva-dl00": [
        "HU"
    ],
    "eva-cl00": [
        "HU"
    ],
    "eva-al00": [
        "HU"
    ],
    "eva-tl00": [
        "HU"
    ],
    "vns-l62": [
        "HU"
    ],
    "huawei vns-l31": [
        "HU"
    ],
    "huawei vns-l21": [
        "HU"
    ],
    "vns-l22": [
        "HU"
    ],
    "sla-l03": [
        "HU"
    ],
    "sla-l22": [
        "HU"
    ],
    "dig-l23": [
        "HU"
    ],
    "vie-l09": [
        "HU"
    ],
    "vie-l29": [
        "HU"
    ],
    "vie-al10": [
        "HU"
    ],
    "ath-ul01": [
        "HU"
    ],
    "ath-ul06": [
        "HU"
    ],
    "huaweit8100": [
        "HU"
    ],
    "u8185": [
        "HU"
    ],
    "u8230": [
        "HU"
    ],
    "u8655-1": [
        "HU"
    ],
    "u8655-51": [
        "HU"
    ],
    "huawei-u8665": [
        "HU"
    ],
    "u8667": [
        "HU"
    ],
    "prism ii": [
        "HU"
    ],
    "u8800pro": [
        "HU"
    ],
    "u8815": [
        "HU"
    ],
    "huawei u8815": [
        "HU"
    ],
    "u8815-51": [
        "HU"
    ],
    "huawei u8825-1": [
        "HU"
    ],
    "huawei u8950-1": [
        "HU"
    ],
    "u9202l-1": [
        "HU"
    ],
    "huawei u9510e": [
        "HU"
    ],
    "w1-u00": [
        "HU"
    ],
    "ars-al00": [
        "HU"
    ],
    "ars-l22": [
        "HU"
    ],
    "ars-tl00": [
        "HU"
    ],
    "huawei y210-0100": [
        "HU"
    ],
    "cro-l02": [
        "HU"
    ],
    "cro-l22": [
        "HU"
    ],
    "cro-u00": [
        "HU"
    ],
    "cag-l02": [
        "HU"
    ],
    "cag-l22": [
        "HU"
    ],
    "huawei y300-0100": [
        "HU"
    ],
    "hw-huawei_y300c": [
        "HU"
    ],
    "huawei lua-u22": [
        "HU"
    ],
    "huawei lua-l21": [
        "HU"
    ],
    "lua-u03": [
        "HU"
    ],
    "lua-l22": [
        "HU"
    ],
    "mya-l22": [
        "HU"
    ],
    "mya-u29": [
        "HU"
    ],
    "mya-l02": [
        "HU"
    ],
    "dra-l21": [
        "HU"
    ],
    "dra-lx3": [
        "HU"
    ],
    "amn-lx2": [
        "HU"
    ],
    "amn-lx1": [
        "HU"
    ],
    "amn-lx9": [
        "HU"
    ],
    "dra-lx5": [
        "HU"
    ],
    "cro-l03": [
        "HU"
    ],
    "cro-l23": [
        "HU"
    ],
    "cag-l03": [
        "HU"
    ],
    "cag-l23": [
        "HU"
    ],
    "dra-lx2": [
        "HU"
    ],
    "dra-al00": [
        "HU"
    ],
    "dra-tl00": [
        "HU"
    ],
    "huawei y511-t00": [
        "HU"
    ],
    "huawei cun-l01": [
        "HU"
    ],
    "huawei cun-l02": [
        "HU"
    ],
    "mi a2 lite) salamweb/2.0.8.1167": [
        "XI"
    ],
    "mara z d": [
        "J4"
    ],
    "lm-x410pm": [
        "LG"
    ],
    "itel l5503s": [
        "IZ"
    ],
    "infinix x625d": [
        "IF"
    ],
    "infinix x652": [
        "IF"
    ],
    "infinix x627w": [
        "IF"
    ],
    "infinix x626b lte": [
        "IF"
    ],
    "hisense rocks 6": [
        "HI"
    ],
    "hisense f19": [
        "HI"
    ],
    "hisense e30": [
        "HI"
    ],
    "qmobile_q_infinity_cinema": [
        "QM"
    ],
    "cinemax_infinity_blaze": [
        "ZN"
    ],
    "cinemax-force": [
        "ZN"
    ],
    "panasonic p95": [
        "PA"
    ],
    "moto e4 plus": [
        "MR"
    ],
    "fp4": [
        "FA"
    ],
    "huawei cun-l03": [
        "HU"
    ],
    "huawei cun-l21": [
        "HU"
    ],
    "huawei cun-l22": [
        "HU"
    ],
    "huawei cun-l23": [
        "HU"
    ],
    "huawei cun-l33": [
        "HU"
    ],
    "huawei cun-u29": [
        "HU"
    ],
    "huawei scc-u21": [
        "HU"
    ],
    "mya-l11": [
        "HU"
    ],
    "mya-l41": [
        "HU"
    ],
    "mya-al10": [
        "HU"
    ],
    "atu-l21": [
        "HU"
    ],
    "atu-l22": [
        "HU"
    ],
    "mrd-lx3": [
        "HU"
    ],
    "mrd-lx1n": [
        "HU"
    ],
    "mrd-lx1f": [
        "HU"
    ],
    "atu-l31": [
        "HU"
    ],
    "huawei tit-al00": [
        "HU"
    ],
    "tit-u02": [
        "HU"
    ],
    "mrd-lx2": [
        "HU"
    ],
    "kavak y625-u03": [
        "HU"
    ],
    "y635-l01": [
        "HU"
    ],
    "y635-l02": [
        "HU"
    ],
    "y635-l03": [
        "HU"
    ],
    "y635-l21": [
        "HU"
    ],
    "cam-l21": [
        "HU"
    ],
    "huawei cam-l03": [
        "HU"
    ],
    "cam-l32": [
        "HU"
    ],
    "med-lx9n": [
        "HU"
    ],
    "trt-lx1": [
        "HU"
    ],
    "trt-lx2": [
        "HU"
    ],
    "dub-tl00": [
        "HU"
    ],
    "dub-lx1": [
        "HU"
    ],
    "dub-lx3": [
        "HU"
    ],
    "trt-tl10": [
        "HU"
    ],
    "ldn-l21": [
        "HU"
    ],
    "ldn-al00": [
        "HU"
    ],
    "ldn-tl10": [
        "HU"
    ],
    "dub-al00": [
        "HU"
    ],
    "dub-al20": [
        "HU"
    ],
    "dub-lx2": [
        "HU"
    ],
    "aqm-lx1": [
        "HU"
    ],
    "fla-al20": [
        "HU"
    ],
    "fla-lx1": [
        "HU"
    ],
    "fla-tl10": [
        "HU"
    ],
    "jkm-tl00": [
        "HU"
    ],
    "jkm-al00": [
        "HU"
    ],
    "jkm-lx1": [
        "HU"
    ],
    "jkm-lx2": [
        "HU"
    ],
    "jkm-lx3": [
        "HU"
    ],
    "stk-l21": [
        "HU"
    ],
    "pearl k2": [
        "HV"
    ],
    "venus_x10": [
        "HV"
    ],
    "venus x12": [
        "HV"
    ],
    "venus x14": [
        "HV"
    ],
    "venus x15": [
        "HV"
    ],
    "venus_x16": [
        "HV"
    ],
    "venus x19": [
        "HV"
    ],
    "if9035": [
        "I0"
    ],
    "if9007": [
        "I0"
    ],
    "if9001": [
        "I0"
    ],
    "if9021": [
        "I0"
    ],
    "if9031": [
        "I0"
    ],
    "w180": [
        "I1"
    ],
    "iocean x7": [
        "I1"
    ],
    "x7s": [
        "I1"
    ],
    "x7s-t": [
        "I1"
    ],
    "x8 mini": [
        "I1"
    ],
    "x8 mini pro": [
        "I1"
    ],
    "nt-3506m": [
        "I2"
    ],
    "a502": [
        "I3"
    ],
    "i10-le": [
        "I3"
    ],
    "imsmart_a401": [
        "I3"
    ],
    "imsmart a501": [
        "I3"
    ],
    "imsmart a503": [
        "I3"
    ],
    "imsmart c501": [
        "I3"
    ],
    "impression imsmart c571": [
        "I3"
    ],
    "inoi_2": [
        "I4"
    ],
    "inoi 2 2019": [
        "I4"
    ],
    "inoi_2_lite": [
        "I4"
    ],
    "inoi 2 lite 2019": [
        "I4"
    ],
    "inoi 2 lite 4gb": [
        "I4"
    ],
    "inoi_3_power": [
        "I4"
    ],
    "inoi_7_lite": [
        "I4"
    ],
    "innjoo 2": [
        "I5"
    ],
    "innjoo 2 lte": [
        "I5"
    ],
    "innjoo 3": [
        "I5"
    ],
    "innjoo 4": [
        "I5"
    ],
    "halo2 3g": [
        "I5"
    ],
    "halo 4": [
        "I5"
    ],
    "halo_4_mini_lte": [
        "I5"
    ],
    "halo plus": [
        "I5"
    ],
    "halo x lte": [
        "I5"
    ],
    "innjoo one 3g": [
        "I5"
    ],
    "innjoo_pro2": [
        "I5"
    ],
    "innjoo x": [
        "I5"
    ],
    "innjoo x3": [
        "I5"
    ],
    "sp05": [
        "I6"
    ],
    "sp06": [
        "I6"
    ],
    "sp20": [
        "I6"
    ],
    "sp21": [
        "I6"
    ],
    "sp401": [
        "I6"
    ],
    "sp402": [
        "I6"
    ],
    "sp41": [
        "I6"
    ],
    "sp42": [
        "I6"
    ],
    "sp43": [
        "I6"
    ],
    "sp453": [
        "I6"
    ],
    "sp454": [
        "I6"
    ],
    "sp455": [
        "I6"
    ],
    "sp46": [
        "I6"
    ],
    "sp493": [
        "I6"
    ],
    "sp494": [
        "I6"
    ],
    "sp50": [
        "I6"
    ],
    "sp510": [
        "I6"
    ],
    "sp511": [
        "I6"
    ],
    "sp514": [
        "I6"
    ],
    "sp517": [
        "I6"
    ],
    "sp531": [
        "I6"
    ],
    "sp541": [
        "I6"
    ],
    "sp542": [
        "I6"
    ],
    "sp550": [
        "I6"
    ],
    "sp551": [
        "I6"
    ],
    "sp552": [
        "I6"
    ],
    "sp554": [
        "I6"
    ],
    "sp571": [
        "I6"
    ],
    "ila_silk": [
        "I7"
    ],
    "ila-x": [
        "I7"
    ],
    "lamcy l350": [
        "I8"
    ],
    "apache g6": [
        "IC"
    ],
    "infinix_buzz": [
        "IF"
    ],
    "infinix hot 4 lite": [
        "IF"
    ],
    "infinix hot 4 pro": [
        "IF"
    ],
    "infinix x606c": [
        "IF"
    ],
    "infinix x608": [
        "IF"
    ],
    "infinix x624": [
        "IF"
    ],
    "infinix x650c": [
        "IF"
    ],
    "infinix x680b": [
        "IF"
    ],
    "infinix-x521": [
        "IF"
    ],
    "infinix x573b": [
        "IF"
    ],
    "infinix x450": [
        "IF"
    ],
    "infinix x501": [
        "IF"
    ],
    "infinix x401": [
        "IF"
    ],
    "infinix x626b": [
        "IF"
    ],
    "infinix x652a": [
        "IF"
    ],
    "infinix x653": [
        "IF"
    ],
    "infinix x503": [
        "IF"
    ],
    "infinix x352": [
        "IF"
    ],
    "infinix x351": [
        "IF"
    ],
    "infinix x530": [
        "IF"
    ],
    "alienxlite2020": [
        "IH"
    ],
    "ihunt_like": [
        "IH"
    ],
    "like_3": [
        "IH"
    ],
    "like_3_pro": [
        "IH"
    ],
    "like_4u": [
        "IH"
    ],
    "one_ love_ dual _camera": [
        "IH"
    ],
    "s10_tank_2019": [
        "IH"
    ],
    "s60_discovery_2019": [
        "IH"
    ],
    "titan_p11000_pro": [
        "IH"
    ],
    "x300 elite": [
        "IH"
    ],
    "intki_e86": [
        "II"
    ],
    "elektra l": [
        "IJ"
    ],
    "elektra xl": [
        "IJ"
    ],
    "i-joy i-call": [
        "IJ"
    ],
    "i-call 300": [
        "IJ"
    ],
    "i-call 300v2": [
        "IJ"
    ],
    "i-call 504": [
        "IJ"
    ],
    "imo discovery ii": [
        "IL"
    ],
    "imo feel a2": [
        "IL"
    ],
    "imo q2": [
        "IL"
    ],
    "imo q2 plus": [
        "IL"
    ],
    "imo q8": [
        "IL"
    ],
    "imo s50": [
        "IL"
    ],
    "imo s67": [
        "IL"
    ],
    "imo s78": [
        "IL"
    ],
    "imo s87": [
        "IL"
    ],
    "imo s88": [
        "IL"
    ],
    "imo s89": [
        "IL"
    ],
    "imo s98": [
        "IL"
    ],
    "imo s99": [
        "IL"
    ],
    "i-style2.1": [
        "IO"
    ],
    "i-style2.1a": [
        "IO"
    ],
    "i-mobile i-style 4": [
        "IO"
    ],
    "i-mobile i-style 7.1": [
        "IO"
    ],
    "i-mobile i-style 7.2": [
        "IO"
    ],
    "i-mobile i-style 7.8 dtv": [
        "IO",
        "KH"
    ],
    "i-mobile i-style 8": [
        "IO"
    ],
    "i-mobile i-style q2 duo": [
        "IO"
    ],
    "i-mobile iq 1068": [
        "IO"
    ],
    "i-mobile iq 3": [
        "IO"
    ],
    "i-mobile iq 5.1a": [
        "IO"
    ],
    "iq 5.5": [
        "IO"
    ],
    "i-mobile iq 5.5": [
        "IO"
    ],
    "iq 5.6": [
        "IO"
    ],
    "iq 5.6a": [
        "IO"
    ],
    "i-mobile iq 6a": [
        "IO"
    ],
    "iq9.1": [
        "IO"
    ],
    "i-mobile iq x3": [
        "IO"
    ],
    "i-mobile iq1-1": [
        "IO"
    ],
    "i-mobile iq5.1 pro": [
        "IO"
    ],
    "jade7s": [
        "IP"
    ],
    "kylin 5.0": [
        "IP"
    ],
    "kylin_5.0s": [
        "IP"
    ],
    "kylin 5.5": [
        "IP"
    ],
    "inq cloud touch": [
        "IQ"
    ],
    "inq cloud touch -parrot": [
        "IQ"
    ],
    "inew_one": [
        "IW"
    ],
    "inew v3": [
        "IW"
    ],
    "v3 plus": [
        "IW"
    ],
    "v3-e": [
        "IW"
    ],
    "v3e": [
        "IW"
    ],
    "v3c": [
        "IW"
    ],
    "v7a": [
        "IW"
    ],
    "aqua_3g": [
        "IX"
    ],
    "aqua.active": [
        "IX"
    ],
    "aqua glory": [
        "IX"
    ],
    "aqua_i-4+": [
        "IX"
    ],
    "intex aqua marvel": [
        "IX",
        "DIS"
    ],
    "aqua star": [
        "IX"
    ],
    "aqua style": [
        "IX"
    ],
    "aqua y2": [
        "IX"
    ],
    "cloud fame 4g": [
        "IX",
        "4M"
    ],
    "intex_cloud_x1": [
        "IX"
    ],
    "intex cloud x11": [
        "IX"
    ],
    "cloud_x2": [
        "IX"
    ],
    "intex cloud x4": [
        "IX"
    ],
    "cloud x5": [
        "IX"
    ],
    "cloud y2": [
        "IX"
    ],
    "intex cloud y4": [
        "IX"
    ],
    "auxus ax01": [
        "IY"
    ],
    "iberry auxus ax02": [
        "IY"
    ],
    "auxus nuclea n1": [
        "IY"
    ],
    "inote_beyond": [
        "IZ"
    ],
    "inote beyond": [
        "IZ",
        "8K"
    ],
    "inote_mini": [
        "IZ"
    ],
    "inote mini": [
        "IZ"
    ],
    "itel it1351": [
        "IZ"
    ],
    "itel it1351e": [
        "IZ"
    ],
    "itel_it1351e": [
        "IZ"
    ],
    "itel_it1400": [
        "IZ"
    ],
    "itel it1500": [
        "IZ"
    ],
    "itel-it1512": [
        "IZ"
    ],
    "itel-it1520": [
        "IZ"
    ],
    "blaster": [
        "J5"
    ],
    "blaster 2": [
        "J5"
    ],
    "cosmo_l707": [
        "J5"
    ],
    "cosmo l808": [
        "J5"
    ],
    "freedom": [
        "J5"
    ],
    "freedom c100": [
        "J5"
    ],
    "freedom_m303": [
        "J5"
    ],
    "freedom x1": [
        "J5"
    ],
    "just5spacer": [
        "J5"
    ],
    "just5-spacer2": [
        "J5"
    ],
    "just5-spacer2s": [
        "J5"
    ],
    "jfone js501": [
        "JF"
    ],
    "jinga basco l3": [
        "JG"
    ],
    "jinga basco neo": [
        "JG"
    ],
    "hotz_m1": [
        "JG"
    ],
    "jinga_igo_l2": [
        "JG"
    ],
    "jinga_igo_m1": [
        "JG"
    ],
    "jinga iron": [
        "JG"
    ],
    "optim4g": [
        "JG"
    ],
    "passplus": [
        "JG"
    ],
    "jinga trezor s1 plus": [
        "JG"
    ],
    "jiayu g2f": [
        "JI"
    ],
    "jiayu g3": [
        "JI"
    ],
    "jiayu g3s": [
        "JI"
    ],
    "jiayu g4": [
        "JI"
    ],
    "jy-g4\\g5": [
        "JI"
    ],
    "jiayu g4_g5": [
        "JI"
    ],
    "jy-g4_g5": [
        "JI"
    ],
    "jiayu g4s": [
        "JI"
    ],
    "jy-g2": [
        "JI"
    ],
    "jy-g3": [
        "JI"
    ],
    "jy-g4": [
        "JI"
    ],
    "jy-g5": [
        "JI"
    ],
    "jiayu s2": [
        "JI"
    ],
    "jiayu-s3": [
        "JI"
    ],
    "jkl a28": [
        "JK"
    ],
    "elegance_4_5": [
        "K1"
    ],
    "elegance_5_0": [
        "K1"
    ],
    "elegance_5_1": [
        "K1"
    ],
    "elegance_5_1_pro": [
        "K1"
    ],
    "elegance_5_5": [
        "K1"
    ],
    "elegance_5_5_pro": [
        "K1"
    ],
    "net1100": [
        "K2"
    ],
    "keneksi_amber": [
        "K3"
    ],
    "keneksi-amulet": [
        "K3"
    ],
    "keneksi_chance": [
        "K3"
    ],
    "keneksi_choice": [
        "K3"
    ],
    "keneksi-crystal": [
        "K3"
    ],
    "keneksi_delta_dual": [
        "K3"
    ],
    "keneksi-dream": [
        "K3"
    ],
    "keneksi-fire": [
        "K3"
    ],
    "keneksi_flame": [
        "K3"
    ],
    "keneksi-flash": [
        "K3"
    ],
    "keneksi-flora": [
        "K3"
    ],
    "keneksi-glass": [
        "K3"
    ],
    "hemera": [
        "K3"
    ],
    "keneksi_liberty": [
        "K3"
    ],
    "keneksi-libra_dual": [
        "K3"
    ],
    "keneksi-moon": [
        "K3"
    ],
    "keneksi-norma": [
        "K3"
    ],
    "keneksi_norma 2": [
        "K3"
    ],
    "keneksi_rock": [
        "K3"
    ],
    "keneksi_sigma": [
        "K3"
    ],
    "keneksi_sky": [
        "K3"
    ],
    "keneksi-solo": [
        "K3"
    ],
    "keneksi_soul": [
        "K3"
    ],
    "keneksi_star": [
        "K3"
    ],
    "keneksi_step": [
        "K3"
    ],
    "keneksi_storm": [
        "K3"
    ],
    "keneksi-sun": [
        "K3"
    ],
    "teta dual": [
        "K3"
    ],
    "keneksi-wind": [
        "K3"
    ],
    "keneksi_zeta": [
        "K3"
    ],
    "kaan_a1": [
        "K4"
    ],
    "kaan n1": [
        "K4"
    ],
    "kaan_n2": [
        "K4"
    ],
    "kuliao k10": [
        "K8"
    ],
    "kooper-mobile-w502": [
        "K9"
    ],
    "karbonn a1*": [
        "KA"
    ],
    "karbonn a1+ duple": [
        "KA"
    ],
    "karbonn a10": [
        "KA"
    ],
    "karbonn a2": [
        "KA"
    ],
    "karbonn_a2+": [
        "KA"
    ],
    "karbonn a26": [
        "KA"
    ],
    "karbonn a27+": [
        "KA"
    ],
    "karbonn a35": [
        "KA"
    ],
    "karbonn a4": [
        "KA"
    ],
    "karbonn a50": [
        "KA"
    ],
    "karbonn a5i": [
        "KA"
    ],
    "karbonn a6": [
        "KA"
    ],
    "karbonn_a91": [
        "KA"
    ],
    "aura note play": [
        "KA"
    ],
    "aura sleek plus": [
        "KA"
    ],
    "k9 kavach 4g": [
        "KA"
    ],
    "k9 music 4g": [
        "KA"
    ],
    "k9 smart": [
        "KA"
    ],
    "k9 smart 1gb": [
        "KA"
    ],
    "k9 smart 4g": [
        "KA"
    ],
    "k9 smart 4g.": [
        "KA"
    ],
    "k9 smart grand": [
        "KA"
    ],
    "k9 smart yuva": [
        "KA"
    ],
    "karbonnk9 viraat 4g": [
        "KA"
    ],
    "k9 viraat 4g": [
        "KA"
    ],
    "karbonn s2": [
        "KA"
    ],
    "titanium jumbo": [
        "KA"
    ],
    "titanium jumbo 2": [
        "KA"
    ],
    "titanium s2 plus": [
        "KA"
    ],
    "titanium_s2_plus": [
        "KA"
    ],
    "titanium_s99": [
        "KA"
    ],
    "titanium vista 4g": [
        "KA"
    ],
    "koobee m2": [
        "KB",
        "M1"
    ],
    "koobee m3": [
        "KB"
    ],
    "koobee-t550": [
        "KB"
    ],
    "kruger&matz drive 4": [
        "KE"
    ],
    "kruger matz drive 4 mini lte": [
        "KE"
    ],
    "kruger&matz drive 4s": [
        "KE"
    ],
    "kruger&matz drive 5": [
        "KE"
    ],
    "kruger_matz flow 4": [
        "KE"
    ],
    "kruger_matz flow 4s": [
        "KE"
    ],
    "krugermatz_live4": [
        "KE"
    ],
    "live4_km0438": [
        "KE"
    ],
    "live4_km0439": [
        "KE"
    ],
    "kruger&matz _live5_km0450": [
        "KE"
    ],
    "move_6_mini": [
        "KE"
    ],
    "kruger&matz move 6s": [
        "KE"
    ],
    "move_7": [
        "KE"
    ],
    "move_8": [
        "KE"
    ],
    "kogan agora 6plus": [
        "KG"
    ],
    "km-e100": [
        "KH"
    ],
    "kingsun": [
        "KI"
    ],
    "kingsun-f1": [
        "KI"
    ],
    "kingsun-s5q": [
        "KI"
    ],
    "kingsun s6": [
        "KI",
        "L2"
    ],
    "kingsun-s8": [
        "KI"
    ],
    "ektra": [
        "KK"
    ],
    "im5": [
        "KK"
    ],
    "kodak_smartway_m1": [
        "KK"
    ],
    "kodak_smartway_t1": [
        "KK"
    ],
    "kodak smartway x1": [
        "KK"
    ],
    "element q": [
        "KL"
    ],
    "komu color": [
        "KM"
    ],
    "komu energy": [
        "KM"
    ],
    "komu-mini": [
        "KM"
    ],
    "sd4930ur": [
        "KN"
    ],
    "kopo l128": [
        "KP"
    ],
    "kopo l8": [
        "KP"
    ],
    "koridy h15": [
        "KR"
    ],
    "koridy h16": [
        "KR"
    ],
    "koridy h20": [
        "KR"
    ],
    "alumini 2": [
        "KS"
    ],
    "alumini3": [
        "KS"
    ],
    "alumini_3_plus": [
        "KS"
    ],
    "alumini3plus": [
        "KS"
    ],
    "kempler_tv": [
        "KS"
    ],
    "kempler_x": [
        "KS"
    ],
    "ktouch_a11": [
        "KT"
    ],
    "k-touch e780": [
        "KT"
    ],
    "k-touch e806": [
        "KT"
    ],
    "k-touch s757": [
        "KT"
    ],
    "k-touch t621": [
        "KT"
    ],
    "k-touch t780": [
        "KT"
    ],
    "k-touch tou ch3": [
        "KT"
    ],
    "k-touch u86": [
        "KT"
    ],
    "k-touch_w619": [
        "KT"
    ],
    "k-touch w658": [
        "KT"
    ],
    "kumai 260": [
        "KU"
    ],
    "km-kumai 290": [
        "KU",
        "KH"
    ],
    "kumai 290s-a": [
        "KU"
    ],
    "kumai 918": [
        "KU"
    ],
    "bigcool": [
        "KW"
    ],
    "coolfive": [
        "KW"
    ],
    "cool-k": [
        "KW"
    ],
    "just5": [
        "KW"
    ],
    "link5": [
        "KW"
    ],
    "three_proofings_w5": [
        "KX"
    ],
    "three proofings w6": [
        "KX"
    ],
    "three_proofings_w7": [
        "KX"
    ],
    "three_proofings_w8": [
        "KX"
    ],
    "three_proofings_w9": [
        "KX"
    ],
    "kyv43": [
        "KY"
    ],
    "kyv47-u": [
        "KY"
    ],
    "e6782": [
        "KY"
    ],
    "np501kc": [
        "KY"
    ],
    "503kc": [
        "KY"
    ],
    "602kc": [
        "KY"
    ],
    "kyv36": [
        "KY"
    ],
    "kyl21": [
        "KY"
    ],
    "e6560c": [
        "KY"
    ],
    "e6560t": [
        "KY"
    ],
    "e6810": [
        "KY"
    ],
    "e6910": [
        "KY"
    ],
    "kyocera-e6790": [
        "KY"
    ],
    "e6790tm": [
        "KY"
    ],
    "e6782l": [
        "KY"
    ],
    "kyf31": [
        "KY"
    ],
    "kyf37": [
        "KY"
    ],
    "kyf39": [
        "KY"
    ],
    "c5170": [
        "KY"
    ],
    "c5215": [
        "KY"
    ],
    "c6750": [
        "KY"
    ],
    "c6730": [
        "KY"
    ],
    "c6530n": [
        "KY"
    ],
    "c6743": [
        "KY"
    ],
    "c6740": [
        "KY"
    ],
    "c6740n": [
        "KY"
    ],
    "c6522n": [
        "KY"
    ],
    "kyv33": [
        "KY"
    ],
    "705kc": [
        "KY"
    ],
    "kc-s301ae": [
        "KY"
    ],
    "c5120": [
        "KY"
    ],
    "kyl23": [
        "KY"
    ],
    "kyv39": [
        "KY"
    ],
    "s4-kc": [
        "KY"
    ],
    "s6-kc": [
        "KY"
    ],
    "x3-kc": [
        "KY"
    ],
    "kyv37": [
        "KY"
    ],
    "kyv42": [
        "KY"
    ],
    "kyv44": [
        "KY"
    ],
    "kyv40u": [
        "KY"
    ],
    "c5155": [
        "KY"
    ],
    "kc-s701": [
        "KY"
    ],
    "kyy24": [
        "KY"
    ],
    "kyv41": [
        "KY"
    ],
    "kyy21": [
        "KY"
    ],
    "kyy22": [
        "KY"
    ],
    "kyy23": [
        "KY"
    ],
    "kyv31": [
        "KY"
    ],
    "kyv34": [
        "KY"
    ],
    "kyv38": [
        "KY"
    ],
    "kyv45": [
        "KY"
    ],
    "thunder 450w": [
        "KZ",
        "H2"
    ],
    "kazam thunder q45": [
        "KZ",
        "H2"
    ],
    "tornado 348": [
        "KZ"
    ],
    "kazam trooper 551": [
        "KZ"
    ],
    "trooper_x35": [
        "KZ"
    ],
    "logic l4t": [
        "1L"
    ],
    "ap5705s": [
        "ATH"
    ],
    "hmr5450": [
        "3H"
    ],
    "rd16q": [
        "RH"
    ],
    "smartn12": [
        "6W"
    ],
    "smartn11": [
        "6W"
    ],
    "smart c11": [
        "6W"
    ],
    "stg_p10": [
        "GQ"
    ],
    "heyou70": [
        "E2"
    ],
    "digit4g energy": [
        "DIG"
    ],
    "digit4g-pro": [
        "DIG"
    ],
    "teracube 2e": [
        "TER"
    ],
    "teracube one": [
        "TER"
    ],
    "solarin": [
        "83"
    ],
    "sp-6150": [
        "31"
    ],
    "novey l2": [
        "NOV"
    ],
    "unsp7": [
        "UNN"
    ],
    "ev1 pro": [
        "PAR"
    ],
    "sp-5300": [
        "31"
    ],
    "kodak_smartway_t2": [
        "KK"
    ],
    "gravity_6p": [
        "MW"
    ],
    "cellacom_s62": [
        "CEL"
    ],
    "trooper_x40": [
        "KZ"
    ],
    "kazam trooper x45": [
        "KZ"
    ],
    "trooper_x55": [
        "KZ"
    ],
    "kazam trooper x50": [
        "KZ"
    ],
    "kazam trooper2 50": [
        "KZ"
    ],
    "kazam tv 45": [
        "KZ"
    ],
    "le 1 pro": [
        "L1"
    ],
    "x800+": [
        "L1"
    ],
    "letv x500": [
        "L1"
    ],
    "letv x501": [
        "L1"
    ],
    "le x526": [
        "L1"
    ],
    "le max": [
        "L1"
    ],
    "le x527": [
        "L1"
    ],
    "lex720": [
        "L1",
        "WI"
    ],
    "lex722": [
        "L1"
    ],
    "le x820": [
        "L1"
    ],
    "x900": [
        "L1"
    ],
    "x900+": [
        "L1"
    ],
    "letv x910": [
        "L1"
    ],
    "s6": [
        "L2"
    ],
    "iva s6": [
        "I8",
        "L2"
    ],
    "xm100": [
        "L2"
    ],
    "xm100 plus": [
        "L2"
    ],
    "xm100s": [
        "L2"
    ],
    "xm300 pro": [
        "L2"
    ],
    "s5a4": [
        "L3"
    ],
    "s4a2": [
        "L3"
    ],
    "s4a5": [
        "L3"
    ],
    "lexand s4a4 neon": [
        "L3",
        "JG"
    ],
    "s4a1": [
        "L3"
    ],
    "lemhoov  l15": [
        "L4"
    ],
    "elite 1": [
        "L5"
    ],
    "kiicaa mix": [
        "L5",
        "XI"
    ],
    "kiicaa power": [
        "L5"
    ],
    "leagoo_lead5": [
        "L5"
    ],
    "leagoo lead7": [
        "L5"
    ],
    "leagoo m5": [
        "L5"
    ],
    "m5 edge": [
        "L5"
    ],
    "leagoo m8": [
        "L5"
    ],
    "leagoo m8pro": [
        "L5"
    ],
    "leagoo-m8-pro": [
        "L5"
    ],
    "leagoo m8_pro": [
        "L5"
    ],
    "leagoo t1": [
        "L5"
    ],
    "venture 1": [
        "L5"
    ],
    "leagoo z1": [
        "L5"
    ],
    "leagoo z5": [
        "L5"
    ],
    "leagoo z6": [
        "L5"
    ],
    "land rover explore": [
        "L6"
    ],
    "land rover l15+": [
        "L6"
    ],
    "land rover t878": [
        "L6"
    ],
    "(landrover-v1": [
        "L6"
    ],
    "(landrover v18": [
        "L6"
    ],
    "landrover v6": [
        "L6"
    ],
    "landrover v8": [
        "L6"
    ],
    "land rover x": [
        "L6"
    ],
    "land rover x17": [
        "L6"
    ],
    "land roverd x18": [
        "L6"
    ],
    "lephone t2": [
        "L7"
    ],
    "lephone_w10": [
        "L7"
    ],
    "lephone_w11": [
        "L7"
    ],
    "lephone_w12": [
        "L7"
    ],
    "lephone_w15": [
        "L7"
    ],
    "lephone_w2": [
        "L7"
    ],
    "lephone_w7": [
        "L7"
    ],
    "lephone_w7_plus": [
        "L7"
    ],
    "lephone_w9": [
        "L7"
    ],
    "clarmin_b6": [
        "L8"
    ],
    "luna g50": [
        "L9",
        "69"
    ],
    "luna g60": [
        "L9",
        "69"
    ],
    "tg-l800s": [
        "L9"
    ],
    "luna v55": [
        "L9",
        "69"
    ],
    "ilium alpha 3": [
        "LA"
    ],
    "alpha 950": [
        "LA"
    ],
    "ilium l1000": [
        "LA"
    ],
    "ilium l1050": [
        "LA"
    ],
    "ilium l1100": [
        "LA"
    ],
    "ilium l1120": [
        "LA"
    ],
    "ilium l1200": [
        "LA"
    ],
    "ilium l1400": [
        "LA"
    ],
    "ilium l200": [
        "LA"
    ],
    "ilium l610": [
        "LA"
    ],
    "ilium l620": [
        "LA"
    ],
    "ilium l910": [
        "LA"
    ],
    "ilium l920": [
        "LA"
    ],
    "ilium l950": [
        "LA"
    ],
    "ilium lt500": [
        "LA"
    ],
    "ilium_lt500": [
        "LA"
    ],
    "ilium lt510": [
        "LA"
    ],
    "ilium lt520": [
        "LA"
    ],
    "ilium m1": [
        "LA"
    ],
    "ilium m3": [
        "LA"
    ],
    "ilium m5": [
        "LA"
    ],
    "ilium m7": [
        "LA"
    ],
    "ilium m9": [
        "LA"
    ],
    "ilium s106": [
        "LA"
    ],
    "ilium s520": [
        "LA",
        "OB"
    ],
    "ilium s620": [
        "LA"
    ],
    "ilium s670": [
        "LA"
    ],
    "ilium x110": [
        "LA"
    ],
    "ilium x120": [
        "LA"
    ],
    "x120c": [
        "LA"
    ],
    "ilium x200": [
        "LA"
    ],
    "ilium x210": [
        "LA"
    ],
    "ilium x220": [
        "LA"
    ],
    "ilium x260": [
        "LA"
    ],
    "ilium x500b": [
        "LA"
    ],
    "ilium x510": [
        "LA"
    ],
    "ilium x520": [
        "LA"
    ],
    "ilium x710": [
        "LA"
    ],
    "ledstar_novus_premium_6.0": [
        "LD"
    ],
    "trendy 5.0": [
        "LD"
    ],
    "lenovo a1010a20": [
        "LE"
    ],
    "lenovo-lenovo-a288t": [
        "LE"
    ],
    "lenovo a288t": [
        "LE"
    ],
    "lenovo l18021": [
        "LE"
    ],
    "lenovo a390_row": [
        "LE"
    ],
    "l18011": [
        "LE"
    ],
    "lenovo a5000": [
        "LE",
        "ON"
    ],
    "lenovo a530": [
        "LE"
    ],
    "lnv-lenovo_a560e": [
        "LE"
    ],
    "lenovo a60": [
        "LE"
    ],
    "lenovo a60+": [
        "LE"
    ],
    "lenovo a690": [
        "LE"
    ],
    "lenovo k10a40": [
        "LE"
    ],
    "lenovo k50a40": [
        "LE"
    ],
    "k31-t3": [
        "LE"
    ],
    "lenovo a7010a48": [
        "LE"
    ],
    "k350t": [
        "LE"
    ],
    "lenovo a7020a48": [
        "LE"
    ],
    "lenovo a7020a40": [
        "LE"
    ],
    "lenovo k33a48": [
        "LE"
    ],
    "lenovo k53a48": [
        "LE"
    ],
    "lenovo k33a42": [
        "LE"
    ],
    "lenovo p2a42": [
        "LE"
    ],
    "p2a42": [
        "LE"
    ],
    "lenovo-p770": [
        "LE"
    ],
    "lenovo p770": [
        "LE"
    ],
    "lenovo p780_row": [
        "LE"
    ],
    "lenovo pb2-670m": [
        "LE"
    ],
    "lenovo l58041": [
        "LE"
    ],
    "lenovos668t": [
        "LE"
    ],
    "lenovo s880": [
        "LE"
    ],
    "lenovo_s920_row": [
        "LE"
    ],
    "lenovo a2016a40": [
        "LE"
    ],
    "lenovo-a6020l36": [
        "LE"
    ],
    "lenovo a6020a40": [
        "LE"
    ],
    "vibe k5": [
        "LE"
    ],
    "lenovo a6020a46": [
        "LE"
    ],
    "vibe k5 plus": [
        "LE"
    ],
    "lenovo p1c72": [
        "LE"
    ],
    "lenovo p1a42": [
        "LE"
    ],
    "lenovo p1ma40": [
        "LE"
    ],
    "lenovo s1a40": [
        "LE"
    ],
    "lenovo z90a40": [
        "LE"
    ],
    "vibe x2 (x2)": [
        "LE"
    ],
    "vibe z2": [
        "LE"
    ],
    "z2 plus": [
        "LE"
    ],
    "lenovo l78071": [
        "LE"
    ],
    "zuk z2151": [
        "LE"
    ],
    "zuk z1": [
        "LE"
    ],
    "z2131": [
        "LE"
    ],
    "zuk z2132": [
        "LE"
    ],
    "zuk z2131": [
        "LE"
    ],
    "zuk z2121": [
        "LE"
    ],
    "lg-lg730": [
        "LG"
    ],
    "lm-x210(g)": [
        "LG"
    ],
    "lm-x210g": [
        "LG"
    ],
    "lm-x220": [
        "LG"
    ],
    "lg-d802": [
        "LG"
    ],
    "lg-e400": [
        "LG"
    ],
    "lg-e510": [
        "LG"
    ],
    "lg-e610v/v10d": [
        "LG"
    ],
    "lg-e610v": [
        "LG"
    ],
    "lg-e610v/v10f": [
        "LG"
    ],
    "lg-e612g": [
        "LG"
    ],
    "lg-e615": [
        "LG"
    ],
    "lg-e617g": [
        "LG"
    ],
    "lg-e730/v10b": [
        "LG"
    ],
    "lg-e900": [
        "LG"
    ],
    "lg-e970": [
        "LG"
    ],
    "lg-e973": [
        "LG"
    ],
    "lg-e980/e98010p": [
        "LG"
    ],
    "lg-e988": [
        "LG"
    ],
    "lg-f120k": [
        "LG"
    ],
    "lg-f160s": [
        "LG"
    ],
    "lg-f240k": [
        "LG"
    ],
    "lg-f240k/10z": [
        "LG"
    ],
    "lg-f240l": [
        "LG"
    ],
    "lm-x210cm": [
        "LG"
    ],
    "vs880": [
        "LG"
    ],
    "vs880pp": [
        "LG"
    ],
    "vs980 4g": [
        "LG"
    ],
    "lg-d618": [
        "LG"
    ],
    "lg-d620": [
        "LG"
    ],
    "vs985 4g": [
        "LG"
    ],
    "lg-d855": [
        "LG"
    ],
    "lg-d852": [
        "LG"
    ],
    "lg-d724": [
        "LG"
    ],
    "lg-h811": [
        "LG"
    ],
    "lg-h815": [
        "LG"
    ],
    "lg-h818": [
        "LG"
    ],
    "lg-h735": [
        "LG"
    ],
    "lg-h542": [
        "LG"
    ],
    "lg-h630": [
        "LG"
    ],
    "lg-h540": [
        "LG"
    ],
    "lg-h525n": [
        "LG"
    ],
    "lg-h736": [
        "LG"
    ],
    "lg-h850": [
        "LG"
    ],
    "lg-h860": [
        "LG"
    ],
    "vs987": [
        "LG"
    ],
    "rs988": [
        "LG"
    ],
    "lg-h840": [
        "LG"
    ],
    "lg-h870ds": [
        "LG"
    ],
    "vs988": [
        "LG"
    ],
    "lm-q850": [
        "LG"
    ],
    "lm-q910": [
        "LG"
    ],
    "lm-g710n": [
        "LG"
    ],
    "lm-g710": [
        "LG"
    ],
    "lm-g710vm": [
        "LG"
    ],
    "lm-g820": [
        "LG"
    ],
    "lm-g820n": [
        "LG"
    ],
    "lm-g810": [
        "LG"
    ],
    "901lg": [
        "LG"
    ],
    "lg-gt540": [
        "LG"
    ],
    "lg-k420": [
        "LG"
    ],
    "lg-f670l": [
        "LG"
    ],
    "lg-k430": [
        "LG"
    ],
    "lg-m250": [
        "LG"
    ],
    "lm-x410.fn": [
        "LG"
    ],
    "vs501": [
        "LG"
    ],
    "lg-m255": [
        "LG"
    ],
    "lg-tp260": [
        "LG"
    ],
    "lgmp260": [
        "LG"
    ],
    "lg-k100": [
        "LG"
    ],
    "lm-x410um": [
        "LG"
    ],
    "lm-x320": [
        "LG"
    ],
    "lg-x230": [
        "LG"
    ],
    "lm-x420": [
        "LG"
    ],
    "lg-x220": [
        "LG"
    ],
    "lm-x540": [
        "LG"
    ],
    "lgms330": [
        "LG"
    ],
    "lg-k330": [
        "LG"
    ],
    "lg-k332": [
        "LG"
    ],
    "lg-k350": [
        "LG"
    ],
    "lg-x240": [
        "LG"
    ],
    "lm-x212(g)": [
        "LG"
    ],
    "rs500": [
        "LG"
    ],
    "vs500pp": [
        "LG"
    ],
    "vs500": [
        "LG"
    ],
    "lg-ku5400": [
        "LG"
    ],
    "lgl35g": [
        "LG"
    ],
    "lg-l40g": [
        "LG"
    ],
    "lg-d325": [
        "LG"
    ],
    "lg-d340f8": [
        "LG"
    ],
    "lgl85c": [
        "LG"
    ],
    "lgl86c": [
        "LG"
    ],
    "lg-h324": [
        "LG"
    ],
    "lg-h340n": [
        "LG"
    ],
    "lm-x410.fgn": [
        "LG"
    ],
    "lg-ls860": [
        "LG"
    ],
    "vs876": [
        "LG"
    ],
    "lg-h502": [
        "LG"
    ],
    "lg-ms690": [
        "LG"
    ],
    "lgms769": [
        "LG"
    ],
    "lg-ms770": [
        "LG"
    ],
    "lg-p880": [
        "LG"
    ],
    "l-07c": [
        "LG"
    ],
    "lg optimus g": [
        "LG"
    ],
    "l-05d": [
        "LG"
    ],
    "p713": [
        "LG"
    ],
    "l-01d": [
        "LG"
    ],
    "lg-p500h": [
        "LG"
    ],
    "lgc660": [
        "LG"
    ],
    "lg-f100l": [
        "LG"
    ],
    "lg-f100s": [
        "LG"
    ],
    "lg-vs410pp": [
        "LG"
    ],
    "vs415pp": [
        "LG"
    ],
    "vs425pp": [
        "LG"
    ],
    "lg-p350": [
        "LG"
    ],
    "lg-p500": [
        "LG"
    ],
    "lg-p659": [
        "LG"
    ],
    "lg-p700": [
        "LG"
    ],
    "lg-p705": [
        "LG"
    ],
    "lg-p705g": [
        "LG"
    ],
    "lg-p713": [
        "LG"
    ],
    "lg-p725": [
        "LG"
    ],
    "lg-p760": [
        "LG"
    ],
    "lg-p769": [
        "LG"
    ],
    "lg-p895": [
        "LG"
    ],
    "lg-p920h": [
        "LG"
    ],
    "lg-p936": [
        "LG"
    ],
    "lg-p940": [
        "LG"
    ],
    "lg-p990": [
        "LG"
    ],
    "lg-p999": [
        "LG"
    ],
    "lg-p505r": [
        "LG"
    ],
    "lg-k371": [
        "LG"
    ],
    "lg-m150": [
        "LG"
    ],
    "lm-x210apm": [
        "LG"
    ],
    "l-02d": [
        "LG"
    ],
    "lm-x410.f": [
        "LG"
    ],
    "lml414dl": [
        "LG"
    ],
    "lml413dl": [
        "LG"
    ],
    "lm-q710(fgn)": [
        "LG"
    ],
    "lm-q710fgn": [
        "LG"
    ],
    "lm-q710.fgn": [
        "LG"
    ],
    "lg-m700": [
        "LG"
    ],
    "lm-x525": [
        "LG"
    ],
    "lm-q610.fg": [
        "LG"
    ],
    "lm-q710.fg": [
        "LG"
    ],
    "lm-q610.fgn": [
        "LG"
    ],
    "lm-q725k": [
        "LG"
    ],
    "lm-q725l": [
        "LG"
    ],
    "lm-q815s": [
        "LG"
    ],
    "lm-q925l": [
        "LG"
    ],
    "lgv33": [
        "LG"
    ],
    "lml211bl": [
        "LG"
    ],
    "lml212vl": [
        "LG"
    ],
    "lg-h343": [
        "LG"
    ],
    "lg-h422": [
        "LG"
    ],
    "l-03k": [
        "LG"
    ],
    "l-01l": [
        "LG"
    ],
    "vs835": [
        "LG"
    ],
    "lml713dl": [
        "LG"
    ],
    "lm-q720": [
        "LG"
    ],
    "lg-su870": [
        "LG"
    ],
    "lm-x220pm": [
        "LG"
    ],
    "lg-h961n": [
        "LG"
    ],
    "lg-h901": [
        "LG"
    ],
    "rs987": [
        "LG"
    ],
    "vs990": [
        "LG"
    ],
    "lg-f800s": [
        "LG"
    ],
    "vs995": [
        "LG"
    ],
    "vs996": [
        "LG"
    ],
    "l-01k": [
        "LG"
    ],
    "lm-v350": [
        "LG"
    ],
    "lm-v350n": [
        "LG"
    ],
    "lm-v405": [
        "LG"
    ],
    "lm-v409n": [
        "LG"
    ],
    "l-51a": [
        "LG"
    ],
    "lm-x440im": [
        "LG"
    ],
    "lg-k580": [
        "LG"
    ],
    "lg-k220": [
        "LG"
    ],
    "lg-m320": [
        "LG"
    ],
    "lm-x510wm": [
        "LG"
    ],
    "lm-x210k": [
        "LG"
    ],
    "lm-x410k": [
        "LG"
    ],
    "lm-x415k": [
        "LG"
    ],
    "lm-x410s": [
        "LG"
    ],
    "lm-x420n": [
        "LG"
    ],
    "lm-x410l": [
        "LG"
    ],
    "lm-x415l": [
        "LG"
    ],
    "lm-x415s": [
        "LG"
    ],
    "x5-lg": [
        "LG"
    ],
    "lm-x510k": [
        "LG"
    ],
    "lm-x510l": [
        "LG"
    ],
    "lm-x510s": [
        "LG"
    ],
    "lm-x625n1": [
        "LG"
    ],
    "lm-x625n": [
        "LG"
    ],
    "lg-h650": [
        "LG"
    ],
    "lm-x210vpp": [
        "LG"
    ],
    "lingwin": [
        "LI"
    ],
    "lingwin k1": [
        "LI"
    ],
    "lingwin k5": [
        "LI"
    ],
    "lingwin t620": [
        "LI"
    ],
    "sprd-lingwin-u820s": [
        "LI"
    ],
    "lingwin u880": [
        "LI"
    ],
    "bjorn_sp-500": [
        "LK"
    ],
    "lark cirrus 4": [
        "LK"
    ],
    "lark cirrus 4.5": [
        "LK"
    ],
    "lark cirrus 5": [
        "LK"
    ],
    "cumulus 5 hd": [
        "LK"
    ],
    "cumulus 5.5 hd": [
        "LK"
    ],
    "cumulus 6 hd": [
        "LK"
    ],
    "lark phablet 6.0": [
        "LK"
    ],
    "lark_stratus_5": [
        "LK"
    ],
    "le fit fr": [
        "LM"
    ],
    "le_hola": [
        "LM"
    ],
    "le hola fr": [
        "LM",
        "J9"
    ],
    "le hop": [
        "LM"
    ],
    "le lift": [
        "LM"
    ],
    "lemoov": [
        "LM"
    ],
    "lemoov2": [
        "LM"
    ],
    "le smooth": [
        "LM",
        "HH"
    ],
    "le smooth fr": [
        "LM",
        "HH"
    ],
    "laiq glam": [
        "LQ",
        "NY"
    ],
    "laiq new york": [
        "LQ"
    ],
    "iqw553": [
        "LS"
    ],
    "iqw553n": [
        "LS"
    ],
    "iq1553": [
        "LS",
        "FL"
    ],
    "iqd700": [
        "LS"
    ],
    "iq1436": [
        "LS",
        "FL"
    ],
    "iq1850": [
        "LS",
        "FL"
    ],
    "iqs300": [
        "LS"
    ],
    "iqe100": [
        "LS"
    ],
    "iqgw516": [
        "LS"
    ],
    "iqel41": [
        "LS"
    ],
    "iqw503": [
        "LS"
    ],
    "iqn700": [
        "LS"
    ],
    "iq1890": [
        "LS",
        "FL"
    ],
    "iq1570": [
        "LS",
        "FL"
    ],
    "iq1502a": [
        "LS"
    ],
    "iq1470": [
        "LS",
        "FL"
    ],
    "iq1511": [
        "LS",
        "FL"
    ],
    "iq1552": [
        "LS",
        "FL"
    ],
    "iq0705": [
        "LS",
        "FL"
    ],
    "iq1401": [
        "LS",
        "FL"
    ],
    "iqw511t": [
        "LS"
    ],
    "iql50": [
        "LS"
    ],
    "iqe200": [
        "LS"
    ],
    "iql550": [
        "LS"
    ],
    "iqr300": [
        "LS"
    ],
    "iq1568": [
        "LS",
        "FL"
    ],
    "iqw608": [
        "LS"
    ],
    "iqp50": [
        "LS"
    ],
    "iq5017": [
        "LS",
        "FL"
    ],
    "iql30": [
        "LS"
    ],
    "iq1452a": [
        "LS"
    ],
    "iq1453": [
        "LS",
        "FL"
    ],
    "iql51": [
        "LS"
    ],
    "lesph5003b": [
        "LT"
    ],
    "lesph5011": [
        "LT"
    ],
    "lesph5014": [
        "LT"
    ],
    "lumus_ion": [
        "LU"
    ],
    "neosc600": [
        "LU"
    ],
    "lava_a3": [
        "LV"
    ],
    "a67": [
        "LV"
    ],
    "a76": [
        "LV"
    ],
    "a97 ips": [
        "LV"
    ],
    "flair z1": [
        "LV"
    ],
    "iris_349+": [
        "LV"
    ],
    "iris349i": [
        "LV"
    ],
    "iris356": [
        "LV"
    ],
    "iris402+": [
        "LV"
    ],
    "iris402e": [
        "LV"
    ],
    "iris405+": [
        "LV"
    ],
    "iris_501": [
        "LV"
    ],
    "iris504q": [
        "LV"
    ],
    "iris78w": [
        "LV"
    ],
    "x1 selfie": [
        "LV"
    ],
    "pixelv1": [
        "LV"
    ],
    "lava_r1": [
        "LV"
    ],
    "x41 plus": [
        "LV"
    ],
    "z61_2gb": [
        "LV"
    ],
    "ls-5501": [
        "LY"
    ],
    "ls-5021": [
        "LY"
    ],
    "ls-4004": [
        "LY"
    ],
    "ls-4001": [
        "LY"
    ],
    "ls-4003": [
        "LY"
    ],
    "ls-4002": [
        "LY"
    ],
    "z667t": [
        "ZT"
    ],
    "zte-z992": [
        "ZT"
    ],
    "z970": [
        "ZT"
    ],
    "bqru-5035": [
        "BX"
    ],
    "bq-5522": [
        "BX"
    ],
    "dash g": [
        "BU"
    ],
    "htc one_m8 eye": [
        "HT"
    ],
    "asus_z012dc": [
        "AU"
    ],
    "pure 1": [
        "9H"
    ],
    "pure 2": [
        "9H"
    ],
    "q-smart_iii_plus": [
        "MY1",
        "QM"
    ],
    "y6_piano": [
        "DO"
    ],
    "y6_piano_black": [
        "DO"
    ],
    "y6 max": [
        "DO"
    ],
    "y6 max 3d": [
        "DO"
    ],
    "citi motion 4g cs5025pl": [
        "D2",
        "MR"
    ],
    "bv8000pro_ru": [
        "B2"
    ],
    "eluga a4": [
        "PA"
    ],
    "hardcaseh550s": [
        "ED"
    ],
    "cubot j3 pro": [
        "CB"
    ],
    "finney u1": [
        "83"
    ],
    "gaamii g1": [
        "SQ"
    ],
    "santin gaamii": [
        "SQ"
    ],
    "m630": [
        "8L"
    ],
    "m558": [
        "8L"
    ],
    "m300 4g": [
        "3D"
    ],
    "mdc m5": [
        "3D"
    ],
    "rs635h": [
        "SQ"
    ],
    "philips_s260": [
        "PH"
    ],
    "5010d": [
        "AL"
    ],
    "4good style r407": [
        "4G"
    ],
    "cumulus_6_hd": [
        "LK"
    ],
    "philips_s326": [
        "PH"
    ],
    "pixel 5a": [
        "GO"
    ],
    "21061110ag": [
        "0P"
    ],
    "opg03": [
        "OP"
    ],
    "xq-at72": [
        "SO"
    ],
    "lp-01": [
        "SH"
    ],
    "c21 pro": [
        "OE"
    ],
    "c19 pro": [
        "OE"
    ],
    "asus_z01bda": [
        "AU"
    ],
    "f-03h": [
        "FU"
    ],
    "bv5000": [
        "B2"
    ],
    "bv7000": [
        "B2"
    ],
    "w_k300s": [
        "WI"
    ],
    "x-tigi_v28": [
        "XT"
    ],
    "x-tigi_v15": [
        "XT"
    ],
    "ax830": [
        "BM"
    ],
    "ax926": [
        "BM"
    ],
    "ax905": [
        "BM"
    ],
    "ax751": [
        "BM"
    ],
    "ax951": [
        "BM"
    ],
    "ax1017": [
        "BM"
    ],
    "ax1076+": [
        "BM"
    ],
    "ax1075+": [
        "BM"
    ],
    "ax1077": [
        "BM"
    ],
    "ax1080": [
        "BM"
    ],
    "ax1082": [
        "BM"
    ],
    "ax751+": [
        "BM"
    ],
    "ax715": [
        "BM"
    ],
    "ax688": [
        "BM"
    ],
    "ls-4005": [
        "LY"
    ],
    "lyf_ls-4006": [
        "LY"
    ],
    "ls-4008": [
        "LY"
    ],
    "ls-4508": [
        "LY"
    ],
    "ls-4503": [
        "LY"
    ],
    "ls-5002": [
        "LY"
    ],
    "ls-5020": [
        "LY"
    ],
    "ls-5017": [
        "LY"
    ],
    "ls-5008": [
        "LY"
    ],
    "ls-5503": [
        "LY"
    ],
    "ls-5005": [
        "LY"
    ],
    "ls-5006": [
        "LY"
    ],
    "ls-5504": [
        "LY"
    ],
    "ls-5507": [
        "LY"
    ],
    "ls-5015": [
        "LY"
    ],
    "ls-5506": [
        "LY"
    ],
    "ls-5505": [
        "LY"
    ],
    "ls-5201": [
        "LY"
    ],
    "ls-5010": [
        "LY"
    ],
    "ls-6001": [
        "LY"
    ],
    "ls-5502": [
        "LY"
    ],
    "ls-5014": [
        "LY"
    ],
    "ls-5018": [
        "LY"
    ],
    "ls-5013": [
        "LY"
    ],
    "ls-5009": [
        "LY"
    ],
    "ls-5016": [
        "LY"
    ],
    "anova a5": [
        "LZ"
    ],
    "alpha_x": [
        "M0"
    ],
    "ssb504r": [
        "YM"
    ],
    "ssb-500": [
        "YM"
    ],
    "mz-15 lite": [
        "M1"
    ],
    "mz-15 plus": [
        "M1"
    ],
    "mz-16s": [
        "M1"
    ],
    "mz-16t": [
        "M1"
    ],
    "mz-16th": [
        "M1"
    ],
    "mz-16th plus": [
        "M1"
    ],
    "mz-16 x": [
        "M1"
    ],
    "m1 metal": [
        "M1"
    ],
    "m1 e": [
        "M1"
    ],
    "m578ca": [
        "M1"
    ],
    "mz-m578c": [
        "M1"
    ],
    "m578c": [
        "M1"
    ],
    "m2": [
        "M1"
    ],
    "m2 e": [
        "M1"
    ],
    "m3e": [
        "M1"
    ],
    "m3s": [
        "M1"
    ],
    "mz-m3s": [
        "M1"
    ],
    "m3x": [
        "M1"
    ],
    "meizu_m5": [
        "M1"
    ],
    "mz-meizu_m5": [
        "M1"
    ],
    "m5s": [
        "M1"
    ],
    "m612c": [
        "M1"
    ],
    "m711c": [
        "M1"
    ],
    "m6t": [
        "M1"
    ],
    "m1813": [
        "M1"
    ],
    "m1816": [
        "M1"
    ],
    "m031": [
        "M1"
    ],
    "m045": [
        "M1"
    ],
    "m040": [
        "M1"
    ],
    "mx2": [
        "M1"
    ],
    "m351": [
        "M1"
    ],
    "m356": [
        "M1"
    ],
    "m355": [
        "M1"
    ],
    "m353": [
        "M1"
    ],
    "mx4": [
        "M1"
    ],
    "mx4 pro": [
        "M1"
    ],
    "m1822": [
        "M1"
    ],
    "pro 6": [
        "M1"
    ],
    "mz-pro 6": [
        "M1"
    ],
    "pro 7-h": [
        "M1"
    ],
    "m1852": [
        "M1"
    ],
    "meeg_101m": [
        "M2"
    ],
    "meeg 103m": [
        "M2"
    ],
    "meeg 210r": [
        "M2"
    ],
    "xino z46 x4": [
        "M4"
    ],
    "g7106": [
        "M5"
    ],
    "g7108": [
        "M5"
    ],
    "m20": [
        "M5"
    ],
    "m35": [
        "M5"
    ],
    "e1 selfie": [
        "M6"
    ],
    "mobiistar kat 452": [
        "M6"
    ],
    "build/kot49h)": [
        "M6"
    ],
    "mobiistar lai 504c": [
        "M6"
    ],
    "mobiistar lai 504k": [
        "M6"
    ],
    "mobiistar lai y": [
        "M6"
    ],
    "mobiistar_lai_yollo": [
        "M6"
    ],
    "mobiistar lai yuki": [
        "M6"
    ],
    "mobiistar lai yuna 1": [
        "M6"
    ],
    "mobiistar_lai_yuna_c": [
        "M6"
    ],
    "mobiistar_lai_yuna_s": [
        "M6"
    ],
    "mobiistar_lai_yuna_x": [
        "M6"
    ],
    "mobiistar_lai_z": [
        "M6"
    ],
    "mobiistar lai z1": [
        "M6"
    ],
    "mobiistar_lai_z2": [
        "M6"
    ],
    "mobiistar_lai_zena": [
        "M6"
    ],
    "mobiistar_lai_zoro_2": [
        "M6"
    ],
    "mobiistar lai zoro 2": [
        "M6"
    ],
    "mobiistar_lai_zoro_3": [
        "M6"
    ],
    "mobiistar_lai_zumbo_j": [
        "M6"
    ],
    "mobiistar_lai_zumbo_j_2017": [
        "M6"
    ],
    "mobiistar_zumbo_j2": [
        "M6"
    ],
    "mobiistar_prime_558": [
        "M6"
    ],
    "mobiistar prime x 2017": [
        "M6"
    ],
    "mobiistar prime x grand": [
        "M6"
    ],
    "prime x max 2018": [
        "M6"
    ],
    "mobiistar_prime_x_plus": [
        "M6"
    ],
    "mobiistar prime x1": [
        "M6"
    ],
    "mobiistar touch lai 512": [
        "M6"
    ],
    "mobiistar touch s03": [
        "M6"
    ],
    "x1 notch": [
        "M6"
    ],
    "mobiistar_zoro_4g": [
        "M6"
    ],
    "mobiistar_lai_zumbo": [
        "M6"
    ],
    "mobiistar zumbo power": [
        "M6"
    ],
    "mobiistar zumbo s2 dual": [
        "M6"
    ],
    "mobiistar zumbo s2": [
        "M6"
    ],
    "mpm_ava758": [
        "M7"
    ],
    "mpm-i616": [
        "M7"
    ],
    "502m": [
        "M8"
    ],
    "myria_five": [
        "M8"
    ],
    "grand": [
        "M8"
    ],
    "myria_grand_4g": [
        "M8"
    ],
    "myria_quad": [
        "M8"
    ],
    "myria_wide_2": [
        "M8"
    ],
    "myria_wide_4g": [
        "M8"
    ],
    "mtc_968": [
        "M9"
    ],
    "mtc 970": [
        "M9"
    ],
    "mtc 970h": [
        "M9"
    ],
    "mtc 972": [
        "M9"
    ],
    "mtc975": [
        "M9"
    ],
    "mtc 978": [
        "M9"
    ],
    "mtc 982": [
        "M9"
    ],
    "mtc 982o": [
        "M9"
    ],
    "mtc 982t": [
        "M9"
    ],
    "smart_race2_4g": [
        "M9"
    ],
    "smart race 4g": [
        "M9"
    ],
    "mtc smart run": [
        "M9"
    ],
    "mtc smart run 4g": [
        "M9"
    ],
    "mtc smartrun 4g": [
        "M9"
    ],
    "mtc smart sprint 4g": [
        "M9"
    ],
    "mtc_smart_sprint_4g": [
        "M9"
    ],
    "mtc_smart_start_2": [
        "M9"
    ],
    "smart surf2 4g": [
        "M9"
    ],
    "smart_surf_4g": [
        "M9"
    ],
    "msp96017": [
        "MA"
    ],
    "msp95015": [
        "MA"
    ],
    "msp95020": [
        "MA"
    ],
    "msp95021": [
        "MA"
    ],
    "msp95014": [
        "MA"
    ],
    "cynus_f10": [
        "MB"
    ],
    "cynus f3": [
        "MB"
    ],
    "cynus f4": [
        "MB"
    ],
    "cynus_f8": [
        "MB"
    ],
    "cynus t1": [
        "MB"
    ],
    "cynus t2": [
        "MB"
    ],
    "cynus t5": [
        "MB"
    ],
    "m-ppxg400": [
        "MC"
    ],
    "m-ppbg500": [
        "MC"
    ],
    "m-ppcg500": [
        "MC"
    ],
    "m-ppag500": [
        "MC"
    ],
    "m-ppxg501": [
        "MC"
    ],
    "m-ppxs470": [
        "MC"
    ],
    "m-pp2s500": [
        "MC"
    ],
    "m-pp2s500c": [
        "MC"
    ],
    "m-ppxs501": [
        "MC"
    ],
    "m-ppax470u": [
        "MC"
    ],
    "m_ppax510u": [
        "MC"
    ],
    "medion b5530": [
        "MD"
    ],
    "medion e4002": [
        "MD"
    ],
    "medion smartphone life e3501": [
        "MD"
    ],
    "medion e4504": [
        "MD"
    ],
    "medion e5004": [
        "MD"
    ],
    "medion e5020": [
        "MD"
    ],
    "medion life p4012": [
        "MD"
    ],
    "medion life p4310": [
        "MD"
    ],
    "medion p5015": [
        "MD"
    ],
    "medion s5004": [
        "MD"
    ],
    "x5001": [
        "MD"
    ],
    "medion p4013": [
        "MD"
    ],
    "medion x4701": [
        "MD"
    ],
    "mofut": [
        "MF"
    ],
    "mofut f1": [
        "MF"
    ],
    "f6": [
        "MF"
    ],
    "mofut_f88rztd": [
        "MF"
    ],
    "mofut_kx": [
        "MF"
    ],
    "mofut_n5": [
        "MF"
    ],
    "mofut t2": [
        "MF"
    ],
    "mywigo city3": [
        "MG"
    ],
    "ms50x6": [
        "MH"
    ],
    "ms55x5": [
        "MH"
    ],
    "ms55x6": [
        "MH"
    ],
    "ms45a4000": [
        "MH"
    ],
    "ms50a4000": [
        "MH"
    ],
    "ms50a4500": [
        "MH"
    ],
    "ms50a6000": [
        "MH"
    ],
    "ms50a5000": [
        "MH"
    ],
    "ms55l1": [
        "MH"
    ],
    "ms50l1": [
        "MH"
    ],
    "mb-2900 quattro": [
        "MH"
    ],
    "ms43a3000": [
        "MH"
    ],
    "ms50b11000": [
        "MH"
    ],
    "polys_ms45l1": [
        "MH"
    ],
    "wave5": [
        "MH"
    ],
    "4560mmx": [
        "MI"
    ],
    "micromax_a101": [
        "MI"
    ],
    "micromax a110q": [
        "MI"
    ],
    "micromax a116": [
        "MI"
    ],
    "micromax a116i": [
        "MI"
    ],
    "micromax a210": [
        "MI",
        "AC"
    ],
    "micromax a24": [
        "MI"
    ],
    "micromax_a26": [
        "MI"
    ],
    "micromax_a36": [
        "MI"
    ],
    "micromax a58": [
        "MI"
    ],
    "micromax a61": [
        "MI"
    ],
    "micromax_a62": [
        "MI"
    ],
    "micromax_a74": [
        "MI"
    ],
    "micromax a92": [
        "MI"
    ],
    "q327": [
        "MI"
    ],
    "micromax q402+": [
        "MI"
    ],
    "micromax q424": [
        "MI"
    ],
    "micromax e481": [
        "MI"
    ],
    "micromax aq5001": [
        "MI"
    ],
    "micromax q417": [
        "MI"
    ],
    "aq5001 canvas power": [
        "MI"
    ],
    "yu5530": [
        "MI"
    ],
    "yu5040": [
        "MI"
    ],
    "crono 22": [
        "MJ"
    ],
    "crono 44": [
        "MJ"
    ],
    "urano 77lte": [
        "MJ"
    ],
    "majestic zeus21": [
        "MJ"
    ],
    "mlled m1b": [
        "ML"
    ],
    "mlled m2+": [
        "ML"
    ],
    "mlled_m3 mini": [
        "ML"
    ],
    "mlled m7s": [
        "ML"
    ],
    "mlled m8": [
        "ML"
    ],
    "mlled_m8s": [
        "ML"
    ],
    "mlled x3s": [
        "ML"
    ],
    "ph350b": [
        "MM",
        "4P"
    ],
    "ph350": [
        "MM"
    ],
    "ph520": [
        "MM"
    ],
    "m4 ss4458": [
        "MN"
    ],
    "m4_b2": [
        "MN"
    ],
    "m4_b3": [
        "MN"
    ],
    "m4 ss4451": [
        "MN"
    ],
    "m4 ss4452": [
        "MN"
    ],
    "m4 ss4457": [
        "MN"
    ],
    "m4 ss4457-r": [
        "MN"
    ],
    "m4 ss4456": [
        "MN"
    ],
    "m4 ss4455": [
        "MN"
    ],
    "m4 ss4458-r": [
        "MN"
    ],
    "m4 ss4040": [
        "MN"
    ],
    "m4 ss4453": [
        "MN"
    ],
    "m4 ss1050": [
        "MN"
    ],
    "m4 ss1060": [
        "MN"
    ],
    "m4 ss1080": [
        "MN"
    ],
    "m4 ss1090": [
        "MN"
    ],
    "m4 ss4020": [
        "MN"
    ],
    "m4 ss1070": [
        "MN"
    ],
    "m4 ss4450": [
        "MN"
    ],
    "m4 ss4350": [
        "MN"
    ],
    "m4 ss4345": [
        "MN"
    ],
    "m4 ss4045": [
        "MN"
    ],
    "m4 ss4445": [
        "MN"
    ],
    "mobix m6": [
        "MO"
    ],
    "mflogin4": [
        "MP"
    ],
    "meglogph": [
        "MP"
    ],
    "mfloginph": [
        "MP"
    ],
    "sp-a20i": [
        "MP"
    ],
    "ms3b": [
        "MP"
    ],
    "megafon optima": [
        "MP"
    ],
    "megafon sp-a5": [
        "MP"
    ],
    "m.t.t. smart multimedia": [
        "MQ"
    ],
    "m.t.t. smartfun": [
        "MQ"
    ],
    "m.t.t.smartmax": [
        "MQ"
    ],
    "motoa953": [
        "MR"
    ],
    "xt603": [
        "MR"
    ],
    "xt682": [
        "MR"
    ],
    "xt687": [
        "MR"
    ],
    "xt535": [
        "MR"
    ],
    "mot-xt320": [
        "MR"
    ],
    "xt320": [
        "MR"
    ],
    "xt321": [
        "MR"
    ],
    "xt555c": [
        "MR"
    ],
    "xt556": [
        "MR"
    ],
    "xt557": [
        "MR"
    ],
    "droid": [
        "MR"
    ],
    "momodesign md droid": [
        "MR"
    ],
    "droid2": [
        "MR"
    ],
    "droid2 global": [
        "MR"
    ],
    "droid3": [
        "MR"
    ],
    "droid4": [
        "MR"
    ],
    "xt894": [
        "MR"
    ],
    "droid4 4g": [
        "MR"
    ],
    "droid bionic": [
        "MR"
    ],
    "droid bionic 4g": [
        "MR"
    ],
    "xt1030": [
        "MR"
    ],
    "xt610": [
        "MR"
    ],
    "droid pro": [
        "MR"
    ],
    "mot-xt910": [
        "MR"
    ],
    "xt910": [
        "MR"
    ],
    "droid razr": [
        "MR"
    ],
    "mot-xt910s": [
        "MR"
    ],
    "xt915": [
        "MR"
    ],
    "xt914": [
        "MR"
    ],
    "xt916": [
        "MR"
    ],
    "xt918": [
        "MR"
    ],
    "xt919": [
        "MR"
    ],
    "xt920": [
        "MR"
    ],
    "droid razr hd": [
        "MR"
    ],
    "xt925": [
        "MR"
    ],
    "xt890": [
        "MR"
    ],
    "xt907": [
        "MR"
    ],
    "xt885": [
        "MR"
    ],
    "xt886": [
        "MR"
    ],
    "xt1254": [
        "MR"
    ],
    "xt1080": [
        "MR"
    ],
    "droidx": [
        "MR"
    ],
    "droid x2": [
        "MR"
    ],
    "xt881": [
        "MR"
    ],
    "xt901": [
        "MR"
    ],
    "xt311": [
        "MR"
    ],
    "xt316": [
        "MR"
    ],
    "xt531": [
        "MR"
    ],
    "xt800w": [
        "MR"
    ],
    "xt626": [
        "MR"
    ],
    "mb300": [
        "MR"
    ],
    "motomb511": [
        "MR"
    ],
    "mb526": [
        "MR"
    ],
    "mb860": [
        "MR"
    ],
    "me525(defy)": [
        "MR"
    ],
    "motorola xt720": [
        "MR"
    ],
    "milestone xt720": [
        "MR"
    ],
    "xt860": [
        "MR"
    ],
    "moto c plus": [
        "MR"
    ],
    "xt1021": [
        "MR"
    ],
    "xt1022": [
        "MR"
    ],
    "xt1706": [
        "MR"
    ],
    "moto e (4) plus": [
        "MR"
    ],
    "xt1924-9": [
        "MR"
    ],
    "xt1028": [
        "MR"
    ],
    "xt1032": [
        "MR"
    ],
    "xt1033": [
        "MR"
    ],
    "xt1031": [
        "MR"
    ],
    "xt1034": [
        "MR"
    ],
    "xt1068": [
        "MR"
    ],
    "xt1069": [
        "MR"
    ],
    "moto g power": [
        "MR"
    ],
    "motog3": [
        "MR"
    ],
    "moto g (4)": [
        "MR"
    ],
    "xt1670": [
        "MR"
    ],
    "xt1687": [
        "MR"
    ],
    "xt1685": [
        "MR"
    ],
    "xt1799-2": [
        "MR"
    ],
    "moto g (5s) plus": [
        "MR"
    ],
    "xt1805": [
        "MR"
    ],
    "xt1804": [
        "MR"
    ],
    "xt1803": [
        "MR"
    ],
    "xt1925-10": [
        "MR"
    ],
    "moto g(6)": [
        "MR"
    ],
    "moto g(6) plus": [
        "MR"
    ],
    "xt1965-6": [
        "MR"
    ],
    "moto g(7) power": [
        "MR"
    ],
    "xt1663": [
        "MR"
    ],
    "xt1049": [
        "MR"
    ],
    "xt1056": [
        "MR"
    ],
    "xt1060": [
        "MR"
    ],
    "xt1058": [
        "MR"
    ],
    "xt1053": [
        "MR"
    ],
    "xt1055": [
        "MR"
    ],
    "xt1052": [
        "MR"
    ],
    "xt1092": [
        "MR"
    ],
    "xt1097": [
        "MR"
    ],
    "xt1562": [
        "MR"
    ],
    "xt1572": [
        "MR"
    ],
    "xt1096": [
        "MR"
    ],
    "xt882": [
        "MR"
    ],
    "xt1650-05": [
        "MR"
    ],
    "xt1635-02": [
        "MR"
    ],
    "xt1635-03": [
        "MR"
    ],
    "xt1789-05": [
        "MR"
    ],
    "xt1710-02": [
        "MR"
    ],
    "moto z2 play": [
        "MR"
    ],
    "xt1710-08": [
        "MR"
    ],
    "xt1929-15": [
        "MR"
    ],
    "xt615": [
        "MR"
    ],
    "mot-xt615": [
        "MR"
    ],
    "mot-xt685": [
        "MR"
    ],
    "xt685": [
        "MR"
    ],
    "motoroix": [
        "MR"
    ],
    "mot-xt390": [
        "MR"
    ],
    "mot-xt389": [
        "MR"
    ],
    "xt389": [
        "MR"
    ],
    "mot-xt303": [
        "MR"
    ],
    "xt303": [
        "MR"
    ],
    "mot-xt305": [
        "MR"
    ],
    "motorola one action": [
        "MR"
    ],
    "xt1970-5": [
        "MR"
    ],
    "motorola one zoom": [
        "MR"
    ],
    "xt1943-1": [
        "MR"
    ],
    "xt1942-1": [
        "MR"
    ],
    "xt1941-2": [
        "MR"
    ],
    "xt897": [
        "MR"
    ],
    "xt621": [
        "MR"
    ],
    "motorola-xt502": [
        "MR"
    ],
    "xt300": [
        "MR"
    ],
    "rm-994_eu_poland_1155": [
        "MS",
        "NK"
    ],
    "lumia 430 dual sim": [
        "MS",
        "NK"
    ],
    "lumia 435 dual sim": [
        "MS",
        "NK"
    ],
    "microsoft": [
        "MS"
    ],
    "rm-1089_1087": [
        "MS"
    ],
    "rm-1090": [
        "MS"
    ],
    "rm-1141": [
        "MS"
    ],
    "lumia 540 dual sim": [
        "MS",
        "NK"
    ],
    "rm-1010": [
        "MS",
        "NK"
    ],
    "lumia 640 dual sim": [
        "MS",
        "NK"
    ],
    "rm-1072": [
        "MS"
    ],
    "rm-1073": [
        "MS"
    ],
    "rm-1074": [
        "MS"
    ],
    "rm-1076": [
        "MS"
    ],
    "rm-1077": [
        "MS"
    ],
    "rm-1113": [
        "MS"
    ],
    "rm-1154": [
        "MS"
    ],
    "rm-1152": [
        "MS"
    ],
    "lumia 850": [
        "MS",
        "NK"
    ],
    "movic w2": [
        "MV"
    ],
    "movic-w3": [
        "MV"
    ],
    "movic-w4": [
        "MV"
    ],
    "movic-w5": [
        "MV"
    ],
    "astro_5n_lte": [
        "MW"
    ],
    "astro x55s": [
        "MW"
    ],
    "nitro_4": [
        "MW"
    ],
    "virtue z5": [
        "MW"
    ],
    "meu an400": [
        "MX"
    ],
    "meu an500": [
        "MX"
    ],
    "myphone a888": [
        "MY",
        "MY1"
    ],
    "myphone a919 duo": [
        "MY",
        "MY1"
    ],
    "myphone_axe_lte": [
        "MY1"
    ],
    "myphone_c-smart_4": [
        "MY1"
    ],
    "c-smart_pix": [
        "MY1"
    ],
    "myphone cityxl": [
        "MY1"
    ],
    "myphone cube": [
        "MY1"
    ],
    "cube_lte": [
        "MY1"
    ],
    "myphone_fun_8": [
        "MY1"
    ],
    "myphone fun lte": [
        "MY1"
    ],
    "hammer active": [
        "HAM"
    ],
    "hammer_active2": [
        "HAM"
    ],
    "hammer_active2_lte": [
        "HAM"
    ],
    "hammer_axe_m_lte": [
        "MY1"
    ],
    "hammer axe pro": [
        "MY1"
    ],
    "hammer_blade2_pro": [
        "HAM"
    ],
    "hammer energy": [
        "HAM"
    ],
    "hammer iron 2": [
        "HAM"
    ],
    "accent_neon": [
        "00"
    ],
    "meanit_c1": [
        "09"
    ],
    "meanit_c2": [
        "09"
    ],
    "meanit mg430": [
        "09"
    ],
    "meanit q1 plus": [
        "09"
    ],
    "meanit q4": [
        "09",
        "60"
    ],
    "meanit q5": [
        "09",
        "60"
    ],
    "meanit_x1": [
        "09"
    ],
    "meanit_x2": [
        "09"
    ],
    "meanit_x6": [
        "09"
    ],
    "iris708": [
        "0A",
        "LV"
    ],
    "techno x595bt": [
        "0B"
    ],
    "maxvi_ms401": [
        "0D"
    ],
    "melrose_2019": [
        "0E"
    ],
    "melrose_s9": [
        "0E"
    ],
    "itruck 7 3g": [
        "0I"
    ],
    "kl-v905": [
        "0K"
    ],
    "lumigon_t3": [
        "0L"
    ],
    "newman k1": [
        "0N"
    ],
    "newman p308": [
        "0N"
    ],
    "poco x2": [
        "0P"
    ],
    "go3c": [
        "0S"
    ],
    "go3c plus": [
        "0S"
    ],
    "go3e": [
        "0S"
    ],
    "go5e": [
        "0S"
    ],
    "5101j": [
        "0S"
    ],
    "tone e19": [
        "0T"
    ],
    "tone m15": [
        "0T"
    ],
    "vipro pro 1": [
        "0V"
    ],
    "vipro pro2": [
        "0V"
    ],
    "vipro pro2x": [
        "0V"
    ],
    "vipro pro 3": [
        "0V"
    ],
    "elite sense": [
        "0W"
    ],
    "alba 57": [
        "1A"
    ],
    "capture+": [
        "1B"
    ],
    "etl-s3520": [
        "1E"
    ],
    "etl-s4521": [
        "1E"
    ],
    "etl-s5042": [
        "1E"
    ],
    "etl-s5084": [
        "1E"
    ],
    "etl-s6022": [
        "1E"
    ],
    "imars vega x7": [
        "1I"
    ],
    "ureki_u1": [
        "1K"
    ],
    "logic_l5d": [
        "1L"
    ],
    "logic x1": [
        "1L"
    ],
    "logic x3": [
        "1L"
    ],
    "logic x4m": [
        "1L"
    ],
    "logic x4m lite": [
        "1L"
    ],
    "logic_x5_lite": [
        "1L"
    ],
    "logic x5 lite2": [
        "1L"
    ],
    "logic x5a": [
        "1L"
    ],
    "logic x5f": [
        "1L"
    ],
    "logic_x5t": [
        "1L"
    ],
    "logic_x60g": [
        "1L"
    ],
    "neo906": [
        "1N"
    ],
    "neo908": [
        "1N"
    ],
    "neo 909": [
        "1N"
    ],
    "phicomm clue 2s": [
        "1P"
    ],
    "phicomm c630 (clue l)": [
        "1P"
    ],
    "phicomm clue m": [
        "1P"
    ],
    "phicomm energy 3+": [
        "1P",
        "E1"
    ],
    "phicomm e653(energy l)": [
        "1P",
        "E1"
    ],
    "multilaser_e": [
        "1R"
    ],
    "multilaser_e_lite": [
        "1R"
    ],
    "multilaser_f": [
        "1R"
    ],
    "multilaser_g": [
        "1R"
    ],
    "multilaser_g_max": [
        "1R"
    ],
    "multilaser_g_pro": [
        "1R"
    ],
    "multilaser h": [
        "1R"
    ],
    "ms40g": [
        "1R"
    ],
    "ms40s": [
        "1R"
    ],
    "ms45s": [
        "1R"
    ],
    "ms45s_a6": [
        "1R"
    ],
    "ms5.v2": [
        "1R"
    ],
    "ms50g": [
        "1R"
    ],
    "ms50l": [
        "1R"
    ],
    "ms50s": [
        "1R"
    ],
    "ms50x": [
        "1R"
    ],
    "ms55m": [
        "1R"
    ],
    "ms60x": [
        "1R"
    ],
    "ms60z": [
        "1R"
    ],
    "ms70": [
        "1R"
    ],
    "ms80x": [
        "1R"
    ],
    "x-style_s5501": [
        "1S"
    ],
    "x-treme pq11": [
        "1S"
    ],
    "x-tremepq16": [
        "1S"
    ],
    "x-tremepq22": [
        "1S"
    ],
    "x-treme pq23": [
        "1S"
    ],
    "x-treme_pq24": [
        "1S"
    ],
    "sigma mobile xtreme pq25": [
        "1S"
    ],
    "x-treme_pq26": [
        "1S"
    ],
    "x_treme_pq27": [
        "1S"
    ],
    "sigma_xtreme_pq27": [
        "1S"
    ],
    "x-treme_pq28": [
        "1S"
    ],
    "x-treme_pq29": [
        "1S"
    ],
    "x-treme-pq30": [
        "1S"
    ],
    "x-treme_pq31": [
        "1S"
    ],
    "x_treme_pq34": [
        "1S"
    ],
    "x-tremepq35": [
        "1S"
    ],
    "x-treme pq39": [
        "1S"
    ],
    "x_treme_pq52": [
        "1S"
    ],
    "x-treme pq53": [
        "1S"
    ],
    "x-treme_pq54": [
        "1S"
    ],
    "turbox_ray": [
        "1T"
    ],
    "turbo_x5_black": [
        "1T",
        "TR"
    ],
    "turbox5black": [
        "1T"
    ],
    "turbox5hero": [
        "1T"
    ],
    "turbo_x5_max": [
        "1T",
        "TR"
    ],
    "turbox5space": [
        "1T"
    ],
    "turbo x6 z": [
        "1T"
    ],
    "turbo_x8": [
        "1T",
        "TR"
    ],
    "ghongv10": [
        "2C"
    ],
    "tele2_maxi": [
        "2L"
    ],
    "tele2_maxi_lte": [
        "2L"
    ],
    "tele2_maxi_plus": [
        "2L"
    ],
    "tele2 midi": [
        "2L"
    ],
    "tele2 midi 1.1": [
        "2L"
    ],
    "tele2_midi_2_0": [
        "2L"
    ],
    "tele2_mini": [
        "2L"
    ],
    "tele2 mini 1.1": [
        "2L"
    ],
    "masstel_juno_q3": [
        "2M"
    ],
    "masstel m05": [
        "2M"
    ],
    "masstel m11": [
        "2M"
    ],
    "masstel m12": [
        "2M"
    ],
    "masstel_m120": [
        "2M"
    ],
    "masstel m15": [
        "2M"
    ],
    "masstel (m18)": [
        "2M"
    ],
    "masstel m190": [
        "2M"
    ],
    "masstel m250": [
        "2M"
    ],
    "masstel n450": [
        "2M"
    ],
    "masstel_n460": [
        "2M"
    ],
    "masstel n520": [
        "2M"
    ],
    "masstel n536": [
        "2M"
    ],
    "masstel n540": [
        "2M"
    ],
    "masstel n550": [
        "2M"
    ],
    "masstel n580": [
        "2M"
    ],
    "masstel_x9": [
        "2M"
    ],
    "nomu s30mini": [
        "2N"
    ],
    "nomu_t18": [
        "2N"
    ],
    "tinai k1": [
        "2T"
    ],
    "tinai k2": [
        "2T"
    ],
    "icherry c110": [
        "3I"
    ],
    "icherry c121": [
        "3I"
    ],
    "icherry c211": [
        "3I"
    ],
    "icherry c216": [
        "3I"
    ],
    "icherry c220": [
        "3I"
    ],
    "icherry_c227": [
        "3I"
    ],
    "icherry c229": [
        "3I"
    ],
    "icherry c230": [
        "3I"
    ],
    "icherry c233": [
        "3I"
    ],
    "icherry c251": [
        "3I"
    ],
    "icherry c252": [
        "3I"
    ],
    "icherry c255": [
        "3I"
    ],
    "meitu2": [
        "3M"
    ],
    "build/jop40d;meitu kiss": [
        "3M"
    ],
    "meitu m4": [
        "3M"
    ],
    "mp1503": [
        "3M"
    ],
    "mp1512": [
        "3M"
    ],
    "mp1603": [
        "3M"
    ],
    "mp1711": [
        "3M"
    ],
    "mp1709": [
        "3M"
    ],
    "mp1602": [
        "3M"
    ],
    "mp1713": [
        "3M"
    ],
    "mp1701": [
        "3M"
    ],
    "mp1718": [
        "3M"
    ],
    "meitu v4": [
        "3M"
    ],
    "mp1605": [
        "3M"
    ],
    "positivo mini i": [
        "3P"
    ],
    "s455": [
        "3P"
    ],
    "twist (2018)": [
        "3P"
    ],
    "twist 2": [
        "3P"
    ],
    "twist 2 fit": [
        "3P"
    ],
    "twist 2 pro": [
        "3P"
    ],
    "twist 3": [
        "3P"
    ],
    "positivo twist m": [
        "3P"
    ],
    "twist max": [
        "3P"
    ],
    "twist metal": [
        "3P"
    ],
    "twist metal 32gb": [
        "3P"
    ],
    "twist_mini": [
        "3P"
    ],
    "twist mini": [
        "3P"
    ],
    "positivo twist s": [
        "3P"
    ],
    "twist se": [
        "3P"
    ],
    "twist xl": [
        "3P"
    ],
    "zyvv1": [
        "3V"
    ],
    "aligator rx510": [
        "4A"
    ],
    "aligator s4080": [
        "4A"
    ],
    "aligator s5060": [
        "4A"
    ],
    "aligator s5065": [
        "4A"
    ],
    "aligator_s5066": [
        "4A"
    ],
    "aligator s5070": [
        "4A"
    ],
    "aligator s5080": [
        "4A"
    ],
    "4good light a103": [
        "4G"
    ],
    "light b100": [
        "4G"
    ],
    "4good s555m 4g": [
        "4G"
    ],
    "people g410": [
        "4G"
    ],
    "people g503": [
        "4G"
    ],
    "4good s450m 4g": [
        "4G"
    ],
    "s501m 3g": [
        "4G"
    ],
    "matrix": [
        "4M"
    ],
    "mobicel_r1": [
        "4M"
    ],
    "pcs01": [
        "4P"
    ],
    "tsd octa a0520p": [
        "5A"
    ],
    "tsd quadra a0509p": [
        "5A",
        "PG"
    ],
    "2e e450 2018": [
        "5E"
    ],
    "e500a_2019": [
        "5E"
    ],
    "zug 3": [
        "5M"
    ],
    "zug 5s": [
        "5M"
    ],
    "zug 5s q": [
        "5M"
    ],
    "nos five": [
        "5N"
    ],
    "nos neva 80": [
        "5N"
    ],
    "nos novu": [
        "5N"
    ],
    "nos novu ii": [
        "5N"
    ],
    "nos novu iii": [
        "5N"
    ],
    "nos roya": [
        "5N"
    ],
    "phonemax_mars": [
        "5P"
    ],
    "phonemax_saturn": [
        "5P"
    ],
    "phonemax_saturn_x": [
        "5P"
    ],
    "qs5509a": [
        "6A"
    ],
    "u304aa": [
        "6A"
    ],
    "primuxdelta6": [
        "6P"
    ],
    "carbono_5": [
        "6S"
    ],
    "cuarzo_6": [
        "6S"
    ],
    "diamante_5": [
        "6S"
    ],
    "vulcano_55": [
        "6S"
    ],
    "twoe e450r": [
        "6T"
    ],
    "maxtron s8": [
        "6X"
    ],
    "maxtron_v2": [
        "6X"
    ],
    "maxtron_v3": [
        "6X"
    ],
    "maxtron-v7": [
        "6X"
    ],
    "ibrit_i5": [
        "7I"
    ],
    "ibrit_i7": [
        "7I"
    ],
    "ibrit_power6": [
        "7I"
    ],
    "ibrit_speed pro": [
        "7I"
    ],
    "ms450": [
        "7M"
    ],
    "ms453": [
        "7M"
    ],
    "ms456": [
        "7M"
    ],
    "ms457": [
        "7M"
    ],
    "ms457plus": [
        "7M"
    ],
    "ms505": [
        "7M"
    ],
    "ms514": [
        "7M"
    ],
    "shift6m": [
        "7S"
    ],
    "mito-311": [
        "8M"
    ],
    "mito_a10": [
        "8M"
    ],
    "mito a16": [
        "8M"
    ],
    "mito a18": [
        "8M"
    ],
    "mito a180": [
        "8M"
    ],
    "mito a230": [
        "8M"
    ],
    "mito a260": [
        "8M"
    ],
    "mito a30": [
        "8M"
    ],
    "mito a310": [
        "8M"
    ],
    "mito a313": [
        "8M"
    ],
    "mito a322": [
        "8M"
    ],
    "mito a33": [
        "8M"
    ],
    "mito a330": [
        "8M"
    ],
    "mito a350": [
        "8M"
    ],
    "mito a360": [
        "8M"
    ],
    "mito a39": [
        "8M"
    ],
    "mito a50": [
        "8M"
    ],
    "mito a55": [
        "8M"
    ],
    "mito_a550": [
        "8M"
    ],
    "mito a60": [
        "8M"
    ],
    "mito a68": [
        "8M"
    ],
    "mito_a69": [
        "8M"
    ],
    "mito_a72": [
        "8M"
    ],
    "mito a73": [
        "8M"
    ],
    "mito a75": [
        "8M"
    ],
    "mito a810": [
        "8M"
    ],
    "mito_a82": [
        "8M"
    ],
    "mito_a950": [
        "8M"
    ],
    "iqm newton": [
        "8Q"
    ],
    "iqm picasso": [
        "8Q"
    ],
    "iqm vivaldi": [
        "8Q"
    ],
    "soyes 6s": [
        "8S"
    ],
    "soyes_7s": [
        "8S"
    ],
    "amigoo m1 max": [
        "9A"
    ],
    "amigoo r300": [
        "9A"
    ],
    "amigoo r9 max": [
        "9A"
    ],
    "amigoo x15": [
        "9A"
    ],
    "sugar c11": [
        "9S"
    ],
    "sugar c21": [
        "9S"
    ],
    "sugar c6": [
        "9S"
    ],
    "sugar f11": [
        "9S"
    ],
    "sugar f7 mini": [
        "9S"
    ],
    "sugar f9": [
        "9S"
    ],
    "sugar s9": [
        "9S"
    ],
    "sugar y11": [
        "9S"
    ],
    "sugar y12": [
        "9S"
    ],
    "sugar y15": [
        "9S"
    ],
    "sugar y7": [
        "9S"
    ],
    "sugar y7 max": [
        "9S"
    ],
    "sugar y8 max": [
        "9S"
    ],
    "sugar y9": [
        "9S"
    ],
    "allview 2 speed quad": [
        "A2"
    ],
    "a10_lite_2019": [
        "A2"
    ],
    "a10_plus": [
        "A2"
    ],
    "a4you": [
        "A2"
    ],
    "allview a4all": [
        "A2"
    ],
    "a5_easy": [
        "A2"
    ],
    "a5_easy_tm": [
        "A2"
    ],
    "a5_quad": [
        "A2"
    ],
    "a5_quad_plus_tm": [
        "A2"
    ],
    "a5_ready": [
        "A2"
    ],
    "a5_ready_tm": [
        "A2"
    ],
    "a5smiley": [
        "A2"
    ],
    "a6_duo": [
        "A2"
    ],
    "a6_lite": [
        "A2"
    ],
    "a7_lite": [
        "A2"
    ],
    "a8_lite": [
        "A2"
    ],
    "a9_lite": [
        "A2"
    ],
    "allview p4i": [
        "A2"
    ],
    "c6_duo": [
        "A2"
    ],
    "e2_living": [
        "A2"
    ],
    "e3_jump": [
        "A2"
    ],
    "e3_living": [
        "A2"
    ],
    "e3_sign": [
        "A2"
    ],
    "e4_lite": [
        "A2"
    ],
    "impera s": [
        "A2"
    ],
    "m9_connect": [
        "A2"
    ],
    "p10_life": [
        "A2"
    ],
    "p10_max": [
        "A2"
    ],
    "p10_style": [
        "A2"
    ],
    "p4_emagic": [
        "A2"
    ],
    "p4_pro": [
        "A2"
    ],
    "p4_quad": [
        "A2"
    ],
    "p41_emagic": [
        "A2"
    ],
    "p41_emagic_tm": [
        "A2"
    ],
    "p43_easy": [
        "A2"
    ],
    "p5_emagic_tm": [
        "A2"
    ],
    "p5_emagic": [
        "A2"
    ],
    "p5life_tm": [
        "A2"
    ],
    "p5_lite": [
        "A2"
    ],
    "p5_pro": [
        "A2"
    ],
    "allview_p6": [
        "A2"
    ],
    "p6_energy": [
        "A2"
    ],
    "p6_energy_tm": [
        "A2"
    ],
    "p6_energy_lite": [
        "A2"
    ],
    "p6_energy_mini": [
        "A2"
    ],
    "p6_lite": [
        "A2"
    ],
    "p6_lite_tm": [
        "A2"
    ],
    "p6_plus": [
        "A2"
    ],
    "p6_pro": [
        "A2"
    ],
    "p6_qmax": [
        "A2"
    ],
    "allview_p6_quad": [
        "A2"
    ],
    "p7_pro": [
        "A2"
    ],
    "p7_pro_tm": [
        "A2"
    ],
    "p7_seon": [
        "A2"
    ],
    "p7_xtreme": [
        "A2"
    ],
    "p8_emagic_tm": [
        "A2"
    ],
    "p8_emagic": [
        "A2"
    ],
    "p8_energy": [
        "A2"
    ],
    "p8_energy_mini_tm": [
        "A2"
    ],
    "p8_energy_mini": [
        "A2"
    ],
    "p8_energy_pro": [
        "A2"
    ],
    "p8_life": [
        "A2"
    ],
    "p8_pro": [
        "A2"
    ],
    "p9_energy": [
        "A2"
    ],
    "p9_energy_lite": [
        "A2"
    ],
    "p9_energy_lite_2017": [
        "A2"
    ],
    "p9_energy_mini": [
        "A2"
    ],
    "p9_energy_mini_tm": [
        "A2"
    ],
    "p9_energy_s": [
        "A2"
    ],
    "p9_life": [
        "A2"
    ],
    "p9_life_tm": [
        "A2"
    ],
    "v1_viper": [
        "A2"
    ],
    "v1_viper_i": [
        "A2"
    ],
    "v1_viper_i4g_tm": [
        "A2"
    ],
    "v1_viper_i4g": [
        "A2"
    ],
    "v2_viper_e": [
        "A2"
    ],
    "v2_viper_i_tm": [
        "A2"
    ],
    "v2_viper_i": [
        "A2"
    ],
    "v2_viper_i4g": [
        "A2"
    ],
    "v2_viper_s": [
        "A2"
    ],
    "v2_viper_x": [
        "A2"
    ],
    "v2_viper_x_plus": [
        "A2"
    ],
    "v2_viper_xe": [
        "A2"
    ],
    "v3_viper": [
        "A2"
    ],
    "v4_viper": [
        "A2"
    ],
    "x1_soul": [
        "A2"
    ],
    "x1_soul_xtreme": [
        "A2"
    ],
    "x2_soul": [
        "A2"
    ],
    "x2_soul_mini": [
        "A2"
    ],
    "x2_soul_mini_tm": [
        "A2"
    ],
    "x2_soul_style_tm": [
        "A2"
    ],
    "x2_soul_style": [
        "A2"
    ],
    "x2_soul_style_plus": [
        "A2"
    ],
    "x2_twin": [
        "A2"
    ],
    "x3_soul": [
        "A2"
    ],
    "x3_soul_lite_tm": [
        "A2"
    ],
    "x3_soul_lite": [
        "A2"
    ],
    "x3_soul_mini": [
        "A2"
    ],
    "x3_soul_plus": [
        "A2"
    ],
    "x3_soul_pro": [
        "A2"
    ],
    "x3_soul_style": [
        "A2"
    ],
    "x4_soul": [
        "A2"
    ],
    "x4_soul_infinity_l": [
        "A2"
    ],
    "x4_soul_infinity_n": [
        "A2"
    ],
    "x4_soul_infinity_s": [
        "A2"
    ],
    "x4_soul_infinity_z": [
        "A2"
    ],
    "x4_soul_lite": [
        "A2"
    ],
    "x4_soul_mini": [
        "A2"
    ],
    "x4_soul_mini_s_tm": [
        "A2"
    ],
    "x4_soul_mini_s": [
        "A2"
    ],
    "x4_soul_style": [
        "A2"
    ],
    "x4_soul_xtreme": [
        "A2"
    ],
    "x5_soul": [
        "A2"
    ],
    "x5_soul_mini": [
        "A2"
    ],
    "x5_soul_pro": [
        "A2"
    ],
    "x6_soul_mini": [
        "A2"
    ],
    "agm a8": [
        "A3"
    ],
    "agm a8 se": [
        "A3"
    ],
    "agm x1": [
        "A3"
    ],
    "agm x2": [
        "A3"
    ],
    "ask_sp581_hd": [
        "A4"
    ],
    "ask sp618": [
        "A4"
    ],
    "altron al-555": [
        "A5"
    ],
    "ark benefit a1": [
        "A6"
    ],
    "ark benefit a2": [
        "A6"
    ],
    "ark benefit a3": [
        "A6"
    ],
    "ark-benefit-i1": [
        "A6"
    ],
    "ark benefit i2": [
        "A6"
    ],
    "ark-benefit i2": [
        "A6"
    ],
    "ark benefit i3": [
        "A6"
    ],
    "ark_benefit_m1": [
        "A6"
    ],
    "ark benefit m1 3g": [
        "A6"
    ],
    "ark_benefit_m1s": [
        "A6"
    ],
    "ark benefit m2": [
        "A6",
        "M1"
    ],
    "ark_benefit_m2c": [
        "A6"
    ],
    "ark benefit m3s": [
        "A6",
        "M1"
    ],
    "ark_benefit_m4": [
        "A6"
    ],
    "ark benefit m5": [
        "A6"
    ],
    "benefit_m5_plus": [
        "A6"
    ],
    "ark benefit m501": [
        "A6"
    ],
    "benefit_m502": [
        "A6"
    ],
    "benefit_m503": [
        "A6"
    ],
    "benefit_m505": [
        "A6"
    ],
    "benefit_m506": [
        "A6"
    ],
    "benefit_m6": [
        "A6"
    ],
    "ark benefit m7": [
        "A6"
    ],
    "benefit_m8": [
        "A6"
    ],
    "benefit_note_1": [
        "A6"
    ],
    "benefit_s401": [
        "A6"
    ],
    "benefit_s402": [
        "A6"
    ],
    "benefit_s403": [
        "A6"
    ],
    "benefit_s404": [
        "A6"
    ],
    "ark_benefit_s451": [
        "A6"
    ],
    "benefit_s453": [
        "A6"
    ],
    "ark_benefit_s501": [
        "A6"
    ],
    "benefit_s502_plus": [
        "A6"
    ],
    "benefit_s503": [
        "A6"
    ],
    "benefit_s503_max": [
        "A6"
    ],
    "benefit_s505": [
        "A6"
    ],
    "edge a5hd": [
        "A6"
    ],
    "elf_s8": [
        "A6"
    ],
    "icon r40+": [
        "A6"
    ],
    "icon r45": [
        "A6"
    ],
    "impulse p1": [
        "A6"
    ],
    "impulse p1+": [
        "A6"
    ],
    "impulse_p2": [
        "A6"
    ],
    "wizard_1": [
        "A6"
    ],
    "as-5432": [
        "A8"
    ],
    "as-5412 max": [
        "A8"
    ],
    "as_601l": [
        "A8"
    ],
    "as_401l": [
        "A8"
    ],
    "as_501": [
        "A8"
    ],
    "as-5434": [
        "A8"
    ],
    "as-5436_grid": [
        "A8"
    ],
    "as-5411 max": [
        "A8"
    ],
    "as-5433 max secret": [
        "A8"
    ],
    "as-5431": [
        "A8"
    ],
    "as-6431": [
        "A8"
    ],
    "as-5433 secret": [
        "A8"
    ],
    "as-5435": [
        "A8"
    ],
    "as-502": [
        "A8"
    ],
    "as-5421": [
        "A8"
    ],
    "as-503": [
        "A8"
    ],
    "as-4411": [
        "A8"
    ],
    "as-4421": [
        "A8"
    ],
    "gsmart alto a2": [
        "GG"
    ],
    "bush 10.0 mytablet": [
        "B1",
        "MY1"
    ],
    "bush 7.85 tablet": [
        "B1"
    ],
    "beeline tab": [
        "B5"
    ],
    "beeline tab 2": [
        "B5"
    ],
    "beeline tab fast": [
        "B5"
    ],
    "beeline tab pro": [
        "B5"
    ],
    "bdf-819": [
        "B6"
    ],
    "k960n_mt6580_32_n": [
        "B6"
    ],
    "k960n_mt6753": [
        "B6"
    ],
    "bdf k107h": [
        "B6"
    ],
    "bdf-kt107": [
        "B6"
    ],
    "bdf-mt6753": [
        "B6"
    ],
    "bdf-p10": [
        "B6"
    ],
    "bdf-x20": [
        "B6"
    ],
    "mobitab10c-3g": [
        "B7"
    ],
    "tab1011q_ii": [
        "B7"
    ],
    "k10 se": [
        "B9"
    ],
    "k10se": [
        "B9"
    ],
    "positivo bgh +simple": [
        "BG"
    ],
    "positivo bgh mini": [
        "BG"
    ],
    "positivo bgh y100": [
        "BG"
    ],
    "positivo bgh y1010": [
        "BG"
    ],
    "positivo bgh y200": [
        "BG"
    ],
    "positivo bgh y210": [
        "BG"
    ],
    "positivo bgh y700": [
        "BG"
    ],
    "positivo bgh y710 kids": [
        "BG"
    ],
    "nook bnrv200": [
        "BN"
    ],
    "nook bntv250": [
        "BN"
    ],
    "nook bntv250a": [
        "BN"
    ],
    "bntv400": [
        "BN"
    ],
    "bntv600": [
        "BN"
    ],
    "nookcolor": [
        "BN"
    ],
    "nook tablet": [
        "BN",
        "OT"
    ],
    "atlantis 1001a": [
        "BP"
    ],
    "atlantis 1010a": [
        "BP"
    ],
    "atlantis a10.g402": [
        "BP"
    ],
    "atlantis a10.g403": [
        "BP"
    ],
    "discovery 1000c": [
        "BP"
    ],
    "discovery_1001": [
        "BP",
        "EX"
    ],
    "discovery 1001a": [
        "BP"
    ],
    "discovery 111c": [
        "BP"
    ],
    "discovery_a10_302": [
        "BP"
    ],
    "endeavour 1001 dvb-t": [
        "BP"
    ],
    "endeavour 1010": [
        "BP"
    ],
    "endeavour 1013": [
        "BP"
    ],
    "endeavour_101l": [
        "BP"
    ],
    "endeavour_1100": [
        "BP"
    ],
    "endeavour 785": [
        "BP"
    ],
    "polaris_803": [
        "BP"
    ],
    "surfing tab b 9.7 3g": [
        "BR"
    ],
    "surfing tab c 3g": [
        "BR"
    ],
    "nb105": [
        "BV"
    ],
    "nb106m": [
        "BV"
    ],
    "nb107": [
        "BV"
    ],
    "nb108": [
        "BV"
    ],
    "nb74": [
        "BV"
    ],
    "nb751": [
        "BV"
    ],
    "nb76": [
        "BV"
    ],
    "nb851": [
        "BV"
    ],
    "nb871": [
        "BV"
    ],
    "nb961": [
        "BV"
    ],
    "np101": [
        "BV"
    ],
    "bravis np 103": [
        "BV"
    ],
    "np 104 3g": [
        "BV"
    ],
    "bravis np 844": [
        "BV"
    ],
    "bravis_slim_3g": [
        "BV"
    ],
    "bqru-1056l": [
        "BX"
    ],
    "bqru-7083": [
        "BX"
    ],
    "bq-7061g": [
        "BX"
    ],
    "aquaris m8": [
        "BX",
        "IX"
    ],
    "bqru-7082": [
        "BX"
    ],
    "bq-7098g": [
        "BX"
    ],
    "bq-1082g": [
        "BX"
    ],
    "bq-1077l": [
        "BX"
    ],
    "bq-1022l": [
        "BX"
    ],
    "bq-1083g": [
        "BX"
    ],
    "bq-8041l": [
        "BX"
    ],
    "bq-7001g": [
        "BX"
    ],
    "bq-7002g": [
        "BX"
    ],
    "bq-7056g": [
        "BX"
    ],
    "bq-7850": [
        "BX"
    ],
    "bq-8002g": [
        "BX"
    ],
    "bq-8052g": [
        "BX"
    ],
    "bq-9051g": [
        "BX"
    ],
    "bq-9052g": [
        "BX"
    ],
    "bq-9702g": [
        "BX"
    ],
    "bq-7022g": [
        "BX"
    ],
    "bq-7022": [
        "BX"
    ],
    "bqru-7081": [
        "BX"
    ],
    "bq-7008g": [
        "BX"
    ],
    "bq-1051g": [
        "BX"
    ],
    "bq curie": [
        "BX"
    ],
    "bq edison": [
        "BX"
    ],
    "bq edison 2 quad core": [
        "BX"
    ],
    "bq edison 3g": [
        "BX"
    ],
    "bq-7051g": [
        "BX"
    ],
    "bq elcano": [
        "BX"
    ],
    "bq-7062g": [
        "BX"
    ],
    "bq-7064g": [
        "BX"
    ],
    "bq1008g": [
        "BX"
    ],
    "bq-1008g": [
        "BX"
    ],
    "bqru-1081g": [
        "BX"
    ],
    "bq-1050g": [
        "BX"
    ],
    "bq-7021g": [
        "BX"
    ],
    "bq-7036l": [
        "BX"
    ],
    "bq-1084l": [
        "BX"
    ],
    "bq-1085l": [
        "BX"
    ],
    "bq-8067l": [
        "BX"
    ],
    "bq-7003": [
        "BX"
    ],
    "bq-8006g": [
        "BX"
    ],
    "bq-7038g": [
        "BX"
    ],
    "bq-7802g": [
        "BX"
    ],
    "bq-7050g": [
        "BX"
    ],
    "bq-7005g": [
        "BX"
    ],
    "bq-7010g": [
        "BX"
    ],
    "bq maxwell plus": [
        "BX"
    ],
    "bq-1007": [
        "BX"
    ],
    "bq-1054l": [
        "BX"
    ],
    "bq-1045g": [
        "BX"
    ],
    "bq-1045": [
        "BX"
    ],
    "bqru-1057l": [
        "BX"
    ],
    "bq-7084g": [
        "BX"
    ],
    "bq-7006g": [
        "BX"
    ],
    "bq-9011": [
        "BX"
    ],
    "bq-7000g": [
        "BX"
    ],
    "bq-7040g": [
        "BX"
    ],
    "ctab101l32g": [
        "C5"
    ],
    "ctab700l": [
        "C5"
    ],
    "tfx712g": [
        "C5"
    ],
    "tgw709": [
        "C5"
    ],
    "tgw710g": [
        "C5"
    ],
    "tra-901g": [
        "C5"
    ],
    "ct701g plus": [
        "C6"
    ],
    "ct701w": [
        "C6"
    ],
    "gt100": [
        "C6"
    ],
    "tesla_tablet_785": [
        "C7"
    ],
    "tesla gravity 9.7 shd": [
        "C7"
    ],
    "tesla tth7": [
        "C7"
    ],
    "impulse 7.85 3g": [
        "C7"
    ],
    "tesla ttl7": [
        "C7"
    ],
    "tesla_tablet_l7_3g": [
        "C7"
    ],
    "tesla l7 quad": [
        "C7"
    ],
    "tesla tablet l7 quad lite": [
        "C7"
    ],
    "tesla l7.1": [
        "C7"
    ],
    "ttl713g": [
        "C7"
    ],
    "ttl8": [
        "C7"
    ],
    "tesla l8.1": [
        "C7"
    ],
    "tesla_tablet_m7": [
        "C7"
    ],
    "tesla_tablet_m8": [
        "C7"
    ],
    "c-721": [
        "C8"
    ],
    "cat tablet galactica x 9.7ca": [
        "CA"
    ],
    "cat nova": [
        "CA"
    ],
    "cat tablet android 4.0.4": [
        "CA"
    ],
    "catnova8": [
        "CA"
    ],
    "cat tablet phoenix 8.1j0": [
        "CA"
    ],
    "cat stargate": [
        "CA"
    ],
    "cat tablet stargate 2": [
        "CA"
    ],
    "concorde tab play": [
        "CC"
    ],
    "concorde tab t10": [
        "CC"
    ],
    "celkon ct2": [
        "CE"
    ],
    "ct1000": [
        "CF"
    ],
    "ct1010": [
        "CF"
    ],
    "ct1020w": [
        "CF"
    ],
    "ct1030": [
        "CF"
    ],
    "ct710fr": [
        "CF"
    ],
    "ct720": [
        "CF"
    ],
    "ct820": [
        "CF"
    ],
    "fusion bolt": [
        "CH",
        "O1"
    ],
    "q7a": [
        "CM"
    ],
    "q7a+": [
        "CM"
    ],
    "cnm touchpad 9.7": [
        "CN"
    ],
    "captiva 10.1 hd": [
        "CP"
    ],
    "captiva 9.7 super fhd": [
        "CP"
    ],
    "captiva pad 10 3g plus": [
        "CP"
    ],
    "iwork10 flagship": [
        "CU"
    ],
    "i1002s": [
        "CU"
    ],
    "iwork10 pro": [
        "CU"
    ],
    "i1-tfd": [
        "CU"
    ],
    "i1-tf": [
        "CU"
    ],
    "i1-tfb": [
        "CU"
    ],
    "i1-tc": [
        "CU"
    ],
    "t8-plus": [
        "CU"
    ],
    "t8-plusms": [
        "CU"
    ],
    "t8plusml": [
        "CU"
    ],
    "t8-plusm": [
        "CU"
    ],
    "u55gt": [
        "CU"
    ],
    "u27gt-3gh": [
        "CU"
    ],
    "u65gt": [
        "CU"
    ],
    "u20gt_ws": [
        "CU"
    ],
    "u23gtc4": [
        "CU"
    ],
    "u25gt": [
        "CU"
    ],
    "u30gt 2h": [
        "CU"
    ],
    "u30gt c4": [
        "CU"
    ],
    "u30gt-h": [
        "CU"
    ],
    "u30gt-hs": [
        "CU"
    ],
    "u30gt2": [
        "CU"
    ],
    "u39gt-3g": [
        "CU"
    ],
    "u51gt-w": [
        "CU"
    ],
    "u9gt v_core 4": [
        "CU"
    ],
    "u9gt3": [
        "CU"
    ],
    "mid1024": [
        "CY"
    ],
    "mid1045": [
        "CY"
    ],
    "mid1048": [
        "CY"
    ],
    "mid1060": [
        "CY"
    ],
    "mid1125": [
        "CY"
    ],
    "mid1126": [
        "CY"
    ],
    "mid7012": [
        "CY"
    ],
    "mid7015": [
        "CY"
    ],
    "mid7015a": [
        "CY"
    ],
    "mid7016": [
        "CY"
    ],
    "mid7022": [
        "CY"
    ],
    "mid7032": [
        "CY"
    ],
    "mid7035": [
        "CY"
    ],
    "mid7036": [
        "CY"
    ],
    "mid7042": [
        "CY"
    ],
    "mid7048": [
        "CY"
    ],
    "mid7052": [
        "CY"
    ],
    "mid7065": [
        "CY"
    ],
    "mid7120": [
        "CY"
    ],
    "mid8024": [
        "CY"
    ],
    "mid8042": [
        "CY"
    ],
    "mid8048": [
        "CY"
    ],
    "mid8125": [
        "CY"
    ],
    "mid8127": [
        "CY"
    ],
    "mid8128": [
        "CY"
    ],
    "mid9724": [
        "CY"
    ],
    "mid9740": [
        "CY"
    ],
    "mid9742": [
        "CY"
    ],
    "citi 1532 3g cs1144mg": [
        "D2"
    ],
    "citi_1544_3g_cs1154mg": [
        "D2"
    ],
    "citi 1576 3g cs1194mg": [
        "D2"
    ],
    "citi 1577 3g cs1195mg": [
        "D2"
    ],
    "citi 1578 4g cs1196ml": [
        "D2"
    ],
    "citi 1901 4g cs1050pl": [
        "D2"
    ],
    "citi 1902 3g cs1051pg": [
        "D2"
    ],
    "citi 3000 4g cs3001ml": [
        "D2"
    ],
    "citi 7507 4g cs7113pl": [
        "D2"
    ],
    "citi 7575 3g cs7193mg": [
        "D2"
    ],
    "citi_7586_3g_ts7203mg": [
        "D2"
    ],
    "citi_8527_4g_cs8139ml": [
        "D2"
    ],
    "citi_8542_4g_cs8152ml": [
        "D2"
    ],
    "citi_8588_3g_cs8205pg": [
        "D2"
    ],
    "citi 8592 3g cs8209mg": [
        "D2"
    ],
    "citi octa 80 cs8218pl": [
        "D2"
    ],
    "citi z510 3g ct5006pg": [
        "D2"
    ],
    "citi z520 3g cs5007pg": [
        "D2"
    ],
    "idxd8 3g": [
        "D2"
    ],
    "digma d700": [
        "D2"
    ],
    "hit 3g ht7071mg": [
        "D2"
    ],
    "hit ht7070mg": [
        "D2"
    ],
    "hit 4g ht7074ml": [
        "D2"
    ],
    "digma idj7 3g": [
        "D2"
    ],
    "idnd7": [
        "D2"
    ],
    "idrq10 3g": [
        "D2"
    ],
    "digma ids10 3g": [
        "D2"
    ],
    "mvm900hwz": [
        "D2"
    ],
    "mvm908hcz": [
        "D2"
    ],
    "idxd10 3g": [
        "D2"
    ],
    "idxd7 3g": [
        "D2"
    ],
    "optima 10.3 3g tt1003mg": [
        "D2"
    ],
    "tt1004pg": [
        "D2"
    ],
    "optima 1104s 3g ts1087mg": [
        "D2"
    ],
    "tt7025mg": [
        "D2"
    ],
    "optima 8019n 4g ts8182ml": [
        "D2"
    ],
    "optima e7.1 3g tt7071mg": [
        "D2"
    ],
    "optima m7.0 tt7008aw": [
        "D2"
    ],
    "optima prime 3g tt7000mg": [
        "D2"
    ],
    "ps1043mg": [
        "D2"
    ],
    "plane 8.4 3g ps8040mg": [
        "D2"
    ],
    "plane 8555m 4g ps8168ml": [
        "D2"
    ],
    "plane 8566n 3g ps8181mg": [
        "D2"
    ],
    "platina 1579m 4g ns1800ml": [
        "D2"
    ],
    "platina 7.1 4g ns7001ql": [
        "D2"
    ],
    "platina 9.7 3g ns9797mg": [
        "D2"
    ],
    "platina 7.2 4g ns6902ql": [
        "D2"
    ],
    "dta-07idrf": [
        "D5"
    ],
    "dslide 1013": [
        "DA"
    ],
    "dslide 700": [
        "DA"
    ],
    "dslide 702": [
        "DA"
    ],
    "dslide 703r": [
        "DA"
    ],
    "dslide 704": [
        "DA"
    ],
    "dslide 706": [
        "DA"
    ],
    "dslide 707": [
        "DA"
    ],
    "dslide800": [
        "DA"
    ],
    "dslide801": [
        "DA"
    ],
    "dslide900": [
        "DA"
    ],
    "dslide 971": [
        "DA"
    ],
    "dslide971dc": [
        "DA"
    ],
    "dslide972": [
        "DA"
    ],
    "dslide973": [
        "DA"
    ],
    "dslide973qc": [
        "DA"
    ],
    "dl1008m": [
        "DD"
    ],
    "tac-70051": [
        "DE"
    ],
    "tad-10023": [
        "DE"
    ],
    "tad-70092": [
        "DE"
    ],
    "tad-97052": [
        "DE"
    ],
    "tad-97072g": [
        "DE"
    ],
    "po10319taq-10172mk3": [
        "DE"
    ],
    "po10039taq-10172mk3": [
        "DE"
    ],
    "po9659taq-10182": [
        "DE"
    ],
    "po11141taq-10242mk2": [
        "DE"
    ],
    "po9818taq-70242": [
        "DE"
    ],
    "po10044taq-70242mk2": [
        "DE"
    ],
    "dell streak": [
        "DL"
    ],
    "dell streak 7": [
        "DL"
    ],
    "venue 10 7040": [
        "DL"
    ],
    "venue 7 3730": [
        "DL"
    ],
    "venue7 3740": [
        "DL"
    ],
    "venue 8 3830": [
        "DL"
    ],
    "venue 8 7840": [
        "DL"
    ],
    "venue 8 hspa+": [
        "DL"
    ],
    "airtab p970g": [
        "DN"
    ],
    "dns airtab pf7001": [
        "DN"
    ],
    "dexp ursus 9ev 3g": [
        "DX"
    ],
    "ursus ns370i": [
        "DX"
    ],
    "ursus ts170": [
        "DX"
    ],
    "ursus ts197 navis": [
        "DX"
    ],
    "va110": [
        "DX"
    ],
    "va210": [
        "DX"
    ],
    "playpad 3g goo": [
        "E0"
    ],
    "playpad 3gtab xl": [
        "E0"
    ],
    "evromedia play pad pro": [
        "E0"
    ],
    "energyi8dual": [
        "E1"
    ],
    "energy s10 dual": [
        "E1"
    ],
    "energy x10 quad": [
        "E1"
    ],
    "gotab gbt9": [
        "E7"
    ],
    "gotab gti8": [
        "E7"
    ],
    "ergo tab crystal lite": [
        "E7"
    ],
    "ergo tab hero ii": [
        "E7"
    ],
    "e-boda supreme x80 dual core": [
        "EB"
    ],
    "e-boda supreme xl200ips": [
        "EB"
    ],
    "tab101 3g": [
        "EG"
    ],
    "tab708": [
        "EG"
    ],
    "tab716": [
        "EG"
    ],
    "tab728 3g": [
        "EG"
    ],
    "tab730": [
        "EG"
    ],
    "tab733": [
        "EG"
    ],
    "tab738": [
        "EG"
    ],
    "tab740": [
        "EG"
    ],
    "easypad 971": [
        "EP"
    ],
    "ta10ca3": [
        "ES"
    ],
    "tm105": [
        "ES"
    ],
    "tm105a": [
        "ES"
    ],
    "tr10cs1": [
        "ES"
    ],
    "et7002c-h12": [
        "EU"
    ],
    "e7020hd": [
        "EV"
    ],
    "e7050hd": [
        "EV"
    ],
    "e8050hg": [
        "EV"
    ],
    "e8051hd": [
        "EV"
    ],
    "actived 7.4 3g": [
        "EX"
    ],
    "actived_8.2_3g": [
        "EX"
    ],
    "cinematv 3g": [
        "EX"
    ],
    "imperium7": [
        "EX"
    ],
    "imperium8": [
        "EX"
    ],
    "infinityll": [
        "EX"
    ],
    "informer 705": [
        "EX"
    ],
    "informer 706 3g": [
        "EX"
    ],
    "informer 921": [
        "EX"
    ],
    "leader": [
        "EX"
    ],
    "onliner1": [
        "EX"
    ],
    "onliner2": [
        "EX"
    ],
    "onliner3": [
        "EX"
    ],
    "squad 10.06 3g": [
        "EX"
    ],
    "squad 7.82 3g": [
        "EX"
    ],
    "surfer 10.11": [
        "EX"
    ],
    "surfer 7.32 3g": [
        "EX"
    ],
    "finepower a1": [
        "F1"
    ],
    "finepower a2": [
        "F1"
    ],
    "finepower b1": [
        "F1"
    ],
    "finepower b2": [
        "F1"
    ],
    "finepower b3": [
        "F1"
    ],
    "q008b": [
        "FD"
    ],
    "q010b": [
        "FD"
    ],
    "q718b": [
        "FD"
    ],
    "q902": [
        "FD"
    ],
    "t707g": [
        "FD"
    ],
    "t708b": [
        "FD"
    ],
    "t725b": [
        "FD"
    ],
    "t725b1": [
        "FD"
    ],
    "t907b": [
        "FD"
    ],
    "vkb004l": [
        "FE"
    ],
    "vkb011b": [
        "FE"
    ],
    "flylife connect 7 3g": [
        "FL"
    ],
    "fly_iq310": [
        "FL"
    ],
    "f-02f": [
        "FU"
    ],
    "f-02k": [
        "FU"
    ],
    "f-05e": [
        "FU"
    ],
    "fartm933kz": [
        "FU"
    ],
    "m532": [
        "FU"
    ],
    "gu1011c": [
        "G4"
    ],
    "gu-6012b": [
        "G4"
    ],
    "gu7013c": [
        "G4"
    ],
    "gu730c": [
        "G4"
    ],
    "gu8012c": [
        "G4"
    ],
    "aries_101": [
        "GC"
    ],
    "elipso_71": [
        "GC"
    ],
    "insignia_1010m": [
        "GC"
    ],
    "insignia_785_pro": [
        "GC"
    ],
    "insignia_800m": [
        "GC"
    ],
    "libra 97": [
        "GC"
    ],
    "orion_102": [
        "GC"
    ],
    "quantum_1010m": [
        "GC"
    ],
    "quantum_1010n": [
        "GC"
    ],
    "tq700n": [
        "GC"
    ],
    "quantum_900": [
        "GC"
    ],
    "goclever tab m723g": [
        "GC"
    ],
    "goclever tab r106": [
        "GC"
    ],
    "goclever tab r70": [
        "GC"
    ],
    "goclever tab t76": [
        "GC"
    ],
    "gem10313bk": [
        "GD"
    ],
    "gem10313s": [
        "GD"
    ],
    "gem7008": [
        "GD"
    ],
    "gem7020": [
        "GD"
    ],
    "gem7032g-rev2": [
        "GD"
    ],
    "ghia_axis7": [
        "GH"
    ],
    "nexus 10": [
        "GO"
    ],
    "ainovo flame (nexus 7)": [
        "GO"
    ],
    "nexus 7": [
        "GO"
    ],
    "nexus 7 2013": [
        "GO"
    ],
    "nexus 9": [
        "GO"
    ],
    "pixel c": [
        "GO"
    ],
    "gigaset qv1030": [
        "GS"
    ],
    "gigaset qv830": [
        "GS"
    ],
    "gr-tb10s": [
        "GU"
    ],
    "ginzzu gt-1050": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7010": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7020": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7030": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7040": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7105": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7115": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7210": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-7810": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-8010": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-8110": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-w831": [
        "GZ",
        "SA"
    ],
    "ginzzu_gt-x770": [
        "GZ"
    ],
    "ginzzu gt-x831": [
        "GZ",
        "SA"
    ],
    "pad d71": [
        "HA"
    ],
    "pad g781": [
        "HA"
    ],
    "hsg1316": [
        "HE"
    ],
    "sn1at71w(b)": [
        "HE"
    ],
    "sn70t3": [
        "HE"
    ],
    "sn70t31": [
        "HE"
    ],
    "sn70t51a": [
        "HE"
    ],
    "sn97t41w": [
        "HE"
    ],
    "t7-qc": [
        "HE"
    ],
    "e270bsa": [
        "HI"
    ],
    "m470bsa": [
        "HI"
    ],
    "m470bse": [
        "HI"
    ],
    "e2281": [
        "HI"
    ],
    "hlv-t1002w": [
        "HL"
    ],
    "hlv-t702": [
        "HL"
    ],
    "hyundai t10": [
        "HN"
    ],
    "hyundai t7s": [
        "HN"
    ],
    "hp 10 plus": [
        "HP"
    ],
    "compaq 7": [
        "HP"
    ],
    "compaq 8": [
        "HP"
    ],
    "hp pro slate 8": [
        "HP"
    ],
    "hp slate 10 hd": [
        "HP"
    ],
    "hp slate 7": [
        "HP"
    ],
    "hp 7": [
        "HP"
    ],
    "hp slate7 extreme": [
        "HP"
    ],
    "hp 7 g2": [
        "HP"
    ],
    "hp 7 plus": [
        "HP"
    ],
    "hp slate 7 plus": [
        "HP"
    ],
    "hp 7 plus g2": [
        "HP"
    ],
    "hp 7 voicetab": [
        "HP"
    ],
    "hp 8": [
        "HP"
    ],
    "hp 8 g2": [
        "HP"
    ],
    "hp slate 8 pro": [
        "HP"
    ],
    "hp slatebook 10 x2 pc": [
        "HP"
    ],
    "sprint atp515ckit": [
        "HT"
    ],
    "htc flyer": [
        "HT",
        "FL"
    ],
    "htc_flyer_p510e": [
        "HT"
    ],
    "htc flyer p512": [
        "HT",
        "FL"
    ],
    "htc-p715a": [
        "HT"
    ],
    "bza-w00": [
        "HU"
    ],
    "d-02h": [
        "HU"
    ],
    "d-01j": [
        "HU"
    ],
    "d-02k": [
        "HU"
    ],
    "ags2-al00": [
        "HU"
    ],
    "jdn-w09": [
        "HU"
    ],
    "q93s": [
        "WU"
    ],
    "o8hd": [
        "O4"
    ],
    "tr10rs1": [
        "ES"
    ],
    "dw-ubt7w": [
        "D7"
    ],
    "bleck": [
        "3K"
    ],
    "ek-t7020": [
        "4K"
    ],
    "ek-mii": [
        "4K"
    ],
    "ipad8,9": [
        "AP"
    ],
    "ipad8,10": [
        "AP"
    ],
    "ipad8,11": [
        "AP"
    ],
    "ipad8,12": [
        "AP"
    ],
    "ipad11,1": [
        "AP"
    ],
    "ipad11,2": [
        "AP"
    ],
    "ipad11,3": [
        "AP"
    ],
    "ipad11,4": [
        "AP"
    ],
    "ipad11,6": [
        "AP"
    ],
    "ipad11,7": [
        "AP"
    ],
    "ipad13,1": [
        "AP"
    ],
    "ipad13,2": [
        "AP"
    ],
    "samsung sm-p615c": [
        "SA"
    ],
    "samsung sm-p615n": [
        "SA"
    ],
    "samsung-sm-p907a": [
        "SA"
    ],
    "samsung sm-t866n": [
        "SA"
    ],
    "samsung sm-t390": [
        "SA"
    ],
    "sm-t395c": [
        "SA"
    ],
    "sm-t395n": [
        "SA"
    ],
    "samsung sm-t575": [
        "SA"
    ],
    "samsung sm-t575n": [
        "SA"
    ],
    "samsung sm-t577": [
        "SA"
    ],
    "samsung sm-t577u": [
        "SA"
    ],
    "samsung sm-t570": [
        "SA"
    ],
    "sm-t878u": [
        "SA"
    ],
    "samsung sm-t875": [
        "SA"
    ],
    "sm-t875n": [
        "SA"
    ],
    "sm-t975n": [
        "SA"
    ],
    "sm-t976n": [
        "SA"
    ],
    "sm-t978u": [
        "SA"
    ],
    "sm-p617": [
        "SA"
    ],
    "samsung sm-p610x": [
        "SA"
    ],
    "sm-t2519": [
        "SA"
    ],
    "sm-n8000": [
        "SA"
    ],
    "samsung sm-t837": [
        "SA"
    ],
    "sm-t517": [
        "SA"
    ],
    "sm-t545": [
        "SA"
    ],
    "sm-t547": [
        "SA"
    ],
    "sm-t547u": [
        "SA"
    ],
    "sm-t540": [
        "SA"
    ],
    "sm-t365m": [
        "SA"
    ],
    "sm-t365f0": [
        "SA"
    ],
    "sm-t365y": [
        "SA"
    ],
    "samsung sm-t505c": [
        "SA"
    ],
    "samsung sm-t505n": [
        "SA"
    ],
    "samsung sm-t507": [
        "SA"
    ],
    "sm-t725c": [
        "SA"
    ],
    "sm-t727": [
        "SA"
    ],
    "sm-t727r4": [
        "SA"
    ],
    "sm-t727u": [
        "SA"
    ],
    "sm-t867r4": [
        "SA"
    ],
    "sm-t867u": [
        "SA"
    ],
    "sm-t237v": [
        "SA"
    ],
    "sm-t232": [
        "SA"
    ],
    "samsung sm-p588c": [
        "SA"
    ],
    "samsung sm-p583": [
        "SA"
    ],
    "samsung sm-t837p": [
        "SA"
    ],
    "sm-t818v": [
        "SA"
    ],
    "sm-t818": [
        "SA"
    ],
    "ipad14,1": [
        "AP"
    ],
    "ipad14,2": [
        "AP"
    ],
    "ipad12,1": [
        "AP"
    ],
    "ipad12,2": [
        "AP"
    ],
    "ipad13,9": [
        "AP"
    ],
    "ipad13,11": [
        "AP"
    ],
    "ipad13,4": [
        "AP"
    ],
    "ipad13,6": [
        "AP"
    ],
    "ipad13,5": [
        "AP"
    ],
    "ipad13,7": [
        "AP"
    ],
    "ipad13,8": [
        "AP"
    ],
    "ipad13,10": [
        "AP"
    ],
    "mids185pr": [
        "PL"
    ],
    "ipad15,3": [
        "AP"
    ],
    "ipad15,4": [
        "AP"
    ],
    "ipad15,5": [
        "AP"
    ],
    "ipad15,6": [
        "AP"
    ],
    "ipad15,7": [
        "AP"
    ],
    "ipad15,8": [
        "AP"
    ],
    "ipad13,16": [
        "AP"
    ],
    "ipad13,17": [
        "AP"
    ],
    "ipad16,1": [
        "AP"
    ],
    "ipad16,2": [
        "AP"
    ],
    "ipad17,1": [
        "AP"
    ],
    "ipad17,2": [
        "AP"
    ],
    "ipad17,3": [
        "AP"
    ],
    "ipad17,4": [
        "AP"
    ],
    "tb350fu": [
        "LE"
    ],
    "notebook6": [
        "IDI"
    ],
    "bq-1036l": [
        "BX"
    ],
    "optima 1200t 3g tt1043pg": [
        "D2"
    ],
    "plane 1512 3g ps1120mg": [
        "D2"
    ],
    "sky 8421d 4g ss8264pl": [
        "W8"
    ],
    "ursus 10mv 3g": [
        "DX"
    ],
    "spice-mi-710": [
        "SP"
    ],
    "spice mi-730": [
        "SP"
    ],
    "m75tg": [
        "CNG"
    ],
    "echo lolly": [
        "M4"
    ],
    "edu-7mt4": [
        "GAM"
    ],
    "epad 7i": [
        "EPK"
    ],
    "fire_v8": [
        "ODP"
    ],
    "tr10cs2": [
        "ES"
    ],
    "m10l pro": [
        "BU"
    ],
    "x109": [
        "Y9"
    ],
    "lenovo b8080-f": [
        "LE"
    ],
    "tb-x605l": [
        "LE"
    ],
    "sm-t805s": [
        "SA"
    ],
    "true smart 7.0 quadcore": [
        "11"
    ],
    "23046rp50c": [
        "XI"
    ],
    "ru_ru": [
        "P8"
    ],
    "p30s_eea": [
        "T7"
    ],
    "p008": [
        "AU"
    ],
    "m40_plus_row": [
        "T7"
    ],
    "tab 15 pro": [
        "B2"
    ],
    "dbr-w09": [
        "HU"
    ],
    "tb3-x70l": [
        "LE"
    ],
    "tb-x605lc": [
        "LE"
    ],
    "a7600-h": [
        "LE"
    ],
    "mc_faust2": [
        "3O"
    ],
    "mc_darwin6": [
        "3O"
    ],
    "mc_gama4": [
        "3O"
    ],
    "mc_cristo4": [
        "3O"
    ],
    "mc_novapro": [
        "3O"
    ],
    "mc_darwin8": [
        "3O"
    ],
    "mc_darwin7": [
        "3O"
    ],
    "mc_faust3": [
        "3O"
    ],
    "darwin9": [
        "3O"
    ],
    "e1c 3g": [
        "A9"
    ],
    "t20(t2e1)": [
        "T7"
    ],
    "qumo vega 783": [
        "QO"
    ],
    "f10xipsq": [
        "LIN"
    ],
    "p80h(d1c2)": [
        "T7"
    ],
    "yt-x703f": [
        "LE"
    ],
    "tab 16": [
        "B2"
    ],
    "swipe_strike8": [
        "0W"
    ],
    "supra m74ng": [
        "S5"
    ],
    "p7_eea": [
        "PRI"
    ],
    "9166g": [
        "TC"
    ],
    "kids 1210b ws1262rw": [
        "D2"
    ],
    "mi pad4plus": [
        "XI"
    ],
    "23043rp34g": [
        "XI"
    ],
    "dby2-w09": [
        "HU"
    ],
    "vk-740-bl": [
        "VO2"
    ],
    "vodafone smart tab 3g": [
        "VF"
    ],
    "dby2-l09": [
        "HU"
    ],
    "x-tigi_joy10": [
        "XT"
    ],
    "hi10 xpro": [
        "1C"
    ],
    "htc a103 plus": [
        "HT"
    ],
    "tecno dp7cpro": [
        "TB"
    ],
    "t50pro_w_row": [
        "T7"
    ],
    "at723c": [
        "3K"
    ],
    "huawei mediapad t1 10 4g": [
        "HU"
    ],
    "maximus 3.0": [
        "MAT",
        "ZM"
    ],
    "23043rp34i": [
        "XI"
    ],
    "ps650": [
        "PEN"
    ],
    "penta ws704dx": [
        "PEN"
    ],
    "mitab_colors_10": [
        "WL"
    ],
    "phonepad 83g": [
        "AIR"
    ],
    "zmooth": [
        "ZKI"
    ],
    "kfsnwi": [
        "KN"
    ],
    "i10plus": [
        "Y5"
    ],
    "p40hd_t_eea": [
        "T7"
    ],
    "ipad6,11": [
        "AP"
    ],
    "f-01d": [
        "FU"
    ],
    "jarvis7_85": [
        "588"
    ],
    "mq703g_1": [
        "TWN"
    ],
    "tb310xu": [
        "LE"
    ],
    "dunnsexecutive": [
        "UD"
    ],
    "dp7cpro": [
        "TB"
    ],
    "dp7cpro-sga1": [
        "TB"
    ],
    "dp8d": [
        "TB"
    ],
    "dl718m": [
        "DD"
    ],
    "dl703qr": [
        "DD"
    ],
    "dl702q": [
        "DD"
    ],
    "dl1022qr": [
        "DD"
    ],
    "dl1010q": [
        "DD"
    ],
    "cuddle a4": [
        "IB"
    ],
    "optima 1200b ts1266rw": [
        "D2"
    ],
    "hiper s-pad": [
        "HIP"
    ],
    "23073rpbfg": [
        "XI"
    ],
    "23043rp34c": [
        "XI"
    ],
    "tb320fc": [
        "LE"
    ],
    "2307brpdcc": [
        "XI"
    ],
    "okt3": [
        "OE"
    ],
    "rt7 titan 5g": [
        "OE",
        "UZ"
    ],
    "rt6": [
        "OE"
    ],
    "rt5": [
        "OE"
    ],
    "opd2203": [
        "ON"
    ],
    "npad x": [
        "NON"
    ],
    "npadplus": [
        "NON"
    ],
    "npadair": [
        "NON"
    ],
    "npad-pro": [
        "NON"
    ],
    "noteair3c": [
        "3O"
    ],
    "npad-plus": [
        "NON"
    ],
    "pad 60": [
        "OSC"
    ],
    "sm-x916b": [
        "SA"
    ],
    "tab 80": [
        "B2"
    ],
    "tab 60": [
        "B2"
    ],
    "t30pro": [
        "DO"
    ],
    "t10s": [
        "DO"
    ],
    "t20mini": [
        "DO"
    ],
    "t40 air": [
        "T7"
    ],
    "tab kingkong": [
        "CB"
    ],
    "eln-w09": [
        "HNR"
    ],
    "eln-l09": [
        "HNR"
    ],
    "23073rpbfc": [
        "XI"
    ],
    "iplay_50s": [
        "3A"
    ],
    "gtx_jaculus": [
        "GTX"
    ],
    "9494g": [
        "TC"
    ],
    "btk-al09": [
        "HU"
    ],
    "btk-w09": [
        "HU"
    ],
    "techno s700bf": [
        "0B"
    ],
    "minitab 3gv": [
        "T3"
    ],
    "ipad5,3": [
        "AP"
    ],
    "ipad5,2": [
        "AP"
    ],
    "ipad5,1": [
        "AP"
    ],
    "ipad5,4": [
        "AP"
    ],
    "samsung sm-t820": [
        "SA"
    ],
    "samsung sm-t500": [
        "SA"
    ],
    "q6t7in": [
        "QI"
    ],
    "techno 10.1 lte tq060x": [
        "0B"
    ],
    "t1060b": [
        "3P"
    ],
    "bq-1024l": [
        "BX"
    ],
    "smart_l20x": [
        "IG"
    ],
    "s7-classic": [
        "8U"
    ],
    "gravity 4g": [
        "FS"
    ],
    "gravity 3g_2019": [
        "FS"
    ],
    "alfa_7mrc": [
        "H0"
    ],
    "optima 1015 3g tt1121pg": [
        "D2"
    ],
    "droidz drive+": [
        "TOR",
        "MR"
    ],
    "notepad_y80": [
        "DJ"
    ],
    "pr5650": [
        "AD"
    ],
    "primuxzonda4": [
        "6P"
    ],
    "primux_siroco6": [
        "6P"
    ],
    "octa t720q": [
        "QE"
    ],
    "glx dorna": [
        "GX"
    ],
    "seeken st-101": [
        "24"
    ],
    "xelio_pro_10_lte": [
        "O1"
    ],
    "h1003_lte_pro": [
        "A2"
    ],
    "lenovo tb-x606v": [
        "LE"
    ],
    "kl9878": [
        "0K"
    ],
    "lenovo tb-8705f": [
        "LE"
    ],
    "p10_hd_eea": [
        "T7"
    ],
    "sm-t532": [
        "SA"
    ],
    "sm-t975": [
        "SA"
    ],
    "sm-t517p": [
        "SA"
    ],
    "alfa_10tm": [
        "H0"
    ],
    "wondro 10": [
        "IB"
    ],
    "alfa_10t": [
        "H0"
    ],
    "rct6603w47m7": [
        "RC"
    ],
    "plus_m19_c779": [
        "C8"
    ],
    "sm-t970": [
        "SA"
    ],
    "sm-t505": [
        "SA"
    ],
    "sm-t307u": [
        "SA"
    ],
    "sm-t870": [
        "SA"
    ],
    "sm-t976b": [
        "SA"
    ],
    "alfa10tb": [
        "H0"
    ],
    "lenovo tb-x304x": [
        "LE"
    ],
    "lenovo tb-x705f": [
        "LE"
    ],
    "fire_tab_6": [
        "IW"
    ],
    "winnovo m866": [
        "W5"
    ],
    "winnovo vtab": [
        "W5"
    ],
    "winnovo_750p": [
        "W5"
    ],
    "winnovo_m798": [
        "W5"
    ],
    "winnovo_750k": [
        "W5"
    ],
    "bp_6010": [
        "BP"
    ],
    "twz_tabplay_125": [
        "Z1"
    ],
    "twz tabplay 126": [
        "Z1"
    ],
    "lgt31": [
        "LG"
    ],
    "iball_slide_wings_4gp": [
        "IB"
    ],
    "iball_slide_nimble_4gf": [
        "IB"
    ],
    "iball_slide_iris_drishti_4g": [
        "IB"
    ],
    "iball_slide_imprint_4g": [
        "IB"
    ],
    "itell k4700": [
        "2I",
        "IZ"
    ],
    "itell k3500": [
        "2I",
        "IZ"
    ],
    "via_s30": [
        "R4"
    ],
    "ivorys1": [
        "LV"
    ],
    "ivory": [
        "LV"
    ],
    "kata-t5": [
        "K0"
    ],
    "kata-tmini4": [
        "K0"
    ],
    "c256": [
        "3I"
    ],
    "citi 1509 3g cs1115mg": [
        "D2"
    ],
    "citi 1510 4g cs1116ml": [
        "D2"
    ],
    "citi 1511 3g ct1117pg": [
        "D2"
    ],
    "citi 7905 4g ct7096pl": [
        "D2"
    ],
    "citi 7907 4g cs7098pl": [
        "D2"
    ],
    "treo_tab8g": [
        "GH",
        "PM"
    ],
    "bq-8077l": [
        "BX"
    ],
    "tz722": [
        "I6"
    ],
    "tz72": [
        "I6"
    ],
    "tz22": [
        "I6"
    ],
    "tz55": [
        "I6"
    ],
    "bq-1020l": [
        "BX"
    ],
    "at702": [
        "85"
    ],
    "cw-v99i": [
        "1C"
    ],
    "pluri_b7_tm": [
        "V2"
    ],
    "pluri b7": [
        "V2"
    ],
    "pluri c8": [
        "V2"
    ],
    "pluri c7": [
        "V2"
    ],
    "801lv": [
        "LE"
    ],
    "501lv": [
        "LE"
    ],
    "sct21": [
        "SA"
    ],
    "kob2-l09": [
        "HU"
    ],
    "p20hd_eea": [
        "T7"
    ],
    "artel star": [
        "40"
    ],
    "artel nova": [
        "40"
    ],
    "artel connect": [
        "40"
    ],
    "artel choice": [
        "40"
    ],
    "artel style": [
        "40"
    ],
    "bah3-l09": [
        "HU"
    ],
    "ctab1044hn": [
        "8C"
    ],
    "ctab-1044": [
        "8C"
    ],
    "clempad_2018": [
        "33"
    ],
    "clempad_hr_plus": [
        "33"
    ],
    "clempad_6_xl": [
        "33"
    ],
    "clempad_hr": [
        "33"
    ],
    "clempad_6": [
        "33"
    ],
    "clempad_7_s": [
        "33"
    ],
    "clempad_8": [
        "33"
    ],
    "clempad_2019": [
        "33"
    ],
    "mfc_2018": [
        "33"
    ],
    "mfc_8": [
        "33"
    ],
    "citi_7543_3g_cs7153mg": [
        "D2"
    ],
    "citi 7529 3g cs7141mg": [
        "D2"
    ],
    "citi 7528 4g cs7140ml": [
        "D2"
    ],
    "techpad10qc": [
        "TP"
    ],
    "techpad_10xx": [
        "TP"
    ],
    "techpad703": [
        "TP"
    ],
    "techpad_3gx": [
        "TP"
    ],
    "sgp561": [
        "SO"
    ],
    "lguk410": [
        "LG"
    ],
    "it-ksa0003": [
        "IB"
    ],
    "it-ksa0012": [
        "IB"
    ],
    "it-ksa0066": [
        "IB"
    ],
    "wv8r-m": [
        "LB"
    ],
    "wv8r-n": [
        "LB"
    ],
    "wv8r_n": [
        "LB"
    ],
    "702lv": [
        "LE"
    ],
    "bush10nou": [
        "B1"
    ],
    "alfa_10rc": [
        "H0"
    ],
    "alfa 7rs": [
        "H0"
    ],
    "alfa_7m": [
        "H0"
    ],
    "alfa_7rc": [
        "H0"
    ],
    "alfa_8rc": [
        "H0"
    ],
    "atl-16": [
        "21"
    ],
    "atl-21": [
        "21"
    ],
    "atl-21plus": [
        "21"
    ],
    "atl-21t": [
        "21"
    ],
    "atl-31": [
        "21"
    ],
    "atl-26": [
        "21"
    ],
    "atl-21x": [
        "21"
    ],
    "la tab 107": [
        "LM"
    ],
    "la_tab_74": [
        "LM"
    ],
    "la_tab_114": [
        "LM"
    ],
    "hipower": [
        "PX"
    ],
    "pc-te508baw": [
        "NE"
    ],
    "lavietab pc-ts507n1s": [
        "NE"
    ],
    "lavietab pc-te508s1": [
        "NE"
    ],
    "lenovo tb-8304f1": [
        "LE"
    ],
    "la tab 105": [
        "LM"
    ],
    "contixo k109": [
        "3C"
    ],
    "contixo kt1100gt": [
        "3C"
    ],
    "contixo gt1160 4g": [
        "3C"
    ],
    "gametab-one": [
        "6B"
    ],
    "plum z709": [
        "P4"
    ],
    "plum z712": [
        "P4"
    ],
    "plum z811": [
        "P4"
    ],
    "mixzo mx1021": [
        "1Z"
    ],
    "kyt32": [
        "KY"
    ],
    "kyt31": [
        "KY"
    ],
    "tpa60w": [
        "AC"
    ],
    "n280i": [
        "DX"
    ],
    "tz151": [
        "I6"
    ],
    "geofox_mid743": [
        "G2"
    ],
    "tf-mid806g": [
        "TL"
    ],
    "tf-mid707g": [
        "TL"
    ],
    "tf-mid1007g": [
        "TL"
    ],
    "tf-mid9707g": [
        "TL"
    ],
    "tf-mid708g": [
        "TL"
    ],
    "tf-mid804g": [
        "TL"
    ],
    "tm-mid794c": [
        "T8"
    ],
    "tm-mid795": [
        "T8"
    ],
    "nova_x7_plus_3g": [
        "O1"
    ],
    "mytab_10iii": [
        "MY1"
    ],
    "nt-tp10": [
        "7N"
    ],
    "odys_nova_x7": [
        "O1"
    ],
    "citi 1903 4g cs1062ml": [
        "D2"
    ],
    "neotab s130": [
        "6N"
    ],
    "neotab s120": [
        "6N"
    ],
    "neotab h85": [
        "6N"
    ],
    "neotab-s125": [
        "6N"
    ],
    "neotab-h110": [
        "6N"
    ],
    "neotab h115": [
        "6N"
    ],
    "neotab kid741": [
        "6N"
    ],
    "neotab s9700": [
        "6N"
    ],
    "nx16a10132s": [
        "NT"
    ],
    "nx16a11264": [
        "NT"
    ],
    "nx16a8116k": [
        "NT"
    ],
    "zur70016": [
        "SS"
    ],
    "zur70016w": [
        "SS"
    ],
    "zur700r": [
        "SS"
    ],
    "zur700w": [
        "SS"
    ],
    "zur805a": [
        "SS"
    ],
    "xelio_10_hd": [
        "O1"
    ],
    "xelio10_hd_plus_3g": [
        "O1"
    ],
    "juniort8pro": [
        "O1"
    ],
    "geodroid_a5": [
        "DA"
    ],
    "citi_1508_4g_cs1114ml": [
        "D2"
    ],
    "mixzo_mx1024_4g": [
        "1Z"
    ],
    "ideal 10s": [
        "H0"
    ],
    "ideal tab 7 ips 3g": [
        "H0"
    ],
    "ideal tab 7 ips": [
        "H0"
    ],
    "ideal tab 9": [
        "H0"
    ],
    "iget smart s70": [
        "IG"
    ],
    "iget smart s72": [
        "IG"
    ],
    "kl4889": [
        "0K"
    ],
    "amber_kids": [
        "XV"
    ],
    "proton_amber_hd": [
        "XV"
    ],
    "proton_jade_2_pro": [
        "XV"
    ],
    "6351-q400i": [
        "IB"
    ],
    "citi 1590 3g cs1207mg": [
        "D2"
    ],
    "citi 1593 3g cs1210mg": [
        "D2"
    ],
    "citi 7591 3g cs7208mg": [
        "D2"
    ],
    "citi 8589 3g cs8206mg": [
        "D2"
    ],
    "citi kids cs7216mg": [
        "D2"
    ],
    "citi octa 10 cs1219pl": [
        "D2"
    ],
    "citi octa 70 cs7217pl": [
        "D2"
    ],
    "ona19tb003": [
        "O4"
    ],
    "u1006h": [
        "3A"
    ],
    "r110": [
        "DX"
    ],
    "mixzo_me1023_3g": [
        "1Z"
    ],
    "rct6513w87": [
        "RC"
    ],
    "citi 8531 3g cs8143mg": [
        "D2"
    ],
    "lgt32": [
        "LG"
    ],
    "casper_s38": [
        "R4"
    ],
    "asus tablet p1801-t": [
        "AU"
    ],
    "kob2-w09": [
        "HU"
    ],
    "km0702": [
        "KE"
    ],
    "rct6973w43md": [
        "RC"
    ],
    "rover pad sky 7.85 3g": [
        "R6"
    ],
    "9020a": [
        "AL"
    ],
    "nimbus 101q": [
        "WX"
    ],
    "play_pad_pro_xl": [
        "E0"
    ],
    "sirius 1001": [
        "QO"
    ],
    "sirius890": [
        "QO"
    ],
    "sky 7.85 3g": [
        "R6"
    ],
    "tab10iq3g": [
        "WY"
    ],
    "techno 9.7 3g": [
        "0B"
    ],
    "techno 8.0 3g": [
        "0B"
    ],
    "t7v 3g": [
        "OY"
    ],
    "aurora-ii": [
        "AZ"
    ],
    "tb-x103f": [
        "LE"
    ],
    "navon platinum 10 3g": [
        "N3"
    ],
    "tz85": [
        "I6"
    ],
    "tz13": [
        "I6"
    ],
    "va170": [
        "DX"
    ],
    "tz711": [
        "I6"
    ],
    "pixus_sprint": [
        "PX"
    ],
    "pyro_7_plus_3g": [
        "O1"
    ],
    "b3-a50fhd": [
        "AC"
    ],
    "pixus blaze 10.1 3g": [
        "PX"
    ],
    "pixus play five": [
        "PX"
    ],
    "rp-udm01a": [
        "4V"
    ],
    "rp-udp05a": [
        "4V"
    ],
    "rp-udm02a": [
        "4V"
    ],
    "p902": [
        "PL"
    ],
    "techno-i785ap": [
        "0B"
    ],
    "techno i101bi": [
        "0B"
    ],
    "viva_c701": [
        "A2"
    ],
    "viva_i701g": [
        "A2"
    ],
    "7116-a5": [
        "50"
    ],
    "sp-ng708-3g": [
        "MU"
    ],
    "ts1012e 3g": [
        "D2"
    ],
    "ts7854m": [
        "D2"
    ],
    "tt7020mg": [
        "D2"
    ],
    "tt7024mg": [
        "D2"
    ],
    "tt7026mw": [
        "D2"
    ],
    "uno_x8": [
        "O1"
    ],
    "ginzzu gt-x870": [
        "GZ",
        "SA"
    ],
    "ginzzu gt-x853": [
        "GZ",
        "SA"
    ],
    "itell k3300": [
        "2I",
        "IZ"
    ],
    "mio touchpad 7 quad core": [
        "MO"
    ],
    "magictab 9gx": [
        "5C"
    ],
    "magictab 718": [
        "5C"
    ],
    "magictab 7ge": [
        "5C"
    ],
    "estar grand ips quad core 3g": [
        "6E"
    ],
    "estar go! ips quad core 3g": [
        "6E"
    ],
    "estar go hd quad core 3g": [
        "6E"
    ],
    "estar zoom quad": [
        "6E"
    ],
    "estar grand": [
        "6E"
    ],
    "estar gemini": [
        "6E"
    ],
    "estar go": [
        "6E"
    ],
    "estar_mini_3g": [
        "6E"
    ],
    "estar beauty hd quad core": [
        "6E"
    ],
    "estar go! intel quad core 3g": [
        "6E"
    ],
    "estar go! hd intel quad core 3g": [
        "6E"
    ],
    "estar go! ips intel quad core 3g": [
        "6E"
    ],
    "estar grand hd quad core": [
        "6E"
    ],
    "estar beauty 2 hd quad core": [
        "6E"
    ],
    "estar grand hd quad core 4g": [
        "6E"
    ],
    "estar moon hd quad core 3g": [
        "6E"
    ],
    "9009g": [
        "AL"
    ],
    "wave_i101g": [
        "EH"
    ],
    "mid-823g": [
        "6M"
    ],
    "ergo b700 5.1 v1.0 20170427": [
        "E7"
    ],
    "element 10.1 q001": [
        "S1"
    ],
    "easypad t7c": [
        "EP"
    ],
    "10dtb12": [
        "1H"
    ],
    "+vt107c": [
        "6C"
    ],
    "+vtq007c": [
        "6C"
    ],
    "tab 3g 7-2": [
        "VX"
    ],
    "tab 4g 10-1": [
        "VX"
    ],
    "701hw": [
        "HU"
    ],
    "p380i": [
        "DX"
    ],
    "a5500-h": [
        "LE"
    ],
    "v972 core4": [
        "OD"
    ],
    "slplus02": [
        "BP"
    ],
    "pixus_blast": [
        "PX"
    ],
    "myt6 dtv": [
        "MY"
    ],
    "ags3-l09": [
        "HU"
    ],
    "sencor_7q105": [
        "S1"
    ],
    "numy_3g_sword": [
        "AZ"
    ],
    "numy3g_ax10": [
        "AZ"
    ],
    "kyt33": [
        "KY"
    ],
    "citi 7587 3g cs7204mg": [
        "D2"
    ],
    "tf-mid1005g": [
        "TL"
    ],
    "pixus_joker": [
        "PX"
    ],
    "a2109a": [
        "LE"
    ],
    "a3500-hv": [
        "LE"
    ],
    "touchbook m7 pro": [
        "BU"
    ],
    "lavie tab e 10fhd1": [
        "NE"
    ],
    "express3-max": [
        "13"
    ],
    "ex7sl4": [
        "EF"
    ],
    "ex7s4": [
        "EF"
    ],
    "ex10s4": [
        "EF"
    ],
    "einsteint3": [
        "EY"
    ],
    "citi 1904 4g cs1064ml": [
        "D2"
    ],
    "citi 7900 3g cs7052pg": [
        "D2"
    ],
    "citi 7901 4g cs7065mg": [
        "D2"
    ],
    "citi 7902 3g cs7066mg": [
        "D2"
    ],
    "citi 7906 3g ct7097mg": [
        "D2"
    ],
    "pr6150": [
        "AD"
    ],
    "pr6146": [
        "AD"
    ],
    "pr6145": [
        "AD"
    ],
    "pr6070": [
        "AD"
    ],
    "pr6020": [
        "AD"
    ],
    "pr5950": [
        "AD"
    ],
    "fuego max": [
        "CI"
    ],
    "quad-core a33 y3": [
        "A7"
    ],
    "m-sp10hxxh": [
        "MC"
    ],
    "m-sp10mxha": [
        "MC"
    ],
    "m-sp10mxhl": [
        "MC"
    ],
    "m-sp7hxah": [
        "MC"
    ],
    "m-sp7xgo3g": [
        "MC"
    ],
    "m002d-2": [
        "8N"
    ],
    "m002k-2": [
        "8N"
    ],
    "m002n": [
        "8N"
    ],
    "m002n-3t": [
        "8N"
    ],
    "m002q-2": [
        "8N"
    ],
    "m002w-2t": [
        "8N"
    ],
    "m002g-2": [
        "8N"
    ],
    "6m-3t": [
        "8N"
    ],
    "l-ixir tab 701 3g": [
        "LM"
    ],
    "l-ixir_tab_840": [
        "LM"
    ],
    "l-ement_tab1040_bt": [
        "LM"
    ],
    "l-ement_tab1040": [
        "LM"
    ],
    "l-ement 740": [
        "LM"
    ],
    "lagoon": [
        "EX"
    ],
    "lark ulitmate 7i": [
        "LK"
    ],
    "q9t7in4g": [
        "QI"
    ],
    "q9t10in4g": [
        "QI"
    ],
    "primuxup": [
        "6P"
    ],
    "qtab10ew": [
        "QB"
    ],
    "gorgeo_4gl": [
        "IB"
    ],
    "blaze_v4": [
        "IB"
    ],
    "platinum_10_3g_v2": [
        "N3"
    ],
    "platinumview": [
        "SW"
    ],
    "platinum 10 3g": [
        "N3"
    ],
    "q101-4g": [
        "VY"
    ],
    "predator 3g": [
        "N3"
    ],
    "plt7775g": [
        "P1"
    ],
    "plus-7_c777": [
        "C8"
    ],
    "plus-9_c778": [
        "C8"
    ],
    "viva_h802_lte_tm": [
        "A2"
    ],
    "viva_h802_lte": [
        "A2"
    ],
    "viva_h701_lte": [
        "A2"
    ],
    "viva_h1002_lte": [
        "A2"
    ],
    "onda_mid": [
        "OD"
    ],
    "qualcore 1027 4g": [
        "OV"
    ],
    "tabletexo wave i101h": [
        "EH"
    ],
    "superion s1 dtv": [
        "CH"
    ],
    "sico_e1002": [
        "13"
    ],
    "elt0704h": [
        "Q1"
    ],
    "elt0706h": [
        "Q1"
    ],
    "elt0802h": [
        "Q1"
    ],
    "smailo_2go": [
        "19"
    ],
    "positivo ypy ab7f": [
        "3P"
    ],
    "positivo ypy ab10h": [
        "3P"
    ],
    "gini_tab_v7": [
        "1G"
    ],
    "gini_tab_v8": [
        "1G"
    ],
    "hi9pro": [
        "1C"
    ],
    "casper_s28": [
        "R4"
    ],
    "cellc_evolve": [
        "02"
    ],
    "lavietab pc-te510s1": [
        "NE"
    ],
    "visionbook_10q_lte": [
        "UA"
    ],
    "twinkle_i5": [
        "IB"
    ],
    "hudl 2": [
        "TD"
    ],
    "excer 8": [
        "AH"
    ],
    "1aec": [
        "MC"
    ],
    "mobo_mb7005": [
        "9M"
    ],
    "mt7-411d": [
        "9M"
    ],
    "mobo mt7-421hd": [
        "9M"
    ],
    "d-41a": [
        "SH"
    ],
    "d-01k": [
        "HU"
    ],
    "soundphone s2": [
        "BP"
    ],
    "i8-max": [
        "VY"
    ],
    "platinum_view2": [
        "SW"
    ],
    "pluri_m8": [
        "V2"
    ],
    "mito t8": [
        "8M"
    ],
    "leagoo leapad 10": [
        "L5"
    ],
    "predator 10": [
        "N3"
    ],
    "reeder_3g_tablet": [
        "RD"
    ],
    "reeder a7ic": [
        "RD"
    ],
    "reeder_a8i_quad": [
        "RD"
    ],
    "reeder a7i quad": [
        "RD"
    ],
    "reeder a8i q2": [
        "RD"
    ],
    "reeder m8": [
        "RD"
    ],
    "reeder_m8 plus": [
        "RD"
    ],
    "reeder_m10 plus": [
        "RD"
    ],
    "reeder_t8": [
        "RD"
    ],
    "reeder p11se": [
        "RD"
    ],
    "rct6303w87m": [
        "RC"
    ],
    "rct6k03w13": [
        "RC"
    ],
    "k83ca": [
        "ZT"
    ],
    "koral_8w2": [
        "HN"
    ],
    "agr-l09": [
        "HU"
    ],
    "lenovo tb-x606f": [
        "LE"
    ],
    "lenovo tb-8504x": [
        "LE"
    ],
    "lenovo tb-7104i": [
        "LE"
    ],
    "lenovo tb3-x70l": [
        "LE"
    ],
    "lenovo tb-8703x": [
        "LE"
    ],
    "lenovo tab 2 a10-70l": [
        "LE"
    ],
    "lenovo tb-x606x": [
        "LE"
    ],
    "lenovo tab 2 a7-30hc": [
        "LE"
    ],
    "lenovo tb-8704x": [
        "LE"
    ],
    "lenovo tb-7304x": [
        "LE"
    ],
    "lenovo tb-7504x": [
        "LE"
    ],
    "lenovo tab 2 a7-30gc": [
        "LE"
    ],
    "lenovo tb-7703x": [
        "LE"
    ],
    "lenovo tb-x505x": [
        "LE"
    ],
    "lenovo tb-8505f": [
        "LE"
    ],
    "hi9air": [
        "1C"
    ],
    "lenovo tab 2 a7-30dc": [
        "LE"
    ],
    "lenovo yt-x703l": [
        "LE"
    ],
    "k-book8mg": [
        "KL"
    ],
    "k-book73g": [
        "KL"
    ],
    "t700": [
        "8E"
    ],
    "impulse 10.1 octa": [
        "C7"
    ],
    "inco sphere": [
        "6I"
    ],
    "amazing p6": [
        "TW"
    ],
    "biowolf 8-f30": [
        "BH"
    ],
    "biowolf8f30": [
        "BH"
    ],
    "ruggbo 20 lite": [
        "BH"
    ],
    "dl1023": [
        "DD"
    ],
    "flare tab": [
        "CH"
    ],
    "flare tab pro": [
        "CH"
    ],
    "kt995 3g": [
        "3C"
    ],
    "vision_tab_7": [
        "N3"
    ],
    "vision_tab_10": [
        "N3"
    ],
    "terra_pad_1005": [
        "WR"
    ],
    "freshmintta7": [
        "OM"
    ],
    "freshmintta10": [
        "OM"
    ],
    "730tpc": [
        "IE"
    ],
    "769tpcii": [
        "IE"
    ],
    "930tpc": [
        "IE"
    ],
    "mid4004jbl": [
        "PL"
    ],
    "po10978taq-10213gmk2": [
        "DE"
    ],
    "gravity_octacore": [
        "FS"
    ],
    "gravity max": [
        "FS"
    ],
    "evromedia play pad 3g 2goo": [
        "E0"
    ],
    "hz0010": [
        "HZ"
    ],
    "ilium_pade9": [
        "LA"
    ],
    "ilium_pade7": [
        "LA"
    ],
    "ilium_pade10": [
        "LA"
    ],
    "iliumpad_rx7": [
        "LA"
    ],
    "iliumpad_rx8": [
        "LA"
    ],
    "iliumpad_rx10": [
        "LA"
    ],
    "cosmo_communicator": [
        "9P"
    ],
    "602lv": [
        "LE"
    ],
    "lavie tab e 8fhd1": [
        "NE"
    ],
    "pc-ts708t1w": [
        "NE"
    ],
    "m20_4g": [
        "T7"
    ],
    "m-sp8mxa": [
        "MC"
    ],
    "m-sp8hxah": [
        "MC"
    ],
    "mixzo mx1397 4g": [
        "1Z"
    ],
    "33gt hd": [
        "LB"
    ],
    "dns airtab mf1011": [
        "DN"
    ],
    "blu studio 7.0 ii": [
        "BU"
    ],
    "techpad_10y": [
        "TP"
    ],
    "techpad_9x": [
        "TP"
    ],
    "techpad_i700": [
        "TP"
    ],
    "avid": [
        "IB"
    ],
    "asus tab a8": [
        "AU"
    ],
    "winmax tx30": [
        "9W"
    ],
    "ags2-w19": [
        "HU"
    ],
    "shield tablet k1": [
        "NV"
    ],
    "bnt-71": [
        "2B"
    ],
    "hibook": [
        "1C"
    ],
    "tz791": [
        "I6"
    ],
    "mids145pxe": [
        "PL"
    ],
    "mids747px": [
        "PL"
    ],
    "pc-te510haw": [
        "NE"
    ],
    "f-04h": [
        "FU"
    ],
    "pc-te510bal": [
        "NE"
    ],
    "hipad x": [
        "1C"
    ],
    "micromax p681": [
        "MI"
    ],
    "micromaxp802": [
        "MI"
    ],
    "tb300fu": [
        "LE"
    ],
    "23073rpbfl": [
        "XI"
    ],
    "mobi 7 lte": [
        "WY"
    ],
    "cmg101": [
        "JW"
    ],
    "u1005e": [
        "3A"
    ],
    "m8go2020": [
        "RD"
    ],
    "iplay50 mini": [
        "3A"
    ],
    "np01j": [
        "57"
    ],
    "mid169": [
        "TK"
    ],
    "titaniumgtcolorsgo": [
        "XV"
    ],
    "elite octax": [
        "SW"
    ],
    "kfrapwi": [
        "KN"
    ],
    "ultramintt t10": [
        "OM"
    ],
    "kftuwi": [
        "KN"
    ],
    "puya": [
        "U8"
    ],
    "ipad8,1": [
        "AP"
    ],
    "ipad8,3": [
        "AP"
    ],
    "ipad8,8": [
        "AP"
    ],
    "ipad8,7": [
        "AP"
    ],
    "ipad8,6": [
        "AP"
    ],
    "ipad6,3": [
        "AP"
    ],
    "ipad6,4": [
        "AP"
    ],
    "ipad6,7": [
        "AP"
    ],
    "ipad4,8": [
        "AP"
    ],
    "ipad4,9": [
        "AP"
    ],
    "ipad4,2": [
        "AP"
    ],
    "ipad4,3": [
        "AP"
    ],
    "ipad3,5": [
        "AP"
    ],
    "ipad3,1": [
        "AP"
    ],
    "ipad3,2": [
        "AP"
    ],
    "ipad3,3": [
        "AP",
        "65"
    ],
    "ipad2,5": [
        "AP"
    ],
    "ipad2,7": [
        "AP"
    ],
    "ipad2,3": [
        "AP"
    ],
    "ipad2,4": [
        "AP"
    ],
    "ipad8,2": [
        "AP"
    ],
    "ipad8,4": [
        "AP"
    ],
    "ipad7,12": [
        "AP"
    ],
    "ipad6,8": [
        "AP"
    ],
    "tb371fc": [
        "LE"
    ],
    "sm-x810": [
        "SA"
    ],
    "sm-x716b": [
        "SA"
    ],
    "sm-x216b": [
        "SA"
    ],
    "tb310fu": [
        "LE"
    ],
    "armor pad lite": [
        "UL"
    ],
    "mt-t8b22": [
        "MOX"
    ],
    "teo8m": [
        "TN"
    ],
    "teo10m": [
        "TN"
    ],
    "pixel tablet": [
        "GO"
    ],
    "t tablet": [
        "TM"
    ],
    "nxtepaper-s1": [
        "EYE"
    ],
    "n01pro": [
        "XG"
    ],
    "itel p10001l": [
        "IZ"
    ],
    "zte t1002": [
        "ZT"
    ],
    "qt2108bp": [
        "QI"
    ],
    "pixus_hammer": [
        "PX"
    ],
    "oc101": [
        "HIG"
    ],
    "npad x1": [
        "NON"
    ],
    "ot5": [
        "OE"
    ],
    "rt7 titan": [
        "OE",
        "UZ"
    ],
    "t10m_pro": [
        "JW"
    ],
    "t10e": [
        "DO"
    ],
    "t20s": [
        "DO"
    ],
    "t30ultra": [
        "DO"
    ],
    "t20ultra": [
        "DO"
    ],
    "tab 50 wifi": [
        "B2"
    ],
    "tab r6 ultra": [
        "HV"
    ],
    "tab r7": [
        "HV"
    ],
    "tb331fc": [
        "LE"
    ],
    "tb370fu": [
        "LE"
    ],
    "pa2353": [
        "VV"
    ],
    "hey2-w09": [
        "HNR"
    ],
    "agm_pad_p1": [
        "A3"
    ],
    "tab 8 wifi": [
        "B2"
    ],
    "tab 11 wifi": [
        "B2"
    ],
    "pce-w29": [
        "HU"
    ],
    "pad 70": [
        "OSC"
    ],
    "pad 13": [
        "OSC"
    ],
    "optima 8404d 4g ts8288pl": [
        "D2"
    ],
    "dbr-w19": [
        "HU"
    ],
    "pet 101-h232e": [
        "PE"
    ],
    "t0802l": [
        "NL"
    ],
    "t0801l": [
        "NL"
    ],
    "x8ultra": [
        "DIA"
    ],
    "gemini 4g": [
        "9P"
    ],
    "aupo zeus 10 pro": [
        "AUP"
    ],
    "ccit a100w": [
        "CNT"
    ],
    "ccit a170w": [
        "CNT"
    ],
    "ccit a8w": [
        "CNT"
    ],
    "ccit a160w": [
        "CNT"
    ],
    "ccit a120w": [
        "CNT"
    ],
    "ccit cw200": [
        "CNT"
    ],
    "ccit a9w": [
        "CNT"
    ],
    "ccit a755g": [
        "CNT"
    ],
    "ccit a725g": [
        "CNT"
    ],
    "ccit a708g": [
        "CNT"
    ],
    "ccit a703+": [
        "CNT"
    ],
    "ccita715g": [
        "CNT"
    ],
    "tg3dbg1ma": [
        "UM"
    ],
    "tlg01_eea": [
        "T7"
    ],
    "spirit qs": [
        "V2"
    ],
    "tab 8e": [
        "B2"
    ],
    "creapad_1009": [
        "WW"
    ],
    "tab 12 pro": [
        "B2"
    ],
    "g-10 ultra": [
        "GRL"
    ],
    "tab 13 pro": [
        "B2"
    ],
    "tab 18": [
        "B2"
    ],
    "vanwinv62": [
        "VAW"
    ],
    "vanwin-v62": [
        "VAW"
    ],
    "mi pad4+": [
        "XI"
    ],
    "mi pad4 wi-fi": [
        "XI"
    ],
    "htc a102": [
        "HT"
    ],
    "plt1077g": [
        "P1"
    ],
    "hit 16 hs1002pl": [
        "D2"
    ],
    "tab a802": [
        "1S"
    ],
    "p26t_eea": [
        "T7"
    ],
    "vankyo_s10": [
        "VC"
    ],
    "bravis np 747 sd": [
        "BV"
    ],
    "gt40 ultra": [
        "8L1"
    ],
    "gdi-w09": [
        "HNR"
    ],
    "twintab-t103gq1": [
        "TWN"
    ],
    "m10_eea": [
        "PRI"
    ],
    "tornado 8": [
        "EX"
    ],
    "wo 9": [
        "WAO"
    ],
    "m10-12_eea": [
        "AC"
    ],
    "tab a1020": [
        "LE"
    ],
    "tab_stand_pro": [
        "LM"
    ],
    "cm7800plus": [
        "CIA"
    ],
    "leagoo_leapad7_8": [
        "L5"
    ],
    "flylife connect 10.1 3g 2": [
        "FL"
    ],
    "tab_a1010_neo": [
        "1S"
    ],
    "tab_a1025_x-treme": [
        "1S"
    ],
    "kt200pro": [
        "CNT"
    ],
    "kt300pro": [
        "CNT"
    ],
    "kt600pro": [
        "CNT"
    ],
    "tdt4541_4g_e_ru": [
        "TOP"
    ],
    "armor pad": [
        "UL"
    ],
    "mega 1": [
        "B2"
    ],
    "active 8": [
        "B2"
    ],
    "active 8 pro": [
        "B2"
    ],
    "tab 7 wifi": [
        "B2"
    ],
    "i11_plus_eea": [
        "Y5"
    ],
    "strong tablet p15000 pro": [
        "IH"
    ],
    "optima 8403d 4g ts8287pl": [
        "D2"
    ],
    "hiper-m-pad": [
        "HIP"
    ],
    "htc a100": [
        "HT"
    ],
    "htc a101": [
        "HT",
        "AC"
    ],
    "nomi c10103": [
        "NM"
    ],
    "bliss-t6": [
        "BLI"
    ],
    "piranha8032": [
        "PIR"
    ],
    "p10x": [
        "WAI"
    ],
    "pixus_line": [
        "PX"
    ],
    "t40hd": [
        "T7"
    ],
    "alldocube iplay50_mini_pro": [
        "3A"
    ],
    "tb330xu": [
        "LE"
    ],
    "iplay50_mini_pro": [
        "3A"
    ],
    "redmi pad se": [
        "XI"
    ],
    "bb-mobile techno 7.0 3g": [
        "0B"
    ],
    "gt-w170": [
        "GZ",
        "SA"
    ],
    "iplay50": [
        "3A"
    ],
    "g3_eea": [
        "GOO"
    ],
    "eagle 806": [
        "KE"
    ],
    "t45hd": [
        "T7"
    ],
    "t45hd_eea": [
        "T7"
    ],
    "t40hd_eea": [
        "T7"
    ],
    "p85t_row": [
        "T7"
    ],
    "p30t": [
        "T7"
    ],
    "ztab10": [
        "JW"
    ],
    "btab10": [
        "JW"
    ],
    "f13_eea": [
        "HZ"
    ],
    "m50hd": [
        "T7"
    ],
    "m50hd_eea": [
        "T7"
    ],
    "m50hd_row": [
        "T7"
    ],
    "m50 pro": [
        "T7"
    ],
    "8305c 4g ts8289pl": [
        "D2"
    ],
    "9160g": [
        "TC"
    ],
    "mbk-t2101": [
        "MBK"
    ],
    "space_one_10se": [
        "O1"
    ],
    "tab-8us2": [
        "WHO"
    ],
    "tablet pc 10 pro": [
        "IH"
    ],
    "tpc1013": [
        "LVI"
    ],
    "digma pro hit 104 hs1005pl": [
        "D2"
    ],
    "digma pro hit 14 hs1006pl": [
        "D2"
    ],
    "dt1": [
        "FOS"
    ],
    "dt2": [
        "FOS"
    ],
    "e11": [
        "KHI"
    ],
    "e12": [
        "KHI"
    ],
    "e17": [
        "KHI"
    ],
    "e18": [
        "KHI"
    ],
    "e28": [
        "KHI"
    ],
    "ee10a": [
        "EGS"
    ],
    "h38": [
        "KHI"
    ],
    "h21": [
        "KHI"
    ],
    "h19": [
        "KHI"
    ],
    "h11": [
        "KHI"
    ],
    "digma pro prime 18 ms1003pl": [
        "D2"
    ],
    "digma pro prime 18 ms1002pl": [
        "D2"
    ],
    "digma pro prime 18 ms1001pl": [
        "D2"
    ],
    "citi 1313c 4g cs1273pl": [
        "D2"
    ],
    "npad y1": [
        "NON"
    ],
    "opd2302": [
        "OP"
    ],
    "ot6": [
        "OE"
    ],
    "ot8": [
        "OE"
    ],
    "picassotabx14": [
        "10"
    ],
    "pixus_drive": [
        "PX"
    ],
    "pixus_wing": [
        "PX"
    ],
    "platinumtab11_4g": [
        "Q2"
    ],
    "rmp2204": [
        "RE"
    ],
    "sky pad10max": [
        "SW"
    ],
    "sky_pad10max": [
        "SW"
    ],
    "sky pad8": [
        "SW"
    ],
    "sky pad8pro": [
        "SW"
    ],
    "e38": [
        "KHI"
    ],
    "dt1 lite": [
        "FOS"
    ],
    "gwat10-1": [
        "GA"
    ],
    "k110_eea": [
        "67"
    ],
    "i9_plus_eea": [
        "Y5"
    ],
    "m40plus_eea": [
        "T7"
    ],
    "platinumtab10v22": [
        "Q2"
    ],
    "pad 11": [
        "OSC"
    ],
    "pad 15": [
        "OSC"
    ],
    "pad 18": [
        "OSC"
    ],
    "pad 8": [
        "OSC"
    ],
    "r10": [
        "DO"
    ],
    "r20": [
        "DO"
    ],
    "p85_eea": [
        "T7"
    ],
    "t10plus": [
        "DO"
    ],
    "htc a101 plus": [
        "HT",
        "AC"
    ],
    "logic instrument fieldbook ks80": [
        "LH",
        "1L"
    ],
    "tb330fu": [
        "LE"
    ],
    "tab 70 wifi": [
        "B2"
    ],
    "spider 8": [
        "OSC"
    ],
    "sm-x210": [
        "SA"
    ],
    "tpc-xe10": [
        "JA"
    ],
    "ceptertab10l": [
        "CEP"
    ],
    "clovertek_g12": [
        "CLT"
    ],
    "elite10qhpro": [
        "VIL"
    ],
    "gt40promax": [
        "PAD"
    ],
    "nogapad 10hd": [
        "OG"
    ],
    "kon_tiki3": [
        "3O"
    ],
    "wo 8": [
        "WAO"
    ],
    "venus pad14": [
        "LIB"
    ],
    "24018rpacg": [
        "XI"
    ],
    "inoipad 128+4gb wi-fi+4g": [
        "I4"
    ],
    "inoipad pro": [
        "I4"
    ],
    "tdt3778_wi_e_cis": [
        "TOP"
    ],
    "tdt4528_4g_e_ru": [
        "TOP"
    ],
    "td-tp010g-2": [
        "WSS"
    ],
    "pce-w30": [
        "HU"
    ],
    "pce-w40": [
        "HU"
    ],
    "pa2373": [
        "VV"
    ],
    "ipa2375": [
        "VV"
    ],
    "ezpad m11": [
        "7J",
        "EZ"
    ],
    "y121-eea": [
        "FLY"
    ],
    "darwinx": [
        "3O"
    ],
    "p85t_eea": [
        "T7"
    ],
    "elite t8plus": [
        "SW"
    ],
    "p40s_eea": [
        "T7"
    ],
    "faust6": [
        "3O"
    ],
    "pixus_titan": [
        "PX"
    ],
    "optima 8259c 4g ts8286pl": [
        "D2"
    ],
    "iplay 50 mini pro": [
        "3A"
    ],
    "optima 1442e 4g ts1290pl": [
        "D2"
    ],
    "m40_plus_eea": [
        "T7"
    ],
    "t40s_eea": [
        "T7"
    ],
    "platinumtab8_4g": [
        "Q2"
    ],
    "opd2301": [
        "OP"
    ],
    "livingstone3": [
        "3O"
    ],
    "10a30q": [
        "LG"
    ],
    "p40s_row": [
        "T7"
    ],
    "m40plus_row": [
        "T7"
    ],
    "t10k_plus": [
        "1D"
    ],
    "pa2473": [
        "VV"
    ],
    "t811": [
        "3A"
    ],
    "a410_4g": [
        "AC"
    ],
    "kvadra_t": [
        "KVA"
    ],
    "npads": [
        "NON"
    ],
    "at1011e": [
        "AZE"
    ],
    "eut310a-11a": [
        "AC"
    ],
    "faust5": [
        "3O"
    ],
    "galileo": [
        "3O"
    ],
    "vnt_tab8": [
        "VNP"
    ],
    "bioniqp116": [
        "ARI"
    ],
    "24018rpacc": [
        "XI"
    ],
    "xiaomi pad 6s pro 12.4": [
        "XI"
    ],
    "xiaomi pad 6 pro": [
        "XI"
    ],
    "xiaomi pad 6": [
        "XI"
    ],
    "citi 8269c 3g cs8254pg": [
        "D2"
    ],
    "kt1007_eea": [
        "NER"
    ],
    "wpad3": [
        "HEW"
    ],
    "p26t_row": [
        "T7"
    ],
    "optima 1415d 4g ts1294pl": [
        "D2"
    ],
    "p40hd_t_row": [
        "T7"
    ],
    "tablet fnac 10 3g": [
        "BX"
    ],
    "km1073": [
        "KE"
    ],
    "km1072": [
        "KE"
    ],
    "magnet_g50_pro": [
        "V2"
    ],
    "armor pad 2": [
        "UL"
    ],
    "smart l32": [
        "IG"
    ],
    "q10-eea": [
        "FAC"
    ],
    "m820-eea": [
        "MA2"
    ],
    "a13_eea": [
        "OAN"
    ],
    "i11_plus": [
        "Y5"
    ],
    "optima 1414d 4g ts1289pl": [
        "D2"
    ],
    "optima 1444e 4g ts1291pl": [
        "D2"
    ],
    "optima 7258c 4g ts7226pl": [
        "D2"
    ],
    "8496g": [
        "TC"
    ],
    "9466x": [
        "TC"
    ],
    "8196g": [
        "TC"
    ],
    "ags5-w00": [
        "HU"
    ],
    "pet 1008-f464e": [
        "PE"
    ],
    "digma pro hit 108e hs1004pl": [
        "D2"
    ],
    "kids 1247c ws1251pl": [
        "D2"
    ],
    "kids 8260c ws8253pl": [
        "D2"
    ],
    "kids_8280c_ws8252pl": [
        "D2"
    ],
    "p80t_eea": [
        "T7"
    ],
    "p80t_row": [
        "T7"
    ],
    "p30s_w_eea": [
        "T7"
    ],
    "optima 1304c 4g ts1292pl": [
        "D2"
    ],
    "100071481a": [
        "O4"
    ],
    "y61-eea": [
        "Y9"
    ],
    "iplay50pro": [
        "3A"
    ],
    "glofiish gpad air": [
        "U6"
    ],
    "9.4 fff": [
        "AR"
    ],
    "x900_us": [
        "AOW"
    ],
    "ex10sl4": [
        "BRV"
    ],
    "p11se_art": [
        "RD"
    ],
    "armor pad 3 pro": [
        "UL"
    ],
    "iplay_60_lite": [
        "3A"
    ],
    "qt23109bp": [
        "QI"
    ],
    "qt22101b": [
        "QI"
    ],
    "m50": [
        "AAU"
    ],
    "hit 16 hs1003pl": [
        "D2"
    ],
    "hit 16 hs1001pl": [
        "D2"
    ],
    "hey2-n09": [
        "HNR"
    ],
    "zc-p95": [
        "ROT"
    ],
    "tyd-109": [
        "TYD"
    ],
    "tyd-109_pro": [
        "TYD"
    ],
    "t104_64gb": [
        "UQ"
    ],
    "terra_pad_1200_v2": [
        "WR"
    ],
    "v12e-lte-8128": [
        "VA2"
    ],
    "agm_pad_p2": [
        "A3"
    ],
    "sm-x916c": [
        "SA"
    ],
    "sm-x910": [
        "SA"
    ],
    "sm-x818u": [
        "SA"
    ],
    "sm-x816b": [
        "SA"
    ],
    "sm-x610": [
        "SA"
    ],
    "sm-x216c": [
        "SA"
    ],
    "sm-x115": [
        "SA"
    ],
    "ot5 s": [
        "OE"
    ],
    "sm-x216n": [
        "SA"
    ],
    "t26-eea": [
        "6O"
    ],
    "tdt3887_wi_d_cis": [
        "TOP"
    ],
    "voom tab 2": [
        "I5"
    ],
    "kids708": [
        "DK"
    ],
    "brt81": [
        "NT"
    ],
    "cm8500plus": [
        "CIA"
    ],
    "torex_pad818": [
        "7T"
    ],
    "mupad102": [
        "IMU"
    ],
    "sm-x518u": [
        "SA"
    ],
    "sm-x516b": [
        "SA"
    ],
    "sm-x306b": [
        "SA"
    ],
    "2405crpfdg": [
        "XI"
    ],
    "sm-x218u": [
        "SA"
    ],
    "sm-x110": [
        "SA"
    ],
    "sm-p620": [
        "SA"
    ],
    "tab76": [
        "LM"
    ],
    "hpad1": [
        "HEW"
    ],
    "v-z40": [
        "VIK"
    ],
    "2405cpcfbg": [
        "0P"
    ],
    "yq10s_max": [
        "AT1"
    ],
    "yq10s_gold": [
        "AT1"
    ],
    "zte t1004": [
        "ZT"
    ],
    "tab_918_pro_4g": [
        "MJ"
    ],
    "tb301fu": [
        "LE"
    ],
    "tb02": [
        "RE4"
    ],
    "teox10-mt8sl128lte": [
        "TN"
    ],
    "x700_eea": [
        "AOW"
    ],
    "m10l plus": [
        "BU"
    ],
    "g-10 pro": [
        "GRL"
    ],
    "z-f1010": [
        "EGS"
    ],
    "asusxpad10": [
        "AU"
    ],
    "tk806_eea": [
        "AEE"
    ],
    "100092980a": [
        "O4"
    ],
    "kl638dk_eea": [
        "0K"
    ],
    "mt-1011qr": [
        "TJD"
    ],
    "smartpad_k7_eu": [
        "BYY"
    ],
    "smartpad_t10": [
        "BYY"
    ],
    "smartpad_t10_eu": [
        "BYY"
    ],
    "via s40": [
        "R4"
    ],
    "g-tide_h1": [
        "GT"
    ],
    "dby2-w00": [
        "HU"
    ],
    "tab 12": [
        "B2"
    ],
    "smart l11": [
        "IG"
    ],
    "smart l31": [
        "IG"
    ],
    "smart w32": [
        "IG"
    ],
    "f3a": [
        "HEW"
    ],
    "t40_plus_rus": [
        "T7"
    ],
    "masstel tab 83": [
        "2M"
    ],
    "masstel_tab_82": [
        "2M"
    ],
    "smart tab 4g e-biz pro": [
        "11"
    ],
    "smart tab 4g m1": [
        "11"
    ],
    "smart tab 4g e-biz": [
        "11"
    ],
    "g-20ultra": [
        "GRL"
    ],
    "ev10": [
        "HOG"
    ],
    "f10xipg": [
        "LIN"
    ],
    "eagle_807": [
        "KE"
    ],
    "eagle_1074": [
        "KE"
    ],
    "ags3-w9": [
        "HU"
    ],
    "pad831b": [
        "7T"
    ],
    "venue7 3740 lte": [
        "DL"
    ],
    "archos t101 hd 4g": [
        "AR"
    ],
    "archos t101 fhd wifi": [
        "AR"
    ],
    "kl9878ae": [
        "0K"
    ],
    "ipad14,8": [
        "AP"
    ],
    "ipad14,9": [
        "AP"
    ],
    "ipad14,10": [
        "AP"
    ],
    "ipad14,11": [
        "AP"
    ],
    "ipad16,3": [
        "AP"
    ],
    "ipad16,4": [
        "AP"
    ],
    "ipad16,5": [
        "AP"
    ],
    "ipad16,6": [
        "AP"
    ],
    "ipad14,3": [
        "AP"
    ],
    "ipad14,4": [
        "AP"
    ],
    "ipad14,5": [
        "AP"
    ],
    "ipad14,6": [
        "AP"
    ],
    "got-al19": [
        "HU"
    ],
    "w10_eea": [
        "WOZ"
    ],
    "sm-x806c": [
        "SA"
    ],
    "dby2-l09ck": [
        "HU"
    ],
    "t50hd": [
        "T7"
    ],
    "tb-q706z": [
        "LE"
    ],
    "pixus_folio": [
        "PX"
    ],
    "d118_eea": [
        "67"
    ],
    "at81k": [
        "AT1"
    ],
    "btxs1": [
        "BRV"
    ],
    "g-8 pro": [
        "GRL"
    ],
    "hanson_flex_hs6000": [
        "HA2"
    ],
    "hbook-pro": [
        "ZH"
    ],
    "volta5": [
        "3O"
    ],
    "contixo cx1065 3g": [
        "3C"
    ],
    "tgr-w09": [
        "HU"
    ],
    "tpc-g1011lte": [
        "JA"
    ],
    "mitraveler 958": [
        "TIV"
    ],
    "tae08n10": [
        "ENO"
    ],
    "tabultracpro": [
        "3O"
    ],
    "gocolor7": [
        "3O"
    ],
    "pluri_m8_2020": [
        "V2"
    ],
    "v-z50": [
        "VIK"
    ],
    "8052_ru": [
        "AL"
    ],
    "oysters t82p 3g": [
        "OY"
    ],
    "sb5 hd": [
        "L3"
    ],
    "chronos_10": [
        "NJO"
    ],
    "s-tab1": [
        "ATU"
    ],
    "smartbook s9+": [
        "47"
    ],
    "p16w": [
        "WEE"
    ],
    "digma pro star 14 as8001pl": [
        "D2"
    ],
    "digma pro hit 104 hs1008pl": [
        "D2"
    ],
    "citi 1421d 4g cs1274pl": [
        "D2"
    ],
    "citi 1314c 4g cs1275pl": [
        "D2"
    ],
    "hit 18 hs1012pl": [
        "D2"
    ],
    "hit 18 hs1011pl": [
        "D2"
    ],
    "hit 18 hs1010pl": [
        "D2"
    ],
    "ego1003": [
        "EGO"
    ],
    "eagle_1076": [
        "KE"
    ],
    "dbr-w10": [
        "HU"
    ],
    "zb30": [
        "ZZB"
    ],
    "ceptertab101": [
        "CEP"
    ],
    "net_r7": [
        "K2"
    ],
    "sm-x516n": [
        "SA"
    ],
    "tab 60 kids": [
        "B2"
    ],
    "tab 50 kids": [
        "B2"
    ],
    "t60": [
        "T7"
    ],
    "t50pro_w_eea": [
        "T7"
    ],
    "t50": [
        "T7"
    ],
    "t20mini kid": [
        "DO"
    ],
    "rt8": [
        "OE"
    ],
    "rmp2205": [
        "RE"
    ],
    "d3_eea": [
        "DMO"
    ],
    "iplay_60": [
        "3A"
    ],
    "kant2": [
        "3O"
    ],
    "opd2304": [
        "ON"
    ],
    "iplay50_lite": [
        "3A"
    ],
    "u310-eea": [
        "YUM"
    ],
    "ihunt strong tablet x pro": [
        "IH"
    ],
    "kingpad z10_eea": [
        "VA"
    ],
    "sky_pad8pro": [
        "SW"
    ],
    "quartzlite": [
        "8U"
    ],
    "v tab 2": [
        "V6"
    ],
    "alfa_10bt_v2": [
        "H0"
    ],
    "it_701a": [
        "ATM"
    ],
    "k113_eea": [
        "67"
    ],
    "k118": [
        "ZW"
    ],
    "xt2261-1": [
        "MR"
    ],
    "f35w_eea": [
        "CWO"
    ],
    "c82w_eea": [
        "CWO"
    ],
    "f21w": [
        "WEE"
    ],
    "smart_w31": [
        "IG"
    ],
    "t28-eea": [
        "6O"
    ],
    "t13_eea": [
        "YES"
    ],
    "i9_plus": [
        "Y5"
    ],
    "lavie tab 9qhd1": [
        "NE"
    ],
    "m821-eea": [
        "MA2"
    ],
    "m820": [
        "MA2"
    ],
    "mes-b1": [
        "MES"
    ],
    "mt11": [
        "UM"
    ],
    "mt10": [
        "UM"
    ],
    "mt07": [
        "UM"
    ],
    "m-t4": [
        "ATU"
    ],
    "m-t3": [
        "ATU"
    ],
    "s-tab10": [
        "ATU"
    ],
    "inoipad 64gb wi-fi+3g": [
        "I4"
    ],
    "a15_eea": [
        "OAN"
    ],
    "k10c": [
        "COL"
    ],
    "ex8s1": [
        "EF"
    ],
    "opd2403": [
        "ON"
    ],
    "opd2303": [
        "OP"
    ],
    "7_premium_pro": [
        "H0"
    ],
    "iplay60_mini_pro": [
        "3A"
    ],
    "via l40": [
        "R4"
    ],
    "ags6-w09": [
        "HU"
    ],
    "ags6-l09": [
        "HU"
    ],
    "ags3-al09": [
        "HU"
    ],
    "y88x__plus": [
        "DJ"
    ],
    "quartzpro": [
        "8U"
    ],
    "magicdrawingpad": [
        "XPP"
    ],
    "slate 10 hd": [
        "HP"
    ],
    "slate 21 pro": [
        "HP"
    ],
    "ns220r": [
        "HJ"
    ],
    "ns220": [
        "HJ"
    ],
    "lifetabplus": [
        "FPS"
    ],
    "lifetab e1091x": [
        "MD"
    ],
    "bach-w09": [
        "HU"
    ],
    "tb360zu": [
        "LE"
    ],
    "tb301xu": [
        "LE"
    ],
    "tab1000": [
        "HEM"
    ],
    "24075rp89g": [
        "XI"
    ],
    "24074rpd2g": [
        "XI"
    ],
    "ex7x4": [
        "EF"
    ],
    "rod2-w09": [
        "HNR"
    ],
    "leopad_10": [
        "ADR"
    ],
    "leopad 10x": [
        "ADR"
    ],
    "leopad_10s": [
        "ADR"
    ],
    "npadq": [
        "NON"
    ],
    "su15 pro": [
        "8L1"
    ],
    "t20mini pro": [
        "DO"
    ],
    "infinix x1101b": [
        "IF"
    ],
    "i9_plus_row": [
        "Y5"
    ],
    "ipa2475": [
        "VV"
    ],
    "24076rp19g": [
        "XI"
    ],
    "24074rpd2i": [
        "XI"
    ],
    "azimut_4": [
        "MC"
    ],
    "tmrv5gtb": [
        "TM"
    ],
    "ultrapad": [
        "8U"
    ],
    "kenshi_k10": [
        "KHI"
    ],
    "wo pad max": [
        "WAO"
    ],
    "sm-x926b": [
        "SA"
    ],
    "wo 7": [
        "WAO"
    ],
    "venus pad16": [
        "LIB"
    ],
    "venus pad15": [
        "LIB"
    ],
    "tg 30": [
        "TM1"
    ],
    "tg15": [
        "TM1"
    ],
    "l16 max": [
        "LIB"
    ],
    "ndl-w09": [
        "HNR"
    ],
    "tb375fc": [
        "LE"
    ],
    "tab 16 pro": [
        "B2"
    ],
    "hi10_xpro_pad": [
        "1C"
    ],
    "b22_eea": [
        "BIE"
    ],
    "v10e-lte-464": [
        "VA2"
    ],
    "mes-b3": [
        "MES"
    ],
    "m10_c01_eea": [
        "PRI"
    ],
    "gravity_4": [
        "FS"
    ],
    "advance a7": [
        "BU"
    ],
    "spacetab_h20_eea": [
        "HAQ"
    ],
    "ndl-l09": [
        "HNR"
    ],
    "9199s": [
        "TC"
    ],
    "lifetab_p1075x": [
        "MD"
    ],
    "g10_us": [
        "GOO"
    ],
    "a130-2024": [
        "ACP"
    ],
    "pad 80 wifi": [
        "OSC"
    ],
    "pad 70 wifi": [
        "OSC"
    ],
    "tab 10 wifi": [
        "B2"
    ],
    "mt16": [
        "UM"
    ],
    "tab r5": [
        "HV"
    ],
    "kst103sd-l": [
        "KIS"
    ],
    "sm-x710": [
        "SA"
    ],
    "sm-x820": [
        "SA"
    ],
    "sm-x826b": [
        "SA"
    ],
    "p25t_row": [
        "T7"
    ],
    "tb-x306x": [
        "LE"
    ],
    "tb-x306f": [
        "LE"
    ],
    "qtab y2": [
        "QM"
    ],
    "98 (m1e3)": [
        "T7"
    ],
    "tpc1013_eea": [
        "LVI"
    ],
    "okapi_tab8_pro": [
        "OKA"
    ],
    "la_tab_link_74": [
        "LM"
    ],
    "gk133m3": [
        "GH"
    ],
    "elite t10 pro": [
        "SW"
    ],
    "tab a11 pro": [
        "UL"
    ],
    "ot11": [
        "OE"
    ],
    "p101-eea": [
        "6O"
    ],
    "noteair4c": [
        "3O"
    ],
    "wo pad pro": [
        "WAO"
    ],
    "wo 10": [
        "WAO"
    ],
    "wo 12": [
        "WAO"
    ],
    "t181-eea": [
        "6O"
    ],
    "itel p10003l": [
        "IZ"
    ],
    "hoco_hi10": [
        "HOC"
    ],
    "tb-x606x": [
        "LE"
    ],
    "tb-x606f": [
        "LE"
    ],
    "tb-x505x": [
        "LE"
    ],
    "tb-x505l": [
        "LE"
    ],
    "neocore_e1r1": [
        "NEO"
    ],
    "digma pro hit 106 hs1007pl": [
        "D2"
    ],
    "digma pro hit 104 hs1009pl": [
        "D2"
    ],
    "redmi pad se 8.7 4g": [
        "XI"
    ],
    "ag_1088_a133p": [
        "SOW"
    ],
    "armor pad pro": [
        "UL"
    ],
    "symtab20": [
        "SM"
    ],
    "tb351fu": [
        "LE"
    ],
    "tb321fu": [
        "LE"
    ],
    "mro-w09": [
        "HU"
    ],
    "tecno t1101": [
        "TB"
    ],
    "sm-p555m": [
        "SA"
    ],
    "rt9": [
        "OE"
    ],
    "rt3 pro": [
        "OE"
    ],
    "q8 da6b8p01": [
        "D2"
    ],
    "pulse ta3e0p01": [
        "D2"
    ],
    "pulse ta3d0p01": [
        "D2"
    ],
    "pulse ta2d0p01": [
        "D2"
    ],
    "spark ta1c8m01": [
        "D2"
    ],
    "spectrum ta2d0p02": [
        "D2"
    ],
    "tb3-710f": [
        "LE"
    ],
    "n101b": [
        "COG"
    ],
    "ft1000": [
        "F0N"
    ],
    "ft800": [
        "F0N"
    ],
    "ftb13": [
        "XV"
    ],
    "yq10sk": [
        "AT1"
    ],
    "infinity ta3e0m01": [
        "D2"
    ],
    "infinity ta2d0m01": [
        "D2"
    ],
    "hoco_hi12": [
        "HOC"
    ],
    "np03j": [
        "57"
    ],
    "sm-t113n": [
        "SA"
    ],
    "sm-p607t": [
        "SA"
    ],
    "ocean k8 pro": [
        "OLA"
    ],
    "mt06": [
        "UM"
    ],
    "n02": [
        "XG"
    ],
    "hanson_flex_7000": [
        "HA2"
    ],
    "touch 7": [
        "PRI"
    ],
    "j10_eea": [
        "JUS"
    ],
    "bky-w09": [
        "HU"
    ],
    "24091rpadc": [
        "XI"
    ],
    "smartpad_a10_l": [
        "BYY"
    ],
    "smartpad_a10_eu": [
        "BYY"
    ],
    "alfa10tx_pro": [
        "H0"
    ],
    "tmnt": [
        "5T"
    ],
    "smart_w84": [
        "IG"
    ],
    "tab-10us": [
        "WHO"
    ],
    "tbx11": [
        "AND"
    ],
    "lguk932": [
        "LG"
    ],
    "edge ta3e1m01": [
        "D2"
    ],
    "edge ta2d1m01": [
        "D2"
    ],
    "navo_p": [
        "V2"
    ],
    "sm-x215": [
        "SA"
    ],
    "mega 8": [
        "B2"
    ],
    "mega 2": [
        "B2"
    ],
    "2410crp4cg": [
        "XI"
    ],
    "2410crp4cc": [
        "XI"
    ],
    "24091rpadg": [
        "XI"
    ],
    "zoom ta3d0p02": [
        "D2"
    ],
    "zenith ta3e1p01": [
        "D2"
    ],
    "zenith ta3d1p01": [
        "D2"
    ],
    "via l50": [
        "R4"
    ],
    "tab r9 pro": [
        "HV"
    ],
    "tab r8": [
        "HV"
    ],
    "p50case": [
        "T7"
    ],
    "24076rp19i": [
        "XI"
    ],
    "2405crpfdl": [
        "XI"
    ],
    "xbook_12": [
        "HM1"
    ],
    "wo pad 13": [
        "WAO"
    ],
    "wo 9 ultra": [
        "WAO"
    ],
    "wo 8 ultra": [
        "WAO"
    ],
    "tgr-w00": [
        "HU"
    ],
    "tab r5 pro": [
        "HV"
    ],
    "alfa 11 bt": [
        "H0"
    ],
    "m8_4g": [
        "1R"
    ],
    "em103a": [
        "APS"
    ],
    "buv7tblt10a": [
        "V7T"
    ],
    "m50s": [
        "T7"
    ],
    "m50-row": [
        "T7"
    ],
    "m50_row": [
        "T7"
    ],
    "m50plus": [
        "T7"
    ],
    "m50mini": [
        "T7"
    ],
    "lunnen ground 11": [
        "LNN"
    ],
    "lunnen ground 10.4": [
        "LNN"
    ],
    "infinix x1101": [
        "IF"
    ],
    "infinity ta3d0m01": [
        "D2"
    ],
    "iplay60 mini turbo": [
        "3A"
    ],
    "h44": [
        "KHI"
    ],
    "h34": [
        "KHI"
    ],
    "h24": [
        "KHI"
    ],
    "h14": [
        "KHI"
    ],
    "gtx_jaculus_01": [
        "GTX"
    ],
    "e10": [
        "KHI"
    ],
    "c3_pro": [
        "COL"
    ],
    "c10s": [
        "QIW"
    ],
    "armor pad 4 ultra": [
        "UL"
    ],
    "agm_pad_t1": [
        "A3"
    ],
    "agm_pad_p2w": [
        "A3"
    ],
    "xyao-w00": [
        "HU"
    ],
    "rol-w00": [
        "HNR"
    ],
    "tab 60 pro": [
        "B2"
    ],
    "web-w09": [
        "HU"
    ],
    "web-w00": [
        "HU"
    ],
    "wgrr-w19": [
        "HU"
    ],
    "z168_eea": [
        "ZIO"
    ],
    "xb-t11i": [
        "XBI"
    ],
    "tb311fu": [
        "LE"
    ],
    "tab a5 kids": [
        "B2"
    ],
    "tab 9 wifi": [
        "B2"
    ],
    "tab 90 wifi": [
        "B2"
    ],
    "tab 90": [
        "B2"
    ],
    "tab_868_pro": [
        "TIB"
    ],
    "tab011": [
        "NON"
    ],
    "pixus_deon": [
        "PX"
    ],
    "pad lite e58": [
        "KHI"
    ],
    "active 10 pro": [
        "B2"
    ],
    "ipa2453": [
        "VV"
    ],
    "ipa2451": [
        "VV"
    ],
    "lecoo p116g": [
        "LE"
    ],
    "m10_r02": [
        "PRI"
    ],
    "dc-8015": [
        "EVE"
    ],
    "sm-x620": [
        "SA"
    ],
    "sm-x526b": [
        "SA"
    ],
    "pad 100": [
        "OSC"
    ],
    "vitumi 10.1": [
        "VTM"
    ],
    "g1000 pro": [
        "GVL"
    ],
    "g1000": [
        "GVL"
    ],
    "g2000": [
        "GVL"
    ],
    "p50_t_row": [
        "T7"
    ],
    "p50_t_eea": [
        "T7"
    ],
    "p50_b": [
        "T7"
    ],
    "p50ai_row": [
        "T7"
    ],
    "t60ai_row": [
        "T7"
    ],
    "opd2409": [
        "OP"
    ],
    "opd2404": [
        "ON"
    ],
    "opd2401": [
        "OP"
    ],
    "l10-t11-eea": [
        "VAS"
    ],
    "l10-t11": [
        "VAS"
    ],
    "tb373fu": [
        "LE"
    ],
    "tb311xu": [
        "LE"
    ],
    "i10_plus": [
        "Y5"
    ],
    "novus tab": [
        "ZU"
    ],
    "it-801b": [
        "ATM"
    ],
    "globalsec tab ten": [
        "GL2"
    ],
    "vtab7": [
        "FV",
        "VT"
    ],
    "2505drp06g": [
        "XI"
    ],
    "zoom ta3e0p02": [
        "D2"
    ],
    "zenith ta2d1p01": [
        "D2"
    ],
    "tl65611s01": [
        "LNN"
    ],
    "tl4648s01": [
        "LNN"
    ],
    "impad 6414": [
        "I3"
    ],
    "eln2-l29": [
        "HNR"
    ],
    "25040rp0ag": [
        "XI"
    ],
    "t70_row": [
        "T7"
    ],
    "t50max_row": [
        "T7"
    ],
    "t50max_eea": [
        "T7"
    ],
    "t50hd_row": [
        "T7"
    ],
    "t50hd_eea": [
        "T7"
    ],
    "t30 max": [
        "DO"
    ],
    "t1201": [
        "3A"
    ],
    "t10pro": [
        "DO"
    ],
    "sm-x516c": [
        "SA"
    ],
    "sm-x218b": [
        "SA"
    ],
    "sm-t636b": [
        "SA"
    ],
    "sirius plus tab 10": [
        "69"
    ],
    "quantum ta2d5p01": [
        "D2"
    ],
    "pad pro e111": [
        "KHI"
    ],
    "pad pro e110": [
        "KHI"
    ],
    "p50_row": [
        "T7"
    ],
    "p50_eea": [
        "T7"
    ],
    "optima 8430e 4g da1c8p01": [
        "D2"
    ],
    "ob-p10": [
        "UZ"
    ],
    "ob-p08": [
        "UZ"
    ],
    "l10_t08_eea": [
        "VAS"
    ],
    "k10 da1c0p01": [
        "D2"
    ],
    "jaculus v2": [
        "GTX"
    ],
    "iplay60_pro": [
        "3A"
    ],
    "hoco_hi11": [
        "HOC"
    ],
    "acd-tab-10s": [
        "ACD"
    ],
    "u10 kid": [
        "DO"
    ],
    "u320": [
        "YUM"
    ],
    "prime 18 ms1003pl": [
        "D2"
    ],
    "prime 18 ms1002pl": [
        "D2"
    ],
    "prime 18 ms1001pl": [
        "D2"
    ],
    "pad6 plus": [
        "YIK"
    ],
    "ot6 kids": [
        "OE"
    ],
    "eln2-w29": [
        "HNR"
    ],
    "25040rp0ae": [
        "XI"
    ],
    "a10-21_eea": [
        "AC"
    ],
    "bigtech_b_ru": [
        "6B"
    ],
    "active 12 pro": [
        "B2"
    ],
    "t60plus_row": [
        "T7"
    ],
    "t60plus_eea": [
        "T7"
    ],
    "t65max_row": [
        "T7"
    ],
    "t65max_eea": [
        "T7"
    ],
    "t50mini_row": [
        "T7"
    ],
    "rol-w60": [
        "HNR",
        "HU"
    ],
    "rod2-w69": [
        "HNR",
        "HU"
    ],
    "m10_r04": [
        "PRI"
    ],
    "edge ta3d1m01": [
        "D2"
    ],
    "eclipse ta3e1p02": [
        "D2"
    ],
    "empire ta3e2m01": [
        "D2"
    ],
    "agm pad t3": [
        "A3"
    ],
    "bve-w10": [
        "HU"
    ],
    "readboy_c26pro": [
        "RB"
    ],
    "funpad-8max": [
        "1F"
    ],
    "btkr-w09": [
        "HU"
    ],
    "ags5-al00": [
        "HU"
    ],
    "torex831b": [
        "7T"
    ],
    "tk_e720_eea": [
        "GRA"
    ],
    "techpad_832": [
        "TP"
    ],
    "sm-x520": [
        "SA"
    ],
    "sm-x626b": [
        "SA"
    ],
    "sm-x510": [
        "SA"
    ],
    "sm-x730": [
        "SA"
    ],
    "sm-x920": [
        "SA"
    ],
    "sm-x300": [
        "SA"
    ],
    "rod-w19": [
        "HNR",
        "HU"
    ],
    "viewpad 7d pro": [
        "VS"
    ],
    "ipad13,18": [
        "AP"
    ],
    "ipad13,19": [
        "AP"
    ],
    "wave taxx5p0x": [
        "D2"
    ],
    "pixel tablet 2": [
        "GO"
    ],
    "25099rp13g": [
        "XI"
    ],
    "2509brp2dg": [
        "XI"
    ],
    "2410crp4ci": [
        "XI"
    ],
    "tab kingkong 2": [
        "CB"
    ],
    "tab r9 plus": [
        "HV"
    ],
    "dmoao_d2_eea": [
        "DMO"
    ],
    "pixus_arena": [
        "PX"
    ],
    "tgr-w10": [
        "HU"
    ],
    "alfa 8tx": [
        "H0"
    ],
    "hey3-w00": [
        "HNR",
        "HU"
    ],
    "hey3-n09": [
        "HNR",
        "HU"
    ],
    "bpad_mini_se": [
        "BNC"
    ],
    "lomonosov3": [
        "3O"
    ],
    "jdn-al00": [
        "HU"
    ],
    "ags2-al00hn": [
        "HU"
    ],
    "jdn2-w09hn": [
        "HU"
    ],
    "hdn-w09": [
        "HU"
    ],
    "hdn-l09": [
        "HU"
    ],
    "hdl-al09": [
        "HU"
    ],
    "hdl-w09": [
        "HU"
    ],
    "bah3-al00": [
        "HU"
    ],
    "mon-w19": [
        "HU"
    ],
    "mon-al19": [
        "HU"
    ],
    "mrx-al09": [
        "HU"
    ],
    "mrx-w09": [
        "HU"
    ],
    "huawei mediapad": [
        "HU"
    ],
    "mediapad 10 fhd": [
        "HU"
    ],
    "mediapad 10 link": [
        "HU"
    ],
    "mediapad 7 lite": [
        "HU"
    ],
    "mediapad 7 vogue": [
        "HU"
    ],
    "mediapad 7 youth": [
        "HU"
    ],
    "bzt-al00": [
        "HU"
    ],
    "bzt-al10": [
        "HU"
    ],
    "huawei m2-801l": [
        "HU"
    ],
    "btv-dl09": [
        "HU"
    ],
    "btv-w09": [
        "HU"
    ],
    "bah-w09": [
        "HU"
    ],
    "cpn-w09": [
        "HU"
    ],
    "cpn-l09": [
        "HU"
    ],
    "cpn-al00": [
        "HU"
    ],
    "bah-al00": [
        "HU"
    ],
    "bah-l09": [
        "HU"
    ],
    "bah3-w09": [
        "HU"
    ],
    "cmr-al19": [
        "HU"
    ],
    "cmr-al09": [
        "HU"
    ],
    "cmr-w09": [
        "HU"
    ],
    "sht-al09": [
        "HU"
    ],
    "sht-w09": [
        "HU"
    ],
    "bah2-al00": [
        "HU"
    ],
    "bah2-al10": [
        "HU"
    ],
    "bah2-w19": [
        "HU"
    ],
    "bah2-l09": [
        "HU"
    ],
    "jdn2-l09": [
        "HU"
    ],
    "jdn2-al00": [
        "HU"
    ],
    "jdn2-al50": [
        "HU"
    ],
    "jdn2-w09": [
        "HU"
    ],
    "cmr-w19": [
        "HU"
    ],
    "scm-w09": [
        "HU"
    ],
    "vrd-al09": [
        "HU"
    ],
    "vrd-al10": [
        "HU"
    ],
    "vrd-w09": [
        "HU"
    ],
    "vrd-w10": [
        "HU"
    ],
    "t1-a21w": [
        "HU"
    ],
    "t1-a21l": [
        "HU"
    ],
    "t1-a23l": [
        "HU"
    ],
    "t1-701u": [
        "HU"
    ],
    "mediapad t1 8.0": [
        "HU"
    ],
    "t1-821w": [
        "HU"
    ],
    "t1-823l": [
        "HU"
    ],
    "fdr-a01l": [
        "HU"
    ],
    "fdr-a01w": [
        "HU"
    ],
    "fdr-a03l": [
        "HU"
    ],
    "605hw": [
        "HU"
    ],
    "bgo-l03": [
        "HU"
    ],
    "ple-703l": [
        "HU"
    ],
    "ple-701l": [
        "HU"
    ],
    "bgo-dl09": [
        "HU"
    ],
    "jdn-l01": [
        "HU"
    ],
    "ags-l09": [
        "HU"
    ],
    "ags-l03": [
        "HU"
    ],
    "ags-w09": [
        "HU"
    ],
    "bg2-u03": [
        "HU"
    ],
    "bg2-u01": [
        "HU"
    ],
    "bzk-w00": [
        "HU"
    ],
    "kob-l09": [
        "HU"
    ],
    "kob-w09": [
        "HU"
    ],
    "bzk-l00": [
        "HU"
    ],
    "ags2-l09": [
        "HU"
    ],
    "ags2-w09": [
        "HU"
    ],
    "ags2-l03": [
        "HU"
    ],
    "gem-701l": [
        "HU"
    ],
    "gem-703l": [
        "HU"
    ],
    "gem-702l": [
        "HU"
    ],
    "hwt31": [
        "HU"
    ],
    "1001-g go": [
        "HW"
    ],
    "705-g go": [
        "HW"
    ],
    "ht-705xs": [
        "HW"
    ],
    "hoozo mt pad 116 lte": [
        "HZ"
    ],
    "hoozo mt116": [
        "HZ"
    ],
    "hoozo mt232": [
        "HZ"
    ],
    "hoozo_x1001": [
        "HZ"
    ],
    "nt-3702m": [
        "I2"
    ],
    "nt-3703m": [
        "I2"
    ],
    "nt-3601p/3602p": [
        "I2"
    ],
    "nt-3603p": [
        "I2"
    ],
    "nt-3805c": [
        "I2"
    ],
    "nt-0805c": [
        "I2"
    ],
    "nt-3701s": [
        "I2"
    ],
    "nt-3702s": [
        "I2"
    ],
    "nt-0704s": [
        "I2"
    ],
    "nt-0701s": [
        "I2"
    ],
    "nt-0902s": [
        "I2"
    ],
    "nt-1017t": [
        "I2"
    ],
    "nt-0909t": [
        "I2"
    ],
    "nt-1001t": [
        "I2"
    ],
    "nt-1011t": [
        "I2"
    ],
    "nt-1009t": [
        "I2"
    ],
    "nt-3905t": [
        "I2"
    ],
    "impad0113": [
        "I3"
    ],
    "impad0314": [
        "I3"
    ],
    "impad_0413": [
        "I3"
    ],
    "impad 1002": [
        "I3"
    ],
    "impad1005": [
        "I3"
    ],
    "impad 1006v2": [
        "I3"
    ],
    "impad 1113": [
        "I3"
    ],
    "impad1311": [
        "I3"
    ],
    "impad 1412": [
        "I3"
    ],
    "impad 1412 rev2": [
        "I3"
    ],
    "impad 2113": [
        "I3"
    ],
    "impad 2412": [
        "I3"
    ],
    "impad_2413": [
        "I3"
    ],
    "impad 3113": [
        "I3"
    ],
    "impad 3412": [
        "I3"
    ],
    "impad4113": [
        "I3"
    ],
    "impad 6015": [
        "I3"
    ],
    "impad6115": [
        "I3"
    ],
    "impad 6115m": [
        "I3"
    ],
    "impad6214": [
        "I3"
    ],
    "impad 8213": [
        "I3"
    ],
    "impad 8901": [
        "I3"
    ],
    "impad 9213": [
        "I3"
    ],
    "impad 9702": [
        "I3"
    ],
    "impad 9704": [
        "I3"
    ],
    "impression impad b702": [
        "I3"
    ],
    "impad_p104": [
        "I3"
    ],
    "irbis tz01": [
        "I6"
    ],
    "irbis tz02": [
        "I6"
    ],
    "tz100": [
        "I6"
    ],
    "tz104": [
        "I6"
    ],
    "tz142": [
        "I6"
    ],
    "tz150": [
        "I6"
    ],
    "tz165": [
        "I6"
    ],
    "tz170": [
        "I6"
    ],
    "tz171": [
        "I6"
    ],
    "tz173": [
        "I6"
    ],
    "tz174": [
        "I6"
    ],
    "tz175": [
        "I6"
    ],
    "tz176": [
        "I6"
    ],
    "tz177": [
        "I6"
    ],
    "tz178": [
        "I6"
    ],
    "tz179": [
        "I6"
    ],
    "tz183": [
        "I6"
    ],
    "tz184": [
        "I6"
    ],
    "tz185": [
        "I6"
    ],
    "tz186": [
        "I6"
    ],
    "tz191": [
        "I6"
    ],
    "tz192": [
        "I6"
    ],
    "tz195": [
        "I6"
    ],
    "tz197": [
        "I6"
    ],
    "tz198": [
        "I6"
    ],
    "tz49": [
        "I6"
    ],
    "irbis tz56": [
        "I6"
    ],
    "tz712": [
        "I6"
    ],
    "tz714": [
        "I6"
    ],
    "tz716": [
        "I6"
    ],
    "tz717": [
        "I6"
    ],
    "tz720": [
        "I6"
    ],
    "tz721": [
        "I6"
    ],
    "tz725": [
        "I6"
    ],
    "tz726": [
        "I6"
    ],
    "tz727": [
        "I6"
    ],
    "tz737": [
        "I6"
    ],
    "tz742": [
        "I6"
    ],
    "tz745": [
        "I6"
    ],
    "tz747": [
        "I6"
    ],
    "tz752": [
        "I6"
    ],
    "tz753": [
        "I6"
    ],
    "tz754": [
        "I6"
    ],
    "tz757": [
        "I6"
    ],
    "tz761": [
        "I6"
    ],
    "tz762": [
        "I6"
    ],
    "tz771": [
        "I6"
    ],
    "tz772": [
        "I6"
    ],
    "tz777": [
        "I6"
    ],
    "tz781": [
        "I6"
    ],
    "tz794": [
        "I6"
    ],
    "tz797": [
        "I6"
    ],
    "tz81l": [
        "I6"
    ],
    "tz831": [
        "I6"
    ],
    "tz841": [
        "I6"
    ],
    "tz853": [
        "I6"
    ],
    "tz854": [
        "I6"
    ],
    "tz855": [
        "I6"
    ],
    "tz856": [
        "I6"
    ],
    "tz857": [
        "I6"
    ],
    "tz858": [
        "I6"
    ],
    "tz864": [
        "I6"
    ],
    "tz865": [
        "I6"
    ],
    "tz872": [
        "I6"
    ],
    "tz874": [
        "I6"
    ],
    "tz877": [
        "I6"
    ],
    "tz878": [
        "I6"
    ],
    "tz881": [
        "I6"
    ],
    "tz882": [
        "I6"
    ],
    "tz884": [
        "I6"
    ],
    "tz885": [
        "I6"
    ],
    "tz890": [
        "I6"
    ],
    "tz891": [
        "I6"
    ],
    "tz892": [
        "I6"
    ],
    "tz897": [
        "I6"
    ],
    "irbis tz93": [
        "I6"
    ],
    "tz960": [
        "I6"
    ],
    "tz961": [
        "I6"
    ],
    "tz962": [
        "I6"
    ],
    "tz963": [
        "I6"
    ],
    "tz964": [
        "I6"
    ],
    "tz965": [
        "I6"
    ],
    "tz967": [
        "I6"
    ],
    "tz968": [
        "I6"
    ],
    "tz969": [
        "I6"
    ],
    "tzart": [
        "I6"
    ],
    "tzhit": [
        "I6"
    ],
    "tzone": [
        "I6"
    ],
    "mi7_hero_beta": [
        "I9"
    ],
    "mi7_hero_tab": [
        "I9"
    ],
    "iball slide 3g7271": [
        "IB"
    ],
    "snap_4g2": [
        "IB"
    ],
    "733tpc": [
        "IE"
    ],
    "smart_g101": [
        "IG"
    ],
    "smart_g102": [
        "IG"
    ],
    "smart_g71": [
        "IG"
    ],
    "smart_g81": [
        "IG"
    ],
    "smart_g81h": [
        "IG"
    ],
    "deox": [
        "IJ"
    ],
    "neon7": [
        "IJ"
    ],
    "neon9": [
        "IJ"
    ],
    "sygnus": [
        "IJ"
    ],
    "imo tab x9": [
        "IL"
    ],
    "imo y5": [
        "IL"
    ],
    "imo z6": [
        "IL"
    ],
    "imo z7": [
        "IL"
    ],
    "i-mobile i-note 2": [
        "IO"
    ],
    "i-mobile i-note 3": [
        "IO"
    ],
    "i-mobile i-note wifi 9": [
        "IO"
    ],
    "irola dx752": [
        "IR"
    ],
    "dx758": [
        "IR"
    ],
    "dx758pro": [
        "IR"
    ],
    "ns-p10a7100": [
        "IS"
    ],
    "ns-p10a8100": [
        "IS"
    ],
    "ns-p11a8100": [
        "IS"
    ],
    "ns-p08a7100": [
        "IS"
    ],
    "ns-p16at10": [
        "IS"
    ],
    "ns-p10a6100": [
        "IS"
    ],
    "ns-p16at08": [
        "IS"
    ],
    "ns-p16at785hd": [
        "IS"
    ],
    "irulu_v3": [
        "IU"
    ],
    "irulu_v4": [
        "IU"
    ],
    "irulu x11": [
        "IU"
    ],
    "auxus corex4 3g": [
        "IY"
    ],
    "tpc-101": [
        "JA"
    ],
    "tpc-pa7807": [
        "JA"
    ],
    "tpc-x10f1": [
        "JA"
    ],
    "tpcy-txe10d": [
        "JA"
    ],
    "tpcy-txe10ds": [
        "JA"
    ],
    "tpcy-txe10dw": [
        "JA"
    ],
    "tpcy-txe10dw232": [
        "JA"
    ],
    "tpcy-txe7d": [
        "JA"
    ],
    "tpcy-txe7dw)": [
        "JA"
    ],
    "tpcy-txte10d": [
        "JA"
    ],
    "tpcy-txte7d)": [
        "JA"
    ],
    "cavion base 10": [
        "CJ"
    ],
    "cavion_10_3grq": [
        "CJ"
    ],
    "cavion base 7 dual": [
        "CJ"
    ],
    "core 10.1 dual 3g": [
        "K1"
    ],
    "kiano elegance by zanetti": [
        "K1"
    ],
    "kiano elegance 8 3g": [
        "K1"
    ],
    "intelect103g": [
        "K1"
    ],
    "kianointelect73g": [
        "K1"
    ],
    "slimtab10_3gr": [
        "K1"
    ],
    "slimtab7_3gr": [
        "K1"
    ],
    "kiano slim tab 8": [
        "K1"
    ],
    "slim tab 8 3g": [
        "K1"
    ],
    "slimtab8_3gr": [
        "K1"
    ],
    "kj-ob03": [
        "K6"
    ],
    "kj-yubi": [
        "K6"
    ],
    "kaicloud 744": [
        "K7"
    ],
    "kaicloud 784": [
        "K7"
    ],
    "kaicloud 942": [
        "K7"
    ],
    "m1050s": [
        "KC"
    ],
    "m1060w": [
        "KC"
    ],
    "m1061": [
        "KC"
    ],
    "m1062": [
        "KC"
    ],
    "m1063w": [
        "KC"
    ],
    "m1066": [
        "KC"
    ],
    "m1068": [
        "KC"
    ],
    "m1070": [
        "KC"
    ],
    "m729": [
        "KC"
    ],
    "m730w": [
        "KC"
    ],
    "m750": [
        "KC"
    ],
    "m752": [
        "KC"
    ],
    "m752h": [
        "KC"
    ],
    "m756": [
        "KC"
    ],
    "m760": [
        "KC"
    ],
    "m762b": [
        "KC"
    ],
    "m766": [
        "KC"
    ],
    "m776h": [
        "KC"
    ],
    "m836": [
        "KC"
    ],
    "m870": [
        "KC"
    ],
    "kocaso-m9100": [
        "KC"
    ],
    "mx736-kit": [
        "KC"
    ],
    "mx780": [
        "KC"
    ],
    "km1065g": [
        "KE"
    ],
    "km1066": [
        "KE"
    ],
    "km1067": [
        "KE"
    ],
    "km0701_1": [
        "KE"
    ],
    "km0805_1": [
        "KE"
    ],
    "kodak tablet 10": [
        "KK"
    ],
    "kodak tablet 7": [
        "KK"
    ],
    "kffowi": [
        "KN"
    ],
    "kfmuwi": [
        "KN"
    ],
    "kftbwi": [
        "KN"
    ],
    "kfsuwi": [
        "KN"
    ],
    "kfarwi": [
        "KN"
    ],
    "kfaswi": [
        "KN"
    ],
    "kfmewi": [
        "KN"
    ],
    "kfgiwi": [
        "KN"
    ],
    "kfdowi": [
        "KN"
    ],
    "kfonwi": [
        "KN"
    ],
    "kfsawi": [
        "KN"
    ],
    "kfsawa": [
        "KN"
    ],
    "silk/1.0.22.153_10033210": [
        "KN"
    ],
    "amazon kindle fire": [
        "KN"
    ],
    "kftt": [
        "KN"
    ],
    "amazon tate": [
        "KN"
    ],
    "kfjwa": [
        "KN"
    ],
    "kfjwi": [
        "KN"
    ],
    "amazon jem": [
        "KN"
    ],
    "kfapwi": [
        "KN"
    ],
    "a811": [
        "L3"
    ],
    "leapad 7s": [
        "L5"
    ],
    "ilium pad e8": [
        "LA"
    ],
    "a2107a-h": [
        "LE"
    ],
    "lenovo tb-x104f": [
        "LE"
    ],
    "lenovo tb-x104l": [
        "LE"
    ],
    "lenovo tb-x104x": [
        "LE"
    ],
    "ideapada10": [
        "LE"
    ],
    "ideapad k1": [
        "LE"
    ],
    "lenovo a7600-h": [
        "LE"
    ],
    "lenovo a7600-f": [
        "LE"
    ],
    "ideataba2109a": [
        "LE"
    ],
    "lenovo a3000-h": [
        "LE"
    ],
    "lenovo a3500-fl": [
        "LE"
    ],
    "lenovo a3500-hv": [
        "LE"
    ],
    "lenovo a3500-f": [
        "LE"
    ],
    "lenovo a3500-h": [
        "LE"
    ],
    "lenovo a5500-h": [
        "LE"
    ],
    "lenovo a5500-f": [
        "LE"
    ],
    "ideatabs2109a-f": [
        "LE"
    ],
    "lenovo s5000-f": [
        "LE"
    ],
    "lenovo s5000-h": [
        "LE"
    ],
    "ideatab s6000-h": [
        "LE"
    ],
    "lenovo s6000l-f": [
        "LE"
    ],
    "s6000": [
        "LE"
    ],
    "lenovo tb-x505f": [
        "LE"
    ],
    "tb-x704a": [
        "LE"
    ],
    "lenovo tb2-x30f": [
        "LE"
    ],
    "lenovo tb2-x30l": [
        "LE"
    ],
    "tb2-x30l": [
        "LE"
    ],
    "tab2a7-10f": [
        "LE"
    ],
    "lenovoa3300-gv": [
        "LE"
    ],
    "lenovoa3300-h": [
        "LE"
    ],
    "lenovo tab 2 a7-30d": [
        "LE"
    ],
    "lenovo tab 2 a8-50l": [
        "LE"
    ],
    "tb-x304f": [
        "LE"
    ],
    "lenovo tb-x704f": [
        "LE"
    ],
    "tb-8504f": [
        "LE"
    ],
    "lenovo tb-x605f": [
        "LE"
    ],
    "lenovo tab s8-50l": [
        "LE"
    ],
    "tab 2 a8-50lc": [
        "LE"
    ],
    "lenovo tb3-730x": [
        "LE"
    ],
    "lenovo tb3-710f": [
        "LE"
    ],
    "lenovo tb3-710i": [
        "LE"
    ],
    "tb3-710i": [
        "LE"
    ],
    "lenovo tb3-850m": [
        "LE"
    ],
    "601lv": [
        "LE"
    ],
    "lenovo tb-x304l": [
        "LE"
    ],
    "tb-x704v": [
        "LE"
    ],
    "701lv": [
        "LE"
    ],
    "lenovo tb-x704l": [
        "LE"
    ],
    "thinkpadtablet": [
        "LE"
    ],
    "thinkpad tablet": [
        "LE"
    ],
    "lenovo yt3-x90x": [
        "LE"
    ],
    "lenovo yt3-x90l": [
        "LE"
    ],
    "lenovo yt3-x90f": [
        "LE"
    ],
    "lenovo yt3-x50f": [
        "LE"
    ],
    "lenovo yt3-x50l": [
        "LE"
    ],
    "yt3-x50m": [
        "LE"
    ],
    "lenovo yt3-850m": [
        "LE"
    ],
    "lenovo yt3-850f": [
        "LE"
    ],
    "lenovo yt3-850l": [
        "LE"
    ],
    "lenovo b8000-f": [
        "LE"
    ],
    "lenovo b8000-h": [
        "LE"
    ],
    "yoga tablet 2-1050f": [
        "LE"
    ],
    "yoga tablet 2-1050l": [
        "LE"
    ],
    "yoga tablet 2-830l": [
        "LE"
    ],
    "yoga tablet 2-830f": [
        "LE"
    ],
    "yoga tablet 2-830lc": [
        "LE"
    ],
    "yoga tablet 2 pro-1380l": [
        "LE"
    ],
    "yoga tablet 2 pro-1380f": [
        "LE"
    ],
    "lenovo b6000-f": [
        "LE"
    ],
    "lg-v700": [
        "LG"
    ],
    "lg-v490": [
        "LG"
    ],
    "lg-v500": [
        "LG"
    ],
    "vk810 4g": [
        "LG"
    ],
    "lg-v935": [
        "LG"
    ],
    "lg-v521": [
        "LG"
    ],
    "vk815": [
        "LG"
    ],
    "lg-v905r": [
        "LG"
    ],
    "lark evolution 10": [
        "LK"
    ],
    "lark evolution x2 7 3g-gps": [
        "LK"
    ],
    "lark_evolution_x4_10.1": [
        "LK"
    ],
    "evolution x4 7 ips": [
        "LK"
    ],
    "lark freeme x2 7": [
        "LK"
    ],
    "lark freeme x2 7 ver.2": [
        "LK"
    ],
    "lark freeme x2 7 ver.3": [
        "LK"
    ],
    "lark freeme x2 8": [
        "LK"
    ],
    "lark freeme x2 9": [
        "LK"
    ],
    "freeme x2 9 v.2": [
        "LK"
    ],
    "freeme x2 9 ver.3": [
        "LK"
    ],
    "(lark freeme x4 7 3g hd": [
        "LK"
    ],
    "freeme x4 9": [
        "LK"
    ],
    "phablet 7": [
        "LK"
    ],
    "ultimate 7i": [
        "LK"
    ],
    "ultimate x4 10.1 3g ips": [
        "LK"
    ],
    "ultimate x4 8s 3g": [
        "LK"
    ],
    "b bot 550": [
        "LM"
    ],
    "e1031": [
        "LM"
    ],
    "e731": [
        "LM"
    ],
    "e812": [
        "LM"
    ],
    "e912": [
        "LM"
    ],
    "id bot 53+": [
        "LM"
    ],
    "idbot553": [
        "LM"
    ],
    "idbot553plus": [
        "LM"
    ],
    "l-ement 741": [
        "LM"
    ],
    "lement_tab901": [
        "LM"
    ],
    "l-ite 502 plus": [
        "LM"
    ],
    "lixir1041": [
        "LM"
    ],
    "kt712a_4.4": [
        "LM"
    ],
    "la tab 72": [
        "LM"
    ],
    "logicom_la_tab_link_71": [
        "LM"
    ],
    "m bot 551": [
        "LM"
    ],
    "m bot 60": [
        "LM"
    ],
    "m_bot_tab_1150": [
        "LM"
    ],
    "m_bot_tab_71": [
        "LM"
    ],
    "power bot": [
        "LM"
    ],
    "tab1062": [
        "LM"
    ],
    "tab950": [
        "LM"
    ],
    "lenco cartab-920": [
        "LN"
    ],
    "lenco cartab-925": [
        "LN"
    ],
    "lenco cooltab-70": [
        "LN"
    ],
    "lenco cooltab-72": [
        "LN"
    ],
    "lenco cooltab-80": [
        "LN"
    ],
    "lenco kidztab-70": [
        "LN"
    ],
    "lenco tab-1014": [
        "LN"
    ],
    "lenco tab-1030": [
        "LN"
    ],
    "lenco tab-704": [
        "LN"
    ],
    "cavion7.1quad": [
        "CJ"
    ],
    "cavion base 7.2 quad": [
        "CJ"
    ],
    "cavion_base_7_3g_silver": [
        "CJ"
    ],
    "cavion base 7 quad": [
        "CJ"
    ],
    "samsung sm-t225": [
        "SA"
    ],
    "9009a": [
        "AL"
    ],
    "lenovo tb-x104f1": [
        "LE"
    ],
    "papyre_pad_7.1": [
        "PAP"
    ],
    "communicator_9.7_3g": [
        "INN"
    ],
    "bpm9727": [
        "BLI"
    ],
    "clicktabdsh18": [
        "ENV"
    ],
    "dt0704k08": [
        "DEN"
    ],
    "drn-809": [
        "DRE"
    ],
    "drn-709": [
        "DRE"
    ],
    "digicom_a10_lte": [
        "DIC"
    ],
    "pioneer computers dreambook": [
        "PIC",
        "PI"
    ],
    "redway_7": [
        "REW"
    ],
    "lenco tab-712": [
        "LN"
    ],
    "lenco tab-813": [
        "LN"
    ],
    "lenco tab-900": [
        "LN"
    ],
    "lenco tab-925": [
        "LN"
    ],
    "lenco tab-9720": [
        "LN"
    ],
    "lepanii": [
        "LP"
    ],
    "le pan tc802a": [
        "LP"
    ],
    "le pan s": [
        "LP"
    ],
    "tc970 (wi-fi)": [
        "LP"
    ],
    "iq1019n": [
        "LS"
    ],
    "iq9610": [
        "LS",
        "FL"
    ],
    "iqm960": [
        "LS"
    ],
    "iqm801": [
        "LS"
    ],
    "iq1010": [
        "LS"
    ],
    "iq1010w": [
        "LS"
    ],
    "iq1025": [
        "LS",
        "FL"
    ],
    "iq1012": [
        "LS",
        "FL"
    ],
    "iq1012n": [
        "LS"
    ],
    "iq181011n": [
        "LS"
    ],
    "iq1805n": [
        "LS"
    ],
    "iq1808": [
        "LS",
        "FL"
    ],
    "iq1810b_m": [
        "LS"
    ],
    "iq1832": [
        "LS",
        "FL"
    ],
    "iqm1001": [
        "LS"
    ],
    "iq9013_4n": [
        "LS"
    ],
    "iqs1001": [
        "LS"
    ],
    "supernova i3g96": [
        "LT"
    ],
    "supernova i3g96x": [
        "LT"
    ],
    "supernova qi16": [
        "LT"
    ],
    "mfc190bbfr": [
        "LX"
    ],
    "mfc195fufr": [
        "LX"
    ],
    "mfc140fr1": [
        "LX"
    ],
    "mfc141fr": [
        "LX"
    ],
    "mfc162fr": [
        "LX"
    ],
    "mfc180fr": [
        "LX"
    ],
    "mfc181fr": [
        "LX"
    ],
    "mfc195dcfr": [
        "LX"
    ],
    "mfc195dpfr": [
        "LX"
    ],
    "mfc250fr": [
        "LX"
    ],
    "mfc280fr": [
        "LX"
    ],
    "mfc270fr": [
        "LX"
    ],
    "mfc142fr": [
        "LX"
    ],
    "mfc155fr": [
        "LX"
    ],
    "mfc157fr": [
        "LX"
    ],
    "mfc163fr": [
        "LX"
    ],
    "mfc156fr": [
        "LX"
    ],
    "mfc170fr": [
        "LX"
    ],
    "mfc175fr": [
        "LX"
    ],
    "mfc375fr": [
        "LX"
    ],
    "mfc500fr": [
        "LX"
    ],
    "mfc045fr": [
        "LX"
    ],
    "x1010": [
        "M3"
    ],
    "101p51c": [
        "M3"
    ],
    "800p31c": [
        "M3"
    ],
    "m785": [
        "M3"
    ],
    "freetab": [
        "M4"
    ],
    "freetab 7001 hd ic": [
        "M4"
    ],
    "freetab 8001 ips x2 3g+": [
        "M4"
    ],
    "freeway tab 7.0": [
        "M4"
    ],
    "midm-8803": [
        "M7"
    ],
    "cozy": [
        "M8"
    ],
    "easy tab 9": [
        "M8"
    ],
    "mtc 1078": [
        "M9"
    ],
    "mid1001": [
        "MA"
    ],
    "mid1009": [
        "MA"
    ],
    "mid1010": [
        "MA"
    ],
    "mid704": [
        "MA"
    ],
    "mid705": [
        "MA"
    ],
    "mid706a": [
        "MA"
    ],
    "mid713": [
        "MA"
    ],
    "mid901": [
        "MA"
    ],
    "mid9701": [
        "MA"
    ],
    "m-sp1ago3g": [
        "MC"
    ],
    "m-mp10pa": [
        "MC"
    ],
    "m-mp10pa3g": [
        "MC"
    ],
    "m-mp1040m": [
        "MC"
    ],
    "m-mp1040mc": [
        "MC"
    ],
    "m-mp1040s2": [
        "MC"
    ],
    "m-mp1041s2": [
        "MC"
    ],
    "m-mp1051s2": [
        "MC"
    ],
    "m-mp1s2a3g": [
        "MC"
    ],
    "m-mp10s4": [
        "MC"
    ],
    "m-mp12s4": [
        "MC"
    ],
    "m-mp1s4b3g": [
        "MC"
    ],
    "m-mp1s4a3g": [
        "MC"
    ],
    "m-mp101s2": [
        "MC"
    ],
    "m-mp1010i": [
        "MC"
    ],
    "m-mp102s2w": [
        "MC"
    ],
    "m-mp102s2b": [
        "MC"
    ],
    "m-mp720go": [
        "MC"
    ],
    "m-mp740gox": [
        "MC"
    ],
    "m-mp726gox": [
        "MC"
    ],
    "m-mp722i": [
        "MC"
    ],
    "smartpad7503g": [
        "MC"
    ],
    "m-ipro110b": [
        "MC"
    ],
    "m-ipro800b": [
        "MC"
    ],
    "m-ipro810b": [
        "MC"
    ],
    "m-ipro810w": [
        "MC"
    ],
    "m-mp8pa3g": [
        "MC"
    ],
    "m-mp842m": [
        "MC"
    ],
    "m-mp840m": [
        "MC"
    ],
    "m-mp876s2": [
        "MC"
    ],
    "m-mp8s2a3g": [
        "MC"
    ],
    "m-mp8s23g": [
        "MC"
    ],
    "m-mp8s2b3g": [
        "MC"
    ],
    "m-mp82s4": [
        "MC"
    ],
    "m-mp84s4": [
        "MC"
    ],
    "m-mp8s4a3g": [
        "MC"
    ],
    "m-mp8s4b3g": [
        "MC"
    ],
    "m-mp860s2": [
        "MC"
    ],
    "m-mp875s2": [
        "MC"
    ],
    "m-mp85s23g": [
        "MC"
    ],
    "m-mp940m": [
        "MC"
    ],
    "m-mp9s4a3g": [
        "MC"
    ],
    "smartpad970s2": [
        "MC"
    ],
    "smartpad970s23g": [
        "MC"
    ],
    "m-sp10mxa": [
        "MC"
    ],
    "e1041x": [
        "MD"
    ],
    "e1051x": [
        "MD"
    ],
    "lifetab_e10310": [
        "MD"
    ],
    "lifetab_e10312": [
        "MD"
    ],
    "lifetab_e10316": [
        "MD"
    ],
    "lifetab_e10320": [
        "MD"
    ],
    "lifetab_e7310": [
        "MD"
    ],
    "lifetab_e7312": [
        "MD"
    ],
    "lifetab_e7316": [
        "MD"
    ],
    "p1035x": [
        "MD"
    ],
    "p850x": [
        "MD"
    ],
    "p851x": [
        "MD"
    ],
    "lifetab_p9514": [
        "MD"
    ],
    "md_lifetab_p9516": [
        "MD"
    ],
    "s1035x": [
        "MD"
    ],
    "lifetab_s9512": [
        "MD"
    ],
    "lifetab_s9714": [
        "MD"
    ],
    "x1030x": [
        "MD"
    ],
    "p70221": [
        "MI"
    ],
    "micromax p280": [
        "MI"
    ],
    "majestic tab 371": [
        "MJ"
    ],
    "tab 411 3g": [
        "MJ"
    ],
    "tab 647 3g": [
        "MJ"
    ],
    "mid102c": [
        "MM"
    ],
    "mid103c": [
        "MM"
    ],
    "mid104c": [
        "MM"
    ],
    "mid114c": [
        "MM"
    ],
    "mid43c": [
        "MM"
    ],
    "mid701": [
        "MM",
        "MA"
    ],
    "mid74c": [
        "MM"
    ],
    "mid77c": [
        "MM"
    ],
    "mid7c": [
        "MM"
    ],
    "mid801": [
        "MM",
        "MA"
    ],
    "mid82c": [
        "MM"
    ],
    "mid84c": [
        "MM"
    ],
    "mp100i octa": [
        "MM"
    ],
    "mp1010": [
        "MM"
    ],
    "mp7007": [
        "MM"
    ],
    "mp717": [
        "MM"
    ],
    "mp843": [
        "MM"
    ],
    "mp888": [
        "MM"
    ],
    "mp959": [
        "MM"
    ],
    "mp969": [
        "MM"
    ],
    "mpdc100 bt": [
        "MM"
    ],
    "mpdc110 bt ips": [
        "MM"
    ],
    "mpdc112 bt ips": [
        "MM"
    ],
    "mpdc8 bt": [
        "MM"
    ],
    "mpdc88 bt ips": [
        "MM"
    ],
    "mpdc903": [
        "MM"
    ],
    "mpqc1030": [
        "MM"
    ],
    "mpqc30i": [
        "MM"
    ],
    "mpqc704 hd": [
        "MM"
    ],
    "mpqc730": [
        "MM"
    ],
    "mpqc784 ips": [
        "MM"
    ],
    "mpqc804hd": [
        "MM"
    ],
    "megafon login 3": [
        "MP"
    ],
    "mflogin3t": [
        "MP"
    ],
    "m.t.t. tablet": [
        "MQ"
    ],
    "mz601": [
        "MR"
    ],
    "mz604": [
        "MR"
    ],
    "mz617": [
        "MR"
    ],
    "xoom": [
        "MR"
    ],
    "xoom 2": [
        "MR"
    ],
    "xoom 2 me": [
        "MR"
    ],
    "xoom wifi": [
        "MR"
    ],
    "slidepad": [
        "MU",
        "WI"
    ],
    "slidepad 104": [
        "MU",
        "WI"
    ],
    "slidepad 108": [
        "MU",
        "WI"
    ],
    "sp704c": [
        "MU"
    ],
    "sp704ce": [
        "MU"
    ],
    "slidepad704ce": [
        "MU",
        "WI"
    ],
    "slidepad 816p": [
        "MU",
        "WI"
    ],
    "slidepad elite 9708": [
        "MU",
        "WI"
    ],
    "slidepad kids": [
        "MU",
        "WI"
    ],
    "slidepad ng 116dc": [
        "MU",
        "WI"
    ],
    "slidepad ng 704dc": [
        "MU",
        "WI"
    ],
    "spng708": [
        "MU"
    ],
    "spng808": [
        "MU"
    ],
    "spng9708": [
        "MU"
    ],
    "spng9716dc": [
        "MU"
    ],
    "mypad 1000 hd": [
        "MY"
    ],
    "mypad 2": [
        "MY"
    ],
    "mypad 750hd": [
        "MY"
    ],
    "mytab10ii": [
        "MY1"
    ],
    "mytab_10_q": [
        "MY1"
    ],
    "enjoy 7 plus": [
        "MZ"
    ],
    "primo76": [
        "MZ"
    ],
    "primo 91": [
        "MZ"
    ],
    "mtn-8978p": [
        "N4"
    ],
    "pc-te508haw": [
        "NE"
    ],
    "c07000": [
        "NM"
    ],
    "c07002": [
        "NM"
    ],
    "c07002hd": [
        "NM"
    ],
    "c07003": [
        "NM"
    ],
    "c07005": [
        "NM"
    ],
    "c07008": [
        "NM"
    ],
    "c07850": [
        "NM"
    ],
    "c10100": [
        "NM"
    ],
    "c10101": [
        "NM"
    ],
    "c10102": [
        "NM"
    ],
    "c10103": [
        "NM"
    ],
    "c101010 ultra2": [
        "NM"
    ],
    "nx785qc8g": [
        "NT"
    ],
    "nxm900mc": [
        "NT"
    ],
    "nxa8qc116": [
        "NT"
    ],
    "next10p12": [
        "NT"
    ],
    "next7p12-8g": [
        "NT"
    ],
    "next800k": [
        "NT"
    ],
    "next8p12": [
        "NT"
    ],
    "next9p": [
        "NT"
    ],
    "nx010hi8g": [
        "NT"
    ],
    "nxm726": [
        "NT"
    ],
    "nx008hd8g": [
        "NT"
    ],
    "nxm908hc": [
        "NT"
    ],
    "tegra note 7": [
        "NV"
    ],
    "tegranote-p1640": [
        "NV"
    ],
    "aeon": [
        "O1"
    ],
    "connect7pro": [
        "O1"
    ],
    "connect8plus": [
        "O1"
    ],
    "element10_plus_3g": [
        "O1"
    ],
    "eos10": [
        "O1"
    ],
    "falcon_10_plus_3g": [
        "O1"
    ],
    "fusion": [
        "O1"
    ],
    "ieos_quad_10_pro": [
        "O1"
    ],
    "junior_8_pro": [
        "O1"
    ],
    "maven10_hd": [
        "O1"
    ],
    "maven_10_plus": [
        "O1"
    ],
    "maven_10_pro": [
        "O1"
    ],
    "maven10_pro_plus_3g": [
        "O1"
    ],
    "maven_x10_hd": [
        "O1"
    ],
    "maven_x10_hd_lte": [
        "O1"
    ],
    "adm816hc": [
        "O1"
    ],
    "noon": [
        "O1"
    ],
    "odys-noon": [
        "O1"
    ],
    "rapid_10_lte": [
        "O1"
    ],
    "rapid7lte": [
        "O1"
    ],
    "space10_plus_3g": [
        "O1"
    ],
    "space10_pro_3g": [
        "O1"
    ],
    "tao_x10": [
        "O1"
    ],
    "thanos_10": [
        "O1"
    ],
    "thor10": [
        "O1"
    ],
    "thor_10": [
        "O1"
    ],
    "thor_10_plus_3g": [
        "O1"
    ],
    "thor10_plus_3g": [
        "O1"
    ],
    "adm8000kp": [
        "O1"
    ],
    "xelio10_plus_3g": [
        "O1"
    ],
    "xelio10extreme": [
        "O1"
    ],
    "xelio_a10": [
        "O1"
    ],
    "xelio_next_10_plus_3g": [
        "O1"
    ],
    "xeliophonetab3": [
        "O1"
    ],
    "ona19tb002": [
        "O4"
    ],
    "ona19tb007": [
        "O4"
    ],
    "oyyut11": [
        "O6"
    ],
    "onda mid": [
        "OD"
    ],
    "obook10 se": [
        "OD"
    ],
    "t2101l2b1c": [
        "OD"
    ],
    "obook 20 plus dualos": [
        "OD"
    ],
    "obook 20 se": [
        "OD"
    ],
    "v10 4g": [
        "OD",
        "WCP"
    ],
    "v820w-dualos": [
        "OD"
    ],
    "v891-dualos": [
        "OD"
    ],
    "v891w dualos": [
        "OD"
    ],
    "v919 3g air dualos": [
        "OD"
    ],
    "v919 4g air core8": [
        "OD"
    ],
    "v919 air ch dualos": [
        "OD"
    ],
    "v919 air dualos": [
        "OD"
    ],
    "v989 air core8": [
        "OD"
    ],
    "funtab 8": [
        "OR"
    ],
    "orange sego": [
        "OR"
    ],
    "ov-basictab": [
        "OV"
    ],
    "ov-quattor10": [
        "OV"
    ],
    "ov-steelcore10+ii": [
        "OV"
    ],
    "ov-tb-07b": [
        "OV"
    ],
    "ov-tb-08 ii": [
        "OV"
    ],
    "qualcore 1010": [
        "OV"
    ],
    "ov10273g": [
        "OV"
    ],
    "ov10274g": [
        "OV"
    ],
    "at101-1116": [
        "OX"
    ],
    "t102er3g": [
        "OY"
    ],
    "t102ms_3g": [
        "OY"
    ],
    "t104b_3g": [
        "OY"
    ],
    "t104b_4g": [
        "OY"
    ],
    "t104er4g": [
        "OY"
    ],
    "oysters t104hvi 3g": [
        "OY"
    ],
    "t104mbi_3g": [
        "OY"
    ],
    "t104sci_3g": [
        "OY"
    ],
    "oysters t14n 3g": [
        "OY"
    ],
    "oysters t3 3g": [
        "OY"
    ],
    "t72ha_3g": [
        "OY"
    ],
    "t72hm3g": [
        "OY"
    ],
    "t72hms_3g": [
        "OY"
    ],
    "t74d_3g": [
        "OY"
    ],
    "t74hmi_4g": [
        "OY"
    ],
    "t74mai_3g": [
        "OY"
    ],
    "t74mr4g": [
        "OY"
    ],
    "t74n_3g": [
        "OY"
    ],
    "t74sc_3g": [
        "OY"
    ],
    "oysters t7x 3g": [
        "OY"
    ],
    "t84bi_4g": [
        "OY"
    ],
    "t84eri_3g": [
        "OY"
    ],
    "t84ni_3g": [
        "OY"
    ],
    "t84ni_4g": [
        "OY"
    ],
    "plt7035-c": [
        "P1"
    ],
    "plt7044k-b": [
        "P1"
    ],
    "plt7602g": [
        "P1"
    ],
    "plt7802": [
        "P1"
    ],
    "polytron t7800": [
        "P5"
    ],
    "polytron_t7700": [
        "P5"
    ],
    "h10882m-tn": [
        "P6"
    ],
    "pocketbook surfpad 3 (10,1)": [
        "P8"
    ],
    "pd-3127": [
        "P9"
    ],
    "pd-3127nc": [
        "P9"
    ],
    "p-08d": [
        "PA"
    ],
    "fz-b2d": [
        "PA"
    ],
    "pcb-t103 curi lite": [
        "PB"
    ],
    "pcb-t715": [
        "PB"
    ],
    "quadra 7 ultraslim": [
        "PG"
    ],
    "pentagramtab7.6": [
        "PG"
    ],
    "pi3210g": [
        "PH"
    ],
    "tle722g": [
        "PH"
    ],
    "tle821l": [
        "PH"
    ],
    "dvr700pi": [
        "PI"
    ],
    "r1": [
        "PI"
    ],
    "mid0714pge02.133": [
        "PL"
    ],
    "mid0714pce01": [
        "PL"
    ],
    "mid0714": [
        "PL"
    ],
    "mid1014": [
        "PL"
    ],
    "midc010pr001": [
        "PL"
    ],
    "midc110": [
        "PL"
    ],
    "midc124": [
        "PL"
    ],
    "midc127": [
        "PL"
    ],
    "midc128": [
        "PL"
    ],
    "midc407": [
        "PL"
    ],
    "midc408": [
        "PL"
    ],
    "midc408pr002": [
        "PL"
    ],
    "midc409": [
        "PL"
    ],
    "midc410": [
        "PL"
    ],
    "midc410pr": [
        "PL"
    ],
    "midc430": [
        "PL"
    ],
    "midc497": [
        "PL"
    ],
    "midc801": [
        "PL"
    ],
    "midc802": [
        "PL"
    ],
    "midc901": [
        "PL"
    ],
    "midc970": [
        "PL"
    ],
    "midcd10": [
        "PL"
    ],
    "midcd97": [
        "PL"
    ],
    "pmid4311": [
        "PL"
    ],
    "pmid71c": [
        "PL"
    ],
    "t-i708d": [
        "PN"
    ],
    "build/ics.polypad.7208hd.dualcore.20121101": [
        "PP"
    ],
    "poly pad_8208hd": [
        "PP"
    ],
    "pgps7797": [
        "PR"
    ],
    "pgps7799cis08gbpg": [
        "PR"
    ],
    "pmt3201_4g": [
        "PR"
    ],
    "pmt3277_3g": [
        "PR"
    ],
    "pmt3287_3g": [
        "PR"
    ],
    "pmt3208_3g": [
        "PR"
    ],
    "pmp3370b": [
        "PR"
    ],
    "pmp3670b": [
        "PR"
    ],
    "pmp5080b": [
        "PR"
    ],
    "pmp5080cpro": [
        "PR"
    ],
    "pmp5101c_quad": [
        "PR"
    ],
    "pmp5570c": [
        "PR"
    ],
    "pmp5580c": [
        "PR"
    ],
    "pmp5588c": [
        "PR"
    ],
    "pmp5770d": [
        "PR"
    ],
    "pmp5870c": [
        "PR"
    ],
    "pmp7079d3g_quad": [
        "PR"
    ],
    "pmp7100d3g": [
        "PR"
    ],
    "pmp7170b3g": [
        "PR"
    ],
    "pmp7170b3g_duo": [
        "PR"
    ],
    "pmp7280c": [
        "PR"
    ],
    "pmp7280c3g_quad": [
        "PR"
    ],
    "pmp7880d3g": [
        "PR"
    ],
    "psp7610duo": [
        "PR"
    ],
    "psp7610duo_ru": [
        "PR"
    ],
    "psp7546duo_ru": [
        "PR"
    ],
    "psp7546duo": [
        "PR"
    ],
    "pov_tab-pl1015": [
        "PV"
    ],
    "pov_tab-p1325(v1.1)": [
        "PV"
    ],
    "pov_tab-p722c(v1.0)": [
        "PV"
    ],
    "pov_tab-p925(v1.0)": [
        "PV"
    ],
    "pov_tab-p506": [
        "PV"
    ],
    "pov_tab-navi7-3g-m": [
        "PV"
    ],
    "pov_tab_navi7_3g_m": [
        "PV"
    ],
    "pov_tab-p527s(v1.0)": [
        "PV"
    ],
    "pov_tab-p547(v1.0)": [
        "PV"
    ],
    "pov_tab-protab25xxl8": [
        "PV"
    ],
    "pov_tab-protab26": [
        "PV"
    ],
    "pixus himax": [
        "PX",
        "W3"
    ],
    "play three v2.0": [
        "PX"
    ],
    "play three v3.1": [
        "PX"
    ],
    "play three v4.0": [
        "PX"
    ],
    "pixus play two": [
        "PX"
    ],
    "ride_3g": [
        "PX"
    ],
    "ride_4g": [
        "PX"
    ],
    "pixus touch 7 3g": [
        "PX",
        "PRI"
    ],
    "momo19": [
        "PY"
    ],
    "momo8w": [
        "PY"
    ],
    "momo mini 3gs": [
        "PY"
    ],
    "momominis": [
        "PY"
    ],
    "qilive 8": [
        "QI"
    ],
    "qilive 8qc": [
        "QI"
    ],
    "qilive 97": [
        "QI"
    ],
    "qilive 97r": [
        "QI"
    ],
    "q7t10inp": [
        "QI"
    ],
    "q8t10in": [
        "QI"
    ],
    "qtab q400": [
        "QM"
    ],
    "qtab q50": [
        "QM"
    ],
    "qtab tab4": [
        "QM",
        "ZQ"
    ],
    "qumo altair 7002": [
        "QO"
    ],
    "qumo altair 7004": [
        "QO"
    ],
    "qumo altair 701 8gb black": [
        "QO"
    ],
    "qumo altair 706": [
        "QO"
    ],
    "qumo altair 71 4gb black": [
        "QO"
    ],
    "qumo sirius 101-4g 8gb black": [
        "QO"
    ],
    "vega 782": [
        "QO"
    ],
    "qumovega783": [
        "QO"
    ],
    "qumo vega 8002": [
        "QO"
    ],
    "qumo yooda": [
        "QO"
    ],
    "sqool-v4": [
        "QS"
    ],
    "sqool-v41": [
        "QS"
    ],
    "casper_l10_4.5g": [
        "R4"
    ],
    "via_l8": [
        "R4"
    ],
    "via_s10": [
        "R4"
    ],
    "via_s7": [
        "R4"
    ],
    "via_s8": [
        "R4"
    ],
    "via_t10": [
        "R4"
    ],
    "via_t17": [
        "R4"
    ],
    "via-t17_m": [
        "R4"
    ],
    "via-t7": [
        "R4"
    ],
    "via_t7-3g": [
        "R4"
    ],
    "via-t7d": [
        "R4"
    ],
    "via_t8b": [
        "R4"
    ],
    "via_t8d-3g": [
        "R4"
    ],
    "rmd_600": [
        "R5"
    ],
    "rmd-974r": [
        "R5"
    ],
    "roverpad": [
        "R6"
    ],
    "roverpad 10.4": [
        "R6"
    ],
    "roverpad 3w a73": [
        "R6"
    ],
    "roverpad 3w7": [
        "R6"
    ],
    "roverpad 3w9.4": [
        "R6"
    ],
    "roverpad 3wt70": [
        "R6"
    ],
    "roverpad 9.7 3g": [
        "R6"
    ],
    "roverpad air s70": [
        "R6"
    ],
    "roverpad sky 7.85": [
        "R6"
    ],
    "roverpad sky 9.7": [
        "R6"
    ],
    "ramosi9": [
        "RA"
    ],
    "ramos w27pro": [
        "RA"
    ],
    "ramos x10 pro\xe6\u2014\xb6\xe5\xb0\u0161\xe7\u2030\u02C6": [
        "RA"
    ],
    "readboy_f300": [
        "RB"
    ],
    "readboy_g100": [
        "RB"
    ],
    "readboy_g20": [
        "RB"
    ],
    "tecno p703": [
        "TB"
    ],
    "magnet_g30": [
        "V2"
    ],
    "m6200": [
        "KC"
    ],
    "kids09": [
        "DK"
    ],
    "9013a": [
        "AL"
    ],
    "9032z": [
        "AL"
    ],
    "8094m": [
        "AL"
    ],
    "9032w": [
        "AL"
    ],
    "9048s": [
        "TC"
    ],
    "gwat8-1": [
        "GA"
    ],
    "qmv7a": [
        "V4"
    ],
    "ghost g03": [
        "GJ"
    ],
    "surface duo": [
        "MS"
    ],
    "surface duo 2": [
        "MS"
    ],
    "rct6b06p23": [
        "RC"
    ],
    "tbbvnc100005208": [
        "O4"
    ],
    "lightyear": [
        "FS"
    ],
    "hope7 max": [
        "XT"
    ],
    "kingpad_sa10": [
        "VA"
    ],
    "joy10 mate": [
        "XT"
    ],
    "vct9b06q22": [
        "UV"
    ],
    "s4t7in": [
        "0U"
    ],
    "hr-v101": [
        "HA"
    ],
    "sm-t561": [
        "SA"
    ],
    "turkcell_t_tablet": [
        "UR"
    ],
    "tab 711 4g": [
        "MJ"
    ],
    "nogapad7g": [
        "OG"
    ],
    "ax4nano": [
        "A2"
    ],
    "ipad7,5": [
        "AP"
    ],
    "pocketbook a7": [
        "P8"
    ],
    "pocketbook a10 3g": [
        "P8"
    ],
    "pocketbook a10": [
        "P8"
    ],
    "pocketbook surfpad 4 l": [
        "P8"
    ],
    "pocketbook surfpad 4 m": [
        "P8"
    ],
    "pocketbook surfpad 4 s": [
        "P8"
    ],
    "pocketbook surfpad2": [
        "P8"
    ],
    "airtab_mw1011": [
        "DN"
    ],
    "sm-t385l": [
        "SA"
    ],
    "plane 8595 3g ps8212pg": [
        "D2"
    ],
    "plane 7594 3g ps7210pg": [
        "D2"
    ],
    "plane 1596 3g ps1213pg": [
        "D2"
    ],
    "plane 1581 3g ps1200mg": [
        "D2"
    ],
    "momo9 star": [
        "PY"
    ],
    "dns airtab m75t": [
        "DN"
    ],
    "bmxc 800": [
        "BMX"
    ],
    "huawei m2-a01l": [
        "HU"
    ],
    "b1-730": [
        "AC"
    ],
    "readboy_g30": [
        "RB"
    ],
    "readboy_g35": [
        "RB"
    ],
    "readboy_g50": [
        "RB"
    ],
    "rct6077w2": [
        "RC"
    ],
    "rct6773w22": [
        "RC"
    ],
    "roadrover changan s": [
        "RR"
    ],
    "rmd-1026": [
        "RX"
    ],
    "rmd-1028": [
        "RX"
    ],
    "rmd-1029": [
        "RX"
    ],
    "rmd-1030": [
        "RX"
    ],
    "rmd-1050": [
        "RX"
    ],
    "rmd-1058": [
        "RX"
    ],
    "rmd-1059": [
        "RX"
    ],
    "rmd-1121": [
        "RX"
    ],
    "rmd-726": [
        "RX"
    ],
    "rmd-750": [
        "RX"
    ],
    "rmd-751": [
        "RX"
    ],
    "rmd-855": [
        "RX"
    ],
    "rmd-857": [
        "RX"
    ],
    "rmd-870": [
        "RX"
    ],
    "element10 1": [
        "S1"
    ],
    "element7v2": [
        "S1"
    ],
    "element 7 v2 basic": [
        "S1"
    ],
    "element 7v3": [
        "S1"
    ],
    "element8": [
        "S1"
    ],
    "sencor element 8v2": [
        "S1"
    ],
    "element 8v3": [
        "S1"
    ],
    "sencor element 9.7v3": [
        "S1"
    ],
    "supra m726g": [
        "S5"
    ],
    "supra m74ag": [
        "S5"
    ],
    "supra m74jg": [
        "S5"
    ],
    "supra_m84d_3g": [
        "S5"
    ],
    "nvtab 7.0 3g": [
        "S5"
    ],
    "gt-n8000": [
        "SA"
    ],
    "sm-p601": [
        "SA"
    ],
    "samsung sm-p602": [
        "SA"
    ],
    "sm-p605": [
        "SA"
    ],
    "samsung sm-p607t": [
        "SA"
    ],
    "sm-p600": [
        "SA"
    ],
    "gt-n8020": [
        "SA"
    ],
    "gt-n8010": [
        "SA"
    ],
    "gt-n5100": [
        "SA"
    ],
    "n5100": [
        "SA"
    ],
    "gt-n5120": [
        "SA"
    ],
    "gt-n5110": [
        "SA"
    ],
    "n5110": [
        "SA"
    ],
    "samsung sm-p902": [
        "SA"
    ],
    "samsung sm-p901": [
        "SA"
    ],
    "samsung sm-p905": [
        "SA"
    ],
    "samsung sm-p900": [
        "SA"
    ],
    "gt-p1000m": [
        "SA"
    ],
    "sch-i800": [
        "SA"
    ],
    "gt-p1000": [
        "SA"
    ],
    "gt-p7500": [
        "SA"
    ],
    "gt-p7500d": [
        "SA"
    ],
    "gt-p7510": [
        "SA"
    ],
    "samsung gt-p7500/p7500bulp5": [
        "SA"
    ],
    "gt-p7500r": [
        "SA"
    ],
    "gt-p7500m": [
        "SA"
    ],
    "gt-p7100": [
        "SA"
    ],
    "gt-p5100": [
        "SA"
    ],
    "sch-i915": [
        "SA"
    ],
    "samsung gt-p5100/p5100xxdmj2": [
        "SA"
    ],
    "gt-p5110": [
        "SA"
    ],
    "gt-p5113": [
        "SA"
    ],
    "gt-p3100": [
        "SA"
    ],
    "gt-p3100b": [
        "SA"
    ],
    "gt-p3110": [
        "SA"
    ],
    "gt-p3113": [
        "SA"
    ],
    "samsung gt-p5200/p5200xxuami8": [
        "SA"
    ],
    "gt-p5200": [
        "SA"
    ],
    "gt-p5220-orange/p5220xxuamk2": [
        "SA"
    ],
    "gt-p5210": [
        "SA"
    ],
    "sm-t211": [
        "SA"
    ],
    "samsung sm-t211/t211xxamj5": [
        "SA"
    ],
    "samsung-sm-t217a": [
        "SA"
    ],
    "sm-t215": [
        "SA"
    ],
    "sm-t217s": [
        "SA"
    ],
    "sm-t217t": [
        "SA"
    ],
    "sm-t212": [
        "SA"
    ],
    "sm-t2105": [
        "SA"
    ],
    "sm-t111": [
        "SA"
    ],
    "sm-t111m": [
        "SA"
    ],
    "sm-t110": [
        "SA"
    ],
    "sm-t113": [
        "SA"
    ],
    "sm-t210-orange/t210xxami9": [
        "SA"
    ],
    "sm-t210r": [
        "SA"
    ],
    "sm-t210": [
        "SA"
    ],
    "sm-t311": [
        "SA"
    ],
    "sm-t315": [
        "SA"
    ],
    "sm-t310": [
        "SA"
    ],
    "sm-t116ny": [
        "SA"
    ],
    "sm-t116nu": [
        "SA"
    ],
    "sm-t536": [
        "SA"
    ],
    "sm-t531": [
        "SA"
    ],
    "samsung-sm-t537a": [
        "SA"
    ],
    "samsung sm-t535": [
        "SA"
    ],
    "sm-t537v": [
        "SA"
    ],
    "sm-t530nu": [
        "SA"
    ],
    "samsung sm-t530": [
        "SA"
    ],
    "sm-t231": [
        "SA"
    ],
    "403sc": [
        "SA"
    ],
    "sm-t235": [
        "SA"
    ],
    "sm-t239": [
        "SA"
    ],
    "samsung sm-t237p": [
        "SA"
    ],
    "sm-t230nu": [
        "SA"
    ],
    "samsung-sm-t337a": [
        "SA"
    ],
    "samsung sm-t335": [
        "SA"
    ],
    "sm-t331": [
        "SA"
    ],
    "sm-t337t": [
        "SA"
    ],
    "sm-t337v": [
        "SA"
    ],
    "samsung sm-t332": [
        "SA"
    ],
    "sm-t330": [
        "SA"
    ],
    "gt-p6200": [
        "SA"
    ],
    "gt-p6201": [
        "SA"
    ],
    "gt-p6810": [
        "SA"
    ],
    "samsung sm-t510": [
        "SA"
    ],
    "sm-t587p": [
        "SA"
    ],
    "samsung sm-t587": [
        "SA"
    ],
    "sm-p585": [
        "SA"
    ],
    "sm-t585": [
        "SA"
    ],
    "sm-p587": [
        "SA"
    ],
    "sm-t597w": [
        "SA"
    ],
    "samsung sm-t595": [
        "SA"
    ],
    "samsung sm-t285": [
        "SA"
    ],
    "sm-p350": [
        "SA"
    ],
    "sm-t357t": [
        "SA"
    ],
    "sm-t357w": [
        "SA"
    ],
    "sm-t355y": [
        "SA"
    ],
    "sm-t385": [
        "SA"
    ],
    "sm-t387vk": [
        "SA"
    ],
    "sm-t387w": [
        "SA"
    ],
    "sm-t387t": [
        "SA"
    ],
    "sm-t387v": [
        "SA"
    ],
    "samsung sm-t387r4": [
        "SA"
    ],
    "sm-t387aa": [
        "SA"
    ],
    "samsung sm-t295": [
        "SA"
    ],
    "samsung sm-t380": [
        "SA"
    ],
    "samsung sm-t290": [
        "SA"
    ],
    "samsung sm-p205": [
        "SA"
    ],
    "sm-p200": [
        "SA"
    ],
    "sm-p550": [
        "SA"
    ],
    "samsung sm-p555m": [
        "SA"
    ],
    "sm-p555": [
        "SA"
    ],
    "sm-p355m": [
        "SA"
    ],
    "sm-p355": [
        "SA"
    ],
    "sm-p355y": [
        "SA"
    ],
    "sm-t397u": [
        "SA"
    ],
    "samsung sm-t395": [
        "SA"
    ],
    "sm-t365": [
        "SA"
    ],
    "sm-t360": [
        "SA"
    ],
    "sm-t378l": [
        "SA"
    ],
    "sm-t378k": [
        "SA"
    ],
    "sm-t378s": [
        "SA"
    ],
    "sm-t377w": [
        "SA"
    ],
    "sm-t378v": [
        "SA"
    ],
    "sm-t567v": [
        "SA"
    ],
    "sm-t562": [
        "SA"
    ],
    "sm-t560": [
        "SA"
    ],
    "samsung sm-t805": [
        "SA"
    ],
    "sm-t807v": [
        "SA"
    ],
    "sm-t807": [
        "SA"
    ],
    "sm-t807p": [
        "SA"
    ],
    "samsung sm-t800": [
        "SA"
    ],
    "samsung sm-t705": [
        "SA"
    ],
    "samsung-sm-t707a": [
        "SA"
    ],
    "sm-t705": [
        "SA"
    ],
    "sm-t700": [
        "SA"
    ],
    "sm-t715c": [
        "SA"
    ],
    "sm-t715n0": [
        "SA"
    ],
    "sm-t715y": [
        "SA"
    ],
    "samsung sm-t719c": [
        "SA"
    ],
    "samsung sm-t719": [
        "SA"
    ],
    "samsung sm-t719y": [
        "SA"
    ],
    "sm-t715": [
        "SA"
    ],
    "sm-t710x": [
        "SA"
    ],
    "sm-t710": [
        "SA"
    ],
    "sm-t713": [
        "SA"
    ],
    "sm-t815": [
        "SA"
    ],
    "samsung-sm-t818a": [
        "SA"
    ],
    "sm-t818t": [
        "SA"
    ],
    "sm-t818w": [
        "SA"
    ],
    "sm-t819y": [
        "SA"
    ],
    "sm-t819": [
        "SA"
    ],
    "samsung sm-t817a": [
        "SA"
    ],
    "samsung sm-t817t": [
        "SA"
    ],
    "samsung sm-t817": [
        "SA"
    ],
    "samsung sm-t817w": [
        "SA"
    ],
    "samsung sm-t810": [
        "SA"
    ],
    "samsung sm-t825": [
        "SA"
    ],
    "sm-t827": [
        "SA"
    ],
    "sm-t835n": [
        "SA"
    ],
    "sm-t837a": [
        "SA"
    ],
    "sm-t837t": [
        "SA"
    ],
    "samsung sm-t835c": [
        "SA"
    ],
    "samsung sm-t837v": [
        "SA"
    ],
    "samsung sm-t830x": [
        "SA"
    ],
    "sm-t837r4": [
        "SA"
    ],
    "samsung sm-t830": [
        "SA"
    ],
    "sm-t727a": [
        "SA"
    ],
    "sm-t720x": [
        "SA"
    ],
    "sm-t727v": [
        "SA"
    ],
    "sm-t725n": [
        "SA"
    ],
    "sm-t725": [
        "SA"
    ],
    "sm-t720": [
        "SA"
    ],
    "sm-p615": [
        "SA"
    ],
    "sm-p610": [
        "SA"
    ],
    "samsung sm-t865n": [
        "SA"
    ],
    "samsung sm-t865": [
        "SA"
    ],
    "sm-t867v": [
        "SA"
    ],
    "sm-t867": [
        "SA"
    ],
    "samsung sm-t860": [
        "SA"
    ],
    "sm-t525": [
        "SA"
    ],
    "samsung sm-t520": [
        "SA"
    ],
    "samsung sm-t900": [
        "SA"
    ],
    "samsung sm-t325": [
        "SA"
    ],
    "sm-t320": [
        "SA"
    ],
    "sm-t677v": [
        "SA"
    ],
    "samsung-sm-t677a": [
        "SA"
    ],
    "sm-t677nl": [
        "SA"
    ],
    "sm-t677nk": [
        "SA"
    ],
    "samsung sm-t677": [
        "SA"
    ],
    "samsung sm-t670": [
        "SA"
    ],
    "gt-n8013": [
        "SA"
    ],
    "gt-p7300": [
        "SA"
    ],
    "gt-p7300-orange/p7300bvkj5": [
        "SA"
    ],
    "gt-p7310": [
        "SA"
    ],
    "gt-p7320": [
        "SA"
    ],
    "gt-p7501": [
        "SA"
    ],
    "gt-p7511": [
        "SA"
    ],
    "androtab 7": [
        "SC"
    ],
    "sh-08e": [
        "SH"
    ],
    "sony tablet p": [
        "SO"
    ],
    "sony tablet s": [
        "SO"
    ],
    "xperia tablet s": [
        "SO"
    ],
    "sgpt12": [
        "SO"
    ],
    "sgpt13": [
        "SO"
    ],
    "sgp311": [
        "SO"
    ],
    "sgp312": [
        "SO"
    ],
    "sgp321": [
        "SO"
    ],
    "so-03e": [
        "SO"
    ],
    "sgp512": [
        "SO"
    ],
    "sgp511": [
        "SO"
    ],
    "so-05f": [
        "SO"
    ],
    "sgp621": [
        "SO"
    ],
    "sgp611": [
        "SO"
    ],
    "sgp612": [
        "SO"
    ],
    "sgp712": [
        "SO"
    ],
    "xperia z2 tablet wifi": [
        "SO"
    ],
    "so-05g": [
        "SO"
    ],
    "sot31": [
        "SO"
    ],
    "sgp771": [
        "SO"
    ],
    "ezee'tab1001": [
        "ST",
        "EZ"
    ],
    "ezeetab1003": [
        "ST",
        "EZ"
    ],
    "ezee'tab1004": [
        "ST",
        "EZ"
    ],
    "ezee'tab10c": [
        "ST",
        "EZ"
    ],
    "ezee'tab10d11-m": [
        "ST",
        "EZ"
    ],
    "ezee' tab702": [
        "ST",
        "EZ"
    ],
    "ezee'tab705": [
        "ST",
        "EZ"
    ],
    "ezee'tab706": [
        "ST",
        "EZ"
    ],
    "ezee'tab707": [
        "ST",
        "EZ"
    ],
    "ezee'tab785": [
        "ST",
        "EZ"
    ],
    "ezee'tab785d11-s": [
        "ST",
        "EZ"
    ],
    "ezee'tab785q11-m": [
        "ST",
        "EZ"
    ],
    "ezee'tab7d10-s": [
        "ST",
        "EZ"
    ],
    "ezee'tab7d12-s": [
        "ST",
        "EZ"
    ],
    "ezee'tab7d13-s": [
        "ST",
        "EZ"
    ],
    "ezeetab7d15-m": [
        "ST",
        "EZ"
    ],
    "ezee'tab802": [
        "ST",
        "EZ"
    ],
    "ezee'tab803": [
        "ST",
        "EZ"
    ],
    "ezee'tab804": [
        "ST",
        "EZ"
    ],
    "ezee tab805": [
        "ST",
        "EZ"
    ],
    "ezee'tab8d11-s": [
        "ST",
        "EZ"
    ],
    "ezee'tab901": [
        "ST",
        "EZ"
    ],
    "ezee'tab903": [
        "ST",
        "EZ"
    ],
    "ezee'tab904": [
        "ST",
        "EZ"
    ],
    "ezee\xe2\u20AC\u2122tab 971": [
        "ST",
        "EZ"
    ],
    "ezee tab973": [
        "ST",
        "EZ"
    ],
    "ezee'tab973": [
        "ST",
        "EZ"
    ],
    "ezee'tab97d11-s": [
        "ST",
        "EZ"
    ],
    "sc-06d": [
        "SU"
    ],
    "sc-74jb": [
        "SU"
    ],
    "sc-91mid": [
        "SU"
    ],
    "sfr startab": [
        "SX"
    ],
    "cyclone voyager": [
        "SZ"
    ],
    "cyclone voyager 2": [
        "SZ"
    ],
    "tolino tab 7": [
        "T1"
    ],
    "tolino tab 8.9": [
        "T1"
    ],
    "tab 10 3g v16": [
        "T3"
    ],
    "tab 7 3g v8": [
        "T3"
    ],
    "tab 8 3g v8": [
        "T3"
    ],
    "tab9 3g": [
        "T3"
    ],
    "tab9 3g v8": [
        "T3"
    ],
    "ignis 8": [
        "T5"
    ],
    "trekstor primetab p10": [
        "T6"
    ],
    "st10216-2a": [
        "T6"
    ],
    "vt10416-1": [
        "T6"
    ],
    "engb": [
        "T6"
    ],
    "surftab breeze 10.1 quad 3g": [
        "T6"
    ],
    "surftab breeze 10.1 quad plus": [
        "T6"
    ],
    "surftab breeze 7.0 quad": [
        "T6"
    ],
    "trekstor surftab breeze 9.6 quad 3g": [
        "T6"
    ],
    "tfmtkaw01232": [
        "T6"
    ],
    "trekstor surftab theatre 13.3": [
        "T6"
    ],
    "trekstor surftab theatre k13": [
        "T6"
    ],
    "trekstor surftab xiron 10.1 3g": [
        "T6"
    ],
    "trekstor surftab xiron 10.1 pure": [
        "T6"
    ],
    "p10s(n4h5)": [
        "T7"
    ],
    "p80x_eea": [
        "T7"
    ],
    "p80x_row": [
        "T7"
    ],
    "t10(e3c6)": [
        "T7"
    ],
    "t30_eea": [
        "T7"
    ],
    "t30_row": [
        "T7"
    ],
    "tbook 16 power(m5f8)": [
        "T7"
    ],
    "98(m3e3)": [
        "T7"
    ],
    "98(m1e9)": [
        "T7"
    ],
    "98(m1e7)": [
        "T7"
    ],
    "98(m1e4)": [
        "T7"
    ],
    "98(m1e5)": [
        "T7"
    ],
    "98(m1e8)": [
        "T7"
    ],
    "x98 air ii(hg5n)": [
        "T7"
    ],
    "x98 air iii": [
        "T7"
    ],
    "x80 power(b2n4)": [
        "T7"
    ],
    "tm-mid1020a": [
        "T8"
    ],
    "tm-mid710": [
        "T8"
    ],
    "tm-mid788d": [
        "T8"
    ],
    "tm-mid792": [
        "T8"
    ],
    "tm-mid798": [
        "T8"
    ],
    "coto_t117": [
        "T9"
    ],
    "x1013": [
        "T9"
    ],
    "tecno dp10a pro": [
        "TB"
    ],
    "tecno p904": [
        "TB"
    ],
    "tecno 7c": [
        "TB"
    ],
    "tecno dp7c pro-sga1": [
        "TB"
    ],
    "tecno dp8d": [
        "TB"
    ],
    "hudl ht7s3": [
        "TD"
    ],
    "w032i-c3": [
        "TD"
    ],
    "mid211h": [
        "TK"
    ],
    "tel-1013giqa": [
        "TL"
    ],
    "tf-mid1010g": [
        "TL"
    ],
    "tf-mid702g": [
        "TL"
    ],
    "tf-mid7805g": [
        "TL"
    ],
    "tf-mid802g": [
        "TL"
    ],
    "tf-mid9705rg": [
        "TL"
    ],
    "primo7": [
        "TN"
    ],
    "primo8": [
        "TN"
    ],
    "qm734-8g": [
        "TN"
    ],
    "qm735-8g": [
        "TN"
    ],
    "s813g": [
        "TP"
    ],
    "xtab 7": [
        "TP"
    ],
    "xtab-70dc": [
        "TP"
    ],
    "xtab 781+": [
        "TP"
    ],
    "xtab-781+": [
        "TP"
    ],
    "dual c1081hd": [
        "TP"
    ],
    "xtab dual c1081+": [
        "TP"
    ],
    "xtab i700": [
        "TP"
    ],
    "hive v 3g": [
        "TR"
    ],
    "turbo-x ice": [
        "TR"
    ],
    "turbo-x tablet spice iii": [
        "TR",
        "SP"
    ],
    "at7-c": [
        "TS"
    ],
    "at10-a": [
        "TS"
    ],
    "at10le-a": [
        "TS"
    ],
    "at10pe-a": [
        "TS"
    ],
    "at100": [
        "TS"
    ],
    "at1s0": [
        "TS"
    ],
    "at200": [
        "TS"
    ],
    "at270": [
        "TS"
    ],
    "at300": [
        "TS"
    ],
    "at300se": [
        "TS"
    ],
    "at330": [
        "TS"
    ],
    "at374": [
        "TS"
    ],
    "at400": [
        "TS"
    ],
    "at470": [
        "TS"
    ],
    "at500": [
        "TS"
    ],
    "at500a": [
        "TS"
    ],
    "at503": [
        "TS"
    ],
    "at570": [
        "TS"
    ],
    "at703": [
        "TS"
    ],
    "at830": [
        "TS"
    ],
    "navipad tm-7049 3grevision 1": [
        "TZ"
    ],
    "navipad tm-7055hd 3g": [
        "TZ"
    ],
    "navipad tm-7855 3g": [
        "TZ"
    ],
    "navipad tm-7858 3g (revision 1)": [
        "TZ"
    ],
    "navipad tm-7887 3g (revision 1": [
        "TZ"
    ],
    "tb-711a": [
        "TZ"
    ],
    "tb-771a": [
        "TZ"
    ],
    "tm-1057": [
        "TZ"
    ],
    "tm-1067": [
        "TZ"
    ],
    "tm-6906": [
        "TZ"
    ],
    "tm-7021": [
        "TZ"
    ],
    "tm-7023": [
        "TZ"
    ],
    "tm-7024": [
        "TZ"
    ],
    "tm-7026 revision 4": [
        "TZ"
    ],
    "tm-7037w": [
        "TZ"
    ],
    "tm-7041": [
        "TZ"
    ],
    "tm-7043xd": [
        "TZ"
    ],
    "tm-7047hd 3g": [
        "TZ"
    ],
    "tm-7052": [
        "TZ"
    ],
    "tm-7053": [
        "TZ"
    ],
    "tm-8041hd": [
        "TZ"
    ],
    "tm-8043": [
        "TZ"
    ],
    "tm-8044": [
        "TZ"
    ],
    "tm-9720": [
        "TZ"
    ],
    "tm-9737w": [
        "TZ"
    ],
    "tm-9738w": [
        "TZ"
    ],
    "tm-9740": [
        "TZ"
    ],
    "tm-9741": [
        "TZ"
    ],
    "tm-9743w": [
        "TZ"
    ],
    "tm-9747": [
        "TZ"
    ],
    "tm-9747bt": [
        "TZ"
    ],
    "tm-9748 3g": [
        "TZ"
    ],
    "tm-9750hd": [
        "TZ"
    ],
    "tm-9751hd": [
        "TZ"
    ],
    "tm-9757": [
        "TZ"
    ],
    "tm-1058": [
        "TZ"
    ],
    "x-pad air 8 3g (revision 1)": [
        "TZ"
    ],
    "tm-8048_revision1": [
        "TZ"
    ],
    "tm-8051": [
        "TZ"
    ],
    "x-pad hit 3g (revision 1)": [
        "TZ"
    ],
    "x-pad ix 7 3g(revision 5)": [
        "TZ"
    ],
    "x-pad lite 7.1 (revision 2)": [
        "TZ"
    ],
    "x-pad lite 7.2 (revision 1)": [
        "TZ"
    ],
    "x-pad navi 10 3g (revision 1)": [
        "TZ"
    ],
    "tm-1046": [
        "TZ"
    ],
    "tm-7096": [
        "TZ"
    ],
    "x-pad navi 7.3 3g (revision 1)": [
        "TZ"
    ],
    "tm-7099": [
        "TZ"
    ],
    "x-pad navi 7.5 3g": [
        "TZ"
    ],
    "tm-7859 3g(revision 1)": [
        "TZ"
    ],
    "x-pad plus 7 3g/tm-9746": [
        "TZ"
    ],
    "x-pad plus 7.1 3g/tm-9749": [
        "TZ"
    ],
    "x-pad quad 10 3g (revision 1)": [
        "TZ"
    ],
    "x-pad quad 7 3g (revision 1)": [
        "TZ"
    ],
    "x-pad quad 7.2 3g (revision 1)": [
        "TZ"
    ],
    "tm-8066 (revision1)": [
        "TZ"
    ],
    "x-pad shine 8.1 3g": [
        "TZ",
        "J0"
    ],
    "x-pad sky 8.1 3g  (revision 1)": [
        "TZ"
    ],
    "tm-9758": [
        "TZ"
    ],
    "tm-9767 3g": [
        "TZ"
    ],
    "x-pad style 10.1 3g": [
        "TZ"
    ],
    "x-pad style 8 3g": [
        "TZ"
    ],
    "visionbook_10qi_3g": [
        "UA"
    ],
    "visionbook 7q plus": [
        "UA"
    ],
    "7qa_3g": [
        "UA"
    ],
    "visionbook 7qi 3g": [
        "UA"
    ],
    "visionbook 8q lte": [
        "UA"
    ],
    "visionbook_8q_plus": [
        "UA"
    ],
    "8qa_3g": [
        "UA"
    ],
    "visionbook_8qe_3g": [
        "UA"
    ],
    "visionbook_8qi_3g": [
        "UA"
    ],
    "visionbook_8qi_3g_plus": [
        "UA"
    ],
    "visionbook p70 lte": [
        "UA"
    ],
    "qooq": [
        "UN"
    ],
    "epic e8": [
        "V2",
        "HR"
    ],
    "epic p7": [
        "V2",
        "HR"
    ],
    "magnet m1": [
        "V2"
    ],
    "navo_qs": [
        "V2"
    ],
    "onyx_qs": [
        "V2"
    ],
    "alba 10 tablet": [
        "1A"
    ],
    "wave i101b": [
        "EH"
    ],
    "wink primo": [
        "WN"
    ],
    "wink highway": [
        "WN",
        "WI"
    ],
    "sk5501": [
        "SMA"
    ],
    "tabletexo_wave_i101r": [
        "EH"
    ],
    "alba7q": [
        "1A"
    ],
    "betelgeuse": [
        "CEI"
    ],
    "dg101tbips": [
        "DGT"
    ],
    "gemini_4g": [
        "9P"
    ],
    "magnet_g10": [
        "V2"
    ],
    "team_7_3g": [
        "GB"
    ],
    "tpc_8063g": [
        "V5"
    ],
    "gravity-2-max": [
        "FS"
    ],
    "n70 dual core": [
        "YU"
    ],
    "sht21": [
        "SH"
    ],
    "gv7777": [
        "PR"
    ],
    "onyx_z": [
        "V2"
    ],
    "orin_qs": [
        "V2"
    ],
    "pluri_m7": [
        "V2"
    ],
    "pluri_q8": [
        "V2"
    ],
    "sirius_qs": [
        "V2"
    ],
    "xavy_l8": [
        "V2"
    ],
    "xavy_t7": [
        "V2"
    ],
    "qtair7": [
        "V4"
    ],
    "qtaxia1": [
        "V4"
    ],
    "qmv7b": [
        "V4"
    ],
    "qtaqz3": [
        "V4"
    ],
    "qtasun1": [
        "V4"
    ],
    "qtasun2": [
        "V4"
    ],
    "qtaqz3kid": [
        "V4"
    ],
    "m1072r-3g": [
        "VA"
    ],
    "m783k": [
        "VA"
    ],
    "m783k-16g": [
        "VA"
    ],
    "m910a": [
        "VA"
    ],
    "vt75c": [
        "VD"
    ],
    "smarttab10": [
        "VF"
    ],
    "smarttab10-msm8260-v03b-apr162012-vodafone-it": [
        "VF"
    ],
    "vodafone smart tab 4": [
        "VF"
    ],
    "vodafone smart tab 4g": [
        "VF"
    ],
    "smarttab7-msm8260-v03b-apr162012-vodafone-es": [
        "VF"
    ],
    "vodafone smarttab ii 10": [
        "VF"
    ],
    "smarttabii10": [
        "VF"
    ],
    "fr-be, smarttabii7": [
        "VF"
    ],
    "vodafone smart tab iii 10": [
        "VF"
    ],
    "vodafone smart tab iii 7": [
        "VF"
    ],
    "vfd 1300": [
        "VF"
    ],
    "vfd 1100": [
        "VF"
    ],
    "vf-1497": [
        "VF"
    ],
    "vfd 1400": [
        "VF"
    ],
    "vf-1397": [
        "VF"
    ],
    "vodacom power tab 10": [
        "VM"
    ],
    "viewpad 10e": [
        "VS"
    ],
    "viewpad7": [
        "VS"
    ],
    "viewsonic-viewpad7e": [
        "VS"
    ],
    "vtab10": [
        "VT"
    ],
    "v_tab_7_eco_iii": [
        "VT"
    ],
    "v_tab_7020a": [
        "VT"
    ],
    "v_tab_7025": [
        "VT"
    ],
    "vt97pro": [
        "VT"
    ],
    "vp74": [
        "VT"
    ],
    "v709x": [
        "VX"
    ],
    "voyo a15": [
        "VY"
    ],
    "vtab1008": [
        "VZ",
        "VT"
    ],
    "primo walpad 7": [
        "WA"
    ],
    "walpad 8b": [
        "WA"
    ],
    "primo walpad 8w": [
        "WA"
    ],
    "mitab alabama": [
        "WL"
    ],
    "mitab brooklyn": [
        "WL"
    ],
    "mitab-epsilon": [
        "WL"
    ],
    "mitab funk": [
        "WL"
    ],
    "mitab hero": [
        "WL"
    ],
    "mitab jump": [
        "WL"
    ],
    "mitab_seattle": [
        "WL"
    ],
    "terra pad 1004": [
        "WR"
    ],
    "woxter_n100": [
        "WX"
    ],
    "woxter nimbus 97q": [
        "WX"
    ],
    "woxter qx 70": [
        "WX"
    ],
    "woxter tablet pc 76cxi": [
        "WX"
    ],
    "woxter tablet pc 90bl": [
        "WX"
    ],
    "woxter tablet pc 97ips": [
        "WX"
    ],
    "woxter zielo d15": [
        "WX"
    ],
    "wexler.book_t7008": [
        "WY"
    ],
    "tab 10q": [
        "WY"
    ],
    "wexler-tab-7t": [
        "WY"
    ],
    "wexler_tab7id": [
        "WY"
    ],
    "ultima 7 twist plus": [
        "WY"
    ],
    "mi pad": [
        "XI"
    ],
    "mi pad 2": [
        "XI"
    ],
    "mi pad 3": [
        "XI"
    ],
    "mi pad 4 plus": [
        "XI"
    ],
    "telepad10a3 4g": [
        "XR"
    ],
    "telepad1032": [
        "XR"
    ],
    "telepad7a3 4g": [
        "XR"
    ],
    "telepad731": [
        "XR"
    ],
    "telepad795": [
        "XR"
    ],
    "hope7_mate": [
        "XT"
    ],
    "x-tigi_joy10_pro": [
        "XT"
    ],
    "x-tigi_joy7_max": [
        "XT"
    ],
    "luna tab474": [
        "YA",
        "69"
    ],
    "luna tab10-150": [
        "YA",
        "69"
    ],
    "luna tab07-920n": [
        "YA",
        "69"
    ],
    "luna tab274": [
        "YA",
        "69"
    ],
    "luna tab07-100": [
        "YA",
        "69"
    ],
    "luna tab07-101": [
        "YA",
        "69"
    ],
    "tab10-410": [
        "YA"
    ],
    "tab09-410": [
        "YA"
    ],
    "noble tab07-485": [
        "YA"
    ],
    "tab10-201": [
        "YA"
    ],
    "xenta tab10-211": [
        "YA"
    ],
    "xenta tab13-201": [
        "YA"
    ],
    "xenta-tab07-210": [
        "YA"
    ],
    "xenta-tab07-211": [
        "YA"
    ],
    "tab07-200": [
        "YA"
    ],
    "xenta tab08-201-3g": [
        "YA"
    ],
    "xenta tab08-200": [
        "YA"
    ],
    "xenta tab9-200": [
        "YA"
    ],
    "xenta tab09-211": [
        "YA"
    ],
    "n101 dual core2 v11": [
        "YU"
    ],
    "zfinery900": [
        "ZF"
    ],
    "zyq-q88": [
        "ZQ"
    ],
    "zync cloud 605": [
        "ZY"
    ],
    "cloud z5": [
        "ZY"
    ],
    "zync dual 7+": [
        "ZY"
    ],
    "zync dual 7i": [
        "ZY"
    ],
    "z1000": [
        "ZY"
    ],
    "z1000 3d": [
        "ZY"
    ],
    "z18": [
        "ZY"
    ],
    "zync z7i 3g": [
        "ZY"
    ],
    "zync z81": [
        "ZY"
    ],
    "z900_plus": [
        "ZY"
    ],
    "z909": [
        "ZY"
    ],
    "z930": [
        "ZY"
    ],
    "z930+": [
        "ZY"
    ],
    "z99": [
        "ZY"
    ],
    "z99_3g": [
        "ZY"
    ],
    "z99 dual core": [
        "ZY"
    ],
    "presto": [
        "10"
    ],
    "s72-b": [
        "10"
    ],
    "sx2w": [
        "10"
    ],
    "tangotab": [
        "10"
    ],
    "ultimax": [
        "10"
    ],
    "valumax": [
        "10"
    ],
    "access_q784c": [
        "20"
    ],
    "p024": [
        "AU"
    ],
    "supernova qi32": [
        "LT"
    ],
    "m1092r": [
        "9D"
    ],
    "m1092r-1": [
        "9D"
    ],
    "m1092r-2": [
        "9D"
    ],
    "m1092rv4": [
        "9D"
    ],
    "m1092rv5": [
        "9D"
    ],
    "notosplus3g": [
        "O1"
    ],
    "k908h4g": [
        "7D"
    ],
    "nitro_phablet_9s": [
        "MW"
    ],
    "navon orpheus 3g": [
        "N3"
    ],
    "it-1101-quad": [
        "86"
    ],
    "it-1101s": [
        "86"
    ],
    "it-1101": [
        "86"
    ],
    "itel it1702": [
        "IZ"
    ],
    "itel it1701": [
        "IZ"
    ],
    "itel it1703": [
        "IZ"
    ],
    "jk103 3g": [
        "J6"
    ],
    "jk960 3g": [
        "J6"
    ],
    "dart kz07": [
        "1K"
    ],
    "maximus_t2": [
        "ZM"
    ],
    "navitel t707 3g": [
        "7V"
    ],
    "navitel_t757lte": [
        "7V"
    ],
    "navitel t700 3g": [
        "7V"
    ],
    "navitel re900 full hd": [
        "7V"
    ],
    "navitel a731": [
        "7V"
    ],
    "navitel a730": [
        "7V"
    ],
    "navitel a650": [
        "7V"
    ],
    "navitel a737": [
        "7V"
    ],
    "navitel a735": [
        "7V"
    ],
    "leapad_x": [
        "L5"
    ],
    "st1009": [
        "3B"
    ],
    "st13416-1": [
        "T6"
    ],
    "supertabk7": [
        "79"
    ],
    "supertaba10": [
        "79"
    ],
    "supertabs7g": [
        "79"
    ],
    "suzuki sumopad8100": [
        "ZS"
    ],
    "ecopad7": [
        "ZS"
    ],
    "sumopad10": [
        "ZS"
    ],
    "vector10.1": [
        "GH"
    ],
    "freebird 5wifi": [
        "LK"
    ],
    "ftrw100": [
        "9R"
    ],
    "dmtab-nv08b": [
        "08"
    ],
    "dmtab-in08a": [
        "08"
    ],
    "dmtab-nv20a": [
        "08"
    ],
    "dmtab-nv24a": [
        "08"
    ],
    "nbty07smkg": [
        "08"
    ],
    "nbfp07pmkg": [
        "08"
    ],
    "snb02-nv7a": [
        "08"
    ],
    "nabi2-nv7a": [
        "08"
    ],
    "spc glow9.7 1.1": [
        "FS"
    ],
    "dl9002": [
        "DD"
    ],
    "rmd-757": [
        "RX"
    ],
    "dl7006": [
        "DD"
    ],
    "dl8006": [
        "DD"
    ],
    "pipo_p9": [
        "PJ"
    ],
    "pipom9pro": [
        "PJ"
    ],
    "pipo t9": [
        "PJ"
    ],
    "sk-mtek gt7301": [
        "2G"
    ],
    "sk-mtek gt7305": [
        "2G"
    ],
    "irulu-al101": [
        "IU"
    ],
    "ml21-m7s quadcore": [
        "1R"
    ],
    "ml01-m7s-quad-core": [
        "1R"
    ],
    "ml01-m7-sd": [
        "1R"
    ],
    "ml12-m7squadcore": [
        "1R"
    ],
    "plt9774g": [
        "P1"
    ],
    "plt7774g": [
        "P1"
    ],
    "plt1074g": [
        "P1"
    ],
    "ptb7pap_ptb7pab_ptb7par": [
        "4P"
    ],
    "q27 4g": [
        "IB"
    ],
    "q9t9in": [
        "QI"
    ],
    "true beyond tab 3g": [
        "11",
        "8K"
    ],
    "vi10": [
        "1C"
    ],
    "vi10 plus": [
        "1C"
    ],
    "vi10pro": [
        "1C"
    ],
    "primo93": [
        "MZ"
    ],
    "primo 93": [
        "MZ"
    ],
    "primo81": [
        "MZ"
    ],
    "via_s18": [
        "R4"
    ],
    "via_s17": [
        "R4"
    ],
    "e-tab 20": [
        "GN"
    ],
    "agr-w09": [
        "HU"
    ],
    "m40_eea": [
        "T7"
    ],
    "citi 10 e402 4g cs1235pl": [
        "D2"
    ],
    "tz719": [
        "I6"
    ],
    "ht1004li16": [
        "HN"
    ],
    "bah3-w59": [
        "HU"
    ],
    "gta7wf": [
        "GH"
    ],
    "iplay_40": [
        "3A"
    ],
    "rc7804f": [
        "3Q"
    ],
    "hi8se": [
        "1C"
    ],
    "maxtron t1": [
        "6X"
    ],
    "citi 8 e400 4g cs8231pl": [
        "D2",
        "PC"
    ],
    "citi 7 e401 4g cs7234pl": [
        "D2"
    ],
    "bq-7083g": [
        "BX"
    ],
    "tm-mid1010": [
        "T8"
    ],
    "gorgeo 4gl": [
        "IB"
    ],
    "tm-mid1050wkd": [
        "T8"
    ],
    "ivorys4g": [
        "LV"
    ],
    "k87ca": [
        "ZT"
    ],
    "sm-t707v": [
        "SA"
    ],
    "ka-e410w": [
        "KQ"
    ],
    "lglk430": [
        "LG"
    ],
    "8088m": [
        "AL"
    ],
    "8088x_eea": [
        "AL"
    ],
    "8088q": [
        "AL"
    ],
    "supra m725g": [
        "S5"
    ],
    "snap 4g2": [
        "IB"
    ],
    "9029z": [
        "AL"
    ],
    "kon_tiki": [
        "3O"
    ],
    "e691x": [
        "MD"
    ],
    "e1050x": [
        "MD"
    ],
    "e1c_3g": [
        "A9"
    ],
    "contixo cx1045": [
        "3C"
    ],
    "optima d10.4 3g tt1002mg": [
        "D2"
    ],
    "alba7nou": [
        "1A"
    ],
    "alba10nou": [
        "1A"
    ],
    "alba7pie": [
        "1A"
    ],
    "alba10pie": [
        "1A"
    ],
    "brisk 4g2": [
        "IB"
    ],
    "tb105l": [
        "C5"
    ],
    "tb-703g": [
        "AJ"
    ],
    "tb717g": [
        "C5"
    ],
    "s280": [
        "DX"
    ],
    "mixzo me 1025": [
        "1Z"
    ],
    "z3211g": [
        "2Z"
    ],
    "venus7": [
        "GH"
    ],
    "vega q7128": [
        "VQ"
    ],
    "bl-919845": [
        "UB"
    ],
    "iplay_30": [
        "3A"
    ],
    "p10 hd_eea": [
        "T7"
    ],
    "h170": [
        "DX"
    ],
    "p510": [
        "DX"
    ],
    "l270": [
        "DX"
    ],
    "l210": [
        "DX"
    ],
    "e210": [
        "DX"
    ],
    "turbopad1015new": [
        "5X"
    ],
    "turbopad1016new": [
        "5X"
    ],
    "turbopad723": [
        "5X"
    ],
    "turbopad 802": [
        "5X"
    ],
    "turbopad 723": [
        "5X"
    ],
    "turbopad 1014": [
        "5X"
    ],
    "turbokids princess": [
        "5T"
    ],
    "turbopad 724": [
        "5X"
    ],
    "turbopad 1015": [
        "5X"
    ],
    "turbopad803": [
        "5X"
    ],
    "turbopad 912": [
        "5X"
    ],
    "revo r77 gps": [
        "EB"
    ],
    "raptor3g8gb": [
        "N3"
    ],
    "ramosi10": [
        "RA"
    ],
    "ramosi8": [
        "RA"
    ],
    "q-pulse70m": [
        "QA"
    ],
    "q-wave101": [
        "QA"
    ],
    "q-wave71m": [
        "QA"
    ],
    "pro_q8_lte": [
        "R6"
    ],
    "pro_q10_lte": [
        "R6"
    ],
    "picopad_7h_7_3g": [
        "XA"
    ],
    "iconbit matrix ultra": [
        "I2",
        "4M"
    ],
    "colortab10 ii": [
        "B7"
    ],
    "colortab 10 ii": [
        "B7"
    ],
    "colortab 10": [
        "B7"
    ],
    "colortab_10m": [
        "B7"
    ],
    "colortab 816i": [
        "B7"
    ],
    "dslide1013qc": [
        "DA"
    ],
    "dslide714": [
        "DA"
    ],
    "dslide710": [
        "DA"
    ],
    "dslide1015": [
        "DA"
    ],
    "dslide1014": [
        "DA"
    ],
    "mpqcg10 3g": [
        "MM"
    ],
    "mpqcg10": [
        "MM"
    ],
    "mpqcg11": [
        "MM"
    ],
    "mpqcg77": [
        "MM"
    ],
    "exo_wave_i007b": [
        "EH"
    ],
    "exo_wave_i007": [
        "EH"
    ],
    "walpad_g2i": [
        "WA"
    ],
    "walpad_g2": [
        "WA"
    ],
    "walpad g3": [
        "WA"
    ],
    "walpad 10b": [
        "WA"
    ],
    "3g note xl": [
        "E0"
    ],
    "celkon_4g_tab-8": [
        "CE"
    ],
    "mito t71": [
        "8M"
    ],
    "mito_t15": [
        "8M"
    ],
    "mito_t65": [
        "8M"
    ],
    "mito_t89": [
        "8M"
    ],
    "jo-uqm10a": [
        "4V"
    ],
    "jk703 3g": [
        "J6"
    ],
    "jk702": [
        "J6"
    ],
    "jk100 v2.0": [
        "J6"
    ],
    "jk101": [
        "J6"
    ],
    "jk700 v2.0": [
        "J6"
    ],
    "krez tm1002s8 3g": [
        "5K"
    ],
    "krez tm1001s8 3g": [
        "5K"
    ],
    "bb-mobile firsttab tp-17": [
        "0B"
    ],
    "kurio10s": [
        "6K"
    ],
    "kurio7s": [
        "6K"
    ],
    "inch regulus 7.85": [
        "2H"
    ],
    "inch regulus ii": [
        "2H"
    ],
    "inch avior 3": [
        "2H"
    ],
    "inco sphere 3": [
        "6I"
    ],
    "tz871": [
        "I6"
    ],
    "tz863": [
        "I6"
    ],
    "tz862": [
        "I6"
    ],
    "tz738": [
        "I6"
    ],
    "tz736": [
        "I6"
    ],
    "tz735": [
        "I6"
    ],
    "tz732": [
        "I6"
    ],
    "tz730": [
        "I6"
    ],
    "tz713": [
        "I6"
    ],
    "tz707": [
        "I6"
    ],
    "tz702": [
        "I6"
    ],
    "tz701": [
        "I6"
    ],
    "astro_phablet_9": [
        "MW"
    ],
    "asus_w706": [
        "AU"
    ],
    "woxter nimbus115": [
        "WX"
    ],
    "woxter qx 101": [
        "WX"
    ],
    "woxter qx 101l": [
        "WX"
    ],
    "woxter qx 102": [
        "WX"
    ],
    "woxter qx 90": [
        "WX"
    ],
    "woxter qx103": [
        "WX"
    ],
    "woxter qx105": [
        "WX"
    ],
    "woxter qx105l": [
        "WX"
    ],
    "woxter qx78": [
        "WX"
    ],
    "woxter qx95": [
        "WX"
    ],
    "woxter qx120": [
        "WX"
    ],
    "woxter i-101": [
        "WX"
    ],
    "woxter nimbus1100rx": [
        "WX"
    ],
    "woxter_qx93": [
        "WX"
    ],
    "woxter qx109": [
        "WX"
    ],
    "woxter qx79": [
        "WX"
    ],
    "woxter sx100": [
        "WX"
    ],
    "woxter sx110": [
        "WX"
    ],
    "woxter qx109r": [
        "WX"
    ],
    "woxter qx85": [
        "WX"
    ],
    "woxter qx99": [
        "WX"
    ],
    "woxter sx220": [
        "WX"
    ],
    "woxter_n200": [
        "WX"
    ],
    "cobalt-t7_3g": [
        "XC"
    ],
    "cobalt t7 3g": [
        "XC"
    ],
    "cobalt_t10_3g": [
        "XC"
    ],
    "cobalt_t10_wifi": [
        "XC"
    ],
    "cobalt_t7_wifi": [
        "XC"
    ],
    "alfa_10mb": [
        "H0"
    ],
    "alfa7lm": [
        "H0"
    ],
    "aoyodkg_a38": [
        "J2"
    ],
    "fire_ii_wifi": [
        "TR"
    ],
    "kingpad_k10": [
        "VA"
    ],
    "kingpad_k10pro": [
        "VA"
    ],
    "magnet_g50": [
        "V2"
    ],
    "slate2": [
        "0W"
    ],
    "9027q": [
        "AL"
    ],
    "memopad 10fhd lte": [
        "AU"
    ],
    "ags2-w09hn": [
        "HU"
    ],
    "iku t2": [
        "8I"
    ],
    "iku t1": [
        "8I"
    ],
    "iku_t3": [
        "8I"
    ],
    "iku_t_max": [
        "8I"
    ],
    "venue 7 hspa+": [
        "DL"
    ],
    "venue 10 5050": [
        "DL"
    ],
    "ursus_9x3g": [
        "DX"
    ],
    "ursus_z380": [
        "DX"
    ],
    "vb_10q_plus": [
        "UA"
    ],
    "verykooltl8010": [
        "VL"
    ],
    "verykool t7440": [
        "VL"
    ],
    "verykoolt7445": [
        "VL"
    ],
    "vi8 plus": [
        "1C"
    ],
    "i216a": [
        "AL"
    ],
    "techno x800bj": [
        "0B"
    ],
    "supra m94bg": [
        "S5"
    ],
    "actived 8.2 3g": [
        "EX"
    ],
    "lg-v533": [
        "LG"
    ],
    "ipad7,11": [
        "AP"
    ],
    "ipad7,3": [
        "AP"
    ],
    "p1060x": [
        "MD"
    ],
    "cw-hi10 plus": [
        "1C"
    ],
    "lenovo b6000-hv": [
        "LE"
    ],
    "s410j": [
        "PH"
    ],
    "qtab v7": [
        "QM"
    ],
    "p80h_eea": [
        "T7"
    ],
    "lasertab10": [
        "Q2"
    ],
    "nomi c09600": [
        "NM"
    ],
    "ifive_mini_3gs": [
        "FW"
    ],
    "ifivex2": [
        "FW"
    ],
    "ifivemini3": [
        "FW"
    ],
    "ifive3": [
        "FW"
    ],
    "plane 8580 4g ps8199ml": [
        "D2"
    ],
    "plane_8558_4g_ps8172pl": [
        "D2"
    ],
    "plane_8549s_4g_ps8162pl": [
        "D2"
    ],
    "shield tablet": [
        "NV"
    ],
    "excer g5.6": [
        "AH"
    ],
    "alba8nou": [
        "1A"
    ],
    "xr6p10": [
        "VZ"
    ],
    "xr6m10": [
        "VZ"
    ],
    "p01y_s": [
        "AU"
    ],
    "pmp7070c3g": [
        "PR"
    ],
    "play three v3.0": [
        "PX"
    ],
    "navon_predator_7": [
        "N3"
    ],
    "plane 8733t 3g ps8145pg": [
        "D2"
    ],
    "quantum_1010_lite": [
        "GC"
    ],
    "lgt02": [
        "LG"
    ],
    "sm-t375s": [
        "SA"
    ],
    "notepad_k10": [
        "DJ"
    ],
    "notepad 102": [
        "DJ"
    ],
    "gtkids7v": [
        "GH"
    ],
    "gtkids7r": [
        "GH"
    ],
    "gtkids7b": [
        "GH"
    ],
    "mixzo me 1030 4g": [
        "1Z"
    ],
    "tecno p701": [
        "TB"
    ],
    "lenovo yb-q501f": [
        "LE"
    ],
    "lenovo yt-x705x": [
        "LE"
    ],
    "onda v989": [
        "OD"
    ],
    "kfauwi": [
        "KN"
    ],
    "sonyso-03e": [
        "SO"
    ],
    "m7s_lite": [
        "1R"
    ],
    "ifive mini 4s": [
        "FW"
    ],
    "ifive air": [
        "FW"
    ],
    "pulsar qi3g": [
        "LT",
        "EX"
    ],
    "rmd_550": [
        "R5"
    ],
    "nomi_c101040": [
        "NM"
    ],
    "lenovo yt-x705l": [
        "LE"
    ],
    "lenovo yt-x705f": [
        "LE"
    ],
    "lenovo tb-7305i": [
        "LE"
    ],
    "k017": [
        "AU"
    ],
    "k015": [
        "AU"
    ],
    "onliner4": [
        "EX"
    ],
    "lm-t605": [
        "LG"
    ],
    "lg-v400": [
        "LG"
    ],
    "lg-v410": [
        "LG"
    ],
    "lg-v480": [
        "LG"
    ],
    "lg-v495": [
        "LG"
    ],
    "lg-v496": [
        "LG"
    ],
    "lg-v497": [
        "LG"
    ],
    "teo104g": [
        "TN"
    ],
    "nomi_c080034": [
        "NM"
    ],
    "nomi_c070034": [
        "NM"
    ],
    "nomi_c070010": [
        "NM"
    ],
    "pmt1177_4g": [
        "PR"
    ],
    "nomi_c070014": [
        "NM"
    ],
    "supra m14a 3g": [
        "S5"
    ],
    "flycat unicum 8s": [
        "QC",
        "FL"
    ],
    "flycat unicum 1002": [
        "QC",
        "FL"
    ],
    "flycat unicum 8003": [
        "QC",
        "FL"
    ],
    "nomi_c080012": [
        "NM"
    ],
    "pmt3157_4g": [
        "PR"
    ],
    "ursus ns310": [
        "DX"
    ],
    "m74c 3g": [
        "S5"
    ],
    "s290": [
        "DX"
    ],
    "s370": [
        "DX"
    ],
    "s380": [
        "DX"
    ],
    "aplay 3": [
        "27"
    ],
    "aplay4": [
        "27"
    ],
    "p330x": [
        "AL"
    ],
    "lenovo tb-x306f": [
        "LE"
    ],
    "lenovo tb-7104f": [
        "LE"
    ],
    "av-10nt310": [
        "JV"
    ],
    "touch_7_3g": [
        "PX"
    ],
    "tecno p704a": [
        "TB"
    ],
    "pixus_touch_7_3g": [
        "PX"
    ],
    "wtab_714": [
        "2I"
    ],
    "wtab 805": [
        "2I"
    ],
    "winner8": [
        "EX"
    ],
    "winner7": [
        "EX"
    ],
    "livecore7032": [
        "OV"
    ],
    "lenovo tb-x306x": [
        "LE"
    ],
    "lenovo tb-j606l": [
        "LE"
    ],
    "lenovo tb-8505x": [
        "LE"
    ],
    "8082_ru": [
        "AL"
    ],
    "8068_eea": [
        "AL"
    ],
    "tla002": [
        "T7"
    ],
    "tla016": [
        "T7"
    ],
    "t1006s": [
        "3A"
    ],
    "t1006": [
        "3A"
    ],
    "c-723ultra": [
        "ZL"
    ],
    "qc-703gn": [
        "1D"
    ],
    "qc-704ga": [
        "1D"
    ],
    "qc-803gn": [
        "1D"
    ],
    "qc-1013g": [
        "1D",
        "KY"
    ],
    "qc-7bhd": [
        "1D"
    ],
    "airtab mp1011": [
        "DN"
    ],
    "airtab_mw7851": [
        "DN"
    ],
    "t102ms3g": [
        "OY"
    ],
    "finepower a3": [
        "F1"
    ],
    "x-pad style 8 3g (revision 3)": [
        "TZ"
    ],
    "kfquwi": [
        "KN"
    ],
    "kfrawi": [
        "KN"
    ],
    "cx9006": [
        "CX0"
    ],
    "x10 (m1d3)": [
        "T7"
    ],
    "10a_lte_eea": [
        "UA"
    ],
    "10_1q205": [
        "S1"
    ],
    "samsung gt-n8000/n8000xxcma1": [
        "SA"
    ],
    "gt-n8020-orange/n8020xdbma2": [
        "SA"
    ],
    "samsung gt-n8020/n8020xdbma4": [
        "SA"
    ],
    "ezee' tab 804": [
        "ST",
        "EZ"
    ],
    "htc flyer p510e": [
        "HT",
        "FL"
    ],
    "pmp7380d3g": [
        "PR"
    ],
    "bq sorbonne": [
        "BX"
    ],
    "nomi_c070020": [
        "NM"
    ],
    "pmt3618_4ge": [
        "PR"
    ],
    "pmt3118_3g": [
        "PR"
    ],
    "pmt3118_3ge": [
        "PR"
    ],
    "pmt3131_3g": [
        "PR"
    ],
    "pmt3618_4g": [
        "PR"
    ],
    "lenovo a7600": [
        "LE"
    ],
    "lenovo pb-6505mc": [
        "LE"
    ],
    "plane 8.6 3g ps8086mg": [
        "D2"
    ],
    "s670": [
        "DX"
    ],
    "peaq pet 100": [
        "PE"
    ],
    "p10s_eea": [
        "T7"
    ],
    "mi pad 4": [
        "XI"
    ],
    "r180": [
        "DX"
    ],
    "q110": [
        "DX"
    ],
    "lenovo tb-x705l": [
        "LE"
    ],
    "lenovo tb-x605l": [
        "LE"
    ],
    "lenovo tb-x505l": [
        "LE"
    ],
    "nomi_c070044": [
        "NM"
    ],
    "nomi_c101014": [
        "NM"
    ],
    "nomi_c101034": [
        "NM"
    ],
    "nomi_c101044": [
        "NM"
    ],
    "nomi_c070014l": [
        "NM"
    ],
    "nomi_c080014": [
        "NM"
    ],
    "m30_pro_row": [
        "T7"
    ],
    "ast21": [
        "AU"
    ],
    "iplay8": [
        "3A"
    ],
    "asus z101 prime": [
        "AU"
    ],
    "adronix mt104": [
        "76",
        "HT"
    ],
    "adronix mt116": [
        "76",
        "HT"
    ],
    "adronix mt232": [
        "76",
        "HT"
    ],
    "hz1012": [
        "HZ"
    ],
    "iplay30": [
        "3A"
    ],
    "km1070": [
        "KE"
    ],
    "lenovo tb-j706l": [
        "LE"
    ],
    "lenovo tb-j606f": [
        "LE"
    ],
    "lenovo tb-8505fs": [
        "LE"
    ],
    "lenovo tb-x306xa": [
        "LE"
    ],
    "p10_hd_row": [
        "T7"
    ],
    "optima 10 x702 4g ts1228pl": [
        "D2"
    ],
    "optima 7 x700 4g ts7224pl": [
        "D2"
    ],
    "optima 8 x701 4g ts8226pl": [
        "D2"
    ],
    "optima 10 a500s 3g ts1220pg": [
        "D2"
    ],
    "nb753": [
        "BV"
    ],
    "nb754": [
        "BV"
    ],
    "plane 8550s 4g ps8163pl": [
        "D2"
    ],
    "plane 1584s 3g ps1201pg": [
        "D2"
    ],
    "plane 1585s 4g ps1202pl": [
        "D2"
    ],
    "plane 7580s 4g ps7192pl": [
        "D2"
    ],
    "818 3g": [
        "50"
    ],
    "pmt1157_4g_ru": [
        "PR"
    ],
    "pmt1196_3g": [
        "PR"
    ],
    "pmt3096_3g": [
        "PR"
    ],
    "pmt3196_3g": [
        "PR"
    ],
    "bq-7082g": [
        "BX"
    ],
    "dl721-rb": [
        "DD"
    ],
    "pmt3761_3g": [
        "PR"
    ],
    "t10(e3c5)": [
        "T7"
    ],
    "m89 pro": [
        "T7"
    ],
    "sm-t555": [
        "SA"
    ],
    "lifetab e1071x": [
        "MD"
    ],
    "9013x": [
        "AL"
    ],
    "9013x_ru": [
        "AL"
    ],
    "9032x": [
        "AL"
    ],
    "9032x_ru": [
        "AL"
    ],
    "h310": [
        "DX"
    ],
    "tz200": [
        "I6"
    ],
    "lenovo tb-7304i": [
        "LE"
    ],
    "lenovo tb-7304n": [
        "LE"
    ],
    "pmt3151_3g_d_cis": [
        "PR"
    ],
    "pmt3231_4g_d_ru": [
        "PR"
    ],
    "pmt4231_4g_d_eea": [
        "PR"
    ],
    "pmt4231_4g_d_ru": [
        "PR"
    ],
    "pmt4238_4g_ru": [
        "PR"
    ],
    "x_style_tab_a104": [
        "1S"
    ],
    "x_style_tab_a83": [
        "1S"
    ],
    "a1-840": [
        "AC"
    ],
    "zt-97003g": [
        "FZ"
    ],
    "nettab_space_3g": [
        "I2"
    ],
    "megafon v9+": [
        "MP"
    ],
    "zoom-h": [
        "4M"
    ],
    "sn7014s": [
        "5Y"
    ],
    "sn7014": [
        "5Y"
    ],
    "smartbook s9q9": [
        "47"
    ],
    "smartbook sb 13": [
        "47"
    ],
    "sirocoy": [
        "6P"
    ],
    "skyvision": [
        "SW"
    ],
    "v_tab_7_lite_iii": [
        "VT"
    ],
    "744tpc plus": [
        "IE"
    ],
    "769tpc": [
        "IE"
    ],
    "766tpc": [
        "IE"
    ],
    "novo7fire": [
        "AZ"
    ],
    "novo7flame": [
        "AZ"
    ],
    "aqt100": [
        "84"
    ],
    "aqt80": [
        "84"
    ],
    "aqt82": [
        "84"
    ],
    "aosp on manta": [
        "GO"
    ],
    "btouch7_plus": [
        "4Q"
    ],
    "compumax blue": [
        "DD"
    ],
    "quantum_2_1010_mobile": [
        "GC"
    ],
    "quantum_2_700_mobile": [
        "GC"
    ],
    "quantum_2_960_mobile": [
        "GC"
    ],
    "hl810g": [
        "HA"
    ],
    "kj-ob02": [
        "K6"
    ],
    "kj-gochi": [
        "K6"
    ],
    "kj-alfark": [
        "K6"
    ],
    "next1015bap": [
        "NT"
    ],
    "supernova is3g": [
        "LT"
    ],
    "xintroni10.1": [
        "T6"
    ],
    "ct735_16gb": [
        "CF"
    ],
    "kftrpwi": [
        "KN"
    ],
    "kftrwi": [
        "KN"
    ],
    "express3": [
        "13"
    ],
    "zippers tab 10i 3g": [
        "48"
    ],
    "maven_g10": [
        "O1"
    ],
    "lavie tab e 7sd1": [
        "NE"
    ],
    "xperia tablet z lte": [
        "SO"
    ],
    "airbook pro 8s": [
        "U0"
    ],
    "mito t85": [
        "8M"
    ],
    "mito t75": [
        "8M"
    ],
    "mito_t81": [
        "8M"
    ],
    "mito t61": [
        "8M"
    ],
    "mito t59": [
        "8M"
    ],
    "move_s201": [
        "J3",
        "KE"
    ],
    "freeme x4 7": [
        "LK"
    ],
    "freeme x4 7hd": [
        "LK"
    ],
    "pace 10": [
        "O1"
    ],
    "pace10": [
        "O1"
    ],
    "pace_10_lte_v2": [
        "O1"
    ],
    "pb1009": [
        "94"
    ],
    "m10400": [
        "94"
    ],
    "m10500": [
        "94"
    ],
    "m7500": [
        "94"
    ],
    "m7600-d": [
        "94"
    ],
    "sm-t225": [
        "SA"
    ],
    "sm-t220": [
        "SA"
    ],
    "21051182g": [
        "XI"
    ],
    "lenovo tb-x6c6x": [
        "LE"
    ],
    "iplay_40h": [
        "3A"
    ],
    "sm-t735": [
        "SA"
    ],
    "sm-t515n": [
        "SA"
    ],
    "tab x8": [
        "VX"
    ],
    "m77qf6": [
        "M3"
    ],
    "km1069": [
        "KE"
    ],
    "m40_row": [
        "T7"
    ],
    "m40(n9h3)": [
        "T7"
    ],
    "hipad pro": [
        "1C"
    ],
    "pixus_sprint_2_16": [
        "PX"
    ],
    "tel-1014giq": [
        "TL"
    ],
    "t737pro": [
        "7V"
    ],
    "t10lte": [
        "W5"
    ],
    "n180i": [
        "DX"
    ],
    "n380i": [
        "DX"
    ],
    "lenovo tb-7305x": [
        "LE"
    ],
    "dl1036": [
        "DD"
    ],
    "dby-w09": [
        "HU"
    ],
    "i10_eea": [
        "Y5"
    ],
    "inoipad mini 2+32 wi-fi+3g": [
        "I4"
    ],
    "inoipad 2+32 wi-fi+3g": [
        "I4"
    ],
    "x_style_tab_a801": [
        "1S"
    ],
    "fever_plus_h": [
        "4M",
        "WI"
    ],
    "m40se_eea": [
        "T7"
    ],
    "p20hd_row": [
        "T7"
    ],
    "nomi_c101030": [
        "NM"
    ],
    "nomi_c101012": [
        "NM"
    ],
    "nomi_c070030": [
        "NM"
    ],
    "nomi_c070012": [
        "NM"
    ],
    "nomi c070011": [
        "NM"
    ],
    "lg-v520": [
        "LG"
    ],
    "e170": [
        "DX"
    ],
    "e180": [
        "DX"
    ],
    "et-108-11a": [
        "AC"
    ],
    "lenovo tb-x605fc": [
        "LE"
    ],
    "contixo kt 1100gt 4g": [
        "3C"
    ],
    "bq-7055l": [
        "BX"
    ],
    "kon_tiki2": [
        "3O"
    ],
    "m17qf6_3g": [
        "M3"
    ],
    "lenovo tb-8704f": [
        "LE"
    ],
    "rct6613w23p": [
        "RC"
    ],
    "flylife connect 7.85 3g 2": [
        "FL"
    ],
    "21051182c": [
        "XI"
    ],
    "sm-t312": [
        "SA"
    ],
    "sm-t533": [
        "SA"
    ],
    "bah3-an10": [
        "HU"
    ],
    "bzc-al00": [
        "HU"
    ],
    "bzc-w00": [
        "HU"
    ],
    "agr-w09hn": [
        "HNR"
    ],
    "ags3-w09": [
        "HU"
    ],
    "ags3-al00": [
        "HU"
    ],
    "ags3-al09hn": [
        "HU"
    ],
    "ags3-w00d": [
        "HU"
    ],
    "ags3-w00e": [
        "HU"
    ],
    "ags3-w09hn": [
        "HU"
    ],
    "bah2-w09": [
        "HU"
    ],
    "co-mate": [
        "IB"
    ],
    "druid_l10": [
        "V2"
    ],
    "runbop2-en": [
        "RU"
    ],
    "plane 1715t 4g pt1139pl": [
        "D2"
    ],
    "plane 1713t 3g pt1138mg": [
        "D2"
    ],
    "plane 1573n 4g ps1189ml": [
        "D2"
    ],
    "plane 1570n 3g ps1185mg": [
        "D2"
    ],
    "plane 1524 3g ps1136mg": [
        "D2"
    ],
    "plane 7547s 3g ps7159pg": [
        "D2"
    ],
    "plane 7561n 3g ps7176mg": [
        "D2"
    ],
    "plane 7574s 4g ps7191pl": [
        "D2"
    ],
    "plane 7700t 4g ps1127pl": [
        "D2"
    ],
    "plane_1523_3g_ps1135mg": [
        "D2"
    ],
    "plane_1526_4g_ps1138ml": [
        "D2"
    ],
    "plane_1537e_3g_ps1149mg": [
        "D2"
    ],
    "plane_1538e_4g_ps1150ml": [
        "D2"
    ],
    "plane_1550s_3g_ps1163mg": [
        "D2"
    ],
    "plane_1551s_4g_ps1164ml": [
        "D2"
    ],
    "plane_1553m_4g_ps1166ml": [
        "D2"
    ],
    "plane_7006_4g_ps7041pl": [
        "D2"
    ],
    "plane_7535e_3g_ps7147mg": [
        "D2"
    ],
    "plane_7545v_3g_ps7151mg": [
        "D2"
    ],
    "plane_7546s_3g_ps7158pg": [
        "D2"
    ],
    "plane_7547s_3g_ps7159pg": [
        "D2"
    ],
    "plane_7556_3g_ps7170mg": [
        "D2"
    ],
    "plane_9654m_3g_ps9167pg": [
        "D2"
    ],
    "plane_9634_3g_ps9146mg": [
        "D2"
    ],
    "plane_8540e_4g_ps8156ml": [
        "D2"
    ],
    "plane_8522_3g_ps8135mg": [
        "D2"
    ],
    "pmt1177_3g": [
        "PR"
    ],
    "pmt3101_4g": [
        "PR"
    ],
    "pmt3101_4gh": [
        "PR"
    ],
    "pmt3151_3g": [
        "PR"
    ],
    "pmt3157_3g": [
        "PR"
    ],
    "pmt3161_3g": [
        "PR"
    ],
    "pmt3171_3g": [
        "PR"
    ],
    "pmt3257_3g": [
        "PR"
    ],
    "pmt3257_4g": [
        "PR"
    ],
    "lg-v530": [
        "LG"
    ],
    "p310": [
        "DX"
    ],
    "p380": [
        "DX"
    ],
    "m40se_row": [
        "T7"
    ],
    "m76qf6": [
        "M3"
    ],
    "i15-tg": [
        "CU"
    ],
    "lenovo pb-6505m": [
        "LE"
    ],
    "beeline tab fast 2": [
        "B5"
    ],
    "4good people at100": [
        "4G",
        "TS"
    ],
    "4good t100m3g": [
        "4G"
    ],
    "t40 plus_eea": [
        "T7"
    ],
    "t40 plus_row": [
        "T7"
    ],
    "iplay20s": [
        "3A"
    ],
    "100015685-a": [
        "O4"
    ],
    "3g_16": [
        "TP"
    ],
    "p80h_row": [
        "T7"
    ],
    "sky 9 a102 3g ss9236pg": [
        "W8"
    ],
    "sunwind sky 7 e200 3g st7230mg": [
        "W8",
        "SE"
    ],
    "qumo_vega_803i": [
        "QO"
    ],
    "mrx-w29": [
        "HU"
    ],
    "gen-10": [
        "56"
    ],
    "h10888m": [
        "P6"
    ],
    "fever_plus_j": [
        "4M",
        "WI"
    ],
    "supra m84e 3g": [
        "S5"
    ],
    "archos 80 oxygen": [
        "AR"
    ],
    "supra m74c 4g": [
        "S5"
    ],
    "supra m12cg": [
        "S5"
    ],
    "lenovo tb-j706f": [
        "LE"
    ],
    "h1010": [
        "P6"
    ],
    "monza-t7": [
        "94"
    ],
    "optima 8 z801 4g ts8227pl": [
        "D2"
    ],
    "optima 7 z800 4g ts7225pl": [
        "D2"
    ],
    "optima 7 a101 3g tt7223pg": [
        "D2"
    ],
    "optima 7 a100s 3g ts7222pg": [
        "D2"
    ],
    "optima 10 a501s 4g ts1221pl": [
        "D2"
    ],
    "sen_1055_arm": [
        "8C"
    ],
    "mrx-w19": [
        "HU"
    ],
    "mrx-w39": [
        "HU"
    ],
    "mrx-al19": [
        "HU"
    ],
    "mrx-an19": [
        "HU"
    ],
    "mrr-w29": [
        "HU"
    ],
    "wgr-w09": [
        "HU"
    ],
    "wgr-w19": [
        "HU"
    ],
    "ginzzu gt-x890": [
        "GZ",
        "SA"
    ],
    "sm-t111nq": [
        "SA"
    ],
    "sm-t297": [
        "SA"
    ],
    "tel-73giqa": [
        "TL"
    ],
    "bdf-m107": [
        "B6"
    ],
    "tz773": [
        "I6"
    ],
    "qt19101hv": [
        "QI"
    ],
    "q210": [
        "DX"
    ],
    "scmr-w09": [
        "HU"
    ],
    "scmr-al09": [
        "HU"
    ],
    "lifetab p1071x": [
        "MD"
    ],
    "lenovo tb-8506f": [
        "LE"
    ],
    "lavie tab e 8hd1": [
        "NE"
    ],
    "ex111": [
        "DX"
    ],
    "q310": [
        "DX"
    ],
    "8088x": [
        "AL"
    ],
    "n210": [
        "DX"
    ],
    "n310": [
        "DX"
    ],
    "n370": [
        "DX"
    ],
    "n570": [
        "DX"
    ],
    "e110": [
        "DX"
    ],
    "nqt-1014giq": [
        "7Q"
    ],
    "nqt-1013giq": [
        "7Q"
    ],
    "nqt-73giq": [
        "7Q"
    ],
    "nqt-7w": [
        "7Q"
    ],
    "tel-74giq": [
        "TL"
    ],
    "taristab2": [
        "69"
    ],
    "ursus a310": [
        "DX"
    ],
    "visionbook_10q_pro": [
        "UA"
    ],
    "tbbvnc100005207": [
        "O4"
    ],
    "smart_l103_eea": [
        "IG"
    ],
    "smart_w10x_eea": [
        "IG"
    ],
    "archos 101 oxygen 4g": [
        "AR"
    ],
    "pmt7788_4g": [
        "PR"
    ],
    "pmt5791_4g": [
        "PR"
    ],
    "pmt5778_4g": [
        "PR"
    ],
    "pmt5771_4g": [
        "PR"
    ],
    "pmt5588_4g": [
        "PR"
    ],
    "rct6973w43r": [
        "RC"
    ],
    "utbook_eea": [
        "WW"
    ],
    "inoipad mini 1+16 wi-fi": [
        "I4"
    ],
    "iplay_8t": [
        "3A"
    ],
    "nokia t20": [
        "NK"
    ],
    "p80_row": [
        "T7"
    ],
    "pmt3231_4g_d_eea": [
        "PR"
    ],
    "sm-t733": [
        "SA"
    ],
    "n410": [
        "DX"
    ],
    "rq-713s": [
        "RQ"
    ],
    "aocos px102": [
        "9Y"
    ],
    "kpad": [
        "3A"
    ],
    "m40pro_eea": [
        "T7"
    ],
    "lenovo tb-j616x": [
        "LE"
    ],
    "w22pro 3g": [
        "RA"
    ],
    "l310i": [
        "DX"
    ],
    "gravity 2": [
        "FS"
    ],
    "m7-3g_qc_3": [
        "1R"
    ],
    "m9-3g": [
        "1R"
    ],
    "m7-3g_quad_core": [
        "1R"
    ],
    "geofox mid 743": [
        "G2"
    ],
    "atab1021e": [
        "AC"
    ],
    "core-t4": [
        "C1"
    ],
    "bub6r-3t": [
        "Y8"
    ],
    "archos oxygen 101s": [
        "AR"
    ],
    "lenovo tb-7305f": [
        "LE"
    ],
    "l370i": [
        "DX"
    ],
    "bq-1025l": [
        "BX"
    ],
    "p20hd_rus": [
        "T7"
    ],
    "gtkids7": [
        "GH"
    ],
    "google pixel slate": [
        "GO"
    ],
    "sunshine_t1": [
        "1J"
    ],
    "u63plus": [
        "3A"
    ],
    "smartview_7_3g": [
        "MY1"
    ],
    "smartview_8_lte": [
        "MY1"
    ],
    "smartview_9_6_3g": [
        "MY1"
    ],
    "archos 101c platinum": [
        "AR"
    ],
    "st7160": [
        "3B"
    ],
    "t505pro": [
        "7V"
    ],
    "sm-t590": [
        "SA"
    ],
    "pmt4771_4g_ru": [
        "PR"
    ],
    "pmt4208_3g_e_ru": [
        "PR"
    ],
    "pmt4208_3g_eea": [
        "PR"
    ],
    "optima 1027n 3g tt1236pg": [
        "D2"
    ],
    "archos 80d xenon": [
        "AR"
    ],
    "archos 70c xenon": [
        "AR"
    ],
    "archos 101c copper": [
        "AR"
    ],
    "archos 101b xenon v2": [
        "AR"
    ],
    "lenovo tb-x6c6f": [
        "LE"
    ],
    "100011886bk": [
        "Z2"
    ],
    "7gb1": [
        "HN"
    ],
    "7wd1": [
        "HN"
    ],
    "tz718": [
        "I6"
    ],
    "tz728": [
        "I6"
    ],
    "tz832": [
        "I6"
    ],
    "rmp2102": [
        "RE"
    ],
    "ulefone tab a7": [
        "UL"
    ],
    "m40pro_row": [
        "T7"
    ],
    "sc-2110": [
        "SU"
    ],
    "sky 9 e201 3g ss9237mg": [
        "W8"
    ],
    "nomi c10105": [
        "NM"
    ],
    "ideatab a3000-h": [
        "LE"
    ],
    "smarty mini7": [
        "3Y"
    ],
    "smarty mini 7l": [
        "3Y"
    ],
    "smarty maxi 10l": [
        "3Y"
    ],
    "nexo smart duo": [
        "7R"
    ],
    "movio 2": [
        "7R"
    ],
    "vankyo_s10_eea": [
        "VC"
    ],
    "vankyo_s8_eea": [
        "VC"
    ],
    "vankyo_s7": [
        "VC"
    ],
    "nexo evo": [
        "7R"
    ],
    "jaguar-01": [
        "8D"
    ],
    "saturn-02": [
        "8D"
    ],
    "saturn-02c": [
        "8D"
    ],
    "tiger-01": [
        "8D"
    ],
    "puma-01": [
        "8D"
    ],
    "k118_eea": [
        "67"
    ],
    "pc-te510jaw": [
        "NE"
    ],
    "pc-te410jaw": [
        "NE"
    ],
    "pc-te507jaw": [
        "NE"
    ],
    "lenovo yt-k606f": [
        "LE"
    ],
    "d-42a": [
        "LE"
    ],
    "p002": [
        "AU"
    ],
    "pc-ts508fam": [
        "NE"
    ],
    "lavie tab e 10fhd2": [
        "NE"
    ],
    "lenovo yt-j706x": [
        "LE"
    ],
    "pomdtb006": [
        "PL"
    ],
    "egq101": [
        "UE"
    ],
    "trekstor surftab b10": [
        "T6"
    ],
    "titan_10_lte": [
        "O1"
    ],
    "destiny": [
        "QD"
    ],
    "pmt7781_4g": [
        "PR"
    ],
    "pmt4667_3g_ru": [
        "PR"
    ],
    "pmt4638_3g_ru": [
        "PR"
    ],
    "pmt4327_3g_ru": [
        "PR"
    ],
    "pmt4311_3g_ru": [
        "PR"
    ],
    "pmt4137_4g": [
        "PR"
    ],
    "pmt4131_4g": [
        "PR"
    ],
    "pmt4118_3g_eea": [
        "PR"
    ],
    "pmt4117_3g_eea": [
        "PR"
    ],
    "pmt4117_3g": [
        "PR"
    ],
    "pmt4111_3g": [
        "PR"
    ],
    "pmt3878_4g": [
        "PR"
    ],
    "pmt3871_4g": [
        "PR"
    ],
    "pmt3861_4g": [
        "PR"
    ],
    "pmt3848_4g": [
        "PR"
    ],
    "pmt3831_4g": [
        "PR"
    ],
    "pmt3771_3g": [
        "PR"
    ],
    "pmt3768_3g": [
        "PR"
    ],
    "quartzt10-3": [
        "38"
    ],
    "matrix7116": [
        "50"
    ],
    "adronixminitab73g": [
        "76",
        "HT"
    ],
    "adronix x1001": [
        "76",
        "HT"
    ],
    "onix_8_3g_01": [
        "OX"
    ],
    "zt216_5": [
        "ZR"
    ],
    "ghia47458": [
        "GH"
    ],
    "xiaomi pad 5": [
        "XI"
    ],
    "sm-t560nu": [
        "SA"
    ],
    "ag_go_tab_access_2": [
        "A3"
    ],
    "ag go-tab access": [
        "A3"
    ],
    "tag tab ii": [
        "7G"
    ],
    "tag-tab-iii": [
        "7G"
    ],
    "t1001": [
        "3A"
    ],
    "maximust1001": [
        "01"
    ],
    "dunns mobile 703gdc": [
        "UD"
    ],
    "dunns at1001": [
        "UD"
    ],
    "tab x10": [
        "VX"
    ],
    "selecline 10": [
        "0U"
    ],
    "qilive 97r-2": [
        "QI"
    ],
    "qilive 79": [
        "QI"
    ],
    "qilive 101": [
        "QI"
    ],
    "mid8072": [
        "CY"
    ],
    "superion_s2_plus": [
        "CH"
    ],
    "superion_s2": [
        "CH"
    ],
    "superion radar deluxe": [
        "CH"
    ],
    "superion s1 plus dtv": [
        "CH"
    ],
    "actab721": [
        "AC"
    ],
    "acer_one_8_t2": [
        "AC"
    ],
    "cp3667at": [
        "CO"
    ],
    "wave-i101l": [
        "EH"
    ],
    "picassotab_x": [
        "10"
    ],
    "masstel_tab10_4g": [
        "2M"
    ],
    "m10splus": [
        "RD"
    ],
    "m10_4g_pro": [
        "1R"
    ],
    "vivax tpc-102 4g": [
        "V5"
    ],
    "m7_3g_a10": [
        "1R"
    ],
    "m53-52401": [
        "HA"
    ],
    "kl9878a_eea": [
        "0K"
    ],
    "ptb8r": [
        "4P"
    ],
    "q10107l-me": [
        "O8"
    ],
    "qtab1010x": [
        "VC",
        "QM"
    ],
    "t1085": [
        "PS"
    ],
    "sp3701": [
        "AD"
    ],
    "sp4701": [
        "AD"
    ],
    "sp5701": [
        "AD"
    ],
    "f104bv2_pro": [
        "5J"
    ],
    "fusion5_f104bv2": [
        "5J"
    ],
    "aidata elde 10 tablet": [
        "U7"
    ],
    "ik-1106": [
        "58"
    ],
    "ik-1025": [
        "58"
    ],
    "ik-7108": [
        "58"
    ],
    "ik-787": [
        "58"
    ],
    "ik-1028": [
        "58"
    ],
    "jdn2-al00hn": [
        "HU"
    ],
    "ira_duo": [
        "Q8"
    ],
    "lm-t600": [
        "LG"
    ],
    "iq1060m": [
        "LS"
    ],
    "lenovo tb-x606xa": [
        "LE"
    ],
    "lenovo tb-x606fa": [
        "LE"
    ],
    "lenovo tb-x605lc": [
        "LE"
    ],
    "lenovo tb-x306fa": [
        "LE"
    ],
    "lenovo tb-8705x": [
        "LE"
    ],
    "lenovo tb-8505xs": [
        "LE"
    ],
    "kingpad_k10_eea": [
        "VA"
    ],
    "etl101al": [
        "6Q"
    ],
    "imart_pro": [
        "V2"
    ],
    "flare tab pro v4.0": [
        "CH"
    ],
    "eutb_758g_tabi_argos_kids": [
        "4J"
    ],
    "rc7t3g21": [
        "RC"
    ],
    "rct6876q22n": [
        "RC"
    ],
    "rct6a06q22": [
        "RC"
    ],
    "t1-a22l": [
        "HU"
    ],
    "platinumtab10_4g_v3": [
        "Q2"
    ],
    "platinumtab10_4g_v1": [
        "Q2"
    ],
    "viva_803g": [
        "A2"
    ],
    "pedi_plus_w": [
        "O1"
    ],
    "rm-790": [
        "R5"
    ],
    "adt_1061": [
        "U7"
    ],
    "m2105k81c": [
        "XI"
    ],
    "mt01": [
        "UM"
    ],
    "hipad-air": [
        "1C"
    ],
    "hipadplus": [
        "1C"
    ],
    "lenovo yt-j706f": [
        "LE"
    ],
    "lenovo tb-j616f": [
        "LE"
    ],
    "lenovo tb-j607f": [
        "LE"
    ],
    "lenovo tb-7306x": [
        "LE"
    ],
    "lenovo tb-7306f": [
        "LE"
    ],
    "rmp2103": [
        "RE"
    ],
    "rt1": [
        "OE"
    ],
    "ipad6,12": [
        "AP"
    ],
    "adt1061": [
        "U7"
    ],
    "adt1061_1": [
        "U7"
    ],
    "m10 4g pro x": [
        "PS"
    ],
    "elite octa": [
        "SW"
    ],
    "sm-x205": [
        "SA"
    ],
    "sm-x200": [
        "SA"
    ],
    "sm-t736b": [
        "SA"
    ],
    "sm-t225n": [
        "SA"
    ],
    "ags3k-w09": [
        "HU"
    ],
    "ags3k-l09": [
        "HU"
    ],
    "agrk-w09": [
        "HU"
    ],
    "agrk-l09": [
        "HU"
    ],
    "i10plus_eea": [
        "Y5"
    ],
    "b1-790": [
        "AC"
    ],
    "b108_4g": [
        "3C"
    ],
    "hoozo mz104": [
        "HZ",
        "MR"
    ],
    "1az2p": [
        "MC"
    ],
    "1az2t": [
        "MC"
    ],
    "walpad 10p": [
        "WA"
    ],
    "wizpad_valuer_v8": [
        "6F"
    ],
    "vivax tablet tpc 802 3g": [
        "V5"
    ],
    "dc-1032": [
        "EVE"
    ],
    "everpad dc-709": [
        "EVE"
    ],
    "dc-718": [
        "EVE"
    ],
    "dc-1104": [
        "EVE"
    ],
    "v tab z1": [
        "VT"
    ],
    "x104-eea": [
        "YB"
    ],
    "y103_eea": [
        "Y9"
    ],
    "m2105k81ac": [
        "XI"
    ],
    "terra_pad_1006": [
        "WR"
    ],
    "t12-eea": [
        "6O"
    ],
    "t151-eea": [
        "6O"
    ],
    "q280": [
        "DX"
    ],
    "q180": [
        "DX"
    ],
    "p1061x": [
        "MD"
    ],
    "via_s48": [
        "R4"
    ],
    "m-mp7s4a3g": [
        "MC"
    ],
    "x_style_tab_a1010": [
        "1S"
    ],
    "kl1071z": [
        "XK"
    ],
    "kl1084": [
        "XK"
    ],
    "motione11": [
        "QV",
        "MR"
    ],
    "crane-evb": [
        "8O"
    ],
    "s2tel-q8": [
        "4O"
    ],
    "up10si36la": [
        "7F"
    ],
    "via_s48_0": [
        "R4"
    ],
    "dslide_1020": [
        "DA"
    ],
    "sm-t860x": [
        "SA"
    ],
    "sn7016": [
        "5Y"
    ],
    "nexa atlas": [
        "7X"
    ],
    "rt701": [
        "RY"
    ],
    "lenovo tb-j716f": [
        "LE"
    ],
    "agr-al09hn": [
        "HNR"
    ],
    "kob2-w09hn": [
        "HNR"
    ],
    "kjr-w09": [
        "HU"
    ],
    "krj-an00": [
        "HU"
    ],
    "mrr-w39": [
        "HU"
    ],
    "ezpad 4se": [
        "7J",
        "EZ"
    ],
    "ezpad m10": [
        "7J",
        "EZ"
    ],
    "ezpad 5se": [
        "7J",
        "EZ"
    ],
    "royole flexpai 2": [
        "RJ"
    ],
    "royole flexpai": [
        "RJ"
    ],
    "t40 pro(t1a1)": [
        "T7"
    ],
    "t40 plus(m7t3)": [
        "T7"
    ],
    "p80_g3m2": [
        "T7"
    ],
    "readboy_c18max": [
        "RB"
    ],
    "bzi-al00": [
        "HU"
    ],
    "bzt3-w09": [
        "HU"
    ],
    "bzd-w00": [
        "HU"
    ],
    "bzt3-al00": [
        "HU"
    ],
    "bzd-al00": [
        "HU"
    ],
    "iplay40": [
        "3A"
    ],
    "hitv102c": [
        "HI"
    ],
    "wgr-an19": [
        "HU"
    ],
    "agm3-w09hn": [
        "HNR"
    ],
    "agm3-al09hn": [
        "HNR"
    ],
    "readboy_c12pro": [
        "RB"
    ],
    "readboy_c5pro": [
        "RB"
    ],
    "hamlet_xzpad412w": [
        "8H"
    ],
    "ezee-tab96q10-m": [
        "ST",
        "EZ"
    ],
    "ezee_tab10o10-s": [
        "ST",
        "EZ"
    ],
    "tgw102l": [
        "C5"
    ],
    "tf10ea2": [
        "ES"
    ],
    "tgw801g": [
        "C5"
    ],
    "tgw801l": [
        "C5"
    ],
    "la_tab_105_p": [
        "LM"
    ],
    "la_tab_113": [
        "LM"
    ],
    "la_tab_115": [
        "LM"
    ],
    "sxpro": [
        "8U"
    ],
    "tab-714": [
        "MJ"
    ],
    "tangotab_364": [
        "10"
    ],
    "tangotab_9": [
        "10"
    ],
    "harrier tab from ee": [
        "E6"
    ],
    "hs_9dtb39": [
        "1H"
    ],
    "hitv101c": [
        "HI"
    ],
    "iplay8t": [
        "3A"
    ],
    "mon-al19b": [
        "HU"
    ],
    "surf1000": [
        "00"
    ],
    "t10 plus": [
        "CU"
    ],
    "a3-a20fhd": [
        "AC"
    ],
    "m7plus": [
        "RD"
    ],
    "readboy_c20pro": [
        "RB"
    ],
    "bza-l00": [
        "HU"
    ],
    "p20hd(n6h5)": [
        "T7"
    ],
    "krj-w09": [
        "HU"
    ],
    "krj2-w09": [
        "HNR"
    ],
    "krj2-an00": [
        "HNR",
        "HU"
    ],
    "brt-w09": [
        "HNR"
    ],
    "brt-an09": [
        "HNR"
    ],
    "leke pad-l06": [
        "ZJ"
    ],
    "fortius quad 7": [
        "QR"
    ],
    "coyote 1090 dvr maximus pro": [
        "QG",
        "ZM"
    ],
    "turbopadpro": [
        "5X"
    ],
    "b3-a20b": [
        "AC"
    ],
    "a101lv": [
        "LE"
    ],
    "atab721e": [
        "AC"
    ],
    "adt1012l": [
        "U7"
    ],
    "tab-a03-bs": [
        "XJ"
    ],
    "nova3color": [
        "3O"
    ],
    "dl1016": [
        "DD"
    ],
    "tab10ultra": [
        "2M"
    ],
    "sm-x906b": [
        "SA"
    ],
    "sm-x806b": [
        "SA"
    ],
    "sm-x800": [
        "SA"
    ],
    "sm-x706b": [
        "SA"
    ],
    "bah4-l09": [
        "HU"
    ],
    "9295g_ru": [
        "TC"
    ],
    "optima 10 z802 4g ts1229pl": [
        "D2"
    ],
    "lenovo tb-j606n": [
        "LE"
    ],
    "bq-9055l": [
        "BX"
    ],
    "cube-t970": [
        "CU"
    ],
    "trekstor surftab theatre s11": [
        "T6"
    ],
    "gravity 4g_2019": [
        "FS"
    ],
    "impad_p101": [
        "I3"
    ],
    "airtel airpad 7-s": [
        "7U"
    ],
    "sm-t827r4": [
        "SA"
    ],
    "bq-1081g": [
        "BX"
    ],
    "sm-x700": [
        "SA"
    ],
    "t12 3g": [
        "OY"
    ],
    "t12v 3g": [
        "OY"
    ],
    "t1270g": [
        "XZ"
    ],
    "aosp on duma": [
        "AU"
    ],
    "via_l30_0": [
        "R4"
    ],
    "surpad": [
        "1C"
    ],
    "tenplus x12": [
        "JC"
    ],
    "viva_1003g_lite": [
        "A2"
    ],
    "t2000": [
        "9F"
    ],
    "blues10": [
        "7Z"
    ],
    "hipad plus": [
        "1C"
    ],
    "sh-t01": [
        "SH"
    ],
    "lavie t11 11qhd1": [
        "NE"
    ],
    "p25_row": [
        "T7"
    ],
    "lavie t11 112k1": [
        "NE"
    ],
    "scepter 8 tablet": [
        "YQ"
    ],
    "advan t5c": [
        "A9"
    ],
    "s470": [
        "DX"
    ],
    "s570": [
        "DX"
    ],
    "s270i": [
        "DX"
    ],
    "lenovo tb-8703f": [
        "LE"
    ],
    "9296g_tr": [
        "TC"
    ],
    "9296g_eea": [
        "TC"
    ],
    "gnp21m02": [
        "GI"
    ],
    "vucapad_n20": [
        "ZC"
    ],
    "bzi-w00": [
        "HU"
    ],
    "sm-t295n": [
        "SA"
    ],
    "sm-t227u": [
        "SA"
    ],
    "etl-t850": [
        "1E"
    ],
    "eben k8s": [
        "YC"
    ],
    "huawei m2-802l": [
        "HU"
    ],
    "jdn2-al50hn": [
        "HU"
    ],
    "k101_eea": [
        "ZW"
    ],
    "sgp521": [
        "SO"
    ],
    "h10882m": [
        "P6"
    ],
    "metal_tablet_10": [
        "JZ"
    ],
    "slate 21": [
        "HP"
    ],
    "m110": [
        "DX"
    ],
    "m210": [
        "DX"
    ],
    "hotreals": [
        "JH"
    ],
    "alfa_8st": [
        "H0"
    ],
    "m10 blue max": [
        "RD"
    ],
    "t40 pro_row": [
        "T7"
    ],
    "kob2-al00hn": [
        "HNR"
    ],
    "m40(n9h1)": [
        "T7"
    ],
    "m40se(m5t3)": [
        "T7"
    ],
    "p20hd(n6h7)": [
        "T7"
    ],
    "tla001": [
        "T7"
    ],
    "bzw-al10": [
        "HU"
    ],
    "bzw-al00": [
        "HU"
    ],
    "ilium_pad_rx7": [
        "LA"
    ],
    "pomdtb005": [
        "PL"
    ],
    "sm-t230": [
        "SA"
    ],
    "hope10 pro": [
        "XT"
    ],
    "la_tab_128": [
        "LM"
    ],
    "logicom la tab 129": [
        "LM"
    ],
    "logicom la tab 127 hd": [
        "LM"
    ],
    "bdl0232pr": [
        "PL"
    ],
    "archos t96 wifi_eea": [
        "AR"
    ],
    "q11-eea": [
        "Y9"
    ],
    "sm-t387p": [
        "SA"
    ],
    "sm-p580": [
        "SA"
    ],
    "ghia_axis7p": [
        "GH"
    ],
    "lenovo tb-7304f": [
        "LE"
    ],
    "tech pad i700": [
        "TP"
    ],
    "ht1002w32": [
        "HN"
    ],
    "qw tb-9718qhd": [
        "WJ"
    ],
    "qw tb-1517d": [
        "WJ"
    ],
    "qw tb-1380qhd": [
        "WJ"
    ],
    "qw tb-1317q": [
        "WJ"
    ],
    "qw tb-7545": [
        "WJ"
    ],
    "aquarius cmp ne145": [
        "HJ",
        "IX"
    ],
    "aquarius ns220": [
        "HJ",
        "IX"
    ],
    "aquarius cmp ns55a": [
        "HJ",
        "IX"
    ],
    "aquarius cmp ns208": [
        "HJ",
        "IX"
    ],
    "tab2a7-20f": [
        "LE"
    ],
    "u27gt-c8": [
        "CU"
    ],
    "webpad_1002_02": [
        "JJ"
    ],
    "t72er3g": [
        "OY"
    ],
    "t104mbi 3g": [
        "OY"
    ],
    "surfer7773g": [
        "EX"
    ],
    "dexp ursus 10m 3g": [
        "DX"
    ],
    "kl628_hl": [
        "0K"
    ],
    "kl628ko": [
        "0K"
    ],
    "hipadx": [
        "1C"
    ],
    "m17qf7_4g": [
        "M3"
    ],
    "dslide_1021": [
        "DA"
    ],
    "dslide1013qc_v4": [
        "DA"
    ],
    "sm-x900": [
        "SA"
    ],
    "p80_eea": [
        "T7"
    ],
    "mobility3g": [
        "PL"
    ],
    "la tab 292": [
        "LM"
    ],
    "h410": [
        "DX"
    ],
    "h370": [
        "DX"
    ],
    "s770i": [
        "DX"
    ],
    "blossomb902": [
        "4W"
    ],
    "qt21101": [
        "QI"
    ],
    "teox103": [
        "TN"
    ],
    "t13-eea": [
        "6O"
    ],
    "tpc-g1010": [
        "JA"
    ],
    "k51": [
        "DX"
    ],
    "qt19101": [
        "QI"
    ],
    "l_ixir_tab_1047hd": [
        "LM"
    ],
    "l470": [
        "DX"
    ],
    "bah4-w09": [
        "HU"
    ],
    "numy_3g_talos": [
        "AZ"
    ],
    "airtab mc1011": [
        "DN"
    ],
    "aoson m96t": [
        "3N"
    ],
    "wx_na_wf": [
        "NV"
    ],
    "archos 101 helium lite": [
        "AR"
    ],
    "archos 70b helium": [
        "AR"
    ],
    "qooq-v50": [
        "UN"
    ],
    "st19101": [
        "0U"
    ],
    "archos oxygen 101s ardoiz": [
        "AR"
    ],
    "sc-01e": [
        "SA",
        "SU"
    ],
    "pa2170": [
        "VV"
    ],
    "p85_row": [
        "T7"
    ],
    "cm_tenderloin": [
        "HP"
    ],
    "digma_idsd": [
        "D2"
    ],
    "letab916": [
        "LT"
    ],
    "lifetab e1081x": [
        "MD"
    ],
    "kl4898_a50": [
        "0K"
    ],
    "k38": [
        "DX"
    ],
    "bdf-p30": [
        "B6"
    ],
    "9081x": [
        "TC"
    ],
    "surface 3": [
        "MS"
    ],
    "hz0010j": [
        "HZ"
    ],
    "7dy": [
        "MC"
    ],
    "7cy": [
        "MC"
    ],
    "7by": [
        "MC"
    ],
    "8ay": [
        "MC"
    ],
    "eda71_g": [
        "WH"
    ],
    "m7_3g": [
        "1R"
    ],
    "m10_3g": [
        "1R"
    ],
    "pmt4337_3g_ru": [
        "PR"
    ],
    "pmt3997_w_d_ru": [
        "PR"
    ],
    "pmt3104_wi_d_ru": [
        "PR"
    ],
    "pmt1157_4g_c_ru": [
        "PR"
    ],
    "pmt1107_4g_d_ru": [
        "PR"
    ],
    "sm-x808u": [
        "SA"
    ],
    "advan 1011": [
        "A9"
    ],
    "acer one 8 t4-82l": [
        "AC"
    ],
    "m10 pro lte": [
        "RD"
    ],
    "la tab stand": [
        "LM"
    ],
    "9060g": [
        "TC"
    ],
    "xp10_wifi": [
        "4X"
    ],
    "a3-a50": [
        "AC"
    ],
    "e1060x": [
        "MD"
    ],
    "ct9a03w23": [
        "UV"
    ],
    "h110": [
        "DX"
    ],
    "h210": [
        "DX"
    ],
    "t806mh": [
        "3A"
    ],
    "etl101gb": [
        "6Q"
    ],
    "a8i-q2": [
        "RD"
    ],
    "air 7.85 3g": [
        "R6"
    ],
    "art 7.85 3g": [
        "R6"
    ],
    "terra_7ow": [
        "GC"
    ],
    "terra_7ol": [
        "GC"
    ],
    "c bot tab 70": [
        "LM"
    ],
    "c bot tab 100": [
        "LM"
    ],
    "et8183gq-hm15": [
        "EU"
    ],
    "et7184gq-b15": [
        "EU"
    ],
    "et7183gq-h16": [
        "EU"
    ],
    "epic_p7": [
        "V2"
    ],
    "epic_m8": [
        "V2"
    ],
    "anry-e30": [
        "7A"
    ],
    "kingpad_sa8_eea": [
        "VA"
    ],
    "pantechp4100": [
        "PT"
    ],
    "picopad-7h": [
        "XA"
    ],
    "pluri_m7_2020": [
        "V2"
    ],
    "peaq pet 100 lte": [
        "PE"
    ],
    "maxtron genio": [
        "6X"
    ],
    "max 10": [
        "DJ"
    ],
    "maven_t10_pro": [
        "O1"
    ],
    "l70_lite": [
        "FS"
    ],
    "03_v89_jbl": [
        "XY"
    ],
    "9296g_ru": [
        "TC"
    ],
    "9296g": [
        "TC"
    ],
    "9295g": [
        "TC"
    ],
    "9080g": [
        "TC"
    ],
    "8094x": [
        "AL"
    ],
    "8092_tr": [
        "AL"
    ],
    "8092_eea": [
        "AL"
    ],
    "8091_tr": [
        "AL"
    ],
    "8091_eea": [
        "AL"
    ],
    "1bec": [
        "MC"
    ],
    "1cy": [
        "MC"
    ],
    "1az_eea": [
        "MC"
    ],
    "1dy4g": [
        "MC"
    ],
    "insys vi4-103": [
        "YI"
    ],
    "insys gu4-k147": [
        "YI"
    ],
    "rct6873w42bmf9e": [
        "RC"
    ],
    "radar deluxe 2": [
        "CH"
    ],
    "platinum103g2019": [
        "N3"
    ],
    "picopad_ggt": [
        "XA"
    ],
    "pad-7-v5": [
        "VG"
    ],
    "pad-7": [
        "VG"
    ],
    "ov-qualcore-7023-3g": [
        "OV"
    ],
    "ov-qualcore-1023-3g": [
        "OV"
    ],
    "nova_4g": [
        "IB"
    ],
    "notetab_pro": [
        "O1"
    ],
    "net_max": [
        "K2"
    ],
    "net_matrix": [
        "K2"
    ],
    "network": [
        "K2"
    ],
    "mouvetab7wifi": [
        "OR"
    ],
    "monsterpad 3g": [
        "5T"
    ],
    "sm-t580": [
        "SA"
    ],
    "sm-t515x": [
        "SA"
    ],
    "sm-t827v": [
        "SA"
    ],
    "sm-t825y": [
        "SA"
    ],
    "power m3": [
        "3A"
    ],
    "wexler_tab10q": [
        "WY"
    ],
    "wtab704-g": [
        "2I"
    ],
    "wtab704-b": [
        "2I"
    ],
    "wtab 803 mini 3g": [
        "2I"
    ],
    "wtab 803 3g": [
        "2I"
    ],
    "vivah10": [
        "A2"
    ],
    "vivah7": [
        "A2"
    ],
    "dslide1016_v2": [
        "DA"
    ],
    "archos 101 xenon lite": [
        "AR"
    ],
    "tel-74giqa": [
        "TL"
    ],
    "m40pro_rus": [
        "T7"
    ],
    "optima 10 a502 3g ts1245pg": [
        "D2",
        "I3"
    ],
    "optima 7 a102 3g ts7243pg": [
        "D2"
    ],
    "hsg1376": [
        "HE"
    ],
    "impad_p701": [
        "I3"
    ],
    "f104evii_pro": [
        "5J"
    ],
    "latabstandrb": [
        "LM"
    ],
    "h11-eea": [
        "LNM"
    ],
    "q3_eea": [
        "FAC"
    ],
    "smb-h8009": [
        "HLL"
    ],
    "n10-eea": [
        "YUM"
    ],
    "l211-eea": [
        "YUM"
    ],
    "famous_tab_10": [
        "FAM"
    ],
    "zik_w1027": [
        "ZIK"
    ],
    "ps_tab_wb01": [
        "PLU"
    ],
    "nbtb101": [
        "BRI"
    ],
    "phantom_z": [
        "VAL"
    ],
    "pixba2019": [
        "ENA"
    ],
    "qc77qps": [
        "3X"
    ],
    "actab821": [
        "AC"
    ],
    "actab1021_a": [
        "AC"
    ],
    "8dy": [
        "MC"
    ],
    "elite_octaxs": [
        "SW"
    ],
    "elite_octaplus": [
        "SW"
    ],
    "nexo-tab-7": [
        "VOL"
    ],
    "enova tab 10 lte": [
        "ENO"
    ],
    "w-109": [
        "6O"
    ],
    "neocore_n1g1": [
        "NEO"
    ],
    "tab-a03-br2": [
        "XJ"
    ],
    "ts_m103a": [
        "X6"
    ],
    "neocore e1-2": [
        "NEO"
    ],
    "jp5 inmate media device": [
        "JPA"
    ],
    "jp5s inmate media device": [
        "JPA"
    ],
    "w109": [
        "6O"
    ],
    "sm-p585m": [
        "SA"
    ],
    "ct101": [
        "CQ"
    ],
    "ct1085_32gb": [
        "CQ"
    ],
    "ctb761": [
        "CY"
    ],
    "feel_7013n": [
        "GER"
    ],
    "bntv650": [
        "BN"
    ],
    "bntv460": [
        "BN"
    ],
    "nitro phablet 7n": [
        "MW"
    ],
    "navo s": [
        "V2"
    ],
    "fast818": [
        "FAR"
    ],
    "fast810": [
        "FAR"
    ],
    "etab5": [
        "GN"
    ],
    "xgt_eea": [
        "XG"
    ],
    "xm14g": [
        "X8"
    ],
    "xpad_m9_3g": [
        "XWA"
    ],
    "x_tigi_joy7_tv": [
        "XT"
    ],
    "x_tigi_joy7_mate": [
        "XT"
    ],
    "xzpad412lte": [
        "8H"
    ],
    "plane 8713t 3g ps8106pg": [
        "D2"
    ],
    "tab 13": [
        "B2"
    ],
    "bush spira b1 8\"": [
        "B1"
    ],
    "bush spira b1 10.1\"": [
        "B1"
    ],
    "turbo-x coral ii": [
        "TR"
    ],
    "calltab10.1": [
        "TR"
    ],
    "calltab2gb10": [
        "TR"
    ],
    "calltab7inch": [
        "TR"
    ],
    "aqua_ii": [
        "TR",
        "IX"
    ],
    "earth 7.0'3g": [
        "INF"
    ],
    "earth10": [
        "INF"
    ],
    "rainbowii 3g": [
        "AZ",
        "WI"
    ],
    "rainbow 3g": [
        "AZ",
        "WI"
    ],
    "rainbowiii3g": [
        "TR",
        "WI"
    ],
    "rubikii7": [
        "TR"
    ],
    "rubik 10.1 ii": [
        "TR"
    ],
    "rubik_10_iii": [
        "TR"
    ],
    "quad-core a33 inet": [
        "TR"
    ],
    "turbo-x tablet hive vi": [
        "TR"
    ],
    "orange mouve 2": [
        "OR"
    ],
    "lanix_pad_e7": [
        "LA"
    ],
    "laika": [
        "FS"
    ],
    "ktab_1003": [
        "KW"
    ],
    "njoy_turnus_8": [
        "NJO"
    ],
    "njoy_tityos_10": [
        "NJO"
    ],
    "njoy_arcas_7": [
        "NJO"
    ],
    "neoqc4g": [
        "MAS"
    ],
    "mytab u30gt 2": [
        "CU",
        "MY1"
    ],
    "m10a_3g": [
        "1R"
    ],
    "kc770": [
        "3P"
    ],
    "archos t 101 4g": [
        "AR"
    ],
    "viva_h801_lte": [
        "A2"
    ],
    "ipad8,5": [
        "AP"
    ],
    "myt5 dtv": [
        "MY"
    ],
    "myt3 dtv": [
        "MY"
    ],
    "mygpad m1782": [
        "MYG"
    ],
    "mygpad m1781": [
        "MYG"
    ],
    "mygpad m1712": [
        "MYG"
    ],
    "ml-wi-m7_3g_plus": [
        "1R"
    ],
    "mf716+": [
        "M3"
    ],
    "mf716": [
        "M3"
    ],
    "m10a-lite": [
        "1R"
    ],
    "citi kids 81 cs8233mg": [
        "D2"
    ],
    "octa-t700m-t2": [
        "QE"
    ],
    "pro 1600e 4g rs1248pl": [
        "D2"
    ],
    "pro 1400e 4g rs1253pl": [
        "D2"
    ],
    "neocore_e2": [
        "NEO"
    ],
    "9032t": [
        "AL"
    ],
    "q3pro": [
        "FAC"
    ],
    "mt-t800": [
        "MOX"
    ],
    "x10mt16": [
        "X8"
    ],
    "1hy4g": [
        "MC"
    ],
    "core-t5": [
        "C1"
    ],
    "100011886a": [
        "O4"
    ],
    "100044018g": [
        "O4"
    ],
    "9013t": [
        "AL"
    ],
    "8094t_eea": [
        "AL"
    ],
    "9309x": [
        "AL"
    ],
    "acrux": [
        "CEI"
    ],
    "bellatrix": [
        "CEI"
    ],
    "btpc-1022qc3g-tv": [
        "BRG"
    ],
    "c15100m": [
        "6K"
    ],
    "c70w": [
        "CWO"
    ],
    "100015685-e": [
        "O4"
    ],
    "tp7a4": [
        "4P"
    ],
    "wm1001": [
        "WEC"
    ],
    "ent11qf12": [
        "ENT"
    ],
    "sgin_x10": [
        "SGI"
    ],
    "rmp2107": [
        "RE"
    ],
    "t21-eea": [
        "6O"
    ],
    "t22-eea": [
        "6O"
    ],
    "r8l5t": [
        "O5"
    ],
    "azupik": [
        "AZU"
    ],
    "cm822": [
        "CIA"
    ],
    "cm522": [
        "CIA"
    ],
    "eut110-11a": [
        "AC"
    ],
    "lw788": [
        "LW1"
    ],
    "m1045w": [
        "ENA"
    ],
    "pcb-t104": [
        "PB"
    ],
    "v100m4l": [
        "PRT"
    ],
    "9309x2_eea": [
        "TC"
    ],
    "9198s": [
        "TC"
    ],
    "9132s": [
        "TC"
    ],
    "9460g": [
        "TC"
    ],
    "9183w": [
        "TC"
    ],
    "ancel801": [
        "ANL"
    ],
    "zkempler_pro": [
        "KS"
    ],
    "mintaka": [
        "HA"
    ],
    "8ey": [
        "MC"
    ],
    "cnm6762": [
        "CNM"
    ],
    "ocean k8": [
        "OLA"
    ],
    "vivax_tpc-105_4g": [
        "V5"
    ],
    "kidiby": [
        "KID"
    ],
    "tikeasy 10d": [
        "AR"
    ],
    "pr5860": [
        "AD"
    ],
    "elite10qh": [
        "VIL"
    ],
    "creapad_1005_eea": [
        "WW"
    ],
    "f105d_128": [
        "5J"
    ],
    "9006w": [
        "AL"
    ],
    "9015b": [
        "AL"
    ],
    "9024w": [
        "AL"
    ],
    "9025q": [
        "AL"
    ],
    "10wb2": [
        "HN"
    ],
    "10la1": [
        "HN"
    ],
    "smooth 8gt": [
        "HH"
    ],
    "nqt-1013giq11": [
        "7Q"
    ],
    "e0111": [
        "EVR"
    ],
    "e0113": [
        "EVR"
    ],
    "e0114": [
        "EVR"
    ],
    "e0116": [
        "EVR"
    ],
    "e0117": [
        "EVR"
    ],
    "ptb10r": [
        "4P"
    ],
    "4104116n": [
        "GH"
    ],
    "ift1018": [
        "IFT"
    ],
    "bzi-w20": [
        "HU"
    ],
    "oysters t72x 3g": [
        "OY"
    ],
    "tq700": [
        "GC"
    ],
    "tpc-xte8": [
        "JA"
    ],
    "tpc-x10k": [
        "JA"
    ],
    "tpc-pa10.1m": [
        "JA"
    ],
    "tpc-755n": [
        "JA"
    ],
    "tpc-71213g": [
        "V5"
    ],
    "tp10a1i": [
        "4P"
    ],
    "symtab60": [
        "SM"
    ],
    "symtab25": [
        "SM"
    ],
    "techpad_10z": [
        "TP"
    ],
    "sn10016": [
        "5Y"
    ],
    "alfa_8rx": [
        "H0"
    ],
    "alfa_10rx": [
        "H0"
    ],
    "9029w": [
        "AL"
    ],
    "u55gt_c8": [
        "CU"
    ],
    "u51gt-sl": [
        "CU"
    ],
    "u31gt": [
        "CU"
    ],
    "u27gtw": [
        "CU"
    ],
    "alfa_10bs": [
        "H0"
    ],
    "smart_w8x": [
        "IG"
    ],
    "silverstone-t10": [
        "94"
    ],
    "s10_row": [
        "VC"
    ],
    "ta2c-m8": [
        "9Q"
    ],
    "szj-js202": [
        "KY"
    ],
    "szj-js201": [
        "KY"
    ],
    "iplay_20p": [
        "3A"
    ],
    "pmt3718_3g": [
        "PR"
    ],
    "pmt3708_3g": [
        "PR"
    ],
    "pmt3637_4g": [
        "PR"
    ],
    "pmt3537_4g": [
        "PR"
    ],
    "pmt3437_4g": [
        "PR"
    ],
    "pmt3427_3g": [
        "PR"
    ],
    "pmt3327_3g": [
        "PR"
    ],
    "pmt3317_3g": [
        "PR"
    ],
    "pmt3301_4g": [
        "PR"
    ],
    "8491x_tr": [
        "TC"
    ],
    "tel-73giqa11": [
        "TL"
    ],
    "ts-m105g-1": [
        "X6"
    ],
    "silver pos": [
        "PR"
    ],
    "k41": [
        "DX"
    ],
    "k31": [
        "DX"
    ],
    "k48": [
        "DX"
    ],
    "lenovo tb-j607z": [
        "LE"
    ],
    "i11_eea": [
        "Y5"
    ],
    "i11": [
        "Y5"
    ],
    "alfa10tx": [
        "H0"
    ],
    "ht1003x16": [
        "HN"
    ],
    "ht1002w16": [
        "HN"
    ],
    "ht0703k16": [
        "HN"
    ],
    "breeze iv": [
        "TR"
    ],
    "iball slide cleo s9": [
        "IB"
    ],
    "insignia_lab": [
        "TQ",
        "GC"
    ],
    "insignia_delta3": [
        "TQ",
        "GC"
    ],
    "hero10rk": [
        "TN"
    ],
    "winnovot2": [
        "W5"
    ],
    "actab1022": [
        "AC"
    ],
    "alfa_8sl": [
        "H0"
    ],
    "vector_slim": [
        "GH"
    ],
    "wave i007kids": [
        "EH"
    ],
    "wave i007t": [
        "EH"
    ],
    "x1060x": [
        "MD"
    ],
    "sky vision2": [
        "SW"
    ],
    "smartabs4": [
        "80"
    ],
    "supernova_i216": [
        "LT"
    ],
    "t71_w": [
        "LV"
    ],
    "iraw7258": [
        "Q8"
    ],
    "iqs801": [
        "LS"
    ],
    "iq1017": [
        "LS",
        "FL"
    ],
    "google pixelbook": [
        "GO"
    ],
    "gtabpnd": [
        "GH"
    ],
    "gtabkids": [
        "GH"
    ],
    "spteo10bk16": [
        "TN"
    ],
    "lenovo tb-9707f": [
        "LE"
    ],
    "goal_10_plus_3g": [
        "O1",
        "WI"
    ],
    "smart_w202": [
        "IG"
    ],
    "dream_edition_c-754": [
        "C8"
    ],
    "606hw": [
        "HU"
    ],
    "smart_l104_eea": [
        "IG"
    ],
    "supra m14cg": [
        "S5"
    ],
    "supra m84eg": [
        "S5"
    ],
    "sxpro_classic": [
        "8U"
    ],
    "10c_lte": [
        "UA"
    ],
    "optima prime 5 3g ts7198pg": [
        "D2"
    ],
    "optima kids 7 ts7203rw": [
        "D2"
    ],
    "noa_m108k": [
        "N5"
    ],
    "noa_p497": [
        "N5"
    ],
    "optima 1028 3g ts1215pg": [
        "D2"
    ],
    "optima_8027_3g_ts8211pg": [
        "D2"
    ],
    "proton_neon": [
        "XV"
    ],
    "blacktab7_3g_v2": [
        "Q2"
    ],
    "lp t70 lite": [
        "LL"
    ],
    "hope10 plus": [
        "XT"
    ],
    "via_s30_0": [
        "R4"
    ],
    "lenovo tb125fu": [
        "LE"
    ],
    "sm-t738u": [
        "SA"
    ],
    "10lb1": [
        "HN"
    ],
    "1iy4g": [
        "MC"
    ],
    "1az2tw": [
        "MC"
    ],
    "9032x_eea": [
        "AL"
    ],
    "alba10q": [
        "1A"
    ],
    "rmp2105": [
        "RE"
    ],
    "rmp2106": [
        "RE"
    ],
    "9060x": [
        "TC"
    ],
    "9032x_tr": [
        "AL"
    ],
    "9013x_eea": [
        "AL"
    ],
    "picassotab_xl": [
        "10"
    ],
    "masstel tab10 wifi": [
        "2M"
    ],
    "tab_912_4g": [
        "MJ"
    ],
    "leapad 7pro": [
        "L5"
    ],
    "algiz_rt8": [
        "HAN"
    ],
    "h10_one": [
        "HDC"
    ],
    "vi108": [
        "VIC"
    ],
    "vi106": [
        "VIC"
    ],
    "vi86": [
        "VIC"
    ],
    "my mobile 708": [
        "MYM"
    ],
    "blacktab7": [
        "Q2"
    ],
    "tpc-g109": [
        "JA"
    ],
    "zpad_1": [
        "0Z"
    ],
    "deimos 7": [
        "NJO"
    ],
    "samsung sm-t355": [
        "SA"
    ],
    "rc0727h": [
        "3Q"
    ],
    "8c_lte": [
        "UA"
    ],
    "ix701": [
        "IXT"
    ],
    "smart_l206": [
        "IG"
    ],
    "smart_w203": [
        "IG"
    ],
    "smart_w20x": [
        "IG"
    ],
    "10l-plus": [
        "UA"
    ],
    "7a_3g": [
        "UA"
    ],
    "9317x1": [
        "TC"
    ],
    "concord_range_hs": [
        "C8"
    ],
    "redway10_lite": [
        "REW"
    ],
    "sm-x706n": [
        "SA"
    ],
    "9296q": [
        "TC"
    ],
    "tab8": [
        "B2"
    ],
    "tab9": [
        "B2"
    ],
    "tz199": [
        "I6"
    ],
    "tab_3g_7-1": [
        "VX"
    ],
    "k18": [
        "DX"
    ],
    "k21": [
        "DX"
    ],
    "h270": [
        "DX"
    ],
    "m107_9863a_64_q": [
        "B6"
    ],
    "pmt4891_4g_eea": [
        "PR"
    ],
    "pmt4791_4g_ru": [
        "PR"
    ],
    "pmt4238_4g_eea": [
        "PR"
    ],
    "dl9003": [
        "DD"
    ],
    "base10_3g_silver": [
        "CJ"
    ],
    "ax503": [
        "A2",
        "BM"
    ],
    "a7_wf": [
        "GH"
    ],
    "81v": [
        "VUE"
    ],
    "816x": [
        "TP"
    ],
    "770g": [
        "TOU"
    ],
    "770n": [
        "TOU"
    ],
    "10edge": [
        "MC"
    ],
    "jr-j71": [
        "JR1"
    ],
    "m7_wifi": [
        "1R"
    ],
    "light_at200": [
        "4G"
    ],
    "i15-tc": [
        "CU"
    ],
    "ilium_pad_rx10v5": [
        "LA"
    ],
    "tibuta_masterpad-e100": [
        "TIB"
    ],
    "ex7w1 plus": [
        "EF"
    ],
    "p10se_eea": [
        "T7"
    ],
    "atlantis_a10_g403": [
        "BP"
    ],
    "at8b": [
        "E9"
    ],
    "fusion aura 3s": [
        "CH",
        "O1"
    ],
    "fz703": [
        "AK"
    ],
    "fz701": [
        "AK"
    ],
    "fire_v7": [
        "ODP"
    ],
    "ghia_vector_3g": [
        "GH"
    ],
    "ghia_axis7_3g": [
        "GH"
    ],
    "piranha pro ii tab 7.0": [
        "PIR"
    ],
    "s170i": [
        "DX"
    ],
    "sencor_10_1q102": [
        "S1"
    ],
    "l110": [
        "DX"
    ],
    "l170": [
        "DX"
    ],
    "l180": [
        "DX"
    ],
    "lg-p530l": [
        "LG"
    ],
    "m7go_2019": [
        "RD"
    ],
    "m7s_plus": [
        "1R"
    ],
    "archos 101 magnus": [
        "AR"
    ],
    "archos 101 copper": [
        "AR"
    ],
    "archos 101 xenon v2": [
        "AR"
    ],
    "archos 101b copper": [
        "AR"
    ],
    "archos 101b platinium": [
        "AR"
    ],
    "archos 101c neon": [
        "AR",
        "JG"
    ],
    "archos 101c xenon": [
        "AR"
    ],
    "archos 101d neon": [
        "AR",
        "JG"
    ],
    "archos 70 copper": [
        "AR"
    ],
    "archos 70b copper": [
        "AR"
    ],
    "archos 70b xenon": [
        "AR"
    ],
    "archos 80b xenon": [
        "AR"
    ],
    "archos 90 copper": [
        "AR"
    ],
    "archos 90b copper": [
        "AR"
    ],
    "archos 90b neon": [
        "AR",
        "JG"
    ],
    "archos 96 xenon": [
        "AR"
    ],
    "ml-wi-m9-3g": [
        "1R"
    ],
    "1100as": [
        "TOU"
    ],
    "archos access 70 3g": [
        "AR"
    ],
    "kj-ac02": [
        "K6"
    ],
    "kj_alfark": [
        "K6"
    ],
    "optima 1026n 3g tt1192pg": [
        "D2"
    ],
    "plane_1525_3g_ps1137mg": [
        "D2"
    ],
    "lenovo tb128fu": [
        "LE"
    ],
    "rmp2108": [
        "RE"
    ],
    "r103": [
        "3N"
    ],
    "r70a": [
        "E9"
    ],
    "reeder_m7_go": [
        "RD"
    ],
    "p80x": [
        "T7"
    ],
    "s20_eea": [
        "VC"
    ],
    "z4_eea": [
        "VC"
    ],
    "zt216_1": [
        "ZR"
    ],
    "zt216_2": [
        "ZR"
    ],
    "honor v6 wi-fi": [
        "HU"
    ],
    "honor v6 5g": [
        "HU"
    ],
    "kobe3-l09": [
        "HU"
    ],
    "ht0701w16": [
        "HN"
    ],
    "sm-x806n": [
        "SA"
    ],
    "sunshine_t1_elite": [
        "1J"
    ],
    "smile_x": [
        "3A"
    ],
    "net_k7": [
        "K2"
    ],
    "sm-p585n0": [
        "SA"
    ],
    "sm-p585y": [
        "SA"
    ],
    "taq_10g": [
        "DE"
    ],
    "taq-10": [
        "DE"
    ],
    "taq-102": [
        "DE"
    ],
    "taq-70": [
        "DE"
    ],
    "taq-90": [
        "DE"
    ],
    "taq_104_eea": [
        "DE"
    ],
    "taristab4": [
        "69"
    ],
    "orange_tab_7_4g": [
        "OR"
    ],
    "ov-qualcore 1023 3g": [
        "OV"
    ],
    "ov-qualcore_1023_3g": [
        "OV"
    ],
    "optima 1023n 3g ts1186mg": [
        "D2"
    ],
    "optima 1022n 3g ts1184mg": [
        "D2"
    ],
    "optima 1024n 4g tt1188pl": [
        "D2"
    ],
    "optima 1025n 4g ts1190ml": [
        "D2"
    ],
    "optima 7016n 3g ts7175mg": [
        "D2"
    ],
    "optima 7017n 3g ts7177mg": [
        "D2"
    ],
    "optima 7018n 4g ts7179ml": [
        "D2"
    ],
    "k3102 wifi": [
        "2I"
    ],
    "kil-82wfdc": [
        "CEI"
    ],
    "kj_ob02": [
        "K6"
    ],
    "kj_ob03": [
        "K6"
    ],
    "kj_yubi": [
        "K6"
    ],
    "kj_yu_bi": [
        "K6"
    ],
    "kl3669_eea": [
        "0K"
    ],
    "kl4890": [
        "0K"
    ],
    "kl4898": [
        "0K"
    ],
    "kl6889": [
        "0K"
    ],
    "kl7590": [
        "0K"
    ],
    "kl7591": [
        "0K"
    ],
    "kl988": [
        "0K"
    ],
    "kova_pcb-t730": [
        "PB"
    ],
    "kova-pcb-t730": [
        "PB"
    ],
    "kova_plus_pcb_t735": [
        "PB"
    ],
    "optima 1315t 4g tt1108ml": [
        "D2"
    ],
    "optima 1100 3g tt1046pg": [
        "D2"
    ],
    "optima 10 e600 3g ts1246pg": [
        "D2"
    ],
    "c81w_eea": [
        "WEE"
    ],
    "light at300": [
        "4G",
        "TS"
    ],
    "plane 7563n 4g ps7178ml": [
        "D2"
    ],
    "plane 7565n 3g ps7180pg": [
        "D2"
    ],
    "plane 8021n 4g ps8183ml": [
        "D2"
    ],
    "plane 8522 3g ps8135mg": [
        "D2"
    ],
    "masstel tab 10a": [
        "2M"
    ],
    "kingpad_m10": [
        "VA"
    ],
    "elite octamax": [
        "SW"
    ],
    "tab_911_3g": [
        "MJ"
    ],
    "tab_811_4g": [
        "MJ"
    ],
    "tangotab_x": [
        "10"
    ],
    "hihi-41kh-tab-1-eea": [
        "HIH"
    ],
    "hihi-40kh-tab-01": [
        "HIH"
    ],
    "d-01h": [
        "HU"
    ],
    "tb328fu": [
        "LE"
    ],
    "t101_2021": [
        "HUG"
    ],
    "jt08-x1": [
        "GEA"
    ],
    "jt10-90": [
        "GEA"
    ],
    "jt10-81b": [
        "GEA"
    ],
    "b21": [
        "DX"
    ],
    "b18": [
        "DX"
    ],
    "b17": [
        "DX"
    ],
    "b31": [
        "DX"
    ],
    "b38": [
        "DX"
    ],
    "cp20": [
        "COO"
    ],
    "i7a": [
        "A9"
    ],
    "viva_h701_lte_cz": [
        "A2"
    ],
    "archos hello 7": [
        "AR"
    ],
    "sot21": [
        "SO"
    ],
    "tab 11": [
        "B2"
    ],
    "tab 6": [
        "B2"
    ],
    "tab 6 kids": [
        "B2"
    ],
    "tab 10": [
        "B2"
    ],
    "superion tab pro": [
        "CH"
    ],
    "moto tab g70 lte": [
        "MR"
    ],
    "m10_lite": [
        "PRI"
    ],
    "m10_air_eea": [
        "PRI"
    ],
    "m10_plus_eea": [
        "PRI"
    ],
    "km0701": [
        "KE"
    ],
    "km0804": [
        "KE"
    ],
    "km0805": [
        "KE"
    ],
    "kbook7m": [
        "KL"
    ],
    "fever_plus": [
        "4M",
        "WI"
    ],
    "archos 70 neon plus": [
        "AR",
        "X1",
        "JG"
    ],
    "ultra 4 tab 9.0": [
        "PIR"
    ],
    "ultra 5 tab white": [
        "PIR"
    ],
    "ursus z280": [
        "DX"
    ],
    "excer g5.2": [
        "AH"
    ],
    "ex1080": [
        "IN2"
    ],
    "10wb1": [
        "HN"
    ],
    "g7060": [
        "5I"
    ],
    "g7100": [
        "5I"
    ],
    "g8060": [
        "5I"
    ],
    "b11": [
        "DX"
    ],
    "sm-x906n": [
        "SA"
    ],
    "c37": [
        "DX"
    ],
    "flow 7": [
        "FS"
    ],
    "gravity 3g": [
        "FS"
    ],
    "gravity pro": [
        "FS"
    ],
    "acer one 7 4g": [
        "AC"
    ],
    "ace10": [
        "VEN"
    ],
    "e7224hg": [
        "EV"
    ],
    "lp_t70": [
        "LL"
    ],
    "picassotab_9": [
        "10"
    ],
    "pmt4991_4g": [
        "PR"
    ],
    "s30_eea": [
        "VC"
    ],
    "s770": [
        "DX"
    ],
    "lomonosov": [
        "3O"
    ],
    "poke2color": [
        "3O"
    ],
    "turbokids3gnew": [
        "5T"
    ],
    "8491x_ru": [
        "TC"
    ],
    "sm-t736n": [
        "SA"
    ],
    "sm-t225c": [
        "SA"
    ],
    "qumo altair 701": [
        "QO"
    ],
    "opd2102a": [
        "OP"
    ],
    "tx201la": [
        "AU",
        "PT"
    ],
    "mipad 3": [
        "XI"
    ],
    "u25gt-c4yt": [
        "CU"
    ],
    "dt07-tab4g": [
        "DTE"
    ],
    "tpm4g_wt8": [
        "M7"
    ],
    "ml-so-m9-3g": [
        "1R"
    ],
    "mlx8": [
        "1R"
    ],
    "c-701 ultra": [
        "ZL"
    ],
    "c-703ultra": [
        "ZL"
    ],
    "droidz duo": [
        "TOR",
        "MR"
    ],
    "droidz dash": [
        "TOR",
        "MR"
    ],
    "droidz push i": [
        "TOR",
        "MR"
    ],
    "droidz edge+": [
        "TOR",
        "MR"
    ],
    "e1c pro": [
        "A9"
    ],
    "droidz duo slim": [
        "TOR",
        "MR"
    ],
    "droidz dash x": [
        "TOR",
        "MR"
    ],
    "droidz portal": [
        "TOR",
        "MR"
    ],
    "droidz portal x": [
        "TOR",
        "MR"
    ],
    "easy_nav_2": [
        "SM"
    ],
    "hsg1351": [
        "HE"
    ],
    "kali_8": [
        "NJO"
    ],
    "kidslegacytabpro": [
        "ZIN"
    ],
    "vsi7q_1": [
        "VS"
    ],
    "wv8-m": [
        "LB"
    ],
    "logikids4": [
        "LM"
    ],
    "midb1048phe": [
        "PL"
    ],
    "midi109pde": [
        "PL"
    ],
    "midi156pde": [
        "PL"
    ],
    "tm-mid870sb": [
        "T8"
    ],
    "signature-s8": [
        "DAN"
    ],
    "xoro megapad3204v5": [
        "XR"
    ],
    "ollee008twoa": [
        "OLL"
    ],
    "nxa8lte116": [
        "NT"
    ],
    "nxa116qc164": [
        "NT"
    ],
    "nxa101lte116": [
        "NT"
    ],
    "alfa_8mg": [
        "H0"
    ],
    "alfa_10yc": [
        "H0"
    ],
    "o+ stream hdtv": [
        "O3"
    ],
    "o+ fab go": [
        "O3"
    ],
    "obook20_plus": [
        "OD"
    ],
    "obook20 plus": [
        "OD"
    ],
    "obook 20 dualos": [
        "OD"
    ],
    "obook 20 plus": [
        "OD"
    ],
    "ninetec ultratab 10 pro": [
        "NIN"
    ],
    "ninetec platinum 10 g3": [
        "NIN"
    ],
    "nasco tango 7": [
        "NAS"
    ],
    "f104evii_eea": [
        "5J"
    ],
    "mega7": [
        "IP"
    ],
    "h1003_lte_pro1": [
        "A2"
    ],
    "h1003_lte_pro3": [
        "A2"
    ],
    "h1004_lte": [
        "A2"
    ],
    "discovery 108c": [
        "BP"
    ],
    "discovery 102c": [
        "BP"
    ],
    "revolution a8": [
        "IMU"
    ],
    "ct1005": [
        "CF"
    ],
    "masstel tab10": [
        "2M"
    ],
    "masstel tab7": [
        "2M"
    ],
    "masstel tab 860": [
        "2M"
    ],
    "masstel tab 712": [
        "2M"
    ],
    "masstel tab 1100": [
        "2M"
    ],
    "masstel tab 706": [
        "2M"
    ],
    "masstel tab 710": [
        "2M"
    ],
    "masstel tab 805": [
        "2M"
    ],
    "masstel tab 815": [
        "2M"
    ],
    "masstel tab 715": [
        "2M"
    ],
    "maia pad plus": [
        "CH"
    ],
    "pmt5718_4g": [
        "PR"
    ],
    "lenovo a5500-hv": [
        "LE"
    ],
    "gravity se": [
        "FS"
    ],
    "space_one10": [
        "O1"
    ],
    "p30air_row": [
        "T7"
    ],
    "sm-t737": [
        "SA"
    ],
    "aosp on santos103g": [
        "SA"
    ],
    "archos 101 platinum 3g": [
        "AR"
    ],
    "t40pro": [
        "T7"
    ],
    "m40air_eea": [
        "T7"
    ],
    "e1014hg": [
        "EV"
    ],
    "e-tab5": [
        "GN"
    ],
    "e-boda revo r76 gps": [
        "EB"
    ],
    "e-boda izzycomm z80": [
        "EB"
    ],
    "e-board-mx055": [
        "CHG"
    ],
    "e-board mx054": [
        "CHG"
    ],
    "dx765 pro": [
        "KC"
    ],
    "dual c981hd": [
        "TP"
    ],
    "dtb-7168g": [
        "DLI"
    ],
    "asus xpad 10lte": [
        "AU"
    ],
    "hmw-w09": [
        "HU"
    ],
    "lenovo tb-q706f": [
        "LE"
    ],
    "sm-t377v": [
        "SA"
    ],
    "lenovo yt-x703f": [
        "LE"
    ],
    "lenovo yb1-x90l": [
        "LE"
    ],
    "lenovo yb1-x90f": [
        "LE"
    ],
    "lenovo tb-8x04f": [
        "LE"
    ],
    "lenovo tb-8504l": [
        "LE"
    ],
    "pomelo-max+": [
        "ODP"
    ],
    "zte-k88": [
        "ZT"
    ],
    "zte-k92": [
        "ZT"
    ],
    "xelio_hd10": [
        "O1"
    ],
    "xelio_hd10_lte": [
        "O1"
    ],
    "xavy g7": [
        "V2"
    ],
    "dt0705w08": [
        "DEN"
    ],
    "dx_ta_7001": [
        "DIN"
    ],
    "dx_tasl83": [
        "DIN"
    ],
    "e-tel-q4": [
        "E8"
    ],
    "engage7+": [
        "18"
    ],
    "ypadp702": [
        "YOO"
    ],
    "ypadp701": [
        "YOO"
    ],
    "marshal me-700a": [
        "MAR"
    ],
    "marshal-me-617": [
        "MAR"
    ],
    "marshal-me-720": [
        "MAR"
    ],
    "iris_pad_g8020": [
        "5I"
    ],
    "everypad2": [
        "LE"
    ],
    "bengal_6": [
        "GOL"
    ],
    "fleet_7": [
        "FA1"
    ],
    "fxt113r": [
        "1F"
    ],
    "itp-xd80l": [
        "INA"
    ],
    "iplay10": [
        "3A"
    ],
    "edison 3": [
        "BX"
    ],
    "edison 3 3g": [
        "BX"
    ],
    "fast7 3g": [
        "00"
    ],
    "fast73g": [
        "00"
    ],
    "hey-w09": [
        "HNR"
    ],
    "sm-t735n": [
        "SA"
    ],
    "opd2102": [
        "OP"
    ],
    "got-al09": [
        "HU"
    ],
    "sm-p613": [
        "SA"
    ],
    "novaairc": [
        "3O"
    ],
    "novatab_r10": [
        "RIZ"
    ],
    "gt1001": [
        "56"
    ],
    "noteair2p": [
        "3O"
    ],
    "noteair2": [
        "3O"
    ],
    "i10_pro": [
        "Y5"
    ],
    "k61": [
        "DX"
    ],
    "d11": [
        "DX"
    ],
    "d21": [
        "DX"
    ],
    "up10_sh36lag": [
        "7F"
    ],
    "t40 pro_eea": [
        "T7"
    ],
    "up918": [
        "7F"
    ],
    "up778": [
        "7F"
    ],
    "up768": [
        "7F"
    ],
    "up1018": [
        "7F"
    ],
    "ax4nano_plus": [
        "A2"
    ],
    "tel-1014giqa": [
        "TL"
    ],
    "etw101gt": [
        "6Q"
    ],
    "azimut 3 lite": [
        "MC"
    ],
    "8094x_eea": [
        "AL"
    ],
    "qc7704gm": [
        "1D"
    ],
    "hipadpro": [
        "1C"
    ],
    "got-w29": [
        "HU"
    ],
    "tbook 16 pro(e6c1)": [
        "T7"
    ],
    "tbook 10 s(e6n7)": [
        "T7"
    ],
    "ama a703": [
        "AMA"
    ],
    "monsterpad7": [
        "1T"
    ],
    "v_tab_7810": [
        "VT"
    ],
    "ama_a703": [
        "AMA"
    ],
    "k28": [
        "DX"
    ],
    "t21": [
        "DX"
    ],
    "huawei m2-803l": [
        "HU"
    ],
    "huawei m2-801w": [
        "HU"
    ],
    "b28": [
        "DX"
    ],
    "b27": [
        "DX"
    ],
    "tab 10 pro": [
        "B2"
    ],
    "p410": [
        "DX"
    ],
    "t500 3g": [
        "7V"
    ],
    "t74mri3g": [
        "OY"
    ],
    "supra m728g": [
        "S5"
    ],
    "plane 7006 4g ps7041ml": [
        "D2"
    ],
    "kob2-l03": [
        "HU"
    ],
    "zpad-x8-pro": [
        "ZIN"
    ],
    "okt1": [
        "OE"
    ],
    "tab-p10232-3g": [
        "PV"
    ],
    "brace-x1": [
        "IB"
    ],
    "monster 4gxx": [
        "DAN"
    ],
    "sm-p619": [
        "SA"
    ],
    "ursus 10ev": [
        "DX"
    ],
    "ultima 8 twist": [
        "WY"
    ],
    "ultima 7 twist": [
        "WY"
    ],
    "ultima 7 octa": [
        "WY"
    ],
    "ultima 7": [
        "WY"
    ],
    "ue pad 1": [
        "UE1"
    ],
    "iqt800": [
        "LS"
    ],
    "insignia delta 2": [
        "TQ",
        "GC"
    ],
    "hykker_mytab10": [
        "HYK"
    ],
    "zed book g": [
        "2I"
    ],
    "wx_un_do": [
        "NV"
    ],
    "wv8-l": [
        "LB"
    ],
    "viva_i7g": [
        "A2"
    ],
    "via_s7-3g": [
        "R4"
    ],
    "u103gt1": [
        "3T",
        "CU"
    ],
    "tpc-xe10dw": [
        "JA"
    ],
    "s180i": [
        "DX"
    ],
    "s180": [
        "DX"
    ],
    "rq-768": [
        "RQ"
    ],
    "rq-712": [
        "RQ"
    ],
    "p1050x": [
        "MD"
    ],
    "p1040x": [
        "MD"
    ],
    "nx16a8116kp": [
        "NT"
    ],
    "nx16a10132sps": [
        "NT"
    ],
    "magnet_w10": [
        "V2"
    ],
    "lg-lk460": [
        "LG"
    ],
    "konrow_701x": [
        "KW"
    ],
    "aquaris m10 fhd": [
        "BX",
        "IX"
    ],
    "aquaris m10 4g": [
        "BX",
        "IX"
    ],
    "alfa_8t": [
        "H0"
    ],
    "positivo bgh m840": [
        "BG"
    ],
    "22081281ac": [
        "XI"
    ],
    "22081283g": [
        "XI"
    ],
    "rt2": [
        "OE"
    ],
    "ax502": [
        "A2",
        "BM"
    ],
    "ax501q": [
        "A2"
    ],
    "iplay9t": [
        "3A"
    ],
    "ags3k-w20": [
        "HU"
    ],
    "vexia fcs e2 clm": [
        "48"
    ],
    "vt701": [
        "ZV"
    ],
    "viz070tab811blu": [
        "VIZ"
    ],
    "viz101tab811blk": [
        "VIZ"
    ],
    "rct6703w12": [
        "RC"
    ],
    "rct6a06p22": [
        "RC"
    ],
    "rct6303w87dk": [
        "RC"
    ],
    "rct6773w22b": [
        "RC"
    ],
    "rct6203w46l": [
        "RC"
    ],
    "rct6973w43": [
        "RC"
    ],
    "rct6873w42m": [
        "RC"
    ],
    "ht0701l16": [
        "HN"
    ],
    "ht0704k08": [
        "HN"
    ],
    "ht0704w08": [
        "HN"
    ],
    "ht1004l16": [
        "HN"
    ],
    "htb801": [
        "ZH"
    ],
    "ht_7rt": [
        "H0"
    ],
    "ht_8mz": [
        "H0"
    ],
    "webpad7007": [
        "JJ"
    ],
    "webpad_1003": [
        "JJ"
    ],
    "zoom": [
        "4M"
    ],
    "meanit_c80c81": [
        "09"
    ],
    "meanit_c10c11": [
        "09"
    ],
    "tb132fu": [
        "LE"
    ],
    "lguk750": [
        "LG"
    ],
    "lg-v755": [
        "LG"
    ],
    "lg-v525s1": [
        "LG"
    ],
    "lg-v525s3": [
        "LG"
    ],
    "lg-v525": [
        "LG"
    ],
    "lg-v522": [
        "LG"
    ],
    "lg-p755l": [
        "LG"
    ],
    "m9_wifi": [
        "1R"
    ],
    "t15-eea": [
        "6O"
    ],
    "a1-734": [
        "AC"
    ],
    "itel w7002p": [
        "IZ"
    ],
    "energy tablet pro 3": [
        "E1"
    ],
    "geofox mid 743+": [
        "G2"
    ],
    "9295g_eea": [
        "TC"
    ],
    "p7pro": [
        "PRI"
    ],
    "p25_t_eea": [
        "T7"
    ],
    "p20s_row": [
        "T7"
    ],
    "u221-eea": [
        "YUM"
    ],
    "tecno p702as": [
        "TB"
    ],
    "1ey4g": [
        "MC"
    ],
    "nm-netpad7": [
        "NEM"
    ],
    "samsung sm-t321": [
        "SA"
    ],
    "sm-t321": [
        "SA"
    ],
    "samsung sm-t905": [
        "SA"
    ],
    "samsung sm-t595n": [
        "SA"
    ],
    "samsung sm-t590x": [
        "SA"
    ],
    "samsung sm-t585n0": [
        "SA"
    ],
    "sm-t595n": [
        "SA"
    ],
    "sm-t819c": [
        "SA"
    ],
    "samsung-sm-t817a": [
        "SA"
    ],
    "s3t10in": [
        "0U"
    ],
    "ieos_quad_w": [
        "O1"
    ],
    "ieos_quad_pro": [
        "O1"
    ],
    "idsq8_3g": [
        "D2"
    ],
    "idsq7_3g": [
        "D2"
    ],
    "idsq8": [
        "D2"
    ],
    "idsq7": [
        "D2"
    ],
    "idsq11_3g": [
        "D2"
    ],
    "idsq11": [
        "D2"
    ],
    "idsq10_3g": [
        "D2"
    ],
    "idrq10_3g": [
        "D2"
    ],
    "idrq10": [
        "D2"
    ],
    "creapad_1009_eea": [
        "WW"
    ],
    "tab r6 pro": [
        "HV"
    ],
    "m8l plus": [
        "BU"
    ],
    "ts-m704f-1": [
        "X6"
    ],
    "hipad max": [
        "1C"
    ],
    "vivimage_e11": [
        "VIV"
    ],
    "dtab01": [
        "HU"
    ],
    "ags3k-w00": [
        "HU"
    ],
    "tb-js101a": [
        "JOY"
    ],
    "bzt4-w19": [
        "HU"
    ],
    "readboy_g90s": [
        "RB"
    ],
    "deyi-10m18": [
        "DEY"
    ],
    "p10hd_lite": [
        "T7"
    ],
    "lavie t8 8hd1": [
        "NE"
    ],
    "sm-t815c": [
        "SA"
    ],
    "bah4-al10": [
        "HU"
    ],
    "yy-107h": [
        "YEL"
    ],
    "waltter neo 10.1": [
        "WAL"
    ],
    "m40 plus_eea": [
        "T7"
    ],
    "kl2108nbe": [
        "0K"
    ],
    "tb328xu": [
        "LE"
    ],
    "opd2101": [
        "OP"
    ],
    "vivah8lte": [
        "A2"
    ],
    "vivah7lte": [
        "A2"
    ],
    "vivah10lte": [
        "A2"
    ],
    "pro 1800f 4g rs1249pl": [
        "D2"
    ],
    "ags5-l09": [
        "HU"
    ],
    "p30hd_row": [
        "T7"
    ],
    "zl80": [
        "B6"
    ],
    "sm-x806e": [
        "SA"
    ],
    "g101-og": [
        "SQ"
    ],
    "m bot tab 103": [
        "LM"
    ],
    "m bot tab 10": [
        "LM"
    ],
    "teo13p": [
        "TN"
    ],
    "teo10s": [
        "TN"
    ],
    "tf501_ec": [
        "TL"
    ],
    "tab8plus": [
        "2M"
    ],
    "tab7q804val": [
        "VAT"
    ],
    "tab7a3g05": [
        "SAK"
    ],
    "tab7plus": [
        "2M"
    ],
    "tab5": [
        "GIR"
    ],
    "tab10plus": [
        "2M"
    ],
    "tab1081": [
        "0H"
    ],
    "tab-s1": [
        "MO1"
    ],
    "t7a6inc": [
        "NB"
    ],
    "t3g_04": [
        "SAT"
    ],
    "mp01a3g": [
        "MWA"
    ],
    "torex pad 8pro": [
        "7T"
    ],
    "torex pad 8 pro": [
        "7T"
    ],
    "kfthwi": [
        "KN"
    ],
    "readboy_g550a": [
        "RB"
    ],
    "tb138fc": [
        "LE"
    ],
    "rod-w09": [
        "HNR"
    ],
    "jt10-x": [
        "GEA"
    ],
    "h10_us": [
        "W5"
    ],
    "wgrr-w09": [
        "HU"
    ],
    "lenovo tb-x306nc_prc": [
        "LE"
    ],
    "actab1021": [
        "AC"
    ],
    "la_tab_124_hd_plus": [
        "LM"
    ],
    "tab_a6": [
        "OAN"
    ],
    "via_l30": [
        "R4"
    ],
    "gtvr10s": [
        "GH"
    ],
    "mupad_k10": [
        "IMU"
    ],
    "mupad104": [
        "IMU"
    ],
    "mupadt7": [
        "IMU"
    ],
    "mupad t10": [
        "IMU"
    ],
    "mupad 7s": [
        "IMU"
    ],
    "mitab california": [
        "WL"
    ],
    "mercury hd quad core": [
        "6E"
    ],
    "maven_7_plus": [
        "O1"
    ],
    "m-wpw801": [
        "MC"
    ],
    "gtab718": [
        "GH"
    ],
    "gtkids7a": [
        "GH"
    ],
    "g1101t": [
        "3P"
    ],
    "fusion5_f704b": [
        "5J"
    ],
    "fusion5_f105d": [
        "5J"
    ],
    "fusion5_f104e": [
        "5J"
    ],
    "fine 7b": [
        "EV1"
    ],
    "eagle_961": [
        "KE"
    ],
    "eagle_1068": [
        "KE"
    ],
    "axis7_slim": [
        "GH"
    ],
    "axis7_led": [
        "GH"
    ],
    "hope8_mate": [
        "XT"
    ],
    "itel w7001": [
        "IZ"
    ],
    "joy8 mate": [
        "XT"
    ],
    "dbook_110": [
        "DA"
    ],
    "tpc-xe10d-h": [
        "JA"
    ],
    "tablet_dl_3910": [
        "DL0"
    ],
    "tablet_dl_3903": [
        "DL0"
    ],
    "tablet_dl_3420": [
        "DL0"
    ],
    "tablet_dl_3411": [
        "DL0"
    ],
    "tablet_dl_3410": [
        "DL0"
    ],
    "tab918qc": [
        "0H"
    ],
    "tab917qc-8gb": [
        "0H"
    ],
    "tab917qc-16gb": [
        "0H"
    ],
    "t74rd": [
        "OY"
    ],
    "t7014q+prixton": [
        "2P"
    ],
    "t1700q-prixton": [
        "2P"
    ],
    "t1700q prixton": [
        "2P"
    ],
    "supra_m743": [
        "S5"
    ],
    "sm-t330nu": [
        "SA"
    ],
    "ideal 8s": [
        "H0"
    ],
    "v116w-dualos": [
        "OD"
    ],
    "u27gt-c8p": [
        "CU"
    ],
    "u25gt-w4": [
        "CU"
    ],
    "smartbook_s7qs": [
        "47"
    ],
    "an7ig3": [
        "AN"
    ],
    "energy i10 dual": [
        "E1"
    ],
    "energy tablet 9 neo 2": [
        "E1"
    ],
    "energy neo 9": [
        "E1"
    ],
    "energy tablet neo 10 3g": [
        "E1"
    ],
    "pmt3407_4g": [
        "PR"
    ],
    "symtab50": [
        "SM"
    ],
    "optima 1245c 4g ts1277ml": [
        "D2"
    ],
    "optima 1411d 4g ts1273pl": [
        "D2"
    ],
    "iplay_50": [
        "3A"
    ],
    "tab a1015": [
        "1S"
    ],
    "9161g": [
        "TC"
    ],
    "htc a103": [
        "HT"
    ],
    "ags5-w09": [
        "HU"
    ],
    "gravity2-4g": [
        "FS"
    ],
    "xiaomi pad 5 pro": [
        "XI"
    ],
    "nomi c080010 libra2": [
        "NM"
    ],
    "tab 15": [
        "B2"
    ],
    "telp-1013kbc": [
        "TL"
    ],
    "v tab z1 a": [
        "VT"
    ],
    "rubenstab_t11": [
        "FRU"
    ],
    "hpad2": [
        "HEW"
    ],
    "sm-x205c": [
        "SA"
    ],
    "nogapad 7g": [
        "OG"
    ],
    "optima prime 4 3g tt7174pg": [
        "D2"
    ],
    "optima_prime_3_3g_ts7131mg": [
        "D2"
    ],
    "m40air_row": [
        "T7"
    ],
    "pritom_m10": [
        "PRI"
    ],
    "m863-eea": [
        "BMX"
    ],
    "pb-6505y": [
        "LE"
    ],
    "zxt-10hl323s": [
        "ZAM"
    ],
    "zxt-10fl323g-pro": [
        "ZAM"
    ],
    "ultrapad_up10.s36la": [
        "7F"
    ],
    "regal tab 10.1": [
        "Z9"
    ],
    "redway7_pro": [
        "REW"
    ],
    "lifetab e1080x": [
        "MD"
    ],
    "e101gcm": [
        "GRA"
    ],
    "quicktab plus": [
        "PCS"
    ],
    "polaris_808_be": [
        "BP"
    ],
    "polaris_808": [
        "BP"
    ],
    "bmxc801": [
        "BMX"
    ],
    "archos core 70 3g": [
        "AR"
    ],
    "archos sense 101 x": [
        "AR"
    ],
    "archos core 101 3g": [
        "AR"
    ],
    "d-51c": [
        "SH"
    ],
    "bah4-w29": [
        "HU"
    ],
    "p30hd_eea": [
        "T7"
    ],
    "3g 1026-q18": [
        "IB"
    ],
    "pcb-t750": [
        "PB"
    ],
    "party": [
        "EX"
    ],
    "paladin evo": [
        "IRO"
    ],
    "flylife web 7.85 slim": [
        "FL"
    ],
    "flylife web 7": [
        "FL"
    ],
    "bah4-w39": [
        "HU"
    ],
    "bzt-w09": [
        "HU"
    ],
    "archos core 101 3g ultra": [
        "AR"
    ],
    "v10_4g": [
        "OD"
    ],
    "bt7x1": [
        "BRV"
    ],
    "m1092q": [
        "CJ"
    ],
    "m-sp7mxah": [
        "MC"
    ],
    "m-sp7mxa": [
        "MC"
    ],
    "tangotab8": [
        "10"
    ],
    "m8_go": [
        "RD"
    ],
    "leke pad-l04": [
        "ZJ"
    ],
    "8800i": [
        "DIM"
    ],
    "viewpad_m10": [
        "VS"
    ],
    "vivax tablet tpc-804 3g": [
        "V5"
    ],
    "dc-714": [
        "EVE"
    ],
    "dc-855": [
        "EVE"
    ],
    "dc-856": [
        "EVE"
    ],
    "dc-9714": [
        "EVE"
    ],
    "dc-9712-8": [
        "EVE"
    ],
    "dd-1gb": [
        "IB"
    ],
    "dc-709": [
        "EVE"
    ],
    "dc-705": [
        "EVE"
    ],
    "dc-1215": [
        "EVE"
    ],
    "dc-1028": [
        "EVE"
    ],
    "everpad dc-1102": [
        "EVE"
    ],
    "dc-9715": [
        "EVE"
    ],
    "dc-1216": [
        "EVE"
    ],
    "dc-1545": [
        "EVE"
    ],
    "kidpad_lite": [
        "1R"
    ],
    "noatab": [
        "C5M"
    ],
    "cabana": [
        "BOO"
    ],
    "strikaplay": [
        "BOO"
    ],
    "cybook tablet": [
        "BOK"
    ],
    "bluslate7": [
        "BUS"
    ],
    "bluslate6": [
        "BUS"
    ],
    "impad 9415": [
        "I3"
    ],
    "impad 1006": [
        "I3"
    ],
    "leagoo_leapad_7i": [
        "L5"
    ],
    "lect-tab1011": [
        "LEC"
    ],
    "lect-tab0711": [
        "LEC"
    ],
    "slide_dazzle_3500": [
        "IB",
        "WI"
    ],
    "viewpad 8e": [
        "VS"
    ],
    "tmk715l": [
        "C5"
    ],
    "tm800a620m": [
        "NUV"
    ],
    "tm101a620m": [
        "NUV"
    ],
    "tfx711g": [
        "C5"
    ],
    "tfx714l": [
        "C5"
    ],
    "tfx713l": [
        "C5"
    ],
    "ht0703w08": [
        "HN"
    ],
    "i1_3gd": [
        "CU"
    ],
    "tb128fu": [
        "LE"
    ],
    "vankyo_s8": [
        "VC"
    ],
    "ffftab10a4": [
        "FFF"
    ],
    "polparoid pure": [
        "PL"
    ],
    "v-pad pop": [
        "VER"
    ],
    "v80 se": [
        "OD"
    ],
    "v80_se": [
        "OD"
    ],
    "ct9a06p23": [
        "UV"
    ],
    "opd2201": [
        "OP"
    ],
    "22081283c": [
        "XI"
    ],
    "anry-1006": [
        "7A"
    ],
    "tw10": [
        "BEF"
    ],
    "scream 3g": [
        "EX"
    ],
    "sb7 pro hd": [
        "L3"
    ],
    "sc7 pro hd": [
        "L3"
    ],
    "4good t704m 3g": [
        "4G"
    ],
    "4good t703m 3g": [
        "4G"
    ],
    "mpqc7": [
        "MM"
    ],
    "mitab_pro_10_plus": [
        "WL"
    ],
    "mitab_pro_10": [
        "WL"
    ],
    "h7_us": [
        "W5"
    ],
    "m8l 2022": [
        "BU"
    ],
    "lenovo tb-8506x": [
        "LE"
    ],
    "ct1056_32gb": [
        "CF"
    ],
    "sm-t813": [
        "SA"
    ],
    "1ey": [
        "MC"
    ],
    "s22_eea": [
        "SEB"
    ],
    "s23_eea": [
        "SEB"
    ],
    "ilium pad x8": [
        "LA"
    ],
    "sm-x205n": [
        "SA"
    ],
    "agm-w09hn": [
        "HNR"
    ],
    "m10 go": [
        "RD"
    ],
    "t5_eea": [
        "YES"
    ],
    "8491x_eea": [
        "TC"
    ],
    "kst103sd": [
        "KIS"
    ],
    "citi 13 x703 4g cs3242ml": [
        "D2"
    ],
    "optima 1440e 4g ts1269pl": [
        "D2"
    ],
    "archos access 101 3g v2": [
        "AR"
    ],
    "citi 1312c 4g cs1272pl": [
        "D2"
    ],
    "citi 8443e 4g cs8271pl": [
        "D2"
    ],
    "st11-a5": [
        "L6"
    ],
    "m40 pro_eea": [
        "T7"
    ],
    "magnet_m10_2020": [
        "V2"
    ],
    "z1_eea": [
        "VC"
    ],
    "dvk87 orion 8 tab": [
        "69"
    ],
    "sm-t738t": [
        "SA"
    ],
    "sm-t738v": [
        "SA"
    ],
    "sm-t735c": [
        "SA"
    ],
    "sky 8244b 3g ss8263pg": [
        "W8"
    ],
    "sky 1430d 4g ss1270pl": [
        "W8"
    ],
    "sky 1123b 3g ss1259pg": [
        "W8"
    ],
    "sky 1262c 3g ss1260pg": [
        "W8"
    ],
    "tdt4518_4g_e_ru": [
        "TOP"
    ],
    "t81n_up": [
        "LV"
    ],
    "t12m_eea": [
        "DJ"
    ],
    "tb-x505f": [
        "LE"
    ],
    "snook-x10": [
        "CTR"
    ],
    "punos 10": [
        "PUN"
    ],
    "azimut 3": [
        "MC"
    ],
    "awow_creapad_1003_eea": [
        "WW"
    ],
    "anpad_u2": [
        "ANX"
    ],
    "m17qf6-3gplus": [
        "M3"
    ],
    "livingstone2": [
        "3O"
    ],
    "v tab z2 lte": [
        "VT"
    ],
    "tr7989": [
        "AD"
    ],
    "kob2k-l09": [
        "HU"
    ],
    "hope8 lte": [
        "XT"
    ],
    "iplay50 pro": [
        "3A"
    ],
    "g10_eea": [
        "GOO"
    ],
    "z08mk": [
        "VIP"
    ],
    "yt3-x50f": [
        "LE"
    ],
    "space_m10": [
        "RE2"
    ],
    "spacetab_h20": [
        "HAQ"
    ],
    "citi 8313c 4g cs8268pl": [
        "D2"
    ],
    "plane_8548s_3g_ps8161pg": [
        "D2"
    ],
    "8402d 4g ws8251pl": [
        "D2"
    ],
    "archos core 3g v4": [
        "AR"
    ],
    "archos t 101x 4g": [
        "AR"
    ],
    "citi kids 10 cs1232mg": [
        "D2"
    ],
    "citi kids 80 cs8239rw": [
        "D2"
    ],
    "sky kids 70 ss7238pg": [
        "W8"
    ],
    "optima 1240c ts1276aw": [
        "D2"
    ],
    "optima 7 e200 3g ts7244pg": [
        "D2"
    ],
    "optima 8250c ts8274aw": [
        "D2"
    ],
    "optima 8258c 4g ts8275ml": [
        "D2"
    ],
    "sky 7143b 3g ss7265pg": [
        "W8"
    ],
    "pic7gs8": [
        "ADV"
    ],
    "bnt-801w": [
        "2B"
    ],
    "onelerndb009": [
        "ONL"
    ],
    "tolino tab 8": [
        "T1"
    ],
    "olkya liger 71g": [
        "OLK"
    ],
    "got-w09": [
        "HU"
    ],
    "tab1090": [
        "0H"
    ],
    "archos 97c platinum": [
        "AR"
    ],
    "archos 70d titanium": [
        "AR"
    ],
    "lenovo tb3-x70f": [
        "LE"
    ],
    "lenovo tb3-850f": [
        "LE"
    ],
    "woxter_n90": [
        "WX"
    ],
    "woxter_n70": [
        "WX"
    ],
    "fieldpad 8": [
        "RUT"
    ],
    "fieldbook k101": [
        "LH"
    ],
    "neutabk1": [
        "NEU"
    ],
    "elan 4g2": [
        "IB"
    ],
    "lm-01": [
        "DTE"
    ],
    "linsay_f10xhd": [
        "LIN"
    ],
    "koral 7w4": [
        "HN"
    ],
    "kidzy70": [
        "00"
    ],
    "k7 kids": [
        "79"
    ],
    "joy10_lte": [
        "XT"
    ],
    "ursus 9x 3g": [
        "DX"
    ],
    "ursus 9px 3g": [
        "DX"
    ],
    "ursus 9ev mini 3g": [
        "DX"
    ],
    "ursus 8ev2 3g": [
        "DX"
    ],
    "ursus 8ev 3g": [
        "DX"
    ],
    "ursus 10m2 3g": [
        "DX"
    ],
    "uqm13a": [
        "4V"
    ],
    "uqm12a": [
        "4V"
    ],
    "u51gt-c8": [
        "CU"
    ],
    "u27gt-sd": [
        "CU"
    ],
    "gfive gpad701": [
        "0G"
    ],
    "ac101pl3gv2": [
        "AR"
    ],
    "novo7_elf": [
        "AZ"
    ],
    "marvel": [
        "DIS"
    ],
    "frozen": [
        "DIS"
    ],
    "f808nm": [
        "WAF"
    ],
    "gpad701": [
        "0G"
    ],
    "gpad702": [
        "0G"
    ],
    "g-padlite": [
        "4Y"
    ],
    "9132g": [
        "TC"
    ],
    "tk701_eea": [
        "AEE"
    ],
    "p30s_row": [
        "T7"
    ],
    "p40hd_row": [
        "T7"
    ],
    "tab_812_4g": [
        "MJ"
    ],
    "p40hd_eea": [
        "T7"
    ],
    "tab 11 se": [
        "B2"
    ],
    "t81n": [
        "LV"
    ],
    "sm-t597v": [
        "SA"
    ],
    "sm-t597p": [
        "SA"
    ],
    "taristab3": [
        "69"
    ],
    "tps-sc10": [
        "TPS"
    ],
    "tpc_8053g": [
        "V5"
    ],
    "twifi-06": [
        "SAT"
    ],
    "gm discovery tab 8": [
        "GN"
    ],
    "uno_x10": [
        "O1"
    ],
    "noon_pro": [
        "O1"
    ],
    "neron": [
        "O1"
    ],
    "orion7ol": [
        "GC"
    ],
    "momo9 3gq": [
        "PY"
    ],
    "sonysgp321": [
        "SO"
    ],
    "gocam_g301": [
        "CON"
    ],
    "hello 7q": [
        "UK"
    ],
    "hugerock t70h": [
        "HUG"
    ],
    "slide_skye_03": [
        "IB",
        "WI"
    ],
    "if236a": [
        "I0"
    ],
    "if195a": [
        "I0"
    ],
    "smart_l102": [
        "IG"
    ],
    "smartview_9.6_3g": [
        "MY1"
    ],
    "st1009x": [
        "3B",
        "SE"
    ],
    "t7a6n": [
        "NB"
    ],
    "tab 4g 8-1": [
        "VX"
    ],
    "tab 747 3g": [
        "MJ"
    ],
    "tab 611 3g": [
        "MJ"
    ],
    "tab 511 3g": [
        "MJ"
    ],
    "toy_story": [
        "DIS"
    ],
    "st-810": [
        "H5"
    ],
    "spirit_x2": [
        "IB"
    ],
    "smart_w101": [
        "IG"
    ],
    "lg-v940n": [
        "LG"
    ],
    "lg-v940": [
        "LG"
    ],
    "lg-v935t": [
        "LG"
    ],
    "lg-v930": [
        "LG"
    ],
    "lg-v700wj": [
        "LG"
    ],
    "lg-v700n": [
        "LG"
    ],
    "lg-v411": [
        "LG"
    ],
    "lg-v400y7": [
        "LG"
    ],
    "lg-p490l": [
        "LG"
    ],
    "lg-v507l": [
        "LG"
    ],
    "tb300xu": [
        "LE"
    ],
    "tb350xu": [
        "LE"
    ],
    "sky pad10": [
        "SW"
    ],
    "azimut3 pro": [
        "MC"
    ],
    "atab1422e": [
        "AC"
    ],
    "b_tab1021": [
        "BOL"
    ],
    "ezpad m10s": [
        "7J",
        "EZ"
    ],
    "m40 pro_row": [
        "T7"
    ],
    "m40 plus_row": [
        "T7"
    ],
    "p20s_eea": [
        "T7"
    ],
    "pad 10": [
        "OSC"
    ],
    "iget smart s100": [
        "IG"
    ],
    "rt3": [
        "OE"
    ],
    "t50_eea": [
        "T7"
    ],
    "t50_row": [
        "T7"
    ],
    "ifiveair": [
        "FW"
    ],
    "ieos_next_10": [
        "O1"
    ],
    "ifive pro 2": [
        "FW"
    ],
    "i15-t": [
        "CU"
    ],
    "topshows-x1": [
        "TO2"
    ],
    "topshows x9": [
        "TO2"
    ],
    "touchmate tm-mid1040": [
        "T8"
    ],
    "dl1025gh": [
        "DD"
    ],
    "mlab_glowy10": [
        "MLA"
    ],
    "hsg1416": [
        "HE"
    ],
    "tab_814": [
        "MJ"
    ],
    "azimut2": [
        "MC"
    ],
    "k87cc": [
        "ZT"
    ],
    "mid1020l": [
        "6E"
    ],
    "pro 1480e 4g rs1267pl": [
        "D2"
    ],
    "tb-8704v": [
        "LE"
    ],
    "theia_10": [
        "NJO"
    ],
    "tfqcoal01232": [
        "T6"
    ],
    "techpad 7qc": [
        "TP"
    ],
    "techpad 10qc": [
        "TP"
    ],
    "tdv900": [
        "LN"
    ],
    "nogapad 10.1ghd": [
        "OG"
    ],
    "nodropout t25": [
        "NOD"
    ],
    "nodropout t25m": [
        "NOD"
    ],
    "bq-8088l": [
        "BX"
    ],
    "m40s_row": [
        "T7"
    ],
    "h28": [
        "DX"
    ],
    "s270": [
        "DX"
    ],
    "s169": [
        "DX"
    ],
    "s110": [
        "DX"
    ],
    "diamond r8": [
        "DUR"
    ],
    "detroit 3": [
        "GOL"
    ],
    "optima 7202 3g ts7055mg": [
        "D2"
    ],
    "optima 7201 3g ts7047pg": [
        "D2"
    ],
    "optima 7200t 3g tt7042mg": [
        "D2"
    ],
    "panoramic fq-058/2": [
        "PA1"
    ],
    "plt-200": [
        "PLT"
    ],
    "plt-100": [
        "PLT"
    ],
    "plt9999g": [
        "P1"
    ],
    "plt7770g": [
        "P1"
    ],
    "pndp60l10blk": [
        "PQ"
    ],
    "pndp60m7pur": [
        "PQ"
    ],
    "prime10se": [
        "VIL"
    ],
    "prime10es": [
        "VIL"
    ],
    "elite9ql": [
        "VIL"
    ],
    "elite8qi": [
        "VIL"
    ],
    "elite7qs": [
        "VIL"
    ],
    "bdl1064pr001": [
        "PL"
    ],
    "etw101gt_c": [
        "6Q"
    ],
    "9137w": [
        "TC"
    ],
    "8491x": [
        "TC"
    ],
    "pmt3103_w_ru": [
        "PR"
    ],
    "8084_eea": [
        "AL"
    ],
    "f803ym": [
        "WAF"
    ],
    "1402d 4g ws1250pl": [
        "D2"
    ],
    "p25_t_row": [
        "T7"
    ],
    "lavie t7 7sd1": [
        "NE"
    ],
    "lavie tab 10fhd3": [
        "NE"
    ],
    "lavie tab t12 12qhd1": [
        "NE"
    ],
    "p30air_eea": [
        "T7"
    ],
    "m170": [
        "DX"
    ],
    "pmt4511_4g_eea": [
        "PR"
    ],
    "elite t10": [
        "SW"
    ],
    "bp_6110": [
        "BP"
    ],
    "gta7plus": [
        "GH"
    ],
    "m40(n9h2)": [
        "T7"
    ],
    "plane_7012m_3g_ps7082mg": [
        "D2"
    ],
    "u70c": [
        "E9"
    ],
    "u800b": [
        "CEI"
    ],
    "u70b": [
        "E9"
    ],
    "moto tab g70": [
        "MR"
    ],
    "nokia t10": [
        "NK"
    ],
    "nokia t21": [
        "NK"
    ],
    "m10es11": [
        "IBO"
    ],
    "x2_eea": [
        "YES"
    ],
    "groberwert hd7": [
        "GR1"
    ],
    "fz-a2a": [
        "PA"
    ],
    "hipad xpro": [
        "1C"
    ],
    "k7_a101_eea": [
        "PRI"
    ],
    "lenovo tb-j6c6f": [
        "LE"
    ],
    "readboy_g600": [
        "RB"
    ],
    "mid_1089ipsa100": [
        "LAS"
    ],
    "scepter8": [
        "YQ"
    ],
    "tabletexo_wave_i101s": [
        "EH"
    ],
    "mq703g": [
        "TWN"
    ],
    "mt003-21": [
        "MIG"
    ],
    "byybuo_smartpad_t10": [
        "BYY"
    ],
    "ox-p010-2": [
        "OXT"
    ],
    "x10mt87": [
        "X8"
    ],
    "senkatel_t1009": [
        "01"
    ],
    "senkatel_t7011": [
        "01"
    ],
    "senkatel t7012": [
        "01"
    ],
    "senkatel_t8002": [
        "01"
    ],
    "senkatel_t9702": [
        "01"
    ],
    "meanit x10": [
        "09"
    ],
    "techno 7.0 lte tq763i": [
        "0B"
    ],
    "techno i700aj": [
        "0B"
    ],
    "techno_tq863q": [
        "0B"
    ],
    "crony-7021": [
        "0C"
    ],
    "tab2323gmqc": [
        "0H"
    ],
    "hi10 plus": [
        "1C"
    ],
    "hi10 pro": [
        "1C"
    ],
    "cw-hi10 pro": [
        "1C"
    ],
    "cw-hi12": [
        "1C"
    ],
    "cw-hi8-super": [
        "1C"
    ],
    "hi8 air": [
        "1C"
    ],
    "hi8 pro": [
        "1C"
    ],
    "hibook pro": [
        "1C"
    ],
    "cw-v17hd3g": [
        "1C"
    ],
    "cw-v88-quad": [
        "1C"
    ],
    "cw-v88s": [
        "1C"
    ],
    "cw-v9-dual": [
        "1C"
    ],
    "cw-v99": [
        "1C"
    ],
    "cw-vi10 plus": [
        "1C"
    ],
    "cw-vi7": [
        "1C"
    ],
    "cw-vi8": [
        "1C"
    ],
    "cw-vx8-3g": [
        "1C"
    ],
    "etl-t752g": [
        "1E"
    ],
    "etl-t882g": [
        "1E"
    ],
    "etl-t970": [
        "1E"
    ],
    "etl-t980": [
        "1E"
    ],
    "mypad7s": [
        "1M"
    ],
    "m7-3g-plus": [
        "1R"
    ],
    "m7_3g_plus": [
        "1R"
    ],
    "m7-3g quad core": [
        "1R"
    ],
    "m7slite": [
        "1R"
    ],
    "m7sqc_plus": [
        "1R"
    ],
    "x-style tab a101": [
        "1S"
    ],
    "x-styletab_a102": [
        "1S"
    ],
    "x_style_tab_a103": [
        "1S"
    ],
    "x-styletab_a81": [
        "1S"
    ],
    "x_style_tab_a82": [
        "1S"
    ],
    "mixzo me1030_3g": [
        "1Z"
    ],
    "mixzo mx1037 4g": [
        "1Z"
    ],
    "mx1037_4g": [
        "1Z"
    ],
    "mx1041_4g": [
        "1Z"
    ],
    "mixzo mx1041 4g": [
        "1Z"
    ],
    "ct9716": [
        "2E"
    ],
    "ceros ct9716-b": [
        "2E"
    ],
    "itell_k3500n": [
        "2I",
        "IZ"
    ],
    "masstel_tab7lte": [
        "2M"
    ],
    "masstel tab 700i": [
        "2M"
    ],
    "masstel tab 840": [
        "2M"
    ],
    "t7012q": [
        "2P"
    ],
    "andromeda s707": [
        "2S"
    ],
    "andromeda s8": [
        "2S"
    ],
    "andromeda s840": [
        "2S"
    ],
    "andromeda s845": [
        "2S"
    ],
    "andromeda s850": [
        "2S"
    ],
    "u1006": [
        "3A"
    ],
    "iplay_20": [
        "3A"
    ],
    "t1001x": [
        "3A"
    ],
    "t1001xs": [
        "3A"
    ],
    "contixo  b105": [
        "3C"
    ],
    "contixo b108": [
        "3C"
    ],
    "contixo cx-1045 3g": [
        "3C"
    ],
    "contixo gx 1035": [
        "3C"
    ],
    "contixo kt107 3g": [
        "3C"
    ],
    "contixo kt107": [
        "3C"
    ],
    "contixo kt715 3g": [
        "3C"
    ],
    "contixo kt995": [
        "3C"
    ],
    "enot-e102": [
        "3E"
    ],
    "enot j101": [
        "3E"
    ],
    "aosonm707tg": [
        "3N"
    ],
    "aosonr101": [
        "3N"
    ],
    "aosonr102": [
        "3N"
    ],
    "aosonr103": [
        "3N"
    ],
    "aosons7": [
        "3N"
    ],
    "aosons7_pro": [
        "3N"
    ],
    "aosons8pro": [
        "3N"
    ],
    "twist tab": [
        "3P"
    ],
    "positivo ypy l1050e": [
        "3P"
    ],
    "ac0732c": [
        "3Q"
    ],
    "ac7803c": [
        "3Q"
    ],
    "rc7802f": [
        "3Q"
    ],
    "mt0812e": [
        "3Q"
    ],
    "lc0804b": [
        "3Q"
    ],
    "mt0724b": [
        "3Q"
    ],
    "lc0725b": [
        "3Q"
    ],
    "lc0723b": [
        "3Q"
    ],
    "lc0810c": [
        "3Q"
    ],
    "lc0901d": [
        "3Q"
    ],
    "3q_er71b": [
        "3Q"
    ],
    "el72b": [
        "3Q"
    ],
    "rc9711b": [
        "3Q"
    ],
    "vm1017a": [
        "3Q"
    ],
    "bc9710am": [
        "3Q"
    ],
    "ts0807b": [
        "3Q"
    ],
    "rc0710b": [
        "3Q"
    ],
    "qs0716d": [
        "3Q"
    ],
    "rc0726b": [
        "3Q"
    ],
    "qs0815c": [
        "3Q"
    ],
    "rc9717b": [
        "3Q"
    ],
    "rc0709b": [
        "3Q"
    ],
    "qs0715c": [
        "3Q"
    ],
    "rc9724c": [
        "3Q"
    ],
    "qs0717d": [
        "3Q"
    ],
    "rc9716b": [
        "3Q"
    ],
    "lc0720c": [
        "3Q"
    ],
    "qs0730c": [
        "3Q"
    ],
    "ts1013b": [
        "3Q"
    ],
    "qs9715f": [
        "3Q"
    ],
    "qs0728c": [
        "3Q"
    ],
    "rc0721b": [
        "3Q"
    ],
    "rc0817c": [
        "3Q"
    ],
    "rc9730c": [
        "3Q"
    ],
    "rc9712c": [
        "3Q"
    ],
    "ac0731b": [
        "3Q"
    ],
    "lc1016c": [
        "3Q"
    ],
    "rc1018c": [
        "3Q"
    ],
    "rc0813c": [
        "3Q"
    ],
    "rc9726c": [
        "3Q"
    ],
    "rc9731c": [
        "3Q"
    ],
    "rc0718c": [
        "3Q"
    ],
    "rc1301c": [
        "3Q"
    ],
    "mt0729b": [
        "3Q"
    ],
    "rc0722c": [
        "3Q"
    ],
    "qs1023h": [
        "3Q"
    ],
    "mt0811b": [
        "3Q"
    ],
    "ac1024c": [
        "3Q"
    ],
    "rc1025f": [
        "3Q"
    ],
    "rc0719h": [
        "3Q"
    ],
    "rc0734h": [
        "3Q"
    ],
    "rc1019g": [
        "3Q"
    ],
    "rc9727f": [
        "3Q"
    ],
    "mt0729d": [
        "3Q"
    ],
    "rc0743h": [
        "3Q"
    ],
    "mt0739d": [
        "3Q"
    ],
    "oc1020a": [
        "3Q"
    ],
    "vm0711a": [
        "3Q"
    ],
    "qs9719d": [
        "3Q"
    ],
    "qs9718c": [
        "3Q"
    ],
    "mt7801c": [
        "3Q"
    ],
    "ts9708b": [
        "3Q"
    ],
    "pnt-7040": [
        "3S"
    ],
    "pnt-7042": [
        "3S"
    ],
    "pnt-7045": [
        "3S"
    ],
    "mytab 8 mini dual core": [
        "3T",
        "MY1"
    ],
    "mytab-u55gt": [
        "3T",
        "MY1"
    ],
    "people gt300": [
        "4G"
    ],
    "t700i_3g": [
        "4G"
    ],
    "tab a4010": [
        "4N"
    ],
    "tab a4030": [
        "4N"
    ],
    "ptb7r": [
        "4P"
    ],
    "syx-t101": [
        "4S"
    ],
    "syx-t102": [
        "4S"
    ],
    "syx-t700)": [
        "4S"
    ],
    "syx-t704": [
        "4S"
    ],
    "turbokids3g": [
        "5T"
    ],
    "turbokids s4": [
        "5T"
    ],
    "turbokids-tmnt": [
        "5T"
    ],
    "mid-123g": [
        "6M"
    ],
    "mid-703g": [
        "6M"
    ],
    "mid-713g": [
        "6M"
    ],
    "mid-721": [
        "6M"
    ],
    "mid-722": [
        "6M"
    ],
    "mystery mid-733g": [
        "6M"
    ],
    "mid-743g": [
        "6M"
    ],
    "mid-753g": [
        "6M"
    ],
    "mid-783g": [
        "6M"
    ],
    "mid-833g": [
        "6M"
    ],
    "anry-rs10": [
        "7A"
    ],
    "anry-s20": [
        "7A"
    ],
    "anry-x20": [
        "7A"
    ],
    "torex-ps12": [
        "7T"
    ],
    "mito t10": [
        "8M"
    ],
    "mito t300": [
        "8M"
    ],
    "mito t330": [
        "8M"
    ],
    "mito t35": [
        "8M"
    ],
    "mito t510": [
        "8M"
    ],
    "mito t888": [
        "8M"
    ],
    "tc1050g": [
        "8T"
    ],
    "mt7-442d": [
        "9M"
    ],
    "casebook_3": [
        "9T"
    ],
    "allview2speedduo": [
        "A2"
    ],
    "allview3speedquad": [
        "A2"
    ],
    "ax2_frenzy": [
        "A2"
    ],
    "allviewax2frenzy": [
        "A2"
    ],
    "ax5nanoq": [
        "A2"
    ],
    "allviewcity": [
        "A2"
    ],
    "allviewcityplus": [
        "A2"
    ],
    "allviewspeed": [
        "A2"
    ],
    "allview speedi": [
        "A2"
    ],
    "viva_1001g": [
        "A2"
    ],
    "viva_1003g": [
        "A2"
    ],
    "viva_h1001_lte": [
        "A2"
    ],
    "viva_h801": [
        "A2"
    ],
    "ask 791sp 3g": [
        "A4"
    ],
    "quad-core a64 p3": [
        "A7"
    ],
    "zy-07b": [
        "A7"
    ],
    "ap-106": [
        "A8"
    ],
    "ap-107g": [
        "A8"
    ],
    "ap-109": [
        "A8"
    ],
    "ap-110n": [
        "A8"
    ],
    "ap-115g": [
        "A8"
    ],
    "ap-719": [
        "A8"
    ],
    "ap-721n": [
        "A8"
    ],
    "ap-727g": [
        "A8"
    ],
    "ap-753g": [
        "A8"
    ],
    "ap-757g": [
        "A8"
    ],
    "ap-941": [
        "A8"
    ],
    "ap-108": [
        "A8"
    ],
    "arian space 70 st7001rw": [
        "AB"
    ],
    "arian space 71 st7002pg": [
        "AB",
        "SE"
    ],
    "arian space 80 ss8003pg": [
        "AB"
    ],
    "arian space 100 st1004pg": [
        "AB",
        "SE"
    ],
    "a1-810": [
        "AC"
    ],
    "a1-811": [
        "AC"
    ],
    "a1-830": [
        "AC"
    ],
    "a3-a10": [
        "AC"
    ],
    "a3-a11": [
        "AC"
    ],
    "b1-710": [
        "AC"
    ],
    "b1-a71": [
        "AC"
    ],
    "b1-720": [
        "AC"
    ],
    "b1-711": [
        "AC"
    ],
    "b1-721": [
        "AC"
    ],
    "b3-a20": [
        "AC"
    ],
    "b3-a10": [
        "AC"
    ],
    "b3-a32": [
        "AC"
    ],
    "b3-a30": [
        "AC"
    ],
    "b3-a40fhd": [
        "AC"
    ],
    "b3-a40": [
        "AC"
    ],
    "b3-a42": [
        "AC"
    ],
    "b3-a50": [
        "AC"
    ],
    "b1-730hd": [
        "AC"
    ],
    "b1-750": [
        "AC"
    ],
    "b1-770": [
        "AC"
    ],
    "b1-760hd": [
        "AC"
    ],
    "b1-780": [
        "AC"
    ],
    "b1-7a0": [
        "AC"
    ],
    "b1-820": [
        "AC"
    ],
    "b1-850": [
        "AC"
    ],
    "b1-830": [
        "AC"
    ],
    "b1-870": [
        "AC"
    ],
    "b1-860a": [
        "AC"
    ],
    "a3-a30": [
        "AC"
    ],
    "a3-a40": [
        "AC"
    ],
    "a1-713": [
        "AC"
    ],
    "a1-713hd": [
        "AC"
    ],
    "a1-841": [
        "AC"
    ],
    "a1-840fhd": [
        "AC"
    ],
    "a210": [
        "AC"
    ],
    "a510": [
        "AC"
    ],
    "a511": [
        "AC"
    ],
    "a700": [
        "AC"
    ],
    "a701": [
        "AC"
    ],
    "b1-723": [
        "AC"
    ],
    "b1-733": [
        "AC"
    ],
    "a501": [
        "AC"
    ],
    "a500": [
        "AC"
    ],
    "a200": [
        "AC"
    ],
    "a101": [
        "AC"
    ],
    "introtr3544": [
        "AD"
    ],
    "tr3845": [
        "AD"
    ],
    "excer_10_pro": [
        "AH"
    ],
    "excer g5": [
        "AH"
    ],
    "excer g5.3": [
        "AH"
    ],
    "aktb-703mz": [
        "AK"
    ],
    "tab-7800": [
        "AK"
    ],
    "tab-7830": [
        "AK"
    ],
    "tab-9800": [
        "AK"
    ],
    "tab-9800q": [
        "AK"
    ],
    "9027f": [
        "AL"
    ],
    "9027w": [
        "AL"
    ],
    "9027x": [
        "AL"
    ],
    "9027t": [
        "AL"
    ],
    "9026x": [
        "AL"
    ],
    "9203a": [
        "AL"
    ],
    "onetouch evo7": [
        "AL"
    ],
    "one touch evo7hd": [
        "AL"
    ],
    "one touch evo8hd": [
        "AL"
    ],
    "9010x": [
        "AL"
    ],
    "9007a": [
        "AL"
    ],
    "9007x": [
        "AL"
    ],
    "9007t": [
        "AL"
    ],
    "9003x": [
        "AL"
    ],
    "9003a": [
        "AL"
    ],
    "9024o": [
        "AL"
    ],
    "i213": [
        "AL"
    ],
    "i216x": [
        "AL"
    ],
    "9005x": [
        "AL"
    ],
    "alcatel one touch p310x": [
        "AL"
    ],
    "alcatel one touch p320x": [
        "AL"
    ],
    "one touch t10": [
        "AL"
    ],
    "one touch t20": [
        "AL"
    ],
    "one touch tab 7": [
        "AL"
    ],
    "one touch tab 7hd": [
        "AL"
    ],
    "a101b": [
        "AN"
    ],
    "a101c": [
        "AN"
    ],
    "a101b2-lz": [
        "AN"
    ],
    "an10g2": [
        "AN"
    ],
    "an10g2-lz": [
        "AN"
    ],
    "arnova 101 g4": [
        "AN"
    ],
    "an10bg2": [
        "AN"
    ],
    "an10bg2dt": [
        "AN"
    ],
    "an10bg2i": [
        "AN"
    ],
    "an10bg3": [
        "AN"
    ],
    "an10bg3-lz": [
        "AN"
    ],
    "an10cg3": [
        "AN"
    ],
    "an10dg3": [
        "AN"
    ],
    "an7g2dte": [
        "AN"
    ],
    "an7g2": [
        "AN"
    ],
    "an7g2i": [
        "AN"
    ],
    "an7g3": [
        "AN"
    ],
    "an7bg3": [
        "AN"
    ],
    "an7cg2": [
        "AN"
    ],
    "an7cg3": [
        "AN"
    ],
    "an7dg3b": [
        "AN"
    ],
    "an7dg3": [
        "AN"
    ],
    "an7fg3": [
        "AN"
    ],
    "an7hg3": [
        "AN"
    ],
    "a80ksc": [
        "AN"
    ],
    "an8g2i": [
        "AN"
    ],
    "an8g3": [
        "AN"
    ],
    "an8bg3": [
        "AN"
    ],
    "an8bg3-lz": [
        "AN"
    ],
    "an8cg3": [
        "AN"
    ],
    "an9g2": [
        "AN"
    ],
    "an9g3": [
        "AN"
    ],
    "arnova 90g3": [
        "AN"
    ],
    "arnova 90 g4": [
        "AN"
    ],
    "arnova 97g4": [
        "AN"
    ],
    "an9g2i": [
        "AN"
    ],
    "an7dg3-cp": [
        "AN"
    ],
    "archm901": [
        "AN"
    ],
    "ipad2,1": [
        "AP"
    ],
    "archos 101 cobalt": [
        "AR"
    ],
    "archos 101 neon": [
        "AR",
        "JG"
    ],
    "archos 101 platinum": [
        "AR"
    ],
    "archos 101 titanium": [
        "AR"
    ],
    "archos 101 xenon": [
        "AR"
    ],
    "archos 101 xs 2": [
        "AR"
    ],
    "ac101bhe": [
        "AR"
    ],
    "archos 101g10": [
        "AR"
    ],
    "archos 101g9": [
        "AR"
    ],
    "archos5": [
        "AR"
    ],
    "archos 70 cobalt": [
        "AR"
    ],
    "archos 70 titanium": [
        "AR"
    ],
    "archos 70 xenon": [
        "AR"
    ],
    "archos 70b titanium": [
        "AR"
    ],
    "archos 70it2": [
        "AR"
    ],
    "archos 79 platinum": [
        "AR"
    ],
    "archos 80 carbon": [
        "AR"
    ],
    "archos 80 childpad": [
        "AR"
    ],
    "archos 80 cobalt": [
        "AR"
    ],
    "archos 80 platinum": [
        "AR"
    ],
    "archos 80 titanium": [
        "AR"
    ],
    "archos 80 xenon": [
        "AR"
    ],
    "archos 80b platinum": [
        "AR"
    ],
    "archos 80g9": [
        "AR"
    ],
    "archos 80xsk": [
        "AR"
    ],
    "archos 97 carbon": [
        "AR"
    ],
    "archos 97 cobalt": [
        "AR"
    ],
    "archos 97 titaniumhd": [
        "AR"
    ],
    "archos 97 xenon": [
        "AR"
    ],
    "archos 97b platinum": [
        "AR"
    ],
    "archos 97b titanium": [
        "AR"
    ],
    "archos chefpad": [
        "AR"
    ],
    "archos familypad 2": [
        "AR"
    ],
    "me171": [
        "AU",
        "MR"
    ],
    "slider sl101": [
        "AU",
        "WI"
    ],
    "me172v": [
        "AU",
        "MR"
    ],
    "k00f": [
        "AU"
    ],
    "k01e": [
        "AU"
    ],
    "k01a": [
        "AU"
    ],
    "k013": [
        "AU"
    ],
    "asus memo pad 7": [
        "AU"
    ],
    "k007": [
        "AU"
    ],
    "k00r": [
        "AU"
    ],
    "k00l": [
        "AU"
    ],
    "k011": [
        "AU"
    ],
    "k014": [
        "AU"
    ],
    "me302c": [
        "AU",
        "MR"
    ],
    "me302kl": [
        "AU"
    ],
    "memo pad fhd 10 lte": [
        "AU"
    ],
    "k00u": [
        "AU"
    ],
    "me173x": [
        "AU",
        "MR"
    ],
    "asus k00s": [
        "AU"
    ],
    "me301t": [
        "AU",
        "MR"
    ],
    "k010": [
        "AU"
    ],
    "k018": [
        "AU"
    ],
    "asus transformer pad tf300t": [
        "AU"
    ],
    "asus pad tf300t": [
        "AU"
    ],
    "tf300t": [
        "AU"
    ],
    "asus transformer pad tf300tg": [
        "AU"
    ],
    "asus transformer pad tf300tl": [
        "AU"
    ],
    "k01b": [
        "AU"
    ],
    "asus transformer pad tf700kl": [
        "AU"
    ],
    "asus transformer pad tf700t": [
        "AU"
    ],
    "k00c": [
        "AU"
    ],
    "transformer prime tf201": [
        "AU"
    ],
    "transformer tf101": [
        "AU"
    ],
    "transformer tf101g": [
        "AU"
    ],
    "asus x pad 10 lte": [
        "AU"
    ],
    "asus z101": [
        "AU"
    ],
    "asus z906": [
        "AU"
    ],
    "p01t_1": [
        "AU"
    ],
    "p021": [
        "AU"
    ],
    "p023": [
        "AU"
    ],
    "p00l": [
        "AU"
    ],
    "p028": [
        "AU"
    ],
    "p00c": [
        "AU"
    ],
    "p027": [
        "AU"
    ],
    "p00i": [
        "AU"
    ],
    "asus_p00i": [
        "AU"
    ],
    "p01v": [
        "AU"
    ],
    "p01w": [
        "AU"
    ],
    "p00a": [
        "AU"
    ],
    "p01y": [
        "AU"
    ],
    "p01z": [
        "AU"
    ],
    "p01ma": [
        "AU"
    ],
    "p01m": [
        "AU"
    ],
    "p001": [
        "AU"
    ],
    "asus_p00j": [
        "AU"
    ],
    "avvio pad": [
        "AV"
    ],
    "axxion atab-701": [
        "AY"
    ],
    "axxion atab-902": [
        "AY"
    ],
    "novo10 hero": [
        "AZ"
    ],
    "novo 10 hero quadcore": [
        "AZ"
    ],
    "novo10 spark": [
        "AZ"
    ],
    "novo7": [
        "AZ"
    ],
    "novo7 flame": [
        "AZ"
    ],
    "numy 3g ax1": [
        "AZ"
    ],
    "numy 3g ax10t": [
        "AZ"
    ],
    "novo9-spark": [
        "AZ"
    ],
    "numy_3g_aw1": [
        "AZ"
    ],
    "numy3gax9": [
        "AZ"
    ],
    "numy3gtalos": [
        "AZ"
    ],
    "numy_3g_bw1": [
        "AZ"
    ],
    "numy_3g_vegas": [
        "AZ"
    ],
    "ax10pro": [
        "AZ"
    ],
    "numy_3g_ax3": [
        "AZ"
    ],
    "numy_note_9": [
        "AZ"
    ],
    "x-viewtablet": [
        "XV"
    ],
    "x_game": [
        "3A"
    ],
    "egl11qf6": [
        "GW"
    ],
    "volta4": [
        "3O"
    ],
    "sm-x616b": [
        "SA"
    ],
    "sky 1264c 4g ss1271pl": [
        "W8"
    ],
    "walpad8g": [
        "WA"
    ],
    "walpad_8g": [
        "WA"
    ],
    "poke3": [
        "3O"
    ],
    "tf-led40s63t2s_536d400pf33_fhd": [
        "TL"
    ],
    "gtking": [
        "B0"
    ],
    "blaupunkt 4k android tv": [
        "BP"
    ],
    "tb-g01": [
        "S9"
    ],
    "nexon x2": [
        "N8"
    ],
    "z28pro": [
        "3L"
    ],
    "32h700gu": [
        "KV"
    ],
    "wiwa dream player": [
        "W4"
    ],
    "wiwa dream player tv": [
        "W4"
    ],
    "rombica smart box v006": [
        "R3"
    ],
    "smotreshka box 115na": [
        "1Q"
    ],
    "smotreshka box 413na": [
        "1Q"
    ],
    "smotreshka box 213a": [
        "1Q"
    ],
    "smotreshka box 213": [
        "1Q"
    ],
    "toucan nano 4k": [
        "I2"
    ],
    "toucan stick 4k": [
        "I2"
    ],
    "vmp023.p.02.d4": [
        "V7"
    ],
    "digma shell lc430duy": [
        "D2"
    ],
    "digma shell t320xvn02.g": [
        "D2"
    ],
    "digma shell lc390tu1a": [
        "D2"
    ],
    "mystery shell 536d420cf12_fhd": [
        "6M"
    ],
    "mystery shell 536d315ph21_hd": [
        "6M"
    ],
    "telefunken shell 536d480xf64_fhd": [
        "TL"
    ],
    "eled-43samrt": [
        "JE"
    ],
    "eled-43smart": [
        "JE"
    ],
    "eled-50smart_uhd": [
        "JE"
    ],
    "eled-55cv_smart_uhd": [
        "JE"
    ],
    "eled-42smart": [
        "JE"
    ],
    "eled-48smart": [
        "JE"
    ],
    "eled-32smart": [
        "JE"
    ],
    "digma shell hv320whb-n85": [
        "D2"
    ],
    "telefunken shell 536d315ph41_hd": [
        "TL"
    ],
    "telefunken shell 536d315ch37_hd": [
        "TL"
    ],
    "telefunken shell 536d315xh31_hd": [
        "TL"
    ],
    "telefunken shell 536d420cf11_fhd": [
        "TL"
    ],
    "telefunken shell 536d480xf52_fhd": [
        "TL"
    ],
    "telefunken shell 536d315xh28_hd": [
        "TL"
    ],
    "mystery shell 536d315xh33_hd": [
        "6M"
    ],
    "mystery shell 536d315ch23_hd": [
        "6M"
    ],
    "mystery shell t430hvn01_fhd": [
        "6M"
    ],
    "mystery shell 536s236ch51_hd": [
        "6M"
    ],
    "mystery shell 536d500cf51_fhd": [
        "6M"
    ],
    "mystery shell 536d480xf31_fhd": [
        "6M"
    ],
    "mystery shell 536d430lf12_fhd": [
        "6M"
    ],
    "mystery shell 536d400xf54_fhd": [
        "6M"
    ],
    "mystery shell 536d400xf31_fhd": [
        "6M"
    ],
    "jvc shell 536d480xf61_fhd": [
        "JV"
    ],
    "jvc shell 536d4306lf12_fhd": [
        "JV"
    ],
    "jvc shell 536d4205cf1b_fhd": [
        "JV"
    ],
    "jvc shell 536d400xf54_fhd": [
        "JV"
    ],
    "jvc shell 536d315xh33_hd": [
        "JV"
    ],
    "yuno shell smarttv": [
        "LM"
    ],
    "yasin android tv": [
        "YJ"
    ],
    "aftwi001": [
        "O9"
    ],
    "aftkmst12": [
        "TS",
        "KN"
    ],
    "aftss": [
        "KN"
    ],
    "aftsss": [
        "KN"
    ],
    "aftbamr311": [
        "TS"
    ],
    "digifors 400": [
        "Q0"
    ],
    "mitv-aesp0": [
        "XI"
    ],
    "as_4k_ci": [
        "OH"
    ],
    "as_4k_ci_pro": [
        "OH"
    ],
    "provision s1": [
        "R0"
    ],
    "kdl48w605b": [
        "SO"
    ],
    "kdl40w705c": [
        "SO"
    ],
    "kd49x8505b": [
        "SO"
    ],
    "kdl32w603a": [
        "SO"
    ],
    "aftmm": [
        "74",
        "KN"
    ],
    "mts tv box 317": [
        "M9"
    ],
    "perfeo_pf_a4551": [
        "93"
    ],
    "telia box": [
        "65"
    ],
    "s70cds": [
        "4D"
    ],
    "nexus player": [
        "GO"
    ],
    "chromecast": [
        "GO"
    ],
    "iconbit stick": [
        "I2"
    ],
    "kj-smart4k": [
        "K6"
    ],
    "gi uni2": [
        "99"
    ],
    "mito_3255": [
        "8M"
    ],
    "tx6s": [
        "9N",
        "PT"
    ],
    "tx9s": [
        "9N",
        "PT"
    ],
    "gtx-r10i pro": [
        "Q4"
    ],
    "gtking_at": [
        "B0"
    ],
    "u43f8000q": [
        "DX"
    ],
    "ugoos-am3": [
        "UG"
    ],
    "leap-s1": [
        "96"
    ],
    "polar_p24l51t2csm": [
        "Q6"
    ],
    "mygica hdr smart tv box": [
        "07"
    ],
    "mygica hdr quad core box": [
        "07"
    ],
    "mygica atv1900 no wv": [
        "07"
    ],
    "mygica atv495 pro 16g": [
        "07"
    ],
    "mygica quad core enjoy tv box": [
        "07"
    ],
    "mygica atv1960": [
        "07"
    ],
    "paladin tv": [
        "YP"
    ],
    "haieratvnippori": [
        "HA"
    ],
    "polarline_32pl13tc-sm": [
        "97"
    ],
    "rombica smart box b1": [
        "R3"
    ],
    "nexon x3+": [
        "N8"
    ],
    "beyondtv2": [
        "TC"
    ],
    "beyondtv5": [
        "TC"
    ],
    "nwx-40f171msy": [
        "NQ"
    ],
    "beyondtv": [
        "TC"
    ],
    "gtking pro": [
        "B0"
    ],
    "rombica smart box q2": [
        "R3"
    ],
    "atv r1": [
        "KL"
    ],
    "tx3 mini": [
        "9N",
        "PT"
    ],
    "rombica tv ultima": [
        "R3"
    ],
    "polar_p40l33t2csm": [
        "Q6"
    ],
    "perfeo_pf_a4552": [
        "93"
    ],
    "rombica tv fly": [
        "R3",
        "FL"
    ],
    "42flea73t2sm": [
        "05"
    ],
    "43u800br": [
        "KV"
    ],
    "smart box d1": [
        "R3"
    ],
    "smart box f2": [
        "R3"
    ],
    "smart box x1": [
        "R3"
    ],
    "smart box z1": [
        "R3"
    ],
    "smart box h4": [
        "R3"
    ],
    "smart box g2": [
        "R3"
    ],
    "smart box a1": [
        "R3"
    ],
    "smart box a3": [
        "R3"
    ],
    "smart box d2": [
        "R3"
    ],
    "tf-led40s19t2s": [
        "TL"
    ],
    "stv-40led25s": [
        "78"
    ],
    "stv-40led42s": [
        "78"
    ],
    "stv_32led42s": [
        "78"
    ],
    "sun_led32s11": [
        "W8"
    ],
    "40fr52br": [
        "KV"
    ],
    "h96 max": [
        "9Z"
    ],
    "h96 max rk3318": [
        "9Z"
    ],
    "qg9": [
        "60"
    ],
    "mdtv": [
        "1Y"
    ],
    "fo-r15": [],
    "tvbox": [],
    "mbox": [
        "28"
    ],
    "smart tv": [],
    "qbox": [
        "Q7"
    ],
    "m8s+ 4k": [],
    "pcbox": [],
    "rk3368-box": [],
    "hismart 4k atv4": [
        "HI"
    ],
    "smart_starwind": [
        "45"
    ],
    "h10 play": [],
    "mecool-bb2": [
        "0M"
    ],
    "stv_32led30c": [
        "78"
    ],
    "tf-led32s75t2s": [
        "TL"
    ],
    "x-media": [
        "D6"
    ],
    "dvs x3": [
        "D6"
    ],
    "artline-kmx3": [
        "59"
    ],
    "50lex-8173/uts2c": [
        "BB"
    ],
    "55lex-8161/uts2c": [
        "BB"
    ],
    "55lex-8162/uts2c": [
        "BB"
    ],
    "dm-led43sr23": [
        "D2"
    ],
    "dm-led24sr20": [
        "D2"
    ],
    "55lex-8174/uts2c": [
        "BB"
    ],
    "28lh7011t": [
        "8A"
    ],
    "32lh7010t": [
        "8A"
    ],
    "32h520t": [
        "4B"
    ],
    "kivi 4k android tv": [
        "KV"
    ],
    "kivi 2k android tv": [
        "KV"
    ],
    "ot-dvb30": [
        "Y6"
    ],
    "nv711wac": [
        "4E"
    ],
    "haieratv": [
        "HA"
    ],
    "amigo7": [
        "3J"
    ],
    "amigo7xyuf": [
        "3J"
    ],
    "amigo7xscb": [
        "3J"
    ],
    "s_turbo_pro": [
        "F5"
    ],
    "n5nova": [
        "6Y"
    ],
    "neo u22-xj": [
        "1X"
    ],
    "pendoo t95": [
        "PQ"
    ],
    "transpeed x4s": [
        "5R"
    ],
    "changhong tv": [
        "C2"
    ],
    "h96 max x2": [
        "9Z"
    ],
    "smart aio tv": [],
    "tvbox_l": [],
    "smartatv": [],
    "l-box": [],
    "tvbox-5g": [],
    "smart_tv": [],
    "32lh7030s": [
        "8A"
    ],
    "smarttv": [],
    "atmaca_smarttv": [
        "5Q"
    ],
    "evbox-plus+": [
        "5U"
    ],
    "kingbox": [
        "5W"
    ],
    "mbox3": [
        "28"
    ],
    "horizont 32le7011d": [
        "4H"
    ],
    "vinabox_x20": [
        "XD"
    ],
    "rombica_cinema4k_v01": [
        "R3"
    ],
    "iconbit xds1000": [
        "I2"
    ],
    "43u600kd": [
        "KV"
    ],
    "dv8304-c": [
        "M9"
    ],
    "b867re": [
        "ZT"
    ],
    "full aosp on noontec": [
        "6H"
    ],
    "aosp on smartbox": [],
    "ja-jp": [
        "PA"
    ],
    "mitv-mooq0": [
        "XI"
    ],
    "32h600kd": [
        "KV"
    ],
    "32tp1hdta1": [
        "39"
    ],
    "bravia 4k ur3": [
        "SO"
    ],
    "aftka": [
        "KN"
    ],
    "le32ct5515ak": [
        "E7"
    ],
    "mitv-axso2": [
        "XI"
    ],
    "mitv-axso1": [
        "XI"
    ],
    "mitv4i": [
        "XI"
    ],
    "mitv-mssp2": [
        "XI"
    ],
    "mitv-mssp3": [
        "XI"
    ],
    "mitv-ansp0": [
        "XI"
    ],
    "tv box": [],
    "bravia vh1": [
        "SO"
    ],
    "bravia 4k ur1": [
        "SO"
    ],
    "bravia 4k vh2": [
        "SO"
    ],
    "bravia vu1": [
        "SO"
    ],
    "aquos-tvx19a": [
        "SH"
    ],
    "aquos-tvx19b": [
        "SH"
    ],
    "aquos-tvj21-2": [
        "SH"
    ],
    "aquos-tvx21a": [
        "SH"
    ],
    "vodafone tv": [
        "VF"
    ],
    "eko android tv": [
        "EK"
    ],
    "eko android tv 2k": [
        "EK"
    ],
    "eko 2k android tv": [
        "EK"
    ],
    "eko 4k android tv": [
        "EK"
    ],
    "kogan tv": [
        "KG"
    ],
    "kogan smartertv": [
        "KG"
    ],
    "kogan smartertv 2k": [
        "KG"
    ],
    "kogantvap": [
        "KG"
    ],
    "mitv-mteq0": [
        "XI"
    ],
    "vesta_smart_tv": [
        "V8"
    ],
    "hismart 2k atv4": [
        "HI"
    ],
    "bravia 8k ur3": [
        "SO"
    ],
    "evpad-5s": [
        "5U"
    ],
    "polarline_k_55pu11tc-sm": [
        "97"
    ],
    "polarline_24pl51tc-sm": [
        "97"
    ],
    "as1_hd": [
        "OH"
    ],
    "kk max": [
        "1V"
    ],
    "tf-led40s41t2s": [
        "TL"
    ],
    "40lex_7171_fts2c": [
        "BB"
    ],
    "50u730gr": [
        "KV"
    ],
    "rombica smart box a1": [
        "R3"
    ],
    "rombica smart box f2": [
        "R3"
    ],
    "tf-led32s60t2s": [
        "TL"
    ],
    "tf-led43s94t2s": [
        "TL"
    ],
    "ex-32hs016b": [
        "35"
    ],
    "28lh7010t": [
        "8A"
    ],
    "42flx9060t2": [
        "05"
    ],
    "2020/2021 uhd android tv": [
        "PH"
    ],
    "2021/22 philips uhd android tv": [
        "PH"
    ],
    "gigatv": [
        "VF"
    ],
    "iconbit movie play": [
        "I2"
    ],
    "dm-led42sr24": [
        "D2"
    ],
    "yuno.pt430ct02.1.cv358h.t42": [
        "YN"
    ],
    "43u800bu": [
        "KV"
    ],
    "32f700wu": [
        "KV"
    ],
    "tf-led43s22t2su": [
        "TL"
    ],
    "hph07": [
        "11"
    ],
    "iconbit movie uno": [
        "I2"
    ],
    "lcd_xxsufoc475a": [
        "SH"
    ],
    "ptv32ss04z_cis_ml": [
        "PR"
    ],
    "mitv-ayfr0": [
        "XI"
    ],
    "neo-x8": [
        "1X"
    ],
    "neo-x8-plus": [
        "1X"
    ],
    "ttk box 214": [
        "TTK"
    ],
    "t96mini": [
        "T96"
    ],
    "zealot": [
        "ZEA"
    ],
    "x88pro10.r1.00.6330.d4": [
        "X88"
    ],
    "x96air_a100": [
        "X96"
    ],
    "h96max rk3318": [
        "9Z"
    ],
    "iconbit xds1100": [
        "I2"
    ],
    "rst_b1103hd": [
        "LEG"
    ],
    "55u600kd": [
        "KV"
    ],
    "aquos_tve19a": [
        "SH"
    ],
    "hb-2000": [
        "NTT"
    ],
    "formuler z alpha": [
        "F5"
    ],
    "as_4k_ci_pro_plus": [
        "OH"
    ],
    "as_4k_plus": [
        "OH"
    ],
    "as_4k_2x": [
        "OH"
    ],
    "as4k": [
        "OH"
    ],
    "as4k-2x": [
        "OH"
    ],
    "as4k-plus": [
        "OH"
    ],
    "as4k_ci": [
        "OH"
    ],
    "as_4k": [
        "OH"
    ],
    "as4k_ci_pro": [
        "OH"
    ],
    "sh6b7ce_eu012": [
        "96"
    ],
    "aftdct31": [
        "TS",
        "KN"
    ],
    "rombica smart box l2": [
        "R3"
    ],
    "24lex_7155/uts2c": [
        "BB"
    ],
    "polarline_40pl52tc-sm": [
        "97"
    ],
    "adt-2": [
        "GO"
    ],
    "orbsmart s86": [
        "ORB"
    ],
    "tox1": [
        "TOX"
    ],
    "topsion": [
        "TO1"
    ],
    "viva_home": [
        "A2"
    ],
    "pab4411": [
        "PR"
    ],
    "gi itv912": [
        "99"
    ],
    "kant-369": [
        "HU"
    ],
    "kant-360s": [
        "HU"
    ],
    "kant-360": [
        "HU"
    ],
    "horizont 43le7022d": [
        "4H"
    ],
    "tf-led32s74t2s": [
        "TL"
    ],
    "rombica smart stick pro": [
        "R3"
    ],
    "x96q": [
        "96Q"
    ],
    "at&t tv": [],
    "km6": [
        "0M"
    ],
    "km1": [
        "0M"
    ],
    "km3": [
        "0M"
    ],
    "km9": [
        "0M"
    ],
    "km5": [
        "0M"
    ],
    "ugoos-um3": [
        "UG"
    ],
    "ugoos-um4": [
        "UG"
    ],
    "ugoos-ut3": [
        "UG"
    ],
    "ugoos-ut3s": [
        "UG"
    ],
    "ugoos-um2": [
        "UG"
    ],
    "ugoos-ut2": [
        "UG"
    ],
    "ugoos-ut1": [
        "UG"
    ],
    "ugoos-am1": [
        "UG"
    ],
    "ugoos-ut4": [
        "UG"
    ],
    "ugoos-ut3plus": [
        "UG"
    ],
    "s900probt": [
        "UNB"
    ],
    "s900_pro": [
        "UNB"
    ],
    "abx-332": [
        "HAR"
    ],
    "polarline_k_32pl13tc-sm": [
        "97"
    ],
    "polarline_k_32pl14tc-sm": [
        "97"
    ],
    "h32f8000c": [
        "DX"
    ],
    "43lu8010t": [
        "8A"
    ],
    "40u600kd": [
        "KV"
    ],
    "rombica tv mercury": [
        "R3"
    ],
    "rombica smart box q1": [
        "R3"
    ],
    "x96_x6_i": [
        "X96"
    ],
    "x96max_plus_ultra": [
        "X96"
    ],
    "x88pro10.r1.dd.6330.xy.d4": [
        "X88"
    ],
    "x88pro10.r.dd.6330.d4": [
        "X88"
    ],
    "gazer_tv": [
        "GAZ"
    ],
    "ec6108v8": [
        "HU"
    ],
    "ec6108v9-01": [
        "HU"
    ],
    "evolveo android stick q4": [
        "EO",
        "60"
    ],
    "yundoo-y2": [
        "YUN"
    ],
    "yundoo-y6": [
        "YUN"
    ],
    "yundoo-y7": [
        "YUN"
    ],
    "yundoo-y8": [
        "YUN"
    ],
    "md09tv": [
        "BIL"
    ],
    "dreamstar a4": [
        "DR1"
    ],
    "movix pro": [
        "DOM"
    ],
    "movix pro voice": [
        "DOM"
    ],
    "tx3mini": [
        "9N",
        "PT"
    ],
    "tx3 max": [
        "9N",
        "PT"
    ],
    "evpad-3s": [
        "5U"
    ],
    "abx-210": [
        "HAR"
    ],
    "abx-110": [
        "HAR"
    ],
    "xr4500": [
        "BUZ"
    ],
    "rk3368": [],
    "rk322x-box": [],
    "rk3128_box": [],
    "realtekatv": [],
    "tim_box": [
        "TIM"
    ],
    "flowbox-f1": [
        "SK"
    ],
    "leelbox": [
        "LEE"
    ],
    "divermax speedbox 3 sb1800": [
        "DIV"
    ],
    "ut8": [
        "UG"
    ],
    "ptv32ss04z_cis_bk": [
        "PR"
    ],
    "ptv50ss04x_cis_bk": [
        "PR"
    ],
    "50lex-8127/uts2c": [
        "BB"
    ],
    "polarline_w_40pl11tc-sm": [
        "97"
    ],
    "sw-led32sb302": [
        "45"
    ],
    "sw-led42sb300": [
        "45"
    ],
    "h-led55eu1311": [
        "HN"
    ],
    "f43f8000q": [
        "DX"
    ],
    "f32g8000c": [
        "DX"
    ],
    "f32f8000c": [
        "DX"
    ],
    "dragon_ott_1_box": [
        "DRA"
    ],
    "vhix-43u169msy": [
        "3H"
    ],
    "vhix-43f169msy": [
        "3H"
    ],
    "vhix-65u169tsy-c": [
        "3H"
    ],
    "vhix-vhix-43u169msy": [
        "3H"
    ],
    "vhix-40f152msy": [
        "3H"
    ],
    "vhix-40f152msyb": [
        "3H"
    ],
    "tx5 pro": [
        "9N",
        "PT"
    ],
    "xdsr785hdr_avant": [
        "XCR"
    ],
    "x96mate_plus": [
        "X96"
    ],
    "h96_max_rk3566": [
        "9Z"
    ],
    "h96_max_rk3318": [
        "9Z"
    ],
    "h96_max_v11": [
        "9Z"
    ],
    "optima_t-ii": [
        "D6"
    ],
    "iconbit xds110": [
        "I2"
    ],
    "tp01_box": [
        "TO1"
    ],
    "32yst5970": [
        "SKY"
    ],
    "32lh1210": [
        "VHM"
    ],
    "32y_stv-r": [
        "HIB"
    ],
    "39hsy111x": [
        "3H"
    ],
    "55usy151x": [
        "3H"
    ],
    "u43f8000eg": [
        "DX"
    ],
    "u55g8000qg": [
        "DX"
    ],
    "u50g9000cg": [
        "DX"
    ],
    "tf-led58s06t2su": [
        "TL"
    ],
    "skyline 50ust5970": [
        "SKY"
    ],
    "ptv40ss04y_cis_ml": [
        "PR"
    ],
    "hty-55uhd11b-s2": [
        "HA1"
    ],
    "hty-50uhdo11mg-hc22": [
        "HA1"
    ],
    "hty-50uhdo11g-hc22": [
        "HA1"
    ],
    "hty-43fhd06b-s2": [
        "HA1"
    ],
    "hty-32hdro6b-hc22": [
        "HA1"
    ],
    "39les80t2sm": [
        "05"
    ],
    "24lh7020t": [
        "8A"
    ],
    "ulx-55utcs3234": [
        "YN"
    ],
    "ulx-32tcs226-b": [
        "YN"
    ],
    "u50g8000qg-a": [
        "DX"
    ],
    "u50g8000qg": [
        "DX"
    ],
    "u43h8000e": [
        "DX"
    ],
    "u43f8100qg": [
        "DX"
    ],
    "smart_tv_bq": [
        "BX"
    ],
    "h39f8000q": [
        "DX"
    ],
    "h32g8000cg": [
        "DX"
    ],
    "h32f8100q": [
        "DX"
    ],
    "h32f8000q-f": [
        "DX"
    ],
    "h32f8000q-e": [
        "DX"
    ],
    "h32f8000q-a": [
        "DX"
    ],
    "h32f8000q-d": [
        "DX"
    ],
    "h24h8000c": [
        "DX"
    ],
    "h24f8000q": [
        "DX"
    ],
    "32ghs57": [
        "DF"
    ],
    "32h540s": [
        "4B"
    ],
    "32h530t": [
        "4B"
    ],
    "32hsy119x": [
        "3H"
    ],
    "55u730gr": [
        "KV"
    ],
    "u43g9000cg": [
        "DX"
    ],
    "f43f8000qg": [
        "DX"
    ],
    "gi fly t2": [
        "99"
    ],
    "32lex-7162/ts2c": [
        "BB"
    ],
    "10moons_t2": [
        "10M"
    ],
    "eo104k_bl": [
        "BPC"
    ],
    "eo104k-bl": [
        "BPC"
    ],
    "boxd7": [
        "DEA"
    ],
    "supra shell hv550qub-b05": [
        "S5"
    ],
    "smart box f3": [
        "R3"
    ],
    "smart box b1": [
        "R3"
    ],
    "h-dmp100": [
        "HN"
    ],
    "neko_lt-50nx7020s": [
        "NEK"
    ],
    "neko_lt-43nx8000s": [
        "NEK"
    ],
    "haier android tv ff pro": [
        "HA"
    ],
    "sm-led32m04s_-ver01": [
        "X2",
        "SA"
    ],
    "smart box c1": [
        "R3"
    ],
    "as_4k_ci_lite": [
        "OH"
    ],
    "you-box": [
        "YOU"
    ],
    "qk9max": [
        "60"
    ],
    "superbox_s2pro": [
        "SBX"
    ],
    "polar_wk_p43u51t2scsm": [
        "Q6"
    ],
    "polar_wk_p39l21t2csm": [
        "Q6"
    ],
    "youwei mini5g": [
        "YO1"
    ],
    "vim2": [
        "KHA"
    ],
    "vinabox_x2-2018": [
        "XD"
    ],
    "vinabox-x10plus": [
        "XD"
    ],
    "vinabox x9 2018": [
        "XD"
    ],
    "vinabox-x9": [
        "XD"
    ],
    "vinabox-x2": [
        "XD"
    ],
    "32f700gr": [
        "KV"
    ],
    "ulx-43utcs347": [
        "YN"
    ],
    "bravia vu31": [
        "SO"
    ],
    "bravia vu2": [
        "SO"
    ],
    "rombica tv air": [
        "R3",
        "A95"
    ],
    "nv720wb": [
        "4E"
    ],
    "lpx-g box max": [
        "LPX"
    ],
    "tf500": [
        "TL"
    ],
    "olto-43st20u": [
        "OLT"
    ],
    "tesla xt550": [
        "C7",
        "MR"
    ],
    "perfeo_pf_a4553": [
        "93"
    ],
    "ipc002": [
        "4I"
    ],
    "km9 pro": [
        "0M"
    ],
    "aftti43": [
        "KN"
    ],
    "aftso001": [
        "JV",
        "KN"
    ],
    "gtcombo": [
        "GTM"
    ],
    "smart box y1": [
        "R3"
    ],
    "swg2001a-a": [
        "B5"
    ],
    "stb0819": [
        "EG"
    ],
    "wud55h7762sn": [
        "WA1"
    ],
    "wud55g7762s": [
        "WA1"
    ],
    "vibox v5 pro": [
        "VIB"
    ],
    "vibox_v2_pro": [
        "VIB"
    ],
    "hk1 mini+": [
        "1V"
    ],
    "vontar x4": [
        "1V"
    ],
    "vontar x2": [
        "1V"
    ],
    "dexp shell pt320at01-5": [
        "DX"
    ],
    "yandexmodule2-00001": [
        "YD"
    ],
    "dexp shell lc390tu1a": [
        "DX"
    ],
    "32h550t": [
        "4B"
    ],
    "hty-32hdr06g": [
        "HA1"
    ],
    "43f1ydx000bs2": [
        "I6"
    ],
    "h-led40gs5003": [
        "HN"
    ],
    "h32f8000qg-a": [
        "DX"
    ],
    "h32h8001c": [
        "DX"
    ],
    "h32f8000qg": [
        "DX"
    ],
    "dm-led55ur31": [
        "D2"
    ],
    "32lex-7272": [
        "BB"
    ],
    "h32h8051c-g": [
        "DX"
    ],
    "rkm mk902ii": [
        "RI",
        "SE"
    ],
    "rkm mk902": [
        "RI"
    ],
    "rkm mk802iv": [
        "RI",
        "SE"
    ],
    "rkm mk802iiis": [
        "RI",
        "SE"
    ],
    "polar_p32l32t2csm": [
        "Q6"
    ],
    "k50dlx9us": [
        "T0"
    ],
    "k24dlx9hs": [
        "T0"
    ],
    "dm-led32sr21": [
        "D2"
    ],
    "65lex-8173/uts2c": [
        "BB"
    ],
    "65lex-8162/uts2c": [
        "BB"
    ],
    "t40sgled-a15": [
        "EU"
    ],
    "t40sled-a14": [
        "EU"
    ],
    "vivax-40le78t2s2sm": [
        "V5"
    ],
    "selenga_a5": [
        "9G"
    ],
    "tox3": [
        "UG"
    ],
    "x96mini_11": [
        "X96"
    ],
    "nexon x1+": [
        "N8"
    ],
    "3188hd": [
        "NZP"
    ],
    "r68 ii": [
        "B0"
    ],
    "pyramid a5x": [
        "RUP"
    ],
    "orbsmart h-01": [
        "ORB"
    ],
    "nogapc pro": [
        "OG"
    ],
    "nogapc live": [
        "OG"
    ],
    "mystery_tv_d4906xf16": [
        "6M"
    ],
    "mystery_tv_d4306lf13": [
        "6M"
    ],
    "mystery_tv_d3155sh12": [
        "6M"
    ],
    "mystery_tv_d2365ch58_ua": [
        "6M"
    ],
    "mystery_tv_d2365ch58": [
        "6M"
    ],
    "chromecast hd": [
        "GO"
    ],
    "b-stream": [
        "BP"
    ],
    "iconbit movie x": [
        "I2"
    ],
    "hiper media stick 4k": [
        "HIP"
    ],
    "hiper media tv 6k": [
        "HIP"
    ],
    "hiper media tv i4 pro": [
        "HIP"
    ],
    "hiper media tv i4": [
        "HIP"
    ],
    "40lex-7257fts2c": [
        "BB"
    ],
    "40lex-7259fts2c": [
        "BB"
    ],
    "43lex-8243uts2c": [
        "BB"
    ],
    "topdevice_tdtv65bs06u_9632": [
        "TOP"
    ],
    "topdevice_tdtv50bs06u_9632": [
        "TOP"
    ],
    "topdevice_tdtv43bs06u_9632": [
        "TOP"
    ],
    "tdtv32bs02h": [
        "TOP"
    ],
    "kant-359": [
        "HU"
    ],
    "kd1": [
        "0M"
    ],
    "pendoo x11 pro": [
        "PQ"
    ],
    "transpeed x4": [
        "5R"
    ],
    "tf-led50s25t2su": [
        "TL"
    ],
    "tf-led50s04t2su": [
        "TL"
    ],
    "u75h8000k": [
        "DX"
    ],
    "u50h8000e": [
        "DX"
    ],
    "u65h8000k": [
        "DX"
    ],
    "4k google tv stick": [
        "RE"
    ],
    "24lh1207": [
        "VIT"
    ],
    "24lh8010t": [
        "8A"
    ],
    "24yst5970": [
        "SKY"
    ],
    "40lf7030s": [
        "8A"
    ],
    "40lst5970": [
        "SKY"
    ],
    "50lu1210": [
        "VHM"
    ],
    "50lu8120t": [
        "8A"
    ],
    "50u540s": [
        "4B"
    ],
    "55lu1210": [
        "VHM"
    ],
    "55lu8120t": [
        "8A"
    ],
    "55sa703": [
        "SAM"
    ],
    "55u540s": [
        "4B"
    ],
    "vontar h1": [
        "1V"
    ],
    "sw-led32sg300": [
        "45"
    ],
    "sw-led32sg301": [
        "45"
    ],
    "sw-led32sg302": [
        "45"
    ],
    "sw-led40sg300": [
        "45"
    ],
    "sun-led32xs300": [
        "W8"
    ],
    "sun-led24xs310": [
        "W8"
    ],
    "40kfs57": [
        "DF"
    ],
    "40f540s": [
        "4B"
    ],
    "40f660ts": [
        "HAR"
    ],
    "42lf7110t": [
        "8A"
    ],
    "43f550t": [
        "4B"
    ],
    "32khs57": [
        "DF"
    ],
    "32yst5975": [
        "SKY"
    ],
    "mts tv box 303": [
        "M9"
    ],
    "dv8235": [
        "M9"
    ],
    "formuler z10": [
        "F5"
    ],
    "formuler z10 pro max": [
        "F5"
    ],
    "afttiff43": [
        "KN"
    ],
    "netta 3.100m": [
        "GOL"
    ],
    "netta 2 pro": [
        "GOL"
    ],
    "kraft_ktv-p50uhd02t2ciwl": [
        "KRA"
    ],
    "kraft_ktv-p43uhd02t2ciwl": [
        "KRA"
    ],
    "kraft-ktv-g40fhd02t2ciwl": [
        "KRA"
    ],
    "k50dlj10us": [
        "T0"
    ],
    "k43dlj10us": [
        "T0"
    ],
    "k32dlx10hs": [
        "T0"
    ],
    "k32dlj12hs": [
        "T0"
    ],
    "swtv-20ae": [
        "SK"
    ],
    "skystream_3plus": [
        "SK1"
    ],
    "yasin 2k tv": [
        "YJ"
    ],
    "ulx-32tcs226": [
        "YN"
    ],
    "dvb-atv100": [
        "HAT"
    ],
    "ilepo mxq-4k": [
        "ILE"
    ],
    "nvx-32h219msy": [
        "NQ"
    ],
    "nvx-39h211msy": [
        "NQ"
    ],
    "nwx-43f149msyv": [
        "NQ"
    ],
    "ex-39hs004b": [
        "35"
    ],
    "43fsy112xc": [
        "3H"
    ],
    "43fsy112xd": [
        "3H"
    ],
    "32h511t": [
        "4B"
    ],
    "43f530t": [
        "4B"
    ],
    "mitv-mooq1": [
        "XI"
    ],
    "thl box 1": [
        "T4"
    ],
    "thl box 1 pro": [
        "T4"
    ],
    "dangcaphd d8 pro": [
        "DA1"
    ],
    "h32f8000q-b": [
        "DX"
    ],
    "h32f8000q-c": [
        "DX"
    ],
    "h32f8100q-a": [
        "DX"
    ],
    "f43f8000cg": [
        "DX"
    ],
    "f43f8000cg-h": [
        "DX"
    ],
    "f43f8000q-g": [
        "DX"
    ],
    "f43f8000qg-a": [
        "DX"
    ],
    "f43f8000qg-d": [
        "DX"
    ],
    "sfcstb2lite": [
        "X1"
    ],
    "haier android tv dvb2k": [
        "HA"
    ],
    "a95x plus": [
        "A95"
    ],
    "a95x max": [
        "A95"
    ],
    "a95x-f1": [
        "A95"
    ],
    "a95xr5": [
        "A95"
    ],
    "a95x f3": [
        "A95"
    ],
    "a95x f3 air": [
        "A95"
    ],
    "a95x f2": [
        "A95"
    ],
    "a95x-r2": [
        "A95"
    ],
    "a95x-r1": [
        "A95"
    ],
    "a95x-a2": [
        "A95"
    ],
    "a95xw2": [
        "A95"
    ],
    "a95x_f3": [
        "A95"
    ],
    "a95xz2plus": [
        "A95"
    ],
    "a95xz2": [
        "A95"
    ],
    "a95xr3": [
        "A95"
    ],
    "a95x-r3_ru": [
        "A95"
    ],
    "a95x r3": [
        "A95"
    ],
    "a95x max +": [
        "A95"
    ],
    "a95x f2 ru": [
        "A95"
    ],
    "a95x f3 slim": [
        "A95"
    ],
    "a95x pro": [
        "A95"
    ],
    "a95x-a1": [
        "A95"
    ],
    "a95x_f3air_ii": [
        "A95"
    ],
    "a95xf4": [
        "A95"
    ],
    "ab5116-01": [
        "NM"
    ],
    "hty-55uhd05b-s2": [
        "HA1"
    ],
    "baff43yfhd": [
        "BFF"
    ],
    "u65yq2200gr": [
        "HIP"
    ],
    "harper_24r490ts": [
        "HAR"
    ],
    "h-led24bs5000": [
        "HN"
    ],
    "evolveo android box h8": [
        "EO"
    ],
    "evolveo android box h4": [
        "EO"
    ],
    "sw-led43sg302": [
        "45"
    ],
    "32lh8010t": [
        "8A"
    ],
    "32lx9051t2": [
        "05"
    ],
    "toucan smart 3d quad": [
        "I2"
    ],
    "tdtv32bs01h_bk": [
        "TOP"
    ],
    "u55h8050e": [
        "DX"
    ],
    "mitv-mosr1": [
        "XI"
    ],
    "39lex-7289": [
        "BB"
    ],
    "f43h8000k": [
        "DX"
    ],
    "50u1ydx000bs2": [
        "I6"
    ],
    "tdtv24bs02h": [
        "TOP"
    ],
    "32lex-7225ts2c": [
        "BB"
    ],
    "ld-65su8815bs": [
        "VEK"
    ],
    "nvx-43u329msy": [
        "NQ"
    ],
    "u43ey1500b": [
        "ACC"
    ],
    "limez2plus": [
        "LIM"
    ],
    "zidoo_x9": [
        "ZI"
    ],
    "55ules92t2sm": [
        "05"
    ],
    "h-led32fs5005": [
        "HN"
    ],
    "sw-led43sg300": [
        "45"
    ],
    "32lh8110t": [
        "8A"
    ],
    "iconbit movie z": [
        "I2"
    ],
    "ptv32ss08z": [
        "PR"
    ],
    "hty-43f06b-vz": [
        "HA1"
    ],
    "43lst5975": [
        "SKY"
    ],
    "43lu1210": [
        "VHM"
    ],
    "vhix-32f199msa": [
        "3H"
    ],
    "u65g8000q": [
        "DX"
    ],
    "50usy151x": [
        "3H"
    ],
    "h3218000k": [
        "DX"
    ],
    "f32ey1500b": [
        "ACC"
    ],
    "h32i8000k": [
        "DX"
    ],
    "baff32ystv-r": [
        "BFF"
    ],
    "u50yq2200gr": [
        "HIP"
    ],
    "u50h8050eg": [
        "DX"
    ],
    "hty-50uhd11b-s2": [
        "HA1"
    ],
    "le-39zths25": [
        "54"
    ],
    "iron+": [
        "6Y"
    ],
    "rombica smart box a2": [
        "R3"
    ],
    "24lh1211": [
        "VHM"
    ],
    "hty-24h06w-vz": [
        "HA1"
    ],
    "h-led55gu7003": [
        "HN"
    ],
    "movix go": [
        "DOM"
    ],
    "nwx-24h121msy": [
        "NQ"
    ],
    "32le7052d": [
        "4H"
    ],
    "h-led43fs5003": [
        "HN"
    ],
    "vekta ld-32sr4850bs": [
        "VEK"
    ],
    "sw-led24sg303": [
        "45"
    ],
    "sun-led43xu400": [
        "W8"
    ],
    "u43g8100qg": [
        "DX"
    ],
    "nexon x3": [
        "N8"
    ],
    "32h1ydx000bs2": [
        "I6"
    ],
    "32lf7120t": [
        "8A"
    ],
    "43kus65": [
        "DF"
    ],
    "sw-led55ug400": [
        "45"
    ],
    "32h1ydx000fbs2": [
        "I6"
    ],
    "39h1ydx000bs2": [
        "I6"
    ],
    "65le7053d": [
        "4H"
    ],
    "yndx-00071": [
        "YD"
    ],
    "yndx-00072": [
        "YD"
    ],
    "vhix-32h181msy": [
        "3H"
    ],
    "sberbox": [
        "SBR"
    ],
    "sbx604": [
        "SVE"
    ],
    "nwx-32h171msy": [
        "NQ"
    ],
    "lt-32nh8020s": [
        "NEK"
    ],
    "lt-43nf7021s": [
        "NEK"
    ],
    "le-32zths25": [
        "54"
    ],
    "dscs9": [
        "DSD"
    ],
    "f43g8000c": [
        "DX"
    ],
    "ulx-39tcs222": [
        "YN"
    ],
    "32lf8120t": [
        "8A"
    ],
    "polar_w_p32l21t2scsm": [
        "Q6"
    ],
    "polar_wk_p65u51t2csm": [
        "Q6"
    ],
    "polar_wk_p32l32t2csm": [
        "Q6"
    ],
    "polar_wk_p42l21t2csm": [
        "Q6"
    ],
    "polar_wk_p50u51t2scsm": [
        "Q6"
    ],
    "i-910": [
        "GOL"
    ],
    "u50f8000qg": [
        "DX"
    ],
    "32lea73t2sm": [
        "05"
    ],
    "sw-led50ub401": [
        "45"
    ],
    "ld-50su8921bs": [
        "VEK"
    ],
    "neko_w_lt_32nh7020s": [
        "NEK"
    ],
    "65u660ts": [
        "HAR"
    ],
    "24lex-7289": [
        "BB"
    ],
    "55ucy1": [
        "DX"
    ],
    "u43yq2200gr": [
        "HIP"
    ],
    "55lex-8243uts2c": [
        "BB"
    ],
    "50lu8110t": [
        "8A"
    ],
    "50ucy2-g": [
        "DX"
    ],
    "24lh7011t": [
        "8A"
    ],
    "philips uhd android tv": [
        "PH"
    ],
    "32h600gr": [
        "KV"
    ],
    "65usy151x": [
        "3H"
    ],
    "h32yq2200gr": [
        "HIP"
    ],
    "55u630s": [
        "4B"
    ],
    "43lu1204": [
        "VIT"
    ],
    "40lex-7202fts2c": [
        "BB"
    ],
    "43lex-7287ts2c": [
        "BB"
    ],
    "32lex-7289-c": [
        "BB"
    ],
    "55lex-8202uts2c": [
        "BB"
    ],
    "hiberg43yuhd": [
        "HIB"
    ],
    "sw-led43ub404": [
        "45"
    ],
    "vontar h618": [
        "1V"
    ],
    "arcelik android tv": [
        "ARC"
    ],
    "arcelik android uhd tv": [
        "ARC"
    ],
    "arcelik google tv": [
        "ARC"
    ],
    "philips google tv ta1": [
        "PH"
    ],
    "oppocnm632": [
        "OP"
    ],
    "profilo 4k android tv": [
        "PF"
    ],
    "altus android tv": [
        "ALT"
    ],
    "beko android tv": [
        "BEK"
    ],
    "grundig android tv": [
        "GU"
    ],
    "grundig google tv uhd+": [
        "GU"
    ],
    "jvc android tv": [
        "JV"
    ],
    "bauhn 4k android tv": [
        "BAU"
    ],
    "mstar android tv": [
        "3R"
    ],
    "regal google tv": [
        "Z9"
    ],
    "vmp-046-664": [
        "V7"
    ],
    "hty-22fhdo6b-hc22": [
        "HA1"
    ],
    "neko_lt-55nx8000s": [
        "NEK"
    ],
    "dm-led43sbb31": [
        "D2"
    ],
    "32fcy1": [
        "DX"
    ],
    "orbsmart rx-01": [
        "ORB"
    ],
    "sm-led65m01su": [
        "X2",
        "SA"
    ],
    "vontar r3": [
        "1V"
    ],
    "skyline_55u7510": [
        "SKY"
    ],
    "skyline 58u7510": [
        "SKY"
    ],
    "mlt43usd02": [
        "MAU"
    ],
    "mlt32hsx02": [
        "MAU"
    ],
    "mitv-moor4": [
        "XI"
    ],
    "uniontv": [
        "TC"
    ],
    "brandt android tv 638": [
        "8B"
    ],
    "h96 pro+": [
        "9Z"
    ],
    "sagemcom diw387_uhd_oor": [
        "OOR",
        "SAG"
    ],
    "nokia streaming stick 800": [
        "NK"
    ],
    "mitv-afkr0": [
        "XI"
    ],
    "onvo_32ov6000h": [
        "ONV"
    ],
    "onvo smart tv": [
        "ONV"
    ],
    "onvo_42ov6000f": [
        "ONV"
    ],
    "onvo_55ov6000u": [
        "ONV"
    ],
    "saba smart tv": [
        "X5"
    ],
    "nordmende_43nm6000f": [
        "NR"
    ],
    "dreamstar": [
        "DR1"
    ],
    "hiremco": [
        "HIR"
    ],
    "matador pro air": [
        "HIR"
    ],
    "spyboxs11": [
        "NOC"
    ],
    "spyboxs11_plus": [
        "NOC"
    ],
    "hkc 4k ai smart tv": [
        "HKC"
    ],
    "fobem 4k smart tv": [
        "FOB"
    ],
    "gtv-50pu744n": [
        "8G"
    ],
    "transpeed_h616": [
        "5R"
    ],
    "mitv-mssp0": [
        "XI"
    ],
    "invin km7": [
        "4I"
    ],
    "50u600gr": [
        "KV"
    ],
    "selenga_a3": [
        "9G"
    ],
    "selenga_a4": [
        "9G"
    ],
    "selenga a1": [
        "9G"
    ],
    "nexon x8": [
        "N8"
    ],
    "vmp-015-162": [
        "V7"
    ],
    "vmp-025-324": [
        "V7"
    ],
    "formuler z8 pro": [
        "F5"
    ],
    "formuler z8": [
        "F5"
    ],
    "kata box 2": [
        "K0"
    ],
    "alfawise a9": [
        "3L"
    ],
    "vorke z7": [
        "2V"
    ],
    "nv510wac": [
        "4E"
    ],
    "nv510wb": [
        "4E"
    ],
    "kb2 pro": [
        "YK"
    ],
    "ki pro": [
        "0M"
    ],
    "ki plus": [
        "0M"
    ],
    "kiii pro": [
        "0M"
    ],
    "km5pro": [
        "4I"
    ],
    "invin_km8": [
        "4I"
    ],
    "jvc shell 536d5005cf5b_fhd": [
        "JV"
    ],
    "eagle classic pro": [
        "EQ"
    ],
    "eagle elite": [
        "EQ"
    ],
    "eagle gold": [
        "EQ"
    ],
    "changhong android tv": [
        "C2"
    ],
    "atom-216rk": [
        "2A"
    ],
    "omnicast uhd": [
        "I2"
    ],
    "movie smart 4k": [
        "I2"
    ],
    "movie iptv quad": [
        "I2"
    ],
    "evolveo multimedia box m4": [
        "EO"
    ],
    "ergo smartbox sx": [
        "E7"
    ],
    "mystery_tv_d3155ch31_ua": [
        "6M"
    ],
    "nexon x5": [
        "N8"
    ],
    "zidoo_x20 pro": [
        "ZI"
    ],
    "vmp-045-664": [
        "V7"
    ],
    "redbox mini 5(mts)": [
        "M9"
    ],
    "ozonehd fun": [
        "OZ"
    ],
    "andowl-q5": [
        "60"
    ],
    "andowl-q4": [
        "60"
    ],
    "atom-216am": [
        "2A"
    ],
    "rombica smart box v003": [
        "R3"
    ],
    "rombica smart box v004": [
        "R3"
    ],
    "rombica smart box v007": [
        "R3"
    ],
    "rombica smart box v008": [
        "R3"
    ],
    "silelis t-1": [
        "70"
    ],
    "percee tv": [
        "TC"
    ],
    "4ife 4k smart tv box": [
        "04"
    ],
    "smart box v009": [
        "R3"
    ],
    "tx5 max": [
        "9N",
        "PT"
    ],
    "gt1-mini": [
        "B0"
    ],
    "gt1-mini-at": [
        "B0"
    ],
    "gt1mini-2": [
        "B0"
    ],
    "tb-po1": [
        "S9"
    ],
    "tb-b01": [
        "S9"
    ],
    "55ur50gu": [
        "KV"
    ],
    "32le77sm": [
        "V5"
    ],
    "40le77sm": [
        "V5"
    ],
    "50ux10s": [
        "KV"
    ],
    "55up50gr": [
        "KV"
    ],
    "55uc50gu": [
        "KV"
    ],
    "55uc50gr": [
        "KV"
    ],
    "65up50gu": [
        "KV"
    ],
    "65lex_8139_uts2c": [
        "BB"
    ],
    "55lex_8158_uts2c": [
        "BB"
    ],
    "55lex_8145_uts2c": [
        "BB"
    ],
    "55lex_8127_uts2c": [
        "BB"
    ],
    "55u600gu": [
        "KV"
    ],
    "55u600gr": [
        "KV"
    ],
    "43lex_8161_uts2c": [
        "BB"
    ],
    "43lex_7158_fts2c": [
        "BB"
    ],
    "43lex_7127_fts2c": [
        "BB"
    ],
    "40lex_7158_fts2c": [
        "BB"
    ],
    "40lex_7143_fts2c": [
        "BB"
    ],
    "40lex_7127_fts2c": [
        "BB"
    ],
    "32lex_7178_ts2c": [
        "BB"
    ],
    "32lex_7168_ts2c": [
        "BB"
    ],
    "32lex_7163_ts2c": [
        "BB"
    ],
    "32lex_7158_ts2c": [
        "BB"
    ],
    "32lex_7154_ts2c": [
        "BB"
    ],
    "32lex_7143_ts2c": [
        "BB"
    ],
    "32lex_7137_ts2c": [
        "BB"
    ],
    "32lex-7166/ts2c": [
        "BB"
    ],
    "32lex-7145/ts2c": [
        "BB"
    ],
    "32lex-7127": [
        "BB"
    ],
    "39lex-7145": [
        "BB"
    ],
    "39lex-7155/ts2c": [
        "BB"
    ],
    "28lex_7144_ts2c": [
        "BB"
    ],
    "sunwell_t95zplus": [
        "5S"
    ],
    "polar_wk_p32l55t2csm": [
        "Q6"
    ],
    "polar_k_p55u51t2csm": [
        "Q6"
    ],
    "polar_k_p43u51t2scsm": [
        "Q6"
    ],
    "polar_k_p42l21t2csm": [
        "Q6"
    ],
    "polar_k_p32l32t2csm": [
        "Q6"
    ],
    "polar_k_p32l21t2scsm": [
        "Q6"
    ],
    "polarline_wk_42pl11tc-sm": [
        "97"
    ],
    "polarline_k_65pu51tc-sm": [
        "97"
    ],
    "polarline_k_50pu11tc-sm": [
        "97"
    ],
    "polarline_k_42pl11tc-sm": [
        "97"
    ],
    "polarline_k_24pl51tc-sm": [
        "97"
    ],
    "yndx-00073": [
        "YD"
    ],
    "x96air_v2": [
        "X96"
    ],
    "x96air_100w": [
        "X96"
    ],
    "x96air_p1": [
        "X96"
    ],
    "black box tv pro": [
        "BLK"
    ],
    "box q": [
        "HOM"
    ],
    "box r 4k": [
        "HOM"
    ],
    "canal plus box": [
        "CAN"
    ],
    "dynalink tv box": [
        "DNA"
    ],
    "filimo box fb-101": [
        "FLM"
    ],
    "netbox-prime": [
        "NET"
    ],
    "netbox-shines": [
        "NET"
    ],
    "meo tv box 4k (diw3930)": [
        "MEO",
        "SAG"
    ],
    "test (diw3930)": [
        "SAG"
    ],
    "apollo premium4k tv": [
        "ONV"
    ],
    "tadaam box": [
        "TAD"
    ],
    "timvisionbox": [
        "TIM"
    ],
    "sn01dngl300": [
        "5Y"
    ],
    "play now tv box 2": [
        "PLA"
    ],
    "aftbu001": [
        "AMZ",
        "KN"
    ],
    "aftkrt": [
        "KN"
    ],
    "aftanna0": [
        "KN"
    ],
    "aftkauk002": [
        "KN"
    ],
    "bravia m6": [
        "SO"
    ],
    "aftmd001": [
        "TC"
    ],
    "aftkm": [
        "KN"
    ],
    "aftka002": [
        "KN"
    ],
    "aftha002": [
        "TS"
    ],
    "aftha003": [
        "TS",
        "KN"
    ],
    "aftha004": [
        "TS",
        "KN"
    ],
    "aftmon001": [
        "4F"
    ],
    "aftmon002": [
        "4F"
    ],
    "aftjuli1": [
        "JV"
    ],
    "aftpr001": [
        "AMZ",
        "KN"
    ],
    "aftwmst22": [
        "JV",
        "KN"
    ],
    "afttiff55": [
        "OIN",
        "KN"
    ],
    "aftha001": [
        "KN"
    ],
    "vol001": [
        "V02"
    ],
    "panodic": [
        "PND"
    ],
    "fenoti_42fn6000f": [
        "FEN"
    ],
    "mag425a": [
        "MIR"
    ],
    "imaq tetra": [
        "IMA"
    ],
    "amlogic alvatech gt1": [
        "B0"
    ],
    "cood-e tv 4k": [
        "CDE"
    ],
    "d2140": [
        "74"
    ],
    "d2150": [
        "74"
    ],
    "ai pont": [],
    "dq08": [
        "1V"
    ],
    "minim8s": [
        "5S"
    ],
    "x96mini": [
        "INK"
    ],
    "wzone": [
        "BOT"
    ],
    "i96 pro": [
        "DRO"
    ],
    "swtv-20ae-pro": [
        "SK"
    ],
    "swtv": [
        "SK"
    ],
    "mybox": [
        "NST"
    ],
    "v10": [
        "WCP"
    ],
    "t95pro": [
        "IOT"
    ],
    "x6-pro": [
        "HIR"
    ],
    "8k3528-t": [],
    "mxq-h3": [
        "5S"
    ],
    "mx10": [],
    "v88": [],
    "h8s": [],
    "x92": [],
    "veon 4k smart tv": [
        "WC"
    ],
    "panavox android tv": [
        "PNV"
    ],
    "hyundai 2k tv": [
        "HN"
    ],
    "tv348_dvb": [
        "UD1"
    ],
    "tv358dvb": [
        "UD1"
    ],
    "tv348_isdb": [
        "UD1"
    ],
    "tv001 on rtd289x": [],
    "net tv.plus": [],
    "o2 tv box": [
        "OT"
    ],
    "tvb-100": [
        "TLK"
    ],
    "cyclone x8": [
        "SZ"
    ],
    "aftalmo": [
        "KN"
    ],
    "aftboxe1": [
        "TS",
        "KN"
    ],
    "triaplaybox": [
        "TRI"
    ],
    "nexon_x10": [
        "N8"
    ],
    "nwx-43f149msy": [
        "NQ"
    ],
    "nwx-24h121wsy": [
        "NQ"
    ],
    "nvx-55u321msy": [
        "NQ"
    ],
    "nvx-50u329msy": [
        "NQ"
    ],
    "q65yk-mg": [
        "QWT"
    ],
    "q55yk-mb": [
        "QWT"
    ],
    "q43yk-mb": [
        "QWT"
    ],
    "q40yf-pb": [
        "QWT"
    ],
    "q32yh-pb": [
        "QWT"
    ],
    "rombica smart box g3": [
        "R3"
    ],
    "ct-8743": [
        "CEN"
    ],
    "ct-8732": [
        "CEN"
    ],
    "ct-8724": [
        "CEN"
    ],
    "ct-8575": [
        "CEN"
    ],
    "ct-8565": [
        "CEN"
    ],
    "ct-8558": [
        "CEN"
    ],
    "ct-8550": [
        "CEN"
    ],
    "ct-8543": [
        "CEN"
    ],
    "ct-8540": [
        "CEN"
    ],
    "ct-8532": [
        "CEN"
    ],
    "salutetv": [
        "SBR"
    ],
    "vekta ld-43sf4850bs": [
        "VEK"
    ],
    "vorke_z1": [
        "2V"
    ],
    "vontar_x3": [
        "1V"
    ],
    "sw-led65ug403": [
        "45"
    ],
    "ulx-50utcs3234": [
        "YN"
    ],
    "ulx-43ftcs2234": [
        "YN"
    ],
    "ulx-32tcsw2234": [
        "YN"
    ],
    "ulx-24tcs221": [
        "YN"
    ],
    "globmall x4": [
        "GLB"
    ],
    "bravia 4k vh21": [
        "SO"
    ],
    "heimat_h43pu2303svf": [
        "HEI"
    ],
    "fengmiproja2": [
        "XI"
    ],
    "ozonehd neo": [
        "OZ"
    ],
    "brandt fhd tv": [
        "8B"
    ],
    "yndx-00091": [
        "YD"
    ],
    "r3g": [
        "40"
    ],
    "dv9135": [
        "M9"
    ],
    "crd55-uhd9": [
        "MAG"
    ],
    "43st20h": [
        "OLT"
    ],
    "ld-32sr5112bs": [
        "VEK"
    ],
    "yndx-00092": [
        "YD"
    ],
    "nexon_x5+": [
        "N8"
    ],
    "50ssd-smart tv-r1": [
        "HEC"
    ],
    "h-led50fu7001": [
        "HN"
    ],
    "h32ey1500b": [
        "ACC"
    ],
    "hty-43fhd06b-s2-t9": [
        "HA1"
    ],
    "h-led55bu7003": [
        "HN"
    ],
    "nexon_x3": [
        "N8"
    ],
    "h-dmp103": [
        "HN"
    ],
    "32h600gu": [
        "KV"
    ],
    "vhix-40f152msy-b": [
        "3H"
    ],
    "le-50ztus30": [
        "54"
    ],
    "yndx-00101": [
        "YD"
    ],
    "dreamstar w2": [
        "DR1"
    ],
    "43ucy1": [
        "DX"
    ],
    "openbox a9": [
        "OH"
    ],
    "ozonehd nexo": [
        "OZ"
    ],
    "tdtv32bs04h": [
        "TOP"
    ],
    "24hhy1": [
        "ACL"
    ],
    "24khs57": [
        "DF"
    ],
    "32f540s": [
        "4B"
    ],
    "32hhy1": [
        "ACL"
    ],
    "40fcy1": [
        "DX"
    ],
    "f32h8050c": [
        "DX"
    ],
    "f43h8050c": [
        "DX"
    ],
    "50ucy1-g": [
        "DX"
    ],
    "55ucy1-g": [
        "DX"
    ],
    "65ucy1-b": [
        "DX"
    ],
    "65ucy1-g": [
        "DX"
    ],
    "u43h8050eg": [
        "DX"
    ],
    "ex-60us001b": [
        "35"
    ],
    "gtx-r10i": [
        "Q4"
    ],
    "cadena pro a csb-231": [
        "CAD"
    ],
    "yndx-00102": [
        "YD"
    ],
    "u55e9100q": [
        "DX"
    ],
    "u50e9100q": [
        "DX"
    ],
    "u50f8000q": [
        "DX"
    ],
    "gtx-98q": [
        "Q4"
    ],
    "technosat w2": [
        "TTS"
    ],
    "technosat x98mini": [
        "TTS"
    ],
    "dm-led43sr22": [
        "D2"
    ],
    "me-cool s": [
        "0M"
    ],
    "h24f8000c": [
        "DX"
    ],
    "24ghs55": [
        "DF"
    ],
    "24ghs57": [
        "DF"
    ],
    "24h1ydx000bs2": [
        "I6"
    ],
    "24h520t": [
        "4B"
    ],
    "24lex-7269": [
        "BB"
    ],
    "28h540s": [
        "4B"
    ],
    "50kus65": [
        "DF"
    ],
    "50u620s": [
        "4B"
    ],
    "50u630s": [
        "4B"
    ],
    "50u660ts": [
        "HAR"
    ],
    "50lu1204": [
        "VIT"
    ],
    "dm-led43ubb31": [
        "D2"
    ],
    "dm-led50ubb31": [
        "D2"
    ],
    "dm-led55ubb31": [
        "D2"
    ],
    "ex-32hs006b": [
        "35"
    ],
    "f43h8000qg": [
        "DX"
    ],
    "h32f8000cg": [
        "DX"
    ],
    "h32g8000kw": [
        "DX"
    ],
    "h32g8000q": [
        "DX"
    ],
    "h32h8000k": [
        "DX"
    ],
    "h32h8000q": [
        "DX"
    ],
    "hiberg55yuhd": [
        "HIB"
    ],
    "hiberg50yuhd": [
        "HIB"
    ],
    "hgtv-led50uhds102t2": [
        "HLB"
    ],
    "hgtv-led55uhds102t2": [
        "HLB"
    ],
    "hgtv-led40fhds100t2": [
        "HLB"
    ],
    "hgtv-led43uhds102t2": [
        "HLB"
    ],
    "hgtv-led55uhdsq100t2": [
        "HLB"
    ],
    "hgtv-led32hds102t2": [
        "HLB"
    ],
    "hgtv-led43fhds102t2": [
        "HLB"
    ],
    "hgtv-led65uhds101t2": [
        "HLB"
    ],
    "h-led32bs5003": [
        "HN"
    ],
    "h-led40bs5003": [
        "HN"
    ],
    "h-led43bu7003": [
        "HN"
    ],
    "harper 55q850ts": [
        "HAR"
    ],
    "harper 55u660ts": [
        "HAR"
    ],
    "harper 58u750ts": [
        "HAR"
    ],
    "harper 50u750ts": [
        "HAR"
    ],
    "harper 65q850ts": [
        "HAR"
    ],
    "harper-50u660ts": [
        "HAR"
    ],
    "tf-led32s14t2s": [
        "TL"
    ],
    "tf-led43s95t2su": [
        "TL"
    ],
    "tf-led50s03t2su": [
        "TL"
    ],
    "tf-led55s11t2su-1": [
        "TL"
    ],
    "mlt55usx02": [
        "MAU"
    ],
    "dm-led32sbb31": [
        "D2"
    ],
    "dm-led40sbb31": [
        "D2"
    ],
    "soullink s1": [
        "SUL"
    ],
    "n5max_x4": [
        "6Y"
    ],
    "atom-108al": [
        "2A"
    ],
    "atom-216al": [
        "2A"
    ],
    "43lf1210": [
        "VHM"
    ],
    "40ghs57": [
        "DF"
    ],
    "43f511t": [
        "4B"
    ],
    "55kus65": [
        "DF"
    ],
    "skystream one": [
        "SK1"
    ],
    "tq55ufbtv1": [
        "TUV"
    ],
    "tdtv43cs05u": [
        "TOP"
    ],
    "tdtv43cs06u": [
        "TOP"
    ],
    "tdtv50bs06u": [
        "TOP"
    ],
    "tdtv50cs05u": [
        "TOP"
    ],
    "tdtv55bs06u": [
        "TOP"
    ],
    "tdtv65bs05u_bk": [
        "TOP"
    ],
    "tdtv43bs06u_bk": [
        "TOP"
    ],
    "tdtv40bs04f": [
        "TOP"
    ],
    "32ghs56": [
        "DF"
    ],
    "32r751ts": [
        "HAR"
    ],
    "hty-75u06b-vn": [
        "HA1"
    ],
    "f40h8000e": [
        "DX"
    ],
    "samtron_w_43sa701": [
        "SAM"
    ],
    "swtv-22ae-fhd": [
        "SK"
    ],
    "p42l31t2csm": [
        "Q6"
    ],
    "polarline_wk_32pl51stc-sm": [
        "97"
    ],
    "28h550t": [
        "4B"
    ],
    "43f750ts": [
        "HAR"
    ],
    "baff32ystv": [
        "BFF"
    ],
    "swtv-22ae": [
        "SK"
    ],
    "43lf1204": [
        "VIT"
    ],
    "85u750ts": [
        "HAR"
    ],
    "40lf8120t": [
        "8A"
    ],
    "hty_43fhd06b": [
        "HA1"
    ],
    "hty-32h06w-vz": [
        "HA1"
    ],
    "hty-43f06w-vz": [
        "HA1"
    ],
    "h32h8050cg": [
        "DX"
    ],
    "hty-32h06b-vz": [
        "HA1"
    ],
    "hty-65u11b-vs": [
        "HA1"
    ],
    "hty-65uhd06b-ha22": [
        "HA1"
    ],
    "32lx9000ct": [
        "05"
    ],
    "hty-65uhdo6b-hk22": [
        "HA1"
    ],
    "vhix-50u169msy": [
        "3H"
    ],
    "hty-43u11s-vd": [
        "HA1"
    ],
    "hty-43fhdo6b-hk22": [
        "HA1"
    ],
    "tf-led43s97t2su": [
        "TL"
    ],
    "sw-led32sg311": [
        "45"
    ],
    "hty-50u11b-vs": [
        "HA1"
    ],
    "td32hfgev1": [
        "TUV"
    ],
    "td32hfwev1": [
        "TUV"
    ],
    "td43ffgtv1": [
        "TUV"
    ],
    "td43ufgcv1": [
        "TUV"
    ],
    "td50ufgev1": [
        "TUV"
    ],
    "td55ufgev1": [
        "TUV"
    ],
    "td65ufgcv1": [
        "TUV"
    ],
    "td75ufgcv1": [
        "TUV"
    ],
    "tdtv24cs04h": [
        "TOP"
    ],
    "tdtv43bs06u": [
        "TOP"
    ],
    "evpad-pro-max": [
        "5U"
    ],
    "32r750ts": [
        "HAR"
    ],
    "32r670ts": [
        "HAR"
    ],
    "32lh8030s": [
        "8A"
    ],
    "32le7051d": [
        "4H"
    ],
    "40f750ts": [
        "HAR"
    ],
    "ct-8740": [
        "CEN"
    ],
    "skyline_50ust5970": [
        "SKY"
    ],
    "sm-qled50t2su": [
        "X2",
        "SA"
    ],
    "tle-50usbm": [
        "REN"
    ],
    "8k618-t": [
        "5R"
    ],
    "43st20u": [
        "OLT"
    ],
    "43u540s": [
        "4B"
    ],
    "43u550t": [
        "4B"
    ],
    "43u750ts": [
        "HAR"
    ],
    "lt-55u900": [
        "GOS"
    ],
    "iconbit xlr3090": [
        "I2"
    ],
    "32les904t2sm": [
        "05"
    ],
    "dm-led32sbb35": [
        "D2"
    ],
    "dm-led24sbb31": [
        "D2"
    ],
    "43lf8120t": [
        "8A"
    ],
    "43lu8120t": [
        "8A"
    ],
    "43lu8130s": [
        "8A"
    ],
    "43lst5970": [
        "SKY"
    ],
    "yasin 4k g smart tv": [
        "YJ"
    ],
    "yasin 2k g smart tv": [
        "YJ"
    ],
    "hiberg43yuhd-r": [
        "HIB"
    ],
    "hiberg50yuhd-r": [
        "HIB"
    ],
    "hty-24hdro6b-hc22": [
        "HA1"
    ],
    "hty-24hdro6w-hc22": [
        "HA1"
    ],
    "hty-32fhd06b-ha22": [
        "HA1"
    ],
    "h-led50bu7003": [
        "HN"
    ],
    "hty-32hdr06b-s2-t9": [
        "HA1"
    ],
    "hty-32hdr06g-hk22": [
        "HA1"
    ],
    "hty-32hdro6g-hk22": [
        "HA1"
    ],
    "hty-43f11b-vs": [
        "HA1"
    ],
    "hty-43fhdo6g-hc22": [
        "HA1"
    ],
    "hty-50u11s-vd": [
        "HA1"
    ],
    "hty-55u11b-vs": [
        "HA1"
    ],
    "hty-55u11s-vd": [
        "HA1"
    ],
    "hty-22fhdo6w-hc22": [
        "HA1"
    ],
    "hty-24h06b-vz": [
        "HA1"
    ],
    "hty-24hdr06b-s2-t9": [
        "HA1"
    ],
    "baff40yfhd": [
        "BFF"
    ],
    "aquos-tve19a": [
        "SH"
    ],
    "aquos-tve21f": [
        "SH"
    ],
    "smux box a1": [
        "SMU"
    ],
    "j-link ii": [
        "D6"
    ],
    "sm-led65m02su": [
        "X2",
        "SA"
    ],
    "sm-led55m02su": [
        "X2",
        "SA"
    ],
    "sm-led50m02su": [
        "X2",
        "SA"
    ],
    "sm-led43m02su": [
        "X2",
        "SA"
    ],
    "sm-led32m14s": [
        "X2",
        "SA"
    ],
    "sm-led32m10s": [
        "X2",
        "SA"
    ],
    "sm-led32m09s": [
        "X2",
        "SA"
    ],
    "sm-led24m09s": [
        "X2",
        "SA"
    ],
    "sm-led24m06s": [
        "X2",
        "SA"
    ],
    "sw-led58ug401": [
        "45"
    ],
    "sw-22ae nf": [
        "SK"
    ],
    "x96air_p2": [
        "X96"
    ],
    "x96air_p3": [
        "X96"
    ],
    "sw-led55ug403": [
        "45"
    ],
    "switron-i12a": [
        "WN"
    ],
    "rasse-001": [
        "B5"
    ],
    "q65yk-mb": [
        "QWT"
    ],
    "orbsmart s85": [
        "ORB"
    ],
    "nwx-65u169tsy-a": [
        "NQ"
    ],
    "nvx-65u321msy": [
        "NQ"
    ],
    "p32l33t2csm": [
        "Q6"
    ],
    "netwit_p12039s": [
        "NWT"
    ],
    "le-55ztus30": [
        "54"
    ],
    "le-50ztus32-a": [
        "54"
    ],
    "le-43ztfs25-b": [
        "54"
    ],
    "le-32zths25-a": [
        "54"
    ],
    "ld-50su8815bs": [
        "VEK"
    ],
    "ld-43su8821bs": [
        "VEK"
    ],
    "ld-43sf4815bs": [
        "VEK"
    ],
    "ld-32sr4815bs": [
        "VEK"
    ],
    "km8-atv-mf": [
        "MP"
    ],
    "lt-55nx8001s": [
        "NEK"
    ],
    "lt-43nf8020s": [
        "NEK"
    ],
    "x96max_plus2": [
        "X96"
    ],
    "x96max_plus_5": [
        "X96"
    ],
    "x96max_plus_q1": [
        "X96"
    ],
    "x96max_plus": [
        "X96"
    ],
    "x96max_plus_q2": [
        "X96"
    ],
    "sw-led58ub400": [
        "45"
    ],
    "sw-led55ub401": [
        "45"
    ],
    "sw-led50ug403": [
        "45"
    ],
    "sw-led50ug400": [
        "45"
    ],
    "rombica smart box x1": [
        "R3"
    ],
    "htv-55u11b-vs": [
        "HA1"
    ],
    "i-925": [
        "GOL"
    ],
    "i-905": [
        "GOL"
    ],
    "4ktv-0su": [
        "PA"
    ],
    "sl-led32s49t2s": [
        "SC1"
    ],
    "sm-led32m13s": [
        "X2",
        "SA"
    ],
    "sm-led43m01su": [
        "X2",
        "SA"
    ],
    "sm-led43m02s": [
        "X2",
        "SA"
    ],
    "43fles902t2sm": [
        "05"
    ],
    "43fles901t2sm": [
        "05"
    ],
    "tanix a3": [
        "9N"
    ],
    "nv731wb": [
        "4E"
    ],
    "nv730wb": [
        "4E"
    ],
    "nv731": [
        "4E"
    ],
    "h-led43eu1312": [
        "HN"
    ],
    "h-led43gu7003": [
        "HN"
    ],
    "h-led50eu1311": [
        "HN"
    ],
    "h-led50gu7003": [
        "HN"
    ],
    "h-led65bu7003": [
        "HN"
    ],
    "h-led65gu7003": [
        "HN"
    ],
    "h-led75bu7005": [
        "HN"
    ],
    "h-led43fs5001-p": [
        "HN"
    ],
    "h-led32fs5001-c": [
        "HN"
    ],
    "h-led32fs5003": [
        "HN"
    ],
    "h-led32gs5003": [
        "HN"
    ],
    "h-led40fs5001": [
        "HN"
    ],
    "h-led40fs5003": [
        "HN"
    ],
    "h-led42fs5001": [
        "HN"
    ],
    "h-led42fs5003": [
        "HN"
    ],
    "h-led65eu1311": [
        "HN"
    ],
    "hiberg75yuhd": [
        "HIB"
    ],
    "65kus65": [
        "DF"
    ],
    "65lex-8262": [
        "BB"
    ],
    "24h510t": [
        "4B"
    ],
    "75ucy1-g": [
        "DX"
    ],
    "h-led43fs5001": [
        "HN"
    ],
    "ex-50us003b": [
        "35"
    ],
    "55u510s": [
        "4B"
    ],
    "50u510s": [
        "4B"
    ],
    "43u6510": [
        "SKY"
    ],
    "43u700gr": [
        "KV"
    ],
    "43fsy112xb": [
        "3H"
    ],
    "43fsy112x": [
        "3H"
    ],
    "43gus65": [
        "DF"
    ],
    "50yuhd-r": [
        "HIB"
    ],
    "ld-24sr4715bs": [
        "VEK"
    ],
    "ld-24sr4815bs": [
        "VEK"
    ],
    "ld-32sr5115bs": [
        "VEK"
    ],
    "ld-39sr4815bs": [
        "VEK"
    ],
    "ld-55su8815bs": [
        "VEK"
    ],
    "le-43ztfs25-f": [
        "54"
    ],
    "tq50ufbcv1": [
        "TUV"
    ],
    "tle-43fsbm": [
        "REN"
    ],
    "td86ufbtv1": [
        "TUV"
    ],
    "43le7052d": [
        "4H"
    ],
    "sei600go": [
        "GO1"
    ],
    "heimat_h65pu2303svf": [
        "HEI"
    ],
    "stv-32dhbk2r-t9": [
        "TUV"
    ],
    "xs100mini": [
        "VIS"
    ],
    "nexon x2+": [
        "N8"
    ],
    "sl-led43s98t2su": [
        "SC1"
    ],
    "sl-led43s94t2s": [
        "SC1"
    ],
    "24lm8002ct2": [
        "05"
    ],
    "dv9157-c": [
        "M9"
    ],
    "sw-led32sg305": [
        "45"
    ],
    "sw-led32sg304": [
        "45"
    ],
    "sun-led43xs301": [
        "W8"
    ],
    "sun-led32xs311": [
        "W8"
    ],
    "sun-led32xs305": [
        "W8"
    ],
    "tf-led32s08t2s": [
        "TL"
    ],
    "sl-led55s01t2su": [
        "SC1"
    ],
    "a-stream": [
        "BP"
    ],
    "newal_tv_uhd-5042": [
        "NEW"
    ],
    "vekta ld-24sr4850bs": [
        "VEK"
    ],
    "oled tv s9": [
        "HA"
    ],
    "ulx-43ftcs2234-t9": [
        "YN"
    ],
    "nokia streaming box 8000": [
        "NK"
    ],
    "polarline_w_43pl51tc-sm": [
        "97"
    ],
    "polarline_w_43pu11tc-sm": [
        "97"
    ],
    "polarline_w_32pl55tc-sm": [
        "97"
    ],
    "polarline_w_42pl11tc-sm": [
        "97"
    ],
    "polarline_w_40pl52tc-sm": [
        "97"
    ],
    "polarline_w_32pl14tc-sm": [
        "97"
    ],
    "polarline_w_32pl13tc-sm": [
        "97"
    ],
    "polarline_w_24pl51tc-sm": [
        "97"
    ],
    "polarline_wk_43pl51stc-sm": [
        "97"
    ],
    "polarline_wk_24pl51tc-sm": [
        "97"
    ],
    "polarline_wk_32pl13tc-sm": [
        "97"
    ],
    "43lu8030s": [
        "8A"
    ],
    "ld-43sf4815bs-t9": [
        "VEK"
    ],
    "polar_w_p40l31t2scsm": [
        "Q6"
    ],
    "openbox a8": [
        "OH"
    ],
    "limet95": [
        "LIM"
    ],
    "mlt43usd02g": [
        "MAU"
    ],
    "sw-led43ug400": [
        "45"
    ],
    "sl-led24s90t2s": [
        "SC1"
    ],
    "55mt-udg54g": [
        "R3"
    ],
    "v39tphe01s": [
        "JW"
    ],
    "v32tphde1s": [
        "JW"
    ],
    "v24tphde1s": [
        "JW"
    ],
    "sw-led58ua401": [
        "45"
    ],
    "sw-led50ub400": [
        "45"
    ],
    "sw-led43ug405": [
        "45"
    ],
    "sw-led32sb300": [
        "45"
    ],
    "sw-led40sb304": [
        "45"
    ],
    "sw-led43sb304": [
        "45"
    ],
    "sw-led43ug401": [
        "45"
    ],
    "sw-led43ug403": [
        "45"
    ],
    "sdott00000": [],
    "sdstb00": [],
    "sdstb02": [
        "UGR"
    ],
    "sdott0202": [
        "UGR"
    ],
    "ott xview av1": [
        "MCA"
    ],
    "mediabox": [],
    "32les902t2sm": [
        "05"
    ],
    "y-4301-fhd-r": [
        "NRD"
    ],
    "y-4001-fhd-r": [
        "NRD"
    ],
    "sun-led65xu401": [
        "W8"
    ],
    "55u620s": [
        "4B"
    ],
    "hty-75uhd06b-s2": [
        "HA1"
    ],
    "43lf7010t": [
        "8A"
    ],
    "sbdv-00006": [
        "SBR"
    ],
    "hty-65uhd06b-s2": [
        "HA1"
    ],
    "43ulx9060t2": [
        "05"
    ],
    "43u1ydx000fbs2": [
        "I6"
    ],
    "43sa705": [
        "SAM"
    ],
    "43lf1212": [
        "VIT"
    ],
    "43lex-9201uts2c": [
        "BB"
    ],
    "43yuhd-r": [
        "HIB"
    ],
    "50le7053d": [
        "4H"
    ],
    "55yuhd-r": [
        "HIB"
    ],
    "65yuhd-r": [
        "HIB"
    ],
    "65u520s": [
        "4B"
    ],
    "65u001bs2": [
        "I6"
    ],
    "65lu1210": [
        "VHM"
    ],
    "65lex-8234-uts2c.hv650qub-f9d": [
        "BB"
    ],
    "65lex-8174": [
        "BB"
    ],
    "55u1ydx000bs2": [
        "I6"
    ],
    "43lex-8289uts2c": [
        "BB"
    ],
    "32lx9050t2": [
        "05"
    ],
    "43f520t": [
        "4B"
    ],
    "42lex-7255fts2c": [
        "BB"
    ],
    "32ystv-r": [
        "BFF"
    ],
    "32h700gr": [
        "KV"
    ],
    "32h650s": [
        "4B"
    ],
    "24lh1203": [
        "VHM"
    ],
    "24lf7020t": [
        "8A"
    ],
    "kp1": [
        "HOM"
    ],
    "km7": [
        "0M"
    ],
    "konka 2k android tv": [
        "KO"
    ],
    "metz 2k tv": [
        "ME"
    ],
    "yasin 4k android tv": [
        "YJ"
    ],
    "yasin 2k android tv": [
        "YJ"
    ],
    "ex-32hs017b": [
        "35"
    ],
    "hibergqled55y": [
        "HIB"
    ],
    "nv721wb": [
        "4E"
    ],
    "nv710wb": [
        "4E"
    ],
    "42fles904t2sm": [
        "05"
    ],
    "onn 2k tv stick": [
        "O4"
    ],
    "f30up": [
        "VI2"
    ],
    "v-home_24lh1211": [
        "VHM"
    ],
    "ugoos am6": [
        "UG"
    ],
    "sternenschein g-21": [
        "DYM"
    ],
    "vhix-65u169tsy": [
        "3H"
    ],
    "bid-at200": [
        "5Z"
    ],
    "td55ufbhv1": [
        "TUV"
    ],
    "43f660ts": [
        "HAR"
    ],
    "rh-le43dsy-c": [
        "ROH"
    ],
    "50sa707": [
        "SAM"
    ],
    "media tv m5": [
        "HIP"
    ],
    "go700fr": [
        "GO1",
        "G1"
    ],
    "selenga": [
        "9G"
    ],
    "ergogs": [
        "E7"
    ],
    "pvbox_p5_pro": [
        "PVB"
    ],
    "nordmende_55nm6000u": [
        "NR"
    ],
    "32sn6000h": [
        "SEN"
    ],
    "32lh8011t": [
        "8A"
    ],
    "32lf7111t": [
        "8A"
    ],
    "32st30h": [
        "OLT"
    ],
    "42gfs56": [
        "DF"
    ],
    "32f550t": [
        "4B"
    ],
    "40f550t": [
        "4B"
    ],
    "gtkingii": [
        "B0"
    ],
    "yndx-00075": [
        "YD"
    ],
    "longtv louie": [
        "LNG"
    ],
    "fibetv": [
        "BEL"
    ],
    "hlq max": [
        "IHL"
    ],
    "h96 mini h8": [
        "9Z"
    ],
    "h96plus": [
        "9Z"
    ],
    "stv-55led41": [
        "78"
    ],
    "sw-led65ug402": [
        "45"
    ],
    "sw-led43ub400": [
        "45"
    ],
    "sw-led43sb300": [
        "45"
    ],
    "sw-led40sb300": [
        "45"
    ],
    "sw-led32sb304": [
        "45"
    ],
    "50ust5970": [
        "SKY"
    ],
    "50lu8130s": [
        "8A"
    ],
    "50lf7010t": [
        "8A"
    ],
    "korax-eurobox": [
        "KRX"
    ],
    "sm-qled55t21su": [
        "X2",
        "SA"
    ],
    "sm-led32m12s": [
        "X2",
        "SA"
    ],
    "onvo_50ov6000u": [
        "ONV"
    ],
    "onvo_43ov6000f": [
        "ONV"
    ],
    "gi-98quick": [
        "99"
    ],
    "amaze ax-50 advance": [
        "DAN"
    ],
    "senna_32sn6000h": [
        "SEN"
    ],
    "aftdec012e": [
        "TC"
    ],
    "aft6e0fa": [
        "TS",
        "KN"
    ],
    "aftkade001": [
        "KN"
    ],
    "aftkauk001": [
        "KN"
    ],
    "aftshn01": [
        "KN"
    ],
    "24ovf6000h": [
        "ONV"
    ],
    "32ov6000h": [
        "ONV"
    ],
    "32ov6001h": [
        "ONV"
    ],
    "42ov6000f": [
        "ONV"
    ],
    "43ov6000f": [
        "ONV"
    ],
    "50ov6000u": [
        "ONV"
    ],
    "55ov6000u": [
        "ONV"
    ],
    "65ov6000u": [
        "ONV"
    ],
    "qilive smart tv": [
        "QI"
    ],
    "dctiw362_play": [
        "SAG"
    ],
    "28lh8120t": [
        "8A"
    ],
    "28lh8110t": [
        "8A"
    ],
    "vhix-55u169tsy": [
        "3H"
    ],
    "vhix-50u169tsy": [
        "3H"
    ],
    "yndx-00076": [
        "YD"
    ],
    "yndx-00074": [
        "YD"
    ],
    "tanix_tx3_mini": [
        "9N"
    ],
    "bt_32fs32b": [
        "BLT"
    ],
    "hongtop_box": [
        "HON"
    ],
    "tox4": [
        "UG"
    ],
    "tox3_plus": [
        "UG"
    ],
    "sl-led50s02t2su": [
        "SC1"
    ],
    "32les901t2sm": [
        "05"
    ],
    "32les903t2sm": [
        "05"
    ],
    "rupa.smarttv.8800.f1010_1.0.0": [
        "RUP"
    ],
    "topdevice_tdtv75bs06u_9632": [
        "TOP"
    ],
    "topdevice_tdtv43bs05u_9632": [
        "TOP"
    ],
    "tq65ufbcv1": [
        "TUV"
    ],
    "td43ffbhv1": [
        "TUV"
    ],
    "td43ufbhv1": [
        "TUV"
    ],
    "td50ufbhv1": [
        "TUV"
    ],
    "td50ufghv1": [
        "TUV"
    ],
    "td65ufbsv1": [
        "TUV"
    ],
    "tdtv24bs01h": [
        "TOP"
    ],
    "vekta ld-32sf4850bs": [
        "VEK"
    ],
    "hibergqled65y": [
        "HIB"
    ],
    "hiberg65yuhd": [
        "HIB"
    ],
    "mnbp-300g": [
        "1X"
    ],
    "ptv50ss08x": [
        "PR"
    ],
    "nvx-75u131msy": [
        "NQ"
    ],
    "nvx-32h219msyx": [
        "NQ"
    ],
    "h24yq2200gr-2": [
        "HIP"
    ],
    "ct-8750": [
        "CEN"
    ],
    "mlt55usd02g": [
        "MAU"
    ],
    "32lh1212-v": [
        "VIT"
    ],
    "megamax_w_42mg11fsm": [
        "MGX"
    ],
    "u55f8000qg": [
        "DX"
    ],
    "mlt43fsx02": [
        "MAU"
    ],
    "td55ufghv1": [
        "TUV"
    ],
    "43u520s": [
        "4B"
    ],
    "55ucy1-b": [
        "DX"
    ],
    "32f700wr": [
        "KV"
    ],
    "u50f8000eg": [
        "DX"
    ],
    "s800 max": [
        "RE2"
    ],
    "s700 max": [
        "RE2"
    ],
    "s600 max": [
        "RE2"
    ],
    "matador-pro": [
        "HIR"
    ],
    "matador pro": [
        "HIR"
    ],
    "matador": [
        "HIR"
    ],
    "ip-60 max": [
        "RE2"
    ],
    "ip-70 max": [
        "RE2"
    ],
    "netta 3": [
        "GOL"
    ],
    "prismplus 4k pro android tv": [
        "PRP"
    ],
    "hty-50uhd05b": [
        "HA1"
    ],
    "dm-led32sbb32": [
        "D2"
    ],
    "40fles900t2sm": [
        "05"
    ],
    "stv-65dubk1r": [
        "TUV"
    ],
    "42lf8130s": [
        "8A"
    ],
    "fuego 2k smart tv": [
        "FG"
    ],
    "singer android tv": [
        "SIN"
    ],
    "singer 4k gsmart tv": [
        "SIN"
    ],
    "42fn6000f": [
        "FEN"
    ],
    "32evf5000s": [
        "EVF"
    ],
    "saba_32sb6000h": [
        "X5"
    ],
    "saba_42sb6000f": [
        "X5"
    ],
    "32les905t2sm": [
        "05"
    ],
    "g guard smart tv": [
        "GRD"
    ],
    "dyon 2k google tv": [
        "DYO"
    ],
    "walton gsmart 2ktv": [
        "WA"
    ],
    "bell streamer": [
        "BEL"
    ],
    "altibox tv": [
        "ALB"
    ],
    "supermax mx11 prime": [
        "SBM"
    ],
    "smx4k": [
        "PL"
    ],
    "telia nordic stb": [
        "65"
    ],
    "42qws9001": [
        "WLR"
    ],
    "akai_ta43bu500": [
        "AK"
    ],
    "akai_ta32bf550": [
        "AK"
    ],
    "65mt-udg54g": [
        "R3"
    ],
    "onvo_24ov6000h": [
        "ONV"
    ],
    "42fles901t2sm": [
        "05"
    ],
    "32lh5000t": [
        "8A"
    ],
    "40lex-9201-fts2c": [
        "BB"
    ],
    "40lex-7291-fts2c": [
        "BB"
    ],
    "40lex-7246fts2c": [
        "BB"
    ],
    "40flx9000ct2": [
        "05"
    ],
    "40fles901t2sm": [
        "05"
    ],
    "32y-hd-r": [
        "BFF"
    ],
    "32lex-7292-ts2c": [
        "BB"
    ],
    "32lex-7291-ts2c": [
        "BB"
    ],
    "32lex-7288ts2c-t9": [
        "BB"
    ],
    "32lex-7264ts2c": [
        "BB"
    ],
    "32lex-7264-ts2c": [
        "BB"
    ],
    "32lex-7260-ts2c": [
        "BB"
    ],
    "32lex-7259ts2c": [
        "BB"
    ],
    "32lex-7257ts2c": [
        "BB"
    ],
    "32lex-7249ts2c": [
        "BB"
    ],
    "32lex-7246ts2c": [
        "BB"
    ],
    "32lex-7213-ts2c": [
        "BB"
    ],
    "32lex-7212-ts2c": [
        "BB"
    ],
    "32lex-7204ts2c": [
        "BB"
    ],
    "32lex-7202ts2c": [
        "BB"
    ],
    "32les906t2sm": [
        "05"
    ],
    "24lex-7289ts2c-t9": [
        "BB"
    ],
    "24hey1": [
        "DX"
    ],
    "gr32200": [
        "GRB"
    ],
    "gr43200": [
        "GRB"
    ],
    "as512": [
        "ALP"
    ],
    "as514": [
        "ALP"
    ],
    "as515": [
        "ALP"
    ],
    "as516": [
        "ALP"
    ],
    "vip7802": [
        "COM"
    ],
    "qs02": [
        "BQ"
    ],
    "allente 1": [
        "ALL"
    ],
    "fundroid mb18": [
        "MLB"
    ],
    "fundroid mb216": [
        "MLB"
    ],
    "stilevs smart tv": [
        "STI"
    ],
    "ok google tv": [
        "O9"
    ],
    "haier matrixtv ael": [
        "HA"
    ],
    "path_7xpro": [
        "KK"
    ],
    "lu-v78": [
        "LUO"
    ],
    "white x": [
        "STV"
    ],
    "40lf7010t": [
        "8A"
    ],
    "iconbit xlr3089": [
        "I2"
    ],
    "mqt55usd03": [
        "MAU"
    ],
    "bt_32fs34b": [
        "BLT"
    ],
    "32lh7011t": [
        "8A"
    ],
    "bt_50fsu34b": [
        "BLT"
    ],
    "aiwaandroidtv": [
        "AW"
    ],
    "32fcy2": [
        "DX"
    ],
    "43fcy1": [
        "DX"
    ],
    "43fcy2": [
        "DX"
    ],
    "42lf8120t": [
        "8A"
    ],
    "43ucy3": [
        "DX"
    ],
    "43ucy2-g": [
        "DX"
    ],
    "43ucy1-g": [
        "DX"
    ],
    "43ucy1-b": [
        "DX"
    ],
    "43u541t": [
        "4B"
    ],
    "43lu1222": [
        "VIT"
    ],
    "55xt-ud2g64n": [
        "R3"
    ],
    "yndx-00077": [
        "YD"
    ],
    "43lf7202t": [
        "8A"
    ],
    "43f690ts": [
        "HAR"
    ],
    "43f541t": [
        "4B"
    ],
    "43fsq2020t2": [
        "RUA"
    ],
    "43fles905t2sm": [
        "05"
    ],
    "43fles900t2sm": [
        "05"
    ],
    "43f01": [
        "HA1"
    ],
    "40lst5975": [
        "SKY"
    ],
    "40lf8130s": [
        "8A"
    ],
    "32st20h": [
        "OLT"
    ],
    "32lh1221": [
        "VIT"
    ],
    "24r470ts": [
        "HAR"
    ],
    "28h541t": [
        "4B"
    ],
    "mclaut tv": [
        "MCL"
    ],
    "tvs-su5007": [
        "GAT"
    ],
    "tle-32sbm": [
        "REN"
    ],
    "tq65ufbhv1": [
        "TUV"
    ],
    "tdtv65bs06u": [
        "TOP"
    ],
    "td43ufbsv1": [
        "TUV"
    ],
    "td32hfbhv1": [
        "TUV"
    ],
    "td24hfbhv1": [
        "TUV"
    ],
    "t43fsm5160": [
        "TN"
    ],
    "ct-8932": [
        "CEN"
    ],
    "ct-8843": [
        "CEN"
    ],
    "ct-8840": [
        "CEN"
    ],
    "ct-8832": [
        "CEN"
    ],
    "ct-8824": [
        "CEN"
    ],
    "c50usy24f": [
        "RAZ"
    ],
    "f32ey1000b": [
        "ACC"
    ],
    "dm-led65ubb33": [
        "D2"
    ],
    "dm-led50ubb33": [
        "D2"
    ],
    "dm-led43ubb33": [
        "D2"
    ],
    "dm-led43sbb33": [
        "D2"
    ],
    "dm-led40sbb33": [
        "D2"
    ],
    "dm-led32sbb33": [
        "D2"
    ],
    "mortal t1": [
        "MOR"
    ],
    "vgk02": [
        "SK"
    ],
    "ip-80 max": [
        "RE2"
    ],
    "ex-40fs001w": [
        "35"
    ],
    "red 90": [
        "SPD"
    ],
    "red 60": [
        "SPD"
    ],
    "red 30": [
        "SPD"
    ],
    "red 10": [
        "SPD"
    ],
    "gazal_100mix": [
        "GAL"
    ],
    "gazal_100": [
        "GAL"
    ],
    "denka tv": [
        "DNK"
    ],
    "dawlance gsmart 4ktv": [
        "DAW"
    ],
    "sambox_km_35_pro": [
        "SAB"
    ],
    "km22": [
        "SAB"
    ],
    "sl-led58s01t2su": [
        "SC1"
    ],
    "sl-led55s02t2su": [
        "SC1"
    ],
    "onvo_65ov6000u": [
        "ONV"
    ],
    "openbox gold": [
        "OH"
    ],
    "n50hq2305svf": [
        "NES"
    ],
    "n43hq2304svf": [
        "NES"
    ],
    "n32hr2301sf": [
        "NES"
    ],
    "n32hf2302sf": [
        "NES"
    ],
    "epico 4k": [
        "COE"
    ],
    "fresh smart tv": [
        "FTH",
        "JG"
    ],
    "crd65-uhd11": [
        "MAG"
    ],
    "gtking_at_atv": [
        "B0"
    ],
    "gt1-mini-at_atv": [
        "B0"
    ],
    "caixun androidtv": [
        "CAI"
    ],
    "ecostartv": [
        "ECS"
    ],
    "fision tv plus": [
        "FIS"
    ],
    "droidlogic hiremco": [
        "HIR"
    ],
    "hiremco matrix": [
        "HIR"
    ],
    "dm-led55ubb33": [
        "D2"
    ],
    "dongle g 4k": [
        "HOM"
    ],
    "tv-impact": [
        "R3"
    ],
    "neko_wk_lt_32nh8000s": [
        "NEK"
    ],
    "neko_lt-43nx7020s": [
        "NEK"
    ],
    "multynet fhd android tv": [
        "MLT"
    ],
    "ailetv": [
        "AL1"
    ],
    "brandt uhd tv": [
        "8B"
    ],
    "duotv": [
        "DUO"
    ],
    "y8 max s905x3": [
        "BQL",
        "DO"
    ],
    "hty-24h06w-vz-m": [
        "HA1"
    ],
    "indurama google tv 4k": [
        "IND"
    ],
    "magentatv box": [
        "MA4"
    ],
    "magentatv one": [
        "MA4"
    ],
    "magentatv one (2. generation)": [
        "MA4"
    ],
    "ntv_h43c612n": [
        "7XR"
    ],
    "ntv-u50c614s": [
        "7XR"
    ],
    "k55usy23": [
        "RAZ"
    ],
    "red360 air 8k": [
        "RE2"
    ],
    "td43ffbsv1": [
        "TUV"
    ],
    "stv-43fdubk1r": [
        "TUV"
    ],
    "senna_43sn6000f": [
        "SEN"
    ],
    "qupi tv start": [
        "QUP"
    ],
    "sencrom redrobox 4k plus": [
        "SNM"
    ],
    "infinityprotv": [
        "IPR"
    ],
    "winkbox 2": [
        "WN"
    ],
    "era8k pro": [
        "KRX"
    ],
    "ntv-h3230ts": [
        "NO2"
    ],
    "50mt-udg54g": [
        "R3"
    ],
    "stv-32fdfbk1r": [
        "TUV"
    ],
    "box r 4k plus": [
        "HOM"
    ],
    "bq_42fs07b": [
        "BX"
    ],
    "bq_32fsfo1b": [
        "BX"
    ],
    "bq_32fs40b": [
        "BX"
    ],
    "bq_32fs38b": [
        "BX"
    ],
    "bt_32fs36b": [
        "BLT"
    ],
    "bq_40fs36b": [
        "BX"
    ],
    "65ules910t2sm": [
        "05"
    ],
    "65ucy3": [
        "DX"
    ],
    "24le7011d": [
        "4H"
    ],
    "youwei box": [
        "YO1"
    ],
    "43lex-8258uts2c": [
        "BB"
    ],
    "43lex-8257uts2c": [
        "BB"
    ],
    "43lex-8249uts2c": [
        "BB"
    ],
    "43lex-8246uts2c": [
        "BB"
    ],
    "43lex-7288fts2c-t9": [
        "BB"
    ],
    "43lex-7260-fts2c": [
        "BB"
    ],
    "43lex-7259fts2c": [
        "BB"
    ],
    "43lex-7257fts2c": [
        "BB"
    ],
    "43lex-8265-uts2c": [
        "BB"
    ],
    "43lex-7246fts2c": [
        "BB"
    ],
    "43lex-7236-fts2c": [
        "BB"
    ],
    "32hsq1220t2": [
        "RUA"
    ],
    "24lh8011t": [
        "8A"
    ],
    "24lh7010t": [
        "8A"
    ],
    "24lf8010t": [
        "8A"
    ],
    "24h550t": [
        "4B"
    ],
    "24f560t": [
        "4B"
    ],
    "43u570t": [
        "4B"
    ],
    "50u541t": [
        "4B"
    ],
    "50lu1222": [
        "VIT"
    ],
    "50u550t": [
        "4B"
    ],
    "55le7053d": [
        "4H"
    ],
    "55lu8030s": [
        "8A"
    ],
    "55lu1222": [
        "VIT"
    ],
    "55ulx9005t2": [
        "05"
    ],
    "55ules901t2sm": [
        "05"
    ],
    "55ue-byvb": [
        "KTC"
    ],
    "k43uh902": [
        "TRC"
    ],
    "k43uh901": [
        "TRC"
    ],
    "k32hh902": [
        "TRC"
    ],
    "h43qsy24f": [
        "RAZ"
    ],
    "h32h5001sa": [
        "TRC"
    ],
    "h32h5000sa": [
        "TRC"
    ],
    "sun-led50xu400": [
        "W8"
    ],
    "box r lite 4k": [
        "HOM"
    ],
    "bq_43fs38b": [
        "BX"
    ],
    "43ov4000af": [
        "ONV"
    ],
    "43lu6000t": [
        "8A"
    ],
    "40lf7030st": [
        "8A"
    ],
    "tdtv50cs06u": [
        "TOP"
    ],
    "tdtv50cq08u": [
        "TOP"
    ],
    "tdtv24bs02h_we": [
        "TOP"
    ],
    "tdtv24bs01h_bk": [
        "TOP"
    ],
    "sm-led32m07s": [
        "X2",
        "SA"
    ],
    "sm-qled50t21su": [
        "X2",
        "SA"
    ],
    "sl-led65s01t2su": [
        "SC1"
    ],
    "hx-43f01fb": [
        "3H"
    ],
    "hx-32h01fb": [
        "3H"
    ],
    "hx-43u01fb": [
        "3H"
    ],
    "hx-50u01fb": [
        "3H"
    ],
    "hx-55u01fb": [
        "3H"
    ],
    "hx-32f01fb": [
        "3H"
    ],
    "hx-24h01fb": [
        "3H"
    ],
    "50lu6000t": [
        "8A"
    ],
    "32qws9002": [
        "WLR"
    ],
    "an-232": [
        "EPL"
    ],
    "zala smartbox dv9135": [
        "ZAL",
        "M9"
    ],
    "yndx-00095": [
        "YD"
    ],
    "yndx-00094": [
        "YD"
    ],
    "yndx-00093": [
        "YD"
    ],
    "winkbox mini": [
        "WN"
    ],
    "winkbox 3": [
        "WN"
    ],
    "waipu tv stick": [
        "WAT"
    ],
    "ulx-24tcs221-t9": [
        "YN"
    ],
    "ulx-32tcs226-t9": [
        "YN"
    ],
    "sm-led55m04su": [
        "X2",
        "SA"
    ],
    "sm-led43m03su": [
        "X2",
        "SA"
    ],
    "sm-led32m15s": [
        "X2",
        "SA"
    ],
    "sm-led24m11s": [
        "X2",
        "SA"
    ],
    "cadena pro a csb-230": [
        "CAD"
    ],
    "cadena pro a3 csb-242": [
        "CAD"
    ],
    "rh-le50dsy-c": [
        "ROH"
    ],
    "rh-le32dsy-c": [
        "ROH"
    ],
    "vontar h728": [
        "1V"
    ],
    "yndx-00096": [
        "YD"
    ],
    "yndx-00081": [
        "YD"
    ],
    "yndx-00080": [
        "YD"
    ],
    "yndx-00079": [
        "YD"
    ],
    "yndx-00078": [
        "YD"
    ],
    "samtron_43sa701": [
        "SAM"
    ],
    "akai_ta50bu500": [
        "AK"
    ],
    "akai_ta32bh500": [
        "AK"
    ],
    "akai_ta32bf552": [
        "AK"
    ],
    "korax-eurobox pro": [
        "KRX"
    ],
    "kf-1500": [
        "TUR"
    ],
    "hoco dq09": [
        "HOC"
    ],
    "gd s1 atv": [
        "GD1"
    ],
    "rombica tv emotion": [
        "R3"
    ],
    "bb2 pro": [
        "0M"
    ],
    "kii pro": [
        "0M"
    ],
    "km9pro": [
        "0M"
    ],
    "km9_tv_box": [
        "0M"
    ],
    "m8s max": [
        "0M"
    ],
    "m8s plus dvb": [
        "0M"
    ],
    "m8s plus l": [
        "0M"
    ],
    "m8s plus w": [
        "0M"
    ],
    "m8s pro": [
        "0M"
    ],
    "m8s pro l": [
        "0M"
    ],
    "m8s pro plus": [
        "0M"
    ],
    "m8s pro w": [
        "0M"
    ],
    "m8sprow": [
        "0M"
    ],
    "hk1 max": [
        "1V"
    ],
    "hk1 mini": [
        "1V"
    ],
    "hk1 pro": [
        "1V"
    ],
    "vontar-kiii": [
        "1V"
    ],
    "vontar mx-4k": [
        "1V"
    ],
    "vontar v1": [
        "1V"
    ],
    "vontar z5": [
        "1V"
    ],
    "vontar z8 arc": [
        "1V"
    ],
    "neo-u1": [
        "1X"
    ],
    "neo-u9-h": [
        "1X"
    ],
    "neo-x5-116a": [
        "1X"
    ],
    "neo-x5-mini": [
        "1X"
    ],
    "neo-x6": [
        "1X"
    ],
    "neo-x7-216a": [
        "1X"
    ],
    "neo-x7-mini": [
        "1X"
    ],
    "neo-x88-i": [
        "1X"
    ],
    "neo-x8-h": [
        "1X"
    ],
    "neo-x8h-plus": [
        "1X"
    ],
    "neo-z64": [
        "1X"
    ],
    "atom-108am": [
        "2A"
    ],
    "vorke z1": [
        "2V"
    ],
    "vorke z5": [
        "2V"
    ],
    "vorke z6": [
        "2V"
    ],
    "vorke z6 plus": [
        "2V"
    ],
    "a95x_r1": [
        "3L",
        "A95"
    ],
    "nv501": [
        "4E"
    ],
    "nv501wac": [
        "4E"
    ],
    "invin-km6": [
        "4I"
    ],
    "invin x2": [
        "4I"
    ],
    "invin_x4": [
        "4I"
    ],
    "draco aw80": [
        "4T"
    ],
    "draco h3": [
        "4T"
    ],
    "orion r68g": [
        "4T"
    ],
    "vega s95_meta": [
        "4T"
    ],
    "vega s95_pro": [
        "4T"
    ],
    "vega s95_telos": [
        "4T"
    ],
    "transpeed_6k": [
        "5R"
    ],
    "tr99": [
        "5R"
    ],
    "tr99 mini+": [
        "5R"
    ],
    "t95zplus": [
        "5S"
    ],
    "32lf7130s": [
        "8A"
    ],
    "beelink a1": [
        "B0"
    ],
    "beelink gt1": [
        "B0"
    ],
    "beelink lake i": [
        "B0"
    ],
    "beelink sea i": [
        "B0"
    ],
    "cvte_msd338_1g": [
        "CV"
    ],
    "cvte_msd338_512m": [
        "CV"
    ],
    "daewoo android tv 638": [
        "D5"
    ],
    "divisat j-link": [
        "D6"
    ],
    "dolamee d5": [
        "D9"
    ],
    "dolamee-d6": [
        "D9"
    ],
    "24dhs54": [
        "DF"
    ],
    "f43d8000k pnl_72043311": [
        "DX"
    ],
    "f48d8000k pnl_72048303_lsc480hn08_8": [
        "DX"
    ],
    "evolveo smart tv box q4": [
        "EO",
        "60"
    ],
    "build": [
        "GO"
    ],
    "afteuff014": [
        "GU"
    ],
    "afteu011": [
        "GU",
        "KN"
    ],
    "afteu014": [
        "GU"
    ],
    "hat4kdtv": [
        "HI"
    ],
    "iconbit movie ultra hd 4k": [
        "I2"
    ],
    "xds74k": [
        "I2"
    ],
    "xds84k": [
        "I2"
    ],
    "xds94k": [
        "I2"
    ],
    "aftjmst12": [
        "IS",
        "KN"
    ],
    "afteamr311": [
        "IS"
    ],
    "katv-01 pro": [
        "K5"
    ],
    "aftb": [
        "KN"
    ],
    "aftn": [
        "KN"
    ],
    "afta": [
        "KN"
    ],
    "aftr": [
        "KN"
    ],
    "aftm": [
        "KN"
    ],
    "aftt": [
        "KN"
    ],
    "afts": [
        "KN"
    ],
    "24fr50wu": [
        "KV"
    ],
    "24h600gr": [
        "KV"
    ],
    "24h600gu": [
        "KV"
    ],
    "24hk30b": [
        "KV"
    ],
    "32fk30g": [
        "KV"
    ],
    "32fk32g": [
        "KV"
    ],
    "32fk32g_-ver01": [
        "KV"
    ],
    "32fr50bu": [
        "KV"
    ],
    "32fr50wr": [
        "KV"
    ],
    "32hk30g_-ver01": [
        "KV"
    ],
    "32hr50gr": [
        "KV"
    ],
    "32hr50gr_-ver02": [
        "KV"
    ],
    "32hr50gu_-ver01": [
        "KV"
    ],
    "32hr55gu": [
        "KV"
    ],
    "40fk30g": [
        "KV"
    ],
    "40fk30g_-ver02": [
        "KV"
    ],
    "40fr50br": [
        "KV"
    ],
    "40u600gr": [
        "KV"
    ],
    "40u600gu": [
        "KV"
    ],
    "40ur50gr": [
        "KV"
    ],
    "40ur50gu": [
        "KV"
    ],
    "43uk30g_-ver01": [
        "KV"
    ],
    "43uk30g_-ver02": [
        "KV"
    ],
    "43uk35g": [
        "KV"
    ],
    "43up50gu": [
        "KV"
    ],
    "49up50gu": [
        "KV"
    ],
    "50fk30g": [
        "KV"
    ],
    "50u600gu": [
        "KV"
    ],
    "50uk35g": [
        "KV"
    ],
    "55uc30g_-ver02": [
        "KV"
    ],
    "55up50gu": [
        "KV"
    ],
    "55ur50gr": [
        "KV"
    ],
    "aftrs": [
        "L0",
        "KN"
    ],
    "nx-32ths100": [
        "N7"
    ],
    "nexon x1": [
        "N8"
    ],
    "nexon x9": [
        "N8"
    ],
    "gtv100": [
        "NA"
    ],
    "shield android tv": [
        "NV"
    ],
    "ng3128hd": [
        "NZ"
    ],
    "openbox a3": [
        "OH"
    ],
    "openbox a4": [
        "OH"
    ],
    "openbox a4 lite": [
        "OH"
    ],
    "openbox a4 pro": [
        "OH"
    ],
    "ozonehd 4k": [
        "OZ"
    ],
    "ozonehd 4k tv": [
        "OZ"
    ],
    "ozonehd t2 wifi": [
        "OZ"
    ],
    "70puh6774_96": [
        "PH"
    ],
    "and1e tv": [
        "PH"
    ],
    "and1e": [
        "PH"
    ],
    "qm161e": [
        "PH"
    ],
    "qm163e": [
        "PH"
    ],
    "qm164e": [
        "PH"
    ],
    "tpm171e": [
        "PH"
    ],
    "pov_tv-hdmi-kb-01": [
        "PV"
    ],
    "pov_tv-hdmi-200bt": [
        "PV"
    ],
    "r-tv box mini+": [
        "R2"
    ],
    "r-tv boxr10.03.d32": [
        "R2"
    ],
    "r-tv box s10": [
        "R2"
    ],
    "r-tv box x10": [
        "R2"
    ],
    "r-tv box x10 pro": [
        "R2"
    ],
    "r-tv box x99.02.00.d32": [
        "R2"
    ],
    "rombica infinity k8": [
        "R3"
    ],
    "rombica smart box 4k v001": [
        "R3"
    ],
    "rombica smart box quad": [
        "R3"
    ],
    "rombica smart box ultra hd v002": [
        "R3"
    ],
    "rombica smart box v005": [
        "R3"
    ],
    "ssq-a0500": [
        "R3"
    ],
    "mk808": [
        "RI"
    ],
    "mk808b": [
        "RI",
        "SE"
    ],
    "gt-b9150": [
        "SA"
    ],
    "skyworth 8k55 e680": [
        "SK"
    ],
    "bravia 2015": [
        "SO"
    ],
    "bravia 2k gb atv3": [
        "SO"
    ],
    "bravia 4k 2015": [
        "SO"
    ],
    "bravia 4k gb": [
        "SO"
    ],
    "bravia 4k gb atv3": [
        "SO"
    ],
    "bravia 4k ur2": [
        "SO"
    ],
    "kdl42w805a": [
        "SO"
    ],
    "storex linkbox": [
        "ST"
    ],
    "k32dlx9hs": [
        "T0"
    ],
    "k40dlm8fs": [
        "T0"
    ],
    "k40dlx9fs": [
        "T0"
    ],
    "tf-led32s39t2s": [
        "TL"
    ],
    "tf-led32s52t2s": [
        "TL"
    ],
    "tf-led32s58t2s_-ver01": [
        "TL"
    ],
    "tf-led32s59t2s": [
        "TL"
    ],
    "tf-led32s70t2s": [
        "TL"
    ],
    "tf-led65s75t2su": [
        "TL"
    ],
    "ugoos-am6": [
        "UG"
    ],
    "vmp-011-81": [
        "V7"
    ],
    "vmp-021-82": [
        "V7"
    ],
    "vmp-041-162": [
        "V7"
    ],
    "vesta32ld86": [
        "V8"
    ],
    "sm-led32m04s": [
        "X2",
        "SA"
    ],
    "sm-led32m11s": [
        "X2",
        "SA"
    ],
    "sm-led40m04s": [
        "X2",
        "SA"
    ],
    "nexbox-a1": [
        "XB"
    ],
    "nexbox-a5": [
        "XB"
    ],
    "nexbox-a95x": [
        "XB"
    ],
    "mxq-nexbox": [
        "XB"
    ],
    "mxq-pro-nexbox": [
        "XB"
    ],
    "xgody_x96": [
        "XG"
    ],
    "mibox1s": [
        "XI"
    ],
    "mibox2": [
        "XI"
    ],
    "mibox3_pro": [
        "XI"
    ],
    "mitv4-ansm0": [
        "XI"
    ],
    "mitv4a": [
        "XI"
    ],
    "mitv-axso0": [
        "XI"
    ],
    "mitv-mssp1": [
        "XI"
    ],
    "hst 260": [
        "XR"
    ],
    "zidoo_h6 pro": [
        "ZI"
    ],
    "zidoo_x1": [
        "ZI"
    ],
    "zidoo_x5": [
        "ZI"
    ],
    "zidoo_x6 pro": [
        "ZI"
    ],
    "zidoo_x8": [
        "ZI"
    ],
    "zidoo_x9s": [
        "ZI"
    ],
    "zidoo_z10": [
        "ZI"
    ],
    "vontar x3": [
        "1V"
    ],
    "portaltv": [
        "F6"
    ],
    "hk1 plus": [
        "1V"
    ],
    "nvidia shield; smart-tv": [
        "NV"
    ],
    "nvidia_shield_pro_2019": [
        "NV"
    ],
    "ozone hd": [
        "OZ"
    ],
    "t95kpro": [
        "5S"
    ],
    "t95upro": [
        "5S"
    ],
    "zidoo_z9s": [
        "ZI"
    ],
    "spc_alien_stick": [
        "FS"
    ],
    "spc_alien": [
        "FS"
    ],
    "pendoo t95z plus": [
        "PQ"
    ],
    "pendoo x92": [
        "PQ"
    ],
    "pendoo mini": [
        "PQ"
    ],
    "pendoo x10 plus": [
        "PQ"
    ],
    "pendoo x8pro+": [
        "PQ"
    ],
    "a5x max.pendoo.01.d4": [
        "PQ"
    ],
    "a5x max.01.d4": [
        "PQ"
    ],
    "a5x max-hydz.01.d4": [
        "PQ"
    ],
    "pendoo.x99.02.00.d32": [
        "PQ"
    ],
    "pipo_x9s": [
        "PJ"
    ],
    "pipo_x10": [
        "PJ"
    ],
    "en1007qplus": [
        "EJ"
    ],
    "solo 4k": [
        "DU"
    ],
    "philco android tv": [
        "4P"
    ],
    "tvb-906x": [
        "81"
    ],
    "beelink gs1": [
        "B0"
    ],
    "andowl": [
        "60"
    ],
    "tivo stream 4k": [
        "YV"
    ],
    "dexp al-2020": [
        "DX"
    ],
    "dns": [
        "DN"
    ],
    "audi_ks1280x480": [],
    "ks1280x480": [],
    "aosp on r33a0": [],
    "hx322x_box": [],
    "x98_s500": [],
    "p1": [],
    "waydroid x86_64 device": [],
    "leo-bx9": [
        "HU"
    ],
    "lg watch urbane": [
        "LG"
    ],
    "watch6,2": [
        "AP"
    ],
    "watch6,3": [
        "AP"
    ],
    "watch6,4": [
        "AP"
    ],
    "asus zenwatch": [
        "AU"
    ],
    "asus zenwatch 2": [
        "AU"
    ],
    "pico g2 4k": [
        "QP"
    ],
    "vrl42": [
        "D2"
    ],
    "nb runiq": [
        "HB"
    ],
    "vr-1541f": [
        "LE"
    ],
    "pacific": [
        "OQ"
    ],
    "quest 2": [
        "OQ"
    ],
    "standalone hmd": [
        "OQ"
    ],
    "h1-c-aladeng": [
        "5G"
    ],
    "lem14": [
        "W9"
    ],
    "moto 360": [
        "MR"
    ],
    "gear live": [
        "SA"
    ],
    "g watch": [
        "LG"
    ],
    "g watch r": [
        "LG"
    ],
    "smartwatch 3": [
        "SO"
    ],
    "motorola-f100": [
        "MR"
    ],
    "nt-1501c": [
        "I2"
    ],
    "r2021w2": [
        "YZ"
    ],
    "appllp2": [
        "GY"
    ],
    "leo-dlxx": [
        "HU"
    ],
    "lem12pro": [
        "W9"
    ],
    "ow19w1": [
        "OP"
    ],
    "ow19w2": [
        "OP"
    ],
    "ow19w3": [
        "OP"
    ],
    "ow20w1": [
        "OP"
    ],
    "lem15": [
        "W9"
    ],
    "geozon lte": [
        "GEO"
    ],
    "leo-dlxxe": [
        "HU"
    ],
    "appllp max": [
        "GY"
    ],
    "pico neo 3": [
        "QP"
    ],
    "thor 4 plus": [
        "ZE1"
    ],
    "thor s": [
        "ZE1"
    ],
    "thor pro": [
        "ZE1"
    ],
    "gll-al01": [
        "HU"
    ],
    "samsung sm-r875f": [
        "SA"
    ],
    "sm-r870": [
        "SA"
    ],
    "sm-r860": [
        "SA"
    ],
    "samsung sm-r905u": [
        "SA"
    ],
    "sm-r925f": [
        "SA"
    ],
    "samsung sm-r925n": [
        "SA"
    ],
    "samsung sm-r925u": [
        "SA"
    ],
    "samsung sm-r920": [
        "SA"
    ],
    "sm-r915u": [
        "SA"
    ],
    "samsung sm-r915f": [
        "SA"
    ],
    "sm-r910": [
        "SA"
    ],
    "samsung sm-r905n": [
        "SA"
    ],
    "sm-r905f": [
        "SA"
    ],
    "sm-r895u": [
        "SA"
    ],
    "sm-r895n": [
        "SA"
    ],
    "sm-r895f": [
        "SA"
    ],
    "sm-r900": [
        "SA"
    ],
    "ticwatch pro s": [
        "MVO"
    ],
    "ticwatch s2": [
        "MVO"
    ],
    "ticwatch c2": [
        "MVO"
    ],
    "ticwatch c2+": [
        "MVO"
    ],
    "ticwatch s": [
        "MVO"
    ],
    "watch6,10": [
        "AP"
    ],
    "watch6,11": [
        "AP"
    ],
    "watch6,12": [
        "AP"
    ],
    "watch6,13": [
        "AP"
    ],
    "watch6,14": [
        "AP"
    ],
    "watch6,15": [
        "AP"
    ],
    "watch6,16": [
        "AP"
    ],
    "watch6,17": [
        "AP"
    ],
    "watch6,18": [
        "AP"
    ],
    "watch7,1": [
        "AP"
    ],
    "watch7,2": [
        "AP"
    ],
    "watch7,3": [
        "AP"
    ],
    "watch7,4": [
        "AP"
    ],
    "watch7,5": [
        "AP"
    ],
    "kidphone4g": [
        "7E"
    ],
    "x9 call2": [
        "WAO"
    ],
    "lem16": [
        "W9"
    ],
    "samsung ticwatch pro 3 ultra gps": [
        "MVO"
    ],
    "arc-al00": [
        "HU"
    ],
    "samsung sm-r885u": [
        "SA"
    ],
    "glass 1": [
        "GO"
    ],
    "pico neo 3 os5.9.5.0 like quest": [
        "QP"
    ],
    "a8110": [
        "QP"
    ],
    "sm-r960": [
        "SA"
    ],
    "sm-r950": [
        "SA"
    ],
    "sm-r920": [
        "SA"
    ],
    "elari 4g wink": [
        "7E"
    ],
    "opwwe231": [
        "ON"
    ],
    "ticwatch pro 5": [
        "MVO"
    ],
    "watch7,8": [
        "AP"
    ],
    "watch7,10": [
        "AP"
    ],
    "watch7,9": [
        "AP"
    ],
    "watch7,11": [
        "AP"
    ],
    "quest 3s": [
        "OQ"
    ],
    "quest 3": [
        "OQ"
    ]
};


class $875ac1efa858937e$var$IndexerDevice {
    static findDeviceBrandsForDeviceCode(deviceCode) {
        let lDeviceCode = deviceCode.toLowerCase();
        let brands = $eaa86e5f68e1af25$exports[lDeviceCode];
        if (brands !== void 0) return brands;
        return [];
    }
}
$875ac1efa858937e$exports = $875ac1efa858937e$var$IndexerDevice;


var $d3607477d39bdd2f$exports = {};

var $f0e5891862cbf6ee$exports = {};

class $f0e5891862cbf6ee$var$DataPacker {
    /**
   * pack objects to str
   * format: shortcode=value;
   * @param obj
   * @param shortKeys
   * @returns {string}
   */ static pack(obj, shortKeys) {
        let data = [];
        for(let key in shortKeys){
            let value = $080a2fe2f6d503e1$exports.get(obj, shortKeys[key]);
            if (value === void 0 || value === null) continue;
            data.push(`${key}=${value};`);
        }
        return data.join('');
    }
    /**
   * unpack string to objects
   * @param str
   * @param shortKeys
   * @returns {{}}
   */ static unpack(str, shortKeys) {
        let regex = /([a-z]{2})=([^;]+)?;/gi;
        let obj = {};
        let match = null;
        while(match = regex.exec(str)){
            let short = match[1];
            let value = match[2] !== void 0 ? match[2] : '';
            let path = shortKeys[short];
            $080a2fe2f6d503e1$exports.set(obj, path, value, true);
        }
        return obj;
    }
}
$f0e5891862cbf6ee$exports = $f0e5891862cbf6ee$var$DataPacker;


var $cbaad1bf507ff5be$exports = {};
$cbaad1bf507ff5be$exports = {
    "cpu": {
        "1": {
            "name": "MediaTek MT6582M",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "2": {
            "name": "MediaTek MT6592",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 3
        },
        "3": {
            "name": "HiSilicon Kirin 620",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 3
        },
        "4": {
            "name": "MediaTek MT6580A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "5": {
            "name": "MediaTek MT6580",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "6": {
            "name": "Spreadtrum SC7731",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "7": {
            "name": "MediaTek MT6582",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "8": {
            "name": "MediaTek MT6739",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 4
        },
        "9": {
            "name": "MediaTek MT6737",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 5
        },
        "10": {
            "name": "Qualcomm Snapdragon 210",
            "code": "MSM8909",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1100,
            "process": "28nm",
            "gpu_id": 6
        },
        "11": {
            "name": "Qualcomm Snapdragon 212",
            "code": "APQ8009",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 6
        },
        "12": {
            "name": "MediaTek MT8125",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 7
        },
        "13": {
            "name": "Samsung Exynos 3110",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "process": "45nm",
            "gpu_id": 8
        },
        "14": {
            "name": "Qualcomm Snapdragon S4 Plus",
            "code": "MSM8960",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 9
        },
        "15": {
            "name": "Qualcomm Snapdragon S4 Pro",
            "code": "MSM8960T",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 10
        },
        "16": {
            "name": "Intel Atom Z3560",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1830,
            "process": "22nm",
            "gpu_id": 13
        },
        "17": {
            "name": "Qualcomm Snapdragon 410",
            "code": "MSM8916",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 14
        },
        "18": {
            "name": "Intel Atom Z2560",
            "type": "x86",
            "cores": "2/4",
            "clock_rate": 1600,
            "process": "35nm",
            "gpu_id": 15
        },
        "19": {
            "name": "Qualcomm Snapdragon 630",
            "code": "SDM630",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "14nm",
            "gpu_id": 16
        },
        "20": {
            "name": "Qualcomm Snapdragon 425",
            "code": "MSM8917",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 17
        },
        "21": {
            "name": "Spreadtrum SC9832",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "22": {
            "name": "Qualcomm Snapdragon 615",
            "code": "MSM8939",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 18
        },
        "23": {
            "name": "Amlogic S805",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 1
        },
        "24": {
            "name": "MediaTek MT6572",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 1
        },
        "25": {
            "name": "Qualcomm Snapdragon 835",
            "code": "MSM8998",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2450,
            "process": "10nm",
            "gpu_id": 19
        },
        "26": {
            "name": "Qualcomm MSM7600",
            "type": "x86",
            "cores": 1,
            "process": "65nm",
            "clock_rate": 528
        },
        "27": {
            "name": "MediaTek MT6589",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 7
        },
        "28": {
            "name": "HiSilicon Kirin 710",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "14nm",
            "gpu_id": 20
        },
        "29": {
            "name": "Texas Instruments OMAP 4460",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "process": "45nm",
            "gpu_id": 8
        },
        "30": {
            "name": "HiSilicon Kirin 920",
            "code": "Hi3630",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 21
        },
        "31": {
            "name": "Qualcomm Snapdragon S1",
            "code": "MSM7227A",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "process": "45nm",
            "gpu_id": 22
        },
        "32": {
            "name": "Qualcomm Snapdragon S4 Plus",
            "code": "MSM8930",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 12
        },
        "33": {
            "name": "Qualcomm Snapdragon 200",
            "code": "MSM8212",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 23
        },
        "34": {
            "name": "HiSilicon Kirin 910T",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1800,
            "process": "28nm",
            "gpu_id": 3
        },
        "35": {
            "name": "Qualcomm Snapdragon 435",
            "code": "MSM8940",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 24
        },
        "36": {
            "name": "MediaTek MT6572M",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 1
        },
        "37": {
            "name": "HiSilicon Kirin 710F",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "12nm",
            "gpu_id": 20
        },
        "38": {
            "name": "MediaTek Helio P35",
            "code": "MT6765",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "12nm",
            "gpu_id": 25
        },
        "39": {
            "name": "MediaTek MT6753T",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 2
        },
        "40": {
            "name": "MediaTek MT6750",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 26
        },
        "41": {
            "name": "Qualcomm Snapdragon 439",
            "code": "SDM439",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 24
        },
        "42": {
            "name": "HiSilicon Kirin 659",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2360,
            "process": "16nm",
            "gpu_id": 27
        },
        "43": {
            "name": "Qualcomm Snapdragon 430",
            "code": "MSM8937",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 24
        },
        "44": {
            "name": "MediaTek Helio A22",
            "code": "MT6761",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 25
        },
        "45": {
            "name": "MediaTek Dimensity 800",
            "code": "MT6873",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "7nm",
            "gpu_id": 28
        },
        "46": {
            "name": "Qualcomm Snapdragon S1",
            "code": "MSM7225A",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "process": "45nm",
            "gpu_id": 22
        },
        "47": {
            "name": "MediaTek Helio P22",
            "code": "MT6762R",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 25
        },
        "48": {
            "name": "HiSilicon Kirin 655",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2100,
            "process": "16nm",
            "gpu_id": 27
        },
        "49": {
            "name": "Qualcomm Snapdragon S2",
            "code": "MSM8255",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1500,
            "process": "45nm",
            "gpu_id": 29
        },
        "50": {
            "name": "HiSilicon Kirin 970",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "10nm",
            "gpu_id": 30
        },
        "51": {
            "name": "HiSilicon K3V2",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "40nm",
            "gpu_id": 31
        },
        "52": {
            "name": "HiSilicon Kirin 980",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "7nm",
            "gpu_id": 32
        },
        "53": {
            "name": "HiSilicon Kirin 985 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2850,
            "process": "7nm",
            "gpu_id": 33
        },
        "54": {
            "name": "HiSilicon Kirin 990 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2860,
            "process": "7nm",
            "gpu_id": 34
        },
        "55": {
            "name": "HiSilicon Kirin 820 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2360,
            "process": "7nm",
            "gpu_id": 35
        },
        "56": {
            "name": "MediaTek MT6735P",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1000,
            "process": "28nm",
            "gpu_id": 2
        },
        "57": {
            "name": "HiSilicon Kirin 810",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2270,
            "process": "7nm",
            "gpu_id": 36
        },
        "58": {
            "name": "MediaTek MT6580M",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "59": {
            "name": "Apple A13 Bionic APL1W85",
            "type": "ARM",
            "cores": 6,
            "process": "7nm",
            "clock_rate": 2650
        },
        "60": {
            "name": "MediaTek MT6752M",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 37
        },
        "61": {
            "name": "Qualcomm Snapdragon 660",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "14nm",
            "gpu_id": 38
        },
        "62": {
            "name": "Qualcomm Snapdragon 710",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "10nm",
            "gpu_id": 39
        },
        "63": {
            "name": "MediaTek Helio P23 MT6763",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2500,
            "process": "16nm",
            "gpu_id": 40
        },
        "64": {
            "name": "Qualcomm Snapdragon 632",
            "code": "SDM632",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "14nm",
            "gpu_id": 41
        },
        "65": {
            "name": "Qualcomm Snapdragon 617",
            "code": "MSM8952",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 18
        },
        "66": {
            "name": "HiSilicon Kirin 650",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "16nm",
            "gpu_id": 27
        },
        "67": {
            "name": "Samsung Exynos 9825",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2730,
            "process": "7nm",
            "gpu_id": 42
        },
        "68": {
            "name": "Qualcomm Snapdragon 616",
            "code": "MSM8939v2",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 18
        },
        "69": {
            "name": "MediaTek MT6737T",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 5
        },
        "70": {
            "name": "HiSilicon Kirin 925",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "28nm",
            "gpu_id": 43
        },
        "71": {
            "name": "Allwinner A33",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "40nm",
            "gpu_id": 1
        },
        "72": {
            "name": "Rockchip RK3168",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 8
        },
        "73": {
            "name": "Rockchip RK3066",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1500,
            "process": "40nm",
            "gpu_id": 44
        },
        "74": {
            "name": "MediaTek MT8735",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 2
        },
        "75": {
            "name": "Nvidia Tegra 4",
            "type": "ARM",
            "cores": 4,
            "process": "28nm",
            "clock_rate": 1800
        },
        "76": {
            "name": "MediaTek MT6739W",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 4
        },
        "77": {
            "name": "Marvell PXA310",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 624
        },
        "78": {
            "name": "Qualcomm Snapdragon 400",
            "code": "MSM8226",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 12
        },
        "79": {
            "name": "MediaTek MT6735",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "cpu_id": 2
        },
        "80": {
            "name": "Rockchip RK3188",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1800,
            "process": "28nm",
            "cpu_id": 44
        },
        "81": {
            "name": "Qualcomm Snapdragon 625",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "14nm",
            "cpu_id": 41
        },
        "82": {
            "name": "Rockchip RK3288",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1800,
            "process": "28nm",
            "cpu_id": 45
        },
        "83": {
            "name": "Unisoc SC9832E",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "cpu_id": 46
        },
        "84": {
            "name": "MediaTek MT6739WW",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "cpu_id": 4
        },
        "85": {
            "name": "MediaTek Helio X10",
            "code": "MT6795",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "28nm",
            "gpu_id": 47
        },
        "86": {
            "name": "MediaTek MT6737M",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1250,
            "process": "28nm",
            "gpu_id": 5
        },
        "87": {
            "name": "Nvidia Tegra 2",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "process": "40nm"
        },
        "88": {
            "name": "Spreadtrum SC7731",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "89": {
            "name": "MediaTek MT8121",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 7
        },
        "90": {
            "name": "MediaTek MT6575",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "process": "40nm",
            "gpu_id": 48
        },
        "91": {
            "name": "Qualcomm Snapdragon S1",
            "code": "MSM7225",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "process": "45nm",
            "gpu_id": 22
        },
        "92": {
            "name": "AMD A8-6410",
            "type": "x86",
            "cores": 4,
            "clock_rate": 2400,
            "process": "28nm",
            "gpu_id": 49
        },
        "93": {
            "name": "MediaTek MT8321M",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "94": {
            "name": "Qualcomm Snapdragon 800",
            "code": "MSM8974",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2300,
            "process": "28nm",
            "gpu_id": 11
        },
        "95": {
            "name": "Texas Instruments OMAP 4470",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1500,
            "process": "45nm",
            "gpu_id": 8
        },
        "96": {
            "name": "Qualcomm Snapdragon 810",
            "code": "MSM8994",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "20nm",
            "gpu_id": 50
        },
        "97": {
            "name": "MediaTek Helio P60T",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 51
        },
        "98": {
            "name": "MediaTek MT8183",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 51
        },
        "99": {
            "name": "MediaTek MT8173",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2400,
            "process": "28nm",
            "gpu_id": 52
        },
        "100": {
            "name": "MediaTek MT8135",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 47
        },
        "101": {
            "name": "MediaTek MT8168",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 53
        },
        "102": {
            "name": "Rockchip RK3188T",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1800,
            "gpu_id": 44
        },
        "103": {
            "name": "Spreadtrum SC7731",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "104": {
            "name": "Apple A6x",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1400
        },
        "105": {
            "name": "Apple A5",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000
        },
        "106": {
            "name": "Apple A8X",
            "type": "ARM",
            "cores": 3,
            "clock_rate": 1500,
            "process": "20nm",
            "gpu_id": 54
        },
        "107": {
            "name": "MediaTek MT8389",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 7
        },
        "108": {
            "name": "Apple A7",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 13
        },
        "109": {
            "name": "Unisoc SC9863A",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1600,
            "process": "28nm",
            "gpu_id": 55
        },
        "110": {
            "name": "Qualcomm Snapdragon S4 Play MSM8225Q",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "45nm",
            "gpu_id": 56
        },
        "111": {
            "name": "Qualcomm Snapdragon 400 MSM8926",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 12
        },
        "112": {
            "name": "MediaTek MT6589T",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 7
        },
        "113": {
            "name": "MediaTek MT6737VWT",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 5
        },
        "114": {
            "name": "MediaTek Helio P70",
            "code": "MT6771",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2100,
            "process": "12nm",
            "gpu_id": 51
        },
        "115": {
            "name": "Qualcomm Snapdragon 652 MSM8976",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "28nm",
            "gpu_id": 57
        },
        "116": {
            "name": "Rockchip RK3399",
            "type": "ARM",
            "cores": 6,
            "clock_rate": 2000,
            "gpu_id": 58
        },
        "117": {
            "name": "MediaTek Helio P10",
            "code": "MT6755",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "28nm",
            "gpu_id": 26
        },
        "118": {
            "name": "MediaTek MT6753",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 59
        },
        "119": {
            "name": "Qualcomm Snapdragon 200 8210",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "gpu_id": 23
        },
        "120": {
            "name": "MediaTek MT8732",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 37
        },
        "121": {
            "name": "MediaTek MT8735B",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "gpu_id": 2
        },
        "122": {
            "name": "Apple A14 Bionic",
            "type": "ARM",
            "cores": 3,
            "clock_rate": 3100
        },
        "123": {
            "name": "Apple A4",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000
        },
        "124": {
            "name": "Apple A6",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000
        },
        "125": {
            "name": "Apple A8",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1400,
            "gpu_id": 60
        },
        "126": {
            "name": "Apple A9",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1800
        },
        "127": {
            "name": "Apple A10 Fusion",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2340
        },
        "128": {
            "name": "Apple A11 Bionic",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2390
        },
        "129": {
            "name": "Apple A13 Bionic",
            "type": "ARM",
            "cores": 6,
            "clock_rate": 2660
        },
        "130": {
            "name": "Apple A12 Bionic",
            "type": "ARM",
            "cores": 6,
            "clock_rate": 2490
        },
        "131": {
            "name": "Intel Atom Z2580",
            "type": "x86",
            "cores": "2/4",
            "clock_rate": 2000,
            "gpu_id": 61
        },
        "132": {
            "name": "Intel Atom Z2420",
            "type": "x86",
            "cores": "1/2",
            "clock_rate": 1200,
            "process": "32nm",
            "gpu_id": 8
        },
        "133": {
            "name": "WonderMedia PRIZM WM8950",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "gpu_id": 62
        },
        "134": {
            "name": "Qualcomm Snapdragon S4 Pro APQ8064A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 10
        },
        "135": {
            "name": "Intel Atom Z3745",
            "type": "x86",
            "cores": 4,
            "clock_rate": 1860,
            "process": "22nm",
            "gpu_id": 63
        },
        "136": {
            "name": "Intel Atom Z3580",
            "type": "x86",
            "cores": 4,
            "clock_rate": 2330,
            "gpu_id": 13
        },
        "137": {
            "name": "NVIDIA Tegra 3",
            "type": "ARM",
            "cores": 4,
            "process": "28nm",
            "clock_rate": 1700
        },
        "138": {
            "name": "Qualcomm Snapdragon 600 APQ8064T",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 64
        },
        "139": {
            "name": "Qualcomm Snapdragon 801 MSM8974AB",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2360,
            "process": "28nm",
            "gpu_id": 65
        },
        "140": {
            "name": "Qualcomm Snapdragon S4 Plus MSM8260A",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 66
        },
        "141": {
            "name": "Qualcomm Snapdragon 865+ 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3100,
            "process": "7nm",
            "gpu_id": 67
        },
        "142": {
            "name": "MediaTek MT6739WM",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1100,
            "process": "28nm",
            "gpu_id": 4
        },
        "143": {
            "name": "MediaTek MT8317",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200,
            "gpu_id": 48
        },
        "144": {
            "name": "MediaTek MT8163",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 51
        },
        "145": {
            "name": "Qualcomm Snapdragon S1 MSM7227",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 600,
            "process": "65nm",
            "gpu_id": 22
        },
        "146": {
            "name": "Apple A12Z Bionic",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2490
        },
        "147": {
            "name": "Apple A12X Bionic",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2490
        },
        "148": {
            "name": "Apple A15 Bionic",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 0
        },
        "149": {
            "name": "Qualcomm MSM7227 Turbo",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 832,
            "process": "65nm",
            "gpu_id": 22
        },
        "150": {
            "name": "Qualcomm Snapdragon S1 QSD8250",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "process": "65nm",
            "gpu_id": 22
        },
        "151": {
            "name": "MediaTek MT8111",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "152": {
            "name": "Intel Atom Z2760",
            "type": "x86",
            "cores": "2/4",
            "clock_rate": 1800,
            "gpu_id": 68
        },
        "153": {
            "name": "Intel Core i5-3317U",
            "type": "x86",
            "cores": "2/4",
            "clock_rate": 1700,
            "gpu_id": 69
        },
        "154": {
            "name": "MediaTek MT6732",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 37
        },
        "155": {
            "name": "Intel Atom Z3735G",
            "type": "x86",
            "cores": 4,
            "clock_rate": 1830,
            "gpu_id": 70
        },
        "156": {
            "name": "Intel Atom Z3740",
            "type": "x86",
            "cores": 4,
            "clock_rate": 1860,
            "gpu_id": 70
        },
        "157": {
            "name": "Qualcomm Snapdragon 808 MSM8992",
            "type": "ARM",
            "cores": 6,
            "clock_rate": 2000,
            "process": "20nm",
            "gpu_id": 71
        },
        "158": {
            "name": "Qualcomm Snapdragon S2 MSM7230",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 800,
            "gpu_id": 29
        },
        "159": {
            "name": "MediaTek MT6732M",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "gpu_id": 37
        },
        "160": {
            "name": "Intel Atom x7 Z8700",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2400,
            "gpu_id": 72
        },
        "161": {
            "name": "NVIDIA Tegra 3 T30L",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500
        },
        "162": {
            "name": "MediaTek MT6750T",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 26
        },
        "163": {
            "name": "MediaTek MT8321",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "164": {
            "name": "MediaTek Helio P22",
            "code": "MT6762D",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 25
        },
        "165": {
            "name": "Spreadtrum SC7731E",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "166": {
            "name": "MediaTek Helio P23",
            "code": "MT6763T",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2500,
            "process": "16nm",
            "gpu_id": 40
        },
        "167": {
            "name": "MediaTek MT6516",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 416,
            "process": "65nm"
        },
        "168": {
            "name": "MediaTek MT8765A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 2
        },
        "169": {
            "name": "MediaTek Helio P23 MT6763V",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "gpu_id": 40
        },
        "170": {
            "name": "MediaTek MT6738",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 26
        },
        "171": {
            "name": "MediaTek Helio P22",
            "code": "MT6762",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 25
        },
        "172": {
            "name": "Qualcomm Snapdragon 429 SDM429",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "gpu_id": 73
        },
        "173": {
            "name": "Qualcomm Snapdragon 820",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2200,
            "process": "14nm",
            "gpu_id": 74
        },
        "174": {
            "name": "MediaTek Helio P20 MT6757",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "16nm",
            "gpu_id": 75
        },
        "175": {
            "name": "MediaTek MT8766B",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "gpu_id": 76
        },
        "176": {
            "name": "MediaTek MT8165A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 37
        },
        "177": {
            "name": "Rockchip RK2918",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1000,
            "gpu_id": 77
        },
        "178": {
            "name": "MediaTek MT6235",
            "type": "",
            "cores": 1,
            "clock_rate": 208
        },
        "179": {
            "name": "MediaTek MT8392",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "gpu_id": 3
        },
        "180": {
            "name": "MediaTek MT6577",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "gpu_id": 48
        },
        "181": {
            "name": "Apple A5X",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "gpu_id": 78
        },
        "182": {
            "name": "MediaTek MT6591",
            "type": "ARM",
            "cores": 6,
            "clock_rate": 1500,
            "gpu_id": 0
        },
        "183": {
            "name": "MediaTek MT6573",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 650,
            "gpu_id": 48
        },
        "184": {
            "name": "MediaTek MT8127",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "gpu_id": 3
        },
        "185": {
            "name": "Rockchip RK2928",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 1,
            "gpu_id": 62
        },
        "186": {
            "name": "Qualcomm QSC6155",
            "type": "",
            "clock_rate": 480,
            "cores": 1
        },
        "187": {
            "name": "MediaTek MT8312",
            "type": "ARM",
            "clock_rate": 1300,
            "cores": 2,
            "gpu_id": 62
        },
        "188": {
            "name": "MediaTek MT6268",
            "type": "",
            "clock_rate": "",
            "cores": 1
        },
        "189": {
            "name": "Intel Atom x5 Z8350",
            "type": "x86",
            "clock_rate": 1960,
            "cores": 4,
            "process": "14nm",
            "gpu_id": 72
        },
        "190": {
            "name": "Texas Instruments OMAP 4430",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 1
        },
        "191": {
            "name": "Apple A5 S5L8940X",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 1,
            "gpu_id": 79
        },
        "192": {
            "name": "Apple S6",
            "type": "ARM",
            "clock_rate": 0,
            "cores": 0,
            "gpu_id": 0
        },
        "193": {
            "name": "Apple S5",
            "type": "ARM",
            "clock_rate": 0,
            "cores": 0,
            "gpu_id": 0
        },
        "194": {
            "name": "MediaTek Helio X20 MT6797M",
            "type": "ARM",
            "clock_rate": 2100,
            "cores": 10,
            "process": "20nm",
            "gpu_id": 80
        },
        "195": {
            "name": "AllWinner A13",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 1,
            "gpu_id": 62
        },
        "196": {
            "name": "Qualcomm Snapdragon 653 MSM8976 Pro",
            "type": "ARM",
            "clock_rate": 1950,
            "cores": 8,
            "process": "28nm",
            "gpu_id": 57
        },
        "197": {
            "name": "Qualcomm Snapdragon 855 Plus",
            "type": "ARM",
            "clock_rate": 2960,
            "cores": 8,
            "process": "7nm",
            "gpu_id": 81
        },
        "198": {
            "name": "Qualcomm Snapdragon 845",
            "type": "ARM",
            "clock_rate": 2800,
            "cores": 8,
            "process": "10nm",
            "gpu_id": 82
        },
        "199": {
            "name": "Unisoc Tiger T618",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "gpu_id": 83
        },
        "200": {
            "name": "Qualcomm MSM8225Q",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 4,
            "gpu_id": 56
        },
        "201": {
            "name": "Action ATM7029",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 4,
            "gpu_id": 84
        },
        "202": {
            "name": "Qualcomm Snapdragon S3 MSM8260",
            "type": "ARM",
            "clock_rate": 1500,
            "cores": 2,
            "process": "45nm",
            "gpu_id": 85
        },
        "203": {
            "name": "Intel Core M3-6Y30",
            "type": "x86",
            "clock_rate": 2200,
            "cores": "2/4",
            "gpu_id": 86
        },
        "204": {
            "name": "Qualcomm Snapdragon 625 MSM8953",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 41
        },
        "205": {
            "name": "Qualcomm Snapdragon 636",
            "type": "ARM",
            "clock_rate": 1800,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 87
        },
        "206": {
            "name": "Intel Atom Z2520",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": "2/4",
            "gpu_id": 88
        },
        "207": {
            "name": "Qualcomm Snapdragon 865",
            "type": "ARM",
            "clock_rate": 2840,
            "cores": 8,
            "process": "7nm",
            "gpu_id": 67
        },
        "208": {
            "name": "Qualcomm Snapdragon 821 MSM8996 Pro",
            "type": "ARM",
            "clock_rate": 2400,
            "cores": 4,
            "process": "14nm",
            "gpu_id": 74
        },
        "209": {
            "name": "Intel Atom Z3590",
            "type": "ARM",
            "clock_rate": 2500,
            "cores": 4,
            "gpu_id": 13
        },
        "210": {
            "name": "MediaTek MT6572\u0410",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 2,
            "gpu_id": 62
        },
        "211": {
            "name": "Intel Atom x3 C3230",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 3
        },
        "212": {
            "name": "Qualcomm Snapdragon S4 Plus MSM8230",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 2,
            "gpu_id": 12
        },
        "213": {
            "name": "HiSilicon Kirin 710A",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "gpu_id": 20
        },
        "214": {
            "name": "Qualcomm Snapdragon 450",
            "type": "ARM",
            "clock_rate": 1800,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 41
        },
        "215": {
            "name": "Spreadtrum SC9830",
            "type": "ARM",
            "clock_rate": 1500,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 1
        },
        "216": {
            "name": "HiSilicon Kirin 950",
            "type": "ARM",
            "clock_rate": 2300,
            "cores": 8,
            "gpu_id": 80
        },
        "217": {
            "name": "Qualcomm Snapdragon S1 MSM7625",
            "type": "ARM",
            "clock_rate": 600,
            "cores": 1,
            "gpu_id": 22
        },
        "218": {
            "name": "Qualcomm Snapdragon S1 MSM7627A",
            "type": "ARM",
            "clock_rate": 600,
            "cores": 1,
            "gpu_id": 22
        },
        "219": {
            "name": "Qualcomm Snapdragon S4 Play",
            "code": "MSM8225",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 2,
            "process": "45nm",
            "gpu_id": 56
        },
        "220": {
            "name": "Qualcomm Snapdragon S4 Play MSM8625Q",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 2,
            "process": "45nm",
            "gpu_id": 56
        },
        "221": {
            "name": "HiSilicon Kirin 960",
            "type": "ARM",
            "clock_rate": 2400,
            "cores": 8,
            "process": "16nm",
            "gpu_id": 89
        },
        "222": {
            "name": "HiSilicon Kirin 960s",
            "type": "ARM",
            "clock_rate": 2100,
            "cores": 8,
            "process": "16nm",
            "gpu_id": 89
        },
        "223": {
            "name": "HiSilicon Kirin 935",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "gpu_id": 21
        },
        "224": {
            "name": "Qualcomm Snapdragon 450",
            "type": "ARM",
            "clock_rate": 1800,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 41
        },
        "225": {
            "name": "HiSilicon Kirin 955",
            "type": "ARM",
            "clock_rate": 2500,
            "cores": 8,
            "process": "16nm",
            "gpu_id": 80
        },
        "226": {
            "name": "MediaTek Helio G80",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "12nm",
            "gpu_id": 83
        },
        "227": {
            "name": "HiSilicon Kirin 930",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "28nm",
            "gpu_id": 21
        },
        "228": {
            "name": "Hisilicon Hi3798MV200",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 4,
            "gpu_id": 3
        },
        "229": {
            "name": "Qualcomm Snapdragon 215",
            "type": "ARM",
            "clock_rate": 1300,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 17
        },
        "230": {
            "name": "MediaTek MT8765B",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 2
        },
        "231": {
            "name": "MediaTek MT8765",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1280,
            "process": "28nm",
            "gpu_id": 2
        },
        "232": {
            "name": "MediaTek Helio P25",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "16nm",
            "gpu_id": 75
        },
        "233": {
            "name": "Samsung Exynos 4412 Quad",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1400,
            "process": "32nm",
            "gpu_id": 44
        },
        "234": {
            "name": "Qualcomm Snapdragon 855",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2840,
            "process": "7nm",
            "gpu_id": 81
        },
        "235": {
            "name": "Broadcom BCM28155",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200
        },
        "236": {
            "name": "Broadcom BCM23550",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1200
        },
        "237": {
            "name": "Samsung Exynos 7904",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "14nm",
            "gpu_id": 40
        },
        "238": {
            "name": "Spreadtrum SC7730",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "gpu_id": 1
        },
        "239": {
            "name": "Samsung Exynos 4415",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "gpu_id": 1
        },
        "240": {
            "name": "Samsung Exynos 4210",
            "type": "ARM",
            "cores": 1,
            "clock_rate": 1400,
            "gpu_id": 62
        },
        "241": {
            "name": "Samsung Exynos 9810",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2900,
            "process": "10nm",
            "gpu_id": 90
        },
        "242": {
            "name": "Qualcomm Snapdragon 765G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "7nm",
            "gpu_id": 91
        },
        "243": {
            "name": "Qualcomm Snapdragon 801 MSM8974AC",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2450,
            "process": "28nm",
            "gpu_id": 65
        },
        "244": {
            "name": "Qualcomm Snapdragon 460",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "11nm",
            "gpu_id": 92
        },
        "245": {
            "name": "AllWinner A10",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 1,
            "gpu_id": 62
        },
        "246": {
            "name": "MediaTek MT6515",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 1,
            "gpu_id": 48
        },
        "247": {
            "name": "MediaTek MT6737W",
            "type": "ARM",
            "clock_rate": 1300,
            "cores": 4,
            "gpu_id": 2
        },
        "248": {
            "name": "Samsung Exynos 7884",
            "type": "ARM",
            "clock_rate": 1560,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 40
        },
        "249": {
            "name": "Samsung Exynos 990",
            "type": "ARM",
            "clock_rate": 2730,
            "cores": 8,
            "process": "7nm",
            "gpu_id": 93
        },
        "250": {
            "name": "Samsung Exynos 850",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 53
        },
        "251": {
            "name": "Samsung Exynos 7578",
            "type": "ARM",
            "clock_rate": 1500,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 5
        },
        "252": {
            "name": "Samsung Exynos 7870 Octa",
            "type": "ARM",
            "clock_rate": 1600,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 27
        },
        "253": {
            "name": "MediaTek Helio P65 MT6768",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "12nm",
            "gpu_id": 83
        },
        "254": {
            "name": "Samsung Exynos 7580 Octa",
            "type": "ARM",
            "clock_rate": 1600,
            "cores": 8,
            "process": "28nm",
            "gpu_id": 5
        },
        "255": {
            "name": "Samsung Exynos 7880",
            "type": "ARM",
            "clock_rate": 1900,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 94
        },
        "256": {
            "name": "Samsung Exynos 9610",
            "type": "ARM",
            "clock_rate": 2300,
            "cores": 8,
            "process": "10nm",
            "gpu_id": 51
        },
        "257": {
            "name": "Samsung Exynos 9611",
            "type": "ARM",
            "clock_rate": 2300,
            "cores": 8,
            "process": "10nm",
            "gpu_id": 51
        },
        "258": {
            "name": "Qualcomm Snapdragon 675",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "11nm",
            "gpu_id": 95
        },
        "259": {
            "name": "Samsung Exynos 7885",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 95
        },
        "260": {
            "name": "Qualcomm Snapdragon 730G",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 96
        },
        "261": {
            "name": "Qualcomm Snapdragon 730",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 96
        },
        "262": {
            "name": "Samsung Exynos 980",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 97
        },
        "263": {
            "name": "Samsung Exynos 5430",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "20nm",
            "gpu_id": 43
        },
        "264": {
            "name": "Samsung Exynos 7420",
            "type": "ARM",
            "clock_rate": 2100,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 98
        },
        "265": {
            "name": "Broadcom BCM21553",
            "type": "ARM",
            "clock_rate": 832,
            "cores": 1,
            "process": "65nm"
        },
        "266": {
            "name": "ST-Ericsson NovaThor U8500",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 2,
            "process": "45nm",
            "gpu_id": 62
        },
        "267": {
            "name": "Samsung Exynos 2100 5G",
            "type": "ARM",
            "clock_rate": 2900,
            "cores": 8,
            "process": "5nm",
            "gpu_id": 99
        },
        "268": {
            "name": "Qualcomm Snapdragon 653 MSM8976 Pro",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "28nm",
            "gpu_id": 57
        },
        "269": {
            "name": "Samsung Exynos 9820",
            "type": "ARM",
            "clock_rate": 2700,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 42
        },
        "270": {
            "name": "Samsung Exynos 8890",
            "type": "ARM",
            "clock_rate": 2600,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 100
        },
        "271": {
            "name": "Samsung Exynos 8895",
            "type": "ARM",
            "clock_rate": 2300,
            "cores": 8,
            "process": "10nm",
            "gpu_id": 101
        },
        "272": {
            "name": "Qualcomm Snapdragon 626 MSM8953 Pro",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "14nm",
            "gpu_id": 41
        },
        "273": {
            "name": "Qualcomm Snapdragon 720G",
            "type": "ARM",
            "clock_rate": 2300,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 96
        },
        "274": {
            "name": "MediaTek Dimensity 720",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "7nm",
            "gpu_id": 102
        },
        "275": {
            "name": "Qualcomm Snapdragon 750 5G",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "8nm",
            "gpu_id": 103
        },
        "276": {
            "name": "Qualcomm Snapdragon 805 APQ8084",
            "type": "ARM",
            "clock_rate": 2700,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 104
        },
        "277": {
            "name": "Spreadtrum SC7715",
            "type": "ARM",
            "clock_rate": 1200,
            "cores": 1,
            "process": "40nm",
            "gpu_id": 62
        },
        "278": {
            "name": "Samsung Exynos 3475",
            "type": "ARM",
            "clock_rate": 1300,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 2
        },
        "279": {
            "name": "Samsung Exynos 7570",
            "type": "ARM",
            "clock_rate": 1400,
            "cores": 4,
            "process": "14nm",
            "gpu_id": 5
        },
        "280": {
            "name": "Spreadtrum SC6815A",
            "type": "ARM",
            "clock_rate": 1000,
            "cores": 1,
            "process": "40nm",
            "gpu_id": 62
        },
        "281": {
            "name": "Qualcomm Snapdragon 427",
            "type": "ARM",
            "clock_rate": 1400,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 17
        },
        "282": {
            "name": "Qualcomm Snapdragon 435",
            "type": "ARM",
            "clock_rate": 1400,
            "cores": 8,
            "process": "28nm",
            "gpu_id": 24
        },
        "283": {
            "name": "Qualcomm Snapdragon 665",
            "type": "ARM",
            "clock_rate": 2200,
            "cores": 8,
            "process": "11nm",
            "gpu_id": 92
        },
        "284": {
            "name": "MediaTek Helio G25",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "12nm",
            "gpu_id": 25
        },
        "285": {
            "name": "Qualcomm Snapdragon 662",
            "type": "ARM",
            "clock_rate": 2000,
            "cores": 8,
            "process": "11nm",
            "gpu_id": 92
        },
        "286": {
            "name": "Qualcomm Snapdragon S2 MSM8255",
            "type": "ARM",
            "clock_rate": 1500,
            "cores": 1,
            "process": "45nm",
            "gpu_id": 29
        },
        "287": {
            "name": "Spreadtrum SC7731G",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "288": {
            "name": "MediaTek MT6571",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 0
        },
        "289": {
            "name": "Qualcomm Snapdragon 712",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "10nm",
            "gpu_id": 39
        },
        "290": {
            "name": "MediaTek Helio P60",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 51
        },
        "291": {
            "name": "MediaTek Helio X20 MT6797",
            "type": "ARM",
            "cores": 10,
            "clock_rate": 2300,
            "process": "20nm",
            "gpu_id": 80
        },
        "292": {
            "name": "MediaTek Helio P20 MT6757",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "16nm",
            "gpu_id": 75
        },
        "293": {
            "name": "MediaTek MT6739WA",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 4
        },
        "294": {
            "name": "Qualcomm Snapdragon 400 MSM8928",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1600,
            "process": "28nm",
            "gpu_id": 12
        },
        "295": {
            "name": "Qualcomm Snapdragon S4 Plus MSM8227",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "process": "28nm",
            "gpu_id": 12
        },
        "296": {
            "name": "MediaTek Dimensity 1000+",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "7nm",
            "gpu_id": 105
        },
        "297": {
            "name": "MediaTek Dimensity 820 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "7nm",
            "gpu_id": 106
        },
        "298": {
            "name": "Qualcomm Snapdragon 670",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2016,
            "process": "10nm",
            "gpu_id": 39
        },
        "299": {
            "name": "Samsung Exynos 880",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "8nm",
            "gpu_id": 97
        },
        "300": {
            "name": "MediaTek Dimensity 800U",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "7nm",
            "gpu_id": 102
        },
        "301": {
            "name": "Samsung Exynos 1080",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2800,
            "process": "5nm",
            "gpu_id": 107
        },
        "302": {
            "name": "MediaTek Dimensity 700",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "7nm",
            "gpu_id": 108
        },
        "303": {
            "name": "Qualcomm Snapdragon 768G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2800,
            "process": "7nm",
            "gpu_id": 91
        },
        "304": {
            "name": "Qualcomm Snapdragon 870 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3200,
            "process": "7nm",
            "gpu_id": 67
        },
        "305": {
            "name": "Qualcomm Snapdragon 888 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2840,
            "process": "5nm",
            "gpu_id": 109
        },
        "306": {
            "name": "MediaTek Dimensity 1100",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "6nm",
            "gpu_id": 110
        },
        "307": {
            "name": "Qualcomm Snapdragon 480 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "8nm",
            "gpu_id": 103
        },
        "308": {
            "name": "MediaTek MT6735A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "cpu_id": 2
        },
        "309": {
            "name": "MediaTek Helio P25 MT6757CH",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "16nm",
            "gpu_id": 75
        },
        "310": {
            "name": "MediaTek MT6735M",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1000,
            "process": "28nm",
            "gpu_id": 2
        },
        "311": {
            "name": "Intel Atom x3-C3130",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "process": "28nm",
            "gpu_id": 1
        },
        "312": {
            "name": "MediaTek MT6750S",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 26
        },
        "313": {
            "name": "MediaTek MT6592M",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1400,
            "process": "28nm",
            "gpu_id": 3
        },
        "314": {
            "name": "Amlogic S905W",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "process": "28nm",
            "gpu_id": 111
        },
        "315": {
            "name": "Intel Atom x5 Z8300",
            "type": "x86",
            "cores": 4,
            "clock_rate": 1840,
            "process": "14nm",
            "gpu_id": 72
        },
        "316": {
            "name": "Allwinner A31S",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 0,
            "process": "40nm",
            "gpu_id": 61
        },
        "317": {
            "name": "Allwinner A20",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "process": "40nm"
        },
        "318": {
            "name": "Unisoc T610",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "12nm",
            "gpu_id": 83
        },
        "319": {
            "name": "MediaTek Helio G70",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 83
        },
        "320": {
            "name": "MediaTek Dimensity 800U",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "7nm",
            "gpu_id": 102
        },
        "321": {
            "name": "MediaTek Helio G95",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2050,
            "process": "12nm",
            "gpu_id": 112
        },
        "322": {
            "name": "MediaTek Helio G85",
            "code": "MT6769Z",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 83
        },
        "323": {
            "name": "MediaTek Helio G35",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "12nm",
            "gpu_id": 25
        },
        "324": {
            "name": "MediaTek Dimensity 1200 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3000,
            "process": "6nm",
            "gpu_id": 110
        },
        "325": {
            "name": "MediaTek Helio G90T",
            "code": "MT6785V/CC",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2050,
            "process": "12nm",
            "gpu_id": 112
        },
        "326": {
            "name": "MediaTek Dimensity 1100 5G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "6nm",
            "gpu_id": 110
        },
        "327": {
            "name": "HiSilicon Kirin 990",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2860,
            "process": "7nm",
            "gpu_id": 34
        },
        "328": {
            "name": "Qualcomm Snapdragon 650",
            "code": "MSM8956",
            "type": "ARM",
            "cores": 6,
            "clock_rate": 1800,
            "process": "28nm",
            "gpu_id": 57
        },
        "329": {
            "name": "Intel Atom x3 C3200",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "28nm",
            "gpu_id": 3
        },
        "330": {
            "name": "Spreadtrum SC7731C",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "331": {
            "name": "Rockchip RK3128",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1200,
            "process": "40nm",
            "gpu_id": 1
        },
        "332": {
            "name": "MediaTek MT6752",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1700,
            "process": "28nm",
            "gpu_id": 37
        },
        "333": {
            "name": "Amlogic S905",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "process": "28nm",
            "gpu_id": 111
        },
        "334": {
            "name": "MediaTek Helio G80",
            "code": "MT6769V/CU",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 113
        },
        "335": {
            "name": "Spreadtrum SC9830A",
            "type": "ARM",
            "clock_rate": 1500,
            "cores": 4,
            "process": "28nm",
            "gpu_id": 1
        },
        "336": {
            "name": "MediaTek MT6580W",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "337": {
            "name": "MediaTek Helio A20",
            "code": "MT6761D",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1800,
            "process": "12nm",
            "gpu_id": 76
        },
        "338": {
            "name": "MediaTek MT6580P",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "339": {
            "name": "MediaTek MT8753P",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1000,
            "process": "28nm",
            "gpu_id": 2
        },
        "340": {
            "name": "MediaTek Helio \u041025",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "12nm",
            "gpu_id": 25
        },
        "341": {
            "name": "Spreadtrum SC7721E",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "342": {
            "name": "MediaTek Helio P35",
            "code": "MT6765V",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "12nm",
            "gpu_id": 25
        },
        "343": {
            "name": "MediaTek Helio P25",
            "code": "MT6757CD",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "16nm",
            "gpu_id": 75
        },
        "344": {
            "name": "MediaTek Dimensity 800",
            "code": "MT6873V",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "7nm",
            "gpu_id": 28
        },
        "345": {
            "name": "MediaTek Helio P95",
            "code": "MT6779V",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "12nm",
            "gpu_id": 114
        },
        "346": {
            "name": "MediaTek Helio P90",
            "code": "MT6779",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "12nm",
            "gpu_id": 114
        },
        "347": {
            "name": "MediaTek Dimensity 1000L",
            "code": "MT6885Z",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "12nm",
            "gpu_id": 110
        },
        "348": {
            "name": "MediaTek Helio G35",
            "code": "MT6765G",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "12nm",
            "gpu_id": 25
        },
        "349": {
            "name": "MediaTek Helio G88",
            "code": "MT6769H",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 113
        },
        "350": {
            "name": "MediaTek Helio G96",
            "code": "MT6781",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2050,
            "process": "12nm",
            "gpu_id": 115
        },
        "351": {
            "name": "Allwinner A31",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 533,
            "process": "40nm",
            "gpu_id": 7
        },
        "352": {
            "name": "Amlogic AML8726-M6",
            "code": "AML8726-MX",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1500,
            "process": "40nm",
            "gpu_id": 1
        },
        "353": {
            "name": "MediaTek Helio P25",
            "code": "MT6757T",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "16nm",
            "gpu_id": 75
        },
        "354": {
            "name": "Unisoc Tiger T606",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1600,
            "process": "12nm",
            "gpu_id": 116
        },
        "355": {
            "name": "MediaTek Helio A25",
            "code": "MT6762V/WD",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "12nm",
            "gpu_id": 25
        },
        "356": {
            "name": "MediaTek Dimensity 810",
            "code": "MT6833P",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "6nm",
            "gpu_id": 108
        },
        "357": {
            "name": "Qualcomm Snapdragon 8 Gen 1",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3000,
            "process": "4nm",
            "gpu_id": 117
        },
        "358": {
            "name": "Qualcomm Snapdragon 695 5G",
            "code": "SM6375",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "6nm",
            "gpu_id": 103
        },
        "359": {
            "name": "Qualcomm Snapdragon 778G 5G",
            "code": "SM7325",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "6nm",
            "gpu_id": 118
        },
        "360": {
            "name": "Spreadtrum SC9830A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1500,
            "process": "28nm",
            "gpu_id": 1
        },
        "361": {
            "name": "Spreadtrum SC9832A",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "362": {
            "name": "MediaTek Dimensity 9000",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3500,
            "process": "4nm",
            "gpu_id": 119
        },
        "363": {
            "name": "Qualcomm Snapdragon 680 4G",
            "code": "SM6225",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "6nm",
            "gpu_id": 92
        },
        "364": {
            "name": "Qualcomm Snapdragon 732G",
            "code": "SM7150-AC",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "8nm",
            "gpu_id": 96
        },
        "365": {
            "name": "Dimensity 810",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "6nm",
            "gpu_id": 115
        },
        "366": {
            "name": "Unisoc Tiger T612",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "12nm",
            "gpu_id": 116
        },
        "367": {
            "name": "MediaTek Helio G36",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "12nm",
            "gpu_id": 25
        },
        "368": {
            "name": "MediaTek Dimensity 7050",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "6nm",
            "gpu_id": 121
        },
        "369": {
            "name": "MediaTek Dimensity 1300",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3000,
            "process": "6nm",
            "gpu_id": 110
        },
        "370": {
            "name": "Qualcomm Snapdragon 7 Gen 1",
            "code": "SM7450-AB",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "4nm",
            "gpu_id": 122
        },
        "371": {
            "name": "MediaTek Dimensity 8100 Max",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "5nm",
            "gpu_id": 123
        },
        "372": {
            "name": "MediaTek Dimensity 810",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2400,
            "process": "6nm",
            "gpu_id": 115
        },
        "373": {
            "name": "Qualcomm Snapdragon 8+ Gen 1",
            "code": "SM8475",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3000,
            "process": "4nm",
            "gpu_id": 117
        },
        "374": {
            "name": "Unisoc Tiger T310",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 76
        },
        "375": {
            "name": "MediaTek Dimensity 9300",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3250,
            "process": "4nm",
            "gpu_id": 124
        },
        "376": {
            "name": "MediaTek Dimensity 9200",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3050,
            "process": "4nm",
            "gpu_id": 125
        },
        "377": {
            "name": "Qualcomm Snapdragon 8 Gen 2",
            "code": "SM8550-AB",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3200,
            "process": "4nm",
            "gpu_id": 126
        },
        "378": {
            "name": "Qualcomm Snapdragon 8 Gen 3",
            "code": "SM8650-AB",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 3300,
            "process": "4nm",
            "gpu_id": 127
        },
        "379": {
            "name": "Samsung Exynos 1580",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2900,
            "process": "4nm",
            "gpu_id": 128
        },
        "380": {
            "name": "MediaTek Dimensity 6100+",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "6nm",
            "gpu_id": 108
        },
        "381": {
            "name": "MediaTek Helio G100",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "6nm",
            "gpu_id": 108
        },
        "382": {
            "name": "MediaTek Helio G81",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 153
        },
        "383": {
            "name": "Allwinner A733",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 154
        },
        "384": {
            "name": "Unisoc T620",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "12nm",
            "gpu_id": 116
        },
        "385": {
            "name": "Unisoc T606",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1600,
            "process": "12nm",
            "gpu_id": 116
        },
        "386": {
            "name": "MediaTek Dimensity 7300",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2500,
            "process": "4nm",
            "gpu_id": 141
        },
        "387": {
            "name": "Unisoc T820",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2100,
            "process": "6nm",
            "gpu_id": 155
        },
        "388": {
            "name": "Unisoc Tiger T616",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 116
        },
        "389": {
            "name": "MediaTek Helio G99",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2200,
            "process": "6nm",
            "gpu_id": 108
        },
        "390": {
            "name": "MediaTek Dimensity 8020",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2600,
            "process": "6nm",
            "gpu_id": 105
        },
        "391": {
            "name": "Rockchip RK3562",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 2000,
            "gpu_id": 156
        },
        "392": {
            "name": "MediaTek MT8788V",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 51
        },
        "393": {
            "name": "MediaTek MTK8768",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2000,
            "process": "12nm",
            "gpu_id": 25
        },
        "394": {
            "name": "MediaTek Helio G37",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2300,
            "process": "12nm",
            "gpu_id": 25
        },
        "395": {
            "name": "Spreadtrum SC9830I",
            "type": "ARM"
        },
        "396": {
            "name": "Allwinner A50",
            "type": "ARM"
        },
        "397": {
            "name": "Rockchip RK3328",
            "type": "ARM"
        },
        "398": {
            "name": "Marvell PXA1928",
            "type": "ARM"
        },
        "399": {
            "name": "Marvell BG4-CT",
            "type": "ARM"
        },
        "400": {
            "name": "Marvell PX986",
            "type": "ARM"
        },
        "401": {
            "name": "MediaTek MT6580WP",
            "type": "ARM",
            "cores": 4,
            "clock_rate": 1300,
            "process": "28nm",
            "gpu_id": 1
        },
        "402": {
            "name": "MediaTek MT6577T",
            "type": "ARM",
            "cores": 2,
            "clock_rate": 1000,
            "process": "40nm",
            "gpu_id": 48
        },
        "403": {
            "name": "MediaTek MT8768CA",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 1800,
            "process": "12nm",
            "gpu_id": 25
        },
        "404": {
            "name": "Qualcomm Snapdragon 850",
            "code": "SDM850",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 2900,
            "process": "10nm",
            "gpu_id": 82
        },
        "405": {
            "name": "MediaTek MT6739",
            "type": "ARM",
            "cores": 8,
            "clock_rate": 0,
            "process": "28nm",
            "gpu_id": 0
        },
        "406": {
            "name": "Mediatek MT8382",
            "type": "ARM",
            "cores": 0,
            "clock_rate": 0,
            "process": "28nm",
            "gpu_id": 0
        }
    }
};


var $0fe9c5884b487c40$exports = {};
$0fe9c5884b487c40$exports = {
    "gpu": {
        "1": {
            "name": "ARM Mali-400 MP2",
            "clock_rate": 500
        },
        "2": {
            "name": "ARM Mali-T720 MP",
            "clock_rate": 650
        },
        "3": {
            "name": "ARM Mali-450 MP4",
            "clock_rate": 700
        },
        "4": {
            "name": "PowerVR GE8100",
            "clock_rate": 570
        },
        "5": {
            "name": "ARM Mali-T720 MP2",
            "clock_rate": 650
        },
        "6": {
            "name": "Qualcomm Adreno 304",
            "clock_rate": 400
        },
        "7": {
            "name": "PowerVR SGX544",
            "clock_rate": 384
        },
        "8": {
            "name": "PowerVR SGX540",
            "clock_rate": 200
        },
        "9": {
            "name": "Qualcomm Adreno 225",
            "clock_rate": 400
        },
        "10": {
            "name": "Qualcomm Adreno 320",
            "clock_rate": 400
        },
        "11": {
            "name": "Qualcomm Adreno 330",
            "clock_rate": 450
        },
        "12": {
            "name": "Qualcomm Adreno 305",
            "clock_rate": 450
        },
        "13": {
            "name": "PowerVR G6430",
            "clock_rate": 457
        },
        "14": {
            "name": "Qualcomm Adreno 306",
            "clock_rate": 450
        },
        "15": {
            "name": "PowerVR SGX544MP2",
            "clock_rate": 400
        },
        "16": {
            "name": "Qualcomm Adreno 508",
            "clock_rate": 650
        },
        "17": {
            "name": "Qualcomm Adreno 308",
            "clock_rate": 450
        },
        "18": {
            "name": "Qualcomm Adreno 405",
            "clock_rate": 550
        },
        "19": {
            "name": "Qualcomm Adreno 540",
            "clock_rate": 710
        },
        "20": {
            "name": "ARM Mali-G51 MP4",
            "clock_rate": 650
        },
        "21": {
            "name": "ARM Mali-T628 MP4",
            "clock_rate": 600
        },
        "22": {
            "name": "Qualcomm Adreno 200",
            "clock_rate": 128
        },
        "23": {
            "name": "Qualcomm Adreno 302",
            "clock_rate": 400
        },
        "24": {
            "name": "Qualcomm Adreno 505",
            "clock_rate": 450
        },
        "25": {
            "name": "PowerVR GE8320",
            "clock_rate": 650
        },
        "26": {
            "name": "ARM Mali-T860 MP2",
            "clock_rate": 650
        },
        "27": {
            "name": "ARM Mali-T830 MP2",
            "clock_rate": 600
        },
        "28": {
            "name": "ARM Mali-G57 MP5",
            "clock_rate": 850
        },
        "29": {
            "name": "Qualcomm Adreno 205",
            "clock_rate": 245
        },
        "30": {
            "name": "ARM Mali-G72 MP12",
            "clock_rate": 850
        },
        "31": {
            "name": "Vivante GC4000",
            "clock_rate": 480
        },
        "32": {
            "name": "ARM Mali-G76 MP10",
            "clock_rate": 720
        },
        "33": {
            "name": "ARM Mali-G77 MP8",
            "clock_rate": 800
        },
        "34": {
            "name": "ARM Mali-G76 MP16",
            "clock_rate": 700
        },
        "35": {
            "name": "ARM Mali-G57 MP6",
            "clock_rate": 700
        },
        "36": {
            "name": "ARM Mali-G52 MP6",
            "clock_rate": 700
        },
        "37": {
            "name": "ARM Mali-T760 MP2",
            "clock_rate": 700
        },
        "38": {
            "name": "Qualcomm Adreno 512",
            "clock_rate": 850
        },
        "39": {
            "name": "Qualcomm Adreno 616",
            "clock_rate": 850
        },
        "40": {
            "name": "ARM Mali-G71 MP2",
            "clock_rate": 770
        },
        "41": {
            "name": "Qualcomm Adreno 506",
            "clock_rate": 650
        },
        "42": {
            "name": "ARM Mali-G76 MP12",
            "clock_rate": 700
        },
        "43": {
            "name": "ARM Mali-T628 MP6",
            "clock_rate": 600
        },
        "44": {
            "name": "ARM Mali-400 MP4",
            "clock_rate": 250
        },
        "45": {
            "name": "ARM Mali-T760 MP4",
            "clock_rate": 600
        },
        "46": {
            "name": "ARM Mali-T820 MP1",
            "clock_rate": 600
        },
        "47": {
            "name": "PowerVR G6200",
            "clock_rate": 700
        },
        "48": {
            "name": "PowerVR SGX531",
            "clock_rate": 200
        },
        "49": {
            "name": "AMD Radeon R5",
            "clock_rate": 850
        },
        "50": {
            "name": "Qualcomm Adreno 430",
            "clock_rate": 650
        },
        "51": {
            "name": "ARM Mali-G72 MP3",
            "clock_rate": 850
        },
        "52": {
            "name": "PowerVR GX6250",
            "clock_rate": 700
        },
        "53": {
            "name": "ARM Mali-G52 MP1",
            "clock_rate": 800
        },
        "54": {
            "name": "PowerVR GX6650",
            "clock_rate": 450
        },
        "55": {
            "name": "PowerVR GE8322",
            "clock_rate": null
        },
        "56": {
            "name": "Qualcomm Adreno 203",
            "clock_rate": 245
        },
        "57": {
            "name": "Qualcomm Adreno 510",
            "clock_rate": 680
        },
        "58": {
            "name": "ARM Mali-T860 MP4",
            "clock_rate": 700
        },
        "59": {
            "name": "ARM Mali-T720 MP4",
            "clock_rate": 600
        },
        "60": {
            "name": "PowerVR GX6450",
            "clock_rate": 450
        },
        "61": {
            "name": "PowerVR SGX544MP2",
            "clock_rate": 400
        },
        "62": {
            "name": "ARM Mali-400 MP",
            "clock_rate": 416
        },
        "63": {
            "name": "Intel HD Graphics (Bay Trail)",
            "clock_rate": 311
        },
        "64": {
            "name": "Qualcomm Adreno 320",
            "clock_rate": 400
        },
        "65": {
            "name": "Qualcomm Adreno 330",
            "clock_rate": 578
        },
        "66": {
            "name": "Qualcomm Adreno 225",
            "clock_rate": 400
        },
        "67": {
            "name": "Qualcomm Adreno 650",
            "clock_rate": 650
        },
        "68": {
            "name": "PowerVR SGX545",
            "clock_rate": 533
        },
        "69": {
            "name": "Intel HD Graphics 4000",
            "clock_rate": 1050
        },
        "70": {
            "name": "Intel HD Graphics (Bay Trail)",
            "clock_rate": 667
        },
        "71": {
            "name": "Qualcomm Adreno 418",
            "clock_rate": 600
        },
        "72": {
            "name": "Intel HD Graphics (Cherry Trail)",
            "clock_rate": 600
        },
        "73": {
            "name": "Qualcomm Adreno 504",
            "clock_rate": 450
        },
        "74": {
            "name": "Qualcomm Adreno 530",
            "clock_rate": 624
        },
        "75": {
            "name": "ARM Mali-T880 MP2",
            "clock_rate": 900
        },
        "76": {
            "name": "PowerVR GE8300",
            "clock_rate": 660
        },
        "77": {
            "name": "Vivante GC800",
            "clock_rate": 575
        },
        "78": {
            "name": "PowerVR SGX543MP4",
            "clock_rate": 0
        },
        "79": {
            "name": "PowerVR SGX543MP2",
            "clock_rate": 0
        },
        "80": {
            "name": "ARM Mali-T880 MP4",
            "clock_rate": 600
        },
        "81": {
            "name": "Qualcomm Adreno 640",
            "clock_rate": 700
        },
        "82": {
            "name": "Qualcomm Adreno 630",
            "clock_rate": 650
        },
        "83": {
            "name": "ARM Mali-G52 MC2",
            "clock_rate": 850
        },
        "84": {
            "name": "Vivante GC1000",
            "clock_rate": 600
        },
        "85": {
            "name": "Qualcomm Adreno 220",
            "clock_rate": 266
        },
        "86": {
            "name": "Intel HD Graphics 515",
            "clock_rate": 850
        },
        "87": {
            "name": "Qualcomm Adreno 509",
            "clock_rate": 0
        },
        "88": {
            "name": "PowerVR SGX544MP2",
            "clock_rate": 533
        },
        "89": {
            "name": "ARM Mali-G71 MP8",
            "clock_rate": 900
        },
        "90": {
            "name": "ARM Mali-G72 MP18",
            "clock_rate": 850
        },
        "91": {
            "name": "Qualcomm Adreno 620",
            "clock_rate": 670
        },
        "92": {
            "name": "Qualcomm Adreno 610",
            "clock_rate": 670
        },
        "93": {
            "name": "ARM Mali-G77 MP11",
            "clock_rate": 0
        },
        "94": {
            "name": "ARM Mali-T830 MP3",
            "clock_rate": 600
        },
        "95": {
            "name": "Qualcomm Adreno 612",
            "clock_rate": 0
        },
        "96": {
            "name": "Qualcomm Adreno 618",
            "clock_rate": 500
        },
        "97": {
            "name": "ARM Mali-G76 MP5",
            "clock_rate": 720
        },
        "98": {
            "name": "ARM Mali-T760 MP8",
            "clock_rate": 772
        },
        "99": {
            "name": "ARM Mali-G78 MP14",
            "clock_rate": 759
        },
        "100": {
            "name": "ARM Mali-T880 MP12",
            "clock_rate": 650
        },
        "101": {
            "name": "ARM Mali-G71 MP20",
            "clock_rate": 900
        },
        "102": {
            "name": "ARM Mali-G57 MP3",
            "clock_rate": 0
        },
        "103": {
            "name": "Qualcomm Adreno 619",
            "clock_rate": 0
        },
        "104": {
            "name": "Qualcomm Adreno 420",
            "clock_rate": 600
        },
        "105": {
            "name": "ARM Mali-G77 MP9",
            "clock_rate": 0
        },
        "106": {
            "name": "ARM Mali-G57 MC5",
            "clock_rate": 900
        },
        "107": {
            "name": "ARM Mali-G78 MP10",
            "clock_rate": 0
        },
        "108": {
            "name": "ARM Mali-G57 MP2",
            "clock_rate": 1068
        },
        "109": {
            "name": "Qualcomm Adreno 660",
            "clock_rate": 0
        },
        "110": {
            "name": "ARM Mali-G77 MC9",
            "clock_rate": 850
        },
        "111": {
            "name": "ARM Mali-450 MP",
            "clock_rate": 0
        },
        "112": {
            "name": "ARM Mali-G76 MP4",
            "clock_rate": 900
        },
        "113": {
            "name": "ARM Mali-G52 MC2",
            "clock_rate": 950
        },
        "114": {
            "name": "PowerVR GM9446",
            "clock_rate": 970
        },
        "115": {
            "name": "ARM Mali-G57 MC2",
            "clock_rate": 850
        },
        "116": {
            "name": "ARM Mali-G57 MP1",
            "clock_rate": 750
        },
        "117": {
            "name": "Qualcomm Adreno 730",
            "clock_rate": 900
        },
        "118": {
            "name": "Qualcomm Adreno 642L",
            "clock_rate": 0
        },
        "119": {
            "name": "ARM Mali-G710 MP10",
            "clock_rate": 0
        },
        "120": {
            "name": "ARM Mali-G76 MC4",
            "clock_rate": 900
        },
        "121": {
            "name": "ARM Mali-G68 MP4",
            "clock_rate": 950
        },
        "122": {
            "name": "Qualcomm Adreno 644",
            "clock_rate": 0
        },
        "123": {
            "name": "ARM Mali-G610 MC6",
            "clock_rate": 0
        },
        "124": {
            "name": "ARM Mali-G720 MP12",
            "clock_rate": 0
        },
        "125": {
            "name": "ARM Mali-G715 MP11",
            "clock_rate": 0
        },
        "126": {
            "name": "Qualcomm Adreno 740",
            "clock_rate": 0
        },
        "127": {
            "name": "Qualcomm Adreno 750",
            "clock_rate": 0
        },
        "128": {
            "name": "Xclipse 540",
            "clock_rate": 0
        },
        "129": {
            "name": "ARM Mali-G78 MP20",
            "clock_rate": 848
        },
        "130": {
            "name": "ARM Mali-G710 MP7",
            "clock_rate": 0
        },
        "131": {
            "name": "ARM Mali-G78 MP24",
            "clock_rate": 0
        },
        "132": {
            "name": "ARM Mali-G78 MP22",
            "clock_rate": 0
        },
        "133": {
            "name": "Xclipse 920",
            "clock_rate": 555
        },
        "134": {
            "name": "Xclipse 530",
            "clock_rate": 0
        },
        "135": {
            "name": "ARM Mali-G610 MP6",
            "clock_rate": 0
        },
        "136": {
            "name": "ARM Mali-G610 MP4",
            "clock_rate": 0
        },
        "137": {
            "name": "Qualcomm Adreno 810",
            "clock_rate": 0
        },
        "138": {
            "name": "Qualcomm Adreno 643",
            "clock_rate": 812
        },
        "139": {
            "name": "Qualcomm Adreno 642",
            "clock_rate": 0
        },
        "140": {
            "name": "ARM Mali-G610 MP3",
            "clock_rate": 0
        },
        "141": {
            "name": "ARM Mali-G615 MP2",
            "clock_rate": 0
        },
        "142": {
            "name": "ARM Mali-G615 MP6",
            "clock_rate": 0
        },
        "143": {
            "name": "Qualcomm Adreno 710",
            "clock_rate": 0
        },
        "144": {
            "name": "Qualcomm Adreno 720",
            "clock_rate": 0
        },
        "145": {
            "name": "Qualcomm Adreno 725",
            "clock_rate": 0
        },
        "146": {
            "name": "Qualcomm Adreno 732",
            "clock_rate": 0
        },
        "147": {
            "name": "Qualcomm Adreno 735",
            "clock_rate": 0
        },
        "148": {
            "name": "Qualcomm Adreno 690",
            "clock_rate": 0
        },
        "149": {
            "name": "Qualcomm Adreno 685",
            "clock_rate": 0
        },
        "150": {
            "name": "Qualcomm Adreno 680",
            "clock_rate": 0
        },
        "151": {
            "name": "Qualcomm Adreno 619L",
            "clock_rate": 0
        },
        "152": {
            "name": "ARM Mali-G68 MP5",
            "clock_rate": 0
        },
        "153": {
            "name": "ARM Mali-G52 MP2",
            "clock_rate": 950
        },
        "154": {
            "name": "IMG BXM-4-64",
            "clock_rate": 0
        },
        "155": {
            "name": "ARM Mali-G57 MP4",
            "clock_rate": 850
        },
        "156": {
            "name": "ARM Mali-G52 2EE",
            "clock_rate": 0
        }
    }
};


var $ea4af73011432266$exports = {};
$ea4af73011432266$exports = {
    "os": {
        "1": {
            "name": "Android"
        },
        "2": {
            "name": "iOS"
        },
        "3": {
            "name": "Windows"
        },
        "4": {
            "name": "Windows Phone"
        }
    }
};


var $8a7a1b24f0e41683$exports = {};
$8a7a1b24f0e41683$exports = {
    DS: 'display.size',
    DP: 'display.dpi',
    // DT: 'display.type',          // string: display type IPS, LCD, OLED, SLED etc.
    // TS: 'display.touch',         // boolean: touch support
    RS: 'display.resolution',
    SZ: 'size',
    WT: 'weight',
    RE: 'release',
    RM: 'hardware.ram',
    CP: 'hardware.cpu_id',
    GP: 'hardware.gpu_id',
    // UI: 'ui_id',                 // int: OS UI <id>
    OS: 'os',
    OI: 'os_id',
    OV: 'os_version',
    SM: 'sim',
    TT: 'performance.antutu',
    TG: 'performance.geekbench' // int: geekbench score
};



var $d3607477d39bdd2f$require$mergeDeep = $47a1491670bab221$exports.mergeDeep;
var $d3607477d39bdd2f$require$sortObject = $47a1491670bab221$exports.sortObject;
/*

### Get more information about a device (experimental)
> year, weight, release, display.size, display.resolution, display.ratio
```js
const InfoDevice = require('node-device-detector/parser/device/info-device');
const infoDevice = new InfoDevice();
const result = infoDevice.info('Asus', 'Zenfone 4');
console.log('Result information about device', result);
/*
result
{
  display: { size: '5.5', resolution: '1080x1920', ratio: '16:9' },
  size: '155.4x75.2x7.7',
  weight: '165',
  release: '2017'
}
is not found result null
*/ /*
```
cast methods
```js
infoDevice.setSizeConvertObject(true);
infoDevice.setResolutionConvertObject(true);
```
 */ // private methods
/**
 * Convert string 100x100 to object {width, height}
 * @param size
 * @return {{width: string, height: string}}
 */ const $d3607477d39bdd2f$var$castResolutionToObject = (size)=>{
    let [width, height] = size.split('x');
    return {
        width: width,
        height: height
    };
};
/**
 * Convert string 100x100x100 to object {width, height, thickness}
 * @param size
 * @return {{thickness: string, width: string, height: string}}
 */ const $d3607477d39bdd2f$var$castSizeToObject = (size)=>{
    let [width, height, thickness] = size.split('x');
    return {
        width: width,
        height: height,
        thickness: thickness
    };
};
/**
 *
 * @param {*} collection
 * @param {number|string} id
 * @returns {null|*}
 * @private
 */ const $d3607477d39bdd2f$var$getDataByIdInCollection = (collection, id)=>{
    let data = collection[parseInt(id)];
    if (data === void 0) return null;
    return data;
};
/**
 * port gcd function
 * @param u
 * @param v
 * @returns {*}
 */ const $d3607477d39bdd2f$var$gcd = (u, v)=>{
    if (u === v) return u;
    if (u === 0) return v;
    if (v === 0) return u;
    if (~u & 1) return v & 1 ? $d3607477d39bdd2f$var$gcd(u >> 1, v) : $d3607477d39bdd2f$var$gcd(u >> 1, v >> 1) << 1;
    if (~v & 1) return $d3607477d39bdd2f$var$gcd(u, v >> 1);
    if (u > v) return $d3607477d39bdd2f$var$gcd(u - v >> 1, v);
    return $d3607477d39bdd2f$var$gcd(v - u >> 1, u);
};

// help block
/**
 * @usage
 * let i = new InfoDevice();
 * let result = i.info('Asus', 'ZenFone 4')
 * console.log({result});
 * // result if found
 * {
 *   display: {size: "5.5", resolution: "1080x1920", ratio: "16:9", ppi: 401},
 *   size: "155.4x75.2x7.7",
 *   weight: "165",
 *   release: "2017"
 * }
 * // result in not found
 * null
 */ /**
 * Class for obtaining information on a device
 */ class $d3607477d39bdd2f$var$InfoDevice extends $7bdad46458c9f578$exports {
    constructor(){
        super();
        /** @type {boolean} convert size 75.2x155.4x7.7 to object {width, height, thickness} */ this.sizeConvertObject = false;
        /** @type {boolean} convert display.resolution 1080x1920 to object {width, height} */ this.resolutionConvertObject = false;
        /** @type {string} fixture path to file */ this.collection = (parcelRequire("hTC6h"));
    }
    /**
   * Overwrite config sizeConvertObject
   * @param {boolean} value
   */ setSizeConvertObject(value) {
        this.sizeConvertObject = !!value;
    }
    /**
   * Overwrite config resolutionConvertObject
   * @param {boolean} value
   */ setResolutionConvertObject(value) {
        this.resolutionConvertObject = !!value;
    }
    /**
   * @param id
   * @returns {null|*}
   */ getOsById(id) {
        if ($ea4af73011432266$exports.os === void 0) return null;
        return $d3607477d39bdd2f$var$getDataByIdInCollection($ea4af73011432266$exports.os, id);
    }
    getGpuIdFromName(name) {
        const lName = name.toLowerCase();
        if ($0fe9c5884b487c40$exports.gpu === void 0) return null;
        for(let id in $0fe9c5884b487c40$exports.gpu){
            let gpu = $0fe9c5884b487c40$exports.gpu[id];
            if (gpu !== void 0 && gpu.name.toLowerCase() === lName) return id;
        }
        return null;
    }
    getGpuById(id) {
        if ($0fe9c5884b487c40$exports.gpu === void 0) return null;
        return $d3607477d39bdd2f$var$getDataByIdInCollection($0fe9c5884b487c40$exports.gpu, id);
    }
    getCpuIdFromName(name) {
        const lName = name.toLowerCase();
        if ($cbaad1bf507ff5be$exports.cpu === void 0) return null;
        for(let id in $cbaad1bf507ff5be$exports.cpu){
            let cpu = $cbaad1bf507ff5be$exports.cpu[id];
            if (cpu !== void 0 && cpu.name !== void 0 && cpu.name.toLowerCase() === lName) return id;
        }
        return null;
    }
    getCpuById(id) {
        if ($cbaad1bf507ff5be$exports.cpu === void 0) return null;
        return $d3607477d39bdd2f$var$getDataByIdInCollection($cbaad1bf507ff5be$exports.cpu, id);
    }
    find(deviceBrand, deviceModel, mergeData = {}) {
        if (!deviceBrand || !deviceModel) return null;
        const fixStringName = (str)=>str.replace(new RegExp('_', 'g'), ' ');
        let brand = fixStringName(deviceBrand).trim().toLowerCase();
        let model = fixStringName(deviceModel).trim().toLowerCase();
        const isSkip = this.collection[brand] === void 0 || this.collection[brand] === null || this.collection[brand][model] === void 0;
        if (isSkip) return null;
        let data = this.collection[brand][model];
        // get normalise data
        let result = $f0e5891862cbf6ee$exports.unpack(data, $8a7a1b24f0e41683$exports);
        this.prepareResultDisplay(result);
        this.prepareResultHardware(result);
        this.prepareResultSoftware(result);
        this.prepareResultSize(result);
        this.prepareResultPerformance(result);
        result = $d3607477d39bdd2f$require$mergeDeep(result, mergeData);
        // redirect and overwrite params
        let dataRedirect = /^->([^;]+)/i.exec(data);
        if (dataRedirect !== null) return this.find(deviceBrand, dataRedirect[1], result);
        return $d3607477d39bdd2f$require$sortObject(result);
    }
    prepareResultSize(result) {
        if (this.sizeConvertObject && result.size) result.size = $d3607477d39bdd2f$var$castSizeToObject(result.size);
    }
    prepareResultSoftware(result) {
        if (result.os_id) {
            let output = [];
            let os = this.getOsById(result.os_id);
            delete result.os_id;
            if (os !== null) output.push(os.name);
            if (result.os_version) {
                output.push(result.os_version);
                delete result.os_version;
            }
            if (output.length === 2) result.os = output.join(' ');
        }
    }
    prepareResultHardware(result) {
        // set hardware data
        if (result.hardware) {
            let gpu;
            let cpu;
            if (result.hardware.gpu === void 0 && result.hardware.gpu_id !== void 0) {
                gpu = this.getGpuById(result.hardware.gpu_id);
                if (gpu !== null) result.hardware.gpu = gpu;
            }
            if (result.hardware.cpu_id !== void 0) {
                cpu = this.getCpuById(result.hardware.cpu_id);
                if (cpu !== null) {
                    result.hardware.cpu = cpu;
                    if (result.hardware.gpu === void 0 && result.hardware.cpu.gpu_id) result.hardware.gpu = this.getGpuById(result.hardware.cpu.gpu_id);
                }
            }
        }
    }
    prepareResultDisplay(result) {
        // set display data
        if (result.display) {
            // calculate ration & ppi
            let resolution = result.display && result.display.resolution ? $d3607477d39bdd2f$var$castResolutionToObject(result.display.resolution) : '';
            let ratio = '';
            let ppi = '';
            if (typeof resolution !== 'string') {
                let resolutionWidth = parseInt(resolution.width);
                let resolutionHeight = parseInt(resolution.height);
                if (resolutionWidth && resolutionHeight) {
                    if (result.display.size) ppi = this.castResolutionPPI(resolutionWidth, resolutionHeight, result.display.size);
                    ratio = this.castResolutionRatio(resolutionWidth, resolutionHeight);
                }
            }
            result.display.size = result.display.size ? result.display.size : null;
            result.display.resolution = this.resolutionConvertObject ? resolution : result.display.resolution;
            if (ratio) result.display.ratio = ratio;
            if (ppi) result.display.ppi = String(ppi);
        }
    }
    /**
   * Converts the values of the performance section to the desired format type
   * @param result {ResultDeviceInfo}
   */ prepareResultPerformance(result) {
        if (result.performance !== void 0 && result.performance.antutu !== void 0) result.performance.antutu = parseInt(result.performance.antutu);
        if (result.performance !== void 0 && result.performance.geekbench !== void 0) result.performance.geekbench = parseInt(result.performance.geekbench);
    }
    /**
   * The main method for obtaining information on brand and device
   * @param {String} deviceBrand
   * @param {String} deviceModel
   * @return {ResultDeviceInfo|null}
   */ info(deviceBrand, deviceModel) {
        return this.find(deviceBrand, deviceModel, {});
    }
    castScreenSizeInInches(widthPx, heightPx, dpi) {
        const diagonalPx = Math.hypot(parseInt(widthPx), parseInt(heightPx));
        return parseFloat((diagonalPx / dpi).toFixed(2));
    }
    /**
   * calculate ratio
   * @param width
   * @param height
   * @returns {string}
   */ castResolutionRatio(width, height) {
        let d = $d3607477d39bdd2f$var$gcd(width, height);
        return `${Math.round(height / d)}:${Math.round(width / d)}`;
    }
    /**
   * calculate PPI
   * @param width
   * @param height
   * @param size
   * @returns {number}
   */ castResolutionPPI(width, height, size) {
        return Math.round(Math.sqrt(Math.pow(parseInt(width), 2) + Math.pow(parseInt(height), 2)) / parseFloat(size));
    }
}
$d3607477d39bdd2f$exports = $d3607477d39bdd2f$var$InfoDevice;


var $c9069243997dc4c4$exports = {};

const { attr: $c9069243997dc4c4$var$attr } = $47a1491670bab221$exports;
/**
 * check screen size
 * @param {string} deviceWidth
 * @param {string} deviceHeight
 * @param {string} metaWidth
 * @param {string} metaHeight
 * @return {boolean}
 */ const $c9069243997dc4c4$var$isDeviceSizeValid = (deviceWidth, deviceHeight, metaWidth, metaHeight)=>{
    if (deviceWidth && deviceHeight && metaWidth && metaHeight) {
        const minMetaWidth = parseInt(metaWidth) - 1;
        const maxMetaWidth = parseInt(metaWidth) + 1;
        const minMetaHeight = parseInt(metaHeight) - 1;
        const maxMetaHeight = parseInt(metaHeight) + 1;
        const isWidthValid = $47a1491670bab221$exports.fuzzyBetweenNumber(parseInt(deviceWidth), minMetaWidth, maxMetaWidth) && $47a1491670bab221$exports.fuzzyBetweenNumber(parseInt(deviceHeight), minMetaHeight, maxMetaHeight);
        const isHeightValid = $47a1491670bab221$exports.fuzzyBetweenNumber(parseInt(deviceWidth), minMetaHeight, maxMetaHeight) && $47a1491670bab221$exports.fuzzyBetweenNumber(parseInt(deviceHeight), minMetaWidth, maxMetaWidth);
        return isWidthValid || isHeightValid;
    }
    return true;
};
const $c9069243997dc4c4$var$isDeviceGpuValid = (gpuName, metaGpu)=>{
    let gpuMetaName = $c9069243997dc4c4$var$extractGpuName(metaGpu);
    if (gpuMetaName && gpuName) return gpuName.includes(gpuMetaName) || gpuMetaName.includes(gpuName);
    return true;
};
/**
 * normalization gpu name
 * @param {string} metaGPU
 * @return {string}
 */ const $c9069243997dc4c4$var$extractGpuName = (metaGPU)=>{
    if (!metaGPU) return metaGPU;
    const gpuMap = [
        {
            regex: /Adreno \(TM\) ([^$,]+)/i,
            name: 'Qualcomm Adreno $1'
        },
        {
            regex: /Mali-([^$,]+)/i,
            name: 'ARM Mali-$1'
        },
        {
            regex: /PowerVR Rogue ([^$,]+)/i,
            name: 'PowerVR $1'
        }
    ];
    for(let i = 0, l = gpuMap.length; i < l; i++){
        let matches = gpuMap[i].regex.exec(metaGPU);
        if (matches !== null) return $47a1491670bab221$exports.matchReplace(gpuMap[i].name, matches);
    }
    return metaGPU;
};
/**
 * @param {ResultDevice} deviceData
 * @param {Object} clientHints
 * @return {boolean}
 */ const $c9069243997dc4c4$var$checkDisplaySize = (deviceData, clientHints)=>{
    let deviceWidth;
    let deviceHeight;
    let deviceInfo = deviceData.info;
    if (deviceInfo) {
        if (deviceInfo.display && typeof deviceInfo.display.resolution === 'string') {
            let resolution = deviceInfo.display.resolution.split('x');
            deviceWidth = resolution[0];
            deviceHeight = resolution[1];
        } else {
            deviceWidth = deviceInfo.display && deviceInfo.display.resolution && deviceInfo.display.resolution.width ? deviceInfo.display.resolution.width : null;
            deviceHeight = deviceInfo.display && deviceInfo.display.resolution && deviceInfo.display.resolution.height ? deviceInfo.display.resolution.height : null;
        }
        let metaWidth = $c9069243997dc4c4$var$attr(clientHints.meta, 'width', null);
        let metaHeight = $c9069243997dc4c4$var$attr(clientHints.meta, 'height', null);
        if (!$c9069243997dc4c4$var$isDeviceSizeValid(deviceWidth, deviceHeight, metaWidth, metaHeight)) return false;
    }
    return true;
};
const $c9069243997dc4c4$var$isGpuExistForClientHints = (clientHints)=>{
    return clientHints.meta && clientHints.meta.gpu && clientHints.meta.gpu.length > 0;
};
const $c9069243997dc4c4$var$isAppleBrandForDeviceData = (deviceData)=>{
    return deviceData.brand === 'Apple' || deviceData.brand === '' && /ip(?:hone|[ao]d)/i.test(deviceData.code);
};
/**
 * @param {ResultDevice} deviceData
 * @param {Object} clientHints
 * @return {boolean}
 */ const $c9069243997dc4c4$var$checkGpu = (deviceData, clientHints)=>{
    let deviceInfo = deviceData.info;
    let deviceGPU = deviceInfo && deviceInfo.hardware && deviceInfo.hardware.gpu ? deviceInfo.hardware.gpu.name : null;
    let metaGPU = $c9069243997dc4c4$var$attr(clientHints.meta, 'gpu', null);
    if (metaGPU === 'PowerVR SGX Doma') metaGPU = 'PowerVR GE8320';
    if (metaGPU !== null && deviceGPU !== null) return $c9069243997dc4c4$var$isDeviceGpuValid(deviceGPU, metaGPU);
    return true;
};
class $c9069243997dc4c4$var$DeviceTrusted {
    /**
   * @param {ResultOs} osData
   * @param {ResultClient} clientData
   * @param {ResultDevice}  deviceData
   * @param clientHints
   * @return {boolean|null}
   */ static check(osData, clientData, deviceData, clientHints) {
        const regexAppleGpu = /GPU Apple/i;
        const isGpuExist = $c9069243997dc4c4$var$isGpuExistForClientHints(clientHints);
        const isAppleBrand = $c9069243997dc4c4$var$isAppleBrandForDeviceData(deviceData);
        // is Apple and lack of client-hints
        if (isAppleBrand && clientHints && clientHints.client && clientHints.client.brands && clientHints.client.brands.length > 0) return false;
        // is Apple and check correct gpu name
        if (isAppleBrand && isGpuExist && !regexAppleGpu.test(clientHints.meta.gpu)) return false;
        else if (isAppleBrand && isGpuExist && regexAppleGpu.test(clientHints.meta.gpu)) return true;
        if (deviceData.info) {
            // check for display size
            if (!$c9069243997dc4c4$var$checkDisplaySize(deviceData, clientHints)) return false;
            // check for gpu name
            if (!$c9069243997dc4c4$var$checkGpu(deviceData, clientHints)) return false;
            return true;
        }
        return null;
    }
}
$c9069243997dc4c4$exports = $c9069243997dc4c4$var$DeviceTrusted;




var $1f7db0c26a7371d4$exports = {};
$1f7db0c26a7371d4$exports = [
    'tvOS',
    'iOS',
    'Mac',
    'iPadOS',
    'watchOS'
];


var $c8c3b009f641a4bb$exports = {};
$c8c3b009f641a4bb$exports = [
    'AmigaOS',
    'IBM',
    'GNU/Linux',
    'Mac',
    'Unix',
    'Windows',
    'BeOS',
    'Chrome OS'
];


var $cf1759e60d422abf$exports = {};
$cf1759e60d422abf$exports = {
    MOBILE: 'Mobile',
    HBBTV: 'HbbTv',
    SHELLTV: 'ShellTv',
    NOTEBOOK: 'Notebook',
    CONSOLE: 'Console',
    CAR_BROWSER: 'CarBrowser',
    CAMERA: 'Camera',
    PORTABLE_MEDIA_PLAYER: 'PortableMediaPlayer'
};


var $0450dc9fcf4ed82a$exports = {};
$0450dc9fcf4ed82a$exports = {
    FEED_READER: 'FeedReader',
    MEDIA_PLAYER: 'MediaPlayer',
    PIM: 'PIM',
    MOBILE_APP: 'MobileApp',
    LIBRARY: 'Library',
    BROWSER: 'Browser'
};


var $1bff80c50a032c17$exports = {};

$1bff80c50a032c17$exports = {
    'automotive': $a86fa4b852e0efb3$exports.CAR_BROWSER,
    'xr': $a86fa4b852e0efb3$exports.WEARABLE,
    'watch': $a86fa4b852e0efb3$exports.WEARABLE,
    'mobile': $a86fa4b852e0efb3$exports.SMARTPHONE,
    'tablet': $a86fa4b852e0efb3$exports.TABLET,
    'desktop': $a86fa4b852e0efb3$exports.DESKTOP,
    'eink': $a86fa4b852e0efb3$exports.TABLET
};


var $a430a7976be4de8a$exports = {};
// prettier-ignore
$a430a7976be4de8a$exports = [
    '36',
    'AH',
    'AI',
    'BL',
    'C1',
    'C4',
    'CB',
    'CW',
    'DB',
    '3M',
    'DT',
    'EU',
    'EZ',
    'FK',
    'FM',
    'FR',
    'FX',
    'GH',
    'GI',
    'GR',
    'HA',
    'HU',
    'IV',
    'JB',
    'KD',
    'M1',
    'MF',
    'MN',
    'MZ',
    'NX',
    'OC',
    'OI',
    'OM',
    'OZ',
    '2P',
    'PI',
    'PE',
    'QU',
    'RE',
    'S0',
    'S7',
    'SA',
    'SB',
    'SG',
    'SK',
    'ST',
    'SU',
    'T1',
    'UH',
    'UM',
    'UT',
    'VE',
    'VV',
    'WI',
    'WP',
    'YN',
    'IO',
    'IS',
    'HQ',
    'RW',
    'HI',
    'PN',
    'BW',
    'YO',
    'PK',
    'MR',
    'AP',
    'AK',
    'UI',
    'SD',
    'VN',
    '4S',
    'RF',
    'LR',
    'SQ',
    'BV',
    'L1',
    'F0',
    'KS',
    'V0',
    'C8',
    'AZ',
    'MM',
    'BT',
    'N0',
    'P0',
    'F3',
    'DU',
    'D0',
    'P1',
    'O4',
    'XO',
    'U0',
    'B0',
    'VA',
    'X0',
    'A5',
    'X1',
    '18',
    'B5',
    'B6',
    'TC',
    'A6',
    '2X',
    'F4',
    'YG',
    'WR',
    'NA',
    'DM',
    '1M',
    'A7',
    'XN',
    'XT',
    'XB',
    'W1',
    'HT',
    'B7',
    'B9',
    'T0',
    'I8',
    'O6',
    'P7',
    'O8',
    '4B',
    'A8',
    'P8',
    '1W',
    'EV',
    'Z0',
    'I9',
    'V4',
    'H4',
    'M5',
    '0S',
    '0C',
    'ZR',
    'D6',
    'F6',
    'P3',
    'FT',
    'A9',
    'X2',
    'NI',
    'FG',
    'TH',
    'N3',
    'GD',
    'O9',
    'Q3',
    'F7',
    'K2',
    'N4',
    'P5',
    'H5',
    'V3',
    'G2',
    'BG',
    'OL',
    'II',
    'TL',
    'M6',
    'Y3',
    'M7',
    'GN',
    'JR',
    'IG',
    'HW',
    '4O',
    'OU',
    '5P',
    'KE',
    '5A',
    'TT',
    '6P',
    'G3',
    '7P',
    'VU',
    'F8',
    'L4',
    'DK',
    'DP',
    'KL',
    'K4',
    'N6',
    'KU',
    'WK',
    'M8',
    'UP',
    'ZT',
    '9P',
    'N8',
    'VR',
    'N9',
    'M9',
    'F9',
    '0P',
    '0A',
    '2F',
    '2M',
    'K7',
    '1N',
    '8A',
    'H7',
    'X3',
    'X4',
    '5O',
    '6I',
    '7I',
    'X5',
    '3P',
    '2E'
];


const $88feee6a131c186a$var$VENDOR_FRAGMENT_PARSER = 'VendorFragment';
const $88feee6a131c186a$var$OS_PARSER = 'Os';
const $88feee6a131c186a$var$BOT_PARSER = 'Bot';
// ===========================
// static private parser init
// ===========================
const $88feee6a131c186a$var$aliasDevice = new $63064923ad99e4d1$exports();
$88feee6a131c186a$var$aliasDevice.setReplaceBrand(false);
const $88feee6a131c186a$var$infoDevice = new $d3607477d39bdd2f$exports();
class $88feee6a131c186a$var$DeviceDetector {
    vendorParserList = {};
    osParserList = {};
    botParserList = {};
    deviceParserList = {};
    clientParserList = {};
    #skipBotDetection = false;
    #deviceIndexes = false;
    #osIndexes = false;
    #clientIndexes = false;
    #deviceAliasCode = false;
    #deviceTrusted = false;
    #deviceInfo = false;
    #clientVersionTruncate = null;
    #osVersionTruncate = null;
    #maxUserAgentSize = null;
    /**
   * @param {DeviceDetectorOptions} options
   **/ constructor(options = {}){
        this.init();
        this.skipBotDetection = $88feee6a131c186a$var$attr(options, 'skipBotDetection', false);
        this.osVersionTruncate = $88feee6a131c186a$var$attr(options, 'osVersionTruncate', null);
        this.clientVersionTruncate = $88feee6a131c186a$var$attr(options, 'clientVersionTruncate', null);
        this.deviceIndexes = $88feee6a131c186a$var$attr(options, 'deviceIndexes', false);
        this.clientIndexes = $88feee6a131c186a$var$attr(options, 'clientIndexes', false);
        this.osIndexes = $88feee6a131c186a$var$attr(options, 'osIndexes', false);
        this.deviceAliasCode = $88feee6a131c186a$var$attr(options, 'deviceAliasCode', false);
        this.maxUserAgentSize = $88feee6a131c186a$var$attr(options, 'maxUserAgentSize', null);
        this.deviceTrusted = $88feee6a131c186a$var$attr(options, 'deviceTrusted', false);
        this.deviceInfo = $88feee6a131c186a$var$attr(options, 'deviceInfo', false);
    }
    init() {
        this.addParseOs($88feee6a131c186a$var$OS_PARSER, new $4dc49b6f19c8e54b$exports());
        this.addParseClient($0450dc9fcf4ed82a$exports.FEED_READER, new $6d83baf9672b0a80$exports());
        this.addParseClient($0450dc9fcf4ed82a$exports.MOBILE_APP, new $5358240e24b4c7df$exports());
        this.addParseClient($0450dc9fcf4ed82a$exports.MEDIA_PLAYER, new $80619a89b85c7ab3$exports());
        this.addParseClient($0450dc9fcf4ed82a$exports.PIM, new $fcc94a58e0ae1264$exports());
        this.addParseClient($0450dc9fcf4ed82a$exports.BROWSER, new $a522a30d1d8b49ce$exports());
        this.addParseClient($0450dc9fcf4ed82a$exports.LIBRARY, new $edb256cd6a1e100f$exports());
        this.addParseDevice($cf1759e60d422abf$exports.HBBTV, new $407264a87b5c9052$exports());
        this.addParseDevice($cf1759e60d422abf$exports.SHELLTV, new $127410077136c7d3$exports());
        this.addParseDevice($cf1759e60d422abf$exports.NOTEBOOK, new $22eb8546cbbee8f0$exports());
        this.addParseDevice($cf1759e60d422abf$exports.CONSOLE, new $9df9b6da98745d30$exports());
        this.addParseDevice($cf1759e60d422abf$exports.CAR_BROWSER, new $81a2f51c312f4a4f$exports());
        this.addParseDevice($cf1759e60d422abf$exports.CAMERA, new $d14192cbf2c5a49a$exports());
        this.addParseDevice($cf1759e60d422abf$exports.PORTABLE_MEDIA_PLAYER, new $6a4e63ed821d479a$exports());
        this.addParseDevice($cf1759e60d422abf$exports.MOBILE, new $5098919fcba0dff2$exports());
        this.addParseVendor($88feee6a131c186a$var$VENDOR_FRAGMENT_PARSER, new $837d31c16149e6f6$exports());
        this.addParseBot($88feee6a131c186a$var$BOT_PARSER, new $6d3fc93af3cd0d3c$exports());
    }
    set deviceTrusted(stage) {
        this.#deviceTrusted = stage;
    }
    get deviceTrusted() {
        return this.#deviceTrusted;
    }
    set deviceInfo(stage) {
        this.#deviceInfo = stage;
    }
    get deviceInfo() {
        return this.#deviceInfo;
    }
    /**
   * Set string size limit for the useragent
   * @param {number} size
   */ set maxUserAgentSize(size) {
        this.#maxUserAgentSize = size;
        for(let name in this.clientParserList)this.clientParserList[name].setMaxUserAgentSize(size);
        for(let name in this.osParserList)this.osParserList[name].setMaxUserAgentSize(size);
        for(let name in this.deviceParserList)this.deviceParserList[name].setMaxUserAgentSize(size);
    }
    /**
   * Get string size limit for the useragent
   * @returns {null|number}
   */ get maxUserAgentSize() {
        return this.#maxUserAgentSize;
    }
    get skipBotDetection() {
        return this.#skipBotDetection;
    }
    set skipBotDetection(discard) {
        this.#skipBotDetection = discard;
    }
    /**
   * @param {boolean} stage - true use indexes, false not use indexes
   */ set deviceIndexes(stage) {
        this.#deviceIndexes = stage;
    }
    /**
   * @return {boolean} - true use indexes, false not use indexes
   */ get deviceIndexes() {
        return this.#deviceIndexes;
    }
    /**
   * true use indexes, false not use indexes
   * @param {boolean} status
   */ set clientIndexes(status) {
        this.#clientIndexes = status;
        for(let name in this.clientParserList)this.clientParserList[name].clientIndexes = status;
    }
    /**
   * @return {boolean}
   */ get clientIndexes() {
        return this.#clientIndexes;
    }
    /**
   * true use indexes, false not use indexes
   * @param status
   */ set osIndexes(status) {
        this.#osIndexes = status;
        for(let name in this.osParserList)this.osParserList[name].osIndexes = status;
    }
    /**
   * true use indexes, false not use indexes
   * @return {boolean}
   */ get osIndexes() {
        return this.#osIndexes;
    }
    /**
   * true use deviceAliasCode, false not use deviceAliasCode
   * @param {boolean} status
   */ set deviceAliasCode(status) {
        this.#deviceAliasCode = status;
    }
    /**
   * true use deviceAliasCode, false not use deviceAliasCode
   * @return {boolean}
   */ get deviceAliasCode() {
        return this.#deviceAliasCode;
    }
    /**
   * set truncate client version (default null - all)
   * @param value
   */ set clientVersionTruncate(value) {
        this.#clientVersionTruncate = value;
        for(let name in this.clientParserList)this.clientParserList[name].setVersionTruncation(value);
    }
    /**
   * get truncate client version
   * @return int|null
   */ get clientVersionTruncate() {
        return this.#clientVersionTruncate;
    }
    /**
   * set truncate os version (default null - all)
   * @param value
   */ set osVersionTruncate(value) {
        this.#osVersionTruncate = value;
        for(let name in this.osParserList)this.osParserList[name].setVersionTruncation(value);
    }
    /**
   * get truncate os version
   * @return {null|number}
   */ get osVersionTruncate() {
        return this.#osVersionTruncate;
    }
    /**
   * set truncate os version (default null - all)
   * @deprecated the method will be removed in v2.0 (use detector.osVersionTruncate)
   * @param value
   */ setOsVersionTruncate(value) {
        this.osVersionTruncate = value;
    }
    /**
   * set truncate client version (default null - all)
   * @deprecated the method will be removed in v2.0 (use detector.clientVersionTruncate)
   * @param value
   */ setClientVersionTruncate(value) {
        this.clientVersionTruncate = value;
    }
    /**
   * get all device types
   * @return {string[]}
   */ getAvailableDeviceTypes() {
        return Object.values($a86fa4b852e0efb3$exports);
    }
    /**
   * get all brands
   * @return {string[]}
   */ getAvailableBrands() {
        return this.getParseDevice($cf1759e60d422abf$exports.MOBILE).getAvailableBrands();
    }
    /**
   * has device brand
   * @param brand
   * @return {boolean}
   */ hasBrand(brand) {
        return this.getParseDevice($cf1759e60d422abf$exports.MOBILE).getCollectionBrands()[brand] !== void 0;
    }
    /**
   * get all browsers
   * @returns {string[]}
   */ getAvailableBrowsers() {
        return this.getParseClient($0450dc9fcf4ed82a$exports.BROWSER).getAvailableBrowsers();
    }
    /**
   * get device parser by name
   * @param {string} name
   * @return {DeviceParserAbstract|null}
   */ getParseDevice(name) {
        return this.deviceParserList[name] ? this.deviceParserList[name] : null;
    }
    /**
   * get client parser by name
   * @param {string} name
   * @return {*}
   */ getParseClient(name) {
        return this.clientParserList[name] ? this.clientParserList[name] : null;
    }
    /**
   * get bot parser by name
   * @param name
   * @return {*}
   */ getParseBot(name) {
        return this.botParserList[name] ? this.botParserList[name] : null;
    }
    /**
   * get os parser by name
   * @param name
   * @return {*}
   */ getParseOs(name) {
        return this.osParserList[name] ? this.osParserList[name] : null;
    }
    /**
   * get vendor parser by name (specific parsers)
   * @param {string} name
   * @return {*}
   */ getParseVendor(name) {
        return this.vendorParserList[name] ? this.vendorParserList[name] : null;
    }
    /**
   * get alias device parser
   * @returns {AliasDevice}
   */ getParseAliasDevice() {
        return $88feee6a131c186a$var$aliasDevice;
    }
    /**
   * get info device parser
   * @returns {InfoDevice}
   */ getParseInfoDevice() {
        return $88feee6a131c186a$var$infoDevice;
    }
    getDeviceParserNames() {
        return $cf1759e60d422abf$exports;
    }
    getClientParserNames() {
        return $0450dc9fcf4ed82a$exports;
    }
    getBotParserNames() {
        return {
            'DEFAULT': $88feee6a131c186a$var$BOT_PARSER
        };
    }
    getOsParserNames() {
        return {
            'DEFAULT': $88feee6a131c186a$var$OS_PARSER
        };
    }
    /**
   * add device type parser
   * @param {string} name
   * @param parser
   */ addParseDevice(name, parser) {
        this.deviceParserList[name] = parser;
    }
    /**
   * add os type parser
   * @param {string} name
   * @param {OsAbstractParser} parser
   */ addParseOs(name, parser) {
        this.osParserList[name] = parser;
    }
    /**
   * add bot type parser
   * @param {string} name
   * @param {BotAbstractParser} parser
   */ addParseBot(name, parser) {
        this.botParserList[name] = parser;
    }
    /**
   * add client type parser
   * @param {string} name
   * @param {ClientAbstractParser} parser
   */ addParseClient(name, parser) {
        this.clientParserList[name] = parser;
    }
    /**
   * add vendor type parser
   * @param {string} name
   * @param {VendorFragmentAbstractParser} parser
   */ addParseVendor(name, parser) {
        this.vendorParserList[name] = parser;
    }
    /**
   * parse OS
   * @param {string} userAgent
   * @param {ResultClientHints|{}} clientHints
   * @return {ResultOs}
   */ parseOs(userAgent, clientHints = {}) {
        let result = {};
        for(let name in this.osParserList){
            let parser = this.osParserList[name];
            let resultMerge = parser.parse(userAgent, clientHints);
            if (resultMerge) {
                result = Object.assign(result, resultMerge);
                break;
            }
        }
        return result;
    }
    /**
   * prepare user agent for restrict rules
   * @param {string|*} userAgent
   * @returns {string|*}
   */ prepareUserAgent(userAgent) {
        if (userAgent && this.maxUserAgentSize && this.maxUserAgentSize < userAgent.length) return String(userAgent).substring(0, this.maxUserAgentSize);
        return userAgent;
    }
    /**
   * parse device type
   * @param {string} userAgent
   * @param {ResultOs} osData
   * @param {ResultClient} clientData
   * @param {ResultDevice} deviceData
   * @param {ResultClientHints} clientHints
   * @return {DeviceType}
   */ parseDeviceType(userAgent, osData, clientData, deviceData, clientHints) {
        userAgent = this.prepareUserAgent(userAgent);
        let osName = $88feee6a131c186a$var$attr(osData, 'name', '');
        let osFamily = $88feee6a131c186a$var$attr(osData, 'family', '');
        let osVersion = $88feee6a131c186a$var$attr(osData, 'version', '');
        let clientType = $88feee6a131c186a$var$attr(clientData, 'type', '');
        let clientShortName = $88feee6a131c186a$var$attr(clientData, 'short_name', '');
        let clientName = $88feee6a131c186a$var$attr(clientData, 'name', '');
        let clientFamily = $88feee6a131c186a$var$attr(clientData, 'family', '');
        let deviceType = $88feee6a131c186a$var$attr(deviceData, 'type', '');
        // client hint detect device type
        if (deviceType === '' && clientHints && clientHints.device && clientHints.device.model && clientHints.formFactors.length) {
            for (const [type, deviceTypeName] of Object.entries($1bff80c50a032c17$exports))if (clientHints.formFactors.includes(type)) {
                deviceType = '' + deviceTypeName;
                break;
            }
        }
        /**
     * All devices containing VR fragment are assumed to be a wearable
     */ if (deviceType === '' && $47a1491670bab221$exports.hasVRFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.WEARABLE;
        /**
     * Chrome on Android passes the device type based on the keyword 'Mobile'
     * If it is present the device should be a smartphone, otherwise it's a tablet
     * See https://developer.chrome.com/multidevice/user-agent#chrome_for_android_user_agent
     * Note: We do not check for browser (family) here, as there might be mobile apps using Chrome, that won't have
     *       a detected browser, but can still be detected. So we check the useragent for Chrome instead.
     */ if (deviceType === '' && osFamily === 'Android' && $47a1491670bab221$exports.matchUserAgent('Chrome/[.0-9]*', userAgent)) deviceType = $47a1491670bab221$exports.matchUserAgent('(Mobile|eliboM)', userAgent) ? $a86fa4b852e0efb3$exports.SMARTPHONE : $a86fa4b852e0efb3$exports.TABLET;
        /**
     * Some UA contain the fragment 'Pad/APad', so we assume those devices as tablets
     */ if (deviceType === $a86fa4b852e0efb3$exports.SMARTPHONE && $47a1491670bab221$exports.matchUserAgent('Pad/APad', userAgent)) deviceType = $a86fa4b852e0efb3$exports.TABLET;
        /**
     * Some UA contain the fragment 'Android; Tablet;' or 'Opera Tablet', so we assume those devices as tablets
     */ if (deviceType === '' && ($47a1491670bab221$exports.hasAndroidTableFragment(userAgent) || $47a1491670bab221$exports.hasOperaTableFragment(userAgent))) deviceType = $a86fa4b852e0efb3$exports.TABLET;
        /**
     * Some user agents simply contain the fragment 'Android; Mobile;', so we assume those devices as smartphones
     */ if (deviceType === '' && $47a1491670bab221$exports.hasAndroidMobileFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.SMARTPHONE;
        /**
     * Android up to 3.0 was designed for smartphones only. But as 3.0, which was tablet only, was published
     * too late, there were a bunch of tablets running with 2.x
     * With 4.0 the two trees were merged and it is for smartphones and tablets
     *
     * So were are expecting that all devices running Android < 2 are smartphones
     * Devices running Android 3.X are tablets. Device type of Android 2.X and 4.X+ are unknown
     */ if (deviceType === '' && osName === 'Android' && osVersion !== '') {
            if ($47a1491670bab221$exports.versionCompare(osVersion, '2.0') === -1) deviceType = $a86fa4b852e0efb3$exports.SMARTPHONE;
            else if ($47a1491670bab221$exports.versionCompare(osVersion, '3.0') >= 0 && $47a1491670bab221$exports.versionCompare(osVersion, '4.0') === -1) deviceType = $a86fa4b852e0efb3$exports.TABLET;
        }
        /**
     * All detected feature phones running android are more likely a smartphone
     */ if (deviceType === $a86fa4b852e0efb3$exports.FEATURE_PHONE && osFamily === 'Android') deviceType = $a86fa4b852e0efb3$exports.SMARTPHONE;
        /**
     * All unknown devices under running Java ME
     * are more likely features phones
     */ if (deviceType === '' && osName === 'Java ME') deviceType = $a86fa4b852e0efb3$exports.FEATURE_PHONE;
        /**
     * All devices running KaiOS are more likely features phones
     */ if ('KaiOS' === osName) deviceType = $a86fa4b852e0efb3$exports.FEATURE_PHONE;
        /**
     * According to http://msdn.microsoft.com/en-us/library/ie/hh920767(v=vs.85).aspx
     * Internet Explorer 10 introduces the "Touch" UA string token. If this token is present at the end of the
     * UA string, the computer has touch capability, and is running Windows 8 (or later).
     * This UA string will be transmitted on a touch-enabled system running Windows 8 (RT)
     *
     * As most touch enabled devices are tablets and only a smaller part are desktops/notebooks we assume that
     * all Windows 8 touch devices are tablets.
     */ const hasWindowTable = '' === deviceType && ('Windows RT' === osName || 'Windows' === osName && $47a1491670bab221$exports.versionCompare(osVersion, '8') >= 0) && $47a1491670bab221$exports.hasTouchFragment(userAgent);
        if (hasWindowTable) deviceType = $a86fa4b852e0efb3$exports.TABLET;
        if ('' === deviceType && /Puffin\/\d/i.test(userAgent)) {
            /**
       * All devices running Puffin Secure Browser that contain letter 'D' are assumed to be desktops
       */ if ($47a1491670bab221$exports.hasPuffinDesktopFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.DESKTOP;
            /**
       * All devices running Puffin Web Browser that contain letter 'P' are assumed to be smartphones
       */ if ($47a1491670bab221$exports.hasPuffinSmartphoneFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.SMARTPHONE;
            /**
       * All devices running Puffin Web Browser that contain letter 'T' are assumed to be tablets
       */ if ($47a1491670bab221$exports.hasPuffinTabletFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.TABLET;
        }
        /**
     * All devices running Opera TV Store are assumed to be a tv
     */ if ($47a1491670bab221$exports.hasOperaTVStoreFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.TV;
        /**
     * All devices running Coolita OS are assumed to be a tv
     */ if ('Coolita OS' === osName) deviceType = $a86fa4b852e0efb3$exports.TV;
        /**
     * All devices that contain Andr0id in string are assumed to be a tv
     */ const hasDeviceTvType = [
            $a86fa4b852e0efb3$exports.TV,
            $a86fa4b852e0efb3$exports.PERIPHERAL
        ].indexOf(deviceType) === -1 && $47a1491670bab221$exports.hasAndroidTVFragment(userAgent);
        if (hasDeviceTvType) deviceType = $a86fa4b852e0efb3$exports.TV;
        /**
     * All devices running Tizen TV or SmartTV are assumed to be a tv
     */ if ('' === deviceType && $47a1491670bab221$exports.hasTVFragment(userAgent)) deviceType = $a86fa4b852e0efb3$exports.TV;
        /**
     * Devices running those clients are assumed to be a TV
     */ if ($47a1491670bab221$exports.hasTVClient(clientName)) deviceType = $a86fa4b852e0efb3$exports.TV;
        /**
     * All devices containing TV fragment are assumed to be a tv
     */ if ('' === deviceType && $47a1491670bab221$exports.matchUserAgent('\\(TV;', userAgent)) deviceType = $a86fa4b852e0efb3$exports.TV;
        /**
     * Set device type desktop if string ua contains desktop
     */ if ($a86fa4b852e0efb3$exports.DESKTOP !== deviceType && userAgent.indexOf('Desktop') !== -1) {
            if ($47a1491670bab221$exports.matchUserAgent('Desktop(?: (x(?:32|64)|WOW64))?;', userAgent)) deviceType = $a86fa4b852e0efb3$exports.DESKTOP;
        }
        // check os desktop and not mobile browser
        if (deviceType === '') {
            let hasMobileBrowser = clientType === $6b929fe91f6b6fc3$exports.BROWSER && $a430a7976be4de8a$exports.indexOf(clientShortName) !== -1;
            let hasDesktopOs = osName !== '' && ($c8c3b009f641a4bb$exports.indexOf(osName) !== -1 || $c8c3b009f641a4bb$exports.indexOf(osFamily) !== -1);
            if (!hasMobileBrowser && hasDesktopOs) deviceType = $a86fa4b852e0efb3$exports.DESKTOP;
        }
        return {
            type: deviceType
        };
    }
    /**
   * get brand by device code (used in indexing)
   * @param {string} deviceCode
   * @returns {string[]}
   */ getBrandsByDeviceCode(deviceCode) {
        if ('' === deviceCode) return [];
        return $875ac1efa858937e$exports.findDeviceBrandsForDeviceCode(deviceCode);
    }
    /**
   * parse device model code from useragent string
   * @param {string} userAgent
   * @returns {ResultDeviceCode}
   */ parseDeviceCode(userAgent) {
        return $88feee6a131c186a$var$aliasDevice.parse(userAgent);
    }
    /**
   * restore original userAgent from clientHints object
   * @param {string} userAgent
   * @param {ResultClientHints} clientHints
   * @return {string}
   */ restoreUserAgentFromClientHints(userAgent, clientHints) {
        return $47a1491670bab221$exports.restoreUserAgentFromClientHints(userAgent, clientHints);
    }
    /**
   * parse device
   * @param {string} userAgent
   * @param {ResultClientHints} clientHints
   * @return {ResultDevice}
   */ parseDevice(userAgent, clientHints) {
        let deviceModel = '';
        let brandIndexes = [];
        let result = {
            id: '',
            type: '',
            brand: '',
            model: '',
            code: '',
            info: {},
            trusted: null
        };
        const ua = this.restoreUserAgentFromClientHints(userAgent, clientHints);
        // skip all parse is client-hints useragent and model not exist
        if (!$47a1491670bab221$exports.hasDeviceModelByClientHints(clientHints) && $47a1491670bab221$exports.hasUserAgentClientHintsFragment(userAgent)) return Object.assign({}, result);
        // add device.code to result
        if (this.deviceIndexes || this.deviceAliasCode || this.deviceInfo || this.deviceTrusted) {
            if ($47a1491670bab221$exports.hasDeviceModelByClientHints(clientHints)) result.code = clientHints.device.model;
            else {
                const alias = this.parseDeviceCode(ua);
                result.code = alias.name ? alias.name : '';
            }
            deviceModel = '' + result.code;
        } else if ($47a1491670bab221$exports.hasDeviceModelByClientHints(clientHints)) deviceModel = '' + clientHints.device.model;
        // get indexes brands to scan only
        if (this.deviceIndexes) brandIndexes = this.getBrandsByDeviceCode(result.code);
        // is desktop fragment then parsing device skip
        if (deviceModel === '' && $47a1491670bab221$exports.hasDesktopFragment(ua)) return result;
        if (result && result.brand === '') for(let name in this.deviceParserList){
            let parser = this.deviceParserList[name];
            let resultMerge = parser.parse(ua, brandIndexes);
            if (resultMerge) {
                result = Object.assign({}, result, resultMerge);
                break;
            }
        }
        if (result && result.brand === '') {
            let resultVendor = this.parseVendor(ua);
            if (resultVendor) {
                result.brand = resultVendor.name;
                result.id = resultVendor.id;
            }
        }
        // client hints get model raw
        if (result.model === '' && $47a1491670bab221$exports.hasDeviceModelByClientHints(clientHints)) result.model = clientHints.device.model;
        // device info or deviceTrusted
        if (this.deviceInfo || this.deviceTrusted) {
            let deviceModel = result.code ? result.code : result.model;
            result.info = this.getParseInfoDevice().info(result.brand, deviceModel);
        }
        return result;
    }
    /**
   * parse vendor
   * @param {string} userAgent
   * @return {ResultVendor|null}
   */ parseVendor(userAgent) {
        return this.getParseVendor($88feee6a131c186a$var$VENDOR_FRAGMENT_PARSER).parse(userAgent);
    }
    /**
   * parse bot
   * @param {string} userAgent
   * @param {ResultClientHints} clientHints
   * @return {ResultBot|{}}
   */ parseBot(userAgent, clientHints) {
        let result = {};
        if (this.skipBotDetection) return result;
        for(let name in this.botParserList){
            let resultMerge = this.botParserList[name].parse(userAgent);
            if (resultMerge) {
                result = Object.assign(result, resultMerge);
                break;
            }
        }
        return result;
    }
    /**
   * parse client
   * @param {string} userAgent
   * @param {ResultClientHints} clientHints
   * @return {ResultClient|{}}
   */ parseClient(userAgent, clientHints) {
        const extendParsers = [
            $0450dc9fcf4ed82a$exports.MOBILE_APP,
            $0450dc9fcf4ed82a$exports.BROWSER
        ];
        // scan for indexes
        if (this.clientIndexes) for(let name in this.clientParserList){
            const hasExtend = extendParsers.indexOf(name) !== -1;
            const parser = this.clientParserList[name];
            const hash = hasExtend ? parser.parseFromHashHintsApp(clientHints) : {};
            const hint = hasExtend ? parser.parseFromClientHints(clientHints) : {};
            const data = parser.parseUserAgentByPositions(userAgent);
            const result = hasExtend ? parser.prepareParseResult(userAgent, data, hint, hash) : data;
            if (result && result.name) return Object.assign({}, result);
        }
        // scan full
        for(let name in this.clientParserList){
            const parser = this.clientParserList[name];
            const result = parser.parse(userAgent, clientHints);
            if (result && result.name) return Object.assign({}, result);
        }
        return {};
    }
    prepareDetectResult(userAgent, osData, clientData, deviceData, clientHints) {
        /**
     * if it's fake UA then it's best not to identify it as Apple running Android OS or GNU/Linux
     */ if (deviceData.brand === 'Apple' && $1f7db0c26a7371d4$exports.indexOf(osData.name) === -1) {
            deviceData.id = '';
            deviceData.brand = '';
            deviceData.model = '';
            deviceData.type = '';
        }
        /**
     * Assume all devices running iOS / Mac OS are from Apple
     */ if (deviceData.brand === '' && $1f7db0c26a7371d4$exports.indexOf(osData.name) !== -1) deviceData.brand = 'Apple';
        let deviceDataType = this.parseDeviceType(userAgent, osData, clientData, deviceData, clientHints);
        deviceData = Object.assign(deviceData, deviceDataType);
        if (this.deviceTrusted) deviceData.trusted = $c9069243997dc4c4$exports.check(osData, clientData, deviceData, clientHints);
        else delete deviceData.trusted;
        if (!this.deviceAliasCode) delete deviceData.code;
        if (!this.deviceInfo) delete deviceData.info;
        /**
     * All devices running Coolita OS are assumed to be a tv
     */ if ('Coolita OS' === osData.name && '' === deviceData.brand) deviceData.brand = 'coocaa';
        return {
            os: osData,
            client: clientData,
            device: deviceData
        };
    }
    /**
   * detect os, client and device for async
   * @param {string} userAgent - string from request header['user-agent']
   * @param {ResultClientHints|{}} clientHints
   * @return {DetectResult}
   */ async detectAsync(userAgent, clientHints = {}) {
        userAgent = this.prepareUserAgent(userAgent);
        let devicePromise = new Promise((resolve)=>{
            return resolve(this.parseDevice(userAgent, clientHints));
        });
        let osPromise = new Promise((resolve)=>{
            return resolve(this.parseOs(userAgent, clientHints));
        });
        let clientPromise = new Promise((resolve)=>{
            return resolve(this.parseClient(userAgent, clientHints));
        });
        let [deviceData, osData, clientData] = await Promise.all([
            devicePromise,
            osPromise,
            clientPromise
        ]);
        return this.prepareDetectResult(userAgent, osData, clientData, deviceData, clientHints);
    }
    /**
   * detect os, client and device for sync
   * @param {string} userAgent - string from request header['user-agent']
   * @param {ResultClientHints|{}} clientHints
   * @return {DetectResult}
   */ detect(userAgent, clientHints = {}) {
        userAgent = this.prepareUserAgent(userAgent);
        let deviceData = this.parseDevice(userAgent, clientHints);
        let osData = this.parseOs(userAgent, clientHints);
        let clientData = this.parseClient(userAgent, clientHints);
        return this.prepareDetectResult(userAgent, osData, clientData, deviceData, clientHints);
    }
}
$88feee6a131c186a$exports = $88feee6a131c186a$var$DeviceDetector;


var $f9223308e96891e9$exports = {};

var $abe08f24eab2619b$exports = {};

const $abe08f24eab2619b$var$DEVICE_TYPE_IDS = {};
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.DESKTOP] = 0;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.SMARTPHONE] = 1;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.TABLET] = 2;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.FEATURE_PHONE] = 3;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.CONSOLE] = 4;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.TV] = 5;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.CAR_BROWSER] = 6;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.SMART_DISPLAY] = 7;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.CAMERA] = 8;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.PORTABLE_MEDIA_PLAYER] = 9;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.PHABLET] = 10;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.SMART_SPEAKER] = 11;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.WEARABLE] = 12;
$abe08f24eab2619b$var$DEVICE_TYPE_IDS[$a86fa4b852e0efb3$exports.PERIPHERAL] = 13;
$abe08f24eab2619b$exports = $abe08f24eab2619b$var$DEVICE_TYPE_IDS;



/**
 * get device type string
 * @param result
 * @returns {string|null}
 */ const $f9223308e96891e9$var$getDeviceType = (result)=>{
    return result.device && result.device.type ? result.device.type : null;
};
/**
 * get device type id for name
 * @param {string} name
 * @returns {number|null}
 */ const $f9223308e96891e9$var$getDeviceTypeIdForName = (name)=>{
    return name && $abe08f24eab2619b$exports[name] ? $abe08f24eab2619b$exports[name] : null;
};
/**
 * get device type id
 * @param result
 * @returns {number|null}
 */ const $f9223308e96891e9$var$getDeviceTypeId = (result)=>{
    return $f9223308e96891e9$var$getDeviceTypeIdForName($f9223308e96891e9$var$getDeviceType(result));
};
/**
 * get client type string
 * @param result
 * @returns {string|null}
 */ const $f9223308e96891e9$var$getClientType = (result)=>{
    return result.client && result.client.type ? result.client.type : null;
};
/**
 * is device type table
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isTablet = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.TABLET;
};
/**
 * is device type phablet
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isPhablet = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.PHABLET;
};
/**
 * is feature phone (push-button telephones)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isFeaturePhone = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.FEATURE_PHONE;
};
/**
 * is device type smartphone
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isSmartphone = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.SMARTPHONE;
};
/**
 * is device type car
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isCar = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.CAR_BROWSER;
};
/**
 * is device type mobile (feature phone, smartphone or phablet)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isMobile = (result)=>{
    return $f9223308e96891e9$var$isSmartphone(result) || $f9223308e96891e9$var$isFeaturePhone(result) || $f9223308e96891e9$var$isPhablet(result);
};
/**
 * is device type desktop
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isDesktop = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.DESKTOP;
};
/**
 * is os android
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isAndroid = (result)=>{
    return result.os && result.os.family === 'Android';
};
/**
 * is os ios
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isIOS = (result)=>{
    return result.os && result.os.family === 'iOS';
};
/**
 * is device type tv
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isTv = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.TV;
};
/**
 * is device type console (xBox, PlayStation, Nintendo etc)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isConsole = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.CONSOLE;
};
/**
 * is device type portable camera
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isCamera = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.CAMERA;
};
/**
 * is device type portable media player
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isPortableMediaPlayer = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.PORTABLE_MEDIA_PLAYER;
};
/**
 * is device type smart speaker (Alisa, Alexa, HomePod etc)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isSmartSpeaker = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.SMART_SPEAKER;
};
/**
 * is device type peripheral (portable terminal, post terminal,
 * single board computers, portable projector)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isPeripheral = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.PERIPHERAL;
};
/**
 * is device type smart display (LCD panel or interactive panel)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isSmartDisplay = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.SMART_DISPLAY;
};
/**
 * is device type wearable (watches, headsets)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isWearable = (result)=>{
    return $f9223308e96891e9$var$getDeviceType(result) === $a86fa4b852e0efb3$exports.WEARABLE;
};
/**
 * is client type browser
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isBrowser = (result)=>{
    return $f9223308e96891e9$var$getClientType(result) === $6b929fe91f6b6fc3$exports.BROWSER;
};
/**
 * is client type app (any type of client other than browser)
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isApp = (result)=>{
    return $f9223308e96891e9$var$getClientType(result) !== null && !$f9223308e96891e9$var$isBrowser(result);
};
/**
 * is client type app desktop
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isDesktopApp = (result)=>{
    return $f9223308e96891e9$var$isApp(result) && $f9223308e96891e9$var$isDesktop(result);
};
/**
 * is client type app mobile
 * @param result
 * @returns {boolean}
 */ const $f9223308e96891e9$var$isMobileApp = (result)=>{
    return $f9223308e96891e9$var$isApp(result) && ($f9223308e96891e9$var$isMobile(result) || $f9223308e96891e9$var$isTablet(result));
};
$f9223308e96891e9$exports = {
    getDeviceType: $f9223308e96891e9$var$getDeviceType,
    getDeviceTypeId: $f9223308e96891e9$var$getDeviceTypeId,
    getDeviceTypeIdForName: $f9223308e96891e9$var$getDeviceTypeIdForName,
    getClientType: $f9223308e96891e9$var$getClientType,
    isCamera: $f9223308e96891e9$var$isCamera,
    isCar: $f9223308e96891e9$var$isCar,
    isConsole: $f9223308e96891e9$var$isConsole,
    isDesktop: $f9223308e96891e9$var$isDesktop,
    isFeaturePhone: $f9223308e96891e9$var$isFeaturePhone,
    isMobile: $f9223308e96891e9$var$isMobile,
    isPeripheral: $f9223308e96891e9$var$isPeripheral,
    isPhablet: $f9223308e96891e9$var$isPhablet,
    isPortableMediaPlayer: $f9223308e96891e9$var$isPortableMediaPlayer,
    isSmartDisplay: $f9223308e96891e9$var$isSmartDisplay,
    isSmartSpeaker: $f9223308e96891e9$var$isSmartSpeaker,
    isSmartphone: $f9223308e96891e9$var$isSmartphone,
    isTablet: $f9223308e96891e9$var$isTablet,
    isTv: $f9223308e96891e9$var$isTv,
    isWearable: $f9223308e96891e9$var$isWearable,
    isAndroid: $f9223308e96891e9$var$isAndroid,
    isBrowser: $f9223308e96891e9$var$isBrowser,
    isApp: $f9223308e96891e9$var$isApp,
    isDesktopApp: $f9223308e96891e9$var$isDesktopApp,
    isMobileApp: $f9223308e96891e9$var$isMobileApp,
    isIOS: $f9223308e96891e9$var$isIOS
};


//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
//---------------------------------------------------------------------
// qrcode
//---------------------------------------------------------------------
/**
 * qrcode
 * @param typeNumber 1 to 40
 * @param errorCorrectionLevel 'L','M','Q','H'
 */ const $2044295c39e9ad20$export$5f3279733515fed0 = function(typeNumber, errorCorrectionLevel) {
    const PAD0 = 0xEC;
    const PAD1 = 0x11;
    let _typeNumber = typeNumber;
    const _errorCorrectionLevel = $2044295c39e9ad20$var$QRErrorCorrectionLevel[errorCorrectionLevel];
    let _modules = null;
    let _moduleCount = 0;
    let _dataCache = null;
    const _dataList = [];
    const _this = {};
    const makeImpl = function(test, maskPattern) {
        _moduleCount = _typeNumber * 4 + 17;
        _modules = function(moduleCount) {
            const modules = new Array(moduleCount);
            for(let row = 0; row < moduleCount; row += 1){
                modules[row] = new Array(moduleCount);
                for(let col = 0; col < moduleCount; col += 1)modules[row][col] = null;
            }
            return modules;
        }(_moduleCount);
        setupPositionProbePattern(0, 0);
        setupPositionProbePattern(_moduleCount - 7, 0);
        setupPositionProbePattern(0, _moduleCount - 7);
        setupPositionAdjustPattern();
        setupTimingPattern();
        setupTypeInfo(test, maskPattern);
        if (_typeNumber >= 7) setupTypeNumber(test);
        if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
        mapData(_dataCache, maskPattern);
    };
    const setupPositionProbePattern = function(row, col) {
        for(let r = -1; r <= 7; r += 1){
            if (row + r <= -1 || _moduleCount <= row + r) continue;
            for(let c = -1; c <= 7; c += 1){
                if (col + c <= -1 || _moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const getBestMaskPattern = function() {
        let minLostPoint = 0;
        let pattern = 0;
        for(let i = 0; i < 8; i += 1){
            makeImpl(true, i);
            const lostPoint = $2044295c39e9ad20$var$QRUtil.getLostPoint(_this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    };
    const setupTimingPattern = function() {
        for(let r = 8; r < _moduleCount - 8; r += 1){
            if (_modules[r][6] != null) continue;
            _modules[r][6] = r % 2 == 0;
        }
        for(let c = 8; c < _moduleCount - 8; c += 1){
            if (_modules[6][c] != null) continue;
            _modules[6][c] = c % 2 == 0;
        }
    };
    const setupPositionAdjustPattern = function() {
        const pos = $2044295c39e9ad20$var$QRUtil.getPatternPosition(_typeNumber);
        for(let i = 0; i < pos.length; i += 1)for(let j = 0; j < pos.length; j += 1){
            const row = pos[i];
            const col = pos[j];
            if (_modules[row][col] != null) continue;
            for(let r = -2; r <= 2; r += 1){
                for(let c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const setupTypeNumber = function(test) {
        const bits = $2044295c39e9ad20$var$QRUtil.getBCHTypeNumber(_typeNumber);
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
        }
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    };
    const setupTypeInfo = function(test, maskPattern) {
        const data = _errorCorrectionLevel << 3 | maskPattern;
        const bits = $2044295c39e9ad20$var$QRUtil.getBCHTypeInfo(data);
        // vertical
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 6) _modules[i][8] = mod;
            else if (i < 8) _modules[i + 1][8] = mod;
            else _modules[_moduleCount - 15 + i][8] = mod;
        }
        // horizontal
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
            else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
            else _modules[8][15 - i - 1] = mod;
        }
        // fixed module
        _modules[_moduleCount - 8][8] = !test;
    };
    const mapData = function(data, maskPattern) {
        let inc = -1;
        let row = _moduleCount - 1;
        let bitIndex = 7;
        let byteIndex = 0;
        const maskFunc = $2044295c39e9ad20$var$QRUtil.getMaskFunction(maskPattern);
        for(let col = _moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col -= 1;
            while(true){
                for(let c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                    let dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    const mask = maskFunc(row, col - c);
                    if (mask) dark = !dark;
                    _modules[row][col - c] = dark;
                    bitIndex -= 1;
                    if (bitIndex == -1) {
                        byteIndex += 1;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || _moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    };
    const createBytes = function(buffer, rsBlocks) {
        let offset = 0;
        let maxDcCount = 0;
        let maxEcCount = 0;
        const dcdata = new Array(rsBlocks.length);
        const ecdata = new Array(rsBlocks.length);
        for(let r = 0; r < rsBlocks.length; r += 1){
            const dcCount = rsBlocks[r].dataCount;
            const ecCount = rsBlocks[r].totalCount - dcCount;
            maxDcCount = Math.max(maxDcCount, dcCount);
            maxEcCount = Math.max(maxEcCount, ecCount);
            dcdata[r] = new Array(dcCount);
            for(let i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
            offset += dcCount;
            const rsPoly = $2044295c39e9ad20$var$QRUtil.getErrorCorrectPolynomial(ecCount);
            const rawPoly = $2044295c39e9ad20$var$qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
            const modPoly = rawPoly.mod(rsPoly);
            ecdata[r] = new Array(rsPoly.getLength() - 1);
            for(let i = 0; i < ecdata[r].length; i += 1){
                const modIndex = i + modPoly.getLength() - ecdata[r].length;
                ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
            }
        }
        let totalCodeCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
        const data = new Array(totalCodeCount);
        let index = 0;
        for(let i = 0; i < maxDcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                data[index] = dcdata[r][i];
                index += 1;
            }
        }
        for(let i = 0; i < maxEcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                data[index] = ecdata[r][i];
                index += 1;
            }
        }
        return data;
    };
    const createData = function(typeNumber, errorCorrectionLevel, dataList) {
        const rsBlocks = $2044295c39e9ad20$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
        const buffer = $2044295c39e9ad20$var$qrBitBuffer();
        for(let i = 0; i < dataList.length; i += 1){
            const data = dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), $2044295c39e9ad20$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
            data.write(buffer);
        }
        // calc num max data.
        let totalDataCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
        if (buffer.getLengthInBits() > totalDataCount * 8) throw 'code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')';
        // end code
        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
        // padding
        while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
        // padding
        while(true){
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD0, 8);
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD1, 8);
        }
        return createBytes(buffer, rsBlocks);
    };
    _this.addData = function(data, mode) {
        mode = mode || 'Byte';
        let newData = null;
        switch(mode){
            case 'Numeric':
                newData = $2044295c39e9ad20$var$qrNumber(data);
                break;
            case 'Alphanumeric':
                newData = $2044295c39e9ad20$var$qrAlphaNum(data);
                break;
            case 'Byte':
                newData = $2044295c39e9ad20$var$qr8BitByte(data);
                break;
            case 'Kanji':
                newData = $2044295c39e9ad20$var$qrKanji(data);
                break;
            default:
                throw 'mode:' + mode;
        }
        _dataList.push(newData);
        _dataCache = null;
    };
    _this.isDark = function(row, col) {
        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + ',' + col;
        return _modules[row][col];
    };
    _this.getModuleCount = function() {
        return _moduleCount;
    };
    _this.make = function() {
        if (_typeNumber < 1) {
            let typeNumber = 1;
            for(; typeNumber < 40; typeNumber++){
                const rsBlocks = $2044295c39e9ad20$var$QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                const buffer = $2044295c39e9ad20$var$qrBitBuffer();
                for(let i = 0; i < _dataList.length; i++){
                    const data = _dataList[i];
                    buffer.put(data.getMode(), 4);
                    buffer.put(data.getLength(), $2044295c39e9ad20$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
                    data.write(buffer);
                }
                let totalDataCount = 0;
                for(let i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                if (buffer.getLengthInBits() <= totalDataCount * 8) break;
            }
            _typeNumber = typeNumber;
        }
        makeImpl(false, getBestMaskPattern());
    };
    _this.createTableTag = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        let qrHtml = '';
        qrHtml += '<table style="';
        qrHtml += ' border-width: 0px; border-style: none;';
        qrHtml += ' border-collapse: collapse;';
        qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
        qrHtml += '">';
        qrHtml += '<tbody>';
        for(let r = 0; r < _this.getModuleCount(); r += 1){
            qrHtml += '<tr>';
            for(let c = 0; c < _this.getModuleCount(); c += 1){
                qrHtml += '<td style="';
                qrHtml += ' border-width: 0px; border-style: none;';
                qrHtml += ' border-collapse: collapse;';
                qrHtml += ' padding: 0px; margin: 0px;';
                qrHtml += ' width: ' + cellSize + 'px;';
                qrHtml += ' height: ' + cellSize + 'px;';
                qrHtml += ' background-color: ';
                qrHtml += _this.isDark(r, c) ? '#000000' : '#ffffff';
                qrHtml += ';';
                qrHtml += '"/>';
            }
            qrHtml += '</tr>';
        }
        qrHtml += '</tbody>';
        qrHtml += '</table>';
        return qrHtml;
    };
    _this.createSvgTag = function(cellSize, margin, alt, title) {
        let opts = {};
        if (typeof arguments[0] == 'object') {
            // Called by options.
            opts = arguments[0];
            // overwrite cellSize and margin.
            cellSize = opts.cellSize;
            margin = opts.margin;
            alt = opts.alt;
            title = opts.title;
        }
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        // Compose alt property surrogate
        alt = typeof alt === 'string' ? {
            text: alt
        } : alt || {};
        alt.text = alt.text || null;
        alt.id = alt.text ? alt.id || 'qrcode-description' : null;
        // Compose title property surrogate
        title = typeof title === 'string' ? {
            text: title
        } : title || {};
        title.text = title.text || null;
        title.id = title.text ? title.id || 'qrcode-title' : null;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let c, mc, r, mr, qrSvg = '', rect;
        rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
        qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
        qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
        qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
        qrSvg += ' preserveAspectRatio="xMinYMin meet"';
        qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
            title.id,
            alt.id
        ].join(' ').trim()) + '"' : '';
        qrSvg += '>';
        qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + '</title>' : '';
        qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + '</description>' : '';
        qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
        qrSvg += '<path d="';
        for(r = 0; r < _this.getModuleCount(); r += 1){
            mr = r * cellSize + margin;
            for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                mc = c * cellSize + margin;
                qrSvg += 'M' + mc + ',' + mr + rect;
            }
        }
        qrSvg += '" stroke="transparent" fill="black"/>';
        qrSvg += '</svg>';
        return qrSvg;
    };
    _this.createDataURL = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        return $2044295c39e9ad20$var$createDataURL(size, size, function(x, y) {
            if (min <= x && x < max && min <= y && y < max) {
                const c = Math.floor((x - min) / cellSize);
                const r = Math.floor((y - min) / cellSize);
                return _this.isDark(r, c) ? 0 : 1;
            } else return 1;
        });
    };
    _this.createImgTag = function(cellSize, margin, alt) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let img = '';
        img += '<img';
        img += '\u0020src="';
        img += _this.createDataURL(cellSize, margin);
        img += '"';
        img += '\u0020width="';
        img += size;
        img += '"';
        img += '\u0020height="';
        img += size;
        img += '"';
        if (alt) {
            img += '\u0020alt="';
            img += escapeXml(alt);
            img += '"';
        }
        img += '/>';
        return img;
    };
    const escapeXml = function(s) {
        let escaped = '';
        for(let i = 0; i < s.length; i += 1){
            const c = s.charAt(i);
            switch(c){
                case '<':
                    escaped += '&lt;';
                    break;
                case '>':
                    escaped += '&gt;';
                    break;
                case '&':
                    escaped += '&amp;';
                    break;
                case '"':
                    escaped += '&quot;';
                    break;
                default:
                    escaped += c;
                    break;
            }
        }
        return escaped;
    };
    const _createHalfASCII = function(margin) {
        const cellSize = 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r1, r2, p;
        const blocks = {
            "\u2588\u2588": "\u2588",
            "\u2588 ": "\u2580",
            " \u2588": "\u2584",
            '  ': ' '
        };
        const blocksLastLineNoMargin = {
            "\u2588\u2588": "\u2580",
            "\u2588 ": "\u2580",
            " \u2588": ' ',
            '  ': ' '
        };
        let ascii = '';
        for(y = 0; y < size; y += 2){
            r1 = Math.floor((y - min) / cellSize);
            r2 = Math.floor((y + 1 - min) / cellSize);
            for(x = 0; x < size; x += 1){
                p = "\u2588";
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = ' ';
                if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += ' ';
                else p += "\u2588";
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
            }
            ascii += '\n';
        }
        if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
        return ascii.substring(0, ascii.length - 1);
    };
    _this.createASCII = function(cellSize, margin) {
        cellSize = cellSize || 1;
        if (cellSize < 2) return _createHalfASCII(margin);
        cellSize -= 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r, p;
        const white = Array(cellSize + 1).join("\u2588\u2588");
        const black = Array(cellSize + 1).join('  ');
        let ascii = '';
        let line = '';
        for(y = 0; y < size; y += 1){
            r = Math.floor((y - min) / cellSize);
            line = '';
            for(x = 0; x < size; x += 1){
                p = 1;
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                line += p ? white : black;
            }
            for(r = 0; r < cellSize; r += 1)ascii += line + '\n';
        }
        return ascii.substring(0, ascii.length - 1);
    };
    _this.renderTo2dContext = function(context, cellSize) {
        cellSize = cellSize || 2;
        const length = _this.getModuleCount();
        for(let row = 0; row < length; row++)for(let col = 0; col < length; col++){
            context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
            context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qrcode.stringToBytes
//---------------------------------------------------------------------
$2044295c39e9ad20$export$5f3279733515fed0.stringToBytes = function(s) {
    const bytes = [];
    for(let i = 0; i < s.length; i += 1){
        const c = s.charCodeAt(i);
        bytes.push(c & 0xff);
    }
    return bytes;
};
//---------------------------------------------------------------------
// qrcode.createStringToBytes
//---------------------------------------------------------------------
/**
 * @param unicodeData base64 string of byte array.
 * [16bit Unicode],[16bit Bytes], ...
 * @param numChars
 */ $2044295c39e9ad20$export$5f3279733515fed0.createStringToBytes = function(unicodeData, numChars) {
    // create conversion map.
    const unicodeMap = function() {
        const bin = $2044295c39e9ad20$var$base64DecodeInputStream(unicodeData);
        const read = function() {
            const b = bin.read();
            if (b == -1) throw 'eof';
            return b;
        };
        let count = 0;
        const unicodeMap = {};
        while(true){
            const b0 = bin.read();
            if (b0 == -1) break;
            const b1 = read();
            const b2 = read();
            const b3 = read();
            const k = String.fromCharCode(b0 << 8 | b1);
            const v = b2 << 8 | b3;
            unicodeMap[k] = v;
            count += 1;
        }
        if (count != numChars) throw count + ' != ' + numChars;
        return unicodeMap;
    }();
    const unknownChar = '?'.charCodeAt(0);
    return function(s) {
        const bytes = [];
        for(let i = 0; i < s.length; i += 1){
            const c = s.charCodeAt(i);
            if (c < 128) bytes.push(c);
            else {
                const b = unicodeMap[s.charAt(i)];
                if (typeof b == 'number') {
                    if ((b & 0xff) == b) // 1byte
                    bytes.push(b);
                    else {
                        // 2bytes
                        bytes.push(b >>> 8);
                        bytes.push(b & 0xff);
                    }
                } else bytes.push(unknownChar);
            }
        }
        return bytes;
    };
};
//---------------------------------------------------------------------
// QRMode
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
//---------------------------------------------------------------------
// QRErrorCorrectionLevel
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$QRErrorCorrectionLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
//---------------------------------------------------------------------
// QRMaskPattern
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
//---------------------------------------------------------------------
// QRUtil
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$QRUtil = function() {
    const PATTERN_POSITION_TABLE = [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ];
    const G15 = 1335;
    const G18 = 7973;
    const G15_MASK = 21522;
    const _this = {};
    const getBCHDigit = function(data) {
        let digit = 0;
        while(data != 0){
            digit += 1;
            data >>>= 1;
        }
        return digit;
    };
    _this.getBCHTypeInfo = function(data) {
        let d = data << 10;
        while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
        return (data << 10 | d) ^ G15_MASK;
    };
    _this.getBCHTypeNumber = function(data) {
        let d = data << 12;
        while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
        return data << 12 | d;
    };
    _this.getPatternPosition = function(typeNumber) {
        return PATTERN_POSITION_TABLE[typeNumber - 1];
    };
    _this.getMaskFunction = function(maskPattern) {
        switch(maskPattern){
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN000:
                return function(i, j) {
                    return (i + j) % 2 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN001:
                return function(i, j) {
                    return i % 2 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN010:
                return function(i, j) {
                    return j % 3 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN011:
                return function(i, j) {
                    return (i + j) % 3 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN100:
                return function(i, j) {
                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN101:
                return function(i, j) {
                    return i * j % 2 + i * j % 3 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN110:
                return function(i, j) {
                    return (i * j % 2 + i * j % 3) % 2 == 0;
                };
            case $2044295c39e9ad20$var$QRMaskPattern.PATTERN111:
                return function(i, j) {
                    return (i * j % 3 + (i + j) % 2) % 2 == 0;
                };
            default:
                throw 'bad maskPattern:' + maskPattern;
        }
    };
    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
        let a = $2044295c39e9ad20$var$qrPolynomial([
            1
        ], 0);
        for(let i = 0; i < errorCorrectLength; i += 1)a = a.multiply($2044295c39e9ad20$var$qrPolynomial([
            1,
            $2044295c39e9ad20$var$QRMath.gexp(i)
        ], 0));
        return a;
    };
    _this.getLengthInBits = function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $2044295c39e9ad20$var$QRMode.MODE_NUMBER:
                return 10;
            case $2044295c39e9ad20$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $2044295c39e9ad20$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $2044295c39e9ad20$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $2044295c39e9ad20$var$QRMode.MODE_NUMBER:
                return 12;
            case $2044295c39e9ad20$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $2044295c39e9ad20$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $2044295c39e9ad20$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $2044295c39e9ad20$var$QRMode.MODE_NUMBER:
                return 14;
            case $2044295c39e9ad20$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $2044295c39e9ad20$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $2044295c39e9ad20$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw 'mode:' + mode;
        }
        else throw 'type:' + type;
    };
    _this.getLostPoint = function(qrcode) {
        const moduleCount = qrcode.getModuleCount();
        let lostPoint = 0;
        // LEVEL1
        for(let row = 0; row < moduleCount; row += 1)for(let col = 0; col < moduleCount; col += 1){
            let sameCount = 0;
            const dark = qrcode.isDark(row, col);
            for(let r = -1; r <= 1; r += 1){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(let c = -1; c <= 1; c += 1){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(let row = 0; row < moduleCount - 1; row += 1)for(let col = 0; col < moduleCount - 1; col += 1){
            let count = 0;
            if (qrcode.isDark(row, col)) count += 1;
            if (qrcode.isDark(row + 1, col)) count += 1;
            if (qrcode.isDark(row, col + 1)) count += 1;
            if (qrcode.isDark(row + 1, col + 1)) count += 1;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(let row = 0; row < moduleCount; row += 1){
            for(let col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        let darkCount = 0;
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
        }
        const ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    };
    return _this;
}();
//---------------------------------------------------------------------
// QRMath
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$QRMath = function() {
    const EXP_TABLE = new Array(256);
    const LOG_TABLE = new Array(256);
    // initialize tables
    for(let i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
    for(let i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
    for(let i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
    const _this = {};
    _this.glog = function(n) {
        if (n < 1) throw 'glog(' + n + ')';
        return LOG_TABLE[n];
    };
    _this.gexp = function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return EXP_TABLE[n];
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrPolynomial
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$qrPolynomial = function(num, shift) {
    if (typeof num.length == 'undefined') throw num.length + '/' + shift;
    const _num = function() {
        let offset = 0;
        while(offset < num.length && num[offset] == 0)offset += 1;
        const _num = new Array(num.length - offset + shift);
        for(let i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
        return _num;
    }();
    const _this = {};
    _this.getAt = function(index) {
        return _num[index];
    };
    _this.getLength = function() {
        return _num.length;
    };
    _this.multiply = function(e) {
        const num = new Array(_this.getLength() + e.getLength() - 1);
        for(let i = 0; i < _this.getLength(); i += 1)for(let j = 0; j < e.getLength(); j += 1)num[i + j] ^= $2044295c39e9ad20$var$QRMath.gexp($2044295c39e9ad20$var$QRMath.glog(_this.getAt(i)) + $2044295c39e9ad20$var$QRMath.glog(e.getAt(j)));
        return $2044295c39e9ad20$var$qrPolynomial(num, 0);
    };
    _this.mod = function(e) {
        if (_this.getLength() - e.getLength() < 0) return _this;
        const ratio = $2044295c39e9ad20$var$QRMath.glog(_this.getAt(0)) - $2044295c39e9ad20$var$QRMath.glog(e.getAt(0));
        const num = new Array(_this.getLength());
        for(let i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
        for(let i = 0; i < e.getLength(); i += 1)num[i] ^= $2044295c39e9ad20$var$QRMath.gexp($2044295c39e9ad20$var$QRMath.glog(e.getAt(i)) + ratio);
        // recursive call
        return $2044295c39e9ad20$var$qrPolynomial(num, 0).mod(e);
    };
    return _this;
};
//---------------------------------------------------------------------
// QRRSBlock
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$QRRSBlock = function() {
    const RS_BLOCK_TABLE = [
        // L
        // M
        // Q
        // H
        // 1
        [
            1,
            26,
            19
        ],
        [
            1,
            26,
            16
        ],
        [
            1,
            26,
            13
        ],
        [
            1,
            26,
            9
        ],
        // 2
        [
            1,
            44,
            34
        ],
        [
            1,
            44,
            28
        ],
        [
            1,
            44,
            22
        ],
        [
            1,
            44,
            16
        ],
        // 3
        [
            1,
            70,
            55
        ],
        [
            1,
            70,
            44
        ],
        [
            2,
            35,
            17
        ],
        [
            2,
            35,
            13
        ],
        // 4
        [
            1,
            100,
            80
        ],
        [
            2,
            50,
            32
        ],
        [
            2,
            50,
            24
        ],
        [
            4,
            25,
            9
        ],
        // 5
        [
            1,
            134,
            108
        ],
        [
            2,
            67,
            43
        ],
        [
            2,
            33,
            15,
            2,
            34,
            16
        ],
        [
            2,
            33,
            11,
            2,
            34,
            12
        ],
        // 6
        [
            2,
            86,
            68
        ],
        [
            4,
            43,
            27
        ],
        [
            4,
            43,
            19
        ],
        [
            4,
            43,
            15
        ],
        // 7
        [
            2,
            98,
            78
        ],
        [
            4,
            49,
            31
        ],
        [
            2,
            32,
            14,
            4,
            33,
            15
        ],
        [
            4,
            39,
            13,
            1,
            40,
            14
        ],
        // 8
        [
            2,
            121,
            97
        ],
        [
            2,
            60,
            38,
            2,
            61,
            39
        ],
        [
            4,
            40,
            18,
            2,
            41,
            19
        ],
        [
            4,
            40,
            14,
            2,
            41,
            15
        ],
        // 9
        [
            2,
            146,
            116
        ],
        [
            3,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            36,
            16,
            4,
            37,
            17
        ],
        [
            4,
            36,
            12,
            4,
            37,
            13
        ],
        // 10
        [
            2,
            86,
            68,
            2,
            87,
            69
        ],
        [
            4,
            69,
            43,
            1,
            70,
            44
        ],
        [
            6,
            43,
            19,
            2,
            44,
            20
        ],
        [
            6,
            43,
            15,
            2,
            44,
            16
        ],
        // 11
        [
            4,
            101,
            81
        ],
        [
            1,
            80,
            50,
            4,
            81,
            51
        ],
        [
            4,
            50,
            22,
            4,
            51,
            23
        ],
        [
            3,
            36,
            12,
            8,
            37,
            13
        ],
        // 12
        [
            2,
            116,
            92,
            2,
            117,
            93
        ],
        [
            6,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            46,
            20,
            6,
            47,
            21
        ],
        [
            7,
            42,
            14,
            4,
            43,
            15
        ],
        // 13
        [
            4,
            133,
            107
        ],
        [
            8,
            59,
            37,
            1,
            60,
            38
        ],
        [
            8,
            44,
            20,
            4,
            45,
            21
        ],
        [
            12,
            33,
            11,
            4,
            34,
            12
        ],
        // 14
        [
            3,
            145,
            115,
            1,
            146,
            116
        ],
        [
            4,
            64,
            40,
            5,
            65,
            41
        ],
        [
            11,
            36,
            16,
            5,
            37,
            17
        ],
        [
            11,
            36,
            12,
            5,
            37,
            13
        ],
        // 15
        [
            5,
            109,
            87,
            1,
            110,
            88
        ],
        [
            5,
            65,
            41,
            5,
            66,
            42
        ],
        [
            5,
            54,
            24,
            7,
            55,
            25
        ],
        [
            11,
            36,
            12,
            7,
            37,
            13
        ],
        // 16
        [
            5,
            122,
            98,
            1,
            123,
            99
        ],
        [
            7,
            73,
            45,
            3,
            74,
            46
        ],
        [
            15,
            43,
            19,
            2,
            44,
            20
        ],
        [
            3,
            45,
            15,
            13,
            46,
            16
        ],
        // 17
        [
            1,
            135,
            107,
            5,
            136,
            108
        ],
        [
            10,
            74,
            46,
            1,
            75,
            47
        ],
        [
            1,
            50,
            22,
            15,
            51,
            23
        ],
        [
            2,
            42,
            14,
            17,
            43,
            15
        ],
        // 18
        [
            5,
            150,
            120,
            1,
            151,
            121
        ],
        [
            9,
            69,
            43,
            4,
            70,
            44
        ],
        [
            17,
            50,
            22,
            1,
            51,
            23
        ],
        [
            2,
            42,
            14,
            19,
            43,
            15
        ],
        // 19
        [
            3,
            141,
            113,
            4,
            142,
            114
        ],
        [
            3,
            70,
            44,
            11,
            71,
            45
        ],
        [
            17,
            47,
            21,
            4,
            48,
            22
        ],
        [
            9,
            39,
            13,
            16,
            40,
            14
        ],
        // 20
        [
            3,
            135,
            107,
            5,
            136,
            108
        ],
        [
            3,
            67,
            41,
            13,
            68,
            42
        ],
        [
            15,
            54,
            24,
            5,
            55,
            25
        ],
        [
            15,
            43,
            15,
            10,
            44,
            16
        ],
        // 21
        [
            4,
            144,
            116,
            4,
            145,
            117
        ],
        [
            17,
            68,
            42
        ],
        [
            17,
            50,
            22,
            6,
            51,
            23
        ],
        [
            19,
            46,
            16,
            6,
            47,
            17
        ],
        // 22
        [
            2,
            139,
            111,
            7,
            140,
            112
        ],
        [
            17,
            74,
            46
        ],
        [
            7,
            54,
            24,
            16,
            55,
            25
        ],
        [
            34,
            37,
            13
        ],
        // 23
        [
            4,
            151,
            121,
            5,
            152,
            122
        ],
        [
            4,
            75,
            47,
            14,
            76,
            48
        ],
        [
            11,
            54,
            24,
            14,
            55,
            25
        ],
        [
            16,
            45,
            15,
            14,
            46,
            16
        ],
        // 24
        [
            6,
            147,
            117,
            4,
            148,
            118
        ],
        [
            6,
            73,
            45,
            14,
            74,
            46
        ],
        [
            11,
            54,
            24,
            16,
            55,
            25
        ],
        [
            30,
            46,
            16,
            2,
            47,
            17
        ],
        // 25
        [
            8,
            132,
            106,
            4,
            133,
            107
        ],
        [
            8,
            75,
            47,
            13,
            76,
            48
        ],
        [
            7,
            54,
            24,
            22,
            55,
            25
        ],
        [
            22,
            45,
            15,
            13,
            46,
            16
        ],
        // 26
        [
            10,
            142,
            114,
            2,
            143,
            115
        ],
        [
            19,
            74,
            46,
            4,
            75,
            47
        ],
        [
            28,
            50,
            22,
            6,
            51,
            23
        ],
        [
            33,
            46,
            16,
            4,
            47,
            17
        ],
        // 27
        [
            8,
            152,
            122,
            4,
            153,
            123
        ],
        [
            22,
            73,
            45,
            3,
            74,
            46
        ],
        [
            8,
            53,
            23,
            26,
            54,
            24
        ],
        [
            12,
            45,
            15,
            28,
            46,
            16
        ],
        // 28
        [
            3,
            147,
            117,
            10,
            148,
            118
        ],
        [
            3,
            73,
            45,
            23,
            74,
            46
        ],
        [
            4,
            54,
            24,
            31,
            55,
            25
        ],
        [
            11,
            45,
            15,
            31,
            46,
            16
        ],
        // 29
        [
            7,
            146,
            116,
            7,
            147,
            117
        ],
        [
            21,
            73,
            45,
            7,
            74,
            46
        ],
        [
            1,
            53,
            23,
            37,
            54,
            24
        ],
        [
            19,
            45,
            15,
            26,
            46,
            16
        ],
        // 30
        [
            5,
            145,
            115,
            10,
            146,
            116
        ],
        [
            19,
            75,
            47,
            10,
            76,
            48
        ],
        [
            15,
            54,
            24,
            25,
            55,
            25
        ],
        [
            23,
            45,
            15,
            25,
            46,
            16
        ],
        // 31
        [
            13,
            145,
            115,
            3,
            146,
            116
        ],
        [
            2,
            74,
            46,
            29,
            75,
            47
        ],
        [
            42,
            54,
            24,
            1,
            55,
            25
        ],
        [
            23,
            45,
            15,
            28,
            46,
            16
        ],
        // 32
        [
            17,
            145,
            115
        ],
        [
            10,
            74,
            46,
            23,
            75,
            47
        ],
        [
            10,
            54,
            24,
            35,
            55,
            25
        ],
        [
            19,
            45,
            15,
            35,
            46,
            16
        ],
        // 33
        [
            17,
            145,
            115,
            1,
            146,
            116
        ],
        [
            14,
            74,
            46,
            21,
            75,
            47
        ],
        [
            29,
            54,
            24,
            19,
            55,
            25
        ],
        [
            11,
            45,
            15,
            46,
            46,
            16
        ],
        // 34
        [
            13,
            145,
            115,
            6,
            146,
            116
        ],
        [
            14,
            74,
            46,
            23,
            75,
            47
        ],
        [
            44,
            54,
            24,
            7,
            55,
            25
        ],
        [
            59,
            46,
            16,
            1,
            47,
            17
        ],
        // 35
        [
            12,
            151,
            121,
            7,
            152,
            122
        ],
        [
            12,
            75,
            47,
            26,
            76,
            48
        ],
        [
            39,
            54,
            24,
            14,
            55,
            25
        ],
        [
            22,
            45,
            15,
            41,
            46,
            16
        ],
        // 36
        [
            6,
            151,
            121,
            14,
            152,
            122
        ],
        [
            6,
            75,
            47,
            34,
            76,
            48
        ],
        [
            46,
            54,
            24,
            10,
            55,
            25
        ],
        [
            2,
            45,
            15,
            64,
            46,
            16
        ],
        // 37
        [
            17,
            152,
            122,
            4,
            153,
            123
        ],
        [
            29,
            74,
            46,
            14,
            75,
            47
        ],
        [
            49,
            54,
            24,
            10,
            55,
            25
        ],
        [
            24,
            45,
            15,
            46,
            46,
            16
        ],
        // 38
        [
            4,
            152,
            122,
            18,
            153,
            123
        ],
        [
            13,
            74,
            46,
            32,
            75,
            47
        ],
        [
            48,
            54,
            24,
            14,
            55,
            25
        ],
        [
            42,
            45,
            15,
            32,
            46,
            16
        ],
        // 39
        [
            20,
            147,
            117,
            4,
            148,
            118
        ],
        [
            40,
            75,
            47,
            7,
            76,
            48
        ],
        [
            43,
            54,
            24,
            22,
            55,
            25
        ],
        [
            10,
            45,
            15,
            67,
            46,
            16
        ],
        // 40
        [
            19,
            148,
            118,
            6,
            149,
            119
        ],
        [
            18,
            75,
            47,
            31,
            76,
            48
        ],
        [
            34,
            54,
            24,
            34,
            55,
            25
        ],
        [
            20,
            45,
            15,
            61,
            46,
            16
        ]
    ];
    const qrRSBlock = function(totalCount, dataCount) {
        const _this = {};
        _this.totalCount = totalCount;
        _this.dataCount = dataCount;
        return _this;
    };
    const _this = {};
    const getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
        switch(errorCorrectionLevel){
            case $2044295c39e9ad20$var$QRErrorCorrectionLevel.L:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
            case $2044295c39e9ad20$var$QRErrorCorrectionLevel.M:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
            case $2044295c39e9ad20$var$QRErrorCorrectionLevel.Q:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
            case $2044295c39e9ad20$var$QRErrorCorrectionLevel.H:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
            default:
                return undefined;
        }
    };
    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
        const rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
        if (typeof rsBlock == 'undefined') throw 'bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel;
        const length = rsBlock.length / 3;
        const list = [];
        for(let i = 0; i < length; i += 1){
            const count = rsBlock[i * 3 + 0];
            const totalCount = rsBlock[i * 3 + 1];
            const dataCount = rsBlock[i * 3 + 2];
            for(let j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
        }
        return list;
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrBitBuffer
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$qrBitBuffer = function() {
    const _buffer = [];
    let _length = 0;
    const _this = {};
    _this.getBuffer = function() {
        return _buffer;
    };
    _this.getAt = function(index) {
        const bufIndex = Math.floor(index / 8);
        return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    };
    _this.put = function(num, length) {
        for(let i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
    };
    _this.getLengthInBits = function() {
        return _length;
    };
    _this.putBit = function(bit) {
        const bufIndex = Math.floor(_length / 8);
        if (_buffer.length <= bufIndex) _buffer.push(0);
        if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
        _length += 1;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrNumber
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$qrNumber = function(data) {
    const _mode = $2044295c39e9ad20$var$QRMode.MODE_NUMBER;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const data = _data;
        let i = 0;
        while(i + 2 < data.length){
            buffer.put(strToNum(data.substring(i, i + 3)), 10);
            i += 3;
        }
        if (i < data.length) {
            if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
            else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
        }
    };
    const strToNum = function(s) {
        let num = 0;
        for(let i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
        return num;
    };
    const chatToNum = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        throw 'illegal char :' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrAlphaNum
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$qrAlphaNum = function(data) {
    const _mode = $2044295c39e9ad20$var$QRMode.MODE_ALPHA_NUM;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const s = _data;
        let i = 0;
        while(i + 1 < s.length){
            buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
            i += 2;
        }
        if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
    };
    const getCode = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        else if ('A' <= c && c <= 'Z') return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        else switch(c){
            case '\u0020':
                return 36;
            case '$':
                return 37;
            case '%':
                return 38;
            case '*':
                return 39;
            case '+':
                return 40;
            case '-':
                return 41;
            case '.':
                return 42;
            case '/':
                return 43;
            case ':':
                return 44;
            default:
                throw 'illegal char :' + c;
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qr8BitByte
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$qr8BitByte = function(data) {
    const _mode = $2044295c39e9ad20$var$QRMode.MODE_8BIT_BYTE;
    const _data = data;
    const _bytes = $2044295c39e9ad20$export$5f3279733515fed0.stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _bytes.length;
    };
    _this.write = function(buffer) {
        for(let i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
    };
    return _this;
};
//---------------------------------------------------------------------
// qrKanji
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$qrKanji = function(data) {
    const _mode = $2044295c39e9ad20$var$QRMode.MODE_KANJI;
    const _data = data;
    const stringToBytes = $2044295c39e9ad20$export$5f3279733515fed0.stringToBytes;
    !function(c, code) {
        // self test for sjis support.
        const test = stringToBytes(c);
        if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw 'sjis not supported.';
    }('\u53cb', 0x9746);
    const _bytes = stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return ~~(_bytes.length / 2);
    };
    _this.write = function(buffer) {
        const data = _bytes;
        let i = 0;
        while(i + 1 < data.length){
            let c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
            if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
            else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
            else throw 'illegal char at ' + (i + 1) + '/' + c;
            c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
            buffer.put(c, 13);
            i += 2;
        }
        if (i < data.length) throw 'illegal char at ' + (i + 1);
    };
    return _this;
};
//=====================================================================
// GIF Support etc.
//
//---------------------------------------------------------------------
// byteArrayOutputStream
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$byteArrayOutputStream = function() {
    const _bytes = [];
    const _this = {};
    _this.writeByte = function(b) {
        _bytes.push(b & 0xff);
    };
    _this.writeShort = function(i) {
        _this.writeByte(i);
        _this.writeByte(i >>> 8);
    };
    _this.writeBytes = function(b, off, len) {
        off = off || 0;
        len = len || b.length;
        for(let i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
    };
    _this.writeString = function(s) {
        for(let i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
    };
    _this.toByteArray = function() {
        return _bytes;
    };
    _this.toString = function() {
        let s = '';
        s += '[';
        for(let i = 0; i < _bytes.length; i += 1){
            if (i > 0) s += ',';
            s += _bytes[i];
        }
        s += ']';
        return s;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64EncodeOutputStream
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$base64EncodeOutputStream = function() {
    let _buffer = 0;
    let _buflen = 0;
    let _length = 0;
    let _base64 = '';
    const _this = {};
    const writeEncoded = function(b) {
        _base64 += String.fromCharCode(encode(b & 0x3f));
    };
    const encode = function(n) {
        if (n < 0) throw 'n:' + n;
        else if (n < 26) return 0x41 + n;
        else if (n < 52) return 0x61 + (n - 26);
        else if (n < 62) return 0x30 + (n - 52);
        else if (n == 62) return 0x2b;
        else if (n == 63) return 0x2f;
        else throw 'n:' + n;
    };
    _this.writeByte = function(n) {
        _buffer = _buffer << 8 | n & 0xff;
        _buflen += 8;
        _length += 1;
        while(_buflen >= 6){
            writeEncoded(_buffer >>> _buflen - 6);
            _buflen -= 6;
        }
    };
    _this.flush = function() {
        if (_buflen > 0) {
            writeEncoded(_buffer << 6 - _buflen);
            _buffer = 0;
            _buflen = 0;
        }
        if (_length % 3 != 0) {
            // padding
            const padlen = 3 - _length % 3;
            for(let i = 0; i < padlen; i += 1)_base64 += '=';
        }
    };
    _this.toString = function() {
        return _base64;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64DecodeInputStream
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$base64DecodeInputStream = function(str) {
    const _str = str;
    let _pos = 0;
    let _buffer = 0;
    let _buflen = 0;
    const _this = {};
    _this.read = function() {
        while(_buflen < 8){
            if (_pos >= _str.length) {
                if (_buflen == 0) return -1;
                throw 'unexpected end of file./' + _buflen;
            }
            const c = _str.charAt(_pos);
            _pos += 1;
            if (c == '=') {
                _buflen = 0;
                return -1;
            } else if (c.match(/^\s$/)) continue;
            _buffer = _buffer << 6 | decode(c.charCodeAt(0));
            _buflen += 6;
        }
        const n = _buffer >>> _buflen - 8 & 0xff;
        _buflen -= 8;
        return n;
    };
    const decode = function(c) {
        if (0x41 <= c && c <= 0x5a) return c - 0x41;
        else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
        else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
        else if (c == 0x2b) return 62;
        else if (c == 0x2f) return 63;
        else throw 'c:' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// gifImage (B/W)
//---------------------------------------------------------------------
const $2044295c39e9ad20$var$gifImage = function(width, height) {
    const _width = width;
    const _height = height;
    const _data = new Array(width * height);
    const _this = {};
    _this.setPixel = function(x, y, pixel) {
        _data[y * _width + x] = pixel;
    };
    _this.write = function(out) {
        //---------------------------------
        // GIF Signature
        out.writeString('GIF87a');
        //---------------------------------
        // Screen Descriptor
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0x80); // 2bit
        out.writeByte(0);
        out.writeByte(0);
        //---------------------------------
        // Global Color Map
        // black
        out.writeByte(0x00);
        out.writeByte(0x00);
        out.writeByte(0x00);
        // white
        out.writeByte(0xff);
        out.writeByte(0xff);
        out.writeByte(0xff);
        //---------------------------------
        // Image Descriptor
        out.writeString(',');
        out.writeShort(0);
        out.writeShort(0);
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0);
        //---------------------------------
        // Local Color Map
        //---------------------------------
        // Raster Data
        const lzwMinCodeSize = 2;
        const raster = getLZWRaster(lzwMinCodeSize);
        out.writeByte(lzwMinCodeSize);
        let offset = 0;
        while(raster.length - offset > 255){
            out.writeByte(255);
            out.writeBytes(raster, offset, 255);
            offset += 255;
        }
        out.writeByte(raster.length - offset);
        out.writeBytes(raster, offset, raster.length - offset);
        out.writeByte(0x00);
        //---------------------------------
        // GIF Terminator
        out.writeString(';');
    };
    const bitOutputStream = function(out) {
        const _out = out;
        let _bitLength = 0;
        let _bitBuffer = 0;
        const _this = {};
        _this.write = function(data, length) {
            if (data >>> length != 0) throw 'length over';
            while(_bitLength + length >= 8){
                _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                length -= 8 - _bitLength;
                data >>>= 8 - _bitLength;
                _bitBuffer = 0;
                _bitLength = 0;
            }
            _bitBuffer = data << _bitLength | _bitBuffer;
            _bitLength = _bitLength + length;
        };
        _this.flush = function() {
            if (_bitLength > 0) _out.writeByte(_bitBuffer);
        };
        return _this;
    };
    const getLZWRaster = function(lzwMinCodeSize) {
        const clearCode = 1 << lzwMinCodeSize;
        const endCode = (1 << lzwMinCodeSize) + 1;
        let bitLength = lzwMinCodeSize + 1;
        // Setup LZWTable
        const table = lzwTable();
        for(let i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
        table.add(String.fromCharCode(clearCode));
        table.add(String.fromCharCode(endCode));
        const byteOut = $2044295c39e9ad20$var$byteArrayOutputStream();
        const bitOut = bitOutputStream(byteOut);
        // clear code
        bitOut.write(clearCode, bitLength);
        let dataIndex = 0;
        let s = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;
        while(dataIndex < _data.length){
            const c = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            if (table.contains(s + c)) s = s + c;
            else {
                bitOut.write(table.indexOf(s), bitLength);
                if (table.size() < 0xfff) {
                    if (table.size() == 1 << bitLength) bitLength += 1;
                    table.add(s + c);
                }
                s = c;
            }
        }
        bitOut.write(table.indexOf(s), bitLength);
        // end code
        bitOut.write(endCode, bitLength);
        bitOut.flush();
        return byteOut.toByteArray();
    };
    const lzwTable = function() {
        const _map = {};
        let _size = 0;
        const _this = {};
        _this.add = function(key) {
            if (_this.contains(key)) throw 'dup key:' + key;
            _map[key] = _size;
            _size += 1;
        };
        _this.size = function() {
            return _size;
        };
        _this.indexOf = function(key) {
            return _map[key];
        };
        _this.contains = function(key) {
            return typeof _map[key] != 'undefined';
        };
        return _this;
    };
    return _this;
};
const $2044295c39e9ad20$var$createDataURL = function(width, height, getPixel) {
    const gif = $2044295c39e9ad20$var$gifImage(width, height);
    for(let y = 0; y < height; y += 1)for(let x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
    const b = $2044295c39e9ad20$var$byteArrayOutputStream();
    gif.write(b);
    const base64 = $2044295c39e9ad20$var$base64EncodeOutputStream();
    const bytes = b.toByteArray();
    for(let i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
    base64.flush();
    return 'data:image/gif;base64,' + base64;
};
var $2044295c39e9ad20$export$2e2bcd8739ae039 = $2044295c39e9ad20$export$5f3279733515fed0;
const $2044295c39e9ad20$export$c8dd6bc66a63753c = $2044295c39e9ad20$export$5f3279733515fed0.stringToBytes;


// Initialize device detector
const $d706c914d748cb55$var$detector = new (0, (/*@__PURE__*/$parcel$interopDefault($88feee6a131c186a$exports)))({
    clientIndexes: true,
    deviceIndexes: true,
    osIndexes: true,
    deviceAliasCode: false,
    deviceTrusted: false,
    deviceInfo: false,
    maxUserAgentSize: 500
});
// DOM elements
let $d706c914d748cb55$var$loadingScreen;
let $d706c914d748cb55$var$mainContent;
let $d706c914d748cb55$var$errorScreen;
let $d706c914d748cb55$var$errorMessage;
let $d706c914d748cb55$var$retryButton;
let $d706c914d748cb55$var$contentDiv;
let $d706c914d748cb55$var$mobileOnlyScreen;
let $d706c914d748cb55$var$qrCodeContainer;
let $d706c914d748cb55$var$currentUrlElement;
let $d706c914d748cb55$var$getAppScreen;
let $d706c914d748cb55$var$getAppButton;
let $d706c914d748cb55$var$getAppDescription;
// Firebase instance
let $d706c914d748cb55$var$app;
/**
 * Initialize Firebase with the appropriate configuration
 */ function $d706c914d748cb55$var$initializeFirebase() {
    const config = (0, $55096a08d23c1fd2$export$72e5f7374eb9f854)();
    // Initialize Firebase app
    $d706c914d748cb55$var$app = (0, $8b041be78626b50a$export$c55cfd413944906d)(config);
}
/**
 * Show loading screen
 */ function $d706c914d748cb55$var$showLoading() {
    $d706c914d748cb55$var$loadingScreen.classList.remove('fade-out');
    $d706c914d748cb55$var$mainContent.classList.add('hidden');
    $d706c914d748cb55$var$errorScreen.classList.add('hidden');
}
/**
 * Hide loading screen with fade effect
 */ function $d706c914d748cb55$var$hideLoading() {
    $d706c914d748cb55$var$loadingScreen.classList.add('fade-out');
    setTimeout(()=>{
        $d706c914d748cb55$var$loadingScreen.style.display = 'none';
    }, 300);
}
/**
 * Show main content with data
 */ function $d706c914d748cb55$var$showContent(data) {
    $d706c914d748cb55$var$hideLoading();
    $d706c914d748cb55$var$mainContent.classList.remove('hidden');
    // Display the response data
    if (data) $d706c914d748cb55$var$contentDiv.innerHTML = `
      <div class="response-data">
        <h3>Response from Firebase Function:</h3>
        <pre>${JSON.stringify(data, null, 2)}</pre>
      </div>
    `;
}
/**
 * Show error screen
 */ function $d706c914d748cb55$var$showError(error) {
    $d706c914d748cb55$var$hideLoading();
    $d706c914d748cb55$var$errorScreen.classList.remove('hidden');
    $d706c914d748cb55$var$errorMessage.textContent = error.message || 'An unexpected error occurred';
    console.error('Error calling Firebase function:', error);
}
/**
 * Show the "Get the App" screen with customized message
 * @param {Object} data - Response data from Firebase containing redirect info
 */ function $d706c914d748cb55$var$showGetAppScreen(data) {
    $d706c914d748cb55$var$hideLoading();
    // Hide other screens
    $d706c914d748cb55$var$mainContent.classList.add('hidden');
    $d706c914d748cb55$var$errorScreen.classList.add('hidden');
    // Show get app screen
    $d706c914d748cb55$var$getAppScreen.classList.remove('hidden');
    // Customize description based on Private Relay status
    if (data.isPrivateRelay) $d706c914d748cb55$var$getAppDescription.innerHTML = `
      To experience this TimeWalk, you'll need the Gazooky TimeWalks app.<br><br>
      <strong>Please follow these steps:</strong><br>
      1. Tap "Download App" below to open the App Store<br>
      2. After installing, open the Gazooky TimeWalks app<br>
      3. You will be asked to paste the content to launch your experience
    `;
    else $d706c914d748cb55$var$getAppDescription.innerHTML = `
      To experience this TimeWalk, you'll need the Gazooky TimeWalks app.<br><br>
      Tap the button below to download the app. Once installed, the app will automatically open with your TimeWalk ready to explore!
    `;
    // Store the data for button click
    $d706c914d748cb55$var$getAppButton.onclick = async ()=>{
        if (data.isPrivateRelay) try {
            // Copy to clipboard for Private Relay users
            const urlToCopy = window.location.href;
            console.log('URL to copy:', urlToCopy);
            console.log('URL type:', typeof urlToCopy);
            console.log('URL value:', String(urlToCopy));
            await navigator.clipboard.writeText(urlToCopy);
            console.log('Successfully copied to clipboard');
            // Redirect to App Store
            window.location.href = data.appStoreUrl;
        } catch (clipboardError) {
            console.error('Failed to copy to clipboard:', clipboardError);
            // Still redirect even if clipboard fails
            window.location.href = data.appStoreUrl;
        }
        else // Normal flow - redirect to appropriate store
        window.location.href = data.redirectUrl;
    };
}
/**
 * Extract URL parameters from the query string
 */ function $d706c914d748cb55$var$getURLParameters() {
    const params = new URLSearchParams(window.location.search);
    return {
        clientId: params.get('clt'),
        projectId: params.get('pro'),
        experienceId: params.get('exp'),
        relay: params.get('relay')
    };
}
/**
 * Validate that all required URL parameters are present
 */ function $d706c914d748cb55$var$validateURLParameters(params) {
    return params.clientId && params.projectId && params.experienceId;
}
/**
 * Collects device signals for fingerprinting
 * @returns {Promise<Object>} Device signals object
 */ async function $d706c914d748cb55$var$collectDeviceSignals() {
    const baseSignals = {
        pixelRatio: window.devicePixelRatio,
        timezoneOffset: new Date().getTimezoneOffset(),
        deviceModel: "",
        platformVersion: ""
    };
    // Try to get high-entropy values from Client Hints
    if (navigator.userAgentData) try {
        const hints = await navigator.userAgentData.getHighEntropyValues([
            'model',
            'platformVersion'
        ]);
        baseSignals.deviceModel = hints.model || "";
        baseSignals.platformVersion = hints.platformVersion || "";
    } catch (e) {
        console.warn('Could not get client hints:', e);
    }
    return baseSignals;
}
/**
 * Call Firebase Cloud Function
 * Extracts URL parameters and passes them to the generateDeepLink function
 */ async function $d706c914d748cb55$var$callFirebaseFunction() {
    try {
        $d706c914d748cb55$var$showLoading();
        // Extract URL parameters
        const params = $d706c914d748cb55$var$getURLParameters();
        // Validate parameters
        if (!$d706c914d748cb55$var$validateURLParameters(params)) {
            const error = new Error('Welcome to Gazooky TimeWalks! Unfortunately, your link is invalid to launch an experience. Please contact your experience provider for more information.');
            $d706c914d748cb55$var$showError(error);
            return;
        }
        // Collect device signals for fingerprinting
        const deviceSignals = await $d706c914d748cb55$var$collectDeviceSignals();
        // Get the Firebase function URL
        const config = (0, $55096a08d23c1fd2$export$72e5f7374eb9f854)();
        const functionUrl = config.useEmulator ? `http://${config.functionsEmulatorHost}/${config.projectId}/europe-west2/generateDeepLink` : `https://europe-west2-${config.projectId}.cloudfunctions.net/generateDeepLink`;
        // Call the Firebase HTTP function
        const response = await fetch(functionUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                clientId: params.clientId,
                projectId: params.projectId,
                experienceId: params.experienceId,
                deviceSignals: deviceSignals,
                relay: params.relay
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        // Check if this is a successful response with redirect/Private Relay handling
        if (result.success && result.data) {
            if (result.data.isPrivateRelay || result.data.redirectUrl) // Show the "Get the App" screen instead of auto-redirecting
            $d706c914d748cb55$var$showGetAppScreen(result.data);
            else // Show the result for debugging
            $d706c914d748cb55$var$showContent(result.data || result);
        } else // Show the result for debugging
        $d706c914d748cb55$var$showContent(result.data || result);
    } catch (error) {
        $d706c914d748cb55$var$showError(error);
    }
}
/**
 * Check if device is mobile (iOS or Android)
 * If not, show QR code screen
 */ function $d706c914d748cb55$var$checkDeviceAndShowQR() {
    // Detect device from user agent
    const userAgent = navigator.userAgent;
    const result = $d706c914d748cb55$var$detector.detect(userAgent);
    // Check if the device is mobile using DeviceHelper
    const isMobileDevice = (0, (/*@__PURE__*/$parcel$interopDefault($f9223308e96891e9$exports))).isMobile(result);
    if (!isMobileDevice) {
        // Device is not mobile, show the mobile-only screen with QR code
        $d706c914d748cb55$var$showMobileOnlyScreen();
        return false; // Not a mobile device
    }
    return true; // Is a mobile device
}
/**
 * Generate QR code for the current URL
 */ function $d706c914d748cb55$var$generateQRCode() {
    const currentUrl = window.location.href;
    // Create QR code
    const qr = (0, $2044295c39e9ad20$export$2e2bcd8739ae039)(0, 'M'); // Type 0 (auto), Error correction level M
    qr.addData(currentUrl);
    qr.make();
    // Generate the QR code as HTML
    const qrHTML = qr.createImgTag(6, 8); // cell size 6, margin 8
    return {
        qrHTML: qrHTML,
        currentUrl: currentUrl
    };
}
/**
 * Show mobile-only screen with QR code
 */ function $d706c914d748cb55$var$showMobileOnlyScreen() {
    // Hide other screens
    $d706c914d748cb55$var$loadingScreen.style.display = 'none';
    $d706c914d748cb55$var$mainContent.classList.add('hidden');
    $d706c914d748cb55$var$errorScreen.classList.add('hidden');
    // Show mobile-only screen
    $d706c914d748cb55$var$mobileOnlyScreen.classList.remove('hidden');
    // Generate and display QR code
    const { qrHTML: qrHTML, currentUrl: currentUrl } = $d706c914d748cb55$var$generateQRCode();
    $d706c914d748cb55$var$qrCodeContainer.innerHTML = qrHTML;
    $d706c914d748cb55$var$currentUrlElement.textContent = currentUrl;
}
/**
 * Initialize the application
 */ function $d706c914d748cb55$var$init() {
    // Get DOM elements
    $d706c914d748cb55$var$loadingScreen = document.getElementById('loading-screen');
    $d706c914d748cb55$var$mainContent = document.getElementById('main-content');
    $d706c914d748cb55$var$errorScreen = document.getElementById('error-screen');
    $d706c914d748cb55$var$errorMessage = document.getElementById('error-message');
    $d706c914d748cb55$var$retryButton = document.getElementById('retry-button');
    $d706c914d748cb55$var$contentDiv = document.getElementById('content');
    $d706c914d748cb55$var$mobileOnlyScreen = document.getElementById('mobile-only-screen');
    $d706c914d748cb55$var$qrCodeContainer = document.getElementById('qr-code-container');
    $d706c914d748cb55$var$currentUrlElement = document.getElementById('current-url');
    $d706c914d748cb55$var$getAppScreen = document.getElementById('get-app-screen');
    $d706c914d748cb55$var$getAppButton = document.getElementById('get-app-button');
    $d706c914d748cb55$var$getAppDescription = document.getElementById('get-app-description');
    // Add retry button handler
    $d706c914d748cb55$var$retryButton.addEventListener('click', ()=>{
        $d706c914d748cb55$var$callFirebaseFunction();
    });
    // Check if device is mobile
    const isMobileDevice = $d706c914d748cb55$var$checkDeviceAndShowQR();
    // Only initialize Firebase and call function if on mobile device
    if (isMobileDevice) try {
        $d706c914d748cb55$var$initializeFirebase();
        // Call Firebase function on page load
        $d706c914d748cb55$var$callFirebaseFunction();
    } catch (error) {
        $d706c914d748cb55$var$showError(error);
    }
}
// Wait for DOM to be ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $d706c914d748cb55$var$init);
else $d706c914d748cb55$var$init();


//# sourceMappingURL=gazooky-timewalks-app.b7706daa.js.map
